/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1420);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(44);
var hide = __webpack_require__(35);
var redefine = __webpack_require__(36);
var ctx = __webpack_require__(45);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(12);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(852);


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return Store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapState", function() { return mapState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapMutations", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapGetters", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapActions", function() { return mapActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNamespacedHelpers", function() { return createNamespacedHelpers; });
/**
 * vuex v3.1.3
 * (c) 2020 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if (false) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if (false) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return result.then(function (res) {
    try {
      this$1._actionSubscribers
        .filter(function (sub) { return sub.after; })
        .forEach(function (sub) { return sub.after(action, this$1.state); });
    } catch (e) {
      if (false) {
        console.warn("[vuex] error in after action subscribers: ");
        console.error(e);
      }
    }
    return res
  })
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && "production" !== 'production') {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if (false) {
        if (moduleName in parentState) {
          console.warn(
            ("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + (path.join('.')) + "\"")
          );
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept anthor params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.1.3',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};

/* harmony default export */ __webpack_exports__["default"] = (index_esm);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(67)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.11
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.11';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(67), __webpack_require__(500).setImmediate))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(730), __esModule: true };

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(99)('wks');
var uid = __webpack_require__(74);
var Symbol = __webpack_require__(4).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(47);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(112);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.security = undefined;var _typeof2 = __webpack_require__(58);var _typeof3 = _interopRequireDefault(_typeof2);var _keys = __webpack_require__(59);var _keys2 = _interopRequireDefault(_keys);var _promise = __webpack_require__(19);var _promise2 = _interopRequireDefault(_promise);exports.







































































































































































































































































errMessage = errMessage;var _axios = __webpack_require__(114);var _axios2 = _interopRequireDefault(_axios);var _elementUi = __webpack_require__(141);var _token = __webpack_require__(25);var _token2 = _interopRequireDefault(_token);var _ajaxError = __webpack_require__(847);var _eslint = __webpack_require__(848);var _eslint2 = _interopRequireDefault(_eslint);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var base = '';exports.default = { ajax: function ajax() {var params = [];params.push.apply(params, arguments);params.splice(0, 1);var url = '' + base + arguments[0];return _axios2.default.post(url, params).then(function (res) {var data = res.data;if (!data.success) {if (data.msg) {if (!(data.msg.indexOf("NO_SHOW_MSG_") === 0)) {errMessage($lang(data.msg));}throw data.msg;}}return data;}, function (err, status) {(0, _ajaxError.ajaxError)(err, status, url);});}, ajaxGet: function ajaxGet() {var params = [];params.push.apply(params, arguments);params.splice(0, 1);var url = '' + base + arguments[0];return _axios2.default.post(url, params).then(function (res) {var data = res.data;if (!data.success) {if (data.msg) {errMessage(data.msg);throw data.msg;}}return data;}, function (err, status) {(0, _ajaxError.ajaxError)(err, status);});}, downloadAttachment: function downloadAttachment(url, params, isOpen, json) {isOpen = isOpen == undefined ? false : isOpen;var arr = [];for (var p in params) {arr.push(p + "=" + params[p]);}arr.push("$compress=true");url = url + "?" + arr.join("&");if (isOpen) {window.open(url);} else {var form = $("#download-form");form.attr("action", url);if (json) {$("#download-form-json").val(json);} else {$("#download-form-json").val("");}form.submit();}}, downloadAttachment2: function downloadAttachment2(_ref) {var url = _ref.url,_ref$params = _ref.params,params = _ref$params === undefined ? {} : _ref$params,_ref$enctype = _ref.enctype,enctype = _ref$enctype === undefined ? 'application/x-www-form-urlencoded' : _ref$enctype,_ref$method = _ref.method,method = _ref$method === undefined ? 'POST' : _ref$method;return new _promise2.default(function (resolve, reject) {var frameId = (Math.random() * 6 + 10).toString(16).replace('.', '');$('\n        <form action="' + url + '" enctype="' + enctype + '" method = "' + method + '">\n          ' + (0, _keys2.default)(params).map(function (name) {if (typeof params[name] !== 'undefined') {return '<textarea name=' + name + '>' + params[name] + '</textarea>';} else {return '';}}).join('') + '\n        </form>\n      ').appendTo($('<iframe id="' + frameId + '" style="display:none"></iframe>').appendTo(document.body).one('load', function () {var iframe = this;if (iframe.contentDocument) {var text = iframe.contentDocument.body.innerText;try {var response = JSON.parse(text);resolve(response);} catch (err) {resolve({ success: false, msg: text });}}$(iframe).remove();}).one('error', function (e) {resolve({ success: false, msg: e.toString() });var iframe = this;$(iframe).remove();}).get(0).contentDocument.body).submit();setTimeout(function (frameId) {$('#' + frameId).remove();}.bind(null, frameId), 60000);});}, applyCover: function applyCover(o, c) {if (o && c) {for (var oo in o) {for (var cc in c) {if (oo == cc) {o[oo] = c[cc];}}}}return o;}, isDefined: function isDefined(v) {return typeof v !== 'undefined';}, apply: function apply(o, c, defaults) {if (defaults) {this.apply(o, defaults);}if (o && c && (typeof c === 'undefined' ? 'undefined' : (0, _typeof3.default)(c)) == 'object') {for (var p in c) {o[p] = c[p];}}return o;}, applyIf: function applyIf(o, c) {if (o) {for (var p in c) {if (!this.isDefined(o[p])) {o[p] = c[p];}}}return o;}, eslint: _eslint2.default, esLintMsg: function esLintMsg(code, options) {return (0, _eslint2.default)(code, options).then(function (msg) {if (msg.length > 0) {var html = '\n            <table class="table table-bordered table-striped">\n              <thead>\n                <tr>\n                  <th>\u884C</th>\n                  <th>\u5217</th>\n                  <th>\u9519\u8BEF</th>\n                </tr>\n              </thead>\n              <tbody>\n                ' + msg.map(function (_ref2) {var column = _ref2.column,line = _ref2.line,message = _ref2.message;return '\n                    <tr>\n                      <td>' + line + '</td>\n                      <td>' + column + '</td>\n                      <td>' + message + '</td>\n                    </tr>\n                  ';}).join('') + '\n                </tbody>\n              </table>\n              ';_elementUi.MessageBox.alert(html, options.title || "语法错误", { dangerouslyUseHTMLString: true });}return msg.length == 0;});} };var downloadUrl = function downloadUrl(url) {var iframe = document.createElement('iframe');iframe.style.display = 'none';iframe.src = url;var onload = function onload() {};iframe.onload = onload;document.body.appendChild(iframe);};if (!window.localStorage.getItem("$customSessionId")) window.localStorage.setItem("$customSessionId", $uuid());_axios2.default.interceptors.request.use(function (config) {return config;}, function (error) {return _promise2.default.reject(error);});$.ajaxSetup({ type: "POST", beforeSend: function beforeSend(xhr) {}, complete: function complete(xhr) {}, statusCode: { 401: function _(a, err) {(0, _ajaxError.ajaxError)(err, '401');} } });function errMessage(message) {
  PF.message("error", message);

}

var security = exports.security = function security(_) {return {
    type: 'http',
    scheme: 'bearer',
    token: _token2.default.getToken() };};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(7)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 18 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(810), __esModule: true };

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(3);
var IE8_DOM_DEFINE = __webpack_require__(215);
var toPrimitive = __webpack_require__(53);
var dP = Object.defineProperty;

exports.f = __webpack_require__(17) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(112);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(54);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return warning; });
/* harmony export (immutable) */ __webpack_exports__["d"] = format;
/* harmony export (immutable) */ __webpack_exports__["e"] = isEmptyValue;
/* unused harmony export isEmptyObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncMap;
/* harmony export (immutable) */ __webpack_exports__["b"] = complementError;
/* harmony export (immutable) */ __webpack_exports__["c"] = deepMerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


var formatRegExp = /%[sdj%]/g;

var warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {
  warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var next = function next(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === objArrLength) {
      callback(results);
    }
  };
  objArrKeys.forEach(function (key) {
    var arr = objArr[key];
    if (firstFields.indexOf(key) !== -1) {
      asyncSerialArray(arr, func, next);
    } else {
      asyncParallelArray(arr, func, next);
    }
  });
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(target[s]) === 'object') {
          target[s] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(776), __esModule: true };

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _setCookie$getCookie$;var _os = __webpack_require__(846);

var _jsCookie = __webpack_require__(299);var _jsCookie2 = _interopRequireDefault(_jsCookie);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var TokenKey = 'xToken';exports.default = (_setCookie$getCookie$ = {


  setCookie: function setCookie(name, value, expDays) {
    _jsCookie2.default.set(name, value, { expires: expDays == undefined ? 7 : expDays });
  },

  getCookie: function getCookie(name) {
    return _jsCookie2.default.get(name);
  },


  delCookie: function delCookie(name) {
    _jsCookie2.default.remove(name);
  } }, (0, _defineProperty3.default)(_setCookie$getCookie$, 'delCookie', function delCookie(



cname) {
  _jsCookie2.default.remove(cname);
}), (0, _defineProperty3.default)(_setCookie$getCookie$, 'getToken', function getToken()


{

  return sessionStorage.getItem(TokenKey);
}), (0, _defineProperty3.default)(_setCookie$getCookie$, 'setToken', function setToken(
token) {
  return sessionStorage.setItem(TokenKey, token);
}), (0, _defineProperty3.default)(_setCookie$getCookie$, 'removeToken', function removeToken()
{
  return sessionStorage.removeItem(TokenKey);
}), _setCookie$getCookie$);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(963), __esModule: true };

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var core = __webpack_require__(18);
var ctx = __webpack_require__(64);
var hide = __webpack_require__(71);
var has = __webpack_require__(86);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(185)('wks');
var uid = __webpack_require__(135);
var Symbol = __webpack_require__(29).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(58);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(965);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(969);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(58);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__required__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__whitespace__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__range__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enum__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pattern__ = __webpack_require__(755);







/* harmony default export */ __webpack_exports__["a"] = ({
  required: __WEBPACK_IMPORTED_MODULE_0__required__["a" /* default */],
  whitespace: __WEBPACK_IMPORTED_MODULE_1__whitespace__["a" /* default */],
  type: __WEBPACK_IMPORTED_MODULE_2__type__["a" /* default */],
  range: __WEBPACK_IMPORTED_MODULE_3__range__["a" /* default */],
  'enum': __WEBPACK_IMPORTED_MODULE_4__enum__["a" /* default */],
  pattern: __WEBPACK_IMPORTED_MODULE_5__pattern__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var base = window.$servicePath;exports.default =

{

  listFlowDocument: function listFlowDocument() {for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {arg[_key] = arguments[_key];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.listFlowDocument'].concat(arg));
  },

  listCommentByBatch: function listCommentByBatch() {for (var _len2 = arguments.length, arg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {arg[_key2] = arguments[_key2];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.listCommentByBatch'].concat(arg));
  },

  addComment: function addComment() {for (var _len3 = arguments.length, arg = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {arg[_key3] = arguments[_key3];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.addComment'].concat(arg));
  },
  updateComment: function updateComment() {for (var _len4 = arguments.length, arg = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {arg[_key4] = arguments[_key4];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.updateComment'].concat(arg));
  },
  deleteComment: function deleteComment() {for (var _len5 = arguments.length, arg = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {arg[_key5] = arguments[_key5];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.deleteComment'].concat(arg));
  },
  getFlowProcess: function getFlowProcess() {for (var _len6 = arguments.length, arg = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {arg[_key6] = arguments[_key6];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.getFlowProcess'].concat(arg));
  },

  listUnfinishedTask: function listUnfinishedTask() {for (var _len7 = arguments.length, arg = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {arg[_key7] = arguments[_key7];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.listUnfinishedTask'].concat(arg));
  },

  listTaskTransactor: function listTaskTransactor() {for (var _len8 = arguments.length, arg = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {arg[_key8] = arguments[_key8];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.listTaskTransactor'].concat(arg));
  },

  getNextFlows: function getNextFlows() {for (var _len9 = arguments.length, arg = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {arg[_key9] = arguments[_key9];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.getNextFlows'].concat(arg));
  },

  getFlowGroupUserOrPositions: function getFlowGroupUserOrPositions() {for (var _len10 = arguments.length, arg = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {arg[_key10] = arguments[_key10];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.getFlowGroupUserOrPositions'].concat(arg));
  },

  forceComplete: function forceComplete() {for (var _len11 = arguments.length, arg = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {arg[_key11] = arguments[_key11];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.forceComplete'].concat(arg));
  },

  replaceTaskIdentity: function replaceTaskIdentity() {for (var _len12 = arguments.length, arg = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {arg[_key12] = arguments[_key12];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.replaceTaskIdentity'].concat(arg));
  },

  suspendProcess: function suspendProcess() {for (var _len13 = arguments.length, arg = Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {arg[_key13] = arguments[_key13];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.suspendProcess'].concat(arg));
  },
  listFlowSuspend: function listFlowSuspend() {for (var _len14 = arguments.length, arg = Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {arg[_key14] = arguments[_key14];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.listFlowSuspend'].concat(arg));
  },
  activeDocument: function activeDocument() {for (var _len15 = arguments.length, arg = Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {arg[_key15] = arguments[_key15];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.activeDocument'].concat(arg));
  },
  deleteDocument: function deleteDocument() {for (var _len16 = arguments.length, arg = Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {arg[_key16] = arguments[_key16];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.deleteDocument'].concat(arg));
  },
  forceWithdraw: function forceWithdraw() {for (var _len17 = arguments.length, arg = Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {arg[_key17] = arguments[_key17];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.forceWithdraw'].concat(arg));
  },

  getNormalTaskActivities: function getNormalTaskActivities() {for (var _len18 = arguments.length, arg = Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {arg[_key18] = arguments[_key18];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.getNormalTaskActivities'].concat(arg));
  },

  terminateProcess: function terminateProcess() {for (var _len19 = arguments.length, arg = Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {arg[_key19] = arguments[_key19];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.terminateProcess'].concat(arg));
  },

  toVoidDocument: function toVoidDocument() {for (var _len20 = arguments.length, arg = Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {arg[_key20] = arguments[_key20];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.toVoidDocument'].concat(arg));
  },

  listTransactionLog: function listTransactionLog() {for (var _len21 = arguments.length, arg = Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {arg[_key21] = arguments[_key21];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.listTransactionLog'].concat(arg));
  },
  getTransactionLog: function getTransactionLog() {for (var _len22 = arguments.length, arg = Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {arg[_key22] = arguments[_key22];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.getTransactionLog'].concat(arg));
  },
  expFlowTransLog: function expFlowTransLog(params) {
    return _util2.default.downloadAttachment(base + '/api/maintain/expFlowTransLog', params);
  },
  updateAndReExecute: function updateAndReExecute() {for (var _len23 = arguments.length, arg = Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {arg[_key23] = arguments[_key23];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.updateAndReExecute'].concat(arg));
  },
  reExecute: function reExecute() {for (var _len24 = arguments.length, arg = Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {arg[_key24] = arguments[_key24];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.reExecute'].concat(arg));
  },
  batchReExecute: function batchReExecute() {for (var _len25 = arguments.length, arg = Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {arg[_key25] = arguments[_key25];}
    return _util2.default.ajax.apply(_util2.default, [base_process_intervene + 'batchReExecute'].concat(arg));
  },
  specify: function specify() {for (var _len26 = arguments.length, arg = Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {arg[_key26] = arguments[_key26];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.specify'].concat(arg));
  },

  startSubProcess: function startSubProcess() {for (var _len27 = arguments.length, arg = Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {arg[_key27] = arguments[_key27];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.startSubProcess'].concat(arg));
  },

  addTask: function addTask() {for (var _len28 = arguments.length, arg = Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {arg[_key28] = arguments[_key28];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.addTask'].concat(arg));
  },
  deleteTask: function deleteTask() {for (var _len29 = arguments.length, arg = Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {arg[_key29] = arguments[_key29];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:pintervene.srv.deleteTask'].concat(arg));
  },

  getHiddenFormData: function getHiddenFormData() {for (var _len30 = arguments.length, arg = Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {arg[_key30] = arguments[_key30];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:maintain.srv.getHiddenFormData'].concat(arg));
  },
  listAuthority: function listAuthority() {for (var _len31 = arguments.length, arg = Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {arg[_key31] = arguments[_key31];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:maintain.srv.listAuthority'].concat(arg));
  },
  deleteAuthority: function deleteAuthority() {for (var _len32 = arguments.length, arg = Array(_len32), _key32 = 0; _key32 < _len32; _key32++) {arg[_key32] = arguments[_key32];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:maintain.srv.deleteAuthority'].concat(arg));
  },
  coverAuthority: function coverAuthority() {for (var _len33 = arguments.length, arg = Array(_len33), _key33 = 0; _key33 < _len33; _key33++) {arg[_key33] = arguments[_key33];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:maintain.srv.coverAuthority'].concat(arg));
  },
  listOrgRes: function listOrgRes() {for (var _len34 = arguments.length, arg = Array(_len34), _key34 = 0; _key34 < _len34; _key34++) {arg[_key34] = arguments[_key34];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:maintain.srv.listOrgRes'].concat(arg));
  },
  listOrgDetail: function listOrgDetail() {for (var _len35 = arguments.length, arg = Array(_len35), _key35 = 0; _key35 < _len35; _key35++) {arg[_key35] = arguments[_key35];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:maintain.srv.listOrgDetail'].concat(arg));
  },

  updateFormData: function updateFormData() {for (var _len36 = arguments.length, arg = Array(_len36), _key36 = 0; _key36 < _len36; _key36++) {arg[_key36] = arguments[_key36];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:maintain.srv.updateFormData'].concat(arg));
  },
  saveFormData: function saveFormData() {for (var _len37 = arguments.length, arg = Array(_len37), _key37 = 0; _key37 < _len37; _key37++) {arg[_key37] = arguments[_key37];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:maintain.srv.saveFormData'].concat(arg));
  },
  listTableTree: function listTableTree() {for (var _len38 = arguments.length, arg = Array(_len38), _key38 = 0; _key38 < _len38; _key38++) {arg[_key38] = arguments[_key38];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:maintain.srv.listTableTree'].concat(arg));
  },
  listTableInfo: function listTableInfo() {for (var _len39 = arguments.length, arg = Array(_len39), _key39 = 0; _key39 < _len39; _key39++) {arg[_key39] = arguments[_key39];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:maintain.srv.listTableInfo'].concat(arg));
  },
  importTableData: function importTableData() {for (var _len40 = arguments.length, arg = Array(_len40), _key40 = 0; _key40 < _len40; _key40++) {arg[_key40] = arguments[_key40];}
    return _util2.default.ajax.apply(_util2.default, [base + '/cheetah/service/s:maintain.srv.importTableData'].concat(arg));
  },



  exportSqlTableData: function exportSqlTableData(data) {
    var params = {};
    var json = PF.encode({ data: data });
    return _util2.default.downloadAttachment(base + '/api/maintain/exportSqlTableData', params, undefined, json, true);
  } };

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20);
var createDesc = __webpack_require__(73);
module.exports = __webpack_require__(17) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var hide = __webpack_require__(35);
var has = __webpack_require__(39);
var SRC = __webpack_require__(74)('src');
var $toString = __webpack_require__(509);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(44).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var fails = __webpack_require__(7);
var defined = __webpack_require__(54);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(931);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(100);
var defined = __webpack_require__(54);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(101);
var createDesc = __webpack_require__(73);
var toIObject = __webpack_require__(40);
var toPrimitive = __webpack_require__(53);
var has = __webpack_require__(39);
var IE8_DOM_DEFINE = __webpack_require__(215);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(17) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(39);
var toObject = __webpack_require__(22);
var IE_PROTO = __webpack_require__(145)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(294);
var isBuffer = __webpack_require__(827);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(27);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(57);
var IE8_DOM_DEFINE = __webpack_require__(258);
var toPrimitive = __webpack_require__(180);
var dP = Object.defineProperty;

exports.f = __webpack_require__(51) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(85)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isEmpty = exports.isEqual = exports.arrayEquals = exports.looseEqual = exports.capitalize = exports.kebabCase = exports.autoprefixer = exports.isFirefox = exports.isEdge = exports.isIE = exports.coerceTruthyValueToArray = exports.arrayFind = exports.arrayFindIndex = exports.escapeRegexpString = exports.valueEquals = exports.generateId = exports.getValueByPath = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.noop = noop;
exports.hasOwn = hasOwn;
exports.toObject = toObject;
exports.getPropByPath = getPropByPath;
exports.rafThrottle = rafThrottle;
exports.objToArray = objToArray;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _types = __webpack_require__(214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasOwnProperty = Object.prototype.hasOwnProperty;

function noop() {};

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
};

function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
};

function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
};

var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  var keyArr = path.split('.');
  var i = 0;
  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    var key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
};

var generateId = exports.generateId = function generateId() {
  return Math.floor(Math.random() * 10000);
};

var valueEquals = exports.valueEquals = function valueEquals(a, b) {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

var escapeRegexpString = exports.escapeRegexpString = function escapeRegexpString() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
};

// TODO: use native Array.find, Array.findIndex when IE support is dropped
var arrayFindIndex = exports.arrayFindIndex = function arrayFindIndex(arr, pred) {
  for (var i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};

var arrayFind = exports.arrayFind = function arrayFind(arr, pred) {
  var idx = arrayFindIndex(arr, pred);
  return idx !== -1 ? arr[idx] : undefined;
};

// coerce truthy value to array
var coerceTruthyValueToArray = exports.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};

var isIE = exports.isIE = function isIE() {
  return !_vue2.default.prototype.$isServer && !isNaN(Number(document.documentMode));
};

var isEdge = exports.isEdge = function isEdge() {
  return !_vue2.default.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
};

var isFirefox = exports.isFirefox = function isFirefox() {
  return !_vue2.default.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
};

var autoprefixer = exports.autoprefixer = function autoprefixer(style) {
  if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') return style;
  var rules = ['transform', 'transition', 'animation'];
  var prefixes = ['ms-', 'webkit-'];
  rules.forEach(function (rule) {
    var value = style[rule];
    if (rule && value) {
      prefixes.forEach(function (prefix) {
        style[prefix + rule] = value;
      });
    }
  });
  return style;
};

var kebabCase = exports.kebabCase = function kebabCase(str) {
  var hyphenateRE = /([^-])([A-Z])/g;
  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
};

var capitalize = exports.capitalize = function capitalize(str) {
  if (!(0, _types.isString)(str)) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

var looseEqual = exports.looseEqual = function looseEqual(a, b) {
  var isObjectA = (0, _types.isObject)(a);
  var isObjectB = (0, _types.isObject)(b);
  if (isObjectA && isObjectB) {
    return JSON.stringify(a) === JSON.stringify(b);
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
};

var arrayEquals = exports.arrayEquals = function arrayEquals(arrayA, arrayB) {
  arrayA = arrayA || [];
  arrayB = arrayB || [];

  if (arrayA.length !== arrayB.length) {
    return false;
  }

  for (var i = 0; i < arrayA.length; i++) {
    if (!looseEqual(arrayA[i], arrayB[i])) {
      return false;
    }
  }

  return true;
};

var isEqual = exports.isEqual = function isEqual(value1, value2) {
  if (Array.isArray(value1) && Array.isArray(value2)) {
    return arrayEquals(value1, value2);
  }
  return looseEqual(value1, value2);
};

var isEmpty = exports.isEmpty = function isEmpty(val) {
  // null or undefined
  if (val == null) return true;

  if (typeof val === 'boolean') return false;

  if (typeof val === 'number') return !val;

  if (val instanceof Error) return val.message === '';

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case '[object String]':
    case '[object Array]':
      return !val.length;

    // Map or Set or File
    case '[object File]':
    case '[object Map]':
    case '[object Set]':
      {
        return !val.size;
      }
    // Plain Object
    case '[object Object]':
      {
        return !Object.keys(val).length;
      }
  }

  return false;
};

function rafThrottle(fn) {
  var locked = false;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (locked) return;
    locked = true;
    window.requestAnimationFrame(function (_) {
      fn.apply(_this, args);
      locked = false;
    });
  };
}

function objToArray(obj) {
  if (Array.isArray(obj)) {
    return obj;
  }
  return isEmpty(obj) ? [] : [obj];
}

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(8);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(44);
var fails = __webpack_require__(7);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(45);
var IObject = __webpack_require__(100);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(14);
var asc = __webpack_require__(161);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(50);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(735);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(742);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(777), __esModule: true };

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(805);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(89);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(17)) {
  var LIBRARY = __webpack_require__(68);
  var global = __webpack_require__(4);
  var fails = __webpack_require__(7);
  var $export = __webpack_require__(1);
  var $typed = __webpack_require__(126);
  var $buffer = __webpack_require__(169);
  var ctx = __webpack_require__(45);
  var anInstance = __webpack_require__(80);
  var propertyDesc = __webpack_require__(73);
  var hide = __webpack_require__(35);
  var redefineAll = __webpack_require__(82);
  var toInteger = __webpack_require__(47);
  var toLength = __webpack_require__(14);
  var toIndex = __webpack_require__(243);
  var toAbsoluteIndex = __webpack_require__(76);
  var toPrimitive = __webpack_require__(53);
  var has = __webpack_require__(39);
  var classof = __webpack_require__(93);
  var isObject = __webpack_require__(8);
  var toObject = __webpack_require__(22);
  var isArrayIter = __webpack_require__(158);
  var create = __webpack_require__(77);
  var getPrototypeOf = __webpack_require__(42);
  var gOPN = __webpack_require__(78).f;
  var getIterFn = __webpack_require__(160);
  var uid = __webpack_require__(74);
  var wks = __webpack_require__(13);
  var createArrayMethod = __webpack_require__(56);
  var createArrayIncludes = __webpack_require__(116);
  var speciesConstructor = __webpack_require__(103);
  var ArrayIterators = __webpack_require__(163);
  var Iterators = __webpack_require__(95);
  var $iterDetect = __webpack_require__(121);
  var setSpecies = __webpack_require__(79);
  var arrayFill = __webpack_require__(162);
  var arrayCopyWithin = __webpack_require__(232);
  var $DP = __webpack_require__(20);
  var $GOPD = __webpack_require__(41);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(238);
var $export = __webpack_require__(1);
var shared = __webpack_require__(99)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(241))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isInContainer = exports.getScrollContainer = exports.isScroll = exports.getStyle = exports.once = exports.off = exports.on = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* istanbul ignore next */

exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.setStyle = setStyle;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = _vue2.default.prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);

/* istanbul ignore next */
var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
var on = exports.on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var off = exports.off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var once = exports.once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
};

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
};

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
};

/* istanbul ignore next */
var getStyle = exports.getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

/* istanbul ignore next */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
};

var isScroll = exports.isScroll = function isScroll(el, vertical) {
  if (isServer) return;

  var determinedDirection = vertical !== null || vertical !== undefined;
  var overflow = determinedDirection ? vertical ? getStyle(el, 'overflow-y') : getStyle(el, 'overflow-x') : getStyle(el, 'overflow');

  return overflow.match(/(scroll|auto)/);
};

var getScrollContainer = exports.getScrollContainer = function getScrollContainer(el, vertical) {
  if (isServer) return;

  var parent = el;
  while (parent) {
    if ([window, document, document.documentElement].includes(parent)) {
      return window;
    }
    if (isScroll(parent, vertical)) {
      return parent;
    }
    parent = parent.parentNode;
  }

  return parent;
};

var isInContainer = exports.isInContainer = function isInContainer(el, container) {
  if (isServer || !el || !container) return false;

  var elRect = el.getBoundingClientRect();
  var containerRect = void 0;

  if ([window, document, document.documentElement, null, undefined].includes(container)) {
    containerRect = {
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      left: 0
    };
  } else {
    containerRect = container.getBoundingClientRect();
  }

  return elRect.top < containerRect.bottom && elRect.bottom > containerRect.top && elRect.right > containerRect.left && elRect.left < containerRect.right;
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(104);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(26);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(972);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty = __webpack_require__(112);var _defineProperty2 = _interopRequireDefault(_defineProperty);var _toConsumableArray2 = __webpack_require__(38);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default = new (function () {
  function _class() {(0, _classCallCheck3.default)(this, _class);}(0, _createClass3.default)(_class, [{ key: "matches", value: function matches(

    el, selector) {
      var names = [
      "matches",
      "matchesSelector",
      "mozMatchesSelector",
      "msMatchesSelector",
      "oMatchesSelector",
      "webkitMatchesSelector"],
      i = void 0;

      for (i = 0; i < names.length; i++) {
        if (names[i] in el) {
          return el[names[i]](selector);
        }
      }
      return false;
    } }, { key: "contains", value: function contains(

    wrapper, inner) {
      if ('contains' in wrapper) {
        return wrapper.contains(inner);
      }

      for (var layer = inner; layer && layer.nodeType === 1; layer = layer.parentNode) {
        if (layer === wrapper) {
          return true;
        }
      }

      return false;
    } }, { key: "closest", value: function closest(

    el, selector) {
      if ("closest" in el) {
        return el.closest(selector);
      }
      if (!document.documentElement.contains(el)) {
        return null;
      }
      do {
        if (this.matches(el, selector)) {
          return el;
        }
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    } }, { key: "byId", value: function byId(

    id) {
      return document.getElementById(id);
    } }, { key: "attr", value: function attr(

    el, attrs) {
      if (!attrs) {
        var ats = {};
        for (var i = 0; i < el.attributes.length; i++) {
          ats[el.attributes[i].nodeName] = el.attributes[i].nodeValue;
        }
        return ats;
      } else {
        for (var name in attrs) {
          if (Object.prototype.hasOwnProperty.call(attrs, name)) {
            el.setAttributeNS(null, name, attrs[name]);
          }
        }
      }
    } }, { key: "assign", value: function assign(

    target, varArgs) {
      if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          for (var nextKey in nextSource) {

            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    } }, { key: "omit", value: function omit(

    target, args) {
      var res = this.assign({}, target);

      for (var i = 0; i < args.length; i++) {
        if (args[i] in res) {
          delete res[args[i]];
        }
      }

      return res;
    } }, { key: "isEmpty", value: function isEmpty(

    x) {
      if (!x) return true;
      for (var k in x) {
        if ({}.hasOwnProperty.call(x, k)) {
          return false;
        }
      }
      return true;
    } }, { key: "chunkString", value: function chunkString(

    str, length) {
      length = Math.floor(length);
      var regWithWordBreak = new RegExp("^.{1," + length + "}\\b", "g"),
      nameChunks = [],
      match = null;
      for (
      nameChunks = [];
      str.length > 0;
      str = str.substring(nameChunks[nameChunks.length - 1].length))
      {
        match = str.match(regWithWordBreak);

        if (match) {
          nameChunks.push(match[0]);
        } else {
          nameChunks.push(str.substr(0, length));
        }
      }

      return nameChunks;
    } }, { key: "applyMatrix", value: function applyMatrix(

    matrix, _ref) {var x = _ref.x,y = _ref.y;
      return {
        x: x * matrix[0] + y * matrix[2] + matrix[4],
        y: x * matrix[1] + y * matrix[3] + matrix[5] };

    } }, { key: "unapplyMatrix", value: function unapplyMatrix(

    matrix, _ref2) {var _Snap;var x = _ref2.x,y = _ref2.y;

      var inverted = (_Snap = Snap).matrix.apply(_Snap, (0, _toConsumableArray3.default)(matrix)).invert();

      return this.applyMatrix([
      inverted.a,
      inverted.b,
      inverted.c,
      inverted.d,
      inverted.e,
      inverted.f],
      { x: x, y: y });
    } }, { key: "watch", value: function watch(

    obj, propList, onChange) {
      var name = void 0,value = void 0;
      for (var i = 0; i < propList.length; i++) {
        name = propList[i];
        value = obj[name];
        (function (name, value) {
          (0, _defineProperty2.default)(obj, name, {
            get: function get() {
              return obj["@" + name];
            },
            set: function set(value) {
              var pre = obj["@" + name];
              obj["@" + name] = value;
              onChange(name, pre, value);
            } });

        })(name, value);
        obj["@" + name] = value;
        obj[name] = value;
      }

    } }, { key: "hasClass", value: function hasClass(

    el, className) {
      return !!(el.getAttribute("class") || "").match(new RegExp("(^|\\s)(" + className + ")(?=$|\\s)"));
    } }, { key: "addClass", value: function addClass(

    el, className) {
      el.setAttribute("class", el.className + " " + className);
    } }, { key: "removeClass", value: function removeClass(

    el, className) {
      el.setAttribute("class", el.className.replace(new RegExp("(^|\\s)(" + className + ")(?=$|\\s)"), ""));
    } }, { key: "getTextLen", value: function getTextLen(

    s) {
      var sum = 0;
      if (s) {
        var len = s.length;
        for (var i = 0; i < len; i++) {
          var code = s.charCodeAt(i);
          sum += code <= 127 ? 1 : 2;
        }
        sum = sum * 7 + 10;
      }
      return sum < 100 ? 100 : sum;
    } }, { key: "isRectNode", value: function isRectNode(
    n) {
      return n && n.type !== 'start' && n.type !== 'end';
    } }]);return _class;}())();

/***/ }),
/* 67 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(74)('meta');
var isObject = __webpack_require__(8);
var has = __webpack_require__(39);
var setDesc = __webpack_require__(20).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(7)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(13)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(35)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(49);
var createDesc = __webpack_require__(105);
module.exports = __webpack_require__(51) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default = new (function () {
  function _class() {(0, _classCallCheck3.default)(this, _class);
    this.footprints = {};
    this.alphabet = "XEROPHYTICS";
  }(0, _createClass3.default)(_class, [{ key: "next", value: function next()

    {
      var id = new Date().valueOf() + "";

      if (id in this.footprints) {
        this.footprints[id] += 1;
      } else {
        this.footprints = (0, _defineProperty3.default)({},
        id, 0);

      }
      return this.alphabet.charAt(+(this.footprints[id] + "").substr(-1)) + (id + this.footprints[id]) + (Math.random() + "").substr(2);
    } }, { key: "join", value: function join()

    {for (var _len = arguments.length, ids = Array(_len), _key = 0; _key < _len; _key++) {ids[_key] = arguments[_key];}

      return ids.join(":");
    } }, { key: "split", value: function split(

    id) {
      return (id || "").split(":");
    } }]);return _class;}())();

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(217);
var enumBugKeys = __webpack_require__(146);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(47);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(3);
var dPs = __webpack_require__(218);
var enumBugKeys = __webpack_require__(146);
var IE_PROTO = __webpack_require__(145)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(143)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(147).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(217);
var hiddenKeys = __webpack_require__(146).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var dP = __webpack_require__(20);
var DESCRIPTORS = __webpack_require__(17);
var SPECIES = __webpack_require__(13)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(45);
var call = __webpack_require__(230);
var isArrayIter = __webpack_require__(158);
var anObject = __webpack_require__(3);
var toLength = __webpack_require__(14);
var getIterFn = __webpack_require__(160);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(36);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
exports.default = {
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
};

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(181);
var defined = __webpack_require__(182);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(182);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(808), __esModule: true };

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var i = 0;exports.default =

{









































  modeFilter: {
    ShapeFocus: 1,
    ShapePan: 2,
    ShapeRemove: 4,
    ShapeConnect: 8,

    LineFocus: 16,
    LinePan: 32,
    LineRemove: 64,
    LineReconnect: 128 },


  tools: {
    hand: i++,
    marquee: i++ } };

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var base = window.$servicePath;exports.default =

{



    listMainMenu: function listMainMenu() {
        return _util2.default.ajax(base + '/api/app/mainMenu');
    },



    listApplication: function listApplication() {
        return _util2.default.ajax(base + '/api/app/listApplication');
    },
    groupApplicationByCode: function groupApplicationByCode(code) {
        return _util2.default.ajax(base + '/api/app/groupApplicationByCode', code);
    },

    clearComponentData: function clearComponentData() {
        return _util2.default.ajax(base + '/api/app/clearComponentData', null);
    },
    getFormFields: function getFormFields(formId) {
        return _util2.default.ajax(base + '/api/app/getFormFields', formId);
    },

    listFormKeys: function listFormKeys() {
        return _util2.default.ajax(base + '/api/app/listFormKeys');
    },




    listActionComponent: function listActionComponent(params) {
        return _util2.default.ajax(base + '/api/app/listActionComponent', params);
    },

    createActionComponent: function createActionComponent(params) {
        return _util2.default.ajax(base + '/api/app/createActionComponent', params);
    },

    createPageComponent: function createPageComponent(params) {
        return _util2.default.ajax(base + '/api/app/createPageComponent', params);
    },

    getScriptComponent: function getScriptComponent(id) {
        return _util2.default.ajax(base + '/api/app/getScriptComponent', id);
    },
    removeComponent: function removeComponent(ids) {
        return _util2.default.ajax(base + '/api/app/removeComponent', ids);
    },



    listDatabaseComponent: function listDatabaseComponent(params) {
        return _util2.default.ajax(base + '/api/app/listDatabaseComponent', params);
    },

    createDatabaseComponent: function createDatabaseComponent(params) {
        return _util2.default.ajax(base + '/api/app/createDatabaseComponent', params);
    },
    getDatabaseComponent: function getDatabaseComponent(id) {
        return _util2.default.ajax(base + '/api/app/getDatabaseComponent', id);
    },



    getDefaultButton: function getDefaultButton(params) {
        params.flag = 1;
        return _util2.default.ajax(base + '/api/app/listActionComponentByType', params);
    },




    getAllButton: function getAllButton(params) {

        return _util2.default.ajax(base + '/api/app/listActionComponentByType', params);
    },




    createApplication: function createApplication(params) {
        return _util2.default.ajax(base + '/api/app/createApplication', params);
    },





    setApplicationProperties: function setApplicationProperties(params, id) {
        return _util2.default.ajax(base + '/api/app/setApplicationProperties', params, id);
    },

    updateApplicationCode: function updateApplicationCode(params) {
        return _util2.default.ajax(base + '/api/app/updateApplicationCode', params);
    },

    updateApplicationSn: function updateApplicationSn(ids) {
        return _util2.default.ajax(base + '/api/app/updateApplicationSn', ids);
    },




    removeApplication: function removeApplication(id) {
        return _util2.default.ajax(base + '/api/app/removeApplication', id);
    },





    copyApplication: function copyApplication(id) {

    },





    createApplicationItem: function createApplicationItem(params, appId) {
        return _util2.default.ajax(base + '/api/app/createApplicationItem', params, appId);
    },








    setApplicationItemProperties: function setApplicationItemProperties(params, id, appId) {
        return _util2.default.ajax(base + '/api/app/setApplicationItemProperties', params, id, appId);
    },

    saveViewConfig: function saveViewConfig(params, id, appId) {
        return _util2.default.ajax(base + '/api/app/saveViewConfig', params, id, appId);
    },








    removeApplicationItem: function removeApplicationItem(id, appId) {
        return _util2.default.ajax(base + '/api/app/removeApplicationItem', id, appId);
    },





    getApplicationItem: function getApplicationItem(id, appId) {
        return _util2.default.ajax(base + '/api/app/getApplicationItem', id, appId);
    },

    getApplicationItems: function getApplicationItems(ids, appId) {
        return _util2.default.ajax(base + '/api/app/getApplicationItems', ids, appId);
    },







    getApplicationViewItems: function getApplicationViewItems(ids, params, appId) {
        return _util2.default.ajax(base + '/api/app/getApplicationViewCompItems', ids, params, appId);
    },
    getApplicationLink: function getApplicationLink(id, appId) {
        return _util2.default.ajax(base + '/api/app/getApplicationLink', id, appId);
    },



    getNavigatorRecord: function getNavigatorRecord(id, appId) {
        return _util2.default.ajax(base + '/api/app/getNavigatorRecord', id, appId);
    },



    listApplicationItem: function listApplicationItem(appId) {
        return _util2.default.ajax(base + '/api/app/listApplicationItem', appId);
    },


    getApplication: function getApplication(appId) {
        return _util2.default.ajax(base + '/api/app/getApplication', appId);
    },
















    listAppItemTree: function listAppItemTree(appId, ItemId) {
        return _util2.default.ajax(base + '/api/app/listAppItemTree', appId, ItemId);
    },


    sortApplicationItem: function sortApplicationItem(parentId, moduleId, appId, sortIds) {
        return _util2.default.ajax(base + '/api/app/sortApplicationItem', parentId, moduleId, appId, sortIds);
    },




    listApplicationFormKey: function listApplicationFormKey(appId) {
        return _util2.default.ajax(base + '/api/app/listApplicationFormKey', appId);
    },

    listApplicationView: function listApplicationView(appId) {
        return _util2.default.ajax(base + '/api/app/listApplicationView', appId);
    },




    formConfig: function formConfig(id, appId) {
        return _util2.default.ajax(base + '/api/app/formConfig', id, appId);
    },












    saveFlowConfig: function saveFlowConfig(data) {
        return _util2.default.ajax(base + '/api/app/saveFlowConfig', data);
    },

    getFlowConfig: function getFlowConfig() {
        return _util2.default.ajax(base + '/api/app/getFlowConfig');
    },

    saveComponentRepositoryConfig: function saveComponentRepositoryConfig(data) {
        return _util2.default.ajax(base + '/api/app/saveComponentRepositoryConfig', data);
    },

    getComponentRepositoryConfig: function getComponentRepositoryConfig() {
        return _util2.default.ajax(base + '/api/app/getComponentRepositoryConfig');
    },

    listApplicationItemTree: function listApplicationItemTree() {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/listApplicationItemTree'].concat(args));
    },

    updateModuleName: function updateModuleName() {for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {args[_key2] = arguments[_key2];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/updateModuleName'].concat(args));
    },
    updateApplicationEntries: function updateApplicationEntries() {for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {args[_key3] = arguments[_key3];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/updateApplicationEntries'].concat(args));
    },

    saveModuleData: function saveModuleData() {for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {args[_key4] = arguments[_key4];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/saveModuleData'].concat(args));
    },

    getModuleDataConfig: function getModuleDataConfig() {for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {args[_key5] = arguments[_key5];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/getModuleDataConfig'].concat(args));
    },


    saveModuleFlow: function saveModuleFlow() {for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {args[_key6] = arguments[_key6];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/saveModuleSet'].concat(args));
    },

    getModuleFlowConfig: function getModuleFlowConfig() {for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {args[_key7] = arguments[_key7];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/getModuleFlowConfig'].concat(args));
    },


    listModuleForm: function listModuleForm() {for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {args[_key8] = arguments[_key8];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/listModuleForm'].concat(args));
    },

    changeModuleForm: function changeModuleForm() {for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {args[_key9] = arguments[_key9];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/changeModuleForm'].concat(args));
    },

    changeModuleRelateForm: function changeModuleRelateForm() {for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {args[_key10] = arguments[_key10];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/changeModuleRelateForm'].concat(args));
    },

    saveModuleSet: function saveModuleSet() {for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {args[_key11] = arguments[_key11];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/saveModuleSet'].concat(args));
    },
    saveFieldMapping: function saveFieldMapping() {for (var _len12 = arguments.length, args = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {args[_key12] = arguments[_key12];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/saveFieldMapping'].concat(args));
    },
    copeForm: function copeForm() {for (var _len13 = arguments.length, args = Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {args[_key13] = arguments[_key13];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/copeForm'].concat(args));
    },
    copyModule: function copyModule() {for (var _len14 = arguments.length, args = Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {args[_key14] = arguments[_key14];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/copyModule'].concat(args));
    },
    copyModuleFlow: function copyModuleFlow() {for (var _len15 = arguments.length, args = Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {args[_key15] = arguments[_key15];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/copyModuleFlow'].concat(args));
    },
    relateFlow: function relateFlow() {for (var _len16 = arguments.length, args = Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {args[_key16] = arguments[_key16];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/relateFlow'].concat(args));
    },
    delRelateFlow: function delRelateFlow() {for (var _len17 = arguments.length, args = Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {args[_key17] = arguments[_key17];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/delRelateFlow'].concat(args));
    },
    getModuleSetConfig: function getModuleSetConfig() {for (var _len18 = arguments.length, args = Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {args[_key18] = arguments[_key18];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/getModuleSetConfig'].concat(args));
    },






    saveModuleForm: function saveModuleForm() {for (var _len19 = arguments.length, args = Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {args[_key19] = arguments[_key19];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/saveModuleForm'].concat(args));
    },

    createModuleForm: function createModuleForm() {for (var _len20 = arguments.length, args = Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {args[_key20] = arguments[_key20];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/createFormDefinition'].concat(args));
    },

    publishDefinition: function publishDefinition() {for (var _len21 = arguments.length, args = Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {args[_key21] = arguments[_key21];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/publishFormDefinition'].concat(args));
    },

    removeDefinition: function removeDefinition() {for (var _len22 = arguments.length, args = Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {args[_key22] = arguments[_key22];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/removeFormDefinition'].concat(args));
    },
    recoverDefinition: function recoverDefinition() {for (var _len23 = arguments.length, args = Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {args[_key23] = arguments[_key23];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/recoverFormDefinition'].concat(args));
    },

    deleteDefinition: function deleteDefinition() {for (var _len24 = arguments.length, args = Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {args[_key24] = arguments[_key24];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/deleteFormDefinition'].concat(args));
    },

    saveModuleMobile: function saveModuleMobile() {for (var _len25 = arguments.length, args = Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {args[_key25] = arguments[_key25];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/saveModuleMobile'].concat(args));
    },

    listExclusiveMarkDeletedDefinition: function listExclusiveMarkDeletedDefinition() {for (var _len26 = arguments.length, args = Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {args[_key26] = arguments[_key26];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/listExclusiveMarkDeletedDefinition'].concat(args));
    },

    listMarkDeletedDefinition: function listMarkDeletedDefinition() {for (var _len27 = arguments.length, args = Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {args[_key27] = arguments[_key27];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/listMarkDeletedDefinition'].concat(args));
    },

    listFormVersionByModuleId: function listFormVersionByModuleId() {for (var _len28 = arguments.length, args = Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {args[_key28] = arguments[_key28];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/listFormVersionByModuleId'].concat(args));
    },




    getModuleFormConfig: function getModuleFormConfig() {for (var _len29 = arguments.length, args = Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {args[_key29] = arguments[_key29];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/getModuleFormConfig'].concat(args));
    },

    applicationLinkTree: function applicationLinkTree() {for (var _len30 = arguments.length, args = Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {args[_key30] = arguments[_key30];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/applicationLinkTree'].concat(args));
    },

    listApplicationItemsByCode: function listApplicationItemsByCode() {for (var _len31 = arguments.length, args = Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {args[_key31] = arguments[_key31];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/listApplicationItemsByCode'].concat(args));
    },
    getAppModuleItems: function getAppModuleItems() {for (var _len32 = arguments.length, args = Array(_len32), _key32 = 0; _key32 < _len32; _key32++) {args[_key32] = arguments[_key32];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/getAppModuleItems'].concat(args));
    },

    saveSystemParameter: function saveSystemParameter() {for (var _len33 = arguments.length, args = Array(_len33), _key33 = 0; _key33 < _len33; _key33++) {args[_key33] = arguments[_key33];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/saveSystemParameter'].concat(args));
    },

    getSystemParameter: function getSystemParameter() {for (var _len34 = arguments.length, args = Array(_len34), _key34 = 0; _key34 < _len34; _key34++) {args[_key34] = arguments[_key34];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/getSystemParameter'].concat(args));
    },

    listApplicationItemsByCategory: function listApplicationItemsByCategory() {for (var _len35 = arguments.length, args = Array(_len35), _key35 = 0; _key35 < _len35; _key35++) {args[_key35] = arguments[_key35];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/listApplicationItemsByCategory'].concat(args));
    },

    listSystemService: function listSystemService(params) {
        return _util2.default.ajax(base + '/api/app/listSystemService', params);
    },
    getSystemService: function getSystemService(id) {
        return _util2.default.ajax(base + '/api/app/getSystemService', id);
    },
    saveSystemService: function saveSystemService(params) {
        return _util2.default.ajax(base + '/api/app/saveSystemService', params);
    },
    removeSystemService: function removeSystemService(ids) {
        return _util2.default.ajax(base + '/api/app/removeSystemService', ids);
    },

    exportApplication: function exportApplication(ids) {
        var params = {};
        var json = PF.encode({
            ids: ids,
            fileName: '\u5BFC\u51FA\u5E94\u7528(' + ids.length + ')' });

        return _util2.default.downloadAttachment(base + '/api/app/exportApplication', params, undefined, json, true);
    },
    exportApplicationComp: function exportApplicationComp(ids) {
        var params = {};
        var json = PF.encode({
            ids: ids,
            fileName: '\u5BFC\u51FA\u7EC4\u4EF6(' + ids.length + ')',
            excludeCategories: ['flow_def', 'module_flow', 'dict', '数据模型'],
            noProgramFiles: true });

        return _util2.default.downloadAttachment(base + '/api/app/exportApplication', params, undefined, json, true);
    },
    exportComponentByIds: function exportComponentByIds(ids, type) {
        var params = {};
        var json = PF.encode({ ids: ids, type: type });
        return _util2.default.downloadAttachment(base + '/api/app/exportComponentByIds', params, undefined, json, true);
    },

    exportComponentByCategoryIds: function exportComponentByCategoryIds(ids, moduleName) {
        var params = {};
        var json = PF.encode({ ids: ids, fileName: moduleName });
        return _util2.default.downloadAttachment(base + '/api/app/exportComponentByCategoryIds', params, undefined, json, true);
    },


    copyView: function copyView() {for (var _len36 = arguments.length, args = Array(_len36), _key36 = 0; _key36 < _len36; _key36++) {args[_key36] = arguments[_key36];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/copyView'].concat(args));
    },
    listModuleFormOperAuthTree: function listModuleFormOperAuthTree(params) {
        return _util2.default.ajax(base + '/api/app/listModuleFormOperAuthTree', params);
    },
    listComponentsByTypeAndAppId: function listComponentsByTypeAndAppId(params) {
        return _util2.default.ajax(base + '/api/app/listComponentsByTypeAndAppId', params);
    },

    listComponentsByAppId: function listComponentsByAppId(params) {
        return _util2.default.ajax(base + '/api/app/listComponentsByAppId', params);
    },
    listComponentType: function listComponentType(params) {
        return _util2.default.ajax(base + '/api/sys/listComponentType', params);
    },
    listComponent: function listComponent(params) {
        return _util2.default.ajax(base + '/api/sys/listComponent', params);
    },
    saveComponent: function saveComponent(params) {
        return _util2.default.ajax(base + '/api/app/saveComponent', params);
    },
    saveEsModelComponent: function saveEsModelComponent(params) {
        return _util2.default.ajax(base + '/api/app/saveEsModelComponent', params);
    },
    importEsData: function importEsData(params) {
        return _util2.default.ajax(base + '/api/app/importEsData', params);
    },
    refreshComponentCache: function refreshComponentCache() {
        return _util2.default.ajax(base + '/api/sys/refreshComponentCache');
    },

    getNavigatorTreeNode: function getNavigatorTreeNode(appId, nodeId) {
        return _util2.default.ajax(base + '/api/app/getNavigatorTreeNode', appId, nodeId);
    },
    getNavigatorTree: function getNavigatorTree(params) {
        return _util2.default.ajax(base + '/api/app/getNavigatorTree', params);
    },
    getAuthNavigatorTree: function getAuthNavigatorTree(params) {
        return _util2.default.ajax(base + '/api/app/getAuthNavigatorTree', params);
    },
    saveNavigatorTree: function saveNavigatorTree(appId, data) {
        return _util2.default.ajax(base + '/api/app/saveNavigatorTree', appId, data);
    },
    copyNavigatorTree: function copyNavigatorTree(appId, id) {
        return _util2.default.ajax(base + '/api/app/copyNavigatorTree', appId, id);
    },
    removeNavigatorTree: function removeNavigatorTree(appId, id) {
        return _util2.default.ajax(base + '/api/app/removeNavigatorTree', appId, id);
    },
    dragNavigatorTreeNode: function dragNavigatorTreeNode(params) {
        return _util2.default.ajax(base + '/api/app/dragNavigatorTreeNode', params);
    },

    copyActionComponent: function copyActionComponent() {for (var _len37 = arguments.length, args = Array(_len37), _key37 = 0; _key37 < _len37; _key37++) {args[_key37] = arguments[_key37];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/copyActionComponent'].concat(args));
    },

    copyComp: function copyComp() {for (var _len38 = arguments.length, args = Array(_len38), _key38 = 0; _key38 < _len38; _key38++) {args[_key38] = arguments[_key38];}
        return _util2.default.ajax.apply(_util2.default, [base + '/api/app/copyComponent'].concat(args));
    },
    getVersionComponent: function getVersionComponent(id) {
        return _util2.default.ajax(base + '/api/app/getVersionComponent', id);
    },
    listComponentRevision: function listComponentRevision(params) {
        return _util2.default.ajax(base + '/api/sys/listComponentRevision', params);
    },
    getComponentRevisionRawData: function getComponentRevisionRawData(id, repositoryId) {
        return _util2.default.ajax(base + '/api/sys/getComponentRevisionRawData', id, repositoryId);
    },
    revertComponent: function revertComponent(ids) {
        return _util2.default.ajax(base + '/api/sys/revertComponent', ids);
    } };

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(20).f;
var has = __webpack_require__(39);
var TAG = __webpack_require__(13)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(46);
var TAG = __webpack_require__(13)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(54);
var fails = __webpack_require__(7);
var spaces = __webpack_require__(149);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(737)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(188)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67), __webpack_require__(502)(module)))

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(44);
var global = __webpack_require__(4);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(68) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(46);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(3);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(3);
var aFunction = __webpack_require__(27);
var SPECIES = __webpack_require__(13)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(259);
var enumBugKeys = __webpack_require__(186);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 107 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(49).f;
var has = __webpack_require__(86);
var TAG = __webpack_require__(30)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(740);
var global = __webpack_require__(29);
var hide = __webpack_require__(71);
var Iterators = __webpack_require__(97);
var TO_STRING_TAG = __webpack_require__(30)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(64);
var call = __webpack_require__(284);
var isArrayIter = __webpack_require__(285);
var anObject = __webpack_require__(57);
var toLength = __webpack_require__(134);
var getIterFn = __webpack_require__(195);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(844), __esModule: true };

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.i18n = exports.use = exports.t = undefined;

var _zhCN = __webpack_require__(503);

var _zhCN2 = _interopRequireDefault(_zhCN);

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _deepmerge = __webpack_require__(504);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _format = __webpack_require__(505);

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var format = (0, _format2.default)(_vue2.default);
var lang = _zhCN2.default;
var merged = false;
var i18nHandler = function i18nHandler() {
  var vuei18n = Object.getPrototypeOf(this || _vue2.default).$t;
  if (typeof vuei18n === 'function' && !!_vue2.default.locale) {
    if (!merged) {
      merged = true;
      _vue2.default.locale(_vue2.default.config.lang, (0, _deepmerge2.default)(lang, _vue2.default.locale(_vue2.default.config.lang) || {}, { clone: true }));
    }
    return vuei18n.apply(this, arguments);
  }
};

var t = exports.t = function t(path, options) {
  var value = i18nHandler.apply(this, arguments);
  if (value !== null && value !== undefined) return value;

  var array = path.split('.');
  var current = lang;

  for (var i = 0, j = array.length; i < j; i++) {
    var property = array[i];
    value = current[property];
    if (i === j - 1) return format(value, options);
    if (!value) return '';
    current = value;
  }
  return '';
};

var use = exports.use = function use(l) {
  lang = l || lang;
};

var i18n = exports.i18n = function i18n(fn) {
  i18nHandler = fn || i18nHandler;
};

exports.default = { use: use, t: t, i18n: i18n };

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(826);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_li_vue__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_li_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_li_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_li_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_li_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_43aaf28a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_li_vue__ = __webpack_require__(1060);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_li_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_43aaf28a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_li_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(40);
var toLength = __webpack_require__(14);
var toAbsoluteIndex = __webpack_require__(76);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(46);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(47);
var defined = __webpack_require__(54);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(8);
var cof = __webpack_require__(46);
var MATCH = __webpack_require__(13)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(13)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(93);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(234);
var redefine = __webpack_require__(36);
var hide = __webpack_require__(35);
var fails = __webpack_require__(7);
var defined = __webpack_require__(54);
var wks = __webpack_require__(13);
var regexpExec = __webpack_require__(164);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(36);
var redefineAll = __webpack_require__(82);
var meta = __webpack_require__(69);
var forOf = __webpack_require__(81);
var anInstance = __webpack_require__(80);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var $iterDetect = __webpack_require__(121);
var setToStringTag = __webpack_require__(92);
var inheritIfRequired = __webpack_require__(150);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var hide = __webpack_require__(35);
var uid = __webpack_require__(74);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(68) || !__webpack_require__(7)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(4)[K];
});


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(27);
var ctx = __webpack_require__(45);
var forOf = __webpack_require__(81);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _popup = __webpack_require__(252);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopperJS = _vue2.default.prototype.$isServer ? function () {} : __webpack_require__(710);
var stop = function stop(e) {
  return e.stopPropagation();
};

/**
 * @param {HTMLElement} [reference=$refs.reference] - The reference element used to position the popper.
 * @param {HTMLElement} [popper=$refs.popper] - The HTML element used as popper, or a configuration used to generate the popper.
 * @param {String} [placement=button] - Placement of the popper accepted values: top(-start, -end), right(-start, -end), bottom(-start, -end), left(-start, -end)
 * @param {Number} [offset=0] - Amount of pixels the popper will be shifted (can be negative).
 * @param {Boolean} [visible=false] Visibility of the popup element.
 * @param {Boolean} [visible-arrow=false] Visibility of the arrow, no style.
 */
exports.default = {
  props: {
    transformOrigin: {
      type: [Boolean, String],
      default: true
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    boundariesPadding: {
      type: Number,
      default: 5
    },
    reference: {},
    popper: {},
    offset: {
      default: 0
    },
    value: Boolean,
    visibleArrow: Boolean,
    arrowOffset: {
      type: Number,
      default: 35
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    popperOptions: {
      type: Object,
      default: function _default() {
        return {
          gpuAcceleration: false
        };
      }
    }
  },

  data: function data() {
    return {
      showPopper: false,
      currentPlacement: ''
    };
  },


  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.showPopper = val;
        this.$emit('input', val);
      }
    },

    showPopper: function showPopper(val) {
      if (this.disabled) return;
      val ? this.updatePopper() : this.destroyPopper();
      this.$emit('input', val);
    }
  },

  methods: {
    createPopper: function createPopper() {
      var _this = this;

      if (this.$isServer) return;
      this.currentPlacement = this.currentPlacement || this.placement;
      if (!/^(top|bottom|left|right)(-start|-end)?$/g.test(this.currentPlacement)) {
        return;
      }

      var options = this.popperOptions;
      var popper = this.popperElm = this.popperElm || this.popper || this.$refs.popper;
      var reference = this.referenceElm = this.referenceElm || this.reference || this.$refs.reference;

      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
        reference = this.referenceElm = this.$slots.reference[0].elm;
      }

      if (!popper || !reference) return;
      if (this.visibleArrow) this.appendArrow(popper);
      if (this.appendToBody) document.body.appendChild(this.popperElm);
      if (this.popperJS && this.popperJS.destroy) {
        this.popperJS.destroy();
      }

      options.placement = this.currentPlacement;
      options.offset = this.offset;
      options.arrowOffset = this.arrowOffset;
      this.popperJS = new PopperJS(reference, popper, options);
      this.popperJS.onCreate(function (_) {
        _this.$emit('created', _this);
        _this.resetTransformOrigin();
        _this.$nextTick(_this.updatePopper);
      });
      if (typeof options.onUpdate === 'function') {
        this.popperJS.onUpdate(options.onUpdate);
      }
      this.popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
      this.popperElm.addEventListener('click', stop);
    },
    updatePopper: function updatePopper() {
      var popperJS = this.popperJS;
      if (popperJS) {
        popperJS.update();
        if (popperJS._popper) {
          popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
        }
      } else {
        this.createPopper();
      }
    },
    doDestroy: function doDestroy(forceDestroy) {
      /* istanbul ignore if */
      if (!this.popperJS || this.showPopper && !forceDestroy) return;
      this.popperJS.destroy();
      this.popperJS = null;
    },
    destroyPopper: function destroyPopper() {
      if (this.popperJS) {
        this.resetTransformOrigin();
      }
    },
    resetTransformOrigin: function resetTransformOrigin() {
      if (!this.transformOrigin) return;
      var placementMap = {
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left'
      };
      var placement = this.popperJS._popper.getAttribute('x-placement').split('-')[0];
      var origin = placementMap[placement];
      this.popperJS._popper.style.transformOrigin = typeof this.transformOrigin === 'string' ? this.transformOrigin : ['top', 'bottom'].indexOf(placement) > -1 ? 'center ' + origin : origin + ' center';
    },
    appendArrow: function appendArrow(element) {
      var hash = void 0;
      if (this.appended) {
        return;
      }

      this.appended = true;

      for (var item in element.attributes) {
        if (/^_v-/.test(element.attributes[item].name)) {
          hash = element.attributes[item].name;
          break;
        }
      }

      var arrow = document.createElement('div');

      if (hash) {
        arrow.setAttribute(hash, '');
      }
      arrow.setAttribute('x-arrow', '');
      arrow.className = 'popper__arrow';
      element.appendChild(arrow);
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.doDestroy(true);
    if (this.popperElm && this.popperElm.parentNode === document.body) {
      this.popperElm.removeEventListener('click', stop);
      document.body.removeChild(this.popperElm);
    }
  },


  // call destroy in keep-alive mode
  deactivated: function deactivated() {
    this.$options.beforeDestroy[0].call(this);
  }
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    var source = arguments[i] || {};
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        var value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
};

;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isDef = isDef;
exports.isKorean = isKorean;
function isDef(val) {
  return val !== undefined && val !== null;
}
function isKorean(text) {
  var reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
  return reg.test(text);
}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-undefined */

var throttle = __webpack_require__(174);

/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}  [atBegin]     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @return {Function} A new, debounced function.
 */
module.exports = function ( delay, atBegin, callback ) {
	return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(183);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 135 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 136 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(57);
var dPs = __webpack_require__(739);
var enumBugKeys = __webpack_require__(186);
var IE_PROTO = __webpack_require__(184)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(179)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(261).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(107);
var TAG = __webpack_require__(30)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loadManager_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loadManager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loadManager_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loadManager_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loadManager_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_02894c18_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_loadManager_vue__ = __webpack_require__(1181);
function injectStyle (ssrContext) {
  __webpack_require__(1180)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02894c18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loadManager_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_02894c18_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_loadManager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loadUsers_vue__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loadUsers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loadUsers_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loadUsers_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loadUsers_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_c94acbf2_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_loadUsers_vue__ = __webpack_require__(1214);
function injectStyle (ssrContext) {
  __webpack_require__(1213)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loadUsers_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_c94acbf2_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_loadUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 45);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(708);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(63);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(52);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(84);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(170);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(130);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(11);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(131);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(172);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(253);

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(254);

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(113);

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(711);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(173);

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(252);

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(133);

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(255);

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(175);

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(214);

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(132);

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(251);

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(713);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(176);

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(714);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(256);

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(174);

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(715);

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(177);

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(178);

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(716);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(257);

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(171);

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(717);

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(718);

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(719);

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(720);

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(721);

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(722);

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(723);

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(728);

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(729);

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(770);

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(771);

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(267);

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(772);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(46);


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&
var pagervue_type_template_id_7274f267_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "el-pager", on: { click: _vm.onPagerClick } },
    [
      _vm.pageCount > 0
        ? _c(
            "li",
            {
              staticClass: "number",
              class: { active: _vm.currentPage === 1, disabled: _vm.disabled }
            },
            [_vm._v("1")]
          )
        : _vm._e(),
      _vm.showPrevMore
        ? _c("li", {
            staticClass: "el-icon more btn-quickprev",
            class: [_vm.quickprevIconClass, { disabled: _vm.disabled }],
            on: {
              mouseenter: function($event) {
                _vm.onMouseenter("left")
              },
              mouseleave: function($event) {
                _vm.quickprevIconClass = "el-icon-more"
              }
            }
          })
        : _vm._e(),
      _vm._l(_vm.pagers, function(pager) {
        return _c(
          "li",
          {
            key: pager,
            staticClass: "number",
            class: { active: _vm.currentPage === pager, disabled: _vm.disabled }
          },
          [_vm._v(_vm._s(pager))]
        )
      }),
      _vm.showNextMore
        ? _c("li", {
            staticClass: "el-icon more btn-quicknext",
            class: [_vm.quicknextIconClass, { disabled: _vm.disabled }],
            on: {
              mouseenter: function($event) {
                _vm.onMouseenter("right")
              },
              mouseleave: function($event) {
                _vm.quicknextIconClass = "el-icon-more"
              }
            }
          })
        : _vm._e(),
      _vm.pageCount > 1
        ? _c(
            "li",
            {
              staticClass: "number",
              class: {
                active: _vm.currentPage === _vm.pageCount,
                disabled: _vm.disabled
              }
            },
            [_vm._v(_vm._s(_vm.pageCount))]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
pagervue_type_template_id_7274f267_render._withStripped = true


// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pagervue_type_script_lang_js_ = ({
  name: 'ElPager',

  props: {
    currentPage: Number,

    pageCount: Number,

    pagerCount: Number,

    disabled: Boolean
  },

  watch: {
    showPrevMore: function showPrevMore(val) {
      if (!val) this.quickprevIconClass = 'el-icon-more';
    },
    showNextMore: function showNextMore(val) {
      if (!val) this.quicknextIconClass = 'el-icon-more';
    }
  },

  methods: {
    onPagerClick: function onPagerClick(event) {
      var target = event.target;
      if (target.tagName === 'UL' || this.disabled) {
        return;
      }

      var newPage = Number(event.target.textContent);
      var pageCount = this.pageCount;
      var currentPage = this.currentPage;
      var pagerCountOffset = this.pagerCount - 2;

      if (target.className.indexOf('more') !== -1) {
        if (target.className.indexOf('quickprev') !== -1) {
          newPage = currentPage - pagerCountOffset;
        } else if (target.className.indexOf('quicknext') !== -1) {
          newPage = currentPage + pagerCountOffset;
        }
      }

      /* istanbul ignore if */
      if (!isNaN(newPage)) {
        if (newPage < 1) {
          newPage = 1;
        }

        if (newPage > pageCount) {
          newPage = pageCount;
        }
      }

      if (newPage !== currentPage) {
        this.$emit('change', newPage);
      }
    },
    onMouseenter: function onMouseenter(direction) {
      if (this.disabled) return;
      if (direction === 'left') {
        this.quickprevIconClass = 'el-icon-d-arrow-left';
      } else {
        this.quicknextIconClass = 'el-icon-d-arrow-right';
      }
    }
  },

  computed: {
    pagers: function pagers() {
      var pagerCount = this.pagerCount;
      var halfPagerCount = (pagerCount - 1) / 2;

      var currentPage = Number(this.currentPage);
      var pageCount = Number(this.pageCount);

      var showPrevMore = false;
      var showNextMore = false;

      if (pageCount > pagerCount) {
        if (currentPage > pagerCount - halfPagerCount) {
          showPrevMore = true;
        }

        if (currentPage < pageCount - halfPagerCount) {
          showNextMore = true;
        }
      }

      var array = [];

      if (showPrevMore && !showNextMore) {
        var startPage = pageCount - (pagerCount - 2);
        for (var i = startPage; i < pageCount; i++) {
          array.push(i);
        }
      } else if (!showPrevMore && showNextMore) {
        for (var _i = 2; _i < pagerCount; _i++) {
          array.push(_i);
        }
      } else if (showPrevMore && showNextMore) {
        var offset = Math.floor(pagerCount / 2) - 1;
        for (var _i2 = currentPage - offset; _i2 <= currentPage + offset; _i2++) {
          array.push(_i2);
        }
      } else {
        for (var _i3 = 2; _i3 < pageCount; _i3++) {
          array.push(_i3);
        }
      }

      this.showPrevMore = showPrevMore;
      this.showNextMore = showNextMore;

      return array;
    }
  },

  data: function data() {
    return {
      current: null,
      showPrevMore: false,
      showNextMore: false,
      quicknextIconClass: 'el-icon-more',
      quickprevIconClass: 'el-icon-more'
    };
  }
});
// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_pagervue_type_script_lang_js_ = (pagervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./packages/pagination/src/pager.vue





/* normalize component */

var component = normalizeComponent(
  src_pagervue_type_script_lang_js_,
  pagervue_type_template_id_7274f267_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pagination/src/pager.vue"
/* harmony default export */ var pager = (component.exports);
// EXTERNAL MODULE: external "element-ui/lib/select"
var select_ = __webpack_require__(36);
var select_default = /*#__PURE__*/__webpack_require__.n(select_);

// EXTERNAL MODULE: external "element-ui/lib/option"
var option_ = __webpack_require__(37);
var option_default = /*#__PURE__*/__webpack_require__.n(option_);

// EXTERNAL MODULE: external "element-ui/lib/input"
var input_ = __webpack_require__(8);
var input_default = /*#__PURE__*/__webpack_require__.n(input_);

// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
var locale_ = __webpack_require__(4);
var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);

// EXTERNAL MODULE: external "element-ui/lib/utils/util"
var util_ = __webpack_require__(2);

// CONCATENATED MODULE: ./packages/pagination/src/pagination.js







/* harmony default export */ var pagination = ({
  name: 'ElPagination',

  props: {
    pageSize: {
      type: Number,
      default: 10
    },

    small: Boolean,

    total: Number,

    pageCount: Number,

    pagerCount: {
      type: Number,
      validator: function validator(value) {
        return (value | 0) === value && value > 4 && value < 22 && value % 2 === 1;
      },

      default: 7
    },

    currentPage: {
      type: Number,
      default: 1
    },

    layout: {
      default: 'prev, pager, next, jumper, ->, total'
    },

    pageSizes: {
      type: Array,
      default: function _default() {
        return [10, 20, 30, 40, 50, 100];
      }
    },

    popperClass: String,

    prevText: String,

    nextText: String,

    background: Boolean,

    disabled: Boolean,

    hideOnSinglePage: Boolean
  },

  data: function data() {
    return {
      internalCurrentPage: 1,
      internalPageSize: 0,
      lastEmittedPage: -1,
      userChangePageSize: false
    };
  },
  render: function render(h) {
    var layout = this.layout;
    if (!layout) return null;
    if (this.hideOnSinglePage && (!this.internalPageCount || this.internalPageCount === 1)) return null;

    var template = h('div', { 'class': ['el-pagination', {
        'is-background': this.background,
        'el-pagination--small': this.small
      }] });
    var TEMPLATE_MAP = {
      prev: h('prev'),
      jumper: h('jumper'),
      pager: h('pager', {
        attrs: { currentPage: this.internalCurrentPage, pageCount: this.internalPageCount, pagerCount: this.pagerCount, disabled: this.disabled },
        on: {
          'change': this.handleCurrentChange
        }
      }),
      next: h('next'),
      sizes: h('sizes', {
        attrs: { pageSizes: this.pageSizes }
      }),
      slot: h('slot', [this.$slots.default ? this.$slots.default : '']),
      total: h('total')
    };
    var components = layout.split(',').map(function (item) {
      return item.trim();
    });
    var rightWrapper = h('div', { 'class': 'el-pagination__rightwrapper' });
    var haveRightWrapper = false;

    template.children = template.children || [];
    rightWrapper.children = rightWrapper.children || [];
    components.forEach(function (compo) {
      if (compo === '->') {
        haveRightWrapper = true;
        return;
      }

      if (!haveRightWrapper) {
        template.children.push(TEMPLATE_MAP[compo]);
      } else {
        rightWrapper.children.push(TEMPLATE_MAP[compo]);
      }
    });

    if (haveRightWrapper) {
      template.children.unshift(rightWrapper);
    }

    return template;
  },


  components: {
    Prev: {
      render: function render(h) {
        return h(
          'button',
          {
            attrs: {
              type: 'button',

              disabled: this.$parent.disabled || this.$parent.internalCurrentPage <= 1
            },
            'class': 'btn-prev', on: {
              'click': this.$parent.prev
            }
          },
          [this.$parent.prevText ? h('span', [this.$parent.prevText]) : h('i', { 'class': 'el-icon el-icon-arrow-left' })]
        );
      }
    },

    Next: {
      render: function render(h) {
        return h(
          'button',
          {
            attrs: {
              type: 'button',

              disabled: this.$parent.disabled || this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0
            },
            'class': 'btn-next', on: {
              'click': this.$parent.next
            }
          },
          [this.$parent.nextText ? h('span', [this.$parent.nextText]) : h('i', { 'class': 'el-icon el-icon-arrow-right' })]
        );
      }
    },

    Sizes: {
      mixins: [locale_default.a],

      props: {
        pageSizes: Array
      },

      watch: {
        pageSizes: {
          immediate: true,
          handler: function handler(newVal, oldVal) {
            if (Object(util_["valueEquals"])(newVal, oldVal)) return;
            if (Array.isArray(newVal)) {
              this.$parent.internalPageSize = newVal.indexOf(this.$parent.pageSize) > -1 ? this.$parent.pageSize : this.pageSizes[0];
            }
          }
        }
      },

      render: function render(h) {
        var _this = this;

        return h(
          'span',
          { 'class': 'el-pagination__sizes' },
          [h(
            'el-select',
            {
              attrs: {
                value: this.$parent.internalPageSize,
                popperClass: this.$parent.popperClass || '',
                size: 'mini',

                disabled: this.$parent.disabled },
              on: {
                'input': this.handleChange
              }
            },
            [this.pageSizes.map(function (item) {
              return h('el-option', {
                attrs: {
                  value: item,
                  label: item + _this.t('el.pagination.pagesize') }
              });
            })]
          )]
        );
      },


      components: {
        ElSelect: select_default.a,
        ElOption: option_default.a
      },

      methods: {
        handleChange: function handleChange(val) {
          if (val !== this.$parent.internalPageSize) {
            this.$parent.internalPageSize = val = parseInt(val, 10);
            this.$parent.userChangePageSize = true;
            this.$parent.$emit('update:pageSize', val);
            this.$parent.$emit('size-change', val);
          }
        }
      }
    },

    Jumper: {
      mixins: [locale_default.a],

      components: { ElInput: input_default.a },

      data: function data() {
        return {
          userInput: null
        };
      },


      watch: {
        '$parent.internalCurrentPage': function $parentInternalCurrentPage() {
          this.userInput = null;
        }
      },

      methods: {
        handleKeyup: function handleKeyup(_ref) {
          var keyCode = _ref.keyCode,
              target = _ref.target;

          // Chrome, Safari, Firefox triggers change event on Enter
          // Hack for IE: https://github.com/ElemeFE/element/issues/11710
          // Drop this method when we no longer supports IE
          if (keyCode === 13) {
            this.handleChange(target.value);
          }
        },
        handleInput: function handleInput(value) {
          this.userInput = value;
        },
        handleChange: function handleChange(value) {
          this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(value);
          this.$parent.emitChange();
          this.userInput = null;
        }
      },

      render: function render(h) {
        return h(
          'span',
          { 'class': 'el-pagination__jump' },
          [this.t('el.pagination.goto'), h('el-input', {
            'class': 'el-pagination__editor is-in-pagination',
            attrs: { min: 1,
              max: this.$parent.internalPageCount,
              value: this.userInput !== null ? this.userInput : this.$parent.internalCurrentPage,
              type: 'number',
              disabled: this.$parent.disabled
            },
            nativeOn: {
              'keyup': this.handleKeyup
            },
            on: {
              'input': this.handleInput,
              'change': this.handleChange
            }
          }), this.t('el.pagination.pageClassifier')]
        );
      }
    },

    Total: {
      mixins: [locale_default.a],

      render: function render(h) {
        return typeof this.$parent.total === 'number' ? h(
          'span',
          { 'class': 'el-pagination__total' },
          [this.t('el.pagination.total', { total: this.$parent.total })]
        ) : '';
      }
    },

    Pager: pager
  },

  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.internalCurrentPage = this.getValidCurrentPage(val);
      this.userChangePageSize = true;
      this.emitChange();
    },
    prev: function prev() {
      if (this.disabled) return;
      var newVal = this.internalCurrentPage - 1;
      this.internalCurrentPage = this.getValidCurrentPage(newVal);
      this.$emit('prev-click', this.internalCurrentPage);
      this.emitChange();
    },
    next: function next() {
      if (this.disabled) return;
      var newVal = this.internalCurrentPage + 1;
      this.internalCurrentPage = this.getValidCurrentPage(newVal);
      this.$emit('next-click', this.internalCurrentPage);
      this.emitChange();
    },
    getValidCurrentPage: function getValidCurrentPage(value) {
      value = parseInt(value, 10);

      var havePageCount = typeof this.internalPageCount === 'number';

      var resetValue = void 0;
      if (!havePageCount) {
        if (isNaN(value) || value < 1) resetValue = 1;
      } else {
        if (value < 1) {
          resetValue = 1;
        } else if (value > this.internalPageCount) {
          resetValue = this.internalPageCount;
        }
      }

      if (resetValue === undefined && isNaN(value)) {
        resetValue = 1;
      } else if (resetValue === 0) {
        resetValue = 1;
      }

      return resetValue === undefined ? value : resetValue;
    },
    emitChange: function emitChange() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.internalCurrentPage !== _this2.lastEmittedPage || _this2.userChangePageSize) {
          _this2.$emit('current-change', _this2.internalCurrentPage);
          _this2.lastEmittedPage = _this2.internalCurrentPage;
          _this2.userChangePageSize = false;
        }
      });
    }
  },

  computed: {
    internalPageCount: function internalPageCount() {
      if (typeof this.total === 'number') {
        return Math.max(1, Math.ceil(this.total / this.internalPageSize));
      } else if (typeof this.pageCount === 'number') {
        return Math.max(1, this.pageCount);
      }
      return null;
    }
  },

  watch: {
    currentPage: {
      immediate: true,
      handler: function handler(val) {
        this.internalCurrentPage = this.getValidCurrentPage(val);
      }
    },

    pageSize: {
      immediate: true,
      handler: function handler(val) {
        this.internalPageSize = isNaN(val) ? 10 : val;
      }
    },

    internalCurrentPage: {
      immediate: true,
      handler: function handler(newVal) {
        this.$emit('update:currentPage', newVal);
        this.lastEmittedPage = -1;
      }
    },

    internalPageCount: function internalPageCount(newVal) {
      /* istanbul ignore if */
      var oldPage = this.internalCurrentPage;
      if (newVal > 0 && oldPage === 0) {
        this.internalCurrentPage = 1;
      } else if (oldPage > newVal) {
        this.internalCurrentPage = newVal === 0 ? 1 : newVal;
        this.userChangePageSize && this.emitChange();
      }
      this.userChangePageSize = false;
    }
  }
});
// CONCATENATED MODULE: ./packages/pagination/index.js


/* istanbul ignore next */
pagination.install = function (Vue) {
  Vue.component(pagination.name, pagination);
};

/* harmony default export */ var packages_pagination = (pagination);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
var componentvue_type_template_id_60140e62_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "dialog-fade" },
      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          staticClass: "el-dialog__wrapper",
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.handleWrapperClick($event)
            }
          }
        },
        [
          _c(
            "div",
            {
              key: _vm.key,
              ref: "dialog",
              class: [
                "el-dialog",
                {
                  "is-fullscreen": _vm.fullscreen,
                  "el-dialog--center": _vm.center
                },
                _vm.customClass
              ],
              style: _vm.style,
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-label": _vm.title || "dialog"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-dialog__header" },
                [
                  _vm._t("title", [
                    _c("span", { staticClass: "el-dialog__title" }, [
                      _vm._v(_vm._s(_vm.title))
                    ])
                  ]),
                  _vm.showClose
                    ? _c(
                        "button",
                        {
                          staticClass: "el-dialog__headerbtn",
                          attrs: { type: "button", "aria-label": "Close" },
                          on: { click: _vm.handleClose }
                        },
                        [
                          _c("i", {
                            staticClass:
                              "el-dialog__close el-icon el-icon-close"
                          })
                        ]
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm.rendered
                ? _c(
                    "div",
                    { staticClass: "el-dialog__body" },
                    [_vm._t("default")],
                    2
                  )
                : _vm._e(),
              _vm.$slots.footer
                ? _c(
                    "div",
                    { staticClass: "el-dialog__footer" },
                    [_vm._t("footer")],
                    2
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ]
  )
}
var componentvue_type_template_id_60140e62_staticRenderFns = []
componentvue_type_template_id_60140e62_render._withStripped = true


// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=template&id=60140e62&

// EXTERNAL MODULE: external "element-ui/lib/utils/popup"
var popup_ = __webpack_require__(14);
var popup_default = /*#__PURE__*/__webpack_require__.n(popup_);

// EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
var migrating_ = __webpack_require__(9);
var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);

// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
var emitter_ = __webpack_require__(3);
var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var componentvue_type_script_lang_js_ = ({
  name: 'ElDialog',

  mixins: [popup_default.a, emitter_default.a, migrating_default.a],

  props: {
    title: {
      type: String,
      default: ''
    },

    modal: {
      type: Boolean,
      default: true
    },

    modalAppendToBody: {
      type: Boolean,
      default: true
    },

    appendToBody: {
      type: Boolean,
      default: false
    },

    lockScroll: {
      type: Boolean,
      default: true
    },

    closeOnClickModal: {
      type: Boolean,
      default: true
    },

    closeOnPressEscape: {
      type: Boolean,
      default: true
    },

    showClose: {
      type: Boolean,
      default: true
    },

    width: String,

    fullscreen: Boolean,

    customClass: {
      type: String,
      default: ''
    },

    top: {
      type: String,
      default: '15vh'
    },
    beforeClose: Function,
    center: {
      type: Boolean,
      default: false
    },

    destroyOnClose: Boolean
  },

  data: function data() {
    return {
      closed: false,
      key: 0
    };
  },


  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.closed = false;
        this.$emit('open');
        this.$el.addEventListener('scroll', this.updatePopper);
        this.$nextTick(function () {
          _this.$refs.dialog.scrollTop = 0;
        });
        if (this.appendToBody) {
          document.body.appendChild(this.$el);
        }
      } else {
        this.$el.removeEventListener('scroll', this.updatePopper);
        if (!this.closed) this.$emit('close');
        if (this.destroyOnClose) {
          this.$nextTick(function () {
            _this.key++;
          });
        }
      }
    }
  },

  computed: {
    style: function style() {
      var style = {};
      if (!this.fullscreen) {
        style.marginTop = this.top;
        if (this.width) {
          style.width = this.width;
        }
      }
      return style;
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'size': 'size is removed.'
        }
      };
    },
    handleWrapperClick: function handleWrapperClick() {
      if (!this.closeOnClickModal) return;
      this.handleClose();
    },
    handleClose: function handleClose() {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide);
      } else {
        this.hide();
      }
    },
    hide: function hide(cancel) {
      if (cancel !== false) {
        this.$emit('update:visible', false);
        this.$emit('close');
        this.closed = true;
      }
    },
    updatePopper: function updatePopper() {
      this.broadcast('ElSelectDropdown', 'updatePopper');
      this.broadcast('ElDropdownMenu', 'updatePopper');
    },
    afterEnter: function afterEnter() {
      this.$emit('opened');
    },
    afterLeave: function afterLeave() {
      this.$emit('closed');
    }
  },

  mounted: function mounted() {
    if (this.visible) {
      this.rendered = true;
      this.open();
      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  },
  destroyed: function destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
});
// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_componentvue_type_script_lang_js_ = (componentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/dialog/src/component.vue





/* normalize component */

var component_component = normalizeComponent(
  src_componentvue_type_script_lang_js_,
  componentvue_type_template_id_60140e62_render,
  componentvue_type_template_id_60140e62_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var component_api; }
component_component.options.__file = "packages/dialog/src/component.vue"
/* harmony default export */ var src_component = (component_component.exports);
// CONCATENATED MODULE: ./packages/dialog/index.js


/* istanbul ignore next */
src_component.install = function (Vue) {
  Vue.component(src_component.name, src_component);
};

/* harmony default export */ var dialog = (src_component);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&
var autocompletevue_type_template_id_152f2ee6_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.close,
          expression: "close"
        }
      ],
      staticClass: "el-autocomplete",
      attrs: {
        "aria-haspopup": "listbox",
        role: "combobox",
        "aria-expanded": _vm.suggestionVisible,
        "aria-owns": _vm.id
      }
    },
    [
      _c(
        "el-input",
        _vm._b(
          {
            ref: "input",
            on: {
              input: _vm.handleInput,
              change: _vm.handleChange,
              focus: _vm.handleFocus,
              blur: _vm.handleBlur,
              clear: _vm.handleClear
            },
            nativeOn: {
              keydown: [
                function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp"
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  _vm.highlight(_vm.highlightedIndex - 1)
                },
                function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown"
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  _vm.highlight(_vm.highlightedIndex + 1)
                },
                function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleKeyEnter($event)
                },
                function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                  ) {
                    return null
                  }
                  return _vm.close($event)
                }
              ]
            }
          },
          "el-input",
          [_vm.$props, _vm.$attrs],
          false
        ),
        [
          _vm.$slots.prepend
            ? _c("template", { slot: "prepend" }, [_vm._t("prepend")], 2)
            : _vm._e(),
          _vm.$slots.append
            ? _c("template", { slot: "append" }, [_vm._t("append")], 2)
            : _vm._e(),
          _vm.$slots.prefix
            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
            : _vm._e(),
          _vm.$slots.suffix
            ? _c("template", { slot: "suffix" }, [_vm._t("suffix")], 2)
            : _vm._e()
        ],
        2
      ),
      _c(
        "el-autocomplete-suggestions",
        {
          ref: "suggestions",
          class: [_vm.popperClass ? _vm.popperClass : ""],
          attrs: {
            "visible-arrow": "",
            "popper-options": _vm.popperOptions,
            "append-to-body": _vm.popperAppendToBody,
            placement: _vm.placement,
            id: _vm.id
          }
        },
        _vm._l(_vm.suggestions, function(item, index) {
          return _c(
            "li",
            {
              key: index,
              class: { highlighted: _vm.highlightedIndex === index },
              attrs: {
                id: _vm.id + "-item-" + index,
                role: "option",
                "aria-selected": _vm.highlightedIndex === index
              },
              on: {
                click: function($event) {
                  _vm.select(item)
                }
              }
            },
            [
              _vm._t(
                "default",
                [
                  _vm._v("\n        " + _vm._s(item[_vm.valueKey]) + "\n      ")
                ],
                { item: item }
              )
            ],
            2
          )
        }),
        0
      )
    ],
    1
  )
}
var autocompletevue_type_template_id_152f2ee6_staticRenderFns = []
autocompletevue_type_template_id_152f2ee6_render._withStripped = true


// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&

// EXTERNAL MODULE: external "throttle-debounce/debounce"
var debounce_ = __webpack_require__(15);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

// EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
var clickoutside_ = __webpack_require__(10);
var clickoutside_default = /*#__PURE__*/__webpack_require__.n(clickoutside_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&
var autocomplete_suggestionsvue_type_template_id_cd10dcf0_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showPopper,
              expression: "showPopper"
            }
          ],
          staticClass: "el-autocomplete-suggestion el-popper",
          class: {
            "is-loading": !_vm.parent.hideLoading && _vm.parent.loading
          },
          style: { width: _vm.dropdownWidth },
          attrs: { role: "region" }
        },
        [
          _c(
            "el-scrollbar",
            {
              attrs: {
                tag: "ul",
                "wrap-class": "el-autocomplete-suggestion__wrap",
                "view-class": "el-autocomplete-suggestion__list"
              }
            },
            [
              !_vm.parent.hideLoading && _vm.parent.loading
                ? _c("li", [_c("i", { staticClass: "el-icon-loading" })])
                : _vm._t("default")
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns = []
autocomplete_suggestionsvue_type_template_id_cd10dcf0_render._withStripped = true


// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&

// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
var vue_popper_ = __webpack_require__(5);
var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);

// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
var scrollbar_ = __webpack_require__(17);
var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var autocomplete_suggestionsvue_type_script_lang_js_ = ({
  components: { ElScrollbar: scrollbar_default.a },
  mixins: [vue_popper_default.a, emitter_default.a],

  componentName: 'ElAutocompleteSuggestions',

  data: function data() {
    return {
      parent: this.$parent,
      dropdownWidth: ''
    };
  },


  props: {
    options: {
      default: function _default() {
        return {
          gpuAcceleration: false
        };
      }
    },
    id: String
  },

  methods: {
    select: function select(item) {
      this.dispatch('ElAutocomplete', 'item-click', item);
    }
  },

  updated: function updated() {
    var _this = this;

    this.$nextTick(function (_) {
      _this.popperJS && _this.updatePopper();
    });
  },
  mounted: function mounted() {
    this.$parent.popperElm = this.popperElm = this.$el;
    this.referenceElm = this.$parent.$refs.input.$refs.input || this.$parent.$refs.input.$refs.textarea;
    this.referenceList = this.$el.querySelector('.el-autocomplete-suggestion__list');
    this.referenceList.setAttribute('role', 'listbox');
    this.referenceList.setAttribute('id', this.id);
  },
  created: function created() {
    var _this2 = this;

    this.$on('visible', function (val, inputWidth) {
      _this2.dropdownWidth = inputWidth + 'px';
      _this2.showPopper = val;
    });
  }
});
// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_autocomplete_suggestionsvue_type_script_lang_js_ = (autocomplete_suggestionsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue





/* normalize component */

var autocomplete_suggestions_component = normalizeComponent(
  src_autocomplete_suggestionsvue_type_script_lang_js_,
  autocomplete_suggestionsvue_type_template_id_cd10dcf0_render,
  autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var autocomplete_suggestions_api; }
autocomplete_suggestions_component.options.__file = "packages/autocomplete/src/autocomplete-suggestions.vue"
/* harmony default export */ var autocomplete_suggestions = (autocomplete_suggestions_component.exports);
// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
var focus_ = __webpack_require__(22);
var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var autocompletevue_type_script_lang_js_ = ({
  name: 'ElAutocomplete',

  mixins: [emitter_default.a, focus_default()('input'), migrating_default.a],

  inheritAttrs: false,

  componentName: 'ElAutocomplete',

  components: {
    ElInput: input_default.a,
    ElAutocompleteSuggestions: autocomplete_suggestions
  },

  directives: { Clickoutside: clickoutside_default.a },

  props: {
    valueKey: {
      type: String,
      default: 'value'
    },
    popperClass: String,
    popperOptions: Object,
    placeholder: String,
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    name: String,
    size: String,
    value: String,
    maxlength: Number,
    minlength: Number,
    autofocus: Boolean,
    fetchSuggestions: Function,
    triggerOnFocus: {
      type: Boolean,
      default: true
    },
    customItem: String,
    selectWhenUnmatched: {
      type: Boolean,
      default: false
    },
    prefixIcon: String,
    suffixIcon: String,
    label: String,
    debounce: {
      type: Number,
      default: 300
    },
    placement: {
      type: String,
      default: 'bottom-start'
    },
    hideLoading: Boolean,
    popperAppendToBody: {
      type: Boolean,
      default: true
    },
    highlightFirstItem: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      activated: false,
      suggestions: [],
      loading: false,
      highlightedIndex: -1,
      suggestionDisabled: false
    };
  },

  computed: {
    suggestionVisible: function suggestionVisible() {
      var suggestions = this.suggestions;
      var isValidData = Array.isArray(suggestions) && suggestions.length > 0;
      return (isValidData || this.loading) && this.activated;
    },
    id: function id() {
      return 'el-autocomplete-' + Object(util_["generateId"])();
    }
  },
  watch: {
    suggestionVisible: function suggestionVisible(val) {
      var $input = this.getInput();
      if ($input) {
        this.broadcast('ElAutocompleteSuggestions', 'visible', [val, $input.offsetWidth]);
      }
    }
  },
  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'custom-item': 'custom-item is removed, use scoped slot instead.',
          'props': 'props is removed, use value-key instead.'
        }
      };
    },
    getData: function getData(queryString) {
      var _this = this;

      if (this.suggestionDisabled) {
        return;
      }
      this.loading = true;
      this.fetchSuggestions(queryString, function (suggestions) {
        _this.loading = false;
        if (_this.suggestionDisabled) {
          return;
        }
        if (Array.isArray(suggestions)) {
          _this.suggestions = suggestions;
          _this.highlightedIndex = _this.highlightFirstItem ? 0 : -1;
        } else {
          console.error('[Element Error][Autocomplete]autocomplete suggestions must be an array');
        }
      });
    },
    handleInput: function handleInput(value) {
      this.$emit('input', value);
      this.suggestionDisabled = false;
      if (!this.triggerOnFocus && !value) {
        this.suggestionDisabled = true;
        this.suggestions = [];
        return;
      }
      this.debouncedGetData(value);
    },
    handleChange: function handleChange(event) {
      this.$emit('change', event.target.value);
    },
    handleFocus: function handleFocus(event) {
      this.activated = true;
      this.$emit('focus', event);
      if (this.triggerOnFocus) {
        this.debouncedGetData(this.value);
      }
    },
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
    },
    handleClear: function handleClear() {
      this.activated = false;
      this.$emit('clear');
    },
    close: function close(e) {
      this.activated = false;
    },
    handleKeyEnter: function handleKeyEnter(e) {
      var _this2 = this;

      if (this.suggestionVisible && this.highlightedIndex >= 0 && this.highlightedIndex < this.suggestions.length) {
        e.preventDefault();
        this.select(this.suggestions[this.highlightedIndex]);
      } else if (this.selectWhenUnmatched) {
        this.$emit('select', { value: this.value });
        this.$nextTick(function (_) {
          _this2.suggestions = [];
          _this2.highlightedIndex = -1;
        });
      }
    },
    select: function select(item) {
      var _this3 = this;

      this.$emit('input', item[this.valueKey]);
      this.$emit('select', item);
      this.$nextTick(function (_) {
        _this3.suggestions = [];
        _this3.highlightedIndex = -1;
      });
    },
    highlight: function highlight(index) {
      if (!this.suggestionVisible || this.loading) {
        return;
      }
      if (index < 0) {
        this.highlightedIndex = -1;
        return;
      }
      if (index >= this.suggestions.length) {
        index = this.suggestions.length - 1;
      }
      var suggestion = this.$refs.suggestions.$el.querySelector('.el-autocomplete-suggestion__wrap');
      var suggestionList = suggestion.querySelectorAll('.el-autocomplete-suggestion__list li');

      var highlightItem = suggestionList[index];
      var scrollTop = suggestion.scrollTop;
      var offsetTop = highlightItem.offsetTop;

      if (offsetTop + highlightItem.scrollHeight > scrollTop + suggestion.clientHeight) {
        suggestion.scrollTop += highlightItem.scrollHeight;
      }
      if (offsetTop < scrollTop) {
        suggestion.scrollTop -= highlightItem.scrollHeight;
      }
      this.highlightedIndex = index;
      var $input = this.getInput();
      $input.setAttribute('aria-activedescendant', this.id + '-item-' + this.highlightedIndex);
    },
    getInput: function getInput() {
      return this.$refs.input.getInput();
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.debouncedGetData = debounce_default()(this.debounce, this.getData);
    this.$on('item-click', function (item) {
      _this4.select(item);
    });
    var $input = this.getInput();
    $input.setAttribute('role', 'textbox');
    $input.setAttribute('aria-autocomplete', 'list');
    $input.setAttribute('aria-controls', 'id');
    $input.setAttribute('aria-activedescendant', this.id + '-item-' + this.highlightedIndex);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.suggestions.$destroy();
  }
});
// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_autocompletevue_type_script_lang_js_ = (autocompletevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue





/* normalize component */

var autocomplete_component = normalizeComponent(
  src_autocompletevue_type_script_lang_js_,
  autocompletevue_type_template_id_152f2ee6_render,
  autocompletevue_type_template_id_152f2ee6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var autocomplete_api; }
autocomplete_component.options.__file = "packages/autocomplete/src/autocomplete.vue"
/* harmony default export */ var autocomplete = (autocomplete_component.exports);
// CONCATENATED MODULE: ./packages/autocomplete/index.js


/* istanbul ignore next */
autocomplete.install = function (Vue) {
  Vue.component(autocomplete.name, autocomplete);
};

/* harmony default export */ var packages_autocomplete = (autocomplete);
// EXTERNAL MODULE: external "element-ui/lib/button"
var button_ = __webpack_require__(12);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: external "element-ui/lib/button-group"
var button_group_ = __webpack_require__(29);
var button_group_default = /*#__PURE__*/__webpack_require__.n(button_group_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&








/* harmony default export */ var dropdownvue_type_script_lang_js_ = ({
  name: 'ElDropdown',

  componentName: 'ElDropdown',

  mixins: [emitter_default.a, migrating_default.a],

  directives: { Clickoutside: clickoutside_default.a },

  components: {
    ElButton: button_default.a,
    ElButtonGroup: button_group_default.a
  },

  provide: function provide() {
    return {
      dropdown: this
    };
  },


  props: {
    trigger: {
      type: String,
      default: 'hover'
    },
    type: String,
    size: {
      type: String,
      default: ''
    },
    splitButton: Boolean,
    hideOnClick: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: 'bottom-end'
    },
    visibleArrow: {
      default: true
    },
    showTimeout: {
      type: Number,
      default: 250
    },
    hideTimeout: {
      type: Number,
      default: 150
    },
    tabindex: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      timeout: null,
      visible: false,
      triggerElm: null,
      menuItems: null,
      menuItemsArray: null,
      dropdownElm: null,
      focusing: false,
      listId: 'dropdown-menu-' + Object(util_["generateId"])()
    };
  },


  computed: {
    dropdownSize: function dropdownSize() {
      return this.size || (this.$ELEMENT || {}).size;
    }
  },

  mounted: function mounted() {
    this.$on('menu-item-click', this.handleMenuItemClick);
  },


  watch: {
    visible: function visible(val) {
      this.broadcast('ElDropdownMenu', 'visible', val);
      this.$emit('visible-change', val);
    },
    focusing: function focusing(val) {
      var selfDefine = this.$el.querySelector('.el-dropdown-selfdefine');
      if (selfDefine) {
        // 自定义
        if (val) {
          selfDefine.className += ' focusing';
        } else {
          selfDefine.className = selfDefine.className.replace('focusing', '');
        }
      }
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'menu-align': 'menu-align is renamed to placement.'
        }
      };
    },
    show: function show() {
      var _this = this;

      if (this.triggerElm.disabled) return;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this.visible = true;
      }, this.trigger === 'click' ? 0 : this.showTimeout);
    },
    hide: function hide() {
      var _this2 = this;

      if (this.triggerElm.disabled) return;
      this.removeTabindex();
      if (this.tabindex >= 0) {
        this.resetTabindex(this.triggerElm);
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this2.visible = false;
      }, this.trigger === 'click' ? 0 : this.hideTimeout);
    },
    handleClick: function handleClick() {
      if (this.triggerElm.disabled) return;
      if (this.visible) {
        this.hide();
      } else {
        this.show();
      }
    },
    handleTriggerKeyDown: function handleTriggerKeyDown(ev) {
      var keyCode = ev.keyCode;
      if ([38, 40].indexOf(keyCode) > -1) {
        // up/down
        this.removeTabindex();
        this.resetTabindex(this.menuItems[0]);
        this.menuItems[0].focus();
        ev.preventDefault();
        ev.stopPropagation();
      } else if (keyCode === 13) {
        // space enter选中
        this.handleClick();
      } else if ([9, 27].indexOf(keyCode) > -1) {
        // tab || esc
        this.hide();
      }
    },
    handleItemKeyDown: function handleItemKeyDown(ev) {
      var keyCode = ev.keyCode;
      var target = ev.target;
      var currentIndex = this.menuItemsArray.indexOf(target);
      var max = this.menuItemsArray.length - 1;
      var nextIndex = void 0;
      if ([38, 40].indexOf(keyCode) > -1) {
        // up/down
        if (keyCode === 38) {
          // up
          nextIndex = currentIndex !== 0 ? currentIndex - 1 : 0;
        } else {
          // down
          nextIndex = currentIndex < max ? currentIndex + 1 : max;
        }
        this.removeTabindex();
        this.resetTabindex(this.menuItems[nextIndex]);
        this.menuItems[nextIndex].focus();
        ev.preventDefault();
        ev.stopPropagation();
      } else if (keyCode === 13) {
        // enter选中
        this.triggerElmFocus();
        target.click();
        if (this.hideOnClick) {
          // click关闭
          this.visible = false;
        }
      } else if ([9, 27].indexOf(keyCode) > -1) {
        // tab // esc
        this.hide();
        this.triggerElmFocus();
      }
    },
    resetTabindex: function resetTabindex(ele) {
      // 下次tab时组件聚焦元素
      this.removeTabindex();
      ele.setAttribute('tabindex', '0'); // 下次期望的聚焦元素
    },
    removeTabindex: function removeTabindex() {
      this.triggerElm.setAttribute('tabindex', '-1');
      this.menuItemsArray.forEach(function (item) {
        item.setAttribute('tabindex', '-1');
      });
    },
    initAria: function initAria() {
      this.dropdownElm.setAttribute('id', this.listId);
      this.triggerElm.setAttribute('aria-haspopup', 'list');
      this.triggerElm.setAttribute('aria-controls', this.listId);

      if (!this.splitButton) {
        // 自定义
        this.triggerElm.setAttribute('role', 'button');
        this.triggerElm.setAttribute('tabindex', this.tabindex);
        this.triggerElm.setAttribute('class', (this.triggerElm.getAttribute('class') || '') + ' el-dropdown-selfdefine'); // 控制
      }
    },
    initEvent: function initEvent() {
      var _this3 = this;

      var trigger = this.trigger,
          show = this.show,
          hide = this.hide,
          handleClick = this.handleClick,
          splitButton = this.splitButton,
          handleTriggerKeyDown = this.handleTriggerKeyDown,
          handleItemKeyDown = this.handleItemKeyDown;

      this.triggerElm = splitButton ? this.$refs.trigger.$el : this.$slots.default[0].elm;

      var dropdownElm = this.dropdownElm;

      this.triggerElm.addEventListener('keydown', handleTriggerKeyDown); // triggerElm keydown
      dropdownElm.addEventListener('keydown', handleItemKeyDown, true); // item keydown
      // 控制自定义元素的样式
      if (!splitButton) {
        this.triggerElm.addEventListener('focus', function () {
          _this3.focusing = true;
        });
        this.triggerElm.addEventListener('blur', function () {
          _this3.focusing = false;
        });
        this.triggerElm.addEventListener('click', function () {
          _this3.focusing = false;
        });
      }
      if (trigger === 'hover') {
        this.triggerElm.addEventListener('mouseenter', show);
        this.triggerElm.addEventListener('mouseleave', hide);
        dropdownElm.addEventListener('mouseenter', show);
        dropdownElm.addEventListener('mouseleave', hide);
      } else if (trigger === 'click') {
        this.triggerElm.addEventListener('click', handleClick);
      }
    },
    handleMenuItemClick: function handleMenuItemClick(command, instance) {
      if (this.hideOnClick) {
        this.visible = false;
      }
      this.$emit('command', command, instance);
    },
    triggerElmFocus: function triggerElmFocus() {
      this.triggerElm.focus && this.triggerElm.focus();
    },
    initDomOperation: function initDomOperation() {
      this.dropdownElm = this.popperElm;
      this.menuItems = this.dropdownElm.querySelectorAll("[tabindex='-1']");
      this.menuItemsArray = [].slice.call(this.menuItems);

      this.initEvent();
      this.initAria();
    }
  },

  render: function render(h) {
    var _this4 = this;

    var hide = this.hide,
        splitButton = this.splitButton,
        type = this.type,
        dropdownSize = this.dropdownSize;


    var handleMainButtonClick = function handleMainButtonClick(event) {
      _this4.$emit('click', event);
      hide();
    };

    var triggerElm = !splitButton ? this.$slots.default : h('el-button-group', [h(
      'el-button',
      {
        attrs: { type: type, size: dropdownSize },
        nativeOn: {
          'click': handleMainButtonClick
        }
      },
      [this.$slots.default]
    ), h(
      'el-button',
      { ref: 'trigger', attrs: { type: type, size: dropdownSize },
        'class': 'el-dropdown__caret-button' },
      [h('i', { 'class': 'el-dropdown__icon el-icon-arrow-down' })]
    )]);

    return h(
      'div',
      { 'class': 'el-dropdown', directives: [{
          name: 'clickoutside',
          value: hide
        }]
      },
      [triggerElm, this.$slots.dropdown]
    );
  }
});
// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_dropdownvue_type_script_lang_js_ = (dropdownvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue
var dropdown_render, dropdown_staticRenderFns




/* normalize component */

var dropdown_component = normalizeComponent(
  src_dropdownvue_type_script_lang_js_,
  dropdown_render,
  dropdown_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var dropdown_api; }
dropdown_component.options.__file = "packages/dropdown/src/dropdown.vue"
/* harmony default export */ var dropdown = (dropdown_component.exports);
// CONCATENATED MODULE: ./packages/dropdown/index.js


/* istanbul ignore next */
dropdown.install = function (Vue) {
  Vue.component(dropdown.name, dropdown);
};

/* harmony default export */ var packages_dropdown = (dropdown);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&
var dropdown_menuvue_type_template_id_0da6b714_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
    [
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showPopper,
              expression: "showPopper"
            }
          ],
          staticClass: "el-dropdown-menu el-popper",
          class: [_vm.size && "el-dropdown-menu--" + _vm.size]
        },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var dropdown_menuvue_type_template_id_0da6b714_staticRenderFns = []
dropdown_menuvue_type_template_id_0da6b714_render._withStripped = true


// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//



/* harmony default export */ var dropdown_menuvue_type_script_lang_js_ = ({
  name: 'ElDropdownMenu',

  componentName: 'ElDropdownMenu',

  mixins: [vue_popper_default.a],

  props: {
    visibleArrow: {
      type: Boolean,
      default: true
    },
    arrowOffset: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      size: this.dropdown.dropdownSize
    };
  },


  inject: ['dropdown'],

  created: function created() {
    var _this = this;

    this.$on('updatePopper', function () {
      if (_this.showPopper) _this.updatePopper();
    });
    this.$on('visible', function (val) {
      _this.showPopper = val;
    });
  },
  mounted: function mounted() {
    this.dropdown.popperElm = this.popperElm = this.$el;
    this.referenceElm = this.dropdown.$el;
    // compatible with 2.6 new v-slot syntax
    // issue link https://github.com/ElemeFE/element/issues/14345
    this.dropdown.initDomOperation();
  },


  watch: {
    'dropdown.placement': {
      immediate: true,
      handler: function handler(val) {
        this.currentPlacement = val;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_dropdown_menuvue_type_script_lang_js_ = (dropdown_menuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue





/* normalize component */

var dropdown_menu_component = normalizeComponent(
  src_dropdown_menuvue_type_script_lang_js_,
  dropdown_menuvue_type_template_id_0da6b714_render,
  dropdown_menuvue_type_template_id_0da6b714_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var dropdown_menu_api; }
dropdown_menu_component.options.__file = "packages/dropdown/src/dropdown-menu.vue"
/* harmony default export */ var dropdown_menu = (dropdown_menu_component.exports);
// CONCATENATED MODULE: ./packages/dropdown-menu/index.js


/* istanbul ignore next */
dropdown_menu.install = function (Vue) {
  Vue.component(dropdown_menu.name, dropdown_menu);
};

/* harmony default export */ var packages_dropdown_menu = (dropdown_menu);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&
var dropdown_itemvue_type_template_id_6359102a_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "el-dropdown-menu__item",
      class: {
        "is-disabled": _vm.disabled,
        "el-dropdown-menu__item--divided": _vm.divided
      },
      attrs: {
        "aria-disabled": _vm.disabled,
        tabindex: _vm.disabled ? null : -1
      },
      on: { click: _vm.handleClick }
    },
    [_vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(), _vm._t("default")],
    2
  )
}
var dropdown_itemvue_type_template_id_6359102a_staticRenderFns = []
dropdown_itemvue_type_template_id_6359102a_render._withStripped = true


// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var dropdown_itemvue_type_script_lang_js_ = ({
  name: 'ElDropdownItem',

  mixins: [emitter_default.a],

  props: {
    command: {},
    disabled: Boolean,
    divided: Boolean,
    icon: String
  },

  methods: {
    handleClick: function handleClick(e) {
      this.dispatch('ElDropdown', 'menu-item-click', [this.command, this]);
    }
  }
});
// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_dropdown_itemvue_type_script_lang_js_ = (dropdown_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue





/* normalize component */

var dropdown_item_component = normalizeComponent(
  src_dropdown_itemvue_type_script_lang_js_,
  dropdown_itemvue_type_template_id_6359102a_render,
  dropdown_itemvue_type_template_id_6359102a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var dropdown_item_api; }
dropdown_item_component.options.__file = "packages/dropdown/src/dropdown-item.vue"
/* harmony default export */ var dropdown_item = (dropdown_item_component.exports);
// CONCATENATED MODULE: ./packages/dropdown-item/index.js


/* istanbul ignore next */
dropdown_item.install = function (Vue) {
  Vue.component(dropdown_item.name, dropdown_item);
};

/* harmony default export */ var packages_dropdown_item = (dropdown_item);
// CONCATENATED MODULE: ./src/utils/aria-utils.js
var aria = aria || {};

aria.Utils = aria.Utils || {};

/**
 * @desc Set focus on descendant nodes until the first focusable element is
 *       found.
 * @param element
 *          DOM node for which to find the first focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */
aria.Utils.focusFirstDescendant = function (element) {
  for (var i = 0; i < element.childNodes.length; i++) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Find the last descendant node that is focusable.
 * @param element
 *          DOM node for which to find the last focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */

aria.Utils.focusLastDescendant = function (element) {
  for (var i = element.childNodes.length - 1; i >= 0; i--) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Set Attempt to set focus on the current node.
 * @param element
 *          The node to attempt to focus on.
 * @returns
 *  true if element is focused.
 */
aria.Utils.attemptFocus = function (element) {
  if (!aria.Utils.isFocusable(element)) {
    return false;
  }
  aria.Utils.IgnoreUtilFocusChanges = true;
  try {
    element.focus();
  } catch (e) {}
  aria.Utils.IgnoreUtilFocusChanges = false;
  return document.activeElement === element;
};

aria.Utils.isFocusable = function (element) {
  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
    return true;
  }

  if (element.disabled) {
    return false;
  }

  switch (element.nodeName) {
    case 'A':
      return !!element.href && element.rel !== 'ignore';
    case 'INPUT':
      return element.type !== 'hidden' && element.type !== 'file';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
};

/**
 * 触发一个事件
 * mouseenter, mouseleave, mouseover, keyup, change, click 等
 * @param  {Element} elm
 * @param  {String} name
 * @param  {*} opts
 */
aria.Utils.triggerEvent = function (elm, name) {
  var eventName = void 0;

  if (/^mouse|click/.test(name)) {
    eventName = 'MouseEvents';
  } else if (/^key/.test(name)) {
    eventName = 'KeyboardEvent';
  } else {
    eventName = 'HTMLEvents';
  }
  var evt = document.createEvent(eventName);

  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    opts[_key - 2] = arguments[_key];
  }

  evt.initEvent.apply(evt, [name].concat(opts));
  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);

  return elm;
};

aria.Utils.keys = {
  tab: 9,
  enter: 13,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  esc: 27
};

/* harmony default export */ var aria_utils = (aria.Utils);
// CONCATENATED MODULE: ./src/utils/menu/aria-submenu.js


var SubMenu = function SubMenu(parent, domNode) {
  this.domNode = domNode;
  this.parent = parent;
  this.subMenuItems = [];
  this.subIndex = 0;
  this.init();
};

SubMenu.prototype.init = function () {
  this.subMenuItems = this.domNode.querySelectorAll('li');
  this.addListeners();
};

SubMenu.prototype.gotoSubIndex = function (idx) {
  if (idx === this.subMenuItems.length) {
    idx = 0;
  } else if (idx < 0) {
    idx = this.subMenuItems.length - 1;
  }
  this.subMenuItems[idx].focus();
  this.subIndex = idx;
};

SubMenu.prototype.addListeners = function () {
  var _this = this;

  var keys = aria_utils.keys;
  var parentNode = this.parent.domNode;
  Array.prototype.forEach.call(this.subMenuItems, function (el) {
    el.addEventListener('keydown', function (event) {
      var prevDef = false;
      switch (event.keyCode) {
        case keys.down:
          _this.gotoSubIndex(_this.subIndex + 1);
          prevDef = true;
          break;
        case keys.up:
          _this.gotoSubIndex(_this.subIndex - 1);
          prevDef = true;
          break;
        case keys.tab:
          aria_utils.triggerEvent(parentNode, 'mouseleave');
          break;
        case keys.enter:
        case keys.space:
          prevDef = true;
          event.currentTarget.click();
          break;
      }
      if (prevDef) {
        event.preventDefault();
        event.stopPropagation();
      }
      return false;
    });
  });
};

/* harmony default export */ var aria_submenu = (SubMenu);
// CONCATENATED MODULE: ./src/utils/menu/aria-menuitem.js



var MenuItem = function MenuItem(domNode) {
  this.domNode = domNode;
  this.submenu = null;
  this.init();
};

MenuItem.prototype.init = function () {
  this.domNode.setAttribute('tabindex', '0');
  var menuChild = this.domNode.querySelector('.el-menu');
  if (menuChild) {
    this.submenu = new aria_submenu(this, menuChild);
  }
  this.addListeners();
};

MenuItem.prototype.addListeners = function () {
  var _this = this;

  var keys = aria_utils.keys;
  this.domNode.addEventListener('keydown', function (event) {
    var prevDef = false;
    switch (event.keyCode) {
      case keys.down:
        aria_utils.triggerEvent(event.currentTarget, 'mouseenter');
        _this.submenu && _this.submenu.gotoSubIndex(0);
        prevDef = true;
        break;
      case keys.up:
        aria_utils.triggerEvent(event.currentTarget, 'mouseenter');
        _this.submenu && _this.submenu.gotoSubIndex(_this.submenu.subMenuItems.length - 1);
        prevDef = true;
        break;
      case keys.tab:
        aria_utils.triggerEvent(event.currentTarget, 'mouseleave');
        break;
      case keys.enter:
      case keys.space:
        prevDef = true;
        event.currentTarget.click();
        break;
    }
    if (prevDef) {
      event.preventDefault();
    }
  });
};

/* harmony default export */ var aria_menuitem = (MenuItem);
// CONCATENATED MODULE: ./src/utils/menu/aria-menubar.js


var Menu = function Menu(domNode) {
  this.domNode = domNode;
  this.init();
};

Menu.prototype.init = function () {
  var menuChildren = this.domNode.childNodes;
  [].filter.call(menuChildren, function (child) {
    return child.nodeType === 1;
  }).forEach(function (child) {
    new aria_menuitem(child); // eslint-disable-line
  });
};
/* harmony default export */ var aria_menubar = (Menu);
// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
var dom_ = __webpack_require__(1);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu.vue?vue&type=script&lang=js&






/* harmony default export */ var menuvue_type_script_lang_js_ = ({
  name: 'ElMenu',

  render: function render(h) {
    var component = h(
      'ul',
      {
        attrs: {
          role: 'menubar'
        },
        key: +this.collapse,
        style: { backgroundColor: this.backgroundColor || '' },
        'class': {
          'el-menu--horizontal': this.mode === 'horizontal',
          'el-menu--collapse': this.collapse,
          "el-menu": true
        }
      },
      [this.$slots.default]
    );

    if (this.collapseTransition) {
      return h('el-menu-collapse-transition', [component]);
    } else {
      return component;
    }
  },


  componentName: 'ElMenu',

  mixins: [emitter_default.a, migrating_default.a],

  provide: function provide() {
    return {
      rootMenu: this
    };
  },


  components: {
    'el-menu-collapse-transition': {
      functional: true,
      render: function render(createElement, context) {
        var data = {
          props: {
            mode: 'out-in'
          },
          on: {
            beforeEnter: function beforeEnter(el) {
              el.style.opacity = 0.2;
            },
            enter: function enter(el) {
              Object(dom_["addClass"])(el, 'el-opacity-transition');
              el.style.opacity = 1;
            },
            afterEnter: function afterEnter(el) {
              Object(dom_["removeClass"])(el, 'el-opacity-transition');
              el.style.opacity = '';
            },
            beforeLeave: function beforeLeave(el) {
              if (!el.dataset) el.dataset = {};

              if (Object(dom_["hasClass"])(el, 'el-menu--collapse')) {
                Object(dom_["removeClass"])(el, 'el-menu--collapse');
                el.dataset.oldOverflow = el.style.overflow;
                el.dataset.scrollWidth = el.clientWidth;
                Object(dom_["addClass"])(el, 'el-menu--collapse');
              } else {
                Object(dom_["addClass"])(el, 'el-menu--collapse');
                el.dataset.oldOverflow = el.style.overflow;
                el.dataset.scrollWidth = el.clientWidth;
                Object(dom_["removeClass"])(el, 'el-menu--collapse');
              }

              el.style.width = el.scrollWidth + 'px';
              el.style.overflow = 'hidden';
            },
            leave: function leave(el) {
              Object(dom_["addClass"])(el, 'horizontal-collapse-transition');
              el.style.width = el.dataset.scrollWidth + 'px';
            }
          }
        };
        return createElement('transition', data, context.children);
      }
    }
  },

  props: {
    mode: {
      type: String,
      default: 'vertical'
    },
    defaultActive: {
      type: String,
      default: ''
    },
    defaultOpeneds: Array,
    uniqueOpened: Boolean,
    router: Boolean,
    menuTrigger: {
      type: String,
      default: 'hover'
    },
    collapse: Boolean,
    backgroundColor: String,
    textColor: String,
    activeTextColor: String,
    collapseTransition: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      activeIndex: this.defaultActive,
      openedMenus: this.defaultOpeneds && !this.collapse ? this.defaultOpeneds.slice(0) : [],
      items: {},
      submenus: {}
    };
  },

  computed: {
    hoverBackground: function hoverBackground() {
      return this.backgroundColor ? this.mixColor(this.backgroundColor, 0.2) : '';
    },
    isMenuPopup: function isMenuPopup() {
      return this.mode === 'horizontal' || this.mode === 'vertical' && this.collapse;
    }
  },
  watch: {
    defaultActive: function defaultActive(value) {
      if (!this.items[value]) {
        this.activeIndex = null;
      }
      this.updateActiveIndex(value);
    },
    defaultOpeneds: function defaultOpeneds(value) {
      if (!this.collapse) {
        this.openedMenus = value;
      }
    },
    collapse: function collapse(value) {
      if (value) this.openedMenus = [];
      this.broadcast('ElSubmenu', 'toggle-collapse', value);
    }
  },
  methods: {
    updateActiveIndex: function updateActiveIndex(val) {
      var item = this.items[val] || this.items[this.activeIndex] || this.items[this.defaultActive];
      if (item) {
        this.activeIndex = item.index;
        this.initOpenedMenu();
      } else {
        this.activeIndex = null;
      }
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'theme': 'theme is removed.'
        }
      };
    },
    getColorChannels: function getColorChannels(color) {
      color = color.replace('#', '');
      if (/^[0-9a-fA-F]{3}$/.test(color)) {
        color = color.split('');
        for (var i = 2; i >= 0; i--) {
          color.splice(i, 0, color[i]);
        }
        color = color.join('');
      }
      if (/^[0-9a-fA-F]{6}$/.test(color)) {
        return {
          red: parseInt(color.slice(0, 2), 16),
          green: parseInt(color.slice(2, 4), 16),
          blue: parseInt(color.slice(4, 6), 16)
        };
      } else {
        return {
          red: 255,
          green: 255,
          blue: 255
        };
      }
    },
    mixColor: function mixColor(color, percent) {
      var _getColorChannels = this.getColorChannels(color),
          red = _getColorChannels.red,
          green = _getColorChannels.green,
          blue = _getColorChannels.blue;

      if (percent > 0) {
        // shade given color
        red *= 1 - percent;
        green *= 1 - percent;
        blue *= 1 - percent;
      } else {
        // tint given color
        red += (255 - red) * percent;
        green += (255 - green) * percent;
        blue += (255 - blue) * percent;
      }
      return 'rgb(' + Math.round(red) + ', ' + Math.round(green) + ', ' + Math.round(blue) + ')';
    },
    addItem: function addItem(item) {
      this.$set(this.items, item.index, item);
    },
    removeItem: function removeItem(item) {
      delete this.items[item.index];
    },
    addSubmenu: function addSubmenu(item) {
      this.$set(this.submenus, item.index, item);
    },
    removeSubmenu: function removeSubmenu(item) {
      delete this.submenus[item.index];
    },
    openMenu: function openMenu(index, indexPath) {
      var openedMenus = this.openedMenus;
      if (openedMenus.indexOf(index) !== -1) return;
      // 将不在该菜单路径下的其余菜单收起
      // collapse all menu that are not under current menu item
      if (this.uniqueOpened) {
        this.openedMenus = openedMenus.filter(function (index) {
          return indexPath.indexOf(index) !== -1;
        });
      }
      this.openedMenus.push(index);
    },
    closeMenu: function closeMenu(index) {
      var i = this.openedMenus.indexOf(index);
      if (i !== -1) {
        this.openedMenus.splice(i, 1);
      }
    },
    handleSubmenuClick: function handleSubmenuClick(submenu) {
      var index = submenu.index,
          indexPath = submenu.indexPath;

      var isOpened = this.openedMenus.indexOf(index) !== -1;

      if (isOpened) {
        this.closeMenu(index);
        this.$emit('close', index, indexPath);
      } else {
        this.openMenu(index, indexPath);
        this.$emit('open', index, indexPath);
      }
    },
    handleItemClick: function handleItemClick(item) {
      var _this = this;

      var index = item.index,
          indexPath = item.indexPath;

      var oldActiveIndex = this.activeIndex;
      var hasIndex = item.index !== null;

      if (hasIndex) {
        this.activeIndex = item.index;
      }

      this.$emit('select', index, indexPath, item);

      if (this.mode === 'horizontal' || this.collapse) {
        this.openedMenus = [];
      }

      if (this.router && hasIndex) {
        this.routeToItem(item, function (error) {
          _this.activeIndex = oldActiveIndex;
          if (error) {
            // vue-router 3.1.0+ push/replace cause NavigationDuplicated error 
            // https://github.com/ElemeFE/element/issues/17044
            if (error.name === 'NavigationDuplicated') return;
            console.error(error);
          }
        });
      }
    },

    // 初始化展开菜单
    // initialize opened menu
    initOpenedMenu: function initOpenedMenu() {
      var _this2 = this;

      var index = this.activeIndex;
      var activeItem = this.items[index];
      if (!activeItem || this.mode === 'horizontal' || this.collapse) return;

      var indexPath = activeItem.indexPath;

      // 展开该菜单项的路径上所有子菜单
      // expand all submenus of the menu item
      indexPath.forEach(function (index) {
        var submenu = _this2.submenus[index];
        submenu && _this2.openMenu(index, submenu.indexPath);
      });
    },
    routeToItem: function routeToItem(item, onError) {
      var route = item.route || item.index;
      try {
        this.$router.push(route, function () {}, onError);
      } catch (e) {
        console.error(e);
      }
    },
    open: function open(index) {
      var _this3 = this;

      var indexPath = this.submenus[index.toString()].indexPath;

      indexPath.forEach(function (i) {
        return _this3.openMenu(i, indexPath);
      });
    },
    close: function close(index) {
      this.closeMenu(index);
    }
  },
  mounted: function mounted() {
    this.initOpenedMenu();
    this.$on('item-click', this.handleItemClick);
    this.$on('submenu-click', this.handleSubmenuClick);
    if (this.mode === 'horizontal') {
      new aria_menubar(this.$el); // eslint-disable-line
    }
    this.$watch('items', this.updateActiveIndex);
  }
});
// CONCATENATED MODULE: ./packages/menu/src/menu.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_menuvue_type_script_lang_js_ = (menuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/menu/src/menu.vue
var menu_render, menu_staticRenderFns




/* normalize component */

var menu_component = normalizeComponent(
  src_menuvue_type_script_lang_js_,
  menu_render,
  menu_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var menu_api; }
menu_component.options.__file = "packages/menu/src/menu.vue"
/* harmony default export */ var src_menu = (menu_component.exports);
// CONCATENATED MODULE: ./packages/menu/index.js


/* istanbul ignore next */
src_menu.install = function (Vue) {
  Vue.component(src_menu.name, src_menu);
};

/* harmony default export */ var packages_menu = (src_menu);
// EXTERNAL MODULE: external "element-ui/lib/transitions/collapse-transition"
var collapse_transition_ = __webpack_require__(21);
var collapse_transition_default = /*#__PURE__*/__webpack_require__.n(collapse_transition_);

// CONCATENATED MODULE: ./packages/menu/src/menu-mixin.js
/* harmony default export */ var menu_mixin = ({
  inject: ['rootMenu'],
  computed: {
    indexPath: function indexPath() {
      var path = [this.index];
      var parent = this.$parent;
      while (parent.$options.componentName !== 'ElMenu') {
        if (parent.index) {
          path.unshift(parent.index);
        }
        parent = parent.$parent;
      }
      return path;
    },
    parentMenu: function parentMenu() {
      var parent = this.$parent;
      while (parent && ['ElMenu', 'ElSubmenu'].indexOf(parent.$options.componentName) === -1) {
        parent = parent.$parent;
      }
      return parent;
    },
    paddingStyle: function paddingStyle() {
      if (this.rootMenu.mode !== 'vertical') return {};

      var padding = 20;
      var parent = this.$parent;

      if (this.rootMenu.collapse) {
        padding = 20;
      } else {
        while (parent && parent.$options.componentName !== 'ElMenu') {
          if (parent.$options.componentName === 'ElSubmenu') {
            padding += 20;
          }
          parent = parent.$parent;
        }
      }
      return { paddingLeft: padding + 'px' };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/submenu.vue?vue&type=script&lang=js&






var poperMixins = {
  props: {
    transformOrigin: {
      type: [Boolean, String],
      default: false
    },
    offset: vue_popper_default.a.props.offset,
    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
    popperOptions: vue_popper_default.a.props.popperOptions
  },
  data: vue_popper_default.a.data,
  methods: vue_popper_default.a.methods,
  beforeDestroy: vue_popper_default.a.beforeDestroy,
  deactivated: vue_popper_default.a.deactivated
};

/* harmony default export */ var submenuvue_type_script_lang_js_ = ({
  name: 'ElSubmenu',

  componentName: 'ElSubmenu',

  mixins: [menu_mixin, emitter_default.a, poperMixins],

  components: { ElCollapseTransition: collapse_transition_default.a },

  props: {
    index: {
      type: String,
      required: true
    },
    showTimeout: {
      type: Number,
      default: 300
    },
    hideTimeout: {
      type: Number,
      default: 300
    },
    popperClass: String,
    disabled: Boolean,
    popperAppendToBody: {
      type: Boolean,
      default: undefined
    }
  },

  data: function data() {
    return {
      popperJS: null,
      timeout: null,
      items: {},
      submenus: {},
      mouseInChild: false
    };
  },

  watch: {
    opened: function opened(val) {
      var _this = this;

      if (this.isMenuPopup) {
        this.$nextTick(function (_) {
          _this.updatePopper();
        });
      }
    }
  },
  computed: {
    // popper option
    appendToBody: function appendToBody() {
      return this.popperAppendToBody === undefined ? this.isFirstLevel : this.popperAppendToBody;
    },
    menuTransitionName: function menuTransitionName() {
      return this.rootMenu.collapse ? 'el-zoom-in-left' : 'el-zoom-in-top';
    },
    opened: function opened() {
      return this.rootMenu.openedMenus.indexOf(this.index) > -1;
    },
    active: function active() {
      var isActive = false;
      var submenus = this.submenus;
      var items = this.items;

      Object.keys(items).forEach(function (index) {
        if (items[index].active) {
          isActive = true;
        }
      });

      Object.keys(submenus).forEach(function (index) {
        if (submenus[index].active) {
          isActive = true;
        }
      });

      return isActive;
    },
    hoverBackground: function hoverBackground() {
      return this.rootMenu.hoverBackground;
    },
    backgroundColor: function backgroundColor() {
      return this.rootMenu.backgroundColor || '';
    },
    activeTextColor: function activeTextColor() {
      return this.rootMenu.activeTextColor || '';
    },
    textColor: function textColor() {
      return this.rootMenu.textColor || '';
    },
    mode: function mode() {
      return this.rootMenu.mode;
    },
    isMenuPopup: function isMenuPopup() {
      return this.rootMenu.isMenuPopup;
    },
    titleStyle: function titleStyle() {
      if (this.mode !== 'horizontal') {
        return {
          color: this.textColor
        };
      }
      return {
        borderBottomColor: this.active ? this.rootMenu.activeTextColor ? this.activeTextColor : '' : 'transparent',
        color: this.active ? this.activeTextColor : this.textColor
      };
    },
    isFirstLevel: function isFirstLevel() {
      var isFirstLevel = true;
      var parent = this.$parent;
      while (parent && parent !== this.rootMenu) {
        if (['ElSubmenu', 'ElMenuItemGroup'].indexOf(parent.$options.componentName) > -1) {
          isFirstLevel = false;
          break;
        } else {
          parent = parent.$parent;
        }
      }
      return isFirstLevel;
    }
  },
  methods: {
    handleCollapseToggle: function handleCollapseToggle(value) {
      if (value) {
        this.initPopper();
      } else {
        this.doDestroy();
      }
    },
    addItem: function addItem(item) {
      this.$set(this.items, item.index, item);
    },
    removeItem: function removeItem(item) {
      delete this.items[item.index];
    },
    addSubmenu: function addSubmenu(item) {
      this.$set(this.submenus, item.index, item);
    },
    removeSubmenu: function removeSubmenu(item) {
      delete this.submenus[item.index];
    },
    handleClick: function handleClick() {
      var rootMenu = this.rootMenu,
          disabled = this.disabled;

      if (rootMenu.menuTrigger === 'hover' && rootMenu.mode === 'horizontal' || rootMenu.collapse && rootMenu.mode === 'vertical' || disabled) {
        return;
      }
      this.dispatch('ElMenu', 'submenu-click', this);
    },
    handleMouseenter: function handleMouseenter(event) {
      var _this2 = this;

      var showTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.showTimeout;


      if (!('ActiveXObject' in window) && event.type === 'focus' && !event.relatedTarget) {
        return;
      }
      var rootMenu = this.rootMenu,
          disabled = this.disabled;

      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical' || disabled) {
        return;
      }
      this.dispatch('ElSubmenu', 'mouse-enter-child');
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this2.rootMenu.openMenu(_this2.index, _this2.indexPath);
      }, showTimeout);

      if (this.appendToBody) {
        this.$parent.$el.dispatchEvent(new MouseEvent('mouseenter'));
      }
    },
    handleMouseleave: function handleMouseleave() {
      var _this3 = this;

      var deepDispatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var rootMenu = this.rootMenu;

      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical') {
        return;
      }
      this.dispatch('ElSubmenu', 'mouse-leave-child');
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        !_this3.mouseInChild && _this3.rootMenu.closeMenu(_this3.index);
      }, this.hideTimeout);

      if (this.appendToBody && deepDispatch) {
        if (this.$parent.$options.name === 'ElSubmenu') {
          this.$parent.handleMouseleave(true);
        }
      }
    },
    handleTitleMouseenter: function handleTitleMouseenter() {
      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
      var title = this.$refs['submenu-title'];
      title && (title.style.backgroundColor = this.rootMenu.hoverBackground);
    },
    handleTitleMouseleave: function handleTitleMouseleave() {
      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
      var title = this.$refs['submenu-title'];
      title && (title.style.backgroundColor = this.rootMenu.backgroundColor || '');
    },
    updatePlacement: function updatePlacement() {
      this.currentPlacement = this.mode === 'horizontal' && this.isFirstLevel ? 'bottom-start' : 'right-start';
    },
    initPopper: function initPopper() {
      this.referenceElm = this.$el;
      this.popperElm = this.$refs.menu;
      this.updatePlacement();
    }
  },
  created: function created() {
    var _this4 = this;

    this.$on('toggle-collapse', this.handleCollapseToggle);
    this.$on('mouse-enter-child', function () {
      _this4.mouseInChild = true;
      clearTimeout(_this4.timeout);
    });
    this.$on('mouse-leave-child', function () {
      _this4.mouseInChild = false;
      clearTimeout(_this4.timeout);
    });
  },
  mounted: function mounted() {
    this.parentMenu.addSubmenu(this);
    this.rootMenu.addSubmenu(this);
    this.initPopper();
  },
  beforeDestroy: function beforeDestroy() {
    this.parentMenu.removeSubmenu(this);
    this.rootMenu.removeSubmenu(this);
  },
  render: function render(h) {
    var _this5 = this;

    var active = this.active,
        opened = this.opened,
        paddingStyle = this.paddingStyle,
        titleStyle = this.titleStyle,
        backgroundColor = this.backgroundColor,
        rootMenu = this.rootMenu,
        currentPlacement = this.currentPlacement,
        menuTransitionName = this.menuTransitionName,
        mode = this.mode,
        disabled = this.disabled,
        popperClass = this.popperClass,
        $slots = this.$slots,
        isFirstLevel = this.isFirstLevel;


    var popupMenu = h(
      'transition',
      {
        attrs: { name: menuTransitionName }
      },
      [h(
        'div',
        {
          ref: 'menu',
          directives: [{
            name: 'show',
            value: opened
          }],

          'class': ['el-menu--' + mode, popperClass],
          on: {
            'mouseenter': function mouseenter($event) {
              return _this5.handleMouseenter($event, 100);
            },
            'mouseleave': function mouseleave() {
              return _this5.handleMouseleave(true);
            },
            'focus': function focus($event) {
              return _this5.handleMouseenter($event, 100);
            }
          }
        },
        [h(
          'ul',
          {
            attrs: {
              role: 'menu'
            },
            'class': ['el-menu el-menu--popup', 'el-menu--popup-' + currentPlacement],
            style: { backgroundColor: rootMenu.backgroundColor || '' } },
          [$slots.default]
        )]
      )]
    );

    var inlineMenu = h('el-collapse-transition', [h(
      'ul',
      {
        attrs: {
          role: 'menu'
        },
        'class': 'el-menu el-menu--inline',
        directives: [{
          name: 'show',
          value: opened
        }],

        style: { backgroundColor: rootMenu.backgroundColor || '' } },
      [$slots.default]
    )]);

    var submenuTitleIcon = rootMenu.mode === 'horizontal' && isFirstLevel || rootMenu.mode === 'vertical' && !rootMenu.collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-right';

    return h(
      'li',
      {
        'class': {
          'el-submenu': true,
          'is-active': active,
          'is-opened': opened,
          'is-disabled': disabled
        },
        attrs: { role: 'menuitem',
          'aria-haspopup': 'true',
          'aria-expanded': opened
        },
        on: {
          'mouseenter': this.handleMouseenter,
          'mouseleave': function mouseleave() {
            return _this5.handleMouseleave(false);
          },
          'focus': this.handleMouseenter
        }
      },
      [h(
        'div',
        {
          'class': 'el-submenu__title',
          ref: 'submenu-title',
          on: {
            'click': this.handleClick,
            'mouseenter': this.handleTitleMouseenter,
            'mouseleave': this.handleTitleMouseleave
          },

          style: [paddingStyle, titleStyle, { backgroundColor: backgroundColor }]
        },
        [$slots.title, h('i', { 'class': ['el-submenu__icon-arrow', submenuTitleIcon] })]
      ), this.isMenuPopup ? popupMenu : inlineMenu]
    );
  }
});
// CONCATENATED MODULE: ./packages/menu/src/submenu.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_submenuvue_type_script_lang_js_ = (submenuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/menu/src/submenu.vue
var submenu_render, submenu_staticRenderFns




/* normalize component */

var submenu_component = normalizeComponent(
  src_submenuvue_type_script_lang_js_,
  submenu_render,
  submenu_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var submenu_api; }
submenu_component.options.__file = "packages/menu/src/submenu.vue"
/* harmony default export */ var submenu = (submenu_component.exports);
// CONCATENATED MODULE: ./packages/submenu/index.js


/* istanbul ignore next */
submenu.install = function (Vue) {
  Vue.component(submenu.name, submenu);
};

/* harmony default export */ var packages_submenu = (submenu);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
var menu_itemvue_type_template_id_2a5dbfea_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "el-menu-item",
      class: {
        "is-active": _vm.active,
        "is-disabled": _vm.disabled
      },
      style: [
        _vm.paddingStyle,
        _vm.itemStyle,
        { backgroundColor: _vm.backgroundColor }
      ],
      attrs: { role: "menuitem", tabindex: "-1" },
      on: {
        click: _vm.handleClick,
        mouseenter: _vm.onMouseEnter,
        focus: _vm.onMouseEnter,
        blur: _vm.onMouseLeave,
        mouseleave: _vm.onMouseLeave
      }
    },
    [
      _vm.parentMenu.$options.componentName === "ElMenu" &&
      _vm.rootMenu.collapse &&
      _vm.$slots.title
        ? _c("el-tooltip", { attrs: { effect: "dark", placement: "right" } }, [
            _c(
              "div",
              { attrs: { slot: "content" }, slot: "content" },
              [_vm._t("title")],
              2
            ),
            _c(
              "div",
              {
                staticStyle: {
                  position: "absolute",
                  left: "0",
                  top: "0",
                  height: "100%",
                  width: "100%",
                  display: "inline-block",
                  "box-sizing": "border-box",
                  padding: "0 20px"
                }
              },
              [_vm._t("default")],
              2
            )
          ])
        : [_vm._t("default"), _vm._t("title")]
    ],
    2
  )
}
var menu_itemvue_type_template_id_2a5dbfea_staticRenderFns = []
menu_itemvue_type_template_id_2a5dbfea_render._withStripped = true


// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&

// EXTERNAL MODULE: external "element-ui/lib/tooltip"
var tooltip_ = __webpack_require__(26);
var tooltip_default = /*#__PURE__*/__webpack_require__.n(tooltip_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var menu_itemvue_type_script_lang_js_ = ({
  name: 'ElMenuItem',

  componentName: 'ElMenuItem',

  mixins: [menu_mixin, emitter_default.a],

  components: { ElTooltip: tooltip_default.a },

  props: {
    index: {
      default: null,
      validator: function validator(val) {
        return typeof val === 'string' || val === null;
      }
    },
    route: [String, Object],
    disabled: Boolean
  },
  computed: {
    active: function active() {
      return this.index === this.rootMenu.activeIndex;
    },
    hoverBackground: function hoverBackground() {
      return this.rootMenu.hoverBackground;
    },
    backgroundColor: function backgroundColor() {
      return this.rootMenu.backgroundColor || '';
    },
    activeTextColor: function activeTextColor() {
      return this.rootMenu.activeTextColor || '';
    },
    textColor: function textColor() {
      return this.rootMenu.textColor || '';
    },
    mode: function mode() {
      return this.rootMenu.mode;
    },
    itemStyle: function itemStyle() {
      var style = {
        color: this.active ? this.activeTextColor : this.textColor
      };
      if (this.mode === 'horizontal' && !this.isNested) {
        style.borderBottomColor = this.active ? this.rootMenu.activeTextColor ? this.activeTextColor : '' : 'transparent';
      }
      return style;
    },
    isNested: function isNested() {
      return this.parentMenu !== this.rootMenu;
    }
  },
  methods: {
    onMouseEnter: function onMouseEnter() {
      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
      this.$el.style.backgroundColor = this.hoverBackground;
    },
    onMouseLeave: function onMouseLeave() {
      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
      this.$el.style.backgroundColor = this.backgroundColor;
    },
    handleClick: function handleClick() {
      if (!this.disabled) {
        this.dispatch('ElMenu', 'item-click', this);
        this.$emit('click', this);
      }
    }
  },
  mounted: function mounted() {
    this.parentMenu.addItem(this);
    this.rootMenu.addItem(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.parentMenu.removeItem(this);
    this.rootMenu.removeItem(this);
  }
});
// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_menu_itemvue_type_script_lang_js_ = (menu_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue





/* normalize component */

var menu_item_component = normalizeComponent(
  src_menu_itemvue_type_script_lang_js_,
  menu_itemvue_type_template_id_2a5dbfea_render,
  menu_itemvue_type_template_id_2a5dbfea_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var menu_item_api; }
menu_item_component.options.__file = "packages/menu/src/menu-item.vue"
/* harmony default export */ var menu_item = (menu_item_component.exports);
// CONCATENATED MODULE: ./packages/menu-item/index.js


/* istanbul ignore next */
menu_item.install = function (Vue) {
  Vue.component(menu_item.name, menu_item);
};

/* harmony default export */ var packages_menu_item = (menu_item);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&
var menu_item_groupvue_type_template_id_543b7bdc_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "el-menu-item-group" }, [
    _c(
      "div",
      {
        staticClass: "el-menu-item-group__title",
        style: { paddingLeft: _vm.levelPadding + "px" }
      },
      [!_vm.$slots.title ? [_vm._v(_vm._s(_vm.title))] : _vm._t("title")],
      2
    ),
    _c("ul", [_vm._t("default")], 2)
  ])
}
var menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns = []
menu_item_groupvue_type_template_id_543b7bdc_render._withStripped = true


// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var menu_item_groupvue_type_script_lang_js_ = ({
  name: 'ElMenuItemGroup',

  componentName: 'ElMenuItemGroup',

  inject: ['rootMenu'],
  props: {
    title: {
      type: String
    }
  },
  data: function data() {
    return {
      paddingLeft: 20
    };
  },

  computed: {
    levelPadding: function levelPadding() {
      var padding = 20;
      var parent = this.$parent;
      if (this.rootMenu.collapse) return 20;
      while (parent && parent.$options.componentName !== 'ElMenu') {
        if (parent.$options.componentName === 'ElSubmenu') {
          padding += 20;
        }
        parent = parent.$parent;
      }
      return padding;
    }
  }
});
// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_menu_item_groupvue_type_script_lang_js_ = (menu_item_groupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue





/* normalize component */

var menu_item_group_component = normalizeComponent(
  src_menu_item_groupvue_type_script_lang_js_,
  menu_item_groupvue_type_template_id_543b7bdc_render,
  menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var menu_item_group_api; }
menu_item_group_component.options.__file = "packages/menu/src/menu-item-group.vue"
/* harmony default export */ var menu_item_group = (menu_item_group_component.exports);
// CONCATENATED MODULE: ./packages/menu-item-group/index.js


/* istanbul ignore next */
menu_item_group.install = function (Vue) {
  Vue.component(menu_item_group.name, menu_item_group);
};

/* harmony default export */ var packages_menu_item_group = (menu_item_group);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
var inputvue_type_template_id_343dd774_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.type === "textarea" ? "el-textarea" : "el-input",
        _vm.inputSize ? "el-input--" + _vm.inputSize : "",
        {
          "is-disabled": _vm.inputDisabled,
          "is-exceed": _vm.inputExceed,
          "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
          "el-input-group--append": _vm.$slots.append,
          "el-input-group--prepend": _vm.$slots.prepend,
          "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
          "el-input--suffix":
            _vm.$slots.suffix ||
            _vm.suffixIcon ||
            _vm.clearable ||
            _vm.showPassword
        }
      ],
      on: {
        mouseenter: function($event) {
          _vm.hovering = true
        },
        mouseleave: function($event) {
          _vm.hovering = false
        }
      }
    },
    [
      _vm.type !== "textarea"
        ? [
            _vm.$slots.prepend
              ? _c(
                  "div",
                  { staticClass: "el-input-group__prepend" },
                  [_vm._t("prepend")],
                  2
                )
              : _vm._e(),
            _vm.type !== "textarea"
              ? _c(
                  "input",
                  _vm._b(
                    {
                      ref: "input",
                      staticClass: "el-input__inner",
                      attrs: {
                        tabindex: _vm.tabindex,
                        type: _vm.showPassword
                          ? _vm.passwordVisible
                            ? "text"
                            : "password"
                          : _vm.type,
                        disabled: _vm.inputDisabled,
                        readonly: _vm.readonly,
                        autocomplete: _vm.autoComplete || _vm.autocomplete,
                        "aria-label": _vm.label
                      },
                      on: {
                        compositionstart: _vm.handleCompositionStart,
                        compositionupdate: _vm.handleCompositionUpdate,
                        compositionend: _vm.handleCompositionEnd,
                        input: _vm.handleInput,
                        focus: _vm.handleFocus,
                        blur: _vm.handleBlur,
                        change: _vm.handleChange
                      }
                    },
                    "input",
                    _vm.$attrs,
                    false
                  )
                )
              : _vm._e(),
            _vm.$slots.prefix || _vm.prefixIcon
              ? _c(
                  "span",
                  { staticClass: "el-input__prefix" },
                  [
                    _vm._t("prefix"),
                    _vm.prefixIcon
                      ? _c("i", {
                          staticClass: "el-input__icon",
                          class: _vm.prefixIcon
                        })
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm.getSuffixVisible()
              ? _c("span", { staticClass: "el-input__suffix" }, [
                  _c(
                    "span",
                    { staticClass: "el-input__suffix-inner" },
                    [
                      !_vm.showClear ||
                      !_vm.showPwdVisible ||
                      !_vm.isWordLimitVisible
                        ? [
                            _vm._t("suffix"),
                            _vm.suffixIcon
                              ? _c("i", {
                                  staticClass: "el-input__icon",
                                  class: _vm.suffixIcon
                                })
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm.showClear
                        ? _c("i", {
                            staticClass:
                              "el-input__icon el-icon-circle-close el-input__clear",
                            on: {
                              mousedown: function($event) {
                                $event.preventDefault()
                              },
                              click: _vm.clear
                            }
                          })
                        : _vm._e(),
                      _vm.showPwdVisible
                        ? _c("i", {
                            staticClass:
                              "el-input__icon el-icon-view el-input__clear",
                            on: { click: _vm.handlePasswordVisible }
                          })
                        : _vm._e(),
                      _vm.isWordLimitVisible
                        ? _c("span", { staticClass: "el-input__count" }, [
                            _c(
                              "span",
                              { staticClass: "el-input__count-inner" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.textLength) +
                                    "/" +
                                    _vm._s(_vm.upperLimit) +
                                    "\n          "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm.validateState
                    ? _c("i", {
                        staticClass: "el-input__icon",
                        class: ["el-input__validateIcon", _vm.validateIcon]
                      })
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.$slots.append
              ? _c(
                  "div",
                  { staticClass: "el-input-group__append" },
                  [_vm._t("append")],
                  2
                )
              : _vm._e()
          ]
        : _c(
            "textarea",
            _vm._b(
              {
                ref: "textarea",
                staticClass: "el-textarea__inner",
                style: _vm.textareaStyle,
                attrs: {
                  tabindex: _vm.tabindex,
                  disabled: _vm.inputDisabled,
                  readonly: _vm.readonly,
                  autocomplete: _vm.autoComplete || _vm.autocomplete,
                  "aria-label": _vm.label
                },
                on: {
                  compositionstart: _vm.handleCompositionStart,
                  compositionupdate: _vm.handleCompositionUpdate,
                  compositionend: _vm.handleCompositionEnd,
                  input: _vm.handleInput,
                  focus: _vm.handleFocus,
                  blur: _vm.handleBlur,
                  change: _vm.handleChange
                }
              },
              "textarea",
              _vm.$attrs,
              false
            )
          ),
      _vm.isWordLimitVisible && _vm.type === "textarea"
        ? _c("span", { staticClass: "el-input__count" }, [
            _vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))
          ])
        : _vm._e()
    ],
    2
  )
}
var inputvue_type_template_id_343dd774_staticRenderFns = []
inputvue_type_template_id_343dd774_render._withStripped = true


// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&

// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
var hiddenTextarea = void 0;

var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';

var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];

function calculateNodeStyling(targetElement) {
  var style = window.getComputedStyle(targetElement);

  var boxSizing = style.getPropertyValue('box-sizing');

  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));

  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));

  var contextStyle = CONTEXT_STYLE.map(function (name) {
    return name + ':' + style.getPropertyValue(name);
  }).join(';');

  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
}

function calcTextareaHeight(targetElement) {
  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  }

  var _calculateNodeStyling = calculateNodeStyling(targetElement),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      contextStyle = _calculateNodeStyling.contextStyle;

  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';

  var height = hiddenTextarea.scrollHeight;
  var result = {};

  if (boxSizing === 'border-box') {
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    height = height - paddingSize;
  }

  hiddenTextarea.value = '';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

  if (minRows !== null) {
    var minHeight = singleRowHeight * minRows;
    if (boxSizing === 'border-box') {
      minHeight = minHeight + paddingSize + borderSize;
    }
    height = Math.max(minHeight, height);
    result.minHeight = minHeight + 'px';
  }
  if (maxRows !== null) {
    var maxHeight = singleRowHeight * maxRows;
    if (boxSizing === 'border-box') {
      maxHeight = maxHeight + paddingSize + borderSize;
    }
    height = Math.min(maxHeight, height);
  }
  result.height = height + 'px';
  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
  hiddenTextarea = null;
  return result;
};
// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
var merge_ = __webpack_require__(7);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
var shared_ = __webpack_require__(19);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var inputvue_type_script_lang_js_ = ({
  name: 'ElInput',

  componentName: 'ElInput',

  mixins: [emitter_default.a, migrating_default.a],

  inheritAttrs: false,

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  data: function data() {
    return {
      textareaCalcStyle: {},
      hovering: false,
      focused: false,
      isComposing: false,
      passwordVisible: false
    };
  },


  props: {
    value: [String, Number],
    size: String,
    resize: String,
    form: String,
    disabled: Boolean,
    readonly: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    /** @Deprecated in next major version */
    autoComplete: {
      type: String,
      validator: function validator(val) {
         false && false;
        return true;
      }
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    suffixIcon: String,
    prefixIcon: String,
    label: String,
    clearable: {
      type: Boolean,
      default: false
    },
    showPassword: {
      type: Boolean,
      default: false
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    tabindex: String
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    validateState: function validateState() {
      return this.elFormItem ? this.elFormItem.validateState : '';
    },
    needStatusIcon: function needStatusIcon() {
      return this.elForm ? this.elForm.statusIcon : false;
    },
    validateIcon: function validateIcon() {
      return {
        validating: 'el-icon-loading',
        success: 'el-icon-circle-check',
        error: 'el-icon-circle-close'
      }[this.validateState];
    },
    textareaStyle: function textareaStyle() {
      return merge_default()({}, this.textareaCalcStyle, { resize: this.resize });
    },
    inputSize: function inputSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputDisabled: function inputDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    nativeInputValue: function nativeInputValue() {
      return this.value === null || this.value === undefined ? '' : String(this.value);
    },
    showClear: function showClear() {
      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
    },
    showPwdVisible: function showPwdVisible() {
      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
    },
    isWordLimitVisible: function isWordLimitVisible() {
      return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
    },
    upperLimit: function upperLimit() {
      return this.$attrs.maxlength;
    },
    textLength: function textLength() {
      if (typeof this.value === 'number') {
        return String(this.value).length;
      }

      return (this.value || '').length;
    },
    inputExceed: function inputExceed() {
      // show exceed style if length of initial value greater then maxlength
      return this.isWordLimitVisible && this.textLength > this.upperLimit;
    }
  },

  watch: {
    value: function value(val) {
      this.$nextTick(this.resizeTextarea);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [val]);
      }
    },

    // native input value is set explicitly
    // do not use v-model / :value in template
    // see: https://github.com/ElemeFE/element/issues/14521
    nativeInputValue: function nativeInputValue() {
      this.setNativeInputValue();
    },

    // when change between <input> and <textarea>,
    // update DOM dependent value and styles
    // https://github.com/ElemeFE/element/issues/14857
    type: function type() {
      var _this = this;

      this.$nextTick(function () {
        _this.setNativeInputValue();
        _this.resizeTextarea();
        _this.updateIconOffset();
      });
    }
  },

  methods: {
    focus: function focus() {
      this.getInput().focus();
    },
    blur: function blur() {
      this.getInput().blur();
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
          'on-icon-click': 'on-icon-click is removed.'
        },
        events: {
          'click': 'click is removed.'
        }
      };
    },
    handleBlur: function handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
      }
    },
    select: function select() {
      this.getInput().select();
    },
    resizeTextarea: function resizeTextarea() {
      if (this.$isServer) return;
      var autosize = this.autosize,
          type = this.type;

      if (type !== 'textarea') return;
      if (!autosize) {
        this.textareaCalcStyle = {
          minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
        };
        return;
      }
      var minRows = autosize.minRows;
      var maxRows = autosize.maxRows;

      this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
    },
    setNativeInputValue: function setNativeInputValue() {
      var input = this.getInput();
      if (!input) return;
      if (input.value === this.nativeInputValue) return;
      input.value = this.nativeInputValue;
    },
    handleFocus: function handleFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    handleCompositionStart: function handleCompositionStart() {
      this.isComposing = true;
    },
    handleCompositionUpdate: function handleCompositionUpdate(event) {
      var text = event.target.value;
      var lastCharacter = text[text.length - 1] || '';
      this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
    },
    handleCompositionEnd: function handleCompositionEnd(event) {
      if (this.isComposing) {
        this.isComposing = false;
        this.handleInput(event);
      }
    },
    handleInput: function handleInput(event) {
      // should not emit input during composition
      // see: https://github.com/ElemeFE/element/issues/10516
      if (this.isComposing) return;

      // hack for https://github.com/ElemeFE/element/issues/8548
      // should remove the following line when we don't support IE
      if (event.target.value === this.nativeInputValue) return;

      this.$emit('input', event.target.value);

      // ensure native input value is controlled
      // see: https://github.com/ElemeFE/element/issues/12850
      this.$nextTick(this.setNativeInputValue);
    },
    handleChange: function handleChange(event) {
      this.$emit('change', event.target.value);
    },
    calcIconOffset: function calcIconOffset(place) {
      var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
      if (!elList.length) return;
      var el = null;
      for (var i = 0; i < elList.length; i++) {
        if (elList[i].parentNode === this.$el) {
          el = elList[i];
          break;
        }
      }
      if (!el) return;
      var pendantMap = {
        suffix: 'append',
        prefix: 'prepend'
      };

      var pendant = pendantMap[place];
      if (this.$slots[pendant]) {
        el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
      } else {
        el.removeAttribute('style');
      }
    },
    updateIconOffset: function updateIconOffset() {
      this.calcIconOffset('prefix');
      this.calcIconOffset('suffix');
    },
    clear: function clear() {
      this.$emit('input', '');
      this.$emit('change', '');
      this.$emit('clear');
    },
    handlePasswordVisible: function handlePasswordVisible() {
      this.passwordVisible = !this.passwordVisible;
      this.focus();
    },
    getInput: function getInput() {
      return this.$refs.input || this.$refs.textarea;
    },
    getSuffixVisible: function getSuffixVisible() {
      return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
    }
  },

  created: function created() {
    this.$on('inputSelect', this.select);
  },
  mounted: function mounted() {
    this.setNativeInputValue();
    this.resizeTextarea();
    this.updateIconOffset();
  },
  updated: function updated() {
    this.$nextTick(this.updateIconOffset);
  }
});
// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/input/src/input.vue





/* normalize component */

var input_component = normalizeComponent(
  src_inputvue_type_script_lang_js_,
  inputvue_type_template_id_343dd774_render,
  inputvue_type_template_id_343dd774_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var input_api; }
input_component.options.__file = "packages/input/src/input.vue"
/* harmony default export */ var src_input = (input_component.exports);
// CONCATENATED MODULE: ./packages/input/index.js


/* istanbul ignore next */
src_input.install = function (Vue) {
  Vue.component(src_input.name, src_input);
};

/* harmony default export */ var packages_input = (src_input);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
var input_numbervue_type_template_id_42f8cf66_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "el-input-number",
        _vm.inputNumberSize ? "el-input-number--" + _vm.inputNumberSize : "",
        { "is-disabled": _vm.inputNumberDisabled },
        { "is-without-controls": !_vm.controls },
        { "is-controls-right": _vm.controlsAtRight }
      ],
      on: {
        dragstart: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _vm.controls
        ? _c(
            "span",
            {
              directives: [
                {
                  name: "repeat-click",
                  rawName: "v-repeat-click",
                  value: _vm.decrease,
                  expression: "decrease"
                }
              ],
              staticClass: "el-input-number__decrease",
              class: { "is-disabled": _vm.minDisabled },
              attrs: { role: "button" },
              on: {
                keydown: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.decrease($event)
                }
              }
            },
            [
              _c("i", {
                class:
                  "el-icon-" + (_vm.controlsAtRight ? "arrow-down" : "minus")
              })
            ]
          )
        : _vm._e(),
      _vm.controls
        ? _c(
            "span",
            {
              directives: [
                {
                  name: "repeat-click",
                  rawName: "v-repeat-click",
                  value: _vm.increase,
                  expression: "increase"
                }
              ],
              staticClass: "el-input-number__increase",
              class: { "is-disabled": _vm.maxDisabled },
              attrs: { role: "button" },
              on: {
                keydown: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.increase($event)
                }
              }
            },
            [
              _c("i", {
                class: "el-icon-" + (_vm.controlsAtRight ? "arrow-up" : "plus")
              })
            ]
          )
        : _vm._e(),
      _c("el-input", {
        ref: "input",
        attrs: {
          value: _vm.displayValue,
          placeholder: _vm.placeholder,
          disabled: _vm.inputNumberDisabled,
          size: _vm.inputNumberSize,
          max: _vm.max,
          min: _vm.min,
          name: _vm.name,
          label: _vm.label
        },
        on: {
          blur: _vm.handleBlur,
          focus: _vm.handleFocus,
          input: _vm.handleInput,
          change: _vm.handleInputChange
        },
        nativeOn: {
          keydown: [
            function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.increase($event)
            },
            function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.decrease($event)
            }
          ]
        }
      })
    ],
    1
  )
}
var input_numbervue_type_template_id_42f8cf66_staticRenderFns = []
input_numbervue_type_template_id_42f8cf66_render._withStripped = true


// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&

// CONCATENATED MODULE: ./src/directives/repeat-click.js


/* harmony default export */ var repeat_click = ({
  bind: function bind(el, binding, vnode) {
    var interval = null;
    var startTime = void 0;
    var handler = function handler() {
      return vnode.context[binding.expression].apply();
    };
    var clear = function clear() {
      if (Date.now() - startTime < 100) {
        handler();
      }
      clearInterval(interval);
      interval = null;
    };

    Object(dom_["on"])(el, 'mousedown', function (e) {
      if (e.button !== 0) return;
      startTime = Date.now();
      Object(dom_["once"])(document, 'mouseup', clear);
      clearInterval(interval);
      interval = setInterval(handler, 100);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var input_numbervue_type_script_lang_js_ = ({
  name: 'ElInputNumber',
  mixins: [focus_default()('input')],
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  directives: {
    repeatClick: repeat_click
  },
  components: {
    ElInput: input_default.a
  },
  props: {
    step: {
      type: Number,
      default: 1
    },
    stepStrictly: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: Infinity
    },
    min: {
      type: Number,
      default: -Infinity
    },
    value: {},
    disabled: Boolean,
    size: String,
    controls: {
      type: Boolean,
      default: true
    },
    controlsPosition: {
      type: String,
      default: ''
    },
    name: String,
    label: String,
    placeholder: String,
    precision: {
      type: Number,
      validator: function validator(val) {
        return val >= 0 && val === parseInt(val, 10);
      }
    }
  },
  data: function data() {
    return {
      currentValue: 0,
      userInput: null
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        var newVal = value === undefined ? value : Number(value);
        if (newVal !== undefined) {
          if (isNaN(newVal)) {
            return;
          }

          if (this.stepStrictly) {
            var stepPrecision = this.getPrecision(this.step);
            var precisionFactor = Math.pow(10, stepPrecision);
            newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
          }

          if (this.precision !== undefined) {
            newVal = this.toPrecision(newVal, this.precision);
          }
        }
        if (newVal >= this.max) newVal = this.max;
        if (newVal <= this.min) newVal = this.min;
        this.currentValue = newVal;
        this.userInput = null;
        this.$emit('input', newVal);
      }
    }
  },
  computed: {
    minDisabled: function minDisabled() {
      return this._decrease(this.value, this.step) < this.min;
    },
    maxDisabled: function maxDisabled() {
      return this._increase(this.value, this.step) > this.max;
    },
    numPrecision: function numPrecision() {
      var value = this.value,
          step = this.step,
          getPrecision = this.getPrecision,
          precision = this.precision;

      var stepPrecision = getPrecision(step);
      if (precision !== undefined) {
        if (stepPrecision > precision) {
          console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
        }
        return precision;
      } else {
        return Math.max(getPrecision(value), stepPrecision);
      }
    },
    controlsAtRight: function controlsAtRight() {
      return this.controls && this.controlsPosition === 'right';
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    inputNumberSize: function inputNumberSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputNumberDisabled: function inputNumberDisabled() {
      return this.disabled || !!(this.elForm || {}).disabled;
    },
    displayValue: function displayValue() {
      if (this.userInput !== null) {
        return this.userInput;
      }

      var currentValue = this.currentValue;

      if (typeof currentValue === 'number') {
        if (this.stepStrictly) {
          var stepPrecision = this.getPrecision(this.step);
          var precisionFactor = Math.pow(10, stepPrecision);
          currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
        }

        if (this.precision !== undefined) {
          currentValue = currentValue.toFixed(this.precision);
        }
      }

      return currentValue;
    }
  },
  methods: {
    toPrecision: function toPrecision(num, precision) {
      if (precision === undefined) precision = this.numPrecision;
      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
    },
    getPrecision: function getPrecision(value) {
      if (value === undefined) return 0;
      var valueString = value.toString();
      var dotPosition = valueString.indexOf('.');
      var precision = 0;
      if (dotPosition !== -1) {
        precision = valueString.length - dotPosition - 1;
      }
      return precision;
    },
    _increase: function _increase(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;

      var precisionFactor = Math.pow(10, this.numPrecision);
      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
    },
    _decrease: function _decrease(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;

      var precisionFactor = Math.pow(10, this.numPrecision);

      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
    },
    increase: function increase() {
      if (this.inputNumberDisabled || this.maxDisabled) return;
      var value = this.value || 0;
      var newVal = this._increase(value, this.step);
      this.setCurrentValue(newVal);
    },
    decrease: function decrease() {
      if (this.inputNumberDisabled || this.minDisabled) return;
      var value = this.value || 0;
      var newVal = this._decrease(value, this.step);
      this.setCurrentValue(newVal);
    },
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
    },
    handleFocus: function handleFocus(event) {
      this.$emit('focus', event);
    },
    setCurrentValue: function setCurrentValue(newVal) {
      var oldVal = this.currentValue;
      if (typeof newVal === 'number' && this.precision !== undefined) {
        newVal = this.toPrecision(newVal, this.precision);
      }
      if (newVal >= this.max) newVal = this.max;
      if (newVal <= this.min) newVal = this.min;
      if (oldVal === newVal) return;
      this.userInput = null;
      this.$emit('input', newVal);
      this.$emit('change', newVal, oldVal);
      this.currentValue = newVal;
    },
    handleInput: function handleInput(value) {
      this.userInput = value;
    },
    handleInputChange: function handleInputChange(value) {
      var newVal = value === '' ? undefined : Number(value);
      if (!isNaN(newVal) || value === '') {
        this.setCurrentValue(newVal);
      }
      this.userInput = null;
    },
    select: function select() {
      this.$refs.input.select();
    }
  },
  mounted: function mounted() {
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('role', 'spinbutton');
    innerInput.setAttribute('aria-valuemax', this.max);
    innerInput.setAttribute('aria-valuemin', this.min);
    innerInput.setAttribute('aria-valuenow', this.currentValue);
    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
  },
  updated: function updated() {
    if (!this.$refs || !this.$refs.input) return;
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('aria-valuenow', this.currentValue);
  }
});
// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_input_numbervue_type_script_lang_js_ = (input_numbervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue





/* normalize component */

var input_number_component = normalizeComponent(
  src_input_numbervue_type_script_lang_js_,
  input_numbervue_type_template_id_42f8cf66_render,
  input_numbervue_type_template_id_42f8cf66_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var input_number_api; }
input_number_component.options.__file = "packages/input-number/src/input-number.vue"
/* harmony default export */ var input_number = (input_number_component.exports);
// CONCATENATED MODULE: ./packages/input-number/index.js


/* istanbul ignore next */
input_number.install = function (Vue) {
  Vue.component(input_number.name, input_number);
};

/* harmony default export */ var packages_input_number = (input_number);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
var radiovue_type_template_id_69cd6268_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "el-radio",
      class: [
        _vm.border && _vm.radioSize ? "el-radio--" + _vm.radioSize : "",
        { "is-disabled": _vm.isDisabled },
        { "is-focus": _vm.focus },
        { "is-bordered": _vm.border },
        { "is-checked": _vm.model === _vm.label }
      ],
      attrs: {
        role: "radio",
        "aria-checked": _vm.model === _vm.label,
        "aria-disabled": _vm.isDisabled,
        tabindex: _vm.tabIndex
      },
      on: {
        keydown: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
          ) {
            return null
          }
          $event.stopPropagation()
          $event.preventDefault()
          _vm.model = _vm.isDisabled ? _vm.model : _vm.label
        }
      }
    },
    [
      _c(
        "span",
        {
          staticClass: "el-radio__input",
          class: {
            "is-disabled": _vm.isDisabled,
            "is-checked": _vm.model === _vm.label
          }
        },
        [
          _c("span", { staticClass: "el-radio__inner" }),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model,
                expression: "model"
              }
            ],
            ref: "radio",
            staticClass: "el-radio__original",
            attrs: {
              type: "radio",
              "aria-hidden": "true",
              name: _vm.name,
              disabled: _vm.isDisabled,
              tabindex: "-1"
            },
            domProps: {
              value: _vm.label,
              checked: _vm._q(_vm.model, _vm.label)
            },
            on: {
              focus: function($event) {
                _vm.focus = true
              },
              blur: function($event) {
                _vm.focus = false
              },
              change: [
                function($event) {
                  _vm.model = _vm.label
                },
                _vm.handleChange
              ]
            }
          })
        ]
      ),
      _c(
        "span",
        {
          staticClass: "el-radio__label",
          on: {
            keydown: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _vm._t("default"),
          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
        ],
        2
      )
    ]
  )
}
var radiovue_type_template_id_69cd6268_staticRenderFns = []
radiovue_type_template_id_69cd6268_render._withStripped = true


// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var radiovue_type_script_lang_js_ = ({
  name: 'ElRadio',

  mixins: [emitter_default.a],

  inject: {
    elForm: {
      default: ''
    },

    elFormItem: {
      default: ''
    }
  },

  componentName: 'ElRadio',

  props: {
    value: {},
    label: {},
    disabled: Boolean,
    name: String,
    border: Boolean,
    size: String
  },

  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    isGroup: function isGroup() {
      var parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'ElRadioGroup') {
          parent = parent.$parent;
        } else {
          this._radioGroup = parent;
          return true;
        }
      }
      return false;
    },

    model: {
      get: function get() {
        return this.isGroup ? this._radioGroup.value : this.value;
      },
      set: function set(val) {
        if (this.isGroup) {
          this.dispatch('ElRadioGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
        }
        this.$refs.radio && (this.$refs.radio.checked = this.model === this.label);
      }
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    radioSize: function radioSize() {
      var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
    },
    isDisabled: function isDisabled() {
      return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
    },
    tabIndex: function tabIndex() {
      return this.isDisabled || this.isGroup && this.model !== this.label ? -1 : 0;
    }
  },

  methods: {
    handleChange: function handleChange() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('change', _this.model);
        _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_radiovue_type_script_lang_js_ = (radiovue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/radio/src/radio.vue





/* normalize component */

var radio_component = normalizeComponent(
  src_radiovue_type_script_lang_js_,
  radiovue_type_template_id_69cd6268_render,
  radiovue_type_template_id_69cd6268_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var radio_api; }
radio_component.options.__file = "packages/radio/src/radio.vue"
/* harmony default export */ var src_radio = (radio_component.exports);
// CONCATENATED MODULE: ./packages/radio/index.js


/* istanbul ignore next */
src_radio.install = function (Vue) {
  Vue.component(src_radio.name, src_radio);
};

/* harmony default export */ var packages_radio = (src_radio);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&
var radio_groupvue_type_template_id_818a704c_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm._elTag,
    {
      tag: "component",
      staticClass: "el-radio-group",
      attrs: { role: "radiogroup" },
      on: { keydown: _vm.handleKeydown }
    },
    [_vm._t("default")],
    2
  )
}
var radio_groupvue_type_template_id_818a704c_staticRenderFns = []
radio_groupvue_type_template_id_818a704c_render._withStripped = true


// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//



var keyCode = Object.freeze({
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
});
/* harmony default export */ var radio_groupvue_type_script_lang_js_ = ({
  name: 'ElRadioGroup',

  componentName: 'ElRadioGroup',

  inject: {
    elFormItem: {
      default: ''
    }
  },

  mixins: [emitter_default.a],

  props: {
    value: {},
    size: String,
    fill: String,
    textColor: String,
    disabled: Boolean
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    _elTag: function _elTag() {
      return (this.$vnode.data || {}).tag || 'div';
    },
    radioGroupSize: function radioGroupSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    }
  },

  created: function created() {
    var _this = this;

    this.$on('handleChange', function (value) {
      _this.$emit('change', value);
    });
  },
  mounted: function mounted() {
    // 当radioGroup没有默认选项时，第一个可以选中Tab导航
    var radios = this.$el.querySelectorAll('[type=radio]');
    var firstLabel = this.$el.querySelectorAll('[role=radio]')[0];
    if (![].some.call(radios, function (radio) {
      return radio.checked;
    }) && firstLabel) {
      firstLabel.tabIndex = 0;
    }
  },

  methods: {
    handleKeydown: function handleKeydown(e) {
      // 左右上下按键 可以在radio组内切换不同选项
      var target = e.target;
      var className = target.nodeName === 'INPUT' ? '[type=radio]' : '[role=radio]';
      var radios = this.$el.querySelectorAll(className);
      var length = radios.length;
      var index = [].indexOf.call(radios, target);
      var roleRadios = this.$el.querySelectorAll('[role=radio]');
      switch (e.keyCode) {
        case keyCode.LEFT:
        case keyCode.UP:
          e.stopPropagation();
          e.preventDefault();
          if (index === 0) {
            roleRadios[length - 1].click();
            roleRadios[length - 1].focus();
          } else {
            roleRadios[index - 1].click();
            roleRadios[index - 1].focus();
          }
          break;
        case keyCode.RIGHT:
        case keyCode.DOWN:
          if (index === length - 1) {
            e.stopPropagation();
            e.preventDefault();
            roleRadios[0].click();
            roleRadios[0].focus();
          } else {
            roleRadios[index + 1].click();
            roleRadios[index + 1].focus();
          }
          break;
        default:
          break;
      }
    }
  },
  watch: {
    value: function value(_value) {
      this.dispatch('ElFormItem', 'el.form.change', [this.value]);
    }
  }
});
// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_radio_groupvue_type_script_lang_js_ = (radio_groupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue





/* normalize component */

var radio_group_component = normalizeComponent(
  src_radio_groupvue_type_script_lang_js_,
  radio_groupvue_type_template_id_818a704c_render,
  radio_groupvue_type_template_id_818a704c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var radio_group_api; }
radio_group_component.options.__file = "packages/radio/src/radio-group.vue"
/* harmony default export */ var radio_group = (radio_group_component.exports);
// CONCATENATED MODULE: ./packages/radio-group/index.js


/* istanbul ignore next */
radio_group.install = function (Vue) {
  Vue.component(radio_group.name, radio_group);
};

/* harmony default export */ var packages_radio_group = (radio_group);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&
var radio_buttonvue_type_template_id_18a77a32_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "el-radio-button",
      class: [
        _vm.size ? "el-radio-button--" + _vm.size : "",
        { "is-active": _vm.value === _vm.label },
        { "is-disabled": _vm.isDisabled },
        { "is-focus": _vm.focus }
      ],
      attrs: {
        role: "radio",
        "aria-checked": _vm.value === _vm.label,
        "aria-disabled": _vm.isDisabled,
        tabindex: _vm.tabIndex
      },
      on: {
        keydown: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
          ) {
            return null
          }
          $event.stopPropagation()
          $event.preventDefault()
          _vm.value = _vm.isDisabled ? _vm.value : _vm.label
        }
      }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.value,
            expression: "value"
          }
        ],
        staticClass: "el-radio-button__orig-radio",
        attrs: {
          type: "radio",
          name: _vm.name,
          disabled: _vm.isDisabled,
          tabindex: "-1"
        },
        domProps: { value: _vm.label, checked: _vm._q(_vm.value, _vm.label) },
        on: {
          change: [
            function($event) {
              _vm.value = _vm.label
            },
            _vm.handleChange
          ],
          focus: function($event) {
            _vm.focus = true
          },
          blur: function($event) {
            _vm.focus = false
          }
        }
      }),
      _c(
        "span",
        {
          staticClass: "el-radio-button__inner",
          style: _vm.value === _vm.label ? _vm.activeStyle : null,
          on: {
            keydown: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _vm._t("default"),
          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
        ],
        2
      )
    ]
  )
}
var radio_buttonvue_type_template_id_18a77a32_staticRenderFns = []
radio_buttonvue_type_template_id_18a77a32_render._withStripped = true


// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var radio_buttonvue_type_script_lang_js_ = ({
  name: 'ElRadioButton',

  mixins: [emitter_default.a],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  props: {
    label: {},
    disabled: Boolean,
    name: String
  },
  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    value: {
      get: function get() {
        return this._radioGroup.value;
      },
      set: function set(value) {
        this._radioGroup.$emit('input', value);
      }
    },
    _radioGroup: function _radioGroup() {
      var parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'ElRadioGroup') {
          parent = parent.$parent;
        } else {
          return parent;
        }
      }
      return false;
    },
    activeStyle: function activeStyle() {
      return {
        backgroundColor: this._radioGroup.fill || '',
        borderColor: this._radioGroup.fill || '',
        boxShadow: this._radioGroup.fill ? '-1px 0 0 0 ' + this._radioGroup.fill : '',
        color: this._radioGroup.textColor || ''
      };
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    size: function size() {
      return this._radioGroup.radioGroupSize || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    isDisabled: function isDisabled() {
      return this.disabled || this._radioGroup.disabled || (this.elForm || {}).disabled;
    },
    tabIndex: function tabIndex() {
      return this.isDisabled || this._radioGroup && this.value !== this.label ? -1 : 0;
    }
  },

  methods: {
    handleChange: function handleChange() {
      var _this = this;

      this.$nextTick(function () {
        _this.dispatch('ElRadioGroup', 'handleChange', _this.value);
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_radio_buttonvue_type_script_lang_js_ = (radio_buttonvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue





/* normalize component */

var radio_button_component = normalizeComponent(
  src_radio_buttonvue_type_script_lang_js_,
  radio_buttonvue_type_template_id_18a77a32_render,
  radio_buttonvue_type_template_id_18a77a32_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var radio_button_api; }
radio_button_component.options.__file = "packages/radio/src/radio-button.vue"
/* harmony default export */ var radio_button = (radio_button_component.exports);
// CONCATENATED MODULE: ./packages/radio-button/index.js


/* istanbul ignore next */
radio_button.install = function (Vue) {
  Vue.component(radio_button.name, radio_button);
};

/* harmony default export */ var packages_radio_button = (radio_button);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
var checkboxvue_type_template_id_d0387074_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "el-checkbox",
      class: [
        _vm.border && _vm.checkboxSize
          ? "el-checkbox--" + _vm.checkboxSize
          : "",
        { "is-disabled": _vm.isDisabled },
        { "is-bordered": _vm.border },
        { "is-checked": _vm.isChecked }
      ],
      attrs: { id: _vm.id }
    },
    [
      _c(
        "span",
        {
          staticClass: "el-checkbox__input",
          class: {
            "is-disabled": _vm.isDisabled,
            "is-checked": _vm.isChecked,
            "is-indeterminate": _vm.indeterminate,
            "is-focus": _vm.focus
          },
          attrs: {
            tabindex: _vm.indeterminate ? 0 : false,
            role: _vm.indeterminate ? "checkbox" : false,
            "aria-checked": _vm.indeterminate ? "mixed" : false
          }
        },
        [
          _c("span", { staticClass: "el-checkbox__inner" }),
          _vm.trueLabel || _vm.falseLabel
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  }
                ],
                staticClass: "el-checkbox__original",
                attrs: {
                  type: "checkbox",
                  "aria-hidden": _vm.indeterminate ? "true" : "false",
                  name: _vm.name,
                  disabled: _vm.isDisabled,
                  "true-value": _vm.trueLabel,
                  "false-value": _vm.falseLabel
                },
                domProps: {
                  checked: Array.isArray(_vm.model)
                    ? _vm._i(_vm.model, null) > -1
                    : _vm._q(_vm.model, _vm.trueLabel)
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.model,
                        $$el = $event.target,
                        $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.model = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.model = $$c
                      }
                    },
                    _vm.handleChange
                  ],
                  focus: function($event) {
                    _vm.focus = true
                  },
                  blur: function($event) {
                    _vm.focus = false
                  }
                }
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  }
                ],
                staticClass: "el-checkbox__original",
                attrs: {
                  type: "checkbox",
                  "aria-hidden": _vm.indeterminate ? "true" : "false",
                  disabled: _vm.isDisabled,
                  name: _vm.name
                },
                domProps: {
                  value: _vm.label,
                  checked: Array.isArray(_vm.model)
                    ? _vm._i(_vm.model, _vm.label) > -1
                    : _vm.model
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.model,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = _vm.label,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.model = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.model = $$c
                      }
                    },
                    _vm.handleChange
                  ],
                  focus: function($event) {
                    _vm.focus = true
                  },
                  blur: function($event) {
                    _vm.focus = false
                  }
                }
              })
        ]
      ),
      _vm.$slots.default || _vm.label
        ? _c(
            "span",
            { staticClass: "el-checkbox__label" },
            [
              _vm._t("default"),
              !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var checkboxvue_type_template_id_d0387074_staticRenderFns = []
checkboxvue_type_template_id_d0387074_render._withStripped = true


// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
  name: 'ElCheckbox',

  mixins: [emitter_default.a],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  componentName: 'ElCheckbox',

  data: function data() {
    return {
      selfModel: false,
      focus: false,
      isLimitExceeded: false
    };
  },


  computed: {
    model: {
      get: function get() {
        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
      },
      set: function set(val) {
        if (this.isGroup) {
          this.isLimitExceeded = false;
          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);

          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);

          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
          this.selfModel = val;
        }
      }
    },

    isChecked: function isChecked() {
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.model;
      } else if (Array.isArray(this.model)) {
        return this.model.indexOf(this.label) > -1;
      } else if (this.model !== null && this.model !== undefined) {
        return this.model === this.trueLabel;
      }
    },
    isGroup: function isGroup() {
      var parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'ElCheckboxGroup') {
          parent = parent.$parent;
        } else {
          this._checkboxGroup = parent;
          return true;
        }
      }
      return false;
    },
    store: function store() {
      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
    },


    /* used to make the isDisabled judgment under max/min props */
    isLimitDisabled: function isLimitDisabled() {
      var _checkboxGroup = this._checkboxGroup,
          max = _checkboxGroup.max,
          min = _checkboxGroup.min;

      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
    },
    isDisabled: function isDisabled() {
      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    checkboxSize: function checkboxSize() {
      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
    }
  },

  props: {
    value: {},
    label: {},
    indeterminate: Boolean,
    disabled: Boolean,
    checked: Boolean,
    name: String,
    trueLabel: [String, Number],
    falseLabel: [String, Number],
    id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
    controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
    border: Boolean,
    size: String
  },

  methods: {
    addToStore: function addToStore() {
      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
        this.model.push(this.label);
      } else {
        this.model = this.trueLabel || true;
      }
    },
    handleChange: function handleChange(ev) {
      var _this = this;

      if (this.isLimitExceeded) return;
      var value = void 0;
      if (ev.target.checked) {
        value = this.trueLabel === undefined ? true : this.trueLabel;
      } else {
        value = this.falseLabel === undefined ? false : this.falseLabel;
      }
      this.$emit('change', value, ev);
      this.$nextTick(function () {
        if (_this.isGroup) {
          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
        }
      });
    }
  },

  created: function created() {
    this.checked && this.addToStore();
  },
  mounted: function mounted() {
    // 为indeterminate元素 添加aria-controls 属性
    if (this.indeterminate) {
      this.$el.setAttribute('aria-controls', this.controls);
    }
  },


  watch: {
    value: function value(_value) {
      this.dispatch('ElFormItem', 'el.form.change', _value);
    }
  }
});
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue





/* normalize component */

var checkbox_component = normalizeComponent(
  src_checkboxvue_type_script_lang_js_,
  checkboxvue_type_template_id_d0387074_render,
  checkboxvue_type_template_id_d0387074_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var checkbox_api; }
checkbox_component.options.__file = "packages/checkbox/src/checkbox.vue"
/* harmony default export */ var src_checkbox = (checkbox_component.exports);
// CONCATENATED MODULE: ./packages/checkbox/index.js


/* istanbul ignore next */
src_checkbox.install = function (Vue) {
  Vue.component(src_checkbox.name, src_checkbox);
};

/* harmony default export */ var packages_checkbox = (src_checkbox);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&
var checkbox_buttonvue_type_template_id_478e906e_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "el-checkbox-button",
      class: [
        _vm.size ? "el-checkbox-button--" + _vm.size : "",
        { "is-disabled": _vm.isDisabled },
        { "is-checked": _vm.isChecked },
        { "is-focus": _vm.focus }
      ],
      attrs: {
        role: "checkbox",
        "aria-checked": _vm.isChecked,
        "aria-disabled": _vm.isDisabled
      }
    },
    [
      _vm.trueLabel || _vm.falseLabel
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model,
                expression: "model"
              }
            ],
            staticClass: "el-checkbox-button__original",
            attrs: {
              type: "checkbox",
              name: _vm.name,
              disabled: _vm.isDisabled,
              "true-value": _vm.trueLabel,
              "false-value": _vm.falseLabel
            },
            domProps: {
              checked: Array.isArray(_vm.model)
                ? _vm._i(_vm.model, null) > -1
                : _vm._q(_vm.model, _vm.trueLabel)
            },
            on: {
              change: [
                function($event) {
                  var $$a = _vm.model,
                    $$el = $event.target,
                    $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.model = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.model = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.model = $$c
                  }
                },
                _vm.handleChange
              ],
              focus: function($event) {
                _vm.focus = true
              },
              blur: function($event) {
                _vm.focus = false
              }
            }
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model,
                expression: "model"
              }
            ],
            staticClass: "el-checkbox-button__original",
            attrs: {
              type: "checkbox",
              name: _vm.name,
              disabled: _vm.isDisabled
            },
            domProps: {
              value: _vm.label,
              checked: Array.isArray(_vm.model)
                ? _vm._i(_vm.model, _vm.label) > -1
                : _vm.model
            },
            on: {
              change: [
                function($event) {
                  var $$a = _vm.model,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = _vm.label,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.model = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.model = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.model = $$c
                  }
                },
                _vm.handleChange
              ],
              focus: function($event) {
                _vm.focus = true
              },
              blur: function($event) {
                _vm.focus = false
              }
            }
          }),
      _vm.$slots.default || _vm.label
        ? _c(
            "span",
            {
              staticClass: "el-checkbox-button__inner",
              style: _vm.isChecked ? _vm.activeStyle : null
            },
            [_vm._t("default", [_vm._v(_vm._s(_vm.label))])],
            2
          )
        : _vm._e()
    ]
  )
}
var checkbox_buttonvue_type_template_id_478e906e_staticRenderFns = []
checkbox_buttonvue_type_template_id_478e906e_render._withStripped = true


// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var checkbox_buttonvue_type_script_lang_js_ = ({
  name: 'ElCheckboxButton',

  mixins: [emitter_default.a],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  data: function data() {
    return {
      selfModel: false,
      focus: false,
      isLimitExceeded: false
    };
  },


  props: {
    value: {},
    label: {},
    disabled: Boolean,
    checked: Boolean,
    name: String,
    trueLabel: [String, Number],
    falseLabel: [String, Number]
  },
  computed: {
    model: {
      get: function get() {
        return this._checkboxGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
      },
      set: function set(val) {
        if (this._checkboxGroup) {
          this.isLimitExceeded = false;
          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);

          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);

          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
        } else if (this.value !== undefined) {
          this.$emit('input', val);
        } else {
          this.selfModel = val;
        }
      }
    },

    isChecked: function isChecked() {
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.model;
      } else if (Array.isArray(this.model)) {
        return this.model.indexOf(this.label) > -1;
      } else if (this.model !== null && this.model !== undefined) {
        return this.model === this.trueLabel;
      }
    },
    _checkboxGroup: function _checkboxGroup() {
      var parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'ElCheckboxGroup') {
          parent = parent.$parent;
        } else {
          return parent;
        }
      }
      return false;
    },
    store: function store() {
      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
    },
    activeStyle: function activeStyle() {
      return {
        backgroundColor: this._checkboxGroup.fill || '',
        borderColor: this._checkboxGroup.fill || '',
        color: this._checkboxGroup.textColor || '',
        'box-shadow': '-1px 0 0 0 ' + this._checkboxGroup.fill

      };
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    size: function size() {
      return this._checkboxGroup.checkboxGroupSize || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },


    /* used to make the isDisabled judgment under max/min props */
    isLimitDisabled: function isLimitDisabled() {
      var _checkboxGroup2 = this._checkboxGroup,
          max = _checkboxGroup2.max,
          min = _checkboxGroup2.min;

      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
    },
    isDisabled: function isDisabled() {
      return this._checkboxGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
    }
  },
  methods: {
    addToStore: function addToStore() {
      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
        this.model.push(this.label);
      } else {
        this.model = this.trueLabel || true;
      }
    },
    handleChange: function handleChange(ev) {
      var _this = this;

      if (this.isLimitExceeded) return;
      var value = void 0;
      if (ev.target.checked) {
        value = this.trueLabel === undefined ? true : this.trueLabel;
      } else {
        value = this.falseLabel === undefined ? false : this.falseLabel;
      }
      this.$emit('change', value, ev);
      this.$nextTick(function () {
        if (_this._checkboxGroup) {
          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
        }
      });
    }
  },

  created: function created() {
    this.checked && this.addToStore();
  }
});
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_checkbox_buttonvue_type_script_lang_js_ = (checkbox_buttonvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue





/* normalize component */

var checkbox_button_component = normalizeComponent(
  src_checkbox_buttonvue_type_script_lang_js_,
  checkbox_buttonvue_type_template_id_478e906e_render,
  checkbox_buttonvue_type_template_id_478e906e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var checkbox_button_api; }
checkbox_button_component.options.__file = "packages/checkbox/src/checkbox-button.vue"
/* harmony default export */ var checkbox_button = (checkbox_button_component.exports);
// CONCATENATED MODULE: ./packages/checkbox-button/index.js


/* istanbul ignore next */
checkbox_button.install = function (Vue) {
  Vue.component(checkbox_button.name, checkbox_button);
};

/* harmony default export */ var packages_checkbox_button = (checkbox_button);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
var checkbox_groupvue_type_template_id_7289a290_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-checkbox-group",
      attrs: { role: "group", "aria-label": "checkbox-group" }
    },
    [_vm._t("default")],
    2
  )
}
var checkbox_groupvue_type_template_id_7289a290_staticRenderFns = []
checkbox_groupvue_type_template_id_7289a290_render._withStripped = true


// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&



/* harmony default export */ var checkbox_groupvue_type_script_lang_js_ = ({
  name: 'ElCheckboxGroup',

  componentName: 'ElCheckboxGroup',

  mixins: [emitter_default.a],

  inject: {
    elFormItem: {
      default: ''
    }
  },

  props: {
    value: {},
    disabled: Boolean,
    min: Number,
    max: Number,
    size: String,
    fill: String,
    textColor: String
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    checkboxGroupSize: function checkboxGroupSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    }
  },

  watch: {
    value: function value(_value) {
      this.dispatch('ElFormItem', 'el.form.change', [_value]);
    }
  }
});
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_checkbox_groupvue_type_script_lang_js_ = (checkbox_groupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue





/* normalize component */

var checkbox_group_component = normalizeComponent(
  src_checkbox_groupvue_type_script_lang_js_,
  checkbox_groupvue_type_template_id_7289a290_render,
  checkbox_groupvue_type_template_id_7289a290_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var checkbox_group_api; }
checkbox_group_component.options.__file = "packages/checkbox/src/checkbox-group.vue"
/* harmony default export */ var checkbox_group = (checkbox_group_component.exports);
// CONCATENATED MODULE: ./packages/checkbox-group/index.js


/* istanbul ignore next */
checkbox_group.install = function (Vue) {
  Vue.component(checkbox_group.name, checkbox_group);
};

/* harmony default export */ var packages_checkbox_group = (checkbox_group);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&
var componentvue_type_template_id_2dcd8fbb_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-switch",
      class: { "is-disabled": _vm.switchDisabled, "is-checked": _vm.checked },
      attrs: {
        role: "switch",
        "aria-checked": _vm.checked,
        "aria-disabled": _vm.switchDisabled
      },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.switchValue($event)
        }
      }
    },
    [
      _c("input", {
        ref: "input",
        staticClass: "el-switch__input",
        attrs: {
          type: "checkbox",
          id: _vm.id,
          name: _vm.name,
          "true-value": _vm.activeValue,
          "false-value": _vm.inactiveValue,
          disabled: _vm.switchDisabled
        },
        on: {
          change: _vm.handleChange,
          keydown: function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.switchValue($event)
          }
        }
      }),
      _vm.inactiveIconClass || _vm.inactiveText
        ? _c(
            "span",
            {
              class: [
                "el-switch__label",
                "el-switch__label--left",
                !_vm.checked ? "is-active" : ""
              ]
            },
            [
              _vm.inactiveIconClass
                ? _c("i", { class: [_vm.inactiveIconClass] })
                : _vm._e(),
              !_vm.inactiveIconClass && _vm.inactiveText
                ? _c("span", { attrs: { "aria-hidden": _vm.checked } }, [
                    _vm._v(_vm._s(_vm.inactiveText))
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _c("span", {
        ref: "core",
        staticClass: "el-switch__core",
        style: { width: _vm.coreWidth + "px" }
      }),
      _vm.activeIconClass || _vm.activeText
        ? _c(
            "span",
            {
              class: [
                "el-switch__label",
                "el-switch__label--right",
                _vm.checked ? "is-active" : ""
              ]
            },
            [
              _vm.activeIconClass
                ? _c("i", { class: [_vm.activeIconClass] })
                : _vm._e(),
              !_vm.activeIconClass && _vm.activeText
                ? _c("span", { attrs: { "aria-hidden": !_vm.checked } }, [
                    _vm._v(_vm._s(_vm.activeText))
                  ])
                : _vm._e()
            ]
          )
        : _vm._e()
    ]
  )
}
var componentvue_type_template_id_2dcd8fbb_staticRenderFns = []
componentvue_type_template_id_2dcd8fbb_render._withStripped = true


// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var switch_src_componentvue_type_script_lang_js_ = ({
  name: 'ElSwitch',
  mixins: [focus_default()('input'), migrating_default.a, emitter_default.a],
  inject: {
    elForm: {
      default: ''
    }
  },
  props: {
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 40
    },
    activeIconClass: {
      type: String,
      default: ''
    },
    inactiveIconClass: {
      type: String,
      default: ''
    },
    activeText: String,
    inactiveText: String,
    activeColor: {
      type: String,
      default: ''
    },
    inactiveColor: {
      type: String,
      default: ''
    },
    activeValue: {
      type: [Boolean, String, Number],
      default: true
    },
    inactiveValue: {
      type: [Boolean, String, Number],
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    id: String
  },
  data: function data() {
    return {
      coreWidth: this.width
    };
  },
  created: function created() {
    if (!~[this.activeValue, this.inactiveValue].indexOf(this.value)) {
      this.$emit('input', this.inactiveValue);
    }
  },

  computed: {
    checked: function checked() {
      return this.value === this.activeValue;
    },
    switchDisabled: function switchDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },
  watch: {
    checked: function checked() {
      this.$refs.input.checked = this.checked;
      if (this.activeColor || this.inactiveColor) {
        this.setBackgroundColor();
      }
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [this.value]);
      }
    }
  },
  methods: {
    handleChange: function handleChange(event) {
      var _this = this;

      var val = this.checked ? this.inactiveValue : this.activeValue;
      this.$emit('input', val);
      this.$emit('change', val);
      this.$nextTick(function () {
        // set input's checked property
        // in case parent refuses to change component's value
        _this.$refs.input.checked = _this.checked;
      });
    },
    setBackgroundColor: function setBackgroundColor() {
      var newColor = this.checked ? this.activeColor : this.inactiveColor;
      this.$refs.core.style.borderColor = newColor;
      this.$refs.core.style.backgroundColor = newColor;
    },
    switchValue: function switchValue() {
      !this.switchDisabled && this.handleChange();
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'on-color': 'on-color is renamed to active-color.',
          'off-color': 'off-color is renamed to inactive-color.',
          'on-text': 'on-text is renamed to active-text.',
          'off-text': 'off-text is renamed to inactive-text.',
          'on-value': 'on-value is renamed to active-value.',
          'off-value': 'off-value is renamed to inactive-value.',
          'on-icon-class': 'on-icon-class is renamed to active-icon-class.',
          'off-icon-class': 'off-icon-class is renamed to inactive-icon-class.'
        }
      };
    }
  },
  mounted: function mounted() {
    /* istanbul ignore if */
    this.coreWidth = this.width || 40;
    if (this.activeColor || this.inactiveColor) {
      this.setBackgroundColor();
    }
    this.$refs.input.checked = this.checked;
  }
});
// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_switch_src_componentvue_type_script_lang_js_ = (switch_src_componentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/switch/src/component.vue





/* normalize component */

var src_component_component = normalizeComponent(
  packages_switch_src_componentvue_type_script_lang_js_,
  componentvue_type_template_id_2dcd8fbb_render,
  componentvue_type_template_id_2dcd8fbb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var src_component_api; }
src_component_component.options.__file = "packages/switch/src/component.vue"
/* harmony default export */ var switch_src_component = (src_component_component.exports);
// CONCATENATED MODULE: ./packages/switch/index.js


/* istanbul ignore next */
switch_src_component.install = function (Vue) {
  Vue.component(switch_src_component.name, switch_src_component);
};

/* harmony default export */ var packages_switch = (switch_src_component);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
var selectvue_type_template_id_0e4aade6_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.handleClose,
          expression: "handleClose"
        }
      ],
      staticClass: "el-select",
      class: [_vm.selectSize ? "el-select--" + _vm.selectSize : ""],
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.toggleMenu($event)
        }
      }
    },
    [
      _vm.multiple
        ? _c(
            "div",
            {
              ref: "tags",
              staticClass: "el-select__tags",
              style: { "max-width": _vm.inputWidth - 32 + "px", width: "100%" }
            },
            [
              _vm.collapseTags && _vm.selected.length
                ? _c(
                    "span",
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            closable: !_vm.selectDisabled,
                            size: _vm.collapseTagSize,
                            hit: _vm.selected[0].hitState,
                            type: "info",
                            "disable-transitions": ""
                          },
                          on: {
                            close: function($event) {
                              _vm.deleteTag($event, _vm.selected[0])
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "el-select__tags-text" }, [
                            _vm._v(_vm._s(_vm.selected[0].currentLabel))
                          ])
                        ]
                      ),
                      _vm.selected.length > 1
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                closable: false,
                                size: _vm.collapseTagSize,
                                type: "info",
                                "disable-transitions": ""
                              }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "el-select__tags-text" },
                                [_vm._v("+ " + _vm._s(_vm.selected.length - 1))]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.collapseTags
                ? _c(
                    "transition-group",
                    { on: { "after-leave": _vm.resetInputHeight } },
                    _vm._l(_vm.selected, function(item) {
                      return _c(
                        "el-tag",
                        {
                          key: _vm.getValueKey(item),
                          attrs: {
                            closable: !_vm.selectDisabled,
                            size: _vm.collapseTagSize,
                            hit: item.hitState,
                            type: "info",
                            "disable-transitions": ""
                          },
                          on: {
                            close: function($event) {
                              _vm.deleteTag($event, item)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "el-select__tags-text" }, [
                            _vm._v(_vm._s(item.currentLabel))
                          ])
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm.filterable
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.query,
                        expression: "query"
                      }
                    ],
                    ref: "input",
                    staticClass: "el-select__input",
                    class: [_vm.selectSize ? "is-" + _vm.selectSize : ""],
                    style: {
                      "flex-grow": "1",
                      width: _vm.inputLength / (_vm.inputWidth - 32) + "%",
                      "max-width": _vm.inputWidth - 42 + "px"
                    },
                    attrs: {
                      type: "text",
                      disabled: _vm.selectDisabled,
                      autocomplete: _vm.autoComplete || _vm.autocomplete
                    },
                    domProps: { value: _vm.query },
                    on: {
                      focus: _vm.handleFocus,
                      blur: function($event) {
                        _vm.softFocus = false
                      },
                      keyup: _vm.managePlaceholder,
                      keydown: [
                        _vm.resetInputState,
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k($event.keyCode, "down", 40, $event.key, [
                              "Down",
                              "ArrowDown"
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.navigateOptions("next")
                        },
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k($event.keyCode, "up", 38, $event.key, [
                              "Up",
                              "ArrowUp"
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.navigateOptions("prev")
                        },
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.selectOption($event)
                        },
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k($event.keyCode, "esc", 27, $event.key, [
                              "Esc",
                              "Escape"
                            ])
                          ) {
                            return null
                          }
                          $event.stopPropagation()
                          $event.preventDefault()
                          _vm.visible = false
                        },
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k(
                              $event.keyCode,
                              "delete",
                              [8, 46],
                              $event.key,
                              ["Backspace", "Delete", "Del"]
                            )
                          ) {
                            return null
                          }
                          return _vm.deletePrevTag($event)
                        },
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                          ) {
                            return null
                          }
                          _vm.visible = false
                        }
                      ],
                      compositionstart: _vm.handleComposition,
                      compositionupdate: _vm.handleComposition,
                      compositionend: _vm.handleComposition,
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.query = $event.target.value
                        },
                        _vm.debouncedQueryChange
                      ]
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-input",
        {
          ref: "reference",
          class: { "is-focus": _vm.visible },
          attrs: {
            type: "text",
            placeholder: _vm.currentPlaceholder,
            name: _vm.name,
            id: _vm.id,
            autocomplete: _vm.autoComplete || _vm.autocomplete,
            size: _vm.selectSize,
            disabled: _vm.selectDisabled,
            readonly: _vm.readonly,
            "validate-event": false,
            tabindex: _vm.multiple && _vm.filterable ? "-1" : null
          },
          on: { focus: _vm.handleFocus, blur: _vm.handleBlur },
          nativeOn: {
            keyup: function($event) {
              return _vm.debouncedOnInputChange($event)
            },
            keydown: [
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                $event.stopPropagation()
                $event.preventDefault()
                _vm.navigateOptions("next")
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                $event.stopPropagation()
                $event.preventDefault()
                _vm.navigateOptions("prev")
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.selectOption($event)
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape"
                  ])
                ) {
                  return null
                }
                $event.stopPropagation()
                $event.preventDefault()
                _vm.visible = false
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                ) {
                  return null
                }
                _vm.visible = false
              }
            ],
            paste: function($event) {
              return _vm.debouncedOnInputChange($event)
            },
            mouseenter: function($event) {
              _vm.inputHovering = true
            },
            mouseleave: function($event) {
              _vm.inputHovering = false
            }
          },
          model: {
            value: _vm.selectedLabel,
            callback: function($$v) {
              _vm.selectedLabel = $$v
            },
            expression: "selectedLabel"
          }
        },
        [
          _vm.$slots.prefix
            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
            : _vm._e(),
          _c("template", { slot: "suffix" }, [
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showClose,
                  expression: "!showClose"
                }
              ],
              class: [
                "el-select__caret",
                "el-input__icon",
                "el-icon-" + _vm.iconClass
              ]
            }),
            _vm.showClose
              ? _c("i", {
                  staticClass:
                    "el-select__caret el-input__icon el-icon-circle-close",
                  on: { click: _vm.handleClearClick }
                })
              : _vm._e()
          ])
        ],
        2
      ),
      _c(
        "transition",
        {
          attrs: { name: "el-zoom-in-top" },
          on: {
            "before-enter": _vm.handleMenuEnter,
            "after-leave": _vm.doDestroy
          }
        },
        [
          _c(
            "el-select-menu",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible && _vm.emptyText !== false,
                  expression: "visible && emptyText !== false"
                }
              ],
              ref: "popper",
              attrs: { "append-to-body": _vm.popperAppendToBody }
            },
            [
              _c(
                "el-scrollbar",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.options.length > 0 && !_vm.loading,
                      expression: "options.length > 0 && !loading"
                    }
                  ],
                  ref: "scrollbar",
                  class: {
                    "is-empty":
                      !_vm.allowCreate &&
                      _vm.query &&
                      _vm.filteredOptionsCount === 0
                  },
                  attrs: {
                    tag: "ul",
                    "wrap-class": "el-select-dropdown__wrap",
                    "view-class": "el-select-dropdown__list"
                  }
                },
                [
                  _vm.showNewOption
                    ? _c("el-option", {
                        attrs: { value: _vm.query, created: "" }
                      })
                    : _vm._e(),
                  _vm._t("default")
                ],
                2
              ),
              _vm.emptyText &&
              (!_vm.allowCreate ||
                _vm.loading ||
                (_vm.allowCreate && _vm.options.length === 0))
                ? [
                    _vm.$slots.empty
                      ? _vm._t("empty")
                      : _c("p", { staticClass: "el-select-dropdown__empty" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.emptyText) +
                              "\n        "
                          )
                        ])
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var selectvue_type_template_id_0e4aade6_staticRenderFns = []
selectvue_type_template_id_0e4aade6_render._withStripped = true


// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
var select_dropdownvue_type_template_id_06828748_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-select-dropdown el-popper",
      class: [{ "is-multiple": _vm.$parent.multiple }, _vm.popperClass],
      style: { minWidth: _vm.minWidth }
    },
    [_vm._t("default")],
    2
  )
}
var select_dropdownvue_type_template_id_06828748_staticRenderFns = []
select_dropdownvue_type_template_id_06828748_render._withStripped = true


// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//



/* harmony default export */ var select_dropdownvue_type_script_lang_js_ = ({
  name: 'ElSelectDropdown',

  componentName: 'ElSelectDropdown',

  mixins: [vue_popper_default.a],

  props: {
    placement: {
      default: 'bottom-start'
    },

    boundariesPadding: {
      default: 0
    },

    popperOptions: {
      default: function _default() {
        return {
          gpuAcceleration: false
        };
      }
    },

    visibleArrow: {
      default: true
    },

    appendToBody: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      minWidth: ''
    };
  },


  computed: {
    popperClass: function popperClass() {
      return this.$parent.popperClass;
    }
  },

  watch: {
    '$parent.inputWidth': function $parentInputWidth() {
      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.referenceElm = this.$parent.$refs.reference.$el;
    this.$parent.popperElm = this.popperElm = this.$el;
    this.$on('updatePopper', function () {
      if (_this.$parent.visible) _this.updatePopper();
    });
    this.$on('destroyPopper', this.destroyPopper);
  }
});
// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_select_dropdownvue_type_script_lang_js_ = (select_dropdownvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue





/* normalize component */

var select_dropdown_component = normalizeComponent(
  src_select_dropdownvue_type_script_lang_js_,
  select_dropdownvue_type_template_id_06828748_render,
  select_dropdownvue_type_template_id_06828748_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var select_dropdown_api; }
select_dropdown_component.options.__file = "packages/select/src/select-dropdown.vue"
/* harmony default export */ var select_dropdown = (select_dropdown_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
var optionvue_type_template_id_7a44c642_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      staticClass: "el-select-dropdown__item",
      class: {
        selected: _vm.itemSelected,
        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
        hover: _vm.hover
      },
      on: {
        mouseenter: _vm.hoverItem,
        click: function($event) {
          $event.stopPropagation()
          return _vm.selectOptionClick($event)
        }
      }
    },
    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
    2
  )
}
var optionvue_type_template_id_7a44c642_staticRenderFns = []
optionvue_type_template_id_7a44c642_render._withStripped = true


// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var optionvue_type_script_lang_js_ = ({
  mixins: [emitter_default.a],

  name: 'ElOption',

  componentName: 'ElOption',

  inject: ['select'],

  props: {
    value: {
      required: true
    },
    label: [String, Number],
    created: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      index: -1,
      groupDisabled: false,
      visible: true,
      hitState: false,
      hover: false
    };
  },


  computed: {
    isObject: function isObject() {
      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
    },
    currentLabel: function currentLabel() {
      return this.label || (this.isObject ? '' : this.value);
    },
    currentValue: function currentValue() {
      return this.value || this.label || '';
    },
    itemSelected: function itemSelected() {
      if (!this.select.multiple) {
        return this.isEqual(this.value, this.select.value);
      } else {
        return this.contains(this.select.value, this.value);
      }
    },
    limitReached: function limitReached() {
      if (this.select.multiple) {
        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
      } else {
        return false;
      }
    }
  },

  watch: {
    currentLabel: function currentLabel() {
      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
    },
    value: function value(val, oldVal) {
      var _select = this.select,
          remote = _select.remote,
          valueKey = _select.valueKey;

      if (!this.created && !remote) {
        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
          return;
        }
        this.dispatch('ElSelect', 'setSelected');
      }
    }
  },

  methods: {
    isEqual: function isEqual(a, b) {
      if (!this.isObject) {
        return a === b;
      } else {
        var valueKey = this.select.valueKey;
        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
      }
    },
    contains: function contains() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var target = arguments[1];

      if (!this.isObject) {
        return arr && arr.indexOf(target) > -1;
      } else {
        var valueKey = this.select.valueKey;
        return arr && arr.some(function (item) {
          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
        });
      }
    },
    handleGroupDisabled: function handleGroupDisabled(val) {
      this.groupDisabled = val;
    },
    hoverItem: function hoverItem() {
      if (!this.disabled && !this.groupDisabled) {
        this.select.hoverIndex = this.select.options.indexOf(this);
      }
    },
    selectOptionClick: function selectOptionClick() {
      if (this.disabled !== true && this.groupDisabled !== true) {
        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
      }
    },
    queryChange: function queryChange(query) {
      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
      if (!this.visible) {
        this.select.filteredOptionsCount--;
      }
    }
  },

  created: function created() {
    this.select.options.push(this);
    this.select.cachedOptions.push(this);
    this.select.optionsCount++;
    this.select.filteredOptionsCount++;

    this.$on('queryChange', this.queryChange);
    this.$on('handleGroupDisabled', this.handleGroupDisabled);
  },
  beforeDestroy: function beforeDestroy() {
    var _select2 = this.select,
        selected = _select2.selected,
        multiple = _select2.multiple;

    var selectedOptions = multiple ? selected : [selected];
    var index = this.select.cachedOptions.indexOf(this);
    var selectedIndex = selectedOptions.indexOf(this);

    // if option is not selected, remove it from cache
    if (index > -1 && selectedIndex < 0) {
      this.select.cachedOptions.splice(index, 1);
    }
    this.select.onOptionDestroy(this.select.options.indexOf(this));
  }
});
// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/select/src/option.vue





/* normalize component */

var option_component = normalizeComponent(
  src_optionvue_type_script_lang_js_,
  optionvue_type_template_id_7a44c642_render,
  optionvue_type_template_id_7a44c642_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var option_api; }
option_component.options.__file = "packages/select/src/option.vue"
/* harmony default export */ var src_option = (option_component.exports);
// EXTERNAL MODULE: external "element-ui/lib/tag"
var tag_ = __webpack_require__(30);
var tag_default = /*#__PURE__*/__webpack_require__.n(tag_);

// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
var resize_event_ = __webpack_require__(13);

// EXTERNAL MODULE: external "element-ui/lib/locale"
var lib_locale_ = __webpack_require__(11);
var lib_locale_default = /*#__PURE__*/__webpack_require__.n(lib_locale_);

// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
var scroll_into_view_ = __webpack_require__(27);
var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);

// CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
/* harmony default export */ var navigation_mixin = ({
  data: function data() {
    return {
      hoverOption: -1
    };
  },


  computed: {
    optionsAllDisabled: function optionsAllDisabled() {
      return this.options.filter(function (option) {
        return option.visible;
      }).every(function (option) {
        return option.disabled;
      });
    }
  },

  watch: {
    hoverIndex: function hoverIndex(val) {
      var _this = this;

      if (typeof val === 'number' && val > -1) {
        this.hoverOption = this.options[val] || {};
      }
      this.options.forEach(function (option) {
        option.hover = _this.hoverOption === option;
      });
    }
  },

  methods: {
    navigateOptions: function navigateOptions(direction) {
      var _this2 = this;

      if (!this.visible) {
        this.visible = true;
        return;
      }
      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
      if (!this.optionsAllDisabled) {
        if (direction === 'next') {
          this.hoverIndex++;
          if (this.hoverIndex === this.options.length) {
            this.hoverIndex = 0;
          }
        } else if (direction === 'prev') {
          this.hoverIndex--;
          if (this.hoverIndex < 0) {
            this.hoverIndex = this.options.length - 1;
          }
        }
        var option = this.options[this.hoverIndex];
        if (option.disabled === true || option.groupDisabled === true || !option.visible) {
          this.navigateOptions(direction);
        }
        this.$nextTick(function () {
          return _this2.scrollToOption(_this2.hoverOption);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ var selectvue_type_script_lang_js_ = ({
  mixins: [emitter_default.a, locale_default.a, focus_default()('reference'), navigation_mixin],

  name: 'ElSelect',

  componentName: 'ElSelect',

  inject: {
    elForm: {
      default: ''
    },

    elFormItem: {
      default: ''
    }
  },

  provide: function provide() {
    return {
      'select': this
    };
  },


  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    readonly: function readonly() {
      return !this.filterable || this.multiple || !Object(util_["isIE"])() && !Object(util_["isEdge"])() && !this.visible;
    },
    showClose: function showClose() {
      var hasValue = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== undefined && this.value !== null && this.value !== '';
      var criteria = this.clearable && !this.selectDisabled && this.inputHovering && hasValue;
      return criteria;
    },
    iconClass: function iconClass() {
      return this.remote && this.filterable ? '' : this.visible ? 'arrow-up is-reverse' : 'arrow-up';
    },
    debounce: function debounce() {
      return this.remote ? 300 : 0;
    },
    emptyText: function emptyText() {
      if (this.loading) {
        return this.loadingText || this.t('el.select.loading');
      } else {
        if (this.remote && this.query === '' && this.options.length === 0) return false;
        if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
          return this.noMatchText || this.t('el.select.noMatch');
        }
        if (this.options.length === 0) {
          return this.noDataText || this.t('el.select.noData');
        }
      }
      return null;
    },
    showNewOption: function showNewOption() {
      var _this = this;

      var hasExistingOption = this.options.filter(function (option) {
        return !option.created;
      }).some(function (option) {
        return option.currentLabel === _this.query;
      });
      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
    },
    selectSize: function selectSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    selectDisabled: function selectDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    collapseTagSize: function collapseTagSize() {
      return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
    }
  },

  components: {
    ElInput: input_default.a,
    ElSelectMenu: select_dropdown,
    ElOption: src_option,
    ElTag: tag_default.a,
    ElScrollbar: scrollbar_default.a
  },

  directives: { Clickoutside: clickoutside_default.a },

  props: {
    name: String,
    id: String,
    value: {
      required: true
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    /** @Deprecated in next major version */
    autoComplete: {
      type: String,
      validator: function validator(val) {
         false && false;
        return true;
      }
    },
    automaticDropdown: Boolean,
    size: String,
    disabled: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    allowCreate: Boolean,
    loading: Boolean,
    popperClass: String,
    remote: Boolean,
    loadingText: String,
    noMatchText: String,
    noDataText: String,
    remoteMethod: Function,
    filterMethod: Function,
    multiple: Boolean,
    multipleLimit: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: function _default() {
        return Object(lib_locale_["t"])('el.select.placeholder');
      }
    },
    defaultFirstOption: Boolean,
    reserveKeyword: Boolean,
    valueKey: {
      type: String,
      default: 'value'
    },
    collapseTags: Boolean,
    popperAppendToBody: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      options: [],
      cachedOptions: [],
      createdLabel: null,
      createdSelected: false,
      selected: this.multiple ? [] : {},
      inputLength: 20,
      inputWidth: 0,
      initialInputHeight: 0,
      cachedPlaceHolder: '',
      optionsCount: 0,
      filteredOptionsCount: 0,
      visible: false,
      softFocus: false,
      selectedLabel: '',
      hoverIndex: -1,
      query: '',
      previousQuery: null,
      inputHovering: false,
      currentPlaceholder: '',
      menuVisibleOnFocus: false,
      isOnComposition: false,
      isSilentBlur: false
    };
  },


  watch: {
    selectDisabled: function selectDisabled() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.resetInputHeight();
      });
    },
    placeholder: function placeholder(val) {
      this.cachedPlaceHolder = this.currentPlaceholder = val;
    },
    value: function value(val, oldVal) {
      if (this.multiple) {
        this.resetInputHeight();
        if (val && val.length > 0 || this.$refs.input && this.query !== '') {
          this.currentPlaceholder = '';
        } else {
          this.currentPlaceholder = this.cachedPlaceHolder;
        }
        if (this.filterable && !this.reserveKeyword) {
          this.query = '';
          this.handleQueryChange(this.query);
        }
      }
      this.setSelected();
      if (this.filterable && !this.multiple) {
        this.inputLength = 20;
      }
      if (!Object(util_["valueEquals"])(val, oldVal)) {
        this.dispatch('ElFormItem', 'el.form.change', val);
      }
    },
    visible: function visible(val) {
      var _this3 = this;

      if (!val) {
        this.broadcast('ElSelectDropdown', 'destroyPopper');
        if (this.$refs.input) {
          this.$refs.input.blur();
        }
        this.query = '';
        this.previousQuery = null;
        this.selectedLabel = '';
        this.inputLength = 20;
        this.menuVisibleOnFocus = false;
        this.resetHoverIndex();
        this.$nextTick(function () {
          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
          }
        });
        if (!this.multiple) {
          if (this.selected) {
            if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
              this.selectedLabel = this.createdLabel;
            } else {
              this.selectedLabel = this.selected.currentLabel;
            }
            if (this.filterable) this.query = this.selectedLabel;
          }

          if (this.filterable) {
            this.currentPlaceholder = this.cachedPlaceHolder;
          }
        }
      } else {
        this.broadcast('ElSelectDropdown', 'updatePopper');
        if (this.filterable) {
          this.query = this.remote ? '' : this.selectedLabel;
          this.handleQueryChange(this.query);
          if (this.multiple) {
            this.$refs.input.focus();
          } else {
            if (!this.remote) {
              this.broadcast('ElOption', 'queryChange', '');
              this.broadcast('ElOptionGroup', 'queryChange');
            }

            if (this.selectedLabel) {
              this.currentPlaceholder = this.selectedLabel;
              this.selectedLabel = '';
            }
          }
        }
      }
      this.$emit('visible-change', val);
    },
    options: function options() {
      var _this4 = this;

      if (this.$isServer) return;
      this.$nextTick(function () {
        _this4.broadcast('ElSelectDropdown', 'updatePopper');
      });
      if (this.multiple) {
        this.resetInputHeight();
      }
      var inputs = this.$el.querySelectorAll('input');
      if ([].indexOf.call(inputs, document.activeElement) === -1) {
        this.setSelected();
      }
      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
        this.checkDefaultFirstOption();
      }
    }
  },

  methods: {
    handleComposition: function handleComposition(event) {
      var _this5 = this;

      var text = event.target.value;
      if (event.type === 'compositionend') {
        this.isOnComposition = false;
        this.$nextTick(function (_) {
          return _this5.handleQueryChange(text);
        });
      } else {
        var lastCharacter = text[text.length - 1] || '';
        this.isOnComposition = !Object(shared_["isKorean"])(lastCharacter);
      }
    },
    handleQueryChange: function handleQueryChange(val) {
      var _this6 = this;

      if (this.previousQuery === val || this.isOnComposition) return;
      if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
        this.previousQuery = val;
        return;
      }
      this.previousQuery = val;
      this.$nextTick(function () {
        if (_this6.visible) _this6.broadcast('ElSelectDropdown', 'updatePopper');
      });
      this.hoverIndex = -1;
      if (this.multiple && this.filterable) {
        this.$nextTick(function () {
          var length = _this6.$refs.input.value.length * 15 + 20;
          _this6.inputLength = _this6.collapseTags ? Math.min(50, length) : length;
          _this6.managePlaceholder();
          _this6.resetInputHeight();
        });
      }
      if (this.remote && typeof this.remoteMethod === 'function') {
        this.hoverIndex = -1;
        this.remoteMethod(val);
      } else if (typeof this.filterMethod === 'function') {
        this.filterMethod(val);
        this.broadcast('ElOptionGroup', 'queryChange');
      } else {
        this.filteredOptionsCount = this.optionsCount;
        this.broadcast('ElOption', 'queryChange', val);
        this.broadcast('ElOptionGroup', 'queryChange');
      }
      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
        this.checkDefaultFirstOption();
      }
    },
    scrollToOption: function scrollToOption(option) {
      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
      if (this.$refs.popper && target) {
        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
        scroll_into_view_default()(menu, target);
      }
      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
    },
    handleMenuEnter: function handleMenuEnter() {
      var _this7 = this;

      this.$nextTick(function () {
        return _this7.scrollToOption(_this7.selected);
      });
    },
    emitChange: function emitChange(val) {
      if (!Object(util_["valueEquals"])(this.value, val)) {
        this.$emit('change', val);
      }
    },
    getOption: function getOption(value) {
      var option = void 0;
      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
      var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
      var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';

      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
        var cachedOption = this.cachedOptions[i];
        var isEqual = isObject ? Object(util_["getValueByPath"])(cachedOption.value, this.valueKey) === Object(util_["getValueByPath"])(value, this.valueKey) : cachedOption.value === value;
        if (isEqual) {
          option = cachedOption;
          break;
        }
      }
      if (option) return option;
      var label = !isObject && !isNull && !isUndefined ? value : '';
      var newOption = {
        value: value,
        currentLabel: label
      };
      if (this.multiple) {
        newOption.hitState = false;
      }
      return newOption;
    },
    setSelected: function setSelected() {
      var _this8 = this;

      if (!this.multiple) {
        var option = this.getOption(this.value);
        if (option.created) {
          this.createdLabel = option.currentLabel;
          this.createdSelected = true;
        } else {
          this.createdSelected = false;
        }
        this.selectedLabel = option.currentLabel;
        this.selected = option;
        if (this.filterable) this.query = this.selectedLabel;
        return;
      }
      var result = [];
      if (Array.isArray(this.value)) {
        this.value.forEach(function (value) {
          result.push(_this8.getOption(value));
        });
      }
      this.selected = result;
      this.$nextTick(function () {
        _this8.resetInputHeight();
      });
    },
    handleFocus: function handleFocus(event) {
      if (!this.softFocus) {
        if (this.automaticDropdown || this.filterable) {
          this.visible = true;
          if (this.filterable) {
            this.menuVisibleOnFocus = true;
          }
        }
        this.$emit('focus', event);
      } else {
        this.softFocus = false;
      }
    },
    blur: function blur() {
      this.visible = false;
      this.$refs.reference.blur();
    },
    handleBlur: function handleBlur(event) {
      var _this9 = this;

      setTimeout(function () {
        if (_this9.isSilentBlur) {
          _this9.isSilentBlur = false;
        } else {
          _this9.$emit('blur', event);
        }
      }, 50);
      this.softFocus = false;
    },
    handleClearClick: function handleClearClick(event) {
      this.deleteSelected(event);
    },
    doDestroy: function doDestroy() {
      this.$refs.popper && this.$refs.popper.doDestroy();
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
      if (!Array.isArray(this.selected)) return;
      var option = this.selected[this.selected.length - 1];
      if (!option) return;

      if (hit === true || hit === false) {
        option.hitState = hit;
        return hit;
      }

      option.hitState = !option.hitState;
      return option.hitState;
    },
    deletePrevTag: function deletePrevTag(e) {
      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
        var value = this.value.slice();
        value.pop();
        this.$emit('input', value);
        this.emitChange(value);
      }
    },
    managePlaceholder: function managePlaceholder() {
      if (this.currentPlaceholder !== '') {
        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
      }
    },
    resetInputState: function resetInputState(e) {
      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
      this.inputLength = this.$refs.input.value.length * 15 + 20;
      this.resetInputHeight();
    },
    resetInputHeight: function resetInputHeight() {
      var _this10 = this;

      if (this.collapseTags && !this.filterable) return;
      this.$nextTick(function () {
        if (!_this10.$refs.reference) return;
        var inputChildNodes = _this10.$refs.reference.$el.childNodes;
        var input = [].filter.call(inputChildNodes, function (item) {
          return item.tagName === 'INPUT';
        })[0];
        var tags = _this10.$refs.tags;
        var sizeInMap = _this10.initialInputHeight || 40;
        input.style.height = _this10.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
        if (_this10.visible && _this10.emptyText !== false) {
          _this10.broadcast('ElSelectDropdown', 'updatePopper');
        }
      });
    },
    resetHoverIndex: function resetHoverIndex() {
      var _this11 = this;

      setTimeout(function () {
        if (!_this11.multiple) {
          _this11.hoverIndex = _this11.options.indexOf(_this11.selected);
        } else {
          if (_this11.selected.length > 0) {
            _this11.hoverIndex = Math.min.apply(null, _this11.selected.map(function (item) {
              return _this11.options.indexOf(item);
            }));
          } else {
            _this11.hoverIndex = -1;
          }
        }
      }, 300);
    },
    handleOptionSelect: function handleOptionSelect(option, byClick) {
      var _this12 = this;

      if (this.multiple) {
        var value = (this.value || []).slice();
        var optionIndex = this.getValueIndex(value, option.value);
        if (optionIndex > -1) {
          value.splice(optionIndex, 1);
        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
          value.push(option.value);
        }
        this.$emit('input', value);
        this.emitChange(value);
        if (option.created) {
          this.query = '';
          this.handleQueryChange('');
          this.inputLength = 20;
        }
        if (this.filterable) this.$refs.input.focus();
      } else {
        this.$emit('input', option.value);
        this.emitChange(option.value);
        this.visible = false;
      }
      this.isSilentBlur = byClick;
      this.setSoftFocus();
      if (this.visible) return;
      this.$nextTick(function () {
        _this12.scrollToOption(option);
      });
    },
    setSoftFocus: function setSoftFocus() {
      this.softFocus = true;
      var input = this.$refs.input || this.$refs.reference;
      if (input) {
        input.focus();
      }
    },
    getValueIndex: function getValueIndex() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var value = arguments[1];

      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
      if (!isObject) {
        return arr.indexOf(value);
      } else {
        var valueKey = this.valueKey;
        var index = -1;
        arr.some(function (item, i) {
          if (Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(value, valueKey)) {
            index = i;
            return true;
          }
          return false;
        });
        return index;
      }
    },
    toggleMenu: function toggleMenu() {
      if (!this.selectDisabled) {
        if (this.menuVisibleOnFocus) {
          this.menuVisibleOnFocus = false;
        } else {
          this.visible = !this.visible;
        }
        if (this.visible) {
          (this.$refs.input || this.$refs.reference).focus();
        }
      }
    },
    selectOption: function selectOption() {
      if (!this.visible) {
        this.toggleMenu();
      } else {
        if (this.options[this.hoverIndex]) {
          this.handleOptionSelect(this.options[this.hoverIndex]);
        }
      }
    },
    deleteSelected: function deleteSelected(event) {
      event.stopPropagation();
      var value = this.multiple ? [] : '';
      this.$emit('input', value);
      this.emitChange(value);
      this.visible = false;
      this.$emit('clear');
    },
    deleteTag: function deleteTag(event, tag) {
      var index = this.selected.indexOf(tag);
      if (index > -1 && !this.selectDisabled) {
        var value = this.value.slice();
        value.splice(index, 1);
        this.$emit('input', value);
        this.emitChange(value);
        this.$emit('remove-tag', tag.value);
      }
      event.stopPropagation();
    },
    onInputChange: function onInputChange() {
      if (this.filterable && this.query !== this.selectedLabel) {
        this.query = this.selectedLabel;
        this.handleQueryChange(this.query);
      }
    },
    onOptionDestroy: function onOptionDestroy(index) {
      if (index > -1) {
        this.optionsCount--;
        this.filteredOptionsCount--;
        this.options.splice(index, 1);
      }
    },
    resetInputWidth: function resetInputWidth() {
      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
    },
    handleResize: function handleResize() {
      this.resetInputWidth();
      if (this.multiple) this.resetInputHeight();
    },
    checkDefaultFirstOption: function checkDefaultFirstOption() {
      this.hoverIndex = -1;
      // highlight the created option
      var hasCreated = false;
      for (var i = this.options.length - 1; i >= 0; i--) {
        if (this.options[i].created) {
          hasCreated = true;
          this.hoverIndex = i;
          break;
        }
      }
      if (hasCreated) return;
      for (var _i = 0; _i !== this.options.length; ++_i) {
        var option = this.options[_i];
        if (this.query) {
          // highlight first options that passes the filter
          if (!option.disabled && !option.groupDisabled && option.visible) {
            this.hoverIndex = _i;
            break;
          }
        } else {
          // highlight currently selected option
          if (option.itemSelected) {
            this.hoverIndex = _i;
            break;
          }
        }
      }
    },
    getValueKey: function getValueKey(item) {
      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
        return item.value;
      } else {
        return Object(util_["getValueByPath"])(item.value, this.valueKey);
      }
    }
  },

  created: function created() {
    var _this13 = this;

    this.cachedPlaceHolder = this.currentPlaceholder = this.placeholder;
    if (this.multiple && !Array.isArray(this.value)) {
      this.$emit('input', []);
    }
    if (!this.multiple && Array.isArray(this.value)) {
      this.$emit('input', '');
    }

    this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
      _this13.onInputChange();
    });

    this.debouncedQueryChange = debounce_default()(this.debounce, function (e) {
      _this13.handleQueryChange(e.target.value);
    });

    this.$on('handleOptionClick', this.handleOptionSelect);
    this.$on('setSelected', this.setSelected);
  },
  mounted: function mounted() {
    var _this14 = this;

    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
      this.currentPlaceholder = '';
    }
    Object(resize_event_["addResizeListener"])(this.$el, this.handleResize);

    var reference = this.$refs.reference;
    if (reference && reference.$el) {
      var sizeMap = {
        medium: 36,
        small: 32,
        mini: 28
      };
      var input = reference.$el.querySelector('input');
      this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.selectSize];
    }
    if (this.remote && this.multiple) {
      this.resetInputHeight();
    }
    this.$nextTick(function () {
      if (reference && reference.$el) {
        _this14.inputWidth = reference.$el.getBoundingClientRect().width;
      }
    });
    this.setSelected();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el && this.handleResize) Object(resize_event_["removeResizeListener"])(this.$el, this.handleResize);
  }
});
// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_selectvue_type_script_lang_js_ = (selectvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/select/src/select.vue





/* normalize component */

var select_component = normalizeComponent(
  src_selectvue_type_script_lang_js_,
  selectvue_type_template_id_0e4aade6_render,
  selectvue_type_template_id_0e4aade6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var select_api; }
select_component.options.__file = "packages/select/src/select.vue"
/* harmony default export */ var src_select = (select_component.exports);
// CONCATENATED MODULE: ./packages/select/index.js


/* istanbul ignore next */
src_select.install = function (Vue) {
  Vue.component(src_select.name, src_select);
};

/* harmony default export */ var packages_select = (src_select);
// CONCATENATED MODULE: ./packages/option/index.js


/* istanbul ignore next */
src_option.install = function (Vue) {
  Vue.component(src_option.name, src_option);
};

/* harmony default export */ var packages_option = (src_option);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&
var option_groupvue_type_template_id_6685e5de_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      staticClass: "el-select-group__wrap"
    },
    [
      _c("li", { staticClass: "el-select-group__title" }, [
        _vm._v(_vm._s(_vm.label))
      ]),
      _c("li", [
        _c("ul", { staticClass: "el-select-group" }, [_vm._t("default")], 2)
      ])
    ]
  )
}
var option_groupvue_type_template_id_6685e5de_staticRenderFns = []
option_groupvue_type_template_id_6685e5de_render._withStripped = true


// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var option_groupvue_type_script_lang_js_ = ({
  mixins: [emitter_default.a],

  name: 'ElOptionGroup',

  componentName: 'ElOptionGroup',

  props: {
    label: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      visible: true
    };
  },


  watch: {
    disabled: function disabled(val) {
      this.broadcast('ElOption', 'handleGroupDisabled', val);
    }
  },

  methods: {
    queryChange: function queryChange() {
      this.visible = this.$children && Array.isArray(this.$children) && this.$children.some(function (option) {
        return option.visible === true;
      });
    }
  },

  created: function created() {
    this.$on('queryChange', this.queryChange);
  },
  mounted: function mounted() {
    if (this.disabled) {
      this.broadcast('ElOption', 'handleGroupDisabled', this.disabled);
    }
  }
});
// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_option_groupvue_type_script_lang_js_ = (option_groupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/select/src/option-group.vue





/* normalize component */

var option_group_component = normalizeComponent(
  src_option_groupvue_type_script_lang_js_,
  option_groupvue_type_template_id_6685e5de_render,
  option_groupvue_type_template_id_6685e5de_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var option_group_api; }
option_group_component.options.__file = "packages/select/src/option-group.vue"
/* harmony default export */ var option_group = (option_group_component.exports);
// CONCATENATED MODULE: ./packages/option-group/index.js


/* istanbul ignore next */
option_group.install = function (Vue) {
  Vue.component(option_group.name, option_group);
};

/* harmony default export */ var packages_option_group = (option_group);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
var buttonvue_type_template_id_ca859fb4_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "el-button",
      class: [
        _vm.type ? "el-button--" + _vm.type : "",
        _vm.buttonSize ? "el-button--" + _vm.buttonSize : "",
        {
          "is-disabled": _vm.buttonDisabled,
          "is-loading": _vm.loading,
          "is-plain": _vm.plain,
          "is-round": _vm.round,
          "is-circle": _vm.circle
        }
      ],
      attrs: {
        disabled: _vm.buttonDisabled || _vm.loading,
        autofocus: _vm.autofocus,
        type: _vm.nativeType
      },
      on: { click: _vm.handleClick }
    },
    [
      _vm.loading ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(),
      _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(),
      _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()
    ]
  )
}
var buttonvue_type_template_id_ca859fb4_staticRenderFns = []
buttonvue_type_template_id_ca859fb4_render._withStripped = true


// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
  name: 'ElButton',

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize: function buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    buttonDisabled: function buttonDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
});
// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/button/src/button.vue





/* normalize component */

var button_component = normalizeComponent(
  src_buttonvue_type_script_lang_js_,
  buttonvue_type_template_id_ca859fb4_render,
  buttonvue_type_template_id_ca859fb4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var button_api; }
button_component.options.__file = "packages/button/src/button.vue"
/* harmony default export */ var src_button = (button_component.exports);
// CONCATENATED MODULE: ./packages/button/index.js


/* istanbul ignore next */
src_button.install = function (Vue) {
  Vue.component(src_button.name, src_button);
};

/* harmony default export */ var packages_button = (src_button);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
var button_groupvue_type_template_id_3d8661d0_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-button-group" }, [_vm._t("default")], 2)
}
var button_groupvue_type_template_id_3d8661d0_staticRenderFns = []
button_groupvue_type_template_id_3d8661d0_render._withStripped = true


// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
//
//
//
//
//

/* harmony default export */ var button_groupvue_type_script_lang_js_ = ({
  name: 'ElButtonGroup'
});
// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_button_groupvue_type_script_lang_js_ = (button_groupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/button/src/button-group.vue





/* normalize component */

var button_group_component = normalizeComponent(
  src_button_groupvue_type_script_lang_js_,
  button_groupvue_type_template_id_3d8661d0_render,
  button_groupvue_type_template_id_3d8661d0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var button_group_api; }
button_group_component.options.__file = "packages/button/src/button-group.vue"
/* harmony default export */ var button_group = (button_group_component.exports);
// CONCATENATED MODULE: ./packages/button-group/index.js


/* istanbul ignore next */
button_group.install = function (Vue) {
  Vue.component(button_group.name, button_group);
};

/* harmony default export */ var packages_button_group = (button_group);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=template&id=493fe34e&
var tablevue_type_template_id_493fe34e_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-table",
      class: [
        {
          "el-table--fit": _vm.fit,
          "el-table--striped": _vm.stripe,
          "el-table--border": _vm.border || _vm.isGroup,
          "el-table--hidden": _vm.isHidden,
          "el-table--group": _vm.isGroup,
          "el-table--fluid-height": _vm.maxHeight,
          "el-table--scrollable-x": _vm.layout.scrollX,
          "el-table--scrollable-y": _vm.layout.scrollY,
          "el-table--enable-row-hover": !_vm.store.states.isComplex,
          "el-table--enable-row-transition":
            (_vm.store.states.data || []).length !== 0 &&
            (_vm.store.states.data || []).length < 100
        },
        _vm.tableSize ? "el-table--" + _vm.tableSize : ""
      ],
      on: {
        mouseleave: function($event) {
          _vm.handleMouseLeave($event)
        }
      }
    },
    [
      _c(
        "div",
        { ref: "hiddenColumns", staticClass: "hidden-columns" },
        [_vm._t("default")],
        2
      ),
      _vm.showHeader
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "mousewheel",
                  rawName: "v-mousewheel",
                  value: _vm.handleHeaderFooterMousewheel,
                  expression: "handleHeaderFooterMousewheel"
                }
              ],
              ref: "headerWrapper",
              staticClass: "el-table__header-wrapper"
            },
            [
              _c("table-header", {
                ref: "tableHeader",
                style: {
                  width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + "px" : ""
                },
                attrs: {
                  store: _vm.store,
                  border: _vm.border,
                  "default-sort": _vm.defaultSort
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          ref: "bodyWrapper",
          staticClass: "el-table__body-wrapper",
          class: [
            _vm.layout.scrollX
              ? "is-scrolling-" + _vm.scrollPosition
              : "is-scrolling-none"
          ],
          style: [_vm.bodyHeight]
        },
        [
          _c("table-body", {
            style: {
              width: _vm.bodyWidth
            },
            attrs: {
              context: _vm.context,
              store: _vm.store,
              stripe: _vm.stripe,
              "row-class-name": _vm.rowClassName,
              "row-style": _vm.rowStyle,
              highlight: _vm.highlightCurrentRow
            }
          }),
          !_vm.data || _vm.data.length === 0
            ? _c(
                "div",
                {
                  ref: "emptyBlock",
                  staticClass: "el-table__empty-block",
                  style: _vm.emptyBlockStyle
                },
                [
                  _c(
                    "span",
                    { staticClass: "el-table__empty-text" },
                    [
                      _vm._t("empty", [
                        _vm._v(
                          _vm._s(_vm.emptyText || _vm.t("el.table.emptyText"))
                        )
                      ])
                    ],
                    2
                  )
                ]
              )
            : _vm._e(),
          _vm.$slots.append
            ? _c(
                "div",
                {
                  ref: "appendWrapper",
                  staticClass: "el-table__append-wrapper"
                },
                [_vm._t("append")],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm.showSummary
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.data && _vm.data.length > 0,
                  expression: "data && data.length > 0"
                },
                {
                  name: "mousewheel",
                  rawName: "v-mousewheel",
                  value: _vm.handleHeaderFooterMousewheel,
                  expression: "handleHeaderFooterMousewheel"
                }
              ],
              ref: "footerWrapper",
              staticClass: "el-table__footer-wrapper"
            },
            [
              _c("table-footer", {
                style: {
                  width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + "px" : ""
                },
                attrs: {
                  store: _vm.store,
                  border: _vm.border,
                  "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
                  "summary-method": _vm.summaryMethod,
                  "default-sort": _vm.defaultSort
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.fixedColumns.length > 0
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "mousewheel",
                  rawName: "v-mousewheel",
                  value: _vm.handleFixedMousewheel,
                  expression: "handleFixedMousewheel"
                }
              ],
              ref: "fixedWrapper",
              staticClass: "el-table__fixed",
              style: [
                {
                  width: _vm.layout.fixedWidth
                    ? _vm.layout.fixedWidth + "px"
                    : ""
                },
                _vm.fixedHeight
              ]
            },
            [
              _vm.showHeader
                ? _c(
                    "div",
                    {
                      ref: "fixedHeaderWrapper",
                      staticClass: "el-table__fixed-header-wrapper"
                    },
                    [
                      _c("table-header", {
                        ref: "fixedTableHeader",
                        style: {
                          width: _vm.bodyWidth
                        },
                        attrs: {
                          fixed: "left",
                          border: _vm.border,
                          store: _vm.store
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  ref: "fixedBodyWrapper",
                  staticClass: "el-table__fixed-body-wrapper",
                  style: [
                    {
                      top: _vm.layout.headerHeight + "px"
                    },
                    _vm.fixedBodyHeight
                  ]
                },
                [
                  _c("table-body", {
                    style: {
                      width: _vm.bodyWidth
                    },
                    attrs: {
                      fixed: "left",
                      store: _vm.store,
                      stripe: _vm.stripe,
                      highlight: _vm.highlightCurrentRow,
                      "row-class-name": _vm.rowClassName,
                      "row-style": _vm.rowStyle
                    }
                  }),
                  _vm.$slots.append
                    ? _c("div", {
                        staticClass: "el-table__append-gutter",
                        style: { height: _vm.layout.appendHeight + "px" }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm.showSummary
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.data && _vm.data.length > 0,
                          expression: "data && data.length > 0"
                        }
                      ],
                      ref: "fixedFooterWrapper",
                      staticClass: "el-table__fixed-footer-wrapper"
                    },
                    [
                      _c("table-footer", {
                        style: {
                          width: _vm.bodyWidth
                        },
                        attrs: {
                          fixed: "left",
                          border: _vm.border,
                          "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
                          "summary-method": _vm.summaryMethod,
                          store: _vm.store
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm.rightFixedColumns.length > 0
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "mousewheel",
                  rawName: "v-mousewheel",
                  value: _vm.handleFixedMousewheel,
                  expression: "handleFixedMousewheel"
                }
              ],
              ref: "rightFixedWrapper",
              staticClass: "el-table__fixed-right",
              style: [
                {
                  width: _vm.layout.rightFixedWidth
                    ? _vm.layout.rightFixedWidth + "px"
                    : "",
                  right: _vm.layout.scrollY
                    ? (_vm.border
                        ? _vm.layout.gutterWidth
                        : _vm.layout.gutterWidth || 0) + "px"
                    : ""
                },
                _vm.fixedHeight
              ]
            },
            [
              _vm.showHeader
                ? _c(
                    "div",
                    {
                      ref: "rightFixedHeaderWrapper",
                      staticClass: "el-table__fixed-header-wrapper"
                    },
                    [
                      _c("table-header", {
                        ref: "rightFixedTableHeader",
                        style: {
                          width: _vm.bodyWidth
                        },
                        attrs: {
                          fixed: "right",
                          border: _vm.border,
                          store: _vm.store
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  ref: "rightFixedBodyWrapper",
                  staticClass: "el-table__fixed-body-wrapper",
                  style: [
                    {
                      top: _vm.layout.headerHeight + "px"
                    },
                    _vm.fixedBodyHeight
                  ]
                },
                [
                  _c("table-body", {
                    style: {
                      width: _vm.bodyWidth
                    },
                    attrs: {
                      fixed: "right",
                      store: _vm.store,
                      stripe: _vm.stripe,
                      "row-class-name": _vm.rowClassName,
                      "row-style": _vm.rowStyle,
                      highlight: _vm.highlightCurrentRow
                    }
                  }),
                  _vm.$slots.append
                    ? _c("div", {
                        staticClass: "el-table__append-gutter",
                        style: { height: _vm.layout.appendHeight + "px" }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm.showSummary
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.data && _vm.data.length > 0,
                          expression: "data && data.length > 0"
                        }
                      ],
                      ref: "rightFixedFooterWrapper",
                      staticClass: "el-table__fixed-footer-wrapper"
                    },
                    [
                      _c("table-footer", {
                        style: {
                          width: _vm.bodyWidth
                        },
                        attrs: {
                          fixed: "right",
                          border: _vm.border,
                          "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
                          "summary-method": _vm.summaryMethod,
                          store: _vm.store
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm.rightFixedColumns.length > 0
        ? _c("div", {
            ref: "rightFixedPatch",
            staticClass: "el-table__fixed-right-patch",
            style: {
              width: _vm.layout.scrollY ? _vm.layout.gutterWidth + "px" : "0",
              height: _vm.layout.headerHeight + "px"
            }
          })
        : _vm._e(),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.resizeProxyVisible,
            expression: "resizeProxyVisible"
          }
        ],
        ref: "resizeProxy",
        staticClass: "el-table__column-resize-proxy"
      })
    ]
  )
}
var tablevue_type_template_id_493fe34e_staticRenderFns = []
tablevue_type_template_id_493fe34e_render._withStripped = true


// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=template&id=493fe34e&

// EXTERNAL MODULE: external "element-ui/lib/checkbox"
var checkbox_ = __webpack_require__(16);
var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);

// EXTERNAL MODULE: external "throttle-debounce"
var external_throttle_debounce_ = __webpack_require__(35);

// EXTERNAL MODULE: external "normalize-wheel"
var external_normalize_wheel_ = __webpack_require__(38);
var external_normalize_wheel_default = /*#__PURE__*/__webpack_require__.n(external_normalize_wheel_);

// CONCATENATED MODULE: ./src/directives/mousewheel.js


var isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

var mousewheel_mousewheel = function mousewheel(element, callback) {
  if (element && element.addEventListener) {
    element.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', function (event) {
      var normalized = external_normalize_wheel_default()(event);
      callback && callback.apply(this, [event, normalized]);
    });
  }
};

/* harmony default export */ var directives_mousewheel = ({
  bind: function bind(el, binding) {
    mousewheel_mousewheel(el, binding.value);
  }
});
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(6);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./packages/table/src/util.js
var util_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var getCell = function getCell(event) {
  var cell = event.target;

  while (cell && cell.tagName.toUpperCase() !== 'HTML') {
    if (cell.tagName.toUpperCase() === 'TD') {
      return cell;
    }
    cell = cell.parentNode;
  }

  return null;
};

var util_isObject = function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : util_typeof(obj)) === 'object';
};

var util_orderBy = function orderBy(array, sortKey, reverse, sortMethod, sortBy) {
  if (!sortKey && !sortMethod && (!sortBy || Array.isArray(sortBy) && !sortBy.length)) {
    return array;
  }
  if (typeof reverse === 'string') {
    reverse = reverse === 'descending' ? -1 : 1;
  } else {
    reverse = reverse && reverse < 0 ? -1 : 1;
  }
  var getKey = sortMethod ? null : function (value, index) {
    if (sortBy) {
      if (!Array.isArray(sortBy)) {
        sortBy = [sortBy];
      }
      return sortBy.map(function (by) {
        if (typeof by === 'string') {
          return Object(util_["getValueByPath"])(value, by);
        } else {
          return by(value, index, array);
        }
      });
    }
    if (sortKey !== '$key') {
      if (util_isObject(value) && '$value' in value) value = value.$value;
    }
    return [util_isObject(value) ? Object(util_["getValueByPath"])(value, sortKey) : value];
  };
  var compare = function compare(a, b) {
    if (sortMethod) {
      return sortMethod(a.value, b.value);
    }
    for (var i = 0, len = a.key.length; i < len; i++) {
      if (a.key[i] < b.key[i]) {
        return -1;
      }
      if (a.key[i] > b.key[i]) {
        return 1;
      }
    }
    return 0;
  };
  return array.map(function (value, index) {
    return {
      value: value,
      index: index,
      key: getKey ? getKey(value, index) : null
    };
  }).sort(function (a, b) {
    var order = compare(a, b);
    if (!order) {
      // make stable https://en.wikipedia.org/wiki/Sorting_algorithm#Stability
      order = a.index - b.index;
    }
    return order * reverse;
  }).map(function (item) {
    return item.value;
  });
};

var getColumnById = function getColumnById(table, columnId) {
  var column = null;
  table.columns.forEach(function (item) {
    if (item.id === columnId) {
      column = item;
    }
  });
  return column;
};

var getColumnByKey = function getColumnByKey(table, columnKey) {
  var column = null;
  for (var i = 0; i < table.columns.length; i++) {
    var item = table.columns[i];
    if (item.columnKey === columnKey) {
      column = item;
      break;
    }
  }
  return column;
};

var getColumnByCell = function getColumnByCell(table, cell) {
  var matches = (cell.className || '').match(/el-table_[^\s]+/gm);
  if (matches) {
    return getColumnById(table, matches[0]);
  }
  return null;
};

var getRowIdentity = function getRowIdentity(row, rowKey) {
  if (!row) throw new Error('row is required when get row identity');
  if (typeof rowKey === 'string') {
    if (rowKey.indexOf('.') < 0) {
      return row[rowKey];
    }
    var key = rowKey.split('.');
    var current = row;
    for (var i = 0; i < key.length; i++) {
      current = current[key[i]];
    }
    return current;
  } else if (typeof rowKey === 'function') {
    return rowKey.call(null, row);
  }
};

var getKeysMap = function getKeysMap(array, rowKey) {
  var arrayMap = {};
  (array || []).forEach(function (row, index) {
    arrayMap[getRowIdentity(row, rowKey)] = { row: row, index: index };
  });
  return arrayMap;
};

function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

function mergeOptions(defaults, config) {
  var options = {};
  var key = void 0;
  for (key in defaults) {
    options[key] = defaults[key];
  }
  for (key in config) {
    if (hasOwn(config, key)) {
      var value = config[key];
      if (typeof value !== 'undefined') {
        options[key] = value;
      }
    }
  }
  return options;
}

function parseWidth(width) {
  if (width !== undefined) {
    width = parseInt(width, 10);
    if (isNaN(width)) {
      width = null;
    }
  }
  return width;
}

function parseMinWidth(minWidth) {
  if (typeof minWidth !== 'undefined') {
    minWidth = parseWidth(minWidth);
    if (isNaN(minWidth)) {
      minWidth = 80;
    }
  }
  return minWidth;
};

function parseHeight(height) {
  if (typeof height === 'number') {
    return height;
  }
  if (typeof height === 'string') {
    if (/^\d+(?:px)?$/.test(height)) {
      return parseInt(height, 10);
    } else {
      return height;
    }
  }
  return null;
}

// https://github.com/reduxjs/redux/blob/master/src/compose.js
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

function toggleRowStatus(statusArr, row, newVal) {
  var changed = false;
  var index = statusArr.indexOf(row);
  var included = index !== -1;

  var addRow = function addRow() {
    statusArr.push(row);
    changed = true;
  };
  var removeRow = function removeRow() {
    statusArr.splice(index, 1);
    changed = true;
  };

  if (typeof newVal === 'boolean') {
    if (newVal && !included) {
      addRow();
    } else if (!newVal && included) {
      removeRow();
    }
  } else {
    if (included) {
      removeRow();
    } else {
      addRow();
    }
  }
  return changed;
}

function walkTreeNode(root, cb) {
  var childrenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
  var lazyKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'hasChildren';

  var isNil = function isNil(array) {
    return !(Array.isArray(array) && array.length);
  };

  function _walker(parent, children, level) {
    cb(parent, children, level);
    children.forEach(function (item) {
      if (item[lazyKey]) {
        cb(item, null, level + 1);
        return;
      }
      var children = item[childrenKey];
      if (!isNil(children)) {
        _walker(item, children, level + 1);
      }
    });
  }

  root.forEach(function (item) {
    if (item[lazyKey]) {
      cb(item, null, 0);
      return;
    }
    var children = item[childrenKey];
    if (!isNil(children)) {
      _walker(item, children, 0);
    }
  });
}
// CONCATENATED MODULE: ./packages/table/src/store/expand.js


/* harmony default export */ var expand = ({
  data: function data() {
    return {
      states: {
        defaultExpandAll: false,
        expandRows: []
      }
    };
  },


  methods: {
    updateExpandRows: function updateExpandRows() {
      var _states = this.states,
          _states$data = _states.data,
          data = _states$data === undefined ? [] : _states$data,
          rowKey = _states.rowKey,
          defaultExpandAll = _states.defaultExpandAll,
          expandRows = _states.expandRows;

      if (defaultExpandAll) {
        this.states.expandRows = data.slice();
      } else if (rowKey) {
        // TODO：这里的代码可以优化
        var expandRowsMap = getKeysMap(expandRows, rowKey);
        this.states.expandRows = data.reduce(function (prev, row) {
          var rowId = getRowIdentity(row, rowKey);
          var rowInfo = expandRowsMap[rowId];
          if (rowInfo) {
            prev.push(row);
          }
          return prev;
        }, []);
      } else {
        this.states.expandRows = [];
      }
    },
    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
      var changed = toggleRowStatus(this.states.expandRows, row, expanded);
      if (changed) {
        this.table.$emit('expand-change', row, this.states.expandRows.slice());
        this.scheduleLayout();
      }
    },
    setExpandRowKeys: function setExpandRowKeys(rowKeys) {
      this.assertRowKey();
      // TODO：这里的代码可以优化
      var _states2 = this.states,
          data = _states2.data,
          rowKey = _states2.rowKey;

      var keysMap = getKeysMap(data, rowKey);
      this.states.expandRows = rowKeys.reduce(function (prev, cur) {
        var info = keysMap[cur];
        if (info) {
          prev.push(info.row);
        }
        return prev;
      }, []);
    },
    isRowExpanded: function isRowExpanded(row) {
      var _states3 = this.states,
          _states3$expandRows = _states3.expandRows,
          expandRows = _states3$expandRows === undefined ? [] : _states3$expandRows,
          rowKey = _states3.rowKey;

      if (rowKey) {
        var expandMap = getKeysMap(expandRows, rowKey);
        return !!expandMap[getRowIdentity(row, rowKey)];
      }
      return expandRows.indexOf(row) !== -1;
    }
  }
});
// CONCATENATED MODULE: ./packages/table/src/store/current.js



/* harmony default export */ var current = ({
  data: function data() {
    return {
      states: {
        // 不可响应的，设置 currentRowKey 时，data 不一定存在，也许无法算出正确的 currentRow
        // 把该值缓存一下，当用户点击修改 currentRow 时，把该值重置为 null
        _currentRowKey: null,
        currentRow: null
      }
    };
  },


  methods: {
    setCurrentRowKey: function setCurrentRowKey(key) {
      this.assertRowKey();
      this.states._currentRowKey = key;
      this.setCurrentRowByKey(key);
    },
    restoreCurrentRowKey: function restoreCurrentRowKey() {
      this.states._currentRowKey = null;
    },
    setCurrentRowByKey: function setCurrentRowByKey(key) {
      var states = this.states;
      var _states$data = states.data,
          data = _states$data === undefined ? [] : _states$data,
          rowKey = states.rowKey;

      var currentRow = null;
      if (rowKey) {
        currentRow = Object(util_["arrayFind"])(data, function (item) {
          return getRowIdentity(item, rowKey) === key;
        });
      }
      states.currentRow = currentRow;
    },
    updateCurrentRow: function updateCurrentRow(currentRow) {
      var states = this.states,
          table = this.table;

      var oldCurrentRow = states.currentRow;
      if (currentRow && currentRow !== oldCurrentRow) {
        states.currentRow = currentRow;
        table.$emit('current-change', currentRow, oldCurrentRow);
        return;
      }
      if (!currentRow && oldCurrentRow) {
        states.currentRow = null;
        table.$emit('current-change', null, oldCurrentRow);
      }
    },
    updateCurrentRowData: function updateCurrentRowData() {
      var states = this.states,
          table = this.table;
      var rowKey = states.rowKey,
          _currentRowKey = states._currentRowKey;
      // data 为 null 时，解构时的默认值会被忽略

      var data = states.data || [];
      var oldCurrentRow = states.currentRow;

      // 当 currentRow 不在 data 中时尝试更新数据
      if (data.indexOf(oldCurrentRow) === -1 && oldCurrentRow) {
        if (rowKey) {
          var currentRowKey = getRowIdentity(oldCurrentRow, rowKey);
          this.setCurrentRowByKey(currentRowKey);
        } else {
          states.currentRow = null;
        }
        if (states.currentRow === null) {
          table.$emit('current-change', null, oldCurrentRow);
        }
      } else if (_currentRowKey) {
        // 把初始时下设置的 rowKey 转化成 rowData
        this.setCurrentRowByKey(_currentRowKey);
        this.restoreCurrentRowKey();
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/table/src/store/tree.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ var tree = ({
  data: function data() {
    return {
      states: {
        // defaultExpandAll 存在于 expand.js 中，这里不重复添加
        // 在展开行中，expandRowKeys 会被转化成 expandRows，expandRowKeys 这个属性只是记录了 TreeTable 行的展开
        // TODO: 拆分为独立的 TreeTable，统一用法
        expandRowKeys: [],
        treeData: {},
        indent: 16,
        lazy: false,
        lazyTreeNodeMap: {},
        lazyColumnIdentifier: 'hasChildren',
        childrenColumnName: 'children'
      }
    };
  },


  computed: {
    // 嵌入型的数据，watch 无法是检测到变化 https://github.com/ElemeFE/element/issues/14998
    // TODO: 使用 computed 解决该问题，是否会造成性能问题？
    // @return { id: { level, children } }
    normalizedData: function normalizedData() {
      if (!this.states.rowKey) return {};
      var data = this.states.data || [];
      return this.normalize(data);
    },

    // @return { id: { children } }
    // 针对懒加载的情形，不处理嵌套数据
    normalizedLazyNode: function normalizedLazyNode() {
      var _states = this.states,
          rowKey = _states.rowKey,
          lazyTreeNodeMap = _states.lazyTreeNodeMap,
          lazyColumnIdentifier = _states.lazyColumnIdentifier;

      var keys = Object.keys(lazyTreeNodeMap);
      var res = {};
      if (!keys.length) return res;
      keys.forEach(function (key) {
        if (lazyTreeNodeMap[key].length) {
          var item = { children: [] };
          lazyTreeNodeMap[key].forEach(function (row) {
            var currentRowKey = getRowIdentity(row, rowKey);
            item.children.push(currentRowKey);
            if (row[lazyColumnIdentifier] && !res[currentRowKey]) {
              res[currentRowKey] = { children: [] };
            }
          });
          res[key] = item;
        }
      });
      return res;
    }
  },

  watch: {
    normalizedData: 'updateTreeData',
    normalizedLazyNode: 'updateTreeData'
  },

  methods: {
    normalize: function normalize(data) {
      var _states2 = this.states,
          childrenColumnName = _states2.childrenColumnName,
          lazyColumnIdentifier = _states2.lazyColumnIdentifier,
          rowKey = _states2.rowKey,
          lazy = _states2.lazy;

      var res = {};
      walkTreeNode(data, function (parent, children, level) {
        var parentId = getRowIdentity(parent, rowKey);
        if (Array.isArray(children)) {
          res[parentId] = {
            children: children.map(function (row) {
              return getRowIdentity(row, rowKey);
            }),
            level: level
          };
        } else if (lazy) {
          // 当 children 不存在且 lazy 为 true，该节点即为懒加载的节点
          res[parentId] = {
            children: [],
            lazy: true,
            level: level
          };
        }
      }, childrenColumnName, lazyColumnIdentifier);
      return res;
    },
    updateTreeData: function updateTreeData() {
      var nested = this.normalizedData;
      var normalizedLazyNode = this.normalizedLazyNode;
      var keys = Object.keys(nested);
      var newTreeData = {};
      if (keys.length) {
        var _states3 = this.states,
            oldTreeData = _states3.treeData,
            defaultExpandAll = _states3.defaultExpandAll,
            expandRowKeys = _states3.expandRowKeys,
            lazy = _states3.lazy;

        var rootLazyRowKeys = [];
        var getExpanded = function getExpanded(oldValue, key) {
          var included = defaultExpandAll || expandRowKeys && expandRowKeys.indexOf(key) !== -1;
          return !!(oldValue && oldValue.expanded || included);
        };
        // 合并 expanded 与 display，确保数据刷新后，状态不变
        keys.forEach(function (key) {
          var oldValue = oldTreeData[key];
          var newValue = _extends({}, nested[key]);
          newValue.expanded = getExpanded(oldValue, key);
          if (newValue.lazy) {
            var _ref = oldValue || {},
                _ref$loaded = _ref.loaded,
                loaded = _ref$loaded === undefined ? false : _ref$loaded,
                _ref$loading = _ref.loading,
                loading = _ref$loading === undefined ? false : _ref$loading;

            newValue.loaded = !!loaded;
            newValue.loading = !!loading;
            rootLazyRowKeys.push(key);
          }
          newTreeData[key] = newValue;
        });
        // 根据懒加载数据更新 treeData
        var lazyKeys = Object.keys(normalizedLazyNode);
        if (lazy && lazyKeys.length && rootLazyRowKeys.length) {
          lazyKeys.forEach(function (key) {
            var oldValue = oldTreeData[key];
            var lazyNodeChildren = normalizedLazyNode[key].children;
            if (rootLazyRowKeys.indexOf(key) !== -1) {
              // 懒加载的 root 节点，更新一下原有的数据，原来的 children 一定是空数组
              if (newTreeData[key].children.length !== 0) {
                throw new Error('[ElTable]children must be an empty array.');
              }
              newTreeData[key].children = lazyNodeChildren;
            } else {
              var _ref2 = oldValue || {},
                  _ref2$loaded = _ref2.loaded,
                  loaded = _ref2$loaded === undefined ? false : _ref2$loaded,
                  _ref2$loading = _ref2.loading,
                  loading = _ref2$loading === undefined ? false : _ref2$loading;

              newTreeData[key] = {
                lazy: true,
                loaded: !!loaded,
                loading: !!loading,
                expanded: getExpanded(oldValue, key),
                children: lazyNodeChildren,
                level: ''
              };
            }
          });
        }
      }
      this.states.treeData = newTreeData;
      this.updateTableScrollY();
    },
    updateTreeExpandKeys: function updateTreeExpandKeys(value) {
      this.states.expandRowKeys = value;
      this.updateTreeData();
    },
    toggleTreeExpansion: function toggleTreeExpansion(row, expanded) {
      this.assertRowKey();

      var _states4 = this.states,
          rowKey = _states4.rowKey,
          treeData = _states4.treeData;

      var id = getRowIdentity(row, rowKey);
      var data = id && treeData[id];
      if (id && data && 'expanded' in data) {
        var oldExpanded = data.expanded;
        expanded = typeof expanded === 'undefined' ? !data.expanded : expanded;
        treeData[id].expanded = expanded;
        if (oldExpanded !== expanded) {
          this.table.$emit('expand-change', row, expanded);
        }
        this.updateTableScrollY();
      }
    },
    loadOrToggle: function loadOrToggle(row) {
      this.assertRowKey();
      var _states5 = this.states,
          lazy = _states5.lazy,
          treeData = _states5.treeData,
          rowKey = _states5.rowKey;

      var id = getRowIdentity(row, rowKey);
      var data = treeData[id];
      if (lazy && data && 'loaded' in data && !data.loaded) {
        this.loadData(row, id, data);
      } else {
        this.toggleTreeExpansion(row);
      }
    },
    loadData: function loadData(row, key, treeNode) {
      var _this = this;

      var load = this.table.load;
      var _states6 = this.states,
          lazyTreeNodeMap = _states6.lazyTreeNodeMap,
          treeData = _states6.treeData;

      if (load && !treeData[key].loaded) {
        treeData[key].loading = true;
        load(row, treeNode, function (data) {
          if (!Array.isArray(data)) {
            throw new Error('[ElTable] data must be an array');
          }
          treeData[key].loading = false;
          treeData[key].loaded = true;
          treeData[key].expanded = true;
          if (data.length) {
            _this.$set(lazyTreeNodeMap, key, data);
          }
          _this.table.$emit('expand-change', row, true);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/table/src/store/watcher.js







var watcher_sortData = function sortData(data, states) {
  var sortingColumn = states.sortingColumn;
  if (!sortingColumn || typeof sortingColumn.sortable === 'string') {
    return data;
  }
  return util_orderBy(data, states.sortProp, states.sortOrder, sortingColumn.sortMethod, sortingColumn.sortBy);
};

var doFlattenColumns = function doFlattenColumns(columns) {
  var result = [];
  columns.forEach(function (column) {
    if (column.children) {
      result.push.apply(result, doFlattenColumns(column.children));
    } else {
      result.push(column);
    }
  });
  return result;
};

/* harmony default export */ var watcher = (external_vue_default.a.extend({
  data: function data() {
    return {
      states: {
        // 3.0 版本后要求必须设置该属性
        rowKey: null,

        // 渲染的数据来源，是对 table 中的 data 过滤排序后的结果
        data: [],

        // 是否包含固定列
        isComplex: false,

        // 列
        _columns: [], // 不可响应的
        originColumns: [],
        columns: [],
        fixedColumns: [],
        rightFixedColumns: [],
        leafColumns: [],
        fixedLeafColumns: [],
        rightFixedLeafColumns: [],
        leafColumnsLength: 0,
        fixedLeafColumnsLength: 0,
        rightFixedLeafColumnsLength: 0,

        // 选择
        isAllSelected: false,
        selection: [],
        reserveSelection: false,
        selectOnIndeterminate: false,
        selectable: null,

        // 过滤
        filters: {}, // 不可响应的
        filteredData: null,

        // 排序
        sortingColumn: null,
        sortProp: null,
        sortOrder: null,

        hoverRow: null
      }
    };
  },


  mixins: [expand, current, tree],

  methods: {
    // 检查 rowKey 是否存在
    assertRowKey: function assertRowKey() {
      var rowKey = this.states.rowKey;
      if (!rowKey) throw new Error('[ElTable] prop row-key is required');
    },


    // 更新列
    updateColumns: function updateColumns() {
      var states = this.states;
      var _columns = states._columns || [];
      states.fixedColumns = _columns.filter(function (column) {
        return column.fixed === true || column.fixed === 'left';
      });
      states.rightFixedColumns = _columns.filter(function (column) {
        return column.fixed === 'right';
      });

      if (states.fixedColumns.length > 0 && _columns[0] && _columns[0].type === 'selection' && !_columns[0].fixed) {
        _columns[0].fixed = true;
        states.fixedColumns.unshift(_columns[0]);
      }

      var notFixedColumns = _columns.filter(function (column) {
        return !column.fixed;
      });
      states.originColumns = [].concat(states.fixedColumns).concat(notFixedColumns).concat(states.rightFixedColumns);

      var leafColumns = doFlattenColumns(notFixedColumns);
      var fixedLeafColumns = doFlattenColumns(states.fixedColumns);
      var rightFixedLeafColumns = doFlattenColumns(states.rightFixedColumns);

      states.leafColumnsLength = leafColumns.length;
      states.fixedLeafColumnsLength = fixedLeafColumns.length;
      states.rightFixedLeafColumnsLength = rightFixedLeafColumns.length;

      states.columns = [].concat(fixedLeafColumns).concat(leafColumns).concat(rightFixedLeafColumns);
      states.isComplex = states.fixedColumns.length > 0 || states.rightFixedColumns.length > 0;
    },


    // 更新 DOM
    scheduleLayout: function scheduleLayout(needUpdateColumns) {
      if (needUpdateColumns) {
        this.updateColumns();
      }
      this.table.debouncedUpdateLayout();
    },


    // 选择
    isSelected: function isSelected(row) {
      var _states$selection = this.states.selection,
          selection = _states$selection === undefined ? [] : _states$selection;

      return selection.indexOf(row) > -1;
    },
    clearSelection: function clearSelection() {
      var states = this.states;
      states.isAllSelected = false;
      var oldSelection = states.selection;
      if (oldSelection.length) {
        states.selection = [];
        this.table.$emit('selection-change', []);
      }
    },
    cleanSelection: function cleanSelection() {
      var states = this.states;
      var data = states.data,
          rowKey = states.rowKey,
          selection = states.selection;

      var deleted = void 0;
      if (rowKey) {
        deleted = [];
        var selectedMap = getKeysMap(selection, rowKey);
        var dataMap = getKeysMap(data, rowKey);
        for (var key in selectedMap) {
          if (selectedMap.hasOwnProperty(key) && !dataMap[key]) {
            deleted.push(selectedMap[key].row);
          }
        }
      } else {
        deleted = selection.filter(function (item) {
          return data.indexOf(item) === -1;
        });
      }
      if (deleted.length) {
        var newSelection = selection.filter(function (item) {
          return deleted.indexOf(item) === -1;
        });
        states.selection = newSelection;
        this.table.$emit('selection-change', newSelection.slice());
      }
    },
    toggleRowSelection: function toggleRowSelection(row, selected) {
      var emitChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var changed = toggleRowStatus(this.states.selection, row, selected);
      if (changed) {
        var newSelection = (this.states.selection || []).slice();
        // 调用 API 修改选中值，不触发 select 事件
        if (emitChange) {
          this.table.$emit('select', newSelection, row);
        }
        this.table.$emit('selection-change', newSelection);
      }
    },
    _toggleAllSelection: function _toggleAllSelection() {
      var states = this.states;
      var _states$data = states.data,
          data = _states$data === undefined ? [] : _states$data,
          selection = states.selection;
      // when only some rows are selected (but not all), select or deselect all of them
      // depending on the value of selectOnIndeterminate

      var value = states.selectOnIndeterminate ? !states.isAllSelected : !(states.isAllSelected || selection.length);
      states.isAllSelected = value;

      var selectionChanged = false;
      data.forEach(function (row, index) {
        if (states.selectable) {
          if (states.selectable.call(null, row, index) && toggleRowStatus(selection, row, value)) {
            selectionChanged = true;
          }
        } else {
          if (toggleRowStatus(selection, row, value)) {
            selectionChanged = true;
          }
        }
      });

      if (selectionChanged) {
        this.table.$emit('selection-change', selection ? selection.slice() : []);
      }
      this.table.$emit('select-all', selection);
    },
    updateSelectionByRowKey: function updateSelectionByRowKey() {
      var states = this.states;
      var selection = states.selection,
          rowKey = states.rowKey,
          data = states.data;

      var selectedMap = getKeysMap(selection, rowKey);
      data.forEach(function (row) {
        var rowId = getRowIdentity(row, rowKey);
        var rowInfo = selectedMap[rowId];
        if (rowInfo) {
          selection[rowInfo.index] = row;
        }
      });
    },
    updateAllSelected: function updateAllSelected() {
      var states = this.states;
      var selection = states.selection,
          rowKey = states.rowKey,
          selectable = states.selectable;
      // data 为 null 时，解构时的默认值会被忽略

      var data = states.data || [];
      if (data.length === 0) {
        states.isAllSelected = false;
        return;
      }

      var selectedMap = void 0;
      if (rowKey) {
        selectedMap = getKeysMap(selection, rowKey);
      }
      var isSelected = function isSelected(row) {
        if (selectedMap) {
          return !!selectedMap[getRowIdentity(row, rowKey)];
        } else {
          return selection.indexOf(row) !== -1;
        }
      };
      var isAllSelected = true;
      var selectedCount = 0;
      for (var i = 0, j = data.length; i < j; i++) {
        var item = data[i];
        var isRowSelectable = selectable && selectable.call(null, item, i);
        if (!isSelected(item)) {
          if (!selectable || isRowSelectable) {
            isAllSelected = false;
            break;
          }
        } else {
          selectedCount++;
        }
      }

      if (selectedCount === 0) isAllSelected = false;
      states.isAllSelected = isAllSelected;
    },


    // 过滤与排序
    updateFilters: function updateFilters(columns, values) {
      if (!Array.isArray(columns)) {
        columns = [columns];
      }
      var states = this.states;
      var filters = {};
      columns.forEach(function (col) {
        states.filters[col.id] = values;
        filters[col.columnKey || col.id] = values;
      });

      return filters;
    },
    updateSort: function updateSort(column, prop, order) {
      if (this.states.sortingColumn && this.states.sortingColumn !== column) {
        this.states.sortingColumn.order = null;
      }
      this.states.sortingColumn = column;
      this.states.sortProp = prop;
      this.states.sortOrder = order;
    },
    execFilter: function execFilter() {
      var _this = this;

      var states = this.states;
      var _data = states._data,
          filters = states.filters;

      var data = _data;

      Object.keys(filters).forEach(function (columnId) {
        var values = states.filters[columnId];
        if (!values || values.length === 0) return;
        var column = getColumnById(_this.states, columnId);
        if (column && column.filterMethod) {
          data = data.filter(function (row) {
            return values.some(function (value) {
              return column.filterMethod.call(null, value, row, column);
            });
          });
        }
      });

      states.filteredData = data;
    },
    execSort: function execSort() {
      var states = this.states;
      states.data = watcher_sortData(states.filteredData, states);
    },


    // 根据 filters 与 sort 去过滤 data
    execQuery: function execQuery(ignore) {
      if (!(ignore && ignore.filter)) {
        this.execFilter();
      }
      this.execSort();
    },
    clearFilter: function clearFilter(columnKeys) {
      var states = this.states;
      var _table$$refs = this.table.$refs,
          tableHeader = _table$$refs.tableHeader,
          fixedTableHeader = _table$$refs.fixedTableHeader,
          rightFixedTableHeader = _table$$refs.rightFixedTableHeader;


      var panels = {};
      if (tableHeader) panels = merge_default()(panels, tableHeader.filterPanels);
      if (fixedTableHeader) panels = merge_default()(panels, fixedTableHeader.filterPanels);
      if (rightFixedTableHeader) panels = merge_default()(panels, rightFixedTableHeader.filterPanels);

      var keys = Object.keys(panels);
      if (!keys.length) return;

      if (typeof columnKeys === 'string') {
        columnKeys = [columnKeys];
      }

      if (Array.isArray(columnKeys)) {
        var columns = columnKeys.map(function (key) {
          return getColumnByKey(states, key);
        });
        keys.forEach(function (key) {
          var column = columns.find(function (col) {
            return col.id === key;
          });
          if (column) {
            // TODO: 优化这里的代码
            panels[key].filteredValue = [];
          }
        });
        this.commit('filterChange', {
          column: columns,
          values: [],
          silent: true,
          multi: true
        });
      } else {
        keys.forEach(function (key) {
          // TODO: 优化这里的代码
          panels[key].filteredValue = [];
        });

        states.filters = {};
        this.commit('filterChange', {
          column: {},
          values: [],
          silent: true
        });
      }
    },
    clearSort: function clearSort() {
      var states = this.states;
      if (!states.sortingColumn) return;

      this.updateSort(null, null, null);
      this.commit('changeSortCondition', {
        silent: true
      });
    },


    // 适配层，expand-row-keys 在 Expand 与 TreeTable 中都有使用
    setExpandRowKeysAdapter: function setExpandRowKeysAdapter(val) {
      // 这里会触发额外的计算，但为了兼容性，暂时这么做
      this.setExpandRowKeys(val);
      this.updateTreeExpandKeys(val);
    },


    // 展开行与 TreeTable 都要使用
    toggleRowExpansionAdapter: function toggleRowExpansionAdapter(row, expanded) {
      var hasExpandColumn = this.states.columns.some(function (_ref) {
        var type = _ref.type;
        return type === 'expand';
      });
      if (hasExpandColumn) {
        this.toggleRowExpansion(row, expanded);
      } else {
        this.toggleTreeExpansion(row, expanded);
      }
    }
  }
}));
// CONCATENATED MODULE: ./packages/table/src/store/index.js




watcher.prototype.mutations = {
  setData: function setData(states, data) {
    var dataInstanceChanged = states._data !== data;
    states._data = data;

    this.execQuery();
    // 数据变化，更新部分数据。
    // 没有使用 computed，而是手动更新部分数据 https://github.com/vuejs/vue/issues/6660#issuecomment-331417140
    this.updateCurrentRowData();
    this.updateExpandRows();
    if (states.reserveSelection) {
      this.assertRowKey();
      this.updateSelectionByRowKey();
    } else {
      if (dataInstanceChanged) {
        this.clearSelection();
      } else {
        this.cleanSelection();
      }
    }
    this.updateAllSelected();

    this.updateTableScrollY();
  },
  insertColumn: function insertColumn(states, column, index, parent) {
    var array = states._columns;
    if (parent) {
      array = parent.children;
      if (!array) array = parent.children = [];
    }

    if (typeof index !== 'undefined') {
      array.splice(index, 0, column);
    } else {
      array.push(column);
    }

    if (column.type === 'selection') {
      states.selectable = column.selectable;
      states.reserveSelection = column.reserveSelection;
    }

    if (this.table.$ready) {
      this.updateColumns(); // hack for dynamics insert column
      this.scheduleLayout();
    }
  },
  removeColumn: function removeColumn(states, column, parent) {
    var array = states._columns;
    if (parent) {
      array = parent.children;
      if (!array) array = parent.children = [];
    }
    if (array) {
      array.splice(array.indexOf(column), 1);
    }

    if (this.table.$ready) {
      this.updateColumns(); // hack for dynamics remove column
      this.scheduleLayout();
    }
  },
  sort: function sort(states, options) {
    var prop = options.prop,
        order = options.order,
        init = options.init;

    if (prop) {
      var column = Object(util_["arrayFind"])(states.columns, function (column) {
        return column.property === prop;
      });
      if (column) {
        column.order = order;
        this.updateSort(column, prop, order);
        this.commit('changeSortCondition', { init: init });
      }
    }
  },
  changeSortCondition: function changeSortCondition(states, options) {
    // 修复 pr https://github.com/ElemeFE/element/pull/15012 导致的 bug
    var column = states.sortingColumn,
        prop = states.sortProp,
        order = states.sortOrder;

    if (order === null) {
      states.sortingColumn = null;
      states.sortProp = null;
    }
    var ingore = { filter: true };
    this.execQuery(ingore);

    if (!options || !(options.silent || options.init)) {
      this.table.$emit('sort-change', {
        column: column,
        prop: prop,
        order: order
      });
    }

    this.updateTableScrollY();
  },
  filterChange: function filterChange(states, options) {
    var column = options.column,
        values = options.values,
        silent = options.silent;

    var newFilters = this.updateFilters(column, values);

    this.execQuery();

    if (!silent) {
      this.table.$emit('filter-change', newFilters);
    }

    this.updateTableScrollY();
  },
  toggleAllSelection: function toggleAllSelection() {
    this.toggleAllSelection();
  },
  rowSelectedChanged: function rowSelectedChanged(states, row) {
    this.toggleRowSelection(row);
    this.updateAllSelected();
  },
  setHoverRow: function setHoverRow(states, row) {
    states.hoverRow = row;
  },
  setCurrentRow: function setCurrentRow(states, row) {
    this.updateCurrentRow(row);
  }
};

watcher.prototype.commit = function (name) {
  var mutations = this.mutations;
  if (mutations[name]) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    mutations[name].apply(this, [this.states].concat(args));
  } else {
    throw new Error('Action not found: ' + name);
  }
};

watcher.prototype.updateTableScrollY = function () {
  external_vue_default.a.nextTick(this.table.updateScrollY);
};

/* harmony default export */ var src_store = (watcher);
// CONCATENATED MODULE: ./packages/table/src/store/helper.js



function createStore(table) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!table) {
    throw new Error('Table is required.');
  }

  var store = new src_store();
  store.table = table;
  // fix https://github.com/ElemeFE/element/issues/14075
  // related pr https://github.com/ElemeFE/element/pull/14146
  store.toggleAllSelection = debounce_default()(10, store._toggleAllSelection);
  Object.keys(initialState).forEach(function (key) {
    store.states[key] = initialState[key];
  });
  return store;
}

function mapStates(mapper) {
  var res = {};
  Object.keys(mapper).forEach(function (key) {
    var value = mapper[key];
    var fn = void 0;
    if (typeof value === 'string') {
      fn = function fn() {
        return this.store.states[value];
      };
    } else if (typeof value === 'function') {
      fn = function fn() {
        return value.call(this, this.store.states);
      };
    } else {
      console.error('invalid value type');
    }
    if (fn) {
      res[key] = fn;
    }
  });
  return res;
};
// EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
var scrollbar_width_ = __webpack_require__(31);
var scrollbar_width_default = /*#__PURE__*/__webpack_require__.n(scrollbar_width_);

// CONCATENATED MODULE: ./packages/table/src/table-layout.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var table_layout_TableLayout = function () {
  function TableLayout(options) {
    _classCallCheck(this, TableLayout);

    this.observers = [];
    this.table = null;
    this.store = null;
    this.columns = null;
    this.fit = true;
    this.showHeader = true;

    this.height = null;
    this.scrollX = false;
    this.scrollY = false;
    this.bodyWidth = null;
    this.fixedWidth = null;
    this.rightFixedWidth = null;
    this.tableHeight = null;
    this.headerHeight = 44; // Table Header Height
    this.appendHeight = 0; // Append Slot Height
    this.footerHeight = 44; // Table Footer Height
    this.viewportHeight = null; // Table Height - Scroll Bar Height
    this.bodyHeight = null; // Table Height - Table Header Height
    this.fixedBodyHeight = null; // Table Height - Table Header Height - Scroll Bar Height
    this.gutterWidth = scrollbar_width_default()();

    for (var name in options) {
      if (options.hasOwnProperty(name)) {
        this[name] = options[name];
      }
    }

    if (!this.table) {
      throw new Error('table is required for Table Layout');
    }
    if (!this.store) {
      throw new Error('store is required for Table Layout');
    }
  }

  TableLayout.prototype.updateScrollY = function updateScrollY() {
    var height = this.height;
    if (height === null) return false;
    var bodyWrapper = this.table.bodyWrapper;
    if (this.table.$el && bodyWrapper) {
      var body = bodyWrapper.querySelector('.el-table__body');
      var prevScrollY = this.scrollY;
      var scrollY = body.offsetHeight > this.bodyHeight;
      this.scrollY = scrollY;
      return prevScrollY !== scrollY;
    }
    return false;
  };

  TableLayout.prototype.setHeight = function setHeight(value) {
    var _this = this;

    var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'height';

    if (external_vue_default.a.prototype.$isServer) return;
    var el = this.table.$el;
    value = parseHeight(value);
    this.height = value;

    if (!el && (value || value === 0)) return external_vue_default.a.nextTick(function () {
      return _this.setHeight(value, prop);
    });

    if (typeof value === 'number') {
      el.style[prop] = value + 'px';
      this.updateElsHeight();
    } else if (typeof value === 'string') {
      el.style[prop] = value;
      this.updateElsHeight();
    }
  };

  TableLayout.prototype.setMaxHeight = function setMaxHeight(value) {
    this.setHeight(value, 'max-height');
  };

  TableLayout.prototype.getFlattenColumns = function getFlattenColumns() {
    var flattenColumns = [];
    var columns = this.table.columns;
    columns.forEach(function (column) {
      if (column.isColumnGroup) {
        flattenColumns.push.apply(flattenColumns, column.columns);
      } else {
        flattenColumns.push(column);
      }
    });

    return flattenColumns;
  };

  TableLayout.prototype.updateElsHeight = function updateElsHeight() {
    var _this2 = this;

    if (!this.table.$ready) return external_vue_default.a.nextTick(function () {
      return _this2.updateElsHeight();
    });
    var _table$$refs = this.table.$refs,
        headerWrapper = _table$$refs.headerWrapper,
        appendWrapper = _table$$refs.appendWrapper,
        footerWrapper = _table$$refs.footerWrapper;

    this.appendHeight = appendWrapper ? appendWrapper.offsetHeight : 0;

    if (this.showHeader && !headerWrapper) return;

    // fix issue (https://github.com/ElemeFE/element/pull/16956)
    var headerTrElm = headerWrapper ? headerWrapper.querySelector('.el-table__header tr') : null;
    var noneHeader = this.headerDisplayNone(headerTrElm);

    var headerHeight = this.headerHeight = !this.showHeader ? 0 : headerWrapper.offsetHeight;
    if (this.showHeader && !noneHeader && headerWrapper.offsetWidth > 0 && (this.table.columns || []).length > 0 && headerHeight < 2) {
      return external_vue_default.a.nextTick(function () {
        return _this2.updateElsHeight();
      });
    }
    var tableHeight = this.tableHeight = this.table.$el.clientHeight;
    var footerHeight = this.footerHeight = footerWrapper ? footerWrapper.offsetHeight : 0;
    if (this.height !== null) {
      this.bodyHeight = tableHeight - headerHeight - footerHeight + (footerWrapper ? 1 : 0);
    }
    this.fixedBodyHeight = this.scrollX ? this.bodyHeight - this.gutterWidth : this.bodyHeight;

    var noData = !(this.store.states.data && this.store.states.data.length);
    this.viewportHeight = this.scrollX ? tableHeight - (noData ? 0 : this.gutterWidth) : tableHeight;

    this.updateScrollY();
    this.notifyObservers('scrollable');
  };

  TableLayout.prototype.headerDisplayNone = function headerDisplayNone(elm) {
    if (!elm) return true;
    var headerChild = elm;
    while (headerChild.tagName !== 'DIV') {
      if (getComputedStyle(headerChild).display === 'none') {
        return true;
      }
      headerChild = headerChild.parentElement;
    }
    return false;
  };

  TableLayout.prototype.updateColumnsWidth = function updateColumnsWidth() {
    if (external_vue_default.a.prototype.$isServer) return;
    var fit = this.fit;
    var bodyWidth = this.table.$el.clientWidth;
    var bodyMinWidth = 0;

    var flattenColumns = this.getFlattenColumns();
    var flexColumns = flattenColumns.filter(function (column) {
      return typeof column.width !== 'number';
    });

    flattenColumns.forEach(function (column) {
      // Clean those columns whose width changed from flex to unflex
      if (typeof column.width === 'number' && column.realWidth) column.realWidth = null;
    });

    if (flexColumns.length > 0 && fit) {
      flattenColumns.forEach(function (column) {
        bodyMinWidth += column.width || column.minWidth || 80;
      });

      var scrollYWidth = this.scrollY ? this.gutterWidth : 0;

      if (bodyMinWidth <= bodyWidth - scrollYWidth) {
        // DON'T HAVE SCROLL BAR
        this.scrollX = false;

        var totalFlexWidth = bodyWidth - scrollYWidth - bodyMinWidth;

        if (flexColumns.length === 1) {
          flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth;
        } else {
          var allColumnsWidth = flexColumns.reduce(function (prev, column) {
            return prev + (column.minWidth || 80);
          }, 0);
          var flexWidthPerPixel = totalFlexWidth / allColumnsWidth;
          var noneFirstWidth = 0;

          flexColumns.forEach(function (column, index) {
            if (index === 0) return;
            var flexWidth = Math.floor((column.minWidth || 80) * flexWidthPerPixel);
            noneFirstWidth += flexWidth;
            column.realWidth = (column.minWidth || 80) + flexWidth;
          });

          flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth - noneFirstWidth;
        }
      } else {
        // HAVE HORIZONTAL SCROLL BAR
        this.scrollX = true;
        flexColumns.forEach(function (column) {
          column.realWidth = column.minWidth;
        });
      }

      this.bodyWidth = Math.max(bodyMinWidth, bodyWidth);
      this.table.resizeState.width = this.bodyWidth;
    } else {
      flattenColumns.forEach(function (column) {
        if (!column.width && !column.minWidth) {
          column.realWidth = 80;
        } else {
          column.realWidth = column.width || column.minWidth;
        }

        bodyMinWidth += column.realWidth;
      });
      this.scrollX = bodyMinWidth > bodyWidth;

      this.bodyWidth = bodyMinWidth;
    }

    var fixedColumns = this.store.states.fixedColumns;

    if (fixedColumns.length > 0) {
      var fixedWidth = 0;
      fixedColumns.forEach(function (column) {
        fixedWidth += column.realWidth || column.width;
      });

      this.fixedWidth = fixedWidth;
    }

    var rightFixedColumns = this.store.states.rightFixedColumns;
    if (rightFixedColumns.length > 0) {
      var rightFixedWidth = 0;
      rightFixedColumns.forEach(function (column) {
        rightFixedWidth += column.realWidth || column.width;
      });

      this.rightFixedWidth = rightFixedWidth;
    }

    this.notifyObservers('columns');
  };

  TableLayout.prototype.addObserver = function addObserver(observer) {
    this.observers.push(observer);
  };

  TableLayout.prototype.removeObserver = function removeObserver(observer) {
    var index = this.observers.indexOf(observer);
    if (index !== -1) {
      this.observers.splice(index, 1);
    }
  };

  TableLayout.prototype.notifyObservers = function notifyObservers(event) {
    var _this3 = this;

    var observers = this.observers;
    observers.forEach(function (observer) {
      switch (event) {
        case 'columns':
          observer.onColumnsChange(_this3);
          break;
        case 'scrollable':
          observer.onScrollableChange(_this3);
          break;
        default:
          throw new Error('Table Layout don\'t have event ' + event + '.');
      }
    });
  };

  return TableLayout;
}();

/* harmony default export */ var table_layout = (table_layout_TableLayout);
// CONCATENATED MODULE: ./packages/table/src/layout-observer.js
/* harmony default export */ var layout_observer = ({
  created: function created() {
    this.tableLayout.addObserver(this);
  },
  destroyed: function destroyed() {
    this.tableLayout.removeObserver(this);
  },


  computed: {
    tableLayout: function tableLayout() {
      var layout = this.layout;
      if (!layout && this.table) {
        layout = this.table.layout;
      }
      if (!layout) {
        throw new Error('Can not find table layout.');
      }
      return layout;
    }
  },

  mounted: function mounted() {
    this.onColumnsChange(this.tableLayout);
    this.onScrollableChange(this.tableLayout);
  },
  updated: function updated() {
    if (this.__updated__) return;
    this.onColumnsChange(this.tableLayout);
    this.onScrollableChange(this.tableLayout);
    this.__updated__ = true;
  },


  methods: {
    onColumnsChange: function onColumnsChange(layout) {
      var cols = this.$el.querySelectorAll('colgroup > col');
      if (!cols.length) return;
      var flattenColumns = layout.getFlattenColumns();
      var columnsMap = {};
      flattenColumns.forEach(function (column) {
        columnsMap[column.id] = column;
      });
      for (var i = 0, j = cols.length; i < j; i++) {
        var col = cols[i];
        var name = col.getAttribute('name');
        var column = columnsMap[name];
        if (column) {
          col.setAttribute('width', column.realWidth || column.width);
        }
      }
    },
    onScrollableChange: function onScrollableChange(layout) {
      var cols = this.$el.querySelectorAll('colgroup > col[name=gutter]');
      for (var i = 0, j = cols.length; i < j; i++) {
        var col = cols[i];
        col.setAttribute('width', layout.scrollY ? layout.gutterWidth : '0');
      }
      var ths = this.$el.querySelectorAll('th.gutter');
      for (var _i = 0, _j = ths.length; _i < _j; _i++) {
        var th = ths[_i];
        th.style.width = layout.scrollY ? layout.gutterWidth + 'px' : '0';
        th.style.display = layout.scrollY ? '' : 'none';
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/table/src/table-body.js
var table_body_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var table_body_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










/* harmony default export */ var table_body = ({
  name: 'ElTableBody',

  mixins: [layout_observer],

  components: {
    ElCheckbox: checkbox_default.a,
    ElTooltip: tooltip_default.a
  },

  props: {
    store: {
      required: true
    },
    stripe: Boolean,
    context: {},
    rowClassName: [String, Function],
    rowStyle: [Object, Function],
    fixed: String,
    highlight: Boolean
  },

  render: function render(h) {
    var _this = this;

    var data = this.data || [];
    return h(
      'table',
      {
        'class': 'el-table__body',
        attrs: { cellspacing: '0',
          cellpadding: '0',
          border: '0' }
      },
      [h('colgroup', [this.columns.map(function (column) {
        return h('col', {
          attrs: { name: column.id },
          key: column.id });
      })]), h('tbody', [data.reduce(function (acc, row) {
        return acc.concat(_this.wrappedRowRender(row, acc.length));
      }, []), h('el-tooltip', {
        attrs: { effect: this.table.tooltipEffect, placement: 'top', content: this.tooltipContent },
        ref: 'tooltip' })])]
    );
  },


  computed: table_body_extends({
    table: function table() {
      return this.$parent;
    }
  }, mapStates({
    data: 'data',
    columns: 'columns',
    treeIndent: 'indent',
    leftFixedLeafCount: 'fixedLeafColumnsLength',
    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
    columnsCount: function columnsCount(states) {
      return states.columns.length;
    },
    leftFixedCount: function leftFixedCount(states) {
      return states.fixedColumns.length;
    },
    rightFixedCount: function rightFixedCount(states) {
      return states.rightFixedColumns.length;
    },
    hasExpandColumn: function hasExpandColumn(states) {
      return states.columns.some(function (_ref) {
        var type = _ref.type;
        return type === 'expand';
      });
    }
  }), {
    firstDefaultColumnIndex: function firstDefaultColumnIndex() {
      return Object(util_["arrayFindIndex"])(this.columns, function (_ref2) {
        var type = _ref2.type;
        return type === 'default';
      });
    }
  }),

  watch: {
    // don't trigger getter of currentRow in getCellClass. see https://jsfiddle.net/oe2b4hqt/
    // update DOM manually. see https://github.com/ElemeFE/element/pull/13954/files#diff-9b450c00d0a9dec0ffad5a3176972e40
    'store.states.hoverRow': function storeStatesHoverRow(newVal, oldVal) {
      var _this2 = this;

      if (!this.store.states.isComplex || this.$isServer) return;
      var raf = window.requestAnimationFrame;
      if (!raf) {
        raf = function raf(fn) {
          return setTimeout(fn, 16);
        };
      }
      raf(function () {
        var rows = _this2.$el.querySelectorAll('.el-table__row');
        var oldRow = rows[oldVal];
        var newRow = rows[newVal];
        if (oldRow) {
          Object(dom_["removeClass"])(oldRow, 'hover-row');
        }
        if (newRow) {
          Object(dom_["addClass"])(newRow, 'hover-row');
        }
      });
    }
  },

  data: function data() {
    return {
      tooltipContent: ''
    };
  },
  created: function created() {
    this.activateTooltip = debounce_default()(50, function (tooltip) {
      return tooltip.handleShowPopper();
    });
  },


  methods: {
    getKeyOfRow: function getKeyOfRow(row, index) {
      var rowKey = this.table.rowKey;
      if (rowKey) {
        return getRowIdentity(row, rowKey);
      }
      return index;
    },
    isColumnHidden: function isColumnHidden(index) {
      if (this.fixed === true || this.fixed === 'left') {
        return index >= this.leftFixedLeafCount;
      } else if (this.fixed === 'right') {
        return index < this.columnsCount - this.rightFixedLeafCount;
      } else {
        return index < this.leftFixedLeafCount || index >= this.columnsCount - this.rightFixedLeafCount;
      }
    },
    getSpan: function getSpan(row, column, rowIndex, columnIndex) {
      var rowspan = 1;
      var colspan = 1;
      var fn = this.table.spanMethod;
      if (typeof fn === 'function') {
        var result = fn({
          row: row,
          column: column,
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
        if (Array.isArray(result)) {
          rowspan = result[0];
          colspan = result[1];
        } else if ((typeof result === 'undefined' ? 'undefined' : table_body_typeof(result)) === 'object') {
          rowspan = result.rowspan;
          colspan = result.colspan;
        }
      }
      return { rowspan: rowspan, colspan: colspan };
    },
    getRowStyle: function getRowStyle(row, rowIndex) {
      var rowStyle = this.table.rowStyle;
      if (typeof rowStyle === 'function') {
        return rowStyle.call(null, {
          row: row,
          rowIndex: rowIndex
        });
      }
      return rowStyle || null;
    },
    getRowClass: function getRowClass(row, rowIndex) {
      var classes = ['el-table__row'];
      if (this.table.highlightCurrentRow && row === this.store.states.currentRow) {
        classes.push('current-row');
      }

      if (this.stripe && rowIndex % 2 === 1) {
        classes.push('el-table__row--striped');
      }
      var rowClassName = this.table.rowClassName;
      if (typeof rowClassName === 'string') {
        classes.push(rowClassName);
      } else if (typeof rowClassName === 'function') {
        classes.push(rowClassName.call(null, {
          row: row,
          rowIndex: rowIndex
        }));
      }

      if (this.store.states.expandRows.indexOf(row) > -1) {
        classes.push('expanded');
      }

      return classes;
    },
    getCellStyle: function getCellStyle(rowIndex, columnIndex, row, column) {
      var cellStyle = this.table.cellStyle;
      if (typeof cellStyle === 'function') {
        return cellStyle.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        });
      }
      return cellStyle;
    },
    getCellClass: function getCellClass(rowIndex, columnIndex, row, column) {
      var classes = [column.id, column.align, column.className];

      if (this.isColumnHidden(columnIndex)) {
        classes.push('is-hidden');
      }

      var cellClassName = this.table.cellClassName;
      if (typeof cellClassName === 'string') {
        classes.push(cellClassName);
      } else if (typeof cellClassName === 'function') {
        classes.push(cellClassName.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        }));
      }

      return classes.join(' ');
    },
    getColspanRealWidth: function getColspanRealWidth(columns, colspan, index) {
      if (colspan < 1) {
        return columns[index].realWidth;
      }
      var widthArr = columns.map(function (_ref3) {
        var realWidth = _ref3.realWidth;
        return realWidth;
      }).slice(index, index + colspan);
      return widthArr.reduce(function (acc, width) {
        return acc + width;
      }, -1);
    },
    handleCellMouseEnter: function handleCellMouseEnter(event, row) {
      var table = this.table;
      var cell = getCell(event);

      if (cell) {
        var column = getColumnByCell(table, cell);
        var hoverState = table.hoverState = { cell: cell, column: column, row: row };
        table.$emit('cell-mouse-enter', hoverState.row, hoverState.column, hoverState.cell, event);
      }

      // 判断是否text-overflow, 如果是就显示tooltip
      var cellChild = event.target.querySelector('.cell');
      if (!(Object(dom_["hasClass"])(cellChild, 'el-tooltip') && cellChild.childNodes.length)) {
        return;
      }
      // use range width instead of scrollWidth to determine whether the text is overflowing
      // to address a potential FireFox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1074543#c3
      var range = document.createRange();
      range.setStart(cellChild, 0);
      range.setEnd(cellChild, cellChild.childNodes.length);
      var rangeWidth = range.getBoundingClientRect().width;
      var padding = (parseInt(Object(dom_["getStyle"])(cellChild, 'paddingLeft'), 10) || 0) + (parseInt(Object(dom_["getStyle"])(cellChild, 'paddingRight'), 10) || 0);
      if ((rangeWidth + padding > cellChild.offsetWidth || cellChild.scrollWidth > cellChild.offsetWidth) && this.$refs.tooltip) {
        var tooltip = this.$refs.tooltip;
        // TODO 会引起整个 Table 的重新渲染，需要优化
        this.tooltipContent = cell.innerText || cell.textContent;
        tooltip.referenceElm = cell;
        tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
        tooltip.doDestroy();
        tooltip.setExpectedState(true);
        this.activateTooltip(tooltip);
      }
    },
    handleCellMouseLeave: function handleCellMouseLeave(event) {
      var tooltip = this.$refs.tooltip;
      if (tooltip) {
        tooltip.setExpectedState(false);
        tooltip.handleClosePopper();
      }
      var cell = getCell(event);
      if (!cell) return;

      var oldHoverState = this.table.hoverState || {};
      this.table.$emit('cell-mouse-leave', oldHoverState.row, oldHoverState.column, oldHoverState.cell, event);
    },


    handleMouseEnter: debounce_default()(30, function (index) {
      this.store.commit('setHoverRow', index);
    }),

    handleMouseLeave: debounce_default()(30, function () {
      this.store.commit('setHoverRow', null);
    }),

    handleContextMenu: function handleContextMenu(event, row) {
      this.handleEvent(event, row, 'contextmenu');
    },
    handleDoubleClick: function handleDoubleClick(event, row) {
      this.handleEvent(event, row, 'dblclick');
    },
    handleClick: function handleClick(event, row) {
      this.store.commit('setCurrentRow', row);
      this.handleEvent(event, row, 'click');
    },
    handleEvent: function handleEvent(event, row, name) {
      var table = this.table;
      var cell = getCell(event);
      var column = void 0;
      if (cell) {
        column = getColumnByCell(table, cell);
        if (column) {
          table.$emit('cell-' + name, row, column, cell, event);
        }
      }
      table.$emit('row-' + name, row, column, event);
    },
    rowRender: function rowRender(row, $index, treeRowData) {
      var _this3 = this;

      var h = this.$createElement;
      var treeIndent = this.treeIndent,
          columns = this.columns,
          firstDefaultColumnIndex = this.firstDefaultColumnIndex;

      var columnsHidden = columns.map(function (column, index) {
        return _this3.isColumnHidden(index);
      });
      var rowClasses = this.getRowClass(row, $index);
      var display = true;
      if (treeRowData) {
        rowClasses.push('el-table__row--level-' + treeRowData.level);
        display = treeRowData.display;
      }
      // 指令 v-show 会覆盖 row-style 中 display
      // 使用 :style 代替 v-show https://github.com/ElemeFE/element/issues/16995
      var displayStyle = display ? null : {
        display: 'none'
      };
      return h(
        'tr',
        {
          style: [displayStyle, this.getRowStyle(row, $index)],
          'class': rowClasses,
          key: this.getKeyOfRow(row, $index),
          on: {
            'dblclick': function dblclick($event) {
              return _this3.handleDoubleClick($event, row);
            },
            'click': function click($event) {
              return _this3.handleClick($event, row);
            },
            'contextmenu': function contextmenu($event) {
              return _this3.handleContextMenu($event, row);
            },
            'mouseenter': function mouseenter(_) {
              return _this3.handleMouseEnter($index);
            },
            'mouseleave': this.handleMouseLeave
          }
        },
        [columns.map(function (column, cellIndex) {
          var _getSpan = _this3.getSpan(row, column, $index, cellIndex),
              rowspan = _getSpan.rowspan,
              colspan = _getSpan.colspan;

          if (!rowspan || !colspan) {
            return null;
          }
          var columnData = table_body_extends({}, column);
          columnData.realWidth = _this3.getColspanRealWidth(columns, colspan, cellIndex);
          var data = {
            store: _this3.store,
            _self: _this3.context || _this3.table.$vnode.context,
            column: columnData,
            row: row,
            $index: $index
          };
          if (cellIndex === firstDefaultColumnIndex && treeRowData) {
            data.treeNode = {
              indent: treeRowData.level * treeIndent,
              level: treeRowData.level
            };
            if (typeof treeRowData.expanded === 'boolean') {
              data.treeNode.expanded = treeRowData.expanded;
              // 表明是懒加载
              if ('loading' in treeRowData) {
                data.treeNode.loading = treeRowData.loading;
              }
              if ('noLazyChildren' in treeRowData) {
                data.treeNode.noLazyChildren = treeRowData.noLazyChildren;
              }
            }
          }
          return h(
            'td',
            {
              style: _this3.getCellStyle($index, cellIndex, row, column),
              'class': _this3.getCellClass($index, cellIndex, row, column),
              attrs: { rowspan: rowspan,
                colspan: colspan
              },
              on: {
                'mouseenter': function mouseenter($event) {
                  return _this3.handleCellMouseEnter($event, row);
                },
                'mouseleave': _this3.handleCellMouseLeave
              }
            },
            [column.renderCell.call(_this3._renderProxy, _this3.$createElement, data, columnsHidden[cellIndex])]
          );
        })]
      );
    },
    wrappedRowRender: function wrappedRowRender(row, $index) {
      var _this4 = this;

      var h = this.$createElement;

      var store = this.store;
      var isRowExpanded = store.isRowExpanded,
          assertRowKey = store.assertRowKey;
      var _store$states = store.states,
          treeData = _store$states.treeData,
          lazyTreeNodeMap = _store$states.lazyTreeNodeMap,
          childrenColumnName = _store$states.childrenColumnName,
          rowKey = _store$states.rowKey;

      if (this.hasExpandColumn && isRowExpanded(row)) {
        var renderExpanded = this.table.renderExpanded;
        var tr = this.rowRender(row, $index);
        if (!renderExpanded) {
          console.error('[Element Error]renderExpanded is required.');
          return tr;
        }
        // 使用二维数组，避免修改 $index
        return [[tr, h(
          'tr',
          { key: 'expanded-row__' + tr.key },
          [h(
            'td',
            {
              attrs: { colspan: this.columnsCount },
              'class': 'el-table__expanded-cell' },
            [renderExpanded(this.$createElement, { row: row, $index: $index, store: this.store })]
          )]
        )]];
      } else if (Object.keys(treeData).length) {
        assertRowKey();
        // TreeTable 时，rowKey 必须由用户设定，不使用 getKeyOfRow 计算
        // 在调用 rowRender 函数时，仍然会计算 rowKey，不太好的操作
        var key = getRowIdentity(row, rowKey);
        var cur = treeData[key];
        var treeRowData = null;
        if (cur) {
          treeRowData = {
            expanded: cur.expanded,
            level: cur.level,
            display: true
          };
          if (typeof cur.lazy === 'boolean') {
            if (typeof cur.loaded === 'boolean' && cur.loaded) {
              treeRowData.noLazyChildren = !(cur.children && cur.children.length);
            }
            treeRowData.loading = cur.loading;
          }
        }
        var tmp = [this.rowRender(row, $index, treeRowData)];
        // 渲染嵌套数据
        if (cur) {
          // currentRow 记录的是 index，所以还需主动增加 TreeTable 的 index
          var i = 0;
          var traverse = function traverse(children, parent) {
            if (!(children && children.length && parent)) return;
            children.forEach(function (node) {
              // 父节点的 display 状态影响子节点的显示状态
              var innerTreeRowData = {
                display: parent.display && parent.expanded,
                level: parent.level + 1
              };
              var childKey = getRowIdentity(node, rowKey);
              if (childKey === undefined || childKey === null) {
                throw new Error('for nested data item, row-key is required.');
              }
              cur = table_body_extends({}, treeData[childKey]);
              // 对于当前节点，分成有无子节点两种情况。
              // 如果包含子节点的，设置 expanded 属性。
              // 对于它子节点的 display 属性由它本身的 expanded 与 display 共同决定。
              if (cur) {
                innerTreeRowData.expanded = cur.expanded;
                // 懒加载的某些节点，level 未知
                cur.level = cur.level || innerTreeRowData.level;
                cur.display = !!(cur.expanded && innerTreeRowData.display);
                if (typeof cur.lazy === 'boolean') {
                  if (typeof cur.loaded === 'boolean' && cur.loaded) {
                    innerTreeRowData.noLazyChildren = !(cur.children && cur.children.length);
                  }
                  innerTreeRowData.loading = cur.loading;
                }
              }
              i++;
              tmp.push(_this4.rowRender(node, $index + i, innerTreeRowData));
              if (cur) {
                var _nodes = lazyTreeNodeMap[childKey] || node[childrenColumnName];
                traverse(_nodes, cur);
              }
            });
          };
          // 对于 root 节点，display 一定为 true
          cur.display = true;
          var nodes = lazyTreeNodeMap[key] || row[childrenColumnName];
          traverse(nodes, cur);
        }
        return tmp;
      } else {
        return this.rowRender(row, $index);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&
var filter_panelvue_type_template_id_7f2c919f_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
    _vm.multiple
      ? _c(
          "div",
          {
            directives: [
              {
                name: "clickoutside",
                rawName: "v-clickoutside",
                value: _vm.handleOutsideClick,
                expression: "handleOutsideClick"
              },
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPopper,
                expression: "showPopper"
              }
            ],
            staticClass: "el-table-filter"
          },
          [
            _c(
              "div",
              { staticClass: "el-table-filter__content" },
              [
                _c(
                  "el-scrollbar",
                  { attrs: { "wrap-class": "el-table-filter__wrap" } },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        staticClass: "el-table-filter__checkbox-group",
                        model: {
                          value: _vm.filteredValue,
                          callback: function($$v) {
                            _vm.filteredValue = $$v
                          },
                          expression: "filteredValue"
                        }
                      },
                      _vm._l(_vm.filters, function(filter) {
                        return _c(
                          "el-checkbox",
                          { key: filter.value, attrs: { label: filter.value } },
                          [_vm._v(_vm._s(filter.text))]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "el-table-filter__bottom" }, [
              _c(
                "button",
                {
                  class: { "is-disabled": _vm.filteredValue.length === 0 },
                  attrs: { disabled: _vm.filteredValue.length === 0 },
                  on: { click: _vm.handleConfirm }
                },
                [_vm._v(_vm._s(_vm.t("el.table.confirmFilter")))]
              ),
              _c("button", { on: { click: _vm.handleReset } }, [
                _vm._v(_vm._s(_vm.t("el.table.resetFilter")))
              ])
            ])
          ]
        )
      : _c(
          "div",
          {
            directives: [
              {
                name: "clickoutside",
                rawName: "v-clickoutside",
                value: _vm.handleOutsideClick,
                expression: "handleOutsideClick"
              },
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPopper,
                expression: "showPopper"
              }
            ],
            staticClass: "el-table-filter"
          },
          [
            _c(
              "ul",
              { staticClass: "el-table-filter__list" },
              [
                _c(
                  "li",
                  {
                    staticClass: "el-table-filter__list-item",
                    class: {
                      "is-active":
                        _vm.filterValue === undefined ||
                        _vm.filterValue === null
                    },
                    on: {
                      click: function($event) {
                        _vm.handleSelect(null)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.t("el.table.clearFilter")))]
                ),
                _vm._l(_vm.filters, function(filter) {
                  return _c(
                    "li",
                    {
                      key: filter.value,
                      staticClass: "el-table-filter__list-item",
                      class: { "is-active": _vm.isActive(filter) },
                      attrs: { label: filter.value },
                      on: {
                        click: function($event) {
                          _vm.handleSelect(filter.value)
                        }
                      }
                    },
                    [_vm._v(_vm._s(filter.text))]
                  )
                })
              ],
              2
            )
          ]
        )
  ])
}
var filter_panelvue_type_template_id_7f2c919f_staticRenderFns = []
filter_panelvue_type_template_id_7f2c919f_render._withStripped = true


// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&

// CONCATENATED MODULE: ./packages/table/src/dropdown.js

var dropdowns = [];

!external_vue_default.a.prototype.$isServer && document.addEventListener('click', function (event) {
  dropdowns.forEach(function (dropdown) {
    var target = event.target;
    if (!dropdown || !dropdown.$el) return;
    if (target === dropdown.$el || dropdown.$el.contains(target)) {
      return;
    }
    dropdown.handleOutsideClick && dropdown.handleOutsideClick(event);
  });
});

/* harmony default export */ var src_dropdown = ({
  open: function open(instance) {
    if (instance) {
      dropdowns.push(instance);
    }
  },
  close: function close(instance) {
    var index = dropdowns.indexOf(instance);
    if (index !== -1) {
      dropdowns.splice(instance, 1);
    }
  }
});
// EXTERNAL MODULE: external "element-ui/lib/checkbox-group"
var checkbox_group_ = __webpack_require__(32);
var checkbox_group_default = /*#__PURE__*/__webpack_require__.n(checkbox_group_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var filter_panelvue_type_script_lang_js_ = ({
  name: 'ElTableFilterPanel',

  mixins: [vue_popper_default.a, locale_default.a],

  directives: {
    Clickoutside: clickoutside_default.a
  },

  components: {
    ElCheckbox: checkbox_default.a,
    ElCheckboxGroup: checkbox_group_default.a,
    ElScrollbar: scrollbar_default.a
  },

  props: {
    placement: {
      type: String,
      default: 'bottom-end'
    }
  },

  methods: {
    isActive: function isActive(filter) {
      return filter.value === this.filterValue;
    },
    handleOutsideClick: function handleOutsideClick() {
      var _this = this;

      setTimeout(function () {
        _this.showPopper = false;
      }, 16);
    },
    handleConfirm: function handleConfirm() {
      this.confirmFilter(this.filteredValue);
      this.handleOutsideClick();
    },
    handleReset: function handleReset() {
      this.filteredValue = [];
      this.confirmFilter(this.filteredValue);
      this.handleOutsideClick();
    },
    handleSelect: function handleSelect(filterValue) {
      this.filterValue = filterValue;

      if (typeof filterValue !== 'undefined' && filterValue !== null) {
        this.confirmFilter(this.filteredValue);
      } else {
        this.confirmFilter([]);
      }

      this.handleOutsideClick();
    },
    confirmFilter: function confirmFilter(filteredValue) {
      this.table.store.commit('filterChange', {
        column: this.column,
        values: filteredValue
      });
      this.table.store.updateAllSelected();
    }
  },

  data: function data() {
    return {
      table: null,
      cell: null,
      column: null
    };
  },


  computed: {
    filters: function filters() {
      return this.column && this.column.filters;
    },


    filterValue: {
      get: function get() {
        return (this.column.filteredValue || [])[0];
      },
      set: function set(value) {
        if (this.filteredValue) {
          if (typeof value !== 'undefined' && value !== null) {
            this.filteredValue.splice(0, 1, value);
          } else {
            this.filteredValue.splice(0, 1);
          }
        }
      }
    },

    filteredValue: {
      get: function get() {
        if (this.column) {
          return this.column.filteredValue || [];
        }
        return [];
      },
      set: function set(value) {
        if (this.column) {
          this.column.filteredValue = value;
        }
      }
    },

    multiple: function multiple() {
      if (this.column) {
        return this.column.filterMultiple;
      }
      return true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.popperElm = this.$el;
    this.referenceElm = this.cell;
    this.table.bodyWrapper.addEventListener('scroll', function () {
      _this2.updatePopper();
    });

    this.$watch('showPopper', function (value) {
      if (_this2.column) _this2.column.filterOpened = value;
      if (value) {
        src_dropdown.open(_this2);
      } else {
        src_dropdown.close(_this2);
      }
    });
  },

  watch: {
    showPopper: function showPopper(val) {
      if (val === true && parseInt(this.popperJS._popper.style.zIndex, 10) < popup_["PopupManager"].zIndex) {
        this.popperJS._popper.style.zIndex = popup_["PopupManager"].nextZIndex();
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_filter_panelvue_type_script_lang_js_ = (filter_panelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue





/* normalize component */

var filter_panel_component = normalizeComponent(
  src_filter_panelvue_type_script_lang_js_,
  filter_panelvue_type_template_id_7f2c919f_render,
  filter_panelvue_type_template_id_7f2c919f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var filter_panel_api; }
filter_panel_component.options.__file = "packages/table/src/filter-panel.vue"
/* harmony default export */ var filter_panel = (filter_panel_component.exports);
// CONCATENATED MODULE: ./packages/table/src/table-header.js
var table_header_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var getAllColumns = function getAllColumns(columns) {
  var result = [];
  columns.forEach(function (column) {
    if (column.children) {
      result.push(column);
      result.push.apply(result, getAllColumns(column.children));
    } else {
      result.push(column);
    }
  });
  return result;
};

var convertToRows = function convertToRows(originColumns) {
  var maxLevel = 1;
  var traverse = function traverse(column, parent) {
    if (parent) {
      column.level = parent.level + 1;
      if (maxLevel < column.level) {
        maxLevel = column.level;
      }
    }
    if (column.children) {
      var colSpan = 0;
      column.children.forEach(function (subColumn) {
        traverse(subColumn, column);
        colSpan += subColumn.colSpan;
      });
      column.colSpan = colSpan;
    } else {
      column.colSpan = 1;
    }
  };

  originColumns.forEach(function (column) {
    column.level = 1;
    traverse(column);
  });

  var rows = [];
  for (var i = 0; i < maxLevel; i++) {
    rows.push([]);
  }

  var allColumns = getAllColumns(originColumns);

  allColumns.forEach(function (column) {
    if (!column.children) {
      column.rowSpan = maxLevel - column.level + 1;
    } else {
      column.rowSpan = 1;
    }
    rows[column.level - 1].push(column);
  });

  return rows;
};

/* harmony default export */ var table_header = ({
  name: 'ElTableHeader',

  mixins: [layout_observer],

  render: function render(h) {
    var _this = this;

    var originColumns = this.store.states.originColumns;
    var columnRows = convertToRows(originColumns, this.columns);
    // 是否拥有多级表头
    var isGroup = columnRows.length > 1;
    if (isGroup) this.$parent.isGroup = true;
    return h(
      'table',
      {
        'class': 'el-table__header',
        attrs: { cellspacing: '0',
          cellpadding: '0',
          border: '0' }
      },
      [h('colgroup', [this.columns.map(function (column) {
        return h('col', {
          attrs: { name: column.id },
          key: column.id });
      }), this.hasGutter ? h('col', {
        attrs: { name: 'gutter' }
      }) : '']), h(
        'thead',
        { 'class': [{ 'is-group': isGroup, 'has-gutter': this.hasGutter }] },
        [this._l(columnRows, function (columns, rowIndex) {
          return h(
            'tr',
            {
              style: _this.getHeaderRowStyle(rowIndex),
              'class': _this.getHeaderRowClass(rowIndex)
            },
            [columns.map(function (column, cellIndex) {
              return h(
                'th',
                {
                  attrs: {
                    colspan: column.colSpan,
                    rowspan: column.rowSpan
                  },
                  on: {
                    'mousemove': function mousemove($event) {
                      return _this.handleMouseMove($event, column);
                    },
                    'mouseout': _this.handleMouseOut,
                    'mousedown': function mousedown($event) {
                      return _this.handleMouseDown($event, column);
                    },
                    'click': function click($event) {
                      return _this.handleHeaderClick($event, column);
                    },
                    'contextmenu': function contextmenu($event) {
                      return _this.handleHeaderContextMenu($event, column);
                    }
                  },

                  style: _this.getHeaderCellStyle(rowIndex, cellIndex, columns, column),
                  'class': _this.getHeaderCellClass(rowIndex, cellIndex, columns, column),
                  key: column.id },
                [h(
                  'div',
                  { 'class': ['cell', column.filteredValue && column.filteredValue.length > 0 ? 'highlight' : '', column.labelClassName] },
                  [column.renderHeader ? column.renderHeader.call(_this._renderProxy, h, { column: column, $index: cellIndex, store: _this.store, _self: _this.$parent.$vnode.context }) : column.label, column.sortable ? h(
                    'span',
                    {
                      'class': 'caret-wrapper',
                      on: {
                        'click': function click($event) {
                          return _this.handleSortClick($event, column);
                        }
                      }
                    },
                    [h('i', { 'class': 'sort-caret ascending',
                      on: {
                        'click': function click($event) {
                          return _this.handleSortClick($event, column, 'ascending');
                        }
                      }
                    }), h('i', { 'class': 'sort-caret descending',
                      on: {
                        'click': function click($event) {
                          return _this.handleSortClick($event, column, 'descending');
                        }
                      }
                    })]
                  ) : '', column.filterable ? h(
                    'span',
                    {
                      'class': 'el-table__column-filter-trigger',
                      on: {
                        'click': function click($event) {
                          return _this.handleFilterClick($event, column);
                        }
                      }
                    },
                    [h('i', { 'class': ['el-icon-arrow-down', column.filterOpened ? 'el-icon-arrow-up' : ''] })]
                  ) : '']
                )]
              );
            }), _this.hasGutter ? h('th', { 'class': 'gutter' }) : '']
          );
        })]
      )]
    );
  },


  props: {
    fixed: String,
    store: {
      required: true
    },
    border: Boolean,
    defaultSort: {
      type: Object,
      default: function _default() {
        return {
          prop: '',
          order: ''
        };
      }
    }
  },

  components: {
    ElCheckbox: checkbox_default.a
  },

  computed: table_header_extends({
    table: function table() {
      return this.$parent;
    },
    hasGutter: function hasGutter() {
      return !this.fixed && this.tableLayout.gutterWidth;
    }
  }, mapStates({
    columns: 'columns',
    isAllSelected: 'isAllSelected',
    leftFixedLeafCount: 'fixedLeafColumnsLength',
    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
    columnsCount: function columnsCount(states) {
      return states.columns.length;
    },
    leftFixedCount: function leftFixedCount(states) {
      return states.fixedColumns.length;
    },
    rightFixedCount: function rightFixedCount(states) {
      return states.rightFixedColumns.length;
    }
  })),

  created: function created() {
    this.filterPanels = {};
  },
  mounted: function mounted() {
    var _this2 = this;

    // nextTick 是有必要的 https://github.com/ElemeFE/element/pull/11311
    this.$nextTick(function () {
      var _defaultSort = _this2.defaultSort,
          prop = _defaultSort.prop,
          order = _defaultSort.order;

      var init = true;
      _this2.store.commit('sort', { prop: prop, order: order, init: init });
    });
  },
  beforeDestroy: function beforeDestroy() {
    var panels = this.filterPanels;
    for (var prop in panels) {
      if (panels.hasOwnProperty(prop) && panels[prop]) {
        panels[prop].$destroy(true);
      }
    }
  },


  methods: {
    isCellHidden: function isCellHidden(index, columns) {
      var start = 0;
      for (var i = 0; i < index; i++) {
        start += columns[i].colSpan;
      }
      var after = start + columns[index].colSpan - 1;
      if (this.fixed === true || this.fixed === 'left') {
        return after >= this.leftFixedLeafCount;
      } else if (this.fixed === 'right') {
        return start < this.columnsCount - this.rightFixedLeafCount;
      } else {
        return after < this.leftFixedLeafCount || start >= this.columnsCount - this.rightFixedLeafCount;
      }
    },
    getHeaderRowStyle: function getHeaderRowStyle(rowIndex) {
      var headerRowStyle = this.table.headerRowStyle;
      if (typeof headerRowStyle === 'function') {
        return headerRowStyle.call(null, { rowIndex: rowIndex });
      }
      return headerRowStyle;
    },
    getHeaderRowClass: function getHeaderRowClass(rowIndex) {
      var classes = [];

      var headerRowClassName = this.table.headerRowClassName;
      if (typeof headerRowClassName === 'string') {
        classes.push(headerRowClassName);
      } else if (typeof headerRowClassName === 'function') {
        classes.push(headerRowClassName.call(null, { rowIndex: rowIndex }));
      }

      return classes.join(' ');
    },
    getHeaderCellStyle: function getHeaderCellStyle(rowIndex, columnIndex, row, column) {
      var headerCellStyle = this.table.headerCellStyle;
      if (typeof headerCellStyle === 'function') {
        return headerCellStyle.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        });
      }
      return headerCellStyle;
    },
    getHeaderCellClass: function getHeaderCellClass(rowIndex, columnIndex, row, column) {
      var classes = [column.id, column.order, column.headerAlign, column.className, column.labelClassName];

      if (rowIndex === 0 && this.isCellHidden(columnIndex, row)) {
        classes.push('is-hidden');
      }

      if (!column.children) {
        classes.push('is-leaf');
      }

      if (column.sortable) {
        classes.push('is-sortable');
      }

      var headerCellClassName = this.table.headerCellClassName;
      if (typeof headerCellClassName === 'string') {
        classes.push(headerCellClassName);
      } else if (typeof headerCellClassName === 'function') {
        classes.push(headerCellClassName.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        }));
      }

      return classes.join(' ');
    },
    toggleAllSelection: function toggleAllSelection(event) {
      event.stopPropagation();
      this.store.commit('toggleAllSelection');
    },
    handleFilterClick: function handleFilterClick(event, column) {
      event.stopPropagation();
      var target = event.target;
      var cell = target.tagName === 'TH' ? target : target.parentNode;
      if (Object(dom_["hasClass"])(cell, 'noclick')) return;
      cell = cell.querySelector('.el-table__column-filter-trigger') || cell;
      var table = this.$parent;

      var filterPanel = this.filterPanels[column.id];

      if (filterPanel && column.filterOpened) {
        filterPanel.showPopper = false;
        return;
      }

      if (!filterPanel) {
        filterPanel = new external_vue_default.a(filter_panel);
        this.filterPanels[column.id] = filterPanel;
        if (column.filterPlacement) {
          filterPanel.placement = column.filterPlacement;
        }
        filterPanel.table = table;
        filterPanel.cell = cell;
        filterPanel.column = column;
        !this.$isServer && filterPanel.$mount(document.createElement('div'));
      }

      setTimeout(function () {
        filterPanel.showPopper = true;
      }, 16);
    },
    handleHeaderClick: function handleHeaderClick(event, column) {
      if (!column.filters && column.sortable) {
        this.handleSortClick(event, column);
      } else if (column.filterable && !column.sortable) {
        this.handleFilterClick(event, column);
      }

      this.$parent.$emit('header-click', column, event);
    },
    handleHeaderContextMenu: function handleHeaderContextMenu(event, column) {
      this.$parent.$emit('header-contextmenu', column, event);
    },
    handleMouseDown: function handleMouseDown(event, column) {
      var _this3 = this;

      if (this.$isServer) return;
      if (column.children && column.children.length > 0) return;
      /* istanbul ignore if */
      if (this.draggingColumn && this.border) {
        this.dragging = true;

        this.$parent.resizeProxyVisible = true;

        var table = this.$parent;
        var tableEl = table.$el;
        var tableLeft = tableEl.getBoundingClientRect().left;
        var columnEl = this.$el.querySelector('th.' + column.id);
        var columnRect = columnEl.getBoundingClientRect();
        var minLeft = columnRect.left - tableLeft + 30;

        Object(dom_["addClass"])(columnEl, 'noclick');

        this.dragState = {
          startMouseLeft: event.clientX,
          startLeft: columnRect.right - tableLeft,
          startColumnLeft: columnRect.left - tableLeft,
          tableLeft: tableLeft
        };

        var resizeProxy = table.$refs.resizeProxy;
        resizeProxy.style.left = this.dragState.startLeft + 'px';

        document.onselectstart = function () {
          return false;
        };
        document.ondragstart = function () {
          return false;
        };

        var handleMouseMove = function handleMouseMove(event) {
          var deltaLeft = event.clientX - _this3.dragState.startMouseLeft;
          var proxyLeft = _this3.dragState.startLeft + deltaLeft;

          resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px';
        };

        var handleMouseUp = function handleMouseUp() {
          if (_this3.dragging) {
            var _dragState = _this3.dragState,
                startColumnLeft = _dragState.startColumnLeft,
                startLeft = _dragState.startLeft;

            var finalLeft = parseInt(resizeProxy.style.left, 10);
            var columnWidth = finalLeft - startColumnLeft;
            column.width = column.realWidth = columnWidth;
            table.$emit('header-dragend', column.width, startLeft - startColumnLeft, column, event);

            _this3.store.scheduleLayout();

            document.body.style.cursor = '';
            _this3.dragging = false;
            _this3.draggingColumn = null;
            _this3.dragState = {};

            table.resizeProxyVisible = false;
          }

          document.removeEventListener('mousemove', handleMouseMove);
          document.removeEventListener('mouseup', handleMouseUp);
          document.onselectstart = null;
          document.ondragstart = null;

          setTimeout(function () {
            Object(dom_["removeClass"])(columnEl, 'noclick');
          }, 0);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
      }
    },
    handleMouseMove: function handleMouseMove(event, column) {
      if (column.children && column.children.length > 0) return;
      var target = event.target;
      while (target && target.tagName !== 'TH') {
        target = target.parentNode;
      }

      if (!column || !column.resizable) return;

      if (!this.dragging && this.border) {
        var rect = target.getBoundingClientRect();

        var bodyStyle = document.body.style;
        if (rect.width > 12 && rect.right - event.pageX < 8) {
          bodyStyle.cursor = 'col-resize';
          if (Object(dom_["hasClass"])(target, 'is-sortable')) {
            target.style.cursor = 'col-resize';
          }
          this.draggingColumn = column;
        } else if (!this.dragging) {
          bodyStyle.cursor = '';
          if (Object(dom_["hasClass"])(target, 'is-sortable')) {
            target.style.cursor = 'pointer';
          }
          this.draggingColumn = null;
        }
      }
    },
    handleMouseOut: function handleMouseOut() {
      if (this.$isServer) return;
      document.body.style.cursor = '';
    },
    toggleOrder: function toggleOrder(_ref) {
      var order = _ref.order,
          sortOrders = _ref.sortOrders;

      if (order === '') return sortOrders[0];
      var index = sortOrders.indexOf(order || null);
      return sortOrders[index > sortOrders.length - 2 ? 0 : index + 1];
    },
    handleSortClick: function handleSortClick(event, column, givenOrder) {
      event.stopPropagation();
      var order = column.order === givenOrder ? null : givenOrder || this.toggleOrder(column);

      var target = event.target;
      while (target && target.tagName !== 'TH') {
        target = target.parentNode;
      }

      if (target && target.tagName === 'TH') {
        if (Object(dom_["hasClass"])(target, 'noclick')) {
          Object(dom_["removeClass"])(target, 'noclick');
          return;
        }
      }

      if (!column.sortable) return;

      var states = this.store.states;
      var sortProp = states.sortProp;
      var sortOrder = void 0;
      var sortingColumn = states.sortingColumn;

      if (sortingColumn !== column || sortingColumn === column && sortingColumn.order === null) {
        if (sortingColumn) {
          sortingColumn.order = null;
        }
        states.sortingColumn = column;
        sortProp = column.property;
      }

      if (!order) {
        sortOrder = column.order = null;
      } else {
        sortOrder = column.order = order;
      }

      states.sortProp = sortProp;
      states.sortOrder = sortOrder;

      this.store.commit('changeSortCondition');
    }
  },

  data: function data() {
    return {
      draggingColumn: null,
      dragging: false,
      dragState: {}
    };
  }
});
// CONCATENATED MODULE: ./packages/table/src/table-footer.js
var table_footer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var table_footer = ({
  name: 'ElTableFooter',

  mixins: [layout_observer],

  render: function render(h) {
    var _this = this;

    var sums = [];
    if (this.summaryMethod) {
      sums = this.summaryMethod({ columns: this.columns, data: this.store.states.data });
    } else {
      this.columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = _this.sumText;
          return;
        }
        var values = _this.store.states.data.map(function (item) {
          return Number(item[column.property]);
        });
        var precisions = [];
        var notNumber = true;
        values.forEach(function (value) {
          if (!isNaN(value)) {
            notNumber = false;
            var decimal = ('' + value).split('.')[1];
            precisions.push(decimal ? decimal.length : 0);
          }
        });
        var precision = Math.max.apply(null, precisions);
        if (!notNumber) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return parseFloat((prev + curr).toFixed(Math.min(precision, 20)));
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = '';
        }
      });
    }

    return h(
      'table',
      {
        'class': 'el-table__footer',
        attrs: { cellspacing: '0',
          cellpadding: '0',
          border: '0' }
      },
      [h('colgroup', [this.columns.map(function (column) {
        return h('col', {
          attrs: { name: column.id },
          key: column.id });
      }), this.hasGutter ? h('col', {
        attrs: { name: 'gutter' }
      }) : '']), h(
        'tbody',
        { 'class': [{ 'has-gutter': this.hasGutter }] },
        [h('tr', [this.columns.map(function (column, cellIndex) {
          return h(
            'td',
            {
              key: cellIndex,
              attrs: { colspan: column.colSpan,
                rowspan: column.rowSpan
              },
              'class': _this.getRowClasses(column, cellIndex) },
            [h(
              'div',
              { 'class': ['cell', column.labelClassName] },
              [sums[cellIndex]]
            )]
          );
        }), this.hasGutter ? h('th', { 'class': 'gutter' }) : ''])]
      )]
    );
  },


  props: {
    fixed: String,
    store: {
      required: true
    },
    summaryMethod: Function,
    sumText: String,
    border: Boolean,
    defaultSort: {
      type: Object,
      default: function _default() {
        return {
          prop: '',
          order: ''
        };
      }
    }
  },

  computed: table_footer_extends({
    table: function table() {
      return this.$parent;
    },
    hasGutter: function hasGutter() {
      return !this.fixed && this.tableLayout.gutterWidth;
    }
  }, mapStates({
    columns: 'columns',
    isAllSelected: 'isAllSelected',
    leftFixedLeafCount: 'fixedLeafColumnsLength',
    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
    columnsCount: function columnsCount(states) {
      return states.columns.length;
    },
    leftFixedCount: function leftFixedCount(states) {
      return states.fixedColumns.length;
    },
    rightFixedCount: function rightFixedCount(states) {
      return states.rightFixedColumns.length;
    }
  })),

  methods: {
    isCellHidden: function isCellHidden(index, columns, column) {
      if (this.fixed === true || this.fixed === 'left') {
        return index >= this.leftFixedLeafCount;
      } else if (this.fixed === 'right') {
        var before = 0;
        for (var i = 0; i < index; i++) {
          before += columns[i].colSpan;
        }
        return before < this.columnsCount - this.rightFixedLeafCount;
      } else if (!this.fixed && column.fixed) {
        // hide cell when footer instance is not fixed and column is fixed
        return true;
      } else {
        return index < this.leftFixedCount || index >= this.columnsCount - this.rightFixedCount;
      }
    },
    getRowClasses: function getRowClasses(column, cellIndex) {
      var classes = [column.id, column.align, column.labelClassName];
      if (column.className) {
        classes.push(column.className);
      }
      if (this.isCellHidden(cellIndex, this.columns, column)) {
        classes.push('is-hidden');
      }
      if (!column.children) {
        classes.push('is-leaf');
      }
      return classes;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=script&lang=js&
var tablevue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var tableIdSeed = 1;

/* harmony default export */ var tablevue_type_script_lang_js_ = ({
  name: 'ElTable',

  mixins: [locale_default.a, migrating_default.a],

  directives: {
    Mousewheel: directives_mousewheel
  },

  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    size: String,

    width: [String, Number],

    height: [String, Number],

    maxHeight: [String, Number],

    fit: {
      type: Boolean,
      default: true
    },

    stripe: Boolean,

    border: Boolean,

    rowKey: [String, Function],

    context: {},

    showHeader: {
      type: Boolean,
      default: true
    },

    showSummary: Boolean,

    sumText: String,

    summaryMethod: Function,

    rowClassName: [String, Function],

    rowStyle: [Object, Function],

    cellClassName: [String, Function],

    cellStyle: [Object, Function],

    headerRowClassName: [String, Function],

    headerRowStyle: [Object, Function],

    headerCellClassName: [String, Function],

    headerCellStyle: [Object, Function],

    highlightCurrentRow: Boolean,

    currentRowKey: [String, Number],

    emptyText: String,

    expandRowKeys: Array,

    defaultExpandAll: Boolean,

    defaultSort: Object,

    tooltipEffect: String,

    spanMethod: Function,

    selectOnIndeterminate: {
      type: Boolean,
      default: true
    },

    indent: {
      type: Number,
      default: 16
    },

    treeProps: {
      type: Object,
      default: function _default() {
        return {
          hasChildren: 'hasChildren',
          children: 'children'
        };
      }
    },

    lazy: Boolean,

    load: Function
  },

  components: {
    TableHeader: table_header,
    TableFooter: table_footer,
    TableBody: table_body,
    ElCheckbox: checkbox_default.a
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        events: {
          expand: 'expand is renamed to expand-change'
        }
      };
    },
    setCurrentRow: function setCurrentRow(row) {
      this.store.commit('setCurrentRow', row);
    },
    toggleRowSelection: function toggleRowSelection(row, selected) {
      this.store.toggleRowSelection(row, selected, false);
      this.store.updateAllSelected();
    },
    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
      this.store.toggleRowExpansionAdapter(row, expanded);
    },
    clearSelection: function clearSelection() {
      this.store.clearSelection();
    },
    clearFilter: function clearFilter(columnKeys) {
      this.store.clearFilter(columnKeys);
    },
    clearSort: function clearSort() {
      this.store.clearSort();
    },
    handleMouseLeave: function handleMouseLeave() {
      this.store.commit('setHoverRow', null);
      if (this.hoverState) this.hoverState = null;
    },
    updateScrollY: function updateScrollY() {
      var changed = this.layout.updateScrollY();
      if (changed) {
        this.layout.notifyObservers('scrollable');
        this.layout.updateColumnsWidth();
      }
    },
    handleFixedMousewheel: function handleFixedMousewheel(event, data) {
      var bodyWrapper = this.bodyWrapper;
      if (Math.abs(data.spinY) > 0) {
        var currentScrollTop = bodyWrapper.scrollTop;
        if (data.pixelY < 0 && currentScrollTop !== 0) {
          event.preventDefault();
        }
        if (data.pixelY > 0 && bodyWrapper.scrollHeight - bodyWrapper.clientHeight > currentScrollTop) {
          event.preventDefault();
        }
        bodyWrapper.scrollTop += Math.ceil(data.pixelY / 5);
      } else {
        bodyWrapper.scrollLeft += Math.ceil(data.pixelX / 5);
      }
    },
    handleHeaderFooterMousewheel: function handleHeaderFooterMousewheel(event, data) {
      var pixelX = data.pixelX,
          pixelY = data.pixelY;

      if (Math.abs(pixelX) >= Math.abs(pixelY)) {
        this.bodyWrapper.scrollLeft += data.pixelX / 5;
      }
    },


    // TODO 使用 CSS transform
    syncPostion: Object(external_throttle_debounce_["throttle"])(20, function () {
      var _bodyWrapper = this.bodyWrapper,
          scrollLeft = _bodyWrapper.scrollLeft,
          scrollTop = _bodyWrapper.scrollTop,
          offsetWidth = _bodyWrapper.offsetWidth,
          scrollWidth = _bodyWrapper.scrollWidth;
      var _$refs = this.$refs,
          headerWrapper = _$refs.headerWrapper,
          footerWrapper = _$refs.footerWrapper,
          fixedBodyWrapper = _$refs.fixedBodyWrapper,
          rightFixedBodyWrapper = _$refs.rightFixedBodyWrapper;

      if (headerWrapper) headerWrapper.scrollLeft = scrollLeft;
      if (footerWrapper) footerWrapper.scrollLeft = scrollLeft;
      if (fixedBodyWrapper) fixedBodyWrapper.scrollTop = scrollTop;
      if (rightFixedBodyWrapper) rightFixedBodyWrapper.scrollTop = scrollTop;
      var maxScrollLeftPosition = scrollWidth - offsetWidth - 1;
      if (scrollLeft >= maxScrollLeftPosition) {
        this.scrollPosition = 'right';
      } else if (scrollLeft === 0) {
        this.scrollPosition = 'left';
      } else {
        this.scrollPosition = 'middle';
      }
    }),

    bindEvents: function bindEvents() {
      this.bodyWrapper.addEventListener('scroll', this.syncPostion, { passive: true });
      if (this.fit) {
        Object(resize_event_["addResizeListener"])(this.$el, this.resizeListener);
      }
    },
    unbindEvents: function unbindEvents() {
      this.bodyWrapper.removeEventListener('scroll', this.syncPostion, { passive: true });
      if (this.fit) {
        Object(resize_event_["removeResizeListener"])(this.$el, this.resizeListener);
      }
    },
    resizeListener: function resizeListener() {
      if (!this.$ready) return;
      var shouldUpdateLayout = false;
      var el = this.$el;
      var _resizeState = this.resizeState,
          oldWidth = _resizeState.width,
          oldHeight = _resizeState.height;


      var width = el.offsetWidth;
      if (oldWidth !== width) {
        shouldUpdateLayout = true;
      }

      var height = el.offsetHeight;
      if ((this.height || this.shouldUpdateHeight) && oldHeight !== height) {
        shouldUpdateLayout = true;
      }

      if (shouldUpdateLayout) {
        this.resizeState.width = width;
        this.resizeState.height = height;
        this.doLayout();
      }
    },
    doLayout: function doLayout() {
      if (this.shouldUpdateHeight) {
        this.layout.updateElsHeight();
      }
      this.layout.updateColumnsWidth();
    },
    sort: function sort(prop, order) {
      this.store.commit('sort', { prop: prop, order: order });
    },
    toggleAllSelection: function toggleAllSelection() {
      this.store.commit('toggleAllSelection');
    }
  },

  computed: tablevue_type_script_lang_js_extends({
    tableSize: function tableSize() {
      return this.size || (this.$ELEMENT || {}).size;
    },
    bodyWrapper: function bodyWrapper() {
      return this.$refs.bodyWrapper;
    },
    shouldUpdateHeight: function shouldUpdateHeight() {
      return this.height || this.maxHeight || this.fixedColumns.length > 0 || this.rightFixedColumns.length > 0;
    },
    bodyWidth: function bodyWidth() {
      var _layout = this.layout,
          bodyWidth = _layout.bodyWidth,
          scrollY = _layout.scrollY,
          gutterWidth = _layout.gutterWidth;

      return bodyWidth ? bodyWidth - (scrollY ? gutterWidth : 0) + 'px' : '';
    },
    bodyHeight: function bodyHeight() {
      var _layout2 = this.layout,
          _layout2$headerHeight = _layout2.headerHeight,
          headerHeight = _layout2$headerHeight === undefined ? 0 : _layout2$headerHeight,
          bodyHeight = _layout2.bodyHeight,
          _layout2$footerHeight = _layout2.footerHeight,
          footerHeight = _layout2$footerHeight === undefined ? 0 : _layout2$footerHeight;

      if (this.height) {
        return {
          height: bodyHeight ? bodyHeight + 'px' : ''
        };
      } else if (this.maxHeight) {
        var maxHeight = parseHeight(this.maxHeight);
        if (typeof maxHeight === 'number') {
          return {
            'max-height': maxHeight - footerHeight - (this.showHeader ? headerHeight : 0) + 'px'
          };
        }
      }
      return {};
    },
    fixedBodyHeight: function fixedBodyHeight() {
      if (this.height) {
        return {
          height: this.layout.fixedBodyHeight ? this.layout.fixedBodyHeight + 'px' : ''
        };
      } else if (this.maxHeight) {
        var maxHeight = parseHeight(this.maxHeight);
        if (typeof maxHeight === 'number') {
          maxHeight = this.layout.scrollX ? maxHeight - this.layout.gutterWidth : maxHeight;
          if (this.showHeader) {
            maxHeight -= this.layout.headerHeight;
          }
          maxHeight -= this.layout.footerHeight;
          return {
            'max-height': maxHeight + 'px'
          };
        }
      }
      return {};
    },
    fixedHeight: function fixedHeight() {
      if (this.maxHeight) {
        if (this.showSummary) {
          return {
            bottom: 0
          };
        }
        return {
          bottom: this.layout.scrollX && this.data.length ? this.layout.gutterWidth + 'px' : ''
        };
      } else {
        if (this.showSummary) {
          return {
            height: this.layout.tableHeight ? this.layout.tableHeight + 'px' : ''
          };
        }
        return {
          height: this.layout.viewportHeight ? this.layout.viewportHeight + 'px' : ''
        };
      }
    },
    emptyBlockStyle: function emptyBlockStyle() {
      if (this.data && this.data.length) return null;
      var height = '100%';
      if (this.layout.appendHeight) {
        height = 'calc(100% - ' + this.layout.appendHeight + 'px)';
      }
      return {
        width: this.bodyWidth,
        height: height
      };
    }
  }, mapStates({
    selection: 'selection',
    columns: 'columns',
    tableData: 'data',
    fixedColumns: 'fixedColumns',
    rightFixedColumns: 'rightFixedColumns'
  })),

  watch: {
    height: {
      immediate: true,
      handler: function handler(value) {
        this.layout.setHeight(value);
      }
    },

    maxHeight: {
      immediate: true,
      handler: function handler(value) {
        this.layout.setMaxHeight(value);
      }
    },

    currentRowKey: {
      immediate: true,
      handler: function handler(value) {
        if (!this.rowKey) return;
        this.store.setCurrentRowKey(value);
      }
    },

    data: {
      immediate: true,
      handler: function handler(value) {
        this.store.commit('setData', value);
      }
    },

    expandRowKeys: {
      immediate: true,
      handler: function handler(newVal) {
        if (newVal) {
          this.store.setExpandRowKeysAdapter(newVal);
        }
      }
    }
  },

  created: function created() {
    var _this = this;

    this.tableId = 'el-table_' + tableIdSeed++;
    this.debouncedUpdateLayout = Object(external_throttle_debounce_["debounce"])(50, function () {
      return _this.doLayout();
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.bindEvents();
    this.store.updateColumns();
    this.doLayout();

    this.resizeState = {
      width: this.$el.offsetWidth,
      height: this.$el.offsetHeight
    };

    // init filters
    this.store.states.columns.forEach(function (column) {
      if (column.filteredValue && column.filteredValue.length) {
        _this2.store.commit('filterChange', {
          column: column,
          values: column.filteredValue,
          silent: true
        });
      }
    });

    this.$ready = true;
  },
  destroyed: function destroyed() {
    this.unbindEvents();
  },
  data: function data() {
    var _treeProps = this.treeProps,
        _treeProps$hasChildre = _treeProps.hasChildren,
        hasChildren = _treeProps$hasChildre === undefined ? 'hasChildren' : _treeProps$hasChildre,
        _treeProps$children = _treeProps.children,
        children = _treeProps$children === undefined ? 'children' : _treeProps$children;

    this.store = createStore(this, {
      rowKey: this.rowKey,
      defaultExpandAll: this.defaultExpandAll,
      selectOnIndeterminate: this.selectOnIndeterminate,
      // TreeTable 的相关配置
      indent: this.indent,
      lazy: this.lazy,
      lazyColumnIdentifier: hasChildren,
      childrenColumnName: children
    });
    var layout = new table_layout({
      store: this.store,
      table: this,
      fit: this.fit,
      showHeader: this.showHeader
    });
    return {
      layout: layout,
      isHidden: false,
      renderExpanded: null,
      resizeProxyVisible: false,
      resizeState: {
        width: null,
        height: null
      },
      // 是否拥有多级表头
      isGroup: false,
      scrollPosition: 'left'
    };
  }
});
// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tablevue_type_script_lang_js_ = (tablevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/table/src/table.vue





/* normalize component */

var table_component = normalizeComponent(
  src_tablevue_type_script_lang_js_,
  tablevue_type_template_id_493fe34e_render,
  tablevue_type_template_id_493fe34e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var table_api; }
table_component.options.__file = "packages/table/src/table.vue"
/* harmony default export */ var src_table = (table_component.exports);
// CONCATENATED MODULE: ./packages/table/index.js


/* istanbul ignore next */
src_table.install = function (Vue) {
  Vue.component(src_table.name, src_table);
};

/* harmony default export */ var packages_table = (src_table);
// CONCATENATED MODULE: ./packages/table/src/config.js


var cellStarts = {
  default: {
    order: ''
  },
  selection: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: '',
    className: 'el-table-column--selection'
  },
  expand: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ''
  },
  index: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ''
  }
};

// 这些选项不应该被覆盖
var cellForced = {
  selection: {
    renderHeader: function renderHeader(h, _ref) {
      var store = _ref.store;

      return h('el-checkbox', {
        attrs: {
          disabled: store.states.data && store.states.data.length === 0,
          indeterminate: store.states.selection.length > 0 && !this.isAllSelected,

          value: this.isAllSelected },
        nativeOn: {
          'click': this.toggleAllSelection
        }
      });
    },
    renderCell: function renderCell(h, _ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          store = _ref2.store,
          $index = _ref2.$index;

      return h('el-checkbox', {
        nativeOn: {
          'click': function click(event) {
            return event.stopPropagation();
          }
        },
        attrs: {
          value: store.isSelected(row),
          disabled: column.selectable ? !column.selectable.call(null, row, $index) : false
        },
        on: {
          'input': function input() {
            store.commit('rowSelectedChanged', row);
          }
        }
      });
    },
    sortable: false,
    resizable: false
  },
  index: {
    renderHeader: function renderHeader(h, _ref3) {
      var column = _ref3.column;

      return column.label || '#';
    },
    renderCell: function renderCell(h, _ref4) {
      var $index = _ref4.$index,
          column = _ref4.column;

      var i = $index + 1;
      var index = column.index;

      if (typeof index === 'number') {
        i = $index + index;
      } else if (typeof index === 'function') {
        i = index($index);
      }

      return h('div', [i]);
    },
    sortable: false
  },
  expand: {
    renderHeader: function renderHeader(h, _ref5) {
      var column = _ref5.column;

      return column.label || '';
    },
    renderCell: function renderCell(h, _ref6) {
      var row = _ref6.row,
          store = _ref6.store;

      var classes = ['el-table__expand-icon'];
      if (store.states.expandRows.indexOf(row) > -1) {
        classes.push('el-table__expand-icon--expanded');
      }
      var callback = function callback(e) {
        e.stopPropagation();
        store.toggleRowExpansion(row);
      };
      return h(
        'div',
        { 'class': classes,
          on: {
            'click': callback
          }
        },
        [h('i', { 'class': 'el-icon el-icon-arrow-right' })]
      );
    },
    sortable: false,
    resizable: false,
    className: 'el-table__expand-column'
  }
};

function defaultRenderCell(h, _ref7) {
  var row = _ref7.row,
      column = _ref7.column,
      $index = _ref7.$index;

  var property = column.property;
  var value = property && Object(util_["getPropByPath"])(row, property).v;
  if (column && column.formatter) {
    return column.formatter(row, column, value, $index);
  }
  return value;
}

function treeCellPrefix(h, _ref8) {
  var row = _ref8.row,
      treeNode = _ref8.treeNode,
      store = _ref8.store;

  if (!treeNode) return null;
  var ele = [];
  var callback = function callback(e) {
    e.stopPropagation();
    store.loadOrToggle(row);
  };
  if (treeNode.indent) {
    ele.push(h('span', { 'class': 'el-table__indent', style: { 'padding-left': treeNode.indent + 'px' } }));
  }
  if (typeof treeNode.expanded === 'boolean' && !treeNode.noLazyChildren) {
    var expandClasses = ['el-table__expand-icon', treeNode.expanded ? 'el-table__expand-icon--expanded' : ''];
    var iconClasses = ['el-icon-arrow-right'];
    if (treeNode.loading) {
      iconClasses = ['el-icon-loading'];
    }
    ele.push(h(
      'div',
      { 'class': expandClasses,
        on: {
          'click': callback
        }
      },
      [h('i', { 'class': iconClasses })]
    ));
  } else {
    ele.push(h('span', { 'class': 'el-table__placeholder' }));
  }
  return ele;
}
// CONCATENATED MODULE: ./packages/table/src/table-column.js
var table_column_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var columnIdSeed = 1;

/* harmony default export */ var table_column = ({
  name: 'ElTableColumn',

  props: {
    type: {
      type: String,
      default: 'default'
    },
    label: String,
    className: String,
    labelClassName: String,
    property: String,
    prop: String,
    width: {},
    minWidth: {},
    renderHeader: Function,
    sortable: {
      type: [Boolean, String],
      default: false
    },
    sortMethod: Function,
    sortBy: [String, Function, Array],
    resizable: {
      type: Boolean,
      default: true
    },
    columnKey: String,
    align: String,
    headerAlign: String,
    showTooltipWhenOverflow: Boolean,
    showOverflowTooltip: Boolean,
    fixed: [Boolean, String],
    formatter: Function,
    selectable: Function,
    reserveSelection: Boolean,
    filterMethod: Function,
    filteredValue: Array,
    filters: Array,
    filterPlacement: String,
    filterMultiple: {
      type: Boolean,
      default: true
    },
    index: [Number, Function],
    sortOrders: {
      type: Array,
      default: function _default() {
        return ['ascending', 'descending', null];
      },
      validator: function validator(val) {
        return val.every(function (order) {
          return ['ascending', 'descending', null].indexOf(order) > -1;
        });
      }
    }
  },

  data: function data() {
    return {
      isSubColumn: false,
      columns: []
    };
  },


  computed: {
    owner: function owner() {
      var parent = this.$parent;
      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }
      return parent;
    },
    columnOrTableParent: function columnOrTableParent() {
      var parent = this.$parent;
      while (parent && !parent.tableId && !parent.columnId) {
        parent = parent.$parent;
      }
      return parent;
    },
    realWidth: function realWidth() {
      return parseWidth(this.width);
    },
    realMinWidth: function realMinWidth() {
      return parseMinWidth(this.minWidth);
    },
    realAlign: function realAlign() {
      return this.align ? 'is-' + this.align : null;
    },
    realHeaderAlign: function realHeaderAlign() {
      return this.headerAlign ? 'is-' + this.headerAlign : this.realAlign;
    }
  },

  methods: {
    getPropsData: function getPropsData() {
      var _this = this;

      for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
        props[_key] = arguments[_key];
      }

      return props.reduce(function (prev, cur) {
        if (Array.isArray(cur)) {
          cur.forEach(function (key) {
            prev[key] = _this[key];
          });
        }
        return prev;
      }, {});
    },
    getColumnElIndex: function getColumnElIndex(children, child) {
      return [].indexOf.call(children, child);
    },
    setColumnWidth: function setColumnWidth(column) {
      if (this.realWidth) {
        column.width = this.realWidth;
      }
      if (this.realMinWidth) {
        column.minWidth = this.realMinWidth;
      }
      if (!column.minWidth) {
        column.minWidth = 80;
      }
      column.realWidth = column.width === undefined ? column.minWidth : column.width;
      return column;
    },
    setColumnForcedProps: function setColumnForcedProps(column) {
      // 对于特定类型的 column，某些属性不允许设置
      var type = column.type;
      var source = cellForced[type] || {};
      Object.keys(source).forEach(function (prop) {
        var value = source[prop];
        if (value !== undefined) {
          column[prop] = prop === 'className' ? column[prop] + ' ' + value : value;
        }
      });
      return column;
    },
    setColumnRenders: function setColumnRenders(column) {
      var _this2 = this;

      var h = this.$createElement;

      // renderHeader 属性不推荐使用。
      if (this.renderHeader) {
        console.warn('[Element Warn][TableColumn]Comparing to render-header, scoped-slot header is easier to use. We recommend users to use scoped-slot header.');
      } else if (column.type !== 'selection') {
        column.renderHeader = function (h, scope) {
          var renderHeader = _this2.$scopedSlots.header;
          return renderHeader ? renderHeader(scope) : column.label;
        };
      }

      var originRenderCell = column.renderCell;
      // TODO: 这里的实现调整
      if (column.type === 'expand') {
        // 对于展开行，renderCell 不允许配置的。在上一步中已经设置过，这里需要简单封装一下。
        column.renderCell = function (h, data) {
          return h(
            'div',
            { 'class': 'cell' },
            [originRenderCell(h, data)]
          );
        };
        this.owner.renderExpanded = function (h, data) {
          return _this2.$scopedSlots.default ? _this2.$scopedSlots.default(data) : _this2.$slots.default;
        };
      } else {
        originRenderCell = originRenderCell || defaultRenderCell;
        // 对 renderCell 进行包装
        column.renderCell = function (h, data) {
          var children = null;
          if (_this2.$scopedSlots.default) {
            children = _this2.$scopedSlots.default(data);
          } else {
            children = originRenderCell(h, data);
          }
          var prefix = treeCellPrefix(h, data);
          var props = {
            class: 'cell',
            style: {}
          };
          if (column.showOverflowTooltip) {
            props.class += ' el-tooltip';
            props.style = { width: (data.column.realWidth || data.column.width) - 1 + 'px' };
          }
          return h(
            'div',
            props,
            [prefix, children]
          );
        };
      }
      return column;
    },
    registerNormalWatchers: function registerNormalWatchers() {
      var _this3 = this;

      var props = ['label', 'property', 'filters', 'filterMultiple', 'sortable', 'index', 'formatter', 'className', 'labelClassName', 'showOverflowTooltip'];
      // 一些属性具有别名
      var aliases = {
        prop: 'property',
        realAlign: 'align',
        realHeaderAlign: 'headerAlign',
        realWidth: 'width'
      };
      var allAliases = props.reduce(function (prev, cur) {
        prev[cur] = cur;
        return prev;
      }, aliases);

      Object.keys(allAliases).forEach(function (key) {
        var columnKey = aliases[key];

        _this3.$watch(key, function (newVal) {
          _this3.columnConfig[columnKey] = newVal;
        });
      });
    },
    registerComplexWatchers: function registerComplexWatchers() {
      var _this4 = this;

      var props = ['fixed'];
      var aliases = {
        realWidth: 'width',
        realMinWidth: 'minWidth'
      };
      var allAliases = props.reduce(function (prev, cur) {
        prev[cur] = cur;
        return prev;
      }, aliases);

      Object.keys(allAliases).forEach(function (key) {
        var columnKey = aliases[key];

        _this4.$watch(key, function (newVal) {
          _this4.columnConfig[columnKey] = newVal;
          var updateColumns = columnKey === 'fixed';
          _this4.owner.store.scheduleLayout(updateColumns);
        });
      });
    }
  },

  components: {
    ElCheckbox: checkbox_default.a
  },

  beforeCreate: function beforeCreate() {
    this.row = {};
    this.column = {};
    this.$index = 0;
    this.columnId = '';
  },
  created: function created() {
    var parent = this.columnOrTableParent;
    this.isSubColumn = this.owner !== parent;
    this.columnId = (parent.tableId || parent.columnId) + '_column_' + columnIdSeed++;

    var type = this.type || 'default';
    var sortable = this.sortable === '' ? true : this.sortable;
    var defaults = table_column_extends({}, cellStarts[type], {
      id: this.columnId,
      type: type,
      property: this.prop || this.property,
      align: this.realAlign,
      headerAlign: this.realHeaderAlign,
      showOverflowTooltip: this.showOverflowTooltip || this.showTooltipWhenOverflow,
      // filter 相关属性
      filterable: this.filters || this.filterMethod,
      filteredValue: [],
      filterPlacement: '',
      isColumnGroup: false,
      filterOpened: false,
      // sort 相关属性
      sortable: sortable,
      // index 列
      index: this.index
    });

    var basicProps = ['columnKey', 'label', 'className', 'labelClassName', 'type', 'renderHeader', 'formatter', 'fixed', 'resizable'];
    var sortProps = ['sortMethod', 'sortBy', 'sortOrders'];
    var selectProps = ['selectable', 'reserveSelection'];
    var filterProps = ['filterMethod', 'filters', 'filterMultiple', 'filterOpened', 'filteredValue', 'filterPlacement'];

    var column = this.getPropsData(basicProps, sortProps, selectProps, filterProps);
    column = mergeOptions(defaults, column);

    // 注意 compose 中函数执行的顺序是从右到左
    var chains = compose(this.setColumnRenders, this.setColumnWidth, this.setColumnForcedProps);
    column = chains(column);

    this.columnConfig = column;

    // 注册 watcher
    this.registerNormalWatchers();
    this.registerComplexWatchers();
  },
  mounted: function mounted() {
    var owner = this.owner;
    var parent = this.columnOrTableParent;
    var children = this.isSubColumn ? parent.$el.children : parent.$refs.hiddenColumns.children;
    var columnIndex = this.getColumnElIndex(children, this.$el);

    owner.store.commit('insertColumn', this.columnConfig, columnIndex, this.isSubColumn ? parent.columnConfig : null);
  },
  destroyed: function destroyed() {
    if (!this.$parent) return;
    var parent = this.$parent;
    this.owner.store.commit('removeColumn', this.columnConfig, this.isSubColumn ? parent.columnConfig : null);
  },
  render: function render(h) {
    // slots 也要渲染，需要计算合并表头
    return h('div', this.$slots.default);
  }
});
// CONCATENATED MODULE: ./packages/table-column/index.js


/* istanbul ignore next */
table_column.install = function (Vue) {
  Vue.component(table_column.name, table_column);
};

/* harmony default export */ var packages_table_column = (table_column);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&
var pickervue_type_template_id_79ae069f_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.ranged
    ? _c(
        "el-input",
        _vm._b(
          {
            directives: [
              {
                name: "clickoutside",
                rawName: "v-clickoutside",
                value: _vm.handleClose,
                expression: "handleClose"
              }
            ],
            ref: "reference",
            staticClass: "el-date-editor",
            class: "el-date-editor--" + _vm.type,
            attrs: {
              readonly:
                !_vm.editable ||
                _vm.readonly ||
                _vm.type === "dates" ||
                _vm.type === "week",
              disabled: _vm.pickerDisabled,
              size: _vm.pickerSize,
              name: _vm.name,
              placeholder: _vm.placeholder,
              value: _vm.displayValue,
              validateEvent: false
            },
            on: {
              focus: _vm.handleFocus,
              input: function(value) {
                return (_vm.userInput = value)
              },
              change: _vm.handleChange
            },
            nativeOn: {
              keydown: function($event) {
                return _vm.handleKeydown($event)
              },
              mouseenter: function($event) {
                return _vm.handleMouseEnter($event)
              },
              mouseleave: function($event) {
                _vm.showClose = false
              }
            }
          },
          "el-input",
          _vm.firstInputId,
          false
        ),
        [
          _c("i", {
            staticClass: "el-input__icon",
            class: _vm.triggerClass,
            attrs: { slot: "prefix" },
            on: { click: _vm.handleFocus },
            slot: "prefix"
          }),
          _vm.haveTrigger
            ? _c("i", {
                staticClass: "el-input__icon",
                class: [_vm.showClose ? "" + _vm.clearIcon : ""],
                attrs: { slot: "suffix" },
                on: { click: _vm.handleClickIcon },
                slot: "suffix"
              })
            : _vm._e()
        ]
      )
    : _c(
        "div",
        {
          directives: [
            {
              name: "clickoutside",
              rawName: "v-clickoutside",
              value: _vm.handleClose,
              expression: "handleClose"
            }
          ],
          ref: "reference",
          staticClass: "el-date-editor el-range-editor el-input__inner",
          class: [
            "el-date-editor--" + _vm.type,
            _vm.pickerSize ? "el-range-editor--" + _vm.pickerSize : "",
            _vm.pickerDisabled ? "is-disabled" : "",
            _vm.pickerVisible ? "is-active" : ""
          ],
          on: {
            click: _vm.handleRangeClick,
            mouseenter: _vm.handleMouseEnter,
            mouseleave: function($event) {
              _vm.showClose = false
            },
            keydown: _vm.handleKeydown
          }
        },
        [
          _c("i", {
            class: ["el-input__icon", "el-range__icon", _vm.triggerClass]
          }),
          _c(
            "input",
            _vm._b(
              {
                staticClass: "el-range-input",
                attrs: {
                  autocomplete: "off",
                  placeholder: _vm.startPlaceholder,
                  disabled: _vm.pickerDisabled,
                  readonly: !_vm.editable || _vm.readonly,
                  name: _vm.name && _vm.name[0]
                },
                domProps: { value: _vm.displayValue && _vm.displayValue[0] },
                on: {
                  input: _vm.handleStartInput,
                  change: _vm.handleStartChange,
                  focus: _vm.handleFocus
                }
              },
              "input",
              _vm.firstInputId,
              false
            )
          ),
          _vm._t("range-separator", [
            _c("span", { staticClass: "el-range-separator" }, [
              _vm._v(_vm._s(_vm.rangeSeparator))
            ])
          ]),
          _c(
            "input",
            _vm._b(
              {
                staticClass: "el-range-input",
                attrs: {
                  autocomplete: "off",
                  placeholder: _vm.endPlaceholder,
                  disabled: _vm.pickerDisabled,
                  readonly: !_vm.editable || _vm.readonly,
                  name: _vm.name && _vm.name[1]
                },
                domProps: { value: _vm.displayValue && _vm.displayValue[1] },
                on: {
                  input: _vm.handleEndInput,
                  change: _vm.handleEndChange,
                  focus: _vm.handleFocus
                }
              },
              "input",
              _vm.secondInputId,
              false
            )
          ),
          _vm.haveTrigger
            ? _c("i", {
                staticClass: "el-input__icon el-range__close-icon",
                class: [_vm.showClose ? "" + _vm.clearIcon : ""],
                on: { click: _vm.handleClickIcon }
              })
            : _vm._e()
        ],
        2
      )
}
var pickervue_type_template_id_79ae069f_staticRenderFns = []
pickervue_type_template_id_79ae069f_render._withStripped = true


// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&

// EXTERNAL MODULE: external "element-ui/lib/utils/date-util"
var date_util_ = __webpack_require__(0);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var NewPopper = {
  props: {
    appendToBody: vue_popper_default.a.props.appendToBody,
    offset: vue_popper_default.a.props.offset,
    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
    arrowOffset: vue_popper_default.a.props.arrowOffset
  },
  methods: vue_popper_default.a.methods,
  data: function data() {
    return merge_default()({ visibleArrow: true }, vue_popper_default.a.data);
  },

  beforeDestroy: vue_popper_default.a.beforeDestroy
};

var DEFAULT_FORMATS = {
  date: 'yyyy-MM-dd',
  month: 'yyyy-MM',
  datetime: 'yyyy-MM-dd HH:mm:ss',
  time: 'HH:mm:ss',
  week: 'yyyywWW',
  timerange: 'HH:mm:ss',
  daterange: 'yyyy-MM-dd',
  monthrange: 'yyyy-MM',
  datetimerange: 'yyyy-MM-dd HH:mm:ss',
  year: 'yyyy'
};
var HAVE_TRIGGER_TYPES = ['date', 'datetime', 'time', 'time-select', 'week', 'month', 'year', 'daterange', 'monthrange', 'timerange', 'datetimerange', 'dates'];
var pickervue_type_script_lang_js_DATE_FORMATTER = function DATE_FORMATTER(value, format) {
  if (format === 'timestamp') return value.getTime();
  return Object(date_util_["formatDate"])(value, format);
};
var pickervue_type_script_lang_js_DATE_PARSER = function DATE_PARSER(text, format) {
  if (format === 'timestamp') return new Date(Number(text));
  return Object(date_util_["parseDate"])(text, format);
};
var RANGE_FORMATTER = function RANGE_FORMATTER(value, format) {
  if (Array.isArray(value) && value.length === 2) {
    var start = value[0];
    var end = value[1];

    if (start && end) {
      return [pickervue_type_script_lang_js_DATE_FORMATTER(start, format), pickervue_type_script_lang_js_DATE_FORMATTER(end, format)];
    }
  }
  return '';
};
var RANGE_PARSER = function RANGE_PARSER(array, format, separator) {
  if (!Array.isArray(array)) {
    array = array.split(separator);
  }
  if (array.length === 2) {
    var range1 = array[0];
    var range2 = array[1];

    return [pickervue_type_script_lang_js_DATE_PARSER(range1, format), pickervue_type_script_lang_js_DATE_PARSER(range2, format)];
  }
  return [];
};
var TYPE_VALUE_RESOLVER_MAP = {
  default: {
    formatter: function formatter(value) {
      if (!value) return '';
      return '' + value;
    },
    parser: function parser(text) {
      if (text === undefined || text === '') return null;
      return text;
    }
  },
  week: {
    formatter: function formatter(value, format) {
      var week = Object(date_util_["getWeekNumber"])(value);
      var month = value.getMonth();
      var trueDate = new Date(value);
      if (week === 1 && month === 11) {
        trueDate.setHours(0, 0, 0, 0);
        trueDate.setDate(trueDate.getDate() + 3 - (trueDate.getDay() + 6) % 7);
      }
      var date = Object(date_util_["formatDate"])(trueDate, format);

      date = /WW/.test(date) ? date.replace(/WW/, week < 10 ? '0' + week : week) : date.replace(/W/, week);
      return date;
    },
    parser: function parser(text, format) {
      // parse as if a normal date
      return TYPE_VALUE_RESOLVER_MAP.date.parser(text, format);
    }
  },
  date: {
    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
    parser: pickervue_type_script_lang_js_DATE_PARSER
  },
  datetime: {
    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
    parser: pickervue_type_script_lang_js_DATE_PARSER
  },
  daterange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  monthrange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  datetimerange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  timerange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  time: {
    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
    parser: pickervue_type_script_lang_js_DATE_PARSER
  },
  month: {
    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
    parser: pickervue_type_script_lang_js_DATE_PARSER
  },
  year: {
    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
    parser: pickervue_type_script_lang_js_DATE_PARSER
  },
  number: {
    formatter: function formatter(value) {
      if (!value) return '';
      return '' + value;
    },
    parser: function parser(text) {
      var result = Number(text);

      if (!isNaN(text)) {
        return result;
      } else {
        return null;
      }
    }
  },
  dates: {
    formatter: function formatter(value, format) {
      return value.map(function (date) {
        return pickervue_type_script_lang_js_DATE_FORMATTER(date, format);
      });
    },
    parser: function parser(value, format) {
      return (typeof value === 'string' ? value.split(', ') : value).map(function (date) {
        return date instanceof Date ? date : pickervue_type_script_lang_js_DATE_PARSER(date, format);
      });
    }
  }
};
var PLACEMENT_MAP = {
  left: 'bottom-start',
  center: 'bottom',
  right: 'bottom-end'
};

var parseAsFormatAndType = function parseAsFormatAndType(value, customFormat, type) {
  var rangeSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '-';

  if (!value) return null;
  var parser = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).parser;
  var format = customFormat || DEFAULT_FORMATS[type];
  return parser(value, format, rangeSeparator);
};

var formatAsFormatAndType = function formatAsFormatAndType(value, customFormat, type) {
  if (!value) return null;
  var formatter = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).formatter;
  var format = customFormat || DEFAULT_FORMATS[type];
  return formatter(value, format);
};

/*
 * Considers:
 *   1. Date object
 *   2. date string
 *   3. array of 1 or 2
 */
var valueEquals = function valueEquals(a, b) {
  // considers Date object and string
  var dateEquals = function dateEquals(a, b) {
    var aIsDate = a instanceof Date;
    var bIsDate = b instanceof Date;
    if (aIsDate && bIsDate) {
      return a.getTime() === b.getTime();
    }
    if (!aIsDate && !bIsDate) {
      return a === b;
    }
    return false;
  };

  var aIsArray = a instanceof Array;
  var bIsArray = b instanceof Array;
  if (aIsArray && bIsArray) {
    if (a.length !== b.length) {
      return false;
    }
    return a.every(function (item, index) {
      return dateEquals(item, b[index]);
    });
  }
  if (!aIsArray && !bIsArray) {
    return dateEquals(a, b);
  }
  return false;
};

var isString = function isString(val) {
  return typeof val === 'string' || val instanceof String;
};

var pickervue_type_script_lang_js_validator = function validator(val) {
  // either: String, Array of String, null / undefined
  return val === null || val === undefined || isString(val) || Array.isArray(val) && val.length === 2 && val.every(isString);
};

/* harmony default export */ var pickervue_type_script_lang_js_ = ({
  mixins: [emitter_default.a, NewPopper],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  props: {
    size: String,
    format: String,
    valueFormat: String,
    readonly: Boolean,
    placeholder: String,
    startPlaceholder: String,
    endPlaceholder: String,
    prefixIcon: String,
    clearIcon: {
      type: String,
      default: 'el-icon-circle-close'
    },
    name: {
      default: '',
      validator: pickervue_type_script_lang_js_validator
    },
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true
    },
    id: {
      default: '',
      validator: pickervue_type_script_lang_js_validator
    },
    popperClass: String,
    editable: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: 'left'
    },
    value: {},
    defaultValue: {},
    defaultTime: {},
    rangeSeparator: {
      default: '-'
    },
    pickerOptions: {},
    unlinkPanels: Boolean,
    validateEvent: {
      type: Boolean,
      default: true
    }
  },

  components: { ElInput: input_default.a },

  directives: { Clickoutside: clickoutside_default.a },

  data: function data() {
    return {
      pickerVisible: false,
      showClose: false,
      userInput: null,
      valueOnOpen: null, // value when picker opens, used to determine whether to emit change
      unwatchPickerOptions: null
    };
  },


  watch: {
    pickerVisible: function pickerVisible(val) {
      if (this.readonly || this.pickerDisabled) return;
      if (val) {
        this.showPicker();
        this.valueOnOpen = Array.isArray(this.value) ? [].concat(this.value) : this.value;
      } else {
        this.hidePicker();
        this.emitChange(this.value);
        this.userInput = null;
        if (this.validateEvent) {
          this.dispatch('ElFormItem', 'el.form.blur');
        }
        this.$emit('blur', this);
        this.blur();
      }
    },

    parsedValue: {
      immediate: true,
      handler: function handler(val) {
        if (this.picker) {
          this.picker.value = val;
        }
      }
    },
    defaultValue: function defaultValue(val) {
      // NOTE: should eventually move to jsx style picker + panel ?
      if (this.picker) {
        this.picker.defaultValue = val;
      }
    },
    value: function value(val, oldVal) {
      if (!valueEquals(val, oldVal) && !this.pickerVisible && this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', val);
      }
    }
  },

  computed: {
    ranged: function ranged() {
      return this.type.indexOf('range') > -1;
    },
    reference: function reference() {
      var reference = this.$refs.reference;
      return reference.$el || reference;
    },
    refInput: function refInput() {
      if (this.reference) {
        return [].slice.call(this.reference.querySelectorAll('input'));
      }
      return [];
    },
    valueIsEmpty: function valueIsEmpty() {
      var val = this.value;
      if (Array.isArray(val)) {
        for (var i = 0, len = val.length; i < len; i++) {
          if (val[i]) {
            return false;
          }
        }
      } else {
        if (val) {
          return false;
        }
      }
      return true;
    },
    triggerClass: function triggerClass() {
      return this.prefixIcon || (this.type.indexOf('time') !== -1 ? 'el-icon-time' : 'el-icon-date');
    },
    selectionMode: function selectionMode() {
      if (this.type === 'week') {
        return 'week';
      } else if (this.type === 'month') {
        return 'month';
      } else if (this.type === 'year') {
        return 'year';
      } else if (this.type === 'dates') {
        return 'dates';
      }

      return 'day';
    },
    haveTrigger: function haveTrigger() {
      if (typeof this.showTrigger !== 'undefined') {
        return this.showTrigger;
      }
      return HAVE_TRIGGER_TYPES.indexOf(this.type) !== -1;
    },
    displayValue: function displayValue() {
      var formattedValue = formatAsFormatAndType(this.parsedValue, this.format, this.type, this.rangeSeparator);
      if (Array.isArray(this.userInput)) {
        return [this.userInput[0] || formattedValue && formattedValue[0] || '', this.userInput[1] || formattedValue && formattedValue[1] || ''];
      } else if (this.userInput !== null) {
        return this.userInput;
      } else if (formattedValue) {
        return this.type === 'dates' ? formattedValue.join(', ') : formattedValue;
      } else {
        return '';
      }
    },
    parsedValue: function parsedValue() {
      if (!this.value) return this.value; // component value is not set
      if (this.type === 'time-select') return this.value; // time-select does not require parsing, this might change in next major version

      var valueIsDateObject = Object(date_util_["isDateObject"])(this.value) || Array.isArray(this.value) && this.value.every(date_util_["isDateObject"]);
      if (valueIsDateObject) {
        return this.value;
      }

      if (this.valueFormat) {
        return parseAsFormatAndType(this.value, this.valueFormat, this.type, this.rangeSeparator) || this.value;
      }

      // NOTE: deal with common but incorrect usage, should remove in next major version
      // user might provide string / timestamp without value-format, coerce them into date (or array of date)
      return Array.isArray(this.value) ? this.value.map(function (val) {
        return new Date(val);
      }) : new Date(this.value);
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    pickerSize: function pickerSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    pickerDisabled: function pickerDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    firstInputId: function firstInputId() {
      var obj = {};
      var id = void 0;
      if (this.ranged) {
        id = this.id && this.id[0];
      } else {
        id = this.id;
      }
      if (id) obj.id = id;
      return obj;
    },
    secondInputId: function secondInputId() {
      var obj = {};
      var id = void 0;
      if (this.ranged) {
        id = this.id && this.id[1];
      }
      if (id) obj.id = id;
      return obj;
    }
  },

  created: function created() {
    // vue-popper
    this.popperOptions = {
      boundariesPadding: 0,
      gpuAcceleration: false
    };
    this.placement = PLACEMENT_MAP[this.align] || PLACEMENT_MAP.left;

    this.$on('fieldReset', this.handleFieldReset);
  },


  methods: {
    focus: function focus() {
      if (!this.ranged) {
        this.$refs.reference.focus();
      } else {
        this.handleFocus();
      }
    },
    blur: function blur() {
      this.refInput.forEach(function (input) {
        return input.blur();
      });
    },


    // {parse, formatTo} Value deals maps component value with internal Date
    parseValue: function parseValue(value) {
      var isParsed = Object(date_util_["isDateObject"])(value) || Array.isArray(value) && value.every(date_util_["isDateObject"]);
      if (this.valueFormat && !isParsed) {
        return parseAsFormatAndType(value, this.valueFormat, this.type, this.rangeSeparator) || value;
      } else {
        return value;
      }
    },
    formatToValue: function formatToValue(date) {
      var isFormattable = Object(date_util_["isDateObject"])(date) || Array.isArray(date) && date.every(date_util_["isDateObject"]);
      if (this.valueFormat && isFormattable) {
        return formatAsFormatAndType(date, this.valueFormat, this.type, this.rangeSeparator);
      } else {
        return date;
      }
    },


    // {parse, formatTo} String deals with user input
    parseString: function parseString(value) {
      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
      return parseAsFormatAndType(value, this.format, type);
    },
    formatToString: function formatToString(value) {
      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
      return formatAsFormatAndType(value, this.format, type);
    },
    handleMouseEnter: function handleMouseEnter() {
      if (this.readonly || this.pickerDisabled) return;
      if (!this.valueIsEmpty && this.clearable) {
        this.showClose = true;
      }
    },
    handleChange: function handleChange() {
      if (this.userInput) {
        var value = this.parseString(this.displayValue);
        if (value) {
          this.picker.value = value;
          if (this.isValidValue(value)) {
            this.emitInput(value);
            this.userInput = null;
          }
        }
      }
      if (this.userInput === '') {
        this.emitInput(null);
        this.emitChange(null);
        this.userInput = null;
      }
    },
    handleStartInput: function handleStartInput(event) {
      if (this.userInput) {
        this.userInput = [event.target.value, this.userInput[1]];
      } else {
        this.userInput = [event.target.value, null];
      }
    },
    handleEndInput: function handleEndInput(event) {
      if (this.userInput) {
        this.userInput = [this.userInput[0], event.target.value];
      } else {
        this.userInput = [null, event.target.value];
      }
    },
    handleStartChange: function handleStartChange(event) {
      var value = this.parseString(this.userInput && this.userInput[0]);
      if (value) {
        this.userInput = [this.formatToString(value), this.displayValue[1]];
        var newValue = [value, this.picker.value && this.picker.value[1]];
        this.picker.value = newValue;
        if (this.isValidValue(newValue)) {
          this.emitInput(newValue);
          this.userInput = null;
        }
      }
    },
    handleEndChange: function handleEndChange(event) {
      var value = this.parseString(this.userInput && this.userInput[1]);
      if (value) {
        this.userInput = [this.displayValue[0], this.formatToString(value)];
        var newValue = [this.picker.value && this.picker.value[0], value];
        this.picker.value = newValue;
        if (this.isValidValue(newValue)) {
          this.emitInput(newValue);
          this.userInput = null;
        }
      }
    },
    handleClickIcon: function handleClickIcon(event) {
      if (this.readonly || this.pickerDisabled) return;
      if (this.showClose) {
        this.valueOnOpen = this.value;
        event.stopPropagation();
        this.emitInput(null);
        this.emitChange(null);
        this.showClose = false;
        if (this.picker && typeof this.picker.handleClear === 'function') {
          this.picker.handleClear();
        }
      } else {
        this.pickerVisible = !this.pickerVisible;
      }
    },
    handleClose: function handleClose() {
      if (!this.pickerVisible) return;
      this.pickerVisible = false;

      if (this.type === 'dates') {
        // restore to former value
        var oldValue = parseAsFormatAndType(this.valueOnOpen, this.valueFormat, this.type, this.rangeSeparator) || this.valueOnOpen;
        this.emitInput(oldValue);
      }
    },
    handleFieldReset: function handleFieldReset(initialValue) {
      this.userInput = initialValue === '' ? null : initialValue;
    },
    handleFocus: function handleFocus() {
      var type = this.type;

      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
        this.pickerVisible = true;
      }
      this.$emit('focus', this);
    },
    handleKeydown: function handleKeydown(event) {
      var _this = this;

      var keyCode = event.keyCode;

      // ESC
      if (keyCode === 27) {
        this.pickerVisible = false;
        event.stopPropagation();
        return;
      }

      // Tab
      if (keyCode === 9) {
        if (!this.ranged) {
          this.handleChange();
          this.pickerVisible = this.picker.visible = false;
          this.blur();
          event.stopPropagation();
        } else {
          // user may change focus between two input
          setTimeout(function () {
            if (_this.refInput.indexOf(document.activeElement) === -1) {
              _this.pickerVisible = false;
              _this.blur();
              event.stopPropagation();
            }
          }, 0);
        }
        return;
      }

      // Enter
      if (keyCode === 13) {
        if (this.userInput === '' || this.isValidValue(this.parseString(this.displayValue))) {
          this.handleChange();
          this.pickerVisible = this.picker.visible = false;
          this.blur();
        }
        event.stopPropagation();
        return;
      }

      // if user is typing, do not let picker handle key input
      if (this.userInput) {
        event.stopPropagation();
        return;
      }

      // delegate other keys to panel
      if (this.picker && this.picker.handleKeydown) {
        this.picker.handleKeydown(event);
      }
    },
    handleRangeClick: function handleRangeClick() {
      var type = this.type;

      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
        this.pickerVisible = true;
      }
      this.$emit('focus', this);
    },
    hidePicker: function hidePicker() {
      if (this.picker) {
        this.picker.resetView && this.picker.resetView();
        this.pickerVisible = this.picker.visible = false;
        this.destroyPopper();
      }
    },
    showPicker: function showPicker() {
      var _this2 = this;

      if (this.$isServer) return;
      if (!this.picker) {
        this.mountPicker();
      }
      this.pickerVisible = this.picker.visible = true;

      this.updatePopper();

      this.picker.value = this.parsedValue;
      this.picker.resetView && this.picker.resetView();

      this.$nextTick(function () {
        _this2.picker.adjustSpinners && _this2.picker.adjustSpinners();
      });
    },
    mountPicker: function mountPicker() {
      var _this3 = this;

      this.picker = new external_vue_default.a(this.panel).$mount();
      this.picker.defaultValue = this.defaultValue;
      this.picker.defaultTime = this.defaultTime;
      this.picker.popperClass = this.popperClass;
      this.popperElm = this.picker.$el;
      this.picker.width = this.reference.getBoundingClientRect().width;
      this.picker.showTime = this.type === 'datetime' || this.type === 'datetimerange';
      this.picker.selectionMode = this.selectionMode;
      this.picker.unlinkPanels = this.unlinkPanels;
      this.picker.arrowControl = this.arrowControl || this.timeArrowControl || false;
      this.$watch('format', function (format) {
        _this3.picker.format = format;
      });

      var updateOptions = function updateOptions() {
        var options = _this3.pickerOptions;

        if (options && options.selectableRange) {
          var ranges = options.selectableRange;
          var parser = TYPE_VALUE_RESOLVER_MAP.datetimerange.parser;
          var format = DEFAULT_FORMATS.timerange;

          ranges = Array.isArray(ranges) ? ranges : [ranges];
          _this3.picker.selectableRange = ranges.map(function (range) {
            return parser(range, format, _this3.rangeSeparator);
          });
        }

        for (var option in options) {
          if (options.hasOwnProperty(option) &&
          // 忽略 time-picker 的该配置项
          option !== 'selectableRange') {
            _this3.picker[option] = options[option];
          }
        }

        // main format must prevail over undocumented pickerOptions.format
        if (_this3.format) {
          _this3.picker.format = _this3.format;
        }
      };
      updateOptions();
      this.unwatchPickerOptions = this.$watch('pickerOptions', function () {
        return updateOptions();
      }, { deep: true });
      this.$el.appendChild(this.picker.$el);
      this.picker.resetView && this.picker.resetView();

      this.picker.$on('dodestroy', this.doDestroy);
      this.picker.$on('pick', function () {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        _this3.userInput = null;
        _this3.pickerVisible = _this3.picker.visible = visible;
        _this3.emitInput(date);
        _this3.picker.resetView && _this3.picker.resetView();
      });

      this.picker.$on('select-range', function (start, end, pos) {
        if (_this3.refInput.length === 0) return;
        if (!pos || pos === 'min') {
          _this3.refInput[0].setSelectionRange(start, end);
          _this3.refInput[0].focus();
        } else if (pos === 'max') {
          _this3.refInput[1].setSelectionRange(start, end);
          _this3.refInput[1].focus();
        }
      });
    },
    unmountPicker: function unmountPicker() {
      if (this.picker) {
        this.picker.$destroy();
        this.picker.$off();
        if (typeof this.unwatchPickerOptions === 'function') {
          this.unwatchPickerOptions();
        }
        this.picker.$el.parentNode.removeChild(this.picker.$el);
      }
    },
    emitChange: function emitChange(val) {
      // determine user real change only
      if (!valueEquals(val, this.valueOnOpen)) {
        this.$emit('change', val);
        this.valueOnOpen = val;
        if (this.validateEvent) {
          this.dispatch('ElFormItem', 'el.form.change', val);
        }
      }
    },
    emitInput: function emitInput(val) {
      var formatted = this.formatToValue(val);
      if (!valueEquals(this.value, formatted)) {
        this.$emit('input', formatted);
      }
    },
    isValidValue: function isValidValue(value) {
      if (!this.picker) {
        this.mountPicker();
      }
      if (this.picker.isValidValue) {
        return value && this.picker.isValidValue(value);
      } else {
        return true;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_pickervue_type_script_lang_js_ = (pickervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue





/* normalize component */

var picker_component = normalizeComponent(
  src_pickervue_type_script_lang_js_,
  pickervue_type_template_id_79ae069f_render,
  pickervue_type_template_id_79ae069f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var picker_api; }
picker_component.options.__file = "packages/date-picker/src/picker.vue"
/* harmony default export */ var picker = (picker_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&
var datevue_type_template_id_2440d4ea_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "el-zoom-in-top" },
      on: { "after-enter": _vm.handleEnter, "after-leave": _vm.handleLeave }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          staticClass: "el-picker-panel el-date-picker el-popper",
          class: [
            {
              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts,
              "has-time": _vm.showTime
            },
            _vm.popperClass
          ]
        },
        [
          _c(
            "div",
            { staticClass: "el-picker-panel__body-wrapper" },
            [
              _vm._t("sidebar"),
              _vm.shortcuts
                ? _c(
                    "div",
                    { staticClass: "el-picker-panel__sidebar" },
                    _vm._l(_vm.shortcuts, function(shortcut, key) {
                      return _c(
                        "button",
                        {
                          key: key,
                          staticClass: "el-picker-panel__shortcut",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.handleShortcutClick(shortcut)
                            }
                          }
                        },
                        [_vm._v(_vm._s(shortcut.text))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _c("div", { staticClass: "el-picker-panel__body" }, [
                _vm.showTime
                  ? _c("div", { staticClass: "el-date-picker__time-header" }, [
                      _c(
                        "span",
                        { staticClass: "el-date-picker__editor-wrap" },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.t("el.datepicker.selectDate"),
                              value: _vm.visibleDate,
                              size: "small"
                            },
                            on: {
                              input: function(val) {
                                return (_vm.userInputDate = val)
                              },
                              change: _vm.handleVisibleDateChange
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "clickoutside",
                              rawName: "v-clickoutside",
                              value: _vm.handleTimePickClose,
                              expression: "handleTimePickClose"
                            }
                          ],
                          staticClass: "el-date-picker__editor-wrap"
                        },
                        [
                          _c("el-input", {
                            ref: "input",
                            attrs: {
                              placeholder: _vm.t("el.datepicker.selectTime"),
                              value: _vm.visibleTime,
                              size: "small"
                            },
                            on: {
                              focus: function($event) {
                                _vm.timePickerVisible = true
                              },
                              input: function(val) {
                                return (_vm.userInputTime = val)
                              },
                              change: _vm.handleVisibleTimeChange
                            }
                          }),
                          _c("time-picker", {
                            ref: "timepicker",
                            attrs: {
                              "time-arrow-control": _vm.arrowControl,
                              visible: _vm.timePickerVisible
                            },
                            on: {
                              pick: _vm.handleTimePick,
                              mounted: _vm.proxyTimePickerDataProperties
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.currentView !== "time",
                        expression: "currentView !== 'time'"
                      }
                    ],
                    staticClass: "el-date-picker__header",
                    class: {
                      "el-date-picker__header--bordered":
                        _vm.currentView === "year" ||
                        _vm.currentView === "month"
                    }
                  },
                  [
                    _c("button", {
                      staticClass:
                        "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.t("el.datepicker.prevYear")
                      },
                      on: { click: _vm.prevYear }
                    }),
                    _c("button", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentView === "date",
                          expression: "currentView === 'date'"
                        }
                      ],
                      staticClass:
                        "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.t("el.datepicker.prevMonth")
                      },
                      on: { click: _vm.prevMonth }
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "el-date-picker__header-label",
                        attrs: { role: "button" },
                        on: { click: _vm.showYearPicker }
                      },
                      [_vm._v(_vm._s(_vm.yearLabel))]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.currentView === "date",
                            expression: "currentView === 'date'"
                          }
                        ],
                        staticClass: "el-date-picker__header-label",
                        class: { active: _vm.currentView === "month" },
                        attrs: { role: "button" },
                        on: { click: _vm.showMonthPicker }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.t("el.datepicker.month" + (_vm.month + 1)))
                        )
                      ]
                    ),
                    _c("button", {
                      staticClass:
                        "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.t("el.datepicker.nextYear")
                      },
                      on: { click: _vm.nextYear }
                    }),
                    _c("button", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentView === "date",
                          expression: "currentView === 'date'"
                        }
                      ],
                      staticClass:
                        "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.t("el.datepicker.nextMonth")
                      },
                      on: { click: _vm.nextMonth }
                    })
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "el-picker-panel__content" },
                  [
                    _c("date-table", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentView === "date",
                          expression: "currentView === 'date'"
                        }
                      ],
                      attrs: {
                        "selection-mode": _vm.selectionMode,
                        "first-day-of-week": _vm.firstDayOfWeek,
                        value: _vm.value,
                        "default-value": _vm.defaultValue
                          ? new Date(_vm.defaultValue)
                          : null,
                        date: _vm.date,
                        "cell-class-name": _vm.cellClassName,
                        "disabled-date": _vm.disabledDate
                      },
                      on: { pick: _vm.handleDatePick }
                    }),
                    _c("year-table", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentView === "year",
                          expression: "currentView === 'year'"
                        }
                      ],
                      attrs: {
                        value: _vm.value,
                        "default-value": _vm.defaultValue
                          ? new Date(_vm.defaultValue)
                          : null,
                        date: _vm.date,
                        "disabled-date": _vm.disabledDate
                      },
                      on: { pick: _vm.handleYearPick }
                    }),
                    _c("month-table", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentView === "month",
                          expression: "currentView === 'month'"
                        }
                      ],
                      attrs: {
                        value: _vm.value,
                        "default-value": _vm.defaultValue
                          ? new Date(_vm.defaultValue)
                          : null,
                        date: _vm.date,
                        "disabled-date": _vm.disabledDate
                      },
                      on: { pick: _vm.handleMonthPick }
                    })
                  ],
                  1
                )
              ])
            ],
            2
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.footerVisible && _vm.currentView === "date",
                  expression: "footerVisible && currentView === 'date'"
                }
              ],
              staticClass: "el-picker-panel__footer"
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectionMode !== "dates",
                      expression: "selectionMode !== 'dates'"
                    }
                  ],
                  staticClass: "el-picker-panel__link-btn",
                  attrs: { size: "mini", type: "text" },
                  on: { click: _vm.changeToNow }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.t("el.datepicker.now")) +
                      "\n      "
                  )
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "el-picker-panel__link-btn",
                  attrs: { plain: "", size: "mini" },
                  on: { click: _vm.confirm }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.t("el.datepicker.confirm")) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var datevue_type_template_id_2440d4ea_staticRenderFns = []
datevue_type_template_id_2440d4ea_render._withStripped = true


// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&
var timevue_type_template_id_3d939089_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "el-zoom-in-top" },
      on: {
        "after-leave": function($event) {
          _vm.$emit("dodestroy")
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          staticClass: "el-time-panel el-popper",
          class: _vm.popperClass
        },
        [
          _c(
            "div",
            {
              staticClass: "el-time-panel__content",
              class: { "has-seconds": _vm.showSeconds }
            },
            [
              _c("time-spinner", {
                ref: "spinner",
                attrs: {
                  "arrow-control": _vm.useArrow,
                  "show-seconds": _vm.showSeconds,
                  "am-pm-mode": _vm.amPmMode,
                  date: _vm.date
                },
                on: {
                  change: _vm.handleChange,
                  "select-range": _vm.setSelectionRange
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "el-time-panel__footer" }, [
            _c(
              "button",
              {
                staticClass: "el-time-panel__btn cancel",
                attrs: { type: "button" },
                on: { click: _vm.handleCancel }
              },
              [_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]
            ),
            _c(
              "button",
              {
                staticClass: "el-time-panel__btn",
                class: { confirm: !_vm.disabled },
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.handleConfirm()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))]
            )
          ])
        ]
      )
    ]
  )
}
var timevue_type_template_id_3d939089_staticRenderFns = []
timevue_type_template_id_3d939089_render._withStripped = true


// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&
var time_spinnervue_type_template_id_1facadeb_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-time-spinner",
      class: { "has-seconds": _vm.showSeconds }
    },
    [
      !_vm.arrowControl
        ? [
            _c(
              "el-scrollbar",
              {
                ref: "hours",
                staticClass: "el-time-spinner__wrapper",
                attrs: {
                  "wrap-style": "max-height: inherit;",
                  "view-class": "el-time-spinner__list",
                  noresize: "",
                  tag: "ul"
                },
                nativeOn: {
                  mouseenter: function($event) {
                    _vm.emitSelectRange("hours")
                  },
                  mousemove: function($event) {
                    _vm.adjustCurrentSpinner("hours")
                  }
                }
              },
              _vm._l(_vm.hoursList, function(disabled, hour) {
                return _c(
                  "li",
                  {
                    key: hour,
                    staticClass: "el-time-spinner__item",
                    class: { active: hour === _vm.hours, disabled: disabled },
                    on: {
                      click: function($event) {
                        _vm.handleClick("hours", {
                          value: hour,
                          disabled: disabled
                        })
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        ("0" + (_vm.amPmMode ? hour % 12 || 12 : hour)).slice(
                          -2
                        )
                      ) + _vm._s(_vm.amPm(hour))
                    )
                  ]
                )
              }),
              0
            ),
            _c(
              "el-scrollbar",
              {
                ref: "minutes",
                staticClass: "el-time-spinner__wrapper",
                attrs: {
                  "wrap-style": "max-height: inherit;",
                  "view-class": "el-time-spinner__list",
                  noresize: "",
                  tag: "ul"
                },
                nativeOn: {
                  mouseenter: function($event) {
                    _vm.emitSelectRange("minutes")
                  },
                  mousemove: function($event) {
                    _vm.adjustCurrentSpinner("minutes")
                  }
                }
              },
              _vm._l(_vm.minutesList, function(enabled, key) {
                return _c(
                  "li",
                  {
                    key: key,
                    staticClass: "el-time-spinner__item",
                    class: { active: key === _vm.minutes, disabled: !enabled },
                    on: {
                      click: function($event) {
                        _vm.handleClick("minutes", {
                          value: key,
                          disabled: false
                        })
                      }
                    }
                  },
                  [_vm._v(_vm._s(("0" + key).slice(-2)))]
                )
              }),
              0
            ),
            _c(
              "el-scrollbar",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showSeconds,
                    expression: "showSeconds"
                  }
                ],
                ref: "seconds",
                staticClass: "el-time-spinner__wrapper",
                attrs: {
                  "wrap-style": "max-height: inherit;",
                  "view-class": "el-time-spinner__list",
                  noresize: "",
                  tag: "ul"
                },
                nativeOn: {
                  mouseenter: function($event) {
                    _vm.emitSelectRange("seconds")
                  },
                  mousemove: function($event) {
                    _vm.adjustCurrentSpinner("seconds")
                  }
                }
              },
              _vm._l(60, function(second, key) {
                return _c(
                  "li",
                  {
                    key: key,
                    staticClass: "el-time-spinner__item",
                    class: { active: key === _vm.seconds },
                    on: {
                      click: function($event) {
                        _vm.handleClick("seconds", {
                          value: key,
                          disabled: false
                        })
                      }
                    }
                  },
                  [_vm._v(_vm._s(("0" + key).slice(-2)))]
                )
              }),
              0
            )
          ]
        : _vm._e(),
      _vm.arrowControl
        ? [
            _c(
              "div",
              {
                staticClass: "el-time-spinner__wrapper is-arrow",
                on: {
                  mouseenter: function($event) {
                    _vm.emitSelectRange("hours")
                  }
                }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "repeat-click",
                      rawName: "v-repeat-click",
                      value: _vm.decrease,
                      expression: "decrease"
                    }
                  ],
                  staticClass: "el-time-spinner__arrow el-icon-arrow-up"
                }),
                _c("i", {
                  directives: [
                    {
                      name: "repeat-click",
                      rawName: "v-repeat-click",
                      value: _vm.increase,
                      expression: "increase"
                    }
                  ],
                  staticClass: "el-time-spinner__arrow el-icon-arrow-down"
                }),
                _c(
                  "ul",
                  { ref: "hours", staticClass: "el-time-spinner__list" },
                  _vm._l(_vm.arrowHourList, function(hour, key) {
                    return _c(
                      "li",
                      {
                        key: key,
                        staticClass: "el-time-spinner__item",
                        class: {
                          active: hour === _vm.hours,
                          disabled: _vm.hoursList[hour]
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            hour === undefined
                              ? ""
                              : (
                                  "0" + (_vm.amPmMode ? hour % 12 || 12 : hour)
                                ).slice(-2) + _vm.amPm(hour)
                          )
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "el-time-spinner__wrapper is-arrow",
                on: {
                  mouseenter: function($event) {
                    _vm.emitSelectRange("minutes")
                  }
                }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "repeat-click",
                      rawName: "v-repeat-click",
                      value: _vm.decrease,
                      expression: "decrease"
                    }
                  ],
                  staticClass: "el-time-spinner__arrow el-icon-arrow-up"
                }),
                _c("i", {
                  directives: [
                    {
                      name: "repeat-click",
                      rawName: "v-repeat-click",
                      value: _vm.increase,
                      expression: "increase"
                    }
                  ],
                  staticClass: "el-time-spinner__arrow el-icon-arrow-down"
                }),
                _c(
                  "ul",
                  { ref: "minutes", staticClass: "el-time-spinner__list" },
                  _vm._l(_vm.arrowMinuteList, function(minute, key) {
                    return _c(
                      "li",
                      {
                        key: key,
                        staticClass: "el-time-spinner__item",
                        class: { active: minute === _vm.minutes }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              minute === undefined
                                ? ""
                                : ("0" + minute).slice(-2)
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            ),
            _vm.showSeconds
              ? _c(
                  "div",
                  {
                    staticClass: "el-time-spinner__wrapper is-arrow",
                    on: {
                      mouseenter: function($event) {
                        _vm.emitSelectRange("seconds")
                      }
                    }
                  },
                  [
                    _c("i", {
                      directives: [
                        {
                          name: "repeat-click",
                          rawName: "v-repeat-click",
                          value: _vm.decrease,
                          expression: "decrease"
                        }
                      ],
                      staticClass: "el-time-spinner__arrow el-icon-arrow-up"
                    }),
                    _c("i", {
                      directives: [
                        {
                          name: "repeat-click",
                          rawName: "v-repeat-click",
                          value: _vm.increase,
                          expression: "increase"
                        }
                      ],
                      staticClass: "el-time-spinner__arrow el-icon-arrow-down"
                    }),
                    _c(
                      "ul",
                      { ref: "seconds", staticClass: "el-time-spinner__list" },
                      _vm._l(_vm.arrowSecondList, function(second, key) {
                        return _c(
                          "li",
                          {
                            key: key,
                            staticClass: "el-time-spinner__item",
                            class: { active: second === _vm.seconds }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  second === undefined
                                    ? ""
                                    : ("0" + second).slice(-2)
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var time_spinnervue_type_template_id_1facadeb_staticRenderFns = []
time_spinnervue_type_template_id_1facadeb_render._withStripped = true


// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var time_spinnervue_type_script_lang_js_ = ({
  components: { ElScrollbar: scrollbar_default.a },

  directives: {
    repeatClick: repeat_click
  },

  props: {
    date: {},
    defaultValue: {}, // reserved for future use
    showSeconds: {
      type: Boolean,
      default: true
    },
    arrowControl: Boolean,
    amPmMode: {
      type: String,
      default: '' // 'a': am/pm; 'A': AM/PM
    }
  },

  computed: {
    hours: function hours() {
      return this.date.getHours();
    },
    minutes: function minutes() {
      return this.date.getMinutes();
    },
    seconds: function seconds() {
      return this.date.getSeconds();
    },
    hoursList: function hoursList() {
      return Object(date_util_["getRangeHours"])(this.selectableRange);
    },
    minutesList: function minutesList() {
      return Object(date_util_["getRangeMinutes"])(this.selectableRange, this.hours);
    },
    arrowHourList: function arrowHourList() {
      var hours = this.hours;
      return [hours > 0 ? hours - 1 : undefined, hours, hours < 23 ? hours + 1 : undefined];
    },
    arrowMinuteList: function arrowMinuteList() {
      var minutes = this.minutes;
      return [minutes > 0 ? minutes - 1 : undefined, minutes, minutes < 59 ? minutes + 1 : undefined];
    },
    arrowSecondList: function arrowSecondList() {
      var seconds = this.seconds;
      return [seconds > 0 ? seconds - 1 : undefined, seconds, seconds < 59 ? seconds + 1 : undefined];
    }
  },

  data: function data() {
    return {
      selectableRange: [],
      currentScrollbar: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      !_this.arrowControl && _this.bindScrollEvent();
    });
  },


  methods: {
    increase: function increase() {
      this.scrollDown(1);
    },
    decrease: function decrease() {
      this.scrollDown(-1);
    },
    modifyDateField: function modifyDateField(type, value) {
      switch (type) {
        case 'hours':
          this.$emit('change', Object(date_util_["modifyTime"])(this.date, value, this.minutes, this.seconds));break;
        case 'minutes':
          this.$emit('change', Object(date_util_["modifyTime"])(this.date, this.hours, value, this.seconds));break;
        case 'seconds':
          this.$emit('change', Object(date_util_["modifyTime"])(this.date, this.hours, this.minutes, value));break;
      }
    },
    handleClick: function handleClick(type, _ref) {
      var value = _ref.value,
          disabled = _ref.disabled;

      if (!disabled) {
        this.modifyDateField(type, value);
        this.emitSelectRange(type);
        this.adjustSpinner(type, value);
      }
    },
    emitSelectRange: function emitSelectRange(type) {
      if (type === 'hours') {
        this.$emit('select-range', 0, 2);
      } else if (type === 'minutes') {
        this.$emit('select-range', 3, 5);
      } else if (type === 'seconds') {
        this.$emit('select-range', 6, 8);
      }
      this.currentScrollbar = type;
    },
    bindScrollEvent: function bindScrollEvent() {
      var _this2 = this;

      var bindFuntion = function bindFuntion(type) {
        _this2.$refs[type].wrap.onscroll = function (e) {
          // TODO: scroll is emitted when set scrollTop programatically
          // should find better solutions in the future!
          _this2.handleScroll(type, e);
        };
      };
      bindFuntion('hours');
      bindFuntion('minutes');
      bindFuntion('seconds');
    },
    handleScroll: function handleScroll(type) {
      var value = Math.min(Math.round((this.$refs[type].wrap.scrollTop - (this.scrollBarHeight(type) * 0.5 - 10) / this.typeItemHeight(type) + 3) / this.typeItemHeight(type)), type === 'hours' ? 23 : 59);
      this.modifyDateField(type, value);
    },


    // NOTE: used by datetime / date-range panel
    //       renamed from adjustScrollTop
    //       should try to refactory it
    adjustSpinners: function adjustSpinners() {
      this.adjustSpinner('hours', this.hours);
      this.adjustSpinner('minutes', this.minutes);
      this.adjustSpinner('seconds', this.seconds);
    },
    adjustCurrentSpinner: function adjustCurrentSpinner(type) {
      this.adjustSpinner(type, this[type]);
    },
    adjustSpinner: function adjustSpinner(type, value) {
      if (this.arrowControl) return;
      var el = this.$refs[type].wrap;
      if (el) {
        el.scrollTop = Math.max(0, value * this.typeItemHeight(type));
      }
    },
    scrollDown: function scrollDown(step) {
      var _this3 = this;

      if (!this.currentScrollbar) {
        this.emitSelectRange('hours');
      }

      var label = this.currentScrollbar;
      var hoursList = this.hoursList;
      var now = this[label];

      if (this.currentScrollbar === 'hours') {
        var total = Math.abs(step);
        step = step > 0 ? 1 : -1;
        var length = hoursList.length;
        while (length-- && total) {
          now = (now + step + hoursList.length) % hoursList.length;
          if (hoursList[now]) {
            continue;
          }
          total--;
        }
        if (hoursList[now]) return;
      } else {
        now = (now + step + 60) % 60;
      }

      this.modifyDateField(label, now);
      this.adjustSpinner(label, now);
      this.$nextTick(function () {
        return _this3.emitSelectRange(_this3.currentScrollbar);
      });
    },
    amPm: function amPm(hour) {
      var shouldShowAmPm = this.amPmMode.toLowerCase() === 'a';
      if (!shouldShowAmPm) return '';
      var isCapital = this.amPmMode === 'A';
      var content = hour < 12 ? ' am' : ' pm';
      if (isCapital) content = content.toUpperCase();
      return content;
    },
    typeItemHeight: function typeItemHeight(type) {
      return this.$refs[type].$el.querySelector('li').offsetHeight;
    },
    scrollBarHeight: function scrollBarHeight(type) {
      return this.$refs[type].$el.offsetHeight;
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
 /* harmony default export */ var basic_time_spinnervue_type_script_lang_js_ = (time_spinnervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue





/* normalize component */

var time_spinner_component = normalizeComponent(
  basic_time_spinnervue_type_script_lang_js_,
  time_spinnervue_type_template_id_1facadeb_render,
  time_spinnervue_type_template_id_1facadeb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var time_spinner_api; }
time_spinner_component.options.__file = "packages/date-picker/src/basic/time-spinner.vue"
/* harmony default export */ var time_spinner = (time_spinner_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var timevue_type_script_lang_js_ = ({
  mixins: [locale_default.a],

  components: {
    TimeSpinner: time_spinner
  },

  props: {
    visible: Boolean,
    timeArrowControl: Boolean
  },

  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.oldValue = this.value;
        this.$nextTick(function () {
          return _this.$refs.spinner.emitSelectRange('hours');
        });
      } else {
        this.needInitAdjust = true;
      }
    },
    value: function value(newVal) {
      var _this2 = this;

      var date = void 0;
      if (newVal instanceof Date) {
        date = Object(date_util_["limitTimeRange"])(newVal, this.selectableRange, this.format);
      } else if (!newVal) {
        date = this.defaultValue ? new Date(this.defaultValue) : new Date();
      }

      this.date = date;
      if (this.visible && this.needInitAdjust) {
        this.$nextTick(function (_) {
          return _this2.adjustSpinners();
        });
        this.needInitAdjust = false;
      }
    },
    selectableRange: function selectableRange(val) {
      this.$refs.spinner.selectableRange = val;
    },
    defaultValue: function defaultValue(val) {
      if (!Object(date_util_["isDate"])(this.value)) {
        this.date = val ? new Date(val) : new Date();
      }
    }
  },

  data: function data() {
    return {
      popperClass: '',
      format: 'HH:mm:ss',
      value: '',
      defaultValue: null,
      date: new Date(),
      oldValue: new Date(),
      selectableRange: [],
      selectionRange: [0, 2],
      disabled: false,
      arrowControl: false,
      needInitAdjust: true
    };
  },


  computed: {
    showSeconds: function showSeconds() {
      return (this.format || '').indexOf('ss') !== -1;
    },
    useArrow: function useArrow() {
      return this.arrowControl || this.timeArrowControl || false;
    },
    amPmMode: function amPmMode() {
      if ((this.format || '').indexOf('A') !== -1) return 'A';
      if ((this.format || '').indexOf('a') !== -1) return 'a';
      return '';
    }
  },

  methods: {
    handleCancel: function handleCancel() {
      this.$emit('pick', this.oldValue, false);
    },
    handleChange: function handleChange(date) {
      // this.visible avoids edge cases, when use scrolls during panel closing animation
      if (this.visible) {
        this.date = Object(date_util_["clearMilliseconds"])(date);
        // if date is out of range, do not emit
        if (this.isValidValue(this.date)) {
          this.$emit('pick', this.date, true);
        }
      }
    },
    setSelectionRange: function setSelectionRange(start, end) {
      this.$emit('select-range', start, end);
      this.selectionRange = [start, end];
    },
    handleConfirm: function handleConfirm() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var first = arguments[1];

      if (first) return;
      var date = Object(date_util_["clearMilliseconds"])(Object(date_util_["limitTimeRange"])(this.date, this.selectableRange, this.format));
      this.$emit('pick', date, visible, first);
    },
    handleKeydown: function handleKeydown(event) {
      var keyCode = event.keyCode;
      var mapping = { 38: -1, 40: 1, 37: -1, 39: 1 };

      // Left or Right
      if (keyCode === 37 || keyCode === 39) {
        var step = mapping[keyCode];
        this.changeSelectionRange(step);
        event.preventDefault();
        return;
      }

      // Up or Down
      if (keyCode === 38 || keyCode === 40) {
        var _step = mapping[keyCode];
        this.$refs.spinner.scrollDown(_step);
        event.preventDefault();
        return;
      }
    },
    isValidValue: function isValidValue(date) {
      return Object(date_util_["timeWithinRange"])(date, this.selectableRange, this.format);
    },
    adjustSpinners: function adjustSpinners() {
      return this.$refs.spinner.adjustSpinners();
    },
    changeSelectionRange: function changeSelectionRange(step) {
      var list = [0, 3].concat(this.showSeconds ? [6] : []);
      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
      var index = list.indexOf(this.selectionRange[0]);
      var next = (index + step + list.length) % list.length;
      this.$refs.spinner.emitSelectRange(mapping[next]);
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      return _this3.handleConfirm(true, true);
    });
    this.$emit('mounted');
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
 /* harmony default export */ var panel_timevue_type_script_lang_js_ = (timevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue





/* normalize component */

var time_component = normalizeComponent(
  panel_timevue_type_script_lang_js_,
  timevue_type_template_id_3d939089_render,
  timevue_type_template_id_3d939089_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var time_api; }
time_component.options.__file = "packages/date-picker/src/panel/time.vue"
/* harmony default export */ var panel_time = (time_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&
var year_tablevue_type_template_id_c86ab5e0_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    { staticClass: "el-year-table", on: { click: _vm.handleYearTableClick } },
    [
      _c("tbody", [
        _c("tr", [
          _c(
            "td",
            {
              staticClass: "available",
              class: _vm.getCellStyle(_vm.startYear + 0)
            },
            [_c("a", { staticClass: "cell" }, [_vm._v(_vm._s(_vm.startYear))])]
          ),
          _c(
            "td",
            {
              staticClass: "available",
              class: _vm.getCellStyle(_vm.startYear + 1)
            },
            [
              _c("a", { staticClass: "cell" }, [
                _vm._v(_vm._s(_vm.startYear + 1))
              ])
            ]
          ),
          _c(
            "td",
            {
              staticClass: "available",
              class: _vm.getCellStyle(_vm.startYear + 2)
            },
            [
              _c("a", { staticClass: "cell" }, [
                _vm._v(_vm._s(_vm.startYear + 2))
              ])
            ]
          ),
          _c(
            "td",
            {
              staticClass: "available",
              class: _vm.getCellStyle(_vm.startYear + 3)
            },
            [
              _c("a", { staticClass: "cell" }, [
                _vm._v(_vm._s(_vm.startYear + 3))
              ])
            ]
          )
        ]),
        _c("tr", [
          _c(
            "td",
            {
              staticClass: "available",
              class: _vm.getCellStyle(_vm.startYear + 4)
            },
            [
              _c("a", { staticClass: "cell" }, [
                _vm._v(_vm._s(_vm.startYear + 4))
              ])
            ]
          ),
          _c(
            "td",
            {
              staticClass: "available",
              class: _vm.getCellStyle(_vm.startYear + 5)
            },
            [
              _c("a", { staticClass: "cell" }, [
                _vm._v(_vm._s(_vm.startYear + 5))
              ])
            ]
          ),
          _c(
            "td",
            {
              staticClass: "available",
              class: _vm.getCellStyle(_vm.startYear + 6)
            },
            [
              _c("a", { staticClass: "cell" }, [
                _vm._v(_vm._s(_vm.startYear + 6))
              ])
            ]
          ),
          _c(
            "td",
            {
              staticClass: "available",
              class: _vm.getCellStyle(_vm.startYear + 7)
            },
            [
              _c("a", { staticClass: "cell" }, [
                _vm._v(_vm._s(_vm.startYear + 7))
              ])
            ]
          )
        ]),
        _c("tr", [
          _c(
            "td",
            {
              staticClass: "available",
              class: _vm.getCellStyle(_vm.startYear + 8)
            },
            [
              _c("a", { staticClass: "cell" }, [
                _vm._v(_vm._s(_vm.startYear + 8))
              ])
            ]
          ),
          _c(
            "td",
            {
              staticClass: "available",
              class: _vm.getCellStyle(_vm.startYear + 9)
            },
            [
              _c("a", { staticClass: "cell" }, [
                _vm._v(_vm._s(_vm.startYear + 9))
              ])
            ]
          ),
          _c("td"),
          _c("td")
        ])
      ])
    ]
  )
}
var year_tablevue_type_template_id_c86ab5e0_staticRenderFns = []
year_tablevue_type_template_id_c86ab5e0_render._withStripped = true


// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var year_tablevue_type_script_lang_js_datesInYear = function datesInYear(year) {
  var numOfDays = Object(date_util_["getDayCountOfYear"])(year);
  var firstDay = new Date(year, 0, 1);
  return Object(date_util_["range"])(numOfDays).map(function (n) {
    return Object(date_util_["nextDate"])(firstDay, n);
  });
};

/* harmony default export */ var year_tablevue_type_script_lang_js_ = ({
  props: {
    disabledDate: {},
    value: {},
    defaultValue: {
      validator: function validator(val) {
        // null or valid Date Object
        return val === null || val instanceof Date && Object(date_util_["isDate"])(val);
      }
    },
    date: {}
  },

  computed: {
    startYear: function startYear() {
      return Math.floor(this.date.getFullYear() / 10) * 10;
    }
  },

  methods: {
    getCellStyle: function getCellStyle(year) {
      var style = {};
      var today = new Date();

      style.disabled = typeof this.disabledDate === 'function' ? year_tablevue_type_script_lang_js_datesInYear(year).every(this.disabledDate) : false;
      style.current = Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value), function (date) {
        return date.getFullYear() === year;
      }) >= 0;
      style.today = today.getFullYear() === year;
      style.default = this.defaultValue && this.defaultValue.getFullYear() === year;

      return style;
    },
    handleYearTableClick: function handleYearTableClick(event) {
      var target = event.target;
      if (target.tagName === 'A') {
        if (Object(dom_["hasClass"])(target.parentNode, 'disabled')) return;
        var year = target.textContent || target.innerText;
        this.$emit('pick', Number(year));
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
 /* harmony default export */ var basic_year_tablevue_type_script_lang_js_ = (year_tablevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue





/* normalize component */

var year_table_component = normalizeComponent(
  basic_year_tablevue_type_script_lang_js_,
  year_tablevue_type_template_id_c86ab5e0_render,
  year_tablevue_type_template_id_c86ab5e0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var year_table_api; }
year_table_component.options.__file = "packages/date-picker/src/basic/year-table.vue"
/* harmony default export */ var year_table = (year_table_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&
var month_tablevue_type_template_id_654d4f42_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    {
      staticClass: "el-month-table",
      on: { click: _vm.handleMonthTableClick, mousemove: _vm.handleMouseMove }
    },
    [
      _c(
        "tbody",
        _vm._l(_vm.rows, function(row, key) {
          return _c(
            "tr",
            { key: key },
            _vm._l(row, function(cell, key) {
              return _c("td", { key: key, class: _vm.getCellStyle(cell) }, [
                _c("div", [
                  _c("a", { staticClass: "cell" }, [
                    _vm._v(
                      _vm._s(
                        _vm.t("el.datepicker.months." + _vm.months[cell.text])
                      )
                    )
                  ])
                ])
              ])
            }),
            0
          )
        }),
        0
      )
    ]
  )
}
var month_tablevue_type_template_id_654d4f42_staticRenderFns = []
month_tablevue_type_template_id_654d4f42_render._withStripped = true


// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var month_tablevue_type_script_lang_js_datesInMonth = function datesInMonth(year, month) {
  var numOfDays = Object(date_util_["getDayCountOfMonth"])(year, month);
  var firstDay = new Date(year, month, 1);
  return Object(date_util_["range"])(numOfDays).map(function (n) {
    return Object(date_util_["nextDate"])(firstDay, n);
  });
};

var clearDate = function clearDate(date) {
  return new Date(date.getFullYear(), date.getMonth());
};

var getMonthTimestamp = function getMonthTimestamp(time) {
  if (typeof time === 'number' || typeof time === 'string') {
    return clearDate(new Date(time)).getTime();
  } else if (time instanceof Date) {
    return clearDate(time).getTime();
  } else {
    return NaN;
  }
};
/* harmony default export */ var month_tablevue_type_script_lang_js_ = ({
  props: {
    disabledDate: {},
    value: {},
    selectionMode: {
      default: 'month'
    },
    minDate: {},

    maxDate: {},
    defaultValue: {
      validator: function validator(val) {
        // null or valid Date Object
        return val === null || Object(date_util_["isDate"])(val) || Array.isArray(val) && val.every(date_util_["isDate"]);
      }
    },
    date: {},
    rangeState: {
      default: function _default() {
        return {
          endDate: null,
          selecting: false
        };
      }
    }
  },

  mixins: [locale_default.a],

  watch: {
    'rangeState.endDate': function rangeStateEndDate(newVal) {
      this.markRange(this.minDate, newVal);
    },
    minDate: function minDate(newVal, oldVal) {
      if (getMonthTimestamp(newVal) !== getMonthTimestamp(oldVal)) {
        this.markRange(this.minDate, this.maxDate);
      }
    },
    maxDate: function maxDate(newVal, oldVal) {
      if (getMonthTimestamp(newVal) !== getMonthTimestamp(oldVal)) {
        this.markRange(this.minDate, this.maxDate);
      }
    }
  },

  data: function data() {
    return {
      months: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
      tableRows: [[], [], []],
      lastRow: null,
      lastColumn: null
    };
  },


  methods: {
    cellMatchesDate: function cellMatchesDate(cell, date) {
      var value = new Date(date);
      return this.date.getFullYear() === value.getFullYear() && Number(cell.text) === value.getMonth();
    },
    getCellStyle: function getCellStyle(cell) {
      var _this = this;

      var style = {};
      var year = this.date.getFullYear();
      var today = new Date();
      var month = cell.text;
      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];
      style.disabled = typeof this.disabledDate === 'function' ? month_tablevue_type_script_lang_js_datesInMonth(year, month).every(this.disabledDate) : false;
      style.current = Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value), function (date) {
        return date.getFullYear() === year && date.getMonth() === month;
      }) >= 0;
      style.today = today.getFullYear() === year && today.getMonth() === month;
      style.default = defaultValue.some(function (date) {
        return _this.cellMatchesDate(cell, date);
      });

      if (cell.inRange) {
        style['in-range'] = true;

        if (cell.start) {
          style['start-date'] = true;
        }

        if (cell.end) {
          style['end-date'] = true;
        }
      }
      return style;
    },
    getMonthOfCell: function getMonthOfCell(month) {
      var year = this.date.getFullYear();
      return new Date(year, month, 1);
    },
    markRange: function markRange(minDate, maxDate) {
      minDate = getMonthTimestamp(minDate);
      maxDate = getMonthTimestamp(maxDate) || minDate;
      var _ref = [Math.min(minDate, maxDate), Math.max(minDate, maxDate)];
      minDate = _ref[0];
      maxDate = _ref[1];

      var rows = this.rows;
      for (var i = 0, k = rows.length; i < k; i++) {
        var row = rows[i];
        for (var j = 0, l = row.length; j < l; j++) {

          var cell = row[j];
          var index = i * 4 + j;
          var time = new Date(this.date.getFullYear(), index).getTime();

          cell.inRange = minDate && time >= minDate && time <= maxDate;
          cell.start = minDate && time === minDate;
          cell.end = maxDate && time === maxDate;
        }
      }
    },
    handleMouseMove: function handleMouseMove(event) {
      if (!this.rangeState.selecting) return;

      var target = event.target;
      if (target.tagName === 'A') {
        target = target.parentNode.parentNode;
      }
      if (target.tagName === 'DIV') {
        target = target.parentNode;
      }
      if (target.tagName !== 'TD') return;

      var row = target.parentNode.rowIndex;
      var column = target.cellIndex;
      // can not select disabled date
      if (this.rows[row][column].disabled) return;

      // only update rangeState when mouse moves to a new cell
      // this avoids frequent Date object creation and improves performance
      if (row !== this.lastRow || column !== this.lastColumn) {
        this.lastRow = row;
        this.lastColumn = column;
        this.$emit('changerange', {
          minDate: this.minDate,
          maxDate: this.maxDate,
          rangeState: {
            selecting: true,
            endDate: this.getMonthOfCell(row * 4 + column)
          }
        });
      }
    },
    handleMonthTableClick: function handleMonthTableClick(event) {
      var target = event.target;
      if (target.tagName === 'A') {
        target = target.parentNode.parentNode;
      }
      if (target.tagName === 'DIV') {
        target = target.parentNode;
      }
      if (target.tagName !== 'TD') return;
      if (Object(dom_["hasClass"])(target, 'disabled')) return;
      var column = target.cellIndex;
      var row = target.parentNode.rowIndex;
      var month = row * 4 + column;
      var newDate = this.getMonthOfCell(month);
      if (this.selectionMode === 'range') {
        if (!this.rangeState.selecting) {
          this.$emit('pick', { minDate: newDate, maxDate: null });
          this.rangeState.selecting = true;
        } else {
          if (newDate >= this.minDate) {
            this.$emit('pick', { minDate: this.minDate, maxDate: newDate });
          } else {
            this.$emit('pick', { minDate: newDate, maxDate: this.minDate });
          }
          this.rangeState.selecting = false;
        }
      } else {
        this.$emit('pick', month);
      }
    }
  },

  computed: {
    rows: function rows() {
      var _this2 = this;

      // TODO: refactory rows / getCellClasses
      var rows = this.tableRows;
      var disabledDate = this.disabledDate;
      var selectedDate = [];
      var now = getMonthTimestamp(new Date());

      for (var i = 0; i < 3; i++) {
        var row = rows[i];

        var _loop = function _loop(j) {
          var cell = row[j];
          if (!cell) {
            cell = { row: i, column: j, type: 'normal', inRange: false, start: false, end: false };
          }

          cell.type = 'normal';

          var index = i * 4 + j;
          var time = new Date(_this2.date.getFullYear(), index).getTime();
          cell.inRange = time >= getMonthTimestamp(_this2.minDate) && time <= getMonthTimestamp(_this2.maxDate);
          cell.start = _this2.minDate && time === getMonthTimestamp(_this2.minDate);
          cell.end = _this2.maxDate && time === getMonthTimestamp(_this2.maxDate);
          var isToday = time === now;

          if (isToday) {
            cell.type = 'today';
          }
          cell.text = index;
          var cellDate = new Date(time);
          cell.disabled = typeof disabledDate === 'function' && disabledDate(cellDate);
          cell.selected = Object(util_["arrayFind"])(selectedDate, function (date) {
            return date.getTime() === cellDate.getTime();
          });

          _this2.$set(row, j, cell);
        };

        for (var j = 0; j < 4; j++) {
          _loop(j);
        }
      }
      return rows;
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
 /* harmony default export */ var basic_month_tablevue_type_script_lang_js_ = (month_tablevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue





/* normalize component */

var month_table_component = normalizeComponent(
  basic_month_tablevue_type_script_lang_js_,
  month_tablevue_type_template_id_654d4f42_render,
  month_tablevue_type_template_id_654d4f42_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var month_table_api; }
month_table_component.options.__file = "packages/date-picker/src/basic/month-table.vue"
/* harmony default export */ var month_table = (month_table_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&
var date_tablevue_type_template_id_5d1f3341_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    {
      staticClass: "el-date-table",
      class: { "is-week-mode": _vm.selectionMode === "week" },
      attrs: { cellspacing: "0", cellpadding: "0" },
      on: { click: _vm.handleClick, mousemove: _vm.handleMouseMove }
    },
    [
      _c(
        "tbody",
        [
          _c(
            "tr",
            [
              _vm.showWeekNumber
                ? _c("th", [_vm._v(_vm._s(_vm.t("el.datepicker.week")))])
                : _vm._e(),
              _vm._l(_vm.WEEKS, function(week, key) {
                return _c("th", { key: key }, [
                  _vm._v(_vm._s(_vm.t("el.datepicker.weeks." + week)))
                ])
              })
            ],
            2
          ),
          _vm._l(_vm.rows, function(row, key) {
            return _c(
              "tr",
              {
                key: key,
                staticClass: "el-date-table__row",
                class: { current: _vm.isWeekActive(row[1]) }
              },
              _vm._l(row, function(cell, key) {
                return _c("td", { key: key, class: _vm.getCellClasses(cell) }, [
                  _c("div", [
                    _c("span", [
                      _vm._v("\n          " + _vm._s(cell.text) + "\n        ")
                    ])
                  ])
                ])
              }),
              0
            )
          })
        ],
        2
      )
    ]
  )
}
var date_tablevue_type_template_id_5d1f3341_staticRenderFns = []
date_tablevue_type_template_id_5d1f3341_render._withStripped = true


// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var _WEEKS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
var date_tablevue_type_script_lang_js_getDateTimestamp = function getDateTimestamp(time) {
  if (typeof time === 'number' || typeof time === 'string') {
    return Object(date_util_["clearTime"])(new Date(time)).getTime();
  } else if (time instanceof Date) {
    return Object(date_util_["clearTime"])(time).getTime();
  } else {
    return NaN;
  }
};

// remove the first element that satisfies `pred` from arr
// return a new array if modification occurs
// return the original array otherwise
var date_tablevue_type_script_lang_js_removeFromArray = function removeFromArray(arr, pred) {
  var idx = typeof pred === 'function' ? Object(util_["arrayFindIndex"])(arr, pred) : arr.indexOf(pred);
  return idx >= 0 ? [].concat(arr.slice(0, idx), arr.slice(idx + 1)) : arr;
};

/* harmony default export */ var date_tablevue_type_script_lang_js_ = ({
  mixins: [locale_default.a],

  props: {
    firstDayOfWeek: {
      default: 7,
      type: Number,
      validator: function validator(val) {
        return val >= 1 && val <= 7;
      }
    },

    value: {},

    defaultValue: {
      validator: function validator(val) {
        // either: null, valid Date object, Array of valid Date objects
        return val === null || Object(date_util_["isDate"])(val) || Array.isArray(val) && val.every(date_util_["isDate"]);
      }
    },

    date: {},

    selectionMode: {
      default: 'day'
    },

    showWeekNumber: {
      type: Boolean,
      default: false
    },

    disabledDate: {},

    cellClassName: {},

    minDate: {},

    maxDate: {},

    rangeState: {
      default: function _default() {
        return {
          endDate: null,
          selecting: false
        };
      }
    }
  },

  computed: {
    offsetDay: function offsetDay() {
      var week = this.firstDayOfWeek;
      // 周日为界限，左右偏移的天数，3217654 例如周一就是 -1，目的是调整前两行日期的位置
      return week > 3 ? 7 - week : -week;
    },
    WEEKS: function WEEKS() {
      var week = this.firstDayOfWeek;
      return _WEEKS.concat(_WEEKS).slice(week, week + 7);
    },
    year: function year() {
      return this.date.getFullYear();
    },
    month: function month() {
      return this.date.getMonth();
    },
    startDate: function startDate() {
      return Object(date_util_["getStartDateOfMonth"])(this.year, this.month);
    },
    rows: function rows() {
      var _this = this;

      // TODO: refactory rows / getCellClasses
      var date = new Date(this.year, this.month, 1);
      var day = Object(date_util_["getFirstDayOfMonth"])(date); // day of first day
      var dateCountOfMonth = Object(date_util_["getDayCountOfMonth"])(date.getFullYear(), date.getMonth());
      var dateCountOfLastMonth = Object(date_util_["getDayCountOfMonth"])(date.getFullYear(), date.getMonth() === 0 ? 11 : date.getMonth() - 1);

      day = day === 0 ? 7 : day;

      var offset = this.offsetDay;
      var rows = this.tableRows;
      var count = 1;

      var startDate = this.startDate;
      var disabledDate = this.disabledDate;
      var cellClassName = this.cellClassName;
      var selectedDate = this.selectionMode === 'dates' ? Object(util_["coerceTruthyValueToArray"])(this.value) : [];
      var now = date_tablevue_type_script_lang_js_getDateTimestamp(new Date());

      for (var i = 0; i < 6; i++) {
        var row = rows[i];

        if (this.showWeekNumber) {
          if (!row[0]) {
            row[0] = { type: 'week', text: Object(date_util_["getWeekNumber"])(Object(date_util_["nextDate"])(startDate, i * 7 + 1)) };
          }
        }

        var _loop = function _loop(j) {
          var cell = row[_this.showWeekNumber ? j + 1 : j];
          if (!cell) {
            cell = { row: i, column: j, type: 'normal', inRange: false, start: false, end: false };
          }

          cell.type = 'normal';

          var index = i * 7 + j;
          var time = Object(date_util_["nextDate"])(startDate, index - offset).getTime();
          cell.inRange = time >= date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate) && time <= date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);
          cell.start = _this.minDate && time === date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate);
          cell.end = _this.maxDate && time === date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);
          var isToday = time === now;

          if (isToday) {
            cell.type = 'today';
          }

          if (i >= 0 && i <= 1) {
            var numberOfDaysFromPreviousMonth = day + offset < 0 ? 7 + day + offset : day + offset;

            if (j + i * 7 >= numberOfDaysFromPreviousMonth) {
              cell.text = count++;
            } else {
              cell.text = dateCountOfLastMonth - (numberOfDaysFromPreviousMonth - j % 7) + 1 + i * 7;
              cell.type = 'prev-month';
            }
          } else {
            if (count <= dateCountOfMonth) {
              cell.text = count++;
            } else {
              cell.text = count++ - dateCountOfMonth;
              cell.type = 'next-month';
            }
          }

          var cellDate = new Date(time);
          cell.disabled = typeof disabledDate === 'function' && disabledDate(cellDate);
          cell.selected = Object(util_["arrayFind"])(selectedDate, function (date) {
            return date.getTime() === cellDate.getTime();
          });
          cell.customClass = typeof cellClassName === 'function' && cellClassName(cellDate);
          _this.$set(row, _this.showWeekNumber ? j + 1 : j, cell);
        };

        for (var j = 0; j < 7; j++) {
          _loop(j);
        }

        if (this.selectionMode === 'week') {
          var start = this.showWeekNumber ? 1 : 0;
          var end = this.showWeekNumber ? 7 : 6;
          var isWeekActive = this.isWeekActive(row[start + 1]);

          row[start].inRange = isWeekActive;
          row[start].start = isWeekActive;
          row[end].inRange = isWeekActive;
          row[end].end = isWeekActive;
        }
      }

      return rows;
    }
  },

  watch: {
    'rangeState.endDate': function rangeStateEndDate(newVal) {
      this.markRange(this.minDate, newVal);
    },
    minDate: function minDate(newVal, oldVal) {
      if (date_tablevue_type_script_lang_js_getDateTimestamp(newVal) !== date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)) {
        this.markRange(this.minDate, this.maxDate);
      }
    },
    maxDate: function maxDate(newVal, oldVal) {
      if (date_tablevue_type_script_lang_js_getDateTimestamp(newVal) !== date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)) {
        this.markRange(this.minDate, this.maxDate);
      }
    }
  },

  data: function data() {
    return {
      tableRows: [[], [], [], [], [], []],
      lastRow: null,
      lastColumn: null
    };
  },


  methods: {
    cellMatchesDate: function cellMatchesDate(cell, date) {
      var value = new Date(date);
      return this.year === value.getFullYear() && this.month === value.getMonth() && Number(cell.text) === value.getDate();
    },
    getCellClasses: function getCellClasses(cell) {
      var _this2 = this;

      var selectionMode = this.selectionMode;
      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];

      var classes = [];
      if ((cell.type === 'normal' || cell.type === 'today') && !cell.disabled) {
        classes.push('available');
        if (cell.type === 'today') {
          classes.push('today');
        }
      } else {
        classes.push(cell.type);
      }

      if (cell.type === 'normal' && defaultValue.some(function (date) {
        return _this2.cellMatchesDate(cell, date);
      })) {
        classes.push('default');
      }

      if (selectionMode === 'day' && (cell.type === 'normal' || cell.type === 'today') && this.cellMatchesDate(cell, this.value)) {
        classes.push('current');
      }

      if (cell.inRange && (cell.type === 'normal' || cell.type === 'today' || this.selectionMode === 'week')) {
        classes.push('in-range');

        if (cell.start) {
          classes.push('start-date');
        }

        if (cell.end) {
          classes.push('end-date');
        }
      }

      if (cell.disabled) {
        classes.push('disabled');
      }

      if (cell.selected) {
        classes.push('selected');
      }

      if (cell.customClass) {
        classes.push(cell.customClass);
      }

      return classes.join(' ');
    },
    getDateOfCell: function getDateOfCell(row, column) {
      var offsetFromStart = row * 7 + (column - (this.showWeekNumber ? 1 : 0)) - this.offsetDay;
      return Object(date_util_["nextDate"])(this.startDate, offsetFromStart);
    },
    isWeekActive: function isWeekActive(cell) {
      if (this.selectionMode !== 'week') return false;
      var newDate = new Date(this.year, this.month, 1);
      var year = newDate.getFullYear();
      var month = newDate.getMonth();

      if (cell.type === 'prev-month') {
        newDate.setMonth(month === 0 ? 11 : month - 1);
        newDate.setFullYear(month === 0 ? year - 1 : year);
      }

      if (cell.type === 'next-month') {
        newDate.setMonth(month === 11 ? 0 : month + 1);
        newDate.setFullYear(month === 11 ? year + 1 : year);
      }

      newDate.setDate(parseInt(cell.text, 10));

      if (Object(date_util_["isDate"])(this.value)) {
        var dayOffset = (this.value.getDay() - this.firstDayOfWeek + 7) % 7 - 1;
        var weekDate = Object(date_util_["prevDate"])(this.value, dayOffset);
        return weekDate.getTime() === newDate.getTime();
      }
      return false;
    },
    markRange: function markRange(minDate, maxDate) {
      minDate = date_tablevue_type_script_lang_js_getDateTimestamp(minDate);
      maxDate = date_tablevue_type_script_lang_js_getDateTimestamp(maxDate) || minDate;
      var _ref = [Math.min(minDate, maxDate), Math.max(minDate, maxDate)];
      minDate = _ref[0];
      maxDate = _ref[1];


      var startDate = this.startDate;
      var rows = this.rows;
      for (var i = 0, k = rows.length; i < k; i++) {
        var row = rows[i];
        for (var j = 0, l = row.length; j < l; j++) {
          if (this.showWeekNumber && j === 0) continue;

          var _cell = row[j];
          var index = i * 7 + j + (this.showWeekNumber ? -1 : 0);
          var time = Object(date_util_["nextDate"])(startDate, index - this.offsetDay).getTime();

          _cell.inRange = minDate && time >= minDate && time <= maxDate;
          _cell.start = minDate && time === minDate;
          _cell.end = maxDate && time === maxDate;
        }
      }
    },
    handleMouseMove: function handleMouseMove(event) {
      if (!this.rangeState.selecting) return;

      var target = event.target;
      if (target.tagName === 'SPAN') {
        target = target.parentNode.parentNode;
      }
      if (target.tagName === 'DIV') {
        target = target.parentNode;
      }
      if (target.tagName !== 'TD') return;

      var row = target.parentNode.rowIndex - 1;
      var column = target.cellIndex;

      // can not select disabled date
      if (this.rows[row][column].disabled) return;

      // only update rangeState when mouse moves to a new cell
      // this avoids frequent Date object creation and improves performance
      if (row !== this.lastRow || column !== this.lastColumn) {
        this.lastRow = row;
        this.lastColumn = column;
        this.$emit('changerange', {
          minDate: this.minDate,
          maxDate: this.maxDate,
          rangeState: {
            selecting: true,
            endDate: this.getDateOfCell(row, column)
          }
        });
      }
    },
    handleClick: function handleClick(event) {
      var target = event.target;
      if (target.tagName === 'SPAN') {
        target = target.parentNode.parentNode;
      }
      if (target.tagName === 'DIV') {
        target = target.parentNode;
      }

      if (target.tagName !== 'TD') return;

      var row = target.parentNode.rowIndex - 1;
      var column = this.selectionMode === 'week' ? 1 : target.cellIndex;
      var cell = this.rows[row][column];

      if (cell.disabled || cell.type === 'week') return;

      var newDate = this.getDateOfCell(row, column);

      if (this.selectionMode === 'range') {
        if (!this.rangeState.selecting) {
          this.$emit('pick', { minDate: newDate, maxDate: null });
          this.rangeState.selecting = true;
        } else {
          if (newDate >= this.minDate) {
            this.$emit('pick', { minDate: this.minDate, maxDate: newDate });
          } else {
            this.$emit('pick', { minDate: newDate, maxDate: this.minDate });
          }
          this.rangeState.selecting = false;
        }
      } else if (this.selectionMode === 'day') {
        this.$emit('pick', newDate);
      } else if (this.selectionMode === 'week') {
        var weekNumber = Object(date_util_["getWeekNumber"])(newDate);
        var value = newDate.getFullYear() + 'w' + weekNumber;
        this.$emit('pick', {
          year: newDate.getFullYear(),
          week: weekNumber,
          value: value,
          date: newDate
        });
      } else if (this.selectionMode === 'dates') {
        var _value = this.value || [];
        var newValue = cell.selected ? date_tablevue_type_script_lang_js_removeFromArray(_value, function (date) {
          return date.getTime() === newDate.getTime();
        }) : [].concat(_value, [newDate]);
        this.$emit('pick', newValue);
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
 /* harmony default export */ var basic_date_tablevue_type_script_lang_js_ = (date_tablevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue





/* normalize component */

var date_table_component = normalizeComponent(
  basic_date_tablevue_type_script_lang_js_,
  date_tablevue_type_template_id_5d1f3341_render,
  date_tablevue_type_template_id_5d1f3341_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var date_table_api; }
date_table_component.options.__file = "packages/date-picker/src/basic/date-table.vue"
/* harmony default export */ var date_table = (date_table_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var datevue_type_script_lang_js_ = ({
  mixins: [locale_default.a],

  directives: { Clickoutside: clickoutside_default.a },

  watch: {
    showTime: function showTime(val) {
      var _this = this;

      /* istanbul ignore if */
      if (!val) return;
      this.$nextTick(function (_) {
        var inputElm = _this.$refs.input.$el;
        if (inputElm) {
          _this.pickerWidth = inputElm.getBoundingClientRect().width + 10;
        }
      });
    },
    value: function value(val) {
      if (this.selectionMode === 'dates' && this.value) return;
      if (Object(date_util_["isDate"])(val)) {
        this.date = new Date(val);
      } else {
        this.date = this.getDefaultValue();
      }
    },
    defaultValue: function defaultValue(val) {
      if (!Object(date_util_["isDate"])(this.value)) {
        this.date = val ? new Date(val) : new Date();
      }
    },
    timePickerVisible: function timePickerVisible(val) {
      var _this2 = this;

      if (val) this.$nextTick(function () {
        return _this2.$refs.timepicker.adjustSpinners();
      });
    },
    selectionMode: function selectionMode(newVal) {
      if (newVal === 'month') {
        /* istanbul ignore next */
        if (this.currentView !== 'year' || this.currentView !== 'month') {
          this.currentView = 'month';
        }
      } else if (newVal === 'dates') {
        this.currentView = 'date';
      }
    }
  },

  methods: {
    proxyTimePickerDataProperties: function proxyTimePickerDataProperties() {
      var _this3 = this;

      var format = function format(timeFormat) {
        _this3.$refs.timepicker.format = timeFormat;
      };
      var value = function value(_value) {
        _this3.$refs.timepicker.value = _value;
      };
      var date = function date(_date) {
        _this3.$refs.timepicker.date = _date;
      };
      var selectableRange = function selectableRange(_selectableRange) {
        _this3.$refs.timepicker.selectableRange = _selectableRange;
      };

      this.$watch('value', value);
      this.$watch('date', date);
      this.$watch('selectableRange', selectableRange);

      format(this.timeFormat);
      value(this.value);
      date(this.date);
      selectableRange(this.selectableRange);
    },
    handleClear: function handleClear() {
      this.date = this.getDefaultValue();
      this.$emit('pick', null);
    },
    emit: function emit(value) {
      var _this4 = this;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (!value) {
        this.$emit.apply(this, ['pick', value].concat(args));
      } else if (Array.isArray(value)) {
        var dates = value.map(function (date) {
          return _this4.showTime ? Object(date_util_["clearMilliseconds"])(date) : Object(date_util_["clearTime"])(date);
        });
        this.$emit.apply(this, ['pick', dates].concat(args));
      } else {
        this.$emit.apply(this, ['pick', this.showTime ? Object(date_util_["clearMilliseconds"])(value) : Object(date_util_["clearTime"])(value)].concat(args));
      }
      this.userInputDate = null;
      this.userInputTime = null;
    },


    // resetDate() {
    //   this.date = new Date(this.date);
    // },

    showMonthPicker: function showMonthPicker() {
      this.currentView = 'month';
    },
    showYearPicker: function showYearPicker() {
      this.currentView = 'year';
    },


    // XXX: 没用到
    // handleLabelClick() {
    //   if (this.currentView === 'date') {
    //     this.showMonthPicker();
    //   } else if (this.currentView === 'month') {
    //     this.showYearPicker();
    //   }
    // },

    prevMonth: function prevMonth() {
      this.date = Object(date_util_["prevMonth"])(this.date);
    },
    nextMonth: function nextMonth() {
      this.date = Object(date_util_["nextMonth"])(this.date);
    },
    prevYear: function prevYear() {
      if (this.currentView === 'year') {
        this.date = Object(date_util_["prevYear"])(this.date, 10);
      } else {
        this.date = Object(date_util_["prevYear"])(this.date);
      }
    },
    nextYear: function nextYear() {
      if (this.currentView === 'year') {
        this.date = Object(date_util_["nextYear"])(this.date, 10);
      } else {
        this.date = Object(date_util_["nextYear"])(this.date);
      }
    },
    handleShortcutClick: function handleShortcutClick(shortcut) {
      if (shortcut.onClick) {
        shortcut.onClick(this);
      }
    },
    handleTimePick: function handleTimePick(value, visible, first) {
      if (Object(date_util_["isDate"])(value)) {
        var newDate = this.value ? Object(date_util_["modifyTime"])(this.value, value.getHours(), value.getMinutes(), value.getSeconds()) : Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(), this.defaultTime);
        this.date = newDate;
        this.emit(this.date, true);
      } else {
        this.emit(value, true);
      }
      if (!first) {
        this.timePickerVisible = visible;
      }
    },
    handleTimePickClose: function handleTimePickClose() {
      this.timePickerVisible = false;
    },
    handleMonthPick: function handleMonthPick(month) {
      if (this.selectionMode === 'month') {
        this.date = Object(date_util_["modifyDate"])(this.date, this.year, month, 1);
        this.emit(this.date);
      } else {
        this.date = Object(date_util_["changeYearMonthAndClampDate"])(this.date, this.year, month);
        // TODO: should emit intermediate value ??
        // this.emit(this.date);
        this.currentView = 'date';
      }
    },
    handleDatePick: function handleDatePick(value) {
      if (this.selectionMode === 'day') {
        var newDate = this.value ? Object(date_util_["modifyDate"])(this.value, value.getFullYear(), value.getMonth(), value.getDate()) : Object(date_util_["modifyWithTimeString"])(value, this.defaultTime);
        // change default time while out of selectableRange
        if (!this.checkDateWithinRange(newDate)) {
          newDate = Object(date_util_["modifyDate"])(this.selectableRange[0][0], value.getFullYear(), value.getMonth(), value.getDate());
        }
        this.date = newDate;
        this.emit(this.date, this.showTime);
      } else if (this.selectionMode === 'week') {
        this.emit(value.date);
      } else if (this.selectionMode === 'dates') {
        this.emit(value, true); // set false to keep panel open
      }
    },
    handleYearPick: function handleYearPick(year) {
      if (this.selectionMode === 'year') {
        this.date = Object(date_util_["modifyDate"])(this.date, year, 0, 1);
        this.emit(this.date);
      } else {
        this.date = Object(date_util_["changeYearMonthAndClampDate"])(this.date, year, this.month);
        // TODO: should emit intermediate value ??
        // this.emit(this.date, true);
        this.currentView = 'month';
      }
    },
    changeToNow: function changeToNow() {
      // NOTE: not a permanent solution
      //       consider disable "now" button in the future
      if ((!this.disabledDate || !this.disabledDate(new Date())) && this.checkDateWithinRange(new Date())) {
        this.date = new Date();
        this.emit(this.date);
      }
    },
    confirm: function confirm() {
      if (this.selectionMode === 'dates') {
        this.emit(this.value);
      } else {
        // value were emitted in handle{Date,Time}Pick, nothing to update here
        // deal with the scenario where: user opens the picker, then confirm without doing anything
        var value = this.value ? this.value : Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(), this.defaultTime);
        this.date = new Date(value); // refresh date
        this.emit(value);
      }
    },
    resetView: function resetView() {
      if (this.selectionMode === 'month') {
        this.currentView = 'month';
      } else if (this.selectionMode === 'year') {
        this.currentView = 'year';
      } else {
        this.currentView = 'date';
      }
    },
    handleEnter: function handleEnter() {
      document.body.addEventListener('keydown', this.handleKeydown);
    },
    handleLeave: function handleLeave() {
      this.$emit('dodestroy');
      document.body.removeEventListener('keydown', this.handleKeydown);
    },
    handleKeydown: function handleKeydown(event) {
      var keyCode = event.keyCode;
      var list = [38, 40, 37, 39];
      if (this.visible && !this.timePickerVisible) {
        if (list.indexOf(keyCode) !== -1) {
          this.handleKeyControl(keyCode);
          event.stopPropagation();
          event.preventDefault();
        }
        if (keyCode === 13 && this.userInputDate === null && this.userInputTime === null) {
          // Enter
          this.emit(this.date, false);
        }
      }
    },
    handleKeyControl: function handleKeyControl(keyCode) {
      var mapping = {
        'year': {
          38: -4, 40: 4, 37: -1, 39: 1, offset: function offset(date, step) {
            return date.setFullYear(date.getFullYear() + step);
          }
        },
        'month': {
          38: -4, 40: 4, 37: -1, 39: 1, offset: function offset(date, step) {
            return date.setMonth(date.getMonth() + step);
          }
        },
        'week': {
          38: -1, 40: 1, 37: -1, 39: 1, offset: function offset(date, step) {
            return date.setDate(date.getDate() + step * 7);
          }
        },
        'day': {
          38: -7, 40: 7, 37: -1, 39: 1, offset: function offset(date, step) {
            return date.setDate(date.getDate() + step);
          }
        }
      };
      var mode = this.selectionMode;
      var year = 3.1536e10;
      var now = this.date.getTime();
      var newDate = new Date(this.date.getTime());
      while (Math.abs(now - newDate.getTime()) <= year) {
        var map = mapping[mode];
        map.offset(newDate, map[keyCode]);
        if (typeof this.disabledDate === 'function' && this.disabledDate(newDate)) {
          continue;
        }
        this.date = newDate;
        this.$emit('pick', newDate, true);
        break;
      }
    },
    handleVisibleTimeChange: function handleVisibleTimeChange(value) {
      var time = Object(date_util_["parseDate"])(value, this.timeFormat);
      if (time && this.checkDateWithinRange(time)) {
        this.date = Object(date_util_["modifyDate"])(time, this.year, this.month, this.monthDate);
        this.userInputTime = null;
        this.$refs.timepicker.value = this.date;
        this.timePickerVisible = false;
        this.emit(this.date, true);
      }
    },
    handleVisibleDateChange: function handleVisibleDateChange(value) {
      var date = Object(date_util_["parseDate"])(value, this.dateFormat);
      if (date) {
        if (typeof this.disabledDate === 'function' && this.disabledDate(date)) {
          return;
        }
        this.date = Object(date_util_["modifyTime"])(date, this.date.getHours(), this.date.getMinutes(), this.date.getSeconds());
        this.userInputDate = null;
        this.resetView();
        this.emit(this.date, true);
      }
    },
    isValidValue: function isValidValue(value) {
      return value && !isNaN(value) && (typeof this.disabledDate === 'function' ? !this.disabledDate(value) : true) && this.checkDateWithinRange(value);
    },
    getDefaultValue: function getDefaultValue() {
      // if default-value is set, return it
      // otherwise, return now (the moment this method gets called)
      return this.defaultValue ? new Date(this.defaultValue) : new Date();
    },
    checkDateWithinRange: function checkDateWithinRange(date) {
      return this.selectableRange.length > 0 ? Object(date_util_["timeWithinRange"])(date, this.selectableRange, this.format || 'HH:mm:ss') : true;
    }
  },

  components: {
    TimePicker: panel_time, YearTable: year_table, MonthTable: month_table, DateTable: date_table, ElInput: input_default.a, ElButton: button_default.a
  },

  data: function data() {
    return {
      popperClass: '',
      date: new Date(),
      value: '',
      defaultValue: null, // use getDefaultValue() for time computation
      defaultTime: null,
      showTime: false,
      selectionMode: 'day',
      shortcuts: '',
      visible: false,
      currentView: 'date',
      disabledDate: '',
      cellClassName: '',
      selectableRange: [],
      firstDayOfWeek: 7,
      showWeekNumber: false,
      timePickerVisible: false,
      format: '',
      arrowControl: false,
      userInputDate: null,
      userInputTime: null
    };
  },


  computed: {
    year: function year() {
      return this.date.getFullYear();
    },
    month: function month() {
      return this.date.getMonth();
    },
    week: function week() {
      return Object(date_util_["getWeekNumber"])(this.date);
    },
    monthDate: function monthDate() {
      return this.date.getDate();
    },
    footerVisible: function footerVisible() {
      return this.showTime || this.selectionMode === 'dates';
    },
    visibleTime: function visibleTime() {
      if (this.userInputTime !== null) {
        return this.userInputTime;
      } else {
        return Object(date_util_["formatDate"])(this.value || this.defaultValue, this.timeFormat);
      }
    },
    visibleDate: function visibleDate() {
      if (this.userInputDate !== null) {
        return this.userInputDate;
      } else {
        return Object(date_util_["formatDate"])(this.value || this.defaultValue, this.dateFormat);
      }
    },
    yearLabel: function yearLabel() {
      var yearTranslation = this.t('el.datepicker.year');
      if (this.currentView === 'year') {
        var startYear = Math.floor(this.year / 10) * 10;
        if (yearTranslation) {
          return startYear + ' ' + yearTranslation + ' - ' + (startYear + 9) + ' ' + yearTranslation;
        }
        return startYear + ' - ' + (startYear + 9);
      }
      return this.year + ' ' + yearTranslation;
    },
    timeFormat: function timeFormat() {
      if (this.format) {
        return Object(date_util_["extractTimeFormat"])(this.format);
      } else {
        return 'HH:mm:ss';
      }
    },
    dateFormat: function dateFormat() {
      if (this.format) {
        return Object(date_util_["extractDateFormat"])(this.format);
      } else {
        return 'yyyy-MM-dd';
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
 /* harmony default export */ var panel_datevue_type_script_lang_js_ = (datevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue





/* normalize component */

var date_component = normalizeComponent(
  panel_datevue_type_script_lang_js_,
  datevue_type_template_id_2440d4ea_render,
  datevue_type_template_id_2440d4ea_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var date_api; }
date_component.options.__file = "packages/date-picker/src/panel/date.vue"
/* harmony default export */ var panel_date = (date_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&
var date_rangevue_type_template_id_2652849a_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "el-zoom-in-top" },
      on: {
        "after-leave": function($event) {
          _vm.$emit("dodestroy")
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          staticClass: "el-picker-panel el-date-range-picker el-popper",
          class: [
            {
              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts,
              "has-time": _vm.showTime
            },
            _vm.popperClass
          ]
        },
        [
          _c(
            "div",
            { staticClass: "el-picker-panel__body-wrapper" },
            [
              _vm._t("sidebar"),
              _vm.shortcuts
                ? _c(
                    "div",
                    { staticClass: "el-picker-panel__sidebar" },
                    _vm._l(_vm.shortcuts, function(shortcut, key) {
                      return _c(
                        "button",
                        {
                          key: key,
                          staticClass: "el-picker-panel__shortcut",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.handleShortcutClick(shortcut)
                            }
                          }
                        },
                        [_vm._v(_vm._s(shortcut.text))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _c("div", { staticClass: "el-picker-panel__body" }, [
                _vm.showTime
                  ? _c(
                      "div",
                      { staticClass: "el-date-range-picker__time-header" },
                      [
                        _c(
                          "span",
                          { staticClass: "el-date-range-picker__editors-wrap" },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "el-date-range-picker__time-picker-wrap"
                              },
                              [
                                _c("el-input", {
                                  ref: "minInput",
                                  staticClass: "el-date-range-picker__editor",
                                  attrs: {
                                    size: "small",
                                    disabled: _vm.rangeState.selecting,
                                    placeholder: _vm.t(
                                      "el.datepicker.startDate"
                                    ),
                                    value: _vm.minVisibleDate
                                  },
                                  on: {
                                    input: function(val) {
                                      return _vm.handleDateInput(val, "min")
                                    },
                                    change: function(val) {
                                      return _vm.handleDateChange(val, "min")
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "clickoutside",
                                    rawName: "v-clickoutside",
                                    value: _vm.handleMinTimeClose,
                                    expression: "handleMinTimeClose"
                                  }
                                ],
                                staticClass:
                                  "el-date-range-picker__time-picker-wrap"
                              },
                              [
                                _c("el-input", {
                                  staticClass: "el-date-range-picker__editor",
                                  attrs: {
                                    size: "small",
                                    disabled: _vm.rangeState.selecting,
                                    placeholder: _vm.t(
                                      "el.datepicker.startTime"
                                    ),
                                    value: _vm.minVisibleTime
                                  },
                                  on: {
                                    focus: function($event) {
                                      _vm.minTimePickerVisible = true
                                    },
                                    input: function(val) {
                                      return _vm.handleTimeInput(val, "min")
                                    },
                                    change: function(val) {
                                      return _vm.handleTimeChange(val, "min")
                                    }
                                  }
                                }),
                                _c("time-picker", {
                                  ref: "minTimePicker",
                                  attrs: {
                                    "time-arrow-control": _vm.arrowControl,
                                    visible: _vm.minTimePickerVisible
                                  },
                                  on: {
                                    pick: _vm.handleMinTimePick,
                                    mounted: function($event) {
                                      _vm.$refs.minTimePicker.format =
                                        _vm.timeFormat
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _c("span", { staticClass: "el-icon-arrow-right" }),
                        _c(
                          "span",
                          {
                            staticClass:
                              "el-date-range-picker__editors-wrap is-right"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "el-date-range-picker__time-picker-wrap"
                              },
                              [
                                _c("el-input", {
                                  staticClass: "el-date-range-picker__editor",
                                  attrs: {
                                    size: "small",
                                    disabled: _vm.rangeState.selecting,
                                    placeholder: _vm.t("el.datepicker.endDate"),
                                    value: _vm.maxVisibleDate,
                                    readonly: !_vm.minDate
                                  },
                                  on: {
                                    input: function(val) {
                                      return _vm.handleDateInput(val, "max")
                                    },
                                    change: function(val) {
                                      return _vm.handleDateChange(val, "max")
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "clickoutside",
                                    rawName: "v-clickoutside",
                                    value: _vm.handleMaxTimeClose,
                                    expression: "handleMaxTimeClose"
                                  }
                                ],
                                staticClass:
                                  "el-date-range-picker__time-picker-wrap"
                              },
                              [
                                _c("el-input", {
                                  staticClass: "el-date-range-picker__editor",
                                  attrs: {
                                    size: "small",
                                    disabled: _vm.rangeState.selecting,
                                    placeholder: _vm.t("el.datepicker.endTime"),
                                    value: _vm.maxVisibleTime,
                                    readonly: !_vm.minDate
                                  },
                                  on: {
                                    focus: function($event) {
                                      _vm.minDate &&
                                        (_vm.maxTimePickerVisible = true)
                                    },
                                    input: function(val) {
                                      return _vm.handleTimeInput(val, "max")
                                    },
                                    change: function(val) {
                                      return _vm.handleTimeChange(val, "max")
                                    }
                                  }
                                }),
                                _c("time-picker", {
                                  ref: "maxTimePicker",
                                  attrs: {
                                    "time-arrow-control": _vm.arrowControl,
                                    visible: _vm.maxTimePickerVisible
                                  },
                                  on: {
                                    pick: _vm.handleMaxTimePick,
                                    mounted: function($event) {
                                      _vm.$refs.maxTimePicker.format =
                                        _vm.timeFormat
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "el-picker-panel__content el-date-range-picker__content is-left"
                  },
                  [
                    _c("div", { staticClass: "el-date-range-picker__header" }, [
                      _c("button", {
                        staticClass:
                          "el-picker-panel__icon-btn el-icon-d-arrow-left",
                        attrs: { type: "button" },
                        on: { click: _vm.leftPrevYear }
                      }),
                      _c("button", {
                        staticClass:
                          "el-picker-panel__icon-btn el-icon-arrow-left",
                        attrs: { type: "button" },
                        on: { click: _vm.leftPrevMonth }
                      }),
                      _vm.unlinkPanels
                        ? _c("button", {
                            staticClass:
                              "el-picker-panel__icon-btn el-icon-d-arrow-right",
                            class: { "is-disabled": !_vm.enableYearArrow },
                            attrs: {
                              type: "button",
                              disabled: !_vm.enableYearArrow
                            },
                            on: { click: _vm.leftNextYear }
                          })
                        : _vm._e(),
                      _vm.unlinkPanels
                        ? _c("button", {
                            staticClass:
                              "el-picker-panel__icon-btn el-icon-arrow-right",
                            class: { "is-disabled": !_vm.enableMonthArrow },
                            attrs: {
                              type: "button",
                              disabled: !_vm.enableMonthArrow
                            },
                            on: { click: _vm.leftNextMonth }
                          })
                        : _vm._e(),
                      _c("div", [_vm._v(_vm._s(_vm.leftLabel))])
                    ]),
                    _c("date-table", {
                      attrs: {
                        "selection-mode": "range",
                        date: _vm.leftDate,
                        "default-value": _vm.defaultValue,
                        "min-date": _vm.minDate,
                        "max-date": _vm.maxDate,
                        "range-state": _vm.rangeState,
                        "disabled-date": _vm.disabledDate,
                        "cell-class-name": _vm.cellClassName,
                        "first-day-of-week": _vm.firstDayOfWeek
                      },
                      on: {
                        changerange: _vm.handleChangeRange,
                        pick: _vm.handleRangePick
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "el-picker-panel__content el-date-range-picker__content is-right"
                  },
                  [
                    _c("div", { staticClass: "el-date-range-picker__header" }, [
                      _vm.unlinkPanels
                        ? _c("button", {
                            staticClass:
                              "el-picker-panel__icon-btn el-icon-d-arrow-left",
                            class: { "is-disabled": !_vm.enableYearArrow },
                            attrs: {
                              type: "button",
                              disabled: !_vm.enableYearArrow
                            },
                            on: { click: _vm.rightPrevYear }
                          })
                        : _vm._e(),
                      _vm.unlinkPanels
                        ? _c("button", {
                            staticClass:
                              "el-picker-panel__icon-btn el-icon-arrow-left",
                            class: { "is-disabled": !_vm.enableMonthArrow },
                            attrs: {
                              type: "button",
                              disabled: !_vm.enableMonthArrow
                            },
                            on: { click: _vm.rightPrevMonth }
                          })
                        : _vm._e(),
                      _c("button", {
                        staticClass:
                          "el-picker-panel__icon-btn el-icon-d-arrow-right",
                        attrs: { type: "button" },
                        on: { click: _vm.rightNextYear }
                      }),
                      _c("button", {
                        staticClass:
                          "el-picker-panel__icon-btn el-icon-arrow-right",
                        attrs: { type: "button" },
                        on: { click: _vm.rightNextMonth }
                      }),
                      _c("div", [_vm._v(_vm._s(_vm.rightLabel))])
                    ]),
                    _c("date-table", {
                      attrs: {
                        "selection-mode": "range",
                        date: _vm.rightDate,
                        "default-value": _vm.defaultValue,
                        "min-date": _vm.minDate,
                        "max-date": _vm.maxDate,
                        "range-state": _vm.rangeState,
                        "disabled-date": _vm.disabledDate,
                        "cell-class-name": _vm.cellClassName,
                        "first-day-of-week": _vm.firstDayOfWeek
                      },
                      on: {
                        changerange: _vm.handleChangeRange,
                        pick: _vm.handleRangePick
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            2
          ),
          _vm.showTime
            ? _c(
                "div",
                { staticClass: "el-picker-panel__footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "el-picker-panel__link-btn",
                      attrs: { size: "mini", type: "text" },
                      on: { click: _vm.handleClear }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.t("el.datepicker.clear")) +
                          "\n      "
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "el-picker-panel__link-btn",
                      attrs: {
                        plain: "",
                        size: "mini",
                        disabled: _vm.btnDisabled
                      },
                      on: {
                        click: function($event) {
                          _vm.handleConfirm(false)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.t("el.datepicker.confirm")) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var date_rangevue_type_template_id_2652849a_staticRenderFns = []
date_rangevue_type_template_id_2652849a_render._withStripped = true


// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var date_rangevue_type_script_lang_js_calcDefaultValue = function calcDefaultValue(defaultValue) {
  if (Array.isArray(defaultValue)) {
    return [new Date(defaultValue[0]), new Date(defaultValue[1])];
  } else if (defaultValue) {
    return [new Date(defaultValue), Object(date_util_["nextDate"])(new Date(defaultValue), 1)];
  } else {
    return [new Date(), Object(date_util_["nextDate"])(new Date(), 1)];
  }
};

/* harmony default export */ var date_rangevue_type_script_lang_js_ = ({
  mixins: [locale_default.a],

  directives: { Clickoutside: clickoutside_default.a },

  computed: {
    btnDisabled: function btnDisabled() {
      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]));
    },
    leftLabel: function leftLabel() {
      return this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.leftDate.getMonth() + 1));
    },
    rightLabel: function rightLabel() {
      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.rightDate.getMonth() + 1));
    },
    leftYear: function leftYear() {
      return this.leftDate.getFullYear();
    },
    leftMonth: function leftMonth() {
      return this.leftDate.getMonth();
    },
    leftMonthDate: function leftMonthDate() {
      return this.leftDate.getDate();
    },
    rightYear: function rightYear() {
      return this.rightDate.getFullYear();
    },
    rightMonth: function rightMonth() {
      return this.rightDate.getMonth();
    },
    rightMonthDate: function rightMonthDate() {
      return this.rightDate.getDate();
    },
    minVisibleDate: function minVisibleDate() {
      if (this.dateUserInput.min !== null) return this.dateUserInput.min;
      if (this.minDate) return Object(date_util_["formatDate"])(this.minDate, this.dateFormat);
      return '';
    },
    maxVisibleDate: function maxVisibleDate() {
      if (this.dateUserInput.max !== null) return this.dateUserInput.max;
      if (this.maxDate || this.minDate) return Object(date_util_["formatDate"])(this.maxDate || this.minDate, this.dateFormat);
      return '';
    },
    minVisibleTime: function minVisibleTime() {
      if (this.timeUserInput.min !== null) return this.timeUserInput.min;
      if (this.minDate) return Object(date_util_["formatDate"])(this.minDate, this.timeFormat);
      return '';
    },
    maxVisibleTime: function maxVisibleTime() {
      if (this.timeUserInput.max !== null) return this.timeUserInput.max;
      if (this.maxDate || this.minDate) return Object(date_util_["formatDate"])(this.maxDate || this.minDate, this.timeFormat);
      return '';
    },
    timeFormat: function timeFormat() {
      if (this.format) {
        return Object(date_util_["extractTimeFormat"])(this.format);
      } else {
        return 'HH:mm:ss';
      }
    },
    dateFormat: function dateFormat() {
      if (this.format) {
        return Object(date_util_["extractDateFormat"])(this.format);
      } else {
        return 'yyyy-MM-dd';
      }
    },
    enableMonthArrow: function enableMonthArrow() {
      var nextMonth = (this.leftMonth + 1) % 12;
      var yearOffset = this.leftMonth + 1 >= 12 ? 1 : 0;
      return this.unlinkPanels && new Date(this.leftYear + yearOffset, nextMonth) < new Date(this.rightYear, this.rightMonth);
    },
    enableYearArrow: function enableYearArrow() {
      return this.unlinkPanels && this.rightYear * 12 + this.rightMonth - (this.leftYear * 12 + this.leftMonth + 1) >= 12;
    }
  },

  data: function data() {
    return {
      popperClass: '',
      value: [],
      defaultValue: null,
      defaultTime: null,
      minDate: '',
      maxDate: '',
      leftDate: new Date(),
      rightDate: Object(date_util_["nextMonth"])(new Date()),
      rangeState: {
        endDate: null,
        selecting: false,
        row: null,
        column: null
      },
      showTime: false,
      shortcuts: '',
      visible: '',
      disabledDate: '',
      cellClassName: '',
      firstDayOfWeek: 7,
      minTimePickerVisible: false,
      maxTimePickerVisible: false,
      format: '',
      arrowControl: false,
      unlinkPanels: false,
      dateUserInput: {
        min: null,
        max: null
      },
      timeUserInput: {
        min: null,
        max: null
      }
    };
  },


  watch: {
    minDate: function minDate(val) {
      var _this = this;

      this.dateUserInput.min = null;
      this.timeUserInput.min = null;
      this.$nextTick(function () {
        if (_this.$refs.maxTimePicker && _this.maxDate && _this.maxDate < _this.minDate) {
          var format = 'HH:mm:ss';
          _this.$refs.maxTimePicker.selectableRange = [[Object(date_util_["parseDate"])(Object(date_util_["formatDate"])(_this.minDate, format), format), Object(date_util_["parseDate"])('23:59:59', format)]];
        }
      });
      if (val && this.$refs.minTimePicker) {
        this.$refs.minTimePicker.date = val;
        this.$refs.minTimePicker.value = val;
      }
    },
    maxDate: function maxDate(val) {
      this.dateUserInput.max = null;
      this.timeUserInput.max = null;
      if (val && this.$refs.maxTimePicker) {
        this.$refs.maxTimePicker.date = val;
        this.$refs.maxTimePicker.value = val;
      }
    },
    minTimePickerVisible: function minTimePickerVisible(val) {
      var _this2 = this;

      if (val) {
        this.$nextTick(function () {
          _this2.$refs.minTimePicker.date = _this2.minDate;
          _this2.$refs.minTimePicker.value = _this2.minDate;
          _this2.$refs.minTimePicker.adjustSpinners();
        });
      }
    },
    maxTimePickerVisible: function maxTimePickerVisible(val) {
      var _this3 = this;

      if (val) {
        this.$nextTick(function () {
          _this3.$refs.maxTimePicker.date = _this3.maxDate;
          _this3.$refs.maxTimePicker.value = _this3.maxDate;
          _this3.$refs.maxTimePicker.adjustSpinners();
        });
      }
    },
    value: function value(newVal) {
      if (!newVal) {
        this.minDate = null;
        this.maxDate = null;
      } else if (Array.isArray(newVal)) {
        this.minDate = Object(date_util_["isDate"])(newVal[0]) ? new Date(newVal[0]) : null;
        this.maxDate = Object(date_util_["isDate"])(newVal[1]) ? new Date(newVal[1]) : null;
        if (this.minDate) {
          this.leftDate = this.minDate;
          if (this.unlinkPanels && this.maxDate) {
            var minDateYear = this.minDate.getFullYear();
            var minDateMonth = this.minDate.getMonth();
            var maxDateYear = this.maxDate.getFullYear();
            var maxDateMonth = this.maxDate.getMonth();
            this.rightDate = minDateYear === maxDateYear && minDateMonth === maxDateMonth ? Object(date_util_["nextMonth"])(this.maxDate) : this.maxDate;
          } else {
            this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
          }
        } else {
          this.leftDate = date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
          this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
        }
      }
    },
    defaultValue: function defaultValue(val) {
      if (!Array.isArray(this.value)) {
        var _calcDefaultValue = date_rangevue_type_script_lang_js_calcDefaultValue(val),
            left = _calcDefaultValue[0],
            right = _calcDefaultValue[1];

        this.leftDate = left;
        this.rightDate = val && val[1] && this.unlinkPanels ? right : Object(date_util_["nextMonth"])(this.leftDate);
      }
    }
  },

  methods: {
    handleClear: function handleClear() {
      this.minDate = null;
      this.maxDate = null;
      this.leftDate = date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
      this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
      this.$emit('pick', null);
    },
    handleChangeRange: function handleChangeRange(val) {
      this.minDate = val.minDate;
      this.maxDate = val.maxDate;
      this.rangeState = val.rangeState;
    },
    handleDateInput: function handleDateInput(value, type) {
      this.dateUserInput[type] = value;
      if (value.length !== this.dateFormat.length) return;
      var parsedValue = Object(date_util_["parseDate"])(value, this.dateFormat);

      if (parsedValue) {
        if (typeof this.disabledDate === 'function' && this.disabledDate(new Date(parsedValue))) {
          return;
        }
        if (type === 'min') {
          this.minDate = Object(date_util_["modifyDate"])(this.minDate || new Date(), parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
          this.leftDate = new Date(parsedValue);
          if (!this.unlinkPanels) {
            this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
          }
        } else {
          this.maxDate = Object(date_util_["modifyDate"])(this.maxDate || new Date(), parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
          this.rightDate = new Date(parsedValue);
          if (!this.unlinkPanels) {
            this.leftDate = Object(date_util_["prevMonth"])(parsedValue);
          }
        }
      }
    },
    handleDateChange: function handleDateChange(value, type) {
      var parsedValue = Object(date_util_["parseDate"])(value, this.dateFormat);
      if (parsedValue) {
        if (type === 'min') {
          this.minDate = Object(date_util_["modifyDate"])(this.minDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
          if (this.minDate > this.maxDate) {
            this.maxDate = this.minDate;
          }
        } else {
          this.maxDate = Object(date_util_["modifyDate"])(this.maxDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
          if (this.maxDate < this.minDate) {
            this.minDate = this.maxDate;
          }
        }
      }
    },
    handleTimeInput: function handleTimeInput(value, type) {
      var _this4 = this;

      this.timeUserInput[type] = value;
      if (value.length !== this.timeFormat.length) return;
      var parsedValue = Object(date_util_["parseDate"])(value, this.timeFormat);

      if (parsedValue) {
        if (type === 'min') {
          this.minDate = Object(date_util_["modifyTime"])(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
          this.$nextTick(function (_) {
            return _this4.$refs.minTimePicker.adjustSpinners();
          });
        } else {
          this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
          this.$nextTick(function (_) {
            return _this4.$refs.maxTimePicker.adjustSpinners();
          });
        }
      }
    },
    handleTimeChange: function handleTimeChange(value, type) {
      var parsedValue = Object(date_util_["parseDate"])(value, this.timeFormat);
      if (parsedValue) {
        if (type === 'min') {
          this.minDate = Object(date_util_["modifyTime"])(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
          if (this.minDate > this.maxDate) {
            this.maxDate = this.minDate;
          }
          this.$refs.minTimePicker.value = this.minDate;
          this.minTimePickerVisible = false;
        } else {
          this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
          if (this.maxDate < this.minDate) {
            this.minDate = this.maxDate;
          }
          this.$refs.maxTimePicker.value = this.minDate;
          this.maxTimePickerVisible = false;
        }
      }
    },
    handleRangePick: function handleRangePick(val) {
      var _this5 = this;

      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var defaultTime = this.defaultTime || [];
      var minDate = Object(date_util_["modifyWithTimeString"])(val.minDate, defaultTime[0]);
      var maxDate = Object(date_util_["modifyWithTimeString"])(val.maxDate, defaultTime[1]);

      if (this.maxDate === maxDate && this.minDate === minDate) {
        return;
      }
      this.onPick && this.onPick(val);
      this.maxDate = maxDate;
      this.minDate = minDate;

      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
      setTimeout(function () {
        _this5.maxDate = maxDate;
        _this5.minDate = minDate;
      }, 10);
      if (!close || this.showTime) return;
      this.handleConfirm();
    },
    handleShortcutClick: function handleShortcutClick(shortcut) {
      if (shortcut.onClick) {
        shortcut.onClick(this);
      }
    },
    handleMinTimePick: function handleMinTimePick(value, visible, first) {
      this.minDate = this.minDate || new Date();
      if (value) {
        this.minDate = Object(date_util_["modifyTime"])(this.minDate, value.getHours(), value.getMinutes(), value.getSeconds());
      }

      if (!first) {
        this.minTimePickerVisible = visible;
      }

      if (!this.maxDate || this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
        this.maxDate = new Date(this.minDate);
      }
    },
    handleMinTimeClose: function handleMinTimeClose() {
      this.minTimePickerVisible = false;
    },
    handleMaxTimePick: function handleMaxTimePick(value, visible, first) {
      if (this.maxDate && value) {
        this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, value.getHours(), value.getMinutes(), value.getSeconds());
      }

      if (!first) {
        this.maxTimePickerVisible = visible;
      }

      if (this.maxDate && this.minDate && this.minDate.getTime() > this.maxDate.getTime()) {
        this.minDate = new Date(this.maxDate);
      }
    },
    handleMaxTimeClose: function handleMaxTimeClose() {
      this.maxTimePickerVisible = false;
    },


    // leftPrev*, rightNext* need to take care of `unlinkPanels`
    leftPrevYear: function leftPrevYear() {
      this.leftDate = Object(date_util_["prevYear"])(this.leftDate);
      if (!this.unlinkPanels) {
        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
      }
    },
    leftPrevMonth: function leftPrevMonth() {
      this.leftDate = Object(date_util_["prevMonth"])(this.leftDate);
      if (!this.unlinkPanels) {
        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
      }
    },
    rightNextYear: function rightNextYear() {
      if (!this.unlinkPanels) {
        this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
      } else {
        this.rightDate = Object(date_util_["nextYear"])(this.rightDate);
      }
    },
    rightNextMonth: function rightNextMonth() {
      if (!this.unlinkPanels) {
        this.leftDate = Object(date_util_["nextMonth"])(this.leftDate);
        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
      } else {
        this.rightDate = Object(date_util_["nextMonth"])(this.rightDate);
      }
    },


    // leftNext*, rightPrev* are called when `unlinkPanels` is true
    leftNextYear: function leftNextYear() {
      this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
    },
    leftNextMonth: function leftNextMonth() {
      this.leftDate = Object(date_util_["nextMonth"])(this.leftDate);
    },
    rightPrevYear: function rightPrevYear() {
      this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
    },
    rightPrevMonth: function rightPrevMonth() {
      this.rightDate = Object(date_util_["prevMonth"])(this.rightDate);
    },
    handleConfirm: function handleConfirm() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isValidValue([this.minDate, this.maxDate])) {
        this.$emit('pick', [this.minDate, this.maxDate], visible);
      }
    },
    isValidValue: function isValidValue(value) {
      return Array.isArray(value) && value && value[0] && value[1] && Object(date_util_["isDate"])(value[0]) && Object(date_util_["isDate"])(value[1]) && value[0].getTime() <= value[1].getTime() && (typeof this.disabledDate === 'function' ? !this.disabledDate(value[0]) && !this.disabledDate(value[1]) : true);
    },
    resetView: function resetView() {
      // NOTE: this is a hack to reset {min, max}Date on picker open.
      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
      if (this.minDate && this.maxDate == null) this.rangeState.selecting = false;
      this.minDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[0]) : null;
      this.maxDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[1]) : null;
    }
  },

  components: { TimePicker: panel_time, DateTable: date_table, ElInput: input_default.a, ElButton: button_default.a }
});
// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
 /* harmony default export */ var panel_date_rangevue_type_script_lang_js_ = (date_rangevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue





/* normalize component */

var date_range_component = normalizeComponent(
  panel_date_rangevue_type_script_lang_js_,
  date_rangevue_type_template_id_2652849a_render,
  date_rangevue_type_template_id_2652849a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var date_range_api; }
date_range_component.options.__file = "packages/date-picker/src/panel/date-range.vue"
/* harmony default export */ var date_range = (date_range_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&
var month_rangevue_type_template_id_f2645fb8_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "el-zoom-in-top" },
      on: {
        "after-leave": function($event) {
          _vm.$emit("dodestroy")
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          staticClass: "el-picker-panel el-date-range-picker el-popper",
          class: [
            {
              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts
            },
            _vm.popperClass
          ]
        },
        [
          _c(
            "div",
            { staticClass: "el-picker-panel__body-wrapper" },
            [
              _vm._t("sidebar"),
              _vm.shortcuts
                ? _c(
                    "div",
                    { staticClass: "el-picker-panel__sidebar" },
                    _vm._l(_vm.shortcuts, function(shortcut, key) {
                      return _c(
                        "button",
                        {
                          key: key,
                          staticClass: "el-picker-panel__shortcut",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.handleShortcutClick(shortcut)
                            }
                          }
                        },
                        [_vm._v(_vm._s(shortcut.text))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _c("div", { staticClass: "el-picker-panel__body" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "el-picker-panel__content el-date-range-picker__content is-left"
                  },
                  [
                    _c("div", { staticClass: "el-date-range-picker__header" }, [
                      _c("button", {
                        staticClass:
                          "el-picker-panel__icon-btn el-icon-d-arrow-left",
                        attrs: { type: "button" },
                        on: { click: _vm.leftPrevYear }
                      }),
                      _vm.unlinkPanels
                        ? _c("button", {
                            staticClass:
                              "el-picker-panel__icon-btn el-icon-d-arrow-right",
                            class: { "is-disabled": !_vm.enableYearArrow },
                            attrs: {
                              type: "button",
                              disabled: !_vm.enableYearArrow
                            },
                            on: { click: _vm.leftNextYear }
                          })
                        : _vm._e(),
                      _c("div", [_vm._v(_vm._s(_vm.leftLabel))])
                    ]),
                    _c("month-table", {
                      attrs: {
                        "selection-mode": "range",
                        date: _vm.leftDate,
                        "default-value": _vm.defaultValue,
                        "min-date": _vm.minDate,
                        "max-date": _vm.maxDate,
                        "range-state": _vm.rangeState,
                        "disabled-date": _vm.disabledDate
                      },
                      on: {
                        changerange: _vm.handleChangeRange,
                        pick: _vm.handleRangePick
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "el-picker-panel__content el-date-range-picker__content is-right"
                  },
                  [
                    _c("div", { staticClass: "el-date-range-picker__header" }, [
                      _vm.unlinkPanels
                        ? _c("button", {
                            staticClass:
                              "el-picker-panel__icon-btn el-icon-d-arrow-left",
                            class: { "is-disabled": !_vm.enableYearArrow },
                            attrs: {
                              type: "button",
                              disabled: !_vm.enableYearArrow
                            },
                            on: { click: _vm.rightPrevYear }
                          })
                        : _vm._e(),
                      _c("button", {
                        staticClass:
                          "el-picker-panel__icon-btn el-icon-d-arrow-right",
                        attrs: { type: "button" },
                        on: { click: _vm.rightNextYear }
                      }),
                      _c("div", [_vm._v(_vm._s(_vm.rightLabel))])
                    ]),
                    _c("month-table", {
                      attrs: {
                        "selection-mode": "range",
                        date: _vm.rightDate,
                        "default-value": _vm.defaultValue,
                        "min-date": _vm.minDate,
                        "max-date": _vm.maxDate,
                        "range-state": _vm.rangeState,
                        "disabled-date": _vm.disabledDate
                      },
                      on: {
                        changerange: _vm.handleChangeRange,
                        pick: _vm.handleRangePick
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            2
          )
        ]
      )
    ]
  )
}
var month_rangevue_type_template_id_f2645fb8_staticRenderFns = []
month_rangevue_type_template_id_f2645fb8_render._withStripped = true


// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var month_rangevue_type_script_lang_js_calcDefaultValue = function calcDefaultValue(defaultValue) {
  if (Array.isArray(defaultValue)) {
    return [new Date(defaultValue[0]), new Date(defaultValue[1])];
  } else if (defaultValue) {
    return [new Date(defaultValue), Object(date_util_["nextMonth"])(new Date(defaultValue))];
  } else {
    return [new Date(), Object(date_util_["nextMonth"])(new Date())];
  }
};
/* harmony default export */ var month_rangevue_type_script_lang_js_ = ({
  mixins: [locale_default.a],

  directives: { Clickoutside: clickoutside_default.a },

  computed: {
    btnDisabled: function btnDisabled() {
      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]));
    },
    leftLabel: function leftLabel() {
      return this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year');
    },
    rightLabel: function rightLabel() {
      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year');
    },
    leftYear: function leftYear() {
      return this.leftDate.getFullYear();
    },
    rightYear: function rightYear() {
      return this.rightDate.getFullYear() === this.leftDate.getFullYear() ? this.leftDate.getFullYear() + 1 : this.rightDate.getFullYear();
    },
    enableYearArrow: function enableYearArrow() {
      return this.unlinkPanels && this.rightYear > this.leftYear + 1;
    }
  },

  data: function data() {
    return {
      popperClass: '',
      value: [],
      defaultValue: null,
      defaultTime: null,
      minDate: '',
      maxDate: '',
      leftDate: new Date(),
      rightDate: Object(date_util_["nextYear"])(new Date()),
      rangeState: {
        endDate: null,
        selecting: false,
        row: null,
        column: null
      },
      shortcuts: '',
      visible: '',
      disabledDate: '',
      format: '',
      arrowControl: false,
      unlinkPanels: false
    };
  },


  watch: {
    value: function value(newVal) {
      if (!newVal) {
        this.minDate = null;
        this.maxDate = null;
      } else if (Array.isArray(newVal)) {
        this.minDate = Object(date_util_["isDate"])(newVal[0]) ? new Date(newVal[0]) : null;
        this.maxDate = Object(date_util_["isDate"])(newVal[1]) ? new Date(newVal[1]) : null;
        if (this.minDate) {
          this.leftDate = this.minDate;
          if (this.unlinkPanels && this.maxDate) {
            var minDateYear = this.minDate.getFullYear();
            var maxDateYear = this.maxDate.getFullYear();
            this.rightDate = minDateYear === maxDateYear ? Object(date_util_["nextYear"])(this.maxDate) : this.maxDate;
          } else {
            this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
          }
        } else {
          this.leftDate = month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
          this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
        }
      }
    },
    defaultValue: function defaultValue(val) {
      if (!Array.isArray(this.value)) {
        var _calcDefaultValue = month_rangevue_type_script_lang_js_calcDefaultValue(val),
            left = _calcDefaultValue[0],
            right = _calcDefaultValue[1];

        this.leftDate = left;
        this.rightDate = val && val[1] && left.getFullYear() !== right.getFullYear() && this.unlinkPanels ? right : Object(date_util_["nextYear"])(this.leftDate);
      }
    }
  },

  methods: {
    handleClear: function handleClear() {
      this.minDate = null;
      this.maxDate = null;
      this.leftDate = month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
      this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
      this.$emit('pick', null);
    },
    handleChangeRange: function handleChangeRange(val) {
      this.minDate = val.minDate;
      this.maxDate = val.maxDate;
      this.rangeState = val.rangeState;
    },
    handleRangePick: function handleRangePick(val) {
      var _this = this;

      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var defaultTime = this.defaultTime || [];
      var minDate = Object(date_util_["modifyWithTimeString"])(val.minDate, defaultTime[0]);
      var maxDate = Object(date_util_["modifyWithTimeString"])(val.maxDate, defaultTime[1]);
      if (this.maxDate === maxDate && this.minDate === minDate) {
        return;
      }
      this.onPick && this.onPick(val);
      this.maxDate = maxDate;
      this.minDate = minDate;

      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
      setTimeout(function () {
        _this.maxDate = maxDate;
        _this.minDate = minDate;
      }, 10);
      if (!close) return;
      this.handleConfirm();
    },
    handleShortcutClick: function handleShortcutClick(shortcut) {
      if (shortcut.onClick) {
        shortcut.onClick(this);
      }
    },


    // leftPrev*, rightNext* need to take care of `unlinkPanels`
    leftPrevYear: function leftPrevYear() {
      this.leftDate = Object(date_util_["prevYear"])(this.leftDate);
      if (!this.unlinkPanels) {
        this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
      }
    },
    rightNextYear: function rightNextYear() {
      if (!this.unlinkPanels) {
        this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
      }
      this.rightDate = Object(date_util_["nextYear"])(this.rightDate);
    },


    // leftNext*, rightPrev* are called when `unlinkPanels` is true
    leftNextYear: function leftNextYear() {
      this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
    },
    rightPrevYear: function rightPrevYear() {
      this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
    },
    handleConfirm: function handleConfirm() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isValidValue([this.minDate, this.maxDate])) {
        this.$emit('pick', [this.minDate, this.maxDate], visible);
      }
    },
    isValidValue: function isValidValue(value) {
      return Array.isArray(value) && value && value[0] && value[1] && Object(date_util_["isDate"])(value[0]) && Object(date_util_["isDate"])(value[1]) && value[0].getTime() <= value[1].getTime() && (typeof this.disabledDate === 'function' ? !this.disabledDate(value[0]) && !this.disabledDate(value[1]) : true);
    },
    resetView: function resetView() {
      // NOTE: this is a hack to reset {min, max}Date on picker open.
      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
      this.minDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[0]) : null;
      this.maxDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[1]) : null;
    }
  },

  components: { MonthTable: month_table, ElInput: input_default.a, ElButton: button_default.a }
});
// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
 /* harmony default export */ var panel_month_rangevue_type_script_lang_js_ = (month_rangevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue





/* normalize component */

var month_range_component = normalizeComponent(
  panel_month_rangevue_type_script_lang_js_,
  month_rangevue_type_template_id_f2645fb8_render,
  month_rangevue_type_template_id_f2645fb8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var month_range_api; }
month_range_component.options.__file = "packages/date-picker/src/panel/month-range.vue"
/* harmony default export */ var month_range = (month_range_component.exports);
// CONCATENATED MODULE: ./packages/date-picker/src/picker/date-picker.js





var date_picker_getPanel = function getPanel(type) {
  if (type === 'daterange' || type === 'datetimerange') {
    return date_range;
  } else if (type === 'monthrange') {
    return month_range;
  }
  return panel_date;
};

/* harmony default export */ var date_picker = ({
  mixins: [picker],

  name: 'ElDatePicker',

  props: {
    type: {
      type: String,
      default: 'date'
    },
    timeArrowControl: Boolean
  },

  watch: {
    type: function type(_type) {
      if (this.picker) {
        this.unmountPicker();
        this.panel = date_picker_getPanel(_type);
        this.mountPicker();
      } else {
        this.panel = date_picker_getPanel(_type);
      }
    }
  },

  created: function created() {
    this.panel = date_picker_getPanel(this.type);
  }
});
// CONCATENATED MODULE: ./packages/date-picker/index.js


/* istanbul ignore next */
date_picker.install = function install(Vue) {
  Vue.component(date_picker.name, date_picker);
};

/* harmony default export */ var packages_date_picker = (date_picker);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&
var time_selectvue_type_template_id_51ab9320_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "el-zoom-in-top" },
      on: {
        "before-enter": _vm.handleMenuEnter,
        "after-leave": function($event) {
          _vm.$emit("dodestroy")
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          ref: "popper",
          staticClass: "el-picker-panel time-select el-popper",
          class: _vm.popperClass,
          style: { width: _vm.width + "px" }
        },
        [
          _c(
            "el-scrollbar",
            {
              attrs: { noresize: "", "wrap-class": "el-picker-panel__content" }
            },
            _vm._l(_vm.items, function(item) {
              return _c(
                "div",
                {
                  key: item.value,
                  staticClass: "time-select-item",
                  class: {
                    selected: _vm.value === item.value,
                    disabled: item.disabled,
                    default: item.value === _vm.defaultValue
                  },
                  attrs: { disabled: item.disabled },
                  on: {
                    click: function($event) {
                      _vm.handleClick(item)
                    }
                  }
                },
                [_vm._v(_vm._s(item.value))]
              )
            }),
            0
          )
        ],
        1
      )
    ]
  )
}
var time_selectvue_type_template_id_51ab9320_staticRenderFns = []
time_selectvue_type_template_id_51ab9320_render._withStripped = true


// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var parseTime = function parseTime(time) {
  var values = (time || '').split(':');
  if (values.length >= 2) {
    var hours = parseInt(values[0], 10);
    var minutes = parseInt(values[1], 10);

    return {
      hours: hours,
      minutes: minutes
    };
  }
  /* istanbul ignore next */
  return null;
};

var compareTime = function compareTime(time1, time2) {
  var value1 = parseTime(time1);
  var value2 = parseTime(time2);

  var minutes1 = value1.minutes + value1.hours * 60;
  var minutes2 = value2.minutes + value2.hours * 60;

  if (minutes1 === minutes2) {
    return 0;
  }

  return minutes1 > minutes2 ? 1 : -1;
};

var formatTime = function formatTime(time) {
  return (time.hours < 10 ? '0' + time.hours : time.hours) + ':' + (time.minutes < 10 ? '0' + time.minutes : time.minutes);
};

var nextTime = function nextTime(time, step) {
  var timeValue = parseTime(time);
  var stepValue = parseTime(step);

  var next = {
    hours: timeValue.hours,
    minutes: timeValue.minutes
  };

  next.minutes += stepValue.minutes;
  next.hours += stepValue.hours;

  next.hours += Math.floor(next.minutes / 60);
  next.minutes = next.minutes % 60;

  return formatTime(next);
};

/* harmony default export */ var time_selectvue_type_script_lang_js_ = ({
  components: { ElScrollbar: scrollbar_default.a },

  watch: {
    value: function value(val) {
      var _this = this;

      if (!val) return;
      this.$nextTick(function () {
        return _this.scrollToOption();
      });
    }
  },

  methods: {
    handleClick: function handleClick(item) {
      if (!item.disabled) {
        this.$emit('pick', item.value);
      }
    },
    handleClear: function handleClear() {
      this.$emit('pick', null);
    },
    scrollToOption: function scrollToOption() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.selected';

      var menu = this.$refs.popper.querySelector('.el-picker-panel__content');
      scroll_into_view_default()(menu, menu.querySelector(selector));
    },
    handleMenuEnter: function handleMenuEnter() {
      var _this2 = this;

      var selected = this.items.map(function (item) {
        return item.value;
      }).indexOf(this.value) !== -1;
      var hasDefault = this.items.map(function (item) {
        return item.value;
      }).indexOf(this.defaultValue) !== -1;
      var option = selected && '.selected' || hasDefault && '.default' || '.time-select-item:not(.disabled)';
      this.$nextTick(function () {
        return _this2.scrollToOption(option);
      });
    },
    scrollDown: function scrollDown(step) {
      var items = this.items;
      var length = items.length;
      var total = items.length;
      var index = items.map(function (item) {
        return item.value;
      }).indexOf(this.value);
      while (total--) {
        index = (index + step + length) % length;
        if (!items[index].disabled) {
          this.$emit('pick', items[index].value, true);
          return;
        }
      }
    },
    isValidValue: function isValidValue(date) {
      return this.items.filter(function (item) {
        return !item.disabled;
      }).map(function (item) {
        return item.value;
      }).indexOf(date) !== -1;
    },
    handleKeydown: function handleKeydown(event) {
      var keyCode = event.keyCode;
      if (keyCode === 38 || keyCode === 40) {
        var mapping = { 40: 1, 38: -1 };
        var offset = mapping[keyCode.toString()];
        this.scrollDown(offset);
        event.stopPropagation();
        return;
      }
    }
  },

  data: function data() {
    return {
      popperClass: '',
      start: '09:00',
      end: '18:00',
      step: '00:30',
      value: '',
      defaultValue: '',
      visible: false,
      minTime: '',
      maxTime: '',
      width: 0
    };
  },


  computed: {
    items: function items() {
      var start = this.start;
      var end = this.end;
      var step = this.step;

      var result = [];

      if (start && end && step) {
        var current = start;
        while (compareTime(current, end) <= 0) {
          result.push({
            value: current,
            disabled: compareTime(current, this.minTime || '-1:-1') <= 0 || compareTime(current, this.maxTime || '100:100') >= 0
          });
          current = nextTime(current, step);
        }
      }

      return result;
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
 /* harmony default export */ var panel_time_selectvue_type_script_lang_js_ = (time_selectvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue





/* normalize component */

var time_select_component = normalizeComponent(
  panel_time_selectvue_type_script_lang_js_,
  time_selectvue_type_template_id_51ab9320_render,
  time_selectvue_type_template_id_51ab9320_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var time_select_api; }
time_select_component.options.__file = "packages/date-picker/src/panel/time-select.vue"
/* harmony default export */ var time_select = (time_select_component.exports);
// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-select.js



/* harmony default export */ var picker_time_select = ({
  mixins: [picker],

  name: 'ElTimeSelect',

  componentName: 'ElTimeSelect',

  props: {
    type: {
      type: String,
      default: 'time-select'
    }
  },

  beforeCreate: function beforeCreate() {
    this.panel = time_select;
  }
});
// CONCATENATED MODULE: ./packages/time-select/index.js


/* istanbul ignore next */
picker_time_select.install = function (Vue) {
  Vue.component(picker_time_select.name, picker_time_select);
};

/* harmony default export */ var packages_time_select = (picker_time_select);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&
var time_rangevue_type_template_id_fb28660e_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "el-zoom-in-top" },
      on: {
        "after-leave": function($event) {
          _vm.$emit("dodestroy")
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          staticClass: "el-time-range-picker el-picker-panel el-popper",
          class: _vm.popperClass
        },
        [
          _c("div", { staticClass: "el-time-range-picker__content" }, [
            _c("div", { staticClass: "el-time-range-picker__cell" }, [
              _c("div", { staticClass: "el-time-range-picker__header" }, [
                _vm._v(_vm._s(_vm.t("el.datepicker.startTime")))
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "el-time-range-picker__body el-time-panel__content",
                  class: {
                    "has-seconds": _vm.showSeconds,
                    "is-arrow": _vm.arrowControl
                  }
                },
                [
                  _c("time-spinner", {
                    ref: "minSpinner",
                    attrs: {
                      "show-seconds": _vm.showSeconds,
                      "am-pm-mode": _vm.amPmMode,
                      "arrow-control": _vm.arrowControl,
                      date: _vm.minDate
                    },
                    on: {
                      change: _vm.handleMinChange,
                      "select-range": _vm.setMinSelectionRange
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "el-time-range-picker__cell" }, [
              _c("div", { staticClass: "el-time-range-picker__header" }, [
                _vm._v(_vm._s(_vm.t("el.datepicker.endTime")))
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "el-time-range-picker__body el-time-panel__content",
                  class: {
                    "has-seconds": _vm.showSeconds,
                    "is-arrow": _vm.arrowControl
                  }
                },
                [
                  _c("time-spinner", {
                    ref: "maxSpinner",
                    attrs: {
                      "show-seconds": _vm.showSeconds,
                      "am-pm-mode": _vm.amPmMode,
                      "arrow-control": _vm.arrowControl,
                      date: _vm.maxDate
                    },
                    on: {
                      change: _vm.handleMaxChange,
                      "select-range": _vm.setMaxSelectionRange
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _c("div", { staticClass: "el-time-panel__footer" }, [
            _c(
              "button",
              {
                staticClass: "el-time-panel__btn cancel",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.handleCancel()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]
            ),
            _c(
              "button",
              {
                staticClass: "el-time-panel__btn confirm",
                attrs: { type: "button", disabled: _vm.btnDisabled },
                on: {
                  click: function($event) {
                    _vm.handleConfirm()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))]
            )
          ])
        ]
      )
    ]
  )
}
var time_rangevue_type_template_id_fb28660e_staticRenderFns = []
time_rangevue_type_template_id_fb28660e_render._withStripped = true


// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var MIN_TIME = Object(date_util_["parseDate"])('00:00:00', 'HH:mm:ss');
var MAX_TIME = Object(date_util_["parseDate"])('23:59:59', 'HH:mm:ss');

var time_rangevue_type_script_lang_js_minTimeOfDay = function minTimeOfDay(date) {
  return Object(date_util_["modifyDate"])(MIN_TIME, date.getFullYear(), date.getMonth(), date.getDate());
};

var time_rangevue_type_script_lang_js_maxTimeOfDay = function maxTimeOfDay(date) {
  return Object(date_util_["modifyDate"])(MAX_TIME, date.getFullYear(), date.getMonth(), date.getDate());
};

// increase time by amount of milliseconds, but within the range of day
var advanceTime = function advanceTime(date, amount) {
  return new Date(Math.min(date.getTime() + amount, time_rangevue_type_script_lang_js_maxTimeOfDay(date).getTime()));
};

/* harmony default export */ var time_rangevue_type_script_lang_js_ = ({
  mixins: [locale_default.a],

  components: { TimeSpinner: time_spinner },

  computed: {
    showSeconds: function showSeconds() {
      return (this.format || '').indexOf('ss') !== -1;
    },
    offset: function offset() {
      return this.showSeconds ? 11 : 8;
    },
    spinner: function spinner() {
      return this.selectionRange[0] < this.offset ? this.$refs.minSpinner : this.$refs.maxSpinner;
    },
    btnDisabled: function btnDisabled() {
      return this.minDate.getTime() > this.maxDate.getTime();
    },
    amPmMode: function amPmMode() {
      if ((this.format || '').indexOf('A') !== -1) return 'A';
      if ((this.format || '').indexOf('a') !== -1) return 'a';
      return '';
    }
  },

  data: function data() {
    return {
      popperClass: '',
      minDate: new Date(),
      maxDate: new Date(),
      value: [],
      oldValue: [new Date(), new Date()],
      defaultValue: null,
      format: 'HH:mm:ss',
      visible: false,
      selectionRange: [0, 2],
      arrowControl: false
    };
  },


  watch: {
    value: function value(_value) {
      if (Array.isArray(_value)) {
        this.minDate = new Date(_value[0]);
        this.maxDate = new Date(_value[1]);
      } else {
        if (Array.isArray(this.defaultValue)) {
          this.minDate = new Date(this.defaultValue[0]);
          this.maxDate = new Date(this.defaultValue[1]);
        } else if (this.defaultValue) {
          this.minDate = new Date(this.defaultValue);
          this.maxDate = advanceTime(new Date(this.defaultValue), 60 * 60 * 1000);
        } else {
          this.minDate = new Date();
          this.maxDate = advanceTime(new Date(), 60 * 60 * 1000);
        }
      }
    },
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.oldValue = this.value;
        this.$nextTick(function () {
          return _this.$refs.minSpinner.emitSelectRange('hours');
        });
      }
    }
  },

  methods: {
    handleClear: function handleClear() {
      this.$emit('pick', null);
    },
    handleCancel: function handleCancel() {
      this.$emit('pick', this.oldValue);
    },
    handleMinChange: function handleMinChange(date) {
      this.minDate = Object(date_util_["clearMilliseconds"])(date);
      this.handleChange();
    },
    handleMaxChange: function handleMaxChange(date) {
      this.maxDate = Object(date_util_["clearMilliseconds"])(date);
      this.handleChange();
    },
    handleChange: function handleChange() {
      if (this.isValidValue([this.minDate, this.maxDate])) {
        this.$refs.minSpinner.selectableRange = [[time_rangevue_type_script_lang_js_minTimeOfDay(this.minDate), this.maxDate]];
        this.$refs.maxSpinner.selectableRange = [[this.minDate, time_rangevue_type_script_lang_js_maxTimeOfDay(this.maxDate)]];
        this.$emit('pick', [this.minDate, this.maxDate], true);
      }
    },
    setMinSelectionRange: function setMinSelectionRange(start, end) {
      this.$emit('select-range', start, end, 'min');
      this.selectionRange = [start, end];
    },
    setMaxSelectionRange: function setMaxSelectionRange(start, end) {
      this.$emit('select-range', start, end, 'max');
      this.selectionRange = [start + this.offset, end + this.offset];
    },
    handleConfirm: function handleConfirm() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var minSelectableRange = this.$refs.minSpinner.selectableRange;
      var maxSelectableRange = this.$refs.maxSpinner.selectableRange;

      this.minDate = Object(date_util_["limitTimeRange"])(this.minDate, minSelectableRange, this.format);
      this.maxDate = Object(date_util_["limitTimeRange"])(this.maxDate, maxSelectableRange, this.format);

      this.$emit('pick', [this.minDate, this.maxDate], visible);
    },
    adjustSpinners: function adjustSpinners() {
      this.$refs.minSpinner.adjustSpinners();
      this.$refs.maxSpinner.adjustSpinners();
    },
    changeSelectionRange: function changeSelectionRange(step) {
      var list = this.showSeconds ? [0, 3, 6, 11, 14, 17] : [0, 3, 8, 11];
      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
      var index = list.indexOf(this.selectionRange[0]);
      var next = (index + step + list.length) % list.length;
      var half = list.length / 2;
      if (next < half) {
        this.$refs.minSpinner.emitSelectRange(mapping[next]);
      } else {
        this.$refs.maxSpinner.emitSelectRange(mapping[next - half]);
      }
    },
    isValidValue: function isValidValue(date) {
      return Array.isArray(date) && Object(date_util_["timeWithinRange"])(this.minDate, this.$refs.minSpinner.selectableRange) && Object(date_util_["timeWithinRange"])(this.maxDate, this.$refs.maxSpinner.selectableRange);
    },
    handleKeydown: function handleKeydown(event) {
      var keyCode = event.keyCode;
      var mapping = { 38: -1, 40: 1, 37: -1, 39: 1 };

      // Left or Right
      if (keyCode === 37 || keyCode === 39) {
        var step = mapping[keyCode];
        this.changeSelectionRange(step);
        event.preventDefault();
        return;
      }

      // Up or Down
      if (keyCode === 38 || keyCode === 40) {
        var _step = mapping[keyCode];
        this.spinner.scrollDown(_step);
        event.preventDefault();
        return;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
 /* harmony default export */ var panel_time_rangevue_type_script_lang_js_ = (time_rangevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue





/* normalize component */

var time_range_component = normalizeComponent(
  panel_time_rangevue_type_script_lang_js_,
  time_rangevue_type_template_id_fb28660e_render,
  time_rangevue_type_template_id_fb28660e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var time_range_api; }
time_range_component.options.__file = "packages/date-picker/src/panel/time-range.vue"
/* harmony default export */ var time_range = (time_range_component.exports);
// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-picker.js




/* harmony default export */ var time_picker = ({
  mixins: [picker],

  name: 'ElTimePicker',

  props: {
    isRange: Boolean,
    arrowControl: Boolean
  },

  data: function data() {
    return {
      type: ''
    };
  },


  watch: {
    isRange: function isRange(_isRange) {
      if (this.picker) {
        this.unmountPicker();
        this.type = _isRange ? 'timerange' : 'time';
        this.panel = _isRange ? time_range : panel_time;
        this.mountPicker();
      } else {
        this.type = _isRange ? 'timerange' : 'time';
        this.panel = _isRange ? time_range : panel_time;
      }
    }
  },

  created: function created() {
    this.type = this.isRange ? 'timerange' : 'time';
    this.panel = this.isRange ? time_range : panel_time;
  }
});
// CONCATENATED MODULE: ./packages/time-picker/index.js


/* istanbul ignore next */
time_picker.install = function (Vue) {
  Vue.component(time_picker.name, time_picker);
};

/* harmony default export */ var packages_time_picker = (time_picker);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
var mainvue_type_template_id_52060272_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "transition",
        {
          attrs: { name: _vm.transition },
          on: {
            "after-enter": _vm.handleAfterEnter,
            "after-leave": _vm.handleAfterLeave
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.disabled && _vm.showPopper,
                  expression: "!disabled && showPopper"
                }
              ],
              ref: "popper",
              staticClass: "el-popover el-popper",
              class: [_vm.popperClass, _vm.content && "el-popover--plain"],
              style: { width: _vm.width + "px" },
              attrs: {
                role: "tooltip",
                id: _vm.tooltipId,
                "aria-hidden":
                  _vm.disabled || !_vm.showPopper ? "true" : "false"
              }
            },
            [
              _vm.title
                ? _c("div", {
                    staticClass: "el-popover__title",
                    domProps: { textContent: _vm._s(_vm.title) }
                  })
                : _vm._e(),
              _vm._t("default", [_vm._v(_vm._s(_vm.content))])
            ],
            2
          )
        ]
      ),
      _vm._t("reference")
    ],
    2
  )
}
var mainvue_type_template_id_52060272_staticRenderFns = []
mainvue_type_template_id_52060272_render._withStripped = true


// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: 'ElPopover',

  mixins: [vue_popper_default.a],

  props: {
    trigger: {
      type: String,
      default: 'click',
      validator: function validator(value) {
        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
      }
    },
    openDelay: {
      type: Number,
      default: 0
    },
    closeDelay: {
      type: Number,
      default: 200
    },
    title: String,
    disabled: Boolean,
    content: String,
    reference: {},
    popperClass: String,
    width: {},
    visibleArrow: {
      default: true
    },
    arrowOffset: {
      type: Number,
      default: 0
    },
    transition: {
      type: String,
      default: 'fade-in-linear'
    },
    tabindex: {
      type: Number,
      default: 0
    }
  },

  computed: {
    tooltipId: function tooltipId() {
      return 'el-popover-' + Object(util_["generateId"])();
    }
  },
  watch: {
    showPopper: function showPopper(val) {
      if (this.disabled) {
        return;
      }
      val ? this.$emit('show') : this.$emit('hide');
    }
  },

  mounted: function mounted() {
    var _this = this;

    var reference = this.referenceElm = this.reference || this.$refs.reference;
    var popper = this.popper || this.$refs.popper;

    if (!reference && this.$slots.reference && this.$slots.reference[0]) {
      reference = this.referenceElm = this.$slots.reference[0].elm;
    }
    // 可访问性
    if (reference) {
      Object(dom_["addClass"])(reference, 'el-popover__reference');
      reference.setAttribute('aria-describedby', this.tooltipId);
      reference.setAttribute('tabindex', this.tabindex); // tab序列
      popper.setAttribute('tabindex', 0);

      if (this.trigger !== 'click') {
        Object(dom_["on"])(reference, 'focusin', function () {
          _this.handleFocus();
          var instance = reference.__vue__;
          if (instance && typeof instance.focus === 'function') {
            instance.focus();
          }
        });
        Object(dom_["on"])(popper, 'focusin', this.handleFocus);
        Object(dom_["on"])(reference, 'focusout', this.handleBlur);
        Object(dom_["on"])(popper, 'focusout', this.handleBlur);
      }
      Object(dom_["on"])(reference, 'keydown', this.handleKeydown);
      Object(dom_["on"])(reference, 'click', this.handleClick);
    }
    if (this.trigger === 'click') {
      Object(dom_["on"])(reference, 'click', this.doToggle);
      Object(dom_["on"])(document, 'click', this.handleDocumentClick);
    } else if (this.trigger === 'hover') {
      Object(dom_["on"])(reference, 'mouseenter', this.handleMouseEnter);
      Object(dom_["on"])(popper, 'mouseenter', this.handleMouseEnter);
      Object(dom_["on"])(reference, 'mouseleave', this.handleMouseLeave);
      Object(dom_["on"])(popper, 'mouseleave', this.handleMouseLeave);
    } else if (this.trigger === 'focus') {
      if (this.tabindex < 0) {
        console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');
      }
      if (reference.querySelector('input, textarea')) {
        Object(dom_["on"])(reference, 'focusin', this.doShow);
        Object(dom_["on"])(reference, 'focusout', this.doClose);
      } else {
        Object(dom_["on"])(reference, 'mousedown', this.doShow);
        Object(dom_["on"])(reference, 'mouseup', this.doClose);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cleanup();
  },
  deactivated: function deactivated() {
    this.cleanup();
  },


  methods: {
    doToggle: function doToggle() {
      this.showPopper = !this.showPopper;
    },
    doShow: function doShow() {
      this.showPopper = true;
    },
    doClose: function doClose() {
      this.showPopper = false;
    },
    handleFocus: function handleFocus() {
      Object(dom_["addClass"])(this.referenceElm, 'focusing');
      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = true;
    },
    handleClick: function handleClick() {
      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
    },
    handleBlur: function handleBlur() {
      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = false;
    },
    handleMouseEnter: function handleMouseEnter() {
      var _this2 = this;

      clearTimeout(this._timer);
      if (this.openDelay) {
        this._timer = setTimeout(function () {
          _this2.showPopper = true;
        }, this.openDelay);
      } else {
        this.showPopper = true;
      }
    },
    handleKeydown: function handleKeydown(ev) {
      if (ev.keyCode === 27 && this.trigger !== 'manual') {
        // esc
        this.doClose();
      }
    },
    handleMouseLeave: function handleMouseLeave() {
      var _this3 = this;

      clearTimeout(this._timer);
      if (this.closeDelay) {
        this._timer = setTimeout(function () {
          _this3.showPopper = false;
        }, this.closeDelay);
      } else {
        this.showPopper = false;
      }
    },
    handleDocumentClick: function handleDocumentClick(e) {
      var reference = this.reference || this.$refs.reference;
      var popper = this.popper || this.$refs.popper;

      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
        reference = this.referenceElm = this.$slots.reference[0].elm;
      }
      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
      this.showPopper = false;
    },
    handleAfterEnter: function handleAfterEnter() {
      this.$emit('after-enter');
    },
    handleAfterLeave: function handleAfterLeave() {
      this.$emit('after-leave');
      this.doDestroy();
    },
    cleanup: function cleanup() {
      if (this.openDelay || this.closeDelay) {
        clearTimeout(this._timer);
      }
    }
  },

  destroyed: function destroyed() {
    var reference = this.reference;

    Object(dom_["off"])(reference, 'click', this.doToggle);
    Object(dom_["off"])(reference, 'mouseup', this.doClose);
    Object(dom_["off"])(reference, 'mousedown', this.doShow);
    Object(dom_["off"])(reference, 'focusin', this.doShow);
    Object(dom_["off"])(reference, 'focusout', this.doClose);
    Object(dom_["off"])(reference, 'mousedown', this.doShow);
    Object(dom_["off"])(reference, 'mouseup', this.doClose);
    Object(dom_["off"])(reference, 'mouseleave', this.handleMouseLeave);
    Object(dom_["off"])(reference, 'mouseenter', this.handleMouseEnter);
    Object(dom_["off"])(document, 'click', this.handleDocumentClick);
  }
});
// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/popover/src/main.vue





/* normalize component */

var main_component = normalizeComponent(
  src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_52060272_render,
  mainvue_type_template_id_52060272_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var main_api; }
main_component.options.__file = "packages/popover/src/main.vue"
/* harmony default export */ var main = (main_component.exports);
// CONCATENATED MODULE: ./packages/popover/src/directive.js
var getReference = function getReference(el, binding, vnode) {
  var _ref = binding.expression ? binding.value : binding.arg;
  var popper = vnode.context.$refs[_ref];
  if (popper) {
    if (Array.isArray(popper)) {
      popper[0].$refs.reference = el;
    } else {
      popper.$refs.reference = el;
    }
  }
};

/* harmony default export */ var directive = ({
  bind: function bind(el, binding, vnode) {
    getReference(el, binding, vnode);
  },
  inserted: function inserted(el, binding, vnode) {
    getReference(el, binding, vnode);
  }
});
// CONCATENATED MODULE: ./packages/popover/index.js




external_vue_default.a.directive('popover', directive);

/* istanbul ignore next */
main.install = function (Vue) {
  Vue.directive('popover', directive);
  Vue.component(main.name, main);
};
main.directive = directive;

/* harmony default export */ var popover = (main);
// CONCATENATED MODULE: ./packages/tooltip/src/main.js






/* harmony default export */ var src_main = ({
  name: 'ElTooltip',

  mixins: [vue_popper_default.a],

  props: {
    openDelay: {
      type: Number,
      default: 0
    },
    disabled: Boolean,
    manual: Boolean,
    effect: {
      type: String,
      default: 'dark'
    },
    arrowOffset: {
      type: Number,
      default: 0
    },
    popperClass: String,
    content: String,
    visibleArrow: {
      default: true
    },
    transition: {
      type: String,
      default: 'el-fade-in-linear'
    },
    popperOptions: {
      default: function _default() {
        return {
          boundariesPadding: 10,
          gpuAcceleration: false
        };
      }
    },
    enterable: {
      type: Boolean,
      default: true
    },
    hideAfter: {
      type: Number,
      default: 0
    },
    tabindex: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      tooltipId: 'el-tooltip-' + Object(util_["generateId"])(),
      timeoutPending: null,
      focusing: false
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    if (this.$isServer) return;

    this.popperVM = new external_vue_default.a({
      data: { node: '' },
      render: function render(h) {
        return this.node;
      }
    }).$mount();

    this.debounceClose = debounce_default()(200, function () {
      return _this.handleClosePopper();
    });
  },
  render: function render(h) {
    var _this2 = this;

    if (this.popperVM) {
      this.popperVM.node = h(
        'transition',
        {
          attrs: {
            name: this.transition
          },
          on: {
            'afterLeave': this.doDestroy
          }
        },
        [h(
          'div',
          {
            on: {
              'mouseleave': function mouseleave() {
                _this2.setExpectedState(false);_this2.debounceClose();
              },
              'mouseenter': function mouseenter() {
                _this2.setExpectedState(true);
              }
            },

            ref: 'popper',
            attrs: { role: 'tooltip',
              id: this.tooltipId,
              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
            },
            directives: [{
              name: 'show',
              value: !this.disabled && this.showPopper
            }],

            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] },
          [this.$slots.content || this.content]
        )]
      );
    }

    var firstElement = this.getFirstElement();
    if (!firstElement) return null;

    var data = firstElement.data = firstElement.data || {};
    data.staticClass = this.addTooltipClass(data.staticClass);

    return firstElement;
  },
  mounted: function mounted() {
    var _this3 = this;

    this.referenceElm = this.$el;
    if (this.$el.nodeType === 1) {
      this.$el.setAttribute('aria-describedby', this.tooltipId);
      this.$el.setAttribute('tabindex', this.tabindex);
      Object(dom_["on"])(this.referenceElm, 'mouseenter', this.show);
      Object(dom_["on"])(this.referenceElm, 'mouseleave', this.hide);
      Object(dom_["on"])(this.referenceElm, 'focus', function () {
        if (!_this3.$slots.default || !_this3.$slots.default.length) {
          _this3.handleFocus();
          return;
        }
        var instance = _this3.$slots.default[0].componentInstance;
        if (instance && instance.focus) {
          instance.focus();
        } else {
          _this3.handleFocus();
        }
      });
      Object(dom_["on"])(this.referenceElm, 'blur', this.handleBlur);
      Object(dom_["on"])(this.referenceElm, 'click', this.removeFocusing);
    }
    // fix issue https://github.com/ElemeFE/element/issues/14424
    if (this.value && this.popperVM) {
      this.popperVM.$nextTick(function () {
        if (_this3.value) {
          _this3.updatePopper();
        }
      });
    }
  },

  watch: {
    focusing: function focusing(val) {
      if (val) {
        Object(dom_["addClass"])(this.referenceElm, 'focusing');
      } else {
        Object(dom_["removeClass"])(this.referenceElm, 'focusing');
      }
    }
  },
  methods: {
    show: function show() {
      this.setExpectedState(true);
      this.handleShowPopper();
    },
    hide: function hide() {
      this.setExpectedState(false);
      this.debounceClose();
    },
    handleFocus: function handleFocus() {
      this.focusing = true;
      this.show();
    },
    handleBlur: function handleBlur() {
      this.focusing = false;
      this.hide();
    },
    removeFocusing: function removeFocusing() {
      this.focusing = false;
    },
    addTooltipClass: function addTooltipClass(prev) {
      if (!prev) {
        return 'el-tooltip';
      } else {
        return 'el-tooltip ' + prev.replace('el-tooltip', '');
      }
    },
    handleShowPopper: function handleShowPopper() {
      var _this4 = this;

      if (!this.expectedState || this.manual) return;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this4.showPopper = true;
      }, this.openDelay);

      if (this.hideAfter > 0) {
        this.timeoutPending = setTimeout(function () {
          _this4.showPopper = false;
        }, this.hideAfter);
      }
    },
    handleClosePopper: function handleClosePopper() {
      if (this.enterable && this.expectedState || this.manual) return;
      clearTimeout(this.timeout);

      if (this.timeoutPending) {
        clearTimeout(this.timeoutPending);
      }
      this.showPopper = false;

      if (this.disabled) {
        this.doDestroy();
      }
    },
    setExpectedState: function setExpectedState(expectedState) {
      if (expectedState === false) {
        clearTimeout(this.timeoutPending);
      }
      this.expectedState = expectedState;
    },
    getFirstElement: function getFirstElement() {
      var slots = this.$slots.default;
      if (!Array.isArray(slots)) return null;
      var element = null;
      for (var index = 0; index < slots.length; index++) {
        if (slots[index] && slots[index].tag) {
          element = slots[index];
        };
      }
      return element;
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.popperVM && this.popperVM.$destroy();
  },
  destroyed: function destroyed() {
    var reference = this.referenceElm;
    if (reference.nodeType === 1) {
      Object(dom_["off"])(reference, 'mouseenter', this.show);
      Object(dom_["off"])(reference, 'mouseleave', this.hide);
      Object(dom_["off"])(reference, 'focus', this.handleFocus);
      Object(dom_["off"])(reference, 'blur', this.handleBlur);
      Object(dom_["off"])(reference, 'click', this.removeFocusing);
    }
  }
});
// CONCATENATED MODULE: ./packages/tooltip/index.js


/* istanbul ignore next */
src_main.install = function (Vue) {
  Vue.component(src_main.name, src_main);
};

/* harmony default export */ var packages_tooltip = (src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
var mainvue_type_template_id_6b29b012_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "msgbox-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }
        ],
        staticClass: "el-message-box__wrapper",
        attrs: {
          tabindex: "-1",
          role: "dialog",
          "aria-modal": "true",
          "aria-label": _vm.title || "dialog"
        },
        on: {
          click: function($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.handleWrapperClick($event)
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "el-message-box",
            class: [_vm.customClass, _vm.center && "el-message-box--center"]
          },
          [
            _vm.title !== null
              ? _c("div", { staticClass: "el-message-box__header" }, [
                  _c("div", { staticClass: "el-message-box__title" }, [
                    _vm.icon && _vm.center
                      ? _c("div", {
                          class: ["el-message-box__status", _vm.icon]
                        })
                      : _vm._e(),
                    _c("span", [_vm._v(_vm._s(_vm.title))])
                  ]),
                  _vm.showClose
                    ? _c(
                        "button",
                        {
                          staticClass: "el-message-box__headerbtn",
                          attrs: { type: "button", "aria-label": "Close" },
                          on: {
                            click: function($event) {
                              _vm.handleAction(
                                _vm.distinguishCancelAndClose
                                  ? "close"
                                  : "cancel"
                              )
                            },
                            keydown: function($event) {
                              if (
                                !("button" in $event) &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              _vm.handleAction(
                                _vm.distinguishCancelAndClose
                                  ? "close"
                                  : "cancel"
                              )
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-message-box__close el-icon-close"
                          })
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _c("div", { staticClass: "el-message-box__content" }, [
              _c("div", { staticClass: "el-message-box__container" }, [
                _vm.icon && !_vm.center && _vm.message !== ""
                  ? _c("div", { class: ["el-message-box__status", _vm.icon] })
                  : _vm._e(),
                _vm.message !== ""
                  ? _c(
                      "div",
                      { staticClass: "el-message-box__message" },
                      [
                        _vm._t("default", [
                          !_vm.dangerouslyUseHTMLString
                            ? _c("p", [_vm._v(_vm._s(_vm.message))])
                            : _c("p", {
                                domProps: { innerHTML: _vm._s(_vm.message) }
                              })
                        ])
                      ],
                      2
                    )
                  : _vm._e()
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showInput,
                      expression: "showInput"
                    }
                  ],
                  staticClass: "el-message-box__input"
                },
                [
                  _c("el-input", {
                    ref: "input",
                    attrs: {
                      type: _vm.inputType,
                      placeholder: _vm.inputPlaceholder
                    },
                    nativeOn: {
                      keydown: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleInputEnter($event)
                      }
                    },
                    model: {
                      value: _vm.inputValue,
                      callback: function($$v) {
                        _vm.inputValue = $$v
                      },
                      expression: "inputValue"
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "el-message-box__errormsg",
                      style: {
                        visibility: !!_vm.editorErrorMessage
                          ? "visible"
                          : "hidden"
                      }
                    },
                    [_vm._v(_vm._s(_vm.editorErrorMessage))]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "el-message-box__btns" },
              [
                _vm.showCancelButton
                  ? _c(
                      "el-button",
                      {
                        class: [_vm.cancelButtonClasses],
                        attrs: {
                          loading: _vm.cancelButtonLoading,
                          round: _vm.roundButton,
                          size: "small"
                        },
                        on: {
                          keydown: function($event) {
                            if (
                              !("button" in $event) &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            _vm.handleAction("cancel")
                          }
                        },
                        nativeOn: {
                          click: function($event) {
                            _vm.handleAction("cancel")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.cancelButtonText ||
                                _vm.t("el.messagebox.cancel")
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showConfirmButton,
                        expression: "showConfirmButton"
                      }
                    ],
                    ref: "confirm",
                    class: [_vm.confirmButtonClasses],
                    attrs: {
                      loading: _vm.confirmButtonLoading,
                      round: _vm.roundButton,
                      size: "small"
                    },
                    on: {
                      keydown: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.handleAction("confirm")
                      }
                    },
                    nativeOn: {
                      click: function($event) {
                        _vm.handleAction("confirm")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.confirmButtonText ||
                            _vm.t("el.messagebox.confirm")
                        ) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            )
          ]
        )
      ]
    )
  ])
}
var mainvue_type_template_id_6b29b012_staticRenderFns = []
mainvue_type_template_id_6b29b012_render._withStripped = true


// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&

// EXTERNAL MODULE: external "element-ui/lib/utils/aria-dialog"
var aria_dialog_ = __webpack_require__(39);
var aria_dialog_default = /*#__PURE__*/__webpack_require__.n(aria_dialog_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var messageBox = void 0;
var typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

/* harmony default export */ var message_box_src_mainvue_type_script_lang_js_ = ({
  mixins: [popup_default.a, locale_default.a],

  props: {
    modal: {
      default: true
    },
    lockScroll: {
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      default: true
    },
    closeOnPressEscape: {
      default: true
    },
    closeOnHashChange: {
      default: true
    },
    center: {
      default: false,
      type: Boolean
    },
    roundButton: {
      default: false,
      type: Boolean
    }
  },

  components: {
    ElInput: input_default.a,
    ElButton: button_default.a
  },

  computed: {
    icon: function icon() {
      var type = this.type,
          iconClass = this.iconClass;

      return iconClass || (type && typeMap[type] ? 'el-icon-' + typeMap[type] : '');
    },
    confirmButtonClasses: function confirmButtonClasses() {
      return 'el-button--primary ' + this.confirmButtonClass;
    },
    cancelButtonClasses: function cancelButtonClasses() {
      return '' + this.cancelButtonClass;
    }
  },

  methods: {
    getSafeClose: function getSafeClose() {
      var _this = this;

      var currentId = this.uid;
      return function () {
        _this.$nextTick(function () {
          if (currentId === _this.uid) _this.doClose();
        });
      };
    },
    doClose: function doClose() {
      var _this2 = this;

      if (!this.visible) return;
      this.visible = false;
      this._closing = true;

      this.onClose && this.onClose();
      messageBox.closeDialog(); // 解绑
      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200);
      }
      this.opened = false;
      this.doAfterClose();
      setTimeout(function () {
        if (_this2.action) _this2.callback(_this2.action, _this2);
      });
    },
    handleWrapperClick: function handleWrapperClick() {
      if (this.closeOnClickModal) {
        this.handleAction(this.distinguishCancelAndClose ? 'close' : 'cancel');
      }
    },
    handleInputEnter: function handleInputEnter() {
      if (this.inputType !== 'textarea') {
        return this.handleAction('confirm');
      }
    },
    handleAction: function handleAction(action) {
      if (this.$type === 'prompt' && action === 'confirm' && !this.validate()) {
        return;
      }
      this.action = action;
      if (typeof this.beforeClose === 'function') {
        this.close = this.getSafeClose();
        this.beforeClose(action, this, this.close);
      } else {
        this.doClose();
      }
    },
    validate: function validate() {
      if (this.$type === 'prompt') {
        var inputPattern = this.inputPattern;
        if (inputPattern && !inputPattern.test(this.inputValue || '')) {
          this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])('el.messagebox.error');
          Object(dom_["addClass"])(this.getInputElement(), 'invalid');
          return false;
        }
        var inputValidator = this.inputValidator;
        if (typeof inputValidator === 'function') {
          var validateResult = inputValidator(this.inputValue);
          if (validateResult === false) {
            this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])('el.messagebox.error');
            Object(dom_["addClass"])(this.getInputElement(), 'invalid');
            return false;
          }
          if (typeof validateResult === 'string') {
            this.editorErrorMessage = validateResult;
            Object(dom_["addClass"])(this.getInputElement(), 'invalid');
            return false;
          }
        }
      }
      this.editorErrorMessage = '';
      Object(dom_["removeClass"])(this.getInputElement(), 'invalid');
      return true;
    },
    getFirstFocus: function getFirstFocus() {
      var btn = this.$el.querySelector('.el-message-box__btns .el-button');
      var title = this.$el.querySelector('.el-message-box__btns .el-message-box__title');
      return btn || title;
    },
    getInputElement: function getInputElement() {
      var inputRefs = this.$refs.input.$refs;
      return inputRefs.input || inputRefs.textarea;
    },
    handleClose: function handleClose() {
      this.handleAction('close');
    }
  },

  watch: {
    inputValue: {
      immediate: true,
      handler: function handler(val) {
        var _this3 = this;

        this.$nextTick(function (_) {
          if (_this3.$type === 'prompt' && val !== null) {
            _this3.validate();
          }
        });
      }
    },

    visible: function visible(val) {
      var _this4 = this;

      if (val) {
        this.uid++;
        if (this.$type === 'alert' || this.$type === 'confirm') {
          this.$nextTick(function () {
            _this4.$refs.confirm.$el.focus();
          });
        }
        this.focusAfterClosed = document.activeElement;
        messageBox = new aria_dialog_default.a(this.$el, this.focusAfterClosed, this.getFirstFocus());
      }

      // prompt
      if (this.$type !== 'prompt') return;
      if (val) {
        setTimeout(function () {
          if (_this4.$refs.input && _this4.$refs.input.$el) {
            _this4.getInputElement().focus();
          }
        }, 500);
      } else {
        this.editorErrorMessage = '';
        Object(dom_["removeClass"])(this.getInputElement(), 'invalid');
      }
    }
  },

  mounted: function mounted() {
    var _this5 = this;

    this.$nextTick(function () {
      if (_this5.closeOnHashChange) {
        window.addEventListener('hashchange', _this5.close);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.closeOnHashChange) {
      window.removeEventListener('hashchange', this.close);
    }
    setTimeout(function () {
      messageBox.closeDialog();
    });
  },
  data: function data() {
    return {
      uid: 1,
      title: undefined,
      message: '',
      type: '',
      iconClass: '',
      customClass: '',
      showInput: false,
      inputValue: null,
      inputPlaceholder: '',
      inputType: 'text',
      inputPattern: null,
      inputValidator: null,
      inputErrorMessage: '',
      showConfirmButton: true,
      showCancelButton: false,
      action: '',
      confirmButtonText: '',
      cancelButtonText: '',
      confirmButtonLoading: false,
      cancelButtonLoading: false,
      confirmButtonClass: '',
      confirmButtonDisabled: false,
      cancelButtonClass: '',
      editorErrorMessage: null,
      callback: null,
      dangerouslyUseHTMLString: false,
      focusAfterClosed: null,
      isOnComposition: false,
      distinguishCancelAndClose: false
    };
  }
});
// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_message_box_src_mainvue_type_script_lang_js_ = (message_box_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/message-box/src/main.vue





/* normalize component */

var src_main_component = normalizeComponent(
  packages_message_box_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_6b29b012_render,
  mainvue_type_template_id_6b29b012_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var src_main_api; }
src_main_component.options.__file = "packages/message-box/src/main.vue"
/* harmony default export */ var message_box_src_main = (src_main_component.exports);
// EXTERNAL MODULE: external "element-ui/lib/utils/vdom"
var vdom_ = __webpack_require__(23);

// CONCATENATED MODULE: ./packages/message-box/src/main.js
var main_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var main_defaults = {
  title: null,
  message: '',
  type: '',
  iconClass: '',
  showInput: false,
  showClose: true,
  modalFade: true,
  lockScroll: true,
  closeOnClickModal: true,
  closeOnPressEscape: true,
  closeOnHashChange: true,
  inputValue: null,
  inputPlaceholder: '',
  inputType: 'text',
  inputPattern: null,
  inputValidator: null,
  inputErrorMessage: '',
  showConfirmButton: true,
  showCancelButton: false,
  confirmButtonPosition: 'right',
  confirmButtonHighlight: false,
  cancelButtonHighlight: false,
  confirmButtonText: '',
  cancelButtonText: '',
  confirmButtonClass: '',
  cancelButtonClass: '',
  customClass: '',
  beforeClose: null,
  dangerouslyUseHTMLString: false,
  center: false,
  roundButton: false,
  distinguishCancelAndClose: false
};






var MessageBoxConstructor = external_vue_default.a.extend(message_box_src_main);

var currentMsg = void 0,
    main_instance = void 0;
var msgQueue = [];

var defaultCallback = function defaultCallback(action) {
  if (currentMsg) {
    var callback = currentMsg.callback;
    if (typeof callback === 'function') {
      if (main_instance.showInput) {
        callback(main_instance.inputValue, action);
      } else {
        callback(action);
      }
    }
    if (currentMsg.resolve) {
      if (action === 'confirm') {
        if (main_instance.showInput) {
          currentMsg.resolve({ value: main_instance.inputValue, action: action });
        } else {
          currentMsg.resolve(action);
        }
      } else if (currentMsg.reject && (action === 'cancel' || action === 'close')) {
        currentMsg.reject(action);
      }
    }
  }
};

var initInstance = function initInstance() {
  main_instance = new MessageBoxConstructor({
    el: document.createElement('div')
  });

  main_instance.callback = defaultCallback;
};

var main_showNextMsg = function showNextMsg() {
  if (!main_instance) {
    initInstance();
  }
  main_instance.action = '';

  if (!main_instance.visible || main_instance.closeTimer) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift();

      var options = currentMsg.options;
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          main_instance[prop] = options[prop];
        }
      }
      if (options.callback === undefined) {
        main_instance.callback = defaultCallback;
      }

      var oldCb = main_instance.callback;
      main_instance.callback = function (action, instance) {
        oldCb(action, instance);
        showNextMsg();
      };
      if (Object(vdom_["isVNode"])(main_instance.message)) {
        main_instance.$slots.default = [main_instance.message];
        main_instance.message = null;
      } else {
        delete main_instance.$slots.default;
      }
      ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape', 'closeOnHashChange'].forEach(function (prop) {
        if (main_instance[prop] === undefined) {
          main_instance[prop] = true;
        }
      });
      document.body.appendChild(main_instance.$el);

      external_vue_default.a.nextTick(function () {
        main_instance.visible = true;
      });
    }
  }
};

var main_MessageBox = function MessageBox(options, callback) {
  if (external_vue_default.a.prototype.$isServer) return;
  if (typeof options === 'string' || Object(vdom_["isVNode"])(options)) {
    options = {
      message: options
    };
    if (typeof arguments[1] === 'string') {
      options.title = arguments[1];
    }
  } else if (options.callback && !callback) {
    callback = options.callback;
  }

  if (typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      // eslint-disable-line
      msgQueue.push({
        options: merge_default()({}, main_defaults, MessageBox.defaults, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      });

      main_showNextMsg();
    });
  } else {
    msgQueue.push({
      options: merge_default()({}, main_defaults, MessageBox.defaults, options),
      callback: callback
    });

    main_showNextMsg();
  }
};

main_MessageBox.setDefaults = function (defaults) {
  main_MessageBox.defaults = defaults;
};

main_MessageBox.alert = function (message, title, options) {
  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return main_MessageBox(merge_default()({
    title: title,
    message: message,
    $type: 'alert',
    closeOnPressEscape: false,
    closeOnClickModal: false
  }, options));
};

main_MessageBox.confirm = function (message, title, options) {
  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return main_MessageBox(merge_default()({
    title: title,
    message: message,
    $type: 'confirm',
    showCancelButton: true
  }, options));
};

main_MessageBox.prompt = function (message, title, options) {
  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return main_MessageBox(merge_default()({
    title: title,
    message: message,
    showCancelButton: true,
    showInput: true,
    $type: 'prompt'
  }, options));
};

main_MessageBox.close = function () {
  main_instance.doClose();
  main_instance.visible = false;
  msgQueue = [];
  currentMsg = null;
};

/* harmony default export */ var packages_message_box_src_main = (main_MessageBox);

// CONCATENATED MODULE: ./packages/message-box/index.js

/* harmony default export */ var message_box = (packages_message_box_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&
var breadcrumbvue_type_template_id_4b464c06_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-breadcrumb",
      attrs: { "aria-label": "Breadcrumb", role: "navigation" }
    },
    [_vm._t("default")],
    2
  )
}
var breadcrumbvue_type_template_id_4b464c06_staticRenderFns = []
breadcrumbvue_type_template_id_4b464c06_render._withStripped = true


// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
//
//
//
//
//

/* harmony default export */ var breadcrumbvue_type_script_lang_js_ = ({
  name: 'ElBreadcrumb',

  props: {
    separator: {
      type: String,
      default: '/'
    },
    separatorClass: {
      type: String,
      default: ''
    }
  },

  provide: function provide() {
    return {
      elBreadcrumb: this
    };
  },
  mounted: function mounted() {
    var items = this.$el.querySelectorAll('.el-breadcrumb__item');
    if (items.length) {
      items[items.length - 1].setAttribute('aria-current', 'page');
    }
  }
});
// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_breadcrumbvue_type_script_lang_js_ = (breadcrumbvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue





/* normalize component */

var breadcrumb_component = normalizeComponent(
  src_breadcrumbvue_type_script_lang_js_,
  breadcrumbvue_type_template_id_4b464c06_render,
  breadcrumbvue_type_template_id_4b464c06_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var breadcrumb_api; }
breadcrumb_component.options.__file = "packages/breadcrumb/src/breadcrumb.vue"
/* harmony default export */ var breadcrumb = (breadcrumb_component.exports);
// CONCATENATED MODULE: ./packages/breadcrumb/index.js


/* istanbul ignore next */
breadcrumb.install = function (Vue) {
  Vue.component(breadcrumb.name, breadcrumb);
};

/* harmony default export */ var packages_breadcrumb = (breadcrumb);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&
var breadcrumb_itemvue_type_template_id_fcf9eaac_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "el-breadcrumb__item" }, [
    _c(
      "span",
      {
        ref: "link",
        class: ["el-breadcrumb__inner", _vm.to ? "is-link" : ""],
        attrs: { role: "link" }
      },
      [_vm._t("default")],
      2
    ),
    _vm.separatorClass
      ? _c("i", {
          staticClass: "el-breadcrumb__separator",
          class: _vm.separatorClass
        })
      : _c(
          "span",
          {
            staticClass: "el-breadcrumb__separator",
            attrs: { role: "presentation" }
          },
          [_vm._v(_vm._s(_vm.separator))]
        )
  ])
}
var breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns = []
breadcrumb_itemvue_type_template_id_fcf9eaac_render._withStripped = true


// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var breadcrumb_itemvue_type_script_lang_js_ = ({
  name: 'ElBreadcrumbItem',
  props: {
    to: {},
    replace: Boolean
  },
  data: function data() {
    return {
      separator: '',
      separatorClass: ''
    };
  },


  inject: ['elBreadcrumb'],

  mounted: function mounted() {
    var _this = this;

    this.separator = this.elBreadcrumb.separator;
    this.separatorClass = this.elBreadcrumb.separatorClass;
    var link = this.$refs.link;
    link.setAttribute('role', 'link');
    link.addEventListener('click', function (_) {
      var to = _this.to,
          $router = _this.$router;

      if (!to || !$router) return;
      _this.replace ? $router.replace(to) : $router.push(to);
    });
  }
});
// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_breadcrumb_itemvue_type_script_lang_js_ = (breadcrumb_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue





/* normalize component */

var breadcrumb_item_component = normalizeComponent(
  src_breadcrumb_itemvue_type_script_lang_js_,
  breadcrumb_itemvue_type_template_id_fcf9eaac_render,
  breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var breadcrumb_item_api; }
breadcrumb_item_component.options.__file = "packages/breadcrumb/src/breadcrumb-item.vue"
/* harmony default export */ var breadcrumb_item = (breadcrumb_item_component.exports);
// CONCATENATED MODULE: ./packages/breadcrumb-item/index.js


/* istanbul ignore next */
breadcrumb_item.install = function (Vue) {
  Vue.component(breadcrumb_item.name, breadcrumb_item);
};

/* harmony default export */ var packages_breadcrumb_item = (breadcrumb_item);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
var formvue_type_template_id_a1b5ff34_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "el-form",
      class: [
        _vm.labelPosition ? "el-form--label-" + _vm.labelPosition : "",
        { "el-form--inline": _vm.inline }
      ]
    },
    [_vm._t("default")],
    2
  )
}
var formvue_type_template_id_a1b5ff34_staticRenderFns = []
formvue_type_template_id_a1b5ff34_render._withStripped = true


// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//



/* harmony default export */ var formvue_type_script_lang_js_ = ({
  name: 'ElForm',

  componentName: 'ElForm',

  provide: function provide() {
    return {
      elForm: this
    };
  },


  props: {
    model: Object,
    rules: Object,
    labelPosition: String,
    labelWidth: String,
    labelSuffix: {
      type: String,
      default: ''
    },
    inline: Boolean,
    inlineMessage: Boolean,
    statusIcon: Boolean,
    showMessage: {
      type: Boolean,
      default: true
    },
    size: String,
    disabled: Boolean,
    validateOnRuleChange: {
      type: Boolean,
      default: true
    },
    hideRequiredAsterisk: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    rules: function rules() {
      // remove then add event listeners on form-item after form rules change
      this.fields.forEach(function (field) {
        field.removeValidateEvents();
        field.addValidateEvents();
      });

      if (this.validateOnRuleChange) {
        this.validate(function () {});
      }
    }
  },
  computed: {
    autoLabelWidth: function autoLabelWidth() {
      if (!this.potentialLabelWidthArr.length) return 0;
      var max = Math.max.apply(Math, this.potentialLabelWidthArr);
      return max ? max + 'px' : '';
    }
  },
  data: function data() {
    return {
      fields: [],
      potentialLabelWidthArr: [] // use this array to calculate auto width
    };
  },
  created: function created() {
    var _this = this;

    this.$on('el.form.addField', function (field) {
      if (field) {
        _this.fields.push(field);
      }
    });
    /* istanbul ignore next */
    this.$on('el.form.removeField', function (field) {
      if (field.prop) {
        _this.fields.splice(_this.fields.indexOf(field), 1);
      }
    });
  },

  methods: {
    resetFields: function resetFields() {
      if (!this.model) {
        console.warn('[Element Warn][Form]model is required for resetFields to work.');
        return;
      }
      this.fields.forEach(function (field) {
        field.resetField();
      });
    },
    clearValidate: function clearValidate() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var fields = props.length ? typeof props === 'string' ? this.fields.filter(function (field) {
        return props === field.prop;
      }) : this.fields.filter(function (field) {
        return props.indexOf(field.prop) > -1;
      }) : this.fields;
      fields.forEach(function (field) {
        field.clearValidate();
      });
    },
    validate: function validate(callback) {
      var _this2 = this;

      if (!this.model) {
        console.warn('[Element Warn][Form]model is required for validate to work!');
        return;
      }

      var promise = void 0;
      // if no callback, return promise
      if (typeof callback !== 'function' && window.Promise) {
        promise = new window.Promise(function (resolve, reject) {
          callback = function callback(valid) {
            valid ? resolve(valid) : reject(valid);
          };
        });
      }

      var valid = true;
      var count = 0;
      // 如果需要验证的fields为空，调用验证时立刻返回callback
      if (this.fields.length === 0 && callback) {
        callback(true);
      }
      var invalidFields = {};
      this.fields.forEach(function (field) {
        field.validate('', function (message, field) {
          if (message) {
            valid = false;
          }
          invalidFields = merge_default()({}, invalidFields, field);
          if (typeof callback === 'function' && ++count === _this2.fields.length) {
            callback(valid, invalidFields);
          }
        });
      });

      if (promise) {
        return promise;
      }
    },
    validateField: function validateField(props, cb) {
      props = [].concat(props);
      var fields = this.fields.filter(function (field) {
        return props.indexOf(field.prop) !== -1;
      });
      if (!fields.length) {
        console.warn('[Element Warn]please pass correct props!');
        return;
      }

      fields.forEach(function (field) {
        field.validate('', cb);
      });
    },
    getLabelWidthIndex: function getLabelWidthIndex(width) {
      var index = this.potentialLabelWidthArr.indexOf(width);
      // it's impossible
      if (index === -1) {
        throw new Error('[ElementForm]unpected width ', width);
      }
      return index;
    },
    registerLabelWidth: function registerLabelWidth(val, oldVal) {
      if (val && oldVal) {
        var index = this.getLabelWidthIndex(oldVal);
        this.potentialLabelWidthArr.splice(index, 1, val);
      } else if (val) {
        this.potentialLabelWidthArr.push(val);
      }
    },
    deregisterLabelWidth: function deregisterLabelWidth(val) {
      var index = this.getLabelWidthIndex(val);
      this.potentialLabelWidthArr.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_formvue_type_script_lang_js_ = (formvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/form/src/form.vue





/* normalize component */

var form_component = normalizeComponent(
  src_formvue_type_script_lang_js_,
  formvue_type_template_id_a1b5ff34_render,
  formvue_type_template_id_a1b5ff34_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var form_api; }
form_component.options.__file = "packages/form/src/form.vue"
/* harmony default export */ var src_form = (form_component.exports);
// CONCATENATED MODULE: ./packages/form/index.js


/* istanbul ignore next */
src_form.install = function (Vue) {
  Vue.component(src_form.name, src_form);
};

/* harmony default export */ var packages_form = (src_form);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
var form_itemvue_type_template_id_b6f3db6c_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-form-item",
      class: [
        {
          "el-form-item--feedback": _vm.elForm && _vm.elForm.statusIcon,
          "is-error": _vm.validateState === "error",
          "is-validating": _vm.validateState === "validating",
          "is-success": _vm.validateState === "success",
          "is-required": _vm.isRequired || _vm.required,
          "is-no-asterisk": _vm.elForm && _vm.elForm.hideRequiredAsterisk
        },
        _vm.sizeClass ? "el-form-item--" + _vm.sizeClass : ""
      ]
    },
    [
      _c(
        "label-wrap",
        {
          attrs: {
            "is-auto-width": _vm.labelStyle && _vm.labelStyle.width === "auto",
            "update-all": _vm.form.labelWidth === "auto"
          }
        },
        [
          _vm.label || _vm.$slots.label
            ? _c(
                "label",
                {
                  staticClass: "el-form-item__label",
                  style: _vm.labelStyle,
                  attrs: { for: _vm.labelFor }
                },
                [
                  _vm._t("label", [
                    _vm._v(_vm._s(_vm.label + _vm.form.labelSuffix))
                  ])
                ],
                2
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        { staticClass: "el-form-item__content", style: _vm.contentStyle },
        [
          _vm._t("default"),
          _c(
            "transition",
            { attrs: { name: "el-zoom-in-top" } },
            [
              _vm.validateState === "error" &&
              _vm.showMessage &&
              _vm.form.showMessage
                ? _vm._t(
                    "error",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "el-form-item__error",
                          class: {
                            "el-form-item__error--inline":
                              typeof _vm.inlineMessage === "boolean"
                                ? _vm.inlineMessage
                                : (_vm.elForm && _vm.elForm.inlineMessage) ||
                                  false
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.validateMessage) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    { error: _vm.validateMessage }
                  )
                : _vm._e()
            ],
            2
          )
        ],
        2
      )
    ],
    1
  )
}
var form_itemvue_type_template_id_b6f3db6c_staticRenderFns = []
form_itemvue_type_template_id_b6f3db6c_render._withStripped = true


// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&

// EXTERNAL MODULE: external "async-validator"
var external_async_validator_ = __webpack_require__(40);
var external_async_validator_default = /*#__PURE__*/__webpack_require__.n(external_async_validator_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/label-wrap.vue?vue&type=script&lang=js&


/* harmony default export */ var label_wrapvue_type_script_lang_js_ = ({
  props: {
    isAutoWidth: Boolean,
    updateAll: Boolean
  },

  inject: ['elForm', 'elFormItem'],

  render: function render() {
    var h = arguments[0];

    var slots = this.$slots.default;
    if (!slots) return null;
    if (this.isAutoWidth) {
      var autoLabelWidth = this.elForm.autoLabelWidth;
      var style = {};
      if (autoLabelWidth && autoLabelWidth !== 'auto') {
        var marginLeft = parseInt(autoLabelWidth, 10) - this.computedWidth;
        if (marginLeft) {
          style.marginLeft = marginLeft + 'px';
        }
      }
      return h(
        'div',
        { 'class': 'el-form-item__label-wrap', style: style },
        [slots]
      );
    } else {
      return slots[0];
    }
  },


  methods: {
    getLabelWidth: function getLabelWidth() {
      if (this.$el && this.$el.firstElementChild) {
        var computedWidth = window.getComputedStyle(this.$el.firstElementChild).width;
        return Math.ceil(parseFloat(computedWidth));
      } else {
        return 0;
      }
    },
    updateLabelWidth: function updateLabelWidth() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'update';

      if (this.$slots.default && this.isAutoWidth && this.$el.firstElementChild) {
        if (action === 'update') {
          this.computedWidth = this.getLabelWidth();
        } else if (action === 'remove') {
          this.elForm.deregisterLabelWidth(this.computedWidth);
        }
      }
    }
  },

  watch: {
    computedWidth: function computedWidth(val, oldVal) {
      if (this.updateAll) {
        this.elForm.registerLabelWidth(val, oldVal);
        this.elFormItem.updateComputedLabelWidth(val);
      }
    }
  },

  data: function data() {
    return {
      computedWidth: 0
    };
  },
  mounted: function mounted() {
    this.updateLabelWidth('update');
  },
  updated: function updated() {
    this.updateLabelWidth('update');
  },
  beforeDestroy: function beforeDestroy() {
    this.updateLabelWidth('remove');
  }
});
// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_label_wrapvue_type_script_lang_js_ = (label_wrapvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue
var label_wrap_render, label_wrap_staticRenderFns




/* normalize component */

var label_wrap_component = normalizeComponent(
  src_label_wrapvue_type_script_lang_js_,
  label_wrap_render,
  label_wrap_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var label_wrap_api; }
label_wrap_component.options.__file = "packages/form/src/label-wrap.vue"
/* harmony default export */ var label_wrap = (label_wrap_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var form_itemvue_type_script_lang_js_ = ({
  name: 'ElFormItem',

  componentName: 'ElFormItem',

  mixins: [emitter_default.a],

  provide: function provide() {
    return {
      elFormItem: this
    };
  },


  inject: ['elForm'],

  props: {
    label: String,
    labelWidth: String,
    prop: String,
    required: {
      type: Boolean,
      default: undefined
    },
    rules: [Object, Array],
    error: String,
    validateStatus: String,
    for: String,
    inlineMessage: {
      type: [String, Boolean],
      default: ''
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    size: String
  },
  components: {
    // use this component to calculate auto width
    LabelWrap: label_wrap
  },
  watch: {
    error: {
      immediate: true,
      handler: function handler(value) {
        this.validateMessage = value;
        this.validateState = value ? 'error' : '';
      }
    },
    validateStatus: function validateStatus(value) {
      this.validateState = value;
    }
  },
  computed: {
    labelFor: function labelFor() {
      return this.for || this.prop;
    },
    labelStyle: function labelStyle() {
      var ret = {};
      if (this.form.labelPosition === 'top') return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;
      if (labelWidth) {
        ret.width = labelWidth;
      }
      return ret;
    },
    contentStyle: function contentStyle() {
      var ret = {};
      var label = this.label;
      if (this.form.labelPosition === 'top' || this.form.inline) return ret;
      if (!label && !this.labelWidth && this.isNested) return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;
      if (labelWidth === 'auto') {
        if (this.labelWidth === 'auto') {
          ret.marginLeft = this.computedLabelWidth;
        } else if (this.form.labelWidth === 'auto') {
          ret.marginLeft = this.elForm.autoLabelWidth;
        }
      } else {
        ret.marginLeft = labelWidth;
      }
      return ret;
    },
    form: function form() {
      var parent = this.$parent;
      var parentName = parent.$options.componentName;
      while (parentName !== 'ElForm') {
        if (parentName === 'ElFormItem') {
          this.isNested = true;
        }
        parent = parent.$parent;
        parentName = parent.$options.componentName;
      }
      return parent;
    },
    fieldValue: function fieldValue() {
      var model = this.form.model;
      if (!model || !this.prop) {
        return;
      }

      var path = this.prop;
      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.');
      }

      return Object(util_["getPropByPath"])(model, path, true).v;
    },
    isRequired: function isRequired() {
      var rules = this.getRules();
      var isRequired = false;

      if (rules && rules.length) {
        rules.every(function (rule) {
          if (rule.required) {
            isRequired = true;
            return false;
          }
          return true;
        });
      }
      return isRequired;
    },
    _formSize: function _formSize() {
      return this.elForm.size;
    },
    elFormItemSize: function elFormItemSize() {
      return this.size || this._formSize;
    },
    sizeClass: function sizeClass() {
      return this.elFormItemSize || (this.$ELEMENT || {}).size;
    }
  },
  data: function data() {
    return {
      validateState: '',
      validateMessage: '',
      validateDisabled: false,
      validator: {},
      isNested: false,
      computedLabelWidth: ''
    };
  },

  methods: {
    validate: function validate(trigger) {
      var _this = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : util_["noop"];

      this.validateDisabled = false;
      var rules = this.getFilteredRule(trigger);
      if ((!rules || rules.length === 0) && this.required === undefined) {
        callback();
        return true;
      }

      this.validateState = 'validating';

      var descriptor = {};
      if (rules && rules.length > 0) {
        rules.forEach(function (rule) {
          delete rule.trigger;
        });
      }
      descriptor[this.prop] = rules;

      var validator = new external_async_validator_default.a(descriptor);
      var model = {};

      model[this.prop] = this.fieldValue;

      validator.validate(model, { firstFields: true }, function (errors, invalidFields) {
        _this.validateState = !errors ? 'success' : 'error';
        _this.validateMessage = errors ? errors[0].message : '';

        callback(_this.validateMessage, invalidFields);
        _this.elForm && _this.elForm.$emit('validate', _this.prop, !errors, _this.validateMessage || null);
      });
    },
    clearValidate: function clearValidate() {
      this.validateState = '';
      this.validateMessage = '';
      this.validateDisabled = false;
    },
    resetField: function resetField() {
      var _this2 = this;

      this.validateState = '';
      this.validateMessage = '';

      var model = this.form.model;
      var value = this.fieldValue;
      var path = this.prop;
      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.');
      }

      var prop = Object(util_["getPropByPath"])(model, path, true);

      this.validateDisabled = true;
      if (Array.isArray(value)) {
        prop.o[prop.k] = [].concat(this.initialValue);
      } else {
        prop.o[prop.k] = this.initialValue;
      }

      // reset validateDisabled after onFieldChange triggered
      this.$nextTick(function () {
        _this2.validateDisabled = false;
      });

      this.broadcast('ElTimeSelect', 'fieldReset', this.initialValue);
    },
    getRules: function getRules() {
      var formRules = this.form.rules;
      var selfRules = this.rules;
      var requiredRule = this.required !== undefined ? { required: !!this.required } : [];

      var prop = Object(util_["getPropByPath"])(formRules, this.prop || '');
      formRules = formRules ? prop.o[this.prop || ''] || prop.v : [];

      return [].concat(selfRules || formRules || []).concat(requiredRule);
    },
    getFilteredRule: function getFilteredRule(trigger) {
      var rules = this.getRules();

      return rules.filter(function (rule) {
        if (!rule.trigger || trigger === '') return true;
        if (Array.isArray(rule.trigger)) {
          return rule.trigger.indexOf(trigger) > -1;
        } else {
          return rule.trigger === trigger;
        }
      }).map(function (rule) {
        return merge_default()({}, rule);
      });
    },
    onFieldBlur: function onFieldBlur() {
      this.validate('blur');
    },
    onFieldChange: function onFieldChange() {
      if (this.validateDisabled) {
        this.validateDisabled = false;
        return;
      }

      this.validate('change');
    },
    updateComputedLabelWidth: function updateComputedLabelWidth(width) {
      this.computedLabelWidth = width ? width + 'px' : '';
    },
    addValidateEvents: function addValidateEvents() {
      var rules = this.getRules();

      if (rules.length || this.required !== undefined) {
        this.$on('el.form.blur', this.onFieldBlur);
        this.$on('el.form.change', this.onFieldChange);
      }
    },
    removeValidateEvents: function removeValidateEvents() {
      this.$off();
    }
  },
  mounted: function mounted() {
    if (this.prop) {
      this.dispatch('ElForm', 'el.form.addField', [this]);

      var initialValue = this.fieldValue;
      if (Array.isArray(initialValue)) {
        initialValue = [].concat(initialValue);
      }
      Object.defineProperty(this, 'initialValue', {
        value: initialValue
      });

      this.addValidateEvents();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('ElForm', 'el.form.removeField', [this]);
  }
});
// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_form_itemvue_type_script_lang_js_ = (form_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/form/src/form-item.vue





/* normalize component */

var form_item_component = normalizeComponent(
  src_form_itemvue_type_script_lang_js_,
  form_itemvue_type_template_id_b6f3db6c_render,
  form_itemvue_type_template_id_b6f3db6c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var form_item_api; }
form_item_component.options.__file = "packages/form/src/form-item.vue"
/* harmony default export */ var form_item = (form_item_component.exports);
// CONCATENATED MODULE: ./packages/form-item/index.js


/* istanbul ignore next */
form_item.install = function (Vue) {
  Vue.component(form_item.name, form_item);
};

/* harmony default export */ var packages_form_item = (form_item);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&
var tab_barvue_type_template_id_2031f33a_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "el-tabs__active-bar",
    class: "is-" + _vm.rootTabs.tabPosition,
    style: _vm.barStyle
  })
}
var tab_barvue_type_template_id_2031f33a_staticRenderFns = []
tab_barvue_type_template_id_2031f33a_render._withStripped = true


// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
//
//
//


/* harmony default export */ var tab_barvue_type_script_lang_js_ = ({
  name: 'TabBar',

  props: {
    tabs: Array
  },

  inject: ['rootTabs'],

  computed: {
    barStyle: {
      get: function get() {
        var _this = this;

        var style = {};
        var offset = 0;
        var tabSize = 0;
        var sizeName = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
        var sizeDir = sizeName === 'width' ? 'x' : 'y';
        var firstUpperCase = function firstUpperCase(str) {
          return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
            return L.toUpperCase();
          });
        };
        this.tabs.every(function (tab, index) {
          var $el = Object(util_["arrayFind"])(_this.$parent.$refs.tabs || [], function (t) {
            return t.id.replace('tab-', '') === tab.paneName;
          });
          if (!$el) {
            return false;
          }

          if (!tab.active) {
            offset += $el['client' + firstUpperCase(sizeName)];
            return true;
          } else {
            tabSize = $el['client' + firstUpperCase(sizeName)];
            var tabStyles = window.getComputedStyle($el);
            if (sizeName === 'width' && _this.tabs.length > 1) {
              tabSize -= parseFloat(tabStyles.paddingLeft) + parseFloat(tabStyles.paddingRight);
            }
            if (sizeName === 'width') {
              offset += parseFloat(tabStyles.paddingLeft);
            }
            return false;
          }
        });

        var transform = 'translate' + firstUpperCase(sizeDir) + '(' + offset + 'px)';
        style[sizeName] = tabSize + 'px';
        style.transform = transform;
        style.msTransform = transform;
        style.webkitTransform = transform;

        return style;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tab_barvue_type_script_lang_js_ = (tab_barvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue





/* normalize component */

var tab_bar_component = normalizeComponent(
  src_tab_barvue_type_script_lang_js_,
  tab_barvue_type_template_id_2031f33a_render,
  tab_barvue_type_template_id_2031f33a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var tab_bar_api; }
tab_bar_component.options.__file = "packages/tabs/src/tab-bar.vue"
/* harmony default export */ var tab_bar = (tab_bar_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&




function noop() {}
var tab_navvue_type_script_lang_js_firstUpperCase = function firstUpperCase(str) {
  return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
    return L.toUpperCase();
  });
};

/* harmony default export */ var tab_navvue_type_script_lang_js_ = ({
  name: 'TabNav',

  components: {
    TabBar: tab_bar
  },

  inject: ['rootTabs'],

  props: {
    panes: Array,
    currentName: String,
    editable: Boolean,
    onTabClick: {
      type: Function,
      default: noop
    },
    onTabRemove: {
      type: Function,
      default: noop
    },
    type: String,
    stretch: Boolean
  },

  data: function data() {
    return {
      scrollable: false,
      navOffset: 0,
      isFocus: false,
      focusable: true
    };
  },


  computed: {
    navStyle: function navStyle() {
      var dir = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'X' : 'Y';
      return {
        transform: 'translate' + dir + '(-' + this.navOffset + 'px)'
      };
    },
    sizeName: function sizeName() {
      return ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
    }
  },

  methods: {
    scrollPrev: function scrollPrev() {
      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
      var currentOffset = this.navOffset;

      if (!currentOffset) return;

      var newOffset = currentOffset > containerSize ? currentOffset - containerSize : 0;

      this.navOffset = newOffset;
    },
    scrollNext: function scrollNext() {
      var navSize = this.$refs.nav['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
      var currentOffset = this.navOffset;

      if (navSize - currentOffset <= containerSize) return;

      var newOffset = navSize - currentOffset > containerSize * 2 ? currentOffset + containerSize : navSize - containerSize;

      this.navOffset = newOffset;
    },
    scrollToActiveTab: function scrollToActiveTab() {
      if (!this.scrollable) return;
      var nav = this.$refs.nav;
      var activeTab = this.$el.querySelector('.is-active');
      if (!activeTab) return;
      var navScroll = this.$refs.navScroll;
      var isHorizontal = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1;
      var activeTabBounding = activeTab.getBoundingClientRect();
      var navScrollBounding = navScroll.getBoundingClientRect();
      var maxOffset = isHorizontal ? nav.offsetWidth - navScrollBounding.width : nav.offsetHeight - navScrollBounding.height;
      var currentOffset = this.navOffset;
      var newOffset = currentOffset;

      if (isHorizontal) {
        if (activeTabBounding.left < navScrollBounding.left) {
          newOffset = currentOffset - (navScrollBounding.left - activeTabBounding.left);
        }
        if (activeTabBounding.right > navScrollBounding.right) {
          newOffset = currentOffset + activeTabBounding.right - navScrollBounding.right;
        }
      } else {
        if (activeTabBounding.top < navScrollBounding.top) {
          newOffset = currentOffset - (navScrollBounding.top - activeTabBounding.top);
        }
        if (activeTabBounding.bottom > navScrollBounding.bottom) {
          newOffset = currentOffset + (activeTabBounding.bottom - navScrollBounding.bottom);
        }
      }
      newOffset = Math.max(newOffset, 0);
      this.navOffset = Math.min(newOffset, maxOffset);
    },
    update: function update() {
      if (!this.$refs.nav) return;
      var sizeName = this.sizeName;
      var navSize = this.$refs.nav['offset' + tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];
      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];
      var currentOffset = this.navOffset;

      if (containerSize < navSize) {
        var _currentOffset = this.navOffset;
        this.scrollable = this.scrollable || {};
        this.scrollable.prev = _currentOffset;
        this.scrollable.next = _currentOffset + containerSize < navSize;
        if (navSize - _currentOffset < containerSize) {
          this.navOffset = navSize - containerSize;
        }
      } else {
        this.scrollable = false;
        if (currentOffset > 0) {
          this.navOffset = 0;
        }
      }
    },
    changeTab: function changeTab(e) {
      var keyCode = e.keyCode;
      var nextIndex = void 0;
      var currentIndex = void 0,
          tabList = void 0;
      if ([37, 38, 39, 40].indexOf(keyCode) !== -1) {
        // 左右上下键更换tab
        tabList = e.currentTarget.querySelectorAll('[role=tab]');
        currentIndex = Array.prototype.indexOf.call(tabList, e.target);
      } else {
        return;
      }
      if (keyCode === 37 || keyCode === 38) {
        // left
        if (currentIndex === 0) {
          // first
          nextIndex = tabList.length - 1;
        } else {
          nextIndex = currentIndex - 1;
        }
      } else {
        // right
        if (currentIndex < tabList.length - 1) {
          // not last
          nextIndex = currentIndex + 1;
        } else {
          nextIndex = 0;
        }
      }
      tabList[nextIndex].focus(); // 改变焦点元素
      tabList[nextIndex].click(); // 选中下一个tab
      this.setFocus();
    },
    setFocus: function setFocus() {
      if (this.focusable) {
        this.isFocus = true;
      }
    },
    removeFocus: function removeFocus() {
      this.isFocus = false;
    },
    visibilityChangeHandler: function visibilityChangeHandler() {
      var _this = this;

      var visibility = document.visibilityState;
      if (visibility === 'hidden') {
        this.focusable = false;
      } else if (visibility === 'visible') {
        setTimeout(function () {
          _this.focusable = true;
        }, 50);
      }
    },
    windowBlurHandler: function windowBlurHandler() {
      this.focusable = false;
    },
    windowFocusHandler: function windowFocusHandler() {
      var _this2 = this;

      setTimeout(function () {
        _this2.focusable = true;
      }, 50);
    }
  },

  updated: function updated() {
    this.update();
  },
  render: function render(h) {
    var _this3 = this;

    var type = this.type,
        panes = this.panes,
        editable = this.editable,
        stretch = this.stretch,
        onTabClick = this.onTabClick,
        onTabRemove = this.onTabRemove,
        navStyle = this.navStyle,
        scrollable = this.scrollable,
        scrollNext = this.scrollNext,
        scrollPrev = this.scrollPrev,
        changeTab = this.changeTab,
        setFocus = this.setFocus,
        removeFocus = this.removeFocus;

    var scrollBtn = scrollable ? [h(
      'span',
      { 'class': ['el-tabs__nav-prev', scrollable.prev ? '' : 'is-disabled'], on: {
          'click': scrollPrev
        }
      },
      [h('i', { 'class': 'el-icon-arrow-left' })]
    ), h(
      'span',
      { 'class': ['el-tabs__nav-next', scrollable.next ? '' : 'is-disabled'], on: {
          'click': scrollNext
        }
      },
      [h('i', { 'class': 'el-icon-arrow-right' })]
    )] : null;

    var tabs = this._l(panes, function (pane, index) {
      var _ref;

      var tabName = pane.name || pane.index || index;
      var closable = pane.isClosable || editable;

      pane.index = '' + index;

      var btnClose = closable ? h('span', { 'class': 'el-icon-close', on: {
          'click': function click(ev) {
            onTabRemove(pane, ev);
          }
        }
      }) : null;

      var tabLabelContent = pane.$slots.label || pane.label;
      var tabindex = pane.active ? 0 : -1;
      return h(
        'div',
        {
          'class': (_ref = {
            'el-tabs__item': true
          }, _ref['is-' + _this3.rootTabs.tabPosition] = true, _ref['is-active'] = pane.active, _ref['is-disabled'] = pane.disabled, _ref['is-closable'] = closable, _ref['is-focus'] = _this3.isFocus, _ref),
          attrs: { id: 'tab-' + tabName,

            'aria-controls': 'pane-' + tabName,
            role: 'tab',
            'aria-selected': pane.active,

            tabindex: tabindex
          },
          key: 'tab-' + tabName, ref: 'tabs', refInFor: true,
          on: {
            'focus': function focus() {
              setFocus();
            },
            'blur': function blur() {
              removeFocus();
            },
            'click': function click(ev) {
              removeFocus();onTabClick(pane, tabName, ev);
            },
            'keydown': function keydown(ev) {
              if (closable && (ev.keyCode === 46 || ev.keyCode === 8)) {
                onTabRemove(pane, ev);
              }
            }
          }
        },
        [tabLabelContent, btnClose]
      );
    });
    return h(
      'div',
      { 'class': ['el-tabs__nav-wrap', scrollable ? 'is-scrollable' : '', 'is-' + this.rootTabs.tabPosition] },
      [scrollBtn, h(
        'div',
        { 'class': ['el-tabs__nav-scroll'], ref: 'navScroll' },
        [h(
          'div',
          {
            'class': ['el-tabs__nav', 'is-' + this.rootTabs.tabPosition, stretch && ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'is-stretch' : ''],
            ref: 'nav',
            style: navStyle,
            attrs: { role: 'tablist'
            },
            on: {
              'keydown': changeTab
            }
          },
          [!type ? h('tab-bar', {
            attrs: { tabs: panes }
          }) : null, tabs]
        )]
      )]
    );
  },
  mounted: function mounted() {
    var _this4 = this;

    Object(resize_event_["addResizeListener"])(this.$el, this.update);
    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    window.addEventListener('blur', this.windowBlurHandler);
    window.addEventListener('focus', this.windowFocusHandler);
    setTimeout(function () {
      _this4.scrollToActiveTab();
    }, 0);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el && this.update) Object(resize_event_["removeResizeListener"])(this.$el, this.update);
    document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
    window.removeEventListener('blur', this.windowBlurHandler);
    window.removeEventListener('focus', this.windowFocusHandler);
  }
});
// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tab_navvue_type_script_lang_js_ = (tab_navvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue
var tab_nav_render, tab_nav_staticRenderFns




/* normalize component */

var tab_nav_component = normalizeComponent(
  src_tab_navvue_type_script_lang_js_,
  tab_nav_render,
  tab_nav_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var tab_nav_api; }
tab_nav_component.options.__file = "packages/tabs/src/tab-nav.vue"
/* harmony default export */ var tab_nav = (tab_nav_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tabs.vue?vue&type=script&lang=js&



/* harmony default export */ var tabsvue_type_script_lang_js_ = ({
  name: 'ElTabs',

  components: {
    TabNav: tab_nav
  },

  props: {
    type: String,
    activeName: String,
    closable: Boolean,
    addable: Boolean,
    value: {},
    editable: Boolean,
    tabPosition: {
      type: String,
      default: 'top'
    },
    beforeLeave: Function,
    stretch: Boolean
  },

  provide: function provide() {
    return {
      rootTabs: this
    };
  },
  data: function data() {
    return {
      currentName: this.value || this.activeName,
      panes: []
    };
  },


  watch: {
    activeName: function activeName(value) {
      this.setCurrentName(value);
    },
    value: function value(_value) {
      this.setCurrentName(_value);
    },
    currentName: function currentName(value) {
      var _this = this;

      if (this.$refs.nav) {
        this.$nextTick(function () {
          _this.$refs.nav.$nextTick(function (_) {
            _this.$refs.nav.scrollToActiveTab();
          });
        });
      }
    }
  },

  methods: {
    calcPaneInstances: function calcPaneInstances() {
      var _this2 = this;

      var isForceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.$slots.default) {
        var paneSlots = this.$slots.default.filter(function (vnode) {
          return vnode.tag && vnode.componentOptions && vnode.componentOptions.Ctor.options.name === 'ElTabPane';
        });
        // update indeed
        var panes = paneSlots.map(function (_ref) {
          var componentInstance = _ref.componentInstance;
          return componentInstance;
        });
        var panesChanged = !(panes.length === this.panes.length && panes.every(function (pane, index) {
          return pane === _this2.panes[index];
        }));
        if (isForceUpdate || panesChanged) {
          this.panes = panes;
        }
      } else if (this.panes.length !== 0) {
        this.panes = [];
      }
    },
    handleTabClick: function handleTabClick(tab, tabName, event) {
      if (tab.disabled) return;
      this.setCurrentName(tabName);
      this.$emit('tab-click', tab, event);
    },
    handleTabRemove: function handleTabRemove(pane, ev) {
      if (pane.disabled) return;
      ev.stopPropagation();
      this.$emit('edit', pane.name, 'remove');
      this.$emit('tab-remove', pane.name);
    },
    handleTabAdd: function handleTabAdd() {
      this.$emit('edit', null, 'add');
      this.$emit('tab-add');
    },
    setCurrentName: function setCurrentName(value) {
      var _this3 = this;

      var changeCurrentName = function changeCurrentName() {
        _this3.currentName = value;
        _this3.$emit('input', value);
      };
      if (this.currentName !== value && this.beforeLeave) {
        var before = this.beforeLeave(value, this.currentName);
        if (before && before.then) {
          before.then(function () {
            changeCurrentName();
            _this3.$refs.nav && _this3.$refs.nav.removeFocus();
          }, function () {
            // https://github.com/ElemeFE/element/pull/14816
            // ignore promise rejection in `before-leave` hook
          });
        } else if (before !== false) {
          changeCurrentName();
        }
      } else {
        changeCurrentName();
      }
    }
  },

  render: function render(h) {
    var _ref2;

    var type = this.type,
        handleTabClick = this.handleTabClick,
        handleTabRemove = this.handleTabRemove,
        handleTabAdd = this.handleTabAdd,
        currentName = this.currentName,
        panes = this.panes,
        editable = this.editable,
        addable = this.addable,
        tabPosition = this.tabPosition,
        stretch = this.stretch;


    var newButton = editable || addable ? h(
      'span',
      {
        'class': 'el-tabs__new-tab',
        on: {
          'click': handleTabAdd,
          'keydown': function keydown(ev) {
            if (ev.keyCode === 13) {
              handleTabAdd();
            }
          }
        },
        attrs: {
          tabindex: '0'
        }
      },
      [h('i', { 'class': 'el-icon-plus' })]
    ) : null;

    var navData = {
      props: {
        currentName: currentName,
        onTabClick: handleTabClick,
        onTabRemove: handleTabRemove,
        editable: editable,
        type: type,
        panes: panes,
        stretch: stretch
      },
      ref: 'nav'
    };
    var header = h(
      'div',
      { 'class': ['el-tabs__header', 'is-' + tabPosition] },
      [newButton, h('tab-nav', navData)]
    );
    var panels = h(
      'div',
      { 'class': 'el-tabs__content' },
      [this.$slots.default]
    );

    return h(
      'div',
      { 'class': (_ref2 = {
          'el-tabs': true,
          'el-tabs--card': type === 'card'
        }, _ref2['el-tabs--' + tabPosition] = true, _ref2['el-tabs--border-card'] = type === 'border-card', _ref2) },
      [tabPosition !== 'bottom' ? [header, panels] : [panels, header]]
    );
  },
  created: function created() {
    if (!this.currentName) {
      this.setCurrentName('0');
    }

    this.$on('tab-nav-update', this.calcPaneInstances.bind(null, true));
  },
  mounted: function mounted() {
    this.calcPaneInstances();
  },
  updated: function updated() {
    this.calcPaneInstances();
  }
});
// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tabsvue_type_script_lang_js_ = (tabsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue
var tabs_render, tabs_staticRenderFns




/* normalize component */

var tabs_component = normalizeComponent(
  src_tabsvue_type_script_lang_js_,
  tabs_render,
  tabs_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var tabs_api; }
tabs_component.options.__file = "packages/tabs/src/tabs.vue"
/* harmony default export */ var tabs = (tabs_component.exports);
// CONCATENATED MODULE: ./packages/tabs/index.js


/* istanbul ignore next */
tabs.install = function (Vue) {
  Vue.component(tabs.name, tabs);
};

/* harmony default export */ var packages_tabs = (tabs);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&
var tab_panevue_type_template_id_9145a070_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.lazy || _vm.loaded || _vm.active
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.active,
              expression: "active"
            }
          ],
          staticClass: "el-tab-pane",
          attrs: {
            role: "tabpanel",
            "aria-hidden": !_vm.active,
            id: "pane-" + _vm.paneName,
            "aria-labelledby": "tab-" + _vm.paneName
          }
        },
        [_vm._t("default")],
        2
      )
    : _vm._e()
}
var tab_panevue_type_template_id_9145a070_staticRenderFns = []
tab_panevue_type_template_id_9145a070_render._withStripped = true


// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var tab_panevue_type_script_lang_js_ = ({
  name: 'ElTabPane',

  componentName: 'ElTabPane',

  props: {
    label: String,
    labelContent: Function,
    name: String,
    closable: Boolean,
    disabled: Boolean,
    lazy: Boolean
  },

  data: function data() {
    return {
      index: null,
      loaded: false
    };
  },


  computed: {
    isClosable: function isClosable() {
      return this.closable || this.$parent.closable;
    },
    active: function active() {
      var active = this.$parent.currentName === (this.name || this.index);
      if (active) {
        this.loaded = true;
      }
      return active;
    },
    paneName: function paneName() {
      return this.name || this.index;
    }
  },

  updated: function updated() {
    this.$parent.$emit('tab-nav-update');
  }
});
// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tab_panevue_type_script_lang_js_ = (tab_panevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue





/* normalize component */

var tab_pane_component = normalizeComponent(
  src_tab_panevue_type_script_lang_js_,
  tab_panevue_type_template_id_9145a070_render,
  tab_panevue_type_template_id_9145a070_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var tab_pane_api; }
tab_pane_component.options.__file = "packages/tabs/src/tab-pane.vue"
/* harmony default export */ var tab_pane = (tab_pane_component.exports);
// CONCATENATED MODULE: ./packages/tab-pane/index.js


/* istanbul ignore next */
tab_pane.install = function (Vue) {
  Vue.component(tab_pane.name, tab_pane);
};

/* harmony default export */ var packages_tab_pane = (tab_pane);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&

/* harmony default export */ var tagvue_type_script_lang_js_ = ({
  name: 'ElTag',
  props: {
    text: String,
    closable: Boolean,
    type: String,
    hit: Boolean,
    disableTransitions: Boolean,
    color: String,
    size: String,
    effect: {
      type: String,
      default: 'light',
      validator: function validator(val) {
        return ['dark', 'light', 'plain'].indexOf(val) !== -1;
      }
    }
  },
  methods: {
    handleClose: function handleClose(event) {
      event.stopPropagation();
      this.$emit('close', event);
    },
    handleClick: function handleClick(event) {
      this.$emit('click', event);
    }
  },
  computed: {
    tagSize: function tagSize() {
      return this.size || (this.$ELEMENT || {}).size;
    }
  },
  render: function render(h) {
    var type = this.type,
        tagSize = this.tagSize,
        hit = this.hit,
        effect = this.effect;

    var classes = ['el-tag', type ? 'el-tag--' + type : '', tagSize ? 'el-tag--' + tagSize : '', effect ? 'el-tag--' + effect : '', hit && 'is-hit'];
    var tagEl = h(
      'span',
      {
        'class': classes,
        style: { backgroundColor: this.color },
        on: {
          'click': this.handleClick
        }
      },
      [this.$slots.default, this.closable && h('i', { 'class': 'el-tag__close el-icon-close', on: {
          'click': this.handleClose
        }
      })]
    );

    return this.disableTransitions ? tagEl : h(
      'transition',
      {
        attrs: { name: 'el-zoom-in-center' }
      },
      [tagEl]
    );
  }
});
// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tagvue_type_script_lang_js_ = (tagvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tag/src/tag.vue
var tag_render, tag_staticRenderFns




/* normalize component */

var tag_component = normalizeComponent(
  src_tagvue_type_script_lang_js_,
  tag_render,
  tag_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var tag_api; }
tag_component.options.__file = "packages/tag/src/tag.vue"
/* harmony default export */ var tag = (tag_component.exports);
// CONCATENATED MODULE: ./packages/tag/index.js


/* istanbul ignore next */
tag.install = function (Vue) {
  Vue.component(tag.name, tag);
};

/* harmony default export */ var packages_tag = (tag);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=template&id=547575a6&
var treevue_type_template_id_547575a6_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-tree",
      class: {
        "el-tree--highlight-current": _vm.highlightCurrent,
        "is-dragging": !!_vm.dragState.draggingNode,
        "is-drop-not-allow": !_vm.dragState.allowDrop,
        "is-drop-inner": _vm.dragState.dropType === "inner"
      },
      attrs: { role: "tree" }
    },
    [
      _vm._l(_vm.root.childNodes, function(child) {
        return _c("el-tree-node", {
          key: _vm.getNodeKey(child),
          attrs: {
            node: child,
            props: _vm.props,
            "render-after-expand": _vm.renderAfterExpand,
            "show-checkbox": _vm.showCheckbox,
            "render-content": _vm.renderContent
          },
          on: { "node-expand": _vm.handleNodeExpand }
        })
      }),
      _vm.isEmpty
        ? _c("div", { staticClass: "el-tree__empty-block" }, [
            _c("span", { staticClass: "el-tree__empty-text" }, [
              _vm._v(_vm._s(_vm.emptyText))
            ])
          ])
        : _vm._e(),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.dragState.showDropIndicator,
            expression: "dragState.showDropIndicator"
          }
        ],
        ref: "dropIndicator",
        staticClass: "el-tree__drop-indicator"
      })
    ],
    2
  )
}
var treevue_type_template_id_547575a6_staticRenderFns = []
treevue_type_template_id_547575a6_render._withStripped = true


// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=template&id=547575a6&

// CONCATENATED MODULE: ./packages/tree/src/model/util.js
var NODE_KEY = '$treeNodeId';

var markNodeData = function markNodeData(node, data) {
  if (!data || data[NODE_KEY]) return;
  Object.defineProperty(data, NODE_KEY, {
    value: node.id,
    enumerable: false,
    configurable: false,
    writable: false
  });
};

var util_getNodeKey = function getNodeKey(key, data) {
  if (!key) return data[NODE_KEY];
  return data[key];
};

var findNearestComponent = function findNearestComponent(element, componentName) {
  var target = element;
  while (target && target.tagName !== 'BODY') {
    if (target.__vue__ && target.__vue__.$options.name === componentName) {
      return target.__vue__;
    }
    target = target.parentNode;
  }
  return null;
};
// CONCATENATED MODULE: ./packages/tree/src/model/node.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function node_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var getChildState = function getChildState(node) {
  var all = true;
  var none = true;
  var allWithoutDisable = true;
  for (var i = 0, j = node.length; i < j; i++) {
    var n = node[i];
    if (n.checked !== true || n.indeterminate) {
      all = false;
      if (!n.disabled) {
        allWithoutDisable = false;
      }
    }
    if (n.checked !== false || n.indeterminate) {
      none = false;
    }
  }

  return { all: all, none: none, allWithoutDisable: allWithoutDisable, half: !all && !none };
};

var reInitChecked = function reInitChecked(node) {
  if (node.childNodes.length === 0) return;

  var _getChildState = getChildState(node.childNodes),
      all = _getChildState.all,
      none = _getChildState.none,
      half = _getChildState.half;

  if (all) {
    node.checked = true;
    node.indeterminate = false;
  } else if (half) {
    node.checked = false;
    node.indeterminate = true;
  } else if (none) {
    node.checked = false;
    node.indeterminate = false;
  }

  var parent = node.parent;
  if (!parent || parent.level === 0) return;

  if (!node.store.checkStrictly) {
    reInitChecked(parent);
  }
};

var getPropertyFromData = function getPropertyFromData(node, prop) {
  var props = node.store.props;
  var data = node.data || {};
  var config = props[prop];

  if (typeof config === 'function') {
    return config(data, node);
  } else if (typeof config === 'string') {
    return data[config];
  } else if (typeof config === 'undefined') {
    var dataProp = data[prop];
    return dataProp === undefined ? '' : dataProp;
  }
};

var nodeIdSeed = 0;

var node_Node = function () {
  function Node(options) {
    node_classCallCheck(this, Node);

    this.id = nodeIdSeed++;
    this.text = null;
    this.checked = false;
    this.indeterminate = false;
    this.data = null;
    this.expanded = false;
    this.parent = null;
    this.visible = true;
    this.isCurrent = false;

    for (var name in options) {
      if (options.hasOwnProperty(name)) {
        this[name] = options[name];
      }
    }

    // internal
    this.level = 0;
    this.loaded = false;
    this.childNodes = [];
    this.loading = false;

    if (this.parent) {
      this.level = this.parent.level + 1;
    }

    var store = this.store;
    if (!store) {
      throw new Error('[Node]store is required!');
    }
    store.registerNode(this);

    var props = store.props;
    if (props && typeof props.isLeaf !== 'undefined') {
      var isLeaf = getPropertyFromData(this, 'isLeaf');
      if (typeof isLeaf === 'boolean') {
        this.isLeafByUser = isLeaf;
      }
    }

    if (store.lazy !== true && this.data) {
      this.setData(this.data);

      if (store.defaultExpandAll) {
        this.expanded = true;
      }
    } else if (this.level > 0 && store.lazy && store.defaultExpandAll) {
      this.expand();
    }
    if (!Array.isArray(this.data)) {
      markNodeData(this, this.data);
    }
    if (!this.data) return;
    var defaultExpandedKeys = store.defaultExpandedKeys;
    var key = store.key;
    if (key && defaultExpandedKeys && defaultExpandedKeys.indexOf(this.key) !== -1) {
      this.expand(null, store.autoExpandParent);
    }

    if (key && store.currentNodeKey !== undefined && this.key === store.currentNodeKey) {
      store.currentNode = this;
      store.currentNode.isCurrent = true;
    }

    if (store.lazy) {
      store._initDefaultCheckedNode(this);
    }

    this.updateLeafState();
  }

  Node.prototype.setData = function setData(data) {
    if (!Array.isArray(data)) {
      markNodeData(this, data);
    }

    this.data = data;
    this.childNodes = [];

    var children = void 0;
    if (this.level === 0 && this.data instanceof Array) {
      children = this.data;
    } else {
      children = getPropertyFromData(this, 'children') || [];
    }

    for (var i = 0, j = children.length; i < j; i++) {
      this.insertChild({ data: children[i] });
    }
  };

  Node.prototype.contains = function contains(target) {
    var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var walk = function walk(parent) {
      var children = parent.childNodes || [];
      var result = false;
      for (var i = 0, j = children.length; i < j; i++) {
        var child = children[i];
        if (child === target || deep && walk(child)) {
          result = true;
          break;
        }
      }
      return result;
    };

    return walk(this);
  };

  Node.prototype.remove = function remove() {
    var parent = this.parent;
    if (parent) {
      parent.removeChild(this);
    }
  };

  Node.prototype.insertChild = function insertChild(child, index, batch) {
    if (!child) throw new Error('insertChild error: child is required.');

    if (!(child instanceof Node)) {
      if (!batch) {
        var children = this.getChildren(true);
        if (children.indexOf(child.data) === -1) {
          if (typeof index === 'undefined' || index < 0) {
            children.push(child.data);
          } else {
            children.splice(index, 0, child.data);
          }
        }
      }
      merge_default()(child, {
        parent: this,
        store: this.store
      });
      child = new Node(child);
    }

    child.level = this.level + 1;

    if (typeof index === 'undefined' || index < 0) {
      this.childNodes.push(child);
    } else {
      this.childNodes.splice(index, 0, child);
    }

    this.updateLeafState();
  };

  Node.prototype.insertBefore = function insertBefore(child, ref) {
    var index = void 0;
    if (ref) {
      index = this.childNodes.indexOf(ref);
    }
    this.insertChild(child, index);
  };

  Node.prototype.insertAfter = function insertAfter(child, ref) {
    var index = void 0;
    if (ref) {
      index = this.childNodes.indexOf(ref);
      if (index !== -1) index += 1;
    }
    this.insertChild(child, index);
  };

  Node.prototype.removeChild = function removeChild(child) {
    var children = this.getChildren() || [];
    var dataIndex = children.indexOf(child.data);
    if (dataIndex > -1) {
      children.splice(dataIndex, 1);
    }

    var index = this.childNodes.indexOf(child);

    if (index > -1) {
      this.store && this.store.deregisterNode(child);
      child.parent = null;
      this.childNodes.splice(index, 1);
    }

    this.updateLeafState();
  };

  Node.prototype.removeChildByData = function removeChildByData(data) {
    var targetNode = null;

    for (var i = 0; i < this.childNodes.length; i++) {
      if (this.childNodes[i].data === data) {
        targetNode = this.childNodes[i];
        break;
      }
    }

    if (targetNode) {
      this.removeChild(targetNode);
    }
  };

  Node.prototype.expand = function expand(callback, expandParent) {
    var _this = this;

    var done = function done() {
      if (expandParent) {
        var parent = _this.parent;
        while (parent.level > 0) {
          parent.expanded = true;
          parent = parent.parent;
        }
      }
      _this.expanded = true;
      if (callback) callback();
    };

    if (this.shouldLoadData()) {
      this.loadData(function (data) {
        if (data instanceof Array) {
          if (_this.checked) {
            _this.setChecked(true, true);
          } else if (!_this.store.checkStrictly) {
            reInitChecked(_this);
          }
          done();
        }
      });
    } else {
      done();
    }
  };

  Node.prototype.doCreateChildren = function doCreateChildren(array) {
    var _this2 = this;

    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    array.forEach(function (item) {
      _this2.insertChild(merge_default()({ data: item }, defaultProps), undefined, true);
    });
  };

  Node.prototype.collapse = function collapse() {
    this.expanded = false;
  };

  Node.prototype.shouldLoadData = function shouldLoadData() {
    return this.store.lazy === true && this.store.load && !this.loaded;
  };

  Node.prototype.updateLeafState = function updateLeafState() {
    if (this.store.lazy === true && this.loaded !== true && typeof this.isLeafByUser !== 'undefined') {
      this.isLeaf = this.isLeafByUser;
      return;
    }
    var childNodes = this.childNodes;
    if (!this.store.lazy || this.store.lazy === true && this.loaded === true) {
      this.isLeaf = !childNodes || childNodes.length === 0;
      return;
    }
    this.isLeaf = false;
  };

  Node.prototype.setChecked = function setChecked(value, deep, recursion, passValue) {
    var _this3 = this;

    this.indeterminate = value === 'half';
    this.checked = value === true;

    if (this.store.checkStrictly) return;

    if (!(this.shouldLoadData() && !this.store.checkDescendants)) {
      var _getChildState2 = getChildState(this.childNodes),
          all = _getChildState2.all,
          allWithoutDisable = _getChildState2.allWithoutDisable;

      if (!this.isLeaf && !all && allWithoutDisable) {
        this.checked = false;
        value = false;
      }

      var handleDescendants = function handleDescendants() {
        if (deep) {
          var childNodes = _this3.childNodes;
          for (var i = 0, j = childNodes.length; i < j; i++) {
            var child = childNodes[i];
            passValue = passValue || value !== false;
            var isCheck = child.disabled ? child.checked : passValue;
            child.setChecked(isCheck, deep, true, passValue);
          }

          var _getChildState3 = getChildState(childNodes),
              half = _getChildState3.half,
              _all = _getChildState3.all;

          if (!_all) {
            _this3.checked = _all;
            _this3.indeterminate = half;
          }
        }
      };

      if (this.shouldLoadData()) {
        // Only work on lazy load data.
        this.loadData(function () {
          handleDescendants();
          reInitChecked(_this3);
        }, {
          checked: value !== false
        });
        return;
      } else {
        handleDescendants();
      }
    }

    var parent = this.parent;
    if (!parent || parent.level === 0) return;

    if (!recursion) {
      reInitChecked(parent);
    }
  };

  Node.prototype.getChildren = function getChildren() {
    var forceInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    // this is data
    if (this.level === 0) return this.data;
    var data = this.data;
    if (!data) return null;

    var props = this.store.props;
    var children = 'children';
    if (props) {
      children = props.children || 'children';
    }

    if (data[children] === undefined) {
      data[children] = null;
    }

    if (forceInit && !data[children]) {
      data[children] = [];
    }

    return data[children];
  };

  Node.prototype.updateChildren = function updateChildren() {
    var _this4 = this;

    var newData = this.getChildren() || [];
    var oldData = this.childNodes.map(function (node) {
      return node.data;
    });

    var newDataMap = {};
    var newNodes = [];

    newData.forEach(function (item, index) {
      var key = item[NODE_KEY];
      var isNodeExists = !!key && Object(util_["arrayFindIndex"])(oldData, function (data) {
        return data[NODE_KEY] === key;
      }) >= 0;
      if (isNodeExists) {
        newDataMap[key] = { index: index, data: item };
      } else {
        newNodes.push({ index: index, data: item });
      }
    });

    if (!this.store.lazy) {
      oldData.forEach(function (item) {
        if (!newDataMap[item[NODE_KEY]]) _this4.removeChildByData(item);
      });
    }

    newNodes.forEach(function (_ref) {
      var index = _ref.index,
          data = _ref.data;

      _this4.insertChild({ data: data }, index);
    });

    this.updateLeafState();
  };

  Node.prototype.loadData = function loadData(callback) {
    var _this5 = this;

    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (this.store.lazy === true && this.store.load && !this.loaded && (!this.loading || Object.keys(defaultProps).length)) {
      this.loading = true;

      var resolve = function resolve(children) {
        _this5.loaded = true;
        _this5.loading = false;
        _this5.childNodes = [];

        _this5.doCreateChildren(children, defaultProps);

        _this5.updateLeafState();
        if (callback) {
          callback.call(_this5, children);
        }
      };

      this.store.load(this, resolve);
    } else {
      if (callback) {
        callback.call(this);
      }
    }
  };

  _createClass(Node, [{
    key: 'label',
    get: function get() {
      return getPropertyFromData(this, 'label');
    }
  }, {
    key: 'key',
    get: function get() {
      var nodeKey = this.store.key;
      if (this.data) return this.data[nodeKey];
      return null;
    }
  }, {
    key: 'disabled',
    get: function get() {
      return getPropertyFromData(this, 'disabled');
    }
  }, {
    key: 'nextSibling',
    get: function get() {
      var parent = this.parent;
      if (parent) {
        var index = parent.childNodes.indexOf(this);
        if (index > -1) {
          return parent.childNodes[index + 1];
        }
      }
      return null;
    }
  }, {
    key: 'previousSibling',
    get: function get() {
      var parent = this.parent;
      if (parent) {
        var index = parent.childNodes.indexOf(this);
        if (index > -1) {
          return index > 0 ? parent.childNodes[index - 1] : null;
        }
      }
      return null;
    }
  }]);

  return Node;
}();

/* harmony default export */ var model_node = (node_Node);
// CONCATENATED MODULE: ./packages/tree/src/model/tree-store.js
var tree_store_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function tree_store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var tree_store_TreeStore = function () {
  function TreeStore(options) {
    var _this = this;

    tree_store_classCallCheck(this, TreeStore);

    this.currentNode = null;
    this.currentNodeKey = null;

    for (var option in options) {
      if (options.hasOwnProperty(option)) {
        this[option] = options[option];
      }
    }

    this.nodesMap = {};

    this.root = new model_node({
      data: this.data,
      store: this
    });

    if (this.lazy && this.load) {
      var loadFn = this.load;
      loadFn(this.root, function (data) {
        _this.root.doCreateChildren(data);
        _this._initDefaultCheckedNodes();
      });
    } else {
      this._initDefaultCheckedNodes();
    }
  }

  TreeStore.prototype.filter = function filter(value) {
    var filterNodeMethod = this.filterNodeMethod;
    var lazy = this.lazy;
    var traverse = function traverse(node) {
      var childNodes = node.root ? node.root.childNodes : node.childNodes;

      childNodes.forEach(function (child) {
        child.visible = filterNodeMethod.call(child, value, child.data, child);

        traverse(child);
      });

      if (!node.visible && childNodes.length) {
        var allHidden = true;
        allHidden = !childNodes.some(function (child) {
          return child.visible;
        });

        if (node.root) {
          node.root.visible = allHidden === false;
        } else {
          node.visible = allHidden === false;
        }
      }
      if (!value) return;

      if (node.visible && !node.isLeaf && !lazy) node.expand();
    };

    traverse(this);
  };

  TreeStore.prototype.setData = function setData(newVal) {
    var instanceChanged = newVal !== this.root.data;
    if (instanceChanged) {
      this.root.setData(newVal);
      this._initDefaultCheckedNodes();
    } else {
      this.root.updateChildren();
    }
  };

  TreeStore.prototype.getNode = function getNode(data) {
    if (data instanceof model_node) return data;
    var key = (typeof data === 'undefined' ? 'undefined' : tree_store_typeof(data)) !== 'object' ? data : util_getNodeKey(this.key, data);
    return this.nodesMap[key] || null;
  };

  TreeStore.prototype.insertBefore = function insertBefore(data, refData) {
    var refNode = this.getNode(refData);
    refNode.parent.insertBefore({ data: data }, refNode);
  };

  TreeStore.prototype.insertAfter = function insertAfter(data, refData) {
    var refNode = this.getNode(refData);
    refNode.parent.insertAfter({ data: data }, refNode);
  };

  TreeStore.prototype.remove = function remove(data) {
    var node = this.getNode(data);

    if (node && node.parent) {
      if (node === this.currentNode) {
        this.currentNode = null;
      }
      node.parent.removeChild(node);
    }
  };

  TreeStore.prototype.append = function append(data, parentData) {
    var parentNode = parentData ? this.getNode(parentData) : this.root;

    if (parentNode) {
      parentNode.insertChild({ data: data });
    }
  };

  TreeStore.prototype._initDefaultCheckedNodes = function _initDefaultCheckedNodes() {
    var _this2 = this;

    var defaultCheckedKeys = this.defaultCheckedKeys || [];
    var nodesMap = this.nodesMap;

    defaultCheckedKeys.forEach(function (checkedKey) {
      var node = nodesMap[checkedKey];

      if (node) {
        node.setChecked(true, !_this2.checkStrictly);
      }
    });
  };

  TreeStore.prototype._initDefaultCheckedNode = function _initDefaultCheckedNode(node) {
    var defaultCheckedKeys = this.defaultCheckedKeys || [];

    if (defaultCheckedKeys.indexOf(node.key) !== -1) {
      node.setChecked(true, !this.checkStrictly);
    }
  };

  TreeStore.prototype.setDefaultCheckedKey = function setDefaultCheckedKey(newVal) {
    if (newVal !== this.defaultCheckedKeys) {
      this.defaultCheckedKeys = newVal;
      this._initDefaultCheckedNodes();
    }
  };

  TreeStore.prototype.registerNode = function registerNode(node) {
    var key = this.key;
    if (!key || !node || !node.data) return;

    var nodeKey = node.key;
    if (nodeKey !== undefined) this.nodesMap[node.key] = node;
  };

  TreeStore.prototype.deregisterNode = function deregisterNode(node) {
    var _this3 = this;

    var key = this.key;
    if (!key || !node || !node.data) return;

    node.childNodes.forEach(function (child) {
      _this3.deregisterNode(child);
    });

    delete this.nodesMap[node.key];
  };

  TreeStore.prototype.getCheckedNodes = function getCheckedNodes() {
    var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var includeHalfChecked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var checkedNodes = [];
    var traverse = function traverse(node) {
      var childNodes = node.root ? node.root.childNodes : node.childNodes;

      childNodes.forEach(function (child) {
        if ((child.checked || includeHalfChecked && child.indeterminate) && (!leafOnly || leafOnly && child.isLeaf)) {
          checkedNodes.push(child.data);
        }

        traverse(child);
      });
    };

    traverse(this);

    return checkedNodes;
  };

  TreeStore.prototype.getCheckedKeys = function getCheckedKeys() {
    var _this4 = this;

    var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return this.getCheckedNodes(leafOnly).map(function (data) {
      return (data || {})[_this4.key];
    });
  };

  TreeStore.prototype.getHalfCheckedNodes = function getHalfCheckedNodes() {
    var nodes = [];
    var traverse = function traverse(node) {
      var childNodes = node.root ? node.root.childNodes : node.childNodes;

      childNodes.forEach(function (child) {
        if (child.indeterminate) {
          nodes.push(child.data);
        }

        traverse(child);
      });
    };

    traverse(this);

    return nodes;
  };

  TreeStore.prototype.getHalfCheckedKeys = function getHalfCheckedKeys() {
    var _this5 = this;

    return this.getHalfCheckedNodes().map(function (data) {
      return (data || {})[_this5.key];
    });
  };

  TreeStore.prototype._getAllNodes = function _getAllNodes() {
    var allNodes = [];
    var nodesMap = this.nodesMap;
    for (var nodeKey in nodesMap) {
      if (nodesMap.hasOwnProperty(nodeKey)) {
        allNodes.push(nodesMap[nodeKey]);
      }
    }

    return allNodes;
  };

  TreeStore.prototype.updateChildren = function updateChildren(key, data) {
    var node = this.nodesMap[key];
    if (!node) return;
    var childNodes = node.childNodes;
    for (var i = childNodes.length - 1; i >= 0; i--) {
      var child = childNodes[i];
      this.remove(child.data);
    }
    for (var _i = 0, j = data.length; _i < j; _i++) {
      var _child = data[_i];
      this.append(_child, node.data);
    }
  };

  TreeStore.prototype._setCheckedKeys = function _setCheckedKeys(key) {
    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var checkedKeys = arguments[2];

    var allNodes = this._getAllNodes().sort(function (a, b) {
      return b.level - a.level;
    });
    var cache = Object.create(null);
    var keys = Object.keys(checkedKeys);
    allNodes.forEach(function (node) {
      return node.setChecked(false, false);
    });
    for (var i = 0, j = allNodes.length; i < j; i++) {
      var node = allNodes[i];
      var nodeKey = node.data[key].toString();
      var checked = keys.indexOf(nodeKey) > -1;
      if (!checked) {
        if (node.checked && !cache[nodeKey]) {
          node.setChecked(false, false);
        }
        continue;
      }

      var parent = node.parent;
      while (parent && parent.level > 0) {
        cache[parent.data[key]] = true;
        parent = parent.parent;
      }

      if (node.isLeaf || this.checkStrictly) {
        node.setChecked(true, false);
        continue;
      }
      node.setChecked(true, true);

      if (leafOnly) {
        (function () {
          node.setChecked(false, false);
          var traverse = function traverse(node) {
            var childNodes = node.childNodes;
            childNodes.forEach(function (child) {
              if (!child.isLeaf) {
                child.setChecked(false, false);
              }
              traverse(child);
            });
          };
          traverse(node);
        })();
      }
    }
  };

  TreeStore.prototype.setCheckedNodes = function setCheckedNodes(array) {
    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var key = this.key;
    var checkedKeys = {};
    array.forEach(function (item) {
      checkedKeys[(item || {})[key]] = true;
    });

    this._setCheckedKeys(key, leafOnly, checkedKeys);
  };

  TreeStore.prototype.setCheckedKeys = function setCheckedKeys(keys) {
    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    this.defaultCheckedKeys = keys;
    var key = this.key;
    var checkedKeys = {};
    keys.forEach(function (key) {
      checkedKeys[key] = true;
    });

    this._setCheckedKeys(key, leafOnly, checkedKeys);
  };

  TreeStore.prototype.setDefaultExpandedKeys = function setDefaultExpandedKeys(keys) {
    var _this6 = this;

    keys = keys || [];
    this.defaultExpandedKeys = keys;

    keys.forEach(function (key) {
      var node = _this6.getNode(key);
      if (node) node.expand(null, _this6.autoExpandParent);
    });
  };

  TreeStore.prototype.setChecked = function setChecked(data, checked, deep) {
    var node = this.getNode(data);

    if (node) {
      node.setChecked(!!checked, deep);
    }
  };

  TreeStore.prototype.getCurrentNode = function getCurrentNode() {
    return this.currentNode;
  };

  TreeStore.prototype.setCurrentNode = function setCurrentNode(currentNode) {
    var prevCurrentNode = this.currentNode;
    if (prevCurrentNode) {
      prevCurrentNode.isCurrent = false;
    }
    this.currentNode = currentNode;
    this.currentNode.isCurrent = true;
  };

  TreeStore.prototype.setUserCurrentNode = function setUserCurrentNode(node) {
    var key = node[this.key];
    var currNode = this.nodesMap[key];
    this.setCurrentNode(currNode);
  };

  TreeStore.prototype.setCurrentNodeKey = function setCurrentNodeKey(key) {
    if (key === null || key === undefined) {
      this.currentNode && (this.currentNode.isCurrent = false);
      this.currentNode = null;
      return;
    }
    var node = this.getNode(key);
    if (node) {
      this.setCurrentNode(node);
    }
  };

  return TreeStore;
}();

/* harmony default export */ var tree_store = (tree_store_TreeStore);
;
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&
var tree_nodevue_type_template_id_3ba3ef0e_render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.node.visible,
          expression: "node.visible"
        }
      ],
      ref: "node",
      staticClass: "el-tree-node",
      class: {
        "is-expanded": _vm.expanded,
        "is-current": _vm.node.isCurrent,
        "is-hidden": !_vm.node.visible,
        "is-focusable": !_vm.node.disabled,
        "is-checked": !_vm.node.disabled && _vm.node.checked
      },
      attrs: {
        role: "treeitem",
        tabindex: "-1",
        "aria-expanded": _vm.expanded,
        "aria-disabled": _vm.node.disabled,
        "aria-checked": _vm.node.checked,
        draggable: _vm.tree.draggable
      },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.handleClick($event)
        },
        contextmenu: function($event) {
          return this$1.handleContextMenu($event)
        },
        dragstart: function($event) {
          $event.stopPropagation()
          return _vm.handleDragStart($event)
        },
        dragover: function($event) {
          $event.stopPropagation()
          return _vm.handleDragOver($event)
        },
        dragend: function($event) {
          $event.stopPropagation()
          return _vm.handleDragEnd($event)
        },
        drop: function($event) {
          $event.stopPropagation()
          return _vm.handleDrop($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "el-tree-node__content",
          style: {
            "padding-left": (_vm.node.level - 1) * _vm.tree.indent + "px"
          }
        },
        [
          _c("span", {
            class: [
              {
                "is-leaf": _vm.node.isLeaf,
                expanded: !_vm.node.isLeaf && _vm.expanded
              },
              "el-tree-node__expand-icon",
              _vm.tree.iconClass ? _vm.tree.iconClass : "el-icon-caret-right"
            ],
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.handleExpandIconClick($event)
              }
            }
          }),
          _vm.showCheckbox
            ? _c("el-checkbox", {
                attrs: {
                  indeterminate: _vm.node.indeterminate,
                  disabled: !!_vm.node.disabled
                },
                on: { change: _vm.handleCheckChange },
                nativeOn: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                },
                model: {
                  value: _vm.node.checked,
                  callback: function($$v) {
                    _vm.$set(_vm.node, "checked", $$v)
                  },
                  expression: "node.checked"
                }
              })
            : _vm._e(),
          _vm.node.loading
            ? _c("span", {
                staticClass: "el-tree-node__loading-icon el-icon-loading"
              })
            : _vm._e(),
          _c("node-content", { attrs: { node: _vm.node } })
        ],
        1
      ),
      _c("el-collapse-transition", [
        !_vm.renderAfterExpand || _vm.childNodeRendered
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "el-tree-node__children",
                attrs: { role: "group", "aria-expanded": _vm.expanded }
              },
              _vm._l(_vm.node.childNodes, function(child) {
                return _c("el-tree-node", {
                  key: _vm.getNodeKey(child),
                  attrs: {
                    "render-content": _vm.renderContent,
                    "render-after-expand": _vm.renderAfterExpand,
                    "show-checkbox": _vm.showCheckbox,
                    node: child
                  },
                  on: { "node-expand": _vm.handleChildNodeExpand }
                })
              }),
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns = []
tree_nodevue_type_template_id_3ba3ef0e_render._withStripped = true


// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var tree_nodevue_type_script_lang_js_ = ({
  name: 'ElTreeNode',

  componentName: 'ElTreeNode',

  mixins: [emitter_default.a],

  props: {
    node: {
      default: function _default() {
        return {};
      }
    },
    props: {},
    renderContent: Function,
    renderAfterExpand: {
      type: Boolean,
      default: true
    },
    showCheckbox: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ElCollapseTransition: collapse_transition_default.a,
    ElCheckbox: checkbox_default.a,
    NodeContent: {
      props: {
        node: {
          required: true
        }
      },
      render: function render(h) {
        var parent = this.$parent;
        var tree = parent.tree;
        var node = this.node;
        var data = node.data,
            store = node.store;

        return parent.renderContent ? parent.renderContent.call(parent._renderProxy, h, { _self: tree.$vnode.context, node: node, data: data, store: store }) : tree.$scopedSlots.default ? tree.$scopedSlots.default({ node: node, data: data }) : h(
          'span',
          { 'class': 'el-tree-node__label' },
          [node.label]
        );
      }
    }
  },

  data: function data() {
    return {
      tree: null,
      expanded: false,
      childNodeRendered: false,
      oldChecked: null,
      oldIndeterminate: null
    };
  },


  watch: {
    'node.indeterminate': function nodeIndeterminate(val) {
      this.handleSelectChange(this.node.checked, val);
    },
    'node.checked': function nodeChecked(val) {
      this.handleSelectChange(val, this.node.indeterminate);
    },
    'node.expanded': function nodeExpanded(val) {
      var _this = this;

      this.$nextTick(function () {
        return _this.expanded = val;
      });
      if (val) {
        this.childNodeRendered = true;
      }
    }
  },

  methods: {
    getNodeKey: function getNodeKey(node) {
      return util_getNodeKey(this.tree.nodeKey, node.data);
    },
    handleSelectChange: function handleSelectChange(checked, indeterminate) {
      if (this.oldChecked !== checked && this.oldIndeterminate !== indeterminate) {
        this.tree.$emit('check-change', this.node.data, checked, indeterminate);
      }
      this.oldChecked = checked;
      this.indeterminate = indeterminate;
    },
    handleClick: function handleClick() {
      var store = this.tree.store;
      store.setCurrentNode(this.node);
      this.tree.$emit('current-change', store.currentNode ? store.currentNode.data : null, store.currentNode);
      this.tree.currentNode = this;
      if (this.tree.expandOnClickNode) {
        this.handleExpandIconClick();
      }
      if (this.tree.checkOnClickNode && !this.node.disabled) {
        this.handleCheckChange(null, {
          target: { checked: !this.node.checked }
        });
      }
      this.tree.$emit('node-click', this.node.data, this.node, this);
    },
    handleContextMenu: function handleContextMenu(event) {
      if (this.tree._events['node-contextmenu'] && this.tree._events['node-contextmenu'].length > 0) {
        event.stopPropagation();
        event.preventDefault();
      }
      this.tree.$emit('node-contextmenu', event, this.node.data, this.node, this);
    },
    handleExpandIconClick: function handleExpandIconClick() {
      if (this.node.isLeaf) return;
      if (this.expanded) {
        this.tree.$emit('node-collapse', this.node.data, this.node, this);
        this.node.collapse();
      } else {
        this.node.expand();
        this.$emit('node-expand', this.node.data, this.node, this);
      }
    },
    handleCheckChange: function handleCheckChange(value, ev) {
      var _this2 = this;

      this.node.setChecked(ev.target.checked, !this.tree.checkStrictly);
      this.$nextTick(function () {
        var store = _this2.tree.store;
        _this2.tree.$emit('check', _this2.node.data, {
          checkedNodes: store.getCheckedNodes(),
          checkedKeys: store.getCheckedKeys(),
          halfCheckedNodes: store.getHalfCheckedNodes(),
          halfCheckedKeys: store.getHalfCheckedKeys()
        });
      });
    },
    handleChildNodeExpand: function handleChildNodeExpand(nodeData, node, instance) {
      this.broadcast('ElTreeNode', 'tree-node-expand', node);
      this.tree.$emit('node-expand', nodeData, node, instance);
    },
    handleDragStart: function handleDragStart(event) {
      if (!this.tree.draggable) return;
      this.tree.$emit('tree-node-drag-start', event, this);
    },
    handleDragOver: function handleDragOver(event) {
      if (!this.tree.draggable) return;
      this.tree.$emit('tree-node-drag-over', event, this);
      event.preventDefault();
    },
    handleDrop: function handleDrop(event) {
      event.preventDefault();
    },
    handleDragEnd: function handleDragEnd(event) {
      if (!this.tree.draggable) return;
      this.tree.$emit('tree-node-drag-end', event, this);
    }
  },

  created: function created() {
    var _this3 = this;

    var parent = this.$parent;

    if (parent.isTree) {
      this.tree = parent;
    } else {
      this.tree = parent.tree;
    }

    var tree = this.tree;
    if (!tree) {
      console.warn('Can not find node\'s tree.');
    }

    var props = tree.props || {};
    var childrenKey = props['children'] || 'children';

    this.$watch('node.data.' + childrenKey, function () {
      _this3.node.updateChildren();
    });

    if (this.node.expanded) {
      this.expanded = true;
      this.childNodeRendered = true;
    }

    if (this.tree.accordion) {
      this.$on('tree-node-expand', function (node) {
        if (_this3.node !== node) {
          _this3.node.collapse();
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tree_nodevue_type_script_lang_js_ = (tree_nodevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue





/* normalize component */

var tree_node_component = normalizeComponent(
  src_tree_nodevue_type_script_lang_js_,
  tree_nodevue_type_template_id_3ba3ef0e_render,
  tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var tree_node_api; }
tree_node_component.options.__file = "packages/tree/src/tree-node.vue"
/* harmony default export */ var tree_node = (tree_node_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var treevue_type_script_lang_js_ = ({
  name: 'ElTree',

  mixins: [emitter_default.a],

  components: {
    ElTreeNode: tree_node
  },

  data: function data() {
    return {
      store: null,
      root: null,
      currentNode: null,
      treeItems: null,
      checkboxItems: [],
      dragState: {
        showDropIndicator: false,
        draggingNode: null,
        dropNode: null,
        allowDrop: true
      }
    };
  },


  props: {
    data: {
      type: Array
    },
    emptyText: {
      type: String,
      default: function _default() {
        return Object(lib_locale_["t"])('el.tree.emptyText');
      }
    },
    renderAfterExpand: {
      type: Boolean,
      default: true
    },
    nodeKey: String,
    checkStrictly: Boolean,
    defaultExpandAll: Boolean,
    expandOnClickNode: {
      type: Boolean,
      default: true
    },
    checkOnClickNode: Boolean,
    checkDescendants: {
      type: Boolean,
      default: false
    },
    autoExpandParent: {
      type: Boolean,
      default: true
    },
    defaultCheckedKeys: Array,
    defaultExpandedKeys: Array,
    currentNodeKey: [String, Number],
    renderContent: Function,
    showCheckbox: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    allowDrag: Function,
    allowDrop: Function,
    props: {
      default: function _default() {
        return {
          children: 'children',
          label: 'label',
          disabled: 'disabled'
        };
      }
    },
    lazy: {
      type: Boolean,
      default: false
    },
    highlightCurrent: Boolean,
    load: Function,
    filterNodeMethod: Function,
    accordion: Boolean,
    indent: {
      type: Number,
      default: 18
    },
    iconClass: String
  },

  computed: {
    children: {
      set: function set(value) {
        this.data = value;
      },
      get: function get() {
        return this.data;
      }
    },

    treeItemArray: function treeItemArray() {
      return Array.prototype.slice.call(this.treeItems);
    },
    isEmpty: function isEmpty() {
      var childNodes = this.root.childNodes;

      return !childNodes || childNodes.length === 0 || childNodes.every(function (_ref) {
        var visible = _ref.visible;
        return !visible;
      });
    }
  },

  watch: {
    defaultCheckedKeys: function defaultCheckedKeys(newVal) {
      this.store.setDefaultCheckedKey(newVal);
    },
    defaultExpandedKeys: function defaultExpandedKeys(newVal) {
      this.store.defaultExpandedKeys = newVal;
      this.store.setDefaultExpandedKeys(newVal);
    },
    data: function data(newVal) {
      this.store.setData(newVal);
    },
    checkboxItems: function checkboxItems(val) {
      Array.prototype.forEach.call(val, function (checkbox) {
        checkbox.setAttribute('tabindex', -1);
      });
    },
    checkStrictly: function checkStrictly(newVal) {
      this.store.checkStrictly = newVal;
    }
  },

  methods: {
    filter: function filter(value) {
      if (!this.filterNodeMethod) throw new Error('[Tree] filterNodeMethod is required when filter');
      this.store.filter(value);
    },
    getNodeKey: function getNodeKey(node) {
      return util_getNodeKey(this.nodeKey, node.data);
    },
    getNodePath: function getNodePath(data) {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in getNodePath');
      var node = this.store.getNode(data);
      if (!node) return [];
      var path = [node.data];
      var parent = node.parent;
      while (parent && parent !== this.root) {
        path.push(parent.data);
        parent = parent.parent;
      }
      return path.reverse();
    },
    getCheckedNodes: function getCheckedNodes(leafOnly, includeHalfChecked) {
      return this.store.getCheckedNodes(leafOnly, includeHalfChecked);
    },
    getCheckedKeys: function getCheckedKeys(leafOnly) {
      return this.store.getCheckedKeys(leafOnly);
    },
    getCurrentNode: function getCurrentNode() {
      var currentNode = this.store.getCurrentNode();
      return currentNode ? currentNode.data : null;
    },
    getCurrentKey: function getCurrentKey() {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in getCurrentKey');
      var currentNode = this.getCurrentNode();
      return currentNode ? currentNode[this.nodeKey] : null;
    },
    setCheckedNodes: function setCheckedNodes(nodes, leafOnly) {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedNodes');
      this.store.setCheckedNodes(nodes, leafOnly);
    },
    setCheckedKeys: function setCheckedKeys(keys, leafOnly) {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedKeys');
      this.store.setCheckedKeys(keys, leafOnly);
    },
    setChecked: function setChecked(data, checked, deep) {
      this.store.setChecked(data, checked, deep);
    },
    getHalfCheckedNodes: function getHalfCheckedNodes() {
      return this.store.getHalfCheckedNodes();
    },
    getHalfCheckedKeys: function getHalfCheckedKeys() {
      return this.store.getHalfCheckedKeys();
    },
    setCurrentNode: function setCurrentNode(node) {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCurrentNode');
      this.store.setUserCurrentNode(node);
    },
    setCurrentKey: function setCurrentKey(key) {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCurrentKey');
      this.store.setCurrentNodeKey(key);
    },
    getNode: function getNode(data) {
      return this.store.getNode(data);
    },
    remove: function remove(data) {
      this.store.remove(data);
    },
    append: function append(data, parentNode) {
      this.store.append(data, parentNode);
    },
    insertBefore: function insertBefore(data, refNode) {
      this.store.insertBefore(data, refNode);
    },
    insertAfter: function insertAfter(data, refNode) {
      this.store.insertAfter(data, refNode);
    },
    handleNodeExpand: function handleNodeExpand(nodeData, node, instance) {
      this.broadcast('ElTreeNode', 'tree-node-expand', node);
      this.$emit('node-expand', nodeData, node, instance);
    },
    updateKeyChildren: function updateKeyChildren(key, data) {
      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in updateKeyChild');
      this.store.updateChildren(key, data);
    },
    initTabIndex: function initTabIndex() {
      this.treeItems = this.$el.querySelectorAll('.is-focusable[role=treeitem]');
      this.checkboxItems = this.$el.querySelectorAll('input[type=checkbox]');
      var checkedItem = this.$el.querySelectorAll('.is-checked[role=treeitem]');
      if (checkedItem.length) {
        checkedItem[0].setAttribute('tabindex', 0);
        return;
      }
      this.treeItems[0] && this.treeItems[0].setAttribute('tabindex', 0);
    },
    handleKeydown: function handleKeydown(ev) {
      var currentItem = ev.target;
      if (currentItem.className.indexOf('el-tree-node') === -1) return;
      var keyCode = ev.keyCode;
      this.treeItems = this.$el.querySelectorAll('.is-focusable[role=treeitem]');
      var currentIndex = this.treeItemArray.indexOf(currentItem);
      var nextIndex = void 0;
      if ([38, 40].indexOf(keyCode) > -1) {
        // up、down
        ev.preventDefault();
        if (keyCode === 38) {
          // up
          nextIndex = currentIndex !== 0 ? currentIndex - 1 : 0;
        } else {
          nextIndex = currentIndex < this.treeItemArray.length - 1 ? currentIndex + 1 : 0;
        }
        this.treeItemArray[nextIndex].focus(); // 选中
      }
      if ([37, 39].indexOf(keyCode) > -1) {
        // left、right 展开
        ev.preventDefault();
        currentItem.click(); // 选中
      }
      var hasInput = currentItem.querySelector('[type="checkbox"]');
      if ([13, 32].indexOf(keyCode) > -1 && hasInput) {
        // space enter选中checkbox
        ev.preventDefault();
        hasInput.click();
      }
    }
  },

  created: function created() {
    var _this = this;

    this.isTree = true;

    this.store = new tree_store({
      key: this.nodeKey,
      data: this.data,
      lazy: this.lazy,
      props: this.props,
      load: this.load,
      currentNodeKey: this.currentNodeKey,
      checkStrictly: this.checkStrictly,
      checkDescendants: this.checkDescendants,
      defaultCheckedKeys: this.defaultCheckedKeys,
      defaultExpandedKeys: this.defaultExpandedKeys,
      autoExpandParent: this.autoExpandParent,
      defaultExpandAll: this.defaultExpandAll,
      filterNodeMethod: this.filterNodeMethod
    });

    this.root = this.store.root;

    var dragState = this.dragState;
    this.$on('tree-node-drag-start', function (event, treeNode) {
      if (typeof _this.allowDrag === 'function' && !_this.allowDrag(treeNode.node)) {
        event.preventDefault();
        return false;
      }
      event.dataTransfer.effectAllowed = 'move';

      // wrap in try catch to address IE's error when first param is 'text/plain'
      try {
        // setData is required for draggable to work in FireFox
        // the content has to be '' so dragging a node out of the tree won't open a new tab in FireFox
        event.dataTransfer.setData('text/plain', '');
      } catch (e) {}
      dragState.draggingNode = treeNode;
      _this.$emit('node-drag-start', treeNode.node, event);
    });

    this.$on('tree-node-drag-over', function (event, treeNode) {
      var dropNode = findNearestComponent(event.target, 'ElTreeNode');
      var oldDropNode = dragState.dropNode;
      if (oldDropNode && oldDropNode !== dropNode) {
        Object(dom_["removeClass"])(oldDropNode.$el, 'is-drop-inner');
      }
      var draggingNode = dragState.draggingNode;
      if (!draggingNode || !dropNode) return;

      var dropPrev = true;
      var dropInner = true;
      var dropNext = true;
      var userAllowDropInner = true;
      if (typeof _this.allowDrop === 'function') {
        dropPrev = _this.allowDrop(draggingNode.node, dropNode.node, 'prev');
        userAllowDropInner = dropInner = _this.allowDrop(draggingNode.node, dropNode.node, 'inner');
        dropNext = _this.allowDrop(draggingNode.node, dropNode.node, 'next');
      }
      event.dataTransfer.dropEffect = dropInner ? 'move' : 'none';
      if ((dropPrev || dropInner || dropNext) && oldDropNode !== dropNode) {
        if (oldDropNode) {
          _this.$emit('node-drag-leave', draggingNode.node, oldDropNode.node, event);
        }
        _this.$emit('node-drag-enter', draggingNode.node, dropNode.node, event);
      }

      if (dropPrev || dropInner || dropNext) {
        dragState.dropNode = dropNode;
      }

      if (dropNode.node.nextSibling === draggingNode.node) {
        dropNext = false;
      }
      if (dropNode.node.previousSibling === draggingNode.node) {
        dropPrev = false;
      }
      if (dropNode.node.contains(draggingNode.node, false)) {
        dropInner = false;
      }
      if (draggingNode.node === dropNode.node || draggingNode.node.contains(dropNode.node)) {
        dropPrev = false;
        dropInner = false;
        dropNext = false;
      }

      var targetPosition = dropNode.$el.getBoundingClientRect();
      var treePosition = _this.$el.getBoundingClientRect();

      var dropType = void 0;
      var prevPercent = dropPrev ? dropInner ? 0.25 : dropNext ? 0.45 : 1 : -1;
      var nextPercent = dropNext ? dropInner ? 0.75 : dropPrev ? 0.55 : 0 : 1;

      var indicatorTop = -9999;
      var distance = event.clientY - targetPosition.top;
      if (distance < targetPosition.height * prevPercent) {
        dropType = 'before';
      } else if (distance > targetPosition.height * nextPercent) {
        dropType = 'after';
      } else if (dropInner) {
        dropType = 'inner';
      } else {
        dropType = 'none';
      }

      var iconPosition = dropNode.$el.querySelector('.el-tree-node__expand-icon').getBoundingClientRect();
      var dropIndicator = _this.$refs.dropIndicator;
      if (dropType === 'before') {
        indicatorTop = iconPosition.top - treePosition.top;
      } else if (dropType === 'after') {
        indicatorTop = iconPosition.bottom - treePosition.top;
      }
      dropIndicator.style.top = indicatorTop + 'px';
      dropIndicator.style.left = iconPosition.right - treePosition.left + 'px';

      if (dropType === 'inner') {
        Object(dom_["addClass"])(dropNode.$el, 'is-drop-inner');
      } else {
        Object(dom_["removeClass"])(dropNode.$el, 'is-drop-inner');
      }

      dragState.showDropIndicator = dropType === 'before' || dropType === 'after';
      dragState.allowDrop = dragState.showDropIndicator || userAllowDropInner;
      dragState.dropType = dropType;
      _this.$emit('node-drag-over', draggingNode.node, dropNode.node, event);
    });

    this.$on('tree-node-drag-end', function (event) {
      var draggingNode = dragState.draggingNode,
          dropType = dragState.dropType,
          dropNode = dragState.dropNode;

      event.preventDefault();
      event.dataTransfer.dropEffect = 'move';

      if (draggingNode && dropNode) {
        var draggingNodeCopy = { data: draggingNode.node.data };
        if (dropType !== 'none') {
          draggingNode.node.remove();
        }
        if (dropType === 'before') {
          dropNode.node.parent.insertBefore(draggingNodeCopy, dropNode.node);
        } else if (dropType === 'after') {
          dropNode.node.parent.insertAfter(draggingNodeCopy, dropNode.node);
        } else if (dropType === 'inner') {
          dropNode.node.insertChild(draggingNodeCopy);
        }
        if (dropType !== 'none') {
          _this.store.registerNode(draggingNodeCopy);
        }

        Object(dom_["removeClass"])(dropNode.$el, 'is-drop-inner');

        _this.$emit('node-drag-end', draggingNode.node, dropNode.node, dropType, event);
        if (dropType !== 'none') {
          _this.$emit('node-drop', draggingNode.node, dropNode.node, dropType, event);
        }
      }
      if (draggingNode && !dropNode) {
        _this.$emit('node-drag-end', draggingNode.node, null, dropType, event);
      }

      dragState.showDropIndicator = false;
      dragState.draggingNode = null;
      dragState.dropNode = null;
      dragState.allowDrop = true;
    });
  },
  mounted: function mounted() {
    this.initTabIndex();
    this.$el.addEventListener('keydown', this.handleKeydown);
  },
  updated: function updated() {
    this.treeItems = this.$el.querySelectorAll('[role=treeitem]');
    this.checkboxItems = this.$el.querySelectorAll('input[type=checkbox]');
  }
});
// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_treevue_type_script_lang_js_ = (treevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/tree/src/tree.vue





/* normalize component */

var tree_component = normalizeComponent(
  src_treevue_type_script_lang_js_,
  treevue_type_template_id_547575a6_render,
  treevue_type_template_id_547575a6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var tree_api; }
tree_component.options.__file = "packages/tree/src/tree.vue"
/* harmony default export */ var src_tree = (tree_component.exports);
// CONCATENATED MODULE: ./packages/tree/index.js


/* istanbul ignore next */
src_tree.install = function (Vue) {
  Vue.component(src_tree.name, src_tree);
};

/* harmony default export */ var packages_tree = (src_tree);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=template&id=6e53341b&
var mainvue_type_template_id_6e53341b_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "el-alert-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }
        ],
        staticClass: "el-alert",
        class: [
          _vm.typeClass,
          _vm.center ? "is-center" : "",
          "is-" + _vm.effect
        ],
        attrs: { role: "alert" }
      },
      [
        _vm.showIcon
          ? _c("i", {
              staticClass: "el-alert__icon",
              class: [_vm.iconClass, _vm.isBigIcon]
            })
          : _vm._e(),
        _c("div", { staticClass: "el-alert__content" }, [
          _vm.title || _vm.$slots.title
            ? _c(
                "span",
                { staticClass: "el-alert__title", class: [_vm.isBoldTitle] },
                [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
                2
              )
            : _vm._e(),
          _vm.$slots.default && !_vm.description
            ? _c(
                "p",
                { staticClass: "el-alert__description" },
                [_vm._t("default")],
                2
              )
            : _vm._e(),
          _vm.description && !_vm.$slots.default
            ? _c("p", { staticClass: "el-alert__description" }, [
                _vm._v(_vm._s(_vm.description))
              ])
            : _vm._e(),
          _c(
            "i",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closable,
                  expression: "closable"
                }
              ],
              staticClass: "el-alert__closebtn",
              class: {
                "is-customed": _vm.closeText !== "",
                "el-icon-close": _vm.closeText === ""
              },
              on: {
                click: function($event) {
                  _vm.close()
                }
              }
            },
            [_vm._v(_vm._s(_vm.closeText))]
          )
        ])
      ]
    )
  ])
}
var mainvue_type_template_id_6e53341b_staticRenderFns = []
mainvue_type_template_id_6e53341b_render._withStripped = true


// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=template&id=6e53341b&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TYPE_CLASSES_MAP = {
  'success': 'el-icon-success',
  'warning': 'el-icon-warning',
  'error': 'el-icon-error'
};
/* harmony default export */ var alert_src_mainvue_type_script_lang_js_ = ({
  name: 'ElAlert',

  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info'
    },
    closable: {
      type: Boolean,
      default: true
    },
    closeText: {
      type: String,
      default: ''
    },
    showIcon: Boolean,
    center: Boolean,
    effect: {
      type: String,
      default: 'light',
      validator: function validator(value) {
        return ['light', 'dark'].indexOf(value) !== -1;
      }
    }
  },

  data: function data() {
    return {
      visible: true
    };
  },


  methods: {
    close: function close() {
      this.visible = false;
      this.$emit('close');
    }
  },

  computed: {
    typeClass: function typeClass() {
      return 'el-alert--' + this.type;
    },
    iconClass: function iconClass() {
      return TYPE_CLASSES_MAP[this.type] || 'el-icon-info';
    },
    isBigIcon: function isBigIcon() {
      return this.description || this.$slots.default ? 'is-big' : '';
    },
    isBoldTitle: function isBoldTitle() {
      return this.description || this.$slots.default ? 'is-bold' : '';
    }
  }
});
// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_alert_src_mainvue_type_script_lang_js_ = (alert_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/alert/src/main.vue





/* normalize component */

var alert_src_main_component = normalizeComponent(
  packages_alert_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_6e53341b_render,
  mainvue_type_template_id_6e53341b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var alert_src_main_api; }
alert_src_main_component.options.__file = "packages/alert/src/main.vue"
/* harmony default export */ var alert_src_main = (alert_src_main_component.exports);
// CONCATENATED MODULE: ./packages/alert/index.js


/* istanbul ignore next */
alert_src_main.install = function (Vue) {
  Vue.component(alert_src_main.name, alert_src_main);
};

/* harmony default export */ var packages_alert = (alert_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
var mainvue_type_template_id_43dbc3d8_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "el-notification-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }
        ],
        class: ["el-notification", _vm.customClass, _vm.horizontalClass],
        style: _vm.positionStyle,
        attrs: { role: "alert" },
        on: {
          mouseenter: function($event) {
            _vm.clearTimer()
          },
          mouseleave: function($event) {
            _vm.startTimer()
          },
          click: _vm.click
        }
      },
      [
        _vm.type || _vm.iconClass
          ? _c("i", {
              staticClass: "el-notification__icon",
              class: [_vm.typeClass, _vm.iconClass]
            })
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "el-notification__group",
            class: { "is-with-icon": _vm.typeClass || _vm.iconClass }
          },
          [
            _c("h2", {
              staticClass: "el-notification__title",
              domProps: { textContent: _vm._s(_vm.title) }
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.message,
                    expression: "message"
                  }
                ],
                staticClass: "el-notification__content"
              },
              [
                _vm._t("default", [
                  !_vm.dangerouslyUseHTMLString
                    ? _c("p", [_vm._v(_vm._s(_vm.message))])
                    : _c("p", { domProps: { innerHTML: _vm._s(_vm.message) } })
                ])
              ],
              2
            ),
            _vm.showClose
              ? _c("div", {
                  staticClass: "el-notification__closeBtn el-icon-close",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.close($event)
                    }
                  }
                })
              : _vm._e()
          ]
        )
      ]
    )
  ])
}
var mainvue_type_template_id_43dbc3d8_staticRenderFns = []
mainvue_type_template_id_43dbc3d8_render._withStripped = true


// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var mainvue_type_script_lang_js_typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

/* harmony default export */ var notification_src_mainvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      visible: false,
      title: '',
      message: '',
      duration: 4500,
      type: '',
      showClose: true,
      customClass: '',
      iconClass: '',
      onClose: null,
      onClick: null,
      closed: false,
      verticalOffset: 0,
      timer: null,
      dangerouslyUseHTMLString: false,
      position: 'top-right'
    };
  },


  computed: {
    typeClass: function typeClass() {
      return this.type && mainvue_type_script_lang_js_typeMap[this.type] ? 'el-icon-' + mainvue_type_script_lang_js_typeMap[this.type] : '';
    },
    horizontalClass: function horizontalClass() {
      return this.position.indexOf('right') > -1 ? 'right' : 'left';
    },
    verticalProperty: function verticalProperty() {
      return (/^top-/.test(this.position) ? 'top' : 'bottom'
      );
    },
    positionStyle: function positionStyle() {
      var _ref;

      return _ref = {}, _ref[this.verticalProperty] = this.verticalOffset + 'px', _ref;
    }
  },

  watch: {
    closed: function closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.$el.addEventListener('transitionend', this.destroyElement);
      }
    }
  },

  methods: {
    destroyElement: function destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    click: function click() {
      if (typeof this.onClick === 'function') {
        this.onClick();
      }
    },
    close: function close() {
      this.closed = true;
      if (typeof this.onClose === 'function') {
        this.onClose();
      }
    },
    clearTimer: function clearTimer() {
      clearTimeout(this.timer);
    },
    startTimer: function startTimer() {
      var _this = this;

      if (this.duration > 0) {
        this.timer = setTimeout(function () {
          if (!_this.closed) {
            _this.close();
          }
        }, this.duration);
      }
    },
    keydown: function keydown(e) {
      if (e.keyCode === 46 || e.keyCode === 8) {
        this.clearTimer(); // detele 取消倒计时
      } else if (e.keyCode === 27) {
        // esc关闭消息
        if (!this.closed) {
          this.close();
        }
      } else {
        this.startTimer(); // 恢复倒计时
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        if (!_this2.closed) {
          _this2.close();
        }
      }, this.duration);
    }
    document.addEventListener('keydown', this.keydown);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.keydown);
  }
});
// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_notification_src_mainvue_type_script_lang_js_ = (notification_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/notification/src/main.vue





/* normalize component */

var notification_src_main_component = normalizeComponent(
  packages_notification_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_43dbc3d8_render,
  mainvue_type_template_id_43dbc3d8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var notification_src_main_api; }
notification_src_main_component.options.__file = "packages/notification/src/main.vue"
/* harmony default export */ var notification_src_main = (notification_src_main_component.exports);
// CONCATENATED MODULE: ./packages/notification/src/main.js





var NotificationConstructor = external_vue_default.a.extend(notification_src_main);

var src_main_instance = void 0;
var instances = [];
var seed = 1;

var main_Notification = function Notification(options) {
  if (external_vue_default.a.prototype.$isServer) return;
  options = merge_default()({}, options);
  var userOnClose = options.onClose;
  var id = 'notification_' + seed++;
  var position = options.position || 'top-right';

  options.onClose = function () {
    Notification.close(id, userOnClose);
  };

  src_main_instance = new NotificationConstructor({
    data: options
  });

  if (Object(vdom_["isVNode"])(options.message)) {
    src_main_instance.$slots.default = [options.message];
    options.message = 'REPLACED_BY_VNODE';
  }
  src_main_instance.id = id;
  src_main_instance.$mount();
  document.body.appendChild(src_main_instance.$el);
  src_main_instance.visible = true;
  src_main_instance.dom = src_main_instance.$el;
  src_main_instance.dom.style.zIndex = popup_["PopupManager"].nextZIndex();

  var verticalOffset = options.offset || 0;
  instances.filter(function (item) {
    return item.position === position;
  }).forEach(function (item) {
    verticalOffset += item.$el.offsetHeight + 16;
  });
  verticalOffset += 16;
  src_main_instance.verticalOffset = verticalOffset;
  instances.push(src_main_instance);
  return src_main_instance;
};

['success', 'warning', 'info', 'error'].forEach(function (type) {
  main_Notification[type] = function (options) {
    if (typeof options === 'string' || Object(vdom_["isVNode"])(options)) {
      options = {
        message: options
      };
    }
    options.type = type;
    return main_Notification(options);
  };
});

main_Notification.close = function (id, userOnClose) {
  var index = -1;
  var len = instances.length;
  var instance = instances.filter(function (instance, i) {
    if (instance.id === id) {
      index = i;
      return true;
    }
    return false;
  })[0];
  if (!instance) return;

  if (typeof userOnClose === 'function') {
    userOnClose(instance);
  }
  instances.splice(index, 1);

  if (len <= 1) return;
  var position = instance.position;
  var removedHeight = instance.dom.offsetHeight;
  for (var i = index; i < len - 1; i++) {
    if (instances[i].position === position) {
      instances[i].dom.style[instance.verticalProperty] = parseInt(instances[i].dom.style[instance.verticalProperty], 10) - removedHeight - 16 + 'px';
    }
  }
};

main_Notification.closeAll = function () {
  for (var i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

/* harmony default export */ var packages_notification_src_main = (main_Notification);
// CONCATENATED MODULE: ./packages/notification/index.js

/* harmony default export */ var notification = (packages_notification_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=template&id=32708644&
var mainvue_type_template_id_32708644_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-slider",
      class: {
        "is-vertical": _vm.vertical,
        "el-slider--with-input": _vm.showInput
      },
      attrs: {
        role: "slider",
        "aria-valuemin": _vm.min,
        "aria-valuemax": _vm.max,
        "aria-orientation": _vm.vertical ? "vertical" : "horizontal",
        "aria-disabled": _vm.sliderDisabled
      }
    },
    [
      _vm.showInput && !_vm.range
        ? _c("el-input-number", {
            ref: "input",
            staticClass: "el-slider__input",
            attrs: {
              step: _vm.step,
              disabled: _vm.sliderDisabled,
              controls: _vm.showInputControls,
              min: _vm.min,
              max: _vm.max,
              debounce: _vm.debounce,
              size: _vm.inputSize
            },
            on: { change: _vm.emitChange },
            model: {
              value: _vm.firstValue,
              callback: function($$v) {
                _vm.firstValue = $$v
              },
              expression: "firstValue"
            }
          })
        : _vm._e(),
      _c(
        "div",
        {
          ref: "slider",
          staticClass: "el-slider__runway",
          class: { "show-input": _vm.showInput, disabled: _vm.sliderDisabled },
          style: _vm.runwayStyle,
          on: { click: _vm.onSliderClick }
        },
        [
          _c("div", { staticClass: "el-slider__bar", style: _vm.barStyle }),
          _c("slider-button", {
            ref: "button1",
            attrs: {
              vertical: _vm.vertical,
              "tooltip-class": _vm.tooltipClass
            },
            model: {
              value: _vm.firstValue,
              callback: function($$v) {
                _vm.firstValue = $$v
              },
              expression: "firstValue"
            }
          }),
          _vm.range
            ? _c("slider-button", {
                ref: "button2",
                attrs: {
                  vertical: _vm.vertical,
                  "tooltip-class": _vm.tooltipClass
                },
                model: {
                  value: _vm.secondValue,
                  callback: function($$v) {
                    _vm.secondValue = $$v
                  },
                  expression: "secondValue"
                }
              })
            : _vm._e(),
          _vm._l(_vm.stops, function(item, key) {
            return _vm.showStops
              ? _c("div", {
                  key: key,
                  staticClass: "el-slider__stop",
                  style: _vm.getStopStyle(item)
                })
              : _vm._e()
          }),
          _vm.markList.length > 0
            ? [
                _c(
                  "div",
                  _vm._l(_vm.markList, function(item, key) {
                    return _c("div", {
                      key: key,
                      staticClass: "el-slider__stop el-slider__marks-stop",
                      style: _vm.getStopStyle(item.position)
                    })
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "el-slider__marks" },
                  _vm._l(_vm.markList, function(item, key) {
                    return _c("slider-marker", {
                      key: key,
                      style: _vm.getStopStyle(item.position),
                      attrs: { mark: item.mark }
                    })
                  }),
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var mainvue_type_template_id_32708644_staticRenderFns = []
mainvue_type_template_id_32708644_render._withStripped = true


// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=template&id=32708644&

// EXTERNAL MODULE: external "element-ui/lib/input-number"
var input_number_ = __webpack_require__(41);
var input_number_default = /*#__PURE__*/__webpack_require__.n(input_number_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&
var buttonvue_type_template_id_e72d2ad2_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "button",
      staticClass: "el-slider__button-wrapper",
      class: { hover: _vm.hovering, dragging: _vm.dragging },
      style: _vm.wrapperStyle,
      attrs: { tabindex: "0" },
      on: {
        mouseenter: _vm.handleMouseEnter,
        mouseleave: _vm.handleMouseLeave,
        mousedown: _vm.onButtonDown,
        touchstart: _vm.onButtonDown,
        focus: _vm.handleMouseEnter,
        blur: _vm.handleMouseLeave,
        keydown: [
          function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "left", 37, $event.key, [
                "Left",
                "ArrowLeft"
              ])
            ) {
              return null
            }
            if ("button" in $event && $event.button !== 0) {
              return null
            }
            return _vm.onLeftKeyDown($event)
          },
          function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "right", 39, $event.key, [
                "Right",
                "ArrowRight"
              ])
            ) {
              return null
            }
            if ("button" in $event && $event.button !== 2) {
              return null
            }
            return _vm.onRightKeyDown($event)
          },
          function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown"
              ])
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.onLeftKeyDown($event)
          },
          function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.onRightKeyDown($event)
          }
        ]
      }
    },
    [
      _c(
        "el-tooltip",
        {
          ref: "tooltip",
          attrs: {
            placement: "top",
            "popper-class": _vm.tooltipClass,
            disabled: !_vm.showTooltip
          }
        },
        [
          _c("span", { attrs: { slot: "content" }, slot: "content" }, [
            _vm._v(_vm._s(_vm.formatValue))
          ]),
          _c("div", {
            staticClass: "el-slider__button",
            class: { hover: _vm.hovering, dragging: _vm.dragging }
          })
        ]
      )
    ],
    1
  )
}
var buttonvue_type_template_id_e72d2ad2_staticRenderFns = []
buttonvue_type_template_id_e72d2ad2_render._withStripped = true


// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var slider_src_buttonvue_type_script_lang_js_ = ({
  name: 'ElSliderButton',

  components: {
    ElTooltip: tooltip_default.a
  },

  props: {
    value: {
      type: Number,
      default: 0
    },
    vertical: {
      type: Boolean,
      default: false
    },
    tooltipClass: String
  },

  data: function data() {
    return {
      hovering: false,
      dragging: false,
      isClick: false,
      startX: 0,
      currentX: 0,
      startY: 0,
      currentY: 0,
      startPosition: 0,
      newPosition: null,
      oldValue: this.value
    };
  },


  computed: {
    disabled: function disabled() {
      return this.$parent.sliderDisabled;
    },
    max: function max() {
      return this.$parent.max;
    },
    min: function min() {
      return this.$parent.min;
    },
    step: function step() {
      return this.$parent.step;
    },
    showTooltip: function showTooltip() {
      return this.$parent.showTooltip;
    },
    precision: function precision() {
      return this.$parent.precision;
    },
    currentPosition: function currentPosition() {
      return (this.value - this.min) / (this.max - this.min) * 100 + '%';
    },
    enableFormat: function enableFormat() {
      return this.$parent.formatTooltip instanceof Function;
    },
    formatValue: function formatValue() {
      return this.enableFormat && this.$parent.formatTooltip(this.value) || this.value;
    },
    wrapperStyle: function wrapperStyle() {
      return this.vertical ? { bottom: this.currentPosition } : { left: this.currentPosition };
    }
  },

  watch: {
    dragging: function dragging(val) {
      this.$parent.dragging = val;
    }
  },

  methods: {
    displayTooltip: function displayTooltip() {
      this.$refs.tooltip && (this.$refs.tooltip.showPopper = true);
    },
    hideTooltip: function hideTooltip() {
      this.$refs.tooltip && (this.$refs.tooltip.showPopper = false);
    },
    handleMouseEnter: function handleMouseEnter() {
      this.hovering = true;
      this.displayTooltip();
    },
    handleMouseLeave: function handleMouseLeave() {
      this.hovering = false;
      this.hideTooltip();
    },
    onButtonDown: function onButtonDown(event) {
      if (this.disabled) return;
      event.preventDefault();
      this.onDragStart(event);
      window.addEventListener('mousemove', this.onDragging);
      window.addEventListener('touchmove', this.onDragging);
      window.addEventListener('mouseup', this.onDragEnd);
      window.addEventListener('touchend', this.onDragEnd);
      window.addEventListener('contextmenu', this.onDragEnd);
    },
    onLeftKeyDown: function onLeftKeyDown() {
      if (this.disabled) return;
      this.newPosition = parseFloat(this.currentPosition) - this.step / (this.max - this.min) * 100;
      this.setPosition(this.newPosition);
      this.$parent.emitChange();
    },
    onRightKeyDown: function onRightKeyDown() {
      if (this.disabled) return;
      this.newPosition = parseFloat(this.currentPosition) + this.step / (this.max - this.min) * 100;
      this.setPosition(this.newPosition);
      this.$parent.emitChange();
    },
    onDragStart: function onDragStart(event) {
      this.dragging = true;
      this.isClick = true;
      if (event.type === 'touchstart') {
        event.clientY = event.touches[0].clientY;
        event.clientX = event.touches[0].clientX;
      }
      if (this.vertical) {
        this.startY = event.clientY;
      } else {
        this.startX = event.clientX;
      }
      this.startPosition = parseFloat(this.currentPosition);
      this.newPosition = this.startPosition;
    },
    onDragging: function onDragging(event) {
      if (this.dragging) {
        this.isClick = false;
        this.displayTooltip();
        this.$parent.resetSize();
        var diff = 0;
        if (event.type === 'touchmove') {
          event.clientY = event.touches[0].clientY;
          event.clientX = event.touches[0].clientX;
        }
        if (this.vertical) {
          this.currentY = event.clientY;
          diff = (this.startY - this.currentY) / this.$parent.sliderSize * 100;
        } else {
          this.currentX = event.clientX;
          diff = (this.currentX - this.startX) / this.$parent.sliderSize * 100;
        }
        this.newPosition = this.startPosition + diff;
        this.setPosition(this.newPosition);
      }
    },
    onDragEnd: function onDragEnd() {
      var _this = this;

      if (this.dragging) {
        /*
         * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
         * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
         */
        setTimeout(function () {
          _this.dragging = false;
          _this.hideTooltip();
          if (!_this.isClick) {
            _this.setPosition(_this.newPosition);
            _this.$parent.emitChange();
          }
        }, 0);
        window.removeEventListener('mousemove', this.onDragging);
        window.removeEventListener('touchmove', this.onDragging);
        window.removeEventListener('mouseup', this.onDragEnd);
        window.removeEventListener('touchend', this.onDragEnd);
        window.removeEventListener('contextmenu', this.onDragEnd);
      }
    },
    setPosition: function setPosition(newPosition) {
      var _this2 = this;

      if (newPosition === null || isNaN(newPosition)) return;
      if (newPosition < 0) {
        newPosition = 0;
      } else if (newPosition > 100) {
        newPosition = 100;
      }
      var lengthPerStep = 100 / ((this.max - this.min) / this.step);
      var steps = Math.round(newPosition / lengthPerStep);
      var value = steps * lengthPerStep * (this.max - this.min) * 0.01 + this.min;
      value = parseFloat(value.toFixed(this.precision));
      this.$emit('input', value);
      this.$nextTick(function () {
        _this2.displayTooltip();
        _this2.$refs.tooltip && _this2.$refs.tooltip.updatePopper();
      });
      if (!this.dragging && this.value !== this.oldValue) {
        this.oldValue = this.value;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_slider_src_buttonvue_type_script_lang_js_ = (slider_src_buttonvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/slider/src/button.vue





/* normalize component */

var src_button_component = normalizeComponent(
  packages_slider_src_buttonvue_type_script_lang_js_,
  buttonvue_type_template_id_e72d2ad2_render,
  buttonvue_type_template_id_e72d2ad2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var src_button_api; }
src_button_component.options.__file = "packages/slider/src/button.vue"
/* harmony default export */ var slider_src_button = (src_button_component.exports);
// CONCATENATED MODULE: ./packages/slider/src/marker.js
/* harmony default export */ var marker = ({
  name: 'ElMarker',

  props: {
    mark: {
      type: [String, Object]
    }
  },
  render: function render() {
    var h = arguments[0];

    var label = typeof this.mark === 'string' ? this.mark : this.mark.label;

    return h(
      'div',
      { 'class': 'el-slider__marks-text', style: this.mark.style || {} },
      [label]
    );
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var slider_src_mainvue_type_script_lang_js_ = ({
  name: 'ElSlider',

  mixins: [emitter_default.a],

  inject: {
    elForm: {
      default: ''
    }
  },

  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    value: {
      type: [Number, Array],
      default: 0
    },
    showInput: {
      type: Boolean,
      default: false
    },
    showInputControls: {
      type: Boolean,
      default: true
    },
    inputSize: {
      type: String,
      default: 'small'
    },
    showStops: {
      type: Boolean,
      default: false
    },
    showTooltip: {
      type: Boolean,
      default: true
    },
    formatTooltip: Function,
    disabled: {
      type: Boolean,
      default: false
    },
    range: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    },
    height: {
      type: String
    },
    debounce: {
      type: Number,
      default: 300
    },
    label: {
      type: String
    },
    tooltipClass: String,
    marks: Object
  },

  components: {
    ElInputNumber: input_number_default.a,
    SliderButton: slider_src_button,
    SliderMarker: marker
  },

  data: function data() {
    return {
      firstValue: null,
      secondValue: null,
      oldValue: null,
      dragging: false,
      sliderSize: 1
    };
  },


  watch: {
    value: function value(val, oldVal) {
      if (this.dragging || Array.isArray(val) && Array.isArray(oldVal) && val.every(function (item, index) {
        return item === oldVal[index];
      })) {
        return;
      }
      this.setValues();
    },
    dragging: function dragging(val) {
      if (!val) {
        this.setValues();
      }
    },
    firstValue: function firstValue(val) {
      if (this.range) {
        this.$emit('input', [this.minValue, this.maxValue]);
      } else {
        this.$emit('input', val);
      }
    },
    secondValue: function secondValue() {
      if (this.range) {
        this.$emit('input', [this.minValue, this.maxValue]);
      }
    },
    min: function min() {
      this.setValues();
    },
    max: function max() {
      this.setValues();
    }
  },

  methods: {
    valueChanged: function valueChanged() {
      var _this = this;

      if (this.range) {
        return ![this.minValue, this.maxValue].every(function (item, index) {
          return item === _this.oldValue[index];
        });
      } else {
        return this.value !== this.oldValue;
      }
    },
    setValues: function setValues() {
      if (this.min > this.max) {
        console.error('[Element Error][Slider]min should not be greater than max.');
        return;
      }
      var val = this.value;
      if (this.range && Array.isArray(val)) {
        if (val[1] < this.min) {
          this.$emit('input', [this.min, this.min]);
        } else if (val[0] > this.max) {
          this.$emit('input', [this.max, this.max]);
        } else if (val[0] < this.min) {
          this.$emit('input', [this.min, val[1]]);
        } else if (val[1] > this.max) {
          this.$emit('input', [val[0], this.max]);
        } else {
          this.firstValue = val[0];
          this.secondValue = val[1];
          if (this.valueChanged()) {
            this.dispatch('ElFormItem', 'el.form.change', [this.minValue, this.maxValue]);
            this.oldValue = val.slice();
          }
        }
      } else if (!this.range && typeof val === 'number' && !isNaN(val)) {
        if (val < this.min) {
          this.$emit('input', this.min);
        } else if (val > this.max) {
          this.$emit('input', this.max);
        } else {
          this.firstValue = val;
          if (this.valueChanged()) {
            this.dispatch('ElFormItem', 'el.form.change', val);
            this.oldValue = val;
          }
        }
      }
    },
    setPosition: function setPosition(percent) {
      var targetValue = this.min + percent * (this.max - this.min) / 100;
      if (!this.range) {
        this.$refs.button1.setPosition(percent);
        return;
      }
      var button = void 0;
      if (Math.abs(this.minValue - targetValue) < Math.abs(this.maxValue - targetValue)) {
        button = this.firstValue < this.secondValue ? 'button1' : 'button2';
      } else {
        button = this.firstValue > this.secondValue ? 'button1' : 'button2';
      }
      this.$refs[button].setPosition(percent);
    },
    onSliderClick: function onSliderClick(event) {
      if (this.sliderDisabled || this.dragging) return;
      this.resetSize();
      if (this.vertical) {
        var sliderOffsetBottom = this.$refs.slider.getBoundingClientRect().bottom;
        this.setPosition((sliderOffsetBottom - event.clientY) / this.sliderSize * 100);
      } else {
        var sliderOffsetLeft = this.$refs.slider.getBoundingClientRect().left;
        this.setPosition((event.clientX - sliderOffsetLeft) / this.sliderSize * 100);
      }
      this.emitChange();
    },
    resetSize: function resetSize() {
      if (this.$refs.slider) {
        this.sliderSize = this.$refs.slider['client' + (this.vertical ? 'Height' : 'Width')];
      }
    },
    emitChange: function emitChange() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$emit('change', _this2.range ? [_this2.minValue, _this2.maxValue] : _this2.value);
      });
    },
    getStopStyle: function getStopStyle(position) {
      return this.vertical ? { 'bottom': position + '%' } : { 'left': position + '%' };
    }
  },

  computed: {
    stops: function stops() {
      var _this3 = this;

      if (!this.showStops || this.min > this.max) return [];
      if (this.step === 0) {
         false && false;
        return [];
      }
      var stopCount = (this.max - this.min) / this.step;
      var stepWidth = 100 * this.step / (this.max - this.min);
      var result = [];
      for (var i = 1; i < stopCount; i++) {
        result.push(i * stepWidth);
      }
      if (this.range) {
        return result.filter(function (step) {
          return step < 100 * (_this3.minValue - _this3.min) / (_this3.max - _this3.min) || step > 100 * (_this3.maxValue - _this3.min) / (_this3.max - _this3.min);
        });
      } else {
        return result.filter(function (step) {
          return step > 100 * (_this3.firstValue - _this3.min) / (_this3.max - _this3.min);
        });
      }
    },
    markList: function markList() {
      var _this4 = this;

      if (!this.marks) {
        return [];
      }

      var marksKeys = Object.keys(this.marks);
      return marksKeys.map(parseFloat).sort(function (a, b) {
        return a - b;
      }).filter(function (point) {
        return point <= _this4.max && point >= _this4.min;
      }).map(function (point) {
        return {
          point: point,
          position: (point - _this4.min) * 100 / (_this4.max - _this4.min),
          mark: _this4.marks[point]
        };
      });
    },
    minValue: function minValue() {
      return Math.min(this.firstValue, this.secondValue);
    },
    maxValue: function maxValue() {
      return Math.max(this.firstValue, this.secondValue);
    },
    barSize: function barSize() {
      return this.range ? 100 * (this.maxValue - this.minValue) / (this.max - this.min) + '%' : 100 * (this.firstValue - this.min) / (this.max - this.min) + '%';
    },
    barStart: function barStart() {
      return this.range ? 100 * (this.minValue - this.min) / (this.max - this.min) + '%' : '0%';
    },
    precision: function precision() {
      var precisions = [this.min, this.max, this.step].map(function (item) {
        var decimal = ('' + item).split('.')[1];
        return decimal ? decimal.length : 0;
      });
      return Math.max.apply(null, precisions);
    },
    runwayStyle: function runwayStyle() {
      return this.vertical ? { height: this.height } : {};
    },
    barStyle: function barStyle() {
      return this.vertical ? {
        height: this.barSize,
        bottom: this.barStart
      } : {
        width: this.barSize,
        left: this.barStart
      };
    },
    sliderDisabled: function sliderDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  mounted: function mounted() {
    var valuetext = void 0;
    if (this.range) {
      if (Array.isArray(this.value)) {
        this.firstValue = Math.max(this.min, this.value[0]);
        this.secondValue = Math.min(this.max, this.value[1]);
      } else {
        this.firstValue = this.min;
        this.secondValue = this.max;
      }
      this.oldValue = [this.firstValue, this.secondValue];
      valuetext = this.firstValue + '-' + this.secondValue;
    } else {
      if (typeof this.value !== 'number' || isNaN(this.value)) {
        this.firstValue = this.min;
      } else {
        this.firstValue = Math.min(this.max, Math.max(this.min, this.value));
      }
      this.oldValue = this.firstValue;
      valuetext = this.firstValue;
    }
    this.$el.setAttribute('aria-valuetext', valuetext);

    // label screen reader
    this.$el.setAttribute('aria-label', this.label ? this.label : 'slider between ' + this.min + ' and ' + this.max);

    this.resetSize();
    window.addEventListener('resize', this.resetSize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resetSize);
  }
});
// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_slider_src_mainvue_type_script_lang_js_ = (slider_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/slider/src/main.vue





/* normalize component */

var slider_src_main_component = normalizeComponent(
  packages_slider_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_32708644_render,
  mainvue_type_template_id_32708644_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var slider_src_main_api; }
slider_src_main_component.options.__file = "packages/slider/src/main.vue"
/* harmony default export */ var slider_src_main = (slider_src_main_component.exports);
// CONCATENATED MODULE: ./packages/slider/index.js


/* istanbul ignore next */
slider_src_main.install = function (Vue) {
  Vue.component(slider_src_main.name, slider_src_main);
};

/* harmony default export */ var slider = (slider_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
var loadingvue_type_template_id_eee0a7ac_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "el-loading-fade" },
      on: { "after-leave": _vm.handleAfterLeave }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          staticClass: "el-loading-mask",
          class: [_vm.customClass, { "is-fullscreen": _vm.fullscreen }],
          style: { backgroundColor: _vm.background || "" }
        },
        [
          _c("div", { staticClass: "el-loading-spinner" }, [
            !_vm.spinner
              ? _c(
                  "svg",
                  {
                    staticClass: "circular",
                    attrs: { viewBox: "25 25 50 50" }
                  },
                  [
                    _c("circle", {
                      staticClass: "path",
                      attrs: { cx: "50", cy: "50", r: "20", fill: "none" }
                    })
                  ]
                )
              : _c("i", { class: _vm.spinner }),
            _vm.text
              ? _c("p", { staticClass: "el-loading-text" }, [
                  _vm._v(_vm._s(_vm.text))
                ])
              : _vm._e()
          ])
        ]
      )
    ]
  )
}
var loadingvue_type_template_id_eee0a7ac_staticRenderFns = []
loadingvue_type_template_id_eee0a7ac_render._withStripped = true


// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loadingvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      text: null,
      spinner: null,
      background: null,
      fullscreen: true,
      visible: false,
      customClass: ''
    };
  },


  methods: {
    handleAfterLeave: function handleAfterLeave() {
      this.$emit('after-leave');
    },
    setText: function setText(text) {
      this.text = text;
    }
  }
});
// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_loadingvue_type_script_lang_js_ = (loadingvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/loading/src/loading.vue





/* normalize component */

var loading_component = normalizeComponent(
  src_loadingvue_type_script_lang_js_,
  loadingvue_type_template_id_eee0a7ac_render,
  loadingvue_type_template_id_eee0a7ac_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var loading_api; }
loading_component.options.__file = "packages/loading/src/loading.vue"
/* harmony default export */ var loading = (loading_component.exports);
// EXTERNAL MODULE: external "element-ui/lib/utils/after-leave"
var after_leave_ = __webpack_require__(33);
var after_leave_default = /*#__PURE__*/__webpack_require__.n(after_leave_);

// CONCATENATED MODULE: ./packages/loading/src/directive.js





var Mask = external_vue_default.a.extend(loading);

var loadingDirective = {};
loadingDirective.install = function (Vue) {
  if (Vue.prototype.$isServer) return;
  var toggleLoading = function toggleLoading(el, binding) {
    if (binding.value) {
      Vue.nextTick(function () {
        if (binding.modifiers.fullscreen) {
          el.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
          el.originalOverflow = Object(dom_["getStyle"])(document.body, 'overflow');
          el.maskStyle.zIndex = popup_["PopupManager"].nextZIndex();

          Object(dom_["addClass"])(el.mask, 'is-fullscreen');
          insertDom(document.body, el, binding);
        } else {
          Object(dom_["removeClass"])(el.mask, 'is-fullscreen');

          if (binding.modifiers.body) {
            el.originalPosition = Object(dom_["getStyle"])(document.body, 'position');

            ['top', 'left'].forEach(function (property) {
              var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
              el.maskStyle[property] = el.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] - parseInt(Object(dom_["getStyle"])(document.body, 'margin-' + property), 10) + 'px';
            });
            ['height', 'width'].forEach(function (property) {
              el.maskStyle[property] = el.getBoundingClientRect()[property] + 'px';
            });

            insertDom(document.body, el, binding);
          } else {
            el.originalPosition = Object(dom_["getStyle"])(el, 'position');
            insertDom(el, el, binding);
          }
        }
      });
    } else {
      after_leave_default()(el.instance, function (_) {
        if (!el.instance.hiding) return;
        el.domVisible = false;
        var target = binding.modifiers.fullscreen || binding.modifiers.body ? document.body : el;
        Object(dom_["removeClass"])(target, 'el-loading-parent--relative');
        Object(dom_["removeClass"])(target, 'el-loading-parent--hidden');
        el.instance.hiding = false;
      }, 300, true);
      el.instance.visible = false;
      el.instance.hiding = true;
    }
  };
  var insertDom = function insertDom(parent, el, binding) {
    if (!el.domVisible && Object(dom_["getStyle"])(el, 'display') !== 'none' && Object(dom_["getStyle"])(el, 'visibility') !== 'hidden') {
      Object.keys(el.maskStyle).forEach(function (property) {
        el.mask.style[property] = el.maskStyle[property];
      });

      if (el.originalPosition !== 'absolute' && el.originalPosition !== 'fixed') {
        Object(dom_["addClass"])(parent, 'el-loading-parent--relative');
      }
      if (binding.modifiers.fullscreen && binding.modifiers.lock) {
        Object(dom_["addClass"])(parent, 'el-loading-parent--hidden');
      }
      el.domVisible = true;

      parent.appendChild(el.mask);
      Vue.nextTick(function () {
        if (el.instance.hiding) {
          el.instance.$emit('after-leave');
        } else {
          el.instance.visible = true;
        }
      });
      el.domInserted = true;
    } else if (el.domVisible && el.instance.hiding === true) {
      el.instance.visible = true;
      el.instance.hiding = false;
    }
  };

  Vue.directive('loading', {
    bind: function bind(el, binding, vnode) {
      var textExr = el.getAttribute('element-loading-text');
      var spinnerExr = el.getAttribute('element-loading-spinner');
      var backgroundExr = el.getAttribute('element-loading-background');
      var customClassExr = el.getAttribute('element-loading-custom-class');
      var vm = vnode.context;
      var mask = new Mask({
        el: document.createElement('div'),
        data: {
          text: vm && vm[textExr] || textExr,
          spinner: vm && vm[spinnerExr] || spinnerExr,
          background: vm && vm[backgroundExr] || backgroundExr,
          customClass: vm && vm[customClassExr] || customClassExr,
          fullscreen: !!binding.modifiers.fullscreen
        }
      });
      el.instance = mask;
      el.mask = mask.$el;
      el.maskStyle = {};

      binding.value && toggleLoading(el, binding);
    },

    update: function update(el, binding) {
      el.instance.setText(el.getAttribute('element-loading-text'));
      if (binding.oldValue !== binding.value) {
        toggleLoading(el, binding);
      }
    },

    unbind: function unbind(el, binding) {
      if (el.domInserted) {
        el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
        toggleLoading(el, { value: false, modifiers: binding.modifiers });
      }
      el.instance && el.instance.$destroy();
    }
  });
};

/* harmony default export */ var src_directive = (loadingDirective);
// CONCATENATED MODULE: ./packages/loading/src/index.js







var LoadingConstructor = external_vue_default.a.extend(loading);

var src_defaults = {
  text: null,
  fullscreen: true,
  body: false,
  lock: false,
  customClass: ''
};

var fullscreenLoading = void 0;

LoadingConstructor.prototype.originalPosition = '';
LoadingConstructor.prototype.originalOverflow = '';

LoadingConstructor.prototype.close = function () {
  var _this = this;

  if (this.fullscreen) {
    fullscreenLoading = undefined;
  }
  after_leave_default()(this, function (_) {
    var target = _this.fullscreen || _this.body ? document.body : _this.target;
    Object(dom_["removeClass"])(target, 'el-loading-parent--relative');
    Object(dom_["removeClass"])(target, 'el-loading-parent--hidden');
    if (_this.$el && _this.$el.parentNode) {
      _this.$el.parentNode.removeChild(_this.$el);
    }
    _this.$destroy();
  }, 300);
  this.visible = false;
};

var src_addStyle = function addStyle(options, parent, instance) {
  var maskStyle = {};
  if (options.fullscreen) {
    instance.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
    instance.originalOverflow = Object(dom_["getStyle"])(document.body, 'overflow');
    maskStyle.zIndex = popup_["PopupManager"].nextZIndex();
  } else if (options.body) {
    instance.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
    ['top', 'left'].forEach(function (property) {
      var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
      maskStyle[property] = options.target.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] + 'px';
    });
    ['height', 'width'].forEach(function (property) {
      maskStyle[property] = options.target.getBoundingClientRect()[property] + 'px';
    });
  } else {
    instance.originalPosition = Object(dom_["getStyle"])(parent, 'position');
  }
  Object.keys(maskStyle).forEach(function (property) {
    instance.$el.style[property] = maskStyle[property];
  });
};

var src_Loading = function Loading() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (external_vue_default.a.prototype.$isServer) return;
  options = merge_default()({}, src_defaults, options);
  if (typeof options.target === 'string') {
    options.target = document.querySelector(options.target);
  }
  options.target = options.target || document.body;
  if (options.target !== document.body) {
    options.fullscreen = false;
  } else {
    options.body = true;
  }
  if (options.fullscreen && fullscreenLoading) {
    return fullscreenLoading;
  }

  var parent = options.body ? document.body : options.target;
  var instance = new LoadingConstructor({
    el: document.createElement('div'),
    data: options
  });

  src_addStyle(options, parent, instance);
  if (instance.originalPosition !== 'absolute' && instance.originalPosition !== 'fixed') {
    Object(dom_["addClass"])(parent, 'el-loading-parent--relative');
  }
  if (options.fullscreen && options.lock) {
    Object(dom_["addClass"])(parent, 'el-loading-parent--hidden');
  }
  parent.appendChild(instance.$el);
  external_vue_default.a.nextTick(function () {
    instance.visible = true;
  });
  if (options.fullscreen) {
    fullscreenLoading = instance;
  }
  return instance;
};

/* harmony default export */ var src = (src_Loading);
// CONCATENATED MODULE: ./packages/loading/index.js



/* harmony default export */ var packages_loading = ({
  install: function install(Vue) {
    Vue.use(src_directive);
    Vue.prototype.$loading = src;
  },

  directive: src_directive,
  service: src
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&
var iconvue_type_template_id_cb3fe7f4_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("i", { class: "el-icon-" + _vm.name })
}
var iconvue_type_template_id_cb3fe7f4_staticRenderFns = []
iconvue_type_template_id_cb3fe7f4_render._withStripped = true


// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=script&lang=js&
//
//
//
//

/* harmony default export */ var iconvue_type_script_lang_js_ = ({
  name: 'ElIcon',

  props: {
    name: String
  }
});
// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_iconvue_type_script_lang_js_ = (iconvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/icon/src/icon.vue





/* normalize component */

var icon_component = normalizeComponent(
  src_iconvue_type_script_lang_js_,
  iconvue_type_template_id_cb3fe7f4_render,
  iconvue_type_template_id_cb3fe7f4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var icon_api; }
icon_component.options.__file = "packages/icon/src/icon.vue"
/* harmony default export */ var icon = (icon_component.exports);
// CONCATENATED MODULE: ./packages/icon/index.js


/* istanbul ignore next */
icon.install = function (Vue) {
  Vue.component(icon.name, icon);
};

/* harmony default export */ var packages_icon = (icon);
// CONCATENATED MODULE: ./packages/row/src/row.js
/* harmony default export */ var src_row = ({
  name: 'ElRow',

  componentName: 'ElRow',

  props: {
    tag: {
      type: String,
      default: 'div'
    },
    gutter: Number,
    type: String,
    justify: {
      type: String,
      default: 'start'
    },
    align: {
      type: String,
      default: 'top'
    }
  },

  computed: {
    style: function style() {
      var ret = {};

      if (this.gutter) {
        ret.marginLeft = '-' + this.gutter / 2 + 'px';
        ret.marginRight = ret.marginLeft;
      }

      return ret;
    }
  },

  render: function render(h) {
    return h(this.tag, {
      class: ['el-row', this.justify !== 'start' ? 'is-justify-' + this.justify : '', this.align !== 'top' ? 'is-align-' + this.align : '', { 'el-row--flex': this.type === 'flex' }],
      style: this.style
    }, this.$slots.default);
  }
});
// CONCATENATED MODULE: ./packages/row/index.js


/* istanbul ignore next */
src_row.install = function (Vue) {
  Vue.component(src_row.name, src_row);
};

/* harmony default export */ var packages_row = (src_row);
// CONCATENATED MODULE: ./packages/col/src/col.js
var col_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* harmony default export */ var col = ({
  name: 'ElCol',

  props: {
    span: {
      type: Number,
      default: 24
    },
    tag: {
      type: String,
      default: 'div'
    },
    offset: Number,
    pull: Number,
    push: Number,
    xs: [Number, Object],
    sm: [Number, Object],
    md: [Number, Object],
    lg: [Number, Object],
    xl: [Number, Object]
  },

  computed: {
    gutter: function gutter() {
      var parent = this.$parent;
      while (parent && parent.$options.componentName !== 'ElRow') {
        parent = parent.$parent;
      }
      return parent ? parent.gutter : 0;
    }
  },
  render: function render(h) {
    var _this = this;

    var classList = [];
    var style = {};

    if (this.gutter) {
      style.paddingLeft = this.gutter / 2 + 'px';
      style.paddingRight = style.paddingLeft;
    }

    ['span', 'offset', 'pull', 'push'].forEach(function (prop) {
      if (_this[prop] || _this[prop] === 0) {
        classList.push(prop !== 'span' ? 'el-col-' + prop + '-' + _this[prop] : 'el-col-' + _this[prop]);
      }
    });

    ['xs', 'sm', 'md', 'lg', 'xl'].forEach(function (size) {
      if (typeof _this[size] === 'number') {
        classList.push('el-col-' + size + '-' + _this[size]);
      } else if (col_typeof(_this[size]) === 'object') {
        var props = _this[size];
        Object.keys(props).forEach(function (prop) {
          classList.push(prop !== 'span' ? 'el-col-' + size + '-' + prop + '-' + props[prop] : 'el-col-' + size + '-' + props[prop]);
        });
      }
    });

    return h(this.tag, {
      class: ['el-col', classList],
      style: style
    }, this.$slots.default);
  }
});
// CONCATENATED MODULE: ./packages/col/index.js


/* istanbul ignore next */
col.install = function (Vue) {
  Vue.component(col.name, col);
};

/* harmony default export */ var packages_col = (col);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&
var upload_listvue_type_template_id_173fedf5_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    {
      class: [
        "el-upload-list",
        "el-upload-list--" + _vm.listType,
        { "is-disabled": _vm.disabled }
      ],
      attrs: { tag: "ul", name: "el-list" }
    },
    _vm._l(_vm.files, function(file) {
      return _c(
        "li",
        {
          key: file.uid,
          class: [
            "el-upload-list__item",
            "is-" + file.status,
            _vm.focusing ? "focusing" : ""
          ],
          attrs: { tabindex: "0" },
          on: {
            keydown: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                  "Backspace",
                  "Delete",
                  "Del"
                ])
              ) {
                return null
              }
              !_vm.disabled && _vm.$emit("remove", file)
            },
            focus: function($event) {
              _vm.focusing = true
            },
            blur: function($event) {
              _vm.focusing = false
            },
            click: function($event) {
              _vm.focusing = false
            }
          }
        },
        [
          _vm._t(
            "default",
            [
              file.status !== "uploading" &&
              ["picture-card", "picture"].indexOf(_vm.listType) > -1
                ? _c("img", {
                    staticClass: "el-upload-list__item-thumbnail",
                    attrs: { src: file.url, alt: "" }
                  })
                : _vm._e(),
              _c(
                "a",
                {
                  staticClass: "el-upload-list__item-name",
                  on: {
                    click: function($event) {
                      _vm.handleClick(file)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-document" }),
                  _vm._v(_vm._s(file.name) + "\n      ")
                ]
              ),
              _c(
                "label",
                { staticClass: "el-upload-list__item-status-label" },
                [
                  _c("i", {
                    class: {
                      "el-icon-upload-success": true,
                      "el-icon-circle-check": _vm.listType === "text",
                      "el-icon-check":
                        ["picture-card", "picture"].indexOf(_vm.listType) > -1
                    }
                  })
                ]
              ),
              !_vm.disabled
                ? _c("i", {
                    staticClass: "el-icon-close",
                    on: {
                      click: function($event) {
                        _vm.$emit("remove", file)
                      }
                    }
                  })
                : _vm._e(),
              !_vm.disabled
                ? _c("i", { staticClass: "el-icon-close-tip" }, [
                    _vm._v(_vm._s(_vm.t("el.upload.deleteTip")))
                  ])
                : _vm._e(),
              file.status === "uploading"
                ? _c("el-progress", {
                    attrs: {
                      type: _vm.listType === "picture-card" ? "circle" : "line",
                      "stroke-width": _vm.listType === "picture-card" ? 6 : 2,
                      percentage: _vm.parsePercentage(file.percentage)
                    }
                  })
                : _vm._e(),
              _vm.listType === "picture-card"
                ? _c("span", { staticClass: "el-upload-list__item-actions" }, [
                    _vm.handlePreview && _vm.listType === "picture-card"
                      ? _c(
                          "span",
                          {
                            staticClass: "el-upload-list__item-preview",
                            on: {
                              click: function($event) {
                                _vm.handlePreview(file)
                              }
                            }
                          },
                          [_c("i", { staticClass: "el-icon-zoom-in" })]
                        )
                      : _vm._e(),
                    !_vm.disabled
                      ? _c(
                          "span",
                          {
                            staticClass: "el-upload-list__item-delete",
                            on: {
                              click: function($event) {
                                _vm.$emit("remove", file)
                              }
                            }
                          },
                          [_c("i", { staticClass: "el-icon-delete" })]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            { file: file }
          )
        ],
        2
      )
    }),
    0
  )
}
var upload_listvue_type_template_id_173fedf5_staticRenderFns = []
upload_listvue_type_template_id_173fedf5_render._withStripped = true


// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&

// EXTERNAL MODULE: external "element-ui/lib/progress"
var progress_ = __webpack_require__(34);
var progress_default = /*#__PURE__*/__webpack_require__.n(progress_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var upload_listvue_type_script_lang_js_ = ({

  name: 'ElUploadList',

  mixins: [locale_default.a],

  data: function data() {
    return {
      focusing: false
    };
  },

  components: { ElProgress: progress_default.a },

  props: {
    files: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    handlePreview: Function,
    listType: String
  },
  methods: {
    parsePercentage: function parsePercentage(val) {
      return parseInt(val, 10);
    },
    handleClick: function handleClick(file) {
      this.handlePreview && this.handlePreview(file);
    }
  }
});
// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_upload_listvue_type_script_lang_js_ = (upload_listvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue





/* normalize component */

var upload_list_component = normalizeComponent(
  src_upload_listvue_type_script_lang_js_,
  upload_listvue_type_template_id_173fedf5_render,
  upload_listvue_type_template_id_173fedf5_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var upload_list_api; }
upload_list_component.options.__file = "packages/upload/src/upload-list.vue"
/* harmony default export */ var upload_list = (upload_list_component.exports);
// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(24);
var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);

// CONCATENATED MODULE: ./packages/upload/src/ajax.js
function getError(action, option, xhr) {
  var msg = void 0;
  if (xhr.response) {
    msg = '' + (xhr.response.error || xhr.response);
  } else if (xhr.responseText) {
    msg = '' + xhr.responseText;
  } else {
    msg = 'fail to post ' + action + ' ' + xhr.status;
  }

  var err = new Error(msg);
  err.status = xhr.status;
  err.method = 'post';
  err.url = action;
  return err;
}

function getBody(xhr) {
  var text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

function upload(option) {
  if (typeof XMLHttpRequest === 'undefined') {
    return;
  }

  var xhr = new XMLHttpRequest();
  var action = option.action;

  if (xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }
      option.onProgress(e);
    };
  }

  var formData = new FormData();

  if (option.data) {
    Object.keys(option.data).forEach(function (key) {
      formData.append(key, option.data[key]);
    });
  }

  formData.append(option.filename, option.file, option.file.name);

  xhr.onerror = function error(e) {
    option.onError(e);
  };

  xhr.onload = function onload() {
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(action, option, xhr));
    }

    option.onSuccess(getBody(xhr));
  };

  xhr.open('post', action, true);

  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }

  var headers = option.headers || {};

  for (var item in headers) {
    if (headers.hasOwnProperty(item) && headers[item] !== null) {
      xhr.setRequestHeader(item, headers[item]);
    }
  }
  xhr.send(formData);
  return xhr;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&
var upload_draggervue_type_template_id_7ebbf219_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-upload-dragger",
      class: {
        "is-dragover": _vm.dragover
      },
      on: {
        drop: function($event) {
          $event.preventDefault()
          return _vm.onDrop($event)
        },
        dragover: function($event) {
          $event.preventDefault()
          return _vm.onDragover($event)
        },
        dragleave: function($event) {
          $event.preventDefault()
          _vm.dragover = false
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var upload_draggervue_type_template_id_7ebbf219_staticRenderFns = []
upload_draggervue_type_template_id_7ebbf219_render._withStripped = true


// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var upload_draggervue_type_script_lang_js_ = ({
  name: 'ElUploadDrag',
  props: {
    disabled: Boolean
  },
  inject: {
    uploader: {
      default: ''
    }
  },
  data: function data() {
    return {
      dragover: false
    };
  },

  methods: {
    onDragover: function onDragover() {
      if (!this.disabled) {
        this.dragover = true;
      }
    },
    onDrop: function onDrop(e) {
      if (this.disabled || !this.uploader) return;
      var accept = this.uploader.accept;
      this.dragover = false;
      if (!accept) {
        this.$emit('file', e.dataTransfer.files);
        return;
      }
      this.$emit('file', [].slice.call(e.dataTransfer.files).filter(function (file) {
        var type = file.type,
            name = file.name;

        var extension = name.indexOf('.') > -1 ? '.' + name.split('.').pop() : '';
        var baseType = type.replace(/\/.*$/, '');
        return accept.split(',').map(function (type) {
          return type.trim();
        }).filter(function (type) {
          return type;
        }).some(function (acceptedType) {
          if (/\..+$/.test(acceptedType)) {
            return extension === acceptedType;
          }
          if (/\/\*$/.test(acceptedType)) {
            return baseType === acceptedType.replace(/\/\*$/, '');
          }
          if (/^[^\/]+\/[^\/]+$/.test(acceptedType)) {
            return type === acceptedType;
          }
          return false;
        });
      }));
    }
  }
});
// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_upload_draggervue_type_script_lang_js_ = (upload_draggervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue





/* normalize component */

var upload_dragger_component = normalizeComponent(
  src_upload_draggervue_type_script_lang_js_,
  upload_draggervue_type_template_id_7ebbf219_render,
  upload_draggervue_type_template_id_7ebbf219_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var upload_dragger_api; }
upload_dragger_component.options.__file = "packages/upload/src/upload-dragger.vue"
/* harmony default export */ var upload_dragger = (upload_dragger_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload.vue?vue&type=script&lang=js&





/* harmony default export */ var uploadvue_type_script_lang_js_ = ({
  inject: ['uploader'],
  components: {
    UploadDragger: upload_dragger
  },
  props: {
    type: String,
    action: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: 'file'
    },
    data: Object,
    headers: Object,
    withCredentials: Boolean,
    multiple: Boolean,
    accept: String,
    onStart: Function,
    onProgress: Function,
    onSuccess: Function,
    onError: Function,
    beforeUpload: Function,
    drag: Boolean,
    onPreview: {
      type: Function,
      default: function _default() {}
    },
    onRemove: {
      type: Function,
      default: function _default() {}
    },
    fileList: Array,
    autoUpload: Boolean,
    listType: String,
    httpRequest: {
      type: Function,
      default: upload
    },
    disabled: Boolean,
    limit: Number,
    onExceed: Function
  },

  data: function data() {
    return {
      mouseover: false,
      reqs: {}
    };
  },


  methods: {
    isImage: function isImage(str) {
      return str.indexOf('image') !== -1;
    },
    handleChange: function handleChange(ev) {
      var files = ev.target.files;

      if (!files) return;
      this.uploadFiles(files);
    },
    uploadFiles: function uploadFiles(files) {
      var _this = this;

      if (this.limit && this.fileList.length + files.length > this.limit) {
        this.onExceed && this.onExceed(files, this.fileList);
        return;
      }

      var postFiles = Array.prototype.slice.call(files);
      if (!this.multiple) {
        postFiles = postFiles.slice(0, 1);
      }

      if (postFiles.length === 0) {
        return;
      }

      postFiles.forEach(function (rawFile) {
        _this.onStart(rawFile);
        if (_this.autoUpload) _this.upload(rawFile);
      });
    },
    upload: function upload(rawFile) {
      var _this2 = this;

      this.$refs.input.value = null;

      if (!this.beforeUpload) {
        return this.post(rawFile);
      }

      var before = this.beforeUpload(rawFile);
      if (before && before.then) {
        before.then(function (processedFile) {
          var fileType = Object.prototype.toString.call(processedFile);

          if (fileType === '[object File]' || fileType === '[object Blob]') {
            if (fileType === '[object Blob]') {
              processedFile = new File([processedFile], rawFile.name, {
                type: rawFile.type
              });
            }
            for (var p in rawFile) {
              if (rawFile.hasOwnProperty(p)) {
                processedFile[p] = rawFile[p];
              }
            }
            _this2.post(processedFile);
          } else {
            _this2.post(rawFile);
          }
        }, function () {
          _this2.onRemove(null, rawFile);
        });
      } else if (before !== false) {
        this.post(rawFile);
      } else {
        this.onRemove(null, rawFile);
      }
    },
    abort: function abort(file) {
      var reqs = this.reqs;

      if (file) {
        var uid = file;
        if (file.uid) uid = file.uid;
        if (reqs[uid]) {
          reqs[uid].abort();
        }
      } else {
        Object.keys(reqs).forEach(function (uid) {
          if (reqs[uid]) reqs[uid].abort();
          delete reqs[uid];
        });
      }
    },
    post: function post(rawFile) {
      var _this3 = this;

      var uid = rawFile.uid;

      var options = {
        headers: this.headers,
        withCredentials: this.withCredentials,
        file: rawFile,
        data: this.data,
        filename: this.name,
        action: this.action,
        onProgress: function onProgress(e) {
          _this3.onProgress(e, rawFile);
        },
        onSuccess: function onSuccess(res) {
          _this3.onSuccess(res, rawFile);
          delete _this3.reqs[uid];
        },
        onError: function onError(err) {
          _this3.onError(err, rawFile);
          delete _this3.reqs[uid];
        }
      };
      var req = this.httpRequest(options);
      this.reqs[uid] = req;
      if (req && req.then) {
        req.then(options.onSuccess, options.onError);
      }
    },
    handleClick: function handleClick() {
      if (!this.disabled) {
        this.$refs.input.value = null;
        this.$refs.input.click();
      }
    },
    handleKeydown: function handleKeydown(e) {
      if (e.target !== e.currentTarget) return;
      if (e.keyCode === 13 || e.keyCode === 32) {
        this.handleClick();
      }
    }
  },

  render: function render(h) {
    var handleClick = this.handleClick,
        drag = this.drag,
        name = this.name,
        handleChange = this.handleChange,
        multiple = this.multiple,
        accept = this.accept,
        listType = this.listType,
        uploadFiles = this.uploadFiles,
        disabled = this.disabled,
        handleKeydown = this.handleKeydown;

    var data = {
      class: {
        'el-upload': true
      },
      on: {
        click: handleClick,
        keydown: handleKeydown
      }
    };
    data.class['el-upload--' + listType] = true;
    return h(
      'div',
      external_babel_helper_vue_jsx_merge_props_default()([data, {
        attrs: { tabindex: '0' }
      }]),
      [drag ? h(
        'upload-dragger',
        {
          attrs: { disabled: disabled },
          on: {
            'file': uploadFiles
          }
        },
        [this.$slots.default]
      ) : this.$slots.default, h('input', { 'class': 'el-upload__input', attrs: { type: 'file', name: name, multiple: multiple, accept: accept },
        ref: 'input', on: {
          'change': handleChange
        }
      })]
    );
  }
});
// CONCATENATED MODULE: ./packages/upload/src/upload.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_uploadvue_type_script_lang_js_ = (uploadvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/upload/src/upload.vue
var upload_render, upload_staticRenderFns




/* normalize component */

var upload_component = normalizeComponent(
  src_uploadvue_type_script_lang_js_,
  upload_render,
  upload_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var upload_api; }
upload_component.options.__file = "packages/upload/src/upload.vue"
/* harmony default export */ var src_upload = (upload_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/index.vue?vue&type=script&lang=js&






function srcvue_type_script_lang_js_noop() {}

/* harmony default export */ var srcvue_type_script_lang_js_ = ({
  name: 'ElUpload',

  mixins: [migrating_default.a],

  components: {
    ElProgress: progress_default.a,
    UploadList: upload_list,
    Upload: src_upload
  },

  provide: function provide() {
    return {
      uploader: this
    };
  },


  inject: {
    elForm: {
      default: ''
    }
  },

  props: {
    action: {
      type: String,
      required: true
    },
    headers: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    data: Object,
    multiple: Boolean,
    name: {
      type: String,
      default: 'file'
    },
    drag: Boolean,
    dragger: Boolean,
    withCredentials: Boolean,
    showFileList: {
      type: Boolean,
      default: true
    },
    accept: String,
    type: {
      type: String,
      default: 'select'
    },
    beforeUpload: Function,
    beforeRemove: Function,
    onRemove: {
      type: Function,
      default: srcvue_type_script_lang_js_noop
    },
    onChange: {
      type: Function,
      default: srcvue_type_script_lang_js_noop
    },
    onPreview: {
      type: Function
    },
    onSuccess: {
      type: Function,
      default: srcvue_type_script_lang_js_noop
    },
    onProgress: {
      type: Function,
      default: srcvue_type_script_lang_js_noop
    },
    onError: {
      type: Function,
      default: srcvue_type_script_lang_js_noop
    },
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    listType: {
      type: String,
      default: 'text' // text,picture,picture-card
    },
    httpRequest: Function,
    disabled: Boolean,
    limit: Number,
    onExceed: {
      type: Function,
      default: srcvue_type_script_lang_js_noop
    }
  },

  data: function data() {
    return {
      uploadFiles: [],
      dragOver: false,
      draging: false,
      tempIndex: 1
    };
  },


  computed: {
    uploadDisabled: function uploadDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  watch: {
    listType: function listType(type) {
      if (type === 'picture-card' || type === 'picture') {
        this.uploadFiles = this.uploadFiles.map(function (file) {
          if (!file.url && file.raw) {
            try {
              file.url = URL.createObjectURL(file.raw);
            } catch (err) {
              console.error('[Element Error][Upload]', err);
            }
          }
          return file;
        });
      }
    },

    fileList: {
      immediate: true,
      handler: function handler(fileList) {
        var _this = this;

        this.uploadFiles = fileList.map(function (item) {
          item.uid = item.uid || Date.now() + _this.tempIndex++;
          item.status = item.status || 'success';
          return item;
        });
      }
    }
  },

  methods: {
    handleStart: function handleStart(rawFile) {
      rawFile.uid = Date.now() + this.tempIndex++;
      var file = {
        status: 'ready',
        name: rawFile.name,
        size: rawFile.size,
        percentage: 0,
        uid: rawFile.uid,
        raw: rawFile
      };

      if (this.listType === 'picture-card' || this.listType === 'picture') {
        try {
          file.url = URL.createObjectURL(rawFile);
        } catch (err) {
          console.error('[Element Error][Upload]', err);
          return;
        }
      }

      this.uploadFiles.push(file);
      this.onChange(file, this.uploadFiles);
    },
    handleProgress: function handleProgress(ev, rawFile) {
      var file = this.getFile(rawFile);
      this.onProgress(ev, file, this.uploadFiles);
      file.status = 'uploading';
      file.percentage = ev.percent || 0;
    },
    handleSuccess: function handleSuccess(res, rawFile) {
      var file = this.getFile(rawFile);

      if (file) {
        file.status = 'success';
        file.response = res;

        this.onSuccess(res, file, this.uploadFiles);
        this.onChange(file, this.uploadFiles);
      }
    },
    handleError: function handleError(err, rawFile) {
      var file = this.getFile(rawFile);
      var fileList = this.uploadFiles;

      file.status = 'fail';

      fileList.splice(fileList.indexOf(file), 1);

      this.onError(err, file, this.uploadFiles);
      this.onChange(file, this.uploadFiles);
    },
    handleRemove: function handleRemove(file, raw) {
      var _this2 = this;

      if (raw) {
        file = this.getFile(raw);
      }
      var doRemove = function doRemove() {
        _this2.abort(file);
        var fileList = _this2.uploadFiles;
        fileList.splice(fileList.indexOf(file), 1);
        _this2.onRemove(file, fileList);
      };

      if (!this.beforeRemove) {
        doRemove();
      } else if (typeof this.beforeRemove === 'function') {
        var before = this.beforeRemove(file, this.uploadFiles);
        if (before && before.then) {
          before.then(function () {
            doRemove();
          }, srcvue_type_script_lang_js_noop);
        } else if (before !== false) {
          doRemove();
        }
      }
    },
    getFile: function getFile(rawFile) {
      var fileList = this.uploadFiles;
      var target = void 0;
      fileList.every(function (item) {
        target = rawFile.uid === item.uid ? item : null;
        return !target;
      });
      return target;
    },
    abort: function abort(file) {
      this.$refs['upload-inner'].abort(file);
    },
    clearFiles: function clearFiles() {
      this.uploadFiles = [];
    },
    submit: function submit() {
      var _this3 = this;

      this.uploadFiles.filter(function (file) {
        return file.status === 'ready';
      }).forEach(function (file) {
        _this3.$refs['upload-inner'].upload(file.raw);
      });
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'default-file-list': 'default-file-list is renamed to file-list.',
          'show-upload-list': 'show-upload-list is renamed to show-file-list.',
          'thumbnail-mode': 'thumbnail-mode has been deprecated, you can implement the same effect according to this case: http://element.eleme.io/#/zh-CN/component/upload#yong-hu-tou-xiang-shang-chuan'
        }
      };
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.uploadFiles.forEach(function (file) {
      if (file.url && file.url.indexOf('blob:') === 0) {
        URL.revokeObjectURL(file.url);
      }
    });
  },
  render: function render(h) {
    var _this4 = this;

    var uploadList = void 0;

    if (this.showFileList) {
      uploadList = h(
        upload_list,
        {
          attrs: {
            disabled: this.uploadDisabled,
            listType: this.listType,
            files: this.uploadFiles,

            handlePreview: this.onPreview },
          on: {
            'remove': this.handleRemove
          }
        },
        [function (props) {
          if (_this4.$scopedSlots.file) {
            return _this4.$scopedSlots.file({
              file: props.file
            });
          }
        }]
      );
    }

    var uploadData = {
      props: {
        type: this.type,
        drag: this.drag,
        action: this.action,
        multiple: this.multiple,
        'before-upload': this.beforeUpload,
        'with-credentials': this.withCredentials,
        headers: this.headers,
        name: this.name,
        data: this.data,
        accept: this.accept,
        fileList: this.uploadFiles,
        autoUpload: this.autoUpload,
        listType: this.listType,
        disabled: this.uploadDisabled,
        limit: this.limit,
        'on-exceed': this.onExceed,
        'on-start': this.handleStart,
        'on-progress': this.handleProgress,
        'on-success': this.handleSuccess,
        'on-error': this.handleError,
        'on-preview': this.onPreview,
        'on-remove': this.handleRemove,
        'http-request': this.httpRequest
      },
      ref: 'upload-inner'
    };

    var trigger = this.$slots.trigger || this.$slots.default;
    var uploadComponent = h(
      'upload',
      uploadData,
      [trigger]
    );

    return h('div', [this.listType === 'picture-card' ? uploadList : '', this.$slots.trigger ? [uploadComponent, this.$slots.default] : uploadComponent, this.$slots.tip, this.listType !== 'picture-card' ? uploadList : '']);
  }
});
// CONCATENATED MODULE: ./packages/upload/src/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var upload_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/upload/src/index.vue
var src_render, src_staticRenderFns




/* normalize component */

var upload_src_component = normalizeComponent(
  upload_srcvue_type_script_lang_js_,
  src_render,
  src_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var src_api; }
upload_src_component.options.__file = "packages/upload/src/index.vue"
/* harmony default export */ var upload_src = (upload_src_component.exports);
// CONCATENATED MODULE: ./packages/upload/index.js


/* istanbul ignore next */
upload_src.install = function (Vue) {
  Vue.component(upload_src.name, upload_src);
};

/* harmony default export */ var packages_upload = (upload_src);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
var progressvue_type_template_id_229ee406_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-progress",
      class: [
        "el-progress--" + _vm.type,
        _vm.status ? "is-" + _vm.status : "",
        {
          "el-progress--without-text": !_vm.showText,
          "el-progress--text-inside": _vm.textInside
        }
      ],
      attrs: {
        role: "progressbar",
        "aria-valuenow": _vm.percentage,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }
    },
    [
      _vm.type === "line"
        ? _c("div", { staticClass: "el-progress-bar" }, [
            _c(
              "div",
              {
                staticClass: "el-progress-bar__outer",
                style: { height: _vm.strokeWidth + "px" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "el-progress-bar__inner",
                    style: _vm.barStyle
                  },
                  [
                    _vm.showText && _vm.textInside
                      ? _c(
                          "div",
                          { staticClass: "el-progress-bar__innerText" },
                          [_vm._v(_vm._s(_vm.content))]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ])
        : _c(
            "div",
            {
              staticClass: "el-progress-circle",
              style: { height: _vm.width + "px", width: _vm.width + "px" }
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 100 100" } }, [
                _c("path", {
                  staticClass: "el-progress-circle__track",
                  style: _vm.trailPathStyle,
                  attrs: {
                    d: _vm.trackPath,
                    stroke: "#e5e9f2",
                    "stroke-width": _vm.relativeStrokeWidth,
                    fill: "none"
                  }
                }),
                _c("path", {
                  staticClass: "el-progress-circle__path",
                  style: _vm.circlePathStyle,
                  attrs: {
                    d: _vm.trackPath,
                    stroke: _vm.stroke,
                    fill: "none",
                    "stroke-linecap": _vm.strokeLinecap,
                    "stroke-width": _vm.percentage ? _vm.relativeStrokeWidth : 0
                  }
                })
              ])
            ]
          ),
      _vm.showText && !_vm.textInside
        ? _c(
            "div",
            {
              staticClass: "el-progress__text",
              style: { fontSize: _vm.progressTextSize + "px" }
            },
            [
              !_vm.status
                ? [_vm._v(_vm._s(_vm.content))]
                : _c("i", { class: _vm.iconClass })
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var progressvue_type_template_id_229ee406_staticRenderFns = []
progressvue_type_template_id_229ee406_render._withStripped = true


// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var progressvue_type_script_lang_js_ = ({
  name: 'ElProgress',
  props: {
    type: {
      type: String,
      default: 'line',
      validator: function validator(val) {
        return ['line', 'circle', 'dashboard'].indexOf(val) > -1;
      }
    },
    percentage: {
      type: Number,
      default: 0,
      required: true,
      validator: function validator(val) {
        return val >= 0 && val <= 100;
      }
    },
    status: {
      type: String,
      validator: function validator(val) {
        return ['success', 'exception', 'warning'].indexOf(val) > -1;
      }
    },
    strokeWidth: {
      type: Number,
      default: 6
    },
    strokeLinecap: {
      type: String,
      default: 'round'
    },
    textInside: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 126
    },
    showText: {
      type: Boolean,
      default: true
    },
    color: {
      type: [String, Array, Function],
      default: ''
    },
    format: Function
  },
  computed: {
    barStyle: function barStyle() {
      var style = {};
      style.width = this.percentage + '%';
      style.backgroundColor = this.getCurrentColor(this.percentage);
      return style;
    },
    relativeStrokeWidth: function relativeStrokeWidth() {
      return (this.strokeWidth / this.width * 100).toFixed(1);
    },
    radius: function radius() {
      if (this.type === 'circle' || this.type === 'dashboard') {
        return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
      } else {
        return 0;
      }
    },
    trackPath: function trackPath() {
      var radius = this.radius;
      var isDashboard = this.type === 'dashboard';
      return '\n        M 50 50\n        m 0 ' + (isDashboard ? '' : '-') + radius + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '-' : '') + radius * 2 + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '' : '-') + radius * 2 + '\n        ';
    },
    perimeter: function perimeter() {
      return 2 * Math.PI * this.radius;
    },
    rate: function rate() {
      return this.type === 'dashboard' ? 0.75 : 1;
    },
    strokeDashoffset: function strokeDashoffset() {
      var offset = -1 * this.perimeter * (1 - this.rate) / 2;
      return offset + 'px';
    },
    trailPathStyle: function trailPathStyle() {
      return {
        strokeDasharray: this.perimeter * this.rate + 'px, ' + this.perimeter + 'px',
        strokeDashoffset: this.strokeDashoffset
      };
    },
    circlePathStyle: function circlePathStyle() {
      return {
        strokeDasharray: this.perimeter * this.rate * (this.percentage / 100) + 'px, ' + this.perimeter + 'px',
        strokeDashoffset: this.strokeDashoffset,
        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
      };
    },
    stroke: function stroke() {
      var ret = void 0;
      if (this.color) {
        ret = this.getCurrentColor(this.percentage);
      } else {
        switch (this.status) {
          case 'success':
            ret = '#13ce66';
            break;
          case 'exception':
            ret = '#ff4949';
            break;
          case 'warning':
            ret = '#e6a23c';
            break;
          default:
            ret = '#20a0ff';
        }
      }
      return ret;
    },
    iconClass: function iconClass() {
      if (this.status === 'warning') {
        return 'el-icon-warning';
      }
      if (this.type === 'line') {
        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
      } else {
        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
      }
    },
    progressTextSize: function progressTextSize() {
      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
    },
    content: function content() {
      if (typeof this.format === 'function') {
        return this.format(this.percentage) || '';
      } else {
        return this.percentage + '%';
      }
    }
  },
  methods: {
    getCurrentColor: function getCurrentColor(percentage) {
      if (typeof this.color === 'function') {
        return this.color(percentage);
      } else if (typeof this.color === 'string') {
        return this.color;
      } else {
        return this.getLevelColor(percentage);
      }
    },
    getLevelColor: function getLevelColor(percentage) {
      var colorArray = this.getColorArray().sort(function (a, b) {
        return a.percentage - b.percentage;
      });

      for (var i = 0; i < colorArray.length; i++) {
        if (colorArray[i].percentage > percentage) {
          return colorArray[i].color;
        }
      }
      return colorArray[colorArray.length - 1].color;
    },
    getColorArray: function getColorArray() {
      var color = this.color;
      var span = 100 / color.length;
      return color.map(function (seriesColor, index) {
        if (typeof seriesColor === 'string') {
          return {
            color: seriesColor,
            progress: (index + 1) * span
          };
        }
        return seriesColor;
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_progressvue_type_script_lang_js_ = (progressvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/progress/src/progress.vue





/* normalize component */

var progress_component = normalizeComponent(
  src_progressvue_type_script_lang_js_,
  progressvue_type_template_id_229ee406_render,
  progressvue_type_template_id_229ee406_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var progress_api; }
progress_component.options.__file = "packages/progress/src/progress.vue"
/* harmony default export */ var progress = (progress_component.exports);
// CONCATENATED MODULE: ./packages/progress/index.js


/* istanbul ignore next */
progress.install = function (Vue) {
  Vue.component(progress.name, progress);
};

/* harmony default export */ var packages_progress = (progress);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&
var spinnervue_type_template_id_697b8538_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "el-spinner" }, [
    _c(
      "svg",
      {
        staticClass: "el-spinner-inner",
        style: { width: _vm.radius / 2 + "px", height: _vm.radius / 2 + "px" },
        attrs: { viewBox: "0 0 50 50" }
      },
      [
        _c("circle", {
          staticClass: "path",
          attrs: {
            cx: "25",
            cy: "25",
            r: "20",
            fill: "none",
            stroke: _vm.strokeColor,
            "stroke-width": _vm.strokeWidth
          }
        })
      ]
    )
  ])
}
var spinnervue_type_template_id_697b8538_staticRenderFns = []
spinnervue_type_template_id_697b8538_render._withStripped = true


// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/* harmony default export */ var spinnervue_type_script_lang_js_ = ({
  name: 'ElSpinner',
  props: {
    type: String,
    radius: {
      type: Number,
      default: 100
    },
    strokeWidth: {
      type: Number,
      default: 5
    },
    strokeColor: {
      type: String,
      default: '#efefef'
    }
  }
});
// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_spinnervue_type_script_lang_js_ = (spinnervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue





/* normalize component */

var spinner_component = normalizeComponent(
  src_spinnervue_type_script_lang_js_,
  spinnervue_type_template_id_697b8538_render,
  spinnervue_type_template_id_697b8538_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var spinner_api; }
spinner_component.options.__file = "packages/spinner/src/spinner.vue"
/* harmony default export */ var spinner = (spinner_component.exports);
// CONCATENATED MODULE: ./packages/spinner/index.js


/* istanbul ignore next */
spinner.install = function (Vue) {
  Vue.component(spinner.name, spinner);
};

/* harmony default export */ var packages_spinner = (spinner);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=template&id=455b9f60&
var mainvue_type_template_id_455b9f60_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "el-message-fade" },
      on: { "after-leave": _vm.handleAfterLeave }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          class: [
            "el-message",
            _vm.type && !_vm.iconClass ? "el-message--" + _vm.type : "",
            _vm.center ? "is-center" : "",
            _vm.showClose ? "is-closable" : "",
            _vm.customClass
          ],
          style: _vm.positionStyle,
          attrs: { role: "alert" },
          on: { mouseenter: _vm.clearTimer, mouseleave: _vm.startTimer }
        },
        [
          _vm.iconClass
            ? _c("i", { class: _vm.iconClass })
            : _c("i", { class: _vm.typeClass }),
          _vm._t("default", [
            !_vm.dangerouslyUseHTMLString
              ? _c("p", { staticClass: "el-message__content" }, [
                  _vm._v(_vm._s(_vm.message))
                ])
              : _c("p", {
                  staticClass: "el-message__content",
                  domProps: { innerHTML: _vm._s(_vm.message) }
                })
          ]),
          _vm.showClose
            ? _c("i", {
                staticClass: "el-message__closeBtn el-icon-close",
                on: { click: _vm.close }
              })
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var mainvue_type_template_id_455b9f60_staticRenderFns = []
mainvue_type_template_id_455b9f60_render._withStripped = true


// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=template&id=455b9f60&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var src_mainvue_type_script_lang_js_typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

/* harmony default export */ var message_src_mainvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      visible: false,
      message: '',
      duration: 3000,
      type: 'info',
      iconClass: '',
      customClass: '',
      onClose: null,
      showClose: false,
      closed: false,
      verticalOffset: 20,
      timer: null,
      dangerouslyUseHTMLString: false,
      center: false
    };
  },


  computed: {
    typeClass: function typeClass() {
      return this.type && !this.iconClass ? 'el-message__icon el-icon-' + src_mainvue_type_script_lang_js_typeMap[this.type] : '';
    },
    positionStyle: function positionStyle() {
      return {
        'top': this.verticalOffset + 'px'
      };
    }
  },

  watch: {
    closed: function closed(newVal) {
      if (newVal) {
        this.visible = false;
      }
    }
  },

  methods: {
    handleAfterLeave: function handleAfterLeave() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    close: function close() {
      this.closed = true;
      if (typeof this.onClose === 'function') {
        this.onClose(this);
      }
    },
    clearTimer: function clearTimer() {
      clearTimeout(this.timer);
    },
    startTimer: function startTimer() {
      var _this = this;

      if (this.duration > 0) {
        this.timer = setTimeout(function () {
          if (!_this.closed) {
            _this.close();
          }
        }, this.duration);
      }
    },
    keydown: function keydown(e) {
      if (e.keyCode === 27) {
        // esc关闭消息
        if (!this.closed) {
          this.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.startTimer();
    document.addEventListener('keydown', this.keydown);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.keydown);
  }
});
// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_message_src_mainvue_type_script_lang_js_ = (message_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/message/src/main.vue





/* normalize component */

var message_src_main_component = normalizeComponent(
  packages_message_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_455b9f60_render,
  mainvue_type_template_id_455b9f60_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var message_src_main_api; }
message_src_main_component.options.__file = "packages/message/src/main.vue"
/* harmony default export */ var message_src_main = (message_src_main_component.exports);
// CONCATENATED MODULE: ./packages/message/src/main.js




var MessageConstructor = external_vue_default.a.extend(message_src_main);

var message_src_main_instance = void 0;
var main_instances = [];
var main_seed = 1;

var main_Message = function Message(options) {
  if (external_vue_default.a.prototype.$isServer) return;
  options = options || {};
  if (typeof options === 'string') {
    options = {
      message: options
    };
  }
  var userOnClose = options.onClose;
  var id = 'message_' + main_seed++;

  options.onClose = function () {
    Message.close(id, userOnClose);
  };
  message_src_main_instance = new MessageConstructor({
    data: options
  });
  message_src_main_instance.id = id;
  if (Object(vdom_["isVNode"])(message_src_main_instance.message)) {
    message_src_main_instance.$slots.default = [message_src_main_instance.message];
    message_src_main_instance.message = null;
  }
  message_src_main_instance.$mount();
  document.body.appendChild(message_src_main_instance.$el);
  var verticalOffset = options.offset || 20;
  main_instances.forEach(function (item) {
    verticalOffset += item.$el.offsetHeight + 16;
  });
  message_src_main_instance.verticalOffset = verticalOffset;
  message_src_main_instance.visible = true;
  message_src_main_instance.$el.style.zIndex = popup_["PopupManager"].nextZIndex();
  main_instances.push(message_src_main_instance);
  return message_src_main_instance;
};

['success', 'warning', 'info', 'error'].forEach(function (type) {
  main_Message[type] = function (options) {
    if (typeof options === 'string') {
      options = {
        message: options
      };
    }
    options.type = type;
    return main_Message(options);
  };
});

main_Message.close = function (id, userOnClose) {
  var len = main_instances.length;
  var index = -1;
  var removedHeight = void 0;
  for (var i = 0; i < len; i++) {
    if (id === main_instances[i].id) {
      removedHeight = main_instances[i].$el.offsetHeight;
      index = i;
      if (typeof userOnClose === 'function') {
        userOnClose(main_instances[i]);
      }
      main_instances.splice(i, 1);
      break;
    }
  }
  if (len <= 1 || index === -1 || index > main_instances.length - 1) return;
  for (var _i = index; _i < len - 1; _i++) {
    var dom = main_instances[_i].$el;
    dom.style['top'] = parseInt(dom.style['top'], 10) - removedHeight - 16 + 'px';
  }
};

main_Message.closeAll = function () {
  for (var i = main_instances.length - 1; i >= 0; i--) {
    main_instances[i].close();
  }
};

/* harmony default export */ var packages_message_src_main = (main_Message);
// CONCATENATED MODULE: ./packages/message/index.js

/* harmony default export */ var packages_message = (packages_message_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&
var mainvue_type_template_id_7ccb6598_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-badge" },
    [
      _vm._t("default"),
      _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
        _c("sup", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.hidden && (_vm.content || _vm.content === 0 || _vm.isDot),
              expression: "!hidden && (content || content === 0 || isDot)"
            }
          ],
          staticClass: "el-badge__content",
          class: [
            "el-badge__content--" + _vm.type,
            {
              "is-fixed": _vm.$slots.default,
              "is-dot": _vm.isDot
            }
          ],
          domProps: { textContent: _vm._s(_vm.content) }
        })
      ])
    ],
    2
  )
}
var mainvue_type_template_id_7ccb6598_staticRenderFns = []
mainvue_type_template_id_7ccb6598_render._withStripped = true


// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var badge_src_mainvue_type_script_lang_js_ = ({
  name: 'ElBadge',

  props: {
    value: [String, Number],
    max: Number,
    isDot: Boolean,
    hidden: Boolean,
    type: {
      type: String,
      validator: function validator(val) {
        return ['primary', 'success', 'warning', 'info', 'danger'].indexOf(val) > -1;
      }
    }
  },

  computed: {
    content: function content() {
      if (this.isDot) return;

      var value = this.value;
      var max = this.max;

      if (typeof value === 'number' && typeof max === 'number') {
        return max < value ? max + '+' : value;
      }

      return value;
    }
  }
});
// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_badge_src_mainvue_type_script_lang_js_ = (badge_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/badge/src/main.vue





/* normalize component */

var badge_src_main_component = normalizeComponent(
  packages_badge_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_7ccb6598_render,
  mainvue_type_template_id_7ccb6598_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var badge_src_main_api; }
badge_src_main_component.options.__file = "packages/badge/src/main.vue"
/* harmony default export */ var badge_src_main = (badge_src_main_component.exports);
// CONCATENATED MODULE: ./packages/badge/index.js


/* istanbul ignore next */
badge_src_main.install = function (Vue) {
  Vue.component(badge_src_main.name, badge_src_main);
};

/* harmony default export */ var badge = (badge_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
var mainvue_type_template_id_59a4a40f_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-card",
      class: _vm.shadow ? "is-" + _vm.shadow + "-shadow" : "is-always-shadow"
    },
    [
      _vm.$slots.header || _vm.header
        ? _c(
            "div",
            { staticClass: "el-card__header" },
            [_vm._t("header", [_vm._v(_vm._s(_vm.header))])],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "el-card__body", style: _vm.bodyStyle },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var mainvue_type_template_id_59a4a40f_staticRenderFns = []
mainvue_type_template_id_59a4a40f_render._withStripped = true


// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=template&id=59a4a40f&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var card_src_mainvue_type_script_lang_js_ = ({
  name: 'ElCard',
  props: {
    header: {},
    bodyStyle: {},
    shadow: {
      type: String
    }
  }
});
// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_card_src_mainvue_type_script_lang_js_ = (card_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/card/src/main.vue





/* normalize component */

var card_src_main_component = normalizeComponent(
  packages_card_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_59a4a40f_render,
  mainvue_type_template_id_59a4a40f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var card_src_main_api; }
card_src_main_component.options.__file = "packages/card/src/main.vue"
/* harmony default export */ var card_src_main = (card_src_main_component.exports);
// CONCATENATED MODULE: ./packages/card/index.js


/* istanbul ignore next */
card_src_main.install = function (Vue) {
  Vue.component(card_src_main.name, card_src_main);
};

/* harmony default export */ var card = (card_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=template&id=ada57782&
var mainvue_type_template_id_ada57782_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-rate",
      attrs: {
        role: "slider",
        "aria-valuenow": _vm.currentValue,
        "aria-valuetext": _vm.text,
        "aria-valuemin": "0",
        "aria-valuemax": _vm.max,
        tabindex: "0"
      },
      on: { keydown: _vm.handleKey }
    },
    [
      _vm._l(_vm.max, function(item, key) {
        return _c(
          "span",
          {
            key: key,
            staticClass: "el-rate__item",
            style: { cursor: _vm.rateDisabled ? "auto" : "pointer" },
            on: {
              mousemove: function($event) {
                _vm.setCurrentValue(item, $event)
              },
              mouseleave: _vm.resetCurrentValue,
              click: function($event) {
                _vm.selectValue(item)
              }
            }
          },
          [
            _c(
              "i",
              {
                staticClass: "el-rate__icon",
                class: [
                  _vm.classes[item - 1],
                  { hover: _vm.hoverIndex === item }
                ],
                style: _vm.getIconStyle(item)
              },
              [
                _vm.showDecimalIcon(item)
                  ? _c("i", {
                      staticClass: "el-rate__decimal",
                      class: _vm.decimalIconClass,
                      style: _vm.decimalStyle
                    })
                  : _vm._e()
              ]
            )
          ]
        )
      }),
      _vm.showText || _vm.showScore
        ? _c(
            "span",
            { staticClass: "el-rate__text", style: { color: _vm.textColor } },
            [_vm._v(_vm._s(_vm.text))]
          )
        : _vm._e()
    ],
    2
  )
}
var mainvue_type_template_id_ada57782_staticRenderFns = []
mainvue_type_template_id_ada57782_render._withStripped = true


// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=template&id=ada57782&

// EXTERNAL MODULE: external "element-ui/lib/utils/types"
var types_ = __webpack_require__(18);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var rate_src_mainvue_type_script_lang_js_ = ({
  name: 'ElRate',

  mixins: [migrating_default.a],

  inject: {
    elForm: {
      default: ''
    }
  },

  data: function data() {
    return {
      pointerAtLeftHalf: true,
      currentValue: this.value,
      hoverIndex: -1
    };
  },


  props: {
    value: {
      type: Number,
      default: 0
    },
    lowThreshold: {
      type: Number,
      default: 2
    },
    highThreshold: {
      type: Number,
      default: 4
    },
    max: {
      type: Number,
      default: 5
    },
    colors: {
      type: [Array, Object],
      default: function _default() {
        return ['#F7BA2A', '#F7BA2A', '#F7BA2A'];
      }
    },
    voidColor: {
      type: String,
      default: '#C6D1DE'
    },
    disabledVoidColor: {
      type: String,
      default: '#EFF2F7'
    },
    iconClasses: {
      type: [Array, Object],
      default: function _default() {
        return ['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on'];
      }
    },
    voidIconClass: {
      type: String,
      default: 'el-icon-star-off'
    },
    disabledVoidIconClass: {
      type: String,
      default: 'el-icon-star-on'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowHalf: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: false
    },
    showScore: {
      type: Boolean,
      default: false
    },
    textColor: {
      type: String,
      default: '#1f2d3d'
    },
    texts: {
      type: Array,
      default: function _default() {
        return ['极差', '失望', '一般', '满意', '惊喜'];
      }
    },
    scoreTemplate: {
      type: String,
      default: '{value}'
    }
  },

  computed: {
    text: function text() {
      var result = '';
      if (this.showScore) {
        result = this.scoreTemplate.replace(/\{\s*value\s*\}/, this.rateDisabled ? this.value : this.currentValue);
      } else if (this.showText) {
        result = this.texts[Math.ceil(this.currentValue) - 1];
      }
      return result;
    },
    decimalStyle: function decimalStyle() {
      var width = '';
      if (this.rateDisabled) {
        width = this.valueDecimal + '%';
      } else if (this.allowHalf) {
        width = '50%';
      }
      return {
        color: this.activeColor,
        width: width
      };
    },
    valueDecimal: function valueDecimal() {
      return this.value * 100 - Math.floor(this.value) * 100;
    },
    classMap: function classMap() {
      var _ref;

      return Array.isArray(this.iconClasses) ? (_ref = {}, _ref[this.lowThreshold] = this.iconClasses[0], _ref[this.highThreshold] = { value: this.iconClasses[1], excluded: true }, _ref[this.max] = this.iconClasses[2], _ref) : this.iconClasses;
    },
    decimalIconClass: function decimalIconClass() {
      return this.getValueFromMap(this.value, this.classMap);
    },
    voidClass: function voidClass() {
      return this.rateDisabled ? this.disabledVoidIconClass : this.voidIconClass;
    },
    activeClass: function activeClass() {
      return this.getValueFromMap(this.currentValue, this.classMap);
    },
    colorMap: function colorMap() {
      var _ref2;

      return Array.isArray(this.colors) ? (_ref2 = {}, _ref2[this.lowThreshold] = this.colors[0], _ref2[this.highThreshold] = { value: this.colors[1], excluded: true }, _ref2[this.max] = this.colors[2], _ref2) : this.colors;
    },
    activeColor: function activeColor() {
      return this.getValueFromMap(this.currentValue, this.colorMap);
    },
    classes: function classes() {
      var result = [];
      var i = 0;
      var threshold = this.currentValue;
      if (this.allowHalf && this.currentValue !== Math.floor(this.currentValue)) {
        threshold--;
      }
      for (; i < threshold; i++) {
        result.push(this.activeClass);
      }
      for (; i < this.max; i++) {
        result.push(this.voidClass);
      }
      return result;
    },
    rateDisabled: function rateDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  watch: {
    value: function value(val) {
      this.currentValue = val;
      this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'text-template': 'text-template is renamed to score-template.'
        }
      };
    },
    getValueFromMap: function getValueFromMap(value, map) {
      var matchedKeys = Object.keys(map).filter(function (key) {
        var val = map[key];
        var excluded = Object(types_["isObject"])(val) ? val.excluded : false;
        return excluded ? value < key : value <= key;
      }).sort(function (a, b) {
        return a - b;
      });
      var matchedValue = map[matchedKeys[0]];
      return Object(types_["isObject"])(matchedValue) ? matchedValue.value : matchedValue || '';
    },
    showDecimalIcon: function showDecimalIcon(item) {
      var showWhenDisabled = this.rateDisabled && this.valueDecimal > 0 && item - 1 < this.value && item > this.value;
      /* istanbul ignore next */
      var showWhenAllowHalf = this.allowHalf && this.pointerAtLeftHalf && item - 0.5 <= this.currentValue && item > this.currentValue;
      return showWhenDisabled || showWhenAllowHalf;
    },
    getIconStyle: function getIconStyle(item) {
      var voidColor = this.rateDisabled ? this.disabledVoidColor : this.voidColor;
      return {
        color: item <= this.currentValue ? this.activeColor : voidColor
      };
    },
    selectValue: function selectValue(value) {
      if (this.rateDisabled) {
        return;
      }
      if (this.allowHalf && this.pointerAtLeftHalf) {
        this.$emit('input', this.currentValue);
        this.$emit('change', this.currentValue);
      } else {
        this.$emit('input', value);
        this.$emit('change', value);
      }
    },
    handleKey: function handleKey(e) {
      if (this.rateDisabled) {
        return;
      }
      var currentValue = this.currentValue;
      var keyCode = e.keyCode;
      if (keyCode === 38 || keyCode === 39) {
        // left / down
        if (this.allowHalf) {
          currentValue += 0.5;
        } else {
          currentValue += 1;
        }
        e.stopPropagation();
        e.preventDefault();
      } else if (keyCode === 37 || keyCode === 40) {
        if (this.allowHalf) {
          currentValue -= 0.5;
        } else {
          currentValue -= 1;
        }
        e.stopPropagation();
        e.preventDefault();
      }
      currentValue = currentValue < 0 ? 0 : currentValue;
      currentValue = currentValue > this.max ? this.max : currentValue;

      this.$emit('input', currentValue);
      this.$emit('change', currentValue);
    },
    setCurrentValue: function setCurrentValue(value, event) {
      if (this.rateDisabled) {
        return;
      }
      /* istanbul ignore if */
      if (this.allowHalf) {
        var target = event.target;
        if (Object(dom_["hasClass"])(target, 'el-rate__item')) {
          target = target.querySelector('.el-rate__icon');
        }
        if (Object(dom_["hasClass"])(target, 'el-rate__decimal')) {
          target = target.parentNode;
        }
        this.pointerAtLeftHalf = event.offsetX * 2 <= target.clientWidth;
        this.currentValue = this.pointerAtLeftHalf ? value - 0.5 : value;
      } else {
        this.currentValue = value;
      }
      this.hoverIndex = value;
    },
    resetCurrentValue: function resetCurrentValue() {
      if (this.rateDisabled) {
        return;
      }
      if (this.allowHalf) {
        this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
      }
      this.currentValue = this.value;
      this.hoverIndex = -1;
    }
  },

  created: function created() {
    if (!this.value) {
      this.$emit('input', 0);
    }
  }
});
// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_rate_src_mainvue_type_script_lang_js_ = (rate_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/rate/src/main.vue





/* normalize component */

var rate_src_main_component = normalizeComponent(
  packages_rate_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_ada57782_render,
  mainvue_type_template_id_ada57782_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var rate_src_main_api; }
rate_src_main_component.options.__file = "packages/rate/src/main.vue"
/* harmony default export */ var rate_src_main = (rate_src_main_component.exports);
// CONCATENATED MODULE: ./packages/rate/index.js


/* istanbul ignore next */
rate_src_main.install = function (Vue) {
  Vue.component(rate_src_main.name, rate_src_main);
};

/* harmony default export */ var rate = (rate_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&
var stepsvue_type_template_id_3c6b6dc0_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-steps",
      class: [
        !_vm.simple && "el-steps--" + _vm.direction,
        _vm.simple && "el-steps--simple"
      ]
    },
    [_vm._t("default")],
    2
  )
}
var stepsvue_type_template_id_3c6b6dc0_staticRenderFns = []
stepsvue_type_template_id_3c6b6dc0_render._withStripped = true


// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var stepsvue_type_script_lang_js_ = ({
  name: 'ElSteps',

  mixins: [migrating_default.a],

  props: {
    space: [Number, String],
    active: Number,
    direction: {
      type: String,
      default: 'horizontal'
    },
    alignCenter: Boolean,
    simple: Boolean,
    finishStatus: {
      type: String,
      default: 'finish'
    },
    processStatus: {
      type: String,
      default: 'process'
    }
  },

  data: function data() {
    return {
      steps: [],
      stepOffset: 0
    };
  },


  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'center': 'center is removed.'
        }
      };
    }
  },

  watch: {
    active: function active(newVal, oldVal) {
      this.$emit('change', newVal, oldVal);
    },
    steps: function steps(_steps) {
      _steps.forEach(function (child, index) {
        child.index = index;
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_stepsvue_type_script_lang_js_ = (stepsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/steps/src/steps.vue





/* normalize component */

var steps_component = normalizeComponent(
  src_stepsvue_type_script_lang_js_,
  stepsvue_type_template_id_3c6b6dc0_render,
  stepsvue_type_template_id_3c6b6dc0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var steps_api; }
steps_component.options.__file = "packages/steps/src/steps.vue"
/* harmony default export */ var steps = (steps_component.exports);
// CONCATENATED MODULE: ./packages/steps/index.js


/* istanbul ignore next */
steps.install = function (Vue) {
  Vue.component(steps.name, steps);
};

/* harmony default export */ var packages_steps = (steps);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=template&id=f414a87a&
var stepvue_type_template_id_f414a87a_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-step",
      class: [
        !_vm.isSimple && "is-" + _vm.$parent.direction,
        _vm.isSimple && "is-simple",
        _vm.isLast && !_vm.space && !_vm.isCenter && "is-flex",
        _vm.isCenter && !_vm.isVertical && !_vm.isSimple && "is-center"
      ],
      style: _vm.style
    },
    [
      _c(
        "div",
        { staticClass: "el-step__head", class: "is-" + _vm.currentStatus },
        [
          _c(
            "div",
            {
              staticClass: "el-step__line",
              style: _vm.isLast
                ? ""
                : { marginRight: _vm.$parent.stepOffset + "px" }
            },
            [
              _c("i", {
                staticClass: "el-step__line-inner",
                style: _vm.lineStyle
              })
            ]
          ),
          _c(
            "div",
            {
              staticClass: "el-step__icon",
              class: "is-" + (_vm.icon ? "icon" : "text")
            },
            [
              _vm.currentStatus !== "success" && _vm.currentStatus !== "error"
                ? _vm._t("icon", [
                    _vm.icon
                      ? _c("i", {
                          staticClass: "el-step__icon-inner",
                          class: [_vm.icon]
                        })
                      : _vm._e(),
                    !_vm.icon && !_vm.isSimple
                      ? _c("div", { staticClass: "el-step__icon-inner" }, [
                          _vm._v(_vm._s(_vm.index + 1))
                        ])
                      : _vm._e()
                  ])
                : _c("i", {
                    staticClass: "el-step__icon-inner is-status",
                    class: [
                      "el-icon-" +
                        (_vm.currentStatus === "success" ? "check" : "close")
                    ]
                  })
            ],
            2
          )
        ]
      ),
      _c("div", { staticClass: "el-step__main" }, [
        _c(
          "div",
          {
            ref: "title",
            staticClass: "el-step__title",
            class: ["is-" + _vm.currentStatus]
          },
          [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
          2
        ),
        _vm.isSimple
          ? _c("div", { staticClass: "el-step__arrow" })
          : _c(
              "div",
              {
                staticClass: "el-step__description",
                class: ["is-" + _vm.currentStatus]
              },
              [_vm._t("description", [_vm._v(_vm._s(_vm.description))])],
              2
            )
      ])
    ]
  )
}
var stepvue_type_template_id_f414a87a_staticRenderFns = []
stepvue_type_template_id_f414a87a_render._withStripped = true


// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=template&id=f414a87a&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var stepvue_type_script_lang_js_ = ({
  name: 'ElStep',

  props: {
    title: String,
    icon: String,
    description: String,
    status: String
  },

  data: function data() {
    return {
      index: -1,
      lineStyle: {},
      internalStatus: ''
    };
  },
  beforeCreate: function beforeCreate() {
    this.$parent.steps.push(this);
  },
  beforeDestroy: function beforeDestroy() {
    var steps = this.$parent.steps;
    var index = steps.indexOf(this);
    if (index >= 0) {
      steps.splice(index, 1);
    }
  },


  computed: {
    currentStatus: function currentStatus() {
      return this.status || this.internalStatus;
    },
    prevStatus: function prevStatus() {
      var prevStep = this.$parent.steps[this.index - 1];
      return prevStep ? prevStep.currentStatus : 'wait';
    },
    isCenter: function isCenter() {
      return this.$parent.alignCenter;
    },
    isVertical: function isVertical() {
      return this.$parent.direction === 'vertical';
    },
    isSimple: function isSimple() {
      return this.$parent.simple;
    },
    isLast: function isLast() {
      var parent = this.$parent;
      return parent.steps[parent.steps.length - 1] === this;
    },
    stepsCount: function stepsCount() {
      return this.$parent.steps.length;
    },
    space: function space() {
      var isSimple = this.isSimple,
          space = this.$parent.space;

      return isSimple ? '' : space;
    },

    style: function style() {
      var style = {};
      var parent = this.$parent;
      var len = parent.steps.length;

      var space = typeof this.space === 'number' ? this.space + 'px' : this.space ? this.space : 100 / (len - (this.isCenter ? 0 : 1)) + '%';
      style.flexBasis = space;
      if (this.isVertical) return style;
      if (this.isLast) {
        style.maxWidth = 100 / this.stepsCount + '%';
      } else {
        style.marginRight = -this.$parent.stepOffset + 'px';
      }

      return style;
    }
  },

  methods: {
    updateStatus: function updateStatus(val) {
      var prevChild = this.$parent.$children[this.index - 1];

      if (val > this.index) {
        this.internalStatus = this.$parent.finishStatus;
      } else if (val === this.index && this.prevStatus !== 'error') {
        this.internalStatus = this.$parent.processStatus;
      } else {
        this.internalStatus = 'wait';
      }

      if (prevChild) prevChild.calcProgress(this.internalStatus);
    },
    calcProgress: function calcProgress(status) {
      var step = 100;
      var style = {};

      style.transitionDelay = 150 * this.index + 'ms';
      if (status === this.$parent.processStatus) {
        step = this.currentStatus !== 'error' ? 0 : 0;
      } else if (status === 'wait') {
        step = 0;
        style.transitionDelay = -150 * this.index + 'ms';
      }

      style.borderWidth = step && !this.isSimple ? '1px' : 0;
      this.$parent.direction === 'vertical' ? style.height = step + '%' : style.width = step + '%';

      this.lineStyle = style;
    }
  },

  mounted: function mounted() {
    var _this = this;

    var unwatch = this.$watch('index', function (val) {
      _this.$watch('$parent.active', _this.updateStatus, { immediate: true });
      _this.$watch('$parent.processStatus', function () {
        var activeIndex = _this.$parent.active;
        _this.updateStatus(activeIndex);
      }, { immediate: true });
      unwatch();
    });
  }
});
// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_stepvue_type_script_lang_js_ = (stepvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/steps/src/step.vue





/* normalize component */

var step_component = normalizeComponent(
  src_stepvue_type_script_lang_js_,
  stepvue_type_template_id_f414a87a_render,
  stepvue_type_template_id_f414a87a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var step_api; }
step_component.options.__file = "packages/steps/src/step.vue"
/* harmony default export */ var step = (step_component.exports);
// CONCATENATED MODULE: ./packages/step/index.js


/* istanbul ignore next */
step.install = function (Vue) {
  Vue.component(step.name, step);
};

/* harmony default export */ var packages_step = (step);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&
var mainvue_type_template_id_5d5d1482_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.carouselClasses,
      on: {
        mouseenter: function($event) {
          $event.stopPropagation()
          return _vm.handleMouseEnter($event)
        },
        mouseleave: function($event) {
          $event.stopPropagation()
          return _vm.handleMouseLeave($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "el-carousel__container",
          style: { height: _vm.height }
        },
        [
          _vm.arrowDisplay
            ? _c("transition", { attrs: { name: "carousel-arrow-left" } }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          (_vm.arrow === "always" || _vm.hover) &&
                          (_vm.loop || _vm.activeIndex > 0),
                        expression:
                          "(arrow === 'always' || hover) && (loop || activeIndex > 0)"
                      }
                    ],
                    staticClass: "el-carousel__arrow el-carousel__arrow--left",
                    attrs: { type: "button" },
                    on: {
                      mouseenter: function($event) {
                        _vm.handleButtonEnter("left")
                      },
                      mouseleave: _vm.handleButtonLeave,
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.throttledArrowClick(_vm.activeIndex - 1)
                      }
                    }
                  },
                  [_c("i", { staticClass: "el-icon-arrow-left" })]
                )
              ])
            : _vm._e(),
          _vm.arrowDisplay
            ? _c("transition", { attrs: { name: "carousel-arrow-right" } }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          (_vm.arrow === "always" || _vm.hover) &&
                          (_vm.loop || _vm.activeIndex < _vm.items.length - 1),
                        expression:
                          "(arrow === 'always' || hover) && (loop || activeIndex < items.length - 1)"
                      }
                    ],
                    staticClass: "el-carousel__arrow el-carousel__arrow--right",
                    attrs: { type: "button" },
                    on: {
                      mouseenter: function($event) {
                        _vm.handleButtonEnter("right")
                      },
                      mouseleave: _vm.handleButtonLeave,
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.throttledArrowClick(_vm.activeIndex + 1)
                      }
                    }
                  },
                  [_c("i", { staticClass: "el-icon-arrow-right" })]
                )
              ])
            : _vm._e(),
          _vm._t("default")
        ],
        2
      ),
      _vm.indicatorPosition !== "none"
        ? _c(
            "ul",
            { class: _vm.indicatorsClasses },
            _vm._l(_vm.items, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: [
                    "el-carousel__indicator",
                    "el-carousel__indicator--" + _vm.direction,
                    { "is-active": index === _vm.activeIndex }
                  ],
                  on: {
                    mouseenter: function($event) {
                      _vm.throttledIndicatorHover(index)
                    },
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.handleIndicatorClick(index)
                    }
                  }
                },
                [
                  _c("button", { staticClass: "el-carousel__button" }, [
                    _vm.hasLabel
                      ? _c("span", [_vm._v(_vm._s(item.label))])
                      : _vm._e()
                  ])
                ]
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var mainvue_type_template_id_5d5d1482_staticRenderFns = []
mainvue_type_template_id_5d5d1482_render._withStripped = true


// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&

// EXTERNAL MODULE: external "throttle-debounce/throttle"
var throttle_ = __webpack_require__(25);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var carousel_src_mainvue_type_script_lang_js_ = ({
  name: 'ElCarousel',

  props: {
    initialIndex: {
      type: Number,
      default: 0
    },
    height: String,
    trigger: {
      type: String,
      default: 'hover'
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    interval: {
      type: Number,
      default: 3000
    },
    indicatorPosition: String,
    indicator: {
      type: Boolean,
      default: true
    },
    arrow: {
      type: String,
      default: 'hover'
    },
    type: String,
    loop: {
      type: Boolean,
      default: true
    },
    direction: {
      type: String,
      default: 'horizontal',
      validator: function validator(val) {
        return ['horizontal', 'vertical'].indexOf(val) !== -1;
      }
    }
  },

  data: function data() {
    return {
      items: [],
      activeIndex: -1,
      containerWidth: 0,
      timer: null,
      hover: false
    };
  },


  computed: {
    arrowDisplay: function arrowDisplay() {
      return this.arrow !== 'never' && this.direction !== 'vertical';
    },
    hasLabel: function hasLabel() {
      return this.items.some(function (item) {
        return item.label.toString().length > 0;
      });
    },
    carouselClasses: function carouselClasses() {
      var classes = ['el-carousel', 'el-carousel--' + this.direction];
      if (this.type === 'card') {
        classes.push('el-carousel--card');
      }
      return classes;
    },
    indicatorsClasses: function indicatorsClasses() {
      var classes = ['el-carousel__indicators', 'el-carousel__indicators--' + this.direction];
      if (this.hasLabel) {
        classes.push('el-carousel__indicators--labels');
      }
      if (this.indicatorPosition === 'outside' || this.type === 'card') {
        classes.push('el-carousel__indicators--outside');
      }
      return classes;
    }
  },

  watch: {
    items: function items(val) {
      if (val.length > 0) this.setActiveItem(this.initialIndex);
    },
    activeIndex: function activeIndex(val, oldVal) {
      this.resetItemPosition(oldVal);
      if (oldVal > -1) {
        this.$emit('change', val, oldVal);
      }
    },
    autoplay: function autoplay(val) {
      val ? this.startTimer() : this.pauseTimer();
    },
    loop: function loop() {
      this.setActiveItem(this.activeIndex);
    }
  },

  methods: {
    handleMouseEnter: function handleMouseEnter() {
      this.hover = true;
      this.pauseTimer();
    },
    handleMouseLeave: function handleMouseLeave() {
      this.hover = false;
      this.startTimer();
    },
    itemInStage: function itemInStage(item, index) {
      var length = this.items.length;
      if (index === length - 1 && item.inStage && this.items[0].active || item.inStage && this.items[index + 1] && this.items[index + 1].active) {
        return 'left';
      } else if (index === 0 && item.inStage && this.items[length - 1].active || item.inStage && this.items[index - 1] && this.items[index - 1].active) {
        return 'right';
      }
      return false;
    },
    handleButtonEnter: function handleButtonEnter(arrow) {
      var _this = this;

      if (this.direction === 'vertical') return;
      this.items.forEach(function (item, index) {
        if (arrow === _this.itemInStage(item, index)) {
          item.hover = true;
        }
      });
    },
    handleButtonLeave: function handleButtonLeave() {
      if (this.direction === 'vertical') return;
      this.items.forEach(function (item) {
        item.hover = false;
      });
    },
    updateItems: function updateItems() {
      this.items = this.$children.filter(function (child) {
        return child.$options.name === 'ElCarouselItem';
      });
    },
    resetItemPosition: function resetItemPosition(oldIndex) {
      var _this2 = this;

      this.items.forEach(function (item, index) {
        item.translateItem(index, _this2.activeIndex, oldIndex);
      });
    },
    playSlides: function playSlides() {
      if (this.activeIndex < this.items.length - 1) {
        this.activeIndex++;
      } else if (this.loop) {
        this.activeIndex = 0;
      }
    },
    pauseTimer: function pauseTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    startTimer: function startTimer() {
      if (this.interval <= 0 || !this.autoplay || this.timer) return;
      this.timer = setInterval(this.playSlides, this.interval);
    },
    setActiveItem: function setActiveItem(index) {
      if (typeof index === 'string') {
        var filteredItems = this.items.filter(function (item) {
          return item.name === index;
        });
        if (filteredItems.length > 0) {
          index = this.items.indexOf(filteredItems[0]);
        }
      }
      index = Number(index);
      if (isNaN(index) || index !== Math.floor(index)) {
        console.warn('[Element Warn][Carousel]index must be an integer.');
        return;
      }
      var length = this.items.length;
      var oldIndex = this.activeIndex;
      if (index < 0) {
        this.activeIndex = this.loop ? length - 1 : 0;
      } else if (index >= length) {
        this.activeIndex = this.loop ? 0 : length - 1;
      } else {
        this.activeIndex = index;
      }
      if (oldIndex === this.activeIndex) {
        this.resetItemPosition(oldIndex);
      }
    },
    prev: function prev() {
      this.setActiveItem(this.activeIndex - 1);
    },
    next: function next() {
      this.setActiveItem(this.activeIndex + 1);
    },
    handleIndicatorClick: function handleIndicatorClick(index) {
      this.activeIndex = index;
    },
    handleIndicatorHover: function handleIndicatorHover(index) {
      if (this.trigger === 'hover' && index !== this.activeIndex) {
        this.activeIndex = index;
      }
    }
  },

  created: function created() {
    var _this3 = this;

    this.throttledArrowClick = throttle_default()(300, true, function (index) {
      _this3.setActiveItem(index);
    });
    this.throttledIndicatorHover = throttle_default()(300, function (index) {
      _this3.handleIndicatorHover(index);
    });
  },
  mounted: function mounted() {
    var _this4 = this;

    this.updateItems();
    this.$nextTick(function () {
      Object(resize_event_["addResizeListener"])(_this4.$el, _this4.resetItemPosition);
      if (_this4.initialIndex < _this4.items.length && _this4.initialIndex >= 0) {
        _this4.activeIndex = _this4.initialIndex;
      }
      _this4.startTimer();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el) Object(resize_event_["removeResizeListener"])(this.$el, this.resetItemPosition);
    this.pauseTimer();
  }
});
// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_carousel_src_mainvue_type_script_lang_js_ = (carousel_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/carousel/src/main.vue





/* normalize component */

var carousel_src_main_component = normalizeComponent(
  packages_carousel_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_5d5d1482_render,
  mainvue_type_template_id_5d5d1482_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var carousel_src_main_api; }
carousel_src_main_component.options.__file = "packages/carousel/src/main.vue"
/* harmony default export */ var carousel_src_main = (carousel_src_main_component.exports);
// CONCATENATED MODULE: ./packages/carousel/index.js


/* istanbul ignore next */
carousel_src_main.install = function (Vue) {
  Vue.component(carousel_src_main.name, carousel_src_main);
};

/* harmony default export */ var carousel = (carousel_src_main);
// CONCATENATED MODULE: ./packages/scrollbar/src/util.js
var BAR_MAP = {
  vertical: {
    offset: 'offsetHeight',
    scroll: 'scrollTop',
    scrollSize: 'scrollHeight',
    size: 'height',
    key: 'vertical',
    axis: 'Y',
    client: 'clientY',
    direction: 'top'
  },
  horizontal: {
    offset: 'offsetWidth',
    scroll: 'scrollLeft',
    scrollSize: 'scrollWidth',
    size: 'width',
    key: 'horizontal',
    axis: 'X',
    client: 'clientX',
    direction: 'left'
  }
};

function renderThumbStyle(_ref) {
  var move = _ref.move,
      size = _ref.size,
      bar = _ref.bar;

  var style = {};
  var translate = 'translate' + bar.axis + '(' + move + '%)';

  style[bar.size] = size;
  style.transform = translate;
  style.msTransform = translate;
  style.webkitTransform = translate;

  return style;
};
// CONCATENATED MODULE: ./packages/scrollbar/src/bar.js



/* istanbul ignore next */
/* harmony default export */ var src_bar = ({
  name: 'Bar',

  props: {
    vertical: Boolean,
    size: String,
    move: Number
  },

  computed: {
    bar: function bar() {
      return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
    },
    wrap: function wrap() {
      return this.$parent.wrap;
    }
  },

  render: function render(h) {
    var size = this.size,
        move = this.move,
        bar = this.bar;


    return h(
      'div',
      {
        'class': ['el-scrollbar__bar', 'is-' + bar.key],
        on: {
          'mousedown': this.clickTrackHandler
        }
      },
      [h('div', {
        ref: 'thumb',
        'class': 'el-scrollbar__thumb',
        on: {
          'mousedown': this.clickThumbHandler
        },

        style: renderThumbStyle({ size: size, move: move, bar: bar }) })]
    );
  },


  methods: {
    clickThumbHandler: function clickThumbHandler(e) {
      // prevent click event of right button
      if (e.ctrlKey || e.button === 2) {
        return;
      }
      this.startDrag(e);
      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
    },
    clickTrackHandler: function clickTrackHandler(e) {
      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];

      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    startDrag: function startDrag(e) {
      e.stopImmediatePropagation();
      this.cursorDown = true;

      Object(dom_["on"])(document, 'mousemove', this.mouseMoveDocumentHandler);
      Object(dom_["on"])(document, 'mouseup', this.mouseUpDocumentHandler);
      document.onselectstart = function () {
        return false;
      };
    },
    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
      if (this.cursorDown === false) return;
      var prevPage = this[this.bar.axis];

      if (!prevPage) return;

      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];

      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
      this.cursorDown = false;
      this[this.bar.axis] = 0;
      Object(dom_["off"])(document, 'mousemove', this.mouseMoveDocumentHandler);
      document.onselectstart = null;
    }
  },

  destroyed: function destroyed() {
    Object(dom_["off"])(document, 'mouseup', this.mouseUpDocumentHandler);
  }
});
// CONCATENATED MODULE: ./packages/scrollbar/src/main.js
// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js






/* istanbul ignore next */
/* harmony default export */ var scrollbar_src_main = ({
  name: 'ElScrollbar',

  components: { Bar: src_bar },

  props: {
    native: Boolean,
    wrapStyle: {},
    wrapClass: {},
    viewClass: {},
    viewStyle: {},
    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
    tag: {
      type: String,
      default: 'div'
    }
  },

  data: function data() {
    return {
      sizeWidth: '0',
      sizeHeight: '0',
      moveX: 0,
      moveY: 0
    };
  },


  computed: {
    wrap: function wrap() {
      return this.$refs.wrap;
    }
  },

  render: function render(h) {
    var gutter = scrollbar_width_default()();
    var style = this.wrapStyle;

    if (gutter) {
      var gutterWith = '-' + gutter + 'px';
      var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';

      if (Array.isArray(this.wrapStyle)) {
        style = Object(util_["toObject"])(this.wrapStyle);
        style.marginRight = style.marginBottom = gutterWith;
      } else if (typeof this.wrapStyle === 'string') {
        style += gutterStyle;
      } else {
        style = gutterStyle;
      }
    }
    var view = h(this.tag, {
      class: ['el-scrollbar__view', this.viewClass],
      style: this.viewStyle,
      ref: 'resize'
    }, this.$slots.default);
    var wrap = h(
      'div',
      {
        ref: 'wrap',
        style: style,
        on: {
          'scroll': this.handleScroll
        },

        'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] },
      [[view]]
    );
    var nodes = void 0;

    if (!this.native) {
      nodes = [wrap, h(src_bar, {
        attrs: {
          move: this.moveX,
          size: this.sizeWidth }
      }), h(src_bar, {
        attrs: {
          vertical: true,
          move: this.moveY,
          size: this.sizeHeight }
      })];
    } else {
      nodes = [h(
        'div',
        {
          ref: 'wrap',
          'class': [this.wrapClass, 'el-scrollbar__wrap'],
          style: style },
        [[view]]
      )];
    }
    return h('div', { class: 'el-scrollbar' }, nodes);
  },


  methods: {
    handleScroll: function handleScroll() {
      var wrap = this.wrap;

      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
    },
    update: function update() {
      var heightPercentage = void 0,
          widthPercentage = void 0;
      var wrap = this.wrap;
      if (!wrap) return;

      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;

      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
    }
  },

  mounted: function mounted() {
    if (this.native) return;
    this.$nextTick(this.update);
    !this.noresize && Object(resize_event_["addResizeListener"])(this.$refs.resize, this.update);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.native) return;
    !this.noresize && Object(resize_event_["removeResizeListener"])(this.$refs.resize, this.update);
  }
});
// CONCATENATED MODULE: ./packages/scrollbar/index.js


/* istanbul ignore next */
scrollbar_src_main.install = function (Vue) {
  Vue.component(scrollbar_src_main.name, scrollbar_src_main);
};

/* harmony default export */ var scrollbar = (scrollbar_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&
var itemvue_type_template_id_1801ae19_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.ready,
          expression: "ready"
        }
      ],
      staticClass: "el-carousel__item",
      class: {
        "is-active": _vm.active,
        "el-carousel__item--card": _vm.$parent.type === "card",
        "is-in-stage": _vm.inStage,
        "is-hover": _vm.hover,
        "is-animating": _vm.animating
      },
      style: _vm.itemStyle,
      on: { click: _vm.handleItemClick }
    },
    [
      _vm.$parent.type === "card"
        ? _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.active,
                expression: "!active"
              }
            ],
            staticClass: "el-carousel__mask"
          })
        : _vm._e(),
      _vm._t("default")
    ],
    2
  )
}
var itemvue_type_template_id_1801ae19_staticRenderFns = []
itemvue_type_template_id_1801ae19_render._withStripped = true


// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var CARD_SCALE = 0.83;
/* harmony default export */ var itemvue_type_script_lang_js_ = ({
  name: 'ElCarouselItem',

  props: {
    name: String,
    label: {
      type: [String, Number],
      default: ''
    }
  },

  data: function data() {
    return {
      hover: false,
      translate: 0,
      scale: 1,
      active: false,
      ready: false,
      inStage: false,
      animating: false
    };
  },


  methods: {
    processIndex: function processIndex(index, activeIndex, length) {
      if (activeIndex === 0 && index === length - 1) {
        return -1;
      } else if (activeIndex === length - 1 && index === 0) {
        return length;
      } else if (index < activeIndex - 1 && activeIndex - index >= length / 2) {
        return length + 1;
      } else if (index > activeIndex + 1 && index - activeIndex >= length / 2) {
        return -2;
      }
      return index;
    },
    calcCardTranslate: function calcCardTranslate(index, activeIndex) {
      var parentWidth = this.$parent.$el.offsetWidth;
      if (this.inStage) {
        return parentWidth * ((2 - CARD_SCALE) * (index - activeIndex) + 1) / 4;
      } else if (index < activeIndex) {
        return -(1 + CARD_SCALE) * parentWidth / 4;
      } else {
        return (3 + CARD_SCALE) * parentWidth / 4;
      }
    },
    calcTranslate: function calcTranslate(index, activeIndex, isVertical) {
      var distance = this.$parent.$el[isVertical ? 'offsetHeight' : 'offsetWidth'];
      return distance * (index - activeIndex);
    },
    translateItem: function translateItem(index, activeIndex, oldIndex) {
      var parentType = this.$parent.type;
      var parentDirection = this.parentDirection;
      var length = this.$parent.items.length;
      if (parentType !== 'card' && oldIndex !== undefined) {
        this.animating = index === activeIndex || index === oldIndex;
      }
      if (index !== activeIndex && length > 2 && this.$parent.loop) {
        index = this.processIndex(index, activeIndex, length);
      }
      if (parentType === 'card') {
        if (parentDirection === 'vertical') {
          console.warn('[Element Warn][Carousel]vertical direction is not supported in card mode');
        }
        this.inStage = Math.round(Math.abs(index - activeIndex)) <= 1;
        this.active = index === activeIndex;
        this.translate = this.calcCardTranslate(index, activeIndex);
        this.scale = this.active ? 1 : CARD_SCALE;
      } else {
        this.active = index === activeIndex;
        var isVertical = parentDirection === 'vertical';
        this.translate = this.calcTranslate(index, activeIndex, isVertical);
      }
      this.ready = true;
    },
    handleItemClick: function handleItemClick() {
      var parent = this.$parent;
      if (parent && parent.type === 'card') {
        var index = parent.items.indexOf(this);
        parent.setActiveItem(index);
      }
    }
  },

  computed: {
    parentDirection: function parentDirection() {
      return this.$parent.direction;
    },
    itemStyle: function itemStyle() {
      var translateType = this.parentDirection === 'vertical' ? 'translateY' : 'translateX';
      var value = translateType + '(' + this.translate + 'px) scale(' + this.scale + ')';
      var style = {
        transform: value
      };
      return Object(util_["autoprefixer"])(style);
    }
  },

  created: function created() {
    this.$parent && this.$parent.updateItems();
  },
  destroyed: function destroyed() {
    this.$parent && this.$parent.updateItems();
  }
});
// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_itemvue_type_script_lang_js_ = (itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/carousel/src/item.vue





/* normalize component */

var item_component = normalizeComponent(
  src_itemvue_type_script_lang_js_,
  itemvue_type_template_id_1801ae19_render,
  itemvue_type_template_id_1801ae19_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var item_api; }
item_component.options.__file = "packages/carousel/src/item.vue"
/* harmony default export */ var src_item = (item_component.exports);
// CONCATENATED MODULE: ./packages/carousel-item/index.js


/* istanbul ignore next */
src_item.install = function (Vue) {
  Vue.component(src_item.name, src_item);
};

/* harmony default export */ var carousel_item = (src_item);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&
var collapsevue_type_template_id_461d57f4_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-collapse",
      attrs: { role: "tablist", "aria-multiselectable": "true" }
    },
    [_vm._t("default")],
    2
  )
}
var collapsevue_type_template_id_461d57f4_staticRenderFns = []
collapsevue_type_template_id_461d57f4_render._withStripped = true


// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
//
//
//
//
//

/* harmony default export */ var collapsevue_type_script_lang_js_ = ({
  name: 'ElCollapse',

  componentName: 'ElCollapse',

  props: {
    accordion: Boolean,
    value: {
      type: [Array, String, Number],
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      activeNames: [].concat(this.value)
    };
  },
  provide: function provide() {
    return {
      collapse: this
    };
  },


  watch: {
    value: function value(_value) {
      this.activeNames = [].concat(_value);
    }
  },

  methods: {
    setActiveNames: function setActiveNames(activeNames) {
      activeNames = [].concat(activeNames);
      var value = this.accordion ? activeNames[0] : activeNames;
      this.activeNames = activeNames;
      this.$emit('input', value);
      this.$emit('change', value);
    },
    handleItemClick: function handleItemClick(item) {
      if (this.accordion) {
        this.setActiveNames((this.activeNames[0] || this.activeNames[0] === 0) && this.activeNames[0] === item.name ? '' : item.name);
      } else {
        var activeNames = this.activeNames.slice(0);
        var index = activeNames.indexOf(item.name);

        if (index > -1) {
          activeNames.splice(index, 1);
        } else {
          activeNames.push(item.name);
        }
        this.setActiveNames(activeNames);
      }
    }
  },

  created: function created() {
    this.$on('item-click', this.handleItemClick);
  }
});
// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_collapsevue_type_script_lang_js_ = (collapsevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue





/* normalize component */

var collapse_component = normalizeComponent(
  src_collapsevue_type_script_lang_js_,
  collapsevue_type_template_id_461d57f4_render,
  collapsevue_type_template_id_461d57f4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var collapse_api; }
collapse_component.options.__file = "packages/collapse/src/collapse.vue"
/* harmony default export */ var collapse = (collapse_component.exports);
// CONCATENATED MODULE: ./packages/collapse/index.js


/* istanbul ignore next */
collapse.install = function (Vue) {
  Vue.component(collapse.name, collapse);
};

/* harmony default export */ var packages_collapse = (collapse);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&
var collapse_itemvue_type_template_id_2d05faac_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-collapse-item",
      class: { "is-active": _vm.isActive, "is-disabled": _vm.disabled }
    },
    [
      _c(
        "div",
        {
          attrs: {
            role: "tab",
            "aria-expanded": _vm.isActive,
            "aria-controls": "el-collapse-content-" + _vm.id,
            "aria-describedby": "el-collapse-content-" + _vm.id
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "el-collapse-item__header",
              class: {
                focusing: _vm.focusing,
                "is-active": _vm.isActive
              },
              attrs: {
                role: "button",
                id: "el-collapse-head-" + _vm.id,
                tabindex: _vm.disabled ? undefined : 0
              },
              on: {
                click: _vm.handleHeaderClick,
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar"
                    ]) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.stopPropagation()
                  return _vm.handleEnterClick($event)
                },
                focus: _vm.handleFocus,
                blur: function($event) {
                  _vm.focusing = false
                }
              }
            },
            [
              _vm._t("title", [_vm._v(_vm._s(_vm.title))]),
              _c("i", {
                staticClass: "el-collapse-item__arrow el-icon-arrow-right",
                class: { "is-active": _vm.isActive }
              })
            ],
            2
          )
        ]
      ),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActive,
                expression: "isActive"
              }
            ],
            staticClass: "el-collapse-item__wrap",
            attrs: {
              role: "tabpanel",
              "aria-hidden": !_vm.isActive,
              "aria-labelledby": "el-collapse-head-" + _vm.id,
              id: "el-collapse-content-" + _vm.id
            }
          },
          [
            _c(
              "div",
              { staticClass: "el-collapse-item__content" },
              [_vm._t("default")],
              2
            )
          ]
        )
      ])
    ],
    1
  )
}
var collapse_itemvue_type_template_id_2d05faac_staticRenderFns = []
collapse_itemvue_type_template_id_2d05faac_render._withStripped = true


// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var collapse_itemvue_type_script_lang_js_ = ({
  name: 'ElCollapseItem',

  componentName: 'ElCollapseItem',

  mixins: [emitter_default.a],

  components: { ElCollapseTransition: collapse_transition_default.a },

  data: function data() {
    return {
      contentWrapStyle: {
        height: 'auto',
        display: 'block'
      },
      contentHeight: 0,
      focusing: false,
      isClick: false,
      id: Object(util_["generateId"])()
    };
  },


  inject: ['collapse'],

  props: {
    title: String,
    name: {
      type: [String, Number],
      default: function _default() {
        return this._uid;
      }
    },
    disabled: Boolean
  },

  computed: {
    isActive: function isActive() {
      return this.collapse.activeNames.indexOf(this.name) > -1;
    }
  },

  methods: {
    handleFocus: function handleFocus() {
      var _this = this;

      setTimeout(function () {
        if (!_this.isClick) {
          _this.focusing = true;
        } else {
          _this.isClick = false;
        }
      }, 50);
    },
    handleHeaderClick: function handleHeaderClick() {
      if (this.disabled) return;
      this.dispatch('ElCollapse', 'item-click', this);
      this.focusing = false;
      this.isClick = true;
    },
    handleEnterClick: function handleEnterClick() {
      this.dispatch('ElCollapse', 'item-click', this);
    }
  }
});
// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_collapse_itemvue_type_script_lang_js_ = (collapse_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue





/* normalize component */

var collapse_item_component = normalizeComponent(
  src_collapse_itemvue_type_script_lang_js_,
  collapse_itemvue_type_template_id_2d05faac_render,
  collapse_itemvue_type_template_id_2d05faac_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var collapse_item_api; }
collapse_item_component.options.__file = "packages/collapse/src/collapse-item.vue"
/* harmony default export */ var collapse_item = (collapse_item_component.exports);
// CONCATENATED MODULE: ./packages/collapse-item/index.js


/* istanbul ignore next */
collapse_item.install = function (Vue) {
  Vue.component(collapse_item.name, collapse_item);
};

/* harmony default export */ var packages_collapse_item = (collapse_item);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&
var cascadervue_type_template_id_032537a6_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: function() {
            return _vm.toggleDropDownVisible(false)
          },
          expression: "() => toggleDropDownVisible(false)"
        }
      ],
      ref: "reference",
      class: [
        "el-cascader",
        _vm.realSize && "el-cascader--" + _vm.realSize,
        { "is-disabled": _vm.isDisabled }
      ],
      on: {
        mouseenter: function($event) {
          _vm.inputHover = true
        },
        mouseleave: function($event) {
          _vm.inputHover = false
        },
        click: function() {
          return _vm.toggleDropDownVisible(_vm.readonly ? undefined : true)
        },
        keydown: _vm.handleKeyDown
      }
    },
    [
      _c(
        "el-input",
        {
          ref: "input",
          class: { "is-focus": _vm.dropDownVisible },
          attrs: {
            size: _vm.realSize,
            placeholder: _vm.placeholder,
            readonly: _vm.readonly,
            disabled: _vm.isDisabled,
            "validate-event": false
          },
          on: {
            focus: _vm.handleFocus,
            blur: _vm.handleBlur,
            input: _vm.handleInput
          },
          model: {
            value: _vm.multiple ? _vm.presentText : _vm.inputValue,
            callback: function($$v) {
              _vm.multiple ? _vm.presentText : (_vm.inputValue = $$v)
            },
            expression: "multiple ? presentText : inputValue"
          }
        },
        [
          _c("template", { slot: "suffix" }, [
            _vm.clearBtnVisible
              ? _c("i", {
                  key: "clear",
                  staticClass: "el-input__icon el-icon-circle-close",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.handleClear($event)
                    }
                  }
                })
              : _c("i", {
                  key: "arrow-down",
                  class: [
                    "el-input__icon",
                    "el-icon-arrow-down",
                    _vm.dropDownVisible && "is-reverse"
                  ],
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.toggleDropDownVisible()
                    }
                  }
                })
          ])
        ],
        2
      ),
      _vm.multiple
        ? _c(
            "div",
            { staticClass: "el-cascader__tags" },
            [
              _vm._l(_vm.presentTags, function(tag, index) {
                return _c(
                  "el-tag",
                  {
                    key: tag.key,
                    attrs: {
                      type: "info",
                      size: _vm.tagSize,
                      hit: tag.hitState,
                      closable: tag.closable,
                      "disable-transitions": ""
                    },
                    on: {
                      close: function($event) {
                        _vm.deleteTag(index)
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(tag.text))])]
                )
              }),
              _vm.filterable && !_vm.isDisabled
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.inputValue,
                        expression: "inputValue",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "el-cascader__search-input",
                    attrs: {
                      type: "text",
                      placeholder: _vm.presentTags.length ? "" : _vm.placeholder
                    },
                    domProps: { value: _vm.inputValue },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.inputValue = $event.target.value.trim()
                        },
                        function(e) {
                          return _vm.handleInput(_vm.inputValue, e)
                        }
                      ],
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.toggleDropDownVisible(true)
                      },
                      keydown: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "delete",
                            [8, 46],
                            $event.key,
                            ["Backspace", "Delete", "Del"]
                          )
                        ) {
                          return null
                        }
                        return _vm.handleDelete($event)
                      },
                      blur: function($event) {
                        _vm.$forceUpdate()
                      }
                    }
                  })
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _c(
        "transition",
        {
          attrs: { name: "el-zoom-in-top" },
          on: { "after-leave": _vm.handleDropdownLeave }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dropDownVisible,
                  expression: "dropDownVisible"
                }
              ],
              ref: "popper",
              class: ["el-popper", "el-cascader__dropdown", _vm.popperClass]
            },
            [
              _c("el-cascader-panel", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.filtering,
                    expression: "!filtering"
                  }
                ],
                ref: "panel",
                attrs: {
                  options: _vm.options,
                  props: _vm.config,
                  border: false,
                  "render-label": _vm.$scopedSlots.default
                },
                on: {
                  "expand-change": _vm.handleExpandChange,
                  close: function($event) {
                    _vm.toggleDropDownVisible(false)
                  }
                },
                model: {
                  value: _vm.checkedValue,
                  callback: function($$v) {
                    _vm.checkedValue = $$v
                  },
                  expression: "checkedValue"
                }
              }),
              _vm.filterable
                ? _c(
                    "el-scrollbar",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.filtering,
                          expression: "filtering"
                        }
                      ],
                      ref: "suggestionPanel",
                      staticClass: "el-cascader__suggestion-panel",
                      attrs: {
                        tag: "ul",
                        "view-class": "el-cascader__suggestion-list"
                      },
                      nativeOn: {
                        keydown: function($event) {
                          return _vm.handleSuggestionKeyDown($event)
                        }
                      }
                    },
                    [
                      _vm.suggestions.length
                        ? _vm._l(_vm.suggestions, function(item, index) {
                            return _c(
                              "li",
                              {
                                key: item.uid,
                                class: [
                                  "el-cascader__suggestion-item",
                                  item.checked && "is-checked"
                                ],
                                attrs: { tabindex: -1 },
                                on: {
                                  click: function($event) {
                                    _vm.handleSuggestionClick(index)
                                  }
                                }
                              },
                              [
                                _c("span", [_vm._v(_vm._s(item.text))]),
                                item.checked
                                  ? _c("i", { staticClass: "el-icon-check" })
                                  : _vm._e()
                              ]
                            )
                          })
                        : _vm._t("empty", [
                            _c(
                              "li",
                              { staticClass: "el-cascader__empty-text" },
                              [_vm._v(_vm._s(_vm.t("el.cascader.noMatch")))]
                            )
                          ])
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var cascadervue_type_template_id_032537a6_staticRenderFns = []
cascadervue_type_template_id_032537a6_render._withStripped = true


// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&

// EXTERNAL MODULE: external "element-ui/lib/cascader-panel"
var cascader_panel_ = __webpack_require__(42);
var cascader_panel_default = /*#__PURE__*/__webpack_require__.n(cascader_panel_);

// EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
var aria_utils_ = __webpack_require__(28);
var aria_utils_default = /*#__PURE__*/__webpack_require__.n(aria_utils_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















var KeyCode = aria_utils_default.a.keys;

var MigratingProps = {
  expandTrigger: {
    newProp: 'expandTrigger',
    type: String
  },
  changeOnSelect: {
    newProp: 'checkStrictly',
    type: Boolean
  },
  hoverThreshold: {
    newProp: 'hoverThreshold',
    type: Number
  }
};

var PopperMixin = {
  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },
    appendToBody: vue_popper_default.a.props.appendToBody,
    visibleArrow: {
      type: Boolean,
      default: true
    },
    arrowOffset: vue_popper_default.a.props.arrowOffset,
    offset: vue_popper_default.a.props.offset,
    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
    popperOptions: vue_popper_default.a.props.popperOptions
  },
  methods: vue_popper_default.a.methods,
  data: vue_popper_default.a.data,
  beforeDestroy: vue_popper_default.a.beforeDestroy
};

var InputSizeMap = {
  medium: 36,
  small: 32,
  mini: 28
};

/* harmony default export */ var cascadervue_type_script_lang_js_ = ({
  name: 'ElCascader',

  directives: { Clickoutside: clickoutside_default.a },

  mixins: [PopperMixin, emitter_default.a, locale_default.a, migrating_default.a],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  components: {
    ElInput: input_default.a,
    ElTag: tag_default.a,
    ElScrollbar: scrollbar_default.a,
    ElCascaderPanel: cascader_panel_default.a
  },

  props: {
    value: {},
    options: Array,
    props: Object,
    size: String,
    placeholder: {
      type: String,
      default: function _default() {
        return Object(lib_locale_["t"])('el.cascader.placeholder');
      }
    },
    disabled: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    filterMethod: Function,
    separator: {
      type: String,
      default: ' / '
    },
    showAllLevels: {
      type: Boolean,
      default: true
    },
    collapseTags: Boolean,
    debounce: {
      type: Number,
      default: 300
    },
    beforeFilter: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    popperClass: String
  },

  data: function data() {
    return {
      dropDownVisible: false,
      checkedValue: this.value || null,
      inputHover: false,
      inputValue: null,
      presentText: null,
      presentTags: [],
      checkedNodes: [],
      filtering: false,
      suggestions: [],
      inputInitialHeight: 0,
      pressDeleteCount: 0
    };
  },


  computed: {
    realSize: function realSize() {
      var _elFormItemSize = (this.elFormItem || {}).elFormItemSize;
      return this.size || _elFormItemSize || (this.$ELEMENT || {}).size;
    },
    tagSize: function tagSize() {
      return ['small', 'mini'].indexOf(this.realSize) > -1 ? 'mini' : 'small';
    },
    isDisabled: function isDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    config: function config() {
      var config = this.props || {};
      var $attrs = this.$attrs;


      Object.keys(MigratingProps).forEach(function (oldProp) {
        var _MigratingProps$oldPr = MigratingProps[oldProp],
            newProp = _MigratingProps$oldPr.newProp,
            type = _MigratingProps$oldPr.type;

        var oldValue = $attrs[oldProp] || $attrs[Object(util_["kebabCase"])(oldProp)];
        if (Object(shared_["isDef"])(oldProp) && !Object(shared_["isDef"])(config[newProp])) {
          if (type === Boolean && oldValue === '') {
            oldValue = true;
          }
          config[newProp] = oldValue;
        }
      });

      return config;
    },
    multiple: function multiple() {
      return this.config.multiple;
    },
    leafOnly: function leafOnly() {
      return !this.config.checkStrictly;
    },
    readonly: function readonly() {
      return !this.filterable || this.multiple;
    },
    clearBtnVisible: function clearBtnVisible() {
      if (!this.clearable || this.isDisabled || this.filtering || !this.inputHover) {
        return false;
      }

      return this.multiple ? !!this.checkedNodes.filter(function (node) {
        return !node.isDisabled;
      }).length : !!this.presentText;
    },
    panel: function panel() {
      return this.$refs.panel;
    }
  },

  watch: {
    disabled: function disabled() {
      this.computePresentContent();
    },
    value: function value(val) {
      if (!Object(util_["isEqual"])(val, this.checkedValue)) {
        this.checkedValue = val;
        this.computePresentContent();
      }
    },
    checkedValue: function checkedValue(val) {
      var value = this.value,
          dropDownVisible = this.dropDownVisible;
      var _config = this.config,
          checkStrictly = _config.checkStrictly,
          multiple = _config.multiple;


      if (!Object(util_["isEqual"])(val, value) || Object(types_["isUndefined"])(value)) {
        this.computePresentContent();
        // hide dropdown when single mode
        if (!multiple && !checkStrictly && dropDownVisible) {
          this.toggleDropDownVisible(false);
        }

        this.$emit('input', val);
        this.$emit('change', val);
        this.dispatch('ElFormItem', 'el.form.change', [val]);
      }
    },

    options: {
      handler: function handler() {
        this.$nextTick(this.computePresentContent);
      },
      deep: true
    },
    presentText: function presentText(val) {
      this.inputValue = val;
    },
    presentTags: function presentTags(val, oldVal) {
      if (this.multiple && (val.length || oldVal.length)) {
        this.$nextTick(this.updateStyle);
      }
    },
    filtering: function filtering(val) {
      this.$nextTick(this.updatePopper);
    }
  },

  mounted: function mounted() {
    var _this = this;

    var input = this.$refs.input;

    if (input && input.$el) {
      this.inputInitialHeight = input.$el.offsetHeight || InputSizeMap[this.realSize] || 40;
    }

    if (!Object(util_["isEmpty"])(this.value)) {
      this.computePresentContent();
    }

    this.filterHandler = debounce_default()(this.debounce, function () {
      var inputValue = _this.inputValue;


      if (!inputValue) {
        _this.filtering = false;
        return;
      }

      var before = _this.beforeFilter(inputValue);
      if (before && before.then) {
        before.then(_this.getSuggestions);
      } else if (before !== false) {
        _this.getSuggestions();
      } else {
        _this.filtering = false;
      }
    });

    Object(resize_event_["addResizeListener"])(this.$el, this.updateStyle);
  },
  beforeDestroy: function beforeDestroy() {
    Object(resize_event_["removeResizeListener"])(this.$el, this.updateStyle);
  },


  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'expand-trigger': 'expand-trigger is removed, use `props.expandTrigger` instead.',
          'change-on-select': 'change-on-select is removed, use `props.checkStrictly` instead.',
          'hover-threshold': 'hover-threshold is removed, use `props.hoverThreshold` instead'
        },
        events: {
          'active-item-change': 'active-item-change is renamed to expand-change'
        }
      };
    },
    toggleDropDownVisible: function toggleDropDownVisible(visible) {
      var _this2 = this;

      if (this.isDisabled) return;

      var dropDownVisible = this.dropDownVisible;
      var input = this.$refs.input;

      visible = Object(shared_["isDef"])(visible) ? visible : !dropDownVisible;
      if (visible !== dropDownVisible) {
        this.dropDownVisible = visible;
        if (visible) {
          this.$nextTick(function () {
            _this2.updatePopper();
            _this2.panel.scrollIntoView();
          });
        }
        input.$refs.input.setAttribute('aria-expanded', visible);
        this.$emit('visible-change', visible);
      }
    },
    handleDropdownLeave: function handleDropdownLeave() {
      this.filtering = false;
      this.inputValue = this.presentText;
    },
    handleKeyDown: function handleKeyDown(event) {
      switch (event.keyCode) {
        case KeyCode.enter:
          this.toggleDropDownVisible();
          break;
        case KeyCode.down:
          this.toggleDropDownVisible(true);
          this.focusFirstNode();
          event.preventDefault();
          break;
        case KeyCode.esc:
        case KeyCode.tab:
          this.toggleDropDownVisible(false);
          break;
      }
    },
    handleFocus: function handleFocus(e) {
      this.$emit('focus', e);
    },
    handleBlur: function handleBlur(e) {
      this.$emit('blur', e);
    },
    handleInput: function handleInput(val, event) {
      !this.dropDownVisible && this.toggleDropDownVisible(true);

      if (event && event.isComposing) return;
      if (val) {
        this.filterHandler();
      } else {
        this.filtering = false;
      }
    },
    handleClear: function handleClear() {
      this.presentText = '';
      this.panel.clearCheckedNodes();
    },
    handleExpandChange: function handleExpandChange(value) {
      this.$nextTick(this.updatePopper.bind(this));
      this.$emit('expand-change', value);
      this.$emit('active-item-change', value); // Deprecated
    },
    focusFirstNode: function focusFirstNode() {
      var _this3 = this;

      this.$nextTick(function () {
        var filtering = _this3.filtering;
        var _$refs = _this3.$refs,
            popper = _$refs.popper,
            suggestionPanel = _$refs.suggestionPanel;

        var firstNode = null;

        if (filtering && suggestionPanel) {
          firstNode = suggestionPanel.$el.querySelector('.el-cascader__suggestion-item');
        } else {
          var firstMenu = popper.querySelector('.el-cascader-menu');
          firstNode = firstMenu.querySelector('.el-cascader-node[tabindex="-1"]');
        }

        if (firstNode) {
          firstNode.focus();
          !filtering && firstNode.click();
        }
      });
    },
    computePresentContent: function computePresentContent() {
      var _this4 = this;

      // nextTick is required, because checked nodes may not change right now
      this.$nextTick(function () {
        if (_this4.config.multiple) {
          _this4.computePresentTags();
          _this4.presentText = _this4.presentTags.length ? ' ' : null;
        } else {
          _this4.computePresentText();
        }
      });
    },
    computePresentText: function computePresentText() {
      var checkedValue = this.checkedValue,
          config = this.config;

      if (!Object(util_["isEmpty"])(checkedValue)) {
        var node = this.panel.getNodeByValue(checkedValue);
        if (node && (config.checkStrictly || node.isLeaf)) {
          this.presentText = node.getText(this.showAllLevels, this.separator);
          return;
        }
      }
      this.presentText = null;
    },
    computePresentTags: function computePresentTags() {
      var isDisabled = this.isDisabled,
          leafOnly = this.leafOnly,
          showAllLevels = this.showAllLevels,
          separator = this.separator,
          collapseTags = this.collapseTags;

      var checkedNodes = this.getCheckedNodes(leafOnly);
      var tags = [];

      var genTag = function genTag(node) {
        return {
          node: node,
          key: node.uid,
          text: node.getText(showAllLevels, separator),
          hitState: false,
          closable: !isDisabled && !node.isDisabled
        };
      };

      if (checkedNodes.length) {
        var first = checkedNodes[0],
            rest = checkedNodes.slice(1);

        var restCount = rest.length;
        tags.push(genTag(first));

        if (restCount) {
          if (collapseTags) {
            tags.push({
              key: -1,
              text: '+ ' + restCount,
              closable: false
            });
          } else {
            rest.forEach(function (node) {
              return tags.push(genTag(node));
            });
          }
        }
      }

      this.checkedNodes = checkedNodes;
      this.presentTags = tags;
    },
    getSuggestions: function getSuggestions() {
      var _this5 = this;

      var filterMethod = this.filterMethod;


      if (!Object(types_["isFunction"])(filterMethod)) {
        filterMethod = function filterMethod(node, keyword) {
          return node.text.includes(keyword);
        };
      }

      var suggestions = this.panel.getFlattedNodes(this.leafOnly).filter(function (node) {
        if (node.isDisabled) return false;
        node.text = node.getText(_this5.showAllLevels, _this5.separator) || '';
        return filterMethod(node, _this5.inputValue);
      });

      if (this.multiple) {
        this.presentTags.forEach(function (tag) {
          tag.hitState = false;
        });
      } else {
        suggestions.forEach(function (node) {
          node.checked = Object(util_["isEqual"])(_this5.checkedValue, node.getValueByOption());
        });
      }

      this.filtering = true;
      this.suggestions = suggestions;
      this.$nextTick(this.updatePopper);
    },
    handleSuggestionKeyDown: function handleSuggestionKeyDown(event) {
      var keyCode = event.keyCode,
          target = event.target;

      switch (keyCode) {
        case KeyCode.enter:
          target.click();
          break;
        case KeyCode.up:
          var prev = target.previousElementSibling;
          prev && prev.focus();
          break;
        case KeyCode.down:
          var next = target.nextElementSibling;
          next && next.focus();
          break;
        case KeyCode.esc:
        case KeyCode.tab:
          this.toggleDropDownVisible(false);
          break;
      }
    },
    handleDelete: function handleDelete() {
      var inputValue = this.inputValue,
          pressDeleteCount = this.pressDeleteCount,
          presentTags = this.presentTags;

      var lastIndex = presentTags.length - 1;
      var lastTag = presentTags[lastIndex];
      this.pressDeleteCount = inputValue ? 0 : pressDeleteCount + 1;

      if (!lastTag) return;

      if (this.pressDeleteCount) {
        if (lastTag.hitState) {
          this.deleteTag(lastIndex);
        } else {
          lastTag.hitState = true;
        }
      }
    },
    handleSuggestionClick: function handleSuggestionClick(index) {
      var multiple = this.multiple;

      var targetNode = this.suggestions[index];

      if (multiple) {
        var checked = targetNode.checked;

        targetNode.doCheck(!checked);
        this.panel.calculateMultiCheckedValue();
      } else {
        this.checkedValue = targetNode.getValueByOption();
        this.toggleDropDownVisible(false);
      }
    },
    deleteTag: function deleteTag(index) {
      var checkedValue = this.checkedValue;

      var val = checkedValue[index];
      this.checkedValue = checkedValue.filter(function (n, i) {
        return i !== index;
      });
      this.$emit('remove-tag', val);
    },
    updateStyle: function updateStyle() {
      var $el = this.$el,
          inputInitialHeight = this.inputInitialHeight;

      if (this.$isServer || !$el) return;

      var suggestionPanel = this.$refs.suggestionPanel;

      var inputInner = $el.querySelector('.el-input__inner');

      if (!inputInner) return;

      var tags = $el.querySelector('.el-cascader__tags');
      var suggestionPanelEl = null;

      if (suggestionPanel && (suggestionPanelEl = suggestionPanel.$el)) {
        var suggestionList = suggestionPanelEl.querySelector('.el-cascader__suggestion-list');
        suggestionList.style.minWidth = inputInner.offsetWidth + 'px';
      }

      if (tags) {
        var offsetHeight = tags.offsetHeight;

        var height = Math.max(offsetHeight + 6, inputInitialHeight) + 'px';
        inputInner.style.height = height;
        this.updatePopper();
      }
    },


    /**
     * public methods
    */
    getCheckedNodes: function getCheckedNodes(leafOnly) {
      return this.panel.getCheckedNodes(leafOnly);
    }
  }
});
// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_cascadervue_type_script_lang_js_ = (cascadervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue





/* normalize component */

var cascader_component = normalizeComponent(
  src_cascadervue_type_script_lang_js_,
  cascadervue_type_template_id_032537a6_render,
  cascadervue_type_template_id_032537a6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var cascader_api; }
cascader_component.options.__file = "packages/cascader/src/cascader.vue"
/* harmony default export */ var cascader = (cascader_component.exports);
// CONCATENATED MODULE: ./packages/cascader/index.js


/* istanbul ignore next */
cascader.install = function (Vue) {
  Vue.component(cascader.name, cascader);
};

/* harmony default export */ var packages_cascader = (cascader);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&
var mainvue_type_template_id_55c8ade7_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.hide,
          expression: "hide"
        }
      ],
      class: [
        "el-color-picker",
        _vm.colorDisabled ? "is-disabled" : "",
        _vm.colorSize ? "el-color-picker--" + _vm.colorSize : ""
      ]
    },
    [
      _vm.colorDisabled
        ? _c("div", { staticClass: "el-color-picker__mask" })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "el-color-picker__trigger",
          on: { click: _vm.handleTrigger }
        },
        [
          _c(
            "span",
            {
              staticClass: "el-color-picker__color",
              class: { "is-alpha": _vm.showAlpha }
            },
            [
              _c("span", {
                staticClass: "el-color-picker__color-inner",
                style: {
                  backgroundColor: _vm.displayedColor
                }
              }),
              !_vm.value && !_vm.showPanelColor
                ? _c("span", {
                    staticClass: "el-color-picker__empty el-icon-close"
                  })
                : _vm._e()
            ]
          ),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.value || _vm.showPanelColor,
                expression: "value || showPanelColor"
              }
            ],
            staticClass: "el-color-picker__icon el-icon-arrow-down"
          })
        ]
      ),
      _c("picker-dropdown", {
        ref: "dropdown",
        class: ["el-color-picker__panel", _vm.popperClass || ""],
        attrs: {
          color: _vm.color,
          "show-alpha": _vm.showAlpha,
          predefine: _vm.predefine
        },
        on: { pick: _vm.confirmValue, clear: _vm.clearValue },
        model: {
          value: _vm.showPicker,
          callback: function($$v) {
            _vm.showPicker = $$v
          },
          expression: "showPicker"
        }
      })
    ],
    1
  )
}
var mainvue_type_template_id_55c8ade7_staticRenderFns = []
mainvue_type_template_id_55c8ade7_render._withStripped = true


// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&

// CONCATENATED MODULE: ./packages/color-picker/src/color.js
var color_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function color_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var hsv2hsl = function hsv2hsl(hue, sat, val) {
  return [hue, sat * val / ((hue = (2 - sat) * val) < 1 ? hue : 2 - hue) || 0, hue / 2];
};

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
var isOnePointZero = function isOnePointZero(n) {
  return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
};

var isPercentage = function isPercentage(n) {
  return typeof n === 'string' && n.indexOf('%') !== -1;
};

// Take input from [0, n] and return it as [0, 1]
var bound01 = function bound01(value, max) {
  if (isOnePointZero(value)) value = '100%';

  var processPercent = isPercentage(value);
  value = Math.min(max, Math.max(0, parseFloat(value)));

  // Automatically convert percentage into number
  if (processPercent) {
    value = parseInt(value * max, 10) / 100;
  }

  // Handle floating point rounding errors
  if (Math.abs(value - max) < 0.000001) {
    return 1;
  }

  // Convert into [0, 1] range if it isn't already
  return value % max / parseFloat(max);
};

var INT_HEX_MAP = { 10: 'A', 11: 'B', 12: 'C', 13: 'D', 14: 'E', 15: 'F' };

var toHex = function toHex(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b;

  var hexOne = function hexOne(value) {
    value = Math.min(Math.round(value), 255);
    var high = Math.floor(value / 16);
    var low = value % 16;
    return '' + (INT_HEX_MAP[high] || high) + (INT_HEX_MAP[low] || low);
  };

  if (isNaN(r) || isNaN(g) || isNaN(b)) return '';

  return '#' + hexOne(r) + hexOne(g) + hexOne(b);
};

var HEX_INT_MAP = { A: 10, B: 11, C: 12, D: 13, E: 14, F: 15 };

var parseHexChannel = function parseHexChannel(hex) {
  if (hex.length === 2) {
    return (HEX_INT_MAP[hex[0].toUpperCase()] || +hex[0]) * 16 + (HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1]);
  }

  return HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1];
};

var hsl2hsv = function hsl2hsv(hue, sat, light) {
  sat = sat / 100;
  light = light / 100;
  var smin = sat;
  var lmin = Math.max(light, 0.01);
  var sv = void 0;
  var v = void 0;

  light *= 2;
  sat *= light <= 1 ? light : 2 - light;
  smin *= lmin <= 1 ? lmin : 2 - lmin;
  v = (light + sat) / 2;
  sv = light === 0 ? 2 * smin / (lmin + smin) : 2 * sat / (light + sat);

  return {
    h: hue,
    s: sv * 100,
    v: v * 100
  };
};

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
var rgb2hsv = function rgb2hsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);

  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var h = void 0,
      s = void 0;
  var v = max;

  var d = max - min;
  s = max === 0 ? 0 : d / max;

  if (max === min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }

  return { h: h * 360, s: s * 100, v: v * 100 };
};

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
var hsv2rgb = function hsv2rgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);

  var i = Math.floor(h);
  var f = h - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);
  var mod = i % 6;
  var r = [v, q, p, p, t, v][mod];
  var g = [t, v, v, q, p, p][mod];
  var b = [p, p, t, v, v, q][mod];

  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255)
  };
};

var Color = function () {
  function Color(options) {
    color_classCallCheck(this, Color);

    this._hue = 0;
    this._saturation = 100;
    this._value = 100;
    this._alpha = 100;

    this.enableAlpha = false;
    this.format = 'hex';
    this.value = '';

    options = options || {};

    for (var option in options) {
      if (options.hasOwnProperty(option)) {
        this[option] = options[option];
      }
    }

    this.doOnChange();
  }

  Color.prototype.set = function set(prop, value) {
    if (arguments.length === 1 && (typeof prop === 'undefined' ? 'undefined' : color_typeof(prop)) === 'object') {
      for (var p in prop) {
        if (prop.hasOwnProperty(p)) {
          this.set(p, prop[p]);
        }
      }

      return;
    }

    this['_' + prop] = value;
    this.doOnChange();
  };

  Color.prototype.get = function get(prop) {
    return this['_' + prop];
  };

  Color.prototype.toRgb = function toRgb() {
    return hsv2rgb(this._hue, this._saturation, this._value);
  };

  Color.prototype.fromString = function fromString(value) {
    var _this = this;

    if (!value) {
      this._hue = 0;
      this._saturation = 100;
      this._value = 100;

      this.doOnChange();
      return;
    }

    var fromHSV = function fromHSV(h, s, v) {
      _this._hue = Math.max(0, Math.min(360, h));
      _this._saturation = Math.max(0, Math.min(100, s));
      _this._value = Math.max(0, Math.min(100, v));

      _this.doOnChange();
    };

    if (value.indexOf('hsl') !== -1) {
      var parts = value.replace(/hsla|hsl|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
        return val !== '';
      }).map(function (val, index) {
        return index > 2 ? parseFloat(val) : parseInt(val, 10);
      });

      if (parts.length === 4) {
        this._alpha = Math.floor(parseFloat(parts[3]) * 100);
      } else if (parts.length === 3) {
        this._alpha = 100;
      }
      if (parts.length >= 3) {
        var _hsl2hsv = hsl2hsv(parts[0], parts[1], parts[2]),
            h = _hsl2hsv.h,
            s = _hsl2hsv.s,
            v = _hsl2hsv.v;

        fromHSV(h, s, v);
      }
    } else if (value.indexOf('hsv') !== -1) {
      var _parts = value.replace(/hsva|hsv|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
        return val !== '';
      }).map(function (val, index) {
        return index > 2 ? parseFloat(val) : parseInt(val, 10);
      });

      if (_parts.length === 4) {
        this._alpha = Math.floor(parseFloat(_parts[3]) * 100);
      } else if (_parts.length === 3) {
        this._alpha = 100;
      }
      if (_parts.length >= 3) {
        fromHSV(_parts[0], _parts[1], _parts[2]);
      }
    } else if (value.indexOf('rgb') !== -1) {
      var _parts2 = value.replace(/rgba|rgb|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
        return val !== '';
      }).map(function (val, index) {
        return index > 2 ? parseFloat(val) : parseInt(val, 10);
      });

      if (_parts2.length === 4) {
        this._alpha = Math.floor(parseFloat(_parts2[3]) * 100);
      } else if (_parts2.length === 3) {
        this._alpha = 100;
      }
      if (_parts2.length >= 3) {
        var _rgb2hsv = rgb2hsv(_parts2[0], _parts2[1], _parts2[2]),
            _h = _rgb2hsv.h,
            _s = _rgb2hsv.s,
            _v = _rgb2hsv.v;

        fromHSV(_h, _s, _v);
      }
    } else if (value.indexOf('#') !== -1) {
      var hex = value.replace('#', '').trim();
      if (!/^(?:[0-9a-fA-F]{3}){1,2}$/.test(hex)) return;
      var r = void 0,
          g = void 0,
          b = void 0;

      if (hex.length === 3) {
        r = parseHexChannel(hex[0] + hex[0]);
        g = parseHexChannel(hex[1] + hex[1]);
        b = parseHexChannel(hex[2] + hex[2]);
      } else if (hex.length === 6 || hex.length === 8) {
        r = parseHexChannel(hex.substring(0, 2));
        g = parseHexChannel(hex.substring(2, 4));
        b = parseHexChannel(hex.substring(4, 6));
      }

      if (hex.length === 8) {
        this._alpha = Math.floor(parseHexChannel(hex.substring(6)) / 255 * 100);
      } else if (hex.length === 3 || hex.length === 6) {
        this._alpha = 100;
      }

      var _rgb2hsv2 = rgb2hsv(r, g, b),
          _h2 = _rgb2hsv2.h,
          _s2 = _rgb2hsv2.s,
          _v2 = _rgb2hsv2.v;

      fromHSV(_h2, _s2, _v2);
    }
  };

  Color.prototype.compare = function compare(color) {
    return Math.abs(color._hue - this._hue) < 2 && Math.abs(color._saturation - this._saturation) < 1 && Math.abs(color._value - this._value) < 1 && Math.abs(color._alpha - this._alpha) < 1;
  };

  Color.prototype.doOnChange = function doOnChange() {
    var _hue = this._hue,
        _saturation = this._saturation,
        _value = this._value,
        _alpha = this._alpha,
        format = this.format;


    if (this.enableAlpha) {
      switch (format) {
        case 'hsl':
          var hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);
          this.value = 'hsla(' + _hue + ', ' + Math.round(hsl[1] * 100) + '%, ' + Math.round(hsl[2] * 100) + '%, ' + _alpha / 100 + ')';
          break;
        case 'hsv':
          this.value = 'hsva(' + _hue + ', ' + Math.round(_saturation) + '%, ' + Math.round(_value) + '%, ' + _alpha / 100 + ')';
          break;
        default:
          var _hsv2rgb = hsv2rgb(_hue, _saturation, _value),
              r = _hsv2rgb.r,
              g = _hsv2rgb.g,
              b = _hsv2rgb.b;

          this.value = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + _alpha / 100 + ')';
      }
    } else {
      switch (format) {
        case 'hsl':
          var _hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);
          this.value = 'hsl(' + _hue + ', ' + Math.round(_hsl[1] * 100) + '%, ' + Math.round(_hsl[2] * 100) + '%)';
          break;
        case 'hsv':
          this.value = 'hsv(' + _hue + ', ' + Math.round(_saturation) + '%, ' + Math.round(_value) + '%)';
          break;
        case 'rgb':
          var _hsv2rgb2 = hsv2rgb(_hue, _saturation, _value),
              _r = _hsv2rgb2.r,
              _g = _hsv2rgb2.g,
              _b = _hsv2rgb2.b;

          this.value = 'rgb(' + _r + ', ' + _g + ', ' + _b + ')';
          break;
        default:
          this.value = toHex(hsv2rgb(_hue, _saturation, _value));
      }
    }
  };

  return Color;
}();

/* harmony default export */ var src_color = (Color);
;
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&
var picker_dropdownvue_type_template_id_06601625_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showPopper,
              expression: "showPopper"
            }
          ],
          staticClass: "el-color-dropdown"
        },
        [
          _c(
            "div",
            { staticClass: "el-color-dropdown__main-wrapper" },
            [
              _c("hue-slider", {
                ref: "hue",
                staticStyle: { float: "right" },
                attrs: { color: _vm.color, vertical: "" }
              }),
              _c("sv-panel", { ref: "sl", attrs: { color: _vm.color } })
            ],
            1
          ),
          _vm.showAlpha
            ? _c("alpha-slider", { ref: "alpha", attrs: { color: _vm.color } })
            : _vm._e(),
          _vm.predefine
            ? _c("predefine", {
                attrs: { color: _vm.color, colors: _vm.predefine }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "el-color-dropdown__btns" },
            [
              _c(
                "span",
                { staticClass: "el-color-dropdown__value" },
                [
                  _c("el-input", {
                    attrs: { "validate-event": false, size: "mini" },
                    on: { blur: _vm.handleConfirm },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleConfirm($event)
                      }
                    },
                    model: {
                      value: _vm.customInput,
                      callback: function($$v) {
                        _vm.customInput = $$v
                      },
                      expression: "customInput"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticClass: "el-color-dropdown__link-btn",
                  attrs: { size: "mini", type: "text" },
                  on: {
                    click: function($event) {
                      _vm.$emit("clear")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.t("el.colorpicker.clear")) +
                      "\n      "
                  )
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "el-color-dropdown__btn",
                  attrs: { plain: "", size: "mini" },
                  on: { click: _vm.confirmValue }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.t("el.colorpicker.confirm")) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var picker_dropdownvue_type_template_id_06601625_staticRenderFns = []
picker_dropdownvue_type_template_id_06601625_render._withStripped = true


// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&
var sv_panelvue_type_template_id_d8583596_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-color-svpanel",
      style: {
        backgroundColor: _vm.background
      }
    },
    [
      _c("div", { staticClass: "el-color-svpanel__white" }),
      _c("div", { staticClass: "el-color-svpanel__black" }),
      _c(
        "div",
        {
          staticClass: "el-color-svpanel__cursor",
          style: {
            top: _vm.cursorTop + "px",
            left: _vm.cursorLeft + "px"
          }
        },
        [_c("div")]
      )
    ]
  )
}
var sv_panelvue_type_template_id_d8583596_staticRenderFns = []
sv_panelvue_type_template_id_d8583596_render._withStripped = true


// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&

// CONCATENATED MODULE: ./packages/color-picker/src/draggable.js

var isDragging = false;

/* harmony default export */ var draggable = (function (element, options) {
  if (external_vue_default.a.prototype.$isServer) return;
  var moveFn = function moveFn(event) {
    if (options.drag) {
      options.drag(event);
    }
  };
  var upFn = function upFn(event) {
    document.removeEventListener('mousemove', moveFn);
    document.removeEventListener('mouseup', upFn);
    document.onselectstart = null;
    document.ondragstart = null;

    isDragging = false;

    if (options.end) {
      options.end(event);
    }
  };
  element.addEventListener('mousedown', function (event) {
    if (isDragging) return;
    document.onselectstart = function () {
      return false;
    };
    document.ondragstart = function () {
      return false;
    };

    document.addEventListener('mousemove', moveFn);
    document.addEventListener('mouseup', upFn);
    isDragging = true;

    if (options.start) {
      options.start(event);
    }
  });
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var sv_panelvue_type_script_lang_js_ = ({
  name: 'el-sl-panel',

  props: {
    color: {
      required: true
    }
  },

  computed: {
    colorValue: function colorValue() {
      var hue = this.color.get('hue');
      var value = this.color.get('value');
      return { hue: hue, value: value };
    }
  },

  watch: {
    colorValue: function colorValue() {
      this.update();
    }
  },

  methods: {
    update: function update() {
      var saturation = this.color.get('saturation');
      var value = this.color.get('value');

      var el = this.$el;
      var width = el.clientWidth,
          height = el.clientHeight;


      this.cursorLeft = saturation * width / 100;
      this.cursorTop = (100 - value) * height / 100;

      this.background = 'hsl(' + this.color.get('hue') + ', 100%, 50%)';
    },
    handleDrag: function handleDrag(event) {
      var el = this.$el;
      var rect = el.getBoundingClientRect();

      var left = event.clientX - rect.left;
      var top = event.clientY - rect.top;
      left = Math.max(0, left);
      left = Math.min(left, rect.width);

      top = Math.max(0, top);
      top = Math.min(top, rect.height);

      this.cursorLeft = left;
      this.cursorTop = top;
      this.color.set({
        saturation: left / rect.width * 100,
        value: 100 - top / rect.height * 100
      });
    }
  },

  mounted: function mounted() {
    var _this = this;

    draggable(this.$el, {
      drag: function drag(event) {
        _this.handleDrag(event);
      },
      end: function end(event) {
        _this.handleDrag(event);
      }
    });

    this.update();
  },
  data: function data() {
    return {
      cursorTop: 0,
      cursorLeft: 0,
      background: 'hsl(0, 100%, 50%)'
    };
  }
});
// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_sv_panelvue_type_script_lang_js_ = (sv_panelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue





/* normalize component */

var sv_panel_component = normalizeComponent(
  components_sv_panelvue_type_script_lang_js_,
  sv_panelvue_type_template_id_d8583596_render,
  sv_panelvue_type_template_id_d8583596_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var sv_panel_api; }
sv_panel_component.options.__file = "packages/color-picker/src/components/sv-panel.vue"
/* harmony default export */ var sv_panel = (sv_panel_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&
var hue_slidervue_type_template_id_5cdc43b1_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-color-hue-slider",
      class: { "is-vertical": _vm.vertical }
    },
    [
      _c("div", {
        ref: "bar",
        staticClass: "el-color-hue-slider__bar",
        on: { click: _vm.handleClick }
      }),
      _c("div", {
        ref: "thumb",
        staticClass: "el-color-hue-slider__thumb",
        style: {
          left: _vm.thumbLeft + "px",
          top: _vm.thumbTop + "px"
        }
      })
    ]
  )
}
var hue_slidervue_type_template_id_5cdc43b1_staticRenderFns = []
hue_slidervue_type_template_id_5cdc43b1_render._withStripped = true


// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var hue_slidervue_type_script_lang_js_ = ({
  name: 'el-color-hue-slider',

  props: {
    color: {
      required: true
    },

    vertical: Boolean
  },

  data: function data() {
    return {
      thumbLeft: 0,
      thumbTop: 0
    };
  },


  computed: {
    hueValue: function hueValue() {
      var hue = this.color.get('hue');
      return hue;
    }
  },

  watch: {
    hueValue: function hueValue() {
      this.update();
    }
  },

  methods: {
    handleClick: function handleClick(event) {
      var thumb = this.$refs.thumb;
      var target = event.target;

      if (target !== thumb) {
        this.handleDrag(event);
      }
    },
    handleDrag: function handleDrag(event) {
      var rect = this.$el.getBoundingClientRect();
      var thumb = this.$refs.thumb;

      var hue = void 0;

      if (!this.vertical) {
        var left = event.clientX - rect.left;
        left = Math.min(left, rect.width - thumb.offsetWidth / 2);
        left = Math.max(thumb.offsetWidth / 2, left);

        hue = Math.round((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth) * 360);
      } else {
        var top = event.clientY - rect.top;
        top = Math.min(top, rect.height - thumb.offsetHeight / 2);
        top = Math.max(thumb.offsetHeight / 2, top);

        hue = Math.round((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight) * 360);
      }

      this.color.set('hue', hue);
    },
    getThumbLeft: function getThumbLeft() {
      if (this.vertical) return 0;
      var el = this.$el;
      var hue = this.color.get('hue');

      if (!el) return 0;
      var thumb = this.$refs.thumb;
      return Math.round(hue * (el.offsetWidth - thumb.offsetWidth / 2) / 360);
    },
    getThumbTop: function getThumbTop() {
      if (!this.vertical) return 0;
      var el = this.$el;
      var hue = this.color.get('hue');

      if (!el) return 0;
      var thumb = this.$refs.thumb;
      return Math.round(hue * (el.offsetHeight - thumb.offsetHeight / 2) / 360);
    },
    update: function update() {
      this.thumbLeft = this.getThumbLeft();
      this.thumbTop = this.getThumbTop();
    }
  },

  mounted: function mounted() {
    var _this = this;

    var _$refs = this.$refs,
        bar = _$refs.bar,
        thumb = _$refs.thumb;


    var dragConfig = {
      drag: function drag(event) {
        _this.handleDrag(event);
      },
      end: function end(event) {
        _this.handleDrag(event);
      }
    };

    draggable(bar, dragConfig);
    draggable(thumb, dragConfig);
    this.update();
  }
});
// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_hue_slidervue_type_script_lang_js_ = (hue_slidervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue





/* normalize component */

var hue_slider_component = normalizeComponent(
  components_hue_slidervue_type_script_lang_js_,
  hue_slidervue_type_template_id_5cdc43b1_render,
  hue_slidervue_type_template_id_5cdc43b1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var hue_slider_api; }
hue_slider_component.options.__file = "packages/color-picker/src/components/hue-slider.vue"
/* harmony default export */ var hue_slider = (hue_slider_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&
var alpha_slidervue_type_template_id_068c66cb_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-color-alpha-slider",
      class: { "is-vertical": _vm.vertical }
    },
    [
      _c("div", {
        ref: "bar",
        staticClass: "el-color-alpha-slider__bar",
        style: {
          background: _vm.background
        },
        on: { click: _vm.handleClick }
      }),
      _c("div", {
        ref: "thumb",
        staticClass: "el-color-alpha-slider__thumb",
        style: {
          left: _vm.thumbLeft + "px",
          top: _vm.thumbTop + "px"
        }
      })
    ]
  )
}
var alpha_slidervue_type_template_id_068c66cb_staticRenderFns = []
alpha_slidervue_type_template_id_068c66cb_render._withStripped = true


// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var alpha_slidervue_type_script_lang_js_ = ({
  name: 'el-color-alpha-slider',

  props: {
    color: {
      required: true
    },
    vertical: Boolean
  },

  watch: {
    'color._alpha': function color_alpha() {
      this.update();
    },
    'color.value': function colorValue() {
      this.update();
    }
  },

  methods: {
    handleClick: function handleClick(event) {
      var thumb = this.$refs.thumb;
      var target = event.target;

      if (target !== thumb) {
        this.handleDrag(event);
      }
    },
    handleDrag: function handleDrag(event) {
      var rect = this.$el.getBoundingClientRect();
      var thumb = this.$refs.thumb;


      if (!this.vertical) {
        var left = event.clientX - rect.left;
        left = Math.max(thumb.offsetWidth / 2, left);
        left = Math.min(left, rect.width - thumb.offsetWidth / 2);

        this.color.set('alpha', Math.round((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth) * 100));
      } else {
        var top = event.clientY - rect.top;
        top = Math.max(thumb.offsetHeight / 2, top);
        top = Math.min(top, rect.height - thumb.offsetHeight / 2);

        this.color.set('alpha', Math.round((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight) * 100));
      }
    },
    getThumbLeft: function getThumbLeft() {
      if (this.vertical) return 0;
      var el = this.$el;
      var alpha = this.color._alpha;

      if (!el) return 0;
      var thumb = this.$refs.thumb;
      return Math.round(alpha * (el.offsetWidth - thumb.offsetWidth / 2) / 100);
    },
    getThumbTop: function getThumbTop() {
      if (!this.vertical) return 0;
      var el = this.$el;
      var alpha = this.color._alpha;

      if (!el) return 0;
      var thumb = this.$refs.thumb;
      return Math.round(alpha * (el.offsetHeight - thumb.offsetHeight / 2) / 100);
    },
    getBackground: function getBackground() {
      if (this.color && this.color.value) {
        var _color$toRgb = this.color.toRgb(),
            r = _color$toRgb.r,
            g = _color$toRgb.g,
            b = _color$toRgb.b;

        return 'linear-gradient(to right, rgba(' + r + ', ' + g + ', ' + b + ', 0) 0%, rgba(' + r + ', ' + g + ', ' + b + ', 1) 100%)';
      }
      return null;
    },
    update: function update() {
      this.thumbLeft = this.getThumbLeft();
      this.thumbTop = this.getThumbTop();
      this.background = this.getBackground();
    }
  },

  data: function data() {
    return {
      thumbLeft: 0,
      thumbTop: 0,
      background: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    var _$refs = this.$refs,
        bar = _$refs.bar,
        thumb = _$refs.thumb;


    var dragConfig = {
      drag: function drag(event) {
        _this.handleDrag(event);
      },
      end: function end(event) {
        _this.handleDrag(event);
      }
    };

    draggable(bar, dragConfig);
    draggable(thumb, dragConfig);
    this.update();
  }
});
// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_alpha_slidervue_type_script_lang_js_ = (alpha_slidervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue





/* normalize component */

var alpha_slider_component = normalizeComponent(
  components_alpha_slidervue_type_script_lang_js_,
  alpha_slidervue_type_template_id_068c66cb_render,
  alpha_slidervue_type_template_id_068c66cb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var alpha_slider_api; }
alpha_slider_component.options.__file = "packages/color-picker/src/components/alpha-slider.vue"
/* harmony default export */ var alpha_slider = (alpha_slider_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&
var predefinevue_type_template_id_06e03093_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-color-predefine" }, [
    _c(
      "div",
      { staticClass: "el-color-predefine__colors" },
      _vm._l(_vm.rgbaColors, function(item, index) {
        return _c(
          "div",
          {
            key: _vm.colors[index],
            staticClass: "el-color-predefine__color-selector",
            class: { selected: item.selected, "is-alpha": item._alpha < 100 },
            on: {
              click: function($event) {
                _vm.handleSelect(index)
              }
            }
          },
          [_c("div", { style: { "background-color": item.value } })]
        )
      }),
      0
    )
  ])
}
var predefinevue_type_template_id_06e03093_staticRenderFns = []
predefinevue_type_template_id_06e03093_render._withStripped = true


// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var predefinevue_type_script_lang_js_ = ({
  props: {
    colors: { type: Array, required: true },
    color: { required: true }
  },
  data: function data() {
    return {
      rgbaColors: this.parseColors(this.colors, this.color)
    };
  },

  methods: {
    handleSelect: function handleSelect(index) {
      this.color.fromString(this.colors[index]);
    },
    parseColors: function parseColors(colors, color) {
      return colors.map(function (value) {
        var c = new src_color();
        c.enableAlpha = true;
        c.format = 'rgba';
        c.fromString(value);
        c.selected = c.value === color.value;
        return c;
      });
    }
  },
  watch: {
    '$parent.currentColor': function $parentCurrentColor(val) {
      var color = new src_color();
      color.fromString(val);

      this.rgbaColors.forEach(function (item) {
        item.selected = color.compare(item);
      });
    },
    colors: function colors(newVal) {
      this.rgbaColors = this.parseColors(newVal, this.color);
    },
    color: function color(newVal) {
      this.rgbaColors = this.parseColors(this.colors, newVal);
    }
  }
});
// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_predefinevue_type_script_lang_js_ = (predefinevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue





/* normalize component */

var predefine_component = normalizeComponent(
  components_predefinevue_type_script_lang_js_,
  predefinevue_type_template_id_06e03093_render,
  predefinevue_type_template_id_06e03093_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var predefine_api; }
predefine_component.options.__file = "packages/color-picker/src/components/predefine.vue"
/* harmony default export */ var predefine = (predefine_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var picker_dropdownvue_type_script_lang_js_ = ({
  name: 'el-color-picker-dropdown',

  mixins: [vue_popper_default.a, locale_default.a],

  components: {
    SvPanel: sv_panel,
    HueSlider: hue_slider,
    AlphaSlider: alpha_slider,
    ElInput: input_default.a,
    ElButton: button_default.a,
    Predefine: predefine
  },

  props: {
    color: {
      required: true
    },
    showAlpha: Boolean,
    predefine: Array
  },

  data: function data() {
    return {
      customInput: ''
    };
  },


  computed: {
    currentColor: function currentColor() {
      var parent = this.$parent;
      return !parent.value && !parent.showPanelColor ? '' : parent.color.value;
    }
  },

  methods: {
    confirmValue: function confirmValue() {
      this.$emit('pick');
    },
    handleConfirm: function handleConfirm() {
      this.color.fromString(this.customInput);
    }
  },

  mounted: function mounted() {
    this.$parent.popperElm = this.popperElm = this.$el;
    this.referenceElm = this.$parent.$el;
  },


  watch: {
    showPopper: function showPopper(val) {
      var _this = this;

      if (val === true) {
        this.$nextTick(function () {
          var _$refs = _this.$refs,
              sl = _$refs.sl,
              hue = _$refs.hue,
              alpha = _$refs.alpha;

          sl && sl.update();
          hue && hue.update();
          alpha && alpha.update();
        });
      }
    },


    currentColor: {
      immediate: true,
      handler: function handler(val) {
        this.customInput = val;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_picker_dropdownvue_type_script_lang_js_ = (picker_dropdownvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue





/* normalize component */

var picker_dropdown_component = normalizeComponent(
  components_picker_dropdownvue_type_script_lang_js_,
  picker_dropdownvue_type_template_id_06601625_render,
  picker_dropdownvue_type_template_id_06601625_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var picker_dropdown_api; }
picker_dropdown_component.options.__file = "packages/color-picker/src/components/picker-dropdown.vue"
/* harmony default export */ var picker_dropdown = (picker_dropdown_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var color_picker_src_mainvue_type_script_lang_js_ = ({
  name: 'ElColorPicker',

  mixins: [emitter_default.a],

  props: {
    value: String,
    showAlpha: Boolean,
    colorFormat: String,
    disabled: Boolean,
    size: String,
    popperClass: String,
    predefine: Array
  },

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  directives: { Clickoutside: clickoutside_default.a },

  computed: {
    displayedColor: function displayedColor() {
      if (!this.value && !this.showPanelColor) {
        return 'transparent';
      }

      return this.displayedRgb(this.color, this.showAlpha);
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    colorSize: function colorSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    colorDisabled: function colorDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  watch: {
    value: function value(val) {
      if (!val) {
        this.showPanelColor = false;
      } else if (val && val !== this.color.value) {
        this.color.fromString(val);
      }
    },

    color: {
      deep: true,
      handler: function handler() {
        this.showPanelColor = true;
      }
    },
    displayedColor: function displayedColor(val) {
      if (!this.showPicker) return;
      var currentValueColor = new src_color({
        enableAlpha: this.showAlpha,
        format: this.colorFormat
      });
      currentValueColor.fromString(this.value);

      var currentValueColorRgb = this.displayedRgb(currentValueColor, this.showAlpha);
      if (val !== currentValueColorRgb) {
        this.$emit('active-change', val);
      }
    }
  },

  methods: {
    handleTrigger: function handleTrigger() {
      if (this.colorDisabled) return;
      this.showPicker = !this.showPicker;
    },
    confirmValue: function confirmValue() {
      var value = this.color.value;
      this.$emit('input', value);
      this.$emit('change', value);
      this.dispatch('ElFormItem', 'el.form.change', value);
      this.showPicker = false;
    },
    clearValue: function clearValue() {
      this.$emit('input', null);
      this.$emit('change', null);
      if (this.value !== null) {
        this.dispatch('ElFormItem', 'el.form.change', null);
      }
      this.showPanelColor = false;
      this.showPicker = false;
      this.resetColor();
    },
    hide: function hide() {
      this.showPicker = false;
      this.resetColor();
    },
    resetColor: function resetColor() {
      var _this = this;

      this.$nextTick(function (_) {
        if (_this.value) {
          _this.color.fromString(_this.value);
        } else {
          _this.showPanelColor = false;
        }
      });
    },
    displayedRgb: function displayedRgb(color, showAlpha) {
      if (!(color instanceof src_color)) {
        throw Error('color should be instance of Color Class');
      }

      var _color$toRgb = color.toRgb(),
          r = _color$toRgb.r,
          g = _color$toRgb.g,
          b = _color$toRgb.b;

      return showAlpha ? 'rgba(' + r + ', ' + g + ', ' + b + ', ' + color.get('alpha') / 100 + ')' : 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
  },

  mounted: function mounted() {
    var value = this.value;
    if (value) {
      this.color.fromString(value);
    }
    this.popperElm = this.$refs.dropdown.$el;
  },
  data: function data() {
    var color = new src_color({
      enableAlpha: this.showAlpha,
      format: this.colorFormat
    });

    return {
      color: color,
      showPicker: false,
      showPanelColor: false
    };
  },


  components: {
    PickerDropdown: picker_dropdown
  }
});
// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_color_picker_src_mainvue_type_script_lang_js_ = (color_picker_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/color-picker/src/main.vue





/* normalize component */

var color_picker_src_main_component = normalizeComponent(
  packages_color_picker_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_55c8ade7_render,
  mainvue_type_template_id_55c8ade7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var color_picker_src_main_api; }
color_picker_src_main_component.options.__file = "packages/color-picker/src/main.vue"
/* harmony default export */ var color_picker_src_main = (color_picker_src_main_component.exports);
// CONCATENATED MODULE: ./packages/color-picker/index.js


/* istanbul ignore next */
color_picker_src_main.install = function (Vue) {
  Vue.component(color_picker_src_main.name, color_picker_src_main);
};

/* harmony default export */ var color_picker = (color_picker_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&
var mainvue_type_template_id_5c654dd8_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-transfer" },
    [
      _c(
        "transfer-panel",
        _vm._b(
          {
            ref: "leftPanel",
            attrs: {
              data: _vm.sourceData,
              title: _vm.titles[0] || _vm.t("el.transfer.titles.0"),
              "default-checked": _vm.leftDefaultChecked,
              placeholder:
                _vm.filterPlaceholder || _vm.t("el.transfer.filterPlaceholder")
            },
            on: { "checked-change": _vm.onSourceCheckedChange }
          },
          "transfer-panel",
          _vm.$props,
          false
        ),
        [_vm._t("left-footer")],
        2
      ),
      _c(
        "div",
        { staticClass: "el-transfer__buttons" },
        [
          _c(
            "el-button",
            {
              class: [
                "el-transfer__button",
                _vm.hasButtonTexts ? "is-with-texts" : ""
              ],
              attrs: {
                type: "primary",
                disabled: _vm.rightChecked.length === 0
              },
              nativeOn: {
                click: function($event) {
                  return _vm.addToLeft($event)
                }
              }
            },
            [
              _c("i", { staticClass: "el-icon-arrow-left" }),
              _vm.buttonTexts[0] !== undefined
                ? _c("span", [_vm._v(_vm._s(_vm.buttonTexts[0]))])
                : _vm._e()
            ]
          ),
          _c(
            "el-button",
            {
              class: [
                "el-transfer__button",
                _vm.hasButtonTexts ? "is-with-texts" : ""
              ],
              attrs: {
                type: "primary",
                disabled: _vm.leftChecked.length === 0
              },
              nativeOn: {
                click: function($event) {
                  return _vm.addToRight($event)
                }
              }
            },
            [
              _vm.buttonTexts[1] !== undefined
                ? _c("span", [_vm._v(_vm._s(_vm.buttonTexts[1]))])
                : _vm._e(),
              _c("i", { staticClass: "el-icon-arrow-right" })
            ]
          )
        ],
        1
      ),
      _c(
        "transfer-panel",
        _vm._b(
          {
            ref: "rightPanel",
            attrs: {
              data: _vm.targetData,
              title: _vm.titles[1] || _vm.t("el.transfer.titles.1"),
              "default-checked": _vm.rightDefaultChecked,
              placeholder:
                _vm.filterPlaceholder || _vm.t("el.transfer.filterPlaceholder")
            },
            on: { "checked-change": _vm.onTargetCheckedChange }
          },
          "transfer-panel",
          _vm.$props,
          false
        ),
        [_vm._t("right-footer")],
        2
      )
    ],
    1
  )
}
var mainvue_type_template_id_5c654dd8_staticRenderFns = []
mainvue_type_template_id_5c654dd8_render._withStripped = true


// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&
var transfer_panelvue_type_template_id_2ddab8bd_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-transfer-panel" }, [
    _c(
      "p",
      { staticClass: "el-transfer-panel__header" },
      [
        _c(
          "el-checkbox",
          {
            attrs: { indeterminate: _vm.isIndeterminate },
            on: { change: _vm.handleAllCheckedChange },
            model: {
              value: _vm.allChecked,
              callback: function($$v) {
                _vm.allChecked = $$v
              },
              expression: "allChecked"
            }
          },
          [
            _vm._v("\n      " + _vm._s(_vm.title) + "\n      "),
            _c("span", [_vm._v(_vm._s(_vm.checkedSummary))])
          ]
        )
      ],
      1
    ),
    _c(
      "div",
      {
        class: [
          "el-transfer-panel__body",
          _vm.hasFooter ? "is-with-footer" : ""
        ]
      },
      [
        _vm.filterable
          ? _c(
              "el-input",
              {
                staticClass: "el-transfer-panel__filter",
                attrs: { size: "small", placeholder: _vm.placeholder },
                nativeOn: {
                  mouseenter: function($event) {
                    _vm.inputHover = true
                  },
                  mouseleave: function($event) {
                    _vm.inputHover = false
                  }
                },
                model: {
                  value: _vm.query,
                  callback: function($$v) {
                    _vm.query = $$v
                  },
                  expression: "query"
                }
              },
              [
                _c("i", {
                  class: ["el-input__icon", "el-icon-" + _vm.inputIcon],
                  attrs: { slot: "prefix" },
                  on: { click: _vm.clearQuery },
                  slot: "prefix"
                })
              ]
            )
          : _vm._e(),
        _c(
          "el-checkbox-group",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hasNoMatch && _vm.data.length > 0,
                expression: "!hasNoMatch && data.length > 0"
              }
            ],
            staticClass: "el-transfer-panel__list",
            class: { "is-filterable": _vm.filterable },
            model: {
              value: _vm.checked,
              callback: function($$v) {
                _vm.checked = $$v
              },
              expression: "checked"
            }
          },
          _vm._l(_vm.filteredData, function(item) {
            return _c(
              "el-checkbox",
              {
                key: item[_vm.keyProp],
                staticClass: "el-transfer-panel__item",
                attrs: {
                  label: item[_vm.keyProp],
                  disabled: item[_vm.disabledProp]
                }
              },
              [_c("option-content", { attrs: { option: item } })],
              1
            )
          }),
          1
        ),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasNoMatch,
                expression: "hasNoMatch"
              }
            ],
            staticClass: "el-transfer-panel__empty"
          },
          [_vm._v(_vm._s(_vm.t("el.transfer.noMatch")))]
        ),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.data.length === 0 && !_vm.hasNoMatch,
                expression: "data.length === 0 && !hasNoMatch"
              }
            ],
            staticClass: "el-transfer-panel__empty"
          },
          [_vm._v(_vm._s(_vm.t("el.transfer.noData")))]
        )
      ],
      1
    ),
    _vm.hasFooter
      ? _c(
          "p",
          { staticClass: "el-transfer-panel__footer" },
          [_vm._t("default")],
          2
        )
      : _vm._e()
  ])
}
var transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns = []
transfer_panelvue_type_template_id_2ddab8bd_render._withStripped = true


// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var transfer_panelvue_type_script_lang_js_ = ({
  mixins: [locale_default.a],

  name: 'ElTransferPanel',

  componentName: 'ElTransferPanel',

  components: {
    ElCheckboxGroup: checkbox_group_default.a,
    ElCheckbox: checkbox_default.a,
    ElInput: input_default.a,
    OptionContent: {
      props: {
        option: Object
      },
      render: function render(h) {
        var getParent = function getParent(vm) {
          if (vm.$options.componentName === 'ElTransferPanel') {
            return vm;
          } else if (vm.$parent) {
            return getParent(vm.$parent);
          } else {
            return vm;
          }
        };
        var panel = getParent(this);
        var transfer = panel.$parent || panel;
        return panel.renderContent ? panel.renderContent(h, this.option) : transfer.$scopedSlots.default ? transfer.$scopedSlots.default({ option: this.option }) : h('span', [this.option[panel.labelProp] || this.option[panel.keyProp]]);
      }
    }
  },

  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    renderContent: Function,
    placeholder: String,
    title: String,
    filterable: Boolean,
    format: Object,
    filterMethod: Function,
    defaultChecked: Array,
    props: Object
  },

  data: function data() {
    return {
      checked: [],
      allChecked: false,
      query: '',
      inputHover: false,
      checkChangeByUser: true
    };
  },


  watch: {
    checked: function checked(val, oldVal) {
      this.updateAllChecked();
      if (this.checkChangeByUser) {
        var movedKeys = val.concat(oldVal).filter(function (v) {
          return val.indexOf(v) === -1 || oldVal.indexOf(v) === -1;
        });
        this.$emit('checked-change', val, movedKeys);
      } else {
        this.$emit('checked-change', val);
        this.checkChangeByUser = true;
      }
    },
    data: function data() {
      var _this = this;

      var checked = [];
      var filteredDataKeys = this.filteredData.map(function (item) {
        return item[_this.keyProp];
      });
      this.checked.forEach(function (item) {
        if (filteredDataKeys.indexOf(item) > -1) {
          checked.push(item);
        }
      });
      this.checkChangeByUser = false;
      this.checked = checked;
    },
    checkableData: function checkableData() {
      this.updateAllChecked();
    },


    defaultChecked: {
      immediate: true,
      handler: function handler(val, oldVal) {
        var _this2 = this;

        if (oldVal && val.length === oldVal.length && val.every(function (item) {
          return oldVal.indexOf(item) > -1;
        })) return;
        var checked = [];
        var checkableDataKeys = this.checkableData.map(function (item) {
          return item[_this2.keyProp];
        });
        val.forEach(function (item) {
          if (checkableDataKeys.indexOf(item) > -1) {
            checked.push(item);
          }
        });
        this.checkChangeByUser = false;
        this.checked = checked;
      }
    }
  },

  computed: {
    filteredData: function filteredData() {
      var _this3 = this;

      return this.data.filter(function (item) {
        if (typeof _this3.filterMethod === 'function') {
          return _this3.filterMethod(_this3.query, item);
        } else {
          var label = item[_this3.labelProp] || item[_this3.keyProp].toString();
          return label.toLowerCase().indexOf(_this3.query.toLowerCase()) > -1;
        }
      });
    },
    checkableData: function checkableData() {
      var _this4 = this;

      return this.filteredData.filter(function (item) {
        return !item[_this4.disabledProp];
      });
    },
    checkedSummary: function checkedSummary() {
      var checkedLength = this.checked.length;
      var dataLength = this.data.length;
      var _format = this.format,
          noChecked = _format.noChecked,
          hasChecked = _format.hasChecked;

      if (noChecked && hasChecked) {
        return checkedLength > 0 ? hasChecked.replace(/\${checked}/g, checkedLength).replace(/\${total}/g, dataLength) : noChecked.replace(/\${total}/g, dataLength);
      } else {
        return checkedLength + '/' + dataLength;
      }
    },
    isIndeterminate: function isIndeterminate() {
      var checkedLength = this.checked.length;
      return checkedLength > 0 && checkedLength < this.checkableData.length;
    },
    hasNoMatch: function hasNoMatch() {
      return this.query.length > 0 && this.filteredData.length === 0;
    },
    inputIcon: function inputIcon() {
      return this.query.length > 0 && this.inputHover ? 'circle-close' : 'search';
    },
    labelProp: function labelProp() {
      return this.props.label || 'label';
    },
    keyProp: function keyProp() {
      return this.props.key || 'key';
    },
    disabledProp: function disabledProp() {
      return this.props.disabled || 'disabled';
    },
    hasFooter: function hasFooter() {
      return !!this.$slots.default;
    }
  },

  methods: {
    updateAllChecked: function updateAllChecked() {
      var _this5 = this;

      var checkableDataKeys = this.checkableData.map(function (item) {
        return item[_this5.keyProp];
      });
      this.allChecked = checkableDataKeys.length > 0 && checkableDataKeys.every(function (item) {
        return _this5.checked.indexOf(item) > -1;
      });
    },
    handleAllCheckedChange: function handleAllCheckedChange(value) {
      var _this6 = this;

      this.checked = value ? this.checkableData.map(function (item) {
        return item[_this6.keyProp];
      }) : [];
    },
    clearQuery: function clearQuery() {
      if (this.inputIcon === 'circle-close') {
        this.query = '';
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_transfer_panelvue_type_script_lang_js_ = (transfer_panelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue





/* normalize component */

var transfer_panel_component = normalizeComponent(
  src_transfer_panelvue_type_script_lang_js_,
  transfer_panelvue_type_template_id_2ddab8bd_render,
  transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var transfer_panel_api; }
transfer_panel_component.options.__file = "packages/transfer/src/transfer-panel.vue"
/* harmony default export */ var transfer_panel = (transfer_panel_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var transfer_src_mainvue_type_script_lang_js_ = ({
  name: 'ElTransfer',

  mixins: [emitter_default.a, locale_default.a, migrating_default.a],

  components: {
    TransferPanel: transfer_panel,
    ElButton: button_default.a
  },

  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    titles: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    buttonTexts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filterPlaceholder: {
      type: String,
      default: ''
    },
    filterMethod: Function,
    leftDefaultChecked: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rightDefaultChecked: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    renderContent: Function,
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    format: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    filterable: Boolean,
    props: {
      type: Object,
      default: function _default() {
        return {
          label: 'label',
          key: 'key',
          disabled: 'disabled'
        };
      }
    },
    targetOrder: {
      type: String,
      default: 'original'
    }
  },

  data: function data() {
    return {
      leftChecked: [],
      rightChecked: []
    };
  },


  computed: {
    dataObj: function dataObj() {
      var key = this.props.key;
      return this.data.reduce(function (o, cur) {
        return (o[cur[key]] = cur) && o;
      }, {});
    },
    sourceData: function sourceData() {
      var _this = this;

      return this.data.filter(function (item) {
        return _this.value.indexOf(item[_this.props.key]) === -1;
      });
    },
    targetData: function targetData() {
      var _this2 = this;

      if (this.targetOrder === 'original') {
        return this.data.filter(function (item) {
          return _this2.value.indexOf(item[_this2.props.key]) > -1;
        });
      } else {
        return this.value.reduce(function (arr, cur) {
          var val = _this2.dataObj[cur];
          if (val) {
            arr.push(val);
          }
          return arr;
        }, []);
      }
    },
    hasButtonTexts: function hasButtonTexts() {
      return this.buttonTexts.length === 2;
    }
  },

  watch: {
    value: function value(val) {
      this.dispatch('ElFormItem', 'el.form.change', val);
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'footer-format': 'footer-format is renamed to format.'
        }
      };
    },
    onSourceCheckedChange: function onSourceCheckedChange(val, movedKeys) {
      this.leftChecked = val;
      if (movedKeys === undefined) return;
      this.$emit('left-check-change', val, movedKeys);
    },
    onTargetCheckedChange: function onTargetCheckedChange(val, movedKeys) {
      this.rightChecked = val;
      if (movedKeys === undefined) return;
      this.$emit('right-check-change', val, movedKeys);
    },
    addToLeft: function addToLeft() {
      var currentValue = this.value.slice();
      this.rightChecked.forEach(function (item) {
        var index = currentValue.indexOf(item);
        if (index > -1) {
          currentValue.splice(index, 1);
        }
      });
      this.$emit('input', currentValue);
      this.$emit('change', currentValue, 'left', this.rightChecked);
    },
    addToRight: function addToRight() {
      var _this3 = this;

      var currentValue = this.value.slice();
      var itemsToBeMoved = [];
      var key = this.props.key;
      this.data.forEach(function (item) {
        var itemKey = item[key];
        if (_this3.leftChecked.indexOf(itemKey) > -1 && _this3.value.indexOf(itemKey) === -1) {
          itemsToBeMoved.push(itemKey);
        }
      });
      currentValue = this.targetOrder === 'unshift' ? itemsToBeMoved.concat(currentValue) : currentValue.concat(itemsToBeMoved);
      this.$emit('input', currentValue);
      this.$emit('change', currentValue, 'right', this.leftChecked);
    },
    clearQuery: function clearQuery(which) {
      if (which === 'left') {
        this.$refs.leftPanel.query = '';
      } else if (which === 'right') {
        this.$refs.rightPanel.query = '';
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_transfer_src_mainvue_type_script_lang_js_ = (transfer_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/transfer/src/main.vue





/* normalize component */

var transfer_src_main_component = normalizeComponent(
  packages_transfer_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_5c654dd8_render,
  mainvue_type_template_id_5c654dd8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var transfer_src_main_api; }
transfer_src_main_component.options.__file = "packages/transfer/src/main.vue"
/* harmony default export */ var transfer_src_main = (transfer_src_main_component.exports);
// CONCATENATED MODULE: ./packages/transfer/index.js


/* istanbul ignore next */
transfer_src_main.install = function (Vue) {
  Vue.component(transfer_src_main.name, transfer_src_main);
};

/* harmony default export */ var transfer = (transfer_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=template&id=5bf181d4&
var mainvue_type_template_id_5bf181d4_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "el-container", class: { "is-vertical": _vm.isVertical } },
    [_vm._t("default")],
    2
  )
}
var mainvue_type_template_id_5bf181d4_staticRenderFns = []
mainvue_type_template_id_5bf181d4_render._withStripped = true


// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=template&id=5bf181d4&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var container_src_mainvue_type_script_lang_js_ = ({
  name: 'ElContainer',

  componentName: 'ElContainer',

  props: {
    direction: String
  },

  computed: {
    isVertical: function isVertical() {
      if (this.direction === 'vertical') {
        return true;
      } else if (this.direction === 'horizontal') {
        return false;
      }
      return this.$slots && this.$slots.default ? this.$slots.default.some(function (vnode) {
        var tag = vnode.componentOptions && vnode.componentOptions.tag;
        return tag === 'el-header' || tag === 'el-footer';
      }) : false;
    }
  }
});
// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_container_src_mainvue_type_script_lang_js_ = (container_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/container/src/main.vue





/* normalize component */

var container_src_main_component = normalizeComponent(
  packages_container_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_5bf181d4_render,
  mainvue_type_template_id_5bf181d4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var container_src_main_api; }
container_src_main_component.options.__file = "packages/container/src/main.vue"
/* harmony default export */ var container_src_main = (container_src_main_component.exports);
// CONCATENATED MODULE: ./packages/container/index.js


/* istanbul ignore next */
container_src_main.install = function (Vue) {
  Vue.component(container_src_main.name, container_src_main);
};

/* harmony default export */ var packages_container = (container_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=template&id=2b296ab2&
var mainvue_type_template_id_2b296ab2_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "el-header", style: { height: _vm.height } },
    [_vm._t("default")],
    2
  )
}
var mainvue_type_template_id_2b296ab2_staticRenderFns = []
mainvue_type_template_id_2b296ab2_render._withStripped = true


// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=template&id=2b296ab2&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var header_src_mainvue_type_script_lang_js_ = ({
  name: 'ElHeader',

  componentName: 'ElHeader',

  props: {
    height: {
      type: String,
      default: '60px'
    }
  }
});
// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_header_src_mainvue_type_script_lang_js_ = (header_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/header/src/main.vue





/* normalize component */

var header_src_main_component = normalizeComponent(
  packages_header_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_2b296ab2_render,
  mainvue_type_template_id_2b296ab2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var header_src_main_api; }
header_src_main_component.options.__file = "packages/header/src/main.vue"
/* harmony default export */ var header_src_main = (header_src_main_component.exports);
// CONCATENATED MODULE: ./packages/header/index.js


/* istanbul ignore next */
header_src_main.install = function (Vue) {
  Vue.component(header_src_main.name, header_src_main);
};

/* harmony default export */ var header = (header_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=template&id=03411dbf&
var mainvue_type_template_id_03411dbf_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { staticClass: "el-aside", style: { width: _vm.width } },
    [_vm._t("default")],
    2
  )
}
var mainvue_type_template_id_03411dbf_staticRenderFns = []
mainvue_type_template_id_03411dbf_render._withStripped = true


// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=template&id=03411dbf&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var aside_src_mainvue_type_script_lang_js_ = ({
  name: 'ElAside',

  componentName: 'ElAside',

  props: {
    width: {
      type: String,
      default: '300px'
    }
  }
});
// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_aside_src_mainvue_type_script_lang_js_ = (aside_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/aside/src/main.vue





/* normalize component */

var aside_src_main_component = normalizeComponent(
  packages_aside_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_03411dbf_render,
  mainvue_type_template_id_03411dbf_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var aside_src_main_api; }
aside_src_main_component.options.__file = "packages/aside/src/main.vue"
/* harmony default export */ var aside_src_main = (aside_src_main_component.exports);
// CONCATENATED MODULE: ./packages/aside/index.js


/* istanbul ignore next */
aside_src_main.install = function (Vue) {
  Vue.component(aside_src_main.name, aside_src_main);
};

/* harmony default export */ var aside = (aside_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=template&id=2a3a7406&
var mainvue_type_template_id_2a3a7406_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "el-main" }, [_vm._t("default")], 2)
}
var mainvue_type_template_id_2a3a7406_staticRenderFns = []
mainvue_type_template_id_2a3a7406_render._withStripped = true


// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=template&id=2a3a7406&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var main_src_mainvue_type_script_lang_js_ = ({
  name: 'ElMain',
  componentName: 'ElMain'
});
// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_main_src_mainvue_type_script_lang_js_ = (main_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/main/src/main.vue





/* normalize component */

var main_src_main_component = normalizeComponent(
  packages_main_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_2a3a7406_render,
  mainvue_type_template_id_2a3a7406_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var main_src_main_api; }
main_src_main_component.options.__file = "packages/main/src/main.vue"
/* harmony default export */ var main_src_main = (main_src_main_component.exports);
// CONCATENATED MODULE: ./packages/main/index.js


/* istanbul ignore next */
main_src_main.install = function (Vue) {
  Vue.component(main_src_main.name, main_src_main);
};

/* harmony default export */ var packages_main = (main_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=template&id=80210338&
var mainvue_type_template_id_80210338_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "el-footer", style: { height: _vm.height } },
    [_vm._t("default")],
    2
  )
}
var mainvue_type_template_id_80210338_staticRenderFns = []
mainvue_type_template_id_80210338_render._withStripped = true


// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=template&id=80210338&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var footer_src_mainvue_type_script_lang_js_ = ({
  name: 'ElFooter',

  componentName: 'ElFooter',

  props: {
    height: {
      type: String,
      default: '60px'
    }
  }
});
// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_footer_src_mainvue_type_script_lang_js_ = (footer_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/footer/src/main.vue





/* normalize component */

var footer_src_main_component = normalizeComponent(
  packages_footer_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_80210338_render,
  mainvue_type_template_id_80210338_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var footer_src_main_api; }
footer_src_main_component.options.__file = "packages/footer/src/main.vue"
/* harmony default export */ var footer_src_main = (footer_src_main_component.exports);
// CONCATENATED MODULE: ./packages/footer/index.js


/* istanbul ignore next */
footer_src_main.install = function (Vue) {
  Vue.component(footer_src_main.name, footer_src_main);
};

/* harmony default export */ var footer = (footer_src_main);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/main.vue?vue&type=script&lang=js&

/* harmony default export */ var timeline_src_mainvue_type_script_lang_js_ = ({
  name: 'ElTimeline',

  props: {
    reverse: {
      type: Boolean,
      default: false
    }
  },

  provide: function provide() {
    return {
      timeline: this
    };
  },
  render: function render() {
    var h = arguments[0];

    var reverse = this.reverse;
    var classes = {
      'el-timeline': true,
      'is-reverse': reverse
    };
    var slots = this.$slots.default || [];
    if (reverse) {
      slots = slots.reverse();
    }
    return h(
      'ul',
      { 'class': classes },
      [slots]
    );
  }
});
// CONCATENATED MODULE: ./packages/timeline/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_timeline_src_mainvue_type_script_lang_js_ = (timeline_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/timeline/src/main.vue
var main_render, main_staticRenderFns




/* normalize component */

var timeline_src_main_component = normalizeComponent(
  packages_timeline_src_mainvue_type_script_lang_js_,
  main_render,
  main_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var timeline_src_main_api; }
timeline_src_main_component.options.__file = "packages/timeline/src/main.vue"
/* harmony default export */ var timeline_src_main = (timeline_src_main_component.exports);
// CONCATENATED MODULE: ./packages/timeline/index.js


/* istanbul ignore next */
timeline_src_main.install = function (Vue) {
  Vue.component(timeline_src_main.name, timeline_src_main);
};

/* harmony default export */ var timeline = (timeline_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&
var itemvue_type_template_id_61a69e50_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "el-timeline-item" }, [
    _c("div", { staticClass: "el-timeline-item__tail" }),
    !_vm.$slots.dot
      ? _c(
          "div",
          {
            staticClass: "el-timeline-item__node",
            class: [
              "el-timeline-item__node--" + (_vm.size || ""),
              "el-timeline-item__node--" + (_vm.type || "")
            ],
            style: {
              backgroundColor: _vm.color
            }
          },
          [
            _vm.icon
              ? _c("i", {
                  staticClass: "el-timeline-item__icon",
                  class: _vm.icon
                })
              : _vm._e()
          ]
        )
      : _vm._e(),
    _vm.$slots.dot
      ? _c("div", { staticClass: "el-timeline-item__dot" }, [_vm._t("dot")], 2)
      : _vm._e(),
    _c("div", { staticClass: "el-timeline-item__wrapper" }, [
      !_vm.hideTimestamp && _vm.placement === "top"
        ? _c("div", { staticClass: "el-timeline-item__timestamp is-top" }, [
            _vm._v("\n      " + _vm._s(_vm.timestamp) + "\n    ")
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "el-timeline-item__content" },
        [_vm._t("default")],
        2
      ),
      !_vm.hideTimestamp && _vm.placement === "bottom"
        ? _c("div", { staticClass: "el-timeline-item__timestamp is-bottom" }, [
            _vm._v("\n      " + _vm._s(_vm.timestamp) + "\n    ")
          ])
        : _vm._e()
    ])
  ])
}
var itemvue_type_template_id_61a69e50_staticRenderFns = []
itemvue_type_template_id_61a69e50_render._withStripped = true


// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var timeline_src_itemvue_type_script_lang_js_ = ({
  name: 'ElTimelineItem',

  inject: ['timeline'],

  props: {
    timestamp: String,

    hideTimestamp: {
      type: Boolean,
      default: false
    },

    placement: {
      type: String,
      default: 'bottom'
    },

    type: String,

    color: String,

    size: {
      type: String,
      default: 'normal'
    },

    icon: String
  }
});
// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_timeline_src_itemvue_type_script_lang_js_ = (timeline_src_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/timeline/src/item.vue





/* normalize component */

var src_item_component = normalizeComponent(
  packages_timeline_src_itemvue_type_script_lang_js_,
  itemvue_type_template_id_61a69e50_render,
  itemvue_type_template_id_61a69e50_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var src_item_api; }
src_item_component.options.__file = "packages/timeline/src/item.vue"
/* harmony default export */ var timeline_src_item = (src_item_component.exports);
// CONCATENATED MODULE: ./packages/timeline-item/index.js


/* istanbul ignore next */
timeline_src_item.install = function (Vue) {
  Vue.component(timeline_src_item.name, timeline_src_item);
};

/* harmony default export */ var timeline_item = (timeline_src_item);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=template&id=01cf3b65&
var mainvue_type_template_id_01cf3b65_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._b(
      {
        class: [
          "el-link",
          _vm.type ? "el-link--" + _vm.type : "",
          _vm.disabled && "is-disabled",
          _vm.underline && !_vm.disabled && "is-underline"
        ],
        attrs: { href: _vm.disabled ? null : _vm.href },
        on: { click: _vm.handleClick }
      },
      "a",
      _vm.$attrs,
      false
    ),
    [
      _vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(),
      _vm.$slots.default
        ? _c("span", { staticClass: "el-link--inner" }, [_vm._t("default")], 2)
        : _vm._e(),
      _vm.$slots.icon ? [_vm.$slots.icon ? _vm._t("icon") : _vm._e()] : _vm._e()
    ],
    2
  )
}
var mainvue_type_template_id_01cf3b65_staticRenderFns = []
mainvue_type_template_id_01cf3b65_render._withStripped = true


// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=template&id=01cf3b65&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var link_src_mainvue_type_script_lang_js_ = ({
  name: 'ElLink',

  props: {
    type: {
      type: String,
      default: 'default'
    },
    underline: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    href: String,
    icon: String
  },

  methods: {
    handleClick: function handleClick(event) {
      if (!this.disabled) {
        if (!this.href) {
          this.$emit('click', event);
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_link_src_mainvue_type_script_lang_js_ = (link_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/link/src/main.vue





/* normalize component */

var link_src_main_component = normalizeComponent(
  packages_link_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_01cf3b65_render,
  mainvue_type_template_id_01cf3b65_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var link_src_main_api; }
link_src_main_component.options.__file = "packages/link/src/main.vue"
/* harmony default export */ var link_src_main = (link_src_main_component.exports);
// CONCATENATED MODULE: ./packages/link/index.js


/* istanbul ignore next */
link_src_main.install = function (Vue) {
  Vue.component(link_src_main.name, link_src_main);
};

/* harmony default export */ var packages_link = (link_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&
var mainvue_type_template_id_7fa02a7e_functional_true_render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "div",
    _vm._g(
      _vm._b(
        {
          class: [
            _vm.data.staticClass,
            "el-divider",
            "el-divider--" + _vm.props.direction
          ]
        },
        "div",
        _vm.data.attrs,
        false
      ),
      _vm.listeners
    ),
    [
      _vm.slots().default && _vm.props.direction !== "vertical"
        ? _c(
            "div",
            { class: ["el-divider__text", "is-" + _vm.props.contentPosition] },
            [_vm._t("default")],
            2
          )
        : _vm._e()
    ]
  )
}
var mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns = []
mainvue_type_template_id_7fa02a7e_functional_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var divider_src_mainvue_type_script_lang_js_ = ({
  name: 'ElDivider',
  props: {
    direction: {
      type: String,
      default: 'horizontal',
      validator: function validator(val) {
        return ['horizontal', 'vertical'].indexOf(val) !== -1;
      }
    },
    contentPosition: {
      type: String,
      default: 'center',
      validator: function validator(val) {
        return ['left', 'center', 'right'].indexOf(val) !== -1;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_divider_src_mainvue_type_script_lang_js_ = (divider_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/divider/src/main.vue





/* normalize component */

var divider_src_main_component = normalizeComponent(
  packages_divider_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_7fa02a7e_functional_true_render,
  mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var divider_src_main_api; }
divider_src_main_component.options.__file = "packages/divider/src/main.vue"
/* harmony default export */ var divider_src_main = (divider_src_main_component.exports);
// CONCATENATED MODULE: ./packages/divider/index.js


/* istanbul ignore next */
divider_src_main.install = function (Vue) {
  Vue.component(divider_src_main.name, divider_src_main);
};

/* harmony default export */ var divider = (divider_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=template&id=44d84a7c&
var mainvue_type_template_id_44d84a7c_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-image" },
    [
      _vm.loading
        ? _vm._t("placeholder", [
            _c("div", { staticClass: "el-image__placeholder" })
          ])
        : _vm.error
        ? _vm._t("error", [
            _c("div", { staticClass: "el-image__error" }, [
              _vm._v(_vm._s(_vm.t("el.image.error")))
            ])
          ])
        : _c(
            "img",
            _vm._g(
              _vm._b(
                {
                  staticClass: "el-image__inner",
                  class: {
                    "el-image__inner--center": _vm.alignCenter,
                    "el-image__preview": _vm.preview
                  },
                  style: _vm.imageStyle,
                  attrs: { src: _vm.src },
                  on: { click: _vm.clickHandler }
                },
                "img",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          ),
      _vm.preview
        ? [
            _vm.showViewer
              ? _c("image-viewer", {
                  attrs: {
                    "z-index": _vm.zIndex,
                    "initial-index": _vm.imageIndex,
                    "on-close": _vm.closeViewer,
                    "url-list": _vm.previewSrcList
                  }
                })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var mainvue_type_template_id_44d84a7c_staticRenderFns = []
mainvue_type_template_id_44d84a7c_render._withStripped = true


// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=template&id=44d84a7c&

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&
var image_viewervue_type_template_id_5e73b307_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "viewer-fade" } }, [
    _c(
      "div",
      {
        ref: "el-image-viewer__wrapper",
        staticClass: "el-image-viewer__wrapper",
        style: { "z-index": _vm.zIndex },
        attrs: { tabindex: "-1" }
      },
      [
        _c("div", { staticClass: "el-image-viewer__mask" }),
        _c(
          "span",
          {
            staticClass: "el-image-viewer__btn el-image-viewer__close",
            on: { click: _vm.hide }
          },
          [_c("i", { staticClass: "el-icon-circle-close" })]
        ),
        !_vm.isSingle
          ? [
              _c(
                "span",
                {
                  staticClass: "el-image-viewer__btn el-image-viewer__prev",
                  class: { "is-disabled": !_vm.infinite && _vm.isFirst },
                  on: { click: _vm.prev }
                },
                [_c("i", { staticClass: "el-icon-arrow-left" })]
              ),
              _c(
                "span",
                {
                  staticClass: "el-image-viewer__btn el-image-viewer__next",
                  class: { "is-disabled": !_vm.infinite && _vm.isLast },
                  on: { click: _vm.next }
                },
                [_c("i", { staticClass: "el-icon-arrow-right" })]
              )
            ]
          : _vm._e(),
        _c(
          "div",
          { staticClass: "el-image-viewer__btn el-image-viewer__actions" },
          [
            _c("div", { staticClass: "el-image-viewer__actions__inner" }, [
              _c("i", {
                staticClass: "el-icon-zoom-out",
                on: {
                  click: function($event) {
                    _vm.handleActions("zoomOut")
                  }
                }
              }),
              _c("i", {
                staticClass: "el-icon-zoom-in",
                on: {
                  click: function($event) {
                    _vm.handleActions("zoomIn")
                  }
                }
              }),
              _c("i", { staticClass: "el-image-viewer__actions__divider" }),
              _c("i", { class: _vm.mode.icon, on: { click: _vm.toggleMode } }),
              _c("i", { staticClass: "el-image-viewer__actions__divider" }),
              _c("i", {
                staticClass: "el-icon-refresh-left",
                on: {
                  click: function($event) {
                    _vm.handleActions("anticlocelise")
                  }
                }
              }),
              _c("i", {
                staticClass: "el-icon-refresh-right",
                on: {
                  click: function($event) {
                    _vm.handleActions("clocelise")
                  }
                }
              })
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "el-image-viewer__canvas" },
          _vm._l(_vm.urlList, function(url, i) {
            return i === _vm.index
              ? _c("img", {
                  key: url,
                  ref: "img",
                  refInFor: true,
                  staticClass: "el-image-viewer__img",
                  style: _vm.imgStyle,
                  attrs: { src: _vm.currentImg },
                  on: {
                    load: _vm.handleImgLoad,
                    error: _vm.handleImgError,
                    mousedown: _vm.handleMouseDown
                  }
                })
              : _vm._e()
          }),
          0
        )
      ],
      2
    )
  ])
}
var image_viewervue_type_template_id_5e73b307_staticRenderFns = []
image_viewervue_type_template_id_5e73b307_render._withStripped = true


// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
var image_viewervue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var Mode = {
  CONTAIN: {
    name: 'contain',
    icon: 'el-icon-full-screen'
  },
  ORIGINAL: {
    name: 'original',
    icon: 'el-icon-c-scale-to-original'
  }
};

var mousewheelEventName = Object(util_["isFirefox"])() ? 'DOMMouseScroll' : 'mousewheel';

/* harmony default export */ var image_viewervue_type_script_lang_js_ = ({
  name: 'elImageViewer',

  props: {
    urlList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    zIndex: {
      type: Number,
      default: 2000
    },
    onSwitch: {
      type: Function,
      default: function _default() {}
    },
    onClose: {
      type: Function,
      default: function _default() {}
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      index: this.initialIndex,
      isShow: false,
      infinite: true,
      loading: false,
      mode: Mode.CONTAIN,
      transform: {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      }
    };
  },

  computed: {
    isSingle: function isSingle() {
      return this.urlList.length <= 1;
    },
    isFirst: function isFirst() {
      return this.index === 0;
    },
    isLast: function isLast() {
      return this.index === this.urlList.length - 1;
    },
    currentImg: function currentImg() {
      return this.urlList[this.index];
    },
    imgStyle: function imgStyle() {
      var _transform = this.transform,
          scale = _transform.scale,
          deg = _transform.deg,
          offsetX = _transform.offsetX,
          offsetY = _transform.offsetY,
          enableTransition = _transform.enableTransition;

      var style = {
        transform: 'scale(' + scale + ') rotate(' + deg + 'deg)',
        transition: enableTransition ? 'transform .3s' : '',
        'margin-left': offsetX + 'px',
        'margin-top': offsetY + 'px'
      };
      if (this.mode === Mode.CONTAIN) {
        style.maxWidth = style.maxHeight = '100%';
      }
      return style;
    }
  },
  watch: {
    index: {
      handler: function handler(val) {
        this.reset();
        this.onSwitch(val);
      }
    },
    currentImg: function currentImg(val) {
      var _this = this;

      this.$nextTick(function (_) {
        var $img = _this.$refs.img[0];
        if (!$img.complete) {
          _this.loading = true;
        }
      });
    }
  },
  methods: {
    hide: function hide() {
      this.deviceSupportUninstall();
      this.onClose();
    },
    deviceSupportInstall: function deviceSupportInstall() {
      var _this2 = this;

      this._keyDownHandler = Object(util_["rafThrottle"])(function (e) {
        var keyCode = e.keyCode;
        switch (keyCode) {
          // ESC
          case 27:
            _this2.hide();
            break;
          // SPACE
          case 32:
            _this2.toggleMode();
            break;
          // LEFT_ARROW
          case 37:
            _this2.prev();
            break;
          // UP_ARROW
          case 38:
            _this2.handleActions('zoomIn');
            break;
          // RIGHT_ARROW
          case 39:
            _this2.next();
            break;
          // DOWN_ARROW
          case 40:
            _this2.handleActions('zoomOut');
            break;
        }
      });
      this._mouseWheelHandler = Object(util_["rafThrottle"])(function (e) {
        var delta = e.wheelDelta ? e.wheelDelta : -e.detail;
        if (delta > 0) {
          _this2.handleActions('zoomIn', {
            zoomRate: 0.015,
            enableTransition: false
          });
        } else {
          _this2.handleActions('zoomOut', {
            zoomRate: 0.015,
            enableTransition: false
          });
        }
      });
      Object(dom_["on"])(document, 'keydown', this._keyDownHandler);
      Object(dom_["on"])(document, mousewheelEventName, this._mouseWheelHandler);
    },
    deviceSupportUninstall: function deviceSupportUninstall() {
      Object(dom_["off"])(document, 'keydown', this._keyDownHandler);
      Object(dom_["off"])(document, mousewheelEventName, this._mouseWheelHandler);
      this._keyDownHandler = null;
      this._mouseWheelHandler = null;
    },
    handleImgLoad: function handleImgLoad(e) {
      this.loading = false;
    },
    handleImgError: function handleImgError(e) {
      this.loading = false;
      e.target.alt = '加载失败';
    },
    handleMouseDown: function handleMouseDown(e) {
      var _this3 = this;

      if (this.loading || e.button !== 0) return;

      var _transform2 = this.transform,
          offsetX = _transform2.offsetX,
          offsetY = _transform2.offsetY;

      var startX = e.pageX;
      var startY = e.pageY;
      this._dragHandler = Object(util_["rafThrottle"])(function (ev) {
        _this3.transform.offsetX = offsetX + ev.pageX - startX;
        _this3.transform.offsetY = offsetY + ev.pageY - startY;
      });
      Object(dom_["on"])(document, 'mousemove', this._dragHandler);
      Object(dom_["on"])(document, 'mouseup', function (ev) {
        Object(dom_["off"])(document, 'mousemove', _this3._dragHandler);
      });

      e.preventDefault();
    },
    reset: function reset() {
      this.transform = {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      };
    },
    toggleMode: function toggleMode() {
      if (this.loading) return;

      var modeNames = Object.keys(Mode);
      var modeValues = Object.values(Mode);
      var index = modeValues.indexOf(this.mode);
      var nextIndex = (index + 1) % modeNames.length;
      this.mode = Mode[modeNames[nextIndex]];
      this.reset();
    },
    prev: function prev() {
      if (this.isFirst && !this.infinite) return;
      var len = this.urlList.length;
      this.index = (this.index - 1 + len) % len;
    },
    next: function next() {
      if (this.isLast && !this.infinite) return;
      var len = this.urlList.length;
      this.index = (this.index + 1) % len;
    },
    handleActions: function handleActions(action) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.loading) return;

      var _zoomRate$rotateDeg$e = image_viewervue_type_script_lang_js_extends({
        zoomRate: 0.2,
        rotateDeg: 90,
        enableTransition: true
      }, options),
          zoomRate = _zoomRate$rotateDeg$e.zoomRate,
          rotateDeg = _zoomRate$rotateDeg$e.rotateDeg,
          enableTransition = _zoomRate$rotateDeg$e.enableTransition;

      var transform = this.transform;

      switch (action) {
        case 'zoomOut':
          if (transform.scale > 0.2) {
            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
          }
          break;
        case 'zoomIn':
          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
          break;
        case 'clocelise':
          transform.deg += rotateDeg;
          break;
        case 'anticlocelise':
          transform.deg -= rotateDeg;
          break;
      }
      transform.enableTransition = enableTransition;
    }
  },
  mounted: function mounted() {
    this.deviceSupportInstall();
    // add tabindex then wrapper can be focusable via Javascript
    // focus wrapper so arrow key can't cause inner scroll behavior underneath
    this.$refs['el-image-viewer__wrapper'].focus();
  }
});
// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_image_viewervue_type_script_lang_js_ = (image_viewervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue





/* normalize component */

var image_viewer_component = normalizeComponent(
  src_image_viewervue_type_script_lang_js_,
  image_viewervue_type_template_id_5e73b307_render,
  image_viewervue_type_template_id_5e73b307_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var image_viewer_api; }
image_viewer_component.options.__file = "packages/image/src/image-viewer.vue"
/* harmony default export */ var image_viewer = (image_viewer_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var isSupportObjectFit = function isSupportObjectFit() {
  return document.documentElement.style.objectFit !== undefined;
};

var ObjectFit = {
  NONE: 'none',
  CONTAIN: 'contain',
  COVER: 'cover',
  FILL: 'fill',
  SCALE_DOWN: 'scale-down'
};

var prevOverflow = '';

/* harmony default export */ var image_src_mainvue_type_script_lang_js_ = ({
  name: 'ElImage',

  mixins: [locale_default.a],
  inheritAttrs: false,

  components: {
    ImageViewer: image_viewer
  },

  props: {
    src: String,
    fit: String,
    lazy: Boolean,
    scrollContainer: {},
    previewSrcList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    zIndex: {
      type: Number,
      default: 2000
    }
  },

  data: function data() {
    return {
      loading: true,
      error: false,
      show: !this.lazy,
      imageWidth: 0,
      imageHeight: 0,
      showViewer: false
    };
  },


  computed: {
    imageStyle: function imageStyle() {
      var fit = this.fit;

      if (!this.$isServer && fit) {
        return isSupportObjectFit() ? { 'object-fit': fit } : this.getImageStyle(fit);
      }
      return {};
    },
    alignCenter: function alignCenter() {
      return !this.$isServer && !isSupportObjectFit() && this.fit !== ObjectFit.FILL;
    },
    preview: function preview() {
      var previewSrcList = this.previewSrcList;

      return Array.isArray(previewSrcList) && previewSrcList.length > 0;
    },
    imageIndex: function imageIndex() {
      var previewIndex = 0;
      var srcIndex = this.previewSrcList.indexOf(this.src);
      if (srcIndex >= 0) {
        previewIndex = srcIndex;
      }
      return previewIndex;
    }
  },

  watch: {
    src: function src(val) {
      this.show && this.loadImage();
    },
    show: function show(val) {
      val && this.loadImage();
    }
  },

  mounted: function mounted() {
    if (this.lazy) {
      this.addLazyLoadListener();
    } else {
      this.loadImage();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.lazy && this.removeLazyLoadListener();
  },


  methods: {
    loadImage: function loadImage() {
      var _this = this;

      if (this.$isServer) return;

      // reset status
      this.loading = true;
      this.error = false;

      var img = new Image();
      img.onload = function (e) {
        return _this.handleLoad(e, img);
      };
      img.onerror = this.handleError.bind(this);

      // bind html attrs
      // so it can behave consistently
      Object.keys(this.$attrs).forEach(function (key) {
        var value = _this.$attrs[key];
        img.setAttribute(key, value);
      });
      img.src = this.src;
    },
    handleLoad: function handleLoad(e, img) {
      this.imageWidth = img.width;
      this.imageHeight = img.height;
      this.loading = false;
    },
    handleError: function handleError(e) {
      this.loading = false;
      this.error = true;
      this.$emit('error', e);
    },
    handleLazyLoad: function handleLazyLoad() {
      if (Object(dom_["isInContainer"])(this.$el, this._scrollContainer)) {
        this.show = true;
        this.removeLazyLoadListener();
      }
    },
    addLazyLoadListener: function addLazyLoadListener() {
      if (this.$isServer) return;

      var scrollContainer = this.scrollContainer;

      var _scrollContainer = null;

      if (Object(types_["isHtmlElement"])(scrollContainer)) {
        _scrollContainer = scrollContainer;
      } else if (Object(types_["isString"])(scrollContainer)) {
        _scrollContainer = document.querySelector(scrollContainer);
      } else {
        _scrollContainer = Object(dom_["getScrollContainer"])(this.$el);
      }

      if (_scrollContainer) {
        this._scrollContainer = _scrollContainer;
        this._lazyLoadHandler = throttle_default()(200, this.handleLazyLoad);
        Object(dom_["on"])(_scrollContainer, 'scroll', this._lazyLoadHandler);
        this.handleLazyLoad();
      }
    },
    removeLazyLoadListener: function removeLazyLoadListener() {
      var _scrollContainer = this._scrollContainer,
          _lazyLoadHandler = this._lazyLoadHandler;


      if (this.$isServer || !_scrollContainer || !_lazyLoadHandler) return;

      Object(dom_["off"])(_scrollContainer, 'scroll', _lazyLoadHandler);
      this._scrollContainer = null;
      this._lazyLoadHandler = null;
    },

    /**
     * simulate object-fit behavior to compatible with IE11 and other browsers which not support object-fit
     */
    getImageStyle: function getImageStyle(fit) {
      var imageWidth = this.imageWidth,
          imageHeight = this.imageHeight;
      var _$el = this.$el,
          containerWidth = _$el.clientWidth,
          containerHeight = _$el.clientHeight;


      if (!imageWidth || !imageHeight || !containerWidth || !containerHeight) return {};

      var vertical = imageWidth / imageHeight < 1;

      if (fit === ObjectFit.SCALE_DOWN) {
        var isSmaller = imageWidth < containerWidth && imageHeight < containerHeight;
        fit = isSmaller ? ObjectFit.NONE : ObjectFit.CONTAIN;
      }

      switch (fit) {
        case ObjectFit.NONE:
          return { width: 'auto', height: 'auto' };
        case ObjectFit.CONTAIN:
          return vertical ? { width: 'auto' } : { height: 'auto' };
        case ObjectFit.COVER:
          return vertical ? { height: 'auto' } : { width: 'auto' };
        default:
          return {};
      }
    },
    clickHandler: function clickHandler() {
      // don't show viewer when preview is false
      if (!this.preview) {
        return;
      }
      // prevent body scroll
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.showViewer = true;
    },
    closeViewer: function closeViewer() {
      document.body.style.overflow = prevOverflow;
      this.showViewer = false;
    }
  }
});
// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_image_src_mainvue_type_script_lang_js_ = (image_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/image/src/main.vue





/* normalize component */

var image_src_main_component = normalizeComponent(
  packages_image_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_44d84a7c_render,
  mainvue_type_template_id_44d84a7c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var image_src_main_api; }
image_src_main_component.options.__file = "packages/image/src/main.vue"
/* harmony default export */ var image_src_main = (image_src_main_component.exports);
// CONCATENATED MODULE: ./packages/image/index.js


/* istanbul ignore next */
image_src_main.install = function (Vue) {
  Vue.component(image_src_main.name, image_src_main);
};

/* harmony default export */ var packages_image = (image_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&
var mainvue_type_template_id_6d9756be_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-calendar" }, [
    _c("div", { staticClass: "el-calendar__header" }, [
      _c("div", { staticClass: "el-calendar__title" }, [
        _vm._v("\n      " + _vm._s(_vm.i18nDate) + "\n    ")
      ]),
      _vm.validatedRange.length === 0
        ? _c(
            "div",
            { staticClass: "el-calendar__button-group" },
            [
              _c(
                "el-button-group",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "plain", size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.selectDate("prev-month")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.t("el.datepicker.prevMonth")) +
                          "\n        "
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "plain", size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.selectDate("today")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.t("el.datepicker.today")) +
                          "\n        "
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "plain", size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.selectDate("next-month")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.t("el.datepicker.nextMonth")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _vm.validatedRange.length === 0
      ? _c(
          "div",
          { key: "no-range", staticClass: "el-calendar__body" },
          [
            _c("date-table", {
              attrs: {
                date: _vm.date,
                "selected-day": _vm.realSelectedDay,
                "first-day-of-week": _vm.realFirstDayOfWeek
              },
              on: { pick: _vm.pickDay }
            })
          ],
          1
        )
      : _c(
          "div",
          { key: "has-range", staticClass: "el-calendar__body" },
          _vm._l(_vm.validatedRange, function(range, index) {
            return _c("date-table", {
              key: index,
              attrs: {
                date: range[0],
                "selected-day": _vm.realSelectedDay,
                range: range,
                "hide-header": index !== 0,
                "first-day-of-week": _vm.realFirstDayOfWeek
              },
              on: { pick: _vm.pickDay }
            })
          }),
          1
        )
  ])
}
var mainvue_type_template_id_6d9756be_staticRenderFns = []
mainvue_type_template_id_6d9756be_render._withStripped = true


// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&

// EXTERNAL MODULE: external "element-ui/lib/utils/date"
var date_ = __webpack_require__(20);
var date_default = /*#__PURE__*/__webpack_require__.n(date_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/date-table.vue?vue&type=script&lang=js&




/* harmony default export */ var src_date_tablevue_type_script_lang_js_ = ({
  props: {
    selectedDay: String, // formated date yyyy-MM-dd
    range: {
      type: Array,
      validator: function validator(val) {
        if (!(val && val.length)) return true;
        var start = val[0],
            end = val[1];

        return Object(date_util_["validateRangeInOneMonth"])(start, end);
      }
    },
    date: Date,
    hideHeader: Boolean,
    firstDayOfWeek: Number
  },

  inject: ['elCalendar'],

  data: function data() {
    return {
      WEEK_DAYS: Object(date_util_["getI18nSettings"])().dayNames
    };
  },


  methods: {
    toNestedArr: function toNestedArr(days) {
      return Object(date_util_["range"])(days.length / 7).map(function (_, index) {
        var start = index * 7;
        return days.slice(start, start + 7);
      });
    },
    getFormateDate: function getFormateDate(day, type) {
      if (!day || ['prev', 'current', 'next'].indexOf(type) === -1) {
        throw new Error('invalid day or type');
      }
      var prefix = this.curMonthDatePrefix;
      if (type === 'prev') {
        prefix = this.prevMonthDatePrefix;
      } else if (type === 'next') {
        prefix = this.nextMonthDatePrefix;
      }
      day = ('00' + day).slice(-2);
      return prefix + '-' + day;
    },
    getCellClass: function getCellClass(_ref) {
      var text = _ref.text,
          type = _ref.type;

      var classes = [type];
      if (type === 'current') {
        var date = this.getFormateDate(text, type);
        if (date === this.selectedDay) {
          classes.push('is-selected');
        }
        if (date === this.formatedToday) {
          classes.push('is-today');
        }
      }
      return classes;
    },
    pickDay: function pickDay(_ref2) {
      var text = _ref2.text,
          type = _ref2.type;

      var date = this.getFormateDate(text, type);
      this.$emit('pick', date);
    },
    cellRenderProxy: function cellRenderProxy(_ref3) {
      var text = _ref3.text,
          type = _ref3.type;
      var h = this.$createElement;

      var render = this.elCalendar.$scopedSlots.dateCell;
      if (!render) return h('span', [text]);

      var day = this.getFormateDate(text, type);
      var date = new Date(day);
      var data = {
        isSelected: this.selectedDay === day,
        type: type + '-month',
        day: day
      };
      return render({ date: date, data: data });
    }
  },

  computed: {
    prevMonthDatePrefix: function prevMonthDatePrefix() {
      var temp = new Date(this.date.getTime());
      temp.setDate(0);
      return date_default.a.format(temp, 'yyyy-MM');
    },
    curMonthDatePrefix: function curMonthDatePrefix() {
      return date_default.a.format(this.date, 'yyyy-MM');
    },
    nextMonthDatePrefix: function nextMonthDatePrefix() {
      var temp = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
      return date_default.a.format(temp, 'yyyy-MM');
    },
    formatedToday: function formatedToday() {
      return this.elCalendar.formatedToday;
    },
    isInRange: function isInRange() {
      return this.range && this.range.length;
    },
    rows: function rows() {
      var days = [];
      // if range exists, should render days in range.
      if (this.isInRange) {
        var _range = this.range,
            start = _range[0],
            end = _range[1];

        var currentMonthRange = Object(date_util_["range"])(end.getDate() - start.getDate() + 1).map(function (_, index) {
          return {
            text: start.getDate() + index,
            type: 'current'
          };
        });
        var remaining = currentMonthRange.length % 7;
        remaining = remaining === 0 ? 0 : 7 - remaining;
        var nextMonthRange = Object(date_util_["range"])(remaining).map(function (_, index) {
          return {
            text: index + 1,
            type: 'next'
          };
        });
        days = currentMonthRange.concat(nextMonthRange);
      } else {
        var date = this.date;
        var firstDay = Object(date_util_["getFirstDayOfMonth"])(date);
        firstDay = firstDay === 0 ? 7 : firstDay;
        var firstDayOfWeek = typeof this.firstDayOfWeek === 'number' ? this.firstDayOfWeek : 1;
        var prevMonthDays = Object(date_util_["getPrevMonthLastDays"])(date, firstDay - firstDayOfWeek).map(function (day) {
          return {
            text: day,
            type: 'prev'
          };
        });
        var currentMonthDays = Object(date_util_["getMonthDays"])(date).map(function (day) {
          return {
            text: day,
            type: 'current'
          };
        });
        days = [].concat(prevMonthDays, currentMonthDays);
        var nextMonthDays = Object(date_util_["range"])(42 - days.length).map(function (_, index) {
          return {
            text: index + 1,
            type: 'next'
          };
        });
        days = days.concat(nextMonthDays);
      }
      return this.toNestedArr(days);
    },
    weekDays: function weekDays() {
      var start = this.firstDayOfWeek;
      var WEEK_DAYS = this.WEEK_DAYS;


      if (typeof start !== 'number' || start === 0) {
        return WEEK_DAYS.slice();
      } else {
        return WEEK_DAYS.slice(start).concat(WEEK_DAYS.slice(0, start));
      }
    }
  },

  render: function render() {
    var _this = this;

    var h = arguments[0];

    var thead = this.hideHeader ? null : h('thead', [this.weekDays.map(function (day) {
      return h(
        'th',
        { key: day },
        [day]
      );
    })]);
    return h(
      'table',
      {
        'class': {
          'el-calendar-table': true,
          'is-range': this.isInRange
        },
        attrs: { cellspacing: '0',
          cellpadding: '0' }
      },
      [thead, h('tbody', [this.rows.map(function (row, index) {
        return h(
          'tr',
          {
            'class': {
              'el-calendar-table__row': true,
              'el-calendar-table__row--hide-border': index === 0 && _this.hideHeader
            },
            key: index },
          [row.map(function (cell, key) {
            return h(
              'td',
              { key: key,
                'class': _this.getCellClass(cell),
                on: {
                  'click': _this.pickDay.bind(_this, cell)
                }
              },
              [h(
                'div',
                { 'class': 'el-calendar-day' },
                [_this.cellRenderProxy(cell)]
              )]
            );
          })]
        );
      })])]
    );
  }
});
// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue?vue&type=script&lang=js&
 /* harmony default export */ var calendar_src_date_tablevue_type_script_lang_js_ = (src_date_tablevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue
var date_table_render, date_table_staticRenderFns




/* normalize component */

var src_date_table_component = normalizeComponent(
  calendar_src_date_tablevue_type_script_lang_js_,
  date_table_render,
  date_table_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var src_date_table_api; }
src_date_table_component.options.__file = "packages/calendar/src/date-table.vue"
/* harmony default export */ var src_date_table = (src_date_table_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var validTypes = ['prev-month', 'today', 'next-month'];
var weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var oneDay = 86400000;

/* harmony default export */ var calendar_src_mainvue_type_script_lang_js_ = ({
  name: 'ElCalendar',

  mixins: [locale_default.a],

  components: {
    DateTable: src_date_table,
    ElButton: button_default.a,
    ElButtonGroup: button_group_default.a
  },

  props: {
    value: [Date, String, Number],
    range: {
      type: Array,
      validator: function validator(range) {
        if (Array.isArray(range)) {
          return range.length === 2 && range.every(function (item) {
            return typeof item === 'string' || typeof item === 'number' || item instanceof Date;
          });
        } else {
          return true;
        }
      }
    },
    firstDayOfWeek: {
      type: Number,
      default: 1
    }
  },

  provide: function provide() {
    return {
      elCalendar: this
    };
  },


  methods: {
    pickDay: function pickDay(day) {
      this.realSelectedDay = day;
    },
    selectDate: function selectDate(type) {
      if (validTypes.indexOf(type) === -1) {
        throw new Error('invalid type ' + type);
      }
      var day = '';
      if (type === 'prev-month') {
        day = this.prevMonthDatePrefix + '-01';
      } else if (type === 'next-month') {
        day = this.nextMonthDatePrefix + '-01';
      } else {
        day = this.formatedToday;
      }

      if (day === this.formatedDate) return;
      this.pickDay(day);
    },
    toDate: function toDate(val) {
      if (!val) {
        throw new Error('invalid val');
      }
      return val instanceof Date ? val : new Date(val);
    },
    rangeValidator: function rangeValidator(date, isStart) {
      var firstDayOfWeek = this.realFirstDayOfWeek;
      var expected = isStart ? firstDayOfWeek : firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
      var message = (isStart ? 'start' : 'end') + ' of range should be ' + weekDays[expected] + '.';
      if (date.getDay() !== expected) {
        console.warn('[ElementCalendar]', message, 'Invalid range will be ignored.');
        return false;
      }
      return true;
    }
  },

  computed: {
    prevMonthDatePrefix: function prevMonthDatePrefix() {
      var temp = new Date(this.date.getTime());
      temp.setDate(0);
      return date_default.a.format(temp, 'yyyy-MM');
    },
    curMonthDatePrefix: function curMonthDatePrefix() {
      return date_default.a.format(this.date, 'yyyy-MM');
    },
    nextMonthDatePrefix: function nextMonthDatePrefix() {
      var temp = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
      return date_default.a.format(temp, 'yyyy-MM');
    },
    formatedDate: function formatedDate() {
      return date_default.a.format(this.date, 'yyyy-MM-dd');
    },
    i18nDate: function i18nDate() {
      var year = this.date.getFullYear();
      var month = this.date.getMonth() + 1;
      return year + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + month);
    },
    formatedToday: function formatedToday() {
      return date_default.a.format(this.now, 'yyyy-MM-dd');
    },


    realSelectedDay: {
      get: function get() {
        if (!this.value) return this.selectedDay;
        return this.formatedDate;
      },
      set: function set(val) {
        this.selectedDay = val;
        var date = new Date(val);
        this.$emit('input', date);
      }
    },

    date: function date() {
      if (!this.value) {
        if (this.realSelectedDay) {
          var d = this.selectedDay.split('-');
          return new Date(d[0], d[1] - 1, d[2]);
        } else if (this.validatedRange.length) {
          return this.validatedRange[0][0];
        }
        return this.now;
      } else {
        return this.toDate(this.value);
      }
    },


    // if range is valid, we get a two-digit array
    validatedRange: function validatedRange() {
      var _this = this;

      var range = this.range;
      if (!range) return [];
      range = range.reduce(function (prev, val, index) {
        var date = _this.toDate(val);
        if (_this.rangeValidator(date, index === 0)) {
          prev = prev.concat(date);
        }
        return prev;
      }, []);
      if (range.length === 2) {
        var _range = range,
            start = _range[0],
            end = _range[1];

        if (start > end) {
          console.warn('[ElementCalendar]end time should be greater than start time');
          return [];
        }
        // start time and end time in one month
        if (Object(date_util_["validateRangeInOneMonth"])(start, end)) {
          return [[start, end]];
        }
        var data = [];
        var startDay = new Date(start.getFullYear(), start.getMonth() + 1, 1);
        var lastDay = this.toDate(startDay.getTime() - oneDay);
        if (!Object(date_util_["validateRangeInOneMonth"])(startDay, end)) {
          console.warn('[ElementCalendar]start time and end time interval must not exceed two months');
          return [];
        }
        // 第一个月的时间范围
        data.push([start, lastDay]);
        // 下一月的时间范围，需要计算一下该月的第一个周起始日
        var firstDayOfWeek = this.realFirstDayOfWeek;
        var nextMontFirstDay = startDay.getDay();
        var interval = 0;
        if (nextMontFirstDay !== firstDayOfWeek) {
          if (firstDayOfWeek === 0) {
            interval = 7 - nextMontFirstDay;
          } else {
            interval = firstDayOfWeek - nextMontFirstDay;
            interval = interval > 0 ? interval : 7 + interval;
          }
        }
        startDay = this.toDate(startDay.getTime() + interval * oneDay);
        if (startDay.getDate() < end.getDate()) {
          data.push([startDay, end]);
        }
        return data;
      }
      return [];
    },
    realFirstDayOfWeek: function realFirstDayOfWeek() {
      if (this.firstDayOfWeek < 1 || this.firstDayOfWeek > 6) {
        return 0;
      }
      return Math.floor(this.firstDayOfWeek);
    }
  },

  data: function data() {
    return {
      selectedDay: '',
      now: new Date()
    };
  }
});
// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_calendar_src_mainvue_type_script_lang_js_ = (calendar_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/calendar/src/main.vue





/* normalize component */

var calendar_src_main_component = normalizeComponent(
  packages_calendar_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_6d9756be_render,
  mainvue_type_template_id_6d9756be_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var calendar_src_main_api; }
calendar_src_main_component.options.__file = "packages/calendar/src/main.vue"
/* harmony default export */ var calendar_src_main = (calendar_src_main_component.exports);
// CONCATENATED MODULE: ./packages/calendar/index.js


/* istanbul ignore next */
calendar_src_main.install = function (Vue) {
  Vue.component(calendar_src_main.name, calendar_src_main);
};

/* harmony default export */ var calendar = (calendar_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&
var mainvue_type_template_id_257dd4a9_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "el-fade-in" } }, [
    _vm.visible
      ? _c(
          "div",
          {
            staticClass: "el-backtop",
            style: {
              right: _vm.styleRight,
              bottom: _vm.styleBottom
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.handleClick($event)
              }
            }
          },
          [
            _vm._t("default", [_c("el-icon", { attrs: { name: "caret-top" } })])
          ],
          2
        )
      : _vm._e()
  ])
}
var mainvue_type_template_id_257dd4a9_staticRenderFns = []
mainvue_type_template_id_257dd4a9_render._withStripped = true


// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var cubic = function cubic(value) {
  return Math.pow(value, 3);
};
var easeInOutCubic = function easeInOutCubic(value) {
  return value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2;
};

/* harmony default export */ var backtop_src_mainvue_type_script_lang_js_ = ({
  name: 'ElBacktop',

  props: {
    visibilityHeight: {
      type: Number,
      default: 200
    },
    target: [String],
    right: {
      type: Number,
      default: 40
    },
    bottom: {
      type: Number,
      default: 40
    }
  },

  data: function data() {
    return {
      el: null,
      container: null,
      visible: false
    };
  },


  computed: {
    styleBottom: function styleBottom() {
      return this.bottom + 'px';
    },
    styleRight: function styleRight() {
      return this.right + 'px';
    }
  },

  mounted: function mounted() {
    this.init();
    this.throttledScrollHandler = throttle_default()(300, this.onScroll);
    this.container.addEventListener('scroll', this.throttledScrollHandler);
  },


  methods: {
    init: function init() {
      this.container = document;
      this.el = document.documentElement;
      if (this.target) {
        this.el = document.querySelector(this.target);
        if (!this.el) {
          throw new Error('target is not existed: ' + this.target);
        }
        this.container = this.el;
      }
    },
    onScroll: function onScroll() {
      var scrollTop = this.el.scrollTop;
      this.visible = scrollTop >= this.visibilityHeight;
    },
    handleClick: function handleClick(e) {
      this.scrollToTop();
      this.$emit('click', e);
    },
    scrollToTop: function scrollToTop() {
      var el = this.el;
      var beginTime = Date.now();
      var beginValue = el.scrollTop;
      var rAF = window.requestAnimationFrame || function (func) {
        return setTimeout(func, 16);
      };
      var frameFunc = function frameFunc() {
        var progress = (Date.now() - beginTime) / 500;
        if (progress < 1) {
          el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
          rAF(frameFunc);
        } else {
          el.scrollTop = 0;
        }
      };
      rAF(frameFunc);
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.container.removeEventListener('scroll', this.throttledScrollHandler);
  }
});
// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_backtop_src_mainvue_type_script_lang_js_ = (backtop_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/backtop/src/main.vue





/* normalize component */

var backtop_src_main_component = normalizeComponent(
  packages_backtop_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_257dd4a9_render,
  mainvue_type_template_id_257dd4a9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var backtop_src_main_api; }
backtop_src_main_component.options.__file = "packages/backtop/src/main.vue"
/* harmony default export */ var backtop_src_main = (backtop_src_main_component.exports);
// CONCATENATED MODULE: ./packages/backtop/index.js


/* istanbul ignore next */
backtop_src_main.install = function (Vue) {
  Vue.component(backtop_src_main.name, backtop_src_main);
};

/* harmony default export */ var backtop = (backtop_src_main);
// CONCATENATED MODULE: ./packages/infinite-scroll/src/main.js




var getStyleComputedProperty = function getStyleComputedProperty(element, property) {
  if (element === window) {
    element = document.documentElement;
  }

  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
};

var entries = function entries(obj) {
  return Object.keys(obj || {}).map(function (key) {
    return [key, obj[key]];
  });
};

var getPositionSize = function getPositionSize(el, prop) {
  return el === window || el === document ? document.documentElement[prop] : el[prop];
};

var getOffsetHeight = function getOffsetHeight(el) {
  return getPositionSize(el, 'offsetHeight');
};

var getClientHeight = function getClientHeight(el) {
  return getPositionSize(el, 'clientHeight');
};

var scope = 'ElInfiniteScroll';
var attributes = {
  delay: {
    type: Number,
    default: 200
  },
  distance: {
    type: Number,
    default: 0
  },
  disabled: {
    type: Boolean,
    default: false
  },
  immediate: {
    type: Boolean,
    default: true
  }
};

var main_getScrollOptions = function getScrollOptions(el, vm) {
  if (!Object(types_["isHtmlElement"])(el)) return {};

  return entries(attributes).reduce(function (map, _ref) {
    var key = _ref[0],
        option = _ref[1];
    var type = option.type,
        defaultValue = option.default;

    var value = el.getAttribute('infinite-scroll-' + key);
    value = Object(types_["isUndefined"])(vm[value]) ? value : vm[value];
    switch (type) {
      case Number:
        value = Number(value);
        value = Number.isNaN(value) ? defaultValue : value;
        break;
      case Boolean:
        value = Object(types_["isDefined"])(value) ? value === 'false' ? false : Boolean(value) : defaultValue;
        break;
      default:
        value = type(value);
    }
    map[key] = value;
    return map;
  }, {});
};

var getElementTop = function getElementTop(el) {
  return el.getBoundingClientRect().top;
};

var main_handleScroll = function handleScroll(cb) {
  var _scope = this[scope],
      el = _scope.el,
      vm = _scope.vm,
      container = _scope.container,
      observer = _scope.observer;

  var _getScrollOptions = main_getScrollOptions(el, vm),
      distance = _getScrollOptions.distance,
      disabled = _getScrollOptions.disabled;

  if (disabled) return;

  var containerInfo = container.getBoundingClientRect();
  if (!containerInfo.width && !containerInfo.height) return;

  var shouldTrigger = false;

  if (container === el) {
    // be aware of difference between clientHeight & offsetHeight & window.getComputedStyle().height
    var scrollBottom = container.scrollTop + getClientHeight(container);
    shouldTrigger = container.scrollHeight - scrollBottom <= distance;
  } else {
    var heightBelowTop = getOffsetHeight(el) + getElementTop(el) - getElementTop(container);
    var offsetHeight = getOffsetHeight(container);
    var borderBottom = Number.parseFloat(getStyleComputedProperty(container, 'borderBottomWidth'));
    shouldTrigger = heightBelowTop - offsetHeight + borderBottom <= distance;
  }

  if (shouldTrigger && Object(types_["isFunction"])(cb)) {
    cb.call(vm);
  } else if (observer) {
    observer.disconnect();
    this[scope].observer = null;
  }
};

/* harmony default export */ var infinite_scroll_src_main = ({
  name: 'InfiniteScroll',
  inserted: function inserted(el, binding, vnode) {
    var cb = binding.value;

    var vm = vnode.context;
    // only include vertical scroll
    var container = Object(dom_["getScrollContainer"])(el, true);

    var _getScrollOptions2 = main_getScrollOptions(el, vm),
        delay = _getScrollOptions2.delay,
        immediate = _getScrollOptions2.immediate;

    var onScroll = debounce_default()(delay, main_handleScroll.bind(el, cb));

    el[scope] = { el: el, vm: vm, container: container, onScroll: onScroll };

    if (container) {
      container.addEventListener('scroll', onScroll);

      if (immediate) {
        var observer = el[scope].observer = new MutationObserver(onScroll);
        observer.observe(container, { childList: true, subtree: true });
        onScroll();
      }
    }
  },
  unbind: function unbind(el) {
    var _el$scope = el[scope],
        container = _el$scope.container,
        onScroll = _el$scope.onScroll;

    if (container) {
      container.removeEventListener('scroll', onScroll);
    }
  }
});
// CONCATENATED MODULE: ./packages/infinite-scroll/index.js


/* istanbul ignore next */
infinite_scroll_src_main.install = function (Vue) {
  Vue.directive(infinite_scroll_src_main.name, infinite_scroll_src_main);
};

/* harmony default export */ var infinite_scroll = (infinite_scroll_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=template&id=5070954c&
var mainvue_type_template_id_5070954c_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-page-header" }, [
    _c(
      "div",
      {
        staticClass: "el-page-header__left",
        on: {
          click: function($event) {
            _vm.$emit("back")
          }
        }
      },
      [
        _c("i", { staticClass: "el-icon-back" }),
        _c(
          "div",
          { staticClass: "el-page-header__title" },
          [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
          2
        )
      ]
    ),
    _c(
      "div",
      { staticClass: "el-page-header__content" },
      [_vm._t("content", [_vm._v(_vm._s(_vm.content))])],
      2
    )
  ])
}
var mainvue_type_template_id_5070954c_staticRenderFns = []
mainvue_type_template_id_5070954c_render._withStripped = true


// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=template&id=5070954c&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var page_header_src_mainvue_type_script_lang_js_ = ({
  name: 'ElPageHeader',

  props: {
    title: {
      type: String,
      default: function _default() {
        return Object(lib_locale_["t"])('el.pageHeader.title');
      }
    },
    content: String
  }
});
// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_page_header_src_mainvue_type_script_lang_js_ = (page_header_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/page-header/src/main.vue





/* normalize component */

var page_header_src_main_component = normalizeComponent(
  packages_page_header_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_5070954c_render,
  mainvue_type_template_id_5070954c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var page_header_src_main_api; }
page_header_src_main_component.options.__file = "packages/page-header/src/main.vue"
/* harmony default export */ var page_header_src_main = (page_header_src_main_component.exports);
// CONCATENATED MODULE: ./packages/page-header/index.js


/* istanbul ignore next */
page_header_src_main.install = function (Vue) {
  Vue.component(page_header_src_main.name, page_header_src_main);
};

/* harmony default export */ var page_header = (page_header_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
var cascader_panelvue_type_template_id_34932346_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["el-cascader-panel", _vm.border && "is-bordered"],
      on: { keydown: _vm.handleKeyDown }
    },
    _vm._l(_vm.menus, function(menu, index) {
      return _c("cascader-menu", {
        key: index,
        ref: "menu",
        refInFor: true,
        attrs: { index: index, nodes: menu }
      })
    }),
    1
  )
}
var cascader_panelvue_type_template_id_34932346_staticRenderFns = []
cascader_panelvue_type_template_id_34932346_render._withStripped = true


// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&

// EXTERNAL MODULE: external "element-ui/lib/radio"
var radio_ = __webpack_require__(43);
var radio_default = /*#__PURE__*/__webpack_require__.n(radio_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&






var stopPropagation = function stopPropagation(e) {
  return e.stopPropagation();
};

/* harmony default export */ var cascader_nodevue_type_script_lang_js_ = ({
  inject: ['panel'],

  components: {
    ElCheckbox: checkbox_default.a,
    ElRadio: radio_default.a
  },

  props: {
    node: {
      required: true
    },
    nodeId: String
  },

  computed: {
    config: function config() {
      return this.panel.config;
    },
    isLeaf: function isLeaf() {
      return this.node.isLeaf;
    },
    isDisabled: function isDisabled() {
      return this.node.isDisabled;
    },
    checkedValue: function checkedValue() {
      return this.panel.checkedValue;
    },
    isChecked: function isChecked() {
      return this.node.isSameNode(this.checkedValue);
    },
    inActivePath: function inActivePath() {
      return this.isInPath(this.panel.activePath);
    },
    inCheckedPath: function inCheckedPath() {
      var _this = this;

      if (!this.config.checkStrictly) return false;

      return this.panel.checkedNodePaths.some(function (checkedPath) {
        return _this.isInPath(checkedPath);
      });
    },
    value: function value() {
      return this.node.getValueByOption();
    }
  },

  methods: {
    handleExpand: function handleExpand() {
      var _this2 = this;

      var panel = this.panel,
          node = this.node,
          isDisabled = this.isDisabled,
          config = this.config;
      var multiple = config.multiple,
          checkStrictly = config.checkStrictly;


      if (!checkStrictly && isDisabled || node.loading) return;

      if (config.lazy && !node.loaded) {
        panel.lazyLoad(node, function () {
          // do not use cached leaf value here, invoke this.isLeaf to get new value.
          var isLeaf = _this2.isLeaf;


          if (!isLeaf) _this2.handleExpand();
          if (multiple) {
            // if leaf sync checked state, else clear checked state
            var checked = isLeaf ? node.checked : false;
            _this2.handleMultiCheckChange(checked);
          }
        });
      } else {
        panel.handleExpand(node);
      }
    },
    handleCheckChange: function handleCheckChange() {
      var panel = this.panel,
          value = this.value,
          node = this.node;

      panel.handleCheckChange(value);
      panel.handleExpand(node);
    },
    handleMultiCheckChange: function handleMultiCheckChange(checked) {
      this.node.doCheck(checked);
      this.panel.calculateMultiCheckedValue();
    },
    isInPath: function isInPath(pathNodes) {
      var node = this.node;

      var selectedPathNode = pathNodes[node.level - 1] || {};
      return selectedPathNode.uid === node.uid;
    },
    renderPrefix: function renderPrefix(h) {
      var isLeaf = this.isLeaf,
          isChecked = this.isChecked,
          config = this.config;
      var checkStrictly = config.checkStrictly,
          multiple = config.multiple;


      if (multiple) {
        return this.renderCheckbox(h);
      } else if (checkStrictly) {
        return this.renderRadio(h);
      } else if (isLeaf && isChecked) {
        return this.renderCheckIcon(h);
      }

      return null;
    },
    renderPostfix: function renderPostfix(h) {
      var node = this.node,
          isLeaf = this.isLeaf;


      if (node.loading) {
        return this.renderLoadingIcon(h);
      } else if (!isLeaf) {
        return this.renderExpandIcon(h);
      }

      return null;
    },
    renderCheckbox: function renderCheckbox(h) {
      var node = this.node,
          config = this.config,
          isDisabled = this.isDisabled;

      var events = {
        on: { change: this.handleMultiCheckChange },
        nativeOn: {}
      };

      if (config.checkStrictly) {
        // when every node is selectable, click event should not trigger expand event.
        events.nativeOn.click = stopPropagation;
      }

      return h('el-checkbox', external_babel_helper_vue_jsx_merge_props_default()([{
        attrs: {
          value: node.checked,
          indeterminate: node.indeterminate,
          disabled: isDisabled
        }
      }, events]));
    },
    renderRadio: function renderRadio(h) {
      var checkedValue = this.checkedValue,
          value = this.value,
          isDisabled = this.isDisabled;

      // to keep same reference if value cause radio's checked state is calculated by reference comparision;

      if (Object(util_["isEqual"])(value, checkedValue)) {
        value = checkedValue;
      }

      return h(
        'el-radio',
        {
          attrs: {
            value: checkedValue,
            label: value,
            disabled: isDisabled
          },
          on: {
            'change': this.handleCheckChange
          },
          nativeOn: {
            'click': stopPropagation
          }
        },
        [h('span')]
      );
    },
    renderCheckIcon: function renderCheckIcon(h) {
      return h('i', { 'class': 'el-icon-check el-cascader-node__prefix' });
    },
    renderLoadingIcon: function renderLoadingIcon(h) {
      return h('i', { 'class': 'el-icon-loading el-cascader-node__postfix' });
    },
    renderExpandIcon: function renderExpandIcon(h) {
      return h('i', { 'class': 'el-icon-arrow-right el-cascader-node__postfix' });
    },
    renderContent: function renderContent(h) {
      var panel = this.panel,
          node = this.node;

      var render = panel.renderLabelFn;
      var vnode = render ? render({ node: node, data: node.data }) : null;

      return h(
        'span',
        { 'class': 'el-cascader-node__label' },
        [vnode || node.label]
      );
    }
  },

  render: function render(h) {
    var _this3 = this;

    var inActivePath = this.inActivePath,
        inCheckedPath = this.inCheckedPath,
        isChecked = this.isChecked,
        isLeaf = this.isLeaf,
        isDisabled = this.isDisabled,
        config = this.config,
        nodeId = this.nodeId;
    var expandTrigger = config.expandTrigger,
        checkStrictly = config.checkStrictly,
        multiple = config.multiple;

    var disabled = !checkStrictly && isDisabled;
    var events = { on: {} };

    if (expandTrigger === 'click') {
      events.on.click = this.handleExpand;
    } else {
      events.on.mouseenter = function (e) {
        _this3.handleExpand();
        _this3.$emit('expand', e);
      };
      events.on.focus = function (e) {
        _this3.handleExpand();
        _this3.$emit('expand', e);
      };
    }
    if (isLeaf && !isDisabled && !checkStrictly && !multiple) {
      events.on.click = this.handleCheckChange;
    }

    return h(
      'li',
      external_babel_helper_vue_jsx_merge_props_default()([{
        attrs: {
          role: 'menuitem',
          id: nodeId,
          'aria-expanded': inActivePath,
          tabindex: disabled ? null : -1
        },
        'class': {
          'el-cascader-node': true,
          'is-selectable': checkStrictly,
          'in-active-path': inActivePath,
          'in-checked-path': inCheckedPath,
          'is-active': isChecked,
          'is-disabled': disabled
        }
      }, events]),
      [this.renderPrefix(h), this.renderContent(h), this.renderPostfix(h)]
    );
  }
});
// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_cascader_nodevue_type_script_lang_js_ = (cascader_nodevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
var cascader_node_render, cascader_node_staticRenderFns




/* normalize component */

var cascader_node_component = normalizeComponent(
  src_cascader_nodevue_type_script_lang_js_,
  cascader_node_render,
  cascader_node_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var cascader_node_api; }
cascader_node_component.options.__file = "packages/cascader-panel/src/cascader-node.vue"
/* harmony default export */ var cascader_node = (cascader_node_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&







/* harmony default export */ var cascader_menuvue_type_script_lang_js_ = ({
  name: 'ElCascaderMenu',

  mixins: [locale_default.a],

  inject: ['panel'],

  components: {
    ElScrollbar: scrollbar_default.a,
    CascaderNode: cascader_node
  },

  props: {
    nodes: {
      type: Array,
      required: true
    },
    index: Number
  },

  data: function data() {
    return {
      activeNode: null,
      hoverTimer: null,
      id: Object(util_["generateId"])()
    };
  },


  computed: {
    isEmpty: function isEmpty() {
      return !this.nodes.length;
    },
    menuId: function menuId() {
      return 'cascader-menu-' + this.id + '-' + this.index;
    }
  },

  methods: {
    handleExpand: function handleExpand(e) {
      this.activeNode = e.target;
    },
    handleMouseMove: function handleMouseMove(e) {
      var activeNode = this.activeNode,
          hoverTimer = this.hoverTimer;
      var hoverZone = this.$refs.hoverZone;


      if (!activeNode || !hoverZone) return;

      if (activeNode.contains(e.target)) {
        clearTimeout(hoverTimer);

        var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
            left = _$el$getBoundingClien.left;

        var startX = e.clientX - left;
        var _$el = this.$el,
            offsetWidth = _$el.offsetWidth,
            offsetHeight = _$el.offsetHeight;

        var top = activeNode.offsetTop;
        var bottom = top + activeNode.offsetHeight;

        hoverZone.innerHTML = '\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + top + ' L' + offsetWidth + ' 0 V' + top + ' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + bottom + ' L' + offsetWidth + ' ' + offsetHeight + ' V' + bottom + ' Z" />\n        ';
      } else if (!hoverTimer) {
        this.hoverTimer = setTimeout(this.clearHoverZone, this.panel.config.hoverThreshold);
      }
    },
    clearHoverZone: function clearHoverZone() {
      var hoverZone = this.$refs.hoverZone;

      if (!hoverZone) return;
      hoverZone.innerHTML = '';
    },
    renderEmptyText: function renderEmptyText(h) {
      return h(
        'div',
        { 'class': 'el-cascader-menu__empty-text' },
        [this.t('el.cascader.noData')]
      );
    },
    renderNodeList: function renderNodeList(h) {
      var menuId = this.menuId;
      var isHoverMenu = this.panel.isHoverMenu;

      var events = { on: {} };

      if (isHoverMenu) {
        events.on.expand = this.handleExpand;
      }

      var nodes = this.nodes.map(function (node, index) {
        var hasChildren = node.hasChildren;

        return h('cascader-node', external_babel_helper_vue_jsx_merge_props_default()([{
          key: node.uid,
          attrs: { node: node,
            'node-id': menuId + '-' + index,
            'aria-haspopup': hasChildren,
            'aria-owns': hasChildren ? menuId : null
          }
        }, events]));
      });

      return [].concat(nodes, [isHoverMenu ? h('svg', { ref: 'hoverZone', 'class': 'el-cascader-menu__hover-zone' }) : null]);
    }
  },

  render: function render(h) {
    var isEmpty = this.isEmpty,
        menuId = this.menuId;

    var events = { nativeOn: {} };

    // optimize hover to expand experience (#8010)
    if (this.panel.isHoverMenu) {
      events.nativeOn.mousemove = this.handleMouseMove;
      // events.nativeOn.mouseleave = this.clearHoverZone;
    }

    return h(
      'el-scrollbar',
      external_babel_helper_vue_jsx_merge_props_default()([{
        attrs: {
          tag: 'ul',
          role: 'menu',
          id: menuId,

          'wrap-class': 'el-cascader-menu__wrap',
          'view-class': {
            'el-cascader-menu__list': true,
            'is-empty': isEmpty
          }
        },
        'class': 'el-cascader-menu' }, events]),
      [isEmpty ? this.renderEmptyText(h) : this.renderNodeList(h)]
    );
  }
});
// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_cascader_menuvue_type_script_lang_js_ = (cascader_menuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
var cascader_menu_render, cascader_menu_staticRenderFns




/* normalize component */

var cascader_menu_component = normalizeComponent(
  src_cascader_menuvue_type_script_lang_js_,
  cascader_menu_render,
  cascader_menu_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var cascader_menu_api; }
cascader_menu_component.options.__file = "packages/cascader-panel/src/cascader-menu.vue"
/* harmony default export */ var cascader_menu = (cascader_menu_component.exports);
// CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
var node_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function src_node_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var uid = 0;

var src_node_Node = function () {
  function Node(data, config, parentNode) {
    src_node_classCallCheck(this, Node);

    this.data = data;
    this.config = config;
    this.parent = parentNode || null;
    this.level = !this.parent ? 1 : this.parent.level + 1;
    this.uid = uid++;

    this.initState();
    this.initChildren();
  }

  Node.prototype.initState = function initState() {
    var _config = this.config,
        valueKey = _config.value,
        labelKey = _config.label;


    this.value = this.data[valueKey];
    this.label = this.data[labelKey];
    this.pathNodes = this.calculatePathNodes();
    this.path = this.pathNodes.map(function (node) {
      return node.value;
    });
    this.pathLabels = this.pathNodes.map(function (node) {
      return node.label;
    });

    // lazy load
    this.loading = false;
    this.loaded = false;
  };

  Node.prototype.initChildren = function initChildren() {
    var _this = this;

    var config = this.config;

    var childrenKey = config.children;
    var childrenData = this.data[childrenKey];
    this.hasChildren = Array.isArray(childrenData);
    this.children = (childrenData || []).map(function (child) {
      return new Node(child, config, _this);
    });
  };

  Node.prototype.calculatePathNodes = function calculatePathNodes() {
    var nodes = [this];
    var parent = this.parent;

    while (parent) {
      nodes.unshift(parent);
      parent = parent.parent;
    }

    return nodes;
  };

  Node.prototype.getPath = function getPath() {
    return this.path;
  };

  Node.prototype.getValue = function getValue() {
    return this.value;
  };

  Node.prototype.getValueByOption = function getValueByOption() {
    return this.config.emitPath ? this.getPath() : this.getValue();
  };

  Node.prototype.getText = function getText(allLevels, separator) {
    return allLevels ? this.pathLabels.join(separator) : this.label;
  };

  Node.prototype.isSameNode = function isSameNode(checkedValue) {
    var value = this.getValueByOption();
    return this.config.multiple && Array.isArray(checkedValue) ? checkedValue.some(function (val) {
      return Object(util_["isEqual"])(val, value);
    }) : Object(util_["isEqual"])(checkedValue, value);
  };

  Node.prototype.broadcast = function broadcast(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var handlerName = 'onParent' + Object(util_["capitalize"])(event);

    this.children.forEach(function (child) {
      if (child) {
        // bottom up
        child.broadcast.apply(child, [event].concat(args));
        child[handlerName] && child[handlerName].apply(child, args);
      }
    });
  };

  Node.prototype.emit = function emit(event) {
    var parent = this.parent;

    var handlerName = 'onChild' + Object(util_["capitalize"])(event);
    if (parent) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      parent[handlerName] && parent[handlerName].apply(parent, args);
      parent.emit.apply(parent, [event].concat(args));
    }
  };

  Node.prototype.onParentCheck = function onParentCheck(checked) {
    if (!this.isDisabled) {
      this.setCheckState(checked);
    }
  };

  Node.prototype.onChildCheck = function onChildCheck() {
    var children = this.children;

    var validChildren = children.filter(function (child) {
      return !child.isDisabled;
    });
    var checked = validChildren.length ? validChildren.every(function (child) {
      return child.checked;
    }) : false;

    this.setCheckState(checked);
  };

  Node.prototype.setCheckState = function setCheckState(checked) {
    var totalNum = this.children.length;
    var checkedNum = this.children.reduce(function (c, p) {
      var num = p.checked ? 1 : p.indeterminate ? 0.5 : 0;
      return c + num;
    }, 0);

    this.checked = checked;
    this.indeterminate = checkedNum !== totalNum && checkedNum > 0;
  };

  Node.prototype.syncCheckState = function syncCheckState(checkedValue) {
    var value = this.getValueByOption();
    var checked = this.isSameNode(checkedValue, value);

    this.doCheck(checked);
  };

  Node.prototype.doCheck = function doCheck(checked) {
    if (this.checked !== checked) {
      if (this.config.checkStrictly) {
        this.checked = checked;
      } else {
        // bottom up to unify the calculation of the indeterminate state
        this.broadcast('check', checked);
        this.setCheckState(checked);
        this.emit('check');
      }
    }
  };

  node_createClass(Node, [{
    key: 'isDisabled',
    get: function get() {
      var data = this.data,
          parent = this.parent,
          config = this.config;

      var disabledKey = config.disabled;
      var checkStrictly = config.checkStrictly;

      return data[disabledKey] || !checkStrictly && parent && parent.isDisabled;
    }
  }, {
    key: 'isLeaf',
    get: function get() {
      var data = this.data,
          loaded = this.loaded,
          hasChildren = this.hasChildren,
          children = this.children;
      var _config2 = this.config,
          lazy = _config2.lazy,
          leafKey = _config2.leaf;

      if (lazy) {
        var isLeaf = Object(shared_["isDef"])(data[leafKey]) ? data[leafKey] : loaded ? !children.length : false;
        this.hasChildren = !isLeaf;
        return isLeaf;
      }
      return !hasChildren;
    }
  }]);

  return Node;
}();

/* harmony default export */ var src_node = (src_node_Node);
// CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
function store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var flatNodes = function flatNodes(data, leafOnly) {
  return data.reduce(function (res, node) {
    if (node.isLeaf) {
      res.push(node);
    } else {
      !leafOnly && res.push(node);
      res = res.concat(flatNodes(node.children, leafOnly));
    }
    return res;
  }, []);
};

var store_Store = function () {
  function Store(data, config) {
    store_classCallCheck(this, Store);

    this.config = config;
    this.initNodes(data);
  }

  Store.prototype.initNodes = function initNodes(data) {
    var _this = this;

    data = Object(util_["coerceTruthyValueToArray"])(data);
    this.nodes = data.map(function (nodeData) {
      return new src_node(nodeData, _this.config);
    });
    this.flattedNodes = this.getFlattedNodes(false, false);
    this.leafNodes = this.getFlattedNodes(true, false);
  };

  Store.prototype.appendNode = function appendNode(nodeData, parentNode) {
    var node = new src_node(nodeData, this.config, parentNode);
    var children = parentNode ? parentNode.children : this.nodes;

    children.push(node);
  };

  Store.prototype.appendNodes = function appendNodes(nodeDataList, parentNode) {
    var _this2 = this;

    nodeDataList = Object(util_["coerceTruthyValueToArray"])(nodeDataList);
    nodeDataList.forEach(function (nodeData) {
      return _this2.appendNode(nodeData, parentNode);
    });
  };

  Store.prototype.getNodes = function getNodes() {
    return this.nodes;
  };

  Store.prototype.getFlattedNodes = function getFlattedNodes(leafOnly) {
    var cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var cachedNodes = leafOnly ? this.leafNodes : this.flattedNodes;
    return cached ? cachedNodes : flatNodes(this.nodes, leafOnly);
  };

  Store.prototype.getNodeByValue = function getNodeByValue(value) {
    if (value) {
      var nodes = this.getFlattedNodes(false, !this.config.lazy).filter(function (node) {
        return Object(util_["valueEquals"])(node.path, value) || node.value === value;
      });
      return nodes && nodes.length ? nodes[0] : null;
    }
    return null;
  };

  return Store;
}();

/* harmony default export */ var cascader_panel_src_store = (store_Store);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
var cascader_panelvue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var cascader_panelvue_type_script_lang_js_KeyCode = aria_utils_default.a.keys;

var DefaultProps = {
  expandTrigger: 'click', // or hover
  multiple: false,
  checkStrictly: false, // whether all nodes can be selected
  emitPath: true, // wether to emit an array of all levels value in which node is located
  lazy: false,
  lazyLoad: util_["noop"],
  value: 'value',
  label: 'label',
  children: 'children',
  leaf: 'leaf',
  disabled: 'disabled',
  hoverThreshold: 500
};

var cascader_panelvue_type_script_lang_js_isLeaf = function isLeaf(el) {
  return !el.getAttribute('aria-owns');
};

var getSibling = function getSibling(el, distance) {
  var parentNode = el.parentNode;

  if (parentNode) {
    var siblings = parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');
    var index = Array.prototype.indexOf.call(siblings, el);
    return siblings[index + distance] || null;
  }
  return null;
};

var getMenuIndex = function getMenuIndex(el, distance) {
  if (!el) return;
  var pieces = el.id.split('-');
  return Number(pieces[pieces.length - 2]);
};

var focusNode = function focusNode(el) {
  if (!el) return;
  el.focus();
  !cascader_panelvue_type_script_lang_js_isLeaf(el) && el.click();
};

var checkNode = function checkNode(el) {
  if (!el) return;

  var input = el.querySelector('input');
  if (input) {
    input.click();
  } else if (cascader_panelvue_type_script_lang_js_isLeaf(el)) {
    el.click();
  }
};

/* harmony default export */ var cascader_panelvue_type_script_lang_js_ = ({
  name: 'ElCascaderPanel',

  components: {
    CascaderMenu: cascader_menu
  },

  props: {
    value: {},
    options: Array,
    props: Object,
    border: {
      type: Boolean,
      default: true
    },
    renderLabel: Function
  },

  provide: function provide() {
    return {
      panel: this
    };
  },
  data: function data() {
    return {
      checkedValue: null,
      checkedNodePaths: [],
      store: [],
      menus: [],
      activePath: [],
      loadCount: 0
    };
  },


  computed: {
    config: function config() {
      return merge_default()(cascader_panelvue_type_script_lang_js_extends({}, DefaultProps), this.props || {});
    },
    multiple: function multiple() {
      return this.config.multiple;
    },
    checkStrictly: function checkStrictly() {
      return this.config.checkStrictly;
    },
    leafOnly: function leafOnly() {
      return !this.checkStrictly;
    },
    isHoverMenu: function isHoverMenu() {
      return this.config.expandTrigger === 'hover';
    },
    renderLabelFn: function renderLabelFn() {
      return this.renderLabel || this.$scopedSlots.default;
    }
  },

  watch: {
    options: {
      handler: function handler() {
        this.initStore();
      },
      immediate: true,
      deep: true
    },
    value: function value() {
      this.syncCheckedValue();
      this.checkStrictly && this.calculateCheckedNodePaths();
    },
    checkedValue: function checkedValue(val) {
      if (!Object(util_["isEqual"])(val, this.value)) {
        this.checkStrictly && this.calculateCheckedNodePaths();
        this.$emit('input', val);
        this.$emit('change', val);
      }
    }
  },

  mounted: function mounted() {
    if (!Object(util_["isEmpty"])(this.value)) {
      this.syncCheckedValue();
    }
  },


  methods: {
    initStore: function initStore() {
      var config = this.config,
          options = this.options;

      if (config.lazy && Object(util_["isEmpty"])(options)) {
        this.lazyLoad();
      } else {
        this.store = new cascader_panel_src_store(options, config);
        this.menus = [this.store.getNodes()];
        this.syncMenuState();
      }
    },
    syncCheckedValue: function syncCheckedValue() {
      var value = this.value,
          checkedValue = this.checkedValue;

      if (!Object(util_["isEqual"])(value, checkedValue)) {
        this.checkedValue = value;
        this.syncMenuState();
      }
    },
    syncMenuState: function syncMenuState() {
      var multiple = this.multiple,
          checkStrictly = this.checkStrictly;

      this.syncActivePath();
      multiple && this.syncMultiCheckState();
      checkStrictly && this.calculateCheckedNodePaths();
      this.$nextTick(this.scrollIntoView);
    },
    syncMultiCheckState: function syncMultiCheckState() {
      var _this = this;

      var nodes = this.getFlattedNodes(this.leafOnly);

      nodes.forEach(function (node) {
        node.syncCheckState(_this.checkedValue);
      });
    },
    syncActivePath: function syncActivePath() {
      var _this2 = this;

      var store = this.store,
          multiple = this.multiple,
          activePath = this.activePath,
          checkedValue = this.checkedValue;


      if (!Object(util_["isEmpty"])(activePath)) {
        var nodes = activePath.map(function (node) {
          return _this2.getNodeByValue(node.getValue());
        });
        this.expandNodes(nodes);
      } else if (!Object(util_["isEmpty"])(checkedValue)) {
        var value = multiple ? checkedValue[0] : checkedValue;
        var checkedNode = this.getNodeByValue(value) || {};
        var _nodes = (checkedNode.pathNodes || []).slice(0, -1);
        this.expandNodes(_nodes);
      } else {
        this.activePath = [];
        this.menus = [store.getNodes()];
      }
    },
    expandNodes: function expandNodes(nodes) {
      var _this3 = this;

      nodes.forEach(function (node) {
        return _this3.handleExpand(node, true /* silent */);
      });
    },
    calculateCheckedNodePaths: function calculateCheckedNodePaths() {
      var _this4 = this;

      var checkedValue = this.checkedValue,
          multiple = this.multiple;

      var checkedValues = multiple ? Object(util_["coerceTruthyValueToArray"])(checkedValue) : [checkedValue];
      this.checkedNodePaths = checkedValues.map(function (v) {
        var checkedNode = _this4.getNodeByValue(v);
        return checkedNode ? checkedNode.pathNodes : [];
      });
    },
    handleKeyDown: function handleKeyDown(e) {
      var target = e.target,
          keyCode = e.keyCode;


      switch (keyCode) {
        case cascader_panelvue_type_script_lang_js_KeyCode.up:
          var prev = getSibling(target, -1);
          focusNode(prev);
          break;
        case cascader_panelvue_type_script_lang_js_KeyCode.down:
          var next = getSibling(target, 1);
          focusNode(next);
          break;
        case cascader_panelvue_type_script_lang_js_KeyCode.left:
          var preMenu = this.$refs.menu[getMenuIndex(target) - 1];
          if (preMenu) {
            var expandedNode = preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');
            focusNode(expandedNode);
          }
          break;
        case cascader_panelvue_type_script_lang_js_KeyCode.right:
          var nextMenu = this.$refs.menu[getMenuIndex(target) + 1];
          if (nextMenu) {
            var firstNode = nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');
            focusNode(firstNode);
          }
          break;
        case cascader_panelvue_type_script_lang_js_KeyCode.enter:
          checkNode(target);
          break;
        case cascader_panelvue_type_script_lang_js_KeyCode.esc:
        case cascader_panelvue_type_script_lang_js_KeyCode.tab:
          this.$emit('close');
          break;
        default:
          return;
      }
    },
    handleExpand: function handleExpand(node, silent) {
      var activePath = this.activePath;
      var level = node.level;

      var path = activePath.slice(0, level - 1);
      var menus = this.menus.slice(0, level);

      if (!node.isLeaf) {
        path.push(node);
        menus.push(node.children);
      }

      this.activePath = path;
      this.menus = menus;

      if (!silent) {
        var pathValues = path.map(function (node) {
          return node.getValue();
        });
        var activePathValues = activePath.map(function (node) {
          return node.getValue();
        });
        if (!Object(util_["valueEquals"])(pathValues, activePathValues)) {
          this.$emit('active-item-change', pathValues); // Deprecated
          this.$emit('expand-change', pathValues);
        }
      }
    },
    handleCheckChange: function handleCheckChange(value) {
      this.checkedValue = value;
    },
    lazyLoad: function lazyLoad(node, onFullfiled) {
      var _this5 = this;

      var config = this.config;

      if (!node) {
        node = node || { root: true, level: 0 };
        this.store = new cascader_panel_src_store([], config);
        this.menus = [this.store.getNodes()];
      }
      node.loading = true;
      var resolve = function resolve(dataList) {
        var parent = node.root ? null : node;
        dataList && dataList.length && _this5.store.appendNodes(dataList, parent);
        node.loading = false;
        node.loaded = true;

        // dispose default value on lazy load mode
        if (Array.isArray(_this5.checkedValue)) {
          var nodeValue = _this5.checkedValue[_this5.loadCount++];
          var valueKey = _this5.config.value;
          var leafKey = _this5.config.leaf;

          if (Array.isArray(dataList) && dataList.filter(function (item) {
            return item[valueKey] === nodeValue;
          }).length > 0) {
            var checkedNode = _this5.store.getNodeByValue(nodeValue);

            if (!checkedNode.data[leafKey]) {
              _this5.lazyLoad(checkedNode, function () {
                _this5.handleExpand(checkedNode);
              });
            }

            if (_this5.loadCount === _this5.checkedValue.length) {
              _this5.$parent.computePresentText();
            }
          }
        }

        onFullfiled && onFullfiled(dataList);
      };
      config.lazyLoad(node, resolve);
    },


    /**
     * public methods
    */
    calculateMultiCheckedValue: function calculateMultiCheckedValue() {
      this.checkedValue = this.getCheckedNodes(this.leafOnly).map(function (node) {
        return node.getValueByOption();
      });
    },
    scrollIntoView: function scrollIntoView() {
      if (this.$isServer) return;

      var menus = this.$refs.menu || [];
      menus.forEach(function (menu) {
        var menuElement = menu.$el;
        if (menuElement) {
          var container = menuElement.querySelector('.el-scrollbar__wrap');
          var activeNode = menuElement.querySelector('.el-cascader-node.is-active') || menuElement.querySelector('.el-cascader-node.in-active-path');
          scroll_into_view_default()(container, activeNode);
        }
      });
    },
    getNodeByValue: function getNodeByValue(val) {
      return this.store.getNodeByValue(val);
    },
    getFlattedNodes: function getFlattedNodes(leafOnly) {
      var cached = !this.config.lazy;
      return this.store.getFlattedNodes(leafOnly, cached);
    },
    getCheckedNodes: function getCheckedNodes(leafOnly) {
      var checkedValue = this.checkedValue,
          multiple = this.multiple;

      if (multiple) {
        var nodes = this.getFlattedNodes(leafOnly);
        return nodes.filter(function (node) {
          return node.checked;
        });
      } else {
        return Object(util_["isEmpty"])(checkedValue) ? [] : [this.getNodeByValue(checkedValue)];
      }
    },
    clearCheckedNodes: function clearCheckedNodes() {
      var config = this.config,
          leafOnly = this.leafOnly;
      var multiple = config.multiple,
          emitPath = config.emitPath;

      if (multiple) {
        this.getCheckedNodes(leafOnly).filter(function (node) {
          return !node.isDisabled;
        }).forEach(function (node) {
          return node.doCheck(false);
        });
        this.calculateMultiCheckedValue();
      } else {
        this.checkedValue = emitPath ? [] : null;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_cascader_panelvue_type_script_lang_js_ = (cascader_panelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue





/* normalize component */

var cascader_panel_component = normalizeComponent(
  src_cascader_panelvue_type_script_lang_js_,
  cascader_panelvue_type_template_id_34932346_render,
  cascader_panelvue_type_template_id_34932346_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var cascader_panel_api; }
cascader_panel_component.options.__file = "packages/cascader-panel/src/cascader-panel.vue"
/* harmony default export */ var cascader_panel = (cascader_panel_component.exports);
// CONCATENATED MODULE: ./packages/cascader-panel/index.js


/* istanbul ignore next */
cascader_panel.install = function (Vue) {
  Vue.component(cascader_panel.name, cascader_panel);
};

/* harmony default export */ var packages_cascader_panel = (cascader_panel);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/avatar/src/main.vue?vue&type=script&lang=js&

/* harmony default export */ var avatar_src_mainvue_type_script_lang_js_ = ({
  name: 'ElAvatar',

  props: {
    size: {
      type: [Number, String],
      validator: function validator(val) {
        if (typeof val === 'string') {
          return ['large', 'medium', 'small'].includes(val);
        }
        return typeof val === 'number';
      }
    },
    shape: {
      type: String,
      default: 'circle',
      validator: function validator(val) {
        return ['circle', 'square'].includes(val);
      }
    },
    icon: String,
    src: String,
    alt: String,
    srcSet: String,
    error: Function,
    fit: {
      type: String,
      default: 'cover'
    }
  },

  data: function data() {
    return {
      isImageExist: true
    };
  },


  computed: {
    avatarClass: function avatarClass() {
      var size = this.size,
          icon = this.icon,
          shape = this.shape;

      var classList = ['el-avatar'];

      if (size && typeof size === 'string') {
        classList.push('el-avatar--' + size);
      }

      if (icon) {
        classList.push('el-avatar--icon');
      }

      if (shape) {
        classList.push('el-avatar--' + shape);
      }

      return classList.join(' ');
    }
  },

  methods: {
    handleError: function handleError() {
      var error = this.error;

      var errorFlag = error ? error() : undefined;
      if (errorFlag !== false) {
        this.isImageExist = false;
      }
    },
    renderAvatar: function renderAvatar() {
      var h = this.$createElement;
      var icon = this.icon,
          src = this.src,
          alt = this.alt,
          isImageExist = this.isImageExist,
          srcSet = this.srcSet,
          fit = this.fit;


      if (isImageExist && src) {
        return h('img', {
          attrs: {
            src: src,

            alt: alt,
            srcSet: srcSet
          },
          on: {
            'error': this.handleError
          },
          style: { 'object-fit': fit } });
      }

      if (icon) {
        return h('i', { 'class': icon });
      }

      return this.$slots.default;
    }
  },

  render: function render() {
    var h = arguments[0];
    var avatarClass = this.avatarClass,
        size = this.size;


    var sizeStyle = typeof size === 'number' ? {
      height: size + 'px',
      width: size + 'px',
      lineHeight: size + 'px'
    } : {};

    return h(
      'span',
      { 'class': avatarClass, style: sizeStyle },
      [this.renderAvatar()]
    );
  }
});
// CONCATENATED MODULE: ./packages/avatar/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_avatar_src_mainvue_type_script_lang_js_ = (avatar_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/avatar/src/main.vue
var src_main_render, src_main_staticRenderFns




/* normalize component */

var avatar_src_main_component = normalizeComponent(
  packages_avatar_src_mainvue_type_script_lang_js_,
  src_main_render,
  src_main_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var avatar_src_main_api; }
avatar_src_main_component.options.__file = "packages/avatar/src/main.vue"
/* harmony default export */ var avatar_src_main = (avatar_src_main_component.exports);
// CONCATENATED MODULE: ./packages/avatar/index.js


/* istanbul ignore next */
avatar_src_main.install = function (Vue) {
  Vue.component(avatar_src_main.name, avatar_src_main);
};

/* harmony default export */ var avatar = (avatar_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=template&id=a4885264&
var mainvue_type_template_id_a4885264_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "el-drawer-fade" },
      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          staticClass: "el-drawer__wrapper",
          attrs: { tabindex: "-1" }
        },
        [
          _c(
            "div",
            {
              staticClass: "el-drawer__container",
              class: _vm.visible && "el-drawer__open",
              attrs: { role: "document", tabindex: "-1" },
              on: {
                click: function($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  return _vm.handleWrapperClick($event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  ref: "drawer",
                  staticClass: "el-drawer",
                  class: [_vm.direction, _vm.customClass],
                  style: _vm.isHorizontal
                    ? "width: " + _vm.size
                    : "height: " + _vm.size,
                  attrs: {
                    "aria-modal": "true",
                    "aria-labelledby": "el-drawer__title",
                    "aria-label": _vm.title,
                    role: "dialog",
                    tabindex: "-1"
                  }
                },
                [
                  _vm.withHeader
                    ? _c(
                        "header",
                        {
                          staticClass: "el-drawer__header",
                          attrs: { id: "el-drawer__title" }
                        },
                        [
                          _vm._t("title", [
                            _c(
                              "span",
                              {
                                attrs: {
                                  role: "heading",
                                  tabindex: "0",
                                  title: _vm.title
                                }
                              },
                              [_vm._v(_vm._s(_vm.title))]
                            )
                          ]),
                          _vm.showClose
                            ? _c(
                                "button",
                                {
                                  staticClass: "el-drawer__close-btn",
                                  attrs: {
                                    "aria-label":
                                      "close " + (_vm.title || "drawer"),
                                    type: "button"
                                  },
                                  on: { click: _vm.closeDrawer }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-dialog__close el-icon el-icon-close"
                                  })
                                ]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.rendered
                    ? _c(
                        "section",
                        { staticClass: "el-drawer__body" },
                        [_vm._t("default")],
                        2
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var mainvue_type_template_id_a4885264_staticRenderFns = []
mainvue_type_template_id_a4885264_render._withStripped = true


// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=template&id=a4885264&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var drawer_src_mainvue_type_script_lang_js_ = ({
  name: 'ElDrawer',
  mixins: [popup_default.a, emitter_default.a],
  props: {
    appendToBody: {
      type: Boolean,
      default: false
    },
    beforeClose: {
      type: Function
    },
    customClass: {
      type: String,
      default: ''
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: true
    },
    direction: {
      type: String,
      default: 'rtl',
      validator: function validator(val) {
        return ['ltr', 'rtl', 'ttb', 'btt'].indexOf(val) !== -1;
      }
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: '30%'
    },
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean
    },
    wrapperClosable: {
      type: Boolean,
      default: true
    },
    withHeader: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isHorizontal: function isHorizontal() {
      return this.direction === 'rtl' || this.direction === 'ltr';
    }
  },
  data: function data() {
    return {
      closed: false,
      prevActiveElement: null
    };
  },

  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.closed = false;
        this.$emit('open');
        if (this.appendToBody) {
          document.body.appendChild(this.$el);
        }
        this.prevActiveElement = document.activeElement;
        this.$nextTick(function () {
          aria_utils_default.a.focusFirstDescendant(_this.$refs.drawer);
        });
      } else {
        if (!this.closed) this.$emit('close');
        this.$nextTick(function () {
          if (_this.prevActiveElement) {
            _this.prevActiveElement.focus();
          }
        });
      }
    }
  },
  methods: {
    afterEnter: function afterEnter() {
      this.$emit('opened');
    },
    afterLeave: function afterLeave() {
      this.$emit('closed');
    },
    hide: function hide(cancel) {
      if (cancel !== false) {
        this.$emit('update:visible', false);
        this.$emit('close');
        if (this.destroyOnClose === true) {
          this.rendered = false;
        }
        this.closed = true;
      }
    },
    handleWrapperClick: function handleWrapperClick() {
      if (this.wrapperClosable) {
        this.closeDrawer();
      }
    },
    closeDrawer: function closeDrawer() {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide);
      } else {
        this.hide();
      }
    },
    handleClose: function handleClose() {
      // This method here will be called by PopupManger, when the `closeOnPressEscape` was set to true
      // pressing `ESC` will call this method, and also close the drawer.
      // This method also calls `beforeClose` if there was one.
      this.closeDrawer();
    }
  },
  mounted: function mounted() {
    if (this.visible) {
      this.rendered = true;
      this.open();
    }
  },
  destroyed: function destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
});
// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_drawer_src_mainvue_type_script_lang_js_ = (drawer_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/drawer/src/main.vue





/* normalize component */

var drawer_src_main_component = normalizeComponent(
  packages_drawer_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_a4885264_render,
  mainvue_type_template_id_a4885264_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var drawer_src_main_api; }
drawer_src_main_component.options.__file = "packages/drawer/src/main.vue"
/* harmony default export */ var drawer_src_main = (drawer_src_main_component.exports);
// CONCATENATED MODULE: ./packages/drawer/index.js


/* istanbul ignore next */
drawer_src_main.install = function (Vue) {
  Vue.component(drawer_src_main.name, drawer_src_main);
};

/* harmony default export */ var drawer = (drawer_src_main);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&
var mainvue_type_template_id_048de730_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    _vm._b(
      {
        attrs: { trigger: "click" },
        model: {
          value: _vm.visible,
          callback: function($$v) {
            _vm.visible = $$v
          },
          expression: "visible"
        }
      },
      "el-popover",
      _vm.$attrs,
      false
    ),
    [
      _c("div", { staticClass: "el-popconfirm" }, [
        _c("p", { staticClass: "el-popconfirm__main" }, [
          !_vm.hideIcon
            ? _c("i", {
                staticClass: "el-popconfirm__icon",
                class: _vm.icon,
                style: { color: _vm.iconColor }
              })
            : _vm._e(),
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
        ]),
        _c(
          "div",
          { staticClass: "el-popconfirm__action" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "mini", type: _vm.cancelButtonType },
                on: { click: _vm.cancel }
              },
              [_vm._v("\n        " + _vm._s(_vm.cancelButtonText) + "\n      ")]
            ),
            _c(
              "el-button",
              {
                attrs: { size: "mini", type: _vm.confirmButtonType },
                on: { click: _vm.confirm }
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.confirmButtonText) + "\n      "
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._t("reference", null, { slot: "reference" })
    ],
    2
  )
}
var mainvue_type_template_id_048de730_staticRenderFns = []
mainvue_type_template_id_048de730_render._withStripped = true


// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&

// EXTERNAL MODULE: external "element-ui/lib/popover"
var popover_ = __webpack_require__(44);
var popover_default = /*#__PURE__*/__webpack_require__.n(popover_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var popconfirm_src_mainvue_type_script_lang_js_ = ({
  name: 'ElPopconfirm',
  props: {
    title: {
      type: String
    },
    confirmButtonText: {
      type: String,
      default: Object(lib_locale_["t"])('el.popconfirm.confirmButtonText')
    },
    cancelButtonText: {
      type: String,
      default: Object(lib_locale_["t"])('el.popconfirm.cancelButtonText')
    },
    confirmButtonType: {
      type: String,
      default: 'primary'
    },
    cancelButtonType: {
      type: String,
      default: 'text'
    },
    icon: {
      type: String,
      default: 'el-icon-question'
    },
    iconColor: {
      type: String,
      default: '#f90'
    },
    hideIcon: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ElPopover: popover_default.a,
    ElButton: button_default.a
  },
  data: function data() {
    return {
      visible: false
    };
  },

  methods: {
    confirm: function confirm() {
      this.visible = false;
      this.$emit('onConfirm');
    },
    cancel: function cancel() {
      this.visible = false;
      this.$emit('onCancel');
    }
  }
});
// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var packages_popconfirm_src_mainvue_type_script_lang_js_ = (popconfirm_src_mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue





/* normalize component */

var popconfirm_src_main_component = normalizeComponent(
  packages_popconfirm_src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_048de730_render,
  mainvue_type_template_id_048de730_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var popconfirm_src_main_api; }
popconfirm_src_main_component.options.__file = "packages/popconfirm/src/main.vue"
/* harmony default export */ var popconfirm_src_main = (popconfirm_src_main_component.exports);
// CONCATENATED MODULE: ./packages/popconfirm/index.js


/* istanbul ignore next */
popconfirm_src_main.install = function (Vue) {
  Vue.component(popconfirm_src_main.name, popconfirm_src_main);
};

/* harmony default export */ var popconfirm = (popconfirm_src_main);
// CONCATENATED MODULE: ./src/index.js
/* Automatically generated by './build/bin/build-entry.js' */






















































































var components = [packages_pagination, dialog, packages_autocomplete, packages_dropdown, packages_dropdown_menu, packages_dropdown_item, packages_menu, packages_submenu, packages_menu_item, packages_menu_item_group, packages_input, packages_input_number, packages_radio, packages_radio_group, packages_radio_button, packages_checkbox, packages_checkbox_button, packages_checkbox_group, packages_switch, packages_select, packages_option, packages_option_group, packages_button, packages_button_group, packages_table, packages_table_column, packages_date_picker, packages_time_select, packages_time_picker, popover, packages_tooltip, packages_breadcrumb, packages_breadcrumb_item, packages_form, packages_form_item, packages_tabs, packages_tab_pane, packages_tag, packages_tree, packages_alert, slider, packages_icon, packages_row, packages_col, packages_upload, packages_progress, packages_spinner, badge, card, rate, packages_steps, packages_step, carousel, scrollbar, carousel_item, packages_collapse, packages_collapse_item, packages_cascader, color_picker, transfer, packages_container, header, aside, packages_main, footer, timeline, timeline_item, packages_link, divider, packages_image, calendar, backtop, page_header, packages_cascader_panel, avatar, drawer, popconfirm, collapse_transition_default.a];

var src_install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  lib_locale_default.a.use(opts.locale);
  lib_locale_default.a.i18n(opts.i18n);

  components.forEach(function (component) {
    Vue.component(component.name, component);
  });

  Vue.use(infinite_scroll);
  Vue.use(packages_loading.directive);

  Vue.prototype.$ELEMENT = {
    size: opts.size || '',
    zIndex: opts.zIndex || 2000
  };

  Vue.prototype.$loading = packages_loading.service;
  Vue.prototype.$msgbox = message_box;
  Vue.prototype.$alert = message_box.alert;
  Vue.prototype.$confirm = message_box.confirm;
  Vue.prototype.$prompt = message_box.prompt;
  Vue.prototype.$notify = notification;
  Vue.prototype.$message = packages_message;
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  src_install(window.Vue);
}

/* harmony default export */ var src_0 = __webpack_exports__["default"] = ({
  version: '2.13.1',
  locale: lib_locale_default.a.use,
  i18n: lib_locale_default.a.i18n,
  install: src_install,
  CollapseTransition: collapse_transition_default.a,
  Loading: packages_loading,
  Pagination: packages_pagination,
  Dialog: dialog,
  Autocomplete: packages_autocomplete,
  Dropdown: packages_dropdown,
  DropdownMenu: packages_dropdown_menu,
  DropdownItem: packages_dropdown_item,
  Menu: packages_menu,
  Submenu: packages_submenu,
  MenuItem: packages_menu_item,
  MenuItemGroup: packages_menu_item_group,
  Input: packages_input,
  InputNumber: packages_input_number,
  Radio: packages_radio,
  RadioGroup: packages_radio_group,
  RadioButton: packages_radio_button,
  Checkbox: packages_checkbox,
  CheckboxButton: packages_checkbox_button,
  CheckboxGroup: packages_checkbox_group,
  Switch: packages_switch,
  Select: packages_select,
  Option: packages_option,
  OptionGroup: packages_option_group,
  Button: packages_button,
  ButtonGroup: packages_button_group,
  Table: packages_table,
  TableColumn: packages_table_column,
  DatePicker: packages_date_picker,
  TimeSelect: packages_time_select,
  TimePicker: packages_time_picker,
  Popover: popover,
  Tooltip: packages_tooltip,
  MessageBox: message_box,
  Breadcrumb: packages_breadcrumb,
  BreadcrumbItem: packages_breadcrumb_item,
  Form: packages_form,
  FormItem: packages_form_item,
  Tabs: packages_tabs,
  TabPane: packages_tab_pane,
  Tag: packages_tag,
  Tree: packages_tree,
  Alert: packages_alert,
  Notification: notification,
  Slider: slider,
  Icon: packages_icon,
  Row: packages_row,
  Col: packages_col,
  Upload: packages_upload,
  Progress: packages_progress,
  Spinner: packages_spinner,
  Message: packages_message,
  Badge: badge,
  Card: card,
  Rate: rate,
  Steps: packages_steps,
  Step: packages_step,
  Carousel: carousel,
  Scrollbar: scrollbar,
  CarouselItem: carousel_item,
  Collapse: packages_collapse,
  CollapseItem: packages_collapse_item,
  Cascader: packages_cascader,
  ColorPicker: color_picker,
  Transfer: transfer,
  Container: packages_container,
  Header: header,
  Aside: aside,
  Main: packages_main,
  Footer: footer,
  Timeline: timeline,
  TimelineItem: timeline_item,
  Link: packages_link,
  Divider: divider,
  Image: packages_image,
  Calendar: calendar,
  Backtop: backtop,
  InfiniteScroll: infinite_scroll,
  PageHeader: page_header,
  CascaderPanel: packages_cascader_panel,
  Avatar: avatar,
  Drawer: drawer,
  Popconfirm: popconfirm
});

/***/ })
/******/ ])["default"];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _vue = __webpack_require__(11);var _vue2 = _interopRequireDefault(_vue);
var _vuex = __webpack_require__(9);var _vuex2 = _interopRequireDefault(_vuex);


var _appInfo = __webpack_require__(463);var _appInfo2 = _interopRequireDefault(_appInfo);
var _appTreeData = __webpack_require__(464);var _appTreeData2 = _interopRequireDefault(_appTreeData);
var _applicationLinkTree = __webpack_require__(465);var _applicationLinkTree2 = _interopRequireDefault(_applicationLinkTree);

var _formConfig = __webpack_require__(466);var _formConfig2 = _interopRequireDefault(_formConfig);
var _appItem = __webpack_require__(467);var _appItem2 = _interopRequireDefault(_appItem);

var _user = __webpack_require__(468);var _user2 = _interopRequireDefault(_user);
var _unit = __webpack_require__(208);var _unit2 = _interopRequireDefault(_unit);


var _getters = __webpack_require__(469);var _getters2 = _interopRequireDefault(_getters);
var _errLog = __webpack_require__(470);var _errLog2 = _interopRequireDefault(_errLog);
var _app = __webpack_require__(471);var _app2 = _interopRequireDefault(_app);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}_vue2.default.use(_vuex2.default);exports.default =


new _vuex2.default.Store({
  modules: {
    appInfo: _appInfo2.default,
    appTreeData: _appTreeData2.default,
    applicationLinkTree: _applicationLinkTree2.default,


    formConfig: _formConfig2.default,
    appItem: _appItem2.default,

    user: _user2.default,

    errLog: _errLog2.default,
    permission: {},
    app: _app2.default },

  getters: _getters2.default });

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var document = __webpack_require__(4).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(44);
var LIBRARY = __webpack_require__(68);
var wksExt = __webpack_require__(216);
var defineProperty = __webpack_require__(20).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(99)('keys');
var uid = __webpack_require__(74);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 146 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(4).document;
module.exports = document && document.documentElement;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(3);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(45)(Function.call, __webpack_require__(41).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var setPrototypeOf = __webpack_require__(148).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(47);
var defined = __webpack_require__(54);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 152 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 153 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(68);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(36);
var hide = __webpack_require__(35);
var Iterators = __webpack_require__(95);
var $iterCreate = __webpack_require__(155);
var setToStringTag = __webpack_require__(92);
var getPrototypeOf = __webpack_require__(42);
var ITERATOR = __webpack_require__(13)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(77);
var descriptor = __webpack_require__(73);
var setToStringTag = __webpack_require__(92);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(35)(IteratorPrototype, __webpack_require__(13)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(120);
var defined = __webpack_require__(54);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(13)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(95);
var ITERATOR = __webpack_require__(13)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(20);
var createDesc = __webpack_require__(73);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(93);
var ITERATOR = __webpack_require__(13)('iterator');
var Iterators = __webpack_require__(95);
module.exports = __webpack_require__(44).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(598);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(22);
var toAbsoluteIndex = __webpack_require__(76);
var toLength = __webpack_require__(14);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(70);
var step = __webpack_require__(233);
var Iterators = __webpack_require__(95);
var toIObject = __webpack_require__(40);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(154)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(102);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(119)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(45);
var invoke = __webpack_require__(223);
var html = __webpack_require__(147);
var cel = __webpack_require__(143);
var global = __webpack_require__(4);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(46)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var macrotask = __webpack_require__(166).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(46)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(27);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var DESCRIPTORS = __webpack_require__(17);
var LIBRARY = __webpack_require__(68);
var $typed = __webpack_require__(126);
var hide = __webpack_require__(35);
var redefineAll = __webpack_require__(82);
var fails = __webpack_require__(7);
var anInstance = __webpack_require__(80);
var toInteger = __webpack_require__(47);
var toLength = __webpack_require__(14);
var toIndex = __webpack_require__(243);
var gOPN = __webpack_require__(78).f;
var dP = __webpack_require__(20).f;
var arrayFill = __webpack_require__(162);
var setToStringTag = __webpack_require__(92);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _locale = __webpack_require__(113);

exports.default = {
  methods: {
    t: function t() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _locale.t.apply(this, args);
    }
  }
};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function () {
  if (_vue2.default.prototype.$isServer) return 0;
  if (scrollBarWidth !== undefined) return scrollBarWidth;

  var outer = document.createElement('div');
  outer.className = 'el-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';

  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;

  return scrollBarWidth;
};

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollBarWidth = void 0;

;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 76);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = __webpack_require__(253);

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = __webpack_require__(132);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(84);

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.type === "textarea" ? "el-textarea" : "el-input",
        _vm.inputSize ? "el-input--" + _vm.inputSize : "",
        {
          "is-disabled": _vm.inputDisabled,
          "is-exceed": _vm.inputExceed,
          "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
          "el-input-group--append": _vm.$slots.append,
          "el-input-group--prepend": _vm.$slots.prepend,
          "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
          "el-input--suffix":
            _vm.$slots.suffix ||
            _vm.suffixIcon ||
            _vm.clearable ||
            _vm.showPassword
        }
      ],
      on: {
        mouseenter: function($event) {
          _vm.hovering = true
        },
        mouseleave: function($event) {
          _vm.hovering = false
        }
      }
    },
    [
      _vm.type !== "textarea"
        ? [
            _vm.$slots.prepend
              ? _c(
                  "div",
                  { staticClass: "el-input-group__prepend" },
                  [_vm._t("prepend")],
                  2
                )
              : _vm._e(),
            _vm.type !== "textarea"
              ? _c(
                  "input",
                  _vm._b(
                    {
                      ref: "input",
                      staticClass: "el-input__inner",
                      attrs: {
                        tabindex: _vm.tabindex,
                        type: _vm.showPassword
                          ? _vm.passwordVisible
                            ? "text"
                            : "password"
                          : _vm.type,
                        disabled: _vm.inputDisabled,
                        readonly: _vm.readonly,
                        autocomplete: _vm.autoComplete || _vm.autocomplete,
                        "aria-label": _vm.label
                      },
                      on: {
                        compositionstart: _vm.handleCompositionStart,
                        compositionupdate: _vm.handleCompositionUpdate,
                        compositionend: _vm.handleCompositionEnd,
                        input: _vm.handleInput,
                        focus: _vm.handleFocus,
                        blur: _vm.handleBlur,
                        change: _vm.handleChange
                      }
                    },
                    "input",
                    _vm.$attrs,
                    false
                  )
                )
              : _vm._e(),
            _vm.$slots.prefix || _vm.prefixIcon
              ? _c(
                  "span",
                  { staticClass: "el-input__prefix" },
                  [
                    _vm._t("prefix"),
                    _vm.prefixIcon
                      ? _c("i", {
                          staticClass: "el-input__icon",
                          class: _vm.prefixIcon
                        })
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm.getSuffixVisible()
              ? _c("span", { staticClass: "el-input__suffix" }, [
                  _c(
                    "span",
                    { staticClass: "el-input__suffix-inner" },
                    [
                      !_vm.showClear ||
                      !_vm.showPwdVisible ||
                      !_vm.isWordLimitVisible
                        ? [
                            _vm._t("suffix"),
                            _vm.suffixIcon
                              ? _c("i", {
                                  staticClass: "el-input__icon",
                                  class: _vm.suffixIcon
                                })
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm.showClear
                        ? _c("i", {
                            staticClass:
                              "el-input__icon el-icon-circle-close el-input__clear",
                            on: {
                              mousedown: function($event) {
                                $event.preventDefault()
                              },
                              click: _vm.clear
                            }
                          })
                        : _vm._e(),
                      _vm.showPwdVisible
                        ? _c("i", {
                            staticClass:
                              "el-input__icon el-icon-view el-input__clear",
                            on: { click: _vm.handlePasswordVisible }
                          })
                        : _vm._e(),
                      _vm.isWordLimitVisible
                        ? _c("span", { staticClass: "el-input__count" }, [
                            _c(
                              "span",
                              { staticClass: "el-input__count-inner" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.textLength) +
                                    "/" +
                                    _vm._s(_vm.upperLimit) +
                                    "\n          "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm.validateState
                    ? _c("i", {
                        staticClass: "el-input__icon",
                        class: ["el-input__validateIcon", _vm.validateIcon]
                      })
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.$slots.append
              ? _c(
                  "div",
                  { staticClass: "el-input-group__append" },
                  [_vm._t("append")],
                  2
                )
              : _vm._e()
          ]
        : _c(
            "textarea",
            _vm._b(
              {
                ref: "textarea",
                staticClass: "el-textarea__inner",
                style: _vm.textareaStyle,
                attrs: {
                  tabindex: _vm.tabindex,
                  disabled: _vm.inputDisabled,
                  readonly: _vm.readonly,
                  autocomplete: _vm.autoComplete || _vm.autocomplete,
                  "aria-label": _vm.label
                },
                on: {
                  compositionstart: _vm.handleCompositionStart,
                  compositionupdate: _vm.handleCompositionUpdate,
                  compositionend: _vm.handleCompositionEnd,
                  input: _vm.handleInput,
                  focus: _vm.handleFocus,
                  blur: _vm.handleBlur,
                  change: _vm.handleChange
                }
              },
              "textarea",
              _vm.$attrs,
              false
            )
          ),
      _vm.isWordLimitVisible && _vm.type === "textarea"
        ? _c("span", { staticClass: "el-input__count" }, [
            _vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&

// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
var emitter_ = __webpack_require__(4);
var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

// EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
var migrating_ = __webpack_require__(11);
var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);

// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
var hiddenTextarea = void 0;

var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';

var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];

function calculateNodeStyling(targetElement) {
  var style = window.getComputedStyle(targetElement);

  var boxSizing = style.getPropertyValue('box-sizing');

  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));

  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));

  var contextStyle = CONTEXT_STYLE.map(function (name) {
    return name + ':' + style.getPropertyValue(name);
  }).join(';');

  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
}

function calcTextareaHeight(targetElement) {
  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  }

  var _calculateNodeStyling = calculateNodeStyling(targetElement),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      contextStyle = _calculateNodeStyling.contextStyle;

  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';

  var height = hiddenTextarea.scrollHeight;
  var result = {};

  if (boxSizing === 'border-box') {
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    height = height - paddingSize;
  }

  hiddenTextarea.value = '';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

  if (minRows !== null) {
    var minHeight = singleRowHeight * minRows;
    if (boxSizing === 'border-box') {
      minHeight = minHeight + paddingSize + borderSize;
    }
    height = Math.max(minHeight, height);
    result.minHeight = minHeight + 'px';
  }
  if (maxRows !== null) {
    var maxHeight = singleRowHeight * maxRows;
    if (boxSizing === 'border-box') {
      maxHeight = maxHeight + paddingSize + borderSize;
    }
    height = Math.min(maxHeight, height);
  }
  result.height = height + 'px';
  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
  hiddenTextarea = null;
  return result;
};
// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
var merge_ = __webpack_require__(9);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
var shared_ = __webpack_require__(21);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var inputvue_type_script_lang_js_ = ({
  name: 'ElInput',

  componentName: 'ElInput',

  mixins: [emitter_default.a, migrating_default.a],

  inheritAttrs: false,

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  data: function data() {
    return {
      textareaCalcStyle: {},
      hovering: false,
      focused: false,
      isComposing: false,
      passwordVisible: false
    };
  },


  props: {
    value: [String, Number],
    size: String,
    resize: String,
    form: String,
    disabled: Boolean,
    readonly: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    /** @Deprecated in next major version */
    autoComplete: {
      type: String,
      validator: function validator(val) {
         false && false;
        return true;
      }
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    suffixIcon: String,
    prefixIcon: String,
    label: String,
    clearable: {
      type: Boolean,
      default: false
    },
    showPassword: {
      type: Boolean,
      default: false
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    tabindex: String
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    validateState: function validateState() {
      return this.elFormItem ? this.elFormItem.validateState : '';
    },
    needStatusIcon: function needStatusIcon() {
      return this.elForm ? this.elForm.statusIcon : false;
    },
    validateIcon: function validateIcon() {
      return {
        validating: 'el-icon-loading',
        success: 'el-icon-circle-check',
        error: 'el-icon-circle-close'
      }[this.validateState];
    },
    textareaStyle: function textareaStyle() {
      return merge_default()({}, this.textareaCalcStyle, { resize: this.resize });
    },
    inputSize: function inputSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputDisabled: function inputDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    nativeInputValue: function nativeInputValue() {
      return this.value === null || this.value === undefined ? '' : String(this.value);
    },
    showClear: function showClear() {
      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
    },
    showPwdVisible: function showPwdVisible() {
      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
    },
    isWordLimitVisible: function isWordLimitVisible() {
      return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
    },
    upperLimit: function upperLimit() {
      return this.$attrs.maxlength;
    },
    textLength: function textLength() {
      if (typeof this.value === 'number') {
        return String(this.value).length;
      }

      return (this.value || '').length;
    },
    inputExceed: function inputExceed() {
      // show exceed style if length of initial value greater then maxlength
      return this.isWordLimitVisible && this.textLength > this.upperLimit;
    }
  },

  watch: {
    value: function value(val) {
      this.$nextTick(this.resizeTextarea);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [val]);
      }
    },

    // native input value is set explicitly
    // do not use v-model / :value in template
    // see: https://github.com/ElemeFE/element/issues/14521
    nativeInputValue: function nativeInputValue() {
      this.setNativeInputValue();
    },

    // when change between <input> and <textarea>,
    // update DOM dependent value and styles
    // https://github.com/ElemeFE/element/issues/14857
    type: function type() {
      var _this = this;

      this.$nextTick(function () {
        _this.setNativeInputValue();
        _this.resizeTextarea();
        _this.updateIconOffset();
      });
    }
  },

  methods: {
    focus: function focus() {
      this.getInput().focus();
    },
    blur: function blur() {
      this.getInput().blur();
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
          'on-icon-click': 'on-icon-click is removed.'
        },
        events: {
          'click': 'click is removed.'
        }
      };
    },
    handleBlur: function handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
      }
    },
    select: function select() {
      this.getInput().select();
    },
    resizeTextarea: function resizeTextarea() {
      if (this.$isServer) return;
      var autosize = this.autosize,
          type = this.type;

      if (type !== 'textarea') return;
      if (!autosize) {
        this.textareaCalcStyle = {
          minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
        };
        return;
      }
      var minRows = autosize.minRows;
      var maxRows = autosize.maxRows;

      this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
    },
    setNativeInputValue: function setNativeInputValue() {
      var input = this.getInput();
      if (!input) return;
      if (input.value === this.nativeInputValue) return;
      input.value = this.nativeInputValue;
    },
    handleFocus: function handleFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    handleCompositionStart: function handleCompositionStart() {
      this.isComposing = true;
    },
    handleCompositionUpdate: function handleCompositionUpdate(event) {
      var text = event.target.value;
      var lastCharacter = text[text.length - 1] || '';
      this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
    },
    handleCompositionEnd: function handleCompositionEnd(event) {
      if (this.isComposing) {
        this.isComposing = false;
        this.handleInput(event);
      }
    },
    handleInput: function handleInput(event) {
      // should not emit input during composition
      // see: https://github.com/ElemeFE/element/issues/10516
      if (this.isComposing) return;

      // hack for https://github.com/ElemeFE/element/issues/8548
      // should remove the following line when we don't support IE
      if (event.target.value === this.nativeInputValue) return;

      this.$emit('input', event.target.value);

      // ensure native input value is controlled
      // see: https://github.com/ElemeFE/element/issues/12850
      this.$nextTick(this.setNativeInputValue);
    },
    handleChange: function handleChange(event) {
      this.$emit('change', event.target.value);
    },
    calcIconOffset: function calcIconOffset(place) {
      var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
      if (!elList.length) return;
      var el = null;
      for (var i = 0; i < elList.length; i++) {
        if (elList[i].parentNode === this.$el) {
          el = elList[i];
          break;
        }
      }
      if (!el) return;
      var pendantMap = {
        suffix: 'append',
        prefix: 'prepend'
      };

      var pendant = pendantMap[place];
      if (this.$slots[pendant]) {
        el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
      } else {
        el.removeAttribute('style');
      }
    },
    updateIconOffset: function updateIconOffset() {
      this.calcIconOffset('prefix');
      this.calcIconOffset('suffix');
    },
    clear: function clear() {
      this.$emit('input', '');
      this.$emit('change', '');
      this.$emit('clear');
    },
    handlePasswordVisible: function handlePasswordVisible() {
      this.passwordVisible = !this.passwordVisible;
      this.focus();
    },
    getInput: function getInput() {
      return this.$refs.input || this.$refs.textarea;
    },
    getSuffixVisible: function getSuffixVisible() {
      return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
    }
  },

  created: function created() {
    this.$on('inputSelect', this.select);
  },
  mounted: function mounted() {
    this.setNativeInputValue();
    this.resizeTextarea();
    this.updateIconOffset();
  },
  updated: function updated() {
    this.$nextTick(this.updateIconOffset);
  }
});
// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/input/src/input.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_inputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/input/src/input.vue"
/* harmony default export */ var input = (component.exports);
// CONCATENATED MODULE: ./packages/input/index.js


/* istanbul ignore next */
input.install = function (Vue) {
  Vue.component(input.name, input);
};

/* harmony default export */ var packages_input = __webpack_exports__["default"] = (input);

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __webpack_require__(131);

/***/ })

/******/ });

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.removeResizeListener = exports.addResizeListener = undefined;

var _resizeObserverPolyfill = __webpack_require__(712);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = typeof window === 'undefined';

/* istanbul ignore next */
var resizeHandler = function resizeHandler(entries) {
  for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var entry = _ref;

    var listeners = entry.target.__resizeListeners__ || [];
    if (listeners.length) {
      listeners.forEach(function (fn) {
        fn();
      });
    }
  }
};

/* istanbul ignore next */
var addResizeListener = exports.addResizeListener = function addResizeListener(element, fn) {
  if (isServer) return;
  if (!element.__resizeListeners__) {
    element.__resizeListeners__ = [];
    element.__ro__ = new _resizeObserverPolyfill2.default(resizeHandler);
    element.__ro__.observe(element);
  }
  element.__resizeListeners__.push(fn);
};

/* istanbul ignore next */
var removeResizeListener = exports.removeResizeListener = function removeResizeListener(element, fn) {
  if (!element || !element.__resizeListeners__) return;
  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
  if (!element.__resizeListeners__.length) {
    element.__ro__.disconnect();
  }
};

/***/ }),
/* 174 */
/***/ (function(module, exports) {

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
module.exports = function ( delay, noTrailing, callback, debounceMode ) {

	// After wrapper has stopped being called, this timeout ensures that
	// `callback` is executed at the proper times in `throttle` and `end`
	// debounce modes.
	var timeoutID;

	// Keep track of the last time `callback` was executed.
	var lastExec = 0;

	// `noTrailing` defaults to falsy.
	if ( typeof noTrailing !== 'boolean' ) {
		debounceMode = callback;
		callback = noTrailing;
		noTrailing = undefined;
	}

	// The `wrapper` function encapsulates all of the throttling / debouncing
	// functionality and when executed will limit the rate at which `callback`
	// is executed.
	function wrapper () {

		var self = this;
		var elapsed = Number(new Date()) - lastExec;
		var args = arguments;

		// Execute `callback` and update the `lastExec` timestamp.
		function exec () {
			lastExec = Number(new Date());
			callback.apply(self, args);
		}

		// If `debounceMode` is true (at begin) this is used to clear the flag
		// to allow future `callback` executions.
		function clear () {
			timeoutID = undefined;
		}

		if ( debounceMode && !timeoutID ) {
			// Since `wrapper` is being called for the first time and
			// `debounceMode` is true (at begin), execute `callback`.
			exec();
		}

		// Clear any existing timeout.
		if ( timeoutID ) {
			clearTimeout(timeoutID);
		}

		if ( debounceMode === undefined && elapsed > delay ) {
			// In throttle mode, if `delay` time has been exceeded, execute
			// `callback`.
			exec();

		} else if ( noTrailing !== true ) {
			// In trailing throttle mode, since `delay` time has not been
			// exceeded, schedule `callback` to execute `delay` ms after most
			// recent execution.
			//
			// If `debounceMode` is true (at begin), schedule `clear` to execute
			// after `delay` ms.
			//
			// If `debounceMode` is false (at end), schedule `callback` to
			// execute after `delay` ms.
			timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
		}

	}

	// Return the wrapper function.
	return wrapper;

};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 127);
/******/ })
/************************************************************************/
/******/ ({

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
var resize_event_ = __webpack_require__(16);

// EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
var scrollbar_width_ = __webpack_require__(39);
var scrollbar_width_default = /*#__PURE__*/__webpack_require__.n(scrollbar_width_);

// EXTERNAL MODULE: external "element-ui/lib/utils/util"
var util_ = __webpack_require__(3);

// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
var dom_ = __webpack_require__(2);

// CONCATENATED MODULE: ./packages/scrollbar/src/util.js
var BAR_MAP = {
  vertical: {
    offset: 'offsetHeight',
    scroll: 'scrollTop',
    scrollSize: 'scrollHeight',
    size: 'height',
    key: 'vertical',
    axis: 'Y',
    client: 'clientY',
    direction: 'top'
  },
  horizontal: {
    offset: 'offsetWidth',
    scroll: 'scrollLeft',
    scrollSize: 'scrollWidth',
    size: 'width',
    key: 'horizontal',
    axis: 'X',
    client: 'clientX',
    direction: 'left'
  }
};

function renderThumbStyle(_ref) {
  var move = _ref.move,
      size = _ref.size,
      bar = _ref.bar;

  var style = {};
  var translate = 'translate' + bar.axis + '(' + move + '%)';

  style[bar.size] = size;
  style.transform = translate;
  style.msTransform = translate;
  style.webkitTransform = translate;

  return style;
};
// CONCATENATED MODULE: ./packages/scrollbar/src/bar.js



/* istanbul ignore next */
/* harmony default export */ var src_bar = ({
  name: 'Bar',

  props: {
    vertical: Boolean,
    size: String,
    move: Number
  },

  computed: {
    bar: function bar() {
      return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
    },
    wrap: function wrap() {
      return this.$parent.wrap;
    }
  },

  render: function render(h) {
    var size = this.size,
        move = this.move,
        bar = this.bar;


    return h(
      'div',
      {
        'class': ['el-scrollbar__bar', 'is-' + bar.key],
        on: {
          'mousedown': this.clickTrackHandler
        }
      },
      [h('div', {
        ref: 'thumb',
        'class': 'el-scrollbar__thumb',
        on: {
          'mousedown': this.clickThumbHandler
        },

        style: renderThumbStyle({ size: size, move: move, bar: bar }) })]
    );
  },


  methods: {
    clickThumbHandler: function clickThumbHandler(e) {
      // prevent click event of right button
      if (e.ctrlKey || e.button === 2) {
        return;
      }
      this.startDrag(e);
      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
    },
    clickTrackHandler: function clickTrackHandler(e) {
      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];

      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    startDrag: function startDrag(e) {
      e.stopImmediatePropagation();
      this.cursorDown = true;

      Object(dom_["on"])(document, 'mousemove', this.mouseMoveDocumentHandler);
      Object(dom_["on"])(document, 'mouseup', this.mouseUpDocumentHandler);
      document.onselectstart = function () {
        return false;
      };
    },
    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
      if (this.cursorDown === false) return;
      var prevPage = this[this.bar.axis];

      if (!prevPage) return;

      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];

      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
      this.cursorDown = false;
      this[this.bar.axis] = 0;
      Object(dom_["off"])(document, 'mousemove', this.mouseMoveDocumentHandler);
      document.onselectstart = null;
    }
  },

  destroyed: function destroyed() {
    Object(dom_["off"])(document, 'mouseup', this.mouseUpDocumentHandler);
  }
});
// CONCATENATED MODULE: ./packages/scrollbar/src/main.js
// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js






/* istanbul ignore next */
/* harmony default export */ var main = ({
  name: 'ElScrollbar',

  components: { Bar: src_bar },

  props: {
    native: Boolean,
    wrapStyle: {},
    wrapClass: {},
    viewClass: {},
    viewStyle: {},
    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
    tag: {
      type: String,
      default: 'div'
    }
  },

  data: function data() {
    return {
      sizeWidth: '0',
      sizeHeight: '0',
      moveX: 0,
      moveY: 0
    };
  },


  computed: {
    wrap: function wrap() {
      return this.$refs.wrap;
    }
  },

  render: function render(h) {
    var gutter = scrollbar_width_default()();
    var style = this.wrapStyle;

    if (gutter) {
      var gutterWith = '-' + gutter + 'px';
      var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';

      if (Array.isArray(this.wrapStyle)) {
        style = Object(util_["toObject"])(this.wrapStyle);
        style.marginRight = style.marginBottom = gutterWith;
      } else if (typeof this.wrapStyle === 'string') {
        style += gutterStyle;
      } else {
        style = gutterStyle;
      }
    }
    var view = h(this.tag, {
      class: ['el-scrollbar__view', this.viewClass],
      style: this.viewStyle,
      ref: 'resize'
    }, this.$slots.default);
    var wrap = h(
      'div',
      {
        ref: 'wrap',
        style: style,
        on: {
          'scroll': this.handleScroll
        },

        'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] },
      [[view]]
    );
    var nodes = void 0;

    if (!this.native) {
      nodes = [wrap, h(src_bar, {
        attrs: {
          move: this.moveX,
          size: this.sizeWidth }
      }), h(src_bar, {
        attrs: {
          vertical: true,
          move: this.moveY,
          size: this.sizeHeight }
      })];
    } else {
      nodes = [h(
        'div',
        {
          ref: 'wrap',
          'class': [this.wrapClass, 'el-scrollbar__wrap'],
          style: style },
        [[view]]
      )];
    }
    return h('div', { class: 'el-scrollbar' }, nodes);
  },


  methods: {
    handleScroll: function handleScroll() {
      var wrap = this.wrap;

      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
    },
    update: function update() {
      var heightPercentage = void 0,
          widthPercentage = void 0;
      var wrap = this.wrap;
      if (!wrap) return;

      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;

      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
    }
  },

  mounted: function mounted() {
    if (this.native) return;
    this.$nextTick(this.update);
    !this.noresize && Object(resize_event_["addResizeListener"])(this.$refs.resize, this.update);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.native) return;
    !this.noresize && Object(resize_event_["removeResizeListener"])(this.$refs.resize, this.update);
  }
});
// CONCATENATED MODULE: ./packages/scrollbar/index.js


/* istanbul ignore next */
main.install = function (Vue) {
  Vue.component(main.name, main);
};

/* harmony default export */ var scrollbar = __webpack_exports__["default"] = (main);

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __webpack_require__(173);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(63);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(52);

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = __webpack_require__(171);

/***/ })

/******/ });

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (ref) {
  return {
    methods: {
      focus: function focus() {
        this.$refs[ref].focus();
      }
    }
  };
};

;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = scrollIntoView;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollIntoView(container, selected) {
  if (_vue2.default.prototype.$isServer) return;

  if (!selected) {
    container.scrollTop = 0;
    return;
  }

  var offsetParents = [];
  var pointer = selected.offsetParent;
  while (pointer && container !== pointer && container.contains(pointer)) {
    offsetParents.push(pointer);
    pointer = pointer.offsetParent;
  }
  var top = selected.offsetTop + offsetParents.reduce(function (prev, curr) {
    return prev + curr.offsetTop;
  }, 0);
  var bottom = top + selected.offsetHeight;
  var viewRectTop = container.scrollTop;
  var viewRectBottom = viewRectTop + container.clientHeight;

  if (top < viewRectTop) {
    container.scrollTop = top;
  } else if (bottom > viewRectBottom) {
    container.scrollTop = bottom - container.clientHeight;
  }
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var aria = aria || {};

aria.Utils = aria.Utils || {};

/**
 * @desc Set focus on descendant nodes until the first focusable element is
 *       found.
 * @param element
 *          DOM node for which to find the first focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */
aria.Utils.focusFirstDescendant = function (element) {
  for (var i = 0; i < element.childNodes.length; i++) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Find the last descendant node that is focusable.
 * @param element
 *          DOM node for which to find the last focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */

aria.Utils.focusLastDescendant = function (element) {
  for (var i = element.childNodes.length - 1; i >= 0; i--) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Set Attempt to set focus on the current node.
 * @param element
 *          The node to attempt to focus on.
 * @returns
 *  true if element is focused.
 */
aria.Utils.attemptFocus = function (element) {
  if (!aria.Utils.isFocusable(element)) {
    return false;
  }
  aria.Utils.IgnoreUtilFocusChanges = true;
  try {
    element.focus();
  } catch (e) {}
  aria.Utils.IgnoreUtilFocusChanges = false;
  return document.activeElement === element;
};

aria.Utils.isFocusable = function (element) {
  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
    return true;
  }

  if (element.disabled) {
    return false;
  }

  switch (element.nodeName) {
    case 'A':
      return !!element.href && element.rel !== 'ignore';
    case 'INPUT':
      return element.type !== 'hidden' && element.type !== 'file';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
};

/**
 * 触发一个事件
 * mouseenter, mouseleave, mouseover, keyup, change, click 等
 * @param  {Element} elm
 * @param  {String} name
 * @param  {*} opts
 */
aria.Utils.triggerEvent = function (elm, name) {
  var eventName = void 0;

  if (/^mouse|click/.test(name)) {
    eventName = 'MouseEvents';
  } else if (/^key/.test(name)) {
    eventName = 'KeyboardEvent';
  } else {
    eventName = 'HTMLEvents';
  }
  var evt = document.createEvent(eventName);

  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    opts[_key - 2] = arguments[_key];
  }

  evt.initEvent.apply(evt, [name].concat(opts));
  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);

  return elm;
};

aria.Utils.keys = {
  tab: 9,
  enter: 13,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  esc: 27
};

exports.default = aria.Utils;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(50);
var document = __webpack_require__(29).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(50);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(107);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 182 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(185)('keys');
var uid = __webpack_require__(135);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(18);
var global = __webpack_require__(29);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(108) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 186 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 187 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(108);
var $export = __webpack_require__(28);
var redefine = __webpack_require__(260);
var hide = __webpack_require__(71);
var Iterators = __webpack_require__(97);
var $iterCreate = __webpack_require__(738);
var setToStringTag = __webpack_require__(109);
var getPrototypeOf = __webpack_require__(262);
var ITERATOR = __webpack_require__(30)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(30);


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(135)('meta');
var isObject = __webpack_require__(50);
var has = __webpack_require__(86);
var setDesc = __webpack_require__(49).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(85)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var core = __webpack_require__(18);
var LIBRARY = __webpack_require__(108);
var wksExt = __webpack_require__(189);
var defineProperty = __webpack_require__(49).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(136);
var createDesc = __webpack_require__(105);
var toIObject = __webpack_require__(87);
var toPrimitive = __webpack_require__(180);
var has = __webpack_require__(86);
var IE8_DOM_DEFINE = __webpack_require__(258);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(51) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 193 */
/***/ (function(module, exports) {



/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(28);
var core = __webpack_require__(18);
var fails = __webpack_require__(85);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(138);
var ITERATOR = __webpack_require__(30)('iterator');
var Iterators = __webpack_require__(97);
module.exports = __webpack_require__(18).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(104);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(71);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(43);
var normalizeHeaderName = __webpack_require__(829);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(295);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(295);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(213)))

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6aa263e2_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(920);
function injectStyle (ssrContext) {
  __webpack_require__(919)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6aa263e2_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (str) {
  return str.split(",").reduce(function (p, c, i, a) {
    p[c] = true;
    return p;
  }, {});
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =

pannable;var _index = __webpack_require__(66);var _index2 = _interopRequireDefault(_index);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function pannable(el, onPan, onPanStart, onPanEnd) {
  var panOrig = void 0,panLastPosition = void 0,panning = void 0,panningTarget = void 0,panOffset = void 0;

  function handleMouseDown(e) {
    var el = _index2.default.closest(e.target, ".pannable");

    if (el) {
      e.preventDefault();
      panOrig = {
        x: e.clientX,
        y: e.clientY };

      panLastPosition = {
        x: e.clientX,
        y: e.clientY };

      var box = el.getBoundingClientRect();
      panOffset = {
        x: box.left + box.width / 2 - e.clientX,
        y: box.top + box.height / 2 - e.clientY };

      panningTarget = el;
      document.addEventListener("mousemove", handleMouseMove, false);
      document.addEventListener("mouseup", handleMouseUp, false);
    }

  }

  function handleMouseMove(e) {
    if (
    !panning &&

    Math.max(
    Math.abs(panOrig.x - e.clientX),
    Math.abs(panOrig.y - e.clientY)) >
    2) {
      panning = true;

      var _el = panningTarget;

      onPanStart(e.clientX, e.clientY, e, panningTarget, panOffset);
      return;
    }

    if (panning) {
      var dx = e.clientX - panLastPosition.x,
      dy = e.clientY - panLastPosition.y;
      panLastPosition = {
        x: e.clientX,
        y: e.clientY };

      onPan(dx, dy, e.clientX, e.clientY, e, panningTarget, panOffset);
    }
  }

  function handleMouseUp(e) {
    panOrig = { x: 0, y: 0 };
    document.removeEventListener("mousemove", handleMouseMove, false);
    document.removeEventListener("mouseup", handleMouseUp, false);
    if (panning) {
      onPanEnd(e, panningTarget);
    }
    panning = false;
  }

  el.addEventListener("mousedown", handleMouseDown, false);

  return function unpannable() {
    el.removeEventListener("mousedown", handleMouseDown, false);
  };
}

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_simplePagination_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_simplePagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_simplePagination_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_simplePagination_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_simplePagination_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_eae94540_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_simplePagination_vue__ = __webpack_require__(1103);
function injectStyle (ssrContext) {
  __webpack_require__(1102)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_simplePagination_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_eae94540_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_simplePagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_allManSelect_vue__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_allManSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_allManSelect_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_allManSelect_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_allManSelect_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_a1d73d88_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_allManSelect_vue__ = __webpack_require__(1120);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_allManSelect_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_a1d73d88_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_allManSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 205 */,
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);
var _axios = __webpack_require__(114);var _axios2 = _interopRequireDefault(_axios);
var _token = __webpack_require__(25);var _token2 = _interopRequireDefault(_token);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var base = window.$servicePath;exports.default =

{



  saveFormData: function saveFormData(params) {
    return _util2.default.ajax(base + '/api/data/saveFormData', params);
  },
  markDeleteFormData: function markDeleteFormData(params) {
    return _util2.default.ajax(base + '/api/data/markDeleteFormData', params);
  },
  markDeleteFormDataReleaseWH: function markDeleteFormDataReleaseWH(params) {
    return _util2.default.ajax(base + '/api/data/markDeleteFormDataReleaseWH', params, true);
  },
  restoreDeletedFormData: function restoreDeletedFormData(params) {
    return _util2.default.ajax(base + '/api/data/restoreDeletedFormData', params);
  },
  deleteFormData: function deleteFormData(params) {
    return _util2.default.ajax(base + '/api/data/deleteFormData', params);
  },





  getFormData: function getFormData(params) {
    return _util2.default.ajax(base + '/api/data/getFormData', params);
  },

  getFormDataByModule: function getFormDataByModule(params) {
    return _util2.default.ajax(base + '/api/data/getFormDataByModule', params);
  },


  changeFormVersion: function changeFormVersion(params) {
    return _util2.default.ajax(base + '/api/data/changeFormVersion', params);
  },

  listFormData: function listFormData(params) {
    return _util2.default.ajax(base + '/api/data/listFormData', params);
  },





  listDocData: function listDocData(params) {
    return _util2.default.ajax(base + '/api/data/listDocData', params);
  },








  saveDict: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(params) {var formData, name;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:

              formData = new FormData();
              for (name in params) {
                if (params.hasOwnProperty(name)) {
                  formData.append(name, params[name]);
                }
              }_context.next = 4;return (
                _axios2.default.post(base + '/api/data/saveDict', formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data' } }));case 4:return _context.abrupt('return', _context.sent.


              data);case 5:case 'end':return _context.stop();}}}, _callee, this);}));function saveDict(_x) {return _ref.apply(this, arguments);}return saveDict;}(),








  deleteDict: function deleteDict(ids) {var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _util2.default.ajax(base + '/api/data/deleteDict', (0, _extends3.default)({ ids: ids }, params));
  },







  getDict: function getDict(id) {var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _util2.default.ajax(base + '/api/data/getDict', (0, _extends3.default)({ id: id }, params));
  },







  getDictByCode: function getDictByCode(code) {
    return _util2.default.ajax(base + '/api/data/getDictByCode', code);
  },










  listDictByApp: function listDictByApp(params) {
    return _util2.default.ajax(base + '/api/data/listDictByApp', params);
  },









  listDict: function listDict(params) {
    return _util2.default.ajax(base + '/api/data/listDict', params);
  },









  listDictTree: function listDictTree(params) {
    return _util2.default.ajax(base + '/api/data/listDictTree', params);
  },





  listWorkTime: function listWorkTime(params) {
    return _util2.default.ajax(base + '/api/data/listWorkTime', params);
  },
  saveWorkTime: function saveWorkTime(data) {
    return _util2.default.ajax(base + '/api/data/saveWorkTime', data);
  },
  deleteWorkTime: function deleteWorkTime(ids) {
    return _util2.default.ajax(base + '/api/data/deleteWorkTime', ids);
  },
  setDefaultWorkTime: function setDefaultWorkTime(id) {
    return _util2.default.ajax(base + '/api/data/setDefaultWorkTime', id);
  },
  getWorkTime: function getWorkTime(id) {
    return _util2.default.ajax(base + '/api/data/getWorkTime', id);
  },


  getTransferSet: function getTransferSet(id) {
    return _util2.default.ajax(base + '/api/data/getTransferSet', id);
  },
  getTransferSetJob: function getTransferSetJob(id) {
    return _util2.default.ajax(base + '/api/data/getTransferSetJob', id);
  },
  saveTransferSet: function saveTransferSet(params) {
    return _util2.default.ajax(base + '/api/data/saveTransferSet', params);
  },
  listTransferSet: function listTransferSet(params) {
    return _util2.default.ajax(base + '/api/data/listTransferSet', params);
  },
  deleteTransferSet: function deleteTransferSet(ids) {
    return _util2.default.ajax(base + '/api/data/deleteTransferSet', ids);
  },
  getImportLog: function getImportLog(id) {
    return _util2.default.ajax(base + '/api/data/getImportLog', id);
  },
  listImportLog: function listImportLog(params) {
    return _util2.default.ajax(base + '/api/data/listImportLog', params);
  },
  listImportItemLog: function listImportItemLog(params) {
    return _util2.default.ajax(base + '/api/data/listImportItemLog', params);
  },
  getImportItemLog: function getImportItemLog(id) {
    return _util2.default.ajax(base + '/api/data/getImportItemLog', id);
  },
  deleteImportItemLog: function deleteImportItemLog(ids) {
    return _util2.default.ajax(base + '/api/data/deleteImportItemLog', ids);
  },
  getTransferDataSource: function getTransferDataSource(id) {
    return _util2.default.ajax(base + '/api/data/getTransferDataSource', id);
  },
  saveTransferDataSource: function saveTransferDataSource(params) {
    return _util2.default.ajax(base + '/api/data/saveTransferDataSource', params);
  },
  listTransferDataSource: function listTransferDataSource(params) {
    return _util2.default.ajax(base + '/api/data/listTransferDataSource', params);
  },
  deleteTransferDataSource: function deleteTransferDataSource(ids) {
    return _util2.default.ajax(base + '/api/data/deleteTransferDataSource', ids);
  },
  importOrganize: function importOrganize(params) {
    return _util2.default.ajax(base + '/api/data/importOrganize', params);
  },
  importProcessDefinition: function importProcessDefinition(params) {
    return _util2.default.ajax(base + '/api/data/importProcessDefinition', params);
  },
  importDocument: function importDocument(params) {
    return _util2.default.ajax(base + '/api/data/importDocument', params);
  },
  reImportDocument: function reImportDocument(params) {
    return _util2.default.ajax(base + '/api/data/reImportDocument', params);
  },
  getFormDataById: function getFormDataById() {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}
    return _util2.default.ajax.apply(_util2.default, [base + '/api/data/getFormDataById'].concat(args));
  },
  migrateProcess: function migrateProcess(params) {
    return _util2.default.ajax(base + '/api/data/migrateProcess', params);
  },








  saveSysDic: function () {var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(params) {var formData, name;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
              formData = new FormData();
              for (name in params) {
                if (params.hasOwnProperty(name)) {
                  formData.append(name, params[name]);
                }
              }_context2.next = 4;return (
                _axios2.default.post(base + '/api/data/saveSysDic', formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data' } }));case 4:return _context2.abrupt('return', _context2.sent.


              data);case 5:case 'end':return _context2.stop();}}}, _callee2, this);}));function saveSysDic(_x4) {return _ref2.apply(this, arguments);}return saveSysDic;}(),

  saveSysFormDic: function saveSysFormDic(params) {
    return _util2.default.ajax(base + '/api/data/saveSysFormDic', params);
  },
  getSysFormDic: function getSysFormDic() {
    return _util2.default.ajax(base + '/api/data/getSysFormDic');
  },
  getSysDicByCode: function getSysDicByCode(code) {
    return _util2.default.ajax(base + '/api/data/getSysDicByCode', code);
  },
  saveServiceDic: function saveServiceDic(params) {
    return _util2.default.ajax(base + '/api/data/saveServiceDic', params);
  },
  getServiceDic: function getServiceDic() {
    return _util2.default.ajax(base + '/api/data/getServiceDic');
  },







  deleteSysDic: function deleteSysDic(ids) {
    return _util2.default.ajax(base + '/api/data/deleteSysDic', ids);
  },






  getSysDic: function getSysDic(id) {
    return _util2.default.ajax(base + '/api/data/getSysDic', id);
  },








  listSysDic: function listSysDic(params) {
    return _util2.default.ajax(base + '/api/data/listSysDic', params);
  },








  listSysDicTree: function listSysDicTree(params) {
    return _util2.default.ajax(base + '/api/data/listSysDicTree', params);
  } };

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var base = window.$servicePath;exports.default =



{





    authenticate: function authenticate(name, password, forceLogin) {
        var s = window.localStorage.getItem("$customSessionId");
        if (forceLogin) {
            return _util2.default.ajax("/authenticate", { u: name, p: password, forceLogin: true, s: s });
        }
        return _util2.default.ajax("/authenticate", { u: name, p: password, s: s });
    },

    authenticateDev: function authenticateDev(name, password, forceLogin) {
        var s = window.localStorage.getItem("$customSessionId");
        if (forceLogin) {
            return _util2.default.ajax("/authenticate", { u: name, p: password, dev: true, forceLogin: true, s: s });
        }
        return _util2.default.ajax("/authenticate", { u: name, p: password, dev: true, s: s });
    },

    loginOut: function loginOut() {
        return _util2.default.ajax("/logout");
    },

    clearSession: function clearSession() {
        return _util2.default.ajax("/clearSession");
    },










    listUser: function listUser(params) {
        return _util2.default.ajax(base + "/api/org/listUser", params.departmentId);
    },








    listUserPaging: function listUserPaging(params) {
        return _util2.default.ajax(base + "/api/org/listUserPaging", params, params.start, params.limit);
    },








    listGroupPagingByAuthType: function listGroupPagingByAuthType(params) {
        params.type = 'auth';
        return _util2.default.ajax(base + "/api/org/listGroupPaging", params, params.start, params.limit);
    },






    getUsers: function getUsers(ids) {
        return _util2.default.ajax(base + "/api/org/getUsers", ids);
    },

    checkToken: function checkToken(ids) {
        return _util2.default.ajax(base + "/api/org/checkToken");
    },






    getUser: function getUser(id) {
        return _util2.default.ajax(base + "/api/org/getUser", id);
    },





    updateUserInfo: function updateUserInfo(params) {
        return _util2.default.ajax(base + "/api/org/updateUserInfo", params);
    },

    updateUserSession: function updateUserSession() {
        return _util2.default.ajax(base + "/api/org/updateUserSession");
    },

    updateUserSessionByDepartmentId: function updateUserSessionByDepartmentId(departmentId) {
        return _util2.default.ajax(base + "/api/org/updateUserSessionByDepartmentId", departmentId);
    },




    loginUserInfo: function loginUserInfo() {
        return _util2.default.ajax(base + "/api/org/loginUserInfo");
    },







    saveUser: function saveUser(params) {
        return _util2.default.ajax(base + "/api/org/saveUser", params);
    },

    updateUserPassword: function updateUserPassword(oldpassword, password) {
        return _util2.default.ajax(base + "/api/org/updateUserPassword", oldpassword, password);
    },







    deleteUser: function deleteUser(userIds) {
        return _util2.default.ajax(base + "/api/org/deleteUser", userIds);
    },








    saveDepartment: function saveDepartment(params) {
        return _util2.default.ajax(base + "/api/org/saveDepartment", params);
    },







    changeDepartmentUser: function changeDepartmentUser(fromDepartmentId, toDepartmentId, userIds) {
        return _util2.default.ajax(base + "/api/org/changeDepartmentUser", fromDepartmentId, toDepartmentId, userIds);
    },






    addDepartmentUser: function addDepartmentUser(departmentId, userIds) {
        return _util2.default.ajax(base + "/api/org/addDepartmentUser", departmentId, userIds);
    },






    listDepartment: function listDepartment(parentId) {
        return _util2.default.ajax(base + "/api/org/listDepartment", parentId);
    },






    listDepartmentListAble: function listDepartmentListAble(parentId) {
        return _util2.default.ajax(base + "/api/org/listDepartmentListAble", parentId);
    },







    listChildDepartment: function listChildDepartment(params) {
        return _util2.default.ajax(base + "/api/org/listChildDepartment", params);
    },

    getUserDepartment: function getUserDepartment(userId) {
        return _util2.default.ajax(base + "/api/org/getUserDepartment", userId);
    },





    getDepartment: function getDepartment(id) {
        return _util2.default.ajax(base + "/api/org/getDepartment", id);
    },






    deleteDepartment: function deleteDepartment(departmentIds) {
        return _util2.default.ajax(base + "/api/org/deleteDepartment", departmentIds);
    },








    deleteDepartmentUser: function deleteDepartmentUser(departmentId, userIds) {
        return _util2.default.ajax(base + "/api/org/deleteDepartmentUser", departmentId, userIds);
    },







    deleteDepartmentAdminUser: function deleteDepartmentAdminUser(departmentId, userIds) {
        return _util2.default.ajax(base + "/api/org/deleteDepartmentAdminUser", departmentId, userIds);
    },







    addDepartmentAdminUser: function addDepartmentAdminUser(departmentId, userIds) {
        return _util2.default.ajax(base + "/api/org/addDepartmentAdminUser", departmentId, userIds);
    },






    deleteOwnerAdminUser: function deleteOwnerAdminUser(userId) {
        return _util2.default.ajax(base + "/api/org/deleteOwnerAdminUser", userId);
    },





    addOwnerAdminUser: function addOwnerAdminUser(userId) {
        return _util2.default.ajax(base + "/api/org/addOwnerAdminUser", userId);
    },





    deleteSystemAdminUser: function deleteSystemAdminUser(userId) {
        return _util2.default.ajax(base + "/api/org/deleteSystemAdminUser", userId);
    },





    addSystemAdminUser: function addSystemAdminUser(userId) {
        return _util2.default.ajax(base + "/api/org/addSystemAdminUser", userId);
    },








    listDepartmentUserPaging: function listDepartmentUserPaging(params) {
        return _util2.default.ajax(base + "/api/org/listDepartmentUserPaging", params.departmentId, params, params.start, params.limit);
    },

    listDepartmentAdminUser: function listDepartmentAdminUser(params) {
        return _util2.default.ajax(base + "/api/org/listDepartmentAdminUser", params.departmentId, null);
    },




    listRole: function listRole(params) {
        return _util2.default.ajax(base + "/api/org/listRole", params);
    },




    saveRole: function saveRole(params) {
        return _util2.default.ajax(base + "/api/org/saveRole", params);
    },

    getRoles: function getRoles(ids) {
        return _util2.default.ajax(base + "/api/org/getRoles", ids);
    },

    getRole: function getRole(id) {
        return _util2.default.ajax(base + "/api/org/getRole", id);
    },

    getIdentity: function getIdentity(id) {
        return _util2.default.ajax(base + "/api/org/getIdentity", id);
    },

    getRoleIdentity: function getRoleIdentity(id) {
        return _util2.default.ajax(base + "/api/org/getRoleIdentity", id);
    },

    listRoleIdentityIdsByRoleIds: function listRoleIdentityIdsByRoleIds(ids) {
        return _util2.default.ajax(base + "/api/org/listRoleIdentityIdsByRoleIds", ids);
    },








    getDepartmentTypeIdentity: function getDepartmentTypeIdentity(id, type, objId) {
        return _util2.default.ajax(base + "/api/org/getDepartmentTypeIdentity", id, type, objId);
    },

    listDepartmentAndCount: function listDepartmentAndCount(parentId) {
        return _util2.default.ajax(base + "/api/org/listDepartmentAndCount", parentId);
    },






    listDepartmentUserGroup: function listDepartmentUserGroup(identityId) {
        return _util2.default.ajax(base + "/api/org/listDepartmentUserGroup", identityId);
    },






    listDepartmentUserRole: function listDepartmentUserRole(identityId) {
        return _util2.default.ajax(base + "/api/org/listDepartmentUserRole", identityId);
    },







    listDepartmentUserRoleByType: function listDepartmentUserRoleByType(identityId, type) {
        return _util2.default.ajax(base + "/api/org/listDepartmentUserRoleByType", identityId, type);
    },






    addDepartmentUserGroup: function addDepartmentUserGroup(identityId, groupIds) {
        return _util2.default.ajax(base + "/api/org/addDepartmentUserGroup", identityId, groupIds);
    },






    deleteDepartmentUserGroup: function deleteDepartmentUserGroup(identityId, groupIds) {
        return _util2.default.ajax(base + "/api/org/deleteDepartmentUserGroup", identityId, groupIds);
    },





    deleteRole: function deleteRole(ids) {
        return _util2.default.ajax(base + "/api/org/deleteRole", ids);
    },




    deleteRoleByCate: function deleteRoleByCate(ids) {
        return _util2.default.ajax(base + "/api/org/deleteRoleByCate", ids);
    },






    listGroupedRole: function listGroupedRole(params) {
        return _util2.default.ajax(base + "/api/org/listGroupedRole", params);
    },


    getGroups: function getGroups(ids) {
        return _util2.default.ajax(base + "/api/org/getGroups", ids);
    },

    getGroup: function getGroup(id) {
        return _util2.default.ajax(base + "/api/org/getGroup", id);
    },




    saveGroup: function saveGroup(params) {
        params.type = 'auth';
        return _util2.default.ajax(base + "/api/org/saveGroup", params);
    },






    deleteGroup: function deleteGroup(ids) {
        return _util2.default.ajax(base + "/api/org/deleteGroup", ids);
    },






    deleteGroupByUnit: function deleteGroupByUnit(ids) {
        return _util2.default.ajax(base + "/api/org/deleteGroupByUnit", ids);
    },







    listGroupedGroup: function listGroupedGroup(params) {
        return _util2.default.ajax(base + "/api/org/listGroupedGroup", params);
    },







    getGroupTree: function getGroupTree(unitId) {
        return _util2.default.ajax(base + "/api/org/getGroupTree", unitId);
    },





    getUnitTree: function getUnitTree(parentId) {
        return _util2.default.ajax(base + "/api/org/getUnitTree", parentId);
    },
    getUnitById: function getUnitById(id) {
        return _util2.default.ajax(base + "/api/org/getUnitById", id);
    },
    clearUserbindIp: function clearUserbindIp(userids) {
        return _util2.default.ajax(base + "/api/org/clearUserbindIp", userids);
    },
    getPYIndexStr: function getPYIndexStr(name) {
        return _util2.default.ajax(base + "/api/org/getPYIndexStr", name);
    },
    getLoginUserUnitDepartments: function getLoginUserUnitDepartments() {
        return _util2.default.ajax(base + "/api/org/getLoginUserUnitDepartments");
    },

    getCurrent: function getCurrent(params) {
        return _util2.default.ajax(base + "/api/orgsel/getCurrent", params);
    },

    orderDepartmentUsers: function orderDepartmentUsers(departmentId) {
        return _util2.default.ajax(base + "/api/org/orderDepartmentUsers", departmentId);
    },

    orderUsers: function orderUsers(userSns, departmentId) {
        return _util2.default.ajax(base + "/api/org/orderUsers", userSns, departmentId);
    },

    orderUserTop: function orderUserTop(userId, departmentId) {
        return _util2.default.ajax(base + "/api/org/orderUserTop", userId, departmentId);
    },

    orderUserLow: function orderUserLow(userId, departmentId) {
        return _util2.default.ajax(base + "/api/org/orderUserLow", userId, departmentId);
    },

    orderDepartments: function orderDepartments(departmentSns) {
        return _util2.default.ajax(base + "/api/org/orderDepartments", departmentSns);
    },
    listGroupDataByType: function listGroupDataByType(params) {
        return _util2.default.ajax(base + "/api/org/listGroupDataByType", params);
    },
    rebuildPermissionIndex: function rebuildPermissionIndex() {
        return _util2.default.ajax(base + "/api/org/rebuildPermissionIndex");
    } };

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _promise = __webpack_require__(19);var _promise2 = _interopRequireDefault(_promise);var _common = __webpack_require__(300);var _common2 = _interopRequireDefault(_common);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var state = {};



var actions = {
  listCurUnit: function listCurUnit(_ref, unitId) {var commit = _ref.commit;
    return new _promise2.default(function (resolve, reject) {
      _common2.default.listCurUnit(unitId).then(function (res) {
        commit('listUnit', res.result);
        resolve(res.result);
      }).catch(function (error) {
        reject(error);
      });
    });
  },


  listCurDept: function listCurDept(_ref2, deptId) {var commit = _ref2.commit;
    return new _promise2.default(function (resolve, reject) {
      _common2.default.listCurDepartment(deptId).then(function (res) {
        commit('listDept', res.result[0].departments);
        resolve(res.result[0].departments);
      }).catch(function (error) {
        reject(error);
      });
    });
  } };



var mutations = {};exports.default =



{
  state: state,
  actions: actions,
  mutations: mutations };

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = {
  props: {
    readOnly: {
      type: Boolean,
      default: false } },


  template: '\n    <div @click="this.handleClick">\n      <div v-show="editable">\n        <slot name="editable"></slot>\n      </div>\n\n      <div v-show="!editable">\n        <slot name="readonly"></slot>\n      </div>\n    </div>\n  ',











  data: function data() {
    return {
      editable: false };

  },

  mounted: function mounted() {
    $(document.body).on('click', this.hijackClick);
  },

  beforeDestroy: function beforeDestroy() {
    $(document.body).off('click', this.hijackClick);
  },

  methods: {
    handleClick: function handleClick() {var _this = this;
      if (this.readOnly) return;
      this.editable = true;
      this.$nextTick(function () {
        $(_this.$el).find('input, textarea, select').focus();
      });
    },

    handleBlur: function handleBlur() {
      this.editable = false;
    },

    hijackClick: function hijackClick(e) {
      if (!this.editable) return;
      var target = e.target;
      var $target = $(target);

      if (!this.$el.contains(target)) {
        if ($target.parents('.el-select-dropdown,.el-picker-panel').length === 0) {
          this.handleBlur();
        }
      }
    } } };

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_InvalidUser_vue__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_InvalidUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_InvalidUser_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_InvalidUser_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_InvalidUser_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8c915c66_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_InvalidUser_vue__ = __webpack_require__(1197);
function injectStyle (ssrContext) {
  __webpack_require__(1196)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c915c66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_InvalidUser_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8c915c66_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_InvalidUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_roleList_vue__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_roleList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_roleList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_roleList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_roleList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0f53a38c_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_roleList_vue__ = __webpack_require__(1205);
function injectStyle (ssrContext) {
  __webpack_require__(1201)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f53a38c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_roleList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0f53a38c_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_roleList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 213 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isString = isString;
exports.isObject = isObject;
exports.isHtmlElement = isHtmlElement;
function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

function isHtmlElement(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
}

var isFunction = exports.isFunction = function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
};

var isUndefined = exports.isUndefined = function isUndefined(val) {
  return val === void 0;
};

var isDefined = exports.isDefined = function isDefined(val) {
  return val !== undefined && val !== null;
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(17) && !__webpack_require__(7)(function () {
  return Object.defineProperty(__webpack_require__(143)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(13);


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(39);
var toIObject = __webpack_require__(40);
var arrayIndexOf = __webpack_require__(116)(false);
var IE_PROTO = __webpack_require__(145)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20);
var anObject = __webpack_require__(3);
var getKeys = __webpack_require__(75);

module.exports = __webpack_require__(17) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(40);
var gOPN = __webpack_require__(78).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(17);
var getKeys = __webpack_require__(75);
var gOPS = __webpack_require__(117);
var pIE = __webpack_require__(101);
var toObject = __webpack_require__(22);
var IObject = __webpack_require__(100);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(7)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(27);
var isObject = __webpack_require__(8);
var invoke = __webpack_require__(223);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(4).parseInt;
var $trim = __webpack_require__(94).trim;
var ws = __webpack_require__(149);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(4).parseFloat;
var $trim = __webpack_require__(94).trim;

module.exports = 1 / $parseFloat(__webpack_require__(149) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(46);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(8);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(152);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(3);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(27);
var toObject = __webpack_require__(22);
var IObject = __webpack_require__(100);
var toLength = __webpack_require__(14);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(22);
var toAbsoluteIndex = __webpack_require__(76);
var toLength = __webpack_require__(14);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(164);
__webpack_require__(1)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(17) && /./g.flags != 'g') __webpack_require__(20).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(102)
});


/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(3);
var isObject = __webpack_require__(8);
var newPromiseCapability = __webpack_require__(168);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(239);
var validate = __webpack_require__(83);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(125)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(20).f;
var create = __webpack_require__(77);
var redefineAll = __webpack_require__(82);
var ctx = __webpack_require__(45);
var anInstance = __webpack_require__(80);
var forOf = __webpack_require__(81);
var $iterDefine = __webpack_require__(154);
var step = __webpack_require__(233);
var setSpecies = __webpack_require__(79);
var DESCRIPTORS = __webpack_require__(17);
var fastKey = __webpack_require__(69).fastKey;
var validate = __webpack_require__(83);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(239);
var validate = __webpack_require__(83);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(125)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var each = __webpack_require__(56)(0);
var redefine = __webpack_require__(36);
var meta = __webpack_require__(69);
var assign = __webpack_require__(220);
var weak = __webpack_require__(242);
var isObject = __webpack_require__(8);
var validate = __webpack_require__(83);
var NATIVE_WEAK_MAP = __webpack_require__(83);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(125)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(82);
var getWeak = __webpack_require__(69).getWeak;
var anObject = __webpack_require__(3);
var isObject = __webpack_require__(8);
var anInstance = __webpack_require__(80);
var forOf = __webpack_require__(81);
var createArrayMethod = __webpack_require__(56);
var $has = __webpack_require__(39);
var validate = __webpack_require__(83);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(47);
var toLength = __webpack_require__(14);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(78);
var gOPS = __webpack_require__(117);
var anObject = __webpack_require__(3);
var Reflect = __webpack_require__(4).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(118);
var isObject = __webpack_require__(8);
var toLength = __webpack_require__(14);
var ctx = __webpack_require__(45);
var IS_CONCAT_SPREADABLE = __webpack_require__(13)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(14);
var repeat = __webpack_require__(151);
var defined = __webpack_require__(54);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(17);
var getKeys = __webpack_require__(75);
var toIObject = __webpack_require__(40);
var isEnum = __webpack_require__(101).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(93);
var from = __webpack_require__(249);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(81);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 250 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* Modified from https://github.com/taylorhakes/fecha
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 Taylor Hakes
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 *     The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 *     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/*eslint-disable*/
// 把 YYYY-MM-DD 改成了 yyyy-MM-dd
(function (main) {
  'use strict';

  /**
   * Parse or format dates
   * @class fecha
   */

  var fecha = {};
  var token = /d{1,4}|M{1,4}|yy(?:yy)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
  var twoDigits = '\\d\\d?';
  var threeDigits = '\\d{3}';
  var fourDigits = '\\d{4}';
  var word = '[^\\s]+';
  var literal = /\[([^]*?)\]/gm;
  var noop = function noop() {};

  function regexEscape(str) {
    return str.replace(/[|\\{()[^$+*?.-]/g, '\\$&');
  }

  function shorten(arr, sLen) {
    var newArr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
      newArr.push(arr[i].substr(0, sLen));
    }
    return newArr;
  }

  function monthUpdate(arrName) {
    return function (d, v, i18n) {
      var index = i18n[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());
      if (~index) {
        d.month = index;
      }
    };
  }

  function pad(val, len) {
    val = String(val);
    len = len || 2;
    while (val.length < len) {
      val = '0' + val;
    }
    return val;
  }

  var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var monthNamesShort = shorten(monthNames, 3);
  var dayNamesShort = shorten(dayNames, 3);
  fecha.i18n = {
    dayNamesShort: dayNamesShort,
    dayNames: dayNames,
    monthNamesShort: monthNamesShort,
    monthNames: monthNames,
    amPm: ['am', 'pm'],
    DoFn: function DoFn(D) {
      return D + ['th', 'st', 'nd', 'rd'][D % 10 > 3 ? 0 : (D - D % 10 !== 10) * D % 10];
    }
  };

  var formatFlags = {
    D: function D(dateObj) {
      return dateObj.getDay();
    },
    DD: function DD(dateObj) {
      return pad(dateObj.getDay());
    },
    Do: function Do(dateObj, i18n) {
      return i18n.DoFn(dateObj.getDate());
    },
    d: function d(dateObj) {
      return dateObj.getDate();
    },
    dd: function dd(dateObj) {
      return pad(dateObj.getDate());
    },
    ddd: function ddd(dateObj, i18n) {
      return i18n.dayNamesShort[dateObj.getDay()];
    },
    dddd: function dddd(dateObj, i18n) {
      return i18n.dayNames[dateObj.getDay()];
    },
    M: function M(dateObj) {
      return dateObj.getMonth() + 1;
    },
    MM: function MM(dateObj) {
      return pad(dateObj.getMonth() + 1);
    },
    MMM: function MMM(dateObj, i18n) {
      return i18n.monthNamesShort[dateObj.getMonth()];
    },
    MMMM: function MMMM(dateObj, i18n) {
      return i18n.monthNames[dateObj.getMonth()];
    },
    yy: function yy(dateObj) {
      return pad(String(dateObj.getFullYear()), 4).substr(2);
    },
    yyyy: function yyyy(dateObj) {
      return pad(dateObj.getFullYear(), 4);
    },
    h: function h(dateObj) {
      return dateObj.getHours() % 12 || 12;
    },
    hh: function hh(dateObj) {
      return pad(dateObj.getHours() % 12 || 12);
    },
    H: function H(dateObj) {
      return dateObj.getHours();
    },
    HH: function HH(dateObj) {
      return pad(dateObj.getHours());
    },
    m: function m(dateObj) {
      return dateObj.getMinutes();
    },
    mm: function mm(dateObj) {
      return pad(dateObj.getMinutes());
    },
    s: function s(dateObj) {
      return dateObj.getSeconds();
    },
    ss: function ss(dateObj) {
      return pad(dateObj.getSeconds());
    },
    S: function S(dateObj) {
      return Math.round(dateObj.getMilliseconds() / 100);
    },
    SS: function SS(dateObj) {
      return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
    },
    SSS: function SSS(dateObj) {
      return pad(dateObj.getMilliseconds(), 3);
    },
    a: function a(dateObj, i18n) {
      return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
    },
    A: function A(dateObj, i18n) {
      return dateObj.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase();
    },
    ZZ: function ZZ(dateObj) {
      var o = dateObj.getTimezoneOffset();
      return (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4);
    }
  };

  var parseFlags = {
    d: [twoDigits, function (d, v) {
      d.day = v;
    }],
    Do: [twoDigits + word, function (d, v) {
      d.day = parseInt(v, 10);
    }],
    M: [twoDigits, function (d, v) {
      d.month = v - 1;
    }],
    yy: [twoDigits, function (d, v) {
      var da = new Date(),
          cent = +('' + da.getFullYear()).substr(0, 2);
      d.year = '' + (v > 68 ? cent - 1 : cent) + v;
    }],
    h: [twoDigits, function (d, v) {
      d.hour = v;
    }],
    m: [twoDigits, function (d, v) {
      d.minute = v;
    }],
    s: [twoDigits, function (d, v) {
      d.second = v;
    }],
    yyyy: [fourDigits, function (d, v) {
      d.year = v;
    }],
    S: ['\\d', function (d, v) {
      d.millisecond = v * 100;
    }],
    SS: ['\\d{2}', function (d, v) {
      d.millisecond = v * 10;
    }],
    SSS: [threeDigits, function (d, v) {
      d.millisecond = v;
    }],
    D: [twoDigits, noop],
    ddd: [word, noop],
    MMM: [word, monthUpdate('monthNamesShort')],
    MMMM: [word, monthUpdate('monthNames')],
    a: [word, function (d, v, i18n) {
      var val = v.toLowerCase();
      if (val === i18n.amPm[0]) {
        d.isPm = false;
      } else if (val === i18n.amPm[1]) {
        d.isPm = true;
      }
    }],
    ZZ: ['[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z', function (d, v) {
      var parts = (v + '').match(/([+-]|\d\d)/gi),
          minutes;

      if (parts) {
        minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
        d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
      }
    }]
  };
  parseFlags.dd = parseFlags.d;
  parseFlags.dddd = parseFlags.ddd;
  parseFlags.DD = parseFlags.D;
  parseFlags.mm = parseFlags.m;
  parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
  parseFlags.MM = parseFlags.M;
  parseFlags.ss = parseFlags.s;
  parseFlags.A = parseFlags.a;

  // Some common format strings
  fecha.masks = {
    default: 'ddd MMM dd yyyy HH:mm:ss',
    shortDate: 'M/D/yy',
    mediumDate: 'MMM d, yyyy',
    longDate: 'MMMM d, yyyy',
    fullDate: 'dddd, MMMM d, yyyy',
    shortTime: 'HH:mm',
    mediumTime: 'HH:mm:ss',
    longTime: 'HH:mm:ss.SSS'
  };

  /***
   * Format a date
   * @method format
   * @param {Date|number} dateObj
   * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
   */
  fecha.format = function (dateObj, mask, i18nSettings) {
    var i18n = i18nSettings || fecha.i18n;

    if (typeof dateObj === 'number') {
      dateObj = new Date(dateObj);
    }

    if (Object.prototype.toString.call(dateObj) !== '[object Date]' || isNaN(dateObj.getTime())) {
      throw new Error('Invalid Date in fecha.format');
    }

    mask = fecha.masks[mask] || mask || fecha.masks['default'];

    var literals = [];

    // Make literals inactive by replacing them with ??
    mask = mask.replace(literal, function ($0, $1) {
      literals.push($1);
      return '@@@';
    });
    // Apply formatting rules
    mask = mask.replace(token, function ($0) {
      return $0 in formatFlags ? formatFlags[$0](dateObj, i18n) : $0.slice(1, $0.length - 1);
    });
    // Inline literal values back into the formatted value
    return mask.replace(/@@@/g, function () {
      return literals.shift();
    });
  };

  /**
   * Parse a date string into an object, changes - into /
   * @method parse
   * @param {string} dateStr Date string
   * @param {string} format Date parse format
   * @returns {Date|boolean}
   */
  fecha.parse = function (dateStr, format, i18nSettings) {
    var i18n = i18nSettings || fecha.i18n;

    if (typeof format !== 'string') {
      throw new Error('Invalid format in fecha.parse');
    }

    format = fecha.masks[format] || format;

    // Avoid regular expression denial of service, fail early for really long strings
    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
    if (dateStr.length > 1000) {
      return null;
    }

    var dateInfo = {};
    var parseInfo = [];
    var literals = [];
    format = format.replace(literal, function ($0, $1) {
      literals.push($1);
      return '@@@';
    });
    var newFormat = regexEscape(format).replace(token, function ($0) {
      if (parseFlags[$0]) {
        var info = parseFlags[$0];
        parseInfo.push(info[1]);
        return '(' + info[0] + ')';
      }

      return $0;
    });
    newFormat = newFormat.replace(/@@@/g, function () {
      return literals.shift();
    });
    var matches = dateStr.match(new RegExp(newFormat, 'i'));
    if (!matches) {
      return null;
    }

    for (var i = 1; i < matches.length; i++) {
      parseInfo[i - 1](dateInfo, matches[i], i18n);
    }

    var today = new Date();
    if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12) {
      dateInfo.hour = +dateInfo.hour + 12;
    } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
      dateInfo.hour = 0;
    }

    var date;
    if (dateInfo.timezoneOffset != null) {
      dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
      date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
    } else {
      date = new Date(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0);
    }
    return date;
  };

  /* istanbul ignore next */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = fecha;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return fecha;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    main.fecha = fecha;
  }
})(undefined);

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PopupManager = undefined;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _merge = __webpack_require__(131);

var _merge2 = _interopRequireDefault(_merge);

var _popupManager = __webpack_require__(709);

var _popupManager2 = _interopRequireDefault(_popupManager);

var _scrollbarWidth = __webpack_require__(171);

var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);

var _dom = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var idSeed = 1;

var scrollBarWidth = void 0;

exports.default = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    openDelay: {},
    closeDelay: {},
    zIndex: {},
    modal: {
      type: Boolean,
      default: false
    },
    modalFade: {
      type: Boolean,
      default: true
    },
    modalClass: {},
    modalAppendToBody: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },

  beforeMount: function beforeMount() {
    this._popupId = 'popup-' + idSeed++;
    _popupManager2.default.register(this._popupId, this);
  },
  beforeDestroy: function beforeDestroy() {
    _popupManager2.default.deregister(this._popupId);
    _popupManager2.default.closeModal(this._popupId);

    this.restoreBodyStyle();
  },
  data: function data() {
    return {
      opened: false,
      bodyPaddingRight: null,
      computedBodyPaddingRight: 0,
      withoutHiddenClass: true,
      rendered: false
    };
  },


  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        if (this._opening) return;
        if (!this.rendered) {
          this.rendered = true;
          _vue2.default.nextTick(function () {
            _this.open();
          });
        } else {
          this.open();
        }
      } else {
        this.close();
      }
    }
  },

  methods: {
    open: function open(options) {
      var _this2 = this;

      if (!this.rendered) {
        this.rendered = true;
      }

      var props = (0, _merge2.default)({}, this.$props || this, options);

      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }
      clearTimeout(this._openTimer);

      var openDelay = Number(props.openDelay);
      if (openDelay > 0) {
        this._openTimer = setTimeout(function () {
          _this2._openTimer = null;
          _this2.doOpen(props);
        }, openDelay);
      } else {
        this.doOpen(props);
      }
    },
    doOpen: function doOpen(props) {
      if (this.$isServer) return;
      if (this.willOpen && !this.willOpen()) return;
      if (this.opened) return;

      this._opening = true;

      var dom = this.$el;

      var modal = props.modal;

      var zIndex = props.zIndex;
      if (zIndex) {
        _popupManager2.default.zIndex = zIndex;
      }

      if (modal) {
        if (this._closing) {
          _popupManager2.default.closeModal(this._popupId);
          this._closing = false;
        }
        _popupManager2.default.openModal(this._popupId, _popupManager2.default.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
        if (props.lockScroll) {
          this.withoutHiddenClass = !(0, _dom.hasClass)(document.body, 'el-popup-parent--hidden');
          if (this.withoutHiddenClass) {
            this.bodyPaddingRight = document.body.style.paddingRight;
            this.computedBodyPaddingRight = parseInt((0, _dom.getStyle)(document.body, 'paddingRight'), 10);
          }
          scrollBarWidth = (0, _scrollbarWidth2.default)();
          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
          var bodyOverflowY = (0, _dom.getStyle)(document.body, 'overflowY');
          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
            document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px';
          }
          (0, _dom.addClass)(document.body, 'el-popup-parent--hidden');
        }
      }

      if (getComputedStyle(dom).position === 'static') {
        dom.style.position = 'absolute';
      }

      dom.style.zIndex = _popupManager2.default.nextZIndex();
      this.opened = true;

      this.onOpen && this.onOpen();

      this.doAfterOpen();
    },
    doAfterOpen: function doAfterOpen() {
      this._opening = false;
    },
    close: function close() {
      var _this3 = this;

      if (this.willClose && !this.willClose()) return;

      if (this._openTimer !== null) {
        clearTimeout(this._openTimer);
        this._openTimer = null;
      }
      clearTimeout(this._closeTimer);

      var closeDelay = Number(this.closeDelay);

      if (closeDelay > 0) {
        this._closeTimer = setTimeout(function () {
          _this3._closeTimer = null;
          _this3.doClose();
        }, closeDelay);
      } else {
        this.doClose();
      }
    },
    doClose: function doClose() {
      this._closing = true;

      this.onClose && this.onClose();

      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200);
      }

      this.opened = false;

      this.doAfterClose();
    },
    doAfterClose: function doAfterClose() {
      _popupManager2.default.closeModal(this._popupId);
      this._closing = false;
    },
    restoreBodyStyle: function restoreBodyStyle() {
      if (this.modal && this.withoutHiddenClass) {
        document.body.style.paddingRight = this.bodyPaddingRight;
        (0, _dom.removeClass)(document.body, 'el-popup-parent--hidden');
      }
      this.withoutHiddenClass = true;
    }
  }
};
exports.PopupManager = _popupManager2.default;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _util = __webpack_require__(52);

/**
 * Show migrating guide in browser console.
 *
 * Usage:
 * import Migrating from 'element-ui/src/mixins/migrating';
 *
 * mixins: [Migrating]
 *
 * add getMigratingConfig method for your component.
 *  getMigratingConfig() {
 *    return {
 *      props: {
 *        'allow-no-selection': 'allow-no-selection is removed.',
 *        'selection-mode': 'selection-mode is removed.'
 *      },
 *      events: {
 *        selectionchange: 'selectionchange is renamed to selection-change.'
 *      }
 *    };
 *  },
 */
exports.default = {
  mounted: function mounted() {
    if (true) return;
    if (!this.$vnode) return;

    var _getMigratingConfig = this.getMigratingConfig(),
        _getMigratingConfig$p = _getMigratingConfig.props,
        props = _getMigratingConfig$p === undefined ? {} : _getMigratingConfig$p,
        _getMigratingConfig$e = _getMigratingConfig.events,
        events = _getMigratingConfig$e === undefined ? {} : _getMigratingConfig$e;

    var _$vnode = this.$vnode,
        data = _$vnode.data,
        componentOptions = _$vnode.componentOptions;

    var definedProps = data.attrs || {};
    var definedEvents = componentOptions.listeners || {};

    for (var propName in definedProps) {
      propName = (0, _util.kebabCase)(propName); // compatible with camel case
      if (props[propName]) {
        console.warn('[Element Migrating][' + this.$options.name + '][Attribute]: ' + props[propName]);
      }
    }

    for (var eventName in definedEvents) {
      eventName = (0, _util.kebabCase)(eventName); // compatible with camel case
      if (events[eventName]) {
        console.warn('[Element Migrating][' + this.$options.name + '][Event]: ' + events[eventName]);
      }
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {},
        events: {}
      };
    }
  }
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _dom = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nodeList = [];
var ctx = '@@clickoutsideContext';

var startClick = void 0;
var seed = 0;

!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mousedown', function (e) {
  return startClick = e;
});

!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mouseup', function (e) {
  nodeList.forEach(function (node) {
    return node[ctx].documentHandler(e, startClick);
  });
});

function createDocumentHandler(el, binding, vnode) {
  return function () {
    var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;

    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
      vnode.context[el[ctx].methodName]();
    } else {
      el[ctx].bindingFn && el[ctx].bindingFn();
    }
  };
}

/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */
exports.default = {
  bind: function bind(el, binding, vnode) {
    nodeList.push(el);
    var id = seed++;
    el[ctx] = {
      id: id,
      documentHandler: createDocumentHandler(el, binding, vnode),
      methodName: binding.expression,
      bindingFn: binding.value
    };
  },
  update: function update(el, binding, vnode) {
    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
    el[ctx].methodName = binding.expression;
    el[ctx].bindingFn = binding.value;
  },
  unbind: function unbind(el) {
    var len = nodeList.length;

    for (var i = 0; i < len; i++) {
      if (nodeList[i][ctx].id === el[ctx].id) {
        nodeList.splice(i, 1);
        break;
      }
    }
    delete el[ctx];
  }
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 83);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(84);

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "el-checkbox",
      class: [
        _vm.border && _vm.checkboxSize
          ? "el-checkbox--" + _vm.checkboxSize
          : "",
        { "is-disabled": _vm.isDisabled },
        { "is-bordered": _vm.border },
        { "is-checked": _vm.isChecked }
      ],
      attrs: { id: _vm.id }
    },
    [
      _c(
        "span",
        {
          staticClass: "el-checkbox__input",
          class: {
            "is-disabled": _vm.isDisabled,
            "is-checked": _vm.isChecked,
            "is-indeterminate": _vm.indeterminate,
            "is-focus": _vm.focus
          },
          attrs: {
            tabindex: _vm.indeterminate ? 0 : false,
            role: _vm.indeterminate ? "checkbox" : false,
            "aria-checked": _vm.indeterminate ? "mixed" : false
          }
        },
        [
          _c("span", { staticClass: "el-checkbox__inner" }),
          _vm.trueLabel || _vm.falseLabel
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  }
                ],
                staticClass: "el-checkbox__original",
                attrs: {
                  type: "checkbox",
                  "aria-hidden": _vm.indeterminate ? "true" : "false",
                  name: _vm.name,
                  disabled: _vm.isDisabled,
                  "true-value": _vm.trueLabel,
                  "false-value": _vm.falseLabel
                },
                domProps: {
                  checked: Array.isArray(_vm.model)
                    ? _vm._i(_vm.model, null) > -1
                    : _vm._q(_vm.model, _vm.trueLabel)
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.model,
                        $$el = $event.target,
                        $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.model = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.model = $$c
                      }
                    },
                    _vm.handleChange
                  ],
                  focus: function($event) {
                    _vm.focus = true
                  },
                  blur: function($event) {
                    _vm.focus = false
                  }
                }
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  }
                ],
                staticClass: "el-checkbox__original",
                attrs: {
                  type: "checkbox",
                  "aria-hidden": _vm.indeterminate ? "true" : "false",
                  disabled: _vm.isDisabled,
                  name: _vm.name
                },
                domProps: {
                  value: _vm.label,
                  checked: Array.isArray(_vm.model)
                    ? _vm._i(_vm.model, _vm.label) > -1
                    : _vm.model
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.model,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = _vm.label,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.model = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.model = $$c
                      }
                    },
                    _vm.handleChange
                  ],
                  focus: function($event) {
                    _vm.focus = true
                  },
                  blur: function($event) {
                    _vm.focus = false
                  }
                }
              })
        ]
      ),
      _vm.$slots.default || _vm.label
        ? _c(
            "span",
            { staticClass: "el-checkbox__label" },
            [
              _vm._t("default"),
              !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&

// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
var emitter_ = __webpack_require__(4);
var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
  name: 'ElCheckbox',

  mixins: [emitter_default.a],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  componentName: 'ElCheckbox',

  data: function data() {
    return {
      selfModel: false,
      focus: false,
      isLimitExceeded: false
    };
  },


  computed: {
    model: {
      get: function get() {
        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
      },
      set: function set(val) {
        if (this.isGroup) {
          this.isLimitExceeded = false;
          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);

          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);

          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
          this.selfModel = val;
        }
      }
    },

    isChecked: function isChecked() {
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.model;
      } else if (Array.isArray(this.model)) {
        return this.model.indexOf(this.label) > -1;
      } else if (this.model !== null && this.model !== undefined) {
        return this.model === this.trueLabel;
      }
    },
    isGroup: function isGroup() {
      var parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'ElCheckboxGroup') {
          parent = parent.$parent;
        } else {
          this._checkboxGroup = parent;
          return true;
        }
      }
      return false;
    },
    store: function store() {
      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
    },


    /* used to make the isDisabled judgment under max/min props */
    isLimitDisabled: function isLimitDisabled() {
      var _checkboxGroup = this._checkboxGroup,
          max = _checkboxGroup.max,
          min = _checkboxGroup.min;

      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
    },
    isDisabled: function isDisabled() {
      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    checkboxSize: function checkboxSize() {
      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
    }
  },

  props: {
    value: {},
    label: {},
    indeterminate: Boolean,
    disabled: Boolean,
    checked: Boolean,
    name: String,
    trueLabel: [String, Number],
    falseLabel: [String, Number],
    id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
    controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
    border: Boolean,
    size: String
  },

  methods: {
    addToStore: function addToStore() {
      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
        this.model.push(this.label);
      } else {
        this.model = this.trueLabel || true;
      }
    },
    handleChange: function handleChange(ev) {
      var _this = this;

      if (this.isLimitExceeded) return;
      var value = void 0;
      if (ev.target.checked) {
        value = this.trueLabel === undefined ? true : this.trueLabel;
      } else {
        value = this.falseLabel === undefined ? false : this.falseLabel;
      }
      this.$emit('change', value, ev);
      this.$nextTick(function () {
        if (_this.isGroup) {
          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
        }
      });
    }
  },

  created: function created() {
    this.checked && this.addToStore();
  },
  mounted: function mounted() {
    // 为indeterminate元素 添加aria-controls 属性
    if (this.indeterminate) {
      this.$el.setAttribute('aria-controls', this.controls);
    }
  },


  watch: {
    value: function value(_value) {
      this.dispatch('ElFormItem', 'el.form.change', _value);
    }
  }
});
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_checkboxvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/checkbox/src/checkbox.vue"
/* harmony default export */ var src_checkbox = (component.exports);
// CONCATENATED MODULE: ./packages/checkbox/index.js


/* istanbul ignore next */
src_checkbox.install = function (Vue) {
  Vue.component(src_checkbox.name, src_checkbox);
};

/* harmony default export */ var packages_checkbox = __webpack_exports__["default"] = (src_checkbox);

/***/ })

/******/ });

/***/ }),
/* 256 */
/***/ (function(module, exports) {

var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/

module.exports = function mergeJSXProps (objs) {
  return objs.reduce(function (a, b) {
    var aa, bb, key, nestedKey, temp
    for (key in b) {
      aa = a[key]
      bb = b[key]
      if (aa && nestRE.test(key)) {
        // normalize class
        if (key === 'class') {
          if (typeof aa === 'string') {
            temp = aa
            a[key] = aa = {}
            aa[temp] = true
          }
          if (typeof bb === 'string') {
            temp = bb
            b[key] = bb = {}
            bb[temp] = true
          }
        }
        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
          // merge functions
          for (nestedKey in bb) {
            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey])
          }
        } else if (Array.isArray(aa)) {
          a[key] = aa.concat(bb)
        } else if (Array.isArray(bb)) {
          a[key] = [aa].concat(bb)
        } else {
          for (nestedKey in bb) {
            aa[nestedKey] = bb[nestedKey]
          }
        }
      } else {
        a[key] = b[key]
      }
    }
    return a
  }, {})
}

function mergeFn (a, b) {
  return function () {
    a && a.apply(this, arguments)
    b && b.apply(this, arguments)
  }
}


/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 124);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&

/* harmony default export */ var tagvue_type_script_lang_js_ = ({
  name: 'ElTag',
  props: {
    text: String,
    closable: Boolean,
    type: String,
    hit: Boolean,
    disableTransitions: Boolean,
    color: String,
    size: String,
    effect: {
      type: String,
      default: 'light',
      validator: function validator(val) {
        return ['dark', 'light', 'plain'].indexOf(val) !== -1;
      }
    }
  },
  methods: {
    handleClose: function handleClose(event) {
      event.stopPropagation();
      this.$emit('close', event);
    },
    handleClick: function handleClick(event) {
      this.$emit('click', event);
    }
  },
  computed: {
    tagSize: function tagSize() {
      return this.size || (this.$ELEMENT || {}).size;
    }
  },
  render: function render(h) {
    var type = this.type,
        tagSize = this.tagSize,
        hit = this.hit,
        effect = this.effect;

    var classes = ['el-tag', type ? 'el-tag--' + type : '', tagSize ? 'el-tag--' + tagSize : '', effect ? 'el-tag--' + effect : '', hit && 'is-hit'];
    var tagEl = h(
      'span',
      {
        'class': classes,
        style: { backgroundColor: this.color },
        on: {
          'click': this.handleClick
        }
      },
      [this.$slots.default, this.closable && h('i', { 'class': 'el-tag__close el-icon-close', on: {
          'click': this.handleClose
        }
      })]
    );

    return this.disableTransitions ? tagEl : h(
      'transition',
      {
        attrs: { name: 'el-zoom-in-center' }
      },
      [tagEl]
    );
  }
});
// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tagvue_type_script_lang_js_ = (tagvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/tag/src/tag.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_tagvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/tag/src/tag.vue"
/* harmony default export */ var tag = (component.exports);
// CONCATENATED MODULE: ./packages/tag/index.js


/* istanbul ignore next */
tag.install = function (Vue) {
  Vue.component(tag.name, tag);
};

/* harmony default export */ var packages_tag = __webpack_exports__["default"] = (tag);

/***/ })

/******/ });

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(51) && !__webpack_require__(85)(function () {
  return Object.defineProperty(__webpack_require__(179)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(86);
var toIObject = __webpack_require__(87);
var arrayIndexOf = __webpack_require__(733)(false);
var IE_PROTO = __webpack_require__(184)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(71);


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(29).document;
module.exports = document && document.documentElement;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(86);
var toObject = __webpack_require__(88);
var IE_PROTO = __webpack_require__(184)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(107);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(259);
var hiddenKeys = __webpack_require__(186).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(23);


/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || __WEBPACK_IMPORTED_MODULE_0__util__["e" /* isEmptyValue */](value, type || rule.type))) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.required, rule.fullField));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (required);

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 116);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "el-radio",
      class: [
        _vm.border && _vm.radioSize ? "el-radio--" + _vm.radioSize : "",
        { "is-disabled": _vm.isDisabled },
        { "is-focus": _vm.focus },
        { "is-bordered": _vm.border },
        { "is-checked": _vm.model === _vm.label }
      ],
      attrs: {
        role: "radio",
        "aria-checked": _vm.model === _vm.label,
        "aria-disabled": _vm.isDisabled,
        tabindex: _vm.tabIndex
      },
      on: {
        keydown: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
          ) {
            return null
          }
          $event.stopPropagation()
          $event.preventDefault()
          _vm.model = _vm.isDisabled ? _vm.model : _vm.label
        }
      }
    },
    [
      _c(
        "span",
        {
          staticClass: "el-radio__input",
          class: {
            "is-disabled": _vm.isDisabled,
            "is-checked": _vm.model === _vm.label
          }
        },
        [
          _c("span", { staticClass: "el-radio__inner" }),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model,
                expression: "model"
              }
            ],
            ref: "radio",
            staticClass: "el-radio__original",
            attrs: {
              type: "radio",
              "aria-hidden": "true",
              name: _vm.name,
              disabled: _vm.isDisabled,
              tabindex: "-1"
            },
            domProps: {
              value: _vm.label,
              checked: _vm._q(_vm.model, _vm.label)
            },
            on: {
              focus: function($event) {
                _vm.focus = true
              },
              blur: function($event) {
                _vm.focus = false
              },
              change: [
                function($event) {
                  _vm.model = _vm.label
                },
                _vm.handleChange
              ]
            }
          })
        ]
      ),
      _c(
        "span",
        {
          staticClass: "el-radio__label",
          on: {
            keydown: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _vm._t("default"),
          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&

// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
var emitter_ = __webpack_require__(4);
var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var radiovue_type_script_lang_js_ = ({
  name: 'ElRadio',

  mixins: [emitter_default.a],

  inject: {
    elForm: {
      default: ''
    },

    elFormItem: {
      default: ''
    }
  },

  componentName: 'ElRadio',

  props: {
    value: {},
    label: {},
    disabled: Boolean,
    name: String,
    border: Boolean,
    size: String
  },

  data: function data() {
    return {
      focus: false
    };
  },

  computed: {
    isGroup: function isGroup() {
      var parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'ElRadioGroup') {
          parent = parent.$parent;
        } else {
          this._radioGroup = parent;
          return true;
        }
      }
      return false;
    },

    model: {
      get: function get() {
        return this.isGroup ? this._radioGroup.value : this.value;
      },
      set: function set(val) {
        if (this.isGroup) {
          this.dispatch('ElRadioGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
        }
        this.$refs.radio && (this.$refs.radio.checked = this.model === this.label);
      }
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    radioSize: function radioSize() {
      var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
    },
    isDisabled: function isDisabled() {
      return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
    },
    tabIndex: function tabIndex() {
      return this.isDisabled || this.isGroup && this.model !== this.label ? -1 : 0;
    }
  },

  methods: {
    handleChange: function handleChange() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('change', _this.model);
        _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_radiovue_type_script_lang_js_ = (radiovue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/radio/src/radio.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_radiovue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/radio/src/radio.vue"
/* harmony default export */ var src_radio = (component.exports);
// CONCATENATED MODULE: ./packages/radio/index.js


/* istanbul ignore next */
src_radio.install = function (Vue) {
  Vue.component(src_radio.name, src_radio);
};

/* harmony default export */ var packages_radio = __webpack_exports__["default"] = (src_radio);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(84);

/***/ })

/******/ });

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =












{
  name: 'vbox',
  props: {
    params: Object },

  data: function data() {
    return {};
  },
  mounted: function mounted() {var _this = this;
    if (this.params.style) {
      this.appendStyle(this.$refs.ct, this.params.style);
    }
    this.params.rows.forEach(function (r, idx) {
      if (r.style) {
        var div = _this.$refs.rows[idx];
        _this.appendStyle(div, r.style);
      }
    });
  },
  methods: {
    appendStyle: function appendStyle(el, style) {
      var oldStyle = $(el).attr("style");
      $(el).attr("style", oldStyle + "; " + style);
    } } };

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_designer_vue__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_designer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_designer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_designer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_designer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5db27ac6_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_vbox_designer_vue__ = __webpack_require__(786);
function injectStyle (ssrContext) {
  __webpack_require__(785)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5db27ac6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_designer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5db27ac6_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_vbox_designer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =












{
  name: "hbox-designer",
  props: {
    params: Object },

  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var me = this;
    me.params.rows.forEach(function (row, index) {
      if (row.items) {

        var el = me.$refs.rows[index];
        me.$emit("addItems", row.items, el);
      }
    });
  },
  methods: {
    setContainerData: function setContainerData(ct, items, data) {
      var index = $(ct).index();
      data.rows[index].items = items;
    } },

  watch: {
    "params.style": {
      immediate: true,
      handler: function handler(v) {var _this = this;
        this.$nextTick(function () {

          $(_this.$refs.ct).attr("style", v + " ; padding:" + _this.params.padding);
        });
      } },

    "params.rows": {
      deep: true,
      immediate: true,
      handler: function handler(newValue) {var _this2 = this;
        this.$nextTick(function () {
          newValue.forEach(function (row, index) {
            var div = _this2.$refs.rows[index];
            var style = (row.style || "") + " ; height:" + row.height + ";padding-top:" + (row.paddingTop || 0) + ";padding-bottom:" + (row.paddingBottom || 0);
            $(div).attr("style", style);
          });
        });
      } } } };

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_editor_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_editor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_editor_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_editor_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_editor_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8fd81a4e_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_vbox_editor_vue__ = __webpack_require__(788);
function injectStyle (ssrContext) {
  __webpack_require__(787)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8fd81a4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_editor_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8fd81a4e_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_vbox_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =





































































{
  name: "vbox-editor",
  props: ["data", "params"],
  methods: {
    addColumn: function addColumn() {
      this.data.rows.push({
        height: "" });

    },
    deleteColumn: function deleteColumn() {
      var selection = this.$refs.table.selection;
      if (!selection) return;
      this.data.rows = this.data.rows.filter(function (r) {return selection.indexOf(r) === -1;});
    } } };

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =













{
  name: 'hbox',
  props: {
    params: Object },

  data: function data() {
    return {};
  },
  mounted: function mounted() {var _this = this;
    if (this.params.style) {
      this.appendStyle(this.$refs.ct, this.params.style);
    }
    this.params.columns.forEach(function (r, idx) {
      if (r.style) {
        var div = _this.$refs.columns[idx];
        _this.appendStyle(div, r.style);
      }
    });
  },
  methods: {
    appendStyle: function appendStyle(el, style) {
      var oldStyle = $(el).attr("style") || "";
      $(el).attr("style", oldStyle + "; " + style);
    } } };

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_designer_vue__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_designer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_designer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_designer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_designer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f7cbb900_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_hbox_designer_vue__ = __webpack_require__(793);
function injectStyle (ssrContext) {
  __webpack_require__(792)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f7cbb900"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_designer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f7cbb900_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_hbox_designer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =










{
  name: "hbox-designer",
  props: {
    params: Object },

  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var me = this;
    me.params.columns.forEach(function (col, index) {
      if (col.items) {

        var el = me.$refs.columns[index];
        me.$emit("addItems", col.items, el);
      }
    });
  },
  methods: {
    setContainerData: function setContainerData(ct, items, data) {
      var index = $(ct).index() - 1;
      data.columns[index].items = items;
    } },

  watch: {
    "params.style": {
      immediate: true,
      handler: function handler(v) {var _this = this;
        this.$nextTick(function () {
          $(_this.$refs.ct).attr("style", v + " ; padding:" + _this.params.padding);
        });
      } },

    "params.columns": {
      deep: true,
      immediate: true,
      handler: function handler(newValue) {var _this2 = this;
        this.$nextTick(function () {
          newValue.forEach(function (col, index) {
            var div = _this2.$refs.columns[index];
            var style = (col.style || "") + " ; width:" + col.width + ";padding-left:" + (col.paddingLeft || 0) + ";padding-right:" + (col.paddingRight || 0);
            $(div).attr("style", style);
          });
        });
      } } } };

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_editor_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_editor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_editor_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_editor_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_editor_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_9875e6b4_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_hbox_editor_vue__ = __webpack_require__(795);
function injectStyle (ssrContext) {
  __webpack_require__(794)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9875e6b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_editor_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_9875e6b4_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_hbox_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =










































































{
  name: "hbox-editor",
  props: ["data", "params"],
  methods: {
    addColumn: function addColumn() {
      this.data.columns.push({
        width: "" });

    },
    deleteColumn: function deleteColumn() {
      var selection = this.$refs.table.selection;
      if (!selection) return;
      this.data.columns = this.data.columns.filter(function (c) {return selection.indexOf(c) === -1;});
    } } };

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =







{
  name: "item-wrapper",
  props: ["params", "data", "idField"],
  mounted: function mounted() {

  },
  computed: {
    pageId: function pageId() {
      return this.idField && this.params[this.idField] || this.params.pageId;
    } } };

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_designer_vue__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_designer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_designer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_designer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_designer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ca0b9b7c_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_item_wrapper_designer_vue__ = __webpack_require__(800);
function injectStyle (ssrContext) {
  __webpack_require__(799)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca0b9b7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_designer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ca0b9b7c_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_item_wrapper_designer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =






{
  name: "item-wrapper-designer",
  props: ["data", "params"],

  mounted: function mounted() {
    var me = this;
    var p = this.params;
    if (p.type === "page") {
      var innerPage = me.$refs.wrapper.$refs.innerPage;
      var unwatch = innerPage.$watch("pageReady", function (r) {
        innerPage.$refs.pageObj.$on("addItems", function (items, el) {
          me.$emit("addItems", items, el);
        });
        unwatch();
      });
    } else if (p.type === "comp") {
      if (_.isFunction(p.dataProcess)) {
        p.dataProcess(p);
      }
    }
  },
  methods: {
    setContainerData: function setContainerData(ct, items, data) {
      if (this.params.type === "page") {
        var pageObj = this.$refs.wrapper.$refs.innerPage.$refs.pageObj;
        if (pageObj && pageObj.setContainerData) {
          pageObj.setContainerData(ct, items, data);
        }
      }
    } } };

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_editor_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_editor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_editor_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_editor_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_editor_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7a8c09d9_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_item_wrapper_editor_vue__ = __webpack_require__(802);
function injectStyle (ssrContext) {
  __webpack_require__(801)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a8c09d9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_editor_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7a8c09d9_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_item_wrapper_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =



















{
    name: "item-wrapper-editor",
    props: ["data", "params"],
    mounted: function mounted() {
    } };

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _slicedToArray2 = __webpack_require__(60);var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);var _promise = __webpack_require__(19);var _promise2 = _interopRequireDefault(_promise);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =




{
  name: "comp-wrapper",
  props: ["params"],
  data: function data() {
    var outer = this;
    var comp = {
      template: this.params.template,
      data: function data() {
        var obj = {
          context: outer.params.context,
          siteId: outer.params.siteId };

        _.each(outer.params.dataSource, function (_ref) {var key = _ref.key;return obj[key] = "";});
        return obj;
      },
      methods: {
        call: function call(methodName) {
          if (this.__scriptEval) {
            var method = this.__scriptEval(methodName);
            if (method) {for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {args[_key - 1] = arguments[_key];}
              method.apply(this, args);
            }
          }
        },
        reloadData: function reloadData(dataKey, ctx) {var _this = this;
          if (ctx) _.assign(this.context, ctx);
          var ds = outer.params.dataSource.filter(function (ds) {return ds.key === dataKey;})[0];
          if (ds) {

            _promise2.default.resolve(ds.getData()).then(function (data) {return _this[dataKey] = data;});
          } else {
            if (window.console) console.log("不存在数据源:" + dataKey);
          }
        } } };


    if (this.params.mixin) {
      comp.mixins = [this.params.mixin];
    }
    comp.mounted = function () {var _this2 = this;
      if (outer.params.script) {
        var fn = void 0;
        try {
          var $script = "\n          " +
          outer.params.script + "\n            return function(exp){\n                return eval(\"(0,\"+exp+\")\");\n            }\n          ";




          fn = new Function($script);
        } catch (e) {
          if (window.console) {
            console.log(outer.params.script);
            console.log(e);
          }
        }

        if (fn) {
          this.__scriptEval = fn.call(this);
        }
      }
      if (outer.params.dataSource) {
        outer.fetchData(outer.params.dataSource).then(function (arr) {
          if (arr) {
            arr.forEach(function (_ref2) {var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),key = _ref3[0],v = _ref3[1];
              _this2[key] = v;
            });
          }
        });
      }
    };
    return {
      compDef: comp,
      cssEl: null };

  },
  mounted: function mounted() {
    if (this.params.style) {
      this.insertCss(this.params.style);
    }

  },
  methods: {
    destroy: function destroy() {
      if (this.cssEl) {
        this.cssEl.remove();
      }
    },
    insertCss: function insertCss(css) {
      if (!css) return;
      this.cssEl = $("<style type='text/css'></style>").html(css).insertBefore(this.$el);
    },
    fetchData: function fetchData(dataSource) {

      if (!dataSource) return _promise2.default.resolve(null);
      var promises = dataSource.map(function (v) {return _.isFunction(v.getData) && v.getData();});
      var keys = dataSource.map(function (d) {return d.key;});
      return _promise2.default.all(promises).then(function (values) {
        return _.zip(keys, values);
      });
    } } };

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(57);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(97);
var ITERATOR = __webpack_require__(30)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(57);
var aFunction = __webpack_require__(104);
var SPECIES = __webpack_require__(30)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(64);
var invoke = __webpack_require__(812);
var html = __webpack_require__(261);
var cel = __webpack_require__(179);
var global = __webpack_require__(29);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(107)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(57);
var isObject = __webpack_require__(50);
var newPromiseCapability = __webpack_require__(197);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29);
var core = __webpack_require__(18);
var dP = __webpack_require__(49);
var DESCRIPTORS = __webpack_require__(51);
var SPECIES = __webpack_require__(30)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(30)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });





































var _widgets = __webpack_require__(821);var _widgets2 = _interopRequireDefault(_widgets);
var _itemWrapperDesigner = __webpack_require__(279);var _itemWrapperDesigner2 = _interopRequireDefault(_itemWrapperDesigner);
var _itemWrapperEditor = __webpack_require__(281);var _itemWrapperEditor2 = _interopRequireDefault(_itemWrapperEditor);
var _vue = __webpack_require__(11);var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  name: "layout-manager",
  props: {
    widgets: Array,
    dataItems: Array,
    editmode: Boolean,
    hideDefaultLayout: {
      type: Boolean,
      defaultValue: false },

    hideCustomLayout: {
      type: Boolean,
      defaultValue: false } },


  data: function data() {
    this.initWidgets();
    return {
      compMap: {},
      currentComp: {},
      defaultWidgets: _widgets2.default,
      ready: false };

  },
  mounted: function mounted() {
    var me = this;
    PF.loadCss("/assets/js/dragula/dragula.min.css");
    PF.requireJs("/assets/js/dragula/dragula.min.js", function () {
      me.$nextTick(function () {
        me.drake = dragula([me.$refs.left1, me.$refs.left2, me.$refs.center], {
          isContainer: function isContainer(el, target) {

            return $(el).is(".dragula-container") && !el.contains(target);
          },
          copy: function copy(el, source) {
            return $(source).is(".widget-container");
          },
          accepts: function accepts(el, target, source, sibling) {
            return !$(target).is(".widget-container");
          },
          removeOnSpill: true }).
        on("drop", function (item, parent, source, currentSibling) {
          if ($(source).is(".widget-container")) {
            if ($(parent).is(".designer-container") || $(parent).is(".dragula-container")) {
              me.addWidget(item);
            }
          }
        });
        me.loadData();
        me.ready = true;
      });
    });
  },
  methods: {
    initWidgets: function initWidgets() {
      if (this.widgets) {
        this.widgets.forEach(function (w) {
          w.initData = _.clone(w);
          delete w.initData.id;
          w.xtype = "item-wrapper";
          w.editorComp = _itemWrapperEditor2.default;
          w.designerComp = _itemWrapperDesigner2.default;

        });
      }
    },
    getWidget: function getWidget(id) {
      return _.find(_widgets2.default, { id: id }) || _.find(this.widgets, { id: id });
    },
    loadData: function loadData() {
      var me = this;
      if (!me.dataItems) return;
      me.dataItems.forEach(function (item) {
        me.addItem(item, me.$refs.center);
      });
    },
    removeWidget: function removeWidget(w) {
      this.$emit("removeWidget", w);
    },
    createNewComponent: function createNewComponent(widget, data) {
      var me = this;
      var id = $uuid();
      var doActive = !data;
      if (_.isString(widget)) {
        widget = me.getWidget(widget);
      }
      data = _.assign({}, _.cloneDeep(widget.initData), data);
      data.id = data.id || id;
      data.widgetId = widget.id;
      var comp = {
        xtype: widget.xtype,
        widgetId: widget.id,
        widgetName: widget.name,
        designerParams: {
          xtype: widget.designerComp.name },

        editorParams: {
          xtype: widget.editorComp.name },

        data: data };

      if (doActive) me.currentComp = comp;
      me.compMap[id] = comp;
      var Designer = _vue2.default.extend(widget.designerComp);
      var designer = new Designer({
        propsData: {
          params: data,
          data: {} } });


      designer.$on("addItems", function (items, el) {

        if (!items) return;
        items.forEach(function (item) {return me.addItem(item, el);});
      });
      designer.$mount();
      comp.designer = designer;
      $(designer.$el).attr("wid", id).click(function (e) {
        e.stopPropagation();
        me.currentComp = comp;
      });
      return designer;
    },
    addWidget: function addWidget(el) {
      var me = this;
      var widgetId = $(el).attr("widget");
      var designer = me.createNewComponent(widgetId);
      $(designer.$el).insertAfter(el);
      $(el).remove();
    },
    addItem: function addItem(item, el) {

      var me = this;
      var widget = me.getWidget(item.widgetId);
      var designer = me.createNewComponent(widget, item);
      $(designer.$el).appendTo(el);
    },
    getCompData: function getCompData(comp) {
      var me = this;
      var containers = $(comp.designer.$el).find(".dragula-container");
      function isOwn(ct) {
        return $(ct).closest("[wid]")[0] === comp.designer.$el;
      }
      var data = _.cloneDeep(comp.data);
      containers.each(function () {
        var ct = this;
        if (isOwn(ct)) {
          var childNodes = ct.childNodes;
          if (!childNodes) return;
          var items = _.map(childNodes, function (node) {
            var wid = $(node).attr("wid");
            var c = me.compMap[wid];
            return c && me.getCompData(c);
          });
          if (comp.designer.setContainerData) {

            comp.designer.setContainerData(ct, items, data);
          }
        }
      });
      data.xtype = comp.xtype;
      data.widgetName = comp.widgetName;
      return data;
    },
    getData: function getData() {
      var me = this;
      var childNodes = me.$refs.center.childNodes;
      if (!childNodes) return [];
      return _.map(childNodes, function (node) {
        var wid = $(node).attr("wid");
        var comp = me.compMap[wid];
        return me.getCompData(comp);
      });
    },
    clear: function clear() {
      _.each(this.compMap, function (comp) {
        if (comp.designer) {
          comp.designer.$destroy();
          $(comp.designer.$el).remove();
        }
      });
      this.currentComp = {};
    } },

  watch: {
    currentComp: function currentComp(comp, oldComp) {
      if (oldComp && oldComp.designer) {
        $(oldComp.designer.$el).removeClass("designer-active");
      }
      if (comp && comp.designer) {
        $(comp.designer.$el).addClass('designer-active');
      }
    },
    dataItems: function dataItems(newValue) {
      if (!this.ready) return;
      this.clear();
      this.compMap = {};
      this.loadData();
    },
    widgets: function widgets() {
      this.initWidgets();
    } },

  computed: {
    allWidgets: function allWidgets() {
      return _widgets2.default.concat(this.widgets);
    } },


  beforeDestroy: function beforeDestroy() {



    this.clear();
    if (this.drake) this.drake.destroy();
  } };

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =








{
  props: {
    data: Array },

  name: "layout-renderer" };

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);
var settle = __webpack_require__(830);
var buildURL = __webpack_require__(832);
var parseHeaders = __webpack_require__(833);
var isURLSameOrigin = __webpack_require__(834);
var createError = __webpack_require__(296);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(835);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(836);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(831);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var base = window.$servicePath;exports.default =

{






  listCurUnit: function listCurUnit(unitId) {
    return _util2.default.ajax(base + '/api/common/listCurUnit', unitId);
  },




  listCurDepartment: function listCurDepartment() {
    return _util2.default.ajax(base + '/api/org/getLoginUserUnitDepartments');
  },











  listDepartmentByPrentId: function listDepartmentByPrentId(parentId) {
    return _util2.default.ajax(base + '/api/common/listDepartmentByPrentId', parentId);
  } };

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var base = window.$servicePath;exports.default =

{



  flowConfig: function flowConfig(params) {
    return _util2.default.ajax(base + '/api/config/flowConfig', params);
  },



  moduleConfig: function moduleConfig(params) {
    return _util2.default.ajax(base + '/api/config/moduleConfig', params);
  },



  getCircularObject: function getCircularObject(taskId, params) {
    return _util2.default.ajaxGet(base + '/api/project/getCircularObject', taskId, params);
  },



  appConfig: function appConfig() {
    return _util2.default.ajaxGet(base + '/api/config/appConfig');
  },






  getModuleFormField: function getModuleFormField(moduleId, appId) {
    return _util2.default.ajax(base + '/api/config/getModuleFormField', moduleId, appId);
  } };

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var base = window.$servicePath;exports.default =
{

  listPlannedSubByBatchIdAndActivityId: function listPlannedSubByBatchIdAndActivityId(batchId, activityId) {
    return _util2.default.ajax(base + '/api/process/listPlannedSubByBatchIdAndActivityId', batchId, activityId);
  },


  listLatestDefinition: function listLatestDefinition(params) {
    return _util2.default.ajax(base + '/api/process/listLatestDefinition', params.applicationId);
  },

  getLatestProcessData: function getLatestProcessData(params) {
    return _util2.default.ajax(base + '/api/process/getLatestProcessData', params);
  },



  getDefinition: function getDefinition(params) {
    return _util2.default.ajax(base + '/api/process/getData', params);
  },



  getFlowChartData: function getFlowChartData(params) {
    return _util2.default.ajax(base + '/api/process/getFlowChartData', params);
  },




  createDefinition: function createDefinition(params) {
    return _util2.default.ajax(base + '/api/process/create', params);
  },
  copyDefinition: function copyDefinition(params) {
    return _util2.default.ajax(base + '/api/process/copy', params);
  },
  removeDefinition: function removeDefinition(params) {
    return _util2.default.ajax(base + '/api/process/remove', params);
  },
  recoverDefinition: function recoverDefinition(params) {
    return _util2.default.ajax(base + '/api/process/recover', params);
  },



  updateDefinition: function updateDefinition(params) {
    return _util2.default.ajax(base + '/api/process/update', params);
  },






  enableDefinition: function enableDefinition(params) {
    return _util2.default.ajax(base + '/api/process/enableDefinition', params);
  },



  listExclusiveMarkDeletedDefinition: function listExclusiveMarkDeletedDefinition(appId, key) {
    return _util2.default.ajax(base + '/api/process/listExclusiveMarkDeletedDefinition', appId, key);
  },






  listMarkDeletedDefinition: function listMarkDeletedDefinition(appId, key) {
    return _util2.default.ajax(base + '/api/process/listMarkDeletedDefinition', appId, key);
  },
  getLatestProcessDefinitionTree: function getLatestProcessDefinitionTree(params) {
    return _util2.default.ajax(base + '/api/process/getLatestProcessDefinitionTree', params);
  },




  listFlowStart: function listFlowStart(params) {
    return _util2.default.ajax(base + '/api/process/listFlowStart', params);
  },
  countFlowNum: function countFlowNum(params) {
    return _util2.default.ajax(base + '/api/process/countFlowNum', params);
  },
  countFlowReadNum: function countFlowReadNum(params) {
    return _util2.default.ajax(base + '/api/process/countFlowReadNum', params);
  },



  countFlowAbDo: function countFlowAbDo(params) {
    return _util2.default.ajax(base + '/api/process/countFlowAbDo', params);
  },



  listFlowTodo: function listFlowTodo(params) {
    return _util2.default.ajax(base + '/api/process/listFlowTodo', params);
  },



  listFlowFinished: function listFlowFinished(params) {
    return _util2.default.ajax(base + '/api/process/listFlowFinished', params);
  },



  listDeptFlowFinished: function listDeptFlowFinished(params) {
    return _util2.default.ajax(base + '/api/process/listDeptFlowFinished', params);
  },



  listFlowDraft: function listFlowDraft(params) {
    return _util2.default.ajax(base + '/api/process/listFlowDraft', params);
  },



  listFlowToRead: function listFlowToRead(params) {
    return _util2.default.ajax(base + '/api/process/listFlowToRead', params);
  },




  listFlowFinishedRead: function listFlowFinishedRead(params) {
    return _util2.default.ajax(base + '/api/process/listFlowFinishedRead', params);
  },




  listFlowDynamicTodo: function listFlowDynamicTodo(params) {
    return _util2.default.ajax(base + '/api/process/listFlowDynamicTodo', params);
  },



  listFlowDynamicFinished: function listFlowDynamicFinished(params) {
    return _util2.default.ajax(base + '/api/process/listFlowDynamicFinished', params);
  },



  listFlowDynamicDraft: function listFlowDynamicDraft(params) {
    return _util2.default.ajax(base + '/api/process/listFlowDynamicDraft', params);
  },




  listFlowDoingWait: function listFlowDoingWait(params) {
    return _util2.default.ajax(base + '/api/process/listFlowDoingWait', params);
  },






  listFlowDelegation: function listFlowDelegation(params) {
    return _util2.default.ajax(base + '/api/process/listFlowDelegation', params);
  },





  listFlowFinishedDelegation: function listFlowFinishedDelegation(params) {
    params.finished = true;
    return _util2.default.ajax(base + '/api/process/listFlowDelegation', params);
  },





  listFlowAgent: function listFlowAgent(params) {
    return _util2.default.ajax(base + '/api/process/listFlowAgent', params);
  },





  listFlowFinishedAgent: function listFlowFinishedAgent(params) {
    params.finished = true;
    return _util2.default.ajax(base + '/api/process/listFlowAgent', params);
  },






  listFlowTrackDraft: function listFlowTrackDraft(params) {
    params.qType = 'draft';
    return _util2.default.ajax(base + '/api/process/listFlowTrack', params);
  },





  listFlowTrackAttention: function listFlowTrackAttention(params) {
    params.qType = 'attention';
    return _util2.default.ajax(base + '/api/process/listFlowTrack', params);
  },





  listFlowSuspend: function listFlowSuspend(params) {
    var key = params.key;

    if ('todo' == key) {
      params.excludeStatus = 'MONITORED';
      params.excludeActivityType = 'dynamic';
      params.notFromMe = true;
    } else if ('draft' == key) {
      params.excludeStatus = 'MONITORED';
      params.excludeActivityType = 'dynamic';
      params.fromMe = true;
    } else if ('dynamicdraft' == key) {
      params.activityType = 'dynamic';
      params.fromMe = true;
    } else if ('waitwork' == key) {
      params.status = 'MONITORED';
    }
    return _util2.default.ajax(base + '/api/process/listFlowSuspend', params);
  },




  countFlowSuspend: function countFlowSuspend(params) {
    var key = params.key;

    if ('todo' == key) {
      params.excludeStatus = 'MONITORED';
      params.excludeActivityType = 'dynamic';
      params.notFromMe = true;
    } else if ('draft' == key) {
      params.excludeStatus = 'MONITORED';
      params.excludeActivityType = 'dynamic';
      params.fromMe = true;
    } else if ('dynamicdraft' == key) {
      params.activityType = 'dynamic';
      params.fromMe = true;
    } else if ('waitwork' == key) {
      params.status = 'MONITORED';
    }
    return _util2.default.ajax(base + '/api/process/countFlowSuspend', params);
  },


  listWaitDeleteDoc: function listWaitDeleteDoc(params) {
    return _util2.default.ajax(base + '/api/process/listWaitDeleteDoc', params);
  },



  listFlowAbDo: function listFlowAbDo(params) {
    return _util2.default.ajax(base + '/api/process/listFlowAbDo', params);
  },

  claim: function claim(taskId, params) {
    if (!params) params = {};
    params.taskId = taskId;
    return _util2.default.ajax(base + '/api/process/claimByParams', params);
  },
  updateAccessTime: function updateAccessTime(params) {
    if (!params.batchId) return;
    return _util2.default.ajax(base + '/api/process/updateAccessTime', params);
  },
  getFlowProcess: function getFlowProcess(params) {
    return _util2.default.ajax(base + '/api/process/getFlowProcess', params.batchId, params);
  },
  getFlowOperationRecord: function getFlowOperationRecord(params) {
    return _util2.default.ajax(base + '/api/process/getFlowOperationRecord', params.batchId, params);
  },
  batchCommit: function batchCommit(params) {
    return _util2.default.ajax(base + '/api/process/batchCommit', params);
  },
  reject: function reject(params) {
    return _util2.default.ajax(base + '/api/process/reject', params);
  },
  save: function save(params) {
    return _util2.default.ajax(base + '/api/process/save', params);
  },



  batchCommitCircular: function batchCommitCircular(taskIds) {
    return _util2.default.ajax(base + '/api/process/batchCommitCircular', taskIds);
  },







  batchTransfer: function batchTransfer(taskIds, params) {
    return _util2.default.ajax(base + '/api/process/batchTransfer', taskIds, params);
  },
  transfer: function transfer(taskId, params) {
    return _util2.default.ajax(base + '/api/process/transfer', taskId, params);
  },





  batchAbGrab: function batchAbGrab(taskIds) {
    return _util2.default.ajax(base + '/api/process/batchAbGrab', taskIds);
  },







  resolve: function resolve(taskId, params) {
    return _util2.default.ajax(base + '/api/process/resolve', taskId, params);
  },







  checkCanTaken: function checkCanTaken(taskId, params) {
    return _util2.default.ajax(base + '/api/process/checkCanTaken', taskId, params);
  },





  taken: function taken(taskId, params) {
    return _util2.default.ajax(base + '/api/process/takenParams', taskId, params);
  },





  deleteCircularTask: function deleteCircularTask(params) {
    return _util2.default.ajax(base + '/api/process/deleteCircularTask', params);
  },





  checkCanUrge: function checkCanUrge(taskId) {
    return _util2.default.ajax(base + '/api/process/checkCanUrge', taskId);
  },







  checkAllCanUrge: function checkAllCanUrge(batchId, taskId) {
    return _util2.default.ajax(base + '/api/process/checkAllCanUrge', batchId, taskId);
  },



  batchSuspend: function batchSuspend(taskIds) {
    return _util2.default.ajax(base + '/api/process/batchSuspend', taskIds);
  },



  batchSuspendReleaseWH: function batchSuspendReleaseWH(params) {
    return _util2.default.ajax(base + '/api/process/batchSuspendReleaseWH', params);
  },




  batchActivate: function batchActivate(businesses) {
    return _util2.default.ajax(base + '/api/process/batchActivate', businesses);
  },
  batchActivateDocs: function batchActivateDocs(businesses) {
    return _util2.default.ajax(base + '/api/process/batchActivateDocs', businesses);
  },





  batchMarkDelete: function batchMarkDelete(businesses) {
    return _util2.default.ajax(base + '/api/process/batchMarkDelete', businesses);
  },






  saveVirtualRecord: function saveVirtualRecord(params) {
    return _util2.default.ajax(base + '/api/process/saveVirtualRecord', params);
  },





  getBindLeaderData: function getBindLeaderData(taskId) {
    return _util2.default.ajax(base + '/api/process/getBindLeaderData', taskId);
  },
  delegateSecretaryRecord: function delegateSecretaryRecord(params) {
    return _util2.default.ajax(base + '/api/process/delegateSecretaryRecord', params);
  },
  delegateSendSecretary: function delegateSendSecretary(params) {
    return _util2.default.ajax(base + '/api/process/delegateSendSecretary', params);
  },
  delegateSendLeader: function delegateSendLeader(params) {
    return _util2.default.ajax(base + '/api/process/delegateSendLeader', params);
  },
  thoroughDeleteDoc: function thoroughDeleteDoc(params) {
    return _util2.default.ajax(base + '/api/process/thoroughDeleteDoc', params);
  },




  getFlows: function getFlows(taskId, params) {
    return _util2.default.ajax(base + '/api/process/getFlows', taskId, params);
  },


  getFlowGroups: function getFlowGroups(taskId, flowId, params) {
    return _util2.default.ajax(base + '/api/process/getFlowGroups', taskId, flowId, params);
  },



  getFlowGroupUserOrPositions: function getFlowGroupUserOrPositions(taskId, flowId, groupId, params) {
    return _util2.default.ajax(base + '/api/process/getFlowGroupUserOrPositions', taskId, flowId, groupId, params);
  },

  getCanRejectTo: function getCanRejectTo(params) {
    return _util2.default.ajax(base + '/api/process/getCanRejectTo', params.taskId);
  },


  getTaskEntityData: function getTaskEntityData(taskId) {
    return _util2.default.ajax(base + '/api/process/getTaskEntityData', taskId);
  },

  listModuleLatestProcDefTree: function listModuleLatestProcDefTree(params) {
    return _util2.default.ajax(base + '/api/process/listModuleLatestProcDefTree', params);
  },
  getActivityFlows: function getActivityFlows(params) {
    return _util2.default.ajax(base + '/api/process/getActivityFlows', params);
  },





  getWorkFlows: function getWorkFlows(params) {
    return _util2.default.ajax(base + '/api/process/getWorkFlows', params);
  },





  getWorkFlowLists: function getWorkFlowLists(params) {
    return _util2.default.ajax(base + '/api/process/getWorkFlowLists', params);
  },





  getWorkFlowTrees: function getWorkFlowTrees(params) {
    return _util2.default.ajax(base + '/api/process/getWorkFlowTrees', params);
  },





  planned: function planned(params) {
    return _util2.default.ajax(base + '/api/process/planned', params);
  },





  batchTakenSubProcess: function batchTakenSubProcess(params) {
    return _util2.default.ajax(base + '/api/process/batchTakenSubProcess', params);
  },




  getPlannedFlows: function getPlannedFlows(params) {
    return _util2.default.ajax(base + '/api/process/getPlannedFlows', params);
  },
  getNextActivityCandidates: function getNextActivityCandidates(params) {
    return _util2.default.ajax(base + '/api/process/getNextActivityCandidates', params);
  },
  refreshProcessCache: function refreshProcessCache() {
    return _util2.default.ajax(base + '/api/process/refreshProcessCache');
  } };

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var ResourceLock = function () {
  function ResourceLock(params) {(0, _classCallCheck3.default)(this, ResourceLock);
    this.resourceId = params.resourceId;
    this.userId = params.userId || PF.userInfo.inituserid;
    this.userName = params.userName || PF.userInfo.initusername;
    this.initunitid = params.initunitid || PF.userInfo.initunitid;
    this.sessionId = params.sessionId;
    this.resTableName = params.resTableName;
    this.docName = params.docName;

  }(0, _createClass3.default)(ResourceLock, [{ key: "unlock", value: function unlock(

    callback) {
      var me = this;
      if (me.unLocked) return;
      me.unLocked = true;
      PF.fsrv("resource.lock.srv.unLock", {
        resourceId: this.resourceId,
        userId: this.userId,
        userName: this.userName,
        sessionId: this.sessionId,
        initunitid: this.initunitid }).
      then(function (o) {
        if (me.intervalId) clearInterval(me.intervalId);
        callback && callback(o);
      });
    } }, { key: "updateLock", value: function updateLock()

    {
      var me = this;
      var resourceLockIntervalTime = window.$Env && $Env.resourceLockIntervalTime || 100000;
      me.intervalId = setInterval(function () {
        me.tryLock(null, true);
      }, resourceLockIntervalTime);
    } }, { key: "tryLock", value: function tryLock(
    callback, noInterval) {
      var me = this;
      PF.fsrv("resource.lock.srv.tryLock", {
        resourceId: this.resourceId,
        userId: this.userId,
        userName: this.userName,
        sessionId: this.sessionId,
        resTableName: this.resTableName,
        docName: this.docName },
      function (r) {
        r = r && r.result;
        if (!noInterval && r && r.success) {
          me.updateLock();
        }
        if (callback) {
          callback(r);
        }
      });
    } }, { key: "destroy", value: function destroy()

    {
      if (this.intervalId) clearInterval(this.intervalId);
    } }]);return ResourceLock;}();

window.ResourceLock = ResourceLock;exports.default =

ResourceLock;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =























{
  name: 'MwButton',

  inject: {
    elFormItem: {
      default: '' } },



  props: {
    type: {
      type: String,
      default: 'default' },

    size: String,
    icon: {
      type: String,
      default: '' },

    nativeType: {
      type: String,
      default: 'button' },

    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean },


  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize: function buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    } },


  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    },
    handleInnerClick: function handleInnerClick(evt) {
      if (this.disabled) {
        evt.stopPropagation();
      }
    } } };

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });









var _data = __webpack_require__(206);var _data2 = _interopRequireDefault(_data);
var _app = __webpack_require__(91);var _app2 = _interopRequireDefault(_app);
var _config = __webpack_require__(301);var _config2 = _interopRequireDefault(_config);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var newForm = void 0;exports.default =


{
  name: 'MwGeneralForm',
  data: function data() {
    return {
      entityId: '',
      formName: '',
      buttons: [] };

  },
  props: {
    formId: String,
    appId: String },

  mounted: function mounted() {
    this.renderForm(this.formId);
  },
  methods: {
    resetForm: function resetForm() {
      this.formName = '';
      this.buttons = [];
      $("#mw-form").empty();
    },
    renderForm: function renderForm(formId) {
      var me = this;
      if (formId) {
        _config2.default.formConfig(this.businessId, formId, this.appId).then(function (data) {
          var res = data.result;
          me.formName = res.name;
          me.entityId = res.entityId;
          $WR.ready(function (manager) {
            manager.create({ xtype: 'Form', $dd: res.content }, function (form) {
              newForm = form;
              newForm.render($("#mw-form"));
              newForm.setValue(res.formData);
            });
          });
        });
      } else {
        me.resetForm();
      }
    },
    formData: function formData() {
      return newForm && newForm.getValue();
    },
    saveFormData: function saveFormData() {
      var me = this;
      var params = {
        formId: this.formId,
        appId: this.appId,
        entityId: this.entityId,
        values: me.formData() };

      _data2.default.saveFormData(params).then(function (data) {
        me.$emit("formActionComplete");
      });
    } },

  watch: {
    formId: function formId(newVal) {
      this.formId = newVal;
      this.renderForm(newVal);
    } } };

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);var _defineProperty = __webpack_require__(112);var _defineProperty2 = _interopRequireDefault(_defineProperty);var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);










































































































































var _lodash = __webpack_require__(98);var _lodash2 = _interopRequireDefault(_lodash);
var _util = __webpack_require__(16);
var _vue = __webpack_require__(11);var _vue2 = _interopRequireDefault(_vue);
var _vuex = __webpack_require__(9);
__webpack_require__(879);
var _formExpContext = __webpack_require__(307);var _formExpContext2 = _interopRequireDefault(_formExpContext);
var _bpmTask = __webpack_require__(308);var bpmTaskApi = _interopRequireWildcard(_bpmTask);

var _resourceLock = __webpack_require__(303);var _resourceLock2 = _interopRequireDefault(_resourceLock);

var _flowActionArea = __webpack_require__(916);var _flowActionArea2 = _interopRequireDefault(_flowActionArea);
var _flowActionTopArea = __webpack_require__(922);var _flowActionTopArea2 = _interopRequireDefault(_flowActionTopArea);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  name: 'MwForm',
  components: {
    "flow-action-area": _flowActionArea2.default,
    "flow-action-top-area": _flowActionTopArea2.default },

  data: function data() {
    var me = this,commentId = $uuid();
    var pos = window.$Env && $Env.formFlowAreaPosition || "right";
    var rightCustomCompId = window.$Env && $Env.formRightCustomCompId || "";;
    return {
      flowActionPosition: pos,
      rightCustomCompId: rightCustomCompId,
      formValueChange: false,
      editMode: me.propEditMode,
      footerButton: [],
      action: '',
      taskComments: [],
      $newForm: undefined,
      commentComponent: [],
      $commentMinComponent: [],
      components: [],
      flowAreaBottomSelRowHeight: 34,
      createTime: '',
      type: '',
      taskId: '',
      batchId: '',
      businessId: '',
      draftsDocId: '',
      flowStarted: false,
      formId: '',
      formKey: '',
      formVersion: '',
      formName: '',
      processDefinitionId: '',
      processDefinitionName: '',
      activityId: '',
      tempBusinessId: '',
      tempTableName: '',
      authFields: undefined,
      extCustomCommentCompId: '',

      form: {
        data: null,
        ver: 1 },

      activity: undefined,
      buttons: [],
      notLoadFlows: window.$Env && window.$Env.formNotLoadFlows,
      flows: [],
      curTackName: "",
      comments: [],

      comment: '',
      commentId: commentId,
      isUpdateComment: false,
      commentCategory: '',


      fieldMapping: {},

      moduleId: '',
      appId: '',
      flowKey: '',


      attachmentData: [],
      taskData: [],

      loaded: false,
      counter: 0,
      formOpenSource: '',

      extData: undefined,






      extraFormField: {},
      formCustomComps: {},
      lockSuccess: true,
      lockErrorMsg: "",
      normalFlowBtn: false,
      fjheight: '110px',
      showSelComment: true,
      disabledComment: false,
      showRightComment: false };

  },
  props: {
    dialog: Object,
    initValue: {
      type: Object,
      default: function _default() {
        return {};
      } },

    propLoading: {
      type: Object },

    extParams: {
      type: Object,
      default: function _default() {
        return {};
      } },





    autoClaim: {
      type: Boolean,
      default: true },

    forceModuleForm: {
      type: Boolean,
      default: false },

    flowModuleNotShowRightPanel: {
      type: Boolean,
      default: false },

    propReadOnly: {
      type: Boolean,
      default: false },

    propModuleId: String,
    propAppId: String,
    propIsCheck: {
      type: Boolean,
      default: false },

    propCheckFromName: String,
    propFlowKey: String,
    propTaskId: String,
    propBusinessId: String,
    propDraftsDeptId: String,
    propDraftsDocId: String,
    propBatchId: String,
    propTempBusinessId: String,
    propTempTableName: String,
    propProcessDefinitionId: String,
    propEditMode: {
      type: Boolean,
      default: true },

    propFormOpenSource: String,
    openType: String },

  created: function created() {
    this.taskId = this.propTaskId;
    this.batchId = this.propBatchId;
    this.businessId = this.propBusinessId;
    this.draftsDocId = this.propDraftsDocId;
    this.moduleId = this.propModuleId;
    this.appId = this.propAppId;
    this.flowKey = this.propFlowKey;
    this.isCheck = this.propIsCheck;
    this.checkFromName = this.propCheckFromName;
    if (!this.businessId) {
      if (this.propTempBusinessId) {
        this.tempBusinessId = this.propTempBusinessId;
      } else {
        this.tempBusinessId = $uuid();
      }
      if (this.propTempTableName) {
        this.tempTableName = this.propTempTableName;
      }
    } else {
      this.tempBusinessId = '';
    }
    this.formOpenSource = this.propFormOpenSource;
  },
  mounted: function mounted() {

    var me = this;
    if (this.isTopArea) {
      if (this.batchId) {
        this.mwApi.business.listComment({ batchId: this.batchId, "excludeHidden": '2' }).then(function (res) {
          res = res.result ? res.result : res;
          me.taskComments = res;
        });
      }
      this.$nextTick(function () {
        $(".mw-open-form .mw-form-left-con").css("overflow-y", "inherit").css("padding-right", "0px");
        $("html").css("overflow-y", "hidden");
      });
    }
    this.renderForm();
  },
  beforeDestroy: function beforeDestroy() {
    try {
      this.$newForm.destroy();
    } catch (e) {
    }
  },
  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'expUser',
  'userInfo',
  'initInfo']), {

    isVerticalArea: function isVerticalArea() {
      return this.flowActionPosition === "top" || this.flowActionPosition === "bottom";
    },
    isBottonArea: function isBottonArea() {
      return this.flowActionPosition === "bottom";
    },
    isTopArea: function isTopArea() {
      return this.flowActionPosition === "top";
    } }),

  methods: {
    downAttachment: function downAttachment(id) {
      if (!id) return;
      var formId = this.formId;
      var businessId = this.tempBusinessId || this.businessId;
      if (!businessId || !formId) {
        return;
      }
      if (window.$Env && $Env.notdownloadAttachment) {
        var p = {
          "id": id,
          "businessId": businessId,
          "formId": formId,
          "tempBusinessId": this.tempBusinessId };

        PF.action.attachment_preview(p);
      } else {
        this.mwUtil.downloadAttachment2({
          url: '/api/business/downloadAttachment',
          params: {
            "id": id,
            "businessId": businessId,
            "formId": formId,
            "tempBusinessId": this.tempBusinessId } });


      }
    },
    refleshAttachmentList: function refleshAttachmentList(formId_, businessId_, tempBusinessId_) {
      var me = this;
      var formId = formId_ || this.formId;
      var businessId = businessId_ || this.businessId;
      var tempBusinessId = tempBusinessId_ ? tempBusinessId_ : "";
      if (!businessId && !tempBusinessId || !formId) {
        return;
      }
      this.mwApi.business.listAttachment({ "businessId": businessId, "formId": formId, "type": "JOA_FJ", "tempBusinessId": tempBusinessId }).then(function (res) {
        me.attachmentData = res.result;
      });
    },
    getFormValueChange: function getFormValueChange() {

      return !this.$newForm || this.$newForm.isDirty();
    },
    setEditMode: function setEditMode(editMode) {var _this = this;
      var me = this;
      if (me.editMode === editMode) return;
      var formValues = void 0;
      if (me.$newForm) {
        formValues = me.$newForm.getValue();
        me.$newForm.destroy();
        me.$newForm = undefined;
      }

      this.mwLodash.remove(me.footerButton, function (n) {
        return true;
      });


      me.editMode = editMode;
      me.renderFormContent();
      if (formValues) {
        me.$once("beforeRender", function () {
          $(_this.$el.querySelector('.mw-form_id')).empty();
          me.$nextTick(function () {
            me.$newForm.setValue(formValues);
          });
        });
      }
    },
    editComment: function editComment() {
      var params = {};
      params.comment = this.comments.slice();
      PF.show('commentEdit', params, this._comment);
    },

    addComment: function addComment() {
      var a = [],me = this;
      var c = me.comment.replace(/\n/g, '');
      if (c == '') {
        return;
      }
      this.comments.push({ 'title': c });
      this.comments.forEach(function (d) {
        a.push(d.title);
      });
      me.mwApi.org.updateUserInfo({ options: a.join('\n') }).then(function () {
        me.$store.dispatch('GetUserInfo');
      });
    },
    _comment: function _comment(data) {
      var a = [],me = this;
      data.forEach(function (d) {
        a.push(d.title);
      });
      me.mwApi.org.updateUserInfo({ options: a.join('\n') }).then(function () {
        me.$store.dispatch('GetUserInfo');
      });
      this.comments = data;
    },



    selComment: function selComment(title) {
      this.comment = title;
    },
    resetForm: function resetForm() {
      this.formName = '';
      this.buttons = [];
      this.comments = [];
      this.comment = '';
      if (this.$newForm) {
        this.$newForm.destroy();
        this.$newForm = undefined;
      }
      this.components = [];
      this.commentComponent = [];
      this.$commentMinComponent = [];
      $(this.$el.querySelector('.mw-form_id')).empty();
    },

    renderForm: function renderForm() {
      var me = this;
      if (me.moduleId) {

        if (me.taskId) {
          me.mwApi.process.getTaskEntityData(me.taskId).then(function (data) {
            me.taskData = data.result;
            me.processDefinitionId = me.taskData.processDefinitionId;
            me.activityId = me.taskData.activityId;
            if (!me.taskData.claimTime && !me.taskData.finishTime && me.autoClaim) {
              var claimParams = {};
              if (me.extParams && me.extParams.fullAuthType) {
                claimParams.fullAuthType = me.extParams.fullAuthType;
              }
              me.mwApi.process.claim(me.taskId, claimParams).then(function (res) {
                me.$emit("updatedData", true);

                if (res && res.result && res.result.startTaskId) {
                  me.taskId = res.result.startTaskId;
                  me.mwApi.process.getTaskEntityData(me.taskId).then(function (data) {
                    me.taskData = data.result;
                    me.processDefinitionId = me.taskData.processDefinitionId;
                    me.activityId = me.taskData.activityId;
                    me.renderTaskForm(me.taskData);
                  });
                } else {
                  me.renderTaskForm(me.taskData);
                }
              });
            } else {
              me.renderTaskForm(me.taskData);
            }
          });
        } else {
          if (me.propProcessDefinitionId) {
            me.processDefinitionId = me.propProcessDefinitionId;
          } else {
            me.processDefinitionId = "";
          }
          me.activityId = '';
          me.renderStartForm();
        }

      } else {
        me.resetForm();
      }
    },
    updateAccessTime: function updateAccessTime() {
      var me = this;
      if (window.$Env && $Env.openFormUpdateAccessTime && me.type == 'module_flow' && me.batchId) {
        var params = { batchId: me.batchId };
        if (me.extParams && me.extParams.fullAuthType) {
          params.fullAuthType = me.extParams.fullAuthType;
        }
        me.mwApi.process.updateAccessTime(params);
      }
    },
    renderStartForm: function renderStartForm() {
      var me = this;

      if (me.type != 'module_normal') {
        me.renderComments();
      }
      me.renderFormContent(true);
    },
    renderTaskForm: function renderTaskForm(t) {
      var me = this;
      if (t.finishTime || t.suspensionState == 2) {
        me.editMode = false;
        me.renderFormContent(false);
      } else {
        me.normalFlowBtn = true;
        if (!me.flowModuleNotShowRightPanel) {
          me.editMode = true;
        }
        me.renderFormContent(true);

        if (me.type != 'module_normal') {
          me.renderComments();
        }
      }
    },
    renderTaskFormFlowTip: function renderTaskFormFlowTip(callback) {
      var me = this;
      if (me.type === 'module_normal') {
        return;
      }
      if (me.taskId) {
        var params = { taskId: me.taskId };
        if (me.$newForm) {
          me.$newForm.fireEvent("rendertaskformflow", params);
        }
        if (me.notLoadFlows) {
          if (callback) callback(me.flows);
          return;
        }
        bpmTaskApi.getTaskFlow(params).then(function (data) {
          if (data) {
            me.flows = data;
            if (callback) callback(me.flows);
          }
        });
      } else {
        if (me.processDefinitionId) {
          PF.ajax("api/process/getStartFlows", { processDefinitionId: me.processDefinitionId }).then(function (data) {
            if (data.result)
            me.flows = data.result;
            if (callback) callback(me.flows);
          });
        }
      }
    },
    renderComments: function renderComments() {
      var me = this;
      var option = me.userInfo.data.options;
      if (option == undefined) {
        me.comments = [];
      } else {
        var options = option.split('\n');
        options.forEach(function (v) {
          me.comments.push({ title: v });
        });
      }
    },
    renderFormContent: function renderFormContent(flowFlag) {var _this2 = this;
      var me = this;
      var params = {};
      if (me.businessId) {
        params.dataId = me.businessId;
      } else {
        var tempId = "";
        if (this.propTempBusinessId) {
          tempId = "_" + this.tempBusinessId;
        }
        params.dataId = tempId;
        if (me.tempTableName) {
          params.tempTableName = me.tempTableName;
        }
      }

      params.taskId = me.taskId;
      if (me.taskId) {
        params.processDefinitionId = me.processDefinitionId;
        params.activityId = me.activityId;
      }
      params.processDefinitionKey = me.flowKey;
      params.flowFlag = flowFlag == undefined ? true : flowFlag;
      params.forceModuleForm = me.forceModuleForm;
      params.normalFlowBtn = me.normalFlowBtn;
      params.moduleId = me.moduleId;
      params.appId = me.appId;
      params.draftsDocId = me.draftsDocId;
      params.formOpenSource = me.formOpenSource;
      params.taskType = me.taskData && me.taskData.type;
      params.propReadOnly = me.propReadOnly;

      if (params.taskId && params.dataId && !me.propReadOnly && !(window.$Env && $Env.notOpenDocLockEditMode)) {
        params.tryLockEditMode = "1";
      }
      me.mwApi.config.moduleConfig(params).then(function (data) {
        var res = data.result;
        me.formId = res.formId;
        var resId = res.formData && res.formData.id;
        if (resId && res.attr && res.attr.set && res.attr.set.savereadmarks) {
          PF.fsrv('read.state.markRead', { resId: resId, userId: me.expUser.id, formId: res.formId });
        }
        if (res.lockSuccess === true) {

          var lock = new _resourceLock2.default({ resourceId: params.dataId, resTableName: me.formId, docName: res.formData.fldtm, initunitid: res.formData.initunitid });
          lock.updateLock();
          me.$on("formActionComplete", function () {return lock.unlock();});
          me.$on("dialogClose", function () {return lock.unlock();});
        } else if (res.lockSuccess === false) {
          me.lockSuccess = false;
          me.lockErrorMsg = res.lockErrorMsg;
          me.readOnly = true;
        } else {

        }
        me.$emit("configLoaded", res);
        me.appId = res.appId;
        me.formVersion = res.formVersion;
        me.formKey = res.formKey;
        me.formName = res.name;
        me.moduleShortName = res.shortName;
        if (window.$Env && $Env.formFlowBottomAreaModules && $Env.formFlowBottomAreaModules.indexOf(me.moduleShortName) != -1) {
          me.flowActionPosition = "bottom";
        }
        me.type = res.type;


        if (!me.taskId && me.type === "module_flow" && me.businessId && me.propEditMode !== "true") {
          me.editMode = false;
          me.readOnly = true;
        }
        me.createTime = res.createTime;
        if (me.editMode)
        me.authFields = res.authFields;else

        me.authFields = {};
        me.extData = res.extData;
        if (res.attr && res.attr.fieldMapping) {
          me.fieldMapping = res.attr.fieldMapping;
        }
        if (res.draftsDocId != undefined) {
          me.businessId = res.draftsDocId;
        }
        if (res.tempDraftsDocId != undefined) {
          me.tempBusinessId = res.tempDraftsDocId;
        }
        if (res.flowStarted != undefined) {
          me.flowStarted = res.flowStarted;
        }
        var formData = res.formData;
        if (formData) {

          if (!me.batchId && formData.initbatchid) {
            me.batchId = formData.initbatchid;
          }

          if (!me.processDefinitionId && formData.initprocdefid) {
            me.processDefinitionId = formData.initprocdefid;
          }

          if (res.formData && res.formData['#items']) {
            var attachment = [];
            res.formData['#items'].forEach(function (v) {
              if (v.type == "JOA_FJ") {
                attachment.push(v);
              }
            });
            me.attachmentData = attachment;

          }
          me.updateAccessTime();
        }
        if (!me.businessId) {
          if (!formData) {
            formData = {};
          } else {
            delete formData.id;
          }
        }
        if (data.result.activity) {
          me.activity = data.result.activity;
          me.processDefinitionId = me.activity.processDefinitionId;
          me.flowKey = me.activity.processDefinitionKey;
          me.processDefinitionName = me.activity.processDefinitionName;
          me.curTackName = me.activity.name;
          me.renderDefaultComment();
        }
        if (data.result.components) {
          var c = data.result.components;
          c.forEach(function (v) {

            v.loading = false;
            v.name = $lang(v.name);
            me.buttons.push(v);

          });
        }
        me.$nextTick(function () {
          me._originalFormData = formData;
          me._renderForm(res.content, formData);
          if (_this2.isTopArea) {
            var cutHeight = 215 + 60;
            if (!me.editMode) cutHeight = 110;
            var fjheight = ($(".mw-open-form .mw-form-right-con").height() - cutHeight) / 2;
            if (fjheight < 80) {
              _this2.fjheight = 80 + 'px';
            } else {
              _this2.fjheight = fjheight + 'px';
            }
          }
          if (me.activity && !me.isVerticalArea) {
            me.renderTaskFormFlowTip(function () {
              if (me.rightCustomCompId) me.processRightCustomComp();
            });
          }
          if (me.$newForm) {
            me.$newForm.refleshAttachmentList = me.refleshAttachmentList;
          }
        });
      }).catch(function (msg) {
        if (window.console) window.console.log(msg);
      });
    },

    _renderForm: function _renderForm(con, value) {
      var me = this;
      var formValue = void 0;
      var initInfo = _lodash2.default.pickBy(me.initInfo, function (v, k) {return _lodash2.default.startsWith(k, "init");});
      if (this.businessId) {
        if (!value) {
          if (me.type == 'module_normal') {
            formValue = me.mwLodash.assign({ initcreatedtime: me.createTime, initappid: me.appId }, initInfo, me.initValue, { id: this.businessId });
          }
        } else {
          formValue = value;
        }
      } else {
        var flow = {};
        if (me.type == 'module_flow') {
          flow.initflowid = me.processDefinitionId;
          flow.initflowkey = me.flowKey;
          flow.moduleId = me.moduleId;
          flow.initflowname = me.processDefinitionName;
        } else {
          flow.moduleId = me.moduleId;
        }
        if (me.forceModuleForm) {
          formValue = me.mwLodash.assign(value, { initcreatedtime: me.createTime, initappid: me.appId }, flow, initInfo, me.initValue);
        } else {
          formValue = me.mwLodash.assign({ initcreatedtime: me.createTime, initappid: me.appId }, flow, initInfo, me.initValue, value);
        }
      }

      function fnImbeddedObjResolver(objId) {
        return new function (formField) {
          var value = [];
          var component;
          var $data;
          var $obj;
          PF.apply(this, {
            init: function init(d, obj) {
              $data = d;
              $obj = obj;
            },
            mount: function mount(fnMount) {
              var html;
              var config = (0, _assign2.default)({
                expUser: me.expUser,
                getForm: function getForm() {
                  return me.$newForm;
                },
                getCurrentObject: function getCurrentObject() {
                  return $obj;
                },
                $previewMode: false,
                getFormValue: function getFormValue() {
                  return me.formData();
                },
                getConfig: function getConfig() {
                  return $data;
                },
                getData: function getData() {
                  return {
                    businessId: me.businessId,
                    tempBusinessId: me.tempBusinessId,
                    formKey: me.formKey,
                    formId: me.formId,
                    formVersion: me.formVersion };

                },
                getFormObject: function getFormObject() {
                  return me;
                } });


              switch (objId) {
                case 'attachment-list':{
                    component = new (_vue2.default.component('form-attachment-list'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'attachment-list-min':{
                    component = new (_vue2.default.component('form-attachment-list-min'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'document-editor':{
                    component = new (_vue2.default.component('form-document-editor'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'zw-attachment-list':{
                    component = new (_vue2.default.component('form-zw-attachment-list'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'comment-list':{
                    component = new (_vue2.default.component('form-comment-list'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'comment-list-min':{
                    component = new (_vue2.default.component('form-comment-list-min'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'imbedded-view':{
                    component = new (_vue2.default.component('form-imbedded-view'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'rel-file-selection':{
                    component = new (_vue2.default.component('form-rel-file-selection'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                default:{
                    if ($data.pageType === "page") {
                      component = PF.createVue({
                        template: "<mw-inner-page :pageId='pageId' noWrap :params='params'></mw-inner-page>",
                        data: {
                          pageId: objId,
                          params: { data: me._data, config: config } } });


                      fnMount(component.$mount().$el);
                    } else if ($data.pageType === "pageData" && $obj.getPageData) {
                      var pageData = $obj.getPageData();
                      pageData.params = { data: me._data, config: config };
                      component = PF.createVue(pageData);
                      if ($obj.$dd.name) {
                        me.formCustomComps[$obj.$dd.name] = component;
                      }
                      fnMount(component.$mount().$el);
                    }
                  }}

              if (objId == 'comment-list') {
                me.commentComponent.push(component);
              }
              if (objId == 'comment-list-min') {
                me.$commentMinComponent.push(component);
              }
              if (component) me.components.push(component);
              if (html) {
                fnMount($('<div>' + html + '</div>'));
              }
              return component;
            },
            onEvent: function onEvent(args) {var _this3 = this;
              if (component) {
                if (component.dealWithEvent) {
                  component.dealWithEvent(args);
                }
              } else {
                if (args.dd.viewId && args.data.id) {
                  me.mwApi.app.getApplicationItems([args.dd.viewId], "").then(function (res) {
                    var mixId = res.result[0].content.table.moduleId;
                    if (mixId) {
                      var _me = _this3;
                      var p = {};
                      p.businessId = args.data.id;
                      p.moduleId = mixId;
                      p.size = 'large_large';
                      p.type = 'normal';
                      p.editMode = _me.editMode;
                      p.appId = '';
                      PF.show('normalForm', p, function () {
                      });
                    }
                  });

                }
              }
            },
            setValue: function setValue(value) {

            },
            getValue: function getValue() {

            },
            setReadOnly: function setReadOnly() {
            },
            destroy: function destroy() {
              try {
                if (component)
                component.$destroy();
              } catch (e) {
                if (window.console && console.error) console.error(e);
              }
            },
            show: function show(ops) {

              var config = (0, _assign2.default)({
                expUser: me.expUser,
                getForm: function getForm() {
                  return me.$newForm;
                },
                getCurrentObject: function getCurrentObject() {
                  return $obj;
                },
                $previewMode: false,
                getFormValue: function getFormValue() {
                  return me.formData();
                }, getConfig: function getConfig() {
                  return $data;
                }, getData: function getData() {
                  return {
                    businessId: me.businessId,
                    tempBusinessId: me.tempBusinessId,
                    draftsDocId: me.draftsDocId,
                    formKey: me.formKey,
                    formId: me.formId,
                    formVersion: me.formVersion };

                }, getFormObject: function getFormObject() {
                  return me;
                } });


              switch (objId) {
                case 'department-selection':{
                    var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                    PF.show('orgSelect', { multiple: multiple, config: config, value: ops.getValue() }, function (data) {
                      ops.setValue(data);
                      me.$newForm.fireEvent("afterorgSelect", data, $obj);
                    });
                    break;
                  }
                case 'user-selection':{
                    var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                    PF.show('orgSelect', { multiple: multiple, config: config, value: ops.getValue() }, function (data) {
                      ops.setValue(data);
                      me.$newForm.fireEvent("afterorgSelect", data, $obj);
                    });
                    break;
                  }
                case 'department-user-selection':{
                    var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                    PF.show('orgSelect', { multiple: multiple, config: config, value: ops.getValue() }, function (data) {
                      ops.setValue(data);
                      me.$newForm.fireEvent("afterorgSelect", data, $obj);
                    });
                    break;
                  }
                case 'custom-selection':{

                    var multi = !$data.singleSel;
                    PF.show('viewSelect', { id: $data.viewId, config: config, multi: multi }, function (data) {
                      if (data) {
                        ops.setValue(data);
                      } else {
                        ops.setValue();
                      }
                    });
                    break;
                  }
                default:{
                    if ($data.pageType == "page") {
                      config.setExtraFormField = function (d) {
                        me.extraFormField = d;
                      };
                      config.$obj = $obj;
                      config.ops = ops;
                      var params = { config: config, modelId: me.moduleId };
                      PF.dialog("mw-inner-page", { title: $data.pageTitle, width: $data.pageWidth, height: $data.pageHeight,
                        propsData: { pageId: objId, params: params } });
                    }
                  }}


            },
            hide: function hide(ops) {
              ops.setValue(value);
            } });

        }(this);
      }

      function fnDataItemResolver(dict, params, setDataItems) {
        if ($.isFunction(params) && !setDataItems) {
          setDataItems = params;
          params = {};
        }
        me.mwApi.data.getDict(dict, params).then(function (data) {
          if (data.result && data.result.value) {
            var v = data.result.value.split(',');
            var v1 = [];
            var items = [];
            v.forEach(function (d) {
              v1 = d.split('|');
              items.push({ text: v1[1] || v1[0], value: v1[0] });
            });
            setDataItems(items);
          }
        });
      }

      function fnDataResolver(args) {
        if ('org-sel-default-value' === args.dataId) {
          me.mwApi.org.getCurrent(args.params).then(function (v) {
            args.fnSetData(v);
          });
        }

        if ('file-number-auto-generate' === args.dataId) {var
          shouldGenerateFileNumber = args.shouldGenerateFileNumber,getGenerateFileNumberParmas = args.getGenerateFileNumberParmas,beforeSetGeneratedFileNumber = args.beforeSetGeneratedFileNumber,setGeneratedFileNumber = args.setGeneratedFileNumber,updateRequestParams = args.updateRequestParams,afterGenerateFileNumber = args.afterGenerateFileNumber;

          var formData = me.formData();

          if (shouldGenerateFileNumber(formData)) {
            var p = getGenerateFileNumberParmas(formData);
            me.mwApi.oasrv.generateAutoDocNumber(p).then(function (res) {
              if (res.success && res.result) {
                me.extraFormField = beforeSetGeneratedFileNumber(res.result);
                setGeneratedFileNumber(res.result);
                updateRequestParams(function (params) {
                  me.mwLodash.assign(params.$form, me.formData());
                });
              }
            }).then(afterGenerateFileNumber, afterGenerateFileNumber);
          } else {
            afterGenerateFileNumber();
          }
        }
      }

      var constantValues = {
        taskId: me.taskId,
        appId: me.appId,
        businessId: me.businessId,
        draftsDocId: me.draftsDocId,
        taskData: me.taskData,
        extParams: me.extParams,
        flowKey: me.flowKey,
        moduleId: me.moduleId,
        extData: me.extData ? me.extData : {},
        formId: me.formId,
        formKey: me.formKey,
        formVersion: me.formVersion,
        activity: me.activity,
        tempBusinessId: me.tempBusinessId,
        fieldMapping: me.fieldMapping,
        formName: me.formName,
        processDefinitionId: me.processDefinitionId,
        processDefinitionName: me.processDefinitionName };


      $WR.ready(function (manager) {
        var content = con;
        content.hideHead = true;
        content.textMode = !me.editMode || me.isNotifyTask() || me.isReadOnlyTask();
        me.$emit("getTitle", content.name || content.title);
        manager.create({
          xtype: 'Form',
          constantValues: constantValues,
          resolvers: {
            fnDataResolver: fnDataResolver,
            fnDataItemResolver: fnDataItemResolver,
            fnImbeddedObjResolver: fnImbeddedObjResolver },

          $dd: content,
          $cc: me.authFields,
          user: me.expUser,
          values: formValue },
        function (form) {
          var mark = me.activity && me.activity.mark ? me.activity.mark : "";
          var marks = mark ? mark.split(",") : [];
          var rootCtx = {
            "$userName": PF.userInfo.name,
            "$loginId": PF.userInfo.loginId,
            "$roleNames": PF.userInfo.roleNames,
            "$deptIdChain": PF.userInfo.deptIdChain,
            '$allIdentityRoleNames': PF.userInfo.allIdentityRoleNames,
            "$ext": _formExpContext2.default,
            '$flowMarks': marks };

          form.setExpressionContext(null, {}, true);
          form.setExpressionContext(null, rootCtx);
          me.$commentMinComponent = [];
          me.$newForm = form;
          form.on('afterRender', function () {
            if (me.propLoading) {
              me.propLoading.close();
            }
            if (me.businessId) {
              if (me.type == 'module_flow') {

                me.renderMinComment();
              }
              if (!me.lockSuccess && !form.notShowLockErrorMsg) {
                me.$newForm.fireEvent("showLockErrorMsg");

                PF.message("warning", me.lockErrorMsg || $lang("文档由其他人编辑中"));
              }
            }
          });
          form.on('manualChange', function (a, b) {
            me.formValueChange = true;
          });

          var exportProperties = ["action", "taskId", "businessId", "draftsDocId", "taskData", "extParams", "flowKey", "moduleId",
          "formId", "formKey", "formVersion", "activity", "tempBusinessId", "fieldMapping", "formName",
          "processDefinitionId", "processDefinitionName", "dialog"];
          exportProperties.forEach(function (p) {
            (0, _defineProperty2.default)(me.$newForm, p, {
              get: function get() {
                return me[p];
              },
              set: function set(v) {
                me[p] = v;
              } });

          });
          var exportFunctions = ["startProcess", "formActionComplete", "refreshComment", "setBtnLoading", "setFlowAreaItems", "setFlowAreaExtraFlows"];
          exportFunctions.forEach(function (f) {
            me.$newForm[f] = me[f].bind(me);
          });
          me.$newForm.getExtForm = function () {
            var params = {};
            params.formData = _lodash2.default.assign({ id: this.businessId }, this.formData());
            params.action = this.action;
            params.taskId = this.taskId;
            params.appId = this.appId;
            if (this.businessId) {
              params.businessId = this.businessId;
            }
            if (this.taskData) {
              params.taskData = this.taskData;
            }
            params.extParams = this.extParams;
            params.flowKey = this.flowKey;
            params.moduleId = this.moduleId;
            params.formId = this.formId;
            params.formKey = this.formKey;
            params.formVersion = this.formVersion;
            params.activity = this.activity;
            params.draftsDocId = this.draftsDocId;
            params.batchId = this.batchId;
            params.tempBusinessId = this.tempBusinessId;
            params.fieldMapping = this.fieldMapping;
            params.formName = this.formName;
            params.processDefinitionId = this.processDefinitionId;
            params.processDefinitionName = this.processDefinitionName;
            params.comment = this.commentId ? [{
              id: this.commentId,
              content: this.comment,
              category: this.commentCategory }] :
            [];

            params.startProcess = this.startProcess;
            params.formActionComplete = this.formActionComplete;
            params.refreshComment = this.refreshComment;
            params.setBtnLoading = this.setBtnLoading;
            params.btnDebounce = this.btnDebounce;

            params.formOpenSource = this.formOpenSource;
            return params;
          }.bind(me);

          me.$newForm.__originalExtForm = me;
          me.$emit("beforeRender", me.$newForm);
          me.$newForm.render($(me.$el.querySelector('.mw-form_id')));
        });
      });
    },

    renderMinComment: function renderMinComment() {
      var me = this;
      var cCategories = [],cTaskNames = [];

      if (me.$commentMinComponent.length === 0) return;
      me.$commentMinComponent.forEach(function (v) {
        var commentConfig = v.$options.config.getConfig();
        if (commentConfig.typeMark == '2') {
          cTaskNames.push(commentConfig.activityName);
        } else {
          cCategories.push(commentConfig.activityName);
        }
      });
      var cCategory, cTaskName;
      if (cCategories.length > 0) {
        cCategory = cCategories.join(',');
      }
      if (cTaskNames.length > 0) {
        cTaskName = cTaskNames.join(',');
      }
      var qcp = {
        businessId: me.businessId,
        batchId: me.batchId,
        processDefinitionId: me.processDefinitionId,
        category: cCategory,
        taskName: cTaskName };

      if (window.$Env && me.type == 'module_flow') {
        if ($Env.formCommentNotShowHide || $Env.afterSaverRenderMinComment) {
          qcp.notShowHide = true;
        }
        if ($Env.formCommentDeptNameInsertUnitName) {
          qcp.deptNameInsertUnitName = true;
        }
        if ($Env.formCommentFilterWithdraw) {
          qcp.formCommentFilterWithdraw = true;
        }
      }
      me.mwApi.business.queryCommentProcess(qcp).then(function (v) {
        var list = v.result;
        if (list) {
          me.$commentMinData = list;
          me.$commentMinComponent.forEach(function (v) {
            v.renderData(list);
          });
        }
      });
    },

    renderConfig: function renderConfig() {var _this4 = this;
      var me = this;
      var params = {};
      params.moduleId = me.moduleId;
      params.appId = me.appId;
      params.taskId = me.taskId;

      if (me.taskId) {
        params.processDefinitionId = me.processDefinitionId;
        params.activityId = me.activityId;
      }
      params.processDefinitionKey = me.flowKey;
      params.formOpenSource = me.formOpenSource;
      me.mwApi.config.flowConfig(params).then(function (data) {
        me.activity = data.result.activity;
        me.processDefinitionId = me.activity.processDefinitionId;
        me.flowKey = me.activity.processDefinitionKey;
        me.processDefinitionName = me.activity.processDefinitionName;
        me.renderDefaultComment();
        var c = data.result.components;
        c.forEach(function (v) {

          v.loading = false;
          me.buttons.push(v);

        });
        if (!_this4.businessId)
        me.setInitValue();
      });
    },

    setInitValue: function setInitValue() {
      var me = this;
      if (me.loaded || me.counter > 50) {
        return;
      }
      me.counter++;
      setTimeout(function () {
        if (me.$newForm) {
          me.loaded = true;
          me.$newForm.setExpressionContext({
            initflowid: me.processDefinitionId,
            initflowkey: me.flowKey,
            moduleId: me.moduleId,
            initflowname: me.processDefinitionName });

        } else {
          me.setInitValue();
        }
      }, 200);
    },


    renderButton: function renderButton(params, callback) {
      var me = this;
      var oldAction = {};
      me.buttons.forEach(function (v) {
        oldAction[v.action] = v.loading;
      });

      me.mwApi.config.flowConfig(params).then(function (data) {
        var btns = [];
        var c = data.result.components;
        c.forEach(function (v) {

          if (undefined == oldAction[v.action]) {
            v.loading = false;
          } else {
            v.loading = oldAction[v.action];
          }
          v.name = $lang(v.name);
          btns.push(v);

        });
        me.buttons = btns;
        me.$newForm.fireEvent("afterrenderbutton", btns);
        me.$nextTick(function () {
          if (callback) {
            callback({ taskId: me.taskId, businessId: me.businessId, batchId: me.batchId, draftsDocId: me.draftsDocId });
          }
        });
      });
    },
    isNotifyTask: function isNotifyTask() {
      var me = this;
      return me.taskData && me.taskData.type === '0' && me.activity && me.activity.activityType !== 'circular';
    },
    isReadOnlyTask: function isReadOnlyTask() {
      var me = this;
      return me.propReadOnly || me.readOnly || me.activity && (me.activity.readOnly === '1' || me.activity.activityType === 'circular');
    },

    renderDefaultComment: function renderDefaultComment() {
      var me = this;
      if (me.taskData) {
        var t = me.taskData;

        var isNotifyTask = me.isNotifyTask();
        if (isNotifyTask) {
          return;
        }
      }
      me.commentCategory = me.activity.commentCategory;
      var moreCommentSwitch = me.activity.moreCommentSwitch;
      if (me.taskId && moreCommentSwitch == '0') {

        me.mwApi.business.listComment({ taskId: me.taskId, isAgentRecord: 0, creatorId: PF.userInfo.inituserid }).then(function (data) {
          var taskComments = data.result;
          if (taskComments.length > 0) {

            $.each(taskComments, function (index, el) {
              if (!el.contentType) {
                me.comment = el.content;
                me.commentId = el.id;
                me.isUpdateComment = true;
                return false;
              }
            });


          } else {

            if (me.activity.defaultComment != undefined) {
              me.comment = me.activity.defaultComment;
            }
          }
          if (me.$newForm) {
            me.$newForm.fireEvent("renderdefaultcomment", { comment: me.comment || "", commentId: me.commentId });
          }
        });
      } else {

        if (me.activity.defaultComment != undefined) {
          me.comment = me.activity.defaultComment;
        }
        if (me.$newForm && me.comment) {
          me.$newForm.fireEvent("renderdefaultcomment", { comment: me.comment || "", commentId: me.commentId });
        }
      }
    },

    formData: function formData() {





      return (0, _extends3.default)({}, this.$newForm && this.$newForm.getValue() || {}, this.extraFormField);

    },

    updateFormData: function updateFormData() {var _form =
      this.form,data = _form.data,ver = _form.ver,
      formData = this.formData();
      if (!_lodash2.default.isEqual(data, formData)) {
        this.form = { data: formData, ver: ver + 1 };
      }
      return this;
    },

    refreshcommentComponent: function refreshcommentComponent() {
      if (this.commentComponent.length > 0) {
        this.commentComponent.forEach(function (o) {
          o.refreshComment();
        });
      }
    },
    resetData: function resetData(data, callback) {
      this.taskId = data.taskId;
      this.businessId = data.businessId;




      if (this.comment) {

        this.refreshcommentComponent();
      }

      this.renderButton(data, callback);
    },

    reRender: function reRender() {
      this.resetForm();
      var me = this;
      me.$nextTick(function () {
        me.commentId = $uuid();
        me.taskId = me.propTaskId;
        me.businessId = me.propBusinessId;
        me.moduleId = me.propModuleId;
        me.appId = me.propAppId;
        me.batchId = me.propBatchId;
        me.flowKey = me.propFlowKey;
        me.attachmentData = [];
        me.isCheck = me.propIsCheck;
        me.checkFromName = me.propcheckFromName;
        if (!me.businessId) {
          me.tempBusinessId = $uuid();
        } else {
          me.tempBusinessId = '';
        }
        this.renderForm();
      });
    },





    _doAction: _lodash2.default.debounce(function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(
      function _callee(action) {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                if (typeof action === 'function') {
                  action.call(this);
                } else {
                  PF.invokeFormAction(action, this.$newForm);
                }case 1:case 'end':return _context.stop();}}}, _callee, this);}));return function (_x) {return _ref.apply(this, arguments);};}(),

    1000,
    { leading: true, trailing: false }),


    noticeButtonEvent: function noticeButtonEvent(name) {
      this.components.forEach(function (c) {
        if (c && c.noticeButtonEvent) {
          c.noticeButtonEvent(name);
        }
      });
    },
    setBtnLoading: function setBtnLoading(loading, name) {
      this.buttons.forEach(function (btn) {
        if (btn.action == name) {
          btn.loading = loading;
        }
      });
    },
    btnDebounce: _lodash2.default.debounce(function (callback) {
      var me = this;
      if (callback) {
        callback();
      }
    }, 1000, {
      'leading': true,
      'trailing': false }),

    formActionComplete: function formActionComplete($form, data) {
      this.$emit("formActionComplete", $form, data);
    },
    refreshComment: function refreshComment(res) {
      var me = this;
      if (res.$comment && res.isAgentRecord != 1) {
        me.commentId = res.$comment[0].id;
        me.comment = res.$comment[0].content;
        me.isUpdateComment = true;
      }
      me.refreshcommentComponent();
    },
    startProcess: _lodash2.default.debounce(function (callback, action) {

      var params = {};
      var me = this;var
      comment = this.comment,commentId = this.commentId,commentCategory = this.commentCategory;

      params.taskId = this.taskId;
      params.appId = this.appId;
      params.moduleId = this.moduleId;
      params.flowKey = this.flowKey;
      params.formId = this.formId;
      if (action) {
        params.action = action;
      }
      if (me.forceModuleForm) {
        params.coverFormData = me.forceModuleForm;
      }
      params.formVersion = this.formVersion;
      params.formKey = this.formKey;
      params.tempBusinessId = this.tempBusinessId;
      params.flowStarted = this.flowStarted;
      if (this.propDraftsDeptId) {
        params.departmentId = this.propDraftsDeptId;
      }
      if (me.isReadOnlyTask() || me.isNotifyTask()) {
        params.$form = { id: this.businessId };
      } else {
        params.$form = _lodash2.default.assign({ id: this.businessId }, this.formData());
      }
      params.$formFieldMapping = this.fieldMapping;

      if (comment || commentId && me.isUpdateComment) {
        params.$comment = [{ id: commentId, content: comment || "", category: commentCategory }];
      }
      params.flowAction = 'start';
      params.formOpenSource = this.formOpenSource;
      if (me.extParams && me.extParams.fullAuthType) {
        params.fullAuthType = me.extParams.fullAuthType;
      }
      if (this.$newForm.fireEvent("beforesave", params, continuation.bind(this)) === false) {
        return callback(undefined, new Error("beforesave abort"));
      }
      function continuation() {var _this5 = this;
        this.mwApi.data.saveFormData(params).then(function (data) {
          var p = { formOpenSource: params.formOpenSource };
          if (!me.taskId) {
            p.taskId = data.result.taskId;
            p.businessId = data.result.businessId;
            me.batchId = data.result.batchId;
            me.draftsDocId = data.result.draftsDocId;
            me.tempBusinessId = '';
            me.taskId = data.result.taskId;
            if (me.$newForm) me.$newForm.taskId = me.taskId;
          } else {
            if (data.result.taskId) {
              p.taskId = data.result.taskId;
              p.businessId = data.result.businessId;
            } else {
              p.taskId = me.taskId;
              p.businessId = me.businessId;

            }
          }
          me.forceModuleForm = false;
          if (window.$Env && $Env.afterSaverRenderMinComment && me.type == 'module_flow') {
            me.renderMinComment();
          }


          _this5.$newForm.fireEvent("aftersave", data);
          me.$emit("updatedData", true);
          me.resetData(p, callback);
        }).catch(function (err) {
          me.$newForm.fireEvent("saveerror", err);
          callback(undefined, err);
        });
      }
      continuation.call(this);
    }, 1000, {
      'leading': true,
      'trailing': false }),

    getEditMode: function getEditMode() {
      return this.editMode;
    },
    setFlowAreaItems: function setFlowAreaItems(items) {
      if (this.$refs.footerArea) {
        this.$refs.footerArea.footerItems = items;
      }
    },
    setFlowAreaExtraFlows: function setFlowAreaExtraFlows(flows) {
      if (this.$refs.footerArea) {
        this.$refs.footerArea.extraFlows = flows;
      }
    },
    transFlowName: function transFlowName(name) {
      if (!name) return "";
      if (name.indexOf('-') > 0) {
        var arr = name.split('-');
        return $lang(arr[0]) + '-' + $lang(arr[1]);
      } else {
        return $lang(name);
      }
    },
    processRightCustomComp: function processRightCustomComp() {
      var me = this;
      if (me.rightCustomCompId && me.$refs.rightCustomCompDiv) {
        var comp = PF.createVue({
          template: "<mw-inner-page :pageId='pageId' noWrap :params='params'></mw-inner-page>",
          data: {
            pageId: me.rightCustomCompId,
            params: { formObj: me } } });


        me.$nextTick(function () {
          $(me.$refs.rightCustomCompDiv).html(comp.$mount().$el);
        });
      }
    },
    sidebarBtn: function sidebarBtn() {
      if (this.showRightComment == true) {
        $(this.$refs.rightComment).css("right", "-260px");
        this.showRightComment = false;
      } else {
        $(this.$refs.rightComment).css("right", "0px");
        this.showRightComment = true;
      }
    } },

  watch: {
    propModuleId: function propModuleId(newVal) {

    },
    propEditMode: function propEditMode(newValue) {
      this.setEditMode(newValue);
    },
    extCustomCommentCompId: function extCustomCommentCompId(newVal) {
      if (newVal) {
        var me = this;
        var comp = PF.createVue({
          template: "<mw-inner-page :pageId='pageId' noWrap :params='params'></mw-inner-page>",
          data: {
            pageId: newVal,
            params: { formObj: me } } });


        me.$nextTick(function () {
          $(me.$refs.extCustomCommentRef).html(comp.$mount().$el);
        });
      }
    } } };

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = {};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.getTaskFlow = undefined;var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _map = __webpack_require__(900);var _map2 = _interopRequireDefault(_map);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);var getTaskFlow = exports.getTaskFlow = function () {var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(










  function _callee(_ref) {var taskId = _ref.taskId,flowId = _ref.flowId,groupId = _ref.groupId,$form = _ref.$form;var params, t;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (

            taskId) {_context.next = 2;break;}throw (
              'you need a taskId to get task-flow');case 2:

            params = $form;
            t = Date.now();if (
            flowId) {_context.next = 6;break;}return _context.abrupt('return',
            _axios2.default.get(uri + '/flow/' + taskId + '?t=' + t, { params: params }).then(function (response) {return response.data;}).
            then(function (data) {

              return _lodash2.default.map(data, function (flow) {
                if (_lodash2.default.isUndefined(flow.cat)) {
                  flow.cat = 'to-next';
                }
                return flow;
              });
            }));case 6:if (


























            groupId) {_context.next = 8;break;}return _context.abrupt('return',
            _axios2.default.get(uri + '/flow/' + taskId + '/' + flowId, { params: params }).then(function (response) {return response.data;}));case 8:return _context.abrupt('return',












            _axios2.default.get(uri + '/flow/' + taskId + '/' + flowId + '/' + groupId, { params: params }).
            then(function (response) {return response.data;}).











            then(function (data) {
              var keyMap = new _map2.default([['U', 'users'], ['P', 'positions']]);
              return _lodash2.default.groupBy(data, function (_ref3) {var type = _ref3.type;return keyMap.get(type);});
            }).then(function (data) {
              if (data[undefined]) {

              }
              return data;
            }));case 9:case 'end':return _context.stop();}}}, _callee, this);}));return function getTaskFlow(_x) {return _ref2.apply(this, arguments);};}();exports.


getTaskPrevious = getTaskPrevious;var _lodash = __webpack_require__(98);var _lodash2 = _interopRequireDefault(_lodash);var _axios = __webpack_require__(114);var _axios2 = _interopRequireDefault(_axios);var _constants = __webpack_require__(915);var _process = __webpack_require__(302);var _process2 = _interopRequireDefault(_process);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var getCanRejectTo = _process2.default.getCanRejectTo;var uri = window.$servicePath + '/rest/process/task';function getTaskPrevious(taskId) {

  if (!taskId)
  throw 'you need a taskId to get previous tasks';

  return _axios2.default.get(uri + '/previous/' + taskId).then(function (response) {return response.data;});
}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(50);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });




























































































var _index = __webpack_require__(200);var _index2 = _interopRequireDefault(_index);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  components: {
    mwCompleteTree: _index2.default },

  props: {
    form: Object,
    height: String },


  data: function data() {
    return {
      maxHeight: $(window).height() - 225 + 'px',
      canTransmit: window.$Env && $Env.flowShowTransmitBtn ? true : false,
      marginLeft: (window.$Env && $Env.formFlowAreaMarginLeft || "0") + "px",
      selectedFlowId: "",
      flows: [],
      extraFlows: [],
      selectedUsers: [],
      selectedUserIds: [],
      selUserModel: '',
      dialogVisible: false,
      isAppendIFrame: false,
      mulSel: false,
      flowCount: 0,
      loading: false,
      candidateBmIds: [],
      flowCandidateData: [],
      loadedSearchUser: false,
      curSelFlowData: [],
      footerItems: [],
      actions: [],
      autoLoadSingleUser: false,
      submitLoading: false,
      selUserLoading: false,
      saveLoading: false };

  },
  mounted: function mounted() {
    var me = this;
    if (me.form) {
      var unwatch = me.form.$watch("buttons", {
        handler: function handler(btns) {
          if (!_.isEmpty(btns)) {
            me.actions = _.map(btns, "action");
          } else {
            me.actions = [];
          }
        },
        immediate: true });

      me.form.$once("hook:beforeDestroy", function () {
        unwatch();
      });
      var doRenderTask = function doRenderTask() {
        me.form.renderTaskFormFlowTip(function (flows) {
          if (flows) {
            me.flows = flows;
            me.flowCount = flows.length;
            me.selectedFlowId = me.flows[0] && me.flows[0].id;
            me.flowChange();
            me.$emit("flowReady");
          }
        });
      };
      me.form.$on("beforeRender", function () {
        if (me.form.isNotifyTask()) {
          me.form.flowAreaBottomSelRowHeight = 0;
          return;
        }
        doRenderTask();
      });
    }
  },
  methods: {
    flowChange: function flowChange() {var _this = this;
      this.selectedUsers = [];
      this.candidateBmIds = [];
      this.flowCandidateData = [];
      this.curSelFlowData = [];
      this.loadedSearchUser = false;
      if (this.isExtraFlowActive) {
        if (this.selectedFlow.onActive) {
          this.selectedFlow.onActive.call(this, function (users) {return _this.selectedUsers = users;});
        }
      }
      var params = {};
      this.$emit("flowChange", this, this.selectedUsers, params);
      if (params.returnFalse !== false) {
        if (this.isOverFlow) {
          if (this.form.taskId) {
            this.loadSingleUsers();
          } else {
            this.selectedUsers = [{ name: "<流程结束>", id: "<流程结束>" }];
          }
        } else {
          if (!this.isExtraFlowActive && this.form.taskId) {
            this.loadSingleUsers();
          }
        }
      }
    },
    formSave: function formSave() {
      var me = this;
      me.saveLoading = true;
      if (!me.form.$newForm.isValid(true)) {
        me.saveLoading = false;
        return;
      }
      me.form.startProcess(function (data, err) {
        me.saveLoading = false;
        if (!err) {
          PF.message($lang("表单数据保存成功") + "!");
        }
      });
    },
    reject: function reject() {
      PF.action.flowreject(this.form.$newForm);
    },
    flowreaded: function flowreaded() {
      PF.action.flowreaded(this.form.$newForm);
    },
    flowplanned: function flowplanned() {
      PF.action.flowplanned(this.form.$newForm);
    },
    flowtransmit: function flowtransmit() {
      PF.action.flowtransmit(this.form.$newForm);
    },
    deleteUser: function deleteUser(user) {
      var index = this.selectedUsers.indexOf(user);
      this.selectedUsers.splice(index, 1);
    },
    searchHandleTaskData: _.debounce(function (query, cb) {
      var me = this;
      if (query) {
        this.loading = true;
        if (me.form.taskId) {
          me.doFilterCandidateData(query, cb);
        } else {
          if (!me.form.$newForm.isValid(true)) {
            this.loading = false;
            return;
          }
          me.form.startProcess(function (d, err) {
            me.loadSingleUsers(function () {
              me.doFilterCandidateData(query, cb);
            });
          });
        }
      } else {
        cb([]);
      }
    }, 200, {
      'leading': true,
      'trailing': false }),

    doFilterCandidateData: function doFilterCandidateData(qcon, cb) {
      var me = this;
      if (!qcon) {
        cb([]);
        return;
      }
      me.doSearchHandleTaskData(function (data) {
        if (!qcon) cb([]);
        var ds = _.filter(data, function (d) {return d.name.toLowerCase().indexOf(qcon.toLowerCase()) > -1;}) || [];
        cb(ds);
      });
    },
    setSelCandidateUser: function setSelCandidateUser(row, event, column) {
      var me = this;
      var flow = me.getSelectedFlow();
      if (!flow) return;
      if (!flow.options.multipleUnit) {
        me.selectedUsers = [row];
        return;
      }
      var r = _.find(me.selectedUsers, function (d) {return d.id == row.id;});
      if (!r) {
        me.selectedUsers.push(row);
      }
    },
    doSearchHandleTaskData: function doSearchHandleTaskData(callback) {
      var me = this;
      if (me.loadedSearchUser) {
        me.loading = false;
        callback(me.flowCandidateData);
        return;
      }
      var flow = me.getSelectedFlow();
      if (!flow) {
        return;
      }
      if (flow.type == "startSubProcess") {
        me.mwApi.process.listPlannedSubByBatchIdAndActivityId(me.form.batchId, flow.activityId).then(function (v) {
          var removeIds = [];
          if (v.result) {
            v.result.forEach(function (v1) {
              removeIds.push(v1.id);
            });
          }

          if (flow.options.sendUnit == 'DEP') {
            var ds = _.filter(me.curSelFlowData, function (d) {return removeIds.indexOf(d.id) == -1;}) || [];
            me.loading = false;
            me.flowCandidateData = ds;
            me.loadedSearchUser = true;
            callback(me.flowCandidateData);
          } else {

            var qp = { taskId: me.form.taskId, flowId: me.selectedFlowId };
            qp.candidateBmIds = me.candidateBmIds;
            PF.invoke("s:process.srv.searchHandleTaskData", qp).then(function (ret) {
              me.loading = false;
              var ds = _.filter(ret.result, function (d) {return removeIds.indexOf(d.id) == -1;}) || [];
              me.flowCandidateData = ds;
              me.loadedSearchUser = true;
              callback(ds);
            }).catch(function () {
              me.loading = false;
            });
          }
        });
      } else {
        var qp = { taskId: me.form.taskId, flowId: me.selectedFlowId };
        qp.candidateBmIds = me.candidateBmIds;
        PF.invoke("s:process.srv.searchHandleTaskData", qp).then(function (ret) {
          me.loading = false;
          me.flowCandidateData = ret.result || [];
          me.loadedSearchUser = true;
          callback(me.flowCandidateData);
        }).catch(function () {
          me.loading = false;
        });
      }
    },
    getSelectedFlow: function getSelectedFlow() {
      return _.find(this.mixFlows, { id: this.selectedFlowId });
    },
    selectUser: function selectUser() {
      var me = this;
      var flow = me.getSelectedFlow();
      if (flow) flow.userTreeVisible = true;
      if (me.form.taskId) {
        me.dialogVisible = true;
      } else {
        if (!me.form.$newForm.isValid(true)) {
          return;
        }
        me.selUserLoading = true;
        me.form.startProcess(function (d, err) {
          me.selUserLoading = false;
          if (!err) {
            me.dialogVisible = true;
          }
        });
      }
    },
    dialogOpen: function dialogOpen() {
      if ($(".v-modal").length > 0) {
        this.appendDialogIframe();
      }
    },
    dialogOpened: function dialogOpened() {
      var me = this;
      if ($(".v-modal").length > 0) {
        if ($(".v-modal").find("iframe").length === 0) {
          me.appendDialogIframe();
        }
        return;
      }
      MW.test(function () {
        if ($(".v-modal").length > 0) {
          return true;
        }
      }, function () {
        me.appendDialogIframe();
      }, 5);
    },
    appendDialogIframe: function appendDialogIframe() {

      $(".v-modal").append($("<iframe width='100%' heigh='100%''></iframe>").css({
        width: '100%',
        height: '100%',
        border: '0px',
        position: "absolute" }));

    },
    setSelectUsers: function setSelectUsers(flow) {
      var me = this;
      var tree = me.$refs[flow.id][0];

      var nodes = tree.getSelectNodes(true);
      me.selectedUsers = _.isArray(nodes) ? nodes : [nodes];
      me.dialogVisible = false;
    },
    processTaskLoadUser: function processTaskLoadUser(flow, params) {
      this.form.$newForm.fireEvent("flowseltaskhandleuser", flow, params);
      return params;
    },
    loadSingleUsers: function loadSingleUsers(params, callback) {
      var me = this;
      if (!me.selectedFlowId) {


        return;
      }
      if ($.isFunction(params)) {
        callback = params;
        params = {};
      } else {
        params = params || {};
      }
      var doload = function doload() {
        $.ajax({
          url: '/rest/process/task/flow/' + me.form.taskId + '/' + me.selectedFlowId,
          data: params,
          success: function success(tree) {
            function getDeepNode(node) {
              if (!node || !node.children) return node;
              return getDeepNode(node.children[0]);
            }
            function isSingleFlow(tree) {
              if (!tree || tree.length !== 1) return false;
              if (!tree[0].children || tree[0].children.length === 0) {
                return !tree[0].hasChild;
              } else {
                return isSingleFlow(tree[0].children);
              }
            }
            me.curSelFlowData = tree;
            me.processCandidateBmIds(tree);
            if (isSingleFlow(tree)) {
              me.selectedUsers = [getDeepNode(tree[0])];
            }
            if (_.isFunction(callback)) {
              callback(tree);
            }
          } });

      };
      if (me.form.$newForm.fireEvent("beforeflowtaskuserload", me.getSelectedFlow(), params, doload) === false) {
        return false;
      }
      doload();
    },
    processCandidateBmIds: function processCandidateBmIds(tree) {
      var me = this;
      me.candidateBmIds = [];
      if (tree) {var
        _processBmIds = function _processBmIds(ds) {
          if (ds && ds.length > 0) {
            _.each(ds, function (d) {
              if (d.hasReal && d.hasChild) {
                me.candidateBmIds.push(d.id);
              }
              _processBmIds(d.children);
            });
          }
        };
        _processBmIds(tree);
      }
    },
    submit: _.debounce(function () {var _this2 = this;
      var me = this;
      if (!me.form.$newForm.isValid(true)) {
        return;
      }
      if (!me.selectedFlowId) {
        PF.message("info", $lang("未获取到符合条件的流向信息"));
        return;
      }
      if (_.isEmpty(me.selectedUsers)) {
        PF.message("info", $lang("请先选择人员"));
        return;
      }
      me.submitLoading = true;
      me.form.startProcess(function (d, err) {
        me.submitLoading = false;
        if (!err) {var










          continuation = function continuation() {
            me._submit();
          };if (me.isExtraFlowActive) {if (me.selectedFlow.onSubmit) {me.selectedFlow.onSubmit.call(me, me.selectedFlow, me.selectedUsers, d);}return;}if (me.form.$newForm.fireEvent("beforecomplete", me.form, me.form, continuation.bind(_this2)) === false) {return false;}continuation();
        }
      });
    }, 1000, {
      'leading': true,
      'trailing': false }),

    _submit: function _submit() {
      var me = this;
      if (!me.selectedFlowId) {
        PF.message("info", $lang("未获取到符合条件的流向信息"));
        return;
      }
      if (_.isEmpty(me.selectedUsers)) {
        PF.message("info", $lang("请先选择人员"));
        return;
      }
      function doCommit(params) {
        me.form.$newForm.fireEvent("beforedocomplete", params);
        me.submitLoading = true;
        me.mwApi.process.batchCommit(params).then(function (res) {
          me.submitLoading = false;
          var data = res.result;
          if (data && !data.success) {
            if (data.errorType == 'comment') {
              if (data.errorCode == 'comment_check_stop') {
                PF.message('info', $lang('您还没有填写意见,请填写意见'));

                return;
              } else if (data.errorCode == 'comment_check_remind') {
                PF.confirm($lang('您还没有填写意见,您确认是要继续完成？'), $lang('提示'), { type: 'warning' }).then(function () {
                  params['$directSave'] = true;
                  doCommit(params);
                }).catch(function () {

                });
                return;
              }
            } else {
              var errorMsg = '';
              if (data.errorMsg) {
                errorMsg = '[' + $lang('错误信息') + ':' + data.errorMsg + ']';
              }
              PF.message('info', $lang('完成失败') + errorMsg + '!');
              return;
            }
          } else {
            if (me.form.$newForm.fireEvent("aftercomplete", params, res) === false) {
              return false;
            }
            me.form.formActionComplete();
          }
        }).catch(function () {
          me.submitLoading = false;
        });
      }
      var flowData = me.getSelectedFlow();
      if (me.selectedFlowId && me.selectedUsers.length === 0) {
        if (flowData.activityId === 'end') {
          var params = {};
          params.type = "complete";

          params.taskId = me.form.taskId;
          params.appId = me.form.appId;
          params.formId = me.form.formId;
          params.formKey = me.form.formKey;

          params.businessId = me.form.businessId;
          params.activities = [{ flowId: flowData.id, activityId: flowData.activityId }];
          if (me.form.comment) {
            params.$comment = [{ id: me.form.commentId, content: me.form.comment, category: me.form.commentCategory }];
          }
          params.formOpenSource = me.params.formOpenSource;

          doCommit(params);
        } else {
          PF.message("info", $lang("请先选择办理人员"));
        }
      } else {
        var activity = {};
        activity.flowId = flowData.id;
        activity.activityId = flowData.activityId;
        activity.type = flowData.type;
        activity.options = flowData.options;
        var items = [];

        if (flowData.type == "startSubProcess" && activity.options.activityUnit == 'group') {
          $.each(me.selectedUsers, function (i, d) {
            var uitem = { group: d.id };
            uitem.users = [];
            _.each(d.identities, function (u) {
              uitem.users.push({ id: u.id });
            });
            items.push(uitem);
          });
        } else {
          _(me.selectedUsers).groupBy("parentId").each(function (users, parentId) {
            if (flowData.options.singleDepartmentRecord !== "true") {
              users.forEach(function (u) {
                items.push({
                  group: parentId,
                  users: [{ id: u.id.split("_").pop() }] });

              });
            } else {
              items.push({
                group: parentId,
                users: users.map(function (u) {return { id: u.id.split("_").pop() };}) });

            }
          });
        }
        activity.items = items;
        var _params = {};
        _params.type = "complete";

        _params.taskId = me.form.taskId;
        _params.appId = me.form.appId;
        _params.formId = me.form.formId;
        _params.formKey = me.form.formKey;

        _params.businessId = me.form.businessId;
        _params.activities = [activity];
        _params.formOpenSource = me.form.formOpenSource;
        doCommit(_params);
      }
    },
    extraFlowButtonClick: function extraFlowButtonClick() {var _this3 = this;
      if (!this.isExtraFlowActive) return;
      var fn = this.selectedFlow.button.handler;
      fn.call(this, function (users) {
        _this3.selectedUsers = users;
      });
    } },

  watch: {
    selectedUsers: function selectedUsers(newVal, oldVal) {var _this4 = this;
      if (newVal && oldVal && newVal.length == oldVal.length && newVal.length === 0) {
        return;
      }
      setTimeout(function () {
        var selUserRowObj = _this4.$refs.selUserRow;
        if (selUserRowObj) {
          var height = $(selUserRowObj.$el).height();
          if (height > 200) {
            height = 200;
          }
          _this4.form.flowAreaBottomSelRowHeight = height;
        }
      }, 50);
    } },

  computed: {
    mixFlows: function mixFlows() {
      var flows = this.flows.concat(this.extraFlows);
      if (flows && flows.length > 1) {
        flows.sort(function (ao, bo) {
          var a = ao.sn || 0;
          var b = bo.sn || 0;
          return a - b;
        });
      }
      return flows;
    },
    isExtraFlowActive: function isExtraFlowActive() {var _this5 = this;
      return this.selectedFlowId && _.findIndex(this.extraFlows, function (f) {return f.id === _this5.selectedFlowId;}) >= 0;
    },
    isOverFlow: function isOverFlow() {
      return this.selectedFlow && this.selectedFlow.activityName === "结束";
    },
    selectedFlow: function selectedFlow() {
      return this.getSelectedFlow();
    } } };

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
















{

  name: 'MwCompleteTree',
  props: {
    search: {
      type: Boolean,
      default: false },


    autoLoad: {
      type: Boolean,
      default: true },


    defaultParentId: {
      type: String },


    defaultParams: {
      type: Object,
      default: function _default() {
        return {};
      } },


    url: {
      type: String,
      required: true },

    rootData: Array,

    expandedFirst: {
      type: Boolean,
      default: false },


    mulNodeNotExpand: {
      type: Boolean,
      default: false },

    autoSelectSingle: Boolean,
    autoSelectData: {
      type: Boolean,
      default: false },


    async: {
      type: Boolean,
      default: false },


    multiple: {
      type: Boolean,
      default: false },

    singleLeaf: {
      type: Boolean,
      default: false },


    multipleLeaf: {
      type: Boolean,
      default: false },

    contextMenuItem: {
      type: Array,
      default: function _default() {
        return [];
      } },


    checkNodes: {
      type: Array,
      default: function _default() {
        return [];
      } },


    selectNode: {
      type: String,
      default: '' },

    type: {
      type: String },

    activityId: {
      type: String },

    businessId: {
      type: String },

    batchId: {
      type: String },

    taskId: {
      type: String },


    treeData: {
      type: [Array, Object] },

    flowCount: Number },

  data: function data() {
    return {
      searchFlag: false,
      searchText: '',
      selectData: {},
      selectParents: [],
      dblClick: false,
      select: false,
      deselect: false,
      check: false,
      expanded_first: false,
      open_last_id: '',
      refreshIds: [],
      initData: [],
      firstCount: 0,
      firstLoaded: false,
      authSelectedData: false,
      leafTypes: ["file", "zg", "wc", "dg"],
      openedIds: [],
      removeIds: [],
      candidateShowsCurrentStatus: window.$Env && $Env.candidateShowsCurrentStatus };

  },
  watch: {
    checkNodes: function checkNodes(newIds) {
      var me = this;
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.uncheck_all();
      newIds.forEach(function (id) {
        var obj = inst.get_node(id);
        inst.check_node(obj);
      });
    },
    selectNode: function selectNode(newId) {
      var me = this;
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.deselect_all();
      if (newId) {
        var obj = inst.get_node(newId);
        inst.select_node(obj);
      }
    },
    searchText: function searchText(val) {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (val == '') {
        setTimeout(function () {
          tree.clear_search();
        }, 250);
      } else {
        if (this.searchFlag) {
          clearTimeout(this.searchFlag);
        }
        this.searchFlag = setTimeout(function () {
          tree.search(val, true, true);
        }, 250);
      }
    },
    url: function url(val) {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (tree) {
        tree.destroy();
      }
      this.renderTree();
    } },

  mounted: function mounted() {var _this = this;
    var me = this;
    if (this.autoLoad) {
      if (this.type == "startSubProcess") {
        if (this.businessId && this.batchId) {

          this.mwApi.process.listPlannedSubByBatchIdAndActivityId(this.batchId, this.activityId).then(function (v) {
            if (v.result) {
              v.result.forEach(function (v1) {

                me.removeIds.push(v1.id);
              });
            }
            _this.renderTree();
          });

        }
        return;
      }
      this.renderTree();
    }
  },
  destroyed: function destroyed() {
    var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
    if (tree) {
      tree.destroy();
    }
  },
  methods: {
    checkAll: function checkAll() {
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.select_all();
    },
    unCheckAll: function unCheckAll() {
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.deselect_all();
    },
    openAll: function openAll() {
      $(this.$el.querySelector('.mw-tree')).jstree('open_all');
    },
    closeAll: function closeAll() {
      $(this.$el.querySelector('.mw-tree')).jstree('close_all');
    },
    refresh: function refresh() {
      $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
    },
    refreshData: function refreshData(data) {
      $(this.$el.querySelector('.mw-tree')).jstree(true).settings.core.data = data;
      $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
    },
    showNode: function showNode(id) {
      var me = this;
      var obj = $(me.$el.querySelector('.mw-tree')).jstree(true).get_node(id);
      $(me.$el.querySelector('.mw-tree')).jstree(true).show_node(obj);
    },
    getSelectNodes: function getSelectNodes(noHide) {
      var me = this;
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      var selected = tree.get_selected();
      var data = [];
      if (selected.length > 0) {
        selected.forEach(function (id) {
          var obj = tree.get_node(id);
          if (me.leafTypes.indexOf(obj.type) != -1 && !obj.state.hidden) {
            if (!noHide) tree.hide_node(obj);
            var d = (0, _assign2.default)({ parentId: obj.parent }, obj.original);
            data.push(d);
          }
        });
      }
      return data;
    },
    getSelected: function getSelected() {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      var selected = tree.get_selected();
      var data = [];
      if (this.multiple) {
        if (selected.length > 0) {
          data = [];
          selected.forEach(function (id) {
            data.push(tree.get_node(id).original);
          });
        }
      } else {
        if (selected.length > 0) {
          data = tree.get_node(selected[0]).original;
        }
      }
      return data;
    },
    renderTree: function renderTree() {
      var me = this,jsTreeEl = $(me.$el.querySelector('.mw-tree'));
      var plugin = ["types"];
      var items = {};
      if (me.multiple) {
        plugin.push("checkbox");
        plugin.push("wholerow");
      } else {
        plugin.push("wholerow");
      }
      if (me.search) {
        plugin.push("search");
      }
      if (me.contextMenuItem.length > 0) {
        plugin.push("contextmenu");
        me.contextMenuItem.forEach(function (item) {
          items[item.name] = {
            "name": item.name ? item.name : '',
            "label": item.label,
            "icon": item.icon ? item.icon : '',
            "action": function action(a) {
              item.func(me.selectData, me.selectParents);
            } };

        });
      }
      var data = {};
      if (me.treeData) {
        data = me.treeData;
      } else {

        var dataConfig = {
          cache: false,
          async: false,
          "url": function url(node) {
            var arr = [];
            for (var p in me.defaultParams) {
              arr.push(p + "=" + me.defaultParams[p]);
            }
            if (node.id === '#') {
              return me.url + '?' + arr.join("&");
            } else {
              return me.url + '/' + node.id + '?' + arr.join("&");
            }
          },
          'data': function data(node) {
            return { 'id': node.id };
          },
          dataFilter: function dataFilter(data, parentId) {
            var isString = typeof data === 'string';
            if (isString) data = JSON.parse(data);
            if (!me.firstLoaded) {
              this.getNoChildren(data);
            }
            if (data) {
              if (window.$currentBrowserLanguage === 'en') {
                PF.walkTree(data, function (d) {
                  d._name = d.name;
                  if (d.name === '<任务结束>' || d.name === '<流程结束>') {
                    d.name = $lang(d.name);
                  } else {
                    d.name = d.Englishname || d.name;
                  }
                });
              }
              this.changeTreeData(data, { id: parentId });
            } else {
              data = [];
            }
            if (me.firstLoaded) {
              var resData = [];

              this._initData(me.initData, data, parentId, resData);
              if (resData.length > 0) {
                return resData[0].children;
              } else {
                  return data;
                }
            } else {
              me.initData = data;
            }
            return data;
          },
          _initData: function _initData(data, nData, curId, resData) {
            for (var i = 0; i < data.length; i++) {
              var v = data[i];
              if (v.children instanceof Array) {
                if (v.id == curId) {
                  for (var j = nData.length - 1; j >= 0; j--) {
                    v.children.unshift(nData[j]);
                  }
                  resData.push(v);
                } else {
                  this._initData(v.children, nData, curId, resData);
                }
              }
            }
          },
          getNoChildren: function getNoChildren(data) {var _this2 = this;
            data.forEach(function (d) {
              if (d.children) {
                _this2.getNoChildren(d.children);
              } else {
                me.refreshIds.push(d.id);
              }
            });
          },
          changeTreeData: function changeTreeData(data, parent) {var _this3 = this;
            if (me.type == "startSubProcess") {
              var m = this;
              me.mwLodash.remove(data, function (d) {

                var dataId = '';
                if (parent) {
                  dataId = d.id;
                } else {
                  dataId = d.id;
                }
                var flag = false;
                me.removeIds.forEach(function (id) {
                  if (id == dataId) {
                    flag = true;
                  }
                });
                return flag;



              });
            }
            data.forEach(function (d) {
              if (!d.text) {
                if (d.name)
                d.text = d.name;
              }
              if (d.type && d.type == 'U') {
                if (parent)
                d.id = parent.id + "_" + d.id;else
                {
                  if (d.parentId) {
                    _this3.parentNodeId = d.parentId;
                    d.id = d.parentId + "_" + d.id;
                  }


                }
              }
              if (d.children) {
                _this3.changeTreeData(d.children, d);
              } else {
                if (!d.hasReal && d.type == "U" && me.candidateShowsCurrentStatus) {
                  d.type = d.fldgwzt == "外出" ? "wc" : d.fldgwzt == "调岗" ? "dg" : "zg";
                  if (d.defaultAgent) {
                    d.text = d.text + "[" + d.defaultAgent + "代办]";
                  }
                } else if (d.hasReal == undefined) {
                  d.children = false;
                  d.type = 'file';
                } else {
                  d.children = d.hasReal;
                  if (!d.hasReal) {
                    d.type = 'file';
                  } else {
                    d.type = 'default';
                  }
                }
              }
            });
          },
          "success": function success(data) {
            return data;
          } };

        data = function data(node, callback) {
          var me = this;
          if (node.id === "#" && me.rootData) {
            callback(processData(me.rootData));
          } else {
            var url = dataConfig.url(node);
            $.ajax({
              url: url,
              data: { id: node.id },
              method: "POST",
              success: function success(d) {
                var data = processData(d, node.id);
                callback.call(me, data);
              } });

          }
          function processData(data, parentId) {
            return dataConfig.dataFilter(data, parentId);
          }
        };
      }

      jsTreeEl.data('jstree', false).empty();
      jsTreeEl.bind("load_node.jstree", function (e, data) {
        var inst = data.instance;
        var set = inst.settings;
        if (set.async && me.expandedFirst) {
          if (data.node && data.node.children && (["<流程结束>", $lang("<流程结束>")].indexOf(data.node.children) != -1 || ["<任务结束>", $lang("<任务结束>")].indexOf(data.node.children[0]) != -1) && me.flowCount != undefined && me.flowCount == 1) {
            if (me.autoSelectSingle) {
              var h = jsTreeEl.jstree(true).get_node(data.node.children);
              jsTreeEl.jstree(true).hide_node(h);
              me.$emit("dblClick", h.original, h.parent);
            }
            return;
          }
          if (data.node && data.node.children && !set.expanded_first) {var
            _open_first_node = function _open_first_node(node) {
              if (node && (node.id == "#" || node.original && (node.original.hasChild > 0 || node.original.hasReal))) {
                me.firstCount++;
                var ns = [];
                if (node.children && node.children.length > 1 && me.mulNodeNotExpand && !me.autoSelectData) {
                  return;
                }
                if (me.type != 'circular') {
                  if (node.children) {
                    for (var _i = 0; _i < node.children.length; _i++) {
                      var id = node.children[_i];
                      var v = inst.get_node(id);
                      if (me.autoSelectData) {
                        ns.push(v);
                      } else {
                        if (v.children && v.children.length > 0) {
                          ns.push(v);
                        }
                      }
                    }
                  }
                } else {
                  var n = inst.get_node(node.children[0]);
                  if (n)
                  ns.push(n);
                }
                if (ns.length > 0) {
                  for (var i = 0; i < ns.length; i++) {
                    var n = ns[i];
                    if (n) {
                      me.refreshIds.push(n.original.id);
                      me.openedIds.push(n.original.id);
                      if (i == ns.length - 1)
                      me.open_last_id = n.original.id;
                    }
                    inst.open_node(n);
                    _open_first_node(n);
                  }
                } else {
                  me.expanded_first = true;
                  set.expanded_first = true;
                }
              } else {
                me.expanded_first = true;
                set.expanded_first = true;
              }
            };
            _open_first_node(data.node);
          }
        }
      }).on("before_open.jstree", function (el, data) {

      }).on("after_open.jstree", function (el, data) {
        var inst = data.instance;
        var set = inst.settings;
        if (me.firstLoaded && me.type != 'circular') {
          var _n = inst.get_node(data.node.id);
          if (_n && _n.original.hasReal != undefined && _n.original.hasReal && _n.children && _n.children.length > 0) {
            var id = _n.original.id;
            if (me.refreshIds.indexOf(id) == -1) {
              me.refreshIds.push(id);
              jsTreeEl.jstree(true).refresh_node(_n);
            }
          }
        }
        if (me.type == 'circular' && set.expanded_first && me.firstLoaded) {
          var node = inst.get_node(data.node.id);
          var children = node.children;
          if (children) {
            children.map(function (v) {
              var n = jsTreeEl.jstree(true).get_node(v);
              if (n.original && me.openedIds.indexOf(n.id) == -1 && me.leafTypes.indexOf(n.original.type) == -1) {
                jsTreeEl.jstree(true).open_node(n);
              }
              me.openedIds.push(n.original.id);
            });
          }
        }
        if (me.autoSelectData) me.firstCount--;
        if (me.expanded_first) {var









          _search = function _search(id) {
            var o = jsTreeEl.jstree(true).get_node(id);
            if (o.children.length > 1) {
              flag = true;
            } else {
              if (o.parent == '#') {
                var p = jsTreeEl.jstree(true).get_node("#");
                if (p.children.length > 1) {
                  flag = true;
                }
              } else {
                _search(o.parent);
              }
            }
          };var flag = false;var obj = jsTreeEl.jstree(true).get_node(me.open_last_id);if (!me.autoSelectData) me.firstCount--;if (me.firstCount < 2) {me.firstLoaded = true;}if (!me.open_last_id || me.flowCount == undefined || me.flowCount != 1) {return;}
          _search(me.open_last_id);
          if (me.autoSelectSingle && !flag) {
            var h = jsTreeEl.jstree(true).get_node(obj.children[0]);
            jsTreeEl.jstree(true).hide_node(h);
            me.$emit("dblClick", h.original, h.parent);
          }
          me.expanded_first = false;
        }
        if (!me.authSelectedData && me.firstCount < 2) {
          if (me.autoSelectData) {
            var doSelFn = function doSelFn(vs) {
              _.each(vs, function (n) {
                var node = jsTreeEl.jstree(true).get_node(n);
                if (!node.children || node.children.length === 0) {
                  jsTreeEl.jstree(true).hide_node(node);
                  me.$emit("dblClick", node.original, node.parent);
                } else {
                  doSelFn(node.children);
                }
              });
            };
            if (data.node.parents && data.node.parents.length > 0) {
              var n = [data.node.parents[data.node.parents.length >= 2 ? data.node.parents.length - 2 : 0]];
              doSelFn(n);
              me.authSelectedData = true;
            }
          }
        }
      }).on("changed.jstree", function (e, data) {

      }).bind("loaded.jstree", function (e, data) {
        jsTreeEl.delegate(".jstree-checkbox", 'mousedown', function (e) {

          var id = $(this).parent()[0].id;
          var inst = jsTreeEl.jstree(true);
          var obj = inst.get_node(id);
          if (!me.dblClick) {
            me.check = true;
            if (obj.state.selected != undefined) {
              if (obj.state.selected) {

              } else {var

                _open_first_node2 = function _open_first_node2(node) {
                  inst.open_node(node);
                  if (!node.original || node.original && me.leafTypes.indexOf(node.original.type) == -1) {
                    me.openedIds.push(node.original.id);
                    if (me.type != 'circular') {
                      var children = node.children;
                      children.map(function (v) {
                        var n = inst.get_node(v);
                        inst.open_node(n);
                        _open_first_node2(n);
                      });
                    }
                  }
                };
                _open_first_node2(obj);

              }
            }
            me.check = false;
          }
        });
      }).bind("click.jstree", function (e, data) {

      }).bind("dblclick.jstree", function (e, data) {
        var id = e.target.id.substr(0, e.target.id.lastIndexOf('_'));
        var obj = jsTreeEl.jstree(true).get_node(id);
        me.dblClick = true;

        if (obj) {
          if (me.leafTypes.indexOf(obj.original.type) != -1) {var
            callback = function callback() {
              jsTreeEl.jstree(true).hide_node(obj);
            };
            me.$emit("dblClick", obj.original, obj.parent, callback);

          } else {
            if (obj.state.selected) {
              jsTreeEl.jstree(true).deselect_node(obj);
            } else {
              jsTreeEl.jstree(true).select_node(obj);
              if (me.openedIds.indexOf(obj.original.id) == -1) {var
                _open_first_node3 = function _open_first_node3(node) {
                  jsTreeEl.jstree(true).open_node(node);
                  if (!node.original || node.original && me.leafTypes.indexOf(node.original.type) == -1) {
                    me.openedIds.push(node.original.id);
                    var children = node.children;
                    children.map(function (v) {
                      var n = jsTreeEl.jstree(true).get_node(v);
                      jsTreeEl.jstree(true).open_node(n);
                      _open_first_node3(n);
                    });
                  }
                };
                _open_first_node3(obj);
              } else {
                if (obj.state.opened && me.multiple) {
                  jsTreeEl.jstree(true).close_node(obj);
                }
              }
            }
          }
        }
        me.dblClick = false;

      }).bind("check_node.jstree", function (e, data) {
      }).bind("select_node.jstree", function (e, data) {
        if (!me.check) {
          if (me.multiple) {
            if (!me.dblClick && !me.deselect && !me.select) {
              var inst = data.instance;
              var obj = inst.get_node(data.node.original.id);
              me.select = true;
              inst.deselect_node(obj);
              me.select = false;
            }
            if (!me.dblClick && !me.deselect && me.select) {
              var inst = data.instance;
              var obj = inst.get_node(data.node.original.id);
              inst.select_node(obj);
            }
          }
        }
      }).bind("deselect_node.jstree", function (e, data) {

        if (!me.check) {
          if (me.multiple) {
            if (!me.dblClick && !me.select && !me.deselect) {
              var inst = data.instance;
              var obj = inst.get_node(data.node.original.id);
              me.deselect = true;
              inst.select_node(obj);
              me.deselect = false;
            }

            if (!me.dblClick && !me.select && me.deselect) {
              var inst = data.instance;
              var obj = inst.get_node(data.node.original.id);
              inst.deselect_node(obj);
            }
          }
        }
      }).jstree({
        'async': me.async,
        'expanded_first': false,
        'core': {
          "themes": {
            "responsive": false },

          "multiple": me.multiple,
          "check_callback": function check_callback(operation, node, node_parent, node_position, more) {
            return true;
          },
          'data': data },


        'checkbox': {
          "keep_selected_style": false,
          "three_state": true,
          "visible": true,
          "tie_selection": true },

        "plugins": plugin,
        "contextmenu": {
          "items": items },

        "types": {
          "#": {
            "icon": "fa fa-folder" },

          "file": {
            "icon": "fa fa-leaf" },

          "zg": {
            "icon": "icon-green fa fa-user" },

          "wc": {
            "icon": "icon-yellow fa fa-user",
            "color": "yellow" },

          "dg": {
            "icon": "icon-grey fa fa-user" },

          "default": {
            "icon": "fa fa-folder" } } });



    } } };

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =






























{
  components: {},


  props: {
    form: Object,
    height: String,
    buttons: Array },

  data: function data() {
    return {
      maxHeight: $(window).height() - 225 + 'px',
      marginLeft: (window.$Env && $Env.formFlowAreaMarginLeft || "0") + "px",
      selectedFlowId: "",
      flows: [],
      extraFlows: [],
      selectedUsers: [],
      selectedUserIds: [],
      selUserModel: '',
      dialogVisible: false,
      mulSel: false,
      flowCount: 0,
      loading: false,
      candidateBmIds: [],
      flowCandidateData: [],
      loadedSearchUser: false,
      curSelFlowData: [],
      footerItems: [],
      actions: [],
      autoLoadSingleUser: false,
      submitLoading: false,
      saveLoading: false,
      businessName: "",
      isShowBtn: true,
      showHeadLeftButton: false };

  },
  mounted: function mounted() {
    var me = this;
    if (window.$Env && window.$Env.showHeadLeftButton) {
      me.showHeadLeftButton = true;
    }
    if (me.form) {
      var unwatch = me.form.$watch("buttons", {
        handler: function handler(btns) {
          if (!_.isEmpty(btns)) {
            me.actions = _.map(btns, "action");
          } else {
            me.actions = [];
          }
        },
        immediate: true });

      me.form.$once("hook:beforeDestroy", function () {
        unwatch();
      });
      me.form.renderTaskFormFlowTip(function (flows) {
        if (flows) {
          me.flows = flows;
          me.flowCount = flows.length;
          me.selectedFlowId = me.flows[0] && me.flows[0].id;
          me.flowChange();
          me.$emit("flowReady");
        }
      });
      if (me.form.taskId) {
        PF.api.process.getTaskEntityData(me.form.taskId).then(function (res) {
          res = res.result ? res.result : res;
          if (res.businessName)
          me.businessName = res.businessName;
          if (me.businessName != "" && me.businessName.length > 16) {
            me.businessName = me.businessName.substring(0, 16) + "...";
          }
        });

      }

      if (me.form.checkFromName && me.form.checkFromName != "" && me.form.checkFromName != 'undefined') {
        me.businessName = me.form.checkFromName;
        if (me.businessName != "" && me.businessName.length > 16) {
          me.businessName = me.businessName.substring(0, 16) + "...";
        }
        me.isShowBtn = false;
      }
    }
  },
  methods: {
    renderTopButtons: function renderTopButtons() {
      var me = this;
      var params = {};
      if (me.businessId) {
        params.dataId = me.businessId;
      } else {
        var tempId = "";
        if (this.propTempBusinessId) {
          tempId = "_" + this.tempBusinessId;
        }
        params.dataId = tempId;
        if (me.tempTableName) {
          params.tempTableName = me.tempTableName;
        }
      }

      params.taskId = me.taskId;
      if (me.taskId) {
        params.processDefinitionId = me.processDefinitionId;
        params.activityId = me.activityId;
      }
      params.processDefinitionKey = me.flowKey;
      params.flowFlag = flowFlag == undefined ? true : flowFlag;
      params.forceModuleForm = me.forceModuleForm;
      params.normalFlowBtn = me.normalFlowBtn;
      params.moduleId = me.moduleId;
      params.appId = me.appId;
      params.draftsDocId = me.draftsDocId;
      params.formOpenSource = me.formOpenSource;
      params.taskType = me.taskData && me.taskData.type;
      params.propReadOnly = me.propReadOnly;

      if (params.taskId && params.dataId && !me.propReadOnly && !(window.$Env && $Env.notOpenDocLockEditMode)) {
        params.tryLockEditMode = "1";
      }
      me.mwApi.config.moduleConfig(params).then(function (data) {
        var res = data.result;
      });
    },
    flowChange: function flowChange() {var _this = this;
      this.selectedUsers = [];
      this.candidateBmIds = [];
      this.flowCandidateData = [];
      this.curSelFlowData = [];
      this.loadedSearchUser = false;
      if (this.isExtraFlowActive) {
        if (this.selectedFlow.onActive) {
          this.selectedFlow.onActive.call(this, function (users) {return _this.selectedUsers = users;});
        }
      }
      var params = {};
      this.$emit("flowChange", this, this.selectedUsers, params);
      if (params.returnFalse !== false) {
        if (this.isOverFlow) {
          if (this.form.taskId) {
            this.loadSingleUsers();
          } else {
            this.selectedUsers = [{ name: $lang("<流程结束>"), id: "<流程结束>" }];
          }
        } else {
          if (!this.isExtraFlowActive && this.form.taskId) {
            this.loadSingleUsers();
          }
        }
      }
    },




    _doAction: _.debounce(function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(
      function _callee(action) {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                if (typeof action === 'function') {
                  action.call(this);
                } else {
                  PF.invokeFormAction(action, this.form.$newForm);
                }case 1:case "end":return _context.stop();}}}, _callee, this);}));return function (_x) {return _ref.apply(this, arguments);};}(),

    1000,
    { leading: true, trailing: false }),

    formSave: function formSave() {
      var me = this;
      me.saveLoading = true;
      if (PF.action.flowsave(me.form.$newForm, function () {
        me.saveLoading = false;
      }) === false) {
        me.saveLoading = false;
      }
    },
    reject: function reject() {
      PF.action.flowreject(this.form.$newForm);
    },
    flowreaded: function flowreaded() {
      PF.action.flowreaded(this.form.$newForm);
    },
    deleteUser: function deleteUser(user) {
      var index = this.selectedUsers.indexOf(user);
      this.selectedUsers.splice(index, 1);
    },
    searchHandleTaskData: _.debounce(function (query, cb) {
      var me = this;
      if (query) {
        this.loading = true;
        if (me.form.taskId) {
          me.doFilterCandidateData(query, cb);
        } else {
          if (!me.form.$newForm.isValid(true)) {
            this.loading = false;
            return;
          }
          me.form.startProcess(function (d, err) {
            me.loadSingleUsers(function () {
              me.doFilterCandidateData(query, cb);
            });
          });
        }
      } else {
        cb([]);
      }
    }, 200, {
      'leading': true,
      'trailing': false }),

    doFilterCandidateData: function doFilterCandidateData(qcon, cb) {
      var me = this;
      if (!qcon) {
        cb([]);
        return;
      }
      me.doSearchHandleTaskData(function (data) {
        if (!qcon) cb([]);
        var ds = _.filter(data, function (d) {return d.name.toLowerCase().indexOf(qcon.toLowerCase()) > -1;}) || [];
        cb(ds);
      });
    },
    setSelCandidateUser: function setSelCandidateUser(row, event, column) {
      var me = this;
      var flow = me.getSelectedFlow();
      if (!flow) return;
      if (!flow.options.multipleUnit) {
        me.selectedUsers = [row];
        return;
      }
      var r = _.find(me.selectedUsers, function (d) {return d.id == row.id;});
      if (!r) {
        me.selectedUsers.push(row);
      }
    },
    doSearchHandleTaskData: function doSearchHandleTaskData(callback) {
      var me = this;
      if (me.loadedSearchUser) {
        me.loading = false;
        callback(me.flowCandidateData);
        return;
      }
      var flow = me.getSelectedFlow();
      if (!flow) {
        return;
      }
      if (flow.type == "startSubProcess") {
        me.mwApi.process.listPlannedSubByBatchIdAndActivityId(me.form.batchId, flow.activityId).then(function (v) {
          var removeIds = [];
          if (v.result) {
            v.result.forEach(function (v1) {
              removeIds.push(v1.id);
            });
          }

          if (flow.options.sendUnit == 'DEP') {
            var ds = _.filter(me.curSelFlowData, function (d) {return removeIds.indexOf(d.id) == -1;}) || [];
            me.loading = false;
            me.flowCandidateData = ds;
            me.loadedSearchUser = true;
            callback(me.flowCandidateData);
          } else {

            var qp = { taskId: me.form.taskId, flowId: me.selectedFlowId };
            qp.candidateBmIds = me.candidateBmIds;
            PF.invoke("s:process.srv.searchHandleTaskData", qp).then(function (ret) {
              me.loading = false;
              var ds = _.filter(ret.result, function (d) {return removeIds.indexOf(d.id) == -1;}) || [];
              me.flowCandidateData = ds;
              me.loadedSearchUser = true;
              callback(ds);
            }).catch(function () {
              me.loading = false;
            });
          }
        });
      } else {
        var qp = { taskId: me.form.taskId, flowId: me.selectedFlowId };
        qp.candidateBmIds = me.candidateBmIds;
        PF.invoke("s:process.srv.searchHandleTaskData", qp).then(function (ret) {
          me.loading = false;
          me.flowCandidateData = ret.result || [];
          me.loadedSearchUser = true;
          callback(me.flowCandidateData);
        }).catch(function () {
          me.loading = false;
        });
      }
    },
    getSelectedFlow: function getSelectedFlow() {
      return _.find(this.mixFlows, { id: this.selectedFlowId });
    },
    selectUser: function selectUser() {
      var me = this;
      var flow = me.getSelectedFlow();
      if (flow) flow.userTreeVisible = true;
      if (me.form.taskId) {
        me.dialogVisible = true;
      } else {
        if (!me.form.$newForm.isValid(true)) {
          return;
        }
        me.form.startProcess(function (d, err) {
          if (!err) me.dialogVisible = true;
        });
      }
    },
    setSelectUsers: function setSelectUsers(flow) {
      var me = this;
      var tree = me.$refs[flow.id][0];

      var nodes = tree.getSelectNodes(true);
      me.selectedUsers = _.isArray(nodes) ? nodes : [nodes];
      me.dialogVisible = false;
    },
    loadSingleUsers: function loadSingleUsers(callback) {
      var me = this;
      if (!me.selectedFlowId) {


        return;
      }
      $.ajax({
        url: "/rest/process/task/flow/" + me.form.taskId + "/" + me.selectedFlowId,
        success: function success(tree) {
          function getDeepNode(node) {
            if (!node || !node.children) return node;
            return getDeepNode(node.children[0]);
          }
          function isSingleFlow(tree) {
            if (!tree || tree.length !== 1) return false;
            if (!tree[0].children || tree[0].children.length === 0) {
              return !tree[0].hasChild;
            } else {
              return isSingleFlow(tree[0].children);
            }
          }
          me.curSelFlowData = tree;
          me.processCandidateBmIds(tree);
          if (isSingleFlow(tree)) {
            me.selectedUsers = [getDeepNode(tree[0])];
          }
          if (_.isFunction(callback)) {
            callback(tree);
          }
        } });

    },
    processCandidateBmIds: function processCandidateBmIds(tree) {
      var me = this;
      me.candidateBmIds = [];
      if (tree) {var
        _processBmIds = function _processBmIds(ds) {
          if (ds && ds.length > 0) {
            _.each(ds, function (d) {
              if (d.hasReal && d.hasChild) {
                me.candidateBmIds.push(d.id);
              }
              _processBmIds(d.children);
            });
          }
        };
        _processBmIds(tree);
      }
    },
    submit: _.debounce(function () {var _this2 = this;
      var me = this;
      if (!me.form.$newForm.isValid(true)) {
        return;
      }
      me.submitLoading = true;
      me.form.startProcess(function (d, err) {
        me.submitLoading = false;
        if (!err) {var










          continuation = function continuation() {
            me._submit();
          };if (me.isExtraFlowActive) {if (me.selectedFlow.onSubmit) {me.selectedFlow.onSubmit.call(me, me.selectedFlow, me.selectedUsers);}return;}if (me.form.$newForm.fireEvent("beforecomplete", me.form, me.form, continuation.bind(_this2)) === false) {return false;}continuation();
        }
      });
    }, 1000, {
      'leading': true,
      'trailing': false }),

    _submit: function _submit() {
      var me = this;

      if (!me.selectedFlowId) {
        PF.message("info", $lang("未获取到符合条件的流向信息"));
        return;
      }
      if (_.isEmpty(me.selectedUsers)) {
        PF.message("info", $lang("请先选择人员"));
        return;
      }
      function doCommit(params) {
        me.form.$newForm.fireEvent("beforedocomplete", params);
        me.submitLoading = true;
        me.mwApi.process.batchCommit(params).then(function (res) {
          me.submitLoading = false;
          var data = res.result;
          if (data && !data.success) {
            if (data.errorType == 'comment') {
              if (data.errorCode == 'comment_check_stop') {
                PF.message('info', $lang('您还没有填写意见,请填写意见'));

                return;
              } else if (data.errorCode == 'comment_check_remind') {
                PF.confirm($lang('您还没有填写意见,您确认是要继续完成？'), $lang('提示'), { type: 'warning' }).then(function () {
                  params['$directSave'] = true;
                  doCommit(params);
                }).catch(function () {

                });
                return;
              }
            } else {
              var errorMsg = '';
              if (data.errorMsg) {
                errorMsg = '[' + $lang('错误信息') + ':' + data.errorMsg + ']';
              }
              PF.message('info', $lang('完成失败') + errorMsg + '!');
              return;
            }
          } else {
            if (me.form.$newForm.fireEvent("aftercomplete", params, res) === false) {
              return false;
            }
            me.form.formActionComplete();
          }
        }).catch(function () {
          me.submitLoading = false;
        });
      }
      var flowData = me.getSelectedFlow();
      if (me.selectedFlowId && me.selectedUsers.length === 0) {
        if (flowData.activityId === 'end') {
          var params = {};
          params.type = "complete";

          params.taskId = me.form.taskId;
          params.appId = me.form.appId;
          params.formId = me.form.formId;
          params.formKey = me.form.formKey;

          params.businessId = me.form.businessId;
          params.activities = [{ flowId: flowData.id, activityId: flowData.activityId }];
          if (me.form.comment) {
            params.$comment = [{ id: me.form.commentId, content: me.form.comment, category: me.form.commentCategory }];
          }
          params.formOpenSource = me.params.formOpenSource;

          doCommit(params);
        } else {
          PF.message("info", $lang("请先选择办理人员"));
        }
      } else {
        var activity = {};
        activity.flowId = flowData.id;
        activity.activityId = flowData.activityId;
        activity.type = flowData.type;
        activity.options = flowData.options;
        var items = [];

        if (flowData.type == "startSubProcess" && activity.options.activityUnit == 'group') {
          $.each(me.selectedUsers, function (i, d) {
            var uitem = { group: d.id };
            uitem.users = [];
            _.each(d.identities, function (u) {
              uitem.users.push({ id: u.id });
            });
            items.push(uitem);
          });
        } else {
          _(me.selectedUsers).groupBy("parentId").each(function (users, parentId) {
            if (flowData.options.singleDepartmentRecord !== "true") {
              users.forEach(function (u) {
                items.push({
                  group: parentId,
                  users: [{ id: u.id.split("_").pop() }] });

              });
            } else {
              items.push({
                group: parentId,
                users: users.map(function (u) {return { id: u.id.split("_").pop() };}) });

            }
          });
        }
        activity.items = items;
        var _params = {};
        _params.type = "complete";

        _params.taskId = me.form.taskId;
        _params.appId = me.form.appId;
        _params.formId = me.form.formId;
        _params.formKey = me.form.formKey;

        _params.businessId = me.form.businessId;
        _params.activities = [activity];
        _params.formOpenSource = me.form.formOpenSource;
        doCommit(_params);
      }
    },
    extraFlowButtonClick: function extraFlowButtonClick() {var _this3 = this;
      if (!this.isExtraFlowActive) return;
      var fn = this.selectedFlow.button.handler;
      fn.call(this, function (users) {
        _this3.selectedUsers = users;
      });
    } },

  computed: {
    mixFlows: function mixFlows() {
      return this.flows.concat(this.extraFlows);
    },
    isExtraFlowActive: function isExtraFlowActive() {var _this4 = this;
      return this.selectedFlowId && _.findIndex(this.extraFlows, function (f) {return f.id === _this4.selectedFlowId;}) >= 0;
    },
    isOverFlow: function isOverFlow() {
      return this.selectedFlow && this.selectedFlow.activityName === "结束";
    },
    selectedFlow: function selectedFlow() {
      return this.getSelectedFlow();
    } } };

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =










{
  name: 'Loading' };

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);var _promise = __webpack_require__(19);var _promise2 = _interopRequireDefault(_promise);var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);




var _vue = __webpack_require__(11);var _vue2 = _interopRequireDefault(_vue);
var _store_rt = __webpack_require__(142);var _store_rt2 = _interopRequireDefault(_store_rt);
var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  name: 'mw-inner-page',
  data: function data() {
    return {
      $component: {},
      cssEl: null,
      pageReady: false };

  },
  props: {
    params: {
      type: Object },


    dialog: {
      type: Object },


    pageId: String,
    pageData: Object,
    noWrap: {
      type: Boolean,
      default: false },

    unitFilter: {
      type: Boolean,
      default: false },

    deptFilter: {
      type: Boolean,
      default: false } },


  mounted: function mounted() {
    this.loadPage();
  },
  watch: {
    pageId: function pageId() {
      this.loadPage();
    } },

  beforeDestroy: function beforeDestroy() {
    this.destroy();
  },
  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'curSelUnitId',
  'curSelDeptId'])),


  methods: {
    destroy: function destroy() {




      if (this.cssEl) {
        this.cssEl.remove();
      }
      this.pageReady = false;
    },
    insertCss: function insertCss(css) {
      if (!css) return;
      this.cssEl = $("<style type='text/css'></style>").html(css).insertBefore(this.$el);
    },
    wrapTpl: function wrapTpl(tpl) {
      return this.noWrap ? tpl : '<div class="mw-panel">\n            <div class="mw-panel mw-panel-class">\n              ' +

      tpl + '\n            </div>\n          </div>';


    },
    getParentPage: function getParentPage() {
      var p = this.$parent;
      do {
        if (p.getPageDef) return p;
        p = p.$parent;
      } while (p);
    },
    getPageDef: function getPageDef(id) {
      var me = this;
      return new _promise2.default(function (resolve, reject) {
        function cacheSubPage(def) {
          if (def && def.subPages) {
            me.subPageMap = {};
            def.subPages.forEach(function (p) {
              if (p)
              me.subPageMap[p.id] = p;
            });
          }
        }
        if (me.pageData) {
          cacheSubPage(me.pageData);
          return resolve(me.pageData);
        }
        var page = void 0;
        var parentPage = me.getParentPage();
        if (parentPage && parentPage.subPageMap) {
          page = parentPage.subPageMap[id];
          if (page) {
            cacheSubPage(page);
            return resolve(page);
          }
        }
        $.ajax('/resource/page/' + id).then(function (res) {

          if (res.success) {
            var def = res.result;
            cacheSubPage(def);
            resolve(def);
          } else {
            reject(res);
          }
        });
      });
    },
    loadPage: function loadPage() {var _this = this;
      var me = this;
      me.destroy();
      if (!me.pageId && !me.pageData) return;
      me.getPageDef(me.pageId, true).then(function (page) {
        if (!page) {
          me.mwMsg("warning", "没找到对应页面:" + me.pageId);
          return;
        }
        _this.insertCss(page.style);
        var $obj = void 0;
        if (page.script) {
          var script = '(function(){\n            var $obj;\n\n            ' +


          page.script + '\n\n            return $obj\n          })()';



          $obj = eval(script);

        }

        if ($obj) {
          $obj = (0, _assign2.default)({

            template: _this.wrapTpl(page.template),
            store: _store_rt2.default,
            router: mwRouter },
          $obj);
        } else {
          $obj = {

            template: _this.wrapTpl(page.template),
            store: _store_rt2.default,
            router: mwRouter };

        }
        var config = {};


        if (me.unitFilter) {
          if (me.curSelUnitId) {
            config.unitFilter = me.curSelUnitId;
          }
        }

        if (me.deptFilter) {
          if (me.curSelDeptId) {
            config.deptFilter = me.curSelDeptId;
          }
        }

        $obj.customConfig = { config: config, params: me.params, dialog: me.dialog };


        me.$component = $obj;
        me.pageReady = true;
      });
    } } };

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var USER_LOGIN = exports.USER_LOGIN = 'USER_LOGIN';
var USER_LOGIN_OUT = exports.USER_LOGIN_OUT = 'USER_LOGIN_OUT';
var GET_USER_INFO = exports.GET_USER_INFO = 'GET_USER_INFO';




var GET_FORM_CONFIG = exports.GET_FORM_CONFIG = 'GET_FORM_CONFIG';
var GET_FORM_CONFIG_LOADED = exports.GET_FORM_CONFIG_LOADED = 'GET_FORM_CONFIG_LOADED';
var SET_FORM_LOADED = exports.SET_FORM_LOADED = 'GET_FORM_LOADED';
var SET_FLOW_LOADED = exports.SET_FLOW_LOADED = 'GET_FLOW_LOADED';
var SET_SET_LOADED = exports.SET_SET_LOADED = 'GET_SET_LOADED';
var SET_DATA_LOADED = exports.SET_DATA_LOADED = 'GET_DATA_LOADED';


var LIST_APPLICATION_ITEM = exports.LIST_APPLICATION_ITEM = 'LIST_APPLICATION_ITEM';

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
















var _resizer = __webpack_require__(937);var _resizer2 = _interopRequireDefault(_resizer);
var _pane = __webpack_require__(939);var _pane2 = _interopRequireDefault(_pane);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  name: 'splitPane',
  components: { Resizer: _resizer2.default, Pane: _pane2.default },
  props: {
    minPercent: {
      type: Number,
      default: 10 },

    defaultPercent: {
      type: Number,
      default: 30 },

    defaultSize: Number,
    split: {
      validator: function validator(value) {
        return ['vertical', 'horizontal'].indexOf(value) >= 0;
      },
      default: 'vertical' } },


  computed: {
    userSelect: function userSelect() {
      return this.active ? 'none' : '';
    },
    cursor: function cursor() {
      return this.active ? 'col-resize' : '';
    } },

  data: function data() {
    return {
      active: false,
      hasMoved: false,
      showMask: false,
      height: null,
      percent: this.defaultPercent,
      type: this.split === 'vertical' ? 'width' : 'height',
      resizeType: this.split === 'vertical' ? 'left' : 'top' };

  },
  mounted: function mounted() {

    if (this.defaultSize) {
      this.computePercentage(this.defaultSize);
    }
  },
  methods: {
    computePercentage: function computePercentage(size) {
      if (!size) return;
      var totalSize = $(this.$el).width();
      this.percent = size * 100 / totalSize;
    },
    onClick: function onClick() {
      if (!this.hasMoved) {

        this.$emit('resize');
      }
    },
    onMouseDown: function onMouseDown() {
      this.active = true;
      this.hasMoved = false;
    },
    onMouseUp: function onMouseUp() {
      this.active = false;
    },
    onMouseMove: function onMouseMove(e) {
      if (e.buttons === 0 || e.which === 0) {
        this.active = false;
      }
      if (this.active) {
        var offset = 0;
        var target = e.currentTarget;
        if (this.split === 'vertical') {
          while (target) {
            offset += target.offsetLeft;
            target = target.offsetParent;
          }
        } else {
          while (target) {
            offset += target.offsetTop;
            target = target.offsetParent;
          }
        }

        var currentPage = this.split === 'vertical' ? e.pageX : e.pageY;
        var targetOffset = this.split === 'vertical' ? e.currentTarget.offsetWidth : e.currentTarget.offsetHeight;
        var percent = Math.floor((currentPage - offset) / targetOffset * 10000) / 100;
        if (percent > this.minPercent && percent < 100 - this.minPercent) {
          this.percent = percent;
        }
        this.$emit('resize', this.percent);
        this.hasMoved = true;
      }
    } },

  watch: {
    defaultPercent: function defaultPercent(val) {
      this.percent = val;
    } } };

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =




{
  props: {
    split: {
      validator: function validator(value) {
        return ['vertical', 'horizontal'].indexOf(value) >= 0;
      },
      required: true } },


  data: function data() {
    var classes = ['Resizer', this.split, 'className'];
    return {
      classes: classes.join(' ') };

  } };

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =






{
  name: 'Pane',
  data: function data() {
    var classes = ['Pane', this.$parent.split, 'className'];
    return {
      classes: classes.join(' '),
      percent: 50 };

  } };

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _stringify = __webpack_require__(24);var _stringify2 = _interopRequireDefault(_stringify);
















var _token = __webpack_require__(25);var _token2 = _interopRequireDefault(_token);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{

  name: 'MwTree',
  props: {
    ajaxType: {
      type: String,
      default: 'GET' },

    search: {
      type: Boolean,
      default: false },

    restful: {
      type: Boolean,
      default: false },


    autoLoad: {
      type: Boolean,
      default: true },


    defaultParentId: {
      type: String },


    defaultParams: {
      type: Object },

    changeDefaultParams: {
      type: Function },

    reload: {
      type: Boolean,
      default: true },


    aliasId: {
      type: String,
      default: 'nodeId' },


    url: {
      type: String },


    expandedFirst: {
      type: Boolean,
      default: false },

    selectFirst: {
      type: Boolean,
      default: false },


    async: {
      type: Boolean,
      default: false },


    multiple: {
      type: Boolean,
      default: false },

    singleLeaf: {
      type: Boolean,
      default: false },


    multipleLeaf: {
      type: Boolean,
      default: false },

    contextMenuItem: {
      type: Array,
      default: function _default() {
        return [];
      } },

    dragEnable: {
      type: Boolean,
      default: false },


    threeState: {
      type: Boolean,
      default: false },



    checkNodes: {
      type: Array,
      default: function _default() {
        return [];
      } },


    selectNode: {
      type: String,
      default: '' },

    checkCallback: {
      type: Function,
      default: function _default(operation, node, node_parent, node_position, more) {
        return true;
      } },

    types: {
      type: Object },


    treeData: {
      type: [Array, Object] },


    paramsAnalyze: {
      type: Function } },


  data: function data() {
    return {
      propTreeData: this.treeData,
      propDefaultParams: this.defaultParams,
      propAsyncLoadOnce: false,
      searchFlag: false,
      searchText: '',
      selectData: {},
      selectParents: [],
      selecteNodeIds: [] };

  },
  watch: {
    checkNodes: function checkNodes(newIds) {
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      try {
        inst.uncheck_all();
        newIds.forEach(function (id) {
          var obj = inst.get_node(id);
          inst.check_node(obj);
        });
      } catch (e) {}

    },
    selectNode: function selectNode(newId) {
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      try {
        inst.deselect_all();
        if (newId) {
          var obj = inst.get_node(newId);
          inst.select_node(obj);
        }
      } catch (e) {}
    },
    searchText: function searchText(val) {
      this.searchTree(val);
    },
    url: function url(val) {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (tree) {
        tree.destroy();
      }
      this.renderTree();
    },
    defaultParams: function defaultParams(val) {
      this.propDefaultParams = val;
      if (this.reload) {
        var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
        if (tree) {
          tree.destroy();
        }
        this.renderTree();
      }
    },
    defaultParentId: function defaultParentId(val) {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (tree) {
        tree.destroy();
      }
      this.renderTree();
    },
    treeData: function treeData(val) {
      this.propTreeData = val;
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (tree) {
        tree.destroy();
      }
      this.renderTree();
    },
    paramsAnalyze: function paramsAnalyze(val) {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (tree) {
        tree.destroy();
      }
      this.renderTree();
    } },

  mounted: function mounted() {
    if (this.autoLoad) {
      this.renderTree();
    }
  },
  destroyed: function destroyed() {
    var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
    if (tree) {
      tree.destroy();
    }
  },
  methods: {
    searchTree: function searchTree(val) {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (val == '') {
        setTimeout(function () {
          try {
            tree.clear_search();
          } catch (e) {}
        }, 250);
      } else {
        if (this.searchFlag) {
          clearTimeout(this.searchFlag);
        }
        this.searchFlag = setTimeout(function () {
          tree.search(val, true, true);
        }, 250);
      }

    },
    checkAll: function checkAll() {
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.select_all();
    },
    unCheckAll: function unCheckAll() {
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.deselect_all();
    },
    openAll: function openAll() {
      $(this.$el.querySelector('.mw-tree')).jstree('open_all');
    },
    openNode: function openNode(openId) {
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      var n = inst.get_node(openId);
      inst.open_node(n);
    },
    closeAll: function closeAll() {
      $(this.$el.querySelector('.mw-tree')).jstree('close_all');
    },
    refresh: function refresh() {


      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (tree) {
        var selected = tree.get_selected();
        this.selecteNodeIds = [];
        if (!this.multiple && selected.length > 0) {
          this.setSelectNodeIds(selected[0], tree);
        }
        tree.destroy();
      }
      this.renderTree();
    },
    setSelectNodeIds: function setSelectNodeIds(nodeId, inst) {
      var me = this;
      me.selecteNodeIds.push(nodeId);
      var node = inst.get_node(nodeId);
      var parents = node.parents;
      if (parents && parents.length > 1) {
        for (var i = 0; i < parents.length - 1; i++) {
          me.selecteNodeIds.push(parents[i]);
        }
      }
    },
    setCheckNodes: function setCheckNodes(newIds) {
      var me = this;
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.uncheck_all();
      newIds.forEach(function (id) {
        var obj = inst.get_node(id);
        inst.check_node(obj);
      });
    },
    setSelectNode: function setSelectNode(newId) {
      var me = this;
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.deselect_all();
      if (newId) {
        var obj = inst.get_node(newId);
        inst.select_node(obj);
      }
    },
    refreshTreeData: function refreshTreeData(val) {
      this.propTreeData = val;
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (tree) {
        tree.destroy();
      }
      this.renderTree();
    },
    refreshData: function refreshData(data) {
      $(this.$el.querySelector('.mw-tree')).jstree(true).settings.core.data = data;
      $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
    },
    getNode: function getNode(id) {
      return $(this.$el.querySelector('.mw-tree')).jstree(true).get_node(id);
    },
    getSelected: function getSelected() {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      var selected = tree.get_selected();

      var data = [];
      if (this.multiple) {
        if (selected.length > 0) {
          data = [];
          selected.forEach(function (id) {
            data.push(tree.get_node(id).original);
          });
        }
      } else {
        if (selected.length > 0) {
          data = tree.get_node(selected[0]).original;
        } else {
          return undefined;
        }
      }
      return data;
    },
    getTree: function getTree() {
      return $(this.$el.querySelector('.mw-tree')).jstree(true);
    },
    getTreeData: function getTreeData() {
      var tree = this.getTree();
      return tree.get_json();
    },

    editNodeName: function editNodeName(selectNode, parentId) {
      var tree = this.getTree();
      var clickedNode = tree.get_node(selectNode);
      tree.edit(clickedNode);
    },
    setNodeText: function setNodeText(node, text) {
      this.getTree().set_text(node, text);
    },
    deleteNode: function deleteNode(selectNode, callback) {
      var tree = this.getTree();
      var clickedNode = tree.get_node(selectNode);
      tree.delete_node(clickedNode);
      if (typeof callback === 'function') {
        callback();
      }
    },

    createNode: function createNode(selectNode, node, position, callback) {
      var tree = this.getTree();
      var id = tree.create_node(selectNode, node, position);
      return tree.get_node(id);
    },


    resetSearchText: function resetSearchText() {
      this.searchText = '';
    },

    changeMenuItem: function changeMenuItem(data) {
      var me = this;
      if (me.contextMenuItem.length > 0) {
        var items = {};
        me.contextMenuItem.forEach(function (item) {
          items[item.name] = {
            "name": item.name ? item.name : '',
            "label": item.label,
            "icon": item.icon ? item.icon : '',
            "action": function action(a) {
              item.func(me.selectData, me.selectParents, a.item, a);
            } };

        });
        return items;
      } else {
        var _items = {};
        this.$emit('changeItem', data, function (d) {
          _items = d;
        });
        return _items;
      }
    },

    renderTree: function renderTree() {var _this = this;

      var me = this,jsTreeEl = $(me.$el.querySelector('.mw-tree'));

      var plugin = ["types"];
      var items = {};
      if (me.multiple) {
        plugin.push("checkbox");
        plugin.push("wholerow");
      } else {
        plugin.push("wholerow");
      }
      var types = { "#": {
          "icon": "fa fa-folder" },

        "file": {
          "icon": "fa fa-leaf" },

        "default": {
          "icon": "fa fa-folder" } };

      if (me.types) {
        types = me.types;
      }

      if (!this.dragEnable) {
        plugin.push("dnd");
      }
      if (me.search) {
        plugin.push("search");
      }















      plugin.push("contextmenu");
      var data = {};

      function changeTreeData(data) {
        data.forEach(function (d) {
          if (undefined == d.text) {
            if (d.name != undefined)
            d.text = d.name;
          }
          if (d.children) {
            if (!d.hasChild) {
              d.hasChild = d.children.length;
            }
            if (d.children.length > 0) {
              changeTreeData(d.children);
            }
          } else {
            d.children = false;
            d.hasChild = 0;
          }
          if (d.hasChild > 0) {
            if (me.multiple && me.multipleLeaf) {
              d.state = { "disabled": true };
            }
          }
          if (!d.id) {
            d.id = d.text;
          }
        });
      }

      if (me.propTreeData) {
        var cdata = [];
        me.propTreeData.forEach(function (v) {
          var v1 = {};
          _this.mwLodash.assign(v1, v);
          cdata.push(v1);
        });
        changeTreeData(cdata);
        data = cdata;
      } else {
        var url = me.url;
        if (url.indexOf("?") == -1) {
          url = url + "?t=" + Date.now();
        } else if (url.indexOf("?t=") == -1 && url.indexOf("&t=") == -1) {
          url = url + "&t=" + Date.now();
        }
        data = {



          "url": me.ajaxType == 'GET' ? function (node) {
            if (me.async) {
              var sendData = undefined;
              if (node.id != '#') {
                sendData = node.original;
                if (me.changeDefaultParams) {
                  var tempDefaultParams = me.changeDefaultParams(sendData);
                  if (tempDefaultParams) {
                    var arr = [];
                    for (var p in tempDefaultParams) {
                      arr.push(p + "=" + tempDefaultParams[p]);
                    }
                    if (node.id != '#') {
                      arr.push(me.aliasId + "=" + node.id);
                    }
                    return url + '&' + arr.join("&");
                  }
                }
              }
            }
            if (me.propDefaultParams) {
              var _arr = [];
              for (var _p in me.propDefaultParams) {
                _arr.push(_p + "=" + encodeURIComponent(me.propDefaultParams[_p]));
              }
              if (node.id != '#') {
                _arr.push(me.aliasId + "=" + node.id);
              }
              return url + '&' + _arr.join("&");
            }

            if (node.id === '#') {
              if (me.defaultParentId) {
                return url + '&args=' + encodeURIComponent('[' + me.defaultParentId + ']');
              }
              return url + '&args=' + encodeURIComponent('[null]');
            } else {
              return url + '&args=' + encodeURIComponent('[' + node.id + ']');
            }
          } : url,
          type: me.ajaxType,
          'data': function data(node) {
            if (me.ajaxType == "GET") {
              return;
            } else {
              if (me.paramsAnalyze) {
                return me.paramsAnalyze(node, me);
              } else {
                return { 'id': node.id };
              }
            }
          },
          dataFilter: function dataFilter(data) {
            var json = JSON.parse(data);
            var data = json.result;
            if (me.restful) {
              data = json;
            }

            if (data) {
              if (me.async) {
                data.forEach(function (d) {
                  if (!me.propAsyncLoadOnce && d.children) {
                    me.propAsyncLoadOnce = true;
                  }

                  if (undefined == d.text) {
                    if (d.name != undefined)
                    d.text = d.name;
                  }
                  if (d.children) {
                    changeTreeData(d.children);
                    if (!d.hasChild) {
                      d.hasChild = d.children.length;
                    }
                  } else {
                    if (d.hasChild) {
                      if (!d.children) {
                        if (d.hasChild > 0) {
                          d.children = true;
                        } else {
                          d.children = false;
                        }
                      }
                    } else {
                      if (!(d.type != '' && me.types)) {
                        d.type = 'file';
                      }
                      d.children = false;
                      d.hasChild = 0;
                    }
                  }
                  if (!d.id) {
                    d.id = d.text;
                  }
                });
              } else {
                changeTreeData(data);
              }
            } else {
              data = [];
            }
            if (me.selecteNodeIds.length === 0) {
              me.$emit("dataAfterLoaded", data);
            }
            me.$emit("dataFilter", data);
            return (0, _stringify2.default)(data);
          },


          "success": function success(data) {
            return data;
          } };

      }

      jsTreeEl.data('jstree', false).empty();
      jsTreeEl.jstree({
        'async': me.async,
        'expanded_first': false,
        'core': {
          "themes": {
            "responsive": false },

          "multiple": me.multiple,
          "check_callback": function check_callback(operation, node, node_parent, node_position, more) {
            return me.checkCallback(operation, node, node_parent, node_position, more);
          },
          'data': data },

        'checkbox': {
          "keep_selected_style": false,
          "tie_selection": true,
          "three_state": me.threeState,
          "visible": true },

        "plugins": plugin,
        "contextmenu": {
          "items": me.changeMenuItem },

        "types": types }).
      bind("load_node.jstree", function (e, data) {
        var inst = data.instance;
        var set = inst.settings;
        if ((!set.async || set.async && me.propAsyncLoadOnce) && me.expandedFirst && !set.expanded_first) {var
          _open_first_node = function _open_first_node(node) {
            if (node.children && node.children[0]) {
              var n = inst.get_node(node.children[0]);
              inst.open_node(n);
              _open_first_node(n);
            } else {
              set.expanded_first = true;
              if (!me.multiple && me.selectFirst) {
                inst.select_node(node);
              }
            }
          };
          _open_first_node(data.node);
        }
        if (me.selecteNodeIds.length > 0) {
          var setSelTreeNode = function setSelTreeNode(parentNode) {
            if (me.selecteNodeIds.length > 0) {
              var nodeId = me.selecteNodeIds[me.selecteNodeIds.length - 1];
              var selNodeObj = inst.get_node(nodeId);
              if (selNodeObj) {
                inst.deselect_all();
                inst.select_node(selNodeObj);
                me.selecteNodeIds.pop();
                setSelTreeNode(selNodeObj);
              } else {
                if (data.node.id != "#") {
                  me.selecteNodeIds.pop();
                  if (me.selecteNodeIds.length === 0) {
                    me.$emit('changed', me.getSelected(), me);
                  }
                } else {
                  if (parentNode.children.length > 0) {
                    me.selecteNodeIds = [];
                    me.$emit('changed', me.getSelected(), me);
                  }
                }
              }
            }
          };
          var nodeId = me.selecteNodeIds.pop();
          selNodeObj = inst.get_node(nodeId);
          if (selNodeObj) {
            inst.deselect_all();
            inst.select_node(selNodeObj);
            inst.open_node(nodeId);
            setSelTreeNode(selNodeObj);
            set.expanded_first = true;
          }
        } else if (set.async && me.expandedFirst) {
          if (data.node && data.node.children && !set.expanded_first) {
            if (me.checkNodes.length > 0) {
              me.checkNodes.forEach(function (id) {
                var obj = inst.get_node(id);
                inst.check_node(obj);
              });
            }
            var node = inst.get_node(data.node.children[0]);
            if (node.original && node.original.hasChild > 0) {
              inst.open_node(data.node.children[0]);
            } else {
              if (me.selectFirst) {
                var selNodeObj = false;
                if (me.selectNode) {
                  selNodeObj = inst.get_node(me.selectNode);
                }
                if (selNodeObj) {
                  inst.select_node(selNodeObj);
                } else {
                  inst.select_node(node);
                }
              }
              set.expanded_first = true;
            }
          } else {
            set.expanded_first = true;
          }
        }
      }).on("changed.jstree", function (e, data) {
        var inst = data.instance;
        if (data.action == 'select_node') {
          if (!me.multiple && me.singleLeaf && data.node.original && data.node.original.hasChild > 0 ||
          me.multiple && me.multipleLeaf && data.node.original && data.node.original.hasChild > 0)
          {
            var obj = inst.get_node(data.node.original.id);
            inst.deselect_node(obj);
            return;
          }
          if (me.contextMenuItem.length > 0) {
            me.selectData = data.node.original;
            var parents = data.node.parents;
            me.selectParents = [];
            parents.forEach(function (id) {
              if ('#' != id) {
                var _obj = inst.get_node(id);
                me.selectParents.push(_obj.original);
              }
            });
            me.$emit('contextMenuChanged', data.node.original, inst.settings);
          }
          if (me.selecteNodeIds.length === 0) {
            me.$emit('changed', data.node.original, me);
          } else {
            if (me.selecteNodeIds.length == 1 && data.node && (!data.node.children || data.node.children.length === 0)) {
              me.$emit('changed', data.node.original, me);
            }
          }
        } else if (data.action == "deselect_node") {
          me.$emit('unselected', data.node.original, me);
        }
      }).on("before_open.jstree", function (el, data) {

      }).bind("loaded.jstree", function (e, data) {
        var inst = data.instance;
        if (me.checkNodes.length > 0) {
          me.checkNodes.forEach(function (id) {
            var obj = inst.get_node(id);
            inst.check_node(obj);
          });
        }
        if (me.selectNode) {
          var obj = inst.get_node(me.selectNode);
          inst.select_node(obj);
        }
        me.$emit('loaded_tree', inst);
      }).bind("dblclick.jstree", function (e, data) {
        var id = e.target.id.substr(0, e.target.id.lastIndexOf('_'));
        var obj = jsTreeEl.jstree(true).get_node(id);
        if (obj) {
          me.$emit("dblClick", obj.original, obj.parent);
        }
      }).on('show_contextmenu.jstree', function (e, data) {
        var inst = data.instance;
        me.$emit('showContextmenu', data.node.original, inst.settings);
      }).on('move_node.jstree', function (e, data) {
        me.$emit('move', e, data);
      }).on('ready.jstree', function (e, data) {
        me.$emit('ready', e, data, me);
        if (me.propTreeData) {
          var inst = data.instance;
          if (me.checkNodes.length > 0) {
            me.checkNodes.forEach(function (id) {
              var obj = inst.get_node(id);
              inst.check_node(obj);
            });
          }
          if (me.selectNode) {
            var obj = inst.get_node(me.selectNode);
            inst.select_node(obj);
          }

          if (me.expandedFirst) {var
            _open_first_node2 = function _open_first_node2(node) {
              if (!node) return;
              if (node.children[0]) {
                var n = inst.get_node(node.children[0]);
                inst.open_node(n);
                _open_first_node2(n);
              } else {
                if (!me.selectNode && me.selectFirst) {
                  inst.select_node(node);
                }
              }
            };
            if (me.propTreeData.length > 0) {
              var _obj2 = inst.get_node(me.propTreeData[0].id);
              inst.open_node(_obj2);
              _open_first_node2(_obj2);
            }

          }
        }
        if (me.search) {
          me.searchTree(me.searchText);
        }
      }).on('refresh.jstree', function (e, data) {
        me.$emit('refresh', e, data, me);
      });


    } } };

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =














{
  name: 'mw-pagination',
  data: function data() {
    var ps = [20, 50, 100, 250, 500, 1000];
    if (ps.indexOf(this.pageSize) == -1) {
      ps.unshift(this.pageSize);
    }
    return {
      pageSizes: ps };

  },
  props: {
    total: {
      type: Number,
      default: 0 },

    currentPage: {
      type: Number,
      default: 1 },

    pageSize: {
      type: Number,
      default: 20 } },


  methods: {
    "currentChange": function currentChange(val) {
      this.$emit('current-change', val);
    },
    "sizeChange": function sizeChange(val) {
      this.$emit('size-change', val);
    } },

  watch: {
    pageSize: function pageSize(val) {
      if (this.pageSizes.indexOf(val) == -1) {
        this.pageSizes.unshift(val);
      }
    } } };

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
































































































































var _table = __webpack_require__(948);var _table2 = _interopRequireDefault(_table);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
_table2.default;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _vuex = __webpack_require__(9);
var _store_rt = __webpack_require__(142);var _store_rt2 = _interopRequireDefault(_store_rt);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  name: 'MwView',
  props: {
    params: {
      type: Object,
      default: function _default() {
        return {};
      } },

    tableParams: {
      type: Object,
      default: function _default() {
        return {};
      } },

    formValue: {
      type: Object,
      default: function _default() {
        return {};
      } },

    applicationId: {
      type: String },

    id: {
      type: String },

    linkId_appId: {
      type: String },

    unitFilter: {
      type: Boolean,
      default: false },

    deptFilter: {
      type: Boolean,
      default: false } },



  data: function data() {
    return {
      serviceId: "",
      menuItems: [],
      defaultKey: '',
      $viewObj: undefined,
      openFormEditMode: false,
      treeNodeFields: [] };

  },
  mounted: function mounted() {
    var me = this;
    if (me.id) {
      me.renderById([me.id]);
    }
    if (me.linkId_appId) {
      me._renderByLinkId();
    }
  },
  watch: {
    'id': function id(val, oldVal) {
      if (val) {
        this.renderById([val]);
      }
    },
    'linkId_appId': function linkId_appId(val, oldVal) {
      if (val) {
        this._renderByLinkId();
      }
    } },


  beforeDestroy: function beforeDestroy() {
    this._destroyViewObj();
  },
  methods: {

    _handleSelect: function _handleSelect(v) {
      this.renderById([v]);
    },
    _renderByLinkId: function _renderByLinkId() {
      var me = this;
      var p = me.linkId_appId.split("_");
      me.menuItems = [];
      me.mwApi.app.getNavigatorRecord(p[0], p[1]).then(function (data) {
        var res = data.result;
        var targetIds = res.targetId.split(',');
        var targets = res.target.split(',');
        for (var i = 0; i < targetIds.length; i++) {
          me.menuItems.push({ id: targetIds[i], name: targets[i] });
        }
        me.defaultKey = targetIds[0];
        me.renderById([me.defaultKey]);
      });
    },
    _destroyViewObj: function _destroyViewObj() {
      try {
        if (this.$viewObj)
        this.$viewObj.$destroy();
        this.$viewObj = undefined;
      } catch (e) {
      }
    },

    getCurrentSelection: function getCurrentSelection() {
      return this.$viewObj.getCurrentSelection();
    },

    refresh: function refresh() {
      if (!this.$viewObj) return;
      return this.$viewObj.refresh();
    },




    getTreeSelection: function getTreeSelection() {
      return this.$viewObj.getTreeSelection();
    },


    renderById: function renderById($$$ids) {var h = this.$createElement;
      var $$$me = this;
      if (!$$$ids) {
        return;
      }
      var vp = _.clone($$$me.params);
      delete vp.getForm;
      delete vp.config;
      $$$me.mwApi.app.getApplicationViewItems($$$ids, vp, "").then(function ($$$data) {

        var $$$el = $$$me.$el.querySelector('.mw-page-view__config');
        $($$$el).empty();
        $$$me._destroyViewObj();

        $$$me.serviceId = $$$ids[0];
        if (!$$$data.result[0]) {
          $$$me.mwMsg('info', '视图不存在或未配置完整！');
          return;
        }
        var $$$content = $$$data.result[0].content;
        if (!$$$content) return;
        var $$$colLength = $$$content.columns.length;
        var $$$html = '';
        for (var i = 0; i < $$$colLength; i++) {
          var v = $$$content.columns[i];
          if (v.colHtml) {
            if (!v.prop) {
              v.prop = $uuid();
            }
            $$$html += '<template slot="' + v.prop + '" slot-scope="scope">\n              ' +
            v.colHtml + '\n            </template>';

          }
        }

        var template = '<div class="mw-page-view__config mw-panel">\n        <toolbar-table ref="toolbarTable" :applicationId="applicationId" :layout="layout" :treeExpandFirst="autoExpandFirst">\n        ' +

        $$$html + '\n        </toolbar-table></div>';


        $$$me.$viewObj = PF.createVue({
          el: $$$el,
          template: template,
          data: {
            extTableParams: $$$me.tableParams,
            extParent: $$$me,
            extCustomCondition: undefined,
            viewConfig: undefined,
            serviceId: $$$me.serviceId,
            mixId: '',
            layout: [],
            applicationId: $$$me.applicationId,
            moduleId: '',
            formId: '',
            defaultKey: $$$me.defaultKey,
            deptFilter: $$$me.deptFilter,
            unitFilter: $$$me.unitFilter,
            formValue: $$$me.formValue,
            params: $$$me.params,
            beforeOpenFormFn: null,
            autoExpandFirst: !$$$content.tree || $$$content.tree.autoExpandFirst !== false },

          computed: (0, _extends3.default)({},
          (0, _vuex.mapGetters)([
          'curSelUnitId',
          'curSelDeptId'])),


          store: _store_rt2.default,
          router: mwRouter,
          created: function created() {
          },
          beforeDestroy: function beforeDestroy() {
          },
          mounted: function mounted() {
            var $me = this;
            $me.viewConfig = $$$content;

            var $script = '(0,function(me){\n\n            ' +

            $$$content.javascript + '\n              return function(exp){\n                  return eval("(0,"+exp+")");\n              }\n            })';





            if ($$$content.table.moduleId) {
              $me.mixId = $$$content.table.moduleId;
              $me.moduleId = $$$content.table.moduleId;
            } else {
              if ($$$content.table.moduleId) {
                $me.mixId = $$$content.table.moduleId;
                $me.moduleId = $$$content.table.moduleId;
              }
            }
            if ($$$content.table.formId) {
              $me.formId = $$$content.table.formId;

            }
            var $$$defaultSort = [];
            $$$content.columns.forEach(function (v) {
              if (v.way && v.way == '2') {
                v.formatter = $me._titleFormatter;
              }
              if (v.sort) {
                v.sortable = "custom";
                if (["desc", "asc"].indexOf(v.sort) != -1) {
                  $$$defaultSort.push({ sort: v.prop, dir: v.sort });
                }
              }
            });
            var $$$url = '#data.listDocData';
            if ($$$content.table.way == '1') {
              $$$url = $$$url.substring(1);
            } else if ($$$content.table.way == '2') {
              var url = $$$content.table.url;
              if (!url) {
                $me.mwMsg('warning', '请配置表格属性URL');
                return;
              }
              if (url.indexOf('.') > -1) {
                if (url.startsWith("#")) {
                  $$$url = url.substring(1);
                } else {
                  $$$url = "/" + url;





                }
              } else {
                $$$url = "#" + $$$ids[0] + '.' + url;





              }
            }

            var scriptEval = void 0;
            try {
              scriptEval = eval($script);
            } catch (e) {
              if (window.console) console.log(e);
              return alert("视图脚本错误:" + e.getMessage());
            }
            scriptEval = scriptEval.call($me, $me);
            var contextEval = function contextEval(exp) {
              var fn = void 0;
              try {
                fn = scriptEval(exp);
              } catch (e) {
                if (window.console) console.log('-_-" 函数' + exp + '配置错误了');
              }
              return typeof fn === "function" ? fn : undefined;
            };
            $me.$contextEval = contextEval;
            var $$$items = [];
            $$$colLength = $$$content.columns.length;
            for (var _i = 0; _i < $$$colLength; _i++) {
              var v = $$$content.columns[_i];
              if (v.prop && v.colHtml) {
                v.slotName = v.prop;
              } else {
                if (v.way && v.way == '3') {
                  if (v.openFunc) {
                    if (typeof v.openFunc === 'string' && v.openFunc !== "") {
                      v.openFunc = contextEval(v.openFunc);
                    }
                  }
                  v.slot = { type: 'html', scope: $me, func: v.openFunc, html: "{{ scope.row[item.prop]}}" };
                }
                if (v.clickEdit && $$$me.params.formeditform !== false) {
                  v.slot = { type: "editableInput", func: v.openFunc };
                }
                if (v.formatter) {
                  if (typeof v.formatter === 'string' && v.formatter !== "") {
                    v.formatter = contextEval(v.formatter);
                  }
                }
              }
              $$$items.push(v);
            }
            $$$me.mwLodash.remove($$$content.columns, "hidden");
            $$$colLength = $$$content.treeToolbarItem.length;
            for (var i = 0; i < $$$colLength; i++) {
              var v = $$$content.treeToolbarItem[i];
              if (typeof v.func === 'string' && v.func !== "") {
                v.func = contextEval(v.func);
                v.$scope = $me;
              }
            }
            if ($me.viewConfig.table.unitFilter) {
              $me.unitFilter = $me.viewConfig.table.unitFilter;
            }
            var pageLimit = $$$content.table.pageLimit;
            if (pageLimit) {
              pageLimit = parseInt(pageLimit);
            }
            var singleSelect = $$$me.params.multiple === false ? true : !$$$content.table.multiple;
            $$$items.push({
              key: $uuid(),
              type: 'menu',
              label: '',
              unitFilter: $me.unitFilter,
              deptFilter: $me.deptFilter,
              pagination: $$$content.table.pagination,
              noPaginationLimit: $$$content.table.noPaginationLimit,
              toolbar: $$$content.table.toolbar,
              defaultActive: true,
              singleSelect: singleSelect,
              showRowExpander: $$$content.table.showRowExpander,
              customCondition: $$$content.table.condition,
              extCustomCondition: $me.extCustomCondition,
              defaultPercent: $$$content.table.treePercent,
              treeToolbarItem: $$$content.treeToolbarItem,
              readerAuthorize: $$$content.table.auth,
              treeConfig: $me._parseTreeConfig($$$content.tree, $$$ids[0], $$$content.table),
              toolbarItem: $$$content.toolbarItem,
              api: $$$url,
              defaultParams: $me.mwLodash.assign({ mixId: $me.mixId, limit: pageLimit }, { condition: $me.extTableParams }),
              defaultSort: $$$defaultSort,
              columns: $$$content.columns });

            var $$$length = $$$content.toolbarItem.length;
            for (var i = 0; i < $$$length; i++) {
              var v = $$$content.toolbarItem[i];
              if (v.type == 'button') {
                for (var j = 0; j < v.items.length; j++) {
                  var v1 = v.items[j];
                  if (typeof v1.func === 'string' && v1.func !== "") {
                    v1.func = contextEval(v1.func);
                    v1.$scope = $me;
                  }
                }
              }
              if (v.type == 'searchText') {
                var searchText = $$$content.searchText;
                if (searchText) {


                  if (searchText.tip)
                  v.tip = searchText.tip;
                  if (searchText.searchCurNode)
                  v.searchCurNode = searchText.searchCurNode;
                  var searchCol = [];
                  $$$content.columns.forEach(function (v) {
                    if (v.search && v.prop) {
                      searchCol.push(v.prop);
                    }
                  });
                  if (searchCol.length > 0) {
                    v.name = searchCol.join("|");
                  } else {
                    v.name = 'title';
                  }
                } else {
                  v.name = 'title';
                }
              }
              $$$items.push(v);
            }
            $me.layout = [];
            $me.layout.push($$$items);
            $me.getDataTable().$on("dataLoaded", function (dataList) {
              $me.$emit("dataLoaded", dataList);
            });
            $me.getDataTable().$on("rowClick", function (row, event, column) {
              $me.$emit("rowClick", row, column, event);
            });
            $me.getDataTable().$on("row-dblclick", function (row, event) {
              $me.$emit("row-dblclick", row, event);
            });
            $me.getDataTable().$on("selectChange", function (selection) {
              $me.$emit("selectChange", selection);
            });
            $me.getDataTable().$on("rowExpanded", function (row, container) {
              $me.$emit("rowExpanded", row, container);
            });

            $$$me.$emit("ready", $me);
          },
          methods: {
            exe: function exe(a) {
              var func = this.$contextEval(a);
              if (!func) return;for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {args[_key - 1] = arguments[_key];}
              return func.apply(this, args);
            },
            invoke: function invoke(url) {var _PF;for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {args[_key2 - 1] = arguments[_key2];}
              return (_PF = PF).invokeInner.apply(_PF, [this.serviceId + '.' + url].concat(args));
            },
            getCurrentSelection: function getCurrentSelection() {
              var me = this;
              var selData = me.mwRef('toolbarTable').getMultipleSelection();
              var ret = _.clone(selData);
              me.mwRef('toolbarTable').$emit("selData", ret);
              return ret;
            },
            getDataTable: function getDataTable() {
              return this.$refs.toolbarTable.$refs.dataTable;
            },
            getData: function getData() {
              return this.getDataTable().getData();
            },
            _titleFormatter: function _titleFormatter(a, b, c) {var h = this.$createElement;
              var me = this;
              return h('span', { 'class': { 'link': true }, attrs: { title: c }, on: { 'click': function click(event) {return me._showForm(a, event);} } }, [c ? c : '无标题']);
            },

            refresh: function refresh() {
              this.mwRef('toolbarTable').refreshTable();
            },




            getTreeSelection: function getTreeSelection() {
              var tree = this.mwRef('toolbarTable').mwRef('tree');
              if (tree) {
                return tree.getSelected();
              }
              return undefined;
            },

            _parseTreeConfig: function _parseTreeConfig(data, id, table) {
              var me = this;
              var config = { dragEnable: data.dragEnable };
              var treeConfig = data.treeData;
              if (table.treePercent == 0) {
                return;
              }
              if (data.way == '1') {
                config.url = this.mwUrl("/api/data/listDocTree");
              } else {
                var url = data.url;
                if (!url) {
                  me.mwMsg('warning', '请配置树属性URL');
                  return;
                }
                if (url.indexOf('.') > -1) {
                  if (url.startsWith("#")) {
                    config.url = this.mwUrl(url.substring(1));
                  } else {
                    if (url.indexOf('?') > -1) {
                      config.url = this.mwUrl('/cheetah/service/') + url + '$$forceTran=false';
                    } else {
                      config.url = this.mwUrl('/cheetah/service/') + url + '?$$forceTran=false';
                    }
                  }
                } else {
                  if (url.startsWith("#")) {
                    config.url = this.mwUrl(url.substring(1));
                  } else {
                    config.url = this.mwUrl('/cheetah/service/') + id + '.' + url + '?$$es=true&$$forceTran=false';
                  }
                }
              }
              config.paramsAnalyze = function (node, tree) {
                var params = {};
                var parentLen = node.parents.length;
                var con = treeConfig[parentLen];
                if (con == undefined) {
                  con = me._getFiledContent(parentLen, treeConfig);
                }
                params.field = con.name;
                params.moduleId = data.moduleId;
                var sort = con.sortWay;
                if (!sort) {
                  sort = 'asc';
                }
                if (me.extTableParams) {
                  params = _.assign(params, me.extTableParams);
                }
                params.orderBy = (con.sortName ? con.sortName : con.name) + ' ' + sort;
                params.levelCur = parentLen + 1;
                params.levelCount = treeConfig.length;
                params.blank = con.blank ? con.blank : '';

                if (me.applicationId) {
                  params.applicationId = me.applicationId;
                }

                if (data.condition)
                params.customCondition = data.condition;

                if (me.extCustomCondition)
                params.extCustomCondition = me.extCustomCondition;

                if (me.unitFilter) {
                  if (me.curSelUnitId) {
                    params.unitFilter = me.curSelUnitId;
                  }
                }
                if (me.deptFilter) {
                  if (me.curSelDeptId) {
                    params.deptFilter = me.curSelDeptId;
                  }
                }
                params.readerAuthorize = table.auth;
                me._addParams(params, node, tree, treeConfig);
                me.$emit("beforeTreeLoad", params, node, tree, treeConfig);
                return params;
              };
              config.changed = function (v, tree) {
                var params = {};
                if (me.extTableParams)
                params = _.assign(params, me.extTableParams);
                var node = tree.getNode(v.id);
                me._addTableParams(params, node, tree, treeConfig);
                var toolbarTable = me.mwRef('toolbarTable');
                if (!me.treeNodeFields || me.treeNodeFields.length === 0) {
                  if (!me.treeNodeFields) me.treeNodeFields = [];
                  for (var k in params) {
                    me.treeNodeFields.push(k);
                  }
                  toolbarTable.treeNodeFields = me.treeNodeFields;
                }
                toolbarTable.isSearch = false;

                if (toolbarTable.mwRef('dataTable')) {
                  var defaultParams = toolbarTable.mwRef('dataTable').defaultParams;
                  var newDefaultParams = (0, _assign2.default)({}, defaultParams, { condition: params });
                  me.$emit("treeSelectionChange", newDefaultParams, node);
                  if (newDefaultParams.returnFalse) {
                    return;
                  }
                  toolbarTable.allowLoaded = true;
                  toolbarTable.refreshTableDefaultParams(newDefaultParams);
                }
              };
              return config;
            },

            _getFiledContent: function _getFiledContent(parentLen, treeConfig) {
              parentLen = parentLen - 1;
              if (parentLen == -1) {
                return;
              }
              if (treeConfig[parentLen] != null) {
                return treeConfig[parentLen];
              } else {
                return this._getFiledContent(parentLen, treeConfig);
              }
            },

            _addTableParams: function _addTableParams(params, node, tree, treeConfig) {
              var parentLen = node.parents.length;
              if (node.parent) {
                var con = treeConfig[parentLen - 1];
                if (con) {
                  var param = _.trim(con.tableParamName);
                  var field = _.trim(con.tableParamField);
                  if (con.blank) {
                    if (con.blank == node.text) {
                      if (param.length == 0) {
                        params[con.name] = 'valueIsNull';
                      } else {
                        params[param] = 'valueIsNull';
                      }
                    } else {
                      if (param.length == 0) {
                        params[con.name] = node.text;
                      } else {
                        if (field.length == 0)
                        params[param] = node.original[param];else

                        params[param] = node.original[field];
                      }
                    }
                  } else {
                    if (param.length == 0) {
                      params[con.name] = node.text;
                    } else {
                      if (field.length == 0)
                      params[param] = node.original[param];else

                      params[param] = node.original[field];
                    }
                  }
                  this._addTableParams(params, tree.getNode(node.parent), tree, treeConfig);
                } else {
                  this._getConName(params, node, tree, parentLen, treeConfig);
                }
              }
            },
            _getConName: function _getConName(params, node, tree, length, treeConfig) {
              var con = treeConfig[length - 1];
              if (con) {
                var name = con.name;
                var param = _.trim(con.tableParamName);
                var field = _.trim(con.tableParamField);
                if (param.length == 0) {
                  params[name] = node.original[name];
                } else {
                  if (field.length == 0)
                  params[param] = node.original[param];else

                  params[param] = node.original[field];
                }
              } else {
                length = length - 1;
                if (length < 0) {
                  return;
                }
                if (treeConfig.length > 1) {
                  this._getConName(params, tree.getNode(node.parent), tree, length, treeConfig);
                } else {
                  this._getConName(params, node, tree, length, treeConfig);
                }
              }
            },
            _addParams: function _addParams(params, node, tree, treeConfig, pnode) {
              var parentLen = node.parents.length;
              if (node.parent) {
                var con = treeConfig[parentLen - 1];
                if (!con) {
                  this._addParams(params, tree.getNode(node.parent), tree, treeConfig, pnode || node);
                  return;
                }
                var param = _.trim(con.treeParamName);
                var field = _.trim(con.treeParamField);
                var vNode = pnode || node;
                if (con.blank) {
                  if (con.blank == vNode.text) {
                    if (param.length == 0) {
                      params['&' + con.name] = 'valueIsNull';
                    } else {
                      params['&' + param] = 'valueIsNull';
                    }
                    this._addParams(params, tree.getNode(node.parent), tree, treeConfig);
                  } else {
                    if (param.length == 0) {
                      params['&' + con.name] = vNode.text;
                      this._addParams(params, tree.getNode(node.parent), tree, treeConfig);
                    } else {
                      if (treeConfig.length == 1) {
                        if (field.length == 0)
                        params[param] = vNode.original[param];else

                        params[param] = vNode.original[field];
                      } else {
                        if (field.length == 0)
                        params['&' + param] = vNode.original[param];else

                        params['&' + param] = vNode.original[field];
                        this._addParams(params, tree.getNode(node.parent), tree, treeConfig);
                      }
                    }
                  }
                } else {
                  if (param.length == 0) {
                    params['&' + con.name] = vNode.text;
                    this._addParams(params, tree.getNode(node.parent), tree, treeConfig);
                  } else {
                    if (treeConfig.length == 1) {
                      if (field.length == 0)
                      params[param] = vNode.original[param];else

                      params[param] = vNode.original[field];
                    } else {
                      if (field.length == 0)
                      params['&' + param] = vNode.original[param];else

                      params['&' + param] = vNode.original[field];
                      this._addParams(params, tree.getNode(node.parent), tree, treeConfig);
                    }
                  }
                }
              }
            },
            _openAll: function _openAll() {
              this.mwRef('toolbarTable').mwRef('tree').openAll();
            },
            _closeAll: function _closeAll() {
              this.mwRef('toolbarTable').mwRef('tree').closeAll();
            },
            _AddFormData: function _AddFormData() {

              var me = this;
              var p = {};
              p.moduleId = me.mixId;
              p.size = 'large_large';
              p.appId = '';
              p.editMode = true;
              p.type = 'normal';
              if (me.formValue)
              p.initValue = me.formValue;

              var extParams = {
                "$view": me };

              if (me.unitFilter) {
                if (me.curSelUnitId) {
                  extParams.unitFilter = me.curSelUnitId;
                }
              }
              if (me.deptFilter) {
                if (me.curSelDeptId) {
                  extParams.deptFilter = me.curSelDeptId;
                }
              }

              p.extParams = extParams;

              PF.show('normalForm', p, function () {
                me.refresh();
              }, function (updateData) {
                if (updateData) {
                  me.refresh();
                }
              });
            },
            _changeFormVersion: function _changeFormVersion(a, b, c) {
              if (a.length == 0) {
                b.mwMsg('warning', $lang('请选择需要切换的记录'));
                return;
              }
              var ids = [];
              a.forEach(function (t) {
                ids.push(t.id);
              });

              PF.show('changeFormVersion', { moduleId: this.mixId, ids: ids });
            },
            _deleteFormData: function _deleteFormData(a, b, c) {
              var me = this;
              if (a.length == 0) {
                b.mwMsg('warning', $lang('请选择需要删除的记录'));
                return;
              }
              var businessIds = [];
              a.forEach(function (t) {
                businessIds.push(t.id);
              });
              b.mwConfirm($lang('此操作执行之后将无法恢复，请谨慎操作！您确定彻底删除选中的记录吗？'), $lang('提示'), {
                type: 'warning' }).
              then(function () {
                var params = {};
                params.idList = businessIds;
                params.formId = me.formId;
                params.moduleId = me.moduleId;
                b.mwApi.data.deleteFormData(params).then(function (res) {
                  if (res.success) {
                    b.refreshTable();
                  }
                });
              }).catch(function () {

              });
            },

            _markDeleteFormData: function _markDeleteFormData(a, b, c) {
              var me = this;
              if (a.length == 0) {
                b.mwMsg('info', $lang('请选择需要标记删除的记录'));
                return;
              }
              var businessIds = [];
              a.forEach(function (t) {
                businessIds.push(t.id);
              });
              b.mwConfirm($lang('您确定标记删除选中的记录吗？'), $lang('提示'), {
                type: 'warning' }).
              then(function () {
                var params = {};
                params.idList = businessIds;
                params.formId = me.formId;
                params.moduleId = me.moduleId;
                b.mwApi.data.markDeleteFormData(params).then(function (res) {
                  if (res.success) {
                    b.refreshTable();
                  }
                });
              }).catch(function () {
              });
            },
            _markDeleteFormDataReleaseWH: function _markDeleteFormDataReleaseWH(a, b) {
              var me = this;
              if (a.length == 0) {
                b.mwMsg('info', $lang('请选择需要标记删除的记录'));
                return;
              }
              var businessIds = [];
              a.forEach(function (t) {
                businessIds.push(t.id);
              });
              b.mwConfirm($lang('您确定标记删除选中的记录吗？'), $lang('提示'), {
                type: 'warning' }).
              then(function () {
                var params = {};
                params.idList = businessIds;
                params.formId = me.formId;
                params.moduleId = me.moduleId;
                b.mwApi.data.markDeleteFormDataReleaseWH(params).then(function (res) {
                  if (res.success) {
                    b.refreshTable();
                  }
                });
              }).catch(function () {
              });
            },

            _restoreDeletedFormData: function _restoreDeletedFormData(a, b, c) {
              var me = this;
              if (a.length == 0) {
                b.mwMsg('info', $lang('请选择需要还原的记录'));
                return;
              }
              var businessIds = [];
              a.forEach(function (t) {
                businessIds.push(t.id);
              });
              b.mwConfirm($lang('您确定还原选中的记录吗？'), $lang('提示'), {
                type: 'warning' }).
              then(function () {
                var params = {};
                params.idList = businessIds;
                params.formId = me.formId;
                params.moduleId = me.moduleId;
                b.mwApi.data.restoreDeletedFormData(params).then(function (res) {
                  if (res.success) {
                    b.refreshTable();
                  }
                });
              }).catch(function () {

              });
            },
            _showForm: function _showForm(row, event) {
              event.stopPropagation();
              var me = this;
              var p = {};
              p.businessId = row.id;
              p.moduleId = me.mixId;
              if (row.initbatchid) {
                p.batchId = row.initbatchid;
              } else {
                p.batchId = row.id;
              }
              p.processDefinitionId = row.initprocdefid;
              p.size = 'large_large';
              p.type = 'normal';
              p.editMode = me.openFormEditMode || false;
              p.appId = '';
              var extParams = {
                "$view": me };

              if (me.unitFilter) {
                if (me.curSelUnitId) {
                  extParams.unitFilter = me.curSelUnitId;
                }
              }
              if (me.deptFilter) {
                if (me.curSelDeptId) {
                  extParams.deptFilter = me.curSelDeptId;
                }
              }

              p.extParams = extParams;
              if ($.isFunction(me.beforeOpenFormFn)) {
                me.beforeOpenFormFn(p);
              }
              PF.show('normalForm', p, function () {
                me.refresh();
              }, function (updateData) {
                if (updateData) {
                  me.refresh();
                }
              });
            } } });


      });


    } } };

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);




var _vue = __webpack_require__(11);var _vue2 = _interopRequireDefault(_vue);
var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  name: "MwFormView",
  props: {
    readOnly: {
      type: Boolean,
      default: false },

    taskId: {
      type: String,
      default: "" },

    appId: {
      type: String,
      default: "" },

    businessId: {
      type: String,
      default: "" },

    draftsDocId: {
      type: String,
      default: "" },

    extParams: {
      type: Object,
      default: function _default() {return {};} },

    flowKey: {
      type: String,
      default: "" },

    formKey: {
      type: String,
      default: "" },

    moduleId: {
      type: String,
      default: "" },

    formVersion: {
      type: String,
      default: "" },

    tempBusinessId: {
      type: String,
      default: "" },


    value: {
      type: Object,
      default: function _default() {return {};} },


    formOpenSource: {
      type: String,
      default: "PcWebsite" },

    dirty: {
      type: Boolean,
      default: false } },



  data: function data() {
    return {
      taskData: {},
      activity: {},
      activityId: "",
      fieldMapping: {},
      formName: "",
      formId: "",
      processDefinitionId: "",
      processDefinitionName: "",
      formInst: null,

      extraFormField: {},
      authFields: undefined,
      type: "",

      commentFields: [],
      miniCommentFields: [],
      components: [],

      batchId: "",

      createTime: "",

      renderTimeout: null };

  },
  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)(["expUser", "userInfo", "initInfo"])),

  mounted: function mounted() {
    this.renderForm();
  },

  beforeDestroy: function beforeDestroy() {
    this.teardown();
  },

  watch: {
    businessId: function businessId() {
      clearTimeout(this.renderTimeout);
      this.renderTimeout = setTimeout(this.renderForm, 0);
    },
    appId: function appId() {
      clearTimeout(this.renderTimeout);
      this.renderTimeout = setTimeout(this.renderForm, 0);
    },
    moduleId: function moduleId() {
      clearTimeout(this.renderTimeout);
      this.renderTimeout = setTimeout(this.renderForm, 0);
    } },


  methods: {
    renderForm: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                if (this.moduleId) {
                  this.beforeInstallFormView();
                }case 1:case "end":return _context.stop();}}}, _callee, this);}));function renderForm() {return _ref.apply(this, arguments);}return renderForm;}(),

    beforeInstallFormView: function () {var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {var _mwApi$config$moduleC,_this = this;var _ref3, result;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (
                  this.mwApi.config.moduleConfig((_mwApi$config$moduleC = {
                    dataId: this.businessId ?
                    this.businessId :
                    this.tempBusinessId ? "_" +
                    this.tempBusinessId :
                    "",
                    taskId: this.taskId,
                    processDefinitionId: this.taskId ? this.processDefinitionId : "",
                    activityId: this.taskId ? this.activityId : "" }, (0, _defineProperty3.default)(_mwApi$config$moduleC, "processDefinitionId",
                  this.flowKey), (0, _defineProperty3.default)(_mwApi$config$moduleC, "flowFlag",
                  false), (0, _defineProperty3.default)(_mwApi$config$moduleC, "forceModuleForm",
                  false), (0, _defineProperty3.default)(_mwApi$config$moduleC, "moduleId",
                  this.moduleId), (0, _defineProperty3.default)(_mwApi$config$moduleC, "appId",
                  this.appId), (0, _defineProperty3.default)(_mwApi$config$moduleC, "draftsDocId",
                  this.draftsDocId), _mwApi$config$moduleC)));case 2:_ref3 = _context2.sent;result = _ref3.result;

                this.$emit("update:appId", result.appId);
                this.$emit("update:formId", result.formId);
                this.$emit("update:formVersion", result.formVersion);
                this.$emit("update:formKey", result.formKey);
                this.formName = result.name;
                this.$emit("update:type", result.type);
                this.$emit("update:value", result.formData);
                this._originalFormData = result.formData;
                this.createTime = result.createTime;
                this.authFields = result.authFields;
                this.formId = result.formId;
                this.formKey = result.formKey;
                if (result.attr && result.attr.fieldMapping) {
                  this.fieldMapping = result.attr.fieldMapping;
                }
                if (result.draftsDocId !== undefined) {
                  this.$emit("update:businessId", result.draftsDocId);
                }
                if (result.tempDraftsDocId !== undefined) {
                  this.$emit("update:tempBusinessId", result.tempDraftsDocId);
                }
                this.$nextTick(function () {
                  _this.installFormView(result.content);
                });case 20:case "end":return _context2.stop();}}}, _callee2, this);}));function beforeInstallFormView() {return _ref2.apply(this, arguments);}return beforeInstallFormView;}(),

    installFormView: function installFormView(dd) {var _this2 = this;
      var me = this;
      if (this.formInst) this.teardown();
      $WR.ready(function (manager) {
        _this2.$emit("getTitle", dd.name || dd.title);

        manager.create(
        {
          xtype: "Form",
          constantValues: _this2.getConstantValues(),
          resolvers: _this2.getResolvers(),
          $dd: (0, _extends3.default)({},
          dd, {
            hideHead: true,
            textMode: _this2.readOnly }),

          $cc: _this2.authFields,
          user: _this2.expUser,
          values: _this2.getFormValues() },

        function (formInst) {
          _this2.formInst = formInst;
          formInst.on("afterRender", function () {
            if (_this2.businessId) {
              if (_this2.type === "module_flow") {

              }
            }
            _this2.handleFields();
          });
          var mark = me.activity && me.activity.mark ? me.activity.mark : "";
          var marks = mark ? mark.split(",") : [];
          var rootCtx = {
            "$userName": PF.userInfo.name,
            "$loginId": PF.userInfo.loginId,
            "$roleNames": PF.userInfo.roleNames,
            "$deptIdChain": PF.userInfo.deptIdChain,
            '$allIdentityRoleNames': PF.userInfo.allIdentityRoleNames,
            "$ext": {},
            '$flowMarks': marks };

          formInst.setExpressionContext(null, {}, true);
          formInst.setExpressionContext(null, rootCtx);
          me.$commentMinComponent = [];
          me.$newForm = formInst;
          formInst.on("manualChange", function () {
            _this2.$emit("update:dirty", true);
            _this2.$emit("dirty");
          });

          _this2.formInst.getExtForm = function () {
            return {
              formData: (0, _extends3.default)({
                id: _this2.businessId },
              _this2.formData()),

              action: "",
              taskId: _this2.taskId,
              appId: _this2.appId,
              businessId: _this2.businessId,
              formId: _this2.formId,
              taskdata: _this2.taskData,
              extParams: _this2.extParams,
              flowKey: _this2.flowKey,
              formVersion: _this2.formVersion,
              activity: _this2.activity,
              draftsDocId: _this2.draftsDocId,
              batchId: _this2.batchId,
              tempBusinessId: _this2.tempBusinessId,
              fieldMapping: _this2.fieldMapping,
              formName: _this2.formName,
              processDefinitionId: _this2.processDefinitionId,
              processDefinitionName: _this2.processDefinitionName,
              comment: [],
              startProcess: function startProcess() {},
              formActionComplete: function formActionComplete() {},
              refreshComment: _this2.refreshComment,
              setBtnLoading: function setBtnLoading() {},
              btnDebounce: function btnDebounce() {},
              formOpenSource: _this2.formOpenSource };

          };
          _this2.formInst.__originalExtForm = _this2;
          _this2.$emit("beforeRender", formInst);
          formInst.render(_this2.$refs.mountPoint);
        });

      });
    },
    getConstantValues: function getConstantValues() {
      return {
        taskId: this.taskId,
        appId: this.appId,
        businessId: this.businessId,
        draftsDocId: this.draftsDocId,
        taskData: this.taskData,
        extParams: this.extParams,
        flowKey: this.flowKey,
        moduleId: this.moduleId,
        formId: this.formId,
        formKey: this.formKey,
        formVersion: this.formVersion,
        activity: this.activity,
        tempBusinessId: this.tempBusinessId,
        fieldMapping: this.fieldMapping,
        formName: this.formName,
        processDefinitionId: this.processDefinitionId,
        processDefinitionName: this.processDefinitionName };

    },
    getResolvers: function getResolvers() {
      return {
        fnDataResolver: this.fnDataResolver(),
        fnDataItemResolver: this.fnDataItemResolver(),
        fnImbeddedObjResolver: this.fnImbeddedObjResolver() };

    },

    getFormValues: function getFormValues() {
      return this.value;
    },
    fnImbeddedObjResolver: function fnImbeddedObjResolver() {var _this4 = this;
      var me = this;
      return function (objId) {
        return new function (formField) {
          var value = [];
          var component;
          var $data;
          var $obj;
          PF.apply(this, {
            init: function init(d, obj) {
              $data = d;
              $obj = obj;
            },
            mount: function mount(fnMount) {
              var html;
              var config = (0, _assign2.default)({
                expUser: me.expUser,
                getForm: function getForm() {
                  if (!me.formInst.taskData) me.formInst.taskData = {};
                  if (!me.formInst.__originalExtForm._originalFormData) {
                    me.formInst.__originalExtForm._originalFormData = me._originalFormData;
                  }
                  return me.formInst;
                },
                getCurrentObject: function getCurrentObject() {
                  return $obj;
                },
                $previewMode: false,
                getFormValue: function getFormValue() {
                  return me.formData();
                },
                getConfig: function getConfig() {
                  return $data;
                },
                getData: function getData() {
                  return {
                    businessId: me.businessId,
                    tempBusinessId: me.tempBusinessId,
                    formKey: me.formKey,
                    formId: me.formId,
                    formVersion: me.formVersion };

                },
                getFormObject: function getFormObject() {
                  return me;
                } });


              switch (objId) {
                case 'attachment-list':{
                    component = new (_vue2.default.component('form-attachment-list'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'attachment-list-min':{
                    component = new (_vue2.default.component('form-attachment-list-min'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'document-editor':{
                    component = new (_vue2.default.component('form-document-editor'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'zw-attachment-list':{
                    component = new (_vue2.default.component('form-zw-attachment-list'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'comment-list':{
                    component = new (_vue2.default.component('form-comment-list'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'comment-list-min':{
                    component = new (_vue2.default.component('form-comment-list-min'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'imbedded-view':{
                    component = new (_vue2.default.component('form-imbedded-view'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                case 'rel-file-selection':{
                    component = new (_vue2.default.component('form-rel-file-selection'))({ params: me._data, config: config });
                    fnMount(component.$mount().$el);
                    break;
                  }
                default:{
                    if ($data.pageType === "page") {
                      component = PF.createVue({
                        template: "<mw-inner-page :pageId='pageId' noWrap :params='params'></mw-inner-page>",
                        data: {
                          pageId: objId,
                          params: { data: me._data, config: config } } });


                      fnMount(component.$mount().$el);
                    } else if ($data.pageType === "pageData" && $obj.getPageData) {
                      var pageData = $obj.getPageData();
                      pageData.params = { data: me._data, config: config };
                      component = PF.createVue(pageData);
                      fnMount(component.$mount().$el);
                    }
                  }}

              if (html) {
                fnMount($('<div>' + html + '</div>'));
              }
              return component;
            },
            onEvent: function onEvent(args) {var _this3 = this;
              if (component) {
                if (component.dealWithEvent) {
                  component.dealWithEvent(args);
                }
              } else {
                if (args.dd.viewId && args.data.id) {
                  me.mwApi.app.getApplicationItems([args.dd.viewId], "").then(function (res) {
                    var mixId = res.result[0].content.table.moduleId;
                    if (mixId) {
                      var _me = _this3;
                      var p = {};
                      p.businessId = args.data.id;
                      p.moduleId = mixId;
                      p.size = 'large_large';
                      p.type = 'normal';
                      p.editMode = _me.editMode;
                      p.appId = '';
                      PF.show('normalForm', p, function () {
                      });
                    }
                  });

                }
              }
            },
            setValue: function setValue(value) {

            },
            getValue: function getValue() {

            },
            setReadOnly: function setReadOnly() {
            },
            destroy: function destroy() {
              if (component)
              component.$destroy();
            },
            show: function show(ops) {

              var config = (0, _assign2.default)({
                expUser: me.expUser,
                getForm: function getForm() {
                  return me.$newForm;
                },
                getCurrentObject: function getCurrentObject() {
                  return $obj;
                },
                $previewMode: false,
                getFormValue: function getFormValue() {
                  return me.formData();
                }, getConfig: function getConfig() {
                  return $data;
                }, getData: function getData() {
                  return {
                    businessId: me.businessId,
                    tempBusinessId: me.tempBusinessId,
                    draftsDocId: me.draftsDocId,
                    formKey: me.formKey,
                    formId: me.formId,
                    formVersion: me.formVersion };

                }, getFormObject: function getFormObject() {
                  return me;
                } });


              switch (objId) {
                case 'department-selection':{

                    var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                    PF.show('orgSelect', { multiple: multiple, config: config, value: ops.getValue() }, function (data) {
                      ops.setValue(data);
                    });
                    break;
                  }
                case 'user-selection':{
                    var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                    PF.show('orgSelect', { multiple: multiple, config: config, value: ops.getValue() }, function (data) {
                      ops.setValue(data);
                    });
                    break;
                  }
                case 'department-user-selection':{

                    var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                    PF.show('orgSelect', { multiple: multiple, config: config, value: ops.getValue() }, function (data) {
                      ops.setValue(data);
                    });
                    break;
                  }
                case 'custom-selection':{
                    var multi = $data.multiSelection == undefined ? false : $data.multiSelection;
                    PF.show('viewSelect', { id: $data.viewId, config: config, multi: multi }, function (data) {
                      if (data) {
                        ops.setValue(data);
                      } else {
                        ops.setValue();
                      }
                    });
                    break;
                  }
                default:{
                    if ($data.pageType == "page") {
                      config.setExtraFormField = function (d) {
                        me.extraFormField = d;
                      };
                      config.$obj = $obj;
                      config.ops = ops;
                      var params = { config: config, modelId: me.moduleId };
                      PF.dialog("mw-inner-page", {
                        title: $data.pageTitle, width: $data.pageWidth, height: $data.pageHeight,
                        propsData: { pageId: objId, params: params } });

                    }
                  }}


            },
            hide: function hide(ops) {
              ops.setValue(value);
            } });

        }(_this4);
      };
    },
    fnDataItemResolver: function fnDataItemResolver() {var _this5 = this;
      var me = this;
      return function () {var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(dict, params, setDataItems) {return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:
                  if ($.isFunction(params) && !setDataItems) {
                    setDataItems = params;
                    params = {};
                  }
                  me.mwApi.data.getDict(dict, params).then(function (data) {
                    if (data.result && data.result.value) {
                      var v = data.result.value.split(',');
                      var v1 = [];
                      var items = [];
                      v.forEach(function (d) {
                        v1 = d.split('|');
                        items.push({ text: v1[1], value: v1[0] });
                      });
                      setDataItems(items);
                    }
                  });case 2:case "end":return _context3.stop();}}}, _callee3, _this5);}));return function (_x, _x2, _x3) {return _ref4.apply(this, arguments);};}();

    },
    fnDataResolver: function fnDataResolver() {var _this6 = this;
      var me = this;
      return function () {var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(args) {var shouldGenerateFileNumber, getGenerateFileNumberParmas, beforeSetGeneratedFileNumber, setGeneratedFileNumber, updateRequestParams, afterGenerateFileNumber, formData, p;return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:
                  if ('org-sel-default-value' === args.dataId) {
                    me.mwApi.org.getCurrent(args.params).then(function (v) {
                      args.fnSetData(v);
                    });
                  }

                  if ('file-number-auto-generate' === args.dataId) {
                    shouldGenerateFileNumber = args.shouldGenerateFileNumber, getGenerateFileNumberParmas = args.getGenerateFileNumberParmas, beforeSetGeneratedFileNumber = args.beforeSetGeneratedFileNumber, setGeneratedFileNumber = args.setGeneratedFileNumber, updateRequestParams = args.updateRequestParams, afterGenerateFileNumber = args.afterGenerateFileNumber;

                    formData = me.formData();

                    if (shouldGenerateFileNumber(formData)) {
                      p = getGenerateFileNumberParmas(formData);
                      me.mwApi.oasrv.generateAutoDocNumber(p).then(function (res) {
                        if (res.success && res.result) {
                          me.extraFormField = beforeSetGeneratedFileNumber(res.result);
                          setGeneratedFileNumber(res.result);
                          updateRequestParams(function (params) {
                            me.mwLodash.assign(params.$form, me.formData());
                          });
                        }
                      }).then(afterGenerateFileNumber, afterGenerateFileNumber);
                    } else {
                      afterGenerateFileNumber();
                    }
                  }case 2:case "end":return _context4.stop();}}}, _callee4, _this6);}));return function (_x4) {return _ref5.apply(this, arguments);};}();

    },
    handleCommentFields: function () {var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {var cTaskNames, cCategories, category, taskName, _ref7, result;return _regenerator2.default.wrap(function _callee5$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:
                cTaskNames = [];
                cCategories = [];
                this.miniCommentFields.forEach(function (com) {
                  var commentConfig = com.$options.config.getConfig();
                  if (commentConfig.typeMark === "2") {
                    cTaskNames.push(commentConfig.activityName);
                  } else {
                    cCategories.push(commentConfig.activityName);
                  }
                });

                category = cCategories.join(",");
                taskName = cTaskNames.join(",");_context5.next = 7;return (

                  this.mwApi.business.queryCommentProcess({
                    businessId: this.businessId,
                    batchId: this.batchId,
                    processDefinitionId: this.processDefinitionId,
                    category: category,
                    taskName: taskName }));case 7:_ref7 = _context5.sent;result = _ref7.result;

                if (result) {
                  this.miniCommentFields.forEach(function (com) {
                    com.renderData(result);
                  });
                }case 10:case "end":return _context5.stop();}}}, _callee5, this);}));function handleCommentFields() {return _ref6.apply(this, arguments);}return handleCommentFields;}(),


    refreshComment: function refreshComment() {
      this.refreshcommentComponent();
    },

    refreshcommentComponent: function refreshcommentComponent() {
      this.commentFields.forEach(function (com) {
        com.refreshComment();
      });
    },

    formData: function formData() {
      return (0, _extends3.default)({},
      this.formInst && this.formInst.getValue() || {},
      this.extraFormField);

    },
    recoverSelection: function recoverSelection() {
      var doc = document;

      var input = doc.createElement("input");
      input.setAttribute(
      "style",
      "width:0;height:0;outline:0;border:0;padding:0;margin:0;position:absolute;top:0;left:0;z-index:0");

      doc.body.appendChild(input);
      input.click();
      input.focus();
      input.select();
      doc.body.removeChild(input);
    },

    teardown: function teardown() {
      if (this.formInst) {
        try {
          this.formInst.destroy();
        } finally {
          this.recoverSelection();
        }
      }
    },

    handleFields: function handleFields() {
      var queue = [this.formInst];
      while (queue.length) {
        var item = queue.shift();

        if (item) {
          if (item.items) {
            for (var i = 0; i < item.items.length; i++) {
              queue.push(item.items.item(i));
            }
          }

          this.$emit('handleField', item);
        }
      }
    } } };

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);


























































































































































var _template = __webpack_require__(954);var _template2 = _interopRequireDefault(_template);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  components: { MwTemplate: _template2.default },
  name: 'ToolbarTable',
  props: {
    layout: Array,

    autoLoad: {
      type: Boolean,
      default: true },

    toolbarTitle: {
      type: String },

    showToolbar: {
      type: Boolean,
      default: true },

    showTreeToolbar: {
      type: Boolean,
      default: true },

    pagination: {
      type: Boolean,
      default: true },

    noPaginationLimit: {
      type: Number },

    defaultPercent: {
      type: Number,
      default: 0 },

    border: {
      type: Boolean,
      default: true },

    showHeader: {
      type: Boolean,
      default: true },

    menuItemWidth: {
      type: Number,
      default: 300 },

    toolbarTitleWidth: {
      type: Number,
      default: 120 },

    applicationId: {
      type: String },

    unitFilter: {
      type: Boolean,
      default: false },

    deptFilter: {
      type: Boolean,
      default: false },

    treeExpandFirst: {
      type: Boolean,
      default: true } },


  data: function data() {
    return {
      propAutoLoad: this.autoLoad,
      propToolbarTitle: this.toolbarTitle,
      propPagination: this.pagination,
      selectNodeId: '',
      propNoPaginationLimit: this.noPaginationLimit,
      propDefaultPercent: this.defaultPercent,
      propShowToolbar: this.showToolbar,
      propShowTreeToolbar: this.showTreeToolbar,
      propBorder: this.border,
      propShowHeader: this.showHeader,
      propMenuItemWidth: this.menuItemWidth,
      propToolbarTitleWidth: this.toolbarTitleWidth,
      propTreeExpandFirst: this.treeExpandFirst,

      propUnitFilter: this.unitFilter,
      propDeptFilter: this.deptFilter,
      allowLoaded: true,

      readerAuthorize: '',

      customCondition: undefined,
      extCustomCondition: undefined,
      expanderDataType: undefined,
      showRowExpander: false,
      treeToolbarItem: [],
      treeConfig: undefined,
      toolbarItem: [],

      filters: {},

      layoutGroup: {},
      layoutGroupItem: [],
      isCommonSearch: false,
      menuItems: [],
      currentMenu: {},
      defaultKey: '',
      currentKey: '',
      defaultSort: [],

      searchFields: {},
      compType: 'view',
      pageCompId: '',
      columns: [],
      nowrap: true,
      defaultParams: {},
      singleSelect: false,
      morePath: '',
      moreFn: '',
      api: '',
      dataList: [],
      sumData: {},
      btnSumData: {},
      menuSumApi: '',
      menuSumParams: {},
      btnSumApi: {},
      treeFlag: false,
      treeNodeFields: [],
      searchCurNode: false,
      searchKey: '',
      isSearch: false,
      beforeSearchParams: {},
      checkCallback: function checkCallback(operation, node, node_parent, node_position, more) {
        var result = {};
        this.$emit("checkCallback", operation, node, node_parent, node_position, more, result);
        return result.ret === false ? false : true;
      },
      defaultParamsChange: false };

  },

  mounted: function mounted() {
    if (this.layout.length > 0) {
      this._loadLayout();
      this._setTableConfig(this.defaultKey);
    }
  },
  watch: {
    toolbarTitle: function toolbarTitle(v) {
      this.propToolbarTitle = v;
    },
    layout: function layout() {
      this._loadLayout();
      this._setTableConfig(this.defaultKey);
    } },

  methods: {
    rowExpanded: function rowExpanded(row, container) {
      this.$emit("rowExpanded", row, container);
    },
    rowStyle: function rowStyle(row, index, ret) {
      this.$emit("rowStyle", row, index, ret);
    },
    rendered: function rendered(dataList, el) {
      this.$emit("rendered", dataList, el);
    },
    dataLoaded: function dataLoaded(dataList, totalSize) {
      this.$emit("dataLoaded", dataList, totalSize);
    },
    treeToolbarBtnClick: function treeToolbarBtnClick($scope, func, item) {
      var me = this;
      if (item.action && item.dealwithWay == "1") {
        PF.action[item.action].call(me, me.mwRef('tree').getSelected(), me.currentKey);
      } else {
        if ($scope)
        func.call($scope, me.mwRef('tree').getSelected(), me._getMe(), me.currentKey);else

        func(me.mwRef('tree').getSelected(), me._getMe(), me.currentKey);
      }
    },
    toolbarBtnClick: function toolbarBtnClick($scope, func, item, $event) {
      var me = this;
      var selDatas = [];
      var dataTable = me.mwRef('dataTable');
      if (dataTable) {
        selDatas = dataTable.getMultipleSelection();
      }
      if (item.action && item.dealwithWay == "1") {
        PF.action[item.action].call(me, selDatas, me.currentKey, $event);
      } else {
        if ($scope)
        func.call($scope, selDatas, me._getMe(), me.currentKey, $event);else

        func(selDatas, me._getMe(), me.currentKey, $event);
      }
    },
    toggleRowSelection: function toggleRowSelection(row, selected) {
      this.mwRef('dataTable').toggleRowSelection(row, selected);
    },
    refreshTableDataList: function refreshTableDataList(dataList, callback) {
      this.mwRef("dataTable").setData(dataList, callback);
    },

    refreshTable: function refreshTable() {
      var me = this;
      if (this.treeFlag) {
        var treeObj = this.mwRef("tree");
        var dataList = me.mwRef("dataTable").dataList;
        if (dataList)
        dataList.splice(0, dataList.length);
        treeObj.refresh();
      } else {
        me.mwRef("dataTable").refresh();
      }
    },
    searchText: function searchText() {var _this = this;
      var me = this;
      me.isCommonSearch = true;
      if (!me.filters[me.searchKey]) {
        if (!$.isEmptyObject(me.beforeSearchParams)) {
          for (var k in me.beforeSearchParams) {
            me.defaultParams.condition[k] = me.beforeSearchParams[k];
          }
        }
        me.isSearch = false;
      } else {
        me.isSearch = true;
        if (me.searchCurNode === false && me.treeNodeFields.length > 0) {
          $.each(me.treeNodeFields, function (i, f) {
            me.beforeSearchParams[f] = me.defaultParams.condition[f];
            delete me.defaultParams.condition[f];
          });
        }
      }
      var searchCon = {};
      var keys = _.keys(this.filters);
      keys.forEach(function (v) {
        var k = v.split("|");
        if (k.length > 0) {
          k.forEach(function (v1) {
            searchCon[v1] = _this.filters[v];
          });
        } else {
          searchCon[k] = _this.filters[v];
        }
      });
      this.$emit("doSearchText", searchCon);
      if (searchCon.returnFalse === false) return;
      this.mwRef("dataTable").search(searchCon);
    },
    refreshMenuSum: function refreshMenuSum() {
      var me = this;
      var para = me.menuSumParams;
      if (!me.menuSumApi.startsWith("/")) {
        if (me.menuSumApi.startsWith("#")) {
          eval("PF.invokeInner('" + me.menuSumApi.substring(1) + "',para)").then(function (data)
          {
            var d = data.result;
            me.$emit("setViewSum", d, me.layout);
            for (var key in me.sumData) {
              if (me.sumData[key] != undefined) {
                if (d[key] == 0) {
                  me.sumData[key] = '';
                } else {
                  me.sumData[key] = d[key];
                }
              }
            }
          });
        } else {
          eval('this.mwApi.' + me.menuSumApi + '(para)').then(function (data)
          {
            var d = data.result;
            me.$emit("setViewSum", d, me.layout);
            for (var key in me.sumData) {
              if (me.sumData[key] != undefined) {
                if (d[key] == 0) {
                  me.sumData[key] = '';
                } else {
                  me.sumData[key] = d[key];
                }
              }
            }
          });
        }
      } else {

        eval("PF.invoke('" + me.menuSumApi.substring(1) + "',para)").then(function (data)
        {
          var d = data.result;
          me.$emit("setViewSum", d, me.layout);
          for (var key in me.sumData) {
            if (me.sumData[key] != undefined) {
              if (d[key] == 0) {
                me.sumData[key] = '';
              } else {
                me.sumData[key] = d[key];
              }
            }
          }
        });
      }
    },
    refreshBtnSum: function refreshBtnSum(sumKey, key) {
      var me = this,para = {};
      var qp = me.btnSumApi[sumKey + "___sumDefaultParams"];
      if (qp && _.isObject(qp)) {
        para = qp;
      }
      if (key) {
        para.key = key;
      } else {
        me.currentKey;
      }
      if (!me.btnSumApi[sumKey].startsWith("/")) {
        if (me.btnSumApi[sumKey].startsWith("#")) {
          eval("PF.invokeInner('" + me.btnSumApi[sumKey].substring(1) + "',para)").then(function (data)
          {
            var d = data.result;
            if (d == 0) {
              me.btnSumData[sumKey] = "";
            } else {
              me.btnSumData[sumKey] = d;
            }
          });
        } else {
          eval('this.mwApi.' + me.btnSumApi[sumKey] + '(para)').then(function (data)
          {
            var d = data.result;
            if (d == 0) {
              me.btnSumData[sumKey] = "";
            } else {
              me.btnSumData[sumKey] = d;
            }
          });
        }
      } else {

        eval("PF.invoke('" + me.btnSumApi[sumKey].substring(1) + "',para)").then(function (data)
        {
          var d = data.result;
          if (d == 0) {
            me.btnSumData[sumKey] = "";
          } else {
            me.btnSumData[sumKey] = d;
          }
        });
      }
    },
    refreshTableDefaultParams: function refreshTableDefaultParams(params) {
      this.beforeSearchParams = {};
      this.defaultParamsChange = true;
      this.defaultParams = params;
    },
    _refreshTable: function _refreshTable() {
      this.mwRef("dataTable").refresh();
    },

    clearSelection: function clearSelection() {
      this.mwRef("dataTable").clearSelection();
    },

    clearFilters: function clearFilters() {var _this2 = this;
      var keys = this.mwLodash.keys(this.filters);
      keys.forEach(function (v) {
        _this2.$set(_this2.filters, v, '');
      });
    },
    _paramsChange: function _paramsChange(params) {
      this.clearFilters();
      if (this.defaultParamsChange) {
        this._refreshTable();
      } else {
        this.defaultParamsChange = false;
      }
    },
    getMultipleSelection: function getMultipleSelection() {
      return this.mwRef('dataTable').getMultipleSelection();
    },
    _getMe: function _getMe() {
      var me = this;
      return {
        mwMsg: me.mwMsg.bind(me),
        mwConfirm: me.mwConfirm.bind(me),
        mwApi: me.mwApi,
        mwUtil: me.mwUtil,
        mwConfig: me.mwConfig,
        refreshTable: me.refreshTable,
        refreshMenuSum: me.refreshMenuSum,
        refreshBtnSum: me.refreshBtnSum };

    },
    _loadLayout: function _loadLayout() {
      var me = this,defaultKey = '',menuItems = [];
      var layoutGroup = {};

      me.layout.forEach(function (item) {
        var key = '';
        item.forEach(function (it) {
          if (it.type == 'menu') {
            menuItems.push(it);
            key = it.key ? it.key : 'default';
            if (!defaultKey) {
              defaultKey = it.defaultActive ? key : '';
            }
          } else if (it.type == "searchText") {
            if (it.searchCurNode) {
              me.searchCurNode = true;
            }
            if (it.name) {
              me.searchKey = it.name;
            }
          }
        });
        layoutGroup[key] = item;
      });

      if (!defaultKey) {
        defaultKey = 'default';
      }
      me._setSumDataConfig(menuItems);
      me.layoutGroup = layoutGroup;
      me.menuItems = menuItems;

      me.defaultKey = defaultKey;
    },
    _setSumDataConfig: function _setSumDataConfig(menuItems) {
      var me = this;
      menuItems.forEach(function (item) {
        if (item.sumKey) {

          me.$set(me.sumData, item.sumKey, '');
        }
        if (item.sumApi) {
          me.menuSumApi = item.sumApi;
          if (item.sumParams) {
            me.menuSumParams = item.sumParams;
          }
        }
      });

    },
    transColumn: function transColumn(columns) {
      if (!columns) return [];
      return columns.map(function (col) {
        if (window.$lang) {
          var newCol = (0, _extends3.default)({}, col);
          newCol.label = $lang(col.label);
          return newCol;
        } else {
          return col;
        }
      });
    },
    _setTableConfig: function _setTableConfig(key) {
      var me = this;
      me.layoutGroupItem = me.layoutGroup[key];
      me.btnSumApi = {};
      me.btnSumData = {};
      me.searchFields = {};
      me.treeFlag = false;
      me.layoutGroupItem.forEach(function (item) {
        if (item.type == 'menu') {
          if (item.pagination != undefined) {
            me.propPagination = item.pagination;
            me.propNoPaginationLimit = item.noPaginationLimit;
          }
          if (item.toolbar != undefined) {
            me.propShowToolbar = item.toolbar;
          }
          if (me.compType == "page" && item.compType != "page") {

            me.$nextTick(function () {
              me._refreshTable();
            });
          }
          me.compType = item.compType || "view";
          me.pageCompId = item.pageCompId || "";
          if (item.defaultPercent != undefined && item.defaultPercent > 0) {
            me.allowLoaded = false;
            me.propDefaultPercent = item.defaultPercent;
            if (item.treeToolbarItem) {
              item.treeToolbarItem.forEach(function (it) {return it.label = $lang(it.label);});
              me.treeToolbarItem = item.treeToolbarItem;
            }

            if (item.treeConfig) {
              me.treeConfig = item.treeConfig;
            }
            if (item.toolbarItem)
            me.toolbarItem = item.toolbarItem;
            me.treeFlag = true;
          } else {
            me.propDefaultPercent = 0;
          }
        }
        if (item.type == 'button') {
          item.items.forEach(function (it) {
            it.label = $lang(it.label);
            if (it.sumKey && it.sumApi) {
              me.btnSumApi[it.sumKey] = it.sumApi;
              me.$set(me.btnSumData, it.sumKey, '');
              me.btnSumApi[it.sumKey + "___sumDefaultParams"] = it.sumParams;
              me.refreshBtnSum(it.sumKey, key, it.sumParams);
            }
          });
        }
        if (item.type == 'searchText') {
          if (item.name != '') {
            me.$set(me.filters, item.name ? item.name : 'title', '');
          }
        }
        if (item.type == 'searchBox') {
          item.fields.forEach(function (it) {
            if (it.type == 'date' || it.type == 'single') {
              me.searchFields[it.name] = '';
            }
          });
        }
      });
      me.menuItems.forEach(function (item) {
        if (item.key == key || me.menuItems.length == 1) {
          me.columns = me.transColumn(item.columns);
          me.nowrap = item.nowrap;
          if (item.defaultParams) {
            me.defaultParams = item.defaultParams;
          } else {
            me.defaultParams = {};
          }
          if (item.morePath) {
            me.morePath = item.morePath;
            me.moreFn = "";
          } else if (item.moreFn) {
            me.moreFn = item.moreFn;
            me.morePath = "";
          } else {
            me.morePath = '';
            me.moreFn = '';
          }

          if (item.defaultSort) {
            me.defaultSort = item.defaultSort;
          } else {
            me.defaultSort = [];
          }

          if (item.api)
          me.api = item.api;else

          me.dataList = item.dataList || [];




          me.propUnitFilter = item.unitFilter;





          me.propDeptFilter = item.deptFilter;

          me.readerAuthorize = item.readerAuthorize;
          me.customCondition = item.customCondition;
          me.extCustomCondition = item.extCustomCondition;


          me.showRowExpander = item.showRowExpander;
          me.singleSelect = item.singleSelect ? item.singleSelect : false;

          if (me.autoLoad && !me.treeFlag) {
            me.currentKey = key;
          }
          return;
        }
      });
      if (me.menuSumApi) {
        me.refreshMenuSum();
      }
      me.afterChangeTab(key);
    },
    _more: function _more() {
      var me = this;
      if (me.morePath) {
        me.$router.push({ path: me.morePath, query: { key: this.currentKey } });
      } else if (me.moreFn) {
        var fn = new Function("return " + me.moreFn)();
        fn.call(me.$parent, me);
      }
    },
    _wholeClick: function _wholeClick(filed) {
      var me = this;
    },

    getCurrentKey: function getCurrentKey() {
      return this.currentKey;
    },
    afterChangeTab: function afterChangeTab(key) {
      this.$emit("afterChangeTab", key);
    },
    sortableUpdate: function sortableUpdate(changes) {
      this.$emit("sortableUpdate", changes);
    },
    _handleSelect: function _handleSelect(key) {
      this._setTableConfig(key);
    } } };

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });





var _vue = __webpack_require__(11);var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var vue = void 0;exports.default =
{
  name: "mwTemplate",
  data: function data() {
    return {};


  },
  props: {
    value: {
      type: Object } },


  mounted: function mounted() {
    var me = this;
    var res = _vue2.default.compile('<el-button @click="test"></el-button>');
    vue = new _vue2.default({
      el: me.$el,
      data: {
        msg: 'hello',
        id: me.id },

      methods: {
        test: function test() {
        } },

      destroyed: function destroyed() {

      },
      render: res.render,
      staticRenderFns: res.staticRenderFns });

  },

  watch: {
    value: function value() {

    } },


  beforeDestroy: function beforeDestroy() {
    if (vue) {

    }
  } };

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =































{
  data: function data() {
    return {
      visible: false };

  },
  name: 'mwDialog',
  beforeDestroy: function beforeDestroy() {
    this.mwRef('dialog').$destroy();
  },
  props: {
    closeOnClickModal: {
      type: Boolean,
      default: false },

    closeOnPressEscape: {
      type: Boolean,
      default: false },

    size: {
      type: String },

    modal: {
      type: Boolean,
      default: true },

    title: {
      type: String },

    customClass: {
      type: String,
      default: '' },

    appendToBody: {
      type: Boolean,
      default: true },

    validateForm: {
      type: Array,
      default: function _default() {
        return [];
      } },

    beforeClose: Function,
    footerButton: {
      type: Array,
      default: function _default() {
        return [];
      } },

    width: String,
    height: String },

  watch: {
    'size': function size(val, oldVal) {

    },
    width: function width() {
      this.setWidthHeight();
    },
    height: function height() {
      this.setWidthHeight();
    } },

  methods: {
    invokeButtonMethod: function invokeButtonMethod(btn) {
      var fn = btn.func || btn.handler;
      if (fn) {
        fn.call(this);
      }
    },
    setWidthHeight: function setWidthHeight() {
      var el = $(this.$el).find(".el-dialog");
      if (this.width) {
        el.width(this.width);
      }
      if (this.height) {
        el.height(this.height);
        el.css("margin", "0 auto");
        var top = ($(window).height() - el.height()) / 2;
        if (top > 0) el.css("top", top);
      }
    },
    _beforeClose: function _beforeClose(done) {
      if (this.beforeClose) {
        this.beforeClose(done);
      } else {
        done();
      }
    },

    show: function show(callback) {
      this.visible = true;
      this.setWidthHeight();
      if (!this.eventInited) {
        this.initEvent();
        this.eventInited = true;
      }
      if (callback) {
        this.$nextTick(function () {
          callback();
        });
      }
    },
    initEvent: function initEvent() {

      $(this.$el).prepend($("<iframe width='100%' height='100%''></iframe>").css({
        width: '100%',
        height: '100%',
        border: '0px',
        position: "absolute" }));


      if (window.$ && $.fn.draggable) {
        var dlg = $(this.$refs.dialog.$refs.dialog);
        var oriTop = void 0;
        dlg.draggable({
          handle: ".el-dialog__header",
          scroll: false,
          stop: function stop(event, ui) {
            var el = ui.helper;
            var marginTop = parseInt(el.css("margin-top"));
            var top = parseInt(el.css("top"));
            if (top < -marginTop) {
              el.css("top", -marginTop + 'px');
            }
          } });

        var oldTop, oldLeft;
        dlg.find(".el-dialog__header").dblclick(function () {
          if (dlg.hasClass("is-fullscreen")) {
            if (oldTop) dlg.css("top", oldTop);
            if (oldLeft) dlg.css("left", oldLeft);
            dlg.removeClass("is-fullscreen");
          } else {
            oldTop = dlg.css("top");
            oldLeft = dlg.css("left");
            dlg.css({ top: "", left: "" });
            dlg.addClass("is-fullscreen");
          }
        });
      }

    },
    hide: function hide() {
      this.visible = false;
    },
    dialogOpen: function dialogOpen() {
      this.$emit("opened");
    } } };

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _class = function () {
  function _class() {(0, _classCallCheck3.default)(this, _class);
    this.listeners = {};
  }(0, _createClass3.default)(_class, [{ key: "on", value: function on(

    event, listener) {
      if (event in this.listeners) {
        this.listeners[event].push(listener);
      } else {
        this.listeners[event] = [listener];
      }
      return this;
    } }, { key: "emit", value: function emit(

    event) {
      if (event in this.listeners) {for (var _len = arguments.length, arg = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {arg[_key - 1] = arguments[_key];}
        for (var i = 0; i < this.listeners[event].length; i++) {var _listeners$event;
          (_listeners$event = this.listeners[event])[i].apply(_listeners$event, arg);
        }
        return true;
      }
      return false;
    } }]);return _class;}();exports.default = _class;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = {
  ELEMENT_NODE: 1,
  TEXT_NODE: 3,
  COMMENT_NODE: 8 };

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (el, handler) {
  var target = void 0,startx = void 0,starty = void 0;
  function handleMouseDown(e) {
    target = e.target;
    startx = e.clientX;
    starty = e.clientY;
  }

  function handleMouseMove(e) {
    if (Math.max(
    Math.abs(e.clientX - startx),
    Math.abs(e.clientY - starty)) >
    5)
    target = null;
  }

  function handleMouseUp(e) {
    if (target === e.target) {
      handler(e);
    }
  }

  el.addEventListener("mousedown", handleMouseDown, false);
  el.addEventListener("mousemove", handleMouseMove, false);
  el.addEventListener("mouseup", handleMouseUp, false);

  return function () {
    el.removeEventListener("mousedown", handleMouseDown, false);
    el.removeEventListener("mousemove", handleMouseMove, false);
    el.removeEventListener("mouseup", handleMouseUp, false);
  };
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =










{
  name: 'rightMenu',
  props: [
  'popItems', 'mouse', 'zIndex', 'width', 'height', 'border', 'padding',
  'boxShadow', 'background', 'borderRadius', 'color'],

  data: function data() {
    return {
      freeStyle: '',
      showPop: false };

  },
  watch: {
    mouse: function mouse() {
      var self = this;
      var x = self.mouse[0];
      var y = self.mouse[1];
      this.updateMenu(x, y);
    } },

  computed: {
    items: function items() {
      return this.popItems;
    } },

  created: function created() {

  },
  beforeDestroy: function beforeDestroy() {

  },
  methods: {
    listItemClick: function listItemClick(it, item) {
      var self = this;
      self.$emit('ListItemClick', it, item);
    },
    mouseDown: function mouseDown() {

    },
    close: function close() {
      this.showPop = false;
    },
    show: function show(x, y) {
      this.updateMenu(x, y);
    },
    updateMenu: function updateMenu(x, y) {
      var self = this;
      if (x === 'close') {
        self.showPop = false;
      } else
      {
        self.freeStyle = 'left:' + x + 'px; top:' + y + 'px;width:' + self.width + ';' + ('z-index:' +
        self.zIndex + ';\n                          height:' +
        self.height + ';\n                          border:' +
        self.border + '; padding: ' + self.padding + ';\n                          box-shadow:' +
        self.boxShadow + '; background: ' + self.background + ';\n                          border-radius:' +
        self.borderRadius + '; color: ' + self.color + '\n                         ');

        self.showPop = true;
      }
    } },

  mounted: function mounted() {

  } };


function preventExplorerMenu() {
  return false;
}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });













var _index = __webpack_require__(322);var _index2 = _interopRequireDefault(_index);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
_index2.default;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =




{
  name: "mw-markdown-editor",
  data: function data() {
    return {
      containerId: "mdeditor-" + new Date().getTime() };

  },
  props: {
    mode: String,
    markdown: String },

  mounted: function mounted() {
    var me = this;
    var el = me.$refs.container;
    var css = [
    "/assets/js/editormd/lib/codemirror/codemirror.min.css",

    "/assets/js/editormd/css/editormd.css"];
    var jsList = [
    "/assets/js/editormd/lib/codemirror/codemirror.min.js",
    "/assets/js/editormd/lib/codemirror/addons.min.js",
    "/assets/js/editormd/lib/codemirror/modes.min.js",
    "/assets/js/plugins/marked.min.js",
    "/assets/js/plugins/prettify.min.js",
    "/assets/js/editormd/editormd.min.js"];
    PF.loadCss(css);
    PF.requireJs(jsList, function () {
      var config = {
        autoHeight: me.autoHeight,
        toolbarIcons: "simple",
        width: "100%",
        height: $(me.$refs.container).height(),
        markdown: me.markdown,
        htmlDecode: "style,script,iframe",
        tocm: true,
        emoji: true,
        taskList: true,
        pluginPath: "/assets/js/editormd/plugins/",
        autoLoadModules: false };

      if (me.mode == "display") {
        me.editor = editormd.markdownToHTML(me.containerId, config);
      } else {
        me.editor = editormd(me.containerId, config);
      }
    });
  },
  methods: {
    getValue: function getValue() {return this.editor && this.editor.getMarkdown();},
    getHtml: function getHtml() {return this.editor && this.editor.getPreviewedHTML();},
    setValue: function setValue(s) {
      if (this.editor) this.editor.setMarkdown(s);
    } } };

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =





{
  name: 'mw-html-editor',
  props: {
    value: {
      type: String,
      default: '' },

    params: {
      type: Object,
      default: {} },

    toolbarType: String },

  data: function data() {
    return {
      valueChange: false,
      editorChange: false,
      editor: undefined };

  },
  mounted: function mounted() {
    var me = this;

    $WR.ready(function (manager) {
      manager.create({
        xtype: 'UEditorComp',
        isFormField: false,
        toolbarType: me.toolbarType },
      function (editor) {
        var pageData = editor.getPageData();
        pageData.params = me.params;
        var component = PF.createVue(pageData);
        $(me.$el).append(component.$mount().$el);
        me.editor = editor;
      });
    });
  },
  watch: {
    value: function value(newVal) {
      var me = this;
      me.value = newVal;
      if (me.editor && !me.editorChange) {
        me.valueChange = true;
        me.editor.setValue(me.value ? me.value : '', false);
      }
      me.valueChange = false;
      me.editorChange = false;
    } },

  methods: {
    getValue: function getValue() {
      return this.editor.getValue();
    },
    setValue: function setValue(val) {
      var me = this;
      me.editor.setValue(val == undefined ? '' : val, false);
    },
    setHeight: function setHeight(val) {
      var me = this;
      me.editor.setHeight(val == undefined ? '' : val);
    } } };

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =

































































{
  name: "mw-formula-generator",
  props: {
    rowData: Array,
    extraFields: Array,
    fields: Array },

  data: function data() {
    return {
      dataList: [],
      dialogSelectVisible: false,
      selectedField: "",

      candidateFields: [
      { name: "用户名称", value: "$userName" },
      { name: "身份权限", value: "$roleNames", type: 'contain' },
      { name: "单位或部门", value: "$D", selectable: "dep" },
      { name: "登陆ID", value: "$loginId" }],

      operators: [







      {
        name: "包含",
        fn: "contains",
        hidden: "type!=='contain'" },
      {
        name: "不包含",
        fn: "notContains",
        hidden: "type!=='contain'" },
      {
        name: "等于",
        fn: "equal",
        hidden: "type==='contain'" },
      {
        name: "不等于",
        fn: "notEqual",
        hidden: "type==='contain'" }] };



  },
  mounted: function mounted() {
    if (this.fields) {
      this.candidateFields = this.fields;
    }
    if (this.extraFields) {
      this.candidateFields = this.candidateFields.concat(this.extraFields);
    }
    if (this.rowData) {
      this.dataList = this.rowData;
    } else {
      this.addRow();
    }
  },
  methods: {
    showHelp: function showHelp() {
      PF.showHelp({ url: '/helpDoc/platform/authory.md' });
    },
    addRow: function addRow() {
      this.dataList.push({
        fieldValue: '',
        fieldName: '',
        fieldType: "",
        value: '',
        displayValue: '',
        operator: "",
        logic: 'and' });

    },
    selectField: function selectField(row, scopeIndex) {
      row.fieldValue = '';
      row.fieldName = '';
      row.fieldType = "";
      row.selectable = false;
      row.value = '';
      row.displayValue = '';
      row.operator = '';
      this.currentSelectRow = row;
      this.dialogSelectVisible = true;
    },
    filterOperator: function filterOperator(fieldValue) {
      var me = this;

      if (!fieldValue) return [];
      var field = me.getField(fieldValue);
      var operators = field.operators || me.operators;
      if (typeof operators === 'number') {
        operators = me.operators.filter(function (op, index) {return operators & 1 << index;});
      }
      return operators.filter(function (op) {
        return op.hidden === undefined || !PF.eval(op.hidden, field, field);
      });
    },
    getField: function getField(fieldValue) {
      return this.candidateFields.filter(function (f) {return f.value === fieldValue;})[0];
    },
    close: function close() {
      if (this.$parent) this.$parent.hide();
    },
    confirm: function confirm() {
      var data = {
        formula: this.generatedFormula,
        rowData: this.dataList };

      this.$emit("ok", data);
      if (this.$parent) this.$parent.hide();
    },
    setSelectedField: function setSelectedField() {
      var row = this.currentSelectRow;
      var field = this.getField(this.selectedField);
      if (field && row) {
        row.fieldValue = this.selectedField;
        row.fieldName = field.name;
        row.selectable = !!field.selectable;
        row.fieldType = field.type;
      }
      this.currentSelectRow = "";
      this.selectedField = "";
      this.dialogSelectVisible = false;
    },
    getValueSelections: function getValueSelections(row) {
      var field = this.getField(row.fieldValue);
      return field && field.selections;
    },
    genFormula: function genFormula() {
      var me = this;
      if (!me.dataList || me.dataList.length === 0) return "";
      return me.dataList.map(function (row, index) {
        if (!row.fieldValue || !row.value || !row.operator) return "";
        var opr = me.operators.filter(function (o) {return o.name === row.operator;})[0];
        if (!opr) throw Error("没有找到对应的操作");
        if (!opr.fn) throw Error("\u672A\u8BBE\u7F6E\u64CD\u4F5C[" + opr.name + "]\u7684\u5904\u7406\u51FD\u6570\u3002");
        var formula = me.getRowFormula(row, opr);
        var logicMap = { "and": " && ", "or": " || " };
        if (index < me.dataList.length - 1) formula += logicMap[row.logic] || "";
        return formula;
      }).join("");
    },
    getRowFormula: function getRowFormula(row, opr) {
      var field = this.getField(row.fieldValue);
      var fnMap = {
        equal: function equal(row) {
          return field.dataType !== "boolean" ?
          row.fieldValue + "===\"" + row.value + "\"" :
          (row.value !== "true" ? "!" : "") + row.fieldValue;
        },
        notEqual: function notEqual(row) {
          return field.dataType !== "boolean" ?
          row.fieldValue + "!==\"" + row.value + "\"" :
          (row.value === "true" ? "!" : "") + row.fieldValue;
        },
        contains: function contains(row) {return "$contains(" + row.fieldValue + ",\"" + row.value + "\")";},
        notContains: function notContains(row) {return "!$contains(" + row.fieldValue + ",\"" + row.value + "\")";} };

      if (typeof opr.fn === 'string') {
        var fn = fnMap[opr.fn];
        if (fn) {
          return fn(row);
        } else {
          throw Error("\u672A\u8BBE\u7F6E\u64CD\u4F5C[" + opr.name + "]\u7684\u5904\u7406\u51FD\u6570\u3002");
        }
      } else {
        return opr.fn(row);
      }
    },



    selectValue: function selectValue(row) {
      var me = this;
      var field = this.getField(row.fieldValue);
      var selectType = field.selectable;
      if (!selectType) {
        return;
      }
      if (typeof selectType === "string") {
        var handlerMap = {
          "dep": me.selectDepartment };

        selectType = handlerMap[selectType];
      } else if ($.isArray(selectType)) {
        var selections = selectType;
        selectType = function selectType(row, callback) {
          PF.treeSelect({ data: selections }, function (data) {
            data = data || {};
            callback({ value: data.value || data.id, displayValue: data.name || data.text });
          });
        };
      }

      if ($.isFunction(selectType)) {
        selectType.call(me, row, function (data) {
          row.value = data.value;
          row.displayValue = data.displayValue;
        });
      }
    },
    selectDepartment: function selectDepartment(row, callback) {
      var selectNode = row.value;
      var defaultParams = {};
      var curUrl = this.mwUrl("/api/org/listDepartment");
      if (!this.userInfo || !this.userInfo.developer) curUrl = this.mwUrl("/api/org/listDepartmentListAble");
      PF.show('tree', {
        url: curUrl,
        defaultParams: defaultParams,
        selectNode: selectNode,
        types: {
          "1": {
            "icon": "fa fa-folder" },

          "2": {
            "icon": "fa fa-leaf" },

          "3": {
            "icon": "fa fa-users" },

          'default': {
            "icon": "fa fa-leaf" } },


        search: false,
        multiple: false,
        singleLeaf: false,
        clearBtn: true },
      function (res) {
        callback({ value: res.id, displayValue: res.name });
      });
    } },

  computed: {
    generatedFormula: function generatedFormula() {
      return this.genFormula();
    } } };

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _stringify = __webpack_require__(24);var _stringify2 = _interopRequireDefault(_stringify);












var _ntkoFuncExtend = __webpack_require__(1022);var _ntkoFuncExtend2 = _interopRequireDefault(_ntkoFuncExtend);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =








{
  name: "mw-ntko-editor",
  data: function data() {
    var me = this;
    return {
      path: $WR.DOC_CTRL_URL_BASE,
      buttons: me.defButtons,
      editor: {} };

  },
  created: function created() {
  },
  props: {
    params: { type: Object },
    defButtons: {
      default: function _default() {
        return [];
      },
      type: Array },

    getForm: {
      default: function _default() {
        return {};
      } },

    propObject: {
      default: function _default() {
        return {};
      },
      type: Object } },


  beforeDestroy: function beforeDestroy() {
    var me = this;
    if (me.ofc) {
      me.ofc.destroy();
    }
    me.ofc = null;
    if (this.ownerCt) {
      this.ownerCt.destroy();
    }
    return;
  },
  mounted: function mounted() {
    var me = this;
    debugger;
    me.initOfc();
    me.initButtonsEvents();
    me.$nextTick(function () {
      me.initIframe(me);
    });
  },
  methods: {
    getForm: function getForm() {
      return this.propObject.getForm ? this.propObject.getForm() : null;
    },
    removeIframe: function removeIframe() {
      if (me.ofc) {
        me.ofc.destroy();
      }
    },



    initOfc: function initOfc() {
      var me = this;
      var loc = window.location;
      var portStr = "";
      if (loc.port != 80) {
        portStr = ":" + loc.port;
      }
      me.windowHref = loc.protocol + "//" + loc.hostname + portStr;
      var cfg = me.propObject;
      if (cfg) {
        me.cfg = cfg;
        me.formData = cfg.formData;

        var form = me.getForm();
        if (form && $.isFunction(form.getValue)) {
          try {
            me.formData = form.getValue();
          } catch (e) {
            me.formData = cfg.formData;
          }
        }
      }
      me.ofc = new _ntkoFuncExtend2.default();
      me.ofc.form = me.getForm();
      me.ofc.renderTo = ".mw-toolbar__body";
      me.ofc.scope = me.$el;
      me.ofc.downloadUrl = me.windowHref + me.mwUrl('/api/business/downloadAttachment');
      me.ofc.uploadUrl = me.windowHref + me.mwUrl('/api/business/uploadAttachment');
      me.ofc.updateUrl = me.windowHref + me.mwUrl('/api/business/updateAttachment');
      me.ofc.pluginUrl = me.windowHref + "/assets/ntkooledocall/ntkooledocall.cab";
      me.ofc.ocxPath = me.windowHref + "/assets/ntkooledocall/OfficeControl.cab#version=5,0,4,0";

      var fieldMap = me.propObject.params.formConfig ? me.propObject.params.formConfig.fieldMap : [];
      if (fieldMap && fieldMap.length > 0) {
        $.each(fieldMap, function (index, el) {
          me.ofc[el.field] = el.props;
        });
      }

      if (me.getForm() && me.getForm().on) {
        me.getForm().on("beforesave", function () {
          var action = me.ofc["BEFORE_FORM_SAVE"] || "ntko_before_form_save_action";
          if (PF.action && PF.action[action]) {
            return PF.action[action].call(me.getForm(), me.ofc);
          } else {
            try {
              var efileType = me.ofc.efileType;
              if ((efileType == "JOA_CG" || efileType == "JOA_HG" || efileType == "JOA_ZW") && me.ofc && me.ofc.isWord() && !me.ofc.isSaved() && !me.ofc.readOnly && me.ofc.getProtectType() != me.ofc.ProtectMode.READONLY) {
                var flag = me.ofc.saveDocumentToServer();
                if (!flag) {
                  alert("正文保存失败");
                }
                return flag;
              }
            } catch (e) {
            }
          }
        });
        var componentTag = me.propObject.componentTag;
        if (componentTag != "CreateCLD" && componentTag != "OnLineEfileEdit" && me.getForm()) {
          me.getForm().getOFC = function () {
            return me.ofc;
          };
        }
      }
    },

    initIframe: function initIframe() {
      var me = this;
      if (me.propObject.params.fileUrl && me.propObject.componentTag == "OnLineEfileEdit") {
        var fName = me.propObject.params.fileName;
        me.ofc.fileName = fName;
        if (me.ofc.getFileType() == ".ofd") {
          me.ofc.tpl = me.ofc.getOfdTpl();
          me.ofc.on("load", function () {
            me.ofc.openOfdDocument(me.propObject.params.fileUrl);
          });
          me.ofc.render(".mw-toolbar__body", me.$el);
          return;
        }
        me.ofc.on("load", function () {
          var isOpen = me.ofc.openFromUrl(me.propObject.params.fileUrl);
          if (isOpen) {
            if (me.propObject.afterDocOpen) {
              me.propObject.afterDocOpen.call(me, me.ofc);
              return;
            }
            if (me.ofc.getProduct() == me.ofc.ProductType.NTKO_OFFICE) {
              me.ofc.showTitleBar(false);
              if (me.ofc.isWord()) {
                me.ofc.showToolBars(false);
                me.ofc.showRevisions(false);
              }
              me.ofc.protect(me.ofc.ProtectMode.READONLY);
            }
          } else {
            alert("文件打开失败");
          }
        });
        me.ofc.render(".mw-toolbar__body", me.$el);
        return;
      }

      me.Load(function (file) {
        if (!file || !file.id) return;

        if (file.mimeType == ".ofd") {
          me.ofc.tpl = me.ofc.getOfdTpl();
          me.ofc.on("load", function () {
            me.ofc.efileType = file.efileType;
            me.ofc.fileName = file.name || "zw.ofd";
            me.ofc.saveParams = {
              fileId: file.id,
              businessId: file.businessId,
              tempBusinessId: file.tempBusinessId,
              formId: file.formId,
              attachId: file.id };

            me.ofc.openOfdDocument({
              fileId: file.id,
              businessId: file.businessId,
              tempBusinessId: file.tempBusinessId,
              formId: file.formId });

          });
          me.ofc.render(".mw-toolbar__body", me.$el);
          return;
        } else {
          if (me.ofc.getFileType() == ".ofd") {
            me.ofc.tpl = null;
          }
        }

        if ($.inArray(file.mimeType, [".png", ".jpg", ".jpeg", ".gif", ".bmp"]) != -1) {
          var imgUrl = me.ofc.downloadUrl + "?" + $.param({
            id: file.id,
            businessId: file.businessId,
            tempBusinessId: file.tempBusinessId,
            formId: file.formId });

          me.ofc.fileName = file.name;
          me.ofc.tpl = "<img src='" + imgUrl + "'/>";
          me.ofc.render(".mw-toolbar__body", me.$el);
          return;
        }
        me.ofc.on("load", function () {
          var action = me.ofc["OPEN_ACTION"] || "ntko_open_action";
          if (PF.action && PF.action[action]) {
            try {
              var flag = PF.action[action](me.getForm(), me.ofc, file);
              if (flag === true) {
                return;
              }
            } catch (e) {
            }
          }
          try {
            me.openDocument(file);
          } catch (e) {
            alert(e);
          }
          var action = me.ofc["AFTER_OPEN_ACTION"] || "ntko_after_open_action";
          if (PF.action && PF.action[action]) {
            try {
              var flag = PF.action[action](me.getForm(), me.ofc);
              if (flag === true) {
                return;
              }
            } catch (e) {
            }
          }
        });
        me.ofc.tpl = null;
        me.ofc.render(".mw-toolbar__body", me.$el);
      });
    },




    openDocument: function openDocument(file) {
      var me = this;
      var tempBusinessId = file.tempBusinessId;
      var businessId = file.businessId;
      var formId = file.formId;
      var linkId = file.id;
      var efileType = file.efileType;
      var fileName = file.name ? file.name : (me.propObject.formData ? me.propObject.formData["fldtm"] || "正文" : "正文") + ".doc";
      var isReadOnly = me.propObject.isReadOnly || false;
      me.ofc.docFormatObject = me.propObject.docFormatObject;
      me.ofc.formData = me.formData;
      me.ofc.openParams = {
        tempBusinessId: tempBusinessId,
        formId: formId,
        businessId: businessId };

      me.ofc.saveParams = {
        tempBusinessId: me.propObject.params.tempBusinessId,
        formId: me.propObject.params.formId,
        businessId: me.propObject.params.businessId };


      me.ofc.fileId = linkId;
      me.ofc.fileLinkId = file.saveNew ? null : linkId;
      me.ofc.setFileName(fileName);
      me.ofc.fileType = me.ofc.getFileType();
      me.ofc.userName = me.propObject.params.userName;
      me.ofc.efileType = efileType;
      me.ofc.pkId = businessId;
      if (!linkId) {
        me.ofc.createNew();
      } else {
        var isOpened = me.ofc.openDocument();
        if (!isOpened) {
          alert("文件打开失败");
          return;
        }
      }
      me.ofc.setUserName();
      if (me.ofc.efileType == me.getEFileTypes().CG) {
        me.ofc.trackRevisions(true);
      }
      me.ofc.showRevisions(false);
      me.ofc.showTitleBar(false);

      if ((efileType == "JOA_CLD" || efileType == "JOA_CG" || me.ofc.isSetBookMarkValue) && !isReadOnly) {
        var formData = me.getForm() && me.getForm().getValue ? me.getForm().getValue() : me.formData;
        me.ofc.setLabelValue(me.propObject.docFormatObject, formData, me.propObject.params.businessId, me.propObject.params.processDefinitionId);
      }
      if ((efileType == "JOA_ZW" || efileType == "JOA_CG") && me.ofc.isWord() && !isReadOnly && !me.ofc.readOnly) {
        me.ofc.setAutoSave();
      }
      if ((me.ofc.isWord() || me.ofc.isExcel()) && (isReadOnly || me.ofc.readOnly)) {
        me.ofc.showToolBars(false);
        me.ofc.setSaved(true);
        me.ofc.protect(me.ofc.ProtectMode.READONLY);
      }
      me.ofc.isOpened = true;
    },
    getEFileTypes: function getEFileTypes() {
      return {
        ZW: "JOA_ZW",
        CG: "JOA_CG",
        FJ: "JOA_FJ",
        HG: "JOA_HG",
        PDF: "JOA_PDF",
        CLD: "JOA_CLD" };

    },
    getOpenFile: function getOpenFile(efileList) {
      efileList = efileList || [];
      var me = this;
      var cfg = me.cfg;
      var isReadOnly = me.propObject.isReadOnly || false;
      var linkId = "";
      var types = me.getEFileTypes();


      me.wordTplFileLinkId = me.propObject.params.efileType == types.CLD ? cfg.docFormatObject.cldMouldId : cfg.docFormatObject.caoGaoMouldId;
      me.headFileLinkId = cfg.docFormatObject.headMouldId;
      me.endFilelinkId = cfg.docFormatObject.tailMouldId;
      me.tmplListObject = cfg.docFormatObject.tmplListObject;
      var isOpenMoudle = false;
      var cg, zwdoc, hg, cld, zwpdf, zwofd, zwimg;

      var efileType = me.propObject.params.efileType;

      function getMimeType(item) {
        if (item.mimeType == ".doc" || item.mimeType == ".docx" || item.mimeType == ".wps") {
          return ".doc";
        }
        return item.mimeType;
      }

      var types = me.getEFileTypes();

      for (var i = 0; i < efileList.length; i++) {
        var item = efileList[i];
        var mimeType = getMimeType(item);
        if (item.type == types.ZW || item.type == types.PDF) {
          if (mimeType == ".doc") {
            zwdoc = item;
          } else if (mimeType == ".pdf") {
            zwpdf = item;
          } else if (mimeType == ".ofd") {
            zwofd = item;
          } else if ($.inArray(mimeType, [".png", ".jpg", ".jpeg", ".gif", ".bmp"]) != -1) {
            zwimg = item;
          }
        } else if (item.type == types.HG) {
          hg = item;
        } else if (item.type == types.CG) {
          cg = item;
        } else if (item.type == types.CLD) {
          cld = item;
        }
      }
      var openFile;
      var businessId = me.propObject.params.businessId;
      var formId = me.propObject.params.formId;
      var tempBusinessId = me.propObject.params.tempBusinessId;

      if (efileType == types.CLD && me.propObject.componentTag != "CreateCLD") {
        openFile = cld;
      } else if (efileType == types.ZW) {
        openFile = isReadOnly ? zwofd || zwpdf || zwdoc || cg || zwimg : zwdoc || cg || zwofd || zwpdf || zwimg;
      } else if (efileType == types.CG) {
        openFile = cg;
      }
      var saveNew = false;
      if (!openFile) {
        linkId = me.wordTplFileLinkId;
        formId = me.propObject.docFormatObject.mouldFormId;
        if (efileType != types.CLD) {
          efileType = types.CG;
          businessId = me.propObject.docFormatObject.caoGaoDocId;
        } else {
          businessId = me.propObject.docFormatObject.cldDocId;
        }
        tempBusinessId = "";
        saveNew = true;
      }
      return {
        tempBusinessId: tempBusinessId,
        formId: formId,
        saveNew: saveNew,
        businessId: businessId,
        mimeType: openFile ? openFile.mimeType : "",
        id: openFile ? openFile.id : linkId,
        efileType: openFile ? openFile.type : efileType,
        name: openFile ? openFile.name : "" };

    },
    _log: function _log(msg) {



    },
    Load: function Load(callback) {
      var me = this;
      var cfg = me.cfg;
      var params = {};
      params.businessId = me.propObject.params.businessId;
      params.formId = me.propObject.params.formId;
      params.tempBusinessId = me.propObject.params.tempBusinessId;

      params.type = me.propObject.params.efileType == "JOA_CLD" ? "JOA_CLD" : "JOA_CG,JOA_HG,JOA_ZW,JOA_PDF";
      me.mwApi.business.listAttachment(params).then(function (r) {
        var fileList = r.result;
        var file = me.getOpenFile(fileList);
        me._log("open file ==> " + (0, _stringify2.default)(file));
        if (callback) {
          callback.call(me, file);
        }
      });
    },
    initButtonsEvents: function initButtonsEvents() {
      var me = this;
      if (me.buttons) {
        $.each(me.buttons, function (i, btn) {
          if (btn.handler) {
            $("#" + btn.id, me.$el).click(function () {
              btn.handler.call(me, me.ofc);
            });
          }
        });
      }
      $("#save").click(function () {
        var efileType = me.ofc.efileType || me.propObject.params.efileType;
        var p = {
          businessId: me.propObject.params.businessId,
          tempBusinessId: me.propObject.params.tempBusinessId,
          formId: me.propObject.params.formId,
          type: efileType };

        var isCheck = false;
        if (efileType == "JOA_CG" || efileType == 'JOA_ZW' || efileType == "JOA_CLD") {
          isCheck = true;
        }
        MW.mwApi.business.listAttachment(p).then(function (res) {
          var fileLinkId;
          if (res && res.result && res.result.length > 0) {
            $.each(res.result, function (idex, el) {
              if (el.mimeType == ".doc" || el.mimeType == ".docx" || el.mimeType == ".wps") {
                fileLinkId = el.id;
              }
            });
          }
          if (isCheck && fileLinkId) {
            p.attachId = fileLinkId;
          } else if (!isCheck) {
            p.attachId = me.ofc.fileId;
          }

          var res = me.ofc.saveDocument(p);
          var ret = JSON.parse(res);
          if (ret.success && ret.result) {
            alert("保存成功");
          }
        });
      });
      $("#print").click(function () {
        if (me.ofc) {
          me.ofc.printOut();
        }
      });
    },
    noticeButtonEvent: function noticeButtonEvent(name) {
      var me = this;
      return;
    },

    closeIframe: function closeIframe() {
      var me = this;

    },
    downLoadAttach: function downLoadAttach(data) {
      var params = {};
      params.id = data.id;
      params.businessId = this.propObject.params.businessId;
      params.formId = this.propObject.params.formId;
      params.tempBusinessId = this.propObject.params.tempBusinessId;
      return this.mwApi.business.downloadAttachment(params, false);
    },

    listAttachment: function listAttachment(data) {
      var params = {};
      params.businessId = this.propObject.params.businessId;
      params.formId = this.propObject.params.formId;
      params.tempBusinessId = this.propObject.params.tempBusinessId;
      return this.mwApi.business.listAttachment(params);
    },

    getDict: function getDict(dict) {

      this.mwApi.data.getDict(dict).then(function (data) {
        return data;
      });
    },
    getDictByCode: function getDictByCode(dictcode) {

      this.mwApi.data.getDictByCode(dictcode).then(function (v) {return console.log(v);}).catch(function (err) {return console.log(err);});
    } } };

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =












{
  name: "mw-ntko-attachment",
  data: function data() {
    var me = this;
    return {
      $frame: undefined,
      path: $WR.DOC_CTRL_URL_BASE,
      buttons: me.defButtons };

  },
  props: {
    params: { type: Object },
    defButtons: {
      default: function _default() {
        return [];
      },
      type: Array },

    propObject: {
      default: function _default() {
        return {};
      },
      type: Object } },


  mounted: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var me;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
              me = this;

              me.attachsFormat = "";
              me.attchAlowCode = false;
              me.attachAlowSize = "";
              me.attachIsAlowSize = false;
              me.attchNamelength = "";
              me.attachIsAlowLength = false;
              if (me.propObject.params.editable) {
                me.mwApi.business.getUploadAttachFormatConfig({}).then(function (res) {
                  if (res.result) {
                    var types = res.result.split(',');
                    var a = [];
                    types.forEach(function (t, index) {
                      a[index] = '.' + t;
                    });
                    me.attachsFormat = a.join();
                    me.attchAlowCode = true;
                  } else {
                    me.attchAlowCode = false;
                  }
                });
                this.mwApi.business.getUploadMaxAttchSizeConfig({}).then(function (res) {
                  if (res.result) {
                    me.attachAlowSize = res.result;
                    me.attachIsAlowSize = true;
                  } else {
                    me.attachIsAlowSize = false;
                  }
                });
              }
              me.$nextTick(function () {
                var isShowInFormPanel = "0";
                var attchlistId = "attchlist_" + $uuid();
                var btnid = "addfile_" + $uuid();
                var myframeId = "myframe_" + $uuid();

                var iframeText = "";
                var iframeHeight = "0px";
                var ocxWidth, ocxHeight;
                if (isShowInFormPanel == "1") {
                  ocxWidth = "1";
                  ocxHeight = "1";
                  iframeText +=
                  '<div><i class="fa x-icon-paperclip"></i><a id="' +
                  btnid +
                  '" href="#" class="normal" ><span>添加附件</span></a>' +
                  '<div id="' +
                  attchlistId +
                  '" style="background: rgb(237, 244, 248); line-height: 19.99px; font-family: Helvetica Neue, Helvetica, Arial, sans-serif; font-size: 14px;"></div>' +
                  "</div>";
                } else {
                  ocxWidth = "100%";
                  ocxHeight = "100%";
                  iframeHeight = "100%";
                }
                var frame = $(
                iframeText +
                '<iframe id="' +
                myframeId +
                '" scrolling="false" style="height:' +
                iframeHeight +
                ";width:100%;border:none;" +
                'padding:0;margin:0;left:0;top:0;overflow:hidden;background-color:#fff;display:block; "' +
                ' src="about:blank"></iframe>');


                frame.on("load", function () {
                  var iframe = $(frame);
                  me.$frame = iframe;
                  var win;
                  if (isShowInFormPanel == "1") {
                    win = iframe[1].contentWindow;
                  } else {
                    win = iframe[0].contentWindow;
                  }
                  var doc = win.contentDocument || win.document;
                  var NTKOATTACH_OCX_ID = "NTKOATTACH_OCX_" + $uuid();
                  var ocxVersion = me.getDict('97eb7306c8e66d5c') || '5,0,1,8';
                  var locationhref = window.location;
                  var portStr = "";
                  if (locationhref.port != 80) {
                    portStr = ":" + locationhref.port;
                  }
                  var whref = locationhref.protocol + "//" + locationhref.hostname + portStr;
                  var OfficeControlPath = whref + "/assets/ntkooledocall/nfmctlnewclsid.cab";

                  doc.body.innerHTML = "<div style=\"width:100%;height:100%\"><object width=\"" + ocxWidth + "\" height=\"" + ocxHeight + "\" id=\"" + NTKOATTACH_OCX_ID + "\"\n      classid=\"clsid:A99B0DE5-282B-472c-A0C7-53E8182CD474\"\n      codebase=" +

                  OfficeControlPath + "#version=" + ocxVersion + ">\n\n      <param NAME=\"_ExtentX\" VALUE=\"26\">\n      <param NAME=\"_ExtentY\" VALUE=\"26\">\n      <param NAME=\"BorderStyle\" VALUE=\"1\">\n      <param NAME=\"BorderColor\" VALUE=\"-2147483632\">\n      <param NAME=\"BackColor\" VALUE=\"-2147483643\">\n      <param NAME=\"ForeColor\" VALUE=\"-2147483640\">\n      <param NAME=\"ProductCaption\" VALUE=\"WebOffice\u7EFC\u5408\u529E\u516C\u7CFB\u7EDF\">\n      <param NAME=\"ProductKey\" VALUE=\"C7A799FF4E69CBF99253367105E6F95F94367EE4\">\n      <param NAME=\"MakerCaption\" VALUE=\"\u5317\u4EAC\u7F8E\u7EDC\u79D1\u6280\u6709\u9650\u516C\u53F8\">\n      <param NAME=\"MakerKey\" VALUE=\"CB4FE3353F5412401BA4A3BDA9CBA50FEA138BBC\">\n      <param NAME=\"IsUseUTF8URL\" VALUE=\"1\">\n      <param NAME=\"IsUseControlAgent\" VALUE=\"0\">\n      <param NAME=\"IsUseUTF8Data\" VALUE=\"1\">\n      <param NAME=\"IsGenDiffFileFieldName\" VALUE=\"0\">\n      <param NAME=\"IsDirectConnect\" VALUE=\"0\">\n      <param NAME=\"MaxUploadSize\" VALUE=\"0\">\n      <param NAME=\"Statusbar\" VALUE=\"1\">\n      <param NAME=\"NetworkBufferSize\" VALUE=\"0\">\n      <param NAME=\"DelFileField\" VALUE=\"delIds\">\n      <param NAME=\"IsPermitAddDelFiles\" VALUE=\"1\">\n      <param NAME=\"ViewType\" VALUE=\"0\">\n      <param NAME=\"Toolbar\" VALUE=\"1\">\n      <param NAME=\"IsConfirmSaveModified\" VALUE=\"0\">\n      <param NAME=\"DefaultAddFileTypes\" VALUE=\"*.*\">\n      <param NAME=\"IsShowContextMenu\" VALUE=\"0\">\n      <param NAME=\"IsReadOnlyMode\" VALUE=\"0\">\n      <param NAME=\"IsEnableEditMenuItem\" VALUE=\"1\">\n      <param NAME=\"IsEnableOpenMenuItem\" VALUE=\"1\"><param NAME=\"IsEnablePaste\" VALUE=\"1\">\n      <param NAME=\"IsConfirmDelFiles\" VALUE=\"0\"><param NAME=\"ReceiveDataTimeOut\" VALUE=\"100000\">\n      <param NAME=\"ConnectServerTimeOut\" VALUE=\"180\"><param NAME=\"IsShowFileMouseTip\" VALUE=\"1\">\n      <param NAME=\"IsEnableSaveAll\" VALUE=\"1\"><param NAME=\"IsEnableAdd\" VALUE=\"1\">\n      <param NAME=\"IsEnableViewDetail\" VALUE=\"1\"><param NAME=\"ScannerPicType\" VALUE=\"1\">\n      <param NAME=\"IsAllowSelScannerPicType\" VALUE=\"1\"><param NAME=\"IsCloseScannerUI\" VALUE=\"1\">\n      <param NAME=\"IsSelScannerIfOnlyOne\" VALUE=\"1\"><param NAME=\"IsSaveOfficeControlDoc\" VALUE=\"0\">\n      <param NAME=\"IsShowColumnHeader\" VALUE=\"1\"><param NAME=\"IsUseAsynSave\" VALUE=\"0\">\n      <param NAME=\"IsSaveLastSelScanner\" VALUE=\"0\"><param NAME=\"IsUseFileIDInDelFileField\" VALUE=\"0\">\n      <param NAME=\"ServerGroupName\" VALUE=\"\u670D\u52A1\u5668\u6587\u4EF6\"><param NAME=\"LocalGroupName\" VALUE=\"\u672C\u5730\u6587\u4EF6\">\n      <param NAME=\"IsForceNoSaveModifiedDlg\" VALUE=\"0\"><param NAME=\"IsShowRename\" VALUE=\"0\">\n      <param NAME=\"IsShowMoveUpDown\" VALUE=\"0\"><param NAME=\"IsSupportScannerCombinePDF\" VALUE=\"0\">\n      <param NAME=\"IsAutoUseFirstScanner\" VALUE=\"0\"><param name=\"_ExtentX\" value=\"26\">\n      <param name=\"_ExtentY\" value=\"26\"><param name=\"BorderStyle\" value=\"1\">\n      <param name=\"BorderColor\" value=\"-2147483632\"><param name=\"BackColor\" value=\"-2147483643\">\n      <param name=\"ForeColor\" value=\"-2147483640\"><param name=\"IsUseUTF8URL\" value=\"1\">\n      <param name=\"IsUseUTF8Data\" value=\"1\"><param name=\"IsUseControlAgent\" value=\"0\">\n      <param name=\"IsDirectConnect\" value=\"0\"><param name=\"MaxUploadSize\" value=\"0\"><param name=\"Statusbar\" value=\"1\">\n      <param name=\"NetworkBufferSize\" value=\"0\"><param name=\"DelFileField\" value=\"delIds\">\n      <param name=\"IsPermitAddDelFiles\" value=\"1\"><param name=\"ViewType\" value=\"0\"><param name=\"Toolbar\" value=\"0\">\n      <param name=\"IsConfirmSaveModified\" value=\"0\"><param name=\"IsShowContextMenu\" value=\"0\">\n      <param name=\"IsReadOnlyMode\" value=\"0\"><param name=\"IsEnableEditMenuItem\" value=\"1\">\n      <param name=\"IsEnableOpenMenuItem\" value=\"1\"><param name=\"IsConfirmDelFiles\" value=\"0\">\n      <param name=\"ReceiveDataTimeOut\" value=\"100000\"><param name=\"ConnectServerTimeOut\" value=\"180\">\n      <param name=\"IsShowFileMouseTip\" value=\"1\"><param name=\"IsEnableSaveAll\" value=\"1\">\n      <param name=\"IsEnableAdd\" value=\"1\"><param name=\"IsEnableViewDetail\" value=\"1\">\n      <param name=\"ScannerPicType\" value=\"1\"><param name=\"IsAllowSelScannerPicType\" value=\"1\">\n      <param name=\"IsCloseScannerUI\" value=\"1\"><param name=\"IsSelScannerIfOnlyOne\" value=\"1\">\n      <param name=\"IsSaveOfficeControlDoc\" value=\"0\"><param name=\"IsShowColumnHeader\" value=\"1\">\n      <param name=\"IsUseAsynSave\" value=\"0\"><param name=\"CancelSheetDoubleClick\" value=\"0\">\n      <param name=\"IsSaveLastSelScanner\" value=\"0\"><param name=\"IsUseFileIDInDelFileField\" value=\"0\">\n      <param name=\"DefaultAddFileTypes\" value=\"*.*\"><param name=\"ServerGroupName\" value=\"\u670D\u52A1\u5668\u6587\u4EF6\">\n      <param name=\"LocalGroupName\" value=\"\u672C\u5730\u6587\u4EF6\"><param name=\"MakerCaption\" value=\"\u5317\u4EAC\u7F8E\u7EDC\u79D1\u6280\u6709\u9650\u516C\u53F8\">\n      <param name=\"MakerKey\" value=\"CB4FE3353F5412401BA4A3BDA9CBA50FEA138BBC\">\n      <param name=\"ProductCaption\" value=\"WebOffice\u7EFC\u5408\u529E\u516C\u7CFB\u7EDF\">\n      <param name=\"ProductKey\" value=\"C7A799FF4E69CBF99253367105E6F95F94367EE4\">\n       <param name=\"wmode\" value=\"opaque\">\n      <embed  wmode=\"opaque\"></embed>\n      <span style=\"color: red;\">\u4E0D\u80FD\u88C5\u8F7D\u6587\u6863\u63A7\u4EF6\uFF0C\u8BF7\u5728\u6D4F\u89C8\u5668\u7684\u9009\u9879\u4E2D\u68C0\u67E5\u6D4F\u89C8\u5668\u7684\u5B89\u5168\u8BBE\u7F6E\u3002</span></object></div>\n\n      ";






































































                  var cfg = me.propObject;
                  if (cfg && cfg.params) {
                    cfg.params.NTKOATTACH_OCX_ID = NTKOATTACH_OCX_ID;
                    cfg.params.attchlistId = attchlistId;
                  } else {
                    cfg = {
                      params: {
                        isShowInFormPanel: isShowInFormPanel,
                        NTKOATTACH_OCX_ID: NTKOATTACH_OCX_ID,
                        attchlistId: attchlistId } };


                  }
                  cfg.params.editmode = me.propObject.params.editable ? "1" : "0";

                  var AfterSaveToURL = "AttachManager.afterSaveToURL(retData, errCode);";
                  var script = "AttachManager.onRender();";
                  var AfterFileDeleted = "AttachManager.afterDeletedToURL(AttachFile)";
                  var BeforeFileAdded = "AttachManager.beforeFileAdded(isServerFile, filePathOrURL, fileName, fileSize);";
                  var OnLocalFileAdded = "AttachManager.onLocalFileAdded(path,name ,AttachFile);";
                  var BeforeFileCommand = "AttachManager.beforeFileCommand(cmdType,IsServerFile,FilePathOrURL ,AttachFile)";
                  var BeforeFileOpened = "AttachManager.beforeFileOpened(cmdType,AttachFile)";
                  var OnSelectChange = "AttachManager.onSelectChange(selectCount);";
                  var OnFileSelecteded = "AttachManager.onFileSelecteded(attachFile);";

                  me.AttachManager = win.AttachManager = me.AttachManager(doc, $, cfg, me);
                  me.AttachManager.addScript(AfterSaveToURL, {
                    language: "JavaScript",
                    for: NTKOATTACH_OCX_ID,
                    event: "AfterSaveToURL(retData, errCode)" },
                  doc);
                  me.AttachManager.addScript(AfterFileDeleted, {
                    language: "JavaScript",
                    for: NTKOATTACH_OCX_ID,
                    event: "AfterFileDeleted(AttachFile)" },
                  doc);
                  me.AttachManager.addScript(BeforeFileAdded, {
                    language: "JavaScript",
                    for: NTKOATTACH_OCX_ID,
                    event: "BeforeFileAdded(isServerFile, filePathOrURL, fileName, fileSize)" },
                  doc);
                  me.AttachManager.addScript(OnLocalFileAdded, {
                    language: "JScript",
                    for: NTKOATTACH_OCX_ID,
                    event: "OnLocalFileAdded(path,name ,AttachFile)" },
                  doc);
                  me.AttachManager.addScript(BeforeFileCommand, {
                    language: "JScript",
                    for: NTKOATTACH_OCX_ID,
                    event: "BeforeFileCommand(cmdType,IsServerFile,FilePathOrURL ,AttachFile)" },
                  doc);
                  me.AttachManager.addScript(BeforeFileOpened, {
                    language: "JavaScript",
                    for: NTKOATTACH_OCX_ID,
                    event: "BeforeFileOpened(cmdType,AttachFile)" },
                  doc);
                  me.AttachManager.addScript(OnSelectChange, {
                    language: "JavaScript",
                    for: NTKOATTACH_OCX_ID,
                    event: "OnSelectChange(selectCount)" },
                  doc);
                  me.AttachManager.addScript(OnFileSelecteded, {
                    language: "JavaScript",
                    for: NTKOATTACH_OCX_ID,
                    event: "OnFileSelecteded(attachFile)" },
                  doc);
                  me.AttachManager.addScript(script, { language: "javascript" }, doc);

                  $("#add").click(function () {
                    me.AttachManager.doAddAttach();
                  });
                  $("#scanner").click(function () {
                    me.AttachManager.doScanner();
                  });
                  $("#deleteAttach").click(function () {
                    me.AttachManager.doDeleteAttach();
                  });
                  $("#down").click(function () {
                    me.AttachManager.doDownOne();
                  });
                  $("#downall").click(function () {
                    me.AttachManager.doDownAll();
                  });
                  $("#print").click(function () {
                    me.AttachManager.doPrint();
                  });
                  $("#listview").click(function () {
                    me.AttachManager.doListView();
                  });
                  $("#iconview").click(function () {
                    me.AttachManager.doIconView();
                  });
                  $("#doMoveSelectFileUp").click(function () {
                    me.AttachManager.doMoveSelectFileUp();
                  });
                  $("#doMoveSelectFileDown").click(function () {
                    me.AttachManager.doMoveSelectFileDown();
                  });
                  $("#rename").click(function () {
                    me.AttachManager.doFileReName();
                  });

                });
                $(".mw-toolbar__body", this.$el).append(frame);
              }, 10);case 9:case "end":return _context.stop();}}}, _callee, this);}));function mounted() {return _ref.apply(this, arguments);}return mounted;}(),

  methods: {
    getDict: function getDict(dict) {
      this.mwApi.data.getDict(dict).then(function (data) {
        return data;
      });
    },
    getDictByCode: function getDictByCode(dictcode) {

      return this.mwApi.data.getDictByCode(dictcode).then(function (v) {return v;}).
      catch(function (err) {return console.log(err);});



    },
    listAttachment: function listAttachment(data) {
      var me = this;

      var params = {};
      if (data && data.type) {
        params.type = data.type;
      } else {
        params.type = this.propObject.params.efileType;
      }
      params.businessId = data.businessId;
      params.formId = data.formId;
      params.tempBusinessId = data.tempBusinessId;
      return this.mwApi.business.listAttachment(params);
    },
    deleteAttachment: function deleteAttachment(ids) {

      var params = {};

      params.businessId = this.propObject.params.businessId;
      params.formId = this.propObject.params.formId;
      params.tempBusinessId = this.propObject.params.tempBusinessId;
      return this.mwApi.business.deleteAttachment((0, _assign2.default)({ attachIds: ids }, params));
    },
    downLoadAttach: function downLoadAttach(data) {
      var params = {};
      params.id = data.id;
      params.type = this.propObject.params.efileType;
      params.businessId = this.propObject.params.businessId;
      params.formId = this.propObject.params.formId;
      params.tempBusinessId = this.propObject.params.tempBusinessId;
      return this.mwApi.business.downloadAttachment(params, false);
    },
    uploadAttachment: function uploadAttachment(data) {
      var params = {};
      params.type = this.propObject.params.efileType;
      params.businessId = this.propObject.params.businessId;
      params.formId = this.propObject.params.formId;
      params.tempBusinessId = this.propObject.params.tempBusinessId;
    },
    tableDataLoaded: function tableDataLoaded(data) {


      this.$emit('dataLoaded', data);
    },
    AttachManager: function AttachManager(doc, $, cfg, fme) {
      return {
        addScript: function addScript(code, scriptTagAttrs, doc) {
          var head =
          doc.head ||
          doc.getElementsByTagName("head")[0] ||
          doc.documentElement;

          var node = doc.createElement("script");
          node.charset = "UTF-8";
          if (scriptTagAttrs) {
            for (var p in scriptTagAttrs) {
              if (scriptTagAttrs.hasOwnProperty(p)) {
                node.setAttribute(p, scriptTagAttrs[p]);
              }
            }
          }
          node.innerText = code;
          head.appendChild(node);
        },
        onRender: function onRender() {
          var me = this;
          me.selectFileIds = [];
          me.deleteFileIds = [];
          me.selectFileIndexs = [];
          me.attchList = [];
          me.delCounts = 0;
          PF.applyIf(me, cfg);
          me.ntkoocx = cfg.ntkoocx || doc.getElementById(cfg.params.NTKOATTACH_OCX_ID);
          me.isShowInFormPanel = cfg.params.isShowInFormPanel;
          me.formView = {};
          if (cfg && cfg.params) {
            me.efileType = cfg.params.efileType || "JOA_FJ";
          }
          try {
            if (me.isShowInFormPanel == "1") {
              me.initAttachData(me, true);
            } else {
              me.initAttachData(me);
            }
          } catch (e) {
            alert("初始化附件列表失败!");
          }
        },
        initAttachData: function initAttachData(me, isReload) {
          if (!me.localInitData) {
            if (me.attchList.length > 0 && !isReload) {
              me.loadAttachData(me.attchList, me);
              fme.tableDataLoaded(me.attchList);

            } else {
              try {
                var params = {};
                params.type = me.params.efileType;
                params.businessId = me.params.businessId;
                params.formId = me.params.formId;
                params.tempBusinessId = me.params.tempBusinessId;
                fme.listAttachment(params).then(function (r) {
                  if (r && r.result) {
                    var returnListArr = r.result;
                    me.attchList = returnListArr;
                    me.loadAttachData(returnListArr, me);
                    fme.tableDataLoaded(me.attchList);
                  }
                });
              } catch (error) {
                console.log(error);
                alert("获取附件信息列表失败.");
              }
            }
          }
        },
        loadAttachData: function loadAttachData(attachArr, me) {


          var loc = window.location;
          var portStr = "";
          if (loc.port != 80) {
            portStr = ":" + loc.port;
          }
          var windowHref = loc.protocol + "//" + loc.hostname + portStr;
          for (var i = 0; i < attachArr.length; i++) {
            var fileId = attachArr[i].id;



            var efileType = attachArr[i].type;










            var efileUrl = windowHref + fme.mwUrl('/api/business/downloadAttachment?');
            var parameters = "";
            var arr = [];
            arr.push('businessId=' + me.params.businessId);
            arr.push('tempBusinessId=' + me.params.tempBusinessId);
            arr.push('formId=' + me.params.formId);
            arr.push('id=' + attachArr[i].id);
            parameters = arr.join("&");
            efileUrl = efileUrl + parameters;
            var attachFile = me.ntkoocx.addServerFile(efileUrl, attachArr[i].name, attachArr[i].size, attachArr[i].createTime);
            if (attachFile) {
              var _sn = i + 1;
              var _createTime = attachArr[i].createTime || "";
              var _creatorId = attachArr[i].creatorId || "";
              var _creatorName = attachArr[i].creator || "";
              me.setFileId(attachFile, fileId);
              me.setFileSn(attachFile, _sn);
              me.setFileCreateTime(attachFile, _createTime);
              me.setFileCreatorId(attachFile, _creatorId);
              me.setFileCreatorName(attachFile, _creatorName);
            }
          }

          var btns = "删除,下载,打印,图标,上移,下移,重命名";
          me.changeButtonStatus(btns, false);
          if (me.ntkoocx.FilesCount > 0) {
            me.changeButtonStatus("全部下载", true);
          }

          if (me.isShowInFormPanel == "1") {
            me.showFileQueue(me);
          }
        },
        getTopToolbar: function getTopToolbar() {
          return document.getElementsByClassName("el-button--small");

        },
        changeButtonStatus: function changeButtonStatus(buttons, enable) {

          var me = this;
          var toolBar = fme.$refs.buttonsContainer;
          if (!toolBar) {
            return;
          }
          if (toolBar && toolBar.childNodes && toolBar.childNodes.length == 0) {
            return;
          }
          var hideButton = void 0;
          if (cfg.params.editmode === "0") {
            hideButton = ["add", "scanner", "deleteAttach", "rename"];
            me.ntkoocx.IsPermitAddDelFiles = 0;
          } else {
            hideButton = [];
          }
          if (!hideButton || hideButton && hideButton.length == 0) {
            return;
          }
          for (var i = 0; i < toolBar.childNodes.length; i++) {
            var v = toolBar.childNodes[i];
            if (v && v.id && hideButton.indexOf(v.id) != -1) {
              $("#" + v.id).hide();

            }
          }
        },
        doAddAttach: function doAddAttach() {
          this.ntkoocx = doc.getElementById(cfg.params.NTKOATTACH_OCX_ID);






          this.ntkoocx.AddLocalFile();

        },
        doScanner: function doScanner(id) {
          this.ntkoocx.AddFromScanner();
        },
        doDeleteAttach: function doDeleteAttach() {
          var me = this;
          me.getSelectFiles();

          if (me.selectFileIds.length == 0) {
            alert("请选择要删除的文件");
            return;
          }
          me.ntkoocx.DoCommand(3);

          try {
            fme.deleteAttachment(me.selectFileIds).then(function (r) {
              me.ntkoocx.Reset();
              me.deleteAttchByIds(me.selectFileIds);
              fme.tableDataLoaded(me.attchList);
              me.initAttachData(me);
            });
          } catch (error) {
            console.log(error);
            alert("删除附件信息失败");
          }
        },
        deleteAttchByIds: function deleteAttchByIds(ids) {
          var me = this;
          var idStr = ids.join(",");
          var newAttchList = [];
          for (var i = 0; i < me.attchList.length; i++) {
            var attch = me.attchList[i];
            if (idStr.indexOf(attch.id) == -1) {
              newAttchList.push(attch);
            }
          }
          me.attchList = newAttchList;
        },
        doDownOne: function doDownOne() {
          this.getSelectFiles();
          if (this.selectFileIds.length == 0) {
            alert("请选择要下载的文件");
            return;
          }
          this.ntkoocx.DoCommand(4);
        },
        doDownAll: function doDownAll() {
          this.ntkoocx.DoCommand(5);
        },
        shimPromptDialog: function shimPromptDialog() {
          $("body>div.el-message-box__wrapper").each(function () {
            if ($(this).find(">iframe").length > 0) return;

            var el = $(this).find(".el-message-box");
            var offset = el.offset();
            var width = el.outerWidth();
            var height = el.outerHeight();
            $("<iframe src='about:blank' width=" + width + "px height=" + height + "px style='position:absolute;top:" + offset.top + "px;left:" + offset.left + "px;border:none;z-index:-1'></iframe>").css({
              width: width,
              height: height,
              position: "absolute" }).
            insertBefore(el);
          });
        },
        doFileReName: function doFileReName() {

          var me = this;



          var attachFiles = me.getSelectFiles();
          var attachFileId = me.selectFileIds[0];
          if (me.selectFileIds.length == 0) {
            alert("请选择要操作的文件");
            return;
          } else if (me.selectFileIds.length > 1) {
            alert("只能选择一份文件");
            return;
          }
          var attachFile = me.attchList[me.selectFileIndexs];
          var fileName = attachFile.name;


          fme.$prompt('请输入附件名称', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: fileName,
            closeOnClickModal: false }).
          then(function (_ref2) {var value = _ref2.value;
            if (value == null || value == '') {
              fme.$alert('附件名不能为空！', '提示', {
                dangerouslyUseHTMLString: true });

              return;
            }


            var params = {};
            params.name = value;
            params.type = me.params.efileType;
            params.attachId = attachFileId;
            params.businessId = me.params.businessId;
            params.formId = me.params.formId;
            params.tempBusinessId = me.params.tempBusinessId;
            try {
              me.ntkoocx.Reset();
              fme.mwApi.business.updateAttachment(params).then(function (r) {
                fme.listAttachment(params).then(function (r) {
                  if (r && r.result) {
                    var returnListArr = r.result;
                    me.attchList = returnListArr;
                    me.loadAttachData(returnListArr, me);
                    fme.tableDataLoaded(me.attchList);

                  }
                });

              });
            } catch (error) {
              console.log(error);
              alert("重命名失败");
            }
          }).catch(function () {





          });

          fme.$nextTick(function () {
            setTimeout(function () {return me.shimPromptDialog();}, 100);
          });

        },
        doPrint: function doPrint() {
          var me = this;
          me.getSelectFiles();
          if (this.selectFileIds.length == 0) {
            alert("请选择要打印的文件");
            return;
          }
          var length = me.selectFileIndexs.length;
          var i = 0;

          function t_print() {
            if (i == length) {
              return;
            }
            me.ntkoocx.SelectFile(me.selectFileIndexs[i], true);
            me.ntkoocx.DoCommand(2);
            me.ntkoocx.SelectFile(me.selectFileIndexs[i], false);
            i++;
          }

          setInterval(t_print, 1000);
        },
        doListView: function doListView() {
          var me = this;
          me.ntkoocx.ViewType = 2;
          var btns = "图标";
          me.changeButtonStatus(btns, true);
          btns = "列表";
          me.changeButtonStatus(btns, false);
          return false;
        },
        doIconView: function doIconView() {
          var me = this;
          me.ntkoocx.ViewType = 0;
          var btns = "列表";
          me.changeButtonStatus(btns, true);
          btns = "图标";
          me.changeButtonStatus(btns, false);
          return false;
        },
        doMoveSelectFileUp: function doMoveSelectFileUp() {

          var me = this;
          var attachFiles = me.getSelectFiles();
          if (me.selectFileIds.length == 0) {
            alert("请选择要操作的文件");
            return;
          } else if (me.selectFileIds.length > 1) {
            alert("只能选择一个文件进行操作.");
            return;
          }
          var attachFile = attachFiles[0];
          var attachFileIndex = me.getFileIndex(attachFile);
          if (attachFileIndex == 0) {
            alert("已是第一个附件！");
            return;
          }
          var attachFileId = me.selectFileIds[0];
          var params = {};
          params.moveType = "up";
          params.attachId = attachFileId;
          params.businessId = me.params.businessId;
          params.formId = me.params.formId;
          params.tempBusinessId = me.params.tempBusinessId;
          fme.mwApi.business.updateAttachmentSn(params).then(function (r) {
            if (r && r.result) {
              var data = {};
              data.type = me.efileType || "JOA_FJ";
              data.businessId = me.params.businessId;
              data.formId = me.params.formId;
              data.tempBusinessId = me.params.tempBusinessId;
              fme.listAttachment(params).then(function (r) {
                if (r && r.result) {
                  var returnListArr = r.result;
                  me.attchList = returnListArr;
                  me.ntkoocx.Reset();
                  me.loadAttachData(returnListArr, me);
                  fme.tableDataLoaded(me.attchList);
                }
              });
            }
          });
        },
        doMoveSelectFileDown: function doMoveSelectFileDown() {

          var me = this;
          var attachFiles = me.getSelectFiles();
          if (me.selectFileIds.length == 0) {
            alert("请选择要操作的文件");
            return;
          } else if (me.selectFileIds.length > 1) {
            alert("只能选择一个文件进行操作.");
            return;
          }
          var attachFile = attachFiles[0];
          var attachFileIndex = me.getFileIndex(attachFile);
          var attachFileId = me.getFileId(attachFile);
          var efileOrders = me.getFileOrders();

          var tmpObj = {};
          var count = 0;
          for (var id in efileOrders) {
            var order = efileOrders[id];
            tmpObj[order + ""] = id;
            count++;
          }

          if (attachFileIndex == count - 1) {
            alert("已是最后一个附件！");
            return;
          }

          var attachFileId = me.selectFileIds[0];
          var params = {};
          params.moveType = "down";
          params.attachId = attachFileId;
          params.businessId = me.params.businessId;
          params.formId = me.params.formId;
          params.tempBusinessId = me.params.tempBusinessId;
          fme.mwApi.business.updateAttachmentSn(params).then(function (r) {
            if (r && r.result) {
              var data = {};
              data.type = me.efileType || "JOA_FJ";
              data.businessId = me.params.businessId;
              data.formId = me.params.formId;
              data.tempBusinessId = me.params.tempBusinessId;
              fme.listAttachment(params).then(function (r) {
                if (r && r.result) {
                  var returnListArr = r.result;
                  me.attchList = returnListArr;
                  me.ntkoocx.Reset();
                  me.loadAttachData(returnListArr, me);
                  fme.tableDataLoaded(me.attchList);
                }
              });
            }
          });

        },
        doReName: function doReName(me) {
          debugger;
        },
        doSaveAttach: function doSaveAttach(me) {

          me.ntkoocx.IsConfirmSaveModified = false;

          var parameters = "";
          var arr = [];
          arr.push('type=' + me.params.efileType);
          arr.push('businessId=' + me.params.businessId);
          arr.push('formId=' + me.params.formId);
          arr.push('tempBusinessId=' + me.params.tempBusinessId);
          parameters = arr.join("&");
          var loc = window.location;
          var portStr = "";
          if (loc.port != 80) {
            portStr = ":" + loc.port;
          }
          var url = loc.protocol + "//" + loc.hostname + portStr;
          me.saveAttachUrl = url + fme.mwUrl("/api/business/uploadAttachment?") + parameters;

          if (me.formName && me.formName != "") {

            me.ntkoocx.beginSaveToURL(me.saveAttachUrl, "uploadFile", {}, me.formName, 0);
          } else {
            me.ntkoocx.beginSaveToURL(me.saveAttachUrl, "uploadFile", {}, '', 0);
          }
        },
        afterDeletedToURL: function afterDeletedToURL(AttachFile, me) {

        },
        beforeFileAdded: function () {var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(
          isServerFile,
          filePathOrURL,
          fileName,
          fileSize) {var me, extIndex, isAllow, exp, format, i, AttachFile, limitFileSize, size;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:

                    me = this;
                    me.formView = {};if (!(


                    me.params.efileType == "JOA_ZW" &&
                    me.ntkoocx.FilesCount == 1)) {_context2.next = 6;break;}

                    alert("正文只允许上传一个!");
                    me.ntkoocx.CancelLastCommand = true;return _context2.abrupt("return");case 6:if (!(


                    me.$limitOnlyOne && me.ntkoocx.FilesCount == 1)) {_context2.next = 10;break;}
                    alert("只允许上传一个!");
                    me.ntkoocx.CancelLastCommand = true;return _context2.abrupt("return");case 10:


                    me = this;if (!
                    isServerFile) {_context2.next = 13;break;}return _context2.abrupt("return");case 13:if (!


                    fme.attchAlowCode) {_context2.next = 25;break;}if (!
                    fileName) {_context2.next = 25;break;}
                    extIndex = fileName.lastIndexOf(".");if (!(
                    extIndex > 0)) {_context2.next = 25;break;}
                    isAllow = false;
                    exp = fileName.substring(extIndex).toLowerCase();
                    format = fme.attachsFormat;
                    if (format == null || format == undefined || format == "") {
                      isAllow = true;
                    } else if (format.indexOf(exp) == -1) {
                      isAllow = false;
                    } else {
                      isAllow = true;
                    }if (
                    isAllow) {_context2.next = 25;break;}
                    alert("请上传格式为" + format + "的文件");
                    me.ntkoocx.CancelLastCommand = true;return _context2.abrupt("return");case 25:





















































                    attchNamelength = fme.attchNamelength ? parseFloat(fme.attchNamelength) : 520;
                    if (fme.attachIsAlowLength && filePathOrURL.length > attchNamelength) {
                      alert("上传附件路径字符过长。");
                      me.ntkoocx.CancelLastCommand = true;
                    }

                    i = 0;case 28:if (!(i < me.ntkoocx.FilesCount)) {_context2.next = 43;break;}
                    AttachFile = me.ntkoocx.GetFile(i);if (!(

                    fileName == AttachFile.FileName &&
                    filePathOrURL == AttachFile.FilePath)) {_context2.next = 36;break;}

                    alert("[" + fileName + "] 已存在.");
                    me.ntkoocx.CancelLastCommand = true;return _context2.abrupt("return");case 36:if (!(

                    fileName == AttachFile.FileName)) {_context2.next = 40;break;}if (!(
                    confirm("[" + fileName + "] 已存在,是否继续添加?") == false)) {_context2.next = 40;break;}
                    me.ntkoocx.CancelLastCommand = true;return _context2.abrupt("return");case 40:i++;_context2.next = 28;break;case 43:






                    if (fme.attachIsAlowSize) {
                      limitFileSize = fme.attachAlowSize ? fme.attachAlowSize : me.limitFileSize;
                      size = (fileSize / 1024 / 1024).toFixed(2);
                      if (
                      limitFileSize &&
                      parseFloat(size) > parseFloat(limitFileSize))
                      {
                        alert("不允许添加超过" + limitFileSize + "M字节的附件！");
                        me.ntkoocx.CancelLastCommand = true;
                      }
                    }case 44:case "end":return _context2.stop();}}}, _callee2, this);}));function beforeFileAdded(_x, _x2, _x3, _x4) {return _ref3.apply(this, arguments);}return beforeFileAdded;}(),

        onLocalFileAdded: function onLocalFileAdded(path, name, attachFile) {
          var me = this;
          attachFile.IsAllowOpenFolder = true;
          if (me.isShowInFormPanel === "1") {
            this.showFileQueue(me);
          } else {
            this.doSaveAttach(me);
          }
        },
        onFileSelecteded: function onFileSelecteded(attachFile, me) {
          var me = this;
          var btns = "删除,下载,打印,重命名";
          me.changeButtonStatus(btns, true);
          if (me.getFileCount() > 1) {
            btns = "上移,下移";
            me.changeButtonStatus(btns, true);
          }
        },
        onSelectChange: function onSelectChange(selectCount, me) {
          var me = this;
          var flag = selectCount > 1;
          var btns = "删除,下载,打印,重命名";
          me.changeButtonStatus(btns, flag);
          flag = selectCount > 1 && me.getFileCount() > 1;
          btns = "上移,下移";
          me.changeButtonStatus(btns, flag);
        },
        beforeFileCommand: function beforeFileCommand(
        cmdType,
        isServerFile,
        filePathOrURL,
        attachFile)
        {
          var me = this;
          var commandstr = "";
          switch (cmdType) {
            case 0:
              commandstr = "ntkoCmdEdit";
              break;
            case 1:
              commandstr = "ntkoCmdOpen";
              break;
            case 2:
              commandstr = "ntkoCmdPrint";
              break;
            case 3:
              commandstr = "ntkoCmdDelete";
              if (me.isShowInFormPanel != "1" && me.delOprFrom == "keyboard") {

                me.ntkoocx.CancelLastCommand = true;
              }
              break;
            case 4:
              commandstr = "ntkoCmdSave";
              break;
            case 5:
              commandstr = "ntkoCmdSaveAll";
              break;
            case 6:
              commandstr = "ntkoCmdRename";
              break;
            case 7:
              commandstr = "ntkoCmdOpenFolder";
              break;
            case 8:
              commandstr = "ntkoCmdViewProp";
              break;}

        },
        beforeFileOpened: function beforeFileOpened(cmdType, attachFile) {


          var me = this;
          var commandstr = "";
          switch (cmdType) {
            case 0:
              commandstr = "ntkoCmdEdit";
              break;
            case 1:
              commandstr = "ntkoCmdOpen";
              var _me = this;
              if (!attachFile) return;

              var fileName = _me.getFileName(attachFile);
              var fileUrl = _me.getFileURL(attachFile);
              var fileId = _me.getFileId(attachFile);
              if (fileUrl && (fileName.indexOf(".doc") != -1 || fileName.indexOf(".docx") != -1 || fileName.indexOf(".xls") != -1 || fileName.indexOf(".pptx") != -1) || fileName.indexOf(".ppt") != -1) {
                _me.params.efileType = _me.efileType;
                _me.params.fileUrl = fileUrl;
                _me.params.fileName = fileName;
                _me.params.fileId = fileId;
                PF.show('OnLineEfileEdit', _me.params, null);














































































































                _me.ntkoocx.CancelLastCommand = true;
              }
              break;
            case 2:
              commandstr = "ntkoCmdPrint";
              break;
            case 3:
              commandstr = "ntkoCmdDelete";
              break;
            case 4:
              commandstr = "ntkoCmdSave";
              break;
            case 5:
              commandstr = "ntkoCmdSaveAll";
              break;
            case 6:
              commandstr = "ntkoCmdRename";
              break;
            case 7:
              commandstr = "ntkoCmdOpenFolder";
              break;
            case 8:
              commandstr = "ntkoCmdViewProp";
              break;}

        },
        afterSaveToURL: function afterSaveToURL(retData, errCode) {
          var me = this;
          if (errCode == 0) {












            if (me.isShowInFormPanel !== "1") {

              me.ntkoocx.Reset();

              me.attchList = [];
              me.initAttachData(me);
            }
            var btns = "全部下载";
            me.changeButtonStatus(btns, true);

          } else if (errCode == 1) {

            alert("文件存取错误");
          } else if (errCode == 2) {

            alert("网络传送错误");
          } else if (errCode == 3) {

            alert("内存错误");
          } else if (errCode == 10) {


            me.removeLocalFile();
          } else if (errCode == 11) {

            alert("超时终止");
          } else if (errCode == 100) {

            alert("其他未知错误");
          } else if (errCode > 100) {

            alert("服务器返回的错误状态信息");
          }
        },
        showFileQueue: function showFileQueue(me) {
          var tempstr = "";
          for (var i = 0; i < me.ntkoocx.FilesCount; i++) {
            var AttachFile = me.ntkoocx.GetFile(i);
            var FileName = AttachFile.FileName;
            var FileSize = AttachFile.FileSize;

            var createTime = this.getFileCreateTime(AttachFile);
            var creatorName = this.getFileCreatorName(AttachFile);
            var creatorId = this.getFileCreatorId(AttachFile);
            var isShowUserInfo = true;
            var isDelLimit = false;

            var userInfo = "";
            if (isShowUserInfo == "true" && creatorName && createTime) {
              userInfo += "(" + creatorName + "," + createTime + ")";
            }

            if (FileSize >= 1024 * 1024) {
              FileSize = (FileSize / 1024 / 1024).toFixed(2) + "M";
            } else if (FileSize >= 1024) {
              FileSize = (FileSize / 1024).toFixed(2) + "K";
            } else {
              FileSize = FileSize + "B";
            }













            var fileList =
            "<i class='fa x-icon-paperclip'></i>" +
            FileName +
            "(" +
            FileSize +
            ")" +
            userInfo +
            "<a  name='open' filecount='" +
            i +
            "' href='javascript:void(0)'>打开</a>&nbsp;&nbsp;";
            fileList +=
            "<a name='down' filecount='" +
            i +
            "'  href='javascript:void(0)'>下载</a>&nbsp;&nbsp;";

            if (me.editmode == "1") {
              if (isDelLimit == "true") {
                if ($userId == creatorId) {
                  fileList +=
                  "<a name='del' filecount='" +
                  i +
                  "' href='javascript:void(0)'>删除</a>";
                }
              } else {
                fileList +=
                "<a name='del' filecount='" +
                i +
                "' href='javascript:void(0)'>删除</a>";
              }
            }

            if (tempstr === "") {
              tempstr = fileList;
            } else {
              tempstr = tempstr + "<br>" + fileList;
            }
          }





          document.getElementById(me.attchlistId).innerHTML = "";
          document.getElementById(me.attchlistId).innerHTML = tempstr;

          var delbtns = document.getElementsByName("del");
          for (var i = 0; i < delbtns.length; i++) {
            delbtns[i].onclick = function () {
              var filecount = this.attributes.filecount.value;
              me.doAttFile(filecount, "del", me.id, me);
            };
          }
          var openbtns = document.getElementsByName("open");
          for (var i = 0; i < openbtns.length; i++) {
            openbtns[i].onclick = function () {
              var filecount = this.attributes.filecount.value;
              me.doAttFile(filecount, "open", me.id, me);
            };
          }
          var downbtns = document.getElementsByName("down");
          for (var i = 0; i < downbtns.length; i++) {
            downbtns[i].onclick = function () {
              var filecount = this.attributes.filecount.value;
              me.doAttFile(filecount, "down", me.id, me);
            };
          }
        },
        showFileQueueInForm: function showFileQueueInForm(me, data) {

          var efileListObj = document.getElementById("#" + me.attchlistId);
          if (efileListObj.length == 0) return;
          var tempstr = "";
          for (var i = 0; i < data.length; i++) {
            var AttachFile = data[i];
            var FileName = AttachFile.efileName || AttachFile.fileName;
            var FileSize = AttachFile.fileSize;
            var FileURL = me.downAttachUrl;
            if (FileURL.lastIndexOf("?") == -1) {
              FileURL += "?";
            } else {
              FileURL += "&";
            }
            FileURL += "id=" + AttachFile.id;
            if (FileSize >= 1024 * 1024) {
              FileSize = (FileSize / 1024 / 1024).toFixed(2) + "M";
            } else if (FileSize >= 1024) {
              FileSize = (FileSize / 1024).toFixed(2) + "K";
            } else {
              FileSize = FileSize + "B";
            }
            var efileText =
            "<img src='${serverPath}/sysicons/sys_toolbar/attach.gif'>" +
            FileName +
            "(" +
            FileSize +
            ")";
            var fileList =
            i + 1 + ".<a href='" + FileURL + "'>" + efileText + "</a>";
            if (tempstr === "") {
              tempstr = fileList;
            } else {
              tempstr = tempstr + "<br>" + fileList;
            }
          }

          efileListObj.html(tempstr);
        },
        doAttFile: function doAttFile(fileCont, type, id, me) {

          if (!me.ntkoocx) {
            alert("NTKO附件管理控件装载失败!");
            return;
          }
          for (var i = 0; i < me.ntkoocx.FilesCount; i++) {
            if (i == fileCont) {
              me.ntkoocx.SelectFile(i, true);
            } else {
              me.ntkoocx.SelectFile(i, false);
            }
          }

          if (type === "down") {
            me.ntkoocx.DoCommand(4);
          } else if (type === "open") {
            me.ntkoocx.DoCommand(1);
          } else if (type === "del") {
            this.getSelectFiles(me);
            me.deleteFileIds[me.delCounts++] = me.selectFileIds[0];
            me.ntkoocx.DoCommand(3);
            this.showFileQueue(me);
          }
        },
        getFileId: function getFileId(attachFile) {

          return attachFile.getCustomData(0);
        },
        setFileId: function setFileId(attachFile, fileId) {

          attachFile.SetCustomData(0, fileId);
        },
        getFileSn: function getFileSn(attachFile) {

          return attachFile.getCustomData(1);
        },
        setFileSn: function setFileSn(attachFile, sn) {

          attachFile.SetCustomData(1, sn);
        },
        setFileCreateTime: function setFileCreateTime(attachFile, createTime) {

          attachFile.SetCustomData(2, createTime);
        },
        getFileCreateTime: function getFileCreateTime(attachFile) {

          return attachFile.getCustomData(2);
        },
        setFileCreatorId: function setFileCreatorId(attachFile, creatorId) {

          attachFile.SetCustomData(3, creatorId || "");
        },
        getFileCreatorId: function getFileCreatorId(attachFile) {

          return attachFile.getCustomData(3);
        },
        setFileCreatorName: function setFileCreatorName(attachFile, createName) {

          attachFile.SetCustomData(4, createName || "");
        },
        getFileCreatorName: function getFileCreatorName(attachFile) {

          return attachFile.getCustomData(4);
        },
        getFileName: function getFileName(attachFile) {

          return attachFile.FileName;
        },
        getFilePath: function getFilePath(attachFile) {

          return attachFile.FilePath;
        },
        getFileURL: function getFileURL(attachFile) {

          return attachFile.FileURL;
        },
        getFileSize: function getFileSize(attachFile) {

          return attachFile.FileSize;
        },
        getFileIndex: function getFileIndex(attachFile) {

          return attachFile.SortOrder;
        },
        getSelectedFileCount: function getSelectedFileCount(me) {

          this.getSelectFiles(me);
          return this.selectFileIds.length;
        },
        getFileCount: function getFileCount() {

          return this.ntkoocx.FilesCount;
        },
        getSelectFiles: function getSelectFiles(me) {

          var me = this;
          if (me.selectFileIds.length > 0) {
            me.selectFileIds = [];
          }
          me.selectFileIndexs = [];
          var attachFiles = [];
          for (var i = 0; i < this.getFileCount(); i++) {
            if (this.isFileSelected(i)) {
              var attachFile = this.getAttachFile(i);
              if (this.isServerFile(attachFile)) {
                me.selectFileIds.push(this.getFileId(attachFile));
                attachFiles.push(attachFile);
                me.selectFileIndexs.push(i);
              }
            }
          }
          return attachFiles;
        },
        getFileOrders: function getFileOrders() {

          var me = this;
          var orders = {};
          for (var i = 0; i < me.getFileCount(); i++) {
            var attachFile = me.getAttachFile(i);
            if (me.isServerFile(attachFile)) {
              var fileId = me.getFileId(attachFile);
              var fileOrder = me.getFileIndex(attachFile);
              orders[fileId] = fileOrder;
            }
          }
          return orders;
        },
        isFileSelected: function isFileSelected(index) {

          return this.ntkoocx.IsFileSelected(index);
        },
        getAttachFile: function getAttachFile(index) {

          return this.ntkoocx.GetFile(index);
        },
        isServerFile: function isServerFile(attachFile) {

          return attachFile.IsServerFile;

        } };

    } } };

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =





{
  name: 'MwViewToolbarTable',
  props: {
    layout: Array,
    applicationId: {
      type: String } } };

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =






























{
  name: 'form-attachment-list',
  data: function data() {
    var me = this;
    return {
      paperItems: '',
      tableData: undefined,
      editMode: !this.$options.config.getCurrentObject().isTextMode(),
      batchId: this.$options.config.getFormObject().batchId || "",
      attachApi: 'business.listAttachment',
      attachDefaultParams: {},
      attachData: [],
      attachColumns: [
      { type: 'index' },
      { prop: 'name', label: $lang('名称'), formatter: me.attachNameFormatter },
      { prop: 'creator', label: $lang('上传者'), width: '120' },
      { prop: 'createTime', label: $lang('上传日期'), width: '170' },
      { prop: 'size', label: $lang('大小'), width: '120', formatter: me.attachFormatter }],

      footerButton: [{
        label: $lang('确定'),
        func: this.paperSure },
      {
        label: $lang('取消'),
        func: this.paperCancel }],

      sendFooterButton: [{
        label: $lang('确定'),
        func: this.sendSure },
      {
        label: $lang('取消'),
        func: this.sendCancel }],


      showTable: true,
      showPager: true,
      showSet: true };

  },
  created: function created() {
    var config = this.$options.config.getConfig();
    this.showPager = config.pager !== false;
    this.showSet = config.sendSet !== false;
    if (this.$options.params.taskData && this.$options.params.taskData.finishTime) {
      this.showPager = false;
      this.showSet = false;
    }

  },
  mounted: function mounted() {
    this.refreshAttachment(this.$options.params.attachmentData);
  },
  methods: {
    paperSure: function paperSure() {
      if (this.$options.config.getForm())
      this.$options.config.getForm().setValueByName('addpaperattachment', this.paperItems);
      this.refreshAttachment(this.tableData);
      this.mwRef('pageDialog').hide();
    },
    paperCancel: function paperCancel() {
      this.mwRef('pageDialog').hide();
    },

    showPaper: function showPaper(e) {
      if (this.$options.config.getForm()) {
        try {
          this.paperItems = this.$options.config.getForm().getValueByName('addpaperattachment');
        } catch (ex) {}
      }
      this.mwRef('pageDialog').show();
    },
    sendSure: function sendSure() {
      this.mwRef('sendDialog').hide();
    },
    sendCancel: function sendCancel() {
      this.mwRef('sendDialog').hide();
    },
    showSend: function showSend(e) {
      var me = this;
      var formData = void 0;
      var form = this.$options.config.getForm();
      if (this.$options.config.getForm().getExtForm())
      formData = this.$options.config.getForm().getExtForm().formData;
      if (!formData) {
        PF.message('warning', $lang('取不到表单值'));
        return;
      }
      var fldzs = formData.fldzs;
      if (!fldzs) {
        PF.message('warning', $lang('请选择主送'));
        return;
      }
      var formSel = formData.addattachsend;
      if (formSel) {
        formSel = PF.decode(formSel);
        if (formSel.orgs) {
          formSel.deptObjs = {};
          formSel.orgs.forEach(function (v) {
            formSel.deptObjs[v.id] = v;
          });
        }
      }

      var flddfbmstn = formData.flddfbmstn;
      var flddfbmstnbmids = formData.flddfbmstnbmids;
      var fldgwnfbms = formData.fldgwnfbms;
      var flddfbmstnryids = formData.flddfbmstnryids || "";
      var flddgwnfrys = formData.flddgwnfrys;

      var fldzsbmIds = formData.fldzsbmIds;
      var fldzsbmNames = formData.fldzsbmNames;
      var fldzsryIds = formData.fldzsryIds;
      var fldzsryNames = formData.fldzsryNames;
      var fldcsbmIds = formData.fldcsbmIds;
      var fldcsbmNames = formData.fldcsbmNames;
      var fldcsryIds = formData.fldcsryIds;
      var fldcsryNames = formData.fldcsryNames;
      if (!flddfbmstn) {
        if (!flddfbmstnbmids) {
          var bmids = [];
          if (fldzsbmIds) {
            bmids = bmids.concat(fldzsbmIds.split(','));
          }
          if (fldcsbmIds) {
            bmids = bmids.concat(fldcsbmIds.split(','));
          }
          if (bmids.length > 0)
          flddfbmstnbmids = bmids.join(",");
        }

        if (!flddfbmstnryids) {
          var ryIds = [];
          if (fldzsryIds) {
            ryIds = ryIds.concat(fldzsryIds.split(','));
          }
          if (fldcsryIds) {
            ryIds = ryIds.concat(fldcsryIds.split(','));
          }
          if (ryIds.length > 0)
          flddfbmstnryids = ryIds.join(",");
        }
      }
      if (!flddfbmstnryids && !flddfbmstnbmids) {
        me.mwMsg('warning', $lang('请选择主送或抄送'));
        return;
      }


      var id = flddfbmstnryids || "";
      if (flddfbmstnbmids) {
        if (id) {
          id = id + ',' + flddfbmstnbmids;
        } else {
          id = flddfbmstnbmids;
        }
      }
      if (!flddfbmstn) {
        var dfmstn = [];
        if (fldzsryNames)
        dfmstn = dfmstn.concat(fldzsryNames.split(','));
        if (fldcsryNames)
        dfmstn = dfmstn.concat(fldcsryNames.split(','));
        if (fldzsbmNames)
        dfmstn = dfmstn.concat(fldzsbmNames.split(','));
        if (fldcsbmNames)
        dfmstn = dfmstn.concat(fldcsbmNames.split(','));
        if (dfmstn.length > 0)
        flddfbmstn = dfmstn.join(",");
      } else {
        var _dfmstn = [];
        if (flddgwnfrys)
        _dfmstn = _dfmstn.concat(flddgwnfrys.split(','));
        if (fldgwnfbms)
        _dfmstn = _dfmstn.concat(fldgwnfbms.split(','));
        if (_dfmstn.length > 0)
        flddfbmstn = _dfmstn.join(",");
      }

      var ids = id.split(',');
      var names = flddfbmstn.split(',');
      var dept = {};
      var idx = 0;
      ids.forEach(function (v1) {
        if (flddfbmstnryids && flddfbmstnryids.indexOf(v1) > -1) {
          dept[v1] = { id: v1, name: names[idx], type: 'ry', files: [] };
        } else {
          dept[v1] = { id: v1, name: names[idx], type: 'bm', files: [] };
        }
        idx++;
      });

      var val = {};

      me.tableData.forEach(function (v) {
        var obj = [];
        idx = 0;
        if (formSel && formSel.fileIds && formSel.fileIds.indexOf(v.id) > -1) {
          ids.forEach(function (v1) {
            if (flddfbmstnryids && flddfbmstnryids.indexOf(v1) > -1) {
              if (formSel.deptObjs && formSel.deptObjs[v1] && formSel.deptObjs[v1].files.indexOf(v.id) == -1) {
                obj.push({ id: v1, name: names[idx], type: 'ry', sel: false });
              } else {
                obj.push({ id: v1, name: names[idx], type: 'ry', sel: true });
              }
            } else {
              if (formSel.deptObjs && formSel.deptObjs[v1] && formSel.deptObjs[v1].files.indexOf(v.id) == -1) {
                obj.push({ id: v1, name: names[idx], type: 'bm', sel: false });
              } else {
                obj.push({ id: v1, name: names[idx], type: 'bm', sel: true });
              }
            }
            idx++;
          });
        } else {
          ids.forEach(function (v1) {
            if (flddfbmstnryids && flddfbmstnryids.indexOf(v1) > -1) {
              obj.push({ id: v1, name: names[idx], type: 'ry', sel: true });
            } else {
              obj.push({ id: v1, name: names[idx], type: 'bm', sel: true });
            }
            idx++;
          });
        }
        val[v.id] = obj;
      });
      var selData = void 0;
      var selId = "";
      PF.show('treeTable', {
        showTreeToolbar: false,
        treeAsync: false,
        treeData: me.tableData,
        size: 'small_large',
        selectFirst: true, clearBtn: false, title: $lang('请选择'),
        columns: [{ type: 'selection' },
        { prop: 'name', label: $lang('部门或用户'), tooltip: true }],
        singleSelect: false,
        changed: function changed(value, tree, table) {
          if (selId == value.id) {
            return;
          }
          selId = value.id;
          selData = val[value.id];
          setTimeout(function () {
            table.setData(selData, function () {
              selData.forEach(function (v) {
                if (v.sel) {
                  table.selectByProp('id', v.id);
                }
              });
            });
          }, 500);
        },
        selectAll: function selectAll(selection) {
          if (selection.length > 0) {
            selection.forEach(function (v) {
              v.sel = true;
            });
          } else {
            selData.forEach(function (v) {
              v.sel = false;
            });
          }
        },
        select: function select(selection, row) {
          row.sel = !row.sel;
        },
        rowClick: function rowClick(row, event, column) {
          row.sel = !row.sel;
        },
        autoLoad: true,
        tableData: [] },
      function (res) {
        var send = {};
        var keys = me.mwLodash.keys(val);
        send.fileIds = [];
        keys.forEach(function (k) {
          send.fileIds.push(k);
          val[k].forEach(function (v) {
            if (v.sel)
            dept[v.id].files.push(k);
          });
        });
        var orgs = [];
        keys = me.mwLodash.keys(dept);
        keys.forEach(function (k) {
          orgs.push(dept[k]);
        });
        send.orgs = orgs;
        form.setValueByName('addattachsend', PF.encode(send));
      });
    },

    attachFormatter: function attachFormatter(row, column, cellValue) {
      if (cellValue) {
        return (cellValue / 1024).toFixed(2) + 'K';
      }
    },
    attachNameFormatter: function attachNameFormatter(row, column, cellValue) {var h = this.$createElement;
      var me = this;
      if (row.category != undefined && row.category == 'pager')
      return h('span', [cellValue]);else

      return h('span', { 'class': 'attach-down', on: { 'click': function click(event) {me.downLoadAttach(row);} } }, [cellValue]);
    },
    downLoadAttach: function downLoadAttach(data) {
      var me = this;
      var params = {};
      params.id = data.id;
      params.businessId = this.$options.params.businessId;
      params.formId = this.$options.params.formId;
      params.tempBusinessId = this.$options.params.tempBusinessId;
      params.editMode = me.editMode;
      params.batchId = me.batchId;
      if (window.PF && PF.action && PF.action["attachment_preview"]) {
        var formObj = me.$options.config.getForm ? me.$options.config.getForm() : {};
        PF.action["attachment_preview"](params, formObj, me);
        return;
      }

      if (this.isCloseAttachDownload()) return;
      me.mwApi.business.downloadAttachment(params);
    },
    showAttachment: function showAttachment(event) {
      event.stopPropagation();



      var closeAttachDownload = this.isCloseAttachDownload();
      var fullAuthType = "";
      if (this.$options.config.getForm().getExtForm())
      fullAuthType = this.$options.config.getForm().getExtForm().extParams.fullAuthType || "";
      PF.show('attachment', { type: "JOA_FJ", businessId: this.$options.params.businessId, tempBusinessId: this.$options.params.tempBusinessId, formId: this.$options.params.formId, batchId: this.batchId, editable: this.editMode, closeAttachDownload: closeAttachDownload, recordsIsCanEdit: this.recordsIsCanEdit, fullAuthType: fullAuthType }, this.refreshAttachment);


    },
    recordsIsCanEdit: function recordsIsCanEdit(rows) {
      var me = this;
      if (window.PF && PF.action && PF.action.formAttachmentIsCanEdit) {
        return PF.action.formAttachmentIsCanEdit(me.$options.config, rows);
      } else {
        return true;
      }
    },
    isCloseAttachDownload: function isCloseAttachDownload() {
      var formObj = this.$options.config.getFormObject();
      var closeAttachDownload = false;
      if (formObj && formObj.type == "module_flow") {
        var sysConfig = formObj.$store.getters.sysConfig;
        if (sysConfig && sysConfig.closeAttachDownload) {
          if (!(!_.isEmpty(formObj.activity) && (formObj.activity.downloadAttach == undefined || formObj.activity.downloadAttach == 1))) {
            closeAttachDownload = true;
          }
        }
      }
      return closeAttachDownload;
    },
    showNtkoEditor: function showNtkoEditor(event) {
      event.stopPropagation();

      var par = {
        editable: this.editMode,
        formConfig: this.$options.config.getConfig(),
        form: this.$options.config.getForm(),
        processActivity: this.$options.config.getFormObject().activity,
        moduleId: this.$options.params.moduleId,
        businessId: this.$options.params.businessId,
        tempBusinessId: this.$options.params.tempBusinessId,
        formId: this.$options.params.formId,
        formData: this.$options.config.getFormValue(),
        isShowToolbar: true };

      PF.show('NtkoEditor', par, this.refreshAttachment);
    },
    createCLD: function createCLD(event) {
      event.stopPropagation();
      var p = {
        editable: this.editMode,
        formConfig: this.$options.config.getConfig(),
        form: this.$options.config.getForm(),
        processActivity: this.$options.config.getFormObject().activity,
        moduleId: this.$options.params.moduleId,
        businessId: this.$options.params.businessId,
        tempBusinessId: this.$options.params.tempBusinessId,
        formId: this.$options.params.formId,
        formData: this.$options.config.getFormValue() };

      PF.show('CreateCLD', p, this.refreshAttachment);
    },
    readCLD: function readCLD(event) {
      event.stopPropagation();
      var p = {
        editable: false,
        formConfig: this.$options.config.getConfig(),
        form: this.$options.config.getForm(),
        processActivity: this.$options.config.getFormObject().activity,
        moduleId: this.$options.params.moduleId,
        businessId: this.$options.params.businessId,
        tempBusinessId: this.$options.params.tempBusinessId,
        formId: this.$options.params.formId,
        formData: this.$options.config.getFormValue() };

      PF.show('readCLD', p, this.refreshAttachment);
    },
    printCLD: function printCLD(event) {
      event.stopPropagation();
      var p = {
        editable: false,
        formConfig: this.$options.config.getConfig(),
        form: this.$options.config.getForm(),
        processActivity: this.$options.config.getFormObject().activity,
        moduleId: this.$options.params.moduleId,
        businessId: this.$options.params.businessId,
        tempBusinessId: this.$options.params.tempBusinessId,
        formId: this.$options.params.formId,
        formData: this.$options.config.getFormValue() };

      PF.show('printCLD', p, this.refreshAttachment);
    },


    refreshAttachment: function refreshAttachment(data) {
      if (data == undefined) {
        return;
      }
      this.tableData = data;
      var ndata = [];
      data.forEach(function (v) {
        if (v.category == undefined || v.category != 'pager')
        ndata.push(v);
      });
      var addpaperattachment = this.$options.config.getForm().getValueByName('addpaperattachment');
      if (addpaperattachment != undefined && addpaperattachment != '') {
        var paper = addpaperattachment.split('\n');
        paper.forEach(function (v) {
          ndata.push({ id: v, name: '【纸质附件】' + v, category: 'pager' });
        });
      }
      if (ndata && ndata.length > 0 && window.$currentBrowserLanguage === 'en') {
        ndata.forEach(function (d) {
          d.creator = d.Englishname || d.creator;
        });
      }
      this.mwRef('attachTable').setData(ndata);
      this.$emit("refreshAttachment", this, ndata);
    },
    onChange: function onChange(name, value, d) {
      if (name === "pager") {

        this.showPager = value;
      }
      if (name === "sendSet") {

        this.showSet = value;
      }
    } },

  destroyed: function destroyed() {

  } };

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);












































var _token = __webpack_require__(25);var _token2 = _interopRequireDefault(_token);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{

  name: 'form-attachment-list-min',
  data: function data() {
    var me = this;
    var config = this.$options.config;
    var editMode = !config.getCurrentObject().isTextMode();
    var businessId = config.getData().businessId;
    var batchId = config.getFormObject().batchId || "";
    var $dd = config.getConfig() || {};
    if (!$dd.buttonIcon && !$dd.buttonLabel) $dd.buttonLabel = $lang("选择文件");
    if ($dd.buttonLabel) $dd.buttonLabel = $lang($dd.buttonLabel);
    return {
      uploader: null,
      editMode: editMode,
      label: $dd.buttonLabel || "",
      icon: $dd.buttonIcon || "",
      type: $dd.colorCls || "primary",
      plain: !!$dd.plain,
      config: config,
      fileList: [],
      accept: '',
      maxSize: 10,
      limit: 1,
      list: '',
      imageUrl: '',
      showUploadDialog: '',
      defaultParams: {
        formId: '',
        businessId: '',
        type: '',
        tempBusinessId: '',
        fullPath: "y",
        batchId: batchId },

      headers: {},
      flag: false,
      avatarStyle: {
        width: '150px',
        height: '150px' },

      action: this.mwUrl('/api/business/uploadAttachment'),
      uploadPercent: 0 };

  },

  created: function created() {

  },
  mounted: function mounted() {
    var me = this;
    this.defaultParams.formId = this.$options.params.formId;
    this.defaultParams.businessId = this.$options.params.businessId;
    this.defaultParams.tempBusinessId = this.$options.params.tempBusinessId;
    this.defaultParams.checkAttchSize = true;
    this.defaultParams.fullAuthType = this.$options.params.fullAuthType || "";
    var config = this.$options.config.getConfig();
    this.$options.config.getCurrentObject().$obj = this;
    this.defaultParams.type = config.fileType || 'JOA_FJ';
    this.maxSize = config.fileSize || 10;
    this.list = config.list || 'true';
    if (config.limit && config.limit === 'true') {
      this.limit = null;
    } else
    {
      this.limit = 1;
    }
    this.showUploadDialog = config.showUploadDialog === '1';
    this.refresh(function () {
      if (config.fileExtension) {
        me.accept = config.fileExtension;
        me.$nextTick(function () {
          me.initPupload();
        });
      } else {
        me.accept = PF._sysConfig && PF._sysConfig.uploadAttachFormat || "";
        me.maxSize = config.fileSize || PF._sysConfig && PF._sysConfig.uploadAttachMaxSize || 10;
        me.initPupload();
      }
      if (me.list === 'false') {
        if (config.pwidth) {
          me.avatarStyle.width = config.pwidth + 'px';
        } else {
          me.avatarStyle.width = '150px';
        }
        if (config.pheight) {
          me.avatarStyle.height = config.pheight + 'px';
        } else
        {
          me.avatarStyle.height = '150px';
        }
      }
    });
  },
  methods: {
    recordIsCanEdit: function recordIsCanEdit(row) {
      if (window.PF && PF.action && PF.action.formAttachmentIsCanEdit) {
        return PF.action.formAttachmentIsCanEdit(this.config, [row]);
      } else {
        return true;
      }
    },
    initPupload: function initPupload() {
      var me = this;
      var buttonId = void 0;
      if (!me.editMode || me.showUploadDialog) return;
      if (me.limit === 1 && me.list === 'false' && me.imageUrl && me.editMode) {
        buttonId = me.mwRef('plusUploaderBtn');
      } else {
        var uploadRef = me.mwRef('uploaderBtn');
        if (uploadRef)
        buttonId = uploadRef.$el;
      }
      if (!buttonId) return;
      PF.requireJs(["/assets/js/Plupload/js/plupload.full.min.js"], function () {
        var cfg = {
          runtimes: 'gears,html5,flash,silverlight,browserplus,html4',
          browse_button: buttonId,
          max_file_size: me.maxSize + 'mb',
          unique_names: true,
          url: me.action,
          multi_selection: me.limit == null ? true : false,
          flash_swf_url: '/assets/js/Plupload/js/Moxie.swf',
          silverlight_xap_url: '/assets/js/Plupload/js/Moxie.xap' };

        if (me.accept) {
          cfg.filters = { mime_types: [
            { title: $lang("自定义文件"), extensions: me.accept }] };

        }
        var uploader = new plupload.Uploader(cfg);
        me.uploader = uploader;
        if (me.$options.config && me.$options.config.getFormObject &&
        me.$options.config.getFormObject() && me.$options.config.getFormObject().$newForm) {
          me.$options.config.getFormObject().$newForm.uploaderPage = me;
        }
        uploader.bind('FilesAdded', function (up, files) {
          if (me.limit == 1 && me.fileList[0]) {
            uploader.setOption("url", me.mwUrl('/api/business/updateAttachment'));
            me.defaultParams.uploadType = "update";
            me.defaultParams.attachId = me.fileList[0].id;
          }
          var formObj = me.$options.config.getFormObject();
          if (formObj && formObj.$newForm) {
            formObj.$newForm.fireEvent("FilesAdded", up, files, me.config);
          }

          me.defaultParams.businessId = me.$options.config.getFormObject().businessId || "";
          if (me.defaultParams.businessId) {
            me.defaultParams.tempBusinessId = "";
          }
          if (me.$options.config.getFormObject().extParams)
          me.defaultParams.fullAuthType = me.$options.config.getFormObject().extParams.fullAuthType || "";
          uploader.setOption("multipart_params", me.defaultParams);
          uploader.start();
        });
        uploader.bind('UploadProgress', function (up, file) {
          me.flag = true;
          me.uploadPercent = file.percent.toFixed(0);
        });
        uploader.bind('UploadComplete', function (up, files) {
          var formObj = me.$options.config.getFormObject();
          if (formObj && formObj.$newForm) {
            formObj.$newForm.fireEvent("beforeUploadComplete", up, files, me.config);
          }
          me.handleSuccess(up, files);
          if (formObj && formObj.$newForm) {
            formObj.$newForm.fireEvent("afterUploadComplete", up, files, me.config);
          }
        });
        uploader.bind('FileUploaded', function (up, file, obj) {
          var r = void 0;

          try {
            r = JSON.parse(obj.response || "{}");
          } catch (err) {
          }
          if (r.success) {
            if (r.result && r.result.msg) {
              PF.alert(r.result.msg);
            }
          } else {
            PF.alert(r.errMsg || "上传出错");
          }
        });
        uploader.bind('Error', function (up, err) {
          var response = err && err.response ? JSON.parse(err.response) : "";
          if (response && response.result) {
            me.$message.warning(response.result.msg);
          } else {
            if (err.message.indexOf("File size error") != -1)
            me.$message.error($lang('上传附件大小不能超过') + me.maxSize + 'MB!');else
            if (err.message.indexOf("File extension error") != -1)
            me.$message.error($lang("只能上传文件类型:") + " " + me.accept);else

            me.$message.warning(err.code + ":" + err.message + (err.file ? ", File: " + err.file.name : ""));
          }
          up.refresh();
        });
        uploader.init();
      });
    },
    showUploadDlg: function showUploadDlg() {
      var me = this;
      if (!me.editMode || !me.showUploadDialog) return;
      var type = me.defaultParams.type;
      var batchId = me.defaultParams.batchId;
      PF.show('attachment', { type: type, businessId: me.$options.params.businessId, tempBusinessId: me.$options.params.tempBusinessId, formId: me.$options.params.formId, batchId: batchId, editable: me.editMode }, function () {
        me.refresh();
      });

    },
    handleSuccess: function handleSuccess(up, files) {
      var me = this;
      me.flag = false;
      me.uploadPercent = 0;
      me.refresh(function () {
        me.$nextTick(function () {
          me.uploadDestroy();
          me.initPupload();
        });
      });

    },
    beforeRemove: function beforeRemove(file) {
      var me = this;
      me.$confirm($lang('确定移除') + file.name + $lang('文件') + '?', $lang('提示'), {
        confirmButtonText: $lang('确定'),
        cancelButtonText: $lang('取消'),
        type: 'warning' }).
      then(function () {
        var params = (0, _assign2.default)({ attachIds: [file.id] }, me.defaultParams);
        me.mwApi.business.deleteAttachment(params).then(function (res) {
          if (res.success) {
            me.$message({
              type: 'success',
              message: $lang('删除成功!') });

            me.refresh(function () {
              me.$nextTick(function () {
                me.uploadDestroy();
                me.initPupload();
              });
            });
          }
        });
      });
    },
    refresh: function refresh(callback) {var _this = this;
      var me = this;

      this.defaultParams.businessId = this.$options.config.getFormObject().businessId;
      if (this.defaultParams.businessId) {
        this.defaultParams.tempBusinessId = "";
      }
      this.mwApi.business.listAttachment(this.defaultParams).then(function (res) {
        if (res.success) {
          _this.fileList = res.result || [];
          var formObj = me.$options.config.getFormObject();
          formObj.$newForm.fireEvent("attachmentload", _this.fileList, me.config);
          var config = _this.$options.config.getConfig();
          var formId = _this.$options.params.formId;
          var businessId = _this.$options.params.businessId;
          var tempBusinessId = _this.$options.params.tempBusinessId;
          if (config.list) {
            if (config.list === 'true') {

            } else {
              if (_this.fileList.length != 0) {
                if (config.limit === 'false') {
                  var id = _this.fileList[0].id;
                  var string = 'id=' + id + '&businessId=' + businessId + '&formId=' + formId + '&tempBusinessId=' + tempBusinessId + '&_t=' + Math.random();
                  _this.imageUrl = _this.mwUrl("/api/business/downloadAttachment?") + string;
                } else
                {
                  _this.fileList.forEach(function (f) {
                    var string = 'id=' + f.id + '&businessId=' + businessId + '&formId=' + formId + '&tempBusinessId=' + tempBusinessId + '&_t=' + Math.random();
                    f.imageUrl = _this.mwUrl("/api/business/downloadAttachment?") + string;
                  });
                }
              } else {
                _this.imageUrl = '';
              }
            }
          }
        }
        if (callback) callback();
      });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {var _this2 = this;
      if (this.fileList.length > 0) {
        var ids = [];
        this.fileList.forEach(function (f) {
          ids.push(f.id);
        });
        var params = (0, _assign2.default)({ attachIds: ids }, this.defaultParams);
        this.mwApi.business.deleteAttachment(params).then(function (res) {
          if (res.success) {
            _this2.refresh();
          }
        });
      } else {
        this.refresh();
      }

    },
    downloadAttachment: function downloadAttachment(data) {
      var me = this;
      var params = {};
      params.id = data.id;
      params.businessId = this.$options.params.businessId;
      params.formId = this.$options.params.formId;
      params.tempBusinessId = this.$options.params.tempBusinessId;
      params.editMode = me.editMode;
      if (window.PF && PF.action && PF.action["attachment_preview"]) {
        var formObj = me.$options.config.getFormObject ? me.$options.config.getFormObject() : {};
        PF.action["attachment_preview"](params, formObj, me);
        return;
      }
      me.mwApi.business.downloadAttachment(params);
    },
    isCloseAttachDownload: function isCloseAttachDownload() {
      var formObj = this.$options.config.getFormObject();
      var closeAttachDownload = false;
      if (formObj && formObj.type == "module_flow") {
        var sysConfig = formObj.$store.getters.sysConfig;
        if (sysConfig && sysConfig.closeAttachDownload) {
          if (!(!_.isEmpty(formObj.activity) && (formObj.activity.downloadAttach == undefined || formObj.activity.downloadAttach == 1))) {
            closeAttachDownload = true;
          }
        }
      }
      return closeAttachDownload;
    },
    onChange: function onChange(name, val, d) {

      var me = this;

      switch (name) {
        case 'buttonLabel':
          me.label = val;
          break;
        case 'buttonIcon':
          me.icon = val;
          break;
        case 'colorCls':
          me.type = val;
          break;
        case 'plain':
          me.plain = val;
          break;
        default:}

    },
    uploadDestroy: function uploadDestroy() {
      if (this.uploader && this.uploader.destroy)
      this.uploader.destroy();
    },
    format: function format(percentage) {
      return parseInt(percentage) === 100 ? '满' : percentage + "%";
    } } };

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =
















{
  name: 'form-comment-list',
  data: function data() {
    var me = this;
    return {
      api: 'business.listComment',
      hideOprLog: window.$Env && $Env.hideCommentlistOperation,
      defaultParams: {
        businessId: '',
        requireHidden: true,
        excludeHidden: '2' },

      columns: [
      { type: 'index' },
      { prop: 'taskName', tooltip: true, label: $lang('节点名称'), width: '120', formatter: me.taskNameFormatter },
      { prop: 'department', tooltip: true, label: $lang('办理部门'), width: '150', formatter: me.depFormatter },
      { prop: 'content', label: $lang('意见内容') },
      { prop: 'creator', label: $lang('姓名'), width: '120', formatter: me.creatorFormatter },
      { prop: 'createTime', label: $lang('填写时间'), width: '170' }],


      showTable: true };

  },
  created: function created() {

  },
  mounted: function mounted() {
    this.refreshComment();
  },
  methods: {
    taskNameFormatter: function taskNameFormatter(row, col, cellValue) {
      return $lang(cellValue);
    },
    depFormatter: function depFormatter(row, col, cellValue) {
      var isEn = window.$currentBrowserLanguage === 'en';
      if (isEn) {
        return row.departmentEnglishname || cellValue;
      } else {
        return cellValue;
      }
    },
    creatorFormatter: function creatorFormatter(row, col, cellValue) {
      var isEn = window.$currentBrowserLanguage === 'en';
      if (isEn) {
        return row.Englishname || cellValue;
      } else {
        return cellValue;
      }
    },
    refreshComment: function refreshComment(event) {
      if (event) {
        event.stopPropagation();
      }
      this.defaultParams.businessId = this.$options.params.businessId;

      this.mwRef('commentTable').refresh();
    },

    showTransactionDialog: function showTransactionDialog(event) {
      event.stopPropagation();
      var me = this;
      PF.showPage({ id: "f0a951bda707bed2", size: 'large_large', title: $lang('办理过程'), businessId: this.$options.params.businessId, batchId: me.$options.params.batchId });

    },
    showOperationRecordDialog: function showOperationRecordDialog(event) {
      event.stopPropagation();
      var me = this;
      PF.show('processOperationRecord', { batchId: me.$options.params.batchId });
    },
    showFlowChatDialog: function showFlowChatDialog(event) {
      event.stopPropagation();
      var me = this;
      PF.func.bpm.showFlowImage({ businessId: me.$options.params.businessId, batchId: me.$options.params.batchId, applicationId: me.$options.params.appId, processDefinitionId: me.$options.params.processDefinitionId, taskId: me.$options.params.taskId }, this);
    } },

  destroyed: function destroyed() {

  } };

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =









{
  name: 'form-comment-list-min',
  data: function data() {
    var config = this.$options.config;
    var previewMode = config.$previewMode;
    var businessId = config.getData().businessId;
    return {
      previewMode: previewMode,
      businessId: businessId,
      comment: '',
      commentList: [] };

  },
  created: function created() {

  },
  mounted: function mounted() {
    var me = this;
    var cfg = this.$options.config;
    if (cfg.getFormObject) {
      var form = cfg.getFormObject();
      if (form && form.$commentMinData) {
        this.renderData(form.$commentMinData);
      }
    }
    $(this.$refs.container).on("click", "span[commentid]", function () {
      var span = $(this);
      var commentId = span.attr("commentid");
      var comment = _.find(me.commentList, { id: commentId });
      me.editComment(comment);
    });
  },
  methods: {
    renderData: function renderData(reList) {
      var me = this;
      var config = this.$options.config.getConfig();

      if (!me.previewMode) {
        var params = {};
        params.businessId = me.businessId;
        var taskName = [];
        var category = [];

        var newList = [];

        var categoryMap = me.mwLodash.groupBy(reList, function (item) {
          return item.category;
        });
        var taskNameMap = me.mwLodash.groupBy(reList, function (item) {
          return item.taskName;
        });

        if (config.typeMark && config.typeMark == '1') {
          if (config.activityName) {
            category = config.activityName.split(',');
            category.forEach(function (v) {
              if (categoryMap[v]) {
                categoryMap[v].forEach(function (v1) {
                  newList.push(v1);
                });
              }
            });
          } else {
            return;
          }
        } else {
          if (config.activityName) {
            taskName = config.activityName.split(',');
            taskName.forEach(function (v) {
              if (taskNameMap[v]) {
                taskNameMap[v].forEach(function (v1) {
                  newList.push(v1);
                });
              }
            });
          } else {
            return;
          }
        }
        var dir = "desc";
        if (window.$Env && $Env.formCommentDirAsc) {
          dir = "asc";
        }
        if (config.fetchMode && config.fetchMode == '1') {
          newList = me.mwLodash.orderBy(newList, ['createTime'], ['desc']);
          if (newList.length > 0) {
            newList = [newList[0]];
          }
        } else if (config.fetchMode && config.fetchMode == '3') {
          var creatorMap = me.mwLodash.groupBy(newList, function (item) {
            return item.creator ? item.creator : item.assigneeName;
          });
          var keys = me.mwLodash.keys(creatorMap);
          newList = [];
          keys.forEach(function (v) {
            creatorMap[v] = me.mwLodash.orderBy(creatorMap[v], ['createTime'], ['desc']);
            newList.push(creatorMap[v][0]);
          });
          newList = me.mwLodash.orderBy(newList, ['createTime'], [dir]);
        } else {
          newList = me.mwLodash.orderBy(newList, ['createTime'], [dir]);
        }
        var form = me.$options.config.getForm();
        form.fireEvent("beforerenderemincomment", me, newList, reList);
        me.doRenderComments(newList);
      }
    },
    doRenderComments: function doRenderComments(newList) {
      var me = this;
      me.commentList = newList || [];
      var config = me.$options.config.getConfig();
      var $form = me.$options.config.getForm();
      var isMultiComment = $form.activity && $form.activity.moreCommentSwitch === "1";
      var taskId = $form.taskId;
      var showEditBtn = config.showEditBtn === "1";
      var format = config.displayFormat;
      var comments = '';
      var comment = void 0;
      if (newList.length > 0) {var

        getTransCreator = function getTransCreator(r) {
          return isEn ? r.Englishname || r.creator : r.creator;
        };var
        getTransDepartment = function getTransDepartment(r) {
          return isEn ? r.departmentEnglishname || r.department : r.department;
        };var isEn = window.$currentBrowserLanguage === 'en';var _loop = function _loop(
        i) {
          var v1 = newList[i];
          comment = '';
          if (v1.contentType === "jpg") {
            comment = format.replace(/\[办理意见\]/g, '<image  height=100 src="data:image/jpg;base64,' + v1.content + '">');
          } else {
            if (v1.content) {
              if (format.indexOf('[办理意见]') != -1) {
                comment = format.replace(/\[办理意见\]/g, MW.htmlEncode(v1.content));
              } else {
                comment = format.replace(/\[办理意见\]/g, '');
              }
            } else {
              comment = format.replace(/\[办理意见\]/g, '');
            }
          }
          if (format.indexOf('[办理人]') != -1) {
            comment = comment.replace(/\[办理人\]/g, v1.creator ? getTransCreator(v1) : v1.assigneeName);
          }
          if (format.indexOf('[单位]') != -1) {
            comment = comment.replace(/\[单位\]/g, $lang(v1.unit));
          }
          if (format.indexOf('[部门]') != -1) {
            if (v1.unit != v1.department)
            comment = comment.replace(/\[部门\]/g, getTransDepartment(v1));else

            comment = comment.replace(/\[部门\]/g, "");
          }
          if (format.indexOf('[意见日期]') != -1) {
            comment = comment.replace(/\[意见日期\]/g, v1.createTime.substring(0, 10));
          }
          if (format.indexOf('[意见时间]') != -1) {
            comment = comment.replace(/\[意见时间\]/g, v1.createTime);
          }
          if (format.indexOf('[意见时间分]') != -1) {
            comment = comment.replace(/\[意见时间分\]/g, v1.createTime.substring(0, 16));
          }
          comment = comment.replace(/\[时间格式\s*:\s*([^\]]+)\]/g, function (str, format) {
            return moment(v1.createTime, "YYYY-MM-dd hh:mm:ss").format(format);
          });
          if (showEditBtn && isMultiComment && taskId === v1.taskId) {
            comment += '<span commentid="' + v1.id + '" style="color:blue;cursor:pointer;margin-left:10px">\u7F16\u8F91</span>';
          }

          if (window.$Env && window.$Env.formCommentShowEnter && window.$Env.formCommentShowEnter == true) {
            comment = comment.replace(/\n/g, "<br/>");
            comment = comment.replace(/ /g, "&nbsp;");
          }
          if (config.displayMode === "inline") {
            comments += '<span>' + comment + '</span>';
          } else {
            comments += '<div>' + comment + '</div>';
          }};for (var i = 0; i < newList.length; i++) {_loop(i);
        }
        me.comment = comments;
      } else {
        me.comment = "";
      }
    },
    editComment: function editComment(comment) {
      var me = this;
      if (!comment || !comment.id) return;
      PF.prompt("", "修改意见", { inputType: "textarea", inputValue: comment.content, closeOnClickModal: false }).
      then(function (r) {
        PF.fsrv("pintervene.srv.updateComment", [comment.id], { content: r.value }, {}).then(function () {
          comment.content = r.value;
          me.doRenderComments(me.commentList);
        });
      }).
      catch(function () {});
    } },

  destroyed: function destroyed() {

  } };

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =







{
  name: 'form-imbedded-view',
  data: function data() {
    return {
      viewId: '',
      tableParams: {},
      formValue: {},
      height: "350px",
      formConfig: {
        getForm: this.$options.config.getForm,
        config: this.$options.config.getConfig(),
        way: 'inner' } };


  },
  created: function created() {

  },
  mounted: function mounted() {
    var me = this;
    var config = this.$options.config.getConfig();
    if (config.style && config.style.height || config.bodyStyle && config.bodyStyle.height) {
      me.height = "100%";
    }
    var id = config.viewId;

    if (id) {
      this.viewId = id;









    }
    me.setTableParams();
    var oldTableParams = _.clone(me.tableParams);
    var form = me.$options.config.getForm();
    var refreshView = _.debounce(function () {
      me.$refs.view.refresh();
    }, 400);
    form.on("change", function (v) {
      me.setTableParams();
      if (!_.isEqual(me.tableParams, oldTableParams)) {
        refreshView();
      }
      oldTableParams = _.clone(me.tableParams);
    });
  },

  methods: {
    setTableParams: function setTableParams() {
      var me = this;
      var form = me.$options.config.getForm();
      var config = me.$options.config.getConfig();
      var formValues = form.getValue();

      var businessId = this.$options.config.getData().businessId;
      if (!businessId) {
        businessId = formValues.id || this.$options.config.getData().tempBusinessId;
      }
      me.tableParams.initrelateid = businessId;

      var fieldObj = form.find(config.name);
      if (fieldObj && fieldObj.textMode !== undefined) {
        me.formConfig.formeditform = !fieldObj.textMode;
      } else if (fieldObj && fieldObj.readOnly === true) {
        me.formConfig.formeditform = false;
      } else {
        me.formConfig.formeditform = !form.isTextMode();
      }
      me.formValue.initrelateid = businessId;
      if (config.relatedField) {
        delete me.tableParams.initrelateid;
        _(config.relatedField).split(",").map(function (f) {return f.indexOf("|") ? f.split("|") : [f, f];}).
        each(function (pairs) {
          me.tableParams[pairs[0]] = formValues[pairs[1]];
          me.formValue[pairs[0]] = formValues[pairs[1]];
        });
      }
    },
    getToolbarTable: function getToolbarTable() {
      return this.getViewObject().mwRef("toolbarTable");
    },
    getViewObject: function getViewObject() {
      return this.$refs.view.$viewObj;
    } },


  destroyed: function destroyed() {

  } };

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =





{
  name: 'form-document-editor',
  data: function data() {
    var me = this;
    me.hasLoad = false;
    var buttons = [];
    var isShowToolbar = true;
    var editMode = !this.$options.config.getCurrentObject().isTextMode();

    if (editMode) {

    } else {

    }



















    var formObj = this.$options.config["$form"];
    if (!formObj && this.$options.config.getForm) {
      formObj = this.$options.config.getForm();
    }
    var fileName = this.$options.params.fileName || $lang("正文");

    var userNameObj = this.$options.config.expUser;
    var userName = "";
    if (userNameObj) {
      userName = userNameObj.name;
    }
    return {
      $model: undefined,
      modelStyle: '',
      title: fileName,
      showEditor: false,
      propObject: {
        params: {
          editmode: !this.$options.config.getCurrentObject().isTextMode() ? "1" : "0",
          efileType: "JOA_ZW",
          formConfig: this.$options.config.getConfig(),
          businessId: this.$options.params.businessId,
          formId: this.$options.params.formId,
          tempBusinessId: this.$options.params.tempBusinessId,
          step: "edit",
          fileName: fileName,
          saveFileType: "",
          pk_id: this.$options.params.businessId,
          yzEfileLinkId: [{ id: "testid" }],
          flowModuleId: this.$options.params.moduleId,
          isLoadFormData: false,
          opType: '1',
          showProgressBar: true,
          isNoCopy: true,
          isReadOnly: 0,
          isPubPDFBtn: false,
          isPrintZW: 0,
          operateType: '',
          userName: userName,
          userNameObj: userNameObj,
          option: this.$options },

        formData: this.$options.config.getFormValue(),
        docFormatObject: {},
        processActivity: "",

        getForm: function getForm() {
          return formObj;
        },
        efileLinkId: "",
        isNewEfileDoc: "",
        isReadOnly: "",
        joaCaoGaoId: "",
        joaHeGaoId: "",
        joaZenWenId: "",
        joaPDFId: "",
        isSaveDoc: true },

      buttons: buttons };

  },
  created: function created() {

  },
  mounted: function mounted() {

  },
  methods: {
    noticeButtonEvent: function noticeButtonEvent(name) {

      var me = this;
      if (me.mwRef('editor')) {
        me.mwRef('editor').noticeButtonEvent(name);
      }
    },

    getDocFormatObject: function getDocFormatObject() {var _this = this;
      var me = this;
      var formData = this.$options.config.getFormValue();
      me.propObject.processActivity = this.$options.config.getFormObject().activity;
      var attachMentList = formData['#items'];
      var joaCaoGaoId = "";
      var joaHeGaoId = "";
      var joaZenWenId = "";
      var joaPDFId = "";
      var joaOFDId = "";
      if (attachMentList && attachMentList.length > 0) {
        attachMentList.map(function (item, index, arr) {
          var itemType = item.type;
          var itemId = item.id;
          if (itemType == "JOA_CG" && item.mimeType != ".pdf") {
            joaCaoGaoId = itemId;
            me.propObject.joaCaoGaoId = joaCaoGaoId;
          }
          if (itemType == "JOA_HG" && item.mimeType != ".pdf") {
            joaHeGaoId = itemId;
            me.propObject.joaHeGaoId = joaHeGaoId;
          }
          if (itemType == "JOA_ZW" && item.mimeType != ".pdf") {
            joaZenWenId = itemId;
            me.propObject.joaZenWenId = joaZenWenId;
          }
          if (itemType == "JOA_ZW" && item.mimeType == ".pdf") {
            joaPDFId = itemId;
            me.propObject.joaPDFId = joaPDFId;
          }

          if (itemType == "JOA_ZW" && item.mimeType == ".ofd") {
            joaOFDId = itemId;
            me.propObject.joaOFDId = joaOFDId;
          }
        });
      }
      var efileLinkId = "";
      if (joaZenWenId) {
        efileLinkId = joaZenWenId;
      } else if (joaHeGaoId) {
        efileLinkId = joaHeGaoId;
      } else if (joaCaoGaoId) {
        efileLinkId = joaCaoGaoId;
      } else {
        efileLinkId = null;
      }

      var isEdit = !this.$options.config.getCurrentObject().isTextMode();
      if (isEdit) {
        me.propObject.efileLinkId = efileLinkId;
        if (!efileLinkId) {
          me.propObject.isNewEfileDoc = true;
        } else {
          me.propObject.isNewEfileDoc = false;
        }
        me.propObject.isReadOnly = false;

        var format = formData.formatid;
        if (!formData.hasOwnProperty("formatid")) {
          me.showEditor = true;
          return;
        }
        if (!format && !this.$options.config.getCurrentObject().isTextMode()) {
          alert($lang("请先选择发文格式！"));
          return;
        }
        this.mwApi.business.getDocumentFormat(format).then(function (r) {
          if (r && r.result) {
            var formatObject = _this.arrangeData(r.result);
            me.propObject.docFormatObject = formatObject;
            me.showEditor = true;
            me.hasLoad = true;

          } else {
            alert($lang("没有找到相应的发文格式，请联系管理员！"));
            return;
          }
        });
      } else {

        if (!efileLinkId) {
          alert($lang("该文件还没有生成正文，请先编辑正文！"));
          return;
        } else {
          me.propObject.efileLinkId = efileLinkId;
          me.propObject.isNewEfileDoc = false;
          me.propObject.isReadOnly = true;
          me.showEditor = true;
        }
      }
    },

    arrangeData: function arrangeData(d) {
      var formatObject = {};
      var docData = d.doc;
      if (docData) {
        formatObject.mouldFormId = "c3faaec06cfae727";
        formatObject.isTaoTouFirst = docData.fldttfs == "先套头" ? true : false;
        if (d.main) {
          formatObject.caoGaoDocId = d.main ? d.main.id : "";

          if (d.main["#items"] && d.main["#items"].length > 0) {
            formatObject.caoGaoMouldId = d.main["#items"][0].id;
          }
        }
        if (d.head) {
          formatObject.headDocId = d.head ? d.head.id : "";
          if (d.head["#items"] && d.head["#items"].length > 0) {
            formatObject.headMouldId = d.head["#items"][0].id;
          }
        }
        if (d.footer) {
          formatObject.tailDocId = d.footer ? d.footer.id : "";
          if (d.footer["#items"] && d.footer["#items"].length > 0) {
            formatObject.tailMouldId = d.footer["#items"][0].id;
          }
        }





        formatObject.fjLabelName = docData.fldfjsq;
        formatObject.htLabelName = docData.fldhtsq;
        formatObject.htLabelValue = docData.fldhtqz;
        formatObject.yzLabelName = docData.fldyzsq;
        formatObject.ffbmLabelName = docData.fldffbmsq;
        formatObject.ffbmLabelValue = docData.fldffbmqz;


        var arrJson = {};
        if (d.mainMark && d.mainMark.length > 0) {
          arrJson = this.arrList(d.mainMark, arrJson);
        }
        if (d.headMark && d.headMark.length > 0) {
          arrJson = this.arrList(d.headMark, arrJson);
        }
        if (d.footerMark && d.footerMark.length > 0) {
          arrJson = this.arrList(d.footerMark, arrJson);
        }
        formatObject.tmplListObject = arrJson;
      }
      return formatObject;
    },
    arrList: function arrList(objList, arrJson) {

      if (objList && objList.length > 0) {
        for (var i = 0; i < objList.length; i++) {
          var label = {};
          label.fldmc = objList[i].fldmc;
          label.fldqzfs = objList[i].fldqzfs;
          label.fldqz = objList[i].fldqz;
          label.fldxhbd = objList[i].fldxhbd;
          label.fldyjgs = objList[i].a1cc3bf8eefb6300;
          label.fldisnew = objList[i].fldfhzxyt;
          var nameKey = label.fldmc;
          arrJson[nameKey] = label;
        }
      }
      return arrJson;
    },
    dealWithEvent: function dealWithEvent(args) {
      var me = this;
      if (args && args.visible) {
        if (!me.hasLoad) {
          $(".v-modal").append($("<iframe width='100%' height=width='100%''></iframe>").css({
            width: '100%',
            height: '100%',
            border: '0px',
            position: "absolute" }));

          this.getDocFormatObject();
        }
      }
    } },

  destroyed: function destroyed() {

  } };

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);










































































































var _store_rt = __webpack_require__(142);var _store_rt2 = _interopRequireDefault(_store_rt);
var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  name: 'form-rel-file-selection',
  data: function data() {
    var me = this;
    var config = this.$options.config;
    var editMode = !config.getCurrentObject().isTextMode();
    return {
      editMode: editMode,
      api: 'business.listRelFile',
      defaultParams: {},
      tableData: [],
      attachColumns: [
      { type: 'selection' },
      { type: 'index' },
      { prop: 'moduleName', label: $lang('所属模块名'), width: '180' },
      { prop: 'fldtm', label: $lang('题名'), formatter: me.defaultTitleFormatter }],

      findColumns: [
      { type: 'selection' },
      { type: 'index' },
      { prop: 'fldtm', label: $lang('题名'), formatter: me.defaultTitleFormatter },
      { prop: 'createTime', label: $lang('拟稿时间'), width: '180' },
      { prop: 'fldbh', label: $lang('文号'), width: '120' },
      { prop: 'initusername', label: $lang('拟稿人'), width: '120' }],

      templateStyle: {
        height: 'auto' },


      showTable: true,
      startDate: '',
      finishDate: '',

      form: {
        createTime: 'period',
        searchRange: 'dept' },

      options: [],
      rules: {},
      footerButton: [
      { label: $lang('取消'), func: this.selectCancel, type: 'default' },
      { label: $lang('确定'), func: this.selectSure }],

      pickerBeginDateBefore: {
        disabledDate: function disabledDate(time) {

          if (me.form.finishDate != '') {
            return time.getTime() > me.form.finishDate;
          }

        } },


      pickerBeginDateAfter: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < me.form.startDate;
        } } };


  },

  store: _store_rt2.default,

  mounted: function mounted() {
    var me = this;
    this.defaultParams = { moduleId: this.$options.params.moduleId,
      docId: this.$options.params.businessId ? this.$options.params.businessId : '' };
  },
  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'expUser'])),



  methods: {
    selectSure: function selectSure() {var _this = this;
      var me = this;
      if (this.mwRef('findTable').getMultipleSelection().length > 0) {
        this.selectCancel();
        this.mwRef('findTable').getMultipleSelection().forEach(function (item) {
          var params = {
            docId: _this.$options.params.tempBusinessId ? _this.$options.params.tempBusinessId : _this.$options.params.businessId,
            docName: _this.$options.params.fldtm,
            moduleId: _this.$options.params.moduleId,
            relModuleId: item.moduleId,
            relDocId: item.id,
            relDocName: item.fldtm };
          _this.mwApi.business.saveRelLife(params).then(function (res) {
            if (res.success) {
              if (res.result === '已存在') {
                _this.mwMsg($lang('该关联文件已存在'));
              } else {
                _this.mwRef('relFileTable').refresh();
              }}
          });

        });
      } else {
        this.mwMsg('info', $lang('请选择你要关联的文件'));
      }
    },

    selectCancel: function selectCancel() {
      this.mwRef('relDialog').hide();
      this.mwRef('formName').resetFields();
    },

    search: function search() {var _this2 = this;

      if (this.form.titleLike) {
        if (!this.form.mixId) {
          this.mwMsg('info', $lang('请选择文件类型'));
        } else {
          var p = { start: 0, limit: 1000, mixId: this.form.mixId, filter: { fldtm: this.form.titleLike } };
          if (this.form.searchRange === 'dept') {
            if (this.expUser.dep.loginUnit) {
              p.unitFilter = this.expUser.dep.loginUnit.id;
            } else {
              p.unitFilter = this.expUser.dep.loginRootDept.id;
            }
          }
          var startDate = void 0,finishDate = void 0;
          if (this.form.createTime != 'shortcut') {
            if (this.form.startDate) {
              startDate = this.format(this.form.startDate, "yyyy-MM-dd HH:mm:ss");
            }
            if (this.form.finishDate) {
              var mat = {};
              mat.M = this.form.finishDate.getMonth() + 1;
              mat.M = this.check(mat.M);
              mat.Y = this.form.finishDate.getFullYear();
              mat.D = this.form.finishDate.getDate();
              mat.D = this.check(mat.D);
              finishDate = mat.Y + "-" + mat.M + "-" + mat.D + ' ' + '24:00:00';
            }
          } else
          {
            if (this.startDate) {
              startDate = this.format(this.startDate, "yyyy-MM-dd HH:mm:ss");
              finishDate = this.format(this.finishDate, "yyyy-MM-dd HH:mm:ss");
            }
          }
          if (startDate && finishDate) {
            p.customCondition = "createTime >= {ts '" + startDate + "'} and createTime <= {ts '" + finishDate + "'} ";
          } else
          if (!startDate && finishDate) {
            p.customCondition = "createTime <= {ts '" + finishDate + "'} ";
          } else if (!finishDate && startDate) {
            p.customCondition = "createTime >= {ts '" + startDate + "'} ";
          }
          this.mwApi.data.listDocData(p).then(function (res) {
            if (res.success) {
              if (res.result.length === 0) {
                _this2.mwMsg($lang('未查询到数据'));}
              _this2.tableData = res.result;
              _this2.mwRef('findTable').setData(_this2.tableData);
            }
          });
        }
      } else
      {
        this.mwMsg('info', $lang('请填写关键字'));
      }
    },
    showDialog: function showDialog() {
      this.mwRef('relDialog').show();
      var config = this.$options.config.getConfig();
      if (config.moduleName) {
        var formName = config.moduleName.split(',');
        var formId = config.moduleId.split(',');
        this.options = [];
        for (var i = 0; i < formId.length; i++) {
          this.options.push({
            value: formId[i],
            label: formName[i] });

        }
      }
    },

    deleteFile: function deleteFile() {var _this3 = this;
      if (this.mwRef('relFileTable').getMultipleSelection().length === 0) {
        this.mwMsg($lang('请选择你要删除的数据'));
      } else {
        this.$confirm($lang('确定要删除该关联文件?'), $lang('提示'), {
          confirmButtonText: $lang('确定'),
          cancelButtonText: $lang('取消'),
          type: 'warning' }).
        then(function () {

          var ids = [];
          _this3.mwRef('relFileTable').getMultipleSelection().forEach(function (item) {
            ids.push(item._id);
          });
          _this3.mwApi.business.delRelFile(ids).then(function (res) {
            if (res.success) {
              _this3.mwMsg($lang('删除成功'));
              _this3.mwRef('relFileTable').refresh();
            }
          });

        }).catch(function () {});

      }
    },
    defaultTitleFormatter: function defaultTitleFormatter(data) {var h = this.$createElement;
      var me = this;
      return h('span', { 'class': { 'link': true }, attrs: { title: data.fldtm }, on: { 'click': function click(event) {return me._showForm(data, event);} } }, [
        data.fldtm ? data.fldtm : $lang('无标题')]);

    },
    _showForm: function _showForm(row, event) {
      event.stopPropagation();
      var me = this,formId = row["#table"],businessId = row.id;
      me.mwApi.data.getFormData({ formId: formId, dataId: businessId }).then(function (data) {
        var p = {};
        p.businessId = businessId;
        p.moduleId = data.result.moduleId;
        p.appId = data.appId;
        p.editMode = false;
        p.formOpenSource = 'pc:rel-file-selection';
        PF.show('flowForm', p);
      });
    },













    handleTime: function handleTime(data) {
      if (data === 'week') {
        this.getDay(-7);
      } else if (data === 'month') {
        this.getMonthDay(-1);
      } else if (data === 'oneyear') {
        this.getMonthDay(-12);
      } else if (data === 'halfyear') {
        this.getMonthDay(-6);
      } else if (data === 'threeyear') {
        this.getMonthDay(-36);
      } else {
        this.getDay(-1);
      }
    },


    getDay: function getDay(days) {
      var today = new Date(),day = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * days;
      day.setTime(targetday_milliseconds);
      var mat = {};
      mat.M = day.getMonth() + 1;
      mat.Y = day.getFullYear();
      mat.D = day.getDate();
      mat.H = day.getHours();
      mat.mi = day.getMinutes();
      mat.S = day.getSeconds();
      var nowday = {};
      nowday.M = today.getMonth() + 1;
      nowday.Y = today.getFullYear();
      nowday.D = today.getDate();
      nowday.H = today.getHours();
      nowday.mi = today.getMinutes();
      nowday.S = today.getSeconds();
      this.startDate = new Date(mat.Y + "-" + mat.M + "-" + mat.D + ' ' + mat.H + ':' + mat.mi + ':' + mat.S);
      this.finishDate = new Date(nowday.Y + "-" + nowday.M + "-" + nowday.D + ' ' + nowday.H + ':' + nowday.mi + ':' + nowday.S);
    },

    getMonthDay: function getMonthDay(mon) {
      var nowdate = new Date();
      var today = new Date();
      nowdate.setMonth(nowdate.getMonth() + mon);
      var mat = {};
      mat.M = nowdate.getMonth() + 1;
      mat.Y = nowdate.getFullYear();
      mat.D = nowdate.getDate();
      mat.H = nowdate.getHours();
      mat.mi = nowdate.getMinutes();
      mat.S = nowdate.getSeconds();
      var day = {};
      day.M = today.getMonth() + 1;
      day.Y = today.getFullYear();
      day.D = today.getDate();
      day.H = today.getHours();
      day.mi = today.getMinutes();
      day.S = today.getSeconds();
      this.startDate = new Date(mat.Y + "-" + mat.M + "-" + mat.D + ' ' + mat.H + ':' + mat.mi + ':' + mat.S);
      this.finishDate = new Date(day.Y + "-" + day.M + "-" + day.D + ' ' + day.H + ':' + day.mi + ':' + day.S);
    },

    format: function format(date, str) {
      var mat = {};
      mat.M = date.getMonth() + 1;
      mat.H = date.getHours();
      mat.s = date.getSeconds();
      mat.m = date.getMinutes();
      mat.Y = date.getFullYear();
      mat.D = date.getDate();
      mat.d = date.getDay();
      mat.d = this.check(mat.d);
      mat.H = this.check(mat.H);
      mat.M = this.check(mat.M);
      mat.D = this.check(mat.D);
      mat.s = this.check(mat.s);
      mat.m = this.check(mat.m);

      if (str.indexOf(":") > -1) {
        return mat.Y + "-" + mat.M + "-" + mat.D + " " + mat.H + ":" + mat.m + ":" + mat.s;
      }
      if (str.indexOf("/") > -1) {
        return mat.Y + "-" + mat.M + "-" + mat.D + " " + mat.H + "/" + mat.m + "/" + mat.s;
      }
      if (str.indexOf("-") > -1) {
        return mat.Y + "-" + mat.M + "-" + mat.D + " " + mat.H + "-" + mat.m + "-" + mat.s;
      }
    },

    check: function check(str) {
      str = str.toString();
      if (str.length < 2) {
        str = '0' + str;
      }
      return str;
    } },

  destroyed: function destroyed() {

  } };

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =





{
  name: 'mw-userfiled-selection',
  props: {
    value: {
      type: String,
      default: '' },

    params: {
      type: Object,
      default: {} } },


  data: function data() {
    return {};


  },
  mounted: function mounted() {
    var me = this;
    $WR.ready(function (manager) {
      manager.create({
        xtype: 'UserFieldSelectionComp',
        isFormField: false },
      function (obj) {
        var pageData = obj.getPageData();
        pageData.params = me.params;
        var component = PF.createVue(pageData);
        $(me.$el).append(component.$mount().$el);
        component.$on("select", function (v) {
          me.$emit("select", v);
        });
        me.$obj = obj;
      });
    });
  },
  methods: {
    getValue: function getValue() {
      return this.$obj.getValue();
    } } };

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);



























































































































var _index = __webpack_require__(200);var _index2 = _interopRequireDefault(_index);
var _bpmTask = __webpack_require__(308);var bpmTaskApi = _interopRequireWildcard(_bpmTask);
var _selected = __webpack_require__(1052);var _selected2 = _interopRequireDefault(_selected);
var _lodash = __webpack_require__(98);var _lodash2 = _interopRequireDefault(_lodash);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  components: {
    MwCompleteSelectedTree: _selected2.default,
    MwCompleteTree: _index2.default },
  props: {
    params: {
      type: Object } },


  data: function data() {
    var me = this;
    var tipOptions = [];
    var tipCheckList = [];
    var tipContent = "";
    if (window.$Env && $Env.compleDialogLeftTipOptions) {
      tipOptions = $Env.compleDialogLeftTipOptions;
      _lodash2.default.each(tipOptions, function (v) {
        if (v.checked) tipCheckList.push(v.value);
      });
      var temp = $Env.compleDialogMsgTemplete || '您好！现有$$sender将"$$businessName"事项发给了您，请您抽时间处理。';
      tipContent = temp.replace('$$businessName', me.params.businessName || "").replace(new RegExp('\\$\\$sender', "gm"), PF.userInfo.initusername);
    }
    return {
      title: $lang('选择流向'),
      curFlowId: undefined,
      curFlowName: '',
      allFlow: [],
      normalFlow: [],
      subProcessFlow: [],
      circularFlow: [],
      isCommentExpaned: false,
      isAddAttention: false,
      customBottom: false,
      autoSelectData: false,
      hideAttention: false,
      allSelectTreeData: [],
      deptTreePanel: {},
      curTreePanel: undefined,
      customBottomComp: undefined,
      showCircular: false,
      showNormal: false,
      showSubProcess: false,
      tipCheckList: tipCheckList,
      tipContent: tipContent,
      tipOptions: tipOptions,
      commentId: '',
      comment: '',
      commentCategory: '',
      flowCount: 0,
      disabledComment: false,
      showSelectAllBtn: false,
      checkedSelectAll: false,
      isSubmitSingleFlow: false,
      footerButton: [
      {
        label: $lang("确定"),
        loading: false,
        func: me.submit },
      {
        label: $lang("关闭"),
        type: "default",
        func: me.close }] };


  },
  mounted: function mounted() {
    var me = this;
    var completeDialogBottomCompId = me.params.completeDialogBottomCompId;
    if (completeDialogBottomCompId) {
      me.customBottom = true;
      me.isCommentExpaned = true;
      me.customBottomComp = PF.createVue({
        template: "<mw-inner-page :pageId='pageId' noWrap :params='params'></mw-inner-page>",
        data: {
          pageId: completeDialogBottomCompId,
          params: me.params } });


    } else {
      if (window.localStorage) {
        me.isCommentExpaned = localStorage.getItem("flow.complete.isCommentExpaned") !== "0";
      }
      if (window.$Env && $Env.hideAttention) {
        me.hideAttention = true;
      }
    }





    this.init();
  },
  watch: {
    params: function params() {
      this.init();
    } },

  methods: {




    transFlowName: function transFlowName(name) {
      if (!name) return "";
      if (name.indexOf('-') > 0) {
        var arr = name.split('-');
        return $lang(arr[0]) + '-' + $lang(arr[1]);
      } else {
        return $lang(name);
      }
    },
    toggleCommentExpaned: function toggleCommentExpaned() {
      this.isCommentExpaned = !this.isCommentExpaned;
      if (window.localStorage) localStorage.setItem("flow.complete.isCommentExpaned", this.isCommentExpaned ? "1" : "0");
    },
    setBtnLoading: function setBtnLoading(loading, idx) {
      if (!loading && this.params.secondfunc && this.isSubmitSingleFlow) this.params.secondfunc();
      this.footerButton[idx].loading = loading;
    },
    editMsg: function editMsg() {var _this = this;
      this.$prompt('', $lang('编辑提醒内容'), {
        confirmButtonText: $lang('确定'),
        cancelButtonText: $lang('取消'),
        inputType: "textarea",
        customClass: 'prompt-dialog-big-input',
        inputPattern: /\S+/,
        inputValue: this.tipContent,
        inputPlaceholder: $lang("请输入提醒内容"),
        inputErrorMessage: $lang("请输入提醒内容") }).
      then(function (_ref) {var value = _ref.value;
        _this.tipContent = value;
      }).catch(function () {

      });
    },
    submit: _lodash2.default.debounce(function () {
      var me = this;
      me._submit();
    }, 1000, {
      'leading': true,
      'trailing': false }),


    _submit: function _submit() {
      var me = this;
      if (!me.showSubProcess && !me.showNormal) {
        PF.message("info", $lang("未获取到符合条件的流向信息"));
        return;
      }
      me.setBtnLoading(true, 0);
      function doCommit(params) {
        if (me.params.fullAuthType) {
          params.fullAuthType = me.params.fullAuthType;
        }
        me.mwApi.process.batchCommit(params).then(function (res) {
          var data = res.result;
          if (data && !data.success) {
            if (data.errorType == 'comment') {
              if (data.errorCode == 'comment_check_stop') {
                PF.message('info', $lang('您还没有填写意见,请填写意见'));
                me.setBtnLoading(false, 0);
                return;
              } else if (data.errorCode == 'comment_check_remind') {
                PF.confirm($lang('您还没有填写意见,您确认是要继续完成？'), $lang('提示'), { type: 'warning' }).then(function () {
                  params['$directSave'] = true;
                  doCommit(params);
                }).catch(function () {
                  me.setBtnLoading(false, 0);
                });
                return;
              }
            } else {
              me.setBtnLoading(false, 0);
              var errorMsg = '';
              if (data.errorMsg) {
                errorMsg = '[错误信息:' + data.errorMsg + ']';
              }
              PF.message('info', '完成失败' + errorMsg + '!');
              return;
            }
          } else {
            me.close();
            me.formActionComplete(params, res);
            me.setBtnLoading(false, 0);
          }
        }).catch(function () {
          me.setBtnLoading(false, 0);
        });
      }

      if (me.allSelectTreeData.length == 0 && me.curFlowId != undefined) {

        var flowData = undefined;
        me.allFlow.map(function (v) {
          if (v.id == me.curFlowId) {
            flowData = v;
          }
        });

        if (flowData.activityId == 'end') {
          var params = {};
          params.type = "complete";
          params.isAddAttention = me.isAddAttention;
          params.taskId = me.params.taskId;
          params.appId = me.params.appId;
          params.formId = me.params.formId;
          params.formKey = me.params.formKey;
          params.entityId = me.params.entityId;
          params.businessId = me.params.businessId;
          params.activities = [{ flowId: flowData.id, activityId: flowData.activityId }];

          if (me.comment) {
            params.$comment = [{ id: me.commentId, content: me.comment, category: me.commentCategory }];
          }
          params.formOpenSource = me.params.formOpenSource;
          doCommit(params);
        } else {
          me.setBtnLoading(false, 0);
          PF.message("info", $lang("请先选择办理人员或者部门!"));
        }
      } else {
        var activities = [];
        me.allSelectTreeData.map(function (v) {
          var activity = {};
          activity.flowId = v.id;
          activity.activityId = v.activityId;
          activity.type = v.category;
          activity.options = v.options;
          var items = [];

          var options = v.options;

          if (options && options.activityUnit == 'group') {
            v.children.map(function (d) {
              if (d.identities.length > 0) {
                var item = {};
                item.group = d.originalId;
                d.identities.map(function (i) {
                  if (i.type == 'U') {
                    if (!item.users) {
                      item.users = [];
                    }
                    if (i.id.indexOf("_") > -1) {
                      item.users.push({ id: i.id.split("_")[1] });
                    } else {
                      item.users.push({ id: i.id });
                    }
                  } else {
                    if (!item.identities) {
                      item.identities = [];
                    }
                    item.identities.push({ id: i.id });
                  }
                });
                items.push(item);
              } else {

















                var item = {};
                item.group = d.parentId;
                if (d.originalId.indexOf("_") > -1) {
                  item.users = [{ id: d.originalId.split("_")[1] }];
                } else {
                  item.users = [{ id: d.originalId }];
                }
                items.push(item);



              }
            });
          } else {
            v.children.map(function (d) {
              var item = {};
              if (d.identities.length > 0) {
                item.group = d.originalId;
                d.identities.map(function (i) {
                  if (i.type == 'U') {
                    if (!item.users) {
                      item.users = [];
                    }
                    if (i.id.indexOf("_") > -1) {
                      item.users.push({ id: i.id.split("_")[1] });
                    } else {
                      item.users.push({ id: i.id });
                    }
                  } else {
                    if (!item.identities) {
                      item.identities = [];
                    }
                    item.identities.push({ id: i.id });
                  }
                });
              } else {
                if (v.options.singleDepartmentRecord === "true") {
                  item = items.filter(function (it) {return it.group === d.parentId;})[0];
                  if (!item) {
                    item = {
                      group: d.parentId,
                      users: [] };

                  }
                  item.users.push({ id: d.originalId.split("_").pop() });
                } else {
                  item.group = d.parentId;

                  if (d.originalId.indexOf("_") > -1) {
                    item.users = [{ id: d.originalId.split("_")[1] }];
                  } else {
                    item.users = [{ id: d.originalId }];
                  }
                }
              }
              if (items.indexOf(item) < 0) items.push(item);
            });
          }
          activity.items = items;
          activities.push(activity);
        });
        var params = {};
        params.type = "complete";
        params.isAddAttention = me.isAddAttention;
        params.reminders = me.tipCheckList.join(",");
        params.tipContent = me.tipContent;
        params.taskId = me.params.taskId;
        params.appId = me.params.appId;
        params.formId = me.params.formId;
        params.formKey = me.params.formKey;
        params.entityId = me.params.entityId;
        params.businessId = me.params.businessId;
        params.activities = activities;
        if (me.comment) {
          params.$comment = [{ id: me.commentId, content: me.comment, category: me.commentCategory }];
        }
        params.formOpenSource = me.params.formOpenSource;
        if (_lodash2.default.isFunction(me.params.beforedocomplete)) {
          if (me.params.beforedocomplete.call(me, params, function () {doCommit(params);}) === false)
          return;
        }
        doCommit(params);
      }
    },
    selectClick: function selectClick() {
      var me = this;
      var hide = true;
      var flowData = undefined;
      me.allFlow.map(function (v) {
        if (v.id == me.curFlowId) {
          flowData = v;
        }
      });












      var data = me.$refs["tree" + me.curFlowId][0].getSelectNodes();

      data.map(function (v) {
        me.dblClick(v, v.parentId);
      });
    },
    deselectClick: function deselectClick() {
      var me = this;
      var tree = me.mwRef('selectedTree');
      var nodes = tree.getSelected();
      if (!nodes) return;
      nodes.forEach(function (n) {
        if (n.type) tree.dblClickNodeId(n.id);
      });
    },
    dblClick: function dblClick(data, parentId, callback) {
      var me = this;
      var flowData = undefined;
      me.allFlow.map(function (v) {
        if (v.id == me.curFlowId) {
          flowData = v;
        }
      });

      var selectFlowData = undefined;
      me.allSelectTreeData.map(function (v) {
        if (v.id == me.curFlowId) {
          selectFlowData = v;
        }
      });

      if (!flowData.options.multipleUnit) {
        if (selectFlowData) {
          me.mwRef('selectedTree').dblClickNodeId(selectFlowData.id);
          selectFlowData = undefined;
        }
      }
      if (callback)
      callback();
      if (selectFlowData) {

        selectFlowData.children.push({ id: data.id + "|" + parentId + "|" + selectFlowData.id, originalId: data.id, flowId: selectFlowData.id, parentId: parentId, text: data.name, children: false, type: 'file', identities: data.identities ? data.identities : [] });
      } else {
        var node = (0, _assign2.default)({ state: { opened: true } }, flowData);
        node.category = flowData.type;
        node.text = me.transFlowName(flowData.name);
        delete node.type;

        node.children = [

        { id: data.id + "|" + parentId + "|" + flowData.id, originalId: data.id, flowId: flowData.id, parentId: parentId, text: node.activityName && node.activityName == '结束' ? '结束' : data.name, type: 'file', children: false, identities: data.identities ? data.identities : [] }];

        me.allSelectTreeData.push(node);
      }
      me._validDisable();

      var normalSelect = [];
      me.allSelectTreeData.forEach(function (v) {
        if (v.category == 'normal') {
          normalSelect.push(v);
        }
      });
      if (normalSelect.length > 1) {
        normalSelect.forEach(function (v) {
          if (v.id != me.curFlowId) {
            for (var i = 0; i < me.allSelectTreeData.length; i++) {
              if (me.allSelectTreeData[i].id == v.id) {
                me.dblClickSelected(me.allSelectTreeData[i]);
                break;
              }
            }
          }
        });
      }
      me.mwRef('selectedTree').refreshData(me.allSelectTreeData);
    },
    selectAll: function selectAll() {
      var me = this;
      var checkedSelectAll = me.checkedSelectAll;
      if (checkedSelectAll && checkedSelectAll == true && me.curFlowId != undefined) {
        var tree = me.mwRef("tree" + me.curFlowId)[0];
        if (tree) $(tree.$el.querySelector('.mw-tree')).jstree("select_all");
      } else if (checkedSelectAll == false && me.curFlowId != undefined) {
        var tree = me.mwRef("tree" + me.curFlowId)[0];
        if (tree) $(tree.$el.querySelector('.mw-tree')).jstree("deselect_all");
      }
    },
    _showSelectAllBtn: function _showSelectAllBtn(conf) {
      var me = this;
      if (conf.type == "startSubProcess" && conf.options && conf.options.sendUnit == "DEP" && !window.$Env.hideProcessSelectAllBtn) {
        me.showSelectAllBtn = true;
      } else {
        me.showSelectAllBtn = false;
      }
    },
    _validDisable: function _validDisable() {
      var me = this;
      if (me.normalFlow.length > 0 && me.subProcessFlow.length > 0) {
        var waits = [];
        me.subProcessFlow.forEach(function (v) {
          if ('1' == v.options.waitComplete) {
            waits.push(v);
          }
        });
        if (waits.length > 0) {
          var normal = false;
          var startSubProcess = false;
          for (var i = 0; i < me.allSelectTreeData.length; i++) {
            var v = me.allSelectTreeData[i];
            if (v.category == 'normal') {
              normal = true;
              break;
            }
            if (v.category == 'startSubProcess' && '1' == v.options.waitComplete) {
              startSubProcess = true;
              break;
            }
          }
          if (normal) {
            me.normalFlow.forEach(function (v) {
              v.$disabled = false;
            });
            waits.forEach(function (v) {
              v.$disabled = true;
            });
          } else if (startSubProcess) {
            me.normalFlow.forEach(function (v) {
              v.$disabled = true;
            });
            waits.forEach(function (v) {
              v.$disabled = false;
            });
          } else {
            me.normalFlow.forEach(function (v) {
              v.$disabled = false;
            });
            waits.forEach(function (v) {
              v.$disabled = false;
            });
          }
        }
      }
    },

    dblClickSelected: function dblClickSelected(data, el) {
      var me = this;
      if (data.type) {

        me.mwRef('tree' + data.flowId)[0].showNode(data.originalId);

        var selectFlowData = undefined;
        var idx = -1;
        me.allSelectTreeData.map(function (v, d) {
          if (v.id == data.flowId) {
            selectFlowData = v;
            idx = d;
          }
        });
        var sIdx = -1;
        selectFlowData.children.map(function (v, d) {

          if (data.originalId == v.originalId) {
            sIdx = d;
          }
        });
        me.allSelectTreeData[idx].children.splice(sIdx, 1);

      } else {
        var _selectFlowData = undefined;
        var _idx = -1;
        me.allSelectTreeData.map(function (v, d) {
          if (v.id == data.id) {
            _selectFlowData = v;
            _idx = d;
          }
        });
        _selectFlowData.children.map(function (v) {
          me.$refs["tree" + v.flowId][0].showNode(v.originalId);

        });
        me.allSelectTreeData.splice(_idx, 1);
      }
      me._validDisable();
    },
    flowClick: function flowClick(conf, event, type) {
      var me = this;
      var flowData = undefined;
      me.allFlow.map(function (v) {
        if (v.id == conf.id) {
          flowData = v;
        }
      });
      if (flowData.$disabled) {
        return;
      }
      me.curFlowId = conf.id;
      me.curFlowName = conf.name;
      me._showSelectAllBtn(conf);
      me.loadFlowDeptUser(flowData);
    },

    init: function init() {
      var me = this;
      if (me.params.comment && me.params.comment.length > 0) {
        me.comment = me.params.comment[0].content;
        me.commentId = me.params.comment[0].id;
        me.commentCategory = me.params.comment[0].category;
      } else {
        me.commentId = $uuid();
        me.comment = '';
        me.commentCategory = me.params.activity.commentCategory;
      }

      bpmTaskApi.getTaskFlow({ taskId: me.params.taskId }).
      then(function (data) {
        if (data.length == 0) {
          return;
        } else {var





















































          findDefaultSelectFlow = function findDefaultSelectFlow() {
            var activity = me.params.defaultSelectActivity;
            var isMatch = function isMatch(o) {return o.id === activity || o.name === activity || o.activityId === activity || o.activityName === activity;};
            return _lodash2.default.find(normal, isMatch) || _lodash2.default.find(subProcess, isMatch) || normal[0] || subProcess[0];
          };var

          _handleSubProcess = function _handleSubProcess() {
            var defaultSelectFlow = findDefaultSelectFlow();
            if (subProcess.length > 0) {
              me.showSubProcess = true;
              me.subProcessFlow = subProcess;
            }
            if (!me.curFlowId) {
              me.curFlowId = defaultSelectFlow.id;
              me.curFlowName = defaultSelectFlow.name;
              me._showSelectAllBtn(defaultSelectFlow);
              me.loadFlowDeptUser(defaultSelectFlow);
            }
            me.flowCount = subProcess.length + normal.length;
            me.autoSelCandidate(defaultSelectFlow);
            me.show();
          };var normal = [];var subProcess = [];data.map(function (d) {if (d.type === 'normal') {normal.push(d);} else if (d.type === 'startSubProcess') {subProcess.push(d);}me.allFlow.push(d);});if (normal.length > 0) {me.normalFlow = normal;me.showNormal = true;if (normal.length === 1 && subProcess.length === 0 && !me.showCircular && (!me.params.activity || me.params.activity.densityNode != "1")) {PF.api.data.getSysFormDic().then(function (res) {if (res.success && res.result && res.result.flowOneShowCompleteDilog === '0') {$.ajax({ url: "/rest/process/task/flow/" + me.params.taskId + "/" + normal[0].id + "?returnTree=undefined", success: function success(d) {function isSingleFlow(tree) {if (!tree || tree.length !== 1) return false;if (!tree[0].children || tree[0].children.length === 0) {return !tree[0].hasChild;} else {return isSingleFlow(tree[0].children);}}if (isSingleFlow(d)) {me.submitSingleFlow(normal[0], d);} else {_handleSubProcess();}} });} else {_handleSubProcess();}});} else {_handleSubProcess();}} else {_handleSubProcess();}
        }
        return data;
      });
      var activity = me.params.activity;

      if (activity && activity.circularSwitch == 1) {
        var flowData = {};
        flowData.id = activity.id;
        flowData.activityId = activity.id;
        flowData.name = $lang("传阅人员");
        flowData.type = "circular";
        var options = {};
        options.multipleUnit = true;
        flowData.options = options;
        var circular = [];
        circular.push(flowData);
        me.circularFlow = circular;
        me.showCircular = true;
        me.allFlow.push(flowData);
      }
    },
    autoSelCandidate: function autoSelCandidate(flow) {
      var me = this;

      if (me.flowCount == 1) {
        if (flow.options.groupType == 'biz' || flow.options.userType == 'biz') {
          me.autoSelectData = true;
        }
      }
    },
    submitSingleFlow: function submitSingleFlow(flowData, data) {
      var me = this;
      function getDeepNode(node, parent) {
        if (!node || !node.children) return { node: node, parent: parent };
        return getDeepNode(node.children[0], node);
      }

      var obj = getDeepNode(data[0]);
      data = obj.node;
      var parentId = obj.parent && obj.parent.id;
      var node = (0, _assign2.default)({ state: { opened: true } }, flowData);
      node.category = flowData.type;
      node.text = flowData.name;
      delete node.type;
      node.children = [{
        id: data.id + "|" + parentId + "|" + flowData.id,
        originalId: data.id,
        flowId: flowData.id,
        parentId: parentId,
        text: data.name,
        type: 'file',
        children: false,
        identities: data.identities || [] }];

      me.allSelectTreeData.push(node);
      me.isSubmitSingleFlow = true;
      me.submit();
    },
    loadFlowDeptUser: function loadFlowDeptUser(conf, rootData) {
      var me = this;

      var flowId = conf.id.replace(/-/g, '_');

      if (me.curTreePanel) {
        me.curTreePanel.vshow = false;
      }

      if (!me.deptTreePanel[flowId]) {
        var multiple = conf.options.multipleUnit;
        var o = void 0;
        if (conf.type != 'circular') {
          o = { vshow: true, rootData: rootData, activityId: conf.activityId, type: conf.type, vif: true, url: "/rest/process/task/flow/" + me.params.taskId + "/" + conf.id, multiple: multiple, defaultParams: { returnTree: conf.options.returnTree } };
        } else {
          o = { vshow: true, rootData: rootData, activityId: conf.activityId, type: conf.type, vif: true, url: "/rest/process/task/circular/" + me.params.taskId, multiple: multiple };
        }
        this.$set(me.deptTreePanel, flowId, o);
      } else {
        me.deptTreePanel[flowId].vshow = true;
      }

      me.curTreePanel = me.deptTreePanel[flowId];

    },

    getTitle: function getTitle(title) {
      this.title = title;
    },
    beforeClose: function beforeClose(done) {
      var me = this;

      if (me.params.secondfunc) {
        me.params.secondfunc();
      }
      me.resetForm();
      done();


    },
    resetForm: function resetForm() {
      var me = this;
      this.curFlowId = undefined;
      this.curFlowName = '';
      this.allFlow = [];
      this.normalFlow = [];
      this.subProcessFlow = [];
      this.circularFlow = [];
      this.allSelectTreeData = [];
      this.deptTreePanel = {};
      this.curTreePanel = undefined;
      this.showCircular = false;
      this.showNormal = false;
      this.showSubProcess = false;
      this.flowCount = 0;
      this.commentId = '';
      this.comment = '';
      this.commentCategory = '';

      if (me.mwRef('selectedTree')) me.mwRef('selectedTree').refreshData(me.allSelectTreeData);
    },

    formActionComplete: function formActionComplete(params, res) {
      var me = this;
      if (me.params.func) {
        me.params.func(params, res);
      }
      this.resetForm();
    },

    show: function show() {
      var me = this;
      if (_lodash2.default.isFunction(me.params.beforeshowdialog)) {
        if (me.params.beforeshowdialog.call(me) === false)
        return;
      }
      me.mwRef('dialog').show();
      if (me.customBottom && me.customBottomComp) {
        me.$nextTick(function () {
          $(me.$refs.customBottom.$el).html(me.customBottomComp.$mount().$el);
        });
      }
    },
    close: function close() {var _this2 = this;
      this.resetForm();
      this.beforeClose(function (o) {
        if (_this2.mwRef('dialog')) _this2.mwRef('dialog').hide();
      });
    } } };

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =
















{

  name: 'MwCompleteSelectedTree',
  props: {
    search: {
      type: Boolean,
      default: false },


    autoLoad: {
      type: Boolean,
      default: true },


    defaultParentId: {
      type: String },


    defaultParams: {
      type: Object },


    url: {
      type: String },


    expandedFirst: {
      type: Boolean,
      default: false },


    async: {
      type: Boolean,
      default: false },


    multiple: {
      type: Boolean,
      default: false },

    singleLeaf: {
      type: Boolean,
      default: false },


    multipleLeaf: {
      type: Boolean,
      default: false },

    contextMenuItem: {
      type: Array,
      default: function _default() {
        return [];
      } },


    checkNodes: {
      type: Array,
      default: function _default() {
        return [];
      } },


    selectNode: {
      type: String,
      default: '' },


    treeData: {
      type: [Array, Object] } },


  data: function data() {
    return {
      searchFlag: false,
      searchText: '',
      selectData: {},
      selectParents: [],

      dblClick: false,
      select: false,
      deselect: false,
      check: false };

  },
  watch: {
    checkNodes: function checkNodes(newIds) {
      var me = this;
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.uncheck_all();
      newIds.forEach(function (id) {
        var obj = inst.get_node(id);
        inst.check_node(obj);
      });
    },
    selectNode: function selectNode(newId) {
      var me = this;
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.deselect_all();
      if (newId) {
        var obj = inst.get_node(newId);
        inst.select_node(obj);
      }
    },
    searchText: function searchText(val) {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (val == '') {
        setTimeout(function () {
          tree.clear_search();
        }, 250);
      } else {
        if (this.searchFlag) {
          clearTimeout(this.searchFlag);
        }
        this.searchFlag = setTimeout(function () {
          tree.search(val, true, true);
        }, 250);
      }
    },
    url: function url(val) {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (tree) {
        tree.destroy();
      }
      this.renderTree();
    } },

  mounted: function mounted() {
    if (this.autoLoad) {
      this.renderTree();
    }
  },
  destroyed: function destroyed() {
    var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
    if (tree) {
      tree.destroy();
    }
  },
  methods: {
    checkAll: function checkAll() {
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.select_all();
    },
    unCheckAll: function unCheckAll() {
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.deselect_all();
    },
    openAll: function openAll() {
      $(this.$el.querySelector('.mw-tree')).jstree('open_all');
    },
    closeAll: function closeAll() {
      $(this.$el.querySelector('.mw-tree')).jstree('close_all');
    },
    refresh: function refresh() {
      $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
    },
    refreshData: function refreshData(data) {
      if (!$(this.$el.querySelector('.mw-tree')).jstree(true)) {
        this.renderTree();
      } else {
        $(this.$el.querySelector('.mw-tree')).jstree(true).settings.core.data = data;
        $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
      }
    },
    dblClickNodeId: function dblClickNodeId(id) {
      var me = this,jsTreeEl = $(me.$el.querySelector('.mw-tree'));
      var obj = jsTreeEl.jstree(true).get_node(id);
      me.dblClick = true;
      if (obj) {
        if (obj.original.type) {
          var parentId = jsTreeEl.jstree(true).get_parent(obj);
          var parentObj = jsTreeEl.jstree(true).get_node(parentId);
          if (parentObj.children.length == 1) {
            jsTreeEl.jstree(true).delete_node(parentObj);
            me.$emit("dblClick", parentObj.original, jsTreeEl);
          } else {
            jsTreeEl.jstree(true).delete_node(obj);
            me.$emit("dblClick", obj.original, jsTreeEl);
          }
        } else {
          jsTreeEl.jstree(true).delete_node(obj);
          me.$emit("dblClick", obj.original, jsTreeEl);
        }
      }
      me.dblClick = false;
    },
    changeTreeData: function changeTreeData(data) {var _this = this;

      data.forEach(function (d) {
        if (!d.text) {
          if (d.name)
          d.text = d.name;
        }
        if (d.children) {
          if (!d.hasChild) {
            d.hasChild = d.children.length;
          }
          if (d.children.length > 0) {
            _this.changeTreeData(d.children);
          } else {
            d.type = 'file';
          }
        } else {
          d.children = false;
          d.hasChild = 0;

          d.type = 'file';

        }

        if (d.hasChild > 0) {
          if (me.multiple && me.multipleLeaf) {
            d.state = { "disabled": true };
          }
        }

      });
    },
    getInstance: function getInstance() {
      var me = this;
      return $(me.$el.querySelector('.mw-tree')).jsTree(true);
    },
    showNode: function showNode(id) {
      var me = this;
      var obj = $(me.$el.querySelector('.mw-tree')).jsTree(true).get_node(id);
      $(me.$el.querySelector('.mw-tree')).jsTree(true).show_node(obj);
    },

    getSelected: function getSelected() {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      var selected = tree.get_selected();
      var data = [];
      if (this.multiple) {
        if (selected.length > 0) {
          data = [];
          selected.forEach(function (id) {
            data.push(tree.get_node(id).original);
          });
        }
      } else {
        if (selected.length > 0) {
          data = tree.get_node(selected[0]).original;
        }
      }
      return data;
    },

    renderTree: function renderTree() {
      var me = this,jsTreeEl = $(me.$el.querySelector('.mw-tree'));
      var plugin = ["types"];
      var items = {};
      if (me.multiple) {
        plugin.push("checkbox");
        plugin.push("wholerow");
      } else {
        plugin.push("wholerow");
      }
      if (me.search) {
        plugin.push("search");
      }
      if (me.contextMenuItem.length > 0) {
        plugin.push("contextmenu");
        me.contextMenuItem.forEach(function (item) {
          items[item.name] = {
            "name": item.name ? item.name : '',
            "label": item.label,
            "icon": item.icon ? item.icon : '',
            "action": function action(a) {
              item.func(me.selectData, me.selectParents);
            } };

        });
      }
      var data = {};
      if (me.treeData) {
        data = me.treeData;
      }

      jsTreeEl.data('jstree', false).empty();
      jsTreeEl.bind("load_node.jstree", function (e, data) {

















      }).on("changed.jstree", function (e, data) {
      }).bind("loaded.jstree", function (e, data) {

      }).bind("click.jstree", function (e) {

      }).bind("dblclick.jstree", function (e) {
        var id = e.target.id.substr(0, e.target.id.lastIndexOf('_'));
        me.dblClickNodeId(id);
      }).bind("check_node.jstree", function (e, data) {

      }).bind("select_node.jstree", function (e, data) {


      }).bind("deselect_node.jstree", function (e, data) {

      }).jstree({
        'async': me.async,
        'expanded_first': false,
        'core': {
          "themes": {
            "responsive": false },

          "multiple": me.multiple,
          "check_callback": function check_callback(operation, node, node_parent, node_position, more) {
            return true;
          },
          'data': data },


        'checkbox': {
          "keep_selected_style": false,
          "three_state": true,
          "visible": true,
          "tie_selection": true },

        "plugins": plugin,
        "contextmenu": {
          "items": items },

        "types": {
          "#": {
            "icon": "fa fa-folder" },

          "file": {
            "icon": "fa fa-leaf" },

          "default": {
            "icon": "fa fa-folder" } } });



    } } };

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =







{
  props: {
    params: {
      type: Object } },


  data: function data() {
    var me = this;
    return {
      title: $lang('选择退回节点'),

      api: 'process.getCanRejectTo',
      defaultParams: {},
      columns: [
      { prop: 'name', tooltip: true, label: $lang('可发至任务'), formatter: me.formatter }],

      footerButton: [
      {
        label: $lang("关闭"),
        type: "default",
        func: me.close },

      {
        label: $lang("确定"),
        func: me.submit }] };



  },
  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
    this.init();
  },
  watch: {
    params: function params() {
      this.init();
    } },

  methods: {
    setBtnLoading: function setBtnLoading(loading, idx) {
      this.footerButton[idx].loading = loading;
    },
    dataLoaded: function dataLoaded(data) {
      var me = this;

      if (data && data.length == 1) {
        var rejectTable = me.$refs.rejectTable;
        rejectTable.$refs.multipleTable.setCurrentRow(data[0]);
        if (rejectTable.multipleSelection.length === 0) {
          rejectTable.multipleSelection.push(data[0]);
        }
      }
    },
    btnDebounce: _.debounce(function (callback) {
      var me = this;
      if (callback) {
        callback();
      }
    }, 1000, {
      'leading': true,
      'trailing': false }),

    formatter: function formatter(data) {var h = this.$createElement;
      var isEnglish = window.$currentBrowserLanguage === 'en';
      var englishName = data.Englishname || data.assigneeName;
      return h('span', [$lang(data.name), '--', isEnglish ? englishName : data.assigneeName, ' ']);
    },
    submit: function submit() {
      var me = this;
      me.btnDebounce(function () {
        me.setBtnLoading(true, 1);
        var selected = me.mwRef('rejectTable').getMultipleSelection();
        if (selected.length == 0) {
          me.setBtnLoading(false, 1);
          me.mwMsg('info', $lang('请选择退回的节点'));
          return;
        }
        var params = {};
        params.type = "reject";
        params.taskId = me.params.taskId;
        params.appId = me.params.appId;
        params.formId = me.params.formId;params.formKey = me.params.formKey;
        if (me.params.comment) {
          params['$comment'] = me.params.comment;
        }
        params.targetTaskId = selected[0].id;
        function doReject(params) {
          if (me.params.fullAuthType) {
            params.fullAuthType = me.params.fullAuthType;
          }
          me.mwApi.process.reject(params).then(function (res) {
            var data = res.result;
            if (data && !data.success) {
              if (data.errorType == 'comment') {
                if (data.errorCode == 'comment_check_stop') {
                  me.mwMsg('info', $lang('您还没有填写意见,请填写意见!'));
                  me.setBtnLoading(false, 1);
                  return;
                } else if (data.errorCode == 'comment_check_remind') {
                  me.mwConfirm($lang('您还没有填写意见,您确认是要继续退回？'), $lang('提示'), { type: 'warning' }).then(function () {
                    params['$directSave'] = true;
                    doReject(params);
                  }).catch(function () {
                    me.setBtnLoading(false, 1);
                  });
                  return;
                }
              } else {
                var errorMsg = '';
                if (data.errorMsg) {
                  errorMsg = '[' + $lang('错误信息') + ':' + data.errorMsg + ']';
                }
                me.mwMsg('info', $lang('退回失败') + errorMsg + '!');
                me.setBtnLoading(false, 1);
                return;
              }
            } else {
              if (me.params.formObj) {
                if (me.params.formObj.fireEvent("afterReject", me) === false)
                return;
              }
              me.close();
              me.formActionComplete();
              me.setBtnLoading(false, 1);
            }
          }).catch(function () {
            me.setBtnLoading(false, 1);
          });
        }
        doReject(params);
      });
    },
    init: function init() {
      this.defaultParams = { taskId: this.params.taskId };
    },
    beforeClose: function beforeClose(done) {
      var me = this;

      if (me.params.secondfunc) {
        me.params.secondfunc();
      }
      me.resetForm();
      done();


    },
    resetForm: function resetForm() {
      var me = this;

    },

    formActionComplete: function formActionComplete() {
      var me = this;
      if (me.params.func) {
        me.params.func();
      }
      this.resetForm();
    },

    show: function show() {
      this.mwRef('dialog').show();
    },
    close: function close() {
      this.resetForm();
      this.mwRef('dialog').hide();
    } } };

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =











{
  props: {
    params: {
      type: Object } },


  data: function data() {
    return {
      userTreeUrl: this.mwUrl('/api/process/getTransmitObject'),
      defaultParams: {},
      aliasId: 'departmentId',
      userFooterButton: [
      { label: $lang('取消'), func: this.selectUserCancel, type: 'default' },
      { label: $lang('确定'), func: this.selectUserSure }] };


  },

  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
    this.init();
  },
  watch: {
    params: function params() {
      this.init();
    } },

  methods: {
    setBtnLoading: function setBtnLoading(loading, idx) {
      this.userFooterButton[idx].loading = loading;
    },
    btnDebounce: _.debounce(function (callback) {
      var me = this;
      if (callback) {
        callback();
      }
    }, 1000, {
      'leading': true,
      'trailing': false }),


    selectUserSure: function selectUserSure() {
      var me = this;
      me.btnDebounce(function () {
        me.setBtnLoading(true, 1);
        var data = me.mwRef('userTree').getSelected();
        if (data.length < 1) {
          me.mwMsg('info', $lang('请选择用户！'));
          me.setBtnLoading(false, 1);
          return;
        }
        var params = {};
        params.receiver = {
          id: data.id,
          name: data.name,
          deptId: data.parentId };

        me.params.func(params);
        me.selectUserCancel();
        me.setBtnLoading(false, 1);
      });
    },

    selectUserCancel: function selectUserCancel() {
      this.mwRef('dialog').hide();
    },
    init: function init() {
      this.defaultParams = { taskId: this.params.taskId };
    },
    resetForm: function resetForm() {
      var me = this;

    },
    formActionComplete: function formActionComplete() {
      var me = this;
      if (me.params.func) {
        me.params.func();
      }
      this.resetForm();
    },
    loadedTree: function loadedTree(inst) {
      var children = inst.get_node("#").children;
      if (children && children.length > 0) {
        var firstNode = inst.get_node(children[0]);
        if (firstNode && firstNode.original && firstNode.original.flag != "1") {
          inst.open_all();
        }
      }
    },
    show: function show() {
      this.mwRef('dialog').show();
    },
    close: function close() {
      this.resetForm();
      this.mwRef('dialog').hide();
    } } };

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);

















































var _li = __webpack_require__(115);var _li2 = _interopRequireDefault(_li);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  components: {
    MwLiTree: _li2.default },

  props: {
    params: {
      type: Object } },


  data: function data() {
    var me = this,commentId = $uuid();
    return {
      title: $lang('拟办'),
      rowStyle: 'height:225px; padding-bottom:5px;',
      fCount: 0,
      workFlows: [],
      candidates: {},
      planneds: {},
      comment: '',
      commentId: commentId,
      commentCategory: '',

      footerButton: [
      {
        label: $lang("关闭"),
        type: "default",
        func: me.close },

      {
        label: $lang("确定"),
        func: me.submit }] };



  },
  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
    this.init();
  },
  watch: {
    params: function params() {
      this.init();
    } },

  methods: {
    setBtnLoading: function setBtnLoading(loading, idx) {
      this.footerButton[idx].loading = loading;
    },
    btnDebounce: _.debounce(function (callback) {
      var me = this;
      if (callback) {
        callback();
      }
    }, 1000, {
      'leading': true,
      'trailing': false }),

    init: function init() {
      var me = this;
      me.mwApi.process.getPlannedFlows({ taskId: me.params.taskId }).then(function (data) {
        var res = data.result;
        if (typeof res.success != 'undefined' && !res.success) {
          me.fCount = 0;
          return;
        }
        me.workFlows = res;
        me.fCount = res.length;
        me.rowStyle = 'height:' + Math.floor(100 / me.fCount) + '%; padding-bottom:5px;';
        res.map(function (wf) {
          var fcandidates = [];
          var fplanneds = [];
          var cidx = 0;
          if (wf.candidates) {
            wf.candidates.map(function (v) {
              if (!v.hidden) {
                var node = (0, _assign2.default)({}, v);
                node.text = v.name;
                node.flowId = wf.id;
                node.idx = cidx++;
                fcandidates.push(node);
              }
            });
          }
          if (wf.planneds) {
            wf.planneds.map(function (v) {
              var node = me._subPlannedAsNode(v);
              node.flowId = wf.id;
              fplanneds.push(node);
            });
          }
          me.candidates[wf.id] = fcandidates;
          me.planneds[wf.id] = fplanneds;
        });
      });
      me.renderComment();

    },
    renderComment: function renderComment() {
      var me = this;
      if (me.params.comment && me.params.comment.length > 0) {
        me.comment = me.params.comment[0].content;
        me.commentId = me.params.comment[0].id;
        me.commentCategory = me.params.comment[0].category;
      } else {
        me.commentId = $uuid();
        me.comment = '';
        me.commentCategory = me.params.activity.commentCategory;
      }










    },
    dblClick: function dblClick(data) {
      if (!data) {
        return;
      }
      var me = this;
      var flowId = data.flowId;

      var fcandidate = me.candidates[flowId];
      var idx;
      fcandidate.map(function (v, d) {
        if (v.id == data.id) {
          idx = d;
          return;
        }
      });
      me.candidates[flowId].splice(idx, 1);

      var node = (0, _assign2.default)({}, data);
      node.text = data.name;
      node.flowId = flowId;
      me.planneds[flowId].push(node);
      me.mwRef('planned' + flowId)[0].refreshData(me.planneds[flowId]);
    },
    dblClickSelected: function dblClickSelected(data) {
      if (!data) {
        return;
      }
      var me = this;
      var flowId = data.flowId;

      var fplanned = me.planneds[flowId];
      var idx = void 0;
      fplanned.map(function (v, d) {
        if (v.id == data.id) {
          idx = d;
          return;
        }
      });
      me.planneds[flowId].splice(idx, 1);


      var node = (0, _assign2.default)({}, data);
      node.text = data.name;
      node.flowId = flowId;
      var cidx = node.idx;
      if (cidx || cidx == 0) {
        me.candidates[flowId].splice(cidx, 0, node);
      } else {
        me.candidates[flowId].push(node);
      }
      me.mwRef('candidate' + flowId)[0].refreshData(me.candidates[flowId]);
    },
    submit: function submit() {
      var me = this;
      me.btnDebounce(function () {
        me.setBtnLoading(true, 1);
        var activities = [];
        me.workFlows.map(function (v) {
          var activity = {};
          activity.flowId = v.id;
          activity.activityId = v.activityId;
          activity.type = v.type;
          activity.options = v.options;

          var items = [];
          me.planneds[v.id].map(function (plan) {
            items.push(me._nodeAsItem(plan));
          });
          activity.items = items;
          activities.push(activity);
        });
        var params = {};
        params.taskId = me.params.taskId;
        params.appId = me.params.appId;
        params.formId = me.params.formId;
        params.activities = activities;
        if (me.comment) {
          params.$comment = [{ id: me.commentId, content: me.comment, category: me.commentCategory }];
        }
        if (me.params.fullAuthType) {
          params.fullAuthType = me.params.fullAuthType;
        }
        me.mwApi.process.planned(params).then(function (res) {
          me.close();
          me.formActionComplete(params);
          me.setBtnLoading(false, 1);
        }).catch(function () {
          me.setBtnLoading(false, 1);
        });
      });
    },
    plannedComment: function plannedComment() {
      var me = this;
      var dcomment = [];
      var ucomment = [];
      var commentContent = '';
      me.workFlows.map(function (v) {
        me.planneds[v.id].map(function (plan) {
          if (v.options.sendUnit == 'DEP') {
            dcomment.push(plan.name);
          } else {
            ucomment.push(plan.name);
          }
        });
      });
      if (ucomment.length > 0) {
        commentContent += '呈' + ucomment.join(',') + '阅示.';
      }
      if (dcomment.length > 0) {
        commentContent += '请' + dcomment.join(',') + '阅知.';
      }
      me.comment = commentContent;
    },
    beforeClose: function beforeClose(done) {
      var me = this;
      me.mwConfirm($lang('确定退出拟办窗口？')).then(function (_) {
        if (me.params.secondfunc) {
          me.params.secondfunc();
        }
        me.resetForm();
        done();
      }).catch(function (_) {});
    },
    formActionComplete: function formActionComplete(params) {
      var me = this;
      if (me.params.func) {
        me.params.func(params);
      }
      this.resetForm();
    },
    close: function close() {
      this.resetForm();
      this.mwRef('dialog').hide();
    },
    show: function show() {
      this.mwRef('dialog').show();
    },
    resetForm: function resetForm() {
      var me = this;
      me.workFlows = [];
      me.candidates = {};
      me.planneds = {};
      me.fCount = 0;
      me.rowStyle = 'height:225px; padding-bottom:5px;';
    },
    _nodeAsItem: function _nodeAsItem(n) {
      var item = {};
      if (n.type == 'U') {
        item.group = n.departmentId;
        if (!item.users) {
          item.users = [];
        }
        item.users.push({ id: n.id });
      } else if (n.identities) {
        item.group = n.id;
        n.identities.map(function (i) {
          if (i.type == 'U') {
            if (!item.users) {
              item.users = [];
            }
            item.users.push({ id: i.id });
          } else {
            if (!item.identities) {
              item.identities = [];
            }
            item.identities.push({ id: i.id });
          }
        });
      }
      return item;
    },
    _subPlannedAsNode: function _subPlannedAsNode(v) {
      var node = {};
      node.id = v.masterObjectId;
      node.name = v.masterObjectName;
      if (v.masterObjectType == 'USER') {
        node.type = 'U';
        node.departmentId = v.masterObjectDeptId;
      } else {
        node.type = 'D';
      }
      if (v.identities) {
        node.identities = v.identities;
      }
      node.text = v.masterObjectName;
      return node;
    } } };

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
















{

  name: 'MwLiTree',
  props: {
    search: {
      type: Boolean,
      default: false },


    autoLoad: {
      type: Boolean,
      default: true },


    defaultParentId: {
      type: String },


    defaultParams: {
      type: Object },


    url: {
      type: String },


    expandedFirst: {
      type: Boolean,
      default: false },


    async: {
      type: Boolean,
      default: false },


    multiple: {
      type: Boolean,
      default: false },

    singleLeaf: {
      type: Boolean,
      default: false },


    multipleLeaf: {
      type: Boolean,
      default: false },

    contextMenuItem: {
      type: Array,
      default: function _default() {
        return [];
      } },


    checkNodes: {
      type: Array,
      default: function _default() {
        return [];
      } },


    selectNode: {
      type: String,
      default: '' },


    treeData: {
      type: [Array, Object] },

    isDblClickDeleteNode: {
      type: Boolean,
      default: true } },


  data: function data() {
    return {
      searchFlag: false,
      searchText: '',
      selectData: {},
      selectParents: [],

      dblClick: false,
      select: false,
      deselect: false,
      check: false };

  },
  watch: {
    searchText: function searchText(val) {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (val == '') {
        setTimeout(function () {
          tree.clear_search();
        }, 250);
      } else {
        if (this.searchFlag) {
          clearTimeout(this.searchFlag);
        }
        this.searchFlag = setTimeout(function () {
          tree.search(val, true, true);
        }, 250);
      }
    },
    url: function url(val) {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (tree) {
        tree.destroy();
      }
      this.renderTree();
    },
    checkNodes: function checkNodes(newIds) {
      var me = this;
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.uncheck_all();
      newIds.forEach(function (id) {
        var obj = inst.get_node(id);
        inst.check_node(obj);
      });
    },
    selectNode: function selectNode(newId) {
      var me = this;
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.deselect_all();
      if (newId) {
        var obj = inst.get_node(newId);
        inst.select_node(obj);
      }
    } },

  mounted: function mounted() {
    if (this.autoLoad) {
      this.renderTree();
    }
  },
  destroyed: function destroyed() {
    var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
    if (tree) {
      tree.destroy();
    }
  },
  methods: {
    getInstance: function getInstance() {
      var me = this;
      return $(me.$el.querySelector('.mw-tree')).jstree(true);
    },
    showNode: function showNode(id) {
      var me = this;
      var obj = $(me.$el.querySelector('.mw-tree')).jstree(true).get_node(id);
      $(me.$el.querySelector('.mw-tree')).jstree(true).show_node(obj);
    },
    getSelectNodes: function getSelectNodes() {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      var selected = tree.get_selected();
      var data = [];
      if (selected.length > 0) {
        selected.forEach(function (id) {
          var obj = tree.get_node(id);
          if (!obj.state.hidden) {

            var d = (0, _assign2.default)({ parentId: obj.parent }, obj.original);
            data.push(d);
          }
        });
      }
      return data;
    },
    checkAll: function checkAll() {
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.select_all();
    },
    unCheckAll: function unCheckAll() {
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.deselect_all();
    },
    openAll: function openAll() {
      $(this.$el.querySelector('.mw-tree')).jstree('open_all');
    },
    closeAll: function closeAll() {
      $(this.$el.querySelector('.mw-tree')).jstree('close_all');
    },
    refresh: function refresh() {
      $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
    },
    refreshData: function refreshData(data) {
      if (!$(this.$el.querySelector('.mw-tree')).jstree(true)) {
        this.renderTree();
      } else {
        if (data) {
          this.$emit("beforeDataFilter", data);
        }
        $(this.$el.querySelector('.mw-tree')).jstree(true).settings.core.data = data;
        $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
      }
    },
    renderTree: function renderTree() {
      var me = this,jsTreeEl = $(me.$el.querySelector('.mw-tree'));

      var plugin = ["types"];
      var items = {};
      if (me.multiple) {
        plugin.push("checkbox");
        plugin.push("wholerow");
      } else {
        plugin.push("wholerow");
      }
      if (me.search) {
        plugin.push("search");
      }
      if (me.contextMenuItem.length > 0) {
        plugin.push("contextmenu");
        me.contextMenuItem.forEach(function (item) {
          items[item.name] = {
            "name": item.name ? item.name : '',
            "label": item.label,
            "icon": item.icon ? item.icon : '',
            "action": function action(a) {
              item.func(me.selectData, me.selectParents);
            } };

        });
      }
      var data = {};
      if (me.treeData) {
        data = me.treeData;
        me.$emit("beforeDataFilter", data);
      }

      jsTreeEl.data('jstree', false).empty();
      jsTreeEl.bind("load_node.jstree", function (e, data) {

      }).on("changed.jstree", function (e, data) {

      }).bind("loaded.jstree", function (e, data) {

      }).bind("click.jstree", function (e) {

      }).bind("dblclick.jstree", function (e) {
        var id = e.target.id.substr(0, e.target.id.lastIndexOf('_'));
        var obj = jsTreeEl.jstree(true).get_node(id);
        me.dblClick = true;
        if (obj) {
          if (me.isDblClickDeleteNode)
          jsTreeEl.jstree(true).delete_node(obj);
          me.$emit("dblClick", obj.original, jsTreeEl);
        }
        me.dblClick = false;
      }).bind("check_node.jstree", function (e, data) {

      }).bind("select_node.jstree", function (e, data) {

      }).bind("deselect_node.jstree", function (e, data) {

      }).jstree({
        'async': me.async,
        'expanded_first': false,
        'core': {
          "themes": {
            "responsive": false },

          "multiple": me.multiple,
          "check_callback": function check_callback(operation, node, node_parent, node_position, more) {
            return true;
          },
          'data': data },

        'checkbox': {
          "keep_selected_style": false,
          "three_state": true,
          "visible": true,
          "tie_selection": true },

        "plugins": plugin,
        "contextmenu": {
          "items": items },

        "types": {
          "#": {
            "icon": "fa fa-folder" },

          "file": {
            "icon": "fa fa-leaf" },

          "default": {
            "icon": "fa fa-leaf" } } });



    } } };

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);
























var _liwt = __webpack_require__(353);var _liwt2 = _interopRequireDefault(_liwt);
var _treewt = __webpack_require__(355);var _treewt2 = _interopRequireDefault(_treewt);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  components: {
    MwWtLi: _liwt2.default,
    MwWtTree: _treewt2.default },

  props: {
    params: {
      type: Object } },


  data: function data() {
    var me = this;
    return {
      title: $lang('运转跟踪'),
      fCount: 0,
      workFlows: [],
      candidates: {},
      planneds: {},
      doings: {},
      finisheds: {},
      rowStyle: 'height:225px; padding-top:5px;',
      hasDoging: false,
      footerButton: [
      {
        label: $lang("关闭"),
        type: "default",
        func: me.close },

      {
        label: $lang("确定"),
        func: me.submit }] };



  },
  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
    this.init();
  },
  watch: {
    params: function params() {
      this.init();
    } },

  methods: {
    setBtnLoading: function setBtnLoading(loading, idx) {
      this.footerButton[idx].loading = loading;
    },
    btnDebounce: _.debounce(function (callback) {
      var me = this;
      if (callback) {
        callback();
      }
    }, 1000, {
      'leading': true,
      'trailing': false }),

    init: function init() {
      var me = this;
      me.mwApi.process.getWorkFlows({ taskId: me.params.taskId }).then(function (data) {
        var res = data.result;
        if (typeof res.success != 'undefined' && !res.success) {
          me.fCount = 0;
          return;
        }
        me.workFlows = res;
        me.fCount = res.length;
        me.rowStyle = 'height:' + Math.floor(100 / me.fCount) + '%; padding-top:5px;';

        res.map(function (wf) {
          var fcandidates = [];
          var fplanneds = [];
          var fdoings = [];
          var cidx = 0;
          wf.url = "/rest/process/task/flow/" + me.params.taskId + "/" + wf.id + ("?_=" + Math.random());
          wf.appendRefresh = wf.options.sendUnit == 'USER';

          if (wf.candidates) {
            wf.candidates.map(function (v) {
              if (!v.hidden) {
                var node = (0, _assign2.default)({}, v);
                var text = v.name;
                if (window.$currentBrowserLanguage === 'en') text = v.Englishname || v.name;
                node.text = text;
                node.flowId = wf.id;
                node.idx = cidx++;
                fcandidates.push(node);
              }
            });
          }
          me.candidates[wf.id] = fcandidates;
          var fs = [];
          if (wf.finisheds) {
            _.each(wf.finisheds, function (v) {
              fs = fs.concat(v.identities);
            });
          }
          me.finisheds[wf.id] = fs;
          if (wf.planneds) {
            wf.planneds.map(function (v) {
              var node = me._subPlannedAsNode(v);
              node.flowId = wf.id;
              fplanneds.push(node);
            });
          }
          me.planneds[wf.id] = fplanneds;

          if (wf.doings) {
            wf.doings.map(function (v) {
              var node = me._subPlannedAsNode(v);
              node.flowId = wf.id;
              fdoings.push(node);
            });
          }
          if (fdoings.length > 0) {
            me.hasDoging = true;
          }
          me.doings[wf.id] = fdoings;
        });
      });
    },
    submit: function submit() {
      var me = this;
      me.btnDebounce(function () {
        me.setBtnLoading(true, 1);
        var activities = [];
        me.workFlows.map(function (v) {
          var activity = {};
          activity.flowId = v.id;
          activity.activityId = v.activityId;
          activity.type = v.type;
          activity.options = v.options;

          var items = [];
          var wtRef = me.mwRef("wt" + v.id)[0];
          if (wtRef.getPlannedsData) {
            items = wtRef.getPlannedsData();
          }
          activity.items = items;
          activities.push(activity);
        });
        var params = {};
        params.taskId = me.params.taskId;
        params.appId = me.params.appId;
        params.formId = me.params.formId;
        params.activities = activities;
        if (me.params.fullAuthType) {
          params.fullAuthType = me.params.fullAuthType;
        }
        me.mwApi.process.planned(params).then(function (res) {
          me.close();
          me.formActionComplete();
          me.setBtnLoading(false, 1);
        }).catch(function () {
          me.setBtnLoading(false, 1);
        });
      });
    },
    beforeClose: function beforeClose(done) {
      var me = this;

      if (me.params.secondfunc) {
        me.params.secondfunc(me.params.isOperation, me.hasDoging);
      }
      me.resetForm();
      done();

    },
    formActionComplete: function formActionComplete() {
      var me = this;
      if (me.params.func) {
        me.params.func();
      }
      this.resetForm();
    },
    close: function close() {
      if (this.params.secondfunc) {
        this.params.secondfunc(this.params.isOperation, this.hasDoging);
      }
      this.resetForm();
      this.mwRef('dialog').hide();
    },
    show: function show() {
      this.mwRef('dialog').show();
    },
    resetForm: function resetForm() {
      var me = this;
      me.workFlows = [];
      me.candidates = {};
      me.planneds = {};
      me.doings = {};
      me.fCount = 0;
      me.rowStyle = 'height:225px; padding-top:5px;';
    },
    _subPlannedAsNode: function _subPlannedAsNode(v) {
      var node = {};
      node.id = v.masterObjectId;
      var mobjName = v.masterObjectName;
      if (window.$currentBrowserLanguage === 'en') mobjName = v.Englishname || v.masterObjectName;
      node.name = mobjName;
      if (v.masterObjectType == 'USER') {
        node.type = 'U';
        node.departmentId = v.masterObjectDeptId;
      } else {
        node.type = 'D';
      }
      if (v.identities) {
        node.identities = v.identities;
      }
      node.text = mobjName;
      return node;
    } } };

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_liwt_vue__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_liwt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_liwt_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_liwt_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_liwt_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_e6bf13dc_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_liwt_vue__ = __webpack_require__(1063);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_liwt_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_e6bf13dc_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_liwt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);


















































var _li = __webpack_require__(115);var _li2 = _interopRequireDefault(_li);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  name: 'MwWtLi',
  components: {
    MwLiTree: _li2.default },

  props: {
    params: {
      type: Object },

    rowStyle: {
      type: String,
      default: function _default() {
        return 'height:225px; padding-top:5px;';
      } },

    flowId: {
      type: String },

    flowName: {
      type: String },

    flowType: {
      type: String },

    options: {
      type: Object },

    activityId: {
      type: String },

    candidates: {
      type: Array,
      default: function _default() {
        return [];
      } },

    planneds: {
      type: Array,
      default: function _default() {
        return [];
      } },

    doings: {
      type: Array,
      default: function _default() {
        return [];
      } },

    finisheds: {
      type: Array,
      default: function _default() {
        return [];
      } } },


  data: function data() {
    var me = this;
    return {
      sendBtnLeading: false,
      takenBtnLeading: false };

  },
  methods: {
    btnDebounce: _.debounce(function (callback) {
      var me = this;
      if (callback) {
        callback();
      }
    }, 1000, {
      'leading': true,
      'trailing': false }),

    candidateDataHandle: function candidateDataHandle(data) {
      data.forEach(function (d) {
        if (!d.text) {
          if (d.name) {
            d.text = d.name;
            if (window.$currentBrowserLanguage === 'en') d.text = d.Englishname || d.name;
          }
        }
        if (!d.originalId) {
          d.originalId = d.id;
          if (d.departmentId) {
            d.id = d.departmentId + '_' + d.id;
          }
        }
      });
    },
    dblClick: function dblClick(data) {
      var me = this;

      var fcandidate = me.candidates;
      var idx;
      fcandidate.map(function (v, d) {
        if (v.id == data.originalId) {
          idx = d;
          return;
        }
      });
      if (idx) {
        me.candidates.splice(idx, 1);
      }

      var node = (0, _assign2.default)({}, data);
      node.id = node.originalId;
      delete node.originalId;
      var text = data.name;
      if (window.$currentBrowserLanguage === 'en') text = data.Englishname || data.name;
      node.text = text;
      node.flowId = me.flowId;
      me.planneds.push(node);
      me.mwRef('planned' + me.flowId).refreshData(me.planneds);
    },
    dblClickSelected: function dblClickSelected(data) {
      var me = this;

      var fplanned = me.planneds;
      var idx = void 0;
      fplanned.map(function (v, d) {
        if (v.id == data.id) {
          idx = d;
          return;
        }
      });
      if (idx !== undefined) {
        me.planneds.splice(idx, 1);
      }


      var node = (0, _assign2.default)({}, data);
      if (!data.originalId) {
        node.originalId = data.id;
        if (data.departmentId) {
          node.id = data.departmentId + '_' + data.id;
        }
      }
      var text = data.name;
      if (window.$currentBrowserLanguage === 'en') text = data.Englishname || data.name;
      node.text = text;
      node.flowId = me.flowId;
      var cidx = node.idx;
      if (cidx || cidx == 0) {
        me.candidates.splice(cidx, 1, node);
      } else {
        me.candidates.push(node);
      }
      me.mwRef('candidate' + me.flowId).refreshData(me.candidates);
    },
    sendClick: function sendClick() {
      var me = this;
      me.btnDebounce(function () {
        me.sendBtnLeading = true;
        var data = me.mwRef('planned' + me.flowId).getSelectNodes();
        if (data.length < 1) {
          me.sendBtnLeading = false;
          return;
        }
        var activities = [];
        var items = [];
        data.map(function (v) {
          items.push(me._nodeAsItem(v));
        });
        var activity = {};
        activity.items = items;
        activity.flowId = me.flowId;
        activity.activityId = me.activityId;
        activity.type = me.flowType;
        activity.options = me.options;
        activities.push(activity);
        var params = {};
        params.type = "complete";
        params.actionDescription = "发送";
        params.taskId = me.params.taskId;
        params.appId = me.params.appId;
        params.formId = me.params.formId;params.formKey = me.params.formKey;
        params.activities = activities;
        me.params.isOperation = true;
        if (me.params.fullAuthType) {
          params.fullAuthType = me.params.fullAuthType;
        }
        me.mwApi.process.batchCommit(params).then(function (res) {
          var rr = res.result;
          if (rr && typeof res.success != 'undefined' && !rr.success) {
            me.mwMsg('info', '发送失败!');
            me.sendBtnLeading = false;
            return;
          } else if (res.success) {
            data.map(function (v) {

              me.doings.push(v);

              var fplanned = me.planneds;
              var idx;
              fplanned.map(function (fv, d) {
                if (fv.id == v.id) {
                  idx = d;
                  return;
                }
              });
              if (idx !== undefined) {
                me.planneds.splice(idx, 1);
              }

              var fidx;
              me.finisheds.map(function (fv, d) {
                if (fv.id == v.id) {
                  fidx = d;
                  return;
                }
              });
              if (fidx !== undefined) {
                me.finisheds.splice(fidx, 1);
              }
            });


            me.mwRef('planned' + me.flowId).refreshData(me.planneds);
            me.mwRef('doing' + me.flowId).refreshData(me.doings);
            me.sendBtnLeading = false;
          }
        }).catch(function () {
          me.sendBtnLeading = false;
        });
      });
    },
    takenClick: function takenClick() {
      var me = this;
      me.btnDebounce(function () {
        me.takenBtnLeading = true;
        var data = me.mwRef('doing' + me.flowId).getSelectNodes();
        if (data.length < 1) {
          me.takenBtnLeading = false;
          return;
        }
        var masterObjectIds = [];
        data.map(function (v) {
          masterObjectIds.push(v.id);
        });
        var params = {};
        params.taskId = me.params.taskId;
        params.flowId = me.flowId;
        params.masterObjectIds = masterObjectIds;
        me.params.isOperation = true;
        if (me.params.fullAuthType) {
          params.fullAuthType = me.params.fullAuthType;
        }
        if (window.$Env && $Env.yzTakenFilterSecondSend) {
          params.filterSecondSend = true;
        }
        me.mwApi.process.batchTakenSubProcess(params).then(function (res) {
          if (res.success) {
            var sent = res.result && res.result.sent && res.result.sent.length ? res.result.sent : [];
            if (sent.length > 0) {
              PF.message("[" + sent.join(",") + "]已办理，不能取回");
            }
            data.map(function (v) {

              if (sent.indexOf(v.name) == -1) {
                me.planneds.push(v);

                var idx;
                me.doings.map(function (fv, d) {
                  if (fv.id == v.id) {
                    idx = d;
                    return;
                  }
                });
                if (idx !== undefined) {
                  me.doings.splice(idx, 1);
                }
              }
            });

            me.mwRef('planned' + me.flowId).refreshData(me.planneds);
            me.mwRef('doing' + me.flowId).refreshData(me.doings);
          }
          me.takenBtnLeading = false;
        }).catch(function () {
          me.takenBtnLeading = false;
        });
      });
    },
    getPlannedsData: function getPlannedsData() {
      var me = this;
      var items = [];
      me.planneds.map(function (plan) {
        items.push(me._nodeAsItem(plan));
      });
      return items;
    },
    _nodeAsItem: function _nodeAsItem(n) {
      var item = {};
      if (n.type == 'U') {
        item.group = n.departmentId;
        if (!item.users) {
          item.users = [];
        }
        item.users.push({ id: n.id });
      } else if (n.identities) {
        item.group = n.id;
        n.identities.map(function (i) {
          if (i.type == 'U') {
            if (!item.users) {
              item.users = [];
            }
            item.users.push({ id: i.id });
          } else {
            if (!item.identities) {
              item.identities = [];
            }
            item.identities.push({ id: i.id });
          }
        });
      }
      return item;
    } } };

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_treewt_vue__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_treewt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_treewt_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_treewt_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_treewt_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f9af8bcc_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_treewt_vue__ = __webpack_require__(1066);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_treewt_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f9af8bcc_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_treewt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });










































var _level = __webpack_require__(1064);var _level2 = _interopRequireDefault(_level);
var _li = __webpack_require__(115);var _li2 = _interopRequireDefault(_li);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  name: 'MwWtTree',
  components: {
    MwLevelTree: _level2.default,
    MwLiTree: _li2.default },

  props: {
    params: {
      type: Object },

    rowStyle: {
      type: String,
      default: function _default() {
        return 'height:225px; padding-top:5px;';
      } },

    flowId: {
      type: String },

    flowName: {
      type: String },

    flowType: {
      type: String },

    options: {
      type: Object },

    activityId: {
      type: String },


    url: {
      type: String },

    appendRefresh: {
      type: Boolean,
      default: false },

    doings: {
      type: Array,
      default: function _default() {
        return [];
      } },

    finisheds: {
      type: Array,
      default: function _default() {
        return [];
      } } },


  data: function data() {
    var me = this;
    return {
      defaultParams: {},
      sendBtnLeading: false,
      takenBtnLeading: false,
      isOperation: false };

  },
  methods: {
    btnDebounce: _.debounce(function (callback) {
      var me = this;
      if (callback) {
        callback();
      }
    }, 1000, {
      'leading': true,
      'trailing': false }),

    treeDataFilter: function treeDataFilter(data) {
      var me = this;
      var doIds = [];
      me.doings.map(function (d, idx) {
        doIds.push(d.id);
      });
      data.forEach(function (d) {
        if (doIds.indexOf(d.id) != -1) {
          d.hidden = true;
        }
        if (!d.text) {
          if (d.name) {
            d.text = d.name;
            if (window.$currentBrowserLanguage === 'en') d.text = d.Englishname || d.name;
          }
        }
        d.originalId = d.id;
        if (d.type && d.type == 'U') {
          if (d.parentId) {
            d.id = d.parentId + "_" + d.id;
          }
        }
        if (d.children && d.children.length > 0) {
          me.treeDataFilter(d.children);
        } else {
          if (d.hasReal == undefined) {
            d.children = false;
            d.type = 'file';
          } else {
            d.children = d.hasReal;
            if (!d.hasReal) {
              d.type = 'file';
            } else {
              d.type = 'default';
            }
          }







        }
      });
    },
    sendClick: function sendClick() {
      var me = this;
      me.btnDebounce(function () {
        me.sendBtnLeading = true;
        var data = me.mwRef('candidate' + me.flowId).getSelectNodes();
        if (data.length < 1) {
          me.sendBtnLeading = false;
          return;
        }
        var activities = [];
        var activity = {};
        activity.items = me._nodeAsItems(data);
        activity.flowId = me.flowId;
        activity.activityId = me.activityId;
        activity.type = me.flowType;
        activity.options = me.options;
        activities.push(activity);
        var params = {};
        params.taskId = me.params.taskId;
        params.appId = me.params.appId;
        params.formId = me.params.formId;params.formKey = me.params.formKey;
        params.type = "complete";
        params.actionDescription = "发送";
        params.activities = activities;
        me.params.isOperation = true;
        if (me.params.fullAuthType) {
          params.fullAuthType = me.params.fullAuthType;
        }
        me.mwApi.process.batchCommit(params).then(function (res) {
          var rr = res.result;
          if (rr && typeof res.success != 'undefined' && !rr.success) {
            me.mwMsg('info', '发送失败!');
            me.sendBtnLeading = false;
            return;
          } else if (res.success) {
            data.map(function (v) {

              me.doings.push(v);

              var fidx;
              me.finisheds.map(function (fv, d) {
                if (fv.id == v.id) {
                  fidx = d;
                  return;
                }
              });
              me.finisheds.splice(fidx, 1);
            });

            me.mwRef('doing' + me.flowId).refreshData(me.doings);

            data.map(function (v) {
              me.mwRef('candidate' + me.flowId).hideNode(v.id);
            });
            me.sendBtnLeading = false;
          }
        }).catch(function () {
          me.sendBtnLeading = false;
        });
      });
    },
    takenClick: function takenClick() {
      var me = this;
      me.btnDebounce(function () {
        me.takenBtnLeading = true;
        var data = me.mwRef('doing' + me.flowId).getSelectNodes();
        if (data.length < 1) {
          me.takenBtnLeading = false;
          return;
        }
        var masterObjectIds = [];
        data.map(function (v) {
          masterObjectIds.push(v.id);
        });
        var params = {};
        params.taskId = me.params.taskId;
        params.flowId = me.flowId;
        params.masterObjectIds = masterObjectIds;
        if (me.params.fullAuthType) {
          params.fullAuthType = me.params.fullAuthType;
        }
        if (window.$Env && $Env.yzTakenFilterSecondSend) {
          params.filterSecondSend = true;
        }
        me.params.isOperation = true;
        me.mwApi.process.batchTakenSubProcess(params).then(function (res) {
          if (res.success) {
            var sent = res.result && res.result.sent && res.result.sent.length ? res.result.sent : [];
            if (sent.length > 0) {
              PF.message("[" + sent.join(",") + "]已办理，不能取回");
            }
            data.map(function (v) {

              if (sent.indexOf(v.name) == -1) {
                var idx;
                me.doings.map(function (fv, d) {
                  if (fv.id == v.id) {
                    idx = d;
                    return;
                  }
                });
                me.doings.splice(idx, 1);
              }
            });

            data.map(function (v) {
              var nodeId;
              if (v.departmentId) {
                nodeId = v.departmentId + "_" + v.id;
              } else {
                nodeId = v.id;
              }
              me.mwRef('candidate' + me.flowId).showNode(nodeId);
            });

            me.mwRef('doing' + me.flowId).refreshData(me.doings);
          }
          me.takenBtnLeading = false;
        }).catch(function () {
          me.takenBtnLeading = false;
        });
      });
    },
    _nodeAsItems: function _nodeAsItems(data) {
      var me = this;
      var items = [];
      var ids = [];
      var options = me.options;
      if (options && options.activityUnit == 'group') {
        data.map(function (d) {
          if (ids.indexOf(d.id) == -1) {
            ids.push(d.id);
            if (d.identities && d.identities.length > 0) {
              var item = {};
              item.group = d.id;
              d.identities.map(function (i) {
                if (i.type == 'U') {
                  if (!item.users) {
                    item.users = [];
                  }
                  if (i.id.indexOf("_") > -1) {
                    item.users.push({ id: i.id.split("_")[1] });
                  } else {
                    item.users.push({ id: i.id });
                  }
                } else {
                  if (!item.identities) {
                    item.identities = [];
                  }
                  item.identities.push({ id: i.id });
                }
              });
              items.push(item);
            } else {
              var item = undefined;
              items.map(function (i) {
                if (i.group == d.parentId) {
                  item = i;
                }
              });
              if (item) {
                if (d.id.indexOf("_") > -1) {
                  item.users = [{ id: d.id.split("_")[1] }];
                } else {
                  item.users = [{ id: d.id }];
                }
              } else {
                item = {};
                item.group = d.parentId;
                if (d.id.indexOf("_") > -1) {
                  item.users = [{ id: d.id.split("_")[1] }];
                } else {
                  item.users = [{ id: d.id }];
                }
                items.push(item);
              }
            }
          }
        });
        return items;
      }

      data.map(function (d) {
        if (ids.indexOf(d.id) == -1) {
          ids.push(d.id);
          var item = {};
          if (d.identities && d.identities.length > 0) {
            item.group = d.id;
            d.identities.map(function (i) {
              if (i.type == 'U') {
                if (!item.users) {
                  item.users = [];
                }
                if (i.id.indexOf("_") > -1) {
                  item.users.push({ id: i.id.split("_")[1] });
                } else {
                  item.users.push({ id: i.id });
                }
              } else {
                if (!item.identities) {
                  item.identities = [];
                }
                item.identities.push({ id: i.id });
              }
            });
          } else {
            item.group = d.parentId;
            if (d.id.indexOf("_") > -1) {
              item.users = [{ id: d.id.split("_")[1] }];
            } else {
              item.users = [{ id: d.id }];
            }
          }
          items.push(item);
        }
      });
      return items;
    } } };

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _stringify = __webpack_require__(24);var _stringify2 = _interopRequireDefault(_stringify);var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);
















var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  name: 'MwLevelTree',
  props: {
    search: {
      type: Boolean,
      default: false },


    autoLoad: {
      type: Boolean,
      default: true },


    defaultParams: {
      type: Object },


    url: {
      type: String,
      required: true },


    expandedFirst: {
      type: Boolean,
      default: false },


    async: {
      type: Boolean,
      default: false },


    multiple: {
      type: Boolean,
      default: false },

    singleLeaf: {
      type: Boolean,
      default: false },


    multipleLeaf: {
      type: Boolean,
      default: false },

    appendRefresh: {
      type: Boolean,
      default: true },

    firstExpandOneLevel: {
      type: Boolean,
      default: false },


    checkNodes: {
      type: Array,
      default: function _default() {
        return [];
      } },


    selectNode: {
      type: String,
      default: '' },


    treeData: {
      type: [Array, Object] } },


  data: function data() {
    return {
      searchFlag: false,
      searchText: '',

      dblClickTrigger: false,
      selectTrigger: false,
      deselectTrigger: false,
      checkTrigger: false,

      current_expanded: false,
      current_expandCount: 0,
      current_expand_last_id: '',
      current_expand_Loaded: false,

      initData: [],
      hasRefreshIds: [],
      hasOpenedIds: [] };

  },
  watch: {
    checkNodes: function checkNodes(newIds) {
      var me = this;
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.uncheck_all();
      newIds.forEach(function (id) {
        var obj = inst.get_node(id);
        inst.check_node(obj);
      });
    },
    selectNode: function selectNode(newId) {
      var me = this;
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.deselect_all();
      if (newId) {
        var obj = inst.get_node(newId);
        inst.select_node(obj);
      }
    },
    searchText: function searchText(val) {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (val == '') {
        setTimeout(function () {
          tree.clear_search();
        }, 250);
      } else {
        if (this.searchFlag) {
          clearTimeout(this.searchFlag);
        }
        this.searchFlag = setTimeout(function () {
          tree.search(val, true, true);
        }, 250);
      }
    },
    url: function url(val) {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      if (tree) {
        tree.destroy();
      }
      this.renderTree();
    } },

  mounted: function mounted() {
    if (this.autoLoad) {
      this.renderTree();
    }
  },
  destroyed: function destroyed() {
    var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
    if (tree) {
      tree.destroy();
    }
  },
  methods: {
    checkAll: function checkAll() {
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.select_all();
    },
    unCheckAll: function unCheckAll() {
      var inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
      inst.deselect_all();
    },
    openAll: function openAll() {
      $(this.$el.querySelector('.mw-tree')).jstree('open_all');
    },
    closeAll: function closeAll() {
      $(this.$el.querySelector('.mw-tree')).jstree('close_all');
    },
    refresh: function refresh() {
      $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
    },
    refreshData: function refreshData(data) {
      $(this.$el.querySelector('.mw-tree')).jstree(true).settings.core.data = data;
      $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
    },
    showNode: function showNode(id) {
      var me = this;
      var obj = $(me.$el.querySelector('.mw-tree')).jstree(true).get_node(id);
      $(me.$el.querySelector('.mw-tree')).jstree(true).show_node(obj);
    },
    hideNode: function hideNode(id) {
      var me = this;
      var tree = $(me.$el.querySelector('.mw-tree')).jstree(true);
      var obj = tree.get_node(id);
      tree.hide_node(obj);
    },
    getSelectNodes: function getSelectNodes() {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      var selected = tree.get_selected();
      var data = [];
      if (selected.length > 0) {
        selected.forEach(function (id) {
          var obj = tree.get_node(id);
          if (obj.type == 'file' && !obj.state.hidden) {
            var d = (0, _assign2.default)({ parentId: obj.parent }, obj.original);
            data.push(d);
          }
        });
      }
      return data;
    },

    getSelected: function getSelected() {
      var tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
      var selected = tree.get_selected();
      var data = [];
      if (this.multiple) {
        if (selected.length > 0) {
          data = [];
          selected.forEach(function (id) {
            data.push(tree.get_node(id).original);
          });
        }
      } else {
        if (selected.length > 0) {
          data = tree.get_node(selected[0]).original;
        }
      }
      return data;
    },
    renderTree: function renderTree() {
      var me = this;
      var plugin = ["types"];
      var items = {};
      if (me.multiple) {
        plugin.push("checkbox");
        plugin.push("wholerow");
      } else {
        plugin.push("wholerow");
      }
      if (me.search) {
        plugin.push("search");
      }
      var data = me.getData();
      me.buildTree(data, plugin, items);
    },
    getData: function getData() {
      var me = this;
      var data = {};
      if (me.treeData) {
        data = me.treeData;
        return data;
      }
      data = {
        async: false,
        "url": function url(node) {
          var arr = [];
          for (var p in me.defaultParams) {
            arr.push(p + "=" + me.defaultParams[p]);
          }
          if (node.id === '#') {
            return me.url + '?' + arr.join("&");
          } else {
            return me.url + '/' + node.id + '?' + arr.join("&");
          }
        },
        'data': function data(node) {
          return { 'id': node.id };
        },
        dataFilter: function dataFilter(data) {
          var data = JSON.parse(data);
          if (!me.current_expand_Loaded) {
            this.loopChildren(data);
          }

          if (data) {
            me.$emit("beforeDataFilter", data);
          } else {
            data = [];
          }
          if (me.current_expand_Loaded) {
            var resData = [];
            this._initData(me.initData, this.data.split('=')[1], data, resData);
            if (resData.length > 0) {
              return (0, _stringify2.default)(resData[0].children);
            } else {
              return (0, _stringify2.default)(data);
            }
          } else {
            me.initData = data;
          }
          return (0, _stringify2.default)(data);
        },
        _initData: function _initData(data, appendParentId, appendData, resData) {
          if (!data) {
            return;
          }
          for (var i = 0; i < data.length; i++) {
            var v = data[i];
            if (v.children instanceof Array) {
              if (v.id == appendParentId) {
                for (var j = appendData.length - 1; j >= 0; j--) {
                  v.children.unshift(appendData[j]);
                }
                resData.push(v);
              } else {
                this._initData(v.children, appendParentId, appendData, resData);
              }
            }
          }
        },
        loopChildren: function loopChildren(data) {var _this = this;
          data.forEach(function (d) {
            if (d.children) {
              _this.loopChildren(d.children);
            } else {
              me.hasRefreshIds.push(d.id);
            }
          });
        },
        "success": function success(data) {
          return data;
        } };

      return data;
    },
    buildTree: function buildTree(data, plugin, cmenuitems) {
      var me = this;
      var jsTreeEl = $(me.$el.querySelector('.mw-tree'));
      jsTreeEl.data('jstree', false).empty();
      jsTreeEl.bind("load_node.jstree", function (e, data) {
        var inst = data.instance;
        var set = inst.settings;
        var node = data.node;
        if (set.async && me.expandedFirst) {
          if (node && node.children && !set.expanded_first) {var
            _open_first_node = function _open_first_node(node) {
              me.current_expandCount++;

              if (node && (node.id == "#" || node.original && node.original.hasChild > 0)) {
                var n = void 0;
                if (node.children) {
                  if (me.firstExpandOneLevel) {
                    n = inst.get_node(node.children[0]);
                  } else {

                    for (var i = 0; i < node.children.length; i++) {
                      var id = node.children[i];
                      var v = inst.get_node(id);
                      if (v.children && v.children.length > 0) {
                        n = v;
                        break;
                      }
                    }
                  }
                }
                if (n) {
                  me.hasRefreshIds.push(n.original.id);
                  me.hasOpenedIds.push(n.original.id);
                  me.current_expand_last_id = n.original.id;
                }
                inst.open_node(n);
                _open_first_node(n);
              } else {
                me.current_expanded = true;
                set.expanded_first = true;
              }
            };
            _open_first_node(node);
          }
        }
      }).on("before_open.jstree", function (el, data) {
      }).on("after_open.jstree", function (el, data) {
        var inst = data.instance;
        var set = inst.settings;
        var node = inst.get_node(data.node.id);
        if (me.current_expand_Loaded) {
          if (me.appendRefresh) {
            if (node.original && !node.original.hidden && node.original.hasChild != undefined && node.original.hasChild > 0) {
              var id = node.original.id;
              if (me.hasRefreshIds.indexOf(id) == -1) {
                me.hasRefreshIds.push(id);
                jsTreeEl.jstree(true).refresh_node(node);
              }
            }
          }
          if (me.hasOpenedIds.indexOf(node.original.id) == -1) {
            me.hasOpenedIds.push(node.original.id);
          }
        }
        if (node.children) {
          node.children.map(function (v) {
            var cn = jsTreeEl.jstree(true).get_node(v);
            if (cn.original && cn.original.hidden) {
              jsTreeEl.jstree(true).hide_node(cn);
            }
          });
        }
        if (me.current_expanded) {
          me.current_expandCount--;

          if (me.current_expandCount == 2) {
            me.current_expand_Loaded = true;
            me.current_expanded = false;
          }
        }
      }).on("changed.jstree", function (e, data) {
      }).bind("loaded.jstree", function (e, data) {
        jsTreeEl.delegate(".jstree-checkbox", 'mousedown', function (e) {


          var id = $(this).parent()[0].id;
          var inst = jsTreeEl.jstree(true);
          var obj = inst.get_node(id);
          if (!me.dblClickTrigger) {
            me.checkTrigger = true;
            if (obj.state.selected != undefined) {
              if (obj.state.selected) {

              } else {var



                _getGroupIds = function _getGroupIds(node) {
                  if (node.original && node.original.type != 'file') {
                    if (me.hasOpenedIds.indexOf(node.original.id) == -1) {
                      groupIds.push(node.original.id);
                    }
                    nodeIds.push(node.id);
                    var children = node.children;
                    if (children instanceof Array) {
                      children.map(function (v) {
                        var n = inst.get_node(v);
                        _getGroupIds(n);
                      });
                    }
                  }
                };var nodeIds = [];var groupIds = [];
                _getGroupIds(obj);
                if (groupIds.length > 0) {




















                  inst.open_node(nodeIds);

                } else {

                  inst.open_node(nodeIds);
                }
              }
            }
            me.checkTrigger = false;
          }
        });
      }).bind("click.jstree", function (e, data) {
      }).bind("check_node.jstree", function (e, data) {
      }).bind("dblclick.jstree", function (e, data) {





































      }).bind("select_node.jstree", function (e, data) {
        if (!me.checkTrigger && me.multiple) {
          if (!me.dblClickTrigger && !me.deselectTrigger) {
            if (!me.selectTrigger) {
              var inst = data.instance;
              var obj = inst.get_node(data.node.original.id);
              me.selectTrigger = true;
              inst.deselect_node(obj);
              me.selectTrigger = false;
            } else {
              var inst = data.instance;
              var obj = inst.get_node(data.node.original.id);
              inst.select_node(obj);
            }
          }
        }
      }).bind("deselect_node.jstree", function (e, data) {
        if (!me.checkTrigger && me.multiple) {
          if (!me.dblClickTrigger && !me.selectTrigger) {
            if (!me.deselectTrigger) {
              var inst = data.instance;
              var obj = inst.get_node(data.node.original.id);
              me.deselectTrigger = true;
              inst.select_node(obj);
              me.deselectTrigger = false;
            } else {
              var inst = data.instance;
              var obj = inst.get_node(data.node.original.id);
              inst.deselect_node(obj);
            }
          }
        }
      }).jstree({
        'async': me.async,
        'expanded_first': false,
        'core': {
          "themes": {
            "responsive": false },

          "multiple": me.multiple,
          "check_callback": function check_callback(operation, node, node_parent, node_position, more) {
            return true;
          },
          'data': data },

        'checkbox': {
          "keep_selected_style": false,
          "three_state": true,
          "visible": true,
          "tie_selection": true },

        "plugins": plugin,
        "contextmenu": {
          "items": cmenuitems },

        "types": {
          "#": {
            "icon": "fa fa-folder" },

          "file": {
            "icon": "fa fa-leaf" },

          "default": {
            "icon": "fa fa-folder" } } });



    } } };

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);
















var _liwt = __webpack_require__(353);var _liwt2 = _interopRequireDefault(_liwt);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  components: {
    MwWtLi: _liwt2.default },

  props: {
    params: {
      type: Object } },


  data: function data() {
    var me = this;
    return {
      title: $lang('运转跟踪'),
      fCount: 0,
      workFlows: [],
      candidates: {},
      planneds: {},
      doings: {},
      rowStyle: 'height:225px; padding-top:5px;',

      footerButton: [
      {
        label: $lang("关闭"),
        type: "default",
        func: me.close },

      {
        label: $lang("确定"),
        func: me.submit }] };



  },
  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
    this.init();
  },
  watch: {
    params: function params() {
      this.init();
    } },

  methods: {
    setBtnLoading: function setBtnLoading(loading, idx) {
      this.footerButton[idx].loading = loading;
    },
    btnDebounce: _.debounce(function (callback) {
      var me = this;
      if (callback) {
        callback();
      }
    }, 1000, {
      'leading': true,
      'trailing': false }),

    init: function init() {
      var me = this;
      me.mwApi.process.getWorkFlowLists({ taskId: me.params.taskId }).then(function (data) {
        var res = data.result;
        if (typeof res.success != 'undefined' && !res.success) {
          me.fCount = 0;
          return;
        }
        me.workFlows = res;
        me.fCount = res.length;
        me.rowStyle = 'height:' + Math.floor(100 / me.fCount) + '%; padding-top:5px;';
        res.map(function (wf) {
          var fcandidates = [];
          var fplanneds = [];
          var fdoings = [];
          var cidx = 0;
          if (wf.candidates) {
            var cIds = [];
            wf.candidates.map(function (v) {
              if (!v.hidden) {
                if (cIds.indexOf(v.id) == -1) {
                  var node = (0, _assign2.default)({}, v);
                  node.text = v.name;
                  node.flowId = wf.id;
                  node.idx = cidx++;
                  fcandidates.push(node);
                  cIds.push(v.id);
                }
              }
            });
          }
          if (wf.planneds) {
            wf.planneds.map(function (v) {
              var node = me._subPlannedAsNode(v);
              node.flowId = wf.id;
              fplanneds.push(node);
            });
          }
          if (wf.doings) {
            wf.doings.map(function (v) {
              var node = me._subPlannedAsNode(v);
              node.flowId = wf.id;
              fdoings.push(node);
            });
          }
          me.candidates[wf.id] = fcandidates;
          me.planneds[wf.id] = fplanneds;
          me.doings[wf.id] = fdoings;
        });
      });
    },
    submit: function submit() {
      var me = this;
      me.btnDebounce(function () {
        me.setBtnLoading(true, 1);
        var activities = [];
        me.workFlows.map(function (v) {
          var activity = {};
          activity.flowId = v.id;
          activity.activityId = v.activityId;
          activity.type = v.type;
          activity.options = v.options;
          activity.items = me.mwRef("wtli" + v.id)[0].getPlannedsData();
          activities.push(activity);
        });
        var params = {};
        params.taskId = me.params.taskId;
        params.appId = me.params.appId;
        params.formId = me.params.formId;
        params.activities = activities;
        me.mwApi.process.planned(params).then(function (res) {
          me.close();
          me.formActionComplete();
          me.setBtnLoading(false, 1);
        }).catch(function () {
          me.setBtnLoading(false, 1);
        });
      });
    },
    beforeClose: function beforeClose(done) {
      var me = this;
      me.mwConfirm($lang('确定退出运转跟踪窗口？')).then(function (_) {
        if (me.params.secondfunc) {
          me.params.secondfunc();
        }
        me.resetForm();
        done();
      }).catch(function (_) {});
    },
    formActionComplete: function formActionComplete() {
      var me = this;
      if (me.params.func) {
        me.params.func();
      }
      this.resetForm();
    },
    close: function close() {
      this.resetForm();
      this.mwRef('dialog').hide();
    },
    show: function show() {
      this.mwRef('dialog').show();
    },
    resetForm: function resetForm() {
      var me = this;
      me.workFlows = [];
      me.candidates = {};
      me.planneds = {};
      me.doings = {};
      me.fCount = 0;
      me.rowStyle = 'height:225px; padding-top:5px;';
    },
    _subPlannedAsNode: function _subPlannedAsNode(v) {
      var node = {};
      node.id = v.masterObjectId;
      node.name = v.masterObjectName;
      if (v.masterObjectType == 'USER') {
        node.type = 'U';
        node.departmentId = v.masterObjectDeptId;
      } else {
        node.type = 'D';
      }
      if (v.identities) {
        node.identities = v.identities;
      }
      node.text = v.masterObjectName;
      return node;
    } } };

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });














var _treewt = __webpack_require__(355);var _treewt2 = _interopRequireDefault(_treewt);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  components: {
    MwWtTree: _treewt2.default },

  props: {
    params: {
      type: Object } },


  data: function data() {
    var me = this;
    return {
      title: $lang('运转跟踪'),
      fCount: 0,
      workFlows: [],
      doings: {},
      rowStyle: 'height:225px; padding-top:5px;',
      footerButton: [
      {
        label: $lang("取消"),
        type: "default",
        func: me.close }] };



  },
  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
    this.init();
  },
  watch: {
    params: function params() {
      this.init();
    } },

  methods: {
    init: function init() {
      var me = this;
      me.mwApi.process.getWorkFlowTrees({ taskId: me.params.taskId }).then(function (data) {
        var res = data.result;
        if (typeof res.success != 'undefined' && !res.success) {
          me.fCount = 0;
          return;
        }
        me.workFlows = res;
        me.fCount = res.length;
        me.rowStyle = 'height:' + Math.floor(100 / me.fCount) + '%; padding-top:5px;';
        me.workFlows.map(function (wf) {
          wf.url = "/rest/process/task/flow/" + me.params.taskId + "/" + wf.id + ('?_=' + Math.random());
          var fdoings = [];
          if (wf.doings) {
            wf.doings.map(function (v) {
              var node = me._subPlannedAsNode(v);
              node.flowId = wf.id;
              fdoings.push(node);
            });
          }
          me.doings[wf.id] = fdoings;
        });
      });
    },
    beforeClose: function beforeClose(done) {
      var me = this;
      me.mwConfirm($lang('确定退出运转跟踪窗口？')).then(function (_) {
        if (me.params.secondfunc) {
          me.params.secondfunc();
        }
        me.resetForm();
        done();
      }).catch(function (_) {});
    },
    formActionComplete: function formActionComplete() {
      var me = this;
      if (me.params.func) {
        me.params.func();
      }
      this.resetForm();
    },
    close: function close() {
      this.resetForm();
      this.mwRef('dialog').hide();
    },
    show: function show() {
      this.mwRef('dialog').show();
    },
    resetForm: function resetForm() {
      var me = this;
      me.workFlows = [];
      me.doings = {};
      me.fCount = 0;
      me.rowStyle = 'height:225px; padding-top:5px;';
    },
    _subPlannedAsNode: function _subPlannedAsNode(v) {
      var node = {};
      node.id = v.masterObjectId;
      node.name = v.masterObjectName;
      if (v.masterObjectType == 'USER') {
        node.type = 'U';
        node.departmentId = v.masterObjectDeptId;
      } else {
        node.type = 'D';
      }
      if (v.identities) {
        node.identities = v.identities;
      }
      node.text = v.masterObjectName;
      return node;
    } } };

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

















































var _virtuallog = __webpack_require__(1073);var _virtuallog2 = _interopRequireDefault(_virtuallog);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
_virtuallog2.default;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =





















{
  props: {
    params: {
      type: Object } },


  data: function data() {
    var me = this;
    return {
      title: $lang('意见代录'),
      form: {
        comment: '' },

      formRules: {
        comment: [{ required: true, message: $lang("请输入办理意见"), trigger: "blur" }] },

      footerButton: [
      {
        label: $lang("关闭"),
        type: "default",
        func: me.close },

      {
        label: $lang("确定"),
        func: me.submit }] };



  },
  mounted: function mounted() {
    var me = this;
    setTimeout(function () {
      me.show();
    }, 200);
    me.form.comment = '';
  },
  methods: {
    setBtnLoading: function setBtnLoading(loading, idx) {
      this.footerButton[idx].loading = loading;
    },
    btnDebounce: _.debounce(function (callback) {
      var me = this;
      if (callback) {
        callback();
      }
    }, 1000, {
      'leading': true,
      'trailing': false }),

    submit: function submit() {
      var me = this;
      this.mwRef("secrecordForm").validate(function (valid) {
        if (valid) {
          me.btnDebounce(function () {
            me.setBtnLoading(true, 1);
            var p = {};
            p.comment = me.form.comment;
            me.formActionComplete(p);
            me.setBtnLoading(false, 1);
          });
        } else {

          return;
        }
      });
    },
    beforeClose: function beforeClose(done) {
      var me = this;

      if (me.params.secondfunc) {
        me.params.secondfunc();
      }
      me.resetForm();
      done();


    },
    resetForm: function resetForm() {
      var me = this;
      me.form.comment = '';
    },
    formActionComplete: function formActionComplete(p) {
      var me = this;
      if (me.params.func) {
        me.params.func(p);
      }
      me.close();
      this.resetForm();
    },
    show: function show() {
      this.mwRef('dialog').show();
    },
    close: function close() {
      this.resetForm();
      this.mwRef('dialog').hide();
    } } };

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =














{
  props: {











    params: {
      type: Object } },


  data: function data() {
    var me = this;
    return {
      width: this.params.width || (this.params.size ? null : "400px"),
      height: this.params.height || (this.params.size ? null : "60vh"),
      dragEnable: !this.params.dragEnable,
      footerButton: [
      { label: $lang(me.params.sureName || '确定'), func: this.selectSure },
      { label: $lang(me.params.cancelName || '取消'), func: this.selectCancel, type: 'default' }] };


  },
  created: function created() {
    var me = this;
    if (me.params.buttonsScript)
    eval(me.params.buttonsScript);
    if (me.params.clearBtn == undefined || me.params.clearBtn) {
      this.footerButton.unshift({
        label: $lang('清除'),
        func: this.clearSure,
        type: 'default' });

    }
  },
  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
  },
  watch: {
    'params.url': function paramsUrl() {
    } },

  methods: {
    selectSure: function selectSure() {
      var me = this,data = this.mwRef('tree').getSelected();
      if (!data) {
        return;
      }
      var multiple = me.params.multiple ? me.params.multiple : false;
      if (multiple) {
        if (data.length > 0) {
          if (me.params.callCancel) {
            me.params.func(data, me.selectCancel);
          } else {
            me.params.func(data);
          }
        } else {
          if (me.params && me.params.noDefaultMsg) {
            me.params.func();
          } else {
            me.mwMsg("warning", "请选择相应条目！");
          }
        }
      } else {
        if (!(data instanceof Array)) {
          if (me.params.callCancel) {
            me.params.func(data, me.selectCancel);
          } else {
            me.params.func(data);
          }
        }
      }
      if (!me.params.callCancel) {
        me.selectCancel();
      }
    },
    selectCancel: function selectCancel() {
      this.mwRef('dialog').hide();
      if (this.params.search) {
        this.mwRef('tree').resetSearchText();
      }
      if (this.params.checkNodes) {
        this.params.checkNodes = [];
      }
      if (this.params.selectNode) {
        this.params.selectNode = '';
      }
    },
    clearSure: function clearSure() {
      var me = this;
      this.mwRef('tree').unCheckAll();
      var multiple = me.params.multiple ? me.params.multiple : false;
      if (multiple) {
        me.params.func([{}]);
      } else {
        me.params.func({});
      }
      me.selectCancel();
    },
    show: function show() {
      this.mwRef('dialog').show();
    } } };

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =




























































































{
  props: {













    params: {
      type: Object } },


  data: function data() {
    var me = this;
    return {
      showSelected: me.params.showSelected == undefined ? false : me.params.showSelected,
      loaded: false,
      setVal: false,
      defaultParams: {},
      tableSelectData: me.params.tableSelectData == undefined ? [] : me.params.tableSelectData,
      selectTag: me.params.selectTag == undefined ? "id" : me.params.selectTag,
      api: '',
      columns: [{ type: 'selection' },
      { prop: 'name', label: $lang('名称'), tooltip: true }],
      selectColumns: [
      { prop: 'name', label: $lang('名称'), tooltip: true }],
      footerButton: [
      { label: $lang(me.params.cancelName || '取消'), func: this.selectCancel, type: 'default' },
      {
        label: $lang(me.params.sureName || '确定'), func: this.selectSure }] };



  },
  created: function created() {
    var me = this;
    if (me.params.buttonsScript)
    eval(me.params.buttonsScript);
    if (me.params.clearBtn == undefined || me.params.clearBtn) {
      this.footerButton.unshift({
        label: $lang('清除'),
        func: this.clearSure,
        type: 'default' });

    }
  },
  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
  },
  watch: {
    'params.url': function paramsUrl() {
    } },

  methods: {
    dataLoaded: function dataLoaded(data) {
      var me = this;
      me.loaded = true;
    },

    rendered: function rendered(data) {var _this2 = this;
      var me = this;
      me.tableSelectData.forEach(function (v) {
        var idx = me.mwLodash.findIndex(data, function (o) {
          return o[me.selectTag] == v[me.selectTag];
        });
        if (idx > -1) {
          me.setVal = true;
          _this2.mwRef("dataTable").selectByProp([me.selectTag], v[me.selectTag]);
        }
      });
    },

    selectChange: function selectChange(selection) {
      var me = this;
      if (me.setVal) {
        me.setVal = false;
        return;
      }
      if (me.loaded) {
        me.loaded = false;
        if (selection.length == 0) {
          return;
        }
      }

      if (me.params.singleSelect) {
        if (me.tableSelectData.length > 0) {
          me.tableSelectData.splice(0, 1);
        }
      }

      if (me.showSelected) {
        var data = this.mwRef("dataTable").getData();
        data.forEach(function (v) {
          var idx = me.mwLodash.findIndex(selection, function (o) {
            return o[me.selectTag] == v[me.selectTag];
          });
          if (idx == -1) {
            idx = me.mwLodash.findIndex(me.tableSelectData, function (o) {
              return o[me.selectTag] == v[me.selectTag];
            });
            if (idx > -1) {
              me.tableSelectData.splice(idx, 1);
            }
          } else {
            idx = me.mwLodash.findIndex(me.tableSelectData, function (o) {
              return o[me.selectTag] == v[me.selectTag];
            });
            if (idx == -1) {
              me.tableSelectData.push(v);
            }
          }
        });
      }

    },

    selectAll: function selectAll(selection) {
      if (this.params.selectAll) {
        this.params.selectAll(selection);
      }
    },
    select: function select(selection, row) {
      if (this.params.select) {
        this.params.select(selection, row);
      }
    },
    rowClick: function rowClick(row, event, column) {
      if (this.params.rowClick) {
        this.params.rowClick(row, event, column);
      }
    },
    expand: function expand() {
      this.mwRef('tree').openAll();
    },
    closed: function closed() {
      this.mwRef('tree').closeAll();
    },
    changed: function changed(data) {
      var me = this;
      if (me.params.changed) {
        me.params.changed.call(me, data, this.mwRef('tree'), this.mwRef('dataTable'));
      } else {
        this.defaultParams = me.params.defaultParams;
      }
    },

    selectSure: function selectSure() {
      var me = this,data = me.mwRef('dataTable').getMultipleSelection();
      if (me.showSelected) {
        me.params.func(me.tableSelectData);
      } else {
        me.params.func(data);
      }
      me.selectCancel();
    },
    selectCancel: function selectCancel() {
      this.mwRef('dialog').hide();
    },
    clearSure: function clearSure() {
      var me = this;
      this.mwRef('tree').unCheckAll();
      me.params.func([]);
      me.selectCancel();
    },
    show: function show() {
      this.mwRef('dialog').show();
    } } };

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =









{
  props: {















    params: {
      type: Object } },


  data: function data() {
    var me = this;
    return {
      dialog: undefined,
      footerButton: [] };

  },
  created: function created() {
    var me = this;

    if (me.params.buttonsScript)
    eval(me.params.buttonsScript);

    if (me.params.showSure) {
      this.footerButton.push({ label: $lang(me.params.sureName || '确定'), func: this.sure });
    }
    if (me.params.showCancel) {
      this.footerButton.push({ label: $lang(me.params.cancelName || '取消'), func: this.cancel, type: 'default' });
    }
  },
  mounted: function mounted() {var _this = this;
    this.dialog = this.mwRef('dialog');
    setTimeout(function () {
      _this.show();
    }, 200);
  },
  methods: {
    show: function show() {
      this.mwRef('dialog').show();
    },

    _done: function _done() {
      this.mwRef('dialog').hide();
    },

    sure: function sure() {
      var me = this,page = me.mwRef('page'),dialog = me.mwRef('dialog');
      if (page.$refs.pageObj._dialogSure) {
        page.$refs.pageObj._dialogSure(me.params.func, me._done);
      } else {
        dialog.hide();
      }
    },

    cancel: function cancel() {
      var me = this,page = me.mwRef('page'),dialog = me.mwRef('dialog');
      if (page.$refs.pageObj._dialogCancel) {
        page.$refs.pageObj._dialogCancel(me.params.func, me._done);
      } else {
        this.mwRef('dialog').hide();
      }
    } } };

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =











{
  props: {






















    params: {
      type: Object } },


  data: function data() {
    var me = this;
    return {
      api: '',
      columns: [{ type: 'selection' },
      { prop: 'name', label: '名称', tooltip: true }],

      footerButton: [
      { label: me.params.cancelName || '取消', func: this.selectCancel, type: 'default' },
      { label: me.params.sureName || '确定', func: this.selectSure }] };


  },
  created: function created() {
    var me = this;
    if (me.params.buttonsScript)
    eval(me.params.buttonsScript);

    if (me.params.clearBtn != undefined && me.params.clearBtn) {
      this.footerButton.unshift({
        label: '清除',
        func: this.clearSure,
        type: 'default' });

    }
  },
  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
  },

  methods: {
    selectSure: function selectSure() {
      var me = this,data = me.mwRef('dataTable').getMultipleSelection();
      me.params.func(data);
      me.selectCancel();
    },

    selectCancel: function selectCancel() {
      this.mwRef('dialog').hide();
    },

    clearSure: function clearSure() {
      var me = this;
      me.params.func([]);
      me.selectCancel();
    },

    show: function show() {
      this.mwRef('dialog').show();
    } } };

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);





















var _vuex = __webpack_require__(9);
var _unit = __webpack_require__(208);var _unit2 = _interopRequireDefault(_unit);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  props: {
    params: {
      type: Object } },


  data: function data() {
    return {
      deptTreeUrl: this.mwUrl('/api/org/getDepartmentTree'),
      thisComp: this,
      api: 'org.listUser',
      footerButton: [{
        label: '确定',
        func: this.save }],

      defaultParams: {},

      treeAliasId: 'departmentId',
      columns: [{ type: 'selection' }, { type: 'index' },
      { prop: 'name', label: '名称', tooltip: true }] };

  },

  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);

  },
  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'expUser']), {

    defaultTreeParams: function defaultTreeParams() {
      var result = void 0;
      if (this.params && this.params.rootId) {
        result = { rootId: this.params.rootId };
      } else if (this.expUser.dep.loginUnit) {
        result = { rootId: this.expUser.dep.loginUnit.id };
      } else {
        result = {};
      }

      if (!(this.userInfo && this.userInfo.developer)) result.listAble = true;
      return result;
    } }),







  methods: {

    changed: function changed(data) {
      this.refreshTableDefaultParams({ departmentId: data.id });
    },

    refreshTableDefaultParams: function refreshTableDefaultParams(params) {
      this.defaultParams = params;
    },
    fillDepInfo: function fillDepInfo(data) {
      var tree = this.$refs.tree;
      var node = tree.getSelected();
      if (!node) return;
      var unitNode = node;
      while (unitNode.type === "file") {
        unitNode = tree.getNode(unitNode.parentId);
        if (!unitNode) break;
      }
      if (data) {
        data.forEach(function (d) {
          d.departmentId = node.id;
          d.departmentName = node.text;
          if (unitNode) {
            d.unitId = unitNode.id;
            d.unitName = unitNode.text;
          }
        });
      }
    },
    save: function save() {
      var data = this.mwRef('dataTable').getMultipleSelection();
      if (data.length < 1) {
        this.mwMsg('info', '请选择用户！');
        return;
      }
      this.fillDepInfo(data);
      this.params.func(data, this.$refs.footerComp, this);
      this.mwRef('dialog').hide();
    },
    show: function show() {
      this.mwRef('dialog').show();
    },
    close: function close() {
      this.mwRef('dialog').hide();
    } } };

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);






var _vuex = __webpack_require__(9);
var _org = __webpack_require__(1088);var _org2 = _interopRequireDefault(_org);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  components: {
    innerOrg: _org2.default },

  props: {
    params: {
      type: Object } },


  data: function data() {
    return {
      title: $lang(this.params.config.getConfig() ? this.params.config.getConfig().label ? this.params.config.getConfig().label : '选择部门及人员' : this.param.label ? this.param.label : '选择部门及人员'),
      footerButton: [{
        label: $lang('确定'),
        func: this.save }] };


  },

  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
  },
  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'expUser']), {

    defaultTreeParams: function defaultTreeParams() {
      return { rootId: this.expUser.dep.loginUnit.id };
    } }),

  methods: {

    changed: function changed(data) {
      this.refreshTableDefaultParams({ departmentId: data.id });
    },

    refreshTableDefaultParams: function refreshTableDefaultParams(params) {
      this.defaultParams = params;
    },

    save: function save() {
      var data = this.mwRef('org').getValue();









      this.params.func(data);
      this.mwRef('dialog').hide();
    },
    show: function show() {
      this.mwRef('dialog').show();
    },
    close: function close() {
      this.mwRef('dialog').hide();
    } } };

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =






{
  props: {
    params: {
      type: Object } },


  data: function data() {
    return {
      $org: undefined };

  },
  mounted: function mounted() {
    var me = this,selectMode = void 0;
    var config = me.params.config || {};
    var cfg = config.getConfig && config.getConfig() || {};
    if (undefined === cfg.singleSel && undefined === cfg.multiSelection) {
      selectMode = 2;
    } else if (cfg.singleSel || !cfg.multiSelection) {
      selectMode = 1;
    } else {
      selectMode = 2;
    }
    cfg.selectMode = selectMode;
    me.$nextTick(function () {
      $WR.ready(function (manager) {
        manager.create({
          xtype: 'bm/OrganizationSelection',


          $form: config.getForm && config.getForm(),
          $dd: cfg,
          renderTo: $(me.$el.querySelector('.org_select')) },
        function (x) {
          x.render();
          me.$org = x;
          if (me.params.value) {
            me.setValue(me.params.value);
          }
          x.on('showPersonalGroupManager', function (main) {
          });
        });
      });
    });
  },
  methods: {
    getValue: function getValue() {
      return this.$org.getValue();
    },
    setValue: function setValue(val) {
      return this.$org.setValue(val);
    } } };

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =



























































































































































































































































































































































































































































































{
  props: {
    params: {
      type: Object } },


  data: function data() {
    var me = this;
    return {
      title: '设置脚本',
      size: 'small_small',
      type: '',
      scriptActions: {},
      form: {
        form_create_preName: '',
        form_create_preAction: '',
        form_create_postName: '',
        form_create_postAction: '',
        form_save_preName: '',
        form_save_preAction: '',
        form_save_postName: '',
        form_save_postAction: '',
        process_start_preName: '',
        process_start_preAction: '',
        process_start_postName: '',
        process_start_postAction: '',
        process_done_preName: '',
        process_done_preAction: '',
        process_done_postName: '',
        process_done_postAction: '',
        process_suspend_preName: '',
        process_suspend_preAction: '',
        process_suspend_postName: '',
        process_suspend_postAction: '',
        process_activate_preName: '',
        process_activate_preAction: '',
        process_activate_postName: '',
        process_activate_postAction: '',
        process_terminate_preName: '',
        process_terminate_preAction: '',
        process_terminate_postName: '',
        process_terminate_postAction: '',
        process_deleted_preName: '',
        process_deleted_preAction: '',
        process_deleted_postName: '',
        process_deleted_postAction: '',
        flow_sequence_taken_preName: '',
        flow_sequence_taken_preAction: '',
        flow_sequence_taken_postName: '',
        flow_sequence_taken_postAction: '',
        task_create_postName: '',
        task_create_postAction: '',
        process_task_create_postName: '',
        process_task_create_postAction: '',
        task_check_before_handle_preName: '',
        task_check_before_handle_preAction: '',
        task_assignee_postName: '',
        task_assignee_postAction: '',
        task_assignee_preName: '',
        task_assignee_preAction: '',
        task_complete_postName: '',
        task_complete_postAction: '',
        task_complete_preName: '',
        task_complete_preAction: '',
        task_taken_postName: '',
        task_taken_postAction: '',
        task_taken_preName: '',
        task_taken_preAction: '',
        task_reject_postName: '',
        task_reject_postAction: '',
        task_reject_preName: '',
        task_reject_preAction: '' },

      scripts1: [],
      footerButton: [
      {
        label: "帮助",
        type: "info",
        func: me.helpnotes },

      {
        label: "关闭",
        type: "default",
        func: me.close },

      {
        label: "确定",
        func: me.submit }] };



  },
  mounted: function mounted() {
    var me = this;
    setTimeout(function () {
      me.show();
    }, 200);
    me.resetForm();
    me.type = me.params.type;
    me.size = me.params.size ? me.params.size : 'small_small';
    var scriptActions = me.params.scriptActions;
    if (scriptActions) {
      for (var k in scriptActions) {
        var v = scriptActions[k];
        if (v) {
          me.form[k + 'Name'] = v.name;
          me.form[k + 'Action'] = v.action;
        }
      }
      me.scriptActions = scriptActions;
    } else {
      me.scriptActions = {};
    }
  },
  methods: {
    setBtnLoading: function setBtnLoading(loading, idx) {
      this.footerButton[idx].loading = loading;
    },
    btnDebounce: _.debounce(function (callback) {
      var me = this;
      if (callback) {
        callback();
      }
    }, 1000, {
      'leading': true,
      'trailing': false }),

    submit: function submit() {
      var me = this;
      this.mwRef("secrecordForm").validate(function (valid) {
        if (!valid) {
          return false;
        }
        me.btnDebounce(function () {
          me.setBtnLoading(true, 1);
          me.formActionComplete(me.scriptActions);
          me.setBtnLoading(false, 1);
        });
      });
    },
    formActionComplete: function formActionComplete(p) {
      var me = this;
      if (me.params.func) {
        me.params.func(p);
      }
      me.close();
    },
    showFlowScript: function showFlowScript(factionType) {
      var me = this;
      var checkValues = [];
      var faction = factionType + 'Action';
      var fname = factionType + 'Name';
      var actionsSel = me.form[faction];
      var namesSel = me.form[fname];
      if (actionsSel) {
        var sAction = actionsSel.split(',');
        var sName = namesSel.split(',');
        var idx = 0;
        sAction.forEach(function (v) {
          checkValues.push({ action: v, name: sName[idx] });
          idx++;
        });
      }
      PF.show('treeTable', {
        url: me.mwUrl("/api/app/listActionComponentByTypeTree"), treeDefaultParams: { type: "系统分类/规则", flag: 0, languageType: 1 },
        size: 'large_large',
        defaultPercent: 25, selectTag: "action",
        selectDefaultPercent: 65,
        selectFirst: true, tableSelectData: checkValues, asyncLoadOnce: true, showSelected: true, clearBtn: true, title: '选择规则脚本', changed: function changed(data) {
          var me = this;
          me.defaultParams = { type: data.code, flag: 0, languageType: 1 };
        }, api: 'app.getAllButton',
        columns: [{ type: 'selection' },
        { prop: 'name', label: '名称', tooltip: true }, { prop: 'remark', label: '备注', tooltip: true }] },
      function (res) {
        var actions = [];
        var names = [];
        if (res && res.length > 0) {
          res.forEach(function (v) {
            actions.push(v.action);
            names.push(v.name);
          });
        }
        var joinAction = actions.join(',');
        var joinName = names.join(',');
        me.form[faction] = joinAction;
        me.form[fname] = joinName;
        me.scriptActions[factionType] = { action: joinAction, name: joinName };
      });
    },
    show: function show() {
      var me = this;
      me.mwRef('dialog').show();
    },
    close: function close() {
      var me = this;
      me.resetForm();
      me.mwRef('dialog').hide();
    },
    resetForm: function resetForm() {
      var me = this;
      me.form.form_create_preName = '';
      me.form.form_create_preAction = '';
      me.form.form_create_postName = '';
      me.form.form_create_postAction = '';
      me.form.form_save_preName = '';
      me.form.form_save_preAction = '';
      me.form.form_save_postName = '';
      me.form.form_save_postAction = '';
      me.form.process_start_preName = '';
      me.form.process_start_preAction = '';
      me.form.process_start_postName = '';
      me.form.process_start_postAction = '';
      me.form.process_done_preName = '';
      me.form.process_done_preAction = '';
      me.form.process_done_postName = '';
      me.form.process_done_postAction = '';
      me.form.process_suspend_preName = '';
      me.form.process_suspend_preAction = '';
      me.form.process_suspend_postName = '';
      me.form.process_suspend_postAction = '';
      me.form.process_activate_preName = '';
      me.form.process_activate_preAction = '';
      me.form.process_activate_postName = '';
      me.form.process_activate_postAction = '';
      me.form.process_terminate_preName = '';
      me.form.process_terminate_preAction = '';
      me.form.process_terminate_postName = '';
      me.form.process_terminate_postAction = '';
      me.form.process_deleted_preName = '';
      me.form.process_deleted_preAction = '';
      me.form.process_deleted_postName = '';
      me.form.process_deleted_postAction = '';
      me.form.flow_sequence_taken_preName = '';
      me.form.flow_sequence_taken_preAction = '';
      me.form.flow_sequence_taken_postName = '';
      me.form.flow_sequence_taken_postAction = '';
      me.form.task_create_postName = '';
      me.form.task_create_postAction = '';
      me.form.task_check_before_handle_preName = '';
      me.form.task_check_before_handle_preAction = '';
      me.form.task_assignee_preName = '';
      me.form.task_assignee_preAction = '';
      me.form.task_assignee_postName = '';
      me.form.task_assignee_postAction = '';
      me.form.task_complete_preName = '';
      me.form.task_complete_preAction = '';
      me.form.task_complete_postName = '';
      me.form.task_complete_postAction = '';
      me.form.task_taken_preName = '';
      me.form.task_taken_preAction = '';
      me.form.task_taken_postName = '';
      me.form.task_taken_postAction = '';
      me.form.task_reject_preName = '';
      me.form.task_reject_preAction = '';
      me.form.task_reject_postName = '';
      me.form.task_reject_postAction = '';

      me.type = '';
      me.size = 'small_small';
      me.scriptActions = {};
    },
    helpnotes: function helpnotes() {
      var me = this;
      me.mwRef('helpDialog').show();
    } } };

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =




























{
  props: {
    params: Object },

  data: function data() {
    return {
      title: "流程图" };

  },
  mounted: function mounted() {
    this.$refs.dialog.show();
  } };

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =



















{
  props: {
    params: {
      type: Object } },


  data: function data() {
    var me = this;
    return {
      activeName: 'first',
      showSecond: false,
      api: 'process.getFlowProcess',
      defaultParams: { batchId: this.params.batchId, type: 1 },
      columns: [
      { type: 'index', width: '40' },
      { prop: 'name', tooltip: true, label: '任务名称', width: '80' },
      { prop: 'sender', tooltip: true, label: '发送人', width: '80' },
      { prop: 'createTime', label: '发送时间', width: '118', formatter: me.dateFormatter },
      { prop: 'department', tooltip: true, label: '办理部门', width: '100' },
      { prop: 'assigneeName', tooltip: true, label: '办理人', width: '100' },
      { prop: 'claimTime', label: '签收时间', width: '118', formatter: me.dateFormatter },
      { prop: 'finishTime', label: '完成时间', width: '118', formatter: me.dateFormatter },
      { prop: 'status', tooltip: true, label: '状态', width: '80', formatter: me.statusFormatter },
      { prop: 'comment', label: '意见' }],


      apiSecond: 'process.getFlowProcess',
      defaultParamsSecond: { batchId: this.params.batchId, type: 0 },
      columnsSecond: [
      { type: 'index', width: '40' },
      { prop: 'name', tooltip: true, label: '任务名称', width: '80' },
      { prop: 'sender', tooltip: true, label: '发送人', width: '80' },
      { prop: 'createTime', label: '发送时间', width: '118', formatter: me.dateFormatter },
      { prop: 'department', tooltip: true, label: '办理部门', width: '100' },
      { prop: 'assigneeName', tooltip: true, label: '办理人', width: '80' },
      { prop: 'claimTime', label: '签收时间', width: '118', formatter: me.dateFormatter },
      { prop: 'finishTime', label: '完成时间', width: '118', formatter: me.dateFormatter },
      { prop: 'status', tooltip: true, label: '状态', width: '80', formatter: me.statusFormatter },
      { prop: 'comment', label: '意见' },
      { label: '操作', width: '40', formatter: me.operatorFormatter }] };


  },
  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
  },
  watch: {
    params: function params(val) {
      this.showSecond = false;
      this.activeName = 'first';
      this.defaultParams = { batchId: val.batchId, type: 1 };
      this.defaultParamsSecond = { batchId: val.batchId, type: 0 };
    } },

  methods: {
    operatorFormatter: function operatorFormatter(row) {var h = this.$createElement;
      var me = this;
      if (me.params.taskId) {
        if (row.currentUserId == row.senderId && !row.claimTime && !row.finishTime) {
          return h('span', [
          h('span', { 'class': { 'link': true }, on: { 'click': function click(event) {return me._deleteTask(row, event);} } }, ['\u53D6\u56DE'])]);



        }
      }
      return "";
    },
    statusFormatter: function statusFormatter(row, col, cellValue) {
      if (cellValue) {
        if (row.finishTime) {
          return '<' + cellValue + '>';
        }
      }
      return cellValue;
    },
    dateFormatter: function dateFormatter(row, col, cellValue) {
      if (cellValue) {
        return cellValue.substring(2, cellValue.lastIndexOf(':'));
      }
      return '';
    },
    _deleteTask: function _deleteTask(row, event) {
      event.stopPropagation();
      var me = this;
      me.mwApi.process.deleteCircularTask({ taskId: me.params.taskId, deletedTaskId: row.id }).then(function (res) {
        if (res.success) {
          me.mwRef('circularTable').refresh();
        }
      });
    },
    handleClick: function handleClick(tab, event) {
      if (tab.name == 'second' && !this.showSecond) {
        this.showSecond = true;
      }
    },

    show: function show() {
      this.mwRef('dialog').show();
    } } };

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });








var _rightPanel = __webpack_require__(373);var _rightPanel2 = _interopRequireDefault(_rightPanel);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  name: "process-interfering",
  data: function data() {
    return {
      title: "流程干预" };

  },
  props: {
    params: {
      type: Object } },


  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
  },
  methods: {
    show: function show() {
      this.mwRef('dialog').show();
    } },

  components: {
    MwFlowInterferingTable: _rightPanel2.default } };

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rightPanel_vue__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rightPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rightPanel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rightPanel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rightPanel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8a7ee81a_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_rightPanel_vue__ = __webpack_require__(1146);
function injectStyle (ssrContext) {
  __webpack_require__(1101)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8a7ee81a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rightPanel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8a7ee81a_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_rightPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);













































































































































var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);
var _simplePagination = __webpack_require__(203);var _simplePagination2 = _interopRequireDefault(_simplePagination);
var _changeFormData = __webpack_require__(1104);var _changeFormData2 = _interopRequireDefault(_changeFormData);
var _changeComment = __webpack_require__(1107);var _changeComment2 = _interopRequireDefault(_changeComment);
var _complete = __webpack_require__(1113);var _complete2 = _interopRequireDefault(_complete);
var _replaceTaskIdentity = __webpack_require__(1118);var _replaceTaskIdentity2 = _interopRequireDefault(_replaceTaskIdentity);
var _forceWithdraw = __webpack_require__(1122);var _forceWithdraw2 = _interopRequireDefault(_forceWithdraw);
var _editAttachment = __webpack_require__(1125);var _editAttachment2 = _interopRequireDefault(_editAttachment);
var _jump2normalFlow = __webpack_require__(1128);var _jump2normalFlow2 = _interopRequireDefault(_jump2normalFlow);
var _jump2concurrenceFlow = __webpack_require__(1131);var _jump2concurrenceFlow2 = _interopRequireDefault(_jump2concurrenceFlow);
var _jump2multipleInstanceFlow = __webpack_require__(1134);var _jump2multipleInstanceFlow2 = _interopRequireDefault(_jump2multipleInstanceFlow);
var _editAuthority = __webpack_require__(1137);var _editAuthority2 = _interopRequireDefault(_editAuthority);
var _recycle = __webpack_require__(1143);var _recycle2 = _interopRequireDefault(_recycle);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  name: 'mw-flow-interfering-table',
  data: function data() {
    return {
      dataList: [],
      pagination: {
        total: 0,
        start: 0,
        limit: 10 } };


  },
  props: {
    filterParams: {
      type: Object,
      default: function _default() {
        return {};
      } } },


  watch: {
    filterParams: function filterParams(val) {
      this.filterParams = val;
      if (!_.isEmpty(val))
      this.updateTable();
    } },

  mounted: function mounted() {
    if (this.filterParams.businessId || this.filterParams.businessName) {
      this.updateTable();
    }
  },
  methods: {
    updateTable: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var _ref2, result, success, totalCount;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!(
                !this.filterParams.businessName && !this.filterParams.businessId)) {_context.next = 3;break;}
                this.mwMsg("warning", "标题或业务ID不能为空!");return _context.abrupt("return");case 3:_context.next = 5;return (


                  _maintain2.default.listFlowDocument({
                    isFlow: true,
                    year: this.filterParams.year || undefined,
                    processDefinitionName:
                    (this.filterParams.processDefinition || {}).name || undefined,
                    draftsUnitId: this.filterParams.matchDept ?
                    undefined :
                    (this.filterParams.draftsUnit || {}).id || undefined,
                    draftsDeptId: this.filterParams.matchDept ?
                    (this.filterParams.draftsUnit || {}).id || undefined :
                    undefined,
                    businessNameLike: this.filterParams.businessName || undefined,
                    businessId: this.filterParams.businessId || undefined,
                    flowStatus:
                    this.filterParams.flowStatus === "2" ?
                    undefined :
                    this.filterParams.flowStatus || undefined,
                    suspensionState:
                    this.filterParams.flowStatus === "2" ?
                    "2" :
                    this.filterParams.flowStatus === "1" ||
                    this.filterParams.flowStatus === "0" ?
                    "1" :
                    undefined,
                    start: this.pagination.start || undefined,
                    limit: this.pagination.limit || undefined,
                    orderBy: this.orderBy || undefined }));case 5:_ref2 = _context.sent;result = _ref2.result;success = _ref2.success;totalCount = _ref2.totalCount;

                this.pagination = (0, _extends3.default)({},
                this.pagination, {
                  total: parseInt(totalCount, 10) });

                this.dataList = result;case 11:case "end":return _context.stop();}}}, _callee, this);}));function updateTable() {return _ref.apply(this, arguments);}return updateTable;}(),

    openForm: function openForm(data) {var

      formId =






      data.id,appId = data.applicationId,businessId = data.businessId,batchId = data.batchId,draftsDocId = data.draftsDocId,processDefinitionId = data.processDefinitionId,moduleId = data.moduleId;
      PF.show(
      "flowForm",
      {
        businessId: businessId,
        batchId: batchId,
        draftsDocId: draftsDocId,
        moduleId: moduleId,
        appId: appId,
        processDefinitionId: processDefinitionId,
        editMode: false,
        size: "large_large",
        formOpenSource: "pc:flow-interfering.table" },

      function () {},
      function () {});

    },
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selection = selection;
    },
    changeFormData: function changeFormData() {
      if (this.selection.length !== 1) {
        this.mwMsg("warning", "请选择一份文件。");
        return;
      }
      this.mwRef("changeFormDataRef").action(this.selection[0]);
    },
    changeComment: function changeComment() {
      if (this.selection.length !== 1) {
        this.mwMsg("warning", "请选择一份文件。");
        return;
      }
      this.mwRef("changeComment").action(this.selection[0]);
    },
    doRecycle: function () {var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {var _selection, _ref4, success;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:if (!(
                this.selection.length < 1)) {_context2.next = 3;break;}
                this.mwMsg("warning", "请至少选择一条记录。");return _context2.abrupt("return");case 3:


                _selection = this.selection.filter(function (x) {return x.suspensionState == "2";});if (!(
                _selection.length < 1)) {_context2.next = 7;break;}
                this.mwMsg("warning", "请选择挂起状态的流程记录！");return _context2.abrupt("return");case 7:_context2.next = 9;return (


                  _maintain2.default.activeDocument(_selection.map(function (x) {return x.batchId;}), {}));case 9:_ref4 = _context2.sent;success = _ref4.success;
                if (success) {
                  this.mwMsg('恢复成功');
                  this.updateTable();
                }case 12:case "end":return _context2.stop();}}}, _callee2, this);}));function doRecycle() {return _ref3.apply(this, arguments);}return doRecycle;}(),

    complete: function complete() {
      if (this.selection.length !== 1) {
        this.mwMsg("warning", "请选择一份文件。");
        return;
      }
      this.mwRef("complete").action(this.selection[0]);
    },
    replaceTaskIdentity: function replaceTaskIdentity() {
      if (this.selection.length !== 1) {
        this.mwMsg("warning", "请选择一份文件。");
        return;
      }
      this.mwRef("replaceTaskIdentity").action(this.selection[0]);
    },
    terminate: function () {var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {var batchId;return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:if (!(
                this.selection.length !== 1)) {_context3.next = 3;break;}
                this.mwMsg("warning", "请选择一份文件。");return _context3.abrupt("return");case 3:_context3.next = 5;return (


                  this.mwConfirm("您确定将此文件强制办结吗？请谨慎操作！"));case 5:if (!_context3.sent) {_context3.next = 12;break;}
                batchId = this.selection[0].batchId;_context3.next = 9;return (
                  _maintain2.default.terminateProcess(batchId, "强制办结", {}));case 9:if (!_context3.sent.success) {_context3.next = 12;break;}
                this.mwMsg("操作成功.");
                this.updateTable();case 12:case "end":return _context3.stop();}}}, _callee3, this);}));function terminate() {return _ref5.apply(this, arguments);}return terminate;}(),



    killTask: function () {var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {var batchId;return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:if (!(
                this.selection.length !== 1)) {_context4.next = 3;break;}
                this.mwMsg("warning", $lang("请选择一份文件"));return _context4.abrupt("return");case 3:_context4.next = 5;return (


                  this.mwConfirm($lang("您确定将此文件作废吗？请谨慎操作！")));case 5:if (!_context4.sent) {_context4.next = 12;break;}
                batchId = this.selection[0].batchId;_context4.next = 9;return (
                  _maintain2.default.suspendProcess(batchId, "", {}));case 9:if (!_context4.sent.success) {_context4.next = 12;break;}
                this.mwMsg($lang("操作成功"));
                this.updateTable();case 12:case "end":return _context4.stop();}}}, _callee4, this);}));function killTask() {return _ref6.apply(this, arguments);}return killTask;}(),



    forceWithdraw: function () {var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {return _regenerator2.default.wrap(function _callee5$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:if (!(
                this.selection.length !== 1)) {_context5.next = 3;break;}
                this.mwMsg("warning", "请选择一份文件。");return _context5.abrupt("return");case 3:



                this.mwRef("forceWithdraw").action(this.selection[0]);case 4:case "end":return _context5.stop();}}}, _callee5, this);}));function forceWithdraw() {return _ref7.apply(this, arguments);}return forceWithdraw;}(),

    editAttachment: function editAttachment() {
      if (this.selection.length !== 1) {
        this.mwMsg("warning", "请选择一份文件。");
        return;
      }
      this.mwRef("editAttachment").action(this.selection[0]);
      this.mwRef("editAttachment").mwRef("dialog").show();
    },
    handleCommand: function handleCommand(cmd) {
      this[cmd]();
    },
    jump2normalFlow: function jump2normalFlow() {
      if (this.selection.length !== 1) {
        this.mwMsg("warning", "请选择一份文件。");
        return;
      }
      this.mwRef("jump2normalFlow").action(this.selection[0]);
    },
    jump2concurrenceFlow: function jump2concurrenceFlow() {
      if (this.selection.length !== 1) {
        this.mwMsg("warning", "请选择一份文件。");
        return;
      }
      this.mwRef("jump2concurrenceFlow").action(this.selection[0]);
    },
    jump2multipleInstanceFlow: function jump2multipleInstanceFlow() {
      if (this.selection.length !== 1) {
        this.mwMsg("warning", "请选择一份文件。");
        return;
      }
      this.mwRef("jump2multipleInstanceFlow").action(this.selection[0]);
    },
    editAuthority: function editAuthority() {
      if (this.selection.length !== 1) {
        this.mwMsg("warning", "请选择一份文件。");
        return;
      }
      this.mwRef("editAuthority").action(this.selection[0]);
    } },

  components: {


    SimplePagination: _simplePagination2.default,

    ChangeFormData: _changeFormData2.default,
    ChangeComment: _changeComment2.default,
    Complete: _complete2.default,

    ReplaceTaskIdentity: _replaceTaskIdentity2.default,

    ForceWithdraw: _forceWithdraw2.default,
    EditAttachment: _editAttachment2.default,
    Jump2normalFlow: _jump2normalFlow2.default,
    Jump2concurrenceFlow: _jump2concurrenceFlow2.default,
    Jump2multipleInstanceFlow: _jump2multipleInstanceFlow2.default,
    EditAuthority: _editAuthority2.default,
    Recycle: _recycle2.default } };

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =












{
  props: {
    value: {
      type: Object,
      required: true } },



  data: function data() {
    return {};
  },

  computed: {
    currentPage: function currentPage() {
      return this.value.start / this.value.limit + 1;
    } },


  methods: {
    handleSizeChange: function handleSizeChange(x) {
      if (x !== this.value.limit) {
        this.$emit("input", (0, _extends3.default)({},
        this.value, {
          limit: x,
          start: 0 }));

      }
    },
    handleCurrentChange: function handleCurrentChange(x) {
      var start = (x - 1) * this.value.limit;
      if (!isNaN(start) && start !== this.value.start) {
        this.$emit("input", (0, _extends3.default)({},
        this.value, {
          start: start }));

      }
    } } };

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _extends3 = __webpack_require__(2);var _extends4 = _interopRequireDefault(_extends3);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);



























var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  data: function data() {var _this = this;
    return {
      footerButton: [
      {
        label: "确定",
        func: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                      _this.submit());case 2:
                    _this.mwMsg("修改成功");
                    _this.$emit('updateTable');
                    _this.mwRef("dialog").hide();case 5:case "end":return _context.stop();}}}, _callee, _this);}));function func() {return _ref.apply(this, arguments);}return func;}() },


      {
        label: "取消",
        func: function func() {
          _this.mwRef("dialog").hide();
        } }],


      nameList: [],
      hiddenFields: {},
      businessId: "",
      applicationId: "",
      moduleId: "",
      value: {},
      formKey: "",
      formId: "",
      batchId: "" };

  },

  watch: {
    "value.initformid": function valueInitformid(formId) {
      this.formId = formId;
    },

    formId: function formId(_formId) {
      this.getHiddenFields();
    } },

  mounted: function mounted() {

  },
  methods: {
    submit: function () {var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {var ofc;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                ofc = this.$refs.formView.formInst.find("office_zw");
                if (ofc && ofc.getEl().find("iframe").length > 0) {
                  ofc.saveToServer({}, true);
                }return _context2.abrupt("return",
                _maintain2.default.saveFormData({
                  $form: (0, _extends4.default)({},
                  this.$refs.formView.formData(),
                  this.hiddenFields),


                  businessId: this.businessId,
                  formKey: this.formKey,
                  moduleId: this.moduleId,
                  batchId: this.batchId }));case 3:case "end":return _context2.stop();}}}, _callee2, this);}));function submit() {return _ref2.apply(this, arguments);}return submit;}(),




    action: function () {var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(_ref3) {var applicationId = _ref3.applicationId,businessId = _ref3.businessId,moduleId = _ref3.moduleId,formEntityKey = _ref3.formEntityKey,batchId = _ref3.batchId;return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:
                this.mwRef("dialog").show();
                this.businessId = businessId;
                this.applicationId = applicationId;

                this.moduleId = moduleId;
                this.formKey = formEntityKey;
                this.batchId = batchId;case 6:case "end":return _context3.stop();}}}, _callee3, this);}));function action(_x) {return _ref4.apply(this, arguments);}return action;}(),






    handleClose: function handleClose() {

    },
    getFormData: function () {var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {var _mwApi$config$moduleC;var me, _ref6, result;return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:
                me = this;_context4.next = 3;return (
                  this.mwApi.config.moduleConfig((_mwApi$config$moduleC = {
                    dataId: this.businessId ?
                    this.businessId :
                    this.tempBusinessId ? "_" +
                    this.tempBusinessId :
                    "",
                    taskId: this.taskId,
                    processDefinitionId: this.taskId ? this.processDefinitionId : "",
                    activityId: this.taskId ? this.activityId : "" }, (0, _defineProperty3.default)(_mwApi$config$moduleC, "processDefinitionId",
                  this.flowKey), (0, _defineProperty3.default)(_mwApi$config$moduleC, "flowFlag",
                  false), (0, _defineProperty3.default)(_mwApi$config$moduleC, "forceModuleForm",
                  false), (0, _defineProperty3.default)(_mwApi$config$moduleC, "moduleId",
                  this.moduleId), (0, _defineProperty3.default)(_mwApi$config$moduleC, "appId",
                  this.appId), (0, _defineProperty3.default)(_mwApi$config$moduleC, "draftsDocId",
                  this.draftsDocId), _mwApi$config$moduleC)));case 3:_ref6 = _context4.sent;result = _ref6.result;

                this.value = result.formData;return _context4.abrupt("return",
                result.formData);case 7:case "end":return _context4.stop();}}}, _callee4, this);}));function getFormData() {return _ref5.apply(this, arguments);}return getFormData;}(),

    handleField: function handleField(item) {
      if (!item.isContainer) return;
      if (item.isContainer()) return;
      if (item.items) return;
      if (!item.isFormField) return;
      if (item.isFormField()) return;var
      xtype = item.xtype;
      switch (xtype) {
        case "Description":
        case "OfficeControl":
        case "RelFileSelection":
        case "Label":{
            break;
          }
        default:{

            item.setHidden(true);
          }}

    },

    getHiddenFields: function () {var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {var _this2 = this;var _ref8, formData, success;return _regenerator2.default.wrap(function _callee5$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (



                  this.mwApi.maintain.getHiddenFormData({
                    businessId: this.businessId,
                    formKey: this.formKey,
                    formId: this.formId,
                    applicationId: this.applicationId,
                    $form: {},
                    moduleId: this.moduleId }));case 2:_ref8 = _context5.sent;formData = _ref8.result;success = _ref8.success;

                this.nameList = formData.map(function (x) {return x.name + "(" + x.id + ")";}).sort();
                this.hiddenFields = formData.reduce(function (p, c) {
                  return (0, _extends4.default)({},
                  p, (0, _defineProperty3.default)({},
                  c.name + "(" + c.id + ")", "" + (_this2.value[c.id || ""] || "")));

                }, {});case 7:case "end":return _context5.stop();}}}, _callee5, this);}));function getHiddenFields() {return _ref7.apply(this, arguments);}return getHiddenFields;}() } };

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _objectWithoutProperties2 = __webpack_require__(210);var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);




































































































































var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);
var _simplePagination = __webpack_require__(203);var _simplePagination2 = _interopRequireDefault(_simplePagination);
var _processSelect = __webpack_require__(1109);var _processSelect2 = _interopRequireDefault(_processSelect);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  data: function data() {var _this = this;
    return {
      footerButton: [
      {
        label: "取消",
        func: function func() {
          _this.mwRef("dialog").hide();
        } }],



      footerButton2: [
      {
        label: "取消",
        func: function func() {
          _this.mwRef("dialog2").hide();
        } },

      {
        label: "确定",
        func: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var taskId, params;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                      _this.mwRef("editingFormRef").validate());case 2:if (!_context.sent) {_context.next = 14;break;}
                    taskId = _this.editingForm.task.id;

                    params = _this.mwLodash.omit(_this.editingForm, "task");
                    params.creatorId = _this.editingForm.task.assignee;
                    params.creator = _this.editingForm.task.assigneeName;
                    if (_.isDate(params.createTime)) {
                      params.createTime = moment(params.createTime).format("YYYY-MM-DD HH:mm:ss");
                    }_context.next = 10;return (

                      _maintain2.default.addComment(taskId, params, {
                        appId: _this.applicationId }));case 10:if (!_context.sent.
                    success) {_context.next = 14;break;}

                    _this.mwMsg("添加意见成功");
                    _this.mwRef("dialog2").hide();
                    _this.updateTable();case 14:case "end":return _context.stop();}}}, _callee, _this);}));function func() {return _ref.apply(this, arguments);}return func;}() }],






      footerButton3: [
      {
        label: "取消",
        func: function func() {
          _this.mwRef("dialog3").hide();
        } },

      {
        label: "确定",
        func: function () {var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {var _editingForm, isUnSaveChange, description, taskId, params;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (
                      _this.mwRef("editingFormRef2").validate());case 2:if (!_context2.sent) {_context2.next = 11;break;}_editingForm =





                    _this.editingForm2, isUnSaveChange = _editingForm.isUnSaveChange, description = _editingForm.description, taskId = _editingForm.task.id, params = (0, _objectWithoutProperties3.default)(_editingForm, ["isUnSaveChange", "description", "task"]);
                    if (_.isDate(params.createTime)) {
                      params.createTime = moment(params.createTime).format("YYYY-MM-DD HH:mm:ss");
                    }_context2.next = 7;return (

                      _maintain2.default.updateComment(
                      _this.selection.map(function (x) {return x.id;}),
                      params,
                      {
                        isUnSaveChange: isUnSaveChange,
                        description: description,
                        appId: _this.applicationId }));case 7:if (!_context2.sent.

                    success) {_context2.next = 11;break;}

                    _this.mwMsg("修改意见成功");
                    _this.mwRef("dialog3").hide();
                    _this.updateTable();case 11:case "end":return _context2.stop();}}}, _callee2, _this);}));function func() {return _ref2.apply(this, arguments);}return func;}() }],





      batchId: "",
      applicationId: "",

      pagination: {
        limit: 100,
        start: 0,
        total: 0 },


      dataList: [],

      editingForm: {
        content: "",
        contentType: "",
        category: "",
        createTime: "",
        task: {} },


      editingForm2: {
        content: "",
        contentType: "",
        category: "",
        createTime: "",
        task: {} },


      selection: [],

      editingRule: {
        content: [
        { required: true, message: "请输入意见内容", trigger: "blur" }],

        contentType: [
        { required: false, message: "请输入意见内容格式", trigger: "blur" }],

        category: [
        { required: false, message: "请输入意见类型", trigger: "blur" }],

        createTime: [
        { required: true, message: "请输入意见填写时间", trigger: "blur" }],

        task: [
        {
          validator: function validator(rule, value, callback) {
            if (!value || !value.id) {
              callback('请选择办理节点');
            } else {
              callback();
            }
          },
          trigger: "input" }] } };




  },

  methods: {
    action: function () {var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(_ref3) {var applicationId = _ref3.applicationId,moduleId = _ref3.moduleId,batchId = _ref3.batchId;return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:
                this.mwRef("dialog").show();
                this.batchId = batchId;
                this.applicationId = applicationId;

                this.updateTable();case 4:case "end":return _context3.stop();}}}, _callee3, this);}));function action(_x) {return _ref4.apply(this, arguments);}return action;}(),


    updateTable: function () {var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {var _ref6, result, success, totalCount;return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (
                  _maintain2.default.listCommentByBatch(
                  this.batchId,
                  {
                    start: this.pagination.start,
                    limit: this.pagination.limit }));case 2:_ref6 = _context4.sent;result = _ref6.result;success = _ref6.success;totalCount = _ref6.totalCount;



                this.dataList = result;
                this.pagination = (0, _extends3.default)({}, this.pagination, { total: parseInt(totalCount, 10) });case 8:case "end":return _context4.stop();}}}, _callee4, this);}));function updateTable() {return _ref5.apply(this, arguments);}return updateTable;}(),


    remove: function () {var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {return _regenerator2.default.wrap(function _callee5$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:if (!(
                this.selection.length < 1)) {_context5.next = 3;break;}
                this.mwMsg("warning", "请至少选择一条意见。");return _context5.abrupt("return");case 3:_context5.next = 5;return (



                  this.mwConfirm("确认要删除该意见吗？"));case 5:if (!_context5.sent) {_context5.next = 11;break;}_context5.next = 8;return (

                  _maintain2.default.deleteComment(this.selection.map(function (x) {return x.id;}), {
                    appId: this.applicationId }));case 8:if (!_context5.sent.
                success) {_context5.next = 11;break;}

                this.mwMsg("删除成功");
                this.updateTable();case 11:case "end":return _context5.stop();}}}, _callee5, this);}));function remove() {return _ref7.apply(this, arguments);}return remove;}(),



    add: function () {var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {return _regenerator2.default.wrap(function _callee6$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:
                this.editingForm.createTime = "" + new Date();
                this.mwRef("dialog2").show();case 2:case "end":return _context6.stop();}}}, _callee6, this);}));function add() {return _ref8.apply(this, arguments);}return add;}(),

    update: function update() {
      if (this.selection.length < 1) {
        this.mwMsg("warning", "请至少选择一条意见。");
        return;
      }
      debugger;
      this.editingForm2 = {
        content: this.selection[0].content,
        contentType: this.selection[0].contentType,
        category: this.selection[0].category,
        createTime: moment(this.selection[0].createTime).toDate(),
        task: {
          id: this.selection[0].taskId,
          name: this.selection[0].taskName } };


      this.mwRef("dialog3").show();
    },

    handleSelectionChange: function handleSelectionChange(selection) {
      this.selection = selection;
    },

    setHidden: function () {var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {return _regenerator2.default.wrap(function _callee7$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:if (!(
                this.selection.length < 1)) {_context7.next = 3;break;}
                this.mwMsg("warning", "请至少选择一条意见。");return _context7.abrupt("return");case 3:_context7.next = 5;return (



                  this.mwConfirm("确认要修改该意见不在表单上显示吗?"));case 5:if (!_context7.sent) {_context7.next = 11;break;}_context7.next = 8;return (

                  _maintain2.default.updateComment(
                  this.selection.map(function (x) {return x.id;}),
                  {
                    hidden: "1" },

                  {
                    appId: this.applicationId }));case 8:if (!_context7.sent.

                success) {_context7.next = 11;break;}

                this.mwMsg("隐藏成功");
                this.updateTable();case 11:case "end":return _context7.stop();}}}, _callee7, this);}));function setHidden() {return _ref9.apply(this, arguments);}return setHidden;}(),




    setVisible: function () {var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {return _regenerator2.default.wrap(function _callee8$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:if (!(
                this.selection.length < 1)) {_context8.next = 3;break;}
                this.mwMsg("warning", "请至少选择一条意见。");return _context8.abrupt("return");case 3:_context8.next = 5;return (



                  this.mwConfirm("确认要修改该意见在表单上显示吗?"));case 5:if (!_context8.sent) {_context8.next = 11;break;}_context8.next = 8;return (

                  _maintain2.default.updateComment(
                  this.selection.map(function (x) {return x.id;}),
                  {
                    hidden: "0" },

                  {
                    appId: this.applicationId }));case 8:if (!_context8.sent.

                success) {_context8.next = 11;break;}

                this.mwMsg("显示成功");
                this.updateTable();case 11:case "end":return _context8.stop();}}}, _callee8, this);}));function setVisible() {return _ref10.apply(this, arguments);}return setVisible;}() },





  components: {
    SimplePagination: _simplePagination2.default,
    ProcessSelect: _processSelect2.default } };

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _getIterator2 = __webpack_require__(89);var _getIterator3 = _interopRequireDefault(_getIterator2);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);






































var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  props: {
    value: {
      type: Object,
      default: function _default() {return {};} },

    batchId: {
      type: String,
      required: true } },



  data: function data() {var _this = this;
    return {
      footerButton: [
      {
        label: "确定",
        func: function func() {
          _this.mwRef("dialog").hide();
        } }],


      list: [] };

  },

  computed: {
    displayValue: function displayValue() {
      if (this.value) {
        if (this.value.name !== undefined) {
          return this.value.name;
        }
      }
      return '';
    } },


  methods: {
    load: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                  _maintain2.default.getFlowProcess(this.batchId, {}));case 2:this.list = _context.sent.result;if (!(

                this.value && this.value.id)) {_context.next = 23;break;}_iteratorNormalCompletion = true;_didIteratorError = false;_iteratorError = undefined;_context.prev = 7;
                for (_iterator = (0, _getIterator3.default)(this.list); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {item = _step.value;
                  if (item.id === this.value.id) {
                    this.mwRef('list').setCurrentRow(item);
                  }
                }_context.next = 15;break;case 11:_context.prev = 11;_context.t0 = _context["catch"](7);_didIteratorError = true;_iteratorError = _context.t0;case 15:_context.prev = 15;_context.prev = 16;if (!_iteratorNormalCompletion && _iterator.return) {_iterator.return();}case 18:_context.prev = 18;if (!_didIteratorError) {_context.next = 21;break;}throw _iteratorError;case 21:return _context.finish(18);case 22:return _context.finish(15);case 23:case "end":return _context.stop();}}}, _callee, this, [[7, 11, 15, 23], [16,, 18, 22]]);}));function load() {return _ref.apply(this, arguments);}return load;}(),


    open: function open() {
      this.mwRef("dialog").show();
      this.load();
    },
    handleSelectionChange: function handleSelectionChange(x) {
      this.$emit("input", x);
    },
    handleChange: function handleChange(val) {
      if (!val) {
        this.$emit('input', {});
      }
    } } };

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _getIterator2 = __webpack_require__(89);var _getIterator3 = _interopRequireDefault(_getIterator2);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);













































var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);
var _manSelect = __webpack_require__(380);var _manSelect2 = _interopRequireDefault(_manSelect);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  data: function data() {var _this = this;
    return {
      editingForm: {
        oneNode: "",
        oneMan: "",

        twoNode: "",
        twoMan: [] },

      unfinishedTaskQueue: [],
      taskTransactorList: [],
      nextFlowList: [],
      editingRule: {
        oneNode: [{ required: true, message: "请选择完成节点" }],
        twoNode: [{ required: true, message: "请选择完成办理人" }],
        oneMan: [{ required: true, message: "请选择送至节点" }],
        twoMan: [
        {
          validator: function validator(rule, value, callback) {
            if (!value || !value.length) {
              callback("请选择办理人");
            } else {
              callback();
            }
          } }] },



      footerButton: [
      {
        label: "确定",
        func: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var taskId, assigneeName, _ref2, activityId, type, items, params;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                      _this.mwRef("editingFormRef").validate());case 2:if (!_context.sent) {_context.next = 15;break;}
                    taskId = _this.editingForm.oneNode;
                    assigneeName = function () {
                      for (var i = 0; i < _this.taskTransactorList.length; i++) {
                        if (
                        _this.taskTransactorList[i].id === _this.editingForm.oneMan)
                        {
                          return _this.taskTransactorList[i].name;
                        }
                      }
                      return "";
                    }();_ref2 =
                    function () {
                      for (var i = 0; i < _this.nextFlowList.length; i++) {
                        if (_this.nextFlowList[i].id === _this.editingForm.twoNode) {
                          return _this.nextFlowList[i];
                        }
                      }
                      return {};
                    }(), activityId = _ref2.activityId, type = _ref2.type;
                    items = [];
                    _this.editingForm.twoMan.forEach(function (d) {
                      if (d.type === "U") {
                        searchScope: {
                          for (var i = 0; i < items.length; i++) {
                            if (items[i].group === d.parentId) {
                              items[i].users.push({ id: d.id });
                              break searchScope;
                            }
                          }

                          items.push({
                            group: d.parentId,
                            users: [{ id: d.id }] });

                        }
                      } else {
                        var users = [],
                        identities = [];var _iteratorNormalCompletion = true;var _didIteratorError = false;var _iteratorError = undefined;try {
                          for (var _iterator = (0, _getIterator3.default)(d.identities || []), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {var iden = _step.value;
                            if (iden.type == "U") {
                              users.push({ id: iden.id });
                            } else {
                              identities.push({ id: iden.id });
                            }
                          }} catch (err) {_didIteratorError = true;_iteratorError = err;} finally {try {if (!_iteratorNormalCompletion && _iterator.return) {_iterator.return();}} finally {if (_didIteratorError) {throw _iteratorError;}}}
                        items.push({
                          group: d.id,
                          users: users,
                          identities: identities });

                      }
                    });
                    params = {
                      assignee: _this.editingForm.oneMan,
                      assigneeName: assigneeName,
                      activities: [
                      {
                        flowId: _this.editingForm.twoNode,
                        activityId: activityId,
                        type: type,
                        items: items }],


                      formOpenSource: 'pc:company-index.flowInterfering.forceComplete' };_context.next = 11;return (


                      _maintain2.default.forceComplete(taskId, params));case 11:if (!_context.sent.success) {_context.next = 15;break;}
                    _this.mwMsg("强制办毕成功");

                    _this.$emit('updateTable');
                    _this.mwRef("dialog").hide();case 15:case "end":return _context.stop();}}}, _callee, _this);}));function func() {return _ref.apply(this, arguments);}return func;}() }],






      applicationId: "",
      businessId: "",
      batchId: "",
      moduleId: "" };

  },
  computed: {
    twoManUrl: function twoManUrl() {
      var taskId = this.editingForm.oneNode;
      var flowId = this.editingForm.twoNode;
      return this.mwUrl("/rest/process/task/flow/" + taskId + "/" + flowId);
    },
    twoManMultiple: function twoManMultiple() {
      for (var i = 0; i < this.nextFlowList.length; i++) {
        if (this.nextFlowList[i].id === this.editingForm.twoNode) {
          return this.nextFlowList[i].options.multipleUnit;
        }
      }
      return false;
    } },

  watch: {
    "editingForm.oneNode": function () {var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(nv, ov) {return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                if (nv !== ov) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    oneMan: "",
                    twoNode: "",
                    twoMan: [] });

                  if (nv) {
                    this.getTaskTransactorList(nv);
                    this.getNextFlowList(nv);
                  }
                }case 1:case "end":return _context2.stop();}}}, _callee2, this);}));function editingFormOneNode(_x, _x2) {return _ref3.apply(this, arguments);}return editingFormOneNode;}(),


    "editingForm.twoNode": function () {var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(nv, ov) {return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:
                if (nv !== ov) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    twoMan: [] });

                }case 1:case "end":return _context3.stop();}}}, _callee3, this);}));function editingFormTwoNode(_x3, _x4) {return _ref4.apply(this, arguments);}return editingFormTwoNode;}() },


  methods: {
    action: function () {var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(_ref5) {var applicationId = _ref5.applicationId,businessId = _ref5.businessId,batchId = _ref5.batchId,moduleId = _ref5.moduleId;return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:
                this.applicationId = applicationId;
                this.businessId = businessId;
                this.batchId = batchId;
                this.moduleId = moduleId;
                this.editingForm = {
                  oneNode: "",
                  oneMan: "",

                  twoNode: "",
                  twoMan: [] };

                this.mwRef("dialog").show();

                this.getUnfinishedTaskQueue();case 7:case "end":return _context4.stop();}}}, _callee4, this);}));function action(_x5) {return _ref6.apply(this, arguments);}return action;}(),


    getUnfinishedTaskQueue: function () {var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {return _regenerator2.default.wrap(function _callee5$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:
                this.unfinishedTaskQueue = [];_context5.next = 3;return (

                  _maintain2.default.listUnfinishedTask(this.batchId, { type: 1, unfinished: true }));case 3:_context5.t0 = _context5.sent.result;if (_context5.t0) {_context5.next = 6;break;}_context5.t0 =
                [];case 6:this.unfinishedTaskQueue = _context5.t0;

                if (!this.editingForm.oneNode && this.unfinishedTaskQueue[0]) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    oneNode: this.unfinishedTaskQueue[0].id });

                }case 8:case "end":return _context5.stop();}}}, _callee5, this);}));function getUnfinishedTaskQueue() {return _ref7.apply(this, arguments);}return getUnfinishedTaskQueue;}(),


    getTaskTransactorList: function () {var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(taskId) {return _regenerator2.default.wrap(function _callee6$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:if (
                taskId) {_context6.next = 2;break;}return _context6.abrupt("return");case 2:
                this.taskTransactorList = [];_context6.next = 5;return (
                  _maintain2.default.listTaskTransactor(
                  taskId,
                  {}));case 5:this.taskTransactorList = _context6.sent.
                result;

                if (!this.editingForm.oneMan && this.taskTransactorList[0]) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    oneMan: this.taskTransactorList[0].id });

                }case 7:case "end":return _context6.stop();}}}, _callee6, this);}));function getTaskTransactorList(_x6) {return _ref8.apply(this, arguments);}return getTaskTransactorList;}(),


    getNextFlowList: function () {var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(taskId) {return _regenerator2.default.wrap(function _callee7$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:if (
                taskId) {_context7.next = 2;break;}return _context7.abrupt("return");case 2:
                this.nextFlowList = [];_context7.next = 5;return (
                  _maintain2.default.getNextFlows(taskId, {
                    types: ["normal"] }));case 5:this.nextFlowList = _context7.sent.
                result;

                if (!this.editingForm.twoNode && this.nextFlowList[0]) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    twoNode: this.nextFlowList[0].id });

                }case 7:case "end":return _context7.stop();}}}, _callee7, this);}));function getNextFlowList(_x7) {return _ref9.apply(this, arguments);}return getNextFlowList;}() },



  components: {
    ManSelect: _manSelect2.default } };

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_manSelect_vue__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_manSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_manSelect_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_manSelect_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_manSelect_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3985e8ab_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_manSelect_vue__ = __webpack_require__(1116);
function injectStyle (ssrContext) {
  __webpack_require__(1115)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_manSelect_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3985e8ab_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_manSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _toConsumableArray2 = __webpack_require__(38);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);var _promise = __webpack_require__(19);var _promise2 = _interopRequireDefault(_promise);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _getIterator2 = __webpack_require__(89);var _getIterator3 = _interopRequireDefault(_getIterator2);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =













{
  props: {
    value: {
      type: Array,
      default: function _default() {return [];} },

    url: {
      type: String,
      required: true },

    multiple: {
      type: Boolean,
      required: true } },



  data: function data() {
    return {
      btns: [
      {
        label: "确定",
        func: this.close }] };



  },
  computed: {
    displayValue: function displayValue() {
      if (this.value && this.value.length) {
        return this.value.map(function (x) {return x.name;}).join(", ");
      }
      return "";
    } },

  methods: {
    close: function close() {
      this.mwRef("zgDeptDialog").hide();
    },

    open: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var jstree, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, id;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                this.mwRef("zgDeptDialog").show();_context.next = 3;return (
                  this.getJstreeInst());case 3:jstree = _context.sent;
                jstree.settings.core.multiple = this.multiple;
                jstree.settings.checkbox.three_state = this.multiple;
                jstree.settings.checkbox.cascade = this.multiple ?
                "up+down+undetermined" :
                "";
                jstree.refresh(true, true);if (!(

                this.value && this.value.length > 0)) {_context.next = 28;break;}_iteratorNormalCompletion = true;_didIteratorError = false;_iteratorError = undefined;_context.prev = 12;
                for (_iterator = (0, _getIterator3.default)(this.value); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {id = _step.value.id;
                  jstree.select_node('jstree_node' + id);
                }_context.next = 20;break;case 16:_context.prev = 16;_context.t0 = _context["catch"](12);_didIteratorError = true;_iteratorError = _context.t0;case 20:_context.prev = 20;_context.prev = 21;if (!_iteratorNormalCompletion && _iterator.return) {_iterator.return();}case 23:_context.prev = 23;if (!_didIteratorError) {_context.next = 26;break;}throw _iteratorError;case 26:return _context.finish(23);case 27:return _context.finish(20);case 28:case "end":return _context.stop();}}}, _callee, this, [[12, 16, 20, 28], [21,, 23, 27]]);}));function open() {return _ref.apply(this, arguments);}return open;}(),



    getJstreeInst: function getJstreeInst() {var _this = this;
      if (!this.mwRef("jstreeMountPoint")) {
        return new _promise2.default(function (resolve, reject) {
          setTimeout(function () {
            resolve(_this.getJstreeInst());
          }, 100);
        });
      }
      var jstree = $(this.mwRef("jstreeMountPoint")).jstree(true);
      if (!jstree) {
        jstree = $(this.mwRef("jstreeMountPoint")).
        on("changed.jstree", function (e, _ref2) {var selected = _ref2.selected;
          var jstree = $(_this.mwRef("jstreeMountPoint")).jstree(true);
          _this.$emit("input", selected.map(function (x) {return jstree.get_node(x).data;}).filter(function (x) {return x;}));
        }).
        jstree({
          core: {
            data: function () {var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(curNode, callback) {var groupId, departments, url;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                        groupId = "";
                        if (curNode.id === "#") {

                          groupId = "";
                        } else {
                          groupId = curNode.data.id;
                        }

                        departments = (
                        curNode.data && curNode.data.children ||
                        []).
                        filter(function (x) {return x.type !== "U";});

                        url = _this.url + "/" + groupId + ("?_=randhash" + Math.random());_context2.t0 =
                        callback;_context2.t1 = [];_context2.t2 = _toConsumableArray3.default;_context2.next = 9;return (

                          _this.mwUtil.ajax(url, { id: groupId }));case 9:_context2.t3 = _context2.sent;_context2.t4 = (0, _context2.t2)(_context2.t3);_context2.t5 = (0, _toConsumableArray3.default)(
                        departments);_context2.t6 =
                        _this.formatter;_context2.t7 = _context2.t1.concat.call(_context2.t1, _context2.t4, _context2.t5).map(_context2.t6);(0, _context2.t0)(_context2.t7);case 15:case "end":return _context2.stop();}}}, _callee2, _this);}));function data(_x, _x2) {return _ref3.apply(this, arguments);}return data;}(),


            strings: {
              "Loading ...": "加载中" },

            check_callback: true,
            multiple: this.multiple },

          plugins: ["wholerow", "checkbox", "changed"] }).

        jstree(true);
      }
      return jstree;
    },

    formatter: function formatter(x, i, a) {
      var selected = this.value.some(function (y) {return y.id === x.id;});
      return {
        id: 'jstree_node' + x.id,
        data: x,
        text: x.name,
        icon: x.hasChild ? "fa fa-folder" : "fa fa-leaf",
        li_attr: {
          class: "mw-tree",
          style: "padding:0" },

        state: {
          opened: i === 0 && x.hasChild,
          checked: selected,
          selected: selected },

        children: x.hasChild ? true : false };

    },

    handleChange: function handleChange(val) {
      if (!val) {
        this.$emit("input", []);
      }
    } } };

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
























var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);
var _allManSelect = __webpack_require__(204);var _allManSelect2 = _interopRequireDefault(_allManSelect);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  data: function data() {var _this = this;
    return {
      editingForm: {
        oneNode: "",
        twoMan: [] },

      unfinishedTaskQueue: [],
      taskTransactorList: [],
      nextFlowList: [],
      editingRule: {
        oneNode: [{ required: true, message: "请选择在办节点" }],

        twoMan: [
        {
          validator: function validator(rule, value, callback) {
            if (!value || !value.length) {
              callback("请选择办理人");
            } else {
              callback();
            }
          } }] },



      footerButton: [
      {
        label: "取消",
        func: function func() {
          _this.mwRef("dialog").hide();
        } },

      {
        label: "确定",
        func: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                      _this.mwRef("editingFormRef").validate());case 2:if (!_context.sent) {_context.next = 9;break;}_context.next = 5;return (

                      _maintain2.default.replaceTaskIdentity(_this.editingForm.oneNode, {

                        id: _this.editingForm.twoMan[0].id,
                        name: _this.editingForm.twoMan[0].name,
                        type: 'U' },
                      {}));case 5:if (!_context.sent.success) {_context.next = 9;break;}

                    _this.mwMsg("转换成功");

                    _this.$emit('updateTable');
                    _this.mwRef("dialog").hide();case 9:case "end":return _context.stop();}}}, _callee, _this);}));function func() {return _ref.apply(this, arguments);}return func;}() }],






      applicationId: "",
      businessId: "",
      batchId: '',
      moduleId: "" };

  },
  computed: {
    twoManUrl: function twoManUrl() {

    },
    twoManMultiple: function twoManMultiple() {
      return false;
    } },

  watch: {
    "editingForm.oneNode": function () {var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(nv, ov) {return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                if (nv !== ov) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    twoMan: [] });

                }case 1:case "end":return _context2.stop();}}}, _callee2, this);}));function editingFormOneNode(_x, _x2) {return _ref2.apply(this, arguments);}return editingFormOneNode;}() },


  methods: {
    action: function () {var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(_ref3) {var applicationId = _ref3.applicationId,businessId = _ref3.businessId,batchId = _ref3.batchId,moduleId = _ref3.moduleId;return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:
                this.applicationId = applicationId;
                this.businessId = businessId;
                this.batchId = batchId;
                this.moduleId = moduleId;
                this.editingForm = {
                  oneNode: "",
                  twoMan: [] };

                this.mwRef("dialog").show();

                this.getUnfinishedTaskQueue();case 7:case "end":return _context3.stop();}}}, _callee3, this);}));function action(_x3) {return _ref4.apply(this, arguments);}return action;}(),


    getUnfinishedTaskQueue: function () {var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:
                this.unfinishedTaskQueue = [];_context4.next = 3;return (

                  _maintain2.default.listUnfinishedTask(this.batchId, { type: 1, unfinished: true, undrafted: true }));case 3:_context4.t0 = _context4.sent.result;if (_context4.t0) {_context4.next = 6;break;}_context4.t0 =
                [];case 6:this.unfinishedTaskQueue = _context4.t0;

                if (!this.editingForm.oneNode && this.unfinishedTaskQueue[0]) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    oneNode: this.unfinishedTaskQueue[0].id });

                }case 8:case "end":return _context4.stop();}}}, _callee4, this);}));function getUnfinishedTaskQueue() {return _ref5.apply(this, arguments);}return getUnfinishedTaskQueue;}() },



  components: {
    AllManSelect: _allManSelect2.default } };

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =

























{
  props: {
    params: {
      type: Object },

    value: {
      type: Array,
      default: function _default() {return [];} } },


  data: function data() {
    return {

      api: "org.listUser",
      footerButton: [
      {
        label: "取消",
        func: this.cancel,
        type: "default" },

      {
        label: "确定",
        func: this.save }],


      displayValue: "",
      defaultParams: {},
      columns: [
      { type: "selection" },
      { type: "index" },
      { prop: "name", label: "名称", tooltip: true }] };


  },
  computed: {
    deptTreeUrl: function deptTreeUrl() {

      if (!this.userInfo || !this.userInfo.developer) return this.mwUrl("/api/org/listDepartmentListAble");
      return this.mwUrl("/api/org/listDepartment");
    } },

  mounted: function mounted() {

  },
  methods: {
    changed: function changed(data) {
      this.refreshTableDefaultParams({ departmentId: data.id });
    },
    refreshTableDefaultParams: function refreshTableDefaultParams(params) {
      this.defaultParams = params;
    },
    setValue: function setValue() {
      if (this.value && this.value.length) {
        this.displayValue = this.value.map(function (x) {return x.name;}).join(", ");
      } else {
        this.displayValue = "";
      }
    },
    save: function save() {
      this.$emit("chooseSec");
      this.value = this.getValue();
      this.setValue();
      this.$emit("input", this.getValue());
      this.mwRef("secDialog").hide();
    },

    cancel: function cancel() {
      this.mwRef("secDialog").hide();
    },


    getValue: function getValue() {
      return this.mwRef("dataTable").getMultipleSelection();
    },

    show: function show() {
      this.mwRef("secDialog").show();
    },
    refresh: function refresh() {
      this.mwRef("tree").refresh();
    },

    open: function open() {
      this.show();
    },
    handleChange: function handleChange(val) {
      if (!val) {
        this.$emit("input", []);
      }
    } } };

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);































var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  data: function data() {var _this = this;
    return {
      footerButton: [
      {
        label: "取消",
        func: function func() {return _this.mwRef("dialog").hide();} }],


      businessId: '',
      batchId: '',
      unfinishedTaskQueue: [] };

  },

  methods: {
    assigneeNameFormatter: function assigneeNameFormatter(a, b, c) {
      if (a.assigneeName) {
        return a.assigneeName;
      } else {
        return a.candidateName;
      }
    },
    action: function () {var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref) {var applicationId = _ref.applicationId,businessId = _ref.businessId,batchId = _ref.batchId,moduleId = _ref.moduleId;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                this.mwRef("dialog").show();
                this.businessId = businessId;
                this.batchId = batchId;
                this.getUnfinishedTaskQueue();case 4:case "end":return _context.stop();}}}, _callee, this);}));function action(_x) {return _ref2.apply(this, arguments);}return action;}(),

    getUnfinishedTaskQueue: function () {var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                this.unfinishedTaskQueue = [];_context2.next = 3;return (

                  _maintain2.default.listUnfinishedTask(this.batchId, { type: 1, unfinished: true, undrafted: true }));case 3:_context2.t0 = _context2.sent.result;if (_context2.t0) {_context2.next = 6;break;}_context2.t0 =
                [];case 6:this.unfinishedTaskQueue = _context2.t0;case 7:case "end":return _context2.stop();}}}, _callee2, this);}));function getUnfinishedTaskQueue() {return _ref3.apply(this, arguments);}return getUnfinishedTaskQueue;}(),


    forceWithdraw: function () {var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(index, row) {var _ref5, success;return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (
                  this.mwConfirm('回收'));case 2:if (!_context3.sent) {_context3.next = 8;break;}_context3.next = 5;return (
                  _maintain2.default.deleteTask(row.id, {}));case 5:_ref5 = _context3.sent;success = _ref5.success;
                if (success) {
                  this.mwMsg('回收成功');
                  this.$emit('updateTable');
                  this.mwRef("dialog").hide();
                }case 8:case "end":return _context3.stop();}}}, _callee3, this);}));function forceWithdraw(_x2, _x3) {return _ref4.apply(this, arguments);}return forceWithdraw;}() } };

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
























































var _doubleface = __webpack_require__(209);var _doubleface2 = _interopRequireDefault(_doubleface);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  data: function data() {var _this = this;
    var fileTypes = window.$Env && $Env.efileTypes ? $Env.efileTypes :
    [{ label: '正文', value: 'JOA_ZW' }, { label: '草稿', value: 'JOA_CG' }, { label: '附件', value: 'JOA_FJ' }, { label: '处理单', value: 'JOA_CLD' }];

    return {
      footerButton: [
      {
        label: "关闭",
        func: function func() {
          _this.mwRef("dialog").hide();
        } }],



      businessId: "",
      applicationId: "",
      moduleId: "",

      formId: "",
      tempBusinessId: "",
      uploadUrl: '/cheetah/service/s:maintain.srv.replaceAttachment',
      attachmentList: [],
      progressText: "",
      isFirstOpen: true,
      initAttachUploadedId: [],
      attchId: '',
      fileType: 'JOA_FJ',
      fileTypes: fileTypes,
      type: 'JOA_FJ' };

  },
  mounted: function mounted() {
    var me = this;
  },
  watch: {},
  components: {
    DoubleFace: _doubleface2.default },

  methods: {
    formatType: function formatType(type) {
      if (type == "JOA_ZW") return "正文";else
      if (type == 'JOA_CG') return '草稿';else
      if (type == 'JOA_CLD') return '处理单';else
      if (type == 'JOA_FJ') return "附件";else
      return type;
    },
    showUpload: function showUpload() {
      if (this.isFirstOpen) {
        this.$nextTick(function () {
          this.initAddUploader();
        });
        this.isFirstOpen = false;
      }
    },

    initAddUploader: function initAddUploader() {
      var me = this;
      var cfg = {
        buttonId: this.$refs.addAttachmentRef.$el,
        maxSize: 500,
        multi: false,
        action: this.mwUrl('/api/business/uploadAttachment') };

      var fn = {
        fileUploaded: function fileUploaded(up, file, resp) {
          me.importSuccessCallback(resp, file, up);
        },
        filesAdded: function filesAdded(up) {
        } };

      PF.initPupload(cfg, fn, function (up) {
        me.uploader = up;
        up.bind('FilesAdded', function (up, files) {
          up.setOption("multipart_params", {
            applicationId: me.applicationId,
            businessId: me.businessId,
            formId: me.formId,
            tempBusinessId: me.tempBusinessId,
            fullPath: 'y',
            type: me.fileType });

          up.start();
        });
      });
    },
    rename: function rename(row, index) {var _this2 = this;
      if (!row.name) {
        this.$message.error($lang('文件名不能为空'));
        return;
      }
      var params = {
        attachId: row.id,
        name: row.name,
        businessId: this.businessId,
        formId: this.formId,
        tempBusinessId: this.tempBusinessId };

      this.mwApi.business.updateAttachment(params).then(function (r) {
        _this2.listAttachment();
      });
    },
    initUploader: function initUploader() {
      var me = this;
      $.each($("button[id^='uploader_']"), function () {
        var buttonId = $(this).attr("id");
        var fjid = buttonId.substring('uploader_'.length);
        if (me.initAttachUploadedId.indexOf(buttonId) != -1) return;
        me.initAttachUploadedId.push(buttonId);
        var cfg = {
          buttonId: buttonId,
          maxSize: 500,
          multi: false,
          action: me.uploadUrl };

        var fn = {
          fileUploaded: function fileUploaded(up, file, resp) {
            me.importSuccessCallback(resp, file, up);
          },
          filesAdded: function filesAdded(up) {
          } };

        PF.initPupload(cfg, fn, function (up) {
          me.uploader = up;
          up.bind('FilesAdded', function (up, files) {
            up.setOption("multipart_params", {
              applicationId: me.applicationId,
              businessId: me.businessId,
              formId: me.formId,
              tempBusinessId: me.tempBusinessId,
              id: fjid,
              fullPath: 'y',
              type: me.type });

            up.start();
          });
        });
      });
    },
    up: function up(row) {
      this.attchId = row.id;
      this.type = row.type;
    },
    action: function action(_ref)





    {var applicationId = _ref.applicationId,businessId = _ref.businessId,moduleId = _ref.moduleId,formEntityKey = _ref.formEntityKey,tempBusinessId = _ref.tempBusinessId;
      this.businessId = businessId;
      this.applicationId = applicationId;
      this.moduleId = moduleId;
      this.formId = formEntityKey;
      this.tempBusinessId = tempBusinessId;
      this.listAttachment();
    },
    listAttachment: function () {var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var _this3 = this;var defaultResult, _ref3, _ref3$result, result;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                defaultResult = [];_context.next = 3;return (


                  this.mwApi.business.listAttachment({
                    businessId: this.businessId,
                    formId: this.formId }));case 3:_ref3 = _context.sent;_ref3$result = _ref3.result;result = _ref3$result === undefined ? defaultResult : _ref3$result;


                this.attachmentList = result.map(function (x) {
                  return (0, _extends3.default)({},
                  x, {
                    payload: {
                      businessId: _this3.businessId,
                      formId: _this3.formId,
                      attachId: x.id },

                    size: x.size ? (x.size / 1024).toFixed(2) + "K" : "" });

                });
                this.$nextTick(function () {
                  this.initUploader();
                });case 8:case 'end':return _context.stop();}}}, _callee, this);}));function listAttachment() {return _ref2.apply(this, arguments);}return listAttachment;}(),

    deleteFile: function deleteFile(_ref4) {var _this4 = this;var id = _ref4.id;
      var params = {
        businessId: this.businessId,
        formId: this.formId,
        tempBusinessId: this.tempBusinessId,
        attachIds: [id] };

      PF.confirm("确定删除？").then(function () {
        _this4.mwApi.business.deleteAttachment(params).then(function () {
          _this4.listAttachment();
        });
      });
    },
    download: function download(_ref5) {var id = _ref5.id;
      PF.downloadAttachment("/api/business/downloadAttachment", {}, false, PF.encode({
        id: id,
        businessId: this.businessId,
        formId: this.formId,
        tempBusinessId: this.tempBusinessId }));

    },
    importSuccessCallback: function importSuccessCallback(resp, file, up) {
      if (resp && resp.success) {

        this.$emit("updateTable");
        this.listAttachment();
      } else {

      }
    } } };

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);


































var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);
var _allManSelect = __webpack_require__(204);var _allManSelect2 = _interopRequireDefault(_allManSelect);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  data: function data() {var _this = this;
    return {
      editingForm: {
        oneNode: "",
        twoNode: "",
        twoMan: [] },

      unfinishedTaskQueue: [],
      nextFlowList: [],
      editingRule: {
        oneNode: [{ required: true, message: "请选择完成节点" }],
        twoNode: [{ required: true, message: "请选择送至节点" }],
        twoMan: [
        {
          validator: function validator(rule, value, callback) {
            if (!value || !value.length) {
              callback("请选择办理人");
            } else {
              callback();
            }
          } }] },



      footerButton: [
      {
        label: "确定",
        func: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var taskId, items, params;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                      _this.mwRef("editingFormRef").validate());case 2:if (!_context.sent) {_context.next = 13;break;}
                    taskId = _this.editingForm.oneNode;
                    items = [];
                    _this.editingForm.twoMan.forEach(function (d) {
                      items.push({
                        group: d.departmentId,
                        users: [{ id: d.id }] });
































                    });
                    params = {
                      $identityItems: items,
                      formOpenSource:
                      "pc:company-index.flowInterfering.jump2normalFlow",
                      actionDescription: '跳至普通节点' };_context.next = 9;return (


                      _maintain2.default.specify(taskId, _this.editingForm.twoNode, params));case 9:if (!_context.sent.success) {_context.next = 13;break;}
                    _this.mwMsg("跳转成功");
                    _this.$emit('updateTable');
                    _this.mwRef("dialog").hide();case 13:case "end":return _context.stop();}}}, _callee, _this);}));function func() {return _ref.apply(this, arguments);}return func;}() }],






      applicationId: "",
      businessId: "",
      batchId: '',
      moduleId: "" };

  },
  computed: {},
  methods: {
    action: function () {var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref2) {var applicationId = _ref2.applicationId,businessId = _ref2.businessId,moduleId = _ref2.moduleId,batchId = _ref2.batchId,processDefinitionId = _ref2.processDefinitionId;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                this.applicationId = applicationId;
                this.businessId = businessId;
                this.batchId = batchId;
                this.moduleId = moduleId;
                this.processDefinitionId = processDefinitionId;
                this.editingForm = {
                  oneNode: "",
                  oneMan: "",

                  twoNode: "",
                  twoMan: [] };

                this.mwRef("dialog").show();

                this.getUnfinishedTaskQueue();
                this.getNormalTaskActivities();case 9:case "end":return _context2.stop();}}}, _callee2, this);}));function action(_x) {return _ref3.apply(this, arguments);}return action;}(),


    getUnfinishedTaskQueue: function () {var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {var undrafted;return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:
                this.unfinishedTaskQueue = [];

                undrafted = window.$Env && $Env.specialContainDrafts === true ? false : true;_context3.next = 4;return (

                  _maintain2.default.listUnfinishedTask(this.batchId, { type: 1, unfinished: true, undrafted: undrafted }));case 4:_context3.t0 = _context3.sent.result;if (_context3.t0) {_context3.next = 7;break;}_context3.t0 =
                [];case 7:this.unfinishedTaskQueue = _context3.t0;

                if (!this.editingForm.oneNode && this.unfinishedTaskQueue[0]) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    oneNode: this.unfinishedTaskQueue[0].id });

                }case 9:case "end":return _context3.stop();}}}, _callee3, this);}));function getUnfinishedTaskQueue() {return _ref4.apply(this, arguments);}return getUnfinishedTaskQueue;}(),


    getNormalTaskActivities: function () {var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:
                this.nextFlowList = [];_context4.next = 3;return (
                  _maintain2.default.getNormalTaskActivities({
                    appId: this.applicationId,
                    processDefinitionId: this.processDefinitionId }));case 3:this.nextFlowList = _context4.sent.
                result;

                if (!this.editingForm.twoNode && this.nextFlowList[0]) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    twoNode: this.nextFlowList[0].id });

                }case 5:case "end":return _context4.stop();}}}, _callee4, this);}));function getNormalTaskActivities() {return _ref5.apply(this, arguments);}return getNormalTaskActivities;}() },



  components: {
    AllManSelect: _allManSelect2.default } };

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _getIterator2 = __webpack_require__(89);var _getIterator3 = _interopRequireDefault(_getIterator2);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);













































var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);
var _manSelect = __webpack_require__(380);var _manSelect2 = _interopRequireDefault(_manSelect);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  data: function data() {var _this = this;
    return {
      editingForm: {
        oneNode: "",
        oneMan: "",

        twoNode: "",
        twoMan: [],
        twoNodeOption: {} },

      unfinishedTaskQueue: [],
      taskTransactorList: [],
      nextFlowList: [],
      editingRule: {
        oneNode: [{ required: true, message: "请选择完成节点" }],
        twoNode: [{ required: true, message: "请选择完成办理人" }],
        oneMan: [{ required: true, message: "请选择送至节点" }],
        twoMan: [
        {
          validator: function validator(rule, value, callback) {
            if (!value || !value.length) {
              callback("请选择办理人");
            } else {
              callback();
            }
          } }] },



      footerButton: [
      {
        label: "确定",
        func: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var taskId, assigneeName, _ref2, activityId, type, items, params;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                      _this.mwRef("editingFormRef").validate());case 2:if (!_context.sent) {_context.next = 15;break;}
                    taskId = _this.editingForm.oneNode;
                    assigneeName = function () {
                      for (var i = 0; i < _this.taskTransactorList.length; i++) {
                        if (
                        _this.taskTransactorList[i].id === _this.editingForm.oneMan)
                        {
                          return _this.taskTransactorList[i].name;
                        }
                      }
                      return "";
                    }();_ref2 =
                    function () {
                      for (var i = 0; i < _this.nextFlowList.length; i++) {
                        if (_this.nextFlowList[i].id === _this.editingForm.twoNode) {
                          return _this.nextFlowList[i];
                        }
                      }
                      return {};
                    }(), activityId = _ref2.activityId, type = _ref2.type;
                    items = [];
                    _this.editingForm.twoMan.forEach(function (d) {
                      if (d.type === "U") {
                        searchScope: {
                          for (var i = 0; i < items.length; i++) {
                            if (items[i].group === d.parentId) {
                              items[i].users.push({ id: d.id });
                              break searchScope;
                            }
                          }

                          items.push({
                            group: d.parentId,
                            users: [{ id: d.id }] });

                        }
                      } else if (d.identities) {
                        var users = [],
                        identities = [];var _iteratorNormalCompletion = true;var _didIteratorError = false;var _iteratorError = undefined;try {
                          for (var _iterator = (0, _getIterator3.default)(d.identities || []), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {var iden = _step.value;
                            if (iden.type == "U") {
                              users.push({ id: iden.id });
                            } else {
                              identities.push({ id: iden.id });
                            }
                          }} catch (err) {_didIteratorError = true;_iteratorError = err;} finally {try {if (!_iteratorNormalCompletion && _iterator.return) {_iterator.return();}} finally {if (_didIteratorError) {throw _iteratorError;}}}
                        items.push({
                          group: d.id,
                          users: users,
                          identities: identities });

                      }
                    });
                    params = {
                      assignee: _this.editingForm.oneMan,
                      assigneeName: assigneeName,
                      activities: [
                      {
                        flowId: _this.editingForm.twoNode,
                        activityId: activityId,
                        type: type,
                        items: items,
                        options: _this.editingForm.twoNodeOption }],


                      formOpenSource: 'pc:company-index.flowInterfering.jump2concurrenceFlow' };_context.next = 11;return (


                      _maintain2.default.startSubProcess(taskId, params));case 11:if (!_context.sent.success) {_context.next = 15;break;}
                    _this.mwMsg("发送成功");
                    _this.$emit('updateTable');
                    _this.mwRef("dialog").hide();case 15:case "end":return _context.stop();}}}, _callee, _this);}));function func() {return _ref.apply(this, arguments);}return func;}() }],






      applicationId: "",
      businessId: "",
      batchId: '',
      moduleId: "" };

  },
  computed: {
    twoManUrl: function twoManUrl() {
      var taskId = this.editingForm.oneNode;
      var flowId = this.editingForm.twoNode;
      return this.mwUrl("/rest/process/task/flow/" + taskId + "/" + flowId);
    },
    twoManMultiple: function twoManMultiple() {
      for (var i = 0; i < this.nextFlowList.length; i++) {
        if (this.nextFlowList[i].id === this.editingForm.twoNode) {
          return this.nextFlowList[i].options.multipleUnit;
        }
      }
      return false;
    } },

  watch: {
    "editingForm.oneNode": function () {var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(nv, ov) {return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                if (nv !== ov) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    oneMan: "",
                    twoNode: "",
                    twoMan: [] });

                  if (nv) {
                    this.getTaskTransactorList(nv);
                    this.getNextFlowList(nv);
                  }
                }case 1:case "end":return _context2.stop();}}}, _callee2, this);}));function editingFormOneNode(_x, _x2) {return _ref3.apply(this, arguments);}return editingFormOneNode;}(),


    "editingForm.twoNode": function () {var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(nv, ov) {return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:
                if (nv !== ov) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    twoMan: [] });

                }case 1:case "end":return _context3.stop();}}}, _callee3, this);}));function editingFormTwoNode(_x3, _x4) {return _ref4.apply(this, arguments);}return editingFormTwoNode;}() },


  methods: {
    action: function () {var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(_ref5) {var applicationId = _ref5.applicationId,businessId = _ref5.businessId,batchId = _ref5.batchId,moduleId = _ref5.moduleId;return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:
                this.applicationId = applicationId;
                this.businessId = businessId;
                this.batchId = batchId;
                this.moduleId = moduleId;
                this.editingForm = {
                  oneNode: "",
                  oneMan: "",

                  twoNode: "",
                  twoMan: [] };

                this.mwRef("dialog").show();

                this.getUnfinishedTaskQueue();case 7:case "end":return _context4.stop();}}}, _callee4, this);}));function action(_x5) {return _ref6.apply(this, arguments);}return action;}(),


    getUnfinishedTaskQueue: function () {var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {return _regenerator2.default.wrap(function _callee5$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:
                this.unfinishedTaskQueue = [];_context5.next = 3;return (

                  _maintain2.default.listUnfinishedTask(this.batchId, { type: 1 }));case 3:_context5.t0 = _context5.sent.result;if (_context5.t0) {_context5.next = 6;break;}_context5.t0 =
                [];case 6:this.unfinishedTaskQueue = _context5.t0;

                if (!this.editingForm.oneNode && this.unfinishedTaskQueue[0]) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    oneNode: this.unfinishedTaskQueue[0].id });

                }case 8:case "end":return _context5.stop();}}}, _callee5, this);}));function getUnfinishedTaskQueue() {return _ref7.apply(this, arguments);}return getUnfinishedTaskQueue;}(),


    getTaskTransactorList: function () {var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(taskId) {return _regenerator2.default.wrap(function _callee6$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:if (
                taskId) {_context6.next = 2;break;}return _context6.abrupt("return");case 2:
                this.taskTransactorList = [];_context6.next = 5;return (
                  _maintain2.default.listTaskTransactor(
                  taskId,
                  {}));case 5:this.taskTransactorList = _context6.sent.
                result;

                if (!this.editingForm.oneMan && this.taskTransactorList[0]) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    oneMan: this.taskTransactorList[0].id });

                }case 7:case "end":return _context6.stop();}}}, _callee6, this);}));function getTaskTransactorList(_x6) {return _ref8.apply(this, arguments);}return getTaskTransactorList;}(),


    getNextFlowList: function () {var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(taskId) {return _regenerator2.default.wrap(function _callee7$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:if (
                taskId) {_context7.next = 2;break;}return _context7.abrupt("return");case 2:
                this.nextFlowList = [];_context7.next = 5;return (
                  _maintain2.default.getNextFlows(taskId, {
                    types: ["startSubProcess"] }));case 5:this.nextFlowList = _context7.sent.
                result;

                if (!this.editingForm.twoNode && this.nextFlowList[0]) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    twoNode: this.nextFlowList[0].id,
                    twoNodeOption: this.nextFlowList[0].options });

                }case 7:case "end":return _context7.stop();}}}, _callee7, this);}));function getNextFlowList(_x7) {return _ref9.apply(this, arguments);}return getNextFlowList;}() },



  components: {
    ManSelect: _manSelect2.default } };

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);























var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);
var _allManSelect = __webpack_require__(204);var _allManSelect2 = _interopRequireDefault(_allManSelect);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  data: function data() {var _this = this;
    return {
      editingForm: {
        oneNode: "",
        twoMan: [] },

      unfinishedTaskQueue: [],
      nextFlowList: [],
      editingRule: {
        oneNode: [{ required: true, message: "请选择节点" }],
        twoMan: [
        {
          validator: function validator(rule, value, callback) {
            if (!value || !value.length) {
              callback("请选择办理人");
            } else {
              callback();
            }
          } }] },



      footerButton: [
      {
        label: "确定",
        func: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var taskId, items, params;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                      _this.mwRef("editingFormRef").validate());case 2:if (!_context.sent) {_context.next = 13;break;}
                    taskId = _this.editingForm.oneNode;
                    items = [];
                    _this.editingForm.twoMan.forEach(function (d) {
                      items.push({
                        group: d.departmentId,
                        users: [{ id: d.id }] });































                    });
                    params = {
                      $identityItems: items,
                      formOpenSource:
                      "pc:company-index.flowInterfering.jump2multipleInstanceFlow",
                      actionDescription: '多实例添加办理人' };_context.next = 9;return (


                      _maintain2.default.addTask(taskId, params));case 9:if (!_context.sent.success) {_context.next = 13;break;}
                    _this.mwMsg("添加办理人成功");
                    _this.$emit('updateTable');
                    _this.mwRef("dialog").hide();case 13:case "end":return _context.stop();}}}, _callee, _this);}));function func() {return _ref.apply(this, arguments);}return func;}() }],






      applicationId: "",
      businessId: "",
      batchId: '',
      moduleId: "" };

  },
  computed: {},
  methods: {
    action: function () {var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref2) {var applicationId = _ref2.applicationId,businessId = _ref2.businessId,moduleId = _ref2.moduleId,batchId = _ref2.batchId,processDefinitionId = _ref2.processDefinitionId;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                this.applicationId = applicationId;
                this.businessId = businessId;
                this.batchId = batchId;
                this.moduleId = moduleId;
                this.processDefinitionId = processDefinitionId;
                this.editingForm = {
                  oneNode: "",
                  oneMan: "",

                  twoMan: [] };

                this.mwRef("dialog").show();

                this.getUnfinishedTaskQueue();case 8:case "end":return _context2.stop();}}}, _callee2, this);}));function action(_x) {return _ref3.apply(this, arguments);}return action;}(),



    getUnfinishedTaskQueue: function () {var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:
                this.unfinishedTaskQueue = [];_context3.next = 3;return (

                  _maintain2.default.listUnfinishedTask(this.batchId, { type: 1, multi: true }));case 3:_context3.t0 = _context3.sent.result;if (_context3.t0) {_context3.next = 6;break;}_context3.t0 =
                [];case 6:this.unfinishedTaskQueue = _context3.t0;

                if (!this.editingForm.oneNode && this.unfinishedTaskQueue[0]) {
                  this.editingForm = (0, _extends3.default)({},
                  this.editingForm, {
                    oneNode: this.unfinishedTaskQueue[0].id });

                }case 8:case "end":return _context3.stop();}}}, _callee3, this);}));function getUnfinishedTaskQueue() {return _ref4.apply(this, arguments);}return getUnfinishedTaskQueue;}() },



  components: {
    AllManSelect: _allManSelect2.default } };

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);




























var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);
var _authorityEditor = __webpack_require__(1139);var _authorityEditor2 = _interopRequireDefault(_authorityEditor);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  data: function data() {var _this = this;
    return {
      footerButton: [
      {
        label: "取消",
        func: function func() {
          _this.mwRef("dialog").hide();
        } }],



      footerButton2: [
      {
        label: "取消",
        func: function func() {
          _this.mwRef("dialog2").hide();
        } },

      {
        label: "确定",
        func: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var _ref2, success;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                      _maintain2.default.coverAuthority({
                        businessId: _this.businessId,
                        authObjIds: _this.currentAuthority.map(function (x) {return x[_authorityEditor.USEDID];}),
                        authType: _this.currentAuthorityType,
                        formKey: _this.formKey }));case 2:_ref2 = _context.sent;success = _ref2.success;

                    if (success) {
                      _this.mwMsg("添加成功.");
                      _this.currentAuthority = [];
                      _this.mwRef("dialog2").hide();
                      _this.getAuthorityList();
                    }case 5:case "end":return _context.stop();}}}, _callee, _this);}));function func() {return _ref.apply(this, arguments);}return func;}() }],




      authorityList: [],
      businessId: "",
      applicationId: "",
      moduleId: "",
      formKey: "",

      currentAuthority: [],
      currentAuthorityType: "",
      dialog2Title: '' };

  },

  methods: {
    submit: function () {var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:case "end":return _context2.stop();}}}, _callee2, this);}));function submit() {return _ref3.apply(this, arguments);}return submit;}(),

    action: function () {var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(_ref4) {var applicationId = _ref4.applicationId,businessId = _ref4.businessId,moduleId = _ref4.moduleId,formEntityKey = _ref4.formEntityKey;return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:
                this.mwRef("dialog").show();

                this.businessId = businessId;
                this.applicationId = applicationId;

                this.moduleId = moduleId;
                this.formKey = formEntityKey;

                this.getAuthorityList();case 6:case "end":return _context3.stop();}}}, _callee3, this);}));function action(_x) {return _ref5.apply(this, arguments);}return action;}(),


    handleClose: function handleClose() {

    },

    getAuthorityList: function () {var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {var _ref7, authorsList, total;return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (



                  this.mwApi.maintain.listAuthority({
                    businessId: this.businessId,
                    formKey: this.formKey }));case 2:_ref7 = _context4.sent;authorsList = _ref7.result;total = _ref7.totalCount;

                this.total = parseInt(total, 10) || 0;
                this.authorityList = authorsList;case 7:case "end":return _context4.stop();}}}, _callee4, this);}));function getAuthorityList() {return _ref6.apply(this, arguments);}return getAuthorityList;}(),


    addAuthorAuthority: function addAuthorAuthority() {
      this.addAuthority("authors");
    },

    addReaderAuthority: function addReaderAuthority() {
      this.addAuthority("readers");
    },

    deleteAuthority: function () {var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {var selection;return _regenerator2.default.wrap(function _callee5$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:
                selection = this.$refs.table.selection;_context5.next = 3;return (

                  this.$confirm("您是否确定要删除？"));case 3:if (!_context5.sent) {_context5.next = 9;break;}_context5.next = 6;return (

                  _maintain2.default.deleteAuthority({
                    businessId: this.businessId,
                    formKey: this.formKey,
                    authReaderObjs: selection.map(function (x) {
                      return {
                        objId: x.id,
                        authType: x.type };

                    }) }));case 6:if (!_context5.sent) {_context5.next = 9;break;}


                this.mwMsg("删除成功.");
                this.getAuthorityList();case 9:case "end":return _context5.stop();}}}, _callee5, this);}));function deleteAuthority() {return _ref8.apply(this, arguments);}return deleteAuthority;}(),




    addAuthority: function addAuthority(type) {var
      selection = this.$refs.table.selection;

      this.currentAuthority = this.authorityList.
      filter(function (x) {return x.type === type;}).
      map(function (x) {return (0, _extends3.default)({}, x, { label: x.name });});
      this.currentAuthorityType = type;
      this.dialog2Title = {
        'authors': '修改作者域',
        'readers': '修改读者域' }[
      type];
      this.$refs.dialog2.show();
    } },


  components: {
    AuthorityEditor: _authorityEditor2.default } };

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.USEDID = undefined;var _slicedToArray2 = __webpack_require__(60);var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);var _toConsumableArray2 = __webpack_require__(38);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _extends4 = __webpack_require__(2);var _extends5 = _interopRequireDefault(_extends4);var _objectWithoutProperties2 = __webpack_require__(210);var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);






























































var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var USEDID = exports.USEDID = "useIdByThisPage";exports.default =




{
  props: {
    value: {
      type: Array,
      default: function _default() {return [];} } },


  data: function data() {
    return {
      titleStyle:
      "height: 30px;line-height:30px;background:#eee;padding:0 5px;",
      bodyStyle:
      "border-top:30px solid transparent;margin-top:-30px;height:100%;",
      detailTreeDefaultExpanedKeys: [],
      defaultTreeProps: {
        children: "children",
        label: "label",
        disabled: "disabled",
        isLeaf: "isLeaf" },

      pendingSelectionChange: [],
      applySelectionChangeTimeout: null,
      USEDID: USEDID };

  },

  computed: {
    detailTreeDefaultCheckKeys: function detailTreeDefaultCheckKeys() {
      return this.value.map(function (x) {return x[USEDID];});
    } },


  methods: {
    loadNavTree: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(node, resolver) {var params, _ref2, result, type, path, isLeaf;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                params = {
                  id: "",
                  type: "" };


                if (node.level === 0) {
                  params.id = "#root";
                  params.type = "#root";
                } else if (node.data) {
                  params.id = node.data.id;
                  params.type = node.data.type;
                }_context.next = 4;return (

                  _maintain2.default.listOrgRes(params));case 4:_ref2 = _context.sent;result = _ref2.result;
                type = params.type;
                path = "";
                isLeaf = false;
                resolver(
                this.trimDuplicatedBy(
                result.map(function (_ref3) {var name = _ref3.name,rest = (0, _objectWithoutProperties3.default)(_ref3, ["name"]);
                  if (node.level === 0) {
                    type = rest.id;
                  }

                  if (node.level > 0) {
                    switch (type) {
                      case "#roles":
                      default:{
                          isLeaf = rest.leaf === true || rest.hasChild === 0;
                        }}

                  }
                  return (0, _extends5.default)({
                    label: name,
                    name: name,
                    type: type,
                    isLeaf: isLeaf },
                  rest);

                }),
                "id"));case 10:case "end":return _context.stop();}}}, _callee, this);}));function loadNavTree(_x, _x2) {return _ref.apply(this, arguments);}return loadNavTree;}(),




    handleNav: function handleNav(data, node, comp) {var _this = this;
      this.selectedNav = data;
      this.$refs.detailTree.store.load = function () {var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(node, resolver) {var result, params;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                  result = [];if (!(
                  node.data && node.data.children && $.isArray(node.data.children))) {_context2.next = 5;break;}
                  result = node.data.children.map(function (x) {
                    var idKey = "objId";
                    if (!x[idKey]) idKey = "id";
                    return (0, _extends5.default)({},
                    x, (0, _defineProperty3.default)({
                      isLeaf: true,
                      type: data.type },
                    USEDID, x[idKey]));

                  });_context2.next = 10;break;case 5:

                  params = {
                    id: (node && node.data || {}).id || data.id,
                    type: data.type,
                    path: data.name };_context2.next = 8;return (

                    _maintain2.default.listOrgDetail(params));case 8:_context2.t0 = function (x) {var _extends3;
                    var idKey = "objId";
                    if (!x[idKey]) idKey = "id";

                    return (0, _extends5.default)({},
                    x, (_extends3 = {}, (0, _defineProperty3.default)(_extends3,
                    USEDID, x[idKey]), (0, _defineProperty3.default)(_extends3, "isLeaf",
                    x.leaf !== false), _extends3));

                  };result = _context2.sent.result.map(_context2.t0);case 10:


                  _this.detailTreeDefaultExpanedKeys.length = 0;
                  _this.detailTreeDefaultExpanedKeys = result.filter(function (x) {
                    if (x.children) return x[USEDID];
                  });
                  resolver(
                  _this.trimDuplicatedBy(
                  result.map(function (_ref5) {var name = _ref5.name,rest = (0, _objectWithoutProperties3.default)(_ref5, ["name"]);
                    return (0, _extends5.default)({
                      label: name,
                      name: name },
                    rest);

                  }),
                  "id"));



                  _this.$nextTick(function () {
                    _this.$refs.detailTree.filter();
                  });case 14:case "end":return _context2.stop();}}}, _callee2, _this);}));return function (_x3, _x4) {return _ref4.apply(this, arguments);};}();

      this.$refs.detailTree.store.root.loaded = false;
      this.$refs.detailTree.store.root.loading = false;
      this.$refs.detailTree.store.root.childNodes = [];

      this.$refs.detailTree.store.root.loadData();
    },

    handleDetail: function handleDetail(data, node, comp) {},

    handleDetailTreeCheckChange: function handleDetailTreeCheckChange(data, checked) {
      if (data && data.children) return;

      this.pendingSelectionChange.push([data, checked]);

      clearTimeout(this.applySelectionChangeTimeout);
      this.applySelectionChangeTimeout = setTimeout(this.applySelectionChange);
    },

    filterNodeMethod: function filterNodeMethod(value, data, node) {
      if (data && data.children) return true;
      if (this.value.some(function (x) {return x.id === data[USEDID];})) {
        return false;
      }
      return true;
    },

    applySelectionChange: function applySelectionChange() {var _this2 = this;
      var value = [].concat((0, _toConsumableArray3.default)(this.value));var _loop = function _loop(
      i) {var _pendingSelectionChan = (0, _slicedToArray3.default)(
        _this2.pendingSelectionChange[i], 2),data = _pendingSelectionChan[0],checked = _pendingSelectionChan[1];
        if (checked) {
          value.push(data);
        } else {
          value = value.filter(function (x) {return x[USEDID] !== data[USEDID];});
        }};for (var i = 0; i < this.pendingSelectionChange.length; i++) {_loop(i);
      }
      this.$emit("input", value);
      this.pendingSelectionChange.length = 0;
      setTimeout(function () {
        _this2.$refs.detailTree.filter();
      }, 100);
    },

    renderContent: function renderContent(h, _ref6) {var _this3 = this;var node = _ref6.node,data = _ref6.data,store = _ref6.store;
      return (
        h("span", { "class": "custom-tree-node", style: "width:100%;" }, [
          h("span", { style: "display:table-cell;width:100%;" }, [node.label]),
          h("span", { style: "display:table-cell;padding:0 8px;" }, [
            h("el-button", { attrs: {
                  type: "text" },
                "class": "be-text", on: { "click":
                  function click() {return _this3.remove(node, data);} } }, [

              h("i", { "class": "el-icon el-icon-close" })])])]));




    },

    remove: function remove(node, data) {var _this4 = this;
      this.$emit("input", this.value.filter(function (x) {return x[USEDID] !== data[USEDID];}));
      this.$nextTick(function () {
        _this4.$refs.detailTree.setCheckedKeys(_this4.detailTreeDefaultCheckKeys);
        _this4.$refs.detailTree.filter();
      });
    },

    trimDuplicatedBy: function trimDuplicatedBy(array, field) {
      var footprints = {};
      for (var i = 0; i < array.length;) {
        var item = array[i];
        if (item[field] in footprints) {
          array.splice(i, 1);
        } else {
          footprints[item[field]] = true;
          i++;
        }
      }
      return array;
    } },


  watch: {
    value: function value(_value) {
      for (var i = 0; _value && i < _value.length; i++) {
        if (_value[i] && !(USEDID in _value[i])) {
          _value[i][USEDID] = _value[i].id;
        }
      }
      this.$refs.detailTree.filter();
      this.$refs.detailTree.setCheckedKeys([]);
    } } };

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);




































var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);
var _simplePagination = __webpack_require__(203);var _simplePagination2 = _interopRequireDefault(_simplePagination);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  data: function data() {
    return {
      selection: [],
      dataList: [],
      pagination: {
        limit: 100,
        start: 0,
        total: 0 } };


  },

  methods: {
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selection = selection;
    },
    remove: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var _ref2, success;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
                  this.mwConfirm('确定删除'));case 2:if (!_context.sent) {_context.next = 8;break;}_context.next = 5;return (
                  _maintain2.default.deleteDocument(this.selection.map(function (x) {return x.draftsDocId;}), {}));case 5:_ref2 = _context.sent;success = _ref2.success;
                if (success) {
                  this.mwMsg('删除成功');
                  this.updateTable();
                  this.$emit("updateTable");
                }case 8:case "end":return _context.stop();}}}, _callee, this);}));function remove() {return _ref.apply(this, arguments);}return remove;}(),


    active: function () {var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {var _ref4, success;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:if (!(
                this.selection.length < 1)) {_context2.next = 3;break;}
                this.mwMsg("warning", "请至少选择一条记录。");return _context2.abrupt("return");case 3:_context2.next = 5;return (


                  _maintain2.default.activeDocument(this.selection.map(function (x) {return x.batchId;}), {}));case 5:_ref4 = _context2.sent;success = _ref4.success;
                if (success) {
                  this.mwMsg('恢复成功');
                  this.updateTable();
                  this.$emit("updateTable");
                }case 8:case "end":return _context2.stop();}}}, _callee2, this);}));function active() {return _ref3.apply(this, arguments);}return active;}(),

    action: function () {var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {return _regenerator2.default.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:
                this.mwRef("dialog").show();
                this.getListFlowSuspend();case 2:case "end":return _context3.stop();}}}, _callee3, this);}));function action() {return _ref5.apply(this, arguments);}return action;}(),

    getListFlowSuspend: function () {var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {var _ref7, result;return _regenerator2.default.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (
                  _maintain2.default.listFlowSuspend({ start: 0, limit: 10 }));case 2:_ref7 = _context4.sent;result = _ref7.result;
                this.dataList = result;case 5:case "end":return _context4.stop();}}}, _callee4, this);}));function getListFlowSuspend() {return _ref6.apply(this, arguments);}return getListFlowSuspend;}(),

    updateTable: function () {var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {var _ref9, result, success, totalCount;return _regenerator2.default.wrap(function _callee5$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (
                  _maintain2.default.listFlowSuspend(
                  {
                    start: this.pagination.start,
                    limit: this.pagination.limit }));case 2:_ref9 = _context5.sent;result = _ref9.result;success = _ref9.success;totalCount = _ref9.totalCount;



                this.dataList = result;
                this.pagination = (0, _extends3.default)({}, this.pagination, { total: parseInt(totalCount, 10) });case 8:case "end":return _context5.stop();}}}, _callee5, this);}));function updateTable() {return _ref8.apply(this, arguments);}return updateTable;}() },


  components: {
    SimplePagination: _simplePagination2.default } };

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =



























































{
  props: {
    params: {
      type: Object } },


  data: function data() {
    return {
      footerButton: [
      {
        label: "确定",
        func: this.saveSure }],


      noticeWay: [],
      notifierId: [],
      notifier: [],
      taskId: [],
      form: {
        urgeTasks: [] } };


  },
  created: function created() {
    this.initData();
  },
  mounted: function mounted() {var _this = this;
    var me = this;
    setTimeout(function () {
      _this.show();
      if (_this.params.data && _this.params.data.length > 0) {

        _this.params.data.forEach(function (it) {
          if (it.transactors && it.transactors.length > 0) _this.notifierId.concat(it.transactors);
        });
      }
    }, 200);
  },
  watch: {
    params: function params(val) {
      this.form = { urgeTasks: [] };
      this.noticeWay = [];
      this.notifierId = [];
      this.notifier = [];
      this.taskId = [];
      this.mwRef("urgeForm").resetFields();
      this.initData();
    } },

  methods: {
    initData: function initData() {
      this.form.businessName = this.params.businessName;
    },
    saveSure: function saveSure() {var _this2 = this;
      if (!this.form.message) {
        this.form.message = $lang("请及时处理。");
      }
      if (this.notifierId.length == 0) {
        PF.message($lang("请选择通知人。"));
        return;
      }
      this.form.urgeTasks = [];
      this.taskId.forEach(function (t, index) {
        _this2.form.urgeTasks.push({
          taskId: _this2.taskId[index],
          urgedUserId: _this2.notifierId[index],
          urgedUser: _this2.notifier[index] });

      });
      this.params.func(this.form);
      this.mwRef("urgeForm").resetFields();
      this.form = { urgeTasks: [] };
      this.noticeWay = [];
      this.notifierId = [];
      this.notifier = [];
      this.taskId = [];
      this.mwRef("dialog").hide();
    },
    handleChange: function handleChange(data) {var _this3 = this;

      var notifier = [];
      var taskId = [];

      data.forEach(function (t) {
        _this3.params.data.forEach(function (d) {
          d.transactors.forEach(function (r) {
            if (t === r.id) {
              notifier.push(r.name);
              taskId.push(d.taskId);
              return;
            }
          });
        });
      });

      this.notifier = notifier;
      this.taskId = taskId;
    },
    handleNoticeChange: function handleNoticeChange(data) {
      this.form.remindMode = data.join();
    },
    handleClose: function handleClose() {
      this.mwRef("urgeForm").resetFields();
      this.form = { urgeTasks: [] };
      this.noticeWay = [];
      this.notifierId = [];
      this.notifier = [];
      this.taskId = [];
      this.mwRef("dialog").hide();
    },
    show: function show() {
      this.mwRef("dialog").show();
    } } };

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);






















var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  props: {
    params: {
      type: Object } },


  data: function data() {
    return {
      deptTreeUrl: this.mwUrl('/api/org/getDepartmentTree'),
      api: 'org.listUser',
      footerButton: [{
        label: $lang('确定'),
        func: this.save }],

      defaultParams: {},

      treeAliasId: 'departmentId',
      columns: [{ type: 'selection' }, { type: 'index' },
      { prop: 'name', label: $lang('名称'), tooltip: true }] };

  },

  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);

  },
  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'expUser']), {

    defaultTreeParams: function defaultTreeParams() {
      var result = { rootId: this.expUser.dep.loginUnit.id };
      if (!(this.userInfo && this.userInfo.developer)) result.listAble = true;
      return result;
    } }),







  methods: {

    changed: function changed(data) {
      this.refreshTableDefaultParams({ departmentId: data.id });
    },

    refreshTableDefaultParams: function refreshTableDefaultParams(params) {
      this.defaultParams = params;
    },

    save: function save() {
      var data = this.mwRef('dataTable').getMultipleSelection();
      if (data.length < 1) {
        this.mwMsg('info', $lang('请选择用户'));
        return;
      }
      var params = {};
      params.receiver = {
        id: data[0].id,
        name: data[0].name };

      this.params.func(params);
      this.mwRef('dialog').hide();
    },
    show: function show() {
      this.mwRef('dialog').show();
    },
    close: function close() {
      this.mwRef('dialog').hide();
    },
    treeDataFilter: function treeDataFilter(data) {
      if (data && window.$currentBrowserLanguage === 'en') {
        data.forEach(function (d) {return d.text = d.Englishname || d.text;});
      }
    } } };

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =



{
  props: {
    params: {
      type: Object } } };

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =












{
  props: {
    params: {
      type: Object } },


  data: function data() {
    return {
      size: this.params.size ? this.params.size : 'full',
      dialog: undefined,
      title: this.params.title ? this.params.title : '',
      updatedData: false,
      width: this.params.width,
      height: this.params.height };

  },
  mounted: function mounted() {var _this = this;
    this.dialog = this.mwRef('dialog');
    setTimeout(function () {
      _this.show();
    }, 200);
  },
  watch: {},


  methods: {
    formConfigLoaded: function formConfigLoaded(config) {

      if (config && config.content) {
        if (!this.params.width) this.width = config.content.dialogWidth;
        if (!this.params.height) this.height = config.content.dialogHeight;
      }
    },
    setSize: function setSize(val) {
      if (this.size != 'full')
      this.size = val;
    },

    getTitle: function getTitle(title) {
      if (!this.title) {
        this.title = title;
      }
    },
    beforeRender: function beforeRender($form) {
      var me = this;
      this.$form = $form;
      if (me.params.isNewCallback && me.params.func) {
        me.params.func.call(me, $form);
      }
    },
    beforeClose: function beforeClose(done) {
      var me = this;
      var editMode = me.mwRef('form').getEditMode();
      if (!editMode) {
        if (me.params.secondfunc) {
          if (me.params.secondfunc(me.updatedData, me.$form, done) === false) return;
        }
        me.resetForm();
        done();
      } else {
        me.mwRef('form').noticeButtonEvent('openDialog');
        if (me.mwRef('form').getFormValueChange()) {
          PF.confirm($lang('确认退出编辑？'), $lang("提示")).then(function () {
            if (me.params.secondfunc) {
              me.params.secondfunc(me.updatedData, me.$form);
            }
            me.resetForm();
            done();
          }, function () {});









        } else {
          if (me.updatedData && me.params.secondfunc) {
            if (me.params.secondfunc(me.updatedData, me.$form, done) === false) return;
          }
          me.resetForm();
          done();
        }
      }
    },
    resetForm: function resetForm() {
      this.params.moduleId = '';
      var form = this.mwRef('form');
      this.mwRef('dialog').hide();
      form.$emit("dialogClose");
      form.resetForm();
    },
    _updatedData: function _updatedData(isRefresh) {
      this.updatedData = isRefresh;
    },
    formActionComplete: function formActionComplete($form, data) {
      var me = this;
      if (!me.params.isNewCallback && me.params.func) {
        me.params.func($form, data);
      }
      this.resetForm();
    },
    show: function show() {
      this.mwRef('dialog').show();
    } } };

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =

















{
  props: {
    params: {
      type: Object } },


  data: function data() {
    var me = this;

    return {
      activeName: 'first',
      api: '/s:business.srv.listFlowLog',
      defaultParams: { batchId: this.params.batchId },
      columns: [
      { type: "index" },
      { prop: 'createTime', label: $lang('操作时间'), width: '160' },
      { prop: 'operator', tooltip: true, label: $lang('用户名'), width: '80' },
      { prop: 'actionName', tooltip: true, label: $lang('操作类型'), width: '80' },
      { prop: 'description', tooltip: true, label: $lang('操作说明'), slot: { type: 'html', func: function func() {} } },
      { prop: "accessType", label: $lang("客户端类型"), width: '90' },
      { prop: 'ip', label: $lang('客户端IP'), width: '118' }] };


  },
  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
  },
  watch: {
    params: function params(val) {
      this.activeName = 'first';
      this.defaultParams = { batchId: val.batchId };
    } },

  methods: {
    dateFormatter: function dateFormatter(row, col, cellValue) {
      if (cellValue) {
        return cellValue.substring(2, cellValue.lastIndexOf(':'));
      }
      return '';
    },
    statusFormatter: function statusFormatter(row, col, cellValue) {
      if (row.finishTime) {
        return '<' + cellValue + '>';
      }
      return cellValue;
    },
    oprrecordFormatter: function oprrecordFormatter(row, col, cellValue) {var h = this.$createElement;
      if (!cellValue) {
        return '';
      }

      var coms = cellValue.map(function (d) {
        return (
          h('li', [
          d.createTime.substring(2, d.createTime.lastIndexOf(':')) + ' ' + d.operator + ' ' + d.actionName + (d.description ? ': ' + d.description : '')]));


      });
      return h('span', ['  ', coms, ' ']);
    },
    handleClick: function handleClick(tab, event) {

    },
    show: function show() {
      this.mwRef('dialog').show();
    } } };

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =






{
  props: {
    params: {
      type: Object } },



  data: function data() {
    var me = this;
    return {};


  },

  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
  },

  methods: {
    beforeClose: function beforeClose(done) {
      if ($.isFunction(this.params.secondfunc)) {
        this.params.secondfunc();
      }
      done();
    },
    show: function show() {
      this.mwRef('dialog').show();
    } } };

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =






{
  props: {
    params: {
      type: Object } },


  data: function data() {
    var formConfig = undefined;
    if (this.params && this.params.config) {
      formConfig = {
        getForm: this.params.config.getForm,
        config: this.params.config.getConfig(),
        way: 'open' };

    }
    if (!this.params.multi) {
      this.params.multiple = false;
    }
    var footerButton = [];
    var addClearBtn = true;
    var okBtnLabel = "确定";
    if (this.params) {
      addClearBtn = !this.params.notShowClearBtn;
      okBtnLabel = this.params.okBtnLabel || "确定";
    }
    if (addClearBtn) {
      footerButton.push({
        label: '清除',
        func: this.clearSure,
        type: 'default' });

    }
    footerButton.push({
      label: okBtnLabel,
      func: this.selectSure });

    footerButton.push({
      label: '取消',
      func: this.cancel,
      type: 'default' });

    return {
      propParams: formConfig != undefined ? formConfig : this.params,
      footerButton: footerButton };

  },

  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
  },

  methods: {
    selectSure: function selectSure() {
      var me = this;
      var selected = me.mwRef('view').getCurrentSelection();
      if (!me.params.multi) {
        if (selected.length > 1) {
          me.mwMsg('warning', '最多选择一条记录！');
          return;
        }
      }
      if (this.params.func(selected, me) === false) {
        return;
      }
      me.cancel();
    },
    clearSure: function clearSure() {
      var me = this;
      me.params.func();
      me.cancel();
    },
    cancel: function cancel() {
      this.mwRef('dialog').hide();
    },
    show: function show() {
      this.mwRef('dialog').show();
    } } };

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =































{
  props: {
    params: {
      type: Object } },



  data: function data() {
    var me = this;
    return {
      comment: [],
      enableSortable: false,
      sugButton: [{
        label: $lang('确定'),
        func: this.editCommentSure },
      {
        label: $lang('取消'),
        type: 'default',
        func: this.closeDialog }] };



  },

  mounted: function mounted() {var _this = this;
    var me = this;
    setTimeout(function () {
      _this.show();
      _this.$nextTick(function () {
        me.$refs.multipleTable.$nextTick(function () {
          me.sortable();
        });
      });
    }, 200);
    this.comment = this.params.comment;
  },
  methods: {
    show: function show() {
      this.mwRef('dialog').show();
    },
    editCommentSure: function editCommentSure() {
      this.params.func(this.comment);
      this.closeDialog();
    },
    closeDialog: function closeDialog() {
      this.mwRef('dialog').hide();
    },
    addOpinion: function addOpinion() {var _this2 = this;
      this.$prompt('', $lang('添加常用意见'), {
        confirmButtonText: $lang('确定'),
        cancelButtonText: $lang('取消'),
        inputType: "textarea",
        inputPattern: /\S+/,
        inputPlaceholder: $lang("请输入意见"),
        inputErrorMessage: $lang("请输入意见") }).
      then(function (_ref) {var value = _ref.value;
        _this2.comment.push({ title: value });
      }).catch(function () {

      });
    },

    editOpinion: function editOpinion(index, row) {var _this3 = this;
      this.$prompt('', $lang('编辑常用意见'), {
        confirmButtonText: $lang('确定'),
        cancelButtonText: $lang('取消'),
        inputType: "textarea",
        inputPattern: /\S+/,
        inputPlaceholder: $lang("请输入意见"),
        inputErrorMessage: $lang("请输入意见"),
        inputValue: row.title }).
      then(function (_ref2) {var value = _ref2.value;
        _this3.comment[index].title = value;
      }).catch(function () {
      });
    },
    handleDelete: function handleDelete(index, row) {
      this.comment.splice(index, 1);
    },
    $lang: function (_$lang) {function $lang(_x, _x2) {return _$lang.apply(this, arguments);}$lang.toString = function () {return _$lang.toString();};return $lang;}(function (key, defaultValue) {
      return $lang(key, defaultValue);
    }),
    getSortableEl: function getSortableEl() {
      return $(this.$el).find(".el-table__body-wrapper tbody");
    },
    sortable: function sortable() {
      var me = this;
      me.enableSortable = true;
      var el = this.getSortableEl();
      var dragStart = -1;
      var dragEnd = -1;
      el.sortable({
        start: function start(event, ui) {
          var item = ui.item;
          dragStart = item.index();
        },
        update: function update(event, ui) {
          var item = ui.item;
          dragEnd = item.index();
          el.sortable("cancel");
          updateDataList(dragStart, dragEnd);
        } }).
      disableSelection();
      function updateDataList(fromIndex, toIndex) {
        var copyDataList = me.comment.slice();
        var d = copyDataList.splice(fromIndex, 1)[0];
        copyDataList.splice(toIndex, 0, d);
        me.comment = copyDataList;
      }
    } },

  watch: {
    params: {
      handler: function handler(val) {
        this.comment = val.comment;
      } } } };

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =







{
  props: {
    params: {
      type: Object } },


  data: function data() {
    var me = this;
    return {
      action: this.mwUrl('/api/business/uploadAttachment'),
      api: 'business.listAttachment',
      defaultParams: {
        formId: '',
        businessId: '',
        tempBusinessId: '',
        type: '',
        accept: '',
        batchId: '',
        actId: '',
        secLevel: "",
        departmentId: "",
        commentId: "",
        taskId: "",
        docId: "",
        fullAuthType: "",
        formData: "" },

      addShow: true,
      deleteShow: true,
      downloadShow: true,
      renameShow: true,
      sortable: true,
      limit: 0,
      recordsIsCanEdit: undefined,
      title: $lang("附件管理") };


  },
  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
    if (this.params.uploadUrl) this.action = this.params.uploadUrl;
    if (this.params.commentId) this.defaultParams.commentId = this.params.commentId;
    if (this.params.departmentId) this.defaultParams.departmentId = this.params.departmentId;
    if (this.params.taskId) this.defaultParams.taskId = this.params.taskId;
    if (this.params.docId) this.defaultParams.docId = this.params.docId;
    if (this.params.fullAuthType) this.defaultParams.fullAuthType = this.params.fullAuthType;
    if (this.params.formData) this.defaultParams.formData = this.params.formData;
    this.defaultParams.formId = this.params.formId;
    this.defaultParams.businessId = this.params.businessId;
    this.defaultParams.tempBusinessId = this.params.tempBusinessId;
    this.defaultParams.type = this.params.type;
    this.defaultParams.accept = this.params.accept;
    this.defaultParams.batchId = this.params.batchId;
    this.defaultParams.actId = this.params.actId;
    this.defaultParams.secLevel = this.params.secLevel;

    this.recordsIsCanEdit = this.params.recordsIsCanEdit;
    this.limit = this.params.limit || 0;
    if (this.params.editable != null) {
      this.addShow = this.params.editable;
      this.deleteShow = this.params.editable;
      this.renameShow = this.params.editable;
      this.sortable = this.params.editable;
    }
    this.downloadShow = !this.params.closeAttachDownload;
    this.title = $lang(this.params.title || "附件管理");
  },
  watch: {
    params: function params(val) {
      this.defaultParams.formId = val.formId;
      this.defaultParams.tempBusinessId = val.tempBusinessId;
      this.defaultParams.businessId = val.businessId;
      this.defaultParams.type = this.params.type;
      this.defaultParams.accept = this.params.accept;
      this.defaultParams.batchId = this.params.batchId;
      this.defaultParams.actId = this.params.actId;
      this.defaultParams.secLevel = this.params.secLevel;
      this.defaultParams.fullAuthType = this.params.fullAuthType;
      this.limit = this.params.limit || 0;
      if (val.editable != null) {
        this.addShow = val.editable;
        this.deleteShow = val.editable;
      }
    } },

  methods: {
    beforeClose: function beforeClose() {
      if (this.params.secondfunc) {
        this.params.secondfunc.call(this);
      } else {
        this.mwRef('dialog').hide();
      }
    },
    tableDataLoaded: function tableDataLoaded(data) {
      this.params.func(data);
    },
    show: function show() {
      this.mwRef('dialog').show();
    } } };

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =






{





  data: function data() {
    var me = this;
    var processActivity = me.$attrs.params.processActivity;
    me.form = me.$attrs.params.form;
    var formObj = me.$attrs.params.form;
    var formConfig = this.$attrs.params.formConfig;
    me.formData = me.$attrs.params.formData;
    var componentTag = this.$options._componentTag;
    me.componentTag = componentTag;
    var buttons = [];
    var fileUrl = this.$attrs.params.fileUrl;
    var fileName = this.$attrs.params.fileName || "正文";
    var fileId = this.$attrs.params.fileId;
    var editmode, fileSaveAs, FileSave, efileType;

    var afterDocOpen = this.$attrs.params.afterDocOpen;
    if (componentTag == "NtkoEditor") {
      editmode = "1";
      efileType = "JOA_ZW";
      var isShowToolbar = this.$attrs.params.isShowToolbar ? this.$attrs.params.isShowToolbar : false;
      if (isShowToolbar) {
        buttons.push({ id: 'save', name: '保存' });
        buttons.push({ id: 'print', name: '打印' });
        buttons.push({ id: 'showCG', name: '显示草稿' });
        buttons.push({ id: 'showZW', name: '显示正文' });
        buttons.push({ id: 'xshj', name: '显示痕迹' });
        buttons.push({ id: 'th', name: '套红' });
        buttons.push({ id: 'format', name: '规范全文' });
        buttons.push({ id: 'filePageSetup', name: '页面设置' });
        buttons.push({ id: 'insertDateTime', name: '插入时间' });
        buttons.push({ id: 'insertFile', name: '导入文件' });
        buttons.push({ id: 'insertPhrase', name: '插入常用语' });
        buttons.push({ id: 'gz', name: '盖章' });
      }
    } else if (componentTag == "OnLineEfileEdit") {

      editmode = this.$attrs.params.editmode;
      efileType = this.$attrs.params.efileType;
    }
    if (me.$attrs.params.buttons) {
      buttons = me.$attrs.params.buttons;
    }

    var userNameObj = me.$store.getters.expUser;
    var userName = "";
    if (userNameObj) {
      userName = userNameObj.name;
    }
    return {
      title: fileName,
      propObject: {
        params: {
          processActivity: processActivity,
          editmode: this.$attrs.params.editable ? "1" : "0",
          formConfig: this.$attrs.params.formConfig,
          businessId: this.$attrs.params.businessId,
          formId: this.$attrs.params.formId,
          tempBusinessId: this.$attrs.params.tempBusinessId,
          efileType: efileType,
          step: "edit",
          fileName: fileName,
          saveFileType: "",
          pk_id: this.$attrs.params.businessId,
          yzEfileLinkId: [{ id: "testid" }],
          flowModuleId: this.$attrs.params.moduleId,
          formComponentId: 'c6e11442bb26455d93b8a724e90d5f6f',
          isLoadFormData: false,
          opType: '1',
          showProgressBar: true,
          isNoCopy: true,
          isReadOnly: 0,
          isPubPDFBtn: false,
          isPrintZW: 0,
          operateType: '',
          fileUrl: fileUrl,
          fileId: fileId,
          FileSave: FileSave,
          fileSaveAs: fileSaveAs,
          userName: userName },

        formData: me.formData,
        docFormatObject: {},
        processActivity: "",
        form: formObj,
        efileLinkId: "",
        isNewEfileDoc: "",
        isReadOnly: "",
        joaCaoGaoId: "",
        joaHeGaoId: "",
        joaZenWenId: "",
        joaPDFId: "",
        componentTag: componentTag,
        afterDocOpen: afterDocOpen },

      buttons: buttons };


  },
  mounted: function mounted() {var _this = this;

    setTimeout(function () {
      var me = _this;
      if (me.componentTag == "OnLineEfileEdit") {
        me.show();
      } else {
        me.getDocFormatObject();
      }
    }, 200);
  },













  methods: {
    getDictByCode: function getDictByCode(dictcode) {
      return this.mwApi.data.getDictByCode(dictcode).then(function (v) {
        return v;
      }).
      catch(function (err) {return console.log(err);});
    },
    show: function show() {
      this.mwRef('dialog').show();
    },
    closeWindow: function closeWindow() {
      var me = this;
      this.mwRef('dialog').hide();
      if (me.mwRef('editor')) {
        me.mwRef('editor').closeIframe();
      }
    },

    getDocFormatObject: function getDocFormatObject() {var _this2 = this;
      var me = this;
      var formData = me.formData;
      me.propObject.processActivity = me.$attrs.params.processActivity;
      var attachMentList = formData['#items'];
      var joaCaoGaoId = "";
      var joaHeGaoId = "";
      var joaZenWenId = "";
      var joaPDFId = "";
      if (attachMentList && attachMentList.length > 0) {
        attachMentList.map(function (item, index, arr) {
          var itemType = item.type;
          var itemId = item.id;
          if (itemType == "JOA_CG" && item.mimeType != ".pdf") {joaCaoGaoId = itemId;me.propObject.joaCaoGaoId = joaCaoGaoId;}
          if (itemType == "JOA_HG" && item.mimeType != ".pdf") {joaHeGaoId = itemId;me.propObject.joaHeGaoId = joaHeGaoId;}
          if (itemType == "JOA_ZW" && item.mimeType != ".pdf") {joaZenWenId = itemId;me.propObject.joaZenWenId = joaZenWenId;}
          if (itemType == "JOA_ZW" && item.mimeType == ".pdf") {joaPDFId = itemId;me.propObject.joaPDFId = joaZenWenId;}
        });
      }
      var efileLinkId = "";
      if (joaZenWenId) {
        efileLinkId = joaZenWenId;
      } else if (joaHeGaoId) {
        efileLinkId = joaHeGaoId;
      } else if (joaCaoGaoId) {
        efileLinkId = joaCaoGaoId;
      } else {
        efileLinkId = null;
      }

      var isEdit = this.$attrs.params.editable;
      if (isEdit) {
        me.propObject.efileLinkId = efileLinkId;
        if (!efileLinkId) {
          me.propObject.isNewEfileDoc = true;
        } else {
          me.propObject.isNewEfileDoc = false;
        }
        me.propObject.isReadOnly = false;

        var format = formData.formatid;
        if (!format && me.$attrs.params.editable) {
          alert("请先选择发文格式！");
          return;
        }
        this.mwApi.business.getDocumentFormat(format).then(function (r) {
          if (r && r.result) {
            var formatObject = _this2.arrangeData(r.result);
            me.propObject.docFormatObject = formatObject;
            me.show();



          } else {
            alert("没有找到相应的发文格式，请联系管理员！");
            return;
          }
        });
      } else {

        if (!efileLinkId) {
          alert("该文件还没有生成正文，请先编辑正文！");
          return;
        } else {
          me.propObject.efileLinkId = efileLinkId;
          me.propObject.isNewEfileDoc = false;
          me.propObject.isReadOnly = true;
          me.showEditor = true;
        }
      }
    },

    arrangeData: function arrangeData(d) {
      var formatObject = {};
      var docData = d.doc;
      if (docData) {
        formatObject.mouldFormId = "c3faaec06cfae727";
        formatObject.isTaoTouFirst = docData.fldttfs == "先套头" ? true : false;
        if (d.main) {
          formatObject.caoGaoDocId = d.main ? d.main.id : "";

          if (d.main["#items"] && d.main["#items"].length > 0) {
            formatObject.caoGaoMouldId = d.main["#items"][0].id;
          }
        }
        if (d.head) {
          formatObject.headDocId = d.head ? d.head.id : "";
          if (d.head["#items"] && d.head["#items"].length > 0) {
            formatObject.headMouldId = d.head["#items"][0].id;
          }
        }
        if (d.footer) {
          formatObject.tailDocId = d.footer ? d.footer.id : "";
          if (d.footer["#items"] && d.footer["#items"].length > 0) {
            formatObject.tailMouldId = d.footer["#items"][0].id;
          }
        }





        formatObject.fjLabelName = docData.fldfjsq;
        formatObject.htLabelName = docData.fldhtsq;
        formatObject.htLabelValue = docData.fldhtqz;
        formatObject.yzLabelName = docData.fldyzsq;
        formatObject.ffbmLabelName = docData.fldffbmsq;
        formatObject.ffbmLabelValue = docData.fldffbmqz;


        var arrJson = {};
        if (d.mainMark && d.mainMark.length > 0) {
          arrJson = this.arrList(d.mainMark, arrJson);
        }
        if (d.headMark && d.headMark.length > 0) {
          arrJson = this.arrList(d.headMark, arrJson);
        }
        if (d.footerMark && d.footerMark.length > 0) {
          arrJson = this.arrList(d.footerMark, arrJson);
        }
        formatObject.tmplListObject = arrJson;
      }
      return formatObject;
    },
    arrList: function arrList(objList, arrJson) {

      if (objList && objList.length > 0) {
        for (var i = 0; i < objList.length; i++) {
          var label = {};
          label.fldmc = objList[i].fldmc;
          label.fldqzfs = objList[i].fldqzfs;
          label.fldqz = objList[i].fldqz;
          label.fldxhbd = objList[i].fldxhbd;
          label.fldyjgs = objList[i].a1cc3bf8eefb6300;
          label.fldisnew = objList[i].fldfhzxyt;
          var nameKey = label.fldmc;
          arrJson[nameKey] = label;
        }
      }
      return arrJson;
    } },

  destroyed: function destroyed() {

  } };

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =





{





  data: function data() {
    var me = this;
    me.form = me.$attrs.params.form;
    var formObj = me.$attrs.params.form;
    return {
      propObject: {
        params: {
          form: formObj,
          editable: this.$attrs.params.editable,
          editMode: this.$attrs.params.editable,
          businessId: this.$attrs.params.businessId,
          formId: this.$attrs.params.formId,
          tempBusinessId: this.$attrs.params.tempBusinessId,
          isShowInFormPanel: "0",
          efileType: "JOA_FJ" } },


      buttons: [
      { id: "add", name: $lang("添加"), class: "fa fa-plus-square fa-fw" },
      { id: "scanner", name: $lang("扫描"), class: "fa fa-plus-circle fa-fw" },
      { id: "deleteAttach", name: $lang("删除"), class: "fa fa-trash-o fa-fw" },
      { id: "down", name: $lang("下载"), class: "fa fa-download fa-fw" },
      { id: "downall", name: $lang("全部下载"), class: "fa fa-download fa-fw" },
      { id: "print", name: $lang("打印"), class: "fa fa-print fa-fw" },
      { id: "listview", name: $lang("列表"), class: "fa fa-list-alt fa-fw" },
      { id: "iconview", name: $lang("图标"), class: "fa fa-file-image-o fa-fw" },
      { id: "doMoveSelectFileUp", name: $lang("上移"), class: "fa fa-arrow-up fa-fw" },
      { id: "doMoveSelectFileDown", name: $lang("下移"), class: "fa fa-arrow-down fa-fw" },
      { id: "rename", name: $lang("重命名"), class: "fa fa-file-image-o fa-fw" }] };


  },
  mounted: function mounted() {var _this = this;
    setTimeout(function () {
      _this.show();
    }, 200);
  },
  methods: {
    tableDataLoaded: function tableDataLoaded(data) {
      this.$attrs.params.func(data);
    },
    show: function show() {
      this.mwRef('dialog').show();
    } } };

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });





var _localHistoryDB = __webpack_require__(1171);var _localHistoryDB2 = _interopRequireDefault(_localHistoryDB);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  name: 'MwCodeEdit',
  props: {
    value: {
      type: String,
      default: '' },

    lang: {
      type: String,
      default: 'Javascript' },

    snippets: [String, Object],
    completeData: Object,
    localHistoryKey: String },

  data: function data() {
    return {
      valueChange: false,
      editorChange: false,
      editor: undefined };

  },
  mounted: function mounted() {
    var me = this;
    $WR.ready(function (manager) {
      manager.create({
        xtype: 'CodeEditor',
        lang: me.lang,
        isFormField: false,
        completeData: me.completeData,
        snippets: me.snippets },
      function (editor) {
        editor.render(me.$el);
        me.editor = editor;
        me.editor.setValue(me.value, false);
        editor.on("change", function (v, c) {
          var val = editor.getValue();
          if (!me.valueChange && val !== me.value) {
            me.editorChange = true;
            me.$emit("input", val);
          }
        });
      });
    });
    if (me.localHistoryKey) {
      me.initLocalHistory();
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      var me = this;
      if (me.editor && !me.editorChange) {
        me.valueChange = true;
        me.editor.setValue(me.value == '' || me.value == undefined ? '' : me.value, false);
      }
      me.valueChange = false;
      me.editorChange = false;
    } },

  beforeDestroy: function beforeDestroy() {
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
  },
  methods: {
    getValue: function getValue() {
      return this.editor.getValue();
    },
    setValue: function setValue(val) {
      var me = this;
      me.editor.setValue(val == undefined ? '' : val, false);
    },
    insert: function insert(row, col, text)
    {
      var session = this.editor.editor.getSession();
      session.insert({ row: row, column: col }, text);
    },

    append: function append(text)
    {
      var session = this.editor.editor.getSession();
      this.insert(session.getLength(), 0, text);
    },

    find: function find(value, caseSensitive)
    {
      var ret = this.editor.editor.find({
        needle: value,
        regExp: true,
        skipCurrent: false,
        backwards: false,
        wrap: true,
        caseSensitive: caseSensitive || false });

      this.editor.editor.session.highlight(this.editor.editor.$search.$options.re);
      return ret;
    },

    replace: function replace(replacement, value, caseSensitive)
    {
      this.editor.editor.replace(replacement, {
        needle: value,
        regExp: true,
        skipCurrent: false,
        backwards: false,
        wrap: true,
        caseSensitive: caseSensitive || false });

    },
    initLocalHistory: function initLocalHistory() {
      if (!window.indexedDB) return;
      var me = this;
      var lastValue = me.getValue();
      me.localHistoryInterval = setInterval(function () {
        var newValue = me.getValue();
        if (newValue && lastValue !== newValue) {
          _localHistoryDB2.default.add(me.localHistoryKey, newValue);
          lastValue = newValue;
        }
      }, 300000);
    } },

  destroyed: function destroyed() {
    var i = this.localHistoryInterval;
    if (i) {
      clearInterval(i);
    }
  } };

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });




var _user = __webpack_require__(474);var _user2 = _interopRequireDefault(_user);
var _role = __webpack_require__(475);var _role2 = _interopRequireDefault(_role);
var _roleList = __webpack_require__(212);var _roleList2 = _interopRequireDefault(_roleList);
var _group = __webpack_require__(476);var _group2 = _interopRequireDefault(_group);
var _InvalidUser = __webpack_require__(211);var _InvalidUser2 = _interopRequireDefault(_InvalidUser);
var _groups = __webpack_require__(477);var _groups2 = _interopRequireDefault(_groups);
var _commonOuterOrg = __webpack_require__(478);var _commonOuterOrg2 = _interopRequireDefault(_commonOuterOrg);
var _dataDic = __webpack_require__(479);var _dataDic2 = _interopRequireDefault(_dataDic);
var _dataDicEdit = __webpack_require__(1221);var _dataDicEdit2 = _interopRequireDefault(_dataDicEdit);
var _fullAuth = __webpack_require__(482);var _fullAuth2 = _interopRequireDefault(_fullAuth);

var _script = __webpack_require__(483);var _script2 = _interopRequireDefault(_script);
var _flow = __webpack_require__(484);var _flow2 = _interopRequireDefault(_flow);
var _set = __webpack_require__(485);var _set2 = _interopRequireDefault(_set);
var _worktime = __webpack_require__(486);var _worktime2 = _interopRequireDefault(_worktime);
var _multilingual = __webpack_require__(487);var _multilingual2 = _interopRequireDefault(_multilingual);
var _recycleBin = __webpack_require__(1239);var _recycleBin2 = _interopRequireDefault(_recycleBin);
var _clearDataOrExpImpl = __webpack_require__(488);var _clearDataOrExpImpl2 = _interopRequireDefault(_clearDataOrExpImpl);
var _flowInterfering = __webpack_require__(1244);var _flowInterfering2 = _interopRequireDefault(_flowInterfering);

var _index = __webpack_require__(489);var _index2 = _interopRequireDefault(_index);

var _loginLog = __webpack_require__(490);var _loginLog2 = _interopRequireDefault(_loginLog);
var _personalLog = __webpack_require__(491);var _personalLog2 = _interopRequireDefault(_personalLog);
var _operationLog = __webpack_require__(492);var _operationLog2 = _interopRequireDefault(_operationLog);
var _flowLog = __webpack_require__(493);var _flowLog2 = _interopRequireDefault(_flowLog);
var _flowTransLog = __webpack_require__(494);var _flowTransLog2 = _interopRequireDefault(_flowTransLog);
var _accessLog = __webpack_require__(495);var _accessLog2 = _interopRequireDefault(_accessLog);

var _file_manager = __webpack_require__(496);var _file_manager2 = _interopRequireDefault(_file_manager);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  name: "MwInnerView",
  components: {
    systemSet_org_user: _user2.default,
    systemSet_org_role: _role2.default,
    systemSet_org_roleList: _roleList2.default,
    systemSet_org_group: _group2.default,
    systemSet_org_InvalidUser: _InvalidUser2.default,
    systemSet_org_groups: _groups2.default,
    systemSet_org_outerOrg: _commonOuterOrg2.default,
    systemSet_org_dataDic: _dataDic2.default,
    systemSet_org_dataDic_edit: _dataDicEdit2.default,
    systemSet_org_full_auth: _fullAuth2.default,
    systemSet_script: _script2.default,
    systemSet_flow: _flow2.default,
    systemSet_set: _set2.default,
    systemSet_worktime: _worktime2.default,
    systemSet_multilingual: _multilingual2.default,
    systemSet_flowInterfering: _flowInterfering2.default,
    clear_data_or_exp_impl: _clearDataOrExpImpl2.default,
    systemSet_recycleBin: _recycleBin2.default,
    systemSet_navigator: _index2.default,
    systemSet_log_loginLog: _loginLog2.default,
    systemSet_log_personalLog: _personalLog2.default,
    systemSet_log_operationLog: _operationLog2.default,
    systemSet_log_flowLog: _flowLog2.default,
    systemSet_log_flowTransLog: _flowTransLog2.default,
    systemSet_log_accessLog: _accessLog2.default,
    systemSet_file_manager: _file_manager2.default },

  props: {
    viewId: String,
    params: Object },


  data: function data() {
    return {
      comp: {} };

  },
  mounted: function mounted() {
    var me = this;




  } };

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



var _deptUser = __webpack_require__(1176);var _deptUser2 = _interopRequireDefault(_deptUser);
var _InvalidUser = __webpack_require__(211);var _InvalidUser2 = _interopRequireDefault(_InvalidUser);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  components: {
    systemSet_org_depUser: _deptUser2.default,
    systemSet_org_InvalidUser: _InvalidUser2.default },

  data: function data() {
    return {
      compId: "" };

  },
  props: {
    viewId: String,
    params: Object,
    default: "systemSet_org_depUser" },

  mounted: function mounted() {
    var me = this;
    if (this.viewId) {
      this.compId = this.viewId;
    } else {
      this.compId = "systemSet_org_depUser";
    }
  },
  methods: {
    changeView: function changeView(viewId) {
      this.compId = viewId;
    } } };

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });




















































































































































































































































































































































































































































































































































































































































































































































































































var _organize = __webpack_require__(1179);var _organize2 = _interopRequireDefault(_organize);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

_organize2.default;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =

































































{
  props: {
    RAdminData: {
      type: Array,
      default: function _default() {
        return [];
      } },

    defaultParentId: {
      type: String,
      default: '' },

    listAble: {
      type: Boolean,
      default: false },

    isRadio: {
      type: Boolean,
      default: false },

    isAppendDepartment: {
      type: Boolean,
      default: false } },


  data: function data() {
    var hxSpan = this.isRadio ? 24 : this.isAppendDepartment ? 7 : 10;
    var yxSpan = this.isAppendDepartment ? 13 : 10;
    return {
      defaultParams: { rootId: this.defaultParentId, listAble: this.listAble },
      deptTreeUrl: this.mwUrl('/api/org/getDepartmentTree'),
      selectedDept: '',
      LAdminData: [],
      hxSpan: hxSpan,
      yxSpan: yxSpan,
      multipleLSelection: [],
      multipleRSelection: [],
      b: false,
      index: -1 };

  },

  methods: {
    tableRowClassName: function tableRowClassName(row) {
      row.row.index = row.rowIndex;
    },
    handleRowR: function handleRowR(row) {
      this.mwRef('adminRData').toggleRowSelection(row);
    },
    handleRow: function handleRow(row) {
      if (!this.isRadio) {
        this.mwRef('adminData').toggleRowSelection(row);
      } else {
        this.index = row.index;
        this.multipleLSelection = [];
        this.multipleLSelection.push(row);
      }
    },

    handleLSelectionChange: function handleLSelectionChange(val) {
      this.multipleLSelection = val;
    },
    handleRSelectionChange: function handleRSelectionChange(val) {
      this.multipleRSelection = val;
    },


    generateData: function generateData(data) {

      var me = this;
      me.loading = true;
      me.selectedDept = data.id;
      this.mwApi.org.listUser({ departmentId: data.id }).then(function (data) {
        if (data.success) {
          me.index = -1;
          me.multipleLSelection = [];
          if (me.RAdminData.length != 0) {

            me.LAdminData = data.result;

            me.RAdminData.forEach(function (r) {
              data.result.forEach(function (t, index) {
                if (r.identityId === t.identityId) {
                  me.LAdminData.splice(index, 1);
                  return;
                }
              });
            });
          } else {
            me.LAdminData = data.result;
          }

        }

      });
    },

    handleChange: function handleChange(data) {var _this = this;
      var me = this;

      if (data === 'RightAll') {
        this.RAdminData.forEach(function (t, index) {
          if (t.departmentId === _this.selectedDept) {
            t.name = _this.getUserName(t.name, t.srcName);
            me.LAdminData.push(t);
          }
        });
        this.RAdminData.splice(0, this.RAdminData.length);
      }

      if (data === 'RightChecked') {
        if (this.multipleRSelection.length == 0) {
          this.mwMsg('info', '请选择你要操作的数据');
        } else {
          this.multipleRSelection.forEach(function (t) {
            if (t.departmentId === _this.selectedDept) {
              t.name = _this.getUserName(t.name, t.srcName);
              me.LAdminData.push(t);
            }
            me.RAdminData.forEach(function (key, index) {
              if (key.identityId === t.identityId) {
                me.RAdminData.splice(index, 1);
              }
            });
          });
          me.LAdminData.sort(function (val1, val2) {
            if (val1.sn > val2.sn) {
              return 1;
            }
            if (val1.sn < val2.sn) {
              return -1;
            }
            if (val1.sn == val2.sn) {
              return 0;
            }
          });
        }
      }
      var fullDeptName = this.getFullDepartmentName();

      if (data === 'LeftAll') {

        this.LAdminData.forEach(function (t, index) {
          if (me.isAppendDepartment) {
            t.srcName = t.name;
            t.name = t.name + "(" + fullDeptName + ")";
          }
          me.RAdminData.push(t);
        });
        this.LAdminData.splice(0, this.LAdminData.length);
      }


      if (data === 'LeftChecked') {
        if (this.multipleLSelection.length == 0) {
          this.mwMsg('info', '请选择你要操作的数据');
        } else {

          if (this.isRadio) {
            this.index = -1;
            this.multipleLSelection.forEach(function (t) {
              if (me.RAdminData.length == 0) {
                me.RAdminData.push(t);
              } else {
                var r = me.RAdminData.shift();
                if (me.LAdminData.length > 0 && r.departmentId == me.LAdminData[0].departmentId) {
                  me.LAdminData.push(r);
                }
                me.RAdminData.push(t);
              }
              me.LAdminData.forEach(function (key, index) {
                if (key.identityId === t.identityId) {
                  me.LAdminData.splice(index, 1);
                }
              });
            });
            this.multipleLSelection = [];
            me.LAdminData.sort(function (val1, val2) {
              if (val1.sn > val2.sn) {
                return 1;
              }
              if (val1.sn < val2.sn) {
                return -1;
              }
              if (val1.sn == val2.sn) {
                return 0;
              }
            });
          } else {
            this.multipleLSelection.forEach(function (t) {
              if (me.isAppendDepartment) {
                t.srcName = t.name;
                t.name = t.name + "(" + fullDeptName + ")";
              }
              me.RAdminData.push(t);
              me.LAdminData.forEach(function (key, index) {
                if (key.identityId === t.identityId) {
                  me.LAdminData.splice(index, 1);
                }
              });
            });
          }
        }
      }
    },
    getUserName: function getUserName(name, srcName) {
      if (this.isAppendDepartment) {
        if (srcName) {
          return srcName;
        }
        var pos = name.lastIndexOf("(");
        if (pos != -1) {
          return name.substring(0, pos);
        }
      }
      return name || "";
    },
    getFullDepartmentName: function getFullDepartmentName() {
      var me = this;
      if (!me.isAppendDepartment) return "";
      var tree = me.$refs.aa;
      var ret = [];
      if (tree) {
        var nodeData = tree.getSelected();
        var node = tree.getNode(nodeData.id);
        while (node) {
          ret.push(node.original.shortname || node.original.name);
          if (node.parent && node.parent != "#") {
            node = tree.getNode(node.parent);
          } else {
            node = undefined;
          }
        }
      }
      return ret.reverse().join("/");
    },

    refreshTree: function refreshTree(a) {
      if (a) {
        this.b = true;
      }
    },
    getValue: function getValue() {
      if (this.isRadio) {
        return this.multipleLSelection;
      } else {
        return this.RAdminData;
      }
    } },


  watch: {
    RAdminData: {
      handler: function handler(val) {
        if (this.b) {
          this.mwRef('aa').refresh();
          this.b = false;
        }
      } },

    defaultParentId: function defaultParentId(val) {
      this.defaultParams = { rootId: this.defaultParentId, listAble: this.listAble };
    } } };

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =






















{
  props: {
    params: {
      type: Object } },


  data: function data() {
    return {

      api: 'org.listUser',
      footerButton: [{
        label: '取消',
        func: this.cancel,
        type: 'default' },

      {
        label: '确定',
        func: this.save }],

      defaultParams: {},
      columns: [{ type: 'selection' }, { type: 'index' },
      { prop: 'name', label: '名称', tooltip: true }] };

  },
  computed: {
    deptTreeUrl: function deptTreeUrl() {

      if (!this.userInfo || !this.userInfo.developer) return this.mwUrl("/api/org/listDepartmentListAble");
      return this.mwUrl("/api/org/listDepartment");
    } },

  methods: {

    changed: function changed(data) {
      this.refreshTableDefaultParams({ departmentId: data.id });

    },

    refreshTableDefaultParams: function refreshTableDefaultParams(params) {
      this.defaultParams = params;
    },

    save: function save() {
      this.$emit('chooseSec');
      this.mwRef('secDialog').hide();
    },

    cancel: function cancel() {
      this.mwRef('secDialog').hide();
    },


    getValue: function getValue() {
      return this.mwRef('dataTable').getMultipleSelection();
    },

    show: function show() {
      this.mwRef('secDialog').show();
    },
    refresh: function refresh() {
      this.mwRef('tree').refresh();
    } } };

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =






















{

  data: function data() {
    return {
      position: '',
      postions: [{
        'id': 1,
        'name': '公司领导' },

      { 'id': 2, 'name': '党组书记' },
      { 'id': 3, 'name': '总经理' },
      { 'id': 4, 'name': '副总经理' }, { 'id': 5, 'name': '主任' },
      { 'id': 6, 'name': '副主任' }, { 'id': 7, 'name': '处长' },
      { 'id': 8, 'name': '副处长' }, { 'id': 9, 'name': '总监' }] };


  },
  methods: {
    confirmPost: function confirmPost() {
      this.$emit("confirm", this.position);
    },
    canclePost: function canclePost() {
      this.$emit("cancel");
    } } };

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =



















{
  data: function data() {
    return {
      btns: [{
        label: '取消',
        func: this.cancelLevel,
        type: 'default' },
      {
        label: '确定',
        func: this.confirmLevel }],

      check: '',
      list: [{
        'id': 1,
        'name': '第一级用户' },
      { 'id': 2, 'name': '第二级用户' },
      { 'id': 3, 'name': '第三级用户' },
      { 'id': 4, 'name': '第四级用户' },
      { 'id': 5, 'name': '领导级' },
      { 'id': 6, 'name': '部门级' }] };


  },
  methods: {
    show: function show() {
      this.mwRef('zgDeptDialog').show();
    },
    cancelLevel: function cancelLevel() {
      this.mwRef('zgDeptDialog').hide();
    },
    confirmLevel: function confirmLevel() {
      this.$emit("confirm", this.check);
      this.cancelLevel();
    } } };

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =




















{
  data: function data() {
    return {
      checkList: [],
      checked: [],
      user: [],
      btns: [{
        label: '全选',
        func: this.selectAll },
      {
        label: '反选',
        func: this.selectSome,
        type: 'default' },
      {
        label: '取消',
        type: 'default',
        func: this.cancelLevel },
      {
        label: '确定',
        func: this.confirmLevel }],

      list: [{
        'id': 1,
        'name': '第一级用户' },
      { 'id': 2, 'name': '第二级用户' },
      { 'id': 3, 'name': '第三级用户' },
      { 'id': 4, 'name': '第四级用户' },
      { 'id': 5, 'name': '领导级' },
      { 'id': 6, 'name': '部门级' }] };


  },
  methods: {
    show: function show() {
      this.mwRef('dialog').show();
    },
    selectAll: function selectAll() {var _this = this;
      this.checkList = [],
      this.list.forEach(function (user) {
        _this.checkList.push(user.id);
      });
    },

    selectSome: function selectSome() {var _this2 = this;
      if (this.checkList.length == 0) {
        this.list.forEach(function (user) {
          _this2.checkList.push(user.id);
        });
      } else
      {

        var a = [];
        this.list.forEach(function (user) {
          a.push(user.id);
        });
        for (var t = 0; t < this.checkList.length; t++) {
          for (var i = 0; i < this.list.length; i++) {
            if (this.checkList[t] === this.list[i].id) {
              delete a[i];
              break;
            }
          }
        }
        this.checkList = a;
      }


    },

    cancelLevel: function cancelLevel() {
      this.mwRef('dialog').hide();
    },
    confirmLevel: function confirmLevel() {var _this3 = this;
      this.user = [];var _loop = function _loop(
      i) {
        _this3.list.forEach(function (r) {
          if (_this3.checkList[i] === r.id) {
            _this3.user.push({ id: _this3.checkList[i], name: r.name });
          }
        });};for (var i = 0; i < this.checkList.length; i++) {_loop(i);
      }
      this.mwRef('dialog').hide();
      this.$emit("confirm", this.user);
    } } };

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =










{
  data: function data() {
    return {

      checkNodes: [],
      btns: [{
        label: '全选',
        func: this.selectAll },
      {
        label: '不选',
        func: this.resetChecked,
        type: 'default' },
      {
        label: '取消',
        func: this.cancelDept,
        type: 'default' },
      {
        label: '确定',
        func: this.confirmDept }] };


  },
  computed: {
    deptTreeUrl: function deptTreeUrl() {

      if (!this.userInfo || !this.userInfo.developer) return this.mwUrl("/api/org/listDepartmentListAble");
      return this.mwUrl("/api/org/listDepartment");
    } },

  methods: {
    selectAll: function selectAll() {
      this.mwRef('deptTree').checkAll();
    },
    resetChecked: function resetChecked() {
      this.mwRef('deptTree').unCheckAll();
    },

    confirmDept: function confirmDept() {
      this.checkNodes = this.mwRef('deptTree').getSelected();
      this.$emit("confirm", this.checkNodes);
      this.cancelDept();
    },

    cancelDept: function cancelDept() {
      this.mwRef('zgDeptDialog').hide();
    },
    getValue: function getValue() {
      return this.checkNodes;
    },
    show: function show() {
      this.mwRef('zgDeptDialog').show();
    } } };

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_firstDept_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_firstDept_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_firstDept_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_firstDept_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_firstDept_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_11597a6b_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_firstDept_vue__ = __webpack_require__(1192);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_firstDept_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_11597a6b_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_firstDept_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =










{
  data: function data() {
    return {
      deptTreeUrl: 'api/org/getUnitTree',
      btns: [{
        label: '全选',
        func: this.selectAll },
      {
        label: '不选',
        func: this.resetChecked,
        type: 'default' },
      {
        label: '取消',
        func: this.cancelDept,
        type: 'default' },
      {
        label: '确定',
        func: this.confirmDept }] };


  },
  methods: {
    selectAll: function selectAll() {
      this.mwRef('deptTree').checkAll();
    },
    resetChecked: function resetChecked() {
      this.mwRef('deptTree').unCheckAll();
    },

    confirmDept: function confirmDept() {
      this.$emit("confirm", this.mwRef('deptTree').getSelected());
      this.cancelDept();
    },

    cancelDept: function cancelDept() {
      this.mwRef('zgDeptDialog').hide();
    },
    getValue: function getValue() {
      return this.mwRef('deptTree').getSelected();
    },
    show: function show() {
      this.mwRef('zgDeptDialog').show();
    } } };

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);







































var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  props: {
    userIdentityId: {
      type: String,
      default: "" },

    deptId: {
      type: String,
      default: "" },

    userInf: {
      type: Array,
      default: function _default() {
        return [];
      } },

    listAble: {
      type: Boolean,
      default: false },

    noResetPwd: {
      type: Boolean,
      default: false } },


  data: function data() {
    return {
      deptRoleTreeUrl: "/api/org/listDepartmentUserGroup",
      codeRoleTreeUrl: "/api/org/getGroupTree",

      addRolesVisible: false,

      unitId: "",

      total: 0,
      checkRoleIds: [],
      selectNode: "",
      roleData: [],
      treeData: [],
      limitName: [],
      treeDefaultParams: {},
      btns: [
      {
        label: "取消",
        func: this.cancelAddRoles,
        type: "default" },

      {
        label: "确定",
        func: this.addRolesSure }] };



  },

  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'userInfo'])),



  mounted: function mounted() {
    this.getTreeData(true);
  },

  methods: {
    changed: function changed(data) {
      var me = this;
      if (data.id == '身份权限' || data.id == '文档权限' || data.id == '流程权限') {
        var type = "";
        if (data.id == '身份权限') {
          type = "1";
        } else if (data.id == '文档权限') {
          type = "2";
        } else if (data.id == '流程权限') {
          type = "3";
        }
        this.mwApi.org.listDepartmentUserRoleByType(this.userIdentityId, type).then(function (res) {
          me.limitName = res.result;
        });
      } else if (data.id == '查看全部权限') {

        this.mwApi.org.listDepartmentUserRole(this.userIdentityId, '').then(function (res) {
          me.limitName = res.result;
        });
      } else {
        me.mwApi.org.getGroup(data.id).then(function (res) {
          var limitName = [];
          if (res.result.roleNames) {
            var names = res.result.roleNames.split(",");
            var roleIds = res.result.roleIds.split(",");
            names.forEach(function (d, index) {
              limitName.push({
                id: roleIds[index],
                name: d });

            });
            me.limitName = limitName;
          }
        });
      }
    },


    getTreeData: function getTreeData(a) {var _this = this;
      this.roleData = [];
      this.treeData = [];
      this.selectNode = "";
      this.mwApi.org.listDepartmentUserGroup(this.userIdentityId).then(function (data) {
        data.result.forEach(function (d) {
          _this.roleData.push({
            id: d.id,
            text: d.name });

        });

        _this.treeData.push(
        {
          text: "角色",
          children: _this.roleData,
          state: {
            disabled: true,
            opened: true } },


        {
          text: "查看全部权限",
          children: [{ text: "身份权限" }, { text: "文档权限" }, { text: "流程权限" }],
          state: {
            disabled: false,
            opened: true } });




        if (!a) {
          _this.mwRef("deptRoleTree").refreshData(_this.treeData);
          _this.mwRef("deptRoleTree").openAll();
        } else {

          _this.mwRef("deptRoleTree").openAll();
        }
        if (_this.roleData.length != 0) {
          _this.selectNode = _this.roleData[0].id;
        } else {
          _this.limitName = [];
        }
      });
    },


    checkRoles: function checkRoles() {var _this2 = this;
      this.mwApi.org.getUnitById(this.deptId).then(function (res) {
        _this2.unitId = res.result.id;
        _this2.treeDefaultParams.unitId = _this2.unitId;
        _this2.checkRoleIds = [];
        _this2.mwRef("addRolesDialog").show();
        if (_this2.total != 0) {
          _this2.mwRef("codeRoleTree").refresh();
        }
        _this2.total = 1;

        _this2.roleData.forEach(function (d) {
          _this2.checkRoleIds.push(d.id);
        });
      });
    },

    addRolesSure: function addRolesSure() {var _this3 = this;
      var a = false;
      var groupIds = [],groups = [];
      this.mwRef("codeRoleTree").
      getSelected().
      forEach(function (d) {
        if (_this3.checkRoleIds.indexOf(d.id) != -1) {
          a = true;
          _this3.mwMsg("warning", "该" + d.text + "已存在无需重复添加");
          return;
        } else {
          groupIds.push(d.id);
          groups.push(d);
          a = false;
        }
      });

      if (!a) {
        if (groupIds.length != 0) {
          this.mwApi.org.
          addDepartmentUserGroup(this.userIdentityId, groupIds).
          then(function (res) {
            if (res.success) {
              _this3.getTreeData(false);
              groups.forEach(function (g) {
                var params = g;
                if (g.userNames) {
                  params.userNames = params.userNames + ',' + _this3.userInf[0].name;
                  params.userDeptIdentityIds = params.userDeptIdentityIds + ',' + _this3.userInf[0].id;
                  params.departmentIds = params.departmentIds + ',' + _this3.userInf[0].departmentId;} else
                {
                  params.userNames = _this3.userInf[0].name;
                  params.userDeptIdentityIds = _this3.userIdentityId;
                  params.departmentIds = _this3.userInf[0].departmentId;
                }
                _this3.mwApi.org.saveGroup(g);
              });

            }
          });
        }
        this.mwRef("addRolesDialog").hide();
      }
    },

    deleteRoles: function deleteRoles() {var _this4 = this;
      var data = this.mwRef("deptRoleTree").getSelected();
      if (["查看全部权限", "身份权限", "文档权限", "流程权限"].indexOf(data.id) != -1) {
        this.mwMsg("请选择角色");
        return;
      }
      if (data.id && data.id != "1") {
        this.$confirm('您确定要删除此角色?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).
        then(function () {
          _this4.mwApi.org.
          deleteDepartmentUserGroup(_this4.userIdentityId, data.id).
          then(function (res) {
            if (res.success) {
              _this4.mwMsg("删除成功");
              _this4.getTreeData(false);
              _this4.mwApi.org.getGroup(data.id).then(function (d) {
                if (d.result && d.success) {
                  var departmentIds = [],userNames = [],userDeptIdentityIds = [];
                  if (d.result.userNames) {
                    userNames = d.result.userNames.split(',');
                  }
                  if (d.result.departmentIds) {
                    departmentIds = d.result.departmentIds.split(',');
                  }
                  userNames.forEach(function (u, index) {
                    if (u === _this4.userInf[0].name) {
                      userNames.splice(index, 1);
                      departmentIds.splice(index, 1);
                    }
                  });
                  var params = d.result;
                  params.userNames = userNames.join();
                  params.departmentIds = departmentIds.join();
                  _this4.mwApi.org.saveGroup(params);
                }
              });

            } else {
              _this4.mwMsg("info", "删除失败");
            }
          });
        }).catch(function () {});
      }
    },

    cancelAddRoles: function cancelAddRoles() {
      this.mwRef("addRolesDialog").hide();
    } },


  watch: {
    userIdentityId: function userIdentityId(val) {
      this.getTreeData(false);
    } } };

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =


















{

  data: function data() {
    var me = this;
    return {
      layout: [],

      btns: [{
        label: '确定', func: this.setUserDeptSure },
      {
        label: '取消', func: this.cancelChoose, type: 'default' }],

      userIds: [] };

  },
  computed: {
    deptTreeUrl: function deptTreeUrl() {

      if (!this.userInfo || !this.userInfo.developer) return this.mwUrl("/api/org/listDepartmentListAble");
      return this.mwUrl("/api/org/listDepartment");
    } },

  mounted: function mounted() {
    var me = this;
    var filterInvalidLoginIds = window.$Env && $Env.filterInvalidLoginIds || "";
    me.layout = [
    [{
      span: 0,
      type: 'menu',
      label: '无效用户',
      api: 'org.listUserPaging',
      defaultParams: { active: 0, filterLoginId: filterInvalidLoginIds },
      columns: [
      { type: 'selection' },

      { prop: 'loginId', label: '账号', tooltip: true },
      { prop: 'name', label: '名称', tooltip: true },
      { prop: 'tel', label: '座机电话', tooltip: true },
      { prop: 'mobile', label: '移动电话', tooltip: true },
      { prop: 'email', label: '电子邮箱', tooltip: true },
      { prop: 'lastModifiedTime', label: '最近修改时间', tooltip: true }] },

    {
      span: 8,
      type: 'button',
      items: [{
        label: '设置部门',
        icon: 'fa fa-plus-square',
        func: me.setDept },
      {
        label: '删除',
        icon: 'fa fa-trash-o fa-fw',
        func: me.deleteUsers }] },

    {
      span: 6,
      type: 'searchText',
      offset: 10,
      name: 'name' }]];


  },
  methods: {

    setDept: function setDept(data) {
      if (data.length == 0) {
        this.mwMsg('info', '请选择你要设置的用户');
      } else {
        this.mwRef('setDeptDialog').show();
        var userIds = [];
        data.forEach(function (r) {
          userIds.push(r.id);
        });
        this.userIds = userIds;
      }
    },

    deleteUsers: function deleteUsers(data) {var _this = this;
      if (data.length == 0) {
        this.mwMsg('info', '请选择你要操作的用户');
      } else
      {
        this.$confirm('是否要删除此用户?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).
        then(function () {
          var arrIds = [];
          data.forEach(function (r) {
            arrIds.push(r.id);
          });
          _this.mwApi.org.deleteUser(arrIds).then(function (data) {
            if (data.success) {
              _this.mwMsg('删除成功!');
              _this.mwRef('toolbarTable').refreshTable();
            } else
            {
              _this.mwMsg('info', '删除成功!');
            }
          });

        });


      }

    },

    setUserDeptSure: function setUserDeptSure() {var _this2 = this;

      var departmentId = this.mwRef('deptTree').getSelected().id;
      this.mwApi.org.addDepartmentUser(departmentId, this.userIds).then(function (data) {
        if (data.success) {

          _this2.mwMsg('设置部门成功!');
          _this2.mwRef('toolbarTable').refreshTable();
          _this2.cancelChoose();


        }

      });
    },
    cancelChoose: function cancelChoose() {
      this.mwRef('setDeptDialog').hide();
    },
    toUser: function toUser() {
      this.$router.push({ path: '/set/user' });
    } } };

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);
































































































































var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  data: function data() {
    var me = this;
    return {
      unitDialogVisible: false,
      edit: false,
      expandFlag: 1,
      change: false,
      reset: false,
      defaultTreeParams: { t: Date.now() },
      defaultUnitParams: {},
      unitTreeUrl: this.mwUrl('/api/org/getUnitTreeContainSelf'),
      roleTreeUrl: this.mwUrl('/api/org/listAllGroupedRole'),

      contextMenuItem: [{ name: 'add', icon: 'fa fa-plus-square', label: '新增', func: me.addRole }, {
        name: 'delete',
        label: '删除',
        icon: 'fa fa-trash-o',
        func: me.deleteRole }],


      unitFooterButton: [
      { label: '全选', func: me.selectAllUnit },
      { label: '不选', func: me.unSelectAllUnit, type: 'default' },
      { label: '确定', func: me.selectUnitSure },
      { label: '取消', func: me.selectUnitCancel, type: 'default' }],

      checkUnitIds: [],
      form: {
        id: '',
        name: '',
        dec: '',
        code: '',
        unitNames: '',
        unitIds: '',
        authType: '1',
        type: '1' },


      form1: {},
      rules: {
        name: [
        { required: true, message: '请输入名称', trigger: 'blur' }],
        code: [
        { required: true, message: '请输入类别', trigger: 'blur' }] },

      importAction: '/api/org/importRoleFromExcel',
      impBtton: [{
        label: "取消",
        func: this.impCancel,
        type: "default" }],

      headers: {},
      isFirstOpen: true };

  },
  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'userInfo',
  'expUser'])),


  mounted: function mounted() {

    var isSysAdmin = this.isSysAdmin();
    var parentId = void 0;
    if (this.userInfo.developer || isSysAdmin) {
      parentId == this.userInfo.owner;
    } else {
      if (this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0) {
        parentId = this.$store.getters.curUnit[0].id;
      }
    }
    if (parentId) this.defaultUnitParams.parentId = parentId;
  },
  methods: {
    showUpload: function showUpload() {
      if (this.isFirstOpen) {
        this.initUploader();
        this.isFirstOpen = false;
      }
    },
    initUploader: function initUploader() {
      var me = this;
      var cfg = {
        buttonId: me.mwRef('uploader').$el,
        maxSize: 500,
        action: me.importAction,
        accept: "xls" };

      var fn = {
        fileUploaded: function fileUploaded(up, file, resp) {debugger;
          me.importSuccessCallback(resp, file, up);
        } };

      PF.initPupload(cfg, fn);
    },

    changed: function changed(data) {var _this = this;
      var me = this;
      if (this.change) {
        this.$confirm('文档修改后尚未保存，是否保存?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).
        then(function () {
          me.saveRole();
        }).catch(function () {me.refresh();});
        me.change = false;
      } else {
        if (data.id && data.hasChild == 0) {
          me.resetFields();
          me.mwApi.org.getRole(data.id).then(function (res) {
            if (res.result) {
              for (var i in res.result) {
                me.form1[i] = res.result[i];
              }
              me.form1.authType = res.result.authType ? res.result.authType : '1';
              me.mwUtil.applyCover(me.form, res.result);
              _this.edit = true;
              _this.reset = false;
            }
          });
        }}
    },
    helpnotes: function helpnotes() {
      PF.showHelp({ url: '/helpDoc/platform/permission.md' });
    },
    isSysAdmin: function isSysAdmin() {
      if (this.userInfo.roleNames && this.userInfo.roleNames.indexOf("系统管理员") != -1) {
        return true;
      }
      return false;
    },
    addRole: function addRole(data, parents) {var _this2 = this;
      this.resetFields();
      this.edit = false;
      if (this.mwRef('roleTree').getSelected()) {
        if (!data) {
          var node = this.mwRef('roleTree').getSelected();
          var _parents = this.mwRef('roleTree').getNode(node.id).parents;
          var nodeName = [];
          _parents.forEach(function (p) {
            if (p != '#')
            nodeName.push(_this2.mwRef('roleTree').getNode(p).text);
          });
          this.form.code = nodeName.join('/');
        } else {
          if (parents) {
            var code = [];
            if (data.hasChild != 0) {
              code.push(data.name);
            }
            parents.forEach(function (d) {
              code.unshift(d.name);
            });
            this.form.code = code.join("/");
          }
        }
        var treeNode = this.mwRef('roleTree').getSelected();
        if (["身份权限", "文档权限", "流程权限"].indexOf(treeNode.name) > -1) {
          if (treeNode.name == "身份权限") {
            this.form.type = "1";
          } else if (treeNode.name == "文档权限") {
            this.form.type = "2";
          } else if (treeNode.name == "流程权限") {
            this.form.type = "3";
          }
        } else {
          this.form.type = treeNode.type;
        }

      }
    },
    saveRole: function saveRole() {var _this3 = this;
      var me = this;
      me.mwRef('roleForm').validate(function (valid) {
        if (valid) {
          me.mwApi.org.saveRole(me.form).then(function (data) {
            if (data.success) {
              me.mwMsg('权限保存成功');
              me.refresh();
            } else
            {
              me.mwMsg('warning', '权限保存失败');
            }
            _this3.change = false;
          });
        } else {
          me.mwMsg('warning', '请输入完整信息');
        }
      });
    },
    deleteRole: function deleteRole(data) {var _this4 = this;
      var me = this;
      if (!data) {
        if (this.mwRef('roleTree').getSelected()) {
          data = this.mwRef('roleTree').getSelected();
        } else {
          me.mwMsg('请选择要删除的节点!');
        }
      }
      if (data.hasChild == 0) {
        me.mwConfirm('您确定要删除此权限').then(function () {
          me.mwApi.org.deleteRole(data.id).then(function (res) {
            if (res.success) {
              me.mwMsg("删除成功");
              _this4.edit = false;
              _this4.change = false;
              me.refresh();
            } else {
              me.mwMsg('warning', '删除失败');
            }
          });
        }).catch(function () {

        });
      } else {
        me.mwConfirm('您确定要删除此类别权限').then(function () {
          me.mwApi.org.deleteRoleByCate(data.id).then(function (res) {
            if (res.success) {
              me.mwMsg("删除成功");
              _this4.change = false;
              me.refresh();
            } else {
              me.mwMsg("删除失败");
            }
          });
        }).catch(function () {

        });
      }
    },

    showUnitDialog: function showUnitDialog() {
      var me = this;
      if (me.form.unitIds) {
        me.checkUnitIds = me.form.unitIds.split(',');
      } else {
        me.checkUnitIds = [];
      }
      me.mwRef('unitDialog').show();
    },

    selectAllUnit: function selectAllUnit() {
      this.mwRef('unitTree').checkAll();
    },

    unSelectAllUnit: function unSelectAllUnit() {
      this.mwRef('unitTree').unCheckAll();
    },

    selectUnitSure: function selectUnitSure() {
      var me = this,unitIds = [],unitNames = [];
      this.mwRef('unitTree').getSelected().forEach(function (d) {
        unitIds.push(d.id);
        unitNames.push(d.text);
      });
      me.form.unitIds = unitIds.join();
      me.form.unitNames = unitNames.join();
      this.selectUnitCancel();
    },
    selectUnitCancel: function selectUnitCancel() {
      this.mwRef('unitDialog').hide();
    },

    resetFields: function resetFields() {
      this.reset = true;
      this.mwRef('roleForm').resetFields();
    },
    refresh: function refresh() {

      this.resetFields();
      this.mwRef('roleTree').refresh();
    },
    expand: function expand() {
      this.expandFlag = 2;
      this.mwRef('roleTree').openAll();
    },
    closed: function closed() {
      this.expandFlag = 1;
      this.mwRef('roleTree').closeAll();
    },
    handleMoreCommand: function handleMoreCommand(command) {
      var me = this;
      if (command === 'import') {
        this.mwRef('impDialog').show();
      }
      if (command === 'export') {
        me.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportRoleToExcel"), {}, false, "");
      }
    },
    impCancel: function impCancel() {
      this.mwRef('impDialog').hide();
    },
    importSuccessCallback: function importSuccessCallback(response, file, up) {
      if (response.result) {
        this.mwRef('roleTree').refresh();
        PF.show('message', { html: response.result.errMsg });
        this.mwRef('impDialog').hide();
      }
      this.mwRef("importData").clearFiles();
    },
    downloadExcel: function downloadExcel() {
      var me = this;
      me.mwUtil.downloadAttachment("/template_file/importRoleExcel.xls");
    } },

  watch: {
    form: {
      handler: function handler(curVal, oldVal) {var _this5 = this;
        var me = this;
        if (!this.reset) {
          this.change = false;var _loop = function _loop(
          i) {

            if (curVal[i]) {
              if (i === 'type') {
                if (curVal["id"] && curVal["id"] != "" && curVal[i] != _this5.form1[i]) {
                  me.mwConfirm('修改后将会影响该权限之前配置的角色作用').then(function () {
                    me.change = true;
                  }).catch(function () {
                    curVal[i] = _this5.form1[i];
                  });
                }
              } else if (i === 'authType') {
                if (curVal[i] != _this5.form1[i]) {
                  _this5.change = true;
                }
              } else {
                if (!_this5.form1[i]) {
                  _this5.form1[i] = '';
                }
                if (curVal[i] != _this5.form1[i]) {
                  _this5.change = true;
                }}
            }};for (var i in curVal) {_loop(i);}}
      },
      deep: true } } };

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);
























































































var _roleInf = __webpack_require__(1202);var _roleInf2 = _interopRequireDefault(_roleInf);
var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{

  components: {
    role: _roleInf2.default },

  data: function data() {
    var me = this;
    return {
      layout: [],
      expandFlag: 1,
      loading: false,
      firstTime: true,
      openDialog: false,
      change: false,
      defaultParams: { deep: true, isContainSelf: true, parentId: "" },
      unitTreeUrl: 'api/org/getUnitTreeContainSelf',
      id: '',
      deptInfo: '',
      showDefultBtn: '',
      importAction: '/api/org/importJobRoleFromExcel',
      savingGroup: false,
      impBtton: [{
        label: "取消",
        func: this.impCancel,
        type: "default" },

      {
        label: "导入",
        func: this.import }],

      headers: {},
      treeData: [] };

  },

  mounted: function mounted() {
    var me = this;
    me.layout = [
    [{
      span: 0,
      type: 'menu',
      label: '角色管理列表',
      api: 'org.listGroupPagingByAuthType',
      columns: [
      { type: 'selection' }, { type: 'index' },
      { slot: { type: "href", func: me.editRole }, prop: 'name', label: '角色名称', tooltip: true },
      { prop: 'roleNames', label: '角色权限' },
      { prop: 'userNames', label: '用户人员' },
      { prop: 'dec', label: '描述' }] },

    {
      span: 8,
      type: 'button',
      items: [{
        label: '添加',
        icon: 'fa fa-plus-square',
        func: me.addRole },

      {
        label: '删除',
        icon: 'fa fa-trash-o fa-fw',
        func: me.deleteGroup }],


      suffixSlot: "dropDown" },
    {
      span: 6,
      type: 'searchText',
      offset: 10,
      name: 'name' }]];


    var isSysAdmin = this.isSysAdmin();
    if (this.userInfo.developer || isSysAdmin) {
      this.defaultParams.parentId = "";
    } else {
      if (this.userInfo.loginUnitModel)
      this.defaultTreeParams.unitId = this.userInfo.loginUnitModel.id;
      if (this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0) {
        this.defaultParams.parentId = this.$store.getters.curUnit[0].id;
      }
    }
    this.mwRef("unitTree").renderTree();
  },

  methods: {
    addRole: function addRole() {
      this.id = '';
      this.mwRef('limitTree').show();
      this.openDialog = true;
    },
    isSysAdmin: function isSysAdmin() {
      if (this.userInfo.roles && this.userInfo.roles.length > 0) {
        for (var i = 0; i < this.userInfo.roles.length; i++) {
          if (this.userInfo.roles[i].name == "系统管理员") {
            return true;
          }
        }
      }
      return false;
    },
    editRole: function editRole(row) {
      this.id = row.id;
      this.mwRef('limitTree').show();
    },

    saveGroup: function saveGroup() {var _this = this;
      if (this.savingGroup) return;
      if (this.mwRef('role').valid()) {
        var group = this.mwRef('role').getValue();
        if (group.postRoleIds == "" && group.docRoleIds == "" && group.flowRoleIds == "") {
          this.mwMsg('warning', '权限角色至少选择一个');
          return;
        }
        this.savingGroup = true;
        this.mwApi.org.saveGroup(group).then(function (data) {
          if (data.success) {
            _this.mwMsg('权限保存成功');

            _this.refresh();
            _this.handleClose();
            _this.openDialog = false;
          } else {
            _this.mwMsg('权限组保存失败');
          }
          _this.savingGroup = false;
        });

      } else {
        this.mwMsg('warning', '请输入完整信息');
      }

    },

    handleClose: function handleClose() {
      this.id = '';
      this.mwRef('role').resetFields();
      this.mwRef('limitTree').hide();
    },

    deleteGroup: function deleteGroup(data) {var _this2 = this;
      var me = this;
      if (data.length == 0) {
        this.mwMsg('info', '请选择你要操作的角色');
      } else
      {
        this.$confirm('是否要删除此角色?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).
        then(function () {
          var arrIds = [];
          data.forEach(function (val) {
            arrIds.push(val.id);
          });
          _this2.mwApi.org.deleteGroup(arrIds).then(function (res) {
            if (res.success) {
              _this2.mwMsg('删除成功!');
              _this2.refresh();
            } else
            {
              _this2.mwMsg('info', '删除成功!');
            }

          });}).catch(function () {});
      }
    },


    loadTableTree: function loadTableTree(data) {var _this3 = this;
      var me = this;
      this.deptInfo = { code: data.id, unitId: data.id, unitName: data.name };

      var params = { code: data.id, start: 0, limit: 2000 };
      this.mwApi.org.listGroupPagingByAuthType(params).then(function (res) {
        _this3.showDefultBtn = '1';
        for (var y = 0; y < res.result.length; y++) {
          if (res.result[y].name == "默认角色") {
            _this3.showDefultBtn = '';
          }
        }
      });
      this.mwRef('dataTable').refreshTableDefaultParams({ code: data.id });
    },


    refresh: function refresh() {
      this.mwRef('dataTable').refreshTableDefaultParams({ code: this.deptInfo.code });

    },
    expand: function expand() {
      this.expandFlag = 2;
      this.mwRef('unitTree').openAll();
    },
    closed: function closed() {
      this.expandFlag = 1;
      this.mwRef('unitTree').closeAll();
    },
    toGroup: function toGroup() {


      if (!window["$servicePath"]) {
        this.$router.push({ path: '/org/group' });
      } else {
        var p = this.$parent;
        do {
          if (p.changeView) {
            p.changeView("systemSet_org_group");
          }
          p = p.$parent;
        } while (p);
      }
    },
    handleMoreCommand: function handleMoreCommand(command) {
      var me = this;
      if (command === 'import') {
        this.mwRef('impDialog').show();
      }
      if (command === 'export') {
        var dataTable = me.mwRef('dataTable');
        var multipleSelection = dataTable.getMultipleSelection();
        if (multipleSelection && multipleSelection.length > 0) {
          var groupIds = [];
          multipleSelection.forEach(function (val) {
            groupIds.push(val.id);
          });
          me.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportJobRoleToExcel"), {}, false, PF.encode({ groupIds: groupIds }));
        } else {
          var data = void 0;
          if (this.mwRef('unitTree').getSelected()) {
            data = this.mwRef('unitTree').getSelected();
          } else {
            me.mwMsg('请选择要导出的单位节点!');
            return;
          }
          me.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportJobRoleToExcel"), { codes: [data.id] }, false, "");
        }
      }
    },
    import: function _import() {
      var me = this;
      me.mwRef("importData").submit();
    },
    impCancel: function impCancel() {
      this.mwRef('impDialog').hide();
    },
    importSuccessCallback: function importSuccessCallback(response, file, fileList) {
      if (this.mwRef("importData") && typeof this.mwRef("importData").clearFiles == 'function') this.mwRef("importData").clearFiles();
      if (response.result) {
        this.mwRef('unitTree').refresh();
        PF.show('message', { html: response.result.errMsg });
        this.mwRef('impDialog').hide();
      }
    },
    downloadExcel: function downloadExcel() {
      var me = this;
      me.mwUtil.downloadAttachment("/template_file/importJobRoleExcel.xls");
    } },

  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'userInfo',
  'expUser'])),


  watch: {} };

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);




































































































var _loadManager = __webpack_require__(139);var _loadManager2 = _interopRequireDefault(_loadManager);
var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  components: {
    loadMan: _loadManager2.default },

  props: {
    groupId: {
      type: String,
      default: '' },

    openDialog: {
      type: Boolean,
      default: false },

    deptInfo: {
      type: Object },

    showDefultBtn: {
      type: String,
      default: '' } },


  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'userInfo',
  'expUser'])),


  data: function data() {

    var me = this;
    return {

      defaultParentId: '',
      firstTime: true,
      change: false,
      isShowDefultBtn: this.showDefultBtn,

      unitTreeUrl: this.mwUrl('/api/org/getUnitTreeContainSelf'),
      defaultParams: { deep: true, isContainSelf: true, parentId: "" },
      roleTreeUrl: this.mwUrl('/api/org/listAllGroupedRole'),


      unitFooterButton: [
      { label: '取消', func: me.selectUnitCancel, type: 'default' },
      { label: '确定', func: me.selectUnitSure }],

      roleFooterButton: [
      { label: '取消', func: me.selectRoleCancel, type: 'default' },
      { label: '确定', func: me.selectRoleSure }],


      userFooterButton: [
      { label: '取消', func: me.cancelSelectUser, type: 'default' },
      { label: '确定', func: me.selectUserSure }],


      checkRoleIds: [],
      selectUnitId: '',

      rules: {
        name: [
        { required: true, message: '请输入名称', trigger: 'blur' }] },


      chooseUsers: [],
      group: {
        id: '',
        code: '',
        dec: '',
        name: '',
        unitId: '',
        unitName: '',
        userDeptIdentityIds: '',
        departmentIds: '',
        userNames: '',
        roleIds: '',
        roleNames: '',
        postRoleNames: '',
        postRoleIds: '',
        docRoleNames: '',
        docRoleIds: '',
        flowRoleNames: '',
        flowRoleIds: '' } };



  },
  mounted: function mounted() {
    this.init();
    var isSysAdmin = this.isSysAdmin();
    if (this.userInfo.developer || isSysAdmin) {
      this.defaultParams.parentId = this.userInfo.owner;
    } else {
      if (this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0) {
        this.defaultParams.parentId = this.$store.getters.curUnit[0].id;
      }
    }
  },

  methods: {

    init: function init() {var _this = this;
      if (this.groupId) {
        this.mwApi.org.getGroup(this.groupId).then(function (res) {
          if (res.result) {
            _this.mwUtil.applyCover(_this.group, res.result);
          } else {
            _this.mwMsg('查询失败');
          }
        });
      } else {
        this.group.code = this.deptInfo.code;
        this.group.unitId = this.deptInfo.unitId;
        this.group.unitName = this.deptInfo.unitName;
        this.setShowDefultBtn(this.deptInfo.unitId);
      }
    },


    selectUnitSure: function selectUnitSure() {
      var data = this.mwRef('unitTree').getSelected();
      if (!data) {
        this.mwMsg('warning', '请选择单位');
      } else {
        this.group.code = data.id;
        this.group.unitId = data.id;
        this.group.unitName = data.text;
        this.selectUnitCancel();
        this.setShowDefultBtn(data.id);
      }
    },
    selectUnitCancel: function selectUnitCancel() {
      this.mwRef('unitDialog').hide();
    },

    showUnitDialog: function showUnitDialog() {
      var me = this;
      me.selectUnitId = me.group.unitId;
      this.mwRef('unitDialog').show();
    },
    isSysAdmin: function isSysAdmin() {
      if (this.userInfo.roles && this.userInfo.roles.length > 0) {
        for (var i = 0; i < this.userInfo.roles.length; i++) {
          if (this.userInfo.roles[i].name == "系统管理员") {
            return true;
          }
        }
      }
      return false;
    },
    userChoose: function userChoose() {

      if (this.group.code) {
        this.mwRef('userDialog').show();
        this.chooseUsers = [];
        if (!this.firstTime) {
          this.mwRef('userChoose').refreshTree(true);
        }
        this.firstTime = false;
        this.defaultParentId = this.group.code;
        if (this.group.userNames) {
          var names = this.group.userNames.split(',');
          var ids = this.group.userDeptIdentityIds.split(',');
          for (var i = 0; i < names.length; i++) {
            this.chooseUsers.push({
              departmentId: ids[i],
              name: names[i],
              identityId: ids[i] });

          }
        }} else {
        this.mwMsg('请选择单位');
      }
    },

    cancelSelectUser: function cancelSelectUser() {
      this.mwRef('userDialog').hide();
    },


    showRoleDialog: function showRoleDialog() {
      var me = this;
      me.checkRoleIds = [];
      if (me.group.postRoleIds) {
        me.checkRoleIds = me.checkRoleIds.concat(me.group.postRoleIds.split(','));
      }
      if (me.group.docRoleIds) {
        me.checkRoleIds = me.checkRoleIds.concat(me.group.docRoleIds.split(','));
      }
      if (me.group.flowRoleIds) {
        me.checkRoleIds = me.checkRoleIds.concat(me.group.flowRoleIds.split(','));
      }
      this.mwRef('roleDialog').show();
    },


    selectUserSure: function selectUserSure() {
      this.mwRef('userDialog').hide();
      this.group.userNames = '';
      this.group.userDeptIdentityIds = '';
      this.group.departmentIds = '';
      var data = this.mwRef('userChoose').getValue();
      var userNames = [];
      var userDeptIdentityIds = [];
      var departmentIds = [];
      data.forEach(function (d) {
        userNames.push(d.name);
        userDeptIdentityIds.push(d.identityId);
        departmentIds.push(d.departmentId);
      });

      this.group.userNames = userNames.join();
      this.group.userDeptIdentityIds = userDeptIdentityIds.join();
      this.group.departmentIds = departmentIds.join();

    },


    selectRoleSure: function selectRoleSure() {
      var postRoleIds = [],postRoleNames = [],docRoleIds = [],docRoleNames = [],flowRoleIds = [],flowRoleNames = [];
      this.mwRef('roleTree').getSelected().forEach(function (d) {
        if (d.type && d.type == "1") {
          postRoleIds.push(d.id);
          postRoleNames.push(d.text);
        } else if (d.type && d.type == "2") {
          docRoleIds.push(d.id);
          docRoleNames.push(d.text);
        } else if (d.type && d.type == "3") {
          flowRoleIds.push(d.id);
          flowRoleNames.push(d.text);
        }
      });
      this.group.postRoleIds = postRoleIds.join();
      this.group.postRoleNames = postRoleNames.join();
      this.group.docRoleIds = docRoleIds.join();
      this.group.docRoleNames = docRoleNames.join();
      this.group.flowRoleIds = flowRoleIds.join();
      this.group.flowRoleNames = flowRoleNames.join();
      this.selectRoleCancel();
    },

    selectRoleCancel: function selectRoleCancel() {
      this.mwRef('roleDialog').hide();
    },


    valid: function valid() {
      var val = false;
      this.mwRef('groupForm').validate(function (valid) {
        val = valid;
      });
      return val;
    },

    getValue: function getValue() {
      return this.group;
    },
    resetFields: function resetFields() {
      this.mwRef('groupForm').resetFields();
    },
    changeDefultRole: function changeDefultRole(type) {
      if (type && type == "1") {
        this.group.name = '默认角色';
        this.isShowDefultBtn = '2';
      } else {
        this.group.name = '';
        this.isShowDefultBtn = '1';
      }
    },
    setShowDefultBtn: function setShowDefultBtn(unitid) {
      var me = this;
      var params = { code: unitid, start: 0, limit: 2000 };
      me.mwApi.org.listGroupPagingByAuthType(params).then(function (res) {
        me.isShowDefultBtn = 1;
        for (var y = 0; y < res.result.length; y++) {
          if (res.result[y].name == "默认角色") {
            me.isShowDefultBtn = 0;
          }
        }
      });
    } },



  watch: {
    openDialog: function openDialog(val) {
      if (val && !this.groupId) {
        this.init();
      }
    },
    groupId: function groupId(val) {
      this.init();
    },
    deptInfo: function deptInfo() {
      this.init();
    } } };

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



var _jobRole = __webpack_require__(1207);var _jobRole2 = _interopRequireDefault(_jobRole);
var _roleList = __webpack_require__(212);var _roleList2 = _interopRequireDefault(_roleList);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  components: {
    systemSet_org_group: _jobRole2.default,
    systemSet_org_roleList: _roleList2.default },

  data: function data() {
    return {
      compId: "" };

  },
  props: {
    viewId: String,
    default: "systemSet_org_group" },

  mounted: function mounted() {
    var me = this;
    if (this.viewId) {
      this.compId = this.viewId;
    } else {
      this.compId = "systemSet_org_group";
    }
  },
  methods: {
    changeView: function changeView(viewId) {
      this.compId = viewId;
    } } };

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _methods;


































































































































































var _loadManager = __webpack_require__(139);var _loadManager2 = _interopRequireDefault(_loadManager);
var _unitDialog = __webpack_require__(422);var _unitDialog2 = _interopRequireDefault(_unitDialog);
var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =


{
  components: {
    loadMan: _loadManager2.default,
    unitDialog: _unitDialog2.default },

  data: function data() {
    var me = this;
    var isShowCategory = !!(window.$Env && $Env.jobRoleShowCategory);
    var defaultParams = { isShowChild: true, type: 'auth', unitId: "", isShowCategory: isShowCategory };
    var allIdentityRoleNames = me.$store.getters.expUser.allIdentityRoleNames;
    var isOnlySelUser = false;
    if (allIdentityRoleNames && allIdentityRoleNames.indexOf("系统管理员") == -1 && me.$store.getters.expUser.unitAdmin) {
      var unitObj = me.$store.getters.unitDepartments;
      defaultParams.unitId = me.$store.getters.curSelUnitId || unitObj && unitObj[0].id || "";
      var params = this.$options.parent.$attrs && this.$options.parent.$attrs.params;
      if (params && params.unitAdmin == 'onlySelUser') {
        isOnlySelUser = true;
      }
    }
    return {
      expandFlag: 1,
      userDialogVisible: false,
      firstTime: true,
      isShowCategory: isShowCategory,
      defaultTreeParams: defaultParams,
      groupTreeUrl: this.mwUrl('/api/org/getGroupTreeByType'),
      unitTreeUrl: this.mwUrl('/api/org/getUnitTree'),
      roleTreeUrl: this.mwUrl('/api/org/listAllGroupedRole'),
      contextMenuItem: [
      { name: 'add', icon: 'fa fa-plus-square', label: '新增', func: me.addGroup },
      { name: 'delete', label: '删除', icon: 'fa fa-trash-o', func: me.deleteGroup }],

      unitFooterButton: [
      { label: '确定', func: me.selectUnitSure },
      { label: '取消', func: me.selectUnitCancel, type: 'default' }],

      roleFooterButton: [
      { label: '确定', func: me.selectRoleSure },
      { label: '取消', func: me.selectRoleCancel, type: 'default' }],

      userFooterButton: [
      { label: '确定', func: me.selectUserSure },
      { label: '取消', func: me.cancelSelectUser, type: 'default' }],

      isOnlySelUser: isOnlySelUser,
      checkRoleIds: [],
      selectUnitId: '',
      curUnitId: '',
      group: {
        id: '',
        code: '',
        dec: '',
        name: '',
        unitId: '',
        category: '',
        unitName: '',
        userDeptIdentityIds: '',
        departmentIds: '',
        userNames: '',
        roleIds: '',
        roleNames: '',
        postRoleNames: '',
        postRoleIds: '',
        docRoleNames: '',
        docRoleIds: '',
        flowRoleNames: '',
        flowRoleIds: '' },

      rules: {
        name: [
        { required: true, message: '请输入名称', trigger: 'blur' }],

        unitName: [
        { required: true, message: '请输入选择单位', trigger: 'change' }] },


      chooseUsers: [],
      defaultParentId: '',
      listAble: false,
      loading: false,
      change: false,
      reset: false,
      form1: {},
      importAction: '/api/org/importJobRoleFromExcel',
      impBtton: [{
        label: "取消",
        type: "default",
        func: this.impCancel }],

      isFirstOpen: true };

  },
  mounted: function mounted() {

    var isSysAdmin = this.isSysAdmin();
    this.listAble = !this.userInfo.developer;

    if (this.userInfo.developer || isSysAdmin) {
      this.curUnitId = this.userInfo.owner || "";
    } else {
      if (this.userInfo.loginUnitModel)
      this.defaultTreeParams.unitId = this.userInfo.loginUnitModel.id;
      if (this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0) {
        this.curUnitId = this.$store.getters.curUnit[0].id;
      }
    }
    this.mwRef("groupTree").renderTree();
  },
  methods: (_methods = {
    showUpload: function showUpload() {
      if (this.isFirstOpen) {
        this.initUploader();
        this.isFirstOpen = false;
      }
    },
    initUploader: function initUploader() {
      var me = this;
      var cfg = {
        buttonId: me.mwRef('uploader').$el,
        maxSize: 500,
        action: me.importAction,
        autoUpload: true,
        accept: "xls" };

      var fn = {
        fileUploaded: function fileUploaded(up, file, resp) {
          me.importSuccessCallback(resp, file, up);
        } };

      PF.initPupload(cfg, fn);
    },

    changed: function changed(data) {
      var me = this;
      if (this.change) {
        this.$confirm('文档修改后尚未保存，是否保存?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).
        then(function () {
          me.saveGroup();
        }).catch(function () {me.refresh();});
        me.change = false;
      } else {
        if (data.id && data.hasChild == 0) {
          me.setShowDefultBtn(data.unitId);
          me.resetFields();
          me.mwApi.org.getGroup(data.id).then(function (res) {
            for (var i in res.result) {
              me.form1[i] = res.result[i];
            }
            me.mwUtil.applyCover(me.group, res.result);
          });
          this.reset = false;
        }
      }
    },
    processTreeParams: function processTreeParams(params) {
    },
    isSysAdmin: function isSysAdmin() {
      if (this.userInfo.roleNames && this.userInfo.roleNames.indexOf("系统管理员") != -1) {
        return true;
      }
      return false;
    },
    confirmUnit: function confirmUnit() {
      var data = this.mwRef('unitDialog').getValue();
      this.group.code = data.id;
      this.group.unitId = data.id;
      this.group.unitName = data.text;
      this.setShowDefultBtn(data.id);

    },
    confirmUnit1: function confirmUnit1() {
      var data = this.mwRef('unitDialog1').getValue();
      var ids = data.map(function (v) {return v.id;});
      this.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportJobRoleToExcel"), { codes: ids.join(",") }, false, "");
    },
    showUnitDialog: function showUnitDialog() {
      var me = this;
      me.selectUnitId = me.group.unitId;
      this.mwRef('unitDialog').show();
      MW.test(function () {
        if (me.mwRef('unitDialog').mwRef('unitTree'))
        return true;
        return false;
      }, function () {
        me.mwRef('unitDialog').mwRef('unitTree').defaultParams.parentId = me.curUnitId;
        me.mwRef('unitDialog').mwRef('unitTree').renderTree();
      }, 50);
    },

    userChoose: function userChoose() {

      if (this.group.code) {
        this.mwRef('userDialog').show();
        this.chooseUsers = [];
        if (!this.firstTime) {
          this.mwRef('userChoose').refreshTree(true);
        }
        this.firstTime = false;
        this.defaultParentId = this.group.code;
        if (this.group.userNames) {
          var names = this.group.userNames.split(',');
          var ids = this.group.userDeptIdentityIds.split(',');
          var departmentIds = this.group.departmentIds.split(',');
          for (var i = 0; i < names.length; i++) {
            this.chooseUsers.push({
              departmentId: departmentIds[i],
              name: names[i],
              identityId: ids[i] });

          }
        }} else {
        this.mwMsg('请选择单位');
      }
    },


    showRoleDialog: function showRoleDialog() {
      var me = this;
      me.checkRoleIds = [];
      if (me.group.postRoleIds) {
        me.checkRoleIds = me.checkRoleIds.concat(me.group.postRoleIds.split(','));
      }
      if (me.group.docRoleIds) {
        me.checkRoleIds = me.checkRoleIds.concat(me.group.docRoleIds.split(','));
      }
      if (me.group.flowRoleIds) {
        me.checkRoleIds = me.checkRoleIds.concat(me.group.flowRoleIds.split(','));
      }
      this.mwRef('roleDialog').show();
    },



    selectUserSure: function selectUserSure() {
      this.mwRef('userDialog').hide();
      this.group.userNames = '';
      this.group.userDeptIdentityIds = '';
      this.group.departmentIds = '';
      var data = this.mwRef('userChoose').getValue();
      var userNames = [];
      var userDeptIdentityIds = [];
      var departmentIds = [];
      data.forEach(function (d) {
        userNames.push(d.name);
        userDeptIdentityIds.push(d.identityId);
        departmentIds.push(d.departmentId);
      });

      this.group.userNames = userNames.join();
      this.group.userDeptIdentityIds = userDeptIdentityIds.join();
      this.group.departmentIds = departmentIds.join();

    },
    helpnotes: function helpnotes() {
      PF.showHelp({ url: '/helpDoc/platform/role_management.md' });
    },
    resetFields: function resetFields() {
      this.reset = true;
      this.mwRef('groupForm').resetFields();
    },

    cancelSelectUser: function cancelSelectUser() {
      this.mwRef('userDialog').hide();
    },


    selectRoleSure: function selectRoleSure() {
      var postRoleIds = [],postRoleNames = [],docRoleIds = [],docRoleNames = [],flowRoleIds = [],flowRoleNames = [];
      this.mwRef('roleTree').getSelected().forEach(function (d) {
        if (d.type && d.type == "1") {
          postRoleIds.push(d.id);
          postRoleNames.push(d.text);
        } else if (d.type && d.type == "2") {
          docRoleIds.push(d.id);
          docRoleNames.push(d.text);
        } else if (d.type && d.type == "3") {
          flowRoleIds.push(d.id);
          flowRoleNames.push(d.text);
        }
      });
      this.group.postRoleIds = postRoleIds.join();
      this.group.postRoleNames = postRoleNames.join();
      this.group.docRoleIds = docRoleIds.join();
      this.group.docRoleNames = docRoleNames.join();
      this.group.flowRoleIds = flowRoleIds.join();
      this.group.flowRoleNames = flowRoleNames.join();
      this.selectRoleCancel();

    },

    selectRoleCancel: function selectRoleCancel() {
      this.mwRef('roleDialog').hide();
    },

    addGroup: function addGroup() {
      $("#defultRoleBtn").hide();
      $("#defultRoleBtn").hide();
      this.resetFields();
      var date = this.mwRef('groupTree').getSelected();
      this.group.unitName = date.unitName ? date.unitName : date.name;
      this.group.unitId = date.unitId ? date.unitId : date.id;
      this.group.code = date.unitId ? date.unitId : date.id;
      this.setShowDefultBtn(this.group.unitId);
    },

    saveGroup: function saveGroup() {var _this = this;
      var me = this;
      me.mwRef('groupForm').validate(function (valid) {
        if (valid) {
          if (me.group.postRoleIds == "" && me.group.docRoleIds == "" && me.group.flowRoleIds == "") {
            _this.mwMsg('warning', '权限角色至少选择一个');
            return;
          }
          if (me.group.name === '默认角色' && !me.group.id) {

            me.mwApi.org.listGroupPagingByAuthType({ start: 0, limit: 2000, code: me.group.code, sorts: [], type: "auth" }).then(function (res) {
              if (res.success) {
                if (res.result.length > 0) {
                  res.result.forEach(function (r, index) {
                    if (r.name === me.group.name) {
                      me.mwMsg('warning', '该单位下默认角色不可重复添加');
                      return;
                    } else {
                      if (index === res.result.length - 1) {
                        me.loading = true;
                        me.mwApi.org.saveGroup(me.group).then(function (data) {
                          me.loading = false;
                          if (data.success) {
                            me.mwMsg('权限组保存成功');
                            me.refresh();
                          } else
                          {
                            me.mwMsg('权限组保存失败');
                          }
                        }).catch(function (data) {
                          _this.loading = false;
                        });
                      }
                    }
                  });
                } else if (res.result.length == 0) {
                  me.loading = true;
                  me.mwApi.org.saveGroup(me.group).then(function (data) {
                    me.loading = false;
                    if (data.success) {

                      me.mwMsg('权限组保存成功');
                      me.refresh();
                    } else
                    {
                      me.mwMsg('权限组保存失败');
                    }
                  }).catch(function (data) {
                    _this.loading = false;
                  });
                }
              }
            });
          } else {
            _this.loading = true;
            me.mwApi.org.saveGroup(me.group).then(function (data) {
              _this.loading = false;
              if (data.success) {

                me.mwMsg('权限组保存成功');
                me.refresh();
              } else
              {
                me.mwMsg('权限组保存失败');
              }
            }).catch(function (data) {
              _this.loading = false;
            });
          }
        } else {
          me.mwMsg('warning', '请输入完整信息');
        }
      });
    },
    deleteGroup: function deleteGroup(data) {
      var me = this;

      if (!data.id) {
        if (this.mwRef('groupTree').getSelected()) {
          data = this.mwRef('groupTree').getSelected();
        } else {
          me.mwMsg('请选择要删除的节点!');
        }
      }




      if (data.hasChild == 0) {
        me.mwConfirm('您确定要删除此权限组').then(function () {
          me.mwApi.org.deleteGroup(data.id).then(function (res) {
            if (res.success) {
              me.mwMsg('删除成功');
              me.refresh();
            } else {
              me.mwMsg('warning', '删除失败');
            }
          });
        }).catch(function () {

        });
      } else {
        me.mwConfirm('您确定要删除此单位权限组').then(function () {
          me.mwApi.org.deleteGroupByUnit(data.id).then(function (res) {
            if (res.success) {
              me.mwMsg('删除成功');
              me.refresh();
            } else {
              me.mwMsg('warning', '删除失败');
            }
          });
        }).catch(function () {

        });
      }
    } }, (0, _defineProperty3.default)(_methods, "resetFields", function resetFields()

  {
    this.mwRef('groupForm').resetFields();
  }), (0, _defineProperty3.default)(_methods, "refresh", function refresh()
  {

    $("#generalRoleBtn").hide();
    $("#defultRoleBtn").hide();
    this.resetFields();
    this.mwRef('groupTree').refresh();
  }), (0, _defineProperty3.default)(_methods, "expand", function expand()
  {
    this.expandFlag = 2;
    this.mwRef('groupTree').openAll();
  }), (0, _defineProperty3.default)(_methods, "closed", function closed()
  {
    this.expandFlag = 1;
    this.mwRef('groupTree').closeAll();
  }), (0, _defineProperty3.default)(_methods, "toGroupList", function toGroupList()
  {


    if (!window["$servicePath"]) {
      this.$router.push({ path: '/org/group/list' });
    } else {
      var p = this.$parent;
      do {
        if (p.changeView) {
          p.changeView("systemSet_org_roleList");
        }
        p = p.$parent;
      } while (p);
    }
  }), (0, _defineProperty3.default)(_methods, "changeDefultRole", function changeDefultRole(
  type) {
    if (type && type == "1") {
      this.group.name = '默认角色';
      $("#generalRoleBtn").show();
      $("#defultRoleBtn").hide();
    } else {
      this.group.name = '';
      $("#generalRoleBtn").hide();
      $("#defultRoleBtn").show();
    }
  }), (0, _defineProperty3.default)(_methods, "setShowDefultBtn", function setShowDefultBtn(
  unitid) {
    var params = { code: unitid, start: 0, limit: 2000 };
    this.mwApi.org.listGroupPagingByAuthType(params).then(function (res) {
      var showDefultBtn = 0;
      for (var y = 0; y < res.result.length; y++) {
        if (res.result[y].name == "默认角色") {
          showDefultBtn = 1;
        }
      }
      if (showDefultBtn == 0) {
        $("#defultRoleBtn").show();
      } else {
        $("#defultRoleBtn").hide();
      }
    });
  }), (0, _defineProperty3.default)(_methods, "handleMoreCommand", function handleMoreCommand(
  command) {
    var me = this;
    if (command === 'import') {
      this.mwRef('impDialog').show();
    }
    if (command === 'export') {
      this.mwRef('unitDialog1').show();
      MW.test(function () {
        if (me.mwRef('unitDialog1').mwRef('unitTree'))
        return true;
        return false;
      }, function () {
        me.mwRef('unitDialog1').mwRef('unitTree').defaultParams.parentId = me.curUnitId;
        me.mwRef('unitDialog1').mwRef('unitTree').renderTree();
      }, 50);
    }
  }), (0, _defineProperty3.default)(_methods, "import", function _import()
  {
    var me = this;
    me.mwRef("importData").submit();
  }), (0, _defineProperty3.default)(_methods, "impCancel", function impCancel()
  {
    this.mwRef('impDialog').hide();
  }), (0, _defineProperty3.default)(_methods, "importSuccessCallback", function importSuccessCallback(
  response, file, fileList) {
    if (this.mwRef("importData") && typeof this.mwRef("importData").clearFiles == 'function') this.mwRef("importData").clearFiles();
    if (response.result) {
      this.mwRef('groupTree').refresh();
      PF.show('message', { html: response.result.errMsg });
      this.mwRef('impDialog').hide();
    }
  }), (0, _defineProperty3.default)(_methods, "downloadExcel", function downloadExcel()
  {
    var me = this;
    me.mwUtil.downloadAttachment("/template_file/importJobRoleExcel.xls");
  }), _methods),

  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'userInfo',
  'expUser'])),


  watch: {
    group: {
      handler: function handler(curVal, oldVal) {
        if (!this.reset) {
          this.change = false;
          for (var i in curVal) {

            if (curVal[i]) {
              if (!this.form1[i]) {
                this.form1[i] = '';
              }
              if (curVal[i] != this.form1[i]) {
                this.change = true;
              }
            }}}
      },
      deep: true } } };

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_unitDialog_vue__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_unitDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_unitDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_unitDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_unitDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6d0677cb_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_unitDialog_vue__ = __webpack_require__(1209);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_unitDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6d0677cb_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_unitDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =









{
  data: function data() {
    return {
      defaultParams: { deep: true, isContainSelf: false, parentId: "" },
      unitTreeUrl: 'api/org/getUnitTreeContainSelf',
      treeData: [],
      unitFooterButton: [
      { label: '确定', func: this.selectUnitSure },
      { label: '取消', func: this.selectUnitCancel, type: 'default' }] };


  },
  props: {
    selectUnitId: {
      type: String,
      default: '' },

    multiple: {
      type: Boolean,
      default: false } },


  mounted: function mounted() {
    var me = this;
  },
  methods: {

    selectUnitSure: function selectUnitSure() {
      var data = this.mwRef('unitTree').getSelected();
      if (!data) {
        this.mwMsg('warning', '请选择单位');
      } else {
        this.$emit("confirm");
        this.selectUnitCancel();
      }
    },
    selectUnitCancel: function selectUnitCancel() {
      this.mwRef('unitDialog').hide();
    },
    getValue: function getValue() {

      return this.mwRef('unitTree').getSelected();
    },
    show: function show() {
      this.mwRef('unitDialog').show();
    } } };

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);















































































































































































































var _loadUsers = __webpack_require__(140);var _loadUsers2 = _interopRequireDefault(_loadUsers);
var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  components: {
    loadUsers: _loadUsers2.default },

  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'userInfo',
  'expUser'])),


  data: function data() {
    var me = this;

    var qzflList = window.$Env && $Env.orgGroupCategoryList ? $Env.orgGroupCategoryList : [
    { 'id': 1, 'name': '机关领导' }, { 'id': 2, 'name': '领导群组' }];

    return {
      isLimit: false,
      layout: [],
      selUnitId: "",
      expandFlag: 1,
      toolbarPosition: window.$Env && $Env.toolbarPosition || 'TOP',
      showGroupOutOrg: true,
      selUnitName: "",
      formSelUnitId: '',
      selCode: "",
      showQJT: true,
      showBDW: false,
      groupTreeUrl: this.mwUrl('/api/org/getGroupTreeByType'),
      defaultTreeParams: { type: 'address_book' },
      unitFooterButton: [
      { label: '取消', func: me.selectUnitCancel, type: "default" },
      { label: '确定', func: me.selectUnitSure }],

      unitFooterButton1: [
      { label: '取消', func: me.selectUnitCancel1, type: "default" },
      { label: '确定', func: me.selectUnitSure }],

      externalBtn: [
      { label: '确定', func: me.externalSure }],

      btns: [{
        label: '取消',
        type: 'default',
        func: me.closeGroupDialog },
      {
        label: '确定',
        func: this.groupSure }],

      check: '',
      list: qzflList,
      unitTreeUrl: this.mwUrl('/api/org/getGroupUnitTree'),
      defaultParams: { deep: true, isContainSelf: false, parentId: "" },
      selectUnitId: '',
      showAllOrg: false,
      showCurOrg: false,
      isExportGroup: false,
      form: {
        id: '',
        code: '',
        name: '',
        sn: 1,
        unitName: '',
        unitId: '',
        departments: '',
        departmentids: '',
        users: '',
        userids: '',
        externalUnit: '' },


      formRules: {
        unitName: [
        { required: true, message: $lang("请选择所属单位"), trigger: 'change' }],

        code: [
        { required: true, message: $lang("请选择分类"), trigger: 'change' }],

        name: [
        { required: true, message: $lang("请输入名称"), trigger: 'blur' }] },


      checkNodes: { dept: [], deptUsers: [] },
      outerDept: '',
      curSelParams: {},
      importAction: '/api/org/importGroupFromExcel',
      impBtton: [{
        label: "取消",
        func: this.impCancel,
        type: "default" }],

      headers: {},
      curUnitId: "",
      isFirstOpen: true };

  },
  mounted: function mounted() {
    var me = this;
    if (window.$Env && $Env.hideGroupOutOrg) {
      me.showGroupOutOrg = false;
    }
    me.layout = [
    [{
      span: 0,
      type: 'menu',
      label: '群组管理',
      api: 'org.listGroupDataByType',
      defaultParams: {
        type: 'address_book' },

      columns: [
      { type: 'selection' }, { prop: 'sn', width: '55', label: '序号' },
      { prop: 'name', label: '名称', slot: { type: "href", func: me.openForm } },
      { prop: 'departments', label: '部门成员', tooltip: true },
      { prop: 'users', label: '用户成员', tooltip: true },
      { prop: 'createUser', label: '修改者' }] },

    {
      span: 12,
      type: 'button',
      items: [{
        label: '添加',
        func: me.addTitle },
      {
        label: '删除',
        func: me.deleteGroup,
        icon: "el-icon-delete" }],
      suffixSlot: "dropDown" },
    {
      span: 6,
      type: 'searchText',
      name: 'name',
      offset: 4,
      func: me.search }]];


    var isSysAdmin = this.isSysAdmin();
    if (this.userInfo.developer || isSysAdmin) {
      this.showCurOrg = true;
      this.defaultParams.parentId = this.userInfo.owner || "";
    } else {
      if (this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0) {
        this.defaultTreeParams.unitId = this.$store.getters.curUnit[0].id;
        this.defaultParams.parentId = this.$store.getters.curUnit[0].id;
      }
    }
    this.mwRef('groupTree').renderTree();
    me.$nextTick(function () {

      $(me.$el).find(".el-row").append('<button id="help" style="float:right;margin-top:8px;" type="button" class="el-button el-button--info"><span><i class="fa fa-question"></i><span>帮助</span></span></button>');
      $("#help").click(function () {
        me.showHelp();
      });
    });

  },
  methods: {
    showUpload: function showUpload() {
      if (this.isFirstOpen) {
        this.initUploader();
        this.isFirstOpen = false;
      }
    },
    initUploader: function initUploader() {
      var me = this;
      var cfg = {
        buttonId: me.mwRef('uploader').$el,
        maxSize: 500,
        action: me.importAction,
        accept: "xls" };

      var fn = {
        fileUploaded: function fileUploaded(up, file, resp) {
          me.importSuccessCallback(resp, file, up);
        } };

      PF.initPupload(cfg, fn);
    },
    changed: function changed(data) {
      var me = this;
      if (!data.id) {
        return;
      }
      var params = { type: 'address_book' };
      var unitText = "";
      if (data.code) {
        params.unitId = data.unitId;
        unitText = data.unitName;
        params.code = data.code;
        me.selCode = data.code;
      } else {
        params.unitId = data.id;
        unitText = data.text;
      }
      me.selUnitId = params.unitId;
      me.selUnitName = unitText;
      me.curSelParams = params;
      $.post("/api/org/listGroupDataByType", params, function (res) {
        me.mwRef('aa').refreshTableDataList(res.result);
      });
    },
    showHelp: function showHelp() {
      PF.showHelp({ url: '/helpDoc/platform/groupManager.md' });
    },
    refreshGridData: function refreshGridData() {
      var me = this;
      $.post("/api/org/listGroupDataByType", me.curSelParams, function (res) {
        var records = me.mwRef('aa').getMultipleSelection();
        me.mwRef('aa').refreshTableDataList(res.result, function () {
          if (records && records.length > 0 && res.result && res.result.length > 0) {
            var row = records[0];
            _.each(res.result, function (v) {if (v.id == row.id) row = v;});
            me.mwRef('aa').clearSelection();
            me.mwRef('aa').toggleRowSelection(row, true);
          }
        });
      });
    },
    addTitle: function addTitle() {
      this.resetFields();
      this.form.unitId = this.selUnitId;
      this.form.unitName = this.selUnitName;
      this.form.code = this.selCode;
      this.showDialog('titleDialog');

    },
    openForm: function openForm(data) {
      var fd = {};
      fd = _.assign(fd, data);
      this.form = fd;
      this.showDialog('titleDialog');
    },
    showUnitDialog: function showUnitDialog() {
      var me = this;
      me.selectUnitId = me.form.unitId;
      me.isExportGroup = false;
      this.showDialog('unitDialog');








    },
    isSysAdmin: function isSysAdmin() {
      if (this.userInfo.roleNames && this.userInfo.roleNames.indexOf("系统管理员") != -1) {
        return true;
      }
      return false;
    },

    selectUnitSure: function selectUnitSure() {
      var me = this;
      var tree = void 0;
      if (this.isExportGroup)
      tree = this.mwRef('unitTree1');else

      tree = this.mwRef('unitTree');
      var data = tree.getSelected();
      if (!data) {
        this.mwMsg('warning', '请选择单位');
      } else {
        if (this.isExportGroup) {
          var ids = data.map(function (v) {return v.id;});
          me.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportGroupToExcel"), { unitId: ids.join(",") }, false, "");
          this.closeDialog('unitDialog1');
        } else {
          me.form.unitId = data.id;
          me.form.unitName = data.text;
          this.selectUnitCancel();
        }
      }
    },
    deleteGroup: function deleteGroup(data) {
      var me = this;
      if (!data || data.length === 0) {
        this.mwMsg('warning', '请选择数据');
        return;
      }
      var ids = [];
      $.each(data, function (i, d) {
        ids.push(d.id);
      });
      me.mwConfirm('您确定要删除此群组?').then(function () {
        PF.ajax("api/org/deleteAddressBookGroup", ids).then(function (res) {
          if (res.result > 0) {
            me.mwMsg("删除成功");
            me.refreshData();
          }
        });
      });
    },
    selectUnitCancel: function selectUnitCancel() {
      this.closeDialog('unitDialog');
    },
    selectUnitCancel1: function selectUnitCancel1() {
      this.closeDialog('unitDialog1');
    },
    closeTitleDialog: function closeTitleDialog() {
      this.resetFields();
      this.closeDialog('titleDialog');
    },
    processSelData: function processSelData(loadUserObj) {
      if (loadUserObj) {
        if (loadUserObj.deptUsers) {
          loadUserObj.deptUsers.splice(0, loadUserObj.deptUsers.length);
        } else {
          loadUserObj.deptUsers = [];
        }
        if (loadUserObj.dept) {
          loadUserObj.dept.splice(0, loadUserObj.dept.length);
        } else {
          loadUserObj.dept = [];
        }
      }
      if (this.form.userids) {
        var names = this.form.users.split(',');
        var ids = this.form.userids.split(',');
        for (var i = 0; i < names.length; i++) {
          if (loadUserObj) {
            loadUserObj.deptUsers.push({ id: ids[i], name: names[i] });
          } else {
            this.checkNodes.deptUsers.push({ id: ids[i], name: names[i] });
          }
        }
      } else {
        this.checkNodes.deptUsers = [];
      }
      if (this.form.departmentids) {
        var _names = this.form.departments.split(',');
        var _ids = this.form.departmentids.split(',');
        for (var _i = 0; _i < _names.length; _i++) {
          if (loadUserObj) {
            loadUserObj.dept.push({ id: _ids[_i], name: _names[_i] });
          } else {
            this.checkNodes.dept.push({ id: _ids[_i], name: _names[_i] });
          }
        }
      } else {
        this.checkNodes.dept = [];
      }
    },
    usersLoad: function usersLoad() {
      var me = this;
      if (!this.form.unitId) {
        this.mwMsg('warning', '请选择单位');
        return;
      }
      var isShowed = this.formSelUnitId;
      this.formSelUnitId = this.form.unitId;
      this.mwRef('loadUsers').show();
      if (isShowed) {
        me.mwRef("loadUsers").mwRef("deptTreeData2").unCheckAll(true);
        setTimeout(function () {
          var loadUserObj = me.mwRef('loadUsers');
          if (loadUserObj.users) {
            loadUserObj.users.splice(0, loadUserObj.users.length);
          }
          me.processSelData(loadUserObj);
          loadUserObj.defaultParams.rootId = me.formSelUnitId;
          loadUserObj.mwRef("deptTreeData2").refresh();
        }, 50);
      }
      this.processSelData();
    },
    refreshData: function refreshData(noRefreshTree) {

      if (!noRefreshTree) {

        this.mwRef('groupTree').refresh();
      }
      this.refreshGridData();
    },
    showOuterDept: function showOuterDept() {
      this.showDialog('externalDept');
    },
    saveTitle: function saveTitle() {var _this = this;
      var me = this;
      me.mwRef('ruleForm').validate(function (valid) {
        if (valid) {
          $.post("/api/org/saveAddressBookGroup", _this.form).then(function (data) {
            me.mwRef('titleDialog').hide();
            me.refreshData();
            me.resetFields();
          });
        }
      });
    },
    handleSortCommand: function handleSortCommand(command) {
      var me = this;
      var multipleSelection = this.mwRef('aa').getMultipleSelection();
      me.doSortSN(command, multipleSelection);
    },
    processSelRowData: function processSelRowData() {
      var me = this;
      this.mwRef('aa').$on("dataLoaded", function (datas) {
        var records = me.mwRef('aa').getMultipleSelection();
        if (records && records.length > 0) {
          var row = records[0];
          _.each(datas, function (v) {if (v.id == row.id || v.userId == row.userId) row = v;});
          me.mwRef('aa').clearSelection();
          me.mwRef('aa').toggleRowSelection(row, true);
        }
      });
    },
    sort: function sort() {
      this.doSortSN("sort");
    },
    up: function up(data) {
      this.doSortSN("up", data);
    },
    down: function down(data) {
      this.doSortSN("down", data);
    },
    top: function top(data) {
      this.doSortSN("top", data);
    },
    bottom: function bottom(data) {
      this.doSortSN("bottom", data);
    },
    doSortSN: function doSortSN(flag, data) {
      var me = this;
      var params = me.curSelParams;
      params.flag = flag;
      if (flag != "sort") {
        if (!data || data.length != 1) {
          this.mwMsg('warning', $lang('请选择一条数据'));
          return;
        }
        params.id = data[0].id;
      }
      PF.ajax("api/org/updateGroupSN", params).then(function (res) {
        if (res.result) {
          me.refreshData(true);
        }
      });
    },
    showDialog: function showDialog(a) {
      this.mwRef(a).show();
    },
    closeDialog: function closeDialog(a) {
      this.mwRef(a).hide();
    },
    closeGroupDialog: function closeGroupDialog() {
      this.closeDialog("dialog");
    },
    groupSure: function groupSure(data) {
      this.form.code = this.check;
      this.closeGroupDialog();
    },

    getDeptUser: function getDeptUser() {
      var dept = this.mwRef('loadUsers').getValue().dept;
      var users = this.mwRef('loadUsers').getValue().users;
      var userids = [],user = [],departmentids = [],departments = [];
      users.forEach(function (item) {
        userids.push(item.id);
        user.push(item.name);
      });
      dept.forEach(function (item) {
        departmentids.push(item.id);
        departments.push(item.name);
      });
      this.form.userids = userids.join();
      this.form.users = user.join();
      this.form.departmentids = departmentids.join();
      this.form.departments = departments.join();
    },
    resetFields: function resetFields() {
      var me = this;
      me.form.id = "";
      me.form.unitName = "";
      me.form.unitId = "";
      me.form.code = "";
      me.form.name = "";
      me.form.sn = "";
      me.form.departmentids = "";
      me.form.departments = "";
      me.form.users = "";
      me.form.userids = "";
      me.form.externalUnit = "";




    },
    refresh: function refresh() {
      this.resetFields();
      this.mwRef('groupTree').refresh();
    },
    expand: function expand() {
      this.expandFlag = 2;
      this.mwRef('groupTree').openAll();
    },
    closed: function closed() {
      this.expandFlag = 1;
      this.mwRef('groupTree').closeAll();
    },
    externalSure: function externalSure() {
      var outerDept = this.outerDept.split("\n");
      this.form.externalUnit = outerDept.join();





      this.mwRef('externalDept').hide();
    },
    changeOrg: function changeOrg(type) {
      if (type && type == "1") {
        this.showAllOrg = true;
        this.showCurOrg = false;
        if (this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0) {
          this.defaultTreeParams.unitId = this.$store.getters.curUnit[0].id;
          this.mwRef('groupTree').refresh();
        }
      } else {
        this.showAllOrg = false;
        this.showCurOrg = true;
        this.defaultTreeParams.unitId = "";
        this.mwRef('groupTree').refresh();
      }
    },
    handleMoreCommand: function handleMoreCommand(command) {
      var me = this;
      if (command === 'import') {
        this.mwRef('impDialog').show();
      }
      if (command === 'export') {









        this.isExportGroup = true;
        this.showDialog('unitDialog1');









      }
    },
    impCancel: function impCancel() {
      this.mwRef('impDialog').hide();
    },
    importSuccessCallback: function importSuccessCallback(response, file) {
      if (response.result) {
        this.mwRef('groupTree').refresh();
        PF.show('message', { html: response.result.errMsg });
        this.mwRef('impDialog').hide();
      }
      this.mwRef("importData").clearFiles();
    },
    downloadExcel: function downloadExcel() {
      var me = this;
      me.mwUtil.downloadAttachment("/template_file/importGroupExcel.xls");
    } } };

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);


















































































































































var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  components: {},


  data: function data() {
    return {
      activeName: 'first',
      companyTreeUrl: this.mwUrl('/api/org/listDepartment'),
      deptTreeUrl: this.mwUrl('/api/org/getDepartmentTree'),
      defaultParams: {},
      dialogHeight: 200,
      searchField: "",
      btns: [{
        label: '取消', func: this.cancelChoose, type: 'default' },
      {
        label: '确定', func: this.chooseUsersSure }],


      multipleSelection: [],
      dept: [],
      users: [],
      members: [],
      deptUsers: [],
      selectId: '',
      selectId2: '' };

  },
  props: {
    checkNodes: {
      type: Object },

    showBDW: {
      type: Boolean,
      default: true },

    showQJT: {
      type: Boolean,
      default: true },

    unitId: {
      type: String,
      default: "" } },


  mounted: function mounted() {
    var me = this;
    if (!this.showQJT) {
      this.activeName = "second";
    }
    this.deptUsers = this.checkNodes.deptUsers;
    this.dept = this.checkNodes.dept;
    if (this.unitId) {
      this.defaultParams.rootId = this.unitId;
    } else {

      if (this.expUser && this.expUser.dep) {
        if (this.expUser.dep.loginUnit) {
          this.defaultParams.rootId = this.expUser.dep.loginUnit.id;
        } else {
          this.defaultParams.rootId = this.expUser.dep.loginRootDept.id;
        }
      }
    }
    this.defaultParams.listAble = !this.userInfo.developer;
    me.$nextTick(function () {
      var h = $(document.body).height();
      me.dialogHeight = (h - h * 0.02 - 260) / 2;
    });
    MW.test(function () {
      if (me.mwRef("deptTreeData"))
      return true;
      return false;
    }, function () {
      me.mwRef("deptTreeData").$on("dblClick", function (a, b) {
        var selected = [];
        selected.push(a);
        me.processSelDeptData(selected);
      });
    }, 50);
    MW.test(function () {
      if (me.mwRef("deptTreeData2"))
      return true;
      return false;
    }, function () {
      me.mwRef("deptTreeData2").$on("dblClick", function (a, b) {
        var selected = [];
        selected.push(a);
        me.processSelDeptData(selected);
      });
    }, 50);
  },
  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'expUser',
  'userInfo'])),


  watch: {},


  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    searchUser: function searchUser() {var _this = this;
      if (!this.searchField) {
        this.mwMsg('info', '请输入搜索内容');
        return;
      }
      var params = { qcon: this.searchField, start: 0, limit: 500 };
      this.mwApi.org.listDepartmentUserPaging(params).then(function (res) {
        _this.users = res.result;
      });
    },
    loadTableTree: function loadTableTree(data) {var _this2 = this;
      var params = { departmentId: data.id };
      this.selectId = data.id;
      this.mwApi.org.listUser(params).then(function (res) {
        _this2.users = res.result;
      });
    },

    loadTableTree2: function loadTableTree2(data) {var _this3 = this;
      var params = { departmentId: data.id };
      this.selectId2 = data.id;
      this.mwApi.org.listUser(params).then(function (res) {
        _this3.users = res.result;
      });
    },

    indexMethod: function indexMethod(index) {
      return index + 1;
    },

    cancelChoose: function cancelChoose() {
      this.mwRef('userDialog').hide();
    },

    chooseUsersSure: function chooseUsersSure() {
      this.mwRef('userDialog').hide();
      this.$emit('closeDialog');
    },

    reset: function reset() {
      this.dept = [];
      this.deptUsers = [];
    },
    getValue: function getValue() {
      return { dept: this.dept, users: this.deptUsers };
    },
    rowClick: function rowClick(row, selected) {
      this.mwRef('multiple1').toggleRowSelection(row, selected);
    },

    move: function move() {
      if (this.activeName == 'first') {
        var selected = this.mwRef('deptTreeData').getSelected();
        if (selected.length > 0) {
          this.processSelDeptData(selected);
        }
        if (this.multipleSelection.length > 0) {
          this.processSelUserData();
        }

      } else {
        var _selected = this.mwRef('deptTreeData2').getSelected();
        if (_selected.length > 0) {
          this.processSelDeptData(_selected);
        }
        if (this.multipleSelection.length > 0) {
          this.processSelUserData();
        }
      }
    },
    processSelDeptData: function processSelDeptData(selected) {var _this4 = this;
      if (this.dept.length > 0) {
        selected.forEach(function (s) {
          _this4.dept.push(s);
        });
        this.dept.forEach(function (t, i) {
          _this4.dept.forEach(function (d, index) {
            if (t.id === d.id && i != index) {
              _this4.dept.splice(index, 1);
              return;
            }
          });
        });
      } else
      {
        this.dept = selected;
      }
    },
    processSelUserData: function processSelUserData() {
      var me = this;
      var users = this.multipleSelection;
      if (users) {
        $.each(users, function (i, u) {
          if (!me._hasSelUsers(u.id)) {
            me.deptUsers.push(u);
          }
        });
      }
    },
    _hasSelUsers: function _hasSelUsers(userId) {
      var ret = false;
      $.each(this.deptUsers, function (i, u) {
        if (u.id == userId) {
          ret = true;
          return;
        }
      });
      return ret;
    },
    dbAddUser: function dbAddUser(row) {
      this.processSelUserData(row);
    },
    dbHandleDept: function dbHandleDept(row) {

      this.delData(this.dept, row);
    },

    dbHandleUser: function dbHandleUser(row) {
      this.delData(this.deptUsers, row);
    },
    delData: function delData(datas, row) {
      $.each(datas, function (i, d) {
        if (d.id == row.id) {
          datas.splice(i, 1);
          return;
        }
      });
    },
    selectAll: function selectAll() {var _this5 = this;
      this.users.forEach(function (item) {
        _this5.rowClick(item, true);
      });
    },
    unSelect: function unSelect() {var _this6 = this;
      this.users.forEach(function (item) {
        _this6.rowClick(item, false);
      });
    },
    handleTabs: function handleTabs(data) {
      if (data.label === '全集团') {
        if (this.selectId) {
          this.loadTableTree({ id: this.selectId });} else
        {
          this.users = [];
        }
      } else {
        if (this.selectId2) {
          this.loadTableTree2({ id: this.selectId2 });
        } else {
          this.users = [];
        }
      }
    },
    show: function show() {
      this.mwRef('userDialog').show();
    } } };

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);











































































































var _loadUsers = __webpack_require__(140);var _loadUsers2 = _interopRequireDefault(_loadUsers);
var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  components: {
    loadUsers: _loadUsers2.default },

  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'userInfo',
  'expUser'])),


  data: function data() {
    var me = this;

    return {
      isLimit: false,
      layout: [],
      expandFlag: 1,
      selectUnitId: '',
      toolbarPosition: window.$Env && $Env.toolbarPosition || 'TOP',
      showOrg: true,
      showCurOrg: false,
      showAllOrg: false,
      form: {
        id: '',
        code: '外单位',
        name: '',
        Englishname: '',
        sn: 1,
        unitName: '',
        unitId: '',
        create_user: '',
        identifier: "" },

      outerOrgTreeUrl: this.mwUrl('/api/org/getGroupTreeByType'),
      defaultTreeParams: { type: 'common_outerOrg' },
      curSelParams: { type: 'common_outerOrg' },
      selCode: '',
      selUnitId: '',
      selUnitName: '',
      formRules: {
        unitName: [
        { required: true, message: $lang("请选择所属单位"), trigger: 'change' }],

        name: [
        { required: true, message: $lang("请输入外单位名称"), trigger: 'blur' }] },


      defaultParams: {
        type: 'common_outerOrg' },

      defaultUnitTreParams: { deep: true, isContainSelf: false, parentId: "" },
      unitTreeUrl: this.mwUrl('/api/org/getUnitTreeContainSelf'),
      unitFooterButton: [
      { label: '取消', func: me.selectUnitCancel, type: "default" },
      { label: '确定', func: me.selectUnitSure }] };


  },
  mounted: function mounted() {
    var me = this;
    var isSysAdmin = this.isSysAdmin();
    var sysAdminShowAllUnit = true;
    if (window.$Env && window.$Env.dataManagementByUnit) {
      sysAdminShowAllUnit = false;
    }
    if ((this.userInfo.developer || isSysAdmin) && sysAdminShowAllUnit) {
      this.showCurOrg = true;
    }
    if (!this.userInfo.developer) {
      if (this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0) {
        me.defaultParams.unitId = this.$store.getters.curUnit[0].id;
        me.curSelParams.unitId = me.defaultParams.unitId;
        if (!isSysAdmin || !sysAdminShowAllUnit) {
          me.defaultTreeParams.unitId = me.defaultParams.unitId;
          me.defaultUnitTreParams.parentId = PF.userInfo.initunitid;
        }

      }
    } else {
      this.defaultParams.unitId = this.userInfo.owner;
    }
    if (window.$Env && window.$Env.showOuterOrg) {
      me.defaultParams.unitId = null;
      me.defaultTreeParams.unitId = "";
      me.showOrg = false;
    }
    var p = me.$parent.params;
    var buttonspan = 16,searchspan = 6,searchOffset = 2;
    if (p && p.selDialog) {
      buttonspan = 13, searchspan = 10, searchOffset = 1;
    }
    me.layout = [
    [{
      span: 0,
      type: 'menu',
      label: $lang('公共外单位管理'),
      api: 'org.listGroupDataByType',
      defaultParams: me.defaultParams,
      columns: [
      { type: 'selection' }, { prop: 'sn', width: '55', label: $lang('序号') },
      { prop: 'name', label: $lang('外单位名称'), slot: { type: "href", func: me.openForm } },
      { prop: 'Englishname', label: $lang('外单位英文名称'), width: '220', tooltip: true },
      { prop: 'identifier', label: $lang('外单位编号'), width: '105', tooltip: true },
      { prop: 'create_user', label: $lang('创建者'), width: '100', tooltip: true }] },

    {
      span: buttonspan,
      type: 'button',
      items: [{
        label: $lang('添加'),
        func: me.addTitle },
      {
        label: $lang('删除'),
        func: me.deleteGroup,
        icon: "el-icon-delete" }],
      suffixSlot: "dropDown" },
    {
      span: searchspan,
      type: 'searchText',
      name: 'name',
      tip: $lang('外单位名称'),
      offset: searchOffset,
      func: me.search }]];



    this.mwRef('groupTree').renderTree();
  },
  methods: {
    changed: function changed(data) {
      var me = this;
      if (!data.id) {
        return;
      }
      var unitText = "";
      if (data.code) {
        me.defaultParams.unitId = data.unitId;
        unitText = data.unitName;
        me.defaultParams.code = data.code;
        me.selCode = data.code;
      } else {
        delete me.defaultParams.code;
        me.selCode = "";
        me.defaultParams.unitId = data.id;
        unitText = data.text;
      }
      me.selUnitId = me.defaultParams.unitId;
      me.selUnitName = unitText;
      me.reloadData();
    },
    reloadData: function reloadData() {
      var me = this;
      var tableObj = me.mwRef('aa');
      if (!tableObj || !tableObj.refreshTableDataList) return;
      $.post("/api/org/listGroupDataByType", me.defaultParams, function (res) {
        tableObj.refreshTableDataList(res.result);
      });
    },
    expand: function expand() {
      this.expandFlag = 2;
      this.mwRef('groupTree').openAll();
    },
    closed: function closed() {
      this.expandFlag = 1;
      this.mwRef('groupTree').closeAll();
    },
    changeOrg: function changeOrg(type) {
      if (type && type == "1") {
        this.showAllOrg = true;
        this.showCurOrg = false;
        if (this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0) {
          this.defaultTreeParams.unitId = this.$store.getters.curUnit[0].id;
          this.mwRef('groupTree').refresh();
        }
      } else {
        this.showAllOrg = false;
        this.showCurOrg = true;
        this.defaultTreeParams.unitId = "";
        this.mwRef('groupTree').refresh();
      }
    },
    addTitle: function addTitle() {
      this.resetFields();
      if (this.userInfo.developer) {
        this.form.unitId = this.userInfo.owner;
        this.form.unitName = "美络科技";
      } else {
        this.form.unitId = this.selUnitId || this.$store.getters.curUnit[0].id;
        this.form.unitName = this.selUnitName || this.$store.getters.curUnit[0].name;
      }
      this.form.create_user = this.userInfo.name;
      this.form.code = $lang(this.selCode || "外单位");
      this.showDialog('titleDialog');
    },
    openForm: function openForm(data) {
      var fd = {};
      fd = _.assign(fd, data);
      this.form = fd;
      this.showDialog('titleDialog');
    },
    isSysAdmin: function isSysAdmin() {
      if (PF.userInfo.allIdentityRoleNames && PF.userInfo.allIdentityRoleNames.indexOf("系统管理员") != -1) {
        return true;
      }
      return false;
    },
    deleteGroup: function deleteGroup(data) {
      var me = this;
      if (!data || data.length === 0) {
        this.mwMsg('warning', '请选择数据');
        return;
      }
      var ids = [];
      $.each(data, function (i, d) {
        ids.push(d.id);
      });
      me.mwConfirm('您确定要删除此外部单位吗?').then(function () {
        PF.ajax("api/org/deleteAddressBookGroup", ids).then(function (res) {
          if (res.result > 0) {
            me.mwMsg("删除成功");
            me.refreshData();
          }
        });
      });
    },
    closeTitleDialog: function closeTitleDialog() {
      this.resetFields();
      this.closeDialog('titleDialog');
    },

    refreshData: function refreshData(noRefreshTree) {
      if (!noRefreshTree) {

        this.mwRef('groupTree').refresh();
      } else {
        this.reloadData();
      }
    },
    saveTitle: function saveTitle() {var _this = this;
      var me = this;
      me.mwRef('ruleForm').validate(function (valid) {
        if (valid) {
          me.form.type = "common_outerOrg";
          $.post("/api/org/saveOuterOrg", _this.form).then(function (data) {
            me.mwRef('titleDialog').hide();
            me.refreshData();
            me.resetFields();
          });
        }
      });
    },
    handleSortCommand: function handleSortCommand(command) {
      var me = this;
      var multipleSelection = this.mwRef('aa').getMultipleSelection();
      me.doSortSN(command, multipleSelection);
    },
    sort: function sort() {
      this.doSortSN("sort");
    },
    up: function up(data) {
      this.doSortSN("up", data);
    },
    down: function down(data) {
      this.doSortSN("down", data);
    },
    top: function top(data) {
      this.doSortSN("top", data);
    },
    bottom: function bottom(data) {
      this.doSortSN("bottom", data);
    },
    doSortSN: function doSortSN(flag, data) {
      var me = this;
      var params = _.assign({}, me.defaultParams);
      params.flag = flag;
      if (flag != "sort") {
        if (!data || data.length != 1) {
          this.mwMsg('warning', $lang('请选择一条数据'));
          return;
        }
        params.id = data[0].id;
      }
      PF.ajax("api/org/updateGroupSN", params).then(function (res) {
        if (res.result) {
          me.reloadData();
        }
      });
    },
    selectUnitCancel: function selectUnitCancel() {
      this.closeDialog('unitDialog');
    },
    showUnitDialog: function showUnitDialog() {
      var me = this;
      me.selectUnitId = me.form.unitId;
      me.isExportGroup = false;
      this.showDialog('unitDialog');
    },

    selectUnitSure: function selectUnitSure() {
      var me = this;
      var tree = this.mwRef('unitTree');
      var data = tree.getSelected();
      if (!data) {
        this.mwMsg('warning', '请选择单位');
      } else {
        me.form.unitId = data.id;
        me.form.unitName = data.text;
        this.selectUnitCancel();
      }
    },
    showDialog: function showDialog(a) {
      this.mwRef(a).show();
    },
    closeDialog: function closeDialog(a) {
      this.mwRef(a).hide();
    },
    closeGroupDialog: function closeGroupDialog() {
      this.closeDialog("dialog");
    },
    resetFields: function resetFields() {
      var me = this;
      me.form.id = "";
      me.form.unitName = "";
      me.form.unitId = "";
      me.form.code = "";
      me.form.name = "";
      me.form.sn = "";
      me.form.create_user = "";
      me.form.identifier = "";
    } } };

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _stringify = __webpack_require__(24);var _stringify2 = _interopRequireDefault(_stringify);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
























































































































































































































var _token = __webpack_require__(25);var _token2 = _interopRequireDefault(_token);
var _firstDept = __webpack_require__(413);var _firstDept2 = _interopRequireDefault(_firstDept);
var _dataValues = __webpack_require__(1218);var _dataValues2 = _interopRequireDefault(_dataValues);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  components: {
    first: _firstDept2.default,
    dValues: _dataValues2.default },

  props: {
    params: {
      type: Object },




    shouldApplicationIdInRequest: {
      type: Boolean } },



  data: function data() {
    var me = this;
    var appId = this.$route.params.appId;
    if (this.$route.params.itemId) {
      appId = '';
    }
    var treeDefaultParams = void 0;
    if (this.shouldApplicationIdInRequest) {
      treeDefaultParams = {
        applicationId: appId };

    } else {
      treeDefaultParams = {};
    }
    return {
      layout: [],
      headers: {},
      appId: appId,
      dictTreeUrl: this.mwUrl("/api/data/listDictTree"),
      action: this.mwUrl("/api/sys/importDict" + (this.shouldApplicationIdInRequest ? "?applicationId=" + appId : '')),
      selectNode: "",
      catalog: "",
      addCode: true,
      more: false,
      moreSys: false,
      form: {
        catalog: "",
        name: "",
        active: "T",
        personal: "F",
        atrrs: "S",
        types: "0",
        typeedit: 2,
        values: "",
        applicationId: '',
        codeContent: '',
        remark: "",
        unitName: "",
        unitId: "",
        code: '' },

      keyValues: {},



      formRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        value: [{ required: true, message: "请输入或选择值", trigger: "blur" }] },


      setButton: [
      {
        label: "确定",
        func: this.chooseSure },

      {
        label: "取消",
        type: "default",
        func: this.cancel }],



      editListButton: [
      {
        label: "确定",
        func: this.editListSure },

      {
        label: "取消",
        type: "default",
        func: this.cancelEditList }],



      leadButton: [
      {
        label: "取消",
        type: "default",
        func: this.closeLeadDialog },

      {
        label: "确定",
        func: this.leadSure }],




      advises: [],

      kinds: [],
      settingValues: [],

      tableData: [],
      treeData: [],
      selectCodeNode: '',



      app: "",

      treeDefaultParams: treeDefaultParams };

  },

  mounted: function mounted() {
    var me = this;
    me.headers.Authorization = _token2.default.getToken();
    me.layout = [
    [
    {
      span: 0,
      type: "menu",
      label: "数据字典",
      api: "data.listDict",
      defaultParams: { applicationId: this.appId },

      columns: [
      { type: "selection" },
      { type: "index" },
      { prop: "active",
        label: "有效",
        width: 60,
        formatter: me.activeFormatter },
      { slot: { type: 'href', func: me.edit }, prop: "name", label: "数据名称", tooltip: true },
      { prop: "code", label: "编码", tooltip: true },
      { prop: "values", label: "选项值", tooltip: true },
      { prop: "codeContent", label: "设置选项值", tooltip: true, formatter: me.codeFormatter },
      {
        prop: "personal",
        label: "所属",
        formatter: me.belongsFormatter,
        tooltip: true },

      { prop: "remark", label: "备注", tooltip: true }] },


    {
      span: 11,
      type: "button",
      items: [
      {
        label: "新建",
        icon: "fa fa-plus-square",
        func: me.addTitle },






      {
        label: "删除",
        icon: "fa fa-trash-o fa-fw",
        func: me.deleteDict },

      {
        label: "复制",
        icon: "fa fa-paste",
        func: me.copy },

      {
        label: "批量修改分类",
        icon: "fa fa-pencil fa-fw",
        func: me.editCatalogList }],

      suffixSlot: "more" },






    {
      span: 6,
      type: "searchText",
      name: "name",
      offset: 7 }]];



  },

  methods: {

    importSuccessFunc: function importSuccessFunc(response, file, fileList) {
      if (response && response.success) {
        this.mwMsg("导入成功");
        this.closeLeadDialog();
        this.mwRef("dictTree").refresh();
      } else {
        this.mwMsg('warning', response && response.msg || '导入失败');
      }
    },

    handleCommand: function handleCommand(command) {
      if (command === 'leadOut') {
        this.leadOut();
      }
      if (command === 'lead') {
        this.lead();
      }
      if (command === 'leadOldData') {
        this.leadOldData();
      }
      if (command === 'loadModules') {
        this.loadModules();
      }
      if (command === 'loadUpdateData') {
        this.loadUpdateData();
      }

    },



    lead: function lead() {
      this.showDialog("leadDialog");
    },
    closeLeadDialog: function closeLeadDialog() {
      this.mwRef("leadDialog").hide();
    },
    leadSure: function leadSure() {
      this.mwRef("importDict").submit();
    },


    leadOut: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var data, params, response;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                data = this.mwRef('dataTable').getMultipleSelection();
                params = '';if (!(
                data && data.length > 0)) {_context.next = 6;break;}
                params = { ids: data.map(function (x) {return x.id;}) };_context.next = 14;break;case 6:if (!
                this.selectNode) {_context.next = 13;break;}_context.next = 9;return (
                  this.mwConfirm("您未选择需要导出的数据，是否需要导出当前选中分类'" + this.selectNode + "'下所有的数据？"));case 9:if (!_context.sent) {_context.next = 11;break;}
                params = { categories: [this.selectNode] };case 11:_context.next = 14;break;case 13:


                this.mwMsg("info", "请选中导出的数据");case 14:if (!

                params) {_context.next = 19;break;}_context.next = 17;return (
                  this.mwUtil.downloadAttachment2({
                    url: '/api/sys/exportDict',
                    params: {
                      jsonData: (0, _stringify2.default)(params),
                      applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined } }));case 17:response = _context.sent;


                if (response.success) {
                  this.mwMsg('导出成功');
                } else if (response.msg) {
                  this.mwMsg('waring', response.msg);
                }case 19:case "end":return _context.stop();}}}, _callee, this);}));function leadOut() {return _ref.apply(this, arguments);}return leadOut;}(),



    exportAll: function () {var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {var response;return _regenerator2.default.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (
                  this.mwUtil.downloadAttachment2({
                    url: '/api/sys/exportDict',
                    params: {
                      jsonData: '',
                      applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined } }));case 2:response = _context2.sent;


                if (response.success) {
                  this.mwMsg('导出成功');
                } else if (response.msg) {
                  this.mwMsg('waring', response.msg);
                }case 4:case "end":return _context2.stop();}}}, _callee2, this);}));function exportAll() {return _ref2.apply(this, arguments);}return exportAll;}(),



    leadOldData: function leadOldData() {},

    loadModules: function loadModules() {},

    loadUpdateData: function loadUpdateData() {},

    deptChoose: function deptChoose(data) {

      var unit = [];
      var unitIds = [];
      data.forEach(function (d) {
        unit.push(d.name);
        unitIds.push(d.id);
      });

      this.form.unitName = unit.join();
      this.form.unitId = unitIds.join();
    },

    showDataAddress: function showDataAddress() {
      this.moreSys = !this.moreSys;
    },

    addTitle: function addTitle() {
      this.mwRef("titleTree").show();
      this.addCode = true;
      this.form = {
        catalog: this.selectNode,
        name: "",
        active: "T",
        personal: "F",
        applicationId: '',
        atrrs: "S",
        types: "0",
        typeedit: 2,
        values: "",
        codeContent: '',
        remark: "",
        unitName: "",
        unitId: "",
        code: '' };

    },

    saveDict: function saveDict() {var _this = this;

      if (this.form.personal === "F") {
        this.clearDept();
      }
      if (this.form.types != "0") {
        this.form.value = this.form.codeContent;
        delete this.form.values;
      } else {
        delete this.form.codeContent;
        this.form.values = this.form.value;
      }
      this.mwRef("dataForm").validate(function (valid) {
        if (valid) {
          delete _this.form.value;
          if (_this.form.types != "0") {
            _this.form.values = '';
          } else {
            _this.form.codeContent = '';
          };
          if (_this.shouldApplicationIdInRequest && !_this.form.applicationId) {
            _this.form.applicationId = _this.$route.params.appId;
          }
          var me = _this;

          _this.mwApi.data.saveDict(_this.form).then(function (res) {
            if (res.success) {
              _this.mwMsg("info", "保存成功");
              _this.mwRef("titleTree").hide();
              _this.refreshTable();
              _this.handleClose();
            }
          });
        } else {
          _this.mwMsg("信息未填写完整");
        }
      });
    },

    loadTableTree: function loadTableTree(data) {
      this.selectNode = data.catalog || data.text;
      this.mwRef("dataTable").refreshTableDefaultParams({
        catalog: data.catalog || data.text,
        applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined });

    },

    deleteDict: function deleteDict(data) {var _this2 = this;
      if (data.length === 0) {
        this.mwMsg("info", "请选择你要删除的数据");
      } else {
        var ids = [];
        data.forEach(function (d) {
          ids.push(d.id);
        });
        this.mwApi.data.deleteDict(ids, { applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined }).then(function (res) {
          if (res.success) {
            _this2.mwMsg("删除成功");
            _this2.refresh();
          } else {
            _this2.mwMsg("info", "删除失败");
          }
        });
      }
    },

    edit: function edit(row, index) {var _this3 = this;
      this.mwApi.data.getDict(row.id, { applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined }).then(function (res) {
        if (res.success) {
          _this3.form = {
            catalog: _this3.selectNode,
            name: "",
            active: "T",
            personal: "F",
            applicationId: '',
            atrrs: "S",
            types: "0",
            typeedit: 2,
            values: "",
            codeContent: '',
            remark: "",
            unitName: "",
            unitId: "",
            code: '' };

          _this3.addCode = false;
          _this3.mwUtil.applyCover(_this3.form, res.result);
          _this3.form.id = res.result.id;
          if (_this3.form.types === "0") {
            _this3.form.value = res.result.values;
          }
          _this3.showDialog("titleTree");
        }
      });

    },

    copy: function copy(data) {var _this4 = this;
      if (data.length === 0) {
        this.mwMsg("info", "请选择你要复制的数据");
      } else {
        data.forEach(function (d) {
          delete d.id;
          d.name = d.name + "-副本";
          _this4.mwApi.data.saveDict(d).then(function (res) {
            if (res.success) {
              _this4.mwMsg("复制成功");
            }
          });
        });
        this.refreshTable();
      }
    },

    handleRadio: function handleRadio() {
      if (this.types != "0") {
        this.mwRef("dataForm").clearValidate();
      }
    },

    handleClose: function handleClose() {
      this.resetFields();
      this.form.name = "";
      this.form.values = "";
      this.form.value = "";

      this.form.codeContent = "";
      this.mwRef("titleTree").hide();
    },
    addSetting: function addSetting() {
      this.showDialog('setValuesDialog');
    },



    chooseSure: function chooseSure() {
      var data = this.mwRef('valueChoose').getValue();
      this.form.codeContent = (0, _stringify2.default)(data);
      this.mwRef("setValuesDialog").hide();
    },



    showDialog: function showDialog(a) {
      this.mwRef(a).show();
    },



    cancel: function cancel() {
      this.mwRef("setValuesDialog").hide();
    },


    editCatalogList: function editCatalogList(data) {
      if (data.length === 0) {
        this.mwMsg("info", "请选择你要操作的数据");
      } else {
        this.mwRef("editListDialog").show();
        this.tableData = data;
        this.catalog = this.selectNode;
      }
    },

    editListSure: function editListSure() {var _this5 = this;
      this.tableData.forEach(function (d) {
        d.catalog = _this5.catalog;
        _this5.mwApi.data.saveDict(d).then(function (res) {
          if (res.success) {
            _this5.mwMsg("修改成功");
            _this5.refresh();
            _this5.mwRef("editListDialog").hide();
          }
        });
      });
    },

    cancelEditList: function cancelEditList() {
      this.mwRef("editListDialog").hide();
    },

    getDept: function getDept() {
      this.$prompt("编号值", "请填写编号值", {
        confirmButtonText: "确定",
        cancelButtonText: "取消" }).

      then(function (_ref3) {var value = _ref3.value;}).
      catch(function () {});
    },

    closeDialog: function closeDialog() {
      this.mwRef("dialog").hide();
    },

    belongsFormatter: function belongsFormatter(data) {
      if (data.personal === "T") {
        return data.unitName;
      } else {
        return "公有";
      }
    },

    activeFormatter: function activeFormatter(data) {var h = this.$createElement;
      if (data.active === 'T') {
        return h("i", { "class": "fa fa-check-square", style: "color:#1ab394" });
      }
    },

    codeFormatter: function codeFormatter(data) {
      var res = [];
      if (data.types == '1' && data.codeContent && data.codeContent.length != 0) {
        var json = JSON.parse(data.codeContent);
        json.forEach(function (d) {
          if (d.data && d.data.length > 0) {
            d.data.forEach(function (t) {
              var a = d.name + '/' + t.name;
              res.push(a);
            });
          } else {
            var a = d.name + '/';
            res.push(a);
          }
        });
      }
      return res.join();
    },

    clearDept: function clearDept() {
      this.form.unit = "";
      this.form.unitName = "";
    },

    refreshTable: function refreshTable() {
      this.mwRef("dataTable").refreshTableDefaultParams({
        catalog: this.selectNode,
        applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined });

    },

    refresh: function refresh() {var _this6 = this;
      this.mwApi.data.listDict({ start: 0, limit: 1, catalog: this.selectNode, applicationId: this.shouldApplicationIdInRequest ? this.appId : undefined }).then(function (res) {
        if (res.success) {
          if (res.result && res.result.length === 1) {
            _this6.mwRef("dataTable").refreshTableDefaultParams({
              catalog: _this6.selectNode,
              applicationId: _this6.shouldApplicationIdInRequest ? _this6.appId : undefined });

          } else {
            _this6.mwRef("dictTree").refresh();
            _this6.mwRef("dataTable").refreshTableDefaultParams({
              catalog: _this6.selectNode,
              applicationId: _this6.shouldApplicationIdInRequest ? _this6.appId : undefined });

          }
        }
      });

    },

    resetFields: function resetFields() {
      this.mwRef("dataForm").resetFields();
    },
    expand: function expand() {
      this.mwRef("dictTree").openAll();
    },
    closed: function closed() {
      this.mwRef("dictTree").closeAll();
    } },

  watch: {} };

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =
























































{
  props: {
    dataId: {
      type: String,
      default: '' } },


  data: function data() {
    return {
      treeData: [],
      settingValues: [],
      menuItem: [{ name: 'add', label: '新增', func: this.addCatalog },
      {
        name: 'edit',
        label: '修改',
        func: this.editCatalog },

      {
        name: 'delete',
        label: '删除',
        func: this.deleteCatalog }],

      valueBtns: [
      {
        label: "取消",
        type: "default",
        func: this.closeValueDialog },

      {
        label: "确定", func: this.addValueSure }],


      types: { "#": {
          "icon": "fa fa-leaf" },

        "file": {
          "icon": "fa fa-leaf" },

        "default": {
          "icon": "fa fa-leaf" } },


      keyValues: {},



      editOrAdd: true,
      rowindex: 0 };


  },

  mounted: function mounted() {
    this.getTreeData();
  },

  methods: {
    queryTreeData: function queryTreeData(json, data) {var _this = this;
      json.forEach(function (d) {
        if (d.id == data.id) {
          if (d.data && d.data.length > 0) {
            _this.settingValues = d.data;} else {
            _this.settingValues = [];
          }
        } else {
          if (d.children && d.children.length > 0) {
            _this.queryTreeData(d.children, data);
          }
        }
      });
    },
    changed: function changed(data) {
      this.selectCodeNode = data.id;
      this.queryTreeData(this.treeData, data);
    },


    getTreeData: function getTreeData() {var _this2 = this;
      this.treeData = [];
      if (this.dataId) {
        this.mwApi.data.getDict(this.dataId).then(function (res) {
          if (res.result && res.result.codeContent) {
            _this2.treeData = JSON.parse(res.result.codeContent);
          } else {
            _this2.treeData = [];
          }
        });
      }
    },
    createRandomId: function createRandomId() {
      return (Math.random() * 10000000).toString(16).substr(0, 4) + '' + new Date().getTime() + '' + Math.random().toString().substr(2, 5);
    },
    newCatalog: function newCatalog() {var _this3 = this;
      this.$prompt("请输入新分类的名字", "添加分类", {
        confirmButtonText: "确定",
        cancelButtonText: "取消" }).

      then(function (_ref) {var value = _ref.value;
        _this3.mwRef('codeTree').createNode('#', { id: 'x-node' + _this3.createRandomId(),
          name: value,
          text: value,
          type: 'file' },
        'last');
        _this3.treeData = _this3.mwRef('codeTree').getTreeData();
      }).
      catch(function () {});
    },
    addCatalog: function addCatalog(data, parentId, item, obj) {var _this4 = this;
      var me = this;
      this.$prompt("请输入新分类的名字", "添加分类", {
        confirmButtonText: "确定",
        cancelButtonText: "取消" }).

      then(function (_ref2) {var value = _ref2.value;

        _this4.mwRef('codeTree').createNode(data, { id: 'x-node' + _this4.createRandomId(),
          name: value,
          text: value,
          type: 'file' },
        'last');
        _this4.mwRef('codeTree').refreshData(_this4.mwRef('codeTree').getTreeData());
      }).
      catch(function () {});

    },
    editCatalog: function editCatalog(data, parentId, obj) {
      this.mwRef('codeTree').editNodeName(data);
    },
    deleteCatalog: function deleteCatalog(data, parentId, obj) {
      this.mwRef('codeTree').deleteNode(data);
      this.treeData = this.mwRef('codeTree').getTreeData();
    },

    addValues: function addValues() {

      if (!this.mwRef('codeTree').getSelected()) {
        this.mwMsg('info', '请选择分类');
      } else {
        this.mwRef('valueKeyDialog').show();
        this.keyValues = {};this.editOrAdd = false;
      }


    },

    queryTData: function queryTData(json, data) {var _this5 = this;
      json.forEach(function (d) {
        if (d.id === data) {
          d.data = _this5.settingValues;
          return;
        } else {
          if (d.children && d.children.length > 0) {
            _this5.queryTData(d.children, data);
          }
        }
      });
      return json;
    },

    addValueSure: function addValueSure() {
      this.closeValueDialog();
      if (this.editOrAdd) {
        this.settingValues[this.rowindex].id = this.keyValues.id;
        this.settingValues[this.rowindex].name = this.keyValues.name;
      } else {
        this.settingValues.push(this.keyValues);
      }
      var treeData = this.mwRef('codeTree').getTreeData();
      this.treeData = this.queryTData(treeData, this.selectCodeNode);
    },
    closeValueDialog: function closeValueDialog() {
      this.mwRef('valueKeyDialog').hide();
    },
    handleDelete: function handleDelete(row, index) {
      this.treeData = this.mwRef('codeTree').getTreeData();
      this.settingValues.splice(index, 1);
      this.queryTData(this.treeData, this.selectCodeNode);
      this.mwRef('codeTree').refreshData(this.treeData);
    },
    editSetValue: function editSetValue(row, index) {
      this.mwRef('valueKeyDialog').show();
      this.keyValues = {};
      this.keyValues.id = row.id;
      this.keyValues.name = row.name;
      this.editOrAdd = true;
      this.rowindex = index;
    },

    getValue: function getValue() {
      var datas = this.mwRef('codeTree').getTreeData();
      function changeJson(dataJson) {
        dataJson.forEach(function (d) {

          for (var t in d) {
            if (t === 'id' || t === 'text' || t === 'data' || t === 'children') {
              if (t === 'text') {
                d.name = d.text;
                delete d.text;
              }
            } else {
              delete d[t];
            }
          }

          if (d.children && d.children.length > 0) {
            d.children = changeJson(d.children);
          }
        });
        return dataJson;
      }
      changeJson(datas);
      return datas;
    } },




  watch: {
    dataId: function dataId(val) {
      this.getTreeData();
    } } };

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _stringify = __webpack_require__(24);var _stringify2 = _interopRequireDefault(_stringify);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);



















































































































var _firstDept = __webpack_require__(480);var _firstDept2 = _interopRequireDefault(_firstDept);
var _dataValues = __webpack_require__(481);var _dataValues2 = _interopRequireDefault(_dataValues);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  components: {
    first: _firstDept2.default,
    dValues: _dataValues2.default,
    "file-input": {
      props: {
        readOnly: {
          type: Boolean,
          default: false },

        disabled: {
          type: Boolean,
          default: false },

        placeholder: {
          type: String,
          default: '' },

        value: {
          default: function _default() {return {};} },

        dictId: {
          type: String,
          default: '' } },


      template: "\n    <el-input :placeholder=\"placeholder\" :value=\"displayValue\" :readOnly=\"true\">\n      <template  v-if=\"uploadable || downloadable\">\n        <el-button slot=\"append\" v-if=\"uploadable\">\n          <label>\n            \u4E0A\u4F20\n            <input type=\"file\" style=\"display:none;\" @change=\"handleChange\" ref=\"input\"/>\n          </label>\n        </el-button>\n        <a style=\"display:block;height:100%;\" href=\"javascript:void(0);\" class=\"el-icon-download el-input__icon\" slot=\"suffix\" v-if=\"downloadable\" @click=\"handleDownload\">\n        </a>\n      </template>\n\n    </el-input>\n    ",














      computed: {
        displayValue: function displayValue() {
          return this.value && this.value.name || this.value || '';
        },
        downloadable: function downloadable() {
          return this.dictId;
        },
        uploadable: function uploadable() {
          return !this.readOnly && !this.disabled;
        } },

      methods: {
        handleChange: function handleChange(e) {
          var files = this.mwRef('input').files;
          if (files[0]) {
            this.$emit('input', files[0]);
          }
        },
        handleDownload: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(e) {var appId, response;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!
                    this.dictId) {_context.next = 6;break;}
                    appId = this.$route.params.appId;_context.next = 4;return (
                      this.mwUtil.downloadAttachment2({
                        url: '/api/data/getDictFile',
                        params: {
                          jsonData: (0, _stringify2.default)([this.dictId, appId]) } }));case 4:response = _context.sent;


                    if (response && response.msg) {
                      this.mwMsg('waring', response.msg);
                    }case 6:case "end":return _context.stop();}}}, _callee, this);}));function handleDownload(_x) {return _ref.apply(this, arguments);}return handleDownload;}() } } },





  props: {
    params: {
      type: Object } },


  watch: {
    params: {
      handler: function handler(newValue, oldValue) {
        debugger;
        if (newValue) {
          if (newValue.form) this.form = newValue.form;
        }
      },
      deep: true } },


  data: function data() {
    return {
      pagination: false,
      labelPosition: 'left',
      appId: this.getParams().appId,
      sysId: this.getParams().sysId,
      form: {
        catalog: "",
        name: "",
        active: "T",
        personal: "F",
        atrrs: "S",
        types: "0",
        typeedit: 2,
        values: "",
        value: "",
        applicationId: '',
        owner: '',
        codeContent: '',
        remark: "",
        unitName: "",
        unitId: "",
        code: '' },

      formRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        value: [{ required: true, message: "请输入或选择值", trigger: "blur" }] },

      setButton: [
      {
        label: "确定",
        func: this.chooseSure },

      {
        label: "取消",
        type: "default",
        func: this.cancel }],


      isEditName: false };

  },
  mounted: function mounted() {
    var me = this;

    debugger;
    me.isEditName = !me.params.isEditName ? false : true;
  },
  methods: {
    saveDict: function saveDict() {var _this = this;
      if (this.form.personal === "F") {
        this.clearDept();
      }
      if (this.form.types == "1") {
        this.$set(this.form, 'value', this.form.codeContent);
      }
      this.mwRef("dataForm").validate(function (valid) {
        if (valid) {

          if (_this.form.types != "0") {
            _this.form.values = '';
          } else {
            _this.form.codeContent = '';
          };
          _this.form.applicationId = _this.$route.params.appId;
          _this.form.owner = _this.$route.params.sysId;
          var me = _this;
          _this.mwApi.data.saveDict(_this.form).then(function (res) {
            if (res.success) {
              _this.mwMsg("info", "保存成功");
              _this.refreshTable();
              _this.handleClose();
            }
          });
        } else {
          _this.mwMsg("信息未填写完整");
        }
      });
    },
    handleRadio: function handleRadio() {
      if (this.types != "0") {
        this.mwRef("dataForm").clearValidate();
      }
    },
    handleClose: function handleClose() {
      this.resetFields();
      this.form.name = "";
      this.form.values = "";
      this.form.value = "";

      this.form.codeContent = "";
      this.mwRef("titleTree").hide();
    },
    addSetting: function addSetting() {
      this.showDialog('setValuesDialog');
    },
    chooseSure: function chooseSure() {
      var data = this.mwRef('valueChoose').getValue();
      this.form.codeContent = (0, _stringify2.default)(data);
      this.mwRef("setValuesDialog").hide();
    },
    cancel: function cancel() {
      this.mwRef("setValuesDialog").hide();
    },
    clearDept: function clearDept() {
      this.form.unit = "";
      this.form.unitName = "";
    },
    resetFields: function resetFields() {
      this.mwRef("dataForm").resetFields();
    },
    showDialog: function showDialog(a) {
      this.mwRef(a).show();
    },
    getParams: function getParams() {
      return this.$route.params;
    },
    deptChoose: function deptChoose(data) {
      var unit = [];
      var unitIds = [];
      data.forEach(function (d) {
        unit.push(d.name);
        unitIds.push(d.id);
      });

      this.form.unitName = unit.join();
      this.form.unitId = unitIds.join();
    },
    showHelp: function showHelp() {
      PF.showHelp({ url: '/helpDoc/platform/dict.md' });
    } } };

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =










{
  data: function data() {
    return {
      deptTreeUrl: 'api/org/getUnitTree',
      btns: [{
        label: '全选',
        func: this.selectAll },
      {
        label: '不选',
        func: this.resetChecked,
        type: 'default' },
      {
        label: '取消',
        func: this.cancelDept,
        type: 'default' },
      {
        label: '确定',
        func: this.confirmDept }] };


  },
  methods: {
    selectAll: function selectAll() {
      this.mwRef('deptTree').checkAll();
    },
    resetChecked: function resetChecked() {
      this.mwRef('deptTree').unCheckAll();
    },

    confirmDept: function confirmDept() {
      this.$emit("confirm", this.mwRef('deptTree').getSelected());
      this.cancelDept();
    },

    cancelDept: function cancelDept() {
      this.mwRef('zgDeptDialog').hide();
    },
    getValue: function getValue() {
      return this.mwRef('deptTree').getSelected();
    },
    show: function show() {
      this.mwRef('zgDeptDialog').show();
    } } };

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =




































































{
  props: {
    dataId: {
      type: String,
      default: '' } },


  data: function data() {
    return {
      treeData: [],
      settingValues: [],
      menuItem: [{ name: 'add', label: '新增', func: this.addCatalog },
      {
        name: 'edit',
        label: '修改',
        func: this.editCatalog },

      {
        name: 'delete',
        label: '删除',
        func: this.deleteCatalog }],

      valueBtns: [
      {
        label: "确定", func: this.addValueSure },

      {
        label: "取消",
        type: "default",
        func: this.closeValueDialog }],


      types: { "#": {
          "icon": "fa fa-leaf" },

        "file": {
          "icon": "fa fa-leaf" },

        "default": {
          "icon": "fa fa-leaf" } },


      keyValues: {},



      editOrAdd: true,
      rowindex: 0 };


  },

  mounted: function mounted() {
    this.getTreeData();
  },

  methods: {
    queryTreeData: function queryTreeData(json, data) {var _this = this;
      json.forEach(function (d) {
        if (d.id == data.id) {
          if (d.data && d.data.length > 0) {
            _this.settingValues = d.data;} else {
            _this.settingValues = [];
          }
        } else {
          if (d.children && d.children.length > 0) {
            _this.queryTreeData(d.children, data);
          }
        }
      });
    },
    changed: function changed(data) {
      this.selectCodeNode = data.id;
      this.queryTreeData(this.treeData, data);
    },


    getTreeData: function getTreeData() {var _this2 = this;
      this.treeData = [];
      if (this.dataId) {
        var appId = this.$route.params.appId;
        this.mwApi.data.getDict(this.dataId, { applicationId: appId }).then(function (res) {
          if (res.result && res.result.codeContent) {
            _this2.treeData = JSON.parse(res.result.codeContent);
          } else {
            _this2.treeData = [];
          }
        });
      }
    },
    createRandomId: function createRandomId() {
      return (Math.random() * 10000000).toString(16).substr(0, 4) + '' + new Date().getTime() + '' + Math.random().toString().substr(2, 5);
    },
    newCatalog: function newCatalog() {var _this3 = this;
      this.$prompt("请输入新分类的名字", "添加分类", {
        confirmButtonText: "确定",
        cancelButtonText: "取消" }).

      then(function (_ref) {var value = _ref.value;
        _this3.mwRef('codeTree').createNode('#', { id: 'x-node' + _this3.createRandomId(),
          name: value,
          text: value,
          type: 'file' },
        'last');
        _this3.treeData = _this3.mwRef('codeTree').getTreeData();
      }).
      catch(function () {});
    },
    addCatalog: function addCatalog(data, parentId, item, obj) {var _this4 = this;
      var me = this;
      this.$prompt("请输入新分类的名字", "添加分类", {
        confirmButtonText: "确定",
        cancelButtonText: "取消" }).

      then(function (_ref2) {var value = _ref2.value;

        _this4.mwRef('codeTree').createNode(data, { id: 'x-node' + _this4.createRandomId(),
          name: value,
          text: value,
          type: 'file' },
        'last');
        _this4.mwRef('codeTree').refreshData(_this4.mwRef('codeTree').getTreeData());
      }).
      catch(function () {});

    },
    editCatalog: function editCatalog(data, parentId, obj) {
      this.mwRef('codeTree').editNodeName(data);
    },
    deleteCatalog: function deleteCatalog(data, parentId, obj) {
      this.mwRef('codeTree').deleteNode(data);
      this.treeData = this.mwRef('codeTree').getTreeData();
    },

    addValues: function addValues() {
      if (!this.mwRef('codeTree').getSelected()) {
        this.mwMsg('info', '请选择分类');
      } else {
        this.mwRef('valueKeyDialog').show();
        this.keyValues = {};this.editOrAdd = false;
      }
    },

    queryTData: function queryTData(json, data) {var _this5 = this;
      json.forEach(function (d) {
        if (d.id === data) {
          d.data = _this5.settingValues;
          return;
        } else {
          if (d.children && d.children.length > 0) {
            _this5.queryTData(d.children, data);
          }
        }
      });
      return json;
    },

    addValueSure: function addValueSure() {
      this.closeValueDialog();
      if (this.editOrAdd) {
        this.settingValues[this.rowindex].id = this.keyValues.id;
        this.settingValues[this.rowindex].name = this.keyValues.name;
      } else {
        this.settingValues.push(this.keyValues);
      }
      var treeData = this.mwRef('codeTree').getTreeData();
      this.treeData = this.queryTData(treeData, this.selectCodeNode);
    },
    closeValueDialog: function closeValueDialog() {
      this.mwRef('valueKeyDialog').hide();
    },
    handleDelete: function handleDelete(row, index) {
      this.treeData = this.mwRef('codeTree').getTreeData();
      this.settingValues.splice(index, 1);
      this.queryTData(this.treeData, this.selectCodeNode);
      this.mwRef('codeTree').refreshData(this.treeData);
    },
    editSetValue: function editSetValue(row, index) {
      this.mwRef('valueKeyDialog').show();
      var initValue = {
        id: row.id,
        name: row.name };

      this.keyValues = initValue;


      this.editOrAdd = true;
      this.rowindex = index;
    },

    getValue: function getValue() {
      var datas = this.mwRef('codeTree').getTreeData();
      function changeJson(dataJson) {
        dataJson.forEach(function (d) {

          for (var t in d) {
            if (t === 'id' || t === 'text' || t === 'data' || t === 'children') {
              if (t === 'text') {
                d.name = d.text;
                delete d.text;
              }
            } else {
              delete d[t];
            }
          }

          if (d.children && d.children.length > 0) {
            d.children = changeJson(d.children);
          }
        });
        return dataJson;
      }
      changeJson(datas);
      return datas;
    } },




  watch: {
    dataId: function dataId(val) {
      this.getTreeData();
    } } };

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);

































































































var _loadManager = __webpack_require__(139);var _loadManager2 = _interopRequireDefault(_loadManager);
var _unitDialog = __webpack_require__(422);var _unitDialog2 = _interopRequireDefault(_unitDialog);
var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  components: {
    loadMan: _loadManager2.default,
    unitDialog: _unitDialog2.default },

  data: function data() {
    var me = this;
    var defaultParams = { isShowChild: true, type: 'full_auth', unitId: "" };
    var expUser = me.$store.getters.expUser;
    if (!expUser.developer && !this.isSysAdmin() && me.$store.getters.expUser.unitAdmin) {
      var unitObj = me.$store.getters.unitDepartments;
      defaultParams.unitId = me.$store.getters.curSelUnitId || unitObj && unitObj[0].id || "";
    }
    var isAuthMsgSelection = window.$Env ? window.$Env.IsFullAuthSendMsgSelection || false : false;
    return {
      expandFlag: 1,
      userDialogVisible: false,
      defaultTreeParams: defaultParams,
      groupTreeUrl: this.mwUrl('/api/org/getGroupTreeByType'),
      unitTreeUrl: this.mwUrl('/api/org/getUnitTree'),
      isEdit: true,
      contextMenuItem: [{ name: 'add', icon: 'fa fa-plus-square', label: '新增', func: me.addGroup }, {
        name: 'delete',
        label: '删除',
        icon: 'fa fa-trash-o',
        func: me.deleteGroup }],

      unitFooterButton: [
      { label: '确定', func: me.selectUnitSure },
      { label: '取消', func: me.selectUnitCancel, type: 'default' }],

      userFooterButton: [
      { label: '确定', func: me.selectUserSure },
      { label: '取消', func: me.cancelSelectUser, type: 'default' }],

      userFooterButton2: [
      { label: '确定', func: me.selectUserSure2 },
      { label: '取消', func: me.cancelSelectUser2, type: 'default' }],

      authTypes: [{ label: "公司", value: "公司" }, { label: "部门", value: "部门" }, { label: "领导", value: "领导" }],
      selectUnitId: '',
      curUnitId: '',
      group: {
        id: '',
        code: '',
        name: '',
        unitId: '',
        unitName: '',
        userId: '',
        agents: '',
        agentIds: '',
        agentDeptIds: '',
        type: 'full_auth',
        msgRemindAgents: '',
        msgRemindAgentIds: '' },

      rules: {
        name: [
        { required: true, message: '请选择授权用户', trigger: 'change' }],

        code: [
        { required: true, message: '请选择权限类型', trigger: 'change' }],

        unitName: [
        { required: true, message: '请选择单位名称', trigger: 'change' }],

        agents: [
        { required: true, message: '请选择代理用户', trigger: 'change' }] },


      chooseUsers: [],
      oneChooseUsers: [],
      defaultParentId: '',
      listAble: false,
      loading: false,
      change: false,
      reset: false,
      form1: {},
      isFirstOpen: true,
      isFullAuthSendMsgSelection: isAuthMsgSelection };

  },
  mounted: function mounted() {
    this.mwRef("groupTree").renderTree();
  },
  methods: {

    changed: function changed(data) {
      var me = this;
      if (this.change) {
        this.$confirm('文档修改后尚未保存，是否保存?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).
        then(function () {
          me.saveGroup();
        }).catch(function () {me.refresh();});
        me.change = false;
      } else {
        if (data.id && data.hasChild == 0) {
          me.resetFields();
          me.mwApi.org.getGroup(data.id).then(function (res) {
            for (var i in res.result) {
              me.form1[i] = res.result[i];
            }
            if (res.result.isDeptSave) {
              me.isEdit = false;
            } else {
              me.isEdit = true;
            }
            me.mwUtil.applyCover(me.group, res.result);
            if (res.result.msgRemindAgents == undefined || res.result.msgRemindAgentIds == undefined) {
              me.group.msgRemindAgents = me.group.agents;
              me.group.msgRemindAgentIds = me.group.agentIds;
            }
          });
          this.reset = false;
        }
      }
    },
    isSysAdmin: function isSysAdmin() {
      var expUser = this.$store.getters.expUser;
      if (expUser.allIdentityRoleNames && expUser.allIdentityRoleNames.indexOf("系统管理员") != -1) {
        return true;
      }
      return false;
    },
    confirmUnit: function confirmUnit() {
      var data = this.mwRef('unitDialog').getValue();
      this.group.unitId = data.id;
      this.group.unitName = data.text;
    },
    expand: function expand() {
      this.expandFlag = 2;
      this.mwRef('groupTree').openAll();
    },
    closed: function closed() {
      this.expandFlag = 1;
      this.mwRef('groupTree').closeAll();
    },
    showUnitDialog: function showUnitDialog() {
      var me = this;
      me.selectUnitId = me.group.unitId;
      this.mwRef('unitDialog').show();
      MW.test(function () {
        if (me.mwRef('unitDialog').mwRef('unitTree'))
        return true;
        return false;
      }, function () {
        me.mwRef('unitDialog').mwRef('unitTree').defaultParams.parentId = me.curUnitId;
        me.mwRef('unitDialog').mwRef('unitTree').renderTree();
      }, 50);
    },
    userChoose: function userChoose() {
      if (this.group.unitId) {
        this.mwRef('userDialog').show();
        if (this.group.name && this.group.id) {
          this.chooseUsers.push({
            name: this.group.name,
            id: this.group.id });

        } else {
          this.oneChooseUsers = [];
        }
        this.defaultParentId = this.group.unitId;
        var treeObj = this.mwRef('userChoose');
        if (treeObj) {
          treeObj.refreshTree(true);
        }
      } else {
        this.mwMsg('请选择单位');
      }
    },
    userChoose2: function userChoose2() {
      if (this.group.unitId) {
        this.mwRef('userDialog2').show();
        this.chooseUsers = [];
        this.defaultParentId = this.group.unitId;
        var treeObj = this.mwRef('userChoose2');
        if (treeObj) {
          treeObj.refreshTree(true);
        }
        if (this.group.agents) {
          var names = this.group.agents.split(',');
          var ids = this.group.agentIds.split(',');
          var departmentIds = this.group.agentDeptIds.split(",");
          for (var i = 0; i < names.length; i++) {
            this.chooseUsers.push({
              name: names[i],
              departmentId: departmentIds[i],
              id: ids[i] });

          }
        }
      } else {
        this.mwMsg('请选择单位');
      }
    },
    userChoose3: function userChoose3() {
      var me = this;
      var names = me.group.agents.split(',');
      var ids = me.group.agentIds.split(',');
      var data = [];
      ids.forEach(function (id, index) {
        data.push({ id: id, text: names[index], label: names[index], children: false });
      });
      var checkNodeIds = [];
      if (me.group.msgRemindAgentIds)
      checkNodeIds = me.group.msgRemindAgentIds.split(",");
      var config = { multiple: true, data: data, checkNodeIds: checkNodeIds };
      PF.treeSelect(config, function (objs) {
        var ids = [];
        var names = [];
        if (objs.length > 0) {
          objs.forEach(function (node) {
            ids.push(node.id);
            names.push(node.text);
          });
          me.group.msgRemindAgents = names.join(",");
          me.group.msgRemindAgentIds = ids.join(",");
        } else {
          me.group.msgRemindAgents = "";
          me.group.msgRemindAgentIds = "";
        }
      });
    },

    selectUserSure: function selectUserSure() {
      this.mwRef('userDialog').hide();
      this.group.name = '';
      this.group.userId = '';
      var data = this.mwRef('userChoose').getValue();
      if (data && data.length > 0) {
        var d = data[0];
        this.group.name = d.name;
        this.group.userId = d.id;
      }
    },

    selectUserSure2: function selectUserSure2() {
      this.mwRef('userDialog2').hide();
      this.group.agents = '';
      this.group.agentIds = '';
      var data = this.mwRef('userChoose2').getValue();
      var userNames = [];
      var userIds = [];
      var agentDeptIds = [];
      data.forEach(function (d) {
        userNames.push(d.name);
        userIds.push(d.id);
        agentDeptIds.push(d.departmentId);
      });
      this.group.agents = userNames.join();
      this.group.agentIds = userIds.join();
      this.group.agentDeptIds = agentDeptIds.join();
    },
    helpnotes: function helpnotes() {

    },
    resetFields: function resetFields() {
      this.reset = true;
      this.mwRef('groupForm').resetFields();
    },
    cancelSelectUser: function cancelSelectUser() {
      this.mwRef('userDialog').hide();
    },
    cancelSelectUser2: function cancelSelectUser2() {
      this.mwRef('userDialog2').hide();
    },
    addGroup: function addGroup() {
      this.resetFields();
      this.isEdit = true;
      var date = this.mwRef('groupTree').getSelected();
      this.group.unitName = date.unitName ? date.unitName : date.name;
      this.group.unitId = date.unitId ? date.unitId : date.id;
    },
    saveGroup: function saveGroup() {
      var me = this;
      me.mwRef('groupForm').validate(function (valid) {
        if (valid) {
          $.post("/api/org/saveFullAuthGroup", me.group).then(function (data) {
            if (!data.success) {
              me.mwMsg(data.msg);
              return;
            }
            me.refresh();
            me.mwMsg('全权代办保存成功');
          });
        }
      });
    },
    refresh: function refresh() {
      this.resetFields();
      this.mwRef('groupTree').refresh();
    },
    deleteGroup: function deleteGroup(data) {
      var me = this;
      if (!data.id) {
        if (this.mwRef('groupTree').getSelected()) {
          data = this.mwRef('groupTree').getSelected();
        } else {
          me.mwMsg('请选择要删除的节点!');
        }
      }
      var params = {};
      var tipMsg = "";
      if (data.hasChild == 0) {
        if (data.isDeptSave) {
          me.mwMsg('商密文书全权代办请在组织成员部门编辑中删除!');
          return;
        }
        params.id = data.id;
        params.name = data.name;
        params.unitName = data.unitName;
        tipMsg = "您确定要删除" + data.name + "的全权代办?";
      } else if (data.level == "2") {
        params.code = data.name;
        params.unitName = data.unitName;
        params.unitId = data.unitId;
        tipMsg = "您确定要删除权限类型" + data.name + "下的所有全权代办?";
      } else if (data.level == "1") {
        params.unitId = data.id;
        params.unitName = data.name;
        tipMsg = "您确定要删除" + data.name + "单位下的所有全权代办?";
      } else {
        me.mwMsg("请选择你要删除的数据");
        return;
      }
      me.mwConfirm(tipMsg).then(function () {
        $.post("/api/org/deleteFullAuthGroup", params).then(function (data) {
          if (!data.success) {
            me.mwMsg(data.msg);
            return;
          }
          me.refresh();
        });
      }).catch(function () {
      });
    } },

  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'userInfo',
  'expUser'])),


  watch: {} };

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =





















































































































{
  data: function data() {
    var me = this;
    return {
      actionTreeUrl: this.mwUrl("/api/app/listActionComponentTree"),
      layout: [],
      paramsLayout: [],
      title: '参数',
      toolbarTitle: '参数列表',
      javascript: '',
      groovy: '',
      params: [],
      paramsForm: {
        id: '',
        name: '',
        description: '' },

      paramsFooterButton: [
      { label: '取消', func: me.paramsCancel, type: 'default' },
      { label: '连续添加', func: me.paramsContinueSure },
      { label: '确定', func: me.paramsSure }],

      form: {
        id: '',
        name: '',
        action: '',
        type: '',
        isDefault: '0',
        remark: '',
        effectiveFormula: 'false' },

      versionNumber: 1,
      defaultParams: { type: '' } };

  },
  mounted: function mounted() {
    var me = this;
    me.paramsLayout = [
    [{
      span: 0,
      key: 'service',
      type: 'menu',
      defaultActive: true,
      dataList: me.params,
      columns: [
      { type: 'selection' },
      { prop: 'name', label: '参数名称', width: '180' },
      { prop: 'description', tooltip: true, label: '说明' }] },

    {
      span: 20, offset: 4, type: 'button', items: [
      { label: '上移', icon: 'fa fa-arrow-circle-up', func: me.up },
      { label: '下移', icon: 'fa fa-arrow-circle-down', func: me.down },
      { label: '添加', icon: 'fa fa-plus-square', func: me.add },
      { label: '编辑', icon: 'fa fa-edit', func: me.edit },
      { label: '删除', icon: 'fa fa-trash-o', func: me.delete }] }]];



    me.layout = [
    [{
      span: 0,
      type: 'menu',
      api: 'app.listActionComponent',
      defaultParams: me.defaultParams,
      columns: [
      { type: 'selection' },
      { prop: 'name', label: '名称', formatter: me._titleFormatter },
      { prop: 'action', label: '标识' },
      { prop: 'isDefault', label: '是否默认', formatter: me.defaultFlagFormatter, width: '120' },
      { prop: 'userName', label: '修改人', width: '60' },
      { prop: 'lastModifiedTime', label: '修改时间', width: '170' },
      { prop: 'remark', label: '备注' }] },

    {
      span: 10, type: 'button', items: [
      { label: '新增', icon: "fa fa-plus-square", func: me.addAction },
      { label: '编辑', icon: "fa fa-pencil fa-fw", func: me.editAction },
      { label: '删除', icon: "fa fa-trash-o fa-fw", func: me.deleteAction }], suffixSlot: "more" }]];

  },
  watch: {},


  methods: {
    handleCommand: function handleCommand(command) {var _this = this;
      if (command === 'import') {
        var selection = this.mwRef('toolbarTable').getMultipleSelection();
        PF.func.view.exportComponentByIds(selection);
      }
      if (command === 'export') {
        PF.show('importComp', {}, function (v) {
          _this.mwRef('toolbarTable').refreshTable();
          _this.mwRef('actionTree').refresh();
        });
      }
    },
    addAction: function addAction(data) {
      var me = this;
      me.form.id = '';
      me.form.name = '';
      me.form.action = '';
      var sel = me.mwRef("actionTree").getSelected();
      if (sel)
      me.form.type = sel.code;else

      me.form.type = '';

      me.form.isDefault = '0';
      me.form.remark = '';
      me.form.effectiveFormula = 'false';
      me.javascript = '';
      me.groovy = '';

      me.mwLodash.remove(me.params, function (o) {
        return true;
      });
      this.mwRef('dialog').show();
    },
    _valid: function _valid() {
      var me = this;
      if (me.form.name == '') {
        me.mwMsg("warning", "请输入名称！");
        return false;
      }
      if (me.form.action == '') {
        me.mwMsg("warning", "请输入标识！");
        return false;
      }

      if (!me.form.action.match(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/)) {
        me.mwMsg('warning', '输入正确的标识，标识可以是字母、数字、$、_(下划线)，但不可用数字开头');
        return false;
      }

      if (me.form.type == '') {
        me.mwMsg("warning", "请输入分类！");
        return false;
      }
      return true;
    },
    editAction: function editAction(data) {
      var me = this;
      if (data.length == 0 || data.length > 1) {
        me.mwMsg("warning", "请选择一条记录！");
      } else {
        me.mwApi.app.getScriptComponent(data[0].id).then(function (res) {
          var d = res.result;
          me.form.id = d.id;
          me.form.name = d.name;
          me.form.action = d.action;
          me.form.type = d.type;
          me.form.isDefault = d.isDefault;
          me.form.remark = d.remark;
          me.form.effectiveFormula = d.effectiveFormula;
          me.javascript = d.javascript;
          me.groovy = d.groovy;
          me.versionNumber = d['#versionNumber'];
          me.mwLodash.remove(me.params, function (o) {
            return true;
          });
          var params = d.params;
          if (params) {
            params.forEach(function (v) {
              me.params.push(v);
            });
          }

          me.mwRef('dialog').show();
        });
      }
    },
    expand: function expand() {
      this.mwRef("actionTree").openAll();
    },
    closed: function closed() {
      this.mwRef("actionTree").closeAll();
    },
    save: function save(e, flag) {var _this2 = this;
      var me = this,params = {};
      if (me.form.id != '') {
        params.id = me.form.id;
      }

      if (!me._valid()) {
        return;
      }
      params.name = me.form.name;
      params.action = me.form.action;
      params.type = me.form.type;
      params.isDefault = me.form.isDefault;
      params.remark = me.form.remark;
      params.effectiveFormula = me.form.effectiveFormula;
      params.javascript = me.mwRef('javascript').getValue();
      params.groovy = me.mwRef('groovy').getValue();

      params['#versionNumber'] = me.versionNumber;
      params['#sync'] = true;

      me.javascript = params.javascript;
      me.groovy = params.groovy;
      if (_.trim(params.groovy).length > 0)
      params.extends = { ref: "action-groovy-service" };

      params.params = me.params;
      me.mwApi.app.createActionComponent(params).then(function (res) {
        me.mwMsg("保存成功！");
        if (flag) {
          _this2.mwRef('dialog').hide();
          me.mwRef("actionTree").refresh();
          me.mwRef('toolbarTable').refreshTable();
        } else {
          if (res && res.result) {
            var d = res.result;
            me.versionNumber = d['#versionNumber'];
            me.form.id = d.id;
          }
        }
      });
    },

    saveClose: function saveClose(e) {
      this.save(e, true);
    },
    close: function close() {
      this.mwRef('dialog').hide();
    },
    handleClose: function handleClose() {
      var me = this;
      this.mwRef('dialog').hide();
      me.mwRef("actionTree").refresh();
      me.mwRef('toolbarTable').refreshTable();
    },
    deleteAction: function deleteAction(data) {
      var me = this;
      if (data.length == 0) {
        me.mwMsg("info", "请至少选择一条记录！");
      } else {
        me.mwConfirm('您确定要删除所选记录').then(function () {
          var p = [];
          data.forEach(function (d) {
            p.push(d.id);
          });
          me.mwApi.app.removeComponent(p).then(function (res) {
            if (res.success) {
              me.mwMsg("删除成功");
              me.mwRef("actionTree").refresh();
              me.mwRef('toolbarTable').refreshTable();
            } else {
              me.mwMsg('warning', '删除失败');
            }
          });
        }).catch(function () {

        });
      }
    },
    up: function up(a) {
      var me = this;
      a.forEach(function (v) {
        var idx = me.mwLodash.findIndex(me.params, function (o) {
          return o.id == v.id;
        });
        if (idx > 0) {
          var remove = me.mwLodash.remove(me.params, function (o) {
            return o.id == v.id;
          });
          me.params.splice(idx - 1, 0, remove[0]);
        }
      });
    },
    down: function down(a) {
      var me = this;
      a.forEach(function (v) {
        var idx = me.mwLodash.findIndex(me.params, function (o) {
          return o.id == v.id;
        });
        if (idx < me.params.length) {
          var remove = me.mwLodash.remove(me.params, function (o) {
            return o.id == v.id;
          });
          me.params.splice(idx + 1, 0, remove[0]);
        }
      });
    },
    reset: function reset() {
      this.paramsForm.id = $uuid();
      this.paramsForm.name = '';
      this.paramsForm.description = '';
    },
    add: function add() {
      var me = this;
      me.reset();
      me.mwRef('paramsDialog').show();
    },
    edit: function edit(a, b) {
      if (a.length == 0) {
        b.mwMsg('warning', '请选择需要编辑的记录');
        return;
      }
      if (a.length > 1) {
        b.mwMsg('warning', '请选择一条需要编辑的记录');
        return;
      }
      this.mwLodash.assign(this.paramsForm, a[0]);
      this.mwRef('paramsDialog').show();
    },

    delete: function _delete(a, b) {
      var me = this;
      if (a.length == 0) {
        b.mwMsg('warning', '请选择需要删除的记录');
        return;
      }
      a.forEach(function (v) {
        for (var i = 0; i < me.params.length; i++) {
          var v1 = me.params[i];
          if (v.id == v1.id) {
            me.params.splice(i, 1);
            break;
          }
        }
      });
    },

    paramsContinueSure: function paramsContinueSure() {
      if (this.paramsSure(true)) {
        this.reset();
      }
    },
    paramsSure: function paramsSure(noCancel) {var _this3 = this;
      var form = {};
      var me = this;
      var flag = false;

      this.params.forEach(function (v) {
        if (v.id == _this3.paramsForm.id) {
          form = v;
          flag = true;
        }
      });
      me.paramsForm.name = me.paramsForm.name.trim();
      if (me.paramsForm.name == '') {
        me.mwMsg('warning', '参数名称不能为空');
        return false;
      }
      if (!me.paramsForm.name.match(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/)) {
        me.mwMsg('warning', '输入正确的参数名称，参数名称可以是字母、数字、$、_(下划线)，但不可用数字开头');
        return false;
      }

      if (me.paramsForm.name) {
        if (!flag) {
          var idx = me.mwLodash.findIndex(me.params, function (o) {
            return o.name.toLowerCase() == me.paramsForm.name.toLowerCase();
          });
          if (idx > -1) {
            me.mwMsg('warning', '参数名称不能重复');
            return false;
          }
        } else {
          var _idx = me.mwLodash.findIndex(me.params, function (o) {
            return o.name.toLowerCase() == me.paramsForm.name.toLowerCase() && o.id != form.id;
          });

          if (_idx > -1) {
            me.mwMsg('warning', '参数名称不能重复');
            return false;
          }
        }
      }
      me.mwLodash.assign(form, me.paramsForm);

      if (!flag)
      me.params.push(form);
      if (!noCancel)
      me.paramsCancel();
      return true;
    },

    paramsCancel: function paramsCancel() {
      this.mwRef('paramsDialog').hide();
    },

    defaultFlagFormatter: function defaultFlagFormatter(data) {
      var me = this;
      return data.isDefault == '1' ? '是' : '否';
    },
    loadTableTree: function loadTableTree(data) {
      this.mwRef("toolbarTable").refreshTableDefaultParams({
        type: data.code });

    },
    _titleFormatter: function _titleFormatter(a, b, c) {var h = this.$createElement;
      var me = this;
      return h('span', { 'class': { 'link': true }, attrs: { title: c }, on: { 'click': function click(event) {return me.editAction([a]);} } }, [c ? c : '无标题']);
    } } };

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =

















































































{
  data: function data() {
    var me = this;
    return {
      title: '',
      type: '',
      scriptType: 'vue',
      nodeLayout: [],
      lineLayout: [],

      baseTemplate: '',
      baseScript: '',
      eventScript: '',

      nodeList: [],
      lineList: [],

      form: {
        id: '',
        name: '',
        code: '',
        template: '',
        script: '',
        active: '1' } };



  },
  mounted: function mounted() {
    var me = this;

    me.nodeLayout = [
    [
    {
      span: 0,
      type: "menu",
      dataList: me.nodeList,
      singleSelect: true,
      columns: [
      { type: "selection" },
      { type: "index" },
      { prop: "name", label: "节点名称" },
      { prop: "code", label: "节点编码", tooltip: true }] },


    {
      span: 10,
      type: "button",
      items: [
      { label: '新增', icon: "fa fa-plus-square", func: me.nodeAdd },
      {
        label: "编辑",
        icon: "fa fa-pencil fa-fw ",
        func: me.nodeEdit },

      { label: '删除', icon: "fa fa-trash-o fa-fw", func: me.nodeDelete }] }]];






    me.lineLayout = [
    [
    {
      span: 0,
      type: "menu",
      dataList: me.lineList,
      singleSelect: true,
      columns: [
      { type: "selection" },
      { type: "index" },
      { prop: "name", label: "流向名称" },
      { prop: "code", label: "流向编码", tooltip: true }] },


    {
      span: 10,
      type: "button",
      items: [
      { label: '新增', icon: "fa fa-plus-square", func: me.lineAdd },
      {
        label: "编辑",
        icon: "fa fa-pencil fa-fw ",
        func: me.lineEdit },

      { label: '删除', icon: "fa fa-trash-o fa-fw", func: me.lineDelete }] }]];





    me.loadData();
  },

  methods: {
    loadData: function loadData() {
      var me = this;
      me.mwApi.app.getFlowConfig().then(function (res) {
        var data = res.result;
        if (data) {
          me.baseTemplate = data.baseTemplate;
          me.baseScript = data.baseScript;
          me.eventScript = data.eventScript;

          if (data.nodeList) {
            data.nodeList.forEach(function (v) {
              if (!v.name) {
                v.name = '';
              }
              if (!v.code) {
                v.code = '';
              }
              if (!v.template) {
                v.template = '';
              }
              if (!v.script) {
                v.script = '';
              }
              me.nodeList.push(v);
            });
          }
          if (data.lineList) {
            data.lineList.forEach(function (v) {
              if (!v.name) {
                v.name = '';
              }
              if (!v.code) {
                v.code = '';
              }
              if (!v.template) {
                v.template = '';
              }
              if (!v.script) {
                v.script = '';
              }
              me.lineList.push(v);
            });
          }
        }
      });
    },

    nodeAdd: function nodeAdd() {
      this.mwRef('dialog').show();
      this.title = '节点配置';
      this.type = 'node';
      this.form.id = '';
      this.form.name = '';
      this.form.code = '';
      this.form.template = '';
      this.form.script = '';
      this.form.active = '1';
    },
    nodeEdit: function nodeEdit(a, b) {var _this = this;
      if (a.length == 0) {
        b.mwMsg('info', '请选择需要修改记录');
        return;
      }
      if (a.length > 1) {
        b.mwMsg('info', '请选择一条需要修改记录');
        return;
      }
      this.title = '节点配置';
      this.type = 'node';

      if (a[0].id) {
        this.nodeList.forEach(function (v) {
          if (v.id == a[0].id) {

            _this.mwUtil.apply(_this.form, v);
            _this.mwRef('dialog').show();
          }
        });
      }
    },
    nodeDelete: function nodeDelete(a, b) {var _this2 = this;
      if (a.length == 0) {
        b.mwMsg('info', '请选择需要删除记录');
        return;
      }
      this.mwConfirm('确定删除此记录吗?').then(function () {
        _this2.nodeList.forEach(function (v, idx) {
          if (v.id == a[0].id) {
            _this2.nodeList.splice(idx, 1);
          }
        });
        _this2.save();
      });
    },


    lineAdd: function lineAdd() {
      this.mwRef('dialog').show();
      this.title = '流向配置';
      this.type = 'line';
      this.form.id = '';
      this.form.name = '';
      this.form.code = '';
      this.form.template = '';
      this.form.script = '';
      this.form.active = '1';
    },
    lineEdit: function lineEdit(a, b) {var _this3 = this;
      if (a.length == 0) {
        b.mwMsg('info', '请选择需要修改记录');
        return;
      }
      if (a.length > 1) {
        b.mwMsg('info', '请选择一条需要修改记录');
        return;
      }
      this.title = '流向配置';
      this.type = 'line';

      if (a[0].id) {
        this.lineList.forEach(function (v) {
          if (v.id == a[0].id) {
            _this3.mwRef('dialog').show();
            _this3.mwUtil.apply(_this3.form, v);
          }
        });
      }
    },
    lineDelete: function lineDelete(a, b) {var _this4 = this;
      if (a.length == 0) {
        b.mwMsg('info', '请选择需要删除记录');
        return;
      }
      this.mwConfirm('确定删除此记录吗?').then(function () {
        _this4.lineList.forEach(function (v, idx) {
          if (v.id == a[0].id) {
            _this4.lineList.splice(idx, 1);
          }
        });
        _this4.save();
      });
    },

    saveForm: function saveForm() {
      var me = this;
      if (this.form.name == '') {
        this.mwMsg('info', '请输入名称');
        return;
      }
      if (this.form.code == '') {
        this.mwMsg('info', '请输入编码');
        return;
      }

      if (me.type == 'node') {
        var node = void 0;
        if (me.form.id == '') {
          me.form.id = $uuid();
        } else {
          me.nodeList.forEach(function (v) {
            if (v.id == me.form.id) {
              node = v;
            }
          });
        }
        me.form.script = me.mwRef('formScript').getValue();
        me.form.template = me.mwRef('formTemplate').getValue();
        if (node) {
          me.mwUtil.apply(node, me.form);
        } else {
          node = {};
          me.mwUtil.apply(node, me.form);
          me.nodeList.unshift(node);
        }
        me.mwRef('dialog').hide();
        me.save();
      }

      if (me.type == 'line') {
        var line = void 0;
        if (me.form.id == '') {
          me.form.id = $uuid();
        } else {
          me.lineList.forEach(function (v) {
            if (v.id == me.form.id) {
              line = v;
            }
          });
        }
        me.form.script = me.mwRef('formScript').getValue();
        me.form.template = me.mwRef('formTemplate').getValue();
        if (line) {
          me.mwUtil.applyCover(line, me.form);
        } else {
          line = {};
          me.mwUtil.apply(line, me.form);
          me.lineList.unshift(line);
        }
        me.mwRef('dialog').hide();
        me.save();
      }


    },
    save: function save() {
      var me = this;
      me.mwApi.app.saveFlowConfig({
        baseTemplate: me.mwRef('baseTemplate').getValue(),
        scriptType: me.scriptType,
        baseScript: me.mwRef('baseScript').getValue(),
        eventScript: me.mwRef('eventScript').getValue(),
        nodeList: me.nodeList,
        lineList: me.lineList }).
      then(function (res) {
        me.mwMsg("保存成功！");
      });
    } } };

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =
















































{

  data: function data() {
    var me = this;
    return {
      set: {
        defaultEnterAppId: '',
        defaultEnterAppName: '',
        scriptStyle: '',
        rootPath: '',
        loginPage: '',
        pageTitle: '',
        repository: '' } };


  },
  mounted: function mounted() {
    var me = this;
    me.mwApi.app.getSystemParameter().then(function (v) {
      if (v.result) {
        var con = v.result.content;
        me.set.defaultEnterAppId = con.defaultEnterAppId;
        me.set.defaultEnterAppName = con.defaultEnterAppName;
        me.set.scriptStyle = con.scriptStyle;
        me.set.rootPath = con.rootPath;
        me.set.loginPage = con.loginPage;
        me.set.pageTitle = con.pageTitle;
        me.set.repository = con.repository;
      }
    });
  },
  methods: {
    showDialog: function showDialog() {
      var me = this;
      PF.show('tree', { size: 'mini_large', url: this.mwUrl("/api/app/listApplicationTree"), defaultParams: { category: 'application' },
        selectFirst: false, title: '选择应用', clearBtn: false, multiple: false, threeState: true, search: true, async: false, multipleLeaf: false, singleLeaf: true }, function (res) {
        if (res) {
          me.set.defaultEnterAppId = res.id;
          me.set.defaultEnterAppName = res.name;
        }

      });
    },
    saveSet: function saveSet() {var _this = this;
      this.set.scriptStyle = this.mwRef('formTemplate').getValue();
      this.mwApi.app.saveSystemParameter({ content: this.set }).then(function () {
        _this.mwMsg('保存成功');
      });
    } } };

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);

































































































































var _vuex = __webpack_require__(9);
var _worktimePreview = __webpack_require__(1233);var _worktimePreview2 = _interopRequireDefault(_worktimePreview);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  data: function data() {
    var me = this;

    var currentYear = new Date().getFullYear();

    var currentYearFirstTime = new Date(currentYear, 0, 1).getTime();

    var currentYearLastTime = new Date(currentYear, 11, 31).getTime();
    return {
      layout: [],
      form: {
        id: '',
        unitId: '',
        unitName: '',
        amStartTime: '09:00',
        amEndTime: '12:00',
        pmStartTime: '13:30',
        pmEndTime: '17:30',
        workdaysList: ['1', '2', '3', '4', '5'],
        holidays: '',
        restdays: '',
        aholiday: '',
        dholidayIndex: '',
        holidayOptions: [],
        arestday: '',
        drestdayIndex: '',
        restdayOptions: [],
        isDefault: 0 },

      isNew: false,
      workdayOptions: [{ name: '星期日', id: '0' }, { name: '星期一', id: '1' }, { name: '星期二', id: '2' }, { name: '星期三', id: '3' }, { name: '星期四', id: '4' }, { name: '星期五', id: '5' }, { name: '星期六', id: '6' }],
      title: '工作时间',
      defaultParams: { deep: true, isContainSelf: true, parentId: "" },
      pickerDateRange: {
        disabledDate: function disabledDate(date) {
          var time = date.getTime();
          return time < currentYearFirstTime || time > currentYearLastTime;
        } } };


  },
  mounted: function mounted() {
    var me = this;
    var isSysAdmin = this.isSysAdmin();
    var sysAdminShowAllUnit = true;
    if (window.$Env && window.$Env.dataManagementByUnit) {
      sysAdminShowAllUnit = false;
    }
    if ((this.userInfo.developer || isSysAdmin) && sysAdminShowAllUnit) {
      this.defaultParams.parentId = this.userInfo.owner || "";;
    } else {
      if (this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0) {
        this.defaultParams.parentId = this.$store.getters.curUnit[0].id;
      }
    }
    me.layout = [[
    {
      span: 0,
      type: 'menu',
      api: 'data.listWorkTime',
      defaultParams: { titleColName: 'unitName', unitId: me.defaultParams.parentId },
      columns: [
      { type: 'selection' },
      { slot: { type: 'href', func: me.edit }, prop: 'unitName', label: '单位名称' },
      { prop: 'amTime', label: '上午上班时间', width: '120' },
      { prop: 'pmTime', label: '下午上班时间', width: '120' },
      { prop: 'workdays', label: '工作日', formatter: me.workdayFormatter, width: '350' },


      { prop: 'isDefault', label: '是否默认', width: '90', formatter: me.defaultFlagFormatter }] },

    {
      span: 10, type: 'button', items: [
      { label: '新增', icon: "fa fa-plus-square", func: me.add },
      { label: '删除', icon: "fa fa-trash-o fa-fw", func: me.delete },
      { label: '设置为默认', icon: "fa fa-cog", func: me.setDefault }] },

    {
      span: 5, offset: 7, type: 'searchText', name: 'titleLike' }]];



    me.$nextTick(function () {
      $(me.$el).find(".el-row").append('<button id="showhelp" style="float:right;margin-top:8px;" type="button" class="el-button el-button--info"><span><i class="fa fa-question"></i><span>帮助</span></span></button>');
      $("#showhelp").click(function () {
        me.helpnotesview();
      });
    });

  },
  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'userInfo',
  'expUser'])),


  methods: {
    defaultFlagFormatter: function defaultFlagFormatter(data) {
      var me = this;
      return data.isDefault == '1' ? '是' : '否';
    },
    workdayFormatter: function workdayFormatter(data) {
      var v = data.workdays;
      return v.replace('0', '星期日').replace('1', '星期一').replace('2', '星期二').replace('3', '星期三').replace('4', '星期四').replace('5', '星期五').replace('6', '星期六');
    },
    showUnit: function showUnit() {
      var me = this,selectNode = '';
      if (me.form.unitId) {
        selectNode = me.form.unitId;
      }
      PF.show('tree', { url: this.mwUrl("/api/org/getUnitTreeContainSelf"), defaultParams: me.defaultParams, selectNode: selectNode, search: false, multiple: false, singleLeaf: false, clearBtn: true }, function (res) {
        me.form.unitId = res.id;
        me.form.unitName = res.name;
      });
    },
    isSysAdmin: function isSysAdmin() {
      if (this.userInfo.roleNames && this.userInfo.roleNames.indexOf("系统管理员") != -1) {
        return true;
      }
      return false;
    },
    addDay: function addDay(type) {
      var me = this;
      if (type == 'holiday') {
        var aday = me.form.aholiday;
        var days = me.form.holidays;
        var optiondays = me.form.holidayOptions;
        if (!days) {
          days = aday;
          optiondays = [aday];
        } else if (days.indexOf(aday) == -1) {
          optiondays.push(aday);
          days = optiondays.join(',');
        }
        me.form.holidays = days;
        me.form.holidayOptions = optiondays;
      } else {
        var aday = me.form.arestday;
        var days = me.form.restdays;
        var optiondays = me.form.restdayOptions;
        if (!days) {
          days = aday;
          optiondays = [aday];
        } else if (days.indexOf(aday) == -1) {
          optiondays.push(aday);
          days = optiondays.join(',');
        }
        me.form.restdays = days;
        me.form.restdayOptions = optiondays;
      }
    },
    delDay: function delDay(type) {
      var me = this;
      if (type == 'holiday') {
        var ddayIndex = me.form.dholidayIndex;
        var days = me.form.holidays;
        var optiondays = me.form.holidayOptions;
        optiondays.splice(ddayIndex, 1);
        days = optiondays.join(',');
        me.form.dholidayIndex = '';
        me.form.holidays = days;
        me.form.holidayOptions = optiondays;
      } else {
        var ddayIndex = me.form.drestdayIndex;
        var days = me.form.restdays;
        var optiondays = me.form.restdayOptions;
        optiondays.splice(ddayIndex, 1);
        days = optiondays.join(',');
        me.form.drestdayIndex = '';
        me.form.restdays = days;
        me.form.restdayOptions = optiondays;
      }
    },
    add: function add() {
      var me = this;
      me.resetForm();


      me.title = '新增';
      me.isNew = true;
      this.mwRef('dialog').show();
    },
    edit: function edit(row, index) {
      var me = this;
      this.mwApi.data.getWorkTime(row.id).then(function (res) {
        if (res.success) {
          var data = res.result;
          me.resetForm();
          me.form.id = data.id;
          me.form.unitId = data.unitId;
          me.form.unitName = data.unitName;
          var amTimes = data.amTime.split('-');
          me.form.amStartTime = amTimes[0];
          me.form.amEndTime = amTimes[1];
          var pmTimes = data.pmTime.split('-');
          me.form.pmStartTime = pmTimes[0];
          me.form.pmEndTime = pmTimes[1];
          me.form.workdaysList = data.workdays.split(',');
          me.form.holidays = data.holidays;
          me.form.restdays = data.restdays;
          if (data.holidays) {
            me.form.holidayOptions = data.holidays.split(',');
          }
          if (data.restdays) {
            me.form.restdayOptions = data.restdays.split(',');
          }
          me.title = '编辑-' + me.form.unitName + '工作时间';
          me.mwRef('dialog').show();
        }
      });
    },
    delete: function _delete(data) {
      var me = this;
      if (data.length == 0) {
        me.mwMsg("info", "请至少选择一条记录！");
        return;
      }
      me.mwConfirm('删除后将无法恢复，您确定要删除所选记录? ').then(function () {
        var ids = [];
        data.forEach(function (d) {
          ids.push(d.id);
        });
        me.mwApi.data.deleteWorkTime(ids).then(function (res) {
          if (res.success) {
            me.mwMsg("删除成功");
            me.mwRef('toolbarTable').refreshTable();
          } else {
            me.mwMsg('warning', '删除失败');
          }
        });
      }).catch(function () {});
    },
    setDefault: function setDefault(data) {
      var me = this;
      if (data.length == 0) {
        me.mwMsg("info", "请至少选择一条记录！");
        return;
      }
      if (data.length > 1) {
        me.mwMsg("info", "只能选择一条记录！");
        return;
      }
      me.mwConfirm('您确定要把所选记录设置为默认').then(function () {
        var ids = [];
        data.forEach(function (d) {
          ids.push(d.id);
        });
        me.mwApi.data.setDefaultWorkTime(ids[0]).then(function (res) {
          if (res.success) {
            me.mwMsg("设置成功");
            me.mwRef('toolbarTable').refreshTable();
          } else {
            me.mwMsg('warning', '设置失败');
          }
        });
      }).catch(function () {});
    },
    save: function save() {
      var me = this;
      var data = {};
      if (me.form.id != '') {
        data.id = me.form.id;
      }
      if (me.form.unitName == '') {
        me.mwMsg("info", "请选择所属单位！");
        return;
      }
      if (!data.id) {
        me.mwApi.data.listWorkTime({ titleColName: 'unitName', unitId: me.defaultParams.parentId }).then(function (res) {
          if (res.result) {
            var addUnit = _.filter(res.result, function (item) {return item.unitId == me.form.unitId;});
            if (addUnit && addUnit.length > 0) {
              me.mwConfirm('当前所属单位已经存在工作时间,继续操作将覆盖原有工作时间,您确定要继续吗?').then(function () {
                data.id = addUnit[0].id;
                me.saveWorkTime(data);
              });
            } else {
              me.saveWorkTime(data);
            }
          }
        });
      } else {
        me.saveWorkTime(data);
      }
    },
    saveWorkTime: function saveWorkTime(params) {
      var me = this;
      var data = {};
      _.extend(data, params);
      data.unitId = me.form.unitId;
      data.unitName = me.form.unitName;
      data.amTime = me.form.amStartTime + '-' + me.form.amEndTime;
      data.pmTime = me.form.pmStartTime + '-' + me.form.pmEndTime;
      data.workdays = me.form.workdaysList.join(',');
      data.holidays = me.form.holidays;
      data.restdays = me.form.restdays;
      data.isDefault = me.form.isDefault;
      me.mwApi.data.saveWorkTime(data).then(function (res) {
        me.mwMsg("保存成功！");
        me.mwRef('dialog').hide();
        me.mwRef('toolbarTable').refreshTable();
      });
    },
    resetForm: function resetForm() {
      var me = this;
      me.form.id = '';
      me.form.unitId = '';
      me.form.unitName = '';
      me.form.amStartTime = '09:00';
      me.form.amEndTime = '12:00';
      me.form.pmStartTime = '13:30';
      me.form.pmEndTime = '17:30';
      me.form.workdaysList = ['1', '2', '3', '4', '5'];
      me.form.holidays = '';
      me.form.restdays = '';
      me.form.aholiday = '';
      me.form.dholidayIndex = '';
      me.form.holidayOptions = [];
      me.form.arestday = '';
      me.form.drestdayIndex = '';
      me.form.restdayOptions = [];
      me.form.isDefault = 0;
    },
    handleClose: function handleClose() {
      var me = this;
      me.resetForm();
      me.isNew = false;
      this.mwRef("dialog").hide();
    },
    contains: function contains(arrays, obj) {
      var i = arrays.length;
      while (i--) {
        if (arrays[i] === obj) {
          return i;
        }
      }
      return -1;
    },
    setSpecialDay: function setSpecialDay(date) {
      var type = '';

      var dd = new Date(date).getDay();
      var dmd = date.substr(5, 5);
      var holidays = this.form.holidays ? this.form.holidays.split(',') : [];
      var restdays = this.form.restdays ? this.form.restdays.split(',') : [];
      if ($.inArray(dd.toString(), this.form.workdaysList) !== -1) {
        var dayInHolidaysIndex = this.contains(holidays, dmd);
        if (dayInHolidaysIndex < 0) {
          holidays.push(dmd);
          type = 'remove';
        } else {
          holidays.splice(dayInHolidaysIndex, 1);
          type = 'add';
        }
        this.form.holidays = holidays.join(',');
      } else {
        var dayInRestdaysIndex = this.contains(restdays, dmd);
        if (dayInRestdaysIndex < 0) {
          restdays.push(dmd);
          type = 'add';
        } else {
          restdays.splice(dayInRestdaysIndex, 1);
          type = 'remove';
        }
        this.form.restdays = restdays.join(',');
      }
      this.$refs.worktimePreview.updateWorkDayState(date, type);
    },
    helpnotes: function helpnotes() {
      PF.showHelp({ url: '/helpDoc/platform/worktime.md' });
    },
    helpnotesview: function helpnotesview() {
      PF.showHelp({ url: '/helpDoc/platform/worktimeView.md' });
    } },

  components: {
    worktimePreview: _worktimePreview2.default } };

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =








{
  name: "preview",
  props: ['formData', 'isNew'],
  watch: {
    formData: {
      handler: function handler(val, oldval) {
        if (oldval !== undefined) {
          this.removeCaledarEvents();
          if (val.id || this.isNew) {
            this.initCalendar();
          }
        }
      },
      immediate: true,
      deep: true } },


  data: function data() {
    return {
      title: "工作时间与休假时间设置",
      calendar: null };

  },
  mounted: function mounted() {var _this = this;
    this.$nextTick(function () {
      _this.initCalendar();
    });
  },
  methods: {
    initWorkdayEvent: function initWorkdayEvent(startDate, endDate) {
      var me = this;
      var workdaysList = me.formData.workdaysList;
      var holidays = me.formData.holidays;
      var restdays = me.formData.restdays;
      Date.prototype.formatCurDate = function () {
        var s = '';
        var mouth = this.getMonth() + 1 >= 10 ? this.getMonth() + 1 : '0' + (this.getMonth() + 1);
        var day = this.getDate() >= 10 ? this.getDate() : '0' + this.getDate();
        s += this.getFullYear() + '-';
        s += mouth + "-";
        s += day;
        return s;
      };

      function getAll(begin, end) {
        var arr = [];
        var ab = begin.split("-");
        var ae = end.split("-");
        var db = new Date();
        db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
        var de = new Date();
        de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
        var unixDb = db.getTime();
        var unixDe = de.getTime();
        for (var k = unixDb; k <= unixDe;) {

          var d = new Date(parseInt(k));
          var dd = d.getDay();
          var dmd = d.formatCurDate().substr(5, 5);
          if ($.inArray(dd.toString(), workdaysList) !== -1 && holidays.indexOf(dmd) < 0 || $.inArray(dd.toString(), workdaysList) == -1 && restdays.indexOf(dmd) !== -1) {

            arr.push({
              start: d.formatCurDate(),
              title: '班',
              className: 'a-worktime' });

          }
          k = k + 24 * 60 * 60 * 1000;
        }
        return arr;
      }
      return getAll(startDate, endDate);
    },
    initCalendar: function initCalendar() {var _this2 = this;
      var cssList = ['/assets/css/fullcalendar/fullcalendar.min.css'];
      var jsList = ['/assets/js/fullcalendar/fullcalendar.min.js', '/assets/js/fullcalendar/zh-cn.js'];
      PF.loadCss(cssList);
      PF.requireJs(jsList, function (res) {
        var me = _this2;
        _this2.calendar = $(me.$refs.calendarContainer).fullCalendar({
          defaultView: "month",
          selectable: true,
          aspectRatio: 2.5,
          firstDay: 0,
          header: {
            left: 'title',
            center: '',
            right: 'prev,today,next' },

          views: {
            month: {
              titleFormat: "YYYY-MM" } },


          dayClick: function dayClick(date, allDay, jsEvent, view) {
            me.setSpecialDay(date.format('YYYY-MM-DD'));
          },
          eventClick: function eventClick(event, jsEvent, view) {
            me.setSpecialDay(event.start.format('YYYY-MM-DD'));
          } });

        _this2.calendar.fullCalendar('addEventSource', function (start, end, timezone, callback) {
          var events = [];
          _this2.removeCaledarEvents();
          events = _this2.initWorkdayEvent(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
          callback(events);
        });
      });
    },
    setSpecialDay: function setSpecialDay(date) {
      this.$emit('setSpecialDay', date);
    },
    refetchCaledar: function refetchCaledar() {
      if (this.calendar) this.calendar.fullCalendar('refetchEvents');
    },
    removeCaledarEvents: function removeCaledarEvents() {
      if (this.calendar) this.calendar.fullCalendar('removeEvents');
    },
    setIsNew: function setIsNew() {
      this.$emit('setIsNew');
    },
    updateWorkDayState: function updateWorkDayState(date, type) {
      if (type == 'remove') {
        this.calendar.fullCalendar('removeEvents', function (event) {
          return event.start && event.start.format("YYYY-MM-DD") == date;
        });
      } else if (type == 'add') {
        this.calendar.fullCalendar('addEventSource', function (start, end, timezone, callback) {
          var event = [{
            start: date,
            title: '班',
            className: 'a-worktime' }];

          callback(event);
        });
      }
    } } };

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =

































































































{
  data: function data() {
    return {
      treeData: [],
      lanData: [],
      treeContextMenu: [],
      selectNodeId: '',
      valueTab: 'keyValue',
      form: {
        name: "",
        category: "LanguagePack",
        template: "",
        id: "",
        code: "" },

      multilangDialogVisible: false,
      selectOption: '',

      title: "",
      disabledSave: false,
      disabledNew: false,
      afterSavedLoad: false,
      options: [{
        value: 'en',
        label: '英语' },
      {
        value: 'ja',
        label: '日语' },
      {
        value: 'ko',
        label: '韩语' },
      {
        value: 'zh-TW',
        label: '中文繁体' }],

      optionsMap: { 'en': '英语', 'ja': '日语', 'ko': '韩语', 'zh-TW': '中文繁体' },
      importAction: '/api/app/impCompXml',
      headers: {},
      impBtton: [{
        label: "取消",
        func: this.impCancel,
        type: "default" },
      {
        label: "导入",
        func: this.import }] };


  },
  mounted: function mounted() {
    var me = this;
    me.treeContextMenu = [{
      name: "删除",
      icon: 'fa fa-remove',
      label: '删除',
      func: function func(selectData, selectParent, curBtn, item) {
        me.removeNode(selectData);
      } }];

    var contextMenu = PF.contextMenu({
      el: me.$refs.treeContainer,
      target: '.mw-tree-no-search__body',
      items: [{
        text: "新建",
        icon: "fa fa-plus",
        handler: function handler() {
          me.createNode();
        } },
      {
        text: "删除",
        icon: "fa fa-remove",
        handler: function handler() {
          me.removeNode();
        } }] });


    me.$on("hook:destroyed", function () {contextMenu.destroy();});
    me.loadTreeData();
  },
  methods: {
    loadTreeData: function loadTreeData(selected) {
      var me = this;
      PF.invoke("s:multilang.srv.listMultilang", { category: 'LanguagePack', sort: 'createTime', dir: 'desc' }).then(function (res) {
        me.treeData = [];
        if (res.result && res.result.length > 0) {
          if (!selected) {
            me.currentNode = res.result[0];
          } else {
            me.afterSavedLoad = true;
            me.currentNode = res.result.find(function (item) {return item.id = selected.id;});
          }
          me.selectNodeId = me.currentNode.id;
        }
        me.lanData = res.result || [];
        me.lanData.forEach(function (item) {
          var temp = {};
          temp.id = item.id;
          temp.name = item.name;
          temp.hasChild = item.hasChild;
          if (!item.hasChild || item.hasChild == 0) temp.type = 'file';
          me.treeData.push(temp);
        });
      });
    },
    treeClick: function treeClick(node) {
      this.currentNode = node;
      this.selectNodeId = node.id;
      var nodedata = this.lanData.find(function (item) {return item.id == node.id;});
      this.setForm(nodedata);
    },
    setForm: function setForm(node) {
      this.clearForm();
      this.form.id = node.id;
      this.form.name = node.name;
      this.form.category = node.category;
      this.form.code = node.code;
      if (node.template) {
        this.form.template = node.template;
      } else if (node.data) {
        var data = {};
        try {
          data = JSON.parse(node.data);
        } catch (error) {
          console.log(error);
        } finally {
          this.form.template = data.template || '';
        }
      }
    },
    clearForm: function clearForm() {
      this.form = {
        name: "",
        category: "LanguagePack",
        template: "",
        id: "",
        code: "" };

    },
    createNode: function createNode(node) {
      this.multilangDialogVisible = true;
    },
    removeNode: function removeNode(node) {
      var me = this;
      if (!node) {
        me.mwMsg("warning", "请选择要删除的语言!");
        return;
      }
      me.mwConfirm('此操作将删除该记录, 是否继续?').then(function () {
        var ids = [node.id];
        me.mwApi.app.removeComponent(ids).then(function (data) {
          me.loadTreeData();
          me.mwMsg('删除成功!');
        });
      }).catch(function () {
      });
    },
    newLanguage: function newLanguage() {
      var me = this;
      if (!me.selectOption) {
        me.mwMsg("warning", "请选择一种语言");
        return;
      }
      var form = { category: "LanguagePack" };
      form.code = me.selectOption;
      form.name = me.optionsMap[me.selectOption];
      me.disabledNew = true;
      me.saveForm(form);
    },
    beforeCloseDialogVisible: function beforeCloseDialogVisible() {
      this.selectOption = '';
    },
    saveForm: function saveForm(form) {
      var me = this;
      var params = !form ? this.form : form;

      var hasData = false;
      _.each(me.lanData, function (item, i) {
        if (item.code == params.code) hasData = true;
      });
      if (hasData && form) {
        me.mwMsg("danger", "该语言已添加, 请重新选择!");
        if (!form) {me.disabledSave = false;} else
        {me.disabledNew = false;}
        return;
      }

      if (!form) {
        params.template = me.mwRef('formTemplate').getValue();
        me.disabledSave = true;
      }
      PF.invoke("s:multilang.srv.saveMultilang", params).then(function (r) {
        if (r.result) {
          me.multilangDialogVisible = false;
          if (!form) {
            me.disabledSave = false;
            _.each(me.lanData, function (item) {
              if (item.id == r.result.id) {
                item.template = r.result.template;
              }
            });
          } else {
            me.disabledNew = false;
            me.loadTreeData(r.result);
          }
          me.mwMsg("success", "保存成功!");
        } else {
          me.mwMsg("danger", "添加语言失败,请重试!");
        }
      });
    },
    handleMoreCommand: function handleMoreCommand(command) {
      var me = this;
      if (command === 'import') {
        this.mwRef('impDialog').show();
      }
      if (command === 'export') {
        me.exportNode(me.currentNode);
      }
    },
    import: function _import() {
      var me = this;
      me.mwRef("importData").submit();
    },
    impCancel: function impCancel() {
      this.mwRef('impDialog').hide();
    },
    importSuccessCallback: function importSuccessCallback(response, file, fileList) {
      if (response.result) {
        this.loadTreeData();
        this.mwRef('impDialog').hide();
      }
      this.mwRef("importData").clearFiles();
    },
    exportNode: function exportNode(node) {
      var me = this;
      if (!node) {
        me.mwMsg("warning", "请选择要导出的语言!");
        return;
      }
      var ids = [node.id];
      me.mwUtil.downloadAttachment(this.mwUrl("/api/app/expCompXml"), {}, false, PF.encode({ ids: ids }));
    },
    showHelp: function showHelp() {
      PF.showHelp({ url: '/helpDoc/platform/multilingual.md' });
    } } };

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =






























{
  components: {},


  data: function data() {
    var me = this;
    return {
      layout: [],
      contextMenuItem: [],
      defaultTreeParams: {},
      defaultParams: {},
      treeData: [],
      params: { "isAdmin": true },
      buttons: [],
      isFirstOpen: true };

  },
  mounted: function mounted() {
    var me = this;
    me.getTreeData();
    me.layout = [
    [{
      span: 0,
      type: 'menu',
      label: '回收站',
      api: 'process.listWaitDeleteDoc',
      defaultParams: me.params,
      defaultSort: [],
      nowrap: false,
      columns: [
      { type: 'selection', reserve: true },
      { label: '序号', width: '50', type: 'index' },
      { prop: 'businessName', label: '标题', tooltip: true },
      { prop: 'startUserName', label: '拟稿人', width: '90', tooltip: true },
      { prop: 'startTime', label: '拟稿时间', width: '160', tooltip: true },
      { prop: 'processDefinitionName', label: '流程定义名称', width: '170', tooltip: true },
      { prop: 'suspendTime', label: '删除时间', width: '160', tooltip: true }] },

    {
      span: 19,
      type: 'button',
      items: me.buttons,
      suffixSlot: "dropDown" },

    {
      span: 5,
      type: 'searchText',
      offset: 0,
      name: 'businessNameLike',
      tip: "标题" }]];


    me.mwRef('dataTable').mwRef('dataTable').$on("rendered", function (dataList, el) {
      if (me.mwRef('dataTable').mwRef('dataTable').filters.filter && me.mwRef('dataTable').mwRef('dataTable').filters.filter.businessNameLike) {
        me.params.moduleId = "";
      }
    });
  },
  methods: {
    getTreeData: function getTreeData() {
      var me = this;
      me.treeData = [];
      $.post(window.$servicePath + "/api/process/listWaitDeleteDocTree", { "isAdmin": true }, function (res) {

        var datas = res.result ? res.result : res;
        if (datas.length > 0) {
          me.treeData = datas;
        }
      });
    },
    changed: function changed(data) {
      var me = this;
      if (!data.id) {
        return;
      }
      me.params.moduleId = data.id;
      me.defaultParams.flag = true;
      if (this.mwRef('dataTable').mwRef('dataTable').filters.filter && this.mwRef('dataTable').mwRef('dataTable').filters.filter.businessNameLike) {
        this.mwRef('dataTable').mwRef('dataTable').filters.filter = {};
      }
      this.mwRef('dataTable').clearSelection();
      this.mwRef('dataTable').mwRef('dataTable').currentChange(1);


    },
    refreshTable: function refreshTable() {
      var me = this;
      me.getTreeData();
      me.mwRef("componentTree").refresh();
      if (this.mwRef('dataTable').mwRef('dataTable').filters.filter && this.mwRef('dataTable').mwRef('dataTable').filters.filter.businessNameLike) {
        this.mwRef('dataTable').mwRef('dataTable').filters.filter = {};
      }
    },
    removeData: function removeData() {
      var me = this;
      var dataTable = me.mwRef('dataTable');
      var multipleSelection = dataTable.getMultipleSelection();
      if (multipleSelection.length == 0) {
        this.mwMsg('warning', '请选择需要删除的数据!');
        return false;
      }
      me.mwConfirm($lang('记录删除后无法恢复，您确认是要删除？'), 'info', { type: 'warning' }).then(function () {
        var businesses = [];
        multipleSelection.forEach(function (t) {
          businesses.push({ businessId: t.businessId, draftsDocId: t.draftsDocId, batchId: t.batchId, formEntityKey: t.formEntityKey, moduleId: t.moduleId, moduleFullName: t.moduleFullName });
        });
        PF.api.process.batchMarkDelete(businesses).then(function (res) {
          if (res.success) {
            var ids = businesses.map(function (t) {return t.businessId;});
            var moduleFullName = businesses[0].moduleFullName;
            PF.invoke("sys-es-publish-service.docUnpublish", { ids: ids, catalogName: moduleFullName }).then(function (res) {});
            me.refreshTable();
          }
        });

      }).catch(function () {
      });

    },
    activate: function activate() {var _this = this;
      var me = this;
      var dataTable = me.mwRef('dataTable');
      var multipleSelection = dataTable.getMultipleSelection();
      if (multipleSelection.length == 0) {
        this.mwMsg('warning', '请选择需要恢复的数据!');
        return false;
      }
      var businesses = [];
      multipleSelection.forEach(function (t) {
        businesses.push({ businessId: t.businessId, draftsDocId: t.draftsDocId, batchId: t.batchId, formEntityKey: t.formEntityKey, moduleId: t.moduleId });
      });
      me.mwApi.process.batchActivateDocs(businesses).then(function (res) {
        if (res.success) {
          _this.mwMsg('message', '已恢复');
          me.refreshTable();
        }
      });
    },
    handleMoreCommand: function handleMoreCommand(command) {
      var me = this;
      if (command === 'import') {
        this.mwRef('impDialog').show();
      }
    } },



  watch: {} };

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =






































{
  data: function data() {var _this = this;
    var me = this;
    return {
      treeUrl: PF.getApplicationPath() + "/api/maintain/listTableCategory",
      defaultParams: {},
      layout: [],
      importProps: {
        action: '/api/maintain/importSqlTableData',
        autoUpload: true,
        showFileList: false,
        onSuccess: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(response) {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                    if (response && response.success) {
                      _this.mwMsg('导入成功');
                    } else {
                      _this.mwMsg('waring', response && response.msg || '导入失败');
                    }case 1:case 'end':return _context.stop();}}}, _callee, _this);}));function onSuccess(_x) {return _ref.apply(this, arguments);}return onSuccess;}(),

        onError: function onError(err, file, fileList) {
          _this.mwMsg('waring', '导入失败');
        } } };


  },
  created: function created() {
    var me = this;
    me.layout = [
    [{
      span: 0,
      type: 'menu',
      label: '数据清理及导出',
      api: '/#api/maintain/listTableData',
      defaultParams: { limit: 250 },
      defaultSort: [{ sort: 'sn', dir: 'desc' }],
      nowrap: false,
      columns: [
      { type: 'selection', reserve: true },
      { prop: 'cname', label: '表中文名称', tooltip: true, width: '250' },
      { prop: 'name', label: '表名', tooltip: true },
      { prop: 'count', label: '数据量', width: '150', tooltip: true }] },

    {
      span: 8,
      type: 'button',
      items: [{
        label: '数据删除',
        icon: 'fa fa-trash-o fa-fw',
        func: me.clearDatas }],
      suffixSlot: "more" }]];



  },
  methods: {
    handleCommand: function handleCommand(command) {
      if (command === 'export') {
        var data = this.mwRef('dataTable').getMultipleSelection();
        this.mwApi.maintain.exportSqlTableData(data);
      }
    },
    treeClick: function treeClick(data) {
      var params = this.mwRef('dataTable').defaultParams;
      this.mwRef('dataTable').clearSelection();
      params.pid = data.id;
      params.dataType = data.dataType || "";
      this.mwRef('dataTable').refreshTable();
    },

    clearDatas: function clearDatas(data) {
      var me = this;
      if (data.length == 0) {
        this.mwMsg('info', '请选择');
        return;
      }
      this.$confirm('确定要删除数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).
      then(function () {
        var ids = [];
        $.each(data, function (i, d) {
          ids.push(d.id);
        });
        PF.invoke("#api/maintain/clearTableData", ids).then(function (r) {
          me.mwRef('dataTable').refreshTable();
        });
      });
    } } };

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _extends3 = __webpack_require__(2);var _extends4 = _interopRequireDefault(_extends3);































































































































var _rightPanel = __webpack_require__(373);var _rightPanel2 = _interopRequireDefault(_rightPanel);
var _flowSelect = __webpack_require__(1246);var _flowSelect2 = _interopRequireDefault(_flowSelect);
var _unitSelect = __webpack_require__(1249);var _unitSelect2 = _interopRequireDefault(_unitSelect);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  data: function data() {
    return {
      filterForm: {
        flowStatus: "",
        suspensionState: "",
        year: "" + new Date().getFullYear(),
        processDefinition: {},
        draftsUnit: {},
        matchDept: false,
        businessName: "" },

      filterParams: {},


      dataList: [],

      pagination: {
        total: 0,
        start: 0,
        limit: 10 },


      orderBy: "",

      selection: [],

      rules: {} };


















  },

  mounted: function mounted() {},

  computed: {
    filterQuery: function filterQuery() {
      var query = [];
      if (this.filterForm.flowStatus) {
        query.push({
          source: "flowStatus",
          value: ["正在办理", "已办结", "已挂起"][this.filterForm.flowStatus] });

      }

      if (this.filterForm.year) {
        query.push({
          source: "year",
          value: this.filterForm.year });

      }

      if (
      this.filterForm.processDefinition &&
      this.filterForm.processDefinition.name)
      {
        query.push({
          source: "processDefinition",
          value: this.filterForm.processDefinition.name });

      }

      if (this.filterForm.draftsUnit && this.filterForm.draftsUnit.name) {
        query.push({
          source: "draftsUnit",
          value: this.filterForm.draftsUnit.name });

      }

      if (this.filterForm.businessName) {
        query.push({
          source: "businessName",
          value: this.filterForm.businessName });

      }
      if (this.filterForm.businessId) {
        query.push({
          source: "businessId",
          value: this.filterForm.businessId });

      }
      return query;
    } },


  methods: {
    handleRemoveQuery: function handleRemoveQuery(_ref) {var source = _ref.source;
      var emptyValue = "";
      switch (source) {
        case "processDefinition":
        case "draftsUnit":{
            emptyValue = {};
            break;
          }
        default:{
            emptyValue = "";
          }}

      this.filterForm = (0, _extends4.default)({}, this.filterForm, (0, _defineProperty3.default)({}, source, emptyValue));
    },
    updateTable: function updateTable() {
      if (!this.filterForm.businessName && !this.filterForm.businessId) {
        this.mwMsg("warning", "标题或业务ID不能为空!");
        return;
      }
      var params = {};
      _.assign(params, this.filterForm);
      this.filterParams = params;
    } },

  components: {
    FlowSelect: _flowSelect2.default,
    UnitSelect: _unitSelect2.default,
    mwFlowInterferingTable: _rightPanel2.default } };

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =








{
  props: {
    value: {
      type: Object,
      default: {} } },



  data: function data() {
    return {};

  },

  computed: {
    displayValue: function displayValue() {
      if (this.value) {
        if (this.value.name !== undefined) {
          return this.value.name;
        }
      }
      return "";
    } },


  methods: {
    open: function open() {

















      var me = this;
      PF.show('treeTable', {
        url: me.mwUrl("/api/app/listSystemApplicationTree"), treeDefaultParams: {},
        size: 'small_large', showTreeToolbar: false, defaultPercent: 50,
        selectFirst: true, asyncLoadOnce: true, clearBtn: false, title: '选择流程', changed: function changed(data) {
          this.defaultParams = { applicationId: data.id };
        }, api: 'process.listLatestDefinition', singleSelect: true, columns: [{ type: 'selection' },
        { prop: 'name', label: '名称', tooltip: true }] },
      function (res) {
        if (res && res.length > 0) {
          me.$emit('input', res[0]);
        }
      });
    },

    handleChange: function handleChange(val) {
      if (!val) {
        this.$emit('input', {});
      }
    } } };

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =






















{
  props: {
    value: {
      type: Object,
      default: {} } },



  data: function data() {
    return {

      checkNodes: [],
      btns: [
      {
        label: "确定",
        func: this.close }] };



  },
  computed: {
    deptTreeUrl: function deptTreeUrl() {

      if (!this.userInfo || !this.userInfo.developer) return this.mwUrl("/api/org/listDepartmentListAble");
      return this.mwUrl("/api/org/listDepartment");
    },
    displayValue: function displayValue() {
      if (this.value) {
        if (this.value.name !== undefined) {
          return this.value.name;
        }
      }
      return "";
    } },

  methods: {
    close: function close() {
      this.mwRef("zgDeptDialog").hide();
    },

    open: function open() {
      this.mwRef("zgDeptDialog").show();

















    },

    handleSelect: function handleSelect(data) {
      this.$emit("input", data);
    },
    handleChange: function handleChange(val) {
      if (!val) {
        this.$emit('input', {});
      }
    } } };

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);





















































var _navigator_form = __webpack_require__(1254);var _navigator_form2 = _interopRequireDefault(_navigator_form);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  components: { navigatorForm: _navigator_form2.default },
  data: function data() {
    var me = this;
    var appId = '';
    if (me.$route) {
      appId = me.$route.params.appId;
    } else if (me.params && me.params.appId) {
      appId = me.params.appId;
    }

    return {
      appId: appId,
      treeData: [],
      currentNode: "",
      treeContextMenu: [],
      rightMenu: [],
      treeListData: null,
      selectNodeId: "",
      importAction: '/api/app/impAppNavigatorTreeComp',
      impBtton: [{
        label: "取消",
        func: this.impCancel,
        type: "default" }],

      isFirstOpen: true };

  },
  props: {
    params: Object },

  mounted: function mounted() {
    var me = this;
    me.treeContextMenu = [{
      name: "新建",
      icon: 'fa fa-plus',
      label: '新建',
      func: function func(selectData, selectParent, item, a) {
        me.createNode(selectData);
      } },
    {
      name: "复制",
      icon: 'fa fa-copy',
      label: '复制',
      func: function func(selectData, selectParent, item, a) {
        me.copyNode(selectData);
      } },
    {
      name: "删除",
      icon: 'fa fa-remove',
      label: '删除',
      func: function func(selectData, selectParent, curBtn, item) {
        me.removeNode(selectData);
      } },
    {
      name: "导入",
      icon: 'fa x-icon-upload',
      label: '导入',
      func: function func(selectData, selectParent, curBtn, item) {
        me.mwRef('impDialog').show();
      } },
    {
      name: "导出",
      icon: 'fa x-icon-download',
      label: '导出',
      func: function func(selectData, selectParent, curBtn, item) {
        me.exportNode(selectData);
      } }];

    var contextMenu = PF.contextMenu({
      el: me.$refs.treeContainer,
      target: '.mw-tree-no-search__body',
      items: [{
        text: "新建",
        icon: "fa fa-new",
        handler: function handler() {
          me.createRoot();
        } }] });


    me.$on("hook:destroyed", function () {contextMenu.destroy();});
    me.loadTreeData();
  },
  methods: {
    showUpload: function showUpload() {
      if (this.isFirstOpen) {
        this.initUploader();
        this.isFirstOpen = false;
      }
    },
    initUploader: function initUploader() {
      var me = this;
      var cfg = {
        buttonId: me.mwRef('uploader').$el,
        maxSize: 500,
        action: me.importAction,
        accept: "xml" };

      var fn = {
        filesAdded: function filesAdded(up) {
        },
        fileUploaded: function fileUploaded(up, file, resp) {
          me.importSuccessCallback(resp, file, up);
        } };

      PF.initPupload(cfg, fn, function (up) {
        me.uploader = up;
        up.bind('FilesAdded', function (up, files) {
          up.setOption("multipart_params", { appId: me.appId, selNodeId: me.selectNodeId });
          up.start();
        });
      });
    },
    dragend: function dragend(e, data) {
      var me = this;
      var params = {};
      params.appId = me.appId;
      params.nodeId = data.node.id;
      params.position = data.position;
      params.oPosition = data.old_position;
      params.parentId = data.parent;
      params.oParentId = data.old_parent;
      me.mwApi.app.dragNavigatorTreeNode(params).then(function (res) {
        if (res.result) {
          me.treeData = res.result;
          setTimeout(function () {
            var tree = me.$refs.mwTree;
            tree.refreshTreeData(me.treeData);
            tree.setSelectNode(data.node.id);
          });
          me.$parent.$emit('updateTreeCount', {
            id: 'navigator_tree',
            length: me.treeData.length });

        }
      });
    },
    impCancel: function impCancel() {
      this.mwRef('impDialog').hide();
    },
    treeClick: function treeClick(node) {
      if (!node.icon) node.icon = '';
      if (!node.bgColor) node.bgColor = '';
      if (!node.authorityForm) node.authorityForm = [];
      this.currentNode = node;
      if (!node.children || node.children && node.children.length < 1) {
        delete this.currentNode.children;
      }
    },
    loadTreeData: function loadTreeData(selectedNode) {
      var me = this;
      me.mwApi.app.getNavigatorTree({ appId: this.appId }).then(function (res) {
        if (res.result && res.result.length > 0) {
          me.currentNode = !selectedNode ? res.result[0] : selectedNode;
          me.selectNodeId = me.currentNode.id;
        }
        me.treeData = res.result || [];
        me.$parent.$emit('updateTreeCount', {
          id: 'navigator_tree',
          length: me.treeData.length });

      });
    },
    refreshTree: function refreshTree() {

    },
    createNode: function createNode(selectData) {
      var me = this;
      if (!selectData || !selectData.id) {
        me.createRoot();
      } else {
        var tree = me.$refs.mwTree;
        var children = tree.getNode(selectData.id).children || [];
        var node = { text: "新链接", parentId: selectData.id, sn: children.length };
        me.currentNode = node;
      }
    },
    copyNode: function copyNode(selectData) {
      var me = this;
      if (!selectData || !selectData.id) return false;
      var tree = me.$refs.mwTree;
      me.mwApi.app.copyNavigatorTree(this.appId, selectData.id).then(function (res) {
        if (res.errMsg) {
          me.mwMsg("复制失败:" + res.errMsg);
        } else {
          me.treeData = res.result || [];
          tree.refreshTreeData(me.treeData);
          me.mwMsg("复制成功");
          me.$parent.$emit('updateTreeCount', {
            id: 'navigator_tree',
            length: me.treeData.length });

        }
      });
    },
    removeNode: function removeNode(selectData) {var _this = this;
      var me = this;
      PF.confirm($lang('删除此节点后将无法恢复,确定要继续吗？'), $lang('提示'), { type: 'warning' }).then(function () {
        var tree = me.$refs.mwTree;
        me.mwApi.app.removeNavigatorTree(_this.appId, selectData.id).then(function (res) {
          if (res.errMsg) {
            me.mwMsg("删除失败:" + res.errMsg);
          } else {
            me.treeData = res.result || [];
            tree.refreshTreeData(me.treeData);
            me.mwMsg("删除成功");
            me.$parent.$emit('updateTreeCount', {
              id: 'navigator_tree',
              length: me.treeData.length });

          }
        });
      });
    },
    createRoot: function createRoot() {
      var me = this;
      var sn = me.treeData.length;
      var node = { text: "新链接", id: '', sn: sn, category: 'link', name: '', exp: '', disable: '1', linkType: 'view', style: 'tree', unit: '1', dept: '0', targetId: '', parentId: '', nav: '1', target: '', way: '1' };
      me.currentNode = node;

    },
    showData: function showData() {
      var me = this;
      var data = me.$refs.mwTree.getTreeData();
      me.treeListData = data;
      me.mwRef('dataDialog').show();
    },
    afterSave: function afterSave(data, isNew) {
      var me = this;
      var tree = me.$refs.mwTree;
      if (isNew) {
        if (data.parentId) {
          me.treeData = me.fixedTreeNode(me.treeData, data.parentId, data);
          tree.createNode(data.parentId, data, 'last');

          tree.openNode(data.parentId);
        } else {
          var node = tree.createNode('#', data, 'last');
          me.treeData.push(data);

        }
        me.currentNode = data;
        me.loadTreeData(me.currentNode);
        me.$parent.$emit('updateTreeCount', {
          id: 'navigator_tree',
          length: me.treeData.length });

      } else {

        (0, _assign2.default)(me.currentNode, data);
        me.loadTreeData(me.currentNode);
      }
    },
    fixedTreeNode: function fixedTreeNode(treedata, parentId, pushInfo) {
      var me = this;
      var result = treedata;
      for (var i = 0; i < result.length; i++) {
        var isBreak = false;
        if (result[i].id == parentId) {
          result[i].children = result[i].children || [];
          result[i].children.push(pushInfo);
          break;
        } else if (result[i].children && result[i].children.length > 0) {
          result[i].children = me.fixedTreeNode(result[i].children, parentId, pushInfo);
        }
      }
      return result;
    },
    import: function _import() {
      var me = this;
      me.mwRef("importData").submit();
    },
    handleMoreCommand: function handleMoreCommand(command) {
      var me = this;
      if (command === 'import') {
        this.mwRef('impDialog').show();
      }
      if (command === 'export') {
        me.exportNode(me.currentNode);
      }
    },
    importSuccessCallback: function importSuccessCallback(response, file, fileList) {
      if (response.result) {
        this.loadTreeData();
        this.mwRef('impDialog').hide();
      }
    },
    getAllChildNodes: function getAllChildNodes(ids, pid, tree) {var _this2 = this;
      ids.push(pid);
      var children = tree.getNode(pid).children || [];
      if (children.length > 0) {
        children.forEach(function (val) {
          _this2.getAllChildNodes(ids, val, tree);
        });
      }
      return ids;
    },
    exportNode: function exportNode(selectData) {
      var ids = [];
      var tree = this.mwRef('mwTree');
      ids = this.getAllChildNodes(ids, selectData.id, tree);
      var par = { appId: this.appId, ids: ids };
      this.mwUtil.downloadAttachment(this.mwUrl("/api/app/expAppNavigatorTreeComp"), {}, false, PF.encode(par));
    } } };

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
































































































































































{
  props: ["node", "appId"],
  data: function data() {
    return {
      form: {
        category: "link",
        name: "",
        exp: "",
        disable: "1",
        linkType: "view",
        style: "tree",
        unit: "1",
        dept: "0",
        targetId: "",
        parentId: "",
        nav: "1",
        target: "",
        way: "1",
        icon: "",
        navHide: '0',
        ewcs: "",
        bgColor: "",
        authorityForm: [] },

      authorityForm: [{
        zdmc: '',
        zdmcstr: '',
        bjf: '',
        srz: '',
        srzstr: '',
        gxf: 'and' }],

      curzdmc: '',
      disabledSave: false,
      dialogFormVisible: false,
      dialogSelectVisible: false,
      scopeIndex: null,
      viewTarget: '',
      viewTargetId: '',
      pageTarget: '',
      pageTargetId: '',
      cateTarget: '',
      cateTargetId: '',
      innerTarget: '',
      innerTargetId: '',
      zdmcKv: {
        $loginId: '登陆ID',
        $userName: '用户名称',
        $roleNames: '身份权限',
        $D: '单位或部门(ID)' } };


  },
  mounted: function mounted() {
    var me = this;

    me.loadData();
    me.chageTarget();

    this.$nextTick(function (a) {
      $('.x-icon-chooser table td button').css('margin-right', '-53px');
      $('.x-icon-chooser table td button').addClass('el-button');
    });
















  },
  watch: {
    node: function node() {
      this.loadData();
    } },

  computed: {
    fwPath: function fwPath() {
      var path = void 0;
      var item = this.form;
      item.id = this.linkId;
      if (item.linkType == "inner") {

        path =
        "/dashboard/" + (
        this.appId || "【当前应用id】") +
        "/" +
        item.style +
        "/" + (
        item.id || "【当前树节点id】") +
        "/" +
        item.linkType +
        "/" + (
        item.id || "【当前树节点id】") +
        "/" +
        item.targetId;
      } else if (item.linkType == "view") {
        path =
        "/dashboard/" + (
        this.appId || "【当前应用id】") +
        "/" +
        item.style +
        "/" + (
        item.id || "【当前树节点id】") +
        "/" +
        item.linkType +
        "/" + (
        item.id || "【当前树节点id】");
      } else if (item.linkType == "page") {
        path =
        "/dashboard/" + (
        this.appId || "【当前应用id】") +
        "/" +
        item.style +
        "/" + (
        item.id || "【当前树节点id】") +
        "/" +
        item.linkType +
        "/" +
        item.targetId;
      } else {
        path =
        "/dashboard/" + (
        this.appId || "【当前应用id】") +
        "/" +
        item.style +
        "/" + (
        item.id || "【当前树节点id】") +
        "/" +
        item.linkType +
        "/index";
      }
      return path;

    },
    previewAuthory: function previewAuthory() {
      var result = '';
      var orexp = '';
      var andexp = '';
      this.authorityForm.forEach(function (item) {
        if (item.zdmc !== '$D') item.srz = item.srzstr;
        if (item.zdmc && item.bjf && item.srz && item.gxf) {
          if (item.zdmc == '$roleNames') {
            var roles = '';
            var roleArr = item.srz.split(',');
            roleArr.forEach(function (role, ri) {
              role = role.replace(/\'|\"|‘|“|’|”/g, '');
              if (role) roles += (ri !== 0 ? ',' : '') + '\'' + role + '\'';
            });
            if (roles) result = result + (item.bjf == '!=' ? '!' : '') + ("$contains($roleNames, " + roles + ")") + (item.gxf == 'and' ? '&&' : '||');
          } else if (item.zdmc == '$D') {
            if (item.bjf == '~~' || item.bjf == '!~~') {
              result = result + (item.bjf == '!~~' ? '!' : '') + ("$contains($deptIdChain, '" + item.srz + "')") + (item.gxf == 'and' ? '&&' : '||');
            } else {
              var srz = item.srz.replace(/\'|\"|‘|“|’|”/g, '');
              result = result + (item.bjf == '!=' ? '!' : '') + (item.zdmc + "('" + srz + "')") + (item.gxf == 'and' ? '&&' : '||');
            }
          } else {
            var _srz = item.srz.replace(/\'|\"|‘|“|’|”/g, '');
            result += item.zdmc + item.bjf + "'" + _srz + "'" + (item.gxf == 'and' ? '&&' : '||');
          }
        }
      });
      var bjf = result.substring(result.length - 2, result.length);
      if (bjf == '&&' || bjf == '||') {
        result = result.substring(0, result.length - 2);
      }
      return result;
    } },

  methods: {
    loadData: function loadData() {
      this.clearTarget();
      var defaultValue = {
        category: "link",
        name: "",
        exp: "",
        disable: "1",
        linkType: "view",
        style: "tree",
        unit: "1",
        dept: "0",
        targetId: "",
        parentId: "",
        nav: "1",
        target: "",
        ewcs: '',
        way: "1",
        navHide: "0" };

      if (this.node && this.node.text !== "新链接") {
        if (!this.node.children) {
          delete this.form.children;
        }
        (0, _assign2.default)(this.form, defaultValue);
        (0, _assign2.default)(this.form, this.node);
      } else {
        var newForm = {};
        (0, _assign2.default)(newForm, defaultValue);
        this.form = (0, _assign2.default)(newForm, this.node);
      }
      this.chageTarget();
    },
    linkTypeChange: function linkTypeChange(v) {
      var me = this;
      if (me.form.linkType == 'view') {
        this.form.target = this.viewTarget;
        this.form.targetId = this.viewTargetId;
      } else if (me.form.linkType == 'page') {
        this.form.target = this.pageTarget;
        this.form.targetId = this.pageTargetId;
      } else if (me.form.linkType == 'cate') {
        this.form.target = this.cateTarget;
        this.form.targetId = this.cateTargetId;
      } else if (me.form.linkType == 'inner') {
        this.form.target = this.innerTarget;
        this.form.targetId = this.innerTargetId;
      }
    },
    selectTarget: function selectTarget() {
      var me = this;
      if (me.form.linkType == "view") {

        var checkNodes;
        if (me.form.targetId) {
          checkNodes = me.form.targetId.split(",");
        }

        PF.show(
        "treeTable",
        {
          url: this.mwUrl("/api/app/listApplicationTree"),
          size: "small_large",
          treeDefaultParams: { category: "view" },
          selectFirst: false,
          clearBtn: false,
          title: "选择视图",
          changed: function changed(data) {
            var me = this;
            me.defaultParams = { sysId: me.appId, code: data.code, category: "view", applicationId: data.id };
          },
          api: "app.getAppModuleItems",
          singleSelect: false },

        function (res) {
          if (res) {
            var targets = [];
            var targetIds = [];
            res.forEach(function (item) {
              targets.push(item.name);
              targetIds.push(item.id);
            });
            me.form.targetId = targetIds.join();
            me.form.target = targets.join();
            me.chageTarget();
          }
        });

      }

      if (me.form.linkType == "page") {
        PF.show(
        "treeTable",
        {
          url: this.mwUrl("/api/app/listApplicationTree"),
          size: "small_large",
          treeDefaultParams: { category: "page" },
          selectFirst: false,
          clearBtn: false,
          title: "选择页面",
          changed: function changed(data) {
            var me = this;
            me.defaultParams = { sysId: me.appId, code: data.code, category: "page", applicationId: data.id };
          },
          api: "app.getAppModuleItems",
          singleSelect: true },

        function (res) {
          if (res && res.length > 0) {
            me.form.targetId = res[0].id;
            me.form.target = res[0].name;
          } else {
            me.form.targetId = "";
            me.form.target = "";
          }
          me.chageTarget();
        });

      }

      if (me.form.linkType == "inner") {

        PF.show(
        "tree",
        {
          treeData: [
          {
            id: $uuid(),
            text: "组织人员",
            hasChild: 6,
            children: [
            {
              id: "systemSet_org_user",
              text: "组织成员",
              type: "file" },

            {
              id: "systemSet_org_group",
              text: "角色管理",
              type: "file" },

            {
              id: "systemSet_org_roleList",
              text: "角色管理(列表)",
              type: "file" },

            {
              id: "systemSet_org_role",
              text: "权限定义",
              type: "file" },

            {
              id: "systemSet_org_InvalidUser",
              text: "无效用户",
              type: "file" },
            {
              id: "systemSet_org_full_auth",
              text: "全权代办",
              type: "file" },

            {
              id: "systemSet_org_groups",
              text: "群组管理",
              type: "file" },

            {
              id: "systemSet_org_outerOrg",
              text: "外部单位",
              type: "file" },

            {
              id: "systemSet_recycleBin",
              text: "回收站",
              type: "file" }] },



          {
            id: $uuid(),
            text: "配置管理",
            hasChild: 8,
            children: [
            {
              id: "systemSet_org_dataDic",
              text: "数据字典",
              type: "file" },

            {
              id: "systemSet_worktime",
              text: "工作时间",
              type: "file" },

            {
              id: "systemSet_script",
              text: "动作脚本",
              type: "file" },

            {
              id: "systemSet_flow",
              text: "流程配置",
              type: "file" },

            {
              id: "systemSet_multilingual",
              text: "语言管理",
              type: "file" },

            {
              id: 'systemSet_navigator',
              text: "导航设置",
              type: "file" }] },



          {
            id: $uuid(),
            text: "维护管理",
            hasChild: 2,
            children: [
            {
              id: "clear_data_or_exp_impl",
              text: "数据清理及导出",
              type: "file" },

            {
              id: "systemSet_flowInterfering",
              text: "流程干预",
              type: "file" }] },



          {
            id: $uuid(),
            text: "日志管理",
            hasChild: 4,
            children: [
            {
              id: 'systemSet_log_operationLog',
              text: '管理日志',
              type: "file" },

            {
              id: 'systemSet_log_personalLog',
              text: '操作日志',
              type: "file" },

            {
              id: 'systemSet_log_flowLog',
              text: '流程日志',
              type: "file" },

            {
              id: 'systemSet_log_loginLog',
              text: '登录日志',
              type: "file" }] }],




          selectFirst: false,
          title: "选择内置视图",
          size: "mini_large",
          multiple: false,
          search: true,
          async: false,
          singleLeaf: true },

        function (res) {
          if (res) {
            me.form.targetId = res.id;
            me.form.target = res.text;
            me.chageTarget();
          }
        });

      }
    },
    selectIcon: function selectIcon() {
      var me = this;

    },
    save: function save() {
      var me = this;
      me.disabledSave = true;
      if (me.form.name == "") {
        me.mwMsg("warning", "请输入名称");
        return;
      }
      var isNew = false;
      var data = {};
      (0, _assign2.default)(data, me.node);

      (0, _assign2.default)(data, me.form);
      data.text = data.name;

      if (data.id && data.parentId) delete me.form.id;
      if (!data.id) {
        data.id = $uuid();
        isNew = true;
      }

      me.mwApi.app.saveNavigatorTree(me.appId, data).then(function (res) {
        if (res.result) {
          me.$emit("afterSave", res.result, isNew);
          me.mwMsg("保存成功");
        } else {
          me.mwMsg("保存失败:" + res.errMsg);
        }
        me.disabledSave = false;
      });
    },
    getPath: function getPath() {
      var path = void 0;
      var item = this.form;
      item.id = this.linkId;
      if (item.linkType == "inner") {

        path = "/dashboard/" + (this.appId || "【当前应用id】") + "/" +
        item.style + "/" + (item.id || "【当前树节点id】") + "/" +
        item.linkType + "/" + (item.id || "【当前树节点id】") + "/" + item.targetId;
      } else if (item.linkType == "view") {
        path =
        "/dashboard/" + (
        this.appId || "【当前应用id】") +
        "/" +
        item.style +
        "/" + (
        item.id || "【当前树节点id】") +
        "/" +
        item.linkType +
        "/" + (
        item.id || "【当前树节点id】");
      } else if (item.linkType == "page") {
        path =
        "/dashboard/" + (
        this.appId || "【当前应用id】") +
        "/" +
        item.style +
        "/" + (
        item.id || "【当前树节点id】") +
        "/" +
        item.linkType +
        "/" +
        item.targetId;
      } else {
        path =
        "/dashboard/" + (
        this.appId || "【当前应用id】") +
        "/" +
        item.style +
        "/" + (
        item.id || "【当前树节点id】") +
        "/" +
        item.linkType +
        "/index";
      }
      alert(path);
    },
    helpnotes: function helpnotes(type) {
      var mdurl = '/helpDoc/platform/navigator.md';
      if (type == 'auth') mdurl = '/helpDoc/platform/authory.md';
      PF.showHelp({ url: mdurl });
    },
    chageTarget: function chageTarget() {
      if (!this.form.target) return;
      if (this.form.linkType == 'view') {
        this.viewTarget = this.form.target;
        this.viewTargetId = this.form.targetId;
      } else if (this.form.linkType == 'page') {
        this.pageTarget = this.form.target;
        this.pageTargetId = this.form.targetId;
      } else if (this.form.linkType == 'cate') {
        this.cateTarget = this.form.target;
        this.cateTargetId = this.form.targetId;
      } else if (this.form.linkType == 'inner') {
        this.innerTarget = this.form.target;
        this.innerTargetId = this.form.targetId;
      }
    },
    clearTarget: function clearTarget() {
      this.viewTarget = '';
      this.viewTargetId = '';
      this.pageTarget = '';
      this.pageTargetId = '';
      this.cateTarget = '';
      this.cateTargetId = '';
      this.innerTarget = '';
      this.innerTargetId = '';
    },
    setFormExp: function setFormExp() {
      if (this.form && this.form.authorityForm && this.form.authorityForm.length > 0) {
        this.authorityForm = this.form.authorityForm;
      }
      this.dialogFormVisible = true;
    },
    clearFormExp: function clearFormExp() {
      this.form.exp = '';
      this.form.authorityForm = [];
      this.authorityForm = [{
        zdmc: '',
        zdmcstr: '',
        bjf: '',
        srz: '',
        srzstr: '',
        gxf: 'and' }];

    },
    setAuthory: function setAuthory() {
      this.form.exp = this.previewAuthory;
      this.form.authorityForm = this.authorityForm;
      this.closeAuthory();
    },
    addAuthory: function addAuthory() {
      this.authorityForm.push({
        zdmc: '',
        zdmcstr: '',
        bjf: '',
        srz: '',
        srzstr: '',
        gxf: 'and' });

    },
    closeAuthory: function closeAuthory() {
      this.authorityForm = [{
        zdmc: '',
        zdmcstr: '',
        bjf: '',
        srz: '',
        srzstr: '',
        gxf: 'and' }];

      this.dialogFormVisible = false;
    },
    selectZdmc: function selectZdmc(authoryItem, scopeIndex) {
      authoryItem.bjf = '';
      authoryItem.srz = '';
      authoryItem.srzstr = '';
      this.scopeIndex = scopeIndex;
      this.dialogSelectVisible = true;
    },
    setCurzdmc: function setCurzdmc() {

      if (this.scopeIndex !== null && this.curzdmc) {
        this.authorityForm[this.scopeIndex].zdmc = this.curzdmc;
        this.authorityForm[this.scopeIndex].zdmcstr = this.zdmcKv[this.curzdmc] || '';
      }
      this.clearCurzdmc();
      this.dialogSelectVisible = false;
    },
    clearCurzdmc: function clearCurzdmc() {
      this.curzdmc = '';
      this.scopeIndex = null;
    },
    selectDept: function selectDept(authoryItem, scopeIndex) {var _this = this;
      var selectNode = this.authorityForm[scopeIndex].srz ? this.authorityForm[scopeIndex].srz : '';
      var defaultParams = {};
      if (!this.userInfo || !this.userInfo.developer) defaultParams.listAble = true;
      PF.show('tree', {
        url: this.mwUrl("/api/org/listDepartmentTree"),
        defaultParams: defaultParams,
        selectNode: selectNode,
        types: {
          "1": {
            "icon": "fa fa-folder" },

          "2": {
            "icon": "fa fa-leaf" },

          "3": {
            "icon": "fa fa-users" },

          'default': {
            "icon": "fa fa-leaf" } },


        search: false,
        multiple: false,
        singleLeaf: false,
        clearBtn: true },
      function (res) {
        if (scopeIndex !== null) {
          _this.authorityForm[scopeIndex].srz = !res ? '' : res.id;
          _this.authorityForm[scopeIndex].srzstr = !res ? '' : res.name;
        }
      });
    } } };

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });















































































































































var _token = __webpack_require__(25);var _token2 = _interopRequireDefault(_token);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  components: {},


  props: {
    params: {
      type: Object } },



  data: function data() {
    var me = this;
    return {
      layout: [],
      headers: {},
      treeUrl: this.mwUrl("/api/business/listLoginTree"),
      selectNode: "",
      finishDate: '',
      startDate: '',

      leadButton: [
      {
        label: "确定",
        func: this.leadSure },
      {
        label: "取消",
        type: "default",
        func: this.closeLeadDialog }],



      form: {},



      pickerBeginDateBefore: {
        disabledDate: function disabledDate(time) {
          if (me.finishDate != '') {
            return time.getTime() > me.finishDate;
          }
        } },


      pickerBeginDateAfter: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < me.startDate;
        } } };


  },

  mounted: function mounted() {
    var me = this;
    me.headers.Authorization = _token2.default.getToken();
    var defaultParams = [];
    if (me.params && me.params.requestParams) {
      defaultParams = me.params.requestParams;
    }
    me.layout = [
    [
    {
      span: 0,
      type: "menu",
      label: "登录日志",
      api: "business.listLoginLog",
      singleSelect: true,
      defaultParams: defaultParams,
      showRowExpander: true,
      columns: [
      { prop: "org", label: "组织", tooltip: true, formatter: me.orgFormatter },
      { prop: "userName", label: "登录人", tooltip: true, width: '80' },
      { prop: "userLoginId", label: "登录人账号", tooltip: true, width: '100' },
      { prop: "lastLoginTime", label: "最后登录时间", tooltip: true, width: '160' },
      { prop: "accessType", label: "最后登录方式", tooltip: true, width: '120' },
      { prop: "loginTimes", label: "今日登录次数", tooltip: true, width: '110' },
      { prop: "userAgent", label: "在线", tooltip: true, formatter: me.statusFormatter, width: '60' }] },


    {
      span: 10,
      type: "button",
      items: [
      {
        label: "导出",
        icon: "fa fa-plus-square",
        func: me.lead }] },



    {
      span: 6,
      type: "searchText",
      name: "userName",
      tip: "登录人",
      offset: 8 }]];



    if (this.params && this.params.isSaveQueryLog == true)
    me.saveQueryLog();
  },

  methods: {
    expand: function expand() {
      this.mwRef('logTree').openAll();
    },
    closed: function closed() {
      this.mwRef('logTree').closeAll();
    },
    rowExpanded: function rowExpanded(row, el) {
      var me = this;
      var par = { userId: row.userId, date: row.createYearMonthDay };
      if (me.params && me.params.requestParams && me.params.requestParams.excludeClientIP) {
        par.excludeClientIP = me.params.requestParams.excludeClientIP;
      }
      PF.ajax("api/business/listUserLog", par).then(function (data) {
        var html = "<table class=\"inner_table\" width=\"100%\">\n        <tr>\n          <th>\u767B\u5F55\u65F6\u95F4</th>\n          <th>\u767B\u5F55\u65B9\u5F0F</th>\n          <th>\u767B\u5F55IP</th>\n          <th>\u6D4F\u89C8\u5668\u7C7B\u578B</th>\n        </tr>";






        if (data.result) {
          data.result.forEach(function (v) {
            html += "<tr><td>" + v.createTime + "</td><td>" + v.accessType + "</td><td>" + v.clientIP + "</td><td>" + me.userAgentFormatter(row, undefined, v.userAgent) + "</td></tr>";
          });
        }
        html += "</table>";
        $(el).html(html);
      });
    },

    loadTableTree: function loadTableTree(data) {
      this.selectNode = data.id;
      var params = _.assign({ id: data.id }, this.params && this.params.requestParams);
      this.mwRef("dataTable").refreshTableDefaultParams(params);
    },
    statusFormatter: function statusFormatter(v) {var h = this.$createElement;
      if (v.status == 1) {
        return h("span", { "class": "fa fa-eye", style: "color:#238E23", attrs: { title: "\u5728\u7EBF" } });
      } else {
        return h("span", { "class": "fa fa-eye", style: "color:#ccc", attrs: { title: "\u79BB\u7EBF" } });
      }
    },
    orgFormatter: function orgFormatter(v) {
      var org = "";
      org = (v.unit ? v.unit : "") + "-" + (v.department ? v.department : "");
      if (!v.unit && !v.department) {
        org = "";
      }
      return org;
    },
    userAgentFormatter: function userAgentFormatter(data, c, userAgent) {

      if (userAgent == null) return "";

      var start = userAgent.indexOf("(");
      userAgent = userAgent.substring(start, userAgent.length);
      var os = "Windows";
      var bit = "32位";
      var brower = "";
      if (userAgent.indexOf("Windows NT 5.0") != -1) {
        os = "Win2000";
      } else if (userAgent.indexOf("Windows NT 5.1") != -1 || userAgent.indexOf("Windows XP") != -1) {
        os = "WinXP";
      } else if (userAgent.indexOf("Windows NT 5.2") != -1) {
        os = "Win2003";
      } else if (userAgent.indexOf("Windows NT 6.0") != -1) {
        os = "Win2008";
      } else if (userAgent.indexOf("Windows NT 6.1") != -1) {
        os = "Win7";
      } else if (userAgent.indexOf("Windows NT 6.2") != -1) {
        os = "Win8";
        if (userAgent.indexOf("ARM;") != -1) {
          os = "WinRT";
        }
      } else if (userAgent.indexOf("Windows NT 6") != -1) {
        os = "WinVista";
      } else if (userAgent.indexOf("Linux") != -1) {
        os = "Linux";
      } else if (userAgent.indexOf("Mac") != -1) {
        os = "Mac";
      }
      if (userAgent.indexOf("WOW64") != -1 || userAgent.indexOf("_64") != -1 || userAgent.indexOf("X64") != -1 || userAgent.indexOf("x64") != -1) {
        bit = "64位";
      }

      if (userAgent.indexOf("MSIE") != -1) {
        brower = "IE";
        var start = userAgent.indexOf("MSIE");
        var end = userAgent.indexOf(";", start);
        brower = brower + userAgent.substring(start + 5, end);
      } else if (userAgent.indexOf("rv:") != -1 && userAgent.indexOf("Firefox") == -1) {
        brower = "IE";
        var start = userAgent.indexOf("rv:");
        var end = userAgent.indexOf(")", start);
        brower = brower + userAgent.substring(start + 3, end);
      } else if (userAgent.indexOf("Firefox") != -1) {
        brower = "Firefox";
        var start = userAgent.indexOf("Firefox/");
        brower = brower + userAgent.substring(start + "Firefox".length + 1, userAgent.length);
      } else if (userAgent.indexOf("Chrome") != -1) {
        brower = "Chrome";
        var start = userAgent.indexOf("Chrome/");
        var end = userAgent.indexOf(".", start);
        end = userAgent.indexOf(".", end + 1);
        brower = brower + userAgent.substring(start + "Chrome".length + 1, end);
      } else if (userAgent.indexOf("Safari") != -1) {

        brower = "Safari";
        var start = userAgent.indexOf("Version/");
        var end = userAgent.indexOf(" ", start);
        brower = brower + userAgent.substring(start + "Version".length + 1, end);
      }

      return brower;
    },

    typeFormatter: function typeFormatter(data, c, v) {
      if (v === -1) {
        return '登录异常';
      } else if (v === 1) {
        if (data.loginId) {
          return '登录验证';} else
        {
          return '切换单位';
        }
      } else if (v === 2) {
        return '登录';
      } else {
        return '退出';
      }
    },

    lead: function lead() {
      this.mwRef("leadDialog").show();
    },

    closeLeadDialog: function closeLeadDialog() {
      this.mwRef("leadDialog").hide();
    },

    closeEditDialog: function closeEditDialog() {
      this.mwRef('editDialog').hide();
    },

    edit: function edit(row, index) {var _this = this;
      this.mwApi.business.getLoginLog(row.id).then(function (res) {
        _this.mwRef('editDialog').show();
        _this.form = res.result;
      });
    },

    closeDialog: function closeDialog(a) {
      this.mwRef(a).hide();
    },
    leadSure: function leadSure() {
      var me = this;
      if (!me.startDate && !me.finishDate) {
        me.mwMsg("warning", '请选择开始时间或结束时间!');
        return;
      }
      var params = {};
      if (me.startDate)
      params.startDate = new moment(me.startDate).format("YYYY-MM-DD HH:mm:ss");
      if (me.finishDate)
      params.finishDate = new moment(me.finishDate).format("YYYY-MM-DD HH:mm:ss");
      if (me.params && me.params.requestParams && me.params.requestParams.includeUsers)
      params.includeUsers = me.params.requestParams.includeUsers;
      if (me.params && me.params.requestParams && me.params.requestParams.excludeUsers)
      params.excludeUsers = me.params.requestParams.excludeUsers;
      if (me.params && me.params.requestParams && me.params.requestParams.threeMemberType)
      params.threeMemberType = me.params.requestParams.threeMemberType;
      if (me.params && me.params.requestParams && me.params.requestParams.notThreeMemberType)
      params.notThreeMemberType = me.params.requestParams.notThreeMemberType;
      if (me.params && me.params.requestParams && me.params.requestParams.excludeClientIP)
      params.excludeClientIP = me.params.requestParams.excludeClientIP;
      this.mwApi.business.expLoginLog(params);
      this.closeLeadDialog();
    },

    saveQueryLog: function saveQueryLog() {
      var dataTable = this.mwRef("dataTable").mwRef("dataTable");
      var tableObj = this.mwRef("dataTable");
      tableObj.$on("dataLoaded", function (d) {
        var total = d ? d.length : 0;
        if (tableObj.isSearch) {
          var rm = "共查询到" + total + "条记录";
          var params = {
            flag: "列表查询",
            targetName: '日志管理-登陆注销日志',
            remark: rm,
            objType: '日志',
            target: '功能',
            eventType: '三员管理操作',
            zycd: "一般",
            result: rm };

          PF.invoke("sys-log-service.saveOprLog", params);
        }
      });
    } },

  watch: {} };

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });





















































































































































































































































var _token = __webpack_require__(25);var _token2 = _interopRequireDefault(_token);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  components: {},


  props: {
    params: {
      type: Object } },



  data: function data() {
    var me = this;
    return {
      layout: [],
      headers: {},
      dictTreeUrl: this.mwUrl("/api/business/listPersonalLogTree"),
      selectNode: "",
      finishDate: '',
      startDate: '',
      leadButton: [
      {
        label: "确定",
        func: this.leadSure },
      {
        label: "取消",
        type: "default",
        func: this.closeLeadDialog }],


      findButton: [
      {
        label: "确定",
        func: function func() {
          var startTime = me.findOptions.createTime;
          var endTime = me.findOptions.finishTime;
          if (startTime)
          me.findOptions.createTime = new moment(startTime).format("YYYY-MM-DD HH:mm:ss");else

            delete me.findOptions.createTime;
          if (endTime)
          me.findOptions.finishTime = new moment(endTime).format("YYYY-MM-DD HH:mm:ss");else

            delete me.findOptions.finishTime;
          me.findOptions.start = 0;
          me.findOptions.limit = 10;
          if (me.params && me.params.requestParams && me.params.requestParams.includeUsers)
          me.findOptions.includeUsers = me.params.requestParams.includeUsers;
          if (me.params && me.params.requestParams && me.params.requestParams.excludeUsers)
          me.findOptions.excludeUsers = me.params.requestParams.excludeUsers;
          if (me.params && me.params.requestParams && me.params.requestParams.threeMemberType)
          me.findOptions.threeMemberType = me.params.requestParams.threeMemberType;
          if (me.params && me.params.requestParams && me.params.requestParams.notThreeMemberType)
          me.findOptions.notThreeMemberType = me.params.requestParams.notThreeMemberType;
          if (me.params && me.params.requestParams && me.params.requestParams.excludeClientIP)
          if (me.params && me.params.requestParams && me.params.requestParams.type)
          me.findOptions.type = me.params.requestParams.type;
          me.findOptions.excludeClientIP = me.params.requestParams.excludeClientIP;

          me.mwRef("dataTable").refreshTableDefaultParams(me.findOptions);

          me.closeFindDialog();
        } },

      {
        label: "取消",
        type: "default",
        func: this.closeFindDialog }],


      api: "",
      form: {},


      findOptions: {},
      pickerBeginDateBefore: {
        disabledDate: function disabledDate(time) {
          if (me.finishDate != '') {
            return time.getTime() > me.finishDate;
          }
        } },

      pickerBeginDateAfter: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < me.startDate;
        } } };


  },

  mounted: function mounted() {
    var me = this;
    me.headers.Authorization = _token2.default.getToken();
    var defaultParams = [];
    if (me.params && me.params.requestParams) {
      defaultParams = me.params.requestParams;
    }
    me.layout = [
    [
    {
      span: 0,
      type: "menu",
      label: "个人操作日志",
      api: "business.listPersonalLog",
      defaultParams: defaultParams,
      singleSelect: true,
      columns: [
      { type: "selection" },
      { prop: "createTime",
        label: "操作时间", width: 160 },
      { slot: { type: 'href', func: me.edit }, prop: "userName", label: "操作用户", width: 80, format: function format(row, cell, cellValue) {
          return !cellValue ? "自动操作" : cellValue;
        } },
      { prop: "userLoginId", label: "操作用户账号", width: 110 },
      { prop: "name", label: "功能名称", width: 120, tooltip: true },
      { prop: "type", label: "操作类型", width: 180 },





      {
        prop: "optResult",
        label: "操作结果",
        tooltip: true },

      { prop: "clientIP", label: "操作人IP", width: 120 },
      { prop: "objType", label: "操作对象类型", width: 180 },
      { prop: "eventType", label: "事件类型", width: 180 },
      { prop: "importantDegree", label: "重要程度", width: 80 }] },


    {
      span: 10,
      type: "button",
      items: [
      {
        label: "导出",
        icon: "fa fa-plus-square",
        func: me.lead },

      {
        label: "查询",
        icon: "fa fa-search",
        func: me.findInf }] },



    {
      span: 6,
      type: "searchText",
      name: "name",
      tip: "操作用户",
      offset: 8 }]];




    me.mwRef("dataTable").mwRef("dataTable").search = function (filters) {
      if (filters.name) {
        var param = { filter: { name: filters.name } };
        if (me.params && me.params.requestParams && me.params.requestParams.excludeClientIP) {
          param.excludeClientIP = me.params.requestParams.excludeClientIP;
        }
        if (me.params && me.params.requestParams && me.params.requestParams.threeMemberType)
        param.threeMemberType = me.params.requestParams.threeMemberType;
        if (me.params && me.params.requestParams && me.params.requestParams.notThreeMemberType)
        param.notThreeMemberType = me.params.requestParams.notThreeMemberType;
        if (me.params && me.params.requestParams && me.params.requestParams.type)
        param.type = me.params.requestParams.type;
        me.mwRef("dataTable").refreshTableDefaultParams(param);
      } else {
        var param = { id: me.selectNode };
        if (me.params && me.params.requestParams && me.params.requestParams.excludeClientIP) {
          param.excludeClientIP = me.params.requestParams.excludeClientIP;
        }
        if (me.params && me.params.requestParams && me.params.requestParams.threeMemberType)
        param.threeMemberType = me.params.requestParams.threeMemberType;
        if (me.params && me.params.requestParams && me.params.requestParams.notThreeMemberType)
        param.notThreeMemberType = me.params.requestParams.notThreeMemberType;
        if (me.params && me.params.requestParams && me.params.requestParams.type)
        param.type = me.params.requestParams.type;
        me.mwRef("dataTable").refreshTableDefaultParams(param);
      }
    };
    me.mwRef("dataTable")._paramsChange = function (params) {
      if (!params.filter || !params.filter.name)
      me.mwRef("dataTable").clearFilters();
      if (me.mwRef("dataTable").defaultParamsChange) {
        me.mwRef("dataTable")._refreshTable();
      } else {
        me.mwRef("dataTable").defaultParamsChange = false;
      }
    };
    if (this.params && this.params.isSaveQueryLog == true)
    me.saveQueryLog();
  },

  methods: {

    loadTableTree: function loadTableTree(data) {
      this.selectNode = data.id;
      var params = _.assign({ id: data.id }, this.params && this.params.requestParams);
      this.mwRef("dataTable").refreshTableDefaultParams(params);
    },

    lead: function lead() {
      var me = this;
      me.startDate = "";
      me.finishDate = "";
      this.mwRef("leadDialog").show();
    },

    leadSure: function leadSure() {
      var me = this;
      if (!me.startDate && !me.finishDate) {
        me.mwMsg("warning", '请选择开始时间或结束时间!');
        return;
      }
      var params = {};
      if (me.startDate)
      params.startDate = new moment(me.startDate).format("YYYY-MM-DD HH:mm:ss");
      if (me.finishDate)
      params.finishDate = new moment(me.finishDate).format("YYYY-MM-DD HH:mm:ss");

      if (me.params && me.params.requestParams && me.params.requestParams.includeUsers)
      params.includeUsers = me.params.requestParams.includeUsers;
      if (me.params && me.params.requestParams && me.params.requestParams.excludeUsers)
      params.excludeUsers = me.params.requestParams.excludeUsers;
      if (me.params && me.params.requestParams && me.params.requestParams.threeMemberType)
      params.threeMemberType = me.params.requestParams.threeMemberType;
      if (me.params && me.params.requestParams && me.params.requestParams.notThreeMemberType)
      params.notThreeMemberType = me.params.requestParams.notThreeMemberType;
      if (me.params && me.params.requestParams && me.params.requestParams.excludeClientIP)
      params.excludeClientIP = me.params.requestParams.excludeClientIP;
      if (me.params && me.params.requestParams && me.params.requestParams.type)
      params.type = me.params.requestParams.type;
      this.mwApi.business.expPersonalLog(params);
      this.closeLeadDialog();
    },
    closeLeadDialog: function closeLeadDialog() {
      this.startDate = "";
      this.finishDate = "";
      this.mwRef("leadDialog").hide();
    },

    closeFindDialog: function closeFindDialog() {
      this.findOptions = {};
      this.mwRef('findDialog').hide();
    },

    findInf: function findInf() {
      this.mwRef("findDialog").show();
    },
    refresh: function refresh() {
      this.mwRef("dictTree").refresh();
    },

    edit: function edit(row) {var _this = this;
      this.mwApi.business.getPersonalLog(row.id).then(function (res) {
        _this.mwRef('editDialog').show();
        _this.form = res.result;
      });
    },

    editSure: function editSure() {
      this.closeEditDialog();
    },
    closeEditDialog: function closeEditDialog() {
      this.mwRef('editDialog').hide();
    },

    expand: function expand() {
      this.mwRef('dictTree').openAll();
    },
    closed: function closed() {
      this.mwRef('dictTree').closeAll();
    },
    format: function format(date) {
      if (!(date instanceof Date)) {
        return '';
      }
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var min = date.getMinutes();
      var second = date.getSeconds();
      month = (month >= 10 ? "" : "0") + month;
      day = (day >= 10 ? "" : "0") + day;
      hour = (hour >= 10 ? "" : "0") + hour;
      min = (min >= 10 ? "" : "0") + min;
      second = (second >= 10 ? "" : "0") + second;
      return year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + second;
    },
    saveQueryLog: function saveQueryLog() {
      var dataTable = this.mwRef("dataTable").mwRef("dataTable");
      var tableObj = this.mwRef("dataTable");
      tableObj.$on("dataLoaded", function (d) {
        var total = d ? d.length : 0;
        if (tableObj.isSearch) {
          var rm = "共查询到" + total + "条记录";
          var params = {
            flag: "列表查询",
            targetName: '日志管理-业务操作日志',
            remark: rm,
            objType: '日志',
            target: '功能',
            eventType: '三员管理操作',
            zycd: "一般",
            result: rm };

          PF.invoke("sys-log-service.saveOprLog", params);
        }
      });
    } },


  watch: {} };

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });































































































































































































var _token = __webpack_require__(25);var _token2 = _interopRequireDefault(_token);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  components: {},


  props: {
    params: {
      type: Object } },



  data: function data() {
    var me = this;
    return {
      layout: [],
      headers: {},
      dictTreeUrl: this.mwUrl("/api/business/listOperationTree"),
      selectNode: "",
      finishDate: '',
      startDate: '',
      leadButton: [
      {
        label: "确定",
        func: this.leadSure },
      {
        label: "取消",
        type: "default",
        func: this.closeLeadDialog }],


      findButton: [
      {
        label: "确定",
        func: function func() {
          var startTime = me.findOptions.createTime;
          var finishTime = me.findOptions.finishTime;
          if (startTime)
          me.findOptions.createTime = new moment(startTime).format("YYYY-MM-DD HH:mm:ss");else

            delete me.findOptions.createTime;
          if (finishTime)
          me.findOptions.finishTime = new moment(finishTime).format("YYYY-MM-DD HH:mm:ss");else

            delete me.findOptions.finishTime;
          me.findOptions.start = 0;
          me.findOptions.limit = 10;
          if (!startTime && !finishTime) {
            me.findOptions.id = me.selectNode;
          }

          if (me.params && me.params.requestParams && me.params.requestParams.includeUsers)
          me.findOptions.includeUsers = me.params.requestParams.includeUsers;
          if (me.params && me.params.requestParams && me.params.requestParams.excludeUsers)
          me.findOptions.excludeUsers = me.params.requestParams.excludeUsers;
          if (me.params && me.params.requestParams && me.params.requestParams.threeMemberType)
          me.findOptions.threeMemberType = me.params.requestParams.threeMemberType;
          if (me.params && me.params.requestParams && me.params.requestParams.notThreeMemberType)
          me.findOptions.notThreeMemberType = me.params.requestParams.notThreeMemberType;
          if (me.params && me.params.requestParams && me.params.requestParams.excludeClientIP)
          me.findOptions.excludeClientIP = me.params.requestParams.excludeClientIP;
          me.mwRef("dataTable").refreshTableDefaultParams(me.findOptions);

          me.closeFindDialog();
        } },
      {
        label: "取消",
        type: "default",
        func: this.closeFindDialog }],


      api: "",
      form: {},


      findOptions: {} };

  },

  mounted: function mounted() {
    var me = this;
    me.headers.Authorization = _token2.default.getToken();
    var defaultParams = [];
    if (me.params && me.params.requestParams) {
      defaultParams = me.params.requestParams;
    }
    me.layout = [
    [
    {
      span: 0,
      type: "menu",
      label: "操作日志",
      api: "business.listOperationLog",
      defaultParams: defaultParams,
      singleSelect: true,
      columns: [
      { type: "selection" },
      { prop: "createTime",
        label: "操作时间", width: 160 },
      { slot: { type: 'href', func: me.edit }, prop: "userName", label: "操作用户", width: 80 },
      { prop: "userLoginId", label: "操作人账号", width: 100 },
      { prop: "clientIP", label: "操作人IP", width: 120 },
      { prop: "name", label: "操作对象", width: 120, tooltip: true },
      { prop: "type", label: "操作类型", width: 80 },
      { prop: "target", label: "操作目标", width: 80 },
      {
        prop: "remark",
        label: "操作说明",
        tooltip: true }] },



    {
      span: 10,
      type: "button",
      items: [
      {
        label: "导出",
        icon: "fa fa-plus-square",
        func: me.lead },

      {
        label: "查询",
        icon: "fa fa-search",
        func: me.findInf }] },



    {
      span: 6,
      type: "searchText",
      name: "name",
      tip: "操作说明",
      offset: 8 }]];



    if (this.params && this.params.isSaveQueryLog == true)
    me.saveQueryLog();
  },

  methods: {

    loadTableTree: function loadTableTree(data) {
      this.selectNode = data.id;
      var params = _.assign({ id: data.id }, this.params && this.params.requestParams);
      this.mwRef("dataTable").refreshTableDefaultParams(params);
    },

    lead: function lead() {
      this.mwRef("leadDialog").show();
    },

    leadSure: function leadSure() {
      var me = this;
      if (!me.startDate && !me.finishDate) {
        me.mwMsg("warning", '请选择开始时间或结束时间!');
        return;
      }
      var params = {};
      if (me.startDate)
      params.startDate = new moment(me.startDate).format("YYYY-MM-DD HH:mm:ss");
      if (me.finishDate)
      params.finishDate = new moment(me.finishDate).format("YYYY-MM-DD HH:mm:ss");

      if (me.params && me.params.requestParams && me.params.requestParams.includeUsers)
      params.includeUsers = me.params.requestParams.includeUsers;
      if (me.params && me.params.requestParams && me.params.requestParams.excludeUsers)
      params.excludeUsers = me.params.requestParams.excludeUsers;
      if (me.params && me.params.requestParams && me.params.requestParams.threeMemberType)
      params.threeMemberType = me.params.requestParams.threeMemberType;
      if (me.params && me.params.requestParams && me.params.requestParams.notThreeMemberType)
      params.notThreeMemberType = me.params.requestParams.notThreeMemberType;
      if (me.params && me.params.requestParams && me.params.requestParams.excludeClientIP)
      params.excludeClientIP = me.params.requestParams.excludeClientIP;
      this.mwApi.business.expOperationLog(params);
      this.closeLeadDialog();
    },
    closeLeadDialog: function closeLeadDialog() {
      this.startDate = "";
      this.finishDate = "";
      this.mwRef("leadDialog").hide();
    },

    closeFindDialog: function closeFindDialog() {


      this.findOptions = {};
      this.mwRef('findDialog').hide();
    },

    findInf: function findInf() {
      this.mwRef("findDialog").show();
    },
    refresh: function refresh() {
      this.mwRef("dictTree").refresh();
    },

    edit: function edit(row) {var _this = this;
      this.mwApi.business.getOperationLog(row.id).then(function (res) {
        _this.mwRef('editDialog').show();
        _this.form = res.result;
      });
    },

    editSure: function editSure() {
      this.closeEditDialog();
    },
    closeEditDialog: function closeEditDialog() {
      this.mwRef('editDialog').hide();
    },

    expand: function expand() {
      this.mwRef('dictTree').openAll();
    },
    closed: function closed() {
      this.mwRef('dictTree').closeAll();
    },
    format: function format(date) {
      if (!(date instanceof Date)) {
        return '';
      }
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var min = date.getMinutes();
      var second = date.getSeconds();
      month = (month >= 10 ? "" : "0") + month;
      day = (day >= 10 ? "" : "0") + day;
      hour = (hour >= 10 ? "" : "0") + hour;
      min = (min >= 10 ? "" : "0") + min;
      second = (second >= 10 ? "" : "0") + second;
      return year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + second;
    },
    saveQueryLog: function saveQueryLog() {
      var dataTable = this.mwRef("dataTable").mwRef("dataTable");
      var tableObj = this.mwRef("dataTable");
      tableObj.$on("dataLoaded", function (d) {
        var total = d ? d.length : 0;
        if (tableObj.isSearch) {
          var rm = "共查询到" + total + "条记录";
          var params = {
            flag: "列表查询",
            targetName: '日志管理-用户管理日志',
            remark: rm,
            objType: '日志',
            target: '功能',
            eventType: '三员管理操作',
            zycd: "一般",
            result: rm };

          PF.invoke("sys-log-service.saveOprLog", params);
        }
      });
    } },


  watch: {} };

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =






























































































































































































































{
  components: {},


  props: {
    params: {
      type: Object } },



  data: function data() {
    var me = this;
    return {
      layout: [],
      headers: {},
      dictTreeUrl: this.mwUrl("/api/business/listFlowLogTree"),
      selectNode: "",
      finishDate: '',
      startDate: '',

      leadButton: [
      {
        label: "确定",
        func: this.leadSure },
      {
        label: "取消",
        type: "default",
        func: this.closeLeadDialog }],





      findButton: [
      {
        label: "确定",
        func: function func() {
          var startTime = me.findOptions.createTime;
          var endTime = me.findOptions.finishTime;
          if (startTime)
          me.findOptions.createTime = new moment(startTime).format("YYYY-MM-DD HH:mm:ss");else

            delete me.findOptions.createTime;

          if (endTime)
          me.findOptions.finishTime = new moment(endTime).format("YYYY-MM-DD HH:mm:ss");else

            delete me.findOptions.finishDate;

          me.findOptions.start = 0;
          me.findOptions.limit = 10;

          if (me.params && me.params.requestParams && me.params.requestParams.includeUsers)
          me.findOptions.includeUsers = me.params.requestParams.includeUsers;
          if (me.params && me.params.requestParams && me.params.requestParams.excludeUsers)
          me.findOptions.excludeUsers = me.params.requestParams.excludeUsers;
          if (me.params && me.params.requestParams && me.params.requestParams.threeMemberType)
          me.findOptions.threeMemberType = me.params.requestParams.threeMemberType;
          if (me.params && me.params.requestParams && me.params.requestParams.notThreeMemberType)
          me.findOptions.notThreeMemberType = me.params.requestParams.notThreeMemberType;
          if (me.params && me.params.requestParams && me.params.requestParams.excludeClientIP)
          me.findOptions.excludeClientIP = me.params.requestParams.excludeClientIP;
          me.mwRef("dataTable").refreshTableDefaultParams(me.findOptions);

          me.closeFindDialog();
        } },
      {
        label: "取消",
        type: "default",
        func: this.closeFindDialog }],



      api: "",

      form: {},



      findOptions: {},


      pickerBeginDateBefore: {
        disabledDate: function disabledDate(time) {
          if (me.finishDate != '') {
            return time.getTime() > me.finishDate;
          }
        } },

      pickerBeginDateAfter: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < me.startDate;
        } } };


  },

  mounted: function mounted() {
    var me = this;
    var defaultParams = [];
    if (me.params && me.params.requestParams) {
      defaultParams = me.params.requestParams;
    }
    debugger;
    me.layout = [
    [
    {
      span: 0,
      type: "menu",
      label: "操作日志",
      api: "/s:business.srv.listFlowLog",
      defaultParams: defaultParams,
      singleSelect: true,

      columns: [

      { prop: 'createTime', label: '操作时间', width: '160' },
      { prop: 'operator', tooltip: true, label: '用户名', width: '80' },
      { prop: 'userLoginId', tooltip: true, label: '用户账号', width: '100' },
      { prop: 'actionName', tooltip: true, label: '操作类型', width: '80' },
      { prop: 'processName', tooltip: true, label: '流程名称', width: '120' },
      { slot: { type: 'href', func: me.edit }, prop: 'businessName', tooltip: true, label: '业务名称' },
      { prop: 'description', tooltip: true, label: '操作说明', slotName: 'description' },
      { prop: "accessType", label: "客户端", tooltip: true, width: '60' },
      { prop: 'ip', label: '客户端IP', width: '118' }] },


    {
      span: 10,
      type: "button",
      items: [
      {
        label: "导出",
        icon: "fa fa-plus-square",
        func: me.lead },

      {
        label: "查询",
        icon: "fa fa-search",
        func: me.findInf }] },



    {
      span: 6,
      type: "searchText",
      name: "name",
      tip: "业务名称",
      offset: 8 }]];





    me.mwRef("dataTable").mwRef("dataTable").search = function (filters) {
      if (filters.name) {
        var param = { filter: { name: filters.name } };
        if (me.params && me.params.requestParams && me.params.requestParams.excludeClientIP) {
          param.excludeClientIP = me.params.requestParams.excludeClientIP;
        }
        me.mwRef("dataTable").refreshTableDefaultParams(param);
      } else {
        var param = { createYearMonthDay: me.selectNode };
        if (me.params && me.params.requestParams && me.params.requestParams.excludeClientIP) {
          param.excludeClientIP = me.params.requestParams.excludeClientIP;
        }
        me.mwRef("dataTable").refreshTableDefaultParams(param);
      }
    };
    me.mwRef("dataTable")._paramsChange = function (params) {
      if (!params.filter || !params.filter.name)
      me.mwRef("dataTable").clearFilters();
      if (me.mwRef("dataTable").defaultParamsChange) {
        me.mwRef("dataTable")._refreshTable();
      } else {
        me.mwRef("dataTable").defaultParamsChange = false;
      }
    };
    if (this.params && this.params.isSaveQueryLog == true)
    me.saveQueryLog();
  },

  methods: {
    formatterDescription: function formatterDescription(row) {

    },
    dateFormatter: function dateFormatter(row, col, cellValue) {
      if (cellValue) {
        return cellValue.substring(2, cellValue.lastIndexOf(':'));
      }
      return '';
    },

    loadTableTree: function loadTableTree(data) {
      this.selectNode = data.id;
      var params = _.assign({ id: data.id }, this.params && this.params.requestParams);debugger;
      this.mwRef("dataTable").refreshTableDefaultParams(params);
    },

    lead: function lead() {
      var me = this;
      me.startDate = "";
      me.finishDate = "";
      this.mwRef("leadDialog").show();
    },

    leadSure: function leadSure() {
      var me = this;
      if (!me.startDate && !me.finishDate) {
        me.mwMsg("warning", '请选择开始时间或结束时间!');
        return;
      }
      var params = {};
      if (me.startDate)
      params.startDate = new moment(me.startDate).format("YYYY-MM-DD HH:mm:ss");
      if (me.finishDate)
      params.finishDate = new moment(me.finishDate).format("YYYY-MM-DD HH:mm:ss");

      if (me.params && me.params.requestParams && me.params.requestParams.includeUsers)
      params.includeUsers = me.params.requestParams.includeUsers;
      if (me.params && me.params.requestParams && me.params.requestParams.excludeUsers)
      params.excludeUsers = me.params.requestParams.excludeUsers;
      if (me.params && me.params.requestParams && me.params.requestParams.threeMemberType)
      params.threeMemberType = me.params.requestParams.threeMemberType;
      if (me.params && me.params.requestParams && me.params.requestParams.notThreeMemberType)
      params.notThreeMemberType = me.params.requestParams.notThreeMemberType;
      if (me.params && me.params.requestParams && me.params.requestParams.excludeClientIP)
      params.excludeClientIP = me.params.requestParams.excludeClientIP;
      this.mwApi.business.expFlowLog(params);
      this.closeLeadDialog();
    },

    closeLeadDialog: function closeLeadDialog() {
      this.mwRef("leadDialog").hide();
    },

    closeFindDialog: function closeFindDialog() {
      this.findOptions = {};
      this.mwRef('findDialog').hide();
    },

    findInf: function findInf() {
      this.findOptions.createTime = "";
      this.findOptions.finishTime = "";
      this.findOptions = {};
      this.mwRef("findDialog").show();
    },
    refresh: function refresh() {
      this.mwRef("dictTree").refresh();
    },

    edit: function edit(row) {var _this = this;
      this.mwApi.business.getFlowLog(row.id).then(function (res) {
        _this.mwRef('editDialog').show();
        _this.form = res.result;
      });
    },

    editSure: function editSure() {
      this.closeEditDialog();
    },
    closeEditDialog: function closeEditDialog() {
      this.mwRef('editDialog').hide();
    },

    expand: function expand() {
      this.mwRef('dictTree').openAll();
    },
    closed: function closed() {
      this.mwRef('dictTree').closeAll();
    },
    format: function format(date) {
      if (!(date instanceof Date)) {
        return '';
      }
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var min = date.getMinutes();
      var second = date.getSeconds();
      month = (month >= 10 ? "" : "0") + month;
      day = (day >= 10 ? "" : "0") + day;
      hour = (hour >= 10 ? "" : "0") + hour;
      min = (min >= 10 ? "" : "0") + min;
      second = (second >= 10 ? "" : "0") + second;
      return parseInt(year + month + day);
    },
    saveQueryLog: function saveQueryLog() {
      var dataTable = this.mwRef("dataTable").mwRef("dataTable");
      var tableObj = this.mwRef("dataTable");
      tableObj.$on("dataLoaded", function (d) {
        var total = d ? d.length : 0;
        if (tableObj.isSearch) {
          var rm = "共查询到" + total + "条记录";
          var params = {
            flag: "列表查询",
            targetName: '日志管理-流程操作日志',
            remark: rm,
            objType: '日志',
            target: '功能',
            eventType: '三员管理操作',
            zycd: "一般",
            result: rm };

          PF.invoke("sys-log-service.saveOprLog", params);
        }
      });
    } },


  watch: {} };

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =
























































































































































































































{
  props: {
    params: Object },

  data: function data() {
    var me = this;
    return {
      layout: [],
      methodArgs: '',
      form: {
        id: '',
        draftsDocId: '',
        batchId: '',
        createTime: '',
        lastModifiedTime: '',
        serviceClass: '',
        methodName: '',
        exceptionStack: '',
        methodArgs: '',
        businessId: '',
        businessName: '',
        moduleName: '',
        processDefinitionName: '' },

      appId: '',
      treeUrl: this.mwUrl("/api/maintain/listTreeFlowTransLog"),
      finishDate: '',
      startDate: '',
      leadButton: [
      {
        label: "取消",
        type: "default",
        func: this.closeLeadDialog },

      {
        label: "确定",
        func: this.leadSure }],


      findButton: [
      {
        label: "取消",
        type: "default",
        func: this.closeFindDialog },

      {
        label: "确定",
        func: function func() {
          var startTime = me.findOptions.startTime;
          var endTime = me.findOptions.endTime;
          me.findOptions.startTime = new moment(startTime).format("YYYY-MM-DD");
          me.findOptions.endTime = new moment(endTime).format("YYYY-MM-DD");
          me.findOptions.start = 0;
          me.findOptions.limit = 10;
          me.findOptions.conQuery = true;
          me.mwRef("dataTable").refreshTableDefaultParams(me.findOptions);
          me.closeFindDialog();
        } }],



      findOptions: {},


      pickerBeginDateBefore: {
        disabledDate: function disabledDate(time) {
          if (me.finishDate != '') {
            return time.getTime() > me.finishDate;
          }
        } },

      pickerBeginDateAfter: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < me.startDate;
        } } };


  },
  mounted: function mounted() {
    var me = this;

    me.layout = [
    [{
      span: 0,
      type: 'menu',
      api: 'maintain.listTransactionLog',
      defaultSort: [{ sort: 'createTime', dir: 'asc' }],
      columns: [
      { type: 'selection' },
      { prop: 'createTime', label: '创建时间', width: '160' },
      { slot: { type: 'href', func: me.view }, prop: 'serviceClass', label: '服务类', width: '300', tooltip: true },
      { prop: 'businessName', label: '文档题名', width: '180', tooltip: true },
      { prop: 'moduleName', label: '模块', width: '100' },
      { prop: 'processDefinitionName', label: '流程', width: '120' },
      { prop: 'exceptionMessage', label: '原因' }] },

    {
      span: 10, type: 'button', items: [
      {
        label: "导出",
        icon: "fa fa-plus-square",
        func: me.lead },

      {
        label: "查询",
        icon: "fa fa-search",
        func: me.findInf },

      { label: '提交', icon: "fa fa-plus-square", func: me.vReExecute }] },

    {
      span: 6,
      type: "searchText",
      name: "name",
      tip: "文档题名",
      offset: 8 }]];


  },
  watch: {
    '$route': function $route(to, from) {
      this.appId = this.$route.params.appId;
    } },

  methods: {
    loadTableTree: function loadTableTree(data) {
      this.selectNode = data.id;
      var qp = { start: 0, limit: 20 };
      if (!data.createYearMonth) {
        qp.createYearMonth = data.id;
      } else {
        qp.createYearMonthDay = data.oldIdValue ? data.id : data.createYearMonth + "-" + data.id;
      }
      var params = _.assign(qp, this.params && this.params.requestParams);
      this.mwRef("dataTable").refreshTableDefaultParams(params);
    },
    view: function view(data) {
      var me = this;
      me.mwApi.maintain.getTransactionLog(data.id).then(function (res) {
        var d = res.result;
        me.form.id = d.id;
        me.form.draftsDocId = d.draftsDocId;
        me.form.batchId = d.batchId;
        me.form.createTime = d.createTime;
        me.form.lastModifiedTime = d.lastModifiedTime;
        me.form.serviceClass = d.serviceClass;
        me.form.methodName = d.methodName;
        me.form.exceptionStack = d.exceptionStack;
        me.methodArgs = js_beautify(d.methodArgs, {});
        me.form.businessId = d.businessId;
        me.form.businessName = d.businessName;
        me.form.moduleName = d.moduleName;
        me.form.processDefinitionName = d.processDefinitionName;
        me.mwRef('dialog').show();
      });
    },
    reExecute: function reExecute() {
      var me = this;
      me.methodArgs = me.mwRef('methodArgs').getValue();
      var loading = me.$loading({
        lock: false,
        fullscreen: false,
        text: '正在提交中，请耐心等待...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.5)' });

      me.mwApi.maintain.updateAndReExecute(me.form.id, me.methodArgs).then(function (res) {
        loading.close();
        if (res.success) {
          me.mwMsg("提交完成");
          me.mwRef('dialog').hide();
          me.mwRef('toolbarTable').refreshTable();
        } else {
          me.mwMsg('warning', '提交失败');
        }
      }).catch(function () {
        loading.close();
      });
    },
    vReExecute: function vReExecute(data) {
      var me = this;
      if (data.length == 0) {
        me.mwMsg("info", "请选择一条记录！");
        return;
      }
      if (data.length > 1) {
        me.mwMsg("info", "最多允许选择一条记录！");
        return;
      }
      me.mwConfirm('您确定要提交所选记录').then(function () {
        var id = data[0].id;
        var loading = me.$loading({
          lock: false,
          fullscreen: false,
          text: '正在提交中，请耐心等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.5)' });

        me.mwApi.maintain.reExecute(id).then(function (res) {
          loading.close();
          if (res.success) {
            me.mwMsg("提交完成");
            me.mwRef('toolbarTable').refreshTable();
          } else {
            me.mwMsg('warning', '提交失败');
          }
        }).catch(function () {
          loading.close();
        });
      }).catch(function () {
      });
    },
    lead: function lead() {
      var me = this;
      me.startDate = "";
      me.finishDate = "";
      this.mwRef("leadDialog").show();
    },

    leadSure: function leadSure() {
      var me = this;
      if (!me.startDate && !me.finishDate) {
        me.mwMsg("warning", '请选择开始时间或结束时间!');
        return;
      }
      var params = {};
      if (me.startDate)
      params.startTime = new moment(me.startDate).format("YYYY-MM-DD");
      if (me.finishDate)
      params.endTime = new moment(me.finishDate).format("YYYY-MM-DD");

      if (me.params && me.params.requestParams && me.params.requestParams.includeUsers)
      params.includeUsers = me.params.requestParams.includeUsers;
      if (me.params && me.params.requestParams && me.params.requestParams.excludeUsers)
      params.excludeUsers = me.params.requestParams.excludeUsers;

      this.mwApi.maintain.expFlowTransLog(params);
      this.closeLeadDialog();
    },
    closeLeadDialog: function closeLeadDialog() {
      this.mwRef("leadDialog").hide();
    },

    closeFindDialog: function closeFindDialog() {
      this.findOptions = {};
      this.mwRef('findDialog').hide();
    },

    findInf: function findInf() {
      this.findOptions = {};
      this.mwRef("findDialog").show();
    },
    handleClose: function handleClose() {
      var me = this;
      this.mwRef("dialog").hide();
    },
    expand: function expand() {
      this.mwRef('dictTree').openAll();
    },
    closed: function closed() {
      this.mwRef('dictTree').closeAll();
    },
    format: function format(date) {
      if (!(date instanceof Date)) {
        return '';
      }
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var min = date.getMinutes();
      var second = date.getSeconds();
      month = (month >= 10 ? "" : "0") + month;
      day = (day >= 10 ? "" : "0") + day;
      hour = (hour >= 10 ? "" : "0") + hour;
      min = (min >= 10 ? "" : "0") + min;
      second = (second >= 10 ? "" : "0") + second;
      return parseInt(year + month + day);
    } } };

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =











































































































































{
  components: {},


  props: {
    params: {
      type: Object } },



  data: function data() {
    var me = this;
    return {
      layout: [],
      headers: {},
      treeUrl: this.mwUrl("/api/business/listAccessTree"),
      selectNode: "",
      finishDate: '',
      startDate: '',

      leadButton: [
      {
        label: "取消",
        type: "default",
        func: this.closeLeadDialog },

      {
        label: "确定",
        func: this.leadSure }],



      form: {},



      pickerBeginDateBefore: {
        disabledDate: function disabledDate(time) {
          if (me.finishDate != '') {
            return time.getTime() > me.finishDate;
          }
        } },

      pickerBeginDateAfter: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < me.startDate;
        } } };


  },

  mounted: function mounted() {
    var me = this;
    me.layout = [
    [
    {
      span: 0,
      type: "menu",
      label: "响应日志",
      api: "business.listAccessLog",
      singleSelect: true,
      columns: [
      { prop: "requestURI", label: "请求地址", tooltip: true },
      { prop: "userName", label: "操作用户", tooltip: true, width: '80' },
      { prop: "createTime", label: "操作时间", tooltip: true, width: '160' },
      { prop: "accessType", label: "响应方式", tooltip: true, width: '80' },
      { prop: "clientIP", label: "客户端IP", tooltip: true, width: '100' },
      { prop: "userAgent", label: "浏览器类型", tooltip: true, width: '120', formatter: me.userAgentFormatter },
      { prop: "duration", label: "响应时长(毫秒)", sortable: true, tooltip: true, width: '130' }] },


    {
      span: 10,
      type: "button",
      items: [
      {
        label: "导出",
        icon: "fa fa-plus-square",
        func: me.lead }] },



    {
      span: 6,
      type: "searchText",
      name: "userName",
      tip: "操作用户或请求地址",
      offset: 8 }]];



  },

  methods: {
    expand: function expand() {
      this.mwRef('logTree').openAll();
    },
    closed: function closed() {
      this.mwRef('logTree').closeAll();
    },
    loadTableTree: function loadTableTree(data) {
      this.selectNode = data.id;
      this.mwRef("dataTable").refreshTableDefaultParams({
        id: data.id });

    },

    userAgentFormatter: function userAgentFormatter(data, c, userAgent) {
      if (userAgent == null) return "";
      var start = userAgent.indexOf("(");
      userAgent = userAgent.substring(start, userAgent.length);
      var os = "Windows";
      var bit = "32位";
      var brower = "";
      if (userAgent.indexOf("Windows NT 5.0") != -1) {
        os = "Win2000";
      } else if (userAgent.indexOf("Windows NT 5.1") != -1 || userAgent.indexOf("Windows XP") != -1) {
        os = "WinXP";
      } else if (userAgent.indexOf("Windows NT 5.2") != -1) {
        os = "Win2003";
      } else if (userAgent.indexOf("Windows NT 6.0") != -1) {
        os = "Win2008";
      } else if (userAgent.indexOf("Windows NT 6.1") != -1) {
        os = "Win7";
      } else if (userAgent.indexOf("Windows NT 6.2") != -1) {
        os = "Win8";
        if (userAgent.indexOf("ARM;") != -1) {
          os = "WinRT";
        }
      } else if (userAgent.indexOf("Windows NT 6") != -1) {
        os = "WinVista";
      } else if (userAgent.indexOf("Linux") != -1) {
        os = "Linux";
      } else if (userAgent.indexOf("Mac") != -1) {
        os = "Mac";
      }
      if (userAgent.indexOf("WOW64") != -1 || userAgent.indexOf("_64") != -1 || userAgent.indexOf("X64") != -1 || userAgent.indexOf("x64") != -1) {
        bit = "64位";
      }

      if (userAgent.indexOf("MSIE") != -1) {
        brower = "IE";
        var start = userAgent.indexOf("MSIE");
        var end = userAgent.indexOf(";", start);
        brower = brower + userAgent.substring(start + 5, end);
      } else if (userAgent.indexOf("rv:") != -1 && userAgent.indexOf("Firefox") == -1) {
        brower = "IE";
        var start = userAgent.indexOf("rv:");
        var end = userAgent.indexOf(")", start);
        brower = brower + userAgent.substring(start + 3, end);
      } else if (userAgent.indexOf("Firefox") != -1) {
        brower = "Firefox";
        var start = userAgent.indexOf("Firefox/");
        brower = brower + userAgent.substring(start + "Firefox".length + 1, userAgent.length);
      } else if (userAgent.indexOf("Chrome") != -1) {
        brower = "Chrome";
        var start = userAgent.indexOf("Chrome/");
        var end = userAgent.indexOf(".", start);
        end = userAgent.indexOf(".", end + 1);
        brower = brower + userAgent.substring(start + "Chrome".length + 1, end);
      } else if (userAgent.indexOf("Safari") != -1) {

        brower = "Safari";
        var start = userAgent.indexOf("Version/");
        var end = userAgent.indexOf(" ", start);
        brower = brower + userAgent.substring(start + "Version".length + 1, end);
      }

      return brower;
    },


    lead: function lead() {
      this.mwRef("leadDialog").show();
    },

    closeLeadDialog: function closeLeadDialog() {
      this.mwRef("leadDialog").hide();
    },

    closeEditDialog: function closeEditDialog() {
      this.mwRef('editDialog').hide();
    },

    edit: function edit(row, index) {var _this = this;
      this.mwApi.business.getAccessLog(row.id).then(function (res) {
        _this.mwRef('editDialog').show();
        _this.form = res.result;
      });
    },
    closeDialog: function closeDialog(a) {
      this.mwRef(a).hide();
    },
    leadSure: function leadSure() {
      var me = this;
      if (!me.startDate && !me.finishDate) {
        me.mwMsg("warning", '请选择开始时间或结束时间!');
        return;
      }
      var params = {};
      if (me.startDate)
      params.startDate = new moment(me.startDate).format("YYYY-MM-DD HH:mm:ss");
      if (me.finishDate)
      params.finishDate = new moment(me.finishDate).format("YYYY-MM-DD HH:mm:ss");
      this.mwApi.business.expAccessLog(params);
      this.closeLeadDialog();
    } },

  watch: {} };

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =























































{
  props: {
    params: Object },

  name: "file_manager",
  data: function data() {
    var appId = _.get(this, "params.appId", _.get(this, "$route.params.appId"));
    var sysId = _.get(this, "$route.params.sysId");
    return {
      autoLoad: false,
      selFolderName: "",
      defaultCheckedKeys: [""],
      dialogTableVisible: false,
      treeData: [],
      fileList: [],
      fileName: "",
      showFileList: false,
      headers: {},
      fdata: {},
      action: this.mwUrl('/api/file/upload'),
      pagination: false,
      noPaginationLimit: 20,
      layout: [],
      appId: appId,
      sysId: sysId,
      imgUrl: "",
      imgTypes: ["png", "jpg", "bmp", "tif", "gif", "PNG", "JPG", "BMP", "TIF", "GIF"],
      coreEditorTypes: ["js", "css", "JS", "CSS"],
      form: {},
      refreshingFileName: '',
      addFolderParentFolder: "" };

  },
  created: function created() {
    var me = this;
    this.$nextTick(function () {
      if (me.treeData.length > 0) {
        me.$refs.folderTree.setCurrentKey(me.treeData[0].label);
        me.selFolderName = me.treeData[0].label;
        me.loadData();
      }
    });
  },
  mounted: function mounted() {
    var me = this;
    me.fdata = {
      appId: me.appId };


    me.layout =
    [
    [{
      key: 'file',
      type: 'menu',
      defaultActive: true,
      pagination: false,
      label: '文件管理',
      api: 'filemanager.listFiles',
      defaultParams: { appId: me.appId, folder: me.selFolderName, category: 'file' },
      defaultSort: [{ sort: 'createTime', dir: 'desc' }],
      columns: [
      { type: 'selection' },
      { prop: 'name', tooltip: true, label: '名称', formatter: me.nameFormatter },
      { prop: 'type', label: '类型', width: '150' },
      { prop: 'size', label: '大小', width: '100', formatter: me.sizeFormatter }] },

    {
      span: 20, type: 'button', items: [
      { label: '上传', icon: "fa fa-upload", func: me.uploadFile },
      { label: '下载', icon: "fa fa-download", func: me.downloadFile },
      { label: '替换', icon: "fa fa-refresh", func: me.refreshFile },
      { label: '删除', icon: "fa fa-trash-o fa-fw", func: me.delFile },
      { label: '获取路径', icon: "fa fa-map", func: me.getUrl }] },

    {
      span: 4, type: 'custom', items: [] }]];


    me.$nextTick(function () {
      $(me.$el).find("[toolbar_custom_area='true']").append('<button id="showhelp" style="float:right;" type="button" class="el-button el-button--info"><span><i class="fa fa-question"></i><span>帮助</span></span></button>');
      $("#showhelp").click(function () {
        me.showHelp();
      });
    });
  },
  methods: {
    contextMenu: function contextMenu(event, object, value, element) {
      this.menuVisible = true;
    },
    handleNodeClick: function handleNodeClick(data) {
      var me = this;
      var name = data.label;
      if (!name) return;
      me.selFolderName = name;
      me.loadData();

    },
    loadTreeNode: function loadTreeNode(node, resolve) {
      var me = this;
      var appId = node.level === 0 ? this.appId : this.appId + "/" + node.data.id;
      MW.mwApi.filemanager.listFolder({ appId: appId }).then(function (res) {
        var r = res ? res.result : null;
        if (r && r.length > 0) {
          var pid = node.level === 0 ? "" : node.data.id;
          var nodes = r.map(function (el) {
            return { label: el.name, id: (pid ? pid + "/" : "") + el.name };
          });
          resolve(nodes);
          setTimeout(function () {
            me.$refs.folderTree.setCurrentKey(nodes[0].id);
            me.loadData();
          }, 100);
        } else {
          resolve([]);
        }
        me.$parent.$emit('updateTreeCount', {
          id: 'file_manager',
          length: r.length || 0 });

      });
    },
    nodeContextMenu: function nodeContextMenu(event, data, node) {
      var me = this;
      var contextMenu = PF.contextMenu({
        autoDestroy: true,
        items: [{
          text: "新建子文件夹",
          icon: "fa fa-new",
          handler: function handler() {
            me.addFolderParentFolder = data.id;
            me.addFolder();
          } }] });


      contextMenu.show(event.pageX, event.pageY);
    },
    loadData: function loadData() {
      var me = this;
      var selFolderName = me.$refs.folderTree.getCurrentKey();
      if (!selFolderName) return false;
      MW.mwApi.filemanager.listFiles({ appId: me.appId, folder: selFolderName }).then(function (r) {
        if (r && r.result.length > 0) {
          me.$refs.viewToolbarTable.refreshTableDataList(r.result);
        } else {
          me.$refs.viewToolbarTable.refreshTableDataList([]);
        }
      });
    },
    listFolder: function listFolder(selLabel) {





















    },
    cancelNewFile: function cancelNewFile() {
      this.dialogTableVisible = false;
      this.fileName = "";
    },
    saveFolder: function saveFolder() {
      var me = this;
      if (!this.fileName) {
        this.$alert("请输入文件名");
        return;
      }
      var fileName = this.fileName;
      if (/^[^\\/:*?""<>|,\\.]+$/.test(fileName) == false) {
        this.$alert("文件名不能包含特殊字符");

        return;
      }
      var tree = me.$refs.folderTree;
      var parentNode = void 0;
      if (me.addFolderParentFolder) {
        fileName = me.addFolderParentFolder + "/" + fileName;
        parentNode = tree.getNode(me.addFolderParentFolder);
      } else {
        parentNode = tree.root;
      }
      me.fileName = "";

      me.addFolderParentFolder = "";
      me.dialogTableVisible = false;
      MW.mwApi.filemanager.addFolder({ appId: me.appId, folder: fileName }).then(function (res) {
        var r = res ? res.result : null;
        if (r) {
          if (r.success === true) {

            tree.append({ label: fileName.split("/").pop(), id: fileName }, parentNode);
            parentNode.expand();
            setTimeout(function () {return tree.setCurrentKey(fileName);}, 200);
          } else {
            alert(r.msg);
          }
        }
      });
    },
    listFiles: function listFiles(params) {
      var me = this;
      params = params || {};

    },
    addFolder: function addFolder() {
      this.dialogTableVisible = true;
    },
    deleteFolder: function deleteFolder() {
      var me = this;
      var folderName = "";
      var nodes = me.$refs.folderTree.getCheckedNodes();
      if (!nodes || nodes == 0) {
        me.$alert("请选择要删除的文件夹");
        return;
      }

      folderName = $.map(nodes, function (el) {
        return el.id;
      }).join("|");
      MW.mwApi.filemanager.deleteFolder({ appId: me.appId, folder: folderName }).then(function (res) {
        var r = res ? res.result : null;
        if (r) {
          if (r.success == true) {
            nodes.forEach(function (n) {return me.$refs.folderTree.remove(n);});
          } else {
            alert(r.msg);
          }
        }
      });

    },
    importSuccessCallback: function importSuccessCallback(resp, file, fileList) {
      if (this.refreshingFileName) {
        this.$alert("替换成功");
      }
      this.loadData();
      this.handleClose();
    },
    nameFormatter: function nameFormatter(data) {var h = this.$createElement;
      var me = this;
      if (me.imgTypes.indexOf(data.type) != -1 || me.coreEditorTypes.indexOf(data.type) != -1) {
        return h("span", { slot: "reference", "class": { 'link': true }, attrs: { title: data.name }, on: { "click": function click(event) {return me._showForm(data, event);} } }, [
          data.name ? data.name : '无标题']);

      } else {
        return data.name;
      }
    },
    sizeFormatter: function sizeFormatter(data) {
      var size = data.size;
      if (size < 0) {
        return "0KB";
      }
      size = size / 1024;
      if (size < 1024) {
        return size.toFixed(2) + "KB";
      }
      size /= 1024;
      return size.toFixed(2) + "MB";
    },
    _showForm: function _showForm(row, event) {
      event.stopPropagation();
      var me = this;
      var url = "/FILE_MANAGER/" + this.appId + "/" + me.$refs.folderTree.getCurrentKey() + "/" + row.name;
      if (me.imgTypes.indexOf(row.type) != -1) {
        me.imgUrl = url;
        me.mwRef("img_show").show();
      } else if (me.coreEditorTypes.indexOf(row.type) != -1) {
        $.get(url, function (res) {
          var lang = ["css", "CSS"].indexOf(row.type) != -1 ? "CSS" : "";
          PF.dialog("MwCodeEdit", {
            title: row.name,
            propsData: { value: res, lang: lang } });

        }, "text");
      }
    },
    getUrl: function getUrl() {
      var me = this;
      var sels = me.$refs.viewToolbarTable.getMultipleSelection();
      if (!sels || sels.length != 1) {
        me.$alert("请选择一个要查看路径的文件");
        return;
      }
      var url = "/FILE_MANAGER/" + this.appId + "/" + me.$refs.folderTree.getCurrentKey() + "/" + sels[0].name;
      this.$alert("<span style='word-break:break-all;'>" + url + "</span>", '文件路径', {
        dangerouslyUseHTMLString: true,
        callback: function callback(action) {
        } });


    },
    handle_img_showClose: function handle_img_showClose() {
      this.mwRef("img_show").hide();
    },
    handleClose: function handleClose() {
      this.refreshingFileName = '';
    },
    uploadFile: function uploadFile() {
      var me = this;
      me.fdata.folder = me.$refs.folderTree.getCurrentKey();
      if (!me.fdata.folder) {
        alert("请选择文件夹");
        return;
      }

      var comp = PF.createVue({
        template: "<el-upload ref='uploader' :show-file-list='false' :on-success=\"importSuccessCallback\"\n                   style=\"display: inline-block\"\n                   :auto-upload=\"true\"\n                   :data=\"fdata\"\n                   :action=\"action\"\n                   :before-upload=\"beforeAvatarUpload\"></el-upload>",





        data: function data() {
          return {
            action: me.action,
            fdata: me.fdata };

        },
        mounted: function mounted() {
          this.$refs.uploader.$refs["upload-inner"].$refs.input.click();
        },
        methods: {
          importSuccessCallback: function importSuccessCallback(resp, file, fileList) {
            me.importSuccessCallback(resp, file, fileList);
          },
          beforeAvatarUpload: function beforeAvatarUpload(file, fileList) {
            me.beforeAvatarUpload(file, fileList);
          } } });


      comp.$mount();






    },
    downloadFile: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {var me, folderName, sels, params;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                me = this;
                folderName = me.$refs.folderTree.getCurrentKey();if (
                folderName) {_context.next = 4;break;}return _context.abrupt("return");case 4:



                sels = me.$refs.viewToolbarTable.getMultipleSelection();
                params = {
                  appId: me.appId,
                  folder: encodeURIComponent(folderName) };if (!(


                sels.length > 0)) {_context.next = 10;break;}
                sels.forEach(function (item) {
                  params.name = encodeURIComponent(item.name);
                  MW.mwApi.filemanager.downloadFile2(params).then(function (res) {
                    if (!res.success && res.msg) {
                      me.$alert(res.msg);
                    }
                  });
                });_context.next = 12;break;case 10:

                me.$alert("请选择要下载的文件");return _context.abrupt("return");case 12:case "end":return _context.stop();}}}, _callee, this);}));function downloadFile() {return _ref.apply(this, arguments);}return downloadFile;}(),



    refreshFile: function refreshFile() {
      var me = this;
      var folderName = me.$refs.folderTree.getCurrentKey();
      if (!folderName) {
        return;
      }

      var sels = me.$refs.viewToolbarTable.getMultipleSelection();

      if (sels.length == 1) {
        me.mwConfirm('此操作将会以上传的文件替换掉原文件，确定要继续吗?').then(function () {
          me.refreshingFileName = sels[0].name;
          var params = {
            appId: me.appId,
            folder: folderName,
            name: me.refreshingFileName };

          me.uploadFile();
        });

      } else {
        me.$alert("请选择一个要替换的文件");
        return;
      }
    },
    delFile: function delFile(records) {
      var me = this;
      var folderName = me.$refs.folderTree.getCurrentKey();
      if (!folderName) {
        return;
      }
      var sels = me.$refs.viewToolbarTable.getMultipleSelection();

      if (!sels || sels.length == 0) {
        me.$alert("请选择要删除的文件");
        return;
      }

      me.mwConfirm('您确定要删除选中的文件吗?').then(function () {

        var name = $.map(sels, function (el) {
          return el.name || "";
        }).join("|");

        var params = {
          appId: me.appId,
          folder: folderName,
          name: name };

        MW.mwApi.filemanager.deleteFile(params).then(function (r) {
          me.loadData();
        });
      });

    },
    beforeAvatarUpload: function beforeAvatarUpload(file, fileList) {
      if (this.refreshingFileName) {
        if (this.refreshingFileName !== file.name) {
          this.$alert('请使用相同名字与类型的文件替换');
          this.refreshingFileName = '';
          return false;
        } else {











        }
      }
    },
    timeFormatter: function timeFormatter(data, c, v) {
      if (v) {
        var time = v;
        return time.substring(5, time.length - 3);
      }
      return v;
    },
    search: function search() {
      this.mwRef('viewToolbarTable').searchText();
    },
    refreshTable: function refreshTable() {
      this.mwRef('viewToolbarTable').refreshTable();
    },
    showHelp: function showHelp() {
      PF.showHelp({ title: '文件管理说明', url: '/helpDoc/platform/file_manage.md' });
    } } };

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
























{
  name: "flow-chart-viewer",
  props: {
    params: Object },

  data: function data() {
    return {
      processDataGraph: undefined,
      color: undefined,
      processList: [],
      curFlowId: undefined,
      originalFlowId: "",
      processCount: 0,
      showProcessList: false,
      isInit: false,
      flowProcess: [] };

  },
  mounted: function mounted() {



    this.processChart(this.params);
    this.originalFlowId = this.params.processDefinitionId;
  },
  methods: {
    processChart: function processChart(_ref) {var _this = this;var applicationId = _ref.applicationId,processDefinitionId = _ref.processDefinitionId,batchId = _ref.batchId;
      var me = this;
      this.mwApi.process.
      getFlowChartData({
        batchId: batchId,
        appId: applicationId,
        id: processDefinitionId }).

      then(function () {var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(data) {var flowData, colors, activityStatus, startId, flag, a, activity;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!(
                  !data.result || !data.result.flows)) {_context.next = 5;break;}

                  me.mwMsg("info", $lang("获取流程图数据失败"));return _context.abrupt("return");case 5:


                  flowData = data.result.flows;
                  if (flowData.graph && flowData.graph.activity) {
                    flowData.graph.activity.forEach(function (act) {
                      if (window.$currentBrowserLanguage === 'en') {
                        act._name = act.name;
                        act.name = $lang(act.name);
                      }
                    });
                  }
                  me.processDataGraph = flowData.graph;
                  me.title = $lang("流程图") + "-" + $lang(flowData.name) + "(" + flowData.version + ".0)";
                  colors = [];
                  activityStatus = flowData.activityStatus;
                  startId = "";
                  flag = false;
                  for (a in activityStatus) {
                    if (activityStatus[a] == "T") {
                      colors.push({ id: a, color: "#fba500", fontColor: "#ffffff" });
                      flag = true;
                    }
                    if (activityStatus[a] == "F") {
                      colors.push({ id: a, color: "#67bc69", fontColor: "#ffffff" });
                      flag = true;
                    }
                    if (activityStatus[a] == "D") {
                      colors.push({ id: a, color: "#fb3500", fontColor: "#ffffff" });
                      flag = true;
                    }
                  }

                  activity = flowData.graph.activity;
                  activity.map(function (v) {
                    if (activityStatus[v.id] == null) {
                      if (v.type == "start") {
                        startId = v.id;
                      } else {
                        colors.push({
                          id: v.id,
                          color: "#999999",
                          fontColor: "#ffffff" });

                      }
                    }
                  });
                  if (flag) {
                    colors.push({
                      id: startId,
                      color: "#67bc69",
                      fontColor: "#ffffff" });

                  } else {
                    colors.push({
                      id: startId,
                      color: "#999999",
                      fontColor: "#ffffff" });

                  }
                  me.color = colors;_context.next = 20;return (

                    me.mwApi.process.getFlowProcess({
                      batchId: me.params.batchId,
                      readerAuthorize: false,
                      requireReturnBusiness: true,
                      sorts: [],
                      type: 1 }));case 20:me.flowProcess = _context.sent.
                  result;

                  if (me.flowProcess) {
                    _.each(me.flowProcess, function (n) {
                      if (n.status == "被取回") {
                        n.status = "取回";
                      } else if (n.status == "被取消" || n.sourceMode == "发送" && n.status == "被强制终止") {
                        n.status = "被取回";
                      }
                    });
                  }
                  me.curFlowId = flowData.id;
                  me.processList = flowData.pdList;
                  me.processCount = me.processList.length;case 25:case "end":return _context.stop();}}}, _callee, _this);}));return function (_x) {return _ref2.apply(this, arguments);};}());



    },
    processSwitchClick: function processSwitchClick() {
      var me = this;
      if (me.showProcessList) {
        me.showProcessList = false;
      } else {
        me.showProcessList = true;
      }
    },
    processClick: function processClick(n, e) {
      var me = this;
      var params = {
        batchId: me.params.batchId,
        applicationId: me.params.applicationId,
        processDefinitionId: n.id };

      me.processChart(params);
    },




    handleRequestTitle: function handleRequestTitle(shape, resolver) {
      var activityId = shape.id;
      var processNodes = (this.flowProcess || []).filter(
      function (x) {return x.activityId === activityId;});


      var list = [
      {
        label: $lang("节点名称"),
        prop: "name" },

      {
        label: $lang("办理人"),
        prop: "assigneeName" },

      {
        label: $lang("办理部门"),
        prop: "department" },

      {
        label: $lang("签收时间"),
        prop: "claimTime" },

      {
        label: $lang("完成时间"),
        prop: "finishTime" },

      {
        label: $lang("状态"),
        prop: "status" },

      {
        label: $lang("意见"),
        prop: "comment" }];


      if (processNodes.length > 0) {
        var preTaskMap = {};
        this.flowProcess.forEach(function (n) {
          preTaskMap[n.previousTaskId] = n;
        });
        processNodes.forEach(function (n) {
          if (preTaskMap[n.id] && preTaskMap[n.id].sourceMode &&
          preTaskMap[n.id].sourceMode == "强制办毕(管理员干预)" && preTaskMap[n.id].businessField2) {
            var arry = preTaskMap[n.id].businessField2.split("_");
            var operator = arry.length == 3 ? arry[2] : n.assigneeName;
            n.status = "强制办毕（" + operator + "）";
          }
          if (window.$currentBrowserLanguage === 'en') {
            n.assigneeName = n.assigneeEnglishname || n.candidateEnglishname || n.assigneeName;
            n.department = n.assigneeDeptEnglishname || n.department;
            n.name = $lang(n.name);
            n.status = $lang(n.status);
          }
        });

        resolver(wrapTable(
        processNodes.map(function (processNode, index) {
          return "\n              <tbody style=\"" + (
          index > 0 ? 'border-top:1px solid #fff;' : '') + "\">\n              " +
          list.map(function (_ref3) {var label = _ref3.label,prop = _ref3.prop;
            if (processNode[prop] == null) return "";
            return "<tr style=\"display:table-row\">\n                    <td style=\"padding: 10px 20px;text-align:right;white-space:nowrap;font-weight:normal;\">" +
            label + "</td>\n                    <td style=\"padding: 10px 20px;\">" +
            processNode[prop] + "</td>\n                  </tr>";

          }).join("") + "\n              </tbody>\n            ";


        }).join("")));

      } else {
        var activity = this.processDataGraph.activity.filter(function (a) {return a.id === activityId;});
        if (activity[0]) {
          resolver(wrapTable("\n          <tbody>\n            <tr style=\"display:table-row\">\n              <td style=\"padding: 10px 20px;text-align:right;white-space:nowrap;font-weight:normal;\">" +


          $lang("节点名称") + "</td>\n              <td style=\"padding: 10px 20px;\">" +
          $lang(activity[0].name) + "</td>\n            </tr>\n          </tbody>\n          "));



        }
      }
      function wrapTable(s) {
        return "\n        <table style=\"background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGMyfgoAAVQBGwzinUYAAAAASUVORK5CYII=);color:#fff;border-collapse:collapse\">\n          " +

        s + "\n        </table>\n        ";


      }
    } },

  watch: {
    params: function params(newValue, oldValue) {
      this.processChart(newValue);
    } } };

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =














{
    name: 'MwServiceConsole',
    components: {},


    data: function data() {
        var me = this;
        return {
            serverPort: "8878" };

    },
    methods: {
        connect: function connect() {
            var me = this;
            var port = this.serverPort || '8878';
            var url = 'ws://' + window.location.hostname + ':' + port;
            if (me.ws)
            {
                me.ws.close();
            }
            me.ws = new WebSocket(url);
            me.ws.onmessage = function (e)
            {
                var node = document.createElement('PRE');
                node.innerHTML = e.data;
                var container = me.$refs.container;
                container.appendChild(node);
                container.scrollTop = container.scrollHeight;
            };
        },
        clear: function clear() {
            this.$refs.container.innerHTML = "";
        },
        close: function close() {
            if (this.ws) this.ws.close();
        },
        destroyed: function destroyed() {
            this.close();
        } },

    watch: {} };

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);




































































































































































var _loadUsers = __webpack_require__(140);var _loadUsers2 = _interopRequireDefault(_loadUsers);
var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  name: 'personal-group',
  components: {
    loadUsers: _loadUsers2.default },

  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'userInfo',
  'expUser'])),


  data: function data() {
    var me = this;
    return {
      isLimit: false,
      layout: [],
      selUnitId: "",
      showGroupOutOrg: true,
      toolbarPosition: window.$Env && $Env.toolbarPosition || 'TOP',
      expandFlag: 1,
      selUnitName: "",
      formSelUnitId: '',
      selCode: "",
      groupTreeUrl: this.mwUrl('/api/org/getGroupTreeByType'),
      defaultTreeParams: { type: 'personal_group', t: Date.now() },
      unitFooterButton: [
      { label: $lang('取消'), func: me.selectUnitCancel, type: "default" },
      { label: $lang('确定'), func: me.selectUnitSure }],

      externalBtn: [
      { label: $lang('确定'), func: me.externalSure }],

      btns: [{
        label: $lang('取消'),
        type: 'default',
        func: me.closeGroupDialog },
      {
        label: $lang('确定'),
        func: this.groupSure }],

      check: '',
      list: [{ 'id': 1, 'name': $lang('机关领导') },
      { 'id': 2, 'name': $lang('领导群组') },
      { 'id': 3, 'name': $lang('美络科技') }],

      unitTreeUrl: this.mwUrl('/api/org/getUnitTreeContainSelf'),
      defaultParams: { deep: true, isContainSelf: true, parentId: "" },
      selectUnitId: '',
      form: {
        id: '',
        code: '',
        name: '',
        sn: 1,
        unitName: '',
        unitId: '',
        departments: '',
        departmentids: '',
        users: '',
        userids: '',
        externalUnit: '',
        create_user: '' },


      formRules: {
        unitName: [
        { required: true, message: $lang("请选择所属单位"), trigger: 'change' }],

        code: [
        { required: true, message: $lang("请选择分类"), trigger: 'change' }],

        name: [
        { required: true, message: $lang("请输入名称"), trigger: 'blur' }] },


      checkNodes: { dept: [], deptUsers: [] },
      outerDept: '',
      curSelParams: {},
      headers: {},
      curUnitId: "",
      curUnitName: "" };

  },
  mounted: function mounted() {
    var me = this;
    if (window.$Env && $Env.hideGroupOutOrg) {
      me.showGroupOutOrg = false;
    }
    me.layout = [
    [{
      span: 0,
      type: 'menu',
      label: '个人群组管理',
      api: 'org.listGroupDataByType',
      defaultParams: {
        type: 'personal_group',
        create_user: this.userInfo.loginId },

      columns: [
      { type: 'selection' }, { prop: 'sn', width: '55', label: '序号' },
      { prop: 'name', label: '名称', slot: { type: "href", func: me.openForm } },
      { prop: 'departments', label: '部门成员', tooltip: true },
      { prop: 'users', label: '用户成员', tooltip: true }] },

    {
      span: 12,
      type: 'button',
      items: [{
        label: '添加',
        func: me.addTitle },
      {
        label: '删除',
        func: me.deleteGroup,
        icon: "el-icon-delete" }],
      suffixSlot: "dropDown" },
    {
      span: 6,
      type: 'searchText',
      name: 'name',
      offset: 4,
      func: me.search }]];


    if (!this.userInfo.developer) {
      if (this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0) {
        this.defaultTreeParams.create_user = this.userInfo.loginId;
        this.defaultTreeParams.unitId = this.curUnitId = this.$store.getters.curUnit[0].id;
        this.curUnitName = this.$store.getters.curUnit[0].name;
        this.defaultParams.parentId = this.$store.getters.curUnit[0].id;
      }
    } else {
      this.defaultTreeParams.create_user = this.userInfo.loginId;
      this.defaultTreeParams.unitId = this.curUnitId = this.userInfo.owner;


    }
    this.mwRef('groupTree').renderTree();
    me.$nextTick(function () {

      $(me.$el).find(".el-row").append('<button id="help" style="float:right;margin-top:8px;" type="button" class="el-button el-button--info"><span><i class="fa fa-question"></i><span>' + $lang('帮助') + '</span></span></button>');
      $("#help").click(function () {
        me.showHelp();
      });
    });

  },
  methods: {
    changed: function changed(data) {
      var me = this;
      if (!data.id) {
        return;
      }
      var params = { type: 'personal_group', create_user: this.userInfo.loginId };
      var unitText = "";
      if (data.code) {
        params.unitId = data.unitId;
        unitText = data.unitName;
        params.code = data.code;
        me.selCode = data.code;
      } else {
        params.unitId = data.id;
        unitText = data.text;
      }
      me.selUnitId = params.unitId;
      me.selUnitName = unitText;
      me.curSelParams = params;
      $.post("/api/org/listGroupDataByType", params, function (res) {
        me.mwRef('aa').refreshTableDataList(res.result);
      });
    },
    showHelp: function showHelp() {
      PF.showHelp({ url: '/helpDoc/platform/groupManager.md' });
    },
    refreshGridData: function refreshGridData() {
      var me = this;
      $.post("/api/org/listGroupDataByType", me.curSelParams, function (res) {
        var records = me.mwRef('aa').getMultipleSelection();
        me.mwRef('aa').refreshTableDataList(res.result, function () {
          if (records && records.length > 0 && res.result && res.result.length > 0) {
            var row = records[0];
            _.each(res.result, function (v) {if (v.id == row.id) row = v;});
            me.mwRef('aa').clearSelection();
            me.mwRef('aa').toggleRowSelection(row, true);
          }
        });
      });
    },
    addTitle: function addTitle() {
      this.resetFields();
      this.form.unitId = this.$store.getters.curUnit[0].id;
      this.form.unitName = this.$store.getters.curUnit[0].name;
      this.form.create_user = this.userInfo.loginId;
      this.showDialog('titleDialog');

    },
    openForm: function openForm(data) {
      var fd = {};
      fd = _.assign(fd, data);
      this.form = fd;
      this.showDialog('titleDialog');
    },
    showUnitDialog: function showUnitDialog() {
      var me = this;
      me.selectUnitId = me.form.unitId;
      this.showDialog('unitDialog');
    },
    isSysAdmin: function isSysAdmin() {
      if (this.userInfo.roles && this.userInfo.roles.length > 0) {
        for (var i = 0; i < this.userInfo.roles.length; i++) {
          if (this.userInfo.roles[i].name == "系统管理员") {
            return true;
          }
        }
      }
      return false;
    },

    selectUnitSure: function selectUnitSure() {
      var me = this;
      var tree = void 0;
      tree = this.mwRef('unitTree');
      var data = tree.getSelected();
      if (!data) {
        this.mwMsg('warning', '请选择单位');
      } else {
        me.form.unitId = data.id;
        me.form.unitName = data.text;
        this.selectUnitCancel();
      }
    },
    deleteGroup: function deleteGroup(data) {
      var me = this;
      if (!data || data.length === 0) {
        this.mwMsg('warning', $lang('请选择数据'));
        return;
      }
      var ids = [];
      $.each(data, function (i, d) {
        ids.push(d.id);
      });
      me.mwConfirm($lang('您确定要删除此群组?')).then(function () {
        PF.ajax("api/org/deleteAddressBookGroup", ids).then(function (res) {
          if (res.result > 0) {
            me.mwMsg($lang("删除成功"));
            me.refreshData();
          }
        });
      });
    },
    selectUnitCancel: function selectUnitCancel() {
      this.closeDialog('unitDialog');
    },
    closeTitleDialog: function closeTitleDialog() {
      this.resetFields();
      this.closeDialog('titleDialog');
    },
    processSelData: function processSelData(loadUserObj) {
      if (loadUserObj) {
        if (loadUserObj.deptUsers) {
          loadUserObj.deptUsers.splice(0, loadUserObj.deptUsers.length);
        } else {
          loadUserObj.deptUsers = [];
        }
        if (loadUserObj.dept) {
          loadUserObj.dept.splice(0, loadUserObj.dept.length);
        } else {
          loadUserObj.dept = [];
        }
      }
      if (this.form.userids) {
        var names = this.form.users.split(',');
        var ids = this.form.userids.split(',');
        for (var i = 0; i < names.length; i++) {
          if (loadUserObj) {
            loadUserObj.deptUsers.push({ id: ids[i], name: names[i] });
          } else {
            this.checkNodes.deptUsers.push({ id: ids[i], name: names[i] });
          }
        }
      } else {
        this.checkNodes.deptUsers = [];
      }
      if (this.form.departmentids) {
        var _names = this.form.departments.split(',');
        var _ids = this.form.departmentids.split(',');
        for (var _i = 0; _i < _names.length; _i++) {
          if (loadUserObj) {
            loadUserObj.dept.push({ id: _ids[_i], name: _names[_i] });
          } else {
            this.checkNodes.dept.push({ id: _ids[_i], name: _names[_i] });
          }
        }
      } else {
        this.checkNodes.dept = [];
      }
    },
    usersLoad: function usersLoad() {
      var me = this;
      if (!this.form.unitId) {
        this.mwMsg('warning', $lang('请选择单位'));
        return;
      }
      var isShowed = this.formSelUnitId;
      this.formSelUnitId = this.form.unitId;
      this.mwRef('loadUsers').show();
      if (isShowed) {
        me.mwRef("loadUsers").mwRef("deptTreeData2").unCheckAll(true);
        setTimeout(function () {
          var loadUserObj = me.mwRef('loadUsers');
          if (loadUserObj.users) {
            loadUserObj.users.splice(0, loadUserObj.users.length);
          }
          me.processSelData(loadUserObj);
          loadUserObj.defaultParams.rootId = me.formSelUnitId;
          loadUserObj.mwRef("deptTreeData2").refresh();
        }, 50);
      }
      this.processSelData();
    },
    refreshData: function refreshData(noRefreshTree) {

      if (!noRefreshTree) {
        this.defaultTreeParams.t = Date.now();
        this.mwRef('groupTree').refresh();
      }
      this.refreshGridData();
    },
    showOuterDept: function showOuterDept() {
      this.showDialog('externalDept');
    },
    saveTitle: function saveTitle() {var _this = this;
      var me = this;
      me.mwRef('ruleForm').validate(function (valid) {
        if (valid) {
          $.post("/api/org/savePersonalGroup", _this.form).then(function (data) {
            me.mwRef('titleDialog').hide();
            me.refreshData();
            me.resetFields();
          });
        }
      });
    },
    handleSortCommand: function handleSortCommand(command) {
      var me = this;
      var multipleSelection = this.mwRef('aa').getMultipleSelection();
      me.doSortSN(command, multipleSelection);
    },
    processSelRowData: function processSelRowData() {
      var me = this;
      this.mwRef('aa').$on("dataLoaded", function (datas) {
        var records = me.mwRef('aa').getMultipleSelection();
        if (records && records.length > 0) {
          var row = records[0];
          _.each(datas, function (v) {if (v.id == row.id || v.userId == row.userId) row = v;});
          me.mwRef('aa').clearSelection();
          me.mwRef('aa').toggleRowSelection(row, true);
        }
      });
    },
    sort: function sort() {
      this.doSortSN("sort");
    },
    up: function up(data) {
      this.doSortSN("up", data);
    },
    down: function down(data) {
      this.doSortSN("down", data);
    },
    top: function top(data) {
      this.doSortSN("top", data);
    },
    bottom: function bottom(data) {
      this.doSortSN("bottom", data);
    },
    doSortSN: function doSortSN(flag, data) {
      var me = this;
      var params = me.curSelParams;
      params.flag = flag;
      if (flag != "sort") {
        if (!data || data.length != 1) {
          this.mwMsg('warning', $lang('请选择一条数据'));
          return;
        }
        params.id = data[0].id;
      }
      PF.ajax("api/org/updateGroupSN", params).then(function (res) {
        if (res.result) {
          me.refreshData(true);
        }
      });
    },
    showDialog: function showDialog(a) {
      this.mwRef(a).show();
    },
    closeDialog: function closeDialog(a) {
      this.mwRef(a).hide();
    },
    closeGroupDialog: function closeGroupDialog() {
      this.closeDialog("dialog");
    },
    groupSure: function groupSure() {
      var me = this;
      var tree = void 0;
      tree = this.mwRef('codeTree');
      var data = tree.getSelected();
      if (!data) {
        this.mwMsg('warning', $lang('请选择群组分类'));
      } else {
        me.form.code = data.name;
        this.closeGroupDialog();
      }
    },

    getDeptUser: function getDeptUser() {
      var dept = this.mwRef('loadUsers').getValue().dept;
      var users = this.mwRef('loadUsers').getValue().users;
      var userids = [],user = [],departmentids = [],departments = [];
      users.forEach(function (item) {
        userids.push(item.id);
        user.push(item.name);
      });
      dept.forEach(function (item) {
        departmentids.push(item.id);
        departments.push(item.name);
      });
      this.form.userids = userids.join();
      this.form.users = user.join();
      this.form.departmentids = departmentids.join();
      this.form.departments = departments.join();
    },
    resetFields: function resetFields() {
      var me = this;
      me.form.id = "";
      me.form.unitName = "";
      me.form.unitId = "";
      me.form.code = "";
      me.form.name = "";
      me.form.sn = "";
      me.form.departmentids = "";
      me.form.departments = "";
      me.form.users = "";
      me.form.userids = "";
      me.form.externalUnit = "";




    },
    showGroupCode: function showGroupCode() {
      var me = this;
      this.mwRef('dialog').show();
      MW.test(function () {
        if (me.mwRef('codeTree'))
        return true;
        return false;
      }, function () {
        me.mwRef('codeTree').refresh();
      }, 50);
    },
    refresh: function refresh() {
      this.resetFields();
      this.mwRef('groupTree').refresh();
    },
    expand: function expand() {
      this.expandFlag = 2;
      this.mwRef('groupTree').openAll();
    },
    closed: function closed() {
      this.expandFlag = 1;
      this.mwRef('groupTree').closeAll();
    },
    externalSure: function externalSure() {
      var outerDept = this.outerDept.split("\n");
      this.form.externalUnit = outerDept.join();





      this.mwRef('externalDept').hide();
    },
    treeDataFilter: function treeDataFilter(data) {
      if (data && window.$currentBrowserLanguage === 'en') {
        data.forEach(function (d) {return d.text = d.Englishname || d.text;});
      }
    } } };

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);



































































































var _loadUsers = __webpack_require__(140);var _loadUsers2 = _interopRequireDefault(_loadUsers);
var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  name: 'personal-outer-org',
  components: {
    loadUsers: _loadUsers2.default },

  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'userInfo',
  'expUser'])),


  data: function data() {
    var me = this;
    return {
      isLimit: false,
      layout: [],
      selectUnitId: '',
      form: {
        id: '',
        code: '外单位',
        name: '',
        Englishname: '',
        sn: 1,
        unitName: '',
        unitId: '',
        create_user: '',
        identifier: '' },

      expandFlag: 2,
      outerOrgTreeUrl: this.mwUrl('/api/org/getGroupTreeByType'),
      defaultTreeParams: { type: 'personal_outerOrg' },
      selCode: '',
      selUnitId: '',
      selUnitName: '',
      formRules: {
        unitName: [
        { required: true, message: $lang("请选择所属单位"), trigger: 'change' }],

        name: [
        { required: true, message: $lang("请输入外单位名称"), trigger: 'blur' }] },


      defaultParams: {
        type: 'personal_outerOrg' } };


  },
  mounted: function mounted() {
    var me = this;
    if (!this.userInfo.developer) {
      if (this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0) {
        this.defaultParams.unitId = this.$store.getters.curUnit[0].id;
      }
    } else {
      this.defaultParams.unitId = this.userInfo.owner;
    }
    this.defaultTreeParams.create_user = this.userInfo.loginId;
    this.defaultParams.create_user = this.userInfo.loginId;
    me.layout = [
    [{
      span: 0,
      type: 'menu',
      label: $lang('个人外单位管理'),
      api: 'org.listGroupDataByType',
      defaultParams: me.defaultParams,
      columns: [
      { type: 'selection' }, { prop: 'sn', width: '55', label: $lang('序号') },
      { prop: 'name', label: $lang('外单位名称'), slot: { type: "href", func: me.openForm } },
      { prop: 'Englishname', label: $lang('外单位英文名称'), width: '220', tooltip: true },
      { prop: 'identifier', label: $lang('外单位编号'), width: '130', tooltip: true }] },

    {
      span: 14,
      type: 'button',
      items: [{
        label: $lang('添加'),
        func: me.addTitle },
      {
        label: $lang('删除'),
        func: me.deleteGroup,
        icon: "el-icon-delete" }],
      suffixSlot: "dropDown" },
    {
      span: 6,
      type: 'searchText',
      name: 'name',
      tip: $lang('外单位名称'),
      offset: 4,
      func: me.search }]];


    this.mwRef('groupTree').renderTree();
  },
  methods: {
    changed: function changed(data) {
      var me = this;
      if (!data.id) {
        return;
      }
      var unitText = "";
      if (data.code) {
        me.defaultParams.unitId = data.unitId;
        unitText = data.unitName;
        me.defaultParams.code = data.code;
        me.selCode = data.code;
      } else {
        delete me.defaultParams.code;
        me.selCode = "";
        me.defaultParams.unitId = data.id;
        unitText = data.text;
      }
      me.selUnitId = me.defaultParams.unitId;
      me.selUnitName = unitText;
      me.reloadData();
    },
    expand: function expand() {
      this.expandFlag = 2;
      this.mwRef('groupTree').openAll();
    },
    closed: function closed() {
      this.expandFlag = 1;
      this.mwRef('groupTree').closeAll();
    },
    reloadData: function reloadData() {
      var me = this;
      var tableObj = me.mwRef('aa');
      if (!tableObj || !tableObj.refreshTableDataList) return;
      $.post("/api/org/listGroupDataByType", me.defaultParams, function (res) {
        tableObj.refreshTableDataList(res.result);
      });
    },
    addTitle: function addTitle() {
      this.resetFields();
      if (this.userInfo.developer) {
        this.form.unitId = this.userInfo.owner;
        this.form.unitName = "美络科技";
      } else {
        this.form.unitId = this.selUnitId || this.$store.getters.curUnit[0].id;
        this.form.unitName = this.selUnitName || this.$store.getters.curUnit[0].name;
      }
      this.form.create_user = this.userInfo.name;
      this.form.code = $lang(this.selCode || "外单位");
      this.form.create_user = this.userInfo.loginId;
      this.showDialog('titleDialog');

    },
    openForm: function openForm(data) {
      var fd = {};
      fd = _.assign(fd, data);
      this.form = fd;
      this.showDialog('titleDialog');
    },
    deleteGroup: function deleteGroup(data) {
      var me = this;
      if (!data || data.length === 0) {
        this.mwMsg('warning', $lang('请选择数据'));
        return;
      }
      var ids = [];
      $.each(data, function (i, d) {
        ids.push(d.id);
      });
      me.mwConfirm($lang('您确定要删除此外部单位吗?')).then(function () {
        PF.ajax("api/org/deleteAddressBookGroup", ids).then(function (res) {
          if (res.result > 0) {
            me.mwMsg($lang("删除成功"));
            me.refreshData();
          }
        });
      });
    },
    closeTitleDialog: function closeTitleDialog() {
      this.resetFields();
      this.closeDialog('titleDialog');
    },

    refreshData: function refreshData(noRefreshTree) {
      if (!noRefreshTree) {

        this.mwRef('groupTree').refresh();
      } else {
        this.reloadData();
      }
    },
    saveTitle: function saveTitle() {var _this = this;
      var me = this;
      me.mwRef('ruleForm').validate(function (valid) {
        if (valid) {
          me.form.type = "personal_outerOrg";
          $.post("/api/org/saveOuterOrg", _this.form).then(function (data) {
            me.mwRef('titleDialog').hide();
            me.refreshData();
            me.resetFields();
          });
        }
      });
    },
    handleSortCommand: function handleSortCommand(command) {
      var me = this;
      var multipleSelection = this.mwRef('aa').getMultipleSelection();
      me.doSortSN(command, multipleSelection);
    },
    sort: function sort() {
      this.doSortSN("sort");
    },
    up: function up(data) {
      this.doSortSN("up", data);
    },
    down: function down(data) {
      this.doSortSN("down", data);
    },
    top: function top(data) {
      this.doSortSN("top", data);
    },
    bottom: function bottom(data) {
      this.doSortSN("bottom", data);
    },
    doSortSN: function doSortSN(flag, data) {
      var me = this;
      var params = me.defaultParams;
      params.flag = flag;
      if (flag != "sort") {
        if (!data || data.length != 1) {
          this.mwMsg('warning', $lang('请选择一条数据'));
          return;
        }
        params.id = data[0].id;
      }
      params.targetName = "外部单位";
      PF.ajax("api/org/updateGroupSN", params).then(function (res) {
        if (res.result) {
          me.refreshData(true);
        }
      });
    },
    showDialog: function showDialog(a) {
      this.mwRef(a).show();
    },
    closeDialog: function closeDialog(a) {
      this.mwRef(a).hide();
    },
    closeGroupDialog: function closeGroupDialog() {
      this.closeDialog("dialog");
    },
    resetFields: function resetFields() {
      var me = this;
      me.form.id = "";
      me.form.unitName = "";
      me.form.unitId = "";
      me.form.code = "";
      me.form.name = "";
      me.form.sn = "";
      me.form.create_user = "";
      me.form.identifier = "";
    } } };

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _stringify = __webpack_require__(24);var _stringify2 = _interopRequireDefault(_stringify);var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _promise = __webpack_require__(19);var _promise2 = _interopRequireDefault(_promise);var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);










































































var _vuex = __webpack_require__(9);
var _vue = __webpack_require__(11);var _vue2 = _interopRequireDefault(_vue);
var _componentRevision = __webpack_require__(1285);var _componentRevision2 = _interopRequireDefault(_componentRevision);
var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);
var _formExpContext = __webpack_require__(307);var _formExpContext2 = _interopRequireDefault(_formExpContext);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  name: "mw-form-edit",
  components: {
    componentRevision: _componentRevision2.default },

  props: {
    propAppId: String,
    propSysId: String,
    propModuleId: String },

  data: function data() {
    var appId = this.propAppId || this.$route.params.appId;
    var sysId = this.propSysId || this.$route.params.sysId;
    var moduleId = this.propModuleId || this.$route.params.moduleId;
    return {
      formList: [],
      form: {
        name: '',
        id: '' },

      relateFormName: '',
      selKey: '',
      addFormItemFlag: false,
      versionNumber: 1,

      showButton: false,
      appId: appId,
      sysId: sysId,
      moduleId: moduleId,
      formId: '',
      key: '',
      isRelation: false,
      $newForm: undefined,
      formData: {},

      editFormFooterButton: [
      {
        label: '取消',
        func: this.editFormCancel },

      {
        label: '保存',
        func: this.editFormSave }],



      footerFormButton: [
      {
        label: '关闭',
        func: this.closeFormDialog },

      {
        label: '删除',
        func: this.deleteFormItem },

      {
        label: '上移',
        func: this.upFormItem },

      {
        label: '下移',
        func: this.downFormItem },

      {
        label: '新建表单项',
        func: this.addFormItem },

      {
        label: '编辑表单项',
        func: this.editFormItem },

      {
        label: '编辑表单',
        func: this.editForm }],



      footerButton: [{
        label: '添加新版本',
        func: this.addNewVersion },
      {
        label: '编辑',
        func: this.editVersion },
      {
        label: '启用',
        func: this.enableVersion },
      {
        label: '删除',
        func: this.deleteVersion },
      {
        label: '回收站',
        func: this.recycleBinManager }],


      recycleBinFooterButton: [
      {
        label: '恢复',
        func: this.recoverVersion },

      {
        label: '彻底删除',
        func: this.cascadeDeleteVersion },
      {
        label: '返回',
        func: this.returnVersionManager }],


      versionList: [],
      versionDelList: [],

      selDelVersionId: 0,
      selDelVersion: 0,
      selDelStatus: 0,

      curVersionId: '',
      curVersion: 0,
      curStatus: 0,

      selVersionId: '',
      selVersion: 0,
      selStatus: 0,

      editable: false,






      extraFormField: {} };

  },
  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'expUser',
  'initInfo'])),


  mounted: function mounted() {
    this.loadForm();
  },
  methods: {

    selectForm: function selectForm(id) {
      var me = this;
      this.selKey = id;
    },

    editSelectForm: function editSelectForm(id) {
      var me = this;
      me.key = id;
      me.selKey = id;
      me.editForm();
    },

    editFormCancel: function editFormCancel() {
      this.mwRef('editFormDialog').hide();
    },

    editFormSave: function editFormSave() {var _this = this;
      var me = this;
      var data = {};
      data.name = me.form.name;
      if (!data.name) {
        this.mwMsg('warning', "名称不能为空");
        return;
      }
      if (me.addFormItemFlag) {
        data.id = me.form.id;
      } else {
        data.key = me.form.id;
      }
      PF.ajax("api/app/createFormItem", data, me.moduleId, me.appId).then(function (data) {
        if (me.key != data.result.key) {
          me.key = data.result.key;
          me.selKey = me.key;
          me.loadForm();
        }
        me.isDirty = false;
        me._refreshFormList();
        _this.mwRef('editFormDialog').hide();
      });
    },
    upFormItem: function upFormItem() {
      var me = this;
      if (me.formList.length == 0) {
        return;
      }
      PF.ajax("api/app/upModuleFormItem", { key: me.selKey }, me.moduleId, me.appId).then(function (data) {
        me._refreshFormList();
      });
    },
    downFormItem: function downFormItem() {
      var me = this;
      if (me.formList.length == 0) {
        return;
      }
      PF.ajax("api/app/downModuleFormItem", { key: me.selKey }, me.moduleId, me.appId).then(function (data) {
        me._refreshFormList();
      });
    },
    deleteFormItem: function deleteFormItem() {var _this2 = this;
      var me = this;
      me.mwConfirm('您确定要删除此关联表单项吗').then(function () {
        PF.ajax("api/app/deleteModuleFormItem", { key: me.selKey }, me.moduleId, me.appId).then(function (data) {
          if (me.key == me.selKey) {
            me.key = data.result.key;
            me.selKey = me.key;
            _this2.loadForm();
          }
          me._refreshFormList();
        });
      }).catch(function () {

      });

    },
    closeFormDialog: function closeFormDialog() {
      this.mwRef('formDialog').hide();
    },

    addFormItem: function addFormItem() {
      var me = this;
      me.addFormItemFlag = true;
      me.form.name = "";
      me.form.id = "";
      me.relateFormName = "";

      me.mwRef('editFormDialog').show();
    },
    editFormItem: function editFormItem() {
      var me = this;
      me.addFormItemFlag = false;
      me.form.name = '';
      me.formList.forEach(function (v) {
        if (v.id == me.selKey) {
          me.form.name = v.name;
          me.form.id = me.selKey;
        }
      });

      me.mwRef('editFormDialog').show();
    },

    editForm: function editForm() {
      this.mwRef('formDialog').hide();
      this.key = this.selKey;
      this.loadForm();
    },
    _refreshFormList: function _refreshFormList() {
      var me = this;
      PF.ajax("api/app/listModuleForm", { moduleId: me.moduleId, appId: me.appId }).then(function (data) {
        me.formList = data.result;
      });
    },

    formManage: function formManage() {
      var me = this;
      this.selKey = this.key;
      me._refreshFormList();
      me.mwRef('formDialog').show();
    },


    showDesign: function showDesign() {
      this.$newForm.showDesign(true);
    },

    showJsEditor: function showJsEditor() {
      this.$newForm.showJsEditor(true);
    },

    preview: function preview() {var _this3 = this;

      var data = this.getDefinitionData();
      this.lintScript(data.script).then(function (result) {
        if (!result) return;
        _this3.$newForm.preview();
      });
    },
    lintScript: function lintScript(script) {
      if (!script) return _promise2.default.resolve(true);
      return _util2.default.esLintMsg(script, { title: "语法错误，注意不要用es6语法" }).then(function (result) {
        return result;
      });
    },
    getDefinitionData: function getDefinitionData() {
      var me = this;
      var designerTabBtn = $(me.$el).find(".x-fd-cmd-design");
      var isDesignerNotActive = !designerTabBtn.is(".active");
      if (isDesignerNotActive) {

        designerTabBtn.click();
      }
      var data = me.$newForm.getDefinitionData();
      if (isDesignerNotActive) {
        $(me.$el).find(".x-fd-cmd-js").click();
      }
      return data;
    },

    save: function save(flag) {
      var me = this;
      var data = me.getDefinitionData();
      var publishForm = flag == undefined ? false : flag;




      if (!data.name) {
        me.mwMsg('warning', '请输入表单属性【名称】');
        return false;
      }
      me.lintScript(data.script).then(function (result) {
        if (!result) return;
        var sp = {
          publishForm: publishForm,
          name: data.name,
          code: data.code,
          content: data,
          customId: data.customId,
          owner: me.sysId,
          "#versionNumber": me.versionNumber,
          "#sync": true };

        function walkItems(items, fn) {
          for (var i = 0; i < items.length; i++) {
            var it = items[i];
            if (!fn(it)) {
              return false;
            }
            if (it.items) {
              var f = walkItems(it.items, fn);
              if (!f) return false;
            }
          }
          return true;
        }
        var isInputValid = walkItems(data.items, function (it) {
          if (_.isFunction(it.isFormField) && it.isFormField() && !it.name) {
            PF.message("warning", "请填写域名.");
            setTimeout(function () {
              $(me.$el).find("[wid='" + it.id + "']").mousedown();
            }, 500);
            return false;
          } else {
            return true;
          }
        });
        if (!isInputValid) return;
        me.mwApi.app.saveModuleForm(sp, me.formId, me.moduleId, me.key, me.curVersion, me.appId).then(function (res) {
          me.$store.dispatch('setAppTreeItemName', { id: me.moduleId, name: data.name });
          me.versionNumber = res.result['#versionNumber'] || 1;
          if (publishForm) {
            me.mwMsg('发布成功');
            me.curStatus = 1;
            $(me.$el.querySelector('.x-fd-cmd-save-enable')).hide();
          } else {
            me.mwMsg('保存成功');
          }
          me.isDirty = false;
        });
      });
    },


    createNewForm: function createNewForm() {
      var me = this;
      me.mwConfirm('确定创建新表单？').then(function () {
        me.formData = {};
        me.mwApi.app.changeModuleForm('', me.key, me.moduleId, me.appId).then(function (res) {
          me.key = res.result.id;
          me.selKey = me.key;
          me.loadForm();
        });
      }).catch(function () {
      });
    },

    relateOtherForm: function relateOtherForm() {
      var me = this;
      PF.show('treeTable', {
        url: this.mwUrl("/api/app/listApplicationTree"), treeDefaultParams: { category: 'form' },
        selectFirst: false, clearBtn: false,
        title: '选择关联次表单', sureName: '确定', changed: function changed(data) {
          var me = this;
          me.defaultParams = { code: data.code, category: 'form' };
        }, api: 'app.listApplicationItemsByCode', showSelected: true, singleSelect: false, size: 'large_small' },

      function (res) {
        var ids = [];
        if (res && res.length > 0) {
          res.forEach(function (v) {
            ids.push(v.id);
          });
        }
        me.mwApi.app.changeModuleRelateForm(ids, me.formId, me.moduleId, me.appId).then(function (res) {
        });

      });
    },


    relateSelectForm: function relateSelectForm() {
      var me = this;
      PF.show('treeTable', {
        url: this.mwUrl("/api/app/listApplicationTree"), treeDefaultParams: { category: 'form' },
        selectFirst: false, clearBtn: true,
        title: '选择关联表单', sureName: '确定', changed: function changed(data) {
          var me = this;
          me.defaultParams = { code: data.code, category: 'form' };
        }, api: 'app.listApplicationItemsByCode', singleSelect: true },

      function (res) {
        if (res && res.length > 0) {
          if (!me.form.name)
          me.form.name = res[0].name;
          me.relateFormName = res[0].name;
          me.form.id = res[0].id;
        } else {
          me.relateFormName = '';
          me.form.id = '';
        }
      });
    },

    cancelRalateForm: function cancelRalateForm() {
      var me = this;
      PF.confirm('确定要取消表单关联？').then(function () {
        me.mwApi.app.copeForm(me.formId, me.key, me.moduleId, me.appId).then(function (res) {
          me.formId = res.result.formId;
          me.key = res.result.key;
          me.selKey = me.key;
          me.isRelation = false;
          me.loadForm();
        });
      });
    },

    relateForm: function relateForm() {
      var me = this;
      PF.show('treeTable', {
        url: this.mwUrl("/api/app/listApplicationTree"), treeDefaultParams: { category: 'form' },
        selectFirst: false, clearBtn: false, buttonsScript: 'me.footerButton.push({label:\'\u5173\u8054\u5E76\u590D\u5236\', func:function(){\n          var data = me.mwRef(\'dataTable\').getMultipleSelection();\n          if(data){\n            data.$copeForm=true;\n            me.params.func(data);\n            me.selectCancel();\n          }\n        }})',







        title: '选择关联表单', sureName: '关联', changed: function changed(data) {
          var me = this;
          me.defaultParams = { appId: data.id, category: 'form' };
        }, api: 'app.listComponentsByTypeAndAppId', singleSelect: true },

      function (res) {
        if (res && res.length > 0) {
          me.formId = res[0].id;
          if (res.$copeForm) {
            me.mwApi.app.copeForm(me.formId, me.key, me.moduleId, me.appId).then(function (res) {
              me.formId = res.result.formId;
              me.key = res.result.key;
              me.selKey = me.key;
              me.loadForm();
            });
          } else {
            me.mwApi.app.changeModuleForm(me.formId, me.key, me.moduleId, me.appId).then(function (res) {
              me.key = res.result.id;
              me.selKey = me.key;
              me.loadForm();
            });
          }
        }
      });
    },

    loadForm: function loadForm(versionId) {
      var me = this;

      PF.ajax("api/app/getModuleFormConfig", { versionId: versionId, key: me.key }, me.moduleId, me.appId).then(function (data) {
        me.formLayOut(data.result);
      });




    },

    formLayOut: function formLayOut(data) {
      var me = this,win = $(window),offHeight = 60,content = data.content;
      var mwForm = $(me.$el.querySelector('.mw-form_id'));
      mwForm.height(win.height() - offHeight);
      mwForm.width(win.width());
      mwForm.empty();
      me.curStatus = data.status;
      me.curVersion = data.version;
      me.versionNumber = data['#versionNumber'] || 1;
      me.selStatus = data.status;
      me.selVersion = data.version;
      if (data.attr && data.attr.isRelation) {
        me.isRelation = true;
      }
      me.key = data.key;
      me.selVersionId = data.formId;
      me.formId = data.formId;

      var con = void 0;
      con = content[me.formId];
      if (!con) {
        con = { customId: me.formId, name: data.formName ? data.formName : data.moduleName };
      } else {
        if (!con.customId)
        con.customId = me.formId;
      }

      me.formData = con;
      var formValue = me.mwLodash.assign({}, _.pickBy(me.initInfo, function (v, k) {return _.startsWith(k, "init");}));

      $WR.ready(function (manager) {
        function fnDataItemResolver(dict, params, setDataItems) {
          if ($.isFunction(params) && !setDataItems) {
            setDataItems = params;
            params = {};
          }
          me.mwApi.data.getDict(dict, params).then(function (data) {
            if (data.result && data.result.value) {
              var v = data.result.value.split(',');
              var v1 = [];
              var items = [];
              v.forEach(function (d) {
                v1 = d.split('|');
                items.push({ text: v1[1] || v1[0], value: v1[0] });
              });
              setDataItems(items);
            }
          });
        }




        function fnDialogResolver(type, ops) {

          if ('dictionary-selector' === type) {var _PF$show;
            PF.show('treeTable', (_PF$show = {
              url: me.mwUrl("/api/app/listApplicationTree"), size: 'small_large', treeDefaultParams: { category: 'application' },
              selectFirst: false, clearBtn: false, title: '选择字典' }, (0, _defineProperty3.default)(_PF$show, 'clearBtn', true), (0, _defineProperty3.default)(_PF$show, 'changed', function changed(data) {
              var me = this;
              me.defaultParams = {
                applicationId: data.id };

            }), (0, _defineProperty3.default)(_PF$show, 'api', 'data.listDictByApp'), (0, _defineProperty3.default)(_PF$show, 'singleSelect', true), _PF$show),
            function (res) {
              if (res && res.length > 0) {
                ops.setValue(res[0].id, res[0].name, res[0].applicationId);
              } else {
                ops.setValue("", "", "");
              }
            });
          }

          if ('action-selector' === type) {
            var val = ops.getValue();
            if (val && val[0]) {
              val = val[0];
            } else {
              val = '';
            }

            PF.show('treeTable', {
              url: me.mwUrl("/api/app/listActionComponentByTypeTree"), treeDefaultParams: { type: "系统分类/表单", flag: 0 },
              size: 'small_large',
              selectFirst: true, asyncLoadOnce: true, clearBtn: true, title: '选择动作脚本', changed: function changed(data) {
                var me = this;
                me.defaultParams = { type: data.code, flag: 0 };
              }, api: 'app.getAllButton', singleSelect: true },
            function (res) {
              if (res && res.length > 0) {
                ops.setValue(res[0].action, res[0].name);
              } else {

                ops.setValue("", "");
              }
            });
          }
          if ('view-selector' === type) {
            PF.show('treeTable', {
              title: "选择视图",
              url: me.mwUrl("/api/app/listApplicationTree"), treeDefaultParams: { category: 'view' },
              selectFirst: false,
              clearBtn: false,
              changed: function changed(data) {
                var me = this;
                me.defaultParams = {
                  applicationId: data.id,
                  category: 'view',
                  simpleResult: true };

              }, api: 'app.getAppModuleItems', singleSelect: true },
            function (data) {
              if (data && data.length > 0) {
                ops.setValue(data[0].id, data[0].name);
              }
            });
          }


          if ('module-selector' === type) {
            PF.show('treeTable',
            {
              url: me.mwUrl("/api/app/listApplicationTree"),
              title: '选择关联模块',
              treeDefaultParams: { category: 'module_flow,module_normal' },
              selectFirst: false, clearBtn: false,
              changed: function changed(data) {
                var me = this;
                me.defaultParams = {
                  applicationId: data.id,
                  category: 'module_flow,module_normal',
                  simpleResult: true };

              },
              api: 'app.getAppModuleItems' },
            function (data) {
              if (data && data.length > 0) {
                var ids = [];
                var names = [];
                data.forEach(function (d) {
                  ids.push(d.id);
                  names.push(d.name);
                });
                ops.setValue(ids.join(), names.join());
              }
            });
          }

          if ('formula-generator' === type) {
            var _data = ops.getValue();
            var defData = me.$newForm.getDefinitionData();

            var fieldXTypes = {
              Text: 1,
              Textarea: 1,
              Select: 1,
              CheckboxGroup: 1,
              RadioGroup: 1,
              Number: 1,
              DateTime: 1,
              Currency: 1,
              Email: 1,
              Phone: 1,
              Mobile: 1,
              PhoneOrMobile: 1,
              Hidden: 1 };

            var fields = [{
              name: "编辑状态",
              value: "$fo.textMode",
              operators: 12,
              dataType: "boolean",
              selectable: [{
                name: "是",
                value: "true" },

              {
                name: "否",
                value: "false" }] }];


            PF.walkTree([defData], "items", function (item) {
              if (fieldXTypes[item.xtype]) fields.push({ value: "$f." + item.name, name: item.label || item.name });
            });
            _data = _data || {};
            _data.extraFields = fields;
            PF.formulaGenerator(_data, function (data) {
              ops.setValue(data);
            });
          }
        }

        function fnImbeddedObjResolver(objId) {
          return new function (formField) {
            var value = [];
            var component;
            var $data;var $obj;
            PF.apply(this, {
              init: function init(d, obj) {
                $data = d;$obj = obj;
              },
              onChange: function onChange(name, val, d) {
                $data = d;



                if (component && component.onChange) {
                  component.onChange(name, val, d);
                }
              },
              mount: function mount(fnMount) {
                var html;
                var config = (0, _assign2.default)({
                  expUser: me.expUser,
                  getForm: function getForm() {
                    return me.$newForm._tw;
                  }, getCurrentObject: function getCurrentObject() {
                    return $obj;
                  },
                  getFormObject: function getFormObject() {
                    return me;
                  },
                  $previewMode: true,
                  getFormValue: function getFormValue() {
                    return {};
                  },
                  getConfig: function getConfig() {
                    return $data;
                  },
                  getData: function getData() {
                    return { businessId: $uuid(), formId: $uuid(), tempBusinessId: $uuid() };
                  } });

                switch (objId) {
                  case 'attachment-list':{
                      component = new (_vue2.default.component('form-attachment-list'))({ params: me._data, config: config });
                      fnMount(component.$mount().$el);
                      break;
                    }
                  case 'attachment-list-min':{
                      component = new (_vue2.default.component('form-attachment-list-min'))({ params: me._data, config: config });
                      fnMount(component.$mount().$el);
                      break;
                    }
                  case 'document-editor':{
                      component = new (_vue2.default.component('form-document-editor'))({ params: me._data, config: config });
                      fnMount(component.$mount().$el);
                      break;
                    }
                  case 'comment-list':{
                      component = new (_vue2.default.component('form-comment-list'))({ params: me._data, config: config });
                      fnMount(component.$mount().$el);
                      break;
                    }
                  case 'comment-list-min':{
                      component = new (_vue2.default.component('form-comment-list-min'))({ params: me._data, config: config });
                      fnMount(component.$mount().$el);
                      break;
                    }
                  case 'imbedded-view':{
                      component = new (_vue2.default.component('form-imbedded-view'))({ params: me._data, config: config });
                      fnMount(component.$mount().$el);
                      break;
                    }
                  case 'rel-file-selection':{
                      component = new (_vue2.default.component('form-rel-file-selection'))({ params: me._data, config: config });
                      fnMount(component.$mount().$el);
                      break;
                    }
                  default:{
                      if ($data.pageType === "page") {
                        var _component = PF.createVue({
                          template: "<mw-inner-page :pageId='pageId' noWrap :params='params'></mw-inner-page>",
                          data: {
                            pageId: objId,
                            params: { data: me._data, config: config } } });


                        fnMount(_component.$mount().$el);
                      } else if ($data.pageType === "pageData" && $obj.getPageData) {
                        var pageData = $obj.getPageData();
                        pageData.params = { data: me._data, config: config };
                        component = PF.createVue(pageData);
                        fnMount(component.$mount().$el);
                      }
                    }}

                if (html) {
                  fnMount($('<div>' + html + '</div>'));
                }
                return component;
              },
              onEvent: function onEvent(args) {var _this4 = this;
                if (component) {
                  if (component.dealWithEvent) {
                    component.dealWithEvent(args);
                  }
                } else {
                  if (args.dd.viewId && args.data.id) {
                    me.mwApi.app.getApplicationItems([args.dd.viewId], "").then(function (res) {
                      var mixId = res.result[0].content.table.moduleId;
                      if (mixId) {
                        var _me = _this4;
                        var p = {};
                        p.businessId = args.data.id;
                        p.moduleId = mixId;
                        p.size = 'large_large';
                        p.type = 'normal';
                        p.editMode = true;
                        p.appId = '';
                        PF.show('normalForm', p, function () {
                        });
                      }
                    });

                  }
                }
              },
              setValue: function setValue(value) {

              },
              getValue: function getValue() {

              },
              setReadOnly: function setReadOnly() {
              },
              destroy: function destroy() {
                if (component) {
                  component.$destroy();
                  $(component.$el).remove();
                }
              },
              show: function show(ops) {
                var config = (0, _assign2.default)({
                  getForm: function getForm() {
                    return me.$newForm;
                  }, getCurrentObject: function getCurrentObject() {
                    return $obj;
                  },
                  $previewMode: true,
                  getFormValue: function getFormValue() {
                    return {};
                  }, getConfig: function getConfig() {
                    return $data;
                  }, getData: function getData() {
                    return { businessId: $uuid(), formId: $uuid(), tempBusinessId: $uuid() };
                  } });


                switch (objId) {
                  case 'department-selection':{

                      var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                      PF.show('orgSelect', {
                        multiple: multiple,
                        config: config,
                        value: ops.getValue() },
                      function (data) {
                        ops.setValue(data);
                      });
                      break;
                    }
                  case 'user-selection':{
                      var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                      PF.show('orgSelect', {
                        multiple: multiple,
                        config: config,
                        value: ops.getValue() },
                      function (data) {
                        ops.setValue(data);
                      });
                      break;
                    }
                  case 'department-user-selection':{

                      var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                      PF.show('orgSelect', {
                        multiple: multiple,
                        config: config,
                        value: ops.getValue() },
                      function (data) {
                        ops.setValue(data);
                      });
                      break;
                    }
                  case 'custom-selection':{

                      var multi = !$data.singleSel;
                      PF.show('viewSelect', {
                        id: $data.viewId,
                        multi: multi,
                        config: config },
                      function (data) {
                        if (data) {
                          ops.setValue(data);
                        } else {
                          ops.setValue();
                        }
                      });
                      break;
                    }
                  default:{
                      if ($data.pageType == "page") {
                        config.setExtraFormField = function (d) {
                          me.extraFormField = d;
                        };
                        config.$obj = $obj;
                        config.ops = ops;
                        var params = { config: config, modelId: me.moduleId };
                        PF.dialog("mw-inner-page", { title: $data.pageTitle, width: $data.pageWidth, height: $data.pageHeight,
                          propsData: { pageId: objId, params: params } });
                      }
                    }}


              },
              hide: function hide(ops) {
                ops.setValue(value);
              } });

          }(this);
        }

        function fnDataResolver(args) {
          if ('org-sel-default-value' === args.dataId) {
            me.mwApi.org.getCurrent(args.params).then(function (v) {
              args.fnSetData(v);
            });
          }
        }

        function fnRepositoryResolver(setRepositories)
        {
          me.mwApi.app.getComponentRepositoryConfig().then(function (v) {


            var repositories = v.result.repositories;

            var usedRepositories = v.result.usedRepositories;
            if (!usedRepositories || usedRepositories.length === 0) {
              usedRepositories = [{ id: 'REP-INTERNAL-COMMON' }, { id: 'REP-INTERNAL-OA' }];
            }
            setRepositories({
              repositories: repositories,
              usedRepositories: usedRepositories });

          });
        }
        manager.create({
          xtype: 'DesignerForm',
          $dd: JSON.parse((0, _stringify2.default)(con)),
          values: formValue,
          layout: 2,
          user: me.expUser,
          resolvers: {
            fnDataResolver: fnDataResolver,
            fnDataItemResolver: fnDataItemResolver,
            fnImbeddedObjResolver: fnImbeddedObjResolver,
            fnDialogResolver: fnDialogResolver,
            fnRepositoryResolver: fnRepositoryResolver } },

        function (x) {
          me.$newForm = x;
          var expContext = (0, _assign2.default)({
            "$userName": PF.userInfo.name,
            "$loginId": PF.userInfo.loginId,
            "$roleNames": PF.userInfo.roleNames,
            "$deptIdChain": PF.userInfo.deptIdChain,
            '$allIdentityRoleNames': PF.userInfo.allIdentityRoleNames,
            "$ext": _formExpContext2.default },
          _formExpContext2.default);
          x.setExpressionContext(expContext);
          x.on('afterRender', function () {
            var div = $('<div style="border-bottom:1px solid #e7eaec;text-align: right;float: left;margin-left: 70px;">\n                        <div class="x-fd-toolbar"><div class="btn-group">\n                          <button class="btn btn-default btn-sm x-fd-cmd-design active" type="button"><i class="fa fa-newspaper-o fa-fw"></i>\u8BBE\u8BA1</button>\n                          <button class="btn btn-default btn-sm x-fd-cmd-js" type="button"><i class="fa fa-terminal fa-fw"></i>\u811A\u672C</button>\n                        </div></div>\n                      </div>\n                      <div style="border-bottom:1px solid #e7eaec;text-align: right;">\n                        <div class="x-fd-toolbar">\n                                <button class="btn btn-primary btn-sm x-fd-cmd-relateForm" type="button">\u5173\u8054\u8868\u5355</button>\n                                <button class="btn btn-primary btn-sm x-fd-cmd-cancel-relation" type="button" style="display:none;">\u53D6\u6D88\u5173\u8054</button>\n                                <button class="btn btn-primary btn-sm x-fd-cmd-versionManage" type="button">\u7248\u672C\u7BA1\u7406</button>\n                                <button class="btn btn-primary btn-sm x-fd-cmd-revision" type="button">\u4FEE\u6539\u8BB0\u5F55</button>\n                                <button class="btn btn-primary btn-sm x-fd-cmd-myPreview" type="button"><i class="fa fa-eye fa-fw"></i>\u9884\u89C8</button>\n                                <button class="btn btn-primary btn-sm x-fd-cmd-save" type="button"><i class="fa fa-save fa-fw"></i>\u4FDD\u5B58</button>\n                                <!--<button class="btn btn-primary btn-sm x-fd-cmd-save-enable" type="button"><i class="fa fa-save fa-fw"></i>\u4FDD\u5B58\u5E76\u542F\u7528</button>-->\n                            </div>\n                  </div>');
















            if (me.isRelation) {
              $('.x-fd-cmd-cancel-relation', div).show();
            }
            if (me.formId)
            $('.x-fd-cmd-save', div).parent().prepend("<span>ID:" + me.formId + "&nbsp;&nbsp;</span>");
            me.$newForm.getToolbarPanelEl().append(div);

            div.find(".btn").on("click", function (e) {
              var text = $(e.target).text();
              switch (text) {
                case "新建表单":
                  me.createNewForm();
                  break;
                case "表单管理":
                  me.createNewForm();
                  break;
                case "关联表单":
                  me.relateForm();
                  break;
                case "取消关联":
                  me.cancelRalateForm();
                  break;
                case "版本管理":
                  me.versionManage();
                  break;
                case "修改记录":
                  me.revisionLog();
                  break;
                case "保存":
                  me.save(me.curStatus == '0');
                  break;
                case "预览":
                  me.preview();
                  break;
                default:}





















            });
            me.showButton = true;
            setTimeout(function () {
              x.resize(win.width(), win.height() - offHeight);
            }, 500);
            me.isDirty = false;
          });
          win.resize(function () {
            mwForm.height(win.height() - offHeight);
            mwForm.width(win.width());
            x.resize(win.width(), win.height() - offHeight);
          });
          x.on('change', function (a, b) {
            me.isDirty = true;
          });
          x.on('repositoryChange', function (usedRepositories)
          {
            me.mwApi.app.saveComponentRepositoryConfig({
              usedRepositories: usedRepositories }).
            then(function (res) {
              me.mwMsg('组件库设置成功！');
            });
          });
          x.render(mwForm);
          x.on('save', function (data) {

          });
        });
      });
    },

    formDataEqual: function formDataEqual() {
      var data = PF.decode(PF.encode(this.$newForm.getDefinitionData()));
      return PF.Object.equals(data, this.formData);
    },


    saveValues: function saveValues() {
      var me = this,data = me.$newForm.getDefinitionData();
      me.mwApi.app.setApplicationItemProperties({
        name: data.title,
        content: data,
        customId: data.customId },
      me.formId, me.appId).then(function (res) {
        var params = {
          moduleId: me.moduleId,
          appId: me.appId };

        me.$store.dispatch('getFormConfig', params);
      });
    },


    addNewVersion: function addNewVersion() {
      var me = this;
      if (me.versionList.length == 0) {
        me.mwRef('versionDialog').hide();
        return;
      }
      this.mwApi.app.createModuleForm(me.moduleId, me.selVersionId, me.appId).then(function (data) {
        me.loadForm(data.result.id);
        me.mwRef('versionDialog').hide();
      });
    },


    deleteVersion: function deleteVersion() {var _this5 = this;
      var me = this;
      if (me.versionList.length == 0) {
        me.mwRef('versionDialog').hide();
        return;
      }
      if (me.selStatus == '1') {
        me.mwMsg('warning', '启用版本无法删除');
        return;
      }
      if (me.selStatus == '2') {
        me.mwMsg('warning', '历史版本无法删除');
        return;
      }
      if (me.versionList.length == 1) {
        me.mwMsg('warning', '无法删除,至少保留一个版本');
        return;
      }
      me.mwConfirm('确定要删除此表单版本？').then(function () {
        _this5.mwApi.app.removeDefinition(me.selVersionId, me.appId).then(function (data) {
          _this5.mwApi.app.listExclusiveMarkDeletedDefinition(me.key, me.appId).then(function (data) {
            me.versionList = data.result;
            me.mwMsg('删除成功');
            var version = me.versionList[0].version;
            var status = me.versionList[0].status;
            var id = me.versionList[0].id;
            if (me.curVersion == me.selVersion) {
              me.curVersionId = id;
              me.curVersion = version;
              me.curStatus = status;
              me.loadForm(id);
            }
            me.selVersionId = id;
            me.selVersion = version;
            me.selStatus = status;
          });
        });
      }).catch(function () {});
    },


    editVersion: function editVersion() {
      var me = this;
      if (me.versionList.length == 0) {
        me.mwRef('versionDialog').hide();
        return;
      } else {
        me.mwRef('versionDialog').hide();
        me.loadForm(me.selVersionId);
      }
    },


    selectVersion: function selectVersion(version, status, id) {
      var me = this;
      me.selVersionId = id;
      me.selVersion = version;
      me.selStatus = status;
    },


    enableVersion: function enableVersion() {var _this6 = this;
      var me = this;
      if (me.versionList.length == 0) {
        me.mwRef('versionDialog').hide();
        return;
      }
      me.mwConfirm('确定启用此表单版本？').then(function () {
        _this6.mwApi.app.publishDefinition(me.selVersionId, me.appId).then(function (data) {
          _this6.mwApi.app.listExclusiveMarkDeletedDefinition(me.key, me.appId).then(function (data) {
            me.versionList = data.result;
          });

          if (me.selVersion == me.curVersion) {
            me.loadForm(me.selVersionId);
            me.mwRef('versionDialog').hide();
          }
          me.mwMsg('启用成功');
        });
      }).catch(function () {

      });
    },


    versionManage: function versionManage() {
      var me = this;
      this.mwApi.app.listExclusiveMarkDeletedDefinition(me.key, me.appId).then(function (data) {
        me.versionList = data.result;
        me.mwRef('versionDialog').show();
        me.mwRef('recycleBinDialog').hide();
      });
    },
    revisionLog: function revisionLog() {
      var me = this;
      me.$refs.revisionDialog.show();
      if (me.$refs.revisionComp) me.$refs.revisionComp.loadData();
    },

    recycleBinManager: function recycleBinManager() {
      var me = this;
      this.mwApi.app.listMarkDeletedDefinition(me.key, me.appId).then(function (data) {
        me.versionDelList = data.result;
        me.mwRef('versionDialog').hide();
        me.mwRef('recycleBinDialog').show();
      });
    },

    selectDelVersion: function selectDelVersion(version, status, id) {
      var me = this;
      me.selDelVersionId = id;
      me.selDelVersion = version;
      me.selDelStatus = status;
    },

    cascadeDeleteVersion: function cascadeDeleteVersion() {var _this7 = this;
      var me = this;
      if (me.selDelVersion == 0) {
        me.mwMsg('warning', '请选择一个表单版本');
        return;
      }
      me.mwConfirm('删除后无法恢复，确定要彻底删除表单版本(' + me.selDelVersion + '.0)？').then(function () {
        _this7.mwApi.app.deleteDefinition(me.selDelVersionId, me.appId).then(function (data) {
          _this7.mwApi.app.listMarkDeletedDefinition(me.key, me.appId).then(function (data) {
            me.versionDelList = data.result;
            me.mwMsg('删除成功');
            if (me.versionDelList && me.versionDelList.length > 0) {
              var version = me.versionDelList[0].version;
              var status = me.versionDelList[0].status;
              me.selDelVersionId = me.versionDelList[0].id;
              me.selDelVersion = version;
              me.selDelStatus = status;
            } else {
              me.selDelVersion = 0;
            }
          });
        });
      }).catch(function () {});
    },

    recoverVersion: function recoverVersion() {var _this8 = this;
      var me = this;
      if (me.selDelVersion == 0) {
        me.mwMsg('warning', '请选择一个表单版本');
        return;
      }
      me.mwConfirm('确定要恢复表单版本(' + me.selDelVersion + '.0)？').then(function () {
        _this8.mwApi.app.recoverDefinition(me.selDelVersionId, me.appId).then(function (data) {
          _this8.mwApi.app.listMarkDeletedDefinition(me.key, me.appId).then(function (data) {
            me.versionDelList = data.result;
            me.mwMsg('恢复成功');
            if (me.versionDelList && me.versionDelList.length > 0) {
              var version = me.versionDelList[0].version;
              var status = me.versionDelList[0].status;
              me.selDelVersionId = me.versionDelList[0].id;
              me.selDelVersion = version;
              me.selDelStatus = status;
            } else {
              me.selDelVersion = 0;
            }
          });
        });
      }).catch(function () {});
    },

    returnVersionManager: function returnVersionManager() {
      var me = this;

      me.versionManage();
    },
    beforeLeave: function beforeLeave(next) {

      if (this.isDirty) {

        PF.confirm("表单尚未保存，是否离开？").
        then(function (o) {
          next();
        }).
        catch(function (o) {
          next(false);
        });
      } else {
        next();
      }
    },
    formRevert: function formRevert() {
      this.loadForm();
    } },

  beforeDestroy: function beforeDestroy() {
    try {
      this.$newForm.destroy();
    } catch (e) {
    }
  } };

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =







{
  name: "component-revision",
  props: {
    componentId: String },

  data: function data() {
    return {
      pagination: true,
      limit: 30,
      layout: [],
      form: {} };

  },
  mounted: function mounted() {
    this._setLayout();
  },
  watch: {
    componentId: function componentId(val, oval) {
      this._setLayout();
    } },

  methods: {
    _setLayout: function _setLayout() {
      var me = this;
      me.layout =
      [
      [{
        key: 'page',
        type: 'menu',
        defaultActive: true,
        pagination: false,
        label: '组件历史版本',
        api: '/s:comp.srv.listComponentRevision',
        defaultParams: { componentId: me.componentId },
        defaultSort: [{ sort: 'createTime', dir: 'desc' }],
        columns: [
        { type: 'selection' },
        { prop: 'name', tooltip: true, label: '名称' },
        { prop: 'revisionComment', tooltip: true, label: '类型', width: 80, align: "center" },
        { prop: 'revisionUser', label: '最后修改者', width: 120, align: "center" },
        { prop: 'revisionTime', label: '最后修改时间', width: 180, align: "center" }] },

      {
        span: 16, type: 'button', items: [
        { label: '回滚', icon: "fa fa-plus-square", func: me.revertComponent }] }]];



    },

    loadData: function loadData() {
      var dataTable = this.$refs.viewToolbarTable.$refs.dataTable;
      if (dataTable) dataTable.loadData();
    },
    revertComponent: function revertComponent() {
      var me = this;
      var records = me.$refs.viewToolbarTable.getMultipleSelection();
      if (!records || records.length === 0) return PF.message("请选择要回滚的版本");
      if (!records.length > 1) return PF.message("只能选择一个回滚的版本");
      var id = records[0].id;
      PF.fsrv("comp.srv.revertComponent", [id]).then(function (res) {
        me.loadData();
        me.$emit("revert", res);
      });
    } } };

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);







































































var _vue = __webpack_require__(11);var _vue2 = _interopRequireDefault(_vue);
var _flowConfig = __webpack_require__(1289);var _flowConfig2 = _interopRequireDefault(_flowConfig);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  name: "mw-flow-edit",
  props: {
    propAppId: String,
    propSysId: String,
    propModuleId: String,
    propAuthUnit: {
      type: Boolean,
      default: false } },


  data: function data() {
    var appId = this.propAppId || this.$route.params.appId;
    var sysId = this.propSysId || this.$route.params.sysId;
    var moduleId = this.propModuleId || this.$route.params.moduleId;
    return {
      appId: appId,
      sysId: sysId,
      moduleId: moduleId,
      flowKeys: [],
      config: {},
      flowKey: '',
      curFlowId: '',


      editable: false,
      designable: true,
      $configVue: null,

      activityTypes: [

      "普通|normal", "串行|serial", "并行|parallel", "子流程|sub-proc", "传阅|circular", "自由节点|dynamic"],



      observer: this,
      flowBar: false,
      enableFlowBtn: false,

      curVersion: 0,
      curStatus: 0,
      selVersion: 0,
      selStatus: 0,
      processList: [],
      processData: undefined,
      processDataGraph: undefined,
      pd: {},
      gridData: [],
      dialogTableVisible: false,
      dialogFormVisible: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '' },

      formLabelWidth: '120px',
      domLoaded: false,

      noNewVersion: false,

      footerButton: [{
        label: '添加新版本',
        func: this.addNewVersion },
      {
        label: '编辑',
        func: this.editProcess },
      {
        label: '启用',
        func: this.enableProcess },
      {
        label: '删除',
        func: this.deleteProcess },
      {
        label: '回收站',
        func: this.recycleBinManager }],

      processDelList: [],
      selDelVersion: 0,
      selDelStatus: 0,
      recycleBinFooterButton: [
      {
        label: '恢复',
        func: this.recoverProcess },

      {
        label: '彻底删除',
        func: this.cascadeDeleteProcess },
      {
        label: '返回',
        func: this.returnVersionManager }],


      relationFlowName: '' };

  },

  computed: {},


  mounted: function mounted() {
    var me = this;
    me.loadModuleFlowConfig(null, null);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$configVue)
    this.$configVue.$destroy(true);
  },
  methods: {

    createNewFlow: function createNewFlow() {
      var me = this;
      me.mwConfirm('确定创建新流程？').then(function () {





      }).catch(function () {});
    },

    relateFlow: function relateFlow() {
      var me = this;
      var checkRoleIds = [];
      if (me.flowKeys) {
        checkRoleIds = me.flowKeys;
      }
      PF.show('treeTable', {
        url: me.mwUrl("/api/app/listAppMoudleTree"), treeDefaultParams: { sysId: me.sysId, category: 'module_flow' },
        size: 'small_large', showTreeToolbar: false, defaultPercent: 50,
        selectFirst: true, asyncLoadOnce: true, clearBtn: false, title: '选择流程', changed: function changed(data) {
          this.defaultParams = { applicationId: data.id };
        }, api: 'process.listLatestDefinition', singleSelect: true, columns: [{ type: 'selection' },
        { prop: 'name', label: '名称', tooltip: true }] },
      function (res) {
        if (res && res.length > 0) {
          me.flowKey = res[0].key;
          var flowName = res[0].name;
          me.mwApi.app.relateFlow(me.flowKey, flowName, me.moduleId, me.appId).then(function (res) {

            if (!res.result.success) {
              me.mwMsg('warning', res.result.msg);
              return;
            }
            me.relationFlowName = flowName;
            me.loadModuleFlowConfig(me.flowKey, res.version);
          });
        }
      });


    },
    delRelatedFlow: function delRelatedFlow() {
      var me = this;
      me.mwApi.app.delRelateFlow(me.flowKey, me.moduleId, me.appId).then(function (res) {
        me.loadModuleFlowConfig(null, null);
      });
    },
    loadModuleFlowConfig: function loadModuleFlowConfig(flowKey, version) {
      var me = this;
      me.mwApi.app.getModuleFlowConfig(flowKey, me.moduleId, me.appId).then(function (res) {
        me.config = res.result;
        me.flowKey = me.config.flowKey;
        me.relationFlowName = me.config.relationFlowName || "";
        me.flowLayOut(version);
      });
    },


    addNewVersion: function addNewVersion() {
      var me = this;
      var params = { appId: me.appId, moduleId: me.moduleId, key: me.flowKey, fromVersion: me.selVersion };
      this.mwApi.process.createDefinition(params).then(function (data) {
        me.loadModuleFlowConfig(me.flowKey, data.result.newVersion);
        me.mwRef('flowVersionDialog').hide();
      });
    },


    deleteProcess: function deleteProcess() {var _this = this;
      var me = this;
      if (me.selStatus == 1) {
        me.mwMsg('warning', '启用版本无法删除');
        return;
      }
      if (me.selStatus == 2) {
        me.mwMsg('warning', '历史版本无法删除');
        return;
      }
      if (me.processList.length == 1) {
        me.mwMsg('warning', '无法删除,至少保留一个版本');
        return;
      }
      me.mwConfirm('确定要删除此流程版本？').then(function () {
        var params = { appId: me.appId, key: me.flowKey, version: me.selVersion };
        _this.mwApi.process.removeDefinition(params).then(function (data) {
          _this.mwApi.process.listExclusiveMarkDeletedDefinition(me.appId, me.flowKey).then(function (data) {
            me.processList = data.result;
            me.mwMsg('删除成功');
            var version = me.processList[0].version;
            var status = me.processList[0].status;
            if (me.curVersion == me.selVersion) {
              me.curVersion = version;
              me.curStatus = status;
              me.flowLayOut(version);
            }
            me.selVersion = version;
            me.selStatus = status;
          });
        });
      }).catch(function () {});
    },

    editProcess: function editProcess() {
      var me = this;
      me.curVersion = me.selVersion;
      me.curStatus = me.selStatus;
      me.mwRef('flowVersionDialog').hide();
      me.flowLayOut(me.selVersion);
    },


    selectVersion: function selectVersion(version, status) {
      var me = this;
      me.selVersion = version;
      me.selStatus = status;
    },


    enableProcess: function enableProcess() {var _this2 = this;
      var me = this;
      me.mwConfirm('启用此流程版本后，新提交的数据将按照此版本流转。流程启用后将无法转回设计状态，不能对节点以及连接线做增删改？').then(function () {
        var params = { appId: me.appId, key: me.flowKey, version: me.selVersion };
        _this2.mwApi.process.enableDefinition(params).then(function (data) {
          me.processList = data.result;
          if (me.selVersion == me.curVersion) {
            me.flowLayOut(me.selVersion);
            me.mwRef('flowVersionDialog').hide();
          }
          me.mwMsg('启用成功');
        });
      }).catch(function () {

      });
    },


    versionManage: function versionManage() {
      var me = this;
      this.mwApi.process.listExclusiveMarkDeletedDefinition(me.appId, me.flowKey).then(function (data) {
        me.processList = data.result;
        me.mwRef('flowVersionDialog').show();
        me.mwRef('flowRecycleBinDialog').hide();
      });
    },

    recycleBinManager: function recycleBinManager() {
      var me = this;
      this.mwApi.process.listMarkDeletedDefinition(me.appId, me.flowKey).then(function (data) {
        me.processDelList = data.result;
        me.mwRef('flowVersionDialog').hide();
        me.mwRef('flowRecycleBinDialog').show();
      });
    },

    selectDelVersion: function selectDelVersion(version, status) {
      var me = this;
      me.selDelVersion = version;
      me.selDelStatus = status;
    },

    cascadeDeleteProcess: function cascadeDeleteProcess() {var _this3 = this;
      var me = this;
      if (me.selDelVersion == 0) {
        me.mwMsg('warning', '请选择一个流程版本');
        return;
      }
      me.mwConfirm('删除后无法恢复，确定要彻底删除流程版本(' + me.selDelVersion + '.0)？').then(function () {
        var params = { appId: me.appId, key: me.flowKey, version: me.selDelVersion, cascade: true };
        _this3.mwApi.process.removeDefinition(params).then(function (data) {
          _this3.mwApi.process.listMarkDeletedDefinition(me.appId, me.flowKey).then(function (data) {
            me.processDelList = data.result;
            me.mwMsg('删除成功');
            if (me.processDelList && me.processDelList.length > 0) {
              var version = me.processDelList[0].version;
              var status = me.processDelList[0].status;
              me.selDelVersion = version;
              me.selDelStatus = status;
            } else {
              me.selDelVersion = 0;
            }
          });
        });
      }).catch(function () {});
    },

    recoverProcess: function recoverProcess() {var _this4 = this;
      var me = this;
      if (me.selDelVersion == 0) {
        me.mwMsg('warning', '请选择一个流程版本');
        return;
      }
      me.mwConfirm('确定要恢复流程版本(' + me.selDelVersion + '.0)？').then(function () {
        var params = { appId: me.appId, key: me.flowKey, version: me.selDelVersion };
        _this4.mwApi.process.recoverDefinition(params).then(function (data) {
          _this4.mwApi.process.listMarkDeletedDefinition(me.appId, me.flowKey).then(function (data) {
            me.processDelList = data.result;
            me.mwMsg('恢复成功');
            if (me.processDelList && me.processDelList.length > 0) {
              var version = me.processDelList[0].version;
              var status = me.processDelList[0].status;
              me.selDelVersion = version;
              me.selDelStatus = status;
            } else {
              me.selDelVersion = 0;
            }
          });
        });
      }).catch(function () {});
    },

    returnVersionManager: function returnVersionManager() {
      var me = this;

      me.versionManage();
    },

    updateDefinition: function () {var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(flag) {var me, data, processData, activities, i, sequences, items, activity, noActivity, j, sequence, noSequence, newObj, parameters, config, businessName, businessKeyword, businessCategory, urgencyLevel, businessField0, businessField1, _flag, fieldMapping, params;return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                me = this;

                data = {};

                processData = this.processData.data;

                data.graph = this.mwRef('processEditor').getData();

                activities = [];
                for (i = 0; i < data.graph.activity.length; i++) {
                  activities.push(data.graph.activity[i].id);
                }

                sequences = [];
                for (i = 0; i < data.graph['sequence-flow'].length; i++) {
                  sequences.push(data.graph['sequence-flow'][i].id);
                }

                items = processData.items;
                if (items.activity) {
                  delete items.activity;
                }
                if (items['sequence-flow']) {
                  delete items['sequence-flow'];
                }if (!
                items.ACTIVITY) {_context.next = 38;break;}

                noActivity = [];
                i = 0;case 14:if (!(i < items.ACTIVITY.length)) {_context.next = 24;break;}
                activity = items.ACTIVITY[i];if (
                activities.indexOf(activity.id) > -1) {_context.next = 19;break;}
                noActivity.push(activity.id);return _context.abrupt('continue', 21);case 19:



                activity.name = activity.parameters.name;
                if (activity.parameters.type)
                activity.extends = activity.parameters.type;case 21:i++;_context.next = 14;break;case 24:

                i = 0;case 25:if (!(i < noActivity.length)) {_context.next = 38;break;}
                j = 0;case 27:if (!(j < items.ACTIVITY.length)) {_context.next = 35;break;}
                activity = items.ACTIVITY[j];if (!(
                noActivity[i] == activity.id)) {_context.next = 32;break;}
                items.ACTIVITY.splice(j, 1);return _context.abrupt('break', 35);case 32:j++;_context.next = 27;break;case 35:i++;_context.next = 25;break;case 38:if (!







                items['SEQUENCE-FLOW']) {_context.next = 68;break;}

                noSequence = [];
                i = 0;case 41:if (!(i < items['SEQUENCE-FLOW'].length)) {_context.next = 54;break;}
                sequence = items['SEQUENCE-FLOW'][i];if (
                sequences.indexOf(sequence.id) > -1) {_context.next = 46;break;}
                noSequence.push(sequence.id);return _context.abrupt('continue', 51);case 46:


                sequence.name = sequence.parameters.name;
                sequence.sourceId = sequence.parameters.from;
                sequence.targetId = sequence.parameters.to;
                sequence.type = sequence.parameters.type;
                sequence.tip = sequence.parameters.tip;case 51:i++;_context.next = 41;break;case 54:


                i = 0;case 55:if (!(i < noSequence.length)) {_context.next = 68;break;}
                j = 0;case 57:if (!(j < items['SEQUENCE-FLOW'].length)) {_context.next = 65;break;}
                sequence = items['SEQUENCE-FLOW'][j];if (!(
                noSequence[i] == sequence.id)) {_context.next = 62;break;}
                items['SEQUENCE-FLOW'].splice(j, 1);return _context.abrupt('break', 65);case 62:j++;_context.next = 57;break;case 65:i++;_context.next = 55;break;case 68:






                data['items'] = processData.items;
                data['name'] = processData.parameters.name || '新建流程';
                data['subProcess'] = processData.parameters.subProcess;
                data['parameters'] = processData.parameters;

                newObj = me.config.attr.flow.versions.length > 0 ? false : true;

                if (me.noNewVersion) {
                  newObj = false;
                }

                parameters = data.parameters;

                if (parameters) {
                  config = me.config.fieldMapping;

                  businessName = parameters.businessName === undefined ? '' : parameters.businessName;

                  businessKeyword = parameters.businessKeyword === undefined ? '' : parameters.businessKeyword;

                  businessCategory = parameters.businessCategory === undefined ? '' : parameters.businessCategory;

                  urgencyLevel = parameters.urgencyLevel === undefined ? '' : parameters.urgencyLevel;

                  businessField0 = parameters.businessField0 === undefined ? '' : parameters.businessField0;

                  businessField1 = parameters.businessField1 === undefined ? '' : parameters.businessField1;

                  _flag = false;
                  fieldMapping = {};
                  if (businessName) {
                    fieldMapping.businessName = businessName;
                  }
                  if (businessKeyword) {
                    fieldMapping.businessKeyword = businessKeyword;
                  }
                  if (businessCategory) {
                    fieldMapping.businessCategory = businessCategory;
                  }
                  if (urgencyLevel) {
                    fieldMapping.urgencyLevel = urgencyLevel;
                  }
                  if (businessField0) {
                    fieldMapping.businessField0 = businessField0;
                  }
                  if (businessField1) {
                    fieldMapping.businessField1 = businessField1;
                  }
                  if (businessName != (config.businessName === undefined ? '' : config.businessName)) {
                    _flag = true;
                  }
                  if (!_flag && businessKeyword != (config.businessKeyword === undefined ? '' : config.businessKeyword)) {
                    _flag = true;
                  }
                  if (!_flag && businessCategory != (config.businessCategory === undefined ? '' : config.businessCategory)) {
                    _flag = true;
                  }
                  if (!_flag && urgencyLevel != (config.urgencyLevel === undefined ? '' : config.urgencyLevel)) {
                    _flag = true;
                  }
                  if (!_flag && businessField0 != (config.businessField0 === undefined ? '' : config.businessField0)) {
                    _flag = true;
                  }
                  if (!_flag && businessField1 != (config.businessField1 === undefined ? '' : config.businessField1)) {
                    _flag = true;
                  }
                  if (_flag) {
                    me.mwApi.app.saveFieldMapping({ fieldMapping: fieldMapping }, me.moduleId, me.appId).then(function (res) {
                      me.config.fieldMapping = fieldMapping;
                    });
                  }
                }

                params = {
                  owner: me.sysId,
                  appId: me.appId,
                  moduleId: me.moduleId,
                  key: me.flowKey,
                  $newObj: newObj,
                  version: me.curVersion,
                  flows: data,
                  publish: flag };


                this.mwApi.process.updateDefinition(params).then(function (data) {
                  me.noNewVersion = true;
                  if (flag) {
                    me.mwMsg('发布成功');
                    me.loadModuleFlowConfig(me.flowKey, me.curVersion);
                  } else {
                    me.mwMsg('保存成功');
                  }
                }).catch(function (reason) {return console.error(reason);});case 78:case 'end':return _context.stop();}}}, _callee, this);}));function updateDefinition(_x) {return _ref.apply(this, arguments);}return updateDefinition;}(),



    flowLayOut: function flowLayOut(version) {
      var me = this,attr = me.config.attr;

      var versions = attr.flow.versions;
      if (version) {
        me.curVersion = version;
      } else {
        me.curVersion = attr.flowVer || (versions.length > 0 ? versions[versions.length - 1].ver : 1);
      }
      me.flowData(me.curVersion, versions);
    },



    flowData: function flowData(version, versions) {
      var me = this;
      if (version == 1 && versions.length == 0) {
        me.selVersion = 1;
        me.editable = true;
        me.flowChart({ name: me.config.moduleName });
      } else {
        var params = { appId: me.appId, key: me.flowKey, version: version };
        this.mwApi.process.getDefinition(params).then(function (data) {
          if (data.result.editable) {
            me.editable = true;
          } else {
            me.editable = false;
          }
          me.curStatus = data.result.flows.status;
          me.selVersion = data.result.flows.version;
          me.selStatus = data.result.flows.status;

          me.flowChart(data.result.flows);
        });
      }
    },

    flowChart: function flowChart(data) {
      var me = this;

      if (!data.items) {
        data.items = {};
      }

      if (!data.parameters) {

      }

      if (!data.items.ACTIVITY) {
        data.items.ACTIVITY = [];












      }

      if (!data.items['SEQUENCE-FLOW']) {
        data.items['SEQUENCE-FLOW'] = [];
      }

      if (this.$configVue) {
        this.$configVue.$destroy(true);
        this.$configVue = null;
      }

      this.loadFlowConfig(_vue2.default, me, data && data.items && { data: data });
    },

    loadFlowConfig: function loadFlowConfig(Vue, parent, _data) {
      var me = this;

      var data = me.config.flowConfig;

      if (!_data.data.parameters) {
        _data.data.parameters = { id: _data.data.id, name: _data.data.name };
      }
      this.processData = _data;

      this.processDataGraph = _data.data.graph;

      if (false) {

        var components = [];

        var event = 'parent.$configVue =' + data.eventScript;

        var script = data.baseScript.replace('$obj', 'var backdrop').replace('$template', data.baseTemplate.replace(/\n/g, '').replace(/'/g, '\\\'')) + "\n";
        components.push("'backdrop':backdrop");

        var nodes = [];

        if (data.nodeList) {
          data.nodeList.forEach(function (v) {
            script += v.script.replace('$obj', 'var node_' + v.code.replace(/-/g, '_')).replace('$template', v.template.replace(/\n/g, '').replace(/'/g, '\\\'')) + "\n";
            components.push("'node-" + v.code.replace(/-/g, '-') + "'" + ':node_' + v.code.replace(/-/g, '_'));
            nodes.push(v.name + "|" + v.code.replace(/-/g, '-'));
          });
        }

        if (data.lineList) {
          data.lineList.forEach(function (v) {
            script += v.script.replace('$obj', 'var line_' + v.code.replace(/-/g, '_')).replace('$template', v.template.replace(/\n/g, '').replace(/'/g, '\\\'')) + "\n";
            components.push("'line-" + v.code.replace(/-/g, '-') + "'" + ':line_' + v.code.replace(/-/g, '_'));
          });
        }
        script = script + event.replace('$components', components.join(","));

        me.activityTypes = nodes;

        eval(script);
      } else {
        new _flowConfig2.default(Vue, me, _data);
      }

    } },

  errorCaptured: function errorCaptured(err, component, info) {
    console.error(err);
  } };

/***/ }),
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _app = __webpack_require__(91);var _app2 = _interopRequireDefault(_app);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var state = {
  info: {} };


var actions = {
  getApplication: function getApplication(_ref, appId) {var commit = _ref.commit;
    _app2.default.getApplication(appId).then(function (data) {
      commit('applicationInfo', data.result);
    });
  } };


var getters = {
  appInfo: function appInfo(state) {return state.info;} };


var mutations = (0, _defineProperty3.default)({},
'applicationInfo', function applicationInfo(state, result) {
  state.info = result;
});exports.default =


{
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations };

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _mutations;function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var state = {
  appId: '',
  treeData: [],
  code: '',
  businessSystemEnter: false,
  url: '' };


var actions = {
  setAppTreeData: function setAppTreeData(_ref, data) {var commit = _ref.commit;
    commit('treeData', data);
  },

  setAppTreeItemName: function setAppTreeItemName(_ref2, params) {var commit = _ref2.commit;
    commit('updateName', params);
  },
  setAppCode: function setAppCode(_ref3, data) {var commit = _ref3.commit;
    commit('appCode', data);
  },
  setBusinessSystemEnter: function setBusinessSystemEnter(_ref4, data) {var commit = _ref4.commit;
    commit('businessSystemEnter', data);
  },
  setModuleUrl: function setModuleUrl(_ref5, data) {var commit = _ref5.commit;
    commit('moduleUrl', data);
  } };


var getters = {
  getAppTreeData: function getAppTreeData(state, getters) {
    return function (appId) {
      if (appId == state.appId) {
        return state.treeData;
      } else {
        state.appId = '';
        state.treeData = [];
        return undefined;
      }
    };
  },
  getAppCode: function getAppCode(state) {return state.code;},
  isBusinessSystemEnter: function isBusinessSystemEnter(state) {return state.businessSystemEnter;},
  getModuleUrl: function getModuleUrl(state) {return state.url;} };


var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations,
'treeData', function treeData(state, data) {
  state.appId = data.appId;
  state.treeData = data.data;
}), (0, _defineProperty3.default)(_mutations,
'updateName', function updateName(state, params) {
  function changeTreeItemName(data, params) {
    for (var i = 0; i < data.length; i++) {
      var v = data[i];
      if (v.id == params.id) {
        v.text = params.name;
        break;
      }
      if (v.children && v.children.length > 0) {
        changeTreeItemName(v.children, params);
      }
    }
  }
  if (state.treeData)
  changeTreeItemName(state.treeData, params);
}), (0, _defineProperty3.default)(_mutations,
'appCode', function appCode(state, data) {
  state.code = data.code;
}), (0, _defineProperty3.default)(_mutations,
'businessSystemEnter', function businessSystemEnter(state, data) {
  state.businessSystemEnter = data.businessSystemEnter;
}), (0, _defineProperty3.default)(_mutations,
'moduleUrl', function moduleUrl(state, data) {
  state.url = data.url;
}), _mutations);exports.default =


{
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations };

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _promise = __webpack_require__(19);var _promise2 = _interopRequireDefault(_promise);var _app = __webpack_require__(91);var _app2 = _interopRequireDefault(_app);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var state = {
  appId: '',
  treeData: [] };


var actions = {
  applicationLinkTree: function applicationLinkTree(_ref, appId) {var commit = _ref.commit;
    return new _promise2.default(function (resolve, reject) {
      _app2.default.applicationLinkTree(appId).then(function (res) {
        if (false === res.result || false === res.success) {
          resolve(res);
          return;
        }
        commit('applicationLinkTree', { appId: appId, data: res.result });
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  } };


var getters = {
  getApplicationLinkTree: function getApplicationLinkTree(state, getters) {
    return function () {
      return state.treeData;
    };
  } };


var mutations = (0, _defineProperty3.default)({},
'applicationLinkTree', function applicationLinkTree(state, data) {
  state.appId = data.appId;
  state.treeData = data.data;
});exports.default =


{
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations };

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _promise = __webpack_require__(19);var _promise2 = _interopRequireDefault(_promise);var _mutations;var _types = __webpack_require__(315);var types = _interopRequireWildcard(_types);
var _app = __webpack_require__(91);var _app2 = _interopRequireDefault(_app);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var state = {
  loaded: false,
  formLoaded: false,
  flowLoaded: false,
  dataLoaded: false,
  setLoaded: false,
  config: {} };


var actions = {
  getFormConfig: function getFormConfig(_ref, param) {var commit = _ref.commit;
    return new _promise2.default(function (resolve, reject) {
      _app2.default.formConfig(param.moduleId, param.appId).then(function (data) {
        commit(types.GET_FORM_CONFIG, data.result);
        commit(types.GET_FORM_CONFIG_LOADED, true);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });

  },
  setFormLoaded: function setFormLoaded(_ref2, loaded) {var commit = _ref2.commit;
    commit(types.SET_FORM_LOADED, loaded);
  },
  setFlowLoaded: function setFlowLoaded(_ref3, loaded) {var commit = _ref3.commit;
    commit(types.SET_FLOW_LOADED, loaded);
  },
  setDataLoaded: function setDataLoaded(_ref4, loaded) {var commit = _ref4.commit;
    commit(types.SET_DATA_LOADED, loaded);
  },
  setSetLoaded: function setSetLoaded(_ref5, loaded) {var commit = _ref5.commit;
    commit(types.SET_SET_LOADED, loaded);
  },
  setFormConfigLoaded: function setFormConfigLoaded(_ref6, loaded) {var commit = _ref6.commit;
    commit(types.GET_FORM_CONFIG_LOADED, loaded);
  },
  clearLoaded: function clearLoaded(_ref7) {var commit = _ref7.commit;
    commit('Clear_Loaded');
  } };


var getters = {};

var mutations = (_mutations = {
  Clear_Loaded: function Clear_Loaded(state) {
    state.loaded = false,
    state.formLoaded = false,
    state.flowLoaded = false,
    state.dataLoaded = false,
    state.setLoaded = false,
    state.config = {};
  } }, (0, _defineProperty3.default)(_mutations,

types.SET_FORM_LOADED, function (state, loaded) {
  state.formLoaded = loaded;
}), (0, _defineProperty3.default)(_mutations,
types.SET_FLOW_LOADED, function (state, loaded) {
  state.flowLoaded = loaded;
}), (0, _defineProperty3.default)(_mutations,
types.SET_DATA_LOADED, function (state, loaded) {
  state.dataLoaded = loaded;
}), (0, _defineProperty3.default)(_mutations,
types.SET_SET_LOADED, function (state, loaded) {
  state.setLoaded = loaded;
}), (0, _defineProperty3.default)(_mutations,
types.GET_FORM_CONFIG_LOADED, function (state, loaded) {
  state.loaded = loaded;
}), (0, _defineProperty3.default)(_mutations,
types.GET_FORM_CONFIG, function (state, result) {
  state.config = result;
}), _mutations);exports.default =



{
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations };

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _types = __webpack_require__(315);var types = _interopRequireWildcard(_types);
var _app = __webpack_require__(91);var _app2 = _interopRequireDefault(_app);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var state = {
  appId: '',
  appName: '',
  entryList: [],
  entryMap: {} };


var actions = {
  listApplicationItem: function listApplicationItem(_ref, appId) {var commit = _ref.commit;
    _app2.default.listApplicationItem(appId).then(function (data) {
      commit(types.LIST_APPLICATION_ITEM, data.result);
    });
  } };


var getters = {};


var mutations = (0, _defineProperty3.default)({},
types.LIST_APPLICATION_ITEM, function (state, result) {
  state.appName = result.name;
  state.entryList = result.entryList;
  state.entryMap = result.entryMap;
});exports.default =


{
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations };

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _promise = __webpack_require__(19);var _promise2 = _interopRequireDefault(_promise);var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _mutations;var _org = __webpack_require__(207);var _org2 = _interopRequireDefault(_org);
var _token = __webpack_require__(25);var _token2 = _interopRequireDefault(_token);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var user = {
  state: {
    expUser: {},
    userInfo: {},
    initInfo: {},
    loginId: '',
    status: '',
    code: '',
    token: _token2.default.getToken(),
    userName: '',
    avatar: '',
    introduction: '',
    roles: [],
    systemParameter: {},
    setting: {
      articlePlatform: [] },


    unitDepartments: [],

    curUnit: [],
    curSelUnit: '',
    curSelUnitId: '',

    curDept: [],
    curSelDept: '',
    curSelDeptId: '',
    sysConfig: {} },


  mutations: (_mutations = {

    SET_EXP_USER: function SET_EXP_USER(state, user) {
      state.expUser = user;
    },
    SET_INIT_INFO: function SET_INIT_INFO(state, info) {
      state.initInfo = info;
    },
    SET_USER_INFO: function SET_USER_INFO(state, user) {
      state.userInfo = user;
      state.loginId = user.loginId;
    },
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_CODE: function SET_CODE(state, code) {
      state.code = code;
    },
    SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
      state.introduction = introduction;
    },
    SET_SETTING: function SET_SETTING(state, setting) {
      state.setting = setting;
    },
    SET_STATUS: function SET_STATUS(state, status) {
      state.status = status;
    },
    SET_NAME: function SET_NAME(state, name) {
      state.userName = name;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_SYS_CONFIG: function SET_SYS_CONFIG(state, sysConfig) {
      state.sysConfig = sysConfig;
    },
    SET_SYSTEM_PARAMETER: function SET_SYSTEM_PARAMETER(state, systemParameter) {
      state.systemParameter = systemParameter;
    },

    unitDepartments: function unitDepartments(state, _unitDepartments) {
      state.unitDepartments = _unitDepartments;
    } }, (0, _defineProperty3.default)(_mutations,

  'listUnit', function listUnit(state, result) {
    state.curUnit = result;
    if (result && result.length > 0) {
      state.curSelUnitId = result[0].id;
      state.curSelUnit = result[0].name;
    }
  }), (0, _defineProperty3.default)(_mutations,
  'setCurSelUnit', function setCurSelUnit(state, unit) {
    state.curSelUnitId = unit.id;
    state.curSelUnit = unit.name;
  }), (0, _defineProperty3.default)(_mutations,
  'listDept', function listDept(state, result) {
    state.curDept = result;




  }), (0, _defineProperty3.default)(_mutations,
  'setCurSelDept', function setCurSelDept(state, dept) {
    state.curSelDeptId = dept.id;
    state.curSelDept = dept.name;
  }), _mutations),


  actions: {


    UserLogin: function UserLogin(_ref, userInfo) {var commit = _ref.commit;
      var username = userInfo.username.trim();
      var password = userInfo.password.trim();
      return new _promise2.default(function (resolve, reject) {
        _org2.default.authenticate(username, password).then(function (res) {
          if (false === res.result || false === res.success) {
            resolve(res);
            return;
          }
          _token2.default.setToken(res.result);
          $xtoken = res.result;
          commit('SET_TOKEN', res.result);
          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    UserDeveloperLogin: function UserDeveloperLogin(_ref2, userInfo) {var commit = _ref2.commit;
      var username = userInfo.username.trim();
      var password = userInfo.password.trim();
      return new _promise2.default(function (resolve, reject) {
        _org2.default.authenticate(username, password, true).then(function (res) {
          if (false === res.result || false === res.success) {
            resolve(res);
            return;
          }
          _token2.default.setToken(res.result);
          $xtoken = res.result;
          commit('SET_TOKEN', res.result);
          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    },





    GetUserInfo: function GetUserInfo(_ref3) {var commit = _ref3.commit,state = _ref3.state;
      return new _promise2.default(function (resolve, reject) {
        _org2.default.loginUserInfo().then(function (res) {
          if (!res || !res.result) {
            reject('error');
          }
          var data = res.result;
          var user = data.$u;
          user.data = user.data || {};
          var u = data.$u;
          u.allIdentityRoleNames = data.$allIdentityRoleNames;
          u.roleNames = data.$roleNames;
          commit('SET_USER_INFO', user);
          commit('SET_EXP_USER', data.$u);
          commit('unitDepartments', data.$unitDepartments);
          if (data.$listCurUnit)
          commit('listUnit', data.$listCurUnit);
          if (data.$listCurDept) {
            commit('listDept', data.$listCurDept);
            if (data.$curDept) {
              commit('setCurSelDept', data.$curDept);
            }
          }
          if (data.$set)
          commit('SET_SYSTEM_PARAMETER', data.$set);

          var info = {};
          info.inituserid = u.id;
          info.loginId = u.loginId;
          info.initusername = u.name;
          info.developer = u.developer;
          info.allIdentityRoleNames = data.$allIdentityRoleNames;
          info.roleNames = data.$roleNames;
          info.mjbs = u.mjbs;
          var dept = u.dep;
          if (dept.loginUnit) {
            info.initunitid = dept.loginUnit.id;
            info.initunitname = dept.loginUnit.name;
            info.initunitshortname = dept.loginUnit.shortname || "";
          }
          if (dept.loginDept) {
            info.initbmid = dept.loginDept.id;
            info.initbmname = dept.loginDept.name;
            info.initbmshortname = dept.loginDept.shortname || "";
          }
          if (u.loginDepartment) {
            info.initdeptid = u.loginDepartment.id;
            info.initdeptname = u.loginDepartment.name;
            info.initdeptshortname = u.loginDepartment.shortname || "";
          }
          info.roleNames = data.$roleNames;
          info.deptIdChain = data.$deptIdChain;
          PF.userInfo = info;
          var sysConfig = {};
          _.assign(sysConfig, data.$sysConfig);
          commit('SET_SYS_CONFIG', sysConfig);
          PF._sysConfig = data.$sysConfig;

          var path = $servicePath + "/login";
          if ($servicePath != '' && info.developer && window.location.href.indexOf(path) == -1) {
            window.location.href = $servicePath + "/login";
          }

          commit('SET_INIT_INFO', info);
          if (u.developer)
          commit('SET_ROLES', ['admin']);else

          commit('SET_ROLES', ['guest']);
          commit('SET_NAME', user.name);
          commit('SET_AVATAR', user.avatar);
          commit('SET_INTRODUCTION', user.introduction);

          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    UserLogOut: function UserLogOut(_ref4) {var commit = _ref4.commit,state = _ref4.state;
      return new _promise2.default(function (resolve, reject) {
        _org2.default.loginOut().then(function (res) {
          _org2.default.clearSession().then(function (res) {
            commit('SET_TOKEN', '');
            commit('SET_ROLES', []);
            _token2.default.removeToken();
            resolve();
          }).catch(function (error) {
            reject(error);
          });
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setCurSelUnit: function setCurSelUnit(_ref5, unit) {var commit = _ref5.commit;
      commit('setCurSelUnit', unit);
    },

    setCurSelDept: function setCurSelDept(_ref6, dept) {var commit = _ref6.commit;
      commit('setCurSelDept', dept);
    } } };exports.default =




user;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var getters = {
  sidebar: function sidebar(state) {return state.app.sidebar;},
  visitedViews: function visitedViews(state) {return state.app.visitedViews;},
  token: function token(state) {return state.user.token;},
  avatar: function avatar(state) {return state.user.avatar;},
  userName: function userName(state) {return state.user.userName;},
  loginId: function loginId(state) {return state.user.loginId;},
  introduction: function introduction(state) {return state.user.introduction;},
  status: function status(state) {return state.user.status;},
  roles: function roles(state) {return state.user.roles;},
  setting: function setting(state) {return state.user.setting;},
  permission_routers: function permission_routers(state) {return state.permission.routers;},
  addRouters: function addRouters(state) {return state.permission.addRouters;},
  userInfo: function userInfo(state) {return state.user.userInfo;},

  expUser: function expUser(state) {return state.user.expUser;},
  initInfo: function initInfo(state) {return state.user.initInfo;},

  systemParameter: function systemParameter(state) {return state.user.systemParameter;},
  unitDepartments: function unitDepartments(state) {return state.user.unitDepartments;},

  curUnit: function curUnit(state) {return state.user.curUnit;},
  curSelUnit: function curSelUnit(state) {return state.user.curSelUnit;},
  curSelUnitId: function curSelUnitId(state) {return state.user.curSelUnitId;},

  curDept: function curDept(state) {return state.user.curDept;},
  curSelDept: function curSelDept(state) {return state.user.curSelDept;},
  curSelDeptId: function curSelDeptId(state) {return state.user.curSelDeptId;},
  sysConfig: function sysConfig(state) {return state.user.sysConfig;} };exports.default =

getters;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var errLog = {
  state: {
    errLog: [] },

  pushLog: function pushLog(log) {
    this.state.errLog.unshift(log);
  },
  clearLog: function clearLog() {
    this.state.errLog = [];
  } };exports.default =


errLog;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _toConsumableArray2 = __webpack_require__(38);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);var _promise = __webpack_require__(19);var _promise2 = _interopRequireDefault(_promise);var _slicedToArray2 = __webpack_require__(60);var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);var _getIterator2 = __webpack_require__(89);var _getIterator3 = _interopRequireDefault(_getIterator2);var _jsCookie = __webpack_require__(299);var _jsCookie2 = _interopRequireDefault(_jsCookie);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var app = {
  state: {
    sidebar: {
      opened: !+_jsCookie2.default.get('sidebarStatus') },

    visitedViews: [] },

  mutations: {
    TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
      if (state.sidebar.opened) {
        _jsCookie2.default.set('sidebarStatus', 1);
      } else {
        _jsCookie2.default.set('sidebarStatus', 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
    },
    ADD_VISITED_VIEWS: function ADD_VISITED_VIEWS(state, view) {
      if (state.visitedViews.some(function (v) {return v.path === view.path;})) return;
      state.visitedViews.push({ name: view.name || view.meta.title, path: view.path });
    },
    CLEAR_VISITED_VIEWS: function CLEAR_VISITED_VIEWS(state, view) {
      state.visitedViews = [];
    },
    DEL_VISITED_VIEWS: function DEL_VISITED_VIEWS(state, view) {
      var index = void 0;var _iteratorNormalCompletion = true;var _didIteratorError = false;var _iteratorError = undefined;try {
        for (var _iterator = (0, _getIterator3.default)(state.visitedViews.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {var _step$value = (0, _slicedToArray3.default)(_step.value, 2),i = _step$value[0],v = _step$value[1];
          if (v.path === view.path) {
            index = i;
            break;
          }
        }} catch (err) {_didIteratorError = true;_iteratorError = err;} finally {try {if (!_iteratorNormalCompletion && _iterator.return) {_iterator.return();}} finally {if (_didIteratorError) {throw _iteratorError;}}}
      state.visitedViews.splice(index, 1);
    } },

  actions: {
    ToggleSideBar: function ToggleSideBar(_ref) {var commit = _ref.commit;
      commit('TOGGLE_SIDEBAR');
    },
    addVisitedViews: function addVisitedViews(_ref2, view) {var commit = _ref2.commit;
      commit('ADD_VISITED_VIEWS', view);
    },
    clearVisitedViews: function clearVisitedViews(_ref3, view) {var commit = _ref3.commit;
      commit('CLEAR_VISITED_VIEWS', view);
    },
    delVisitedViews: function delVisitedViews(_ref4, view) {var commit = _ref4.commit,state = _ref4.state;
      return new _promise2.default(function (resolve) {
        commit('DEL_VISITED_VIEWS', view);
        resolve([].concat((0, _toConsumableArray3.default)(state.visitedViews)));
      });
    } } };exports.default =



app;

/***/ }),
/* 472 */
/***/ (function(module, exports) {

/*!
* screenfull
* v3.3.3 - 2018-09-04
* (c) Sindre Sorhus; MIT License
*/
(function () {
	'use strict';

	var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
	var isCommonjs = typeof module !== 'undefined' && module.exports;
	var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;

	var fn = (function () {
		var val;

		var fnMap = [
			[
				'requestFullscreen',
				'exitFullscreen',
				'fullscreenElement',
				'fullscreenEnabled',
				'fullscreenchange',
				'fullscreenerror'
			],
			// New WebKit
			[
				'webkitRequestFullscreen',
				'webkitExitFullscreen',
				'webkitFullscreenElement',
				'webkitFullscreenEnabled',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			// Old WebKit (Safari 5.1)
			[
				'webkitRequestFullScreen',
				'webkitCancelFullScreen',
				'webkitCurrentFullScreenElement',
				'webkitCancelFullScreen',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			[
				'mozRequestFullScreen',
				'mozCancelFullScreen',
				'mozFullScreenElement',
				'mozFullScreenEnabled',
				'mozfullscreenchange',
				'mozfullscreenerror'
			],
			[
				'msRequestFullscreen',
				'msExitFullscreen',
				'msFullscreenElement',
				'msFullscreenEnabled',
				'MSFullscreenChange',
				'MSFullscreenError'
			]
		];

		var i = 0;
		var l = fnMap.length;
		var ret = {};

		for (; i < l; i++) {
			val = fnMap[i];
			if (val && val[1] in document) {
				for (i = 0; i < val.length; i++) {
					ret[fnMap[0][i]] = val[i];
				}
				return ret;
			}
		}

		return false;
	})();

	var eventNameMap = {
		change: fn.fullscreenchange,
		error: fn.fullscreenerror
	};

	var screenfull = {
		request: function (elem) {
			var request = fn.requestFullscreen;

			elem = elem || document.documentElement;

			// Work around Safari 5.1 bug: reports support for
			// keyboard in fullscreen even though it doesn't.
			// Browser sniffing, since the alternative with
			// setTimeout is even worse.
			if (/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) {
				elem[request]();
			} else {
				elem[request](keyboardAllowed ? Element.ALLOW_KEYBOARD_INPUT : {});
			}
		},
		exit: function () {
			document[fn.exitFullscreen]();
		},
		toggle: function (elem) {
			if (this.isFullscreen) {
				this.exit();
			} else {
				this.request(elem);
			}
		},
		onchange: function (callback) {
			this.on('change', callback);
		},
		onerror: function (callback) {
			this.on('error', callback);
		},
		on: function (event, callback) {
			var eventName = eventNameMap[event];
			if (eventName) {
				document.addEventListener(eventName, callback, false);
			}
		},
		off: function (event, callback) {
			var eventName = eventNameMap[event];
			if (eventName) {
				document.removeEventListener(eventName, callback, false);
			}
		},
		raw: fn
	};

	if (!fn) {
		if (isCommonjs) {
			module.exports = false;
		} else {
			window.screenfull = false;
		}

		return;
	}

	Object.defineProperties(screenfull, {
		isFullscreen: {
			get: function () {
				return Boolean(document[fn.fullscreenElement]);
			}
		},
		element: {
			enumerable: true,
			get: function () {
				return document[fn.fullscreenElement];
			}
		},
		enabled: {
			enumerable: true,
			get: function () {
				// Coerce to boolean in case of old WebKit
				return Boolean(document[fn.fullscreenEnabled]);
			}
		}
	});

	if (isCommonjs) {
		module.exports = screenfull;
	} else {
		window.screenfull = screenfull;
	}
})();


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = {
  name: 'MwColorSelect',
  template: "<div ref=\"mountPoint\" style=\"margin-top:4px;\"></div>",
  data: function data() {
    return {
      valueChange: false,
      chooserChange: false };

  },
  props: {
    value: {
      default: "" },

    onChange: {
      type: Function,
      default: function _default() {

      } } },


  defaultProps: {},
  mounted: function mounted() {var _this = this;
    var mountPoint = this.mwRef("mountPoint");
    var colorChooser = new ($WR.require('form/default/ColorPicker'))({ hideLabel: true });
    colorChooser.render(mountPoint);
    colorChooser.setValue(this.value);
    this.colorChooser = colorChooser;
    colorChooser.on("change", function (e) {
      var value = _this.colorChooser.getValue();
      if (!_this.valueChange && value !== _this.value) {
        _this.chooserChange = true;
        _this.$emit("input", value);
        _this.onChange();
      }
    });
  },

  watch: {
    value: function value(val, oval) {
      if (this.colorChooser && !this.chooserChange) {
        this.valueChange = true;
        this.colorChooser.setValue(val);
      }
      this.valueChange = false;
      this.chooserChange = false;
    } },


  beforeDestroy: function beforeDestroy() {
    if (this.colorChooser) {
      this.colorChooser.destroy();
      this.colorChooser = null;
    }

  } };

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_365007cf_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_user_vue__ = __webpack_require__(1198);
function injectStyle (ssrContext) {
  __webpack_require__(1175)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-365007cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_365007cf_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_user_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_role_vue__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_role_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_role_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_role_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_role_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_35ad3576_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_role_vue__ = __webpack_require__(1200);
function injectStyle (ssrContext) {
  __webpack_require__(1199)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35ad3576"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_role_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_35ad3576_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_role_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_group_vue__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_group_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_group_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_group_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_group_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_08622628_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_group_vue__ = __webpack_require__(1211);
function injectStyle (ssrContext) {
  __webpack_require__(1206)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08622628"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_group_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_08622628_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_groups_vue__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_groups_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_groups_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_groups_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_groups_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_54bc24c4_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_groups_vue__ = __webpack_require__(1215);
function injectStyle (ssrContext) {
  __webpack_require__(1212)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54bc24c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_groups_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_54bc24c4_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_groups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_commonOuterOrg_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_commonOuterOrg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_commonOuterOrg_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_commonOuterOrg_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_commonOuterOrg_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_1a71f2b8_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_commonOuterOrg_vue__ = __webpack_require__(1217);
function injectStyle (ssrContext) {
  __webpack_require__(1216)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a71f2b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_commonOuterOrg_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_1a71f2b8_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_commonOuterOrg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataDic_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataDic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataDic_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataDic_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataDic_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6e024009_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_dataDic_vue__ = __webpack_require__(1220);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataDic_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6e024009_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_dataDic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_firstDept_vue__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_firstDept_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_firstDept_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_firstDept_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_firstDept_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6561c091_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_firstDept_vue__ = __webpack_require__(1223);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_firstDept_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6561c091_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_firstDept_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataValues_vue__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataValues_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataValues_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataValues_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataValues_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_16cdc4fd_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_dataValues_vue__ = __webpack_require__(1224);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataValues_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_16cdc4fd_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_dataValues_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_fullAuth_vue__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_fullAuth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_fullAuth_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_fullAuth_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_fullAuth_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_623b34e0_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_fullAuth_vue__ = __webpack_require__(1227);
function injectStyle (ssrContext) {
  __webpack_require__(1226)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-623b34e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_fullAuth_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_623b34e0_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_fullAuth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_script_vue__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_script_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_script_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_script_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_script_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3847aa33_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_script_vue__ = __webpack_require__(1228);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_script_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3847aa33_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_script_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_vue__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8f8a6932_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flow_vue__ = __webpack_require__(1229);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8f8a6932_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_set_vue__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_set_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_set_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_set_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_set_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_824e65dc_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_set_vue__ = __webpack_require__(1231);
function injectStyle (ssrContext) {
  __webpack_require__(1230)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-824e65dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_set_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_824e65dc_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_set_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktime_vue__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktime_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktime_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktime_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_537a7cb7_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_worktime_vue__ = __webpack_require__(1236);
function injectStyle (ssrContext) {
  __webpack_require__(1232)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktime_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_537a7cb7_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_worktime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_multilingual_vue__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_multilingual_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_multilingual_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_multilingual_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_multilingual_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_57b30289_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_multilingual_vue__ = __webpack_require__(1238);
function injectStyle (ssrContext) {
  __webpack_require__(1237)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57b30289"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_multilingual_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_57b30289_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_multilingual_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_clearDataOrExpImpl_vue__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_clearDataOrExpImpl_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_clearDataOrExpImpl_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_clearDataOrExpImpl_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_clearDataOrExpImpl_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_d9ab6912_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_clearDataOrExpImpl_vue__ = __webpack_require__(1243);
function injectStyle (ssrContext) {
  __webpack_require__(1242)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_clearDataOrExpImpl_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_d9ab6912_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_clearDataOrExpImpl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3b3935ef_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1257);
function injectStyle (ssrContext) {
  __webpack_require__(1253)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b3935ef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3b3935ef_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loginLog_vue__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loginLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loginLog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loginLog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loginLog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_a0753e76_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_loginLog_vue__ = __webpack_require__(1259);
function injectStyle (ssrContext) {
  __webpack_require__(1258)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0753e76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_loginLog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_a0753e76_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_loginLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalLog_vue__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalLog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalLog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalLog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_752fc9de_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_personalLog_vue__ = __webpack_require__(1261);
function injectStyle (ssrContext) {
  __webpack_require__(1260)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-752fc9de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalLog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_752fc9de_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_personalLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_operationLog_vue__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_operationLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_operationLog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_operationLog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_operationLog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ad1cf59a_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_operationLog_vue__ = __webpack_require__(1263);
function injectStyle (ssrContext) {
  __webpack_require__(1262)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad1cf59a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_operationLog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ad1cf59a_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_operationLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowLog_vue__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowLog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowLog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowLog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_31e66652_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flowLog_vue__ = __webpack_require__(1265);
function injectStyle (ssrContext) {
  __webpack_require__(1264)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31e66652"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowLog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_31e66652_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flowLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowTransLog_vue__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowTransLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowTransLog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowTransLog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowTransLog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5f31c71a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flowTransLog_vue__ = __webpack_require__(1266);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowTransLog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5f31c71a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flowTransLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_accessLog_vue__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_accessLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_accessLog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_accessLog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_accessLog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_315cb351_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_accessLog_vue__ = __webpack_require__(1268);
function injectStyle (ssrContext) {
  __webpack_require__(1267)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-315cb351"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_accessLog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_315cb351_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_accessLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_74c0639c_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1270);
function injectStyle (ssrContext) {
  __webpack_require__(1269)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74c0639c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_74c0639c_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7a358fec_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1288);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7a358fec_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Flow_vue__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Flow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Flow_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Flow_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Flow_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_12671a21_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Flow_vue__ = __webpack_require__(1303);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Flow_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_12671a21_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Flow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 499 */,
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(501);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67), __webpack_require__(213)))

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: '确定',
      clear: '清空'
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      // week: '周次',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择'
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择',
      noData: '暂无数据'
    },
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页'
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!'
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传'
    },
    table: {
      emptyText: '暂无数据',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计'
    },
    tree: {
      emptyText: '暂无数据'
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项'
    },
    image: {
      error: '加载失败'
    },
    pageHeader: {
      title: '返回'
    },
    popconfirm: {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }
  }
};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function(key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function(key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
        return cloneIfNecessary(source, optionsArgument)
    } else if (sourceIsArray) {
        var arrayMerge = options.arrayMerge || defaultArrayMerge;
        return arrayMerge(target, source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (Vue) {

  /**
   * template
   *
   * @param {String} string
   * @param {Array} ...args
   * @return {String}
   */

  function template(string) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (args.length === 1 && _typeof(args[0]) === 'object') {
      args = args[0];
    }

    if (!args || !args.hasOwnProperty) {
      args = {};
    }

    return string.replace(RE_NARGS, function (match, prefix, i, index) {
      var result = void 0;

      if (string[index - 1] === '{' && string[index + match.length] === '}') {
        return i;
      } else {
        result = (0, _util.hasOwn)(args, i) ? args[i] : null;
        if (result === null || result === undefined) {
          return '';
        }

        return result;
      }
    });
  }

  return template;
};

var _util = __webpack_require__(52);

var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
/**
 *  String format template
 *  - Inspired:
 *    https://github.com/Matt-Esch/string-template/index.js
 */

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(507);

__webpack_require__(704);

__webpack_require__(705);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(508);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(580);
__webpack_require__(581);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(584);
__webpack_require__(585);
__webpack_require__(586);
__webpack_require__(588);
__webpack_require__(589);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(593);
__webpack_require__(594);
__webpack_require__(595);
__webpack_require__(596);
__webpack_require__(597);
__webpack_require__(599);
__webpack_require__(600);
__webpack_require__(601);
__webpack_require__(602);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(607);
__webpack_require__(608);
__webpack_require__(609);
__webpack_require__(610);
__webpack_require__(611);
__webpack_require__(163);
__webpack_require__(612);
__webpack_require__(234);
__webpack_require__(613);
__webpack_require__(235);
__webpack_require__(614);
__webpack_require__(615);
__webpack_require__(616);
__webpack_require__(617);
__webpack_require__(618);
__webpack_require__(238);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(619);
__webpack_require__(620);
__webpack_require__(621);
__webpack_require__(622);
__webpack_require__(623);
__webpack_require__(624);
__webpack_require__(625);
__webpack_require__(626);
__webpack_require__(627);
__webpack_require__(628);
__webpack_require__(629);
__webpack_require__(630);
__webpack_require__(631);
__webpack_require__(632);
__webpack_require__(633);
__webpack_require__(634);
__webpack_require__(635);
__webpack_require__(636);
__webpack_require__(637);
__webpack_require__(638);
__webpack_require__(639);
__webpack_require__(640);
__webpack_require__(641);
__webpack_require__(642);
__webpack_require__(643);
__webpack_require__(644);
__webpack_require__(645);
__webpack_require__(646);
__webpack_require__(647);
__webpack_require__(648);
__webpack_require__(649);
__webpack_require__(650);
__webpack_require__(651);
__webpack_require__(652);
__webpack_require__(653);
__webpack_require__(654);
__webpack_require__(655);
__webpack_require__(656);
__webpack_require__(657);
__webpack_require__(658);
__webpack_require__(659);
__webpack_require__(660);
__webpack_require__(661);
__webpack_require__(662);
__webpack_require__(663);
__webpack_require__(664);
__webpack_require__(665);
__webpack_require__(666);
__webpack_require__(667);
__webpack_require__(668);
__webpack_require__(669);
__webpack_require__(670);
__webpack_require__(671);
__webpack_require__(672);
__webpack_require__(673);
__webpack_require__(674);
__webpack_require__(675);
__webpack_require__(676);
__webpack_require__(677);
__webpack_require__(678);
__webpack_require__(679);
__webpack_require__(680);
__webpack_require__(681);
__webpack_require__(682);
__webpack_require__(683);
__webpack_require__(684);
__webpack_require__(685);
__webpack_require__(686);
__webpack_require__(687);
__webpack_require__(688);
__webpack_require__(689);
__webpack_require__(690);
__webpack_require__(691);
__webpack_require__(692);
__webpack_require__(693);
__webpack_require__(694);
__webpack_require__(695);
__webpack_require__(696);
__webpack_require__(697);
__webpack_require__(698);
__webpack_require__(699);
__webpack_require__(700);
__webpack_require__(701);
__webpack_require__(702);
__webpack_require__(703);
module.exports = __webpack_require__(44);


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(4);
var has = __webpack_require__(39);
var DESCRIPTORS = __webpack_require__(17);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(36);
var META = __webpack_require__(69).KEY;
var $fails = __webpack_require__(7);
var shared = __webpack_require__(99);
var setToStringTag = __webpack_require__(92);
var uid = __webpack_require__(74);
var wks = __webpack_require__(13);
var wksExt = __webpack_require__(216);
var wksDefine = __webpack_require__(144);
var enumKeys = __webpack_require__(510);
var isArray = __webpack_require__(118);
var anObject = __webpack_require__(3);
var isObject = __webpack_require__(8);
var toObject = __webpack_require__(22);
var toIObject = __webpack_require__(40);
var toPrimitive = __webpack_require__(53);
var createDesc = __webpack_require__(73);
var _create = __webpack_require__(77);
var gOPNExt = __webpack_require__(219);
var $GOPD = __webpack_require__(41);
var $GOPS = __webpack_require__(117);
var $DP = __webpack_require__(20);
var $keys = __webpack_require__(75);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(78).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(101).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(68)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(35)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(99)('native-function-to-string', Function.toString);


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(75);
var gOPS = __webpack_require__(117);
var pIE = __webpack_require__(101);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(77) });


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(17), 'Object', { defineProperty: __webpack_require__(20).f });


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(17), 'Object', { defineProperties: __webpack_require__(218) });


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(40);
var $getOwnPropertyDescriptor = __webpack_require__(41).f;

__webpack_require__(55)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(22);
var $getPrototypeOf = __webpack_require__(42);

__webpack_require__(55)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(22);
var $keys = __webpack_require__(75);

__webpack_require__(55)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(55)('getOwnPropertyNames', function () {
  return __webpack_require__(219).f;
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(69).onFreeze;

__webpack_require__(55)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(69).onFreeze;

__webpack_require__(55)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(8);
var meta = __webpack_require__(69).onFreeze;

__webpack_require__(55)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(8);

__webpack_require__(55)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(8);

__webpack_require__(55)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(8);

__webpack_require__(55)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(220) });


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { is: __webpack_require__(221) });


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(148).set });


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(93);
var test = {};
test[__webpack_require__(13)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(36)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', { bind: __webpack_require__(222) });


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(17) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(42);
var HAS_INSTANCE = __webpack_require__(13)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(20).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(224);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(225);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var has = __webpack_require__(39);
var cof = __webpack_require__(46);
var inheritIfRequired = __webpack_require__(150);
var toPrimitive = __webpack_require__(53);
var fails = __webpack_require__(7);
var gOPN = __webpack_require__(78).f;
var gOPD = __webpack_require__(41).f;
var dP = __webpack_require__(20).f;
var $trim = __webpack_require__(94).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(77)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(17) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(36)(global, NUMBER, $Number);
}


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toInteger = __webpack_require__(47);
var aNumberValue = __webpack_require__(226);
var repeat = __webpack_require__(151);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(7)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $fails = __webpack_require__(7);
var aNumberValue = __webpack_require__(226);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(1);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(1);
var _isFinite = __webpack_require__(4).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', { isInteger: __webpack_require__(227) });


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(1);
var isInteger = __webpack_require__(227);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(225);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(224);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(1);
var log1p = __webpack_require__(228);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(1);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(1);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(1);
var sign = __webpack_require__(152);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(1);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(1);
var $expm1 = __webpack_require__(153);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { fround: __webpack_require__(229) });


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(1);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(1);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { log1p: __webpack_require__(228) });


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { sign: __webpack_require__(152) });


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(153);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(153);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(76);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(40);
var toLength = __webpack_require__(14);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(94)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(119)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(154)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $at = __webpack_require__(119)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(14);
var context = __webpack_require__(156);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(157)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(1);
var context = __webpack_require__(156);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(157)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(151)
});


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(14);
var context = __webpack_require__(156);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(157)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(37)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(37)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(37)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(37)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(37)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(37)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(37)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(37)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(37)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(37)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(37)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(37)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(37)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(53);

$export($export.P + $export.F * __webpack_require__(7)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(1);
var toISOString = __webpack_require__(587);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(7);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(36)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(13)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(35)(proto, TO_PRIMITIVE, __webpack_require__(590));


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(3);
var toPrimitive = __webpack_require__(53);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', { isArray: __webpack_require__(118) });


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(45);
var $export = __webpack_require__(1);
var toObject = __webpack_require__(22);
var call = __webpack_require__(230);
var isArrayIter = __webpack_require__(158);
var toLength = __webpack_require__(14);
var createProperty = __webpack_require__(159);
var getIterFn = __webpack_require__(160);

$export($export.S + $export.F * !__webpack_require__(121)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var createProperty = __webpack_require__(159);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(7)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(1);
var toIObject = __webpack_require__(40);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(100) != Object || !__webpack_require__(48)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var html = __webpack_require__(147);
var cof = __webpack_require__(46);
var toAbsoluteIndex = __webpack_require__(76);
var toLength = __webpack_require__(14);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(7)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var aFunction = __webpack_require__(27);
var toObject = __webpack_require__(22);
var fails = __webpack_require__(7);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(48)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $forEach = __webpack_require__(56)(0);
var STRICT = __webpack_require__(48)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var isArray = __webpack_require__(118);
var SPECIES = __webpack_require__(13)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $map = __webpack_require__(56)(1);

$export($export.P + $export.F * !__webpack_require__(48)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $filter = __webpack_require__(56)(2);

$export($export.P + $export.F * !__webpack_require__(48)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $some = __webpack_require__(56)(3);

$export($export.P + $export.F * !__webpack_require__(48)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $every = __webpack_require__(56)(4);

$export($export.P + $export.F * !__webpack_require__(48)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(231);

$export($export.P + $export.F * !__webpack_require__(48)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(231);

$export($export.P + $export.F * !__webpack_require__(48)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $indexOf = __webpack_require__(116)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(48)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(40);
var toInteger = __webpack_require__(47);
var toLength = __webpack_require__(14);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(48)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { copyWithin: __webpack_require__(232) });

__webpack_require__(70)('copyWithin');


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { fill: __webpack_require__(162) });

__webpack_require__(70)('fill');


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(56)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(70)(KEY);


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(56)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(70)(KEY);


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79)('Array');


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var inheritIfRequired = __webpack_require__(150);
var dP = __webpack_require__(20).f;
var gOPN = __webpack_require__(78).f;
var isRegExp = __webpack_require__(120);
var $flags = __webpack_require__(102);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(17) && (!CORRECT_NEW || __webpack_require__(7)(function () {
  re2[__webpack_require__(13)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(36)(global, 'RegExp', $RegExp);
}

__webpack_require__(79)('RegExp');


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(235);
var anObject = __webpack_require__(3);
var $flags = __webpack_require__(102);
var DESCRIPTORS = __webpack_require__(17);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(36)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(7)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(3);
var toLength = __webpack_require__(14);
var advanceStringIndex = __webpack_require__(165);
var regExpExec = __webpack_require__(122);

// @@match logic
__webpack_require__(123)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(3);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(14);
var toInteger = __webpack_require__(47);
var advanceStringIndex = __webpack_require__(165);
var regExpExec = __webpack_require__(122);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(123)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(3);
var sameValue = __webpack_require__(221);
var regExpExec = __webpack_require__(122);

// @@search logic
__webpack_require__(123)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(120);
var anObject = __webpack_require__(3);
var speciesConstructor = __webpack_require__(103);
var advanceStringIndex = __webpack_require__(165);
var toLength = __webpack_require__(14);
var callRegExpExec = __webpack_require__(122);
var regexpExec = __webpack_require__(164);
var fails = __webpack_require__(7);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(123)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(68);
var global = __webpack_require__(4);
var ctx = __webpack_require__(45);
var classof = __webpack_require__(93);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(8);
var aFunction = __webpack_require__(27);
var anInstance = __webpack_require__(80);
var forOf = __webpack_require__(81);
var speciesConstructor = __webpack_require__(103);
var task = __webpack_require__(166).set;
var microtask = __webpack_require__(167)();
var newPromiseCapabilityModule = __webpack_require__(168);
var perform = __webpack_require__(236);
var userAgent = __webpack_require__(124);
var promiseResolve = __webpack_require__(237);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(13)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(82)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(92)($Promise, PROMISE);
__webpack_require__(79)(PROMISE);
Wrapper = __webpack_require__(44)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(121)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(242);
var validate = __webpack_require__(83);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(125)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $typed = __webpack_require__(126);
var buffer = __webpack_require__(169);
var anObject = __webpack_require__(3);
var toAbsoluteIndex = __webpack_require__(76);
var toLength = __webpack_require__(14);
var isObject = __webpack_require__(8);
var ArrayBuffer = __webpack_require__(4).ArrayBuffer;
var speciesConstructor = __webpack_require__(103);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(79)(ARRAY_BUFFER);


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
$export($export.G + $export.W + $export.F * !__webpack_require__(126).ABV, {
  DataView: __webpack_require__(169).DataView
});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(27);
var anObject = __webpack_require__(3);
var rApply = (__webpack_require__(4).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(7)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(1);
var create = __webpack_require__(77);
var aFunction = __webpack_require__(27);
var anObject = __webpack_require__(3);
var isObject = __webpack_require__(8);
var fails = __webpack_require__(7);
var bind = __webpack_require__(222);
var rConstruct = (__webpack_require__(4).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(20);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(3);
var toPrimitive = __webpack_require__(53);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(7)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(1);
var gOPD = __webpack_require__(41).f;
var anObject = __webpack_require__(3);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(3);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(155)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(41);
var getPrototypeOf = __webpack_require__(42);
var has = __webpack_require__(39);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(8);
var anObject = __webpack_require__(3);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(41);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(3);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(1);
var getProto = __webpack_require__(42);
var anObject = __webpack_require__(3);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(3);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(244) });


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(3);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(20);
var gOPD = __webpack_require__(41);
var getPrototypeOf = __webpack_require__(42);
var has = __webpack_require__(39);
var $export = __webpack_require__(1);
var createDesc = __webpack_require__(73);
var anObject = __webpack_require__(3);
var isObject = __webpack_require__(8);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(1);
var setProto = __webpack_require__(148);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(1);
var $includes = __webpack_require__(116)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(70)('includes');


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(245);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(14);
var aFunction = __webpack_require__(27);
var arraySpeciesCreate = __webpack_require__(161);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(70)('flatMap');


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(245);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(14);
var toInteger = __webpack_require__(47);
var arraySpeciesCreate = __webpack_require__(161);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(70)('flatten');


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(1);
var $at = __webpack_require__(119)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(246);
var userAgent = __webpack_require__(124);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(246);
var userAgent = __webpack_require__(124);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(94)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(94)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(1);
var defined = __webpack_require__(54);
var toLength = __webpack_require__(14);
var isRegExp = __webpack_require__(120);
var getFlags = __webpack_require__(102);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(155)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(144)('asyncIterator');


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(144)('observable');


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(1);
var ownKeys = __webpack_require__(244);
var toIObject = __webpack_require__(40);
var gOPD = __webpack_require__(41);
var createProperty = __webpack_require__(159);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $values = __webpack_require__(247)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(247)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(22);
var aFunction = __webpack_require__(27);
var $defineProperty = __webpack_require__(20);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(17) && $export($export.P + __webpack_require__(127), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(22);
var aFunction = __webpack_require__(27);
var $defineProperty = __webpack_require__(20);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(17) && $export($export.P + __webpack_require__(127), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(53);
var getPrototypeOf = __webpack_require__(42);
var getOwnPropertyDescriptor = __webpack_require__(41).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(17) && $export($export.P + __webpack_require__(127), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(53);
var getPrototypeOf = __webpack_require__(42);
var getOwnPropertyDescriptor = __webpack_require__(41).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(17) && $export($export.P + __webpack_require__(127), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(248)('Map') });


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(248)('Set') });


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(128)('Map');


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(128)('Set');


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(128)('WeakMap');


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(128)('WeakSet');


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(129)('Map');


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(129)('Set');


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(129)('WeakMap');


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(129)('WeakSet');


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.G, { global: __webpack_require__(4) });


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.S, 'System', { global: __webpack_require__(4) });


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(1);
var cof = __webpack_require__(46);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var scale = __webpack_require__(250);
var fround = __webpack_require__(229);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { scale: __webpack_require__(250) });


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(1);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(1);
var core = __webpack_require__(44);
var global = __webpack_require__(4);
var speciesConstructor = __webpack_require__(103);
var promiseResolve = __webpack_require__(237);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(1);
var newPromiseCapability = __webpack_require__(168);
var perform = __webpack_require__(236);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(3);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(3);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(3);
var getPrototypeOf = __webpack_require__(42);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(240);
var from = __webpack_require__(249);
var metadata = __webpack_require__(62);
var anObject = __webpack_require__(3);
var getPrototypeOf = __webpack_require__(42);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(3);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(3);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(3);
var getPrototypeOf = __webpack_require__(42);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(62);
var anObject = __webpack_require__(3);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(62);
var anObject = __webpack_require__(3);
var aFunction = __webpack_require__(27);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(1);
var microtask = __webpack_require__(167)();
var process = __webpack_require__(4).process;
var isNode = __webpack_require__(46)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(1);
var global = __webpack_require__(4);
var core = __webpack_require__(44);
var microtask = __webpack_require__(167)();
var OBSERVABLE = __webpack_require__(13)('observable');
var aFunction = __webpack_require__(27);
var anObject = __webpack_require__(3);
var anInstance = __webpack_require__(80);
var redefineAll = __webpack_require__(82);
var hide = __webpack_require__(35);
var forOf = __webpack_require__(81);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(79)('Observable');


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(4);
var $export = __webpack_require__(1);
var userAgent = __webpack_require__(124);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $task = __webpack_require__(166);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(163);
var getKeys = __webpack_require__(75);
var redefine = __webpack_require__(36);
var global = __webpack_require__(4);
var hide = __webpack_require__(35);
var Iterators = __webpack_require__(95);
var wks = __webpack_require__(13);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(706);
module.exports = __webpack_require__(44).RegExp.escape;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(1);
var $re = __webpack_require__(707)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.validateRangeInOneMonth = exports.extractTimeFormat = exports.extractDateFormat = exports.nextYear = exports.prevYear = exports.nextMonth = exports.prevMonth = exports.changeYearMonthAndClampDate = exports.timeWithinRange = exports.limitTimeRange = exports.clearMilliseconds = exports.clearTime = exports.modifyWithTimeString = exports.modifyTime = exports.modifyDate = exports.range = exports.getRangeMinutes = exports.getMonthDays = exports.getPrevMonthLastDays = exports.getRangeHours = exports.getWeekNumber = exports.getStartDateOfMonth = exports.nextDate = exports.prevDate = exports.getFirstDayOfMonth = exports.getDayCountOfYear = exports.getDayCountOfMonth = exports.parseDate = exports.formatDate = exports.isDateObject = exports.isDate = exports.toDate = exports.getI18nSettings = undefined;

var _date = __webpack_require__(251);

var _date2 = _interopRequireDefault(_date);

var _locale = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var weeks = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

var newArray = function newArray(start, end) {
  var result = [];
  for (var i = start; i <= end; i++) {
    result.push(i);
  }
  return result;
};

var getI18nSettings = exports.getI18nSettings = function getI18nSettings() {
  return {
    dayNamesShort: weeks.map(function (week) {
      return (0, _locale.t)('el.datepicker.weeks.' + week);
    }),
    dayNames: weeks.map(function (week) {
      return (0, _locale.t)('el.datepicker.weeks.' + week);
    }),
    monthNamesShort: months.map(function (month) {
      return (0, _locale.t)('el.datepicker.months.' + month);
    }),
    monthNames: months.map(function (month, index) {
      return (0, _locale.t)('el.datepicker.month' + (index + 1));
    }),
    amPm: ['am', 'pm']
  };
};

var toDate = exports.toDate = function toDate(date) {
  return isDate(date) ? new Date(date) : null;
};

var isDate = exports.isDate = function isDate(date) {
  if (date === null || date === undefined) return false;
  if (isNaN(new Date(date).getTime())) return false;
  if (Array.isArray(date)) return false; // deal with `new Date([ new Date() ]) -> new Date()`
  return true;
};

var isDateObject = exports.isDateObject = function isDateObject(val) {
  return val instanceof Date;
};

var formatDate = exports.formatDate = function formatDate(date, format) {
  date = toDate(date);
  if (!date) return '';
  return _date2.default.format(date, format || 'yyyy-MM-dd', getI18nSettings());
};

var parseDate = exports.parseDate = function parseDate(string, format) {
  return _date2.default.parse(string, format || 'yyyy-MM-dd', getI18nSettings());
};

var getDayCountOfMonth = exports.getDayCountOfMonth = function getDayCountOfMonth(year, month) {
  if (month === 3 || month === 5 || month === 8 || month === 10) {
    return 30;
  }

  if (month === 1) {
    if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
      return 29;
    } else {
      return 28;
    }
  }

  return 31;
};

var getDayCountOfYear = exports.getDayCountOfYear = function getDayCountOfYear(year) {
  var isLeapYear = year % 400 === 0 || year % 100 !== 0 && year % 4 === 0;
  return isLeapYear ? 366 : 365;
};

var getFirstDayOfMonth = exports.getFirstDayOfMonth = function getFirstDayOfMonth(date) {
  var temp = new Date(date.getTime());
  temp.setDate(1);
  return temp.getDay();
};

// see: https://stackoverflow.com/questions/3674539/incrementing-a-date-in-javascript
// {prev, next} Date should work for Daylight Saving Time
// Adding 24 * 60 * 60 * 1000 does not work in the above scenario
var prevDate = exports.prevDate = function prevDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount);
};

var nextDate = exports.nextDate = function nextDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
};

var getStartDateOfMonth = exports.getStartDateOfMonth = function getStartDateOfMonth(year, month) {
  var result = new Date(year, month, 1);
  var day = result.getDay();

  if (day === 0) {
    return prevDate(result, 7);
  } else {
    return prevDate(result, day);
  }
};

var getWeekNumber = exports.getWeekNumber = function getWeekNumber(src) {
  if (!isDate(src)) return null;
  var date = new Date(src.getTime());
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
  // January 4 is always in week 1.
  var week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
  // Rounding should be fine for Daylight Saving Time. Its shift should never be more than 12 hours.
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
};

var getRangeHours = exports.getRangeHours = function getRangeHours(ranges) {
  var hours = [];
  var disabledHours = [];

  (ranges || []).forEach(function (range) {
    var value = range.map(function (date) {
      return date.getHours();
    });

    disabledHours = disabledHours.concat(newArray(value[0], value[1]));
  });

  if (disabledHours.length) {
    for (var i = 0; i < 24; i++) {
      hours[i] = disabledHours.indexOf(i) === -1;
    }
  } else {
    for (var _i = 0; _i < 24; _i++) {
      hours[_i] = false;
    }
  }

  return hours;
};

var getPrevMonthLastDays = exports.getPrevMonthLastDays = function getPrevMonthLastDays(date, amount) {
  if (amount <= 0) return [];
  var temp = new Date(date.getTime());
  temp.setDate(0);
  var lastDay = temp.getDate();
  return range(amount).map(function (_, index) {
    return lastDay - (amount - index - 1);
  });
};

var getMonthDays = exports.getMonthDays = function getMonthDays(date) {
  var temp = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  var days = temp.getDate();
  return range(days).map(function (_, index) {
    return index + 1;
  });
};

function setRangeData(arr, start, end, value) {
  for (var i = start; i < end; i++) {
    arr[i] = value;
  }
}

var getRangeMinutes = exports.getRangeMinutes = function getRangeMinutes(ranges, hour) {
  var minutes = new Array(60);

  if (ranges.length > 0) {
    ranges.forEach(function (range) {
      var start = range[0];
      var end = range[1];
      var startHour = start.getHours();
      var startMinute = start.getMinutes();
      var endHour = end.getHours();
      var endMinute = end.getMinutes();
      if (startHour === hour && endHour !== hour) {
        setRangeData(minutes, startMinute, 60, true);
      } else if (startHour === hour && endHour === hour) {
        setRangeData(minutes, startMinute, endMinute + 1, true);
      } else if (startHour !== hour && endHour === hour) {
        setRangeData(minutes, 0, endMinute + 1, true);
      } else if (startHour < hour && endHour > hour) {
        setRangeData(minutes, 0, 60, true);
      }
    });
  } else {
    setRangeData(minutes, 0, 60, true);
  }
  return minutes;
};

var range = exports.range = function range(n) {
  // see https://stackoverflow.com/questions/3746725/create-a-javascript-array-containing-1-n
  return Array.apply(null, { length: n }).map(function (_, n) {
    return n;
  });
};

var modifyDate = exports.modifyDate = function modifyDate(date, y, m, d) {
  return new Date(y, m, d, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
};

var modifyTime = exports.modifyTime = function modifyTime(date, h, m, s) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), h, m, s, date.getMilliseconds());
};

var modifyWithTimeString = exports.modifyWithTimeString = function modifyWithTimeString(date, time) {
  if (date == null || !time) {
    return date;
  }
  time = parseDate(time, 'HH:mm:ss');
  return modifyTime(date, time.getHours(), time.getMinutes(), time.getSeconds());
};

var clearTime = exports.clearTime = function clearTime(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

var clearMilliseconds = exports.clearMilliseconds = function clearMilliseconds(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), 0);
};

var limitTimeRange = exports.limitTimeRange = function limitTimeRange(date, ranges) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'HH:mm:ss';

  // TODO: refactory a more elegant solution
  if (ranges.length === 0) return date;
  var normalizeDate = function normalizeDate(date) {
    return _date2.default.parse(_date2.default.format(date, format), format);
  };
  var ndate = normalizeDate(date);
  var nranges = ranges.map(function (range) {
    return range.map(normalizeDate);
  });
  if (nranges.some(function (nrange) {
    return ndate >= nrange[0] && ndate <= nrange[1];
  })) return date;

  var minDate = nranges[0][0];
  var maxDate = nranges[0][0];

  nranges.forEach(function (nrange) {
    minDate = new Date(Math.min(nrange[0], minDate));
    maxDate = new Date(Math.max(nrange[1], minDate));
  });

  var ret = ndate < minDate ? minDate : maxDate;
  // preserve Year/Month/Date
  return modifyDate(ret, date.getFullYear(), date.getMonth(), date.getDate());
};

var timeWithinRange = exports.timeWithinRange = function timeWithinRange(date, selectableRange, format) {
  var limitedDate = limitTimeRange(date, selectableRange, format);
  return limitedDate.getTime() === date.getTime();
};

var changeYearMonthAndClampDate = exports.changeYearMonthAndClampDate = function changeYearMonthAndClampDate(date, year, month) {
  // clamp date to the number of days in `year`, `month`
  // eg: (2010-1-31, 2010, 2) => 2010-2-28
  var monthDate = Math.min(date.getDate(), getDayCountOfMonth(year, month));
  return modifyDate(date, year, month, monthDate);
};

var prevMonth = exports.prevMonth = function prevMonth(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  return month === 0 ? changeYearMonthAndClampDate(date, year - 1, 11) : changeYearMonthAndClampDate(date, year, month - 1);
};

var nextMonth = exports.nextMonth = function nextMonth(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  return month === 11 ? changeYearMonthAndClampDate(date, year + 1, 0) : changeYearMonthAndClampDate(date, year, month + 1);
};

var prevYear = exports.prevYear = function prevYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var year = date.getFullYear();
  var month = date.getMonth();
  return changeYearMonthAndClampDate(date, year - amount, month);
};

var nextYear = exports.nextYear = function nextYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var year = date.getFullYear();
  var month = date.getMonth();
  return changeYearMonthAndClampDate(date, year + amount, month);
};

var extractDateFormat = exports.extractDateFormat = function extractDateFormat(format) {
  return format.replace(/\W?m{1,2}|\W?ZZ/g, '').replace(/\W?h{1,2}|\W?s{1,3}|\W?a/gi, '').trim();
};

var extractTimeFormat = exports.extractTimeFormat = function extractTimeFormat(format) {
  return format.replace(/\W?D{1,2}|\W?Do|\W?d{1,4}|\W?M{1,4}|\W?y{2,4}/g, '').trim();
};

var validateRangeInOneMonth = exports.validateRangeInOneMonth = function validateRangeInOneMonth(start, end) {
  return start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
};

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _dom = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasModal = false;
var hasInitZIndex = false;
var zIndex = void 0;

var getModal = function getModal() {
  if (_vue2.default.prototype.$isServer) return;
  var modalDom = PopupManager.modalDom;
  if (modalDom) {
    hasModal = true;
  } else {
    hasModal = false;
    modalDom = document.createElement('div');
    PopupManager.modalDom = modalDom;

    modalDom.addEventListener('touchmove', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    modalDom.addEventListener('click', function () {
      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
    });
  }

  return modalDom;
};

var instances = {};

var PopupManager = {
  modalFade: true,

  getInstance: function getInstance(id) {
    return instances[id];
  },

  register: function register(id, instance) {
    if (id && instance) {
      instances[id] = instance;
    }
  },

  deregister: function deregister(id) {
    if (id) {
      instances[id] = null;
      delete instances[id];
    }
  },

  nextZIndex: function nextZIndex() {
    return PopupManager.zIndex++;
  },

  modalStack: [],

  doOnModalClick: function doOnModalClick() {
    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topItem) return;

    var instance = PopupManager.getInstance(topItem.id);
    if (instance && instance.closeOnClickModal) {
      instance.close();
    }
  },

  openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
    if (_vue2.default.prototype.$isServer) return;
    if (!id || zIndex === undefined) return;
    this.modalFade = modalFade;

    var modalStack = this.modalStack;

    for (var i = 0, j = modalStack.length; i < j; i++) {
      var item = modalStack[i];
      if (item.id === id) {
        return;
      }
    }

    var modalDom = getModal();

    (0, _dom.addClass)(modalDom, 'v-modal');
    if (this.modalFade && !hasModal) {
      (0, _dom.addClass)(modalDom, 'v-modal-enter');
    }
    if (modalClass) {
      var classArr = modalClass.trim().split(/\s+/);
      classArr.forEach(function (item) {
        return (0, _dom.addClass)(modalDom, item);
      });
    }
    setTimeout(function () {
      (0, _dom.removeClass)(modalDom, 'v-modal-enter');
    }, 200);

    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
      dom.parentNode.appendChild(modalDom);
    } else {
      document.body.appendChild(modalDom);
    }

    if (zIndex) {
      modalDom.style.zIndex = zIndex;
    }
    modalDom.tabIndex = 0;
    modalDom.style.display = '';

    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
  },

  closeModal: function closeModal(id) {
    var modalStack = this.modalStack;
    var modalDom = getModal();

    if (modalStack.length > 0) {
      var topItem = modalStack[modalStack.length - 1];
      if (topItem.id === id) {
        if (topItem.modalClass) {
          var classArr = topItem.modalClass.trim().split(/\s+/);
          classArr.forEach(function (item) {
            return (0, _dom.removeClass)(modalDom, item);
          });
        }

        modalStack.pop();
        if (modalStack.length > 0) {
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
        }
      } else {
        for (var i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1);
            break;
          }
        }
      }
    }

    if (modalStack.length === 0) {
      if (this.modalFade) {
        (0, _dom.addClass)(modalDom, 'v-modal-leave');
      }
      setTimeout(function () {
        if (modalStack.length === 0) {
          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
          modalDom.style.display = 'none';
          PopupManager.modalDom = undefined;
        }
        (0, _dom.removeClass)(modalDom, 'v-modal-leave');
      }, 200);
    }
  }
};

Object.defineProperty(PopupManager, 'zIndex', {
  configurable: true,
  get: function get() {
    if (!hasInitZIndex) {
      zIndex = zIndex || (_vue2.default.prototype.$ELEMENT || {}).zIndex || 2000;
      hasInitZIndex = true;
    }
    return zIndex;
  },
  set: function set(value) {
    zIndex = value;
  }
});

var getTopPopup = function getTopPopup() {
  if (_vue2.default.prototype.$isServer) return;
  if (PopupManager.modalStack.length > 0) {
    var topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topPopup) return;
    var instance = PopupManager.getInstance(topPopup.id);

    return instance;
  }
};

if (!_vue2.default.prototype.$isServer) {
  // handle `esc` key when the popup is shown
  window.addEventListener('keydown', function (event) {
    if (event.keyCode === 27) {
      var topPopup = getTopPopup();

      if (topPopup && topPopup.closeOnPressEscape) {
        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close();
      }
    }
  });
}

exports.default = PopupManager;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version {{version}}
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

//
// Cross module loader
// Supported: Node, AMD, Browser globals
//
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.Popper = factory();
    }
})(undefined, function () {

    'use strict';

    var root = window;

    // default options
    var DEFAULTS = {
        // placement of the popper
        placement: 'bottom',

        gpuAcceleration: true,

        // shift popper from its origin by the given amount of pixels (can be negative)
        offset: 0,

        // the element which will act as boundary of the popper
        boundariesElement: 'viewport',

        // amount of pixel used to define a minimum distance between the boundaries and the popper
        boundariesPadding: 5,

        // popper will try to prevent overflow following this order,
        // by default, then, it could overflow on the left and on top of the boundariesElement
        preventOverflowOrder: ['left', 'right', 'top', 'bottom'],

        // the behavior used by flip to change the placement of the popper
        flipBehavior: 'flip',

        arrowElement: '[x-arrow]',

        arrowOffset: 0,

        // list of functions used to modify the offsets before they are applied to the popper
        modifiers: ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle'],

        modifiersIgnored: [],

        forceAbsolute: false
    };

    /**
     * Create a new Popper.js instance
     * @constructor Popper
     * @param {HTMLElement} reference - The reference element used to position the popper
     * @param {HTMLElement|Object} popper
     *      The HTML element used as popper, or a configuration used to generate the popper.
     * @param {String} [popper.tagName='div'] The tag name of the generated popper.
     * @param {Array} [popper.classNames=['popper']] Array of classes to apply to the generated popper.
     * @param {Array} [popper.attributes] Array of attributes to apply, specify `attr:value` to assign a value to it.
     * @param {HTMLElement|String} [popper.parent=window.document.body] The parent element, given as HTMLElement or as query string.
     * @param {String} [popper.content=''] The content of the popper, it can be text, html, or node; if it is not text, set `contentType` to `html` or `node`.
     * @param {String} [popper.contentType='text'] If `html`, the `content` will be parsed as HTML. If `node`, it will be appended as-is.
     * @param {String} [popper.arrowTagName='div'] Same as `popper.tagName` but for the arrow element.
     * @param {Array} [popper.arrowClassNames='popper__arrow'] Same as `popper.classNames` but for the arrow element.
     * @param {String} [popper.arrowAttributes=['x-arrow']] Same as `popper.attributes` but for the arrow element.
     * @param {Object} options
     * @param {String} [options.placement=bottom]
     *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -right),
     *      left(-start, -end)`
     *
     * @param {HTMLElement|String} [options.arrowElement='[x-arrow]']
     *      The DOM Node used as arrow for the popper, or a CSS selector used to get the DOM node. It must be child of
     *      its parent Popper. Popper.js will apply to the given element the style required to align the arrow with its
     *      reference element.
     *      By default, it will look for a child node of the popper with the `x-arrow` attribute.
     *
     * @param {Boolean} [options.gpuAcceleration=true]
     *      When this property is set to true, the popper position will be applied using CSS3 translate3d, allowing the
     *      browser to use the GPU to accelerate the rendering.
     *      If set to false, the popper will be placed using `top` and `left` properties, not using the GPU.
     *
     * @param {Number} [options.offset=0]
     *      Amount of pixels the popper will be shifted (can be negative).
     *
     * @param {String|Element} [options.boundariesElement='viewport']
     *      The element which will define the boundaries of the popper position, the popper will never be placed outside
     *      of the defined boundaries (except if `keepTogether` is enabled)
     *
     * @param {Number} [options.boundariesPadding=5]
     *      Additional padding for the boundaries
     *
     * @param {Array} [options.preventOverflowOrder=['left', 'right', 'top', 'bottom']]
     *      Order used when Popper.js tries to avoid overflows from the boundaries, they will be checked in order,
     *      this means that the last ones will never overflow
     *
     * @param {String|Array} [options.flipBehavior='flip']
     *      The behavior used by the `flip` modifier to change the placement of the popper when the latter is trying to
     *      overlap its reference element. Defining `flip` as value, the placement will be flipped on
     *      its axis (`right - left`, `top - bottom`).
     *      You can even pass an array of placements (eg: `['right', 'left', 'top']` ) to manually specify
     *      how alter the placement when a flip is needed. (eg. in the above example, it would first flip from right to left,
     *      then, if even in its new placement, the popper is overlapping its reference element, it will be moved to top)
     *
     * @param {Array} [options.modifiers=[ 'shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle']]
     *      List of functions used to modify the data before they are applied to the popper, add your custom functions
     *      to this array to edit the offsets and placement.
     *      The function should reflect the @params and @returns of preventOverflow
     *
     * @param {Array} [options.modifiersIgnored=[]]
     *      Put here any built-in modifier name you want to exclude from the modifiers list
     *      The function should reflect the @params and @returns of preventOverflow
     *
     * @param {Boolean} [options.removeOnDestroy=false]
     *      Set to true if you want to automatically remove the popper when you call the `destroy` method.
     */
    function Popper(reference, popper, options) {
        this._reference = reference.jquery ? reference[0] : reference;
        this.state = {};

        // if the popper variable is a configuration object, parse it to generate an HTMLElement
        // generate a default popper if is not defined
        var isNotDefined = typeof popper === 'undefined' || popper === null;
        var isConfig = popper && Object.prototype.toString.call(popper) === '[object Object]';
        if (isNotDefined || isConfig) {
            this._popper = this.parse(isConfig ? popper : {});
        }
        // otherwise, use the given HTMLElement as popper
        else {
                this._popper = popper.jquery ? popper[0] : popper;
            }

        // with {} we create a new object with the options inside it
        this._options = Object.assign({}, DEFAULTS, options);

        // refactoring modifiers' list
        this._options.modifiers = this._options.modifiers.map(function (modifier) {
            // remove ignored modifiers
            if (this._options.modifiersIgnored.indexOf(modifier) !== -1) return;

            // set the x-placement attribute before everything else because it could be used to add margins to the popper
            // margins needs to be calculated to get the correct popper offsets
            if (modifier === 'applyStyle') {
                this._popper.setAttribute('x-placement', this._options.placement);
            }

            // return predefined modifier identified by string or keep the custom one
            return this.modifiers[modifier] || modifier;
        }.bind(this));

        // make sure to apply the popper position before any computation
        this.state.position = this._getPosition(this._popper, this._reference);
        setStyle(this._popper, { position: this.state.position, top: 0 });

        // fire the first update to position the popper in the right place
        this.update();

        // setup event listeners, they will take care of update the position in specific situations
        this._setupEventListeners();
        return this;
    }

    //
    // Methods
    //
    /**
     * Destroy the popper
     * @method
     * @memberof Popper
     */
    Popper.prototype.destroy = function () {
        this._popper.removeAttribute('x-placement');
        this._popper.style.left = '';
        this._popper.style.position = '';
        this._popper.style.top = '';
        this._popper.style[getSupportedPropertyName('transform')] = '';
        this._removeEventListeners();

        // remove the popper if user explicity asked for the deletion on destroy
        if (this._options.removeOnDestroy) {
            this._popper.remove();
        }
        return this;
    };

    /**
     * Updates the position of the popper, computing the new offsets and applying the new style
     * @method
     * @memberof Popper
     */
    Popper.prototype.update = function () {
        var data = { instance: this, styles: {} };

        // store placement inside the data object, modifiers will be able to edit `placement` if needed
        // and refer to _originalPlacement to know the original value
        data.placement = this._options.placement;
        data._originalPlacement = this._options.placement;

        // compute the popper and reference offsets and put them inside data.offsets
        data.offsets = this._getOffsets(this._popper, this._reference, data.placement);

        // get boundaries
        data.boundaries = this._getBoundaries(data, this._options.boundariesPadding, this._options.boundariesElement);

        data = this.runModifiers(data, this._options.modifiers);

        if (typeof this.state.updateCallback === 'function') {
            this.state.updateCallback(data);
        }
    };

    /**
     * If a function is passed, it will be executed after the initialization of popper with as first argument the Popper instance.
     * @method
     * @memberof Popper
     * @param {Function} callback
     */
    Popper.prototype.onCreate = function (callback) {
        // the createCallbacks return as first argument the popper instance
        callback(this);
        return this;
    };

    /**
     * If a function is passed, it will be executed after each update of popper with as first argument the set of coordinates and informations
     * used to style popper and its arrow.
     * NOTE: it doesn't get fired on the first call of the `Popper.update()` method inside the `Popper` constructor!
     * @method
     * @memberof Popper
     * @param {Function} callback
     */
    Popper.prototype.onUpdate = function (callback) {
        this.state.updateCallback = callback;
        return this;
    };

    /**
     * Helper used to generate poppers from a configuration file
     * @method
     * @memberof Popper
     * @param config {Object} configuration
     * @returns {HTMLElement} popper
     */
    Popper.prototype.parse = function (config) {
        var defaultConfig = {
            tagName: 'div',
            classNames: ['popper'],
            attributes: [],
            parent: root.document.body,
            content: '',
            contentType: 'text',
            arrowTagName: 'div',
            arrowClassNames: ['popper__arrow'],
            arrowAttributes: ['x-arrow']
        };
        config = Object.assign({}, defaultConfig, config);

        var d = root.document;

        var popper = d.createElement(config.tagName);
        addClassNames(popper, config.classNames);
        addAttributes(popper, config.attributes);
        if (config.contentType === 'node') {
            popper.appendChild(config.content.jquery ? config.content[0] : config.content);
        } else if (config.contentType === 'html') {
            popper.innerHTML = config.content;
        } else {
            popper.textContent = config.content;
        }

        if (config.arrowTagName) {
            var arrow = d.createElement(config.arrowTagName);
            addClassNames(arrow, config.arrowClassNames);
            addAttributes(arrow, config.arrowAttributes);
            popper.appendChild(arrow);
        }

        var parent = config.parent.jquery ? config.parent[0] : config.parent;

        // if the given parent is a string, use it to match an element
        // if more than one element is matched, the first one will be used as parent
        // if no elements are matched, the script will throw an error
        if (typeof parent === 'string') {
            parent = d.querySelectorAll(config.parent);
            if (parent.length > 1) {
                console.warn('WARNING: the given `parent` query(' + config.parent + ') matched more than one element, the first one will be used');
            }
            if (parent.length === 0) {
                throw 'ERROR: the given `parent` doesn\'t exists!';
            }
            parent = parent[0];
        }
        // if the given parent is a DOM nodes list or an array of nodes with more than one element,
        // the first one will be used as parent
        if (parent.length > 1 && parent instanceof Element === false) {
            console.warn('WARNING: you have passed as parent a list of elements, the first one will be used');
            parent = parent[0];
        }

        // append the generated popper to its parent
        parent.appendChild(popper);

        return popper;

        /**
         * Adds class names to the given element
         * @function
         * @ignore
         * @param {HTMLElement} target
         * @param {Array} classes
         */
        function addClassNames(element, classNames) {
            classNames.forEach(function (className) {
                element.classList.add(className);
            });
        }

        /**
         * Adds attributes to the given element
         * @function
         * @ignore
         * @param {HTMLElement} target
         * @param {Array} attributes
         * @example
         * addAttributes(element, [ 'data-info:foobar' ]);
         */
        function addAttributes(element, attributes) {
            attributes.forEach(function (attribute) {
                element.setAttribute(attribute.split(':')[0], attribute.split(':')[1] || '');
            });
        }
    };

    /**
     * Helper used to get the position which will be applied to the popper
     * @method
     * @memberof Popper
     * @param config {HTMLElement} popper element
     * @param reference {HTMLElement} reference element
     * @returns {String} position
     */
    Popper.prototype._getPosition = function (popper, reference) {
        var container = getOffsetParent(reference);

        if (this._options.forceAbsolute) {
            return 'absolute';
        }

        // Decide if the popper will be fixed
        // If the reference element is inside a fixed context, the popper will be fixed as well to allow them to scroll together
        var isParentFixed = isFixed(reference, container);
        return isParentFixed ? 'fixed' : 'absolute';
    };

    /**
     * Get offsets to the popper
     * @method
     * @memberof Popper
     * @access private
     * @param {Element} popper - the popper element
     * @param {Element} reference - the reference element (the popper will be relative to this)
     * @returns {Object} An object containing the offsets which will be applied to the popper
     */
    Popper.prototype._getOffsets = function (popper, reference, placement) {
        placement = placement.split('-')[0];
        var popperOffsets = {};

        popperOffsets.position = this.state.position;
        var isParentFixed = popperOffsets.position === 'fixed';

        //
        // Get reference element position
        //
        var referenceOffsets = getOffsetRectRelativeToCustomParent(reference, getOffsetParent(popper), isParentFixed);

        //
        // Get popper sizes
        //
        var popperRect = getOuterSizes(popper);

        //
        // Compute offsets of popper
        //

        // depending by the popper placement we have to compute its offsets slightly differently
        if (['right', 'left'].indexOf(placement) !== -1) {
            popperOffsets.top = referenceOffsets.top + referenceOffsets.height / 2 - popperRect.height / 2;
            if (placement === 'left') {
                popperOffsets.left = referenceOffsets.left - popperRect.width;
            } else {
                popperOffsets.left = referenceOffsets.right;
            }
        } else {
            popperOffsets.left = referenceOffsets.left + referenceOffsets.width / 2 - popperRect.width / 2;
            if (placement === 'top') {
                popperOffsets.top = referenceOffsets.top - popperRect.height;
            } else {
                popperOffsets.top = referenceOffsets.bottom;
            }
        }

        // Add width and height to our offsets object
        popperOffsets.width = popperRect.width;
        popperOffsets.height = popperRect.height;

        return {
            popper: popperOffsets,
            reference: referenceOffsets
        };
    };

    /**
     * Setup needed event listeners used to update the popper position
     * @method
     * @memberof Popper
     * @access private
     */
    Popper.prototype._setupEventListeners = function () {
        // NOTE: 1 DOM access here
        this.state.updateBound = this.update.bind(this);
        root.addEventListener('resize', this.state.updateBound);
        // if the boundariesElement is window we don't need to listen for the scroll event
        if (this._options.boundariesElement !== 'window') {
            var target = getScrollParent(this._reference);
            // here it could be both `body` or `documentElement` thanks to Firefox, we then check both
            if (target === root.document.body || target === root.document.documentElement) {
                target = root;
            }
            target.addEventListener('scroll', this.state.updateBound);
            this.state.scrollTarget = target;
        }
    };

    /**
     * Remove event listeners used to update the popper position
     * @method
     * @memberof Popper
     * @access private
     */
    Popper.prototype._removeEventListeners = function () {
        // NOTE: 1 DOM access here
        root.removeEventListener('resize', this.state.updateBound);
        if (this._options.boundariesElement !== 'window' && this.state.scrollTarget) {
            this.state.scrollTarget.removeEventListener('scroll', this.state.updateBound);
            this.state.scrollTarget = null;
        }
        this.state.updateBound = null;
    };

    /**
     * Computed the boundaries limits and return them
     * @method
     * @memberof Popper
     * @access private
     * @param {Object} data - Object containing the property "offsets" generated by `_getOffsets`
     * @param {Number} padding - Boundaries padding
     * @param {Element} boundariesElement - Element used to define the boundaries
     * @returns {Object} Coordinates of the boundaries
     */
    Popper.prototype._getBoundaries = function (data, padding, boundariesElement) {
        // NOTE: 1 DOM access here
        var boundaries = {};
        var width, height;
        if (boundariesElement === 'window') {
            var body = root.document.body,
                html = root.document.documentElement;

            height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
            width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);

            boundaries = {
                top: 0,
                right: width,
                bottom: height,
                left: 0
            };
        } else if (boundariesElement === 'viewport') {
            var offsetParent = getOffsetParent(this._popper);
            var scrollParent = getScrollParent(this._popper);
            var offsetParentRect = getOffsetRect(offsetParent);

            // Thanks the fucking native API, `document.body.scrollTop` & `document.documentElement.scrollTop`
            var getScrollTopValue = function getScrollTopValue(element) {
                return element == document.body ? Math.max(document.documentElement.scrollTop, document.body.scrollTop) : element.scrollTop;
            };
            var getScrollLeftValue = function getScrollLeftValue(element) {
                return element == document.body ? Math.max(document.documentElement.scrollLeft, document.body.scrollLeft) : element.scrollLeft;
            };

            // if the popper is fixed we don't have to substract scrolling from the boundaries
            var scrollTop = data.offsets.popper.position === 'fixed' ? 0 : getScrollTopValue(scrollParent);
            var scrollLeft = data.offsets.popper.position === 'fixed' ? 0 : getScrollLeftValue(scrollParent);

            boundaries = {
                top: 0 - (offsetParentRect.top - scrollTop),
                right: root.document.documentElement.clientWidth - (offsetParentRect.left - scrollLeft),
                bottom: root.document.documentElement.clientHeight - (offsetParentRect.top - scrollTop),
                left: 0 - (offsetParentRect.left - scrollLeft)
            };
        } else {
            if (getOffsetParent(this._popper) === boundariesElement) {
                boundaries = {
                    top: 0,
                    left: 0,
                    right: boundariesElement.clientWidth,
                    bottom: boundariesElement.clientHeight
                };
            } else {
                boundaries = getOffsetRect(boundariesElement);
            }
        }
        boundaries.left += padding;
        boundaries.right -= padding;
        boundaries.top = boundaries.top + padding;
        boundaries.bottom = boundaries.bottom - padding;
        return boundaries;
    };

    /**
     * Loop trough the list of modifiers and run them in order, each of them will then edit the data object
     * @method
     * @memberof Popper
     * @access public
     * @param {Object} data
     * @param {Array} modifiers
     * @param {Function} ends
     */
    Popper.prototype.runModifiers = function (data, modifiers, ends) {
        var modifiersToRun = modifiers.slice();
        if (ends !== undefined) {
            modifiersToRun = this._options.modifiers.slice(0, getArrayKeyIndex(this._options.modifiers, ends));
        }

        modifiersToRun.forEach(function (modifier) {
            if (isFunction(modifier)) {
                data = modifier.call(this, data);
            }
        }.bind(this));

        return data;
    };

    /**
     * Helper used to know if the given modifier depends from another one.
     * @method
     * @memberof Popper
     * @param {String} requesting - name of requesting modifier
     * @param {String} requested - name of requested modifier
     * @returns {Boolean}
     */
    Popper.prototype.isModifierRequired = function (requesting, requested) {
        var index = getArrayKeyIndex(this._options.modifiers, requesting);
        return !!this._options.modifiers.slice(0, index).filter(function (modifier) {
            return modifier === requested;
        }).length;
    };

    //
    // Modifiers
    //

    /**
     * Modifiers list
     * @namespace Popper.modifiers
     * @memberof Popper
     * @type {Object}
     */
    Popper.prototype.modifiers = {};

    /**
     * Apply the computed styles to the popper element
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The same data object
     */
    Popper.prototype.modifiers.applyStyle = function (data) {
        // apply the final offsets to the popper
        // NOTE: 1 DOM access here
        var styles = {
            position: data.offsets.popper.position
        };

        // round top and left to avoid blurry text
        var left = Math.round(data.offsets.popper.left);
        var top = Math.round(data.offsets.popper.top);

        // if gpuAcceleration is set to true and transform is supported, we use `translate3d` to apply the position to the popper
        // we automatically use the supported prefixed version if needed
        var prefixedProperty;
        if (this._options.gpuAcceleration && (prefixedProperty = getSupportedPropertyName('transform'))) {
            styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
            styles.top = 0;
            styles.left = 0;
        }
        // othwerise, we use the standard `left` and `top` properties
        else {
                styles.left = left;
                styles.top = top;
            }

        // any property present in `data.styles` will be applied to the popper,
        // in this way we can make the 3rd party modifiers add custom styles to it
        // Be aware, modifiers could override the properties defined in the previous
        // lines of this modifier!
        Object.assign(styles, data.styles);

        setStyle(this._popper, styles);

        // set an attribute which will be useful to style the tooltip (use it to properly position its arrow)
        // NOTE: 1 DOM access here
        this._popper.setAttribute('x-placement', data.placement);

        // if the arrow modifier is required and the arrow style has been computed, apply the arrow style
        if (this.isModifierRequired(this.modifiers.applyStyle, this.modifiers.arrow) && data.offsets.arrow) {
            setStyle(data.arrowElement, data.offsets.arrow);
        }

        return data;
    };

    /**
     * Modifier used to shift the popper on the start or end of its reference element side
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.shift = function (data) {
        var placement = data.placement;
        var basePlacement = placement.split('-')[0];
        var shiftVariation = placement.split('-')[1];

        // if shift shiftVariation is specified, run the modifier
        if (shiftVariation) {
            var reference = data.offsets.reference;
            var popper = getPopperClientRect(data.offsets.popper);

            var shiftOffsets = {
                y: {
                    start: { top: reference.top },
                    end: { top: reference.top + reference.height - popper.height }
                },
                x: {
                    start: { left: reference.left },
                    end: { left: reference.left + reference.width - popper.width }
                }
            };

            var axis = ['bottom', 'top'].indexOf(basePlacement) !== -1 ? 'x' : 'y';

            data.offsets.popper = Object.assign(popper, shiftOffsets[axis][shiftVariation]);
        }

        return data;
    };

    /**
     * Modifier used to make sure the popper does not overflows from it's boundaries
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.preventOverflow = function (data) {
        var order = this._options.preventOverflowOrder;
        var popper = getPopperClientRect(data.offsets.popper);

        var check = {
            left: function left() {
                var left = popper.left;
                if (popper.left < data.boundaries.left) {
                    left = Math.max(popper.left, data.boundaries.left);
                }
                return { left: left };
            },
            right: function right() {
                var left = popper.left;
                if (popper.right > data.boundaries.right) {
                    left = Math.min(popper.left, data.boundaries.right - popper.width);
                }
                return { left: left };
            },
            top: function top() {
                var top = popper.top;
                if (popper.top < data.boundaries.top) {
                    top = Math.max(popper.top, data.boundaries.top);
                }
                return { top: top };
            },
            bottom: function bottom() {
                var top = popper.top;
                if (popper.bottom > data.boundaries.bottom) {
                    top = Math.min(popper.top, data.boundaries.bottom - popper.height);
                }
                return { top: top };
            }
        };

        order.forEach(function (direction) {
            data.offsets.popper = Object.assign(popper, check[direction]());
        });

        return data;
    };

    /**
     * Modifier used to make sure the popper is always near its reference
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.keepTogether = function (data) {
        var popper = getPopperClientRect(data.offsets.popper);
        var reference = data.offsets.reference;
        var f = Math.floor;

        if (popper.right < f(reference.left)) {
            data.offsets.popper.left = f(reference.left) - popper.width;
        }
        if (popper.left > f(reference.right)) {
            data.offsets.popper.left = f(reference.right);
        }
        if (popper.bottom < f(reference.top)) {
            data.offsets.popper.top = f(reference.top) - popper.height;
        }
        if (popper.top > f(reference.bottom)) {
            data.offsets.popper.top = f(reference.bottom);
        }

        return data;
    };

    /**
     * Modifier used to flip the placement of the popper when the latter is starting overlapping its reference element.
     * Requires the `preventOverflow` modifier before it in order to work.
     * **NOTE:** This modifier will run all its previous modifiers everytime it tries to flip the popper!
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.flip = function (data) {
        // check if preventOverflow is in the list of modifiers before the flip modifier.
        // otherwise flip would not work as expected.
        if (!this.isModifierRequired(this.modifiers.flip, this.modifiers.preventOverflow)) {
            console.warn('WARNING: preventOverflow modifier is required by flip modifier in order to work, be sure to include it before flip!');
            return data;
        }

        if (data.flipped && data.placement === data._originalPlacement) {
            // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
            return data;
        }

        var placement = data.placement.split('-')[0];
        var placementOpposite = getOppositePlacement(placement);
        var variation = data.placement.split('-')[1] || '';

        var flipOrder = [];
        if (this._options.flipBehavior === 'flip') {
            flipOrder = [placement, placementOpposite];
        } else {
            flipOrder = this._options.flipBehavior;
        }

        flipOrder.forEach(function (step, index) {
            if (placement !== step || flipOrder.length === index + 1) {
                return;
            }

            placement = data.placement.split('-')[0];
            placementOpposite = getOppositePlacement(placement);

            var popperOffsets = getPopperClientRect(data.offsets.popper);

            // this boolean is used to distinguish right and bottom from top and left
            // they need different computations to get flipped
            var a = ['right', 'bottom'].indexOf(placement) !== -1;

            // using Math.floor because the reference offsets may contain decimals we are not going to consider here
            if (a && Math.floor(data.offsets.reference[placement]) > Math.floor(popperOffsets[placementOpposite]) || !a && Math.floor(data.offsets.reference[placement]) < Math.floor(popperOffsets[placementOpposite])) {
                // we'll use this boolean to detect any flip loop
                data.flipped = true;
                data.placement = flipOrder[index + 1];
                if (variation) {
                    data.placement += '-' + variation;
                }
                data.offsets.popper = this._getOffsets(this._popper, this._reference, data.placement).popper;

                data = this.runModifiers(data, this._options.modifiers, this._flip);
            }
        }.bind(this));
        return data;
    };

    /**
     * Modifier used to add an offset to the popper, useful if you more granularity positioning your popper.
     * The offsets will shift the popper on the side of its reference element.
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.offset = function (data) {
        var offset = this._options.offset;
        var popper = data.offsets.popper;

        if (data.placement.indexOf('left') !== -1) {
            popper.top -= offset;
        } else if (data.placement.indexOf('right') !== -1) {
            popper.top += offset;
        } else if (data.placement.indexOf('top') !== -1) {
            popper.left -= offset;
        } else if (data.placement.indexOf('bottom') !== -1) {
            popper.left += offset;
        }
        return data;
    };

    /**
     * Modifier used to move the arrows on the edge of the popper to make sure them are always between the popper and the reference element
     * It will use the CSS outer size of the arrow element to know how many pixels of conjuction are needed
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.arrow = function (data) {
        var arrow = this._options.arrowElement;
        var arrowOffset = this._options.arrowOffset;

        // if the arrowElement is a string, suppose it's a CSS selector
        if (typeof arrow === 'string') {
            arrow = this._popper.querySelector(arrow);
        }

        // if arrow element is not found, don't run the modifier
        if (!arrow) {
            return data;
        }

        // the arrow element must be child of its popper
        if (!this._popper.contains(arrow)) {
            console.warn('WARNING: `arrowElement` must be child of its popper element!');
            return data;
        }

        // arrow depends on keepTogether in order to work
        if (!this.isModifierRequired(this.modifiers.arrow, this.modifiers.keepTogether)) {
            console.warn('WARNING: keepTogether modifier is required by arrow modifier in order to work, be sure to include it before arrow!');
            return data;
        }

        var arrowStyle = {};
        var placement = data.placement.split('-')[0];
        var popper = getPopperClientRect(data.offsets.popper);
        var reference = data.offsets.reference;
        var isVertical = ['left', 'right'].indexOf(placement) !== -1;

        var len = isVertical ? 'height' : 'width';
        var side = isVertical ? 'top' : 'left';
        var translate = isVertical ? 'translateY' : 'translateX';
        var altSide = isVertical ? 'left' : 'top';
        var opSide = isVertical ? 'bottom' : 'right';
        var arrowSize = getOuterSizes(arrow)[len];

        //
        // extends keepTogether behavior making sure the popper and its reference have enough pixels in conjuction
        //

        // top/left side
        if (reference[opSide] - arrowSize < popper[side]) {
            data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowSize);
        }
        // bottom/right side
        if (reference[side] + arrowSize > popper[opSide]) {
            data.offsets.popper[side] += reference[side] + arrowSize - popper[opSide];
        }

        // compute center of the popper
        var center = reference[side] + (arrowOffset || reference[len] / 2 - arrowSize / 2);

        var sideValue = center - popper[side];

        // prevent arrow from being placed not contiguously to its popper
        sideValue = Math.max(Math.min(popper[len] - arrowSize - 8, sideValue), 8);
        arrowStyle[side] = sideValue;
        arrowStyle[altSide] = ''; // make sure to remove any old style from the arrow

        data.offsets.arrow = arrowStyle;
        data.arrowElement = arrow;

        return data;
    };

    //
    // Helpers
    //

    /**
     * Get the outer sizes of the given element (offset size + margins)
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Object} object containing width and height properties
     */
    function getOuterSizes(element) {
        // NOTE: 1 DOM access here
        var _display = element.style.display,
            _visibility = element.style.visibility;
        element.style.display = 'block';element.style.visibility = 'hidden';
        var calcWidthToForceRepaint = element.offsetWidth;

        // original method
        var styles = root.getComputedStyle(element);
        var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
        var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
        var result = { width: element.offsetWidth + y, height: element.offsetHeight + x };

        // reset element styles
        element.style.display = _display;element.style.visibility = _visibility;
        return result;
    }

    /**
     * Get the opposite placement of the given one/
     * @function
     * @ignore
     * @argument {String} placement
     * @returns {String} flipped placement
     */
    function getOppositePlacement(placement) {
        var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
        return placement.replace(/left|right|bottom|top/g, function (matched) {
            return hash[matched];
        });
    }

    /**
     * Given the popper offsets, generate an output similar to getBoundingClientRect
     * @function
     * @ignore
     * @argument {Object} popperOffsets
     * @returns {Object} ClientRect like output
     */
    function getPopperClientRect(popperOffsets) {
        var offsets = Object.assign({}, popperOffsets);
        offsets.right = offsets.left + offsets.width;
        offsets.bottom = offsets.top + offsets.height;
        return offsets;
    }

    /**
     * Given an array and the key to find, returns its index
     * @function
     * @ignore
     * @argument {Array} arr
     * @argument keyToFind
     * @returns index or null
     */
    function getArrayKeyIndex(arr, keyToFind) {
        var i = 0,
            key;
        for (key in arr) {
            if (arr[key] === keyToFind) {
                return i;
            }
            i++;
        }
        return null;
    }

    /**
     * Get CSS computed property of the given element
     * @function
     * @ignore
     * @argument {Eement} element
     * @argument {String} property
     */
    function getStyleComputedProperty(element, property) {
        // NOTE: 1 DOM access here
        var css = root.getComputedStyle(element, null);
        return css[property];
    }

    /**
     * Returns the offset parent of the given element
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Element} offset parent
     */
    function getOffsetParent(element) {
        // NOTE: 1 DOM access here
        var offsetParent = element.offsetParent;
        return offsetParent === root.document.body || !offsetParent ? root.document.documentElement : offsetParent;
    }

    /**
     * Returns the scrolling parent of the given element
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Element} offset parent
     */
    function getScrollParent(element) {
        var parent = element.parentNode;

        if (!parent) {
            return element;
        }

        if (parent === root.document) {
            // Firefox puts the scrollTOp value on `documentElement` instead of `body`, we then check which of them is
            // greater than 0 and return the proper element
            if (root.document.body.scrollTop || root.document.body.scrollLeft) {
                return root.document.body;
            } else {
                return root.document.documentElement;
            }
        }

        // Firefox want us to check `-x` and `-y` variations as well
        if (['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1) {
            // If the detected scrollParent is body, we perform an additional check on its parentNode
            // in this way we'll get body if the browser is Chrome-ish, or documentElement otherwise
            // fixes issue #65
            return parent;
        }
        return getScrollParent(element.parentNode);
    }

    /**
     * Check if the given element is fixed or is inside a fixed parent
     * @function
     * @ignore
     * @argument {Element} element
     * @argument {Element} customContainer
     * @returns {Boolean} answer to "isFixed?"
     */
    function isFixed(element) {
        if (element === root.document.body) {
            return false;
        }
        if (getStyleComputedProperty(element, 'position') === 'fixed') {
            return true;
        }
        return element.parentNode ? isFixed(element.parentNode) : element;
    }

    /**
     * Set the style to the given popper
     * @function
     * @ignore
     * @argument {Element} element - Element to apply the style to
     * @argument {Object} styles - Object with a list of properties and values which will be applied to the element
     */
    function setStyle(element, styles) {
        function is_numeric(n) {
            return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
        }
        Object.keys(styles).forEach(function (prop) {
            var unit = '';
            // add unit if the value is numeric and is one of the following
            if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && is_numeric(styles[prop])) {
                unit = 'px';
            }
            element.style[prop] = styles[prop] + unit;
        });
    }

    /**
     * Check if the given variable is a function
     * @function
     * @ignore
     * @argument {*} functionToCheck - variable to check
     * @returns {Boolean} answer to: is a function?
     */
    function isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    }

    /**
     * Get the position of the given element, relative to its offset parent
     * @function
     * @ignore
     * @param {Element} element
     * @return {Object} position - Coordinates of the element and its `scrollTop`
     */
    function getOffsetRect(element) {
        var elementRect = {
            width: element.offsetWidth,
            height: element.offsetHeight,
            left: element.offsetLeft,
            top: element.offsetTop
        };

        elementRect.right = elementRect.left + elementRect.width;
        elementRect.bottom = elementRect.top + elementRect.height;

        // position
        return elementRect;
    }

    /**
     * Get bounding client rect of given element
     * @function
     * @ignore
     * @param {HTMLElement} element
     * @return {Object} client rect
     */
    function getBoundingClientRect(element) {
        var rect = element.getBoundingClientRect();

        // whether the IE version is lower than 11
        var isIE = navigator.userAgent.indexOf("MSIE") != -1;

        // fix ie document bounding top always 0 bug
        var rectTop = isIE && element.tagName === 'HTML' ? -element.scrollTop : rect.top;

        return {
            left: rect.left,
            top: rectTop,
            right: rect.right,
            bottom: rect.bottom,
            width: rect.right - rect.left,
            height: rect.bottom - rectTop
        };
    }

    /**
     * Given an element and one of its parents, return the offset
     * @function
     * @ignore
     * @param {HTMLElement} element
     * @param {HTMLElement} parent
     * @return {Object} rect
     */
    function getOffsetRectRelativeToCustomParent(element, parent, fixed) {
        var elementRect = getBoundingClientRect(element);
        var parentRect = getBoundingClientRect(parent);

        if (fixed) {
            var scrollParent = getScrollParent(parent);
            parentRect.top += scrollParent.scrollTop;
            parentRect.bottom += scrollParent.scrollTop;
            parentRect.left += scrollParent.scrollLeft;
            parentRect.right += scrollParent.scrollLeft;
        }

        var rect = {
            top: elementRect.top - parentRect.top,
            left: elementRect.left - parentRect.left,
            bottom: elementRect.top - parentRect.top + elementRect.height,
            right: elementRect.left - parentRect.left + elementRect.width,
            width: elementRect.width,
            height: elementRect.height
        };
        return rect;
    }

    /**
     * Get the prefixed supported property name
     * @function
     * @ignore
     * @argument {String} property (camelCase)
     * @returns {String} prefixed property (camelCase)
     */
    function getSupportedPropertyName(property) {
        var prefixes = ['', 'ms', 'webkit', 'moz', 'o'];

        for (var i = 0; i < prefixes.length; i++) {
            var toCheck = prefixes[i] ? prefixes[i] + property.charAt(0).toUpperCase() + property.slice(1) : property;
            if (typeof root.document.body.style[toCheck] !== 'undefined') {
                return toCheck;
            }
        }
        return null;
    }

    /**
     * The Object.assign() method is used to copy the values of all enumerable own properties from one or more source
     * objects to a target object. It will return the target object.
     * This polyfill doesn't support symbol properties, since ES5 doesn't have symbols anyway
     * Source: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
     * @function
     * @ignore
     */
    if (!Object.assign) {
        Object.defineProperty(Object, 'assign', {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function value(target) {
                if (target === undefined || target === null) {
                    throw new TypeError('Cannot convert first argument to object');
                }

                var to = Object(target);
                for (var i = 1; i < arguments.length; i++) {
                    var nextSource = arguments[i];
                    if (nextSource === undefined || nextSource === null) {
                        continue;
                    }
                    nextSource = Object(nextSource);

                    var keysArray = Object.keys(nextSource);
                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                        var nextKey = keysArray[nextIndex];
                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                        if (desc !== undefined && desc.enumerable) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
                return to;
            }
        });
    }

    return Popper;
});

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 97);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "el-button",
      class: [
        _vm.type ? "el-button--" + _vm.type : "",
        _vm.buttonSize ? "el-button--" + _vm.buttonSize : "",
        {
          "is-disabled": _vm.buttonDisabled,
          "is-loading": _vm.loading,
          "is-plain": _vm.plain,
          "is-round": _vm.round,
          "is-circle": _vm.circle
        }
      ],
      attrs: {
        disabled: _vm.buttonDisabled || _vm.loading,
        autofocus: _vm.autofocus,
        type: _vm.nativeType
      },
      on: { click: _vm.handleClick }
    },
    [
      _vm.loading ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(),
      _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(),
      _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
  name: 'ElButton',

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize: function buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    buttonDisabled: function buttonDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
});
// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/button/src/button.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_buttonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/button/src/button.vue"
/* harmony default export */ var src_button = (component.exports);
// CONCATENATED MODULE: ./packages/button/index.js


/* istanbul ignore next */
src_button.install = function (Vue) {
  Vue.component(src_button.name, src_button);
};

/* harmony default export */ var packages_button = __webpack_exports__["default"] = (src_button);

/***/ })

/******/ });

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(67)))

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dom = __webpack_require__(63);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Transition = function () {
  function Transition() {
    _classCallCheck(this, Transition);
  }

  Transition.prototype.beforeEnter = function beforeEnter(el) {
    (0, _dom.addClass)(el, 'collapse-transition');
    if (!el.dataset) el.dataset = {};

    el.dataset.oldPaddingTop = el.style.paddingTop;
    el.dataset.oldPaddingBottom = el.style.paddingBottom;

    el.style.height = '0';
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
  };

  Transition.prototype.enter = function enter(el) {
    el.dataset.oldOverflow = el.style.overflow;
    if (el.scrollHeight !== 0) {
      el.style.height = el.scrollHeight + 'px';
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    } else {
      el.style.height = '';
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    }

    el.style.overflow = 'hidden';
  };

  Transition.prototype.afterEnter = function afterEnter(el) {
    // for safari: remove class then reset height is necessary
    (0, _dom.removeClass)(el, 'collapse-transition');
    el.style.height = '';
    el.style.overflow = el.dataset.oldOverflow;
  };

  Transition.prototype.beforeLeave = function beforeLeave(el) {
    if (!el.dataset) el.dataset = {};
    el.dataset.oldPaddingTop = el.style.paddingTop;
    el.dataset.oldPaddingBottom = el.style.paddingBottom;
    el.dataset.oldOverflow = el.style.overflow;

    el.style.height = el.scrollHeight + 'px';
    el.style.overflow = 'hidden';
  };

  Transition.prototype.leave = function leave(el) {
    if (el.scrollHeight !== 0) {
      // for safari: add class after set height, or it will jump to zero height suddenly, weired
      (0, _dom.addClass)(el, 'collapse-transition');
      el.style.height = 0;
      el.style.paddingTop = 0;
      el.style.paddingBottom = 0;
    }
  };

  Transition.prototype.afterLeave = function afterLeave(el) {
    (0, _dom.removeClass)(el, 'collapse-transition');
    el.style.height = '';
    el.style.overflow = el.dataset.oldOverflow;
    el.style.paddingTop = el.dataset.oldPaddingTop;
    el.style.paddingBottom = el.dataset.oldPaddingBottom;
  };

  return Transition;
}();

exports.default = {
  name: 'ElCollapseTransition',
  functional: true,
  render: function render(h, _ref) {
    var children = _ref.children;

    var data = {
      on: new Transition()
    };

    return h('transition', data, children);
  }
};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isVNode = isVNode;

var _util = __webpack_require__(52);

function isVNode(node) {
  return node !== null && (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object' && (0, _util.hasOwn)(node, 'componentOptions');
};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 131);
/******/ })
/************************************************************************/
/******/ ({

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
var vue_popper_ = __webpack_require__(5);
var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);

// EXTERNAL MODULE: external "throttle-debounce/debounce"
var debounce_ = __webpack_require__(17);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
var dom_ = __webpack_require__(2);

// EXTERNAL MODULE: external "element-ui/lib/utils/util"
var util_ = __webpack_require__(3);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(7);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./packages/tooltip/src/main.js






/* harmony default export */ var main = ({
  name: 'ElTooltip',

  mixins: [vue_popper_default.a],

  props: {
    openDelay: {
      type: Number,
      default: 0
    },
    disabled: Boolean,
    manual: Boolean,
    effect: {
      type: String,
      default: 'dark'
    },
    arrowOffset: {
      type: Number,
      default: 0
    },
    popperClass: String,
    content: String,
    visibleArrow: {
      default: true
    },
    transition: {
      type: String,
      default: 'el-fade-in-linear'
    },
    popperOptions: {
      default: function _default() {
        return {
          boundariesPadding: 10,
          gpuAcceleration: false
        };
      }
    },
    enterable: {
      type: Boolean,
      default: true
    },
    hideAfter: {
      type: Number,
      default: 0
    },
    tabindex: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      tooltipId: 'el-tooltip-' + Object(util_["generateId"])(),
      timeoutPending: null,
      focusing: false
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    if (this.$isServer) return;

    this.popperVM = new external_vue_default.a({
      data: { node: '' },
      render: function render(h) {
        return this.node;
      }
    }).$mount();

    this.debounceClose = debounce_default()(200, function () {
      return _this.handleClosePopper();
    });
  },
  render: function render(h) {
    var _this2 = this;

    if (this.popperVM) {
      this.popperVM.node = h(
        'transition',
        {
          attrs: {
            name: this.transition
          },
          on: {
            'afterLeave': this.doDestroy
          }
        },
        [h(
          'div',
          {
            on: {
              'mouseleave': function mouseleave() {
                _this2.setExpectedState(false);_this2.debounceClose();
              },
              'mouseenter': function mouseenter() {
                _this2.setExpectedState(true);
              }
            },

            ref: 'popper',
            attrs: { role: 'tooltip',
              id: this.tooltipId,
              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
            },
            directives: [{
              name: 'show',
              value: !this.disabled && this.showPopper
            }],

            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] },
          [this.$slots.content || this.content]
        )]
      );
    }

    var firstElement = this.getFirstElement();
    if (!firstElement) return null;

    var data = firstElement.data = firstElement.data || {};
    data.staticClass = this.addTooltipClass(data.staticClass);

    return firstElement;
  },
  mounted: function mounted() {
    var _this3 = this;

    this.referenceElm = this.$el;
    if (this.$el.nodeType === 1) {
      this.$el.setAttribute('aria-describedby', this.tooltipId);
      this.$el.setAttribute('tabindex', this.tabindex);
      Object(dom_["on"])(this.referenceElm, 'mouseenter', this.show);
      Object(dom_["on"])(this.referenceElm, 'mouseleave', this.hide);
      Object(dom_["on"])(this.referenceElm, 'focus', function () {
        if (!_this3.$slots.default || !_this3.$slots.default.length) {
          _this3.handleFocus();
          return;
        }
        var instance = _this3.$slots.default[0].componentInstance;
        if (instance && instance.focus) {
          instance.focus();
        } else {
          _this3.handleFocus();
        }
      });
      Object(dom_["on"])(this.referenceElm, 'blur', this.handleBlur);
      Object(dom_["on"])(this.referenceElm, 'click', this.removeFocusing);
    }
    // fix issue https://github.com/ElemeFE/element/issues/14424
    if (this.value && this.popperVM) {
      this.popperVM.$nextTick(function () {
        if (_this3.value) {
          _this3.updatePopper();
        }
      });
    }
  },

  watch: {
    focusing: function focusing(val) {
      if (val) {
        Object(dom_["addClass"])(this.referenceElm, 'focusing');
      } else {
        Object(dom_["removeClass"])(this.referenceElm, 'focusing');
      }
    }
  },
  methods: {
    show: function show() {
      this.setExpectedState(true);
      this.handleShowPopper();
    },
    hide: function hide() {
      this.setExpectedState(false);
      this.debounceClose();
    },
    handleFocus: function handleFocus() {
      this.focusing = true;
      this.show();
    },
    handleBlur: function handleBlur() {
      this.focusing = false;
      this.hide();
    },
    removeFocusing: function removeFocusing() {
      this.focusing = false;
    },
    addTooltipClass: function addTooltipClass(prev) {
      if (!prev) {
        return 'el-tooltip';
      } else {
        return 'el-tooltip ' + prev.replace('el-tooltip', '');
      }
    },
    handleShowPopper: function handleShowPopper() {
      var _this4 = this;

      if (!this.expectedState || this.manual) return;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this4.showPopper = true;
      }, this.openDelay);

      if (this.hideAfter > 0) {
        this.timeoutPending = setTimeout(function () {
          _this4.showPopper = false;
        }, this.hideAfter);
      }
    },
    handleClosePopper: function handleClosePopper() {
      if (this.enterable && this.expectedState || this.manual) return;
      clearTimeout(this.timeout);

      if (this.timeoutPending) {
        clearTimeout(this.timeoutPending);
      }
      this.showPopper = false;

      if (this.disabled) {
        this.doDestroy();
      }
    },
    setExpectedState: function setExpectedState(expectedState) {
      if (expectedState === false) {
        clearTimeout(this.timeoutPending);
      }
      this.expectedState = expectedState;
    },
    getFirstElement: function getFirstElement() {
      var slots = this.$slots.default;
      if (!Array.isArray(slots)) return null;
      var element = null;
      for (var index = 0; index < slots.length; index++) {
        if (slots[index] && slots[index].tag) {
          element = slots[index];
        };
      }
      return element;
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.popperVM && this.popperVM.$destroy();
  },
  destroyed: function destroyed() {
    var reference = this.referenceElm;
    if (reference.nodeType === 1) {
      Object(dom_["off"])(reference, 'mouseenter', this.show);
      Object(dom_["off"])(reference, 'mouseleave', this.hide);
      Object(dom_["off"])(reference, 'focus', this.handleFocus);
      Object(dom_["off"])(reference, 'blur', this.handleBlur);
      Object(dom_["off"])(reference, 'click', this.removeFocusing);
    }
  }
});
// CONCATENATED MODULE: ./packages/tooltip/index.js


/* istanbul ignore next */
main.install = function (Vue) {
  Vue.component(main.name, main);
};

/* harmony default export */ var tooltip = __webpack_exports__["default"] = (main);

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __webpack_require__(133);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(63);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(52);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(130);

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(11);

/***/ })

/******/ });

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 99);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-button-group" }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
//
//
//
//
//

/* harmony default export */ var button_groupvue_type_script_lang_js_ = ({
  name: 'ElButtonGroup'
});
// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_button_groupvue_type_script_lang_js_ = (button_groupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/button/src/button-group.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_button_groupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/button/src/button-group.vue"
/* harmony default export */ var button_group = (component.exports);
// CONCATENATED MODULE: ./packages/button-group/index.js


/* istanbul ignore next */
button_group.install = function (Vue) {
  Vue.component(button_group.name, button_group);
};

/* harmony default export */ var packages_button_group = __webpack_exports__["default"] = (button_group);

/***/ })

/******/ });

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 86);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(84);

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-checkbox-group",
      attrs: { role: "group", "aria-label": "checkbox-group" }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&

// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
var emitter_ = __webpack_require__(4);
var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&



/* harmony default export */ var checkbox_groupvue_type_script_lang_js_ = ({
  name: 'ElCheckboxGroup',

  componentName: 'ElCheckboxGroup',

  mixins: [emitter_default.a],

  inject: {
    elFormItem: {
      default: ''
    }
  },

  props: {
    value: {},
    disabled: Boolean,
    min: Number,
    max: Number,
    size: String,
    fill: String,
    textColor: String
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    checkboxGroupSize: function checkboxGroupSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    }
  },

  watch: {
    value: function value(_value) {
      this.dispatch('ElFormItem', 'el.form.change', [_value]);
    }
  }
});
// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_checkbox_groupvue_type_script_lang_js_ = (checkbox_groupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_checkbox_groupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/checkbox/src/checkbox-group.vue"
/* harmony default export */ var checkbox_group = (component.exports);
// CONCATENATED MODULE: ./packages/checkbox-group/index.js


/* istanbul ignore next */
checkbox_group.install = function (Vue) {
  Vue.component(checkbox_group.name, checkbox_group);
};

/* harmony default export */ var packages_checkbox_group = __webpack_exports__["default"] = (checkbox_group);

/***/ })

/******/ });

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, callback) {
  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
  var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!instance || !callback) throw new Error('instance & callback is required');
  var called = false;
  var afterLeaveCallback = function afterLeaveCallback() {
    if (called) return;
    called = true;
    if (callback) {
      callback.apply(null, arguments);
    }
  };
  if (once) {
    instance.$once('after-leave', afterLeaveCallback);
  } else {
    instance.$on('after-leave', afterLeaveCallback);
  }
  setTimeout(function () {
    afterLeaveCallback();
  }, speed + 100);
};

; /**
   * Bind after-leave event for vue instance. Make sure after-leave is called in any browsers.
   *
   * @param {Vue} instance Vue instance.
   * @param {Function} callback callback of after-leave event
   * @param {Number} speed the speed of transition, default value is 300ms
   * @param {Boolean} once weather bind after-leave once. default value is false.
   */

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 119);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-progress",
      class: [
        "el-progress--" + _vm.type,
        _vm.status ? "is-" + _vm.status : "",
        {
          "el-progress--without-text": !_vm.showText,
          "el-progress--text-inside": _vm.textInside
        }
      ],
      attrs: {
        role: "progressbar",
        "aria-valuenow": _vm.percentage,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }
    },
    [
      _vm.type === "line"
        ? _c("div", { staticClass: "el-progress-bar" }, [
            _c(
              "div",
              {
                staticClass: "el-progress-bar__outer",
                style: { height: _vm.strokeWidth + "px" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "el-progress-bar__inner",
                    style: _vm.barStyle
                  },
                  [
                    _vm.showText && _vm.textInside
                      ? _c(
                          "div",
                          { staticClass: "el-progress-bar__innerText" },
                          [_vm._v(_vm._s(_vm.content))]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ])
        : _c(
            "div",
            {
              staticClass: "el-progress-circle",
              style: { height: _vm.width + "px", width: _vm.width + "px" }
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 100 100" } }, [
                _c("path", {
                  staticClass: "el-progress-circle__track",
                  style: _vm.trailPathStyle,
                  attrs: {
                    d: _vm.trackPath,
                    stroke: "#e5e9f2",
                    "stroke-width": _vm.relativeStrokeWidth,
                    fill: "none"
                  }
                }),
                _c("path", {
                  staticClass: "el-progress-circle__path",
                  style: _vm.circlePathStyle,
                  attrs: {
                    d: _vm.trackPath,
                    stroke: _vm.stroke,
                    fill: "none",
                    "stroke-linecap": _vm.strokeLinecap,
                    "stroke-width": _vm.percentage ? _vm.relativeStrokeWidth : 0
                  }
                })
              ])
            ]
          ),
      _vm.showText && !_vm.textInside
        ? _c(
            "div",
            {
              staticClass: "el-progress__text",
              style: { fontSize: _vm.progressTextSize + "px" }
            },
            [
              !_vm.status
                ? [_vm._v(_vm._s(_vm.content))]
                : _c("i", { class: _vm.iconClass })
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var progressvue_type_script_lang_js_ = ({
  name: 'ElProgress',
  props: {
    type: {
      type: String,
      default: 'line',
      validator: function validator(val) {
        return ['line', 'circle', 'dashboard'].indexOf(val) > -1;
      }
    },
    percentage: {
      type: Number,
      default: 0,
      required: true,
      validator: function validator(val) {
        return val >= 0 && val <= 100;
      }
    },
    status: {
      type: String,
      validator: function validator(val) {
        return ['success', 'exception', 'warning'].indexOf(val) > -1;
      }
    },
    strokeWidth: {
      type: Number,
      default: 6
    },
    strokeLinecap: {
      type: String,
      default: 'round'
    },
    textInside: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 126
    },
    showText: {
      type: Boolean,
      default: true
    },
    color: {
      type: [String, Array, Function],
      default: ''
    },
    format: Function
  },
  computed: {
    barStyle: function barStyle() {
      var style = {};
      style.width = this.percentage + '%';
      style.backgroundColor = this.getCurrentColor(this.percentage);
      return style;
    },
    relativeStrokeWidth: function relativeStrokeWidth() {
      return (this.strokeWidth / this.width * 100).toFixed(1);
    },
    radius: function radius() {
      if (this.type === 'circle' || this.type === 'dashboard') {
        return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
      } else {
        return 0;
      }
    },
    trackPath: function trackPath() {
      var radius = this.radius;
      var isDashboard = this.type === 'dashboard';
      return '\n        M 50 50\n        m 0 ' + (isDashboard ? '' : '-') + radius + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '-' : '') + radius * 2 + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '' : '-') + radius * 2 + '\n        ';
    },
    perimeter: function perimeter() {
      return 2 * Math.PI * this.radius;
    },
    rate: function rate() {
      return this.type === 'dashboard' ? 0.75 : 1;
    },
    strokeDashoffset: function strokeDashoffset() {
      var offset = -1 * this.perimeter * (1 - this.rate) / 2;
      return offset + 'px';
    },
    trailPathStyle: function trailPathStyle() {
      return {
        strokeDasharray: this.perimeter * this.rate + 'px, ' + this.perimeter + 'px',
        strokeDashoffset: this.strokeDashoffset
      };
    },
    circlePathStyle: function circlePathStyle() {
      return {
        strokeDasharray: this.perimeter * this.rate * (this.percentage / 100) + 'px, ' + this.perimeter + 'px',
        strokeDashoffset: this.strokeDashoffset,
        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
      };
    },
    stroke: function stroke() {
      var ret = void 0;
      if (this.color) {
        ret = this.getCurrentColor(this.percentage);
      } else {
        switch (this.status) {
          case 'success':
            ret = '#13ce66';
            break;
          case 'exception':
            ret = '#ff4949';
            break;
          case 'warning':
            ret = '#e6a23c';
            break;
          default:
            ret = '#20a0ff';
        }
      }
      return ret;
    },
    iconClass: function iconClass() {
      if (this.status === 'warning') {
        return 'el-icon-warning';
      }
      if (this.type === 'line') {
        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
      } else {
        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
      }
    },
    progressTextSize: function progressTextSize() {
      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
    },
    content: function content() {
      if (typeof this.format === 'function') {
        return this.format(this.percentage) || '';
      } else {
        return this.percentage + '%';
      }
    }
  },
  methods: {
    getCurrentColor: function getCurrentColor(percentage) {
      if (typeof this.color === 'function') {
        return this.color(percentage);
      } else if (typeof this.color === 'string') {
        return this.color;
      } else {
        return this.getLevelColor(percentage);
      }
    },
    getLevelColor: function getLevelColor(percentage) {
      var colorArray = this.getColorArray().sort(function (a, b) {
        return a.percentage - b.percentage;
      });

      for (var i = 0; i < colorArray.length; i++) {
        if (colorArray[i].percentage > percentage) {
          return colorArray[i].color;
        }
      }
      return colorArray[colorArray.length - 1].color;
    },
    getColorArray: function getColorArray() {
      var color = this.color;
      var span = 100 / color.length;
      return color.map(function (seriesColor, index) {
        if (typeof seriesColor === 'string') {
          return {
            color: seriesColor,
            progress: (index + 1) * span
          };
        }
        return seriesColor;
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_progressvue_type_script_lang_js_ = (progressvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/progress/src/progress.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_progressvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/progress/src/progress.vue"
/* harmony default export */ var progress = (component.exports);
// CONCATENATED MODULE: ./packages/progress/index.js


/* istanbul ignore next */
progress.install = function (Vue) {
  Vue.component(progress.name, progress);
};

/* harmony default export */ var packages_progress = __webpack_exports__["default"] = (progress);

/***/ })

/******/ });

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var throttle = __webpack_require__(174);
var debounce = __webpack_require__(133);

module.exports = {
	throttle: throttle,
	debounce: debounce
};


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 61);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(52);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(84);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(130);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(170);

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(172);

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(254);

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(175);

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(173);

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(133);

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(113);

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(132);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(176);

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(177);

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      staticClass: "el-select-dropdown__item",
      class: {
        selected: _vm.itemSelected,
        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
        hover: _vm.hover
      },
      on: {
        mouseenter: _vm.hoverItem,
        click: function($event) {
          $event.stopPropagation()
          return _vm.selectOptionClick($event)
        }
      }
    },
    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&

// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
var emitter_ = __webpack_require__(4);
var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

// EXTERNAL MODULE: external "element-ui/lib/utils/util"
var util_ = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var optionvue_type_script_lang_js_ = ({
  mixins: [emitter_default.a],

  name: 'ElOption',

  componentName: 'ElOption',

  inject: ['select'],

  props: {
    value: {
      required: true
    },
    label: [String, Number],
    created: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      index: -1,
      groupDisabled: false,
      visible: true,
      hitState: false,
      hover: false
    };
  },


  computed: {
    isObject: function isObject() {
      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
    },
    currentLabel: function currentLabel() {
      return this.label || (this.isObject ? '' : this.value);
    },
    currentValue: function currentValue() {
      return this.value || this.label || '';
    },
    itemSelected: function itemSelected() {
      if (!this.select.multiple) {
        return this.isEqual(this.value, this.select.value);
      } else {
        return this.contains(this.select.value, this.value);
      }
    },
    limitReached: function limitReached() {
      if (this.select.multiple) {
        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
      } else {
        return false;
      }
    }
  },

  watch: {
    currentLabel: function currentLabel() {
      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
    },
    value: function value(val, oldVal) {
      var _select = this.select,
          remote = _select.remote,
          valueKey = _select.valueKey;

      if (!this.created && !remote) {
        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
          return;
        }
        this.dispatch('ElSelect', 'setSelected');
      }
    }
  },

  methods: {
    isEqual: function isEqual(a, b) {
      if (!this.isObject) {
        return a === b;
      } else {
        var valueKey = this.select.valueKey;
        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
      }
    },
    contains: function contains() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var target = arguments[1];

      if (!this.isObject) {
        return arr && arr.indexOf(target) > -1;
      } else {
        var valueKey = this.select.valueKey;
        return arr && arr.some(function (item) {
          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
        });
      }
    },
    handleGroupDisabled: function handleGroupDisabled(val) {
      this.groupDisabled = val;
    },
    hoverItem: function hoverItem() {
      if (!this.disabled && !this.groupDisabled) {
        this.select.hoverIndex = this.select.options.indexOf(this);
      }
    },
    selectOptionClick: function selectOptionClick() {
      if (this.disabled !== true && this.groupDisabled !== true) {
        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
      }
    },
    queryChange: function queryChange(query) {
      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
      if (!this.visible) {
        this.select.filteredOptionsCount--;
      }
    }
  },

  created: function created() {
    this.select.options.push(this);
    this.select.cachedOptions.push(this);
    this.select.optionsCount++;
    this.select.filteredOptionsCount++;

    this.$on('queryChange', this.queryChange);
    this.$on('handleGroupDisabled', this.handleGroupDisabled);
  },
  beforeDestroy: function beforeDestroy() {
    var _select2 = this.select,
        selected = _select2.selected,
        multiple = _select2.multiple;

    var selectedOptions = multiple ? selected : [selected];
    var index = this.select.cachedOptions.indexOf(this);
    var selectedIndex = selectedOptions.indexOf(this);

    // if option is not selected, remove it from cache
    if (index > -1 && selectedIndex < 0) {
      this.select.cachedOptions.splice(index, 1);
    }
    this.select.onOptionDestroy(this.select.options.indexOf(this));
  }
});
// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/select/src/option.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_optionvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/select/src/option.vue"
/* harmony default export */ var src_option = __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(257);

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.handleClose,
          expression: "handleClose"
        }
      ],
      staticClass: "el-select",
      class: [_vm.selectSize ? "el-select--" + _vm.selectSize : ""],
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.toggleMenu($event)
        }
      }
    },
    [
      _vm.multiple
        ? _c(
            "div",
            {
              ref: "tags",
              staticClass: "el-select__tags",
              style: { "max-width": _vm.inputWidth - 32 + "px", width: "100%" }
            },
            [
              _vm.collapseTags && _vm.selected.length
                ? _c(
                    "span",
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            closable: !_vm.selectDisabled,
                            size: _vm.collapseTagSize,
                            hit: _vm.selected[0].hitState,
                            type: "info",
                            "disable-transitions": ""
                          },
                          on: {
                            close: function($event) {
                              _vm.deleteTag($event, _vm.selected[0])
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "el-select__tags-text" }, [
                            _vm._v(_vm._s(_vm.selected[0].currentLabel))
                          ])
                        ]
                      ),
                      _vm.selected.length > 1
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                closable: false,
                                size: _vm.collapseTagSize,
                                type: "info",
                                "disable-transitions": ""
                              }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "el-select__tags-text" },
                                [_vm._v("+ " + _vm._s(_vm.selected.length - 1))]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.collapseTags
                ? _c(
                    "transition-group",
                    { on: { "after-leave": _vm.resetInputHeight } },
                    _vm._l(_vm.selected, function(item) {
                      return _c(
                        "el-tag",
                        {
                          key: _vm.getValueKey(item),
                          attrs: {
                            closable: !_vm.selectDisabled,
                            size: _vm.collapseTagSize,
                            hit: item.hitState,
                            type: "info",
                            "disable-transitions": ""
                          },
                          on: {
                            close: function($event) {
                              _vm.deleteTag($event, item)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "el-select__tags-text" }, [
                            _vm._v(_vm._s(item.currentLabel))
                          ])
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm.filterable
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.query,
                        expression: "query"
                      }
                    ],
                    ref: "input",
                    staticClass: "el-select__input",
                    class: [_vm.selectSize ? "is-" + _vm.selectSize : ""],
                    style: {
                      "flex-grow": "1",
                      width: _vm.inputLength / (_vm.inputWidth - 32) + "%",
                      "max-width": _vm.inputWidth - 42 + "px"
                    },
                    attrs: {
                      type: "text",
                      disabled: _vm.selectDisabled,
                      autocomplete: _vm.autoComplete || _vm.autocomplete
                    },
                    domProps: { value: _vm.query },
                    on: {
                      focus: _vm.handleFocus,
                      blur: function($event) {
                        _vm.softFocus = false
                      },
                      keyup: _vm.managePlaceholder,
                      keydown: [
                        _vm.resetInputState,
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k($event.keyCode, "down", 40, $event.key, [
                              "Down",
                              "ArrowDown"
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.navigateOptions("next")
                        },
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k($event.keyCode, "up", 38, $event.key, [
                              "Up",
                              "ArrowUp"
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.navigateOptions("prev")
                        },
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.selectOption($event)
                        },
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k($event.keyCode, "esc", 27, $event.key, [
                              "Esc",
                              "Escape"
                            ])
                          ) {
                            return null
                          }
                          $event.stopPropagation()
                          $event.preventDefault()
                          _vm.visible = false
                        },
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k(
                              $event.keyCode,
                              "delete",
                              [8, 46],
                              $event.key,
                              ["Backspace", "Delete", "Del"]
                            )
                          ) {
                            return null
                          }
                          return _vm.deletePrevTag($event)
                        },
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                          ) {
                            return null
                          }
                          _vm.visible = false
                        }
                      ],
                      compositionstart: _vm.handleComposition,
                      compositionupdate: _vm.handleComposition,
                      compositionend: _vm.handleComposition,
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.query = $event.target.value
                        },
                        _vm.debouncedQueryChange
                      ]
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-input",
        {
          ref: "reference",
          class: { "is-focus": _vm.visible },
          attrs: {
            type: "text",
            placeholder: _vm.currentPlaceholder,
            name: _vm.name,
            id: _vm.id,
            autocomplete: _vm.autoComplete || _vm.autocomplete,
            size: _vm.selectSize,
            disabled: _vm.selectDisabled,
            readonly: _vm.readonly,
            "validate-event": false,
            tabindex: _vm.multiple && _vm.filterable ? "-1" : null
          },
          on: { focus: _vm.handleFocus, blur: _vm.handleBlur },
          nativeOn: {
            keyup: function($event) {
              return _vm.debouncedOnInputChange($event)
            },
            keydown: [
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                $event.stopPropagation()
                $event.preventDefault()
                _vm.navigateOptions("next")
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                $event.stopPropagation()
                $event.preventDefault()
                _vm.navigateOptions("prev")
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.selectOption($event)
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape"
                  ])
                ) {
                  return null
                }
                $event.stopPropagation()
                $event.preventDefault()
                _vm.visible = false
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                ) {
                  return null
                }
                _vm.visible = false
              }
            ],
            paste: function($event) {
              return _vm.debouncedOnInputChange($event)
            },
            mouseenter: function($event) {
              _vm.inputHovering = true
            },
            mouseleave: function($event) {
              _vm.inputHovering = false
            }
          },
          model: {
            value: _vm.selectedLabel,
            callback: function($$v) {
              _vm.selectedLabel = $$v
            },
            expression: "selectedLabel"
          }
        },
        [
          _vm.$slots.prefix
            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
            : _vm._e(),
          _c("template", { slot: "suffix" }, [
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showClose,
                  expression: "!showClose"
                }
              ],
              class: [
                "el-select__caret",
                "el-input__icon",
                "el-icon-" + _vm.iconClass
              ]
            }),
            _vm.showClose
              ? _c("i", {
                  staticClass:
                    "el-select__caret el-input__icon el-icon-circle-close",
                  on: { click: _vm.handleClearClick }
                })
              : _vm._e()
          ])
        ],
        2
      ),
      _c(
        "transition",
        {
          attrs: { name: "el-zoom-in-top" },
          on: {
            "before-enter": _vm.handleMenuEnter,
            "after-leave": _vm.doDestroy
          }
        },
        [
          _c(
            "el-select-menu",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible && _vm.emptyText !== false,
                  expression: "visible && emptyText !== false"
                }
              ],
              ref: "popper",
              attrs: { "append-to-body": _vm.popperAppendToBody }
            },
            [
              _c(
                "el-scrollbar",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.options.length > 0 && !_vm.loading,
                      expression: "options.length > 0 && !loading"
                    }
                  ],
                  ref: "scrollbar",
                  class: {
                    "is-empty":
                      !_vm.allowCreate &&
                      _vm.query &&
                      _vm.filteredOptionsCount === 0
                  },
                  attrs: {
                    tag: "ul",
                    "wrap-class": "el-select-dropdown__wrap",
                    "view-class": "el-select-dropdown__list"
                  }
                },
                [
                  _vm.showNewOption
                    ? _c("el-option", {
                        attrs: { value: _vm.query, created: "" }
                      })
                    : _vm._e(),
                  _vm._t("default")
                ],
                2
              ),
              _vm.emptyText &&
              (!_vm.allowCreate ||
                _vm.loading ||
                (_vm.allowCreate && _vm.options.length === 0))
                ? [
                    _vm.$slots.empty
                      ? _vm._t("empty")
                      : _c("p", { staticClass: "el-select-dropdown__empty" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.emptyText) +
                              "\n        "
                          )
                        ])
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&

// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
var emitter_ = __webpack_require__(4);
var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
var focus_ = __webpack_require__(22);
var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);

// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
var locale_ = __webpack_require__(6);
var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);

// EXTERNAL MODULE: external "element-ui/lib/input"
var input_ = __webpack_require__(10);
var input_default = /*#__PURE__*/__webpack_require__.n(input_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
var select_dropdownvue_type_template_id_06828748_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-select-dropdown el-popper",
      class: [{ "is-multiple": _vm.$parent.multiple }, _vm.popperClass],
      style: { minWidth: _vm.minWidth }
    },
    [_vm._t("default")],
    2
  )
}
var select_dropdownvue_type_template_id_06828748_staticRenderFns = []
select_dropdownvue_type_template_id_06828748_render._withStripped = true


// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&

// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
var vue_popper_ = __webpack_require__(5);
var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//



/* harmony default export */ var select_dropdownvue_type_script_lang_js_ = ({
  name: 'ElSelectDropdown',

  componentName: 'ElSelectDropdown',

  mixins: [vue_popper_default.a],

  props: {
    placement: {
      default: 'bottom-start'
    },

    boundariesPadding: {
      default: 0
    },

    popperOptions: {
      default: function _default() {
        return {
          gpuAcceleration: false
        };
      }
    },

    visibleArrow: {
      default: true
    },

    appendToBody: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      minWidth: ''
    };
  },


  computed: {
    popperClass: function popperClass() {
      return this.$parent.popperClass;
    }
  },

  watch: {
    '$parent.inputWidth': function $parentInputWidth() {
      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.referenceElm = this.$parent.$refs.reference.$el;
    this.$parent.popperElm = this.popperElm = this.$el;
    this.$on('updatePopper', function () {
      if (_this.$parent.visible) _this.updatePopper();
    });
    this.$on('destroyPopper', this.destroyPopper);
  }
});
// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_select_dropdownvue_type_script_lang_js_ = (select_dropdownvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_select_dropdownvue_type_script_lang_js_,
  select_dropdownvue_type_template_id_06828748_render,
  select_dropdownvue_type_template_id_06828748_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/select/src/select-dropdown.vue"
/* harmony default export */ var select_dropdown = (component.exports);
// EXTERNAL MODULE: ./packages/select/src/option.vue + 4 modules
var src_option = __webpack_require__(34);

// EXTERNAL MODULE: external "element-ui/lib/tag"
var tag_ = __webpack_require__(38);
var tag_default = /*#__PURE__*/__webpack_require__.n(tag_);

// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
var scrollbar_ = __webpack_require__(14);
var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);

// EXTERNAL MODULE: external "throttle-debounce/debounce"
var debounce_ = __webpack_require__(17);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

// EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
var clickoutside_ = __webpack_require__(12);
var clickoutside_default = /*#__PURE__*/__webpack_require__.n(clickoutside_);

// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
var resize_event_ = __webpack_require__(16);

// EXTERNAL MODULE: external "element-ui/lib/locale"
var lib_locale_ = __webpack_require__(19);

// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
var scroll_into_view_ = __webpack_require__(31);
var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);

// EXTERNAL MODULE: external "element-ui/lib/utils/util"
var util_ = __webpack_require__(3);

// CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
/* harmony default export */ var navigation_mixin = ({
  data: function data() {
    return {
      hoverOption: -1
    };
  },


  computed: {
    optionsAllDisabled: function optionsAllDisabled() {
      return this.options.filter(function (option) {
        return option.visible;
      }).every(function (option) {
        return option.disabled;
      });
    }
  },

  watch: {
    hoverIndex: function hoverIndex(val) {
      var _this = this;

      if (typeof val === 'number' && val > -1) {
        this.hoverOption = this.options[val] || {};
      }
      this.options.forEach(function (option) {
        option.hover = _this.hoverOption === option;
      });
    }
  },

  methods: {
    navigateOptions: function navigateOptions(direction) {
      var _this2 = this;

      if (!this.visible) {
        this.visible = true;
        return;
      }
      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
      if (!this.optionsAllDisabled) {
        if (direction === 'next') {
          this.hoverIndex++;
          if (this.hoverIndex === this.options.length) {
            this.hoverIndex = 0;
          }
        } else if (direction === 'prev') {
          this.hoverIndex--;
          if (this.hoverIndex < 0) {
            this.hoverIndex = this.options.length - 1;
          }
        }
        var option = this.options[this.hoverIndex];
        if (option.disabled === true || option.groupDisabled === true || !option.visible) {
          this.navigateOptions(direction);
        }
        this.$nextTick(function () {
          return _this2.scrollToOption(_this2.hoverOption);
        });
      }
    }
  }
});
// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
var shared_ = __webpack_require__(21);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ var selectvue_type_script_lang_js_ = ({
  mixins: [emitter_default.a, locale_default.a, focus_default()('reference'), navigation_mixin],

  name: 'ElSelect',

  componentName: 'ElSelect',

  inject: {
    elForm: {
      default: ''
    },

    elFormItem: {
      default: ''
    }
  },

  provide: function provide() {
    return {
      'select': this
    };
  },


  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    readonly: function readonly() {
      return !this.filterable || this.multiple || !Object(util_["isIE"])() && !Object(util_["isEdge"])() && !this.visible;
    },
    showClose: function showClose() {
      var hasValue = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== undefined && this.value !== null && this.value !== '';
      var criteria = this.clearable && !this.selectDisabled && this.inputHovering && hasValue;
      return criteria;
    },
    iconClass: function iconClass() {
      return this.remote && this.filterable ? '' : this.visible ? 'arrow-up is-reverse' : 'arrow-up';
    },
    debounce: function debounce() {
      return this.remote ? 300 : 0;
    },
    emptyText: function emptyText() {
      if (this.loading) {
        return this.loadingText || this.t('el.select.loading');
      } else {
        if (this.remote && this.query === '' && this.options.length === 0) return false;
        if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
          return this.noMatchText || this.t('el.select.noMatch');
        }
        if (this.options.length === 0) {
          return this.noDataText || this.t('el.select.noData');
        }
      }
      return null;
    },
    showNewOption: function showNewOption() {
      var _this = this;

      var hasExistingOption = this.options.filter(function (option) {
        return !option.created;
      }).some(function (option) {
        return option.currentLabel === _this.query;
      });
      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
    },
    selectSize: function selectSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    selectDisabled: function selectDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    collapseTagSize: function collapseTagSize() {
      return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
    }
  },

  components: {
    ElInput: input_default.a,
    ElSelectMenu: select_dropdown,
    ElOption: src_option["a" /* default */],
    ElTag: tag_default.a,
    ElScrollbar: scrollbar_default.a
  },

  directives: { Clickoutside: clickoutside_default.a },

  props: {
    name: String,
    id: String,
    value: {
      required: true
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    /** @Deprecated in next major version */
    autoComplete: {
      type: String,
      validator: function validator(val) {
         false && false;
        return true;
      }
    },
    automaticDropdown: Boolean,
    size: String,
    disabled: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    allowCreate: Boolean,
    loading: Boolean,
    popperClass: String,
    remote: Boolean,
    loadingText: String,
    noMatchText: String,
    noDataText: String,
    remoteMethod: Function,
    filterMethod: Function,
    multiple: Boolean,
    multipleLimit: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: function _default() {
        return Object(lib_locale_["t"])('el.select.placeholder');
      }
    },
    defaultFirstOption: Boolean,
    reserveKeyword: Boolean,
    valueKey: {
      type: String,
      default: 'value'
    },
    collapseTags: Boolean,
    popperAppendToBody: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      options: [],
      cachedOptions: [],
      createdLabel: null,
      createdSelected: false,
      selected: this.multiple ? [] : {},
      inputLength: 20,
      inputWidth: 0,
      initialInputHeight: 0,
      cachedPlaceHolder: '',
      optionsCount: 0,
      filteredOptionsCount: 0,
      visible: false,
      softFocus: false,
      selectedLabel: '',
      hoverIndex: -1,
      query: '',
      previousQuery: null,
      inputHovering: false,
      currentPlaceholder: '',
      menuVisibleOnFocus: false,
      isOnComposition: false,
      isSilentBlur: false
    };
  },


  watch: {
    selectDisabled: function selectDisabled() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.resetInputHeight();
      });
    },
    placeholder: function placeholder(val) {
      this.cachedPlaceHolder = this.currentPlaceholder = val;
    },
    value: function value(val, oldVal) {
      if (this.multiple) {
        this.resetInputHeight();
        if (val && val.length > 0 || this.$refs.input && this.query !== '') {
          this.currentPlaceholder = '';
        } else {
          this.currentPlaceholder = this.cachedPlaceHolder;
        }
        if (this.filterable && !this.reserveKeyword) {
          this.query = '';
          this.handleQueryChange(this.query);
        }
      }
      this.setSelected();
      if (this.filterable && !this.multiple) {
        this.inputLength = 20;
      }
      if (!Object(util_["valueEquals"])(val, oldVal)) {
        this.dispatch('ElFormItem', 'el.form.change', val);
      }
    },
    visible: function visible(val) {
      var _this3 = this;

      if (!val) {
        this.broadcast('ElSelectDropdown', 'destroyPopper');
        if (this.$refs.input) {
          this.$refs.input.blur();
        }
        this.query = '';
        this.previousQuery = null;
        this.selectedLabel = '';
        this.inputLength = 20;
        this.menuVisibleOnFocus = false;
        this.resetHoverIndex();
        this.$nextTick(function () {
          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
          }
        });
        if (!this.multiple) {
          if (this.selected) {
            if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
              this.selectedLabel = this.createdLabel;
            } else {
              this.selectedLabel = this.selected.currentLabel;
            }
            if (this.filterable) this.query = this.selectedLabel;
          }

          if (this.filterable) {
            this.currentPlaceholder = this.cachedPlaceHolder;
          }
        }
      } else {
        this.broadcast('ElSelectDropdown', 'updatePopper');
        if (this.filterable) {
          this.query = this.remote ? '' : this.selectedLabel;
          this.handleQueryChange(this.query);
          if (this.multiple) {
            this.$refs.input.focus();
          } else {
            if (!this.remote) {
              this.broadcast('ElOption', 'queryChange', '');
              this.broadcast('ElOptionGroup', 'queryChange');
            }

            if (this.selectedLabel) {
              this.currentPlaceholder = this.selectedLabel;
              this.selectedLabel = '';
            }
          }
        }
      }
      this.$emit('visible-change', val);
    },
    options: function options() {
      var _this4 = this;

      if (this.$isServer) return;
      this.$nextTick(function () {
        _this4.broadcast('ElSelectDropdown', 'updatePopper');
      });
      if (this.multiple) {
        this.resetInputHeight();
      }
      var inputs = this.$el.querySelectorAll('input');
      if ([].indexOf.call(inputs, document.activeElement) === -1) {
        this.setSelected();
      }
      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
        this.checkDefaultFirstOption();
      }
    }
  },

  methods: {
    handleComposition: function handleComposition(event) {
      var _this5 = this;

      var text = event.target.value;
      if (event.type === 'compositionend') {
        this.isOnComposition = false;
        this.$nextTick(function (_) {
          return _this5.handleQueryChange(text);
        });
      } else {
        var lastCharacter = text[text.length - 1] || '';
        this.isOnComposition = !Object(shared_["isKorean"])(lastCharacter);
      }
    },
    handleQueryChange: function handleQueryChange(val) {
      var _this6 = this;

      if (this.previousQuery === val || this.isOnComposition) return;
      if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
        this.previousQuery = val;
        return;
      }
      this.previousQuery = val;
      this.$nextTick(function () {
        if (_this6.visible) _this6.broadcast('ElSelectDropdown', 'updatePopper');
      });
      this.hoverIndex = -1;
      if (this.multiple && this.filterable) {
        this.$nextTick(function () {
          var length = _this6.$refs.input.value.length * 15 + 20;
          _this6.inputLength = _this6.collapseTags ? Math.min(50, length) : length;
          _this6.managePlaceholder();
          _this6.resetInputHeight();
        });
      }
      if (this.remote && typeof this.remoteMethod === 'function') {
        this.hoverIndex = -1;
        this.remoteMethod(val);
      } else if (typeof this.filterMethod === 'function') {
        this.filterMethod(val);
        this.broadcast('ElOptionGroup', 'queryChange');
      } else {
        this.filteredOptionsCount = this.optionsCount;
        this.broadcast('ElOption', 'queryChange', val);
        this.broadcast('ElOptionGroup', 'queryChange');
      }
      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
        this.checkDefaultFirstOption();
      }
    },
    scrollToOption: function scrollToOption(option) {
      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
      if (this.$refs.popper && target) {
        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
        scroll_into_view_default()(menu, target);
      }
      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
    },
    handleMenuEnter: function handleMenuEnter() {
      var _this7 = this;

      this.$nextTick(function () {
        return _this7.scrollToOption(_this7.selected);
      });
    },
    emitChange: function emitChange(val) {
      if (!Object(util_["valueEquals"])(this.value, val)) {
        this.$emit('change', val);
      }
    },
    getOption: function getOption(value) {
      var option = void 0;
      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
      var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
      var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';

      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
        var cachedOption = this.cachedOptions[i];
        var isEqual = isObject ? Object(util_["getValueByPath"])(cachedOption.value, this.valueKey) === Object(util_["getValueByPath"])(value, this.valueKey) : cachedOption.value === value;
        if (isEqual) {
          option = cachedOption;
          break;
        }
      }
      if (option) return option;
      var label = !isObject && !isNull && !isUndefined ? value : '';
      var newOption = {
        value: value,
        currentLabel: label
      };
      if (this.multiple) {
        newOption.hitState = false;
      }
      return newOption;
    },
    setSelected: function setSelected() {
      var _this8 = this;

      if (!this.multiple) {
        var option = this.getOption(this.value);
        if (option.created) {
          this.createdLabel = option.currentLabel;
          this.createdSelected = true;
        } else {
          this.createdSelected = false;
        }
        this.selectedLabel = option.currentLabel;
        this.selected = option;
        if (this.filterable) this.query = this.selectedLabel;
        return;
      }
      var result = [];
      if (Array.isArray(this.value)) {
        this.value.forEach(function (value) {
          result.push(_this8.getOption(value));
        });
      }
      this.selected = result;
      this.$nextTick(function () {
        _this8.resetInputHeight();
      });
    },
    handleFocus: function handleFocus(event) {
      if (!this.softFocus) {
        if (this.automaticDropdown || this.filterable) {
          this.visible = true;
          if (this.filterable) {
            this.menuVisibleOnFocus = true;
          }
        }
        this.$emit('focus', event);
      } else {
        this.softFocus = false;
      }
    },
    blur: function blur() {
      this.visible = false;
      this.$refs.reference.blur();
    },
    handleBlur: function handleBlur(event) {
      var _this9 = this;

      setTimeout(function () {
        if (_this9.isSilentBlur) {
          _this9.isSilentBlur = false;
        } else {
          _this9.$emit('blur', event);
        }
      }, 50);
      this.softFocus = false;
    },
    handleClearClick: function handleClearClick(event) {
      this.deleteSelected(event);
    },
    doDestroy: function doDestroy() {
      this.$refs.popper && this.$refs.popper.doDestroy();
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
      if (!Array.isArray(this.selected)) return;
      var option = this.selected[this.selected.length - 1];
      if (!option) return;

      if (hit === true || hit === false) {
        option.hitState = hit;
        return hit;
      }

      option.hitState = !option.hitState;
      return option.hitState;
    },
    deletePrevTag: function deletePrevTag(e) {
      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
        var value = this.value.slice();
        value.pop();
        this.$emit('input', value);
        this.emitChange(value);
      }
    },
    managePlaceholder: function managePlaceholder() {
      if (this.currentPlaceholder !== '') {
        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
      }
    },
    resetInputState: function resetInputState(e) {
      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
      this.inputLength = this.$refs.input.value.length * 15 + 20;
      this.resetInputHeight();
    },
    resetInputHeight: function resetInputHeight() {
      var _this10 = this;

      if (this.collapseTags && !this.filterable) return;
      this.$nextTick(function () {
        if (!_this10.$refs.reference) return;
        var inputChildNodes = _this10.$refs.reference.$el.childNodes;
        var input = [].filter.call(inputChildNodes, function (item) {
          return item.tagName === 'INPUT';
        })[0];
        var tags = _this10.$refs.tags;
        var sizeInMap = _this10.initialInputHeight || 40;
        input.style.height = _this10.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
        if (_this10.visible && _this10.emptyText !== false) {
          _this10.broadcast('ElSelectDropdown', 'updatePopper');
        }
      });
    },
    resetHoverIndex: function resetHoverIndex() {
      var _this11 = this;

      setTimeout(function () {
        if (!_this11.multiple) {
          _this11.hoverIndex = _this11.options.indexOf(_this11.selected);
        } else {
          if (_this11.selected.length > 0) {
            _this11.hoverIndex = Math.min.apply(null, _this11.selected.map(function (item) {
              return _this11.options.indexOf(item);
            }));
          } else {
            _this11.hoverIndex = -1;
          }
        }
      }, 300);
    },
    handleOptionSelect: function handleOptionSelect(option, byClick) {
      var _this12 = this;

      if (this.multiple) {
        var value = (this.value || []).slice();
        var optionIndex = this.getValueIndex(value, option.value);
        if (optionIndex > -1) {
          value.splice(optionIndex, 1);
        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
          value.push(option.value);
        }
        this.$emit('input', value);
        this.emitChange(value);
        if (option.created) {
          this.query = '';
          this.handleQueryChange('');
          this.inputLength = 20;
        }
        if (this.filterable) this.$refs.input.focus();
      } else {
        this.$emit('input', option.value);
        this.emitChange(option.value);
        this.visible = false;
      }
      this.isSilentBlur = byClick;
      this.setSoftFocus();
      if (this.visible) return;
      this.$nextTick(function () {
        _this12.scrollToOption(option);
      });
    },
    setSoftFocus: function setSoftFocus() {
      this.softFocus = true;
      var input = this.$refs.input || this.$refs.reference;
      if (input) {
        input.focus();
      }
    },
    getValueIndex: function getValueIndex() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var value = arguments[1];

      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
      if (!isObject) {
        return arr.indexOf(value);
      } else {
        var valueKey = this.valueKey;
        var index = -1;
        arr.some(function (item, i) {
          if (Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(value, valueKey)) {
            index = i;
            return true;
          }
          return false;
        });
        return index;
      }
    },
    toggleMenu: function toggleMenu() {
      if (!this.selectDisabled) {
        if (this.menuVisibleOnFocus) {
          this.menuVisibleOnFocus = false;
        } else {
          this.visible = !this.visible;
        }
        if (this.visible) {
          (this.$refs.input || this.$refs.reference).focus();
        }
      }
    },
    selectOption: function selectOption() {
      if (!this.visible) {
        this.toggleMenu();
      } else {
        if (this.options[this.hoverIndex]) {
          this.handleOptionSelect(this.options[this.hoverIndex]);
        }
      }
    },
    deleteSelected: function deleteSelected(event) {
      event.stopPropagation();
      var value = this.multiple ? [] : '';
      this.$emit('input', value);
      this.emitChange(value);
      this.visible = false;
      this.$emit('clear');
    },
    deleteTag: function deleteTag(event, tag) {
      var index = this.selected.indexOf(tag);
      if (index > -1 && !this.selectDisabled) {
        var value = this.value.slice();
        value.splice(index, 1);
        this.$emit('input', value);
        this.emitChange(value);
        this.$emit('remove-tag', tag.value);
      }
      event.stopPropagation();
    },
    onInputChange: function onInputChange() {
      if (this.filterable && this.query !== this.selectedLabel) {
        this.query = this.selectedLabel;
        this.handleQueryChange(this.query);
      }
    },
    onOptionDestroy: function onOptionDestroy(index) {
      if (index > -1) {
        this.optionsCount--;
        this.filteredOptionsCount--;
        this.options.splice(index, 1);
      }
    },
    resetInputWidth: function resetInputWidth() {
      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
    },
    handleResize: function handleResize() {
      this.resetInputWidth();
      if (this.multiple) this.resetInputHeight();
    },
    checkDefaultFirstOption: function checkDefaultFirstOption() {
      this.hoverIndex = -1;
      // highlight the created option
      var hasCreated = false;
      for (var i = this.options.length - 1; i >= 0; i--) {
        if (this.options[i].created) {
          hasCreated = true;
          this.hoverIndex = i;
          break;
        }
      }
      if (hasCreated) return;
      for (var _i = 0; _i !== this.options.length; ++_i) {
        var option = this.options[_i];
        if (this.query) {
          // highlight first options that passes the filter
          if (!option.disabled && !option.groupDisabled && option.visible) {
            this.hoverIndex = _i;
            break;
          }
        } else {
          // highlight currently selected option
          if (option.itemSelected) {
            this.hoverIndex = _i;
            break;
          }
        }
      }
    },
    getValueKey: function getValueKey(item) {
      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
        return item.value;
      } else {
        return Object(util_["getValueByPath"])(item.value, this.valueKey);
      }
    }
  },

  created: function created() {
    var _this13 = this;

    this.cachedPlaceHolder = this.currentPlaceholder = this.placeholder;
    if (this.multiple && !Array.isArray(this.value)) {
      this.$emit('input', []);
    }
    if (!this.multiple && Array.isArray(this.value)) {
      this.$emit('input', '');
    }

    this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
      _this13.onInputChange();
    });

    this.debouncedQueryChange = debounce_default()(this.debounce, function (e) {
      _this13.handleQueryChange(e.target.value);
    });

    this.$on('handleOptionClick', this.handleOptionSelect);
    this.$on('setSelected', this.setSelected);
  },
  mounted: function mounted() {
    var _this14 = this;

    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
      this.currentPlaceholder = '';
    }
    Object(resize_event_["addResizeListener"])(this.$el, this.handleResize);

    var reference = this.$refs.reference;
    if (reference && reference.$el) {
      var sizeMap = {
        medium: 36,
        small: 32,
        mini: 28
      };
      var input = reference.$el.querySelector('input');
      this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.selectSize];
    }
    if (this.remote && this.multiple) {
      this.resetInputHeight();
    }
    this.$nextTick(function () {
      if (reference && reference.$el) {
        _this14.inputWidth = reference.$el.getBoundingClientRect().width;
      }
    });
    this.setSelected();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el && this.handleResize) Object(resize_event_["removeResizeListener"])(this.$el, this.handleResize);
  }
});
// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_selectvue_type_script_lang_js_ = (selectvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/select/src/select.vue





/* normalize component */

var select_component = Object(componentNormalizer["a" /* default */])(
  src_selectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var select_api; }
select_component.options.__file = "packages/select/src/select.vue"
/* harmony default export */ var src_select = (select_component.exports);
// CONCATENATED MODULE: ./packages/select/index.js


/* istanbul ignore next */
src_select.install = function (Vue) {
  Vue.component(src_select.name, src_select);
};

/* harmony default export */ var packages_select = __webpack_exports__["default"] = (src_select);

/***/ })
/******/ ]);

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 53);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(52);

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      staticClass: "el-select-dropdown__item",
      class: {
        selected: _vm.itemSelected,
        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
        hover: _vm.hover
      },
      on: {
        mouseenter: _vm.hoverItem,
        click: function($event) {
          $event.stopPropagation()
          return _vm.selectOptionClick($event)
        }
      }
    },
    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&

// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
var emitter_ = __webpack_require__(4);
var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

// EXTERNAL MODULE: external "element-ui/lib/utils/util"
var util_ = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var optionvue_type_script_lang_js_ = ({
  mixins: [emitter_default.a],

  name: 'ElOption',

  componentName: 'ElOption',

  inject: ['select'],

  props: {
    value: {
      required: true
    },
    label: [String, Number],
    created: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      index: -1,
      groupDisabled: false,
      visible: true,
      hitState: false,
      hover: false
    };
  },


  computed: {
    isObject: function isObject() {
      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
    },
    currentLabel: function currentLabel() {
      return this.label || (this.isObject ? '' : this.value);
    },
    currentValue: function currentValue() {
      return this.value || this.label || '';
    },
    itemSelected: function itemSelected() {
      if (!this.select.multiple) {
        return this.isEqual(this.value, this.select.value);
      } else {
        return this.contains(this.select.value, this.value);
      }
    },
    limitReached: function limitReached() {
      if (this.select.multiple) {
        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
      } else {
        return false;
      }
    }
  },

  watch: {
    currentLabel: function currentLabel() {
      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
    },
    value: function value(val, oldVal) {
      var _select = this.select,
          remote = _select.remote,
          valueKey = _select.valueKey;

      if (!this.created && !remote) {
        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
          return;
        }
        this.dispatch('ElSelect', 'setSelected');
      }
    }
  },

  methods: {
    isEqual: function isEqual(a, b) {
      if (!this.isObject) {
        return a === b;
      } else {
        var valueKey = this.select.valueKey;
        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
      }
    },
    contains: function contains() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var target = arguments[1];

      if (!this.isObject) {
        return arr && arr.indexOf(target) > -1;
      } else {
        var valueKey = this.select.valueKey;
        return arr && arr.some(function (item) {
          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
        });
      }
    },
    handleGroupDisabled: function handleGroupDisabled(val) {
      this.groupDisabled = val;
    },
    hoverItem: function hoverItem() {
      if (!this.disabled && !this.groupDisabled) {
        this.select.hoverIndex = this.select.options.indexOf(this);
      }
    },
    selectOptionClick: function selectOptionClick() {
      if (this.disabled !== true && this.groupDisabled !== true) {
        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
      }
    },
    queryChange: function queryChange(query) {
      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
      if (!this.visible) {
        this.select.filteredOptionsCount--;
      }
    }
  },

  created: function created() {
    this.select.options.push(this);
    this.select.cachedOptions.push(this);
    this.select.optionsCount++;
    this.select.filteredOptionsCount++;

    this.$on('queryChange', this.queryChange);
    this.$on('handleGroupDisabled', this.handleGroupDisabled);
  },
  beforeDestroy: function beforeDestroy() {
    var _select2 = this.select,
        selected = _select2.selected,
        multiple = _select2.multiple;

    var selectedOptions = multiple ? selected : [selected];
    var index = this.select.cachedOptions.indexOf(this);
    var selectedIndex = selectedOptions.indexOf(this);

    // if option is not selected, remove it from cache
    if (index > -1 && selectedIndex < 0) {
      this.select.cachedOptions.splice(index, 1);
    }
    this.select.onOptionDestroy(this.select.options.indexOf(this));
  }
});
// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/select/src/option.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_optionvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/select/src/option.vue"
/* harmony default export */ var src_option = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(84);

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _select_src_option__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34);


/* istanbul ignore next */
_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = function (Vue) {
  Vue.component(_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
};

/* harmony default export */ __webpack_exports__["default"] = (_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ })

/******/ });

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(724);


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule normalizeWheel
 * @typechecks
 */



var UserAgent_DEPRECATED = __webpack_require__(725);

var isEventSupported = __webpack_require__(726);


// Reasonable defaults
var PIXEL_STEP  = 10;
var LINE_HEIGHT = 40;
var PAGE_HEIGHT = 800;

/**
 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
 * complicated, thus this doc is long and (hopefully) detailed enough to answer
 * your questions.
 *
 * If you need to react to the mouse wheel in a predictable way, this code is
 * like your bestest friend. * hugs *
 *
 * As of today, there are 4 DOM event types you can listen to:
 *
 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
 *
 * So what to do?  The is the best:
 *
 *   normalizeWheel.getEventType();
 *
 * In your event callback, use this code to get sane interpretation of the
 * deltas.  This code will return an object with properties:
 *
 *   spinX   -- normalized spin speed (use for zoom) - x plane
 *   spinY   -- " - y plane
 *   pixelX  -- normalized distance (to pixels) - x plane
 *   pixelY  -- " - y plane
 *
 * Wheel values are provided by the browser assuming you are using the wheel to
 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
 * significantly on different platforms and browsers, forgetting that you can
 * scroll at different speeds.  Some devices (like trackpads) emit more events
 * at smaller increments with fine granularity, and some emit massive jumps with
 * linear speed or acceleration.
 *
 * This code does its best to normalize the deltas for you:
 *
 *   - spin is trying to normalize how far the wheel was spun (or trackpad
 *     dragged).  This is super useful for zoom support where you want to
 *     throw away the chunky scroll steps on the PC and make those equal to
 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
 *     resolve a single slow step on a wheel to 1.
 *
 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
 *     get the crazy differences between browsers, but at least it'll be in
 *     pixels!
 *
 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
 *     should translate to positive value zooming IN, negative zooming OUT.
 *     This matches the newer 'wheel' event.
 *
 * Why are there spinX, spinY (or pixels)?
 *
 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
 *     with a mouse.  It results in side-scrolling in the browser by default.
 *
 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
 *
 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
 *     probably is by browsers in conjunction with fancy 3D controllers .. but
 *     you know.
 *
 * Implementation info:
 *
 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
 * average mouse:
 *
 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
 *
 * On the trackpad:
 *
 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
 *
 * On other/older browsers.. it's more complicated as there can be multiple and
 * also missing delta values.
 *
 * The 'wheel' event is more standard:
 *
 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
 *
 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
 * backward compatibility with older events.  Those other values help us
 * better normalize spin speed.  Example of what the browsers provide:
 *
 *                          | event.wheelDelta | event.detail
 *        ------------------+------------------+--------------
 *          Safari v5/OS X  |       -120       |       0
 *          Safari v5/Win7  |       -120       |       0
 *         Chrome v17/OS X  |       -120       |       0
 *         Chrome v17/Win7  |       -120       |       0
 *                IE9/Win7  |       -120       |   undefined
 *         Firefox v4/OS X  |     undefined    |       1
 *         Firefox v4/Win7  |     undefined    |       3
 *
 */
function normalizeWheel(/*object*/ event) /*object*/ {
  var sX = 0, sY = 0,       // spinX, spinY
      pX = 0, pY = 0;       // pixelX, pixelY

  // Legacy
  if ('detail'      in event) { sY = event.detail; }
  if ('wheelDelta'  in event) { sY = -event.wheelDelta / 120; }
  if ('wheelDeltaY' in event) { sY = -event.wheelDeltaY / 120; }
  if ('wheelDeltaX' in event) { sX = -event.wheelDeltaX / 120; }

  // side scrolling on FF with DOMMouseScroll
  if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
    sX = sY;
    sY = 0;
  }

  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;

  if ('deltaY' in event) { pY = event.deltaY; }
  if ('deltaX' in event) { pX = event.deltaX; }

  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode == 1) {          // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {                             // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  }

  // Fall-back if spin cannot be determined
  if (pX && !sX) { sX = (pX < 1) ? -1 : 1; }
  if (pY && !sY) { sY = (pY < 1) ? -1 : 1; }

  return { spinX  : sX,
           spinY  : sY,
           pixelX : pX,
           pixelY : pY };
}


/**
 * The best combination if you prefer spinX + spinY normalization.  It favors
 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
 * 'wheel' event, making spin speed determination impossible.
 */
normalizeWheel.getEventType = function() /*string*/ {
  return (UserAgent_DEPRECATED.firefox())
           ? 'DOMMouseScroll'
           : (isEventSupported('wheel'))
               ? 'wheel'
               : 'mousewheel';
};

module.exports = normalizeWheel;


/***/ }),
/* 725 */
/***/ (function(module, exports) {

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @providesModule UserAgent_DEPRECATED
 */

/**
 *  Provides entirely client-side User Agent and OS detection. You should prefer
 *  the non-deprecated UserAgent module when possible, which exposes our
 *  authoritative server-side PHP-based detection to the client.
 *
 *  Usage is straightforward:
 *
 *    if (UserAgent_DEPRECATED.ie()) {
 *      //  IE
 *    }
 *
 *  You can also do version checks:
 *
 *    if (UserAgent_DEPRECATED.ie() >= 7) {
 *      //  IE7 or better
 *    }
 *
 *  The browser functions will return NaN if the browser does not match, so
 *  you can also do version compares the other way:
 *
 *    if (UserAgent_DEPRECATED.ie() < 7) {
 *      //  IE6 or worse
 *    }
 *
 *  Note that the version is a float and may include a minor version number,
 *  so you should always use range operators to perform comparisons, not
 *  strict equality.
 *
 *  **Note:** You should **strongly** prefer capability detection to browser
 *  version detection where it's reasonable:
 *
 *    http://www.quirksmode.org/js/support.html
 *
 *  Further, we have a large number of mature wrapper functions and classes
 *  which abstract away many browser irregularities. Check the documentation,
 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
 *  another copy of "event || window.event".
 *
 */

var _populated = false;

// Browsers
var _ie, _firefox, _opera, _webkit, _chrome;

// Actual IE browser for compatibility mode
var _ie_real_version;

// Platforms
var _osx, _windows, _linux, _android;

// Architectures
var _win64;

// Devices
var _iphone, _ipad, _native;

var _mobile;

function _populate() {
  if (_populated) {
    return;
  }

  _populated = true;

  // To work around buggy JS libraries that can't handle multi-digit
  // version numbers, Opera 10's user agent string claims it's Opera
  // 9, then later includes a Version/X.Y field:
  //
  // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
  var uas = navigator.userAgent;
  var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
  var os    = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);

  _iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
  _ipad = /\b(iP[ao]d)/.exec(uas);
  _android = /Android/i.exec(uas);
  _native = /FBAN\/\w+;/i.exec(uas);
  _mobile = /Mobile/i.exec(uas);

  // Note that the IE team blog would have you believe you should be checking
  // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
  // from either x64 or ia64;  so ultimately, you should just check for Win64
  // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
  // Windows will send 'WOW64' instead.
  _win64 = !!(/Win64/.exec(uas));

  if (agent) {
    _ie = agent[1] ? parseFloat(agent[1]) : (
          agent[5] ? parseFloat(agent[5]) : NaN);
    // IE compatibility mode
    if (_ie && document && document.documentMode) {
      _ie = document.documentMode;
    }
    // grab the "true" ie version from the trident token if available
    var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
    _ie_real_version = trident ? parseFloat(trident[1]) + 4 : _ie;

    _firefox = agent[2] ? parseFloat(agent[2]) : NaN;
    _opera   = agent[3] ? parseFloat(agent[3]) : NaN;
    _webkit  = agent[4] ? parseFloat(agent[4]) : NaN;
    if (_webkit) {
      // We do not add the regexp to the above test, because it will always
      // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
      // the userAgent string.
      agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
      _chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
    } else {
      _chrome = NaN;
    }
  } else {
    _ie = _firefox = _opera = _chrome = _webkit = NaN;
  }

  if (os) {
    if (os[1]) {
      // Detect OS X version.  If no version number matches, set _osx to true.
      // Version examples:  10, 10_6_1, 10.7
      // Parses version number as a float, taking only first two sets of
      // digits.  If only one set of digits is found, returns just the major
      // version number.
      var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);

      _osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
    } else {
      _osx = false;
    }
    _windows = !!os[2];
    _linux   = !!os[3];
  } else {
    _osx = _windows = _linux = false;
  }
}

var UserAgent_DEPRECATED = {

  /**
   *  Check if the UA is Internet Explorer.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  ie: function() {
    return _populate() || _ie;
  },

  /**
   * Check if we're in Internet Explorer compatibility mode.
   *
   * @return bool true if in compatibility mode, false if
   * not compatibility mode or not ie
   */
  ieCompatibilityMode: function() {
    return _populate() || (_ie_real_version > _ie);
  },


  /**
   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
   * this when we don't need it -- tracked by #601957.
   */
  ie64: function() {
    return UserAgent_DEPRECATED.ie() && _win64;
  },

  /**
   *  Check if the UA is Firefox.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  firefox: function() {
    return _populate() || _firefox;
  },


  /**
   *  Check if the UA is Opera.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  opera: function() {
    return _populate() || _opera;
  },


  /**
   *  Check if the UA is WebKit.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  webkit: function() {
    return _populate() || _webkit;
  },

  /**
   *  For Push
   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
   */
  safari: function() {
    return UserAgent_DEPRECATED.webkit();
  },

  /**
   *  Check if the UA is a Chrome browser.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  chrome : function() {
    return _populate() || _chrome;
  },


  /**
   *  Check if the user is running Windows.
   *
   *  @return bool `true' if the user's OS is Windows.
   */
  windows: function() {
    return _populate() || _windows;
  },


  /**
   *  Check if the user is running Mac OS X.
   *
   *  @return float|bool   Returns a float if a version number is detected,
   *                       otherwise true/false.
   */
  osx: function() {
    return _populate() || _osx;
  },

  /**
   * Check if the user is running Linux.
   *
   * @return bool `true' if the user's OS is some flavor of Linux.
   */
  linux: function() {
    return _populate() || _linux;
  },

  /**
   * Check if the user is running on an iPhone or iPod platform.
   *
   * @return bool `true' if the user is running some flavor of the
   *    iPhone OS.
   */
  iphone: function() {
    return _populate() || _iphone;
  },

  mobile: function() {
    return _populate() || (_iphone || _ipad || _android || _mobile);
  },

  nativeApp: function() {
    // webviews inside of the native apps
    return _populate() || _native;
  },

  android: function() {
    return _populate() || _android;
  },

  ipad: function() {
    return _populate() || _ipad;
  }
};

module.exports = UserAgent_DEPRECATED;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */



var ExecutionEnvironment = __webpack_require__(727);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature =
    document.implementation &&
    document.implementation.hasFeature &&
    // always returns true in newer browsers as per the standard.
    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
    document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM ||
      capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ExecutionEnvironment
 */

/*jslint evil: true */



var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners:
    canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ariaUtils = __webpack_require__(178);

var _ariaUtils2 = _interopRequireDefault(_ariaUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @constructor
 * @desc Dialog object providing modal focus management.
 *
 * Assumptions: The element serving as the dialog container is present in the
 * DOM and hidden. The dialog container has role='dialog'.
 *
 * @param dialogId
 *          The ID of the element serving as the dialog container.
 * @param focusAfterClosed
 *          Either the DOM node or the ID of the DOM node to focus when the
 *          dialog closes.
 * @param focusFirst
 *          Optional parameter containing either the DOM node or the ID of the
 *          DOM node to focus when the dialog opens. If not specified, the
 *          first focusable element in the dialog will receive focus.
 */
var aria = aria || {};
var tabEvent;

aria.Dialog = function (dialog, focusAfterClosed, focusFirst) {
  var _this = this;

  this.dialogNode = dialog;
  if (this.dialogNode === null || this.dialogNode.getAttribute('role') !== 'dialog') {
    throw new Error('Dialog() requires a DOM element with ARIA role of dialog.');
  }

  if (typeof focusAfterClosed === 'string') {
    this.focusAfterClosed = document.getElementById(focusAfterClosed);
  } else if ((typeof focusAfterClosed === 'undefined' ? 'undefined' : _typeof(focusAfterClosed)) === 'object') {
    this.focusAfterClosed = focusAfterClosed;
  } else {
    this.focusAfterClosed = null;
  }

  if (typeof focusFirst === 'string') {
    this.focusFirst = document.getElementById(focusFirst);
  } else if ((typeof focusFirst === 'undefined' ? 'undefined' : _typeof(focusFirst)) === 'object') {
    this.focusFirst = focusFirst;
  } else {
    this.focusFirst = null;
  }

  if (this.focusFirst) {
    this.focusFirst.focus();
  } else {
    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
  }

  this.lastFocus = document.activeElement;
  tabEvent = function tabEvent(e) {
    _this.trapFocus(e);
  };
  this.addListeners();
};

aria.Dialog.prototype.addListeners = function () {
  document.addEventListener('focus', tabEvent, true);
};

aria.Dialog.prototype.removeListeners = function () {
  document.removeEventListener('focus', tabEvent, true);
};

aria.Dialog.prototype.closeDialog = function () {
  var _this2 = this;

  this.removeListeners();
  if (this.focusAfterClosed) {
    setTimeout(function () {
      _this2.focusAfterClosed.focus();
    });
  }
};

aria.Dialog.prototype.trapFocus = function (event) {
  if (_ariaUtils2.default.IgnoreUtilFocusChanges) {
    return;
  }
  if (this.dialogNode.contains(event.target)) {
    this.lastFocus = event.target;
  } else {
    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
    if (this.lastFocus === document.activeElement) {
      _ariaUtils2.default.focusLastDescendant(this.dialogNode);
    }
    this.lastFocus = document.activeElement;
  }
};

exports.default = aria.Dialog;

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validator___ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messages__ = __webpack_require__(769);






/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */];
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* deepMerge */])(Object(__WEBPACK_IMPORTED_MODULE_4__messages__["b" /* newMessages */])(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments[2];

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return;
    }
    function complete(results) {
      var i = void 0;
      var field = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          errors = errors.concat.apply(errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        for (i = 0; i < errors.length; i++) {
          field = errors[i].field;
          fields[field] = fields[field] || [];
          fields[field].push(errors[i]);
        }
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */]) {
        messages = Object(__WEBPACK_IMPORTED_MODULE_4__messages__["b" /* newMessages */])();
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* deepMerge */])(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* asyncMap */])(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rule.fields) === 'object' || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;
      function addFullfield(key, schema) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (errors.length) {
          Object(__WEBPACK_IMPORTED_MODULE_2__util__["f" /* warning */])('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* complementError */])(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* complementError */])(rule));
            } else if (options.error) {
              errors = [options.error(rule, Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* format */])(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            doIt(errs && errs.length ? errors.concat(errs) : errs);
          });
        }
      }

      var res = rule.validator(rule, data.value, cb, data.source, options);
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !__WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */].hasOwnProperty(rule.type)) {
      throw new Error(Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* format */])('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */].required;
    }
    return __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */][type] = validator;
};

Schema.messages = __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */];

/* harmony default export */ __webpack_exports__["default"] = (Schema);

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(731);
module.exports = __webpack_require__(18).Object.assign;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(28);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(732) });


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(51);
var getKeys = __webpack_require__(106);
var gOPS = __webpack_require__(187);
var pIE = __webpack_require__(136);
var toObject = __webpack_require__(88);
var IObject = __webpack_require__(181);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(85)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(87);
var toLength = __webpack_require__(134);
var toAbsoluteIndex = __webpack_require__(734);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(183);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(736), __esModule: true };

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96);
__webpack_require__(110);
module.exports = __webpack_require__(189).f('iterator');


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(183);
var defined = __webpack_require__(182);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(137);
var descriptor = __webpack_require__(105);
var setToStringTag = __webpack_require__(109);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(71)(IteratorPrototype, __webpack_require__(30)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(49);
var anObject = __webpack_require__(57);
var getKeys = __webpack_require__(106);

module.exports = __webpack_require__(51) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(741);
var step = __webpack_require__(263);
var Iterators = __webpack_require__(97);
var toIObject = __webpack_require__(87);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(188)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(743), __esModule: true };

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(744);
__webpack_require__(193);
__webpack_require__(747);
__webpack_require__(748);
module.exports = __webpack_require__(18).Symbol;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(29);
var has = __webpack_require__(86);
var DESCRIPTORS = __webpack_require__(51);
var $export = __webpack_require__(28);
var redefine = __webpack_require__(260);
var META = __webpack_require__(190).KEY;
var $fails = __webpack_require__(85);
var shared = __webpack_require__(185);
var setToStringTag = __webpack_require__(109);
var uid = __webpack_require__(135);
var wks = __webpack_require__(30);
var wksExt = __webpack_require__(189);
var wksDefine = __webpack_require__(191);
var enumKeys = __webpack_require__(745);
var isArray = __webpack_require__(264);
var anObject = __webpack_require__(57);
var isObject = __webpack_require__(50);
var toObject = __webpack_require__(88);
var toIObject = __webpack_require__(87);
var toPrimitive = __webpack_require__(180);
var createDesc = __webpack_require__(105);
var _create = __webpack_require__(137);
var gOPNExt = __webpack_require__(746);
var $GOPD = __webpack_require__(192);
var $GOPS = __webpack_require__(187);
var $DP = __webpack_require__(49);
var $keys = __webpack_require__(106);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(265).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(136).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(108)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(71)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(106);
var gOPS = __webpack_require__(187);
var pIE = __webpack_require__(136);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(87);
var gOPN = __webpack_require__(265).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(191)('asyncIterator');


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(191)('observable');


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__string__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__method__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boolean__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__regexp__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__integer__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__float__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__array__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__object__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__enum__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pattern__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__date__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__required__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__type__ = __webpack_require__(768);















/* harmony default export */ __webpack_exports__["a"] = ({
  string: __WEBPACK_IMPORTED_MODULE_0__string__["a" /* default */],
  method: __WEBPACK_IMPORTED_MODULE_1__method__["a" /* default */],
  number: __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */],
  boolean: __WEBPACK_IMPORTED_MODULE_3__boolean__["a" /* default */],
  regexp: __WEBPACK_IMPORTED_MODULE_4__regexp__["a" /* default */],
  integer: __WEBPACK_IMPORTED_MODULE_5__integer__["a" /* default */],
  float: __WEBPACK_IMPORTED_MODULE_6__float__["a" /* default */],
  array: __WEBPACK_IMPORTED_MODULE_7__array__["a" /* default */],
  object: __WEBPACK_IMPORTED_MODULE_8__object__["a" /* default */],
  'enum': __WEBPACK_IMPORTED_MODULE_9__enum__["a" /* default */],
  pattern: __WEBPACK_IMPORTED_MODULE_10__pattern__["a" /* default */],
  date: __WEBPACK_IMPORTED_MODULE_11__date__["a" /* default */],
  url: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  hex: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  email: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  required: __WEBPACK_IMPORTED_MODULE_12__required__["a" /* default */]
});

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(23);



/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, 'string');
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (string);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(23);


/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.whitespace, rule.fullField));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (whitespace);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__required__ = __webpack_require__(266);




/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    Object(__WEBPACK_IMPORTED_MODULE_2__required__["a" /* default */])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* format */](options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) !== rule.type) {
    errors.push(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* format */](options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(23);


/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (range);

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(23);

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (enumerable);

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(23);


/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (pattern);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(23);



/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (method);

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(23);



/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (number);

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rule___ = __webpack_require__(33);



/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (boolean);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(23);



/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value)) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (regexp);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(23);



/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (integer);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(23);



/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (floatFn);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(23);


/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'array') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, 'array');
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'array')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (array);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(23);



/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (object);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(23);


var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (enumerable);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(23);



/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (pattern);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(23);



function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value)) {
      var dateObject = void 0;

      if (typeof value === 'number') {
        dateObject = new Date(value);
      } else {
        dateObject = value;
      }

      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, dateObject, source, errors, options);
      if (dateObject) {
        __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (date);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rule___ = __webpack_require__(33);



function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value);
  __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].required(rule, value, source, errors, options, type);
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (required);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(23);



function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, ruleType) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, ruleType);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, ruleType)) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = newMessages;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = newMessages();

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 114);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __webpack_require__(172);

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "el-input-number",
        _vm.inputNumberSize ? "el-input-number--" + _vm.inputNumberSize : "",
        { "is-disabled": _vm.inputNumberDisabled },
        { "is-without-controls": !_vm.controls },
        { "is-controls-right": _vm.controlsAtRight }
      ],
      on: {
        dragstart: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _vm.controls
        ? _c(
            "span",
            {
              directives: [
                {
                  name: "repeat-click",
                  rawName: "v-repeat-click",
                  value: _vm.decrease,
                  expression: "decrease"
                }
              ],
              staticClass: "el-input-number__decrease",
              class: { "is-disabled": _vm.minDisabled },
              attrs: { role: "button" },
              on: {
                keydown: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.decrease($event)
                }
              }
            },
            [
              _c("i", {
                class:
                  "el-icon-" + (_vm.controlsAtRight ? "arrow-down" : "minus")
              })
            ]
          )
        : _vm._e(),
      _vm.controls
        ? _c(
            "span",
            {
              directives: [
                {
                  name: "repeat-click",
                  rawName: "v-repeat-click",
                  value: _vm.increase,
                  expression: "increase"
                }
              ],
              staticClass: "el-input-number__increase",
              class: { "is-disabled": _vm.maxDisabled },
              attrs: { role: "button" },
              on: {
                keydown: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.increase($event)
                }
              }
            },
            [
              _c("i", {
                class: "el-icon-" + (_vm.controlsAtRight ? "arrow-up" : "plus")
              })
            ]
          )
        : _vm._e(),
      _c("el-input", {
        ref: "input",
        attrs: {
          value: _vm.displayValue,
          placeholder: _vm.placeholder,
          disabled: _vm.inputNumberDisabled,
          size: _vm.inputNumberSize,
          max: _vm.max,
          min: _vm.min,
          name: _vm.name,
          label: _vm.label
        },
        on: {
          blur: _vm.handleBlur,
          focus: _vm.handleFocus,
          input: _vm.handleInput,
          change: _vm.handleInputChange
        },
        nativeOn: {
          keydown: [
            function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.increase($event)
            },
            function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.decrease($event)
            }
          ]
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&

// EXTERNAL MODULE: external "element-ui/lib/input"
var input_ = __webpack_require__(10);
var input_default = /*#__PURE__*/__webpack_require__.n(input_);

// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
var focus_ = __webpack_require__(22);
var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);

// EXTERNAL MODULE: ./src/directives/repeat-click.js
var repeat_click = __webpack_require__(30);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var input_numbervue_type_script_lang_js_ = ({
  name: 'ElInputNumber',
  mixins: [focus_default()('input')],
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  directives: {
    repeatClick: repeat_click["a" /* default */]
  },
  components: {
    ElInput: input_default.a
  },
  props: {
    step: {
      type: Number,
      default: 1
    },
    stepStrictly: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: Infinity
    },
    min: {
      type: Number,
      default: -Infinity
    },
    value: {},
    disabled: Boolean,
    size: String,
    controls: {
      type: Boolean,
      default: true
    },
    controlsPosition: {
      type: String,
      default: ''
    },
    name: String,
    label: String,
    placeholder: String,
    precision: {
      type: Number,
      validator: function validator(val) {
        return val >= 0 && val === parseInt(val, 10);
      }
    }
  },
  data: function data() {
    return {
      currentValue: 0,
      userInput: null
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        var newVal = value === undefined ? value : Number(value);
        if (newVal !== undefined) {
          if (isNaN(newVal)) {
            return;
          }

          if (this.stepStrictly) {
            var stepPrecision = this.getPrecision(this.step);
            var precisionFactor = Math.pow(10, stepPrecision);
            newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
          }

          if (this.precision !== undefined) {
            newVal = this.toPrecision(newVal, this.precision);
          }
        }
        if (newVal >= this.max) newVal = this.max;
        if (newVal <= this.min) newVal = this.min;
        this.currentValue = newVal;
        this.userInput = null;
        this.$emit('input', newVal);
      }
    }
  },
  computed: {
    minDisabled: function minDisabled() {
      return this._decrease(this.value, this.step) < this.min;
    },
    maxDisabled: function maxDisabled() {
      return this._increase(this.value, this.step) > this.max;
    },
    numPrecision: function numPrecision() {
      var value = this.value,
          step = this.step,
          getPrecision = this.getPrecision,
          precision = this.precision;

      var stepPrecision = getPrecision(step);
      if (precision !== undefined) {
        if (stepPrecision > precision) {
          console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
        }
        return precision;
      } else {
        return Math.max(getPrecision(value), stepPrecision);
      }
    },
    controlsAtRight: function controlsAtRight() {
      return this.controls && this.controlsPosition === 'right';
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    inputNumberSize: function inputNumberSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    inputNumberDisabled: function inputNumberDisabled() {
      return this.disabled || !!(this.elForm || {}).disabled;
    },
    displayValue: function displayValue() {
      if (this.userInput !== null) {
        return this.userInput;
      }

      var currentValue = this.currentValue;

      if (typeof currentValue === 'number') {
        if (this.stepStrictly) {
          var stepPrecision = this.getPrecision(this.step);
          var precisionFactor = Math.pow(10, stepPrecision);
          currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
        }

        if (this.precision !== undefined) {
          currentValue = currentValue.toFixed(this.precision);
        }
      }

      return currentValue;
    }
  },
  methods: {
    toPrecision: function toPrecision(num, precision) {
      if (precision === undefined) precision = this.numPrecision;
      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
    },
    getPrecision: function getPrecision(value) {
      if (value === undefined) return 0;
      var valueString = value.toString();
      var dotPosition = valueString.indexOf('.');
      var precision = 0;
      if (dotPosition !== -1) {
        precision = valueString.length - dotPosition - 1;
      }
      return precision;
    },
    _increase: function _increase(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;

      var precisionFactor = Math.pow(10, this.numPrecision);
      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
    },
    _decrease: function _decrease(val, step) {
      if (typeof val !== 'number' && val !== undefined) return this.currentValue;

      var precisionFactor = Math.pow(10, this.numPrecision);

      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
    },
    increase: function increase() {
      if (this.inputNumberDisabled || this.maxDisabled) return;
      var value = this.value || 0;
      var newVal = this._increase(value, this.step);
      this.setCurrentValue(newVal);
    },
    decrease: function decrease() {
      if (this.inputNumberDisabled || this.minDisabled) return;
      var value = this.value || 0;
      var newVal = this._decrease(value, this.step);
      this.setCurrentValue(newVal);
    },
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
    },
    handleFocus: function handleFocus(event) {
      this.$emit('focus', event);
    },
    setCurrentValue: function setCurrentValue(newVal) {
      var oldVal = this.currentValue;
      if (typeof newVal === 'number' && this.precision !== undefined) {
        newVal = this.toPrecision(newVal, this.precision);
      }
      if (newVal >= this.max) newVal = this.max;
      if (newVal <= this.min) newVal = this.min;
      if (oldVal === newVal) return;
      this.userInput = null;
      this.$emit('input', newVal);
      this.$emit('change', newVal, oldVal);
      this.currentValue = newVal;
    },
    handleInput: function handleInput(value) {
      this.userInput = value;
    },
    handleInputChange: function handleInputChange(value) {
      var newVal = value === '' ? undefined : Number(value);
      if (!isNaN(newVal) || value === '') {
        this.setCurrentValue(newVal);
      }
      this.userInput = null;
    },
    select: function select() {
      this.$refs.input.select();
    }
  },
  mounted: function mounted() {
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('role', 'spinbutton');
    innerInput.setAttribute('aria-valuemax', this.max);
    innerInput.setAttribute('aria-valuemin', this.min);
    innerInput.setAttribute('aria-valuenow', this.currentValue);
    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
  },
  updated: function updated() {
    if (!this.$refs || !this.$refs.input) return;
    var innerInput = this.$refs.input.$refs.input;
    innerInput.setAttribute('aria-valuenow', this.currentValue);
  }
});
// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_input_numbervue_type_script_lang_js_ = (input_numbervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_input_numbervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/input-number/src/input-number.vue"
/* harmony default export */ var input_number = (component.exports);
// CONCATENATED MODULE: ./packages/input-number/index.js


/* istanbul ignore next */
input_number.install = function (Vue) {
  Vue.component(input_number.name, input_number);
};

/* harmony default export */ var packages_input_number = __webpack_exports__["default"] = (input_number);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(63);

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

module.exports = __webpack_require__(176);

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__);


/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    var interval = null;
    var startTime = void 0;
    var handler = function handler() {
      return vnode.context[binding.expression].apply();
    };
    var clear = function clear() {
      if (Date.now() - startTime < 100) {
        handler();
      }
      clearInterval(interval);
      interval = null;
    };

    Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["on"])(el, 'mousedown', function (e) {
      if (e.button !== 0) return;
      startTime = Date.now();
      Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["once"])(document, 'mouseup', clear);
      clearInterval(interval);
      interval = setInterval(handler, 100);
    });
  }
});

/***/ })

/******/ });

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 59);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = __webpack_require__(175);

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __webpack_require__(255);

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = __webpack_require__(132);

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = __webpack_require__(256);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(52);

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

module.exports = __webpack_require__(177);

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

module.exports = __webpack_require__(178);

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

module.exports = __webpack_require__(267);

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
var cascader_panelvue_type_template_id_34932346_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["el-cascader-panel", _vm.border && "is-bordered"],
      on: { keydown: _vm.handleKeyDown }
    },
    _vm._l(_vm.menus, function(menu, index) {
      return _c("cascader-menu", {
        key: index,
        ref: "menu",
        refInFor: true,
        attrs: { index: index, nodes: menu }
      })
    }),
    1
  )
}
var staticRenderFns = []
cascader_panelvue_type_template_id_34932346_render._withStripped = true


// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&

// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(26);
var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);

// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
var scrollbar_ = __webpack_require__(14);
var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);

// EXTERNAL MODULE: external "element-ui/lib/checkbox"
var checkbox_ = __webpack_require__(18);
var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);

// EXTERNAL MODULE: external "element-ui/lib/radio"
var radio_ = __webpack_require__(51);
var radio_default = /*#__PURE__*/__webpack_require__.n(radio_);

// EXTERNAL MODULE: external "element-ui/lib/utils/util"
var util_ = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&






var stopPropagation = function stopPropagation(e) {
  return e.stopPropagation();
};

/* harmony default export */ var cascader_nodevue_type_script_lang_js_ = ({
  inject: ['panel'],

  components: {
    ElCheckbox: checkbox_default.a,
    ElRadio: radio_default.a
  },

  props: {
    node: {
      required: true
    },
    nodeId: String
  },

  computed: {
    config: function config() {
      return this.panel.config;
    },
    isLeaf: function isLeaf() {
      return this.node.isLeaf;
    },
    isDisabled: function isDisabled() {
      return this.node.isDisabled;
    },
    checkedValue: function checkedValue() {
      return this.panel.checkedValue;
    },
    isChecked: function isChecked() {
      return this.node.isSameNode(this.checkedValue);
    },
    inActivePath: function inActivePath() {
      return this.isInPath(this.panel.activePath);
    },
    inCheckedPath: function inCheckedPath() {
      var _this = this;

      if (!this.config.checkStrictly) return false;

      return this.panel.checkedNodePaths.some(function (checkedPath) {
        return _this.isInPath(checkedPath);
      });
    },
    value: function value() {
      return this.node.getValueByOption();
    }
  },

  methods: {
    handleExpand: function handleExpand() {
      var _this2 = this;

      var panel = this.panel,
          node = this.node,
          isDisabled = this.isDisabled,
          config = this.config;
      var multiple = config.multiple,
          checkStrictly = config.checkStrictly;


      if (!checkStrictly && isDisabled || node.loading) return;

      if (config.lazy && !node.loaded) {
        panel.lazyLoad(node, function () {
          // do not use cached leaf value here, invoke this.isLeaf to get new value.
          var isLeaf = _this2.isLeaf;


          if (!isLeaf) _this2.handleExpand();
          if (multiple) {
            // if leaf sync checked state, else clear checked state
            var checked = isLeaf ? node.checked : false;
            _this2.handleMultiCheckChange(checked);
          }
        });
      } else {
        panel.handleExpand(node);
      }
    },
    handleCheckChange: function handleCheckChange() {
      var panel = this.panel,
          value = this.value,
          node = this.node;

      panel.handleCheckChange(value);
      panel.handleExpand(node);
    },
    handleMultiCheckChange: function handleMultiCheckChange(checked) {
      this.node.doCheck(checked);
      this.panel.calculateMultiCheckedValue();
    },
    isInPath: function isInPath(pathNodes) {
      var node = this.node;

      var selectedPathNode = pathNodes[node.level - 1] || {};
      return selectedPathNode.uid === node.uid;
    },
    renderPrefix: function renderPrefix(h) {
      var isLeaf = this.isLeaf,
          isChecked = this.isChecked,
          config = this.config;
      var checkStrictly = config.checkStrictly,
          multiple = config.multiple;


      if (multiple) {
        return this.renderCheckbox(h);
      } else if (checkStrictly) {
        return this.renderRadio(h);
      } else if (isLeaf && isChecked) {
        return this.renderCheckIcon(h);
      }

      return null;
    },
    renderPostfix: function renderPostfix(h) {
      var node = this.node,
          isLeaf = this.isLeaf;


      if (node.loading) {
        return this.renderLoadingIcon(h);
      } else if (!isLeaf) {
        return this.renderExpandIcon(h);
      }

      return null;
    },
    renderCheckbox: function renderCheckbox(h) {
      var node = this.node,
          config = this.config,
          isDisabled = this.isDisabled;

      var events = {
        on: { change: this.handleMultiCheckChange },
        nativeOn: {}
      };

      if (config.checkStrictly) {
        // when every node is selectable, click event should not trigger expand event.
        events.nativeOn.click = stopPropagation;
      }

      return h('el-checkbox', external_babel_helper_vue_jsx_merge_props_default()([{
        attrs: {
          value: node.checked,
          indeterminate: node.indeterminate,
          disabled: isDisabled
        }
      }, events]));
    },
    renderRadio: function renderRadio(h) {
      var checkedValue = this.checkedValue,
          value = this.value,
          isDisabled = this.isDisabled;

      // to keep same reference if value cause radio's checked state is calculated by reference comparision;

      if (Object(util_["isEqual"])(value, checkedValue)) {
        value = checkedValue;
      }

      return h(
        'el-radio',
        {
          attrs: {
            value: checkedValue,
            label: value,
            disabled: isDisabled
          },
          on: {
            'change': this.handleCheckChange
          },
          nativeOn: {
            'click': stopPropagation
          }
        },
        [h('span')]
      );
    },
    renderCheckIcon: function renderCheckIcon(h) {
      return h('i', { 'class': 'el-icon-check el-cascader-node__prefix' });
    },
    renderLoadingIcon: function renderLoadingIcon(h) {
      return h('i', { 'class': 'el-icon-loading el-cascader-node__postfix' });
    },
    renderExpandIcon: function renderExpandIcon(h) {
      return h('i', { 'class': 'el-icon-arrow-right el-cascader-node__postfix' });
    },
    renderContent: function renderContent(h) {
      var panel = this.panel,
          node = this.node;

      var render = panel.renderLabelFn;
      var vnode = render ? render({ node: node, data: node.data }) : null;

      return h(
        'span',
        { 'class': 'el-cascader-node__label' },
        [vnode || node.label]
      );
    }
  },

  render: function render(h) {
    var _this3 = this;

    var inActivePath = this.inActivePath,
        inCheckedPath = this.inCheckedPath,
        isChecked = this.isChecked,
        isLeaf = this.isLeaf,
        isDisabled = this.isDisabled,
        config = this.config,
        nodeId = this.nodeId;
    var expandTrigger = config.expandTrigger,
        checkStrictly = config.checkStrictly,
        multiple = config.multiple;

    var disabled = !checkStrictly && isDisabled;
    var events = { on: {} };

    if (expandTrigger === 'click') {
      events.on.click = this.handleExpand;
    } else {
      events.on.mouseenter = function (e) {
        _this3.handleExpand();
        _this3.$emit('expand', e);
      };
      events.on.focus = function (e) {
        _this3.handleExpand();
        _this3.$emit('expand', e);
      };
    }
    if (isLeaf && !isDisabled && !checkStrictly && !multiple) {
      events.on.click = this.handleCheckChange;
    }

    return h(
      'li',
      external_babel_helper_vue_jsx_merge_props_default()([{
        attrs: {
          role: 'menuitem',
          id: nodeId,
          'aria-expanded': inActivePath,
          tabindex: disabled ? null : -1
        },
        'class': {
          'el-cascader-node': true,
          'is-selectable': checkStrictly,
          'in-active-path': inActivePath,
          'in-checked-path': inCheckedPath,
          'is-active': isChecked,
          'is-disabled': disabled
        }
      }, events]),
      [this.renderPrefix(h), this.renderContent(h), this.renderPostfix(h)]
    );
  }
});
// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_cascader_nodevue_type_script_lang_js_ = (cascader_nodevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
var cascader_node_render, cascader_node_staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_cascader_nodevue_type_script_lang_js_,
  cascader_node_render,
  cascader_node_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/cascader-panel/src/cascader-node.vue"
/* harmony default export */ var cascader_node = (component.exports);
// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
var locale_ = __webpack_require__(6);
var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&







/* harmony default export */ var cascader_menuvue_type_script_lang_js_ = ({
  name: 'ElCascaderMenu',

  mixins: [locale_default.a],

  inject: ['panel'],

  components: {
    ElScrollbar: scrollbar_default.a,
    CascaderNode: cascader_node
  },

  props: {
    nodes: {
      type: Array,
      required: true
    },
    index: Number
  },

  data: function data() {
    return {
      activeNode: null,
      hoverTimer: null,
      id: Object(util_["generateId"])()
    };
  },


  computed: {
    isEmpty: function isEmpty() {
      return !this.nodes.length;
    },
    menuId: function menuId() {
      return 'cascader-menu-' + this.id + '-' + this.index;
    }
  },

  methods: {
    handleExpand: function handleExpand(e) {
      this.activeNode = e.target;
    },
    handleMouseMove: function handleMouseMove(e) {
      var activeNode = this.activeNode,
          hoverTimer = this.hoverTimer;
      var hoverZone = this.$refs.hoverZone;


      if (!activeNode || !hoverZone) return;

      if (activeNode.contains(e.target)) {
        clearTimeout(hoverTimer);

        var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
            left = _$el$getBoundingClien.left;

        var startX = e.clientX - left;
        var _$el = this.$el,
            offsetWidth = _$el.offsetWidth,
            offsetHeight = _$el.offsetHeight;

        var top = activeNode.offsetTop;
        var bottom = top + activeNode.offsetHeight;

        hoverZone.innerHTML = '\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + top + ' L' + offsetWidth + ' 0 V' + top + ' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + bottom + ' L' + offsetWidth + ' ' + offsetHeight + ' V' + bottom + ' Z" />\n        ';
      } else if (!hoverTimer) {
        this.hoverTimer = setTimeout(this.clearHoverZone, this.panel.config.hoverThreshold);
      }
    },
    clearHoverZone: function clearHoverZone() {
      var hoverZone = this.$refs.hoverZone;

      if (!hoverZone) return;
      hoverZone.innerHTML = '';
    },
    renderEmptyText: function renderEmptyText(h) {
      return h(
        'div',
        { 'class': 'el-cascader-menu__empty-text' },
        [this.t('el.cascader.noData')]
      );
    },
    renderNodeList: function renderNodeList(h) {
      var menuId = this.menuId;
      var isHoverMenu = this.panel.isHoverMenu;

      var events = { on: {} };

      if (isHoverMenu) {
        events.on.expand = this.handleExpand;
      }

      var nodes = this.nodes.map(function (node, index) {
        var hasChildren = node.hasChildren;

        return h('cascader-node', external_babel_helper_vue_jsx_merge_props_default()([{
          key: node.uid,
          attrs: { node: node,
            'node-id': menuId + '-' + index,
            'aria-haspopup': hasChildren,
            'aria-owns': hasChildren ? menuId : null
          }
        }, events]));
      });

      return [].concat(nodes, [isHoverMenu ? h('svg', { ref: 'hoverZone', 'class': 'el-cascader-menu__hover-zone' }) : null]);
    }
  },

  render: function render(h) {
    var isEmpty = this.isEmpty,
        menuId = this.menuId;

    var events = { nativeOn: {} };

    // optimize hover to expand experience (#8010)
    if (this.panel.isHoverMenu) {
      events.nativeOn.mousemove = this.handleMouseMove;
      // events.nativeOn.mouseleave = this.clearHoverZone;
    }

    return h(
      'el-scrollbar',
      external_babel_helper_vue_jsx_merge_props_default()([{
        attrs: {
          tag: 'ul',
          role: 'menu',
          id: menuId,

          'wrap-class': 'el-cascader-menu__wrap',
          'view-class': {
            'el-cascader-menu__list': true,
            'is-empty': isEmpty
          }
        },
        'class': 'el-cascader-menu' }, events]),
      [isEmpty ? this.renderEmptyText(h) : this.renderNodeList(h)]
    );
  }
});
// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_cascader_menuvue_type_script_lang_js_ = (cascader_menuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
var cascader_menu_render, cascader_menu_staticRenderFns




/* normalize component */

var cascader_menu_component = Object(componentNormalizer["a" /* default */])(
  src_cascader_menuvue_type_script_lang_js_,
  cascader_menu_render,
  cascader_menu_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var cascader_menu_api; }
cascader_menu_component.options.__file = "packages/cascader-panel/src/cascader-menu.vue"
/* harmony default export */ var cascader_menu = (cascader_menu_component.exports);
// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
var shared_ = __webpack_require__(21);

// CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var uid = 0;

var node_Node = function () {
  function Node(data, config, parentNode) {
    _classCallCheck(this, Node);

    this.data = data;
    this.config = config;
    this.parent = parentNode || null;
    this.level = !this.parent ? 1 : this.parent.level + 1;
    this.uid = uid++;

    this.initState();
    this.initChildren();
  }

  Node.prototype.initState = function initState() {
    var _config = this.config,
        valueKey = _config.value,
        labelKey = _config.label;


    this.value = this.data[valueKey];
    this.label = this.data[labelKey];
    this.pathNodes = this.calculatePathNodes();
    this.path = this.pathNodes.map(function (node) {
      return node.value;
    });
    this.pathLabels = this.pathNodes.map(function (node) {
      return node.label;
    });

    // lazy load
    this.loading = false;
    this.loaded = false;
  };

  Node.prototype.initChildren = function initChildren() {
    var _this = this;

    var config = this.config;

    var childrenKey = config.children;
    var childrenData = this.data[childrenKey];
    this.hasChildren = Array.isArray(childrenData);
    this.children = (childrenData || []).map(function (child) {
      return new Node(child, config, _this);
    });
  };

  Node.prototype.calculatePathNodes = function calculatePathNodes() {
    var nodes = [this];
    var parent = this.parent;

    while (parent) {
      nodes.unshift(parent);
      parent = parent.parent;
    }

    return nodes;
  };

  Node.prototype.getPath = function getPath() {
    return this.path;
  };

  Node.prototype.getValue = function getValue() {
    return this.value;
  };

  Node.prototype.getValueByOption = function getValueByOption() {
    return this.config.emitPath ? this.getPath() : this.getValue();
  };

  Node.prototype.getText = function getText(allLevels, separator) {
    return allLevels ? this.pathLabels.join(separator) : this.label;
  };

  Node.prototype.isSameNode = function isSameNode(checkedValue) {
    var value = this.getValueByOption();
    return this.config.multiple && Array.isArray(checkedValue) ? checkedValue.some(function (val) {
      return Object(util_["isEqual"])(val, value);
    }) : Object(util_["isEqual"])(checkedValue, value);
  };

  Node.prototype.broadcast = function broadcast(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var handlerName = 'onParent' + Object(util_["capitalize"])(event);

    this.children.forEach(function (child) {
      if (child) {
        // bottom up
        child.broadcast.apply(child, [event].concat(args));
        child[handlerName] && child[handlerName].apply(child, args);
      }
    });
  };

  Node.prototype.emit = function emit(event) {
    var parent = this.parent;

    var handlerName = 'onChild' + Object(util_["capitalize"])(event);
    if (parent) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      parent[handlerName] && parent[handlerName].apply(parent, args);
      parent.emit.apply(parent, [event].concat(args));
    }
  };

  Node.prototype.onParentCheck = function onParentCheck(checked) {
    if (!this.isDisabled) {
      this.setCheckState(checked);
    }
  };

  Node.prototype.onChildCheck = function onChildCheck() {
    var children = this.children;

    var validChildren = children.filter(function (child) {
      return !child.isDisabled;
    });
    var checked = validChildren.length ? validChildren.every(function (child) {
      return child.checked;
    }) : false;

    this.setCheckState(checked);
  };

  Node.prototype.setCheckState = function setCheckState(checked) {
    var totalNum = this.children.length;
    var checkedNum = this.children.reduce(function (c, p) {
      var num = p.checked ? 1 : p.indeterminate ? 0.5 : 0;
      return c + num;
    }, 0);

    this.checked = checked;
    this.indeterminate = checkedNum !== totalNum && checkedNum > 0;
  };

  Node.prototype.syncCheckState = function syncCheckState(checkedValue) {
    var value = this.getValueByOption();
    var checked = this.isSameNode(checkedValue, value);

    this.doCheck(checked);
  };

  Node.prototype.doCheck = function doCheck(checked) {
    if (this.checked !== checked) {
      if (this.config.checkStrictly) {
        this.checked = checked;
      } else {
        // bottom up to unify the calculation of the indeterminate state
        this.broadcast('check', checked);
        this.setCheckState(checked);
        this.emit('check');
      }
    }
  };

  _createClass(Node, [{
    key: 'isDisabled',
    get: function get() {
      var data = this.data,
          parent = this.parent,
          config = this.config;

      var disabledKey = config.disabled;
      var checkStrictly = config.checkStrictly;

      return data[disabledKey] || !checkStrictly && parent && parent.isDisabled;
    }
  }, {
    key: 'isLeaf',
    get: function get() {
      var data = this.data,
          loaded = this.loaded,
          hasChildren = this.hasChildren,
          children = this.children;
      var _config2 = this.config,
          lazy = _config2.lazy,
          leafKey = _config2.leaf;

      if (lazy) {
        var isLeaf = Object(shared_["isDef"])(data[leafKey]) ? data[leafKey] : loaded ? !children.length : false;
        this.hasChildren = !isLeaf;
        return isLeaf;
      }
      return !hasChildren;
    }
  }]);

  return Node;
}();

/* harmony default export */ var src_node = (node_Node);
// CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
function store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var flatNodes = function flatNodes(data, leafOnly) {
  return data.reduce(function (res, node) {
    if (node.isLeaf) {
      res.push(node);
    } else {
      !leafOnly && res.push(node);
      res = res.concat(flatNodes(node.children, leafOnly));
    }
    return res;
  }, []);
};

var store_Store = function () {
  function Store(data, config) {
    store_classCallCheck(this, Store);

    this.config = config;
    this.initNodes(data);
  }

  Store.prototype.initNodes = function initNodes(data) {
    var _this = this;

    data = Object(util_["coerceTruthyValueToArray"])(data);
    this.nodes = data.map(function (nodeData) {
      return new src_node(nodeData, _this.config);
    });
    this.flattedNodes = this.getFlattedNodes(false, false);
    this.leafNodes = this.getFlattedNodes(true, false);
  };

  Store.prototype.appendNode = function appendNode(nodeData, parentNode) {
    var node = new src_node(nodeData, this.config, parentNode);
    var children = parentNode ? parentNode.children : this.nodes;

    children.push(node);
  };

  Store.prototype.appendNodes = function appendNodes(nodeDataList, parentNode) {
    var _this2 = this;

    nodeDataList = Object(util_["coerceTruthyValueToArray"])(nodeDataList);
    nodeDataList.forEach(function (nodeData) {
      return _this2.appendNode(nodeData, parentNode);
    });
  };

  Store.prototype.getNodes = function getNodes() {
    return this.nodes;
  };

  Store.prototype.getFlattedNodes = function getFlattedNodes(leafOnly) {
    var cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var cachedNodes = leafOnly ? this.leafNodes : this.flattedNodes;
    return cached ? cachedNodes : flatNodes(this.nodes, leafOnly);
  };

  Store.prototype.getNodeByValue = function getNodeByValue(value) {
    if (value) {
      var nodes = this.getFlattedNodes(false, !this.config.lazy).filter(function (node) {
        return Object(util_["valueEquals"])(node.path, value) || node.value === value;
      });
      return nodes && nodes.length ? nodes[0] : null;
    }
    return null;
  };

  return Store;
}();

/* harmony default export */ var src_store = (store_Store);
// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
var merge_ = __webpack_require__(9);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

// EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
var aria_utils_ = __webpack_require__(32);
var aria_utils_default = /*#__PURE__*/__webpack_require__.n(aria_utils_);

// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
var scroll_into_view_ = __webpack_require__(31);
var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var KeyCode = aria_utils_default.a.keys;

var DefaultProps = {
  expandTrigger: 'click', // or hover
  multiple: false,
  checkStrictly: false, // whether all nodes can be selected
  emitPath: true, // wether to emit an array of all levels value in which node is located
  lazy: false,
  lazyLoad: util_["noop"],
  value: 'value',
  label: 'label',
  children: 'children',
  leaf: 'leaf',
  disabled: 'disabled',
  hoverThreshold: 500
};

var cascader_panelvue_type_script_lang_js_isLeaf = function isLeaf(el) {
  return !el.getAttribute('aria-owns');
};

var getSibling = function getSibling(el, distance) {
  var parentNode = el.parentNode;

  if (parentNode) {
    var siblings = parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');
    var index = Array.prototype.indexOf.call(siblings, el);
    return siblings[index + distance] || null;
  }
  return null;
};

var getMenuIndex = function getMenuIndex(el, distance) {
  if (!el) return;
  var pieces = el.id.split('-');
  return Number(pieces[pieces.length - 2]);
};

var focusNode = function focusNode(el) {
  if (!el) return;
  el.focus();
  !cascader_panelvue_type_script_lang_js_isLeaf(el) && el.click();
};

var checkNode = function checkNode(el) {
  if (!el) return;

  var input = el.querySelector('input');
  if (input) {
    input.click();
  } else if (cascader_panelvue_type_script_lang_js_isLeaf(el)) {
    el.click();
  }
};

/* harmony default export */ var cascader_panelvue_type_script_lang_js_ = ({
  name: 'ElCascaderPanel',

  components: {
    CascaderMenu: cascader_menu
  },

  props: {
    value: {},
    options: Array,
    props: Object,
    border: {
      type: Boolean,
      default: true
    },
    renderLabel: Function
  },

  provide: function provide() {
    return {
      panel: this
    };
  },
  data: function data() {
    return {
      checkedValue: null,
      checkedNodePaths: [],
      store: [],
      menus: [],
      activePath: [],
      loadCount: 0
    };
  },


  computed: {
    config: function config() {
      return merge_default()(_extends({}, DefaultProps), this.props || {});
    },
    multiple: function multiple() {
      return this.config.multiple;
    },
    checkStrictly: function checkStrictly() {
      return this.config.checkStrictly;
    },
    leafOnly: function leafOnly() {
      return !this.checkStrictly;
    },
    isHoverMenu: function isHoverMenu() {
      return this.config.expandTrigger === 'hover';
    },
    renderLabelFn: function renderLabelFn() {
      return this.renderLabel || this.$scopedSlots.default;
    }
  },

  watch: {
    options: {
      handler: function handler() {
        this.initStore();
      },
      immediate: true,
      deep: true
    },
    value: function value() {
      this.syncCheckedValue();
      this.checkStrictly && this.calculateCheckedNodePaths();
    },
    checkedValue: function checkedValue(val) {
      if (!Object(util_["isEqual"])(val, this.value)) {
        this.checkStrictly && this.calculateCheckedNodePaths();
        this.$emit('input', val);
        this.$emit('change', val);
      }
    }
  },

  mounted: function mounted() {
    if (!Object(util_["isEmpty"])(this.value)) {
      this.syncCheckedValue();
    }
  },


  methods: {
    initStore: function initStore() {
      var config = this.config,
          options = this.options;

      if (config.lazy && Object(util_["isEmpty"])(options)) {
        this.lazyLoad();
      } else {
        this.store = new src_store(options, config);
        this.menus = [this.store.getNodes()];
        this.syncMenuState();
      }
    },
    syncCheckedValue: function syncCheckedValue() {
      var value = this.value,
          checkedValue = this.checkedValue;

      if (!Object(util_["isEqual"])(value, checkedValue)) {
        this.checkedValue = value;
        this.syncMenuState();
      }
    },
    syncMenuState: function syncMenuState() {
      var multiple = this.multiple,
          checkStrictly = this.checkStrictly;

      this.syncActivePath();
      multiple && this.syncMultiCheckState();
      checkStrictly && this.calculateCheckedNodePaths();
      this.$nextTick(this.scrollIntoView);
    },
    syncMultiCheckState: function syncMultiCheckState() {
      var _this = this;

      var nodes = this.getFlattedNodes(this.leafOnly);

      nodes.forEach(function (node) {
        node.syncCheckState(_this.checkedValue);
      });
    },
    syncActivePath: function syncActivePath() {
      var _this2 = this;

      var store = this.store,
          multiple = this.multiple,
          activePath = this.activePath,
          checkedValue = this.checkedValue;


      if (!Object(util_["isEmpty"])(activePath)) {
        var nodes = activePath.map(function (node) {
          return _this2.getNodeByValue(node.getValue());
        });
        this.expandNodes(nodes);
      } else if (!Object(util_["isEmpty"])(checkedValue)) {
        var value = multiple ? checkedValue[0] : checkedValue;
        var checkedNode = this.getNodeByValue(value) || {};
        var _nodes = (checkedNode.pathNodes || []).slice(0, -1);
        this.expandNodes(_nodes);
      } else {
        this.activePath = [];
        this.menus = [store.getNodes()];
      }
    },
    expandNodes: function expandNodes(nodes) {
      var _this3 = this;

      nodes.forEach(function (node) {
        return _this3.handleExpand(node, true /* silent */);
      });
    },
    calculateCheckedNodePaths: function calculateCheckedNodePaths() {
      var _this4 = this;

      var checkedValue = this.checkedValue,
          multiple = this.multiple;

      var checkedValues = multiple ? Object(util_["coerceTruthyValueToArray"])(checkedValue) : [checkedValue];
      this.checkedNodePaths = checkedValues.map(function (v) {
        var checkedNode = _this4.getNodeByValue(v);
        return checkedNode ? checkedNode.pathNodes : [];
      });
    },
    handleKeyDown: function handleKeyDown(e) {
      var target = e.target,
          keyCode = e.keyCode;


      switch (keyCode) {
        case KeyCode.up:
          var prev = getSibling(target, -1);
          focusNode(prev);
          break;
        case KeyCode.down:
          var next = getSibling(target, 1);
          focusNode(next);
          break;
        case KeyCode.left:
          var preMenu = this.$refs.menu[getMenuIndex(target) - 1];
          if (preMenu) {
            var expandedNode = preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');
            focusNode(expandedNode);
          }
          break;
        case KeyCode.right:
          var nextMenu = this.$refs.menu[getMenuIndex(target) + 1];
          if (nextMenu) {
            var firstNode = nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');
            focusNode(firstNode);
          }
          break;
        case KeyCode.enter:
          checkNode(target);
          break;
        case KeyCode.esc:
        case KeyCode.tab:
          this.$emit('close');
          break;
        default:
          return;
      }
    },
    handleExpand: function handleExpand(node, silent) {
      var activePath = this.activePath;
      var level = node.level;

      var path = activePath.slice(0, level - 1);
      var menus = this.menus.slice(0, level);

      if (!node.isLeaf) {
        path.push(node);
        menus.push(node.children);
      }

      this.activePath = path;
      this.menus = menus;

      if (!silent) {
        var pathValues = path.map(function (node) {
          return node.getValue();
        });
        var activePathValues = activePath.map(function (node) {
          return node.getValue();
        });
        if (!Object(util_["valueEquals"])(pathValues, activePathValues)) {
          this.$emit('active-item-change', pathValues); // Deprecated
          this.$emit('expand-change', pathValues);
        }
      }
    },
    handleCheckChange: function handleCheckChange(value) {
      this.checkedValue = value;
    },
    lazyLoad: function lazyLoad(node, onFullfiled) {
      var _this5 = this;

      var config = this.config;

      if (!node) {
        node = node || { root: true, level: 0 };
        this.store = new src_store([], config);
        this.menus = [this.store.getNodes()];
      }
      node.loading = true;
      var resolve = function resolve(dataList) {
        var parent = node.root ? null : node;
        dataList && dataList.length && _this5.store.appendNodes(dataList, parent);
        node.loading = false;
        node.loaded = true;

        // dispose default value on lazy load mode
        if (Array.isArray(_this5.checkedValue)) {
          var nodeValue = _this5.checkedValue[_this5.loadCount++];
          var valueKey = _this5.config.value;
          var leafKey = _this5.config.leaf;

          if (Array.isArray(dataList) && dataList.filter(function (item) {
            return item[valueKey] === nodeValue;
          }).length > 0) {
            var checkedNode = _this5.store.getNodeByValue(nodeValue);

            if (!checkedNode.data[leafKey]) {
              _this5.lazyLoad(checkedNode, function () {
                _this5.handleExpand(checkedNode);
              });
            }

            if (_this5.loadCount === _this5.checkedValue.length) {
              _this5.$parent.computePresentText();
            }
          }
        }

        onFullfiled && onFullfiled(dataList);
      };
      config.lazyLoad(node, resolve);
    },


    /**
     * public methods
    */
    calculateMultiCheckedValue: function calculateMultiCheckedValue() {
      this.checkedValue = this.getCheckedNodes(this.leafOnly).map(function (node) {
        return node.getValueByOption();
      });
    },
    scrollIntoView: function scrollIntoView() {
      if (this.$isServer) return;

      var menus = this.$refs.menu || [];
      menus.forEach(function (menu) {
        var menuElement = menu.$el;
        if (menuElement) {
          var container = menuElement.querySelector('.el-scrollbar__wrap');
          var activeNode = menuElement.querySelector('.el-cascader-node.is-active') || menuElement.querySelector('.el-cascader-node.in-active-path');
          scroll_into_view_default()(container, activeNode);
        }
      });
    },
    getNodeByValue: function getNodeByValue(val) {
      return this.store.getNodeByValue(val);
    },
    getFlattedNodes: function getFlattedNodes(leafOnly) {
      var cached = !this.config.lazy;
      return this.store.getFlattedNodes(leafOnly, cached);
    },
    getCheckedNodes: function getCheckedNodes(leafOnly) {
      var checkedValue = this.checkedValue,
          multiple = this.multiple;

      if (multiple) {
        var nodes = this.getFlattedNodes(leafOnly);
        return nodes.filter(function (node) {
          return node.checked;
        });
      } else {
        return Object(util_["isEmpty"])(checkedValue) ? [] : [this.getNodeByValue(checkedValue)];
      }
    },
    clearCheckedNodes: function clearCheckedNodes() {
      var config = this.config,
          leafOnly = this.leafOnly;
      var multiple = config.multiple,
          emitPath = config.emitPath;

      if (multiple) {
        this.getCheckedNodes(leafOnly).filter(function (node) {
          return !node.isDisabled;
        }).forEach(function (node) {
          return node.doCheck(false);
        });
        this.calculateMultiCheckedValue();
      } else {
        this.checkedValue = emitPath ? [] : null;
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_cascader_panelvue_type_script_lang_js_ = (cascader_panelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue





/* normalize component */

var cascader_panel_component = Object(componentNormalizer["a" /* default */])(
  src_cascader_panelvue_type_script_lang_js_,
  cascader_panelvue_type_template_id_34932346_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var cascader_panel_api; }
cascader_panel_component.options.__file = "packages/cascader-panel/src/cascader-panel.vue"
/* harmony default export */ var cascader_panel = (cascader_panel_component.exports);
// CONCATENATED MODULE: ./packages/cascader-panel/index.js


/* istanbul ignore next */
cascader_panel.install = function (Vue) {
  Vue.component(cascader_panel.name, cascader_panel);
};

/* harmony default export */ var packages_cascader_panel = __webpack_exports__["default"] = (cascader_panel);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(170);

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __webpack_require__(131);

/***/ })

/******/ });

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 74);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(63);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(52);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(130);

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(11);

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "transition",
        {
          attrs: { name: _vm.transition },
          on: {
            "after-enter": _vm.handleAfterEnter,
            "after-leave": _vm.handleAfterLeave
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.disabled && _vm.showPopper,
                  expression: "!disabled && showPopper"
                }
              ],
              ref: "popper",
              staticClass: "el-popover el-popper",
              class: [_vm.popperClass, _vm.content && "el-popover--plain"],
              style: { width: _vm.width + "px" },
              attrs: {
                role: "tooltip",
                id: _vm.tooltipId,
                "aria-hidden":
                  _vm.disabled || !_vm.showPopper ? "true" : "false"
              }
            },
            [
              _vm.title
                ? _c("div", {
                    staticClass: "el-popover__title",
                    domProps: { textContent: _vm._s(_vm.title) }
                  })
                : _vm._e(),
              _vm._t("default", [_vm._v(_vm._s(_vm.content))])
            ],
            2
          )
        ]
      ),
      _vm._t("reference")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&

// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
var vue_popper_ = __webpack_require__(5);
var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);

// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
var dom_ = __webpack_require__(2);

// EXTERNAL MODULE: external "element-ui/lib/utils/util"
var util_ = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: 'ElPopover',

  mixins: [vue_popper_default.a],

  props: {
    trigger: {
      type: String,
      default: 'click',
      validator: function validator(value) {
        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
      }
    },
    openDelay: {
      type: Number,
      default: 0
    },
    closeDelay: {
      type: Number,
      default: 200
    },
    title: String,
    disabled: Boolean,
    content: String,
    reference: {},
    popperClass: String,
    width: {},
    visibleArrow: {
      default: true
    },
    arrowOffset: {
      type: Number,
      default: 0
    },
    transition: {
      type: String,
      default: 'fade-in-linear'
    },
    tabindex: {
      type: Number,
      default: 0
    }
  },

  computed: {
    tooltipId: function tooltipId() {
      return 'el-popover-' + Object(util_["generateId"])();
    }
  },
  watch: {
    showPopper: function showPopper(val) {
      if (this.disabled) {
        return;
      }
      val ? this.$emit('show') : this.$emit('hide');
    }
  },

  mounted: function mounted() {
    var _this = this;

    var reference = this.referenceElm = this.reference || this.$refs.reference;
    var popper = this.popper || this.$refs.popper;

    if (!reference && this.$slots.reference && this.$slots.reference[0]) {
      reference = this.referenceElm = this.$slots.reference[0].elm;
    }
    // 可访问性
    if (reference) {
      Object(dom_["addClass"])(reference, 'el-popover__reference');
      reference.setAttribute('aria-describedby', this.tooltipId);
      reference.setAttribute('tabindex', this.tabindex); // tab序列
      popper.setAttribute('tabindex', 0);

      if (this.trigger !== 'click') {
        Object(dom_["on"])(reference, 'focusin', function () {
          _this.handleFocus();
          var instance = reference.__vue__;
          if (instance && typeof instance.focus === 'function') {
            instance.focus();
          }
        });
        Object(dom_["on"])(popper, 'focusin', this.handleFocus);
        Object(dom_["on"])(reference, 'focusout', this.handleBlur);
        Object(dom_["on"])(popper, 'focusout', this.handleBlur);
      }
      Object(dom_["on"])(reference, 'keydown', this.handleKeydown);
      Object(dom_["on"])(reference, 'click', this.handleClick);
    }
    if (this.trigger === 'click') {
      Object(dom_["on"])(reference, 'click', this.doToggle);
      Object(dom_["on"])(document, 'click', this.handleDocumentClick);
    } else if (this.trigger === 'hover') {
      Object(dom_["on"])(reference, 'mouseenter', this.handleMouseEnter);
      Object(dom_["on"])(popper, 'mouseenter', this.handleMouseEnter);
      Object(dom_["on"])(reference, 'mouseleave', this.handleMouseLeave);
      Object(dom_["on"])(popper, 'mouseleave', this.handleMouseLeave);
    } else if (this.trigger === 'focus') {
      if (this.tabindex < 0) {
        console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');
      }
      if (reference.querySelector('input, textarea')) {
        Object(dom_["on"])(reference, 'focusin', this.doShow);
        Object(dom_["on"])(reference, 'focusout', this.doClose);
      } else {
        Object(dom_["on"])(reference, 'mousedown', this.doShow);
        Object(dom_["on"])(reference, 'mouseup', this.doClose);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cleanup();
  },
  deactivated: function deactivated() {
    this.cleanup();
  },


  methods: {
    doToggle: function doToggle() {
      this.showPopper = !this.showPopper;
    },
    doShow: function doShow() {
      this.showPopper = true;
    },
    doClose: function doClose() {
      this.showPopper = false;
    },
    handleFocus: function handleFocus() {
      Object(dom_["addClass"])(this.referenceElm, 'focusing');
      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = true;
    },
    handleClick: function handleClick() {
      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
    },
    handleBlur: function handleBlur() {
      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = false;
    },
    handleMouseEnter: function handleMouseEnter() {
      var _this2 = this;

      clearTimeout(this._timer);
      if (this.openDelay) {
        this._timer = setTimeout(function () {
          _this2.showPopper = true;
        }, this.openDelay);
      } else {
        this.showPopper = true;
      }
    },
    handleKeydown: function handleKeydown(ev) {
      if (ev.keyCode === 27 && this.trigger !== 'manual') {
        // esc
        this.doClose();
      }
    },
    handleMouseLeave: function handleMouseLeave() {
      var _this3 = this;

      clearTimeout(this._timer);
      if (this.closeDelay) {
        this._timer = setTimeout(function () {
          _this3.showPopper = false;
        }, this.closeDelay);
      } else {
        this.showPopper = false;
      }
    },
    handleDocumentClick: function handleDocumentClick(e) {
      var reference = this.reference || this.$refs.reference;
      var popper = this.popper || this.$refs.popper;

      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
        reference = this.referenceElm = this.$slots.reference[0].elm;
      }
      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
      this.showPopper = false;
    },
    handleAfterEnter: function handleAfterEnter() {
      this.$emit('after-enter');
    },
    handleAfterLeave: function handleAfterLeave() {
      this.$emit('after-leave');
      this.doDestroy();
    },
    cleanup: function cleanup() {
      if (this.openDelay || this.closeDelay) {
        clearTimeout(this._timer);
      }
    }
  },

  destroyed: function destroyed() {
    var reference = this.reference;

    Object(dom_["off"])(reference, 'click', this.doToggle);
    Object(dom_["off"])(reference, 'mouseup', this.doClose);
    Object(dom_["off"])(reference, 'mousedown', this.doShow);
    Object(dom_["off"])(reference, 'focusin', this.doShow);
    Object(dom_["off"])(reference, 'focusout', this.doClose);
    Object(dom_["off"])(reference, 'mousedown', this.doShow);
    Object(dom_["off"])(reference, 'mouseup', this.doClose);
    Object(dom_["off"])(reference, 'mouseleave', this.handleMouseLeave);
    Object(dom_["off"])(reference, 'mouseenter', this.handleMouseEnter);
    Object(dom_["off"])(document, 'click', this.handleDocumentClick);
  }
});
// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/popover/src/main.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/popover/src/main.vue"
/* harmony default export */ var main = (component.exports);
// CONCATENATED MODULE: ./packages/popover/src/directive.js
var getReference = function getReference(el, binding, vnode) {
  var _ref = binding.expression ? binding.value : binding.arg;
  var popper = vnode.context.$refs[_ref];
  if (popper) {
    if (Array.isArray(popper)) {
      popper[0].$refs.reference = el;
    } else {
      popper.$refs.reference = el;
    }
  }
};

/* harmony default export */ var directive = ({
  bind: function bind(el, binding, vnode) {
    getReference(el, binding, vnode);
  },
  inserted: function inserted(el, binding, vnode) {
    getReference(el, binding, vnode);
  }
});
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(7);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./packages/popover/index.js




external_vue_default.a.directive('popover', directive);

/* istanbul ignore next */
main.install = function (Vue) {
  Vue.directive('popover', directive);
  Vue.component(main.name, main);
};
main.directive = directive;

/* harmony default export */ var popover = __webpack_exports__["default"] = (main);

/***/ })

/******/ });

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _stringify = __webpack_require__(24);var _stringify2 = _interopRequireDefault(_stringify);var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _keys = __webpack_require__(59);var _keys2 = _interopRequireDefault(_keys);var _typeof2 = __webpack_require__(58);var _typeof3 = _interopRequireDefault(_typeof2);
var _lodash = __webpack_require__(98);var _lodash2 = _interopRequireDefault(_lodash);
var _viewFunction = __webpack_require__(779);var _viewFunction2 = _interopRequireDefault(_viewFunction);
var _BpmFunction = __webpack_require__(780);var _BpmFunction2 = _interopRequireDefault(_BpmFunction);
__webpack_require__(781);

var _app = __webpack_require__(91);var _app2 = _interopRequireDefault(_app);
var _free = __webpack_require__(849);var _free2 = _interopRequireDefault(_free);
var _business = __webpack_require__(850);var _business2 = _interopRequireDefault(_business);
var _common = __webpack_require__(300);var _common2 = _interopRequireDefault(_common);
var _com = __webpack_require__(851);var _com2 = _interopRequireDefault(_com);
var _config = __webpack_require__(301);var _config2 = _interopRequireDefault(_config);
var _data = __webpack_require__(206);var _data2 = _interopRequireDefault(_data);
var _org = __webpack_require__(207);var _org2 = _interopRequireDefault(_org);
var _process = __webpack_require__(302);var _process2 = _interopRequireDefault(_process);
var _job = __webpack_require__(854);var _job2 = _interopRequireDefault(_job);
var _oa = __webpack_require__(855);var _oa2 = _interopRequireDefault(_oa);
var _oaSrv = __webpack_require__(856);var _oaSrv2 = _interopRequireDefault(_oaSrv);
var _maintain = __webpack_require__(34);var _maintain2 = _interopRequireDefault(_maintain);
var _fileManager = __webpack_require__(857);var _fileManager2 = _interopRequireDefault(_fileManager);
var _token = __webpack_require__(25);var _token2 = _interopRequireDefault(_token);

var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);
__webpack_require__(858);
__webpack_require__(866);
__webpack_require__(867);
__webpack_require__(303);

var _index = __webpack_require__(868);var _index2 = _interopRequireDefault(_index);

var _util3 = __webpack_require__(16);var _util4 = _interopRequireDefault(_util3);
var _config3 = __webpack_require__(871);var _config4 = _interopRequireDefault(_config3);
var _index3 = __webpack_require__(872);var _index4 = _interopRequireDefault(_index3);
var _index5 = __webpack_require__(876);var _index6 = _interopRequireDefault(_index5);
var _index7 = __webpack_require__(927);var _index8 = _interopRequireDefault(_index7);
var _page = __webpack_require__(930);var _page2 = _interopRequireDefault(_page);
var _splitPanel = __webpack_require__(936);var _splitPanel2 = _interopRequireDefault(_splitPanel);
var _tree = __webpack_require__(942);var _tree2 = _interopRequireDefault(_tree);
var _pagination = __webpack_require__(945);var _pagination2 = _interopRequireDefault(_pagination);
var _index9 = __webpack_require__(947);var _index10 = _interopRequireDefault(_index9);
var _index11 = __webpack_require__(322);var _index12 = _interopRequireDefault(_index11);
var _MwFormView = __webpack_require__(950);var _MwFormView2 = _interopRequireDefault(_MwFormView);
var _index13 = __webpack_require__(953);var _index14 = _interopRequireDefault(_index13);
var _uploadTable = __webpack_require__(957);var _uploadTable2 = _interopRequireDefault(_uploadTable);
var _dialog = __webpack_require__(958);var _dialog2 = _interopRequireDefault(_dialog);
var _processChartEditor = __webpack_require__(960);var _processChartEditor2 = _interopRequireDefault(_processChartEditor);
var _rightMenu = __webpack_require__(1008);var _rightMenu2 = _interopRequireDefault(_rightMenu);
var _index15 = __webpack_require__(1011);var _index16 = _interopRequireDefault(_index15);
var _screenfull = __webpack_require__(472);var _screenfull2 = _interopRequireDefault(_screenfull);
var _mdeditor = __webpack_require__(1013);var _mdeditor2 = _interopRequireDefault(_mdeditor);
var _htmlEditor = __webpack_require__(1016);var _htmlEditor2 = _interopRequireDefault(_htmlEditor);
var _formulaGenerator = __webpack_require__(1018);var _formulaGenerator2 = _interopRequireDefault(_formulaGenerator);

var _ntkoEditor = __webpack_require__(1021);var _ntkoEditor2 = _interopRequireDefault(_ntkoEditor);
var _ntkoAttachment = __webpack_require__(1026);var _ntkoAttachment2 = _interopRequireDefault(_ntkoAttachment);
var _colorSelect = __webpack_require__(473);var _colorSelect2 = _interopRequireDefault(_colorSelect);

var _toobarTable = __webpack_require__(1028);var _toobarTable2 = _interopRequireDefault(_toobarTable);

var _invokeFormAction = __webpack_require__(1030);var _invokeFormAction2 = _interopRequireDefault(_invokeFormAction);

var _scriptLoader = __webpack_require__(1031);var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

var _attachment = __webpack_require__(1032);var _attachment2 = _interopRequireDefault(_attachment);
var _attachmentListMin = __webpack_require__(1034);var _attachmentListMin2 = _interopRequireDefault(_attachmentListMin);
var _comment = __webpack_require__(1037);var _comment2 = _interopRequireDefault(_comment);
var _commentMin = __webpack_require__(1039);var _commentMin2 = _interopRequireDefault(_commentMin);
var _imbeddedView = __webpack_require__(1041);var _imbeddedView2 = _interopRequireDefault(_imbeddedView);
var _documentEditor = __webpack_require__(1043);var _documentEditor2 = _interopRequireDefault(_documentEditor);
var _relFileSelection = __webpack_require__(1045);var _relFileSelection2 = _interopRequireDefault(_relFileSelection);
var _userFiledSelection = __webpack_require__(1048);var _userFiledSelection2 = _interopRequireDefault(_userFiledSelection);
var _index17 = __webpack_require__(200);var _index18 = _interopRequireDefault(_index17);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}


var components = [
_attachment2.default,
_attachmentListMin2.default,
_comment2.default,
_imbeddedView2.default,
_commentMin2.default,
_documentEditor2.default,
_relFileSelection2.default,
_index6.default,
_colorSelect2.default,
_MwFormView2.default,
_index2.default,
_index12.default,
_toobarTable2.default,
_index14.default,
_index16.default,
_page2.default,
_index8.default,
_index4.default,
_splitPanel2.default,
_tree2.default,
_pagination2.default,
_index10.default,
_uploadTable2.default,
_dialog2.default,
_processChartEditor2.default,
_rightMenu2.default,
_htmlEditor2.default,
_formulaGenerator2.default,
_ntkoEditor2.default,
_ntkoAttachment2.default,
_userFiledSelection2.default,
_index18.default,
_mdeditor2.default];

var uploading = void 0;
var install = {
    install: function install(Vue) {
        components.map(function (component) {
            Vue.component(component.name, component);
        });
        Vue.prototype.mwRef = function (obj) {
            return eval('this.$refs.' + obj);
        };
        Vue.prototype.mwMsg = function (arg1, arg2) {
            if (!arg2) {
                arg2 = arg1;
                arg1 = 'success';
            }
            this.$message({ type: arg1, duration: 2000, message: arg2, showClose: true });
        };
        Vue.prototype.mwLoadingClose = function () {
            uploading.close();
        };
        Vue.prototype.mwUrl = function (url) {
            return $servicePath + url;
        };
        Vue.prototype.mwLoading = function (options) {
            if (options == undefined) {
                options = "加载中...";
            }
            if ((typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) == 'object') {
                uploading = this.$loading(options);
                return uploading;
            }
            uploading = this.$loading({
                lock: true,
                text: options,
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255,255, 0.8)' });

        };
        Vue.prototype.mwConfirm = function (msg, prompt, type) {

            if ((typeof type === 'undefined' ? 'undefined' : (0, _typeof3.default)(type)) == 'object') {
                return this.$confirm(msg, prompt, type);
            } else {
                if (!prompt) {
                    prompt = $lang('提示');
                }
                if (!type) {
                    type = 'warning';
                }
                return this.$confirm(msg, prompt, {
                    closeOnClickModal: false,
                    confirmButtonText: $lang('确定'),
                    cancelButtonText: $lang('取消'),
                    type: type });

            }
        };
        Vue.prototype.mwUtil = _util4.default;
        Vue.prototype.mwConfig = _config4.default;
        var api = {


            postUrl: _com2.default.ajax,
            post: _util2.default.ajax,
            get: _util2.default.ajaxGet,
            app: _app2.default,
            free: _free2.default,
            common: _common2.default,
            business: _business2.default,
            com: _com2.default,
            config: _config2.default,
            data: _data2.default,
            org: _org2.default,
            process: _process2.default,
            job: _job2.default,
            oa: _oa2.default,
            oasrv: _oaSrv2.default,
            maintain: _maintain2.default,
            filemanager: _fileManager2.default };



        Vue.prototype.mwApi = api;


        if (!MW.mwApi) {
            MW.ns("MW.mwApi");
        }



        MW.mwApi = api;
        MW.invoke = _com2.default.invoke;
        MW.invokeInner = _com2.default.invokeInner;
        MW.ajax = _com2.default.ajax;
        Vue.prototype.mwLodash = _lodash2.default;


        if (!window.PF) {
            window.PF = {};
        }
        PF.token = _token2.default;
        PF.encode = MW.encode;
        PF.decode = MW.decode;

        PF.apply = MW.apply;
        PF.applyIf = MW.applyIf;
        PF.Object = MW.Object;
        PF.isNumber = MW.isNumber;


        PF.ns = MW.ns;
        if (!PF.api) {
            PF.ns("PF.api");
        }
        PF.api = api;
        PF._ = _lodash2.default;
        PF.invoke = _com2.default.invoke;
        PF.fsrv = function (url) {var _PF;
            if (url.indexOf('s:') != 0) url = "s:" + url;for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {args[_key - 1] = arguments[_key];}
            return (_PF = PF).invoke.apply(_PF, [url].concat(args));
        };

        PF.srv = function (url) {
            if (url.indexOf("/") === -1) {
                url = window.$servicePath + "/cheetah/service/" + url;
            }for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {args[_key2 - 1] = arguments[_key2];}
            return _util2.default.ajax.apply(_util2.default, [url].concat(args));
        };
        PF.invokeInner = _com2.default.invokeInner;




        PF.invokeAction = function (action, context) {
            PF.action[action](context);
        };

        PF.invokeFormAction = _invokeFormAction2.default;


        PF.ajax = _com2.default.ajax;
        PF.downloadAttachment = _util4.default.downloadAttachment;
        PF.downloadAttachment2 = _util4.default.downloadAttachment2;
        PF.url = function (url) {
            return $servicePath + url;
        };

        PF.func = {
            bpm: _BpmFunction2.default,
            view: _viewFunction2.default };

        PF.screenfull = function () {
            if (!_screenfull2.default.enabled) {
                this.$message({
                    message: '你的浏览器不支持',
                    type: 'warning' });

                return false;
            }
            _screenfull2.default.toggle();
        };

        PF.message = function (arg1, arg2) {
            var retObj = void 0;
            if ((typeof arg1 === 'undefined' ? 'undefined' : (0, _typeof3.default)(arg1)) === 'object') {
                retObj = Vue.prototype.$message(arg1);
            } else {
                if (!arg2) {
                    arg2 = arg1;
                    arg1 = 'success';
                }
                retObj = Vue.prototype.$message({ type: arg1, duration: 2000, message: arg2, showClose: true });
            }
            if (!arg1.noShim) {
                setTimeout(function () {
                    $("body>div.el-message").each(function () {
                        if ($(this).find('iframe').length === 0) {
                            $(this).prepend($("<iframe></iframe>").css({
                                width: 'calc(100% + 20px)',
                                height: '60px',
                                margin: "-25px 0 0 -20px",
                                "z-index": -1,
                                border: '0px',
                                position: "absolute" }));

                        }
                    });
                }, 50);
            }
            return retObj;
        };
        PF.shimMsgBox = function () {
            $("body>div.el-message-box__wrapper").each(function () {
                if ($(this).find('iframe').length === 0) {
                    $(this).prepend($("<iframe></iframe>").css({
                        width: '100%',
                        height: '100%',
                        "z-index": -1,
                        border: '0px',
                        position: "absolute" }));

                }
            });
        };
        PF.confirm = function (msg, prompt, type) {
            if ((typeof type === 'undefined' ? 'undefined' : (0, _typeof3.default)(type)) == 'object') {
                var o = Vue.prototype.$confirm(msg, prompt, type);
                PF.shimMsgBox();
                return o;
            } else {
                if (!prompt) {
                    prompt = $lang('提示');
                }
                if (!type) {
                    type = 'warning';
                }
                var _o = Vue.prototype.$confirm(msg, prompt, {
                    closeOnClickModal: false,
                    confirmButtonText: $lang('确定'),
                    cancelButtonText: $lang('取消'),
                    type: type });

                PF.shimMsgBox();
                return _o;
            }
        };
        PF.alert = function (msg, title, fn) {
            if (_lodash2.default.isFunction(fn)) {
                var o = Vue.prototype.$alert(msg, title, {
                    confirmButtonText: '确定',
                    callback: fn });

                PF.shimMsgBox();
                return o;
            } else {
                var _o2 = Vue.prototype.$alert(msg, title, fn);
                PF.shimMsgBox();
                return _o2;
            }

        };
        PF.loading = function (options) {
            if (options == undefined) {
                options = "加载中...";
            }
            if ((typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) == 'object') {
                uploading = Vue.prototype.$loading(options);
                return uploading;
            }
            uploading = Vue.prototype.$loading({
                lock: true,
                text: options,
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255,255, 0.8)' });

            setTimeout(function () {
                $("body>div.el-loading-mask").each(function () {
                    if ($(this).find('iframe').length === 0) {
                        $(this).prepend($("<iframe></iframe>").css({
                            width: '100%',
                            height: '100%',
                            "z-index": -1,
                            border: '0px',
                            position: "absolute" }));

                    }
                });
            }, 50);
            return uploading;
        };

        PF.prompt = function (msg, prompt, type) {
            var retObj = void 0;
            if ((typeof type === 'undefined' ? 'undefined' : (0, _typeof3.default)(type)) === 'object') {
                retObj = Vue.prototype.$prompt(msg, prompt, type);
            } else {
                if (!prompt) {
                    prompt = '提示';
                }
                if (!type) {
                    type = 'text';
                }
                retObj = Vue.prototype.$prompt(msg, prompt, {
                    closeOnClickModal: false,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: type });

            }
            PF.shimMsgBox();
            return retObj;
        };

        PF.contextMenu = function (config) {
            var Comp = Vue.extend(_rightMenu2.default);
            var comp = new Comp({
                propsData: {
                    popItems: config.items } });


            var el = $(comp.$mount().$el).appendTo(document.body);
            var event = void 0;
            comp.$on("ListItemClick", function (index, item) {
                hide();

                if (item && (item.action || item.handler)) {
                    (item.action || item.handler).call(item.scope, event);
                }
            });
            function hide() {
                comp.close();
                if (config.autoDestroy) {
                    setTimeout(function () {destroy();}, 500);
                }
            }
            if (config.el) {var
                showMenu = function showMenu(e) {
                    e.preventDefault();
                    var x = e.pageX;
                    var y = e.pageY;
                    comp.show(x, y);
                };

                $(config.el).contextmenu(function (e) {
                    event = e;
                    function contains(cls, child) {
                        var f = false;
                        $(config.el).find(cls).each(function () {
                            if ($.contains(this, child)) f = true;
                        });
                        return f;
                    }
                    if (config.target && !$(e.target).is(config.target) &&
                    !(config.targetContains && contains(config.target, e.target))) return;
                    if (config.excludeTarget && (
                    $(e.target).is(config.excludeTarget) ||
                    contains(config.excludeTarget, e.target))) return;
                    showMenu(e);
                });

            }
            $(document.body).on("mousedown.contextmenu", hide);
            $(config.el).on("mousedown.contextmenu", hide);
            function destroy() {
                $(document.body).off("mousedown.contextmenu", hide);
                $(config.el).off("mousedown.contextmenu", hide);
                comp.$destroy();
                el.remove();
            }
            return {
                destroy: destroy,
                hide: hide,
                show: function show(x, y) {comp.show(x, y);} };

        };
        PF.requireJs = function (scripts, callback) {
            _scriptLoader2.default.requireJs(scripts, callback);
        };
        PF.loadCss = function (urls) {
            _scriptLoader2.default.loadCss(urls);
        };
        PF.dialog = function (comp, config) {
            if (typeof comp === "string") {
                var Comp = Vue.component(comp);
                if (!Comp) {
                    return PF.message("没找到注册的组件:" + comp);
                }
                comp = Comp;
            }
            var attributeHtml = "";
            if (config.propsData) {
                (0, _keys2.default)(config.propsData).forEach(function (key) {
                    attributeHtml += ' :' + key + '="' + key + '" ';
                });
            }
            if (config.eventDatas) {
                (0, _keys2.default)(config.eventDatas).forEach(function (key) {
                    attributeHtml += ' @' + key + '="' + key + '" ';
                });
            }
            var buttons = config.footerButton || config.buttons || config.btns;
            if (buttons) {
                buttons.forEach(function (btn) {
                    var fn = btn.func || btn.handler;
                    delete btn.handler;
                    btn.func = function () {
                        var comp = dlg.$refs.comp;
                        fn.call(dlg, comp);
                    };
                });
            }
            var dlg = PF.createVue({
                template: '<mwDialog ref="d"\n              title=' +
                config.title + '\n              :beforeClose="beforeClose"\n              size="' + (

                config.size || "full") + '"\n              width="' + (
                config.width || "") + '"\n              height="' + (
                config.height || "") + '"\n              :footerButton="footerButton"\n              @opened="opened"\n              >\n              <comp ref="comp" ' +



                attributeHtml + '></comp>\n            </mwDialog>',

                data: (0, _extends3.default)({ footerButton: buttons }, config.propsData),
                methods: (0, _extends3.default)({
                    beforeClose: function beforeClose() {
                        var me = this;
                        me.$emit("beforeclose", this.$refs.comp);
                        setTimeout(function () {
                            $(me.$el).remove();
                            me.$destroy();
                        }, 200);
                    },
                    opened: function opened() {
                        this.$emit("opened", this.$refs.comp);
                    },
                    close: function close() {
                        this.beforeClose();
                        this.$refs.d.hide();
                    } },
                config.eventDatas),

                mounted: function mounted() {

                },
                components: { comp: comp } });

            dlg.$mount();
            $(dlg.$el).appendTo(document.body);

            dlg.$refs.d.show();
            return dlg;
        };
        PF.showMarkdown = function (config) {
            return PF.dialog(_mdeditor2.default, config);
        };
        PF.showHelp = function (config) {
            if (!config.markdown && config.url) {
                $.get(config.url, function (res) {
                    config = (0, _extends3.default)({ markdown: res }, config);
                    config.url = null;
                    PF.showHelp(config);
                });
                return;
            }
            return PF.showMarkdown({
                title: config.title || "帮助",
                size: "page",
                propsData: {
                    mode: "display",
                    markdown: config.markdown } });


        };
        PF.getApplicationPath = function () {
            return window.$servicePath || "";
        };
        PF.getServicePath = function () {
            return PF.getApplicationPath() + "/service";
        };
        PF.eval = function (exp, context, scope) {
            if (typeof exp === 'string') {

                var body = '\n            var v;\n              try {\n                context=context||{};\n                with(context) {\n                  v = eval(exp);\n                }\n              } catch(e) {}\n              return v;\n            ';









                var fn = new Function("exp", "context", body);
                return fn.call(scope, exp, context);
            }
        };

        PF.formulaGenerator = function (config, callback) {
            var dlg = PF.dialog("mw-formula-generator", {
                title: "表达式生成",
                width: 800,
                height: 420,
                propsData: config });

            dlg.$on("opened", function (comp) {
                comp.$on("ok", function (data) {
                    callback(data);
                });
            });
        };

        PF.treeSelect = function (config, callback) {
            PF.dialog("MwTree", {
                title: $lang(config.title || "请选择"),
                width: config.width || 400,
                height: config.height || 500,
                propsData: {
                    multiple: config.multiple === undefined ? false : config.multiple,
                    multipleLeaf: config.multipleLeaf === undefined ? false : config.multipleLeaf,
                    expandedFirst: true,
                    treeData: config.data,
                    checkNodes: config.checkNodeIds || [] },

                eventDatas: {
                    dblClick: function dblClick(row, parent) {
                        if (_lodash2.default.isFunction(config.dblClick)) {
                            config.dblClick(row, parent);
                            this.close();
                        }
                    } },

                footerButton: [{
                    label: $lang("确定"),
                    func: function func(tree) {
                        var nodes = tree.getSelected();
                        if (callback) callback(nodes);
                        this.close();
                    } },
                {
                    label: $lang("关闭"),
                    func: function func(tree) {
                        this.close();
                    } }] });


        };
        PF.selectComponent = function (config, callback) {
            PF.show('treeTable', {
                url: PF.url("/api/app/listApplicationTree"), size: 'small_large', treeDefaultParams: { category: config.category },
                selectFirst: !!config.selectFirst, clearBtn: !!config.clearBtn, title: config.title || '选择', changed: function changed(data) {
                    var me = this;
                    me.defaultParams = { category: config.category, applicationId: data.id, simpleResult: config.simpleResult === undefined ? true : config.simpleResult };
                }, api: 'app.getAppModuleItems', singleSelect: !!config.singleSelect },

            function (res) {
                if (callback) callback(res);
            });
        };
        PF.openCenterWindowUrl = function (address, obj, widthx, hightx, onClose, openCallBack, showModalDialog) {
            if (!widthx && !hightx) {
                var isFullScreen = true;
            } else {
                isFullScreen = false;
                var windowhight = hightx;
                var windowwidth = widthx;
                var top = 0;
                if (windowhight && windowhight > 0) {
                    top = (window.screen.availHeight - windowhight) / 2;
                } else {
                    windowhight = window.screen.availHeight - (window.$Env && $Env.openWindowHeight || 60);
                }
                var left = (window.screen.availWidth - windowwidth) / 2;
            }
            var features = "scrollbars=1,status=no,toolbar=no,menubar=no,location=no,resizable=yes";
            var win;
            if (window.showModalDialog && showModalDialog) {
                features = features.replace(',', ';');
                win = window.showModalDialog(address, obj, 'dialogHeight =' + hightx + 'px;dialogWidth=' + widthx + 'px;' + features);
            } else
            win = window.open(address, obj, 'Height=' + windowhight + ',Left=' + left + ',Top=' + top + ',Width=' + windowwidth + ',' + features);
            if ($.isFunction(openCallBack)) {
                openCallBack.call(win);
            }
            if (isFullScreen) {
                win.moveTo(0, 0);
                win.resizeTo(screen.availWidth, screen.availHeight);
            }
            if ($.isFunction(onClose)) {PF.onWindowClose(win, onClose);}
            return win;
        };
        PF.onWindowClose = function (win, callback) {
            if (!win) return;
            var timer;
            function ifWindowClosed() {
                try {
                    if (win.closed === true) {
                        clearInterval(timer);
                        callback(win);
                        win = null;
                    }
                } catch (e) {
                    if (timer) {
                        win = null;
                        clearInterval(timer);
                    }
                }
            }
            timer = window.setInterval(ifWindowClosed, 500);
        };
        PF.urlAppend = function (url, params) {
            if ((typeof params === 'undefined' ? 'undefined' : (0, _typeof3.default)(params)) === "object") {var
                stringify = function stringify(o) {
                    if ($.isPlainObject(o) || $.isArray(o)) {
                        return (0, _stringify2.default)(o);
                    } else {
                        return o;
                    }
                };
                params = _lodash2.default.chain(params).mapValues(function (v) {return encodeURIComponent(stringify(v));}).toPairs().
                map(_lodash2.default.partial(_lodash2.default.join, _lodash2.default, "=")).join("&").value();
            }
            return url + (url.indexOf("?") > -1 ? "&" : "?") + params;
        };
        PF.initPupload = function (config, fn, callback) {
            var maxSize = config.maxSize || 10;
            PF.requireJs(["/assets/js/Plupload/js/plupload.full.min.js"], function () {
                var cfg = {
                    runtimes: 'gears,html5,flash,silverlight,browserplus,html4',
                    browse_button: config.buttonId,
                    max_file_size: maxSize + 'mb',
                    unique_names: true,
                    url: config.action || PF.url('/api/business/uploadAttachment'),
                    multi_selection: config.multi ? true : false,
                    flash_swf_url: '/assets/js/Plupload/js/Moxie.swf',
                    silverlight_xap_url: '/assets/js/Plupload/js/Moxie.xap' };

                if (config.accept) {
                    cfg.filters = {
                        mime_types: [
                        { title: config.title || "自定义文件", extensions: config.accept }] };


                }
                var uploader = new plupload.Uploader(cfg);
                uploader.bind('Init', function (up) {
                    if (fn && fn.init) {
                        fn.init(up, files);
                    }
                });
                uploader.bind('UploadFile', function (up, file) {
                    if (fn && fn.uploadFile) {
                        return fn.uploadFile(up, file);
                    }
                });

                uploader.bind('FilesAdded', function (up, files) {
                    if (fn && fn.filesAdded) {
                        fn.filesAdded(up, files);
                    } else {
                        uploader.setOption("multipart_params", config.params);
                        if (config.autoUpload && config.autoUpload === false) return;
                        uploader.start();
                    }
                });
                uploader.bind('UploadProgress', function (up, file) {
                    if (fn && fn.uploadProgress)
                    fn.uploadProgress(up, file);
                });
                uploader.bind('FileUploaded', function (up, file, re) {
                    if (fn && fn.fileUploaded) {
                        var resp = $.parseJSON(re.response);
                        fn.fileUploaded(up, file, resp);
                    }
                });
                uploader.bind('UploadComplete', function (up, files) {
                    if (fn && fn.handleSuccess)
                    fn.handleSuccess(up, files);
                });
                uploader.bind('Error', function (up, err) {
                    if (err.response) {
                        var response = JSON.parse(err.response);
                        if (response && response.result) {
                            PF.message(response.result.msg);
                        }
                    } else {
                        if (err.message.indexOf("File size error") != -1)
                        PF.message($lang('上传附件大小不能超过') + maxSize + 'MB!');else
                        if (err.message.indexOf("File extension error") != -1)
                        PF.message($lang("只能上传文件类型:") + " " + config.accept);else

                        PF.message(err.code + ":" + err.message + (err.file ? ", File: " + err.file.name : ""));}
                    up.refresh();
                });
                uploader.init();
                if (callback)
                callback(uploader);
            });
        };
        PF.walkTree = function (items, subKey, fn) {
            if (!items) return;
            if (typeof subKey === 'function') {
                fn = subKey;
                subKey = 'children';
            }
            items.forEach(function (it) {
                fn(it);
                PF.walkTree(it[subKey], subKey, fn);
            });
        };
        PF.selectDepartment = function (config, callback) {
            var defaultParams = {
                deep: true,
                isContainSelf: !config.excludeSelf,
                parentId: config.parentId,
                flags: config.flag };

            PF.show('tree', {
                url: PF.url("/api/org/listDepartmentTree"),
                defaultParams: defaultParams,
                checkNodes: config.checkNodes,
                search: !!config.search,
                multiple: config.multiple,
                selectFirst: !!config.selectFirst,
                clearBtn: config.showClearBtn,
                singleLeaf: config.singleLeaf },

            function (res) {
                if (callback) {callback(res);}
            });

        };

        Vue.prototype.moment = window.moment;

    } };exports.default =



install;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(18);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(778);
module.exports = __webpack_require__(18).Object.keys;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(88);
var $keys = __webpack_require__(106);

__webpack_require__(194)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var func = {



  exportComponentByIds: function exportComponentByIds(a) {
    if (a.length == 0) {
      PF.message('warning', '请选择需要导出的数据');
      return;
    }
    var ids = [];
    a.forEach(function (v) {
      ids.push(v.id);
    });
    PF.api.app.exportComponentByIds(ids);
  },

  importComponentByIds: function importComponentByIds(a, b) {
    PF.show('importComp', {}, function (v) {
      b.refreshTable();
    });
  } };exports.default =



func;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var func = {



  showFlowImage: function showFlowImage(a) {

    if (a.processDefinitionId) {
      var p = { batchId: a.batchId, processDefinitionId: a.processDefinitionId, applicationId: a.applicationId };
      PF.show('processChartViewer', p);
      return;
    }

    PF.api.process.getLatestProcessData(a).then(function (res) {
      if (res.success) {
        var processDefinitionId = res.result.processDefinitionId;
        var batchId = res.result.batchId;
        if (null != processDefinitionId) {
          var _p = { batchId: batchId, processDefinitionId: processDefinitionId, applicationId: a.applicationId };
          PF.show('processChartViewer', _p);
        }
      }
    });
  },
  showFlowInterfering: function showFlowInterfering(a) {
    if (!a.businessName && !a.businessId) {
      PF.message('info', $lang('标题或业务ID不能为空!'));
      return;
    }
    PF.show('processInterfering', a);
  },



  showFlowProcess: function showFlowProcess(a) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要查看办理过程的文件'));
      return;
    }
    if (a.length > 1) {
      PF.message('info', $lang('请选择一条需要查看办理过程的文件'));
      return;
    }
    PF.show('transactionProcess', { batchId: a[0].batchId, taskId: a[0].id });
  },




  showFlowWorkTrack: function showFlowWorkTrack(a) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要查看运转跟踪的文件'));
      return;
    }
    if (a.length > 1) {
      PF.message('info', $lang('请选择一条需要查看运转跟踪的文件'));
      return;
    }
    PF.show('flowWorktrack', { taskId: a[0].id, appId: a[0].applicationId, formId: a[0].formEntityKey, businessId: a[0].businessId });
  },





  abGrab: function abGrab(a, b) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要抢办的数据'));
      return;
    }
    var taskIds = [];
    a.forEach(function (t) {
      taskIds.push(t.id);
    });
    PF.api.process.batchAbGrab(taskIds).then(function (res) {
      if (res.success) {
        b.refreshTable();
      }
    });
  },



  batchCommitCircular: function batchCommitCircular(a, b) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要阅毕的数据'));
      return;
    }
    var taskIds = [];
    a.forEach(function (t) {
      taskIds.push(t.id);
    });
    PF.api.process.batchCommitCircular(taskIds).then(function (res) {
      if (res.success) {
        b.refreshTable();
      }
    });
  },



  batchTransfer: function batchTransfer(a, b) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要转办的文件'));
      return;
    }
    var taskIds = [];
    a.forEach(function (t) {
      taskIds.push(t.id);
    });
    PF.show('turnProcess', { taskIds: taskIds }, function (params) {
      PF.api.process.batchTransfer(taskIds, params).then(function (res) {
        var data = res.result;
        if (data && !data.success) {
          if (data.errorType === "comment") {
            if (data.errorCode === 'comment_check_stop') {
              PF.message('info', $lang('当前环节存在必填意见环节,不支持批量办理!'));
              return;
            } else if (data.errorCode === 'comment_check_remind') {
              PF.message('info', $lang('当前环节存在提示填写意见环节,不支持批量办理!'));
              return;
            }
          } else {
            var errorMsg = '';
            if (data.errorMsg) {
              errorMsg = '[错误信息:' + data.errorMsg + ']';
            }
            PF.message('info', $lang('转办失败' + errorMsg + '!'));
            return;
          }
        } else if (res.success) {
          PF.message($lang('转办成功'));
          b.refreshTable();
        }
      });
    });
  },



  taken: function taken(a, b) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要取回的文件'));
      return;
    }
    if (a.length > 1) {
      PF.message('info', $lang('请选择一条需要取回的文件'));
      return;
    }
    var param = { containClaimed: true };
    var takenParam = {};
    if (b && b.fullAuthType) {
      param.fullAuthType = b.fullAuthType;
      takenParam.fullAuthType = b.fullAuthType;
    }

    PF.api.process.checkCanTaken(a[0].id, param).then(function (res) {
      if (res.success) {
        var result = res.result;
        if (!result.canTaken) {
          PF.message('info', $lang('此文件' + result.reason + '不可取回'));
          return;
        }
        var message = '';
        if (result.assignees) {
          message = $lang('{}已签收', null, $lang(result.assignees)) + ",";
        }
        PF.confirm(message + $lang('确定取回选中的文件吗？'), $lang('提示'), {
          type: 'warning' }).
        then(function () {
          PF.api.process.taken(a[0].id, takenParam).then(function (res) {
            if (res.success) {
              b.refreshTable();
            }
          });
        }).catch(function () {

        });
      }
    });
  },



  revoke: function revoke(a, b) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要撤办的文件'));
      return;
    }
    if (a.length > 1) {
      PF.message('info', $lang('请选择一条需要撤办的文件'));
      return;
    }
    var param = { containClaimed: true };
    PF.api.process.checkCanTaken(a[0].id, param).then(function (res) {
      if (res.success) {
        var result = res.result;
        if (!result.canTaken) {
          PF.message('info', $lang('此文件' + result.reason + '不可撤办'));
          return;
        }
        var message = '';
        if (result.assignees) {
          message = result.assignees + '已签收,';
        }
        PF.confirm($lang(message + '确定撤办选中的文件吗？'), $lang('提示'), {
          type: 'warning' }).
        then(function () {
          PF.api.process.taken(a[0].id).then(function (res) {
            if (res.success) {
              b.refreshTable();
            }
          });
        }).catch(function () {

        });
      }
    });
  },



  transmit: function transmit(a, b) {
    PF.message('info', $lang('此功能将在后期开发，请耐心等待...'));
  },



  cancelDelegation: function cancelDelegation(a, b) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要取消委托的文件'));
      return;
    }
    if (a.length > 1) {
      PF.message('info', $lang('请选择一条需要取消委托的文件'));
      return;
    }
    PF.confirm($lang('确定取消委托选中的文件吗？'), $lang('提示'), {
      type: 'warning' }).
    then(function () {
      PF.api.process.resolve(a[0].id, { checkGoOut: false }).then(function (res) {
        if (res.success) {
          b.refreshTable();
        }
      });
    }).catch(function () {

    });
  },



  returnClient: function returnClient(a, b) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要交还委托人的文件'));
      return;
    }
    if (a.length > 1) {
      PF.message('info', $lang('请选择一条需要交还委托人的文件'));
      return;
    }
    PF.confirm($lang('确定把选中的文件交还委托人吗？'), $lang('提示'), {
      type: 'warning' }).
    then(function () {
      PF.api.process.resolve(a[0].id, { checkGoOut: true }).then(function (res) {
        if (res.success) {
          b.refreshTable();
        }
      });
    }).catch(function () {

    });
  },



  suspend: function suspend(a, b, key) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要挂起的文件'));
      return;
    }
    var params = [];
    a.forEach(function (t) {
      params.push({
        moduleId: t.moduleId,
        businessId: t.businessId,
        taskId: t.id });

    });
    PF.confirm($lang('确定挂起选中的文件吗？'), $lang('提示'), {
      type: 'warning' }).
    then(function () {
      PF.api.process.batchSuspendReleaseWH(params).then(function (res) {
        if (res.success) {
          b.refreshTable();
          b.refreshBtnSum('recycle', key);
        }
      }).catch(function () {
      });
    }).catch(function () {
    });
  },



  activate: function activate(a, b) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要恢复的文件'));
      return;
    }
    var businesses = [];
    a.forEach(function (t) {
      businesses.push({ businessId: t.businessId, batchId: t.batchId, draftsDocId: t.draftsDocId, moduleId: t.moduleId });
    });
    PF.confirm($lang('确定恢复选中的文件吗？'), $lang('提示'), {
      type: 'warning' }).
    then(function () {
      PF.api.process.batchActivate(businesses).then(function (res) {
        if (res.success) {
          b.refreshTable();
        }
      });
    }).catch(function () {

    });
  },
  markDelete: function markDelete(a, b) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要删除的文件'));
      return;
    }
    var businesses = [];
    a.forEach(function (t) {
      businesses.push({ businessId: t.businessId, draftsDocId: t.draftsDocId, batchId: t.batchId, formEntityKey: t.formEntityKey, moduleId: t.moduleId });
    });
    PF.confirm($lang('您确定删除选中的文件吗？'), $lang('提示'), {
      type: 'warning' }).
    then(function () {
      PF.api.process.batchMarkDelete(businesses).then(function (res) {
        if (res.success) {
          b.refreshTable();
        }
      });
    }).catch(function () {

    });
  },



  thoroughDelete: function thoroughDelete(a, b) {
    PF.message('info', $lang('此功能将在后期开发，静待...'));



















  },




  continuousTodo: function continuousTodo() {
    PF.show("page", { id: "5a0fc6dcc3574e67" });
  },




  attention: function attention(a, b) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要关注的文件'));
      return;
    }
    var add_taskIds = [];
    var del_draftsDocIds = [];
    a.forEach(function (t) {
      if (t.attentionStatus) {
        del_businessIds.push(t.draftsDocId);
      } else {
        add_taskIds.push(t.id);
      }
    });
    if (add_taskIds.length > 0 && del_draftsDocIds.length > 0) {
      PF.api.business.removeAttentionByBusiness(del_draftsDocIds).then(function (res) {
        if (res.success) {
          return PF.api.business.addAttention(add_taskIds);
        }
      }).then(function (res) {
        if (res.success) {
          b.refreshTable();
        }
      });
    } else if (add_taskIds.length > 0) {
      PF.api.business.addAttention(add_taskIds).then(function (res) {
        if (res.success) {
          b.refreshTable();
        }
      });
    } else {
      PF.api.business.removeAttentionByBusiness(del_draftsDocIds).then(function (res) {
        if (res.success) {
          b.refreshTable();
        }
      });
    }
  },



  removeAttention: function removeAttention(a, b) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要取消关注的文件'));
      return;
    }
    var ids = a.map(function (item) {return item.id;});
    PF.api.business.removeAttention(ids).then(function (res) {
      if (res.success) {
        b.refreshTable();
      }
    });
  },



  urge: function urge(a, b) {
    if (a.length == 0) {
      PF.message('info', $lang('请选择需要催办的文件'));
      return;
    }
    if (a.length > 1) {
      PF.message('info', $lang('请选择一条需要催办的文件'));
      return;
    }
    var r = a[0];
    var id = r.id;
    if (r.type == 4 && r.yzStatus) id = r.yzStatus;
    PF.api.process.checkAllCanUrge(a[0].batchId, id).then(function (res) {
      if (res.success) {
        var result = res.result;
        if (!result.canUrge) {
          PF.message('info', $lang('此文件不可催办'));
          return;
        }
        PF.show('urgeProcess', { data: result.tasks, businessName: a[0].businessName }, function (data) {
          PF.api.business.addUrge(data).then(function (res) {
            if (res.success) {
              PF.message($lang('催办成功'));
            }
          });
        });
      }
    });
  } };exports.default =


func;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _vbox = __webpack_require__(782);var _vbox2 = _interopRequireDefault(_vbox);
var _vboxDesigner = __webpack_require__(269);var _vboxDesigner2 = _interopRequireDefault(_vboxDesigner);
var _vboxEditor = __webpack_require__(271);var _vboxEditor2 = _interopRequireDefault(_vboxEditor);

var _hbox = __webpack_require__(789);var _hbox2 = _interopRequireDefault(_hbox);
var _hboxDesigner = __webpack_require__(274);var _hboxDesigner2 = _interopRequireDefault(_hboxDesigner);
var _hboxEditor = __webpack_require__(276);var _hboxEditor2 = _interopRequireDefault(_hboxEditor);

var _itemWrapper = __webpack_require__(796);var _itemWrapper2 = _interopRequireDefault(_itemWrapper);
var _itemWrapperDesigner = __webpack_require__(279);var _itemWrapperDesigner2 = _interopRequireDefault(_itemWrapperDesigner);
var _itemWrapperEditor = __webpack_require__(281);var _itemWrapperEditor2 = _interopRequireDefault(_itemWrapperEditor);

var _compWrapper = __webpack_require__(803);var _compWrapper2 = _interopRequireDefault(_compWrapper);

var _manager = __webpack_require__(818);var _manager2 = _interopRequireDefault(_manager);
var _layoutRenderer = __webpack_require__(823);var _layoutRenderer2 = _interopRequireDefault(_layoutRenderer);
var _vue = __webpack_require__(11);var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

[_manager2.default,
_layoutRenderer2.default,
_vbox2.default, _vboxDesigner2.default, _vboxEditor2.default,
_hbox2.default, _hboxDesigner2.default, _hboxEditor2.default,
_itemWrapper2.default, _itemWrapperDesigner2.default, _itemWrapperEditor2.default,
_compWrapper2.default].
forEach(function (component) {
  _vue2.default.component(component.name, component);
});

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4902df38_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_vbox_vue__ = __webpack_require__(784);
function injectStyle (ssrContext) {
  __webpack_require__(783)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4902df38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vbox_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4902df38_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_vbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ct",staticClass:"vbox-container",class:_vm.params.className,style:({padding:_vm.params.padding})},_vm._l((_vm.params.rows),function(row,index){return _c('div',{key:index,ref:"rows",refInFor:true,staticClass:"vbox-row",class:row.className,style:({height:row.height,'padding-top':row.paddingTop,'paddingBottom':row.paddingBottom})},_vm._l((row.items),function(item){return _c('div',{staticClass:"vbox-item",style:({width:item.width || '100%'})},[_c(item.xtype,{tag:"component",attrs:{"params":item}})],1)}),0)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ct",staticClass:"vbox-container",class:_vm.params.className,style:({padding:_vm.params.padding})},[_c('div',{staticClass:"handler"}),_vm._v(" "),_c('div',{staticClass:"vbox-row-ct"},_vm._l((_vm.params.rows),function(row,index){return _c('div',{key:index,ref:"rows",refInFor:true,staticClass:"vbox-row dragula-container"})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',[_c('el-form-item',{attrs:{"label":"名称"}},[_c('el-input',{model:{value:(_vm.data.name),callback:function ($$v) {_vm.$set(_vm.data, "name", $$v)},expression:"data.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"内边距(padding)"}},[_c('el-input',{model:{value:(_vm.data.padding),callback:function ($$v) {_vm.$set(_vm.data, "padding", $$v)},expression:"data.padding"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"样式类名(class)"}},[_c('el-input',{model:{value:(_vm.data.className),callback:function ($$v) {_vm.$set(_vm.data, "className", $$v)},expression:"data.className"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"样式(style)"}},[_c('el-input',{model:{value:(_vm.data.style),callback:function ($$v) {_vm.$set(_vm.data, "style", $$v)},expression:"data.style"}})],1),_vm._v(" "),_c('el-button-group',[_c('el-button',{attrs:{"type":"primary","icon":"fa fa-add"},on:{"click":_vm.addColumn}},[_vm._v("增加")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"fa fa-delete"},on:{"click":_vm.deleteColumn}},[_vm._v("删除")])],1),_vm._v(" "),_c('el-table',{ref:"table",staticStyle:{"width":"100%"},attrs:{"data":_vm.data.rows}},[_c('el-table-column',{attrs:{"type":"selection","width":"23"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"高度"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{model:{value:(scope.row.height),callback:function ($$v) {_vm.$set(scope.row, "height", $$v)},expression:"scope.row.height"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"上边距","width":"62"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{model:{value:(scope.row.paddingTop),callback:function ($$v) {_vm.$set(scope.row, "paddingTop", $$v)},expression:"scope.row.paddingTop"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"下边距","width":"62"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{model:{value:(scope.row.paddingBottom),callback:function ($$v) {_vm.$set(scope.row, "paddingBottom", $$v)},expression:"scope.row.paddingBottom"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"样式类","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{model:{value:(scope.row.className),callback:function ($$v) {_vm.$set(scope.row, "className", $$v)},expression:"scope.row.className"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"样式","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{model:{value:(scope.row.style),callback:function ($$v) {_vm.$set(scope.row, "style", $$v)},expression:"scope.row.style"}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_18e5c486_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_hbox_vue__ = __webpack_require__(791);
function injectStyle (ssrContext) {
  __webpack_require__(790)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18e5c486"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_hbox_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_18e5c486_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_hbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ct",staticClass:"hbox-container",class:_vm.params.className,style:({padding:_vm.params.padding})},_vm._l((_vm.params.columns),function(col,index){return _c('div',{key:index,ref:"columns",refInFor:true,staticClass:"hbox-column",class:{'fit-height':!_vm.params.dynamicHeight},style:({"padding-left":col.paddingLeft,"padding-right":col.paddingRight,width:col.width})},_vm._l((col.items),function(item){return _c('div',{staticClass:"hbox-item",style:({height:item.height || '100%'})},[_c(item.xtype,{tag:"component",attrs:{"params":item}})],1)}),0)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ct",staticClass:"hbox-container",class:_vm.params.className,style:({padding:_vm.params.padding})},[_c('div',{staticClass:"handler"}),_vm._v(" "),_vm._l((_vm.params.columns),function(col,index){return _c('div',{key:index,ref:"columns",refInFor:true,staticClass:"hbox-column dragula-container",class:{'fit-height':!_vm.params.dynamicHeight}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',[_c('el-form-item',{attrs:{"label":"名称"}},[_c('el-input',{model:{value:(_vm.data.name),callback:function ($$v) {_vm.$set(_vm.data, "name", $$v)},expression:"data.name"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-checkbox',{model:{value:(_vm.data.dynamicHeight),callback:function ($$v) {_vm.$set(_vm.data, "dynamicHeight", $$v)},expression:"data.dynamicHeight"}},[_vm._v("由内容撑开高度")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"内边距(padding)"}},[_c('el-input',{model:{value:(_vm.data.padding),callback:function ($$v) {_vm.$set(_vm.data, "padding", $$v)},expression:"data.padding"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"样式类名(class)"}},[_c('el-input',{model:{value:(_vm.data.className),callback:function ($$v) {_vm.$set(_vm.data, "className", $$v)},expression:"data.className"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"样式(style)"}},[_c('el-input',{model:{value:(_vm.data.style),callback:function ($$v) {_vm.$set(_vm.data, "style", $$v)},expression:"data.style"}})],1),_vm._v(" "),_c('el-button-group',[_c('el-button',{attrs:{"type":"primary","icon":"fa fa-add"},on:{"click":_vm.addColumn}},[_vm._v("增加")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"fa fa-delete"},on:{"click":_vm.deleteColumn}},[_vm._v("删除")])],1),_vm._v(" "),_c('el-table',{ref:"table",staticStyle:{"width":"100%"},attrs:{"data":_vm.data.columns}},[_c('el-table-column',{attrs:{"type":"selection","width":"23"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"宽度"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{model:{value:(scope.row.width),callback:function ($$v) {_vm.$set(scope.row, "width", $$v)},expression:"scope.row.width"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"左边距","width":"62"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{model:{value:(scope.row.paddingLeft),callback:function ($$v) {_vm.$set(scope.row, "paddingLeft", $$v)},expression:"scope.row.paddingLeft"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"右边距","width":"62"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{model:{value:(scope.row.paddingRight),callback:function ($$v) {_vm.$set(scope.row, "paddingRight", $$v)},expression:"scope.row.paddingRight"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"样式类","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{model:{value:(scope.row.className),callback:function ($$v) {_vm.$set(scope.row, "className", $$v)},expression:"scope.row.className"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"样式","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{model:{value:(scope.row.style),callback:function ($$v) {_vm.$set(scope.row, "style", $$v)},expression:"scope.row.style"}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_63e0577f_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_item_wrapper_vue__ = __webpack_require__(798);
function injectStyle (ssrContext) {
  __webpack_require__(797)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63e0577f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_item_wrapper_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_63e0577f_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_item_wrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"auto"},style:({width:_vm.params.width,height:(_vm.params.height||'100%'),padding:_vm.params.padding})},[(_vm.params.type==='page')?_c('mw-inner-page',{ref:"innerPage",attrs:{"noWrap":"","pageId":_vm.pageId,"pageData":_vm.params.pageData,"params":_vm.params}}):_vm._e(),_vm._v(" "),(_vm.params.type==='comp' && _vm.params.template)?_c('comp-wrapper',{attrs:{"params":_vm.params}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-wrapper"},[_c('item-wrapper',{ref:"wrapper",attrs:{"params":_vm.params,"data":_vm.data,"idField":"designerPageId"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.data.editorPageId)?_c('el-form',[_c('el-form-item',{attrs:{"label":"名称"}},[_c('el-input',{model:{value:(_vm.data.name),callback:function ($$v) {_vm.$set(_vm.data, "name", $$v)},expression:"data.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"宽度"}},[_c('el-input',{model:{value:(_vm.data.width),callback:function ($$v) {_vm.$set(_vm.data, "width", $$v)},expression:"data.width"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"高度"}},[_c('el-input',{model:{value:(_vm.data.height),callback:function ($$v) {_vm.$set(_vm.data, "height", $$v)},expression:"data.height"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"内边距(padding)"}},[_c('el-input',{model:{value:(_vm.data.padding),callback:function ($$v) {_vm.$set(_vm.data, "padding", $$v)},expression:"data.padding"}})],1)],1):_c('mw-inner-page',{attrs:{"noWrap":"","pageId":_vm.data.editorPageId,"params":_vm.data}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comp_wrapper_vue__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comp_wrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comp_wrapper_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comp_wrapper_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comp_wrapper_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_45d1af40_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_comp_wrapper_vue__ = __webpack_require__(817);
function injectStyle (ssrContext) {
  __webpack_require__(804)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45d1af40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comp_wrapper_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_45d1af40_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_comp_wrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(806), __esModule: true };

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(110);
__webpack_require__(96);
module.exports = __webpack_require__(807);


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(138);
var ITERATOR = __webpack_require__(30)('iterator');
var Iterators = __webpack_require__(97);
module.exports = __webpack_require__(18).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(110);
__webpack_require__(96);
module.exports = __webpack_require__(809);


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(57);
var get = __webpack_require__(195);
module.exports = __webpack_require__(18).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(193);
__webpack_require__(96);
__webpack_require__(110);
__webpack_require__(811);
__webpack_require__(815);
__webpack_require__(816);
module.exports = __webpack_require__(18).Promise;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(108);
var global = __webpack_require__(29);
var ctx = __webpack_require__(64);
var classof = __webpack_require__(138);
var $export = __webpack_require__(28);
var isObject = __webpack_require__(50);
var aFunction = __webpack_require__(104);
var anInstance = __webpack_require__(196);
var forOf = __webpack_require__(111);
var speciesConstructor = __webpack_require__(286);
var task = __webpack_require__(287).set;
var microtask = __webpack_require__(813)();
var newPromiseCapabilityModule = __webpack_require__(197);
var perform = __webpack_require__(288);
var userAgent = __webpack_require__(814);
var promiseResolve = __webpack_require__(289);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(30)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(198)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(109)($Promise, PROMISE);
__webpack_require__(290)(PROMISE);
Wrapper = __webpack_require__(18)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(291)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 812 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var macrotask = __webpack_require__(287).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(107)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(28);
var core = __webpack_require__(18);
var global = __webpack_require__(29);
var speciesConstructor = __webpack_require__(286);
var promiseResolve = __webpack_require__(289);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(28);
var newPromiseCapability = __webpack_require__(197);
var perform = __webpack_require__(288);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.compDef,{tag:"component"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_manager_vue__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_manager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_manager_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_manager_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_manager_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_cbd3d3b2_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_manager_vue__ = __webpack_require__(822);
function injectStyle (ssrContext) {
  __webpack_require__(819)
  __webpack_require__(820)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbd3d3b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_manager_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_cbd3d3b2_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_manager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _hboxDesigner = __webpack_require__(274);var _hboxDesigner2 = _interopRequireDefault(_hboxDesigner);
var _hboxEditor = __webpack_require__(276);var _hboxEditor2 = _interopRequireDefault(_hboxEditor);

var _vboxDesigner = __webpack_require__(269);var _vboxDesigner2 = _interopRequireDefault(_vboxDesigner);
var _vboxEditor = __webpack_require__(271);var _vboxEditor2 = _interopRequireDefault(_vboxEditor);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var widgets = [
{
  id: "widget-layout-hbox",
  xtype: "hbox",
  name: "列布局",
  builtIn: true,
  initData: { columns: [{ width: "50%" }, { width: "50%" }] },
  editorComp: _hboxEditor2.default,
  designerComp: _hboxDesigner2.default },

{
  id: "widget-layout-vbox",
  xtype: "vbox",
  name: "行布局",
  builtIn: true,
  initData: { rows: [{ height: "50%" }, { height: "50%" }] },
  editorComp: _vboxEditor2.default,
  designerComp: _vboxDesigner2.default }];exports.default =


widgets;

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticStyle:{"height":"100%"},attrs:{"gutter":10}},[_c('el-col',{staticStyle:{"height":"100%"},attrs:{"span":4}},[_c('div',{ref:"left",staticStyle:{"height":"100%"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideDefaultLayout),expression:"!hideDefaultLayout"}],ref:"left1",staticClass:"default-widget widget-container"},_vm._l((_vm.defaultWidgets),function(w){return _c('el-card',{key:w.name,staticClass:"box-card",attrs:{"widget":w.id}},[_c('i',{staticClass:"fa fa-th fa-lg"}),_vm._v(_vm._s(w.name)+"\n        ")])}),1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideCustomLayout),expression:"!hideCustomLayout"}],ref:"left2",staticClass:"custom-widget widget-container"},_vm._l((_vm.widgets),function(w){return _c('el-card',{key:w.name,ref:w.id,refInFor:true,staticClass:"box-card",attrs:{"info":w,"widget":w.id}},[_c('i',{staticClass:"fa fa-list-ul fa-lg"}),_vm._v(_vm._s(w.name)),(!w.builtIn && _vm.editmode)?_c('span',{staticStyle:{"float":"right","cursor":"pointer"},on:{"click":function($event){return _vm.removeWidget(w)}}},[_c('i',{staticClass:"fa fa-close fa-lg"})]):_vm._e()])}),1)])]),_vm._v(" "),_c('el-col',{staticStyle:{"height":"100%"},attrs:{"span":15}},[_c('div',{ref:"center",staticClass:"designer-container"})]),_vm._v(" "),_c('el-col',{staticStyle:{"height":"100%"},attrs:{"span":5}},[_c('div',{ref:"right",staticClass:"editor-container"},[(!!_vm.currentComp)?_c('h3',{staticStyle:{"padding-left":"20px"}},[_vm._v(_vm._s(_vm.currentComp.widgetName))]):_vm._e(),_vm._v(" "),(!!_vm.currentComp)?_c(_vm.currentComp.editorParams && _vm.currentComp.editorParams.xtype,{tag:"component",attrs:{"data":_vm.currentComp.data,"params":_vm.currentComp.editorParams}}):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_layout_renderer_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_layout_renderer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_layout_renderer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_layout_renderer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_layout_renderer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6cda0379_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_layout_renderer_vue__ = __webpack_require__(825);
function injectStyle (ssrContext) {
  __webpack_require__(824)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cda0379"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_layout_renderer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6cda0379_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_layout_renderer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},_vm._l((_vm.data),function(item,index){return _c(item.xtype,{key:index,tag:"component",attrs:{"params":item}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);
var bind = __webpack_require__(294);
var Axios = __webpack_require__(828);
var defaults = __webpack_require__(199);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(298);
axios.CancelToken = __webpack_require__(842);
axios.isCancel = __webpack_require__(297);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(843);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 827 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(199);
var utils = __webpack_require__(43);
var InterceptorManager = __webpack_require__(837);
var dispatchRequest = __webpack_require__(838);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(296);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);
var transformData = __webpack_require__(839);
var isCancel = __webpack_require__(297);
var defaults = __webpack_require__(199);
var isAbsoluteURL = __webpack_require__(840);
var combineURLs = __webpack_require__(841);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(298);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(845);
var $Object = __webpack_require__(18).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(28);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(51), 'Object', { defineProperty: __webpack_require__(49).f });


/***/ }),
/* 846 */
/***/ (function(module, exports) {

exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';

exports.homedir = function () {
	return '/'
};


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.











ajaxError = ajaxError;var _elementUi = __webpack_require__(141);var showMessage = false;function ajaxError(err, status, url) {
  if (!(window.location.href.indexOf('/login') > -1)) {
    if (url && (url.indexOf('loginUserInfo') > -1 || url.indexOf('logout') > -1)) {
      return;
    }
    if (err.response && err.response.status == 401 || err.response && err.response.data.indexOf('/login') > -1 || '401' == status) {
      if (window.$Env && $Env.sessionTimeoutToLogin) {
        window.location.href = "/logout";
      } else if (!showMessage) {
        showMessage = true;
        _elementUi.MessageBox.prompt('登录超时,请输入密码', {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          inputType: 'password',
          beforeClose: function beforeClose(action, instance, done) {
            if (action == 'confirm') {
              var value = instance.inputValue;
              if (PF.userInfo.developer) {
                this.mwApi.org.authenticateDev(PF.userInfo.loginId, value, true).then(function (res) {
                  if (res.success && res.result) {
                    showMessage = false;
                    done();
                  } else {
                    PF.message("error", '密码验证错误，请重新输入！');
                  }
                });
              } else {
                this.mwApi.org.authenticate(PF.userInfo.loginId, value, true).then(function (res) {
                  if (res.success && res.result) {
                    showMessage = false;
                    done();
                  } else {
                    PF.message("error", '密码验证错误，请重新输入！');
                  }
                });
              }
            }
          } }).
        then(function (_ref) {var value = _ref.value;

        }).catch(function () {

        });
      }
    } else if (err.response && err.response.status == 600 || err.response && err.response.data.indexOf('/login') > -1 || '600' == status) {
      if (!showMessage) {
        showMessage = true;
        _elementUi.MessageBox.prompt('此账号已在其他设备登录,请输入密码', {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          inputType: 'password',
          beforeClose: function beforeClose(action, instance, done) {
            if (action == 'confirm') {
              var value = instance.inputValue;
              if (PF.userInfo.developer) {
                this.mwApi.org.authenticateDev(PF.userInfo.loginId, value, true).then(function (res) {
                  if (res.success && res.result) {
                    showMessage = false;
                    done();
                  } else {
                    PF.message("error", '密码验证错误，请重新输入！');
                  }
                });
              } else {
                this.mwApi.org.authenticate(PF.userInfo.loginId, value, true).then(function (res) {
                  if (res.success && res.result) {
                    showMessage = false;
                    done();
                  } else {
                    PF.message("error", '密码验证错误，请重新输入！');
                  }
                });
              }
            }
          } }).
        then(function (_ref2) {var value = _ref2.value;

        }).catch(function () {

        });
      }
    } else {
      throw err;
    }
  }
}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _promise = __webpack_require__(19);var _promise2 = _interopRequireDefault(_promise);exports.default =































































































































































function (code) {var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
  return new _promise2.default(function (resolve, reject) {
    if (window.eslint) {
      var EsLint = new eslint();
      resolve(EsLint.verify(code, options));
    } else {
      PF.requireJs('/assets/js/eslint/eslint.min.js', function () {
        var EsLint = new eslint();
        resolve(EsLint.verify(code, options));
      });
    }
  });

};function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var defaultOptions = { "parserOptions": { "ecmaVersion": 5, "sourceType": "script", "ecmaFeatures": {} }, "rules": { "constructor-super": true, "for-direction": true, "getter-return": true, "no-case-declarations": true, "no-compare-neg-zero": true, "no-cond-assign": true, "no-console": false, "no-constant-condition": true, "no-control-regex": true, "no-debugger": false, "no-delete-var": true, "no-dupe-args": true, "no-dupe-class-members": true, "no-dupe-keys": true, "no-duplicate-case": true, "no-empty-character-class": true, "no-empty-pattern": true, "no-empty": true, "no-ex-assign": true, "no-extra-boolean-cast": true, "no-extra-semi": true, "no-fallthrough": true, "no-func-assign": true, "no-global-assign": true, "no-inner-declarations": true, "no-invalid-regexp": true, "no-irregular-whitespace": true, "no-mixed-spaces-and-tabs": false, "no-new-symbol": true, "no-obj-calls": true, "no-octal": true, "no-redeclare": true, "no-regex-spaces": true, "no-self-assign": true, "no-sparse-arrays": true, "no-this-before-super": true, "no-undef": true, "no-unexpected-multiline": true, "no-unreachable": true, "no-unsafe-finally": true, "no-unsafe-negation": true, "no-unused-labels": true, "no-unused-vars": false, "no-useless-escape": true, "require-yield": true, "use-isnan": true, "valid-typeof": true }, "env": { browser: true, es6: false, jquery: true } };

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var base = window.$servicePath;exports.default =


{

  updateUserPassword: function updateUserPassword() {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}
    return _util2.default.ajax.apply(_util2.default, [base + '/free/sys/updateUserPassword'].concat(args));
  },
  sendEmail: function sendEmail() {for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {args[_key2] = arguments[_key2];}
    return _util2.default.ajax.apply(_util2.default, [base + '/free/sys/sendEmail'].concat(args));
  },
  sendPhone: function sendPhone() {for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {args[_key3] = arguments[_key3];}
    return _util2.default.ajax.apply(_util2.default, [base + '/free/sys/sendPhone'].concat(args));
  },
  getUserByLoginId: function getUserByLoginId() {for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {args[_key4] = arguments[_key4];}
    return _util2.default.ajax.apply(_util2.default, [base + '/free/sys/getUserByLoginId'].concat(args));
  },
  register: function register() {for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {args[_key5] = arguments[_key5];}
    return _util2.default.ajax.apply(_util2.default, [base + '/api/sys/register'].concat(args));
  } };

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var base = window.$servicePath;exports.default =


{



  listAttention: function listAttention(params) {
    return _util2.default.ajax(base + "/api/process/listAttention", params);
  },





  listUrged: function listUrged(params) {
    return _util2.default.ajax(base + "/api/process/listUrged", params);
  },
  addAttention: function addAttention(taskIds) {
    return _util2.default.ajax(base + "/api/process/addAttention", taskIds, null);
  },
  removeAttentionByBusiness: function removeAttentionByBusiness(draftsDocIds) {
    return _util2.default.ajax(base + "/api/process/removeAttentionByBusiness", draftsDocIds);
  },
  removeAttention: function removeAttention(ids) {
    return _util2.default.ajax(base + "/api/process/removeAttention", ids);
  },
  addUrge: function addUrge(params) {
    return _util2.default.ajax(base + "/api/process/addUrge", params);
  },

  listComment: function listComment(params) {
    return _util2.default.ajax(base + "/api/process/listComment", params);
  },

  listAttachment: function listAttachment(params) {
    return _util2.default.ajax(base + "/api/business/listAttachment", params);
  },
  checkAttachmentIsExist: function checkAttachmentIsExist(params) {
    return _util2.default.ajax(base + "/api/business/checkAttachmentIsExist", params);
  },





  copyAttachment: function copyAttachment() {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}
    return _util2.default.ajax.apply(_util2.default, [base + "/api/business/copyAttachment"].concat(args));
  },







  selectiveCopyAttachment: function selectiveCopyAttachment(params) {
    return _util2.default.ajax(base + "/api/business/selectiveCopyAttachment", params);
  },
  updateAttachment: function updateAttachment(params) {
    return _util2.default.ajax(base + "/api/business/updateAttachment", params);
  },
  updateAttachmentSn: function updateAttachmentSn(params) {
    return _util2.default.ajax(base + "/api/business/updateAttachmentSn", params);
  },

  deleteAttachment: function deleteAttachment(params) {
    return _util2.default.ajax(base + "/api/business/deleteAttachment", params);
  },
  downloadAttachment: function downloadAttachment(params, isOpen) {
    return _util2.default.downloadAttachment(base + "/api/business/downloadAttachment", params, isOpen);
  },
  downloadAttachments: function downloadAttachments(params) {
    return _util2.default.downloadAttachment(base + "/api/business/downloadAttachments", params);
  },
  listLoginTree: function listLoginTree(params) {
    return _util2.default.ajax(base + "/api/business/listLoginTree", params);
  },
  listLoginLog: function listLoginLog(params) {
    return _util2.default.ajax(base + "/api/business/listLoginLog", params);
  },
  getLoginLog: function getLoginLog(id) {
    return _util2.default.ajax(base + "/api/business/getLoginLog", id);
  },

  listAccessTree: function listAccessTree(params) {
    return _util2.default.ajax(base + "/api/business/listAccessTree", params);
  },
  listAccessLog: function listAccessLog(params) {
    return _util2.default.ajax(base + "/api/business/listAccessLog", params);
  },
  getAccessLog: function getAccessLog(id) {
    return _util2.default.ajax(base + "/api/business/getAccessLog", id);
  },


  listExceptionTree: function listExceptionTree(params) {
    return _util2.default.ajax(base + "/api/business/listExceptionTree", params);
  },
  listExceptionLog: function listExceptionLog(params) {
    return _util2.default.ajax(base + "/api/business/listExceptionLog", params);
  },
  getExceptionLog: function getExceptionLog(id) {
    return _util2.default.ajax(base + "/api/business/getExceptionLog", id);
  },


  listOperationTree: function listOperationTree(params) {
    return _util2.default.ajax(base + "/api/business/listOperationTree", params);
  },
  listOperationLog: function listOperationLog(params) {
    return _util2.default.ajax(base + "/api/business/listOperationLog", params);
  },
  getOperationLog: function getOperationLog(id) {
    return _util2.default.ajax(base + "/api/business/getOperationLog", id);
  },
  expOperationLog: function expOperationLog(params) {
    return _util2.default.downloadAttachment(base + "/api/business/expOperationLog", params);
  },

  listPersonalLogTree: function listPersonalLogTree(params) {
    return _util2.default.ajax(base + "/api/business/listPersonalLogTree", params);
  },
  listPersonalLog: function listPersonalLog(params) {
    return _util2.default.ajax(base + "/api/business/listPersonalLog", params);
  },
  getPersonalLog: function getPersonalLog(id) {
    return _util2.default.ajax(base + "/api/business/getPersonalLog", id);
  },
  expPersonalLog: function expPersonalLog(params) {
    return _util2.default.downloadAttachment(base + "/api/business/expPersonalLog", params);
  },

  listDeveloperTree: function listDeveloperTree(params) {
    return _util2.default.ajax(base + "/api/business/listDeveloperTree", params);
  },
  listDeveloperLog: function listDeveloperLog(params) {
    return _util2.default.ajax(base + "/api/business/listDeveloperLog", params);
  },
  getDeveloperLog: function getDeveloperLog(id) {
    return _util2.default.ajax(base + "/api/business/getDeveloperLog", id);
  },
  expDeveloperLog: function expDeveloperLog(params) {
    return _util2.default.downloadAttachment(base + "/api/business/expDeveloperLog", params);
  },
  expFlowLog: function expFlowLog(params) {
    return _util2.default.downloadAttachment(base + "/api/business/expFlowLog", params);
  },
  expExceptionLog: function expExceptionLog(params) {
    return _util2.default.downloadAttachment(base + "/api/business/expExceptionLog", params);
  },
  expLoginLog: function expLoginLog(params) {
    return _util2.default.downloadAttachment(base + "/api/business/expLoginLog", params);
  },
  expAccessLog: function expAccessLog(params) {
    return _util2.default.downloadAttachment(base + "/api/business/expAccessLog", params);
  },
  expServiceLog: function expServiceLog(params) {
    return _util2.default.downloadAttachment(base + "/api/business/expServiceLog", params);
  },
  listBusinessTree: function listBusinessTree(params) {
    return _util2.default.ajax(base + "/api/business/listBusinessTree", params);
  },
  listBusinessLog: function listBusinessLog(params) {
    return _util2.default.ajax(base + "/api/business/listBusinessLog", params);
  },
  getBusinessLog: function getBusinessLog(id) {
    return _util2.default.ajax(base + "/api/business/getBusinessLog", id);
  },
  getFlowLog: function getFlowLog(id) {
    return _util2.default.ajax(base + "/api/business/getFlowLog", id);
  },

  queryCommentProcess: function queryCommentProcess() {for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {args[_key2] = arguments[_key2];}
    return _util2.default.ajax.apply(_util2.default, [base + "/api/process/queryCommentProcess"].concat(args));
  },

  getDocumentFormat: function getDocumentFormat() {for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {args[_key3] = arguments[_key3];}
    return _util2.default.ajax.apply(_util2.default, [base + "/api/business/getDocumentFormat"].concat(args));
  },

  invoke: function invoke(url) {for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {args[_key4 - 1] = arguments[_key4];}
    return _util2.default.ajax.apply(_util2.default, [base + "/" + url].concat(args));
  },

  saveRelLife: function saveRelLife(params) {
    return _util2.default.ajax(base + "/api/business/saveRelLife", params);
  },

  listRelFile: function listRelFile(params) {
    return _util2.default.ajax(base + "/api/business/listRelFile", params);
  },

  delRelFile: function delRelFile(params) {
    return _util2.default.ajax(base + "/api/business/delRelFile", params);
  },

  listServiceLog: function listServiceLog(params) {
    return _util2.default.ajax(base + "/api/business/listServiceLog", params);
  },
  getServiceLog: function getServiceLog(id) {
    return _util2.default.ajax(base + "/api/business/getServiceLog", id);
  },
  getTimerLog: function getTimerLog(id) {
    return _util2.default.ajax(base + "/api/business/getTimerLog", id);
  },
  expTimerLog: function expTimerLog(params) {
    return _util2.default.downloadAttachment(base + "/api/business/expTimerLog", params);
  },
  listTimerLog: function listTimerLog(params) {
    return _util2.default.ajax(base + "/api/business/listTimerLog", params);
  },
  getUploadAttachFormatConfig: _.memoize(function (params) {
    return _util2.default.ajax(base + "/api/business/getUploadAttachFormatConfig", params);
  }, function (o) {return "key";}),
  getUploadMaxAttchSizeConfig: _.memoize(function (params) {
    return _util2.default.ajax(base + "/api/business/getUploadMaxAttchSizeConfig", params);
  }, function (o) {return "key";}) };

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var base = window.$servicePath;exports.default =

{



  reqGenerateId: function reqGenerateId() {
    return _util2.default.ajax(base + '/api/app/generateId');
  },

  invoke: function invoke(url) {
    var $$$url = '';
    if (url.startsWith("#")) {
      $$$url = url.substring(1);
    } else {
      if (url.indexOf('?') > -1) {
        $$$url = 'cheetah/service/' + url + '&$$forceTran=false';
      } else {
        $$$url = 'cheetah/service/' + url + '?$$forceTran=false';
      }
    }for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {args[_key - 1] = arguments[_key];}
    return _util2.default.ajax.apply(_util2.default, [base + '/' + $$$url].concat(args));
  },

  invokeInner: function invokeInner(url) {
    var $$$url = '';
    if (url.startsWith("#")) {
      $$$url = url.substring(1);
    } else {
      if (url.indexOf('?') > -1) {
        $$$url = 'cheetah/service/' + url + '&$$es=true&$$forceTran=false';
      } else {
        $$$url = 'cheetah/service/' + url + '?$$es=true&$$forceTran=false';
      }
    }for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {args[_key2 - 1] = arguments[_key2];}
    return _util2.default.ajax.apply(_util2.default, [base + '/' + $$$url].concat(args));
  },

  ajax: function ajax(url) {for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {args[_key3 - 1] = arguments[_key3];}
    return _util2.default.ajax.apply(_util2.default, [base + '/' + url].concat(args));
  } };

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(853);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 853 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var base = window.$servicePath;exports.default =

{
  listJob: function listJob() {
    return _util2.default.ajax(base + '/api/job/listJob');
  },
  getJob: function getJob(id) {
    return _util2.default.ajax(base + '/api/job/getJob', id);
  },

  createQuatzComponent: function createQuatzComponent(params) {
    return _util2.default.ajax(base + '/api/job/createQuatzComponent', params);
  },
  removeQuatzComponent: function removeQuatzComponent(params) {
    return _util2.default.ajax(base + '/api/job/removeQuatzComponent', params);
  },
  getQuatzComponent: function getQuatzComponent(id) {
    return _util2.default.ajax(base + '/api/job/getQuatzComponent', id);
  },
  execJob: function execJob(params) {
    return _util2.default.ajax(base + '/api/job/execJob', params);
  },
  suspendJob: function suspendJob(params) {
    return _util2.default.ajax(base + '/api/job/suspendJob', params);
  },
  resumeJob: function resumeJob(params) {
    return _util2.default.ajax(base + '/api/job/resumeJob', params);
  } };

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var base = window.$servicePath;exports.default =
{







  saveFileWord: function saveFileWord(params) {
    return _util2.default.ajax(base + '/cheetah/service/s:oa:oa.srv.saveFileWord', params);
  },






  deleteFileWord: function deleteFileWord(ids) {
    return _util2.default.ajax(base + '/cheetah/service/s:oa:oa.srv.deleteFileWord', ids);
  },






  getFileWord: function getFileWord(id) {
    return _util2.default.ajax(base + '/cheetah/service/s:oa:oa.srv.getFileWord', id);
  },








  listFileWord: function listFileWord(params) {
    return _util2.default.ajax(base + '/cheetah/service/s:oa:oa.srv.listFileWord', params);
  },








  listFileWordTree: function listFileWordTree(params) {
    return _util2.default.ajax(base + '/cheetah/service/s:oa:oa.srv.listFileWordTree', params);
  },





  exportFileWord: function exportFileWord(params) {
    return _util2.default.downloadAttachment(base + '/cheetah/service/s:oa:oa.srv.exportFileWord', params);
  },







  saveDeptWs: function saveDeptWs(params) {
    return _util2.default.ajax(base + '/cheetah/service/s:oa:oa.srv.saveDeptWs', params);
  },






  deleteDeptWs: function deleteDeptWs(ids) {
    return _util2.default.ajax(base + '/cheetah/service/s:oa:oa.srv.deleteDeptWs', ids);
  },






  getDeptWs: function getDeptWs(id) {
    return _util2.default.ajax(base + '/cheetah/service/s:oa:oa.srv.getDeptWs', id);
  },








  listDeptWs: function listDeptWs(params) {
    return _util2.default.ajax(base + '/cheetah/service/s:oa:oa.srv.listDeptWs', params);
  },
  listMultiLevelDocTree: function listMultiLevelDocTree(params) {
    return _util2.default.ajax(base + '/cheetah/service/s:oa:oa.srv.listMultiLevelDocTree', params);
  },
  listMultiLevelDocData: function listMultiLevelDocData(params) {
    return _util2.default.ajax(base + '/cheetah/service/s:oa:oa.srv.listMultiLevelDocData', params);
  } };

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var base = '/cheetah/service/s:oa:oa.srv.';exports.default =

{


















  listMatchFileWord: function listMatchFileWord(params) {









































































    return _util2.default.ajax(base + 'listMatchFileWord', params);
  },






























  generateDocNumber: function generateDocNumber(params) {





































    return _util2.default.ajax(base + 'generateDocNumber', params);
  },



























  generatePreYearDocNumber: function generatePreYearDocNumber(params) {



















    return _util2.default.ajax(base + 'generatePreYearDocNumber', params);
  },

  generatePreviewDocNumber: function generatePreviewDocNumber(params) {








    return _util2.default.ajax(base + 'generatePreviewDocNumber', params);
  },

  generateAutoDocNumber: function generateAutoDocNumber(params) {












    return _util2.default.ajax(
    "/cheetah/service/s:oa:oa.srv.generateAutoDocNumber",
    params);

  } };

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _util = __webpack_require__(16);var _util2 = _interopRequireDefault(_util);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var base = window.$servicePath;exports.default =


{





    listFiles: function listFiles(params) {
        return _util2.default.ajax(base + '/api/file/listFiles', params);
    },





    deleteFile: function deleteFile(params) {
        return _util2.default.ajax(base + '/api/file/deleteFile', params);
    },
    downloadFile: function downloadFile(params) {
        return _util2.default.downloadAttachment(base + '/api/file/download', params);
    },
    downloadFile2: function downloadFile2(params) {
        return _util2.default.downloadAttachment2({ url: base + '/api/file/download', params: params });
    },





    deleteFolder: function deleteFolder(params) {
        return _util2.default.ajax(base + '/api/file/deleteFolder', params);
    },





    addFolder: function addFolder(params) {
        return _util2.default.ajax(base + '/api/file/addFolder', params);
    },
    listFolder: function listFolder(params) {
        return _util2.default.ajax(base + '/api/file/listFolder', params);
    } };

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(859);
__webpack_require__(860);
__webpack_require__(861);
__webpack_require__(862);
__webpack_require__(863);
__webpack_require__(864);
__webpack_require__(865);

$WR.defaultRepositories = $WR.defaultRepositories || [];
var rep = $WR.defaultRepositories.find(function (r) {return r.id === 'REP-INTERNAL-COMMON';});
if (rep) {
  rep.categories.push({
    name: "扩展组件",
    icon: "fa fa-cogs",
    widgets: [
    {
      "name": "保存按钮",
      "xtype": "saveButton",
      "icon": "fa fa-save" },

    {
      "name": "编辑按钮",
      "xtype": "editButton",
      "icon": "fa fa-edit" },

    {
      "name": "关闭按钮",
      "xtype": "closeButton",
      "icon": "fa fa-close" },

    {
      "name": "保存关闭按钮",
      "xtype": "saveAndCloseButton",
      "icon": "fa fa-close" },

    {
      "name": "字典选择",
      "xtype": "DictSelectField",
      "icon": "fa fa-book" },
    {
      "name": "百度编辑器",
      "xtype": "UEditorComp",
      "icon": "fa fa-window-maximize" },
    {
      "name": "按钮输出框",
      "xtype": "CommonButtonField",
      "icon": "fa fa-external-link" }] });



}

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
(function () {
  var wid = $WR.define('cheetahApplication/form/savebutton', [], function (require, exports, module) {
    var HTML = '';
    module.exports = require('form/default/Button');
  });
  $WR.defineType({
    id: wid,
    xtype: 'saveButton',
    designer: 'DesignerSaveButton' });

})();


(function () {
  var wid = $WR.define('cheetahApplication/form/DesignerSaveButton', [], function (require, exports, module) {
    var HTML = '';
    var Class = MW.extend(require('designer/form/default/Button'), {
      defaults: {
        xtype: 'saveButton',
        xtypeName: '保存按钮',
        value: "保存",
        actionName: "保存",
        action: "formSave",
        sizeCls: "btn-std",
        iconCls: "fa fa-save",
        colorCls: "btn-primary" } });


    module.exports = Class;
  });
  $WR.defineType({
    id: wid,
    xtype: 'DesignerSaveButton',
    designer: '' });

})();

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

(function () {
  var wid = $WR.define('cheetahApplication/form/closeButton', [], function (require, exports, module) {
    var HTML = '';
    module.exports = require('form/default/Button');
  });
  $WR.defineType({
    id: wid,
    xtype: 'closeButton',
    designer: 'DesignerCloseButton' });

})();


(function () {
  var wid = $WR.define('cheetahApplication/form/DesignerCloseButton', [], function (require, exports, module) {
    var HTML = '';

    var Class = MW.extend(require('designer/form/default/Button'), {
      defaults: {
        xtype: 'closeButton',
        xtypeName: '关闭按钮',
        value: "关闭",
        actionName: "关闭",
        action: "formClose",
        sizeCls: "btn-std",
        iconCls: "fa fa-close",
        colorCls: "btn-primary" } });


    module.exports = Class;
  });
  $WR.defineType({
    id: wid,
    xtype: 'DesignerCloseButton',
    designer: '' });

})();

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
(function () {
  var wid = $WR.define('cheetahApplication/form/DesignerSaveAndCloseButton', [], function (require, exports, module) {
    var HTML = '';

    var Class = MW.extend(require('designer/form/default/Button'), {
      defaults: {
        xtype: 'saveAndCloseButton',
        xtypeName: '保存关闭',
        value: "保存",
        actionName: "保存关闭",
        action: "formSaveAndClose",
        sizeCls: "btn-std",
        iconCls: "fa fa-save",
        colorCls: "btn-primary" } });


    module.exports = Class;
  });
  $WR.defineType({
    id: wid,
    xtype: 'DesignerSaveAndCloseButton',
    designer: '' });

})();


(function () {
  var wid = $WR.define('cheetahApplication/form/saveAndCloseButton', [], function (require, exports, module) {
    var HTML = '';
    module.exports = require('form/default/Button');
  });
  $WR.defineType({
    id: wid,
    xtype: 'saveAndCloseButton',
    designer: 'DesignerSaveAndCloseButton' });

})();

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
(function () {
  try {
    var wid = $WR.define('cheetahApplication/form/DesignerEditButton', [], function (require, exports, module) {
      var HTML = '';

      var Class = MW.extend(require('designer/form/default/Button'), {
        defaults: {
          xtype: 'editButton',
          xtypeName: '编辑按钮',
          value: "编辑",
          actionName: "编辑",
          action: "formEdit",
          sizeCls: "btn-std",
          iconCls: "fa fa-edit",
          colorCls: "btn-info" } });


      module.exports = Class;
    });
    $WR.defineType({
      id: wid,
      xtype: 'DesignerEditButton',
      designer: '' });

  } catch (e) {
    console.error(e);
  }
})();

(function () {
  var wid = $WR.define('cheetahApplication/form/editButton', [], function (require, exports, module) {
    var HTML = '';
    module.exports = require('form/default/Button');
  });
  $WR.defineType({
    id: wid,
    xtype: 'editButton',
    designer: 'DesignerEditButton' });

})();

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _promise = __webpack_require__(19);var _promise2 = _interopRequireDefault(_promise);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var wid = $WR.define('cheetahApplication/form/DesignerDictSelectField', [], function (require, exports, module) {
  var HTML = '\n  <div class="x-field-editor">\n    <div class="basic-editor"></div>\n    <div class="form-group">\n        <label>\u6570\u636E\u5B57\u5178</label>\n        <input name="dictionaryName" type="text" style="width: 120px" readonly>\n        <input name="dictionary" type="hidden" class="form-control">\n        <input name="dictionaryAppId" type="hidden" class="form-control">\n        <button class="x-cmd-select-dict">\u9009\u62E9</button>\n    </div>\n    <div class="controls">\n       <div class="checkbox">\n           <label><input name="enableInput" data-type="boolean" type="checkbox" value="true">\u662F\u5426\u53EF\u8F93\u5165</label>\n       </div>\n   </div>\n    <div class="style-editor"></div>\n</div>\n  ';

















  var WidgetClass = require('cheetahApplication/form/DictSelectField');
  var Comp = MW.extend(require('designer/form/default/Base'), {
    defaults: {
      xtype: 'DictSelectField',
      xtypeName: '字典选择',
      isFormField: true },

    _getTpl: function _getTpl() {
      return $(HTML);
    },
    getTargetWidgetClass: function getTargetWidgetClass() {
      return WidgetClass;
    } });


  module.exports = Comp;

});
$WR.defineType({
  id: wid,
  xtype: 'DesignerDictSelectField',
  designer: '' });


wid = $WR.define('cheetahApplication/form/DictSelectField', [], function (require, exports, module) {
  var HTML = '\n          <div class="x-imbedded-selection">\n            <span class="value"></span>\n            <a class="button">\u9009\u62E9</a>\n        </div>\n        ';





  var inputHtml = '<div class="input-group">\n          <input type="text" class="form-control" autocomplete="off" {attrs:attributes}/>\n          <a class="input-group-addon button" style=\'color:blue;border-color: white;background-color: white;\'>\u9009\u62E9</a>\n        </div>';




  var Comp = MW.extend(require('form/default/InputField'), {
    protectedDefaults: {
      btnLabel: '选择',
      isFormField: true },

    _renderBody: function _renderBody() {
      var html = HTML;
      var enableInput = this.$dd.enableInput;
      if (enableInput) {
        html = inputHtml;
      }
      var el = $(html);
      var me = this;
      el.find("a.button").click(function () {
        me.getDict().then(function (data) {
          PF.treeSelect({ data: data }, function (obj) {
            me._value = obj.id;
            if (enableInput) {
              var inputObj = el.find("input");
              inputObj.val(inputObj.val() + obj.name);
            } else {
              el.find(".value").text(obj.name);
            }
          });
        });
      });
      me.el = el;
      return el;
    },
    getDict: function getDict() {
      var me = this;
      if (me._dictValues) {
        return _promise2.default.resolve(me._dictValues);
      }
      var dd = me.getDD();
      return PF.api.data.getDict(dd.dictionary, { applicationId: dd.dictionaryAppId }).then(function (res) {
        if (res.result && res.result.value) {
          me._dictValues = res.result.value.split(",").map(function (v) {
            var arr = v.split("|");
            return { id: arr[1], name: arr[0] };
          });
          return me._dictValues;
        }
      });
    },
    _getValue: function _getValue(v) {
      var me = this;
      if (me.isTextMode()) {
        return v;
      }
      if (me.$dd.enableInput) {
        if (me.__readered) {
          return me.el.find("input").val();
        } else {
          me.__readered = true;
          me.el.find("input").val(v || "");
          return v;
        }
      }
      var ret = me._value || v;
      return ret;
    },
    getDisplayValue: function getDisplayValue() {
      var me = this;
      if (me.$dd.enableInput) {
        return me.el.find("input").val();
      } else {
        return me.el.find(".value").text();
      }
    },
    _setValue: function _setValue(v, disableEvent, values) {
      var me = this;

      if (this.$dd.enableInput) {
        if (me.isTextMode()) {
          me.el.find(".x-field-text-mode-body").text(v);
        } else {
          me.el.find("input").val(v);
          me.__bd[me._getInputName(me.$dd)] = v;
        }
      } else {
        me.getDict().then(function (data) {
          var ds = me._dictValues || data;
          if (ds) {
            var d = ds.filter(function (d) {
              return d.id === v;
            })[0];
            if (d) {
              me._value = d.id;
              if (me.isTextMode()) {
                me.el.find(".x-field-text-mode-body").text(v);
              } else {
                me.el.find(".value").text(d.name);
              }
              me.__bd[me._getInputName(me.$dd)] = me._value;
            }
          }
        });
      }
    } });

  module.exports = Comp;
});

$WR.defineType({
  id: wid,
  xtype: 'DictSelectField',
  designer: 'DesignerDictSelectField' });

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var wid = $WR.define('cheetahApplication/form/DesignerUEditorComp', [], function (require, exports, module) {
    var HTML = '\n  <div class="x-field-editor">\n    <div class="form-group">\n        <label>\u57DF\u540D</label>\n        <input name="contentField" value="content" type="text" class="form-control" maxlength="30">\n    </div>\n    <div class="form-group">\n    <label>\u5BBD\u5EA6(\u767E\u5206\u6BD4)</label>\n    <input name="containerWidth" value="100%" type="text" class="form-control" maxlength="30">\n    </div>\n    <div class="form-group">\n        <label>\u53EA\u8BFB\u6A21\u5F0F\u9AD8\u5EA6(\u6570\u5B57)</label>\n        <input name="editorReadHeight" value="305"  class="form-control" maxlength="30">\n    </div>\n    <div class="form-group">\n        <label>\u7F16\u8F91\u6A21\u5F0F\u9AD8\u5EA6(\u6570\u5B57)</label>\n        <input name="editorHeight" value="280" class="form-control" maxlength="30">\n    </div>\n     <div class="form-group">\n        <label>\u662F\u5426\u53EA\u8BFB</label>\n         <div class="controls row">\n            <div class="col-sm-4"><label class="radio-inline"><input checked type="radio" value="0" name="isReadonly">\u5426</label></div>\n            <div class="col-sm-4"><label class="radio-inline"><input type="radio" value="1" name="isReadonly">\u662F</label></div>\n        </div>\n    </div>\n</div>\n  ';


























    var WidgetClass = require('cheetahApplication/form/UEditorComp');
    var Comp = MW.extend(require('designer/form/default/imbedded/ImbeddedField'), {
        defaults: {
            xtype: 'UEditorComp',
            label: '百度编辑器',
            xtypeName: '百度编辑器',
            isFormField: true },

        _getTpl: function _getTpl() {
            return $(HTML);
        },
        getTargetWidgetClass: function getTargetWidgetClass() {
            return WidgetClass;
        } });


    module.exports = Comp;

});
$WR.defineType({
    id: wid,
    xtype: 'DesignerUEditorComp',
    designer: '' });


wid = $WR.define('cheetahApplication/form/UEditorComp', [], function (require, exports, module) {
    var HTML = '\n       <div class="EditorContainer" style="position: relative;z-index: 0;height:100%;"></div>\n        ';


    var Comp = MW.extend(require('form/default/ImbeddedField'), {
        protectedDefaults: {
            imbeddedObjId: 'pageData',
            pageType: "pageData" },

        constructor: function constructor(config, owner) {
            var dd = config ? config.$dd || config : null;
            if (dd) dd.name = dd.name || dd.contentField;
            Comp.superclass.constructor.apply(this, arguments);
        },
        getCtHeight: function getCtHeight() {
            var el = this.el || $("div[wid='" + this.id + "']");
            return el.parent().height() || "100%";
        },
        getPageData: function getPageData() {
            var out = this;
            var $obj = {
                template: HTML,
                data: function data() {
                    return {
                        editMode: false,
                        containerWidth: '100%',
                        isReady: false };

                },
                created: function created() {
                    var me = this;
                    if (me.$options.params)
                    me.params = me.$options.params;
                },
                mounted: function mounted() {
                    var me = this;
                    this.$nextTick(function () {
                        var dd = {};
                        if (me.params.config) {
                            me.config = me.params.config;
                            if (me.config && me.config.getCurrentObject) {
                                me.dd = me.config.getCurrentObject().$dd;
                                me.editMode = !me.config.getCurrentObject().isTextMode();
                                if (me.dd)
                                me.containerWidth = me.dd.containerWidth || '100%';
                            }
                            if (me.config && me.config.getForm) {
                                var form = me.config.getForm();
                                form.fireEvent("setUeditorInitParams", me.dd);
                            }
                        } else {
                            me.dd = {
                                editorReadHeight: me.params.editorReadHeight,
                                editorHeight: me.params.editorHeight,
                                contentField: me.params.contentField };

                            me.editMode = me.params.editMode || true;
                        }
                        if (!me.dd.editorHeight) {

                            me.dd.editorHeight = out.getCtHeight();
                        } else if (/%$/.test(me.dd.editorHeight)) {
                            me.dd.editorHeight = out.getCtHeight() * (Number(me.dd.editorHeight.replace("%", "")) / 100) - 35;
                        }
                        if (me.dd.editorHeight.toString().indexOf("px") > 0)
                        me.dd.editorHeight = me.dd.editorHeight.toString().substring(0, me.dd.editorHeight.toString().indexOf("px"));
                        if (me.dd.editorReadHeight && me.dd.editorReadHeight.toString().indexOf("px") > 0)
                        me.dd.editorReadHeight = me.dd.editorReadHeight.toString().substring(0, me.dd.editorReadHeight.toString().indexOf("px"));
                        if (me.dd.isReadonly && me.dd.isReadonly == "1")
                        me.editMode = false;
                        me.loadEditor();
                    });

                },
                methods: {
                    loadEditor: function loadEditor() {
                        var me = this;
                        me.containerId = $uuid();
                        $(this.$el).html("<script type='text/plain'  id=" + me.containerId + "></script>");
                        var formId = void 0,businessId = void 0,tempBusinessId = void 0;

                        if (me.config && me.config.getForm) {
                            var form = me.config.getForm();
                            if (form.getExtForm) {
                                var extForm = form.getExtForm();
                                formId = extForm.formId || "";
                                businessId = extForm.businessId || "";
                                tempBusinessId = extForm.tempBusinessId || "";
                            }
                        } else {
                            formId = me.params.formId || "";
                            businessId = me.params.businessId || "";
                            tempBusinessId = me.params.tempBusinessId || "";
                        }
                        var url = PF.url("/cheetah/service/ckeditorService.saveUeditorEfile?type=JOA_EDITOR&formId=" + formId + "&businessId=" + businessId + "&tempBusinessId=" + tempBusinessId);
                        PF.requireJs(["/assets/js/ueditor/ueditor.config.js",
                        "/assets/js/ueditor/ueditor.all.js"],
                        function () {
                            me.editor = UE.getEditor(me.containerId, {
                                zIndex: 9999,
                                initialFrameHeight: me.editMode ? me.dd.editorHeight : me.dd.editorReadHeight,
                                initialFrameWidth: me.containerWidth,
                                autoHeightEnabled: false,
                                autoFloatEnabled: false,
                                elementPathEnabled: false,
                                readonly: !me.editMode,
                                toolbars: !me.editMode ? [] : [
                                ['undo', 'redo',
                                '|', 'bold', 'italic', 'underline',
                                '|', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify',
                                '|', 'fontfamily', 'fontsize', 'forecolor', 'backcolor',
                                '|', 'rowspacingtop', 'rowspacingbottom', 'lineheight', 'indent',
                                '|', 'insertorderedlist', 'insertunorderedlist', 'insertimage', 'inserttable', 'fullscreen']],


                                contextMenu: !me.editMode ? [] : "",
                                wordCount: false,
                                imageUrl: url });

                            me.editor.addListener("contentChange", function () {
                                var content = me.editor.getContent();
                                if (me.config && me.config.getForm) {
                                    var _form = me.config.getForm();
                                    _form.setValueByName(me.dd.contentField, content);
                                }
                            });






                            me.editor.addListener("wordCount", function (params) {
                                var content = me.editor.getContent();
                                if (me.config && me.config.getForm) {
                                    var _form2 = me.config.getForm();
                                    _form2.setValueByName(me.dd.contentField, content);
                                }
                            });
                            me.editor.ready(function () {
                                out.editor = me.editor;
                                if (out._value) {
                                    out.setValue(out._value);
                                }
                                if (out._height) {
                                    out.setValue(out._height);
                                }
                                var content = "";
                                var config = me.params.config;
                                if (config && config.getFormValue) {
                                    var formValue = config.getFormValue();
                                    content = formValue[me.dd.contentField || "content"];
                                } else {
                                    content = me.params.content || "";
                                }
                                if (content) {
                                    me.editor.setContent(content);
                                }

                                UE.dom.domUtils.on(me.editor.body, "drop", function (e) {
                                    setTimeout(function () {
                                        var cont = me.editor.getContent();
                                        if (cont.indexOf('<img src=') != -1) {
                                            cont = cont.replace(/<div><img.*><\/div>/g, "");
                                            me.editor.setContent(cont);
                                            me.editor.focus(true);
                                        }
                                    }, 0);
                                });

                            });

                        });
                    } },

                destroyed: function destroyed() {
                    if (this.editor) {
                        try {
                            this.editor.destroy();
                        } catch (e) {}
                    }
                } };

            return $obj;
        },
        isFormField: function isFormField() {
            return false;
        },
        _renderTextModeBody: function _renderTextModeBody(dd, fnMount) {
            return this._renderBody(dd, fnMount);
        },
        _destroy: function _destroy() {
            if (this.editor) {
                this.editor.destroy();
            }
            Comp.superclass._destroy.apply(this, arguments);
        },
        getValue: function getValue() {
            if (this.editor) {
                return this.editor.getContent();
            }
            return this._value || "";
        },
        reset: function reset(value) {
            if (this.editor) {
                this.editor.setContent(value);
            }
        },
        setValue: function setValue(value) {
            if (this.editor) {
                this.editor.setContent(value || '');
            } else {
                this._value = value;
            }
        },
        setHeight: function setHeight(height) {
            if (this.editor && height) {
                this.editor.setHeight(height);
            } else {
                this._height = height || 300;
            }
        } });


    module.exports = Comp;
});

$WR.defineType({
    id: wid,
    xtype: 'UEditorComp',
    designer: 'DesignerUEditorComp' });

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var wid = $WR.define('cheetahApplication/form/DesignerCommonButtonField', [], function (require, exports, module) {
  var HTML = '\n  <div class="x-field-editor">\n    <div class="basic-editor"></div>\n    <div class="form-group">\n        <label>\u52A8\u4F5C</label>\n        <input name="actionName" type="text" style="width: 120px" readonly>\n        <input name="action" type="hidden" class="form-control">\n        <button class="x-cmd-select-action">\u9009\u62E9</button>\n    </div>\n    <div class="form-group"><label>\u70B9\u51FB\u6267\u884C\u51FD\u6570</label>\n        <div class="controls">\n            <div style="height: 150px; border: 1px solid #e5e6e7;">\n                <script data-bind="script" data-bind-type="widget" type="text/plain">\n                    {xtype: \'CodeEditor\', lang: \'Javascript\', isFormField: false, showLineNumbers: true}\n                </script>\n            </div>\n        </div>\n    </div>\n    <div class="controls">\n       <div class="checkbox">\n           <label><input name="enableInput" data-type="boolean" type="checkbox" value="true">\u662F\u5426\u53EF\u8F93\u5165</label>\n       </div>\n   </div>\n    <div class="style-editor"></div>\n</div>\n  ';

























  var WidgetClass = require('cheetahApplication/form/CommonButtonField');
  var Comp = MW.extend(require('designer/form/default/Base'), {
    defaults: {
      xtype: 'CommonButtonField',
      xtypeName: '字典选择',
      isFormField: true },

    _getTpl: function _getTpl() {
      return $(HTML);
    },
    getTargetWidgetClass: function getTargetWidgetClass() {
      return WidgetClass;
    } });


  module.exports = Comp;

});
$WR.defineType({
  id: wid,
  xtype: 'DesignerCommonButtonField',
  designer: '' });


wid = $WR.define('cheetahApplication/form/CommonButtonField', [], function (require, exports, module) {
  var HTML = '\n          <div class="x-imbedded-selection">\n            <span class="value"></span>\n            <a class="button">\u9009\u62E9</a>\n        </div>\n        ';





  var inputHtml = '<div class="input-group">\n          <input type="text" class="form-control" autocomplete="off" {attrs:attributes}/>\n          <a class="input-group-addon button" style=\'color:blue;border-color: white;background-color: white;\'>\u9009\u62E9</a>\n        </div>';



  var Comp = MW.extend(require('form/default/InputField'), {
    protectedDefaults: {
      btnLabel: '选择',
      isFormField: true },

    _renderBody: function _renderBody(dd, edit) {
      var html = HTML;
      var me = this;
      var enableInput = me.$dd.enableInput;
      if (enableInput) {
        html = inputHtml;
      }
      var el = $(html);

      el.find("a.button").click(function ($event) {
        if (dd.action) {
          if (window.PF && window.PF.invokeFormAction)
          {
            window.PF.invokeFormAction(dd.action, me.$form);
          }
        }
        if (dd.script) {
          var fn = me.$form.scriptContextEval(dd.script);
          if ($.isFunction(fn)) {
            fn.call(me.$form, $event);
          }
        }
      });
      me.el = el;
      return el;
    },
    _getValue: function _getValue() {
      if (this.$dd.enableInput) {
        return this.el.find("input").val();
      } else {
        return this.el.find(".value").text();
      }
    },
    _setValue: function _setValue(v) {

      if (this.$dd.enableInput) {
        this.el.find("input").val(v);
      } else {
        this.el.find(".value").text(v);
      }
    } });

  module.exports = Comp;
});

$WR.defineType({
  id: wid,
  xtype: 'CommonButtonField',
  designer: 'DesignerCommonButtonField' });

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _vue = __webpack_require__(11);var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
function getLanguage(key, defaultValue) {
  var langPacks = window.$languagePacks || {};
  var s = langPacks[key] || defaultValue || key;
  if (s && s.indexOf && s.indexOf("{") >= 0) {
    var values = Array.prototype.slice.call(arguments, 2);
    var defaultIndex = 0;
    s = s.replace(/\{(\d)?\}/g, function (s, i) {
      if (i === undefined) {
        i = defaultIndex;
      }
      defaultIndex++;
      return values[i];
    });
  }
  return s;
}

window.$lang = getLanguage;
_vue2.default.prototype.$lang = getLanguage;exports.default =
getLanguage;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _stringify = __webpack_require__(24);var _stringify2 = _interopRequireDefault(_stringify);var _vue = __webpack_require__(11);var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var eventBus = new _vue2.default();
var obj = {
  connect: function connect(callback) {var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (this.isSupportWs()) {
      var me = this;
      var port = config.port || '9876';
      var url = 'ws://' + window.location.hostname + ':' + port;
      var ws = this.ws = new WebSocket(url);
      ws.onopen = function () {
        if (callback) {
          callback();
        } else {

          MessageCenter.send({ cmd: "init", category: PF.userInfo.inituserid });
        }
      };
      ws.onmessage = function (e)
      {
        var obj = JSON.parse(e.data);
        if (obj.type === "Notification") {
          eventBus.$notify({
            title: obj.title || '',
            message: obj.msg,
            position: 'bottom-right' });

        }
        eventBus.$emit("message", obj);
      };
      ws.onerror = function () {
        eventBus.$emit("error");
      };
      ws.onclose = function () {
        setTimeout(function () {me.connect();}, 3000);
      };
    }
  },
  isSupportWs: function isSupportWs() {
    return !!window.WebSocket;
  },
  markRead: function markRead(messageId) {
    return PF.invoke("s:sms.srv.markRead", messageId);
  },
  on: function on() {
    eventBus.$on.apply(eventBus, arguments);
  },
  off: function off() {
    eventBus.$off.apply(eventBus, arguments);
  },
  once: function once() {
    eventBus.$once.apply(eventBus, arguments);
  },
  send: function send(msg) {
    if (typeof msg !== 'string') {
      msg = (0, _stringify2.default)(msg);
    }
    this.ws.send(msg);
  } };

window.MessageCenter = obj;exports.default =
obj;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _button = __webpack_require__(869);var _button2 = _interopRequireDefault(_button);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

_button2.default.install = function (Vue) {
  Vue.component(_button2.default.name, _button2.default);
};exports.default =
_button2.default;

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_button_vue__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_button_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_button_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_button_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_41fae9e6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_button_vue__ = __webpack_require__(870);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_button_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_41fae9e6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"el-button",class:[
    _vm.type ? 'el-button--' + _vm.type : '',
    _vm.buttonSize ? 'el-button--' + _vm.buttonSize : '',
    {
      'is-disabled': _vm.disabled,
      'is-loading': _vm.loading,
      'is-plain': _vm.plain,
      'is-round': _vm.round
    }
  ],attrs:{"disabled":_vm.disabled,"autofocus":_vm.autofocus,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"el-icon-loading",on:{"click":_vm.handleInnerClick}}):_vm._e(),_vm._v(" "),(_vm.icon && !_vm.loading)?_c('i',{class:_vm.icon,on:{"click":_vm.handleInnerClick}}):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('span',{on:{"click":_vm.handleInnerClick}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =
{
  pagination: {
    total: 0,
    currentPage: 1,
    start: 0,
    limit: 20 } };

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _main = __webpack_require__(873);var _main2 = _interopRequireDefault(_main);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =


_main2.default;

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_09ec312e_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(875);
function injectStyle (ssrContext) {
  __webpack_require__(874)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_09ec312e_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-open-form"},[_c('div',{staticClass:"mw-from-top-con",attrs:{"id":"mw-form"}}),_vm._v(" "),_c('div',{staticClass:"mw-form-bot-btns"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.saveFormData()}}},[_vm._v("保存")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _main = __webpack_require__(877);var _main2 = _interopRequireDefault(_main);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =


_main2.default;

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_12d0c607_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(926);
function injectStyle (ssrContext) {
  __webpack_require__(878)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12d0c607"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_12d0c607_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 878 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);var _flowSave = __webpack_require__(880);var _flowSave2 = _interopRequireDefault(_flowSave);
var _flowComplete = __webpack_require__(881);var _flowComplete2 = _interopRequireDefault(_flowComplete);
var _flowReject = __webpack_require__(882);var _flowReject2 = _interopRequireDefault(_flowReject);

var _flowTransmit = __webpack_require__(883);var _flowTransmit2 = _interopRequireDefault(_flowTransmit);
var _flowPlanned = __webpack_require__(884);var _flowPlanned2 = _interopRequireDefault(_flowPlanned);
var _flowWorktrack = __webpack_require__(885);var _flowWorktrack2 = _interopRequireDefault(_flowWorktrack);
var _flowWorktrackli = __webpack_require__(886);var _flowWorktrackli2 = _interopRequireDefault(_flowWorktrackli);
var _flowWorktracktree = __webpack_require__(887);var _flowWorktracktree2 = _interopRequireDefault(_flowWorktracktree);

var _flowReaded = __webpack_require__(888);var _flowReaded2 = _interopRequireDefault(_flowReaded);
var _flowTovoid = __webpack_require__(889);var _flowTovoid2 = _interopRequireDefault(_flowTovoid);

var _flowVirtuallog = __webpack_require__(890);var _flowVirtuallog2 = _interopRequireDefault(_flowVirtuallog);
var _flowSendleader = __webpack_require__(891);var _flowSendleader2 = _interopRequireDefault(_flowSendleader);
var _flowSendsecretary = __webpack_require__(892);var _flowSendsecretary2 = _interopRequireDefault(_flowSendsecretary);
var _flowSecrecord = __webpack_require__(893);var _flowSecrecord2 = _interopRequireDefault(_flowSecrecord);

var _flowSpsendleader = __webpack_require__(894);var _flowSpsendleader2 = _interopRequireDefault(_flowSpsendleader);
var _flowSpsecrecord = __webpack_require__(895);var _flowSpsecrecord2 = _interopRequireDefault(_flowSpsecrecord);
var _flowTransactionDialog = __webpack_require__(896);var _flowTransactionDialog2 = _interopRequireDefault(_flowTransactionDialog);
var _flowShowFlowImage = __webpack_require__(897);var _flowShowFlowImage2 = _interopRequireDefault(_flowShowFlowImage);


var _formSave = __webpack_require__(898);var _formSave2 = _interopRequireDefault(_formSave);
var _formClose = __webpack_require__(899);var _formClose2 = _interopRequireDefault(_formClose);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}


function addActions(callback) {

  if (!PF.action) PF.action = {};
  if (!PF.action.flowsave) {
    var actions = {
      flowsave: _flowSave2.default,
      flowcomplete: _flowComplete2.default,
      flowreject: _flowReject2.default,
      flowtransmit: _flowTransmit2.default,
      flowplanned: _flowPlanned2.default,
      flowworktrack: _flowWorktrack2.default,
      flowworktrackli: _flowWorktrackli2.default,
      flowworktracktree: _flowWorktracktree2.default,
      flowreaded: _flowReaded2.default,
      flowtovoid: _flowTovoid2.default,
      flowvirtuallog: _flowVirtuallog2.default,
      flowsendleader: _flowSendleader2.default,
      flowsendsecretary: _flowSendsecretary2.default,
      flowsecrecord: _flowSecrecord2.default,
      flowspsendleader: _flowSpsendleader2.default,
      flowspsecrecord: _flowSpsecrecord2.default,
      showTransactionDialog: _flowTransactionDialog2.default,
      showFlowImage: _flowShowFlowImage2.default,
      formSave: _formSave2.default,

      formSaveAndClose: function formSaveAndClose($form, noMsg) {
        return _formSave2.default.call(this, $form, true, noMsg);
      },
      formClose: _formClose2.default,
      formEdit: function formEdit($form) {
        if ($form.__originalExtForm && $form.__originalExtForm.setEditMode) {
          $form.__originalExtForm.setEditMode(true);
        } else {
          $form.setTextMode(false);
        }
      } };


    (0, _assign2.default)(PF.action, actions);
  }
}
addActions();exports.default =
addActions;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form, callback) {
  var $params = $form.getExtForm();
  if (!$form.isValid(true)) {
    return false;
  }
  var btnName = $params.action;
  $params.setBtnLoading(true, btnName);
  function save(data, err) {
    $params.setBtnLoading(false, btnName);
    if (!err) {
      if (callback) callback(data);
      PF.message($lang("表单数据保存成功") + "!");
    }
  }

  $params.startProcess(save);

};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =
function ($form) {
  var extForm = $form.__originalExtForm;

  if (!$form.isValid(true)) {
    return;
  }
  var btnName = extForm.action;
  extForm.setBtnLoading(true, btnName);

  function complete(data, err) {
    extForm.setBtnLoading(false, btnName);
    if (err) {
      return;
    }
    var p = {
      action: extForm.action,
      taskId: data.taskId,
      appId: extForm.appId,
      formId: extForm.formId,
      entityId: extForm.entityId,
      businessId: data.businessId,
      batchId: data.batchId,
      draftsDocId: data.draftsDocId,
      activity: extForm.activity,
      comment: extForm.commentId ? [{
        id: extForm.commentId,
        content: extForm.comment,
        category: extForm.commentCategory }] :
      [],
      formOpenSource: extForm.formOpenSource,
      defaultSelectActivity: extForm.activity && extForm.activity.defaultSelectActivityId };

    p.businessName = $form.getValueByName(extForm.fieldMapping.businessName);
    if (extForm.extParams && extForm.extParams.fullAuthType) {
      p.fullAuthType = extForm.extParams.fullAuthType;
    }
    p.beforedocomplete = function (params, callback) {
      return $form.fireEvent("beforedocomplete", p, params, this, callback.bind(this));
    };
    p.beforeshowdialog = function () {
      return $form.fireEvent("beforeshowcompletedialog", p, this);
    };
    if ($form.fireEvent("beforecomplete", p, extForm, continuation.bind(this)) === false) {
      return false;
    }
    function continuation() {
      extForm.setBtnLoading(true, btnName);
      function afterComplete(params, res) {

        if ($form.fireEvent("aftercomplete", params, res, cb.bind($form)) === false) {
          return false;
        }
        cb();
        function cb() {
          extForm.formActionComplete();
        }
      }
      PF.show('flowComplete', p, afterComplete, function beforeClose() {
        extForm.setBtnLoading(false, btnName);
      });
    }
    continuation.call(this);
  }

  if (extForm.isNotifyTask() || extForm.isReadOnlyTask()) {
    complete(extForm);
  } else {
    extForm.startProcess(complete, "complete");
  }
};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
    if (!(window.$Env && $Env.noSendBackValid) && !$form.isValid(true)) {
        return;
    }

    var $params = $form.getExtForm();

    if ($form.fireEvent("beforereject", $params, fn) === false) return;
    fn();




    function fn() {
        $params.startProcess(function () {});
        var p = {
            taskId: $params.taskId,
            appId: $params.appId,
            formId: $params.formId };

        if ($params.extParams && $params.extParams.fullAuthType) {
            p.fullAuthType = $params.extParams.fullAuthType;
        }
        p.formObj = $form;
        if ($params.comment) {
            p.comment = $params.comment;
        }
        PF.show('flowReject', p, $params.formActionComplete);
    }


};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
    var $params = $form.getExtForm();
    if (!$form.isValid(true)) {
        return;
    }
    var p = {
        taskId: $params.taskId,
        appId: $params.appId,
        formId: $params.formId };



    if ($form.fireEvent("beforeFlowTransmit", p, fn) === false) return;
    fn();
    function fn() {
        PF.show("flowTransmit", p, function (res) {
            if ($params.comment) {
                res['$comment'] = $params.comment;
            }
            function doTransfer(params) {
                if ($params.extParams && $params.extParams.fullAuthType) {
                    params.fullAuthType = $params.extParams.fullAuthType;
                }
                PF.api.process.transfer($params.taskId, params).then(function (res) {
                    var data = res.result;
                    if (!data.success) {
                        if (data.errorType === "comment") {
                            if (data.errorCode === 'comment_check_stop') {
                                PF.message('info', $lang('您还没有填写意见,请填写意见!'));
                                return;
                            } else if (data.errorCode === 'comment_check_remind') {
                                PF.confirm($lang('您还没有填写意见,您确认是要继续转办？'), $lang('提示'), { type: 'warning' }).then(function () {
                                    params['$directSave'] = true;
                                    doTransfer(params);
                                }).catch(function () {});
                                return;
                            }
                        } else {
                            var errorMsg = '';
                            if (data.errorMsg) {
                                errorMsg = '[' + $lang('错误信息') + ':' + data.errorMsg + ']';
                            }
                            PF.message('info', '转办失败' + errorMsg + '!');
                            return;
                        }
                    } else {
                        if ($form.fireEvent("afterFlowTransmit", params, res) === false) return;
                        $params.formActionComplete();
                    }
                }).catch(function () {});
            }
            doTransfer(res);
        });
    }
};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var $params = $form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }
  var p = {
    action: $params.action,
    taskId: $params.taskId,
    appId: $params.appId,
    formId: $params.formId,
    entityId: $params.entityId,
    activity: $params.activity,
    comment: $params.comment };

  if ($params.extParams && $params.extParams.fullAuthType) {
    p.fullAuthType = $params.extParams.fullAuthType;
  }
  PF.show("flowPlanned", p, function (res) {
    $params.refreshComment(res);
    $form.fireEvent("afterflowproposed", res);
  });
};

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var $params = $form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }
  var p = {
    businessId: $params.businessId,
    batchId: $params.batchId,
    draftsDocId: $params.draftsDocId,
    taskId: $params.taskId,
    appId: $params.appId,
    formId: $params.formId,
    isOperation: false };

  if ($params.extParams && $params.extParams.fullAuthType) {
    p.fullAuthType = $params.extParams.fullAuthType;
  }
  PF.show("flowWorktrack", p, function (res) {
  }, function (isOperation, hasDoging) {
    if (!isOperation) {
      var yzStatus = hasDoging ? "在办" : "办毕";
      PF.invoke("#/api/process/updateYzStatus", $params.taskId, yzStatus);
    }
  });
};

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var $params = $form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  var p = {
    businessId: $params.businessId,
    batchId: $params.batchId,
    draftsDocId: $params.draftsDocId,
    taskId: $params.taskId,
    appId: $params.appId,
    formId: $params.formId };

  if ($params.extParams && $params.extParams.fullAuthType) {
    p.fullAuthType = $params.extParams.fullAuthType;
  }
  PF.show("flowWorktrackLi", p, function (res) {

  });
};

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var $params = $form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  var p = {
    businessId: $params.businessId,
    batchId: $params.batchId,
    draftsDocId: $params.draftsDocId,
    taskId: $params.taskId,
    appId: $params.appId,
    formId: $params.formId };

  if ($params.extParams && $params.extParams.fullAuthType) {
    p.fullAuthType = $params.extParams.fullAuthType;
  }
  PF.show("flowWorktrackTree", p, function (res) {

  });
};

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
    var $params = $form.getExtForm();
    if (!$form.isValid(true)) {
        return;
    }

    $params.btnDebounce(function () {
        var params = {};
        params.type = 'complete';
        params.taskId = $params.taskId;
        params.formId = $params.formId;
        params.formKey = $params.formKey;
        params.appId = $params.appId;
        params.entityId = $params.entityId;
        if ($params.comment) {
            params['$comment'] = $params.comment;
        }
        var btnName = $params.action;
        $params.setBtnLoading(true, btnName);
        if ($params.extParams && $params.extParams.fullAuthType) {
            params.fullAuthType = $params.extParams.fullAuthType;
        }
        function doReaded(params) {
            PF.api.process.batchCommit(params).then(function (res) {
                var data = res.result;
                if (data && !data.success) {
                    if (data.errorType == 'comment') {
                        if (data.errorCode == 'comment_check_stop') {
                            PF.message('info', $lang('您还没有填写意见,请填写意见!'));
                            $params.setBtnLoading(false, btnName);
                            return;
                        } else if (data.errorCode == 'comment_check_remind') {
                            PF.confirm($lang('您还没有填写意见,您确认是要继续完成？'), $lang('提示'), { type: 'warning' }).then(function () {
                                params['$directSave'] = true;
                                doReaded(params);
                            }).catch(function () {
                                $params.setBtnLoading(false, btnName);
                            });
                            return;
                        }
                    } else {
                        var errorMsg = '';
                        if (data.errorMsg) {
                            errorMsg = '[' + $lang('错误信息') + ':' + data.errorMsg + ']';
                        }
                        PF.message('info', $lang('完成失败') + errorMsg + '!');
                        $params.setBtnLoading(false, btnName);
                        return;
                    }
                } else {
                    $params.formActionComplete();
                    $params.setBtnLoading(false, btnName);
                }
            }).catch(function () {
                $params.setBtnLoading(false, btnName);
            });
        }

        doReaded(params);
    });
};

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var $params = $form.getExtForm();




  var p = {
    taskId: $params.taskId,
    appId: $params.appId,
    formId: $params.formId };

  $params.btnDebounce(function () {
    var btnName = $params.action;
    $params.setBtnLoading(true, btnName);
    PF.confirm($lang('您确定将此文件作废？请谨慎操作！'), $lang('提示'), { type: 'info' }).then(function () {
      var params = [];
      var param = {
        moduleId: $params.moduleId,
        businessId: $params.businessId,
        taskId: $params.taskId };

      if ($params.extParams && $params.extParams.fullAuthType) {
        param.fullAuthType = $params.extParams.fullAuthType;
      }
      params.push(param);
      PF.api.process.batchSuspendReleaseWH(params).then(function (res) {
        $form.fireEvent("aftertovoid", $params, res.success);
        if (res.success) {
          $params.formActionComplete();
        }
        $params.setBtnLoading(false, btnName);
      }).catch(function () {
        $params.setBtnLoading(false, btnName);
      });
    }).catch(function () {
      $params.setBtnLoading(false, btnName);
    });
  });
};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var $params = $form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  var activity = $params.activity;

















  var agentRecordFlowIds = [];
  var canAgentRecordFlowIds = activity.canAgentRecordFlowIds;
  if (canAgentRecordFlowIds && null != canAgentRecordFlowIds) {
    var arFlowIds = canAgentRecordFlowIds.split(',');
    if (arFlowIds.length > 0) {
      for (var i = 0; i < arFlowIds.length; i++) {
        agentRecordFlowIds[i] = arFlowIds[i];
      }
    }
  }
  if (agentRecordFlowIds.length < 1) {
    PF.message('info', '未设置代录节点流向，请与管理员联系!');
    return;
  }
  var p = {
    taskId: $params.taskId,
    appId: $params.appId,
    formId: $params.formId,
    activity: $params.activity,

    agentRecordFlowIds: agentRecordFlowIds };

  PF.show('flowVirtualog', p, function (res) {
    $params.refreshComment(res);
  });
};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var $params = $form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  $params.btnDebounce(function () {
    var p = {
      taskId: $params.taskId,
      appId: $params.appId,
      formId: $params.formId };

    if ($params.comment) {
      p['$comment'] = $params.comment;
    }
    var btnName = $params.action;
    $params.setBtnLoading(true, btnName);
    PF.confirm('您确定送给领导？', '提示', { type: 'info' }).then(function () {

      p.actionDescription = '送领导';
      p.leaderActivityName = '';
      if ($params.taskData.taskActivityType == 'notify') {
        if ($params.activity.circularLeaderActivityName) {
          p.leaderActivityName = $params.activity.circularLeaderActivityName;
        }
      } else {
        if ($params.activity.leaderActivityName) {
          p.leaderActivityName = $params.activity.leaderActivityName;
        }
      }
      if ($params.extParams && $params.extParams.fullAuthType) {
        p.fullAuthType = $params.extParams.fullAuthType;
      }
      PF.api.process.delegateSendLeader(p).then(function (res) {
        if (res.success) {
          $params.formActionComplete();
        }
        $params.setBtnLoading(false, btnName);
      }).catch(function () {
        $params.setBtnLoading(false, btnName);
      });
    }).catch(function () {
      $params.setBtnLoading(false, btnName);
    });
  });
};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var $params = $form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  $params.btnDebounce(function () {
    var p = {
      taskId: $params.taskId,
      appId: $params.appId,
      formId: $params.formId };

    if ($params.comment) {
      p['$comment'] = $params.comment;
    }
    var btnName = $params.action;
    $params.setBtnLoading(true, btnName);
    PF.confirm('您确定送给秘书？', '提示', { type: 'info' }).then(function () {

      p.actionDescription = '送秘书';
      p.secretaryActivityName = '';
      if ($params.taskData.taskActivityType == 'notify') {
        if ($params.activity.circularSecActivityName) {
          p.secretaryActivityName = $params.activity.circularSecActivityName;
        }
      } else {
        if ($params.activity.secActivityName) {
          p.secretaryActivityName = $params.activity.secActivityName;
        }
      }
      if ($params.extParams && $params.extParams.fullAuthType) {
        p.fullAuthType = $params.extParams.fullAuthType;
      }
      PF.api.process.delegateSendSecretary(p).then(function (res) {
        if (res.success) {
          $params.formActionComplete();
        }
        $params.setBtnLoading(false, btnName);
      }).catch(function () {
        $params.setBtnLoading(false, btnName);
      });
    }).catch(function () {
      $params.setBtnLoading(false, btnName);
    });
  });
};

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var $params = $form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  var p = {
    taskId: $params.taskId,
    appId: $params.appId,
    formId: $params.formId,
    activity: $params.activity,
    ownerName: $params.taskData.ownerName };



  PF.show('flowSecrecord', p, function (res) {
    var comment = res.comment;
    var params = {};
    params.isAgentRecord = 1;

    params.actionDescription = '秘书代录：' + comment;
    params.taskId = $params.taskId;
    params.appId = $params.appId;
    params.formId = $params.formId;
    params.arActivityName = '';
    if ($params.taskData.taskActivityType == 'notify') {
      if ($params.activity.circularLeaderActivityName) {
        params.arActivityName = $params.activity.circularLeaderActivityName;
      }
    } else {
      if ($params.activity.leaderActivityName) {
        params.arActivityName = $params.activity.leaderActivityName;
      }
    }
    if ($params.extParams && $params.extParams.fullAuthType) {
      params.fullAuthType = $params.extParams.fullAuthType;
    }
    params.$comment = [{ id: $uuid(), content: comment, category: $params.activity.commentCategory, leading: 1, isAgentRecord: 1, agentType: 'SECRETARY' }];
    PF.api.process.delegateSecretaryRecord(params).then(function (res) {
      $params.refreshComment(params);
    }).catch(function () {
      $params.refreshComment(params);
    });
  });
};

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var $params = $form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  var btnName = $params.action;
  $params.btnDebounce(function () {
    $params.setBtnLoading(true, btnName);
    PF.confirm('您确定送给领导？', '提示', { type: 'info' }).then(function () {
      PF.api.process.getBindLeaderData($params.taskId).then(function (res) {
        if (res.success) {
          var leadData = res.result;
          if (!leadData || !leadData.flow) {
            PF.message('info', '获取领导数据信息失败!');
            return;
          }
          doCommit(leadData);
        }
      });
    }).catch(function () {
      $params.setBtnLoading(false, btnName);
    });
  });

  function doCommit(leadData) {
    var p = {
      taskId: $params.taskId,
      appId: $params.appId,
      formId: $params.formId,
      formKey: $params.formKey };

    if ($params.comment) {
      p['$comment'] = $params.comment;
    }
    p.type = "complete";
    p.actionDescription = '送领导';
    p['$directSave'] = true;
    var flow = leadData.flow;
    if (flow) {
      var activity = {};
      activity.flowId = flow.id;
      activity.activityId = flow.activityId;
      activity.type = flow.type;
      activity.options = flow.options;
      var items = [];
      var item = {};
      item.group = leadData.departmentId;
      item.users = [{ id: leadData.id }];
      items.push(item);
      activity.items = items;
      p.activities = [activity];
    }
    if ($params.extParams && $params.extParams.fullAuthType) {
      p.fullAuthType = $params.extParams.fullAuthType;
    }
    PF.api.process.batchCommit(p).then(function (res) {
      if (res.success) {
        $params.formActionComplete();
      }
      $params.setBtnLoading(false, btnName);
    }).catch(function () {
      $params.setBtnLoading(false, btnName);
    });
  }
};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var $params = $form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  PF.api.process.getBindLeaderData($params.taskId).then(function (res) {
    if (res.success) {
      var leadData = res.result;
      if (!leadData || !leadData.flow) {
        PF.message('info', '获取领导数据信息失败!');
        return;
      }
      var p = {
        taskId: $params.taskId,
        appId: $params.appId,
        formId: $params.formId,
        activity: $params.activity,
        ownerName: leadData.name };


      if ($params.extParams && $params.extParams.fullAuthType) {
        p.fullAuthType = $params.extParams.fullAuthType;
      }
      PF.show('flowSecrecord', p, function (res) {
        var comment = res.comment;
        var params = {};
        params.type = "virtualRecord";
        params.isAgentRecord = 1;

        params.actionDescription = '秘书代录：' + comment;
        params.taskId = $params.taskId;
        params.appId = $params.appId;
        params.formId = $params.formId;

        var items = [];
        var item = {};
        item.group = leadData.departmentId;
        item.users = [{ id: leadData.id }];
        items.push(item);
        params.activities = [{ activityId: leadData.activityId, items: items }];
        params.$comment = [{ id: $uuid(), content: comment, category: $params.activity.commentCategory, leading: 1, isAgentRecord: 1, agentType: 'SECRETARY' }];
        PF.api.process.saveVirtualRecord(params).then(function (res) {
          $params.refreshComment(params);
        }).catch(function () {
          $params.refreshComment(params);
        });
      });
    }
  });
};

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var extForm = $form.getExtForm();
  var businessId = extForm.businessId;
  var taskId = extForm.taskId;
  PF.show('transactionProcess', { businessId: businessId, batchId: extForm.batchId, taskId: taskId });
};

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var extForm = $form.getExtForm();
  var businessId = extForm.businessId;
  var processDefinitionId = !window.$Env || !$Env.flowImageNotPassProcessDefinitionId || !businessId ? extForm.processDefinitionId : '';
  var applicationId = extForm.appId;
  PF.func.bpm.showFlowImage({
    businessId: businessId,
    batchId: extForm.batchId,
    processDefinitionId: processDefinitionId,
    applicationId: applicationId });

};

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form, autoClose, noMsg) {
  var extForm = $form.getExtForm();
  var params = {};
  if (!$form.isValid(true)) {
    return;
  }
  params.appId = extForm.appId;
  params.moduleId = extForm.moduleId;
  params.formId = extForm.formId;
  params.formVersion = extForm.formVersion;
  params.formKey = extForm.formKey;
  params.tempBusinessId = extForm.tempBusinessId;
  params.$form = extForm.formData;
  params.formOpenSource = extForm.formOpenSource;
  if ($form.fireEvent("beforesave", params, callback) === false) {
    $form.__originalExtForm.$emit("updatedData", true);
    return;
  }
  function callback() {
    PF.api.data.saveFormData(params).then(function (data) {
      $form.fireEvent("aftersave", data);
      $form.__originalExtForm.$emit("updatedData", true);
      if (autoClose) extForm.formActionComplete($form, data);
      $form.__originalExtForm.businessId = data.result.id;
      if (!noMsg) PF.message($lang("表单数据保存成功") + "!");
      return false;
    });
  }
  callback();
};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function ($form) {
  var dialog = $form.dialog;
  if (dialog) {
    if (dialog.$parent.params.secondfunc) {
      dialog.$parent.params.secondfunc(dialog.$parent.updatedData);
    }
    dialog.hide();
  }
};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(901), __esModule: true };

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(193);
__webpack_require__(96);
__webpack_require__(110);
__webpack_require__(902);
__webpack_require__(908);
__webpack_require__(911);
__webpack_require__(913);
module.exports = __webpack_require__(18).Map;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(903);
var validate = __webpack_require__(309);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(904)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(49).f;
var create = __webpack_require__(137);
var redefineAll = __webpack_require__(198);
var ctx = __webpack_require__(64);
var anInstance = __webpack_require__(196);
var forOf = __webpack_require__(111);
var $iterDefine = __webpack_require__(188);
var step = __webpack_require__(263);
var setSpecies = __webpack_require__(290);
var DESCRIPTORS = __webpack_require__(51);
var fastKey = __webpack_require__(190).fastKey;
var validate = __webpack_require__(309);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29);
var $export = __webpack_require__(28);
var meta = __webpack_require__(190);
var fails = __webpack_require__(85);
var hide = __webpack_require__(71);
var redefineAll = __webpack_require__(198);
var forOf = __webpack_require__(111);
var anInstance = __webpack_require__(196);
var isObject = __webpack_require__(50);
var setToStringTag = __webpack_require__(109);
var dP = __webpack_require__(49).f;
var each = __webpack_require__(905)(0);
var DESCRIPTORS = __webpack_require__(51);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(64);
var IObject = __webpack_require__(181);
var toObject = __webpack_require__(88);
var toLength = __webpack_require__(134);
var asc = __webpack_require__(906);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(907);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(50);
var isArray = __webpack_require__(264);
var SPECIES = __webpack_require__(30)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(28);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(909)('Map') });


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(138);
var from = __webpack_require__(910);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(111);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(912)('Map');


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(914)('Map');


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);
var aFunction = __webpack_require__(104);
var ctx = __webpack_require__(64);
var forOf = __webpack_require__(111);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var WARN_UNDEFINED_TASK_UNIT_TYPE = exports.WARN_UNDEFINED_TASK_UNIT_TYPE = 'undefined task unit type, must be U or P, means users or positions';

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_action_area_vue__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_action_area_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_action_area_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_action_area_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_action_area_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0fbfc3a2_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flow_action_area_vue__ = __webpack_require__(921);
function injectStyle (ssrContext) {
  __webpack_require__(917)
  __webpack_require__(918)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fbfc3a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_action_area_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0fbfc3a2_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flow_action_area_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel flow-tree-select"},[(_vm.search)?_c('div',{staticClass:"mw-tree-search"},[_c('el-input',{attrs:{"placeholder":_vm.$lang('请输入搜索内容'),"clearable":""},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1):_vm._e(),_vm._v(" "),_c('div',{class:{'mw-tree-search__body':_vm.search,'mw-tree-no-search__body':!_vm.search}},[_c('div',{staticClass:"mw-tree"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height:_vm.height,overflow:'auto',padding:'8px 30px 2px 30px','background-color':'#e9ebe9',border:'solid 1px #ddd'})},[(_vm.actions.indexOf('flowreaded')<0 && _vm.actions.indexOf('flowcomplete')>=0)?_c('el-row',{ref:"selUserRow",style:({'margin-left': _vm.marginLeft,'text-align':'left'}),attrs:{"gutter":20}},[_c('el-col',{staticStyle:{"width":"300px"},attrs:{"span":8}},[_c('div',{staticClass:"demo-input-suffix"},[_vm._v("\n        "+_vm._s(_vm.$lang('流转到'))+"：\n        "),_c('el-select',{ref:"flowsSelect",staticStyle:{"width":"calc(100% - 68px)"},attrs:{"placeholder":_vm.$lang('请选择流向')},on:{"change":_vm.flowChange},model:{value:(_vm.selectedFlowId),callback:function ($$v) {_vm.selectedFlowId=$$v},expression:"selectedFlowId"}},_vm._l((_vm.mixFlows),function(flow){return _c('el-option',{key:flow.id,attrs:{"label":flow.name,"value":flow.id}})}),1)],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"width":"calc(100% - 310px)","padding-left":"0px"}},[(!_vm.isExtraFlowActive && !_vm.isOverFlow)?_c('el-button',{staticClass:"hg_form_btn_cls",staticStyle:{"vertical-align":"top"},attrs:{"loading":_vm.selUserLoading,"type":"default","icon":"fa fa-user"},on:{"click":_vm.selectUser}},[_vm._v(_vm._s(_vm.$lang("选择人员")))]):_vm._e(),_vm._v(" "),(_vm.isExtraFlowActive && _vm.selectedFlow.button)?_c('el-button',{staticClass:"hg_form_btn_cls",staticStyle:{"vertical-align":"top"},attrs:{"type":"info","icon":"fa fa-user"},on:{"click":_vm.extraFlowButtonClick}},[_vm._v(_vm._s(_vm.selectedFlow.button.text))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"recipient-flow-area-box"},[_vm._l((_vm.selectedUsers),function(user){return _c('span',{key:user.id,staticClass:"person-item"},[_c('span',{staticStyle:{"color":"#004ecc"}},[_vm._v(_vm._s(user.name))]),_vm._v(" "),_c('a',{staticClass:"fa fa-times",on:{"click":function($event){return _vm.deleteUser(user)}}})])}),_vm._v(" "),(!_vm.isExtraFlowActive && !_vm.isOverFlow)?_c('el-autocomplete',{ref:"searchUser",staticStyle:{"width":"160px"},attrs:{"popper-class":"flow-action-area-autocomplete","fetch-suggestions":_vm.searchHandleTaskData,"placeholder":_vm.$lang('请输入内容')},on:{"select":_vm.setSelCandidateUser},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"name"},[_vm._v(_vm._s(scope.item.name)),(scope.item.departmentFullName)?_c('span',{staticClass:"addr"},[_vm._v("("+_vm._s(scope.item.departmentFullName)+")")]):_vm._e()])]}}],null,false,2205305489),model:{value:(_vm.selUserModel),callback:function ($$v) {_vm.selUserModel=$$v},expression:"selUserModel"}}):_vm._e()],2)],1)],1):_vm._e(),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"5px","text-align":"center"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[(_vm.actions.indexOf('flowcomplete')>=0)?_c('el-button',{staticClass:"hg_form_btn_cls",attrs:{"type":"default","loading":_vm.submitLoading},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.$lang("流转")))]):_vm._e(),_vm._v(" "),(_vm.actions.indexOf('flowreject')>=0)?_c('el-button',{staticClass:"hg_form_btn_cls",attrs:{"type":"default"},on:{"click":_vm.reject}},[_vm._v(_vm._s(_vm.$lang("退回")))]):_vm._e(),_vm._v(" "),(_vm.actions.indexOf('flowreaded')>=0)?_c('el-button',{staticClass:"hg_form_btn_cls",attrs:{"type":"default"},on:{"click":_vm.flowreaded}},[_vm._v(_vm._s(_vm.$lang("阅毕")))]):_vm._e(),_vm._v(" "),(_vm.actions.indexOf('flowsave')>=0)?_c('el-button',{staticClass:"hg_form_btn_cls",attrs:{"type":"info","loading":_vm.saveLoading},on:{"click":_vm.formSave}},[_vm._v(_vm._s(_vm.$lang("保存")))]):_vm._e(),_vm._v(" "),(_vm.actions.indexOf('flowplanned')>=0)?_c('el-button',{staticClass:"hg_form_btn_cls",attrs:{"type":"default"},on:{"click":_vm.flowplanned}},[_vm._v(_vm._s(_vm.$lang("拟办")))]):_vm._e(),_vm._v(" "),(_vm.actions.indexOf('flowtransmit')>=0 && _vm.canTransmit)?_c('el-button',{staticClass:"hg_form_btn_cls",attrs:{"type":"default"},on:{"click":_vm.flowtransmit}},[_vm._v(_vm._s(_vm.$lang("转办")))]):_vm._e(),_vm._v(" "),_vm._l((_vm.footerItems),function(item){return [(!item.noShow)?[(item.handler && item.text)?[_c('el-button',{staticClass:"hg_form_btn_cls",attrs:{"type":"default","icon":item.icon},on:{"click":item.handler}},[_vm._v(_vm._s(item.text))])]:[_c(item,{tag:"component"})]]:_vm._e()]})],2)],1),_vm._v(" "),_vm._l((_vm.flows),function(flow){return _c('el-dialog',{key:flow.id,attrs:{"title":_vm.$lang('选择人员'),"visible":_vm.dialogVisible && _vm.selectedFlowId===flow.id,"width":"500px","show-close":false,"append-to-body":""},on:{"opened":_vm.dialogOpened,"open":_vm.dialogOpen}},[_c('div',{style:({'max-height':_vm.maxHeight,overflow:'auto'})},[(flow.userTreeVisible)?_c('mw-complete-tree',{ref:flow.id,refInFor:true,attrs:{"url":'/rest/process/task/flow/'+ _vm.form.taskId + '/' + flow.id,"defaultParams":_vm.processTaskLoadUser(flow,{returnTree:flow.options.returnTree}),"autoSelectSingle":false,"businessId":_vm.form.businessId,"batchId":_vm.form.batchId,"activityId":flow.activityId,"async":true,"multiple":!!flow.options.multipleUnit,"expandedFirst":true,"mulNodeNotExpand":true,"type":flow.type,"flowCount":_vm.flowCount}}):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.setSelectUsers(flow)}}},[_vm._v(_vm._s(_vm.$lang("确 定")))]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v(_vm._s(_vm.$lang("取 消")))])],1)])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_action_top_area_vue__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_action_top_area_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_action_top_area_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_action_top_area_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_action_top_area_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2ff18555_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flow_action_top_area_vue__ = __webpack_require__(925);
function injectStyle (ssrContext) {
  __webpack_require__(923)
  __webpack_require__(924)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ff18555"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_action_top_area_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2ff18555_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flow_action_top_area_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 923 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form_head_top",style:({height:_vm.height,overflow:'auto',padding:'6px 20px','background-color':'#e9ebe9',border:'solid 1px #ddd'})},[_c('el-row',{attrs:{"gutter":20}},[(_vm.showHeadLeftButton)?_c('el-col',{staticClass:"form_head_left_buttom",staticStyle:{"text-align":"left"},attrs:{"span":8}}):_c('el-col',{staticStyle:{"text-align":"left"},attrs:{"span":8}},[_c('div',{staticStyle:{"font-size":"24px","line-height":"35px","color":"white"}},[_vm._v(_vm._s(_vm.$lang('标题'))+"："+_vm._s(_vm.businessName))])]),_vm._v(" "),_c('el-col',{staticClass:"form_head_buttom",staticStyle:{"text-align":"right"},attrs:{"span":16}},[_vm._l((_vm.buttons),function(button){return (_vm.isShowBtn)?_c('el-button',{key:button.action,staticStyle:{"margin-right":"4px"},attrs:{"type":"default","loading":button.loading},on:{"click":function($event){return _vm._doAction(button.action)}}},[_vm._v(_vm._s(button.name)+"\n      ")]):_vm._e()}),_vm._v(" "),_vm._l((_vm.footerItems),function(item){return [(!item.noShow)?[(item.handler && item.text)?[_c('el-button',{attrs:{"type":"default","icon":item.icon},on:{"click":item.handler}},[_vm._v(_vm._s(item.text))])]:[_c(item,{tag:"component"})]]:_vm._e()]})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('div',{staticClass:"mw-panel",class:{'flow-area-on-top':((_vm.type==='module_flow' || _vm.isCheck || _vm.normalFlowBtn) && _vm.flowActionPosition==='top')},staticStyle:{"position":"relative"}},[_c('div',{staticClass:"mw-open-form ",class:{'mw-normal-form_layout':(_vm.type==='module_normal' && !_vm.normalFlowBtn || _vm.isBottonArea)?true:false,'mw-read-only-form':(!_vm.editMode && !_vm.isTopArea)},style:({height:(_vm.type==='module_flow' && _vm.processDefinitionId || _vm.normalFlowBtn) && _vm.editMode && _vm.isBottonArea?'calc(100% - '+(_vm.flowAreaBottomSelRowHeight+50)+'px)':((_vm.type==='module_flow' || _vm.isCheck || _vm.normalFlowBtn) && _vm.isTopArea?'calc(100% - 50px)':'100%')})},[_c('div',{staticClass:"mw-form-left-con"},[_vm._m(0),_vm._v(" "),((_vm.type=='module_flow' || _vm.normalFlowBtn) && _vm.editMode && !_vm.isVerticalArea)?_c('div',{staticClass:"mw-form-right-con"},[(_vm.rightCustomCompId)?[_c('div',{ref:"rightCustomCompDiv",staticStyle:{"width":"100%","height":"100%"}})]:[_c('div',{staticClass:"comment"},[_c('div',{staticClass:"comment-tip"},[_vm._v(_vm._s(_vm.$lang("常用意见"))+"\n              "),_c('el-button',{on:{"click":function($event){return _vm.editComment()}}},[_vm._v(_vm._s(_vm.$lang("编辑常用意见")))])],1),_vm._v(" "),_c('div',{staticClass:"comment-list"},_vm._l((_vm.comments),function(c,index){return _c('div',{key:index},[_c('a',{domProps:{"textContent":_vm._s(c.title)},on:{"click":function($event){return _vm.selComment(c.title)}}})])}),0),_vm._v(" "),(_vm.extCustomCommentCompId)?[_c('div',{ref:"extCustomCommentRef"})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"comment-tip"},[_vm._v(_vm._s(_vm.$lang("填写意见"))+"\n              "),_c('el-button',{on:{"click":function($event){return _vm.addComment()}}},[_vm._v(_vm._s(_vm.$lang("添加到常用意见")))])],1),_vm._v(" "),_c('div',{staticClass:"comment-sub"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],staticStyle:{"border":"1px solid #9e9e9e","width":"100%"},attrs:{"rows":"5","placeholder":_vm.$lang('请输入或选择常用意见'),"disabled":_vm.disabledComment},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}})])],2),_vm._v(" "),_c('div',{staticClass:"form-btn"},_vm._l((_vm.buttons),function(button){return _c('el-button',{key:button.action,attrs:{"type":"primary","loading":button.loading},on:{"click":function($event){return _vm._doAction(button.action)}}},[_vm._v(_vm._s(button.name)+"\n            ")])}),1),_vm._v(" "),(_vm.type=='module_flow')?_c('div',{staticClass:"flow-form-tip"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$lang('当前节点')))]),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"50px"}},[_c('ul',[_c('li',[_c('span',{staticClass:"path_btn_style",attrs:{"ondragstart":"return false;","href":"#"}},[_c('span',[_vm._v(_vm._s(_vm.$lang(_vm.curTackName)))])])])])]),_vm._v(" "),(!_vm.notLoadFlows)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$lang("提交流转")))]):_vm._e(),_vm._v(" "),(!_vm.notLoadFlows)?_c('div',{staticClass:"path_list"},[_c('div',{staticClass:"path_fix_ico"},[_vm._v(_vm._s(_vm.$lang('送达')))]),_vm._v(" "),_c('ul',{staticClass:"path_btn"},_vm._l((_vm.flows),function(f,index){return _c('li',{class:_vm.flows.length===1 ? '': index===0 ? 'top': index===_vm.flows.length-1 ? 'bottom': ''},[_c('span',{staticClass:"path_btn_style",attrs:{"ondragstart":"return false;","href":"#"}},[_c('span',[_vm._v(_vm._s(_vm.transFlowName(f.name)))])])])}),0)]):_vm._e()]):_vm._e()]],2):_vm._e(),_vm._v(" "),((_vm.type=='module_flow' || _vm.normalFlowBtn)  && _vm.isTopArea)?_c('div',{ref:"rightComment",staticClass:"mw-form-right-con split-right-con"},[_c('iframe',{staticStyle:{"border":"0px currentColor","left":"-8px","width":"100%","height":"100%","position":"absolute","z-index":"0"}}),_vm._v(" "),_c('div',{staticClass:"right_panel_btn right-sidebar-toggle",on:{"click":_vm.sidebarBtn}}),_vm._v(" "),_c('div',{staticClass:"comment",staticStyle:{"position":"relative"}},[(_vm.editMode)?_c('div',{staticClass:"comment-tip"},[_c('span',{staticStyle:{"color":"black","font-weight":"600"}},[_vm._v(_vm._s(_vm.$lang("填写意见")))]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","right":"88px"},attrs:{"type":"default","title":"编辑常用意见"},on:{"click":function($event){return _vm.editComment()}}},[_c('i',{staticClass:"fa fa-cog"})]),_vm._v(" "),_c('el-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSelComment),expression:"showSelComment"}],staticStyle:{"float":"right"},on:{"command":_vm.selComment,"click":_vm.selComment}},[_c('el-button',{staticStyle:{"position":"inherit"},attrs:{"type":"default"}},[_vm._v("\n                  常用意见"),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},_vm._l((_vm.comments),function(c,index){return _c('el-dropdown-item',{key:index,attrs:{"command":c.title}},[_vm._v(_vm._s(c.title))])}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.editMode)?_c('div',{staticClass:"comment-sub",staticStyle:{"margin-bottom":"10px"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],staticStyle:{"border":"1px solid #9e9e9e","width":"100%"},attrs:{"rows":"5","placeholder":_vm.$lang('请输入或选择常用意见'),"disabled":_vm.disabledComment},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flowComment",staticStyle:{"margin-bottom":"10px"}},[_c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("批示意见汇总")]),_vm._v(" "),_c('div',{staticClass:"list_normal",style:({height:_vm.fjheight,overflow:'auto'})},[_c('ul',{staticClass:"down_table_list_text"},_vm._l((Array.prototype.reverse.call(_vm.taskComments)),function(c,index){return _c('li',{key:index},[_c('dl',{staticClass:"down_other_file"},[_c('dd',[_c('div',{staticClass:"file_tips"},[_vm._v(_vm._s(c.content))]),_vm._v(" "),_c('div',{staticClass:"file_title",staticStyle:{"padding-bottom":"0px","font-size":"12px"}},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.moment(c.createTime).format("MM-DD HH:mm")))]),_vm._v("\n                            "+_vm._s(c.department+':'+c.creator))])])])])}),0)])])],1)],1),_vm._v(" "),_c('div',{staticClass:"flowAttachment"},[_c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("查看附件")]),_vm._v(" "),_c('div',{staticClass:"list_normal",style:({height:_vm.fjheight,overflow:'auto'})},[_c('ul',{staticClass:"down_table_list_text"},_vm._l((_vm.attachmentData),function(c,index){return _c('li',{key:index},[_c('dl',{staticClass:"down_other_file"},[_c('dd',[_c('div',{staticClass:"file_title"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.downAttachment(c.id)}}},[_vm._v(_vm._s(c.name))])]),_vm._v(" "),_c('div',{staticClass:"file_tips_info"},[_vm._v(_vm._s(c.creator+' '+_vm.moment(c.createTime).format("MM-DD HH:mm")))])])])])}),0)])])],1)],1)])]):_vm._e()])]),_vm._v(" "),((_vm.type==='module_flow' && _vm.processDefinitionId || _vm.normalFlowBtn ) && _vm.editMode && _vm.isBottonArea)?_c('flow-action-area',{ref:"footerArea",staticClass:"vertical-flow-area",attrs:{"height":(_vm.flowAreaBottomSelRowHeight+50)+'px',"form":this}}):_vm._e(),_vm._v(" "),((_vm.type==='module_flow' || _vm.normalFlowBtn || _vm.isCheck ) && _vm.isTopArea)?_c('flow-action-top-area',{ref:"footerArea",staticClass:"vertical-flow-area",attrs:{"height":"50px","form":this,"buttons":_vm.buttons}}):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-form-left"},[_c('div',{staticClass:"__body"},[_c('div',{staticClass:"mw-form_id"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0c02adc8_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(929);
function injectStyle (ssrContext) {
  __webpack_require__(928)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c02adc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0c02adc8_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 928 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-spinner sk-spinner-wave"},[_c('div',{staticClass:"sk-rect1"}),_vm._v(" "),_c('div',{staticClass:"sk-rect2"}),_vm._v(" "),_c('div',{staticClass:"sk-rect3"}),_vm._v(" "),_c('div',{staticClass:"sk-rect4"}),_vm._v(" "),_c('div',{staticClass:"sk-rect5"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_61023cc3_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(935);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_61023cc3_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(932), __esModule: true };

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96);
__webpack_require__(933);
module.exports = __webpack_require__(18).Array.from;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(64);
var $export = __webpack_require__(28);
var toObject = __webpack_require__(88);
var call = __webpack_require__(284);
var isArrayIter = __webpack_require__(285);
var toLength = __webpack_require__(134);
var createProperty = __webpack_require__(934);
var getIterFn = __webpack_require__(195);

$export($export.S + $export.F * !__webpack_require__(291)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(49);
var createDesc = __webpack_require__(105);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageReady)?_c(_vm.$component,{ref:"pageObj",tag:"component",attrs:{"params":_vm.params}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7d493d04_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(941);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7d493d04_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_resizer_vue__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_resizer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_resizer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_resizer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_resizer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2456831a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_resizer_vue__ = __webpack_require__(938);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_resizer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2456831a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_resizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_pane_vue__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_pane_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_pane_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_pane_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_pane_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_baf5085c_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_pane_vue__ = __webpack_require__(940);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_pane_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_baf5085c_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_pane_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var _obj, _obj$1, _obj$2;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-splitter-container clearfix",style:({ cursor: _vm.cursor, userSelect: _vm.userSelect}),on:{"mouseup":_vm.onMouseUp,"mousemove":_vm.onMouseMove}},[_c('pane',{staticClass:"splitter-pane splitter-paneL",style:(( _obj = {}, _obj[_vm.type] = _vm.percent+'%', _obj )),attrs:{"split":_vm.split}},[_vm._t("paneL")],2),_vm._v(" "),_c('resizer',{style:(( _obj$1 = {}, _obj$1[_vm.resizeType] = _vm.percent+'%', _obj$1['display'] = _vm.percent>0?'inherit':'none', _obj$1 )),attrs:{"split":_vm.split},nativeOn:{"mousedown":function($event){return _vm.onMouseDown($event)},"click":function($event){return _vm.onClick($event)}}}),_vm._v(" "),_c('pane',{staticClass:"splitter-pane splitter-paneR",style:(( _obj$2 = {}, _obj$2[_vm.type] = 100-_vm.percent+'%', _obj$2 )),attrs:{"split":_vm.split}},[_vm._t("paneR")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticStyle:{"position":"absolute","top":"0","left":"0","bottom":"0","right":"0"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_297d6b76_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(944);
function injectStyle (ssrContext) {
  __webpack_require__(943)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_297d6b76_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel mw-tree-select"},[(_vm.search)?_c('div',{staticClass:"mw-tree-search"},[_c('el-input',{attrs:{"placeholder":"请输入搜索内容","clearable":""},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1):_vm._e(),_vm._v(" "),_c('div',{class:{'mw-tree-search__body':_vm.search,'mw-tree-no-search__body':!_vm.search}},[_c('div',{staticClass:"mw-tree"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4040d33c_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(946);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4040d33c_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-sizes":_vm.pageSizes,"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.sizeChange,"current-change":_vm.currentChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3fcd2dde_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(949);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3fcd2dde_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _vuex = __webpack_require__(9);
var _doubleface = __webpack_require__(209);var _doubleface2 = _interopRequireDefault(_doubleface);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  name: 'mw-table',

  data: function data() {

    var me = this,data = {
      total: 0,
      dataList: [],
      filters: {},
      loading: false,
      colSort: '',
      colDir: '',
      multipleSelection: [],
      enableSortable: false };

    if (me.pagination) {
      return this.mwUtil.applyIf(
      data, this.mwConfig.pagination);
    } else {
      return data;
    }
  },
  created: function created() {

  },

  props: {
    api: {
      type: String },

    autoLoad: {
      type: Boolean,
      default: true },


    data: {
      type: Array },

    currentKey: {
      type: String,
      default: 'default' },

    pagination: {
      type: Boolean,
      default: true },

    noPaginationLimit: {
      type: Number },

    readerAuthorize: {
      type: Boolean },

    border: {
      type: Boolean,
      default: true },

    showHeader: {
      type: Boolean,
      default: true },

    defaultParams: {
      type: Object },

    customCondition: {
      type: String },




    showRowExpander: Boolean,
    extCustomCondition: {
      type: String },

    defaultParamsAutoLoad: {
      type: Boolean,
      default: false },

    applicationId: {
      type: String },

    unitFilter: {
      type: Boolean,
      default: false },

    deptFilter: {
      type: Boolean,
      default: false },


    defaultSort: {
      type: Array,
      default: function _default() {
        return [];
      } },


    nowrap: {
      type: Boolean,
      default: true },


    columns: {
      type: Array,
      default: function _default() {
        return [];
      } },

    singleSelect: {
      type: Boolean,
      default: false },

    defaultDblClick: {
      type: Boolean,
      default: true },

    allowLoaded: {
      type: Boolean,
      default: true } },


  mounted: function mounted() {var _this = this;
    this.$nextTick(function () {
      _this.processPageSize();
      if (_this.autoLoad) {
        _this.loadData();
      }
    });
  },
  computed: (0, _extends3.default)({},
  (0, _vuex.mapGetters)([
  'curSelUnitId',
  'curSelDeptId'])),


  watch: {
    defaultParams: function defaultParams(val) {
      this.defaultParams = val;
      this.currentPage = 1;
      this.filters = {};
      if (this.defaultParamsAutoLoad) {
        this.loadData();
      } else {
        this.defaultParamsChange();
      }
    },

    currentKey: function currentKey(_currentKey) {var _this2 = this;
      this.currentKey = _currentKey;
      this.currentPage = 1;
      this.filters = {};

      this.$nextTick(function () {
        _this2.loadData();
      });
    },
    dataList: function dataList() {
      if (this.enableSortable) this.sortable();
    } },

  methods: {
    rowExpandChange: function rowExpandChange(row, expandedRows) {var _this3 = this;
      var copyRows = expandedRows.map(function (r) {return r;});
      var allRows = this.dataList;
      copyRows.sort(function (a, b) {
        var indexA = allRows.indexOf(a);
        var indexB = allRows.indexOf(b);
        return indexA < indexB ? -1 : indexA > indexB ? 1 : 0;
      });
      var index = copyRows.indexOf(row);
      if (index > -1) {
        this.$nextTick(function () {
          var container = $(_this3.$el).find(".mw-row-expand-container").eq(index);
          _this3.$emit("rowExpanded", row, container);
        });
      }
    },
    _rowSelectable: function _rowSelectable(row, index) {
      return !_.isFunction(this.rowSelectable) || this.rowSelectable(row, index);
    },
    getRowKeys: function getRowKeys(row) {
      return row.id;
    },
    processPageSize: function processPageSize() {
      var me = this;
      if (me.pagination) {
        if (me.defaultParams && me.defaultParams.limit) {
          me.limit = me.defaultParams.limit;
        } else {
          if (!me.mwRef("multipleTable")) return;
          var tableHeight = $(me.mwRef("multipleTable").$el).height();
          var rowNum = Math.floor(tableHeight / 38);
          if (rowNum < 6) rowNum = 6;
          me.limit = rowNum;
        }
      }
    },
    columnClick: function columnClick($scope, scope, func) {
      var me = this;
      if ($scope)
      func.call($scope, scope.row, me._getMe(), me.currentKey);else

      func(scope.row, me._getMe(), me.currentKey);
    },

    defaultParamsChange: function defaultParamsChange() {

      this.$emit('params-change', this.defaultParams);
    },
    getMultipleSelection: function getMultipleSelection() {
      return this.multipleSelection;
    },

    selectByProp: function selectByProp(prop, value) {
      var idx = undefined;
      for (var i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i][prop] === value) {
          idx = i;
          break;
        }
      }
      if (idx != undefined) {
        if (this.singleSelect) {
          this.mwRef('multipleTable').clearSelection();
        }
        this.mwRef('multipleTable').setCurrentRow(this.dataList[idx]);
        this.mwRef('multipleTable').toggleRowSelection(this.dataList[idx]);
      }
    },
    selectAll: function selectAll(selection) {
      this.$emit('selectAll', selection);
    },
    select: function select(selection, row) {
      if (this.singleSelect) {
        this.mwRef('multipleTable').clearSelection();
        this.multipleSelection = [];
        this.mwRef('multipleTable').toggleRowSelection(row);
      }
      this.$emit('select', selection, row);
    },

    clearSelection: function clearSelection() {
      this.mwRef('multipleTable').clearSelection();
    },

    rowClick: function rowClick(row, event, column) {
      var index = this.dataList.indexOf(row);
      var selectable = this._rowSelectable(row, index);
      if (this.singleSelect && selectable) {
        this.mwRef('multipleTable').clearSelection();
      }
      this.$emit('rowClick', row, event, column);
      if (selectable) {
        this.mwRef('multipleTable').toggleRowSelection(row);
      }
    },
    toggleRowSelection: function toggleRowSelection(row, selected) {
      this.mwRef('multipleTable').toggleRowSelection(row, selected);
    },
    selectChange: function selectChange(selection) {
      this.multipleSelection = selection;
      this.$emit('selectChange', selection);
    },
    rowStyle: function rowStyle(row, index) {
      var ret = {};
      this.$emit('rowStyle', row, index, ret);
      return ret;
    },
    refresh: function refresh() {
      this.loadData();
    },
    search: function search(filter) {
      this.loadData(filter);
    },

    getData: function getData() {
      return this.dataList;
    },

    setData: function setData(data, callback) {
      this.dataList = data;
      if (callback) {
        this.$nextTick(function () {
          callback();
        });
      }
    },



    loadData: function loadData(filter) {var _this4 = this;
      if (!this.allowLoaded) {
        return;
      }
      if (!this.api) {
        this.dataList = this.data;
      } else {
        var me = this;
        var para = {};
        if (me.pagination) {
          para = {
            start: (me.currentPage - 1) * me.limit,
            limit: me.limit };

        } else {
          if (me.noPaginationLimit != undefined) {
            para = {
              start: 0,
              limit: me.noPaginationLimit };

          }
        }
        if (filter) {
          var keys = me.mwLodash.keys(filter);
          var fm = {};
          keys.forEach(function (v) {
            if (filter[v]) {
              fm[v] = filter[v];
            }
          });
          keys = me.mwLodash.keys(fm);
          if (keys.length > 0) {
            this.currentPage = 1;
            if (para.start != undefined) {
              para.start = 0;
            }
            me.filters = { filter: fm };
          } else
          {
            me.filters = {};
          }
        }
        me._applyNotEmptyIf(para, me.filters);
        if (me.defaultParams) {
          this.mwUtil.applyIf(para, me.defaultParams);
        }
        me.loading = true;
        if (me.colSort && me.colDir) {
          para.sorts = [{ sort: me.colSort, dir: me.colDir }];
        } else {
          para.sorts = me.defaultSort;
        }
        if (me.unitFilter) {
          if (me.curSelUnitId) {
            para.unitFilter = me.curSelUnitId;
          }
        }
        if (me.deptFilter) {
          if (me.curSelDeptId) {
            para.deptFilter = me.curSelDeptId;
          }
        }

        if (me.customCondition) {
          para.customCondition = me.customCondition;
        }

        if (me.extCustomCondition) {
          para.extCustomCondition = me.extCustomCondition;
        }

        if (me.readerAuthorize != undefined) {
          para.readerAuthorize = me.readerAuthorize;
        }
        if (me.applicationId) {
          para.applicationId = me.applicationId;
        }
        me.$emit('beforeloadData', para);
        if (!me.api.startsWith("/")) {
          if (me.api.startsWith("#")) {
            eval("PF.invokeInner('" + me.api.substring(1) + "',para)").then(function (data)
            {_this4.dataList = data.result;
              if (me.pagination) {
                if (data.totalCount)
                _this4.total = Number(data.totalCount);else

                _this4.total = 0;
              }
              me._dataLoad();
              _this4.loading = false;
            });
          } else {
            eval('this.mwApi.' + me.api + '(para)').then(function (data)
            {_this4.dataList = data.result;
              if (me.pagination) {
                if (data.totalCount)
                _this4.total = Number(data.totalCount);else

                _this4.total = 0;
              }
              me._dataLoad();
              _this4.loading = false;me._rendered();});
          }
        } else {

          eval("PF.invoke('" + me.api.substring(1) + "',para)").then(function (data)
          {_this4.dataList = data.result;
            if (me.pagination) {
              if (data.totalCount)
              _this4.total = Number(data.totalCount);else

              _this4.total = 0;
            }
            me._dataLoad();
            _this4.loading = false;me._rendered();});
        }
      }
    },
    _dataLoad: function _dataLoad() {
      this.$emit('dataLoaded', this.dataList, this.total);
    },
    _rendered: function _rendered() {var _this5 = this;
      var me = this;
      this.$nextTick(function () {
        _this5.$emit('rendered', _this5.dataList, me.$el);
      });
    },
    _applyNotEmptyIf: function _applyNotEmptyIf(o, c) {
      if (o) {
        for (var p in c) {
          if (!this.mwUtil.isDefined(o[p])) {
            if (c[p]) {
              o[p] = c[p];
            }
          }
        }
      }
      return o;
    },
    rowDblClick: function rowDblClick(row, event) {
      var me = this;
      if (me.defaultDblClick) {

      } else {
        me.$emit('row-dblclick', row, event);
      }
    },
    sizeChange: function sizeChange(val) {
      this.limit = val;
      this.loadData();
    },
    currentChange: function currentChange(val) {
      this.currentPage = val;
      this.loadData();
      this.mwRef('multipleTable').bodyWrapper.scrollTop = 0;
    },
    sortChange: function sortChange(column, prop, order) {
      if (column) {
        if (column.prop && column.order) {
          this.colDir = column.order == "descending" ? "DESC" : "ASC";
          this.colSort = column.prop;
          this.loadData();
          return;
        }
      }
      this.colDir = '';
      this.colSort = '';
      this.loadData();
    },
    _getScope: function _getScope() {
      return this;
    },
    _getMe: function _getMe() {
      var me = this;
      return {
        mwMsg: me.mwMsg.bind(me),
        mwConfirm: me.mwConfirm.bind(me),
        mwApi: me.mwApi,
        mwUtil: me.mwUtil,
        mwConfig: me.mwConfig,
        refresh: me.refresh };

    },
    getSortableEl: function getSortableEl() {
      return $(this.$el).find(".el-table__body-wrapper tbody");
    },
    sortable: function sortable() {
      var me = this;
      me.enableSortable = true;
      var el = this.getSortableEl();
      var dragStart = -1;
      var dragEnd = -1;
      el.sortable({
        start: function start(event, ui) {
          var item = ui.item;
          dragStart = item.index();
        },
        update: function update(event, ui) {
          var item = ui.item;
          dragEnd = item.index();
          updateDataList(dragStart, dragEnd);
        } }).
      disableSelection();
      function updateDataList(fromIndex, toIndex) {
        var copyDataList = me.dataList.slice();
        var d = copyDataList.splice(fromIndex, 1)[0];
        copyDataList.splice(toIndex, 0, d);
        var changes = [];
        for (var i = 0; i < me.dataList.length; i++) {
          var row = me.dataList[i];
          if (me.dataList[i] !== copyDataList[i]) {
            changes.push({
              row: row,
              oldIndex: i,
              newIndex: copyDataList.indexOf(row) });

          }
        }
        me.dataList = copyDataList;
        me.$emit("sortableUpdate", changes);
      }
    },
    cancelSortable: function cancelSortable() {
      this.enableSortable = false;
      var el = this.getSortableEl();
      el.sortable("cancel");
    } },

  components: {
    DoubleFace: _doubleface2.default } };

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('div',{class:{'mw-pagination__body': _vm.pagination,'mw-no-pagination__body': !_vm.pagination, 'mw-panel': !_vm.pagination}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"multipleTable",class:{ 'mw-table':true,'mw-nowrap':!_vm.nowrap, 'mw-single-select':_vm.singleSelect},attrs:{"border":_vm.border,"data":_vm.dataList,"show-header":_vm.showHeader,"row-style":_vm.rowStyle,"highlight-current-row":"","row-key":_vm.getRowKeys},on:{"sort-change":_vm.sortChange,"select":_vm.select,"select-all":_vm.selectAll,"row-click":_vm.rowClick,"selection-change":_vm.selectChange,"row-dblclick":_vm.rowDblClick,"expand-change":_vm.rowExpandChange}},[(_vm.showRowExpander)?_c('el-table-column',{attrs:{"type":"expand","width":"30","class-name":"mw-col-expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"mw-row-expand-container"})]}}],null,false,3554780800)}):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(item,index){return [(item.slot==undefined && item.slotName==undefined)?_c('el-table-column',{key:item.id+_vm.currentKey+index,attrs:{"prop":item.prop,"label":item.label?item.label:('index'==item.type?_vm.$lang('序号'):undefined),"type":item.type,"resizable":true,"align":item.align,"header-align":item.headerAlign,"fixed":item.fixed,"selectable":_vm._rowSelectable,"reserve-selection":item.reserve ? true: false,"show-overflow-tooltip":('selection'==item.type || ('index'==item.type))?false:(item.noTooltip?false:true),"formatter":item.formatter,"class-name":item.className,"label-class-name":item.labelClassName,"width":(item.width?(item.autoWidth?undefined:item.width):('selection'==item.type)?'35':('index'==item.type)?55:undefined),"min-width":item.minWidth ? item.minWidth:undefined,"sortable":(item.sortable ?item.sortable:undefined)},on:{"sort-change":function($event){(item.sortable ?'sortChange':undefined)}}}):(item.slotName!=undefined)?_c('el-table-column',{key:item.id+_vm.currentKey+index,attrs:{"prop":item.prop,"label":item.label,"type":item.type,"resizable":true,"align":item.align,"header-align":item.headerAlign,"fixed":item.fixed,"show-overflow-tooltip":item.noTooltip?false:true,"class-name":item.className,"label-class-name":item.labelClassName,"width":item.width?(item.autoWidth?undefined:item.width):undefined,"min-width":item.minWidth ? item.minWidth:undefined,"sortable":(item.sortable ?item.sortable:undefined)},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._t(item.slotName,null,{"scope":scope})]}}],null,true)}):(item.slot!=undefined)?_c('el-table-column',{key:item.id+_vm.currentKey+index,attrs:{"prop":item.prop,"label":item.label,"type":item.type,"resizable":true,"align":item.align,"header-align":item.headerAlign,"fixed":item.fixed,"show-overflow-tooltip":item.noTooltip?false:true,"formatter":item.formatter,"class-name":item.className,"label-class-name":item.labelClassName,"width":item.width?(item.autoWidth?undefined:item.width):undefined,"min-width":item.minWidth ? item.minWidth:undefined,"sortable":(item.sortable ?item.sortable:undefined)},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(item.slot['type']=='html')?[_c('a',{domProps:{"innerHTML":_vm._s(scope.row[item.prop])},on:{"click":function($event){return _vm.columnClick(item.slot.scope,scope,item.slot.func)}}})]:(item.slot['type']=='edit')?[_c('el-input',{directives:[{name:"show",rawName:"v-show",value:(scope.row.$_edit?scope.row.$_edit:true),expression:"scope.row.$_edit?scope.row.$_edit:true"}],attrs:{"size":"small"},model:{value:(scope.row[item.prop]),callback:function ($$v) {_vm.$set(scope.row, item.prop, $$v)},expression:"scope.row[item.prop]"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!scope.row.$_edit?scope.row.$_edit:true),expression:"!scope.row.$_edit?scope.row.$_edit:true"}]},[_vm._v(_vm._s(scope.row[item.prop]))])]:(item.slot['type']=='button')?_vm._l((item.slot.items),function(it,index){return _c('el-button',{key:'btnSlot'+index,staticClass:"mw-btn-mini",attrs:{"size":"mini"},on:{"click":function($event){it.func(scope.row,_vm._getMe(),scope.$index)}}},[(it.icon)?_c('i',{class:it.icon}):_vm._e(),_c('span',{domProps:{"innerHTML":_vm._s(it.label)}})])}):(item.slot['type']=='href')?[_c('a',{on:{"click":function($event){item.slot.func(scope.row,_vm._getMe(),scope.$index)}}},[_vm._v(_vm._s(item.slot.label?item.slot.label:scope.row[item.prop]))])]:(item.slot['type']=='editableInput')?[_c('double-face',[_c('span',{attrs:{"slot":"readonly"},slot:"readonly"},[_vm._v(_vm._s(scope.row[item.prop])+" ")]),_vm._v(" "),_c('span',{attrs:{"slot":"editable"},slot:"editable"},[_c('el-input',{on:{"change":function($event){item.slot.func(scope.row,_vm._getMe(),scope.$index)}},model:{value:(scope.row[item.prop]),callback:function ($$v) {_vm.$set(scope.row, item.prop, $$v)},expression:"scope.row[item.prop]"}})],1)])]:(item.slot['type']=='editableSelect')?[_c('double-face',[_c('span',{attrs:{"slot":"readonly"},slot:"readonly"},[_vm._v(_vm._s(scope.row[item.prop])+" ")]),_vm._v(" "),_c('span',{attrs:{"slot":"editable"},slot:"editable"},[(scope.row[item.prop+'__editable']==false)?_c('span',[_vm._v("\n                  "+_vm._s(scope.row[item.prop])+"\n              ")]):_c('el-select',{attrs:{"placeholder":_vm.$lang('请选择')},on:{"change":function($event){item.slot.func(scope.row,_vm._getMe(),scope.$index)}},model:{value:(scope.row[item.prop]),callback:function ($$v) {_vm.$set(scope.row, item.prop, $$v)},expression:"scope.row[item.prop]"}},_vm._l((item.slot.options),function(d){return _c('el-option',{key:d.value,attrs:{"label":d.label,"value":d.value}})}),1)],1)])]:_vm._e()]}}],null,true)}):_vm._e()]})],2)],1),_vm._v(" "),(_vm.pagination)?_c('mw-pagination',{attrs:{"total":_vm.total,"currentPage":_vm.currentPage,"pageSize":_vm.limit},on:{"size-change":_vm.sizeChange,"current-change":_vm.currentChange}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MwFormView_vue__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MwFormView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MwFormView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MwFormView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MwFormView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_9770771c_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_MwFormView_vue__ = __webpack_require__(952);
function injectStyle (ssrContext) {
  __webpack_require__(951)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MwFormView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_9770771c_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_MwFormView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mountPoint"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_c0d90580_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(956);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_c0d90580_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_template_vue__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_template_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_template_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_template_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_template_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_64d2a3c6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_template_vue__ = __webpack_require__(955);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_template_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_64d2a3c6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_template_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('div')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('split-pane',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout.length>0),expression:"layout.length>0"}],attrs:{"defaultPercent":_vm.propDefaultPercent,"split":"vertical"}},[(_vm.propDefaultPercent>0)?_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[(_vm.propShowTreeToolbar)?_c('div',{staticClass:"mw-toolbar mw-toolbar__left"},[_vm._l((_vm.treeToolbarItem),function(i){return [(!i.hidden)?_c('el-button',{staticClass:"tree-button",attrs:{"id":i.id},on:{"click":function($event){return _vm.treeToolbarBtnClick(i.$scope,i.func,i)}}},[_c('i',{class:i.icon}),_c('span',{domProps:{"innerHTML":_vm._s(i.label)}})]):_vm._e()]})],2):_vm._e(),_vm._v(" "),_c('div',{class:{'mw-toolbar__body':_vm.propShowTreeToolbar,'mw-panel':!_vm.propShowTreeToolbar}},[(_vm.treeConfig !=undefined)?_c('mw-tree',{ref:"tree",attrs:{"async":true,"ajaxType":"POST","checkCallback":_vm.checkCallback,"dragEnable":_vm.treeConfig.dragEnable?true:false,"expandedFirst":_vm.propTreeExpandFirst,"applicationId":_vm.applicationId,"selectFirst":true,"selectNode":_vm.selectNodeId,"treeData":_vm.treeConfig.treeData,"paramsAnalyze":_vm.treeConfig.paramsAnalyze,"url":_vm.treeConfig.url,"autoLoad":undefined==_vm.treeConfig.autoLoad?true:_vm.treeConfig.autoLoad},on:{"changed":_vm.treeConfig.changed,"ready":_vm.treeConfig.ready,"dataFilter":_vm.treeConfig.dataFilter}}):_vm._e()],1)])]):_vm._e(),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right "},[(_vm.propShowToolbar)?_c('div',{staticClass:"mw-toolbar"},[(_vm.propToolbarTitle?true:false)?_c('div',{staticClass:"mw__title pull-left",style:({width:_vm.propToolbarTitleWidth+'px'})},[_c('h5',{domProps:{"innerHTML":_vm._s(_vm.propToolbarTitle)}})]):_vm._e(),_vm._v(" "),_c('div',{class:{'mw__body':_vm.propToolbarTitle?true:false,'pull-left':_vm.propToolbarTitle?true:false},style:({width:(_vm.propToolbarTitle?('calc(100% - '+ _vm.propToolbarTitleWidth+'px)'):'100%')})},[(_vm.menuItems.length>1?true:false)?_c('div',{staticClass:"mw__body__menu pull-left",style:({width:_vm.propMenuItemWidth+'px'})},[_c('el-menu',{attrs:{"default-active":_vm.defaultKey,"mode":"horizontal"},on:{"select":_vm._handleSelect}},_vm._l((_vm.menuItems),function(i){return (!i.hidden)?_c('el-menu-item',{key:i.key,attrs:{"index":i.key}},[_vm._v(_vm._s(i.label)+"\n                  "),(i.sumKey)?_c('span',{staticClass:"badge badge-danger",domProps:{"innerHTML":_vm._s(_vm.sumData[i.sumKey])}}):_vm._e()]):_vm._e()}),1)],1):_vm._e(),_vm._v(" "),_c('div',{class:{'pull-left':_vm.menuItems.length>1?true:false},style:({width:_vm.menuItems.length>1?'calc(100% - '+ _vm.propMenuItemWidth+'px)':'100%'})},[_c('el-row',_vm._l((_vm.layoutGroupItem),function(item){return (item.span?true:false)?_c('el-col',{key:item.type,style:(item.style ? item.style+' height:50px;':'height:50px;'),attrs:{"span":item.span,"offset":item.offset?item.offset:0}},[(item.type=='button')?[(item.prefixSlot!=undefined)?[_vm._t(item.prefixSlot)]:_vm._e(),_vm._v(" "),_vm._l((item.items),function(i){return [(!i.sumKey)?_c('el-button',{key:i.label,attrs:{"type":i.type?i.type:''},on:{"click":function($event){return _vm.toolbarBtnClick(i.$scope,i.func,i,$event)}}},[_c('i',{class:i.icon}),_c('span',{domProps:{"innerHTML":_vm._s(i.label)}})]):_vm._e(),_vm._v(" "),(i.sumKey)?_c('el-badge',{attrs:{"value":_vm.btnSumData[i.sumKey]}},[_c('el-button',{key:i.label,attrs:{"type":i.type?i.type:''},on:{"click":function($event){return _vm.toolbarBtnClick(i.$scope,i.func,i,$event)}}},[_c('i',{class:i.icon}),_c('span',{domProps:{"innerHTML":_vm._s(i.label)}})])],1):_vm._e()]}),_vm._v(" "),(item.suffixSlot!=undefined)?[_vm._t(item.suffixSlot)]:_vm._e()]:(item.type=='searchText')?[_c('div',{staticStyle:{"padding-top":"8px","line-height":"30px"}},[_c('el-input',{attrs:{"placeholder":_vm.$lang(item.tip?item.tip:'名称')},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.searchText($event)}},model:{value:(_vm.filters[item.name]),callback:function ($$v) {_vm.$set(_vm.filters, item.name, $$v)},expression:"filters[item.name]"}},[_c('el-button',{directives:[{name:"waves",rawName:"v-waves"}],attrs:{"slot":"append","type":"primary"},on:{"click":_vm.searchText},slot:"append"},[_vm._v(_vm._s(_vm.$lang('查询')))])],1)],1)]:(item.type=='custom')?[_c('div',{ref:"toolbarCustomArea",refInFor:true,staticStyle:{"padding-top":"8px","line-height":"30px"},attrs:{"toolbar_custom_area":"true"}})]:(item.type=='searchBox')?[_c('el-popover',{attrs:{"placement":"bottom","popper-class":"mw-toolbar-popover","width":"500","trigger":"click"}},[_c('div',{staticClass:"mw__body"},[_c('el-form',{attrs:{"label-width":"100px"}},[_vm._l((item.fields),function(f){return [(f.type=='date')?[_c('el-form-item',{attrs:{"label":f.label+' :'}},[_c('el-col',{attrs:{"span":4}},[_vm._v("\n                                "+_vm._s(_vm.$lang("全部"))+"\n                              ")]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('el-date-picker',{attrs:{"align":"right","type":"year","placeholder":"选择年"}})],1)],1)]:(f.type=='single')?[_c('el-form-item',{attrs:{"label":f.label+' :'}},[_c('el-col',{attrs:{"span":4}},[_c('span',{on:{"click":function($event){return _vm._wholeClick(f)}}},[_vm._v(_vm._s(_vm.$lang("全部")))])]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_vm._l((f.items),function(t){return [_c('el-col',{attrs:{"span":6}},[_c('span',{domProps:{"innerHTML":_vm._s(t.label)}})])]})],2)],1)]:_vm._e()]})],2)],1),_vm._v(" "),_c('el-button',{staticClass:"search-box",attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"fa fa-list-ul"}),_vm._v(_vm._s(_vm.$lang("筛选条件")))])],1)]:(item.type=='slot')?[_vm._t(item.name)]:_vm._e()],2):_vm._e()}),1)],1)]),_vm._v(" "),(_vm.morePath || _vm.moreFn?true:false)?_c('div',{staticClass:"mw-more"},[_c('el-button',{on:{"click":function($event){return _vm._more()}}},[_vm._v("更多")])],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{class:{'mw-toolbar__body':_vm.propShowToolbar,'mw-panel':!_vm.propShowToolbar}},[(_vm.compType=='page' && _vm.pageCompId)?_c('mw-inner-page',{ref:"dataPage",attrs:{"params":_vm.defaultParams,"noWrap":"","pageId":_vm.pageCompId}}):_c('mw-table',{ref:"dataTable",attrs:{"defaultParams":_vm.defaultParams,"showHeader":_vm.propShowHeader,"columns":_vm.columns,"singleSelect":_vm.singleSelect,"currentKey":_vm.currentKey,"defaultSort":_vm.defaultSort,"border":_vm.propBorder,"autoLoad":false,"pagination":_vm.propPagination,"noPaginationLimit":_vm.propNoPaginationLimit,"data":_vm.dataList,"allowLoaded":_vm.allowLoaded,"nowrap":_vm.nowrap,"api":_vm.api,"customCondition":_vm.customCondition,"readerAuthorize":_vm.readerAuthorize,"showRowExpander":_vm.showRowExpander,"extCustomCondition":_vm.extCustomCondition,"unitFilter":_vm.propUnitFilter,"applicationId":_vm.applicationId,"deptFilter":_vm.propDeptFilter},on:{"params-change":_vm._paramsChange,"rowStyle":_vm.rowStyle,"sortableUpdate":_vm.sortableUpdate,"rendered":_vm.rendered,"rowExpanded":_vm.rowExpanded,"dataLoaded":_vm.dataLoaded},scopedSlots:_vm._u([_vm._l((_vm.columns),function(item,index){return {key:item.slotName,fn:function(ref){
var scope = ref.scope;
return (undefined !=item.slotName)?[_vm._t(item.slotName,null,{"scope":scope,"row":scope.row,"column":scope.column,"$index":scope.$index})]:undefined}}})],null,true)})],1)])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default = {
  name: 'mw-upload-table',
  data: function data() {
    return {
      columns: [],

      fileList: [],
      accept: '',
      maxSize: 10,
      uploader: null,
      fileUploadVisible: false,
      fileUploadMsg: '',
      uploadPercent: 0 };

  },
  created: function created() {

  },
  props: {
    action: {
      type: String,
      required: true },

    deleteShow: {
      type: Boolean,
      default: true },

    addShow: {
      type: Boolean,
      default: true },

    recordsIsCanEdit: {
      type: Function },

    renameShow: {
      type: Boolean,
      default: true },

    downloadShow: {
      type: Boolean,
      default: true },

    sortable: {
      type: Boolean,
      default: true },

    multiple: {
      type: Boolean,
      default: true },

    name: {
      type: String,
      default: 'file' },

    limit: {
      type: Number },

    api: {
      type: String,
      required: true },

    defaultParams: {
      type: Object } },



  mounted: function mounted() {
    var me = this;
    if (me.limit && me.limit == 1)
    me.multiple = false;
    me.accept = PF._sysConfig && PF._sysConfig.uploadAttachFormat || "";
    me.maxSize = PF._sysConfig && PF._sysConfig.uploadAttachMaxSize || 10;

    if (me.defaultParams.accept)
    me.accept = me.defaultParams.accept;
    me.initPupload();
    var nameCol = { prop: 'fileName', label: $lang('名称') };
    if (this.renameShow) nameCol.slot = { type: "editableInput", func: this.rename };
    this.columns.push({ type: 'selection' }, { type: 'index', sortable: true },
    nameCol,
    { prop: 'mimeType', label: $lang('扩展名'), width: '80' },
    { prop: 'size', label: $lang('大小'), width: '100', formatter: this._attachFormatter });

    var showPageNum = window.$Env && $Env.attachDlgShowPageNum || false;
    if (showPageNum) {
      this.columns.push({ prop: 'pageNum', label: $lang('页数'), width: '60',
        slot: { type: "editableInput", func: this.setPageNum } });

    }
    var showMJBS = window.$Env && $Env.attachDlgShowMJBS || false;
    if (showMJBS) {
      var secOptions = [{ value: '', label: '无' }, { value: '非密', label: '非密' }, { value: '秘密', label: '秘密' }, { value: '机密', label: '机密' }];
      if (window.$Env && window.$Env.secOptions) {
        secOptions = window.$Env.secOptions;
      }

      var secLevel = this.defaultParams.secLevel;
      if (secLevel == "机密" || secLevel == "1") {

      } else if (secLevel == "秘密" || secLevel == "2") {
        secOptions = secOptions.slice(0, 3);
      } else {
        secOptions = secOptions.slice(0, 2);
      }
      this.columns.push({ prop: 'fldmjbs', label: $lang('密级'), width: '80',
        slot: { type: "editableSelect", func: this.setMJBS, options: secOptions } });

    }

    if (this.sortable == true) {}
    this.mwRef('table').sortable();
  },
  watch: {
    'defaultParams.tempBusinessId': function defaultParamsTempBusinessId(val) {
      this.mwRef('table').refresh();
    },
    'defaultParams.businessId': function defaultParamsBusinessId(val) {
      this.mwRef('table').refresh();
    } },

  methods: {
    initPupload: function initPupload() {
      var me = this;
      PF.requireJs(["/assets/js/Plupload/js/plupload.full.min.js"], function () {
        var cfg = {
          runtimes: 'gears,html5,flash,silverlight,browserplus,html4',
          browse_button: me.mwRef('uploader').$el,
          max_file_size: me.maxSize + 'mb',
          unique_names: true,
          url: me.action,
          multi_selection: me.multiple,
          flash_swf_url: '/assets/js/Plupload/js/Moxie.swf',
          silverlight_xap_url: '/assets/js/Plupload/js/Moxie.xap' };

        if (me.accept) {
          cfg.filters = { mime_types: [
            { title: $lang("自定义文件"), extensions: me.accept }] };

        }
        var uploader = new plupload.Uploader(cfg);
        me.uploader = uploader;
        uploader.bind('FilesAdded', function (up, files) {

          if (me.limit && me.limit != 0 && me.fileList.length >= me.limit) {
            me.$message.error($lang("最多只能上传") + me.limit + $lang("个文件!"));
            files.forEach(function (v) {
              up.removeFile(v);
            });
            return;
          }
          var fgwjList = {};
          if (me.fileList.length > 0) {
            files.forEach(function (v) {
              var fj = _.find(me.fileList, function (f) {return f.name == v.name;});
              if (fj) {
                fgwjList[fj.name] = fj.id;
              }
            });
          }
          me.defaultParams.fullPath = "y";
          if (!_.isEmpty(fgwjList)) {
            var fileNames = [];
            _.mapKeys(fgwjList, function (i, n) {fileNames.push(n);});
            PF.confirm($lang("文件名称") + "[" + fileNames + "]" + $lang("已存在，是否覆盖")).then(function () {
              me.defaultParams.fjwjList = PF.encode(fgwjList);
              uploader.setOption("multipart_params", me.defaultParams);
              uploader.start();
            }).catch(function () {
              uploader.setOption("multipart_params", me.defaultParams);
              uploader.start();
            });
          } else {
            uploader.setOption("multipart_params", me.defaultParams);
            uploader.start();
          }
        });
        uploader.bind('UploadProgress', function (up, file) {
          me.fileUploadVisible = true;
          me.uploadPercent = parseInt(file.percent.toFixed(0));
          me.fileUploadMsg = '当前上传文件: ' + file.name;
        });
        uploader.bind('UploadComplete', function (up, files) {
          me._uploadSuccess(up, files);
        });
        uploader.bind('Error', function (up, err) {
          if (err.response) {
            var response = JSON.parse(err.response);
            if (response && response.result) {
              me.$message.warning(response.result.msg);
            }
          } else {
            if (err.message.indexOf("File size error") != -1)
            me.$message.error($lang('上传附件大小不能超过') + me.maxSize + 'MB!');else
            if (err.message.indexOf("File extension error") != -1)
            me.$message.error($lang("只能上传文件类型:") + " " + me.accept + $lang("的文件"));else

            me.$message.warning(err.code + ":" + err.message + (err.file ? ", File: " + err.file.name : ""));
          }
          up.refresh();

        });
        uploader.init();
      });
    },
    downloadAttachment: function downloadAttachment() {
      var sel = this.mwRef('table').getMultipleSelection();
      if (sel.length == 0) {
        this.mwMsg('info', $lang('请选择需要下载的记录'));
        return;
      }
      if (sel.length > 1) {
        this.mwMsg('info', $lang('只能单个文件下载'));
        return;
      }
      var params = (0, _assign2.default)({ id: sel[0].id }, this.defaultParams);
      this.mwApi.business.downloadAttachment(params);

    },
    downloadAllAttachment: function downloadAllAttachment() {
      this.mwApi.business.downloadAttachments(this.defaultParams);

    },
    deleteAttachment: function deleteAttachment() {var _this = this;
      var sel = this.mwRef('table').getMultipleSelection();
      if (sel.length == 0) {
        this.mwMsg('info', $lang('请选择需要删除的记录'));
        return;
      }
      if (this.recordsIsCanEdit) {
        if (this.recordsIsCanEdit(sel) === false) return;
      }
      var ids = [];
      sel.map(function (v) {
        ids.push(v.id);
      });

      this.mwApi.business.deleteAttachment((0, _assign2.default)({ attachIds: ids }, this.defaultParams)).then(function () {
        _this.fileUploadVisible = false;
        _this.uploadPercent = 0;
        _this.mwRef('table').refresh();
      });
    },
    _tableDataLoaded: function _tableDataLoaded(data) {
      this.fileList = data || [];
      this.$emit('dataLoaded', data);
    },
    _attachFormatter: function _attachFormatter(row, column, cellValue) {
      return (cellValue / 1024).toFixed(2) + 'K';
    },
    _uploadSuccess: function _uploadSuccess(up, fileList) {


      this.mwRef('table').refresh();
    },
    _sortableUpdate: function _sortableUpdate(changes) {var _this2 = this;
      var dataList = this.$refs.table.dataList;

      var indexMap = {};
      for (var i = 0; i < dataList.length; i++) {
        var d = dataList[i];
        if (d.sn !== i) {
          indexMap[d.id] = i;
        }
      }
      if (!$.isEmptyObject(indexMap)) {
        var params = (0, _assign2.default)({ indexMap: indexMap }, this.defaultParams);
        PF.fsrv("business.srv.updateAttachmentSn", params).then(function (res) {
          if (res.success) {
            for (var _i = 1; _i < dataList.length; _i++) {
              var _d = dataList[_i];
              _d.sn = _i;
            }
            _this2.mwRef('table').refresh();
          }
        });
      }
    },
    rename: function rename(row, table, index) {
      if (!row.fileName) {
        this.$message.error($lang('文件名不能为空'));
        return;
      }
      if (this.recordsIsCanEdit) {
        if (this.recordsIsCanEdit([row]) === false) return;
      }
      var params = (0, _assign2.default)({ attachId: row.id, name: row.fileName + row.mimeType }, this.defaultParams);
      this.mwApi.business.updateAttachment(params).then(function (r) {
        table.refresh();
      });
    },
    setPageNum: function setPageNum(row, table, index) {
      var params = (0, _assign2.default)({ attachId: row.id, pageNum: row.pageNum }, this.defaultParams);
      this.mwApi.business.updateAttachment(params).then(function (r) {
        table.refresh();
      });
    },
    setMJBS: function setMJBS(row, table, index) {
      var params = (0, _assign2.default)({ attachId: row.id, fldmjbs: row.fldmjbs }, this.defaultParams);
      this.mwApi.business.updateAttachment(params).then(function (r) {
        table.refresh();
      });
    },
    format: function format(percentage) {
      return parseInt(percentage) === 100 ? '成功' : percentage + '%';
    } },

  render: function render() {var h = arguments[0];var
    action =
    this.action,multiple = this.multiple,name = this.name,limit = this.limit,api = this.api,columns = this.columns,defaultParams = this.defaultParams,accept = this.accept,maxSize = this.maxSize,downloadAttachment = this.downloadAttachment,downloadAllAttachment = this.downloadAllAttachment,addShow = this.addShow,deleteShow = this.deleteShow,renameShow = this.renameShow,downloadShow = this.downloadShow,deleteAttachment = this.deleteAttachment,_tableDataLoaded = this._tableDataLoaded,_sortableUpdate = this._sortableUpdate,fileUploadVisible = this.fileUploadVisible,uploadPercent = this.uploadPercent,format = this.format,fileUploadMsg = this.fileUploadMsg;

    var addBtn = void 0;
    if (addShow)
    addBtn = h('el-button', { attrs: { type: 'default' }, ref: 'uploader' }, [h('i', { 'class': 'fa fa-plus-square fa-fw' }), $lang('添加')]);

    var deleteBtn = void 0;
    if (deleteShow)
    deleteBtn = h('el-button', { attrs: { type: 'default' }, on: { 'click': deleteAttachment } }, [h('i', { 'class': 'fa fa-trash-o fa-fw' }), $lang('删除')]);

    var downloadBtn = void 0;
    if (downloadShow)
    downloadBtn = h('div', { style: 'float:right;' }, [
      h('el-button', { attrs: { type: 'default' }, on: { 'click': downloadAttachment } }, [h('i', { attrs: { className: 'fa fa-download fa-fw' } }), $lang('下载')]),
      h('el-button', { attrs: { type: 'default' }, on: { 'click': downloadAllAttachment } }, [h('i', { attrs: { className: 'fa fa-download fa-fw' } }), $lang('下载全部')])]);

    var percentTpl = void 0;
    if (fileUploadVisible)
    percentTpl = h('div', { style: 'margin-top:0px;' }, [
      h('div', { style: 'line-height:12px;text-align:center;font-size:12px;width:100%;margin-top:0px;margin-bottom:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' }, [fileUploadMsg]),
      h('el-progress', { attrs: { percentage: uploadPercent, format: format }, style: 'margin-top:0px;' })]);else


    percentTpl = "";
    return (
      h('div', { 'class': 'mw-upload' }, [
        h('div', { 'class': 'mw-toolbar' }, [
          addBtn,
          deleteBtn,
          downloadBtn]),

        h('div', { 'class': 'mw-toolbar__body', style: 'height:calc(100% - 150px);' }, [
          h('mw-table', { attrs: { api: api, pagination: false, columns: columns, defaultParams: defaultParams }, ref: 'table', on: { 'sortableUpdate': _sortableUpdate, 'dataLoaded': _tableDataLoaded } })]),


        h('div', { style: 'padding-top: 15px;color: black;' }, [
          percentTpl,
          h('el-tooltip', { attrs: { className: 'item', effect: 'dark', content: accept, placement: 'top-start' } }, [
            h('div', { style: 'width: 95%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;' }, [$lang('支持格式'), '\uFF1A', accept ? accept : "所有", '\u3002'])]),

          h('el-tooltip', { attrs: { className: 'item', effect: 'dark', content: maxSize, placement: 'top-start' } }, [
            h('div', { style: 'width: 95%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;' }, [$lang('上传大小'), '\uFF1A\u4E0D\u8D85\u8FC7', maxSize, 'MB\u3002'])])])]));





  } };

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7b91d395_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(959);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7b91d395_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{ref:"dialog",staticClass:"mw-dialog",class:[{'mw-dialog__large_large':(_vm.size=='large_large')
           ,'mw-dialog__large_small':(_vm.size=='large_small')
           ,'mw-dialog__large_mini':(_vm.size=='large_mini')
           ,'mw-dialog__small_large':(_vm.size=='small_large')
           ,'mw-dialog__small_small':(_vm.size=='small_small')
           ,'mw-dialog__small_mini':(_vm.size=='small_mini')
           ,'mw-dialog__mini_large':(_vm.size=='mini_large')
           ,'mw-dialog__mini_small':(_vm.size=='mini_small')
           ,'mw-dialog__mini_mini':(_vm.size=='mini_mini')
           ,'mw-dialog__large':(_vm.size=='large')
           ,'mw-dialog__small':(_vm.size=='small')
           ,'mw-dialog__form':(_vm.size=='form')
           ,'mw-dialog__view':(_vm.size=='view')
           ,'mw-dialog__page':(_vm.size=='page')
           ,'mw-dialog__full':(_vm.size=='full')
           ,'mw-dialog__mini':(_vm.size=='mini'),'mw-dialog__noFooterButton':(_vm.footerButton.length==0) },_vm.customClass],attrs:{"close-on-press-escape":_vm.closeOnPressEscape,"title":_vm.$lang(_vm.title),"modal":_vm.modal,"visible":_vm.visible,"close-on-click-modal":_vm.closeOnClickModal,"append-to-body":_vm.appendToBody,"before-close":_vm._beforeClose},on:{"opened":_vm.dialogOpen,"update:visible":function($event){_vm.visible=$event}}},[_vm._t("default"),_vm._v(" "),_c('template',{slot:"footer"},[_vm._l((_vm.footerButton),function(item){return (_vm.footerButton.length>0)?[_c('el-button',{attrs:{"size":"mini","loading":item.loading,"type":item.type?((item.type=='default')?'':item.type):'primary'},domProps:{"innerHTML":_vm._s(item.label)},on:{"click":function($event){return _vm.invokeButtonMethod(item)}}})]:_vm._e()}),_vm._v(" "),_vm._t("footer")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _processEditor = __webpack_require__(961);var _processEditor2 = _interopRequireDefault(_processEditor);
var _config = __webpack_require__(1007);var _config2 = _interopRequireDefault(_config);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var sketch = void 0;
var i = 0;
var tools = {
  hand: i++,
  marquee: i++ };exports.default =

{
  name: 'MwProcessChartEditor',
  render: function render() {var h = arguments[0];var
    zoomOut = this.zoomOut,zoomIn = this.zoomIn,zoomDefault = this.zoomDefault,editable = this.editable,clear = this.clear,color = this.color,changeHand = this.changeHand,changeMarquee = this.changeMarquee;
    var leftHtml = '';
    var cls = 'mw-process-chart-body mw-process-chart-body-readonly';
    var clearBtn = '';
    var colorHtml = '';
    var toolsHtml = '';
    if (color) {
      colorHtml = h('div', { 'class': '__char_color' }, [
        h('i', { 'class': 'fa fa-square', style: 'color:#999999' }), h('span', [$lang('未办')]),
        h('i', { 'class': 'fa fa-square', style: 'color:#67bc69' }), h('span', [$lang('已办')]),
        h('i', { 'class': 'fa fa-square', style: 'color:#fb3500' }), h('span', [$lang('在办')]),
        h('i', { 'class': 'fa fa-square', style: 'color:#fba500' }), h('span', [$lang('待办')])]);

    } else {
      toolsHtml = h('label', [h('input', { attrs: { type: 'checkbox', name: 'sketchMode' }, on: { 'click': function click(event) {return changeMarquee(event);} } }), '\xA0', $lang('移动画布'), '\xA0\xA0\xA0']);
    }

    if (editable) {
      leftHtml = h('div', { 'class': '__char_left' }, [
        h('ul', [
        h('li', [
        h('a', { 'class': 'fa fa-play-circle _task', attrs: { 'data-type': 'start', 'data-name': '\u5F00\u59CB', href: 'javascript:void(0)', draggable: 'true' } }),
        h('p', ['\u5F00\u59CB\u4EFB\u52A1'])]),

        h('li', [
        h('a', { 'class': 'fa fa-user _task', attrs: { 'data-type': 'normal', 'data-name': '\u65B0\u589E\u8282\u70B9', href: 'javascript:void(0)', draggable: 'true' } }),
        h('p', ['\u666E\u901A\u4EFB\u52A1'])]),

        h('li', [
        h('a', { 'class': 'fa fa-ellipsis-h _task', attrs: { 'data-type': 'serial', 'data-name': '\u65B0\u589E\u8282\u70B9', href: 'javascript:void(0)', draggable: 'true' } }),
        h('p', ['\u4E32\u884C\u4EFB\u52A1'])]),

        h('li', [
        h('a', { 'class': 'fa fa-sliders _task', attrs: { 'data-type': 'parallel', 'data-name': '\u65B0\u589E\u8282\u70B9', href: 'javascript:void(0)', draggable: 'true' } }),
        h('p', ['\u5E76\u884C\u4EFB\u52A1'])]),

        h('li', [
        h('a', { 'class': 'fa fa-code-fork _task', attrs: { 'data-type': 'sub-proc', 'data-name': '\u65B0\u589E\u8282\u70B9', href: 'javascript:void(0)', draggable: 'true' } }),
        h('p', ['\u5B50\u6D41\u7A0B'])]),

        h('li', [
        h('a', { 'class': 'fa fa-paw _task', attrs: { 'data-type': 'circular', 'data-name': '\u65B0\u589E\u8282\u70B9', href: 'javascript:void(0)', draggable: 'true' } }),
        h('p', ['\u4F20\u9605'])]),

        h('li', [
        h('a', { 'class': 'fa fa-paw _task', attrs: { 'data-type': 'dynamic', 'data-name': '\u81EA\u7531\u8282\u70B9', href: 'javascript:void(0)', draggable: 'true' } }),
        h('p', ['\u81EA\u7531\u8282\u70B9'])]),

        h('li', [
        h('a', { 'class': 'fa fa-stop-circle _task', attrs: { 'data-type': 'end', 'data-name': '\u7ED3\u675F', href: 'javascript:void(0)', draggable: 'true' } }),
        h('p', ['\u7ED3\u675F\u4EFB\u52A1'])])])]);



      cls = 'mw-process-chart-body';
      clearBtn = h('button', { 'class': 'el-button el-button--primary', on: { 'click': clear } }, [h('i', { 'class': 'fa fa-trash-o' }), '\u6E05\u9664']);
    }
    return (
      h('div', { 'class': cls }, [
        leftHtml,
        h('div', { 'class': '__char_toolbar' }, [
          toolsHtml,
          h('button', { 'class': 'el-button el-button--primary', on: { 'click': zoomIn } }, [h('i', { 'class': 'fa fa-search-plus' }), $lang('放大')]),
          h('button', { 'class': 'el-button el-button--primary', on: { 'click': zoomOut } }, [h('i', { 'class': 'fa fa-search-minus' }), $lang('缩小')]),
          h('button', { 'class': 'el-button el-button--primary', on: { 'click': zoomDefault } }, [h('i', { 'class': 'fa fa-refresh' }), $lang('原始')]),

          clearBtn]),


        colorHtml,
        h('svg', { attrs: { xmls: 'http://www.w3.org/2000/svg', version: '1.1' }, 'class': '__char_body' })]));

  },
  props: {
    editable: { default: false, type: Boolean },
    designable: { default: false, type: Boolean },
    color: Array,
    observer: {
      type: Object },

    value: Object,
    activityTypes: Array },

  data: function data() {
    return {
      data: undefined,
      eventId: Math.random() };

  },
  mounted: function mounted() {var _this = this;
    var me = this;
    PF.requireJs("/assets/js/svg/snap.svg.js", function () {
      var svg = me.$el.querySelector(".__char_body");

      sketch = new Sketch(svg);

      sketch.on('requestTitle', function (shape, resolver) {
        _this.$emit('requestTitle', shape, resolver);
      });

      sketch.applyDefault();

      if (!me.editable) {
        sketch.mode = 51;
      } else {
        sketch.mode = 255;
      }
      sketch.tool = tools.marquee;
      sketch.typeNameVisible = me.designable;

      if (me.observer) {
        sketch.on('createShape', function (v) {
          me.observer.$emit('node:append', v);
        });
        sketch.on('focusShape', function (v) {
          me.observer.$emit('node:click', v);
        });
        sketch.on('removeShape', function (v) {
          me.observer.$emit('node:remove', v);
        });
        sketch.on('updateLine', function (v) {
          me.observer.$emit('line:update', v);
        });
        sketch.on('createLine', function (v) {
          me.observer.$emit('line:append', v);
        });
        sketch.on('focusLine', function (v) {
          me.observer.$emit('line:click', v);
        });
        sketch.on('removeLine', function (v) {
          me.observer.$emit('line:remove', v);
        });
        sketch.on('blur', function (v) {
          me.observer.$emit('backdrop:click', v);
        });

        me.observer.$on("updateShape", function (v) {
          sketch.updateShape(v);
        });
        me.observer.$on("updateLine", function (v) {
          sketch.updateLine(v, true);
        });


        var dataType = void 0,dataName = void 0;

        $(_this.$el).delegate("._task", 'mousedown', function (e) {
          dataType = e.currentTarget.getAttribute('data-type');
          dataName = e.currentTarget.getAttribute('data-name');
        });

        $(_this.$el).delegate(".__char_body", 'dragover', function (e) {
          for (var el = e.target; el && el.nodeType === 1; el = el.parentNode) {
            if (el === svg) {
              e.preventDefault();
              sketch.requestAutoScroll(e.clientX, e.clientY);
              break;
            }
          }
        });
        $(_this.$el).delegate(".__char_body", 'drop', function (e) {
          for (var el = e.target; el && el.nodeType === 1; el = el.parentNode) {
            if (el === svg) {
              var matrix = sketch.matrix,
              snapMatrix = Snap.matrix.apply(Snap.matrix, matrix).invert(),
              box = svg.getBoundingClientRect(),
              x = e.clientX - box.left,
              y = e.clientY - box.top,
              tx = snapMatrix.x(x, y),
              ty = snapMatrix.y(x, y);
              sketch.createShape({
                type: dataType,
                matrix: [1, 0, 0, 1, tx, ty],
                name: dataName });

              break;
            }
          }
        });

        $(document.body).on('dragend.' + _this.eventId, function (e) {
          sketch.cancelAutoScroll();
        });

      }
      if (me.value) {
        sketch.data = me.value;
      }
      if (me.color) {
        sketch.setColor(me.color);
        sketch.mode = 17;
      }
    });
  },
  deactivated: function deactivated() {
    this.clearChart();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearChart();
  },
  methods: {
    clear: function clear() {
      var me = this;
      sketch.clear();
      me.observer.$emit("clear");
    },

    changeMarquee: function changeMarquee(event) {

      if (!event.target.checked)
      sketch.tool = tools.marquee;else

      sketch.tool = tools.hand;
    },

    zoomIn: function zoomIn() {
      sketch.zoomIn();
    },
    zoomDefault: function zoomDefault() {
      sketch.zoomDefault();
    },
    zoomOut: function zoomOut() {
      sketch.zoomOut();
    },

    clearChart: function clearChart() {
      sketch.destroy();
    },
    setData: function setData(data) {
      sketch.data = data;
    },
    getData: function getData() {
      return sketch.data;
    },
    addEvent: function addEvent() {

    } },

  watch: {
    value: function value(val, oldVal) {
      var me = this;
      me.setData(val);
    },
    editable: function editable(val, oldVal) {
      if (!val) {
        sketch.mode = 51;
      } else {
        sketch.mode = 255;
      }
    },
    designable: function designable(val, oldVal) {
      sketch.typeNameVisible = val;
    },
    color: function color(val, oldVal) {
      sketch.setColor(val);
    } },

  errorCaptured: function errorCaptured(err, component, info) {
    console.error('--%c MwProcessChart%c error: %o', 'color:green', null, err);
  } };

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _defineProperty = __webpack_require__(112);var _defineProperty2 = _interopRequireDefault(_defineProperty);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _index = __webpack_require__(962);var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(90);var _index4 = _interopRequireDefault(_index3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

Sketch =
function Sketch(svg) {var _this = this;(0, _classCallCheck3.default)(this, Sketch);
  var bn = new _index2.default(svg),
  proxyMethods = [

  "changeMatrix",
  "blur",


  "addShape",
  "createShape",
  "updateShape",
  "removeShape",
  "focusShape",


  "addLine",
  "createLine",
  "updateLine",
  "removeLine",
  "focusLine",


  "focusPoint",
  "removePoint",


  "beforeCreateShape",
  "zoomDefault",
  "zoomIn",
  "zoomOut",
  "destroy",
  "on",
  "off",

  "applyDefault",
  "clear",

  "select",
  "selectAll",

  "setColor",

  "requestAutoScroll",
  "cancelAutoScroll"],

  proxyValues = [
  "matrix",
  "data",
  "dirty",
  "mode",
  "typeNameVisible",
  "tool"];


  for (var i = 0; i < proxyMethods.length; i++) {
    this[proxyMethods[i]] = bn[proxyMethods[i]].bind(bn);
  }var _loop = function _loop(

  _i) {
    (0, _defineProperty2.default)(_this, proxyValues[_i], {
      get: function get() {
        return bn[proxyValues[_i]];
      },
      set: function set(v) {
        bn[proxyValues[_i]] = v;
      } });};for (var _i = 0; _i < proxyValues.length; _i++) {_loop(_i);

  }
};


Sketch.HandTool = _index4.default.tools.hand;
Sketch.MarqueeTool = _index4.default.tools.marquee;

if (typeof window !== "undefined") {

  window.Sketch = Sketch;
}exports.default =

Sketch;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _slicedToArray2 = __webpack_require__(60);var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);var _toConsumableArray2 = __webpack_require__(38);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);var _keys = __webpack_require__(59);var _keys2 = _interopRequireDefault(_keys);var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);var _get2 = __webpack_require__(65);var _get3 = _interopRequireDefault(_get2);var _index = __webpack_require__(72);var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(975);var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(992);var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(66);var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__(90);var _index10 = _interopRequireDefault(_index9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _class = function (_Layer) {(0, _inherits3.default)(_class, _Layer);


  function _class(svg) {(0, _classCallCheck3.default)(this, _class);var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this));


    _this.id = _index2.default.next();

    _this.svg = svg;

    _this.defaultMatrix = [1, 0, 0, 1, 0, 0];



    _this.shapes = {};

    _this.lines = {};

    _this.shapeDefs = {};

    _this.lineDefs = {};

    _this.matrix = [1, 0, 0, 1, 0, 0];

    _this.focusObjectId = "";

    _this.ghostShape = null;

    _this.ghostLine = null;

    _this.panningPointId = null;

    _this.panningGroup = null;


    _this.dirty = false;

    _this.mode = 255;

    _this.isPanningBackground = false;

    _this.selectPath = null;

    _this.selectsObjectIds = {};

    _this.typeNameVisible = true;

    _this.colorOfShapes = {};

    _this.tool = _index10.default.tools.hand;

    var renderHandler = null,
    dinnerSvg = new _index4.default(_this.svg);

    _index8.default.watch(_this, [
    "shapes", "lines", "shapeDefs", "lineDefs", "matrix", "focusObjectId", "ghostShape", "ghostLine", "snappedX", "snappedY", "panningPointId", "panningGroup", "mode", "isPanningBackground", "selectPath", "selectsObjectIds", "typeNameVisible", "colorOfShapes", "tool"],
    function (name, preVal, value) {

      clearTimeout(renderHandler);
      renderHandler = setTimeout(function () {
        dinnerSvg.update((0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'display', _this).call(_this));

        switch (name) {
          case "matrix":{
              _this.emit("changeMatrix", preVal, value);
              break;
            }
          case "shapes":
          case "lines":{
              if (!_this.dirty) {
                _this.dirty = true;
                _this.emit("dirty");
              }
              break;
            }}

      }, 0);
    });


    _this.install();return _this;
  }(0, _createClass3.default)(_class, [{ key: 'clear', value: function clear()


































































































    {
      this.shapes = {};
      this.lines = {};
      this.blur();
      this.colorOfShapes = {};
      this.selectsObjectIds = {};
    } }, { key: 'applyDefault', value: function applyDefault()

    {var _this2 = this;

      var markerDefs = Snap.parse('<defs>\n      <marker \n        id=' + (

      this.id + 'normalMarkerArrow') + '\n        markerWidth=\'16\'\n        markerHeight=\'12\'\n        orient=\'auto\' \n        viewBox=\'-12 -6 16 12\'\n        markerUnits=\'userSpaceOnUse\'\n      >\n        <path fill=' +






      "#336699" + ' d=\'M-14,-6 L2,0 L-14,6 L-8,0 L-14,-6\' />\n      </marker>\n      <marker \n        id=' + (


      this.id + 'normalMarkerArrowFocus') + '\n        markerWidth=\'16\'\n        markerHeight=\'12\'\n        orient=\'auto\' \n        viewBox=\'-12 -6 16 12\'\n        markerUnits=\'userSpaceOnUse\'\n      >\n        <path fill=' +






      "red" + ' d=\'M-14,-6 L2,0 L-14,6 L-8,0 L-14,-6\' />\n      </marker>\n\n      <marker \n        id=' + (



      this.id + 'startSubProcessMarkerArrow') + '\n        markerWidth=\'16\'\n        markerHeight=\'12\'\n        orient=\'auto\' \n        viewBox=\'-12 -6 16 12\'\n        markerUnits=\'userSpaceOnUse\'\n      >\n        <path fill=' +






      "#99aa99" + ' d=\'M-14,-6 L2,0 L-14,6 L-8,0 L-14,-6\' />\n      </marker>\n      <marker \n      id=' + (


      this.id + 'startSubProcessMarkerArrowFocus') + '\n      markerWidth=\'16\'\n      markerHeight=\'12\'\n      orient=\'auto\' \n      viewBox=\'-12 -6 16 12\'\n      markerUnits=\'userSpaceOnUse\'\n    >\n      <path fill=' +






      "red" + ' d=\'M-14,-6 L2,0 L-14,6 L-8,0 L-14,-6\' />\n    </marker>\n    </defs>').

      node.firstChild;

      this.svg.appendChild(markerDefs);


      [
      {
        type: "normal",
        fill: "lightblue",
        typeName: "普通",
        meta: {
          lineButtonTypes: ["normal"] } },


      {
        type: "parallel",
        fill: "lightblue",
        typeName: "并行",
        meta: {
          lineButtonTypes: ["normal"] } },


      {
        type: "sub-proc",
        fill: "lightblue",
        typeName: "子流程",
        meta: {
          lineButtonTypes: ["normal"] } },


      {
        type: "circular",
        fill: "lightblue",
        typeName: "传阅",
        meta: {
          lineButtonTypes: ["normal"] } },


      {
        type: "serial",
        fill: "lightblue",
        typeName: "串行",
        meta: {
          lineButtonTypes: ["normal"] } },


      {
        type: "dynamic",
        fill: "lightblue",
        typeName: "动态",
        meta: {
          lineButtonTypes: ["normal"] } },


      {
        type: "proxy",
        fill: "lightblue",
        typeName: "代理事件",
        meta: {
          lineButtonTypes: ["normal"] } }].


      forEach(function (_ref) {var type = _ref.type,typeName = _ref.typeName,fill = _ref.fill,meta = _ref.meta;
        _this2.addShape(type, typeName, '<rect x="50" y="50" rx="5" ry="5" width="100" height="50" fill="' + fill + '" filter="url(#nodeFilter)"  fill-opacity="1" stroke="#000" stroke-width="0"></rect>', meta);
      });

      [
      {
        type: "start",
        fill: "lightgreen",
        typeName: "",
        meta: {
          lineButtonTypes: ["normal"] } },


      {
        type: "end",
        fill: "lightcoral",
        typeName: "" }].

      forEach(function (_ref2) {var type = _ref2.type,typeName = _ref2.typeName,fill = _ref2.fill,meta = _ref2.meta;
        _this2.addShape(type, typeName, '<circle cx="0" cy="0" r="25"  stroke="#000" stroke-width="0"  fill="' + fill + '" filter="url(#nodeFilter)" fill-opacity="1" ></circle>', meta);
      });

      [
      {
        type: "normal",
        name: "新建普通流向",
        style: {
          stroke: "#336699",
          "stroke-width": 2,
          "fill": "none",
          "marker-end": 'url(#' + (this.id + 'normalMarkerArrow') + ')' },

        focusStyle: {
          stroke: "red",
          "marker-end": 'url(#' + (this.id + 'normalMarkerArrowFocus') + ')' } },


      {
        type: "startSubProcess",
        name: "运转",
        style: {
          stroke: "#99aa99",
          "stroke-width": 2,
          "fill": "none",
          "stroke-dasharray": "5,3",
          "marker-end": 'url(#' + (this.id + 'startSubProcessMarkerArrow') + ')' },

        focusStyle: {
          stroke: "red",
          "marker-end": 'url(#' + (this.id + 'startSubProcessMarkerArrowFocus') + ')' } },


      {
        type: "sendHandled",
        name: "直送经办",
        style: {
          stroke: "#336699",
          "stroke-width": 2,
          "fill": "none",
          "marker-end": 'url(#' + (this.id + 'startSubProcessMarkerArrow') + ')' },

        focusStyle: {
          stroke: "red",
          "marker-end": 'url(#' + (this.id + 'startSubProcessMarkerArrowFocus') + ')' } }].


      forEach(function (_ref3) {var type = _ref3.type,style = _ref3.style,name = _ref3.name,focusStyle = _ref3.focusStyle;
        _this2.addLine(type, name, style, focusStyle);
      });

      this.on("createLine", function (line) {var
        id = line.id;
        setTimeout(function () {
          _this2.focusLine({ id: id });
        }, 0);
      });
    } }, { key: 'data', get: function get() {var _this3 = this;return { "sequence-flow": (0, _keys2.default)(this.lines).map(function (lineId) {var _lines$lineId = _this3.lines[lineId],id = _lines$lineId.id,type = _lines$lineId.type,targetShapeId = _lines$lineId.targetShapeId,sourceShapeId = _lines$lineId.sourceShapeId,points = _lines$lineId.points,tip = _lines$lineId.tip;return { id: id, "to": targetShapeId, "points": { "start": points[0].x + ',' + points[0].y, "middle": points.slice(1, -1).map(function (_ref4) {var x = _ref4.x,y = _ref4.y;return x + ',' + y;}), "end": points[points.length - 1].x + ',' + points[points.length - 1].y }, "from": sourceShapeId, type: type, tip: tip };}), "board": { "scale": 1.21875, "dimension": { "w": 1170, "h": 419, "y": 99, "x": 0 }, "box": { "xMax": 960, "yMax": 320 } }, "activity": (0, _keys2.default)(this.shapes).map(function (shapeId) {var _shapes$shapeId = _this3.shapes[shapeId],id = _shapes$shapeId.id,matrix = _shapes$shapeId.matrix,name = _shapes$shapeId.name,type = _shapes$shapeId.type;return { "position": { "x": matrix[4], "y": matrix[5] }, id: id, "name": name, type: type };}), "editor-version": "1" };}, set: function set(data) {var _this4 = this;this.shapes = data["activity"].reduce(function (p, c, i, a) {var _c$position = c.position,x = _c$position.x,y = _c$position.y,id = c.id,name = c.name,type = c.type;x = +x;y = +y;p[id] = { id: id, matrix: [1, 0, 0, 1, x, y], name: name, type: type };return p;}, {});this.lines = data["sequence-flow"].reduce(function (p, c, i, a) {var id = c.id,to = c.to,_c$points = c.points,start = _c$points.start,middle = _c$points.middle,end = _c$points.end,from = c.from,type = c.type,tip = c.tip,line = { id: id, type: type, tip: tip, targetShapeId: to, sourceShapeId: from, targetPoint: { x: 0, y: 0 }, sourcePoint: { x: 0, y: 0 }, points: [start].concat((0, _toConsumableArray3.default)(middle), [end]).reduce(function (p, c, i, a) {var _c$split = c.split(","),_c$split2 = (0, _slicedToArray3.default)(_c$split, 2),x = _c$split2[0],y = _c$split2[1];x = +x;y = +y;return [].concat((0, _toConsumableArray3.default)(p), [{ x: x, y: y }]);}, []) },points = _this4.getPoints(line);line.points = points;p[id] = line;return p;}, {});this.blur();this.colorOfShapes = {};this.selectsObjectIds = {};setTimeout(function () {_this4.dirty = false;}, 0);} }]);return _class;}(_index6.default);exports.default = _class;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(964);
module.exports = __webpack_require__(18).Object.getPrototypeOf;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(88);
var $getPrototypeOf = __webpack_require__(262);

__webpack_require__(194)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(966), __esModule: true };

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(967);
module.exports = __webpack_require__(18).Object.setPrototypeOf;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(28);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(968).set });


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(50);
var anObject = __webpack_require__(57);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(64)(Function.call, __webpack_require__(192).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(970), __esModule: true };

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(971);
var $Object = __webpack_require__(18).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(28);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(137) });


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(973), __esModule: true };

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(974);
var $Object = __webpack_require__(18).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(87);
var $getOwnPropertyDescriptor = __webpack_require__(192).f;

__webpack_require__(194)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _index = __webpack_require__(976);var _index2 = _interopRequireDefault(_index);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

SvgD =
function SvgD(svg) {(0, _classCallCheck3.default)(this, SvgD);
  var s = new _index2.default(svg);
  this.update = s.update.bind(s);
};exports.default =


SvgD;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _stringify = __webpack_require__(24);var _stringify2 = _interopRequireDefault(_stringify);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _index = __webpack_require__(977);var _index2 = _interopRequireDefault(_index);

var _NodeTypes = __webpack_require__(328);var _NodeTypes2 = _interopRequireDefault(_NodeTypes);

var _diff = __webpack_require__(990);var _diff2 = _interopRequireDefault(_diff);


var _IE = __webpack_require__(991);var _IE2 = _interopRequireDefault(_IE);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var XLINK = "http://www.w3.org/1999/xlink",
XMLNS = "http://www.w3.org/2000/svg";var _class = function () {


  function _class(svg) {(0, _classCallCheck3.default)(this, _class);
    this.tree = null;
    this.svg = svg;

    this.domParser = new _index2.default();
  }(0, _createClass3.default)(_class, [{ key: 'update', value: function update(

    svgCode) {var _this = this;
      var tree = this.parse(svgCode);

      if (!this.tree) {
        this.tree = tree;
        tree.forEach(function (desc) {return _this.svg.appendChild(_this.solid(desc));});
      } else {
        this.diff(this.tree, tree);
      }
      tree = null;
    } }, { key: 'parse', value: function parse(

    svgCode) {
      return this.domParser.parse(this.trim(svgCode));
    } }, { key: 'trim', value: function trim(

    code) {
      return code.replace(/(<(pre|script|style|textarea)+?<\/\2)|(^|>)\s+|\s+(?=<|$)/g, "$1$3");
    } }, { key: 'solid', value: function solid(

    desc) {var _this2 = this;var
      type = desc.type,name = desc.name,value = desc.value,children = desc.children,attributes = desc.attributes,
      node = void 0;
      switch (type) {
        case _NodeTypes2.default.ELEMENT_NODE:{
            node = document.createElementNS(XMLNS, name);
            for (var key in attributes) {
              if (attributes.hasOwnProperty(key)) {
                this.setAttribute(node, key, attributes[key]);
              }
            }
            break;
          }
        case _NodeTypes2.default.COMMENT_NODE:{
            node = document.createComment(value);
            break;
          }

        case _NodeTypes2.default.TEXT_NODE:{
            node = document.createTextNode(value);
            break;
          }}


      desc.raw = node;

      if (children.length) {
        children.forEach(function (c) {return node.appendChild(_this2.solid(c));});
      }
      return node;
    } }, { key: 'diff', value: function diff(

    oldTree, newTree) {
      this.align(oldTree, newTree, this.svg);
    } }, { key: 'align', value: function align(

    lista, listb, rawParent) {

      if ((0, _stringify2.default)(lista) !== (0, _stringify2.default)(listb)) {

        var keyLista = this.getKeyList(lista),
        keyListb = this.getKeyList(listb);

        if (keyLista && keyListb) {
          var edsc = new _diff2.default(keyLista, keyListb).editscript();

          for (var i = 0; i < edsc.length; i++) {
            switch (edsc[i]) {
              case _diff2.default.INSERT:{
                  this.insertNodeByIndex(lista, listb[i], i, rawParent);
                  break;
                }
              case _diff2.default.DELETE:{
                  this.deleteNodeByIndex(lista, i, rawParent);
                  edsc.splice(i, 1);
                  i--;
                  break;
                }
              case _diff2.default.REPLACE:{
                  this.replaceNodeByIndex(lista, listb[i], i, rawParent);
                  break;
                }
              case _diff2.default.NOOP:{
                  this.updateNodeByIndex(lista, listb[i], i, rawParent);
                  break;
                }}

          }
        } else {

          for (var _i = 0, j = 0; _i < lista.length && j < listb.length; _i++, j++) {
            this.updateNodeByIndex(lista, listb[_i], _i, rawParent);
          }

          while (listb.length in lista) {
            this.deleteNodeByIndex(lista, lista.length - 1, rawParent);
          }

          while (listb.length > lista.length) {
            this.insertNodeByIndex(lista, listb[lista.length], lista.length, rawParent);
          }
        }
      }
    } }, { key: 'getKeyList', value: function getKeyList(

    list) {
      var footprint = {},
      keys = [];

      for (var i = 0; i < list.length; i++) {
        if (!list[i].attributes.id) {
          return null;
        }
        if (list[i].attributes.id in footprint) {
          return null;
        }
        keys.push(list[i].attributes.id);
      }
      return keys;
    } }, { key: 'insertNodeByIndex', value: function insertNodeByIndex(

    oldTree, newNode, index, rawParent) {
      if (!newNode.raw) {
        newNode.raw = this.solid(newNode);
      }

      rawParent.insertBefore(newNode.raw, index in oldTree ? oldTree[index].raw : null);
      oldTree.splice(index, 0, newNode);
    } }, { key: 'deleteNodeByIndex', value: function deleteNodeByIndex(

    oldTree, index, rawParent) {
      rawParent.removeChild(oldTree.splice(index, 1)[0].raw);
    } }, { key: 'replaceNodeByIndex', value: function replaceNodeByIndex(

    oldTree, newNode, index, rawParent) {
      if (!newNode.raw) {
        newNode.raw = this.solid(newNode);
      }
      rawParent.replaceChild(newNode.raw, oldTree.splice(index, 1, newNode)[0].raw);
    } }, { key: 'hasMarkAttr', value: function hasMarkAttr(

    el) {
      if ("marker-end" in el.attributes) {
        return true;
      }

      if ("marker-start" in el.attributes) {
        return true;
      }

      if ("marker" in el.attributes) {
        return true;
      }
    } }, { key: 'shouldReplace', value: function shouldReplace(

    oldNode, newNode) {
      if (oldNode.type !== newNode.type) {
        return true;
      }
      if (oldNode.type === newNode.type) {
        if (oldNode.type === _NodeTypes2.default.ELEMENT_NODE) {
          if (oldNode.name !== newNode.name) {
            return true;
          }
          if (_IE2.default && (this.hasMarkAttr(oldNode) || this.hasMarkAttr(newNode))) {
            return true;
          }
        } else if (oldNode.value !== newNode.value) {
          return true;
        }
      }

      return false;
    } }, { key: 'updateNodeByIndex', value: function updateNodeByIndex(

    oldTree, newNode, index, rawParent) {
      if ((0, _stringify2.default)(oldTree[index]) !== (0, _stringify2.default)(newNode)) {

        if (this.shouldReplace(oldTree[index], newNode)) {
          this.replaceNodeByIndex(oldTree, newNode, index, rawParent);
          return;
        }

        if (oldTree[index].type === _NodeTypes2.default.ELEMENT_NODE) {
          this.diffAttributes(oldTree[index], newNode);

          this.align(oldTree[index].children, newNode.children, oldTree[index].raw);
        }
      }
    } }, { key: 'diffAttributes', value: function diffAttributes(

    oldNode, newNode) {
      for (var newAttrName in newNode.attributes) {
        if (newNode.attributes.hasOwnProperty(newAttrName)) {

          if (!(newAttrName in oldNode.attributes)) {
            oldNode.attributes[newAttrName] = newNode.attributes[newAttrName];
            this.setAttribute(oldNode.raw, newAttrName, newNode.attributes[newAttrName]);
          } else {

            if (oldNode.attributes[newAttrName] !== newNode.attributes[newAttrName]) {
              oldNode.attributes[newAttrName] = newNode.attributes[newAttrName];
              this.setAttribute(oldNode.raw, newAttrName, newNode.attributes[newAttrName]);
            }
          }
        }
      }

      for (var oldAttrName in oldNode.attributes) {
        if (oldNode.attributes.hasOwnProperty(oldAttrName)) {
          if (!(oldAttrName in newNode.attributes)) {
            delete oldNode.attributes[oldAttrName];
            this.removeAttribute(oldNode.raw, oldAttrName);
          }
        }
      }
    } }, { key: 'setAttribute', value: function setAttribute(

    el, attrName, attrValue) {
      if (attrName.substring(0, 6) === "xlink:") {
        el.setAttributeNS(XLINK, attrName.substring(6), attrValue);
      } else if (attrName.substring(0, 4) === "xml:") {
        el.setAttributeNS(XMLNS, attrName.substring(4), attrValue);
      } else {
        el.setAttribute(attrName, attrValue);
      }
    } }, { key: 'removeAttribute', value: function removeAttribute(

    el, attrName) {
      if (attrName.substring(0, 6) === "xlink:") {
        el.removeAttributeNS(XLINK, attrName.substring(6));
      } else if (attrName.substring(0, 4) === "xml:") {
        el.removeAttributeNS(XMLNS, attrName.substring(4));
      } else {
        el.removeAttribute(attrName);
      }
    } }, { key: 'destroy', value: function destroy()

    {
      this.tree = null;
      this.svg = null;
    } }]);return _class;}();exports.default = _class;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _index = __webpack_require__(978);var _index2 = _interopRequireDefault(_index);

var _NodeTypes = __webpack_require__(328);var _NodeTypes2 = _interopRequireDefault(_NodeTypes);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _class = function () {


  function _class() {(0, _classCallCheck3.default)(this, _class);
    this._parser = new _index2.default();
    this._dom = null;
    this._stack = null;

    this.handleStart = this.handleStart.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleText = this.handleText.bind(this);
    this.handleComment = this.handleComment.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDone = this.handleDone.bind(this);

    this._parser.
    on("start", this.handleStart).
    on("open", this.handleOpen).
    on("text", this.handleText).
    on("comment", this.handleComment).
    on("close", this.handleClose).
    on("done", this.handleDone);
  }(0, _createClass3.default)(_class, [{ key: 'handleStart', value: function handleStart()

    {
      this._dom = [];
      this._stack = [];
    } }, { key: 'handleOpen', value: function handleOpen(

    name, attributes, selfClosing) {
      var node = {
        type: _NodeTypes2.default.ELEMENT_NODE,
        name: name,
        value: null,
        children: [],
        attributes: attributes };

      Object.defineProperty(node, "raw", {
        value: null,
        enumerable: false,
        configurable: true,
        writable: true });

      if (this._stack.length > 0) {
        this._stack[this._stack.length - 1].children.push(node);
      } else {
        this._dom.push(node);
      }
      if (!selfClosing) {
        this._stack.push(node);
      }
    } }, { key: 'handleText', value: function handleText(

    text) {
      var node = {
        type: _NodeTypes2.default.TEXT_NODE,
        name: "#text",
        value: text,
        children: [],
        attributes: {} };

      Object.defineProperty(node, "raw", {
        value: null,
        enumerable: false,
        configurable: true,
        writable: true });

      if (this._stack.length > 0) {
        this._stack[this._stack.length - 1].children.push(node);
      } else {
        this._dom.push(node);
      }
    } }, { key: 'handleComment', value: function handleComment(

    text) {
      var node = {
        type: _NodeTypes2.default.TEXT_NODE,
        name: "#comment",
        value: text,
        children: [],
        attributes: {} };

      Object.defineProperty(node, "raw", {
        value: null,
        enumerable: false,
        configurable: true,
        writable: true });

      if (this._stack.length > 0) {
        this._stack[this._stack.length - 1].children.push(node);
      } else {
        this._dom.push(node);
      }
    } }, { key: 'handleClose', value: function handleClose(

    name, selfClosing) {
      if (!selfClosing) {
        this._stack.pop();
      }
    } }, { key: 'handleDone', value: function handleDone()

    {
      this._stack.length = 0;
    } }, { key: 'parse', value: function parse(

    html) {
      this._parser.parse(html);

      return this._dom;
    } }]);return _class;}();exports.default = _class;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);

var _index = __webpack_require__(979);var _index2 = _interopRequireDefault(_index);
var _EventEmitter2 = __webpack_require__(327);var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);

var _isSelfCloseing = __webpack_require__(986);var _isSelfCloseing2 = _interopRequireDefault(_isSelfCloseing);
var _isClosedBy = __webpack_require__(987);var _isClosedBy2 = _interopRequireDefault(_isClosedBy);
var _isClosedByParent = __webpack_require__(988);var _isClosedByParent2 = _interopRequireDefault(_isClosedByParent);

var _makeStack = __webpack_require__(989);var _makeStack2 = _interopRequireDefault(_makeStack);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _class = function (_EventEmitter) {(0, _inherits3.default)(_class, _EventEmitter);


  function _class() {var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};(0, _classCallCheck3.default)(this, _class);var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this));


    _this._stack = null;

    var tkzr = _this._tokenizer = new _index2.default(opts),
    pendingTag = void 0;

    tkzr.on("start", function () {
      _this.emit("start");
    });

    tkzr.on("opening-tag", function (name) {
      pendingTag = {
        name: name,
        attributes: {} };

    });

    tkzr.on('closing-tag', function (name) {

      var current = _this._stack.peek(),

      parent = _this._stack.peek(1);
      if (current) {
        if (current.name === name) {
          _this._stack.pop();
          _this.emit('close', current.name, false);
        } else {
          if (parent && parent.name === name && (0, _isClosedByParent2.default)(current.name)) {
            _this._stack.pop();
            _this.emit('close', current.name, false);
            _this._stack.pop();
            _this.emit('close', parent.name, false);
          }
        }
      }
    });

    tkzr.on('opening-tag-end', function (name, token) {

      var mightBeClosed = _this._stack.peek(),
      isSelfClose = token === '/>' || (0, _isSelfCloseing2.default)(name);
      if (mightBeClosed && (0, _isClosedBy2.default)(mightBeClosed.name, pendingTag.name)) {
        _this._stack.pop();
        _this.emit('close', mightBeClosed.name, false);
      }
      _this.emit('open', pendingTag.name, pendingTag.attributes, isSelfClose);
      if (isSelfClose) {
        _this.emit('close', pendingTag.name, true);
      } else {
        _this._stack.push(pendingTag);
      }
    });

    tkzr.on('text', function (value) {
      _this.emit('text', value);
    });

    tkzr.on('comment', function (value) {
      _this.emit('comment', value);
    });

    tkzr.on('attribute', function (name, value) {
      pendingTag.attributes[name] = value;
    });return _this;
  }(0, _createClass3.default)(_class, [{ key: 'parse', value: function parse(

    html) {
      this._stack = (0, _makeStack2.default)();
      this._tokenizer.tokenize(html);
      while (this._stack.length > 0) {
        var next = this._stack.pop();
        this.emit('close', next.name, false);
      }
      delete this._stack;
      this.emit('done');
    } }]);return _class;}(_EventEmitter3.default);exports.default = _class;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);

var _EventEmitter2 = __webpack_require__(327);var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
var _defaultEntityMap = __webpack_require__(980);var _defaultEntityMap2 = _interopRequireDefault(_defaultEntityMap);

var _chunk = __webpack_require__(981);var _chunk2 = _interopRequireDefault(_chunk);
var _readAttribute = __webpack_require__(982);var _readAttribute2 = _interopRequireDefault(_readAttribute);
var _States = __webpack_require__(983);var _States2 = _interopRequireDefault(_States);

var _deentityify = __webpack_require__(984);var _deentityify2 = _interopRequireDefault(_deentityify);

var _helper = __webpack_require__(985);var _helper2 = _interopRequireDefault(_helper);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _class = function (_EventEmitter) {(0, _inherits3.default)(_class, _EventEmitter);


  function _class() {var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};(0, _classCallCheck3.default)(this, _class);var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this));


    _this._running = false;

    _this._entityMap = _helper2.default.assign({}, _defaultEntityMap2.default, opts.entities);return _this;
  }(0, _createClass3.default)(_class, [{ key: 'cancel', value: function cancel()

    {
      this._send("cancel");
    } }, { key: 'entities', value: function entities(

    map) {
      _helper2.default.assign(this._entityMap, map);
    } }, { key: '_send', value: function _send(

    ev) {
      if (!this._running) {
        return;
      }
      if (ev === 'text') {
        var text = arguments[1];
        if (this._text === undefined) {
          this._text = text;
        } else {
          this._text += text;
        }
      } else {
        if (this._text) {
          var deentText = (0, _deentityify2.default)(this._text, this._entityMap);
          this.emit('text', deentText);
          delete this._text;
        }
        var len = arguments.length;
        if (len === 1) {
          this.emit(ev);
        } else if (len === 2) {
          this.emit(ev, arguments[1]);
        } else if (len === 3) {
          this.emit(ev, arguments[1], arguments[2]);
        } else {
          this.emit.apply(this, arguments);
        }
      }
      if (ev === 'cancel') {
        delete this._running;
      }
    } }, { key: 'tokenize', value: function tokenize(

    html) {
      this._running = true;
      this._send('start');
      var pos = 0,
      state = _States2.default.inText,
      currentTag,
      next;
      while (pos < html.length) {
        if (state === _States2.default.inText) {
          var isBracket = html.charAt(pos) === '<';
          if (isBracket && (next = _chunk2.default.getOpeningTag(html, pos))) {
            pos += next.length;
            currentTag = next.match[2];
            this._send('opening-tag', currentTag);
            state = _States2.default.inTag;
          } else if (isBracket && (next = _chunk2.default.getClosingTag(html, pos))) {
            pos += next.length;
            this._send('closing-tag', next.match[2]);
          } else if (isBracket && (next = _chunk2.default.getCommentOpen(html, pos))) {
            pos += next.length;
            state = _States2.default.inComment;
          } else if (next = _chunk2.default.getText(html, pos)) {
            pos += next.length;
            this._send('text', next.match[1]);
          } else {
            var text = html.substring(pos, pos + 1);
            pos += 1;
            this._send('text', text);
          }
        } else if (state === _States2.default.inComment) {
          if (next = _chunk2.default.getComment(html, pos)) {
            pos += next.length;
            this._send('comment', next.match[2]);
            state = _States2.default.inText;
          } else {
            this._send('comment', html.substring(pos));
            break;
          }
        } else if (state === _States2.default.inScript) {
          if (next = _chunk2.default.getScript(html, pos)) {
            pos += next.length;
            this._send('text', next.match[2]);
            this._send('closing-tag', 'script');
            state = _States2.default.inText;
          } else {
            this._send('text', html.substring(pos));
            break;
          }
        } else if (state === _States2.default.inTag) {
          if (next = _chunk2.default.getAttributeName(html, pos)) {
            pos += next.length;
            var name = next.match[2];
            var hasVal = next.match[4];
            if (hasVal) {
              var read = (0, _readAttribute2.default)(html, pos);
              pos += read.length;
              this._send('attribute', name, (0, _deentityify2.default)(read.value, this._entityMap));
            } else {
              this._send('attribute', name, '');
            }
          } else if (next = _chunk2.default.getTagEnd(html, pos)) {
            pos += next.length;
            var token = next.match[2];
            this._send('opening-tag-end', currentTag, token);
            state = currentTag === 'script' ? _States2.default.inScript : _States2.default.inText;
          } else {
            state = _States2.default.inText;
          }
        } else {
          break;
        }
      }
      this._send('done');
      delete this._running;
    } }]);return _class;}(_EventEmitter3.default);exports.default = _class;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = {
  "quot": "\"",
  "amp": "&",
  "lt": "<",
  "gt": ">",
  "nbsp": "\xA0" };

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = [
{ name: 'getOpeningTag', regex: /(<(([a-z0-9\-]+:)?[a-z0-9\-]+))/ig },
{ name: 'getText', regex: /([^<]+)/g },
{ name: 'getClosingTag', regex: /(<\/(([a-z0-9\-]+:)?[a-z0-9\-]+)>)/ig },
{ name: 'getCommentOpen', regex: /(<!\-\-)/g },
{ name: 'getComment', regex: /(([\s\S]*?)\-\->)/g },
{ name: 'getScript', regex: /(([\s\S]*?)<\/script>)/g },
{ name: 'getTagEnd', regex: /(\s*(\/?>))/g },
{ name: 'getAttributeName', regex: /(\s+(([a-z0-9\-_]+:)?[a-z0-9\-_]+)(\s*=\s*)?)/ig }].
reduce(function (pre, item) {
  pre[item.name] = function (str, pos) {
    item.regex.lastIndex = pos;
    var match = item.regex.exec(str);
    if (!match || match.index !== pos) {
      return undefined;
    } else {
      return {
        length: match[1].length,
        match: match };

    }
  };
  return pre;
}, {
  getOpeningTag: function getOpeningTag(str, pos) {},
  getText: function getText(str, pos) {},
  getClosingTag: function getClosingTag(str, pos) {},
  getCommentOpen: function getCommentOpen(str, pos) {},
  getComment: function getComment(str, pos) {},
  getScript: function getScript(str, pos) {},
  getTagEnd: function getTagEnd(str, pos) {},
  getAttributeName: function getAttributeName(str, pos) {} });

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =
function (str, pos) {
  var quote = str.charAt(pos);
  if (quote === '"' || quote === "'") {
    var nextQuote = str.indexOf(quote, pos + 1);
    if (nextQuote === -1) {
      return { length: str.length - pos, value: str.substring(pos + 1) };
    } else {
      return { length: nextQuote - pos + 1, value: str.substring(pos + 1, nextQuote) };
    }
  } else {
    patt.lastIndex = pos;
    var match = patt.exec(str);
    return { length: match[1].length, value: match[2] };
  }
};var patt = /(\s*([^>\s/]*))/g;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = {
  inTag: 'in tag',
  inComment: 'in comment',
  inText: 'in text',
  inScript: 'in script' };

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =
















function (text, aMap) {
  map = aMap;
  return text.replace(patt, handler);
};var patt = /&(#?)([a-z0-9]+);/ig,map;function handler(ent, isNum, content) {if (isNum) {var num;if (content.charAt(0) === 'x') {num = parseInt('0' + content, 16);} else {num = parseInt(content, 10);}return String.fromCharCode(num);} else {return map[content] || ent;}}

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default = new (function () {
  function _class() {(0, _classCallCheck3.default)(this, _class);

  }(0, _createClass3.default)(_class, [{ key: 'assign', value: function assign(

    target, varArgs) {
      if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          for (var nextKey in nextSource) {

            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    } }]);return _class;}())();

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =


function (closee) {
  return !!table[closee];
};var _makeLookup = __webpack_require__(201);var _makeLookup2 = _interopRequireDefault(_makeLookup);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var table = (0, _makeLookup2.default)('area,base,br,col,command,embed,hr,img,input,keygen,link,meta,param,source,track,wbr');

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =




















function (closee, closer) {
  var lookup = table[closee] || empty;
  return !!lookup[closer];
};var _makeLookup = __webpack_require__(201);var _makeLookup2 = _interopRequireDefault(_makeLookup);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var empty = {};var table = { p: (0, _makeLookup2.default)('address,article,aside,blockquote,div,dl,fieldset,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,hr,main,nav,ol,p,pre,section,table,ul'), li: (0, _makeLookup2.default)('li'), dt: (0, _makeLookup2.default)('dt,dd'), dd: (0, _makeLookup2.default)('dt,dd'), rb: (0, _makeLookup2.default)('rb,rt,rtc,rp'), rt: (0, _makeLookup2.default)('rb,rt,rtc,rp'), rtc: (0, _makeLookup2.default)('rb,rtc,rp'), rp: (0, _makeLookup2.default)('rb,rt,rtc,rp'), optgroup: (0, _makeLookup2.default)('optgroup'), option: (0, _makeLookup2.default)('option,optgroup'), thead: (0, _makeLookup2.default)('tbody,tfoot'), tbody: (0, _makeLookup2.default)('tbody,tfoot'), tfoot: (0, _makeLookup2.default)('tbody'), tr: (0, _makeLookup2.default)('tr'), td: (0, _makeLookup2.default)('td,th'), th: (0, _makeLookup2.default)('td,th') };

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =


function (closee) {
  return !!table[closee];
};var _makeLookup = __webpack_require__(201);var _makeLookup2 = _interopRequireDefault(_makeLookup);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var table = (0, _makeLookup2.default)('p,li,dd,rb,rt,rtc,rp,optgroup,option,tbody,tfoot,tr,td,th');

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =



function () {
  var stack = [];

  stack.peek = peek;
  return stack;
};function peek(n) {n = n || 0;return this[this.length - (n + 1)];}

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}


function Eq(a, b) {return a === b;}var


Diff = function () {
  function Diff(a, b) {var eql = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Eq;(0, _classCallCheck3.default)(this, Diff);
    this.a = a;
    this.b = b;
    this.eql = eql;
    this.moda = Array.apply(null, new Array(a.length)).map(true.valueOf, false);
    this.modb = Array.apply(null, new Array(b.length)).map(true.valueOf, false);

    this.down = {};
    this.up = {};
    this.lcs(0, a.length, 0, b.length);
  }(0, _createClass3.default)(Diff, [{ key: 'editscript', value: function editscript()
    {
      var moda = this.moda,modb = this.modb;
      var astart = 0,aend = moda.length;
      var bstart = 0,bend = modb.length;
      var result = [];
      while (astart < aend || bstart < bend) {
        if (astart < aend && bstart < bend) {
          if (!moda[astart] && !modb[bstart]) {
            result.push(Diff.NOOP);
            astart++;
            bstart++;
            continue;
          } else
          if (moda[astart] && modb[bstart]) {
            result.push(Diff.REPLACE);
            astart++;
            bstart++;
            continue;
          }
        }
        if (astart < aend && (bstart >= bend || moda[astart])) {
          result.push(Diff.DELETE);
          astart++;
        }
        if (bstart < bend && (astart >= aend || modb[bstart])) {
          result.push(Diff.INSERT);
          bstart++;
        }
      }
      return result;
    } }, { key: 'lcs', value: function lcs(
    astart, aend, bstart, bend) {
      var a = this.a,b = this.b,eql = this.eql;

      while (astart < aend && bstart < bend && eql(a[astart], b[bstart])) {
        astart++;
        bstart++;
      }

      while (astart < aend && bstart < bend && eql(a[aend - 1], b[bend - 1])) {
        aend--;
        bend--;
      }
      if (astart === aend) {

        while (bstart < bend) {
          this.modb[bstart] = true;
          bstart++;
        }
      } else
      if (bend === bstart) {

        while (astart < aend) {
          this.moda[astart] = true;
          astart++;
        }
      } else
      {
        var snake = this.snake(astart, aend, bstart, bend);
        this.lcs(astart, snake.x, bstart, snake.y);
        this.lcs(snake.u, aend, snake.v, bend);
      }
    } }, { key: 'snake', value: function snake(
    astart, aend, bstart, bend) {
      var a = this.a,b = this.b,eql = this.eql;
      var N = aend - astart,M = bend - bstart;
      var kdown = astart - bstart;
      var kup = aend - bend;
      var delta = N - M;
      var deltaOdd = delta & 1;
      var down = this.down;
      down[kdown + 1] = astart;
      var up = this.up;
      up[kup - 1] = aend;
      var Dmax = (N + M + 1) / 2;
      for (var D = 0; D <= Dmax; D++) {
        var k, x, y;

        for (k = kdown - D; k <= kdown + D; k += 2) {
          if (k === kdown - D) {
            x = down[k + 1];
          } else
          {
            x = down[k - 1] + 1;
            if (k < kdown + D && down[k + 1] >= x) {
              x = down[k + 1];
            }
          }
          y = x - k;
          while (x < aend && y < bend && eql(a[x], b[y])) {
            x++;
            y++;
          }
          down[k] = x;
          if (deltaOdd && kup - D < k && k < kup + D &&
          up[k] <= down[k]) {
            return {
              x: down[k],
              y: down[k] - k,
              u: up[k],
              v: up[k] - k };

          }
        }

        for (k = kup - D; k <= kup + D; k += 2) {
          if (k === kup + D) {
            x = up[k - 1];
          } else
          {
            x = up[k + 1] - 1;
            if (k > kup - D && up[k - 1] < x) {
              x = up[k - 1];
            }
          }
          y = x - k;
          while (x > astart && y > bstart && eql(a[x - 1], b[y - 1])) {
            x--;
            y--;
          }
          up[k] = x;
          if (!deltaOdd && kdown - D <= k && k <= kdown + D &&
          up[k] <= down[k]) {
            return {
              x: down[k],
              y: down[k] - k,
              u: up[k],
              v: up[k] - k };

          }
        }
      }
    } }]);return Diff;}();


Diff.NOOP = 'nop';
Diff.DELETE = 'del';
Diff.INSERT = 'ins';
Diff.REPLACE = 'rep';exports.default =

Diff;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var uA = window.navigator.userAgent,

isIE = /msie\s|trident\/|edge\//i.test(uA) && !!(document.uniqueID || document.documentMode || window.ActiveXObject || window.MSInputMethodContext);exports.default =
isIE;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);var _BackgroundMixin = __webpack_require__(993);var _BackgroundMixin2 = _interopRequireDefault(_BackgroundMixin);
var _DefsLayerMixin = __webpack_require__(994);var _DefsLayerMixin2 = _interopRequireDefault(_DefsLayerMixin);
var _HelperLayerMixin = __webpack_require__(995);var _HelperLayerMixin2 = _interopRequireDefault(_HelperLayerMixin);
var _LineLayerMixin = __webpack_require__(996);var _LineLayerMixin2 = _interopRequireDefault(_LineLayerMixin);
var _ShapeLayerMixin = __webpack_require__(999);var _ShapeLayerMixin2 = _interopRequireDefault(_ShapeLayerMixin);
var _SnappableMixin = __webpack_require__(1002);var _SnappableMixin2 = _interopRequireDefault(_SnappableMixin);

var _LineHotAreaLayerMixin = __webpack_require__(1003);var _LineHotAreaLayerMixin2 = _interopRequireDefault(_LineHotAreaLayerMixin);

var _ToolLayerMixin = __webpack_require__(1004);var _ToolLayerMixin2 = _interopRequireDefault(_ToolLayerMixin);

var _index = __webpack_require__(1005);var _index2 = _interopRequireDefault(_index);

var _ExtentAutoChangableMixin = __webpack_require__(1006);var _ExtentAutoChangableMixin2 = _interopRequireDefault(_ExtentAutoChangableMixin);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var Mixins = {
  BackgroundMixin: _BackgroundMixin2.default,
  DefsLayerMixin: _DefsLayerMixin2.default,
  ToolLayerMixin: _ToolLayerMixin2.default,
  LineHotAreaLayerMixin: _LineHotAreaLayerMixin2.default,
  LineLayerMixin: _LineLayerMixin2.default,
  ShapeLayerMixin: _ShapeLayerMixin2.default,
  HelperLayerMixin: _HelperLayerMixin2.default,
  SnappableMixin: _SnappableMixin2.default,
  ExtentAutoChangableMixin: _ExtentAutoChangableMixin2.default };


var queue = [
"BackgroundMixin",
"DefsLayerMixin",
"ToolLayerMixin",
"LineHotAreaLayerMixin",
"LineLayerMixin",
"ShapeLayerMixin",
"HelperLayerMixin",
"SnappableMixin",
"ExtentAutoChangableMixin"];var _class = function (_queue$reduceRight) {(0, _inherits3.default)(_class, _queue$reduceRight);function _class() {(0, _classCallCheck3.default)(this, _class);return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));}return _class;}(


queue.reduceRight(function (p, c, i, a) {
  return Mixins[c](p);
}, _index2.default));exports.default = _class;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _toConsumableArray2 = __webpack_require__(38);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);var _keys = __webpack_require__(59);var _keys2 = _interopRequireDefault(_keys);var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _get2 = __webpack_require__(65);var _get3 = _interopRequireDefault(_get2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);exports.default =








function (superClass) {
  return function (_superClass) {(0, _inherits3.default)(_class, _superClass);
    function _class() {var _ref;(0, _classCallCheck3.default)(this, _class);for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {arg[_key] = arguments[_key];}var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(

      arg)));

      _this["BackgroundMixin@handleMouseDown"] = _this["BackgroundMixin@handleMouseDown"].bind(_this);return _this;
    }(0, _createClass3.default)(_class, [{ key: 'getObjectsByPath', value: function getObjectsByPath(

      path) {var _this2 = this;

        var selectBbox = Snap.path.getBBox(path),
        included = {};

        (0, _keys2.default)(this.shapes).forEach(function (shapeId) {var _Snap;var _shapes$shapeId =
          _this2.shapes[shapeId],id = _shapes$shapeId.id,type = _shapes$shapeId.type,name = _shapes$shapeId.name,matrix = _shapes$shapeId.matrix,_getShapeDefByType =
          _this2.getShapeDefByType(type),path = _getShapeDefByType.path,html = _getShapeDefByType.html,bbox = _getShapeDefByType.bbox,typeName = _getShapeDefByType.name;


          if (Snap.path.isBBoxIntersect(selectBbox, Snap.path.getBBox(Snap.path.map(path, (_Snap = Snap).matrix.apply(_Snap, (0, _toConsumableArray3.default)(matrix)).translate(-(bbox.x + bbox.width / 2), -(bbox.y + bbox.height / 2)))))) {
            included[shapeId] = true;
          }
        });
        return included;
      } }, { key: 'install', value: function install()

      {var _this3 = this;
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'install', this).call(this);
        var selectStartPoint = { x: 0, y: 0 };
        var onPan = function onPan(dx, dy, x, y, e, panningTarget, panOffset) {
          if (panningTarget.id === _this3.id) {
            if (_index8.default.tools.hand === _this3.tool) {

              var m = _this3.matrix.slice(0);
              m[4] += dx;
              m[5] += dy;
              _this3.changeMatrix(m);
            }

            if (_index8.default.tools.marquee === _this3.tool) {
              var box = _this3.svg.getBoundingClientRect(),
              endPoint = _index6.default.unapplyMatrix(_this3.matrix, {
                x: x - box.left,
                y: y - box.top });


              _this3.selectPath = 'M ' + selectStartPoint.x + ' ' + selectStartPoint.y + ' H ' + endPoint.x + ' V ' + endPoint.y + ' H ' + selectStartPoint.x;

              _this3.requestAutoScroll(x, y);
            }










          }
        },onPanStart = function onPanStart(x, y, e, panningTarget, panOffset) {


          if (_index8.default.tools.marquee === _this3.tool && panningTarget.id === _this3.id) {
            var box = _this3.svg.getBoundingClientRect();
            selectStartPoint = _index6.default.unapplyMatrix(_this3.matrix, {
              x: e.clientX - box.left,
              y: e.clientY - box.top });

            _this3.selectPath = 'M  ' + selectStartPoint.x + ' ' + selectStartPoint.y + ' ';
          }

        },onPanEnd = function onPanEnd(e, panningTarget) {
          if (_index8.default.tools.hand === _this3.tool) {
            _this3.isPanningBackground = false;
          }
          if (_index8.default.tools.marquee === _this3.tool && panningTarget.id === _this3.id) {
            setTimeout(function () {
              _this3.selectsObjectIds = _this3.getObjectsByPath(_this3.selectPath);
              _this3.selectPath = null;
              _this3.emit("selectEnd", (0, _keys2.default)(_this3.selectsObjectIds).map(function (shapeId) {return _this3.shapes[shapeId];}));
            }, 0);
            _this3.cancelAutoScroll();
          }
        };

        this["Background~pannableHandler"] = (0, _index2.default)(this.svg, onPan, onPanStart, onPanEnd);

        this.svg.addEventListener("mousedown", this["BackgroundMixin@handleMouseDown"], false);

        this["BackgroundMixin@handleClick"] = (0, _index10.default)(this.svg, function (e) {
          if (_index6.default.hasClass(e.target, "background")) {
            _this3.blur();
          }
        });
      } }, { key: 'destroy', value: function destroy()

      {
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'destroy', this).call(this);
        this["Background~pannableHandler"]();
        this.svg.removeEventListener("mousedown", this["BackgroundMixin@handleMouseDown"], false);
        this["BackgroundMixin@handleClick"]();
      } }, { key:

      "BackgroundMixin@handleMouseDown", value: function BackgroundMixinHandleMouseDown(e) {
        if (_index8.default.tools.hand === this.tools) {
          this.isPanningBackground = true;
        }
      } }, { key: 'blur', value: function blur(

      silent) {
        if (silent ? true : this.emit("blur")) {
          this.focusObjectId = "";
        }
        this.selectsObjectIds = {};

      } }, { key: 'changeMatrix', value: function changeMatrix(

      matrix) {
        this.matrix = matrix;
      } }, { key: 'zoomDefault', value: function zoomDefault()

      {
        this.changeMatrix(this.defaultMatrix);
      } }, { key: 'zoomIn', value: function zoomIn()

      {
        var m = this.matrix.slice(0);
        m[0] = m[3] = m[0] + .1;
        this.changeMatrix(m);
      } }, { key: 'zoomOut', value: function zoomOut()

      {
        var m = this.matrix.slice(0);
        m[0] = m[3] = m[0] - .1;
        this.changeMatrix(m);
      } }, { key: 'display', value: function display()

      {
        var id = this.id,
        matrix = this.matrix,
        children = (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'display', this).call(this);

        return '\n      <g \n        id="' +

        id + '"\n        transform="matrix(' +
        matrix.join(",") + ')"\n        class="pannable"\n        >\n\n        <style>\n          #' +




        this.id + ' .button:hover {\n            fill: rgb(255, 252, 176)\n          }\n          #' +


        this.id + ' .button {\n            fill: #fff;\n            fill-opacity: .8\n          }\n        </style>\n  \n        <rect \n          x="-1000000" \n          y="-1000000" \n          width="2000000" \n          height="2000000" \n          fill="transparent"\n          class="background"\n\n        ></rect>\n  \n        <g pointer-events="none">\n          <path \n            d="M -22 -1 H -1000 M 22 -1 H 6000 M -1 -22 V -1000 M -1 22 V 3000"\n            fill = "none"\n            stroke = "rgba(0,0,0,0.1)"\n            stroke-width = "2"\n            stroke-dasharray = "6,6"\n            shape-randering = "crispEdges"\n          >\n          </path>\n          <path d="M -15 -1 H 15 M -1 -15 V 15"\n          fill = "none"\n          stroke = "rgb(204, 204, 204)"\n          stroke-width="2"\n          stroke-linecap = "round"></path>\n          <text \n            x="-10" \n            y="-10" \n            fill = "rgb(204, 204,204)"\n            font-family = "consolas, menlo, dejavu sans mono, monospace"\n            font-weight = "900"\n            text-anchor = "end"\n            alignment-baseline="baseline"\n          >(0,0)</text>\n        </g>\n  \n        ' + (









































        children || "") + '\n  \n      </g>\n    ';



      } }]);return _class;}(superClass);

};var _index = __webpack_require__(202);var _index2 = _interopRequireDefault(_index);var _index3 = __webpack_require__(72);var _index4 = _interopRequireDefault(_index3);var _index5 = __webpack_require__(66);var _index6 = _interopRequireDefault(_index5);var _index7 = __webpack_require__(90);var _index8 = _interopRequireDefault(_index7);var _index9 = __webpack_require__(329);var _index10 = _interopRequireDefault(_index9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _get2 = __webpack_require__(65);var _get3 = _interopRequireDefault(_get2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);exports.default =

function (superClass) {
  return function (_superClass) {(0, _inherits3.default)(_class, _superClass);
    function _class() {var _ref;(0, _classCallCheck3.default)(this, _class);for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {arg[_key] = arguments[_key];}return (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(

      arg)));
    }(0, _createClass3.default)(_class, [{ key: "install", value: function install()

      {
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), "install", this).call(this);
      } }, { key: "destroy", value: function destroy()

      {
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), "destroy", this).call(this);
      } }, { key: "display", value: function display()

      {
        return (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), "display", this).call(this) + ("\n      <defs>\n        <filter id=\"nodeFilterHover\">\n          <feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"2.2\">\n          </feGaussianBlur>\n          <feOffset dx=\"1\" dy=\"1\" result=\"offsetblur\"></feOffset>\n          <feFlood flood-color=\"rgba(0,0,0,1)\"></feFlood>\n          <feComposite in2=\"offsetblur\" operator=\"in\">\n          </feComposite>\n          <feMerge>\n            <feMergeNode>\n            </feMergeNode>\n            <feMergeNode in=\"SourceGraphic\"></feMergeNode>\n          </feMerge>\n        </filter>\n        <filter id=\"nodeFilter\" x=\"0\" y=\"0\">\n          <feOffset result=\"offOut\" in=\"SourceAlpha\" dx=\"1\" dy=\"1\"></feOffset>\n          <feGaussianBlur result=\"blurOut\" in=\"offOut\" stdDeviation=\"1\">\n          </feGaussianBlur>\n          <feBlend in=\"SourceGraphic\" in2=\"blurOut\" mode=\"normal\">\n          </feBlend>\n        </filter>\n        <filter x=\"0\" y=\"0\" width=\"1\" height=\"1\" id=\"" +





















        _index2.default.join(this.id, "labelBackgroundFilter") + "\">\n          <feFlood flood-color=\"#fff\" flood-opacity=\".8\"/>\n          <feComposite in=\"SourceGraphic\" operator=\"over\"/>\n        </filter>\n        <filter id=\"" +



        _index2.default.join(this.id, "screenBlendMode") + "\">\n          <feFlood flood-color=\"#fff\" flood-opacity=\".3\"/>\n          <feComposite in=\"SourceGraphic\"/>\n        </filter>\n\n\n        <marker \n          id=" + (






        this.id + 'hotArea4polyline') + "\n          markerWidth='20'\n          markerHeight='16'\n          orient='auto' \n          viewBox='-14 -8 20 16'\n          markerUnits='userSpaceOnUse'\n        >\n          <path fill=blue fill-opacity=.3 d='M-16,-8 H4 V8 H-16 Z' />\n        </marker>\n\n      </defs>");










      } }]);return _class;}(superClass);

};var _index = __webpack_require__(72);var _index2 = _interopRequireDefault(_index);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _get2 = __webpack_require__(65);var _get3 = _interopRequireDefault(_get2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);exports.default = function (superClass) {
  return function (_superClass) {(0, _inherits3.default)(_class, _superClass);
    function _class() {var _ref;(0, _classCallCheck3.default)(this, _class);for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {arg[_key] = arguments[_key];}return (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(

      arg)));
    }(0, _createClass3.default)(_class, [{ key: "install", value: function install()

      {
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), "install", this).call(this);
      } }, { key: "destroy", value: function destroy()

      {
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), "destroy", this).call(this);
      } }, { key: "display", value: function display()

      {
        var x = "",y = "",snappedX = this.snappedX,snappedY = this.snappedY;
        if (snappedX) {
          x = "\n        <path \n          d=\"M" +

          snappedX + ",-100000 L" + snappedX + ",100000\"\n          stroke=\"rgb(255, 195, 66)\"\n          stroke-opacity=\".5\"\n          stroke-width=\"2\"\n          pointer-events=\"none\"\n        >\n        </path>\n        ";







        }

        if (snappedY) {
          y = "\n          <path \n            d=\"M-100000," +

          snappedY + " L100000," + snappedY + "\"\n            stroke=\"rgb(255, 195, 66)\"\n            stroke-opacity=\".5\"\n            stroke-width=\"2\"\n            pointer-events=\"none\"\n          ></path>\n        ";






        }
        return (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), "display", this).call(this) + ("<g>" + x + y + "</g>");
      } }]);return _class;}(superClass);

};function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _keys = __webpack_require__(59);var _keys2 = _interopRequireDefault(_keys);var _toConsumableArray2 = __webpack_require__(38);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);var _slicedToArray2 = __webpack_require__(60);var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _get2 = __webpack_require__(65);var _get3 = _interopRequireDefault(_get2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);exports.default =








function (superClass) {
  return function (_superClass) {(0, _inherits3.default)(_class, _superClass);
    function _class() {var _ref;(0, _classCallCheck3.default)(this, _class);for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {arg[_key] = arguments[_key];}var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(

      arg)));

      _this["LineLayerMixin@handleClick"] = _this["LineLayerMixin@handleClick"].bind(_this);
      _this["LineLayerMixin@mouseMove"] = _this["LineLayerMixin@mouseMove"].bind(_this);
      _this["LineLayerMixin@mouseDown"] = _this["LineLayerMixin@mouseDown"].bind(_this);

      _this["LineLayerMixin@dblclick"] = _this["LineLayerMixin@dblclick"].bind(_this);return _this;

    }(0, _createClass3.default)(_class, [{ key: 'createLine', value: function createLine(

      line, silent) {
        var newLine = _index3.default.assign({}, line, {
          id: line.id || _index7.default.next() });

        newLine.points = this.getPoints(newLine);
        if (silent ? true : this.emit("createLine", newLine)) {
          this.lines = _index3.default.assign({}, this.lines, (0, _defineProperty3.default)({},
          newLine.id, newLine));


          return true;
        }
        return false;
      } }, { key: 'updateLine', value: function updateLine(

      line, silent) {
        if (silent ? true : this.emit("updateLine", line)) {
          this.lines = _index3.default.assign({}, this.lines, (0, _defineProperty3.default)({},
          line.id, _index3.default.assign({}, this.lines[line.id], line)));

          return true;
        }
        return false;
      } }, { key: 'removeLine', value: function removeLine(

      line, silent) {

        if (silent ? true : this.emit("removeLine", line)) {
          if (this.focusObjectId === line.id) {
            this.focusObjectId = null;
            this.focusShape(this.shapes[this.lines[line.id].sourceShapeId]);
          }
          this.lines = _index3.default.omit(this.lines, [line.id]);
          return true;
        }
        return false;
      } }, { key: 'focusLine', value: function focusLine(

      line, silent) {
        this.selectsObjectIds = {};

        if (silent ? true : this.emit("focusLine", line)) {
          this.focusObjectId = line.id;
          return true;
        }
        return false;
      } }, { key: 'focusPoint', value: function focusPoint(

      lineId, index, silent) {
        if (silent ? true : this.emit("focusPoint", lineId, index)) {
          this.focusObjectId = _index7.default.join(lineId, index);
          return true;
        }
        return false;
      } }, { key: 'removePoint', value: function removePoint(

      lineId, index, silent) {
        if (silent ? true : this.emit("removePoint", lineId, index)) {
          this.lines[lineId].points.splice(+index, 1);
          this.lines[lineId].points = this.getPoints(this.lines[lineId]);
          this.lines = this.lines;

          if (this.focusObjectId === _index7.default.join(lineId, index)) {
            this.focusObjectId = null;
          }
          return true;
        }
        return false;
      } }, { key: 'calcPointsOfSelfConnectLine', value: function calcPointsOfSelfConnectLine(

      shapeId) {
        var shapePos = this.getPointByShape(shapeId);
        return [
        {
          x: shapePos.x,
          y: shapePos.y + shapePos.height / 2 },

        {
          x: shapePos.x,
          y: shapePos.y + shapePos.height },

        {
          x: shapePos.x + shapePos.width,
          y: shapePos.y + shapePos.height },

        {
          x: shapePos.x + shapePos.width,
          y: shapePos.y - shapePos.height },

        {
          x: shapePos.x,
          y: shapePos.y - shapePos.height },

        {
          x: shapePos.x,
          y: shapePos.y - shapePos.height / 2 }];


      } }, { key: 'install', value: function install()

      {var _this2 = this;
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'install', this).call(this);

        var backUpShapeId = void 0,pendingPointName = void 0,anotherPendingPointName = void 0,hasAutoCalcMidPoint = void 0;

        var onPan = function onPan(dx, dy, x, y, e, panningTarget, panOffset) {
          if (_this2.panningPointId) {var _IdManager$split =
            _index7.default.split(_this2.panningPointId),_IdManager$split2 = (0, _slicedToArray3.default)(_IdManager$split, 2),lineId = _IdManager$split2[0],index = _IdManager$split2[1],
            frameBx = _this2.svg.getBoundingClientRect(),
            mousePoint = _this2.snap(_index3.default.unapplyMatrix(_this2.matrix, {
              x: e.clientX - frameBx.left,
              y: e.clientY - frameBx.top })),

            points = _this2.lines[lineId].points,

            shape = _index3.default.closest(e.target, ".shape");
            if (shape) {
              if (!(_index9.default.modeFilter.LineReconnect & _this2.mode)) {
                return;
              }var _IdManager$split3 =
              _index7.default.split(shape.id),_IdManager$split4 = (0, _slicedToArray3.default)(_IdManager$split3, 2),_ = _IdManager$split4[0],shapeId = _IdManager$split4[1];
              if (shapeId !== _this2.lines[lineId][pendingPointName] && shapeId !== _this2.lines[lineId][anotherPendingPointName]) {
                _this2.lines[lineId][pendingPointName] = shapeId;
                if (hasAutoCalcMidPoint) {
                  _this2.lines[lineId].points = [];
                }
                _this2.lines[lineId].points = _this2.getPoints(_this2.lines[lineId]);
                _this2.lines = _this2.lines;
              }

              if (shapeId === _this2.lines[lineId][anotherPendingPointName]) {
                _this2.lines[lineId][pendingPointName] = shapeId;
                if (_this2.lines[lineId].points.length <= 2 && !hasAutoCalcMidPoint) {
                  _this2.lines[lineId].points = _this2.calcPointsOfSelfConnectLine(shapeId);
                  hasAutoCalcMidPoint = true;
                }
                _this2.lines[lineId].points = _this2.getPoints(_this2.lines[lineId]);
                _this2.lines = _this2.lines;
              }

            } else {
              if (index === "0") {

                if (!(_index9.default.modeFilter.LineReconnect & _this2.mode)) {
                  return;
                }
                _this2.lines[lineId].sourcePoint = mousePoint;
                _this2.lines[lineId].sourceShapeId = "";
                if (hasAutoCalcMidPoint) {
                  _this2.lines[lineId].points = [];
                }
                _this2.lines[lineId].points = _this2.getPoints(_this2.lines[lineId]);
                _this2.lines = _this2.lines;
              } else if (index === points.length - 1 + "") {

                if (!(_index9.default.modeFilter.LineReconnect & _this2.mode)) {
                  return;
                }
                _this2.lines[lineId].targetPoint = mousePoint;
                _this2.lines[lineId].targetShapeId = "";
                if (hasAutoCalcMidPoint) {
                  _this2.lines[lineId].points = [];
                }
                _this2.lines[lineId].points = _this2.getPoints(_this2.lines[lineId]);
                _this2.lines = _this2.lines;
              } else {
                if (!(_index9.default.modeFilter.LinePan & _this2.mode)) {
                  return;
                }

                _this2.lines[lineId].points[index] = mousePoint;
                if (hasAutoCalcMidPoint) {
                  _this2.lines[lineId].points = [];
                }
                _this2.lines[lineId].points = _this2.getPoints(_this2.lines[lineId]);
                _this2.lines = _this2.lines;
              }
            }
            _this2.requestAutoScroll(e.clientX, e.clientY);
          }
        },onPanStart = function onPanStart(x, y, e, panningTarget, panOffset) {
          if (_index3.default.hasClass(panningTarget, "point")) {
            var point = panningTarget,_IdManager$split5 =
            _index7.default.split(point.id),_IdManager$split6 = (0, _slicedToArray3.default)(_IdManager$split5, 3),_ = _IdManager$split6[0],lineId = _IdManager$split6[1],index = _IdManager$split6[2],
            frameBx = _this2.svg.getBoundingClientRect(),
            mousePoint = _index3.default.unapplyMatrix(_this2.matrix, {
              x: e.clientX - frameBx.left,
              y: e.clientY - frameBx.top }),

            points = _this2.lines[lineId].points.slice(0);

            _this2.panningPointId = _index7.default.join(lineId, index);

            if (index === "0") {

              if (!(_index9.default.modeFilter.LineReconnect & _this2.mode)) {
                return;
              }
              backUpShapeId = _this2.lines[lineId].sourceShapeId;

              _this2.lines[lineId].sourcePoint = mousePoint;
              _this2.lines[lineId].sourceShapeId = "";
              _this2.lines = _this2.lines;
              pendingPointName = "sourceShapeId";
              anotherPendingPointName = "targetShapeId";
            } else if (index === points.length - 1 + "") {

              if (!(_index9.default.modeFilter.LineReconnect & _this2.mode)) {
                return;
              }
              backUpShapeId = _this2.lines[lineId].targetShapeId;

              _this2.lines[lineId].targetPoint = mousePoint;
              _this2.lines[lineId].targetPoint = "";
              _this2.lines = _this2.lines;

              pendingPointName = "targetShapeId";
              anotherPendingPointName = "sourceShapeId";
            } else {

              if (!(_index9.default.modeFilter.LinePan & _this2.mode)) {
                return;
              }
              points[index] = mousePoint;

              _this2.lines[lineId].points = points;
              _this2.lines = _this2.lines;
            }

            _this2.beforeSnap(_index7.default.join(lineId, index));
          }

          if (_index3.default.matches(panningTarget, "[data-action^='add-line-']")) {
            var type = panningTarget.getAttribute("data-action").replace(/^add-line-/, ''),
            sourceShape = _index3.default.closest(e.target, ".shape"),
            shapeId = _this2.focusObjectId,
            _frameBx = _this2.svg.getBoundingClientRect(),
            targetPoint = _index3.default.unapplyMatrix(_this2.matrix, {
              x: e.clientX - _frameBx.left,
              y: e.clientY - _frameBx.top }),

            line = {
              id: _index7.default.next(),
              type: type,
              sourceShapeId: shapeId,
              targetShapeId: "",
              points: [],

              sourcePoint: { x: -99999, y: -99999 },
              targetPoint: targetPoint,

              isCreateByPan: true };

            line.points = _this2.getPoints(line);

            _this2.ghostLine = line;
          }
        },onPanEnd = function onPanEnd(e) {
          if (_this2.panningPointId) {var _IdManager$split7 =
            _index7.default.split(_this2.panningPointId),_IdManager$split8 = (0, _slicedToArray3.default)(_IdManager$split7, 2),lineId = _IdManager$split8[0],index = _IdManager$split8[1];

            if (!_this2.lines[lineId][pendingPointName]) {
              _this2.lines[lineId][pendingPointName] = backUpShapeId;
              _this2.lines[lineId].points = _this2.getPoints(_this2.lines[lineId]);
              _this2.lines = _this2.lines;
            } else {
              if (!_this2.updateLine(_this2.lines[lineId])) {
                _this2.lines[lineId][pendingPointName] = backUpShapeId;
                _this2.lines[lineId].points = _this2.getPoints(_this2.lines[lineId]);
                _this2.lines = _this2.lines;
              }
            }
          }

          if (_this2.ghostLine && _this2.ghostLine.isCreateByPan) {
            if (_this2.ghostLine.targetShapeId) {

              if (_this2.createLine(_this2.ghostLine)) {
                _this2.focusShape(_this2.shapes[_this2.ghostLine.targetShapeId]);
                _this2.ghostLine = null;
              }
            } else {
              _this2.ghostLine = null;
            }
          }
          _this2.afterSnap();
          _this2["panningPointId"] = "";
          hasAutoCalcMidPoint = false;
          _this2.cancelAutoScroll();
        };

        this["LineLayerMixin@pannableHandler"] = (0, _index5.default)(this.svg, onPan, onPanStart, onPanEnd);

        this.svg.addEventListener("click", this["LineLayerMixin@handleClick"], false);
        this.svg.addEventListener("mousemove", this["LineLayerMixin@mouseMove"], false);
        this.svg.addEventListener("mousedown", this["LineLayerMixin@mouseDown"], false);
        this.svg.addEventListener("dblclick", this["LineLayerMixin@dblclick"], false);
      } }, { key: 'destroy', value: function destroy()

      {
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'destroy', this).call(this);

        this["LineLayerMixin@pannableHandler"]();

        this.svg.removeEventListener("click", this["LineLayerMixin@handleClick"], false);
        this.svg.removeEventListener("mousemove", this["LineLayerMixin@mouseMove"], false);
        this.svg.removeEventListener("mousedown", this["LineLayerMixin@mouseDown"], false);
        this.svg.removeEventListener("dblclick", this["LineLayerMixin@dblclick"], false);
      } }, { key:

      "LineLayerMixin@handleClick", value: function LineLayerMixinHandleClick(e) {
        var btn = _index3.default.closest(e.target, "[data-action^='add-line-']");
        if (btn) {
          var type = btn.getAttribute("data-action").replace(/^add-line-/, ''),
          sourceShape = _index3.default.closest(e.target, ".shape"),
          shapeId = this.focusObjectId,
          frameBx = this.svg.getBoundingClientRect(),
          targetPoint = _index3.default.unapplyMatrix(this.matrix, {
            x: e.clientX - frameBx.left,
            y: e.clientY - frameBx.top }),

          line = {
            id: _index7.default.next(),
            type: type,
            sourceShapeId: shapeId,
            targetShapeId: "",
            points: [],

            sourcePoint: { x: -99999, y: -99999 },
            targetPoint: targetPoint };

          line.points = this.getPoints(line);

          this.ghostLine = line;
        }

        if (_index9.default.modeFilter.LineFocus & this.mode) {

          var _line = _index3.default.closest(e.target, ".line");

          if (_line) {var _IdManager$split9 =
            _index7.default.split(_line.id),_IdManager$split10 = (0, _slicedToArray3.default)(_IdManager$split9, 2),_ = _IdManager$split10[0],lineId = _IdManager$split10[1];

            this.focusLine(this.lines[lineId]);
          }
        }


        var point = _index3.default.closest(e.target, ".point");
        if (point) {var _IdManager$split11 =
          _index7.default.split(point.id),_IdManager$split12 = (0, _slicedToArray3.default)(_IdManager$split11, 3),_2 = _IdManager$split12[0],_lineId = _IdManager$split12[1],index = _IdManager$split12[2];

          if (index !== "0" && +index < this.lines[_lineId].points.length - 1) {
            this.focusPoint(_lineId, index);
          }

        }

        if (_index3.default.closest(e.target, '[data-action="remove-focus-object"]')) {

          if (this.focusObjectId in this.lines) {
            if (this.removeLine(this.lines[this.focusObjectId])) {
            }
          } else {var _IdManager$split13 =

            _index7.default.split(this.focusObjectId),_IdManager$split14 = (0, _slicedToArray3.default)(_IdManager$split13, 2),_lineId2 = _IdManager$split14[0],_index = _IdManager$split14[1];

            if (_lineId2 in this.lines) {
              if (_index in this.lines[_lineId2].points) {
                if (_index !== "0" && +_index < this.lines[_lineId2].points.length - 1) {
                  if (this.removePoint(_lineId2, _index)) {
                    this.focusObjectId = null;
                  }
                }
              }
            }
          }
        }
      } }, { key:

      "LineLayerMixin@mouseMove", value: function LineLayerMixinMouseMove(e) {
        if (this.ghostLine) {
          var shape = _index3.default.closest(e.target, ".shape");
          if (shape) {var _IdManager$split15 =
            _index7.default.split(shape.id),_IdManager$split16 = (0, _slicedToArray3.default)(_IdManager$split15, 2),_ = _IdManager$split16[0],shapeId = _IdManager$split16[1];
            if (shapeId !== this.ghostLine.targetShapeId && shapeId !== this.ghostLine.sourceShapeId) {
              var ghostLine = _index3.default.assign({}, this.ghostLine, {
                targetShapeId: shapeId,
                points: [] }),

              points = this.getPoints(ghostLine);
              ghostLine.points = points;
              this.ghostLine = ghostLine;
            }

            if (shapeId === this.ghostLine.sourceShapeId) {
              var _ghostLine = _index3.default.assign({}, this.ghostLine, {
                targetShapeId: shapeId,
                points: this.calcPointsOfSelfConnectLine(shapeId) }),

              _points = this.getPoints(_ghostLine);
              _ghostLine.points = _points;
              this.ghostLine = _ghostLine;
            }

          } else {
            var frameBx = this.svg.getBoundingClientRect(),
            targetPoint = _index3.default.unapplyMatrix(this.matrix, {
              x: e.clientX - frameBx.left,
              y: e.clientY - frameBx.top }),

            _ghostLine2 = _index3.default.assign({}, this.ghostLine, {
              targetPoint: targetPoint,
              targetShapeId: "",
              points: [] }),

            _points2 = this.getPoints(_ghostLine2);

            _ghostLine2.points = _points2;
            this.ghostLine = _ghostLine2;
          }
        }
      } }, { key:

      "LineLayerMixin@mouseDown", value: function LineLayerMixinMouseDown(e) {
        if (this.ghostLine) {
          if (this.ghostLine.targetShapeId) {

            if (this.createLine(this.ghostLine)) {
              this.ghostLine = null;
            }
          } else {
            this.ghostLine = null;
          }
        }
      } }, { key:

      "LineLayerMixin@dblclick", value: function LineLayerMixinDblclick(e) {
        if (!(_index9.default.modeFilter.LinePan & this.mode)) {
          return;
        }
        var line = _index3.default.closest(e.target, ".line");
        if (line) {var _IdManager$split17 =
          _index7.default.split(line.id),_IdManager$split18 = (0, _slicedToArray3.default)(_IdManager$split17, 2),_ = _IdManager$split18[0],lineId = _IdManager$split18[1],
          frameBx = this.svg.getBoundingClientRect(),
          mousePoint = _index3.default.unapplyMatrix(this.matrix, {
            x: e.clientX - frameBx.left,
            y: e.clientY - frameBx.top }),

          pointOnLine = (0, _getProjectionofPointOnLine2.default)(mousePoint, this.lines[lineId].points),
          points = this.lines[lineId].points.slice(0);
          if (pointOnLine) {
            points.splice(pointOnLine.i + 1, 0, mousePoint);
            this.lines[lineId].points = points;
            this.lines = this.lines;
          }

        }
      } }, { key: 'getPoints', value: function getPoints(_ref2)








      {var sourceShapeId = _ref2.sourceShapeId,targetShapeId = _ref2.targetShapeId,points = _ref2.points,sourcePoint = _ref2.sourcePoint,targetPoint = _ref2.targetPoint;

        if (sourceShapeId && targetShapeId && points.length > 2) {
          var inpa = this.getIntersetion(points[1], sourceShapeId),
          inpb = this.getIntersetion(points[points.length - 2], targetShapeId);

          if (inpa && inpb) {
            return [inpa].concat((0, _toConsumableArray3.default)(points.slice(1, points.length - 1)), [inpb]);
          }
          return [];
        }


        if (sourceShapeId && !targetShapeId && points.length > 2 && targetPoint) {
          var _inpa = this.getIntersetion(points[1], sourceShapeId);
          if (_inpa) {
            return [_inpa].concat((0, _toConsumableArray3.default)(points.slice(1, points.length - 1)), [targetPoint]);
          }
          return [];
        }


        if (!sourceShapeId && targetShapeId && points.length > 2 && sourcePoint) {
          var _inpb = this.getIntersetion(points[points.length - 2], targetShapeId);
          if (_inpb) {
            return [sourcePoint].concat((0, _toConsumableArray3.default)(points.slice(1, points.length - 1)), [_inpb]);
          }
          return [];
        }


        if (!sourceShapeId && !targetShapeId && points.length > 2) {
          return [];
        }


        if (sourceShapeId && targetShapeId && points.length <= 2) {
          var _inpa2 = this.getIntersetion(sourceShapeId, targetShapeId),
          _inpb2 = this.getIntersetion(targetShapeId, sourceShapeId);

          if (_inpa2 && _inpb2) {
            return [_inpa2, _inpb2];
          }
          return [];
        }


        if (sourceShapeId && !targetShapeId && points.length <= 2) {
          var _inpa3 = this.getIntersetion(sourceShapeId, targetPoint);

          if (_inpa3) {
            return [_inpa3, targetPoint];
          }
          return [];
        }


        if (!sourceShapeId && targetShapeId && points.length <= 2) {
          var _inpb3 = this.getIntersetion(sourcePoint, targetShapeId);


          if (_inpb3) {
            return [sourcePoint, _inpb3];
          }
          return [];
        }


        if (!sourceShapeId && !targetShapeId && points.length <= 2) {
          return [];
        }
      } }, { key: 'getIntersetion', value: function getIntersetion(

      source, target) {
        var line = this.getLine(source, target),
        curve = this.getCurve(source, target),

        int = Snap.path.intersection(line, curve);
        if (int && int.length) {
          return int[0];
        }


        if (typeof source === "string") {
          return this.getPointByShape(source);
        } else if (typeof target === "string") {
          return this.getPointByShape(target);
        }
        return null;
      } }, { key: 'getLine', value: function getLine(

      source, target) {
        var p1 = void 0,p2 = void 0;
        if (typeof source === "string") {
          p1 = this.getPointByShape(source);
        } else {
          p1 = source;
        }

        if (typeof target === "string") {
          p2 = this.getPointByShape(target);
        } else {
          p2 = target;
        }

        return 'M ' + p1.x + ' ' + p1.y + ' L ' + p2.x + ' ' + p2.y;
      } }, { key: 'getLineDefByType', value: function getLineDefByType(

      type) {
        return this.lineDefs[type] || this.lineDefs[(0, _keys2.default)(this.lineDefs)[0]];
      } }, { key: 'getPointByShape', value: function getPointByShape(

      shapeId) {var _Snap;
        var shape = this.shapes[shapeId],
        type = shape.type,matrix = shape.matrix,_getShapeDefByType =
        this.getShapeDefByType(type),bbox = _getShapeDefByType.bbox,
        width = shape.type === 'normal' ? _index3.default.getTextLen(shape.name) : bbox.width,

        ctm = (_Snap = Snap).matrix.apply(_Snap, (0, _toConsumableArray3.default)(matrix)).translate(-(bbox.x + width / 2), -(bbox.y + bbox.height / 2)),
        mid = {
          x: bbox.x + width / 2,
          y: bbox.y + bbox.height / 2 },

        tmid = _index3.default.applyMatrix([ctm.a, ctm.b, ctm.c, ctm.d, ctm.e, ctm.f], mid),
        ttopLeft = _index3.default.applyMatrix([ctm.a, ctm.b, ctm.c, ctm.d, ctm.e, ctm.f], bbox);
        tmid.width = 2 * (tmid.x - ttopLeft.x);
        tmid.height = 2 * (tmid.y - ttopLeft.y);
        return tmid;
      } }, { key: 'getCurve', value: function getCurve(

      source, target) {var _Snap2;
        var shapeId = void 0;
        if (typeof source === "string") {
          shapeId = source;
        } else {
          shapeId = target;
        }

        var shape = this.shapes[shapeId],
        type = shape.type,matrix = shape.matrix,_getShapeDefByType2 =
        this.getShapeDefByType(type),bbox = _getShapeDefByType2.bbox,path = _getShapeDefByType2.path,
        width = _index3.default.isRectNode(shape) ? _index3.default.getTextLen(shape.name) : bbox.width;
        if (bbox.path && _index3.default.isRectNode(shape)) {
          path = MW.deepClone(bbox.path);
          path[1][1] = width;
          path[3][1] = -width;
        }

        var ctm = (_Snap2 = Snap).matrix.apply(_Snap2, (0, _toConsumableArray3.default)(matrix)).translate(-(bbox.x + width / 2), -(bbox.y + bbox.height / 2));


        return Snap.path.map(path, ctm);
      } }, { key: 'addLine', value: function addLine(

      type, name, style, focusStyle) {
        this.lineDefs[type] = {
          type: type,
          name: name,
          style: style,
          focusStyle: focusStyle };

        this.lineDefs = this.lineDefs;
      } }, { key: 'getBBox', value: function getBBox(
      points) {var hotAreaWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
        if (points.length) {
          var xmin = points[0].x,
          ymin = points[0].y,
          xmax = xmin,
          ymax = ymin;
          for (var i = 0; i < points.length; i++) {
            xmin = Math.min(points[i].x, xmin);
            ymin = Math.min(points[i].y, ymin);
            xmax = Math.max(points[i].x, xmax);
            ymax = Math.max(points[i].y, ymax);
          }

          return {
            x: xmin - hotAreaWidth / 2,
            y: ymin - hotAreaWidth / 2,
            width: xmax - xmin + hotAreaWidth,
            height: ymax - ymin + hotAreaWidth };

        }
        return { x: 0, y: 0, width: 0, height: 0 };
      } }, { key: 'getTotalLengthOfPoint', value: function getTotalLengthOfPoint(

      points) {

        return Snap.path.getTotalLength('M ' + points[0].x + ' ' + points[0].y + ' ' + points.slice(1).map(function (_ref3) {var x = _ref3.x,y = _ref3.y;return 'L ' + x + ' ' + y;}).join(""));
      } }, { key: 'getPanningLineHtml', value: function getPanningLineHtml()

      {var _this3 = this;
        if (this.panningGroup && !_index3.default.isEmpty(this.panningGroup.lines)) {var _panningGroup =
          this.panningGroup,panStartPoint = _panningGroup.panStartPoint,panEndPoint = _panningGroup.panEndPoint,
          dx = panEndPoint.x - panStartPoint.x,
          dy = panEndPoint.y - panStartPoint.y;

          return (0, _keys2.default)(this.panningGroup.lines).map(function (lineId) {var _lines$lineId =
            _this3.lines[lineId],type = _lines$lineId.type,points = _lines$lineId.points,id = _lines$lineId.id,sourceShapeId = _lines$lineId.sourceShapeId,targetShapeId = _lines$lineId.targetShapeId,_getLineDefByType =
            _this3.getLineDefByType(type),style = _getLineDefByType.style,focusStyle = _getLineDefByType.focusStyle;
            return '\n            <polyline \n            points="' +

            points.map(function (_ref4) {var x = _ref4.x,y = _ref4.y;return x + dx + ' ' + (y + dy);}).join(",") + '"\n            ' +
            (0, _keys2.default)(style).map(function (name) {return name + '="' + style[name] + '"';}).join(" ") + '\n            pointer-events="none"\n            stroke="rgb(255, 195, 66)"\n            stroke-width=2\n          ></polyline>\n          ';





          }).join("");
        }
        return "";
      } }, { key: 'renderOneLine', value: function renderOneLine(

      line, isGhost) {var _this4 = this;var
        type = line.type,points = line.points,id = line.id,sourceShapeId = line.sourceShapeId,targetShapeId = line.targetShapeId,_line$tip = line.tip,tip = _line$tip === undefined ? '' : _line$tip,_getLineDefByType2 =
        this.getLineDefByType(type),style = _getLineDefByType2.style,focusStyle = _getLineDefByType2.focusStyle,
        focusedPointIndex = this.focusObjectId && +this.focusObjectId.replace(new RegExp('^' + id + ':(\\d+)$', "g"), "$1"),
        focus = this.focusObjectId === id,
        semifocus = typeof focusedPointIndex === "number",
        bbox = this.getBBox(points),
        muted = isGhost || this.panningPointId || !(focus || semifocus),
        ps = points.map(function (_ref5) {var x = _ref5.x,y = _ref5.y;return x + ' ' + y;}).join(","),
        startDash = 10,
        endDash = 10,
        lineLength = this.getTotalLengthOfPoint(points),
        midDash = lineLength - startDash - endDash,
        canReconnect = _index9.default.modeFilter.LineReconnect & this.mode,
        start = canReconnect ? 0 : 1,
        end = canReconnect ? void 0 : -1,
        opacity = 0,

        midPoint = Snap.path.getPointAtLength('M ' + points[0].x + ' ' + points[0].y + ' ' + points.slice(1).map(function (_ref6) {var x = _ref6.x,y = _ref6.y;return 'L ' + x + ' ' + y;}).join(""), lineLength / 2),
        tipLite = tip.replace(/(.{7}).*/g, '$1...');

        if (this.panningGroup && (sourceShapeId in this.panningGroup.shapes || targetShapeId in this.panningGroup.shapes)) {
          opacity = .5;
        }


        if (focus) {
          style = _index3.default.assign({}, style, focusStyle);
        }

        return '\n      <g\n        id="' +

        _index7.default.join(this.id, id) + '"\n        class="line"\n      >\n        <polyline \n          points="' +



        ps + '"\n          fill="none"\n          stroke="transparent"\n          stroke-opacity="0"\n          stroke-width="10"\n          pointer-events="' + (




        isGhost ? "none" : "auto") + '"\n        ></polyline>\n        <polyline \n          points="' +


        ps + '"\n          fill="none"\n          stroke="#fff"\n          stroke-opacity="0.9"\n          stroke-dasharray="' +



        startDash + ' ' + midDash + ' ' + endDash + '"\n          stroke-dashoffset="' + (
        startDash + midDash + endDash) + '"\n          stroke-width="' +
        6 + '"\n          pointer-events="none"\n        ></polyline>\n        <polyline \n          points="' +



        ps + '"\n          ' +
        (0, _keys2.default)(style).map(function (name) {return name + '="' + style[name] + '"';}).join(" ") + '\n          pointer-events="none"\n          ' + (

        opacity ? 'style=opacity:' + opacity : '') + '\n        ></polyline>\n\n        ' +


        points.slice(start, end).map(function (_ref7, i) {var x = _ref7.x,y = _ref7.y;return '\n          <circle \n            cx="' +

          x + '" \n            cy="' +
          y + '" \n            r="5" \n            fill="' + (

          focusedPointIndex === i + start ? "red" : "#000") + '" \n            pointer-events="' + (
          muted ? "none" : "all") + '"\n            fill-opacity="' + (
          focusedPointIndex === i + start ? "1" : ".3") + '" \n            stroke="transparent" \n            stroke-width="10" \n            id="' +


          _index7.default.join(_this4.id, id, i + start) + '" \n            class="point pannable"\n            visibility="' + (

          (focus || focusedPointIndex) && _index9.default.modeFilter.LinePan & _this4.mode ? "visible" : "hidden") + '"\n            ></circle>\n        ';}).

        join("") + '\n\n        <rect\n          x = "' +


        bbox.x + '"\n          y = "' +
        bbox.y + '"\n          width = "' +
        bbox.width + '"\n          height = "' +
        bbox.height + '"\n          fill="none" \n          stroke="#8888FF" \n          stroke-dasharray="3,3"\n          shape-rendering = "crispEdges"\n          visibility="' + (




        focus ? "visible" : "hidden") + '"\n          pointer-events = "none"\n        >\n        </rect>\n        <title>' + (



        tip || '') + '</title>\n        <g>\n          <text style="cursor: default;" x=' +

        midPoint.x + ' y=' + midPoint.y + ' text-anchor=middle filter=url(#' + _index7.default.join(this.id, "screenBlendMode") + ' font-size=11>\n            <tspan>' + (
        tipLite || '') + '</tspan>\n            <title>' + (
        tip || '') + '</title>\n          </text>\n        </g>\n      </g>\n      ';




      } }, { key: 'display', value: function display()

      {var _this5 = this;
        var linesHtml = (0, _keys2.default)(this.lines).map(function (lineId) {return lineId === _this5.focusObjectId ? "" : _this5.renderOneLine(_this5.lines[lineId]);}).join(""),
        ghostLineHtml = this.ghostLine ?
        this.renderOneLine(this.ghostLine, true) :
        "",
        focusLineHtml = this.focusObjectId in this.lines ? this.renderOneLine(this.lines[this.focusObjectId]) : "",
        panningLineHtml = this.getPanningLineHtml();
        return (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'display', this).call(this) + ('<g>' + linesHtml + ghostLineHtml + focusLineHtml + '</g><g>' + panningLineHtml + '</g>');
      } }]);return _class;}(superClass);

};var _index2 = __webpack_require__(66);var _index3 = _interopRequireDefault(_index2);var _index4 = __webpack_require__(202);var _index5 = _interopRequireDefault(_index4);var _index6 = __webpack_require__(72);var _index7 = _interopRequireDefault(_index6);var _getProjectionofPointOnLine = __webpack_require__(997);var _getProjectionofPointOnLine2 = _interopRequireDefault(_getProjectionofPointOnLine);var _index8 = __webpack_require__(90);var _index9 = _interopRequireDefault(_index8);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =











function (point, points) {

  var segs = [],
  dists = [],
  minDist = 0,
  hasMinDistSeg = void 0,
  i = void 0;

  for (i = 0; i < points.length - 1; i++) {
    segs.push([points[i], points[i + 1]]);
  }

  for (i = 0; i < segs.length; i++) {
    dists[i] = (0, _getDistanceBetweenLineAndPoint2.default)(segs[i], point);
    if (i === 0) {
      minDist = dists[i];
    } else {
      minDist = Math.min(dists[i], minDist);
    }
  }

  hasMinDistSeg = segs[dists.indexOf(minDist)];

  if (Math.max(
  Math.abs(hasMinDistSeg[0].x - point.x),
  Math.abs(hasMinDistSeg[0].y - point.y)) <
  8) {
    return null;
  }

  if (Math.max(
  Math.abs(hasMinDistSeg[1].x - point.x),
  Math.abs(hasMinDistSeg[1].y - point.y)) <
  8) {
    return null;
  }

  var p = getSpPoint(hasMinDistSeg[0], hasMinDistSeg[1], point);

  return {
    x: p.x,
    y: p.y,
    i: dists.indexOf(minDist) };

};var _getDistanceBetweenLineAndPoint = __webpack_require__(998);var _getDistanceBetweenLineAndPoint2 = _interopRequireDefault(_getDistanceBetweenLineAndPoint);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function getSpPoint(A, B, C) {var x1 = A.x,y1 = A.y,x2 = B.x,y2 = B.y,x3 = C.x,y3 = C.y;var px = x2 - x1,py = y2 - y1,dAB = px * px + py * py;var u = ((x3 - x1) * px + (y3 - y1) * py) / dAB;var x = x1 + u * px,y = y1 + u * py;return { x: x, y: y };}

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =













function (line, point) {
  return distToSegment(point, line[0], line[1]);
};function sqr(x) {return x * x;}function dist2(v, w) {return sqr(v.x - w.x) + sqr(v.y - w.y);}function distToSegmentSquared(p, v, w) {var l2 = dist2(v, w);if (l2 == 0) return dist2(p, v);var t = ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;t = Math.max(0, Math.min(1, t));return dist2(p, { x: v.x + t * (w.x - v.x), y: v.y + t * (w.y - v.y) });}function distToSegment(p, v, w) {return Math.sqrt(distToSegmentSquared(p, v, w));}

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _keys = __webpack_require__(59);var _keys2 = _interopRequireDefault(_keys);var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _slicedToArray2 = __webpack_require__(60);var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _get2 = __webpack_require__(65);var _get3 = _interopRequireDefault(_get2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);exports.default =















function (superClass) {
  return function (_superClass) {(0, _inherits3.default)(_class, _superClass);
    function _class() {var _ref;(0, _classCallCheck3.default)(this, _class);for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {arg[_key] = arguments[_key];}var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(

      arg)));

      _this["ShapeLayerMixin@handleMouseMove"] = _this["ShapeLayerMixin@handleMouseMove"].bind(_this);
      _this["ShapeLayerMixin@handleMouseDown"] = _this["ShapeLayerMixin@handleMouseDown"].bind(_this);
      _this["ShapeLayerMixin@handleMouseOver"] = _this["ShapeLayerMixin@handleMouseOver"].bind(_this);return _this;
    }(0, _createClass3.default)(_class, [{ key: 'install', value: function install()

      {var _this2 = this;
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'install', this).call(this);

        var onPan = function onPan(dx, dy, x, y, e, panningTarget, panOffset) {
          if (!(_this2.mode & _index8.default.modeFilter.ShapePan)) {
            return;
          }
          if (_this2.panningGroup) {


            var box = _this2.svg.getBoundingClientRect();
            _this2.panningGroup.panEndPoint = _this2.snap(_index6.default.unapplyMatrix(_this2.matrix, {
              x: x - box.left + panOffset.x,
              y: y - box.top + panOffset.y }));


            _this2.panningGroup = _this2.panningGroup;

            _this2.requestAutoScroll(x, y);
          }
        },onPanStart = function onPanStart(x, y, e, panningTarget, panOffset) {
          if (!(_this2.mode & _index8.default.modeFilter.ShapePan)) {
            return;
          }
          if (_index6.default.hasClass(panningTarget, "shape")) {
            var shape = panningTarget,_IdManager$split =
            _index4.default.split(shape.id),_IdManager$split2 = (0, _slicedToArray3.default)(_IdManager$split, 2),_ = _IdManager$split2[0],shapeId = _IdManager$split2[1],
            mousePoint = _this2.getShapePosition(shapeId);
            _this2.beforeSnap(shapeId);


            if (_index6.default.isEmpty(_this2.selectsObjectIds)) {
              _this2.panningGroup = {
                shapes: (0, _defineProperty3.default)({}, shapeId, true),
                lines: {},
                panStartPoint: mousePoint,
                panEndPoint: mousePoint };

            } else {
              _this2.panningGroup = {
                shapes: _index6.default.assign({}, _this2.selectsObjectIds),
                lines: (0, _keys2.default)(_this2.lines).reduce(function (p, c, i, a) {
                  if (_this2.lines[c].sourceShapeId in _this2.selectsObjectIds && _this2.lines[c].targetShapeId in _this2.selectsObjectIds) {
                    p[c] = true;
                  }
                  return p;
                }, {}),
                panStartPoint: mousePoint,
                panEndPoint: mousePoint };

            }

          }
        },onPanEnd = function onPanEnd(e) {

          if (_this2.panningGroup) {var _panningGroup =
            _this2.panningGroup,panEndPoint = _panningGroup.panEndPoint,panStartPoint = _panningGroup.panStartPoint,
            dp = {
              x: panEndPoint.x - panStartPoint.x,
              y: panEndPoint.y - panStartPoint.y };

            (0, _keys2.default)(_this2.panningGroup.shapes).forEach(function (shapeId) {
              var m = _this2.shapes[shapeId].matrix;
              m[4] += dp.x;
              m[5] += dp.y;
            });

            (0, _keys2.default)(_this2.panningGroup.lines).forEach(function (lineId) {
              var points = _this2.lines[lineId].points;
              points.forEach(function (p) {
                p.x += dp.x;
                p.y += dp.y;
              });
            });

            for (var lineId in _this2.lines) {
              if (_this2.lines.hasOwnProperty(lineId)) {
                if (_this2.lines[lineId].sourceShapeId in _this2.panningGroup.shapes ||
                _this2.lines[lineId].targetShapeId in _this2.panningGroup.shapes) {

                  _this2.lines[lineId].points = _this2.getPoints(_this2.lines[lineId]);
                }
              }
            }

            _this2.shapes = _this2.shapes;
            _this2.lines = _this2.lines;
          }
          _this2.afterSnap();
          _this2.panningGroup = null;
          _this2.cancelAutoScroll();
        };

        this["ShapeLayerMixin@pannableHandler"] = (0, _index2.default)(this.svg, onPan, onPanStart, onPanEnd);

        this.svg.addEventListener("mousemove", this["ShapeLayerMixin@handleMouseMove"], false);
        this.svg.addEventListener("mousedown", this["ShapeLayerMixin@handleMouseDown"], false);
        this.svg.addEventListener("mouseover", this["ShapeLayerMixin@handleMouseOver"], false);
        this["ShapeLayerMixin@handleClick"] = (0, _index10.default)(this.svg, function (e) {
          if (_index6.default.closest(e.target, '[data-action="remove-focus-object"]')) {

            if (_this2.focusObjectId in _this2.shapes) {
              _this2.removeShape(_this2.shapes[_this2.focusObjectId]);
            }
          }

          if (_index8.default.modeFilter.ShapeFocus & _this2.mode) {
            var shape = _index6.default.closest(e.target, ".shape");
            if (shape) {var _IdManager$split3 =
              _index4.default.split(shape.id),_IdManager$split4 = (0, _slicedToArray3.default)(_IdManager$split3, 2),_ = _IdManager$split4[0],shapeId = _IdManager$split4[1];

              _this2.focusShape(_this2.shapes[shapeId]);
            }
          }
        });

        this.formattableTitle = new _index12.default();
      } }, { key: 'destroy', value: function destroy()

      {
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'destroy', this).call(this);
        this["ShapeLayerMixin@pannableHandler"]();

        this.svg.removeEventListener("mousemove", this["ShapeLayerMixin@handleMouseMove"], false);
        this.svg.removeEventListener("mousedown", this["ShapeLayerMixin@handleMouseDown"], false);
        this.svg.removeEventListener("mouseover", this["ShapeLayerMixin@handleMouseOver"], false);
        this["ShapeLayerMixin@handleClick"]();
        this.formattableTitle.destroy();
      } }, { key:


      "ShapeLayerMixin@handleMouseMove", value: function ShapeLayerMixinHandleMouseMove(e) {
        if (this.ghostShape) {

          var m = this.ghostShape.matrix.slice(0),
          frameBx = this.svg.getBoundingClientRect(),_snap =
          this.snap(_index6.default.unapplyMatrix(this.matrix, {
            x: e.clientX - frameBx.left,
            y: e.clientY - frameBx.top })),x = _snap.x,y = _snap.y;


          m[4] = x;
          m[5] = y;
          this.ghostShape = _index6.default.assign({}, this.ghostShape, {
            matrix: m });



        }
      } }, { key:

      "ShapeLayerMixin@handleMouseDown", value: function ShapeLayerMixinHandleMouseDown(e) {
        if (this.ghostShape) {
          this.createShape(this.ghostShape);
          this.ghostShape = null;
          this.afterSnap();

        }
      } }, { key:

      "ShapeLayerMixin@handleMouseOver", value: function ShapeLayerMixinHandleMouseOver(e) {
        var shape = _index6.default.closest(e.target, ".shape");
        if (shape) {var _IdManager$split5 =
          _index4.default.split(shape.id),_IdManager$split6 = (0, _slicedToArray3.default)(_IdManager$split5, 2),_ = _IdManager$split6[0],shapeId = _IdManager$split6[1];

          var title = '';
          this.emit('requestTitle', this.shapes[shapeId], function (t) {return title = t;});
          if (title) {
            this.formattableTitle.request(shape, title);
          }
        }
      } }, { key: 'proxyBBoxWidth', value: function proxyBBoxWidth(

      bbox) {
        if (!bbox) return;
        var width = bbox.width;
        delete bbox.width;
        Object.defineProperty(bbox, "width", {
          get: function get() {
            return width;
          },
          set: function set(value) {
            width = value;
          } });

      } }, { key: 'addShape', value: function addShape(
      type, typeName, html, meta) {
        var path = (0, _transformShape2path2.default)(html),

        bbox = Snap.path.getBBox(path);
        if (type === 'normal') {

        }
        this.shapeDefs = _index6.default.assign({}, this.shapeDefs, (0, _defineProperty3.default)({},
        type, {
          type: type,
          html: html,
          path: path,
          bbox: bbox,
          name: typeName || "",
          meta: _index6.default.assign({}, {
            lineButtonTypes: [] },
          meta || {}) }));


      } }, { key: 'createShape', value: function createShape(

      shape, silent) {
        var id = shape.id || _index4.default.next();
        shape.id = id;
        if (silent ? true : this.emit("createShape", shape)) {
          this.shapes = _index6.default.assign({}, this.shapes, (0, _defineProperty3.default)({},
          shape.id, shape));

          this.focusShape(shape);
          return true;
        }
        return false;
      } }, { key: 'updateShape', value: function updateShape(

      shape, silent) {
        if (silent ? true : this.emit("updateShape", shape)) {
          this.shapes = _index6.default.assign({}, this.shapes, (0, _defineProperty3.default)({},
          shape.id, _index6.default.assign({}, this.shapes[shape.id], shape)));

          for (var lineId in this.lines) {
            if (this.lines.hasOwnProperty(lineId)) {
              if (this.lines[lineId].sourceShapeId === shape.id ||
              this.lines[lineId].targetShapeId === shape.id) {

                this.lines[lineId].points = this.getPoints(this.lines[lineId]);
              }
            }
          }
          this.lines = this.lines;
          return true;
        }
        return false;
      } }, { key: 'removeShape', value: function removeShape(

      shape, silent) {
        if (silent ? true : this.emit("removeShape", shape)) {

          this.shapes = _index6.default.omit(this.shapes, [shape.id]);

          if (this.focusObjectId === shape.id) {
            this.focusObjectId = null;
            if ((0, _keys2.default)(this.shapes).length) {
              this.focusShape(this.shapes[(0, _keys2.default)(this.shapes)[0]]);
            } else {
              this.blur();
            }
          }

          for (var lineId in this.lines) {
            if (this.lines.hasOwnProperty(lineId)) {
              if (this.lines[lineId].sourceShapeId === shape.id ||
              this.lines[lineId].targetShapeId === shape.id) {
                this.removeLine(this.lines[lineId], silent);
              }
            }
          }

          this.lines = this.lines;
          return true;
        }
        return false;
      } }, { key: 'focusShape', value: function focusShape(

      shape, silent) {
        if (silent ? true : this.emit("focusShape", shape)) {
          this.focusObjectId = shape.id;
        }
        this.selectsObjectIds = {};
      } }, { key: 'beforeCreateShape', value: function beforeCreateShape(

      desciption) {
        var des = _index6.default.assign({}, desciption);

        des.id = des.id || _index4.default.next();

        this.ghostShape = des;

        this.beforeSnap();
      } }, { key: 'getShapeDefByType', value: function getShapeDefByType(

      type) {
        return this.shapeDefs[type] || this.shapeDefs[(0, _keys2.default)(this.shapeDefs)[0]];
      } }, { key: 'setColor', value: function setColor(

      idncolors) {
        this.colorOfShapes = idncolors.reduce(function (p, c, i, a) {
          p[c.id] = c;
          return p;
        }, {});
      } }, { key: 'renderOneShape', value: function renderOneShape(

      pid, def, shape, focusObjectId, isGhost) {

        if (_index6.default.isRectNode(def)) {
          def.bbox.width = _index6.default.getTextLen(shape.name);
          def.html = def.html.replace(/width="\d+"/, 'width="' + def.bbox.width + '"');
        }var
        id = shape.id,type = shape.type,name = shape.name,matrix = shape.matrix,
        path = def.path,html = def.html,bbox = def.bbox,typeName = def.name,
        htmlId = _index4.default.join(pid, id),
        clazz = "shape pannable",

        chunckNames = [shape.name],
        lineHeight = FontSize * 1.5,
        typeNameVisible = this.typeNameVisible,
        firstLineY = bbox.y + bbox.height / 2 - (chunckNames.length - 1) / 2 * lineHeight + (typeName && typeNameVisible ? -lineHeight / 4 : 0),
        lineX = bbox.x + bbox.width / 2,

        tspans = [shape.name].map(function (span, i, l) {
          var currentLineY = firstLineY + i * lineHeight;

          return '<tspan \n          x="' +
          lineX + '" \n          y="' +
          currentLineY + '"\n          dy="' +
          FontSize * .8 / 2 + '"\n          >' +
          span + '</tspan>';
        }).join(""),
        outlinePadding = 5,
        selected = id in this.selectsObjectIds,
        outline = '\n          <rect \n            x="' + (

        bbox.x - outlinePadding) + '" \n            y="' + (
        bbox.x - outlinePadding) + '" \n            width="' + (
        bbox.width + outlinePadding + outlinePadding) + '" \n            height="' + (
        bbox.height + outlinePadding + outlinePadding) + '"\n            visibility="' + (
        focusObjectId === id || selected ? "visible" : "hidden") + '" \n            pointer-events = "none"\n            fill="none" \n            stroke=' + (


        selected ? "rgb(255,116,0)" : "#8888FF") + ' \n            stroke-dasharray="3,3"\n            shape-rendering = "crispEdges"\n          ></rect>',




        filter = '',
        color = this.colorOfShapes[id] || {},
        fontColor = "#000",
        opacity = 0;

        if (color.color) {
          html = '\n          <g fill=' +
          color.color + '>' + this.removeInnerAttributeOfHtml(html, ["fill"]) + '</g>\n        ';

        }

        if (this.panningGroup && id in this.panningGroup.shapes) {
          opacity = .5;
        }

        if (color.fontColor) {
          fontColor = color.fontColor;
        }

        return '\n        <g\n          id = "' +

        htmlId + '"\n          class = "' +
        clazz + '"\n          transform = "matrix(' +
        matrix.join(",") + ') translate(-' + (bbox.x + bbox.width / 2) + ', -' + (bbox.y + bbox.height / 2) + ')"\n          ' + (
        isGhost ? 'pointer-events="none"' : 'pointer-events="all"') + '\n          ' + (
        opacity ? 'style=opacity:' + opacity : '') + '\n        >\n          ' +

        html + '\n    \n          <g\n            fill="' +


        fontColor + '"\n          >\n            <text \n              x="' + (


        bbox.x + bbox.width / 2) + '" \n              y="' + (
        bbox.y + bbox.height / 2) + '" \n              text-anchor="middle" \n              font-size="' +

        FontSize + '"\n              stroke= "none"\n              pointer-events="none"\n              filter="' +


        filter + '"\n            >\n              ' +

        tspans + '\n            </text>\n\n            <text\n              x="' + (



        bbox.x + bbox.width - 5) + '" \n              y="' + (
        bbox.y + bbox.height - lineHeight / 2 + 4) + '" \n              text-anchor="end" \n              font-size="' + (

        FontSize - 2) + '"\n              stroke= "none"\n              fill-opacity=".8"\n              pointer-events="none"\n              filter="' +



        filter + '"\n              visibility="' + (
        typeName && typeNameVisible ? "visible" : "hidden") + '"\n            >' +
        typeName + '</text>\n          </g>\n\n          ' +


        outline + '\n        </g>\n      ';


      } }, { key: 'removeInnerAttributeOfHtml', value: function removeInnerAttributeOfHtml(

      html, attrs) {
        var reg = new RegExp('((' + attrs.join("|") + ')\\s*=\\s*[\'|"]?)\\s*(.*?)\\s*[\'|"]?(?=[\\s|\\/|>])', 'g');
        return html.replace(reg, "");
      } }, { key: 'renderOnePanningShape', value: function renderOnePanningShape(

      def, shape, startPoint, endPoint) {
        if (def.type === 'normal') {
          def.bbox.width = _index6.default.getTextLen(shape.name);
          def.html = def.html.replace(/width="\d+"/, 'width="' + def.bbox.width + '"');
        }var
        id = shape.id,type = shape.type,name = shape.name,matrix = shape.matrix,
        path = def.path,html = def.html,bbox = def.bbox,typeName = def.name,
        dx = endPoint.x - startPoint.x,
        dy = endPoint.y - startPoint.y,
        chunckNames = _index6.default.chunkString(name, bbox.width / FontSize),
        lineHeight = FontSize * 1.5,
        typeNameVisible = this.typeNameVisible,
        firstLineY = bbox.y + bbox.height / 2 - (chunckNames.length - 1) / 2 * lineHeight + (typeName && typeNameVisible ? -lineHeight / 4 : 0),
        lineX = bbox.x + bbox.width / 2,
        tspans = _index6.default.chunkString(name, bbox.width / FontSize).map(function (span, i, l) {
          var currentLineY = firstLineY + i * lineHeight;

          return '<tspan \n          x="' +
          lineX + '" \n          y="' +
          currentLineY + '"\n          dy="' +
          FontSize * .8 / 2 + '"\n          >' +
          span + '</tspan>';
        }).join("");
        html = this.removeInnerAttributeOfHtml(html, ["filter", "stroke", "fill-opacity", "stroke-width", "stroke-opacity"]);
        return '\n        <g\n          transform = "matrix(' +

        matrix.join(",") + ') translate(-' + (bbox.x + bbox.width / 2) + ', -' + (bbox.y + bbox.height / 2) + ') translate(' + dx + ', ' + dy + ')"\n          pointer-events="none"\n\n          fill-opacity=".8"\n          stroke="rgb(255, 195, 66)"\n          stroke-width=2\n        >\n          ' +






        html + '\n\n          <g\n        >\n          <text \n            x="' + (




        bbox.x + bbox.width / 2) + '" \n            y="' + (
        bbox.y + bbox.height / 2) + '" \n            text-anchor="middle" \n            font-size="' +

        FontSize + '"\n            pointer-events="none"\n            stroke=none\n          >\n            ' +



        tspans + '\n          </text>\n\n          <text\n            x="' + (



        bbox.x + bbox.width - 5) + '" \n            y="' + (
        bbox.y + bbox.height - lineHeight / 2 + 4) + '" \n            text-anchor="end" \n            font-size="' + (

        FontSize - 2) + '"\n            fill-opacity=".8"\n            pointer-events="none"\n            stroke=none\n            visibility="' + (



        typeName && typeNameVisible ? "visible" : "hidden") + '"\n          >' +
        typeName + '</text>\n        </g>\n        </g>\n      ';



      } }, { key: 'select', value: function select(

      shapeIds) {
        this.selectsObjectIds = shapeIds.reduce(function (p, c, i, a) {
          p[c] = true;
          return p;
        }, {});
      } }, { key: 'selectAll', value: function selectAll()

      {
        this.select((0, _keys2.default)(this.shapes));
      } }, { key: 'display', value: function display()

      {var _this3 = this;
        var shapes = this.shapes,
        pid = this.id,
        defs = this.shapeDefs,
        ghostShape = this.ghostShape,
        focusObjectId = this.focusObjectId;
        var shapesCode = (0, _keys2.default)(shapes).map(function (shapeId) {var _shapes$shapeId =
          shapes[shapeId],id = _shapes$shapeId.id,type = _shapes$shapeId.type,name = _shapes$shapeId.name,matrix = _shapes$shapeId.matrix;
          return _this3.renderOneShape(pid, _this3.getShapeDefByType(type), shapes[shapeId], focusObjectId, false);
        }).join(""),
        ghostShapeCode = ghostShape ?
        this.renderOneShape(pid, this.getShapeDefByType(ghostShape.type), ghostShape, focusObjectId, true) : '',

        panningGroupShapeCode = this.panningGroup && this.panningGroup.shapes ?
        (0, _keys2.default)(this.panningGroup.shapes).map(function (shapeId) {var _shapes$shapeId2 =
          shapes[shapeId],id = _shapes$shapeId2.id,type = _shapes$shapeId2.type,name = _shapes$shapeId2.name,matrix = _shapes$shapeId2.matrix,_panningGroup2 =
          _this3.panningGroup,panStartPoint = _panningGroup2.panStartPoint,panEndPoint = _panningGroup2.panEndPoint;
          return _this3.renderOnePanningShape(_this3.getShapeDefByType(type), shapes[shapeId], panStartPoint, panEndPoint);
        }) : '';

        return (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'display', this).call(this) + ('<g>' + shapesCode + ghostShapeCode + '</g><g>' + panningGroupShapeCode + '</g>');
      } }]);return _class;}(superClass);

};var _index = __webpack_require__(202);var _index2 = _interopRequireDefault(_index);var _index3 = __webpack_require__(72);var _index4 = _interopRequireDefault(_index3);var _index5 = __webpack_require__(66);var _index6 = _interopRequireDefault(_index5);var _transformShape2path = __webpack_require__(1000);var _transformShape2path2 = _interopRequireDefault(_transformShape2path);var _index7 = __webpack_require__(90);var _index8 = _interopRequireDefault(_index7);var _index9 = __webpack_require__(329);var _index10 = _interopRequireDefault(_index9);var _index11 = __webpack_require__(1001);var _index12 = _interopRequireDefault(_index11);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var FontSize = 13;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =

















































function (svgString) {
  var root = wrap(svgString),
  treeWalker = void 0,

  node = void 0,
  attrs = void 0,
  pathCode = "",
  paths = "",
  ctm = void 0;
  try {

    treeWalker = document.createTreeWalker(root);
  } catch (e) {

    treeWalker = document.createTreeWalker(root, NodeFilter.SHOW_ALL, null, false);
  }
  while (treeWalker.nextNode()) {
    node = treeWalker.currentNode;
    attrs = _index2.default.attr(node);

    switch (node.nodeName.toLowerCase()) {
      case "rect":{
          attrs.x = +attrs.x || 0;
          attrs.y = +attrs.y || 0;
          attrs.rx = +attrs.rx || 0;
          attrs.ry = +attrs.ry || 0;
          attrs.width = +attrs.width || 0;
          attrs.height = +attrs.height || 0;
          pathCode = '\n          M ' +
          attrs.x + ' ' + (attrs.y + attrs.ry) + '\n          A ' +
          attrs.rx + ' ' + attrs.ry + ', 0, 0, 1, ' + (attrs.rx + attrs.x) + ' ' + attrs.y + '\n          L ' + (
          attrs.x + attrs.width - attrs.rx) + ' ' + attrs.y + '\n\n          A ' +

          attrs.rx + ' ' + attrs.ry + ', 0, 0, 1, ' + (attrs.x + attrs.width) + ' ' + (attrs.y + attrs.ry) + '\n\n          L ' + (

          attrs.x + attrs.width) + ' ' + (attrs.y + attrs.height - attrs.ry) + '\n\n          A ' +

          attrs.rx + ' ' + attrs.ry + ', 0, 0, 1, ' + (attrs.x + attrs.width - attrs.rx) + ' ' + (attrs.y + attrs.height) + '\n\n          L ' + (

          attrs.x + attrs.rx) + ' ' + (attrs.y + attrs.height) + '\n\n          A ' +

          attrs.rx + ' ' + attrs.ry + ', 0, 0, 1, ' + attrs.x + ' ' + (attrs.y + attrs.height - attrs.ry) + '\n\n          Z\n        ';





          pathCode = '\n          M ' +
          attrs.x + ' ' + (attrs.y + attrs.ry) + '\n          Q ' +
          attrs.x + ' ' + attrs.y + ', ' + (attrs.x + attrs.rx) + ' ' + attrs.y + '\n          L ' + (
          attrs.x + attrs.width - attrs.rx) + ' ' + attrs.y + '\n          Q ' + (
          attrs.x + attrs.width) + ' ' + attrs.y + ', ' + (attrs.x + attrs.width) + ' ' + (attrs.y + attrs.ry) + '\n          L ' + (
          attrs.x + attrs.width) + ' ' + (attrs.y + attrs.height - attrs.ry) + '\n          Q ' + (
          attrs.x + attrs.width) + ' ' + (attrs.y + attrs.height) + ', ' + (attrs.x + attrs.width - attrs.rx) + ' ' + (attrs.y + attrs.height) + '\n          L ' + (
          attrs.x + attrs.rx) + ' ' + (attrs.y + attrs.height) + '\n          \n          Q ' +

          attrs.x + ' ' + (attrs.y + attrs.height) + ', ' + attrs.x + ' ' + (attrs.y + attrs.height - attrs.ry) + '\n          \n          Z\n        ';



          break;
        }

      case "circle":{
          attrs.cx = +attrs.cx || 0;
          attrs.cy = +attrs.cy || 0;
          attrs.r = +attrs.r || 0;
          pathCode = '\n          M ' +
          attrs.cx + ' ' + (attrs.cy - attrs.r) + '\n          A ' +
          attrs.r + ' ' + attrs.r + ', 0, 1, 0, ' + attrs.cx + ' ' + (attrs.cy + attrs.r) + '\n          A ' +
          attrs.r + ' ' + attrs.r + ', 0, 1, 0, ' + attrs.cx + ' ' + (attrs.cy - attrs.r) + '\n          Z\n        ';var _attrs =








          attrs,cx = _attrs.cx,cy = _attrs.cy,r = _attrs.r,c = 0.551915024494 * r;
          pathCode = '\n          M ' +
          cx + ' ' + (cy - r) + ' C ' + (cx + c) + ' ' + (cy - r) + ', ' + (cx + r) + ' ' + (cy - c) + ', ' + (cx + r) + ' ' + cy + '\n          C ' + (
          cx + r) + ' ' + (cy + c) + ', ' + (cx + c) + ' ' + (cy + r) + ', ' + cx + ' ' + (cy + r) + '\n          C ' + (
          cx - c) + ' ' + (cy + r) + ', ' + (cx - r) + ' ' + (cy + c) + ', ' + (cx - r) + ' ' + cy + '\n          C ' + (
          cx - r) + ' ' + (cy - c) + ', ' + (cx - c) + ' ' + (cy - r) + ', ' + cx + ' ' + (cy - r) + '\n          Z\n        ';


          break;
        }
      case "ellipse":{
          attrs.cx = +attrs.cx || 0;
          attrs.cy = +attrs.cy || 0;
          attrs.rx = +attrs.rx || 0;
          attrs.ry = +attrs.ry || 0;
          pathCode = '\n        M ' +
          attrs.cx + ' ' + (attrs.cy - attrs.r) + '\n        A ' +
          attrs.rx + ' ' + attrs.ry + ', 0, 1, 0, ' + attrs.cx + ' ' + (attrs.cy + attrs.ry) + '\n        A ' +
          attrs.rx + ' ' + attrs.ry + ', 0, 1, 0, ' + attrs.cx + ' ' + (attrs.cy - attrs.ry) + '\n        Z\n      ';


          break;
        }
      case "polygon":{
          pathCode = _convertPoints(attrs.points.trim().split(/[\s,]+/)) + "z";
          break;
        }
      case "line":{
          pathCode = _convertPoints([attrs.x1, attrs.y1, attrs.x2, attrs.y2]);
          break;
        }
      case "polyline":{
          pathCode = _convertPoints(attrs.points.trim().split(/[\s,]+/));
          break;
        }}


    if (pathCode) {
      ctm = getCTM(node);
      if (ctm) {

        paths += Snap.path.map(pathCode, Snap.matrix(
        ctm.a,
        ctm.b,
        ctm.c,
        ctm.d,
        ctm.e,
        ctm.f));

      } else {

        paths += pathCode;
      }

    }
  }

  return paths;
};var _index = __webpack_require__(66);var _index2 = _interopRequireDefault(_index);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _convertPoints(points) {var path = "";for (var i = 0; i < points.length; i += 2) {var prefix = path.length ? ' ' : 'M';path += prefix + points[i] + ',' + points[i + 1];}return path;}function wrap(svgString) {var div = document.createElement("div");div.innerHTML = '<svg>' + svgString + '</svg>';return div.firstChild;}function getCTM(el) {var ctm = void 0;for (var p = el; p; p = p.parentNode) {if (ctm) {ctm = getCTMofEl(el).inverse().multiply(ctm);} else {ctm = getCTMofEl(el);}}return ctm;}function getCTMofEl(el) {var ctm = el.getCTM();if (ctm) {return ctm;}var tr = el.transform.baseVal;for (var i = 0; i < tr.length; i++) {if (ctm) {ctm = tr[i].matrix;} else {ctm = tr[i].matrix.inverse().multiply(ctm);}}return ctm;}

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function listen(el, event, func) {
  if (el.addEventListener) {
    el.addEventListener(event, func);
    return function () {
      el.removeEventListener(event, func);
    };
  } else if (el.attachEvent) {
    el.attachEvent("on" + event, func);
    return function () {
      el.detachEvent("on" + event, func);
    };
  }
}

function contains(wrapper, inner) {
  if ('contains' in wrapper) {
    return wrapper.contains(inner);
  }

  for (var layer = inner; layer && layer.nodeType === 1; layer = layer.parentNode) {
    if (layer === wrapper) {
      return true;
    }
  }

  return false;
}var _class = function () {


  function _class() {(0, _classCallCheck3.default)(this, _class);
    this.cloud = null;
    this.anchor = null;
    this.active = false;
    this.unlisteners = [];
    this.spaceBetweenAnchorAndCloud = 20;
    this.spaceBetweenWallAndCloud = 30;
    this.scrollbarHeatareaWidth = 30;
    this.hideTimeoutHandler = null;
    this.hideTimeout = 100;

    this.install();
  }(0, _createClass3.default)(_class, [{ key: "install", value: function install()
    {
      this.makeCloud();
      this.bindEvents();
    } }, { key: "destroy", value: function destroy()
    {
      this.makeRain();
      this.unbindEvents();
    } }, { key: "makeCloud", value: function makeCloud()
    {
      this.cloud = document.createElement('div');
      this.cloud.setAttribute('style', 'position:fixed;top:0;left:0;border:0;margin:0 0 0 -10px;visibility:hidden;box-sizing:border-box;overflow:auto;display:none;border-color:transparent;border-style:solid;z-index:99999;');
      document.body.appendChild(this.cloud);
    } }, { key: "makeRain", value: function makeRain()
    {
      document.body.removeChild(this.cloud);
    } }, { key: "bindEvents", value: function bindEvents()
    {
      this.unlisteners = [
      listen(document, 'mousemove', this.handleMouseMove.bind(this))];

    } }, { key: "unbindEvents", value: function unbindEvents()
    {
      while (this.unlisteners.length) {
        this.unlisteners.pop()();
      }
    } }, { key: "request", value: function request(
    anchor, html) {
      clearTimeout(this.hideTimeoutHandler);
      this.hideTimeoutHandler = null;
      this.anchor = anchor;
      this.html = html;
      var anchorBox = anchor.getBoundingClientRect();
      var fullWidth = "innerWidth" in window ? window.innerWidth : document.documentElement.offsetWidth;
      var fullHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
      var spaceOnLeft = anchorBox.left;
      var spaceOnRight = fullWidth - anchorBox.right;
      var spaceOnTop = anchorBox.bottom;
      var spaceOnBottom = fullHeight - anchorBox.top;
      this.cloud.style.display = 'block';
      this.cloud.style.visibility = 'hidden';
      this.cloud.style.width = 'auto';
      this.cloud.style.height = 'auto';
      this.cloud.style.top = '-100%';
      this.cloud.style.left = '-100%';
      this.cloud.style.borderWidth = '0';
      this.cloud.innerHTML = html;
      var cloudWidth = this.cloud.clientWidth;
      var onRight = spaceOnRight > spaceOnLeft;
      var spaceX = onRight ? spaceOnRight : spaceOnLeft;
      if (spaceX < cloudWidth) {
        cloudWidth = spaceX - this.spaceBetweenWallAndCloud;
        this.cloud.style.width = cloudWidth + 'px';
      }
      var left;
      var borderLeftWidth = 0;
      var borderRightWidth = 0;
      if (onRight) {
        left = anchorBox.right;
        borderLeftWidth = this.spaceBetweenAnchorAndCloud;
        borderRightWidth = Math.min(fullWidth - left - cloudWidth, this.scrollbarHeatareaWidth);
      } else
      {
        left = spaceX - cloudWidth;
        borderRightWidth = this.spaceBetweenAnchorAndCloud;
      }
      this.cloud.style.left = left + 'px';
      this.cloud.style.borderLeftWidth = borderLeftWidth + 'px';
      this.cloud.style.borderRightWidth = borderRightWidth + 'px';
      var cloudHeight = this.cloud.clientHeight;
      var onTop = spaceOnTop > spaceOnBottom;
      var spaceY = onTop ? spaceOnTop : spaceOnBottom;
      if (spaceY < cloudHeight) {
        cloudHeight = spaceY - this.spaceBetweenWallAndCloud;
        this.cloud.style.height = cloudHeight + 'px';
      }
      var top;
      var borderBottomWidth = 0;
      if (onTop) {
        top = spaceY - cloudHeight;
        borderBottomWidth = Math.min(this.spaceBetweenAnchorAndCloud, this.scrollbarHeatareaWidth);
      } else
      {
        top = anchorBox.top;
        borderBottomWidth = Math.min(fullHeight - top - cloudHeight, this.scrollbarHeatareaWidth);
      }
      this.cloud.style.top = top + 'px';
      this.cloud.style.borderBottomWidth = borderBottomWidth + 'px';
      this.cloud.style.visibility = 'visible';
      this.active = true;
    } }, { key: "fadeAway", value: function fadeAway()
    {
      if (!this.hideTimeoutHandler) return;
      this.cloud.style.visibility = 'hidden';
      this.cloud.style.display = 'none';
      document.body.style.overflow = '';
      this.active = false;
    } }, { key: "handleMouseMove", value: function handleMouseMove(
    event) {
      if (!this.active)
      return;
      var target = event.target || event.srcElement;
      if (contains(this.anchor, target))
      return;
      if (contains(this.cloud, target))
      return;
      this.hideTimeoutHandler = setTimeout(this.fadeAway.bind(this), this.hideTimeout);
    } }]);return _class;}();exports.default = _class;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _slicedToArray2 = __webpack_require__(60);var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);var _keys = __webpack_require__(59);var _keys2 = _interopRequireDefault(_keys);var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);exports.default =

function (superClass) {
  return function (_superClass) {(0, _inherits3.default)(_class, _superClass);
    function _class() {var _ref;(0, _classCallCheck3.default)(this, _class);for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {arg[_key] = arguments[_key];}return (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(

      arg)));
    }(0, _createClass3.default)(_class, [{ key: "install", value: function install()

      {} }, { key: "destroy", value: function destroy()
      {} }, { key: "display", value: function display()
      {return "";} }, { key: "getShapePosition", value: function getShapePosition(


      shapeId) {var _shapes$shapeId =
        this.shapes[shapeId],id = _shapes$shapeId.id,type = _shapes$shapeId.type,name = _shapes$shapeId.name,matrix = _shapes$shapeId.matrix;

        return {
          x: matrix[4],
          y: matrix[5] };

      } }, { key: "beforeSnap", value: function beforeSnap(


      excludedId) {
        var snappableX = [],
        snappableY = [],
        shapeIdList = (0, _keys2.default)(this.shapes),
        lineIdList = (0, _keys2.default)(this.lines),
        position = void 0;

        for (var i = 0; i < shapeIdList.length; i++) {
          if (shapeIdList[i] !== excludedId) {
            position = this.getShapePosition(shapeIdList[i]);
            snappableX.push(Math.floor(position.x));
            snappableY.push(Math.floor(position.y));
          }
        }var _IdManage$split =

        _index2.default.split(excludedId),_IdManage$split2 = (0, _slicedToArray3.default)(_IdManage$split, 2),lineId = _IdManage$split2[0],index = _IdManage$split2[1];


        for (var _i = 0; _i < lineIdList.length; _i++) {
          for (var j = 1; j < this.lines[lineIdList[_i]].points.length - 1; j++) {
            if (lineId === lineIdList[_i] && +index === j) {
            } else {
              snappableX.push(Math.floor(this.lines[lineIdList[_i]].points[j].x));
              snappableY.push(Math.floor(this.lines[lineIdList[_i]].points[j].y));
            }
          }
        }

        this.snappableX = snappableX;
        this.snappableY = snappableY;
        this.snappedX = null;
        this.snappedY = null;
      } }, { key: "snap", value: function snap(

      point) {
        var snappedX = null,
        snappedY = null,
        x = void 0,y = void 0;

        for (var i = 0; i < this.snappableX.length; i++) {
          if (Math.abs(point.x - this.snappableX[i]) < 10) {

            snappedX = this.snappableX[i];

            break;
          }
        }

        for (var _i2 = 0; _i2 < this.snappableY.length; _i2++) {
          if (Math.abs(point.y - this.snappableY[_i2]) < 10) {

            snappedY = this.snappableY[_i2];

            break;
          }
        }

        this.snappedX = snappedX;
        this.snappedY = snappedY;

        return {
          x: snappedX === null ? point.x : snappedX,
          y: snappedY === null ? point.y : snappedY };


      } }, { key: "afterSnap", value: function afterSnap()

      {
        this.snappedX = null;
        this.snappedY = null;
        this.snappableX = [];
        this.snappableY = [];
      } }]);return _class;}(superClass);

};var _index = __webpack_require__(72);var _index2 = _interopRequireDefault(_index);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _keys = __webpack_require__(59);var _keys2 = _interopRequireDefault(_keys);var _slicedToArray2 = __webpack_require__(60);var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _get2 = __webpack_require__(65);var _get3 = _interopRequireDefault(_get2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);exports.default =





function (superClass) {
  return function (_superClass) {(0, _inherits3.default)(_class, _superClass);
    function _class() {var _ref;(0, _classCallCheck3.default)(this, _class);for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {arg[_key] = arguments[_key];}var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(

      arg)));

      _this["LineHotAreaLayerMixin@handleClick"] = _this["LineHotAreaLayerMixin@handleClick"].bind(_this);return _this;

    }(0, _createClass3.default)(_class, [{ key: 'install', value: function install()

      {
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'install', this).call(this);

        this.svg.addEventListener("click", this["LineHotAreaLayerMixin@handleClick"], false);
      } }, { key: 'destroy', value: function destroy()

      {
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'destroy', this).call(this);

        this.svg.removeEventListener("click", this["LineHotAreaLayerMixin@handleClick"], false);
      } }, { key:

      "LineHotAreaLayerMixin@handleClick", value: function LineHotAreaLayerMixinHandleClick(e) {

        var hotarea = _index2.default.closest(e.target, ".hotarea");
        if (hotarea) {var _IdManager$split =
          _index4.default.split(hotarea.id),_IdManager$split2 = (0, _slicedToArray3.default)(_IdManager$split, 2),_ = _IdManager$split2[0],lineId = _IdManager$split2[1];

          this.focusLine(this.lines[lineId]);

        }

      } }, { key: 'display', value: function display()

      {var _this2 = this;
        var html = (0, _keys2.default)(this.lines).map(function (lineId) {

          if (lineId === _this2.focusObjectId) {
            return "";
          }



          var line = _this2.lines[lineId],
          points = line.points;
          if (points.length < 2) {
            return "";
          }var _points =
          points[points.length - 1],x = _points.x,y = _points.y,_points2 =
          points[points.length - 2],lx = _points2.x,ly = _points2.y,
          deg = void 0;

          if (Math.abs(lx - x) < 2) {
            deg = -90 * (ly - y) / Math.abs(ly - y);
          } else {
            deg = Math.atan((ly - y) / (lx - x)) * 180 / Math.PI;

            if (x < lx) {
              deg += 180;
            }
          }

          return '\n          <circle\n            cx=' +

          0 + '\n            cy=' +
          0 + '\n            r=' +
          10 + '\n\n            fill=transparent\n            fill-opacity=.3\n            stroke=none\n            class=hotarea \n            id=' +





          _index4.default.join(_this2.id, lineId, "hotarea") + '\n            transform="translate(' +
          x + ', ' + y + ') rotate(' + deg + ') translate(-8)"\n          ></circle>          \n        ';


        }).join("");
        return (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'display', this).call(this) + ('<g>' + html + '</g>');
      } }]);return _class;}(superClass);

};var _index = __webpack_require__(66);var _index2 = _interopRequireDefault(_index);var _index3 = __webpack_require__(72);var _index4 = _interopRequireDefault(_index3);var _index5 = __webpack_require__(90);var _index6 = _interopRequireDefault(_index5);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _slicedToArray2 = __webpack_require__(60);var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _get2 = __webpack_require__(65);var _get3 = _interopRequireDefault(_get2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);exports.default =





function (superClass) {
  return function (_superClass) {(0, _inherits3.default)(_class, _superClass);
    function _class() {var _ref;(0, _classCallCheck3.default)(this, _class);for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {arg[_key] = arguments[_key];}return (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(

      arg)));
    }(0, _createClass3.default)(_class, [{ key: 'install', value: function install()

      {
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'install', this).call(this);
      } }, { key: 'destroy', value: function destroy()

      {
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'destroy', this).call(this);
      } }, { key: 'renderOneButton', value: function renderOneButton(

      dy) {
        var sizeOfSqure = 4;
        return '\n      <path\n        pointer-events="none"\n        d="M ' + (


        2 + sizeOfSqure) + ' ' + (13 + dy - sizeOfSqure) + ' h -' + sizeOfSqure + ' v ' + sizeOfSqure + ' h ' + sizeOfSqure + ' v -' + sizeOfSqure + ' L ' + (14 - sizeOfSqure) + ' ' + (2 + dy + sizeOfSqure) + ' h ' + sizeOfSqure + ' v -' + sizeOfSqure + ' h -' + sizeOfSqure + ' v ' + sizeOfSqure + '"\n        stroke="#000"\n        fill="none"\n        stroke-width="2"\n      ></path>\n      ';





      } }, { key: 'getlineButtons', value: function getlineButtons(

      shapeId) {var _this2 = this;
        var shape = this.shapes[shapeId],
        shapeDef = this.getShapeDefByType(shape.type),
        lineButtonTypes = shapeDef.meta.lineButtonTypes;

        return lineButtonTypes.map(function (type, i) {var _getLineDefByType =
          _this2.getLineDefByType(type),name = _getLineDefByType.name,style = _getLineDefByType.style,
          dy = i * 18;
          return '\n          <rect \n          x="0" \n          y="' +


          dy + '"\n          width="16" \n          height="16" \n          fill="none" \n          stroke="none" \n          pointer-events="bounding-box" \n          class="button pannable"\n          data-action="add-line-' +






          type + '"\n        >\n          <title>' +

          name + '</title>\n        </rect>\n        ' +

          _this2.renderOneButton(dy) + '\n        ';

        }).join("");
      } }, { key: 'getRemoveButton', value: function getRemoveButton()

      {
        return '\n        <rect \n        x="0" \n        y="0"\n        width="16" \n        height="16" \n        fill="none" \n        stroke="none" \n        pointer-events="bounding-box" \n        class="button"\n        data-action="remove-focus-object"\n      >\n        <title>\u5220\u9664</title>\n      </rect>\n      <path \n        d="M 2,2 L 13,13 M 13,2 L 2,13" \n        fill="none" \n        stroke="#000" \n        stroke-width="2"\n        pointer-events="none"\n      ></path>\n      ';





















      } }, { key: 'getButtons4Shape', value: function getButtons4Shape(

      shapeId) {

        var bbox = this.getShapeDefByType(this.shapes[this.focusObjectId].type).bbox,
        shape = this.shapes[this.focusObjectId],
        width = _index6.default.isRectNode(shape) ? _index6.default.getTextLen(shape.name) : bbox.width,
        outlinePadding = 5,
        matrixStr = 'matrix(' + this.shapes[this.focusObjectId].matrix.join(",") + ') translate(-' + (bbox.x + width / 2) + ', -' + (bbox.y + bbox.height / 2) + ')',
        removeButtons = _index4.default.modeFilter.ShapeRemove & this.mode ?
        this.getRemoveButton() :
        null,
        lineButtons = _index4.default.modeFilter.ShapeConnect & this.mode ?
        removeButtons ? '<g transform="translate(0, 20)">' +
        this.getlineButtons(this.focusObjectId) + '</g>' :
        this.getlineButtons(this.focusObjectId) :
        "";

        return '\n        <g \n          transform="' +

        matrixStr + ' translate(' + (bbox.x + width + 2 * outlinePadding + 2) + ', ' + (bbox.y - outlinePadding) + ')"\n          visibility="' + (
        !this.panningGroup && !this.ghostLine ? "visible" : "hidden") + '"\n        >\n          ' +

        removeButtons + '\n          ' +
        lineButtons + '\n        </g>\n        ';


      } }, { key: 'getButtons4Line', value: function getButtons4Line(

      lineId) {
        var bbox = this.getBBox(this.lines[this.focusObjectId].points),
        outlinePadding = 5,
        removeButtons = _index4.default.modeFilter.LineRemove & this.mode ?
        this.getRemoveButton() :
        null;

        return '\n        <g \n          transform="translate(' + (

        bbox.x + bbox.width + 2 * outlinePadding + 2) + ', ' + (bbox.y - outlinePadding) + ')"\n          visibility="' + (
        !this.panningGroup && !this.ghostLine ? "visible" : "hidden") + '"\n        >\n          ' +

        removeButtons + '\n        </g>\n        ';


      } }, { key: 'getButtons4Point', value: function getButtons4Point(

      lineId, index) {var _lines$lineId$points$ =
        this.lines[lineId].points[index],x = _lines$lineId$points$.x,y = _lines$lineId$points$.y,
        bbox = { x: x - 5, y: y - 5, width: 10, height: 10 },
        outlinePadding = 5,
        removeButtons = _index4.default.modeFilter.LinePan & this.mode ?
        this.getRemoveButton() :
        null;

        return '\n        <g \n          transform="translate(' + (

        bbox.x + bbox.width + 2 * outlinePadding + 2) + ', ' + (bbox.y - outlinePadding) + ')"\n          visibility="' + (
        !this.panningGroup && !this.ghostLine ? "visible" : "hidden") + '"\n        >\n          ' +

        removeButtons + '\n        </g>\n        ';


      } }, { key: 'display', value: function display()

      {
        var buttons = "",
        selectPath = this.selectPath ? '\n          <path \n            d="' +

        this.selectPath + 'Z"\n            fill = "rgb(255, 116, 0)"\n            fill-opacity = "0.1"\n            stroke-dasharray = "5 1 3 1"\n            stroke = "rgb(255, 116, 0)"\n            shape-rendering = "crispEdges"\n            pointer-events = "none"\n          ></path>\n        ' :







        "";

        if (this.focusObjectId in this.shapes) {

          buttons = this.getButtons4Shape(this.focusObjectId);
        } else if (this.focusObjectId in this.lines) {
          buttons = this.getButtons4Line(this.focusObjectId);
        } else if (this.focusObjectId && this.focusObjectId.match(/^[^:]+:\d+/)) {var _IdManager$split =
          _index2.default.split(this.focusObjectId),_IdManager$split2 = (0, _slicedToArray3.default)(_IdManager$split, 2),lineId = _IdManager$split2[0],index = _IdManager$split2[1];
          buttons = this.getButtons4Point(lineId, index);
        }

        return (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'display', this).call(this) + ('<g>' + buttons + ' ' + selectPath + '</g>');
      } }]);return _class;}(superClass);

};var _index = __webpack_require__(72);var _index2 = _interopRequireDefault(_index);var _index3 = __webpack_require__(90);var _index4 = _interopRequireDefault(_index3);var _index5 = __webpack_require__(66);var _index6 = _interopRequireDefault(_index5);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _class =
function _class() {(0, _classCallCheck3.default)(this, _class);
  var callbacks = {};

  this.on = function (eventType, callback) {
    if (!(eventType in callbacks)) {
      callbacks[eventType] = [];
    }

    callbacks[eventType].push(callback);
  };

  this.off = function (eventType, callback) {
    if (!eventType) {
      callbacks = {};
    } else {
      if (eventType in callbacks) {
        if (!callback) {
          callbacks[eventType] = [];
        } else {
          callbacks[eventType] = callbacks[eventType].filter(function (x) {return x !== callback;});
        }
      }
    }

  };

  this.emit = function (eventType) {for (var _len = arguments.length, arg = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {arg[_key - 1] = arguments[_key];}
    if (eventType in callbacks) {
      return callbacks[eventType].reduce(function (p, c, i, a) {
        return c.apply(undefined, arg) !== false && p;
      }, true);
    }
    return true;
  };
};exports.default = _class;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _toConsumableArray2 = __webpack_require__(38);var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _get2 = __webpack_require__(65);var _get3 = _interopRequireDefault(_get2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);exports.default =








function (superClass) {
  return function (_superClass) {(0, _inherits3.default)(_class, _superClass);
    function _class() {var _ref;(0, _classCallCheck3.default)(this, _class);for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {arg[_key] = arguments[_key];}var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(

      arg)));

      _this["ExtentAutoChange@scrollTimeout"] = null;return _this;
    }(0, _createClass3.default)(_class, [{ key: "install", value: function install()

      {
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), "install", this).call(this);
      } }, { key: "destroy", value: function destroy()

      {
        (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), "destroy", this).call(this);
      } }, { key: "requestAutoScroll", value: function requestAutoScroll(

      clientX, clientY, config) {var _this2 = this;
        config = _index2.default.assign({}, defaultConfig, config);

        var box = this.svg.getBoundingClientRect(),
        dx = void 0,dy = void 0;

        if (clientX - box.left < config.threshold) {
          dx = config.step;
        } else if (box.right - clientX < config.threshold) {
          dx = -config.step;
        } else {
          dx = 0;
        }

        if (clientY - box.top < config.threshold) {
          dy = config.step;
        } else if (box.bottom - clientY < config.threshold) {
          dy = -config.step;
        } else {
          dy = 0;
        }

        if ((dx || dy) && !this["ExtentAutoChange@scrollTimeout"]) {
          var scroll = function scroll() {
            _this2.doScroll(dx, dy);
            _this2["ExtentAutoChange@scrollTimeout"] = setTimeout(scroll, config.interval);
          };

          this["ExtentAutoChange@scrollTimeout"] = setTimeout(scroll, config.delay);
        } else if (!dx && !dy && this["ExtentAutoChange@scrollTimeout"]) {
          this.cancelAutoScroll();
        }


      } }, { key: "cancelAutoScroll", value: function cancelAutoScroll()

      {
        clearTimeout(this["ExtentAutoChange@scrollTimeout"]);
        this["ExtentAutoChange@scrollTimeout"] = null;
      } }, { key: "doScroll", value: function doScroll(

      dx, dy) {
        this.changeMatrix([].concat((0, _toConsumableArray3.default)(this.matrix.slice(0, 4)), [this.matrix[4] + dx, this.matrix[5] + dy]));
      } }]);return _class;}(superClass);

};var _index = __webpack_require__(66);var _index2 = _interopRequireDefault(_index);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var defaultConfig = { delay: 100, interval: 20, threshold: 20, step: 10 };

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _util = __webpack_require__(16);exports.default =
function () {return (
    {

      api: {

        root: '/api/',


        security: (0, _util.security)() } });};

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_585bb5e0_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1010);
function injectStyle (ssrContext) {
  __webpack_require__(1009)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-585bb5e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_585bb5e0_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPop && _vm.items.length>0)?_c('ul',{staticClass:"menu-box",style:(_vm.freeStyle),attrs:{"oncontextmenu":"return false"},on:{"mousedown":function($event){$event.stopPropagation();return _vm.mouseDown($event)}}},[_vm._t("above"),_vm._v(" "),_vm._l((_vm.items),function(item,it){return _c('li',{on:{"click":function($event){return _vm.listItemClick(it,item)}}},[_c('a',[_c('i',{class:item.class || item.icon}),_c('span',{staticClass:"menu-boxmenu-sep"},[_vm._v(" ")]),_c('span',[_vm._v(_vm._s(item.txt || item.text))])])])}),_vm._v(" "),_vm._t("below")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_baa2ea00_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1012);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_baa2ea00_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel mw-view__imbedded"},[(_vm.menuItems.length>1)?_c('div',{staticClass:"mw-toolbar"},[_c('el-menu',{attrs:{"default-active":_vm.defaultKey,"mode":"horizontal"},on:{"select":_vm._handleSelect}},_vm._l((_vm.menuItems),function(v){return _c('el-menu-item',{key:v.id,attrs:{"index":v.id},domProps:{"textContent":_vm._s(v.name)}},[_c('span',{staticClass:"badge badge-danger"})])}),1)],1):_vm._e(),_vm._v(" "),_c('div',{class:{'mw-toolbar__body':_vm.menuItems.length>1,'mw-panel':(_vm.menuItems.length==0 ||_vm.menuItems.length==1)}},[_c('div',{staticClass:"mw-page-view__config mw-panel"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f54f3260_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1015);
function injectStyle (ssrContext) {
  __webpack_require__(1014)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f54f3260"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f54f3260_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.containerId}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6ffdea92_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1017);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6ffdea92_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticStyle:{"height":"100%","width":"100%","overflow":"hidden"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_22dbf331_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1020);
function injectStyle (ssrContext) {
  __webpack_require__(1019)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22dbf331"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_22dbf331_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('el-form',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.dataList,"height":"250","border":""}},[_c('el-table-column',{attrs:{"prop":"fieldValue","label":"字段名称","type":"index","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{staticStyle:{"width":"80%"},attrs:{"placeholder":"字段名称","readonly":""},model:{value:(scope.row.fieldName),callback:function ($$v) {_vm.$set(scope.row, "fieldName", $$v)},expression:"scope.row.fieldName"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){$event.preventDefault();return _vm.selectField(scope.row, scope.$index)}}},[_vm._v("选择")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"operator","label":"比较值","type":"index","width":"98"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{model:{value:(scope.row.operator),callback:function ($$v) {_vm.$set(scope.row, "operator", $$v)},expression:"scope.row.operator"}},_vm._l((_vm.filterOperator(scope.row.fieldValue)),function(op){return _c('el-option',{key:op.name,attrs:{"label":op.name,"value":op.name}})}),1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"输入值","type":"index","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{style:({width: scope.row.selectable?'80%':'100%'}),attrs:{"placeholder":"输入值"},model:{value:(scope.row.value),callback:function ($$v) {_vm.$set(scope.row, "value", $$v)},expression:"scope.row.value"}}),_vm._v(" "),(scope.row.selectable)?_c('el-button',{on:{"click":function($event){$event.preventDefault();return _vm.selectValue(scope.row)}}},[_vm._v("选择")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"logic","label":"关系符","type":"index","width":"98"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{model:{value:(scope.row.logic),callback:function ($$v) {_vm.$set(scope.row, "logic", $$v)},expression:"scope.row.logic"}},[_c('el-option',{attrs:{"label":"并且","value":"and"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"或者","value":"or"}})],1)]}}])})],1)],1),_vm._v(" "),_c('div',[_c('p',{staticStyle:{"margin-top":"10px","font-size":"16px","font-weight":"600"}},[_vm._v("预览:")]),_vm._v(" "),_c('div',{staticStyle:{"height":"30px"}},[_vm._v("\n        "+_vm._s(_vm.generatedFormula)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"dialog-footer",staticStyle:{"float":"right"}},[_c('el-button',{on:{"click":_vm.showHelp}},[_vm._v("帮助")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.addRow}},[_vm._v("添加一行")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.close}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirm}},[_vm._v("确 定")])],1),_vm._v(" "),_c('el-dialog',{ref:"selzdmc",attrs:{"title":"选择字段名称","width":"300px","append-to-body":true,"show-close":false,"visible":_vm.dialogSelectVisible},on:{"update:visible":function($event){_vm.dialogSelectVisible=$event}}},[_c('div',{staticStyle:{"width":"100%","padding-top":"8px","overflow":"auto","max-height":"500px"}},_vm._l((_vm.candidateFields),function(field){return _c('p',[_c('el-radio',{attrs:{"label":field.value},model:{value:(_vm.selectedField),callback:function ($$v) {_vm.selectedField=$$v},expression:"selectedField"}},[_vm._v(_vm._s(field.name))])],1)}),0),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogSelectVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.setSelectedField($event)}}},[_vm._v("确 定")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_editor_vue__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_editor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_editor_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_editor_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_editor_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0aa00948_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_ntko_editor_vue__ = __webpack_require__(1025);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_editor_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0aa00948_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_ntko_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _stringify = __webpack_require__(24);var _stringify2 = _interopRequireDefault(_stringify);var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);var _ntkoFuncBase = __webpack_require__(1023);var _ntkoFuncBase2 = _interopRequireDefault(_ntkoFuncBase);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

NtkoOffice = function (_OfficeBase) {(0, _inherits3.default)(NtkoOffice, _OfficeBase);function NtkoOffice() {(0, _classCallCheck3.default)(this, NtkoOffice);return (0, _possibleConstructorReturn3.default)(this, (NtkoOffice.__proto__ || (0, _getPrototypeOf2.default)(NtkoOffice)).apply(this, arguments));}(0, _createClass3.default)(NtkoOffice, [{ key: "getProduct", value: function getProduct()


    {
      return this.ProductType.NTKO_OFFICE;
    } }, { key: "openDocument", value: function openDocument(





    openParams) {

      var openParams = openParams || this.openParams || {};
      var fileId = openParams.fileId || this.fileId || "";
      var formId = openParams.formId || "";
      var businessId = openParams.businessId || "";
      var tempBusinessId = openParams.tempBusinessId || "";
      var xToken = openParams.xToken || this.xToken || "";

      if (fileId && this.downloadUrl) {
        var url = this.downloadUrl + "?id=" + fileId + "&formId=" + formId + "&businessId=" + businessId + "&xToken=" + xToken;
        url += "&tempBusinessId=" + tempBusinessId;
        return this.openFromUrl(url);
      } else {
        return false;
      }
    } }, { key: "saveDocumentAsNew", value: function saveDocumentAsNew(

    postParams) {
      this.fileLinkId = null;
      return this.saveDocument(postParams);
    } }, { key: "saveDocument", value: function saveDocument(






    postParams) {
      var me = this;
      var saveParams = postParams || this.saveParams || {};

      var formId = saveParams.formId || this.formId || "";
      var businessId = saveParams.businessId || this.businessId || "";
      var tempBusinessId = saveParams.tempBusinessId || this.tempBusinessId || "";
      var xToken = saveParams.xToken || this.xToken || "";
      var efileName = saveParams.fileName || this.fileName || "";
      var efileType = saveParams.efileType || this.efileType || "";
      var attachId = saveParams.attachId || me.fileLinkId || "";

      var params = {
        type: efileType,
        businessId: businessId,
        formId: formId,
        tempBusinessId: tempBusinessId,
        efileName: efileName,
        fileName: efileName,
        xToken: xToken };


      if (attachId) {
        params.attachId = attachId;
      }
      postParams = params;
      if (!postParams) {
        return false;
      }
      this.createForm(postParams);
      var saveUrl = postParams.attachId ? this.updateUrl : this.uploadUrl;
      this.log("");
      this.log("postParams: " + (0, _stringify2.default)(postParams));
      this.log("saveUrl: " + saveUrl);
      var res = this.ocx.SaveToURL(saveUrl, "uploadFile", "", this.fileName, this.NTKO_SAVE_FORM, false);
      this.log("saveResult=" + res);
      return res;
    } }, { key: "saveDocumentToServer", value: function saveDocumentToServer()

    {
      var me = this;
      var extForm = me.form || {};
      var saveParams = this.saveParams || {};

      var formId = extForm.formId || saveParams.formId || this.formId || "";
      var businessId = extForm.businessId || saveParams.businessId || this.businessId || "";
      var tempBusinessId = extForm.tempBusinessId || saveParams.tempBusinessId || this.tempBusinessId || "";
      var xToken = saveParams.xToken || this.xToken || "";
      var efileName = saveParams.fileName || this.fileName || "";
      var efileType = saveParams.efileType || this.efileType || "";
      var params = {
        type: efileType,
        businessId: businessId,
        tempBusinessId: tempBusinessId,
        formId: formId };


      var res = me.querySync(me.getHttpPath() + PF.url("/api/business/listAttachment"), params);



      var fileLinkId;
      if (res && res.result && res.result.length > 0) {
        $.each(res.result, function (i, r) {
          if (r.mimeType == ".docx" || r.mimeType == ".doc" || r.mimeType == ".wps") {
            fileLinkId = r.id;
            return true;
          }
        });
      }
      if (fileLinkId) {
        me.fileLinkId = fileLinkId;
      } else {
        me.fileLinkId = null;
      }
      var result = me.saveDocument({
        businessId: businessId,
        tempBusinessId: tempBusinessId,
        formId: formId });

      var res = JSON.parse(result);
      if (res.result && res.success) {
        if (res.result.fileLinkId) {
          me.fileLinkId = res.result.fileLinkId;
        }
        if (me.form) {
          if (efileType == "JOA_ZW") {
            me.form.setValueByName("fldhaszw", true);
          } else if (efileType == 'JOA_CG') {
            me.form.setValueByName("fldhascg", true);
          } else if (efileType == "JOA_CLD") {
            me.form.setValueByName("fldhascld", true);
          }
        }
        return true;
      } else {
        return false;
      }

    } }, { key: "setFileName", value: function setFileName(






    fileName) {
      this.log("set fileName : " + fileName);
      if (fileName) {
        fileName = fileName.replace(/[\\\/:*?"<>|\n\r]/g, "");
        this.fileName = fileName;
        this.setWebFileName(fileName);
      }
    } }, { key: "publishAsPdf", value: function publishAsPdf(

    saveParams, isUseSecurity, isPermitPrint, isPermitCopy) {
      var me = this;
      var saveParams = saveParams || this.saveParams || {};
      var formId = saveParams.formId || this.formId || "";
      var businessId = saveParams.businessId || this.businessId || "";
      var tempBusinessId = saveParams.tempBusinessId || this.tempBusinessId || "";
      var xToken = saveParams.xToken || this.xToken || "";
      var efileName = saveParams.fileName || this.fileName || "";
      efileName = this.getBaseName(efileName) + ".pdf";
      var efileType = saveParams.efileType || this.efileType || "";
      var attachId = saveParams.attachId || "";
      if (!me.ocx.IsPDFCreatorInstalled()) {
        alert("请先下载安装PDF转换器后再执行此操作!!");
        return;
      }


      var params = {
        type: efileType,
        businessId: businessId,
        formId: formId,
        tempBusinessId: tempBusinessId,
        efileName: efileName,
        fileName: efileName,
        xToken: xToken,
        fullPath: "true" };

      if (attachId) {
        params.attachId = attachId;
      }
      this.createForm(params);
      var saveUrl = attachId ? this.updateUrl : this.uploadUrl;
      var IsUseSecurity = this.getBoolValue(isUseSecurity, false);
      var IsPermitPrint = this.getBoolValue(isPermitPrint, true);
      var IsPermitCopy = this.getBoolValue(isPermitCopy, true);
      var paramsStr = "";
      me.ocx.PublishAsPDFToURL(saveUrl, "uploadFile", paramsStr, efileName, me.NTKO_SAVE_FORM, "", true, false, IsUseSecurity, me.PASS_WORD, IsPermitPrint, IsPermitCopy);
    } }, { key: "addPicFromUrl", value: function addPicFromUrl(








    url, top, left, isSeal) {
      this.log("imageUrl:" + url);
      var version = this.getOfficeVersion();
      var topx = -50;
      var leftx = 180;
      if (version == this.OfficeVersion.v2003) {
        leftx = 180;
      } else if (version == this.OfficeVersion.v2007) {
        leftx = -40;
      } else if (version == this.OfficeVersion.v2010) {
        leftx = -30;
      } else if (version == this.OfficeVersion.v2013) {
        leftx = -25;
      }
      if (!isSeal) {
        topx = 0;
        leftx = 0;
      }
      var isFloat = true;
      var relative = 1;
      var zorder = 0;

      if (typeof top == "number") {
        topx = top;
      }
      if (typeof left == "number") {
        leftx = left;
      }
      if (isSeal) {
        var shapes = this.ocx.ActiveDocument.Shapes;
        var count = shapes.Count;
        var names = [];
        for (var i = 1; i <= count; i++) {
          var shape = shapes.Item(i);
          names.push(shape.Name);
        }
        try {
          this.ocx.AddPicFromURL(url, true, leftx, topx, 1, 100, 0, true);
        } catch (e) {
          this.error("添加图片错误:" + url);
        }
        count = shapes.Count;
        for (var i = 1; i <= count; i++) {
          var shape = shapes.Item(i);
          if (!$.inArray(shape.Name, names)) {
            shape.Name = "seal" + shape.Name;
            shape.AlternativeText = 'seal';
          }
        }
      } else {
        try {
          this.ocx.AddPicFromURL(url, false, leftx, topx, 1, 100, 1);
        } catch (e) {
          this.error("添加图片错误:" + url);
        }
      }


    } }, { key: "resolveTags", value: function resolveTags(


    str) {
      this.log(str);
      var arr = str.split("");
      var step = [];
      var str = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == "[" && !str.substr(0, 1) != "[") {
          if (str) {
            step.push(str);
          }
          str = "";
        }
        str += arr[i];
        if (arr[i] == "]" && str.substr(0, 1) == "[") {
          if (str) {
            step.push(str);
          }
          str = "";
        }
        if (i == arr.length - 1 && str) {
          step.push(str);
        }
      }
      return step;
    } }, { key: "appendContent", value: function appendContent(

    st, yj, cfg, isReturnStr) {
      this.log(st + " ==> " + (0, _stringify2.default)(yj));
      var me = this;
      yj = yj || {};
      var userName = yj.creator || yj.assigneeName || "";
      var message = yj.content || "";
      var createTime = yj.createTime || "";
      var value = "";
      var userId = yj.creatorId || yj.assignee;

      function getProp(str) {
        str = str || "";
        str = str.replace("\[", "").replace("\]", "");
        var arr = str.split("#");
        if (arr.length > 1 && arr[1]) {
          return arr[1];
        }
        return "";
      }

      switch (true) {
        case /\[办理人.*\]/.test(st) || /\[电子签名\]/.test(st):
          var prop = getProp(st);
          if (prop) {
            value = userName;
          } else {

            debugger;
            var imgUrl = me.checkUserSignature(userId);
            if (imgUrl && !isReturnStr) {
              try {
                me.addPicFromUrl(imgUrl);
              } catch (e) {
                value = userName;
              }
            } else {
              value = userName;
            }
          }
          break;
        case "[办理意见]" == st:
          value = message;
          break;
        case /\[意见时间.*\]/.test(st) || /\[意见日期.*\]/.test(st):
          var formatStr = getProp(st) || "yyyy年M月d日";
          if (createTime) {
            value = me.formatDateStr(formatStr, createTime);
          }
          break;
        case "[办理部门]" == st:
          value = yj.department;
          break;
        case "[换行]" == st:
          if (isReturnStr) {
            value = "\n";
          } else {
            me.nextLine();
          }
          break;
        case "[居右]" == st:
          if (!isReturnStr) me.alignRight();
          break;
        case "[居中]" == st:
          if (!isReturnStr) me.alignCenter();
          break;
        case "[居左]" == st:
          if (!isReturnStr) me.alignLeft();
          break;
        default:
          value = st;
          break;}


      if (value && !isReturnStr) {
        me.addText(value);
      } else {
        return value;
      }
    } }, { key: "setLabelValue", value: function setLabelValue(


    formatObject, formData, businessId, processDefinitionId) {
      var me = this;
      var saveParams = me.saveParams || {};

      var htLabel = formatObject.htLabelName;
      var ffbmLabel = formatObject.ffbmLabelName;
      var htValue = formatObject.htLabelValue;
      var ffbmValue = formatObject.ffbmLabelValue;

      if (htLabel && htValue) {
        htValue = me._eval(formData, htValue);

        if (me.hasBookMark(htLabel)) {
          me.setBookMarkValue(htLabel, htValue);
          try {
            me.fitWidth(htLabel, htValue);
          } catch (e) {
            me.log();
          }
        }
      }

      if (ffbmLabel && ffbmValue) {
        ffbmValue = me._eval(formData, ffbmValue);
        formData[ffbmLabel] = ffbmValue;
        if (me.hasBookMark(ffbmLabel)) {
          me.setBookMarkValue(ffbmLabel, ffbmValue);
        }
      }


      var names = this.getBookMarksName();
      $.each(names, function (i, bkName) {
        if (!me.hasBookMark(bkName)) return;
        var bkObj = formatObject.tmplListObject[bkName];

        if (bkName == "fldfj") {
          var params = {
            businessId: me.businessId || saveParams.businessId || "",
            tempBusinessId: me.tempBusinessId || saveParams.tempBusinessId || "",
            formId: me.formId || saveParams.formId || "",
            type: "JOA_FJ" };

          MW.mwApi.business.listAttachment(params).then(function (res) {
            var fjStr = "";
            if (res && res.result) {
              var list = res.result;
              $.each(list, function (idx, fj) {
                fjStr += (list.length > 1 ? idx + 1 + "." : "") + me.getBaseName(fj.name) + (idx == list.length - 1 ? "" : "\r");
              });
            }
            me.setBookMarkValue(bkName, fjStr);
          });
        } else if (bkObj) {
          var valueFrom = bkObj['fldqzfs'];
          var formula = $.trim(bkObj['fldqz']);
          var hqName = bkObj['huiqian'];
          var yiName = bkObj["fldyjgs"];
          var isSetBMarkValue = true;
          var oldValue = me.getBookMarkValue(bkName);
          var value = "";
          if (valueFrom == "表单域值") {
            value = formData[formula] || "";
            me.setBookMarkValue(bkName, value);
          } else if (valueFrom == "取值表达式") {
            value = me._eval(formData, formula || "");
            me.setBookMarkValue(bkName, value);
          } else if (valueFrom == "按意见类型取值" || valueFrom == "按环节名称取值") {
            var regx = /\[(居(中|左|右)|电子签名)\]/;
            var p = {
              businessId: businessId,
              processDefinitionId: processDefinitionId };

            if (valueFrom == "按环节名称取值") {
              p.taskName = formula;
            } else
            {
              p.category = formula;
            }
            MW.mwApi.business.queryCommentProcess(p).then(function (r) {
              if (!r || !r.result) {
                return;
              }
              var yjs = r.result || [];
              if (bkObj.fldfhzxyt == "是") {
                yjs = yjs.length > 0 ? [yjs[yjs.length - 1]] : [];
              }
              if (regx.test(yiName)) {
                me.selectBookMark(bkName);
                var tags = me.resolveTags(yiName);
                $.each(yjs, function (ii, yj) {
                  if (tags) {
                    $.each(tags, function (index, el) {
                      me.appendContent(el, yj, {});
                    });
                    if (ii != yjs.length - 1) me.nextLine();
                  }
                });
              } else {
                var tags = me.resolveTags(yiName);
                $.each(yjs, function (ii, yj) {
                  if (tags) {
                    $.each(tags, function (index, el) {
                      value += me.appendContent(el, yj, {}, true);
                    });
                    if (ii != yjs.length - 1) value += "\n";
                  }
                });
                me.setBookMarkValue(bkName, value);
              }
            });
          } else if (valueFrom == "办理过程") {
            MW.mwApi.process.getFlowProcess({ businessId: businessId, type: 1 }).then(function (v) {
              if (v && v.result && v.result.length > 0) {
                var list = v.result;
                var processValue = "";
                for (var m = 0; m < list.length; m++) {
                  var processData = list[m];
                  var processDate = me.formatDateStr("yyyy年M月d日", processData.createTime);
                  var processComment = processData.comment || "";
                  processValue += (m + 1).toString() + ":";
                  processValue += processData.name + "    " + processData.department + "    " + processDate + "    " + processComment;
                  if (m < list.length - 1) processValue += "\n";
                }
                me.setBookMarkValue(bkName, processValue);
              }
            });
          } else if (valueFrom == "动态表格") {



            if (!me.form) return;
            if (!me.form.find(formula)) return;
            var tableConfig = me.form.find(formula).getDD();
            if (!tableConfig) return;
            var columnsWidth = tableConfig.columnsWidth;
            var fieldNames = tableConfig.fieldNames;
            var tableValue = tableConfig.value || me.form.find(formula).getValue();
            var row = tableValue.length + 1;
            var col = columnsWidth.length;
            var table = void 0;
            var valueList = tableConfig.value || me.form.find(formula).getValue();

            if (me.hasBookMark(bkName)) {

              me.selectBookMark(bkName);
              var range = me.ocx.activedocument.application.Selection.Range;
              table = me.ocx.activedocument.Tables.Add(range, row, col, 1, 0);

              table.Range.cells.VerticalAlignment = 1;
              var rowCount = table.Rows.Count;
              table.Range.ParagraphFormat.Alignment = 1;

              var title = [];
              var field = [];
              var items = tableConfig.items;
              var count = 0;
              if (!items) return;

              items.map(function (currentValue, index, arr) {
                var colSpan = currentValue.colSpan;
                var itemList = currentValue.items;
                var itemText = "";
                if (itemList && itemList.length > 0) {
                  itemList.map(function (item, i, v) {
                    var xtype = item.xtype;
                    if (xtype == "Label") {
                      if (!itemText) {
                        itemText += "'" + item.value + "'";
                      } else {
                        itemText += "+" + "'" + item.value + "'";
                      }
                    } else {
                      if (!itemText) {
                        itemText = item.name;
                      } else {
                        itemText += "+" + item.name;
                      }
                    }
                  });
                }
                count = count + colSpan;
                if (count > col) {
                  itemText = itemText;
                  field.push(itemText);
                } else {
                  itemText = itemText + "#" + colSpan.toString();
                  itemText = itemText || "";
                  itemText.replace(/'/g, "");
                  title.push(itemText);
                }
              });


              for (var i = 0; i < title.length; i++) {
                var titleName = title[i].indexOf("#") != -1 ? title[i].split("#")[0] : "";
                var titleColspan = title[i].indexOf("#") != -1 ? title[i].split("#")[1] : 1;
                if (titleName) {
                  titleName = titleName.replace(/'/g, "");
                }
                table.cell(1, i + 1).range.font.size = 12;
                table.cell(1, i + 1).Range.Text = titleName;
                table.cell(1, i + 1).Range.Font.Bold = true;
                table.cell(1, i + 1).Range.Font.Color = 8210719;
              }

              var rowNum = 2;
              for (var n = 0; n < valueList.length; n++) {
                var v = valueList[n];
                for (var m = 0; m < col; m++) {
                  var fieldName = field[m];
                  var fieldValue = me._eval(v, fieldName) || "";

                  table.cell(rowNum + n, m + 1).range.font.size = 12;
                  table.cell(rowNum + n, m + 1).Range.Text = fieldValue;
                }
              }
            }
          }
        }
      });
    } }, { key: "checkUserSignature", value: function checkUserSignature(

    userId) {











      this.log("userId:" + userId);
      return null;
    } }, { key: "querySync", value: function querySync(

    url, data) {
      var me = this;
      var result;
      $.ajax({
        url: url,
        method: "POST",
        data: data,
        async: false,
        success: function success(res) {
          result = res;
        } });

      return result;
    } }, { key: "fitWidth", value: function fitWidth(

    lblName, str) {
      str = str || "";
      var ps = this.ocx.ActiveDocument.Application.Selection.PageSetup;
      var contentWidth = ps.PageWidth - ps.Leftmargin - ps.Rightmargin;
      var len = str.length - str.replace(/\w/g, "").length;
      if (len > 0) {
        len = Math.floor(len / 2);
      }
      len = str.length - len;
      if (this.hasBookMark(lblName)) {
        var fontSize = this.ocx.ActiveDocument.BookMarks(lblName).Range.Font.Size;
        var count = contentWidth / fontSize;
        count = Math.floor(count);
        var scale = Math.ceil(count * 100 / len);
        this.ocx.ActiveDocument.BookMarks(lblName).Range.Font.Scaling = scale;
        this.log(lblName + " scale: " + scale);
      }
    } }, { key: "getOfdTpl", value: function getOfdTpl()



    {
      var ocxId = this.ocxId;
      var ocxPath = this.getHttpPath() + "/assets/ntkooledocall/suwellreaderpro-2.0.18.0504-setup-a.exe" || this.ofdOcxPath;
      var tpl = "<object width=\"100%\" height=\"100%\" id=\"" + ocxId + "\" classid=\"CLSID:C7F277DC-6C47-AB2C-FB6A-070DC8BE7533\">\n            <PARAM NAME=\"modal\" VALUE=\"0\">\n            <PARAM NAME=\"enabled\" VALUE=\"-1\">\n            <span><a href=\"" +


      ocxPath + "\">\u5B89\u88C5OFD\u63D2\u4EF6</a></span>\n            </object>";

      return tpl;
    } }, { key: "openOfdDocument", value: function openOfdDocument(

    openParams) {
      var url;
      if (typeof openParams == "string") {
        url = openParams;
      } else {
        var openParams = openParams || this.openParams || {};
        var fileId = openParams.fileId || this.fileId || "";
        var formId = openParams.formId || "";
        var businessId = openParams.businessId || "";
        var tempBusinessId = openParams.tempBusinessId || "";
        var xToken = openParams.xToken || this.xToken || "";
        var url = this.downloadUrl + "?id=" + fileId + "&formId=" + formId + "&businessId=" + businessId + "&xToken=" + xToken;
        url += "&tempBusinessId=" + tempBusinessId;
      }
      this.log(url);
      return this.ocx.openFile2(url, false);
    } }, { key: "saveOfd", value: function saveOfd(

    url) {
      this.ocx.saveFile(url);
    } }]);return NtkoOffice;}(_ntkoFuncBase2.default);exports.default = NtkoOffice;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(26);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(31);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(32);var _inherits3 = _interopRequireDefault(_inherits2);var _ocxBase = __webpack_require__(1024);var _ocxBase2 = _interopRequireDefault(_ocxBase);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _class = function (_OcxBase) {(0, _inherits3.default)(_class, _OcxBase);


  function _class(params) {(0, _classCallCheck3.default)(this, _class);
    params = params || {};var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this,
    params));

    _this.ocxId = "NTKO_OFFICE_" + $uuid();
    _this.NTKO_SAVE_FORM = "NTKO_SAVE_FORM";
    _this.events = {};


    _this.classid = params.classid;
    _this.Caption = params.Caption;
    _this.MakerCaption = params.MakerCaption;
    _this.MakerKey = params.MakerKey;
    _this.ProductCaption = params.ProductCaption;
    _this.ProductKey = params.ProductKey;


    _this.ocxPath = params.ocxPath;
    _this.uploadUrl = params.uploadUrl;
    _this.updateUrl = params.updateUrl;
    _this.downloadUrl = params.downloadUrl;
    _this.pluginUrl = params.pluginUrl;

    _this.fileName = params.fileName;
    _this.fileType = params.fileType;
    _this.fileId = params.fileId;
    _this.efileType = params.efileType;
    _this.userName = params.userName;
    _this.fileLinkId = params.fileLinkId;
    _this.pkId = params.pkId || params.businessId;

    _this.tempBusinessId = params.tempBusinessId;
    _this.formId = params.formId;
    _this.businessId = params.businessId;
    _this.xToken = params.xToken;

    _this.setVersion = -1;
    _this.PASS_WORD = "autosoft";

    var locationhref = window.location;
    var portStr = "";
    if (locationhref.port != 80) {
      portStr = ":" + locationhref.port;
    }
    _this.httpPath = locationhref.protocol + "//" + locationhref.hostname + portStr;





    _this.AlignType = {
      "LEFT": 0,
      "CENTER": 1,
      "RIGHT": 2 };


    _this.SaveMode = {
      NEW: "new",
      UPDATE: "update" };






    _this.DocTypeValue = {
      DOC: 0,
      DOCX: 16,
      XLS: 56,
      XLSX: 51 };


    _this.HttpMethod = {
      Get: 0,
      Post: 1 };






    _this.OfficeVersion = {
      v2016: 2016,
      v2013: 2013,
      v2010: 2010,
      v2007: 2007,
      v2003: 2002,
      vOther: 0 };






    _this.DocType = {
      WORD: 0,
      EXECL: 1,
      PPT: 2,
      PDF: 3,
      TIF: 4 };






    _this.ProtectMode = {
      REVISIONS: 0,
      POSTIL: 1,
      FORMFIELD: 2,
      READONLY: 3 };






    _this.DialogType = {
      SAVEAS: 2 };






    _this.FontSize = {
      "初号": 42,
      "小初": 36,
      "一号": 26,
      "小一": 24,
      "二号": 22,
      "小二": 18,
      "三号": 16,
      "小三": 15,
      "四号": 14,
      "小四": 12,
      "五号": 10.5,
      "小五": 9,
      "六号": 7.5,
      "小六": 6.5,
      "七号": 5.5,
      "八号": 5 };return _this;

  }(0, _createClass3.default)(_class, [{ key: "setOcx", value: function setOcx(





    ocx) {
      this.ocx = ocx;
    } }, { key: "createForm", value: function createForm(






    data) {
      var doc;
      if (this.el) {
        var win = this.el[0].contentWindow;
        doc = win.contentDocument || win.document;
      }
      doc = doc || document;
      this.clearForm();
      var data = data || {};
      var fm = doc.getElementById(this.NTKO_SAVE_FORM);
      if (!fm) {
        fm = $("<form id='" + this.NTKO_SAVE_FORM + "' method='post'></form>");
      } else {
        fm = $(fm);
      }
      fm.children().remove();
      for (var k in data) {
        fm.append("<input type='hidden' name='" + k + "' value='" + data[k] + "' />");
      }
      $(doc.body).append(fm);
    } }, { key: "clearForm", value: function clearForm()




    {
      var doc;
      if (this.el) {
        var win = this.el[0].contentWindow;
        doc = win.contentDocument || win.document;
      }
      doc = doc || document;
      $(doc.body).find("#" + this.NTKO_SAVE_FORM).remove();
    } }, { key: "log", value: function log(





    msg) {
      if (!this.__loginfo) {
        this.__loginfo = [];
      }
      this.__loginfo.push(msg);



    } }, { key: "error", value: function error(





    msg) {
      this.log("ERROR====>" + msg);
      if (window.console && window.console.trace) {
        window.console.trace(msg);
      }
    } }, { key: "warn", value: function warn(

    msg) {
      if (window.console && window.console.warn) {
        window.console.warn(msg);
      }
    } }, { key: "getFileType", value: function getFileType(






    fileName) {
      fileName = fileName || this.fileName || "";
      if (fileName) {
        var arr = fileName.split(".");
        return "." + arr[arr.length - 1];
      } else if (this.ocx) {
        if (this.isWord()) {
          return ".doc";
        } else if (this.isExcel()) {
          return ".xls";
        } else if (this.isPPT()) {
          return ".ppt";
        }
      }
    } }, { key: "getDocType", value: function getDocType(






    fileType) {
      fileType = fileType || this.fileType;
      if (fileType) {
        if (fileType == ".doc" || fileType == ".docx" || fileType == ".wps") {
          return this.DocType.WORD;
        }
        if (fileType == ".xls" || fileType == ".xlsx" || fileType == ".et") {
          return this.DocType.EXECL;
        }
        if (fileType == ".ppt" || fileType == ".pptx" || fileType == ".dps") {
          return this.DocType.PPT;
        }
        if (fileType == ".pdf") {
          return this.DocType.PDF;
        }
        if (fileType == ".tiff" || fileType == ".tif") {
          return this.DocType.TIF;
        }
      } else if (this.ocx) {
        if (this.ocx.DocType == 1 || this.ocx.DocType == 6) {
          return this.DocType.WORD;
        }
        if (this.ocx.DocType == 2) {
          return this.DocType.EXECL;
        }
        if (this.ocx.DocType == 3) {
          return this.DocType.PPT;
        }
        if (this.ocx.DocType == 51) {
          return this.DocType.PDF;
        }
      }
      return -1;
    } }, { key: "createNew", value: function createNew()




    {
      var docType = this.getDocType(this.fileType);
      switch (docType) {
        case this.DocType.WORD:
          this.ocx.CreateNew("Word.Document");
          break;
        case this.DocType.EXECL:
          this.ocx.CreateNew("Excel.Sheet");
          break;
        default:
          this.ocx.CreateNew("Word.Document");
          break;}

    } }, { key: "unProtect", value: function unProtect()





    {
      if (this.isWord()) {
        try {
          this.ocx.ActiveDocument.Unprotect(this.PASS_WORD);
        } catch (e) {
          this.error(e);
        }
      } else if (this.isExcel()) {
        var sheets = this.ocx.ActiveDocument.Sheets;
        for (var i = 1; i <= sheets.Count; i++) {
          try {
            sheets(i).Unprotect(this.PASS_WORD);
          } catch (e) {
            this.error(e);
          }
        }
      }
    } }, { key: "getProtectType", value: function getProtectType()





    {
      return this.ocx.ActiveDocument.ProtectionType;
    } }, { key: "protect", value: function protect(






    type, noReset) {
      if (this.isWord()) {
        var protectType = this.getProtectType();
        if (protectType != -1) {
          try {
            this.unProtect();
          } catch (e) {
            this.error(e);
          }
        }
        this.ocx.ActiveDocument.Protect(type, noReset || false, this.PASS_WORD);
      } else if (this.isExcel()) {
        var sheets = this.ocx.ActiveDocument.Sheets;
        for (var i = 1; i <= sheets.Count; i++) {
          try {
            sheets(i).Protect(this.PASS_WORD);
          } catch (e) {
            this.error(e);
          }
        }
      }

    } }, { key: "addText", value: function addText(





    text) {
      this.ocx.ActiveDocument.Application.Selection.TypeText(text);
    } }, { key: "homeKey", value: function homeKey()




    {
      var me = this;
      me.ocx.ActiveDocument.Application.Selection.HomeKey(6);
    } }, { key: "endKey", value: function endKey()




    {
      var me = this;
      me.ocx.ActiveDocument.Application.Selection.EndKey(6);
    } }, { key: "moveUp", value: function moveUp(






    unit, count) {
      var me = this;
      if (!unit) unit = 5;
      if (!count) count = 1;
      me.ocx.ActiveDocument.Application.Selection.MoveUp(unit, count);
    } }, { key: "moveDown", value: function moveDown(






    unit, count) {
      var me = this;
      if (!unit) unit = 5;
      if (!count) count = 1;
      me.ocx.ActiveDocument.Application.Selection.MoveDown(unit, count);
    } }, { key: "moveLeft", value: function moveLeft(






    unit, count) {
      var me = this;
      if (!unit) unit = 1;
      if (!count) count = 1;
      me.ocx.ActiveDocument.Application.Selection.MoveLeft(unit, count);
    } }, { key: "moveRight", value: function moveRight(






    unit, count) {
      var me = this;
      if (!unit) unit = 1;
      if (!count) count = 1;
      me.ocx.ActiveDocument.Application.Selection.MoveRight(unit, count);
    } }, { key: "nextLine", value: function nextLine()




    {
      this.ocx.ActiveDocument.Application.Selection.TypeParagraph();
    } }, { key: "selectBookMark", value: function selectBookMark(





    lblName) {
      var bookmarks = this.ocx.ActiveDocument.Bookmarks;
      if (this.hasBookMark(lblName)) {
        bookmarks.Item(lblName).Range.Select();
      }
    } }, { key: "hasBookMark", value: function hasBookMark(






    lblName) {
      return this.ocx.ActiveDocument.BookMarks.Exists(lblName);
    } }, { key: "setBookMarkValue", value: function setBookMarkValue(







    lblName, lblValue) {
      this.log(lblName + ":" + lblValue);
      lblValue = lblValue || "";
      if (this.hasBookMark(lblName)) {
        var bk = this.ocx.ActiveDocument.Bookmarks(lblName);
        var start = bk.Range.Start;
        var end = start + lblValue.length;
        bk.Range.Text = lblValue;
        this.addBookMark(lblName, start, end);
        this.moveRight();
        return true;
      }
      this.warn("BookMark '" + lblName + "' is not found!!");
      return false;
    } }, { key: "getBookMarkValue", value: function getBookMarkValue(





    lblName) {
      var me = this;
      if (me.hasBookMark(lblName)) {
        return this.ocx.ActiveDocument.Bookmarks(lblName).Range.Text;
      } else {
        return "";
      }
    } }, { key: "getBookMarksName", value: function getBookMarksName()





    {
      var me = this;
      var marks = [];
      var bookmarks = me.ocx.ActiveDocument.BookMarks;
      var count = bookmarks.Count;
      for (var i = 1; i <= count; i++) {
        marks.push(bookmarks.Item(i).Name);
      }
      return marks;
    } }, { key: "getBookMarkCount", value: function getBookMarkCount()





    {
      var me = this;
      return me.ocx.ActiveDocument.BookMarks.Count;
    } }, { key: "setBookMarkValues", value: function setBookMarkValues(





    data) {
      var me = this;
      for (k in data) {
        me.setBookMarkValue(k, data[k]);
      }
    } }, { key: "getOfficeVer", value: function getOfficeVer()





    {
      return this.ocx.ActiveDocument.Application.Version;
    } }, { key: "getOfficeVersion", value: function getOfficeVersion()






    {
      var getVersion = 0.0;
      try {
        if (this.setVersion == -1) {
          getVersion = parseFloat(this.getOfficeVer());
          this.setVersion = getVersion;
        } else {
          getVersion = this.setVersion;
        }
        if (getVersion == 11.0) {
          return this.OfficeVersion.v2003;
        } else if (getVersion == 12.0) {
          return this.OfficeVersion.v2007;
        } else if (getVersion == 14.0) {
          return this.OfficeVersion.v2010;
        } else if (getVersion == 15.0) {
          return this.OfficeVersion.v2013;
        } else if (getVersion > 15.0) {
          return this.OfficeVersion.v2016;
        } else {
          return this.OfficeVersion.vOther;
        }
      } catch (e) {
        return this.OfficeVersion.v2003;
      }
    } }, { key: "printOut", value: function printOut()




    {
      var me = this;
      me.ocx.PrintOut(true);
    } }, { key: "acceptAllRevisions", value: function acceptAllRevisions()




    {
      var me = this;
      if (me.getProtectType() != "-1") {
        me.unProtect();
      }
      try {
        me.ocx.ActiveDocument.AcceptAllRevisions();
      } catch (e) {
        this.error("AcceptAllRevisions Failed!:" + e);
      }
    } }, { key: "showDialog", value: function showDialog(





    dialogType) {
      this.ocx.ShowDialog(dialogType);
    } }, { key: "saveAs", value: function saveAs()




    {
      this.ocx.FileSaveAs = true;
      if (this.isWord()) {
        var pType = this.getProtectType();
        if (pType == this.ProtectMode.READONLY) {
          this.unProtect();
          this.showDialog(this.DialogType.SAVEAS);
          me.protect(this.ProtectMode.READONLY);
          return;
        }
      }
      this.showDialog(this.DialogType.SAVEAS);
    } }, { key: "align", value: function align(





    alginType) {
      var me = this;
      me.ocx.ActiveDocument.application.selection.Range.ParagraphFormat.Alignment = alginType;
    } }, { key: "alignLeft", value: function alignLeft()




    {
      this.align(this.AlignType.LEFT);
    } }, { key: "alignCenter", value: function alignCenter()




    {
      this.align(this.AlignType.CENTER);
    } }, { key: "alignRight", value: function alignRight()




    {
      this.align(this.AlignType.RIGHT);
    } }, { key: "addBookMark", value: function addBookMark(







    lblName, start, end) {
      var me = this;
      try {
        if (typeof start == "number" && typeof end == "number") {
          me.ocx.ActiveDocument.Range(start, end).Select();
        } else {
          me.ocx.ActiveDocument.Application.Selection.Select();
        }
        me.ocx.ActiveDocument.Bookmarks.Add(lblName);
      } catch (e) {
        me.error(e);
        return false;
      }
      return true;
    } }, { key: "setMarkupMode", value: function setMarkupMode(





    mode) {
      var me = this;
      me.ocx.ActiveDocument.ActiveWindow.View.MarkupMode = mode;
    } }, { key: "createTable", value: function createTable(







    rows, cols, width) {
      var me = this;
      var range = me.ocx.ActiveDocument.Application.Selection.Range;
      var table = me.ocx.ActiveDocument.Tables.Add(range, rows, cols, 1, 0);
      this.table = table;
      if (width.length == cols) {
        for (var i = 1; i <= rows; i++) {
          for (var j = 1; j <= cols; j++) {
            table.Cell(i, j).Width = width[j - 1];
          }
        }
      }
      me.log("createTable->rows:" + rows + ",cols:" + cols);
      return table;
    } }, { key: "selectCell", value: function selectCell(






    rowIndex, colIndex) {
      var me = this;
      if (!this.table) {
        me.log("selectCell->not found table");
        return;
      }
      try {
        this.cell = this.table.Cell(rowIndex, colIndex);
        this.cell.Range.Select();
      } catch (e) {
        this.error("selectCell" + e);
      }
    } }, { key: "setCellValue", value: function setCellValue(







    value, rowIndex, colIndex) {
      var me = this;
      if (!this.table) {
        me.log("setCellValue->not found table");
        return;
      }
      if (!this.cell) {
        me.log("setCellValue->not found cell");
        return;
      }
      try {
        if (rowIndex && colIndex) {
          this.table.Cell(rowIndex, colIndex).Range.Text = value;
        } else {
          this.cell.Range.Text = value;
        }
      } catch (e) {
        me.error(e);
      }

    } }, { key: "createTableInCell", value: function createTableInCell(








    data, sqName, thead, content) {
      var me = this;
      if (!sqName || !me.hasBookMark(sqName)) {
        me.log("Bookmark" + sqName + " is not exists!");
        return;
      }
      var bk = ntko.ActiveDocument.Bookmarks.Item(sqName);
      var tables = bk.Range.Tables;
      if (tables.Count > 0) {
        var table = tables.Item(1);
        me.table = table;
        if (bk.Range.Cells.Count > 0) {
          var cell = bk.Range.Cells.Item(1);
          var colIdx = cell.columnIndex;
          var rowIdx = cell.rowIndex;
          var rowCount = (data ? data.length : 0) + (thead ? thead.length : 0);
          var colCount = (thead || content).length;
          cell.Split(rowCount, colCount);
          var idx = 0;
          for (var r = rowIdx; r <= rowIdx + (thead && thead.length > 0 ? data.length : data.length - 1); r++) {
            table.Rows.Item(r).Range.ParagraphFormat.Alignment = 1;
            table.Rows.Item(r).Height = 25;
            if (r == rowIdx && thead && thead.length > 1) {
              table.Rows.Item(r).Range.Font.Bold = true;
              table.Cell(r, 1).Range.Text = thead[c - 1];
              for (var c = 1; c <= thead.length; c++) {
                table.Cell(r, c).VerticalAlignment = 1;
                table.Cell(r, c).Range.Text = thead[c - 1];
              }
            } else {
              var d = data[idx];
              for (var c = 1; c <= content.length; c++) {
                table.Cell(r, c).VerticalAlignment = 1;
                table.Cell(r, c).Range.Text = d ? d[content[c - 1]] : "";
              }
              idx++;
            }
          }
        }
      }
    } }, { key: "trackRevisions", value: function trackRevisions(





    bool) {
      this.ocx.ActiveDocument.TrackRevisions = bool;
    } }, { key: "isTrackRevisions", value: function isTrackRevisions()





    {
      return this.ocx.ActiveDocument.TrackRevisions;
    } }, { key: "isWord", value: function isWord()





    {
      return this.getDocType() == this.DocType.WORD;
    } }, { key: "isExcel", value: function isExcel()






    {
      return this.getDocType() == this.DocType.EXECL;
    } }, { key: "isPPT", value: function isPPT()






    {
      return this.getDocType == this.DocType.PPT;
    } }, { key: "isOfficeFile", value: function isOfficeFile()





    {
      return this.isWord() || this.isExcel() || this.isPPT();
    } }, { key: "showRevisions", value: function showRevisions(





    bool) {
      var me = this;
      if (me.isWord()) {
        try {
          me.ocx.ActiveDocument.ShowRevisions = bool;
        } catch (e) {
          me.error(e);
        }
      }
    } }, { key: "isShowRevisions", value: function isShowRevisions()

    {
      var me = this;
      if (me.isWord()) {
        try {
          return me.ocx.ActiveDocument.ShowRevisions;
        } catch (e) {
          me.error(e);
        }
      }
    } }, { key: "isSaved", value: function isSaved()





    {
      var me = this;


      return me.ocx.Activedocument.Saved;
    } }, { key: "setSaved", value: function setSaved(





    isSaved) {
      this.ocx.Activedocument.Saved = isSaved;
    } }, { key: "setUserName", value: function setUserName(





    userName) {
      userName = userName || this.userName || "";
      if (this.isWord()) {
        if (userName) {
          this.ocx.ActiveDocument.Application.UserName = userName;
        }
        if (this.getOfficeVersion() >= this.OfficeVersion.v2013) {
          try {
            this.ocx.ActiveDocument.Application.Options.UseLocalUserInfo = true;
          } catch (e) {
          }
        }
      }

    } }, { key: "setFileName", value: function setFileName(





    fileName) {
      this.log("set fileName : " + fileName);
      if (fileName) {
        this.fileName = fileName;
      }
    } }, { key: "randomFileName", value: function randomFileName(






    docType) {
      return ("" + Math.random()).substr(2) + (docType || ".doc");
    } }, { key: "removeAutoSave", value: function removeAutoSave()

    {
      var obj = window.onlineEditPanelObj;
      if (!obj) return;
      if (obj.ocx) {
        obj.ocx.RemoveCustomButtonOnMenu(9);
      }
      clearInterval(obj.intervalFnId);
      delete obj.intervalFnId;
      delete window.onlineEditPanelObj;
    } }, { key: "autoSave", value: function autoSave()

    {
      var obj = window.onlineEditPanelObj;
      if (!obj || !obj.ocx) return;
      obj.countdown = obj.countdown - 1;
      if (obj.countdown > 0) {
        var minute = Math.floor(obj.countdown / 60);
        obj.ocx.AddCustomButtonOnMenu(9, "  " + (minute != 0 ? minute + "分" : "") + obj.countdown % 60 + "秒后自动保存");
      } else {
        clearInterval(obj.intervalFnId);
        obj.ocx.AddCustomButtonOnMenu(9, "  自动保存中.....");
        obj.saveDocumentToServer();
        obj.ocx.RemoveCustomButtonOnMenu(9);
        obj.countdown = obj.autoSaveInterval * 60;
        obj.intervalFnId = setInterval("autoSave()", 1000);
      }
    } }, { key: "setAutoSave", value: function setAutoSave()

    {
      var me = this;
      var re = 5;
      MW.mwApi.data.getDictByCode("自动保存间隔时长").then(function (v) {
        if (v && v.result && v.result.active == "T") {
          re = v.result.values ? v.result.values : 0;
          if (re && PF.isNumber(re = parseInt(re)) && re > 0) {
            me.autoSaveInterval = re;
            me.countdown = re * 60;
            window.onlineEditPanelObj = me;
            window.autoSave = me.autoSave;
            me.intervalFnId = setInterval("autoSave()", 1000);
          }
        }
      }).catch(function (err) {return console.log(err);});
    } }, { key: "_eval", value: function _eval(









    scope, exp) {
      function ExprEvaluator(scope, context) {
        this.scope = scope;
        this.context = context;
        this.evalFn = this.createScope();
      }

      ExprEvaluator.prototype = {
        variableRe: /^[_a-zA-Z][_0-9a-zA-Z]*$/,
        keywords: ["extends", "break", "case", "catch", "continue", "null", "debugger", "default", "delete", "do", "else", "finally", "for", "function", "if", "in", "instanceof", "new", "return", "switch", "this", "throw", "try", "typeof", "var", "void", "while", "with"],
        isValidVariable: function isValidVariable(name) {
          return this.variableRe.test(name) && this.keywords.indexOf(name) == -1;
        },
        createScope: function createScope() {
          var body = '';
          var scope = this.scope;
          if (scope) {
            for (var key in scope) {

              if (scope.hasOwnProperty(key) && this.isValidVariable(key)) {
                body += "var " + key + " = __$$__." + key + ";";
              }
            }
          }
          body += "try{return eval(__$__)}catch(e){return ''}";
          return new Function("__$__", "__$$__", body);
        },
        eval: function _eval(expr) {
          return this.evalFn.call(this.context, expr, this.scope);
        } };


      return new ExprEvaluator(scope).eval(exp);

    } }, { key: "_eval_", value: function _eval_(







    scope, exp) {
      var variableRe = /^[_a-zA-Z][_0-9a-zA-Z]*$/;
      var keywords = ["extends", "break", "case", "catch", "continue", "null", "debugger", "default", "delete", "do", "else", "finally", "for", "function", "if", "in", "instanceof", "new", "return", "switch", "this", "throw", "try", "typeof", "var", "void", "while", "with"];

      function isValidVariable(name) {
        return variableRe.test(name) && keywords.indexOf(name) == -1;
      }

      var body = '';
      if (scope) {
        for (var key in scope) {
          if (scope.hasOwnProperty(key) && isValidVariable(key)) {
            body += "var " + key + " = __$$__." + key + ";";

          }
        }
      }
      body += exp;
      var func = new Function("__$$__", body);
      try {
        return func(scope, exp);
      } catch (e) {
        return '';
      }
    } }, { key: "setPageNumber", value: function setPageNumber(








    fontName, fontSize, text) {
      fontName = fontName || "宋体";
      fontSize = fontSize || 14.25;
      text = text || "－";
      var ActiveDocument = this.ocx.ActiveDocument;
      ActiveDocument.ActiveWindow.ActivePane.View.SeekView = 10;
      var Sections = ActiveDocument.Sections;
      function setNumber(footer, align) {
        footer.Range.Delete();
        footer.PageNumbers.NumberStyle = 0;
        var rng = footer.Range;
        rng.Text = text;
        rng.Collapse(1);
        ActiveDocument.Fields.Add(rng, 33, "Page");
        rng.Collapse(1);
        rng.Text = text;
        footer.Range.Font.Size = fontSize;
        footer.Range.Font.Name = fontName;
        footer.Range.ParagraphFormat.WordWrap = false;
        footer.Range.ParagraphFormat.Alignment = align;
        footer.Range.ParagraphFormat.CharacterUnitRightIndent = 1;
        footer.Range.Fields.Update();
      }

      for (var i = 1; i <= Sections.Count; i++) {
        Sections.Item(i).PageSetup.DifferentFirstPageHeaderFooter = false;
        Sections.Item(i).PageSetup.OddAndEvenPagesHeaderFooter = true;
        for (var ii = 1; ii <= 3; ii++) {
          ActiveDocument.Sections(i).Headers(ii).Range.Paragraphs.Item(i).Format.Borders(-3).Color = 0;
          ActiveDocument.Sections(i).Headers(ii).Range.Paragraphs.Item(i).Format.Borders(-3).LineStyle = 0;
        }

        var footer = ActiveDocument.Sections(i).Footers.Item(1);
        setNumber(footer, this.AlignType.LEFT);
        footer = ActiveDocument.Sections(i).Footers.Item(3);
        setNumber(footer, this.AlignType.RIGHT);
      }
      ActiveDocument.ActiveWindow.ActivePane.View.SeekView = 0;
    } }, { key: "cmToPoints", value: function cmToPoints(





    cm) {
      return this.ocx.ActiveDocument.Application.CentimetersToPoints(cm);
    } }, { key: "setPageMargin", value: function setPageMargin(








    top, bottom, left, right) {
      top = top || 3.7;
      bottom = bottom || 3.4;
      left = left || 2.8;
      right = right || 2.6;
      try {
        var ActiveDocument = this.ocx.ActiveDocument;
        ActiveDocument.PageSetup.TopMargin = this.cmToPoints(top);
        ActiveDocument.PageSetup.BottomMargin = this.cmToPoints(bottom);
        ActiveDocument.PageSetup.LeftMargin = this.cmToPoints(left);
        ActiveDocument.PageSetup.RightMargin = this.cmToPoints(right);
      } catch (e) {
        this.error(e);
      }
    } }, { key: "setParagraphFormat", value: function setParagraphFormat(










    fontName, fontSize, bold, lineSpacingRule, lineSpacing, indent) {
      fontName = fontName || "仿宋_GB2312";
      fontSize = fontSize || this.FontSize["四号"];
      bold = bold || false;
      lineSpacingRule = lineSpacingRule || this.LineSpacingRule.EXACTLY;
      lineSpacing = lineSpacing || 29;
      indent = indent || 2;
      var ActiveDocument = this.ocx.ActiveDocument;
      ActiveDocument.Application.Selection.Range.Font.Name = fontName;
      ActiveDocument.Application.Selection.Range.Font.Size = fontSize;
      ActiveDocument.Application.Selection.Range.Font.Bold = bold;
      ActiveDocument.Application.Selection.ParagraphFormat.LineSpacingRule = lineSpacingRule;
      ActiveDocument.Application.Selection.Range.ParagraphFormat.LineSpacing = lineSpacing;
      ActiveDocument.Application.Selection.ParagraphFormat.CharacterUnitFirstLineIndent = indent;
    } }, { key: "setStyle", value: function setStyle(







    styleName, nameFarEast, fontSize) {
      var ActiveDocument = this.ocx.ActiveDocument;
      try {
        var stl = ActiveDocument.Styles.Item(styleName);
        if (stl) {
          stl.Font.Size = fontSize || this.FontSize["三号"];
          stl.Font.NameFarEast = nameFarEast;
        }
      }
      catch (e) {
        this.error(e);
      }
    } }, { key: "standardizing", value: function standardizing()





    {
      this.setPageMargin();
      this.setParagraphFormat();
      this.setPageNumber();
      this.setStyle("正文", "仿宋_GB2312");
      this.homeKey();
    } }, { key: "closeDocument", value: function closeDocument()




    {
      this.removeAutoSave();
      if (this.ocx) {
        try {
          this.ocx.Close();
        } catch (e) {

        }
      }
    } }, { key: "getTpl", value: function getTpl()

    {

      var classid = this.classid || "clsid:01DFB4B4-0E07-4e3f-8B7A-98FD6BFF153F";
      var Caption = this.Caption || "欢迎使用WebOffice综合办公系统!";
      var MakerCaption = this.MakerCaption || "北京美络克思科技有限公司";
      var MakerKey = this.MakerKey || "C3F5BF43B534CDC8150F57D0647A14DB2F126CAC";
      var ProductCaption = this.ProductCaption || "美络科技OA系统";
      var ProductKey = this.ProductKey || "566C944216242DE373C29867DC8E7AA682C2CC45";
      var ocxPath = this.ocxPath;
      var ocxId = this.ocxId;
      var tpl = "<object style=\"z-index:-999999;\" class=\"officeOcx\" id=\"" + ocxId + "\"\n            classid=\"" +
      classid + "\"\n            codebase=\"" +
      ocxPath + "\"\n            width=\"100%\" height=\"100%\">\n            <param name=\"BorderStyle\" value=\"1\">\n            <param name=\"Titlebar\" value=\"0\">\n            <param name=\"Menubar\" value=\"-1\">\n            <param name=\"ToolBars\" value=\"-1\">\n            <param name=\"IsShowHelpMenu\" value=\"0\">\n            <param name=\"IsShowToolMenu\" value=\"-1\">\n            <param name=\"Caption\" value=\"" +







      Caption + "\">\n            <param name=\"MakerCaption\" value=\"" +
      MakerCaption + "\">\n            <param name=\"MakerKey\" value=\"" +
      MakerKey + "\">\n            <param name=\"ProductCaption\" value=\"" +
      ProductCaption + "\">\n            <param name=\"ProductKey\" value=\"" +
      ProductKey + "\">\n            <param name=\"FileNew\" value=\"0\">\n            <param name=\"FileOpen\" value=\"0\">\n            <param name=\"FileSave\" value=\"0\">\n            <param name=\"FileClose\" value=\"0\">\n            <param name=\"IsStrictNoCopy\" value=\"0\">\n            <param name=\"IsRemoveMacrosOnSave\" value=\"0\">\n            <param name=\"MaxUploadSize\" value=\"0\">\n            <param name=\"FileSaveAs\" value=\"0\">\n            <param name=\"IsNoCopy\" value=\"0\">\n            <param name=\"IsUseUTF8URL\" value=\"1\">\n            <param name=\"IsUseUTF8Data\" value=\"1\">\n            <SPAN STYLE=\"color:red\">\u4E0D\u80FD\u88C5\u8F7D\u6587\u6863\u63A7\u4EF6,\u8BF7\u5728\u68C0\u67E5\u6D4F\u89C8\u5668\u7684\u9009\u9879\u4E2D\u68C0\u67E5\u6D4F\u89C8\u5668\u7684\u5B89\u5168\u8BBE\u7F6E\u3002</SPAN>\n          </object>";













      return tpl;
    } }, { key: "setIframe", value: function setIframe(






    iframe) {
      var me = this;
      if (!this.el) {
        this.el = iframe;
      }
      var win = iframe[0].contentWindow;
      var doc = win.contentDocument || win.document;
      var elements = doc.getElementsByTagName("object");
      $.each(elements, function (index, el) {
        var id = el.id || id;
        if (id.substring(0, 11) == "NTKO_OFFICE") {
          me.ocxId = id;
          me.setOcx(el);
          return true;
        }
      });
    } }, { key: "addEvent", value: function addEvent(

    eventName, handler) {
      var me = this;
      var doc;
      if (window.attachEvent && this.ocx) {
        this.ocx.attachEvent(eventName, handler);
        return;
      }
      if (this.el) {
        var win = this.el[0].contentWindow;
        doc = win.contentDocument || win.document;
      }
      if (doc.getElementById(eventName)) return;
      doc = doc || document;
      var head = doc.head || doc.getElementsByTagName("head")[0] || doc.documentElement;
      var node = doc.createElement("script");
      node.charset = "UTF-8";
      node.setAttribute("language", "JScript");
      node.setAttribute("for", this.ocxId);
      node.setAttribute("event", eventName);
      node.setAttribute("id", eventName);
      var ocxId = this.ocxId;
      var scriptHtml = "\n    var arg=arguments;\n    var ocx=document.getElementById('" +

      ocxId + "');\n    if(ocx&&document.createEvent){\n      var evt = document.createEvent('HTMLEvents');\n      evt.initEvent('_" +


      eventName + "_', false, false);\n      evt._arg=arg;\n      ocx.dispatchEvent(evt);\n    }\n    ";




      node.innerHTML = scriptHtml;
      head.appendChild(node);

      this.ocx.addEventListener("_" + eventName + "_", function (evt) {
        if (handler) {
          handler.call(me, evt);
        }
      });
    } }, { key: "render", value: function render(








    to, scope) {
      this.renderTo = to || this.renderTo;
      this.scope = scope || this.scope;
      var me = this;
      var tpl = this.tpl || this.getTpl();
      var iframeHtml = '<iframe scrolling="false" name="NTKO_EDITOR"   style="height:700px;width:100%;border:none;padding:0;margin:0;left:0;top:0;z-index:-999999;overflow:hidden;background-color:#fff;" src="about:blank"></iframe>';

      var iframe = $(iframeHtml);
      iframe.on("load", function () {
        var win = iframe[0].contentWindow;
        var doc = win.contentDocument || win.document;

        doc.body.innerHTML = tpl;
        var ocx = doc.getElementById(me.ocxId);
        me.setOcx(ocx);
        setTimeout(function () {
          if (me.events.load) {
            me.events.load.call(me);
          }
        }, 100);
      });
      this.el = iframe;
      if (this.renderTo) {
        if (this.renderTo) {
          $(this.renderTo, scope).append(iframe);
        }
      }

      return iframe;

    } }, { key: "destroy", value: function destroy()


    {
      this.closeDocument();
      this.ocx = null;
      if (this.el) {
        this.el.remove();
      }
      this.el = null;
    } }, { key: "rerender", value: function rerender()




    {
      this.destroy();
      if (this.renderTo) {
        this.render(this.renderTo, this.scope);
      }
    } }, { key: "on", value: function on(

    key, func) {
      this.events[key] = func;
    } }, { key: "formatDateStr", value: function formatDateStr(


    fmt, source) {

      source = source + "";
      if (typeof source == "string") {
        source = new Date(Date.parse(source.replace(/-/g, "/")));
      }
      var o = {
        "M+": source.getMonth() + 1,

        "d+": source.getDate(),

        "h+": source.getHours(),

        "m+": source.getMinutes(),

        "s+": source.getSeconds(),

        "q+": Math.floor((source.getMonth() + 3) / 3),

        "S": source.getMilliseconds() };

      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (source.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));}
      return fmt;
    } }, { key: "getBaseName", value: function getBaseName(

    fileName) {
      if (!fileName) return "";
      return fileName.substring(0, fileName.lastIndexOf("."));
    } }, { key: "getBoolValue", value: function getBoolValue(

    bool, defaultValue) {
      return typeof bool == "boolean" ? bool : typeof defaultValue == "boolean" ? defaultValue : false;
    } }, { key: "openFromUrl", value: function openFromUrl(






    url) {
      this.log(url);
      try {
        this.addDocTypePlugins();
      } catch (e) {
      }
      try {
        this.ocx.OpenFromURL(url, false);
      } catch (e) {
        return false;
      }
      return true;
    } }, { key: "addDocTypePlugins", value: function addDocTypePlugins()




    {
      var ver = this.pluginVersion || "4.0.0.8";
      var url = this.pluginUrl;
      this.ocx.AddDocTypePlugin(".pdf", "PDF.NtkoDocument", ver, url, 51, true);
      this.ocx.AddDocTypePlugin(".tif", "TIF.NtkoDocument", ver, url, 52);
      this.ocx.AddDocTypePlugin(".tiff", "TIF.NtkoDocument", ver, url, 52);
    } }, { key: "addTempFromUrl", value: function addTempFromUrl(





    url) {

      this.log("addTempFromURL : " + url);
      this.ocx.AddTemplateFromURL(url);
    } }, { key: "showTitleBar", value: function showTitleBar(





    bool) {
      this.ocx.TitleBar = bool;
    } }, { key: "showToolBars", value: function showToolBars(





    bool) {
      this.ocx.ToolBars = bool;
    } }, { key: "setReadOnly", value: function setReadOnly(

    bool) {
      this.ocx.IsReadOnly = bool;
    } }, { key: "isReadOnly", value: function isReadOnly()

    {
      return this.ocx.IsReadOnly;
    } }, { key: "setWebFileName", value: function setWebFileName(





    fileName) {
      this.ocx.WebFileName = this.FileName || fileName;
    } }]);return _class;}(_ocxBase2.default);exports.default = _class;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _classCallCheck2 = __webpack_require__(10);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(15);var _createClass3 = _interopRequireDefault(_createClass2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _class = function () {
  function _class(params) {(0, _classCallCheck3.default)(this, _class);
    params = params || {};
    this.fileName = params.fileName;
    this.ocxId = "_OCX_" + $uuid();
    this.ProductType = {
      NTKO_OFFICE: 1,
      SUWELL_OFD: 2,
      DJ_AIP: 3,
      KINGGRID_PDF: 4,
      KINGGRID_OFFICE: 5 };

  }(0, _createClass3.default)(_class, [{ key: "getHttpPath", value: function getHttpPath()

    {
      var locationhref = window.location;
      var portStr = "";
      if (locationhref.port != 80) {
        portStr = ":" + locationhref.port;
      }
      return this.httpPath = locationhref.protocol + "//" + locationhref.hostname + portStr;
    } }, { key: "on", value: function on(

    key, func) {
      this.events[key] = func;
    } }, { key: "setOcx", value: function setOcx(

    ocx) {
      this.ocx = ocx;
    } }, { key: "render", value: function render(







    to, scope) {
      this.renderTo = to || this.renderTo;
      this.scope = scope || this.scope;
      var me = this;
      var tpl = this.tpl || this.getTpl();
      var iframeHtml = '<iframe scrolling="false" name="_OCX_EDITOR"   style="height:700px;width:100%;border:none;padding:0;margin:0;left:0;top:0;z-index:-999999;overflow:hidden;background-color:#fff;" src="about:blank"></iframe>';

      var iframe = $(iframeHtml);
      iframe.on("load", function () {
        var win = iframe[0].contentWindow;
        var doc = win.contentDocument || win.document;

        doc.body.innerHTML = tpl;
        var ocx = doc.getElementById(me.ocxId);
        me.setOcx(ocx);
        setTimeout(function () {
          if (me.events.load) {
            me.events.load.call(me);
          }
        }, 100);
      });
      this.el = iframe;
      if (this.renderTo) {
        if (this.renderTo) {
          $(this.renderTo, scope).append(iframe);
        }
      }
      return iframe;
    } }, { key: "rerender", value: function rerender()




    {
      this.destroy();
      if (this.renderTo) {
        this.render(this.renderTo, this.scope);
      }
    } }, { key: "closeDocument", value: function closeDocument()

    {

    } }, { key: "destroy", value: function destroy()

    {
      this.closeDocument();
      this.ocx = null;
      if (this.el) {
        this.el.remove();
      }
      this.el = null;
    } }, { key: "getProduct", value: function getProduct()

    {
      return 0;
    } }, { key: "getTpl", value: function getTpl()

    {
      return "";
    } }]);return _class;}();exports.default = _class;

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.buttons.length>0)?_c('div',{ref:"buttonsContainer",staticClass:"mw-toolbar"},_vm._l((_vm.buttons),function(button){return _c('el-button',{key:button.id,attrs:{"size":"small","type":"primary","id":button.id}},[_vm._v("\n      "+_vm._s(button.name)+"\n    ")])}),1):_vm._e(),_vm._v(" "),_c('div',{ref:"iframeContainer",staticClass:"mw-toolbar__body"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_attachment_vue__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_attachment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_attachment_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_attachment_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_attachment_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_de9ce8d8_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_ntko_attachment_vue__ = __webpack_require__(1027);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_attachment_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_de9ce8d8_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_ntko_attachment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-upload"},[(_vm.buttons.length>0)?_c('div',{ref:"buttonsContainer",staticClass:"mw-toolbar"},_vm._l((_vm.buttons),function(button){return _c('el-button',{key:button.id,attrs:{"size":"small","type":"primary","id":button.id}},[_c('i',{class:button.class}),_vm._v(_vm._s(button.name)+"\n    ")])}),1):_vm._e(),_vm._v(" "),_c('div',{ref:"iframeContainer",staticClass:"mw-toolbar__body",staticStyle:{"background-color":"transparent"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_toobarTable_vue__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_toobarTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_toobarTable_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_toobarTable_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_toobarTable_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_069fad0c_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_toobarTable_vue__ = __webpack_require__(1029);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_toobarTable_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_069fad0c_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_toobarTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('toolbar-table',{ref:"toolbarTable",attrs:{"applicationId":_vm.applicationId,"layout":_vm.layout}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (action, $form) {
  var extForm = $form.__originalExtForm;
  if (extForm) {
    extForm.action = action;
  }
  PF.action[action]($form);
};

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var loadedScripts = {};
var loadingScriptsCallbacks = {};
var funs = {
    requireJs: function requireJs(scripts, callback) {
        function load(url, callback) {
            if (loadedScripts[url]) return setTimeout(function () {
                callback.call(this, true);
            }, 0);
            if (loadingScriptsCallbacks[url]) {
                loadingScriptsCallbacks[url].push(callback);
                return;
            }
            loadingScriptsCallbacks[url] = [callback];
            function invokeCallback(r) {
                if (loadingScriptsCallbacks[url]) {
                    loadingScriptsCallbacks[url].forEach(function (c) {
                        c(r);
                    });
                    loadingScriptsCallbacks[url] = undefined;
                }
            }
            var script = document.createElement('script');
            script.type = 'text/javascript';

            var onErrorFn = function onErrorFn() {

                invokeCallback(false);
            };
            var onLoadFn = function onLoadFn() {
                loadedScripts[url] = true;
                invokeCallback(true);

            };
            script.onerror = onErrorFn;
            if ('addEventListener' in script) {
                script.onload = onLoadFn;
            } else if ('readyState' in script) {
                script.onreadystatechange = function () {
                    if (this.readyState == 'loaded' || this.readyState == 'complete') {
                        onLoadFn();
                    }
                };
            } else {
                script.onload = onLoadFn;
            }
            script.src = url;
            document.getElementsByTagName('head')[0].appendChild(script);
            return script;
        }

        if (!$.isArray(scripts)) scripts = scripts.split(",");
        var ubound = scripts.length - 1,
        cursor = 0;
        doLoad();

        function doLoad() {
            if (cursor <= ubound) {
                load(scripts[cursor], function () {
                    cursor++;
                    doLoad();
                });
            } else {
                callback();
            }
        }
    },
    loadCss: function loadCss(url) {
        var me = this;
        if ($.isArray(url)) {
            url.forEach(function (u) {
                me.loadCss(u);
            });
            return;
        }
        if (!loadedScripts[url]) {
            $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', url));
            loadedScripts[url] = true;
        }
    } };exports.default =

funs;

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_vue__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_aaaf410e_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_attachment_vue__ = __webpack_require__(1033);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_aaaf410e_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_attachment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"5px","border":"1px solid #ddd","border-bottom":"0px"}},[_c('mw-dialog',{ref:"pageDialog",attrs:{"size":"mini_mini","appendToBody":true,"title":_vm.$lang('请编辑纸质附件名称'),"footerButton":_vm.footerButton}},[_c('div',{staticStyle:{"padding-top":"5px"}},[_c('el-input',{attrs:{"rows":6,"type":"textarea","placeholder":_vm.$lang('请输入内容')},model:{value:(_vm.paperItems),callback:function ($$v) {_vm.paperItems=$$v},expression:"paperItems"}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"15px","color":"red","padding-top":"5px"}},[_vm._v(_vm._s(_vm.$lang("多个附件请按回车换行！")))])],1)]),_vm._v(" "),_c('mw-dialog',{ref:"sendDialog",attrs:{"size":"mini_mini","appendToBody":true,"title":_vm.$lang('附件发送设置'),"footerButton":_vm.sendFooterButton}},[_c('div',{staticStyle:{"padding-top":"5px"}})]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#ececec","line-height":"35px","padding-left":"5px"}},[_vm._v("\n    "+_vm._s(_vm.$lang("附件列表"))+"："),_c('el-button',{on:{"click":function($event){return _vm.showAttachment($event)}}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(_vm._s(_vm.$lang("附件管理")))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPager && _vm.editMode),expression:"showPager && editMode"}],on:{"click":function($event){return _vm.showPaper($event)}}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(_vm._s(_vm.$lang("纸质附件")))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSet),expression:"showSet"}],on:{"click":function($event){return _vm.showSend($event)}}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(_vm._s(_vm.$lang("附件发送设置")))]),_vm._v(" "),(_vm.showTable)?_c('el-button',{staticStyle:{"float":"right","background":"none","border":"none","margin-top":"2px","padding":"7px 3px"},attrs:{"icon":"fa fa-chevron-up"},on:{"click":function($event){_vm.showTable =!_vm.showTable}}}):_c('el-button',{staticStyle:{"float":"right","background":"none","border":"none","margin-top":"2px","padding":"7px 3px"},attrs:{"icon":"fa fa-chevron-down"},on:{"click":function($event){_vm.showTable =!_vm.showTable}}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTable),expression:"showTable"}],staticStyle:{"width":"100%"}},[_c('mw-table',{ref:"attachTable",attrs:{"data":_vm.attachData,"columns":_vm.attachColumns,"pagination":false,"defaultParams":_vm.attachDefaultParams,"defaultParamsAutoLoad":true,"autoLoad":false}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_list_min_vue__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_list_min_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_list_min_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_list_min_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_list_min_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_d65b73a6_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_attachment_list_min_vue__ = __webpack_require__(1036);
function injectStyle (ssrContext) {
  __webpack_require__(1035)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d65b73a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_list_min_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_d65b73a6_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_attachment_list_min_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"upload"},[(_vm.limit === 1 && _vm.list === 'false')?_c('div',[(_vm.imageUrl)?_c('div',{staticClass:"box"},[_c('img',{staticClass:"avatar",style:(_vm.avatarStyle),attrs:{"src":_vm.imageUrl}}),_vm._v(" "),(_vm.editMode)?_c('div',{staticClass:"box-content",attrs:{"slot":"tip"},slot:"tip"},[_c('ul',{staticClass:"icon"},[_c('li',{ref:"plusUploaderBtn",attrs:{"title":_vm.$lang('添加')},on:{"click":_vm.showUploadDlg}},[_vm._m(0)]),_vm._v(" "),_c('li',{attrs:{"title":_vm.$lang('下载')},on:{"click":function($event){return _vm.downloadAttachment(_vm.fileList[0])}}},[_vm._m(1)]),_vm._v(" "),(_vm.recordIsCanEdit(_vm.fileList[0]))?_c('li',{attrs:{"title":_vm.$lang('删除')},on:{"click":function($event){return _vm.beforeRemove(_vm.fileList[0])}}},[_vm._m(2)]):_vm._e()])]):_vm._e()]):(_vm.editMode)?_c('el-button',{ref:"uploaderBtn",attrs:{"size":"small","type":_vm.type,"plain":_vm.plain},on:{"click":_vm.showUploadDlg}},[(!!_vm.icon)?_c('i',{class:_vm.icon,style:({margin:_vm.label?undefined:"0",padding:_vm.label?undefined:"0"})}):_vm._e(),_vm._v(_vm._s(_vm.label)+"\n    ")]):_vm._e()],1):_c('div',[(_vm.editMode)?_c('el-button',{ref:"uploaderBtn",attrs:{"size":"small","type":_vm.type,"plain":_vm.plain},on:{"click":_vm.showUploadDlg}},[(!!_vm.icon)?_c('i',{class:_vm.icon,style:({margin:_vm.label?undefined:"0",padding:_vm.label?undefined:"0"})}):_vm._e(),_vm._v(_vm._s(_vm.label)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.editMode && _vm.flag== true)?_c('el-progress',{staticStyle:{"margin-top":"5px"},attrs:{"percentage":_vm.uploadPercent,"format":"format"}}):_vm._e(),_vm._v(" "),_c('div',[_c('ul',{staticClass:"el-upload-list el-upload-list--text"},_vm._l((_vm.fileList),function(item){return _c('li',{staticClass:"el-upload-list__item is-success uploadList",staticStyle:{"position":"relative"}},[_c('a',{staticClass:"el-upload-list__item-name",attrs:{"name":item.id},on:{"click":function($event){return _vm.downloadAttachment(item)}}},[_c('i',{staticClass:"el-icon-document"}),_vm._v(_vm._s(item.name)+"\n          ")]),_vm._v(" "),_vm._m(3,true),_vm._v(" "),(_vm.editMode && _vm.recordIsCanEdit(item))?_c('i',{staticClass:"el-icon-close ele-icon",on:{"click":function($event){return _vm.beforeRemove(item)}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.imageUrl),expression:"item.imageUrl"}],staticStyle:{"margin-bottom":"5px"}},[_c('img',{staticClass:"avatar",style:(_vm.avatarStyle),attrs:{"src":item.imageUrl}})])])}),0)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"el-icon-plus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"background":"#67C23A"},attrs:{"href":"#"}},[_c('i',{staticClass:"el-icon-download"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"background":"#E6A23C"},attrs:{"href":"#"}},[_c('i',{staticClass:"el-icon-close"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"el-upload-list__item-status-label"},[_c('i',{staticClass:"el-icon-upload-success el-icon-circle-check ele-icon"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_vue__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5b10e35e_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_comment_vue__ = __webpack_require__(1038);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5b10e35e_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_comment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"5px","border":"1px solid #ddd","border-bottom":"0px"}},[_c('div',{staticStyle:{"background-color":"#ececec","line-height":"35px","padding-left":"5px"}},[_vm._v("\n    "+_vm._s(_vm.$lang("意见列表"))+"："),_c('el-button',{on:{"click":function($event){return _vm.refreshComment($event)}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(_vm._s(_vm.$lang("刷新")))]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.showFlowChatDialog($event)}}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v(_vm._s(_vm.$lang("流程图示")))]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.showTransactionDialog($event)}}},[_c('i',{staticClass:"fa fa-sitemap"}),_vm._v(_vm._s(_vm.$lang("办理过程")))]),_vm._v(" "),(!_vm.hideOprLog)?_c('el-button',{on:{"click":function($event){return _vm.showOperationRecordDialog($event)}}},[_c('i',{staticClass:"fa fa-sitemap"}),_vm._v(_vm._s(_vm.$lang("操作记录")))]):_vm._e(),_vm._v(" "),(_vm.showTable)?_c('el-button',{staticStyle:{"float":"right","background":"none","border":"none","margin-top":"2px","padding":"7px 3px"},attrs:{"icon":"fa fa-chevron-up"},on:{"click":function($event){_vm.showTable =!_vm.showTable}}}):_c('el-button',{staticStyle:{"float":"right","background":"none","border":"none","margin-top":"2px","padding":"7px 3px"},attrs:{"icon":"fa fa-chevron-down"},on:{"click":function($event){_vm.showTable =!_vm.showTable}}})],1),_vm._v(" "),_c('mw-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTable),expression:"showTable"}],ref:"commentTable",attrs:{"api":_vm.api,"columns":_vm.columns,"pagination":false,"nowrap":false,"defaultParams":_vm.defaultParams,"defaultParamsAutoLoad":true,"autoLoad":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_min_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_min_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_min_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_min_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_min_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0b6abca6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_comment_min_vue__ = __webpack_require__(1040);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_min_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0b6abca6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_comment_min_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.previewMode)?_c('img',{attrs:{"src":"data:image/png;base64,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"}}):_vm._e(),_vm._v(" "),(!_vm.previewMode)?_c('div',[_c('div',{ref:"container",domProps:{"innerHTML":_vm._s(_vm.comment)}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_imbeddedView_vue__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_imbeddedView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_imbeddedView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_imbeddedView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_imbeddedView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_771292b5_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_imbeddedView_vue__ = __webpack_require__(1042);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_imbeddedView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_771292b5_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_imbeddedView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"innerView",staticStyle:{"margin-top":"5px","border":"1px solid #ddd"},style:({height:_vm.height})},[_c('mw-view',{ref:"view",attrs:{"id":_vm.viewId,"tableParams":_vm.tableParams,"params":_vm.formConfig,"formValue":_vm.formValue}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_document_editor_vue__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_document_editor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_document_editor_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_document_editor_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_document_editor_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_31aa541d_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_document_editor_vue__ = __webpack_require__(1044);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_document_editor_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_31aa541d_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_document_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[(_vm.showEditor)?_c('mw-ntko-editor',{ref:"editor",attrs:{"defButtons":_vm.buttons,"propObject":_vm.propObject}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rel_file_selection_vue__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rel_file_selection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rel_file_selection_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rel_file_selection_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rel_file_selection_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_66b41684_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_rel_file_selection_vue__ = __webpack_require__(1047);
function injectStyle (ssrContext) {
  __webpack_require__(1046)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rel_file_selection_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_66b41684_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_rel_file_selection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"5px 0","border":"1px solid #ddd","border-bottom":"0px"}},[_c('div',{staticStyle:{"background-color":"#ececec","line-height":"35px","padding-left":"5px"}},[_vm._v("\n      "+_vm._s(_vm.$lang("关联文件列表"))+"："),(_vm.editMode)?_c('el-button',{on:{"click":_vm.showDialog}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(_vm._s(_vm.$lang("添加关联")))]):_vm._e(),_vm._v(" "),(_vm.editMode)?_c('el-button',{on:{"click":_vm.deleteFile}},[_c('i',{staticClass:"el-icon-delete"}),_vm._v(_vm._s(_vm.$lang("删除")))]):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTable),expression:"showTable"}],staticStyle:{"width":"100%"}},[_c('mw-table',{ref:"relFileTable",attrs:{"api":_vm.api,"columns":_vm.attachColumns,"pagination":false,"defaultParams":_vm.defaultParams,"defaultParamsAutoLoad":true,"autoLoad":false}})],1),_vm._v(" "),_c('mw-dialog',{ref:"relDialog",attrs:{"size":"small_large","title":_vm.$lang('选择关联文件'),"footerButton":_vm.footerButton}},[_c('div',{staticClass:"rellife"},[_c('el-form',{ref:"formName",attrs:{"label-width":"7em"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('拟稿时间'),"prop":"createTime"}},[_c('el-radio-group',{model:{value:(_vm.form.createTime),callback:function ($$v) {_vm.$set(_vm.form, "createTime", $$v)},expression:"form.createTime"}},[_c('el-radio',{attrs:{"label":"shortcut"}},[_vm._v(_vm._s(_vm.$lang("快捷时间段")))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"period"}},[_vm._v(_vm._s(_vm.$lang("时间范围")))])],1)],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.createTime === 'shortcut'),expression:"form.createTime === 'shortcut'"}],attrs:{"span":24}},[_c('el-form-item',[_c('el-radio-group',{on:{"change":_vm.handleTime},model:{value:(_vm.form.shortcut),callback:function ($$v) {_vm.$set(_vm.form, "shortcut", $$v)},expression:"form.shortcut"}},[_c('el-row',{staticStyle:{"margin-bottom":"17px"}},[_c('el-radio',{attrs:{"label":"day"}},[_vm._v(_vm._s(_vm.$lang('最近一天')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"week"}},[_vm._v(_vm._s(_vm.$lang('最近一周')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"month"}},[_vm._v(_vm._s(_vm.$lang('最近一月')))])],1),_vm._v(" "),_c('el-row',[_c('el-radio',{attrs:{"label":"halfyear"}},[_vm._v(_vm._s(_vm.$lang("最近半年")))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"oneyear"}},[_vm._v(_vm._s(_vm.$lang('最近一年')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"threeyear"}},[_vm._v(_vm._s(_vm.$lang('最近三年')))])],1)],1)],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.createTime === 'period'),expression:"form.createTime === 'period'"}],attrs:{"span":24}},[_c('el-form-item',{attrs:{"prop":"period"}},[_c('el-col',{attrs:{"span":24}},[[_c('el-date-picker',{attrs:{"type":"date","placeholder":_vm.$lang('选择日期'),"picker-options":_vm.pickerBeginDateBefore},model:{value:(_vm.form.startDate),callback:function ($$v) {_vm.$set(_vm.form, "startDate", $$v)},expression:"form.startDate"}})],_vm._v("\n               "+_vm._s(_vm.$lang('至'))+"\n               "),_c('el-date-picker',{attrs:{"type":"date","placeholder":_vm.$lang('选择日期'),"picker-options":_vm.pickerBeginDateAfter},model:{value:(_vm.form.finishDate),callback:function ($$v) {_vm.$set(_vm.form, "finishDate", $$v)},expression:"form.finishDate"}})],2)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('搜索范围'),"prop":"searchRange"}},[_c('el-radio-group',{model:{value:(_vm.form.searchRange),callback:function ($$v) {_vm.$set(_vm.form, "searchRange", $$v)},expression:"form.searchRange"}},[_c('el-radio',{attrs:{"label":"system"}},[_vm._v(_vm._s(_vm.$lang('整个系统')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"dept"}},[_vm._v(_vm._s(_vm.$lang('整个单位')))])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('文件类型'),"prop":"mixId"}},[_c('el-select',{attrs:{"placeholder":_vm.$lang('请选择')},model:{value:(_vm.form.mixId),callback:function ($$v) {_vm.$set(_vm.form, "mixId", $$v)},expression:"form.mixId"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":15}},[_c('el-form-item',{attrs:{"label":_vm.$lang('关键字'),"prop":"titleLike"}},[_c('el-input',{model:{value:(_vm.form.titleLike),callback:function ($$v) {_vm.$set(_vm.form, "titleLike", $$v)},expression:"form.titleLike"}},[_c('el-button',{directives:[{name:"waves",rawName:"v-waves"}],attrs:{"slot":"append","type":"primary"},on:{"click":function($event){return _vm.search()}},slot:"append"},[_vm._v(_vm._s(_vm.$lang('查询')))])],1)],1)],1)],1),_vm._v(" "),_c('mw-table',{ref:"findTable",staticClass:"tableStyle",style:(_vm.templateStyle),attrs:{"columns":_vm.findColumns,"pagination":false,"data":_vm.tableData,"autoLoad":false,"defaultParamsAutoLoad":true}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_206f7f82_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1049);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_206f7f82_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_complete_vue__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_complete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_complete_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_complete_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_complete_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2bf927da_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_complete_vue__ = __webpack_require__(1054);
function injectStyle (ssrContext) {
  __webpack_require__(1051)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_complete_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2bf927da_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_complete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_selected_vue__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_selected_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_selected_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_selected_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_selected_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8df9c662_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_selected_vue__ = __webpack_require__(1053);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_selected_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8df9c662_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_selected_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[(_vm.search)?_c('div',{staticClass:"mw-tree-search"},[_c('el-input',{attrs:{"placeholder":_vm.$lang('请输入搜索内容'),"clearable":""},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1):_vm._e(),_vm._v(" "),_c('div',{class:{'mw-tree-search__body':_vm.search,'mw-tree-no-search__body':!_vm.search}},[_c('div',{staticClass:"mw-tree"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"form","title":_vm.title,"appendToBody":false,"footerButton":_vm.footerButton,"customClass":"mw-flow-complete","beforeClose":_vm.beforeClose}},[_c('div',{ref:"abc",staticClass:"__form_content"},[_c('el-row',{staticClass:"__comment_top",class:{'comment-expend':_vm.isCommentExpaned}},[_c('el-col',{staticClass:"__direction",attrs:{"span":7}},[_c('div',{staticClass:"__left-box",class:{'__not_notice':!_vm.showCircular}},[_c('div',{staticClass:"__notice_top",class:{'__flow_panel_01':(_vm.showNormal && !_vm.showSubProcess),
          '__flow_panel_02':(!_vm.showNormal && _vm.showSubProcess)}},[(_vm.showNormal)?_c('div',{staticClass:"__left01"},[_c('div',{staticClass:"__panel"},[_c('div',{staticClass:"__panel-heading"},[_vm._v(_vm._s(_vm.$lang("下一环节(单选)")))]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},_vm._l((_vm.normalFlow),function(n){return _c('li',{staticClass:"__item",class:{'__active':(_vm.curFlowId==n.id),'__disable':n.$disabled?n.$disabled:false},attrs:{"title":_vm.transFlowName(n.name)},domProps:{"innerHTML":_vm._s(_vm.transFlowName(n.name))},on:{"click":function($event){return _vm.flowClick(n,$event,'normal')}}})}),0)])]):_vm._e(),_vm._v(" "),(_vm.showSubProcess)?_c('div',{staticClass:"__left02"},[_c('div',{staticClass:"__panel"},[_c('div',{staticClass:"__panel-heading",staticStyle:{"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}},[_vm._v(_vm._s(_vm.$lang("并行发送(多选)")))]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},_vm._l((_vm.subProcessFlow),function(n){return _c('li',{staticClass:"__item",class:{'__active':(_vm.curFlowId==n.id),'__disable':n.$disabled?n.$disabled:false},attrs:{"title":_vm.transFlowName(n.name)},domProps:{"innerHTML":_vm._s(_vm.transFlowName(n.name))},on:{"click":function($event){return _vm.flowClick(n,$event,'sub')}}})}),0)])]):_vm._e(),_vm._v(" "),(!_vm.showNormal && !_vm.showSubProcess)?_c('div',{staticClass:"mw-panel"},[_c('div',[_vm._v(_vm._s(_vm.$lang("未获取到符合条件的流向信息")))])]):_vm._e()]),_vm._v(" "),(_vm.showCircular)?_c('div',{staticClass:"__notice"},[_c('div',{staticClass:"__panel"},[_c('div',{staticClass:"__panel-heading"},[_vm._v(_vm._s(_vm.$lang("传阅")))]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},_vm._l((_vm.circularFlow),function(n){return _c('li',{staticClass:"__item",class:{'__active':(_vm.curFlowId==n.id)},domProps:{"innerHTML":_vm._s(_vm.transFlowName(n.name))},on:{"click":function($event){return _vm.flowClick(n,$event,'circular')}}})}),0)])]):_vm._e()])]),_vm._v(" "),_c('el-col',{staticClass:"__col-h100",attrs:{"span":17}},[_c('el-row',{staticClass:"__col-h100"},[_c('el-col',{staticClass:"__col-h100",attrs:{"span":11}},[_c('div',{staticClass:"__panel __tree-panel"},[_c('div',{staticClass:"__panel-heading"},[_c('div',{staticStyle:{"display":"inline-block","width":"calc(100% - 250px)","white-space":"nowrap","text-overflow":"ellipsis","overflow":"hidden"}},[_vm._v(_vm._s(_vm.$lang("备选"))+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"pull-right",staticStyle:{"width":"250px","overflow":"hidden","white-space":"nowrap","height":"30px"}},[_vm._v("("+_vm._s(_vm.$lang("双击移入"))+">>) \n                    "),(_vm.showSelectAllBtn)?_c('el-checkbox',{staticStyle:{"font-size":"12px","margin-right":"50px"},on:{"change":_vm.selectAll},model:{value:(_vm.checkedSelectAll),callback:function ($$v) {_vm.checkedSelectAll=$$v},expression:"checkedSelectAll"}},[_vm._v("全选")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},_vm._l((_vm.deptTreePanel),function(value,key){return (value.vif)?_c('mw-complete-tree',{directives:[{name:"show",rawName:"v-show",value:(value.vshow),expression:"value.vshow"}],key:key,ref:'tree'+key,refInFor:true,attrs:{"rootData":value.rootData,"autoSelectSingle":true,"autoSelectData":_vm.autoSelectData,"url":value.url,"defaultParams":value.defaultParams,"businessId":_vm.params.businessId,"batchId":_vm.params.batchId,"activityId":value.activityId,"async":true,"multiple":value.multiple,"expandedFirst":true,"taskId":_vm.params.taskId,"type":value.type,"flowCount":_vm.flowCount},on:{"dblClick":_vm.dblClick}}):_vm._e()}),1)])]),_vm._v(" "),_c('el-col',{staticClass:"__col-h100",attrs:{"span":2}},[_c('div',{staticClass:"__sel"},[_c('el-button',{staticClass:"__btn",attrs:{"type":"primary","title":_vm.$lang('选择')},on:{"click":_vm.selectClick}},[_vm._v(">>")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('el-button',{staticClass:"__btn",attrs:{"type":"primary","title":_vm.$lang('移除')},on:{"click":_vm.deselectClick}},[_vm._v("<<")])],1)]),_vm._v(" "),_c('el-col',{staticClass:"__col-h100",attrs:{"span":11}},[_c('div',{staticClass:"__panel __tree-panel"},[_c('div',{staticClass:"__panel-heading"},[_vm._v(_vm._s(_vm.$lang("选中"))+"("+_vm._s(_vm.$lang("双击移出"))+")")]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},[_c('mw-complete-selected-tree',{ref:"selectedTree",attrs:{"autoLoad":true,"async":false,"multiple":true,"treeData":_vm.allSelectTreeData,"expandedFirst":true},on:{"dblClick":_vm.dblClickSelected}})],1)])])],1)],1)],1),_vm._v(" "),(!_vm.customBottom)?[_c('el-row',{staticClass:"__comment",class:{'comment-expend':_vm.isCommentExpaned}},[(!_vm.hideAttention)?_c('el-col',{staticClass:"__col-h100",attrs:{"span":5}},[_c('div',{staticClass:"__field-set"},[(_vm.tipOptions.length > 0)?[_c('div',{staticClass:"__title"},[_vm._v(_vm._s(_vm.$lang("提醒")))]),_vm._v(" "),_c('div',[_c('el-checkbox-group',{model:{value:(_vm.tipCheckList),callback:function ($$v) {_vm.tipCheckList=$$v},expression:"tipCheckList"}},[_vm._l((_vm.tipOptions),function(option){return [_c('el-checkbox',{attrs:{"label":option.value}},[_vm._v(_vm._s(_vm.$lang(option.text)))]),_vm._v(" "),(option.canEdit)?_c('span',{staticStyle:{"color":"blue","cursor":"pointer","font-size":"13px"},attrs:{"cname":"notifySMS"},on:{"click":_vm.editMsg}},[_vm._v("编辑")]):_vm._e()]})],2)],1)]:_c('div',{staticClass:"__notice_all"},[_c('div',{staticStyle:{"position":"absolute","width":"150px","height":"40px","top":"50%","margin-top":"-20px","left":"50%","margin-left":"-75px"}},[_c('el-checkbox',{staticStyle:{"overflow":"hidden","text-overflow":"ellipsis"},attrs:{"border":""},model:{value:(_vm.isAddAttention),callback:function ($$v) {_vm.isAddAttention=$$v},expression:"isAddAttention"}},[_vm._v(_vm._s(_vm.$lang("我要关注")))])],1)])],2)]):_vm._e(),_vm._v(" "),_c('el-col',{staticClass:"__col-h100",attrs:{"span":_vm.hideAttention?24:19}},[_c('div',{staticClass:"__field-set",staticStyle:{"margin-right":"0px"}},[_c('div',{staticClass:"__title"},[_vm._v(_vm._s(_vm.$lang("意见")))]),_vm._v(" "),_c('el-input',{staticClass:"__col-h100",staticStyle:{"margin-top":"2px"},attrs:{"type":"textarea","resize":"none","disabled":_vm.disabledComment},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}})],1)])],1)]:[_c('el-row',{ref:"customBottom",staticClass:"__comment",class:{'comment-expend':_vm.isCommentExpaned}})]],2),_vm._v(" "),(!_vm.customBottom)?_c('div',{staticClass:"pull-left",staticStyle:{"display":"inline-block"},attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.toggleCommentExpaned}},[_vm._v(_vm._s(_vm.isCommentExpaned?_vm.$lang("缩小意见框"):_vm.$lang("放大意见框")))])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_reject_vue__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_reject_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_reject_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_reject_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_reject_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0d691d97_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_reject_vue__ = __webpack_require__(1056);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_reject_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0d691d97_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_reject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"small_mini","title":_vm.title,"appendToBody":false,"footerButton":_vm.footerButton,"customClass":"mw-flow-complete","beforeClose":_vm.beforeClose}},[_c('mw-table',{ref:"rejectTable",attrs:{"api":_vm.api,"columns":_vm.columns,"pagination":false,"singleSelect":true,"defaultParams":_vm.defaultParams,"showHeader":false,"defaultParamsAutoLoad":true,"autoLoad":true},on:{"dataLoaded":_vm.dataLoaded}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_transmit_vue__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_transmit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_transmit_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_transmit_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_transmit_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_61c6b260_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_transmit_vue__ = __webpack_require__(1058);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_transmit_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_61c6b260_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_transmit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"mini_small","title":_vm.$lang('选择用户'),"appendToBody":false,"footerButton":_vm.userFooterButton}},[_c('mw-tree',{ref:"userTree",attrs:{"url":_vm.params.treeUrl || _vm.userTreeUrl,"treeData":_vm.params.treeData,"singleLeaf":true,"async":true,"expandedFirst":true,"multiple":false,"search":false,"defaultParams":_vm.defaultParams,"aliasId":_vm.aliasId},on:{"loaded_tree":_vm.loadedTree}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_planned_vue__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_planned_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_planned_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_planned_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_planned_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5f415e3c_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_planned_vue__ = __webpack_require__(1061);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_planned_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5f415e3c_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_planned_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[(_vm.search)?_c('div',{staticClass:"mw-tree-search"},[_c('el-input',{attrs:{"placeholder":_vm.$lang('请输入搜索内容'),"clearable":""},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1):_vm._e(),_vm._v(" "),_c('div',{class:{'mw-tree-search__body':_vm.search,'mw-tree-no-search__body':!_vm.search}},[_c('div',{staticClass:"mw-tree"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"form","title":_vm.title,"appendToBody":false,"footerButton":_vm.footerButton,"customClass":"mw-flow-complete","beforeClose":_vm.beforeClose}},[_c('div',{staticClass:"__form_content"},[(_vm.fCount> 1)?[_c('el-row',{staticClass:"__comment_top __col-h100"},[_c('el-col',{staticClass:"__col-h100"},[_c('div',{staticClass:"__left-box",staticStyle:{"margin-right":"0px"}},[_vm._l((_vm.workFlows),function(flow){return [_c('el-row',{ref:'row'+flow.id,refInFor:true,style:(_vm.rowStyle)},[_c('el-col',{staticClass:"__col-h100",attrs:{"span":12}},[_c('div',{staticClass:"__panel __tree-panel"},[_c('div',{staticClass:"__panel-heading"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$lang(flow.name))}}),_c('span',{staticClass:"pull-right",staticStyle:{"padding-right":"5px"}},[_vm._v("("+_vm._s(_vm.$lang("双击移入"))+">>)")])]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},[_c('mw-li-tree',{ref:'candidate'+flow.id,refInFor:true,attrs:{"autoLoad":true,"async":false,"multiple":false,"treeData":_vm.candidates[flow.id]},on:{"dblClick":_vm.dblClick}})],1)])]),_vm._v(" "),_c('el-col',{staticClass:"__col-h100",staticStyle:{"padding-left":"5px"},attrs:{"span":12}},[_c('div',{staticClass:"__panel __tree-panel"},[_c('div',{staticClass:"__panel-heading"},[_vm._v(_vm._s(_vm.$lang("已选"))),_c('span',{staticClass:"pull-right",staticStyle:{"padding-right":"5px"}},[_vm._v("("+_vm._s(_vm.$lang("双击移出"))+")")])]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},[_c('mw-li-tree',{ref:'planned'+flow.id,refInFor:true,attrs:{"autoLoad":true,"async":false,"multiple":false,"treeData":_vm.planneds[flow.id]},on:{"dblClick":_vm.dblClickSelected}})],1)])])],1)]})],2)])],1),_vm._v(" "),_c('el-row',{staticClass:"__comment"},[_c('el-col',{staticClass:"__col-h100"},[_c('div',{staticClass:"__field-set",staticStyle:{"margin-right":"0px"}},[_c('div',{staticClass:"__title"},[_vm._v(_vm._s(_vm.$lang("意见"))+"："),_c('el-button',{attrs:{"type":"default","size":"mini"},on:{"click":function($event){return _vm.plannedComment()}}},[_vm._v(_vm._s(_vm.$lang("生成拟办意见")))])],1),_vm._v(" "),_c('el-input',{staticClass:"__col-h100",staticStyle:{"margin-top":"2px"},attrs:{"type":"textarea","resize":"none"},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}})],1)])],1)]:_vm._e(),_vm._v(" "),(_vm.fCount< 1)?[_c('div',{staticClass:"__sel"},[_c('span',{staticClass:"__btn"},[_vm._v(_vm._s(_vm.$lang("未获取到符合条件的流向信息")))])])]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrack_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrack_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrack_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrack_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrack_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7e6aa631_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_worktrack_vue__ = __webpack_require__(1067);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrack_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7e6aa631_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_worktrack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{style:(_vm.rowStyle)},[_c('el-col',{staticClass:"__col-h100",attrs:{"span":6}},[_c('div',{staticClass:"__panel __tree-panel"},[_c('div',{staticClass:"__panel-heading"},[_c('span',{staticStyle:{"display":"inline-block","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis","width":"calc(100% - 90px)"},attrs:{"title":_vm.$lang(_vm.flowName)},domProps:{"innerHTML":_vm._s(_vm.$lang(_vm.flowName))}}),_vm._v(" "),_c('span',{staticClass:"pull-right",staticStyle:{"padding-right":"5px","width":"90px","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}},[_vm._v("("+_vm._s(_vm.$lang("双击移入"))+">>)")])]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},[_c('mw-li-tree',{ref:'candidate'+_vm.flowId,attrs:{"autoLoad":true,"async":false,"multiple":false,"treeData":_vm.candidates},on:{"dblClick":_vm.dblClick,"beforeDataFilter":_vm.candidateDataHandle}})],1)])]),_vm._v(" "),_c('el-col',{staticClass:"__col-h100",staticStyle:{"padding-left":"5px"},attrs:{"span":5}},[_c('div',{staticClass:"__panel __tree-panel"},[_c('div',{staticClass:"__panel-heading"},[_vm._v(_vm._s(_vm.$lang("已选"))),_c('span',{staticClass:"pull-right",staticStyle:{"padding-right":"5px","width":"calc(100% - 60px)","text-align":"right","text-overflow":"ellipsis","overflow":"hidden","white-space":"nowrap"}},[_vm._v("("+_vm._s(_vm.$lang("双击移出"))+")")])]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},[_c('mw-li-tree',{ref:'planned'+_vm.flowId,attrs:{"autoLoad":true,"async":false,"multiple":true,"treeData":_vm.planneds},on:{"dblClick":_vm.dblClickSelected}})],1)])]),_vm._v(" "),_c('el-col',{staticClass:"__col-h100",attrs:{"span":2}},[_c('div',{staticClass:"__sel"},[_c('el-button',{staticClass:"__btn",staticStyle:{"padding-bottom":"5px"},attrs:{"type":"primary","leading":_vm.sendBtnLeading},on:{"click":function($event){return _vm.sendClick()}}},[_vm._v(_vm._s(_vm.$lang("发送"))+">>")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('el-button',{staticClass:"__btn",staticStyle:{"padding-top":"5px"},attrs:{"leading":_vm.takenBtnLeading},on:{"click":function($event){return _vm.takenClick()}}},[_vm._v(_vm._s(_vm.$lang("取回")))])],1)]),_vm._v(" "),_c('el-col',{staticClass:"__col-h100",attrs:{"span":5}},[_c('div',{staticClass:"__panel __tree-panel"},[_c('div',{staticClass:"__panel-heading"},[_vm._v(_vm._s(_vm.$lang("在办")))]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},[_c('mw-li-tree',{ref:'doing'+_vm.flowId,attrs:{"autoLoad":true,"async":false,"multiple":true,"treeData":_vm.doings,"isDblClickDeleteNode":false}})],1)])]),_vm._v(" "),_c('el-col',{staticClass:"__col-h100",staticStyle:{"padding-left":"5px"},attrs:{"span":5}},[_c('div',{staticClass:"__panel __tree-panel"},[_c('div',{staticClass:"__panel-heading"},[_vm._v(_vm._s(_vm.$lang("办毕")))]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},_vm._l((_vm.finisheds),function(n){return _c('li',{staticClass:"__item",domProps:{"innerHTML":_vm._s(n.name)}})}),0)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_level_vue__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_level_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_level_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_level_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_level_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4d189bd8_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_level_vue__ = __webpack_require__(1065);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_level_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4d189bd8_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_level_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[(_vm.search)?_c('div',{staticClass:"mw-tree-search"},[_c('el-input',{attrs:{"placeholder":_vm.$lang('请输入搜索内容'),"clearable":""},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1):_vm._e(),_vm._v(" "),_c('div',{class:{'mw-tree-search__body':_vm.search,'mw-tree-no-search__body':!_vm.search}},[_c('div',{staticClass:"mw-tree"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{style:(_vm.rowStyle)},[_c('el-col',{staticClass:"__col-h100",attrs:{"span":10}},[_c('div',{staticClass:"__panel __tree-panel"},[_c('div',{staticClass:"__panel-heading"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$lang(_vm.flowName))}})]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},[[(true)?_c('mw-level-tree',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],key:_vm.flowId,ref:'candidate'+_vm.flowId,attrs:{"type":_vm.flowType,"url":_vm.url,"appendRefresh":_vm.appendRefresh,"defaultParams":_vm.defaultParams,"businessId":_vm.params.businessId,"activityId":_vm.activityId,"async":true,"autoLoad":true,"multiple":true,"expandedFirst":true,"flowCount":1},on:{"beforeDataFilter":_vm.treeDataFilter}}):_vm._e()]],2)])]),_vm._v(" "),_c('el-col',{staticClass:"__col-h100",attrs:{"span":2}},[_c('div',{staticClass:"__sel"},[_c('el-button',{staticClass:"__btn",staticStyle:{"padding-bottom":"5px"},attrs:{"type":"primary","leading":_vm.sendBtnLeading},on:{"click":function($event){return _vm.sendClick()}}},[_vm._v(_vm._s(_vm.$lang("发送"))+">>")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('el-button',{staticClass:"__btn",staticStyle:{"padding-top":"5px"},attrs:{"leading":_vm.takenBtnLeading},on:{"click":function($event){return _vm.takenClick()}}},[_vm._v("<<"+_vm._s(_vm.$lang("取回")))])],1)]),_vm._v(" "),_c('el-col',{staticClass:"__col-h100",attrs:{"span":6}},[_c('div',{staticClass:"__panel __tree-panel"},[_c('div',{staticClass:"__panel-heading"},[_vm._v(_vm._s(_vm.$lang("在办")))]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},[_c('mw-li-tree',{ref:'doing'+_vm.flowId,attrs:{"autoLoad":true,"async":false,"multiple":true,"treeData":_vm.doings}})],1)])]),_vm._v(" "),_c('el-col',{staticClass:"__col-h100",staticStyle:{"padding-left":"5px"},attrs:{"span":6}},[_c('div',{staticClass:"__panel __tree-panel"},[_c('div',{staticClass:"__panel-heading"},[_vm._v(_vm._s(_vm.$lang("办毕")))]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},_vm._l((_vm.finisheds),function(n){return _c('li',{staticClass:"__item",domProps:{"innerHTML":_vm._s(n.name)}})}),0)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"form","appendToBody":false,"title":_vm.title,"footerButton":_vm.footerButton,"customClass":"mw-flow-complete","beforeClose":_vm.beforeClose}},[_c('div',{staticClass:"__form_content"},[(false)?[_c('div',{staticClass:"__sel"},[_c('span',{staticClass:"__btn"},[_vm._v(_vm._s(_vm.$lang("未获取到符合条件的流向信息")))])])]:_vm._e(),_vm._v(" "),_vm._l((_vm.workFlows),function(flow){return [(flow.options.workShowTree)?[_c('mw-wt-tree',{ref:'wt'+flow.id,refInFor:true,attrs:{"rowStyle":_vm.rowStyle,"flowId":flow.id,"flowName":flow.name,"flowType":flow.type,"params":_vm.params,"activityId":flow.activityId,"url":flow.url,"appendRefresh":flow.appendRefresh,"doings":_vm.doings[flow.id],"finisheds":flow.finisheds,"options":flow.options}})]:_vm._e(),_vm._v(" "),(!flow.options.workShowTree)?[_c('mw-wt-li',{ref:'wt'+flow.id,refInFor:true,attrs:{"rowStyle":_vm.rowStyle,"flowId":flow.id,"flowName":flow.name,"flowType":flow.type,"params":_vm.params,"activityId":flow.activityId,"candidates":_vm.candidates[flow.id],"planneds":_vm.planneds[flow.id],"doings":_vm.doings[flow.id],"finisheds":_vm.finisheds[flow.id],"options":flow.options}})]:_vm._e()]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrackLi_vue__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrackLi_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrackLi_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrackLi_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrackLi_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_b8aa6850_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_worktrackLi_vue__ = __webpack_require__(1069);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrackLi_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_b8aa6850_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_worktrackLi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"form","appendToBody":false,"title":_vm.title,"footerButton":_vm.footerButton,"customClass":"mw-flow-complete","beforeClose":_vm.beforeClose}},[_c('div',{staticClass:"__form_content"},[(false)?[_c('div',{staticClass:"__sel"},[_c('span',{staticClass:"__btn"},[_vm._v(_vm._s(_vm.$lang("未获取到符合条件的流向信息")))])])]:_vm._e(),_vm._v(" "),_vm._l((_vm.workFlows),function(flow){return [_c('mw-wt-li',{ref:'wtli'+flow.id,refInFor:true,attrs:{"rowStyle":_vm.rowStyle,"flowId":flow.id,"flowName":flow.name,"flowType":flow.type,"params":_vm.params,"activityId":flow.activityId,"candidates":_vm.candidates[flow.id],"planneds":_vm.planneds[flow.id],"doings":_vm.doings[flow.id],"finisheds":flow.finisheds,"options":flow.options}})]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrackTree_vue__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrackTree_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrackTree_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrackTree_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrackTree_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0cd57694_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_worktrackTree_vue__ = __webpack_require__(1071);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktrackTree_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0cd57694_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_worktrackTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"form","appendToBody":false,"title":_vm.title,"footerButton":_vm.footerButton,"customClass":"mw-flow-complete","beforeClose":_vm.beforeClose}},[_c('div',{staticClass:"__form_content"},[(false)?[_c('div',{staticClass:"__sel"},[_c('span',{staticClass:"__btn"},[_vm._v(_vm._s(_vm.$lang("未获取到符合条件的流向信息")))])])]:_vm._e(),_vm._v(" "),_vm._l((_vm.workFlows),function(flow){return [_c('mw-wt-tree',{attrs:{"rowStyle":_vm.rowStyle,"flowId":flow.id,"flowName":flow.name,"flowType":flow.type,"params":_vm.params,"activityId":flow.activityId,"url":flow.url,"doings":_vm.doings[flow.id],"finisheds":flow.finisheds,"options":flow.options}})]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_virtuallog_vue__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_virtuallog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_virtuallog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_virtuallog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_virtuallog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6e1fc8c8_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_virtuallog_vue__ = __webpack_require__(1074);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_virtuallog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6e1fc8c8_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_virtuallog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);var _li = __webpack_require__(115);var _li2 = _interopRequireDefault(_li);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
{
  components: {
    MwLiTree: _li2.default },

  props: {
    params: {
      type: Object } },


  data: function data() {
    var me = this,commentId = $uuid();
    return {
      title: $lang('虚拟日志'),
      commentId: commentId,
      commentCategory: '',
      leading: 1,
      isAgentRecord: 1,
      agentType: 'SECRETARY',
      agentRecordActs: [],
      form: {
        comment: '',
        agentRecordActId: '' },

      formRules: {
        comment: [{ required: true, message: $lang("请输入办理意见"), trigger: "blur" }] },

      footerButton: [
      {
        label: $lang("关闭"),
        type: "default",
        func: me.close },

      {
        label: $lang("确定"),
        func: me.submit }],


      srcAgentRecordActs: [],
      currentArActId: '',
      currentCandidates: [],
      currentPlannedes: [],
      cpActivities: {} };

  },
  mounted: function mounted() {var _this = this;
    var me = this;
    setTimeout(function () {
      _this.show();
    }, 200);
    me.commentId = $uuid();
    me.commentCategory = me.params.activity.commentCategory;
    me.form.comment = '';
    me.init();
  },
  watch: {
    params: function params() {
      this.init();
    } },

  methods: {
    init: function init() {
      var me = this;
      me.mwApi.process.getFlows(me.params.taskId, me.params).then(function (res) {

        var srcAgentRecordFlowIds = me.params.agentRecordFlowIds;
        me.agentRecordActs = [];

        if (res.success && res.result) {
          var flows = res.result;
          var fi = 0;
          flows.forEach(function (f) {








            srcAgentRecordFlowIds.forEach(function (arf) {
              if (arf == f.id) {
                var act = { id: f.activityId, name: f.activityName, flowId: f.id };
                me.srcAgentRecordActs[f.activityId] = act;
                me.agentRecordActs[fi++] = act;
              }
            });
          });
          if (me.agentRecordActs.length > 0) {
            me.form.agentRecordActId = me.agentRecordActs[0].id;
            me.currentArActId = me.agentRecordActs[0].id;
            me._getCurrentArActivityCandidates();
          }
        }
      });
    },
    setBtnLoading: function setBtnLoading(loading, idx) {
      this.footerButton[idx].loading = loading;
    },
    btnDebounce: _.debounce(function (callback) {
      var me = this;
      if (callback) {
        callback();
      }
    }, 1000, {
      'leading': true,
      'trailing': false }),

    changeAgentRecordAct: function changeAgentRecordAct(val) {
      var me = this;
      me.currentArActId = val;
      var currentCp = me.cpActivities[val];
      if (null != currentCp) {
        me.currentPlannedes = currentCp['planned'];
        me.currentCandidates = currentCp['candidate'];
        me.mwRef('planned').refreshData(me.currentPlannedes);
        me.mwRef('candidate').refreshData(me.currentCandidates);
        return;
      }
      me._getCurrentArActivityCandidates();
    },
    _getCurrentArActivityCandidates: function _getCurrentArActivityCandidates() {
      var me = this;
      var act = me.srcAgentRecordActs[me.currentArActId];
      me.mwApi.process.getNextActivityCandidates({ taskId: me.params.taskId, flowId: act.flowId }).then(function (data) {
        var res = data.result;
        if (typeof res.success != 'undefined' && !res.success) {
          me.currentPlannedes = [];
          me.currentCandidates = [];
        } else {
          me.currentPlannedes = [];
          me.currentCandidates = res;
        }
        me.cpActivities[me.currentArActId] = { 'planned': me.currentPlannedes, 'candidate': me.currentCandidates };
        if (me.mwRef('candidate')) {
          me.mwRef('candidate').refreshData(me.currentCandidates);
        }
        if (me.mwRef('planned')) {
          me.mwRef('planned').refreshData(me.currentPlannedes);
        }
      });
    },
    candidateDataHandle: function candidateDataHandle(data) {
      for (var i = 0; i < data.length; i++) {
        var d = data[i];
        if (!d.text) {
          if (d.name)
          d.text = d.name;
        }
        if (!d.originalId) {
          d.originalId = d.id;
          if (d.departmentId) {
            d.id = d.departmentId + '_' + d.id;
          }
        }
        if (!d.idx && d.idx != 0) {
          d.idx = i;
        }
      }
    },
    dblClick: function dblClick(data) {
      var me = this;

      var fcandidate = me.currentCandidates;
      var idx;
      fcandidate.map(function (v, d) {
        if (v.id == data.id) {
          idx = d;
          return;
        }
      });
      me.currentCandidates.splice(idx, 1);

      var node = (0, _assign2.default)({}, data);
      node.text = data.name;
      me.currentPlannedes.push(node);
      me.mwRef('planned').refreshData(me.currentPlannedes);
      me.cpActivities[me.currentArActId] = { 'planned': me.currentPlannedes, 'candidate': me.currentCandidates };
    },
    dblClickSelected: function dblClickSelected(data) {
      var me = this;

      var fplanned = me.currentPlannedes;
      var idx = void 0;
      fplanned.map(function (v, d) {
        if (v.id == data.id) {
          idx = d;
          return;
        }
      });
      me.currentPlannedes.splice(idx, 1);

      var node = (0, _assign2.default)({}, data);
      node.text = data.name;
      var cidx = node.idx;
      if (cidx || cidx == 0) {
        me.currentCandidates.splice(cidx, 0, node);
      } else {
        me.currentCandidates.push(node);
      }
      me.mwRef('candidate').refreshData(me.currentCandidates);
      me.cpActivities[me.currentArActId] = { 'planned': me.currentPlannedes, 'candidate': me.currentCandidates };
    },
    submit: function submit() {
      var me = this;
      if (me.currentPlannedes.length < 1) {
        me.mwMsg('info', $lang("请先选择可选领导"));
        return;
      }
      this.mwRef("virtuallogForm").validate(function (valid) {
        if (valid) {
          me.btnDebounce(function () {
            me.setBtnLoading(true, 1);
            var act = me.srcAgentRecordActs[me.currentArActId];
            var params = {};
            params.type = "virtualRecord";
            params.isAgentRecord = me.isAgentRecord;
            params.appId = me.params.appId;
            params.formId = me.params.formId;
            params.taskId = me.params.taskId;

            var items = [];
            me.currentPlannedes.map(function (plan) {
              items.push(me._nodeAsItem(plan));
            });
            params.activities = [{ activityId: act.id, items: items, flowId: act.flowId }];
            params.$comment = [{
              id: me.commentId,
              content: me.form.comment,
              category: me.commentCategory,
              leading: me.leading,
              isAgentRecord: me.isAgentRecord,
              agentType: me.agentType }];

            me.mwApi.process.saveVirtualRecord(params).then(function (res) {
              me.close();
              me.formActionComplete(params);
              me.setBtnLoading(false, 1);
            }).catch(function () {
              me.setBtnLoading(false, 1);
            });
          });
        } else {

          return;
        }
      });
    },
    beforeClose: function beforeClose(done) {
      var me = this;

      if (me.params.secondfunc) {
        me.params.secondfunc();
      }
      me.resetForm();
      done();


    },
    resetForm: function resetForm() {
      var me = this;
      me.form.comment = '';
      me.commentId = $uuid();
      me.commentCategory = '';
    },
    formActionComplete: function formActionComplete() {
      var me = this;
      if (me.params.func) {
        me.params.func();
      }
      this.resetForm();
    },
    show: function show() {
      this.mwRef('dialog').show();
    },
    close: function close() {
      this.resetForm();
      this.mwRef('dialog').hide();
    },
    _nodeAsItem: function _nodeAsItem(n) {
      var item = {};
      item.group = n.departmentId;
      if (!item.users) {
        item.users = [];
      }
      item.users.push({ id: n.originalId });
      return item;
    } } };

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"small_large","title":_vm.title,"appendToBody":false,"footerButton":_vm.footerButton,"customClass":"mw-flow-complete","beforeClose":_vm.beforeClose}},[_c('el-form',{ref:"virtuallogForm",staticStyle:{"padding-top":"20px"},attrs:{"model":_vm.form,"label-width":"100px","rules":_vm.formRules}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('代录节点')+'：'}},[_c('el-select',{on:{"change":_vm.changeAgentRecordAct},model:{value:(_vm.form.agentRecordActId),callback:function ($$v) {_vm.$set(_vm.form, "agentRecordActId", $$v)},expression:"form.agentRecordActId"}},_vm._l((_vm.agentRecordActs),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"325px","padding-top":"5px"}},[_c('el-col',{staticClass:"__col-h100",attrs:{"span":12}},[_c('div',{staticClass:"__panel __tree-panel"},[_c('div',{staticClass:"__panel-heading"},[_vm._v(_vm._s(_vm.$lang('可选领导'))+"："),_c('span',{staticClass:"pull-right",staticStyle:{"padding-right":"5px"}},[_vm._v("("+_vm._s(_vm.$lang('双击移入'))+">>)")])]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},[_c('mw-li-tree',{ref:"candidate",attrs:{"autoLoad":true,"async":false,"multiple":false,"treeData":_vm.currentCandidates},on:{"dblClick":_vm.dblClick,"beforeDataFilter":_vm.candidateDataHandle}})],1)])]),_vm._v(" "),_c('el-col',{staticClass:"__col-h100",staticStyle:{"padding-left":"5px"},attrs:{"span":12}},[_c('div',{staticClass:"__panel __tree-panel"},[_c('div',{staticClass:"__panel-heading"},[_vm._v(_vm._s(_vm.$lang('已选领导'))+"："),_c('span',{staticClass:"pull-right",staticStyle:{"padding-right":"5px"}},[_vm._v("("+_vm._s(_vm.$lang('双击移出'))+")")])]),_vm._v(" "),_c('div',{staticClass:"__panel-body"},[_c('mw-li-tree',{ref:"planned",attrs:{"autoLoad":true,"async":false,"multiple":true,"treeData":_vm.currentPlannedes},on:{"dblClick":_vm.dblClickSelected}})],1)])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding-top":"10px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('办理意见')+'：',"prop":"comment"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.comment),callback:function ($$v) {_vm.$set(_vm.form, "comment", $$v)},expression:"form.comment"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_secrecord_vue__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_secrecord_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_secrecord_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_secrecord_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_secrecord_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_65f5afba_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_secrecord_vue__ = __webpack_require__(1076);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_secrecord_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_65f5afba_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_secrecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"mini_mini","title":_vm.title,"appendToBody":false,"footerButton":_vm.footerButton,"customClass":"mw-flow-complete","beforeClose":_vm.beforeClose}},[_c('el-form',{ref:"secrecordForm",staticStyle:{"padding-top":"20px"},attrs:{"model":_vm.form,"label-width":"100px","rules":_vm.formRules}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('代录领导')+'：'}},[[_c('span',{domProps:{"innerHTML":_vm._s(_vm.params.ownerName)}})]],2)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('办理意见')+'：',"prop":"comment"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.comment),callback:function ($$v) {_vm.$set(_vm.form, "comment", $$v)},expression:"form.comment"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_tree_vue__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_tree_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_tree_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_tree_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_tree_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_054baccc_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_tree_vue__ = __webpack_require__(1078);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_tree_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_054baccc_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_tree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":_vm.params.size,"width":_vm.width,"height":_vm.height,"title":_vm.$lang(_vm.params.title?_vm.params.title:'选择'),"appendToBody":false,"footerButton":_vm.footerButton,"before-close":_vm.selectCancel}},[_c('mw-tree',{ref:"tree",attrs:{"url":_vm.params.url,"singleLeaf":(_vm.params.singleLeaf!=undefined)?_vm.params.singleLeaf:true,"async":_vm.params.async?_vm.params.async:false,"expandedFirst":true,"selectFirst":(_vm.params.selectFirst!=undefined)?_vm.params.selectFirst:false,"defaultParentId":_vm.params.defaultParentId,"dragEnable":_vm.dragEnable,"aliasId":_vm.params.aliasId,"checkNodes":_vm.params.checkNodes,"selectNode":_vm.params.selectNode,"treeData":_vm.params.treeData,"types":(_vm.params.types!=undefined) ? _vm.params.types : null,"multipleLeaf":(_vm.params.multipleLeaf!=undefined)?_vm.params.multipleLeaf:false,"multiple":_vm.params.multiple?_vm.params.multiple:false,"defaultParams":_vm.params.defaultParams,"restful":(_vm.params.restful!=undefined)?_vm.params.restful:false,"threeState":_vm.params.threeState,"search":_vm.params.search?_vm.params.search:false},on:{"ready":_vm.params.ready}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_treeTable_vue__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_treeTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_treeTable_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_treeTable_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_treeTable_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_05d0b05f_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_treeTable_vue__ = __webpack_require__(1080);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_treeTable_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_05d0b05f_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_treeTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":_vm.params.size?_vm.params.size:'small_small',"customClass":"mw-dialog-tree-table","title":_vm.params.title?_vm.params.title:'选择',"appendToBody":false,"footerButton":_vm.footerButton,"before-close":_vm.selectCancel}},[(!_vm.showSelected)?_c('split-pane',{attrs:{"defaultPercent":_vm.params.defaultPercent?_vm.params.defaultPercent:50}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-panel"},[(_vm.params.showTreeToolbar==undefined?true:_vm.params.showTreeToolbar)?_c('div',{staticClass:"mw-toolbar",staticStyle:{"margin-right":"0px","margin-left":"0px","margin-bottom":"0px"}},[_c('mw-button',{attrs:{"icon":"fa fa-angle-double-down"},on:{"click":_vm.expand}},[_vm._v("展开\n            ")]),_vm._v(" "),_c('mw-button',{attrs:{"icon":"fa fa-angle-double-up"},on:{"click":_vm.closed}},[_vm._v("折叠\n            ")])],1):_vm._e(),_vm._v(" "),_c('div',{class:[{'mw-toolbar__body':(_vm.params.showTreeToolbar==undefined?true:_vm.params.showTreeToolbar),
          'mw-panel-y':!(_vm.params.showTreeToolbar==undefined?true:_vm.params.showTreeToolbar)},'mw-app__edit']},[_c('mw-tree',{ref:"tree",staticStyle:{"padding-top":"0px"},attrs:{"url":_vm.params.url,"defaultParentId":_vm.params.defaultParentId,"treeData":_vm.params.treeData,"async":(_vm.params.treeAsync==undefined?true:_vm.params.treeAsync),"expandedFirst":true,"selectFirst":_vm.params.selectFirst,"defaultParams":_vm.params.treeDefaultParams,"changeDefaultParams":_vm.params.changeDefaultParams,"multiple":false},on:{"changed":_vm.changed}})],1)])])]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('div',{staticClass:"mw-panel"},[_c('mw-table',{ref:"dataTable",attrs:{"columns":_vm.params.columns ? _vm.params.columns:_vm.columns,"defaultParamsAutoLoad":true,"data":_vm.params.tableData,"autoLoad":_vm.params.autoLoad==undefined?false:_vm.params.autoLoad,"pagination":false,"defaultParams":_vm.defaultParams,"api":_vm.params.api,"singleSelect":_vm.params.singleSelect},on:{"select":_vm.select,"selectAll":_vm.selectAll,"rowClick":_vm.rowClick}})],1)])])],2):_c('split-pane',{attrs:{"defaultPercent":_vm.params.defaultPercent?_vm.params.defaultPercent:30}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-panel"},[(_vm.params.showTreeToolbar==undefined?true:_vm.params.showTreeToolbar)?_c('div',{staticClass:"mw-toolbar",staticStyle:{"margin-right":"0px","margin-left":"0px","margin-bottom":"0px"}},[_c('mw-button',{attrs:{"icon":"fa fa-angle-double-down"},on:{"click":_vm.expand}},[_vm._v("展开\n            ")]),_vm._v(" "),_c('mw-button',{attrs:{"icon":"fa fa-angle-double-up"},on:{"click":_vm.closed}},[_vm._v("折叠\n            ")])],1):_vm._e(),_vm._v(" "),_c('div',{class:[{'mw-toolbar__body':(_vm.params.showTreeToolbar==undefined?true:_vm.params.showTreeToolbar),
          'mw-panel-y':!(_vm.params.showTreeToolbar==undefined?true:_vm.params.showTreeToolbar)},'mw-app__edit']},[_c('mw-tree',{ref:"tree",staticStyle:{"padding-top":"0px"},attrs:{"url":_vm.params.url,"defaultParentId":_vm.params.defaultParentId,"treeData":_vm.params.treeData,"async":(_vm.params.treeAsync==undefined?true:_vm.params.treeAsync),"expandedFirst":true,"selectFirst":_vm.params.selectFirst,"defaultParams":_vm.params.treeDefaultParams,"changeDefaultParams":_vm.params.changeDefaultParams,"multiple":false},on:{"changed":_vm.changed}})],1)])])]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('split-pane',{attrs:{"defaultPercent":_vm.params.selectDefaultPercent?_vm.params.selectDefaultPercent:50}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('mw-table',{ref:"dataTable",attrs:{"columns":_vm.params.columns ? _vm.params.columns:_vm.columns,"defaultParamsAutoLoad":true,"data":_vm.params.tableData,"autoLoad":_vm.params.autoLoad==undefined?false:_vm.params.autoLoad,"pagination":false,"defaultParams":_vm.defaultParams,"api":_vm.params.api,"singleSelect":_vm.params.singleSelect},on:{"selectChange":_vm.selectChange,"select":_vm.select,"dataLoaded":_vm.dataLoaded,"rendered":_vm.rendered,"selectAll":_vm.selectAll,"rowClick":_vm.rowClick}})],1)]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('div',{staticClass:"mw-panel"},[_c('mw-table',{ref:"dataSelectTable",attrs:{"columns":_vm.params.selectColumns ? _vm.params.selectColumns:_vm.selectColumns,"pagination":false,"data":_vm.tableSelectData}})],1)])])],2)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_page_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_page_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_page_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_page_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_page_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3909561d_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_page_vue__ = __webpack_require__(1082);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_page_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3909561d_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":_vm.params.size?_vm.params.size:'full',"footerButton":_vm.footerButton,"width":_vm.params.width?_vm.params.width:'',"height":_vm.params.height?_vm.params.height:'',"customClass":_vm.params.customClass?_vm.params.customClass:'',"title":_vm.$lang(_vm.params.title?_vm.params.title:''),"appendToBody":false,"beforeClose":_vm.cancel,"modal":_vm.params.modal}},[_c('mw-inner-page',{ref:"page",attrs:{"pageId":_vm.params.id,"params":_vm.params,"dialog":_vm.dialog}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_table_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_table_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_table_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ce19276a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_table_vue__ = __webpack_require__(1084);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_table_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ce19276a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":_vm.params.size?_vm.params.size:'small_small',"customClass":"mw-dialog-tree-table","title":_vm.params.title?_vm.params.title:'选择',"appendToBody":false,"footerButton":_vm.footerButton,"before-close":_vm.selectCancel}},[_c('mw-table',{ref:"dataTable",attrs:{"columns":_vm.params.columns ? _vm.params.columns:_vm.columns,"defaultParamsAutoLoad":true,"pagination":_vm.params.pagination==undefined?false:_vm.params.pagination,"defaultParams":_vm.params.defaultParams==undefined?{}:_vm.params.defaultParams,"data":_vm.params.data,"api":_vm.params.api,"singleSelect":_vm.params.singleSelect}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_select_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_select_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_select_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_select_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_60106db8_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_user_select_vue__ = __webpack_require__(1086);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_select_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_60106db8_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_user_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"small_large","appendToBody":false,"footerButton":_vm.footerButton,"title":"选择用户"}},[_c('el-col',{style:({"height":"calc(100% - "+(_vm.params.footerHeight||0)+"px)","overflow-x":"hidden"}),attrs:{"span":12}},[_c('mw-tree',{ref:"tree",attrs:{"url":_vm.deptTreeUrl,"async":true,"expandedFirst":true,"defaultParams":_vm.defaultTreeParams,"multiple":false,"aliasId":_vm.treeAliasId},on:{"changed":_vm.changed}})],1),_vm._v(" "),_c('el-col',{style:({"height":"calc(100% - "+(_vm.params.footerHeight||0)+"px)"}),attrs:{"span":12}},[_c('mw-table',{ref:"dataTable",attrs:{"columns":_vm.columns,"defaultParamsAutoLoad":true,"autoLoad":false,"pagination":false,"defaultParams":_vm.defaultParams,"api":_vm.api,"singleSelect":_vm.params.multiple==undefined ?true:!_vm.params.multiple}})],1),_vm._v(" "),(_vm.params.footerComp)?_c(_vm.params.footerComp,{ref:"footerComp",tag:"component",attrs:{"params":_vm.thisComp}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_org_select_vue__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_org_select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_org_select_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_org_select_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_org_select_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_e1b89894_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_org_select_vue__ = __webpack_require__(1090);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_org_select_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_e1b89894_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_org_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_org_vue__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_org_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_org_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_org_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_org_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_d9d09282_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_org_vue__ = __webpack_require__(1089);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_org_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_d9d09282_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_org_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('div',{staticClass:"mw-panel org_select"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"large_large","appendToBody":false,"footerButton":_vm.footerButton,"title":_vm.title}},[_c('innerOrg',{ref:"org",attrs:{"params":_vm.params}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_script_set_vue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_script_set_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_script_set_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_script_set_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_script_set_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_180e0316_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flow_script_set_vue__ = __webpack_require__(1093);
function injectStyle (ssrContext) {
  __webpack_require__(1092)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_script_set_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_180e0316_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flow_script_set_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-script-set"},[_c('mw-dialog',{ref:"dialog",attrs:{"size":_vm.size,"title":_vm.title,"appendToBody":false,"footerButton":_vm.footerButton,"customClass":"mw-flow-complete","beforeClose":_vm.close}},[_c('el-form',{ref:"secrecordForm",staticStyle:{"padding-top":"20px"},attrs:{"model":_vm.form,"label-width":"110px"}},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"表单保存前置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.form_save_preName),callback:function ($$v) {_vm.$set(_vm.form, "form_save_preName", $$v)},expression:"form.form_save_preName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.form_save_preAction),callback:function ($$v) {_vm.$set(_vm.form, "form_save_preAction", $$v)},expression:"form.form_save_preAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('form_save_pre')}}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"后置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.form_save_postName),callback:function ($$v) {_vm.$set(_vm.form, "form_save_postName", $$v)},expression:"form.form_save_postName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.form_save_postAction),callback:function ($$v) {_vm.$set(_vm.form, "form_save_postAction", $$v)},expression:"form.form_save_postAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('form_save_post')}}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"流程启动前置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.process_start_preName),callback:function ($$v) {_vm.$set(_vm.form, "process_start_preName", $$v)},expression:"form.process_start_preName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.process_start_preAction),callback:function ($$v) {_vm.$set(_vm.form, "process_start_preAction", $$v)},expression:"form.process_start_preAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('process_start_pre')}}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"后置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.process_start_postName),callback:function ($$v) {_vm.$set(_vm.form, "process_start_postName", $$v)},expression:"form.process_start_postName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.process_start_postAction),callback:function ($$v) {_vm.$set(_vm.form, "process_start_postAction", $$v)},expression:"form.process_start_postAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('process_start_post')}}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":21}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"label":"流程启动拦截："}},[_c('el-input',{model:{value:(_vm.form.process_start_interceptName),callback:function ($$v) {_vm.$set(_vm.form, "process_start_interceptName", $$v)},expression:"form.process_start_interceptName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.process_start_interceptAction),callback:function ($$v) {_vm.$set(_vm.form, "process_start_interceptAction", $$v)},expression:"form.process_start_interceptAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('process_start_intercept')}}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"流程办结前置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.process_done_preName),callback:function ($$v) {_vm.$set(_vm.form, "process_done_preName", $$v)},expression:"form.process_done_preName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.process_done_preAction),callback:function ($$v) {_vm.$set(_vm.form, "process_done_preAction", $$v)},expression:"form.process_done_preAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('process_done_pre')}}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"后置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.process_done_postName),callback:function ($$v) {_vm.$set(_vm.form, "process_done_postName", $$v)},expression:"form.process_done_postName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.process_done_postAction),callback:function ($$v) {_vm.$set(_vm.form, "process_done_postAction", $$v)},expression:"form.process_done_postAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('process_done_post')}}},[_vm._v("选择")]),_vm._v(" "),_c('el-tooltip',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],staticStyle:{"width":"10%"},attrs:{"placement":"top"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n            流程办结上下文参数："),_c('br'),_vm._v("\n                isFlowOver：是否流程办结 true-是 false-否"),_c('br'),_vm._v("\n                isDocOver： 是否文档办结 true-是 false-否"),_c('br')]),_vm._v(" "),_c('i',{staticClass:"el-icon-info"})])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"流程挂起前置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.process_suspend_preName),callback:function ($$v) {_vm.$set(_vm.form, "process_suspend_preName", $$v)},expression:"form.process_suspend_preName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.process_suspend_preAction),callback:function ($$v) {_vm.$set(_vm.form, "process_suspend_preAction", $$v)},expression:"form.process_suspend_preAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('process_suspend_pre')}}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"后置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.process_suspend_postName),callback:function ($$v) {_vm.$set(_vm.form, "process_suspend_postName", $$v)},expression:"form.process_suspend_postName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.process_suspend_postAction),callback:function ($$v) {_vm.$set(_vm.form, "process_suspend_postAction", $$v)},expression:"form.process_suspend_postAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('process_suspend_post')}}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"流程激活前置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.process_activate_preName),callback:function ($$v) {_vm.$set(_vm.form, "process_activate_preName", $$v)},expression:"form.process_activate_preName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.process_activate_preAction),callback:function ($$v) {_vm.$set(_vm.form, "process_activate_preAction", $$v)},expression:"form.process_activate_preAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('process_activate_pre')}}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"后置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.process_activate_postName),callback:function ($$v) {_vm.$set(_vm.form, "process_activate_postName", $$v)},expression:"form.process_activate_postName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.process_activate_postAction),callback:function ($$v) {_vm.$set(_vm.form, "process_activate_postAction", $$v)},expression:"form.process_activate_postAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('process_activate_post')}}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"流程终止前置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.process_terminate_preName),callback:function ($$v) {_vm.$set(_vm.form, "process_terminate_preName", $$v)},expression:"form.process_terminate_preName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.process_terminate_preAction),callback:function ($$v) {_vm.$set(_vm.form, "process_terminate_preAction", $$v)},expression:"form.process_terminate_preAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('process_terminate_pre')}}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"后置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.process_terminate_postName),callback:function ($$v) {_vm.$set(_vm.form, "process_terminate_postName", $$v)},expression:"form.process_terminate_postName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.process_terminate_postAction),callback:function ($$v) {_vm.$set(_vm.form, "process_terminate_postAction", $$v)},expression:"form.process_terminate_postAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('process_terminate_post')}}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"流程删除前置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.process_deleted_preName),callback:function ($$v) {_vm.$set(_vm.form, "process_deleted_preName", $$v)},expression:"form.process_deleted_preName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.process_deleted_preAction),callback:function ($$v) {_vm.$set(_vm.form, "process_deleted_preAction", $$v)},expression:"form.process_deleted_preAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('process_deleted_pre')}}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"label":"后置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.process_deleted_postName),callback:function ($$v) {_vm.$set(_vm.form, "process_deleted_postName", $$v)},expression:"form.process_deleted_postName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.process_deleted_postAction),callback:function ($$v) {_vm.$set(_vm.form, "process_deleted_postAction", $$v)},expression:"form.process_deleted_postAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('process_deleted_post')}}},[_vm._v("选择")]),_vm._v(" "),_c('el-tooltip',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='process'),expression:"type=='process'"}],staticStyle:{"width":"10%"},attrs:{"placement":"top"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n             流程删除上下文参数："),_c('br'),_vm._v("\n                 isLastBatch：是否最后一个批次流程 true-是 false-否"),_c('br')]),_vm._v(" "),_c('i',{staticClass:"el-icon-info"})])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":21}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='line'),expression:"type=='line'"}],attrs:{"label":"流向跳转前置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.flow_sequence_taken_preName),callback:function ($$v) {_vm.$set(_vm.form, "flow_sequence_taken_preName", $$v)},expression:"form.flow_sequence_taken_preName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.flow_sequence_taken_preAction),callback:function ($$v) {_vm.$set(_vm.form, "flow_sequence_taken_preAction", $$v)},expression:"form.flow_sequence_taken_preAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='line'),expression:"type=='line'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('flow_sequence_taken_pre')}}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":21}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='line'),expression:"type=='line'"}],attrs:{"label":"流向跳转后置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.flow_sequence_taken_postName),callback:function ($$v) {_vm.$set(_vm.form, "flow_sequence_taken_postName", $$v)},expression:"form.flow_sequence_taken_postName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.flow_sequence_taken_postAction),callback:function ($$v) {_vm.$set(_vm.form, "flow_sequence_taken_postAction", $$v)},expression:"form.flow_sequence_taken_postAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='line'),expression:"type=='line'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('flow_sequence_taken_post')}}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"label":"任务创建后："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_create_postName),callback:function ($$v) {_vm.$set(_vm.form, "task_create_postName", $$v)},expression:"form.task_create_postName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.task_create_postAction),callback:function ($$v) {_vm.$set(_vm.form, "task_create_postAction", $$v)},expression:"form.task_create_postAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('task_create_post')}}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"label":"任务办理前："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_check_before_handle_preName),callback:function ($$v) {_vm.$set(_vm.form, "task_check_before_handle_preName", $$v)},expression:"form.task_check_before_handle_preName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.task_check_before_handle_preAction),callback:function ($$v) {_vm.$set(_vm.form, "task_check_before_handle_preAction", $$v)},expression:"form.task_check_before_handle_preAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('task_check_before_handle_pre')}}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"label":"任务签收前置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_assignee_preName),callback:function ($$v) {_vm.$set(_vm.form, "task_assignee_preName", $$v)},expression:"form.task_assignee_preName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.task_assignee_preAction),callback:function ($$v) {_vm.$set(_vm.form, "task_assignee_preAction", $$v)},expression:"form.task_assignee_preAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('task_assignee_pre')}}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"label":"后置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_assignee_postName),callback:function ($$v) {_vm.$set(_vm.form, "task_assignee_postName", $$v)},expression:"form.task_assignee_postName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.task_assignee_postAction),callback:function ($$v) {_vm.$set(_vm.form, "task_assignee_postAction", $$v)},expression:"form.task_assignee_postAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('task_assignee_post')}}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"label":"任务完成前置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_complete_preName),callback:function ($$v) {_vm.$set(_vm.form, "task_complete_preName", $$v)},expression:"form.task_complete_preName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.task_complete_preAction),callback:function ($$v) {_vm.$set(_vm.form, "task_complete_preAction", $$v)},expression:"form.task_complete_preAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('task_complete_pre')}}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"label":"后置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_complete_postName),callback:function ($$v) {_vm.$set(_vm.form, "task_complete_postName", $$v)},expression:"form.task_complete_postName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.task_complete_postAction),callback:function ($$v) {_vm.$set(_vm.form, "task_complete_postAction", $$v)},expression:"form.task_complete_postAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('task_complete_post')}}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"label":"任务取回前置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_taken_preName),callback:function ($$v) {_vm.$set(_vm.form, "task_taken_preName", $$v)},expression:"form.task_taken_preName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_taken_preAction),callback:function ($$v) {_vm.$set(_vm.form, "task_taken_preAction", $$v)},expression:"form.task_taken_preAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('task_taken_pre')}}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"label":"后置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_taken_postName),callback:function ($$v) {_vm.$set(_vm.form, "task_taken_postName", $$v)},expression:"form.task_taken_postName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_taken_postAction),callback:function ($$v) {_vm.$set(_vm.form, "task_taken_postAction", $$v)},expression:"form.task_taken_postAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('task_taken_post')}}},[_vm._v("选择")]),_vm._v(" "),_c('el-tooltip',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],staticStyle:{"width":"10%"},attrs:{"placement":"top"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n            任务取回上下文参数："),_c('br'),_vm._v("\n            isRollback：是否流程回滚 true-是 false-否"),_c('br')]),_vm._v(" "),_c('i',{staticClass:"el-icon-info"})])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"label":"任务退回前置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_reject_preName),callback:function ($$v) {_vm.$set(_vm.form, "task_reject_preName", $$v)},expression:"form.task_reject_preName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_reject_preAction),callback:function ($$v) {_vm.$set(_vm.form, "task_reject_preAction", $$v)},expression:"form.task_reject_preAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('task_reject_pre')}}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"label":"后置："}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_reject_postName),callback:function ($$v) {_vm.$set(_vm.form, "task_reject_postName", $$v)},expression:"form.task_reject_postName"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.task_reject_postAction),callback:function ($$v) {_vm.$set(_vm.form, "task_reject_postAction", $$v)},expression:"form.task_reject_postAction"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.showFlowScript('task_reject_post')}}},[_vm._v("选择")]),_vm._v(" "),_c('el-tooltip',{directives:[{name:"show",rawName:"v-show",value:(_vm.type=='node'),expression:"type=='node'"}],staticStyle:{"width":"10%"},attrs:{"placement":"top"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n            任务退回上下文参数："),_c('br'),_vm._v("\n            isRejectToSend：是否退回运转发送任务 true-是 false-否"),_c('br')]),_vm._v(" "),_c('i',{staticClass:"el-icon-info"})])],1)],1)],1)],1),_vm._v(" "),_c('mw-dialog',{ref:"helpDialog",attrs:{"size":"small_large","title":"帮助说明"}},[_c('div',{staticClass:"mw-toolbar__body"},[_c('pre',[_c('b',[_vm._v("SYSTEM：ComponentSystem对象")]),_vm._v("\n       SYSTEM.getService(xxx.class):获取Service接口\n      ")]),_vm._v(" "),_c('pre',[_c('b',[_vm._v("RT：ServiceRuntime对象")]),_vm._v("\n       RT.invoke(String serviceId, String method, Object... args):调用后台服务接口\n      ")]),_vm._v(" "),_c('pre',[_c('b',[_vm._v("BIT：流程拦截器工具类")]),_vm._v("\n       BIT.getConfig()：获取流程、节点、流向配置数据\n                         流程脚本则可以获取到流程配置数据；\n                         节点脚本则可以获取节点配置数据；\n       BIT.getCliParams()：客户端传入的参数\n       BIT.getCliLoginUser()：客户端当前登录用户\n       BIT.getDatabase()：客户端传入的数据库\n       BIT.getFormData()：获取表单数据\n       BIT.getModuleId()：获取模块ID\n       BIT.getBusinessId()：获取文档ID，注意：表单创建前拦截值为空, 切换节点表单保存前为空\n       BIT.getDraftsDocId()：获取文档ID，注意：表单创建前拦截值为空\n       BIT.getBatchId()：获取流程批次ID，流程启动前拦截值为空\n       BIT.getFormDatabase()：获取表单数据库\n       BIT.getFormEntityKey()：获取表单key\n       BIT.getTaskData()：节点脚本可获取任务数据\n\n       BIT.getContextParameterNames()：获取上下文所有参数名集合\n       BIT.getContext(String name)：获取上下文某个参数的值\n       BIT.getApiContextParameterNames()：获取API上下文所有参数名集合\n       BIT.getApiContextParameter(String key)：获取API上下文某个参数的值\n\n       BIT.setFormData(Map data)：修改表单数据\n       BIT.setProcessUpdateData(Map data)：修改流程数据\n      ")]),_vm._v(" "),_c('pre',[_c('b',[_vm._v("BTT：流程事务工具类")]),_vm._v("\n      createForm(Map formData,\n                 String moduleId,\n                 String formEntityKey,\n                 String formEntityId,\n                 Integer formEntityVersion,\n                 String formDatabase)：创建Form对象\n      getForm(String id, String formEntityKey, String formDatabase)：获取Form对象\n      removeForm(String id, String formEntityKey, String formDatabase)：删除Form对象\n      removeUrge(String businessId, String urgedUserId)：删除催办(注意：不再提供支持，已标记为弃用状态)\n      removeUrge(String dataId, String dataType, String urgedUserId)：删除催办\n      -----------------------------------------------------\n      Form：表数据对象\n              getEntity()：获取FormEntity对象\n              setData(Map data)：修改表单数据\n              addAddReaders(Set addReaders)：新增读者域\n              addRemoveReaders(Set removeReaders)：移除读者域\n              addCoverReaders(Set coverReaders)：覆盖读者域\n              addAddAuthors(Set addAuthors)：新增作者域\n              addRemoveAuthors(Set removeAuthors)：移除作者域\n              addCoverAuthors(Set coverAuthors)：覆盖作者域\n              setFileCopySource(String businessId, String formKey, String database, String[] fileIds)：拷贝某一份文档的附件,fileIds限定拷贝附件ID集合,若为空则拷贝所有附件\n      FormEntity：表数据实体对象\n              getProperty(String name)：获取属性值\n              setProperty(String name, Object value)：修改属性值\n              removeProperty(String name)：删除属性值\n              getData()：获取表单原数据，Map格式\n      ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_chart_viewer_vue__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_chart_viewer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_chart_viewer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_chart_viewer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_chart_viewer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f00141d8_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_process_chart_viewer_vue__ = __webpack_require__(1096);
function injectStyle (ssrContext) {
  __webpack_require__(1095)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_chart_viewer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f00141d8_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_process_chart_viewer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1095 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",staticClass:"process-chart-viewer-dialog",attrs:{"appendToBody":false,"title":_vm.title,"size":"large_large"}},[_c('flow-chart-viewer',{attrs:{"params":_vm.params}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_transaction_process_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_transaction_process_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_transaction_process_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_transaction_process_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_transaction_process_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_028c8e8a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_transaction_process_vue__ = __webpack_require__(1098);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_transaction_process_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_028c8e8a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_transaction_process_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"appendToBody":false,"title":"办理过程","size":"large_large","customClass":"mw-form-view-dialog"}},[_c('div',{staticClass:"mw-margin-top-10 process-dialog"},[_c('el-tabs',{attrs:{"type":"card"},on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"流程办理过程","name":"first"}},[_c('mw-table',{attrs:{"api":_vm.api,"columns":_vm.columns,"pagination":false,"nowrap":false,"defaultParams":_vm.defaultParams,"defaultParamsAutoLoad":true}})],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"阅知办理过程","name":"second"}},[(_vm.showSecond)?[_c('mw-table',{ref:"circularTable",attrs:{"api":_vm.apiSecond,"columns":_vm.columnsSecond,"pagination":false,"nowrap":false,"defaultParams":_vm.defaultParamsSecond,"defaultParamsAutoLoad":true}})]:_vm._e()],2)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_interfering_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_interfering_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_interfering_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_interfering_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_interfering_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5b8c583b_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_process_interfering_vue__ = __webpack_require__(1147);
function injectStyle (ssrContext) {
  __webpack_require__(1100)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b8c583b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_interfering_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5b8c583b_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_process_interfering_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-sizes":[10, 20, 50, 100],"page-size":_vm.value.limit,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.value.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_changeFormData_vue__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_changeFormData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_changeFormData_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_changeFormData_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_changeFormData_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_56b119f4_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_changeFormData_vue__ = __webpack_require__(1106);
function injectStyle (ssrContext) {
  __webpack_require__(1105)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_changeFormData_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_56b119f4_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_changeFormData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"large_large","title":"修改字段","footerButton":_vm.footerButton},on:{"closed":_vm.handleClose}},[_c('el-tabs',{attrs:{"value":"first"}},[_c('el-tab-pane',{attrs:{"label":"普通字段","name":"first"}},[_c('div',{staticStyle:{"height":"100%","overflow":"auto"}},[_c('mw-form-view',{ref:"formView",attrs:{"businessId":_vm.businessId,"appId":_vm.applicationId,"moduleId":_vm.moduleId,"value":_vm.value},on:{"update:value":function($event){_vm.value=$event},"handleField":_vm.handleField}})],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"隐藏字段","name":"second"}},[_c('div',{staticStyle:{"height":"100%","overflow":"auto"}},[_c('table',{staticStyle:{"width":"100%","border-collapse":"separate","border-spacing":"10px 10px"}},[_c('tbody',_vm._l((_vm.nameList),function(name){return _c('tr',{key:name},[_c('td',{staticStyle:{"text-align":"left","width":"180px"}},[_vm._v(_vm._s(name))]),_vm._v(" "),_c('td',[_c('el-input',{attrs:{"type":"textarea","rows":1},model:{value:(_vm.hiddenFields[name]),callback:function ($$v) {_vm.$set(_vm.hiddenFields, name, $$v)},expression:"hiddenFields[name]"}})],1)])}),0)])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_changeComment_vue__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_changeComment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_changeComment_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_changeComment_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_changeComment_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_b8ad3f92_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_changeComment_vue__ = __webpack_require__(1112);
function injectStyle (ssrContext) {
  __webpack_require__(1108)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_changeComment_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_b8ad3f92_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_changeComment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_processSelect_vue__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_processSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_processSelect_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_processSelect_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_processSelect_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2c40bf13_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_processSelect_vue__ = __webpack_require__(1111);
function injectStyle (ssrContext) {
  __webpack_require__(1110)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_processSelect_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2c40bf13_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_processSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-input',{attrs:{"placeholder":"","readonly":"","value":_vm.displayValue,"clearable":true},on:{"change":_vm.handleChange}},[_c('template',{slot:"append"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.open}},[_vm._v("选择")])],1)],2),_vm._v(" "),_c('mw-dialog',{ref:"dialog",attrs:{"size":"small_large","title":"选择节点","footerButton":_vm.footerButton}},[_c('div',{staticStyle:{"height":"100%","overflow":"auto"}},[_c('el-table',{ref:"list",staticStyle:{"width":"100%","height":"100%"},attrs:{"data":_vm.list,"highlight-current-row":"","current-row-key":this.value && this.value.id,"row-key":"id","height":"100%"},on:{"current-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"index","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"名称"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.name))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"department","label":"办理部门"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sender","label":"发送人"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"assigneeName","label":"办理人"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createTime","label":"发送时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"claimTime","label":"签收时间"}})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mw-dialog',{ref:"dialog",attrs:{"size":"large_large","title":"修改意见"}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{on:{"click":_vm.remove}},[_vm._v("删除")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.add}},[_vm._v("添加")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.update}},[_vm._v("修改")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.setHidden}},[_vm._v("表单不显示意见")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.setVisible}},[_vm._v("表单显示意见")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body mw-app__edit"},[_c('div',{staticClass:"mw-pagination__body"},[_c('el-table',{staticClass:"mw-table",staticStyle:{"width":"100%"},attrs:{"stripe":"","border":"","height":"100%","data":_vm.dataList},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"40"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"任务名称","width":"120","prop":"taskName"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"content","label":"意见"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"creator","label":"填写人","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"hidden","width":"100","label":"显示状态"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(['显示', '隐藏', '标记删除'][scope.row.hidden])+"\n                  ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createTime","label":"填写时间","width":"170"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"mw-pagination"},[_c('simple-pagination',{on:{"input":_vm.updateTable},model:{value:(_vm.pagination),callback:function ($$v) {_vm.pagination=$$v},expression:"pagination"}})],1)])]),_vm._v(" "),_c('mw-dialog',{ref:"dialog2",attrs:{"size":"","title":"添加意见","footerButton":_vm.footerButton2}},[_c('div',{staticStyle:{"padding":"10px"}},[_c('el-form',{ref:"editingFormRef",attrs:{"model":_vm.editingForm,"label-width":"150px","rules":_vm.editingRule}},[_c('el-form-item',{attrs:{"label":"意见内容","prop":"content"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.editingForm.content),callback:function ($$v) {_vm.$set(_vm.editingForm, "content", $$v)},expression:"editingForm.content"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"意见内容格式","prop":"contentType"}},[_c('el-input',{attrs:{"type":""},model:{value:(_vm.editingForm.contentType),callback:function ($$v) {_vm.$set(_vm.editingForm, "contentType", $$v)},expression:"editingForm.contentType"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"意见类型","prop":"category"}},[_c('el-input',{attrs:{"type":""},model:{value:(_vm.editingForm.category),callback:function ($$v) {_vm.$set(_vm.editingForm, "category", $$v)},expression:"editingForm.category"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"办理节点","prop":"task"}},[_c('process-select',{attrs:{"batchId":_vm.batchId},model:{value:(_vm.editingForm.task),callback:function ($$v) {_vm.$set(_vm.editingForm, "task", $$v)},expression:"editingForm.task"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"意见填写时间","prop":"createTime"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"yyyy-MM-dd HH:mm:ss","type":"datetime","placeholder":"选择日期时间","align":"right"},model:{value:(_vm.editingForm.createTime),callback:function ($$v) {_vm.$set(_vm.editingForm, "createTime", $$v)},expression:"editingForm.createTime"}})],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"dialog3",attrs:{"size":"","title":"修改意见","footerButton":_vm.footerButton3}},[_c('div',{staticStyle:{"padding":"10px"}},[_c('el-form',{ref:"editingFormRef2",attrs:{"model":_vm.editingForm2,"label-width":"150px","rules":_vm.editingRule}},[_c('el-form-item',{attrs:{"label":"意见内容","prop":"content"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.editingForm2.content),callback:function ($$v) {_vm.$set(_vm.editingForm2, "content", $$v)},expression:"editingForm2.content"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"意见内容格式","prop":"contentType"}},[_c('el-input',{attrs:{"type":""},model:{value:(_vm.editingForm2.contentType),callback:function ($$v) {_vm.$set(_vm.editingForm2, "contentType", $$v)},expression:"editingForm2.contentType"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"意见类型","prop":"category"}},[_c('el-input',{attrs:{"type":""},model:{value:(_vm.editingForm2.category),callback:function ($$v) {_vm.$set(_vm.editingForm2, "category", $$v)},expression:"editingForm2.category"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"办理节点","prop":"task"}},[_c('process-select',{attrs:{"batchId":_vm.batchId},model:{value:(_vm.editingForm2.task),callback:function ($$v) {_vm.$set(_vm.editingForm2, "task", $$v)},expression:"editingForm2.task"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"label":"不保存意见修改记录","prop":"isUnSaveChange"}},[_c('el-switch',{attrs:{"active-color":"#000","inactive-color":"#eee"},model:{value:(_vm.editingForm2.isUnSaveChange),callback:function ($$v) {_vm.$set(_vm.editingForm2, "isUnSaveChange", $$v)},expression:"editingForm2.isUnSaveChange"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"意见填写时间","prop":"createTime"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"yyyy-MM-dd HH:mm:ss","type":"datetime","placeholder":"选择日期时间","align":"right"},model:{value:(_vm.editingForm2.createTime),callback:function ($$v) {_vm.$set(_vm.editingForm2, "createTime", $$v)},expression:"editingForm2.createTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"修改说明","prop":"description"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.editingForm2.description),callback:function ($$v) {_vm.$set(_vm.editingForm2, "description", $$v)},expression:"editingForm2.description"}})],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_complete_vue__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_complete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_complete_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_complete_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_complete_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_10964d5a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_complete_vue__ = __webpack_require__(1117);
function injectStyle (ssrContext) {
  __webpack_require__(1114)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_complete_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_10964d5a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_complete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-input',{attrs:{"placeholder":"","readonly":"","value":_vm.displayValue,"clearable":true},on:{"change":_vm.handleChange}},[_c('template',{slot:"append"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.open}},[_vm._v("选择")])],1)],2),_vm._v(" "),_c('mw-dialog',{ref:"zgDeptDialog",attrs:{"title":"选择人员","size":"small_large","footerButton":_vm.btns,"close-on-click-modal":false}},[_c('div',{ref:"jstreeMountPoint",staticStyle:{"padding":"10px"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"","title":"强制办毕","footerButton":_vm.footerButton}},[_c('div',{staticStyle:{"padding":"10px"}},[_c('el-form',{ref:"editingFormRef",attrs:{"model":_vm.editingForm,"label-width":"150px","rules":_vm.editingRule}},[_c('el-form-item',{attrs:{"label":"完成节点","prop":"oneNode"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.editingForm.oneNode),callback:function ($$v) {_vm.$set(_vm.editingForm, "oneNode", $$v)},expression:"editingForm.oneNode"}},_vm._l((_vm.unfinishedTaskQueue),function(item){return _c('el-option',{key:item.id,attrs:{"label":((item.name||'') + "-" + (item.department||'') + "-" + (item.candidateName||'')).replace(/-$|^-|--/g, ''),"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"完成办理人","prop":"oneMan"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.editingForm.oneMan),callback:function ($$v) {_vm.$set(_vm.editingForm, "oneMan", $$v)},expression:"editingForm.oneMan"}},_vm._l((_vm.taskTransactorList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"送至节点","prop":"twoNode"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.editingForm.twoNode),callback:function ($$v) {_vm.$set(_vm.editingForm, "twoNode", $$v)},expression:"editingForm.twoNode"}},_vm._l((_vm.nextFlowList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"办理人","prop":"twoMan"}},[_c('man-select',{attrs:{"url":_vm.twoManUrl,"multiple":_vm.twoManMultiple},model:{value:(_vm.editingForm.twoMan),callback:function ($$v) {_vm.$set(_vm.editingForm, "twoMan", $$v)},expression:"editingForm.twoMan"}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_replaceTaskIdentity_vue__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_replaceTaskIdentity_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_replaceTaskIdentity_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_replaceTaskIdentity_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_replaceTaskIdentity_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_28c69d23_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_replaceTaskIdentity_vue__ = __webpack_require__(1121);
function injectStyle (ssrContext) {
  __webpack_require__(1119)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_replaceTaskIdentity_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_28c69d23_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_replaceTaskIdentity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-input',{attrs:{"placeholder":"","readonly":"","value":_vm.displayValue,"clearable":true},on:{"change":_vm.handleChange}},[_c('template',{slot:"append"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.open}},[_vm._v("选择")])],1)],2),_vm._v(" "),_c('mw-dialog',{ref:"secDialog",attrs:{"size":"small_small","footerButton":_vm.footerButton,"close-on-click-modal":false}},[_c('el-col',{attrs:{"span":12}},[_c('mw-tree',{ref:"tree",attrs:{"url":_vm.deptTreeUrl,"async":true,"expandedFirst":true,"multiple":false},on:{"changed":_vm.changed}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('mw-table',{ref:"dataTable",attrs:{"columns":_vm.columns,"defaultParamsAutoLoad":true,"autoLoad":false,"pagination":false,"defaultParams":_vm.defaultParams,"api":_vm.api,"singleSelect":true}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"","title":"转换办理人","footerButton":_vm.footerButton}},[_c('div',{staticStyle:{"padding":"10px"}},[_c('el-form',{ref:"editingFormRef",attrs:{"model":_vm.editingForm,"label-width":"150px","rules":_vm.editingRule}},[_c('el-form-item',{attrs:{"label":"在办节点","prop":"oneNode"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.editingForm.oneNode),callback:function ($$v) {_vm.$set(_vm.editingForm, "oneNode", $$v)},expression:"editingForm.oneNode"}},_vm._l((_vm.unfinishedTaskQueue),function(item){return _c('el-option',{key:item.id,attrs:{"label":((item.name||'') + "-" + (item.department||'') + "-" + (item.candidateName||'')).replace(/-$|^-|--/g, ''),"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"办理人","prop":"twoMan"}},[_c('all-man-select',{model:{value:(_vm.editingForm.twoMan),callback:function ($$v) {_vm.$set(_vm.editingForm, "twoMan", $$v)},expression:"editingForm.twoMan"}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_forceWithdraw_vue__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_forceWithdraw_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_forceWithdraw_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_forceWithdraw_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_forceWithdraw_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_316328d6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_forceWithdraw_vue__ = __webpack_require__(1124);
function injectStyle (ssrContext) {
  __webpack_require__(1123)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_forceWithdraw_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_316328d6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_forceWithdraw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"large_small","title":"任务列表","footerButton":_vm.footerButton}},[_c('div',{staticStyle:{"padding":"10px","height":"100%"}},[_c('el-table',{attrs:{"data":_vm.unfinishedTaskQueue,"height":"100%"}},[_c('el-table-column',{attrs:{"prop":"name","label":"任务名称"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createTime","label":"创建时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sender","label":"发送人"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"assigneeName","label":"办理人","formatter":_vm.assigneeNameFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"claimTime","label":"签收时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","align":"center","label":"操作","width":"60"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},nativeOn:{"click":function($event){$event.preventDefault();return _vm.forceWithdraw(scope.$index, scope.row)}}},[_vm._v("\n            回收\n          ")])]}}])})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_editAttachment_vue__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_editAttachment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_editAttachment_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_editAttachment_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_editAttachment_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_553cbde4_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_editAttachment_vue__ = __webpack_require__(1127);
function injectStyle (ssrContext) {
  __webpack_require__(1126)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_editAttachment_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_553cbde4_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_editAttachment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"large_large","title":"编辑附件","footerButton":_vm.footerButton},on:{"opened":_vm.showUpload}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-select',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.$lang('请选择')},model:{value:(_vm.fileType),callback:function ($$v) {_vm.fileType=$$v},expression:"fileType"}},_vm._l((_vm.fileTypes),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1),_vm._v(" "),_c('el-button',{ref:"addAttachmentRef"},[_vm._v("添加")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body mw-app__edit"},[_c('el-table',{attrs:{"height":"100%","data":_vm.attachmentList}},[_c('el-table-column',{attrs:{"label":"序号","width":"40","prop":"sn"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"名称","prop":"name"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('double-face',[_c('span',{attrs:{"slot":"readonly"},slot:"readonly"},[_vm._v(_vm._s(scope.row["name"])+" ")]),_vm._v(" "),_c('span',{attrs:{"slot":"editable"},slot:"editable"},[_c('el-input',{on:{"change":function($event){return _vm.rename(scope.row,scope.$index)}},model:{value:(scope.row['name']),callback:function ($$v) {_vm.$set(scope.row, 'name', $$v)},expression:"scope.row['name']"}})],1)])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"大小","prop":"size","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"类型","prop":"type","width":"60"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.formatType(scope.row.type)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.download(scope.row)}}},[_vm._v("\n              下载\n            ")]),_vm._v(" "),_c('el-button',{attrs:{"id":'uploader_'+scope.row.id,"type":"text","size":"small"},on:{"click":function($event){return _vm.up(scope.row)}}},[_vm._v("\n              替换\n            ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.deleteFile(scope.row)}}},[_vm._v("\n              删除\n            ")])]}}])})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2normalFlow_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2normalFlow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2normalFlow_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2normalFlow_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2normalFlow_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_459c948e_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_jump2normalFlow_vue__ = __webpack_require__(1130);
function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2normalFlow_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_459c948e_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_jump2normalFlow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"","title":"跳至普通节点","footerButton":_vm.footerButton}},[_c('div',{staticStyle:{"padding":"10px"}},[_c('el-form',{ref:"editingFormRef",attrs:{"model":_vm.editingForm,"label-width":"150px","rules":_vm.editingRule}},[_c('el-form-item',{attrs:{"label":"所在节点","prop":"oneNode"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.editingForm.oneNode),callback:function ($$v) {_vm.$set(_vm.editingForm, "oneNode", $$v)},expression:"editingForm.oneNode"}},_vm._l((_vm.unfinishedTaskQueue),function(item){return _c('el-option',{key:item.id,attrs:{"label":((item.name||'') + "-" + (item.department||'') + "-" + (item.candidateName||'')).replace(/-$|^-|--/g, ''),"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"送至节点","prop":"twoNode"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.editingForm.twoNode),callback:function ($$v) {_vm.$set(_vm.editingForm, "twoNode", $$v)},expression:"editingForm.twoNode"}},_vm._l((_vm.nextFlowList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"办理人","prop":"twoMan"}},[_c('all-man-select',{model:{value:(_vm.editingForm.twoMan),callback:function ($$v) {_vm.$set(_vm.editingForm, "twoMan", $$v)},expression:"editingForm.twoMan"}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2concurrenceFlow_vue__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2concurrenceFlow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2concurrenceFlow_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2concurrenceFlow_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2concurrenceFlow_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7b34a95e_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_jump2concurrenceFlow_vue__ = __webpack_require__(1133);
function injectStyle (ssrContext) {
  __webpack_require__(1132)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2concurrenceFlow_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7b34a95e_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_jump2concurrenceFlow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"","title":"并行发送","footerButton":_vm.footerButton}},[_c('div',{staticStyle:{"padding":"10px"}},[_c('el-form',{ref:"editingFormRef",attrs:{"model":_vm.editingForm,"label-width":"150px","rules":_vm.editingRule}},[_c('el-form-item',{attrs:{"label":"完成节点","prop":"oneNode"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.editingForm.oneNode),callback:function ($$v) {_vm.$set(_vm.editingForm, "oneNode", $$v)},expression:"editingForm.oneNode"}},_vm._l((_vm.unfinishedTaskQueue),function(item){return _c('el-option',{key:item.id,attrs:{"label":((item.name||'') + "-" + (item.department||'') + "-" + (item.candidateName||'')).replace(/-$|^-|--/g, ''),"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"完成办理人","prop":"oneMan"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.editingForm.oneMan),callback:function ($$v) {_vm.$set(_vm.editingForm, "oneMan", $$v)},expression:"editingForm.oneMan"}},_vm._l((_vm.taskTransactorList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"送至节点","prop":"twoNode"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.editingForm.twoNode),callback:function ($$v) {_vm.$set(_vm.editingForm, "twoNode", $$v)},expression:"editingForm.twoNode"}},_vm._l((_vm.nextFlowList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"办理人","prop":"twoMan"}},[_c('man-select',{attrs:{"url":_vm.twoManUrl,"multiple":_vm.twoManMultiple},model:{value:(_vm.editingForm.twoMan),callback:function ($$v) {_vm.$set(_vm.editingForm, "twoMan", $$v)},expression:"editingForm.twoMan"}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2multipleInstanceFlow_vue__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2multipleInstanceFlow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2multipleInstanceFlow_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2multipleInstanceFlow_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2multipleInstanceFlow_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_90605252_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_jump2multipleInstanceFlow_vue__ = __webpack_require__(1136);
function injectStyle (ssrContext) {
  __webpack_require__(1135)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jump2multipleInstanceFlow_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_90605252_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_jump2multipleInstanceFlow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"","title":"多实例发送","footerButton":_vm.footerButton}},[_c('div',{staticStyle:{"padding":"10px"}},[_c('el-form',{ref:"editingFormRef",attrs:{"model":_vm.editingForm,"label-width":"150px","rules":_vm.editingRule}},[_c('el-form-item',{attrs:{"label":"所在节点","prop":"oneNode"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.editingForm.oneNode),callback:function ($$v) {_vm.$set(_vm.editingForm, "oneNode", $$v)},expression:"editingForm.oneNode"}},_vm._l((_vm.unfinishedTaskQueue),function(item){return _c('el-option',{key:item.id,attrs:{"label":((item.name||'') + "-" + (item.department||'') + "-" + (item.candidateName||'')).replace(/-$|^-|--/g, ''),"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"办理人","prop":"twoMan"}},[_c('all-man-select',{model:{value:(_vm.editingForm.twoMan),callback:function ($$v) {_vm.$set(_vm.editingForm, "twoMan", $$v)},expression:"editingForm.twoMan"}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_editAuthority_vue__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_editAuthority_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_editAuthority_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_editAuthority_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_editAuthority_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4e978a83_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_editAuthority_vue__ = __webpack_require__(1142);
function injectStyle (ssrContext) {
  __webpack_require__(1138)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_editAuthority_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4e978a83_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_editAuthority_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_authorityEditor_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_authorityEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_authorityEditor_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_authorityEditor_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_authorityEditor_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2fa8f7b6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_authorityEditor_vue__ = __webpack_require__(1141);
function injectStyle (ssrContext) {
  __webpack_require__(1140)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_authorityEditor_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2fa8f7b6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_authorityEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"row-bg",staticStyle:{"height":"100%","position":"relative"},attrs:{"gutter":1}},[_c('el-col',{staticStyle:{"height":"100%"},attrs:{"span":8}},[_c('div',{style:(_vm.titleStyle)},[_vm._v("身份列表")]),_vm._v(" "),_c('div',{style:(_vm.bodyStyle)},[_c('el-tree',{staticStyle:{"height":"100%","overflow":"auto"},attrs:{"lazy":"","load":_vm.loadNavTree,"props":_vm.defaultTreeProps,"expand-on-click-node":false},on:{"node-click":_vm.handleNav}})],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"height":"100%"},attrs:{"span":8}},[_c('div',{style:(_vm.titleStyle)},[_vm._v("身份明细")]),_vm._v(" "),_c('div',{style:(_vm.bodyStyle)},[_c('el-tree',{ref:"detailTree",staticStyle:{"height":"100%","overflow":"auto"},attrs:{"lazy":"","load":null,"show-checkbox":"","default-expanded-keys":_vm.detailTreeDefaultExpanedKeys,"node-key":_vm.USEDID,"props":_vm.defaultTreeProps,"expand-on-click-node":false,"check-on-click-node":"","default-checked-keys":_vm.detailTreeDefaultCheckKeys,"filter-node-method":_vm.filterNodeMethod},on:{"node-click":_vm.handleDetail,"check-change":_vm.handleDetailTreeCheckChange}})],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"height":"100%"},attrs:{"span":8}},[_c('div',{style:(_vm.titleStyle)},[_vm._v("已选身份")]),_vm._v(" "),_c('div',{style:(_vm.bodyStyle)},[_c('el-tree',{staticStyle:{"height":"100%","overflow":"auto"},attrs:{"data":_vm.value,"renderContent":_vm.renderContent}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"large_large","title":"修改读作者域","footerButton":_vm.footerButton},on:{"closed":_vm.handleClose}},[_c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{on:{"click":function($event){return _vm.addAuthorAuthority()}}},[_vm._v("分配作者域权限")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.addReaderAuthority()}}},[_vm._v("分配读者域权限")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){return _vm.deleteAuthority()}}},[_vm._v("删除")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-table',{ref:"table",staticStyle:{"height":"100%"},attrs:{"height":"100%","border":"","data":_vm.authorityList}},[_c('el-table-column',{attrs:{"type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"授权对象名"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"授权对象ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"授权类型"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type==='authors')?_c('span',[_vm._v("作者域")]):_vm._e(),_vm._v(" "),(scope.row.type==='readers')?_c('span',[_vm._v("读者域")]):_vm._e()]}}])})],1)],1),_vm._v(" "),_c('mw-dialog',{ref:"dialog2",attrs:{"size":"small_large","title":_vm.dialog2Title,"footerButton":_vm.footerButton2}},[_c('authority-editor',{model:{value:(_vm.currentAuthority),callback:function ($$v) {_vm.currentAuthority=$$v},expression:"currentAuthority"}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_recycle_vue__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_recycle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_recycle_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_recycle_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_recycle_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_320ce5e9_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_recycle_vue__ = __webpack_require__(1145);
function injectStyle (ssrContext) {
  __webpack_require__(1144)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_recycle_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_320ce5e9_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_recycle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mw-dialog',{ref:"dialog",attrs:{"size":"large_large","title":"恢复作废文件"}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{on:{"click":_vm.active}},[_vm._v("恢复")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body mw-app__edit"},[_c('div',{staticClass:"mw-pagination__body"},[_c('el-table',{staticClass:"mw-table",staticStyle:{"width":"100%"},attrs:{"stripe":"","border":"","data":_vm.dataList,"height":"100%"},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"40"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"businessName","label":"标题","width":"350"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"当前环节","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sender","label":"发件人","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"suspendTime","label":"删除时间","width":"160"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"mw-pagination"},[_c('simple-pagination',{on:{"input":_vm.updateTable},model:{value:(_vm.pagination),callback:function ($$v) {_vm.pagination=$$v},expression:"pagination"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-right"},[_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{on:{"click":_vm.changeFormData}},[_vm._v("修改字段")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.editAuthority}},[_vm._v("修改读作者域")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.changeComment}},[_vm._v("修改意见")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.complete}},[_vm._v("强制办毕")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.replaceTaskIdentity}},[_vm._v("转换办理人")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.terminate}},[_vm._v("强制办结")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.killTask}},[_vm._v("作废")]),_vm._v(" "),_c('el-dropdown',{on:{"command":_vm.handleCommand}},[_c('el-button',[_vm._v("\n          节点跳转"),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"jump2normalFlow"}},[_vm._v("普通流向")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"jump2concurrenceFlow"}},[_vm._v("并行发送")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"jump2multipleInstanceFlow"}},[_vm._v("多实例发送")])],1)],1),_vm._v(" "),_c('el-button',{on:{"click":_vm.forceWithdraw}},[_vm._v("强制回收")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.editAttachment}},[_vm._v("编辑正文/附件")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body mw-app__edit"},[_c('div',{staticClass:"mw-pagination__body"},[_c('el-table',{staticClass:"mw-table",staticStyle:{"width":"100%"},attrs:{"stripe":"","border":"","height":"100%","data":_vm.dataList},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"40"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"文件标题"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openForm(scope.row)}}},[_vm._v(_vm._s(scope.row.businessName))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"processDefinitionName","label":"所属流程","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"currentTaskName","label":"当前环节","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"currentTransactor","label":"当前办理人","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startTime","label":"创建时间","width":"170"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startUserName","label":"创建人","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"当前状态","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.suspensionState === '2' ? '已挂起' : ["正在办理", "已办结"][scope.row.flowStatus])+"\n            ")]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"mw-pagination"},[_c('simple-pagination',{on:{"input":_vm.updateTable},model:{value:(_vm.pagination),callback:function ($$v) {_vm.pagination=$$v},expression:"pagination"}})],1)])]),_vm._v(" "),_c('ChangeFormData',{ref:"changeFormDataRef",on:{"updateTable":_vm.updateTable}}),_vm._v(" "),_c('ChangeComment',{ref:"changeComment"}),_vm._v(" "),_c('Complete',{ref:"complete",on:{"updateTable":_vm.updateTable}}),_vm._v(" "),_c('ReplaceTaskIdentity',{ref:"replaceTaskIdentity",on:{"updateTable":_vm.updateTable}}),_vm._v(" "),_c('ForceWithdraw',{ref:"forceWithdraw",on:{"updateTable":_vm.updateTable}}),_vm._v(" "),_c('EditAttachment',{ref:"editAttachment",on:{"updateTable":_vm.updateTable}}),_vm._v(" "),_c('Jump2normalFlow',{ref:"jump2normalFlow",on:{"updateTable":_vm.updateTable}}),_vm._v(" "),_c('Jump2concurrenceFlow',{ref:"jump2concurrenceFlow",on:{"updateTable":_vm.updateTable}}),_vm._v(" "),_c('Jump2multipleInstanceFlow',{ref:"jump2multipleInstanceFlow",on:{"updateTable":_vm.updateTable}}),_vm._v(" "),_c('edit-authority',{ref:"editAuthority",on:{"updateTable":_vm.updateTable}}),_vm._v(" "),_c('Recycle',{ref:"recycle",on:{"updateTable":_vm.updateTable}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"appendToBody":false,"title":_vm.title,"size":"large_large"}},[_c('div',{staticClass:"mw-margin-top-10 process-dialog"},[_c('MwFlowInterferingTable',{attrs:{"filterParams":_vm.params}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_urge_process_vue__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_urge_process_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_urge_process_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_urge_process_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_urge_process_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4420a5cd_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_urge_process_vue__ = __webpack_require__(1149);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_urge_process_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4420a5cd_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_urge_process_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"title":"催办","appendToBody":false,"size":"small_small","footerButton":_vm.footerButton,"before-close":_vm.handleClose}},[_c('div',{staticClass:"mw-toolbar__body,mw-margin-top-10",staticStyle:{"margin-top":"20px"}},[[_c('el-form',{ref:"urgeForm",attrs:{"label-width":"130px","model":_vm.form}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"题名"}},[_c('el-input',{staticStyle:{"width":"70%"},attrs:{"readonly":""},model:{value:(_vm.form.businessName),callback:function ($$v) {_vm.$set(_vm.form, "businessName", $$v)},expression:"form.businessName"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"催办信息"}},[_c('el-input',{staticStyle:{"width":"70%"},attrs:{"type":"textarea"},model:{value:(_vm.form.message),callback:function ($$v) {_vm.$set(_vm.form, "message", $$v)},expression:"form.message"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"通知人"}},[_c('el-checkbox-group',{on:{"change":_vm.handleChange},model:{value:(_vm.notifierId),callback:function ($$v) {_vm.notifierId=$$v},expression:"notifierId"}},[_vm._l((_vm.params.data),function(list){return _vm._l((list.transactors),function(item){return _c('el-col',{key:item.id,attrs:{"span":9}},[_c('el-checkbox',{key:item.name,attrs:{"label":item.id}},[_vm._v(_vm._s(item.name))])],1)})})],2)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"通知方式"}},[[_c('el-checkbox-group',{on:{"change":_vm.handleNoticeChange},model:{value:(_vm.noticeWay),callback:function ($$v) {_vm.noticeWay=$$v},expression:"noticeWay"}},[_c('el-checkbox',{key:1,attrs:{"label":"1"}},[_vm._v("发送短信")]),_vm._v(" "),_c('el-checkbox',{key:2,attrs:{"label":"2"}},[_vm._v("即时消息")])],1)]],2)],1)],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_turnto_process_vue__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_turnto_process_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_turnto_process_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_turnto_process_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_turnto_process_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_656a2814_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_turnto_process_vue__ = __webpack_require__(1151);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_turnto_process_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_656a2814_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_turnto_process_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"small_small","appendToBody":false,"footerButton":_vm.footerButton,"title":_vm.$lang('选择用户')}},[_c('el-col',{attrs:{"span":12}},[_c('mw-tree',{staticClass:"mw-dialog-body",attrs:{"url":_vm.deptTreeUrl,"async":true,"expandedFirst":true,"defaultParams":_vm.defaultTreeParams,"multiple":false,"aliasId":_vm.treeAliasId},on:{"dataFilter":_vm.treeDataFilter,"changed":_vm.changed}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('mw-table',{ref:"dataTable",attrs:{"columns":_vm.columns,"defaultParamsAutoLoad":true,"autoLoad":false,"pagination":false,"defaultParams":_vm.defaultParams,"api":_vm.api,"singleSelect":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_blank_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_blank_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_blank_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_blank_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_blank_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_35343ab6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_blank_vue__ = __webpack_require__(1153);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_blank_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_35343ab6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_blank_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_form_vue__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6b1abba6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_form_vue__ = __webpack_require__(1155);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6b1abba6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"appendToBody":false,"size":_vm.size,"width":_vm.width,"height":_vm.height,"customClass":_vm.params.type=='normal'?'mw-normal-form':'mw-flow-form',"beforeClose":_vm.beforeClose,"title":_vm.title?_vm.title:''}},[_c('MwForm',{ref:"form",attrs:{"dialog":_vm.dialog,"initValue":_vm.params.initValue?_vm.params.initValue:{},"propModuleId":_vm.params.moduleId,"propFlowKey":_vm.params.key,"propAppId":_vm.params.appId,"propTempTableName":_vm.params.tempTableName,"propReadOnly":(_vm.params.readOnly!=undefined)?_vm.params.readOnly:false,"propBusinessId":_vm.params.businessId,"propLoading":_vm.params.loading,"propDraftsDocId":_vm.params.draftsDocId,"propBatchId":_vm.params.batchId,"propTempBusinessId":_vm.params.tempBusinessId,"propFormOpenSource":_vm.params.formOpenSource?_vm.params.formOpenSource:'form',"flowModuleNotShowRightPanel":(_vm.params.flowModuleNotShowRightPanel==undefined)?false:_vm.params.flowModuleNotShowRightPanel,"propTaskId":_vm.params.taskId,"propProcessDefinitionId":_vm.params.processDefinitionId,"autoClaim":(_vm.params.autoClaim==undefined)?true:_vm.params.autoClaim,"forceModuleForm":(_vm.params.forceModuleForm==undefined)?false:_vm.params.forceModuleForm,"extParams":_vm.params.extParams,"propEditMode":(_vm.params.editMode!=undefined)?_vm.params.editMode:true,"propDraftsDeptId":_vm.params.draftsDeptId},on:{"getTitle":_vm.getTitle,"beforeRender":_vm.beforeRender,"configLoaded":_vm.formConfigLoaded,"formActionComplete":_vm.formActionComplete,"updatedData":_vm._updatedData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_operationRecord_vue__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_operationRecord_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_operationRecord_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_operationRecord_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_operationRecord_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_179435bc_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_process_operationRecord_vue__ = __webpack_require__(1157);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_process_operationRecord_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_179435bc_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_process_operationRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"appendToBody":false,"title":_vm.$lang('查看操作记录'),"size":"large_large","customClass":"mw-form-view-dialog"}},[_c('div',{staticClass:"mw-margin-top-10 process-dialog"},[_c('mw-table',{attrs:{"api":_vm.api,"columns":_vm.columns,"pagination":false,"nowrap":false,"defaultParams":_vm.defaultParams,"defaultParamsAutoLoad":true}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_preview_vue__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_preview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_preview_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_preview_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_preview_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_273c1214_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_view_preview_vue__ = __webpack_require__(1159);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_preview_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_273c1214_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_view_preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"view","width":_vm.params.width ? _vm.params.width : '',"beforeClose":_vm.beforeClose,"height":_vm.params.height ? _vm.params.height : '',"customClass":"dialog__preView","closeOnClickModal":true,"appendToBody":false,"title":_vm.params.title || '视图预览'}},[_c('mw-view',{attrs:{"id":_vm.params.id,"params":_vm.params.params,"tableParams":_vm.params.tableParams}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_select_vue__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_select_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_select_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_select_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4a0eb00d_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_view_select_vue__ = __webpack_require__(1161);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_view_select_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4a0eb00d_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_view_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"large_large","width":_vm.params.width ? _vm.params.width : '',"height":_vm.params.height ? _vm.params.height : '',"customClass":"dialog__preView","footerButton":_vm.footerButton,"closeOnClickModal":true,"appendToBody":false,"title":_vm.params.title || '选择'}},[_c('mw-view',{ref:"view",attrs:{"id":_vm.params.id,"params":_vm.propParams,"tableParams":_vm.params.tableParams}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_edit_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_edit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_edit_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_edit_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_edit_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_01afc9c6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_comment_edit_vue__ = __webpack_require__(1163);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_comment_edit_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_01afc9c6_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_comment_edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"title":_vm.$lang('编辑常用意见'),"appendToBody":false,"size":"small_small","footerButton":_vm.sugButton}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.addOpinion}},[_c('i',{staticClass:" fa fa-plus-square"}),_vm._v(_vm._s(_vm.$lang("添加")))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding-right":"20px"}},[_vm._v(_vm._s(_vm.$lang("备注：意见拖动排序")))])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-table',{ref:"multipleTable",staticClass:"mw-table mw-edit-comment",staticStyle:{"cursor":"pointer"},attrs:{"data":_vm.comment,"show-header":false}},[_c('el-table-column',{attrs:{"prop":"title","width":"450","label":_vm.$lang('意见')}}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"icon":"el-icon-delete","size":"small"},on:{"click":function($event){return _vm.handleDelete(scope.$index, scope.row)}}},[_vm._v(_vm._s(_vm.$lang("删除")))]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-edit","size":"small"},on:{"click":function($event){return _vm.editOpinion(scope.$index, scope.row)}}},[_vm._v(_vm._s(_vm.$lang("编辑")))])]}}])})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4f38bdd9_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_attachment_vue__ = __webpack_require__(1165);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_attachment_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4f38bdd9_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_attachment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"title":_vm.title,"appendToBody":false,"size":"small_large","beforeClose":_vm.beforeClose}},[_c('mw-upload-table',{attrs:{"action":_vm.action,"limit":_vm.limit,"addShow":_vm.addShow,"deleteShow":_vm.deleteShow,"renameShow":_vm.renameShow,"downloadShow":_vm.downloadShow,"recordsIsCanEdit":_vm.recordsIsCanEdit,"sortable":_vm.sortable,"defaultParams":_vm.defaultParams,"api":_vm.api},on:{"dataLoaded":_vm.tableDataLoaded}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_editor_vue__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_editor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_editor_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_editor_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_editor_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_dae08ee4_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_ntko_editor_vue__ = __webpack_require__(1167);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_editor_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_dae08ee4_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_ntko_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"title":_vm.title,"appendToBody":false,"size":"full","before-close":_vm.closeWindow}},[_c('mw-ntko-editor',{ref:"editor",attrs:{"defButtons":_vm.buttons,"propObject":_vm.propObject}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_attachment_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_attachment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_attachment_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_attachment_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_attachment_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_a82a5d5a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_ntko_attachment_vue__ = __webpack_require__(1169);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_ntko_attachment_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_a82a5d5a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_ntko_attachment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"title":_vm.$lang('附件管理'),"appendToBody":false,"size":"large_mini"}},[_c('mw-ntko-attachment',{attrs:{"defButtons":_vm.buttons,"propObject":_vm.propObject},on:{"dataLoaded":_vm.tableDataLoaded}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_23aeaf80_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1172);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_23aeaf80_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default = {
  open: function open(callback) {
    var request = window.indexedDB.open("dev-local-history");
    request.onsuccess = function (event) {
      var db = event.target.result;
      var tx = db.transaction('defaultStore', 'readwrite');
      var store = tx.objectStore('defaultStore');
      callback(db, store);
    };
    request.onupgradeneeded = function (event) {
      var db = event.target.result;
      var store = db.createObjectStore('defaultStore', { autoIncrement: true });
      store.createIndex('key', 'key', { unique: false });
    };
  },
  add: function add(key, data, callback) {
    var me = this;
    this.open(function (db, store) {
      var req = store.add({ data: data, time: new Date().getTime(), key: key });
      req.onsuccess = function () {
        if (callback) callback();
        db.close();
        setTimeout(function () {
          me.clear();
        }, 10);
      };
    });
  },
  get: function get(key, callback) {
    this.open(function (db, store) {

      var keyIndex = store.index("key");
      var req = void 0;
      if (key) {
        req = keyIndex.openCursor(IDBKeyRange.only(key));
      } else {
        req = keyIndex.openCursor();
      }
      var records = [];
      req.onsuccess = function (event) {
        var cursor = event.target.result;
        if (cursor) {
          var d = (0, _assign2.default)({}, cursor.value);
          d.primaryKey = cursor.primaryKey;
          records.push(d);
          cursor.continue();
        } else {
          callback(records);
        }
      };
    });
  },
  clear: function clear() {var _this = this;
    this.get(null, function (records) {

      var deleteKeys = _(records).groupBy("key").
      mapValues(function (v) {return _.sortBy(v, "time").reverse().slice(19).map(function (o) {return o.primaryKey;});}).
      values().flatten().value();
      _this.open(function (db, store) {
        deleteKeys.forEach(function (k) {return store.delete(k);});
      });
    });
  } };

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-edit",staticStyle:{"overflow":"hidden"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MwInnerView_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MwInnerView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MwInnerView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MwInnerView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MwInnerView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3ea3c1ea_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_MwInnerView_vue__ = __webpack_require__(1271);
function injectStyle (ssrContext) {
  __webpack_require__(1174)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ea3c1ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_MwInnerView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3ea3c1ea_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_MwInnerView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_deptUser_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_deptUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_deptUser_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_deptUser_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_deptUser_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_fd6ce37c_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_deptUser_vue__ = __webpack_require__(1195);
function injectStyle (ssrContext) {
  __webpack_require__(1177)
  __webpack_require__(1178)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd6ce37c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_deptUser_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_fd6ce37c_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_deptUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);var _extends2 = __webpack_require__(2);var _extends3 = _interopRequireDefault(_extends2);var _loadManager = __webpack_require__(139);var _loadManager2 = _interopRequireDefault(_loadManager);
var _chooseSecretary = __webpack_require__(1182);var _chooseSecretary2 = _interopRequireDefault(_chooseSecretary);
var _choosePost = __webpack_require__(1184);var _choosePost2 = _interopRequireDefault(_choosePost);
var _staffLevel = __webpack_require__(1186);var _staffLevel2 = _interopRequireDefault(_staffLevel);
var _infothirdLevel = __webpack_require__(1188);var _infothirdLevel2 = _interopRequireDefault(_infothirdLevel);
var _zgDept = __webpack_require__(1190);var _zgDept2 = _interopRequireDefault(_zgDept);
var _firstDept = __webpack_require__(413);var _firstDept2 = _interopRequireDefault(_firstDept);
var _queryRoles = __webpack_require__(1193);var _queryRoles2 = _interopRequireDefault(_queryRoles);
var _token = __webpack_require__(25);var _token2 = _interopRequireDefault(_token);
var _vuex = __webpack_require__(9);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{

    components: {
        loadMan: _loadManager2.default,
        chooseSec: _chooseSecretary2.default,
        choosePost: _choosePost2.default,
        staff: _staffLevel2.default,
        infothird: _infothirdLevel2.default,
        zgdept: _zgDept2.default,
        first: _firstDept2.default,
        queryrole: _queryRoles2.default },

    props: {
        params: Object },

    data: function data() {
        var readMode = this.params && this.params.readMode;
        var noResetPwd = this.params && this.params.noResetPwd;
        var showSaveBtn = this.params && this.params.showSaveBtn;
        var listAble = this.params && this.params.listAble;
        return {
            readMode: readMode,
            noResetPwd: noResetPwd,
            showSaveBtn: showSaveBtn,
            showHandOver: window.$Env && $Env.showHandOverBtn ? true : false,
            listAble: listAble,

            checkedId: '',
            userIdentityId: '',

            nodeText: '',
            identityId: '',

            init: true,
            init1: true,

            firstDeptOpen: true,
            firstUserOpen: true,
            firstImpDeptOpen: true,
            firstImpUserOpen: true,
            firstUserDialogOpen: true,
            edit: false,
            editUser: false,
            isLimit: false,
            deptTreeUrl: '',
            showMJBS: false,
            defaultParams1: null,
            menuItem1: [],
            expandFlag: 2,
            primaryDUrl: this.mwUrl('/api/org/getUserDepartmentFullPath'),
            userInfo1: [],
            userLevelOption: [],
            btns: [{
                label: '取消',
                func: this.cancelChoose,
                type: 'default' },
            {
                label: '确定',
                func: this.addTransUserDept }],

            btns1: [{
                label: '取消',
                func: this.cancelChoose1,
                type: 'default' },
            {
                label: '确定',
                func: this.expChooseDeptUser },
            {
                label: '全展开',
                func: this.openAll },
            {
                label: '全选',
                func: this.checkAll },
            {
                label: '不选',
                func: this.unCheckAll }],

            deptBtns: [{
                label: '确定',
                func: this.pDeptSure },
            {
                label: '取消',
                func: this.cancelChoosePDept,
                type: 'default' }],


            userFooterButton: [
            { label: '确定', func: this.chooseAdminSure },
            { label: '取消', func: this.cancelChooseAdmin, type: 'default' }],


            imageUrl: '',
            layout: [],
            deptManagers: [],
            types: {
                "1": {
                    "icon": "fa fa-folder" },

                "2": {
                    "icon": "fa fa-leaf" },

                "3": {
                    "icon": "fa fa-users" },

                'default': {
                    "icon": "fa fa-leaf" } },


            menuItem: [{ name: 'add', icon: 'fa fa-plus-square', label: '添加', func: this.addDepart },
            {
                name: 'edit',
                label: '编辑',
                icon: 'fa fa-pencil fa-fw',
                func: this.editDept },

            {
                name: 'delete',
                label: '删除',
                icon: 'fa fa-trash-o',
                func: this.deleteDepartment }],


            education: [{
                label: '小学',
                value: '1' },
            {
                label: '初中',
                value: '2' },
            {
                label: '高中',
                value: '3' },
            {
                label: '本科',
                value: '4' },
            {
                label: '专科',
                value: '5' },
            {
                label: '硕士',
                value: '6' },
            {
                label: '博士',
                value: '7' },
            {
                label: '博士后',
                value: '8' }],

            dept: {
                name: '',
                shortname: '',
                Englishname: '',
                id: '',
                flag: '1',
                adminName: '',
                adminId: '',
                sn: '',
                listAble: '1',
                parentId: '',
                parentName: '',
                code: '' },


            user: {
                loginId: '',
                name: '',
                sex: '1',
                initial: '',
                pinyin: '',
                Englishname: '',
                password: '',
                email: '',
                label: '',
                applicationIdentityId: '',
                staffId: '',
                departmentName: '',
                departmentId: '',
                sn: '',
                phone: '',
                mobile: '',
                position: '',
                secretary: '',
                secretaryId: '',
                jobs: '',
                isSecret: '1',
                timeOfJoinInWork: '',
                workyear_: '',
                edu: '',
                userLevel: '',
                birth: '',
                age_: '',
                idNumber: '',
                weiChatNum: '',
                listAble: '1',
                roleNames: '',
                roleid: '',
                departmentIdentityId: '',
                companyEmail: '',
                zgdept: '',
                zgdeptid: '',
                staffLevel: '',
                secondRank: '',
                thirdRank: '',
                mjbs: '',
                persontype: '1',
                firstLevelDept: '',
                firstLevelDeptId: '',
                secondLevelDept: '',
                secondLevelDeptId: '',
                thirdLevelDept: '',
                thirdLevelDeptId: '',
                primaryDepartmentName: '',
                primaryDepartmentId: '',
                bindIP: '',
                avatarAttachId: '' },


            rules: {
                loginId: [
                { required: true, message: "请输入账号", trigger: 'blur' }],

                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                password: [
                { required: true, message: '请输入密码', trigger: 'blur' }],

                applicationIdentityId: [
                { required: true, message: '请输入编码', trigger: 'blur' }],

                initial: [
                { required: true, message: '请输入该人员姓名首字母', trigger: 'blur' }] },



            deptRule: {
                name: [{ required: true, message: "请输入名称", trigger: 'blur' }] },


            defaultParentId: '',


            addUserDept: false,
            exportDept: false,
            firstTime: true,
            loading: false,
            activeName: 'basic',
            staffLevel: false,
            info3: false,
            primaryTree: true,
            secFirst: false,
            showBtn: false,
            showJBBtn: false,
            defaultParams: {
                formId: 'e12www44134',
                businessId: 'e12www44134',
                type: 'e12www44134',
                tempBusinessId: 'e12www44134',
                flag: 'avatar' },

            headers: {},
            avatarStyle: {
                width: '120px',
                height: '120px' },

            fileList: [],

            signUrl: '',
            signParams: {
                formId: 'wtrgng6623',
                businessId: 'wtrgng6623',
                type: 'wtrgng6623',
                tempBusinessId: 'wtrgng6623' },

            fileSignList: [],

            buttons: [],
            action: this.mwUrl('/api/business/uploadAttachment'),
            importAction: '/api/org/importDepartmentUserFromExcel',
            importDeptAction: '/api/org/importDepartmentFromExcel',
            deptImpBtn: [{
                label: "取消",
                func: this.impDeptCancel,
                type: "default" }],

            leadButton: [{
                label: "取消",
                func: this.impUserCancel,
                type: "default" }],

            handOverTodoButton: [
            { label: '确定', func: this.chooseHandOverTodoSure },
            { label: '取消', func: this.cancelHandOverTodo, type: 'default' }],

            handOverFinishButton: [
            { label: '确定', func: this.chooseHandOverFinishSure },
            { label: '取消', func: this.cancelHandOverFinish, type: 'default' }],

            hideBtn: false,
            bindForm: {
                bindIP: "",
                userId: "" },

            handOverTodoForm: {
                assigned: '',
                assignedId: '',
                recipient: '',
                recipientId: '' },

            handOverFinishForm: {
                assigned: '',
                assignedId: '',
                recipient: '',
                recipientId: '',
                startTime: '',
                endTime: '',
                moduleName: '',
                moduleId: '' },

            chooseUsersRData: [],
            userSelIsMul: false,
            userSelFooterButton: [
            { label: '确定', func: this.chooseUserSure },
            { label: '取消', func: this.cancelUserSel, type: 'default' }],

            handeOverSelField: { id: '', name: '', type: '' } };

    },
    created: function created() {
        var isSysAdmin = this.isSysAdmin();
        if (this.userInfo.developer || isSysAdmin || this.userInfo.unitAdmin) {
            this.showBtn = true;
        } else {
            this.menuItem = [];
        }
        if (this.params && this.params.projectName && this.params.projectName == "hg") {
            this.showMJBS = true;
            this.hideBtn = true;
        }
        if (this.params && this.params.showJBBtn) {
            this.showJBBtn = this.params.showJBBtn;
        }
        if (this.params && this.params.showBtn) {
            this.showBtn = this.params.showBtn;
        }

        this.buttons = this.showBtn == true && !this.readMode && !this.hideBtn ? [{
            label: '添加',
            icon: 'fa fa-plus-square',
            func: this.addUser },
        {
            label: '删除',
            icon: 'fa fa-trash-o fa-fw',
            func: this.deleteUser }] :
        [];
        this.buttons.push({
            label: '查看角色',
            icon: 'fa ',
            func: this.roleLookUp });

    },

    mounted: function mounted() {

        var me = this;

        me.layout = [
        [{
            span: 0,
            type: 'menu',
            label: '组织人员',
            api: 'org.listDepartmentUserPaging',
            defaultParams: { noIdentityInfo: "false", notShowRoleName: true },
            defaultSort: [{ sort: 'sn', dir: 'desc' }],
            nowrap: false,
            columns: [
            { type: 'selection', reserve: true },
            { label: '序号', prop: 'sn', width: '55' },

            { slot: { type: "href", func: me.dbHandleRow }, prop: 'name', width: '100', label: '姓名', tooltip: true },
            { prop: 'loginId', label: '帐号', tooltip: true, width: '100' },
            { prop: 'phone', label: '座机电话', width: '113', tooltip: true },
            { prop: 'mobile', label: '移动电话', width: '113', tooltip: true },
            { prop: 'email', label: '电子邮箱', tooltip: true, width: '150' },
            { prop: 'departmentFullName', label: '组织', tooltip: true, formatter: me.departmentFullNameFormatter }] },



        {
            span: 18,
            type: 'button',
            items: this.buttons,
            suffixSlot: "dropDown" },

        {
            span: 5,
            type: 'searchText',
            offset: 0,
            name: 'qcon',
            tip: "姓名,帐号等" },
        {
            span: 1,
            type: 'custom',
            items: [] }]];



        var isSysAdmin = this.isSysAdmin();
        if ((this.userInfo.developer || isSysAdmin) && !this.listAble) {
            var api = '/api/org/listDepartmentAndCount?t=' + Date.now();
            this.deptTreeUrl = this.mwUrl(api);
        } else {
            if (this.userInfo.unitAdmin || this.userInfo.departmentAdmin || this.listAble) {
                var rootId = void 0;
                if (this.expUser.dep.loginUnit) {
                    rootId = this.expUser.dep.loginUnit.id;
                } else {
                    rootId = this.expUser.dep.loginRootDept.id;
                }
                this.defaultParams1 = { rootId: rootId, t: Date.now() };
                if (this.listAble) this.defaultParams1.listAble = true;
                var _api = '/api/org/getDepartmentTreeCount';

                this.deptTreeUrl = this.mwUrl(_api);
                if (this.showBtn == true) {
                    this.menuItem1 = this.menuItem;
                } else if (this.userInfo.departmentAdmin) {

                }
            }
        }
        me.$nextTick(function () {
            if (!me.hideBtn) {
                $(me.$el).find("[toolbar_custom_area='true']").append("<button id=\"showhelp\" style=\"float:right;padding-left: 0;padding-right: 0;width: 30px;text-align: center;\" type=\"button\" class=\"el-button el-button--info\"><span class=\"text-center\"><i class=\"fa fa-question\" style=\"padding-right: 0;margin-right: 0;\"></i><span>" + $lang('') + "</span></span></button>");
                $("#showhelp").click(function () {
                    me.showHelp();
                });
            }
            me.processSelRowData();
            me.showTreeRightPanel();
            if (this.params && this.params.isSaveQueryUserLog == true)
            me.queryUserLog();
        });
    },

    computed: (0, _extends3.default)({},
    (0, _vuex.mapGetters)([
    'userInfo',
    'expUser']), {

        birth: function birth() {
            return this.user.birth;
        },
        timeOfJoinInWork: function timeOfJoinInWork() {
            return this.user.timeOfJoinInWork;
        } }),

    watch: {
        birth: function birth(newValue, oldValue) {
            this.user.age_ = this.ageNum(newValue);
        },
        timeOfJoinInWork: function timeOfJoinInWork(newValue, oldValue) {
            this.user.workyear_ = this.ageNum(newValue);
        } },

    methods: {
        showUserUpload: function showUserUpload() {
            if (this.firstImpUserOpen) {
                this.initUploader("user");
                this.firstImpUserOpen = false;
            }
        },
        tableRowStyle: function tableRowStyle(row, index, ret) {
            if (row.row.listAble == "2") {
                ret["background-color"] = "#ddd";
            }
        },
        treeDataFilter: function treeDataFilter(data) {
            var me = this;
            if (data) {
                _.each(data, function (d) {
                    if (d.listAble == "2") {
                        d.icon = "fa fa-ban";

                    }
                });
            }
        },
        showTreeRightPanel: function showTreeRightPanel() {
            var me = this;
            if (me.userInfo.developer || me.isSysAdmin() || me.userInfo.unitAdmin) {
                var contextMenu = PF.contextMenu({
                    el: me.$refs.deptTreePanelDiv,
                    target: '.mw-toolbar__body',
                    items: [{
                        text: "添加",
                        icon: "fa fa-plus",
                        handler: function handler() {

                            me.addDepart(null, true);
                        } }] });


                me.$on("hook:destroyed", function () {contextMenu.destroy();});
            }
        },
        showDeptUpload: function showDeptUpload() {
            if (this.firstImpDeptOpen) {
                this.initUploader('dept');
                this.firstImpDeptOpen = false;
            }
        },
        initUserImg: function initUserImg() {
            if (this.firstUserDialogOpen) {
                this.$nextTick(function () {

                    this.initUserImgUploader('sign');

                    this.initUserImgUploader('signPlus');


                    this.initUserImgUploader('img');

                    this.initUserImgUploader('imgPlus');
                    this.firstUserDialogOpen = false;
                });
            }
        },
        initUserImgUploader: function initUserImgUploader(type) {
            var me = this;
            var btnId = void 0,params = void 0;
            var url = me.action;
            if (type == "img" || type == "imgPlus") {
                if (type == "img") {
                    btnId = me.mwRef('imgUploader').$el;
                } else {
                    btnId = me.mwRef('imgPlusUploader');
                }
                if (me.user.id) {
                    url = "/api/data/saveUserAvatar";
                    params = { userId: me.user.id };
                } else {
                    params = me.defaultParams;
                }
            } else if (type == "sign") {
                btnId = me.mwRef('signUploader').$el;
                params = me.signParams;
            } else if (type == "signPlus") {
                btnId = me.mwRef('signPlusUploader');
                params = me.signParams;
            }
            var cfg = {
                buttonId: btnId,
                maxSize: 500,
                action: url,
                title: "图片文件",
                accept: "jpg,jpeg,gif,png,bmp,tif",
                params: params };

            var fn = {
                uploadFile: function uploadFile(up, file) {
                    if (type == "img" || type == "imgPlus") {
                        return me.beforeAvatarUpload(up, file);
                    } else if (type == "sign" || type == "signPlus") {
                        return me.beforeSignUpload(up, file);
                    }
                },
                fileUploaded: function fileUploaded(up, file, resp) {
                    if (type == "img" || type == "imgPlus")
                    me.handleAvatarSuccess(resp, file, up);else
                    if (type == "sign" || type == "signPlus")
                    me.handleSignSuccess(resp, file, up);
                } };

            PF.initPupload(cfg, fn);
        },
        initUploader: function initUploader(type) {
            var me = this;
            var btnId = void 0,action = void 0;
            if (type == "user") {
                btnId = me.mwRef('UserUploader').$el;
                action = me.importAction;
            } else {
                btnId = me.mwRef('DeptUploader').$el;
                action = me.importDeptAction;
            }

            var cfg = {
                buttonId: btnId,
                maxSize: 500,
                action: action,
                accept: "xls" };

            var fn = {
                fileUploaded: function fileUploaded(up, file, resp) {
                    if (type == "user")
                    me.importSuccessCallback(resp, file, up);else

                    me.importDeptSuccessCallback(resp, file, up);
                } };

            PF.initPupload(cfg, fn);
        },
        aa: function aa(node, callback) {
            var menuItem = {};
            if (node.id === this.userInfo.loginDepartment.id) {
                menuItem = {
                    'item1': {
                        name: 'add',
                        icon: 'fa fa-plus-square',
                        label: '添加',
                        action: this.addDepart },

                    'item2': {
                        name: 'edit',
                        label: '编辑',
                        icon: 'fa fa-pencil fa-fw',
                        action: this.editDept },

                    'item3': {
                        name: 'delete',
                        label: '删除',
                        icon: 'fa fa-trash-o',
                        action: this.deleteDepartment } };


            }
            callback(menuItem);
        },
        departmentFullNameFormatter: function departmentFullNameFormatter(data) {
            if (data.ID) {
                return data.departmentFullName;
            } else {
                return data.departmentName;
            }
        },
        ageNum: function ageNum(newValue) {
            var age = "";
            if (!newValue) return "0";
            if (new Date().getMonth() > new Date(newValue).getMonth()) {
                age = new Date().getFullYear() - new Date(newValue).getFullYear();
            } else if (new Date().getMonth() == new Date(newValue).getMonth()) {
                if (new Date().getDate() >= new Date(newValue).getDate()) {
                    age = new Date().getFullYear() - new Date(newValue).getFullYear();
                } else {
                    age = new Date().getFullYear() - new Date(newValue).getFullYear() - 1;
                }
            } else {
                age = new Date().getFullYear() - new Date(newValue).getFullYear() - 1;
            }
            return age;
        },
        importDept: function importDept() {
            var me = this;
            me.mwRef("importDeptData").submit();
        },
        importUser: function importUser() {
            var me = this;
            me.mwRef("importData").submit();
        },
        isSysAdmin: function isSysAdmin() {

            if (this.userInfo.allIdentityRoleNames && this.userInfo.allIdentityRoleNames.indexOf("系统管理员") != -1) {
                return true;
            }
            return false;
        },
        importSuccessCallback: function importSuccessCallback(response, file, up) {
            if (response.result) {
                this.mwRef('deptTreeData').refresh();
                PF.show('message', { title: "导入信息", html: response.result[0].errMsg });
                this.mwRef('leadDialog').hide();
            }

            if (this.mwRef("importData") && typeof this.mwRef("importData").clearFiles == "function") {
                this.mwRef("importData").clearFiles();
            } else if (up && up.files && up.files.length > 0 && typeof up.splice == "function") {
                up.splice(0, up.files.length);
            }
        },
        importDeptSuccessCallback: function importDeptSuccessCallback(response, file, up) {
            if (response.result) {
                this.mwRef('deptTreeData').refresh();
                PF.show('message', { title: "导入信息", html: response.result.errMsg });
                this.mwRef('impDeptDialog').hide();
            }

            if (this.mwRef("importDeptData") && typeof this.mwRef("importDeptData").clearFiles == "function") {
                this.mwRef("importDeptData").clearFiles();
            } else if (up && up.files && up.files.length > 0 && typeof up.splice == "function") {
                up.splice(0, up.files.length);
            }
        },

        handleDeptMoreCommand: function handleDeptMoreCommand(command) {
            if (command === 'importDept') {
                this.mwRef('impDeptDialog').show();
            }
            if (command === 'exportDept') {


                this.exportDept = true;
                this.mwRef('addDeptDialog1').show();
                this.initDeptDialog1Data();
            }
        },
        openAll: function openAll() {
            this.mwRef('deptTree1').openAll();
        },
        checkAll: function checkAll() {
            this.openAll();
            this.mwRef('deptTree1').checkAll();
        },
        unCheckAll: function unCheckAll() {
            this.mwRef('deptTree1').unCheckAll();
        },

        expChooseDeptUser: function expChooseDeptUser() {
            var datas = this.mwRef('deptTree1').getSelected();
            var ids = datas.map(function (v) {return v.id;});
            var params = { deptIds: ids };
            if (this.exportDept) {
                this.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportDepartmentToExcel"), {}, false, PF.encode(params));
            } else {
                this.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportDepartmentUserToExcel"), {}, false, PF.encode(params));
            }
            this.mwRef('addDeptDialog1').hide();
        },

        handleMoreCommand: function handleMoreCommand(command) {
            if (command === 'leadIn') {
                this.mwRef('leadDialog').show();
            } else if (command === 'leadOut') {
                this.exportDept = false;
                var dataTable = this.mwRef('dataTable');
                var multipleSelection = dataTable.getMultipleSelection();
                if (multipleSelection && multipleSelection.length > 0) {
                    var userIds = [];
                    var deptIds = {};
                    multipleSelection.forEach(function (val) {
                        userIds.push(val.userId || val.id);
                        deptIds[val.userId || val.id] = val.departmentId;
                    });
                    this.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportDepartmentUserToExcel"), {}, false, PF.encode({ userIds: userIds, deptIds: deptIds }));
                } else {
                    this.mwRef('addDeptDialog1').show();
                    this.initDeptDialog1Data();
                }
            } else if (command === 'removeip') {
                this.removeIp(1);
            } else if (command === 'bindip') {
                this.bindUserIp();
            }
        },
        handOverCommand: function handOverCommand(command) {
            if (command === 'todo') {
                this.handOverTodoForm = {
                    assigned: '',
                    assignedId: '',
                    recipient: '',
                    recipientId: '' };

                this.mwRef('handOverTodo').show();
            } else if (command === 'finish') {
                this.handOverFinishForm = {
                    assigned: '',
                    assignedId: '',
                    recipient: '',
                    recipientId: '',
                    startTime: '',
                    endTime: '',
                    moduleName: '',
                    moduleId: '' };

                this.mwRef('handOverFinish').show();
            }
        },
        initDeptDialog1Data: function initDeptDialog1Data() {var _this = this;
            if (this.init1) {
                this.mwRef('addDeptDialog1').$nextTick(function () {
                    _this.mwRef('deptTree1').refresh();
                });
            }
            this.init1 = false;
        },
        doOrderDepartments: function doOrderDepartments(data, dept) {
            var me = this;
            var n = data.position + 1;
            var departmentSns = [];
            departmentSns.push(dept.id + ',' + n);
            me.mwApi.org.listDepartmentAndCount(dept.parentId).then(function (res) {
                res.result.forEach(function (r, index) {
                    if (r.id === dept.id) {
                        if (data.position > index) {
                            for (var i = 0; i < index; i++) {
                                var no = i + 1;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                            for (var i = index + 1; i <= data.position; i++) {
                                var no = i;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                            for (var i = data.position + 1; i < res.result.length; i++) {
                                var no = i + 1;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                        }
                        if (data.position < index) {
                            for (var i = 0; i < data.position; i++) {
                                var no = i + 1;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                            for (var i = data.position; i < index; i++) {
                                var no = i + 2;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                            for (var i = index + 1; i < res.result.length; i++) {
                                var no = i + 1;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                        }
                        if (data.position === index) {
                            for (var i = index + 1; i < res.result.length; i++) {
                                var no = i + 1;
                                departmentSns.push(res.result[i].id + ',' + no);
                            }
                        }
                    }
                });
                me.mwApi.org.orderDepartments(departmentSns);
            });
        },
        moveTreeNode: function moveTreeNode(e, data) {
            var me = this;
            var dept = {};
            dept.id = data.node.id;
            dept.parentId = data.node.parent;
            dept.parentName = this.mwRef('deptTreeData').getNode(data.node.parent).text;
            if (dept.parentName) {
                dept.parentName = dept.parentName.substring(0, dept.parentName.lastIndexOf('('));
            }
            if (dept.parentId === '#') {
                dept.parentId = '';
            }
            dept.name = data.node.original.name.substring(0, data.node.original.name.indexOf('('));

            if (data.old_parent == data.parent) {
                me.doOrderDepartments(data, dept);
            } else {
                this.mwApi.org.saveDepartment(dept).then(function (resu) {
                    if (resu.success) {
                        me.doOrderDepartments(data, dept);
                    }
                });
            }
        },

        handleAvatarSuccess: function handleAvatarSuccess(response, file, fileList) {var _this2 = this;
            if (!this.user.id && response.result) {
                this.user.avatarAttachId = response.result['#items'][0].id;
            }
            if (this.fileList.length > 0) {
                var ids = [];
                this.fileList.forEach(function (f) {
                    ids.push(f.id);
                });
                var params = (0, _assign2.default)({ attachIds: ids }, this.defaultParams);
                this.mwApi.business.deleteAttachment(params).then(function (res) {
                    if (res.success) {
                        _this2.refreshPic(_this2.defaultParams);
                    }
                });
            } else {
                this.refreshPic(this.defaultParams);
            }
        },

        beforeAvatarUpload: function beforeAvatarUpload(up, file) {
            var a = true;
            if (this.user.id) {
                this.defaultParams.id = this.user.id;
                a = true;
            } else if (this.user.loginId) {
                this.defaultParams.type = this.user.loginId;
                this.defaultParams.fullPath = true;
                a = true;
            } else {
                this.mwMsg('请输入登录账号名');
                up.removeFile(file);
                a = false;
            };
            return a;
        },

        beforeSignUpload: function beforeSignUpload(up, file) {
            var a = true;
            if (this.user.loginId) {
                this.signParams.type = this.user.loginId;
                this.signParams.businessId = this.user.loginId;
                this.signParams.formId = this.user.loginId;
                this.signParams.tempBusinessId = this.user.loginId;
                this.signParams.fullPath = true;
                a = true;
            } else {
                this.mwMsg('请输入登录账号名');
                up.removeFile(file);
                a = false;
            };
            return a;
        },

        handleSignSuccess: function handleSignSuccess(response, file, fileList) {var _this3 = this;
            if (this.fileSignList.length > 0) {
                var ids = [];
                this.fileSignList.forEach(function (f) {
                    ids.push(f.id);
                });
                var params = (0, _assign2.default)({ attachIds: ids }, this.signParams);
                this.mwApi.business.deleteAttachment(params).then(function (res) {
                    if (res.success) {
                        _this3.refreshSign(_this3.signParams);
                    }
                });
            } else {
                this.refreshSign(this.signParams);
            }
        },

        remove: function remove(file) {var _this4 = this;

            $(".sign").click(function (event) {
                event.preventDefault();
            });
            var params = (0, _assign2.default)({ attachIds: [file.id] }, this.signParams);
            this.mwApi.business.deleteAttachment(params).then(function (res) {
                if (res.success) {
                    _this4.refreshSign(_this4.signParams);
                    $(".sign").unbind('click');
                }
            });
        },

        removePic: function removePic(file, flag) {var _this5 = this;
            $(".headImg").click(function (event) {
                event.preventDefault();
            });
            if (this.user.id && flag == "avatar") {
                this.mwUtil.ajax(PF.getApplicationPath() + "/api/data/removeUserAvatar", { userId: this.user.id }).then(function (res) {
                    if (res.success) {
                        _this5.refreshPic(_this5.defaultParams);
                        $(".headImg").unbind('click');

                    }
                });
            } else {
                var params = (0, _assign2.default)({ attachIds: [file.id] }, this.defaultParams);
                this.mwApi.business.deleteAttachment(params).then(function (res) {
                    if (res.success) {
                        if (flag == "avatar") {
                            _this5.user.avatarAttachId = "";
                        }
                        _this5.refreshPic(_this5.defaultParams);
                        $(".headImg").unbind('click');
                    }
                });
            }

        },
        refreshSign: function refreshSign() {var _this6 = this;
            this.mwApi.business.listAttachment(this.signParams).then(function (res) {
                var params = _this6.signParams;
                _this6.fileSignList = res.result || [];
                if (_this6.fileSignList.length > 0) {
                    var string = 'id=' + res.result[0].id + '&businessId=' + params.businessId + '&formId=' + params.formId + '&tempBusinessId=' + params.tempBusinessId + '&xToken=' + _token2.default.getToken();
                    _this6.signUrl = _this6.mwUrl("/api/business/downloadAttachment?") + string;
                } else {
                    _this6.signUrl = '';
                }
            });
        },
        refreshPic: function refreshPic() {var _this7 = this;
            if (this.user.id) {
                this.mwUtil.ajax(PF.getApplicationPath() + "/api/data/hasUserAvatar", { userId: this.user.id }).then(function (res) {
                    if (res.result) {
                        _this7.imageUrl = PF.getApplicationPath() + "/api/data/getUserAvatar?userId=" + _this7.user.id + "&t=" + Date.now();
                    } else {
                        _this7.imageUrl = '';
                    }
                });
            } else {
                this.mwApi.business.listAttachment(this.defaultParams).then(function (res) {
                    var params = _this7.defaultParams;
                    _this7.fileList = res.result || [];
                    if (_this7.fileList.length > 0) {
                        var string = 'id=' + res.result[0].id + '&businessId=' + params.businessId + '&formId=' + params.formId + '&tempBusinessId=' + params.tempBusinessId + '&xToken=' + _token2.default.getToken();
                        _this7.imageUrl = _this7.mwUrl("/api/business/downloadAttachment?") + string;
                    } else {
                        _this7.imageUrl = '';
                    }
                });
            }
        },
        downloadAttachment: function downloadAttachment(data, params) {
            if (params.flag == 'avatar' && this.user.id) {
                this.mwUtil.downloadAttachment(this.mwUrl("/api/data/getUserAvatar"), {}, false, PF.encode({ userId: this.user.id, flag: "download" }));
            } else {
                params.id = data.id;
                this.mwApi.business.downloadAttachment(params);
            }
        },
        loadTableTree: function loadTableTree(data) {var _this8 = this;
            if (!this.isSysAdmin() && !this.userInfo.unitAdmin && this.userInfo.departmentAdmin) {
                if (data.id === this.userInfo.loginDepartment.id) {
                    this.isLimit = false;
                    var btns = [{
                        label: '添加',
                        icon: 'fa fa-plus-square',
                        func: this.addUser },

                    {
                        label: '删除',
                        icon: 'fa fa-trash-o fa-fw',
                        func: this.deleteUser }];


                    if (this.buttons.length > 0) {
                        this.buttons.splice(0, this.buttons.length);
                    }
                    btns.forEach(function (item) {
                        _this8.buttons.push(item);
                    });

                } else {
                    this.isLimit = true;
                    if (this.buttons.length > 0) {
                        this.buttons.splice(0, this.buttons.length);
                    }
                }
            }
            if (!this.isSysAdmin() && !this.userInfo.ownerAdmin && this.userInfo.unitAdmin) {
                this.buttons.splice(2, 1);
            }
            if (this.mwRef('dataTable').mwRef('dataTable').filters.filter && this.mwRef('dataTable').mwRef('dataTable').filters.filter.qcon) {
                this.mwRef('dataTable').mwRef('dataTable').filters.filter.qcon = '';
            }
            this.refreshTable(data.id, function () {});
            this.checkedId = data.id;
            this.nodeText = data.text.substring(0, data.text.indexOf('('));
        },
        refreshTable: function refreshTable(checkedId, callback) {
            var tableDefaultParams = this.mwRef('dataTable').defaultParams;
            tableDefaultParams.departmentId = checkedId;

            this.mwRef('dataTable').refreshTable();
            if (typeof callback === 'function') {
                this.mwRef('dataTable').clearSelection();
            }
        },

        adminFormatter: function adminFormatter(data) {
            if (data.isAdmin) {
                return '< i class = "fa fa-user" title = "管理员" > < /i>';
            }
        },

        deleteDepartment: function deleteDepartment(dept) {
            if (!dept.id) {
                if (this.mwRef('deptTreeData').getSelected()) {
                    dept = this.mwRef('deptTreeData').getSelected();
                } else {
                    me.mwMsg('请选择要删除的节点!');
                }
            }
            var a = false;
            if (dept.hasChild > 0) {
                a = true;
            } else {
                a = false;
            }
            var me = this;
            var pos = me.deptTreeUrl.indexOf("?t");

            if (a) {
                this.$confirm('此节点下有多个子节点, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning' }).
                then(function () {
                    me.mwApi.org.deleteDepartment([dept.id]).then(function (data) {
                        if (pos != -1) {
                            me.deptTreeUrl = me.deptTreeUrl.substring(0, pos) + "?t=" + Date.now();
                        } else {
                            me.deptTreeUrl = me.deptTreeUrl += "?t=" + Date.now();
                        }
                        if (data.success) {
                            me.mwMsg('删除成功!');
                            me.mwRef('deptTreeData').refresh();
                            me.loadTableTree(dept);
                        } else {
                            me.mwMsg('info', '删除失败!');
                        }

                    });
                });
            } else {
                this.$confirm('您确定要删除此节点', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning' }).
                then(function () {
                    me.mwApi.org.deleteDepartment([dept.id]).then(function (data) {
                        if (pos != -1) {
                            me.deptTreeUrl = me.deptTreeUrl.substring(0, pos) + "?t=" + Date.now();
                        } else {
                            me.deptTreeUrl = me.deptTreeUrl += "?t=" + Date.now();
                        }
                        if (data.success) {
                            me.mwMsg('删除成功!');
                            me.mwRef('deptTreeData').refresh();
                            me.loadTableTree(dept);
                        } else {
                            me.mwMsg('info', '删除失败!');
                        }
                    });
                }).catch(function () {});
            }
        },

        expand: function expand() {
            this.expandFlag = 2;
            this.mwRef('deptTreeData').openAll();
        },
        closed: function closed() {
            this.expandFlag = 1;
            this.mwRef('deptTreeData').closeAll();
        },

        saveDept: function saveDept() {var _this9 = this;
            var me = this;
            this.mwRef('ruleForm').validate(function (valid) {
                if (valid) {
                    if (!_this9.edit) {
                        _this9.dept.parentId = _this9.dept.parentId ? _this9.checkedId : '<ROOT>';
                        _this9.dept.parentName = _this9.dept.parentName ? _this9.nodeText : '<ROOT>';
                    } else {
                        if (!_this9.dept.parentId) {
                            _this9.dept.parentId = '<ROOT>';
                            _this9.dept.parentName = '<ROOT>';
                        }
                    }
                    _this9.mwApi.org.saveDepartment(_this9.dept).then(function (data) {
                        var pos = me.deptTreeUrl.indexOf("?t");
                        if (pos != -1) {
                            me.deptTreeUrl = me.deptTreeUrl.substring(0, pos) + "?t=" + Date.now();
                        } else {
                            me.deptTreeUrl = me.deptTreeUrl += "?t=" + Date.now();
                        }
                        if (data.success) {
                            _this9.mwMsg('保存成功');
                            _this9.mwRef('deptTreeData').refresh();
                            _this9.mwRef('deptDialog').hide();
                            _this9.mwRef('ruleForm').resetFields();
                        }
                    });
                } else {
                    _this9.mwMsg('信息未填写完整');
                }
            });
        },
        closeDeptDialog: function closeDeptDialog() {
            this.mwRef('deptDialog').hide();
            this.mwRef('ruleForm').resetFields();
        },
        addDepart: function addDepart(data, addRoot) {var _this10 = this;

            this.edit = false;
            if ((!addRoot || addRoot !== true) && this.mwRef('deptTreeData').getTreeData().length > 0) {
                if (!this.mwRef('deptTreeData').getSelected()) {
                    this.mwMsg('请选中你要操作的部门或单位');
                } else {
                    var nodeText = this.nodeText.substring(0, this.nodeText.indexOf('(')) || '';
                    this.mwApi.org.getDepartment(this.checkedId).then(function (data) {
                        var flag;
                        if (data.result.flag && data.result.flag != 1) {
                            flag = '3';
                        }
                        _this10.dept = {
                            name: '',
                            shortname: '',
                            Englishname: '',
                            id: '',
                            flag: flag || '2',
                            adminName: '',
                            adminId: '',
                            sn: '',
                            listAble: '1',
                            parentId: _this10.checkedId,
                            parentName: _this10.nodeText,
                            identityIds: '',
                            code: '' };

                    });
                    this.mwRef('deptDialog').show();
                }
            } else {
                this.dept = {
                    name: '',
                    shortname: '',
                    Englishname: '',
                    id: '',
                    flag: '1',
                    adminName: '',
                    adminId: '',
                    sn: '',
                    listAble: '1',
                    identityIds: '',
                    code: '' };

                this.mwRef('deptDialog').show();
            }

        },
        editDept: function editDept() {var _this11 = this;
            if (!this.mwRef('deptTreeData').getSelected()) {
                this.mwMsg('请选择你要编辑的部门');
            } else {
                this.edit = true;
                this.mwApi.org.getDepartment(this.checkedId).then(function (res) {
                    if (res.success) {
                        _this11.dept = {
                            id: '',
                            name: '',
                            shortname: '',
                            Englishname: '',
                            flag: '1',
                            adminName: '',
                            adminId: '',
                            sn: '',
                            listAble: '1',
                            identityIds: '',
                            code: '' };

                        if (res.result.parentId) {
                            _this11.dept.parentId = '';
                            _this11.dept.parentName = '';
                        }
                        _this11.mwUtil.applyCover(_this11.dept, res.result);
                        if (res.result.parentId) {
                            if (_this11.dept.parentName.indexOf('(') != -1) {
                                _this11.dept.parentName = _this11.dept.parentName.substring(0, _this11.dept.parentName.indexOf('('));
                            }
                        }
                        _this11.mwRef('deptDialog').show();
                    }
                });
            }
        },
        removeIp: function removeIp(type) {var _this12 = this;
            var userIds = [];
            if (type && type == "1") {
                var multipleSelection = this.mwRef('dataTable').getMultipleSelection();
                var isCanAddUser = true;
                multipleSelection.forEach(function (r) {
                    if (r.id) {
                        userIds.push(r.id);
                    } else if (r.ID) {
                        userIds.push(r.ID);
                    }

                });
            } else if (type && type == "2") {
                userIds.push(this.user.id);
            }
            if (userIds.length == 0) {
                this.mwMsg('info', '请选择你需要操作的用户');
            } else {
                this.$confirm('是否解除ip绑定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning' }).
                then(function () {
                    _this12.mwApi.org.clearUserbindIp(userIds).then(function (res) {
                        if (res.result) {
                            _this12.user.bindIP = '';
                            _this12.mwMsg('success', '解除ip成功');
                        }
                    });
                }).catch(function () {});
            }
        },

        handleRoleCommand: function handleRoleCommand(command) {

            if (command == 'a') {
                this.roleLookUp();
            }
        },
        roleLookUp: function roleLookUp() {var _this13 = this;
            var multipleSelection = this.mwRef('dataTable').getMultipleSelection();
            var len = multipleSelection.length - 1;
            if (multipleSelection.length != 1) {
                this.mwMsg('info', '请选择一个用户进行操作');
            } else {
                var userId = multipleSelection[len].userId || multipleSelection[len].id;
                this.mwApi.org.getDepartmentTypeIdentity(multipleSelection[len].departmentId, 'DEP_USER', userId).then(function (data) {
                    _this13.userIdentityId = data.result.id;
                    _this13.identityId = _this13.userIdentityId;
                    _this13.mwRef('userRoleDialog').show();
                    _this13.userInfo1 = [{ id: _this13.userIdentityId, name: multipleSelection[len].name, departmentId: multipleSelection[len].departmentId, isLimit: _this13.isLimit }];
                });
            }
        },
        chooseSure: function chooseSure(a) {
            this.mwRef(a).show();
        },
        cancel: function cancel(a) {
            this.mwRef(a).hide();
        },

        bindSec: function bindSec() {
            if (this.secFirst) {
                this.mwRef('chooseSec').refresh();
            }
            this.chooseSure('chooseSec');
            this.secFirst = true;
        },
        showMenu: function showMenu() {

        },


        confirmPost: function confirmPost(data) {
            this.cancel('choosePost');
            this.user.position = data;
        },


        confirmSec: function confirmSec() {
            var data = this.mwRef('chooseSec').getValue();
            this.user.secretary = data[0].name;
            this.user.secretaryId = data[0].id;
        },


        confirmTwoRand: function confirmTwoRand(data) {
            this.user.secondRank = '';
            this.user.secondRankId = '';
            var secondRank = [];
            var secondRankId = [];
            data.forEach(function (d) {
                secondRank.push(d.id);
                secondRankId.push(d.name);
            });
            this.user.secondRank = secondRank.join();
            this.user.secondRankId = secondRankId.join();
        },



        handleDeptCommand: function handleDeptCommand(command) {var _this14 = this;
            this.ismultiple = false;
            var data = this.mwRef('dataTable').getMultipleSelection();
            if (data.length == 0) {
                this.mwMsg('请选择你要操作的用户');
            } else {
                this.mwRef('addDeptDialog').show();
                if (this.init) {
                    this.mwRef('addDeptDialog').$nextTick(function () {
                        _this14.mwRef('deptTree').refresh();
                    });
                }
                this.init = false;

                if (command == 'add') {
                    this.addUserDept = true;
                } else {
                    this.addUserDept = false;
                }
            }


        },

        addUser: function addUser() {var _this15 = this;

            if (!this.firstUserOpen) {
                this.mwRef('userForm').resetFields();
            }

            this.firstUserOpen = false;

            if (this.mwRef('deptTreeData').getSelected().length === 0) {
                this.mwMsg('info', '请选择部门再添加用户');
            } else {

                this.mwApi.org.getDepartment(this.checkedId).then(function (data) {
                    _this15.user = {
                        departmentId: _this15.checkedId,
                        loginId: '',
                        name: '',
                        sex: '1',
                        initial: '',
                        pinyin: '',
                        Englishname: '',
                        password: '',
                        email: '',
                        label: '',
                        id: '',
                        staffId: '',
                        departmentName: data.result.name,
                        sn: '',
                        phone: '',
                        mobile: '',
                        position: '',
                        secretary: '',
                        secretaryId: '',
                        jobs: '',
                        isSecret: '1',
                        timeOfJoinInWork: '',
                        workyear: '',
                        edu: '',
                        birth: '',
                        mjbs: '',
                        age: '',
                        idNumber: '',
                        weiChatNum: '',
                        userLevel: '',
                        listAble: '1',
                        roleNames: '',
                        roleid: '',
                        persontype: '1',
                        departmentIdentityId: '',
                        companyEmail: '',
                        zgdept: '',
                        zgdeptid: '',
                        staffLevel: '',
                        secondRank: '',
                        thirdRank: '',
                        firstLevelDept: '',
                        firstLevelDeptId: '',
                        secondLevelDept: '',
                        secondLevelDeptId: '',
                        thirdLevelDept: '',
                        thirdLevelDeptId: '',
                        primaryDepartmentName: data.result.name,
                        primaryDepartmentId: data.result.id };

                    _this15.signUrl = '';
                    _this15.imageUrl = '';
                    _this15.editUser = false;
                    _this15.mwRef('userAddDialog').show();
                });

            }

        },
        deleteUser: function deleteUser(data) {
            var me = this;
            if (data.length == 0) {
                this.mwMsg('info', '请选择你要操作的用户');
                return;
            }
            this.$confirm('确定要删除该部门用户?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning' }).
            then(function () {
                var depUsersMap = {};
                data.forEach(function (val) {
                    if (!depUsersMap[val.departmentId]) depUsersMap[val.departmentId] = [];
                    depUsersMap[val.departmentId].push({ id: val.userId || val.id, name: val.name, identityId: val.identityId });
                });
                var p = void 0;
                _.each(depUsersMap, function (vals, k) {
                    var arrIds = [];
                    vals.forEach(function (v) {
                        arrIds.push(v.id);
                    });
                    if (!p) {
                        p = me.mwApi.org.deleteDepartmentUser(k, arrIds);
                    } else {
                        p = p.then(function (data) {
                            return me.mwApi.org.deleteDepartmentUser(k, arrIds);
                        });
                    }
                });
                p.then(function (data) {
                    if (data.success) {
                        me.mwMsg('删除成功!');
                        me.mwRef('deptTreeData').refresh();
                    } else {
                        me.mwMsg('info', '删除成功!');
                    }
                });
            });
        },
        changeTreeData: function changeTreeData(data) {var _this16 = this;
            data.forEach(function (d) {
                d.label = d.name;
                if (d.children && d.children.length > 0) {
                    _this16.changeTreeData(d.children);
                }
            });
        },

        dbHandleRow: function dbHandleRow(row, index) {var _this17 = this;
            var id = row.ID || row.id;
            this.mwApi.org.getUser(id).then(function (res) {
                if (res.success) {
                    _this17.user = {
                        id: '',
                        departmentId: '',
                        loginId: '',
                        name: '',
                        sex: '1',
                        initial: '',
                        pinyin: '',
                        Englishname: '',
                        password: '',
                        email: '',
                        label: '',
                        staffId: '',
                        departmentName: '',
                        childDept: '',
                        childDeptId: '',
                        sn: '',
                        phone: '',
                        persontype: '1',
                        mobile: '',
                        position: '',
                        secretary: '',
                        secretaryId: '',
                        jobs: '',
                        isSecret: '1',
                        timeOfJoinInWork: '',
                        workyear_: '',
                        edu: '',
                        birth: '',
                        age: '',
                        idNumber: '',
                        weiChatNum: '',
                        userLevel: '',
                        listAble: '1',
                        roleNames: '',
                        roleid: '',
                        departmentIdentityId: '',
                        companyEmail: '',
                        zgdept: '',
                        zgdeptid: '',
                        staffLevel: '',
                        secondRank: '',
                        thirdRank: '',
                        firstLevelDept: '',
                        firstLevelDeptId: '',
                        secondLevelDept: '',
                        secondLevelDeptId: '',
                        thirdLevelDept: '',
                        thirdLevelDeptId: '',
                        primaryDepartmentName: '',
                        primaryDepartmentId: '',
                        bindIP: '',
                        mjbs: '' };

                    _this17.mwRef('userAddDialog').show();
                    var departmentId = row.departmentId || _this17.checkedId;
                    _this17.mwUtil.applyCover(_this17.user, res.result);
                    if (res.result.positions && res.result.positions[departmentId]) {
                        _this17.user.position = res.result.positions[departmentId];
                    }
                    if (res.result.data) {
                        var data = JSON.parse(res.result.data);
                        _this17.user.bindIP = data.bindIP ? data.bindIP : "";
                    }
                    _this17.user.sn = row.sn;
                    _this17.user.workyear_ = _this17.ageNum(row.timeOfJoinInWork);
                    _this17.user.departmentId = departmentId;
                    _this17.user.departmentName = _this17.nodeText;
                    _this17.defaultParams.type = _this17.user.loginId;
                    _this17.signParams.type = _this17.user.loginId;
                    _this17.signParams.businessId = _this17.user.loginId;
                    _this17.signParams.formId = _this17.user.loginId;
                    _this17.signParams.tempBusinessId = _this17.user.loginId;
                    _this17.refreshPic();
                    _this17.refreshSign();
                    _this17.editUser = true;

                    _this17.mwApi.org.getDepartmentTypeIdentity(departmentId, 'DEP_USER', id).then(function (datas) {
                        _this17.userIdentityId = datas.result.id;
                        _this17.user.departmentName = datas.result.departmentName || _this17.nodeText;
                    });
                }
            });
        },

        cancelChoose: function cancelChoose() {
            this.mwRef('addDeptDialog').hide();
        },
        cancelChoose1: function cancelChoose1() {
            this.mwRef('addDeptDialog1').hide();
        },


        addUsersDept: function addUsersDept() {var _this18 = this;
            var me = this;
            this.user.departmentId = this.mwRef('deptTree').getSelected().id;
            var userIds = [];
            var multipleSelection = this.mwRef('dataTable').getMultipleSelection();
            var isCanAddUser = true;
            multipleSelection.forEach(function (r) {
                if (r.departmentId == me.user.departmentId) {
                    me.mwMsg('info', '该用户已是该部门成员,无须重复添加');
                    isCanAddUser = false;
                    return;
                }
                userIds.push(r.userId || r.id);
            });
            if (!isCanAddUser) return;
            this.mwApi.org.addDepartmentUser(this.user.departmentId, userIds).then(function (data) {
                if (data.success) {
                    _this18.mwMsg('追加成功!');
                    _this18.cancelChoose();
                } else {
                    _this18.mwMsg('info', '追加失败!');
                }
            });
        },

        addTransUserDept: function addTransUserDept() {
            if (this.addUserDept) {
                this.addUsersDept();
            } else {
                this.tansUserDept();
            }
        },

        tansUserDept: function tansUserDept() {var _this19 = this;
            var me = this;
            var toDepartmentId = this.mwRef('deptTree').getSelected().id;
            var depUsersMap = {};
            var isCanTans = true;
            var data = this.mwRef('dataTable').getMultipleSelection();
            if (!data || data.length === 0) {
                this.mwMsg('info', '请选择转换用户');
                return;
            }
            data.forEach(function (val) {
                if (toDepartmentId === val.departmentId) {
                    _this19.mwMsg('info', '该用户已是该部门成员,无须转换');
                    isCanTans = false;
                    return;
                }
                if (!depUsersMap[val.departmentId]) depUsersMap[val.departmentId] = [];
                depUsersMap[val.departmentId].push({ id: val.userId || val.id, name: val.name, identityId: val.identityId });
            });
            if (!isCanTans) return;
            var p = void 0;
            _.each(depUsersMap, function (vals, k) {
                var userIds = [];
                vals.forEach(function (v) {
                    userIds.push(v.id);
                });
                if (!p) {
                    p = me.mwApi.org.changeDepartmentUser(k, toDepartmentId, userIds);
                } else {
                    p = p.then(function (data) {
                        return me.mwApi.org.changeDepartmentUser(k, toDepartmentId, userIds);
                    });
                }
            });
            p.then(function (data) {
                _this19.mwMsg('转换部门成功!');
                _this19.cancelChoose();
                _this19.mwRef('deptTreeData').refresh();
            });
        },
        handleManage: function handleManage(data) {var _this20 = this;
            if (data.length == 0) {
                this.mwMsg('info', '请选择你要操作的数据');
            } else {

                data.forEach(function (t) {
                    if (t.isAdmin) {
                        _this20.mwApi.org.deleteOwnerAdminUser(t.id);
                    } else {
                        _this20.mwApi.org.addOwnerAdminUser(t.id);
                    }
                });
                this.refreshTable(this.checkedId, function () {});
            }
        },

        closeUserDialog: function closeUserDialog() {
            this.mwRef('userAddDialog').hide();
            this.mwRef('userForm').resetFields();
        },


        newUser: function newUser() {var _this21 = this;
            this.mwRef('userForm').validate(function (valid) {
                if (valid) {
                    _this21.user.signUrl = _this21.signUrl;
                    _this21.user.imageUrl = _this21.imageUrl;
                    _this21.mwApi.org.saveUser(_this21.user).then(function (data) {
                        if (data.success) {
                            _this21.mwMsg('保存成功');
                            _this21.mwRef('userAddDialog').hide();
                            _this21.closeUserDialog();
                            _this21.mwRef('deptTreeData').refresh();

                        }
                    });
                } else {
                    _this21.mwMsg('warninPF.getRouterg', '信息未填写完整');
                }
            });
        },
        processSelRowData: function processSelRowData() {
            var me = this;
            this.mwRef('dataTable').$on("dataLoaded", function (datas) {
                me._currTableAllRecords = datas;
                var records = me.mwRef('dataTable').getMultipleSelection();
                if (records && records.length > 0) {
                    var row = records[0];
                    _.each(datas, function (v) {if (v.id == row.id || v.userId == row.userId) row = v;});
                    me.mwRef('dataTable').clearSelection();
                    me.mwRef('dataTable').toggleRowSelection(row, true);
                }
            });
        },

        handleSortCommand: function handleSortCommand(command) {var _this22 = this;
            var me = this;
            var multipleSelection = this.mwRef('dataTable').getMultipleSelection();
            if (command === 'sort') {
                var a = '1234';
                this.mwApi.org.orderDepartmentUsers(this.checkedId).then(function (res) {
                    _this22.refreshTable(_this22.checkedId, a, function (a) {
                    });
                });
                return;
            }
            if (!multipleSelection || multipleSelection.length != 1) {
                this.mwMsg('请选择一个用户');
                return;
            }
            if (command === 'top') {
                if (multipleSelection && multipleSelection.length > 0) {
                    this.mwApi.org.orderUserTop(multipleSelection[0].id, this.checkedId).then(function (res) {
                        if (res.result) {
                            _this22.refreshTable(_this22.checkedId);
                        }
                    });
                } else {
                    this.mwMsg('请选择你要操作的用户');
                }
            };

            if (command === 'footer') {
                if (multipleSelection && multipleSelection.length > 0) {
                    this.mwApi.org.orderUserLow(multipleSelection[0].id, this.checkedId).then(function (res) {
                        if (res.result) {
                            _this22.refreshTable(_this22.checkedId);
                        }
                    });
                } else {
                    this.mwMsg('请选择你要操作的用户');
                }

            };

            if (command == 'down') {

                if (multipleSelection && multipleSelection.length > 0) {
                    var userSns = [];
                    var len = multipleSelection.length - 1;
                    this.mwApi.org.listDepartmentUserPaging({ departmentId: this.checkedId, start: 0, limit: 100000 }).then(function (res) {
                        if (res.success && res.totalCount > 1) {
                            res.result.forEach(function (r, index) {
                                if (r.id === multipleSelection[0].id && index != res.totalCount - 1) {
                                    var name2 = res.result[index + 1].id + ',' + multipleSelection[len].sn;
                                    var name1 = multipleSelection[len].id + ',' + res.result[index + 1].sn;
                                    userSns.push(name1);
                                    userSns.push(name2);
                                    _this22.mwApi.org.orderUsers(userSns, _this22.checkedId).then(function (data) {
                                        if (data.success) {
                                            _this22.refreshTable(_this22.checkedId);
                                        }
                                    });
                                    return;
                                }
                            });
                        }
                    });
                } else {
                    this.mwMsg('请选择你要操作的用户');
                }
            }

            if (command == 'up') {
                if (multipleSelection && multipleSelection.length > 0) {
                    var _len = multipleSelection.length - 1;
                    var _userSns = [];
                    this.mwApi.org.listDepartmentUserPaging({ departmentId: this.checkedId, start: 0, limit: 100000 }).then(function (res) {
                        if (res.success && res.totalCount > 1) {
                            res.result.forEach(function (r, index) {
                                if (r.id === multipleSelection[0].id && index != 0) {
                                    var name2 = res.result[index - 1].id + ',' + multipleSelection[_len].sn;
                                    var name1 = multipleSelection[_len].id + ',' + res.result[index - 1].sn;
                                    _userSns.push(name1);
                                    _userSns.push(name2);
                                    _this22.mwApi.org.orderUsers(_userSns, _this22.checkedId).then(function (data) {
                                        if (data.success) {
                                            _this22.refreshTable(_this22.checkedId);
                                        }
                                    });
                                    return;
                                }
                            });
                        }
                    });
                } else {
                    this.mwMsg('请选择你要操作的用户');
                }
            }
        },
        showChooseAdminDialog: function showChooseAdminDialog() {var _this23 = this;
            this.mwRef('userDialog').show();
            this.mwApi.org.getUnitById(this.checkedId).then(function (res) {
                _this23.defaultParentId = res.result.id;
                _this23.deptManagers = [];
                if (!_this23.firstTime) {
                    _this23.mwRef('chooseMangers').refreshTree(true);
                }
                _this23.firstTime = false;

                if (_this23.dept.adminId) {
                    var names = _this23.dept.adminName.split(',');
                    var ids = _this23.dept.adminId.split(',');
                    var identityIds = _this23.dept.identityIds.split(',');
                    for (var i = 0; i < names.length; i++) {
                        _this23.deptManagers.push({
                            id: ids[i],
                            name: names[i] });


                    }
                }
            });
        },
        chooseAdminSure: function chooseAdminSure() {
            this.dept.adminName = '';
            this.dept.adminId = '';
            this.dept.identityIds = '';
            var adminName = [];
            var adminId = [];
            var identityIds = [];
            this.mwRef('userDialog').hide();
            var data = this.mwRef('chooseMangers').getValue();
            data.forEach(function (d) {
                adminName.push(d.name);
                adminId.push(d.id);
                identityIds.push(d.identityId);
            });
            this.dept.adminName = adminName.join();
            this.dept.adminId = adminId.join();
            this.dept.identityIds = identityIds.join();

        },
        cancelChooseAdmin: function cancelChooseAdmin() {
            this.mwRef('userDialog').hide();
        },
        clearMan: function clearMan() {
            this.dept.adminName = '';
            this.dept.adminId = '';
            this.dept.identityIds = '';
        },
        findRoles: function findRoles() {
            if (this.user.id) {
                this.mwRef('userRoleDialog').show();
                this.identityId = this.userIdentityId;
                this.userInfo1 = [{ id: this.userIdentityId, name: this.user.name, departmentId: this.user.departmentId, isLimit: this.isLimit }];
            } else {
                this.mwMsg('info', "新建用户没有角色");
            }

        },
        closeRoleDialog: function closeRoleDialog() {
            this.refreshTable(this.checkedId);
            this.mwRef('userRoleDialog').hide();
        },
        clearStaLevel: function clearStaLevel() {
            this.user.staffLevel = '';
        },
        clearseaLevel: function clearseaLevel() {
            this.user.secondRank = '';
        },

        cthirdLevel: function cthirdLevel(data) {
            this.info3 = false;
            var thirdRank = [];

            data.forEach(function (d) {
                thirdRank.push(d);
            });

            this.user.thirdRank = thirdRank.join();

        },
        clearSec: function clearSec() {
            this.user.secretary = '';
            this.user.secretaryId = '';
        },
        canclethirdLevel: function canclethirdLevel() {
            this.info3 = false;
        },
        clearLevel: function clearLevel() {
            this.user.thirdRank = '';
        },
        employLevel: function employLevel(data) {
            this.user.staffLevel = data;
        },

        firstDeptChoose: function firstDeptChoose(data) {
            this.user.firstLevelDept = '';
            this.user.firstLevelDeptId = '';
            var firstLevelDept = [];
            var firstLevelDeptId = [];
            for (var i = 0; i < data.length; i++) {
                firstLevelDept.push(data[i].name);
                firstLevelDeptId.push(data[i].id);
            }
            this.user.firstLevelDept = firstLevelDept.join();
            this.user.firstLevelDeptId = firstLevelDeptId.join();
        },
        clearfirstDept: function clearfirstDept() {
            this.user.firstLevelDept = '';
            this.user.firstLevelDeptId = '';
        },
        secondDeptChoose: function secondDeptChoose(data) {

            var secondLevelDept = [];
            var secondLevelDeptId = [];

            this.user.secondLevelDept = '';
            this.user.secondLevelDeptId = '';

            for (var i = 0; i < data.length; i++) {
                secondLevelDept.push(data[i].name);
                secondLevelDeptId.push(data[i].id);
            }
            this.user.secondLevelDept = secondLevelDept.join();
            this.user.secondLevelDeptId = secondLevelDeptId.join();
        },


        clearsecondDept: function clearsecondDept() {
            this.user.secondLevelDept = '';
            this.user.secondLevelDeptId = '';
        },

        thirdDeptChoose: function thirdDeptChoose(data) {

            this.user.thirdLevelDept = '';
            this.user.thirdLevelDeptId = '';
            var thirdLevelDept = [];
            var thirdLevelDeptId = [];
            for (var i = 0; i < data.length; i++) {
                thirdLevelDept.push(data[i].name);
                thirdLevelDeptId.push(data[i].id);
            }
            this.user.thirdLevelDept = thirdLevelDept.join();
            this.user.thirdLevelDeptId = thirdLevelDeptId.join();
        },

        clearthirdDept: function clearthirdDept() {
            this.user.thirdLevelDept = '';
            this.user.thirdLevelDeptId = '';
        },

        zgdeptChoose: function zgdeptChoose(data) {

            this.user.zgdept = '';
            this.user.zgdeptid = '';
            var zgdept = [];
            var zgdeptIds = [];
            for (var i = 0; i < data.length; i++) {
                zgdept.push(data[i].name);
                zgdeptIds.push(data[i].id);
            }
            this.user.zgdept = zgdept.join();
            this.user.zgdeptid = zgdeptIds.join();
        },

        clearZgdept: function clearZgdept() {
            this.user.zgdept = '';
            this.user.zgdeptid = '';
        },

        cancelChoosePDept: function cancelChoosePDept() {
            this.mwRef('primaryDeptDialog').hide();
        },

        pDeptSure: function pDeptSure() {
            var data = this.mwRef('primaryDept').getSelected();
            if (data) {
                this.user.primaryDepartmentName = data.srcName,
                this.user.primaryDepartmentId = data.id;
                this.cancelChoosePDept();
            } else {
                this.mwMsg('请选择');
            }
        },
        showPtree: function showPtree() {
            if (!this.primaryTree) {
                this.mwRef('primaryDept').refresh();
            }
            this.primaryTree = false;
            this.mwRef('primaryDeptDialog').show();

        },
        toInvalidUser: function toInvalidUser() {

            if (!window["$servicePath"]) {
                this.$router.push({ path: '/org/InvalidUser' });
            } else {
                var p = this.$parent;
                do {
                    if (p.changeView) {
                        p.changeView("systemSet_org_InvalidUser");
                    }
                    p = p.$parent;
                } while (p);
            }
        },
        showHelp: function showHelp() {

            PF.showHelp({ url: '/helpDoc/platform/organization.md' });

        },
        getPYIndexStr: function getPYIndexStr() {
            var me = this;
            var name = me.user.name;
            this.mwApi.org.getPYIndexStr(name).then(function (res) {
                if (res.result) {
                    me.user.pinyin = res.result;
                }
            });
        },
        downloadPersonExcel: function downloadPersonExcel() {
            var me = this;
            me.mwUtil.downloadAttachment("/template_file/importPersonExcel.xls");
        },
        downloadDeptExcel: function downloadDeptExcel() {
            var me = this;
            me.mwUtil.downloadAttachment("/template_file/importDepartmentExcel.xls");
        },
        impDeptCancel: function impDeptCancel() {
            this.mwRef('impDeptDialog').hide();
        },
        impUserCancel: function impUserCancel() {
            this.mwRef('leadDialog').hide();
        },
        cancelHandOverTodo: function cancelHandOverTodo() {
            this.mwRef('handOverTodo').hide();
        },
        chooseHandOverTodoSure: function chooseHandOverTodoSure() {
            var me = this;
            if (!me.handOverTodoForm.assigned) {
                PF.message($lang("请选择原办理人"));
                return;
            }
            if (!me.handOverTodoForm.recipient) {
                PF.message($lang("请选择交接收人"));
                return;
            }
            PF.invoke("#api/process/handOver", me.handOverTodoForm).then(function (res) {
                PF.message($lang("交接成功"));
                me.cancelHandOverTodo();
            });
        },
        cancelHandOverFinish: function cancelHandOverFinish() {
            this.mwRef('handOverFinish').hide();
        },
        chooseHandOverFinishSure: function chooseHandOverFinishSure() {
            var me = this;
            if (!me.handOverFinishForm.assignedId) {
                PF.message($lang("请选择原办理人"));
                return;
            }
            if (!me.handOverFinishForm.recipientId) {
                PF.message($lang("请选择交接收人"));
                return;
            }
            PF.invoke("#api/data/handOverFinished", me.handOverFinishForm).then(function (res) {
                PF.message($lang("交接成功"));
                me.cancelHandOverFinish();
            });
        },
        moduleChoose: function moduleChoose() {
            var me = this;
            var moduleId = me.handOverFinishForm.moduleId;
            var checkNodes = [];
            if (moduleId) {
                checkNodes = moduleId.split(',');
            }
            PF.show('treeTable', {
                url: PF.url("/api/app/listApplicationTreeByCategory"),
                treeDefaultParams: {
                    categories: 'module_flow' },

                selectFirst: true,
                clearBtn: true,
                changed: function changed(data) {
                    this.defaultParams = {
                        applicationId: data.applicationId,
                        categories: 'module_flow' };

                },
                api: 'app.listApplicationItemsByCategory',
                singleSelect: false },

            function (res) {
                if (res) {
                    var names = [];
                    var ids = [];
                    res.forEach(function (item) {
                        names.push(item.name);
                        ids.push(item.id);
                    });
                    me.handOverFinishForm.moduleId = ids.join(',');
                    me.handOverFinishForm.moduleName = names.join(',');
                }
            });
        },
        moduleClear: function moduleClear() {
            this.handOverFinishForm.moduleId = "";
            this.handOverFinishForm.moduleName = "";
        },
        userChoose: function userChoose(handeOverSelField) {
            this.handeOverSelField = handeOverSelField;
            this.defaultParentId = this.$store.getters.curSelUnitId;
            var userChooseObj = this.mwRef('handOverUserChoose');
            if (userChooseObj) {
                userChooseObj.index = -1;
                userChooseObj.multipleLSelection = [];
            }
            this.mwRef('userSelDialog').show();
        },
        cancelUserSel: function cancelUserSel() {
            this.mwRef('userSelDialog').hide();
        },
        chooseUserSure: function chooseUserSure() {
            var me = this;
            var data = me.mwRef('handOverUserChoose').getValue();
            if (data.length === 0) {
                PF.message("请选择用户");
                return;
            }
            me.cancelUserSel();
            if (me.handeOverSelField.type == 1) {
                me.handOverTodoForm[me.handeOverSelField.id] = data[0].id;
                me.handOverTodoForm[me.handeOverSelField.name] = data[0].name;
            } else if (me.handeOverSelField.type == 2) {
                me.handOverFinishForm[me.handeOverSelField.id] = data[0].id;
                me.handOverFinishForm[me.handeOverSelField.name] = data[0].name;
            }
        },
        queryUserLog: function queryUserLog() {
            var dataTable = this.mwRef("dataTable").mwRef("dataTable");
            var tableObj = this.mwRef("dataTable");
            tableObj.$on("dataLoaded", function (d) {
                var total = d ? d.length : 0;
                if (tableObj.isSearch) {
                    var rm = "共查询到" + total + "条记录";
                    var params = {
                        flag: "列表查询",
                        targetName: '组织成员',
                        remark: rm,
                        objType: '组织机构',
                        target: '功能',
                        eventType: '三员管理操作',
                        zycd: "一般",
                        result: rm };

                    PF.invoke("sys-log-service.saveOprLog", params);
                }
            });
        },
        clearIp: function clearIp() {
            var me = this;
            me.bindForm.bindIP = "";
        },
        bindUserIp: function bindUserIp() {
            var me = this;
            var userIds = [];
            var multipleSelection = me.mwRef('dataTable').getMultipleSelection();
            if (multipleSelection.length == 0) {
                me.mwMsg('info', '请选择你需要操作的用户');
            } else if (multipleSelection.length == 1) {
                var r = multipleSelection[0];
                if (r.id) {
                    me.bindForm.userId = r.id;
                } else if (r.ID) {
                    me.bindForm.userId = r.ID;
                }
                if (r.bindIP) {
                    me.bindForm.bindIP = r.bindIP;
                }
                me.mwRef('secDialog').show();
            } else {
                me.mwMsg('info', '请选择一名用户进行绑定操作');
            }
        },
        closeBindIP: function closeBindIP() {
            this.bindForm.bindIP = "";
            this.mwRef('secDialog').hide();
        },
        saveBindIP: function saveBindIP() {
            var me = this;
            var bindIPstr = "";
            if (me.bindForm.bindIP && me.bindForm.bindIP != "") bindIPstr = me.bindForm.bindIP.replace(/\s*/g, "");
            if (bindIPstr == "") {
                me.mwMsg('info', '请输入内容');
            } else {
                var selectedTree = me.mwRef('deptTreeData').getSelected();
                var deptid = selectedTree.id;
                me.mwApi.org.updateUserInfo(me.bindForm).then(function (res) {
                    me.refreshTable(deptid, function () {});
                    if (res.success) {
                        me.mwMsg('success', '绑定成功');
                    } else {
                        me.mwMsg('info', '绑定失败');
                    }
                    me.mwRef('secDialog').hide();
                    me.bindForm.bindIP = "";
                });
            }
        } } };

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('el-col',{staticStyle:{"height":"100%","overflow-y":"auto"},attrs:{"span":_vm.isRadio ? 12 : 7}},[_c('mw-tree',{ref:"aa",attrs:{"url":_vm.deptTreeUrl,"async":true,"multiple":false,"defaultParams":_vm.defaultParams,"expandedFirst":true,"selectFirst":true,"selectNode":_vm.selectedDept,"aliasId":"departmentId"},on:{"changed":_vm.generateData}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"height":"100%"},attrs:{"span":_vm.isRadio ? 12 :17}},[_c('el-col',{staticStyle:{"height":"100%","overflow-y":"auto"},attrs:{"span":_vm.hxSpan}},[_c('el-table',{ref:"adminData",attrs:{"data":_vm.LAdminData,"row-class-name":_vm.tableRowClassName},on:{"row-click":_vm.handleRow,"selection-change":_vm.handleLSelectionChange}},[(!_vm.isRadio)?_c('el-table-column',{attrs:{"type":"selection","width":"30"}}):_vm._e(),_vm._v(" "),(_vm.isRadio)?_c('el-table-column',{attrs:{"width":"30","type":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return (_vm.isRadio)?[(_vm.isRadio)?_c('el-radio',{staticClass:"radio",attrs:{"label":props.row.index},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},[_vm._v(_vm._s())]):_vm._e()]:undefined}}],null,true)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"width":"55","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"名称"}})],1)],1),_vm._v(" "),(!_vm.isRadio)?_c('el-col',{staticClass:"loadManager-button",staticStyle:{"margin-top":"calc(50% - 180px)"},attrs:{"offset":1,"span":2}},[(!_vm.isRadio)?_c('el-button',{on:{"click":function($event){return _vm.handleChange('LeftAll')}}},[_c('i',{staticClass:"fa fa-angle-double-right"})]):_vm._e(),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.handleChange('LeftChecked')}}},[_c('i',{staticClass:"fa fa-angle-right"})]),_vm._v(" "),(!_vm.isRadio)?_c('el-button',{on:{"click":function($event){return _vm.handleChange('RightAll')}}},[_c('i',{staticClass:"fa fa-angle-double-left"})]):_vm._e(),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.handleChange('RightChecked')}}},[_c('i',{staticClass:"fa fa-angle-left"})])],1):_vm._e(),_vm._v(" "),(!_vm.isRadio)?_c('el-col',{staticStyle:{"height":"100%","overflow-y":"auto"},attrs:{"offset":1,"span":_vm.yxSpan}},[[_c('el-table',{ref:"adminRData",attrs:{"data":_vm.RAdminData},on:{"row-click":_vm.handleRowR,"selection-change":_vm.handleRSelectionChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"30"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"40","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"名称"}})],1)]],2):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_chooseSecretary_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_chooseSecretary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_chooseSecretary_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_chooseSecretary_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_chooseSecretary_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5c780422_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_chooseSecretary_vue__ = __webpack_require__(1183);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_chooseSecretary_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5c780422_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_chooseSecretary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"secDialog",attrs:{"size":"small_small","footerButton":_vm.footerButton,"close-on-click-modal":false}},[_c('el-col',{attrs:{"span":12}},[_c('mw-tree',{ref:"tree",attrs:{"url":_vm.deptTreeUrl,"async":true,"expandedFirst":true,"multiple":false},on:{"changed":_vm.changed}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('mw-table',{ref:"dataTable",attrs:{"columns":_vm.columns,"defaultParamsAutoLoad":true,"autoLoad":false,"pagination":false,"defaultParams":_vm.defaultParams,"api":_vm.api,"singleSelect":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_choosePost_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_choosePost_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_choosePost_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_choosePost_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_choosePost_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_a540cbaa_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_choosePost_vue__ = __webpack_require__(1185);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_choosePost_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_a540cbaa_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_choosePost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-bottom":"15px"}},[_c('div',{staticStyle:{"max-height":"300px","overflow":"auto"}},[_c('el-radio-group',{model:{value:(_vm.position),callback:function ($$v) {_vm.position=$$v},expression:"position"}},_vm._l((_vm.postions),function(i){return _c('el-radio',{key:i.id,staticStyle:{"display":"block","margin-left":"50px","height":"30px","line-height":"30px","font-size":"16px","font-weight":"normal"},attrs:{"label":i.name}},[_vm._v(_vm._s(i.name))])}),1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",staticStyle:{"text-align":"right","margin-top":"15px"},attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.canclePost}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirmPost}},[_vm._v("确 定")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_staffLevel_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_staffLevel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_staffLevel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_staffLevel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_staffLevel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6910c50a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_staffLevel_vue__ = __webpack_require__(1187);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_staffLevel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6910c50a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_staffLevel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"zgDeptDialog",attrs:{"size":"mini_mini","footerButton":_vm.btns,"close-on-click-modal":false}},[_c('div',{staticStyle:{"margin-top":"20px"}},[_c('el-radio-group',{model:{value:(_vm.check),callback:function ($$v) {_vm.check=$$v},expression:"check"}},_vm._l((_vm.list),function(i){return _c('el-radio',{key:i.id,staticStyle:{"display":"block","margin-left":"50px","height":"30px","line-height":"30px","font-size":"16px","font-weight":"normal"},attrs:{"label":i.name}},[_vm._v(_vm._s(i.name))])}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_infothirdLevel_vue__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_infothirdLevel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_infothirdLevel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_infothirdLevel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_infothirdLevel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7075304c_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_infothirdLevel_vue__ = __webpack_require__(1189);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_infothirdLevel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7075304c_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_infothirdLevel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"size":"mini_mini","footerButton":_vm.btns,"close-on-click-modal":false}},[_c('div',{staticStyle:{"margin-top":"20px"}},[_c('el-checkbox-group',{model:{value:(_vm.checkList),callback:function ($$v) {_vm.checkList=$$v},expression:"checkList"}},_vm._l((_vm.list),function(item){return _c('el-checkbox',{key:item.id,staticStyle:{"display":"block","margin-left":"80px","height":"30px","line-height":"30px","font-size":"16px","font-weight":"normal"},attrs:{"label":item.id}},[_vm._v(_vm._s(item.name)+" "),_c('span')])}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_zgDept_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_zgDept_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_zgDept_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_zgDept_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_zgDept_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2892a010_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_zgDept_vue__ = __webpack_require__(1191);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_zgDept_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2892a010_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_zgDept_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"zgDeptDialog",attrs:{"title":"选择部门机构","size":"mini_mini","footerButton":_vm.btns,"close-on-click-modal":false}},[_c('mw-tree',{ref:"deptTree",staticClass:"mw-dialog-body",attrs:{"url":_vm.deptTreeUrl,"multipleLeaf":true,"checkNodes":_vm.checkNodes,"async":true,"expandedFirst":true,"multiple":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"zgDeptDialog",attrs:{"title":"选择部门机构","size":"mini_mini","footerButton":_vm.btns,"close-on-click-modal":false}},[_c('mw-tree',{ref:"deptTree",staticClass:"mw-dialog-body",attrs:{"url":_vm.deptTreeUrl,"multipleLeaf":false,"async":false,"expandedFirst":true,"multiple":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_queryRoles_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_queryRoles_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_queryRoles_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_queryRoles_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_queryRoles_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7138c8c3_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_queryRoles_vue__ = __webpack_require__(1194);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_queryRoles_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7138c8c3_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_queryRoles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('mw-dialog',{ref:"addRolesDialog",attrs:{"title":"角色选择","size":"mini_mini","footerButton":_vm.btns,"close-on-click-modal":false}},[_c('mw-tree',{ref:"codeRoleTree",attrs:{"url":_vm.codeRoleTreeUrl,"multipleLeaf":true,"async":false,"expandedFirst":true,"defaultParams":_vm.treeDefaultParams,"multiple":true}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.userInfo.ownerAdmin||_vm.userInfo.unitAdmin || !_vm.userInf[0].isLimit) && !_vm.noResetPwd),expression:"(userInfo.ownerAdmin||userInfo.unitAdmin || !userInf[0].isLimit) && !noResetPwd"}],staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.checkRoles}},[_vm._v("添加")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.deleteRoles}},[_vm._v("删除")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-col',{attrs:{"span":12}},[_c('mw-tree',{ref:"deptRoleTree",attrs:{"multiple":false,"multipleLeaf":true,"treeData":_vm.treeData,"url":_vm.deptRoleTreeUrl,"autoLoad":false,"selectNode":_vm.selectNode},on:{"changed":_vm.changed}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.limitName,"stripe":""}},[_c('el-table-column',{attrs:{"label":"权限名称"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.name)+"\n            ")]}}])})],1)]],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container mw-bar-data org_mgr"},[_c('split-pane',{attrs:{"defaultSize":358,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('mw-dialog',{ref:"userAddDialog",attrs:{"size":"large_large","before-close":_vm.closeUserDialog,"title":_vm.$lang(_vm.user.id ? '编辑用户' : '新建用户'),"close-on-click-modal":false},on:{"opened":_vm.initUserImg}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.closeUserDialog}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(" "+_vm._s(_vm.$lang("关闭")))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSaveBtn || (_vm.showBtn && !_vm.readMode) || (_vm.readMode && !_vm.noResetPwd)),expression:"showSaveBtn || (showBtn && !readMode) || (readMode && !noResetPwd)"}],staticStyle:{"margin":"4px 7px"},attrs:{"type":"primary"},on:{"click":_vm.newUser}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v(" "+_vm._s(_vm.$lang("保存")))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.findRoles}},[_c('i',{staticClass:"fa fa-vcard"}),_vm._v("  "+_vm._s(_vm.$lang("查看角色")))]),_vm._v(" "),(_vm.user.id)?_c('span',{staticClass:"pull-right"},[_c('b',[_vm._v(_vm._s(_vm.$lang("编码"))+"：")]),_vm._v(_vm._s(_vm.user.id)+"\n              ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[[_c('el-row',[_c('el-form',{ref:"userForm",attrs:{"model":_vm.user,"rules":_vm.rules,"label-width":"130px"}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('登录账号'),"prop":"loginId"}},[_c('el-input',{attrs:{"disabled":_vm.readMode||_vm.hideBtn},model:{value:(_vm.user.loginId),callback:function ($$v) {_vm.$set(_vm.user, "loginId", $$v)},expression:"user.loginId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('真实姓名'),"prop":"name"}},[_c('el-input',{attrs:{"disabled":_vm.readMode},on:{"input":_vm.getPYIndexStr},model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('姓名首字母'),"prop":"pinyin"}},[_c('el-input',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.pinyin),callback:function ($$v) {_vm.$set(_vm.user, "pinyin", $$v)},expression:"user.pinyin"}}),_vm._v(" "),(!_vm.readMode)?_c('el-button',{on:{"click":_vm.getPYIndexStr}},[_vm._v(_vm._s(_vm.$lang('获取')))]):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('英文名')}},[_c('el-input',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.Englishname),callback:function ($$v) {_vm.$set(_vm.user, "Englishname", $$v)},expression:"user.Englishname"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('用户密码'),"prop":"password"}},[_c('el-input',{attrs:{"disabled":_vm.noResetPwd ? !(!_vm.user.id) : false},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_vm._v(" "),(!_vm.noResetPwd)?_c('el-button',{on:{"click":function($event){_vm.user.password = ''}}},[_vm._v(_vm._s(_vm.$lang('重置')))]):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('人员密级')}},[_c('el-select',{staticStyle:{"width":"70%"},attrs:{"placeholder":_vm.$lang('请选择')},model:{value:(_vm.user.userLevel),callback:function ($$v) {_vm.$set(_vm.user, "userLevel", $$v)},expression:"user.userLevel"}},_vm._l((_vm.userLevelOption),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('员工号')}},[_c('el-input',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.staffId),callback:function ($$v) {_vm.$set(_vm.user, "staffId", $$v)},expression:"user.staffId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('座机电话')}},[_c('el-input',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.phone),callback:function ($$v) {_vm.$set(_vm.user, "phone", $$v)},expression:"user.phone"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('移动电话')}},[_c('el-input',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.mobile),callback:function ($$v) {_vm.$set(_vm.user, "mobile", $$v)},expression:"user.mobile"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('电子邮箱')}},[_c('el-input',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('企业邮箱')}},[_c('el-input',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.companyEmail),callback:function ($$v) {_vm.$set(_vm.user, "companyEmail", $$v)},expression:"user.companyEmail"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('信息公开')}},[_c('el-radio-group',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.isSecret),callback:function ($$v) {_vm.$set(_vm.user, "isSecret", $$v)},expression:"user.isSecret"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v(_vm._s(_vm.$lang('是')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v(_vm._s(_vm.$lang("否")))])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('性别')}},[_c('el-radio-group',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.sex),callback:function ($$v) {_vm.$set(_vm.user, "sex", $$v)},expression:"user.sex"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v(_vm._s(_vm.$lang('男')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v(_vm._s(_vm.$lang('女')))])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('入职日期')}},[_c('el-date-picker',{attrs:{"type":"date","disabled":_vm.readMode},model:{value:(_vm.user.timeOfJoinInWork),callback:function ($$v) {_vm.$set(_vm.user, "timeOfJoinInWork", $$v)},expression:"user.timeOfJoinInWork"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('工龄')}},[_c('el-input',{staticStyle:{"width":"70%"},attrs:{"controls-position":"right","min":0,"disabled":true},model:{value:(_vm.user.workyear_),callback:function ($$v) {_vm.$set(_vm.user, "workyear_", $$v)},expression:"user.workyear_"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('出生日期')}},[_c('el-date-picker',{attrs:{"disabled":_vm.readMode,"type":"date"},model:{value:(_vm.user.birth),callback:function ($$v) {_vm.$set(_vm.user, "birth", $$v)},expression:"user.birth"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('职级')}},[_c('el-input',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.jobs),callback:function ($$v) {_vm.$set(_vm.user, "jobs", $$v)},expression:"user.jobs"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('是否列选')}},[_c('el-radio-group',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.listAble),callback:function ($$v) {_vm.$set(_vm.user, "listAble", $$v)},expression:"user.listAble"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v(_vm._s(_vm.$lang('是')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v(_vm._s(_vm.$lang('否')))])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('学历')}},[_c('el-select',{staticStyle:{"width":"70%"},attrs:{"placeholder":_vm.$lang('请选择'),"disabled":_vm.readMode},model:{value:(_vm.user.edu),callback:function ($$v) {_vm.$set(_vm.user, "edu", $$v)},expression:"user.edu"}},_vm._l((_vm.education),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('证件号码')}},[_c('el-input',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.idNumber),callback:function ($$v) {_vm.$set(_vm.user, "idNumber", $$v)},expression:"user.idNumber"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('房间号')}},[_c('el-input',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.roomNum),callback:function ($$v) {_vm.$set(_vm.user, "roomNum", $$v)},expression:"user.roomNum"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('绑定秘书')}},[_c('el-input',{staticStyle:{"width":"60%"},attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.secretary),callback:function ($$v) {_vm.$set(_vm.user, "secretary", $$v)},expression:"user.secretary"}}),_vm._v(" "),(!_vm.readMode)?_c('el-button',{on:{"click":_vm.bindSec}},[_vm._v(_vm._s(_vm.$lang('选择')))]):_vm._e(),_vm._v(" "),(!_vm.readMode)?_c('el-button',{on:{"click":_vm.clearSec}},[_vm._v(_vm._s(_vm.$lang('清除')))]):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"label":_vm.$lang('绑定秘书')}},[_c('el-input',{staticStyle:{"width":"60%"},attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.secretaryId),callback:function ($$v) {_vm.$set(_vm.user, "secretaryId", $$v)},expression:"user.secretaryId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('岗位')}},[_c('el-input',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.position),callback:function ($$v) {_vm.$set(_vm.user, "position", $$v)},expression:"user.position"}}),_vm._v(" "),(!_vm.readMode)?_c('el-button',{on:{"click":function($event){return _vm.chooseSure('choosePost')}}},[_vm._v(_vm._s(_vm.$lang('选择')))]):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('人员类型')}},[_c('el-radio-group',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.persontype),callback:function ($$v) {_vm.$set(_vm.user, "persontype", $$v)},expression:"user.persontype"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v(_vm._s(_vm.$lang('本地员工')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v(_vm._s(_vm.$lang('外派员工')))])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[(!_vm.showMJBS)?_c('el-form-item',{attrs:{"label":_vm.$lang('微信号')}},[_c('el-input',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.weiChatNum),callback:function ($$v) {_vm.$set(_vm.user, "weiChatNum", $$v)},expression:"user.weiChatNum"}})],1):_c('el-form-item',{attrs:{"label":_vm.$lang('密级')}},[_c('el-select',{staticStyle:{"width":"70%"},attrs:{"placeholder":_vm.$lang('请选择'),"disabled":_vm.readMode||_vm.hideBtn},model:{value:(_vm.user.mjbs),callback:function ($$v) {_vm.$set(_vm.user, "mjbs", $$v)},expression:"user.mjbs"}},[_c('el-option',{key:"无",attrs:{"label":"无","value":"无"}}),_vm._v(" "),_c('el-option',{key:"非涉密",attrs:{"label":"非涉密","value":"非涉密"}}),_vm._v(" "),_c('el-option',{key:"一般",attrs:{"label":"一般","value":"一般"}}),_vm._v(" "),_c('el-option',{key:"重要",attrs:{"label":"重要","value":"重要"}})],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('电子签名')}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.signUrl),expression:"signUrl"}],staticClass:"box"},[_c('img',{staticClass:"avatar",staticStyle:{"width":"95px","height":"43px"},attrs:{"src":_vm.signUrl}}),_vm._v(" "),_c('div',{staticClass:"box-content",staticStyle:{"top":"-12%"}},[_c('ul',{staticClass:"icon"},[_c('li',{ref:"signPlusUploader"},[_c('a',{staticStyle:{"width":"15px","height":"15px","line-height":"15px","font-size":"12px"},attrs:{"href":"#"}},[_c('i',{staticClass:"el-icon-plus"})])]),_vm._v(" "),_c('li',{attrs:{"title":"下载"},on:{"click":function($event){return _vm.downloadAttachment(_vm.fileSignList[0],_vm.signParams)}}},[_c('a',{staticStyle:{"background":"#67C23A","width":"15px","height":"15px","line-height":"15px","font-size":"12px"},attrs:{"href":"#"}},[_c('i',{staticClass:"el-icon-download"})])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.remove(_vm.fileSignList[0])}}},[_c('a',{staticStyle:{"width":"15px","height":"15px","line-height":"15px","font-size":"12px"},attrs:{"href":"#"}},[_c('i',{staticClass:"el-icon-close"})])])])])]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.signUrl && !_vm.readMode),expression:"!signUrl && !readMode"}],ref:"signUploader",attrs:{"size":"small","type":"primary"}},[_vm._v(_vm._s(_vm.$lang('选择')))])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('头像')}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageUrl),expression:"imageUrl"}],staticClass:"box"},[_c('img',{staticClass:"avatar",style:(_vm.avatarStyle),attrs:{"src":_vm.imageUrl}}),_vm._v(" "),_c('div',{staticClass:"box-content"},[_c('ul',{staticClass:"icon"},[_c('li',{ref:"imgPlusUploader"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"el-icon-plus"})])]),_vm._v(" "),_c('li',{attrs:{"title":"下载"},on:{"click":function($event){return _vm.downloadAttachment(_vm.fileList[0],_vm.defaultParams)}}},[_c('a',{staticStyle:{"background":"#67C23A"},attrs:{"href":"#"}},[_c('i',{staticClass:"el-icon-download"})])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.removePic(_vm.fileList[0],'avatar')}}},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"el-icon-close"})])])])])]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.imageUrl && !_vm.readMode),expression:"!imageUrl && !readMode"}],ref:"imgUploader",attrs:{"size":"small","type":"primary"}},[_vm._v(_vm._s(_vm.$lang('添加')))])],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"border":"1px solid #eee"}}),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('主属部门'),"prop":"primaryDepartmentName"}},[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.user.primaryDepartmentName),callback:function ($$v) {_vm.$set(_vm.user, "primaryDepartmentName", $$v)},expression:"user.primaryDepartmentName"}}),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.id && !_vm.readMode),expression:"user.id && !readMode"}],on:{"click":function($event){return _vm.showPtree()}}},[_vm._v(_vm._s(_vm.$lang('选择')))])],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('主属部门'),"prop":"primaryDepartmentId"}},[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.user.primaryDepartmentId),callback:function ($$v) {_vm.$set(_vm.user, "primaryDepartmentId", $$v)},expression:"user.primaryDepartmentId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('序号')}},[_c('el-input-number',{staticStyle:{"width":"70%"},attrs:{"min":1,"disabled":_vm.readMode,"controls-position":"right"},model:{value:(_vm.user.sn),callback:function ($$v) {_vm.$set(_vm.user, "sn", $$v)},expression:"user.sn"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('所属部门'),"prop":"departmentName"}},[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.user.departmentName),callback:function ($$v) {_vm.$set(_vm.user, "departmentName", $$v)},expression:"user.departmentName"}})],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('所属部门'),"prop":"departmentId"}},[_c('el-input',{attrs:{"disabled":_vm.readMode},model:{value:(_vm.user.departmentId),callback:function ($$v) {_vm.$set(_vm.user, "departmentId", $$v)},expression:"user.departmentId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('绑定IP'),"prop":"primaryDepartmentName"}},[_c('el-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.bindIP),expression:"user.bindIP"}],attrs:{"readonly":""},model:{value:(_vm.user.bindIP),callback:function ($$v) {_vm.$set(_vm.user, "bindIP", $$v)},expression:"user.bindIP"}}),_vm._v(" "),(!_vm.readMode)?_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.bindIP),expression:"user.bindIP"}],on:{"click":function($event){return _vm.removeIp(2)}}},[_vm._v(_vm._s(_vm.$lang('解除绑定')))]):_vm._e(),_vm._v(" "),(!_vm.readMode)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.user.bindIP),expression:"!user.bindIP"}]},[_vm._v(_vm._s(_vm.$lang("未绑定")))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('el-form',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"label-width":"130px"}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"员工级别"}},[_c('el-input',{staticStyle:{"width":"60%"},attrs:{"readonly":""},model:{value:(_vm.user.staffLevel),callback:function ($$v) {_vm.$set(_vm.user, "staffLevel", $$v)},expression:"user.staffLevel"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.chooseSure('staffLevel')}}},[_vm._v("选择")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.clearStaLevel}},[_vm._v("清空")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"二类信息查看级别"}},[_c('el-input',{staticStyle:{"width":"60%"},attrs:{"readonly":""},model:{value:(_vm.user.secondRank),callback:function ($$v) {_vm.$set(_vm.user, "secondRank", $$v)},expression:"user.secondRank"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.chooseSure('secondRank')}}},[_vm._v("选择")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.clearseaLevel}},[_vm._v("清空")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"三类信息查看级别"}},[_c('el-input',{staticStyle:{"width":"60%"},attrs:{"readonly":""},model:{value:(_vm.user.thirdRank),callback:function ($$v) {_vm.$set(_vm.user, "thirdRank", $$v)},expression:"user.thirdRank"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.chooseSure('cthirdLevel')}}},[_vm._v("选择")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.clearLevel}},[_vm._v("清空")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"主管部门"}},[_c('el-input',{staticStyle:{"width":"80%"},attrs:{"readonly":""},model:{value:(_vm.user.zgdept),callback:function ($$v) {_vm.$set(_vm.user, "zgdept", $$v)},expression:"user.zgdept"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.chooseSure('zgDeptDialog')}}},[_vm._v("选择")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.clearZgdept}},[_vm._v("清空")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"一级单位"}},[_c('el-input',{staticStyle:{"width":"80%"},attrs:{"readonly":""},model:{value:(_vm.user.firstLevelDept),callback:function ($$v) {_vm.$set(_vm.user, "firstLevelDept", $$v)},expression:"user.firstLevelDept"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.chooseSure('firstDept')}}},[_vm._v("选择")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.clearfirstDept}},[_vm._v("清空")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"二级单位"}},[_c('el-input',{staticStyle:{"width":"80%"},attrs:{"readonly":""},model:{value:(_vm.user.secondLevelDept),callback:function ($$v) {_vm.$set(_vm.user, "secondLevelDept", $$v)},expression:"user.secondLevelDept"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.chooseSure('secondDept')}}},[_vm._v("选择")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.clearsecondDept}},[_vm._v("清空")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"三级单位"}},[_c('el-input',{staticStyle:{"width":"80%"},attrs:{"readonly":""},model:{value:(_vm.user.thirdLevelDept),callback:function ($$v) {_vm.$set(_vm.user, "thirdLevelDept", $$v)},expression:"user.thirdLevelDept"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.chooseSure('thirdDept')}}},[_vm._v("选择")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.clearthirdDept}},[_vm._v("清空")])],1)],1)],1)],1)]],2)]),_vm._v(" "),_c('mw-dialog',{ref:"deptDialog",attrs:{"size":"large_small","before-close":_vm.closeDeptDialog,"title":_vm.$lang( _vm.dept.id ? '编辑部门' : '新建部门' ),"close-on-click-modal":false}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.closeDeptDialog}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(" "+_vm._s(_vm.$lang('关闭')))]),_vm._v(" "),_c('el-button',{staticStyle:{"margin":"4px 7px"},attrs:{"type":"primary"},on:{"click":_vm.saveDept}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v(" "+_vm._s(_vm.$lang('保存')))]),_vm._v(" "),(_vm.dept.id)?_c('span',{staticClass:"pull-right"},[_c('b',[_vm._v(_vm._s(_vm.$lang('ID'))+"：")]),_vm._v(_vm._s(_vm.dept.id)+"\n              ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-row',[_c('el-form',{ref:"ruleForm",attrs:{"label-width":"150px","model":_vm.dept,"rules":_vm.deptRule}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('部门名称'),"prop":"name"}},[_c('el-input',{model:{value:(_vm.dept.name),callback:function ($$v) {_vm.$set(_vm.dept, "name", $$v)},expression:"dept.name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('部门简称')}},[_c('el-input',{model:{value:(_vm.dept.shortname),callback:function ($$v) {_vm.$set(_vm.dept, "shortname", $$v)},expression:"dept.shortname"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('英文名称')}},[_c('el-input',{model:{value:(_vm.dept.Englishname),callback:function ($$v) {_vm.$set(_vm.dept, "Englishname", $$v)},expression:"dept.Englishname"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('编码')}},[_c('el-input',{model:{value:(_vm.dept.code),callback:function ($$v) {_vm.$set(_vm.dept, "code", $$v)},expression:"dept.code"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('部门类型')}},[_c('el-radio-group',{model:{value:(_vm.dept.flag),callback:function ($$v) {_vm.$set(_vm.dept, "flag", $$v)},expression:"dept.flag"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v(_vm._s(_vm.$lang('单位')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v(_vm._s(_vm.$lang('部门')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"3"}},[_vm._v(_vm._s(_vm.$lang('子部门')))])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('是否列选')}},[_c('el-radio-group',{model:{value:(_vm.dept.listAble),callback:function ($$v) {_vm.$set(_vm.dept, "listAble", $$v)},expression:"dept.listAble"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v(_vm._s(_vm.$lang('是')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v(_vm._s(_vm.$lang('否')))])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('管理员','管  理  员 ')}},[_c('el-input',{staticStyle:{"width":"75%"},attrs:{"type":"textarea","readonly":""},model:{value:(_vm.dept.adminName),callback:function ($$v) {_vm.$set(_vm.dept, "adminName", $$v)},expression:"dept.adminName"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.showChooseAdminDialog}},[_vm._v(_vm._s(_vm.$lang('选择')))]),_vm._v(" "),_c('el-button',{on:{"click":_vm.clearMan}},[_vm._v(" "+_vm._s(_vm.$lang('清空')))])],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('序号')}},[_c('el-input-number',{attrs:{"min":1,"controls-position":"right"},model:{value:(_vm.dept.sn),callback:function ($$v) {_vm.$set(_vm.dept, "sn", $$v)},expression:"dept.sn"}})],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$lang('上级')}},[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.dept.parentName),callback:function ($$v) {_vm.$set(_vm.dept, "parentName", $$v)},expression:"dept.parentName"}})],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"上级"}},[_c('el-input',{model:{value:(_vm.dept.parentId),callback:function ($$v) {_vm.$set(_vm.dept, "parentId", $$v)},expression:"dept.parentId"}})],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"管理员"}},[_c('el-input',{staticStyle:{"width":"75%"},attrs:{"type":"textarea","readonly":""},model:{value:(_vm.dept.adminId),callback:function ($$v) {_vm.$set(_vm.dept, "adminId", $$v)},expression:"dept.adminId"}})],1)],1)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtn && !_vm.readMode && !_vm.hideBtn),expression:"showBtn && !readMode && !hideBtn"}],on:{"click":_vm.addDepart}},[_c('i',{staticClass:"fa fa-plus-square"}),_vm._v(_vm._s(_vm.$lang('添加')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtn && !_vm.readMode),expression:"showBtn && !readMode"}],on:{"click":_vm.editDept}},[_c('i',{staticClass:"fa fa-pencil fa-fw "}),_vm._v(_vm._s(_vm.$lang('编辑')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtn && !_vm.readMode && !_vm.hideBtn),expression:"showBtn && !readMode && !hideBtn"}],on:{"click":_vm.deleteDepartment}},[_c('i',{staticClass:"fa fa-trash-o "}),_vm._v(_vm._s(_vm.$lang('删除')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag==1),expression:"expandFlag==1"}],on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v(" "+_vm._s(_vm.$lang('展开'))+"\n            ")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag!=1),expression:"expandFlag!=1"}],on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v(_vm._s(_vm.$lang('折叠'))+"\n            ")]),_vm._v(" "),_c('el-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtn && !_vm.readMode && !_vm.hideBtn),expression:"showBtn && !readMode && !hideBtn"}],attrs:{"trigger":"hover"},on:{"command":_vm.handleDeptMoreCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n                "+_vm._s(_vm.$lang('更多'))),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"importDept"}},[_vm._v(_vm._s(_vm.$lang('导入')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"exportDept"}},[_vm._v(_vm._s(_vm.$lang('导出')))])],1)],1)],1),_vm._v(" "),_c('div',{ref:"deptTreePanelDiv",staticClass:"mw-toolbar__body"},[(_vm.defaultParams1 && _vm.defaultParams1.rootId)?_c('div',{staticClass:" treeClass"},[_c('mw-tree',{ref:"deptTreeData",attrs:{"url":_vm.deptTreeUrl,"async":true,"multiple":false,"defaultParams":_vm.defaultParams1,"aliasId":"departmentId","contextMenuItem":_vm.menuItem1,"autoLoad":false,"dragEnable":_vm.userInfo.unitAdmin ? false:true,"expandedFirst":true,"selectFirst":true,"types":_vm.types},on:{"changeItem":_vm.aa,"dataFilter":_vm.treeDataFilter,"move":_vm.moveTreeNode,"changed":_vm.loadTableTree}})],1):_c('div',{staticClass:"treeClass"},[_c('mw-tree',{ref:"deptTreeData",attrs:{"url":_vm.deptTreeUrl,"async":true,"multiple":false,"contextMenuItem":_vm.menuItem,"autoLoad":false,"expandedFirst":true,"selectFirst":true,"types":_vm.types},on:{"dataFilter":_vm.treeDataFilter,"changed":_vm.loadTableTree,"move":_vm.moveTreeNode}})],1)])],1)]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"dataTable",attrs:{"layout":_vm.layout,"autoLoad":false,"defaultParams":_vm.defaultParams},on:{"rowStyle":_vm.tableRowStyle}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtn && !_vm.readMode),expression:"showBtn && !readMode"}],attrs:{"slot":"dropDown"},slot:"dropDown"},[_c('el-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtn && !_vm.readMode && !_vm.hideBtn),expression:"showBtn && !readMode && !hideBtn"}],attrs:{"trigger":"hover"},on:{"command":_vm.handleDeptCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_c('i',{staticClass:"fa fa-cog"}),_vm._v(_vm._s(_vm.$lang('部门操作'))),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"add"}},[_c('i',{staticClass:"fa fa-plus-square"}),_vm._v(_vm._s(_vm.$lang('追加部门'))+"\n                ")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"transform"}},[_c('i',{staticClass:"fa fa-plus-square"}),_vm._v(_vm._s(_vm.$lang('转换部门'))+"\n                ")])],1)],1),_vm._v(" "),_c('el-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtn && !_vm.readMode && !_vm.hideBtn),expression:"showBtn && !readMode && !hideBtn"}],attrs:{"trigger":"hover"},on:{"command":_vm.handleSortCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n                "+_vm._s(_vm.$lang('排序'))),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"sort"}},[_vm._v(_vm._s(_vm.$lang('排序')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"top"}},[_vm._v(_vm._s(_vm.$lang('置顶')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"footer"}},[_vm._v(_vm._s(_vm.$lang('置底')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"up"}},[_vm._v(_vm._s(_vm.$lang('上移')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"down"}},[_vm._v(" "+_vm._s(_vm.$lang('下移')))])],1)],1),_vm._v(" "),_c('el-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtn && !_vm.readMode),expression:"showBtn && !readMode"}],attrs:{"trigger":"hover"},on:{"command":_vm.handleMoreCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n                "+_vm._s(_vm.$lang('更多'))),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[(!_vm.hideBtn)?_c('el-dropdown-item',{attrs:{"command":"leadIn"}},[_vm._v(_vm._s(_vm.$lang('导入')))]):_vm._e(),_vm._v(" "),(!_vm.hideBtn)?_c('el-dropdown-item',{attrs:{"command":"leadOut"}},[_vm._v(_vm._s(_vm.$lang('导出')))]):_vm._e(),_vm._v(" "),(_vm.hideBtn)?_c('el-dropdown-item',{attrs:{"command":"bindip"}},[_vm._v(_vm._s(_vm.$lang('ip绑定')))]):_vm._e(),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"removeip"}},[_vm._v(_vm._s(_vm.$lang('解除ip绑定')))])],1)],1),_vm._v(" "),_c('el-dropdown',{directives:[{name:"show",rawName:"v-show",value:((_vm.showBtn && !_vm.readMode && _vm.showHandOver)||_vm.showJBBtn),expression:"(showBtn && !readMode && showHandOver)||showJBBtn"}],attrs:{"trigger":"hover"},on:{"command":_vm.handOverCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n                "+_vm._s(_vm.$lang('交办'))),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"todo"}},[_vm._v(_vm._s(_vm.$lang('待办交办')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"finish"}},[_vm._v(_vm._s(_vm.$lang('经办交办')))])],1)],1),_vm._v(" "),_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true,"lock":true}}],staticStyle:{"float":"right","margin":"9px 3px 0px 0px"},attrs:{"size":"mini"},on:{"click":_vm.toInvalidUser}},[_c('i',{staticClass:"fa fa-user-times"}),_vm._v(_vm._s(_vm.$lang('无效用户')))])],1)])],1)])],2),_vm._v(" "),_c('mw-dialog',{ref:"secDialog",attrs:{"title":_vm.$lang('帐号绑定IP')}},[_c('el-form',{staticStyle:{"margin-top":"20px"},attrs:{"label-width":"100px"}},[_c('el-form-item',{attrs:{"label":"帐号绑定IP"}},[_c('span',{staticClass:"form-content",staticStyle:{"display":"inline-block","margin-left":"5%"}},[_c('el-input',{staticStyle:{"height":"30px"},model:{value:(_vm.bindForm.bindIP),callback:function ($$v) {_vm.$set(_vm.bindForm, "bindIP", $$v)},expression:"bindForm.bindIP"}}),_vm._v(" "),_c('el-button',{staticClass:"btn-danger",staticStyle:{"margin-left":"20px"},on:{"click":_vm.clearIp}},[_vm._v("清除")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.closeBindIP}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveBindIP}},[_vm._v("确 定")])],1)],1),_vm._v(" "),_c('mw-dialog',{ref:"userRoleDialog",attrs:{"size":"small_small","title":_vm.$lang('角色浏览'),"close-on-click-modal":false,"before-close":_vm.closeRoleDialog}},[_c('queryrole',{attrs:{"deptId":_vm.checkedId,"userIdentityId":_vm.identityId,"userInf":_vm.userInfo1,"listAble":_vm.listAble,"noResetPwd":_vm.noResetPwd}})],1),_vm._v(" "),_c('mw-dialog',{ref:"impDeptDialog",attrs:{"title":_vm.$lang('导入部门数据'),"size":"mini_small","footerButton":_vm.deptImpBtn},on:{"opened":_vm.showDeptUpload}},[_c('div',{staticClass:"mw-dialog_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"导入说明:"}},[[_vm._v("\n                第一步：单击此处"),_c('el-button',{on:{"click":_vm.downloadDeptExcel}},[_vm._v("下载模版")]),_c('br'),_vm._v("\n                第二步：按照模板格式录入部门数据;"),_c('br'),_vm._v("\n                第三步：上传模板文件:\n              ")]],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传文件:"}},[_c('el-button',{ref:"DeptUploader"},[_vm._v("上传文件")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip"},[_vm._v("只能上传.xls文件")])],1)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"leadDialog",attrs:{"title":"导入人员数据","size":"mini_small","footerButton":_vm.leadButton},on:{"opened":_vm.showUserUpload}},[_c('div',{staticClass:"mw-dialog_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"导入说明:"}},[[_vm._v("\n                    第一步：单击此处"),_c('el-button',{on:{"click":_vm.downloadPersonExcel}},[_vm._v("下载模版")]),_c('br'),_vm._v("\n                    第二步：按照模板格式录入人员数据;"),_c('br'),_vm._v("\n                    第三步：上传模板文件:\n                ")]],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传文件:"}},[_c('el-button',{ref:"UserUploader"},[_vm._v("上传文件")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip"},[_vm._v("只能上传.xls文件")])],1)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"handOverTodo",attrs:{"title":_vm.$lang('待办交办'),"size":"mini_small","footerButton":_vm.handOverTodoButton}},[_c('div',{staticClass:"mw-dialog_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('原办理人'),"prop":"assigned"}},[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.handOverTodoForm.assigned),callback:function ($$v) {_vm.$set(_vm.handOverTodoForm, "assigned", $$v)},expression:"handOverTodoForm.assigned"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.userChoose({id:'assignedId',name:'assigned',type:1})}}},[_vm._v(_vm._s(_vm.$lang('选择')))])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"assignedId"}},[_c('el-input',{model:{value:(_vm.handOverTodoForm.assignedId),callback:function ($$v) {_vm.$set(_vm.handOverTodoForm, "assignedId", $$v)},expression:"handOverTodoForm.assignedId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('交接收人'),"prop":"recipient"}},[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.handOverTodoForm.recipient),callback:function ($$v) {_vm.$set(_vm.handOverTodoForm, "recipient", $$v)},expression:"handOverTodoForm.recipient"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.userChoose({id:'recipientId',name:'recipient',type:1})}}},[_vm._v(_vm._s(_vm.$lang('选择')))])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"recipientId"}},[_c('el-input',{model:{value:(_vm.handOverTodoForm.recipientId),callback:function ($$v) {_vm.$set(_vm.handOverTodoForm, "recipientId", $$v)},expression:"handOverTodoForm.recipientId"}})],1)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"userSelDialog",attrs:{"size":"large_large","width":'680px',"title":_vm.$lang('选择用户'),"footerButton":_vm.userSelFooterButton,"close-on-click-modal":false}},[_c('loadMan',{ref:"handOverUserChoose",attrs:{"isRadio":true,"defaultParentId":_vm.defaultParentId,"listAble":false}})],1),_vm._v(" "),_c('mw-dialog',{ref:"handOverFinish",attrs:{"width":'580px',"title":_vm.$lang('经办交办'),"footerButton":_vm.handOverFinishButton}},[_c('div',{staticClass:"mw-dialog_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('原办理人'),"prop":"assigned"}},[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.handOverFinishForm.assigned),callback:function ($$v) {_vm.$set(_vm.handOverFinishForm, "assigned", $$v)},expression:"handOverFinishForm.assigned"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.userChoose({id:'assignedId',name:'assigned',type:2})}}},[_vm._v(_vm._s(_vm.$lang('选择')))])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"assignedId"}},[_c('el-input',{model:{value:(_vm.handOverFinishForm.assignedId),callback:function ($$v) {_vm.$set(_vm.handOverFinishForm, "assignedId", $$v)},expression:"handOverFinishForm.assignedId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('交接收人'),"prop":"recipient"}},[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.handOverFinishForm.recipient),callback:function ($$v) {_vm.$set(_vm.handOverFinishForm, "recipient", $$v)},expression:"handOverFinishForm.recipient"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.userChoose({id:'recipientId',name:'recipient',type:2})}}},[_vm._v(_vm._s(_vm.$lang('选择')))])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"recipientId"}},[_c('el-input',{model:{value:(_vm.handOverFinishForm.recipientId),callback:function ($$v) {_vm.$set(_vm.handOverFinishForm, "recipientId", $$v)},expression:"handOverFinishForm.recipientId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('应用范围'),"prop":"moduleName"}},[_c('el-input',{staticStyle:{"width":"300px"},attrs:{"type":"textarea","autosize":{minRows: 2},"placeholder":"","readonly":""},model:{value:(_vm.handOverFinishForm.moduleName),callback:function ($$v) {_vm.$set(_vm.handOverFinishForm, "moduleName", $$v)},expression:"handOverFinishForm.moduleName"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.moduleChoose}},[_vm._v(_vm._s(_vm.$lang('选择')))]),_vm._v(" "),_c('el-button',{on:{"click":_vm.moduleClear}},[_vm._v(_vm._s(_vm.$lang('清空')))])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"recipientId"}},[_c('el-input',{model:{value:(_vm.handOverFinishForm.moduleId),callback:function ($$v) {_vm.$set(_vm.handOverFinishForm, "moduleId", $$v)},expression:"handOverFinishForm.moduleId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('时间范围'),"prop":"startTime"}},[_c('el-date-picker',{staticStyle:{"width":"150px"},attrs:{"type":"date"},model:{value:(_vm.handOverFinishForm.startTime),callback:function ($$v) {_vm.$set(_vm.handOverFinishForm, "startTime", $$v)},expression:"handOverFinishForm.startTime"}}),_vm._v(_vm._s(_vm.$lang('至：'))+"\n              "),_c('el-date-picker',{staticStyle:{"width":"150px"},attrs:{"type":"date"},model:{value:(_vm.handOverFinishForm.endTime),callback:function ($$v) {_vm.$set(_vm.handOverFinishForm, "endTime", $$v)},expression:"handOverFinishForm.endTime"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('备注')}},[_vm._v("\n              "+_vm._s(_vm.$lang('1、此交办表只是赋予交接人在汇总视图中获得查看打开权限；'))),_c('br'),_vm._v("\n              "+_vm._s(_vm.$lang('2、若不选择【应用范围】，则默认全部应用范围；'))+" "),_c('br'),_vm._v("\n              "+_vm._s(_vm.$lang('3、若不选择【时间范围】，则默认全部时间范围。'))+"\n            ")])],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"primaryDeptDialog",attrs:{"title":"选择主属部门","size":"mini_small","footerButton":_vm.deptBtns,"close-on-click-modal":false}},[_c('mw-tree',{ref:"primaryDept",attrs:{"url":_vm.primaryDUrl,"async":true,"expandedFirst":true,"multiple":false,"defaultParentId":_vm.user.id}})],1),_vm._v(" "),_c('mw-dialog',{ref:"addDeptDialog",attrs:{"size":"mini_small","footerButton":_vm.btns,"close-on-click-modal":false}},[_c('mw-tree',{ref:"deptTree",attrs:{"url":_vm.deptTreeUrl,"async":true,"multiple":false,"defaultParams":_vm.defaultParams1,"aliasId":"departmentId","autoLoad":false,"expandedFirst":true,"selectFirst":true}})],1),_vm._v(" "),_c('mw-dialog',{ref:"addDeptDialog1",attrs:{"size":"mini_small","footerButton":_vm.btns1,"close-on-click-modal":false}},[_c('mw-tree',{ref:"deptTree1",attrs:{"url":_vm.deptTreeUrl,"threeState":true,"async":true,"multiple":true,"defaultParams":_vm.defaultParams1,"aliasId":"departmentId","autoLoad":false,"expandedFirst":true,"selectFirst":true}})],1),_vm._v(" "),_c('mw-dialog',{ref:"choosePost",attrs:{"close-on-click-modal":false}},[_c('choosePost',{on:{"confirm":_vm.confirmPost,"cancel":function($event){return _vm.cancel('choosePost')}}})],1),_vm._v(" "),_c('infothird',{ref:"secondRank",on:{"confirm":_vm.confirmTwoRand}}),_vm._v(" "),_c('staff',{ref:"staffLevel",on:{"confirm":_vm.employLevel}}),_vm._v(" "),_c('infothird',{ref:"cthirdLevel",on:{"confirm":_vm.cthirdLevel}}),_vm._v(" "),_c('zgdept',{ref:"zgDeptDialog",on:{"confirm":_vm.zgdeptChoose}}),_vm._v(" "),_c('chooseSec',{ref:"chooseSec",on:{"chooseSec":_vm.confirmSec}}),_vm._v(" "),_c('first',{ref:"firstDept",on:{"confirm":_vm.firstDeptChoose}}),_vm._v(" "),_c('first',{ref:"secondDept",on:{"confirm":_vm.secondDeptChoose}}),_vm._v(" "),_c('first',{ref:"thirdDept",on:{"confirm":_vm.thirdDeptChoose}}),_vm._v(" "),_c('mw-dialog',{ref:"userDialog",attrs:{"size":"large_large","title":"选择用户","footerButton":_vm.userFooterButton,"close-on-click-modal":false}},[_c('loadMan',{ref:"chooseMangers",attrs:{"RAdminData":_vm.deptManagers,"defaultParentId":_vm.defaultParentId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('toolbar-table',{ref:"toolbarTable",attrs:{"layout":_vm.layout}}),_vm._v(" "),_c('mw-dialog',{ref:"setDeptDialog",attrs:{"size":"mini_small","footerButton":_vm.btns,"title":"选择部门机构","close-on-click-modal":false}},[_c('div',[_c('mw-tree',{ref:"deptTree",staticClass:"mw-dialog-body",attrs:{"url":_vm.deptTreeUrl,"async":true,"expandedFirst":true,"multiple":false}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.compId,{tag:"component",attrs:{"params":_vm.params}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container"},[_c('mw-dialog',{ref:"unitDialog",attrs:{"size":"mini_mini","title":"选择单位","footerButton":_vm.unitFooterButton,"close-on-click-modal":false}},[_c('mw-tree',{ref:"unitTree",attrs:{"url":_vm.unitTreeUrl,"defaultParams":_vm.defaultUnitParams,"async":false,"multiple":true,"contextMenuItem":_vm.contextMenuItem,"expandedFirst":true,"checkNodes":_vm.checkUnitIds}})],1),_vm._v(" "),_c('mw-dialog',{ref:"impDialog",attrs:{"title":"导入权限定义数据","size":"mini_small","footerButton":_vm.impBtton},on:{"opened":_vm.showUpload}},[_c('div',{staticClass:"mw-dialog_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"导入说明:"}},[[_vm._v("\n              第一步：单击此处"),_c('el-button',{on:{"click":_vm.downloadExcel}},[_vm._v("下载模版")]),_c('br'),_vm._v("\n              第二步：按照模板格式录入数据;"),_c('br'),_vm._v("\n              第三步：上传模板文件:\n            ")]],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传文件:"}},[_c('el-button',{ref:"uploader"},[_vm._v("上传文件")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip"},[_vm._v("只能上传.xls文件")])],1)],1)],1)],1)]),_vm._v(" "),_c('split-pane',{attrs:{"defaultSize":358}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{on:{"click":function($event){return _vm.addRole()}}},[_c('i',{staticClass:"fa fa-plus-square",attrs:{"type":"primary"}}),_vm._v("新增")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.deleteRole()}}},[_c('i',{staticClass:"fa fa-trash-o",attrs:{"type":"primary"}}),_vm._v("删除")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag==1),expression:"expandFlag==1"}],on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v("展开")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag!=1),expression:"expandFlag!=1"}],on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v("折叠")]),_vm._v(" "),_c('el-dropdown',{attrs:{"trigger":"hover"},on:{"command":_vm.handleMoreCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n              更多"),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"import"}},[_vm._v("导入")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"export"}},[_vm._v("导出")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"roleTree",attrs:{"url":_vm.roleTreeUrl,"defaultParams":_vm.defaultTreeParams,"async":true,"contextMenuItem":_vm.contextMenuItem,"dragEnable":true,"expandedFirst":true,"selectFirst":true},on:{"changed":_vm.changed}})],1)])]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.saveRole}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v(" 保存")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","margin-top":"8px"},attrs:{"type":"info"},on:{"click":_vm.helpnotes}},[_c('i',{staticClass:"fa fa-question"}),_vm._v("帮助\n          ")]),_vm._v(" "),(_vm.form.id)?_c('span',{staticClass:"pull-right"},[_c('b',[_vm._v("权限编码：")]),_vm._v(_vm._s(_vm.form.id)+"\n        ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-form',{ref:"roleForm",staticClass:"mw-form",attrs:{"label-width":"130px","rules":_vm.rules,"model":_vm.form}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"id"}},[_c('el-input',{model:{value:(_vm.form.id),callback:function ($$v) {_vm.$set(_vm.form, "id", $$v)},expression:"form.id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"权限名称","prop":"name"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"权限类型","prop":"type"}},[[_c('el-radio-group',{model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v("身份权限")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v("文档权限")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"3"}},[_vm._v("流程权限")])],1)]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"所属单位","prop":"unitNames"}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"readonly":""},model:{value:(_vm.form.unitNames),callback:function ($$v) {_vm.$set(_vm.form, "unitNames", $$v)},expression:"form.unitNames"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.showUnitDialog}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"unitIds"}},[_c('el-input',{model:{value:(_vm.form.unitIds),callback:function ($$v) {_vm.$set(_vm.form, "unitIds", $$v)},expression:"form.unitIds"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"权限描述","prop":"dec"}},[_c('el-input',{model:{value:(_vm.form.dec),callback:function ($$v) {_vm.$set(_vm.form, "dec", $$v)},expression:"form.dec"}})],1)],1)],1)],1)])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_roleInf_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_roleInf_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_roleInf_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_roleInf_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_roleInf_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_40e93c5f_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_roleInf_vue__ = __webpack_require__(1204);
function injectStyle (ssrContext) {
  __webpack_require__(1203)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40e93c5f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_roleInf_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_40e93c5f_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_roleInf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mw-dialog',{ref:"unitDialog",attrs:{"size":"mini_mini","title":"选择单位","footerButton":_vm.unitFooterButton,"close-on-click-modal":false}},[_c('mw-tree',{ref:"unitTree",attrs:{"url":_vm.unitTreeUrl,"defaultParams":_vm.defaultParams,"async":false,"selectNode":_vm.selectUnitId}})],1),_vm._v(" "),_c('mw-dialog',{ref:"roleDialog",attrs:{"size":"mini_small","title":"选择角色","footerButton":_vm.roleFooterButton,"close-on-click-modal":false}},[_c('mw-tree',{ref:"roleTree",attrs:{"url":_vm.roleTreeUrl,"multipleLeaf":true,"checkNodes":_vm.checkRoleIds,"async":false,"expandedFirst":true,"multiple":true}})],1),_vm._v(" "),_c('mw-dialog',{ref:"userDialog",attrs:{"size":"large_large","title":"选择用户","footerButton":_vm.userFooterButton,"close-on-click-modal":false}},[_c('loadMan',{ref:"userChoose",attrs:{"RAdminData":_vm.chooseUsers,"defaultParentId":_vm.defaultParentId}})],1),_vm._v(" "),_c('el-form',{ref:"groupForm",attrs:{"label-width":"130px","rules":_vm.rules,"model":_vm.group}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{ref:"unitName",attrs:{"label":"单位名称"}},[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.group.unitName),callback:function ($$v) {_vm.$set(_vm.group, "unitName", $$v)},expression:"group.unitName"}}),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.group.name === '默认角色'},on:{"click":_vm.showUnitDialog}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"unitId"}},[_c('el-input',{model:{value:(_vm.group.unitId),callback:function ($$v) {_vm.$set(_vm.group, "unitId", $$v)},expression:"group.unitId"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"code"}},[_c('el-input',{model:{value:(_vm.group.code),callback:function ($$v) {_vm.$set(_vm.group, "code", $$v)},expression:"group.code"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"角色名称","prop":"name"}},[_c('el-input',{attrs:{"readonly":_vm.group.name === '默认角色' && _vm.group.id.length > 0},model:{value:(_vm.group.name),callback:function ($$v) {_vm.$set(_vm.group, "name", $$v)},expression:"group.name"}}),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowDefultBtn=='1'),expression:"isShowDefultBtn=='1'"}],on:{"click":function($event){return _vm.changeDefultRole(1)}}},[_vm._v("默认角色")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowDefultBtn=='2'),expression:"isShowDefultBtn=='2'"}],on:{"click":function($event){return _vm.changeDefultRole(2)}}},[_vm._v("普通角色")])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"id"}},[_c('el-input',{model:{value:(_vm.group.id),callback:function ($$v) {_vm.$set(_vm.group, "id", $$v)},expression:"group.id"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"身份权限","prop":"postRoleNames"}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"readonly":""},model:{value:(_vm.group.postRoleNames),callback:function ($$v) {_vm.$set(_vm.group, "postRoleNames", $$v)},expression:"group.postRoleNames"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.showRoleDialog}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"postRoleIds"}},[_c('el-input',{model:{value:(_vm.group.postRoleIds),callback:function ($$v) {_vm.$set(_vm.group, "postRoleIds", $$v)},expression:"group.postRoleIds"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"文档权限","prop":"docRoleNames"}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"readonly":""},model:{value:(_vm.group.docRoleNames),callback:function ($$v) {_vm.$set(_vm.group, "docRoleNames", $$v)},expression:"group.docRoleNames"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.showRoleDialog}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"docRoleIds"}},[_c('el-input',{model:{value:(_vm.group.docRoleIds),callback:function ($$v) {_vm.$set(_vm.group, "docRoleIds", $$v)},expression:"group.docRoleIds"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"流程权限","prop":"flowRoleNames"}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"readonly":""},model:{value:(_vm.group.flowRoleNames),callback:function ($$v) {_vm.$set(_vm.group, "flowRoleNames", $$v)},expression:"group.flowRoleNames"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.showRoleDialog}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"flowRoleIds"}},[_c('el-input',{model:{value:(_vm.group.flowRoleIds),callback:function ($$v) {_vm.$set(_vm.group, "flowRoleIds", $$v)},expression:"group.flowRoleIds"}})],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.group.name != '默认角色'),expression:"group.name != '默认角色'"}],attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"用户人员","prop":"userNames"}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"readonly":""},model:{value:(_vm.group.userNames),callback:function ($$v) {_vm.$set(_vm.group, "userNames", $$v)},expression:"group.userNames"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.userChoose}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"userDeptIdentityIds"}},[_c('el-input',{model:{value:(_vm.group.userDeptIdentityIds),callback:function ($$v) {_vm.$set(_vm.group, "userDeptIdentityIds", $$v)},expression:"group.userDeptIdentityIds"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"角色描述","prop":"dec"}},[_c('el-input',{model:{value:(_vm.group.dec),callback:function ($$v) {_vm.$set(_vm.group, "dec", $$v)},expression:"group.dec"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container"},[_c('mw-dialog',{ref:"limitTree",attrs:{"size":"large_large","title":_vm.id ? '编辑权限' : '新建权限',"before-close":_vm.handleClose,"close-on-click-modal":false}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveGroup}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v("  保存")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('role',{ref:"role",attrs:{"openDialog":_vm.openDialog,"groupId":_vm.id,"showDefultBtn":_vm.showDefultBtn,"deptInfo":_vm.deptInfo}})],1)]),_vm._v(" "),_c('mw-dialog',{ref:"impDialog",attrs:{"title":"导入角色管理数据","size":"mini_small","footerButton":_vm.impBtton}},[_c('div',{staticClass:"mw-dialog_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"导入说明:"}},[[_vm._v("\n              第一步：单击此处"),_c('el-button',{on:{"click":_vm.downloadExcel}},[_vm._v("下载模版")]),_c('br'),_vm._v("\n              第二步：按照模板格式录入角色管理数据;"),_c('br'),_vm._v("\n              第三步：上传模板文件:\n            ")]],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传文件:"}},[[_c('el-upload',{ref:"importData",staticStyle:{"display":"inline-block"},attrs:{"on-success":_vm.importSuccessCallback,"auto-upload":false,"action":_vm.importAction,"multiple":"","headers":_vm.headers,"limit":1}},[_c('el-button',[_vm._v("获取文件")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传.xls/.xlsx文件")])],1)]],2)],1)],1)],1)]),_vm._v(" "),_c('split-pane',{attrs:{"defaultSize":358,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag==1),expression:"expandFlag==1"}],attrs:{"size":"mini"},on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v("展开")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag!=1),expression:"expandFlag!=1"}],attrs:{"size":"mini"},on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v("折叠")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.toGroup}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v("分类显示")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"unitTree",attrs:{"url":_vm.unitTreeUrl,"defaultParams":_vm.defaultParams,"autoLoad":false,"async":false,"multiple":false,"selectFirst":true,"dragEnable":true,"expandedFirst":true},on:{"changed":_vm.loadTableTree}})],1)])]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"dataTable",attrs:{"layout":_vm.layout,"autoLoad":false}},[_c('span',{attrs:{"slot":"dropDown"},slot:"dropDown"},[_c('el-dropdown',{attrs:{"trigger":"hover"},on:{"command":_vm.handleMoreCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n                 更多"),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"import"}},[_vm._v("导入")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"export"}},[_vm._v("导出")])],1)],1)],1)])],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jobRole_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jobRole_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jobRole_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jobRole_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jobRole_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_846ad46c_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_jobRole_vue__ = __webpack_require__(1210);
function injectStyle (ssrContext) {
  __webpack_require__(1208)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-846ad46c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_jobRole_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_846ad46c_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_jobRole_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"unitDialog",attrs:{"size":"mini_mini","title":"选择单位","footerButton":_vm.unitFooterButton,"close-on-click-modal":false}},[_c('mw-tree',{ref:"unitTree",attrs:{"url":_vm.unitTreeUrl,"defaultParams":_vm.defaultParams,"autoLoad":false,"async":false,"selectNode":_vm.selectUnitId,"multiple":_vm.multiple,"expandedFirst":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container"},[_c('unitDialog',{ref:"unitDialog",attrs:{"selectUnitId":_vm.group.unitId},on:{"confirm":_vm.confirmUnit}}),_vm._v(" "),_c('unitDialog',{ref:"unitDialog1",attrs:{"selectUnitId":_vm.group.unitId,"multiple":true},on:{"confirm":_vm.confirmUnit1}}),_vm._v(" "),_c('mw-dialog',{ref:"roleDialog",attrs:{"size":"mini_small","title":"选择角色","footerButton":_vm.roleFooterButton,"close-on-click-modal":false}},[_c('mw-tree',{ref:"roleTree",attrs:{"url":_vm.roleTreeUrl,"multipleLeaf":true,"checkNodes":_vm.checkRoleIds,"async":false,"expandedFirst":true,"multiple":true}})],1),_vm._v(" "),_c('mw-dialog',{ref:"userDialog",attrs:{"size":"large_large","title":"选择用户","footerButton":_vm.userFooterButton,"close-on-click-modal":false}},[_c('loadMan',{ref:"userChoose",attrs:{"RAdminData":_vm.chooseUsers,"defaultParentId":_vm.defaultParentId,"listAble":_vm.listAble,"isAppendDepartment":true}})],1),_vm._v(" "),_c('mw-dialog',{ref:"impDialog",attrs:{"title":"导入角色管理数据","size":"mini_small","footerButton":_vm.impBtton},on:{"opened":_vm.showUpload}},[_c('div',{staticClass:"mw-dialog_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"导入说明:"}},[[_vm._v("\n              第一步：单击此处"),_c('el-button',{on:{"click":_vm.downloadExcel}},[_vm._v("下载模版")]),_c('br'),_vm._v("\n              第二步：按照模板格式录入角色管理数据;"),_c('br'),_vm._v("\n              第三步：上传模板文件:\n            ")]],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传文件:"}},[_c('el-button',{ref:"uploader"},[_vm._v("上传文件")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip"},[_vm._v("只能上传.xls文件")])],1)],1)],1)],1)]),_vm._v(" "),_c('split-pane',{attrs:{"defaultSize":378,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar"},[(!_vm.isOnlySelUser)?_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.addGroup}},[_c('i',{staticClass:"fa fa-plus-square"}),_vm._v("新增")]):_vm._e(),_vm._v(" "),(!_vm.isOnlySelUser)?_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.deleteGroup}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v("删除")]):_vm._e(),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag==1),expression:"expandFlag==1"}],attrs:{"size":"mini"},on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v("展开")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag!=1),expression:"expandFlag!=1"}],attrs:{"size":"mini"},on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v("折叠")]),_vm._v(" "),(!_vm.isOnlySelUser)?_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.toGroupList}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v("列表显示")]):_vm._e(),_vm._v(" "),_c('el-dropdown',{attrs:{"trigger":"hover"},on:{"command":_vm.handleMoreCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n              更多"),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[(!_vm.isOnlySelUser)?_c('el-dropdown-item',{attrs:{"command":"import"}},[_vm._v("导入")]):_vm._e(),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"export"}},[_vm._v("导出")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"groupTree",attrs:{"url":_vm.groupTreeUrl,"autoLoad":false,"async":true,"contextMenuItem":_vm.isOnlySelUser?[]:_vm.contextMenuItem,"multipleLeaf":true,"dragEnable":true,"defaultParams":_vm.defaultTreeParams,"expandedFirst":true,"selectFirst":true},on:{"changed":_vm.changed}})],1)])]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true,"lock":true}}],attrs:{"size":"mini"},on:{"click":_vm.saveGroup}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v(" 保存")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","margin-top":"8px"},attrs:{"type":"info"},on:{"click":_vm.helpnotes}},[_c('i',{staticClass:"fa fa-question"}),_vm._v("帮助\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-form',{ref:"groupForm",staticClass:"mw-form",attrs:{"label-width":"130px","rules":_vm.rules,"model":_vm.group}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"单位名称","prop":"unitName"}},[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.group.unitName),callback:function ($$v) {_vm.$set(_vm.group, "unitName", $$v)},expression:"group.unitName"}}),_vm._v(" "),(!_vm.isOnlySelUser)?_c('el-button',{attrs:{"disabled":_vm.group.name === '默认角色'},on:{"click":_vm.showUnitDialog}},[_vm._v("选择")]):_vm._e()],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"unitId"}},[_c('el-input',{model:{value:(_vm.group.unitId),callback:function ($$v) {_vm.$set(_vm.group, "unitId", $$v)},expression:"group.unitId"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"code"}},[_c('el-input',{model:{value:(_vm.group.code),callback:function ($$v) {_vm.$set(_vm.group, "code", $$v)},expression:"group.code"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"角色名称","prop":"name"}},[_c('el-input',{attrs:{"readonly":(_vm.group.name === '默认角色' && _vm.group.id.length > 0) || _vm.isOnlySelUser},model:{value:(_vm.group.name),callback:function ($$v) {_vm.$set(_vm.group, "name", $$v)},expression:"group.name"}}),_vm._v(" "),(!_vm.isOnlySelUser)?_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"defultRoleBtn"},on:{"click":function($event){return _vm.changeDefultRole(1)}}},[_vm._v("默认角色")]):_vm._e(),_vm._v(" "),(!_vm.isOnlySelUser)?_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"generalRoleBtn"},on:{"click":function($event){return _vm.changeDefultRole(2)}}},[_vm._v("普通角色")]):_vm._e()],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"id"}},[_c('el-input',{model:{value:(_vm.group.id),callback:function ($$v) {_vm.$set(_vm.group, "id", $$v)},expression:"group.id"}})],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowCategory),expression:"isShowCategory"}],attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"角色分类","prop":"category"}},[_c('el-input',{model:{value:(_vm.group.category),callback:function ($$v) {_vm.$set(_vm.group, "category", $$v)},expression:"group.category"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"身份权限","prop":"postRoleNames"}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"readonly":""},model:{value:(_vm.group.postRoleNames),callback:function ($$v) {_vm.$set(_vm.group, "postRoleNames", $$v)},expression:"group.postRoleNames"}}),_vm._v(" "),(!_vm.isOnlySelUser)?_c('el-button',{on:{"click":_vm.showRoleDialog}},[_vm._v("选择")]):_vm._e()],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"postRoleIds"}},[_c('el-input',{model:{value:(_vm.group.postRoleIds),callback:function ($$v) {_vm.$set(_vm.group, "postRoleIds", $$v)},expression:"group.postRoleIds"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"文档权限","prop":"docRoleNames"}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"readonly":""},model:{value:(_vm.group.docRoleNames),callback:function ($$v) {_vm.$set(_vm.group, "docRoleNames", $$v)},expression:"group.docRoleNames"}}),_vm._v(" "),(!_vm.isOnlySelUser)?_c('el-button',{on:{"click":_vm.showRoleDialog}},[_vm._v("选择")]):_vm._e()],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"docRoleIds"}},[_c('el-input',{model:{value:(_vm.group.docRoleIds),callback:function ($$v) {_vm.$set(_vm.group, "docRoleIds", $$v)},expression:"group.docRoleIds"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"流程权限","prop":"flowRoleNames"}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"readonly":""},model:{value:(_vm.group.flowRoleNames),callback:function ($$v) {_vm.$set(_vm.group, "flowRoleNames", $$v)},expression:"group.flowRoleNames"}}),_vm._v(" "),(!_vm.isOnlySelUser)?_c('el-button',{on:{"click":_vm.showRoleDialog}},[_vm._v("选择")]):_vm._e()],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"flowRoleIds"}},[_c('el-input',{model:{value:(_vm.group.flowRoleIds),callback:function ($$v) {_vm.$set(_vm.group, "flowRoleIds", $$v)},expression:"group.flowRoleIds"}})],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.group.name != '默认角色'),expression:"group.name != '默认角色'"}],attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"用户人员","prop":"userNames"}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"readonly":""},model:{value:(_vm.group.userNames),callback:function ($$v) {_vm.$set(_vm.group, "userNames", $$v)},expression:"group.userNames"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.userChoose}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"userDeptIdentityIds"}},[_c('el-input',{model:{value:(_vm.group.userDeptIdentityIds),callback:function ($$v) {_vm.$set(_vm.group, "userDeptIdentityIds", $$v)},expression:"group.userDeptIdentityIds"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"departmentIds"}},[_c('el-input',{model:{value:(_vm.group.departmentIds),callback:function ($$v) {_vm.$set(_vm.group, "departmentIds", $$v)},expression:"group.departmentIds"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"角色描述","prop":"dec"}},[_c('el-input',{model:{value:(_vm.group.dec),callback:function ($$v) {_vm.$set(_vm.group, "dec", $$v)},expression:"group.dec"}})],1)],1)],1)],1)])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.compId,{tag:"component"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"userDialog",attrs:{"size":"large_large","footerButton":_vm.btns,"close-on-click-modal":false}},[_c('el-row',{staticClass:"loadUsers"},[_c('el-col',{attrs:{"span":10}},[_c('div',{staticClass:"dialog-content"},[[_c('el-tabs',{attrs:{"type":"card"},on:{"tab-click":_vm.handleTabs},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[(_vm.showQJT)?_c('el-tab-pane',{attrs:{"label":"全集团","name":"first"}},[_c('div',{style:({height: _vm.dialogHeight + 'px','overflow-y':'scroll' })},[_c('mw-tree',{ref:"deptTreeData",attrs:{"url":_vm.companyTreeUrl,"async":true,"multiple":true,"expandedFirst":true},on:{"changed":_vm.loadTableTree}})],1)]):_vm._e(),_vm._v(" "),(_vm.showBDW)?_c('el-tab-pane',{attrs:{"label":"本单位","name":"second"}},[_c('div',{style:({height: _vm.dialogHeight + 'px','overflow-y':'scroll' })},[_c('mw-tree',{ref:"deptTreeData2",attrs:{"url":_vm.deptTreeUrl,"async":true,"multiple":true,"defaultParams":_vm.defaultParams,"aliasId":"departmentId","expandedFirst":true},on:{"changed":_vm.loadTableTree2}})],1)]):_vm._e()],1)]],2),_vm._v(" "),_c('div',{staticClass:"mw-toolbar"},[_vm._v("成员列表")]),_vm._v(" "),_c('div',[_c('el-col',{attrs:{"span":8}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.selectAll}},[_vm._v("全选")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.unSelect}},[_vm._v("全不选")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12,"offset":4}},[_c('el-input',{attrs:{"placeholder":"用户名"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.searchUser($event)}},model:{value:(_vm.searchField),callback:function ($$v) {_vm.searchField=$$v},expression:"searchField"}},[_c('el-button',{directives:[{name:"waves",rawName:"v-waves"}],attrs:{"slot":"append","type":"primary"},on:{"click":_vm.searchUser},slot:"append"},[_vm._v("查询")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar_body",style:({'margin-top':'50px', height: _vm.dialogHeight + 'px' })},[_c('el-table',{ref:"multiple1",staticClass:"mw-table a2",staticStyle:{"cursor":"pointer","padding-left":"80px"},attrs:{"data":_vm.users,"show-header":false},on:{"row-dblclick":_vm.dbAddUser,"row-click":_vm.rowClick,"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"30"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"名称","align":"left","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.name)+"\n              ")]}}])})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('el-button',{staticStyle:{"display":"block","margin":"180px 60px 50px 60px"},on:{"click":_vm.move}},[_vm._v("选择")]),_vm._v(" "),_c('el-button',{staticStyle:{"display":"block","margin":"30px 60px"},on:{"click":_vm.reset}},[_vm._v("清空")])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('div',{staticClass:"mw-toolbar"},[_vm._v("已选择机构(双击移除)")]),_vm._v(" "),_c('div',{style:({height: _vm.dialogHeight + 'px'})},[_c('el-table',{ref:"multipleTable",staticClass:"mw-table",staticStyle:{"cursor":"pointer","height":"200px"},attrs:{"border":"","data":_vm.dept,"show-header":false,"tooltip-effect":"dark"},on:{"row-dblclick":_vm.dbHandleDept}},[_c('el-table-column',{attrs:{"type":"index","label":"序号","width":"50","index":_vm.indexMethod}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"名称"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.name)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"button","size":"small"},on:{"click":function($event){return _vm.dbHandleDept(scope.row,scope.$index)}}},[_c('i',{staticClass:"fa fa-trash-o fa-fw"})])]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar"},[_vm._v("已选择用户(双击移除)")]),_vm._v(" "),_c('div',{style:({height: (_vm.dialogHeight+50) + 'px' })},[_c('el-table',{ref:"multipleTable",staticClass:"mw-table",staticStyle:{"cursor":"pointer"},attrs:{"border":"","data":_vm.deptUsers,"show-header":false,"tooltip-effect":"dark"},on:{"row-dblclick":_vm.dbHandleUser}},[_c('el-table-column',{attrs:{"type":"index","label":"序号","width":"50","index":_vm.indexMethod}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"名称"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.name)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"button","size":"small"},on:{"click":function($event){return _vm.dbHandleUser(scope.row,scope.$index)}}},[_c('i',{staticClass:"fa fa-trash-o fa-fw"})])]}}])})],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container"},[_c('mw-dialog',{ref:"dialog",attrs:{"size":"mini_mini","footerButton":_vm.btns,"close-on-click-modal":false,"title":_vm.$lang('选择群组分类')}},[_c('div',{staticStyle:{"margin-top":"20px"}},[_c('el-radio-group',{model:{value:(_vm.check),callback:function ($$v) {_vm.check=$$v},expression:"check"}},_vm._l((_vm.list),function(i){return _c('el-radio',{key:i.id,staticStyle:{"display":"block","margin-left":"50px","height":"30px","line-height":"30px","font-size":"16px","font-weight":"normal"},attrs:{"label":i.name}},[_vm._v(_vm._s(i.name))])}),1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"titleDialog",attrs:{"title":_vm.form.id ? _vm.$lang('编辑群组') : _vm.$lang('新建群组'),"close-on-click-modal":false}},[(_vm.toolbarPosition!='BOTTOM')?_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.closeTitleDialog}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(" "+_vm._s(_vm.$lang('关闭')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveTitle}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v("\n        "+_vm._s(_vm.$lang('保存')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-dialog',{ref:"unitDialog",attrs:{"size":"mini_small","title":_vm.$lang('选择群组分类'),"footerButton":_vm.unitFooterButton,"close-on-click-modal":false}},[_c('mw-tree',{ref:"unitTree",attrs:{"url":_vm.unitTreeUrl,"defaultParams":_vm.defaultParams,"async":true,"expandedFirst":true,"selectFirst":true}})],1),_vm._v(" "),[_c('el-row',[_c('el-form',{ref:"ruleForm",attrs:{"label-width":"120px","model":_vm.form,"rules":_vm.formRules}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('所属单位'),"prop":"unitName"}},[_c('el-input',{staticStyle:{"width":"80%"},attrs:{"readonly":""},model:{value:(_vm.form.unitName),callback:function ($$v) {_vm.$set(_vm.form, "unitName", $$v)},expression:"form.unitName"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.showUnitDialog}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"label":_vm.$lang('所属单位')}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.unitId),callback:function ($$v) {_vm.$set(_vm.form, "unitId", $$v)},expression:"form.unitId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('群组分类'),"prop":"code"}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.mwRef('dialog').show()}}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('群组名称'),"prop":"name"}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('群组序列')}},[_c('el-input-number',{staticStyle:{"width":"80%"},attrs:{"controls":false,"min":1},model:{value:(_vm.form.sn),callback:function ($$v) {_vm.$set(_vm.form, "sn", $$v)},expression:"form.sn"}})],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":24}},[_c('el-form-item',[_c('el-input',{attrs:{"type":"textarea","placeholder":_vm.$lang('请输入内容')},model:{value:(_vm.form.departmentids),callback:function ($$v) {_vm.$set(_vm.form, "departmentids", $$v)},expression:"form.departmentids"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('群组成员')}},[_c('div',{staticStyle:{"margin-bottom":"5px"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":_vm.$lang('请输入内容'),"readonly":""},model:{value:(_vm.form.departments),callback:function ($$v) {_vm.$set(_vm.form, "departments", $$v)},expression:"form.departments"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.usersLoad}},[_vm._v("选择")]),_vm._v(" "),_c('loadUsers',{ref:"loadUsers",attrs:{"checkNodes":_vm.checkNodes,"showBDW":_vm.showBDW,"showQJT":_vm.showQJT,"unitId":_vm.form.unitId},on:{"closeDialog":_vm.getDeptUser}})],1),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","placeholder":_vm.$lang('请输入内容'),"readonly":""},model:{value:(_vm.form.users),callback:function ($$v) {_vm.$set(_vm.form, "users", $$v)},expression:"form.users"}})],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-form-item',[_c('el-input',{attrs:{"type":"textarea","placeholder":_vm.$lang('请输入内容')},model:{value:(_vm.form.userids),callback:function ($$v) {_vm.$set(_vm.form, "userids", $$v)},expression:"form.userids"}})],1)],1),_vm._v(" "),(_vm.showGroupOutOrg)?_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('外部单位')}},[_c('el-input',{attrs:{"type":"textarea","placeholder":_vm.$lang('请输入内容')},model:{value:(_vm.form.externalUnit),callback:function ($$v) {_vm.$set(_vm.form, "externalUnit", $$v)},expression:"form.externalUnit"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.showOuterDept}},[_vm._v(_vm._s(_vm.$lang("选择")))])],1)],1):_vm._e()],1)],1)]],2),_vm._v(" "),(_vm.toolbarPosition=='BOTTOM')?_c('div',{staticClass:"mw-toolbar",staticStyle:{"text-align":"right"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveTitle}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v("\n        "+_vm._s(_vm.$lang('保存')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.closeTitleDialog}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(" "+_vm._s(_vm.$lang('关闭')))])],1):_vm._e()]),_vm._v(" "),_c('mw-dialog',{ref:"externalDept",attrs:{"title":_vm.$lang('外部单位'),"footerButton":_vm.externalBtn,"close-on-click-modal":false}},[_c('div',{staticClass:"mw-toolbar__body"},[_c('p',{staticStyle:{"margin-top":"5px"}},[_vm._v(_vm._s(_vm.$lang("外部单位(多个以回车换行)")))]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 10, maxRows: 20},"width":"80%"},model:{value:(_vm.outerDept),callback:function ($$v) {_vm.outerDept=$$v},expression:"outerDept"}})],1)]),_vm._v(" "),_c('mw-dialog',{ref:"impDialog",attrs:{"title":_vm.$lang('导入群组数据'),"size":"mini_small","footerButton":_vm.impBtton},on:{"opened":_vm.showUpload}},[_c('div',{staticClass:"mw-dialog_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('导入说明')}},[[_vm._v("\n              第一步：单击此处"),_c('el-button',{on:{"click":_vm.downloadExcel}},[_vm._v("下载模版")]),_c('br'),_vm._v("\n              第二步：按照模板格式录入数据;"),_c('br'),_vm._v("\n              第三步：上传模板文件:\n            ")]],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传文件:"}},[_c('el-button',{ref:"uploader"},[_vm._v("上传文件")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip"},[_vm._v("只能上传.xls文件")])],1)],1)],1)],1)]),_vm._v(" "),_c('split-pane',{attrs:{"defaultSize":358,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('mw-dialog',{ref:"unitDialog1",attrs:{"size":"mini_small","title":"选择群组分类","footerButton":_vm.unitFooterButton1,"close-on-click-modal":false}},[_c('mw-tree',{ref:"unitTree1",attrs:{"url":_vm.unitTreeUrl,"defaultParams":_vm.defaultParams,"async":false,"threeState":true,"expandedFirst":true,"selectFirst":true,"multiple":true}})],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag==1),expression:"expandFlag==1"}],attrs:{"size":"mini"},on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v(_vm._s(_vm.$lang('展开')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag!=1),expression:"expandFlag!=1"}],attrs:{"size":"mini"},on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v(_vm._s(_vm.$lang('折叠')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCurOrg),expression:"showCurOrg"}],attrs:{"size":"mini"},on:{"click":function($event){return _vm.changeOrg(1)}}},[_c('i',{staticClass:"fa fa-user-circle-o"}),_vm._v(_vm._s(_vm.$lang('本单位')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAllOrg),expression:"showAllOrg"}],attrs:{"size":"mini"},on:{"click":function($event){return _vm.changeOrg(2)}}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(_vm._s(_vm.$lang('全集团')))]),_vm._v(" "),_c('el-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.userInfo.unitAdmin ||!_vm.isLimit),expression:"userInfo.unitAdmin ||!isLimit"}],attrs:{"trigger":"hover"},on:{"command":_vm.handleMoreCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n               "+_vm._s(_vm.$lang('更多'))),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"import"}},[_vm._v(_vm._s(_vm.$lang('导入')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"export"}},[_vm._v(_vm._s(_vm.$lang('导出')))])],1)],1)],1),_vm._v(" "),_c('div',[_c('mw-tree',{ref:"groupTree",attrs:{"url":_vm.groupTreeUrl,"autoLoad":false,"async":true,"multipleLeaf":true,"dragEnable":true,"defaultParams":_vm.defaultTreeParams,"expandedFirst":true,"selectFirst":true},on:{"changed":_vm.changed}})],1)],1)]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"aa",attrs:{"layout":_vm.layout,"pagination":false}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.userInfo.unitAdmin ||!_vm.isLimit),expression:"userInfo.unitAdmin ||!isLimit"}],attrs:{"slot":"dropDown"},slot:"dropDown"},[_c('el-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.userInfo.unitAdmin ||!_vm.isLimit),expression:"userInfo.unitAdmin ||!isLimit"}],attrs:{"trigger":"hover"},on:{"command":_vm.handleSortCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n                 "+_vm._s(_vm.$lang('排序'))),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"sort"}},[_vm._v(_vm._s(_vm.$lang('排序')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"top"}},[_vm._v(_vm._s(_vm.$lang('置顶')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"bottom"}},[_vm._v(_vm._s(_vm.$lang('置底')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"up"}},[_vm._v(_vm._s(_vm.$lang('上移')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"down"}},[_vm._v(_vm._s(_vm.$lang('下移'))+" ")])],1)],1)],1)])],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel commonOuterOrg"},[_c('mw-dialog',{ref:"titleDialog",attrs:{"title":_vm.form.id ? _vm.$lang('编辑外单位') : _vm.$lang('新建公共外单位'),"close-on-click-modal":false}},[(_vm.toolbarPosition!='BOTTOM')?_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.closeTitleDialog}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(_vm._s(_vm.$lang('关闭')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveTitle}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v("\n        "+_vm._s(_vm.$lang('保存')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[[_c('el-row',[_c('el-form',{ref:"ruleForm",attrs:{"label-width":"130px","model":_vm.form,"rules":_vm.formRules}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOrg),expression:"showOrg"}],attrs:{"label":_vm.$lang('所属单位'),"prop":"unitName"}},[_c('el-input',{staticStyle:{"width":"80%"},attrs:{"readonly":""},model:{value:(_vm.form.unitName),callback:function ($$v) {_vm.$set(_vm.form, "unitName", $$v)},expression:"form.unitName"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.showUnitDialog}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"label":_vm.$lang('所属单位ID')}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.unitId),callback:function ($$v) {_vm.$set(_vm.form, "unitId", $$v)},expression:"form.unitId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('外单位分类'),"prop":"code"}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('外单位名称'),"prop":"name"}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('外单位英文名称'),"prop":"name"}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.Englishname),callback:function ($$v) {_vm.$set(_vm.form, "Englishname", $$v)},expression:"form.Englishname"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('外单位序列')}},[_c('el-input-number',{staticStyle:{"width":"80%"},attrs:{"controls":false,"min":1},model:{value:(_vm.form.sn),callback:function ($$v) {_vm.$set(_vm.form, "sn", $$v)},expression:"form.sn"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('外单位编号'),"prop":"identifier"}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.identifier),callback:function ($$v) {_vm.$set(_vm.form, "identifier", $$v)},expression:"form.identifier"}})],1)],1)],1)],1)]],2),_vm._v(" "),(_vm.toolbarPosition=='BOTTOM')?_c('div',{staticClass:"mw-toolbar",staticStyle:{"text-align":"right"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveTitle}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v(_vm._s(_vm.$lang('保存')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.closeTitleDialog}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(_vm._s(_vm.$lang('关闭')))])],1):_vm._e()]),_vm._v(" "),_c('split-pane',{attrs:{"defaultSize":238,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('mw-dialog',{ref:"unitDialog",attrs:{"size":"mini_small","title":"选择外单位分类","footerButton":_vm.unitFooterButton,"close-on-click-modal":false}},[_c('mw-tree',{ref:"unitTree",attrs:{"url":_vm.unitTreeUrl,"defaultParams":_vm.defaultUnitTreParams,"async":false,"threeState":true,"expandedFirst":true,"selectFirst":true,"multiple":false}})],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag==1),expression:"expandFlag==1"}],attrs:{"size":"mini"},on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v(_vm._s(_vm.$lang('展开')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag!=1),expression:"expandFlag!=1"}],attrs:{"size":"mini"},on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v(_vm._s(_vm.$lang('折叠')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCurOrg),expression:"showCurOrg"}],attrs:{"size":"mini"},on:{"click":function($event){return _vm.changeOrg(1)}}},[_c('i',{staticClass:"fa fa-user-circle-o"}),_vm._v(_vm._s(_vm.$lang('本单位')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAllOrg),expression:"showAllOrg"}],attrs:{"size":"mini"},on:{"click":function($event){return _vm.changeOrg(2)}}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(_vm._s(_vm.$lang('全集团')))])],1),_vm._v(" "),_c('div',[_c('mw-tree',{ref:"groupTree",attrs:{"url":_vm.outerOrgTreeUrl,"autoLoad":false,"async":true,"multipleLeaf":true,"dragEnable":true,"defaultParams":_vm.defaultTreeParams,"expandedFirst":true,"selectFirst":true},on:{"changed":_vm.changed}})],1)],1)]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"aa",attrs:{"layout":_vm.layout,"pagination":false}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.userInfo.unitAdmin ||!_vm.isLimit),expression:"userInfo.unitAdmin ||!isLimit"}],attrs:{"slot":"dropDown"},slot:"dropDown"},[_c('el-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.userInfo.unitAdmin ||!_vm.isLimit),expression:"userInfo.unitAdmin ||!isLimit"}],attrs:{"trigger":"hover"},on:{"command":_vm.handleSortCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n                "+_vm._s(_vm.$lang('排序'))),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",staticStyle:{"width":"100px"},attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"sort"}},[_vm._v(_vm._s(_vm.$lang('排序')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"top"}},[_vm._v(_vm._s(_vm.$lang('置顶')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"bottom"}},[_vm._v(_vm._s(_vm.$lang('置底')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"up"}},[_vm._v(_vm._s(_vm.$lang('上移')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"down"}},[_vm._v(_vm._s(_vm.$lang('下移')))])],1)],1)],1)])],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataValues_vue__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataValues_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataValues_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataValues_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataValues_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_836708b8_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_dataValues_vue__ = __webpack_require__(1219);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataValues_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_836708b8_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_dataValues_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.newCatalog}},[_c('i',{staticClass:"fa fa-plus-square"}),_vm._v(" 新建分类")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"codeTree",attrs:{"multiple":false,"types":_vm.types,"expandedFirst":true,"treeData":_vm.treeData,"autoLoad":false,"contextMenuItem":_vm.menuItem},on:{"changed":_vm.changed}})],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-col',{attrs:{"span":6}},[_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.addValues}},[_c('i',{staticClass:" fa fa-plus-square"}),_vm._v(" 添加")])],1)],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body,setting"},[_c('el-table',{attrs:{"data":_vm.settingValues,"empty-text":""}},[_c('el-table-column',{attrs:{"label":"名称","prop":"name"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{on:{"click":function($event){return _vm.editSetValue(scope.row,scope.$index)}}},[_vm._v(_vm._s(scope.row.name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"编号","prop":"id","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"danger","icon":"el-icon-delete","circle":""},on:{"click":function($event){return _vm.handleDelete(scope.row,scope.$index)}}})]}}])})],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"valueKeyDialog",attrs:{"footerButton":_vm.valueBtns,"size":"mini_mini"}},[_c('div',{staticClass:"mw-toolbar_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"60px"}},[_c('el-form-item',{attrs:{"prop":"name","label":"名称"}},[_c('el-input',{model:{value:(_vm.keyValues.name),callback:function ($$v) {_vm.$set(_vm.keyValues, "name", $$v)},expression:"keyValues.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"id","label":"编号"}},[_c('el-input',{model:{value:(_vm.keyValues.id),callback:function ($$v) {_vm.$set(_vm.keyValues, "id", $$v)},expression:"keyValues.id"}})],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container mw-bar-data"},[_c('split-pane',{attrs:{"defaultPercent":30,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('mw-dialog',{ref:"titleTree",attrs:{"title":_vm.addCode ? '新建' : '编辑',"size":"large_large","before-close":_vm.handleClose,"close-on-click-modal":false}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleClose}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v("  关闭")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveDict}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v("  保存")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-form',{ref:"dataForm",staticStyle:{"margin-top":"20px"},attrs:{"model":_vm.form,"label-width":"130px","rules":_vm.formRules}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"类别","prop":"catalog"}},[_c('el-input',{model:{value:(_vm.form.catalog),callback:function ($$v) {_vm.$set(_vm.form, "catalog", $$v)},expression:"form.catalog"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"名称","prop":"name"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"编码","prop":"code"}},[_c('el-input',{model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"是否有效","prop":"active"}},[_c('el-radio-group',{model:{value:(_vm.form.active),callback:function ($$v) {_vm.$set(_vm.form, "active", $$v)},expression:"form.active"}},[_c('el-radio',{attrs:{"label":"T"}},[_vm._v("是")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"F"}},[_vm._v("否")])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"是否私有","prop":"personal"}},[_c('el-radio-group',{model:{value:(_vm.form.personal),callback:function ($$v) {_vm.$set(_vm.form, "personal", $$v)},expression:"form.personal"}},[_c('el-radio',{attrs:{"label":"T"}},[_vm._v("是")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"F"}},[_vm._v("否")])],1)],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.personal === 'T'),expression:"form.personal === 'T'"}],attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"所属单位"}},[_c('el-input',{staticStyle:{"width":"65%"},model:{value:(_vm.form.unitName),callback:function ($$v) {_vm.$set(_vm.form, "unitName", $$v)},expression:"form.unitName"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.showDialog('unitTree')}}},[_vm._v("选择")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.clearDept}},[_vm._v("清空")])],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"所属单位"}},[_c('el-input',{model:{value:(_vm.form.unitId),callback:function ($$v) {_vm.$set(_vm.form, "unitId", $$v)},expression:"form.unitId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"选项值类型","prop":"types"}},[_c('el-radio-group',{on:{"change":_vm.handleRadio},model:{value:(_vm.form.types),callback:function ($$v) {_vm.$set(_vm.form, "types", $$v)},expression:"form.types"}},[_c('el-radio',{attrs:{"label":"0"}},[_vm._v("值")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"1"}},[_vm._v("设置选项值")])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"选项值","prop":"value"}},[(_vm.form.types === '1')?[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.addSetting}},[_vm._v("设置选项值")])]:[_c('el-input',{model:{value:(_vm.form.value),callback:function ($$v) {_vm.$set(_vm.form, "value", $$v)},expression:"form.value"}})]],2)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":12,"prop":"values"}},[_c('el-form-item',{attrs:{"label":"选项值"}},[_c('el-input',{model:{value:(_vm.form.values),callback:function ($$v) {_vm.$set(_vm.form, "values", $$v)},expression:"form.values"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"是否开放前台编辑"}},[_c('el-radio-group',{model:{value:(_vm.form.typeedit),callback:function ($$v) {_vm.$set(_vm.form, "typeedit", $$v)},expression:"form.typeedit"}},[_c('el-radio',{attrs:{"label":1}},[_vm._v("开放")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2}},[_vm._v("不开放")])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"备注","prop":"remark"}},[_c('el-input',{model:{value:(_vm.form.remark),callback:function ($$v) {_vm.$set(_vm.form, "remark", $$v)},expression:"form.remark"}})],1)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"setValuesDialog",attrs:{"footerButton":_vm.setButton,"size":"small_large","title":"设置选项值"}},[_c('dValues',{ref:"valueChoose",attrs:{"dataId":_vm.form.id}})],1),_vm._v(" "),_c('first',{ref:"unitTree",on:{"confirm":_vm.deptChoose}}),_vm._v(" "),_c('mw-dialog',{ref:"editListDialog",attrs:{"title":"选择修改分类","size":"mini_mini","footerButton":_vm.editListButton}},[_c('el-form',{staticStyle:{"margin-top":"20px"}},[_c('el-form-item',{attrs:{"label":"分类"}},[_c('el-input',{model:{value:(_vm.catalog),callback:function ($$v) {_vm.catalog=$$v},expression:"catalog"}})],1)],1)],1),_vm._v(" "),_c('mw-dialog',{ref:"leadDialog",attrs:{"title":"数据导入","size":"mini_mini","footerButton":_vm.leadButton}},[_c('div',{staticClass:"mw-dialog_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"数据文件:"}},[[_c('el-upload',{ref:"importDict",staticStyle:{"display":"inline-block"},attrs:{"on-success":_vm.importSuccessFunc,"auto-upload":false,"action":_vm.action,"multiple":"","headers":_vm.headers,"limit":1}},[_c('el-button',[_vm._v("选择")])],1)]],2)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v("展开")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v("折叠")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.exportAll}},[_c('i',{staticClass:"fa fa-external-link"}),_vm._v("全部导出")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"dictTree",attrs:{"url":_vm.dictTreeUrl,"async":false,"multiple":false,"selectFirst":true,"expandedFirst":true,"dragEnable":true,"defaultParams":_vm.treeDefaultParams},on:{"changed":_vm.loadTableTree}})],1)],1)]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"dataTable",attrs:{"layout":_vm.layout,"autoLoad":false}},[_c('span',{attrs:{"slot":"more"},slot:"more"},[_c('el-dropdown',{attrs:{"trigger":"hover"},on:{"command":_vm.handleCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n            更多 "),_c('i',{staticClass:"fa fa-angle-double-right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"leadOut"}},[_vm._v("导出")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"lead"}},[_vm._v("导入")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"leadOldData"}},[_vm._v("导入旧数据")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"loadModules"}},[_vm._v("加入模块")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"loadUpdateData"}},[_vm._v("加入更新包")])],1)],1)],1)])],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataDicEdit_vue__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataDicEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataDicEdit_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataDicEdit_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataDicEdit_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_57cfff38_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_dataDicEdit_vue__ = __webpack_require__(1225);
function injectStyle (ssrContext) {
  __webpack_require__(1222)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57cfff38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_dataDicEdit_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_57cfff38_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_dataDicEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"zgDeptDialog",attrs:{"title":"选择部门机构","size":"mini_mini","footerButton":_vm.btns,"close-on-click-modal":false}},[_c('mw-tree',{ref:"deptTree",staticClass:"mw-dialog-body",attrs:{"url":_vm.deptTreeUrl,"multipleLeaf":false,"async":false,"expandedFirst":true,"multiple":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.newCatalog}},[_c('i',{staticClass:"fa fa-plus-square"}),_vm._v(" 新建分类")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"codeTree",attrs:{"multiple":false,"types":_vm.types,"expandedFirst":true,"treeData":_vm.treeData,"autoLoad":false,"contextMenuItem":_vm.menuItem},on:{"changed":_vm.changed}})],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-col',{attrs:{"span":6}},[_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.addValues}},[_c('i',{staticClass:" fa fa-plus-square"}),_vm._v(" 添加")])],1)],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body,setting"},[_c('el-table',{attrs:{"data":_vm.settingValues,"empty-text":""}},[_c('el-table-column',{attrs:{"label":"名称","prop":"name"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{on:{"click":function($event){return _vm.editSetValue(scope.row,scope.$index)}}},[_vm._v(_vm._s(scope.row.name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"编号","width":"155"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-popover',{attrs:{"trigger":"hover","placement":"top"}},[_c('p',[_vm._v(_vm._s(scope.row.id))]),_vm._v(" "),_c('div',{staticClass:"name-wrapper",attrs:{"slot":"reference"},slot:"reference"},[_c('span',[_vm._v(_vm._s(scope.row.id))])])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"danger","icon":"el-icon-delete","circle":""},on:{"click":function($event){return _vm.handleDelete(scope.row,scope.$index)}}})]}}])})],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"valueKeyDialog",attrs:{"footerButton":_vm.valueBtns,"size":"mini_mini"}},[_c('div',{staticClass:"mw-toolbar_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"60px"}},[_c('el-form-item',{attrs:{"prop":"name","label":"名称"}},[_c('el-input',{model:{value:(_vm.keyValues.name),callback:function ($$v) {_vm.$set(_vm.keyValues, "name", $$v)},expression:"keyValues.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"id","label":"编号"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 6, maxRows: 8},"placeholder":"请输入内容"},model:{value:(_vm.keyValues.id),callback:function ($$v) {_vm.$set(_vm.keyValues, "id", $$v)},expression:"keyValues.id"}})],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('mw-dialog',{ref:"setValuesDialog",attrs:{"footerButton":_vm.setButton,"size":"small_large","title":"设置选项值"}},[_c('dValues',{ref:"valueChoose",attrs:{"dataId":_vm.form.id}})],1),_vm._v(" "),_c('first',{ref:"unitTree",on:{"confirm":_vm.deptChoose}}),_vm._v(" "),_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleClose}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v("  关闭")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveDict}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v("  保存")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","margin-top":"8px"},attrs:{"type":"info"},on:{"click":_vm.showHelp}},[_c('i',{staticClass:"fa fa-question"}),_vm._v("帮助")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-form',{ref:"dataForm",staticStyle:{"margin-top":"20px"},attrs:{"model":_vm.form,"label-position":_vm.labelPosition,"label-width":"100px","rules":_vm.formRules}},[_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"类别","prop":"catalog"}},[_c('el-input',{model:{value:(_vm.form.catalog),callback:function ($$v) {_vm.$set(_vm.form, "catalog", $$v)},expression:"form.catalog"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"数据名称","prop":"name"}},[_c('el-input',{attrs:{"disabled":!_vm.isEditName},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"编码","prop":"code"}},[_c('el-input',{model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"是否有效","prop":"active"}},[_c('el-radio-group',{model:{value:(_vm.form.active),callback:function ($$v) {_vm.$set(_vm.form, "active", $$v)},expression:"form.active"}},[_c('el-radio',{attrs:{"label":"T"}},[_vm._v("是")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"F"}},[_vm._v("否")])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"是否私有","prop":"personal"}},[_c('el-radio-group',{model:{value:(_vm.form.personal),callback:function ($$v) {_vm.$set(_vm.form, "personal", $$v)},expression:"form.personal"}},[_c('el-radio',{attrs:{"label":"T"}},[_vm._v("是")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"F"}},[_vm._v("否")])],1)],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.personal === 'T'),expression:"form.personal === 'T'"}],attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"所属单位"}},[_c('el-input',{staticStyle:{"width":"85%"},attrs:{"type":"textarea","rows":2},model:{value:(_vm.form.unitName),callback:function ($$v) {_vm.$set(_vm.form, "unitName", $$v)},expression:"form.unitName"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.showDialog('unitTree')}}},[_vm._v("选择")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.clearDept}},[_vm._v("清空")])],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"所属单位"}},[_c('el-input',{model:{value:(_vm.form.unitId),callback:function ($$v) {_vm.$set(_vm.form, "unitId", $$v)},expression:"form.unitId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"选项类型","prop":"types"}},[_c('el-radio-group',{on:{"change":_vm.handleRadio},model:{value:(_vm.form.types),callback:function ($$v) {_vm.$set(_vm.form, "types", $$v)},expression:"form.types"}},[_c('el-radio',{attrs:{"label":"0"}},[_vm._v("值")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"1"}},[_vm._v("设置选项值")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v("文件")])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"选 项 值 ","prop":"value"}},[(_vm.form.types === '1')?[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.addSetting}},[_vm._v("设置选项值")])]:(_vm.form.types === '0')?[_c('el-input',{model:{value:(_vm.form.value),callback:function ($$v) {_vm.$set(_vm.form, "value", $$v)},expression:"form.value"}})]:(_vm.form.types === '2')?[_c('file-input',{attrs:{"dict-id":_vm.form.id},model:{value:(_vm.form.value),callback:function ($$v) {_vm.$set(_vm.form, "value", $$v)},expression:"form.value"}})]:_vm._e()],2)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":12,"prop":"values"}},[_c('el-form-item',{attrs:{"label":"选项值"}},[_c('el-input',{model:{value:(_vm.form.values),callback:function ($$v) {_vm.$set(_vm.form, "values", $$v)},expression:"form.values"}})],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"是否开放前台编辑"}},[_c('el-radio-group',{model:{value:(_vm.form.typeedit),callback:function ($$v) {_vm.$set(_vm.form, "typeedit", $$v)},expression:"form.typeedit"}},[_c('el-radio',{attrs:{"label":1}},[_vm._v("开放")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2}},[_vm._v("不开放")])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"数据备注","prop":"remark"}},[_c('el-input',{attrs:{"type":"textarea","rows":4},model:{value:(_vm.form.remark),callback:function ($$v) {_vm.$set(_vm.form, "remark", $$v)},expression:"form.remark"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container"},[_c('unitDialog',{ref:"unitDialog",attrs:{"selectUnitId":_vm.group.unitId},on:{"confirm":_vm.confirmUnit}}),_vm._v(" "),_c('mw-dialog',{ref:"userDialog",attrs:{"size":"large_large","title":"选择用户","footerButton":_vm.userFooterButton,"close-on-click-modal":false}},[_c('loadMan',{ref:"userChoose",attrs:{"isRadio":true,"defaultParentId":_vm.defaultParentId,"listAble":_vm.listAble,"RAdminData":_vm.oneChooseUsers}})],1),_vm._v(" "),_c('mw-dialog',{ref:"userDialog2",attrs:{"size":"large_large","title":"选择用户","footerButton":_vm.userFooterButton2,"close-on-click-modal":false}},[_c('loadMan',{ref:"userChoose2",attrs:{"RAdminData":_vm.chooseUsers,"defaultParentId":_vm.defaultParentId,"listAble":_vm.listAble}})],1),_vm._v(" "),_c('split-pane',{attrs:{"defaultSize":378,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.addGroup}},[_c('i',{staticClass:"fa fa-plus-square"}),_vm._v("新增")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.deleteGroup}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v("删除")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag==1),expression:"expandFlag==1"}],attrs:{"size":"mini"},on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v("展开")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag!=1),expression:"expandFlag!=1"}],attrs:{"size":"mini"},on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v("折叠")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"groupTree",attrs:{"url":_vm.groupTreeUrl,"autoLoad":false,"async":true,"contextMenuItem":_vm.contextMenuItem,"multipleLeaf":true,"dragEnable":true,"defaultParams":_vm.defaultTreeParams,"expandedFirst":true,"selectFirst":true},on:{"changed":_vm.changed}})],1)])]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true,"lock":true}}],attrs:{"size":"mini"},on:{"click":_vm.saveGroup}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v(" 保存")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-form',{ref:"groupForm",staticClass:"mw-form",attrs:{"label-width":"130px","rules":_vm.rules,"model":_vm.group}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"单位名称","prop":"unitName"}},[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.group.unitName),callback:function ($$v) {_vm.$set(_vm.group, "unitName", $$v)},expression:"group.unitName"}}),_vm._v(" "),(_vm.isEdit)?_c('el-button',{on:{"click":_vm.showUnitDialog}},[_vm._v("选择")]):_vm._e()],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"unitId"}},[_c('el-input',{model:{value:(_vm.group.unitId),callback:function ($$v) {_vm.$set(_vm.group, "unitId", $$v)},expression:"group.unitId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"授权用户","prop":"name"}},[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.group.name),callback:function ($$v) {_vm.$set(_vm.group, "name", $$v)},expression:"group.name"}}),_vm._v(" "),(!_vm.group.id)?_c('el-button',{on:{"click":_vm.userChoose}},[_vm._v("选择")]):_vm._e()],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"id"}},[_c('el-input',{model:{value:(_vm.group.id),callback:function ($$v) {_vm.$set(_vm.group, "id", $$v)},expression:"group.id"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"userId"}},[_c('el-input',{model:{value:(_vm.group.userId),callback:function ($$v) {_vm.$set(_vm.group, "userId", $$v)},expression:"group.userId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"权限类型","prop":"code"}},[_c('el-select',{attrs:{"placeholder":"请选择","disabled":!_vm.isEdit},model:{value:(_vm.group.code),callback:function ($$v) {_vm.$set(_vm.group, "code", $$v)},expression:"group.code"}},_vm._l((_vm.authTypes),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"代理用户","prop":"agents"}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"readonly":""},model:{value:(_vm.group.agents),callback:function ($$v) {_vm.$set(_vm.group, "agents", $$v)},expression:"group.agents"}}),_vm._v(" "),(_vm.isEdit)?_c('el-button',{on:{"click":_vm.userChoose2}},[_vm._v("选择")]):_vm._e()],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"agentIds"}},[_c('el-input',{model:{value:(_vm.group.agentIds),callback:function ($$v) {_vm.$set(_vm.group, "agentIds", $$v)},expression:"group.agentIds"}})],1)],1),_vm._v(" "),(_vm.isFullAuthSendMsgSelection)?_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"消息提醒代理用户","prop":"msgRemindAgents"}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"readonly":""},model:{value:(_vm.group.msgRemindAgents),callback:function ($$v) {_vm.$set(_vm.group, "msgRemindAgents", $$v)},expression:"group.msgRemindAgents"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.userChoose3}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"msgRemindAgents"}},[_c('el-input',{model:{value:(_vm.group.msgRemindAgents),callback:function ($$v) {_vm.$set(_vm.group, "msgRemindAgents", $$v)},expression:"group.msgRemindAgents"}})],1)],1):_vm._e()],1)],1)])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('mw-dialog',{ref:"dialog",attrs:{"size":"full","title":"动作脚本","before-close":_vm.handleClose}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.save}},[_c('i',{staticClass:"fa fa-plus-square",attrs:{"type":"primary"}}),_vm._v("保存")]),_vm._v("\n        "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveClose}},[_c('i',{staticClass:"fa fa-plus-square",attrs:{"type":"primary"}}),_vm._v("保存关闭")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-tabs',{attrs:{"type":"card"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("基础配置")]),_vm._v(" "),_c('div',{staticClass:"mw-panel"},[_c('split-pane',{attrs:{"defaultPercent":50,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-panel-y",staticStyle:{"margin-right":"5px"}},[_c('el-form',{ref:"form",staticClass:"mw-form",staticStyle:{"width":"90%"},attrs:{"label-width":"100px","model":_vm.form}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"id"}},[_c('el-input',{model:{value:(_vm.form.id),callback:function ($$v) {_vm.$set(_vm.form, "id", $$v)},expression:"form.id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"名称","prop":"name"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"标识","prop":"action"}},[_c('el-input',{model:{value:(_vm.form.action),callback:function ($$v) {_vm.$set(_vm.form, "action", $$v)},expression:"form.action"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"分类","prop":"type"}},[_c('el-input',{model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"生效公式","prop":"effectiveFormula"}},[_c('el-input',{model:{value:(_vm.form.effectiveFormula),callback:function ($$v) {_vm.$set(_vm.form, "effectiveFormula", $$v)},expression:"form.effectiveFormula"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否默认","prop":"isDefault"}},[_c('el-radio-group',{model:{value:(_vm.form.isDefault),callback:function ($$v) {_vm.$set(_vm.form, "isDefault", $$v)},expression:"form.isDefault"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v("是")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"0"}},[_vm._v("否")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注","prop":"remark"}},[_c('el-input',{attrs:{"type":"textarea","rows":3},model:{value:(_vm.form.remark),callback:function ($$v) {_vm.$set(_vm.form, "remark", $$v)},expression:"form.remark"}})],1)],1)],1)],1)]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('mw-dialog',{ref:"paramsDialog",attrs:{"size":"mini_mini","title":_vm.title,"footerButton":_vm.paramsFooterButton,"close-on-click-modal":false}},[_c('el-form',{ref:"paramsForm",staticStyle:{"margin-top":"20px"},attrs:{"model":_vm.paramsForm,"label-width":"70px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"名称"}},[_c('el-input',{model:{value:(_vm.paramsForm.name),callback:function ($$v) {_vm.$set(_vm.paramsForm, "name", $$v)},expression:"paramsForm.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"描述"}},[_c('el-input',{model:{value:(_vm.paramsForm.description),callback:function ($$v) {_vm.$set(_vm.paramsForm, "description", $$v)},expression:"paramsForm.description"}})],1)],1)],1)],1),_vm._v(" "),_c('toolbar-table',{ref:"paramsToolbarTable",attrs:{"toolbarTitle":_vm.toolbarTitle,"toolbarTitleWidth":200,"pagination":false,"showHeader":true,"layout":_vm.paramsLayout}})],1)],2)],1)]),_vm._v(" "),_c('el-tab-pane',{staticClass:"script-box"},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("javascript脚本")]),_vm._v(" "),_c('mw-code-edit',{ref:"javascript",attrs:{"value":_vm.javascript}})],1),_vm._v(" "),_c('el-tab-pane',{staticClass:"script-box"},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("groovy脚本")]),_vm._v(" "),_c('mw-code-edit',{ref:"groovy",attrs:{"value":_vm.groovy,"lang":"Groovy"}})],1)],1)],1)]),_vm._v(" "),_c('split-pane',{attrs:{"defaultPercent":25,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v("展开")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v("折叠")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"actionTree",attrs:{"url":_vm.actionTreeUrl,"async":false,"multiple":false,"selectFirst":true,"expandedFirst":true},on:{"changed":_vm.loadTableTree}})],1)])]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"toolbarTable",attrs:{"layout":_vm.layout,"autoLoad":false}},[_c('span',{attrs:{"slot":"more"},slot:"more"},[_c('el-dropdown',{attrs:{"trigger":"hover"},on:{"command":_vm.handleCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n                更多 "),_c('i',{staticClass:"fa fa-angle-double-right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"import"}},[_vm._v("导出")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"export"}},[_vm._v("导入")])],1)],1)],1)])],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-config"},[_c('mw-dialog',{ref:"dialog",staticClass:"flow-config-dialog",attrs:{"size":"full","title":_vm.title}},[_c('div',{staticClass:"mw-panel"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-form',{attrs:{"inline":true,"label-width":"60px"}},[_c('el-form-item',{attrs:{"label":"名称："}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"编码："}},[_c('el-input',{model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveForm}},[_c('i',{staticClass:"fa fa-plus-square"}),_vm._v("保存")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body",staticStyle:{"overflow":"hidden"}},[_c('el-col',{staticClass:"__title",attrs:{"span":12}},[_vm._v("模板")]),_vm._v(" "),_c('el-col',{staticClass:"__title",attrs:{"span":12}},[_vm._v("控制")]),_vm._v(" "),_c('el-col',{staticClass:"__code",attrs:{"span":12}},[_c('mw-code-edit',{ref:"formTemplate",attrs:{"value":_vm.form.template,"lang":"HTML"}})],1),_vm._v(" "),_c('el-col',{staticClass:"__code",attrs:{"span":12}},[_c('mw-code-edit',{ref:"formScript",attrs:{"value":_vm.form.script}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"__type"},[_c('el-form',{attrs:{"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"脚本方式："}},[_c('el-select',{model:{value:(_vm.scriptType),callback:function ($$v) {_vm.scriptType=$$v},expression:"scriptType"}},[_c('el-option',{key:"vue",attrs:{"label":"vue","value":"vue"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"mw-panel"},[_c('el-tabs',{attrs:{"type":"card"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("流程配置")]),_vm._v(" "),_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{on:{"click":_vm.save}},[_c('i',{staticClass:"fa fa-plus-square"}),_vm._v("保存")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body",staticStyle:{"overflow":"hidden"}},[_c('el-col',{staticClass:"__title",attrs:{"span":12}},[_vm._v("模板")]),_vm._v(" "),_c('el-col',{staticClass:"__title",attrs:{"span":12}},[_vm._v("控制")]),_vm._v(" "),_c('el-col',{staticClass:"__code",attrs:{"span":12}},[_c('mw-code-edit',{ref:"baseTemplate",attrs:{"value":_vm.baseTemplate,"lang":"HTML"}})],1),_vm._v(" "),_c('el-col',{staticClass:"__code",attrs:{"span":12}},[_c('mw-code-edit',{ref:"baseScript",attrs:{"value":_vm.baseScript}})],1)],1)]),_vm._v(" "),_c('el-tab-pane',{staticClass:"script-box"},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("节点配置")]),_vm._v(" "),_c('toolbar-table',{ref:"nodeTable",attrs:{"layout":_vm.nodeLayout,"autoLoad":true,"pagination":false}})],1),_vm._v(" "),_c('el-tab-pane',{staticClass:"script-box"},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("流向配置")]),_vm._v(" "),_c('toolbar-table',{ref:"lineTable",attrs:{"layout":_vm.lineLayout,"autoLoad":true,"pagination":false}})],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("事件处理")]),_vm._v(" "),_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{on:{"click":_vm.save}},[_c('i',{staticClass:"fa fa-plus-square"}),_vm._v("保存")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body",staticStyle:{"overflow":"hidden"}},[_c('el-col',{staticClass:"__title",attrs:{"span":24}},[_vm._v("事件处理")]),_vm._v(" "),_c('el-col',{staticClass:"__code",attrs:{"span":24}},[_c('mw-code-edit',{ref:"eventScript",attrs:{"value":_vm.eventScript}})],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.saveSet}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v(" 保存")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-form',{ref:"setForm",staticClass:"mw-form",attrs:{"label-width":"130px","model":_vm.set}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"默认登录应用","prop":"name"}},[_c('el-input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],model:{value:(_vm.set.defaultEnterAppId),callback:function ($$v) {_vm.$set(_vm.set, "defaultEnterAppId", $$v)},expression:"set.defaultEnterAppId"}}),_vm._v(" "),_c('el-input',{attrs:{"readOnly":""},model:{value:(_vm.set.defaultEnterAppName),callback:function ($$v) {_vm.$set(_vm.set, "defaultEnterAppName", $$v)},expression:"set.defaultEnterAppName"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.showDialog}},[_vm._v("选择")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"默认库","prop":"repository"}},[_c('el-input',{model:{value:(_vm.set.repository),callback:function ($$v) {_vm.$set(_vm.set, "repository", $$v)},expression:"set.repository"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"登录页面","prop":"loginPage"}},[_c('el-input',{model:{value:(_vm.set.loginPage),callback:function ($$v) {_vm.$set(_vm.set, "loginPage", $$v)},expression:"set.loginPage"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"页卡标题","prop":"pageTitle"}},[_c('el-input',{model:{value:(_vm.set.pageTitle),callback:function ($$v) {_vm.$set(_vm.set, "pageTitle", $$v)},expression:"set.pageTitle"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"资源根路径","prop":"rootPath"}},[_c('el-input',{model:{value:(_vm.set.rootPath),callback:function ($$v) {_vm.$set(_vm.set, "rootPath", $$v)},expression:"set.rootPath"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"应用资源","prop":"scriptStyle"}},[_c('div',{staticStyle:{"height":"400px"}},[_c('mw-code-edit',{ref:"formTemplate",attrs:{"value":_vm.set.scriptStyle,"lang":"HTML"}})],1)])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktimePreview_vue__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktimePreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktimePreview_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktimePreview_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktimePreview_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ea7b1e42_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_worktimePreview_vue__ = __webpack_require__(1235);
function injectStyle (ssrContext) {
  __webpack_require__(1234)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_worktimePreview_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ea7b1e42_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_worktimePreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"worktime-preview box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{ref:"calendarContainer",staticClass:"calendar"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel worktime"},[_c('mw-dialog',{ref:"dialog",attrs:{"size":"large_large","title":_vm.title,"before-close":_vm.handleClose}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleClose}},[_c('i',{staticClass:"fa fa-mail-reply",attrs:{"type":"primary"}}),_vm._v("关闭")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.save}},[_c('i',{staticClass:"fa fa-file-text",attrs:{"type":"primary"}}),_vm._v("保存")]),_vm._v(" "),_c('el-button',{staticClass:"pull-right",staticStyle:{"margin-top":"8px"},attrs:{"type":"info"},on:{"click":_vm.helpnotes}},[_c('i',{staticClass:"fa fa-question"}),_vm._v("帮助\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-form',{ref:"form",staticClass:"mw-form",staticStyle:{"width":"90%"},attrs:{"label-width":"100px","model":_vm.form}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-input',{model:{value:(_vm.form.id),callback:function ($$v) {_vm.$set(_vm.form, "id", $$v)},expression:"form.id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属单位"}},[_c('el-input',{staticStyle:{"width":"75%"},attrs:{"readonly":""},model:{value:(_vm.form.unitName),callback:function ($$v) {_vm.$set(_vm.form, "unitName", $$v)},expression:"form.unitName"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.showUnit}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"label":"单位ID"}},[_c('el-input',{model:{value:(_vm.form.unitId),callback:function ($$v) {_vm.$set(_vm.form, "unitId", $$v)},expression:"form.unitId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上午工作时间"}},[_c('el-time-select',{attrs:{"placeholder":"起始时间","picker-options":{
                start: '00:00',
                step: '00:15',
                end: '12:00'
              }},model:{value:(_vm.form.amStartTime),callback:function ($$v) {_vm.$set(_vm.form, "amStartTime", $$v)},expression:"form.amStartTime"}}),_vm._v("\n            至\n            "),_c('el-time-select',{attrs:{"placeholder":"结束时间","picker-options":{
                start: '00:00',
                step: '00:15',
                end: '12:00',
                minTime: _vm.form.amStartTime
              }},model:{value:(_vm.form.amEndTime),callback:function ($$v) {_vm.$set(_vm.form, "amEndTime", $$v)},expression:"form.amEndTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"下午工作时间"}},[_c('el-time-select',{attrs:{"placeholder":"起始时间","picker-options":{
                  start: '12:00',
                  step: '00:15',
                  end: '24:00'
                }},model:{value:(_vm.form.pmStartTime),callback:function ($$v) {_vm.$set(_vm.form, "pmStartTime", $$v)},expression:"form.pmStartTime"}}),_vm._v("\n              至\n              "),_c('el-time-select',{attrs:{"placeholder":"结束时间","picker-options":{
                  start: '12:00',
                  step: '00:15',
                  end: '24:00',
                  minTime: _vm.form.pmStartTime
                }},model:{value:(_vm.form.pmEndTime),callback:function ($$v) {_vm.$set(_vm.form, "pmEndTime", $$v)},expression:"form.pmEndTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作日"}},[_c('el-checkbox-group',{attrs:{"min":1},model:{value:(_vm.form.workdaysList),callback:function ($$v) {_vm.$set(_vm.form, "workdaysList", $$v)},expression:"form.workdaysList"}},_vm._l((_vm.workdayOptions),function(workday){return _c('el-checkbox',{key:workday.id,attrs:{"label":workday.id}},[_vm._v(_vm._s(workday.name))])}),1)],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"label":"是否默认"}},[_c('el-input',{model:{value:(_vm.form.isDefault),callback:function ($$v) {_vm.$set(_vm.form, "isDefault", $$v)},expression:"form.isDefault"}})],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('worktime-preview',{ref:"worktimePreview",attrs:{"formData":_vm.form,"isNew":_vm.isNew},on:{"setSpecialDay":_vm.setSpecialDay}})],1)]),_vm._v(" "),_c('toolbar-table',{ref:"toolbarTable",attrs:{"layout":_vm.layout}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('split-pane',{attrs:{"defaultPercent":20}},[_c('div',{staticClass:"mw-split-left",attrs:{"slot":"paneL"},slot:"paneL"},[_c('div',{staticClass:"mw-panel-y mw-panel__tree"},[_c('div',{staticClass:"mw-toolbar"},[_c('mw-button',{on:{"click":function($event){return _vm.createNode(_vm.currentNode)}}},[_vm._v("新建\n        ")]),_vm._v(" "),_c('mw-button',{on:{"click":function($event){return _vm.removeNode(_vm.currentNode)}}},[_vm._v("删除\n        ")]),_vm._v(" "),_c('el-dropdown',{attrs:{"trigger":"hover"},on:{"command":_vm.handleMoreCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n            更多"),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"import"}},[_vm._v("导入")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"export"}},[_vm._v("导出")])],1)],1)],1),_vm._v(" "),_c('div',{ref:"treeContainer",staticClass:"mw-toolbar__body mw-app__edit"},[_c('mw-tree',{ref:"mwTree",attrs:{"treeData":_vm.treeData,"async":false,"multiple":false,"expandedFirst":false,"autoLoad":true,"selectNode":_vm.selectNodeId,"contextMenuItem":_vm.treeContextMenu,"dragEnable":false},on:{"changed":_vm.treeClick}})],1)]),_vm._v(" "),_c('el-dialog',{ref:"multilangDialog",attrs:{"title":"新建","width":"300px","show-close":false,"before-close":_vm.beforeCloseDialogVisible,"visible":_vm.multilangDialogVisible},on:{"update:visible":function($event){_vm.multilangDialogVisible=$event}}},[_c('div',{staticStyle:{"width":"100%","height":"8px"}}),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.selectOption),callback:function ($$v) {_vm.selectOption=$$v},expression:"selectOption"}},[_c('el-option',{attrs:{"label":"请选择","value":""}}),_vm._v(" "),_vm._l((_vm.options),function(option){return _c('el-option',{key:option.value,attrs:{"label":option.label,"value":option.value}})})],2),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.multilangDialogVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.disabledNew},on:{"click":function($event){$event.preventDefault();return _vm.newLanguage($event)}}},[_vm._v("确 定")])],1)],1),_vm._v(" "),_c('mw-dialog',{ref:"impDialog",attrs:{"title":"导入语言配置","size":"mini_small","footerButton":_vm.impBtton}},[_c('div',{staticClass:"mw-dialog_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"上传文件:"}},[[_c('el-upload',{ref:"importData",staticStyle:{"display":"inline-block"},attrs:{"on-success":_vm.importSuccessCallback,"auto-upload":false,"action":_vm.importAction,"multiple":"","headers":_vm.headers,"limit":1}},[_c('el-button',[_vm._v("获取文件")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传.xml文件")])],1)]],2)],1)],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"flow-config-dialog mw-split-right",attrs:{"slot":"paneR"},slot:"paneR"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-form',{attrs:{"inline":true,"label-width":"60px"}},[_c('el-form-item',[_c('el-button',{attrs:{"disabled":_vm.disabledSave,"type":"primary"},on:{"click":function($event){return _vm.saveForm(0)}}},[_c('i',{staticClass:"fa fa-plus-square"}),_vm._v("保存")])],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"float":"right"}},[_c('el-button',{attrs:{"type":"info"},on:{"click":_vm.showHelp}},[_c('i',{staticClass:"fa fa-question"}),_vm._v("帮助")])],1),_vm._v(" "),_c('el-form-item',{staticClass:"pull-right",attrs:{"label":"ID："}},[_vm._v("\n          "+_vm._s(_vm.form.id)+"\n          ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"mw-panel"},[_c('div',{staticClass:"mw-panel mw-panel-class"},[_c('el-tabs',{attrs:{"stretch":true},model:{value:(_vm.valueTab),callback:function ($$v) {_vm.valueTab=$$v},expression:"valueTab"}},[_c('el-tab-pane',{attrs:{"label":" 键值对 ","name":"keyValue"}},[_c('mw-code-edit',{ref:"formTemplate",attrs:{"lang":"Text","value":_vm.form.template}})],1)],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_recycleBin_vue__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_recycleBin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_recycleBin_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_recycleBin_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_recycleBin_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6ab1368f_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_recycleBin_vue__ = __webpack_require__(1241);
function injectStyle (ssrContext) {
  __webpack_require__(1240)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ab1368f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_recycleBin_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6ab1368f_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_recycleBin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container"},[_c('split-pane',{attrs:{"defaultSize":208}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"componentTree",attrs:{"treeData":_vm.treeData,"defaultParams":_vm.defaultTreeParams,"async":false,"contextMenuItem":_vm.contextMenuItem,"dragEnable":true,"expandedFirst":true,"selectFirst":true},on:{"changed":_vm.changed}})],1)])]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"dataTable",attrs:{"layout":_vm.layout,"autoLoad":false,"defaultParams":_vm.defaultParams}},[_c('span',{attrs:{"slot":"dropDown"},slot:"dropDown"},[_c('el-button',{on:{"click":_vm.removeData}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v("删除\n            ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.activate}},[_c('i',{staticClass:"fa fa-rotate-right"}),_vm._v("恢复\n            ")])],1),_vm._v(" "),_c('span',[_vm._v(" ")])])],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('split-pane',{attrs:{"defaultPercent":20}},[_c('div',{staticClass:"mw-split-left",attrs:{"slot":"paneL"},slot:"paneL"},[_c('div',{staticClass:"mw-panel-y mw-panel__tree"},[_c('div',{ref:"treeContainer",staticClass:"mw-toolbar__body mw-app__edit"},[_c('mw-tree',{ref:"mwTree",attrs:{"url":_vm.treeUrl,"async":true,"multiple":false,"selectFirst":true,"expandedFirst":true,"autoLoad":true,"dragEnable":false},on:{"changed":_vm.treeClick}})],1)])]),_vm._v(" "),_c('div',{staticClass:"flow-config-dialog mw-split-right",attrs:{"slot":"paneR"},slot:"paneR"},[_c('toolbar-table',{ref:"dataTable",attrs:{"layout":_vm.layout,"autoLoad":false,"defaultParams":_vm.defaultParams}},[_c('span',{attrs:{"slot":"more"},slot:"more"},[_c('el-dropdown',{attrs:{"trigger":"hover"},on:{"command":_vm.handleCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n                更多 "),_c('i',{staticClass:"fa fa-angle-double-right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"export"}},[_vm._v("导出")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"divided":"","command":""}},[_c('el-upload',_vm._b({staticStyle:{"margin":"0 -20px"}},'el-upload',_vm.importProps,false),[_c('div',{staticStyle:{"padding":"0px 50px 0 20px","text-align":"left"}},[_vm._v("导入")])])],1)],1)],1)],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_1ce0187a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1252);
function injectStyle (ssrContext) {
  __webpack_require__(1245)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_1ce0187a_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowSelect_vue__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowSelect_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowSelect_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowSelect_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_1c55e616_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flowSelect_vue__ = __webpack_require__(1248);
function injectStyle (ssrContext) {
  __webpack_require__(1247)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flowSelect_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_1c55e616_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flowSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-input',{attrs:{"placeholder":"","readonly":"","value":_vm.displayValue,"clearable":true},on:{"change":_vm.handleChange}},[_c('template',{slot:"append"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.open}},[_vm._v("选择")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_unitSelect_vue__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_unitSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_unitSelect_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_unitSelect_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_unitSelect_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_37c13404_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_unitSelect_vue__ = __webpack_require__(1251);
function injectStyle (ssrContext) {
  __webpack_require__(1250)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_unitSelect_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_37c13404_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_unitSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-input',{attrs:{"placeholder":"","readonly":"","value":_vm.displayValue,"clearable":true},on:{"change":_vm.handleChange}},[_c('template',{slot:"append"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.open}},[_vm._v("选择")])],1)],2),_vm._v(" "),_c('mw-dialog',{ref:"zgDeptDialog",attrs:{"title":"选择部门机构","size":"small_large","footerButton":_vm.btns,"close-on-click-modal":false}},[_c('mw-tree',{ref:"deptTree",staticClass:"mw-dialog-body",attrs:{"url":_vm.deptTreeUrl,"multipleLeaf":true,"selectFirst":true,"async":true,"expandedFirst":true,"multiple":false},on:{"changed":_vm.handleSelect}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"92%"}},[_c('split-pane',{attrs:{"defaultPercent":25}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-panel-y mw-panel__tree"},[_c('div',{staticClass:"mw-toolbar"},[_c('h5',[_vm._v("流程干预")])]),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body mw-app__edit",staticStyle:{"padding":"10px 20px 0px 0px"}},[_c('el-form',{ref:"filterFormRef",attrs:{"model":_vm.filterForm,"label-width":"80px","size":"mini","rules":_vm.rules},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.updateTable($event)}}},[_c('el-form-item',{attrs:{"label":"流程状态"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":false,"placeholder":""},model:{value:(_vm.filterForm.flowStatus),callback:function ($$v) {_vm.$set(_vm.filterForm, "flowStatus", $$v)},expression:"filterForm.flowStatus"}},[_c('el-option',{attrs:{"label":"全部","value":""}}),_vm._v(" "),_c('el-option',{attrs:{"label":"正在办理","value":"0"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已办结","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"已挂起","value":"2"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"年度"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"year","format":"yyyy","value-format":"yyyy","placeholder":""},model:{value:(_vm.filterForm.year),callback:function ($$v) {_vm.$set(_vm.filterForm, "year", $$v)},expression:"filterForm.year"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"流程"}},[_c('FlowSelect',{model:{value:(_vm.filterForm.processDefinition),callback:function ($$v) {_vm.$set(_vm.filterForm, "processDefinition", $$v)},expression:"filterForm.processDefinition"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"单位"}},[_c('UnitSelect',{model:{value:(_vm.filterForm.draftsUnit),callback:function ($$v) {_vm.$set(_vm.filterForm, "draftsUnit", $$v)},expression:"filterForm.draftsUnit"}}),_vm._v(" "),_c('el-checkbox',{model:{value:(_vm.filterForm.matchDept),callback:function ($$v) {_vm.$set(_vm.filterForm, "matchDept", $$v)},expression:"filterForm.matchDept"}},[_vm._v("匹配部门")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"标题","prop":"businessName"}},[_c('el-input',{staticStyle:{"border-radius":"0","border-bottom":"10px solid transparent"},attrs:{"type":"textarea","autosize":"","placeholder":"","clearable":true},model:{value:(_vm.filterForm.businessName),callback:function ($$v) {_vm.$set(_vm.filterForm, "businessName", $$v)},expression:"filterForm.businessName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"业务ID","prop":"businessId"}},[_c('el-input',{staticStyle:{"border-radius":"0","border-bottom":"10px solid transparent"},attrs:{"type":"textarea","autosize":"","placeholder":"","clearable":true},model:{value:(_vm.filterForm.businessId),callback:function ($$v) {_vm.$set(_vm.filterForm, "businessId", $$v)},expression:"filterForm.businessId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"筛选条件"}},_vm._l((_vm.filterQuery),function(item){return _c('el-tag',{key:item.source,staticStyle:{"margin":"5px"},attrs:{"size":"mini","closable":""},on:{"close":function($event){return _vm.handleRemoveQuery(item)}}},[_vm._v("\n                  "+_vm._s(item.value)+"\n                ")])}),1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary","native-type":"submit"}},[_vm._v("查询")])],1)],1)],1)])])]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('mwFlowInterferingTable',{attrs:{"filterParams":_vm.filterParams}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_navigator_form_vue__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_navigator_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_navigator_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_navigator_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_navigator_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7d2d1fc2_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_navigator_form_vue__ = __webpack_require__(1256);
function injectStyle (ssrContext) {
  __webpack_require__(1255)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d2d1fc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_navigator_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7d2d1fc2_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_navigator_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('div',{staticClass:"mw-toolbar"},[_c('mw-button',{attrs:{"disabled":_vm.disabledSave,"icon":"fa fa-save"},on:{"click":_vm.save}},[_vm._v("保存")]),_vm._v(" "),_c('mw-button',{attrs:{"icon":"fa fa-map"},on:{"click":_vm.getPath}},[_vm._v("获取路径")]),_vm._v(" "),_c('el-button',{staticClass:"pull-right",staticStyle:{"margin-top":"8px"},attrs:{"type":"info"},on:{"click":_vm.helpnotes}},[_c('i',{staticClass:"fa fa-question"}),_vm._v("帮助\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-form',{ref:"form",staticClass:"mw-form",attrs:{"label-width":"130px","model":_vm.form}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"id"}},[_c('el-input',{model:{value:(_vm.form.id),callback:function ($$v) {_vm.$set(_vm.form, "id", $$v)},expression:"form.id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"显示名称","prop":"name"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"链接类型","prop":"linkType"}},[_c('el-radio-group',{on:{"change":_vm.linkTypeChange},model:{value:(_vm.form.linkType),callback:function ($$v) {_vm.$set(_vm.form, "linkType", $$v)},expression:"form.linkType"}},[_c('el-radio',{attrs:{"label":"view"}},[_vm._v("视图")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"page"}},[_vm._v("页面")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"inner"}},[_vm._v("内置视图")])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"链接目标","prop":"target"}},[_c('el-input',{attrs:{"readonly":""},on:{"change":_vm.chageTarget},model:{value:(_vm.form.target),callback:function ($$v) {_vm.$set(_vm.form, "target", $$v)},expression:"form.target"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.selectTarget}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"targetId"}},[_c('el-input',{model:{value:(_vm.form.targetId),callback:function ($$v) {_vm.$set(_vm.form, "targetId", $$v)},expression:"form.targetId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"导航图标","prop":"icon"}},[_c('MwIconSelect',{staticStyle:{"width":"60%"},model:{value:(_vm.form.icon),callback:function ($$v) {_vm.$set(_vm.form, "icon", $$v)},expression:"form.icon"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"图标颜色","prop":"bgColor"}},[_c('MwColorSelect',{staticStyle:{"width":"60%"},model:{value:(_vm.form.bgColor),callback:function ($$v) {_vm.$set(_vm.form, "bgColor", $$v)},expression:"form.bgColor"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"显示风格","prop":"style"}},[_c('el-radio',{attrs:{"label":"tree"},model:{value:(_vm.form.style),callback:function ($$v) {_vm.$set(_vm.form, "style", $$v)},expression:"form.style"}},[_vm._v("树状菜单")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"full"},model:{value:(_vm.form.style),callback:function ($$v) {_vm.$set(_vm.form, "style", $$v)},expression:"form.style"}},[_vm._v("没导航菜单")])],1)],1),_vm._v(" "),(_vm.form.style=='full')?_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"导航隐藏","prop":"navHide"}},[_c('el-radio',{attrs:{"label":"0"},model:{value:(_vm.form.navHide),callback:function ($$v) {_vm.$set(_vm.form, "navHide", $$v)},expression:"form.navHide"}},[_vm._v("隐藏")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"1"},model:{value:(_vm.form.navHide),callback:function ($$v) {_vm.$set(_vm.form, "navHide", $$v)},expression:"form.navHide"}},[_vm._v("显示")])],1)],1):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"权限过滤","prop":"exp"}},[_c('el-input',{model:{value:(_vm.form.exp),callback:function ($$v) {_vm.$set(_vm.form, "exp", $$v)},expression:"form.exp"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.setFormExp}},[_vm._v("生成表达式")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.clearFormExp}},[_vm._v("清空")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"是否显示","prop":"disable"}},[_c('el-radio',{attrs:{"label":"1"},model:{value:(_vm.form.disable),callback:function ($$v) {_vm.$set(_vm.form, "disable", $$v)},expression:"form.disable"}},[_vm._v("是")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"0"},model:{value:(_vm.form.disable),callback:function ($$v) {_vm.$set(_vm.form, "disable", $$v)},expression:"form.disable"}},[_vm._v("否")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"额外参数","prop":"ewcs"}},[_c('el-input',{model:{value:(_vm.form.ewcs),callback:function ($$v) {_vm.$set(_vm.form, "ewcs", $$v)},expression:"form.ewcs"}})],1)],1)],1)],1),_vm._v(" "),_c('el-dialog',{ref:"authority",attrs:{"width":"800px","before-close":_vm.closeAuthory,"visible":_vm.dialogFormVisible},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"margin-right":"12px"}},[_vm._v("生成权限表达式")]),_vm._v(" "),_c('el-button',{attrs:{"type":"info"},on:{"click":function($event){return _vm.helpnotes('auth')}}},[_c('i',{staticClass:"fa fa-question"}),_vm._v("帮助\n      ")])],1),_vm._v(" "),_c('el-form',{attrs:{"model":_vm.authorityForm}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.authorityForm,"height":"250","border":""}},[_c('el-table-column',{attrs:{"prop":"zdmc","label":"字段名称","type":"index","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{staticStyle:{"width":"80%"},attrs:{"placeholder":"字段名称","readonly":""},model:{value:(scope.row.zdmcstr),callback:function ($$v) {_vm.$set(scope.row, "zdmcstr", $$v)},expression:"scope.row.zdmcstr"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){$event.preventDefault();return _vm.selectZdmc(scope.row, scope.$index)}}},[_vm._v("选择")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"bjf","label":"比较值","type":"index","width":"98"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{model:{value:(scope.row.bjf),callback:function ($$v) {_vm.$set(scope.row, "bjf", $$v)},expression:"scope.row.bjf"}},[_c('el-option',{attrs:{"label":"请选择","value":""}}),_vm._v(" "),(scope.row.zdmc=='$D')?_c('el-option',{attrs:{"label":"等于(包含子部门)","value":"~~"}}):_vm._e(),_vm._v(" "),(scope.row.zdmc=='$D')?_c('el-option',{attrs:{"label":"不等于(包含子部门)","value":"!~~"}}):_vm._e(),_vm._v(" "),_c('el-option',{attrs:{"label":scope.row.zdmc=='$roleNames'?'包含':'等于',"value":"=="}}),_vm._v(" "),_c('el-option',{attrs:{"label":scope.row.zdmc=='$roleNames'?'不包含':'不等于',"value":"!="}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"srz","label":"输入值","type":"index","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{style:({width: scope.row.zdmc=='$D'?'80%':'100%'}),attrs:{"readonly":scope.row.zdmc=='$D'?true:false,"placeholder":"输入值"},model:{value:(scope.row.srzstr),callback:function ($$v) {_vm.$set(scope.row, "srzstr", $$v)},expression:"scope.row.srzstr"}}),_vm._v(" "),(scope.row.zdmc=='$D')?_c('el-button',{on:{"click":function($event){$event.preventDefault();return _vm.selectDept(scope.row, scope.$index)}}},[_vm._v("选择")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"gxf","label":"关系符","type":"index","width":"98"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{model:{value:(scope.row.gxf),callback:function ($$v) {_vm.$set(scope.row, "gxf", $$v)},expression:"scope.row.gxf"}},[_c('el-option',{attrs:{"label":"并且","value":"and"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"或者","value":"or"}})],1)]}}])})],1)],1),_vm._v(" "),_c('div',[_c('p',{staticStyle:{"margin-top":"10px","font-size":"16px","font-weight":"600"}},[_vm._v("预览:")]),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.previewAuthory)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.addAuthory}},[_vm._v("添加一行")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closeAuthory}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.setAuthory}},[_vm._v("确 定")])],1)],1),_vm._v(" "),_c('el-dialog',{ref:"selzdmc",attrs:{"title":"选择字段名称","width":"300px","show-close":false,"before-close":_vm.clearCurzdmc,"visible":_vm.dialogSelectVisible},on:{"update:visible":function($event){_vm.dialogSelectVisible=$event}}},[_c('div',{staticStyle:{"width":"100%","height":"8px"}}),_vm._v(" "),_c('p',[_c('el-radio',{attrs:{"label":"$loginId"},model:{value:(_vm.curzdmc),callback:function ($$v) {_vm.curzdmc=$$v},expression:"curzdmc"}},[_vm._v("登陆ID")])],1),_vm._v(" "),_c('p',[_c('el-radio',{attrs:{"label":"$userName"},model:{value:(_vm.curzdmc),callback:function ($$v) {_vm.curzdmc=$$v},expression:"curzdmc"}},[_vm._v("用户名称")])],1),_vm._v(" "),_c('p',[_c('el-radio',{attrs:{"label":"$roleNames"},model:{value:(_vm.curzdmc),callback:function ($$v) {_vm.curzdmc=$$v},expression:"curzdmc"}},[_vm._v("身份权限")])],1),_vm._v(" "),_c('p',[_c('el-radio',{attrs:{"label":"$D"},model:{value:(_vm.curzdmc),callback:function ($$v) {_vm.curzdmc=$$v},expression:"curzdmc"}},[_vm._v("单位或部门(ID)")])],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogSelectVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.setCurzdmc($event)}}},[_vm._v("确 定")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('split-pane',{attrs:{"defaultPercent":20}},[_c('div',{staticClass:"mw-split-left",attrs:{"slot":"paneL"},slot:"paneL"},[_c('div',{staticClass:"mw-panel-y mw-panel__tree"},[_c('div',{staticClass:"mw-toolbar"},[_c('mw-button',{on:{"click":function($event){return _vm.createNode(_vm.currentNode)}}},[_vm._v("新建\n        ")]),_vm._v(" "),_c('mw-button',{on:{"click":function($event){return _vm.removeNode(_vm.currentNode)}}},[_vm._v("删除\n        ")]),_vm._v(" "),_c('mw-button',{on:{"click":_vm.showData}},[_vm._v("data\n        ")]),_vm._v(" "),_c('el-dropdown',{attrs:{"trigger":"hover"},on:{"command":_vm.handleMoreCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n            更多"),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"import"}},[_vm._v("导入")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"export"}},[_vm._v("导出")])],1)],1)],1),_vm._v(" "),_c('div',{ref:"treeContainer",staticClass:"mw-toolbar__body mw-app__edit"},[_c('mw-tree',{ref:"mwTree",attrs:{"treeData":_vm.treeData,"async":false,"multiple":false,"contextMenuItem":_vm.treeContextMenu,"expandedFirst":false,"autoLoad":true,"selectNode":_vm.selectNodeId},on:{"changed":_vm.treeClick,"move":_vm.dragend}})],1)]),_vm._v(" "),_c('mw-dialog',{ref:"dataDialog",attrs:{"size":"large_large","title":"导航树数据"}},[_c('div',{staticClass:"mw-toolbar__body"},[_c('pre',[_vm._v(_vm._s(_vm.treeListData)+"\n        ")])])]),_vm._v(" "),_c('mw-dialog',{ref:"impDialog",attrs:{"title":"导入导航菜单","size":"mini_small","footerButton":_vm.impBtton},on:{"opened":_vm.showUpload}},[_c('div',{staticClass:"mw-dialog_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"上传文件:"}},[_c('el-button',{ref:"uploader"},[_vm._v("上传文件")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip"},[_vm._v("只能上传.xml文件")])],1)],1)],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"mw-split-right",attrs:{"slot":"paneR"},slot:"paneR"},[(!!_vm.currentNode)?_c('navigatorForm',{attrs:{"node":_vm.currentNode,"appId":_vm.appId},on:{"afterSave":_vm.afterSave}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container mw-bar-data"},[_c('split-pane',{attrs:{"defaultSize":216,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('mw-dialog',{ref:"leadDialog",attrs:{"title":"导出系统登录日志excel","size":"mini_mini","footerButton":_vm.leadButton}},[_c('div',{staticClass:"mw-dialog_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"开始时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择时间","picker-options":_vm.pickerBeginDateBefore},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"结束时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择时间","picker-options":_vm.pickerBeginDateAfter},model:{value:(_vm.finishDate),callback:function ($$v) {_vm.finishDate=$$v},expression:"finishDate"}})]],2)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"editDialog",attrs:{"title":"查看信息","size":"small_large"}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.closeDialog('editDialog')}}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(" 关闭")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-form',{attrs:{"label-width":"130px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"用户名 :"}},[[_c('el-input',{staticStyle:{"width":"96%"},attrs:{"readonly":""},model:{value:(_vm.form.loginId),callback:function ($$v) {_vm.$set(_vm.form, "loginId", $$v)},expression:"form.loginId"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"名称 :"}},[[_c('el-input',{staticStyle:{"width":"96%"},attrs:{"readonly":""},model:{value:(_vm.form.userName),callback:function ($$v) {_vm.$set(_vm.form, "userName", $$v)},expression:"form.userName"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"浏览器信息 :"}},[[_c('el-input',{staticStyle:{"width":"96%"},attrs:{"readonly":""},model:{value:(_vm.form.userAgent),callback:function ($$v) {_vm.$set(_vm.form, "userAgent", $$v)},expression:"form.userAgent"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"登录时间 :"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.createTime),callback:function ($$v) {_vm.$set(_vm.form, "createTime", $$v)},expression:"form.createTime"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"服务器地址 :"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.serverName),callback:function ($$v) {_vm.$set(_vm.form, "serverName", $$v)},expression:"form.serverName"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"服务器端口 :"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.serverPort),callback:function ($$v) {_vm.$set(_vm.form, "serverPort", $$v)},expression:"form.serverPort"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"客户端IP :"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.clientIP),callback:function ($$v) {_vm.$set(_vm.form, "clientIP", $$v)},expression:"form.clientIP"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"网卡地址 :"}},[[_c('el-input',{attrs:{"readonly":""}})]],2)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar__body"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v("展开")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v("折叠")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"logTree",attrs:{"url":_vm.treeUrl,"async":false,"multiple":false,"selectFirst":true,"defaultParams":_vm.params && _vm.params.requestParams,"expandedFirst":true},on:{"changed":_vm.loadTableTree}})],1)])])],1),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"dataTable",attrs:{"layout":_vm.layout,"autoLoad":false},on:{"rowExpanded":_vm.rowExpanded}})],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container mw-bar-data"},[_c('split-pane',{attrs:{"defaultSize":216,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('mw-dialog',{ref:"leadDialog",attrs:{"title":"用户操作日志excel","size":"mini_mini","footerButton":_vm.leadButton}},[_c('div',{staticClass:"mw-toolbar_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"开始时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期"},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"结束时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期"},model:{value:(_vm.finishDate),callback:function ($$v) {_vm.finishDate=$$v},expression:"finishDate"}})]],2)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"findDialog",attrs:{"title":"查询","size":"small_small","footerButton":_vm.findButton}},[_c('div',{staticClass:"mw-toolbar_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作开始时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期","picker-options":_vm.pickerBeginDateBefore},model:{value:(_vm.findOptions.createTime),callback:function ($$v) {_vm.$set(_vm.findOptions, "createTime", $$v)},expression:"findOptions.createTime"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作结束时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期","picker-options":_vm.pickerBeginDateAfter},model:{value:(_vm.findOptions.finishTime),callback:function ($$v) {_vm.$set(_vm.findOptions, "finishTime", $$v)},expression:"findOptions.finishTime"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作人"}},[[_c('el-input',{model:{value:(_vm.findOptions.userName),callback:function ($$v) {_vm.$set(_vm.findOptions, "userName", $$v)},expression:"findOptions.userName"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"功能名称"}},[[_c('el-input',{model:{value:(_vm.findOptions.name),callback:function ($$v) {_vm.$set(_vm.findOptions, "name", $$v)},expression:"findOptions.name"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作类型"}},[[_c('el-input',{model:{value:(_vm.findOptions.type),callback:function ($$v) {_vm.$set(_vm.findOptions, "type", $$v)},expression:"findOptions.type"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作对象类型"}},[[_c('el-input',{model:{value:(_vm.findOptions.type),callback:function ($$v) {_vm.$set(_vm.findOptions, "type", $$v)},expression:"findOptions.type"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"事件类型"}},[[_c('el-input',{model:{value:(_vm.findOptions.eventType),callback:function ($$v) {_vm.$set(_vm.findOptions, "eventType", $$v)},expression:"findOptions.eventType"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作结果"}},[[_c('el-input',{model:{value:(_vm.findOptions.optResult),callback:function ($$v) {_vm.$set(_vm.findOptions, "optResult", $$v)},expression:"findOptions.optResult"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"客户端IP :"}},[[_c('el-input',{model:{value:(_vm.findOptions.clientIP),callback:function ($$v) {_vm.$set(_vm.findOptions, "clientIP", $$v)},expression:"findOptions.clientIP"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"重要程度 :"}},[[_c('el-input',{model:{value:(_vm.findOptions.importantDegree),callback:function ($$v) {_vm.$set(_vm.findOptions, "importantDegree", $$v)},expression:"findOptions.importantDegree"}})]],2)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"editDialog",attrs:{"title":"查看信息","size":"large_large"}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.closeEditDialog}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(" 关闭")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作时间"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.createTime),callback:function ($$v) {_vm.$set(_vm.form, "createTime", $$v)},expression:"form.createTime"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作人"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.userName),callback:function ($$v) {_vm.$set(_vm.form, "userName", $$v)},expression:"form.userName"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"功能名称"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作类型"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作对象类型"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.objType),callback:function ($$v) {_vm.$set(_vm.form, "objType", $$v)},expression:"form.objType"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"事件类型"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.eventType),callback:function ($$v) {_vm.$set(_vm.form, "eventType", $$v)},expression:"form.eventType"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"操作结果"}},[[_c('el-input',{staticStyle:{"width":"96%"},attrs:{"type":"textarea","rows":10,"readonly":""},model:{value:(_vm.form.optResult),callback:function ($$v) {_vm.$set(_vm.form, "optResult", $$v)},expression:"form.optResult"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作人IP :"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.clientIP),callback:function ($$v) {_vm.$set(_vm.form, "clientIP", $$v)},expression:"form.clientIP"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"重要程度"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.importantDegree),callback:function ($$v) {_vm.$set(_vm.form, "importantDegree", $$v)},expression:"form.importantDegree"}})]],2)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v("展开")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v("折叠")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"dictTree",attrs:{"url":_vm.dictTreeUrl,"async":false,"multiple":false,"selectFirst":true,"defaultParams":_vm.params && _vm.params.requestParams,"expandedFirst":true},on:{"changed":_vm.loadTableTree}})],1)])],1),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"dataTable",attrs:{"layout":_vm.layout,"autoLoad":false}})],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container mw-bar-data"},[_c('split-pane',{attrs:{"defaultSize":216,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('mw-dialog',{ref:"leadDialog",attrs:{"title":"导出管理日志excel","size":"mini_mini","footerButton":_vm.leadButton}},[_c('div',{staticClass:"mw-toolbar_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"开始时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期","picker-options":_vm.pickerBeginDateBefore},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"结束时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期","picker-options":_vm.pickerBeginDateAfter},model:{value:(_vm.finishDate),callback:function ($$v) {_vm.finishDate=$$v},expression:"finishDate"}})]],2)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"findDialog",attrs:{"title":"查询","size":"small_small","footerButton":_vm.findButton}},[_c('div',{staticClass:"mw-toolbar_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作开始时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期"},model:{value:(_vm.findOptions.createTime),callback:function ($$v) {_vm.$set(_vm.findOptions, "createTime", $$v)},expression:"findOptions.createTime"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作结束时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期"},model:{value:(_vm.findOptions.finishTime),callback:function ($$v) {_vm.$set(_vm.findOptions, "finishTime", $$v)},expression:"findOptions.finishTime"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作人"}},[[_c('el-input',{model:{value:(_vm.findOptions.userName),callback:function ($$v) {_vm.$set(_vm.findOptions, "userName", $$v)},expression:"findOptions.userName"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作对象"}},[[_c('el-input',{model:{value:(_vm.findOptions.name),callback:function ($$v) {_vm.$set(_vm.findOptions, "name", $$v)},expression:"findOptions.name"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作类型"}},[[_c('el-input',{model:{value:(_vm.findOptions.type),callback:function ($$v) {_vm.$set(_vm.findOptions, "type", $$v)},expression:"findOptions.type"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"操作目标"}},[[_c('el-input',{model:{value:(_vm.findOptions.target),callback:function ($$v) {_vm.$set(_vm.findOptions, "target", $$v)},expression:"findOptions.target"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作说明"}},[[_c('el-input',{model:{value:(_vm.findOptions.remark),callback:function ($$v) {_vm.$set(_vm.findOptions, "remark", $$v)},expression:"findOptions.remark"}})]],2)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"editDialog",attrs:{"title":"查看信息","size":"large_large"}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.closeEditDialog}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(" 关闭")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作时间"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.createTime),callback:function ($$v) {_vm.$set(_vm.form, "createTime", $$v)},expression:"form.createTime"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作人"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.userName),callback:function ($$v) {_vm.$set(_vm.form, "userName", $$v)},expression:"form.userName"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作对象"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作类型"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作目标"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.target),callback:function ($$v) {_vm.$set(_vm.form, "target", $$v)},expression:"form.target"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":20}},[_c('el-form-item',{attrs:{"label":"操作说明"}},[[_c('el-input',{staticStyle:{"width":"96%"},attrs:{"type":"textarea","rows":10,"readonly":""},model:{value:(_vm.form.remark),callback:function ($$v) {_vm.$set(_vm.form, "remark", $$v)},expression:"form.remark"}})]],2)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v("展开")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v("折叠")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"dictTree",attrs:{"url":_vm.dictTreeUrl,"async":false,"multiple":false,"selectFirst":true,"defaultParams":_vm.params && _vm.params.requestParams,"expandedFirst":true},on:{"changed":_vm.loadTableTree}})],1)])],1),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"dataTable",attrs:{"layout":_vm.layout,"autoLoad":false}})],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container mw-bar-data"},[_c('split-pane',{attrs:{"defaultSize":216,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('mw-dialog',{ref:"leadDialog",attrs:{"title":"导出流程日志","size":"mini_mini","footerButton":_vm.leadButton}},[_c('div',{staticClass:"mw-toolbar_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"开始时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择时间","picker-options":_vm.pickerBeginDateBefore},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"结束时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择时间","picker-options":_vm.pickerBeginDateAfter},model:{value:(_vm.finishDate),callback:function ($$v) {_vm.finishDate=$$v},expression:"finishDate"}})]],2)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"findDialog",attrs:{"title":"查询","size":"small_small","footerButton":_vm.findButton}},[_c('div',{staticClass:"mw-toolbar_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作开始时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期"},model:{value:(_vm.findOptions.createTime),callback:function ($$v) {_vm.$set(_vm.findOptions, "createTime", $$v)},expression:"findOptions.createTime"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作结束时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期"},model:{value:(_vm.findOptions.finishTime),callback:function ($$v) {_vm.$set(_vm.findOptions, "finishTime", $$v)},expression:"findOptions.finishTime"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"业务名称"}},[[_c('el-input',{model:{value:(_vm.findOptions.businessNameLike),callback:function ($$v) {_vm.$set(_vm.findOptions, "businessNameLike", $$v)},expression:"findOptions.businessNameLike"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"用户名"}},[[_c('el-input',{model:{value:(_vm.findOptions.operatorLike),callback:function ($$v) {_vm.$set(_vm.findOptions, "operatorLike", $$v)},expression:"findOptions.operatorLike"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作类型"}},[[_c('el-input',{model:{value:(_vm.findOptions.actionNameLike),callback:function ($$v) {_vm.$set(_vm.findOptions, "actionNameLike", $$v)},expression:"findOptions.actionNameLike"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"IP地址"}},[[_c('el-input',{model:{value:(_vm.findOptions.ip),callback:function ($$v) {_vm.$set(_vm.findOptions, "ip", $$v)},expression:"findOptions.ip"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"流程名称"}},[[_c('el-input',{model:{value:(_vm.findOptions.processName),callback:function ($$v) {_vm.$set(_vm.findOptions, "processName", $$v)},expression:"findOptions.processName"}})]],2)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"editDialog",attrs:{"title":"查看信息","size":"small_small"}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.closeEditDialog}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(" 关闭")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作时间"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.createTime),callback:function ($$v) {_vm.$set(_vm.form, "createTime", $$v)},expression:"form.createTime"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"用户名"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.operator),callback:function ($$v) {_vm.$set(_vm.form, "operator", $$v)},expression:"form.operator"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"操作类型"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.actionName),callback:function ($$v) {_vm.$set(_vm.form, "actionName", $$v)},expression:"form.actionName"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"业务名称"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.businessName),callback:function ($$v) {_vm.$set(_vm.form, "businessName", $$v)},expression:"form.businessName"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"业务文档ID"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.draftsDocId),callback:function ($$v) {_vm.$set(_vm.form, "draftsDocId", $$v)},expression:"form.draftsDocId"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"业务批次"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.batchId),callback:function ($$v) {_vm.$set(_vm.form, "batchId", $$v)},expression:"form.batchId"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"任务ID"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.taskId),callback:function ($$v) {_vm.$set(_vm.form, "taskId", $$v)},expression:"form.taskId"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"IP地址"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.ip),callback:function ($$v) {_vm.$set(_vm.form, "ip", $$v)},expression:"form.ip"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"操作说明"}},[[_c('div',{domProps:{"innerHTML":_vm._s(_vm.form.description)}})]],2)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v("展开")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v("折叠")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"dictTree",attrs:{"url":_vm.dictTreeUrl,"async":false,"multiple":false,"selectFirst":true,"defaultParams":_vm.params && _vm.params.requestParams,"expandedFirst":true},on:{"changed":_vm.loadTableTree}})],1)])],1),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"dataTable",attrs:{"layout":_vm.layout,"autoLoad":false},scopedSlots:_vm._u([{key:"description",fn:function(scope){return [_c('div',{domProps:{"innerHTML":_vm._s(scope.row.description)}})]}}])})],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container mw-bar-data"},[_c('split-pane',{attrs:{"defaultSize":150,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('mw-dialog',{ref:"leadDialog",attrs:{"title":"导出流程事务日志","size":"mini_mini","footerButton":_vm.leadButton}},[_c('div',{staticClass:"mw-toolbar_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"开始时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择时间","picker-options":_vm.pickerBeginDateBefore},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"结束时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择时间","picker-options":_vm.pickerBeginDateAfter},model:{value:(_vm.finishDate),callback:function ($$v) {_vm.finishDate=$$v},expression:"finishDate"}})]],2)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"findDialog",attrs:{"title":"查询","size":"small_small","footerButton":_vm.findButton}},[_c('div',{staticClass:"mw-toolbar_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"开始时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期"},model:{value:(_vm.findOptions.startTime),callback:function ($$v) {_vm.$set(_vm.findOptions, "startTime", $$v)},expression:"findOptions.startTime"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"结束时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期"},model:{value:(_vm.findOptions.endTime),callback:function ($$v) {_vm.$set(_vm.findOptions, "endTime", $$v)},expression:"findOptions.endTime"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"业务名称"}},[[_c('el-input',{model:{value:(_vm.findOptions.businessNameLike),callback:function ($$v) {_vm.$set(_vm.findOptions, "businessNameLike", $$v)},expression:"findOptions.businessNameLike"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"模块"}},[[_c('el-input',{model:{value:(_vm.findOptions.moduleNameLike),callback:function ($$v) {_vm.$set(_vm.findOptions, "moduleNameLike", $$v)},expression:"findOptions.moduleNameLike"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"流程"}},[[_c('el-input',{model:{value:(_vm.findOptions.processDefinitionNameLike),callback:function ($$v) {_vm.$set(_vm.findOptions, "processDefinitionNameLike", $$v)},expression:"findOptions.processDefinitionNameLike"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"服务类"}},[[_c('el-input',{model:{value:(_vm.findOptions.serviceClassLike),callback:function ($$v) {_vm.$set(_vm.findOptions, "serviceClassLike", $$v)},expression:"findOptions.serviceClassLike"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"方法名"}},[[_c('el-input',{model:{value:(_vm.findOptions.methodNameLike),callback:function ($$v) {_vm.$set(_vm.findOptions, "methodNameLike", $$v)},expression:"findOptions.methodNameLike"}})]],2)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"dialog",attrs:{"size":"large_large","title":"查看事务日志","before-close":_vm.handleClose}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleClose}},[_c('i',{staticClass:"fa fa-mail-reply",attrs:{"type":"primary"}}),_vm._v("关闭")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.reExecute}},[_c('i',{staticClass:"fa fa-plus-square",attrs:{"type":"primary"}}),_vm._v("提交")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-tabs',{attrs:{"type":"card"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("基本信息")]),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"mw-form",staticStyle:{"width":"90%"},attrs:{"label-width":"120px","model":_vm.form}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"文档ID:"}},[_c('el-input',{attrs:{"readonly":true},model:{value:(_vm.form.businessId),callback:function ($$v) {_vm.$set(_vm.form, "businessId", $$v)},expression:"form.businessId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"文档题名:"}},[_c('el-input',{attrs:{"readonly":true},model:{value:(_vm.form.businessName),callback:function ($$v) {_vm.$set(_vm.form, "businessName", $$v)},expression:"form.businessName"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"模块:"}},[_c('el-input',{attrs:{"readonly":true},model:{value:(_vm.form.moduleName),callback:function ($$v) {_vm.$set(_vm.form, "moduleName", $$v)},expression:"form.moduleName"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"流程:"}},[_c('el-input',{attrs:{"readonly":true},model:{value:(_vm.form.processDefinitionName),callback:function ($$v) {_vm.$set(_vm.form, "processDefinitionName", $$v)},expression:"form.processDefinitionName"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"prop":"id"}},[_c('el-input',{model:{value:(_vm.form.id),callback:function ($$v) {_vm.$set(_vm.form, "id", $$v)},expression:"form.id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"起草文档ID:"}},[_c('el-input',{attrs:{"readonly":true},model:{value:(_vm.form.draftsDocId),callback:function ($$v) {_vm.$set(_vm.form, "draftsDocId", $$v)},expression:"form.draftsDocId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"批次ID:"}},[_c('el-input',{attrs:{"readonly":true},model:{value:(_vm.form.batchId),callback:function ($$v) {_vm.$set(_vm.form, "batchId", $$v)},expression:"form.batchId"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"创建时间:"}},[_c('el-input',{attrs:{"readonly":true},model:{value:(_vm.form.createTime),callback:function ($$v) {_vm.$set(_vm.form, "createTime", $$v)},expression:"form.createTime"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"最后修改时间:"}},[_c('el-input',{attrs:{"readonly":true},model:{value:(_vm.form.lastModifiedTime),callback:function ($$v) {_vm.$set(_vm.form, "lastModifiedTime", $$v)},expression:"form.lastModifiedTime"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"服务类:"}},[_c('el-input',{attrs:{"readonly":true},model:{value:(_vm.form.serviceClass),callback:function ($$v) {_vm.$set(_vm.form, "serviceClass", $$v)},expression:"form.serviceClass"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"方法名:"}},[_c('el-input',{attrs:{"readonly":true},model:{value:(_vm.form.methodName),callback:function ($$v) {_vm.$set(_vm.form, "methodName", $$v)},expression:"form.methodName"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"异常内容:"}},[_c('el-input',{attrs:{"type":"textarea","rows":15,"readonly":true},model:{value:(_vm.form.exceptionStack),callback:function ($$v) {_vm.$set(_vm.form, "exceptionStack", $$v)},expression:"form.exceptionStack"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-tab-pane',{staticClass:"script-box"},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("提交数据")]),_vm._v(" "),_c('mw-code-edit',{ref:"methodArgs",attrs:{"value":_vm.methodArgs,"lang":"JSON"}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v("展开")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v("折叠")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"dictTree",attrs:{"url":_vm.treeUrl,"async":false,"multiple":false,"selectFirst":true,"defaultParams":_vm.params && _vm.params.requestParams,"expandedFirst":true},on:{"changed":_vm.loadTableTree}})],1)])],1),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"dataTable",attrs:{"layout":_vm.layout,"autoLoad":false}})],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container mw-bar-data"},[_c('split-pane',{attrs:{"defaultSize":150,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('mw-dialog',{ref:"leadDialog",attrs:{"title":"导出系统登录日志excel","size":"mini_mini","footerButton":_vm.leadButton}},[_c('div',{staticClass:"mw-dialog_body",staticStyle:{"margin-top":"20px"}},[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"开始时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择时间","picker-options":_vm.pickerBeginDateBefore},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"结束时间"}},[[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择时间","picker-options":_vm.pickerBeginDateAfter},model:{value:(_vm.finishDate),callback:function ($$v) {_vm.finishDate=$$v},expression:"finishDate"}})]],2)],1)],1)],1)]),_vm._v(" "),_c('mw-dialog',{ref:"editDialog",attrs:{"title":"查看信息","size":"small_large"}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.closeDialog('editDialog')}}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(" 关闭")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('el-form',{attrs:{"label-width":"130px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"用户名 :"}},[[_c('el-input',{staticStyle:{"width":"96%"},attrs:{"readonly":""},model:{value:(_vm.form.loginId),callback:function ($$v) {_vm.$set(_vm.form, "loginId", $$v)},expression:"form.loginId"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"名称 :"}},[[_c('el-input',{staticStyle:{"width":"96%"},attrs:{"readonly":""},model:{value:(_vm.form.userName),callback:function ($$v) {_vm.$set(_vm.form, "userName", $$v)},expression:"form.userName"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"浏览器信息 :"}},[[_c('el-input',{staticStyle:{"width":"96%"},attrs:{"readonly":""},model:{value:(_vm.form.userAgent),callback:function ($$v) {_vm.$set(_vm.form, "userAgent", $$v)},expression:"form.userAgent"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"登录时间 :"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.createTime),callback:function ($$v) {_vm.$set(_vm.form, "createTime", $$v)},expression:"form.createTime"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"服务器地址 :"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.serverName),callback:function ($$v) {_vm.$set(_vm.form, "serverName", $$v)},expression:"form.serverName"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"服务器端口 :"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.serverPort),callback:function ($$v) {_vm.$set(_vm.form, "serverPort", $$v)},expression:"form.serverPort"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"客户端IP :"}},[[_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.form.clientIP),callback:function ($$v) {_vm.$set(_vm.form, "clientIP", $$v)},expression:"form.clientIP"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"网卡地址 :"}},[[_c('el-input',{attrs:{"readonly":""}})]],2)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar__body"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v("展开")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v("折叠")])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-tree',{ref:"logTree",attrs:{"url":_vm.treeUrl,"async":false,"multiple":false,"selectFirst":true,"expandedFirst":true},on:{"changed":_vm.loadTableTree}})],1)])])],1),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"dataTable",attrs:{"layout":_vm.layout,"autoLoad":false}})],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('split-pane',{attrs:{"defaultPercent":20}},[_c('div',{staticClass:"mw-split-left",attrs:{"slot":"paneL"},slot:"paneL"},[_c('el-dialog',{attrs:{"title":"新建文件夹","width":"30%","visible":_vm.dialogTableVisible,"small":""},on:{"update:visible":function($event){_vm.dialogTableVisible=$event},"close":function($event){_vm.addFolderParentFolder=''}}},[_c('div',{staticStyle:{"margin-top":"5px"}},[_c('el-input',{attrs:{"placeholder":"请输入文件名"},model:{value:(_vm.fileName),callback:function ($$v) {_vm.fileName=$$v},expression:"fileName"}})],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.cancelNewFile}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveFolder}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('div',{staticClass:"mw-toolbar"},[_c('mw-button',{attrs:{"icon":"fa fa-plus"},on:{"click":_vm.addFolder}},[_vm._v("新建文件夹")]),_vm._v(" "),_c('mw-button',{attrs:{"icon":"fa fa-remove"},on:{"click":_vm.deleteFolder}},[_vm._v("删除")])],1),_vm._v(" "),_c('el-tree',{ref:"folderTree",attrs:{"data":_vm.treeData,"node-key":"id","default-checked-keys":_vm.defaultCheckedKeys,"show-checkbox":"","lazy":"","load":_vm.loadTreeNode,"highlight-current":"","expand-on-click-node":false,"check-strictly":""},on:{"node-click":_vm.handleNodeClick,"node-contextmenu":_vm.nodeContextMenu}})],1),_vm._v(" "),_c('div',{staticClass:"mw-split-right",attrs:{"slot":"paneR"},slot:"paneR"},[_c('div',{staticClass:"mw-panel"},[_c('mw-dialog',{ref:"img_show",attrs:{"title":"文件浏览","before-close":_vm.handle_img_showClose,"close-on-click-modal":false,"size":"small_large"}},[_c('div',{staticStyle:{"margin-top":"5px","height":"98%"}},[_c('img',{attrs:{"width":"100%","height":"100%","src":_vm.imgUrl}})])]),_vm._v(" "),_c('toolbar-table',{ref:"viewToolbarTable",attrs:{"layout":_vm.layout,"autoLoad":_vm.autoLoad}},[_c('span',[_c('el-button',{attrs:{"type":"info","size":"mini"},on:{"click":_vm.showHelp}},[_c('i',{staticClass:"fa fa-question"}),_vm._v("帮助2")])],1)])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.viewId,{tag:"component",attrs:{"params":_vm.params}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_chart_viewer_vue__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_chart_viewer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_chart_viewer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_chart_viewer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_chart_viewer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_44028248_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flow_chart_viewer_vue__ = __webpack_require__(1274);
function injectStyle (ssrContext) {
  __webpack_require__(1273)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_flow_chart_viewer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_44028248_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_flow_chart_viewer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-process-viewer"},[_c('div',{staticClass:"mw-process-chart"},[_c('MwProcessChartEditor',{attrs:{"value":_vm.processDataGraph,"color":_vm.color,"editable":false},on:{"requestTitle":_vm.handleRequestTitle}})],1),_vm._v(" "),(_vm.processCount>1)?_c('div',{staticClass:"mw-process-chart-switch"},[_c('div',{staticClass:"_toolbar"},[_c('el-button',{staticClass:"el-button el-button--primary",on:{"click":function($event){return _vm.processSwitchClick()}}},[_c('i',{staticClass:"fa fa-eye"}),_c('span',{domProps:{"textContent":_vm._s(_vm.showProcessList?'隐藏流程列表':'查看流程列表')}})])],1),_vm._v(" "),(_vm.showProcessList)?_c('div',{staticClass:"_tab process-list"},[_c('el-card',{staticClass:"box-card"},[_vm._l((_vm.processList),function(n){return [_c('li',{staticClass:"_item",class:{'active':(_vm.curFlowId==n.id)},on:{"click":function($event){return _vm.processClick(n,$event)}}},[_c('span',{staticClass:"label label-info",domProps:{"textContent":_vm._s(!n.isSub?'主':'')}}),_vm._v(" "),_c('el-badge',{attrs:{"is-dot":n.id==_vm.originalFlowId}},[_c('span',{domProps:{"innerHTML":_vm._s(n.name)}})])],1)]})],2)],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = {
  name: 'MwDoubleFace',
  props: {
    readOnly: {
      type: Boolean,
      default: false } },


  template: '\n    <div @click="this.handleClick">\n      <div v-show="editable">\n        <slot name="editable"></slot>\n      </div>\n\n      <div v-show="!editable">\n        <slot name="readonly"></slot>\n      </div>\n    </div>\n  ',











  data: function data() {
    return {
      editable: false };

  },

  mounted: function mounted() {
    $(document.body).on('click', this.hijackClick);
  },

  beforeDestroy: function beforeDestroy() {
    $(document.body).off('click', this.hijackClick);
  },

  methods: {
    handleClick: function handleClick() {var _this = this;
      if (this.readOnly) return;
      this.editable = true;
      this.$nextTick(function () {
        $(_this.$el).find('input, textarea, select').focus();
      });
    },

    handleBlur: function handleBlur() {
      this.editable = false;
    },

    hijackClick: function hijackClick(e) {
      if (!this.editable) return;
      var target = e.target;
      var $target = $(target);

      if (!this.$el.contains(target)) {
        if ($target.parents('.el-select-dropdown,.el-picker-panel').length === 0) {
          this.handleBlur();
        }
      }
    } } };

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_serviceConsole_vue__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_serviceConsole_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_serviceConsole_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_serviceConsole_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_serviceConsole_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_26cc66fe_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_serviceConsole_vue__ = __webpack_require__(1278);
function injectStyle (ssrContext) {
  __webpack_require__(1277)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_serviceConsole_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_26cc66fe_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_serviceConsole_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticClass:"toolbar mw-toolbar"},[_c('el-radio',{attrs:{"label":"8878","border":""},model:{value:(_vm.serverPort),callback:function ($$v) {_vm.serverPort=$$v},expression:"serverPort"}},[_vm._v("本机本机")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"8877","border":""},model:{value:(_vm.serverPort),callback:function ($$v) {_vm.serverPort=$$v},expression:"serverPort"}},[_vm._v("全部日志")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.connect}},[_vm._v("连接")]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.clear}},[_vm._v("清空")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":_vm.close}},[_vm._v("断开连接")])],1),_vm._v(" "),_c('div',{ref:"container",staticClass:"server-log",staticStyle:{"height":"calc(100% - 60px)","width":"100%","background":"#555","color":"white","overflow":"auto"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalGroup_vue__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalGroup_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalGroup_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalGroup_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_e2f427ee_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_personalGroup_vue__ = __webpack_require__(1281);
function injectStyle (ssrContext) {
  __webpack_require__(1280)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e2f427ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalGroup_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_e2f427ee_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_personalGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-split-container"},[_c('mw-dialog',{ref:"dialog",attrs:{"size":"mini_mini","footerButton":_vm.btns,"close-on-click-modal":false,"title":"选择群组分类"}},[_c('mw-tree',{ref:"codeTree",attrs:{"url":_vm.groupTreeUrl,"defaultParams":_vm.defaultTreeParams,"autoLoad":false,"async":false,"expandedFirst":true,"selectFirst":true},on:{"dataFilter":_vm.treeDataFilter}})],1),_vm._v(" "),_c('mw-dialog',{ref:"titleDialog",attrs:{"title":_vm.form.id ? '编辑群组' : '新建群组',"close-on-click-modal":false}},[(_vm.toolbarPosition!='BOTTOM')?_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.closeTitleDialog}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(" "+_vm._s(_vm.$lang('关闭')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveTitle}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v("\n      "+_vm._s(_vm.$lang('保存')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[_c('mw-dialog',{ref:"unitDialog",attrs:{"size":"mini_small","title":"选择群组分类","footerButton":_vm.unitFooterButton,"close-on-click-modal":false}},[_c('mw-tree',{ref:"unitTree",attrs:{"url":_vm.unitTreeUrl,"defaultParams":_vm.defaultParams,"async":true,"expandedFirst":true,"selectFirst":true}})],1),_vm._v(" "),[_c('el-row',[_c('el-form',{ref:"ruleForm",attrs:{"label-width":"120px","model":_vm.form,"rules":_vm.formRules}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('所属单位'),"prop":"unitName"}},[_c('el-input',{staticStyle:{"width":"80%"},attrs:{"readonly":""},model:{value:(_vm.form.unitName),callback:function ($$v) {_vm.$set(_vm.form, "unitName", $$v)},expression:"form.unitName"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"label":_vm.$lang('所属单位ID')}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.unitId),callback:function ($$v) {_vm.$set(_vm.form, "unitId", $$v)},expression:"form.unitId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('群组分类'),"prop":"code"}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.showGroupCode()}}},[_vm._v(_vm._s(_vm.$lang('选择')))])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('群组名称'),"prop":"name"}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('群组序列')}},[_c('el-input-number',{staticStyle:{"width":"80%"},attrs:{"controls":false,"min":1},model:{value:(_vm.form.sn),callback:function ($$v) {_vm.$set(_vm.form, "sn", $$v)},expression:"form.sn"}})],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"span":24}},[_c('el-form-item',[_c('el-input',{attrs:{"type":"textarea","placeholder":_vm.$lang('请输入内容')},model:{value:(_vm.form.departmentids),callback:function ($$v) {_vm.$set(_vm.form, "departmentids", $$v)},expression:"form.departmentids"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('群组成员')}},[_c('div',{staticStyle:{"margin-bottom":"5px"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":_vm.$lang('请输入内容'),"readonly":""},model:{value:(_vm.form.departments),callback:function ($$v) {_vm.$set(_vm.form, "departments", $$v)},expression:"form.departments"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.usersLoad}},[_vm._v(_vm._s(_vm.$lang("选择")))]),_vm._v(" "),_c('loadUsers',{ref:"loadUsers",attrs:{"checkNodes":_vm.checkNodes,"showQJT":false,"unitId":_vm.form.unitId},on:{"closeDialog":_vm.getDeptUser}})],1),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","placeholder":_vm.$lang('请输入内容'),"readonly":""},model:{value:(_vm.form.users),callback:function ($$v) {_vm.$set(_vm.form, "users", $$v)},expression:"form.users"}})],1)],1),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('el-form-item',[_c('el-input',{attrs:{"type":"textarea","placeholder":_vm.$lang('请输入内容')},model:{value:(_vm.form.userids),callback:function ($$v) {_vm.$set(_vm.form, "userids", $$v)},expression:"form.userids"}})],1)],1),_vm._v(" "),(_vm.showGroupOutOrg)?_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('外部单位')}},[_c('el-input',{attrs:{"type":"textarea","placeholder":_vm.$lang('请输入内容')},model:{value:(_vm.form.externalUnit),callback:function ($$v) {_vm.$set(_vm.form, "externalUnit", $$v)},expression:"form.externalUnit"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.showOuterDept}},[_vm._v(_vm._s(_vm.$lang('选择')))])],1)],1):_vm._e()],1)],1)]],2),_vm._v(" "),(_vm.toolbarPosition=='BOTTOM')?_c('div',{staticClass:"mw-toolbar",staticStyle:{"text-align":"right"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveTitle}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v("\n        "+_vm._s(_vm.$lang('保存')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.closeTitleDialog}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(" "+_vm._s(_vm.$lang('关闭')))])],1):_vm._e()]),_vm._v(" "),_c('mw-dialog',{ref:"externalDept",attrs:{"title":"外部单位","footerButton":_vm.externalBtn,"close-on-click-modal":false}},[_c('div',{staticClass:"mw-toolbar__body"},[_c('p',{staticStyle:{"margin-top":"5px"}},[_vm._v("外部单位(多个以回车换行)")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 10, maxRows: 20},"width":"80%"},model:{value:(_vm.outerDept),callback:function ($$v) {_vm.outerDept=$$v},expression:"outerDept"}})],1)]),_vm._v(" "),_c('split-pane',{attrs:{"defaultSize":220,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag==1),expression:"expandFlag==1"}],attrs:{"size":"mini"},on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v(_vm._s(_vm.$lang('展开')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag!=1),expression:"expandFlag!=1"}],attrs:{"size":"mini"},on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v(_vm._s(_vm.$lang('折叠')))])],1),_vm._v(" "),_c('div',[_c('mw-tree',{ref:"groupTree",attrs:{"url":_vm.groupTreeUrl,"autoLoad":false,"async":true,"multipleLeaf":true,"dragEnable":true,"defaultParams":_vm.defaultTreeParams,"expandedFirst":true,"selectFirst":true},on:{"changed":_vm.changed}})],1)])]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"aa",attrs:{"layout":_vm.layout,"pagination":false}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.userInfo.unitAdmin ||!_vm.isLimit),expression:"userInfo.unitAdmin ||!isLimit"}],attrs:{"slot":"dropDown"},slot:"dropDown"},[_c('el-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.userInfo.unitAdmin ||!_vm.isLimit),expression:"userInfo.unitAdmin ||!isLimit"}],attrs:{"trigger":"hover"},on:{"command":_vm.handleSortCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n                 "+_vm._s(_vm.$lang('排序'))),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"sort"}},[_vm._v(_vm._s(_vm.$lang('排序')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"top"}},[_vm._v(_vm._s(_vm.$lang('置顶')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"bottom"}},[_vm._v(_vm._s(_vm.$lang('置底')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"up"}},[_vm._v(_vm._s(_vm.$lang('上移')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"down"}},[_vm._v(" "+_vm._s(_vm.$lang('下移')))])],1)],1)],1)])],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalOuterOrg_vue__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalOuterOrg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalOuterOrg_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalOuterOrg_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalOuterOrg_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2113b226_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_personalOuterOrg_vue__ = __webpack_require__(1284);
function injectStyle (ssrContext) {
  __webpack_require__(1283)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2113b226"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_personalOuterOrg_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2113b226_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_personalOuterOrg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel commonOuterOrg"},[_c('mw-dialog',{ref:"titleDialog",attrs:{"title":_vm.form.id ? _vm.$lang('编辑个人外单位') : _vm.$lang('新建个人外单位'),"close-on-click-modal":false}},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.closeTitleDialog}},[_c('i',{staticClass:"fa fa-mail-reply "}),_vm._v(" "+_vm._s(_vm.$lang('关闭')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveTitle}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v("\n        "+_vm._s(_vm.$lang('保存')))])],1),_vm._v(" "),_c('div',{staticClass:"mw-toolbar__body"},[[_c('el-row',[_c('el-form',{ref:"ruleForm",attrs:{"label-width":"130px","model":_vm.form,"rules":_vm.formRules}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('所属单位'),"prop":"unitName"}},[_c('el-input',{staticStyle:{"width":"80%"},attrs:{"readonly":""},model:{value:(_vm.form.unitName),callback:function ($$v) {_vm.$set(_vm.form, "unitName", $$v)},expression:"form.unitName"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"label":"所属单位ID"}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.unitId),callback:function ($$v) {_vm.$set(_vm.form, "unitId", $$v)},expression:"form.unitId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('外单位分类'),"prop":"code"}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('外单位名称'),"prop":"name"}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('外单位英文名称'),"prop":"name"}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.Englishname),callback:function ($$v) {_vm.$set(_vm.form, "Englishname", $$v)},expression:"form.Englishname"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('外单位序列')}},[_c('el-input-number',{staticStyle:{"width":"80%"},attrs:{"controls":false,"min":1},model:{value:(_vm.form.sn),callback:function ($$v) {_vm.$set(_vm.form, "sn", $$v)},expression:"form.sn"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$lang('外单位编号'),"prop":"identifier"}},[_c('el-input',{staticStyle:{"width":"80%"},model:{value:(_vm.form.identifier),callback:function ($$v) {_vm.$set(_vm.form, "identifier", $$v)},expression:"form.identifier"}})],1)],1)],1)],1)]],2)]),_vm._v(" "),_c('split-pane',{attrs:{"defaultSize":220,"split":"vertical"}},[_c('template',{slot:"paneL"},[_c('div',{staticClass:"mw-split-left"},[_c('div',{staticClass:"mw-toolbar"},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag==1),expression:"expandFlag==1"}],attrs:{"size":"mini"},on:{"click":_vm.expand}},[_c('i',{staticClass:"fa fa-angle-double-down"}),_vm._v(_vm._s(_vm.$lang('展开')))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.expandFlag!=1),expression:"expandFlag!=1"}],attrs:{"size":"mini"},on:{"click":_vm.closed}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_vm._v(_vm._s(_vm.$lang('折叠')))])],1),_vm._v(" "),_c('div',[_c('mw-tree',{ref:"groupTree",attrs:{"url":_vm.outerOrgTreeUrl,"autoLoad":false,"async":true,"multipleLeaf":true,"dragEnable":true,"defaultParams":_vm.defaultTreeParams,"expandedFirst":true,"selectFirst":true},on:{"changed":_vm.changed}})],1)])]),_vm._v(" "),_c('template',{slot:"paneR"},[_c('div',{staticClass:"mw-split-right"},[_c('toolbar-table',{ref:"aa",attrs:{"layout":_vm.layout,"pagination":false}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.userInfo.unitAdmin ||!_vm.isLimit),expression:"userInfo.unitAdmin ||!isLimit"}],attrs:{"slot":"dropDown"},slot:"dropDown"},[_c('el-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.userInfo.unitAdmin ||!_vm.isLimit),expression:"userInfo.unitAdmin ||!isLimit"}],attrs:{"trigger":"hover"},on:{"command":_vm.handleSortCommand}},[_c('el-button',{staticClass:"el-dropdown-link"},[_vm._v("\n               "+_vm._s(_vm.$lang('排序'))),_c('i',{staticClass:"el-icon-caret-bottom el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"mw-toolbar-dropdown",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"sort"}},[_vm._v(_vm._s(_vm.$lang('排序')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"top"}},[_vm._v(_vm._s(_vm.$lang('置顶')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"bottom"}},[_vm._v(_vm._s(_vm.$lang('置底')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"up"}},[_vm._v(_vm._s(_vm.$lang('上移')))]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"down"}},[_vm._v(" "+_vm._s(_vm.$lang('下移')))])],1)],1)],1)])],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f561c7c4_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1287);
function injectStyle (ssrContext) {
  __webpack_require__(1286)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f561c7c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f561c7c4_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel"},[_c('toolbar-table',{ref:"viewToolbarTable",attrs:{"pagination":_vm.pagination,"limit":_vm.limit,"layout":_vm.layout}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-panel mw-form-layout mw-process-manage"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showButton),expression:"showButton"}],staticClass:"__buttons"},[_c('div',{staticStyle:{"display":"inline-block","padding-left":"2px","padding-top":"2px","padding-right":"12px","font-size":"14px"}},[(_vm.curStatus==0)?_c('span',[_vm._v("设计")]):(_vm.curStatus==1)?_c('span',[_vm._v("启用")]):_c('span',[_vm._v("历史")]),_vm._v("("),_c('span',{domProps:{"textContent":_vm._s(_vm.curVersion)}}),_vm._v(".0)\n    ")])]),_vm._v(" "),_c('mw-dialog',{ref:"editFormDialog",attrs:{"title":"新建表单项","size":"mini_mini","appendToBody":true,"footerButton":_vm.editFormFooterButton}},[_c('el-form',{staticStyle:{"margin-top":"20px"},attrs:{"model":_vm.form,"label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"名称"}},[_c('el-input',{attrs:{"auto-complete":"off"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),(_vm.addFormItemFlag)?_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"关联表单"}},[_c('el-input',{staticStyle:{"width":"60%"},attrs:{"disabled":true},model:{value:(_vm.relateFormName),callback:function ($$v) {_vm.relateFormName=$$v},expression:"relateFormName"}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.relateSelectForm}},[_vm._v("选择")])],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"label":"关联表单"}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.form.id),callback:function ($$v) {_vm.$set(_vm.form, "id", $$v)},expression:"form.id"}})],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('mw-dialog',{ref:"formDialog",attrs:{"title":"表单管理","size":"small_large","appendToBody":true,"footerButton":_vm.footerFormButton}},[_c('ul',{staticClass:"process-list"},_vm._l((_vm.formList),function(item,index){return _c('li',{key:index,class:{list_bg:(item.id!=_vm.selKey),active:(item.id==_vm.selKey)},on:{"click":function($event){return _vm.selectForm(item.id)},"dblclick":function($event){return _vm.editSelectForm(item.id)}}},[_c('span',{domProps:{"textContent":_vm._s(item.name)}})])}),0)]),_vm._v(" "),_c('mw-dialog',{ref:"versionDialog",attrs:{"title":"表单版本管理","size":"small_large","appendToBody":true,"footerButton":_vm.footerButton}},[_c('ul',{staticClass:"process-list"},_vm._l((_vm.versionList),function(item,index){return _c('li',{key:index,class:{list_bg:(item.version!=_vm.selVersion),active:(item.version==_vm.selVersion)},on:{"click":function($event){return _vm.selectVersion(item.version,item.status,item.id)},"dblclick":_vm.editVersion}},[_c('span',{domProps:{"textContent":_vm._s(item.name)}}),_vm._v("("),_c('span',{domProps:{"textContent":_vm._s(item.version)}}),_vm._v(".0)\n        "),(item.status==0)?_c('span',{staticClass:"pull-right"},[_vm._v("设计")]):(item.status==1)?_c('span',{staticClass:"pull-right"},[_vm._v("启用")]):_c('span',{staticClass:"pull-right"},[_vm._v("历史")])])}),0)]),_vm._v(" "),_c('mw-dialog',{ref:"recycleBinDialog",attrs:{"title":"管理回收站","size":"small_large","appendToBody":true,"footerButton":_vm.recycleBinFooterButton}},[_c('ul',{staticClass:"process-list"},_vm._l((_vm.versionDelList),function(item,index){return _c('li',{key:index,class:{list_bg:(item.version!=_vm.selDelVersion),active:(item.version==_vm.selDelVersion)},on:{"click":function($event){return _vm.selectDelVersion(item.version,item.status,item.id)}}},[_c('span',{domProps:{"textContent":_vm._s(item.name)}}),_vm._v("("),_c('span',{domProps:{"textContent":_vm._s(item.version)}}),_vm._v(".0)\n      ")])}),0)]),_vm._v(" "),_c('mw-dialog',{ref:"revisionDialog",attrs:{"title":"修改记录","width":"900","height":"600"}},[_c('componentRevision',{ref:"revisionComp",attrs:{"componentId":_vm.formId},on:{"revert":_vm.formRevert}})],1),_vm._v(" "),_c('div',{staticClass:"mw-form_id mw-panel"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default =













function (Vue, parent, _data) {
  var backdrop = (0, _backdrop2.default)(Vue, parent, _data);
  var node_sub_proc = (0, _node_sub_proc2.default)(Vue, parent, _data);
  var node_serial = (0, _node_serial2.default)(Vue, parent, _data);
  var node_parallel = (0, _node_parallel2.default)(Vue, parent, _data);
  var node_normal = (0, _node_normal2.default)(Vue, parent, _data);
  var node_end = (0, _node_end2.default)(Vue, parent, _data);
  var node_start = (0, _node_start2.default)(Vue, parent, _data);
  var line_normal = (0, _line_normal2.default)(Vue, parent, _data);

  var node_circular = (0, _node_circular2.default)(Vue, parent, _data);
  var node_fork_serial = (0, _node_fork_serial2.default)(Vue, parent, _data);
  var node_fork_parallel = (0, _node_fork_parallel2.default)(Vue, parent, _data);
  var node_fork_join = (0, _node_fork_join2.default)(Vue, parent, _data);
  var node_dynamic = (0, _node_dynamic2.default)(Vue, parent, _data);

  var nodeParams = {};
  var lineParams = {};
  var content = {};
  var config = parent.config;
  if (config && config.formId && config.content && config.content[config.formId]) {
    content = config.content[config.formId];
  }

  var backdropParams = {
    editable: parent.editable,
    key: _data.data.key,
    content: content };

  var types = [];
  parent.activityTypes.map(function (v) {
    var s = v.split("|");
    types.push({ label: s[0], value: s[1] });
  });
  nodeParams.sysId = parent.sysId;
  nodeParams.applicationId = _data.data.applicationId || parent.appId;
  nodeParams.processDefinitionId = _data.data.id;
  nodeParams.editable = parent.editable;
  nodeParams.moduleId = parent.moduleId;
  if (config) {
    nodeParams.flowMarks = config.flowMarks || "";
    lineParams.flowMarks = config.flowMarks || "";
  }
  lineParams.processDefinitionId = _data.data.id;
  lineParams.applicationId = _data.data.applicationId || parent.appId;
  lineParams.editable = parent.editable;
  lineParams.moduleId = parent.moduleId;
  nodeParams.changeType = function (val) {
    parent.$configVue.type = 'node-' + val;
  };
  nodeParams.activityTypes = types;
  nodeParams.processDataItems = _data.data.items;

  lineParams.processDataItems = _data.data.items;

  parent.$configVue = new Vue({
    el: '#mw-process-chart-config',
    template: '<div id="mw-process-chart-config"><component :is="type" :data="data" :params="params"></component></div>',
    components: {
      'backdrop': backdrop,
      'node-sub-proc': node_sub_proc,
      'node-serial': node_serial,
      'node-parallel': node_parallel,
      'node-normal': node_normal,
      'node-end': node_end,
      'node-start': node_start,
      'line-normal': line_normal,
      'node-circular': node_circular,
      'node-fork-serial': node_fork_serial,
      'node-fork-parallel': node_fork_parallel,
      'node-fork-join': node_fork_join,
      'node-dynamic': node_dynamic },

    data: function data() {
      return {
        type: '',
        data: {},
        params: {} };

    },
    mounted: function mounted() {
      var me = this;
      var processData = _data.data;
      me.type = 'backdrop';
      me.data = processData.parameters;

      if (config.fieldMapping.businessName == undefined) {
        this.$set(me.data, 'businessName', '');
      } else {
        this.$set(me.data, 'businessName', config.fieldMapping.businessName);
      }
      if (config.fieldMapping.businessKeyword == undefined) {
        this.$set(me.data, 'businessKeyword', '');
      } else {
        this.$set(me.data, 'businessKeyword', config.fieldMapping.businessKeyword);
      }
      if (config.fieldMapping.businessCategory == undefined) {
        this.$set(me.data, 'businessCategory', '');
      } else {
        this.$set(me.data, 'businessCategory', config.fieldMapping.businessCategory);
      }
      if (config.fieldMapping.urgencyLevel == undefined) {
        this.$set(me.data, 'urgencyLevel', '');
      } else {
        this.$set(me.data, 'urgencyLevel', config.fieldMapping.urgencyLevel);
      }
      backdropParams.id = processData.id;
      me.params = backdropParams;


      var items = processData.items;

      var activity = items.ACTIVITY;
      var sequence = items['SEQUENCE-FLOW'];
      parent.$off([['node:append', 'node:remove', 'node:click', 'line:update', 'line:append', 'line:remove', 'line:click', 'backdrop:click', 'clear']]);


      parent.$on('node:append', function (data) {
        var n = { id: data.id, extends: data.type, parameters: { id: data.id, type: data.type } };
        activity.push(n);
      });


      parent.$on('node:remove', function (data) {
        for (var i = 0; i < activity.length; i++) {
          var v = activity[i];
          if (v.id == data.id) {
            activity.splice(i, 1);
            break;
          }
        }
      });


      parent.$on('node:click', function (data) {
        for (var i = 0; i < activity.length; i++) {
          var v = activity[i];
          if (v.id == data.id) {
            me.type = 'node-' + v.parameters.type;

            if (v.parameters.name == undefined) {
              delete v.parameters.name;
            }
            me.data = v.parameters;
            me.params = nodeParams;
            break;
          }
        }
      });


      parent.$on('line:append', function (data) {
        data.type = 'normal';
        var from = data.sourceShapeId;
        var to = data.targetShapeId;
        var n = {
          id: data.id,
          sourceId: from,
          targetId: to,
          type: data.type,
          tip: data.tip,
          parameters: { id: data.id, from: from, to: to, type: data.type, tip: data.tip } };

        sequence.push(n);
      });

      parent.$on('line:update', function (data) {
        var from = data.sourceShapeId;
        var to = data.targetShapeId;
        for (var i = 0; i < sequence.length; i++) {
          var v = sequence[i];


          v.sourceId = from;
          v.targetId = to;


          if (v.id == data.id) {
            me.type = 'line-normal';
            if (v.parameters.name == undefined) {
              delete v.parameters.name;
            }
            v.parameters.from = from;
            v.parameters.to = to;

            me.data = v.parameters;
            var fromFlag = false;
            var toFlag = false;
            for (var j = 0; j < activity.length; j++) {
              var a = activity[j];

              if (!fromFlag && a.id == me.data.from) {
                lineParams.fromName = a.parameters.name;
                fromFlag = true;
              }
              if (!toFlag && a.id == me.data.to) {
                lineParams.toName = a.parameters.name;
                toFlag = true;
              }
              if (fromFlag && toFlag) {
                break;
              }
            }
            me.params = lineParams;
            break;
          }
        }

      });


      parent.$on('line:remove', function (data) {
        for (var i = 0; i < sequence.length; i++) {
          var v = sequence[i];
          if (v.id == data.id) {
            sequence.splice(i, 1);
            break;
          }
        }
      });


      parent.$on('line:click', function (data) {

        for (var i = 0; i < sequence.length; i++) {
          var v = sequence[i];
          if (v.id == data.id) {
            me.type = 'line-normal';
            if (v.parameters.name == undefined) {
              delete v.parameters.name;
            }
            me.data = v.parameters;
            var fromFlag = false;
            var toFlag = false;
            for (var j = 0; j < activity.length; j++) {
              var a = activity[j];

              if (!fromFlag && a.id == me.data.from) {
                lineParams.fromName = a.parameters.name;
                fromFlag = true;
              }
              if (!toFlag && a.id == me.data.to) {
                lineParams.toName = a.parameters.name;
                toFlag = true;
              }
              if (fromFlag && toFlag) {
                break;
              }
            }
            me.params = lineParams;
            break;
          }
        }
      });


      parent.$on('backdrop:click', function (data) {
        me.type = 'backdrop';
        me.data = processData.parameters;
        me.params = backdropParams;
      });

      parent.$on('clear', function (data) {
        items.ACTIVITY = [];
        activity = items.ACTIVITY;
        items['SEQUENCE-FLOW'] = [];
        sequence = items['SEQUENCE-FLOW'];
      });


    } });


};var _backdrop = __webpack_require__(1290);var _backdrop2 = _interopRequireDefault(_backdrop);var _node_sub_proc = __webpack_require__(1291);var _node_sub_proc2 = _interopRequireDefault(_node_sub_proc);var _node_serial = __webpack_require__(1292);var _node_serial2 = _interopRequireDefault(_node_serial);var _node_parallel = __webpack_require__(1293);var _node_parallel2 = _interopRequireDefault(_node_parallel);var _node_normal = __webpack_require__(1294);var _node_normal2 = _interopRequireDefault(_node_normal);var _node_end = __webpack_require__(1295);var _node_end2 = _interopRequireDefault(_node_end);var _node_start = __webpack_require__(1296);var _node_start2 = _interopRequireDefault(_node_start);var _line_normal = __webpack_require__(1297);var _line_normal2 = _interopRequireDefault(_line_normal);var _node_circular = __webpack_require__(1298);var _node_circular2 = _interopRequireDefault(_node_circular);var _node_fork_serial = __webpack_require__(1299);var _node_fork_serial2 = _interopRequireDefault(_node_fork_serial);var _node_fork_parallel = __webpack_require__(1300);var _node_fork_parallel2 = _interopRequireDefault(_node_fork_parallel);var _node_fork_join = __webpack_require__(1301);var _node_fork_join2 = _interopRequireDefault(_node_fork_join);var _node_dynamic = __webpack_require__(1302);var _node_dynamic2 = _interopRequireDefault(_node_dynamic);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (Vue, parent, _data) {
  var backdrop = {
    template: '\n    <div class=\'__config__body\'>\n      <div class="_key">ID:&nbsp;<span v-text="params[\'id\']"></span></div>\n      <el-collapse v-model="activeName" accordion>\n        <el-collapse-item title="\u57FA\u672C\u5C5E\u6027" name="1">\n           <el-form  label-width="65px">\n              <el-form-item label="\u6D41\u7A0B\u6807\u8BC6" v-show="false">\n                  <el-input v-model="data[\'id\']" :disabled="true">\n                  </el-input>\n              </el-form-item>\n              <el-form-item label="\u6D41\u7A0BKEY\uFF1A">\n                  <!--<el-input v-model="params[\'key\']" :disabled="true">-->\n                  <!--</el-input>-->\n                  <span v-text="params[\'key\']"></span>\n              </el-form-item>\n              <!--<el-form-item label="\u6D41\u7A0B\u5206\u7C7B\uFF1A">\n                  <el-input v-model="data[\'category\']">\n                  </el-input>\n              </el-form-item>-->\n              <el-form-item label="\u6D41\u7A0B\u540D\u79F0\uFF1A">\n                  <el-input v-model="data[\'name\']" ></el-input>\n              </el-form-item>\n              <!--<el-form-item label="\u6D41\u7A0B\u7B80\u79F0\uFF1A">\n                  <el-input v-model="data[\'simpleName\']" ></el-input>\n              </el-form-item>\n              <el-form-item label="\u6D41\u7A0B\u5E8F\u53F7\uFF1A">\n                  <el-input v-model="data[\'sn\']" ></el-input>\n              </el-form-item>-->\n              <el-form-item label="\u9002\u7528\u8303\u56F4\uFF1A">\n                  <el-input v-model="data[\'scopeName\']" :disabled="true" style="width:65%"></el-input>\n                  <el-button type="primary" @click="showUnit">\u9009\u62E9</el-button>\n              </el-form-item>\n\n              <el-form-item label="\u9002\u7528\u8303\u56F4\uFF1A" v-show="false">\n                  <el-input v-model="data[\'scope\']" :disabled="true"></el-input>\n              </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u4EFB\u52A1\u6620\u5C04" name="2">\n             <el-form  label-width="65px">\n                <el-form-item label="\u9898\u540D\uFF1A">\n                  <el-select v-model="data[\'businessName\']" clearable filterable  key="businessName">\n                    <el-option :label="item.name" :value="item.id" :key="item.id+\'1\'" v-for="item in fieldItems"></el-option>\n                  </el-select>\n                </el-form-item>\n\n                <el-form-item label="\u5173\u952E\u5B57\uFF1A">\n                  <el-select v-model="data[\'businessKeyword\']" clearable  filterable  key="businessKeyword">\n                    <el-option :label="item.name" :value="item.id" :key="item.id+\'2\'" v-for="item in fieldItems"></el-option>\n                  </el-select>\n                </el-form-item>\n\n                <el-form-item label="\u4E1A\u52A1\u5206\u7C7B\uFF1A">\n                  <el-select v-model="data[\'businessCategory\']" clearable filterable  key="businessCategory">\n                    <el-option :label="item.name" :value="item.id" :key="item.id+\'3\'" v-for="item in fieldItems"></el-option>\n                  </el-select>\n                </el-form-item>\n\n                <el-form-item label="\u7D27\u6025\u7A0B\u5EA6\uFF1A">\n                  <el-select v-model="data[\'urgencyLevel\']" clearable  filterable  key="urgencyLevel">\n                    <el-option :label="item.name" :value="item.id" :key="item.id+\'4\'" v-for="item in fieldItems"></el-option>\n                  </el-select>\n                </el-form-item>\n                <el-form-item label="\u6269\u5C55\u5B57\u6BB51:">\n                  <el-select v-model="data[\'businessField0\']" clearable  filterable  key="businessField0">\n                    <el-option :label="item.name" :value="item.id" :key="item.id+\'5\'" v-for="item in fieldItems"></el-option>\n                  </el-select>\n                </el-form-item>\n                <el-form-item label="\u6269\u5C55\u5B57\u6BB52:">\n                  <el-select v-model="data[\'businessField1\']" clearable  filterable  key="businessField1">\n                    <el-option :label="item.name" :value="item.id" :key="item.id+\'6\'" v-for="item in fieldItems"></el-option>\n                  </el-select>\n                </el-form-item>\n             </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u5206\u53D1\u8BBE\u7F6E" name="3" class="__btn">\n             <el-form  label-width="65px">\n                <el-form-item label="\u63A5\u6536\u5355\u4F4D\uFF1A">\n                  <el-button type="primary" @click="showApp(\'disDefUnit\')">\u9009\u62E9\u9ED8\u8BA4\u5E94\u7528</el-button>\n                </el-form-item>\n                <div  style="padding:5px;padding-bottom:2px;margin-bottom:2px;border:1px #ddd solid" v-show="data.disDefUnit.length>0">\n                   \u9ED8\u8BA4\u5E94\u7528\uFF1A<el-button  :key="it.id" v-for="it in data.disDefUnit">{{it.name}}\n                   </el-button>\n                </div>\n                <table class="inner_table">\n                  <colgroup>\n                    <col style="width:108px">\n                    <col style="width:108px">\n                    <col style="width:39px">\n                  </colgroup>\n                  <tbody>\n                    <tr><th>\u5355\u4F4D</th><th>\u5E94\u7528</th><th><i class="fa fa-plus-square" @click="addDisUnit()" title="\u65B0\u589E"></i></th></tr>\n                    <tr :key="idx" v-for="(it,idx) in data.disUnit">\n                    <td><input type=\'text\' readonly :title="it[\'un\']" @focus="showDisUnit(idx,\'unit\')" v-model="it[\'un\']"/></td>\n                    <td><input type=\'text\' readonly :title="it[\'an\']" @focus="showApp(\'unit\',idx)" v-model="it[\'an\']"/></td>\n                    <td><i class="fa fa-minus-square" @click="delDisUnit(idx)"></i></td>\n                    </tr>\n                  </tbody>\n                </table>\n             </el-form>\n             <el-form  label-width="65px">\n                <el-form-item label="\u63A5\u6536\u90E8\u95E8\uFF1A">\n                  <el-button type="primary" @click="showApp(\'disDefDept\')">\u9009\u62E9\u9ED8\u8BA4\u5E94\u7528</el-button>\n                </el-form-item>\n                <div  style="padding:5px;margin-bottom:2px;padding-bottom:2px;border:1px #ddd solid" v-show="data.disDefDept.length>0">\n                   \u9ED8\u8BA4\u5E94\u7528\uFF1A<el-button  :key="it.id" v-for="it in data.disDefDept">{{it.name}}\n                   </el-button>\n                </div>\n                <table class="inner_table">\n                  <colgroup>\n                    <col style="width:108px">\n                    <col style="width:108px">\n                    <col style="width:39px">\n                  </colgroup>\n                  <tbody>\n                    <tr><th>\u5355\u4F4D</th><th>\u5E94\u7528</th><th><i class="fa fa-plus-square" @click="addDisDept()" title="\u65B0\u589E"></i></th></tr>\n                    <tr :key="idx" v-for="(it,idx) in data.disDept">\n                    <td><input type=\'text\' readonly :title="it[\'un\']" @focus="showDisUnit(idx,\'dept\')" v-model="it[\'un\']"/></td>\n                    <td><input type=\'text\' readonly :title="it[\'an\']"  @focus="showApp(\'dept\',idx)" v-model="it[\'an\']"/></td>\n                    <td><i class="fa fa-minus-square" @click="delDisDept(idx)"></i></td>\n                    </tr>\n                  </tbody>\n                </table>\n             </el-form>\n             <el-form  label-width="95px">\n                <el-form-item label="\u4E2A\u4EBA\u63A5\u6536\u5E94\u7528\uFF1A">\n                  <el-button type="primary" @click="showApp(\'disPersonal\')">\u9009\u62E9</el-button>\n                </el-form-item>\n                <div  style="padding:5px;padding-bottom:2px;border:1px #ddd solid" v-show="data.disPersonal.length>0">\n                   <el-button  :key="it.id" v-for="it in data.disPersonal">{{it.name}}\n                   </el-button>\n                </div>\n             </el-form>\n             <el-form  label-width="65px">\n                <el-form-item label="\u5B57\u6BB5\u5BF9\u5E94\uFF1A">\n                </el-form-item>\n                <table class="inner_table">\n                  <colgroup>\n                    <col style="width:108px">\n                    <col style="width:108px">\n                    <col style="width:39px">\n                  </colgroup>\n                  <tbody>\n                    <tr><th>\u63A5\u6536\u8868\u5355\u5B57\u6BB5</th><th>\u53D6\u503C\u8868\u8FBE\u5F0F</th><th><i class="fa fa-plus-square" @click="addMapping()" title="\u65B0\u589E"></i></th></tr>\n                    <tr :key="idx" v-for="(it,idx) in data.disMapping">\n                    <td><input type=\'text\' v-model="it[\'f\']"/></td>\n                    <td><input type=\'text\' v-model="it[\'t\']"/></td>\n                    <td><i class="fa fa-minus-square" @click="delMapping(idx)"></i></td>\n                    </tr>\n                  </tbody>\n                </table>\n             </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u5176\u4ED6" name="4">\n           <el-form  label-width="80px">\n           <el-form-item label="\u79FB\u52A8\u7AEF\u65B0\u542F:" >\n                <el-radio-group v-model="data[\'mobileNewApp\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                 </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u6267\u884C\u811A\u672C\uFF1A">\n                <el-button type="primary" @click="showFlowScriptSet(\'process\')">\u8BBE\u7F6E</el-button>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n      </el-collapse>\n</div>\n    ',








































































































































































    props: {
      data: {
        type: Object },

      params: {
        type: Object } },


    data: function data() {
      return {
        activeName: '1',
        fieldItems: [] };

    },
    created: function created() {



      if (this.data.disPersonal == undefined) {
        this.$set(this.data, 'disPersonal', []);
      }
      if (this.data.disUnit == undefined) {
        this.$set(this.data, 'disUnit', []);
      }
      if (this.data.disDept == undefined) {
        this.$set(this.data, 'disDept', []);
      }

      if (this.data.disDefUnit == undefined) {
        this.$set(this.data, 'disDefUnit', []);
      }
      if (this.data.disDefDept == undefined) {
        this.$set(this.data, 'disDefDept', []);
      }

      if (this.data.disMapping == undefined) {
        this.$set(this.data, 'disMapping', []);
      }
      if (this.data.mobileNewApp == undefined) {
        this.$set(this.data, 'mobileNewApp', 1);
      }
      if (this.params.content && this.params.content.items) {
        this.getFields(this.params.content.items);
      }
    },
    mounted: function mounted() {
      var me = this;
    },

    methods: {
      delDisUnit: function delDisUnit(idx) {
        this.data.disUnit.splice(idx, 1);
      },
      addDisUnit: function addDisUnit() {
        var me = this;
        me.data.disUnit.push({ u: '', un: '', a: '', an: '' });
      },
      delDisDept: function delDisDept(idx) {
        this.data.disDept.splice(idx, 1);
      },
      addDisDept: function addDisDept() {
        var me = this;
        me.data.disDept.push({ u: '', un: '', a: '', an: '' });
      },

      delMapping: function delMapping(idx) {
        this.data.disMapping.splice(idx, 1);
      },
      addMapping: function addMapping() {
        var me = this;
        me.data.disMapping.push({ f: '', t: '' });
      },
      showDisUnit: function showDisUnit(idx, type) {
        var me = this;
        var val = [];
        var data;
        if (type == 'unit') {
          data = me.data.disUnit[idx];
        } else if (type == 'dept') {
          data = me.data.disDept[idx];
        }
        if (data.u.trim() !== '') {
          var u = data.u.split(",");
          var un = data.un.split(",");
          for (var i = 0; i < u.length; i++) {
            val.push({ id: u[i], name: un[i] });
          }
        }
        PF.show('orgSelect', {
          config: {
            getConfig: function getConfig() {
              return {
                "LO": false,
                "userStrDelimiter": "#",
                "departmentNameProperty": "name",
                "hideLabel": true,
                "COO": false,
                "departmentStrDelimiter": "#",
                "xtype": "DepartmentUserSelection",
                "displayDelimiter": ",",
                "CG": false,
                "GO": true,
                "DO": false,
                "SO": false,
                "bodyStyle": {},
                "label": "接收单位",
                "POO": false,
                "dataMode": "2",
                "SOO": true,
                "labelAlign": "left",
                "PG": false,
                "activeTab": "全系统",
                "sizeCls": "large",
                "xtypeName": "机构及人员",
                "visible": true,
                "isFormField": true };

            } }, value: { DEP: val, DISPLAYNAME: val } }, function (res) {
          if (res.DEP.length > 0) {
            var u = [];
            var un = [];
            res.DEP.forEach(function (item) {
              u.push(item.id);
              un.push(item.name);
            });
            data.u = u.join();
            data.un = un.join();
          }
        });
      },
      showDisDept: function showDisDept() {
        var me = this;
        PF.show('orgSelect', {
          config: {
            getConfig: function getConfig() {
              return {
                "LO": true,
                "departmentNameProperty": "name",
                "hideLabel": true,
                "COO": false,
                "xtype": "DepartmentUserSelection",
                "displayDelimiter": ",",
                "CG": false,
                "GO": true,
                "bodyStyle": {},
                "label": "接收部门",
                "POO": false,
                "dataMode": "2",
                "labelAlign": "left",
                "PG": false,
                "activeTab": "本单位",
                "sizeCls": "large",
                "xtypeName": "机构及人员",
                "visible": true,
                "isFormField": true };

            } }, value: { DEP: me.data.disDept } }, function (data) {
          var dept = [];
          if (data.DEP.length > 0) {
            data.DEP.forEach(function (item) {
              dept.push({ id: item.id, name: item.name });
            });
          }
          me.data.disDept = dept;
        });
      },
      showApp: function showApp(type, idx) {
        var categories = 'module_flow';
        if ("disPersonal" == type) {
          categories = 'module_flow,module_normal';
        }
        var me = this;
        PF.show('treeTable',
        { url: PF.url("/api/app/listApplicationTreeByCategory"),
          treeDefaultParams: { categories: categories },
          selectFirst: true,
          clearBtn: true,
          changed: function changed(data) {
            var me = this;
            if (data.applicationId)
            me.defaultParams = { applicationId: data.applicationId, categories: categories };else

            me.defaultParams = { owner: data.id, categories: categories };
          },
          api: 'app.listApplicationItemsByCategory',
          singleSelect: true },

        function (res) {
          var items = [];
          if (res && res.length > 0) {
            res.forEach(function (it) {
              items.push({ id: it.id, name: it.name });
            });
          }
          var data;
          if (type == 'unit') {
            data = me.data.disUnit[idx];
            if (items.length > 0) {
              data.a = items[0].id;
              data.an = items[0].name;
            } else {
              data.a = '';
              data.an = '';
            }
          } else if (type == 'dept') {
            data = me.data.disDept[idx];
            if (items.length > 0) {
              data.a = items[0].id;
              data.an = items[0].name;
            } else {
              data.a = '';
              data.an = '';
            }
          } else {
            me.data[type] = items;
          }
        });
      },
      showUnit: function showUnit() {
        var me = this,checkNodes = [];

        if (me.data['scope']) {
          checkNodes = me.data['scope'].split(',');
        }
        PF.show('tree', { url: this.mwUrl("/api/org/getUnitTree"), checkNodes: checkNodes, search: false, multiple: true, singleLeaf: false, clearBtn: true, multipleLeaf: false }, function (res) {
          var scopeName = [];
          var scope = [];
          res.forEach(function (item) {
            scopeName.push(item.name);
            scope.push(item.id);
          });

          me.$set(me.data, 'scopeName', scopeName.join(','));
          me.$set(me.data, 'scope', scope.join(','));
        });
      },
      showFlowScriptSet: function showFlowScriptSet(type) {
        var me = this;
        var p = {};
        p.size = 'small_large';
        p.type = type;

        var scriptActions = me.data.scriptActions;
        if (scriptActions) {
          p.scriptActions = scriptActions;
        } else {
          p.scriptActions = {};
        }
        PF.show('flowScriptSet', p, function (res) {
          me.$set(me.data, 'scriptActions', res);
        });
      },
      getFields: function getFields(items) {
        var me = this;
        items.forEach(function (it) {
          if (it.isFormField) {
            if (it.name)
            me.fieldItems.push({ id: it.name, name: it.label });else

            me.fieldItems.push({ id: it.id, name: it.label });
          } else {
            if (it.items) {
              me.getFields(it.items);
            }
          }
        });
      } } };


  return backdrop;
};

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _stringify = __webpack_require__(24);var _stringify2 = _interopRequireDefault(_stringify);exports.default = function (Vue, parent, _data) {
  var node_sub_proc = {
    template: '\n    <div class=\'__config__body\'> \n      <el-collapse v-model="activeName" accordion>\n        <el-collapse-item title="\u57FA\u672C\u5C5E\u6027" name="1">\n           <el-form label-width="65px">\n            <el-form-item label="\u552F\u4E00\u6807\u8BC6\uFF1A" v-show=false>\n                <el-input v-model="data[\'id\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u540D\u79F0\uFF1A">\n                <el-input v-model="data[\'name\']" :disabled="!params.editable"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u5E8F\u53F7\uFF1A">\n                <el-input v-model="data[\'sn\']"></el-input>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u6D41\u7A0B\u63A7\u5236" name="2">\n           <el-form label-width="92px">\n            <el-form-item label="\u8282\u70B9\u7C7B\u578B\uFF1A">\n                <el-select @change=\'changeType\' v-model="data[\'type\']" :disabled="!params.editable">\n                  <el-option\n                    v-for="item in types"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u76EE\u6807\u6D41\u7A0B\uFF1A" v-show="data[\'type\'] === \'sub-proc\'">\n                <el-input v-model="data[\'subProcessDefName\']" style="width:60%;" :disabled="true"></el-input>\n                <el-button type="primary" @click="showSubProcess">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u76EE\u6807\u6D41\u7A0B" v-show="false">\n                <el-input v-model="data[\'subProcessDefKey\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u76EE\u6807\u6D41\u7A0B\u6A21\u5757" v-show="false">\n                <el-input v-model="data[\'subProcessModuleId\']" :disabled="true"></el-input>\n                <el-input v-model="data[\'subProcessApplicationId\']" :disabled="true"></el-input>\n            </el-form-item>\n            \n            <el-form-item label="\u76EE\u6807\u8282\u70B9\uFF1A" v-show="data[\'type\'] === \'sub-proc\'">\n                <el-input v-model="data[\'subProcessStartActivityName\']" style="width:60%;" :disabled="true"></el-input>\n                <el-button type="primary" @click="showSubProcessNode">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u76EE\u6807\u8282\u70B9" v-show="false">\n                <el-input v-model="data[\'subProcessStartActivityId\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u529E\u7406\u90E8\u95E8\uFF1A">\n                <el-select v-model="data[\'groupType\']">\n                  <el-option\n                    v-for="item in groupTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u76F8\u5BF9\u90E8\u95E8\uFF1A" v-show="data[\'groupType\'] === \'relative\' ">\n                <el-input v-model="data[\'relativeGroupName\']" style="width:60%;" :disabled="true"></el-input>\n                <el-button type="primary" @click="showDept">\u9009\u62E9</el-button>\n            </el-form-item>\n             <el-form-item label="\u76F8\u5BF9\u90E8\u95E8" v-show="false">\n                  <el-input v-model="data[\'relativeGroup\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u5B57\u6BB5\uFF1A"  v-show="data[\'groupType\'] === \'biz\' ">\n                <el-input v-model="data[\'groupField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'groupType\'] === \'handled-group\' ">\n                <el-input v-model="data[\'groupHandledActName\']"  :disabled="true" style="width:60%;"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'groupHandled\', name:\'groupHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'groupHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n              <el-form-item label="\u90E8\u95E8\u8303\u56F4\uFF1A">\n                <el-select v-model="data[\'group\']">\n                  <el-option\n                    v-for="item in groups"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u529E\u7406\u7528\u6237\uFF1A">\n                <el-select v-model="data[\'userType\']">\n                  <el-option\n                    v-for="item in userTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n\n            <el-form-item label="\u7528\u6237\u6743\u9650\uFF1A" v-show="data[\'userType\'] === \'role\' ">\n              <el-input v-model="data[\'userRoleName\']" style="width:60%" :disabled="true"></el-input>\n              <el-button type="primary" @click="showRole({id:\'userRole\', name:\'userRoleName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u6743\u9650" v-show="false">\n              <el-input v-model="data[\'userRole\']" :disabled="true"></el-input>\n            </el-form-item>\n\n            <el-form-item label="\u7528\u6237\u5B57\u6BB5\uFF1A" v-show="data[\'userType\']=== \'biz\' ">\n                <el-input v-model="data[\'userField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'userType\'] === \'handled-user\' ">\n                <el-input v-model="data[\'userHandledActName\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'userHandled\', name:\'userHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'userHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u6392\u9664\u6761\u4EF6\uFF1A">\n              <el-radio-group v-model="data[\'excludeSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u6392\u9664\u8303\u56F4\uFF1A" v-show="data[\'excludeSwitch\']== \'1\' ">\n                <el-select v-model="data[\'excludeType\']">\n                  <el-option\n                    v-for="item in excludeTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n          </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u8868\u5355\u63A7\u5236" name="3" >\n           <el-form  label-width="85px">\n            <el-form-item label="\u5B50\u6D41\u7A0B\u8868\u5355\uFF1A">\n               <el-radio-group v-model="data[\'subProcessFormSwitch\']" size="mini">\n                <el-radio-button label="1">\u542F\u7528</el-radio-button>\n                <el-radio-button label="0">\u7981\u6B62</el-radio-button>\n                </el-radio-group> \n            </el-form-item>\n            <el-form-item label="\u8868\u5355\u57DF\u6620\u5C04\uFF1A" v-show="data[\'subProcessFormSwitch\']==\'1\' && null!=data[\'subProcessModuleId\'] && data[\'subProcessModuleId\'].length>0">\n                <el-button type="primary" @click="showFormFieldMapping()">\u8BBE\u7F6E</el-button>\n            </el-form-item>\n            <el-form-item label="\u8868\u5355\u57DF\u6620\u5C04" v-show="false">\n                <el-input v-model="data[\'subProcessFormFieldMapping\']" :disabled="true"></el-input>\n            </el-form-item>\n           </el-form>\n        </el-collapse-item>\n      </el-collapse>\n      </div>\n    ',





















































































































































    props: {
      data: {
        type: Object },

      params: {
        type: Object } },


    data: function data() {
      return {
        fields: ['id', 'name', 'type', 'sn', 'type', 'groupType', 'group', 'relativeGroup', 'relativeGroupName',
        'groupField', 'groupHandled', 'groupHandledActName', 'userType', 'userRole', 'userRoleName', 'userField', 'userHandledActName',
        'userHandled', 'excludeSwitch', 'subProcessDefKey', 'subProcessDefName', 'subProcessModuleId', 'subProcessApplicationId',
        'subProcessStartActivityId', 'subProcessStartActivityName', 'excludeType', 'subProcessFormSwitch', 'subProcessFormFieldMapping'],

        activeName: '1',
        types: [],
        groupTypes: [{ value: 'role', label: '权限' }, { value: 'relative', label: '相对部门' }, { value: 'handled-group', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'upper-group', label: '发送部门' }, { value: 'draft-group', label: '发起部门' }],
        groups: [{ value: '<当前>', label: '<当前>' }, { value: '<上级>', label: '<上级>' }, { value: '<下级>', label: '<下级>' }, { value: '<平级>', label: '<平级>' },
        { value: '<当前和上级>', label: '<当前和上级>' }, { value: '<当前和下级>', label: '<当前和下级>' },
        { value: '<所有下级>', label: '<所有下级>' }, { value: '<上级的平级>', label: '<上级的平级>' },
        { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<部门上级>', label: '<部门上级>' }, { value: '<部门下级>', label: '<部门下级>' }, { value: '<部门平级>', label: '<部门平级>' },
        { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<本单位任选(不包含下级)>', label: '<本单位任选(不包含下级)>' },
        { value: '<本单位的一级部门>', label: '<本单位的一级部门>' }, { value: '<单位上级>', label: '<单位上级>' }, { value: '<单位平级>', label: '<单位平级>' },
        { value: '<上级单位部门>', label: '<上级单位部门>' }, { value: '<上级单位任选>', label: '<上级单位任选>' }],
        userTypes: [{ value: 'role', label: '权限' }, { value: 'handled-user', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'draft-user', label: '发起人' }, { value: 'upper-user', label: '发送人' }],
        excludeTypes: [{ value: 'current-user', label: '当前用户' }, { value: 'current-dep', label: '当前部门' }] };

    },
    created: function created() {
      var me = this;
      me.clearField();
      me.types = me.params.activityTypes;
      me.initData();
    },
    watch: {
      'data.name': function dataName(val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", { id: me.data.id, name: val });
        }
      },
      'data.id': function dataId(val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name;
          this.$set(this.data, 'name', '新增节点');
        }
        this.initData();
      } },

    methods: {
      initData: function initData() {
        var me = this;
        if (me.data.name == undefined) {
          this.$set(me.data, 'name', '新增节点');
        }
        if (this.data.excludeSwitch == undefined) {
          this.$set(this.data, 'excludeSwitch', '0');
        }

        if (this.data.type == undefined) {
          this.$set(this.data, 'type', 'sub-proc');
        }

        if (this.data.groupType == undefined) {
          this.$set(this.data, 'groupType', this.groupTypes[0].value);
        }

        if (this.data.group == undefined) {
          this.$set(this.data, 'group', '<当前>');
        }

        if (this.data.userType == undefined) {
          this.$set(this.data, 'userType', this.userTypes[0].value);
        }
        if (this.data.excludeType == undefined) {
          this.$set(this.data, 'excludeType', this.excludeTypes[0].value);
        }
        if (this.data.subProcessFormSwitch == undefined) {
          this.$set(this.data, 'subProcessFormSwitch', '1');
        }
      },
      showHandledNode: function showHandledNode(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        PF.show('tree', { treeData: me._getActivities(['start', 'end', 'circular', 'sub-proc']), selectFirst: false, selectNode: selectNode }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });

      },
      showDept: function showDept() {
        var me = this;
        var selectNode = '';
        if (me.data['relativeGroup']) {
          selectNode = me.data['relativeGroup'];
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listDepartment"), selectFirst: false, selectNode: selectNode, search: true, async: true, singleLeaf: false }, function (res) {
          me.$set(me.data, 'relativeGroup', res.id);
          me.$set(me.data, 'relativeGroupName', res.name);
        });
      },
      showRole: function showRole(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listFlowGroupedRole"), selectFirst: false, selectNode: selectNode, search: true, clearBtn: true }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });
      },

      showSubProcess: function showSubProcess() {
        var me = this;
        var selectNode = '';
        if (me.data.subProcessDefKey) {
          if (me.data.subProcessModuleId) {
            selectNode = me.data.subProcessDefKey + '|' + me.data.subProcessModuleId;
          } else {
            selectNode = me.data.subProcessDefKey;
          }
        }
        PF.show('tree', { url: this.mwUrl("/api/process/listModuleLatestProcDefTree"), singleLeaf: true, selectFirst: false, selectNode: selectNode, search: true, defaultParams: { sysId: me.params.sysId } }, function (res) {
          if (res) {
            if (res.id) {
              var ids = res.id.split('|');
              me.$set(me.data, 'subProcessDefKey', ids[0]);
            } else {
              me.$set(me.data, 'subProcessDefKey', res.id);
            }
            me.$set(me.data, 'subProcessDefName', res.name);
            me.$set(me.data, 'subProcessApplicationId', res.appId);
            me.$set(me.data, 'subProcessModuleId', res.moduleId);
            delete me.data.subProcessStartActivityId;
            delete me.data.subProcessStartActivityName;
            delete me.data.subProcessFormFieldMapping;
          }
        });
      },
      showSubProcessNode: function showSubProcessNode() {
        var me = this;
        var key = me.data.subProcessDefKey;
        if (key) {
          var selectNode = '';
          if (me.data['subProcessStartActivityId']) {
            selectNode = me.data['subProcessStartActivityId'];
          }
          var appId = me.params.applicationId;
          if (me.data.subProcessApplicationId) {
            appId = me.data.subProcessApplicationId;
          }
          PF.show('tree', { url: this.mwUrl("/api/process/getSubProcessStartActivities"), selectFirst: false, selectNode: selectNode, defaultParams: { key: key, appId: appId } }, function (res) {
            me.$set(me.data, 'subProcessStartActivityId', res.id);
            me.$set(me.data, 'subProcessStartActivityName', res.name);
          });
        }
      },
      showFormFieldMapping: function showFormFieldMapping() {
        var me = this;
        var moduleId = me.params.moduleId;
        var subProcessDefKey = me.data.subProcessDefKey;
        if (!subProcessDefKey) {
          me.mwMsg('info', '请先选择一个目标流程!');
          return;
        }
        var formFieldMapping = [];
        if (me.data.subProcessFormFieldMapping) {
          formFieldMapping = JSON.parse(me.data.subProcessFormFieldMapping);
        }
        PF.show('processFormFieldMapping', { moduleId: moduleId, subProcessModuleId: me.data.subProcessModuleId, formFieldMapping: formFieldMapping, applicationId: me.params.applicationId }, function (res) {
          var data = res.data;
          if (!data) {
            data = [];
          }
          me.$set(me.data, 'subProcessFormFieldMapping', (0, _stringify2.default)(data));
        });
      },
      clearField: function clearField() {
        var me = this;
        function contains(obj) {
          for (var i = 0; i < me.fields.length; i++) {
            if (me.fields[i] == obj) {
              return true;
            }
          }
          return false;
        }
        var del = [];
        for (var s in me.data) {
          if (!contains(s)) {
            del.push(s);
          }
        }
        for (var i = 0; i < del.length; i++) {
          delete me.data[del[i]];
        }
      },
      changeType: function changeType(val) {
        parent.$emit("updateShape", { id: this.data.id, type: val });
        this.params.changeType(val);
      },
      _getActivities: function _getActivities(excludeActivityTypes) {
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var treeData = [];
        var exclude;
        activities.forEach(function (a) {
          exclude = false;
          excludeActivityTypes.forEach(function (et) {
            if (et == a.extends) {
              exclude = true;
            }
          });
          if (!exclude) {
            treeData.push({ id: a.id, text: a.parameters.name, name: a.parameters.name });
          }
        });
        return treeData;
      } } };


  return node_sub_proc;
};function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (Vue, parent, _data) {
  var node_serial = {
    template: '\n    <div class=\'__config__body\'>\n       <el-collapse v-model="activeName" accordion>\n        <el-collapse-item title="\u57FA\u672C\u5C5E\u6027" name="1">\n           <el-form label-width="65px">\n            <el-form-item label="\u552F\u4E00\u6807\u8BC6\uFF1A" v-show=false>\n                <el-input v-model="data[\'id\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u540D\u79F0\uFF1A">\n                <el-input v-model="data[\'name\']" :disabled="!params.editable"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u6807\u8BC6\uFF1A">\n                <el-input v-model="data[\'mark\']" style="width:calc(100% - 48px);"></el-input>\n                <el-button type="primary" @click="showFlowMarks()">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u5E8F\u53F7\uFF1A">\n                <el-input v-model="data[\'sn\']"></el-input>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u6D41\u7A0B\u63A7\u5236" name="2">\n           <el-form label-width="92px">\n            <el-form-item label="\u8282\u70B9\u7C7B\u578B\uFF1A">\n                <el-select @change=\'changeType\' v-model="data[\'type\']" :disabled="!params.editable">\n                  <el-option\n                    v-for="item in types"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n\n            <el-form-item label="\u529E\u7406\u90E8\u95E8\uFF1A">\n                <el-select v-model="data[\'groupType\']">\n                  <el-option\n                    v-for="item in groupTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u76F8\u5BF9\u90E8\u95E8\uFF1A" v-show="data[\'groupType\'] === \'relative\' ">\n                <el-input v-model="data[\'relativeGroupName\']" style="width:60%;" :disabled="true"></el-input>\n                <el-button type="primary" @click="showDept">\u9009\u62E9</el-button>\n            </el-form-item>\n             <el-form-item label="\u76F8\u5BF9\u90E8\u95E8" v-show="false">\n                  <el-input v-model="data[\'relativeGroup\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u5B57\u6BB5\uFF1A"  v-show="data[\'groupType\'] === \'biz\' ">\n                <el-input v-model="data[\'groupField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'groupType\'] === \'handled-group\' ">\n                <el-input v-model="data[\'groupHandledActName\']"  :disabled="true" style="width:60%;"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'groupHandled\', name:\'groupHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'groupHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n              <el-form-item label="\u90E8\u95E8\u8303\u56F4\uFF1A">\n                <el-select v-model="data[\'group\']">\n                  <el-option\n                    v-for="item in groups"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u529E\u7406\u7528\u6237\uFF1A">\n                <el-select v-model="data[\'userType\']">\n                  <el-option\n                    v-for="item in userTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-row v-show="data[\'userType\'] === \'role\' ">\n              <el-form-item label="\u7528\u6237\u6743\u9650\uFF1A" v-show="data[\'userType\'] === \'role\' ">\n                <el-input v-model="data[\'userRoleName\']" style="width:60%" :disabled="true"></el-input>\n                <el-button type="primary" @click="showRole({id:\'userRole\', name:\'userRoleName\'})">\u9009\u62E9</el-button>\n              </el-form-item>\n              <el-form-item label="\u7528\u6237\u6743\u9650" v-show="false">\n                <el-input v-model="data[\'userRole\']" :disabled="true"></el-input>\n              </el-form-item>\n              <table class="inner_table">\n                  <colgroup>\n                    <col style="width:108px">\n                    <col style="width:108px">\n                    <col style="width:29px">\n                  </colgroup>\n                  <tbody>\n                    <tr><th>\u6761\u4EF6</th><th>\u6743\u9650</th><th><i class="fa fa-plus-square" @click="addConditionRoleRow()" title="\u65B0\u589E"></i></th></tr>\n                    <tr :key="idx" v-for="(it,idx) in data.conditionRoles">\n                    <td ><input style="width: 100px;line-height: 25px;" type=\'text\' :title="it[\'condition\']" v-model="it[\'condition\']"/></td>\n                    <td >\n                    <input style="width: 100px;line-height: 25px;" type=\'text\' readonly :title="it[\'roleName\']" @focus="showMulRole(idx,{id:\'roleId\', name:\'roleName\'})" v-model="it[\'roleName\']"/>\n                    <input type=\'text\' readonly :title="it[\'roleId\']"  v-model="it[\'roleId\']" v-show="false"/>\n                    </td>\n                    <td ><i class="fa fa-minus-square" @click="deleteConditionRoleRow(idx)"></i></td>\n                    </tr>\n                  </tbody>\n               </table>\n            </el-row>\n            <el-form-item label="\u7528\u6237\u5B57\u6BB5\uFF1A" v-show="data[\'userType\']=== \'biz\' ">\n                <el-input v-model="data[\'userField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'userType\'] === \'handled-user\' ">\n                <el-input v-model="data[\'userHandledActName\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'userHandled\', name:\'userHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'userHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u6392\u9664\u6761\u4EF6\uFF1A">\n              <el-radio-group v-model="data[\'excludeSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u6392\u9664\u8303\u56F4\uFF1A" v-show="data[\'excludeSwitch\']== \'1\' ">\n                <el-select v-model="data[\'excludeType\']">\n                  <el-option\n                    v-for="item in excludeTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="B\u89D2\u63A7\u5236\uFF1A">\n              <el-radio-group v-model="data[\'bRoleSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="B\u76F8\u5BF9A\u90E8\u95E8\uFF1A" v-show="data[\'bRoleSwitch\'] === \'1\' ">\n                <el-select v-model="data[\'aGroupScope\']">\n                  <el-option\n                    v-for="item in aGroupScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="B\u7528\u6237\u6743\u9650\uFF1A" v-show="data[\'bRoleSwitch\'] === \'1\' ">\n              <el-input v-model="data[\'bUserRoleName\']" style="width:60%" :disabled="true"></el-input>\n              <el-button type="primary" @click="showRole({id:\'bUserRole\', name:\'bUserRoleName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="B\u7528\u6237\u6743\u9650" v-show="false">\n              <el-input v-model="data[\'bUserRole\']" :disabled="true"></el-input>\n            </el-form-item>\n          </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u8868\u5355\u63A7\u5236" name="3">\n           <el-form  label-width="92px">\n            <el-form-item label="\u64CD\u4F5C\u6309\u94AE\uFF1A">\n                <el-button type="primary" @click="showFlowButton()">\u9009\u62E9</el-button>\n            </el-form-item>\n            <div style="padding:5px;border:1px #ddd solid" v-show="data.buttons.length>0">\n              <el-button  :key="button.id" v-for="button in data.buttons">{{button.name}}\n              </el-button>\n            </div>\n            <el-form-item label="\u64CD\u4F5C\u6743\u9650\uFF1A">\n                <el-button type="primary" @click="showFormOperAuth()">\u9009\u62E9</el-button>\n            </el-form-item>\n             <div style="padding:5px;border:1px #ddd solid" v-show="data.operAuths.length>0">\n                 <el-button  :key="auth.id" v-for="auth in data.operAuths">{{auth.name}}\n                 </el-button>\n            </div>\n               <el-form-item label="\u5207\u6362\u8868\u5355\uFF1A">\n                <el-button type="primary" @click="showRelateForm()">\u9009\u62E9</el-button>\n               </el-form-item>\n               <div style="padding:5px;border:1px #ddd solid" v-show="data.openFormId">\n                   <div v-text="data.openFormName"></div>\n            </div>\n            <el-form-item label="\u53EF\u9000\u56DE\u8282\u70B9\uFF1A">\n                <el-input v-model="data[\'canRejectActivityNames\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showCanRejectNodes({id:\'canRejectActivityIds\', name:\'canRejectActivityNames\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u53EF\u9000\u56DE\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'canRejectActivityIds\']" :disabled="true"></el-input>\n              </el-form-item>\n           <el-form-item label="\u542F\u7528\u4F20\u9605\uFF1A">\n              <el-radio-group v-model="data[\'circularSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u4F20\u9605\u8303\u56F4\uFF1A" v-show="data[\'circularSwitch\']===\'1\'">\n                <el-select v-model="data[\'circularScope\']">\n                  <el-option\n                    v-for="item in circularScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u4F20\u9605\u79D8\u4E66\u4EE3\u529E\uFF1A"  v-show="data[\'circularSwitch\']===\'1\'">\n                <el-radio-group v-model="data[\'circularSecretarySwitch\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u79D8\u4E66\u8282\u70B9\u540D\uFF1A" v-show="data[\'circularSwitch\']===\'1\' && data[\'circularSecretarySwitch\']===\'1\'">\n                    <el-input v-model="data[\'circularSecActivityName\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u8282\u70B9\u540D\uFF1A" v-show="data[\'circularSwitch\']===\'1\' && data[\'circularSecretarySwitch\']===\'1\'">\n                    <el-input v-model="data[\'circularLeaderActivityName\']"></el-input>\n                </el-form-item>\n            <el-form-item label="\u542F\u7528\u8F6C\u529E\uFF1A">\n              <el-radio-group v-model="data[\'transmitSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u8F6C\u529E\u8303\u56F4\uFF1A" v-show="data[\'transmitSwitch\']===\'1\'">\n                <el-select v-model="data[\'transmitScope\']">\n                  <el-option\n                    v-for="item in transmitScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n               <el-form-item label="\u610F\u89C1\u63A7\u5236\uFF1A">\n              <el-radio-group v-model="data[\'commentSwitch\']" size="mini">\n                <el-radio-button label="1">\u5C55\u5F00</el-radio-button>\n                <el-radio-button label="0">\u6298\u53E0</el-radio-button>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u610F\u89C1\u5206\u7C7B\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-input v-model="data[\'commentCategory\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u610F\u89C1\u5E8F\u53F7\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-input v-model="data[\'commentSn\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u9ED8\u8BA4\u610F\u89C1\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-input v-model="data[\'defaultComment\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u586B\u5199\u591A\u6761\u610F\u89C1\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-radio-group v-model="data[\'moreCommentSwitch\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u4FEE\u6539\u610F\u89C1\u8303\u56F4\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-select v-model="data[\'commentModifyScope\']">\n                  <el-option\n                    v-for="item in commentModifyScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u68C0\u67E5\u65B9\u5F0F\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-select v-model="data[\'commentCheckMode\']">\n                  <el-option\n                    v-for="item in commentCheckModes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n              </el-form-item>\n              <el-form-item label="\u5B8C\u6210\u5F3A\u5236\u586B\u5199\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-select v-model="data[\'completeComment\']">\n                  <el-option\n                    v-for="item in mandatoryOptions"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n               </el-form-item>\n               <el-form-item label="\u8F6C\u529E\u5F3A\u5236\u586B\u5199\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                 <el-select v-model="data[\'transmitComment\']">\n                  <el-option\n                    v-for="item in mandatoryOptions"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n               </el-form-item>\n               <el-form-item label="\u9000\u56DE\u5F3A\u5236\u586B\u5199\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n               <el-select v-model="data[\'rejectComment\']">\n                  <el-option\n                    v-for="item in mandatoryOptions"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n               </el-form-item>\n               <el-form-item label="\u53EA\u8BFB:" >\n                  <el-radio-group v-model="data[\'readOnly\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u9644\u4EF6\u53EF\u7F16\u8F91:" >\n                  <el-radio-group v-model="data[\'editAttach\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n               </el-form-item>\n                <el-form-item label="\u9644\u4EF6\u53EF\u4E0A\u4F20:" >\n                  <el-radio-group v-model="data[\'uploadAttach\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n                </el-form-item> \n                <el-form-item label="\u9644\u4EF6\u53EF\u4E0B\u8F7D:" >\n                  <el-radio-group v-model="data[\'downloadAttach\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n                </el-form-item> \n                <el-form-item label="\u6B63\u6587\u6253\u5F00\u65B9\u5F0F:" >\n                    <el-input v-model="data[\'attchOct\']" style="width:calc(100% - 48px);"></el-input>\n                    <el-button type="primary" @click="showOcxList">\u9009\u62E9</el-button>\n                </el-form-item> \n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u79D8\u4E66\u4EE3\u529E" name="4">\n            <el-form  label-width="105px">\n              <el-form-item label="\u542F\u7528\u79D8\u4E66\u4EE3\u529E\uFF1A">\n              <el-radio-group v-model="data[\'secretarySwitch\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u79D8\u4E66\u4EE3\u529E\u6D41\u7A0B\uFF1A" v-show="data[\'secretarySwitch\']===\'1\'">\n               <el-radio-group v-model="data[\'secretarySubProcSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u4EE3\u529E\u6D41\u7A0B\u540D\u79F0\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'secSubProcessDefName\']" style="width:60%;" :disabled="true"></el-input>\n                    <el-button type="primary" @click="showSubProcess">\u9009\u62E9</el-button>\n                </el-form-item>\n                <el-form-item label="\u4EE3\u529E\u6D41\u7A0BKey" v-show="false">\n                    <el-input v-model="data[\'secSubProcessDefKey\']" :disabled="true"></el-input>\n                </el-form-item>\n                 <el-form-item label="\u4EE3\u529E\u6D41\u7A0B\u6A21\u5757" v-show="false">\n                <el-input v-model="data[\'secSubProcessModuleId\']" :disabled="true"></el-input>\n                <el-input v-model="data[\'secSubProcessApplicationId\']" :disabled="true"></el-input>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u4EE3\u529E\u8282\u70B9\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessSecActivityName\']" style="width:60%;" :disabled="true"></el-input>\n                    <el-button type="primary" @click="showSubProcessNode(\'subProcessSecActivityId\', \'subProcessSecActivityName\')">\u9009\u62E9</el-button>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u4EE3\u529E\u8282\u70B9ID" v-show="false">\n                    <el-input v-model="data[\'subProcessSecActivityId\']" :disabled="true"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u4EE3\u529E\u8282\u70B9\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessLeaderActivityName\']" style="width:60%;" :disabled="true"></el-input>\n                    <el-button type="primary" @click="showSubProcessNode(\'subProcessLeaderActivityId\', \'subProcessLeaderActivityName\')">\u9009\u62E9</el-button>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u4EE3\u529E\u8282\u70B9ID" v-show="false">\n                    <el-input v-model="data[\'subProcessLeaderActivityId\']" :disabled="true"></el-input>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u8282\u70B9\u63D0\u793A" v-show="false && data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessSecActivityTip\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u8282\u70B9\u63D0\u793A" v-show="false && data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessLeaderActivityTip\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u8282\u70B9\u540D\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'0\'">\n                    <el-input v-model="data[\'secActivityName\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u8282\u70B9\u540D\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'0\'">\n                    <el-input v-model="data[\'leaderActivityName\']"></el-input>\n                </el-form-item>\n               <el-form-item label="\u4EE3\u5F55\u8282\u70B9\u6D41\u5411\uFF1A">\n                <el-input v-model="data[\'canAgentRecordFlowNames\']"  :disabled="true" style="width:50%"></el-input>\n                <el-button type="primary" @click="showCanAgentRecordFlows({id:\'canAgentRecordFlowIds\', name:\'canAgentRecordFlowNames\'})">\u9009\u62E9</el-button>\n                 <el-tooltip placement="top" style="width:10%">\n                  <div slot="content">\n                  \u914D\u7F6E"\u865A\u62DF\u65E5\u5FD7"\u64CD\u4F5C\u6309\u94AE\u540E\u751F\u6548</div>\n                  <i class="el-icon-question"></i>\n                </el-tooltip>\n               </el-form-item>\n               <el-form-item label="\u4EE3\u5F55\u8282\u70B9ID" v-show="false">\n                  <el-input v-model="data[\'canAgentRecordFlowIds\']" :disabled="true"></el-input>\n              </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u79FB\u52A8\u914D\u7F6E" name="6">\n          <el-form  label-width="92px">\n              <el-form-item label="\u662F\u5426\u529E\u7406:" >\n                  <el-radio-group v-model="data[\'mobileHandler\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u8868\u5355\u7F16\u8F91:" >\n                  <el-radio-group v-model="data[\'mobileEdit\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u7F16\u8F91\u6B63\u6587:" >\n                  <el-radio-group v-model="data[\'mobileZWEdit\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u7F16\u8F91\u9644\u4EF6:" >\n                  <el-radio-group v-model="data[\'mobileFJEdit\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u4E0A\u4F20\u9644\u4EF6:" >\n                  <el-radio-group v-model="data[\'mobileFJUpload\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n          </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u5176\u4ED6" name="5">\n           <el-form  label-width="92px">\n              <el-form-item label="\u65F6\u9650\u63A7\u5236\uFF1A">\n              <el-radio-group v-model="data[\'timeSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u65F6\u95F4\u7C7B\u578B\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                <el-select v-model="data[\'timeType\']">\n                  <el-option\n                    v-for="item in timeTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u7B7E\u6536\u9650\u529E\u65F6\u95F4\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                  <el-input v-model="data[\'claimLimitedTime\']"></el-input>\n              </el-form-item>\n              <el-form-item label="\u529E\u6BD5\u9650\u529E\u65F6\u95F4\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                  <el-input v-model="data[\'finishLimitedTime\']"></el-input>\n              </el-form-item>\n              <el-form-item label="\u81EA\u52A8\u6D41\u8F6C\u610F\u89C1\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                  <el-input v-model="data[\'autoLZYJ\']"></el-input>\n              </el-form-item>\n              <el-form-item label="\u6267\u884C\u811A\u672C\uFF1A">\n                <el-button type="primary" @click="showFlowScriptSet(\'node\')">\u8BBE\u7F6E</el-button>\n              </el-form-item>\n              <el-form-item label="\u662F\u5426\u9886\u5BFC\u8282\u70B9\uFF1A">\n              <el-select v-model="data[\'leaderNode\']">\n                  <el-option\n                    v-for="item in groupYesNo"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u662F\u5426\u5B9A\u5BC6\u8282\u70B9\uFF1A">\n              <el-select v-model="data[\'densityNode\']">\n                  <el-option\n                    v-for="item in groupYesNo"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n      </el-collapse>\n    </div>\n    ',





































































































































































































































































































































































































































































































    props: {
      data: {
        type: Object },

      params: {
        type: Object } },


    data: function data() {
      return {
        fields: ['id', 'name', 'mark', 'type', 'sn', 'groupType', 'group', 'relativeGroup', 'relativeGroupName',
        'groupField', 'groupHandled', 'groupHandledActName', 'userType', 'userRole', 'userRoleName', 'conditionRoles', 'userField', 'userHandledActName',
        'userHandled', 'excludeSwitch', 'buttons', 'operAuths', 'scriptActions', 'timeSwitch', 'timeType', 'claimLimitedTime', 'finishLimitedTime', 'autoLZYJ',
        'excludeType', 'bRoleSwitch', 'aGroupScope', 'bUserRole', 'bUserRoleName',
        'canRejectActivityIds', 'canRejectActivityNames', 'transmitSwitch',
        'transmitScope', 'commentSwitch', 'commentCategory', 'commentSn',
        'defaultComment', 'moreCommentSwitch', 'commentModifyScope', 'commentCheckMode', 'completeComment', 'transmitComment', 'rejectComment',
        'circularSwitch', 'circularScope', 'circularSecretarySwitch', 'circularSecActivityName', 'circularLeaderActivityName',
        'secretarySwitch', 'secretarySubProcSwitch', 'secSubProcessDefName', 'secSubProcessDefKey', 'secSubProcessModuleId', 'secSubProcessApplicationId',
        'subProcessSecActivityName', 'subProcessSecActivityId', 'subProcessLeaderActivityName', 'subProcessLeaderActivityId',
        'subProcessSecActivityTip', 'subProcessLeaderActivityTip', 'secActivityName', 'leaderActivityName', 'readOnly', 'editAttach', 'uploadAttach', 'downloadAttach', 'attchOct', 'attchOctKey',
        'mobileHandler', 'mobileEdit', 'mobileZWEdit', 'mobileFJEdit', 'mobileFJUpload',
        'canAgentRecordFlowNames', 'canAgentRecordFlowIds', 'openFormId', 'openFormName', 'leaderNode', 'densityNode'],

        activeName: '1',
        types: [],
        groupTypes: [{ value: 'role', label: '权限' }, { value: 'relative', label: '相对部门' }, { value: 'handled-group', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'upper-group', label: '发送部门' }, { value: 'draft-group', label: '发起部门' }],
        groups: [{ value: '<当前>', label: '<当前>' }, { value: '<上级>', label: '<上级>' }, { value: '<下级>', label: '<下级>' }, { value: '<平级>', label: '<平级>' },
        { value: '<当前和上级>', label: '<当前和上级>' }, { value: '<当前和下级>', label: '<当前和下级>' },
        { value: '<所有下级>', label: '<所有下级>' }, { value: '<上级的平级>', label: '<上级的平级>' },
        { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<部门上级>', label: '<部门上级>' }, { value: '<部门下级>', label: '<部门下级>' }, { value: '<部门平级>', label: '<部门平级>' },
        { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<本单位任选(不包含下级)>', label: '<本单位任选(不包含下级)>' },
        { value: '<本单位的一级部门>', label: '<本单位的一级部门>' }, { value: '<单位上级>', label: '<单位上级>' }, { value: '<单位平级>', label: '<单位平级>' },
        { value: '<上级单位部门>', label: '<上级单位部门>' }, { value: '<上级单位任选>', label: '<上级单位任选>' }],
        userTypes: [{ value: 'role', label: '权限' }, { value: 'handled-user', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'draft-user', label: '发起人' }, { value: 'upper-user', label: '发送人' }],
        circularScopes: [{ value: '<当前>', label: '<当前>' }, { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<任选>', label: '<任选>' }],
        timeTypes: [{ value: 'work', label: '工作时间(单位:h)' }, { value: 'reality', label: '实际时间(单位:h)' }, { value: 'biz', label: '业务字段' }],
        transmitScopes: [{ value: '<当前>', label: '<当前>' }, { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<任选>', label: '<任选>' }],
        excludeTypes: [{ value: 'current-user', label: '当前用户' }, { value: 'current-dep', label: '当前部门' }],
        commentCheckModes: [{ value: 'task', label: '当前环节' }, { value: 'activity', label: '当前节点' }, { value: 'doc', label: '当前文档' }],
        commentModifyScopes: [{ value: 'disabled', label: '禁止' }, { value: 'self', label: '本人' }, { value: 'all', label: '所有人' }],
        mandatoryOptions: [{ value: 'no', label: '否' }, { value: 'remind', label: '提示' }, { value: 'yes', label: '是' }],
        aGroupScopes: [{ value: '<当前>', label: '<当前>' }, { value: '<本部门任选>', label: '<本部门任选>' }],
        groupYesNo: [{ value: '1', label: '是' }, { value: '0', label: '否' }] };

    },
    created: function created() {
      var me = this;
      me.clearField();
      me.types = me.params.activityTypes;
      me.initData();
    },
    watch: {
      'data.name': function dataName(val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", { id: me.data.id, name: val });
        }
      },
      'data.id': function dataId(val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name;
          this.$set(this.data, 'name', '新增节点');
        }
        this.initData();
      } },

    methods: {
      initData: function initData() {
        var me = this;
        if (this.data.openFormId == undefined) {
          this.$set(this.data, 'openFormId', '');
          this.$set(this.data, 'openFormName', '');
        }
        if (this.data.conditionRoles == undefined) {
          this.$set(this.data, 'conditionRoles', []);
        }

        if (me.data.name == undefined) {
          this.$set(me.data, 'name', '新增节点');
        }
        if (this.data.excludeSwitch == undefined) {
          this.$set(this.data, 'excludeSwitch', '0');
        }
        if (this.data.buttons == undefined) {
          this.$set(this.data, 'buttons', []);
        }
        if (this.data.operAuths == undefined) {
          this.$set(this.data, 'operAuths', []);
        }
        if (me.data.mark == undefined) {
          this.$set(me.data, 'mark', '');
        }
        if (this.data.scriptActions == undefined) {
          this.$set(this.data, 'scriptActions', {});
        }
        if (this.data.type == undefined) {
          this.$set(this.data, 'type', 'serial');
        }

        if (this.data.groupType == undefined) {
          this.$set(this.data, 'groupType', this.groupTypes[0].value);
        }

        if (this.data.group == undefined) {
          this.$set(this.data, 'group', '<当前>');
        }

        if (this.data.userType == undefined) {
          this.$set(this.data, 'userType', this.userTypes[0].value);
        }
        if (this.data.mobileHandler == undefined) {
          this.$set(this.data, 'mobileHandler', "1");
        }
        if (this.data.mobileEdit == undefined) {
          this.$set(this.data, 'mobileEdit', "0");
        }
        if (this.data.mobileZWEdit == undefined) {
          this.$set(this.data, 'mobileZWEdit', "0");
        }
        if (this.data.mobileFJEdit == undefined) {
          this.$set(this.data, 'mobileFJEdit', "0");
        }
        if (this.data.mobileFJUpload == undefined) {
          this.$set(this.data, 'mobileFJUpload', "1");
        }
        if (this.data.readOnly == undefined) {
          this.$set(this.data, 'readOnly', "0");
        }
        if (this.data.editAttach == undefined) {
          this.$set(this.data, 'editAttach', "1");
        }
        if (this.data.uploadAttach == undefined) {
          this.$set(this.data, 'uploadAttach', "1");
        }
        if (this.data.downloadAttach == undefined) {
          this.$set(this.data, 'downloadAttach', "1");
        }
        if (this.data.attchOctKey == undefined) {
          this.$set(this.data, 'attchOctKey', "");
        }
        if (this.data.attchOct == undefined) {
          this.$set(this.data, 'attchOct', "无");
        }
        if (this.data.circularSwitch == undefined) {
          this.$set(this.data, 'circularSwitch', '0');
        }

        if (this.data.circularScope == undefined) {
          this.$set(this.data, 'circularScope', this.circularScopes[0].value);
        }
        if (this.data.circularSecretarySwitch == undefined) {
          this.$set(this.data, 'circularSecretarySwitch', '0');
        }
        if (this.data.timeSwitch == undefined) {
          this.$set(this.data, 'timeSwitch', '0');
        }
        if (this.data.timeType == undefined) {
          this.$set(this.data, 'timeType', 'work');
        }
        if (this.data.excludeType == undefined) {
          this.$set(this.data, 'excludeType', this.excludeTypes[0].value);
        }
        if (this.data.bRoleSwitch == undefined) {
          this.$set(this.data, 'bRoleSwitch', '0');
        }
        if (this.data.aGroupScope == undefined) {
          this.$set(this.data, 'aGroupScope', '<当前>');
        }
        if (this.data.transmitSwitch == undefined) {
          this.$set(this.data, 'transmitSwitch', '0');
        }
        if (this.data.transmitScope == undefined) {
          this.$set(this.data, 'transmitScope', this.transmitScopes[0].value);
        }
        if (this.data.secretarySwitch == undefined) {
          this.$set(this.data, 'secretarySwitch', '0');
        }
        if (this.data.secretarySubProcSwitch == undefined) {
          this.$set(this.data, 'secretarySubProcSwitch', '0');
        }
        if (this.data.commentSwitch == undefined) {
          this.$set(this.data, 'commentSwitch', '0');
        }
        if (this.data.moreCommentSwitch == undefined) {
          this.$set(this.data, 'moreCommentSwitch', '0');
        }
        if (this.data.commentModifyScope == undefined) {
          this.$set(this.data, 'commentModifyScope', 'self');
        }
        if (this.data.commentCheckMode == undefined) {
          this.$set(this.data, 'commentCheckMode', this.commentCheckModes[0].value);
        }
        if (this.data.completeComment == undefined) {
          this.$set(this.data, 'completeComment', 'no');
        }
        if (this.data.transmitComment == undefined) {
          this.$set(this.data, 'transmitComment', 'no');
        }
        if (this.data.rejectComment == undefined) {
          this.$set(this.data, 'rejectComment', 'no');
        }
        if (this.data.leaderNode == undefined) {
          this.$set(this.data, 'leaderNode', '0');
        }
        if (this.data.densityNode == undefined) {
          this.$set(this.data, 'densityNode', '0');
        }

      },
      addConditionRoleRow: function addConditionRoleRow() {
        var me = this;
        me.data.conditionRoles.push({ condition: '', roleId: '', roleName: '' });
      },
      deleteConditionRoleRow: function deleteConditionRoleRow(idx) {
        this.data.conditionRoles.splice(idx, 1);
      },
      showMulRole: function showMulRole(idx) {
        var me = this;
        var data = me.data.conditionRoles[idx];
        var selectNode = '';
        if (data && data.roleId) {
          selectNode = data.roleId;
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listFlowGroupedRole"), selectFirst: false, selectNode: selectNode, search: true, clearBtn: true }, function (res) {
          me.$set(data, "roleId", res.id);
          me.$set(data, "roleName", res.name);
        });
      },
      showRelateForm: function showRelateForm() {
        var me = this;
        var moduleId = me.params.moduleId;
        var appId = me.params.applicationId;

        PF.show('tableDialog', { api: "app.listModuleForm", clearBtn: true,
          defaultParams: { moduleId: moduleId, appId: appId }, singleSelect: true }, function (res) {
          if (res.length > 0) {
            me.$set(me.data, 'openFormId', res[0].id);
            me.$set(me.data, 'openFormName', res[0].name);
          } else {
            me.$set(me.data, 'openFormId', "");
            me.$set(me.data, 'openFormName', "");
          }
        });

      },
      showHandledNode: function showHandledNode(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        PF.show('tree', {
          treeData: me._getActivities(['start', 'end', 'circular', 'sub-proc']), selectFirst: false, selectNode: selectNode },
        function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });
      },
      showOcxList: function showOcxList() {
        var me = this;
        PF.show('tree', { url: me.mwUrl("/api/data/getOcxList"), selectFirst: false, selectNode: "", search: true, async: true, singleLeaf: true }, function (res) {
          me.$set(me.data, 'attchOct', res.name || "");
          me.$set(me.data, 'attchOctKey', res.key || "");
        });
      },
      showFlowMarks: function showFlowMarks() {
        var me = this;
        var flowMarks = me.params.flowMarks || "";
        if (!flowMarks) {
          PF.message("请在模块设置中配置流程标识");
          return;
        }
        flowMarks = _.uniq(flowMarks.split(","));
        var treeData = [];
        _.each(flowMarks, function (v) {treeData.push({ id: v, name: v });});
        var checkNodes = (me.data.mark || "").split(",");
        PF.show('tree', { treeData: treeData, checkNodes: checkNodes, multiple: true, clearBtn: true }, function (res) {
          var marks = [];
          _.each(res, function (v) {
            marks.push(v.name);
          });
          me.$set(me.data, 'mark', marks.join(","));
        });
      },
      showCanRejectNodes: function showCanRejectNodes(f) {
        var me = this;
        var checkNodes;
        if (me.data[f.id]) {
          checkNodes = me.data[f.id].split(',');
        }
        PF.show('tree', { treeData: me._getActivities(['start', 'end', 'circular', 'sub-proc']), checkNodes: checkNodes, multiple: true, clearBtn: true }, function (res) {
          var activityNames = [];
          var activityIds = [];
          res.forEach(function (item) {
            activityNames.push(item.name);
            activityIds.push(item.id);
          });

          me.$set(me.data, f.id, activityIds.join(','));
          me.$set(me.data, f.name, activityNames.join(','));
        });
      },
      showCanAgentRecordNodes: function showCanAgentRecordNodes(f) {
        var me = this;
        var checkNodes;
        if (me.data[f.id]) {
          checkNodes = me.data[f.id].split(',');
        }
        PF.show('tree', { treeData: me._getCanAgentRecordNextActivities(['start', 'end', 'circular', 'sub-proc']), checkNodes: checkNodes, multiple: true, clearBtn: true }, function (res) {
          var activityNames = [];
          var activityIds = [];
          res.forEach(function (item) {
            activityNames.push(item.name);
            activityIds.push(item.id);
          });
          me.$set(me.data, f.id, activityIds.join(','));
          me.$set(me.data, f.name, activityNames.join(','));
        });
      },
      showCanAgentRecordFlows: function showCanAgentRecordFlows(f) {
        var me = this;
        var checkFlows;
        if (me.data[f.id]) {
          checkFlows = me.data[f.id].split(',');
        }
        PF.show('tree', { treeData: me._getCanAgentRecordFlows(['start', 'end', 'circular', 'sub-proc']), checkNodes: checkFlows, multiple: true, clearBtn: true }, function (res) {
          var flowNames = [];
          var flowIds = [];
          res.forEach(function (item) {
            flowNames.push(item.name);
            flowIds.push(item.id);
          });
          me.$set(me.data, f.id, flowIds.join(','));
          me.$set(me.data, f.name, flowNames.join(','));
        });
      },
      showDept: function showDept() {
        var me = this;
        var selectNode = '';
        if (me.data['relativeGroup']) {
          selectNode = me.data['relativeGroup'];
        }
        PF.show('tree', {
          url: this.mwUrl("/api/org/listDepartment"), selectFirst: false,
          selectNode: selectNode,
          search: true,
          async: true,
          singleLeaf: false },
        function (res) {
          me.$set(me.data, 'relativeGroup', res.id);
          me.$set(me.data, 'relativeGroupName', res.name);
        });
      },
      showRole: function showRole(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        var params;
        if (parent && parent.propAuthUnit) {
          params = { authUnitFilter: true };
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listFlowGroupedRole"), selectFirst: false, defaultParams: params, selectNode: selectNode, search: true, clearBtn: true }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });
      },
      showFlowButton: function showFlowButton() {
        var me = this;
        var value = [];
        for (var i = 0; i < me.data.buttons.length; i++) {
          value.push(me.data.buttons[i].action);
        }
        PF.show('treeTable', {
          url: me.mwUrl("/api/app/listActionComponentByTypeTree"), treeDefaultParams: { type: "系统分类/表单/流程", flag: 0 },
          size: 'small_large',
          selectFirst: true, asyncLoadOnce: true, clearBtn: true, title: '选择动作脚本', changed: function changed(data) {
            var me = this;
            me.defaultParams = { type: data.code, flag: 2 };
          }, api: 'app.getAllButton', singleSelect: false },
        function (res) {
          var btns = [];
          if (res && res.length > 0) {
            res.forEach(function (v) {
              btns.push({ name: v.name, action: v.action });
            });
          }
          me.$set(me.data, 'buttons', btns);
        });
      },
      showFlowScriptSet: function showFlowScriptSet(type) {
        var me = this;
        var p = {};
        p.type = type;
        var scriptActions = me.data.scriptActions;
        if (scriptActions) {
          p.scriptActions = scriptActions;
        } else {
          p.scriptActions = {};
        }
        PF.show('flowScriptSet', p, function (res) {
          me.$set(me.data, 'scriptActions', res);
        });
      },
      showFormOperAuth: function showFormOperAuth() {
        var me = this;
        var moduleId = me.params.moduleId;
        var appId = me.params.applicationId;
        var checkNodes = [];
        for (var i = 0; i < me.data.operAuths.length; i++) {
          checkNodes.push(me.data.operAuths[i].id);
        }
        PF.show('tree', { url: this.mwUrl(
          "/api/app/listModuleFormOperAuthTree"), checkNodes: checkNodes, search:
          true, multiple: true, singleLeaf: false, clearBtn: true, multipleLeaf: false,
          defaultParams: { moduleId: moduleId, appId: appId } }, function (res) {
          var auths = [];
          if (res && res.length > 0) {
            res.forEach(function (v) {
              if (v.id) {
                auths.push({ name: v.name, id: v.id });
              }
            });
          }
          me.$set(me.data, 'operAuths', auths);
        });
      },
      clearField: function clearField() {
        var me = this;

        function contains(obj) {
          for (var i = 0; i < me.fields.length; i++) {
            if (me.fields[i] == obj) {
              return true;
            }
          }
          return false;
        }

        var del = [];
        for (var s in me.data) {
          if (!contains(s)) {
            del.push(s);
          }
        }
        for (var i = 0; i < del.length; i++) {
          delete me.data[del[i]];
        }
      },
      changeType: function changeType(val) {
        parent.$emit("updateShape", { id: this.data.id, type: val });
        this.params.changeType(val);
      },
      showSubProcess: function showSubProcess() {
        var me = this;
        var selectNode = '';
        if (me.data.secSubProcessDefKey) {
          if (me.data.secSubProcessModuleId) {
            selectNode = me.data.secSubProcessDefKey + '|' + me.data.secSubProcessModuleId;
          } else {
            selectNode = me.data.secSubProcessDefKey;
          }
        }
        PF.show('tree', { url: this.mwUrl("/api/process/listModuleLatestProcDefTree"), singleLeaf: true, selectFirst: false, selectNode: selectNode, search: true, defaultParams: { sysId: me.params.sysId } }, function (res) {
          if (res) {
            if (res.id) {
              var ids = res.id.split('|');
              me.$set(me.data, 'secSubProcessDefKey', ids[0]);



            } else {
              me.$set(me.data, 'secSubProcessDefKey', res.id);

            }
            me.$set(me.data, 'secSubProcessDefName', res.name);
            me.$set(me.data, 'secSubProcessApplicationId', res.appId);
            me.$set(me.data, 'secSubProcessModuleId', res.moduleId);
            delete me.data.subProcessSecActivityId;
            delete me.data.subProcessSecActivityName;
            delete me.data.subProcessLeaderActivityId;
            delete me.data.subProcessLeaderActivityName;
          }
        });
      },
      showSubProcessNode: function showSubProcessNode(fid, fname) {
        var me = this;
        var key = me.data.secSubProcessDefKey;
        if (key) {
          var selectNode = '';
          if (me.data[fid]) {
            selectNode = me.data[fid];
          }
          var appId = me.params.applicationId;
          if (me.data.secSubProcessApplicationId) {
            appId = me.data.secSubProcessApplicationId;
          }
          PF.show('tree', { url: this.mwUrl("/api/process/getSubProcessStartActivities"), selectFirst: false, selectNode: selectNode, defaultParams: { key: key, appId: appId } }, function (res) {
            me.$set(me.data, fid, res.id);
            me.$set(me.data, fname, res.name);
          });
        }
      },
      _getActivities: function _getActivities(excludeActivityTypes) {
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var treeData = [];
        var exclude;
        activities.forEach(function (a) {
          exclude = false;
          excludeActivityTypes.forEach(function (et) {
            if (et == a.extends) {
              exclude = true;
            }
          });
          if (!exclude) {
            treeData.push({ id: a.id, text: a.parameters.name, name: a.parameters.name });
          }
        });
        return treeData;
      },
      _getCanAgentRecordNextActivities: function _getCanAgentRecordNextActivities(excludeActivityTypes) {
        var me = this;
        var currentNodeId = me.data.id;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var acts = {};
        activities.forEach(function (a) {
          acts[a.id] = a;
        });
        var treeData = [];
        var flows = processDataItems['SEQUENCE-FLOW'];
        var exclude;
        flows.forEach(function (f) {
          exclude = false;
          if (f.parameters.from == currentNodeId) {

            if ('startSubProcess' == f.parameters.type && 'DEP' == f.parameters.sendUnit) {
              exclude = true;
            }
            if (!exclude) {
              var act = acts[f.parameters.to];
              excludeActivityTypes.forEach(function (at) {
                if (at == act.extends) {
                  exclude = true;
                }
              });
              if (!exclude) {
                treeData.push({ id: act.id, text: act.parameters.name, name: act.parameters.name });
              }
            }
          }
        });
        return treeData;
      },
      _getCanAgentRecordFlows: function _getCanAgentRecordFlows(excludeActivityTypes) {
        var me = this;
        var currentNodeId = me.data.id;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var acts = {};
        var actNames = {};
        activities.forEach(function (a) {
          acts[a.id] = a;
          actNames[a.id] = a.parameters.name;
        });
        var treeData = [];
        var flows = processDataItems['SEQUENCE-FLOW'];
        var exclude;
        flows.forEach(function (f) {
          exclude = false;
          if (f.parameters.from == currentNodeId) {

            if ('startSubProcess' == f.parameters.type && 'DEP' == f.parameters.sendUnit) {
              exclude = true;
            }
            if (!exclude) {
              var act = acts[f.parameters.to];
              excludeActivityTypes.forEach(function (at) {
                if (at == act.extends) {
                  exclude = true;
                }
              });
              if (!exclude) {
                var name = f.parameters.name;
                if (!name) {
                  name = actNames[f.parameters.from] + '-' + actNames[f.parameters.to];
                }
                treeData.push({ id: f.id, text: name, name: name, sourceId_targetId: f.parameters.from + '-' + f.parameters.to });
              }
            }
          }
        });
        return treeData;
      } } };


  return node_serial;
};

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (Vue, parent, _data) {
  var node_parallel = {
    template: '\n    <div class=\'__config__body\'>\n       <el-collapse v-model="activeName" accordion>\n        <el-collapse-item title="\u57FA\u672C\u5C5E\u6027" name="1">\n           <el-form label-width="65px">\n            <el-form-item label="\u552F\u4E00\u6807\u8BC6\uFF1A" v-show=false>\n                <el-input v-model="data[\'id\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u540D\u79F0\uFF1A">\n                <el-input v-model="data[\'name\']" :disabled="!params.editable"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u6807\u8BC6\uFF1A">\n                <el-input v-model="data[\'mark\']" style="width:calc(100% - 48px);"></el-input>\n                <el-button type="primary" @click="showFlowMarks()">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u5E8F\u53F7\uFF1A">\n                <el-input v-model="data[\'sn\']"></el-input>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u6D41\u7A0B\u63A7\u5236" name="2">\n           <el-form label-width="92px">\n            <el-form-item label="\u8282\u70B9\u7C7B\u578B\uFF1A">\n                <el-select @change=\'changeType\' v-model="data[\'type\']" :disabled="!params.editable">\n                  <el-option\n                    v-for="item in types"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n\n            <el-form-item label="\u529E\u7406\u90E8\u95E8\uFF1A">\n                <el-select v-model="data[\'groupType\']">\n                  <el-option\n                    v-for="item in groupTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u76F8\u5BF9\u90E8\u95E8\uFF1A" v-show="data[\'groupType\'] === \'relative\' ">\n                <el-input v-model="data[\'relativeGroupName\']" style="width:60%;" :disabled="true"></el-input>\n                <el-button type="primary" @click="showDept">\u9009\u62E9</el-button>\n            </el-form-item>\n             <el-form-item label="\u76F8\u5BF9\u90E8\u95E8" v-show="false">\n                  <el-input v-model="data[\'relativeGroup\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u5B57\u6BB5\uFF1A"  v-show="data[\'groupType\'] === \'biz\' ">\n                <el-input v-model="data[\'groupField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'groupType\'] === \'handled-group\' ">\n                <el-input v-model="data[\'groupHandledActName\']"  :disabled="true" style="width:60%;"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'groupHandled\', name:\'groupHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'groupHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n              <el-form-item label="\u90E8\u95E8\u8303\u56F4\uFF1A" >\n                <el-select v-model="data[\'group\']">\n                  <el-option\n                    v-for="item in groups"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u529E\u7406\u7528\u6237\uFF1A">\n                <el-select v-model="data[\'userType\']">\n                  <el-option\n                    v-for="item in userTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-row v-show="data[\'userType\'] === \'role\' ">\n              <el-form-item label="\u7528\u6237\u6743\u9650\uFF1A" v-show="data[\'userType\'] === \'role\' ">\n                <el-input v-model="data[\'userRoleName\']" style="width:60%" :disabled="true"></el-input>\n                <el-button type="primary" @click="showRole({id:\'userRole\', name:\'userRoleName\'})">\u9009\u62E9</el-button>\n              </el-form-item>\n              <el-form-item label="\u7528\u6237\u6743\u9650" v-show="false">\n                <el-input v-model="data[\'userRole\']" :disabled="true"></el-input>\n              </el-form-item>\n              <table class="inner_table">\n                  <colgroup>\n                    <col style="width:108px">\n                    <col style="width:108px">\n                    <col style="width:29px">\n                  </colgroup>\n                  <tbody>\n                    <tr><th>\u6761\u4EF6</th><th>\u6743\u9650</th><th><i class="fa fa-plus-square" @click="addConditionRoleRow()" title="\u65B0\u589E"></i></th></tr>\n                    <tr :key="idx" v-for="(it,idx) in data.conditionRoles">\n                    <td ><input style="width: 100px;line-height: 25px;" type=\'text\' :title="it[\'condition\']" v-model="it[\'condition\']"/></td>\n                    <td >\n                    <input style="width: 100px;line-height: 25px;" type=\'text\' readonly :title="it[\'roleName\']" @focus="showMulRole(idx,{id:\'roleId\', name:\'roleName\'})" v-model="it[\'roleName\']"/>\n                    <input type=\'text\' readonly :title="it[\'roleId\']"  v-model="it[\'roleId\']" v-show="false"/>\n                    </td>\n                    <td ><i class="fa fa-minus-square" @click="deleteConditionRoleRow(idx)"></i></td>\n                    </tr>\n                  </tbody>\n              </table>\n            </el-row>\n            <el-form-item label="\u7528\u6237\u5B57\u6BB5\uFF1A" v-show="data[\'userType\']=== \'biz\' ">\n                <el-input v-model="data[\'userField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'userType\'] === \'handled-user\' ">\n                <el-input v-model="data[\'userHandledActName\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'userHandled\', name:\'userHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'userHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u6392\u9664\u6761\u4EF6\uFF1A">\n              <el-radio-group v-model="data[\'excludeSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u6392\u9664\u8303\u56F4\uFF1A" v-show="data[\'excludeSwitch\']== \'1\' ">\n                <el-select v-model="data[\'excludeType\']">\n                  <el-option\n                    v-for="item in excludeTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="B\u89D2\u63A7\u5236\uFF1A">\n              <el-radio-group v-model="data[\'bRoleSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="B\u76F8\u5BF9A\u90E8\u95E8\uFF1A" v-show="data[\'bRoleSwitch\'] === \'1\' ">\n                <el-select v-model="data[\'aGroupScope\']">\n                  <el-option\n                    v-for="item in aGroupScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="B\u7528\u6237\u6743\u9650\uFF1A" v-show="data[\'bRoleSwitch\'] === \'1\' ">\n              <el-input v-model="data[\'bUserRoleName\']" style="width:60%" :disabled="true"></el-input>\n              <el-button type="primary" @click="showRole({id:\'bUserRole\', name:\'bUserRoleName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="B\u7528\u6237\u6743\u9650" v-show="false">\n              <el-input v-model="data[\'bUserRole\']" :disabled="true"></el-input>\n            </el-form-item>\n            \n            <el-form-item label="\u5B8C\u6210\u6761\u4EF6\uFF1A">\n              <el-input v-model="data[\'completeCondition\']"></el-input>\n            </el-form-item>\n          <el-form-item label="\u90E8\u95E8\u5185\u62A2\u529E\uFF1A">\n              <el-radio-group v-model="data[\'autoCompleteDepartmentTask\']" size="mini">\n                <el-radio-button label="true">\u5F00</el-radio-button>\n                <el-radio-button label="false">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n          </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u8868\u5355\u63A7\u5236" name="3">\n           <el-form  label-width="92px">\n            <el-form-item label="\u64CD\u4F5C\u6309\u94AE\uFF1A">\n                <el-button type="primary" @click="showFlowButton()">\u9009\u62E9</el-button>\n            </el-form-item>\n            <div style="padding:5px;border:1px #ddd solid" v-show="data.buttons.length>0">\n              <el-button  :key="button.id" v-for="button in data.buttons">{{button.name}}\n              </el-button>\n            </div>\n            <el-form-item label="\u64CD\u4F5C\u6743\u9650\uFF1A">\n                <el-button type="primary" @click="showFormOperAuth()">\u9009\u62E9</el-button>\n            </el-form-item>\n             <div style="padding:5px;border:1px #ddd solid" v-show="data.operAuths.length>0">\n                 <el-button  :key="auth.id" v-for="auth in data.operAuths">{{auth.name}}\n                 </el-button>\n            </div>\n               <el-form-item label="\u5207\u6362\u8868\u5355\uFF1A">\n                <el-button type="primary" @click="showRelateForm()">\u9009\u62E9</el-button>\n               </el-form-item>\n               <div style="padding:5px;border:1px #ddd solid" v-show="data.openFormId">\n                   <div v-text="data.openFormName"></div>\n            </div>\n            <el-form-item label="\u53EF\u9000\u56DE\u8282\u70B9\uFF1A">\n                <el-input v-model="data[\'canRejectActivityNames\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showCanRejectNodes({id:\'canRejectActivityIds\', name:\'canRejectActivityNames\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u53EF\u9000\u56DE\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'canRejectActivityIds\']" :disabled="true"></el-input>\n              </el-form-item>\n           <el-form-item label="\u542F\u7528\u4F20\u9605\uFF1A">\n              <el-radio-group v-model="data[\'circularSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u4F20\u9605\u8303\u56F4\uFF1A" v-show="data[\'circularSwitch\']===\'1\'">\n                <el-select v-model="data[\'circularScope\']">\n                  <el-option\n                    v-for="item in circularScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u4F20\u9605\u79D8\u4E66\u4EE3\u529E\uFF1A"  v-show="data[\'circularSwitch\']===\'1\'">\n                <el-radio-group v-model="data[\'circularSecretarySwitch\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u79D8\u4E66\u8282\u70B9\u540D\uFF1A" v-show="data[\'circularSwitch\']===\'1\' && data[\'circularSecretarySwitch\']===\'1\'">\n                    <el-input v-model="data[\'circularSecActivityName\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u8282\u70B9\u540D\uFF1A" v-show="data[\'circularSwitch\']===\'1\' && data[\'circularSecretarySwitch\']===\'1\'">\n                    <el-input v-model="data[\'circularLeaderActivityName\']"></el-input>\n                </el-form-item>\n            <el-form-item label="\u542F\u7528\u8F6C\u529E\uFF1A">\n              <el-radio-group v-model="data[\'transmitSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u8F6C\u529E\u8303\u56F4\uFF1A" v-show="data[\'transmitSwitch\']===\'1\'">\n                <el-select v-model="data[\'transmitScope\']">\n                  <el-option\n                    v-for="item in transmitScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n               <el-form-item label="\u610F\u89C1\u63A7\u5236\uFF1A">\n              <el-radio-group v-model="data[\'commentSwitch\']" size="mini">\n                <el-radio-button label="1">\u5C55\u5F00</el-radio-button>\n                <el-radio-button label="0">\u6298\u53E0</el-radio-button>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u610F\u89C1\u5206\u7C7B\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-input v-model="data[\'commentCategory\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u610F\u89C1\u5E8F\u53F7\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-input v-model="data[\'commentSn\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u9ED8\u8BA4\u610F\u89C1\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-input v-model="data[\'defaultComment\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u586B\u5199\u591A\u6761\u610F\u89C1\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-radio-group v-model="data[\'moreCommentSwitch\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u4FEE\u6539\u610F\u89C1\u8303\u56F4\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-select v-model="data[\'commentModifyScope\']">\n                  <el-option\n                    v-for="item in commentModifyScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u68C0\u67E5\u65B9\u5F0F\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-select v-model="data[\'commentCheckMode\']">\n                  <el-option\n                    v-for="item in commentCheckModes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n              </el-form-item>\n              <el-form-item label="\u5B8C\u6210\u5F3A\u5236\u586B\u5199\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-select v-model="data[\'completeComment\']">\n                  <el-option\n                    v-for="item in mandatoryOptions"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n               </el-form-item>\n               <el-form-item label="\u8F6C\u529E\u5F3A\u5236\u586B\u5199\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                 <el-select v-model="data[\'transmitComment\']">\n                  <el-option\n                    v-for="item in mandatoryOptions"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n               </el-form-item>\n               <el-form-item label="\u9000\u56DE\u5F3A\u5236\u586B\u5199\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n               <el-select v-model="data[\'rejectComment\']">\n                  <el-option\n                    v-for="item in mandatoryOptions"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n               </el-form-item>\n               <el-form-item label="\u53EA\u8BFB:" >\n                  <el-radio-group v-model="data[\'readOnly\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u9644\u4EF6\u53EF\u7F16\u8F91:" >\n                  <el-radio-group v-model="data[\'editAttach\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n               </el-form-item>\n                <el-form-item label="\u9644\u4EF6\u53EF\u4E0A\u4F20:" >\n                  <el-radio-group v-model="data[\'uploadAttach\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n                </el-form-item> \n                <el-form-item label="\u9644\u4EF6\u53EF\u4E0B\u8F7D:" >\n                  <el-radio-group v-model="data[\'downloadAttach\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n                </el-form-item> \n                <el-form-item label="\u6B63\u6587\u6253\u5F00\u65B9\u5F0F:" >\n                    <el-input v-model="data[\'attchOct\']" style="width:calc(100% - 48px);"></el-input>\n                    <el-button type="primary" @click="showOcxList">\u9009\u62E9</el-button>\n                </el-form-item> \n            </el-form>\n        </el-collapse-item>\n          <el-collapse-item title="\u79D8\u4E66\u4EE3\u529E" name="4">\n            <el-form  label-width="92px">\n              <el-form-item label="\u542F\u7528\u79D8\u4E66\u4EE3\u529E\uFF1A">\n              <el-radio-group v-model="data[\'secretarySwitch\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u79D8\u4E66\u4EE3\u529E\u6D41\u7A0B\uFF1A" v-show="data[\'secretarySwitch\']===\'1\'">\n               <el-radio-group v-model="data[\'secretarySubProcSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u4EE3\u529E\u6D41\u7A0B\u540D\u79F0\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'secSubProcessDefName\']" style="width:60%;" :disabled="true"></el-input>\n                    <el-button type="primary" @click="showSubProcess">\u9009\u62E9</el-button>\n                </el-form-item>\n                <el-form-item label="\u4EE3\u529E\u6D41\u7A0BKey" v-show="false">\n                    <el-input v-model="data[\'secSubProcessDefKey\']" :disabled="true"></el-input>\n                </el-form-item>\n                 <el-form-item label="\u4EE3\u529E\u6D41\u7A0B\u6A21\u5757" v-show="false">\n                <el-input v-model="data[\'secSubProcessModuleId\']" :disabled="true"></el-input>\n                <el-input v-model="data[\'secSubProcessApplicationId\']" :disabled="true"></el-input>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u4EE3\u529E\u8282\u70B9\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessSecActivityName\']" style="width:60%;" :disabled="true"></el-input>\n                    <el-button type="primary" @click="showSubProcessNode(\'subProcessSecActivityId\', \'subProcessSecActivityName\')">\u9009\u62E9</el-button>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u4EE3\u529E\u8282\u70B9ID" v-show="false">\n                    <el-input v-model="data[\'subProcessSecActivityId\']" :disabled="true"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u4EE3\u529E\u8282\u70B9\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessLeaderActivityName\']" style="width:60%;" :disabled="true"></el-input>\n                    <el-button type="primary" @click="showSubProcessNode(\'subProcessLeaderActivityId\', \'subProcessLeaderActivityName\')">\u9009\u62E9</el-button>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u4EE3\u529E\u8282\u70B9ID" v-show="false">\n                    <el-input v-model="data[\'subProcessLeaderActivityId\']" :disabled="true"></el-input>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u8282\u70B9\u63D0\u793A" v-show="false && data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessSecActivityTip\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u8282\u70B9\u63D0\u793A" v-show="false && data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessLeaderActivityTip\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u8282\u70B9\u540D\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'0\'">\n                    <el-input v-model="data[\'secActivityName\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u8282\u70B9\u540D\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'0\'">\n                    <el-input v-model="data[\'leaderActivityName\']"></el-input>\n                </el-form-item>\n               <el-form-item label="\u4EE3\u5F55\u8282\u70B9\u6D41\u5411\uFF1A">\n                <el-input v-model="data[\'canAgentRecordFlowNames\']"  :disabled="true" style="width:50%"></el-input>\n                <el-button type="primary" @click="showCanAgentRecordFlows({id:\'canAgentRecordFlowIds\', name:\'canAgentRecordFlowNames\'})">\u9009\u62E9</el-button>\n                 <el-tooltip placement="top" style="width:10%">\n                  <div slot="content">\n                  \u914D\u7F6E"\u865A\u62DF\u65E5\u5FD7"\u64CD\u4F5C\u6309\u94AE\u540E\u751F\u6548</div>\n                  <i class="el-icon-question"></i>\n                </el-tooltip>\n               </el-form-item>\n               <el-form-item label="\u4EE3\u5F55\u8282\u70B9ID" v-show="false">\n                  <el-input v-model="data[\'canAgentRecordFlowIds\']" :disabled="true"></el-input>\n              </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u79FB\u52A8\u914D\u7F6E" name="6">\n          <el-form  label-width="92px">\n              <el-form-item label="\u662F\u5426\u529E\u7406:" >\n                  <el-radio-group v-model="data[\'mobileHandler\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u8868\u5355\u7F16\u8F91:" >\n                  <el-radio-group v-model="data[\'mobileEdit\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u7F16\u8F91\u6B63\u6587:" >\n                  <el-radio-group v-model="data[\'mobileZWEdit\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u7F16\u8F91\u9644\u4EF6:" >\n                  <el-radio-group v-model="data[\'mobileFJEdit\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u4E0A\u4F20\u9644\u4EF6:" >\n                  <el-radio-group v-model="data[\'mobileFJUpload\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n          </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u5176\u4ED6" name="5">\n           <el-form  label-width="92px">\n              <el-form-item label="\u65F6\u9650\u63A7\u5236\uFF1A">\n              <el-radio-group v-model="data[\'timeSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u65F6\u95F4\u7C7B\u578B\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                <el-select v-model="data[\'timeType\']">\n                  <el-option\n                    v-for="item in timeTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u7B7E\u6536\u9650\u529E\u65F6\u95F4\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                  <el-input v-model="data[\'claimLimitedTime\']"></el-input>\n              </el-form-item>\n              <el-form-item label="\u529E\u6BD5\u9650\u529E\u65F6\u95F4\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                  <el-input v-model="data[\'finishLimitedTime\']"></el-input>\n              </el-form-item>\n              <el-form-item label="\u81EA\u52A8\u6D41\u8F6C\u610F\u89C1\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                  <el-input v-model="data[\'autoLZYJ\']"></el-input>\n              </el-form-item>\n              <el-form-item label="\u6267\u884C\u811A\u672C\uFF1A">\n                <el-button type="primary" @click="showFlowScriptSet(\'node\')">\u8BBE\u7F6E</el-button>\n            </el-form-item>\n            <el-form-item label="\u662F\u5426\u9886\u5BFC\u8282\u70B9\uFF1A">\n              <el-select v-model="data[\'leaderNode\']">\n                  <el-option\n                    v-for="item in groupYesNo"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u662F\u5426\u5B9A\u5BC6\u8282\u70B9\uFF1A">\n              <el-select v-model="data[\'densityNode\']">\n                  <el-option\n                    v-for="item in groupYesNo"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n      </el-collapse>\n    </div>\n    ',















































































































































































































































































































































































































































































































    props: {
      data: {
        type: Object },

      params: {
        type: Object } },


    data: function data() {
      return {
        fields: ['id', 'name', 'mark', 'completeCondition', 'autoCompleteDepartmentTask', 'type', 'sn', 'groupType', 'group', 'relativeGroup', 'relativeGroupName',
        'groupField', 'groupHandled', 'groupHandledActName', 'userType', 'userRole', 'userRoleName', 'conditionRoles', 'userField', 'userHandledActName',
        'userHandled', 'excludeSwitch', 'buttons', 'scriptActions', 'operAuths', 'timeSwitch', 'timeType', 'claimLimitedTime', 'finishLimitedTime', 'autoLZYJ',
        'excludeType', 'bRoleSwitch', 'aGroupScope', 'bUserRole', 'bUserRoleName',
        'canRejectActivityIds', 'canRejectActivityNames', 'transmitSwitch',
        'transmitScope', 'commentSwitch', 'commentCategory', 'commentSn',
        'defaultComment', 'moreCommentSwitch', 'commentModifyScope', 'commentCheckMode', 'completeComment', 'transmitComment', 'rejectComment',
        'circularSwitch', 'circularScope', 'circularSecretarySwitch', 'circularSecActivityName', 'circularLeaderActivityName',
        'secretarySwitch', 'secretarySubProcSwitch', 'secSubProcessDefName', 'secSubProcessDefKey', 'secSubProcessModuleId', 'secSubProcessApplicationId',
        'subProcessSecActivityName', 'subProcessSecActivityId', 'subProcessLeaderActivityName', 'subProcessLeaderActivityId',
        'subProcessSecActivityTip', 'subProcessLeaderActivityTip', 'secActivityName', 'leaderActivityName', 'readOnly', 'editAttach', 'uploadAttach', 'downloadAttach', 'attchOct', 'attchOctKey',
        'mobileHandler', 'mobileEdit', 'mobileZWEdit', 'mobileFJEdit', 'mobileFJUpload',
        'canAgentRecordFlowNames', 'canAgentRecordFlowIds', 'openFormId', 'openFormName', 'leaderNode', 'densityNode'],

        activeName: '1',
        types: [],
        groupTypes: [{ value: 'role', label: '权限' }, { value: 'relative', label: '相对部门' }, { value: 'handled-group', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'upper-group', label: '发送部门' }, { value: 'draft-group', label: '发起部门' }],
        groups: [{ value: '<当前>', label: '<当前>' }, { value: '<上级>', label: '<上级>' }, { value: '<下级>', label: '<下级>' }, { value: '<平级>', label: '<平级>' },
        { value: '<当前和上级>', label: '<当前和上级>' }, { value: '<当前和下级>', label: '<当前和下级>' },
        { value: '<所有下级>', label: '<所有下级>' }, { value: '<上级的平级>', label: '<上级的平级>' },
        { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<部门上级>', label: '<部门上级>' }, { value: '<部门下级>', label: '<部门下级>' }, { value: '<部门平级>', label: '<部门平级>' },
        { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<本单位任选(不包含下级)>', label: '<本单位任选(不包含下级)>' },
        { value: '<本单位的一级部门>', label: '<本单位的一级部门>' }, { value: '<单位上级>', label: '<单位上级>' }, { value: '<单位平级>', label: '<单位平级>' },
        { value: '<上级单位部门>', label: '<上级单位部门>' }, { value: '<上级单位任选>', label: '<上级单位任选>' }],
        userTypes: [{ value: 'role', label: '权限' }, { value: 'handled-user', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'draft-user', label: '发起人' }, { value: 'upper-user', label: '发送人' }],
        circularScopes: [{ value: '<当前>', label: '<当前>' }, { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<任选>', label: '<任选>' }],
        timeTypes: [{ value: 'work', label: '工作时间(单位:h)' }, { value: 'reality', label: '实际时间(单位:h)' }, { value: 'biz', label: '业务字段' }],
        transmitScopes: [{ value: '<当前>', label: '<当前>' }, { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<任选>', label: '<任选>' }],
        excludeTypes: [{ value: 'current-user', label: '当前用户' }, { value: 'current-dep', label: '当前部门' }],
        commentCheckModes: [{ value: 'task', label: '当前环节' }, { value: 'activity', label: '当前节点' }, { value: 'doc', label: '当前文档' }],
        commentModifyScopes: [{ value: 'disabled', label: '禁止' }, { value: 'self', label: '本人' }, { value: 'all', label: '所有人' }],
        mandatoryOptions: [{ value: 'no', label: '否' }, { value: 'remind', label: '提示' }, { value: 'yes', label: '是' }],
        aGroupScopes: [{ value: '<当前>', label: '<当前>' }, { value: '<本部门任选>', label: '<本部门任选>' }],
        groupYesNo: [{ value: '1', label: '是' }, { value: '0', label: '否' }] };

    },
    created: function created() {
      var me = this;
      me.clearField();
      me.types = me.params.activityTypes;
      me.initData();
    },
    watch: {
      'data.name': function dataName(val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", { id: me.data.id, name: val });
        }
      },
      'data.id': function dataId(val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name;
          this.$set(this.data, 'name', '新增节点');
        }
        this.initData();
      } },

    methods: {
      initData: function initData() {
        var me = this;
        if (this.data.openFormId == undefined) {
          this.$set(this.data, 'openFormId', '');
          this.$set(this.data, 'openFormName', '');
        }
        if (this.data.conditionRoles == undefined) {
          this.$set(this.data, 'conditionRoles', []);
        }

        if (me.data.name == undefined) {
          this.$set(me.data, 'name', '新增节点');
        }
        if (this.data.excludeSwitch == undefined) {
          this.$set(this.data, 'excludeSwitch', '0');
        }
        if (this.data.buttons == undefined) {
          this.$set(this.data, 'buttons', []);
        }
        if (this.data.scriptActions == undefined) {
          this.$set(this.data, 'scriptActions', {});
        }
        if (this.data.operAuths == undefined) {
          this.$set(this.data, 'operAuths', []);
        }
        if (this.data.type == undefined) {
          this.$set(this.data, 'type', 'parallel');
        }

        if (this.data.groupType == undefined) {
          this.$set(this.data, 'groupType', this.groupTypes[0].value);
        }

        if (this.data.group == undefined) {
          this.$set(this.data, 'group', '<当前>');
        }

        if (this.data.userType == undefined) {
          this.$set(this.data, 'userType', this.userTypes[0].value);
        }

        if (this.data.mobileHandler == undefined) {
          this.$set(this.data, 'mobileHandler', "1");
        }
        if (this.data.mobileEdit == undefined) {
          this.$set(this.data, 'mobileEdit', "0");
        }
        if (this.data.mobileZWEdit == undefined) {
          this.$set(this.data, 'mobileZWEdit', "0");
        }
        if (this.data.mobileFJEdit == undefined) {
          this.$set(this.data, 'mobileFJEdit', "0");
        }
        if (this.data.mobileFJUpload == undefined) {
          this.$set(this.data, 'mobileFJUpload', "1");
        }
        if (this.data.readOnly == undefined) {
          this.$set(this.data, 'readOnly', "0");
        }
        if (this.data.editAttach == undefined) {
          this.$set(this.data, 'editAttach', "1");
        }
        if (this.data.uploadAttach == undefined) {
          this.$set(this.data, 'uploadAttach', "1");
        }
        if (this.data.downloadAttach == undefined) {
          this.$set(this.data, 'downloadAttach', "1");
        }
        if (this.data.attchOctKey == undefined) {
          this.$set(this.data, 'attchOctKey', "");
        }
        if (this.data.attchOct == undefined) {
          this.$set(this.data, 'attchOct', "无");
        }
        if (this.data.circularSwitch == undefined) {
          this.$set(this.data, 'circularSwitch', '0');
        }
        if (me.data.mark == undefined) {
          this.$set(me.data, 'mark', '');
        }
        if (me.data.completeCondition == undefined) {
          this.$set(me.data, 'completeCondition', '');
        }
        if (me.data.autoCompleteDepartmentTask == undefined) {
          this.$set(me.data, 'autoCompleteDepartmentTask', '');
        }
        if (this.data.circularScope == undefined) {
          this.$set(this.data, 'circularScope', this.circularScopes[0].value);
        }
        if (this.data.circularSecretarySwitch == undefined) {
          this.$set(this.data, 'circularSecretarySwitch', '0');
        }

        if (this.data.timeSwitch == undefined) {
          this.$set(this.data, 'timeSwitch', '0');
        }
        if (this.data.timeType == undefined) {
          this.$set(this.data, 'timeType', 'work');
        }
        if (this.data.excludeType == undefined) {
          this.$set(this.data, 'excludeType', this.excludeTypes[0].value);
        }
        if (this.data.bRoleSwitch == undefined) {
          this.$set(this.data, 'bRoleSwitch', '0');
        }
        if (this.data.aGroupScope == undefined) {
          this.$set(this.data, 'aGroupScope', '<当前>');
        }
        if (this.data.transmitSwitch == undefined) {
          this.$set(this.data, 'transmitSwitch', '0');
        }
        if (this.data.transmitScope == undefined) {
          this.$set(this.data, 'transmitScope', this.transmitScopes[0].value);
        }
        if (this.data.secretarySwitch == undefined) {
          this.$set(this.data, 'secretarySwitch', '0');
        }
        if (this.data.secretarySubProcSwitch == undefined) {
          this.$set(this.data, 'secretarySubProcSwitch', '0');
        }
        if (this.data.commentSwitch == undefined) {
          this.$set(this.data, 'commentSwitch', '0');
        }
        if (this.data.moreCommentSwitch == undefined) {
          this.$set(this.data, 'moreCommentSwitch', '0');
        }
        if (this.data.commentModifyScope == undefined) {
          this.$set(this.data, 'commentModifyScope', 'self');
        }
        if (this.data.commentCheckMode == undefined) {
          this.$set(this.data, 'commentCheckMode', this.commentCheckModes[0].value);
        }
        if (this.data.completeComment == undefined) {
          this.$set(this.data, 'completeComment', 'no');
        }
        if (this.data.transmitComment == undefined) {
          this.$set(this.data, 'transmitComment', 'no');
        }
        if (this.data.rejectComment == undefined) {
          this.$set(this.data, 'rejectComment', 'no');
        }
        if (this.data.leaderNode == undefined) {
          this.$set(this.data, 'leaderNode', '0');
        }
        if (this.data.densityNode == undefined) {
          this.$set(this.data, 'densityNode', '0');
        }

      },
      addConditionRoleRow: function addConditionRoleRow() {
        var me = this;
        me.data.conditionRoles.push({ condition: '', roleId: '', roleName: '' });
      },
      deleteConditionRoleRow: function deleteConditionRoleRow(idx) {
        this.data.conditionRoles.splice(idx, 1);
      },
      showMulRole: function showMulRole(idx) {
        var me = this;
        var data = me.data.conditionRoles[idx];
        var selectNode = '';
        if (data && data.roleId) {
          selectNode = data.roleId;
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listFlowGroupedRole"), selectFirst: false, selectNode: selectNode, search: true, clearBtn: true }, function (res) {
          me.$set(data, "roleId", res.id);
          me.$set(data, "roleName", res.name);
        });
      },
      showRelateForm: function showRelateForm() {
        var me = this;
        var moduleId = me.params.moduleId;
        var appId = me.params.applicationId;

        PF.show('tableDialog', { api: "app.listModuleForm", clearBtn: true,
          defaultParams: { moduleId: moduleId, appId: appId }, singleSelect: true }, function (res) {
          if (res.length > 0) {
            me.$set(me.data, 'openFormId', res[0].id);
            me.$set(me.data, 'openFormName', res[0].name);
          } else {
            me.$set(me.data, 'openFormId', "");
            me.$set(me.data, 'openFormName', "");
          }
        });

      },
      showHandledNode: function showHandledNode(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        PF.show('tree', {
          treeData: me._getActivities(['start', 'end', 'circular', 'sub-proc']), selectFirst: false, selectNode: selectNode },
        function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });
      },
      showOcxList: function showOcxList() {
        var me = this;
        PF.show('tree', { url: me.mwUrl("/api/data/getOcxList"), selectFirst: false, selectNode: "", search: true, async: true, singleLeaf: true }, function (res) {
          me.$set(me.data, 'attchOct', res.name || "");
          me.$set(me.data, 'attchOctKey', res.key || "");
        });
      },
      showFlowMarks: function showFlowMarks() {
        var me = this;
        var flowMarks = me.params.flowMarks || "";
        if (!flowMarks) {
          PF.message("请在模块设置中配置流程标识");
          return;
        }
        flowMarks = _.uniq(flowMarks.split(","));
        var treeData = [];
        _.each(flowMarks, function (v) {treeData.push({ id: v, name: v });});
        var checkNodes = (me.data.mark || "").split(",");
        PF.show('tree', { treeData: treeData, checkNodes: checkNodes, multiple: true, clearBtn: true }, function (res) {
          var marks = [];
          _.each(res, function (v) {
            marks.push(v.name);
          });
          me.$set(me.data, 'mark', marks.join(","));
        });
      },
      showCanRejectNodes: function showCanRejectNodes(f) {
        var me = this;
        var checkNodes;
        if (me.data[f.id]) {
          checkNodes = me.data[f.id].split(',');
        }
        PF.show('tree', { treeData: me._getActivities(['start', 'end', 'circular', 'sub-proc']), checkNodes: checkNodes, multiple: true, clearBtn: true }, function (res) {
          var activityNames = [];
          var activityIds = [];
          res.forEach(function (item) {
            activityNames.push(item.name);
            activityIds.push(item.id);
          });

          me.$set(me.data, f.id, activityIds.join(','));
          me.$set(me.data, f.name, activityNames.join(','));
        });
      },
      showCanAgentRecordNodes: function showCanAgentRecordNodes(f) {
        var me = this;
        var checkNodes;
        if (me.data[f.id]) {
          checkNodes = me.data[f.id].split(',');
        }
        PF.show('tree', { treeData: me._getCanAgentRecordNextActivities(['start', 'end', 'circular', 'sub-proc']), checkNodes: checkNodes, multiple: true, clearBtn: true }, function (res) {
          var activityNames = [];
          var activityIds = [];
          res.forEach(function (item) {
            activityNames.push(item.name);
            activityIds.push(item.id);
          });
          me.$set(me.data, f.id, activityIds.join(','));
          me.$set(me.data, f.name, activityNames.join(','));
        });
      },
      showCanAgentRecordFlows: function showCanAgentRecordFlows(f) {
        var me = this;
        var checkFlows;
        if (me.data[f.id]) {
          checkFlows = me.data[f.id].split(',');
        }
        PF.show('tree', { treeData: me._getCanAgentRecordFlows(['start', 'end', 'circular', 'sub-proc']), checkNodes: checkFlows, multiple: true, clearBtn: true }, function (res) {
          var flowNames = [];
          var flowIds = [];
          res.forEach(function (item) {
            flowNames.push(item.name);
            flowIds.push(item.id);
          });
          me.$set(me.data, f.id, flowIds.join(','));
          me.$set(me.data, f.name, flowNames.join(','));
        });
      },
      showDept: function showDept() {
        var me = this;
        var selectNode = '';
        if (me.data['relativeGroup']) {
          selectNode = me.data['relativeGroup'];
        }
        PF.show('tree', {
          url: this.mwUrl("/api/org/listDepartment"), selectFirst: false, selectNode: selectNode,
          search: true,
          async: true,
          singleLeaf: false },
        function (res) {
          me.$set(me.data, 'relativeGroup', res.id);
          me.$set(me.data, 'relativeGroupName', res.name);
        });
      },
      showRole: function showRole(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        var params;
        if (parent && parent.propAuthUnit) {
          params = { authUnitFilter: true };
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listFlowGroupedRole"), selectFirst: false, defaultParams: params, selectNode: selectNode, search: true, clearBtn: true }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });
      },
      showFlowButton: function showFlowButton() {
        var me = this;
        var value = [];
        for (var i = 0; i < me.data.buttons.length; i++) {
          value.push(me.data.buttons[i].action);
        }
        PF.show('treeTable', {
          url: me.mwUrl("/api/app/listActionComponentByTypeTree"), treeDefaultParams: { type: "系统分类/表单/流程", flag: 0 },
          size: 'small_large',
          selectFirst: true, asyncLoadOnce: true, clearBtn: true, title: '选择动作脚本', changed: function changed(data) {
            var me = this;
            me.defaultParams = { type: data.code, flag: 2 };
          }, api: 'app.getAllButton', singleSelect: false },
        function (res) {
          var btns = [];
          if (res && res.length > 0) {
            res.forEach(function (v) {
              btns.push({ name: v.name, action: v.action });
            });
          }
          me.$set(me.data, 'buttons', btns);
        });
      },
      showFlowScriptSet: function showFlowScriptSet(type) {
        var me = this;
        var p = {};
        p.type = type;
        var scriptActions = me.data.scriptActions;
        if (scriptActions) {
          p.scriptActions = scriptActions;
        } else {
          p.scriptActions = {};
        }
        PF.show('flowScriptSet', p, function (res) {
          me.$set(me.data, 'scriptActions', res);
        });
      },
      showFormOperAuth: function showFormOperAuth() {
        var me = this;
        var moduleId = me.params.moduleId;
        var appId = me.params.applicationId;
        var checkNodes = [];
        for (var i = 0; i < me.data.operAuths.length; i++) {
          checkNodes.push(me.data.operAuths[i].id);
        }
        PF.show('tree', { url: this.mwUrl(
          "/api/app/listModuleFormOperAuthTree"), checkNodes: checkNodes, search:
          true, multiple: true, singleLeaf: false, clearBtn: true, multipleLeaf: false,
          defaultParams: { moduleId: moduleId, appId: appId } }, function (res) {
          var auths = [];
          if (res && res.length > 0) {
            res.forEach(function (v) {
              if (v.id) {
                auths.push({ name: v.name, id: v.id });
              }
            });
          }
          me.$set(me.data, 'operAuths', auths);
        });
      },
      clearField: function clearField() {
        var me = this;

        function contains(obj) {
          for (var i = 0; i < me.fields.length; i++) {
            if (me.fields[i] == obj) {
              return true;
            }
          }
          return false;
        }

        var del = [];
        for (var s in me.data) {
          if (!contains(s)) {
            del.push(s);
          }
        }
        for (var i = 0; i < del.length; i++) {
          delete me.data[del[i]];
        }
      },
      changeType: function changeType(val) {
        parent.$emit("updateShape", { id: this.data.id, type: val });
        this.params.changeType(val);
      },
      showSubProcess: function showSubProcess() {
        var me = this;
        var selectNode = '';
        if (me.data.secSubProcessDefKey) {
          if (me.data.secSubProcessModuleId) {
            selectNode = me.data.secSubProcessDefKey + '|' + me.data.secSubProcessModuleId;
          } else {
            selectNode = me.data.secSubProcessDefKey;
          }
        }
        PF.show('tree', { url: this.mwUrl("/api/process/listModuleLatestProcDefTree"), singleLeaf: true, selectFirst: false, selectNode: selectNode, search: true, defaultParams: { sysId: me.params.sysId } }, function (res) {
          if (res) {
            if (res.id) {
              var ids = res.id.split('|');
              me.$set(me.data, 'secSubProcessDefKey', ids[0]);
              if (ids.length > 1) {
                me.$set(me.data, 'secSubProcessModuleId', ids[1]);
              }
            } else {
              me.$set(me.data, 'secSubProcessDefKey', res.id);
              me.$set(me.data, 'secSubProcessModuleId', res.id);
            }
            me.$set(me.data, 'secSubProcessDefName', res.name);
            me.$set(me.data, 'secSubProcessApplicationId', res.appId);
            me.$set(me.data, 'secSubProcessModuleId', res.moduleId);
            delete me.data.subProcessSecActivityId;
            delete me.data.subProcessSecActivityName;
            delete me.data.subProcessLeaderActivityId;
            delete me.data.subProcessLeaderActivityName;
          }
        });
      },
      showSubProcessNode: function showSubProcessNode(fid, fname) {
        var me = this;
        var key = me.data.secSubProcessDefKey;
        if (key) {
          var selectNode = '';
          if (me.data[fid]) {
            selectNode = me.data[fid];
          }
          var appId = me.params.applicationId;
          if (me.data.secSubProcessApplicationId) {
            appId = me.data.secSubProcessApplicationId;
          }
          PF.show('tree', { url: this.mwUrl("/api/process/getSubProcessStartActivities"), selectFirst: false, selectNode: selectNode, defaultParams: { key: key, appId: appId } }, function (res) {
            me.$set(me.data, fid, res.id);
            me.$set(me.data, fname, res.name);
          });
        }
      },
      _getActivities: function _getActivities(excludeActivityTypes) {
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var treeData = [];
        var exclude;
        activities.forEach(function (a) {
          exclude = false;
          excludeActivityTypes.forEach(function (et) {
            if (et == a.extends) {
              exclude = true;
            }
          });
          if (!exclude) {
            treeData.push({ id: a.id, text: a.parameters.name, name: a.parameters.name });
          }
        });
        return treeData;
      },
      _getCanAgentRecordNextActivities: function _getCanAgentRecordNextActivities(excludeActivityTypes) {
        var me = this;
        var currentNodeId = me.data.id;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var acts = {};
        activities.forEach(function (a) {
          acts[a.id] = a;
        });
        var treeData = [];
        var flows = processDataItems['SEQUENCE-FLOW'];
        var exclude;
        flows.forEach(function (f) {
          exclude = false;
          if (f.parameters.from == currentNodeId) {

            if ('startSubProcess' == f.parameters.type && 'DEP' == f.parameters.sendUnit) {
              exclude = true;
            }
            if (!exclude) {
              var act = acts[f.parameters.to];
              excludeActivityTypes.forEach(function (at) {
                if (at == act.extends) {
                  exclude = true;
                }
              });
              if (!exclude) {
                treeData.push({ id: act.id, text: act.parameters.name, name: act.parameters.name });
              }
            }
          }
        });
        return treeData;
      },
      _getCanAgentRecordFlows: function _getCanAgentRecordFlows(excludeActivityTypes) {
        var me = this;
        var currentNodeId = me.data.id;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var acts = {};
        var actNames = {};
        activities.forEach(function (a) {
          acts[a.id] = a;
          actNames[a.id] = a.parameters.name;
        });
        var treeData = [];
        var flows = processDataItems['SEQUENCE-FLOW'];
        var exclude;
        flows.forEach(function (f) {
          exclude = false;
          if (f.parameters.from == currentNodeId) {

            if ('startSubProcess' == f.parameters.type && 'DEP' == f.parameters.sendUnit) {
              exclude = true;
            }
            if (!exclude) {
              var act = acts[f.parameters.to];
              excludeActivityTypes.forEach(function (at) {
                if (at == act.extends) {
                  exclude = true;
                }
              });
              if (!exclude) {
                var name = f.parameters.name;
                if (!name) {
                  name = actNames[f.parameters.from] + '-' + actNames[f.parameters.to];
                }
                treeData.push({ id: f.id, text: name, name: name, sourceId_targetId: f.parameters.from + '-' + f.parameters.to });
              }
            }
          }
        });
        return treeData;
      } } };


  return node_parallel;
};

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (Vue, parent, _data) {
  var node_normal = {
    template: '\n    <div class=\'__config__body\'>\n      <el-collapse v-model="activeName" accordion>\n        <el-collapse-item title="\u57FA\u672C\u5C5E\u6027" name="1">\n           <el-form  label-width="65px">\n            <el-form-item label="\u552F\u4E00\u6807\u8BC6\uFF1A" v-show=false>\n                <el-input v-model="data[\'id\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u540D\u79F0\uFF1A">\n                <el-input v-model="data[\'name\']" :disabled="!params.editable"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u6807\u8BC6\uFF1A">\n                <el-input v-model="data[\'mark\']" style="width:calc(100% - 48px);"></el-input>\n                <el-button type="primary" @click="showFlowMarks()">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u5E8F\u53F7\uFF1A">\n                <el-input v-model="data[\'sn\']"></el-input>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u6D41\u7A0B\u63A7\u5236" name="2">\n           <el-form label-width="92px">\n            <el-form-item label="\u8282\u70B9\u7C7B\u578B\uFF1A">\n                <el-select @change=\'changeType\' v-model="data[\'type\']" :disabled="!params.editable">\n                  <el-option\n                    v-for="item in types"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n\n            <el-form-item label="\u529E\u7406\u90E8\u95E8\uFF1A">\n                <el-select v-model="data[\'groupType\']" @change=\'changeGroupType\'>\n                  <el-option\n                    v-for="item in groupTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u76F8\u5BF9\u90E8\u95E8\uFF1A" v-show="data[\'groupType\'] === \'relative\' ">\n                <el-input v-model="data[\'relativeGroupName\']" style="width:60%;" :disabled="true"></el-input>\n                <el-button type="primary" @click="showDept">\u9009\u62E9</el-button>\n            </el-form-item>\n             <el-form-item label="\u76F8\u5BF9\u90E8\u95E8" v-show="false">\n                  <el-input v-model="data[\'relativeGroup\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u5B57\u6BB5\uFF1A"  v-show="data[\'groupType\'] === \'biz\' ">\n                <el-input v-model="data[\'groupField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'groupType\'] === \'handled-group\' ">\n                <el-input v-model="data[\'groupHandledActName\']"  :disabled="true" style="width:60%;"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'groupHandled\', name:\'groupHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'groupHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n              <el-form-item label="\u90E8\u95E8\u8303\u56F4\uFF1A" v-show="data[\'groupType\']!=\'bind-group\'">\n                <el-select v-model="data[\'group\']">\n                  <el-option\n                    v-for="item in groups"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u529E\u7406\u7528\u6237\uFF1A">\n                <el-select v-model="data[\'userType\']">\n                  <el-option\n                    v-for="item in userTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            \n            <el-row v-show="data[\'userType\'] === \'role\' ">\n              <el-form-item label="\u7528\u6237\u6743\u9650\uFF1A" v-show="data[\'userType\'] === \'role\' ">\n                <el-input v-model="data[\'userRoleName\']" style="width:60%" :disabled="true"></el-input>\n                <el-button type="primary" @click="showRole({id:\'userRole\', name:\'userRoleName\'})">\u9009\u62E9</el-button>\n              </el-form-item>\n              <el-form-item label="\u7528\u6237\u6743\u9650" v-show="false">\n                <el-input v-model="data[\'userRole\']" :disabled="true"></el-input>\n              </el-form-item>\n              <table class="inner_table">\n                <colgroup>\n                  <col style="width:108px">\n                  <col style="width:108px">\n                  <col style="width:29px">\n                </colgroup>\n                <tbody>\n                  <tr><th>\u6761\u4EF6</th><th>\u6743\u9650</th><th><i class="fa fa-plus-square" @click="addConditionRoleRow()" title="\u65B0\u589E"></i></th></tr>\n                  <tr :key="idx" v-for="(it,idx) in data.conditionRoles">\n                  <td ><input style="width: 100px;line-height: 25px;" type=\'text\' :title="it[\'condition\']" v-model="it[\'condition\']"/></td>\n                  <td >\n                  <input style="width: 100px;line-height: 25px;" type=\'text\' readonly :title="it[\'roleName\']" @focus="showMulRole(idx,{id:\'roleId\', name:\'roleName\'})" v-model="it[\'roleName\']"/>\n                  <input type=\'text\' readonly :title="it[\'roleId\']"  v-model="it[\'roleId\']" v-show="false"/>\n                  </td>\n                  <td ><i class="fa fa-minus-square" @click="deleteConditionRoleRow(idx)"></i></td>\n                  </tr>\n                </tbody>\n              </table>\n            </el-row>\n            \n            <el-form-item label="\u7528\u6237\u5B57\u6BB5\uFF1A" v-show="data[\'userType\']=== \'biz\' ">\n                <el-input v-model="data[\'userField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'userType\'] === \'handled-user\' ">\n                <el-input v-model="data[\'userHandledActName\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'userHandled\', name:\'userHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'userHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u6392\u9664\u6761\u4EF6\uFF1A"  v-show="data[\'groupType\']!=\'bind-group\'">\n              <el-radio-group v-model="data[\'excludeSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u6392\u9664\u8303\u56F4\uFF1A" v-show="data[\'excludeSwitch\']== \'1\' && data[\'groupType\']!=\'bind-group\'">\n                <el-select v-model="data[\'excludeType\']">\n                  <el-option\n                    v-for="item in excludeTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="B\u89D2\u63A7\u5236\uFF1A" v-show="data[\'groupType\']!=\'bind-group\'">\n              <el-radio-group v-model="data[\'bRoleSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="B\u76F8\u5BF9A\u90E8\u95E8\uFF1A" v-show="data[\'bRoleSwitch\'] === \'1\' && data[\'groupType\']!=\'bind-group\' ">\n                <el-select v-model="data[\'aGroupScope\']">\n                  <el-option\n                    v-for="item in aGroupScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="B\u7528\u6237\u6743\u9650\uFF1A" v-show="data[\'bRoleSwitch\'] === \'1\' && data[\'groupType\']!=\'bind-group\' ">\n              <el-input v-model="data[\'bUserRoleName\']" style="width:60%" :disabled="true"></el-input>\n              <el-button type="primary" @click="showRole({id:\'bUserRole\', name:\'bUserRoleName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="B\u7528\u6237\u6743\u9650" v-show="false">\n              <el-input v-model="data[\'bUserRole\']" :disabled="true"></el-input>\n            </el-form-item>\n          </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u8868\u5355\u63A7\u5236" name="3">\n           <el-form  label-width="92px">\n            <el-form-item label="\u64CD\u4F5C\u6309\u94AE\uFF1A">\n                <el-button type="primary" @click="showFlowButton()">\u9009\u62E9</el-button>\n            </el-form-item>\n            <div style="padding:5px;border:1px #ddd solid" v-show="data.buttons.length>0">\n              <el-button  :key="button.id" v-for="button in data.buttons">{{button.name}}\n              </el-button>\n            </div>\n            <el-form-item label="\u64CD\u4F5C\u6743\u9650\uFF1A">\n                <el-button type="primary" @click="showFormOperAuth()">\u9009\u62E9</el-button>\n            </el-form-item>\n             <div style="padding:5px;border:1px #ddd solid" v-show="data.operAuths.length>0">\n                 <el-button  :key="auth.id" v-for="auth in data.operAuths">{{auth.name}}\n                 </el-button>\n            </div>\n            <el-form-item label="\u5207\u6362\u8868\u5355\uFF1A">\n                <el-button type="primary" @click="showRelateForm()">\u9009\u62E9</el-button>\n               </el-form-item>\n               <div style="padding:5px;border:1px #ddd solid" v-show="data.openFormId">\n                   <div v-text="data.openFormName"></div>\n            </div>\n            <el-form-item label="\u9ED8\u8BA4\u9009\u4E2D\u6D41\u5411\uFF1A">\n                <el-input v-model="data.defaultSelectActivityName"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showDefaultSelectFlows()">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u9ED8\u8BA4\u9009\u4E2D\u6D41\u5411ID\uFF1A" v-show="false">\n                <el-input v-model="data.defaultSelectActivityId"  :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u53EF\u9000\u56DE\u8282\u70B9\uFF1A">\n                <el-input v-model="data[\'canRejectActivityNames\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showCanRejectNodes({id:\'canRejectActivityIds\', name:\'canRejectActivityNames\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u53EF\u9000\u56DE\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'canRejectActivityIds\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u62DF\u529E\u6D41\u5411\uFF1A">\n                <el-input v-model="data[\'plannedFlowActivityNames\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showPlannedActivityFlows()">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u62DF\u529E\u6D41\u5411ID" v-show="false">\n                  <el-input v-model="data[\'plannedFlowIds\']" :disabled="true"></el-input>\n              </el-form-item>\n              <el-form-item label="\u62DF\u529E\u6D41\u5411\u8282\u70B9\u7EC4\u5408ID" v-show="false">\n                  <el-input v-model="data[\'plannedFlowActivityIds\']" :disabled="true"></el-input>\n              </el-form-item>\n           <el-form-item label="\u542F\u7528\u4F20\u9605\uFF1A">\n              <el-radio-group v-model="data[\'circularSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u4F20\u9605\u8303\u56F4\uFF1A" v-show="data[\'circularSwitch\']===\'1\'">\n                <el-select v-model="data[\'circularScope\']">\n                  <el-option\n                    v-for="item in circularScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u4F20\u9605\u79D8\u4E66\u4EE3\u529E\uFF1A"  v-show="data[\'circularSwitch\']===\'1\'">\n                <el-radio-group v-model="data[\'circularSecretarySwitch\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u79D8\u4E66\u8282\u70B9\u540D\uFF1A" v-show="data[\'circularSwitch\']===\'1\' && data[\'circularSecretarySwitch\']===\'1\'">\n                    <el-input v-model="data[\'circularSecActivityName\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u8282\u70B9\u540D\uFF1A" v-show="data[\'circularSwitch\']===\'1\' && data[\'circularSecretarySwitch\']===\'1\'">\n                    <el-input v-model="data[\'circularLeaderActivityName\']"></el-input>\n                </el-form-item>\n            <el-form-item label="\u542F\u7528\u8F6C\u529E\uFF1A">\n              <el-radio-group v-model="data[\'transmitSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u8F6C\u529E\u8303\u56F4\uFF1A" v-show="data[\'transmitSwitch\']===\'1\'">\n                <el-select v-model="data[\'transmitScope\']">\n                  <el-option\n                    v-for="item in transmitScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u610F\u89C1\u63A7\u5236\uFF1A">\n              <el-radio-group v-model="data[\'commentSwitch\']" size="mini">\n                <el-radio-button label="1">\u5C55\u5F00</el-radio-button>\n                <el-radio-button label="0">\u6298\u53E0</el-radio-button>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u610F\u89C1\u5206\u7C7B\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-input v-model="data[\'commentCategory\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u610F\u89C1\u5E8F\u53F7\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-input v-model="data[\'commentSn\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u9ED8\u8BA4\u610F\u89C1\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-input v-model="data[\'defaultComment\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u586B\u5199\u591A\u6761\u610F\u89C1\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-radio-group v-model="data[\'moreCommentSwitch\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u4FEE\u6539\u610F\u89C1\u8303\u56F4\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-select v-model="data[\'commentModifyScope\']">\n                  <el-option\n                    v-for="item in commentModifyScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u68C0\u67E5\u65B9\u5F0F\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-select v-model="data[\'commentCheckMode\']">\n                  <el-option\n                    v-for="item in commentCheckModes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n              </el-form-item>\n              <el-form-item label="\u5B8C\u6210\u5F3A\u5236\u586B\u5199\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-select v-model="data[\'completeComment\']">\n                  <el-option\n                    v-for="item in mandatoryOptions"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n               </el-form-item>\n               <el-form-item label="\u8F6C\u529E\u5F3A\u5236\u586B\u5199\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                 <el-select v-model="data[\'transmitComment\']">\n                  <el-option\n                    v-for="item in mandatoryOptions"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n               </el-form-item>\n               <el-form-item label="\u9000\u56DE\u5F3A\u5236\u586B\u5199\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n               <el-select v-model="data[\'rejectComment\']">\n                  <el-option\n                    v-for="item in mandatoryOptions"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n               </el-form-item>\n               <el-form-item label="\u53EA\u8BFB:" >\n                  <el-radio-group v-model="data[\'readOnly\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n               </el-form-item>\n                <el-form-item label="\u9644\u4EF6\u53EF\u7F16\u8F91:" >\n                  <el-radio-group v-model="data[\'editAttach\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n                </el-form-item>\n                <el-form-item label="\u9644\u4EF6\u53EF\u4E0A\u4F20:" >\n                  <el-radio-group v-model="data[\'uploadAttach\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n                </el-form-item> \n                <el-form-item label="\u9644\u4EF6\u53EF\u4E0B\u8F7D:" >\n                  <el-radio-group v-model="data[\'downloadAttach\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n                </el-form-item> \n                <el-form-item label="\u6B63\u6587\u6253\u5F00\u65B9\u5F0F:" >\n                    <el-input v-model="data[\'attchOct\']" style="width:calc(100% - 48px);"></el-input>\n                    <el-button type="primary" @click="showOcxList">\u9009\u62E9</el-button>\n                </el-form-item> \n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u79D8\u4E66\u4EE3\u529E" name="4">\n            <el-form  label-width="92px">\n              <el-form-item label="\u542F\u7528\u79D8\u4E66\u4EE3\u529E\uFF1A">\n              <el-radio-group v-model="data[\'secretarySwitch\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u79D8\u4E66\u4EE3\u529E\u6D41\u7A0B\uFF1A" v-show="data[\'secretarySwitch\']===\'1\'">\n               <el-radio-group v-model="data[\'secretarySubProcSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u4EE3\u529E\u6D41\u7A0B\u540D\u79F0\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'secSubProcessDefName\']" style="width:60%;" :disabled="true"></el-input>\n                    <el-button type="primary" @click="showSubProcess">\u9009\u62E9</el-button>\n                </el-form-item>\n                <el-form-item label="\u4EE3\u529E\u6D41\u7A0BKey" v-show="false">\n                    <el-input v-model="data[\'secSubProcessDefKey\']" :disabled="true"></el-input>\n                </el-form-item>\n                 <el-form-item label="\u4EE3\u529E\u6D41\u7A0B\u6A21\u5757" v-show="false">\n                <el-input v-model="data[\'secSubProcessModuleId\']" :disabled="true"></el-input>\n                <el-input v-model="data[\'secSubProcessApplicationId\']" :disabled="true"></el-input>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u4EE3\u529E\u8282\u70B9\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessSecActivityName\']" style="width:60%;" :disabled="true"></el-input>\n                    <el-button type="primary" @click="showSubProcessNode(\'subProcessSecActivityId\', \'subProcessSecActivityName\')">\u9009\u62E9</el-button>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u4EE3\u529E\u8282\u70B9ID" v-show="false">\n                    <el-input v-model="data[\'subProcessSecActivityId\']" :disabled="true"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u4EE3\u529E\u8282\u70B9\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessLeaderActivityName\']" style="width:60%;" :disabled="true"></el-input>\n                    <el-button type="primary" @click="showSubProcessNode(\'subProcessLeaderActivityId\', \'subProcessLeaderActivityName\')">\u9009\u62E9</el-button>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u4EE3\u529E\u8282\u70B9ID" v-show="false">\n                    <el-input v-model="data[\'subProcessLeaderActivityId\']" :disabled="true"></el-input>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u8282\u70B9\u63D0\u793A" v-show="false && data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessSecActivityTip\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u8282\u70B9\u63D0\u793A" v-show="false && data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessLeaderActivityTip\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u8282\u70B9\u540D\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] != \'1\'">\n                    <el-input v-model="data[\'secActivityName\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u8282\u70B9\u540D\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] != \'1\'">\n                    <el-input v-model="data[\'leaderActivityName\']"></el-input>\n                </el-form-item>\n               <el-form-item label="\u4EE3\u5F55\u8282\u70B9\u6D41\u5411\uFF1A">\n                <el-input v-model="data[\'canAgentRecordFlowNames\']"  :disabled="true" style="width:50%"></el-input>\n                <el-button type="primary" @click="showCanAgentRecordFlows({id:\'canAgentRecordFlowIds\', name:\'canAgentRecordFlowNames\'})">\u9009\u62E9</el-button>\n                 <el-tooltip placement="top" style="width:10%">\n                  <div slot="content">\n                  \u914D\u7F6E"\u865A\u62DF\u65E5\u5FD7"\u64CD\u4F5C\u6309\u94AE\u540E\u751F\u6548</div>\n                  <i class="el-icon-question"></i>\n                </el-tooltip>\n               </el-form-item>\n               <el-form-item label="\u4EE3\u5F55\u8282\u70B9ID" v-show="false">\n                  <el-input v-model="data[\'canAgentRecordFlowIds\']" :disabled="true"></el-input>\n              </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u79FB\u52A8\u914D\u7F6E" name="6">\n          <el-form  label-width="92px">\n              <el-form-item label="\u662F\u5426\u529E\u7406:" >\n                  <el-radio-group v-model="data[\'mobileHandler\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u8868\u5355\u7F16\u8F91:" >\n                  <el-radio-group v-model="data[\'mobileEdit\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u7F16\u8F91\u6B63\u6587:" >\n                  <el-radio-group v-model="data[\'mobileZWEdit\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u7F16\u8F91\u9644\u4EF6:" >\n                  <el-radio-group v-model="data[\'mobileFJEdit\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u4E0A\u4F20\u9644\u4EF6:" >\n                  <el-radio-group v-model="data[\'mobileFJUpload\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n          </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u5176\u4ED6" name="5">\n           <el-form  label-width="92px">\n              <el-form-item label="\u65F6\u9650\u63A7\u5236\uFF1A">\n              <el-radio-group v-model="data[\'timeSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u65F6\u95F4\u7C7B\u578B\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                <el-select v-model="data[\'timeType\']">\n                  <el-option\n                    v-for="item in timeTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u7B7E\u6536\u9650\u529E\u65F6\u95F4\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                  <el-input v-model="data[\'claimLimitedTime\']"></el-input>\n              </el-form-item>\n              <el-form-item label="\u529E\u6BD5\u9650\u529E\u65F6\u95F4\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                  <el-input v-model="data[\'finishLimitedTime\']"></el-input>\n              </el-form-item>\n              <el-form-item label="\u81EA\u52A8\u6D41\u8F6C\u610F\u89C1\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                  <el-input v-model="data[\'autoLZYJ\']"></el-input>\n              </el-form-item>\n              <el-form-item label="\u6267\u884C\u811A\u672C\uFF1A">\n                <el-button type="primary" @click="showFlowScriptSet(\'node\')">\u8BBE\u7F6E</el-button>\n            </el-form-item>\n            <el-form-item label="\u662F\u5426\u9886\u5BFC\u8282\u70B9\uFF1A">\n              <el-select v-model="data[\'leaderNode\']">\n                  <el-option\n                    v-for="item in groupYesNo"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u9886\u5BFC\u8868\u8FBE\u5F0F:">\n                <el-input v-model="data[\'leaderNodeExp\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u662F\u5426\u5B9A\u5BC6\u8282\u70B9\uFF1A">\n              <el-select v-model="data[\'densityNode\']">\n                  <el-option\n                    v-for="item in groupYesNo"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n      </el-collapse>\n      </div>\n    ',



























































































































































































































































































































































































































































































































    props: {
      data: {
        type: Object },

      params: {
        type: Object } },


    data: function data() {
      return {
        fields: ['id', 'name', 'mark', 'type', 'sn', 'groupType', 'group', 'relativeGroup', 'relativeGroupName',
        'groupField', 'groupHandled', 'groupHandledActName', 'userType', 'userRole', 'userRoleName', 'conditionRoles', 'userField', 'userHandledActName',
        'userHandled', 'excludeSwitch', 'buttons', 'scriptActions', 'operAuths', 'timeSwitch', 'timeType', 'claimLimitedTime', 'finishLimitedTime', 'autoLZYJ',
        'excludeType', 'bRoleSwitch', 'aGroupScope', 'bUserRole', 'bUserRoleName',
        'canRejectActivityIds', 'canRejectActivityNames', 'transmitSwitch',
        'transmitScope', 'commentSwitch', 'commentCategory', 'commentSn',
        'defaultComment', 'moreCommentSwitch', 'commentModifyScope', 'commentCheckMode',
        'completeComment', 'transmitComment', 'rejectComment', 'plannedFlowIds', 'plannedFlowActivityNames', 'plannedFlowActivityIds',
        'circularSwitch', 'circularScope', 'circularSecretarySwitch', 'circularSecActivityName', 'circularLeaderActivityName',
        'secretarySwitch', 'secretarySubProcSwitch', 'secSubProcessDefName', 'secSubProcessDefKey', 'secSubProcessModuleId', 'secSubProcessApplicationId',
        'subProcessSecActivityName', 'subProcessSecActivityId', 'subProcessLeaderActivityName', 'subProcessLeaderActivityId',
        'subProcessSecActivityTip', 'subProcessLeaderActivityTip', 'secActivityName', 'leaderActivityName', 'readOnly', 'editAttach', 'uploadAttach', 'downloadAttach', 'attchOct', 'attchOctKey',
        'mobileHandler', 'mobileEdit', 'mobileZWEdit', 'mobileFJEdit', 'mobileFJUpload',
        'canAgentRecordFlowNames', 'canAgentRecordFlowIds', 'openFormId', 'openFormName', 'leaderNode', 'leaderNodeExp', 'densityNode', "defaultSelectActivityName", "defaultSelectActivityId"],

        activeName: '1',
        types: [],
        groupTypes: [{ value: 'role', label: '权限' }, { value: 'relative', label: '相对部门' }, { value: 'handled-group', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'upper-group', label: '发送部门' }, { value: 'draft-group', label: '发起部门' }, { value: 'bind-group', label: '<绑定部门>' }],

        groups: [{ value: '<当前>', label: '<当前>' }, { value: '<上级>', label: '<上级>' }, { value: '<下级>', label: '<下级>' }, { value: '<平级>', label: '<平级>' },
        { value: '<当前和上级>', label: '<当前和上级>' }, { value: '<当前和下级>', label: '<当前和下级>' },
        { value: '<所有下级>', label: '<所有下级>' }, { value: '<上级的平级>', label: '<上级的平级>' },
        { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<部门上级>', label: '<部门上级>' }, { value: '<部门下级>', label: '<部门下级>' }, { value: '<部门平级>', label: '<部门平级>' },
        { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<本单位任选(不包含下级)>', label: '<本单位任选(不包含下级)>' },
        { value: '<本单位的一级部门>', label: '<本单位的一级部门>' }, { value: '<单位上级>', label: '<单位上级>' }, { value: '<单位平级>', label: '<单位平级>' },
        { value: '<上级单位部门>', label: '<上级单位部门>' }, { value: '<上级单位任选>', label: '<上级单位任选>' }],
        defaultUserTypes: [{ value: 'role', label: '权限' }, { value: 'handled-user', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'draft-user', label: '发起人' }, { value: 'upper-user', label: '发送人' }],
        bindUserTypes: [{ value: 'bind-leader', label: '<绑定领导>' }, { value: 'bind-secretary', label: '<绑定秘书>' }],
        circularScopes: [{ value: '<当前>', label: '<当前>' }, { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<任选>', label: '<任选>' }],
        timeTypes: [{ value: 'work', label: '工作时间(单位:h)' }, { value: 'reality', label: '实际时间(单位:h)' }, { value: 'biz', label: '业务字段' }],
        transmitScopes: [{ value: '<当前>', label: '<当前>' }, { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<任选>', label: '<任选>' }],
        excludeTypes: [{ value: 'current-user', label: '当前用户' }, { value: 'current-dep', label: '当前部门' }],
        commentCheckModes: [{ value: 'task', label: '当前环节' }, { value: 'activity', label: '当前节点' }, { value: 'doc', label: '当前文档' }],
        commentModifyScopes: [{ value: 'disabled', label: '禁止' }, { value: 'self', label: '本人' }, { value: 'all', label: '所有人' }],
        mandatoryOptions: [{ value: 'no', label: '否' }, { value: 'remind', label: '提示' }, { value: 'yes', label: '是' }],
        aGroupScopes: [{ value: '<当前>', label: '<当前>' }, { value: '<本部门任选>', label: '<本部门任选>' }],
        groupYesNo: [{ value: '1', label: '是' }, { value: '0', label: '否' }] };

    },
    created: function created() {
      var me = this;
      me.clearField();
      me.types = me.params.activityTypes;
      me.initData();
    },
    watch: {
      'data.name': function dataName(val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", { id: me.data.id, name: val });
        }
      },
      'data.id': function dataId(val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name;
          this.$set(this.data, 'name', '新增节点');
        }
        this.initData();
      } },

    methods: {
      initData: function initData() {
        var me = this;
        if (this.data.openFormId == undefined) {
          this.$set(this.data, 'openFormId', '');
          this.$set(this.data, 'openFormName', '');
        }
        if (this.data.conditionRoles == undefined) {
          this.$set(this.data, 'conditionRoles', []);
        }
        if (this.data.groupType == undefined) {
          this.$set(this.data, 'groupType', this.groupTypes[0].value);
        }
        if (this.data.mobileHandler == undefined) {
          this.$set(this.data, 'mobileHandler', "1");
        }
        if (this.data.mobileEdit == undefined) {
          this.$set(this.data, 'mobileEdit', "0");
        }
        if (this.data.mobileZWEdit == undefined) {
          this.$set(this.data, 'mobileZWEdit', "0");
        }
        if (this.data.mobileFJEdit == undefined) {
          this.$set(this.data, 'mobileFJEdit', "0");
        }
        if (this.data.mobileFJUpload == undefined) {
          this.$set(this.data, 'mobileFJUpload', "1");
        }
        if (this.data.readOnly == undefined) {
          this.$set(this.data, 'readOnly', "0");
        }
        if (this.data.editAttach == undefined) {
          this.$set(this.data, 'editAttach', "1");
        }
        if (this.data.uploadAttach == undefined) {
          this.$set(this.data, 'uploadAttach', "1");
        }
        if (this.data.downloadAttach == undefined) {
          this.$set(this.data, 'downloadAttach', "1");
        }
        if (this.data.attchOctKey == undefined) {
          this.$set(this.data, 'attchOctKey', "");
        }
        if (this.data.attchOct == undefined) {
          this.$set(this.data, 'attchOct', "无");
        }

        if ('bind-group' == me.data.groupType) {
          me.userTypes = me.bindUserTypes;
        } else {
          me.userTypes = me.defaultUserTypes;
        }

        if (me.data.name == undefined) {
          this.$set(me.data, 'name', '新增节点');
        }
        if (me.data.mark == undefined) {
          this.$set(me.data, 'mark', '');
        }
        if (this.data.excludeSwitch == undefined) {
          this.$set(this.data, 'excludeSwitch', '0');
        }
        if (this.data.buttons == undefined) {
          this.$set(this.data, 'buttons', []);
        }
        if (this.data.scriptActions == undefined) {
          this.$set(this.data, 'scriptActions', {});
        }
        if (this.data.operAuths == undefined) {
          this.$set(this.data, 'operAuths', []);
        }
        if (this.data.type == undefined) {
          this.$set(this.data, 'type', 'normal');
        }

        if (this.data.group == undefined) {
          this.$set(this.data, 'group', '<当前>');
        }

        if (this.data.userType == undefined) {
          this.$set(this.data, 'userType', this.userTypes[0].value);
        }
        if (this.data.circularSwitch == undefined) {
          this.$set(this.data, 'circularSwitch', '0');
        }
        if (this.data.circularScope == undefined) {
          this.$set(this.data, 'circularScope', this.circularScopes[0].value);
        }
        if (this.data.circularSecretarySwitch == undefined) {
          this.$set(this.data, 'circularSecretarySwitch', '0');
        }
        if (this.data.timeSwitch == undefined) {
          this.$set(this.data, 'timeSwitch', '0');
        }
        if (this.data.timeType == undefined) {
          this.$set(this.data, 'timeType', 'work');
        }
        if (this.data.excludeType == undefined) {
          this.$set(this.data, 'excludeType', this.excludeTypes[0].value);
        }
        if (this.data.bRoleSwitch == undefined) {
          this.$set(this.data, 'bRoleSwitch', '0');
        }
        if (this.data.aGroupScope == undefined) {
          this.$set(this.data, 'aGroupScope', '<当前>');
        }
        if (this.data.transmitSwitch == undefined) {
          this.$set(this.data, 'transmitSwitch', '0');
        }
        if (this.data.transmitScope == undefined) {
          this.$set(this.data, 'transmitScope', this.transmitScopes[0].value);
        }
        if (this.data.secretarySwitch == undefined) {
          this.$set(this.data, 'secretarySwitch', '0');
        }
        if (this.data.secretarySubProcSwitch == undefined) {
          this.$set(this.data, 'secretarySubProcSwitch', '0');
        }
        if (this.data.commentSwitch == undefined) {
          this.$set(this.data, 'commentSwitch', '0');
        }
        if (this.data.moreCommentSwitch == undefined) {
          this.$set(this.data, 'moreCommentSwitch', '0');
        }
        if (this.data.commentModifyScope == undefined) {
          this.$set(this.data, 'commentModifyScope', 'self');
        }
        if (this.data.commentCheckMode == undefined) {
          this.$set(this.data, 'commentCheckMode', this.commentCheckModes[0].value);
        }
        if (this.data.completeComment == undefined) {
          this.$set(this.data, 'completeComment', 'no');
        }
        if (this.data.transmitComment == undefined) {
          this.$set(this.data, 'transmitComment', 'no');
        }
        if (this.data.rejectComment == undefined) {
          this.$set(this.data, 'rejectComment', 'no');
        }
        if (this.data.leaderNode == undefined) {
          this.$set(this.data, 'leaderNode', '0');
        }
        if (this.data.leaderNodeExp == undefined) {
          this.$set(this.data, 'leaderNodeExp', '');
        }
        if (this.data.densityNode == undefined) {
          this.$set(this.data, 'densityNode', '0');
        }
      },
      addConditionRoleRow: function addConditionRoleRow() {
        var me = this;
        me.data.conditionRoles.push({ condition: '', roleId: '', roleName: '' });
      },
      deleteConditionRoleRow: function deleteConditionRoleRow(idx) {
        this.data.conditionRoles.splice(idx, 1);
      },
      showRelateForm: function showRelateForm() {
        var me = this;
        var moduleId = me.params.moduleId;
        var appId = me.params.applicationId;

        PF.show('tableDialog', { api: "app.listModuleForm", clearBtn: true,
          defaultParams: { moduleId: moduleId, appId: appId }, singleSelect: true }, function (res) {
          if (res.length > 0) {
            me.$set(me.data, 'openFormId', res[0].id);
            me.$set(me.data, 'openFormName', res[0].name);
          } else {
            me.$set(me.data, 'openFormId', "");
            me.$set(me.data, 'openFormName', "");
          }
        });

      },
      showHandledNode: function showHandledNode(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        PF.show('tree', { treeData: me._getActivities(['start', 'end', 'circular', 'sub-proc']), selectFirst: false, selectNode: selectNode }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });

      },
      showOcxList: function showOcxList() {
        var me = this;
        PF.show('tree', { url: me.mwUrl("/api/data/getOcxList"), selectFirst: false, selectNode: "", search: true, async: true, singleLeaf: true }, function (res) {
          me.$set(me.data, 'attchOct', res.name || "");
          me.$set(me.data, 'attchOctKey', res.key || "");
        });
      },
      showFlowMarks: function showFlowMarks() {
        var me = this;
        var flowMarks = me.params.flowMarks || "";
        if (!flowMarks) {
          PF.message("请在模块设置中配置流程标识");
          return;
        }
        flowMarks = _.uniq(flowMarks.split(","));
        var treeData = [];
        _.each(flowMarks, function (v) {treeData.push({ id: v, name: v });});
        var checkNodes = (me.data.mark || "").split(",");
        PF.show('tree', { treeData: treeData, checkNodes: checkNodes, multiple: true, clearBtn: true }, function (res) {
          var marks = [];
          _.each(res, function (v) {
            marks.push(v.name);
          });
          me.$set(me.data, 'mark', marks.join(","));
        });
      },
      showCanRejectNodes: function showCanRejectNodes(f) {
        var me = this;

        var checkNodes;
        if (me.data[f.id]) {
          checkNodes = me.data[f.id].split(',');
        }
        PF.show('tree', { treeData: me._getActivities(['start', 'end', 'circular', 'sub-proc']), checkNodes: checkNodes, multiple: true, clearBtn: true }, function (res) {
          var activityNames = [];
          var activityIds = [];
          res.forEach(function (item) {
            activityNames.push(item.name);
            activityIds.push(item.id);
          });

          me.$set(me.data, f.id, activityIds.join(','));
          me.$set(me.data, f.name, activityNames.join(','));
        });
      },
      showCanAgentRecordNodes: function showCanAgentRecordNodes(f) {
        var me = this;
        var checkNodes;
        if (me.data[f.id]) {
          checkNodes = me.data[f.id].split(',');
        }
        PF.show('tree', { treeData: me._getCanAgentRecordNextActivities(['start', 'end', 'circular', 'sub-proc']), checkNodes: checkNodes, multiple: true, clearBtn: true }, function (res) {
          var activityNames = [];
          var activityIds = [];
          res.forEach(function (item) {
            activityNames.push(item.name);
            activityIds.push(item.id);
          });
          me.$set(me.data, f.id, activityIds.join(','));
          me.$set(me.data, f.name, activityNames.join(','));
        });
      },
      showCanAgentRecordFlows: function showCanAgentRecordFlows(f) {
        var me = this;
        var checkFlows;
        if (me.data[f.id]) {
          checkFlows = me.data[f.id].split(',');
        }
        PF.show('tree', { treeData: me._getCanAgentRecordFlows(['start', 'end', 'circular', 'sub-proc']), checkNodes: checkFlows, multiple: true, clearBtn: true }, function (res) {
          var flowNames = [];
          var flowIds = [];
          res.forEach(function (item) {
            flowNames.push(item.name);
            flowIds.push(item.id);
          });
          me.$set(me.data, f.id, flowIds.join(','));
          me.$set(me.data, f.name, flowNames.join(','));
        });
      },
      showDefaultSelectFlows: function showDefaultSelectFlows() {
        var me = this;
        PF.show('tree', { treeData: me._getActivityFlows(null, me.data.id), checkNodes: [], multiple: false, clearBtn: true }, function (res) {
          var id = "";
          var name = "";
          if (res && res.sourceId_targetId) {
            id = res.sourceId_targetId.split("-")[1];
            name = res.name;
          }
          me.$set(me.data, "defaultSelectActivityName", name);
          me.$set(me.data, "defaultSelectActivityId", id);
        });
      },
      showPlannedActivityFlows: function showPlannedActivityFlows() {
        var me = this;
        var checkNodes;
        if (me.data['plannedFlowIds']) {
          checkNodes = me.data['plannedFlowIds'].split(',');
        }
        PF.show('tree', { treeData: me._getActivityFlows(['startSubProcess']), checkNodes: checkNodes, multiple: true, clearBtn: true }, function (res) {
          var flowIds = [];
          var flowActivityIds = [];
          var flowActivityNames = [];
          res.forEach(function (item) {
            flowIds.push(item.id);
            flowActivityNames.push(item.name);
            flowActivityIds.push(item.sourceId_targetId);
          });

          me.$set(me.data, 'plannedFlowIds', flowIds.join(','));
          me.$set(me.data, 'plannedFlowActivityIds', flowActivityIds.join(','));
          me.$set(me.data, 'plannedFlowActivityNames', flowActivityNames.join(','));
        });
      },
      showDept: function showDept() {
        var me = this;
        var selectNode = '';
        if (me.data['relativeGroup']) {
          selectNode = me.data['relativeGroup'];
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listDepartment"), selectFirst: false, selectNode: selectNode, search: true, async: true, singleLeaf: false }, function (res) {
          me.$set(me.data, 'relativeGroup', res.id);
          me.$set(me.data, 'relativeGroupName', res.name);
        });
      },
      showRole: function showRole(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        var params;
        if (parent && parent.propAuthUnit) {
          params = { authUnitFilter: true };
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listFlowGroupedRole"), selectFirst: false, defaultParams: params, selectNode: selectNode, search: true, clearBtn: true }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });
      },
      showMulRole: function showMulRole(idx) {
        var me = this;
        var data = me.data.conditionRoles[idx];
        var selectNode = '';
        if (data && data.roleId) {
          selectNode = data.roleId;
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listFlowGroupedRole"), selectFirst: false, selectNode: selectNode, search: true, clearBtn: true }, function (res) {
          me.$set(data, "roleId", res.id);
          me.$set(data, "roleName", res.name);
        });
      },
      showFlowButton: function showFlowButton() {
        var me = this;
        var value = [];
        for (var i = 0; i < me.data.buttons.length; i++) {
          value.push(me.data.buttons[i].action);
        }
        PF.show('treeTable', {
          url: me.mwUrl("/api/app/listActionComponentByTypeTree"), treeDefaultParams: { type: "系统分类/表单/流程", flag: 0 },
          size: 'small_large',
          selectFirst: true, asyncLoadOnce: true, clearBtn: true, title: '选择动作脚本', changed: function changed(data) {
            var me = this;
            me.defaultParams = { type: data.code, flag: 2 };
          }, api: 'app.getAllButton', singleSelect: false },
        function (res) {
          var btns = [];
          if (res && res.length > 0) {
            res.forEach(function (v) {
              btns.push({ name: v.name, action: v.action });
            });
          }
          me.$set(me.data, 'buttons', btns);
        });
      },
      showFlowScriptSet: function showFlowScriptSet(type) {
        var me = this;
        var p = {};
        p.type = type;
        var scriptActions = me.data.scriptActions;
        if (scriptActions) {
          p.scriptActions = scriptActions;
        } else {
          p.scriptActions = {};
        }
        PF.show('flowScriptSet', p, function (res) {
          me.$set(me.data, 'scriptActions', res);
        });
      },
      showFormOperAuth: function showFormOperAuth() {
        var me = this;
        var moduleId = me.params.moduleId;
        var appId = me.params.applicationId;
        var checkNodes = [];
        for (var i = 0; i < me.data.operAuths.length; i++) {
          checkNodes.push(me.data.operAuths[i].id);
        }
        PF.show('tree', { url: this.mwUrl(
          "/api/app/listModuleFormOperAuthTree"), checkNodes: checkNodes, search:
          true, multiple: true, singleLeaf: false, clearBtn: true, multipleLeaf: false,
          defaultParams: { moduleId: moduleId, appId: appId } }, function (res) {
          var auths = [];
          if (res && res.length > 0) {
            res.forEach(function (v) {
              if (v.id) {
                auths.push({ name: v.name, id: v.id });
              }
            });
          }
          me.$set(me.data, 'operAuths', auths);
        });
      },

      clearField: function clearField() {
        var me = this;
        function contains(obj) {
          for (var i = 0; i < me.fields.length; i++) {
            if (me.fields[i] == obj) {
              return true;
            }
          }
          return false;
        }
        var del = [];
        for (var s in me.data) {
          if (!contains(s)) {
            del.push(s);
          }
        }
        for (var i = 0; i < del.length; i++) {
          delete me.data[del[i]];
        }
      },
      changeType: function changeType(val) {
        parent.$emit("updateShape", { id: this.data.id, type: val });
        this.params.changeType(val);
      },
      changeGroupType: function changeGroupType(val) {
        var me = this;
        var oldUt = me.data.userType;
        if ('bind-group' == val) {
          me.userTypes = me.bindUserTypes;
          var exist = false;
          me.bindUserTypes.forEach(function (v) {
            if (v.value == oldUt) {
              exist = true;
            }
          });
          if (!exist) {
            me.$set(me.data, 'userType', me.userTypes[0].value);
          }
        } else {
          me.userTypes = me.defaultUserTypes;
          var exist = false;
          me.bindUserTypes.forEach(function (v) {
            if (v.value == oldUt) {
              exist = true;
            }
          });
          if (exist) {
            me.$set(me.data, 'userType', me.userTypes[0].value);
          }
        }
      },
      showSubProcess: function showSubProcess() {
        var me = this;
        var selectNode = '';
        if (me.data.secSubProcessDefKey) {
          if (me.data.secSubProcessModuleId) {
            selectNode = me.data.secSubProcessDefKey + '|' + me.data.secSubProcessModuleId;
          } else {
            selectNode = me.data.secSubProcessDefKey;
          }
        }
        PF.show('tree', { url: this.mwUrl("/api/process/listModuleLatestProcDefTree"), singleLeaf: true, selectFirst: false, selectNode: selectNode, search: true, defaultParams: { sysId: me.params.sysId } }, function (res) {
          if (res) {
            if (res.id) {
              var ids = res.id.split('|');
              me.$set(me.data, 'secSubProcessDefKey', ids[0]);
            } else {
              me.$set(me.data, 'secSubProcessDefKey', res.id);
            }
            me.$set(me.data, 'secSubProcessDefName', res.name);
            me.$set(me.data, 'secSubProcessApplicationId', res.appId);
            me.$set(me.data, 'secSubProcessModuleId', res.moduleId);

            delete me.data.subProcessSecActivityId;
            delete me.data.subProcessSecActivityName;
            delete me.data.subProcessLeaderActivityId;
            delete me.data.subProcessLeaderActivityName;
          }
        });
      },
      showSubProcessNode: function showSubProcessNode(fid, fname) {
        var me = this;
        var key = me.data.secSubProcessDefKey;
        if (key) {
          var selectNode = '';
          if (me.data[fid]) {
            selectNode = me.data[fid];
          }
          var appId = me.params.applicationId;
          if (me.data.secSubProcessApplicationId) {
            appId = me.data.secSubProcessApplicationId;
          }
          PF.show('tree', { url: this.mwUrl("/api/process/getSubProcessStartActivities"), selectFirst: false, selectNode: selectNode, defaultParams: { key: key, appId: appId } }, function (res) {
            me.$set(me.data, fid, res.id);
            me.$set(me.data, fname, res.name);
          });
        }
      },
      _getActivities: function _getActivities(excludeActivityTypes) {
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var treeData = [];
        var exclude;
        activities.forEach(function (a) {
          exclude = false;
          excludeActivityTypes.forEach(function (et) {
            if (et == a.extends) {
              exclude = true;
            }
          });
          if (!exclude) {
            treeData.push({ id: a.id, text: a.parameters.name, name: a.parameters.name });
          }
        });
        return treeData;
      },
      _getActivityFlows: function _getActivityFlows(flowTypes, sourceActivity) {
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var actNames = {};
        activities.forEach(function (a) {
          actNames[a.id] = a.parameters.name;
        });
        var flows = processDataItems['SEQUENCE-FLOW'];
        var treeData = [];

        flows.forEach(function (f) {

          if (!flowTypes || flowTypes.indexOf(f.parameters.type) > -1) {
            if (!sourceActivity || f.parameters.from === sourceActivity) {
              var name = actNames[f.parameters.from] + '-' + actNames[f.parameters.to];
              treeData.push({ id: f.id, text: name, name: name, sourceId_targetId: f.parameters.from + '-' + f.parameters.to });
            }
          }






        });
        return treeData;
      },
      _getCanAgentRecordNextActivities: function _getCanAgentRecordNextActivities(excludeActivityTypes) {
        var me = this;
        var currentNodeId = me.data.id;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var acts = {};
        activities.forEach(function (a) {
          acts[a.id] = a;
        });
        var treeData = [];
        var flows = processDataItems['SEQUENCE-FLOW'];
        var exclude;
        flows.forEach(function (f) {
          exclude = false;
          if (f.parameters.from == currentNodeId) {

            if ('startSubProcess' == f.parameters.type && 'DEP' == f.parameters.sendUnit) {
              exclude = true;
            }
            if (!exclude) {
              var act = acts[f.parameters.to];
              excludeActivityTypes.forEach(function (at) {
                if (at == act.extends) {
                  exclude = true;
                }
              });
              if (!exclude) {
                treeData.push({ id: act.id, text: act.parameters.name, name: act.parameters.name });
              }
            }
          }
        });
        return treeData;
      },
      _getCanAgentRecordFlows: function _getCanAgentRecordFlows(excludeActivityTypes) {
        var me = this;
        var currentNodeId = me.data.id;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var acts = {};
        var actNames = {};
        activities.forEach(function (a) {
          acts[a.id] = a;
          actNames[a.id] = a.parameters.name;
        });
        var treeData = [];
        var flows = processDataItems['SEQUENCE-FLOW'];
        var exclude;
        flows.forEach(function (f) {
          exclude = false;
          if (f.parameters.from == currentNodeId) {

            if ('startSubProcess' == f.parameters.type && 'DEP' == f.parameters.sendUnit) {
              exclude = true;
            }
            if (!exclude) {
              var act = acts[f.parameters.to];
              excludeActivityTypes.forEach(function (at) {
                if (at == act.extends) {
                  exclude = true;
                }
              });
              if (!exclude) {
                var name = f.parameters.name;
                if (!name) {
                  name = actNames[f.parameters.from] + '-' + actNames[f.parameters.to];
                }
                treeData.push({ id: f.id, text: name, name: name, sourceId_targetId: f.parameters.from + '-' + f.parameters.to });
              }
            }
          }
        });
        return treeData;
      } } };


  return node_normal;
};

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (Vue, parent, _data) {
  var node_end = {
    template: '\n    <div class=\'__config__body\'> \n       <el-collapse v-model="activeName" accordion>\n        <el-collapse-item title="\u57FA\u672C\u5C5E\u6027" name="1">\n          <div>\n           <el-form label-width="65px">\n            <el-form-item label="\u552F\u4E00\u6807\u8BC6\uFF1A" v-show=false>\n                <el-input v-model="data[\'id\']" :disabled="true"></el-input>\n            </el-form-item>\n             <el-form-item label="\u8282\u70B9\u540D\u79F0\uFF1A">\n                <el-input v-model="data[\'name\']" :disabled="true"></el-input>\n            </el-form-item>\n         </el-form>\n          </div>\n        </el-collapse-item>\n      </el-collapse>\n      </div>\n    ',

















    props: {
      data: {
        type: Object } },


    data: function data() {
      return {

        activeName: '1' };

    },
    created: function created() {
      if (this.data.name == undefined) {
        this.$set(this.data, 'name', '结束');
      }
    },
    watch: {
      'data.name': function dataName(val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", { id: me.data.id, name: val });
        }
      },
      'data.id': function dataId(val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name;
          this.$set(this.data, 'name', '结束');
        }
      } } };


  return node_end;
};

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (Vue, parent, _data) {
  var node_start = {
    template: '\n      <div class=\'__config__body\'> \n         <el-collapse v-model="activeName" accordion>\n        <el-collapse-item title="\u57FA\u672C\u5C5E\u6027" name="1">\n          <div>\n           <el-form label-width="65px">\n            <el-form-item label="\u552F\u4E00\u6807\u8BC6\uFF1A" v-show=false>\n                <el-input v-model="data[\'id\']" :disabled="true"></el-input>\n            </el-form-item>\n             <el-form-item label="\u8282\u70B9\u540D\u79F0\uFF1A">\n                <el-input v-model="data[\'name\']" :disabled="true"></el-input>\n            </el-form-item>\n         </el-form>\n          </div>\n        </el-collapse-item>\n      </el-collapse>\n      </div>\n    ',

















    props: {
      data: {
        type: Object } },


    data: function data() {
      return {

        activeName: '1' };

    },
    created: function created() {
      if (this.data.name == undefined) {
        this.$set(this.data, 'name', '开始');
      }
    },
    watch: {
      'data.name': function dataName(val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", { id: me.data.id, name: val });
        }
      },
      'data.id': function dataId(val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name;
          this.$set(this.data, 'name', '开始');
        }
      } } };


  return node_start;
};

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (Vue, parent, _data) {
  var line_normal = {
    template: '\n    <div class=\'__config__body\'>\n      <el-collapse v-model="activeName" accordion>\n        <el-collapse-item title="\u57FA\u672C\u5C5E\u6027" name="1">\n\n           <el-form label-width="65px">\n            <el-form-item label="\u6D41\u5411\u6807\u8BC6\uFF1A" v-show=false>\n                <el-input v-model="data[\'id\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u6E90\u81EA\u8282\u70B9\uFF1A">\n                <el-input v-model="params[\'fromName\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u76EE\u6807\u8282\u70B9\uFF1A">\n                <el-input v-model="params[\'toName\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u6E90\u81EA\u8282\u70B9\uFF1A" v-show="false">\n                <el-input v-model="data[\'from\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u76EE\u6807\u8282\u70B9\uFF1A" v-show="false">\n                <el-input v-model="data[\'to\']" :disabled="true"></el-input>\n            </el-form-item>\n             <el-form-item label="\u6D41\u5411\u540D\u79F0\uFF1A">\n                <el-input v-model="data[\'name\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u6D41\u5411\u63D0\u793A\uFF1A">\n                <el-input v-model="data[\'tip\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u6D41\u5411\u6807\u8BC6\uFF1A">\n                <el-input v-model="data[\'dMark\']" style="width:calc(100% - 48px);"></el-input>\n                <el-button type="primary" @click="showFlowMarks()">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u6D41\u5411\u5E8F\u53F7\uFF1A">\n                <el-input v-model="data[\'sn\']"></el-input>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u6D41\u7A0B\u63A7\u5236" name="2">\n           <el-form label-width="92px">\n           <el-form-item label="\u663E\u793A\u6761\u4EF6\uFF1A">\n                <el-input v-model="data[\'condition\']" style="width:85%"></el-input>\n                <el-tooltip placement="top">\n                  <div slot="content">\n                  \u5185\u7F6E\u4E0A\u4E0B\u6587\uFF1A<br/>\n                  * $form \u8868\u5355\u6570\u636E <br/>\n                  * $user \u5F53\u524D\u767B\u5F55\u7528\u6237\u6570\u636E<br/>\n                  \u5185\u7F6E\u51FD\u6570\uFF1A<br/>\n                  * $R(\'\u89D2\u8272\u540D\', ...) \u5177\u6709\u6307\u5B9A\u89D2\u8272<br/>\n                  * $D(\'\u90E8\u95E8\u540D\u79F0 xxx/yyy/zzz\') \u5C5E\u4E8E\u6307\u5B9A\u90E8\u95E8<br/>\n                  * $DR(\'\u90E8\u95E8\u540D\u79F0\', \'\u89D2\u8272\u540D\', ...) \u5177\u6709\u6307\u5B9A\u90E8\u95E8\u7684\u89D2\u8272<br/>\n                  * $G(\'\u7EC4\u540D\u79F0\') \u5C5E\u4E8E\u6307\u5B9A\u7EC4<br/>\n                  * $GR(\'\u7EC4\u540D\u79F0\', \'\u89D2\u8272\u540D\', ...)<br/>\n                  * $DA(\'\u90E8\u95E8\u540D\u79F0\') \u662F\u5426\u90E8\u95E8\u7BA1\u7406\u5458<br/>\n                  * $GA(\'\u7EC4\u540D\u79F0\') \u662F\u5426\u7EC4\u7BA1\u7406\u5458<br/>\n                  * $U(\'\u7528\u6237\u767B\u5F55ID\', ...) \u5728\u6307\u5B9A\u7684\u7528\u6237\u540D\u5217\u8868\u4E2D<br/>\n                  * $sysAdmin \u662F\u5426\u7CFB\u7EDF\u7BA1\u7406<br/>\n                 \u4F8B\u5982:\u4E0D\u5177\u6709\u4E3B\u7BA1\u548C\u526F\u7ECF\u7406\u7684\u89D2\u8272\u5E76\u4E14\u7533\u8BF7\u5929\u6570(\u8868\u57DF\u540D\uFF1Afldtianshu)\u5927\u4E8E2<br/>\n                    Js\u811A\u672C\u8868\u8FBE\u5F0F\uFF1A     !$R(\'\u4E3B\u7BA1\',\'\u526F\u7ECF\u7406\') && $vi($f.fldtianshu)>2 <br/>\n                    groovy\u811A\u672C\u8868\u8FBE\u5F0F\uFF1A $p{!$R(\'\u4E3B\u7BA1\',\'\u526F\u7ECF\u7406\')} && xt.vi($form.fldtianshu)>2 <br/>\n                    </div>\n                  <i class="el-icon-question"></i>\n                </el-tooltip>\n\n            </el-form-item>\n            <el-form-item label="\u6D41\u5411\u7C7B\u578B\uFF1A">\n                <el-select v-model="data[\'type\']" @change="changeType">\n                  <el-option\n                    v-for="item in types"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'type\'] === \'sendHandled\' ">\n                <el-input v-model="data[\'handleActivityName\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary"  @click="showHandledNode({id:\'handleActivityId\', name:\'handleActivityName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'handleActivityId\']" :disabled="true"></el-input>\n            </el-form-item>\n           <el-form-item label="\u540C\u4E00\u6D41\u7A0B\uFF1A" v-show="data[\'type\'] === \'sendHandled\'">\n               <el-radio-group v-model="data[\'sameProcess\']">\n               <el-radio  label="1">\u662F</el-radio>\n               <el-radio  label="0">\u5426</el-radio>\n               </el-radio-group>\n           </el-form-item>\n           <el-form-item label="\u8FD0\u8F6C\u7C7B\u578B\uFF1A" v-show="data[\'type\'] === \'startSubProcess\' ">\n                <el-select v-model="data[\'sendUnit\']" @change="changeSendUnit">\n                  <el-option\n                    v-for="item in sendUnits"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u8FD0\u8F6C\u89C4\u5219\uFF1A" v-show="data[\'type\'] === \'startSubProcess\' ">\n                <el-select v-model="data[\'sendRule\']">\n                  <el-option\n                    v-for="item in sendRules"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u53D1\u9001\u5230\u8FD0\u8F6C\uFF1A" v-show="data[\'type\'] === \'startSubProcess\' ">\n                <el-radio-group v-model="data[\'sendToYz\']">\n                <el-radio  label="0">\u662F</el-radio>\n                <el-radio  label="1">\u5426</el-radio>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u7B49\u5F85\u5B8C\u6210\uFF1A" v-show="data[\'type\'] === \'startSubProcess\' ">\n                <el-radio-group v-model="data[\'waitComplete\']">\n                <el-radio  label="1">\u662F</el-radio>\n                <el-radio  label="0">\u5426</el-radio>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u8DF3\u8F6C\u5F85\u529E\uFF1A" v-show="data[\'type\'] === \'startSubProcess\' ">\n                <el-radio-group v-model="data[\'skipTodo\']" size="mini">\n                  <el-radio-button label="1">\u5F00</el-radio-button>\n                  <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u8DF3\u8F6C\u6A21\u5F0F\uFF1A" v-show="data[\'type\'] === \'startSubProcess\' && data[\'skipTodo\'] === \'1\' ">\n                <el-radio-group v-model="data[\'skipTodoMode\']">\n                <el-radio  label="userComplete">\u7528\u6237</el-radio>\n                <el-radio  label="activityComplete">\u8282\u70B9</el-radio>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u5E72\u9884\u7236\u4EFB\u52A1\uFF1A" v-show="data[\'type\'] === \'startSubProcess\' ">\n                <el-radio-group v-model="data[\'interventionParentTask\']" size="mini">\n                  <el-radio-button label="1">\u5F00</el-radio-button>\n                  <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u8DF3\u8F6C\u8282\u70B9\uFF1A" v-show="data[\'type\'] === \'startSubProcess\' && data[\'interventionParentTask\']==\'1\' ">\n                <el-input v-model="data[\'skipToActivityName\']" :disabled="true" style="width:60%;"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'skipToActivityId\', name:\'skipToActivityName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u8DF3\u8F6C\u8282\u70B9:" v-show="false">\n                  <el-input v-model="data[\'skipToActivityId\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u529E\u7406\u90E8\u95E8\uFF1A" v-show="data[\'type\'] != \'sendHandled\' ">\n                <el-select v-model="data[\'groupType\']">\n                  <el-option\n                    v-for="item in groupTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u76F8\u5BF9\u90E8\u95E8\uFF1A" v-show="data[\'type\'] != \'sendHandled\' && data[\'groupType\'] === \'relative\' ">\n                <el-input v-model="data[\'relativeGroupName\']" style="width:60%;" :disabled="true"></el-input>\n                <el-button type="primary" @click="showDept">\u9009\u62E9</el-button>\n            </el-form-item>\n             <el-form-item label="\u76F8\u5BF9\u90E8\u95E8" v-show="false">\n                  <el-input v-model="data[\'relativeGroup\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u5B57\u6BB5\uFF1A"  v-show="data[\'type\'] != \'sendHandled\' && data[\'groupType\'] === \'biz\' ">\n                <el-input v-model="data[\'groupField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'type\'] != \'sendHandled\' && data[\'groupType\'] === \'handled-group\' ">\n                <el-input v-model="data[\'groupHandledActName\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'groupHandled\', name:\'groupHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'groupHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n              <el-form-item label="\u90E8\u95E8\u8303\u56F4\uFF1A" v-show="data[\'type\'] != \'sendHandled\' && data[\'groupType\']!=\'no\'">\n                <el-select v-model="data[\'group\']">\n                  <el-option\n                    v-for="item in groups"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u6392\u9664\u6761\u4EF6\uFF1A" v-show="data[\'type\']!= \'sendHandled\' &&\u3000data[\'groupType\'] != \'no\' ">\n                <el-radio-group v-model="data[\'excludeSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u6392\u9664\u8303\u56F4\uFF1A" v-show="data[\'type\']!= \'sendHandled\' &&\u3000data[\'groupType\'] != \'no\' && data[\'excludeSwitch\']== \'1\' ">\n                <el-select v-model="data[\'excludeType\']">\n                  <el-option\n                    v-for="item in excludeTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u5185\u62A2\u529E\uFF1A">\n              <el-radio-group v-model="data[\'singleDepartmentRecord\']" size="mini" v-show="data[\'type\'] === \'startSubProcess\' ">\n                <el-radio-button label="true">\u5F00</el-radio-button>\n                <el-radio-button label="false">\u5173</el-radio-button>\n               </el-radio-group>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u8868\u5355\u63A7\u5236" name="3">\n           <el-form label-width="92px">\n            <el-form-item label="\u8FD0\u8F6C\u8DDF\u8E2A\u5355\u4F4D\uFF1A" v-show="data[\'type\'] === \'startSubProcess\' ">\n                <el-select v-model="data[\'workTrackUnit\']">\n                  <el-option\n                    v-for="item in workTrackUnits"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u9009\u62E9\u5355\u4F4D\uFF1A" v-show="data[\'type\'] != \'startSubProcess\' || data[\'sendUnit\']!=\'USER\'">\n                <el-select v-model="data[\'selectUnit\']" :disabled="data[\'type\'] === \'startSubProcess\' && data[\'sendUnit\']===\'DEP\'">\n                  <el-option\n                    v-for="item in selectUnits"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u9009\u62E9\u5355\u4F4D\uFF1A" v-show="data[\'type\'] === \'startSubProcess\' && data[\'sendUnit\']===\'USER\'">\n                <el-select v-model="data[\'selectUnit\']">\n                  <el-option\n                    v-for="item in workUserSelectUnits"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u529E\u7406\u5355\u4F4D\uFF1A" v-show="data[\'selectUnit\'] != \'position\' ">\n                <el-select v-model="data[\'activityUnit\']" :disabled="data[\'type\'] === \'startSubProcess\' ">\n                  <el-option\n                    v-for="item in activityUnits"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u5408\u5E76\u5230\u4E0A\u7EA7\uFF1A" v-show="data[\'type\'] != \'startSubProcess\' || data[\'sendUnit\']===\'DEP\' ">\n                <el-select v-model="data[\'mergeType\']">\n                  <el-option\n                    v-for="item in mergeTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u76F4\u63A5\u53D1\u9001\uFF1A">\n                <el-radio-group v-model="data[\'sendDirectly\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u4EFB\u52A1\u63D0\u793A\uFF1A">\n                <el-input v-model="data[\'taskTip\']"></el-input>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u5176\u4ED6" name="4">\n           <el-form  label-width="65px">\n            <el-form-item label="\u6267\u884C\u811A\u672C\uFF1A">\n                <el-button type="primary" @click="showFlowScriptSet(\'line\')">\u8BBE\u7F6E</el-button>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n      </el-collapse>\n</div>\n    ',




















































































































































































































































































    props: {
      data: {
        type: Object },

      params: {
        type: Object } },


    data: function data() {
      return {
        activeName: '1',
        types: [{ value: 'normal', label: '普通' }, { value: 'startSubProcess', label: '运转' }, { value: 'sendHandled', label: '直送经办' }],

        groupTypes: [{ value: 'no', label: '不启用' }, { value: 'role', label: '权限' }, { value: 'relative', label: '相对部门' }, { value: 'handled-group', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'upper-group', label: '发送部门' }, { value: 'draft-group', label: '发起部门' }],

        groups: [{ value: '<当前>', label: '<当前>' }, { value: '<上级>', label: '<上级>' }, { value: '<下级>', label: '<下级>' }, { value: '<平级>', label: '<平级>' },
        { value: '<当前和上级>', label: '<当前和上级>' }, { value: '<当前和下级>', label: '<当前和下级>' },
        { value: '<所有下级>', label: '<所有下级>' }, { value: '<上级的平级>', label: '<上级的平级>' },
        { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<部门上级>', label: '<部门上级>' }, { value: '<部门下级>', label: '<部门下级>' }, { value: '<部门平级>', label: '<部门平级>' },
        { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<本单位任选(不包含下级)>', label: '<本单位任选(不包含下级)>' },
        { value: '<本单位的一级部门>', label: '<本单位的一级部门>' }, { value: '<单位上级>', label: '<单位上级>' }, { value: '<单位平级>', label: '<单位平级>' },
        { value: '<上级单位部门>', label: '<上级单位部门>' }, { value: '<上级单位任选>', label: '<上级单位任选>' }],
        sendUnits: [{ value: 'USER', label: '人员' }, { value: 'DEP', label: '部门' }],
        sendRules: [{ value: 'batch', label: '按批次' }, { value: 'process', label: '按流程' }],
        selectUnits: [{ value: 'user', label: '人员' }, { value: 'group', label: '部门' }, { value: 'user-tree', label: '人员树' }, { value: 'group-tree', label: '部门树' }],
        workUserSelectUnits: [{ value: 'user', label: '人员' }, { value: 'user-tree', label: '人员树' }],
        activityUnits: [{ value: 'group', label: '部门' }, { value: 'user', label: '人员' }],
        mergeTypes: [{ value: 'no', label: '不启用' }, { value: 'dep', label: '部门' }, { value: 'unit', label: '单位' }],
        workTrackUnits: [{ value: 'activity', label: '当前节点' }, { value: 'user', label: '当前用户' }],
        excludeTypes: [{ value: 'current-user', label: '当前用户' }, { value: 'current-dep', label: '当前部门' }] };

    },

    created: function created() {
      this.initData();
    },

    watch: {
      'data.id': function dataId(val, oldVal) {
        this.initData();
      },
      'data.tip': function dataTip(val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateLine", { id: me.data.id, tip: val });
        }
      } },

    methods: {
      initData: function initData() {
        if (this.data.type == undefined) {
          this.$set(this.data, 'type', this.types[0].value);
        };
        if (this.data.groupType == undefined) {
          this.$set(this.data, 'groupType', 'no');
        };
        if (this.data.sendToYz == undefined) {
          this.$set(this.data, 'sendToYz', '0');
        }
        if (this.data.group == undefined) {
          this.$set(this.data, 'group', '<当前>');
        };
        if (this.data.excludeSwitch == undefined) {
          this.$set(this.data, 'excludeSwitch', '0');
        };
        if (this.data.sendDirectly == undefined) {
          this.$set(this.data, 'sendDirectly', '1');
        };
        if (this.data.selectUnit == undefined) {
          this.$set(this.data, 'selectUnit', 'user-tree');
        }
        if (this.data.activityUnit == undefined) {
          this.$set(this.data, 'activityUnit', 'group');
        }
        if (this.data.mergeType == undefined) {
          this.$set(this.data, 'mergeType', 'no');
        };
        if (this.data.workTrackUnit == undefined) {
          this.$set(this.data, 'workTrackUnit', this.workTrackUnits[0].value);
        };
        if (this.data.excludeType == undefined) {
          this.$set(this.data, 'excludeType', this.excludeTypes[0].value);
        };
        if (this.data.scriptActions == undefined) {
          this.$set(this.data, 'scriptActions', {});
        }



      },
      showHandledNode: function showHandledNode(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        PF.show('tree', { treeData: me._getActivities(['start', 'end', 'circular', 'sub-proc'], f.id == "skipToActivityId"), selectFirst: false, selectNode: selectNode }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });

      },
      showDept: function showDept() {
        var me = this;
        var selectNode = '';
        if (me.data['relativeGroup']) {
          selectNode = me.data['relativeGroup'];
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listDepartment"), selectFirst: false, selectNode: selectNode, search: true, async: true, singleLeaf: false }, function (res) {
          me.$set(me.data, 'relativeGroup', res.id);
          me.$set(me.data, 'relativeGroupName', res.name);
        });
      },
      showFlowScriptSet: function showFlowScriptSet(type) {
        var me = this;
        var p = {};
        p.size = 'small_mini';
        p.type = type;
        var scriptActions = me.data.scriptActions;
        if (scriptActions) {
          p.scriptActions = scriptActions;
        } else {
          p.scriptActions = {};
        }
        PF.show('flowScriptSet', p, function (res) {
          me.$set(me.data, 'scriptActions', res);
        });
      },
      changeType: function changeType(val) {
        parent.$emit("updateLine", { id: this.data.id, type: val });
        if (this.data.type == "sendHandled") {
          if (this.data.sameProcess == undefined) {
            this.$set(this.data, 'sameProcess', '0');
          }
        }
        if (this.data.type === 'startSubProcess') {

          if (this.data.waitComplete == undefined) {
            this.$set(this.data, 'waitComplete', '0');
          }
          if (this.data.sendToYz == undefined) {
            this.$set(this.data, 'sendToYz', '0');
          }
          if (this.data.skipTodo == undefined) {
            this.$set(this.data, 'skipTodo', '1');
          }
          if (this.data.skipTodoMode == undefined) {
            this.$set(this.data, 'skipTodoMode', 'activityComplete');
          }
          if (this.data.interventionParentTask == undefined) {
            this.$set(this.data, 'interventionParentTask', '0');
          }
          if (this.data.workTrackUnit == undefined) {
            this.$set(this.data, 'workTrackUnit', this.workTrackUnits[0].value);
          }
          if (this.data.sendUnit == undefined) {
            this.$set(this.data, 'sendUnit', this.sendUnits[0].value);
          }
          if (this.data.sendRule == undefined) {
            this.$set(this.data, 'sendRule', this.sendRules[0].value);
          }

          if (this.data.sendUnit === 'DEP') {
            this.$set(this.data, 'selectUnit', 'group');
            this.$set(this.data, 'activityUnit', 'group');
          } else {
            this.$set(this.data, 'selectUnit', 'user');
            this.$set(this.data, 'activityUnit', 'user');
            this.$set(this.data, 'mergeType', 'no');
          }
        } else {

          this.$set(this.data, 'selectUnit', 'user-tree');
          this.$set(this.data, 'activityUnit', 'group');
          this.$set(this.data, 'mergeType', 'no');
        }
      },
      changeSendUnit: function changeSendUnit(val) {
        if (val === 'DEP') {
          this.$set(this.data, 'selectUnit', 'group');
          this.$set(this.data, 'activityUnit', 'group');
        } else {
          this.$set(this.data, 'selectUnit', 'user');
          this.$set(this.data, 'activityUnit', 'user');
          this.$set(this.data, 'mergeType', 'no');
        }
      },
      showFlowMarks: function showFlowMarks() {
        var me = this;
        var flowMarks = me.params.flowMarks || "";
        if (!flowMarks) {
          PF.message("请在模块设置中配置流程标识");
          return;
        }
        flowMarks = _.uniq(flowMarks.split(","));
        var treeData = [];
        _.each(flowMarks, function (v) {treeData.push({ id: v, name: v });});
        var checkNodes = (me.data.dMark || "").split(",");
        PF.show('tree', { treeData: treeData, checkNodes: checkNodes, multiple: true, clearBtn: true }, function (res) {
          var marks = [];
          _.each(res, function (v) {
            marks.push(v.name);
          });
          me.$set(me.data, 'dMark', marks.join(","));
        });
      },
      _getActivities: function _getActivities(excludeActivityTypes, isSkipToActivity) {
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var treeData = [];
        var exclude;
        activities.forEach(function (a) {
          exclude = false;
          excludeActivityTypes.forEach(function (et) {
            if (et == a.extends) {
              exclude = true;
            }
          });
          if (!exclude) {
            treeData.push({ id: a.id, text: a.parameters.name, name: a.parameters.name });
          }
        });
        if (isSkipToActivity) {
          var flows = me.params.processDataItems["SEQUENCE-FLOW"];
          var flowDirs = _.filter(flows, function (a) {return a.sourceId == me.data.from;});
          var nodeIds = [];
          _.each(flowDirs, function (v) {nodeIds.push(v.targetId);});
          _.each(activities, function (v) {
            if (nodeIds.indexOf(v.id) != -1 && v.extends == 'end') {
              treeData.push({ id: v.id, text: v.parameters.name, name: v.parameters.name });
            }
          });
        }
        return treeData;
      } } };



  return line_normal;
};

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (Vue, parent, _data) {
  var node_circular = {
    template: '\n    <div class=\'__config__body\'> \n      <el-collapse v-model="activeName" accordion>\n        <el-collapse-item title="\u57FA\u672C\u5C5E\u6027" name="1">\n           <el-form  label-width="65px">\n            <el-form-item label="\u552F\u4E00\u6807\u8BC6\uFF1A" v-show=false>\n                <el-input v-model="data[\'id\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u540D\u79F0\uFF1A">\n                <el-input v-model="data[\'name\']" :disabled="!params.editable"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u5E8F\u53F7\uFF1A">\n                <el-input v-model="data[\'sn\']"></el-input>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u6D41\u7A0B\u63A7\u5236" name="2">\n           <el-form label-width="92px">\n            <el-form-item label="\u8282\u70B9\u7C7B\u578B\uFF1A">\n                <el-select @change=\'changeType\' v-model="data[\'type\']" :disabled="!params.editable">\n                  <el-option\n                    v-for="item in types"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            \n            <el-form-item label="\u529E\u7406\u90E8\u95E8\uFF1A">\n                <el-select v-model="data[\'groupType\']">\n                  <el-option\n                    v-for="item in groupTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u76F8\u5BF9\u90E8\u95E8\uFF1A" v-show="data[\'groupType\'] === \'relative\' ">\n                <el-input v-model="data[\'relativeGroupName\']" style="width:60%;" :disabled="true"></el-input>\n                <el-button type="primary" @click="showDept">\u9009\u62E9</el-button>\n            </el-form-item>\n             <el-form-item label="\u76F8\u5BF9\u90E8\u95E8" v-show="false">\n                  <el-input v-model="data[\'relativeGroup\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u5B57\u6BB5\uFF1A"  v-show="data[\'groupType\'] === \'biz\' ">\n                <el-input v-model="data[\'groupField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'groupType\'] === \'handled-group\' ">\n                <el-input v-model="data[\'groupHandledActName\']"  :disabled="true" style="width:60%;"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'groupHandled\', name:\'groupHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'groupHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n              <el-form-item label="\u90E8\u95E8\u8303\u56F4\uFF1A">\n                <el-select v-model="data[\'group\']">\n                  <el-option\n                    v-for="item in groups"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u529E\u7406\u7528\u6237\uFF1A">\n                <el-select v-model="data[\'userType\']">\n                  <el-option\n                    v-for="item in userTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n\n            <el-form-item label="\u7528\u6237\u6743\u9650\uFF1A" v-show="data[\'userType\'] === \'role\' ">\n              <el-input v-model="data[\'userRoleName\']" style="width:60%" :disabled="true"></el-input>\n              <el-button type="primary" @click="showRole({id:\'userRole\', name:\'userRoleName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u6743\u9650" v-show="false">\n              <el-input v-model="data[\'userRole\']" :disabled="true"></el-input>\n            </el-form-item>\n\n            <el-form-item label="\u7528\u6237\u5B57\u6BB5\uFF1A" v-show="data[\'userType\']=== \'biz\' ">\n                <el-input v-model="data[\'userField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'userType\'] === \'handled-user\' ">\n                <el-input v-model="data[\'userHandledActName\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'userHandled\', name:\'userHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'userHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u6392\u9664\u6761\u4EF6\uFF1A">\n              <el-radio-group v-model="data[\'excludeSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u6392\u9664\u8303\u56F4\uFF1A" v-show="data[\'excludeSwitch\']== \'1\' ">\n                <el-select v-model="data[\'excludeType\']">\n                  <el-option\n                    v-for="item in excludeTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n          </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u8868\u5355\u63A7\u5236" name="3">\n           <el-form  label-width="92px">\n            <el-form-item label="\u64CD\u4F5C\u6309\u94AE\uFF1A">\n                <el-button type="primary" @click="showFlowButton()">\u9009\u62E9</el-button>\n            </el-form-item>\n            <div style="padding:5px;border:1px #ddd solid" v-show="data.buttons.length>0">\n              <el-button  :key="button.id" v-for="button in data.buttons">{{button.name}}\n              </el-button>\n            </div>\n            <el-form-item label="\u64CD\u4F5C\u6743\u9650\uFF1A">\n                <el-button type="primary" @click="showFormOperAuth()">\u9009\u62E9</el-button>\n            </el-form-item>\n             <div style="padding:5px;border:1px #ddd solid" v-show="data.operAuths.length>0">\n                 <el-button  :key="auth.id" v-for="auth in data.operAuths">{{auth.name}}\n                 </el-button>\n            </div>\n             <el-form-item label="\u5207\u6362\u8868\u5355\uFF1A">\n                <el-button type="primary" @click="showRelateForm()">\u9009\u62E9</el-button>\n               </el-form-item>\n               <div style="padding:5px;border:1px #ddd solid" v-show="data.openFormId">\n                   <div v-text="data.openFormName"></div>\n            </div>\n           <el-form-item label="\u542F\u7528\u4F20\u9605\uFF1A">\n              <el-radio-group v-model="data[\'circularSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u4F20\u9605\u8303\u56F4\uFF1A" v-show="data[\'circularSwitch\']===\'1\'">\n                <el-select v-model="data[\'circularScope\']">\n                  <el-option\n                    v-for="item in circularScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n                </el-form-item>\n                <el-form-item label="\u4F20\u9605\u79D8\u4E66\u4EE3\u529E\uFF1A"  v-show="data[\'circularSwitch\']===\'1\'">\n                <el-radio-group v-model="data[\'circularSecretarySwitch\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u79D8\u4E66\u8282\u70B9\u540D\uFF1A" v-show="data[\'circularSwitch\']===\'1\' && data[\'circularSecretarySwitch\']===\'1\'">\n                    <el-input v-model="data[\'circularSecActivityName\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u8282\u70B9\u540D\uFF1A" v-show="data[\'circularSwitch\']===\'1\' && data[\'circularSecretarySwitch\']===\'1\'">\n                    <el-input v-model="data[\'circularLeaderActivityName\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9ED8\u8BA4\u610F\u89C1\uFF1A">\n                    <el-input v-model="data[\'defaultComment\']"></el-input>\n                </el-form-item>\n               <el-form-item label="\u53EA\u8BFB:" >\n                  <el-radio-group v-model="data[\'readOnly\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n               </el-form-item>\n                <el-form-item label="\u9644\u4EF6\u53EF\u7F16\u8F91:" >\n                  <el-radio-group v-model="data[\'editAttach\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n                </el-form-item>\n                <el-form-item label="\u9644\u4EF6\u53EF\u4E0A\u4F20:" >\n                  <el-radio-group v-model="data[\'uploadAttach\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n                </el-form-item> \n                <el-form-item label="\u9644\u4EF6\u53EF\u4E0B\u8F7D:" >\n                  <el-radio-group v-model="data[\'downloadAttach\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n                </el-form-item> \n                <el-form-item label="\u6B63\u6587\u6253\u5F00\u65B9\u5F0F:" >\n                    <el-input v-model="data[\'attchOct\']" style="width:calc(100% - 48px);"></el-input>\n                    <el-button type="primary" @click="showOcxList">\u9009\u62E9</el-button>\n                </el-form-item> \n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u79D8\u4E66\u4EE3\u529E" name="4">\n            <el-form  label-width="92px">\n              <el-form-item label="\u542F\u7528\u79D8\u4E66\u4EE3\u529E\uFF1A">\n                <el-radio-group v-model="data[\'secretarySwitch\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u79D8\u4E66\u8282\u70B9\u540D\uFF1A" v-show="data[\'secretarySwitch\']===\'1\'">\n                    <el-input v-model="data[\'secActivityName\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u8282\u70B9\u540D\uFF1A" v-show="data[\'secretarySwitch\']===\'1\'">\n                    <el-input v-model="data[\'leaderActivityName\']"></el-input>\n                </el-form-item>\n              </el-form>  \n         </el-collapse-item>\n         <el-collapse-item title="\u79FB\u52A8\u914D\u7F6E" name="6">\n          <el-form  label-width="92px">\n              <el-form-item label="\u662F\u5426\u529E\u7406:" >\n                  <el-radio-group v-model="data[\'mobileHandler\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u8868\u5355\u7F16\u8F91:" >\n                  <el-radio-group v-model="data[\'mobileEdit\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u7F16\u8F91\u6B63\u6587:" >\n                  <el-radio-group v-model="data[\'mobileZWEdit\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u7F16\u8F91\u9644\u4EF6:" >\n                  <el-radio-group v-model="data[\'mobileFJEdit\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n              <el-form-item label="\u4E0A\u4F20\u9644\u4EF6:" >\n                  <el-radio-group v-model="data[\'mobileFJUpload\']" size="mini">\n                    <el-radio-button label="1">\u5F00</el-radio-button>\n                    <el-radio-button label="0">\u5173</el-radio-button>\n                  </el-radio-group>\n              </el-form-item>\n          </el-form-item>\n          </el-form>\n        </el-collapse-item>\n         <el-collapse-item title="\u5176\u4ED6" name="5">\n           <el-form  label-width="92px">\n            <el-form-item label="\u6267\u884C\u811A\u672C\uFF1A">\n                <el-button type="primary" @click="showFlowScriptSet(\'node\')">\u8BBE\u7F6E</el-button>\n            </el-form-item>\n            <el-form-item label="\u662F\u5426\u9886\u5BFC\u8282\u70B9\uFF1A">\n              <el-select v-model="data[\'leaderNode\']">\n                  <el-option\n                    v-for="item in groupYesNo"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>     \n      </el-collapse>\n      </div>\n    ',










































































































































































































































































    props: {
      data: {
        type: Object },

      params: {
        type: Object } },


    data: function data() {
      return {
        fields: ['id', 'name', 'type', 'sn', 'groupType', 'group', 'relativeGroup', 'relativeGroupName',
        'groupField', 'groupHandled', 'groupHandledActName', 'userType', 'userRole', 'userRoleName', 'userField', 'userHandledActName',
        'userHandled', 'excludeSwitch', 'excludeType', 'buttons', 'scriptActions', 'operAuths', 'defaultComment',
        'circularSwitch', 'circularScope', 'circularSecretarySwitch', 'circularSecActivityName', 'circularLeaderActivityName',
        'secretarySwitch', 'secActivityName', 'leaderActivityName', 'openFormId', 'openFormName', 'leaderNode',
        'mobileHandler', 'mobileEdit', 'mobileZWEdit', 'mobileFJEdit', 'mobileFJUpload',
        'readOnly', 'editAttach', 'uploadAttach', 'downloadAttach', 'attchOct', 'attchOctKey'],

        activeName: '1',
        types: [],

        groupTypes: [{ value: 'role', label: '权限' }, { value: 'relative', label: '相对部门' }, { value: 'handled-group', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'upper-group', label: '发送部门' }, { value: 'draft-group', label: '发起部门' }],

        groups: [{ value: '<当前>', label: '<当前>' }, { value: '<上级>', label: '<上级>' }, { value: '<下级>', label: '<下级>' }, { value: '<平级>', label: '<平级>' },
        { value: '<当前和上级>', label: '<当前和上级>' }, { value: '<当前和下级>', label: '<当前和下级>' },
        { value: '<所有下级>', label: '<所有下级>' }, { value: '<上级的平级>', label: '<上级的平级>' },
        { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<部门上级>', label: '<部门上级>' }, { value: '<部门下级>', label: '<部门下级>' }, { value: '<部门平级>', label: '<部门平级>' },
        { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<本单位任选(不包含下级)>', label: '<本单位任选(不包含下级)>' },
        { value: '<本单位的一级部门>', label: '<本单位的一级部门>' }, { value: '<单位上级>', label: '<单位上级>' }, { value: '<单位平级>', label: '<单位平级>' },
        { value: '<上级单位部门>', label: '<上级单位部门>' }, { value: '<上级单位任选>', label: '<上级单位任选>' }],
        userTypes: [{ value: 'role', label: '权限' }, { value: 'handled-user', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'draft-user', label: '发起人' }, { value: 'upper-user', label: '发送人' }],
        circularScopes: [{ value: '<当前>', label: '<当前>' }, { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<任选>', label: '<任选>' }],
        excludeTypes: [{ value: 'current-user', label: '当前用户' }, { value: 'current-dep', label: '当前部门' }],
        groupYesNo: [{ value: '1', label: '是' }, { value: '0', label: '否' }] };

    },
    created: function created() {
      var me = this;
      me.clearField();
      me.types = me.params.activityTypes;
      me.initData();
    },
    watch: {
      'data.name': function dataName(val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", { id: me.data.id, name: val });
        }
      },
      'data.id': function dataId(val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name;
          this.$set(this.data, 'name', '新增节点');
        }
        this.initData();
      } },

    methods: {
      initData: function initData() {
        var me = this;
        if (this.data.openFormId == undefined) {
          this.$set(this.data, 'openFormId', '');
          this.$set(this.data, 'openFormName', '');
        }

        if (me.data.name == undefined) {
          this.$set(me.data, 'name', '新增节点');
        }
        if (this.data.excludeSwitch == undefined) {
          this.$set(this.data, 'excludeSwitch', '0');
        }
        if (this.data.mobileHandler == undefined) {
          this.$set(this.data, 'mobileHandler', "1");
        }
        if (this.data.mobileEdit == undefined) {
          this.$set(this.data, 'mobileEdit', "0");
        }
        if (this.data.mobileZWEdit == undefined) {
          this.$set(this.data, 'mobileZWEdit', "0");
        }
        if (this.data.mobileFJEdit == undefined) {
          this.$set(this.data, 'mobileFJEdit', "0");
        }
        if (this.data.mobileFJUpload == undefined) {
          this.$set(this.data, 'mobileFJUpload', "1");
        }
        if (this.data.readOnly == undefined) {
          this.$set(this.data, 'readOnly', "0");
        }
        if (this.data.editAttach == undefined) {
          this.$set(this.data, 'editAttach', "1");
        }
        if (this.data.uploadAttach == undefined) {
          this.$set(this.data, 'uploadAttach', "1");
        }
        if (this.data.downloadAttach == undefined) {
          this.$set(this.data, 'downloadAttach', "1");
        }
        if (this.data.attchOctKey == undefined) {
          this.$set(this.data, 'attchOctKey', "");
        }
        if (this.data.attchOct == undefined) {
          this.$set(this.data, 'attchOct', "无");
        }
        if (this.data.buttons == undefined) {
          this.$set(this.data, 'buttons', []);
        }
        if (this.data.scriptActions == undefined) {
          this.$set(this.data, 'scriptActions', {});
        }
        if (this.data.operAuths == undefined) {
          this.$set(this.data, 'operAuths', []);
        }
        if (this.data.type == undefined) {
          this.$set(this.data, 'type', 'circular');
        }

        if (this.data.groupType == undefined) {
          this.$set(this.data, 'groupType', this.groupTypes[0].value);
        }

        if (this.data.group == undefined) {
          this.$set(this.data, 'group', '<当前>');
        }

        if (this.data.userType == undefined) {
          this.$set(this.data, 'userType', this.userTypes[0].value);
        }
        if (this.data.circularSwitch == undefined) {
          this.$set(this.data, 'circularSwitch', '0');
        }
        if (this.data.circularScope == undefined) {
          this.$set(this.data, 'circularScope', this.circularScopes[0].value);
        }
        if (this.data.circularSecretarySwitch == undefined) {
          this.$set(this.data, 'circularSecretarySwitch', '0');
        }
        if (this.data.excludeType == undefined) {
          this.$set(this.data, 'excludeType', this.excludeTypes[0].value);
        }

        if (this.data.secretarySwitch == undefined) {
          this.$set(this.data, 'secretarySwitch', '0');
        }
        if (this.data.leaderNode == undefined) {
          this.$set(this.data, 'leaderNode', '0');
        }
      },

      showRelateForm: function showRelateForm() {
        var me = this;
        var moduleId = me.params.moduleId;
        var appId = me.params.applicationId;

        PF.show('tableDialog', { api: "app.listModuleForm", clearBtn: true,
          defaultParams: { moduleId: moduleId, appId: appId }, singleSelect: true }, function (res) {
          if (res.length > 0) {
            me.$set(me.data, 'openFormId', res[0].id);
            me.$set(me.data, 'openFormName', res[0].name);
          } else {
            me.$set(me.data, 'openFormId', "");
            me.$set(me.data, 'openFormName', "");
          }
        });

      },
      showOcxList: function showOcxList() {
        var me = this;
        PF.show('tree', { url: me.mwUrl("/api/data/getOcxList"), selectFirst: false, selectNode: "", search: true, async: true, singleLeaf: true }, function (res) {
          me.$set(me.data, 'attchOct', res.name || "");
          me.$set(me.data, 'attchOctKey', res.key || "");
        });
      },
      showHandledNode: function showHandledNode(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        PF.show('tree', { treeData: me._getActivities(['start', 'end', 'circular', 'sub-proc']), selectFirst: false, selectNode: selectNode }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });

      },
      showDept: function showDept() {
        var me = this;
        var selectNode = '';
        if (me.data['relativeGroup']) {
          selectNode = me.data['relativeGroup'];
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listDepartment"), selectFirst: false, selectNode: selectNode, search: true, async: true, singleLeaf: false }, function (res) {
          me.$set(me.data, 'relativeGroup', res.id);
          me.$set(me.data, 'relativeGroupName', res.name);
        });
      },
      showRole: function showRole(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }

        PF.show('tree', { url: this.mwUrl("/api/org/listFlowGroupedRole"), selectFirst: false, selectNode: selectNode, search: true, clearBtn: true }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });
      },
      showFlowButton: function showFlowButton() {
        var me = this;
        var value = [];
        for (var i = 0; i < me.data.buttons.length; i++) {
          value.push(me.data.buttons[i].action);
        }
        PF.show('treeTable', {
          url: me.mwUrl("/api/app/listActionComponentByTypeTree"), treeDefaultParams: { type: "系统分类/表单/流程", flag: 0 },
          size: 'small_large',
          selectFirst: true, asyncLoadOnce: true, clearBtn: true, title: '选择动作脚本', changed: function changed(data) {
            var me = this;
            me.defaultParams = { type: data.code, flag: 2 };
          }, api: 'app.getAllButton', singleSelect: false },
        function (res) {
          var btns = [];
          if (res && res.length > 0) {
            res.forEach(function (v) {
              if (v.action) {
                btns.push({ name: v.name, action: v.action });
              }
            });
          }
          me.$set(me.data, 'buttons', btns);
        });
      },
      showFlowScriptSet: function showFlowScriptSet(type) {
        var me = this;
        var p = {};
        p.type = type;
        var scriptActions = me.data.scriptActions;
        if (scriptActions) {
          p.scriptActions = scriptActions;
        } else {
          p.scriptActions = {};
        }
        PF.show('flowScriptSet', p, function (res) {
          me.$set(me.data, 'scriptActions', res);
        });
      },
      showFormOperAuth: function showFormOperAuth() {
        var me = this;
        var moduleId = me.params.moduleId;
        var appId = me.params.applicationId;
        var checkNodes = [];
        for (var i = 0; i < me.data.operAuths.length; i++) {
          checkNodes.push(me.data.operAuths[i].id);
        }
        PF.show('tree', { url: this.mwUrl(
          "/api/app/listModuleFormOperAuthTree"), checkNodes: checkNodes, search:
          true, multiple: true, singleLeaf: false, clearBtn: true, multipleLeaf: false,
          defaultParams: { moduleId: moduleId, appId: appId } }, function (res) {
          var auths = [];
          if (res && res.length > 0) {
            res.forEach(function (v) {
              if (v.id) {
                auths.push({ name: v.name, id: v.id });
              }
            });
          }
          me.$set(me.data, 'operAuths', auths);
        });
      },
      clearField: function clearField() {
        var me = this;
        function contains(obj) {
          for (var i = 0; i < me.fields.length; i++) {
            if (me.fields[i] == obj) {
              return true;
            }
          }
          return false;
        }
        var del = [];
        for (var s in me.data) {
          if (!contains(s)) {
            del.push(s);
          }
        }
        for (var i = 0; i < del.length; i++) {
          delete me.data[del[i]];
        }
      },
      changeType: function changeType(val) {
        parent.$emit("updateShape", { id: this.data.id, type: val });
        this.params.changeType(val);
      },
      _getActivities: function _getActivities(excludeActivityTypes) {
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var treeData = [];
        var exclude;
        activities.forEach(function (a) {
          exclude = false;
          excludeActivityTypes.forEach(function (et) {
            if (et == a.extends) {
              exclude = true;
            }
          });
          if (!exclude) {
            treeData.push({ id: a.id, text: a.parameters.name, name: a.parameters.name });
          }
        });
        return treeData;
      } } };


  return node_circular;
};

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (Vue, parent, _data) {
  var node_fork_serial = {
    template: '\n    <div class=\'__config__body\'>\n      <el-collapse v-model="activeName" accordion>\n        <el-collapse-item title="\u57FA\u672C\u5C5E\u6027" name="1">\n           <el-form label-width="65px">\n            <el-form-item label="\u552F\u4E00\u6807\u8BC6\uFF1A" v-show=false>\n                <el-input v-model="data[\'id\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u540D\u79F0\uFF1A">\n                <el-input v-model="data[\'name\']" :disabled="!params.editable"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u6807\u8BC6\uFF1A">\n                <el-input v-model="data[\'mark\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u5E8F\u53F7\uFF1A">\n                <el-input v-model="data[\'sn\']"></el-input>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u6D41\u7A0B\u63A7\u5236" name="2">\n           <el-form label-width="92px">\n            <el-form-item label="\u8282\u70B9\u7C7B\u578B\uFF1A">\n                <el-select @change=\'changeType\' v-model="data[\'type\']" :disabled="!params.editable">\n                  <el-option\n                    v-for="item in types"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u529E\u7406\u90E8\u95E8\uFF1A">\n                <el-select v-model="data[\'groupType\']">\n                  <el-option\n                    v-for="item in groupTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u76F8\u5BF9\u90E8\u95E8\uFF1A" v-show="data[\'groupType\'] === \'relative\' ">\n                <el-input v-model="data[\'relativeGroupName\']" style="width:60%;" :disabled="true"></el-input>\n                <el-button type="primary" @click="showDept">\u9009\u62E9</el-button>\n            </el-form-item>\n             <el-form-item label="\u76F8\u5BF9\u90E8\u95E8" v-show="false">\n                  <el-input v-model="data[\'relativeGroup\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u5B57\u6BB5\uFF1A"  v-show="data[\'groupType\'] === \'biz\' ">\n                <el-input v-model="data[\'groupField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'groupType\'] === \'handled-group\' ">\n                <el-input v-model="data[\'groupHandledActName\']"  :disabled="true" style="width:60%;"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'groupHandled\', name:\'groupHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'groupHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n              <el-form-item label="\u90E8\u95E8\u8303\u56F4\uFF1A">\n                <el-select v-model="data[\'group\']">\n                  <el-option\n                    v-for="item in groups"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u529E\u7406\u7528\u6237\uFF1A">\n                <el-select v-model="data[\'userType\']">\n                  <el-option\n                    v-for="item in userTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n\n            <el-form-item label="\u7528\u6237\u6743\u9650\uFF1A" v-show="data[\'userType\'] === \'role\' ">\n              <el-input v-model="data[\'userRoleName\']" style="width:60%" :disabled="true"></el-input>\n              <el-button type="primary" @click="showRole({id:\'userRole\', name:\'userRoleName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u6743\u9650" v-show="false">\n              <el-input v-model="data[\'userRole\']" :disabled="true"></el-input>\n            </el-form-item>\n\n            <el-form-item label="\u7528\u6237\u5B57\u6BB5\uFF1A" v-show="data[\'userType\']=== \'biz\' ">\n                <el-input v-model="data[\'userField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'userType\'] === \'handled-user\' ">\n                <el-input v-model="data[\'userHandledActName\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'userHandled\', name:\'userHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'userHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u6392\u9664\u6761\u4EF6\uFF1A">\n              <el-radio-group v-model="data[\'excludeSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n          </el-form>\n        </el-collapse-item>\n      </el-collapse>\n      </div>\n    ',











































































































    props: {
      data: {
        type: Object },

      params: {
        type: Object } },


    data: function data() {
      return {
        fields: ['id', 'name', 'mark', 'sn', 'type', 'groupType', 'group', 'relativeGroup', 'relativeGroupName', 'groupField',
        'groupHandled', 'groupHandledActName', 'userType', 'userRole', 'userRoleName', 'userField', 'userHandled',
        'userHandledActName', 'excludeSwitch'],

        activeName: '1',
        types: [],
        groupTypes: [{ value: 'role', label: '权限' }, { value: 'relative', label: '相对部门' }, { value: 'handled-group', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'upper-group', label: '发送部门' }, { value: 'draft-group', label: '发起部门' }],
        groups: [{ value: '<当前>', label: '<当前>' }, { value: '<上级>', label: '<上级>' }, { value: '<下级>', label: '<下级>' }, { value: '<平级>', label: '<平级>' },
        { value: '<当前和上级>', label: '<当前和上级>' }, { value: '<当前和下级>', label: '<当前和下级>' },
        { value: '<所有下级>', label: '<所有下级>' }, { value: '<上级的平级>', label: '<上级的平级>' },
        { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<部门上级>', label: '<部门上级>' }, { value: '<部门下级>', label: '<部门下级>' }, { value: '<部门平级>', label: '<部门平级>' },
        { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<本单位任选(不包含下级)>', label: '<本单位任选(不包含下级)>' },
        { value: '<本单位的一级部门>', label: '<本单位的一级部门>' }, { value: '<单位上级>', label: '<单位上级>' }, { value: '<单位平级>', label: '<单位平级>' },
        { value: '<上级单位部门>', label: '<上级单位部门>' }, { value: '<上级单位任选>', label: '<上级单位任选>' }],
        userTypes: [{ value: 'role', label: '权限' }, { value: 'handled-user', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'draft-user', label: '发起人' }, { value: 'upper-user', label: '发送人' }] };

    },
    created: function created() {
      var me = this;
      me.clearField();
      me.types = me.params.activityTypes;
      me.initData();
    },
    watch: {
      'data.name': function dataName(val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", { id: me.data.id, name: val });
        }
      },
      'data.id': function dataId(val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name;
          this.$set(this.data, 'name', '新增节点');
        }
        this.initData();
      } },

    methods: {
      initData: function initData() {
        var me = this;
        if (me.data.name == undefined) {
          this.$set(me.data, 'name', '新增分支节点');
        }
        if (this.data.excludeSwitch == undefined) {
          this.$set(this.data, 'excludeSwitch', '0');
        }

        if (this.data.type == undefined) {
          this.$set(this.data, 'type', 'fork-serial');
        }

        if (this.data.groupType == undefined) {
          this.$set(this.data, 'groupType', 'role');
        }

        if (this.data.group == undefined) {
          this.$set(this.data, 'group', '<当前>');
        }
        if (this.data.userType == undefined) {
          this.$set(this.data, 'userType', 'role');
        }
        if (me.data.mark == undefined) {
          this.$set(me.data, 'mark', '');
        }
      },
      showHandledNode: function showHandledNode(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        PF.show('tree', { treeData: me._getActivities(['start', 'end', 'circular', 'sub-proc']), selectFirst: false, selectNode: selectNode }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });

      },
      showDept: function showDept() {
        var me = this;
        var selectNode = '';
        if (me.data['relativeGroup']) {
          selectNode = me.data['relativeGroup'];
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listDepartment"), selectFirst: false, selectNode: selectNode, search: true, async: true, singleLeaf: false }, function (res) {
          me.$set(me.data, 'relativeGroup', res.id);
          me.$set(me.data, 'relativeGroupName', res.name);
        });
      },
      showRole: function showRole(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listFlowGroupedRole"), selectFirst: false, selectNode: selectNode, search: true, clearBtn: true }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });
      },
      clearField: function clearField() {
        var me = this;
        function contains(obj) {
          for (var i = 0; i < me.fields.length; i++) {
            if (me.fields[i] == obj) {
              return true;
            }
          }
          return false;
        }
        var del = [];
        for (var s in me.data) {
          if (!contains(s)) {
            del.push(s);
          }
        }
        for (var i = 0; i < del.length; i++) {
          delete me.data[del[i]];
        }
      },
      changeType: function changeType(val) {
        parent.$emit("updateShape", { id: this.data.id, type: val });
        this.params.changeType(val);
      },
      _getActivities: function _getActivities(excludeActivityTypes) {
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var treeData = [];
        var exclude;
        activities.forEach(function (a) {
          exclude = false;
          excludeActivityTypes.forEach(function (et) {
            if (et == a.extends) {
              exclude = true;
            }
          });
          if (!exclude) {
            treeData.push({ id: a.id, text: a.parameters.name, name: a.parameters.name });
          }
        });
        return treeData;
      } } };


  return node_fork_serial;
};

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (Vue, parent, _data) {
  var node_fork_parallel = {
    template: '\n    <div class=\'__config__body\'>\n      <el-collapse v-model="activeName" accordion>\n        <el-collapse-item title="\u57FA\u672C\u5C5E\u6027" name="1">\n           <el-form label-width="65px">\n            <el-form-item label="\u552F\u4E00\u6807\u8BC6\uFF1A" v-show=false>\n                <el-input v-model="data[\'id\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u540D\u79F0\uFF1A">\n                <el-input v-model="data[\'name\']" :disabled="!params.editable"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u6807\u8BC6\uFF1A">\n                <el-input v-model="data[\'mark\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u5E8F\u53F7\uFF1A">\n                <el-input v-model="data[\'sn\']"></el-input>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u6D41\u7A0B\u63A7\u5236" name="2">\n           <el-form label-width="92px">\n            <el-form-item label="\u8282\u70B9\u7C7B\u578B\uFF1A">\n                <el-select @change=\'changeType\' v-model="data[\'type\']" :disabled="!params.editable">\n                  <el-option\n                    v-for="item in types"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u529E\u7406\u90E8\u95E8\uFF1A">\n                <el-select v-model="data[\'groupType\']">\n                  <el-option\n                    v-for="item in groupTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u76F8\u5BF9\u90E8\u95E8\uFF1A" v-show="data[\'groupType\'] === \'relative\' ">\n                <el-input v-model="data[\'relativeGroupName\']" style="width:60%;" :disabled="true"></el-input>\n                <el-button type="primary" @click="showDept">\u9009\u62E9</el-button>\n            </el-form-item>\n             <el-form-item label="\u76F8\u5BF9\u90E8\u95E8" v-show="false">\n                  <el-input v-model="data[\'relativeGroup\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u5B57\u6BB5\uFF1A"  v-show="data[\'groupType\'] === \'biz\' ">\n                <el-input v-model="data[\'groupField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'groupType\'] === \'handled-group\' ">\n                <el-input v-model="data[\'groupHandledActName\']"  :disabled="true" style="width:60%;"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'groupHandled\', name:\'groupHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'groupHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n              <el-form-item label="\u90E8\u95E8\u8303\u56F4\uFF1A" >\n                <el-select v-model="data[\'group\']">\n                  <el-option\n                    v-for="item in groups"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u529E\u7406\u7528\u6237\uFF1A">\n                <el-select v-model="data[\'userType\']">\n                  <el-option\n                    v-for="item in userTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n\n            <el-form-item label="\u7528\u6237\u6743\u9650\uFF1A" v-show="data[\'userType\'] === \'role\' ">\n              <el-input v-model="data[\'userRoleName\']" style="width:60%" :disabled="true"></el-input>\n              <el-button type="primary" @click="showRole({id:\'userRole\', name:\'userRoleName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u6743\u9650" v-show="false">\n              <el-input v-model="data[\'userRole\']" :disabled="true"></el-input>\n            </el-form-item>\n\n            <el-form-item label="\u7528\u6237\u5B57\u6BB5\uFF1A" v-show="data[\'userType\']=== \'biz\' ">\n                <el-input v-model="data[\'userField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'userType\'] === \'handled-user\' ">\n                <el-input v-model="data[\'userHandledActName\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'userHandled\', name:\'userHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'userHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u6392\u9664\u6761\u4EF6\uFF1A">\n                <el-radio-group v-model="data[\'excludeSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n          </el-form>\n        </el-collapse-item>\n      </el-collapse>\n      </div>\n    ',











































































































    props: {
      data: {
        type: Object },

      params: {
        type: Object } },


    data: function data() {
      return {
        fields: ['id', 'name', 'mark', 'sn', 'type', 'groupType', 'group', 'relativeGroup', 'relativeGroupName', 'groupField',
        'groupHandled', 'groupHandledActName', 'userType', 'userRole', 'userRoleName', 'userField', 'userHandled',
        'userHandledActName', 'excludeSwitch'],

        activeName: '1',
        types: [],
        groupTypes: [{ value: 'role', label: '权限' }, { value: 'relative', label: '相对部门' }, { value: 'handled-group', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'upper-group', label: '发送部门' }, { value: 'draft-group', label: '发起部门' }],
        groups: [{ value: '<当前>', label: '<当前>' }, { value: '<上级>', label: '<上级>' }, { value: '<下级>', label: '<下级>' }, { value: '<平级>', label: '<平级>' },
        { value: '<当前和上级>', label: '<当前和上级>' }, { value: '<当前和下级>', label: '<当前和下级>' },
        { value: '<所有下级>', label: '<所有下级>' }, { value: '<上级的平级>', label: '<上级的平级>' },
        { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<部门上级>', label: '<部门上级>' }, { value: '<部门下级>', label: '<部门下级>' }, { value: '<部门平级>', label: '<部门平级>' },
        { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<本单位任选(不包含下级)>', label: '<本单位任选(不包含下级)>' },
        { value: '<本单位的一级部门>', label: '<本单位的一级部门>' }, { value: '<单位上级>', label: '<单位上级>' }, { value: '<单位平级>', label: '<单位平级>' },
        { value: '<上级单位部门>', label: '<上级单位部门>' }, { value: '<上级单位任选>', label: '<上级单位任选>' }],
        userTypes: [{ value: 'role', label: '权限' }, { value: 'handled-user', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'draft-user', label: '发起人' }, { value: 'upper-user', label: '发送人' }] };

    },
    created: function created() {
      var me = this;
      me.clearField();
      me.types = me.params.activityTypes;
      me.initData();
    },
    watch: {
      'data.name': function dataName(val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", { id: me.data.id, name: val });
        }
      },
      'data.id': function dataId(val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name;
          this.$set(this.data, 'name', '新增节点');
        }
        this.initData();
      } },

    methods: {
      initData: function initData() {
        var me = this;
        if (me.data.name == undefined) {
          this.$set(me.data, 'name', '新增分支节点');
        }
        if (this.data.excludeSwitch == undefined) {
          this.$set(this.data, 'excludeSwitch', '0');
        }

        if (this.data.type == undefined) {
          this.$set(this.data, 'type', 'fork-parallel');
        }

        if (this.data.groupType == undefined) {
          this.$set(this.data, 'groupType', 'role');
        }
        if (this.data.group == undefined) {
          this.$set(this.data, 'group', '<当前>');
        }
        if (this.data.userType == undefined) {
          this.$set(this.data, 'userType', 'role');
        }
        if (me.data.mark == undefined) {
          this.$set(me.data, 'mark', '');
        }
      },
      showHandledNode: function showHandledNode(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        PF.show('tree', { treeData: me._getActivities(['start', 'end', 'circular', 'sub-proc']), selectFirst: false, selectNode: selectNode }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });

      },
      showDept: function showDept() {
        var me = this;
        var selectNode = '';
        if (me.data['relativeGroup']) {
          selectNode = me.data['relativeGroup'];
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listDepartment"), selectFirst: false, selectNode: selectNode, search: true, async: true, singleLeaf: false }, function (res) {
          me.$set(me.data, 'relativeGroup', res.id);
          me.$set(me.data, 'relativeGroupName', res.name);
        });
      },
      showRole: function showRole(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listFlowGroupedRole"), selectFirst: false, selectNode: selectNode, search: true, clearBtn: true }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });
      },
      clearField: function clearField() {
        var me = this;
        function contains(obj) {
          for (var i = 0; i < me.fields.length; i++) {
            if (me.fields[i] == obj) {
              return true;
            }
          }
          return false;
        }
        var del = [];
        for (var s in me.data) {
          if (!contains(s)) {
            del.push(s);
          }
        }
        for (var i = 0; i < del.length; i++) {
          delete me.data[del[i]];
        }
      },
      changeType: function changeType(val) {
        parent.$emit("updateShape", { id: this.data.id, type: val });
        this.params.changeType(val);
      },
      _getActivities: function _getActivities(excludeActivityTypes) {
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var treeData = [];
        var exclude;
        activities.forEach(function (a) {
          exclude = false;
          excludeActivityTypes.forEach(function (et) {
            if (et == a.extends) {
              exclude = true;
            }
          });
          if (!exclude) {
            treeData.push({ id: a.id, text: a.parameters.name, name: a.parameters.name });
          }
        });
        return treeData;
      } } };


  return node_fork_parallel;
};

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (Vue, parent, _data) {
  var node_fork_join = {
    template: '\n    <div class=\'__config__body\'> \n      <el-collapse v-model="activeName" accordion>\n        <el-collapse-item title="\u57FA\u672C\u5C5E\u6027" name="1">\n           <el-form label-width="65px">\n            <el-form-item label="\u552F\u4E00\u6807\u8BC6\uFF1A" v-show=false>\n                <el-input v-model="data[\'id\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u540D\u79F0\uFF1A">\n                <el-input v-model="data[\'name\']" :disabled="!params.editable"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u5E8F\u53F7\uFF1A">\n                <el-input v-model="data[\'sn\']"></el-input>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u6D41\u7A0B\u63A7\u5236" name="2">\n           <el-form label-width="65px">\n            <el-form-item label="\u8282\u70B9\u7C7B\u578B\uFF1A">\n                <el-select @change=\'changeType\' v-model="data[\'type\']" :disabled="!params.editable">\n                  <el-option\n                    v-for="item in types"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            \n          </el-form>\n        </el-collapse-item>\n      </el-collapse>\n      </div>\n    ',

































    props: {
      data: {
        type: Object },

      params: {
        type: Object } },


    data: function data() {
      return {
        fields: ['id', 'name', 'sn', 'type'],

        activeName: '1',
        types: [] };

    },
    created: function created() {
      var me = this;
      me.clearField();
      me.types = me.params.activityTypes;
      me.initData();
    },
    watch: {
      'data.name': function dataName(val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", { id: me.data.id, name: val });
        }
      },
      'data.id': function dataId(val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name;
          this.$set(this.data, 'name', '新增聚合节点');
        }
        this.initData();
      } },

    methods: {
      initData: function initData() {
        var me = this;
        if (me.data.name == undefined) {
          this.$set(me.data, 'name', '新增聚合节点');
        }
      },
      clearField: function clearField() {
        var me = this;
        function contains(obj) {
          for (var i = 0; i < me.fields.length; i++) {
            if (me.fields[i] == obj) {
              return true;
            }
          }
          return false;
        }
        var del = [];
        for (var s in me.data) {
          if (!contains(s)) {
            del.push(s);
          }
        }
        for (var i = 0; i < del.length; i++) {
          delete me.data[del[i]];
        }
      },
      changeType: function changeType(val) {
        parent.$emit("updateShape", { id: this.data.id, type: val });
        this.params.changeType(val);
      } } };



  return node_fork_join;
};

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });exports.default = function (Vue, parent, _data) {
  var node_dynamic = {
    template: '\n    <div class=\'__config__body\'> \n      <el-collapse v-model="activeName" accordion>\n        <el-collapse-item title="\u57FA\u672C\u5C5E\u6027" name="1">\n           <el-form  label-width="105px">\n            <el-form-item label="\u552F\u4E00\u6807\u8BC6\uFF1A" v-show=false>\n                <el-input v-model="data[\'id\']" :disabled="true"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u540D\u79F0\uFF1A">\n                <el-input v-model="data[\'name\']" :disabled="!params.editable"></el-input>\n            </el-form-item>\n            <el-form-item label="\u8282\u70B9\u5E8F\u53F7\uFF1A">\n                <el-input v-model="data[\'sn\']"></el-input>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u6D41\u7A0B\u63A7\u5236" name="2">\n           <el-form label-width="105px">\n            <el-form-item label="\u8282\u70B9\u7C7B\u578B\uFF1A">\n                <el-select @change=\'changeType\' v-model="data[\'type\']" :disabled="!params.editable">\n                  <el-option\n                    v-for="item in types"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n           \n            <el-form-item label="\u529E\u7406\u90E8\u95E8\uFF1A">\n                <el-select v-model="data[\'groupType\']" @change=\'changeGroupType\'>\n                  <el-option\n                    v-for="item in groupTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u76F8\u5BF9\u90E8\u95E8\uFF1A" v-show="data[\'groupType\'] === \'relative\' ">\n                <el-input v-model="data[\'relativeGroupName\']" style="width:60%;" :disabled="true"></el-input>\n                <el-button type="primary" @click="showDept">\u9009\u62E9</el-button>\n            </el-form-item>\n             <el-form-item label="\u76F8\u5BF9\u90E8\u95E8" v-show="false">\n                  <el-input v-model="data[\'relativeGroup\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u5B57\u6BB5\uFF1A"  v-show="data[\'groupType\'] === \'biz\' ">\n                <el-input v-model="data[\'groupField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'groupType\'] === \'handled-group\' ">\n                <el-input v-model="data[\'groupHandledActName\']"  :disabled="true" style="width:60%;"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'groupHandled\', name:\'groupHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u90E8\u95E8\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'groupHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n              <el-form-item label="\u90E8\u95E8\u8303\u56F4\uFF1A" v-show="data[\'groupType\']!=\'bind-group\'">\n                <el-select v-model="data[\'group\']">\n                  <el-option\n                    v-for="item in groups"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u529E\u7406\u7528\u6237\uFF1A">\n                <el-select v-model="data[\'userType\']">\n                  <el-option\n                    v-for="item in userTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n\n            <el-form-item label="\u7528\u6237\u6743\u9650\uFF1A" v-show="data[\'userType\'] === \'role\' ">\n              <el-input v-model="data[\'userRoleName\']" style="width:60%" :disabled="true"></el-input>\n              <el-button type="primary" @click="showRole({id:\'userRole\', name:\'userRoleName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u6743\u9650" v-show="false">\n              <el-input v-model="data[\'userRole\']" :disabled="true"></el-input>\n            </el-form-item>\n\n            <el-form-item label="\u7528\u6237\u5B57\u6BB5\uFF1A" v-show="data[\'userType\']=== \'biz\' ">\n                <el-input v-model="data[\'userField\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9\uFF1A" v-show="data[\'userType\'] === \'handled-user\' ">\n                <el-input v-model="data[\'userHandledActName\']"  :disabled="true" style="width:60%"></el-input>\n                <el-button type="primary" @click="showHandledNode({id:\'userHandled\', name:\'userHandledActName\'})">\u9009\u62E9</el-button>\n            </el-form-item>\n            <el-form-item label="\u7528\u6237\u7ECF\u529E\u8282\u70B9" v-show="false">\n                  <el-input v-model="data[\'userHandled\']" :disabled="true"></el-input>\n              </el-form-item>\n            <el-form-item label="\u6392\u9664\u6761\u4EF6\uFF1A"  v-show="data[\'groupType\']!=\'bind-group\'">\n              <el-radio-group v-model="data[\'excludeSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u6392\u9664\u8303\u56F4\uFF1A" v-show="data[\'excludeSwitch\']== \'1\' && data[\'groupType\']!=\'bind-group\'">\n                <el-select v-model="data[\'excludeType\']">\n                  <el-option\n                    v-for="item in excludeTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n        </el-collapse-item>\n        <el-collapse-item title="\u8868\u5355\u63A7\u5236" name="3">\n           <el-form  label-width="105px">\n            <el-form-item label="\u64CD\u4F5C\u6309\u94AE\uFF1A">\n                <el-button type="primary" @click="showFlowButton()">\u9009\u62E9</el-button>\n            </el-form-item>\n            <div style="padding:5px;border:1px #ddd solid" v-show="data.buttons.length>0">\n              <el-button  :key="button.id" v-for="button in data.buttons">{{button.name}}\n              </el-button>\n            </div>\n            <el-form-item label="\u64CD\u4F5C\u6743\u9650\uFF1A">\n                <el-button type="primary" @click="showFormOperAuth()">\u9009\u62E9</el-button>\n            </el-form-item>\n             <div style="padding:5px;border:1px #ddd solid" v-show="data.operAuths.length>0">\n                 <el-button  :key="auth.id" v-for="auth in data.operAuths">{{auth.name}}\n                 </el-button>\n            </div>\n            <el-form-item label="\u542F\u7528\u8F6C\u529E\uFF1A">\n              <el-radio-group v-model="data[\'transmitSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u8F6C\u529E\u8303\u56F4\uFF1A" v-show="data[\'transmitSwitch\']===\'1\'">\n                <el-select v-model="data[\'transmitScope\']">\n                  <el-option\n                    v-for="item in transmitScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n               <el-form-item label="\u610F\u89C1\u63A7\u5236\uFF1A">\n              <el-radio-group v-model="data[\'commentSwitch\']" size="mini">\n                <el-radio-button label="1">\u5C55\u5F00</el-radio-button>\n                <el-radio-button label="0">\u6298\u53E0</el-radio-button>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u610F\u89C1\u5206\u7C7B\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-input v-model="data[\'commentCategory\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u610F\u89C1\u5E8F\u53F7\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-input v-model="data[\'commentSn\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u9ED8\u8BA4\u610F\u89C1\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-input v-model="data[\'defaultComment\']"></el-input>\n            </el-form-item>\n            <el-form-item label="\u586B\u5199\u591A\u6761\u610F\u89C1\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-radio-group v-model="data[\'moreCommentSwitch\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u4FEE\u6539\u610F\u89C1\u8303\u56F4\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-select v-model="data[\'commentModifyScope\']">\n                  <el-option\n                    v-for="item in commentModifyScopes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u68C0\u67E5\u65B9\u5F0F\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-select v-model="data[\'commentCheckMode\']">\n                  <el-option\n                    v-for="item in commentCheckModes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n              </el-form-item>\n              <el-form-item label="\u5B8C\u6210\u5F3A\u5236\u586B\u5199\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                <el-select v-model="data[\'completeComment\']">\n                  <el-option\n                    v-for="item in mandatoryOptions"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n               </el-form-item>\n               <el-form-item label="\u8F6C\u529E\u5F3A\u5236\u586B\u5199\uFF1A" v-show="data[\'commentSwitch\']==\'1\'">\n                 <el-select v-model="data[\'transmitComment\']">\n                  <el-option\n                    v-for="item in mandatoryOptions"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n               </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u79D8\u4E66\u4EE3\u529E" name="4" v-show="false">\n            <el-form  label-width="105px">\n              <el-form-item label="\u542F\u7528\u79D8\u4E66\u4EE3\u529E\uFF1A">\n              <el-radio-group v-model="data[\'secretarySwitch\']">\n                <el-radio label="1">\u662F</el-radio>\n                <el-radio label="0">\u5426</el-radio>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u79D8\u4E66\u4EE3\u529E\u6D41\u7A0B\uFF1A" v-show="data[\'secretarySwitch\']===\'1\'">\n               <el-radio-group v-model="data[\'secretarySubProcSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n               </el-form-item>\n               <el-form-item label="\u4EE3\u529E\u6D41\u7A0B\u540D\u79F0\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'secSubProcessDefName\']" style="width:60%;" :disabled="true"></el-input>\n                    <el-button type="primary" @click="showSubProcess">\u9009\u62E9</el-button>\n                </el-form-item>\n                <el-form-item label="\u4EE3\u529E\u6D41\u7A0BKey" v-show="false">\n                    <el-input v-model="data[\'secSubProcessDefKey\']" :disabled="true"></el-input>\n                </el-form-item>\n                 <el-form-item label="\u4EE3\u529E\u6D41\u7A0B\u6A21\u5757" v-show="false">\n                <el-input v-model="data[\'secSubProcessModuleId\']" :disabled="true"></el-input>\n                <el-input v-model="data[\'secSubProcessApplicationId\']" :disabled="true"></el-input>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u4EE3\u529E\u8282\u70B9\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessSecActivityName\']" style="width:60%;" :disabled="true"></el-input>\n                    <el-button type="primary" @click="showSubProcessNode(\'subProcessSecActivityId\', \'subProcessSecActivityName\')">\u9009\u62E9</el-button>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u4EE3\u529E\u8282\u70B9ID" v-show="false">\n                    <el-input v-model="data[\'subProcessSecActivityId\']" :disabled="true"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u4EE3\u529E\u8282\u70B9\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessLeaderActivityName\']" style="width:60%;" :disabled="true"></el-input>\n                    <el-button type="primary" @click="showSubProcessNode(\'subProcessLeaderActivityId\', \'subProcessLeaderActivityName\')">\u9009\u62E9</el-button>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u4EE3\u529E\u8282\u70B9ID" v-show="false">\n                    <el-input v-model="data[\'subProcessLeaderActivityId\']" :disabled="true"></el-input>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u8282\u70B9\u63D0\u793A" v-show="false && data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessSecActivityTip\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u8282\u70B9\u63D0\u793A" v-show="false && data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] === \'1\'">\n                    <el-input v-model="data[\'subProcessLeaderActivityTip\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u79D8\u4E66\u8282\u70B9\u540D\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] != \'1\'">\n                    <el-input v-model="data[\'secActivityName\']"></el-input>\n                </el-form-item>\n                <el-form-item label="\u9886\u5BFC\u8282\u70B9\u540D\uFF1A" v-show="data[\'secretarySwitch\']===\'1\' && data[\'secretarySubProcSwitch\'] != \'1\'">\n                    <el-input v-model="data[\'leaderActivityName\']"></el-input>\n                </el-form-item>\n               <el-form-item label="\u4EE3\u5F55\u8282\u70B9\u6D41\u5411\uFF1A">\n                <el-input v-model="data[\'canAgentRecordFlowNames\']"  :disabled="true" style="width:50%"></el-input>\n                <el-button type="primary" @click="showCanAgentRecordFlows({id:\'canAgentRecordFlowIds\', name:\'canAgentRecordFlowNames\'})">\u9009\u62E9</el-button>\n                 <el-tooltip placement="top" style="width:10%">\n                  <div slot="content">\n                  \u914D\u7F6E"\u865A\u62DF\u65E5\u5FD7"\u64CD\u4F5C\u6309\u94AE\u540E\u751F\u6548</div>\n                  <i class="el-icon-question"></i>\n                </el-tooltip>\n               </el-form-item>\n               <el-form-item label="\u4EE3\u5F55\u8282\u70B9ID" v-show="false">\n                  <el-input v-model="data[\'canAgentRecordFlowIds\']" :disabled="true"></el-input>\n              </el-form-item>\n            </el-form>\n        </el-collapse-item>\n        <el-collapse-item title="\u5176\u4ED6" name="5">\n           <el-form  label-width="105px">\n              <el-form-item label="\u65F6\u9650\u63A7\u5236\uFF1A">\n              <el-radio-group v-model="data[\'timeSwitch\']" size="mini">\n                <el-radio-button label="1">\u5F00</el-radio-button>\n                <el-radio-button label="0">\u5173</el-radio-button>\n                </el-radio-group>\n            </el-form-item>\n            <el-form-item label="\u65F6\u95F4\u7C7B\u578B\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                <el-select v-model="data[\'timeType\']">\n                  <el-option\n                    v-for="item in timeTypes"\n                    :key="item.value"\n                    :label="item.label"\n                    :value="item.value">\n                  </el-option>\n                </el-select>\n            </el-form-item>\n            <el-form-item label="\u7B7E\u6536\u9650\u529E\u65F6\u95F4\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                  <el-input v-model="data[\'claimLimitedTime\']"></el-input>\n              </el-form-item>\n              <el-form-item label="\u529E\u6BD5\u9650\u529E\u65F6\u95F4\uFF1A" v-show="data[\'timeSwitch\']==\'1\'">\n                  <el-input v-model="data[\'finishLimitedTime\']"></el-input>\n              </el-form-item>\n              <el-form-item label="\u6267\u884C\u811A\u672C\uFF1A">\n                <el-button type="primary" @click="showFlowScriptSet(\'node\')">\u8BBE\u7F6E</el-button>\n            </el-form-item>\n            </el-form>\n        </el-collapse-item>\n      </el-collapse>\n      </div>\n    ',















































































































































































































































































































    props: {
      data: {
        type: Object },

      params: {
        type: Object } },


    data: function data() {
      return {
        fields: ['id', 'name', 'type', 'sn', 'groupType', 'group', 'relativeGroup', 'relativeGroupName',
        'groupField', 'groupHandled', 'groupHandledActName', 'userType', 'userRole', 'userRoleName', 'userField', 'userHandledActName',
        'userHandled', 'excludeSwitch', 'excludeType', 'buttons', 'operAuths', 'scriptActions', 'timeSwitch', 'timeType', 'claimLimitedTime', 'finishLimitedTime',
        'transmitSwitch', 'transmitScope', 'commentSwitch', 'commentCategory', 'commentSn',
        'defaultComment', 'moreCommentSwitch', 'commentModifyScope', 'commentCheckMode',
        'completeComment', 'transmitComment',
        'secretarySwitch', 'secretarySubProcSwitch', 'secSubProcessDefName', 'secSubProcessDefKey', 'secSubProcessModuleId', 'secSubProcessApplicationId',
        'subProcessSecActivityName', 'subProcessSecActivityId', 'subProcessLeaderActivityName', 'subProcessLeaderActivityId',
        'subProcessSecActivityTip', 'subProcessLeaderActivityTip', 'secActivityName', 'leaderActivityName',
        'canAgentRecordFlowNames', 'canAgentRecordFlowIds'],

        activeName: '1',
        types: [],

        groupTypes: [{ value: 'role', label: '权限' }, { value: 'relative', label: '相对部门' }, { value: 'handled-group', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'upper-group', label: '发送部门' }, { value: 'draft-group', label: '发起部门' }, { value: 'bind-group', label: '<绑定部门>' }],

        groups: [{ value: '<当前>', label: '<当前>' }, { value: '<上级>', label: '<上级>' }, { value: '<下级>', label: '<下级>' }, { value: '<平级>', label: '<平级>' },
        { value: '<当前和上级>', label: '<当前和上级>' }, { value: '<当前和下级>', label: '<当前和下级>' },
        { value: '<所有下级>', label: '<所有下级>' }, { value: '<上级的平级>', label: '<上级的平级>' },
        { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<部门上级>', label: '<部门上级>' }, { value: '<部门下级>', label: '<部门下级>' }, { value: '<部门平级>', label: '<部门平级>' },
        { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<本单位任选(不包含下级)>', label: '<本单位任选(不包含下级)>' },
        { value: '<本单位的一级部门>', label: '<本单位的一级部门>' }, { value: '<单位上级>', label: '<单位上级>' }, { value: '<单位平级>', label: '<单位平级>' },
        { value: '<上级单位部门>', label: '<上级单位部门>' }, { value: '<上级单位任选>', label: '<上级单位任选>' }],
        defaultUserTypes: [{ value: 'role', label: '权限' }, { value: 'handled-user', label: '经办' }, { value: 'biz', label: '业务指定' }, { value: 'draft-user', label: '发起人' }, { value: 'upper-user', label: '发送人' }],
        bindUserTypes: [{ value: 'bind-leader', label: '<绑定领导>' }, { value: 'bind-secretary', label: '<绑定秘书>' }],
        circularScopes: [{ value: '<当前>', label: '<当前>' }, { value: '<经办人>', label: '<经办人>' }, { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<任选>', label: '<任选>' }],
        timeTypes: [{ value: 'work', label: '工作时间(单位:h)' }, { value: 'reality', label: '实际时间(单位:h)' }, { value: 'biz', label: '业务字段' }],
        transmitScopes: [{ value: '<当前>', label: '<当前>' }, { value: '<本部门任选>', label: '<本部门任选>' }, { value: '<本单位任选>', label: '<本单位任选>' }, { value: '<任选>', label: '<任选>' }],
        excludeTypes: [{ value: 'current-user', label: '当前用户' }, { value: 'current-dep', label: '当前部门' }],
        commentCheckModes: [{ value: 'task', label: '当前环节' }, { value: 'activity', label: '当前节点' }, { value: 'doc', label: '当前文档' }],
        commentModifyScopes: [{ value: 'disabled', label: '禁止' }, { value: 'self', label: '本人' }, { value: 'all', label: '所有人' }],
        mandatoryOptions: [{ value: 'no', label: '否' }, { value: 'remind', label: '提示' }, { value: 'yes', label: '是' }] };

    },
    created: function created() {
      var me = this;
      me.clearField();
      me.types = me.params.activityTypes;
      me.initData();
    },
    watch: {
      'data.name': function dataName(val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", { id: me.data.id, name: val });
        }
      },
      'data.id': function dataId(val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name;
          this.$set(this.data, 'name', '自由节点');
        }
        this.initData();
      } },

    methods: {
      initData: function initData() {
        var me = this;
        if (this.data.groupType == undefined) {
          this.$set(this.data, 'groupType', this.groupTypes[0].value);
        }
        if ('bind-group' == me.data.groupType) {
          me.userTypes = me.bindUserTypes;
        } else {
          me.userTypes = me.defaultUserTypes;
        }

        if (me.data.name == undefined) {
          this.$set(me.data, 'name', '自由节点');
        }
        if (this.data.excludeSwitch == undefined) {
          this.$set(this.data, 'excludeSwitch', '0');
        }
        if (this.data.buttons == undefined) {
          this.$set(this.data, 'buttons', []);
        }
        if (this.data.scriptActions == undefined) {
          this.$set(this.data, 'scriptActions', {});
        }
        if (this.data.operAuths == undefined) {
          this.$set(this.data, 'operAuths', []);
        }
        if (this.data.type == undefined) {
          this.$set(this.data, 'type', 'dynamic');
        }

        if (this.data.group == undefined) {
          this.$set(this.data, 'group', '<当前>');
        }

        if (this.data.userType == undefined) {
          this.$set(this.data, 'userType', this.userTypes[0].value);
        }
        if (this.data.timeSwitch == undefined) {
          this.$set(this.data, 'timeSwitch', '0');
        }
        if (this.data.timeType == undefined) {
          this.$set(this.data, 'timeType', 'work');
        }
        if (this.data.excludeType == undefined) {
          this.$set(this.data, 'excludeType', this.excludeTypes[0].value);
        }
        if (this.data.transmitSwitch == undefined) {
          this.$set(this.data, 'transmitSwitch', '0');
        }
        if (this.data.transmitScope == undefined) {
          this.$set(this.data, 'transmitScope', this.transmitScopes[0].value);
        }
        if (this.data.secretarySwitch == undefined) {
          this.$set(this.data, 'secretarySwitch', '0');
        }
        if (this.data.secretarySubProcSwitch == undefined) {
          this.$set(this.data, 'secretarySubProcSwitch', '0');
        }
        if (this.data.commentSwitch == undefined) {
          this.$set(this.data, 'commentSwitch', '0');
        }
        if (this.data.moreCommentSwitch == undefined) {
          this.$set(this.data, 'moreCommentSwitch', '0');
        }
        if (this.data.commentModifyScope == undefined) {
          this.$set(this.data, 'commentModifyScope', 'self');
        }
        if (this.data.commentCheckMode == undefined) {
          this.$set(this.data, 'commentCheckMode', this.commentCheckModes[0].value);
        }
        if (this.data.completeComment == undefined) {
          this.$set(this.data, 'completeComment', 'no');
        }
        if (this.data.transmitComment == undefined) {
          this.$set(this.data, 'transmitComment', 'no');
        }
      },
      showHandledNode: function showHandledNode(f) {
        var me = this;

        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }
        PF.show('tree', { treeData: me._getActivities(['start', 'end', 'circular', 'sub-proc']), selectFirst: false, selectNode: selectNode }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });

      },
      showCanAgentRecordFlows: function showCanAgentRecordFlows(f) {
        var me = this;
        var checkFlows;
        if (me.data[f.id]) {
          checkFlows = me.data[f.id].split(',');
        }
        PF.show('tree', { treeData: me._getCanAgentRecordFlows(['start', 'end', 'circular', 'sub-proc']), checkNodes: checkFlows, multiple: true, clearBtn: true }, function (res) {
          var flowNames = [];
          var flowIds = [];
          res.forEach(function (item) {
            flowNames.push(item.name);
            flowIds.push(item.id);
          });
          me.$set(me.data, f.id, flowIds.join(','));
          me.$set(me.data, f.name, flowNames.join(','));
        });
      },
      showDept: function showDept() {
        var me = this;
        var selectNode = '';
        if (me.data['relativeGroup']) {
          selectNode = me.data['relativeGroup'];
        }
        PF.show('tree', { url: this.mwUrl("/api/org/listDepartment"), selectFirst: false, selectNode: selectNode, search: true, async: true, singleLeaf: false }, function (res) {
          me.$set(me.data, 'relativeGroup', res.id);
          me.$set(me.data, 'relativeGroupName', res.name);
        });
      },
      showRole: function showRole(f) {
        var me = this;
        var selectNode = '';
        if (me.data[f.id]) {
          selectNode = me.data[f.id];
        }

        PF.show('tree', { url: this.mwUrl("/api/org/listFlowGroupedRole"), selectFirst: false, selectNode: selectNode, search: true, clearBtn: true }, function (res) {
          me.$set(me.data, f.id, res.id);
          me.$set(me.data, f.name, res.name);
        });
      },
      showFlowButton: function showFlowButton() {
        var me = this;
        var value = [];
        for (var i = 0; i < me.data.buttons.length; i++) {
          value.push(me.data.buttons[i].action);
        }
        PF.show('treeTable', {
          url: me.mwUrl("/api/app/listActionComponentByTypeTree"), treeDefaultParams: { type: "系统分类/表单/流程", flag: 0 },
          size: 'small_large',
          selectFirst: true, asyncLoadOnce: true, clearBtn: true, title: '选择动作脚本', changed: function changed(data) {
            var me = this;
            me.defaultParams = { type: data.code, flag: 2 };
          }, api: 'app.getAllButton', singleSelect: false },
        function (res) {
          var btns = [];
          if (res && res.length > 0) {
            res.forEach(function (v) {
              btns.push({ name: v.name, action: v.action });
            });
          }
          me.$set(me.data, 'buttons', btns);
        });
      },
      showFlowScriptSet: function showFlowScriptSet(type) {
        var me = this;
        var p = {};
        p.type = type;
        var scriptActions = me.data.scriptActions;
        if (scriptActions) {
          p.scriptActions = scriptActions;
        } else {
          p.scriptActions = {};
        }
        PF.show('flowScriptSet', p, function (res) {
          me.$set(me.data, 'scriptActions', res);
        });
      },
      showFormOperAuth: function showFormOperAuth() {
        var me = this;
        var moduleId = me.params.moduleId;
        var appId = me.params.applicationId;
        var checkNodes = [];
        for (var i = 0; i < me.data.operAuths.length; i++) {
          checkNodes.push(me.data.operAuths[i].id);
        }
        PF.show('tree', { url: this.mwUrl(
          "/api/app/listModuleFormOperAuthTree"), checkNodes: checkNodes, search:
          true, multiple: true, singleLeaf: false, clearBtn: true, multipleLeaf: false,
          defaultParams: { moduleId: moduleId, appId: appId } }, function (res) {
          var auths = [];
          if (res && res.length > 0) {
            res.forEach(function (v) {
              if (v.id) {
                auths.push({ name: v.name, id: v.id });
              }
            });
          }
          me.$set(me.data, 'operAuths', auths);
        });
      },

      clearField: function clearField() {
        var me = this;
        function contains(obj) {
          for (var i = 0; i < me.fields.length; i++) {
            if (me.fields[i] == obj) {
              return true;
            }
          }
          return false;
        }
        var del = [];
        for (var s in me.data) {
          if (!contains(s)) {
            del.push(s);
          }
        }
        for (var i = 0; i < del.length; i++) {
          delete me.data[del[i]];
        }
      },
      changeType: function changeType(val) {
        parent.$emit("updateShape", { id: this.data.id, type: val });
        this.params.changeType(val);
      },
      changeGroupType: function changeGroupType(val) {
        var me = this;
        var oldUt = me.data.userType;
        if ('bind-group' == val) {
          me.userTypes = me.bindUserTypes;
          var exist = false;
          me.bindUserTypes.forEach(function (v) {
            if (v.value == oldUt) {
              exist = true;
            }
          });
          if (!exist) {
            me.$set(me.data, 'userType', me.userTypes[0].value);
          }
        } else {
          me.userTypes = me.defaultUserTypes;
          var exist = false;
          me.bindUserTypes.forEach(function (v) {
            if (v.value == oldUt) {
              exist = true;
            }
          });
          if (exist) {
            me.$set(me.data, 'userType', me.userTypes[0].value);
          }
        }
      },
      showSubProcess: function showSubProcess() {
        var me = this;
        var selectNode = '';
        if (me.data.secSubProcessDefKey) {
          if (me.data.secSubProcessModuleId) {
            selectNode = me.data.secSubProcessDefKey + '|' + me.data.secSubProcessModuleId;
          } else {
            selectNode = me.data.secSubProcessDefKey;
          }
        }
        PF.show('tree', { url: this.mwUrl("/api/process/listModuleLatestProcDefTree"), singleLeaf: true, selectFirst: false, selectNode: selectNode, search: true }, function (res) {
          if (res) {
            if (res.id) {
              var ids = res.id.split('|');
              me.$set(me.data, 'secSubProcessDefKey', ids[0]);
            } else {
              me.$set(me.data, 'secSubProcessDefKey', res.id);
            }
            me.$set(me.data, 'secSubProcessDefName', res.name);
            me.$set(me.data, 'secSubProcessApplicationId', res.appId);
            me.$set(me.data, 'secSubProcessModuleId', res.moduleId);

            delete me.data.subProcessSecActivityId;
            delete me.data.subProcessSecActivityName;
            delete me.data.subProcessLeaderActivityId;
            delete me.data.subProcessLeaderActivityName;
          }
        });
      },
      showSubProcessNode: function showSubProcessNode(fid, fname) {
        var me = this;
        var key = me.data.secSubProcessDefKey;
        if (key) {
          var selectNode = '';
          if (me.data[fid]) {
            selectNode = me.data[fid];
          }
          var appId = me.params.applicationId;
          if (me.data.secSubProcessApplicationId) {
            appId = me.data.secSubProcessApplicationId;
          }
          PF.show('tree', { url: this.mwUrl("/api/process/getSubProcessStartActivities"), selectFirst: false, selectNode: selectNode, defaultParams: { key: key, appId: appId } }, function (res) {
            me.$set(me.data, fid, res.id);
            me.$set(me.data, fname, res.name);
          });
        }
      },
      _getActivities: function _getActivities(excludeActivityTypes) {
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var treeData = [];
        var exclude;
        activities.forEach(function (a) {
          exclude = false;
          excludeActivityTypes.forEach(function (et) {
            if (et == a.extends) {
              exclude = true;
            }
          });
          if (!exclude) {
            treeData.push({ id: a.id, text: a.parameters.name, name: a.parameters.name });
          }
        });
        return treeData;
      },
      _getActivityFlows: function _getActivityFlows(flowTypes) {
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var actNames = {};
        activities.forEach(function (a) {
          actNames[a.id] = a.parameters.name;
        });
        var flows = processDataItems['SEQUENCE-FLOW'];
        var treeData = [];
        var exclude;
        flows.forEach(function (f) {
          exclude = false;
          flowTypes.forEach(function (et) {
            if (et == f.parameters.type) {
              var name = actNames[f.parameters.from] + '-' + actNames[f.parameters.to];
              treeData.push({ id: f.id, text: name, name: name, sourceId_targetId: f.parameters.from + '-' + f.parameters.to });
            }
          });
        });
        return treeData;
      },
      _getCanAgentRecordFlows: function _getCanAgentRecordFlows(excludeActivityTypes) {
        var me = this;
        var currentNodeId = me.data.id;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var acts = {};
        var actNames = {};
        activities.forEach(function (a) {
          acts[a.id] = a;
          actNames[a.id] = a.parameters.name;
        });
        var treeData = [];
        var flows = processDataItems['SEQUENCE-FLOW'];
        var exclude;
        flows.forEach(function (f) {
          exclude = false;
          if (f.parameters.from == currentNodeId) {

            if ('startSubProcess' == f.parameters.type && 'DEP' == f.parameters.sendUnit) {
              exclude = true;
            }
            if (!exclude) {
              var act = acts[f.parameters.to];
              excludeActivityTypes.forEach(function (at) {
                if (at == act.extends) {
                  exclude = true;
                }
              });
              if (!exclude) {
                var name = f.parameters.name;
                if (!name) {
                  name = actNames[f.parameters.from] + '-' + actNames[f.parameters.to];
                }
                treeData.push({ id: f.id, text: name, name: name, sourceId_targetId: f.parameters.from + '-' + f.parameters.to });
              }
            }
          }
        });
        return treeData;
      } } };


  return node_dynamic;
};

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-process-manage"},[_c('mw-dialog',{ref:"flowVersionDialog",attrs:{"title":"管理流程版本","size":"small_large","appendToBody":true,"footerButton":_vm.footerButton}},[_c('div',{staticClass:"mw-process-manage"},[_c('ul',{staticClass:"process-list mw-process-manage"},_vm._l((_vm.processList),function(item,index){return _c('li',{key:index,class:{list_bg:(item.version!=_vm.selVersion),active:(item.version==_vm.selVersion)},on:{"click":function($event){return _vm.selectVersion(item.version,item.status)},"dblclick":_vm.editProcess}},[_c('span',{domProps:{"textContent":_vm._s(item.name)}}),_vm._v("("),_c('span',{domProps:{"textContent":_vm._s(item.version)}}),_vm._v(".0)\n        "),(item.status==0)?_c('span',{staticClass:"pull-right"},[_vm._v("设计")]):(item.status==1)?_c('span',{staticClass:"pull-right"},[_vm._v("启用")]):_c('span',{staticClass:"pull-right"},[_vm._v("历史")])])}),0)])]),_vm._v(" "),_c('mw-dialog',{ref:"flowRecycleBinDialog",attrs:{"title":"管理回收站","size":"small_large","appendToBody":true,"footerButton":_vm.recycleBinFooterButton}},[_c('ul',{staticClass:"process-list"},_vm._l((_vm.processDelList),function(item,index){return _c('li',{key:index,class:{list_bg:(item.version!=_vm.selDelVersion),active:(item.version==_vm.selDelVersion)},on:{"click":function($event){return _vm.selectDelVersion(item.version,item.status)}}},[_c('span',{domProps:{"textContent":_vm._s(item.name)}}),_vm._v("("),_c('span',{domProps:{"textContent":_vm._s(item.version)}}),_vm._v(".0)\n      ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"flow-edit-top"},[_c('div',{staticClass:"flow-des"},[_c('div',{staticStyle:{"display":"inline-block","padding-left":"10px","font-size":"14px"}},[(_vm.curStatus==0)?_c('span',[_vm._v("设计")]):(_vm.curStatus==1)?_c('span',[_vm._v("启用")]):_c('span',[_vm._v("历史")]),_vm._v("("),_c('span',{domProps:{"textContent":_vm._s(_vm.curVersion)}}),_vm._v(".0)\n        "),(_vm.relationFlowName)?_c('span',{staticStyle:{"padding-left":"20px"}},[_vm._v("关联流程:"+_vm._s(_vm.relationFlowName)+"\n          "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.delRelatedFlow}},[_vm._v("取消关联")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"flowbar"},[(!_vm.relationFlowName)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.relateFlow}},[_vm._v("关联流程")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.versionManage()}}},[_vm._v("版本管理")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.updateDefinition(false)}}},[_vm._v("保存")]),_vm._v(" "),(_vm.editable)?_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.editable),expression:"editable"}],attrs:{"type":"primary"},on:{"click":function($event){return _vm.updateDefinition(true)}}},[_vm._v("保存并启用")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticStyle:{"height":"calc(100% - 40px)","width":"100%"},attrs:{"id":"flowLayout"}},[_c('div',{staticClass:"mw-process-chart"},[_c('MwProcessChartEditor',{ref:"processEditor",staticClass:"flowLayout",attrs:{"editable":_vm.editable,"designable":_vm.designable,"observer":_vm.observer,"value":_vm.processDataGraph}}),_vm._v(" "),_vm._m(0)],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-process-chart-right"},[_c('div',{attrs:{"id":"mw-process-chart-config"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _vue = __webpack_require__(11);var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(1305);var _index2 = _interopRequireDefault(_index);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}


var directives = [
_index2.default];


var install = {
  install: function install(Vue) {
    directives.map(function (directive) {
      Vue.directive(directive.name, directive);
    });
  } };exports.default =


install;

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _assign = __webpack_require__(12);var _assign2 = _interopRequireDefault(_assign);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default = {
  name: 'waves',
  bind: function bind(el, binding) {
    el.addEventListener('click', function (e) {
      var customOpts = (0, _assign2.default)({}, binding.value);
      var opts = (0, _assign2.default)({
        ele: el,
        type: 'hit',
        color: 'rgba(0, 0, 0, 0.15)' },
      customOpts);
      var target = opts.ele;
      if (target) {
        target.style.position = 'relative';
        target.style.overflow = 'hidden';
        var rect = target.getBoundingClientRect();
        var ripple = target.querySelector('.waves-ripple');
        if (!ripple) {
          ripple = document.createElement('span');
          ripple.className = 'waves-ripple';
          ripple.style.height = ripple.style.width = Math.max(rect.width, rect.height) + 'px';
          target.appendChild(ripple);
        } else {
          ripple.className = 'waves-ripple';
        }
        switch (opts.type) {
          case 'center':
            ripple.style.top = rect.height / 2 - ripple.offsetHeight / 2 + 'px';
            ripple.style.left = rect.width / 2 - ripple.offsetWidth / 2 + 'px';
            break;
          default:
            ripple.style.top = e.pageY - rect.top - ripple.offsetHeight / 2 - document.body.scrollTop + 'px';
            ripple.style.left = e.pageX - rect.left - ripple.offsetWidth / 2 - document.body.scrollLeft + 'px';}

        ripple.style.backgroundColor = opts.color;
        ripple.className = 'waves-ripple z-active';
        return false;
      }
    }, false);
  } };

/***/ }),
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _regenerator = __webpack_require__(5);var _regenerator2 = _interopRequireDefault(_regenerator);var _asyncToGenerator2 = __webpack_require__(6);var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);















var _complete = __webpack_require__(1050);var _complete2 = _interopRequireDefault(_complete);
var _reject = __webpack_require__(1055);var _reject2 = _interopRequireDefault(_reject);

var _transmit = __webpack_require__(1057);var _transmit2 = _interopRequireDefault(_transmit);
var _planned = __webpack_require__(1059);var _planned2 = _interopRequireDefault(_planned);
var _worktrack = __webpack_require__(1062);var _worktrack2 = _interopRequireDefault(_worktrack);
var _worktrackLi = __webpack_require__(1068);var _worktrackLi2 = _interopRequireDefault(_worktrackLi);
var _worktrackTree = __webpack_require__(1070);var _worktrackTree2 = _interopRequireDefault(_worktrackTree);

var _virtuallog = __webpack_require__(1072);var _virtuallog2 = _interopRequireDefault(_virtuallog);
var _secrecord = __webpack_require__(1075);var _secrecord2 = _interopRequireDefault(_secrecord);


var _tree = __webpack_require__(1077);var _tree2 = _interopRequireDefault(_tree);
var _treeTable = __webpack_require__(1079);var _treeTable2 = _interopRequireDefault(_treeTable);
var _page = __webpack_require__(1081);var _page2 = _interopRequireDefault(_page);
var _table = __webpack_require__(1083);var _table2 = _interopRequireDefault(_table);



var _userSelect = __webpack_require__(1085);var _userSelect2 = _interopRequireDefault(_userSelect);
var _orgSelect = __webpack_require__(1087);var _orgSelect2 = _interopRequireDefault(_orgSelect);
var _flowScriptSet = __webpack_require__(1091);var _flowScriptSet2 = _interopRequireDefault(_flowScriptSet);

var _processChartViewer = __webpack_require__(1094);var _processChartViewer2 = _interopRequireDefault(_processChartViewer);
var _transactionProcess = __webpack_require__(1097);var _transactionProcess2 = _interopRequireDefault(_transactionProcess);

var _processInterfering = __webpack_require__(1099);var _processInterfering2 = _interopRequireDefault(_processInterfering);
var _urgeProcess = __webpack_require__(1148);var _urgeProcess2 = _interopRequireDefault(_urgeProcess);
var _turntoProcess = __webpack_require__(1150);var _turntoProcess2 = _interopRequireDefault(_turntoProcess);



var _blank = __webpack_require__(1152);var _blank2 = _interopRequireDefault(_blank);
var _form = __webpack_require__(1154);var _form2 = _interopRequireDefault(_form);


var _processOperationRecord = __webpack_require__(1156);var _processOperationRecord2 = _interopRequireDefault(_processOperationRecord);

var _viewPreview = __webpack_require__(1158);var _viewPreview2 = _interopRequireDefault(_viewPreview);
var _viewSelect = __webpack_require__(1160);var _viewSelect2 = _interopRequireDefault(_viewSelect);
var _commentEdit = __webpack_require__(1162);var _commentEdit2 = _interopRequireDefault(_commentEdit);

var _attachment = __webpack_require__(1164);var _attachment2 = _interopRequireDefault(_attachment);
var _ntkoEditor = __webpack_require__(1166);var _ntkoEditor2 = _interopRequireDefault(_ntkoEditor);

var _ntkoAttachment = __webpack_require__(1168);var _ntkoAttachment2 = _interopRequireDefault(_ntkoAttachment);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =



















{
  name: 'mwPublicDialog',
  components: {
    FlowComplete: _complete2.default,
    FlowReject: _reject2.default,
    flowTransmit: _transmit2.default,
    flowPlanned: _planned2.default,
    flowWorktrack: _worktrack2.default,
    flowWorktrackLi: _worktrackLi2.default,
    flowWorktrackTree: _worktrackTree2.default,
    flowVirtualog: _virtuallog2.default,
    flowSecrecord: _secrecord2.default,
    transactionProcess: _transactionProcess2.default,
    urgeProcess: _urgeProcess2.default,
    turnProcess: _turntoProcess2.default,
    commentEdit: _commentEdit2.default,
    NtkoEditor: _ntkoEditor2.default,
    OnLineEfileEdit: _ntkoEditor2.default,
    NtkoAttachment: _ntkoAttachment2.default,
    attachment: _attachment2.default,
    tree: _tree2.default,
    treeTable: _treeTable2.default,
    tableDialog: _table2.default,
    page: _page2.default,
    userSelect: _userSelect2.default,
    orgSelect: _orgSelect2.default,












    blank: _blank2.default,
    normalForm: _form2.default,
    flowForm: _form2.default,
    viewPreview: _viewPreview2.default,
    viewSelect: _viewSelect2.default,
    processChartViewer: _processChartViewer2.default,
    processInterfering: _processInterfering2.default,


    processOperationRecord: _processOperationRecord2.default,


    flowScriptSet: _flowScriptSet2.default },


  data: function data() {
    return {
      index: 0,
      item0: {},
      item1: {},
      item2: {},
      item3: {},
      item4: {},
      item5: {},
      item6: {},
      item7: {},
      item8: {},
      item9: {} };

  },
  methods: {
    clear: function clear() {
      var me = this;
      for (var idx = 0; idx < 10; idx++) {
        if (me.mwRef('dialog' + idx) && me.mwLodash.keys(me.mwRef('dialog' + idx).$refs).length > 0 && !me.mwRef('dialog' + idx).mwRef(me.mwLodash.keys(me.mwRef('dialog' + idx).$refs)[0]).visible) {
          me['item' + idx] = { component: 'blank', params: {} };
        }
      }
    },
    showForm: function showForm(data, callback) {
      data.isNewCallback = true;
      return this.show("normalForm", data, callback);
    },
    showPage: function showPage(data, func, secondfunc) {
      return this.show("page", data, func, secondfunc);
    },
    show: function show(name, data, func, secondfunc) {
      var me = this;
      me.index = 0;
      for (var idx = 0; idx < 10; idx++) {
        if (me.mwRef('dialog' + idx) && me.mwLodash.keys(me.mwRef('dialog' + idx).$refs).length > 0 && !me.mwRef('dialog' + idx).mwRef(me.mwLodash.keys(me.mwRef('dialog' + idx).$refs)[0]).visible) {
          me['item' + idx] = { component: 'blank', params: {} };
        }
      }
      me.$nextTick(function () {
        me.__nextNoVisible();
        me.mwLodash.debounce((0, _asyncToGenerator3.default)(_regenerator2.default.mark(
        function _callee() {return _regenerator2.default.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                  me.mwApi.org.checkToken().then(function (v) {
                    if (v) {
                      if (func) {
                        data.func = func;
                      }
                      if (secondfunc) {
                        data.secondfunc = secondfunc;
                      }
                      me['item' + me.index] = { component: name, params: data };
                    }
                  });case 1:case 'end':return _context.stop();}}}, _callee, this);})),

        2000,
        { leading: true, trailing: false })();
      });
    },
    __nextNoVisible: function __nextNoVisible() {
      var me = this;
      if (me.mwRef('dialog' + me.index)) {
        var refs = me.mwRef('dialog' + me.index).$refs;
        if (me.mwLodash.keys(refs).length > 0 && me.mwRef('dialog' + me.index).mwRef(me.mwLodash.keys(refs)[0]).visible) {
          me.index++;
          me.__nextNoVisible();
        }
      }
    } } };

/***/ }),
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _vue = __webpack_require__(11);var _vue2 = _interopRequireDefault(_vue);
var _lodash = __webpack_require__(98);var _lodash2 = _interopRequireDefault(_lodash);
var _en = __webpack_require__(1421);var _en2 = _interopRequireDefault(_en);
var _locale = __webpack_require__(113);var _locale2 = _interopRequireDefault(_locale);

__webpack_require__(506);


var _elementUi = __webpack_require__(141);var _elementUi2 = _interopRequireDefault(_elementUi);
__webpack_require__(773);
__webpack_require__(774);
var _index_rt = __webpack_require__(1422);var _index_rt2 = _interopRequireDefault(_index_rt);
var _components = __webpack_require__(1423);var _components2 = _interopRequireDefault(_components);
var _directive = __webpack_require__(1304);var _directive2 = _interopRequireDefault(_directive);
__webpack_require__(1426);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

window.$Env = {};
PF.changeElementLocaleToEn = function () {
  _locale2.default.use(_en2.default);
};
_vue2.default.config.productionTip = false;
_vue2.default.use(_elementUi2.default);
_vue2.default.use(_index_rt2.default);
_vue2.default.use(_components2.default);
_vue2.default.use(_directive2.default);

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Clear'
    },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      prevYear: 'Previous Year',
      nextYear: 'Next Year',
      prevMonth: 'Previous Month',
      nextMonth: 'Next Month',
      year: '',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      loading: 'Loading',
      placeholder: 'Select',
      noData: 'No data'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      deleteTip: 'press delete to remove',
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
      sumText: 'Sum'
    },
    tree: {
      emptyText: 'No Data'
    },
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'], // to be translated
      filterPlaceholder: 'Enter keyword', // to be translated
      noCheckedFormat: '{total} items', // to be translated
      hasCheckedFormat: '{checked}/{total} checked' // to be translated
    },
    image: {
      error: 'FAILED'
    },
    pageHeader: {
      title: 'Back' // to be translated
    },
    popconfirm: {
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }
  }
};

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _index_public = __webpack_require__(775);var _index_public2 = _interopRequireDefault(_index_public);
var _store_rt = __webpack_require__(142);var _store_rt2 = _interopRequireDefault(_store_rt);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  install: function install(Vue) {
    _index_public2.default.install(Vue);

    PF.createVue = function (config) {
      config.store = _store_rt2.default;
      return new Vue(config);
    };
  } };

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });var _indexRt = __webpack_require__(1424);var _indexRt2 = _interopRequireDefault(_indexRt);
var _codeEdit = __webpack_require__(1170);var _codeEdit2 = _interopRequireDefault(_codeEdit);


var _MwInnerView = __webpack_require__(1173);var _MwInnerView2 = _interopRequireDefault(_MwInnerView);

var _flowChartViewer = __webpack_require__(1272);var _flowChartViewer2 = _interopRequireDefault(_flowChartViewer);
var _doubleFace = __webpack_require__(1275);var _doubleFace2 = _interopRequireDefault(_doubleFace);
var _serviceConsole = __webpack_require__(1276);var _serviceConsole2 = _interopRequireDefault(_serviceConsole);
var _personalGroup = __webpack_require__(1279);var _personalGroup2 = _interopRequireDefault(_personalGroup);
var _personalOuterOrg = __webpack_require__(1282);var _personalOuterOrg2 = _interopRequireDefault(_personalOuterOrg);

var _Form = __webpack_require__(497);var _Form2 = _interopRequireDefault(_Form);
var _Flow = __webpack_require__(498);var _Flow2 = _interopRequireDefault(_Flow);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var components = [
_indexRt2.default,
_codeEdit2.default,


_MwInnerView2.default,
_doubleFace2.default,

_serviceConsole2.default,
_personalGroup2.default,
_personalOuterOrg2.default,
_Form2.default,
_Flow2.default,
_flowChartViewer2.default];


var install = {
  install: function install(Vue) {
    components.map(function (component) {
      Vue.component(component.name, component);
    });
    Vue.component('mw-code-editor', _codeEdit2.default);
  } };exports.default =



install;

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_rt_vue__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_rt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_rt_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_rt_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_rt_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_b68eb760_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_rt_vue__ = __webpack_require__(1425);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_rt_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_b68eb760_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_rt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.item0.component,{ref:"dialog0",tag:"div",attrs:{"params":_vm.item0.params}}),_vm._v(" "),_c(_vm.item1.component,{ref:"dialog1",tag:"div",attrs:{"params":_vm.item1.params}}),_vm._v(" "),_c(_vm.item2.component,{ref:"dialog2",tag:"div",attrs:{"params":_vm.item2.params}}),_vm._v(" "),_c(_vm.item3.component,{ref:"dialog3",tag:"div",attrs:{"params":_vm.item3.params}}),_vm._v(" "),_c(_vm.item4.component,{ref:"dialog4",tag:"div",attrs:{"params":_vm.item4.params}}),_vm._v(" "),_c(_vm.item5.component,{ref:"dialog5",tag:"div",attrs:{"params":_vm.item5.params}}),_vm._v(" "),_c(_vm.item6.component,{ref:"dialog6",tag:"div",attrs:{"params":_vm.item6.params}}),_vm._v(" "),_c(_vm.item7.component,{ref:"dialog7",tag:"div",attrs:{"params":_vm.item7.params}}),_vm._v(" "),_c(_vm.item8.component,{ref:"dialog8",tag:"div",attrs:{"params":_vm.item8.params}}),_vm._v(" "),_c(_vm.item9.component,{ref:"dialog9",tag:"div",attrs:{"params":_vm.item9.params}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/contrib.09d5908ccad29e2a2fd7.js